export default {
  "A1BG": [
    "A1BG EGDHEFLEVPEAQEDVEATFPVHQPGNYSCSYR-N4H5F0S1G0 glyco",
    "A1BG EGDHEFLEVPEAQEDVEATFPVHQPGNYSCSYR-N4H5F0S2G0 glyco",
    "A1BG cnv",
    "A1BG methyl",
    "A1BG proteo",
    "A1BG rna"
  ],
  "A1BG-AS1": [
    "A1BG-AS1 methyl"
  ],
  "A1CF": [
    "A1CF cnv",
    "A1CF rna"
  ],
  "A2M": [
    "A2M GCVLLSYLNETVTVSASLESVR-N4H5F0S2G0 glyco",
    "A2M SLGNVNFTVSAEALESQELCGTEVPSVPEHGR-N2H5F0S0G0 glyco",
    "A2M SLGNVNFTVSAEALESQELCGTEVPSVPEHGR-N2H6F0S0G0 glyco",
    "A2M SLGNVNFTVSAEALESQELCGTEVPSVPEHGR-N3H6F0S1G0 glyco",
    "A2M SLGNVNFTVSAEALESQELCGTEVPSVPEHGR-N4H5F0S1G0 glyco",
    "A2M SLGNVNFTVSAEALESQELCGTEVPSVPEHGRK-N2H5F0S0G0 glyco",
    "A2M SLGNVNFTVSAEALESQELCGTEVPSVPEHGRK-N2H6F0S0G0 glyco",
    "A2M SLGNVNFTVSAEALESQELCGTEVPSVPEHGRK-N2H7F0S0G0 glyco",
    "A2M SLGNVNFTVSAEALESQELCGTEVPSVPEHGRK-N3H4F0S1G0 glyco",
    "A2M SLGNVNFTVSAEALESQELCGTEVPSVPEHGRK-N3H5F0S1G0 glyco",
    "A2M SLGNVNFTVSAEALESQELCGTEVPSVPEHGRK-N3H6F0S1G0 glyco",
    "A2M SLGNVNFTVSAEALESQELCGTEVPSVPEHGRK-N4H4F0S1G0 glyco",
    "A2M SLGNVNFTVSAEALESQELCGTEVPSVPEHGRK-N4H5F0S1G0 glyco",
    "A2M VSNQTLSLFFTVLQDVPVR-N4H5F0S1G0 glyco",
    "A2M VSNQTLSLFFTVLQDVPVR-N4H5F1S1G0 glyco",
    "A2M cnv",
    "A2M proteo",
    "A2M rna"
  ],
  "A2M-AS1": [
    "A2M-AS1 methyl"
  ],
  "A2ML1": [
    "A2ML1 cnv",
    "A2ML1 rna"
  ],
  "A3GALT2": [
    "A3GALT2 cnv",
    "A3GALT2 rna"
  ],
  "A4GALT": [
    "A4GALT cnv",
    "A4GALT methyl",
    "A4GALT rna"
  ],
  "A4GNT": [
    "A4GNT cnv",
    "A4GNT rna"
  ],
  "AAAS": [
    "AAAS 452_462_1_1_S462 phospho",
    "AAAS 462_462_1_1_S462 phospho",
    "AAAS cnv",
    "AAAS methyl",
    "AAAS proteo",
    "AAAS rna"
  ],
  "AACS": [
    "AACS cnv",
    "AACS methyl",
    "AACS proteo",
    "AACS rna"
  ],
  "AADAC": [
    "AADAC cnv",
    "AADAC rna"
  ],
  "AADACL2": [
    "AADACL2 cnv"
  ],
  "AADACL3": [
    "AADACL3 cnv",
    "AADACL3 rna"
  ],
  "AADACL4": [
    "AADACL4 cnv"
  ],
  "AADAT": [
    "AADAT cnv",
    "AADAT methyl",
    "AADAT proteo",
    "AADAT rna"
  ],
  "AAGAB": [
    "AAGAB 310_311_1_1_S311 phospho",
    "AAGAB cnv",
    "AAGAB methyl",
    "AAGAB proteo",
    "AAGAB rna"
  ],
  "AAK1": [
    "AAK1 14_34_1_1_S21 phospho",
    "AAK1 375_389_1_1_T389 phospho",
    "AAK1 605_606_1_1_T606 phospho",
    "AAK1 618_624_2_0 phospho",
    "AAK1 618_624_2_2_T620S624 phospho",
    "AAK1 637_650_1_0 phospho",
    "AAK1 652_664_1_1_S652 phospho",
    "AAK1 731_756_1_1_S731 phospho",
    "AAK1 cnv",
    "AAK1 kinase",
    "AAK1 methyl",
    "AAK1 proteo",
    "AAK1 rna"
  ],
  "AAMDC": [
    "AAMDC 41_46_1_1_S46 phospho",
    "AAMDC cnv",
    "AAMDC methyl",
    "AAMDC proteo",
    "AAMDC rna"
  ],
  "AAMP": [
    "AAMP cnv",
    "AAMP methyl",
    "AAMP proteo",
    "AAMP rna"
  ],
  "AANAT": [
    "AANAT cnv",
    "AANAT methyl",
    "AANAT rna"
  ],
  "AAR2": [
    "AAR2 cnv",
    "AAR2 methyl",
    "AAR2 proteo",
    "AAR2 rna"
  ],
  "AARD": [
    "AARD cnv",
    "AARD methyl",
    "AARD rna"
  ],
  "AARS1": [
    "AARS1 399_403_1_1_S399 phospho",
    "AARS1 cnv",
    "AARS1 methyl",
    "AARS1 proteo",
    "AARS1 rna"
  ],
  "AARS2": [
    "AARS2 cnv",
    "AARS2 methyl",
    "AARS2 proteo",
    "AARS2 rna"
  ],
  "AARSD1": [
    "AARSD1 cnv",
    "AARSD1 methyl",
    "AARSD1 proteo",
    "AARSD1 rna"
  ],
  "AASDH": [
    "AASDH cnv",
    "AASDH methyl",
    "AASDH rna"
  ],
  "AASDHPPT": [
    "AASDHPPT cnv",
    "AASDHPPT methyl",
    "AASDHPPT proteo",
    "AASDHPPT rna"
  ],
  "AASS": [
    "AASS cnv",
    "AASS methyl",
    "AASS proteo",
    "AASS rna"
  ],
  "AATF": [
    "AATF cnv",
    "AATF methyl",
    "AATF proteo",
    "AATF rna"
  ],
  "AATK": [
    "AATK cnv",
    "AATK kinase",
    "AATK methyl",
    "AATK rna"
  ],
  "ABAT": [
    "ABAT cnv",
    "ABAT methyl",
    "ABAT proteo",
    "ABAT rna"
  ],
  "ABCA1": [
    "ABCA1 1137_1151_1_1_S1145 phospho",
    "ABCA1 1280_1302_1_1_S1296 phospho",
    "ABCA1 2225_2234_1_1_S2234 phospho",
    "ABCA1 QVMAEVNK-N2H6F0S0G0 glyco",
    "ABCA1 QVMAEVNK-N2H7F0S0G0 glyco",
    "ABCA1 YPTPGEAPGVVGNFNK-N2H7F0S0G0 glyco",
    "ABCA1 YPTPGEAPGVVGNFNK-N2H8F0S0G0 glyco",
    "ABCA1 cnv",
    "ABCA1 methyl",
    "ABCA1 proteo",
    "ABCA1 rna"
  ],
  "ABCA10": [
    "ABCA10 cnv",
    "ABCA10 rna"
  ],
  "ABCA11P": [
    "ABCA11P methyl"
  ],
  "ABCA12": [
    "ABCA12 cnv",
    "ABCA12 rna"
  ],
  "ABCA13": [
    "ABCA13 cnv",
    "ABCA13 methyl",
    "ABCA13 rna"
  ],
  "ABCA17P": [
    "ABCA17P methyl"
  ],
  "ABCA2": [
    "ABCA2 1323_1332_2_2_S1328S1332 phospho",
    "ABCA2 GNMSSLGFTSK-N2H8F0S0G0 glyco",
    "ABCA2 RGNMSSLGFTSK-N2H7F0S0G0 glyco",
    "ABCA2 RGNMSSLGFTSK-N2H8F0S0G0 glyco",
    "ABCA2 cnv",
    "ABCA2 methyl",
    "ABCA2 proteo",
    "ABCA2 rna"
  ],
  "ABCA3": [
    "ABCA3 cnv",
    "ABCA3 methyl",
    "ABCA3 proteo",
    "ABCA3 rna"
  ],
  "ABCA4": [
    "ABCA4 cnv",
    "ABCA4 rna"
  ],
  "ABCA5": [
    "ABCA5 cnv",
    "ABCA5 methyl",
    "ABCA5 proteo",
    "ABCA5 rna"
  ],
  "ABCA6": [
    "ABCA6 cnv",
    "ABCA6 rna"
  ],
  "ABCA7": [
    "ABCA7 cnv",
    "ABCA7 methyl",
    "ABCA7 proteo",
    "ABCA7 rna"
  ],
  "ABCA8": [
    "ABCA8 cnv",
    "ABCA8 proteo",
    "ABCA8 rna"
  ],
  "ABCA9": [
    "ABCA9 cnv",
    "ABCA9 rna"
  ],
  "ABCB1": [
    "ABCB1 cnv",
    "ABCB1 methyl",
    "ABCB1 proteo",
    "ABCB1 rna"
  ],
  "ABCB10": [
    "ABCB10 cnv",
    "ABCB10 methyl",
    "ABCB10 proteo",
    "ABCB10 rna"
  ],
  "ABCB11": [
    "ABCB11 cnv",
    "ABCB11 rna"
  ],
  "ABCB4": [
    "ABCB4 cnv",
    "ABCB4 methyl",
    "ABCB4 rna"
  ],
  "ABCB5": [
    "ABCB5 cnv",
    "ABCB5 rna"
  ],
  "ABCB6": [
    "ABCB6 708_714_1_1_S709 phospho",
    "ABCB6 cnv",
    "ABCB6 methyl",
    "ABCB6 proteo",
    "ABCB6 rna"
  ],
  "ABCB7": [
    "ABCB7 proteo",
    "ABCB7 rna"
  ],
  "ABCB8": [
    "ABCB8 cnv",
    "ABCB8 methyl",
    "ABCB8 proteo",
    "ABCB8 rna"
  ],
  "ABCB9": [
    "ABCB9 cnv",
    "ABCB9 methyl",
    "ABCB9 rna"
  ],
  "ABCC1": [
    "ABCC1 930_931_1_1_S930 phospho",
    "ABCC1 cnv",
    "ABCC1 methyl",
    "ABCC1 proteo",
    "ABCC1 rna"
  ],
  "ABCC10": [
    "ABCC10 cnv",
    "ABCC10 methyl",
    "ABCC10 proteo",
    "ABCC10 rna"
  ],
  "ABCC11": [
    "ABCC11 cnv",
    "ABCC11 methyl",
    "ABCC11 rna"
  ],
  "ABCC12": [
    "ABCC12 cnv",
    "ABCC12 rna"
  ],
  "ABCC2": [
    "ABCC2 cnv",
    "ABCC2 rna"
  ],
  "ABCC3": [
    "ABCC3 cnv",
    "ABCC3 methyl",
    "ABCC3 proteo",
    "ABCC3 rna"
  ],
  "ABCC4": [
    "ABCC4 638_648_1_1_T646 phospho",
    "ABCC4 cnv",
    "ABCC4 methyl",
    "ABCC4 proteo",
    "ABCC4 rna"
  ],
  "ABCC5": [
    "ABCC5 cnv",
    "ABCC5 methyl",
    "ABCC5 rna"
  ],
  "ABCC6": [
    "ABCC6 cnv",
    "ABCC6 rna"
  ],
  "ABCC6P2": [
    "ABCC6P2 methyl"
  ],
  "ABCC8": [
    "ABCC8 cnv",
    "ABCC8 methyl",
    "ABCC8 rna"
  ],
  "ABCC9": [
    "ABCC9 cnv",
    "ABCC9 methyl",
    "ABCC9 rna"
  ],
  "ABCD1": [
    "ABCD1 methyl",
    "ABCD1 proteo",
    "ABCD1 rna"
  ],
  "ABCD2": [
    "ABCD2 cnv",
    "ABCD2 proteo",
    "ABCD2 rna"
  ],
  "ABCD3": [
    "ABCD3 cnv",
    "ABCD3 methyl",
    "ABCD3 proteo",
    "ABCD3 rna"
  ],
  "ABCD4": [
    "ABCD4 cnv",
    "ABCD4 methyl",
    "ABCD4 proteo",
    "ABCD4 rna"
  ],
  "ABCE1": [
    "ABCE1 cnv",
    "ABCE1 methyl",
    "ABCE1 proteo",
    "ABCE1 rna"
  ],
  "ABCF1": [
    "ABCF1 105_109_1_0 phospho",
    "ABCF1 105_109_2_0 phospho",
    "ABCF1 105_109_2_2_S105S109 phospho",
    "ABCF1 140_140_1_1_S140 phospho",
    "ABCF1 166_166_1_1_S166 phospho",
    "ABCF1 20_24_1_1_S22 phospho",
    "ABCF1 228_244_1_1_S228 phospho",
    "ABCF1 228_254_1_1_S228 phospho",
    "ABCF1 cnv",
    "ABCF1 methyl",
    "ABCF1 proteo",
    "ABCF1 rna"
  ],
  "ABCF2": [
    "ABCF2 349_349_1_1_S349 phospho",
    "ABCF2 cnv",
    "ABCF2 methyl",
    "ABCF2 proteo",
    "ABCF2 rna"
  ],
  "ABCF2-H2BK1": [
    "ABCF2-H2BK1 cnv",
    "ABCF2-H2BK1 methyl",
    "ABCF2-H2BK1 rna"
  ],
  "ABCF3": [
    "ABCF3 cnv",
    "ABCF3 methyl",
    "ABCF3 proteo",
    "ABCF3 rna"
  ],
  "ABCG1": [
    "ABCG1 cnv",
    "ABCG1 methyl",
    "ABCG1 proteo",
    "ABCG1 rna"
  ],
  "ABCG2": [
    "ABCG2 cnv",
    "ABCG2 methyl",
    "ABCG2 proteo",
    "ABCG2 rna"
  ],
  "ABCG4": [
    "ABCG4 cnv",
    "ABCG4 methyl",
    "ABCG4 rna"
  ],
  "ABCG5": [
    "ABCG5 cnv",
    "ABCG5 rna"
  ],
  "ABCG8": [
    "ABCG8 cnv",
    "ABCG8 methyl",
    "ABCG8 rna"
  ],
  "ABHD1": [
    "ABHD1 cnv",
    "ABHD1 methyl",
    "ABHD1 rna"
  ],
  "ABHD10": [
    "ABHD10 cnv",
    "ABHD10 methyl",
    "ABHD10 proteo",
    "ABHD10 rna"
  ],
  "ABHD11": [
    "ABHD11 cnv",
    "ABHD11 methyl",
    "ABHD11 proteo",
    "ABHD11 rna"
  ],
  "ABHD12": [
    "ABHD12 5_5_1_1_T5 phospho",
    "ABHD12 cnv",
    "ABHD12 methyl",
    "ABHD12 proteo",
    "ABHD12 rna"
  ],
  "ABHD12B": [
    "ABHD12B cnv",
    "ABHD12B methyl",
    "ABHD12B rna"
  ],
  "ABHD13": [
    "ABHD13 cnv",
    "ABHD13 methyl",
    "ABHD13 proteo",
    "ABHD13 rna"
  ],
  "ABHD14A": [
    "ABHD14A cnv",
    "ABHD14A methyl",
    "ABHD14A rna"
  ],
  "ABHD14A-ACY1": [
    "ABHD14A-ACY1 cnv",
    "ABHD14A-ACY1 methyl",
    "ABHD14A-ACY1 rna"
  ],
  "ABHD14B": [
    "ABHD14B cnv",
    "ABHD14B methyl",
    "ABHD14B proteo",
    "ABHD14B rna"
  ],
  "ABHD15": [
    "ABHD15 cnv",
    "ABHD15 methyl",
    "ABHD15 rna"
  ],
  "ABHD16A": [
    "ABHD16A cnv",
    "ABHD16A methyl",
    "ABHD16A proteo",
    "ABHD16A rna"
  ],
  "ABHD16B": [
    "ABHD16B cnv",
    "ABHD16B rna"
  ],
  "ABHD17A": [
    "ABHD17A cnv",
    "ABHD17A methyl",
    "ABHD17A proteo",
    "ABHD17A rna"
  ],
  "ABHD17B": [
    "ABHD17B cnv",
    "ABHD17B methyl",
    "ABHD17B proteo",
    "ABHD17B rna"
  ],
  "ABHD17C": [
    "ABHD17C cnv",
    "ABHD17C methyl",
    "ABHD17C proteo",
    "ABHD17C rna"
  ],
  "ABHD18": [
    "ABHD18 cnv",
    "ABHD18 methyl",
    "ABHD18 rna"
  ],
  "ABHD2": [
    "ABHD2 cnv",
    "ABHD2 methyl",
    "ABHD2 proteo",
    "ABHD2 rna"
  ],
  "ABHD3": [
    "ABHD3 cnv",
    "ABHD3 methyl",
    "ABHD3 rna"
  ],
  "ABHD4": [
    "ABHD4 cnv",
    "ABHD4 proteo",
    "ABHD4 rna"
  ],
  "ABHD5": [
    "ABHD5 cnv",
    "ABHD5 methyl",
    "ABHD5 proteo",
    "ABHD5 rna"
  ],
  "ABHD6": [
    "ABHD6 cnv",
    "ABHD6 methyl",
    "ABHD6 proteo",
    "ABHD6 rna"
  ],
  "ABHD8": [
    "ABHD8 cnv",
    "ABHD8 methyl",
    "ABHD8 rna"
  ],
  "ABI1": [
    "ABI1 174_187_1_1_S183 phospho",
    "ABI1 200_216_1_0 phospho",
    "ABI1 222_225_1_0 phospho",
    "ABI1 cnv",
    "ABI1 methyl",
    "ABI1 proteo",
    "ABI1 rna"
  ],
  "ABI2": [
    "ABI2 168_181_1_1_S177 phospho",
    "ABI2 194_212_1_1_S210 phospho",
    "ABI2 218_221_1_1_S221 phospho",
    "ABI2 218_227_2_2_S221S227 phospho",
    "ABI2 256_291_1_0 phospho",
    "ABI2 cnv",
    "ABI2 methyl",
    "ABI2 proteo",
    "ABI2 rna"
  ],
  "ABI3": [
    "ABI3 197_219_1_1_S201 phospho",
    "ABI3 197_219_1_1_S210 phospho",
    "ABI3 335_359_1_1_S336 phospho",
    "ABI3 cnv",
    "ABI3 methyl",
    "ABI3 proteo",
    "ABI3 rna"
  ],
  "ABI3BP": [
    "ABI3BP VHINTTSDSILLK-N2H5F0S0G0 glyco",
    "ABI3BP cnv",
    "ABI3BP proteo",
    "ABI3BP rna"
  ],
  "ABITRAM": [
    "ABITRAM cnv",
    "ABITRAM methyl",
    "ABITRAM rna"
  ],
  "ABL1": [
    "ABL1 16_16_1_1_S16 phospho",
    "ABL1 578_588_1_1_S588 phospho",
    "ABL1 695_702_1_1_S702 phospho",
    "ABL1 934_938_1_0 phospho",
    "ABL1 cnv",
    "ABL1 kinase",
    "ABL1 methyl",
    "ABL1 proteo",
    "ABL1 rna"
  ],
  "ABL2": [
    "ABL2 584_590_1_1_S587 phospho",
    "ABL2 602_605_1_1_S605 phospho",
    "ABL2 616_619_1_1_S616 phospho",
    "ABL2 766_774_1_0 phospho",
    "ABL2 cnv",
    "ABL2 kinase",
    "ABL2 methyl",
    "ABL2 proteo",
    "ABL2 rna"
  ],
  "ABLIM1": [
    "ABLIM1 154_156_1_1_S156 phospho",
    "ABLIM1 154_164_1_0 phospho",
    "ABLIM1 154_164_1_1_S156 phospho",
    "ABLIM1 294_301_1_1_S295 phospho",
    "ABLIM1 319_341_1_0 phospho",
    "ABLIM1 319_341_1_1_S320 phospho",
    "ABLIM1 330_341_1_1_S335 phospho",
    "ABLIM1 418_430_1_1_S420 phospho",
    "ABLIM1 418_430_1_1_S426 phospho",
    "ABLIM1 418_430_2_2_S420S423 phospho",
    "ABLIM1 433_454_1_0 phospho",
    "ABLIM1 458_473_1_0 phospho",
    "ABLIM1 556_557_1_0 phospho",
    "ABLIM1 556_557_1_1_S556 phospho",
    "ABLIM1 623_652_1_0 phospho",
    "ABLIM1 639_652_1_0 phospho",
    "ABLIM1 639_652_1_1_S647 phospho",
    "ABLIM1 676_676_1_1_S676 phospho",
    "ABLIM1 cnv",
    "ABLIM1 methyl",
    "ABLIM1 proteo",
    "ABLIM1 rna"
  ],
  "ABLIM2": [
    "ABLIM2 103_116_1_1_S112 phospho",
    "ABLIM2 17_26_1_1_S17 phospho",
    "ABLIM2 237_240_1_1_S237 phospho",
    "ABLIM2 276_296_1_0 phospho",
    "ABLIM2 278_296_1_1_S294 phospho",
    "ABLIM2 362_372_1_1_S364 phospho",
    "ABLIM2 396_413_1_1_S404 phospho",
    "ABLIM2 446_452_1_1_S446 phospho",
    "ABLIM2 502_507_1_1_S502 phospho",
    "ABLIM2 cnv",
    "ABLIM2 methyl",
    "ABLIM2 proteo",
    "ABLIM2 rna"
  ],
  "ABLIM3": [
    "ABLIM3 276_290_1_0 phospho",
    "ABLIM3 276_290_1_1_S282 phospho",
    "ABLIM3 372_383_1_1_S372 phospho",
    "ABLIM3 372_383_1_1_S373 phospho",
    "ABLIM3 372_383_2_2_S372S373 phospho",
    "ABLIM3 394_399_1_1_S394 phospho",
    "ABLIM3 419_425_1_1_T421 phospho",
    "ABLIM3 503_504_1_1_S503 phospho",
    "ABLIM3 503_504_2_2_S503S504 phospho",
    "ABLIM3 557_567_1_1_S567 phospho",
    "ABLIM3 570_581_1_1_S576 phospho",
    "ABLIM3 597_607_1_1_S599 phospho",
    "ABLIM3 cnv",
    "ABLIM3 methyl",
    "ABLIM3 proteo",
    "ABLIM3 rna"
  ],
  "ABO": [
    "ABO cnv",
    "ABO rna"
  ],
  "ABR": [
    "ABR 225_232_1_1_S225 phospho",
    "ABR 303_320_1_1_S312 phospho",
    "ABR 308_320_1_1_S312 phospho",
    "ABR 323_333_1_1_T333 phospho",
    "ABR cnv",
    "ABR methyl",
    "ABR proteo",
    "ABR rna"
  ],
  "ABRA": [
    "ABRA cnv",
    "ABRA rna"
  ],
  "ABRACL": [
    "ABRACL cnv",
    "ABRACL proteo",
    "ABRACL rna"
  ],
  "ABRAXAS1": [
    "ABRAXAS1 cnv",
    "ABRAXAS1 methyl",
    "ABRAXAS1 proteo",
    "ABRAXAS1 rna"
  ],
  "ABRAXAS2": [
    "ABRAXAS2 cnv",
    "ABRAXAS2 methyl",
    "ABRAXAS2 proteo",
    "ABRAXAS2 rna"
  ],
  "ABT1": [
    "ABT1 cnv",
    "ABT1 methyl",
    "ABT1 rna"
  ],
  "ABTB1": [
    "ABTB1 cnv",
    "ABTB1 methyl",
    "ABTB1 rna"
  ],
  "ABTB2": [
    "ABTB2 365_365_1_1_S365 phospho",
    "ABTB2 cnv",
    "ABTB2 methyl",
    "ABTB2 proteo",
    "ABTB2 rna"
  ],
  "ABTB3": [
    "ABTB3 cnv",
    "ABTB3 methyl",
    "ABTB3 proteo",
    "ABTB3 rna"
  ],
  "ACAA1": [
    "ACAA1 cnv",
    "ACAA1 methyl",
    "ACAA1 proteo",
    "ACAA1 rna"
  ],
  "ACAA2": [
    "ACAA2 cnv",
    "ACAA2 methyl",
    "ACAA2 proteo",
    "ACAA2 rna"
  ],
  "ACACA": [
    "ACACA 2376_2383_1_1_S2380 phospho",
    "ACACA 60_71_1_1_S66 phospho",
    "ACACA cnv",
    "ACACA methyl",
    "ACACA proteo",
    "ACACA rna"
  ],
  "ACACB": [
    "ACACB cnv",
    "ACACB methyl",
    "ACACB rna"
  ],
  "ACAD10": [
    "ACAD10 cnv",
    "ACAD10 methyl",
    "ACAD10 proteo",
    "ACAD10 rna"
  ],
  "ACAD11": [
    "ACAD11 cnv",
    "ACAD11 methyl",
    "ACAD11 proteo",
    "ACAD11 rna"
  ],
  "ACAD8": [
    "ACAD8 cnv",
    "ACAD8 methyl",
    "ACAD8 proteo",
    "ACAD8 rna"
  ],
  "ACAD9": [
    "ACAD9 cnv",
    "ACAD9 methyl",
    "ACAD9 proteo",
    "ACAD9 rna"
  ],
  "ACADL": [
    "ACADL cnv",
    "ACADL methyl",
    "ACADL proteo",
    "ACADL rna"
  ],
  "ACADM": [
    "ACADM cnv",
    "ACADM methyl",
    "ACADM proteo",
    "ACADM rna"
  ],
  "ACADS": [
    "ACADS cnv",
    "ACADS methyl",
    "ACADS proteo",
    "ACADS rna"
  ],
  "ACADSB": [
    "ACADSB cnv",
    "ACADSB methyl",
    "ACADSB proteo",
    "ACADSB rna"
  ],
  "ACADVL": [
    "ACADVL cnv",
    "ACADVL methyl",
    "ACADVL proteo",
    "ACADVL rna"
  ],
  "ACAN": [
    "ACAN SNDSGVYR-N2H4F0S0G0 glyco",
    "ACAN SNDSGVYR-N2H5F0S0G0 glyco",
    "ACAN TVYLYPNQTGLPDPLSR-N2H5F0S0G0 glyco",
    "ACAN TVYLYPNQTGLPDPLSR-N4H3F1S0G0 glyco",
    "ACAN TVYLYPNQTGLPDPLSR-N5H3F1S0G0 glyco",
    "ACAN TVYVHANQTGYPDPSSR-N4H3F1S0G0 glyco",
    "ACAN TVYVHANQTGYPDPSSR-N5H3F1S0G0 glyco",
    "ACAN cnv",
    "ACAN methyl",
    "ACAN proteo",
    "ACAN rna"
  ],
  "ACAP1": [
    "ACAP1 cnv",
    "ACAP1 methyl",
    "ACAP1 rna"
  ],
  "ACAP2": [
    "ACAP2 378_391_1_1_S379 phospho",
    "ACAP2 378_391_1_1_S384 phospho",
    "ACAP2 378_391_2_0 phospho",
    "ACAP2 516_521_1_1_S521 phospho",
    "ACAP2 cnv",
    "ACAP2 methyl",
    "ACAP2 proteo",
    "ACAP2 rna"
  ],
  "ACAP3": [
    "ACAP3 cnv",
    "ACAP3 methyl",
    "ACAP3 proteo",
    "ACAP3 rna"
  ],
  "ACAT1": [
    "ACAT1 cnv",
    "ACAT1 methyl",
    "ACAT1 proteo",
    "ACAT1 rna"
  ],
  "ACAT2": [
    "ACAT2 cnv",
    "ACAT2 methyl",
    "ACAT2 proteo",
    "ACAT2 rna"
  ],
  "ACBD3": [
    "ACBD3 cnv",
    "ACBD3 methyl",
    "ACBD3 proteo",
    "ACBD3 rna"
  ],
  "ACBD4": [
    "ACBD4 cnv",
    "ACBD4 methyl",
    "ACBD4 rna"
  ],
  "ACBD5": [
    "ACBD5 123_137_1_1_T137 phospho",
    "ACBD5 397_400_1_1_S400 phospho",
    "ACBD5 cnv",
    "ACBD5 methyl",
    "ACBD5 proteo",
    "ACBD5 rna"
  ],
  "ACBD6": [
    "ACBD6 cnv",
    "ACBD6 methyl",
    "ACBD6 proteo",
    "ACBD6 rna"
  ],
  "ACBD7": [
    "ACBD7 67_77_1_1_S67 phospho",
    "ACBD7 cnv",
    "ACBD7 methyl",
    "ACBD7 proteo",
    "ACBD7 rna"
  ],
  "ACCS": [
    "ACCS cnv",
    "ACCS methyl",
    "ACCS rna"
  ],
  "ACCSL": [
    "ACCSL cnv",
    "ACCSL rna"
  ],
  "ACD": [
    "ACD 106_111_1_1_S111 phospho",
    "ACD 422_435_2_2_S425S435 phospho",
    "ACD cnv",
    "ACD methyl",
    "ACD rna"
  ],
  "ACE": [
    "ACE KFDVNQLQNTTIK-N2H5F0S0G0 glyco",
    "ACE KFDVNQLQNTTIK-N2H7F0S0G0 glyco",
    "ACE NETHFDAGAK-N2H9F0S0G0 glyco",
    "ACE NMQIANHTLK-N4H5F1S0G0 glyco",
    "ACE NMQIANHTLK-N4H5F1S1G0 glyco",
    "ACE cnv",
    "ACE methyl",
    "ACE proteo",
    "ACE rna"
  ],
  "ACE2": [
    "ACE2 methyl",
    "ACE2 rna"
  ],
  "ACER1": [
    "ACER1 cnv",
    "ACER1 rna"
  ],
  "ACER2": [
    "ACER2 cnv",
    "ACER2 methyl",
    "ACER2 rna"
  ],
  "ACER3": [
    "ACER3 cnv",
    "ACER3 methyl",
    "ACER3 rna"
  ],
  "ACHE": [
    "ACHE cnv",
    "ACHE methyl",
    "ACHE proteo",
    "ACHE rna"
  ],
  "ACIN1": [
    "ACIN1 200_216_1_1_S200 phospho",
    "ACIN1 200_216_1_1_T214 phospho",
    "ACIN1 200_216_2_2_S200S203 phospho",
    "ACIN1 323_325_1_1_S325 phospho",
    "ACIN1 360_380_1_1_S370 phospho",
    "ACIN1 360_380_1_1_T374 phospho",
    "ACIN1 384_421_1_1_S385 phospho",
    "ACIN1 384_421_2_0 phospho",
    "ACIN1 384_421_2_1_S413 phospho",
    "ACIN1 427_446_1_1_S438 phospho",
    "ACIN1 450_459_1_1_S450 phospho",
    "ACIN1 521_527_1_0 phospho",
    "ACIN1 624_642_1_1_T642 phospho",
    "ACIN1 635_642_1_1_T642 phospho",
    "ACIN1 670_674_1_1_S670 phospho",
    "ACIN1 689_689_1_1_S689 phospho",
    "ACIN1 823_830_1_1_S823 phospho",
    "ACIN1 833_862_1_0 phospho",
    "ACIN1 855_870_1_0 phospho",
    "ACIN1 855_870_1_1_S858 phospho",
    "ACIN1 858_870_1_1_S858 phospho",
    "ACIN1 959_964_1_1_S964 phospho",
    "ACIN1 cnv",
    "ACIN1 methyl",
    "ACIN1 proteo",
    "ACIN1 rna"
  ],
  "ACKR1": [
    "ACKR1 cnv",
    "ACKR1 rna"
  ],
  "ACKR2": [
    "ACKR2 cnv",
    "ACKR2 methyl",
    "ACKR2 rna"
  ],
  "ACKR3": [
    "ACKR3 347_361_1_1_S350 phospho",
    "ACKR3 cnv",
    "ACKR3 rna"
  ],
  "ACKR4": [
    "ACKR4 cnv",
    "ACKR4 rna"
  ],
  "ACLY": [
    "ACLY 453_459_1_1_S455 phospho",
    "ACLY 478_481_1_1_S481 phospho",
    "ACLY cnv",
    "ACLY methyl",
    "ACLY proteo",
    "ACLY rna"
  ],
  "ACMSD": [
    "ACMSD cnv",
    "ACMSD rna"
  ],
  "ACO1": [
    "ACO1 618_630_1_1_T628 phospho",
    "ACO1 cnv",
    "ACO1 methyl",
    "ACO1 proteo",
    "ACO1 rna"
  ],
  "ACO2": [
    "ACO2 cnv",
    "ACO2 methyl",
    "ACO2 proteo",
    "ACO2 rna"
  ],
  "ACOD1": [
    "ACOD1 cnv",
    "ACOD1 rna"
  ],
  "ACOT1": [
    "ACOT1 cnv",
    "ACOT1 rna"
  ],
  "ACOT11": [
    "ACOT11 cnv",
    "ACOT11 methyl",
    "ACOT11 proteo",
    "ACOT11 rna"
  ],
  "ACOT12": [
    "ACOT12 cnv",
    "ACOT12 methyl",
    "ACOT12 rna"
  ],
  "ACOT13": [
    "ACOT13 cnv",
    "ACOT13 methyl",
    "ACOT13 proteo",
    "ACOT13 rna"
  ],
  "ACOT2": [
    "ACOT2 cnv",
    "ACOT2 rna"
  ],
  "ACOT4": [
    "ACOT4 cnv",
    "ACOT4 methyl",
    "ACOT4 rna"
  ],
  "ACOT6": [
    "ACOT6 cnv",
    "ACOT6 methyl",
    "ACOT6 rna"
  ],
  "ACOT7": [
    "ACOT7 cnv",
    "ACOT7 methyl",
    "ACOT7 proteo",
    "ACOT7 rna"
  ],
  "ACOT8": [
    "ACOT8 cnv",
    "ACOT8 proteo",
    "ACOT8 rna"
  ],
  "ACOT9": [
    "ACOT9 methyl",
    "ACOT9 proteo",
    "ACOT9 rna"
  ],
  "ACOX1": [
    "ACOX1 cnv",
    "ACOX1 methyl",
    "ACOX1 proteo",
    "ACOX1 rna"
  ],
  "ACOX2": [
    "ACOX2 cnv",
    "ACOX2 proteo",
    "ACOX2 rna"
  ],
  "ACOX3": [
    "ACOX3 cnv",
    "ACOX3 methyl",
    "ACOX3 proteo",
    "ACOX3 rna"
  ],
  "ACOXL": [
    "ACOXL cnv",
    "ACOXL methyl",
    "ACOXL rna"
  ],
  "ACP1": [
    "ACP1 cnv",
    "ACP1 methyl",
    "ACP1 proteo",
    "ACP1 rna"
  ],
  "ACP2": [
    "ACP2 FNPNISWQPIPVHTVPITEDR-N2H3F1S0G0 glyco",
    "ACP2 NLTLMATTSQLPK-N2H8F0S0G0 glyco",
    "ACP2 QTPEYQNESSR-N2H3F1S0G0 glyco",
    "ACP2 YEQLQNETR-N2H4F0S0G0 glyco",
    "ACP2 YEQLQNETR-N2H5F0S0G0 glyco",
    "ACP2 YEQLQNETR-N2H6F0S0G0 glyco",
    "ACP2 YEQLQNETR-N2H7F0S0G0 glyco",
    "ACP2 YEQLQNETR-N2H8F0S0G0 glyco",
    "ACP2 YHGFLNTSYHR-N2H3F1S0G0 glyco",
    "ACP2 YHGFLNTSYHR-N4H3F1S0G0 glyco",
    "ACP2 cnv",
    "ACP2 methyl",
    "ACP2 proteo",
    "ACP2 rna"
  ],
  "ACP3": [
    "ACP3 cnv",
    "ACP3 rna"
  ],
  "ACP4": [
    "ACP4 cnv",
    "ACP4 rna"
  ],
  "ACP5": [
    "ACP5 cnv",
    "ACP5 methyl",
    "ACP5 rna"
  ],
  "ACP6": [
    "ACP6 cnv",
    "ACP6 methyl",
    "ACP6 proteo",
    "ACP6 rna"
  ],
  "ACP7": [
    "ACP7 cnv",
    "ACP7 methyl",
    "ACP7 rna"
  ],
  "ACR": [
    "ACR cnv",
    "ACR rna"
  ],
  "ACRBP": [
    "ACRBP cnv",
    "ACRBP methyl",
    "ACRBP rna"
  ],
  "ACRV1": [
    "ACRV1 cnv",
    "ACRV1 rna"
  ],
  "ACSBG1": [
    "ACSBG1 cnv",
    "ACSBG1 proteo",
    "ACSBG1 rna"
  ],
  "ACSBG2": [
    "ACSBG2 cnv",
    "ACSBG2 rna"
  ],
  "ACSF2": [
    "ACSF2 cnv",
    "ACSF2 methyl",
    "ACSF2 proteo",
    "ACSF2 rna"
  ],
  "ACSF3": [
    "ACSF3 cnv",
    "ACSF3 methyl",
    "ACSF3 proteo",
    "ACSF3 rna"
  ],
  "ACSL1": [
    "ACSL1 cnv",
    "ACSL1 methyl",
    "ACSL1 proteo",
    "ACSL1 rna"
  ],
  "ACSL3": [
    "ACSL3 cnv",
    "ACSL3 methyl",
    "ACSL3 proteo",
    "ACSL3 rna"
  ],
  "ACSL4": [
    "ACSL4 methyl",
    "ACSL4 proteo",
    "ACSL4 rna"
  ],
  "ACSL5": [
    "ACSL5 cnv",
    "ACSL5 rna"
  ],
  "ACSL6": [
    "ACSL6 cnv",
    "ACSL6 methyl",
    "ACSL6 proteo",
    "ACSL6 rna"
  ],
  "ACSM1": [
    "ACSM1 cnv",
    "ACSM1 rna"
  ],
  "ACSM2A": [
    "ACSM2A cnv",
    "ACSM2A rna"
  ],
  "ACSM2B": [
    "ACSM2B cnv",
    "ACSM2B rna"
  ],
  "ACSM3": [
    "ACSM3 cnv",
    "ACSM3 rna"
  ],
  "ACSM4": [
    "ACSM4 cnv"
  ],
  "ACSM5": [
    "ACSM5 cnv",
    "ACSM5 rna"
  ],
  "ACSM6": [
    "ACSM6 cnv",
    "ACSM6 rna"
  ],
  "ACSS1": [
    "ACSS1 cnv",
    "ACSS1 methyl",
    "ACSS1 proteo",
    "ACSS1 rna"
  ],
  "ACSS2": [
    "ACSS2 263_267_1_0 phospho",
    "ACSS2 263_267_1_1_S267 phospho",
    "ACSS2 28_36_1_1_S30 phospho",
    "ACSS2 cnv",
    "ACSS2 methyl",
    "ACSS2 proteo",
    "ACSS2 rna"
  ],
  "ACSS3": [
    "ACSS3 cnv",
    "ACSS3 methyl",
    "ACSS3 proteo",
    "ACSS3 rna"
  ],
  "ACTA1": [
    "ACTA1 cnv",
    "ACTA1 methyl",
    "ACTA1 proteo",
    "ACTA1 rna"
  ],
  "ACTA2": [
    "ACTA2 cnv",
    "ACTA2 methyl",
    "ACTA2 proteo",
    "ACTA2 rna"
  ],
  "ACTB": [
    "ACTB cnv",
    "ACTB methyl",
    "ACTB proteo",
    "ACTB rna"
  ],
  "ACTBL2": [
    "ACTBL2 cnv",
    "ACTBL2 proteo"
  ],
  "ACTC1": [
    "ACTC1 cnv",
    "ACTC1 rna"
  ],
  "ACTG1": [
    "ACTG1 cnv",
    "ACTG1 methyl",
    "ACTG1 proteo",
    "ACTG1 rna"
  ],
  "ACTG1P25": [
    "ACTG1P25 methyl"
  ],
  "ACTG2": [
    "ACTG2 cnv",
    "ACTG2 rna"
  ],
  "ACTL10": [
    "ACTL10 cnv",
    "ACTL10 methyl",
    "ACTL10 rna"
  ],
  "ACTL6A": [
    "ACTL6A 233_233_1_1_S233 phospho",
    "ACTL6A cnv",
    "ACTL6A methyl",
    "ACTL6A proteo",
    "ACTL6A rna"
  ],
  "ACTL6B": [
    "ACTL6B cnv",
    "ACTL6B methyl",
    "ACTL6B proteo",
    "ACTL6B rna"
  ],
  "ACTL7A": [
    "ACTL7A cnv",
    "ACTL7A rna"
  ],
  "ACTL7B": [
    "ACTL7B cnv",
    "ACTL7B rna"
  ],
  "ACTL8": [
    "ACTL8 cnv",
    "ACTL8 rna"
  ],
  "ACTL9": [
    "ACTL9 cnv"
  ],
  "ACTN1": [
    "ACTN1 cnv",
    "ACTN1 methyl",
    "ACTN1 proteo",
    "ACTN1 rna"
  ],
  "ACTN1-DT": [
    "ACTN1-DT methyl"
  ],
  "ACTN2": [
    "ACTN2 cnv",
    "ACTN2 methyl",
    "ACTN2 proteo",
    "ACTN2 rna"
  ],
  "ACTN3": [
    "ACTN3 cnv",
    "ACTN3 methyl",
    "ACTN3 proteo",
    "ACTN3 rna"
  ],
  "ACTN4": [
    "ACTN4 cnv",
    "ACTN4 methyl",
    "ACTN4 proteo",
    "ACTN4 rna"
  ],
  "ACTR10": [
    "ACTR10 cnv",
    "ACTR10 methyl",
    "ACTR10 proteo",
    "ACTR10 rna"
  ],
  "ACTR1A": [
    "ACTR1A cnv",
    "ACTR1A methyl",
    "ACTR1A proteo",
    "ACTR1A rna"
  ],
  "ACTR1B": [
    "ACTR1B cnv",
    "ACTR1B methyl",
    "ACTR1B proteo",
    "ACTR1B rna"
  ],
  "ACTR2": [
    "ACTR2 cnv",
    "ACTR2 methyl",
    "ACTR2 proteo",
    "ACTR2 rna"
  ],
  "ACTR3": [
    "ACTR3 cnv",
    "ACTR3 methyl",
    "ACTR3 proteo",
    "ACTR3 rna"
  ],
  "ACTR3B": [
    "ACTR3B cnv",
    "ACTR3B methyl",
    "ACTR3B proteo",
    "ACTR3B rna"
  ],
  "ACTR3C": [
    "ACTR3C cnv",
    "ACTR3C methyl",
    "ACTR3C rna"
  ],
  "ACTR5": [
    "ACTR5 cnv",
    "ACTR5 methyl",
    "ACTR5 proteo",
    "ACTR5 rna"
  ],
  "ACTR6": [
    "ACTR6 cnv",
    "ACTR6 methyl",
    "ACTR6 proteo",
    "ACTR6 rna"
  ],
  "ACTR8": [
    "ACTR8 cnv",
    "ACTR8 methyl",
    "ACTR8 proteo",
    "ACTR8 rna"
  ],
  "ACTRT1": [
    "ACTRT1 rna"
  ],
  "ACTRT2": [
    "ACTRT2 cnv",
    "ACTRT2 rna"
  ],
  "ACTRT3": [
    "ACTRT3 cnv",
    "ACTRT3 methyl",
    "ACTRT3 rna"
  ],
  "ACVR1": [
    "ACVR1 cnv",
    "ACVR1 kinase",
    "ACVR1 methyl",
    "ACVR1 proteo",
    "ACVR1 rna"
  ],
  "ACVR1B": [
    "ACVR1B cnv",
    "ACVR1B kinase",
    "ACVR1B methyl",
    "ACVR1B proteo",
    "ACVR1B rna"
  ],
  "ACVR1C": [
    "ACVR1C cnv",
    "ACVR1C kinase",
    "ACVR1C methyl",
    "ACVR1C rna"
  ],
  "ACVR2A": [
    "ACVR2A NISGSIEIVK-N2H5F0S0G0 glyco",
    "ACVR2A cnv",
    "ACVR2A kinase",
    "ACVR2A methyl",
    "ACVR2A proteo",
    "ACVR2A rna"
  ],
  "ACVR2B": [
    "ACVR2B cnv",
    "ACVR2B kinase",
    "ACVR2B methyl",
    "ACVR2B rna"
  ],
  "ACVR2B-AS1": [
    "ACVR2B-AS1 methyl"
  ],
  "ACVRL1": [
    "ACVRL1 155_161_1_1_S160 phospho",
    "ACVRL1 cnv",
    "ACVRL1 kinase",
    "ACVRL1 methyl",
    "ACVRL1 rna"
  ],
  "ACY1": [
    "ACY1 cnv",
    "ACY1 methyl",
    "ACY1 rna"
  ],
  "ACY3": [
    "ACY3 cnv",
    "ACY3 proteo",
    "ACY3 rna"
  ],
  "ACYP1": [
    "ACYP1 cnv",
    "ACYP1 methyl",
    "ACYP1 proteo",
    "ACYP1 rna"
  ],
  "ACYP2": [
    "ACYP2 cnv",
    "ACYP2 methyl",
    "ACYP2 proteo",
    "ACYP2 rna"
  ],
  "ADA": [
    "ADA cnv",
    "ADA methyl",
    "ADA proteo",
    "ADA rna"
  ],
  "ADA2": [
    "ADA2 cnv",
    "ADA2 proteo",
    "ADA2 rna"
  ],
  "ADAD1": [
    "ADAD1 cnv",
    "ADAD1 methyl"
  ],
  "ADAD2": [
    "ADAD2 cnv",
    "ADAD2 methyl",
    "ADAD2 rna"
  ],
  "ADAL": [
    "ADAL cnv",
    "ADAL methyl",
    "ADAL proteo",
    "ADAL rna"
  ],
  "ADAM10": [
    "ADAM10 719_719_1_1_T719 phospho",
    "ADAM10 740_741_1_1_S740 phospho",
    "ADAM10 EGICNGFTALCPASDPKPNFTDCNR-N4H5F1S2G0 glyco",
    "ADAM10 INTTADEK-N2H8F0S0G0 glyco",
    "ADAM10 INTTADEKDPTNPFRFPNIGVEK-N2H9F0S0G0 glyco",
    "ADAM10 NISFMVK-N2H5F0S0G0 glyco",
    "ADAM10 NISQVLEK-N2H5F0S0G0 glyco",
    "ADAM10 NISQVLEK-N2H6F0S0G0 glyco",
    "ADAM10 NISQVLEK-N2H7F0S0G0 glyco",
    "ADAM10 NISQVLEK-N2H8F0S0G0 glyco",
    "ADAM10 cnv",
    "ADAM10 methyl",
    "ADAM10 proteo",
    "ADAM10 rna"
  ],
  "ADAM11": [
    "ADAM11 cnv",
    "ADAM11 methyl",
    "ADAM11 proteo",
    "ADAM11 rna"
  ],
  "ADAM12": [
    "ADAM12 cnv",
    "ADAM12 methyl",
    "ADAM12 rna"
  ],
  "ADAM15": [
    "ADAM15 cnv",
    "ADAM15 methyl",
    "ADAM15 proteo",
    "ADAM15 rna"
  ],
  "ADAM17": [
    "ADAM17 MFSNCSK-N2H5F0S0G0 glyco",
    "ADAM17 NTSWDNAGFK-N2H5F0S0G0 glyco",
    "ADAM17 VVVVDGKNESEYTVK-N2H8F0S0G0 glyco",
    "ADAM17 cnv",
    "ADAM17 methyl",
    "ADAM17 proteo",
    "ADAM17 rna"
  ],
  "ADAM18": [
    "ADAM18 cnv",
    "ADAM18 rna"
  ],
  "ADAM19": [
    "ADAM19 cnv",
    "ADAM19 methyl",
    "ADAM19 rna"
  ],
  "ADAM2": [
    "ADAM2 cnv"
  ],
  "ADAM20": [
    "ADAM20 cnv",
    "ADAM20 rna"
  ],
  "ADAM21": [
    "ADAM21 cnv",
    "ADAM21 rna"
  ],
  "ADAM22": [
    "ADAM22 833_841_1_1_S839 phospho",
    "ADAM22 833_847_1_1_S841 phospho",
    "ADAM22 861_863_1_1_S863 phospho",
    "ADAM22 884_889_1_1_S886 phospho",
    "ADAM22 884_891_1_0 phospho",
    "ADAM22 884_891_1_1_S886 phospho",
    "ADAM22 ETCSGNSSQCAPNIHK-N2H5F0S0G0 glyco",
    "ADAM22 TLNCSGGHVK-N2H5F0S0G0 glyco",
    "ADAM22 cnv",
    "ADAM22 methyl",
    "ADAM22 proteo",
    "ADAM22 rna"
  ],
  "ADAM23": [
    "ADAM23 HDVFCGFLLCTNLTR-N5H4F2S0G0 glyco",
    "ADAM23 cnv",
    "ADAM23 methyl",
    "ADAM23 proteo",
    "ADAM23 rna"
  ],
  "ADAM28": [
    "ADAM28 cnv",
    "ADAM28 rna"
  ],
  "ADAM29": [
    "ADAM29 cnv",
    "ADAM29 methyl",
    "ADAM29 rna"
  ],
  "ADAM30": [
    "ADAM30 cnv",
    "ADAM30 methyl",
    "ADAM30 rna"
  ],
  "ADAM32": [
    "ADAM32 cnv",
    "ADAM32 methyl",
    "ADAM32 rna"
  ],
  "ADAM33": [
    "ADAM33 cnv",
    "ADAM33 methyl",
    "ADAM33 rna"
  ],
  "ADAM3A": [
    "ADAM3A methyl"
  ],
  "ADAM7": [
    "ADAM7 cnv"
  ],
  "ADAM8": [
    "ADAM8 cnv",
    "ADAM8 methyl",
    "ADAM8 rna"
  ],
  "ADAM9": [
    "ADAM9 758_761_1_1_S758 phospho",
    "ADAM9 758_769_2_2_S758T761 phospho",
    "ADAM9 NFSSCSAEDFEK-N2H5F0S0G0 glyco",
    "ADAM9 NFSSCSAEDFEK-N2H6F0S0G0 glyco",
    "ADAM9 NFSSCSAEDFEK-N2H7F0S0G0 glyco",
    "ADAM9 NFSSCSAEDFEK-N2H8F0S0G0 glyco",
    "ADAM9 cnv",
    "ADAM9 methyl",
    "ADAM9 proteo",
    "ADAM9 rna"
  ],
  "ADAMDEC1": [
    "ADAMDEC1 cnv",
    "ADAMDEC1 rna"
  ],
  "ADAMTS1": [
    "ADAMTS1 cnv",
    "ADAMTS1 methyl",
    "ADAMTS1 rna"
  ],
  "ADAMTS10": [
    "ADAMTS10 cnv",
    "ADAMTS10 methyl",
    "ADAMTS10 rna"
  ],
  "ADAMTS12": [
    "ADAMTS12 cnv",
    "ADAMTS12 methyl",
    "ADAMTS12 rna"
  ],
  "ADAMTS13": [
    "ADAMTS13 cnv",
    "ADAMTS13 rna"
  ],
  "ADAMTS14": [
    "ADAMTS14 cnv",
    "ADAMTS14 methyl",
    "ADAMTS14 rna"
  ],
  "ADAMTS15": [
    "ADAMTS15 cnv",
    "ADAMTS15 methyl",
    "ADAMTS15 rna"
  ],
  "ADAMTS16": [
    "ADAMTS16 cnv",
    "ADAMTS16 methyl",
    "ADAMTS16 rna"
  ],
  "ADAMTS16-DT": [
    "ADAMTS16-DT methyl"
  ],
  "ADAMTS17": [
    "ADAMTS17 cnv",
    "ADAMTS17 methyl",
    "ADAMTS17 rna"
  ],
  "ADAMTS18": [
    "ADAMTS18 cnv",
    "ADAMTS18 methyl",
    "ADAMTS18 rna"
  ],
  "ADAMTS19": [
    "ADAMTS19 cnv",
    "ADAMTS19 methyl",
    "ADAMTS19 rna"
  ],
  "ADAMTS19-AS1": [
    "ADAMTS19-AS1 methyl"
  ],
  "ADAMTS2": [
    "ADAMTS2 cnv",
    "ADAMTS2 methyl",
    "ADAMTS2 rna"
  ],
  "ADAMTS20": [
    "ADAMTS20 cnv",
    "ADAMTS20 methyl",
    "ADAMTS20 rna"
  ],
  "ADAMTS3": [
    "ADAMTS3 cnv",
    "ADAMTS3 methyl",
    "ADAMTS3 rna"
  ],
  "ADAMTS4": [
    "ADAMTS4 cnv",
    "ADAMTS4 proteo",
    "ADAMTS4 rna"
  ],
  "ADAMTS5": [
    "ADAMTS5 cnv",
    "ADAMTS5 methyl",
    "ADAMTS5 rna"
  ],
  "ADAMTS6": [
    "ADAMTS6 cnv",
    "ADAMTS6 rna"
  ],
  "ADAMTS7": [
    "ADAMTS7 cnv",
    "ADAMTS7 methyl",
    "ADAMTS7 proteo",
    "ADAMTS7 rna"
  ],
  "ADAMTS8": [
    "ADAMTS8 cnv",
    "ADAMTS8 methyl",
    "ADAMTS8 rna"
  ],
  "ADAMTS9": [
    "ADAMTS9 cnv",
    "ADAMTS9 methyl",
    "ADAMTS9 rna"
  ],
  "ADAMTSL1": [
    "ADAMTSL1 cnv",
    "ADAMTSL1 methyl",
    "ADAMTSL1 rna"
  ],
  "ADAMTSL2": [
    "ADAMTSL2 cnv",
    "ADAMTSL2 methyl",
    "ADAMTSL2 proteo",
    "ADAMTSL2 rna"
  ],
  "ADAMTSL3": [
    "ADAMTSL3 cnv",
    "ADAMTSL3 methyl",
    "ADAMTSL3 rna"
  ],
  "ADAMTSL4": [
    "ADAMTSL4 cnv",
    "ADAMTSL4 methyl",
    "ADAMTSL4 proteo",
    "ADAMTSL4 rna"
  ],
  "ADAMTSL5": [
    "ADAMTSL5 cnv",
    "ADAMTSL5 methyl",
    "ADAMTSL5 rna"
  ],
  "ADAP1": [
    "ADAP1 cnv",
    "ADAP1 methyl",
    "ADAP1 proteo",
    "ADAP1 rna"
  ],
  "ADAP2": [
    "ADAP2 cnv",
    "ADAP2 methyl",
    "ADAP2 rna"
  ],
  "ADAR": [
    "ADAR 818_825_1_0 phospho",
    "ADAR 818_825_1_1_S825 phospho",
    "ADAR 818_825_1_1_T818 phospho",
    "ADAR cnv",
    "ADAR methyl",
    "ADAR proteo",
    "ADAR rna"
  ],
  "ADARB1": [
    "ADARB1 26_26_1_1_S26 phospho",
    "ADARB1 cnv",
    "ADARB1 methyl",
    "ADARB1 proteo",
    "ADARB1 rna"
  ],
  "ADARB2": [
    "ADARB2 cnv",
    "ADARB2 methyl",
    "ADARB2 rna"
  ],
  "ADAT1": [
    "ADAT1 cnv",
    "ADAT1 methyl",
    "ADAT1 rna"
  ],
  "ADAT2": [
    "ADAT2 cnv",
    "ADAT2 methyl",
    "ADAT2 proteo",
    "ADAT2 rna"
  ],
  "ADAT3": [
    "ADAT3 cnv",
    "ADAT3 methyl",
    "ADAT3 proteo",
    "ADAT3 rna"
  ],
  "ADCK1": [
    "ADCK1 cnv",
    "ADCK1 kinase",
    "ADCK1 proteo",
    "ADCK1 rna"
  ],
  "ADCK2": [
    "ADCK2 cnv",
    "ADCK2 kinase",
    "ADCK2 methyl",
    "ADCK2 rna"
  ],
  "ADCK5": [
    "ADCK5 cnv",
    "ADCK5 kinase",
    "ADCK5 methyl",
    "ADCK5 rna"
  ],
  "ADCY1": [
    "ADCY1 550_563_1_1_S551 phospho",
    "ADCY1 cnv",
    "ADCY1 methyl",
    "ADCY1 proteo",
    "ADCY1 rna"
  ],
  "ADCY10": [
    "ADCY10 cnv",
    "ADCY10 rna"
  ],
  "ADCY10P1": [
    "ADCY10P1 methyl"
  ],
  "ADCY2": [
    "ADCY2 1083_1091_1_1_S1085 phospho",
    "ADCY2 16_16_1_1_S16 phospho",
    "ADCY2 472_472_1_1_S472 phospho",
    "ADCY2 cnv",
    "ADCY2 methyl",
    "ADCY2 proteo",
    "ADCY2 rna"
  ],
  "ADCY3": [
    "ADCY3 cnv",
    "ADCY3 methyl",
    "ADCY3 proteo",
    "ADCY3 rna"
  ],
  "ADCY4": [
    "ADCY4 cnv",
    "ADCY4 methyl",
    "ADCY4 rna"
  ],
  "ADCY5": [
    "ADCY5 664_690_1_1_S666 phospho",
    "ADCY5 cnv",
    "ADCY5 methyl",
    "ADCY5 proteo",
    "ADCY5 rna"
  ],
  "ADCY6": [
    "ADCY6 576_576_1_1_S576 phospho",
    "ADCY6 cnv",
    "ADCY6 methyl",
    "ADCY6 proteo",
    "ADCY6 rna"
  ],
  "ADCY6-DT": [
    "ADCY6-DT methyl"
  ],
  "ADCY7": [
    "ADCY7 cnv",
    "ADCY7 methyl",
    "ADCY7 rna"
  ],
  "ADCY8": [
    "ADCY8 cnv",
    "ADCY8 methyl",
    "ADCY8 proteo",
    "ADCY8 rna"
  ],
  "ADCY9": [
    "ADCY9 1257_1259_1_1_S1257 phospho",
    "ADCY9 1307_1307_1_1_S1307 phospho",
    "ADCY9 608_620_1_0 phospho",
    "ADCY9 cnv",
    "ADCY9 methyl",
    "ADCY9 proteo",
    "ADCY9 rna"
  ],
  "ADCYAP1": [
    "ADCYAP1 cnv",
    "ADCYAP1 methyl",
    "ADCYAP1 rna"
  ],
  "ADCYAP1R1": [
    "ADCYAP1R1 434_450_1_0 phospho",
    "ADCYAP1R1 434_450_1_1_S434 phospho",
    "ADCYAP1R1 434_450_2_1_S434 phospho",
    "ADCYAP1R1 434_450_2_2_S434S447 phospho",
    "ADCYAP1R1 cnv",
    "ADCYAP1R1 methyl",
    "ADCYAP1R1 proteo",
    "ADCYAP1R1 rna"
  ],
  "ADD1": [
    "ADD1 133_138_1_1_S135 phospho",
    "ADD1 355_366_1_0 phospho",
    "ADD1 355_366_1_1_S355 phospho",
    "ADD1 355_366_1_1_S358 phospho",
    "ADD1 457_468_1_1_S465 phospho",
    "ADD1 480_494_1_0 phospho",
    "ADD1 480_494_1_1_T480 phospho",
    "ADD1 586_586_1_1_S586 phospho",
    "ADD1 600_614_1_0 phospho",
    "ADD1 600_614_1_1_S600 phospho",
    "ADD1 627_650_1_1_S645 phospho",
    "ADD1 cnv",
    "ADD1 methyl",
    "ADD1 proteo",
    "ADD1 rna"
  ],
  "ADD2": [
    "ADD2 528_539_1_1_S530 phospho",
    "ADD2 530_539_1_1_S530 phospho",
    "ADD2 544_546_1_1_S546 phospho",
    "ADD2 55_62_1_1_S60 phospho",
    "ADD2 55_62_1_1_S62 phospho",
    "ADD2 585_592_1_1_S592 phospho",
    "ADD2 585_604_3_3_S592S596S600 phospho",
    "ADD2 596_604_1_0 phospho",
    "ADD2 596_604_1_1_S596 phospho",
    "ADD2 596_604_1_1_S600 phospho",
    "ADD2 596_604_1_1_S604 phospho",
    "ADD2 596_604_2_2_S596S600 phospho",
    "ADD2 596_604_2_2_S600S604 phospho",
    "ADD2 596_604_3_3_S596S600S604 phospho",
    "ADD2 596_611_2_2_S600S604 phospho",
    "ADD2 611_619_1_1_S613 phospho",
    "ADD2 611_619_2_2_S613S617 phospho",
    "ADD2 613_619_1_1_S613 phospho",
    "ADD2 613_619_2_2_S613S617 phospho",
    "ADD2 684_699_1_1_S693 phospho",
    "ADD2 684_699_1_1_S697 phospho",
    "ADD2 684_699_2_2_S693S697 phospho",
    "ADD2 684_703_1_0 phospho",
    "ADD2 684_703_1_1_S701 phospho",
    "ADD2 684_703_2_2_S697S701 phospho",
    "ADD2 cnv",
    "ADD2 methyl",
    "ADD2 proteo",
    "ADD2 rna"
  ],
  "ADD3": [
    "ADD3 615_629_1_1_S618 phospho",
    "ADD3 618_629_1_1_S618 phospho",
    "ADD3 632_647_1_1_S645 phospho",
    "ADD3 632_651_1_1_S645 phospho",
    "ADD3 632_651_1_1_S649 phospho",
    "ADD3 632_651_2_2_S645S649 phospho",
    "ADD3 641_647_1_1_S641 phospho",
    "ADD3 641_647_1_1_S645 phospho",
    "ADD3 641_647_2_2_S641S645 phospho",
    "ADD3 641_651_1_1_S645 phospho",
    "ADD3 641_651_1_1_S649 phospho",
    "ADD3 641_651_2_2_S645S649 phospho",
    "ADD3 cnv",
    "ADD3 methyl",
    "ADD3 proteo",
    "ADD3 rna"
  ],
  "ADD3-AS1": [
    "ADD3-AS1 methyl"
  ],
  "ADGB": [
    "ADGB cnv",
    "ADGB methyl",
    "ADGB rna"
  ],
  "ADGB-DT": [
    "ADGB-DT methyl"
  ],
  "ADGRA1": [
    "ADGRA1 346_346_1_1_S346 phospho",
    "ADGRA1 436_447_1_1_S447 phospho",
    "ADGRA1 517_526_1_1_S519 phospho",
    "ADGRA1 cnv",
    "ADGRA1 methyl",
    "ADGRA1 proteo",
    "ADGRA1 rna"
  ],
  "ADGRA2": [
    "ADGRA2 1107_1116_1_1_S1107 phospho",
    "ADGRA2 982_997_1_1_S982 phospho",
    "ADGRA2 cnv",
    "ADGRA2 methyl",
    "ADGRA2 rna"
  ],
  "ADGRA3": [
    "ADGRA3 cnv",
    "ADGRA3 methyl",
    "ADGRA3 proteo",
    "ADGRA3 rna"
  ],
  "ADGRB1": [
    "ADGRB1 1257_1257_1_1_S1257 phospho",
    "ADGRB1 1274_1284_1_1_S1278 phospho",
    "ADGRB1 1291_1291_1_1_S1291 phospho",
    "ADGRB1 1381_1395_1_1_S1392 phospho",
    "ADGRB1 cnv",
    "ADGRB1 methyl",
    "ADGRB1 proteo",
    "ADGRB1 rna"
  ],
  "ADGRB2": [
    "ADGRB2 1225_1231_1_1_S1225 phospho",
    "ADGRB2 1261_1275_1_1_S1275 phospho",
    "ADGRB2 1510_1513_1_1_S1510 phospho",
    "ADGRB2 1542_1545_1_1_S1542 phospho",
    "ADGRB2 cnv",
    "ADGRB2 methyl",
    "ADGRB2 proteo",
    "ADGRB2 rna"
  ],
  "ADGRB3": [
    "ADGRB3 1220_1220_1_1_S1220 phospho",
    "ADGRB3 NVTDTFK-N2H5F0S0G0 glyco",
    "ADGRB3 cnv",
    "ADGRB3 proteo",
    "ADGRB3 rna"
  ],
  "ADGRD1": [
    "ADGRD1 cnv",
    "ADGRD1 methyl",
    "ADGRD1 rna"
  ],
  "ADGRD2": [
    "ADGRD2 cnv",
    "ADGRD2 methyl",
    "ADGRD2 rna"
  ],
  "ADGRE1": [
    "ADGRE1 cnv",
    "ADGRE1 rna"
  ],
  "ADGRE2": [
    "ADGRE2 cnv",
    "ADGRE2 rna"
  ],
  "ADGRE3": [
    "ADGRE3 cnv",
    "ADGRE3 rna"
  ],
  "ADGRE5": [
    "ADGRE5 761_776_1_1_S769 phospho",
    "ADGRE5 LSAVNSIFLSHNNTK-N5H3F1S0G0 glyco",
    "ADGRE5 cnv",
    "ADGRE5 proteo",
    "ADGRE5 rna"
  ],
  "ADGRF1": [
    "ADGRF1 cnv",
    "ADGRF1 rna"
  ],
  "ADGRF2": [
    "ADGRF2 cnv",
    "ADGRF2 rna"
  ],
  "ADGRF3": [
    "ADGRF3 cnv",
    "ADGRF3 methyl",
    "ADGRF3 rna"
  ],
  "ADGRF4": [
    "ADGRF4 cnv",
    "ADGRF4 rna"
  ],
  "ADGRF5": [
    "ADGRF5 cnv",
    "ADGRF5 proteo",
    "ADGRF5 rna"
  ],
  "ADGRG1": [
    "ADGRG1 201_214_1_1_S201 phospho",
    "ADGRG1 664_672_1_1_S664 phospho",
    "ADGRG1 FMGDMVSFEEDRINATVWK-N2H6F0S0G0 glyco",
    "ADGRG1 FMGDMVSFEEDRINATVWK-N2H7F0S0G0 glyco",
    "ADGRG1 NSSQVLGEK-N2H5F0S0G0 glyco",
    "ADGRG1 NSSQVLGEK-N2H8F0S0G0 glyco",
    "ADGRG1 VANLTEPVVLTFQHQLQPK-N5H5F1S1G0 glyco",
    "ADGRG1 cnv",
    "ADGRG1 proteo",
    "ADGRG1 rna"
  ],
  "ADGRG2": [
    "ADGRG2 methyl",
    "ADGRG2 rna"
  ],
  "ADGRG3": [
    "ADGRG3 cnv",
    "ADGRG3 rna"
  ],
  "ADGRG4": [
    "ADGRG4 methyl",
    "ADGRG4 rna"
  ],
  "ADGRG5": [
    "ADGRG5 cnv",
    "ADGRG5 rna"
  ],
  "ADGRG6": [
    "ADGRG6 cnv",
    "ADGRG6 methyl",
    "ADGRG6 rna"
  ],
  "ADGRG7": [
    "ADGRG7 cnv",
    "ADGRG7 rna"
  ],
  "ADGRL1": [
    "ADGRL1 1447_1473_1_1_S1447 phospho",
    "ADGRL1 GPDLSNCTSPWVNQVAQK-N2H5F0S0G0 glyco",
    "ADGRL1 cnv",
    "ADGRL1 methyl",
    "ADGRL1 proteo",
    "ADGRL1 rna"
  ],
  "ADGRL1-AS1": [
    "ADGRL1-AS1 methyl"
  ],
  "ADGRL2": [
    "ADGRL2 1276_1281_1_1_S1278 phospho",
    "ADGRL2 1374_1377_1_1_S1374 phospho",
    "ADGRL2 NSTIAVNSHVISVSINK-N2H5F0S0G0 glyco",
    "ADGRL2 SLGQFLSTENATIK-N2H5F0S0G0 glyco",
    "ADGRL2 SLGQFLSTENATIK-N2H6F0S0G0 glyco",
    "ADGRL2 cnv",
    "ADGRL2 methyl",
    "ADGRL2 proteo",
    "ADGRL2 rna"
  ],
  "ADGRL3": [
    "ADGRL3 1254_1268_1_1_S1254 phospho",
    "ADGRL3 1508_1509_1_1_S1509 phospho",
    "ADGRL3 1508_1527_1_1_T1521 phospho",
    "ADGRL3 1521_1527_1_1_T1521 phospho",
    "ADGRL3 1535_1536_1_1_S1536 phospho",
    "ADGRL3 cnv",
    "ADGRL3 methyl",
    "ADGRL3 proteo",
    "ADGRL3 rna"
  ],
  "ADGRL4": [
    "ADGRL4 cnv",
    "ADGRL4 methyl",
    "ADGRL4 proteo",
    "ADGRL4 rna"
  ],
  "ADGRV1": [
    "ADGRV1 cnv",
    "ADGRV1 methyl",
    "ADGRV1 rna"
  ],
  "ADH1A": [
    "ADH1A cnv",
    "ADH1A rna"
  ],
  "ADH1B": [
    "ADH1B cnv",
    "ADH1B rna"
  ],
  "ADH1C": [
    "ADH1C cnv",
    "ADH1C rna"
  ],
  "ADH4": [
    "ADH4 cnv",
    "ADH4 rna"
  ],
  "ADH5": [
    "ADH5 cnv",
    "ADH5 methyl",
    "ADH5 proteo",
    "ADH5 rna"
  ],
  "ADH6": [
    "ADH6 cnv",
    "ADH6 rna"
  ],
  "ADH7": [
    "ADH7 cnv",
    "ADH7 rna"
  ],
  "ADHFE1": [
    "ADHFE1 cnv",
    "ADHFE1 methyl",
    "ADHFE1 proteo",
    "ADHFE1 rna"
  ],
  "ADI1": [
    "ADI1 cnv",
    "ADI1 methyl",
    "ADI1 proteo",
    "ADI1 rna"
  ],
  "ADIG": [
    "ADIG cnv",
    "ADIG rna"
  ],
  "ADIPOQ": [
    "ADIPOQ cnv",
    "ADIPOQ proteo",
    "ADIPOQ rna"
  ],
  "ADIPOR1": [
    "ADIPOR1 cnv",
    "ADIPOR1 methyl",
    "ADIPOR1 rna"
  ],
  "ADIPOR2": [
    "ADIPOR2 cnv",
    "ADIPOR2 methyl",
    "ADIPOR2 rna"
  ],
  "ADIRF": [
    "ADIRF cnv",
    "ADIRF methyl",
    "ADIRF proteo",
    "ADIRF rna"
  ],
  "ADK": [
    "ADK cnv",
    "ADK methyl",
    "ADK proteo",
    "ADK rna"
  ],
  "ADM": [
    "ADM cnv",
    "ADM methyl",
    "ADM rna"
  ],
  "ADM2": [
    "ADM2 cnv",
    "ADM2 methyl",
    "ADM2 rna"
  ],
  "ADM5": [
    "ADM5 cnv",
    "ADM5 methyl",
    "ADM5 rna"
  ],
  "ADNP": [
    "ADNP 921_923_1_1_S921 phospho",
    "ADNP 953_955_1_1_S953 phospho",
    "ADNP 98_98_1_1_S98 phospho",
    "ADNP cnv",
    "ADNP methyl",
    "ADNP proteo",
    "ADNP rna"
  ],
  "ADNP-AS1": [
    "ADNP-AS1 methyl"
  ],
  "ADNP2": [
    "ADNP2 cnv",
    "ADNP2 methyl",
    "ADNP2 rna"
  ],
  "ADO": [
    "ADO cnv",
    "ADO methyl",
    "ADO proteo",
    "ADO rna"
  ],
  "ADORA1": [
    "ADORA1 cnv",
    "ADORA1 methyl",
    "ADORA1 proteo",
    "ADORA1 rna"
  ],
  "ADORA2A": [
    "ADORA2A cnv",
    "ADORA2A methyl",
    "ADORA2A rna"
  ],
  "ADORA2A-AS1": [
    "ADORA2A-AS1 methyl"
  ],
  "ADORA2B": [
    "ADORA2B cnv",
    "ADORA2B methyl",
    "ADORA2B rna"
  ],
  "ADORA3": [
    "ADORA3 cnv",
    "ADORA3 rna"
  ],
  "ADPGK": [
    "ADPGK cnv",
    "ADPGK methyl",
    "ADPGK proteo",
    "ADPGK rna"
  ],
  "ADPGK-AS1": [
    "ADPGK-AS1 methyl"
  ],
  "ADPRH": [
    "ADPRH cnv",
    "ADPRH methyl",
    "ADPRH proteo",
    "ADPRH rna"
  ],
  "ADPRHL1": [
    "ADPRHL1 cnv",
    "ADPRHL1 rna"
  ],
  "ADPRM": [
    "ADPRM cnv",
    "ADPRM methyl",
    "ADPRM rna"
  ],
  "ADPRS": [
    "ADPRS 57_67_1_1_T64 phospho",
    "ADPRS cnv",
    "ADPRS methyl",
    "ADPRS proteo",
    "ADPRS rna"
  ],
  "ADRA1A": [
    "ADRA1A cnv",
    "ADRA1A methyl",
    "ADRA1A rna"
  ],
  "ADRA1B": [
    "ADRA1B 406_417_1_1_S406 phospho",
    "ADRA1B cnv",
    "ADRA1B methyl",
    "ADRA1B rna"
  ],
  "ADRA1D": [
    "ADRA1D cnv",
    "ADRA1D methyl",
    "ADRA1D rna"
  ],
  "ADRA2A": [
    "ADRA2A cnv",
    "ADRA2A methyl",
    "ADRA2A proteo",
    "ADRA2A rna"
  ],
  "ADRA2B": [
    "ADRA2B cnv",
    "ADRA2B methyl",
    "ADRA2B rna"
  ],
  "ADRA2C": [
    "ADRA2C cnv",
    "ADRA2C methyl",
    "ADRA2C rna"
  ],
  "ADRB1": [
    "ADRB1 cnv",
    "ADRB1 methyl",
    "ADRB1 rna"
  ],
  "ADRB2": [
    "ADRB2 246_246_1_1_S246 phospho",
    "ADRB2 cnv",
    "ADRB2 methyl",
    "ADRB2 rna"
  ],
  "ADRB3": [
    "ADRB3 cnv",
    "ADRB3 methyl",
    "ADRB3 rna"
  ],
  "ADRM1": [
    "ADRM1 211_225_1_1_S224 phospho",
    "ADRM1 405_405_1_1_S405 phospho",
    "ADRM1 cnv",
    "ADRM1 methyl",
    "ADRM1 proteo",
    "ADRM1 rna"
  ],
  "ADSL": [
    "ADSL cnv",
    "ADSL methyl",
    "ADSL proteo",
    "ADSL rna"
  ],
  "ADSS1": [
    "ADSS1 cnv",
    "ADSS1 methyl",
    "ADSS1 proteo",
    "ADSS1 rna"
  ],
  "ADSS2": [
    "ADSS2 cnv",
    "ADSS2 methyl",
    "ADSS2 proteo",
    "ADSS2 rna"
  ],
  "ADTRP": [
    "ADTRP cnv",
    "ADTRP rna"
  ],
  "AEBP1": [
    "AEBP1 cnv",
    "AEBP1 methyl",
    "AEBP1 proteo",
    "AEBP1 rna"
  ],
  "AEBP2": [
    "AEBP2 206_217_1_1_S206 phospho",
    "AEBP2 cnv",
    "AEBP2 methyl",
    "AEBP2 proteo",
    "AEBP2 rna"
  ],
  "AEN": [
    "AEN cnv",
    "AEN methyl",
    "AEN rna"
  ],
  "AFAP1": [
    "AFAP1 248_265_1_0 phospho",
    "AFAP1 277_295_1_1_S283 phospho",
    "AFAP1 277_295_2_0 phospho",
    "AFAP1 546_553_1_1_S548 phospho",
    "AFAP1 661_668_1_1_S668 phospho",
    "AFAP1 675_697_1_0 phospho",
    "AFAP1 675_697_1_1_S679 phospho",
    "AFAP1 704_711_1_1_S711 phospho",
    "AFAP1 cnv",
    "AFAP1 methyl",
    "AFAP1 proteo",
    "AFAP1 rna"
  ],
  "AFAP1L1": [
    "AFAP1L1 315_329_1_1_S329 phospho",
    "AFAP1L1 603_608_1_1_S603 phospho",
    "AFAP1L1 745_751_1_1_S747 phospho",
    "AFAP1L1 cnv",
    "AFAP1L1 methyl",
    "AFAP1L1 proteo",
    "AFAP1L1 rna"
  ],
  "AFAP1L2": [
    "AFAP1L2 344_346_1_1_S344 phospho",
    "AFAP1L2 397_414_1_1_Y413 phospho",
    "AFAP1L2 484_495_1_1_S484 phospho",
    "AFAP1L2 545_581_1_0 phospho",
    "AFAP1L2 623_640_1_1_S640 phospho",
    "AFAP1L2 796_800_1_1_S796 phospho",
    "AFAP1L2 cnv",
    "AFAP1L2 methyl",
    "AFAP1L2 proteo",
    "AFAP1L2 rna"
  ],
  "AFDN": [
    "AFDN 1040_1045_1_1_S1042 phospho",
    "AFDN 1055_1066_1_1_S1066 phospho",
    "AFDN 1131_1141_2_0 phospho",
    "AFDN 1131_1141_2_2_S1131S1141 phospho",
    "AFDN 1131_1141_2_2_S1132S1141 phospho",
    "AFDN 1157_1186_1_0 phospho",
    "AFDN 1189_1195_1_1_T1191 phospho",
    "AFDN 1649_1655_1_0 phospho",
    "AFDN 1731_1747_1_1_S1731 phospho",
    "AFDN 1731_1747_1_1_S1736 phospho",
    "AFDN 173_175_1_1_S175 phospho",
    "AFDN 1756_1762_1_1_S1756 phospho",
    "AFDN 345_350_1_1_S350 phospho",
    "AFDN cnv",
    "AFDN methyl",
    "AFDN proteo",
    "AFDN rna"
  ],
  "AFF1": [
    "AFF1 cnv",
    "AFF1 methyl",
    "AFF1 rna"
  ],
  "AFF2": [
    "AFF2 methyl",
    "AFF2 rna"
  ],
  "AFF3": [
    "AFF3 cnv",
    "AFF3 methyl",
    "AFF3 proteo",
    "AFF3 rna"
  ],
  "AFF4": [
    "AFF4 1055_1058_1_1_S1058 phospho",
    "AFF4 178_195_1_1_S180 phospho",
    "AFF4 210_224_1_1_S212 phospho",
    "AFF4 487_502_1_1_S487 phospho",
    "AFF4 549_557_1_1_S549 phospho",
    "AFF4 619_624_1_1_S620 phospho",
    "AFF4 668_686_1_1_T674 phospho",
    "AFF4 703_712_1_1_S706 phospho",
    "AFF4 814_821_1_1_S814 phospho",
    "AFF4 cnv",
    "AFF4 methyl",
    "AFF4 proteo",
    "AFF4 rna"
  ],
  "AFG1L": [
    "AFG1L cnv",
    "AFG1L methyl",
    "AFG1L proteo",
    "AFG1L rna"
  ],
  "AFG3L1P": [
    "AFG3L1P methyl"
  ],
  "AFG3L2": [
    "AFG3L2 cnv",
    "AFG3L2 methyl",
    "AFG3L2 proteo",
    "AFG3L2 rna"
  ],
  "AFM": [
    "AFM DIENFNSTQK-N3H4F0S1G0 glyco",
    "AFM DIENFNSTQK-N4H5F0S1G0 glyco",
    "AFM DIENFNSTQK-N4H5F0S2G0 glyco",
    "AFM DIENFNSTQK-N4H5F1S2G0 glyco",
    "AFM DIENFNSTQK-N5H6F0S3G0 glyco",
    "AFM HNFSHCCSK-N4H5F0S1G0 glyco",
    "AFM HNFSHCCSK-N4H5F0S2G0 glyco",
    "AFM YAEDKFNETTEK-N4H5F0S1G0 glyco",
    "AFM YAEDKFNETTEK-N4H5F0S2G0 glyco",
    "AFM cnv",
    "AFM proteo"
  ],
  "AFMID": [
    "AFMID cnv",
    "AFMID methyl",
    "AFMID rna"
  ],
  "AFP": [
    "AFP cnv",
    "AFP rna"
  ],
  "AFTPH": [
    "AFTPH 375_382_1_1_S382 phospho",
    "AFTPH 375_387_1_1_S382 phospho",
    "AFTPH 517_522_1_1_S518 phospho",
    "AFTPH 608_617_1_1_T617 phospho",
    "AFTPH cnv",
    "AFTPH methyl",
    "AFTPH proteo",
    "AFTPH rna"
  ],
  "AFTPH-DT": [
    "AFTPH-DT methyl"
  ],
  "AGA": [
    "AGA cnv",
    "AGA methyl",
    "AGA proteo",
    "AGA rna"
  ],
  "AGAP1": [
    "AGAP1 414_422_1_1_S422 phospho",
    "AGAP1 468_468_1_1_S468 phospho",
    "AGAP1 783_787_1_1_T783 phospho",
    "AGAP1 cnv",
    "AGAP1 methyl",
    "AGAP1 proteo",
    "AGAP1 rna"
  ],
  "AGAP2": [
    "AGAP2 146_149_1_1_S147 phospho",
    "AGAP2 166_175_1_1_S168 phospho",
    "AGAP2 166_175_1_1_S175 phospho",
    "AGAP2 26_35_1_1_S33 phospho",
    "AGAP2 388_388_1_1_S388 phospho",
    "AGAP2 47_54_1_1_S54 phospho",
    "AGAP2 634_638_1_1_S638 phospho",
    "AGAP2 647_648_1_1_S648 phospho",
    "AGAP2 808_821_1_1_S808 phospho",
    "AGAP2 925_929_1_1_S927 phospho",
    "AGAP2 cnv",
    "AGAP2 methyl",
    "AGAP2 proteo",
    "AGAP2 rna"
  ],
  "AGAP2-AS1": [
    "AGAP2-AS1 methyl"
  ],
  "AGAP3": [
    "AGAP3 471_479_1_1_S479 phospho",
    "AGAP3 574_577_1_1_S574 phospho",
    "AGAP3 cnv",
    "AGAP3 methyl",
    "AGAP3 proteo",
    "AGAP3 rna"
  ],
  "AGAP4": [
    "AGAP4 cnv",
    "AGAP4 rna"
  ],
  "AGAP5": [
    "AGAP5 cnv",
    "AGAP5 rna"
  ],
  "AGAP6": [
    "AGAP6 cnv",
    "AGAP6 rna"
  ],
  "AGAP9": [
    "AGAP9 cnv",
    "AGAP9 rna"
  ],
  "AGBL1": [
    "AGBL1 cnv",
    "AGBL1 rna"
  ],
  "AGBL2": [
    "AGBL2 cnv",
    "AGBL2 methyl",
    "AGBL2 rna"
  ],
  "AGBL3": [
    "AGBL3 cnv",
    "AGBL3 methyl",
    "AGBL3 rna"
  ],
  "AGBL4": [
    "AGBL4 cnv",
    "AGBL4 methyl",
    "AGBL4 rna"
  ],
  "AGBL5": [
    "AGBL5 cnv",
    "AGBL5 methyl",
    "AGBL5 rna"
  ],
  "AGBL5-AS1": [
    "AGBL5-AS1 methyl"
  ],
  "AGER": [
    "AGER cnv",
    "AGER rna"
  ],
  "AGFG1": [
    "AGFG1 162_181_1_1_T177 phospho",
    "AGFG1 162_181_2_1_T177 phospho",
    "AGFG1 162_181_2_2_T177S181 phospho",
    "AGFG1 177_181_2_2_T177S181 phospho",
    "AGFG1 315_336_1_1_S317 phospho",
    "AGFG1 315_336_1_1_S326 phospho",
    "AGFG1 cnv",
    "AGFG1 methyl",
    "AGFG1 proteo",
    "AGFG1 rna"
  ],
  "AGFG2": [
    "AGFG2 209_217_1_1_S217 phospho",
    "AGFG2 cnv",
    "AGFG2 methyl",
    "AGFG2 proteo",
    "AGFG2 rna"
  ],
  "AGGF1": [
    "AGGF1 cnv",
    "AGGF1 methyl",
    "AGGF1 proteo",
    "AGGF1 rna"
  ],
  "AGK": [
    "AGK cnv",
    "AGK methyl",
    "AGK proteo",
    "AGK rna"
  ],
  "AGL": [
    "AGL cnv",
    "AGL methyl",
    "AGL proteo",
    "AGL rna"
  ],
  "AGMAT": [
    "AGMAT cnv",
    "AGMAT rna"
  ],
  "AGMO": [
    "AGMO cnv",
    "AGMO rna"
  ],
  "AGO1": [
    "AGO1 cnv",
    "AGO1 methyl",
    "AGO1 proteo",
    "AGO1 rna"
  ],
  "AGO2": [
    "AGO2 cnv",
    "AGO2 methyl",
    "AGO2 proteo",
    "AGO2 rna"
  ],
  "AGO3": [
    "AGO3 cnv",
    "AGO3 methyl",
    "AGO3 proteo",
    "AGO3 rna"
  ],
  "AGO4": [
    "AGO4 cnv",
    "AGO4 methyl",
    "AGO4 rna"
  ],
  "AGPAT1": [
    "AGPAT1 cnv",
    "AGPAT1 proteo",
    "AGPAT1 rna"
  ],
  "AGPAT2": [
    "AGPAT2 cnv",
    "AGPAT2 methyl",
    "AGPAT2 proteo",
    "AGPAT2 rna"
  ],
  "AGPAT3": [
    "AGPAT3 cnv",
    "AGPAT3 methyl",
    "AGPAT3 proteo",
    "AGPAT3 rna"
  ],
  "AGPAT4": [
    "AGPAT4 cnv",
    "AGPAT4 proteo",
    "AGPAT4 rna"
  ],
  "AGPAT5": [
    "AGPAT5 cnv",
    "AGPAT5 methyl",
    "AGPAT5 proteo",
    "AGPAT5 rna"
  ],
  "AGPS": [
    "AGPS 65_82_1_1_S65 phospho",
    "AGPS cnv",
    "AGPS methyl",
    "AGPS proteo",
    "AGPS rna"
  ],
  "AGR2": [
    "AGR2 cnv",
    "AGR2 rna"
  ],
  "AGR3": [
    "AGR3 cnv",
    "AGR3 rna"
  ],
  "AGRN": [
    "AGRN CVEESGSAHCVCPMLTCPEANATK-N4H5F1S1G0 glyco",
    "AGRN DPCSNVTCSFGSTCAR-N4H5F2S0G0 glyco",
    "AGRN NELMLNSSLMR-N2H5F0S0G0 glyco",
    "AGRN cnv",
    "AGRN methyl",
    "AGRN proteo",
    "AGRN rna"
  ],
  "AGRP": [
    "AGRP cnv",
    "AGRP rna"
  ],
  "AGT": [
    "AGT VYIHPFHLVIHNESTCEQLAK-N2H5F0S0G0 glyco",
    "AGT VYIHPFHLVIHNESTCEQLAK-N2H9F0S0G0 glyco",
    "AGT VYIHPFHLVIHNESTCEQLAK-N4H5F0S1G0 glyco",
    "AGT VYIHPFHLVIHNESTCEQLAK-N4H5F0S2G0 glyco",
    "AGT VYIHPFHLVIHNESTCEQLAK-N4H5F1S2G0 glyco",
    "AGT VYIHPFHLVIHNESTCEQLAK-N4H5F2S1G0 glyco",
    "AGT VYIHPFHLVIHNESTCEQLAK-N4H6F1S1G0 glyco",
    "AGT VYIHPFHLVIHNESTCEQLAK-N5H3F1S0G0 glyco",
    "AGT VYIHPFHLVIHNESTCEQLAK-N5H6F2S1G0 glyco",
    "AGT VYIHPFHLVIHNESTCEQLAK-N5H6F2S2G0 glyco",
    "AGT VYIHPFHLVIHNESTCEQLAK-N6H3F5S0G0 glyco",
    "AGT cnv",
    "AGT proteo",
    "AGT rna"
  ],
  "AGTPBP1": [
    "AGTPBP1 1219_1224_1_1_S1220 phospho",
    "AGTPBP1 cnv",
    "AGTPBP1 methyl",
    "AGTPBP1 proteo",
    "AGTPBP1 rna"
  ],
  "AGTR1": [
    "AGTR1 cnv",
    "AGTR1 methyl",
    "AGTR1 rna"
  ],
  "AGTR2": [
    "AGTR2 rna"
  ],
  "AGTRAP": [
    "AGTRAP cnv",
    "AGTRAP methyl",
    "AGTRAP proteo",
    "AGTRAP rna"
  ],
  "AGXT": [
    "AGXT cnv",
    "AGXT rna"
  ],
  "AGXT2": [
    "AGXT2 cnv"
  ],
  "AHCTF1": [
    "AHCTF1 1209_1222_1_1_S1222 phospho",
    "AHCTF1 1209_1222_2_2_S1218S1222 phospho",
    "AHCTF1 1229_1232_1_1_S1232 phospho",
    "AHCTF1 cnv",
    "AHCTF1 methyl",
    "AHCTF1 proteo",
    "AHCTF1 rna"
  ],
  "AHCY": [
    "AHCY cnv",
    "AHCY methyl",
    "AHCY proteo",
    "AHCY rna"
  ],
  "AHCYL1": [
    "AHCYL1 cnv",
    "AHCYL1 methyl",
    "AHCYL1 proteo",
    "AHCYL1 rna"
  ],
  "AHCYL2": [
    "AHCYL2 107_113_1_1_S107 phospho",
    "AHCYL2 cnv",
    "AHCYL2 methyl",
    "AHCYL2 proteo",
    "AHCYL2 rna"
  ],
  "AHDC1": [
    "AHDC1 1061_1068_1_1_S1064 phospho",
    "AHDC1 1398_1405_1_1_S1399 phospho",
    "AHDC1 1398_1405_2_2_S1399S1403 phospho",
    "AHDC1 1464_1479_1_1_S1476 phospho",
    "AHDC1 1476_1479_1_1_S1476 phospho",
    "AHDC1 1495_1511_1_1_S1507 phospho",
    "AHDC1 896_916_1_1_S896 phospho",
    "AHDC1 99_107_1_1_T99 phospho",
    "AHDC1 cnv",
    "AHDC1 methyl",
    "AHDC1 proteo",
    "AHDC1 rna"
  ],
  "AHI1": [
    "AHI1 cnv",
    "AHI1 methyl",
    "AHI1 rna"
  ],
  "AHI1-DT": [
    "AHI1-DT methyl"
  ],
  "AHNAK": [
    "AHNAK 1007_1023_1_1_S1010 phospho",
    "AHNAK 1068_1068_1_1_S1068 phospho",
    "AHNAK 1445_1452_1_1_S1452 phospho",
    "AHNAK 1452_1452_1_1_S1452 phospho",
    "AHNAK 158_165_1_1_T158 phospho",
    "AHNAK 176_177_1_1_S177 phospho",
    "AHNAK 18_24_1_1_S18 phospho",
    "AHNAK 210_220_1_1_S210 phospho",
    "AHNAK 210_220_2_2_S210S216 phospho",
    "AHNAK 2580_2580_1_1_S2580 phospho",
    "AHNAK 2708_2708_1_1_S2708 phospho",
    "AHNAK 3409_3412_1_1_S3412 phospho",
    "AHNAK 3716_3724_1_1_T3716 phospho",
    "AHNAK 4516_4522_1_1_S4520 phospho",
    "AHNAK 4564_4564_1_1_T4564 phospho",
    "AHNAK 4766_4766_1_1_T4766 phospho",
    "AHNAK 4900_4912_1_1_S4903 phospho",
    "AHNAK 4908_4912_1_1_S4908 phospho",
    "AHNAK 5031_5031_1_1_S5031 phospho",
    "AHNAK 5089_5099_1_1_S5099 phospho",
    "AHNAK 5386_5400_1_1_S5400 phospho",
    "AHNAK 5448_5448_1_1_S5448 phospho",
    "AHNAK 5620_5620_1_1_S5620 phospho",
    "AHNAK 564_572_1_0 phospho",
    "AHNAK 570_572_1_1_S570 phospho",
    "AHNAK 5729_5739_1_1_S5731 phospho",
    "AHNAK 5745_5763_2_2_S5749S5752 phospho",
    "AHNAK 5749_5763_1_1_S5763 phospho",
    "AHNAK 5749_5763_2_2_S5752S5763 phospho",
    "AHNAK 5780_5784_1_1_S5780 phospho",
    "AHNAK 5780_5807_1_0 phospho",
    "AHNAK 5780_5807_1_1_S5782 phospho",
    "AHNAK 5824_5830_1_1_T5824 phospho",
    "AHNAK 5836_5845_1_1_S5841 phospho",
    "AHNAK 5836_5857_1_1_S5841 phospho",
    "AHNAK 5860_5870_1_1_S5863 phospho",
    "AHNAK 5863_5870_1_1_S5867 phospho",
    "AHNAK 698_698_1_1_S698 phospho",
    "AHNAK 788_793_1_1_S793 phospho",
    "AHNAK cnv",
    "AHNAK methyl",
    "AHNAK proteo",
    "AHNAK rna"
  ],
  "AHNAK2": [
    "AHNAK2 1583_1583_1_1_S1583 phospho",
    "AHNAK2 294_305_1_1_S294 phospho",
    "AHNAK2 330_339_1_1_S332 phospho",
    "AHNAK2 3408_3408_1_1_S3408 phospho",
    "AHNAK2 5172_5182_1_1_S5175 phospho",
    "AHNAK2 5712_5715_1_1_S5714 phospho",
    "AHNAK2 842_846_1_1_S842 phospho",
    "AHNAK2 cnv",
    "AHNAK2 methyl",
    "AHNAK2 mut",
    "AHNAK2 proteo",
    "AHNAK2 rna"
  ],
  "AHR": [
    "AHR cnv",
    "AHR methyl",
    "AHR proteo",
    "AHR rna"
  ],
  "AHRR": [
    "AHRR cnv",
    "AHRR methyl",
    "AHRR rna"
  ],
  "AHSA1": [
    "AHSA1 cnv",
    "AHSA1 methyl",
    "AHSA1 proteo",
    "AHSA1 rna"
  ],
  "AHSA2P": [
    "AHSA2P methyl"
  ],
  "AHSG": [
    "AHSG 133_137_1_1_S137 phospho",
    "AHSG 291_306_1_0 phospho",
    "AHSG 291_306_1_1_S297 phospho",
    "AHSG 291_306_1_1_S300 phospho",
    "AHSG 291_306_1_1_S302 phospho",
    "AHSG AALAAFNAQNNGSNFQLEEISR-N3H4F0S1G0 glyco",
    "AHSG AALAAFNAQNNGSNFQLEEISR-N4H5F0S0G0 glyco",
    "AHSG AALAAFNAQNNGSNFQLEEISR-N4H5F0S1G0 glyco",
    "AHSG AALAAFNAQNNGSNFQLEEISR-N4H5F0S2G0 glyco",
    "AHSG AALAAFNAQNNGSNFQLEEISR-N4H5F1S1G0 glyco",
    "AHSG AALAAFNAQNNGSNFQLEEISR-N4H5F1S2G0 glyco",
    "AHSG AALAAFNAQNNGSNFQLEEISR-N4H5F2S1G0 glyco",
    "AHSG AALAAFNAQNNGSNFQLEEISR-N4H5F3S1G0 glyco",
    "AHSG AALAAFNAQNNGSNFQLEEISR-N4H6F1S1G0 glyco",
    "AHSG AALAAFNAQNNGSNFQLEEISR-N5H6F0S2G0 glyco",
    "AHSG AALAAFNAQNNGSNFQLEEISR-N5H6F1S2G0 glyco",
    "AHSG AALAAFNAQNNGSNFQLEEISR-N5H6F3S2G0 glyco",
    "AHSG AALAAFNAQNNGSNFQLEEISR-N7H5F0S0G0 glyco",
    "AHSG KVCQDCPLLAPLNDTR-N4H5F0S2G0 glyco",
    "AHSG VCQDCPLLAPLNDTR-N3H3F2S0G0 glyco",
    "AHSG VCQDCPLLAPLNDTR-N3H4F0S1G0 glyco",
    "AHSG VCQDCPLLAPLNDTR-N4H5F0S0G0 glyco",
    "AHSG VCQDCPLLAPLNDTR-N4H5F0S1G0 glyco",
    "AHSG VCQDCPLLAPLNDTR-N4H5F0S2G0 glyco",
    "AHSG VCQDCPLLAPLNDTR-N4H5F1S2G0 glyco",
    "AHSG VCQDCPLLAPLNDTR-N5H6F0S2G0 glyco",
    "AHSG VCQDCPLLAPLNDTR-N5H6F0S3G0 glyco",
    "AHSG VCQDCPLLAPLNDTR-N5H6F1S3G0 glyco",
    "AHSG cnv",
    "AHSG proteo",
    "AHSG rna"
  ],
  "AHSP": [
    "AHSP cnv",
    "AHSP proteo",
    "AHSP rna"
  ],
  "AICDA": [
    "AICDA cnv",
    "AICDA rna"
  ],
  "AIDA": [
    "AIDA cnv",
    "AIDA methyl",
    "AIDA proteo",
    "AIDA rna"
  ],
  "AIF1": [
    "AIF1 37_45_1_1_S39 phospho",
    "AIF1 cnv",
    "AIF1 proteo",
    "AIF1 rna"
  ],
  "AIF1L": [
    "AIF1L 133_134_1_0 phospho",
    "AIF1L cnv",
    "AIF1L methyl",
    "AIF1L proteo",
    "AIF1L rna"
  ],
  "AIFM1": [
    "AIFM1 methyl",
    "AIFM1 proteo",
    "AIFM1 rna"
  ],
  "AIFM2": [
    "AIFM2 cnv",
    "AIFM2 methyl",
    "AIFM2 proteo",
    "AIFM2 rna"
  ],
  "AIFM3": [
    "AIFM3 cnv",
    "AIFM3 methyl",
    "AIFM3 rna"
  ],
  "AIG1": [
    "AIG1 cnv",
    "AIG1 methyl",
    "AIG1 proteo",
    "AIG1 rna"
  ],
  "AIM2": [
    "AIM2 cnv",
    "AIM2 methyl",
    "AIM2 rna"
  ],
  "AIMP1": [
    "AIMP1 140_153_1_1_S140 phospho",
    "AIMP1 cnv",
    "AIMP1 proteo",
    "AIMP1 rna"
  ],
  "AIMP2": [
    "AIMP2 cnv",
    "AIMP2 methyl",
    "AIMP2 proteo",
    "AIMP2 rna"
  ],
  "AIP": [
    "AIP 40_53_1_1_S43 phospho",
    "AIP cnv",
    "AIP methyl",
    "AIP proteo",
    "AIP rna"
  ],
  "AIPL1": [
    "AIPL1 cnv",
    "AIPL1 rna"
  ],
  "AIRE": [
    "AIRE cnv",
    "AIRE methyl",
    "AIRE rna"
  ],
  "AJAP1": [
    "AJAP1 cnv",
    "AJAP1 methyl",
    "AJAP1 rna"
  ],
  "AJM1": [
    "AJM1 104_109_1_1_S109 phospho",
    "AJM1 411_434_1_0 phospho",
    "AJM1 468_469_1_1_S468 phospho",
    "AJM1 497_499_1_1_S499 phospho",
    "AJM1 856_856_1_1_S856 phospho",
    "AJM1 cnv",
    "AJM1 methyl",
    "AJM1 proteo",
    "AJM1 rna"
  ],
  "AJUBA": [
    "AJUBA 122_137_1_1_S137 phospho",
    "AJUBA 215_237_1_0 phospho",
    "AJUBA cnv",
    "AJUBA methyl",
    "AJUBA proteo",
    "AJUBA rna"
  ],
  "AK1": [
    "AK1 178_188_1_1_S178 phospho",
    "AK1 32_39_1_1_S38 phospho",
    "AK1 cnv",
    "AK1 methyl",
    "AK1 proteo",
    "AK1 rna"
  ],
  "AK2": [
    "AK2 cnv",
    "AK2 methyl",
    "AK2 proteo",
    "AK2 rna"
  ],
  "AK3": [
    "AK3 cnv",
    "AK3 methyl",
    "AK3 proteo",
    "AK3 rna"
  ],
  "AK4": [
    "AK4 cnv",
    "AK4 methyl",
    "AK4 proteo",
    "AK4 rna"
  ],
  "AK4P3": [
    "AK4P3 cnv",
    "AK4P3 rna"
  ],
  "AK5": [
    "AK5 cnv",
    "AK5 methyl",
    "AK5 proteo",
    "AK5 rna"
  ],
  "AK6": [
    "AK6 cnv",
    "AK6 methyl",
    "AK6 proteo",
    "AK6 rna"
  ],
  "AK7": [
    "AK7 cnv",
    "AK7 methyl",
    "AK7 rna"
  ],
  "AK8": [
    "AK8 cnv",
    "AK8 methyl",
    "AK8 rna"
  ],
  "AK9": [
    "AK9 cnv",
    "AK9 methyl",
    "AK9 rna"
  ],
  "AKAIN1": [
    "AKAIN1 cnv",
    "AKAIN1 methyl",
    "AKAIN1 rna"
  ],
  "AKAP1": [
    "AKAP1 533_544_1_1_T533 phospho",
    "AKAP1 590_600_1_1_S592 phospho",
    "AKAP1 69_75_1_1_T70 phospho",
    "AKAP1 cnv",
    "AKAP1 methyl",
    "AKAP1 proteo",
    "AKAP1 rna"
  ],
  "AKAP10": [
    "AKAP10 180_189_1_1_S187 phospho",
    "AKAP10 47_52_1_1_S52 phospho",
    "AKAP10 cnv",
    "AKAP10 methyl",
    "AKAP10 proteo",
    "AKAP10 rna"
  ],
  "AKAP11": [
    "AKAP11 1100_1109_1_1_T1100 phospho",
    "AKAP11 1240_1249_1_1_S1242 phospho",
    "AKAP11 284_292_1_1_S288 phospho",
    "AKAP11 452_470_1_1_S456 phospho",
    "AKAP11 cnv",
    "AKAP11 methyl",
    "AKAP11 proteo",
    "AKAP11 rna"
  ],
  "AKAP12": [
    "AKAP12 1115_1119_1_0 phospho",
    "AKAP12 1115_1119_1_1_T1116 phospho",
    "AKAP12 11_53_1_0 phospho",
    "AKAP12 11_53_1_1_T21 phospho",
    "AKAP12 1225_1233_1_1_S1226 phospho",
    "AKAP12 1390_1408_1_1_S1395 phospho",
    "AKAP12 1390_1408_2_2_S1391S1395 phospho",
    "AKAP12 1587_1594_1_1_S1587 phospho",
    "AKAP12 1674_1674_1_1_S1674 phospho",
    "AKAP12 1727_1730_1_1_S1727 phospho",
    "AKAP12 1753_1760_1_1_T1760 phospho",
    "AKAP12 1760_1760_1_1_T1760 phospho",
    "AKAP12 219_227_1_1_S219 phospho",
    "AKAP12 248_258_1_1_S248 phospho",
    "AKAP12 280_295_1_1_S286 phospho",
    "AKAP12 280_295_2_2_S283S286 phospho",
    "AKAP12 351_374_1_0 phospho",
    "AKAP12 351_374_1_1_S371 phospho",
    "AKAP12 381_392_1_1_S381 phospho",
    "AKAP12 469_483_1_1_S472 phospho",
    "AKAP12 469_483_1_1_S483 phospho",
    "AKAP12 469_483_2_2_S472S483 phospho",
    "AKAP12 490_505_1_0 phospho",
    "AKAP12 490_505_1_1_S505 phospho",
    "AKAP12 544_557_2_2_S554S557 phospho",
    "AKAP12 544_577_1_0 phospho",
    "AKAP12 597_598_1_0 phospho",
    "AKAP12 597_598_1_1_S598 phospho",
    "AKAP12 608_612_1_1_S612 phospho",
    "AKAP12 627_629_1_1_S627 phospho",
    "AKAP12 627_629_2_2_S627S629 phospho",
    "AKAP12 63_75_1_1_S75 phospho",
    "AKAP12 640_651_1_0 phospho",
    "AKAP12 640_651_1_1_S645 phospho",
    "AKAP12 640_651_2_0 phospho",
    "AKAP12 696_698_1_1_S696 phospho",
    "AKAP12 696_698_1_1_S698 phospho",
    "AKAP12 696_698_2_2_S696S698 phospho",
    "AKAP12 696_698_2_2_S697S698 phospho",
    "AKAP12 696_698_3_3_S696S697S698 phospho",
    "AKAP12 723_761_1_1_S732 phospho",
    "AKAP12 723_761_1_1_S749 phospho",
    "AKAP12 723_761_1_1_S761 phospho",
    "AKAP12 780_806_1_1_S806 phospho",
    "AKAP12 834_852_1_1_S841 phospho",
    "AKAP12 885_900_1_1_S887 phospho",
    "AKAP12 96_105_1_1_S96 phospho",
    "AKAP12 cnv",
    "AKAP12 methyl",
    "AKAP12 proteo",
    "AKAP12 rna"
  ],
  "AKAP13": [
    "AKAP13 1271_1289_1_1_S1282 phospho",
    "AKAP13 1507_1513_1_1_S1507 phospho",
    "AKAP13 1604_1628_1_1_S1606 phospho",
    "AKAP13 1604_1639_1_1_S1606 phospho",
    "AKAP13 1880_1891_1_1_S1880 phospho",
    "AKAP13 1931_1936_1_1_S1933 phospho",
    "AKAP13 1931_1936_1_1_S1936 phospho",
    "AKAP13 1931_1936_2_2_S1933S1936 phospho",
    "AKAP13 2471_2483_1_1_T2471 phospho",
    "AKAP13 2722_2732_1_1_S2724 phospho",
    "AKAP13 649_656_1_1_S650 phospho",
    "AKAP13 943_960_1_1_T953 phospho",
    "AKAP13 981_988_1_1_S983 phospho",
    "AKAP13 cnv",
    "AKAP13 methyl",
    "AKAP13 proteo",
    "AKAP13 rna"
  ],
  "AKAP14": [
    "AKAP14 rna"
  ],
  "AKAP17A": [
    "AKAP17A 537_537_1_1_S537 phospho",
    "AKAP17A proteo",
    "AKAP17A rna"
  ],
  "AKAP3": [
    "AKAP3 cnv",
    "AKAP3 methyl",
    "AKAP3 rna"
  ],
  "AKAP5": [
    "AKAP5 cnv",
    "AKAP5 methyl",
    "AKAP5 proteo",
    "AKAP5 rna"
  ],
  "AKAP6": [
    "AKAP6 1059_1067_1_0 phospho",
    "AKAP6 1059_1067_1_1_S1067 phospho",
    "AKAP6 1644_1646_1_1_S1644 phospho",
    "AKAP6 1653_1663_1_1_S1655 phospho",
    "AKAP6 cnv",
    "AKAP6 proteo",
    "AKAP6 rna"
  ],
  "AKAP7": [
    "AKAP7 cnv",
    "AKAP7 methyl",
    "AKAP7 proteo",
    "AKAP7 rna"
  ],
  "AKAP8": [
    "AKAP8 323_328_1_1_S328 phospho",
    "AKAP8 cnv",
    "AKAP8 methyl",
    "AKAP8 proteo",
    "AKAP8 rna"
  ],
  "AKAP8L": [
    "AKAP8L 222_228_1_1_S222 phospho",
    "AKAP8L cnv",
    "AKAP8L methyl",
    "AKAP8L proteo",
    "AKAP8L rna"
  ],
  "AKAP9": [
    "AKAP9 1641_1650_1_1_S1642 phospho",
    "AKAP9 cnv",
    "AKAP9 methyl",
    "AKAP9 proteo",
    "AKAP9 rna"
  ],
  "AKIP1": [
    "AKIP1 cnv",
    "AKIP1 methyl",
    "AKIP1 rna"
  ],
  "AKIRIN1": [
    "AKIRIN1 cnv",
    "AKIRIN1 methyl",
    "AKIRIN1 rna"
  ],
  "AKIRIN2": [
    "AKIRIN2 cnv",
    "AKIRIN2 methyl",
    "AKIRIN2 rna"
  ],
  "AKNA": [
    "AKNA 1219_1228_1_1_S1228 phospho",
    "AKNA cnv",
    "AKNA methyl",
    "AKNA rna"
  ],
  "AKNAD1": [
    "AKNAD1 cnv",
    "AKNAD1 methyl",
    "AKNAD1 rna"
  ],
  "AKR1A1": [
    "AKR1A1 cnv",
    "AKR1A1 methyl",
    "AKR1A1 proteo",
    "AKR1A1 rna"
  ],
  "AKR1B1": [
    "AKR1B1 cnv",
    "AKR1B1 methyl",
    "AKR1B1 proteo",
    "AKR1B1 rna"
  ],
  "AKR1B10": [
    "AKR1B10 cnv",
    "AKR1B10 rna"
  ],
  "AKR1B15": [
    "AKR1B15 cnv",
    "AKR1B15 rna"
  ],
  "AKR1C1": [
    "AKR1C1 cnv",
    "AKR1C1 rna"
  ],
  "AKR1C2": [
    "AKR1C2 cnv",
    "AKR1C2 proteo",
    "AKR1C2 rna"
  ],
  "AKR1C3": [
    "AKR1C3 cnv",
    "AKR1C3 proteo",
    "AKR1C3 rna"
  ],
  "AKR1C4": [
    "AKR1C4 cnv",
    "AKR1C4 rna"
  ],
  "AKR1C8": [
    "AKR1C8 cnv",
    "AKR1C8 rna"
  ],
  "AKR1D1": [
    "AKR1D1 cnv",
    "AKR1D1 methyl",
    "AKR1D1 rna"
  ],
  "AKR1E2": [
    "AKR1E2 cnv",
    "AKR1E2 methyl",
    "AKR1E2 rna"
  ],
  "AKR7A2": [
    "AKR7A2 cnv",
    "AKR7A2 methyl",
    "AKR7A2 proteo",
    "AKR7A2 rna"
  ],
  "AKR7A3": [
    "AKR7A3 cnv",
    "AKR7A3 methyl",
    "AKR7A3 proteo",
    "AKR7A3 rna"
  ],
  "AKR7L": [
    "AKR7L cnv",
    "AKR7L rna"
  ],
  "AKT1": [
    "AKT1 122_137_1_0 phospho",
    "AKT1 122_137_1_1_S124 phospho",
    "AKT1 122_137_1_1_S129 phospho",
    "AKT1 122_137_2_2_S124S129 phospho",
    "AKT1 cnv",
    "AKT1 kinase",
    "AKT1 methyl",
    "AKT1 proteo",
    "AKT1 rna"
  ],
  "AKT1S1": [
    "AKT1S1 183_187_1_1_S183 phospho",
    "AKT1S1 198_212_1_1_S203 phospho",
    "AKT1S1 198_212_2_0 phospho",
    "AKT1S1 198_212_2_2_S202S203 phospho",
    "AKT1S1 198_212_3_3_S202S203S212 phospho",
    "AKT1S1 202_212_1_1_S212 phospho",
    "AKT1S1 202_212_2_2_S203S212 phospho",
    "AKT1S1 246_247_1_1_T246 phospho",
    "AKT1S1 73_97_1_1_S88 phospho",
    "AKT1S1 73_97_2_2_S88S92 phospho",
    "AKT1S1 cnv",
    "AKT1S1 methyl",
    "AKT1S1 proteo",
    "AKT1S1 rna"
  ],
  "AKT2": [
    "AKT2 406_416_1_1_S416 phospho",
    "AKT2 64_79_1_1_S64 phospho",
    "AKT2 cnv",
    "AKT2 kinase",
    "AKT2 methyl",
    "AKT2 proteo",
    "AKT2 rna"
  ],
  "AKT3": [
    "AKT3 cnv",
    "AKT3 kinase",
    "AKT3 methyl",
    "AKT3 proteo",
    "AKT3 rna"
  ],
  "AKTIP": [
    "AKTIP cnv",
    "AKTIP methyl",
    "AKTIP proteo",
    "AKTIP rna"
  ],
  "AL6459221": [
    "AL6459221 ALQAVYSMMSWPDDVPPEGWNR-N4H5F0S2G0 glyco",
    "AL6459221 KALQAVYSMMSWPDDVPPEGWNR-N4H5F0S2G0 glyco",
    "AL6459221 QSVPAHFVALNGSK-N2H5F0S0G0 glyco",
    "AL6459221 QSVPAHFVALNGSK-N2H6F0S0G0 glyco",
    "AL6459221 QSVPAHFVALNGSK-N2H7F0S0G0 glyco",
    "AL6459221 QSVPAHFVALNGSK-N2H8F0S0G0 glyco",
    "AL6459221 QSVPAHFVALNGSK-N3H5F0S1G0 glyco",
    "AL6459221 QSVPAHFVALNGSK-N3H6F0S1G0 glyco",
    "AL6459221 SPYYNVSDEISFHCYDGYTLR-N4H5F0S1G0 glyco",
    "AL6459221 TMFPNLTDVR-N4H5F0S2G0 glyco"
  ],
  "ALAD": [
    "ALAD 206_207_1_1_S207 phospho",
    "ALAD cnv",
    "ALAD methyl",
    "ALAD proteo",
    "ALAD rna"
  ],
  "ALAS1": [
    "ALAS1 cnv",
    "ALAS1 methyl",
    "ALAS1 rna"
  ],
  "ALAS2": [
    "ALAS2 rna"
  ],
  "ALB": [
    "ALB 287_297_1_1_S294 phospho",
    "ALB 29_29_1_1_S29 phospho",
    "ALB 76_82_1_1_S82 phospho",
    "ALB 76_92_1_1_S82 phospho",
    "ALB cnv",
    "ALB proteo",
    "ALB rna"
  ],
  "ALCAM": [
    "ALCAM EGDNITLK-N6H3F1S0G0 glyco",
    "ALCAM EGDNITLK-N6H4F1S0G0 glyco",
    "ALCAM EGDNITLK-N6H4F2S0G0 glyco",
    "ALCAM IIISPEENVTLTCTAENQLER-N2H5F0S0G0 glyco",
    "ALCAM KLGDCISEDSYPDGNITWYR-N2H5F0S0G0 glyco",
    "ALCAM LGDCISEDSYPDGNITWYR-N2H5F0S0G0 glyco",
    "ALCAM LGDCISEDSYPDGNITWYR-N5H3F1S0G0 glyco",
    "ALCAM LNLSENYTLSISNAR-N2H5F0S0G0 glyco",
    "ALCAM LNLSENYTLSISNAR-N5H3F1S0G0 glyco",
    "ALCAM NATGDYK-N4H3F1S0G0 glyco",
    "ALCAM NATGDYK-N5H3F1S0G0 glyco",
    "ALCAM cnv",
    "ALCAM methyl",
    "ALCAM proteo",
    "ALCAM rna"
  ],
  "ALDH16A1": [
    "ALDH16A1 cnv",
    "ALDH16A1 methyl",
    "ALDH16A1 proteo",
    "ALDH16A1 rna"
  ],
  "ALDH18A1": [
    "ALDH18A1 cnv",
    "ALDH18A1 methyl",
    "ALDH18A1 proteo",
    "ALDH18A1 rna"
  ],
  "ALDH1A1": [
    "ALDH1A1 cnv",
    "ALDH1A1 proteo",
    "ALDH1A1 rna"
  ],
  "ALDH1A2": [
    "ALDH1A2 cnv",
    "ALDH1A2 methyl",
    "ALDH1A2 rna"
  ],
  "ALDH1A3": [
    "ALDH1A3 cnv",
    "ALDH1A3 methyl",
    "ALDH1A3 proteo",
    "ALDH1A3 rna"
  ],
  "ALDH1A3-AS1": [
    "ALDH1A3-AS1 methyl"
  ],
  "ALDH1B1": [
    "ALDH1B1 cnv",
    "ALDH1B1 methyl",
    "ALDH1B1 proteo",
    "ALDH1B1 rna"
  ],
  "ALDH1L1": [
    "ALDH1L1 cnv",
    "ALDH1L1 methyl",
    "ALDH1L1 proteo",
    "ALDH1L1 rna"
  ],
  "ALDH1L1-AS2": [
    "ALDH1L1-AS2 methyl"
  ],
  "ALDH1L2": [
    "ALDH1L2 cnv",
    "ALDH1L2 methyl",
    "ALDH1L2 proteo",
    "ALDH1L2 rna"
  ],
  "ALDH2": [
    "ALDH2 cnv",
    "ALDH2 methyl",
    "ALDH2 proteo",
    "ALDH2 rna"
  ],
  "ALDH3A1": [
    "ALDH3A1 cnv",
    "ALDH3A1 proteo",
    "ALDH3A1 rna"
  ],
  "ALDH3A2": [
    "ALDH3A2 cnv",
    "ALDH3A2 methyl",
    "ALDH3A2 proteo",
    "ALDH3A2 rna"
  ],
  "ALDH3B1": [
    "ALDH3B1 cnv",
    "ALDH3B1 methyl",
    "ALDH3B1 proteo",
    "ALDH3B1 rna"
  ],
  "ALDH3B2": [
    "ALDH3B2 cnv",
    "ALDH3B2 methyl",
    "ALDH3B2 rna"
  ],
  "ALDH4A1": [
    "ALDH4A1 cnv",
    "ALDH4A1 methyl",
    "ALDH4A1 proteo",
    "ALDH4A1 rna"
  ],
  "ALDH5A1": [
    "ALDH5A1 cnv",
    "ALDH5A1 methyl",
    "ALDH5A1 proteo",
    "ALDH5A1 rna"
  ],
  "ALDH6A1": [
    "ALDH6A1 cnv",
    "ALDH6A1 methyl",
    "ALDH6A1 proteo",
    "ALDH6A1 rna"
  ],
  "ALDH7A1": [
    "ALDH7A1 cnv",
    "ALDH7A1 methyl",
    "ALDH7A1 proteo",
    "ALDH7A1 rna"
  ],
  "ALDH8A1": [
    "ALDH8A1 cnv",
    "ALDH8A1 rna"
  ],
  "ALDH9A1": [
    "ALDH9A1 cnv",
    "ALDH9A1 methyl",
    "ALDH9A1 proteo",
    "ALDH9A1 rna"
  ],
  "ALDOA": [
    "ALDOA 100_106_1_1_S100 phospho",
    "ALDOA 173_186_1_1_S186 phospho",
    "ALDOA 260_281_1_0 phospho",
    "ALDOA 260_281_1_1_S276 phospho",
    "ALDOA 343_364_1_0 phospho",
    "ALDOA 90_93_1_0 phospho",
    "ALDOA 90_93_1_1_S93 phospho",
    "ALDOA cnv",
    "ALDOA methyl",
    "ALDOA proteo",
    "ALDOA rna"
  ],
  "ALDOB": [
    "ALDOB cnv",
    "ALDOB rna"
  ],
  "ALDOC": [
    "ALDOC 119_132_1_1_S132 phospho",
    "ALDOC 36_39_1_1_S36 phospho",
    "ALDOC 36_39_1_1_S39 phospho",
    "ALDOC 45_52_1_1_S45 phospho",
    "ALDOC cnv",
    "ALDOC proteo",
    "ALDOC rna"
  ],
  "ALG1": [
    "ALG1 cnv",
    "ALG1 methyl",
    "ALG1 proteo",
    "ALG1 rna"
  ],
  "ALG10": [
    "ALG10 cnv",
    "ALG10 methyl",
    "ALG10 rna"
  ],
  "ALG10B": [
    "ALG10B cnv",
    "ALG10B methyl",
    "ALG10B rna"
  ],
  "ALG11": [
    "ALG11 cnv",
    "ALG11 methyl",
    "ALG11 proteo",
    "ALG11 rna"
  ],
  "ALG12": [
    "ALG12 cnv",
    "ALG12 methyl",
    "ALG12 proteo",
    "ALG12 rna"
  ],
  "ALG13": [
    "ALG13 methyl",
    "ALG13 proteo",
    "ALG13 rna"
  ],
  "ALG14": [
    "ALG14 cnv",
    "ALG14 methyl",
    "ALG14 rna"
  ],
  "ALG1L": [
    "ALG1L cnv",
    "ALG1L rna"
  ],
  "ALG1L2": [
    "ALG1L2 cnv",
    "ALG1L2 rna"
  ],
  "ALG1L9P": [
    "ALG1L9P methyl"
  ],
  "ALG2": [
    "ALG2 cnv",
    "ALG2 methyl",
    "ALG2 proteo",
    "ALG2 rna"
  ],
  "ALG3": [
    "ALG3 11_13_1_1_S11 phospho",
    "ALG3 cnv",
    "ALG3 methyl",
    "ALG3 rna"
  ],
  "ALG5": [
    "ALG5 cnv",
    "ALG5 methyl",
    "ALG5 proteo",
    "ALG5 rna"
  ],
  "ALG6": [
    "ALG6 cnv",
    "ALG6 methyl",
    "ALG6 proteo",
    "ALG6 rna"
  ],
  "ALG8": [
    "ALG8 cnv",
    "ALG8 methyl",
    "ALG8 proteo",
    "ALG8 rna"
  ],
  "ALG9": [
    "ALG9 cnv",
    "ALG9 methyl",
    "ALG9 proteo",
    "ALG9 rna"
  ],
  "ALK": [
    "ALK cnv",
    "ALK kinase",
    "ALK methyl",
    "ALK proteo",
    "ALK rna"
  ],
  "ALKAL1": [
    "ALKAL1 cnv",
    "ALKAL1 methyl",
    "ALKAL1 rna"
  ],
  "ALKAL2": [
    "ALKAL2 cnv",
    "ALKAL2 methyl",
    "ALKAL2 rna"
  ],
  "ALKBH1": [
    "ALKBH1 cnv",
    "ALKBH1 methyl",
    "ALKBH1 rna"
  ],
  "ALKBH2": [
    "ALKBH2 cnv",
    "ALKBH2 methyl",
    "ALKBH2 rna"
  ],
  "ALKBH3": [
    "ALKBH3 cnv",
    "ALKBH3 methyl",
    "ALKBH3 proteo",
    "ALKBH3 rna"
  ],
  "ALKBH4": [
    "ALKBH4 cnv",
    "ALKBH4 methyl",
    "ALKBH4 proteo",
    "ALKBH4 rna"
  ],
  "ALKBH5": [
    "ALKBH5 361_367_1_1_S361 phospho",
    "ALKBH5 60_71_1_1_S64 phospho",
    "ALKBH5 60_71_2_2_S64S69 phospho",
    "ALKBH5 cnv",
    "ALKBH5 methyl",
    "ALKBH5 proteo",
    "ALKBH5 rna"
  ],
  "ALKBH6": [
    "ALKBH6 cnv",
    "ALKBH6 methyl",
    "ALKBH6 rna"
  ],
  "ALKBH7": [
    "ALKBH7 cnv",
    "ALKBH7 methyl",
    "ALKBH7 rna"
  ],
  "ALKBH8": [
    "ALKBH8 cnv",
    "ALKBH8 proteo",
    "ALKBH8 rna"
  ],
  "ALLC": [
    "ALLC cnv",
    "ALLC rna"
  ],
  "ALMS1": [
    "ALMS1 cnv",
    "ALMS1 methyl",
    "ALMS1 proteo",
    "ALMS1 rna"
  ],
  "ALOX12": [
    "ALOX12 cnv",
    "ALOX12 methyl",
    "ALOX12 rna"
  ],
  "ALOX12-AS1": [
    "ALOX12-AS1 methyl"
  ],
  "ALOX12B": [
    "ALOX12B cnv",
    "ALOX12B methyl",
    "ALOX12B proteo",
    "ALOX12B rna"
  ],
  "ALOX15": [
    "ALOX15 cnv",
    "ALOX15 methyl",
    "ALOX15 rna"
  ],
  "ALOX15B": [
    "ALOX15B cnv",
    "ALOX15B rna"
  ],
  "ALOX5": [
    "ALOX5 cnv",
    "ALOX5 methyl",
    "ALOX5 proteo",
    "ALOX5 rna"
  ],
  "ALOX5AP": [
    "ALOX5AP cnv",
    "ALOX5AP proteo",
    "ALOX5AP rna"
  ],
  "ALOXE3": [
    "ALOXE3 cnv",
    "ALOXE3 methyl",
    "ALOXE3 rna"
  ],
  "ALPG": [
    "ALPG cnv"
  ],
  "ALPI": [
    "ALPI cnv"
  ],
  "ALPK1": [
    "ALPK1 cnv",
    "ALPK1 kinase",
    "ALPK1 rna"
  ],
  "ALPK2": [
    "ALPK2 cnv",
    "ALPK2 kinase",
    "ALPK2 rna"
  ],
  "ALPK3": [
    "ALPK3 cnv",
    "ALPK3 kinase",
    "ALPK3 methyl",
    "ALPK3 rna"
  ],
  "ALPL": [
    "ALPL 100_117_1_1_S110 phospho",
    "ALPL cnv",
    "ALPL methyl",
    "ALPL proteo",
    "ALPL rna"
  ],
  "ALPP": [
    "ALPP cnv",
    "ALPP rna"
  ],
  "ALS2": [
    "ALS2 1335_1340_1_1_S1335 phospho",
    "ALS2 1462_1474_1_1_S1464 phospho",
    "ALS2 464_479_1_1_S466 phospho",
    "ALS2 483_492_1_1_S483 phospho",
    "ALS2 483_492_1_1_S492 phospho",
    "ALS2 483_492_2_2_S483S492 phospho",
    "ALS2 506_523_1_1_T510 phospho",
    "ALS2 cnv",
    "ALS2 methyl",
    "ALS2 proteo",
    "ALS2 rna"
  ],
  "ALS2CL": [
    "ALS2CL cnv",
    "ALS2CL methyl",
    "ALS2CL rna"
  ],
  "ALX1": [
    "ALX1 cnv",
    "ALX1 methyl",
    "ALX1 rna"
  ],
  "ALX3": [
    "ALX3 cnv",
    "ALX3 rna"
  ],
  "ALX4": [
    "ALX4 cnv",
    "ALX4 methyl",
    "ALX4 rna"
  ],
  "ALYREF": [
    "ALYREF cnv",
    "ALYREF methyl",
    "ALYREF proteo",
    "ALYREF rna"
  ],
  "AMACR": [
    "AMACR cnv",
    "AMACR methyl",
    "AMACR proteo",
    "AMACR rna"
  ],
  "AMBN": [
    "AMBN cnv",
    "AMBN rna"
  ],
  "AMBP": [
    "AMBP YFYNGTSMACETFQYGGCMGNGNNFVTEK-N4H5F0S2G0 glyco",
    "AMBP YFYNGTSMACETFQYGGCMGNGNNFVTEK-N4H5F2S1G0 glyco",
    "AMBP YFYNGTSMACETFQYGGCMGNGNNFVTEK-N4H6F1S1G0 glyco",
    "AMBP YFYNGTSMACETFQYGGCMGNGNNFVTEK-N5H5F1S1G0 glyco",
    "AMBP cnv",
    "AMBP proteo",
    "AMBP rna"
  ],
  "AMBRA1": [
    "AMBRA1 1194_1214_1_1_S1208 phospho",
    "AMBRA1 cnv",
    "AMBRA1 methyl",
    "AMBRA1 proteo",
    "AMBRA1 rna"
  ],
  "AMD1": [
    "AMD1 cnv",
    "AMD1 methyl",
    "AMD1 rna"
  ],
  "AMDHD1": [
    "AMDHD1 cnv",
    "AMDHD1 methyl",
    "AMDHD1 rna"
  ],
  "AMDHD2": [
    "AMDHD2 cnv",
    "AMDHD2 methyl",
    "AMDHD2 proteo",
    "AMDHD2 rna"
  ],
  "AMELX": [
    "AMELX rna"
  ],
  "AMELY": [
    "AMELY methyl"
  ],
  "AMER1": [
    "AMER1 methyl",
    "AMER1 rna"
  ],
  "AMER2": [
    "AMER2 103_117_1_1_T105 phospho",
    "AMER2 229_233_1_1_S233 phospho",
    "AMER2 367_371_1_1_S371 phospho",
    "AMER2 76_82_1_1_S76 phospho",
    "AMER2 cnv",
    "AMER2 methyl",
    "AMER2 proteo",
    "AMER2 rna"
  ],
  "AMER3": [
    "AMER3 cnv",
    "AMER3 methyl",
    "AMER3 rna"
  ],
  "AMFR": [
    "AMFR 507_534_1_1_S523 phospho",
    "AMFR cnv",
    "AMFR methyl",
    "AMFR proteo",
    "AMFR rna"
  ],
  "AMH": [
    "AMH cnv",
    "AMH rna"
  ],
  "AMHR2": [
    "AMHR2 cnv",
    "AMHR2 kinase",
    "AMHR2 rna"
  ],
  "AMIGO1": [
    "AMIGO1 cnv",
    "AMIGO1 methyl",
    "AMIGO1 proteo",
    "AMIGO1 rna"
  ],
  "AMIGO2": [
    "AMIGO2 cnv",
    "AMIGO2 methyl",
    "AMIGO2 rna"
  ],
  "AMIGO3": [
    "AMIGO3 cnv",
    "AMIGO3 methyl",
    "AMIGO3 rna"
  ],
  "AMMECR1": [
    "AMMECR1 methyl",
    "AMMECR1 rna"
  ],
  "AMMECR1L": [
    "AMMECR1L cnv",
    "AMMECR1L methyl",
    "AMMECR1L rna"
  ],
  "AMN": [
    "AMN cnv",
    "AMN methyl",
    "AMN rna"
  ],
  "AMN1": [
    "AMN1 cnv",
    "AMN1 methyl",
    "AMN1 proteo",
    "AMN1 rna"
  ],
  "AMOT": [
    "AMOT 229_229_1_1_S229 phospho",
    "AMOT 708_721_1_1_S714 phospho",
    "AMOT methyl",
    "AMOT proteo",
    "AMOT rna"
  ],
  "AMOTL1": [
    "AMOTL1 191_191_1_1_S191 phospho",
    "AMOTL1 272_275_1_1_S272 phospho",
    "AMOTL1 743_755_1_1_S743 phospho",
    "AMOTL1 743_755_1_1_S755 phospho",
    "AMOTL1 758_763_1_1_S759 phospho",
    "AMOTL1 850_856_1_1_S856 phospho",
    "AMOTL1 874_874_1_1_S874 phospho",
    "AMOTL1 cnv",
    "AMOTL1 methyl",
    "AMOTL1 proteo",
    "AMOTL1 rna"
  ],
  "AMOTL2": [
    "AMOTL2 103_128_1_1_S108 phospho",
    "AMOTL2 234_241_1_1_S241 phospho",
    "AMOTL2 294_294_1_1_S294 phospho",
    "AMOTL2 592_602_1_1_S598 phospho",
    "AMOTL2 cnv",
    "AMOTL2 methyl",
    "AMOTL2 proteo",
    "AMOTL2 rna"
  ],
  "AMPD1": [
    "AMPD1 cnv",
    "AMPD1 rna"
  ],
  "AMPD2": [
    "AMPD2 168_168_1_1_S168 phospho",
    "AMPD2 188_197_1_1_S190 phospho",
    "AMPD2 282_314_1_1_T289 phospho",
    "AMPD2 cnv",
    "AMPD2 methyl",
    "AMPD2 proteo",
    "AMPD2 rna"
  ],
  "AMPD3": [
    "AMPD3 92_96_1_0 phospho",
    "AMPD3 92_96_1_1_S94 phospho",
    "AMPD3 cnv",
    "AMPD3 methyl",
    "AMPD3 proteo",
    "AMPD3 rna"
  ],
  "AMPH": [
    "AMPH 244_252_1_1_S252 phospho",
    "AMPH 260_285_1_0 phospho",
    "AMPH 260_285_1_1_S262 phospho",
    "AMPH 260_285_1_1_S272 phospho",
    "AMPH 260_285_2_1_S262 phospho",
    "AMPH 260_285_2_2_S262S272 phospho",
    "AMPH 260_285_2_2_S262S276 phospho",
    "AMPH 310_312_1_1_T310 phospho",
    "AMPH 498_506_1_1_S506 phospho",
    "AMPH 542_560_1_0 phospho",
    "AMPH 542_560_1_1_S549 phospho",
    "AMPH cnv",
    "AMPH methyl",
    "AMPH proteo",
    "AMPH rna"
  ],
  "AMT": [
    "AMT cnv",
    "AMT methyl",
    "AMT proteo",
    "AMT rna"
  ],
  "AMTN": [
    "AMTN cnv",
    "AMTN rna"
  ],
  "AMY1A": [
    "AMY1A cnv",
    "AMY1A rna"
  ],
  "AMY1B": [
    "AMY1B cnv",
    "AMY1B rna"
  ],
  "AMY1C": [
    "AMY1C cnv",
    "AMY1C rna"
  ],
  "AMY2A": [
    "AMY2A cnv",
    "AMY2A rna"
  ],
  "AMY2B": [
    "AMY2B cnv",
    "AMY2B rna"
  ],
  "AMZ1": [
    "AMZ1 cnv",
    "AMZ1 methyl",
    "AMZ1 rna"
  ],
  "AMZ2": [
    "AMZ2 cnv",
    "AMZ2 methyl",
    "AMZ2 proteo",
    "AMZ2 rna"
  ],
  "AMZ2P1": [
    "AMZ2P1 methyl"
  ],
  "ANAPC1": [
    "ANAPC1 355_364_1_1_S355 phospho",
    "ANAPC1 cnv",
    "ANAPC1 methyl",
    "ANAPC1 proteo",
    "ANAPC1 rna"
  ],
  "ANAPC10": [
    "ANAPC10 cnv",
    "ANAPC10 methyl",
    "ANAPC10 proteo",
    "ANAPC10 rna"
  ],
  "ANAPC11": [
    "ANAPC11 cnv",
    "ANAPC11 methyl",
    "ANAPC11 rna"
  ],
  "ANAPC13": [
    "ANAPC13 cnv",
    "ANAPC13 methyl",
    "ANAPC13 rna"
  ],
  "ANAPC15": [
    "ANAPC15 cnv",
    "ANAPC15 methyl",
    "ANAPC15 rna"
  ],
  "ANAPC16": [
    "ANAPC16 cnv",
    "ANAPC16 proteo",
    "ANAPC16 rna"
  ],
  "ANAPC1P1": [
    "ANAPC1P1 methyl"
  ],
  "ANAPC1P2": [
    "ANAPC1P2 methyl"
  ],
  "ANAPC2": [
    "ANAPC2 532_534_1_1_S534 phospho",
    "ANAPC2 cnv",
    "ANAPC2 methyl",
    "ANAPC2 proteo",
    "ANAPC2 rna"
  ],
  "ANAPC4": [
    "ANAPC4 cnv",
    "ANAPC4 methyl",
    "ANAPC4 proteo",
    "ANAPC4 rna"
  ],
  "ANAPC5": [
    "ANAPC5 cnv",
    "ANAPC5 methyl",
    "ANAPC5 proteo",
    "ANAPC5 rna"
  ],
  "ANAPC7": [
    "ANAPC7 cnv",
    "ANAPC7 methyl",
    "ANAPC7 proteo",
    "ANAPC7 rna"
  ],
  "ANG": [
    "ANG cnv",
    "ANG methyl",
    "ANG proteo",
    "ANG rna"
  ],
  "ANGEL1": [
    "ANGEL1 cnv",
    "ANGEL1 methyl",
    "ANGEL1 rna"
  ],
  "ANGEL2": [
    "ANGEL2 cnv",
    "ANGEL2 methyl",
    "ANGEL2 proteo",
    "ANGEL2 rna"
  ],
  "ANGPT1": [
    "ANGPT1 cnv",
    "ANGPT1 rna"
  ],
  "ANGPT2": [
    "ANGPT2 IVTATVNNSVLQK-N4H5F1S0G0 glyco",
    "ANGPT2 KIVTATVNNSVLQK-N2H5F0S0G0 glyco",
    "ANGPT2 cnv",
    "ANGPT2 proteo",
    "ANGPT2 rna"
  ],
  "ANGPT4": [
    "ANGPT4 cnv",
    "ANGPT4 rna"
  ],
  "ANGPTL1": [
    "ANGPTL1 cnv",
    "ANGPTL1 rna"
  ],
  "ANGPTL2": [
    "ANGPTL2 ILNQTADMLQLASK-N2H8F0S0G0 glyco",
    "ANGPTL2 cnv",
    "ANGPTL2 proteo",
    "ANGPTL2 rna"
  ],
  "ANGPTL3": [
    "ANGPTL3 cnv",
    "ANGPTL3 rna"
  ],
  "ANGPTL4": [
    "ANGPTL4 cnv",
    "ANGPTL4 methyl",
    "ANGPTL4 proteo",
    "ANGPTL4 rna"
  ],
  "ANGPTL5": [
    "ANGPTL5 cnv",
    "ANGPTL5 rna"
  ],
  "ANGPTL6": [
    "ANGPTL6 cnv",
    "ANGPTL6 methyl",
    "ANGPTL6 rna"
  ],
  "ANGPTL7": [
    "ANGPTL7 cnv",
    "ANGPTL7 rna"
  ],
  "ANGPTL8": [
    "ANGPTL8 cnv",
    "ANGPTL8 rna"
  ],
  "ANHX": [
    "ANHX cnv"
  ],
  "ANK1": [
    "ANK1 1378_1380_1_1_T1378 phospho",
    "ANK1 1378_1380_1_1_T1380 phospho",
    "ANK1 1660_1674_1_1_S1666 phospho",
    "ANK1 1684_1693_1_1_S1686 phospho",
    "ANK1 1684_1693_2_2_S1686S1690 phospho",
    "ANK1 429_433_1_1_S429 phospho",
    "ANK1 594_604_1_1_S594 phospho",
    "ANK1 594_604_1_1_S597 phospho",
    "ANK1 759_769_1_1_S759 phospho",
    "ANK1 779_783_1_1_S781 phospho",
    "ANK1 834_834_1_1_S834 phospho",
    "ANK1 856_856_1_1_S856 phospho",
    "ANK1 960_973_1_1_T961 phospho",
    "ANK1 cnv",
    "ANK1 methyl",
    "ANK1 proteo",
    "ANK1 rna"
  ],
  "ANK2": [
    "ANK2 1452_1466_1_0 phospho",
    "ANK2 1452_1466_1_1_S1454 phospho",
    "ANK2 1459_1473_1_1_S1461 phospho",
    "ANK2 1732_1750_1_0 phospho",
    "ANK2 1732_1750_1_1_S1732 phospho",
    "ANK2 1732_1750_2_2_S1732S1733 phospho",
    "ANK2 1754_1765_1_1_S1755 phospho",
    "ANK2 1822_1824_1_1_S1822 phospho",
    "ANK2 1822_1824_2_2_S1822S1824 phospho",
    "ANK2 1846_1849_1_1_S1846 phospho",
    "ANK2 1855_1860_1_1_S1855 phospho",
    "ANK2 1855_1860_1_1_S1858 phospho",
    "ANK2 1855_1860_2_2_S1855S1858 phospho",
    "ANK2 1875_1885_1_1_S1879 phospho",
    "ANK2 1879_1885_1_1_S1879 phospho",
    "ANK2 1879_1885_1_1_S1882 phospho",
    "ANK2 1879_1885_2_2_S1879S1882 phospho",
    "ANK2 1905_1907_1_1_S1905 phospho",
    "ANK2 1929_1929_1_1_S1929 phospho",
    "ANK2 1964_1966_1_1_S1964 phospho",
    "ANK2 1976_1979_1_1_S1976 phospho",
    "ANK2 2127_2127_1_1_S2127 phospho",
    "ANK2 2239_2250_1_1_S2243 phospho",
    "ANK2 2312_2315_1_1_S2315 phospho",
    "ANK2 2312_2320_1_1_S2315 phospho",
    "ANK2 2391_2415_1_1_S2405 phospho",
    "ANK2 2405_2415_1_1_S2405 phospho",
    "ANK2 2451_2472_1_1_S2463 phospho",
    "ANK2 2516_2531_1_1_S2516 phospho",
    "ANK2 2534_2551_1_1_S2537 phospho",
    "ANK2 2534_2551_2_1_S2537 phospho",
    "ANK2 2554_2574_1_1_S2574 phospho",
    "ANK2 2574_2574_1_1_S2574 phospho",
    "ANK2 2583_2583_1_1_T2583 phospho",
    "ANK2 2640_2657_1_1_S2642 phospho",
    "ANK2 2693_2715_1_0 phospho",
    "ANK2 2693_2715_1_1_S2704 phospho",
    "ANK2 2781_2808_1_0 phospho",
    "ANK2 2781_2808_1_1_S2795 phospho",
    "ANK2 2834_2856_1_1_S2834 phospho",
    "ANK2 3087_3096_1_1_T3093 phospho",
    "ANK2 3264_3277_1_1_S3277 phospho",
    "ANK2 3407_3417_1_1_S3409 phospho",
    "ANK2 3764_3784_1_0 phospho",
    "ANK2 3792_3795_1_1_S3793 phospho",
    "ANK2 3792_3803_1_0 phospho",
    "ANK2 3792_3803_1_1_S3793 phospho",
    "ANK2 3792_3803_1_1_T3797 phospho",
    "ANK2 3792_3803_1_1_T3803 phospho",
    "ANK2 3792_3803_2_0 phospho",
    "ANK2 3792_3803_2_1_T3797 phospho",
    "ANK2 3792_3803_2_2_S3793T3797 phospho",
    "ANK2 3792_3803_2_2_S3793T3803 phospho",
    "ANK2 3792_3803_3_0 phospho",
    "ANK2 3797_3803_1_1_T3803 phospho",
    "ANK2 3811_3818_1_1_T3814 phospho",
    "ANK2 3823_3833_1_1_S3823 phospho",
    "ANK2 3823_3840_1_0 phospho",
    "ANK2 3823_3840_1_1_S3840 phospho",
    "ANK2 3823_3840_2_0 phospho",
    "ANK2 3844_3858_1_0 phospho",
    "ANK2 3844_3858_1_1_S3845 phospho",
    "ANK2 3907_3937_1_0 phospho",
    "ANK2 3907_3937_1_1_S3909 phospho",
    "ANK2 3947_3952_1_0 phospho",
    "ANK2 3947_3952_1_1_S3947 phospho",
    "ANK2 621_625_1_1_S621 phospho",
    "ANK2 691_692_1_1_S691 phospho",
    "ANK2 838_861_1_0 phospho",
    "ANK2 838_861_1_1_S846 phospho",
    "ANK2 907_915_1_1_S914 phospho",
    "ANK2 919_935_1_1_S934 phospho",
    "ANK2 cnv",
    "ANK2 proteo",
    "ANK2 rna"
  ],
  "ANK3": [
    "ANK3 1443_1445_1_1_S1445 phospho",
    "ANK3 1459_1462_1_1_S1459 phospho",
    "ANK3 1461_1473_1_1_S1462 phospho",
    "ANK3 1695_1702_1_1_S1702 phospho",
    "ANK3 1984_1994_1_1_S1984 phospho",
    "ANK3 2007_2011_1_1_S2009 phospho",
    "ANK3 2175_2211_1_1_S2193 phospho",
    "ANK3 2224_2235_1_1_S2225 phospho",
    "ANK3 2254_2264_1_1_S2256 phospho",
    "ANK3 2608_2608_1_1_S2608 phospho",
    "ANK3 2621_2630_1_0 phospho",
    "ANK3 2621_2630_2_2_S2625S2630 phospho",
    "ANK3 4332_4333_1_1_S4333 phospho",
    "ANK3 4332_4352_1_1_S4342 phospho",
    "ANK3 623_623_1_1_S623 phospho",
    "ANK3 cnv",
    "ANK3 methyl",
    "ANK3 proteo",
    "ANK3 rna"
  ],
  "ANKAR": [
    "ANKAR cnv",
    "ANKAR methyl",
    "ANKAR rna"
  ],
  "ANKDD1A": [
    "ANKDD1A cnv",
    "ANKDD1A methyl",
    "ANKDD1A rna"
  ],
  "ANKDD1B": [
    "ANKDD1B cnv",
    "ANKDD1B methyl",
    "ANKDD1B rna"
  ],
  "ANKEF1": [
    "ANKEF1 cnv",
    "ANKEF1 methyl",
    "ANKEF1 rna"
  ],
  "ANKFN1": [
    "ANKFN1 88_92_1_0 phospho",
    "ANKFN1 88_92_1_1_S92 phospho",
    "ANKFN1 cnv",
    "ANKFN1 rna"
  ],
  "ANKFY1": [
    "ANKFY1 903_903_1_1_S903 phospho",
    "ANKFY1 cnv",
    "ANKFY1 methyl",
    "ANKFY1 proteo",
    "ANKFY1 rna"
  ],
  "ANKH": [
    "ANKH cnv",
    "ANKH methyl",
    "ANKH rna"
  ],
  "ANKHD1": [
    "ANKHD1 cnv",
    "ANKHD1 methyl",
    "ANKHD1 rna"
  ],
  "ANKHD1-EIF4EBP3": [
    "ANKHD1-EIF4EBP3 cnv",
    "ANKHD1-EIF4EBP3 methyl",
    "ANKHD1-EIF4EBP3 rna"
  ],
  "ANKIB1": [
    "ANKIB1 284_304_1_1_S304 phospho",
    "ANKIB1 737_737_1_1_S737 phospho",
    "ANKIB1 cnv",
    "ANKIB1 methyl",
    "ANKIB1 proteo",
    "ANKIB1 rna"
  ],
  "ANKK1": [
    "ANKK1 cnv",
    "ANKK1 kinase",
    "ANKK1 methyl",
    "ANKK1 rna"
  ],
  "ANKLE1": [
    "ANKLE1 cnv",
    "ANKLE1 methyl",
    "ANKLE1 rna"
  ],
  "ANKLE2": [
    "ANKLE2 662_672_1_1_S662 phospho",
    "ANKLE2 cnv",
    "ANKLE2 methyl",
    "ANKLE2 proteo",
    "ANKLE2 rna"
  ],
  "ANKMY1": [
    "ANKMY1 cnv",
    "ANKMY1 methyl",
    "ANKMY1 rna"
  ],
  "ANKMY2": [
    "ANKMY2 cnv",
    "ANKMY2 methyl",
    "ANKMY2 proteo",
    "ANKMY2 rna"
  ],
  "ANKRA2": [
    "ANKRA2 cnv",
    "ANKRA2 methyl",
    "ANKRA2 rna"
  ],
  "ANKRD1": [
    "ANKRD1 cnv",
    "ANKRD1 rna"
  ],
  "ANKRD10": [
    "ANKRD10 cnv",
    "ANKRD10 methyl",
    "ANKRD10 proteo",
    "ANKRD10 rna"
  ],
  "ANKRD11": [
    "ANKRD11 2374_2374_1_1_S2374 phospho",
    "ANKRD11 808_817_1_1_S812 phospho",
    "ANKRD11 cnv",
    "ANKRD11 methyl",
    "ANKRD11 proteo",
    "ANKRD11 rna"
  ],
  "ANKRD12": [
    "ANKRD12 126_138_1_1_S126 phospho",
    "ANKRD12 cnv",
    "ANKRD12 methyl",
    "ANKRD12 rna"
  ],
  "ANKRD13A": [
    "ANKRD13A cnv",
    "ANKRD13A methyl",
    "ANKRD13A proteo",
    "ANKRD13A rna"
  ],
  "ANKRD13B": [
    "ANKRD13B cnv",
    "ANKRD13B methyl",
    "ANKRD13B rna"
  ],
  "ANKRD13C": [
    "ANKRD13C cnv",
    "ANKRD13C methyl",
    "ANKRD13C rna"
  ],
  "ANKRD13D": [
    "ANKRD13D 465_477_1_1_S465 phospho",
    "ANKRD13D cnv",
    "ANKRD13D methyl",
    "ANKRD13D proteo",
    "ANKRD13D rna"
  ],
  "ANKRD16": [
    "ANKRD16 cnv",
    "ANKRD16 methyl",
    "ANKRD16 proteo",
    "ANKRD16 rna"
  ],
  "ANKRD17": [
    "ANKRD17 1692_1699_1_0 phospho",
    "ANKRD17 2037_2055_1_1_S2046 phospho",
    "ANKRD17 2058_2066_1_1_S2058 phospho",
    "ANKRD17 2058_2066_1_1_S2066 phospho",
    "ANKRD17 2400_2410_1_1_S2400 phospho",
    "ANKRD17 2400_2417_1_1_S2400 phospho",
    "ANKRD17 5_43_1_1_S19 phospho",
    "ANKRD17 cnv",
    "ANKRD17 methyl",
    "ANKRD17 proteo",
    "ANKRD17 rna"
  ],
  "ANKRD18A": [
    "ANKRD18A cnv",
    "ANKRD18A methyl",
    "ANKRD18A rna"
  ],
  "ANKRD18B": [
    "ANKRD18B cnv",
    "ANKRD18B methyl",
    "ANKRD18B rna"
  ],
  "ANKRD18DP": [
    "ANKRD18DP methyl"
  ],
  "ANKRD2": [
    "ANKRD2 cnv",
    "ANKRD2 rna"
  ],
  "ANKRD20A1": [
    "ANKRD20A1 cnv",
    "ANKRD20A1 methyl",
    "ANKRD20A1 rna"
  ],
  "ANKRD20A2P": [
    "ANKRD20A2P cnv",
    "ANKRD20A2P rna"
  ],
  "ANKRD20A3P": [
    "ANKRD20A3P cnv",
    "ANKRD20A3P rna"
  ],
  "ANKRD20A4P": [
    "ANKRD20A4P cnv",
    "ANKRD20A4P rna"
  ],
  "ANKRD22": [
    "ANKRD22 cnv",
    "ANKRD22 rna"
  ],
  "ANKRD23": [
    "ANKRD23 cnv",
    "ANKRD23 methyl",
    "ANKRD23 rna"
  ],
  "ANKRD24": [
    "ANKRD24 354_359_1_1_S354 phospho",
    "ANKRD24 cnv",
    "ANKRD24 methyl",
    "ANKRD24 proteo",
    "ANKRD24 rna"
  ],
  "ANKRD26": [
    "ANKRD26 627_630_1_1_S630 phospho",
    "ANKRD26 cnv",
    "ANKRD26 methyl",
    "ANKRD26 rna"
  ],
  "ANKRD26P3": [
    "ANKRD26P3 methyl"
  ],
  "ANKRD27": [
    "ANKRD27 cnv",
    "ANKRD27 methyl",
    "ANKRD27 proteo",
    "ANKRD27 rna"
  ],
  "ANKRD28": [
    "ANKRD28 cnv",
    "ANKRD28 methyl",
    "ANKRD28 proteo",
    "ANKRD28 rna"
  ],
  "ANKRD29": [
    "ANKRD29 cnv",
    "ANKRD29 methyl",
    "ANKRD29 proteo",
    "ANKRD29 rna"
  ],
  "ANKRD30A": [
    "ANKRD30A cnv",
    "ANKRD30A methyl",
    "ANKRD30A rna"
  ],
  "ANKRD30B": [
    "ANKRD30B cnv",
    "ANKRD30B methyl",
    "ANKRD30B rna"
  ],
  "ANKRD30BL": [
    "ANKRD30BL cnv",
    "ANKRD30BL methyl",
    "ANKRD30BL rna"
  ],
  "ANKRD31": [
    "ANKRD31 cnv",
    "ANKRD31 methyl",
    "ANKRD31 rna"
  ],
  "ANKRD33": [
    "ANKRD33 cnv",
    "ANKRD33 rna"
  ],
  "ANKRD33B": [
    "ANKRD33B cnv",
    "ANKRD33B methyl",
    "ANKRD33B rna"
  ],
  "ANKRD34A": [
    "ANKRD34A 247_262_1_1_S247 phospho",
    "ANKRD34A 291_292_1_0 phospho",
    "ANKRD34A 316_327_1_1_T316 phospho",
    "ANKRD34A 383_395_1_1_S392 phospho",
    "ANKRD34A 449_461_1_1_S461 phospho",
    "ANKRD34A cnv",
    "ANKRD34A methyl",
    "ANKRD34A rna"
  ],
  "ANKRD34B": [
    "ANKRD34B cnv",
    "ANKRD34B methyl",
    "ANKRD34B rna"
  ],
  "ANKRD34C": [
    "ANKRD34C cnv",
    "ANKRD34C methyl",
    "ANKRD34C rna"
  ],
  "ANKRD35": [
    "ANKRD35 670_680_1_1_S672 phospho",
    "ANKRD35 cnv",
    "ANKRD35 methyl",
    "ANKRD35 proteo",
    "ANKRD35 rna"
  ],
  "ANKRD36": [
    "ANKRD36 cnv",
    "ANKRD36 methyl",
    "ANKRD36 rna"
  ],
  "ANKRD36B": [
    "ANKRD36B cnv",
    "ANKRD36B methyl",
    "ANKRD36B rna"
  ],
  "ANKRD36BP2": [
    "ANKRD36BP2 methyl"
  ],
  "ANKRD36C": [
    "ANKRD36C cnv",
    "ANKRD36C methyl",
    "ANKRD36C rna"
  ],
  "ANKRD37": [
    "ANKRD37 cnv",
    "ANKRD37 methyl",
    "ANKRD37 rna"
  ],
  "ANKRD39": [
    "ANKRD39 cnv",
    "ANKRD39 methyl",
    "ANKRD39 proteo",
    "ANKRD39 rna"
  ],
  "ANKRD40": [
    "ANKRD40 cnv",
    "ANKRD40 methyl",
    "ANKRD40 proteo",
    "ANKRD40 rna"
  ],
  "ANKRD40CL": [
    "ANKRD40CL cnv",
    "ANKRD40CL rna"
  ],
  "ANKRD42": [
    "ANKRD42 cnv",
    "ANKRD42 methyl",
    "ANKRD42 rna"
  ],
  "ANKRD44": [
    "ANKRD44 cnv",
    "ANKRD44 methyl",
    "ANKRD44 proteo",
    "ANKRD44 rna"
  ],
  "ANKRD45": [
    "ANKRD45 cnv",
    "ANKRD45 methyl",
    "ANKRD45 proteo",
    "ANKRD45 rna"
  ],
  "ANKRD46": [
    "ANKRD46 cnv",
    "ANKRD46 methyl",
    "ANKRD46 proteo",
    "ANKRD46 rna"
  ],
  "ANKRD49": [
    "ANKRD49 cnv",
    "ANKRD49 methyl",
    "ANKRD49 rna"
  ],
  "ANKRD50": [
    "ANKRD50 921_947_1_1_S932 phospho",
    "ANKRD50 cnv",
    "ANKRD50 methyl",
    "ANKRD50 proteo",
    "ANKRD50 rna"
  ],
  "ANKRD52": [
    "ANKRD52 cnv",
    "ANKRD52 methyl",
    "ANKRD52 proteo",
    "ANKRD52 rna"
  ],
  "ANKRD53": [
    "ANKRD53 cnv",
    "ANKRD53 methyl",
    "ANKRD53 rna"
  ],
  "ANKRD54": [
    "ANKRD54 cnv",
    "ANKRD54 methyl",
    "ANKRD54 proteo",
    "ANKRD54 rna"
  ],
  "ANKRD55": [
    "ANKRD55 cnv",
    "ANKRD55 rna"
  ],
  "ANKRD6": [
    "ANKRD6 cnv",
    "ANKRD6 methyl",
    "ANKRD6 rna"
  ],
  "ANKRD60": [
    "ANKRD60 cnv",
    "ANKRD60 methyl",
    "ANKRD60 rna"
  ],
  "ANKRD61": [
    "ANKRD61 cnv",
    "ANKRD61 rna"
  ],
  "ANKRD62": [
    "ANKRD62 cnv",
    "ANKRD62 methyl",
    "ANKRD62 rna"
  ],
  "ANKRD62P1-PARP4P3": [
    "ANKRD62P1-PARP4P3 cnv",
    "ANKRD62P1-PARP4P3 rna"
  ],
  "ANKRD63": [
    "ANKRD63 cnv",
    "ANKRD63 methyl",
    "ANKRD63 rna"
  ],
  "ANKRD65": [
    "ANKRD65 cnv",
    "ANKRD65 proteo",
    "ANKRD65 rna"
  ],
  "ANKRD66": [
    "ANKRD66 cnv",
    "ANKRD66 rna"
  ],
  "ANKRD7": [
    "ANKRD7 cnv",
    "ANKRD7 methyl",
    "ANKRD7 rna"
  ],
  "ANKRD9": [
    "ANKRD9 cnv",
    "ANKRD9 methyl",
    "ANKRD9 rna"
  ],
  "ANKS1A": [
    "ANKS1A 318_333_1_1_T318 phospho",
    "ANKS1A 622_643_1_0 phospho",
    "ANKS1A 622_643_1_1_S624 phospho",
    "ANKS1A 622_643_1_1_S626 phospho",
    "ANKS1A 645_652_1_1_S647 phospho",
    "ANKS1A 661_666_1_1_S663 phospho",
    "ANKS1A 887_895_1_1_S887 phospho",
    "ANKS1A cnv",
    "ANKS1A methyl",
    "ANKS1A proteo",
    "ANKS1A rna"
  ],
  "ANKS1B": [
    "ANKS1B 1248_1254_1_1_S1248 phospho",
    "ANKS1B 291_316_1_1_S310 phospho",
    "ANKS1B 640_657_1_1_S651 phospho",
    "ANKS1B 734_747_1_1_S738 phospho",
    "ANKS1B 958_987_1_1_T969 phospho",
    "ANKS1B cnv",
    "ANKS1B methyl",
    "ANKS1B proteo",
    "ANKS1B rna"
  ],
  "ANKS3": [
    "ANKS3 cnv",
    "ANKS3 methyl",
    "ANKS3 rna"
  ],
  "ANKS4B": [
    "ANKS4B cnv",
    "ANKS4B rna"
  ],
  "ANKS6": [
    "ANKS6 732_742_1_0 phospho",
    "ANKS6 cnv",
    "ANKS6 methyl",
    "ANKS6 proteo",
    "ANKS6 rna"
  ],
  "ANKUB1": [
    "ANKUB1 cnv",
    "ANKUB1 rna"
  ],
  "ANKZF1": [
    "ANKZF1 361_364_1_1_S361 phospho",
    "ANKZF1 607_607_1_1_T607 phospho",
    "ANKZF1 674_685_1_1_S675 phospho",
    "ANKZF1 cnv",
    "ANKZF1 methyl",
    "ANKZF1 proteo",
    "ANKZF1 rna"
  ],
  "ANLN": [
    "ANLN 225_236_1_1_S225 phospho",
    "ANLN 602_605_1_1_S605 phospho",
    "ANLN 621_639_1_1_S621 phospho",
    "ANLN 755_763_1_0 phospho",
    "ANLN 755_763_1_1_S755 phospho",
    "ANLN cnv",
    "ANLN methyl",
    "ANLN proteo",
    "ANLN rna"
  ],
  "ANO1": [
    "ANO1 cnv",
    "ANO1 methyl",
    "ANO1 proteo",
    "ANO1 rna"
  ],
  "ANO10": [
    "ANO10 cnv",
    "ANO10 methyl",
    "ANO10 proteo",
    "ANO10 rna"
  ],
  "ANO2": [
    "ANO2 cnv",
    "ANO2 methyl",
    "ANO2 rna"
  ],
  "ANO3": [
    "ANO3 36_47_1_1_S36 phospho",
    "ANO3 cnv",
    "ANO3 methyl",
    "ANO3 rna"
  ],
  "ANO4": [
    "ANO4 cnv",
    "ANO4 methyl",
    "ANO4 rna"
  ],
  "ANO5": [
    "ANO5 cnv",
    "ANO5 methyl",
    "ANO5 rna"
  ],
  "ANO6": [
    "ANO6 256_260_1_1_S256 phospho",
    "ANO6 LNITCESSK-N2H6F0S0G0 glyco",
    "ANO6 LNITCESSK-N2H7F0S0G0 glyco",
    "ANO6 LNITCESSK-N2H8F0S0G0 glyco",
    "ANO6 cnv",
    "ANO6 methyl",
    "ANO6 proteo",
    "ANO6 rna"
  ],
  "ANO7": [
    "ANO7 cnv",
    "ANO7 rna"
  ],
  "ANO8": [
    "ANO8 cnv",
    "ANO8 methyl",
    "ANO8 proteo",
    "ANO8 rna"
  ],
  "ANO9": [
    "ANO9 cnv",
    "ANO9 methyl",
    "ANO9 rna"
  ],
  "ANOS1": [
    "ANOS1 methyl",
    "ANOS1 proteo",
    "ANOS1 rna"
  ],
  "ANP32A": [
    "ANP32A cnv",
    "ANP32A methyl",
    "ANP32A proteo",
    "ANP32A rna"
  ],
  "ANP32B": [
    "ANP32B 15_15_1_1_T15 phospho",
    "ANP32B 244_244_1_1_T244 phospho",
    "ANP32B cnv",
    "ANP32B methyl",
    "ANP32B proteo",
    "ANP32B rna"
  ],
  "ANP32D": [
    "ANP32D cnv",
    "ANP32D rna"
  ],
  "ANP32E": [
    "ANP32E cnv",
    "ANP32E methyl",
    "ANP32E proteo",
    "ANP32E rna"
  ],
  "ANPEP": [
    "ANPEP AEFNITLIHPK-N2H5F0S0G0 glyco",
    "ANPEP KLNYTLSQGHR-N3H6F0S0G0 glyco",
    "ANPEP KLNYTLSQGHR-N4H5F0S0G0 glyco",
    "ANPEP cnv",
    "ANPEP methyl",
    "ANPEP proteo",
    "ANPEP rna"
  ],
  "ANTKMT": [
    "ANTKMT cnv",
    "ANTKMT methyl",
    "ANTKMT rna"
  ],
  "ANTXR1": [
    "ANTXR1 362_362_1_1_S362 phospho",
    "ANTXR1 cnv",
    "ANTXR1 methyl",
    "ANTXR1 proteo",
    "ANTXR1 rna"
  ],
  "ANTXR2": [
    "ANTXR2 cnv",
    "ANTXR2 methyl",
    "ANTXR2 rna"
  ],
  "ANTXRL": [
    "ANTXRL cnv",
    "ANTXRL rna"
  ],
  "ANXA1": [
    "ANXA1 101_101_1_1_T101 phospho",
    "ANXA1 34_46_1_1_S34 phospho",
    "ANXA1 34_46_1_1_S37 phospho",
    "ANXA1 cnv",
    "ANXA1 proteo",
    "ANXA1 rna"
  ],
  "ANXA10": [
    "ANXA10 cnv",
    "ANXA10 rna"
  ],
  "ANXA11": [
    "ANXA11 cnv",
    "ANXA11 methyl",
    "ANXA11 proteo",
    "ANXA11 rna"
  ],
  "ANXA13": [
    "ANXA13 cnv",
    "ANXA13 rna"
  ],
  "ANXA2": [
    "ANXA2 12_26_1_1_S26 phospho",
    "ANXA2 12_26_1_1_T19 phospho",
    "ANXA2 184_188_1_1_S184 phospho",
    "ANXA2 314_323_1_1_Y318 phospho",
    "ANXA2 cnv",
    "ANXA2 methyl",
    "ANXA2 proteo",
    "ANXA2 rna"
  ],
  "ANXA2R": [
    "ANXA2R cnv",
    "ANXA2R methyl",
    "ANXA2R rna"
  ],
  "ANXA2R-AS1": [
    "ANXA2R-AS1 methyl"
  ],
  "ANXA2R-OT1": [
    "ANXA2R-OT1 methyl"
  ],
  "ANXA3": [
    "ANXA3 cnv",
    "ANXA3 methyl",
    "ANXA3 proteo",
    "ANXA3 rna"
  ],
  "ANXA4": [
    "ANXA4 cnv",
    "ANXA4 methyl",
    "ANXA4 proteo",
    "ANXA4 rna"
  ],
  "ANXA5": [
    "ANXA5 111_118_1_1_T118 phospho",
    "ANXA5 129_149_1_0 phospho",
    "ANXA5 cnv",
    "ANXA5 methyl",
    "ANXA5 proteo",
    "ANXA5 rna"
  ],
  "ANXA6": [
    "ANXA6 10_31_1_1_Y10 phospho",
    "ANXA6 cnv",
    "ANXA6 proteo",
    "ANXA6 rna"
  ],
  "ANXA7": [
    "ANXA7 cnv",
    "ANXA7 methyl",
    "ANXA7 proteo",
    "ANXA7 rna"
  ],
  "ANXA8": [
    "ANXA8 cnv",
    "ANXA8 rna"
  ],
  "ANXA8L1": [
    "ANXA8L1 cnv",
    "ANXA8L1 rna"
  ],
  "ANXA9": [
    "ANXA9 cnv",
    "ANXA9 rna"
  ],
  "AOAH": [
    "AOAH cnv",
    "AOAH rna"
  ],
  "AOC1": [
    "AOC1 cnv",
    "AOC1 methyl",
    "AOC1 rna"
  ],
  "AOC2": [
    "AOC2 cnv",
    "AOC2 rna"
  ],
  "AOC3": [
    "AOC3 cnv",
    "AOC3 proteo",
    "AOC3 rna"
  ],
  "AOPEP": [
    "AOPEP cnv",
    "AOPEP methyl",
    "AOPEP rna"
  ],
  "AOX1": [
    "AOX1 cnv",
    "AOX1 methyl",
    "AOX1 rna"
  ],
  "AOX3P-AOX2P": [
    "AOX3P-AOX2P cnv",
    "AOX3P-AOX2P rna"
  ],
  "AP1AR": [
    "AP1AR cnv",
    "AP1AR methyl",
    "AP1AR rna"
  ],
  "AP1B1": [
    "AP1B1 cnv",
    "AP1B1 methyl",
    "AP1B1 proteo",
    "AP1B1 rna"
  ],
  "AP1G1": [
    "AP1G1 760_782_1_0 phospho",
    "AP1G1 cnv",
    "AP1G1 methyl",
    "AP1G1 proteo",
    "AP1G1 rna"
  ],
  "AP1G2": [
    "AP1G2 cnv",
    "AP1G2 methyl",
    "AP1G2 proteo",
    "AP1G2 rna"
  ],
  "AP1M1": [
    "AP1M1 cnv",
    "AP1M1 methyl",
    "AP1M1 proteo",
    "AP1M1 rna"
  ],
  "AP1M2": [
    "AP1M2 cnv",
    "AP1M2 methyl",
    "AP1M2 rna"
  ],
  "AP1S1": [
    "AP1S1 cnv",
    "AP1S1 methyl",
    "AP1S1 proteo",
    "AP1S1 rna"
  ],
  "AP1S2": [
    "AP1S2 methyl",
    "AP1S2 proteo",
    "AP1S2 rna"
  ],
  "AP1S3": [
    "AP1S3 cnv",
    "AP1S3 methyl",
    "AP1S3 rna"
  ],
  "AP2A1": [
    "AP2A1 517_528_1_1_S518 phospho",
    "AP2A1 626_657_1_1_S655 phospho",
    "AP2A1 636_657_1_1_S655 phospho",
    "AP2A1 784_809_1_1_S792 phospho",
    "AP2A1 cnv",
    "AP2A1 methyl",
    "AP2A1 proteo",
    "AP2A1 rna"
  ],
  "AP2A2": [
    "AP2A2 cnv",
    "AP2A2 methyl",
    "AP2A2 proteo",
    "AP2A2 rna"
  ],
  "AP2B1": [
    "AP2B1 cnv",
    "AP2B1 proteo",
    "AP2B1 rna"
  ],
  "AP2M1": [
    "AP2M1 149_156_1_1_T156 phospho",
    "AP2M1 45_48_1_1_S45 phospho",
    "AP2M1 cnv",
    "AP2M1 methyl",
    "AP2M1 proteo",
    "AP2M1 rna"
  ],
  "AP2S1": [
    "AP2S1 cnv",
    "AP2S1 methyl",
    "AP2S1 proteo",
    "AP2S1 rna"
  ],
  "AP3B1": [
    "AP3B1 225_227_1_1_S227 phospho",
    "AP3B1 cnv",
    "AP3B1 methyl",
    "AP3B1 proteo",
    "AP3B1 rna"
  ],
  "AP3B2": [
    "AP3B2 238_240_1_1_S240 phospho",
    "AP3B2 701_706_1_1_S701 phospho",
    "AP3B2 701_706_2_2_S701S706 phospho",
    "AP3B2 701_706_3_3_S701S703S706 phospho",
    "AP3B2 878_878_1_1_T878 phospho",
    "AP3B2 cnv",
    "AP3B2 methyl",
    "AP3B2 proteo",
    "AP3B2 rna"
  ],
  "AP3D1": [
    "AP3D1 632_636_1_1_S632 phospho",
    "AP3D1 824_829_1_1_S829 phospho",
    "AP3D1 876_903_1_0 phospho",
    "AP3D1 cnv",
    "AP3D1 methyl",
    "AP3D1 proteo",
    "AP3D1 rna"
  ],
  "AP3M1": [
    "AP3M1 cnv",
    "AP3M1 methyl",
    "AP3M1 proteo",
    "AP3M1 rna"
  ],
  "AP3M2": [
    "AP3M2 cnv",
    "AP3M2 methyl",
    "AP3M2 proteo",
    "AP3M2 rna"
  ],
  "AP3S1": [
    "AP3S1 cnv",
    "AP3S1 methyl",
    "AP3S1 proteo",
    "AP3S1 rna"
  ],
  "AP3S2": [
    "AP3S2 cnv",
    "AP3S2 methyl",
    "AP3S2 proteo",
    "AP3S2 rna"
  ],
  "AP4B1": [
    "AP4B1 cnv",
    "AP4B1 methyl",
    "AP4B1 proteo",
    "AP4B1 rna"
  ],
  "AP4B1-AS1": [
    "AP4B1-AS1 methyl"
  ],
  "AP4E1": [
    "AP4E1 cnv",
    "AP4E1 methyl",
    "AP4E1 proteo",
    "AP4E1 rna"
  ],
  "AP4M1": [
    "AP4M1 cnv",
    "AP4M1 methyl",
    "AP4M1 proteo",
    "AP4M1 rna"
  ],
  "AP4S1": [
    "AP4S1 cnv",
    "AP4S1 methyl",
    "AP4S1 proteo",
    "AP4S1 rna"
  ],
  "AP5B1": [
    "AP5B1 cnv",
    "AP5B1 methyl",
    "AP5B1 proteo",
    "AP5B1 rna"
  ],
  "AP5M1": [
    "AP5M1 cnv",
    "AP5M1 methyl",
    "AP5M1 proteo",
    "AP5M1 rna"
  ],
  "AP5S1": [
    "AP5S1 cnv",
    "AP5S1 methyl",
    "AP5S1 proteo",
    "AP5S1 rna"
  ],
  "AP5Z1": [
    "AP5Z1 cnv",
    "AP5Z1 methyl",
    "AP5Z1 proteo",
    "AP5Z1 rna"
  ],
  "APAF1": [
    "APAF1 cnv",
    "APAF1 methyl",
    "APAF1 proteo",
    "APAF1 rna"
  ],
  "APBA1": [
    "APBA1 238_248_1_1_S242 phospho",
    "APBA1 238_248_2_2_S242S246 phospho",
    "APBA1 242_248_1_1_S242 phospho",
    "APBA1 263_264_1_0 phospho",
    "APBA1 280_285_1_1_S285 phospho",
    "APBA1 305_313_2_2_T305S313 phospho",
    "APBA1 367_370_1_1_T370 phospho",
    "APBA1 566_578_1_1_S568 phospho",
    "APBA1 cnv",
    "APBA1 methyl",
    "APBA1 proteo",
    "APBA1 rna"
  ],
  "APBA2": [
    "APBA2 466_475_1_1_S468 phospho",
    "APBA2 cnv",
    "APBA2 proteo",
    "APBA2 rna"
  ],
  "APBA3": [
    "APBA3 cnv",
    "APBA3 methyl",
    "APBA3 proteo",
    "APBA3 rna"
  ],
  "APBB1": [
    "APBB1 cnv",
    "APBB1 methyl",
    "APBB1 proteo",
    "APBB1 rna"
  ],
  "APBB1IP": [
    "APBB1IP 525_534_1_0 phospho",
    "APBB1IP 525_534_1_1_S526 phospho",
    "APBB1IP cnv",
    "APBB1IP methyl",
    "APBB1IP proteo",
    "APBB1IP rna"
  ],
  "APBB2": [
    "APBB2 334_359_1_1_S334 phospho",
    "APBB2 cnv",
    "APBB2 methyl",
    "APBB2 proteo",
    "APBB2 rna"
  ],
  "APBB3": [
    "APBB3 cnv",
    "APBB3 methyl",
    "APBB3 rna"
  ],
  "APC": [
    "APC 1031_1044_1_1_S1042 phospho",
    "APC 1031_1044_2_2_S1038S1042 phospho",
    "APC 107_117_1_1_S111 phospho",
    "APC 1100_1102_1_1_S1100 phospho",
    "APC 1364_1385_1_1_S1371 phospho",
    "APC 1388_1398_1_1_S1389 phospho",
    "APC 1436_1448_1_1_T1438 phospho",
    "APC 1773_1785_1_1_S1774 phospho",
    "APC 2011_2022_1_1_S2022 phospho",
    "APC 2088_2096_1_1_S2093 phospho",
    "APC 2088_2096_2_2_S2088S2093 phospho",
    "APC 2129_2137_1_1_S2129 phospho",
    "APC 2239_2247_1_1_S2244 phospho",
    "APC 2260_2270_1_1_S2270 phospho",
    "APC 2289_2296_1_1_S2290 phospho",
    "APC 2567_2581_1_0 phospho",
    "APC 2724_2724_1_1_S2724 phospho",
    "APC 2793_2813_1_0 phospho",
    "APC 2820_2830_1_1_S2830 phospho",
    "APC 2835_2842_1_1_S2835 phospho",
    "APC 744_751_1_1_S744 phospho",
    "APC 925_938_1_0 phospho",
    "APC 959_973_1_0 phospho",
    "APC cnv",
    "APC methyl",
    "APC proteo",
    "APC rna"
  ],
  "APC2": [
    "APC2 1841_1841_1_1_S1841 phospho",
    "APC2 2008_2024_1_1_S2008 phospho",
    "APC2 706_718_1_1_S709 phospho",
    "APC2 cnv",
    "APC2 methyl",
    "APC2 proteo",
    "APC2 rna"
  ],
  "APCDD1": [
    "APCDD1 cnv",
    "APCDD1 methyl",
    "APCDD1 proteo",
    "APCDD1 rna"
  ],
  "APCDD1L": [
    "APCDD1L cnv",
    "APCDD1L methyl",
    "APCDD1L rna"
  ],
  "APCDD1L-DT": [
    "APCDD1L-DT methyl"
  ],
  "APCS": [
    "APCS cnv",
    "APCS proteo"
  ],
  "APEH": [
    "APEH cnv",
    "APEH methyl",
    "APEH proteo",
    "APEH rna"
  ],
  "APELA": [
    "APELA cnv",
    "APELA rna"
  ],
  "APEX1": [
    "APEX1 cnv",
    "APEX1 methyl",
    "APEX1 proteo",
    "APEX1 rna"
  ],
  "APEX2": [
    "APEX2 methyl",
    "APEX2 rna"
  ],
  "APH1A": [
    "APH1A cnv",
    "APH1A methyl",
    "APH1A proteo",
    "APH1A rna"
  ],
  "APH1B": [
    "APH1B cnv",
    "APH1B methyl",
    "APH1B rna"
  ],
  "API5": [
    "API5 457_464_1_1_S464 phospho",
    "API5 cnv",
    "API5 methyl",
    "API5 proteo",
    "API5 rna"
  ],
  "APIP": [
    "APIP 84_89_1_1_S87 phospho",
    "APIP cnv",
    "APIP methyl",
    "APIP proteo",
    "APIP rna"
  ],
  "APLF": [
    "APLF cnv",
    "APLF methyl",
    "APLF rna"
  ],
  "APLN": [
    "APLN methyl",
    "APLN rna"
  ],
  "APLNR": [
    "APLNR 343_351_1_0 phospho",
    "APLNR 343_351_1_1_S345 phospho",
    "APLNR 343_351_2_0 phospho",
    "APLNR cnv",
    "APLNR proteo",
    "APLNR rna"
  ],
  "APLP1": [
    "APLP1 cnv",
    "APLP1 methyl",
    "APLP1 proteo",
    "APLP1 rna"
  ],
  "APLP2": [
    "APLP2 RNQSLSLLYK-N2H7F0S0G0 glyco",
    "APLP2 RNQSLSLLYK-N2H8F0S0G0 glyco",
    "APLP2 cnv",
    "APLP2 methyl",
    "APLP2 proteo",
    "APLP2 rna"
  ],
  "APMAP": [
    "APMAP 19_19_1_1_T19 phospho",
    "APMAP AGPNGTLFVADAYK-N2H3F0S0G0 glyco",
    "APMAP AGPNGTLFVADAYK-N2H3F1S0G0 glyco",
    "APMAP AGPNGTLFVADAYK-N2H4F0S0G0 glyco",
    "APMAP AGPNGTLFVADAYK-N2H4F1S0G0 glyco",
    "APMAP AGPNGTLFVADAYK-N2H5F0S0G0 glyco",
    "APMAP AGPNGTLFVADAYK-N2H5F1S0G0 glyco",
    "APMAP AGPNGTLFVADAYK-N2H6F0S0G0 glyco",
    "APMAP AGPNGTLFVADAYK-N2H7F0S0G0 glyco",
    "APMAP AGPNGTLFVADAYK-N2H8F0S0G0 glyco",
    "APMAP AGPNGTLFVADAYK-N3H3F1S0G0 glyco",
    "APMAP AGPNGTLFVADAYK-N4H3F1S0G0 glyco",
    "APMAP AGPNGTLFVADAYK-N4H5F0S2G0 glyco",
    "APMAP NMSFVNDLTVTQDGR-N2H5F0S0G0 glyco",
    "APMAP NMSFVNDLTVTQDGR-N2H6F0S0G0 glyco",
    "APMAP NMSFVNDLTVTQDGR-N2H7F0S0G0 glyco",
    "APMAP NMSFVNDLTVTQDGR-N2H8F0S0G0 glyco",
    "APMAP NMSFVNDLTVTQDGRK-N2H5F0S0G0 glyco",
    "APMAP NMSFVNDLTVTQDGRK-N2H6F0S0G0 glyco",
    "APMAP NMSFVNDLTVTQDGRK-N2H7F0S0G0 glyco",
    "APMAP NMSFVNDLTVTQDGRK-N2H8F0S0G0 glyco",
    "APMAP cnv",
    "APMAP methyl",
    "APMAP proteo",
    "APMAP rna"
  ],
  "APOA1": [
    "APOA1 cnv",
    "APOA1 proteo",
    "APOA1 rna"
  ],
  "APOA1-AS": [
    "APOA1-AS methyl"
  ],
  "APOA2": [
    "APOA2 54_54_1_1_S54 phospho",
    "APOA2 68_73_1_1_S68 phospho",
    "APOA2 cnv",
    "APOA2 proteo",
    "APOA2 rna"
  ],
  "APOA4": [
    "APOA4 cnv",
    "APOA4 proteo",
    "APOA4 rna"
  ],
  "APOA5": [
    "APOA5 cnv",
    "APOA5 rna"
  ],
  "APOB": [
    "APOB 4048_4052_1_0 phospho",
    "APOB FEVDSPVYNATWSASLK-N4H5F0S1G0 glyco",
    "APOB FEVDSPVYNATWSASLK-N4H5F0S2G0 glyco",
    "APOB FNSSYLQGTNQITGR-N4H5F0S1G0 glyco",
    "APOB FVEGSHNSTVSLTTK-N3H5F0S0G0 glyco",
    "APOB FVEGSHNSTVSLTTK-N3H5F0S1G0 glyco",
    "APOB FVEGSHNSTVSLTTK-N3H6F0S1G0 glyco",
    "APOB FVEGSHNSTVSLTTK-N4H5F0S1G0 glyco",
    "APOB FVEGSHNSTVSLTTK-N6H3F3S0G0 glyco",
    "APOB QVFPGLNYCTSGAYSNASSTDSASYYPLTGDTR-N4H5F0S1G0 glyco",
    "APOB QVLFLDTVYGNCSTHFTVK-N2H5F0S0G0 glyco",
    "APOB QVLFLDTVYGNCSTHFTVK-N2H6F0S0G0 glyco",
    "APOB QVLFLDTVYGNCSTHFTVK-N2H7F0S0G0 glyco",
    "APOB VNQNLVYESGSLNFSK-N4H5F0S1G0 glyco",
    "APOB VNQNLVYESGSLNFSK-N4H5F0S2G0 glyco",
    "APOB YDFNSSMLYSTAK-N3H4F0S1G0 glyco",
    "APOB YDFNSSMLYSTAK-N4H5F0S1G0 glyco",
    "APOB YDFNSSMLYSTAK-N4H5F0S2G0 glyco",
    "APOB cnv",
    "APOB methyl",
    "APOB proteo",
    "APOB rna"
  ],
  "APOBEC1": [
    "APOBEC1 cnv"
  ],
  "APOBEC2": [
    "APOBEC2 cnv",
    "APOBEC2 rna"
  ],
  "APOBEC3A": [
    "APOBEC3A cnv",
    "APOBEC3A rna"
  ],
  "APOBEC3B": [
    "APOBEC3B cnv",
    "APOBEC3B rna"
  ],
  "APOBEC3C": [
    "APOBEC3C cnv",
    "APOBEC3C proteo",
    "APOBEC3C rna"
  ],
  "APOBEC3D": [
    "APOBEC3D cnv",
    "APOBEC3D rna"
  ],
  "APOBEC3F": [
    "APOBEC3F cnv",
    "APOBEC3F rna"
  ],
  "APOBEC3G": [
    "APOBEC3G cnv",
    "APOBEC3G proteo",
    "APOBEC3G rna"
  ],
  "APOBEC3H": [
    "APOBEC3H cnv",
    "APOBEC3H rna"
  ],
  "APOBEC4": [
    "APOBEC4 cnv",
    "APOBEC4 rna"
  ],
  "APOBR": [
    "APOBR 175_175_1_1_S175 phospho",
    "APOBR 572_574_1_1_T572 phospho",
    "APOBR cnv",
    "APOBR proteo",
    "APOBR rna"
  ],
  "APOC1": [
    "APOC1 cnv",
    "APOC1 proteo",
    "APOC1 rna"
  ],
  "APOC2": [
    "APOC2 cnv",
    "APOC2 proteo",
    "APOC2 rna"
  ],
  "APOC3": [
    "APOC3 cnv",
    "APOC3 proteo"
  ],
  "APOC4": [
    "APOC4 cnv",
    "APOC4 proteo",
    "APOC4 rna"
  ],
  "APOC4-APOC2": [
    "APOC4-APOC2 cnv",
    "APOC4-APOC2 rna"
  ],
  "APOD": [
    "APOD ADGTVNQIEGEATPVNLTEPAK-N2H3F0S0G0 glyco",
    "APOD ADGTVNQIEGEATPVNLTEPAK-N2H3F1S0G0 glyco",
    "APOD ADGTVNQIEGEATPVNLTEPAK-N2H4F0S0G0 glyco",
    "APOD ADGTVNQIEGEATPVNLTEPAK-N2H5F0S0G0 glyco",
    "APOD ADGTVNQIEGEATPVNLTEPAK-N3H4F1S1G0 glyco",
    "APOD ADGTVNQIEGEATPVNLTEPAK-N4H5F0S1G0 glyco",
    "APOD ADGTVNQIEGEATPVNLTEPAK-N4H5F0S2G0 glyco",
    "APOD ADGTVNQIEGEATPVNLTEPAK-N4H5F1S1G0 glyco",
    "APOD ADGTVNQIEGEATPVNLTEPAK-N4H5F1S2G0 glyco",
    "APOD ADGTVNQIEGEATPVNLTEPAKLEVK-N2H3F1S0G0 glyco",
    "APOD ADGTVNQIEGEATPVNLTEPAKLEVK-N2H5F0S0G0 glyco",
    "APOD ADGTVNQIEGEATPVNLTEPAKLEVK-N2H8F0S0G0 glyco",
    "APOD ADGTVNQIEGEATPVNLTEPAKLEVK-N3H4F0S1G0 glyco",
    "APOD ADGTVNQIEGEATPVNLTEPAKLEVK-N3H4F1S1G0 glyco",
    "APOD ADGTVNQIEGEATPVNLTEPAKLEVK-N4H5F0S1G0 glyco",
    "APOD ADGTVNQIEGEATPVNLTEPAKLEVK-N4H5F1S1G0 glyco",
    "APOD ADGTVNQIEGEATPVNLTEPAKLEVK-N4H5F1S2G0 glyco",
    "APOD ADGTVNQIEGEATPVNLTEPAKLEVK-N4H5F2S1G0 glyco",
    "APOD ADGTVNQIEGEATPVNLTEPAKLEVK-N5H6F1S1G0 glyco",
    "APOD ADGTVNQIEGEATPVNLTEPAKLEVK-N5H6F1S2G0 glyco",
    "APOD CIQANYSLMENGK-N2H3F0S0G0 glyco",
    "APOD CIQANYSLMENGK-N2H3F1S0G0 glyco",
    "APOD CIQANYSLMENGK-N2H4F0S0G0 glyco",
    "APOD CIQANYSLMENGK-N2H5F0S0G0 glyco",
    "APOD CIQANYSLMENGK-N2H6F0S0G0 glyco",
    "APOD CIQANYSLMENGK-N2H7F0S0G0 glyco",
    "APOD CIQANYSLMENGK-N2H8F0S0G0 glyco",
    "APOD CIQANYSLMENGK-N3H3F0S0G0 glyco",
    "APOD CIQANYSLMENGK-N3H4F0S1G0 glyco",
    "APOD CIQANYSLMENGK-N3H4F1S0G0 glyco",
    "APOD CIQANYSLMENGK-N4H3F0S0G0 glyco",
    "APOD CIQANYSLMENGK-N4H4F0S1G0 glyco",
    "APOD CIQANYSLMENGK-N4H5F0S0G0 glyco",
    "APOD CIQANYSLMENGK-N4H5F0S1G0 glyco",
    "APOD CIQANYSLMENGK-N4H5F0S2G0 glyco",
    "APOD CIQANYSLMENGK-N4H5F2S1G0 glyco",
    "APOD CIQANYSLMENGK-N5H3F0S0G0 glyco",
    "APOD CIQANYSLMENGK-N5H4F0S0G0 glyco",
    "APOD CIQANYSLMENGK-N5H4F1S0G0 glyco",
    "APOD CIQANYSLMENGK-N5H5F0S2G0 glyco",
    "APOD CIQANYSLMENGK-N5H6F0S2G0 glyco",
    "APOD CIQANYSLMENGK-N5H6F0S3G0 glyco",
    "APOD CIQANYSLMENGK-N5H6F2S1G0 glyco",
    "APOD CIQANYSLMENGK-N6H3F0S0G0 glyco",
    "APOD CIQANYSLMENGK-N6H4F0S1G0 glyco",
    "APOD CIQANYSLMENGK-N6H5F0S1G0 glyco",
    "APOD CIQANYSLMENGK-N6H5F0S2G0 glyco",
    "APOD CIQANYSLMENGK-N6H5F2S1G0 glyco",
    "APOD CIQANYSLMENGK-N6H6F0S2G0 glyco",
    "APOD cnv",
    "APOD proteo",
    "APOD rna"
  ],
  "APOE": [
    "APOE 147_148_1_1_S147 phospho",
    "APOE cnv",
    "APOE proteo",
    "APOE rna"
  ],
  "APOF": [
    "APOF cnv",
    "APOF proteo",
    "APOF rna"
  ],
  "APOH": [
    "APOH LGNWSAMPSCK-N3H4F0S1G0 glyco",
    "APOH LGNWSAMPSCK-N4H5F0S0G0 glyco",
    "APOH LGNWSAMPSCK-N4H5F0S1G0 glyco",
    "APOH LGNWSAMPSCK-N4H5F0S2G0 glyco",
    "APOH LGNWSAMPSCK-N5H6F0S3G0 glyco",
    "APOH LGNWSAMPSCK-N5H6F1S3G0 glyco",
    "APOH VYKPSAGNNSLYR-N3H3F2S0G0 glyco",
    "APOH VYKPSAGNNSLYR-N3H4F0S0G0 glyco",
    "APOH VYKPSAGNNSLYR-N3H4F0S1G0 glyco",
    "APOH VYKPSAGNNSLYR-N3H4F1S1G0 glyco",
    "APOH VYKPSAGNNSLYR-N4H5F0S1G0 glyco",
    "APOH VYKPSAGNNSLYR-N4H5F0S2G0 glyco",
    "APOH VYKPSAGNNSLYR-N4H5F1S2G0 glyco",
    "APOH cnv",
    "APOH proteo",
    "APOH rna"
  ],
  "APOL1": [
    "APOL1 307_314_1_1_S311 phospho",
    "APOL1 307_314_1_1_S314 phospho",
    "APOL1 307_314_2_2_S311S314 phospho",
    "APOL1 cnv",
    "APOL1 proteo",
    "APOL1 rna"
  ],
  "APOL2": [
    "APOL2 cnv",
    "APOL2 proteo",
    "APOL2 rna"
  ],
  "APOL3": [
    "APOL3 cnv",
    "APOL3 proteo",
    "APOL3 rna"
  ],
  "APOL4": [
    "APOL4 cnv",
    "APOL4 rna"
  ],
  "APOL5": [
    "APOL5 cnv",
    "APOL5 rna"
  ],
  "APOL6": [
    "APOL6 cnv",
    "APOL6 rna"
  ],
  "APOLD1": [
    "APOLD1 cnv",
    "APOLD1 methyl",
    "APOLD1 rna"
  ],
  "APOM": [
    "APOM TELFSSSCPGGIMLNETGQGYQR-N3H5F0S1G0 glyco",
    "APOM TELFSSSCPGGIMLNETGQGYQR-N4H5F0S1G0 glyco",
    "APOM TELFSSSCPGGIMLNETGQGYQR-N4H5F0S2G0 glyco",
    "APOM TELFSSSCPGGIMLNETGQGYQR-N4H5F2S1G0 glyco",
    "APOM cnv",
    "APOM methyl",
    "APOM proteo",
    "APOM rna"
  ],
  "APOO": [
    "APOO methyl",
    "APOO proteo",
    "APOO rna"
  ],
  "APOOL": [
    "APOOL proteo",
    "APOOL rna"
  ],
  "APP": [
    "APP cnv",
    "APP methyl",
    "APP proteo",
    "APP rna"
  ],
  "APPBP2": [
    "APPBP2 cnv",
    "APPBP2 methyl",
    "APPBP2 rna"
  ],
  "APPL1": [
    "APPL1 393_403_2_2_T399S401 phospho",
    "APPL1 673_696_1_1_S693 phospho",
    "APPL1 cnv",
    "APPL1 methyl",
    "APPL1 proteo",
    "APPL1 rna"
  ],
  "APPL2": [
    "APPL2 cnv",
    "APPL2 methyl",
    "APPL2 proteo",
    "APPL2 rna"
  ],
  "APRT": [
    "APRT cnv",
    "APRT methyl",
    "APRT proteo",
    "APRT rna"
  ],
  "APTR": [
    "APTR methyl"
  ],
  "APTX": [
    "APTX cnv",
    "APTX methyl",
    "APTX proteo",
    "APTX rna"
  ],
  "AQP1": [
    "AQP1 246_262_1_1_S247 phospho",
    "AQP1 246_262_1_1_S262 phospho",
    "AQP1 cnv",
    "AQP1 proteo",
    "AQP1 rna"
  ],
  "AQP10": [
    "AQP10 cnv",
    "AQP10 rna"
  ],
  "AQP11": [
    "AQP11 cnv",
    "AQP11 methyl",
    "AQP11 rna"
  ],
  "AQP12A": [
    "AQP12A cnv",
    "AQP12A rna"
  ],
  "AQP12B": [
    "AQP12B cnv",
    "AQP12B rna"
  ],
  "AQP2": [
    "AQP2 cnv",
    "AQP2 rna"
  ],
  "AQP3": [
    "AQP3 cnv",
    "AQP3 methyl",
    "AQP3 rna"
  ],
  "AQP4": [
    "AQP4 273_277_1_0 phospho",
    "AQP4 273_277_1_1_T273 phospho",
    "AQP4 273_277_2_2_T273S276 phospho",
    "AQP4 276_277_1_1_S276 phospho",
    "AQP4 276_289_1_1_S285 phospho",
    "AQP4 276_289_2_2_S276S285 phospho",
    "AQP4 285_289_1_1_S285 phospho",
    "AQP4 316_322_1_1_S316 phospho",
    "AQP4 316_322_1_1_S321 phospho",
    "AQP4 316_322_1_1_S322 phospho",
    "AQP4 cnv",
    "AQP4 methyl",
    "AQP4 proteo",
    "AQP4 rna"
  ],
  "AQP5": [
    "AQP5 cnv",
    "AQP5 methyl",
    "AQP5 rna"
  ],
  "AQP6": [
    "AQP6 cnv",
    "AQP6 rna"
  ],
  "AQP7": [
    "AQP7 cnv",
    "AQP7 rna"
  ],
  "AQP7B": [
    "AQP7B cnv",
    "AQP7B rna"
  ],
  "AQP8": [
    "AQP8 cnv",
    "AQP8 rna"
  ],
  "AQP9": [
    "AQP9 cnv",
    "AQP9 rna"
  ],
  "AQR": [
    "AQR cnv",
    "AQR methyl",
    "AQR proteo",
    "AQR rna"
  ],
  "AR": [
    "AR methyl",
    "AR rna"
  ],
  "ARAF": [
    "ARAF 155_165_1_1_S157 phospho",
    "ARAF 212_246_1_0 phospho",
    "ARAF kinase",
    "ARAF methyl",
    "ARAF proteo",
    "ARAF rna"
  ],
  "ARAP1": [
    "ARAP1 428_438_1_1_S428 phospho",
    "ARAP1 721_729_1_1_S729 phospho",
    "ARAP1 737_751_1_1_S738 phospho",
    "ARAP1 cnv",
    "ARAP1 methyl",
    "ARAP1 proteo",
    "ARAP1 rna"
  ],
  "ARAP2": [
    "ARAP2 cnv",
    "ARAP2 methyl",
    "ARAP2 proteo",
    "ARAP2 rna"
  ],
  "ARAP3": [
    "ARAP3 1444_1451_1_1_S1444 phospho",
    "ARAP3 cnv",
    "ARAP3 proteo",
    "ARAP3 rna"
  ],
  "ARC": [
    "ARC cnv",
    "ARC methyl",
    "ARC rna"
  ],
  "ARCN1": [
    "ARCN1 487_493_1_1_S493 phospho",
    "ARCN1 cnv",
    "ARCN1 methyl",
    "ARCN1 proteo",
    "ARCN1 rna"
  ],
  "AREG": [
    "AREG cnv",
    "AREG rna"
  ],
  "AREL1": [
    "AREL1 327_343_2_2_S327S337 phospho",
    "AREL1 cnv",
    "AREL1 methyl",
    "AREL1 rna"
  ],
  "ARF1": [
    "ARF1 cnv",
    "ARF1 methyl",
    "ARF1 proteo",
    "ARF1 rna"
  ],
  "ARF3": [
    "ARF3 cnv",
    "ARF3 methyl",
    "ARF3 proteo",
    "ARF3 rna"
  ],
  "ARF4": [
    "ARF4 cnv",
    "ARF4 methyl",
    "ARF4 proteo",
    "ARF4 rna"
  ],
  "ARF4-AS1": [
    "ARF4-AS1 methyl"
  ],
  "ARF5": [
    "ARF5 cnv",
    "ARF5 methyl",
    "ARF5 proteo",
    "ARF5 rna"
  ],
  "ARF6": [
    "ARF6 cnv",
    "ARF6 methyl",
    "ARF6 proteo",
    "ARF6 rna"
  ],
  "ARFGAP1": [
    "ARFGAP1 315_327_1_0 phospho",
    "ARFGAP1 315_327_1_1_S316 phospho",
    "ARFGAP1 331_342_1_1_S333 phospho",
    "ARFGAP1 72_82_1_1_T82 phospho",
    "ARFGAP1 cnv",
    "ARFGAP1 methyl",
    "ARFGAP1 proteo",
    "ARFGAP1 rna"
  ],
  "ARFGAP2": [
    "ARFGAP2 131_146_1_1_S146 phospho",
    "ARFGAP2 cnv",
    "ARFGAP2 methyl",
    "ARFGAP2 proteo",
    "ARFGAP2 rna"
  ],
  "ARFGAP3": [
    "ARFGAP3 365_378_1_1_S367 phospho",
    "ARFGAP3 451_458_1_1_S455 phospho",
    "ARFGAP3 cnv",
    "ARFGAP3 methyl",
    "ARFGAP3 proteo",
    "ARFGAP3 rna"
  ],
  "ARFGEF1": [
    "ARFGEF1 1533_1566_1_1_S1555 phospho",
    "ARFGEF1 48_52_1_1_S52 phospho",
    "ARFGEF1 52_52_1_1_S52 phospho",
    "ARFGEF1 cnv",
    "ARFGEF1 methyl",
    "ARFGEF1 proteo",
    "ARFGEF1 rna"
  ],
  "ARFGEF2": [
    "ARFGEF2 1525_1534_1_1_S1528 phospho",
    "ARFGEF2 1775_1782_1_1_S1782 phospho",
    "ARFGEF2 214_227_1_1_S227 phospho",
    "ARFGEF2 214_227_2_2_S218S227 phospho",
    "ARFGEF2 218_227_1_1_S227 phospho",
    "ARFGEF2 236_251_1_1_T244 phospho",
    "ARFGEF2 276_281_1_1_S277 phospho",
    "ARFGEF2 cnv",
    "ARFGEF2 proteo",
    "ARFGEF2 rna"
  ],
  "ARFGEF3": [
    "ARFGEF3 1047_1066_1_1_S1061 phospho",
    "ARFGEF3 1047_1066_1_1_S1066 phospho",
    "ARFGEF3 1047_1066_2_2_S1061S1066 phospho",
    "ARFGEF3 1649_1658_1_1_S1651 phospho",
    "ARFGEF3 1673_1676_1_1_S1676 phospho",
    "ARFGEF3 cnv",
    "ARFGEF3 methyl",
    "ARFGEF3 proteo",
    "ARFGEF3 rna"
  ],
  "ARFIP1": [
    "ARFIP1 36_56_1_1_S36 phospho",
    "ARFIP1 cnv",
    "ARFIP1 methyl",
    "ARFIP1 proteo",
    "ARFIP1 rna"
  ],
  "ARFIP2": [
    "ARFIP2 cnv",
    "ARFIP2 methyl",
    "ARFIP2 proteo",
    "ARFIP2 rna"
  ],
  "ARFRP1": [
    "ARFRP1 cnv",
    "ARFRP1 methyl",
    "ARFRP1 proteo",
    "ARFRP1 rna"
  ],
  "ARG1": [
    "ARG1 cnv",
    "ARG1 proteo",
    "ARG1 rna"
  ],
  "ARG2": [
    "ARG2 cnv",
    "ARG2 methyl",
    "ARG2 proteo",
    "ARG2 rna"
  ],
  "ARGFX": [
    "ARGFX cnv"
  ],
  "ARGLU1": [
    "ARGLU1 76_77_1_1_S77 phospho",
    "ARGLU1 cnv",
    "ARGLU1 methyl",
    "ARGLU1 proteo",
    "ARGLU1 rna"
  ],
  "ARHGAP1": [
    "ARHGAP1 219_226_1_1_S223 phospho",
    "ARHGAP1 223_226_1_1_S223 phospho",
    "ARHGAP1 44_56_1_1_S50 phospho",
    "ARHGAP1 44_56_2_2_S50S51 phospho",
    "ARHGAP1 49_56_1_1_S51 phospho",
    "ARHGAP1 49_65_1_1_S51 phospho",
    "ARHGAP1 cnv",
    "ARHGAP1 methyl",
    "ARHGAP1 proteo",
    "ARHGAP1 rna"
  ],
  "ARHGAP10": [
    "ARHGAP10 576_591_1_1_S591 phospho",
    "ARHGAP10 cnv",
    "ARHGAP10 methyl",
    "ARHGAP10 proteo",
    "ARHGAP10 rna"
  ],
  "ARHGAP11A": [
    "ARHGAP11A cnv",
    "ARHGAP11A methyl",
    "ARHGAP11A rna"
  ],
  "ARHGAP11A-SCG5": [
    "ARHGAP11A-SCG5 cnv",
    "ARHGAP11A-SCG5 methyl",
    "ARHGAP11A-SCG5 rna"
  ],
  "ARHGAP11B": [
    "ARHGAP11B cnv",
    "ARHGAP11B methyl",
    "ARHGAP11B rna"
  ],
  "ARHGAP12": [
    "ARHGAP12 103_104_1_1_S103 phospho",
    "ARHGAP12 103_115_1_1_S103 phospho",
    "ARHGAP12 163_165_1_1_S165 phospho",
    "ARHGAP12 176_176_1_1_S176 phospho",
    "ARHGAP12 191_206_1_1_S201 phospho",
    "ARHGAP12 213_224_2_2_S213S215 phospho",
    "ARHGAP12 230_243_1_1_S240 phospho",
    "ARHGAP12 230_243_1_1_T231 phospho",
    "ARHGAP12 230_243_2_2_T231S240 phospho",
    "ARHGAP12 252_273_1_1_S262 phospho",
    "ARHGAP12 457_460_1_1_S460 phospho",
    "ARHGAP12 571_592_1_1_S592 phospho",
    "ARHGAP12 639_639_1_1_T639 phospho",
    "ARHGAP12 cnv",
    "ARHGAP12 methyl",
    "ARHGAP12 proteo",
    "ARHGAP12 rna"
  ],
  "ARHGAP15": [
    "ARHGAP15 210_221_1_1_S212 phospho",
    "ARHGAP15 241_246_1_1_S243 phospho",
    "ARHGAP15 cnv",
    "ARHGAP15 rna"
  ],
  "ARHGAP17": [
    "ARHGAP17 161_171_1_1_S162 phospho",
    "ARHGAP17 551_575_1_1_S575 phospho",
    "ARHGAP17 551_584_1_1_S575 phospho",
    "ARHGAP17 595_628_1_1_S625 phospho",
    "ARHGAP17 674_696_1_1_S676 phospho",
    "ARHGAP17 701_728_1_0 phospho",
    "ARHGAP17 cnv",
    "ARHGAP17 methyl",
    "ARHGAP17 proteo",
    "ARHGAP17 rna"
  ],
  "ARHGAP18": [
    "ARHGAP18 cnv",
    "ARHGAP18 proteo",
    "ARHGAP18 rna"
  ],
  "ARHGAP19": [
    "ARHGAP19 cnv",
    "ARHGAP19 methyl",
    "ARHGAP19 rna"
  ],
  "ARHGAP19-SLIT1": [
    "ARHGAP19-SLIT1 cnv",
    "ARHGAP19-SLIT1 rna"
  ],
  "ARHGAP20": [
    "ARHGAP20 23_26_1_1_S23 phospho",
    "ARHGAP20 681_690_1_1_S681 phospho",
    "ARHGAP20 cnv",
    "ARHGAP20 methyl",
    "ARHGAP20 rna"
  ],
  "ARHGAP21": [
    "ARHGAP21 1094_1104_2_2_S1096S1099 phospho",
    "ARHGAP21 1110_1115_1_0 phospho",
    "ARHGAP21 1431_1433_1_1_S1432 phospho",
    "ARHGAP21 1431_1433_1_1_S1433 phospho",
    "ARHGAP21 1497_1509_1_1_S1504 phospho",
    "ARHGAP21 1669_1687_1_1_S1669 phospho",
    "ARHGAP21 1803_1803_1_1_T1803 phospho",
    "ARHGAP21 232_238_1_1_T234 phospho",
    "ARHGAP21 253_255_1_1_S253 phospho",
    "ARHGAP21 317_336_1_1_S319 phospho",
    "ARHGAP21 441_450_1_1_S441 phospho",
    "ARHGAP21 475_489_1_1_S477 phospho",
    "ARHGAP21 475_489_1_1_S483 phospho",
    "ARHGAP21 612_616_1_1_S616 phospho",
    "ARHGAP21 743_747_1_1_T747 phospho",
    "ARHGAP21 857_874_1_1_S857 phospho",
    "ARHGAP21 879_889_1_1_S881 phospho",
    "ARHGAP21 881_889_1_1_S881 phospho",
    "ARHGAP21 914_930_1_1_S924 phospho",
    "ARHGAP21 cnv",
    "ARHGAP21 methyl",
    "ARHGAP21 proteo",
    "ARHGAP21 rna"
  ],
  "ARHGAP22": [
    "ARHGAP22 362_375_1_1_S375 phospho",
    "ARHGAP22 cnv",
    "ARHGAP22 methyl",
    "ARHGAP22 proteo",
    "ARHGAP22 rna"
  ],
  "ARHGAP23": [
    "ARHGAP23 1306_1317_1_1_S1306 phospho",
    "ARHGAP23 1393_1396_1_1_S1393 phospho",
    "ARHGAP23 351_356_1_1_S351 phospho",
    "ARHGAP23 361_372_1_1_S361 phospho",
    "ARHGAP23 361_372_1_1_S372 phospho",
    "ARHGAP23 361_372_2_2_S361S372 phospho",
    "ARHGAP23 538_556_1_1_S554 phospho",
    "ARHGAP23 597_603_1_1_S598 phospho",
    "ARHGAP23 597_603_1_1_S603 phospho",
    "ARHGAP23 597_603_2_2_S598S603 phospho",
    "ARHGAP23 610_618_1_1_S611 phospho",
    "ARHGAP23 621_630_1_1_S623 phospho",
    "ARHGAP23 677_687_1_1_S677 phospho",
    "ARHGAP23 cnv",
    "ARHGAP23 methyl",
    "ARHGAP23 proteo",
    "ARHGAP23 rna"
  ],
  "ARHGAP24": [
    "ARHGAP24 413_415_1_1_S415 phospho",
    "ARHGAP24 cnv",
    "ARHGAP24 proteo",
    "ARHGAP24 rna"
  ],
  "ARHGAP25": [
    "ARHGAP25 357_363_1_1_S363 phospho",
    "ARHGAP25 363_363_1_1_S363 phospho",
    "ARHGAP25 379_386_1_1_S380 phospho",
    "ARHGAP25 500_527_1_1_S512 phospho",
    "ARHGAP25 cnv",
    "ARHGAP25 proteo",
    "ARHGAP25 rna"
  ],
  "ARHGAP26": [
    "ARHGAP26 570_584_1_1_S584 phospho",
    "ARHGAP26 588_610_1_0 phospho",
    "ARHGAP26 cnv",
    "ARHGAP26 methyl",
    "ARHGAP26 proteo",
    "ARHGAP26 rna"
  ],
  "ARHGAP27": [
    "ARHGAP27 455_466_1_1_S466 phospho",
    "ARHGAP27 cnv",
    "ARHGAP27 methyl",
    "ARHGAP27 proteo",
    "ARHGAP27 rna"
  ],
  "ARHGAP27P1-BPTFP1-KPNA2P3": [
    "ARHGAP27P1-BPTFP1-KPNA2P3 cnv",
    "ARHGAP27P1-BPTFP1-KPNA2P3 methyl",
    "ARHGAP27P1-BPTFP1-KPNA2P3 rna"
  ],
  "ARHGAP28": [
    "ARHGAP28 cnv",
    "ARHGAP28 methyl",
    "ARHGAP28 rna"
  ],
  "ARHGAP29": [
    "ARHGAP29 355_357_1_1_S357 phospho",
    "ARHGAP29 cnv",
    "ARHGAP29 methyl",
    "ARHGAP29 proteo",
    "ARHGAP29 rna"
  ],
  "ARHGAP29-AS1": [
    "ARHGAP29-AS1 methyl"
  ],
  "ARHGAP30": [
    "ARHGAP30 cnv",
    "ARHGAP30 proteo",
    "ARHGAP30 rna"
  ],
  "ARHGAP31": [
    "ARHGAP31 1026_1039_1_1_S1036 phospho",
    "ARHGAP31 1048_1054_1_1_S1054 phospho",
    "ARHGAP31 1071_1080_1_1_S1080 phospho",
    "ARHGAP31 1178_1184_1_1_S1178 phospho",
    "ARHGAP31 1432_1432_1_1_S1432 phospho",
    "ARHGAP31 272_286_1_1_S272 phospho",
    "ARHGAP31 340_352_1_1_S346 phospho",
    "ARHGAP31 346_352_1_1_S346 phospho",
    "ARHGAP31 382_392_1_1_S387 phospho",
    "ARHGAP31 623_629_1_1_S629 phospho",
    "ARHGAP31 764_800_1_1_S778 phospho",
    "ARHGAP31 952_960_1_1_S954 phospho",
    "ARHGAP31 963_980_1_1_S974 phospho",
    "ARHGAP31 cnv",
    "ARHGAP31 methyl",
    "ARHGAP31 proteo",
    "ARHGAP31 rna"
  ],
  "ARHGAP31-AS1": [
    "ARHGAP31-AS1 methyl"
  ],
  "ARHGAP32": [
    "ARHGAP32 607_617_1_1_S613 phospho",
    "ARHGAP32 682_685_1_1_S682 phospho",
    "ARHGAP32 703_720_1_1_S706 phospho",
    "ARHGAP32 949_954_1_1_S952 phospho",
    "ARHGAP32 cnv",
    "ARHGAP32 methyl",
    "ARHGAP32 proteo",
    "ARHGAP32 rna"
  ],
  "ARHGAP33": [
    "ARHGAP33 497_509_1_1_S500 phospho",
    "ARHGAP33 cnv",
    "ARHGAP33 methyl",
    "ARHGAP33 proteo",
    "ARHGAP33 rna"
  ],
  "ARHGAP35": [
    "ARHGAP35 1105_1112_1_1_Y1105 phospho",
    "ARHGAP35 1127_1142_1_0 phospho",
    "ARHGAP35 1127_1142_1_1_S1134 phospho",
    "ARHGAP35 1127_1142_2_2_S1134S1142 phospho",
    "ARHGAP35 1173_1179_1_1_S1179 phospho",
    "ARHGAP35 769_773_1_1_T771 phospho",
    "ARHGAP35 975_994_1_1_S975 phospho",
    "ARHGAP35 cnv",
    "ARHGAP35 methyl",
    "ARHGAP35 proteo",
    "ARHGAP35 rna"
  ],
  "ARHGAP36": [
    "ARHGAP36 215_215_1_1_S215 phospho",
    "ARHGAP36 431_432_1_1_S432 phospho",
    "ARHGAP36 methyl",
    "ARHGAP36 rna"
  ],
  "ARHGAP39": [
    "ARHGAP39 169_173_1_1_S173 phospho",
    "ARHGAP39 223_232_1_1_S223 phospho",
    "ARHGAP39 273_273_1_1_S273 phospho",
    "ARHGAP39 284_286_1_1_S286 phospho",
    "ARHGAP39 366_374_1_1_S366 phospho",
    "ARHGAP39 384_388_1_1_S384 phospho",
    "ARHGAP39 400_407_1_1_S407 phospho",
    "ARHGAP39 500_532_1_1_S500 phospho",
    "ARHGAP39 689_699_1_1_S690 phospho",
    "ARHGAP39 cnv",
    "ARHGAP39 methyl",
    "ARHGAP39 proteo",
    "ARHGAP39 rna"
  ],
  "ARHGAP4": [
    "ARHGAP4 857_889_1_0 phospho",
    "ARHGAP4 936_946_1_1_S946 phospho",
    "ARHGAP4 methyl",
    "ARHGAP4 proteo",
    "ARHGAP4 rna"
  ],
  "ARHGAP40": [
    "ARHGAP40 cnv",
    "ARHGAP40 methyl",
    "ARHGAP40 rna"
  ],
  "ARHGAP42": [
    "ARHGAP42 cnv",
    "ARHGAP42 methyl",
    "ARHGAP42 proteo",
    "ARHGAP42 rna"
  ],
  "ARHGAP44": [
    "ARHGAP44 598_637_1_1_S634 phospho",
    "ARHGAP44 cnv",
    "ARHGAP44 methyl",
    "ARHGAP44 proteo",
    "ARHGAP44 rna"
  ],
  "ARHGAP44-AS1": [
    "ARHGAP44-AS1 methyl"
  ],
  "ARHGAP45": [
    "ARHGAP45 23_29_1_1_S23 phospho",
    "ARHGAP45 557_569_1_1_S569 phospho",
    "ARHGAP45 577_603_1_0 phospho",
    "ARHGAP45 577_603_1_1_S578 phospho",
    "ARHGAP45 619_629_1_1_S619 phospho",
    "ARHGAP45 73_86_1_1_S73 phospho",
    "ARHGAP45 944_956_1_1_S951 phospho",
    "ARHGAP45 cnv",
    "ARHGAP45 methyl",
    "ARHGAP45 proteo",
    "ARHGAP45 rna"
  ],
  "ARHGAP5": [
    "ARHGAP5 1124_1138_1_1_S1124 phospho",
    "ARHGAP5 1171_1184_1_1_S1176 phospho",
    "ARHGAP5 1171_1184_2_2_S1173S1176 phospho",
    "ARHGAP5 1217_1218_1_1_S1218 phospho",
    "ARHGAP5 cnv",
    "ARHGAP5 methyl",
    "ARHGAP5 proteo",
    "ARHGAP5 rna"
  ],
  "ARHGAP6": [
    "ARHGAP6 640_641_1_1_S640 phospho",
    "ARHGAP6 657_681_1_1_S670 phospho",
    "ARHGAP6 747_759_1_1_S751 phospho",
    "ARHGAP6 methyl",
    "ARHGAP6 proteo",
    "ARHGAP6 rna"
  ],
  "ARHGAP8": [
    "ARHGAP8 cnv",
    "ARHGAP8 methyl",
    "ARHGAP8 rna"
  ],
  "ARHGAP9": [
    "ARHGAP9 cnv",
    "ARHGAP9 methyl",
    "ARHGAP9 proteo",
    "ARHGAP9 rna"
  ],
  "ARHGDIA": [
    "ARHGDIA 128_133_1_1_Y133 phospho",
    "ARHGDIA 34_34_1_1_S34 phospho",
    "ARHGDIA cnv",
    "ARHGDIA methyl",
    "ARHGDIA proteo",
    "ARHGDIA rna"
  ],
  "ARHGDIB": [
    "ARHGDIB cnv",
    "ARHGDIB proteo",
    "ARHGDIB rna"
  ],
  "ARHGDIG": [
    "ARHGDIG cnv",
    "ARHGDIG methyl",
    "ARHGDIG rna"
  ],
  "ARHGEF1": [
    "ARHGEF1 797_798_1_1_S798 phospho",
    "ARHGEF1 cnv",
    "ARHGEF1 methyl",
    "ARHGEF1 proteo",
    "ARHGEF1 rna"
  ],
  "ARHGEF10": [
    "ARHGEF10 18_35_1_1_S35 phospho",
    "ARHGEF10 316_316_1_1_S316 phospho",
    "ARHGEF10 cnv",
    "ARHGEF10 methyl",
    "ARHGEF10 proteo",
    "ARHGEF10 rna"
  ],
  "ARHGEF10L": [
    "ARHGEF10L cnv",
    "ARHGEF10L methyl",
    "ARHGEF10L proteo",
    "ARHGEF10L rna"
  ],
  "ARHGEF11": [
    "ARHGEF11 1332_1340_1_1_S1335 phospho",
    "ARHGEF11 1332_1360_1_1_S1335 phospho",
    "ARHGEF11 145_150_1_1_S150 phospho",
    "ARHGEF11 1492_1509_1_1_S1498 phospho",
    "ARHGEF11 1492_1509_1_1_T1502 phospho",
    "ARHGEF11 1515_1520_1_1_S1520 phospho",
    "ARHGEF11 1515_1531_1_1_S1520 phospho",
    "ARHGEF11 1534_1559_1_1_S1559 phospho",
    "ARHGEF11 282_295_1_0 phospho",
    "ARHGEF11 282_295_1_1_S295 phospho",
    "ARHGEF11 282_295_2_2_S291S295 phospho",
    "ARHGEF11 282_295_2_2_S291T294 phospho",
    "ARHGEF11 294_295_1_1_S295 phospho",
    "ARHGEF11 311_326_1_1_S311 phospho",
    "ARHGEF11 35_41_1_1_S35 phospho",
    "ARHGEF11 585_596_2_2_S585S596 phospho",
    "ARHGEF11 673_686_1_1_S675 phospho",
    "ARHGEF11 691_701_1_1_S695 phospho",
    "ARHGEF11 691_701_2_2_S695S698 phospho",
    "ARHGEF11 703_712_1_1_T708 phospho",
    "ARHGEF11 703_712_1_1_T712 phospho",
    "ARHGEF11 703_712_2_2_T708T712 phospho",
    "ARHGEF11 cnv",
    "ARHGEF11 methyl",
    "ARHGEF11 proteo",
    "ARHGEF11 rna"
  ],
  "ARHGEF12": [
    "ARHGEF12 1286_1300_1_1_S1288 phospho",
    "ARHGEF12 1389_1394_1_1_S1389 phospho",
    "ARHGEF12 189_190_1_1_S190 phospho",
    "ARHGEF12 292_309_1_1_S309 phospho",
    "ARHGEF12 41_47_1_1_S41 phospho",
    "ARHGEF12 631_643_1_1_S637 phospho",
    "ARHGEF12 732_736_1_1_T736 phospho",
    "ARHGEF12 cnv",
    "ARHGEF12 methyl",
    "ARHGEF12 proteo",
    "ARHGEF12 rna"
  ],
  "ARHGEF15": [
    "ARHGEF15 cnv",
    "ARHGEF15 rna"
  ],
  "ARHGEF16": [
    "ARHGEF16 cnv",
    "ARHGEF16 methyl",
    "ARHGEF16 rna"
  ],
  "ARHGEF17": [
    "ARHGEF17 1330_1345_1_0 phospho",
    "ARHGEF17 142_152_1_1_S142 phospho",
    "ARHGEF17 1991_1998_1_1_T1991 phospho",
    "ARHGEF17 393_407_1_1_S395 phospho",
    "ARHGEF17 461_476_1_1_S461 phospho",
    "ARHGEF17 461_476_1_1_S463 phospho",
    "ARHGEF17 499_533_1_1_S507 phospho",
    "ARHGEF17 499_533_2_2_S507S527 phospho",
    "ARHGEF17 546_550_1_1_S546 phospho",
    "ARHGEF17 613_627_1_1_S619 phospho",
    "ARHGEF17 940_948_1_1_S940 phospho",
    "ARHGEF17 cnv",
    "ARHGEF17 methyl",
    "ARHGEF17 proteo",
    "ARHGEF17 rna"
  ],
  "ARHGEF18": [
    "ARHGEF18 1014_1017_1_1_S1014 phospho",
    "ARHGEF18 724_735_1_1_S733 phospho",
    "ARHGEF18 760_760_1_1_S760 phospho",
    "ARHGEF18 cnv",
    "ARHGEF18 methyl",
    "ARHGEF18 proteo",
    "ARHGEF18 rna"
  ],
  "ARHGEF19": [
    "ARHGEF19 cnv",
    "ARHGEF19 methyl",
    "ARHGEF19 rna"
  ],
  "ARHGEF2": [
    "ARHGEF2 679_679_1_1_T679 phospho",
    "ARHGEF2 691_700_1_0 phospho",
    "ARHGEF2 691_700_1_1_T695 phospho",
    "ARHGEF2 886_903_1_1_S886 phospho",
    "ARHGEF2 932_932_1_1_S932 phospho",
    "ARHGEF2 940_953_1_1_S941 phospho",
    "ARHGEF2 940_960_2_0 phospho",
    "ARHGEF2 cnv",
    "ARHGEF2 methyl",
    "ARHGEF2 proteo",
    "ARHGEF2 rna"
  ],
  "ARHGEF2-AS2": [
    "ARHGEF2-AS2 methyl"
  ],
  "ARHGEF25": [
    "ARHGEF25 595_601_1_1_S595 phospho",
    "ARHGEF25 595_601_2_2_S595S599 phospho",
    "ARHGEF25 cnv",
    "ARHGEF25 methyl",
    "ARHGEF25 rna"
  ],
  "ARHGEF26": [
    "ARHGEF26 222_239_1_1_S222 phospho",
    "ARHGEF26 392_396_1_1_S392 phospho",
    "ARHGEF26 739_751_1_1_S739 phospho",
    "ARHGEF26 76_80_1_1_S80 phospho",
    "ARHGEF26 cnv",
    "ARHGEF26 methyl",
    "ARHGEF26 proteo",
    "ARHGEF26 rna"
  ],
  "ARHGEF26-AS1": [
    "ARHGEF26-AS1 methyl"
  ],
  "ARHGEF28": [
    "ARHGEF28 cnv",
    "ARHGEF28 methyl",
    "ARHGEF28 rna"
  ],
  "ARHGEF3": [
    "ARHGEF3 78_79_1_1_S79 phospho",
    "ARHGEF3 cnv",
    "ARHGEF3 methyl",
    "ARHGEF3 rna"
  ],
  "ARHGEF33": [
    "ARHGEF33 cnv",
    "ARHGEF33 methyl",
    "ARHGEF33 rna"
  ],
  "ARHGEF35": [
    "ARHGEF35 cnv",
    "ARHGEF35 rna"
  ],
  "ARHGEF37": [
    "ARHGEF37 cnv",
    "ARHGEF37 methyl",
    "ARHGEF37 proteo",
    "ARHGEF37 rna"
  ],
  "ARHGEF38": [
    "ARHGEF38 cnv",
    "ARHGEF38 rna"
  ],
  "ARHGEF39": [
    "ARHGEF39 cnv",
    "ARHGEF39 methyl",
    "ARHGEF39 rna"
  ],
  "ARHGEF4": [
    "ARHGEF4 cnv",
    "ARHGEF4 methyl",
    "ARHGEF4 proteo",
    "ARHGEF4 rna"
  ],
  "ARHGEF40": [
    "ARHGEF40 1466_1474_1_1_S1474 phospho",
    "ARHGEF40 1480_1497_1_0 phospho",
    "ARHGEF40 255_266_1_1_S262 phospho",
    "ARHGEF40 270_273_1_1_T270 phospho",
    "ARHGEF40 371_371_1_1_T371 phospho",
    "ARHGEF40 961_961_1_1_S961 phospho",
    "ARHGEF40 cnv",
    "ARHGEF40 methyl",
    "ARHGEF40 proteo",
    "ARHGEF40 rna"
  ],
  "ARHGEF5": [
    "ARHGEF5 cnv",
    "ARHGEF5 rna"
  ],
  "ARHGEF6": [
    "ARHGEF6 122_144_1_0 phospho",
    "ARHGEF6 122_144_1_1_S124 phospho",
    "ARHGEF6 559_573_1_1_S569 phospho",
    "ARHGEF6 methyl",
    "ARHGEF6 proteo",
    "ARHGEF6 rna"
  ],
  "ARHGEF7": [
    "ARHGEF7 153_164_1_1_S153 phospho",
    "ARHGEF7 231_244_1_1_S236 phospho",
    "ARHGEF7 626_626_1_1_S626 phospho",
    "ARHGEF7 cnv",
    "ARHGEF7 methyl",
    "ARHGEF7 proteo",
    "ARHGEF7 rna"
  ],
  "ARHGEF7-AS2": [
    "ARHGEF7-AS2 methyl"
  ],
  "ARHGEF9": [
    "ARHGEF9 methyl",
    "ARHGEF9 proteo",
    "ARHGEF9 rna"
  ],
  "ARID1A": [
    "ARID1A 1743_1751_1_1_S1751 phospho",
    "ARID1A 1754_1755_1_1_S1755 phospho",
    "ARID1A 220_233_1_1_S233 phospho",
    "ARID1A 357_367_1_1_S363 phospho",
    "ARID1A 377_382_1_1_S382 phospho",
    "ARID1A 696_709_1_1_S696 phospho",
    "ARID1A 762_772_1_1_S772 phospho",
    "ARID1A cnv",
    "ARID1A methyl",
    "ARID1A mut",
    "ARID1A proteo",
    "ARID1A rna"
  ],
  "ARID1B": [
    "ARID1B 1595_1598_1_1_S1595 phospho",
    "ARID1B 1608_1617_1_1_S1608 phospho",
    "ARID1B 497_509_1_1_S502 phospho",
    "ARID1B cnv",
    "ARID1B methyl",
    "ARID1B proteo",
    "ARID1B rna"
  ],
  "ARID2": [
    "ARID2 1299_1309_1_0 phospho",
    "ARID2 cnv",
    "ARID2 methyl",
    "ARID2 proteo",
    "ARID2 rna"
  ],
  "ARID3A": [
    "ARID3A cnv",
    "ARID3A methyl",
    "ARID3A rna"
  ],
  "ARID3B": [
    "ARID3B cnv",
    "ARID3B methyl",
    "ARID3B rna"
  ],
  "ARID3C": [
    "ARID3C cnv",
    "ARID3C methyl",
    "ARID3C rna"
  ],
  "ARID4A": [
    "ARID4A 1105_1121_1_1_S1109 phospho",
    "ARID4A 538_542_2_2_S538S542 phospho",
    "ARID4A 863_864_1_1_S864 phospho",
    "ARID4A cnv",
    "ARID4A methyl",
    "ARID4A proteo",
    "ARID4A rna"
  ],
  "ARID4B": [
    "ARID4B 1013_1039_1_1_S1029 phospho",
    "ARID4B 1150_1165_1_0 phospho",
    "ARID4B 666_680_1_1_S675 phospho",
    "ARID4B cnv",
    "ARID4B methyl",
    "ARID4B proteo",
    "ARID4B rna"
  ],
  "ARID5A": [
    "ARID5A cnv",
    "ARID5A methyl",
    "ARID5A rna"
  ],
  "ARID5B": [
    "ARID5B cnv",
    "ARID5B rna"
  ],
  "ARIH1": [
    "ARIH1 cnv",
    "ARIH1 methyl",
    "ARIH1 proteo",
    "ARIH1 rna"
  ],
  "ARIH2": [
    "ARIH2 cnv",
    "ARIH2 methyl",
    "ARIH2 proteo",
    "ARIH2 rna"
  ],
  "ARL1": [
    "ARL1 cnv",
    "ARL1 methyl",
    "ARL1 proteo",
    "ARL1 rna"
  ],
  "ARL10": [
    "ARL10 cnv",
    "ARL10 methyl",
    "ARL10 proteo",
    "ARL10 rna"
  ],
  "ARL11": [
    "ARL11 cnv",
    "ARL11 rna"
  ],
  "ARL13A": [
    "ARL13A rna"
  ],
  "ARL13B": [
    "ARL13B cnv",
    "ARL13B methyl",
    "ARL13B proteo",
    "ARL13B rna"
  ],
  "ARL14": [
    "ARL14 cnv",
    "ARL14 rna"
  ],
  "ARL14EP": [
    "ARL14EP cnv",
    "ARL14EP methyl",
    "ARL14EP proteo",
    "ARL14EP rna"
  ],
  "ARL14EPL": [
    "ARL14EPL cnv",
    "ARL14EPL rna"
  ],
  "ARL15": [
    "ARL15 cnv",
    "ARL15 methyl",
    "ARL15 proteo",
    "ARL15 rna"
  ],
  "ARL16": [
    "ARL16 cnv",
    "ARL16 methyl",
    "ARL16 rna"
  ],
  "ARL17A": [
    "ARL17A cnv",
    "ARL17A methyl",
    "ARL17A rna"
  ],
  "ARL17B": [
    "ARL17B cnv",
    "ARL17B methyl",
    "ARL17B rna"
  ],
  "ARL2": [
    "ARL2 43_47_1_1_S45 phospho",
    "ARL2 cnv",
    "ARL2 methyl",
    "ARL2 proteo",
    "ARL2 rna"
  ],
  "ARL2-SNX15": [
    "ARL2-SNX15 cnv",
    "ARL2-SNX15 rna"
  ],
  "ARL2BP": [
    "ARL2BP 140_147_1_0 phospho",
    "ARL2BP 151_157_1_1_S153 phospho",
    "ARL2BP 151_157_1_1_S157 phospho",
    "ARL2BP cnv",
    "ARL2BP methyl",
    "ARL2BP proteo",
    "ARL2BP rna"
  ],
  "ARL3": [
    "ARL3 39_48_1_1_T46 phospho",
    "ARL3 cnv",
    "ARL3 methyl",
    "ARL3 proteo",
    "ARL3 rna"
  ],
  "ARL4A": [
    "ARL4A cnv",
    "ARL4A methyl",
    "ARL4A rna"
  ],
  "ARL4C": [
    "ARL4C cnv",
    "ARL4C methyl",
    "ARL4C proteo",
    "ARL4C rna"
  ],
  "ARL4D": [
    "ARL4D cnv",
    "ARL4D methyl",
    "ARL4D rna"
  ],
  "ARL5A": [
    "ARL5A cnv",
    "ARL5A methyl",
    "ARL5A rna"
  ],
  "ARL5B": [
    "ARL5B cnv",
    "ARL5B methyl",
    "ARL5B rna"
  ],
  "ARL5C": [
    "ARL5C cnv",
    "ARL5C methyl",
    "ARL5C rna"
  ],
  "ARL6": [
    "ARL6 cnv",
    "ARL6 methyl",
    "ARL6 proteo",
    "ARL6 rna"
  ],
  "ARL6IP1": [
    "ARL6IP1 cnv",
    "ARL6IP1 methyl",
    "ARL6IP1 proteo",
    "ARL6IP1 rna"
  ],
  "ARL6IP4": [
    "ARL6IP4 231_245_1_1_S239 phospho",
    "ARL6IP4 332_343_1_1_S332 phospho",
    "ARL6IP4 cnv",
    "ARL6IP4 methyl",
    "ARL6IP4 proteo",
    "ARL6IP4 rna"
  ],
  "ARL6IP5": [
    "ARL6IP5 cnv",
    "ARL6IP5 methyl",
    "ARL6IP5 proteo",
    "ARL6IP5 rna"
  ],
  "ARL6IP6": [
    "ARL6IP6 19_19_1_1_T19 phospho",
    "ARL6IP6 71_80_1_1_S80 phospho",
    "ARL6IP6 cnv",
    "ARL6IP6 methyl",
    "ARL6IP6 proteo",
    "ARL6IP6 rna"
  ],
  "ARL8A": [
    "ARL8A cnv",
    "ARL8A methyl",
    "ARL8A proteo",
    "ARL8A rna"
  ],
  "ARL8B": [
    "ARL8B cnv",
    "ARL8B methyl",
    "ARL8B proteo",
    "ARL8B rna"
  ],
  "ARL9": [
    "ARL9 cnv",
    "ARL9 methyl",
    "ARL9 rna"
  ],
  "ARLNC1": [
    "ARLNC1 methyl"
  ],
  "ARMC1": [
    "ARMC1 189_203_1_1_S189 phospho",
    "ARMC1 cnv",
    "ARMC1 methyl",
    "ARMC1 proteo",
    "ARMC1 rna"
  ],
  "ARMC10": [
    "ARMC10 42_54_1_0 phospho",
    "ARMC10 42_54_1_1_S45 phospho",
    "ARMC10 cnv",
    "ARMC10 methyl",
    "ARMC10 proteo",
    "ARMC10 rna"
  ],
  "ARMC12": [
    "ARMC12 cnv",
    "ARMC12 rna"
  ],
  "ARMC2": [
    "ARMC2 cnv",
    "ARMC2 methyl",
    "ARMC2 rna"
  ],
  "ARMC3": [
    "ARMC3 cnv",
    "ARMC3 rna"
  ],
  "ARMC5": [
    "ARMC5 cnv",
    "ARMC5 methyl",
    "ARMC5 proteo",
    "ARMC5 rna"
  ],
  "ARMC6": [
    "ARMC6 cnv",
    "ARMC6 methyl",
    "ARMC6 proteo",
    "ARMC6 rna"
  ],
  "ARMC7": [
    "ARMC7 cnv",
    "ARMC7 methyl",
    "ARMC7 rna"
  ],
  "ARMC8": [
    "ARMC8 cnv",
    "ARMC8 methyl",
    "ARMC8 proteo",
    "ARMC8 rna"
  ],
  "ARMC9": [
    "ARMC9 cnv",
    "ARMC9 methyl",
    "ARMC9 proteo",
    "ARMC9 rna"
  ],
  "ARMCX1": [
    "ARMCX1 methyl",
    "ARMCX1 proteo",
    "ARMCX1 rna"
  ],
  "ARMCX2": [
    "ARMCX2 proteo",
    "ARMCX2 rna"
  ],
  "ARMCX3": [
    "ARMCX3 110_119_1_1_S110 phospho",
    "ARMCX3 57_70_1_1_S61 phospho",
    "ARMCX3 proteo",
    "ARMCX3 rna"
  ],
  "ARMCX4": [
    "ARMCX4 methyl",
    "ARMCX4 rna"
  ],
  "ARMCX5": [
    "ARMCX5 methyl",
    "ARMCX5 proteo",
    "ARMCX5 rna"
  ],
  "ARMCX5-GPRASP2": [
    "ARMCX5-GPRASP2 methyl",
    "ARMCX5-GPRASP2 rna"
  ],
  "ARMCX6": [
    "ARMCX6 proteo",
    "ARMCX6 rna"
  ],
  "ARMH1": [
    "ARMH1 cnv",
    "ARMH1 methyl",
    "ARMH1 rna"
  ],
  "ARMH2": [
    "ARMH2 cnv",
    "ARMH2 rna"
  ],
  "ARMH3": [
    "ARMH3 cnv",
    "ARMH3 methyl",
    "ARMH3 proteo",
    "ARMH3 rna"
  ],
  "ARMH4": [
    "ARMH4 cnv",
    "ARMH4 methyl",
    "ARMH4 proteo",
    "ARMH4 rna"
  ],
  "ARMS2": [
    "ARMS2 cnv",
    "ARMS2 rna"
  ],
  "ARMT1": [
    "ARMT1 cnv",
    "ARMT1 methyl",
    "ARMT1 proteo",
    "ARMT1 rna"
  ],
  "ARNT": [
    "ARNT 68_74_1_1_S68 phospho",
    "ARNT cnv",
    "ARNT proteo",
    "ARNT rna"
  ],
  "ARNT2": [
    "ARNT2 cnv",
    "ARNT2 methyl",
    "ARNT2 proteo",
    "ARNT2 rna"
  ],
  "ARNTL": [
    "ARNTL cnv",
    "ARNTL methyl",
    "ARNTL proteo",
    "ARNTL rna"
  ],
  "ARNTL2": [
    "ARNTL2 cnv",
    "ARNTL2 methyl",
    "ARNTL2 rna"
  ],
  "ARPC1A": [
    "ARPC1A cnv",
    "ARPC1A methyl",
    "ARPC1A proteo",
    "ARPC1A rna"
  ],
  "ARPC1B": [
    "ARPC1B 310_323_1_1_S310 phospho",
    "ARPC1B cnv",
    "ARPC1B methyl",
    "ARPC1B proteo",
    "ARPC1B rna"
  ],
  "ARPC2": [
    "ARPC2 cnv",
    "ARPC2 methyl",
    "ARPC2 proteo",
    "ARPC2 rna"
  ],
  "ARPC3": [
    "ARPC3 cnv",
    "ARPC3 methyl",
    "ARPC3 proteo",
    "ARPC3 rna"
  ],
  "ARPC4": [
    "ARPC4 cnv",
    "ARPC4 methyl",
    "ARPC4 proteo",
    "ARPC4 rna"
  ],
  "ARPC4-TTLL3": [
    "ARPC4-TTLL3 cnv",
    "ARPC4-TTLL3 methyl",
    "ARPC4-TTLL3 rna"
  ],
  "ARPC5": [
    "ARPC5 cnv",
    "ARPC5 methyl",
    "ARPC5 proteo",
    "ARPC5 rna"
  ],
  "ARPC5L": [
    "ARPC5L 64_68_1_1_S64 phospho",
    "ARPC5L cnv",
    "ARPC5L methyl",
    "ARPC5L proteo",
    "ARPC5L rna"
  ],
  "ARPIN": [
    "ARPIN cnv",
    "ARPIN methyl",
    "ARPIN proteo",
    "ARPIN rna"
  ],
  "ARPIN-AP3S2": [
    "ARPIN-AP3S2 cnv",
    "ARPIN-AP3S2 methyl",
    "ARPIN-AP3S2 rna"
  ],
  "ARPP19": [
    "ARPP19 104_127_1_1_S123 phospho",
    "ARPP19 cnv",
    "ARPP19 methyl",
    "ARPP19 proteo",
    "ARPP19 rna"
  ],
  "ARPP21": [
    "ARPP21 31_33_1_1_S33 phospho",
    "ARPP21 cnv",
    "ARPP21 methyl",
    "ARPP21 rna"
  ],
  "ARR3": [
    "ARR3 rna"
  ],
  "ARRB1": [
    "ARRB1 410_412_1_1_S412 phospho",
    "ARRB1 cnv",
    "ARRB1 methyl",
    "ARRB1 proteo",
    "ARRB1 rna"
  ],
  "ARRB2": [
    "ARRB2 cnv",
    "ARRB2 methyl",
    "ARRB2 proteo",
    "ARRB2 rna"
  ],
  "ARRDC1": [
    "ARRDC1 cnv",
    "ARRDC1 methyl",
    "ARRDC1 proteo",
    "ARRDC1 rna"
  ],
  "ARRDC2": [
    "ARRDC2 cnv",
    "ARRDC2 methyl",
    "ARRDC2 rna"
  ],
  "ARRDC3": [
    "ARRDC3 cnv",
    "ARRDC3 methyl",
    "ARRDC3 rna"
  ],
  "ARRDC3-AS1": [
    "ARRDC3-AS1 methyl"
  ],
  "ARRDC4": [
    "ARRDC4 cnv",
    "ARRDC4 methyl",
    "ARRDC4 rna"
  ],
  "ARRDC5": [
    "ARRDC5 cnv",
    "ARRDC5 rna"
  ],
  "ARSA": [
    "ARSA cnv",
    "ARSA methyl",
    "ARSA proteo",
    "ARSA rna"
  ],
  "ARSB": [
    "ARSB CTLIDALNVTR-N2H5F0S0G0 glyco",
    "ARSB CTLIDALNVTR-N2H6F0S0G0 glyco",
    "ARSB cnv",
    "ARSB methyl",
    "ARSB proteo",
    "ARSB rna"
  ],
  "ARSD": [
    "ARSD methyl",
    "ARSD proteo",
    "ARSD rna"
  ],
  "ARSF": [
    "ARSF proteo",
    "ARSF rna"
  ],
  "ARSG": [
    "ARSG cnv",
    "ARSG methyl",
    "ARSG proteo",
    "ARSG rna"
  ],
  "ARSH": [
    "ARSH rna"
  ],
  "ARSI": [
    "ARSI cnv",
    "ARSI methyl",
    "ARSI rna"
  ],
  "ARSJ": [
    "ARSJ cnv",
    "ARSJ methyl",
    "ARSJ rna"
  ],
  "ARSK": [
    "ARSK cnv",
    "ARSK methyl",
    "ARSK rna"
  ],
  "ARSL": [
    "ARSL rna"
  ],
  "ART1": [
    "ART1 cnv",
    "ART1 rna"
  ],
  "ART3": [
    "ART3 cnv",
    "ART3 proteo",
    "ART3 rna"
  ],
  "ART4": [
    "ART4 cnv",
    "ART4 rna"
  ],
  "ART5": [
    "ART5 cnv",
    "ART5 methyl",
    "ART5 rna"
  ],
  "ARTN": [
    "ARTN cnv",
    "ARTN methyl",
    "ARTN rna"
  ],
  "ARV1": [
    "ARV1 cnv",
    "ARV1 methyl",
    "ARV1 proteo",
    "ARV1 rna"
  ],
  "ARVCF": [
    "ARVCF 259_286_1_1_S267 phospho",
    "ARVCF 343_348_1_1_S343 phospho",
    "ARVCF 592_606_1_1_S606 phospho",
    "ARVCF 642_642_1_1_T642 phospho",
    "ARVCF 915_921_1_1_S915 phospho",
    "ARVCF cnv",
    "ARVCF methyl",
    "ARVCF proteo",
    "ARVCF rna"
  ],
  "ARX": [
    "ARX methyl",
    "ARX rna"
  ],
  "AS3MT": [
    "AS3MT cnv",
    "AS3MT methyl",
    "AS3MT proteo",
    "AS3MT rna"
  ],
  "ASAH1": [
    "ASAH1 ILAPAYFILGGNQSGEGCVITR-N2H3F0S0G0 glyco",
    "ASAH1 ILAPAYFILGGNQSGEGCVITR-N2H4F0S0G0 glyco",
    "ASAH1 ILAPAYFILGGNQSGEGCVITR-N2H5F0S0G0 glyco",
    "ASAH1 ILAPAYFILGGNQSGEGCVITR-N2H6F0S0G0 glyco",
    "ASAH1 ILAPAYFILGGNQSGEGCVITR-N2H7F0S0G0 glyco",
    "ASAH1 TVLENSTSYEEAK-N2H4F0S0G0 glyco",
    "ASAH1 TVLENSTSYEEAK-N2H5F0S0G0 glyco",
    "ASAH1 TVLENSTSYEEAK-N2H6F0S0G0 glyco",
    "ASAH1 TVLENSTSYEEAK-N2H7F0S0G0 glyco",
    "ASAH1 TVLENSTSYEEAK-N2H8F0S0G0 glyco",
    "ASAH1 cnv",
    "ASAH1 methyl",
    "ASAH1 proteo",
    "ASAH1 rna"
  ],
  "ASAH1-AS1": [
    "ASAH1-AS1 methyl"
  ],
  "ASAH2": [
    "ASAH2 cnv",
    "ASAH2 rna"
  ],
  "ASAH2B": [
    "ASAH2B cnv",
    "ASAH2B methyl",
    "ASAH2B rna"
  ],
  "ASAP1": [
    "ASAP1 1014_1025_1_1_S1020 phospho",
    "ASAP1 1034_1047_1_1_S1034 phospho",
    "ASAP1 1115_1121_1_1_S1121 phospho",
    "ASAP1 710_719_1_1_S710 phospho",
    "ASAP1 830_836_1_0 phospho",
    "ASAP1 830_836_1_1_S832 phospho",
    "ASAP1 995_1001_1_1_S1001 phospho",
    "ASAP1 cnv",
    "ASAP1 methyl",
    "ASAP1 proteo",
    "ASAP1 rna"
  ],
  "ASAP2": [
    "ASAP2 701_701_1_1_S701 phospho",
    "ASAP2 701_712_1_1_S701 phospho",
    "ASAP2 820_822_1_1_S822 phospho",
    "ASAP2 cnv",
    "ASAP2 methyl",
    "ASAP2 proteo",
    "ASAP2 rna"
  ],
  "ASAP3": [
    "ASAP3 277_282_2_2_S277S282 phospho",
    "ASAP3 853_859_1_1_S853 phospho",
    "ASAP3 cnv",
    "ASAP3 methyl",
    "ASAP3 proteo",
    "ASAP3 rna"
  ],
  "ASB1": [
    "ASB1 cnv",
    "ASB1 methyl",
    "ASB1 proteo",
    "ASB1 rna"
  ],
  "ASB10": [
    "ASB10 cnv",
    "ASB10 rna"
  ],
  "ASB11": [
    "ASB11 rna"
  ],
  "ASB12": [
    "ASB12 rna"
  ],
  "ASB13": [
    "ASB13 cnv",
    "ASB13 methyl",
    "ASB13 proteo",
    "ASB13 rna"
  ],
  "ASB14": [
    "ASB14 cnv",
    "ASB14 rna"
  ],
  "ASB15": [
    "ASB15 cnv",
    "ASB15 rna"
  ],
  "ASB16": [
    "ASB16 cnv",
    "ASB16 rna"
  ],
  "ASB16-AS1": [
    "ASB16-AS1 methyl"
  ],
  "ASB17": [
    "ASB17 cnv"
  ],
  "ASB18": [
    "ASB18 cnv",
    "ASB18 methyl",
    "ASB18 rna"
  ],
  "ASB2": [
    "ASB2 cnv",
    "ASB2 rna"
  ],
  "ASB3": [
    "ASB3 cnv",
    "ASB3 methyl",
    "ASB3 rna"
  ],
  "ASB4": [
    "ASB4 cnv",
    "ASB4 rna"
  ],
  "ASB5": [
    "ASB5 cnv",
    "ASB5 rna"
  ],
  "ASB6": [
    "ASB6 cnv",
    "ASB6 methyl",
    "ASB6 proteo",
    "ASB6 rna"
  ],
  "ASB7": [
    "ASB7 cnv",
    "ASB7 methyl",
    "ASB7 rna"
  ],
  "ASB8": [
    "ASB8 cnv",
    "ASB8 methyl",
    "ASB8 rna"
  ],
  "ASB9": [
    "ASB9 rna"
  ],
  "ASCC1": [
    "ASCC1 cnv",
    "ASCC1 methyl",
    "ASCC1 proteo",
    "ASCC1 rna"
  ],
  "ASCC2": [
    "ASCC2 cnv",
    "ASCC2 methyl",
    "ASCC2 proteo",
    "ASCC2 rna"
  ],
  "ASCC3": [
    "ASCC3 297_298_1_1_S298 phospho",
    "ASCC3 cnv",
    "ASCC3 methyl",
    "ASCC3 proteo",
    "ASCC3 rna"
  ],
  "ASCL1": [
    "ASCL1 cnv",
    "ASCL1 methyl",
    "ASCL1 rna"
  ],
  "ASCL2": [
    "ASCL2 cnv",
    "ASCL2 methyl",
    "ASCL2 rna"
  ],
  "ASCL3": [
    "ASCL3 cnv"
  ],
  "ASCL4": [
    "ASCL4 cnv",
    "ASCL4 methyl",
    "ASCL4 rna"
  ],
  "ASCL5": [
    "ASCL5 cnv",
    "ASCL5 methyl",
    "ASCL5 rna"
  ],
  "ASDURF": [
    "ASDURF cnv",
    "ASDURF methyl",
    "ASDURF proteo",
    "ASDURF rna"
  ],
  "ASF1A": [
    "ASF1A cnv",
    "ASF1A proteo",
    "ASF1A rna"
  ],
  "ASF1B": [
    "ASF1B 198_198_1_1_S198 phospho",
    "ASF1B cnv",
    "ASF1B methyl",
    "ASF1B rna"
  ],
  "ASGR1": [
    "ASGR1 cnv",
    "ASGR1 rna"
  ],
  "ASGR2": [
    "ASGR2 cnv",
    "ASGR2 rna"
  ],
  "ASH1L": [
    "ASH1L 1659_1683_1_1_S1681 phospho",
    "ASH1L cnv",
    "ASH1L methyl",
    "ASH1L rna"
  ],
  "ASH2L": [
    "ASH2L 623_623_1_1_S623 phospho",
    "ASH2L cnv",
    "ASH2L methyl",
    "ASH2L proteo",
    "ASH2L rna"
  ],
  "ASIC1": [
    "ASIC1 cnv",
    "ASIC1 methyl",
    "ASIC1 rna"
  ],
  "ASIC2": [
    "ASIC2 cnv",
    "ASIC2 methyl",
    "ASIC2 rna"
  ],
  "ASIC3": [
    "ASIC3 cnv",
    "ASIC3 methyl",
    "ASIC3 rna"
  ],
  "ASIC4": [
    "ASIC4 155_155_1_1_S155 phospho",
    "ASIC4 cnv",
    "ASIC4 rna"
  ],
  "ASIC5": [
    "ASIC5 cnv"
  ],
  "ASIP": [
    "ASIP cnv",
    "ASIP rna"
  ],
  "ASL": [
    "ASL cnv",
    "ASL methyl",
    "ASL proteo",
    "ASL rna"
  ],
  "ASMT": [
    "ASMT rna"
  ],
  "ASMTL": [
    "ASMTL 165_191_1_1_S165 phospho",
    "ASMTL 170_191_1_1_S181 phospho",
    "ASMTL 197_211_1_1_S197 phospho",
    "ASMTL proteo",
    "ASMTL rna"
  ],
  "ASNS": [
    "ASNS cnv",
    "ASNS methyl",
    "ASNS proteo",
    "ASNS rna"
  ],
  "ASNSD1": [
    "ASNSD1 cnv",
    "ASNSD1 methyl",
    "ASNSD1 rna"
  ],
  "ASNSP1": [
    "ASNSP1 methyl"
  ],
  "ASPA": [
    "ASPA cnv",
    "ASPA methyl",
    "ASPA proteo",
    "ASPA rna"
  ],
  "ASPDH": [
    "ASPDH cnv",
    "ASPDH rna"
  ],
  "ASPG": [
    "ASPG cnv",
    "ASPG methyl",
    "ASPG rna"
  ],
  "ASPH": [
    "ASPH LVQLFPNDTSLK-N2H5F0S0G0 glyco",
    "ASPH LVQLFPNDTSLK-N2H6F0S0G0 glyco",
    "ASPH LVQLFPNDTSLK-N2H7F0S0G0 glyco",
    "ASPH LVQLFPNDTSLK-N2H8F0S0G0 glyco",
    "ASPH LVQLFPNDTSLK-N2H9F0S0G0 glyco",
    "ASPH YNLSEVLQGK-N2H5F0S0G0 glyco",
    "ASPH YNLSEVLQGK-N2H6F0S0G0 glyco",
    "ASPH cnv",
    "ASPH methyl",
    "ASPH proteo",
    "ASPH rna"
  ],
  "ASPHD1": [
    "ASPHD1 cnv",
    "ASPHD1 methyl",
    "ASPHD1 rna"
  ],
  "ASPHD2": [
    "ASPHD2 cnv",
    "ASPHD2 methyl",
    "ASPHD2 proteo",
    "ASPHD2 rna"
  ],
  "ASPM": [
    "ASPM 2782_2798_2_2_S2789Y2798 phospho",
    "ASPM cnv",
    "ASPM methyl",
    "ASPM rna"
  ],
  "ASPN": [
    "ASPN cnv",
    "ASPN proteo",
    "ASPN rna"
  ],
  "ASPRV1": [
    "ASPRV1 cnv",
    "ASPRV1 methyl",
    "ASPRV1 rna"
  ],
  "ASPSCR1": [
    "ASPSCR1 272_280_1_1_S275 phospho",
    "ASPSCR1 287_287_1_1_S287 phospho",
    "ASPSCR1 594_596_1_0 phospho",
    "ASPSCR1 594_596_1_1_S596 phospho",
    "ASPSCR1 cnv",
    "ASPSCR1 methyl",
    "ASPSCR1 proteo",
    "ASPSCR1 rna"
  ],
  "ASRGL1": [
    "ASRGL1 cnv",
    "ASRGL1 methyl",
    "ASRGL1 proteo",
    "ASRGL1 rna"
  ],
  "ASS1": [
    "ASS1 cnv",
    "ASS1 methyl",
    "ASS1 proteo",
    "ASS1 rna"
  ],
  "ASTE1": [
    "ASTE1 cnv",
    "ASTE1 methyl",
    "ASTE1 rna"
  ],
  "ASTL": [
    "ASTL cnv",
    "ASTL rna"
  ],
  "ASTN1": [
    "ASTN1 192_216_1_1_S216 phospho",
    "ASTN1 227_232_1_1_S227 phospho",
    "ASTN1 340_366_1_0 phospho",
    "ASTN1 376_379_2_2_S376S379 phospho",
    "ASTN1 AAPIYELVTNNQTQR-N2H8F0S0G0 glyco",
    "ASTN1 cnv",
    "ASTN1 proteo",
    "ASTN1 rna"
  ],
  "ASTN2": [
    "ASTN2 275_278_1_1_S278 phospho",
    "ASTN2 cnv",
    "ASTN2 methyl",
    "ASTN2 proteo",
    "ASTN2 rna"
  ],
  "ASXL1": [
    "ASXL1 440_453_1_1_S442 phospho",
    "ASXL1 cnv",
    "ASXL1 methyl",
    "ASXL1 rna"
  ],
  "ASXL2": [
    "ASXL2 136_148_1_1_S139 phospho",
    "ASXL2 218_235_1_1_S224 phospho",
    "ASXL2 393_397_1_1_S395 phospho",
    "ASXL2 570_580_1_1_S571 phospho",
    "ASXL2 627_637_1_1_S637 phospho",
    "ASXL2 cnv",
    "ASXL2 methyl",
    "ASXL2 rna"
  ],
  "ASXL3": [
    "ASXL3 cnv",
    "ASXL3 methyl",
    "ASXL3 rna"
  ],
  "ASZ1": [
    "ASZ1 cnv",
    "ASZ1 methyl"
  ],
  "ATAD1": [
    "ATAD1 314_322_1_1_S322 phospho",
    "ATAD1 cnv",
    "ATAD1 methyl",
    "ATAD1 proteo",
    "ATAD1 rna"
  ],
  "ATAD2": [
    "ATAD2 1149_1158_1_0 phospho",
    "ATAD2 322_327_1_1_S327 phospho",
    "ATAD2 cnv",
    "ATAD2 methyl",
    "ATAD2 proteo",
    "ATAD2 rna"
  ],
  "ATAD2B": [
    "ATAD2B cnv",
    "ATAD2B methyl",
    "ATAD2B rna"
  ],
  "ATAD3A": [
    "ATAD3A cnv",
    "ATAD3A methyl",
    "ATAD3A proteo",
    "ATAD3A rna"
  ],
  "ATAD3B": [
    "ATAD3B cnv",
    "ATAD3B methyl",
    "ATAD3B rna"
  ],
  "ATAD3C": [
    "ATAD3C cnv",
    "ATAD3C rna"
  ],
  "ATAD5": [
    "ATAD5 cnv",
    "ATAD5 methyl",
    "ATAD5 rna"
  ],
  "ATAT1": [
    "ATAT1 249_249_1_1_T249 phospho",
    "ATAT1 258_264_1_1_S260 phospho",
    "ATAT1 258_264_1_1_S264 phospho",
    "ATAT1 cnv",
    "ATAT1 proteo",
    "ATAT1 rna"
  ],
  "ATCAY": [
    "ATCAY cnv",
    "ATCAY methyl",
    "ATCAY proteo",
    "ATCAY rna"
  ],
  "ATE1": [
    "ATE1 cnv",
    "ATE1 methyl",
    "ATE1 proteo",
    "ATE1 rna"
  ],
  "ATE1-AS1": [
    "ATE1-AS1 methyl"
  ],
  "ATF1": [
    "ATF1 cnv",
    "ATF1 methyl",
    "ATF1 proteo",
    "ATF1 rna"
  ],
  "ATF2": [
    "ATF2 112_116_1_1_S112 phospho",
    "ATF2 62_73_1_1_T71 phospho",
    "ATF2 62_73_2_2_T69T71 phospho",
    "ATF2 cnv",
    "ATF2 methyl",
    "ATF2 proteo",
    "ATF2 rna"
  ],
  "ATF3": [
    "ATF3 162_162_1_1_T162 phospho",
    "ATF3 cnv",
    "ATF3 methyl",
    "ATF3 rna"
  ],
  "ATF4": [
    "ATF4 cnv",
    "ATF4 methyl",
    "ATF4 rna"
  ],
  "ATF5": [
    "ATF5 cnv",
    "ATF5 methyl",
    "ATF5 rna"
  ],
  "ATF6": [
    "ATF6 cnv",
    "ATF6 rna"
  ],
  "ATF6B": [
    "ATF6B cnv",
    "ATF6B rna"
  ],
  "ATF7": [
    "ATF7 cnv",
    "ATF7 methyl",
    "ATF7 proteo",
    "ATF7 rna"
  ],
  "ATF7-NPFF": [
    "ATF7-NPFF cnv",
    "ATF7-NPFF methyl",
    "ATF7-NPFF rna"
  ],
  "ATF7IP": [
    "ATF7IP 113_123_1_1_S113 phospho",
    "ATF7IP 113_123_2_2_S113T118 phospho",
    "ATF7IP 445_453_1_1_S445 phospho",
    "ATF7IP 473_479_1_1_S477 phospho",
    "ATF7IP 473_486_1_1_S477 phospho",
    "ATF7IP 557_567_1_0 phospho",
    "ATF7IP 557_567_1_1_S559 phospho",
    "ATF7IP 56_64_1_0 phospho",
    "ATF7IP 56_64_1_1_S57 phospho",
    "ATF7IP 673_673_1_1_S673 phospho",
    "ATF7IP 887_902_1_1_S899 phospho",
    "ATF7IP cnv",
    "ATF7IP proteo",
    "ATF7IP rna"
  ],
  "ATF7IP2": [
    "ATF7IP2 cnv",
    "ATF7IP2 methyl",
    "ATF7IP2 rna"
  ],
  "ATG10": [
    "ATG10 cnv",
    "ATG10 methyl",
    "ATG10 rna"
  ],
  "ATG101": [
    "ATG101 cnv",
    "ATG101 methyl",
    "ATG101 proteo",
    "ATG101 rna"
  ],
  "ATG12": [
    "ATG12 cnv",
    "ATG12 methyl",
    "ATG12 proteo",
    "ATG12 rna"
  ],
  "ATG13": [
    "ATG13 233_262_1_0 phospho",
    "ATG13 cnv",
    "ATG13 methyl",
    "ATG13 proteo",
    "ATG13 rna"
  ],
  "ATG14": [
    "ATG14 cnv",
    "ATG14 methyl",
    "ATG14 rna"
  ],
  "ATG16L1": [
    "ATG16L1 269_280_1_1_S269 phospho",
    "ATG16L1 287_304_1_1_S287 phospho",
    "ATG16L1 cnv",
    "ATG16L1 methyl",
    "ATG16L1 proteo",
    "ATG16L1 rna"
  ],
  "ATG16L2": [
    "ATG16L2 170_179_1_1_S172 phospho",
    "ATG16L2 cnv",
    "ATG16L2 methyl",
    "ATG16L2 rna"
  ],
  "ATG2A": [
    "ATG2A 1261_1275_1_1_S1263 phospho",
    "ATG2A 403_403_1_1_S403 phospho",
    "ATG2A cnv",
    "ATG2A methyl",
    "ATG2A proteo",
    "ATG2A rna"
  ],
  "ATG2B": [
    "ATG2B 1576_1589_1_1_S1583 phospho",
    "ATG2B 1576_1589_2_2_S1579S1583 phospho",
    "ATG2B 239_257_1_1_S255 phospho",
    "ATG2B 239_257_2_1_S255 phospho",
    "ATG2B cnv",
    "ATG2B methyl",
    "ATG2B proteo",
    "ATG2B rna"
  ],
  "ATG3": [
    "ATG3 cnv",
    "ATG3 methyl",
    "ATG3 proteo",
    "ATG3 rna"
  ],
  "ATG4A": [
    "ATG4A methyl",
    "ATG4A rna"
  ],
  "ATG4B": [
    "ATG4B cnv",
    "ATG4B methyl",
    "ATG4B proteo",
    "ATG4B rna"
  ],
  "ATG4C": [
    "ATG4C 451_452_1_1_S451 phospho",
    "ATG4C cnv",
    "ATG4C proteo",
    "ATG4C rna"
  ],
  "ATG4D": [
    "ATG4D cnv",
    "ATG4D methyl",
    "ATG4D rna"
  ],
  "ATG5": [
    "ATG5 cnv",
    "ATG5 methyl",
    "ATG5 proteo",
    "ATG5 rna"
  ],
  "ATG7": [
    "ATG7 cnv",
    "ATG7 methyl",
    "ATG7 proteo",
    "ATG7 rna"
  ],
  "ATG9A": [
    "ATG9A 14_33_1_1_S18 phospho",
    "ATG9A 670_675_1_0 phospho",
    "ATG9A 735_741_1_1_S735 phospho",
    "ATG9A 828_828_1_1_S828 phospho",
    "ATG9A cnv",
    "ATG9A methyl",
    "ATG9A proteo",
    "ATG9A rna"
  ],
  "ATG9B": [
    "ATG9B cnv",
    "ATG9B rna"
  ],
  "ATIC": [
    "ATIC cnv",
    "ATIC methyl",
    "ATIC proteo",
    "ATIC rna"
  ],
  "ATL1": [
    "ATL1 18_23_1_1_S23 phospho",
    "ATL1 18_23_2_2_S22S23 phospho",
    "ATL1 cnv",
    "ATL1 methyl",
    "ATL1 proteo",
    "ATL1 rna"
  ],
  "ATL2": [
    "ATL2 23_51_1_0 phospho",
    "ATL2 cnv",
    "ATL2 methyl",
    "ATL2 proteo",
    "ATL2 rna"
  ],
  "ATL3": [
    "ATL3 cnv",
    "ATL3 methyl",
    "ATL3 proteo",
    "ATL3 rna"
  ],
  "ATM": [
    "ATM 1883_1893_1_1_T1885 phospho",
    "ATM cnv",
    "ATM kinase",
    "ATM methyl",
    "ATM mut",
    "ATM proteo",
    "ATM rna"
  ],
  "ATMIN": [
    "ATMIN cnv",
    "ATMIN methyl",
    "ATMIN rna"
  ],
  "ATN1": [
    "ATN1 34_43_1_1_S34 phospho",
    "ATN1 630_639_1_1_S632 phospho",
    "ATN1 645_649_1_1_S645 phospho",
    "ATN1 651_664_1_1_S661 phospho",
    "ATN1 734_748_3_3_S739S746S748 phospho",
    "ATN1 73_84_1_1_S77 phospho",
    "ATN1 73_84_2_2_S77S79 phospho",
    "ATN1 896_896_1_1_S896 phospho",
    "ATN1 90_107_1_1_S101 phospho",
    "ATN1 cnv",
    "ATN1 methyl",
    "ATN1 proteo",
    "ATN1 rna"
  ],
  "ATOH1": [
    "ATOH1 cnv",
    "ATOH1 methyl",
    "ATOH1 rna"
  ],
  "ATOH7": [
    "ATOH7 cnv",
    "ATOH7 methyl",
    "ATOH7 rna"
  ],
  "ATOH8": [
    "ATOH8 cnv",
    "ATOH8 methyl",
    "ATOH8 rna"
  ],
  "ATOX1": [
    "ATOX1 61_64_1_1_S63 phospho",
    "ATOX1 cnv",
    "ATOX1 methyl",
    "ATOX1 proteo",
    "ATOX1 rna"
  ],
  "ATP10A": [
    "ATP10A cnv",
    "ATP10A methyl",
    "ATP10A rna"
  ],
  "ATP10B": [
    "ATP10B cnv",
    "ATP10B rna"
  ],
  "ATP10D": [
    "ATP10D cnv",
    "ATP10D rna"
  ],
  "ATP11A": [
    "ATP11A cnv",
    "ATP11A methyl",
    "ATP11A proteo",
    "ATP11A rna"
  ],
  "ATP11B": [
    "ATP11B cnv",
    "ATP11B methyl",
    "ATP11B proteo",
    "ATP11B rna"
  ],
  "ATP11C": [
    "ATP11C 1121_1126_1_1_S1123 phospho",
    "ATP11C methyl",
    "ATP11C proteo",
    "ATP11C rna"
  ],
  "ATP12A": [
    "ATP12A cnv",
    "ATP12A methyl",
    "ATP12A rna"
  ],
  "ATP13A1": [
    "ATP13A1 899_905_1_1_S899 phospho",
    "ATP13A1 cnv",
    "ATP13A1 methyl",
    "ATP13A1 proteo",
    "ATP13A1 rna"
  ],
  "ATP13A2": [
    "ATP13A2 cnv",
    "ATP13A2 methyl",
    "ATP13A2 proteo",
    "ATP13A2 rna"
  ],
  "ATP13A3": [
    "ATP13A3 817_824_1_1_S817 phospho",
    "ATP13A3 90_98_1_1_S98 phospho",
    "ATP13A3 cnv",
    "ATP13A3 methyl",
    "ATP13A3 proteo",
    "ATP13A3 rna"
  ],
  "ATP13A4": [
    "ATP13A4 cnv",
    "ATP13A4 methyl",
    "ATP13A4 rna"
  ],
  "ATP13A5": [
    "ATP13A5 cnv",
    "ATP13A5 rna"
  ],
  "ATP1A1": [
    "ATP1A1 216_239_1_1_S228 phospho",
    "ATP1A1 228_239_1_1_S228 phospho",
    "ATP1A1 40_47_1_1_S47 phospho",
    "ATP1A1 498_499_1_0 phospho",
    "ATP1A1 cnv",
    "ATP1A1 methyl",
    "ATP1A1 proteo",
    "ATP1A1 rna"
  ],
  "ATP1A1-AS1": [
    "ATP1A1-AS1 methyl"
  ],
  "ATP1A2": [
    "ATP1A2 445_452_1_1_S450 phospho",
    "ATP1A2 486_499_1_1_S496 phospho",
    "ATP1A2 496_499_1_1_S496 phospho",
    "ATP1A2 9_15_1_1_S10 phospho",
    "ATP1A2 cnv",
    "ATP1A2 proteo",
    "ATP1A2 rna"
  ],
  "ATP1A3": [
    "ATP1A3 208_208_1_1_S208 phospho",
    "ATP1A3 217_240_1_1_S229 phospho",
    "ATP1A3 464_467_1_1_S467 phospho",
    "ATP1A3 56_67_1_1_S67 phospho",
    "ATP1A3 cnv",
    "ATP1A3 methyl",
    "ATP1A3 proteo",
    "ATP1A3 rna"
  ],
  "ATP1A4": [
    "ATP1A4 cnv",
    "ATP1A4 rna"
  ],
  "ATP1B1": [
    "ATP1B1 LEWLGNCSGLNDETYGYK-N6H5F1S1G0 glyco",
    "ATP1B1 LEWLGNCSGLNDETYGYK-N6H5F2S1G0 glyco",
    "ATP1B1 VLGFKPKPPKNESLETYPVMK-N5H6F1S3G0 glyco",
    "ATP1B1 VLGFKPKPPKNESLETYPVMK-N5H6F2S3G0 glyco",
    "ATP1B1 VLGFKPKPPKNESLETYPVMK-N5H6F3S2G0 glyco",
    "ATP1B1 cnv",
    "ATP1B1 methyl",
    "ATP1B1 proteo",
    "ATP1B1 rna"
  ],
  "ATP1B2": [
    "ATP1B2 FHVNYTQPLVAVK-N2H5F0S0G0 glyco",
    "ATP1B2 FHVNYTQPLVAVK-N2H6F0S0G0 glyco",
    "ATP1B2 FHVNYTQPLVAVK-N2H7F0S0G0 glyco",
    "ATP1B2 FHVNYTQPLVAVK-N2H8F0S0G0 glyco",
    "ATP1B2 FHVNYTQPLVAVK-N2H9F0S0G0 glyco",
    "ATP1B2 FHVNYTQPLVAVK-N3H6F1S0G0 glyco",
    "ATP1B2 FLEPYNDSIQAQK-N2H10F0S0G0 glyco",
    "ATP1B2 FLEPYNDSIQAQK-N2H3F0S0G0 glyco",
    "ATP1B2 FLEPYNDSIQAQK-N2H4F0S0G0 glyco",
    "ATP1B2 FLEPYNDSIQAQK-N2H5F0S0G0 glyco",
    "ATP1B2 FLEPYNDSIQAQK-N2H6F0S0G0 glyco",
    "ATP1B2 FLEPYNDSIQAQK-N2H7F0S0G0 glyco",
    "ATP1B2 FLEPYNDSIQAQK-N2H8F0S0G0 glyco",
    "ATP1B2 FLEPYNDSIQAQK-N2H9F0S0G0 glyco",
    "ATP1B2 FLEPYNDSIQAQK-N3H4F0S0G0 glyco",
    "ATP1B2 FLEPYNDSIQAQK-N3H5F0S0G0 glyco",
    "ATP1B2 FLEPYNDSIQAQK-N3H5F1S0G0 glyco",
    "ATP1B2 FLEPYNDSIQAQK-N3H6F0S0G0 glyco",
    "ATP1B2 FLEPYNDSIQAQK-N3H6F0S1G0 glyco",
    "ATP1B2 FLEPYNDSIQAQK-N3H6F1S0G0 glyco",
    "ATP1B2 FLEPYNDSIQAQK-N4H3F0S2G0 glyco",
    "ATP1B2 FLEPYNDSIQAQK-N4H5F0S0G0 glyco",
    "ATP1B2 FLNVTPNVEVNVECR-N2H9F0S0G0 glyco",
    "ATP1B2 FLNVTPNVEVNVECR-N5H3F1S0G0 glyco",
    "ATP1B2 FLNVTPNVEVNVECR-N5H5F2S1G0 glyco",
    "ATP1B2 FLNVTPNVEVNVECR-N5H6F1S1G0 glyco",
    "ATP1B2 FLNVTPNVEVNVECR-N5H6F3S1G0 glyco",
    "ATP1B2 FLNVTPNVEVNVECR-N6H4F1S0G0 glyco",
    "ATP1B2 KFHVNYTQPLVAVK-N2H5F0S0G0 glyco",
    "ATP1B2 KFHVNYTQPLVAVK-N2H6F0S0G0 glyco",
    "ATP1B2 KFHVNYTQPLVAVK-N2H7F0S0G0 glyco",
    "ATP1B2 KFHVNYTQPLVAVK-N2H8F0S0G0 glyco",
    "ATP1B2 TENLDVIVNVSDTESWDQHVQK-N2H5F0S0G0 glyco",
    "ATP1B2 TENLDVIVNVSDTESWDQHVQK-N2H6F0S0G0 glyco",
    "ATP1B2 TENLDVIVNVSDTESWDQHVQK-N2H7F0S0G0 glyco",
    "ATP1B2 TQLGNCSGIGDSTHYGYSTGQPCVFIK-N2H5F0S0G0 glyco",
    "ATP1B2 TQLGNCSGIGDSTHYGYSTGQPCVFIK-N2H9F0S0G0 glyco",
    "ATP1B2 TQLGNCSGIGDSTHYGYSTGQPCVFIK-N5H4F2S0G0 glyco",
    "ATP1B2 VINFYAGANQSMNVTCAGK-N4H4F0S1G0 glyco",
    "ATP1B2 cnv",
    "ATP1B2 methyl",
    "ATP1B2 proteo",
    "ATP1B2 rna"
  ],
  "ATP1B3": [
    "ATP1B3 NLTVCPDGALFEQK-N4H5F1S1G0 glyco",
    "ATP1B3 NLTVCPDGALFEQK-N4H5F1S2G0 glyco",
    "ATP1B3 cnv",
    "ATP1B3 methyl",
    "ATP1B3 proteo",
    "ATP1B3 rna"
  ],
  "ATP1B4": [
    "ATP1B4 rna"
  ],
  "ATP23": [
    "ATP23 cnv",
    "ATP23 proteo",
    "ATP23 rna"
  ],
  "ATP2A1": [
    "ATP2A1 cnv",
    "ATP2A1 methyl",
    "ATP2A1 rna"
  ],
  "ATP2A1-AS1": [
    "ATP2A1-AS1 methyl"
  ],
  "ATP2A2": [
    "ATP2A2 cnv",
    "ATP2A2 methyl",
    "ATP2A2 proteo",
    "ATP2A2 rna"
  ],
  "ATP2A3": [
    "ATP2A3 cnv",
    "ATP2A3 methyl",
    "ATP2A3 rna"
  ],
  "ATP2B1": [
    "ATP2B1 1155_1173_1_1_S1155 phospho",
    "ATP2B1 1177_1182_1_0 phospho",
    "ATP2B1 1177_1182_1_1_S1178 phospho",
    "ATP2B1 1177_1182_2_2_S1177S1178 phospho",
    "ATP2B1 1177_1182_2_2_S1178S1182 phospho",
    "ATP2B1 cnv",
    "ATP2B1 methyl",
    "ATP2B1 proteo",
    "ATP2B1 rna"
  ],
  "ATP2B2": [
    "ATP2B2 1116_1132_1_1_S1116 phospho",
    "ATP2B2 1116_1132_1_1_S1117 phospho",
    "ATP2B2 1135_1145_1_0 phospho",
    "ATP2B2 1135_1145_1_1_S1142 phospho",
    "ATP2B2 1162_1163_1_1_S1163 phospho",
    "ATP2B2 1178_1205_1_0 phospho",
    "ATP2B2 1200_1205_1_1_S1201 phospho",
    "ATP2B2 18_27_1_0 phospho",
    "ATP2B2 18_27_1_1_S18 phospho",
    "ATP2B2 cnv",
    "ATP2B2 methyl",
    "ATP2B2 proteo",
    "ATP2B2 rna"
  ],
  "ATP2B3": [
    "ATP2B3 methyl",
    "ATP2B3 proteo",
    "ATP2B3 rna"
  ],
  "ATP2B4": [
    "ATP2B4 1102_1115_1_1_S1115 phospho",
    "ATP2B4 1126_1132_1_1_S1126 phospho",
    "ATP2B4 1126_1145_1_1_T1145 phospho",
    "ATP2B4 1126_1160_1_1_T1145 phospho",
    "ATP2B4 1136_1139_1_1_S1138 phospho",
    "ATP2B4 1136_1168_1_0 phospho",
    "ATP2B4 1147_1168_1_0 phospho",
    "ATP2B4 1147_1168_1_1_S1158 phospho",
    "ATP2B4 1174_1204_1_0 phospho",
    "ATP2B4 13_17_1_1_S13 phospho",
    "ATP2B4 315_328_1_1_S328 phospho",
    "ATP2B4 cnv",
    "ATP2B4 methyl",
    "ATP2B4 proteo",
    "ATP2B4 rna"
  ],
  "ATP2C1": [
    "ATP2C1 cnv",
    "ATP2C1 methyl",
    "ATP2C1 proteo",
    "ATP2C1 rna"
  ],
  "ATP2C2": [
    "ATP2C2 cnv",
    "ATP2C2 methyl",
    "ATP2C2 rna"
  ],
  "ATP4A": [
    "ATP4A cnv",
    "ATP4A methyl",
    "ATP4A rna"
  ],
  "ATP4B": [
    "ATP4B cnv",
    "ATP4B rna"
  ],
  "ATP5F1A": [
    "ATP5F1A cnv",
    "ATP5F1A methyl",
    "ATP5F1A proteo",
    "ATP5F1A rna"
  ],
  "ATP5F1B": [
    "ATP5F1B 415_418_1_1_S415 phospho",
    "ATP5F1B 528_529_1_0 phospho",
    "ATP5F1B cnv",
    "ATP5F1B methyl",
    "ATP5F1B proteo",
    "ATP5F1B rna"
  ],
  "ATP5F1C": [
    "ATP5F1C cnv",
    "ATP5F1C methyl",
    "ATP5F1C proteo",
    "ATP5F1C rna"
  ],
  "ATP5F1D": [
    "ATP5F1D cnv",
    "ATP5F1D methyl",
    "ATP5F1D proteo",
    "ATP5F1D rna"
  ],
  "ATP5F1E": [
    "ATP5F1E cnv",
    "ATP5F1E methyl",
    "ATP5F1E rna"
  ],
  "ATP5IF1": [
    "ATP5IF1 cnv",
    "ATP5IF1 methyl",
    "ATP5IF1 proteo",
    "ATP5IF1 rna"
  ],
  "ATP5MC1": [
    "ATP5MC1 cnv",
    "ATP5MC1 methyl",
    "ATP5MC1 rna"
  ],
  "ATP5MC2": [
    "ATP5MC2 cnv",
    "ATP5MC2 methyl",
    "ATP5MC2 rna"
  ],
  "ATP5MC3": [
    "ATP5MC3 cnv",
    "ATP5MC3 methyl",
    "ATP5MC3 rna"
  ],
  "ATP5ME": [
    "ATP5ME cnv",
    "ATP5ME methyl",
    "ATP5ME proteo",
    "ATP5ME rna"
  ],
  "ATP5MF": [
    "ATP5MF cnv",
    "ATP5MF proteo",
    "ATP5MF rna"
  ],
  "ATP5MF-PTCD1": [
    "ATP5MF-PTCD1 cnv",
    "ATP5MF-PTCD1 rna"
  ],
  "ATP5MG": [
    "ATP5MG cnv",
    "ATP5MG methyl",
    "ATP5MG proteo",
    "ATP5MG rna"
  ],
  "ATP5MGL": [
    "ATP5MGL cnv",
    "ATP5MGL rna"
  ],
  "ATP5MJ": [
    "ATP5MJ cnv",
    "ATP5MJ methyl",
    "ATP5MJ proteo",
    "ATP5MJ rna"
  ],
  "ATP5MK": [
    "ATP5MK cnv",
    "ATP5MK methyl",
    "ATP5MK proteo",
    "ATP5MK rna"
  ],
  "ATP5PB": [
    "ATP5PB cnv",
    "ATP5PB methyl",
    "ATP5PB proteo",
    "ATP5PB rna"
  ],
  "ATP5PD": [
    "ATP5PD cnv",
    "ATP5PD methyl",
    "ATP5PD proteo",
    "ATP5PD rna"
  ],
  "ATP5PF": [
    "ATP5PF cnv",
    "ATP5PF methyl",
    "ATP5PF proteo",
    "ATP5PF rna"
  ],
  "ATP5PO": [
    "ATP5PO cnv",
    "ATP5PO methyl",
    "ATP5PO proteo",
    "ATP5PO rna"
  ],
  "ATP6AP1": [
    "ATP6AP1 463_467_1_1_S465 phospho",
    "ATP6AP1 LNASLPALLLIR-N2H6F0S0G0 glyco",
    "ATP6AP1 QPVSPVIHPPVSYNDTAPR-N2H8F0S0G0 glyco",
    "ATP6AP1 QPVSPVIHPPVSYNDTAPR-N5H3F1S0G0 glyco",
    "ATP6AP1 methyl",
    "ATP6AP1 proteo",
    "ATP6AP1 rna"
  ],
  "ATP6AP1-DT": [
    "ATP6AP1-DT methyl"
  ],
  "ATP6AP2": [
    "ATP6AP2 methyl",
    "ATP6AP2 proteo",
    "ATP6AP2 rna"
  ],
  "ATP6V0A1": [
    "ATP6V0A1 670_670_1_1_T670 phospho",
    "ATP6V0A1 cnv",
    "ATP6V0A1 methyl",
    "ATP6V0A1 proteo",
    "ATP6V0A1 rna"
  ],
  "ATP6V0A2": [
    "ATP6V0A2 695_704_1_1_S695 phospho",
    "ATP6V0A2 cnv",
    "ATP6V0A2 methyl",
    "ATP6V0A2 proteo",
    "ATP6V0A2 rna"
  ],
  "ATP6V0A4": [
    "ATP6V0A4 cnv",
    "ATP6V0A4 rna"
  ],
  "ATP6V0B": [
    "ATP6V0B cnv",
    "ATP6V0B methyl",
    "ATP6V0B rna"
  ],
  "ATP6V0C": [
    "ATP6V0C cnv",
    "ATP6V0C methyl",
    "ATP6V0C rna"
  ],
  "ATP6V0D1": [
    "ATP6V0D1 cnv",
    "ATP6V0D1 methyl",
    "ATP6V0D1 proteo",
    "ATP6V0D1 rna"
  ],
  "ATP6V0D2": [
    "ATP6V0D2 cnv",
    "ATP6V0D2 rna"
  ],
  "ATP6V0E1": [
    "ATP6V0E1 cnv",
    "ATP6V0E1 methyl",
    "ATP6V0E1 rna"
  ],
  "ATP6V0E2": [
    "ATP6V0E2 cnv",
    "ATP6V0E2 methyl",
    "ATP6V0E2 rna"
  ],
  "ATP6V0E2-AS1": [
    "ATP6V0E2-AS1 methyl"
  ],
  "ATP6V1A": [
    "ATP6V1A cnv",
    "ATP6V1A methyl",
    "ATP6V1A proteo",
    "ATP6V1A rna"
  ],
  "ATP6V1B1": [
    "ATP6V1B1 cnv",
    "ATP6V1B1 methyl",
    "ATP6V1B1 rna"
  ],
  "ATP6V1B2": [
    "ATP6V1B2 cnv",
    "ATP6V1B2 methyl",
    "ATP6V1B2 proteo",
    "ATP6V1B2 rna"
  ],
  "ATP6V1C1": [
    "ATP6V1C1 cnv",
    "ATP6V1C1 proteo",
    "ATP6V1C1 rna"
  ],
  "ATP6V1C2": [
    "ATP6V1C2 cnv",
    "ATP6V1C2 methyl",
    "ATP6V1C2 rna"
  ],
  "ATP6V1D": [
    "ATP6V1D cnv",
    "ATP6V1D methyl",
    "ATP6V1D proteo",
    "ATP6V1D rna"
  ],
  "ATP6V1E1": [
    "ATP6V1E1 cnv",
    "ATP6V1E1 methyl",
    "ATP6V1E1 proteo",
    "ATP6V1E1 rna"
  ],
  "ATP6V1E2": [
    "ATP6V1E2 cnv",
    "ATP6V1E2 methyl",
    "ATP6V1E2 rna"
  ],
  "ATP6V1F": [
    "ATP6V1F cnv",
    "ATP6V1F methyl",
    "ATP6V1F proteo",
    "ATP6V1F rna"
  ],
  "ATP6V1FNB": [
    "ATP6V1FNB cnv",
    "ATP6V1FNB rna"
  ],
  "ATP6V1G1": [
    "ATP6V1G1 cnv",
    "ATP6V1G1 methyl",
    "ATP6V1G1 proteo",
    "ATP6V1G1 rna"
  ],
  "ATP6V1G2": [
    "ATP6V1G2 cnv",
    "ATP6V1G2 proteo",
    "ATP6V1G2 rna"
  ],
  "ATP6V1G2-DDX39B": [
    "ATP6V1G2-DDX39B cnv",
    "ATP6V1G2-DDX39B rna"
  ],
  "ATP6V1G3": [
    "ATP6V1G3 cnv"
  ],
  "ATP6V1H": [
    "ATP6V1H 473_483_1_1_S483 phospho",
    "ATP6V1H cnv",
    "ATP6V1H methyl",
    "ATP6V1H proteo",
    "ATP6V1H rna"
  ],
  "ATP7A": [
    "ATP7A 262_280_1_1_S270 phospho",
    "ATP7A 270_280_1_1_S270 phospho",
    "ATP7A methyl",
    "ATP7A proteo",
    "ATP7A rna"
  ],
  "ATP7B": [
    "ATP7B cnv",
    "ATP7B methyl",
    "ATP7B rna"
  ],
  "ATP8A1": [
    "ATP8A1 21_29_1_1_S29 phospho",
    "ATP8A1 21_29_3_3_S25T28S29 phospho",
    "ATP8A1 28_29_1_1_S29 phospho",
    "ATP8A1 425_450_1_1_S443 phospho",
    "ATP8A1 cnv",
    "ATP8A1 methyl",
    "ATP8A1 proteo",
    "ATP8A1 rna"
  ],
  "ATP8A2": [
    "ATP8A2 433_435_1_1_S435 phospho",
    "ATP8A2 5_6_1_1_S6 phospho",
    "ATP8A2 cnv",
    "ATP8A2 methyl",
    "ATP8A2 proteo",
    "ATP8A2 rna"
  ],
  "ATP8B1": [
    "ATP8B1 cnv",
    "ATP8B1 methyl",
    "ATP8B1 rna"
  ],
  "ATP8B1-AS1": [
    "ATP8B1-AS1 methyl"
  ],
  "ATP8B2": [
    "ATP8B2 cnv",
    "ATP8B2 methyl",
    "ATP8B2 rna"
  ],
  "ATP8B3": [
    "ATP8B3 cnv",
    "ATP8B3 methyl",
    "ATP8B3 rna"
  ],
  "ATP8B4": [
    "ATP8B4 cnv",
    "ATP8B4 methyl",
    "ATP8B4 rna"
  ],
  "ATP9A": [
    "ATP9A cnv",
    "ATP9A methyl",
    "ATP9A proteo",
    "ATP9A rna"
  ],
  "ATP9B": [
    "ATP9B cnv",
    "ATP9B methyl",
    "ATP9B proteo",
    "ATP9B rna"
  ],
  "ATPAF1": [
    "ATPAF1 cnv",
    "ATPAF1 methyl",
    "ATPAF1 proteo",
    "ATPAF1 rna"
  ],
  "ATPAF2": [
    "ATPAF2 cnv",
    "ATPAF2 methyl",
    "ATPAF2 proteo",
    "ATPAF2 rna"
  ],
  "ATPSCKMT": [
    "ATPSCKMT cnv",
    "ATPSCKMT methyl",
    "ATPSCKMT rna"
  ],
  "ATR": [
    "ATR 435_441_1_1_S435 phospho",
    "ATR cnv",
    "ATR kinase",
    "ATR methyl",
    "ATR proteo",
    "ATR rna"
  ],
  "ATRAID": [
    "ATRAID cnv",
    "ATRAID methyl",
    "ATRAID rna"
  ],
  "ATRIP": [
    "ATRIP 92_97_1_1_S97 phospho",
    "ATRIP cnv",
    "ATRIP methyl",
    "ATRIP rna"
  ],
  "ATRN": [
    "ATRN CENLTTGK-N2H5F0S0G0 glyco",
    "ATRN CENLTTGK-N4H5F0S1G0 glyco",
    "ATRN CENLTTGK-N4H5F0S2G0 glyco",
    "ATRN CINQSICEK-N4H5F0S2G0 glyco",
    "ATRN IDSTGNVTNELR-N2H5F0S0G0 glyco",
    "ATRN IDSTGNVTNELR-N2H6F0S0G0 glyco",
    "ATRN IDSTGNVTNELR-N2H7F0S0G0 glyco",
    "ATRN IDSTGNVTNELR-N2H8F0S0G0 glyco",
    "ATRN IDSTGNVTNELR-N2H9F0S0G0 glyco",
    "ATRN VFHIHNESWVLLTPK-N2H5F0S0G0 glyco",
    "ATRN VFHIHNESWVLLTPK-N2H6F0S0G0 glyco",
    "ATRN cnv",
    "ATRN methyl",
    "ATRN proteo",
    "ATRN rna"
  ],
  "ATRNL1": [
    "ATRNL1 cnv",
    "ATRNL1 methyl",
    "ATRNL1 proteo",
    "ATRNL1 rna"
  ],
  "ATRX": [
    "ATRX 1230_1251_1_1_S1245 phospho",
    "ATRX 1346_1352_1_1_S1348 phospho",
    "ATRX 1346_1352_2_2_S1348S1352 phospho",
    "ATRX 1989_2002_1_1_S1996 phospho",
    "ATRX 1989_2002_2_2_S1992S1996 phospho",
    "ATRX 203_213_1_1_S213 phospho",
    "ATRX 25_34_1_1_S25 phospho",
    "ATRX 309_316_1_1_S316 phospho",
    "ATRX 661_684_1_1_S677 phospho",
    "ATRX 668_684_1_1_S677 phospho",
    "ATRX 745_759_1_1_S750 phospho",
    "ATRX 810_819_1_1_S819 phospho",
    "ATRX 89_120_1_1_S92 phospho",
    "ATRX methyl",
    "ATRX mut",
    "ATRX proteo",
    "ATRX rna"
  ],
  "ATXN1": [
    "ATXN1 775_779_1_1_S775 phospho",
    "ATXN1 82_91_1_1_S88 phospho",
    "ATXN1 cnv",
    "ATXN1 methyl",
    "ATXN1 proteo",
    "ATXN1 rna"
  ],
  "ATXN10": [
    "ATXN10 cnv",
    "ATXN10 methyl",
    "ATXN10 proteo",
    "ATXN10 rna"
  ],
  "ATXN1L": [
    "ATXN1L 284_292_1_1_S284 phospho",
    "ATXN1L 284_292_2_2_S284S289 phospho",
    "ATXN1L 449_467_1_1_T456 phospho",
    "ATXN1L cnv",
    "ATXN1L methyl",
    "ATXN1L proteo",
    "ATXN1L rna"
  ],
  "ATXN2": [
    "ATXN2 466_466_1_1_S466 phospho",
    "ATXN2 528_541_1_1_S530 phospho",
    "ATXN2 554_565_1_1_S558 phospho",
    "ATXN2 616_624_1_1_S624 phospho",
    "ATXN2 666_678_1_1_S667 phospho",
    "ATXN2 697_736_1_1_S728 phospho",
    "ATXN2 771_776_1_1_S772 phospho",
    "ATXN2 784_788_1_1_S784 phospho",
    "ATXN2 843_872_1_1_S861 phospho",
    "ATXN2 843_872_1_1_S865 phospho",
    "ATXN2 843_872_2_2_S861S865 phospho",
    "ATXN2 843_872_3_0 phospho",
    "ATXN2 881_889_1_1_S889 phospho",
    "ATXN2 cnv",
    "ATXN2 methyl",
    "ATXN2 proteo",
    "ATXN2 rna"
  ],
  "ATXN2-AS": [
    "ATXN2-AS methyl"
  ],
  "ATXN2L": [
    "ATXN2L 103_121_1_1_S103 phospho",
    "ATXN2L 111_121_1_1_S111 phospho",
    "ATXN2L 31_67_1_0 phospho",
    "ATXN2L 31_67_1_1_S32 phospho",
    "ATXN2L 421_434_1_1_S424 phospho",
    "ATXN2L 452_496_1_1_S496 phospho",
    "ATXN2L 557_563_1_1_S559 phospho",
    "ATXN2L 588_598_1_1_S594 phospho",
    "ATXN2L 600_634_1_0 phospho",
    "ATXN2L 615_634_1_0 phospho",
    "ATXN2L 615_634_1_1_S634 phospho",
    "ATXN2L cnv",
    "ATXN2L methyl",
    "ATXN2L proteo",
    "ATXN2L rna"
  ],
  "ATXN3": [
    "ATXN3 250_263_1_1_S250 phospho",
    "ATXN3 cnv",
    "ATXN3 proteo",
    "ATXN3 rna"
  ],
  "ATXN7": [
    "ATXN7 cnv",
    "ATXN7 methyl",
    "ATXN7 rna"
  ],
  "ATXN7L1": [
    "ATXN7L1 cnv",
    "ATXN7L1 methyl",
    "ATXN7L1 rna"
  ],
  "ATXN7L2": [
    "ATXN7L2 cnv",
    "ATXN7L2 methyl",
    "ATXN7L2 rna"
  ],
  "ATXN7L3": [
    "ATXN7L3 277_288_1_1_S281 phospho",
    "ATXN7L3 cnv",
    "ATXN7L3 methyl",
    "ATXN7L3 proteo",
    "ATXN7L3 rna"
  ],
  "ATXN7L3B": [
    "ATXN7L3B 76_92_1_1_S92 phospho",
    "ATXN7L3B cnv",
    "ATXN7L3B methyl",
    "ATXN7L3B proteo",
    "ATXN7L3B rna"
  ],
  "AUH": [
    "AUH cnv",
    "AUH methyl",
    "AUH proteo",
    "AUH rna"
  ],
  "AUNIP": [
    "AUNIP cnv",
    "AUNIP methyl",
    "AUNIP rna"
  ],
  "AUP1": [
    "AUP1 cnv",
    "AUP1 methyl",
    "AUP1 proteo",
    "AUP1 rna"
  ],
  "AURKA": [
    "AURKA cnv",
    "AURKA kinase",
    "AURKA methyl",
    "AURKA rna"
  ],
  "AURKAIP1": [
    "AURKAIP1 cnv",
    "AURKAIP1 methyl",
    "AURKAIP1 proteo",
    "AURKAIP1 rna"
  ],
  "AURKB": [
    "AURKB cnv",
    "AURKB kinase",
    "AURKB methyl",
    "AURKB rna"
  ],
  "AURKC": [
    "AURKC cnv",
    "AURKC kinase",
    "AURKC methyl",
    "AURKC rna"
  ],
  "AUTS2": [
    "AUTS2 1174_1176_1_1_S1174 phospho",
    "AUTS2 1187_1209_1_1_S1209 phospho",
    "AUTS2 319_319_1_1_S319 phospho",
    "AUTS2 cnv",
    "AUTS2 methyl",
    "AUTS2 proteo",
    "AUTS2 rna"
  ],
  "AVEN": [
    "AVEN cnv",
    "AVEN methyl",
    "AVEN proteo",
    "AVEN rna"
  ],
  "AVIL": [
    "AVIL cnv",
    "AVIL rna"
  ],
  "AVL9": [
    "AVL9 244_276_1_1_S244 phospho",
    "AVL9 312_337_1_1_S323 phospho",
    "AVL9 580_586_1_1_S582 phospho",
    "AVL9 580_586_1_1_S586 phospho",
    "AVL9 cnv",
    "AVL9 methyl",
    "AVL9 proteo",
    "AVL9 rna"
  ],
  "AVP": [
    "AVP cnv",
    "AVP rna"
  ],
  "AVPI1": [
    "AVPI1 cnv",
    "AVPI1 methyl",
    "AVPI1 rna"
  ],
  "AVPR1A": [
    "AVPR1A cnv",
    "AVPR1A methyl",
    "AVPR1A rna"
  ],
  "AVPR1B": [
    "AVPR1B cnv",
    "AVPR1B methyl",
    "AVPR1B rna"
  ],
  "AVPR2": [
    "AVPR2 rna"
  ],
  "AWAT1": [
    "AWAT1 rna"
  ],
  "AWAT2": [
    "AWAT2 rna"
  ],
  "AXDND1": [
    "AXDND1 cnv",
    "AXDND1 methyl",
    "AXDND1 rna"
  ],
  "AXIN1": [
    "AXIN1 481_496_2_2_S486S493 phospho",
    "AXIN1 486_496_1_0 phospho",
    "AXIN1 cnv",
    "AXIN1 methyl",
    "AXIN1 rna"
  ],
  "AXIN2": [
    "AXIN2 449_461_1_1_S461 phospho",
    "AXIN2 cnv",
    "AXIN2 methyl",
    "AXIN2 rna"
  ],
  "AXL": [
    "AXL cnv",
    "AXL kinase",
    "AXL methyl",
    "AXL proteo",
    "AXL rna"
  ],
  "AZGP1": [
    "AZGP1 DIVEYYNDSNGSHVLQGR-N4H5F0S2G0 glyco",
    "AZGP1 DIVEYYNDSNGSHVLQGR-N4H5F1S2G0 glyco",
    "AZGP1 FGCEIENNR-N3H4F0S1G0 glyco",
    "AZGP1 FGCEIENNR-N4H5F0S1G0 glyco",
    "AZGP1 FGCEIENNR-N4H5F0S2G0 glyco",
    "AZGP1 cnv",
    "AZGP1 proteo",
    "AZGP1 rna"
  ],
  "AZI2": [
    "AZI2 186_189_1_1_S188 phospho",
    "AZI2 cnv",
    "AZI2 methyl",
    "AZI2 proteo",
    "AZI2 rna"
  ],
  "AZIN1": [
    "AZIN1 cnv",
    "AZIN1 methyl",
    "AZIN1 rna"
  ],
  "AZIN2": [
    "AZIN2 cnv",
    "AZIN2 methyl",
    "AZIN2 rna"
  ],
  "AZU1": [
    "AZU1 cnv",
    "AZU1 proteo",
    "AZU1 rna"
  ],
  "B2M": [
    "B2M cnv",
    "B2M methyl",
    "B2M proteo",
    "B2M rna"
  ],
  "B3GALNT1": [
    "B3GALNT1 cnv",
    "B3GALNT1 methyl",
    "B3GALNT1 rna"
  ],
  "B3GALNT2": [
    "B3GALNT2 cnv",
    "B3GALNT2 methyl",
    "B3GALNT2 rna"
  ],
  "B3GALT1": [
    "B3GALT1 cnv",
    "B3GALT1 methyl",
    "B3GALT1 rna"
  ],
  "B3GALT2": [
    "B3GALT2 cnv",
    "B3GALT2 rna"
  ],
  "B3GALT4": [
    "B3GALT4 cnv",
    "B3GALT4 methyl",
    "B3GALT4 rna"
  ],
  "B3GALT5": [
    "B3GALT5 cnv",
    "B3GALT5 methyl",
    "B3GALT5 rna"
  ],
  "B3GALT6": [
    "B3GALT6 cnv",
    "B3GALT6 methyl",
    "B3GALT6 proteo",
    "B3GALT6 rna"
  ],
  "B3GALT9": [
    "B3GALT9 cnv",
    "B3GALT9 methyl",
    "B3GALT9 rna"
  ],
  "B3GAT1": [
    "B3GAT1 cnv",
    "B3GAT1 methyl",
    "B3GAT1 rna"
  ],
  "B3GAT2": [
    "B3GAT2 cnv",
    "B3GAT2 methyl",
    "B3GAT2 rna"
  ],
  "B3GAT3": [
    "B3GAT3 cnv",
    "B3GAT3 methyl",
    "B3GAT3 proteo",
    "B3GAT3 rna"
  ],
  "B3GLCT": [
    "B3GLCT cnv",
    "B3GLCT methyl",
    "B3GLCT proteo",
    "B3GLCT rna"
  ],
  "B3GNT2": [
    "B3GNT2 cnv",
    "B3GNT2 methyl",
    "B3GNT2 rna"
  ],
  "B3GNT3": [
    "B3GNT3 cnv",
    "B3GNT3 rna"
  ],
  "B3GNT4": [
    "B3GNT4 cnv",
    "B3GNT4 methyl",
    "B3GNT4 rna"
  ],
  "B3GNT5": [
    "B3GNT5 cnv",
    "B3GNT5 methyl",
    "B3GNT5 rna"
  ],
  "B3GNT6": [
    "B3GNT6 cnv",
    "B3GNT6 rna"
  ],
  "B3GNT7": [
    "B3GNT7 cnv",
    "B3GNT7 methyl",
    "B3GNT7 rna"
  ],
  "B3GNT8": [
    "B3GNT8 cnv",
    "B3GNT8 rna"
  ],
  "B3GNT9": [
    "B3GNT9 cnv",
    "B3GNT9 methyl",
    "B3GNT9 rna"
  ],
  "B3GNTL1": [
    "B3GNTL1 cnv",
    "B3GNTL1 methyl",
    "B3GNTL1 rna"
  ],
  "B4GALNT1": [
    "B4GALNT1 cnv",
    "B4GALNT1 methyl",
    "B4GALNT1 proteo",
    "B4GALNT1 rna"
  ],
  "B4GALNT2": [
    "B4GALNT2 cnv",
    "B4GALNT2 methyl",
    "B4GALNT2 rna"
  ],
  "B4GALNT3": [
    "B4GALNT3 cnv",
    "B4GALNT3 methyl",
    "B4GALNT3 rna"
  ],
  "B4GALNT4": [
    "B4GALNT4 cnv",
    "B4GALNT4 methyl",
    "B4GALNT4 proteo",
    "B4GALNT4 rna"
  ],
  "B4GALT1": [
    "B4GALT1 cnv",
    "B4GALT1 methyl",
    "B4GALT1 proteo",
    "B4GALT1 rna"
  ],
  "B4GALT2": [
    "B4GALT2 cnv",
    "B4GALT2 methyl",
    "B4GALT2 rna"
  ],
  "B4GALT3": [
    "B4GALT3 cnv",
    "B4GALT3 methyl",
    "B4GALT3 proteo",
    "B4GALT3 rna"
  ],
  "B4GALT4": [
    "B4GALT4 cnv",
    "B4GALT4 methyl",
    "B4GALT4 proteo",
    "B4GALT4 rna"
  ],
  "B4GALT5": [
    "B4GALT5 cnv",
    "B4GALT5 methyl",
    "B4GALT5 rna"
  ],
  "B4GALT6": [
    "B4GALT6 cnv",
    "B4GALT6 methyl",
    "B4GALT6 rna"
  ],
  "B4GALT7": [
    "B4GALT7 cnv",
    "B4GALT7 methyl",
    "B4GALT7 rna"
  ],
  "B4GAT1": [
    "B4GAT1 cnv",
    "B4GAT1 methyl",
    "B4GAT1 proteo",
    "B4GAT1 rna"
  ],
  "B4GAT1-DT": [
    "B4GAT1-DT methyl"
  ],
  "B9D1": [
    "B9D1 cnv",
    "B9D1 methyl",
    "B9D1 proteo",
    "B9D1 rna"
  ],
  "B9D2": [
    "B9D2 cnv",
    "B9D2 methyl",
    "B9D2 proteo",
    "B9D2 rna"
  ],
  "BAALC": [
    "BAALC cnv",
    "BAALC methyl",
    "BAALC proteo",
    "BAALC rna"
  ],
  "BAALC-AS1": [
    "BAALC-AS1 methyl"
  ],
  "BAAT": [
    "BAAT cnv",
    "BAAT rna"
  ],
  "BABAM1": [
    "BABAM1 27_29_1_1_S29 phospho",
    "BABAM1 44_66_1_1_S49 phospho",
    "BABAM1 49_66_1_1_S66 phospho",
    "BABAM1 cnv",
    "BABAM1 proteo",
    "BABAM1 rna"
  ],
  "BABAM2": [
    "BABAM2 cnv",
    "BABAM2 methyl",
    "BABAM2 proteo",
    "BABAM2 rna"
  ],
  "BACE1": [
    "BACE1 cnv",
    "BACE1 methyl",
    "BACE1 proteo",
    "BACE1 rna"
  ],
  "BACE2": [
    "BACE2 cnv",
    "BACE2 methyl",
    "BACE2 rna"
  ],
  "BACH1": [
    "BACH1 196_209_1_1_S196 phospho",
    "BACH1 cnv",
    "BACH1 methyl",
    "BACH1 proteo",
    "BACH1 rna"
  ],
  "BACH2": [
    "BACH2 315_321_1_1_S315 phospho",
    "BACH2 510_515_1_1_S510 phospho",
    "BACH2 cnv",
    "BACH2 methyl",
    "BACH2 rna"
  ],
  "BAD": [
    "BAD 118_124_1_1_S118 phospho",
    "BAD 74_91_1_0 phospho",
    "BAD cnv",
    "BAD methyl",
    "BAD proteo",
    "BAD rna"
  ],
  "BAG1": [
    "BAG1 cnv",
    "BAG1 methyl",
    "BAG1 proteo",
    "BAG1 rna"
  ],
  "BAG2": [
    "BAG2 cnv",
    "BAG2 methyl",
    "BAG2 proteo",
    "BAG2 rna"
  ],
  "BAG3": [
    "BAG3 134_145_1_1_S136 phospho",
    "BAG3 171_191_1_1_S173 phospho",
    "BAG3 194_198_1_0 phospho",
    "BAG3 194_198_1_1_S195 phospho",
    "BAG3 205_224_1_0 phospho",
    "BAG3 377_386_1_0 phospho",
    "BAG3 377_386_2_2_S377S386 phospho",
    "BAG3 cnv",
    "BAG3 methyl",
    "BAG3 proteo",
    "BAG3 rna"
  ],
  "BAG4": [
    "BAG4 219_253_1_1_S253 phospho",
    "BAG4 cnv",
    "BAG4 methyl",
    "BAG4 proteo",
    "BAG4 rna"
  ],
  "BAG5": [
    "BAG5 cnv",
    "BAG5 methyl",
    "BAG5 proteo",
    "BAG5 rna"
  ],
  "BAG6": [
    "BAG6 1074_1080_1_1_S1075 phospho",
    "BAG6 1110_1111_1_0 phospho",
    "BAG6 1110_1111_1_1_S1111 phospho",
    "BAG6 92_117_1_1_S113 phospho",
    "BAG6 92_123_1_1_S113 phospho",
    "BAG6 958_958_1_1_S958 phospho",
    "BAG6 958_979_1_1_S958 phospho",
    "BAG6 958_979_1_1_S967 phospho",
    "BAG6 958_979_2_2_S958S967 phospho",
    "BAG6 967_979_1_1_S967 phospho",
    "BAG6 cnv",
    "BAG6 methyl",
    "BAG6 proteo",
    "BAG6 rna"
  ],
  "BAHCC1": [
    "BAHCC1 cnv",
    "BAHCC1 methyl",
    "BAHCC1 rna"
  ],
  "BAHD1": [
    "BAHD1 121_121_1_1_S121 phospho",
    "BAHD1 184_184_1_1_S184 phospho",
    "BAHD1 cnv",
    "BAHD1 methyl",
    "BAHD1 rna"
  ],
  "BAIAP2": [
    "BAIAP2 249_261_1_0 phospho",
    "BAIAP2 249_261_1_1_S261 phospho",
    "BAIAP2 323_331_1_1_S325 phospho",
    "BAIAP2 452_475_1_0 phospho",
    "BAIAP2 cnv",
    "BAIAP2 methyl",
    "BAIAP2 proteo",
    "BAIAP2 rna"
  ],
  "BAIAP2-DT": [
    "BAIAP2-DT methyl"
  ],
  "BAIAP2L1": [
    "BAIAP2L1 cnv",
    "BAIAP2L1 methyl",
    "BAIAP2L1 rna"
  ],
  "BAIAP2L2": [
    "BAIAP2L2 cnv",
    "BAIAP2L2 methyl",
    "BAIAP2L2 rna"
  ],
  "BAIAP3": [
    "BAIAP3 78_90_1_1_S80 phospho",
    "BAIAP3 cnv",
    "BAIAP3 methyl",
    "BAIAP3 proteo",
    "BAIAP3 rna"
  ],
  "BAK1": [
    "BAK1 cnv",
    "BAK1 proteo",
    "BAK1 rna"
  ],
  "BAMBI": [
    "BAMBI cnv",
    "BAMBI methyl",
    "BAMBI rna"
  ],
  "BANF1": [
    "BANF1 cnv",
    "BANF1 methyl",
    "BANF1 proteo",
    "BANF1 rna"
  ],
  "BANF2": [
    "BANF2 cnv",
    "BANF2 rna"
  ],
  "BANK1": [
    "BANK1 cnv",
    "BANK1 methyl",
    "BANK1 rna"
  ],
  "BANP": [
    "BANP 98_115_1_1_S108 phospho",
    "BANP cnv",
    "BANP methyl",
    "BANP proteo",
    "BANP rna"
  ],
  "BAP1": [
    "BAP1 287_292_1_1_S292 phospho",
    "BAP1 305_327_1_1_S327 phospho",
    "BAP1 513_528_1_1_S521 phospho",
    "BAP1 cnv",
    "BAP1 methyl",
    "BAP1 rna"
  ],
  "BARD1": [
    "BARD1 cnv",
    "BARD1 methyl",
    "BARD1 rna"
  ],
  "BARHL1": [
    "BARHL1 cnv",
    "BARHL1 methyl",
    "BARHL1 rna"
  ],
  "BARHL2": [
    "BARHL2 cnv",
    "BARHL2 methyl",
    "BARHL2 rna"
  ],
  "BARX1": [
    "BARX1 cnv",
    "BARX1 methyl",
    "BARX1 rna"
  ],
  "BARX1-DT": [
    "BARX1-DT methyl"
  ],
  "BARX2": [
    "BARX2 cnv",
    "BARX2 methyl",
    "BARX2 rna"
  ],
  "BASP1": [
    "BASP1 164_172_1_1_S164 phospho",
    "BASP1 164_183_1_0 phospho",
    "BASP1 164_183_1_1_S164 phospho",
    "BASP1 164_183_1_1_S177 phospho",
    "BASP1 164_183_2_2_S172S176 phospho",
    "BASP1 164_196_1_0 phospho",
    "BASP1 186_196_1_1_T196 phospho",
    "BASP1 205_224_1_1_S219 phospho",
    "BASP1 31_36_1_1_T31 phospho",
    "BASP1 31_36_1_1_T36 phospho",
    "BASP1 31_36_2_2_T31T36 phospho",
    "BASP1 31_40_1_0 phospho",
    "BASP1 31_40_1_1_T36 phospho",
    "BASP1 31_40_2_2_T31T36 phospho",
    "BASP1 31_40_2_2_T36S40 phospho",
    "BASP1 cnv",
    "BASP1 methyl",
    "BASP1 proteo",
    "BASP1 rna"
  ],
  "BATF": [
    "BATF cnv",
    "BATF rna"
  ],
  "BATF2": [
    "BATF2 cnv",
    "BATF2 rna"
  ],
  "BATF3": [
    "BATF3 cnv",
    "BATF3 methyl",
    "BATF3 rna"
  ],
  "BAX": [
    "BAX cnv",
    "BAX methyl",
    "BAX proteo",
    "BAX rna"
  ],
  "BAZ1A": [
    "BAZ1A 1413_1420_1_1_S1413 phospho",
    "BAZ1A 731_739_1_1_T731 phospho",
    "BAZ1A cnv",
    "BAZ1A methyl",
    "BAZ1A proteo",
    "BAZ1A rna"
  ],
  "BAZ1A-AS1": [
    "BAZ1A-AS1 methyl"
  ],
  "BAZ1B": [
    "BAZ1B 1468_1476_1_1_S1468 phospho",
    "BAZ1B 152_161_1_1_S158 phospho",
    "BAZ1B 310_318_1_1_S312 phospho",
    "BAZ1B 699_710_2_2_S705S708 phospho",
    "BAZ1B 945_952_1_1_S947 phospho",
    "BAZ1B cnv",
    "BAZ1B methyl",
    "BAZ1B proteo",
    "BAZ1B rna"
  ],
  "BAZ2A": [
    "BAZ2A 132_138_1_1_S133 phospho",
    "BAZ2A 1395_1397_1_1_S1395 phospho",
    "BAZ2A 1768_1768_1_1_S1768 phospho",
    "BAZ2A cnv",
    "BAZ2A methyl",
    "BAZ2A rna"
  ],
  "BAZ2B": [
    "BAZ2B cnv",
    "BAZ2B methyl",
    "BAZ2B rna"
  ],
  "BBC3": [
    "BBC3 cnv",
    "BBC3 methyl",
    "BBC3 rna"
  ],
  "BBIP1": [
    "BBIP1 cnv",
    "BBIP1 methyl",
    "BBIP1 proteo",
    "BBIP1 rna"
  ],
  "BBLN": [
    "BBLN cnv",
    "BBLN methyl",
    "BBLN proteo",
    "BBLN rna"
  ],
  "BBOF1": [
    "BBOF1 cnv",
    "BBOF1 methyl",
    "BBOF1 rna"
  ],
  "BBOX1": [
    "BBOX1 cnv",
    "BBOX1 proteo",
    "BBOX1 rna"
  ],
  "BBS1": [
    "BBS1 cnv",
    "BBS1 proteo",
    "BBS1 rna"
  ],
  "BBS10": [
    "BBS10 719_719_1_1_S719 phospho",
    "BBS10 cnv",
    "BBS10 methyl",
    "BBS10 rna"
  ],
  "BBS12": [
    "BBS12 cnv",
    "BBS12 methyl",
    "BBS12 rna"
  ],
  "BBS2": [
    "BBS2 cnv",
    "BBS2 methyl",
    "BBS2 proteo",
    "BBS2 rna"
  ],
  "BBS4": [
    "BBS4 cnv",
    "BBS4 methyl",
    "BBS4 proteo",
    "BBS4 rna"
  ],
  "BBS5": [
    "BBS5 cnv",
    "BBS5 methyl",
    "BBS5 proteo",
    "BBS5 rna"
  ],
  "BBS7": [
    "BBS7 cnv",
    "BBS7 methyl",
    "BBS7 proteo",
    "BBS7 rna"
  ],
  "BBS9": [
    "BBS9 831_845_1_1_S839 phospho",
    "BBS9 cnv",
    "BBS9 methyl",
    "BBS9 proteo",
    "BBS9 rna"
  ],
  "BBX": [
    "BBX 838_849_1_1_S844 phospho",
    "BBX cnv",
    "BBX methyl",
    "BBX proteo",
    "BBX rna"
  ],
  "BCAM": [
    "BCAM 596_614_1_1_S600 phospho",
    "BCAM 621_621_1_1_S621 phospho",
    "BCAM TQNFTLLVQGSPELK-N2H4F0S0G0 glyco",
    "BCAM TQNFTLLVQGSPELK-N2H5F0S0G0 glyco",
    "BCAM TQNFTLLVQGSPELK-N2H6F0S0G0 glyco",
    "BCAM TQNFTLLVQGSPELK-N4H5F0S1G0 glyco",
    "BCAM cnv",
    "BCAM methyl",
    "BCAM proteo",
    "BCAM rna"
  ],
  "BCAN": [
    "BCAN 406_420_1_0 phospho",
    "BCAN 406_420_1_1_S419 phospho",
    "BCAN TLFLFPNQTGFPNK-N2H10F0S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N2H5F0S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N2H6F0S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N2H7F0S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N2H8F0S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N3H3F1S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N3H4F0S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N3H4F1S2G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N3H4F2S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N3H4F2S2G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H3F1S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H3F3S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H4F0S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H4F1S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H4F1S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H4F1S2G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H4F2S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H5F0S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H5F1S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H5F1S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H5F1S2G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H5F1S3G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H5F2S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H5F2S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H5F2S2G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H5F3S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H5F3S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H6F0S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H6F1S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H6F1S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N4H6F2S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H3F1S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H3F2S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H3F3S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H4F0S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H4F0S2G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H4F1S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H4F1S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H4F1S2G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H4F2S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H4F2S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H4F3S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H5F0S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H5F1S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H5F1S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H5F1S2G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H5F2S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H5F2S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H5F3S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H6F1S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H6F1S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N5H6F2S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N6H3F1S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N6H3F2S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N6H3F3S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N6H3F4S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N6H4F0S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N6H4F1S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N6H4F1S2G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N6H4F2S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N6H4F2S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N6H5F1S1G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N8H4F0S0G0 glyco",
    "BCAN TLFLFPNQTGFPNK-N8H5F0S0G0 glyco",
    "BCAN VALPAYPASLTDVSLALSELRPNDSGIYR-N2H5F0S0G0 glyco",
    "BCAN cnv",
    "BCAN methyl",
    "BCAN proteo",
    "BCAN rna"
  ],
  "BCAP29": [
    "BCAP29 cnv",
    "BCAP29 methyl",
    "BCAP29 proteo",
    "BCAP29 rna"
  ],
  "BCAP31": [
    "BCAP31 methyl",
    "BCAP31 proteo",
    "BCAP31 rna"
  ],
  "BCAR1": [
    "BCAR1 474_481_1_1_S474 phospho",
    "BCAR1 cnv",
    "BCAR1 methyl",
    "BCAR1 proteo",
    "BCAR1 rna"
  ],
  "BCAR3": [
    "BCAR3 290_292_1_1_S290 phospho",
    "BCAR3 338_341_1_1_S338 phospho",
    "BCAR3 63_78_1_1_S78 phospho",
    "BCAR3 83_93_1_1_S83 phospho",
    "BCAR3 cnv",
    "BCAR3 methyl",
    "BCAR3 proteo",
    "BCAR3 rna"
  ],
  "BCAS1": [
    "BCAS1 314_318_1_1_S314 phospho",
    "BCAS1 346_354_1_1_T354 phospho",
    "BCAS1 381_399_1_1_S381 phospho",
    "BCAS1 480_489_1_1_T482 phospho",
    "BCAS1 cnv",
    "BCAS1 proteo",
    "BCAS1 rna"
  ],
  "BCAS2": [
    "BCAS2 cnv",
    "BCAS2 proteo",
    "BCAS2 rna"
  ],
  "BCAS3": [
    "BCAS3 480_492_1_1_S480 phospho",
    "BCAS3 480_492_1_1_S488 phospho",
    "BCAS3 570_572_1_1_S570 phospho",
    "BCAS3 706_732_1_1_S706 phospho",
    "BCAS3 829_838_1_1_S838 phospho",
    "BCAS3 849_854_1_1_S850 phospho",
    "BCAS3 869_879_1_1_S869 phospho",
    "BCAS3 886_900_1_1_S886 phospho",
    "BCAS3 cnv",
    "BCAS3 methyl",
    "BCAS3 proteo",
    "BCAS3 rna"
  ],
  "BCAS4": [
    "BCAS4 cnv",
    "BCAS4 methyl",
    "BCAS4 rna"
  ],
  "BCAT1": [
    "BCAT1 cnv",
    "BCAT1 methyl",
    "BCAT1 proteo",
    "BCAT1 rna"
  ],
  "BCAT2": [
    "BCAT2 cnv",
    "BCAT2 methyl",
    "BCAT2 proteo",
    "BCAT2 rna"
  ],
  "BCCIP": [
    "BCCIP 42_42_1_1_S42 phospho",
    "BCCIP cnv",
    "BCCIP methyl",
    "BCCIP proteo",
    "BCCIP rna"
  ],
  "BCDIN3D": [
    "BCDIN3D cnv",
    "BCDIN3D methyl",
    "BCDIN3D rna"
  ],
  "BCDIN3D-AS1": [
    "BCDIN3D-AS1 methyl"
  ],
  "BCHE": [
    "BCHE ENETEIIK-N2H4F0S0G0 glyco",
    "BCHE ENETEIIK-N2H5F0S0G0 glyco",
    "BCHE ENETEIIK-N2H6F0S0G0 glyco",
    "BCHE ENETEIIK-N2H7F0S0G0 glyco",
    "BCHE ENETEIIK-N2H8F0S0G0 glyco",
    "BCHE cnv",
    "BCHE proteo",
    "BCHE rna"
  ],
  "BCKDHA": [
    "BCKDHA 337_345_1_1_S337 phospho",
    "BCKDHA 337_353_1_1_S347 phospho",
    "BCKDHA 337_353_2_0 phospho",
    "BCKDHA 337_353_2_2_S337S347 phospho",
    "BCKDHA 347_353_1_1_S347 phospho",
    "BCKDHA 347_362_1_1_S347 phospho",
    "BCKDHA cnv",
    "BCKDHA methyl",
    "BCKDHA proteo",
    "BCKDHA rna"
  ],
  "BCKDHB": [
    "BCKDHB cnv",
    "BCKDHB methyl",
    "BCKDHB proteo",
    "BCKDHB rna"
  ],
  "BCKDK": [
    "BCKDK cnv",
    "BCKDK kinase",
    "BCKDK methyl",
    "BCKDK proteo",
    "BCKDK rna"
  ],
  "BCL10": [
    "BCL10 136_144_1_1_S138 phospho",
    "BCL10 cnv",
    "BCL10 methyl",
    "BCL10 proteo",
    "BCL10 rna"
  ],
  "BCL11A": [
    "BCL11A 164_174_1_1_S171 phospho",
    "BCL11A 574_584_1_1_S574 phospho",
    "BCL11A 86_88_1_1_S86 phospho",
    "BCL11A cnv",
    "BCL11A methyl",
    "BCL11A rna"
  ],
  "BCL11B": [
    "BCL11B cnv",
    "BCL11B methyl",
    "BCL11B rna"
  ],
  "BCL2": [
    "BCL2 cnv",
    "BCL2 methyl",
    "BCL2 proteo",
    "BCL2 rna"
  ],
  "BCL2A1": [
    "BCL2A1 cnv",
    "BCL2A1 rna"
  ],
  "BCL2L1": [
    "BCL2L1 cnv",
    "BCL2L1 methyl",
    "BCL2L1 proteo",
    "BCL2L1 rna"
  ],
  "BCL2L10": [
    "BCL2L10 cnv",
    "BCL2L10 methyl",
    "BCL2L10 rna"
  ],
  "BCL2L11": [
    "BCL2L11 cnv",
    "BCL2L11 methyl",
    "BCL2L11 rna"
  ],
  "BCL2L12": [
    "BCL2L12 cnv",
    "BCL2L12 methyl",
    "BCL2L12 rna"
  ],
  "BCL2L13": [
    "BCL2L13 394_399_1_1_S395 phospho",
    "BCL2L13 444_453_1_1_S450 phospho",
    "BCL2L13 444_461_1_1_S450 phospho",
    "BCL2L13 465_468_1_1_S468 phospho",
    "BCL2L13 465_479_1_1_S468 phospho",
    "BCL2L13 cnv",
    "BCL2L13 methyl",
    "BCL2L13 proteo",
    "BCL2L13 rna"
  ],
  "BCL2L14": [
    "BCL2L14 cnv",
    "BCL2L14 rna"
  ],
  "BCL2L15": [
    "BCL2L15 cnv",
    "BCL2L15 rna"
  ],
  "BCL2L2": [
    "BCL2L2 cnv",
    "BCL2L2 methyl",
    "BCL2L2 rna"
  ],
  "BCL2L2-PABPN1": [
    "BCL2L2-PABPN1 cnv",
    "BCL2L2-PABPN1 rna"
  ],
  "BCL3": [
    "BCL3 41_41_1_1_S41 phospho",
    "BCL3 cnv",
    "BCL3 methyl",
    "BCL3 rna"
  ],
  "BCL6": [
    "BCL6 330_333_1_1_S333 phospho",
    "BCL6 337_350_1_1_S343 phospho",
    "BCL6 385_404_1_1_S404 phospho",
    "BCL6 cnv",
    "BCL6 methyl",
    "BCL6 rna"
  ],
  "BCL6B": [
    "BCL6B cnv",
    "BCL6B methyl",
    "BCL6B rna"
  ],
  "BCL7A": [
    "BCL7A 224_228_1_1_S228 phospho",
    "BCL7A cnv",
    "BCL7A methyl",
    "BCL7A proteo",
    "BCL7A rna"
  ],
  "BCL7B": [
    "BCL7B cnv",
    "BCL7B methyl",
    "BCL7B proteo",
    "BCL7B rna"
  ],
  "BCL7C": [
    "BCL7C 111_126_1_1_S126 phospho",
    "BCL7C cnv",
    "BCL7C methyl",
    "BCL7C proteo",
    "BCL7C rna"
  ],
  "BCL9": [
    "BCL9 1031_1039_1_1_S1039 phospho",
    "BCL9 10_19_1_1_S19 phospho",
    "BCL9 10_19_2_2_S11S19 phospho",
    "BCL9 153_167_1_1_T155 phospho",
    "BCL9 278_278_1_1_S278 phospho",
    "BCL9 288_308_1_1_S291 phospho",
    "BCL9 315_325_1_1_T315 phospho",
    "BCL9 55_66_1_1_S62 phospho",
    "BCL9 687_689_1_1_S687 phospho",
    "BCL9 907_917_1_1_S917 phospho",
    "BCL9 cnv",
    "BCL9 methyl",
    "BCL9 proteo",
    "BCL9 rna"
  ],
  "BCL9L": [
    "BCL9L 1013_1021_1_1_S1017 phospho",
    "BCL9L 116_121_1_1_S116 phospho",
    "BCL9L 1478_1487_1_1_S1480 phospho",
    "BCL9L 21_25_2_2_S21S25 phospho",
    "BCL9L 88_93_1_1_S88 phospho",
    "BCL9L 934_949_1_1_S947 phospho",
    "BCL9L 997_1010_1_1_S1010 phospho",
    "BCL9L cnv",
    "BCL9L methyl",
    "BCL9L proteo",
    "BCL9L rna"
  ],
  "BCLAF1": [
    "BCLAF1 175_175_1_1_S175 phospho",
    "BCLAF1 175_179_1_1_S175 phospho",
    "BCLAF1 179_196_1_1_S181 phospho",
    "BCLAF1 203_220_1_1_S220 phospho",
    "BCLAF1 255_266_1_1_S266 phospho",
    "BCLAF1 270_295_1_0 phospho",
    "BCLAF1 270_295_2_0 phospho",
    "BCLAF1 270_295_2_2_S283S288 phospho",
    "BCLAF1 270_295_3_0 phospho",
    "BCLAF1 282_295_1_1_S283 phospho",
    "BCLAF1 282_295_1_1_S288 phospho",
    "BCLAF1 282_295_2_2_S283S288 phospho",
    "BCLAF1 282_298_2_2_S288S298 phospho",
    "BCLAF1 282_298_3_3_S283S288S298 phospho",
    "BCLAF1 298_302_1_1_S298 phospho",
    "BCLAF1 339_343_1_1_T339 phospho",
    "BCLAF1 381_383_1_1_S383 phospho",
    "BCLAF1 381_387_1_1_S383 phospho",
    "BCLAF1 395_406_1_1_S395 phospho",
    "BCLAF1 395_406_2_2_S395T400 phospho",
    "BCLAF1 492_494_1_1_S494 phospho",
    "BCLAF1 509_510_1_1_S510 phospho",
    "BCLAF1 523_529_1_1_S529 phospho",
    "BCLAF1 646_646_1_1_S646 phospho",
    "BCLAF1 688_688_1_1_S688 phospho",
    "BCLAF1 837_838_1_1_T838 phospho",
    "BCLAF1 879_886_1_1_S882 phospho",
    "BCLAF1 879_886_2_2_S881S882 phospho",
    "BCLAF1 cnv",
    "BCLAF1 methyl",
    "BCLAF1 proteo",
    "BCLAF1 rna"
  ],
  "BCLAF3": [
    "BCLAF3 70_80_2_2_S78S80 phospho",
    "BCLAF3 methyl",
    "BCLAF3 proteo",
    "BCLAF3 rna"
  ],
  "BCO1": [
    "BCO1 cnv",
    "BCO1 rna"
  ],
  "BCO2": [
    "BCO2 cnv",
    "BCO2 methyl",
    "BCO2 rna"
  ],
  "BCOR": [
    "BCOR 422_423_1_1_S423 phospho",
    "BCOR methyl",
    "BCOR mut",
    "BCOR rna"
  ],
  "BCORL1": [
    "BCORL1 methyl",
    "BCORL1 rna"
  ],
  "BCORP1": [
    "BCORP1 methyl"
  ],
  "BCR": [
    "BCR 1264_1269_1_1_S1264 phospho",
    "BCR 235_246_1_1_S235 phospho",
    "BCR 367_385_1_1_S369 phospho",
    "BCR 369_385_1_1_S382 phospho",
    "BCR 455_468_1_1_S459 phospho",
    "BCR 455_468_2_2_S459S463 phospho",
    "BCR 698_700_1_1_S698 phospho",
    "BCR 93_122_1_1_S122 phospho",
    "BCR cnv",
    "BCR methyl",
    "BCR proteo",
    "BCR rna"
  ],
  "BCS1L": [
    "BCS1L cnv",
    "BCS1L methyl",
    "BCS1L proteo",
    "BCS1L rna"
  ],
  "BDH1": [
    "BDH1 cnv",
    "BDH1 methyl",
    "BDH1 proteo",
    "BDH1 rna"
  ],
  "BDH2": [
    "BDH2 cnv",
    "BDH2 proteo",
    "BDH2 rna"
  ],
  "BDKRB1": [
    "BDKRB1 cnv",
    "BDKRB1 rna"
  ],
  "BDKRB2": [
    "BDKRB2 cnv",
    "BDKRB2 rna"
  ],
  "BDNF": [
    "BDNF cnv",
    "BDNF methyl",
    "BDNF rna"
  ],
  "BDNF-AS": [
    "BDNF-AS methyl"
  ],
  "BDP1": [
    "BDP1 2449_2451_1_1_S2451 phospho",
    "BDP1 cnv",
    "BDP1 methyl",
    "BDP1 rna"
  ],
  "BEAN1": [
    "BEAN1 cnv",
    "BEAN1 methyl",
    "BEAN1 rna"
  ],
  "BECN1": [
    "BECN1 cnv",
    "BECN1 methyl",
    "BECN1 proteo",
    "BECN1 rna"
  ],
  "BECN2": [
    "BECN2 cnv",
    "BECN2 rna"
  ],
  "BEGAIN": [
    "BEGAIN 246_252_1_1_S246 phospho",
    "BEGAIN 448_455_1_1_S455 phospho",
    "BEGAIN cnv",
    "BEGAIN methyl",
    "BEGAIN proteo",
    "BEGAIN rna"
  ],
  "BEND2": [
    "BEND2 rna"
  ],
  "BEND3": [
    "BEND3 cnv",
    "BEND3 methyl",
    "BEND3 rna"
  ],
  "BEND4": [
    "BEND4 cnv",
    "BEND4 methyl",
    "BEND4 rna"
  ],
  "BEND5": [
    "BEND5 cnv",
    "BEND5 methyl",
    "BEND5 rna"
  ],
  "BEND6": [
    "BEND6 cnv",
    "BEND6 methyl",
    "BEND6 rna"
  ],
  "BEND7": [
    "BEND7 cnv",
    "BEND7 methyl",
    "BEND7 rna"
  ],
  "BEST1": [
    "BEST1 cnv",
    "BEST1 rna"
  ],
  "BEST2": [
    "BEST2 cnv",
    "BEST2 methyl",
    "BEST2 rna"
  ],
  "BEST3": [
    "BEST3 cnv",
    "BEST3 rna"
  ],
  "BEST4": [
    "BEST4 cnv",
    "BEST4 rna"
  ],
  "BET1": [
    "BET1 cnv",
    "BET1 methyl",
    "BET1 proteo",
    "BET1 rna"
  ],
  "BET1L": [
    "BET1L 37_37_1_1_S37 phospho",
    "BET1L cnv",
    "BET1L methyl",
    "BET1L proteo",
    "BET1L rna"
  ],
  "BEX1": [
    "BEX1 methyl",
    "BEX1 rna"
  ],
  "BEX2": [
    "BEX2 methyl",
    "BEX2 rna"
  ],
  "BEX3": [
    "BEX3 methyl",
    "BEX3 rna"
  ],
  "BEX4": [
    "BEX4 methyl",
    "BEX4 proteo",
    "BEX4 rna"
  ],
  "BEX5": [
    "BEX5 rna"
  ],
  "BFAR": [
    "BFAR cnv",
    "BFAR methyl",
    "BFAR rna"
  ],
  "BFSP1": [
    "BFSP1 cnv",
    "BFSP1 methyl",
    "BFSP1 rna"
  ],
  "BFSP2": [
    "BFSP2 cnv",
    "BFSP2 rna"
  ],
  "BGLAP": [
    "BGLAP cnv",
    "BGLAP rna"
  ],
  "BGN": [
    "BGN LLQVVYLHSNNITK-N3H4F2S2G0 glyco",
    "BGN LLQVVYLHSNNITK-N4H3F1S0G0 glyco",
    "BGN LLQVVYLHSNNITK-N4H4F1S0G0 glyco",
    "BGN LLQVVYLHSNNITK-N4H5F1S0G0 glyco",
    "BGN LLQVVYLHSNNITK-N4H5F1S1G0 glyco",
    "BGN LLQVVYLHSNNITK-N4H5F1S2G0 glyco",
    "BGN LLQVVYLHSNNITK-N5H3F1S0G0 glyco",
    "BGN LLQVVYLHSNNITK-N5H4F0S0G0 glyco",
    "BGN LLQVVYLHSNNITK-N5H4F1S0G0 glyco",
    "BGN LLQVVYLHSNNITK-N5H4F1S1G0 glyco",
    "BGN LLQVVYLHSNNITK-N5H4F1S2G0 glyco",
    "BGN LLQVVYLHSNNITK-N5H5F1S0G0 glyco",
    "BGN LLQVVYLHSNNITK-N6H3F1S0G0 glyco",
    "BGN LLQVVYLHSNNITK-N6H5F1S0G0 glyco",
    "BGN MIENGSLSFLPTLR-N4H5F1S0G0 glyco",
    "BGN MIENGSLSFLPTLR-N4H5F1S1G0 glyco",
    "BGN MIENGSLSFLPTLR-N5H4F1S0G0 glyco",
    "BGN proteo",
    "BGN rna"
  ],
  "BHLHA15": [
    "BHLHA15 cnv",
    "BHLHA15 methyl",
    "BHLHA15 rna"
  ],
  "BHLHA9": [
    "BHLHA9 cnv",
    "BHLHA9 methyl",
    "BHLHA9 rna"
  ],
  "BHLHB9": [
    "BHLHB9 methyl",
    "BHLHB9 rna"
  ],
  "BHLHE22": [
    "BHLHE22 cnv",
    "BHLHE22 rna"
  ],
  "BHLHE22-AS1": [
    "BHLHE22-AS1 methyl"
  ],
  "BHLHE23": [
    "BHLHE23 cnv",
    "BHLHE23 methyl",
    "BHLHE23 rna"
  ],
  "BHLHE40": [
    "BHLHE40 cnv",
    "BHLHE40 methyl",
    "BHLHE40 rna"
  ],
  "BHLHE40-AS1": [
    "BHLHE40-AS1 methyl"
  ],
  "BHLHE41": [
    "BHLHE41 119_137_1_1_S122 phospho",
    "BHLHE41 cnv",
    "BHLHE41 methyl",
    "BHLHE41 rna"
  ],
  "BHMT": [
    "BHMT cnv",
    "BHMT rna"
  ],
  "BHMT2": [
    "BHMT2 cnv",
    "BHMT2 rna"
  ],
  "BICC1": [
    "BICC1 633_637_1_1_S633 phospho",
    "BICC1 766_771_1_1_S766 phospho",
    "BICC1 cnv",
    "BICC1 methyl",
    "BICC1 rna"
  ],
  "BICD1": [
    "BICD1 569_574_1_1_S570 phospho",
    "BICD1 597_616_1_0 phospho",
    "BICD1 cnv",
    "BICD1 methyl",
    "BICD1 proteo",
    "BICD1 rna"
  ],
  "BICD2": [
    "BICD2 329_343_1_0 phospho",
    "BICD2 582_582_1_1_S582 phospho",
    "BICD2 cnv",
    "BICD2 methyl",
    "BICD2 proteo",
    "BICD2 rna"
  ],
  "BICDL1": [
    "BICDL1 cnv",
    "BICDL1 methyl",
    "BICDL1 rna"
  ],
  "BICDL2": [
    "BICDL2 cnv",
    "BICDL2 methyl",
    "BICDL2 rna"
  ],
  "BICRA": [
    "BICRA 1413_1413_1_1_S1413 phospho",
    "BICRA cnv",
    "BICRA methyl",
    "BICRA proteo",
    "BICRA rna"
  ],
  "BICRAL": [
    "BICRAL 674_687_1_1_S675 phospho",
    "BICRAL 976_988_1_1_S976 phospho",
    "BICRAL cnv",
    "BICRAL methyl",
    "BICRAL proteo",
    "BICRAL rna"
  ],
  "BID": [
    "BID cnv",
    "BID methyl",
    "BID proteo",
    "BID rna"
  ],
  "BIK": [
    "BIK cnv",
    "BIK methyl",
    "BIK rna"
  ],
  "BIN1": [
    "BIN1 276_302_1_0 phospho",
    "BIN1 276_302_1_1_S278 phospho",
    "BIN1 286_307_1_0 phospho",
    "BIN1 286_307_1_1_S298 phospho",
    "BIN1 286_307_2_0 phospho",
    "BIN1 286_307_2_2_S296S298 phospho",
    "BIN1 286_307_3_3_S296S298S303 phospho",
    "BIN1 296_307_1_0 phospho",
    "BIN1 296_307_1_1_S296 phospho",
    "BIN1 296_307_1_1_S298 phospho",
    "BIN1 296_307_2_2_S296S298 phospho",
    "BIN1 296_307_2_2_S298S303 phospho",
    "BIN1 296_307_3_3_S296S298S303 phospho",
    "BIN1 296_327_1_1_S298 phospho",
    "BIN1 296_327_2_0 phospho",
    "BIN1 323_327_1_1_T323 phospho",
    "BIN1 348_350_1_1_T348 phospho",
    "BIN1 cnv",
    "BIN1 methyl",
    "BIN1 proteo",
    "BIN1 rna"
  ],
  "BIN2": [
    "BIN2 233_237_1_1_S233 phospho",
    "BIN2 242_259_1_0 phospho",
    "BIN2 242_259_1_1_S247 phospho",
    "BIN2 331_359_1_1_S331 phospho",
    "BIN2 367_372_1_0 phospho",
    "BIN2 367_372_1_1_S369 phospho",
    "BIN2 384_389_1_1_S385 phospho",
    "BIN2 397_421_1_1_S410 phospho",
    "BIN2 397_421_1_1_S418 phospho",
    "BIN2 397_421_2_2_S410S418 phospho",
    "BIN2 403_421_1_1_S418 phospho",
    "BIN2 425_440_2_0 phospho",
    "BIN2 425_440_2_2_S432S436 phospho",
    "BIN2 435_440_1_1_S436 phospho",
    "BIN2 435_452_1_1_T452 phospho",
    "BIN2 cnv",
    "BIN2 methyl",
    "BIN2 proteo",
    "BIN2 rna"
  ],
  "BIN3": [
    "BIN3 cnv",
    "BIN3 methyl",
    "BIN3 proteo",
    "BIN3 rna"
  ],
  "BIRC2": [
    "BIRC2 cnv",
    "BIRC2 methyl",
    "BIRC2 proteo",
    "BIRC2 rna"
  ],
  "BIRC3": [
    "BIRC3 cnv",
    "BIRC3 methyl",
    "BIRC3 rna"
  ],
  "BIRC5": [
    "BIRC5 cnv",
    "BIRC5 methyl",
    "BIRC5 rna"
  ],
  "BIRC6": [
    "BIRC6 473_486_1_1_S480 phospho",
    "BIRC6 cnv",
    "BIRC6 methyl",
    "BIRC6 proteo",
    "BIRC6 rna"
  ],
  "BIRC7": [
    "BIRC7 cnv",
    "BIRC7 rna"
  ],
  "BIRC8": [
    "BIRC8 cnv",
    "BIRC8 methyl"
  ],
  "BIVM": [
    "BIVM cnv",
    "BIVM methyl",
    "BIVM rna"
  ],
  "BIVM-ERCC5": [
    "BIVM-ERCC5 cnv",
    "BIVM-ERCC5 methyl",
    "BIVM-ERCC5 rna"
  ],
  "BLACAT1": [
    "BLACAT1 cnv",
    "BLACAT1 rna"
  ],
  "BLCAP": [
    "BLCAP cnv",
    "BLCAP methyl",
    "BLCAP rna"
  ],
  "BLID": [
    "BLID cnv",
    "BLID rna"
  ],
  "BLK": [
    "BLK cnv",
    "BLK kinase",
    "BLK rna"
  ],
  "BLM": [
    "BLM cnv",
    "BLM methyl",
    "BLM rna"
  ],
  "BLMH": [
    "BLMH cnv",
    "BLMH methyl",
    "BLMH proteo",
    "BLMH rna"
  ],
  "BLNK": [
    "BLNK 124_133_1_1_S129 phospho",
    "BLNK 209_225_1_1_S219 phospho",
    "BLNK cnv",
    "BLNK proteo",
    "BLNK rna"
  ],
  "BLOC1S1": [
    "BLOC1S1 cnv",
    "BLOC1S1 methyl",
    "BLOC1S1 proteo",
    "BLOC1S1 rna"
  ],
  "BLOC1S2": [
    "BLOC1S2 cnv",
    "BLOC1S2 methyl",
    "BLOC1S2 proteo",
    "BLOC1S2 rna"
  ],
  "BLOC1S3": [
    "BLOC1S3 63_74_1_1_S65 phospho",
    "BLOC1S3 63_74_2_2_T63S65 phospho",
    "BLOC1S3 cnv",
    "BLOC1S3 methyl",
    "BLOC1S3 proteo",
    "BLOC1S3 rna"
  ],
  "BLOC1S4": [
    "BLOC1S4 cnv",
    "BLOC1S4 methyl",
    "BLOC1S4 proteo",
    "BLOC1S4 rna"
  ],
  "BLOC1S5": [
    "BLOC1S5 25_31_1_1_S25 phospho",
    "BLOC1S5 cnv",
    "BLOC1S5 methyl",
    "BLOC1S5 proteo",
    "BLOC1S5 rna"
  ],
  "BLOC1S5-TXNDC5": [
    "BLOC1S5-TXNDC5 cnv",
    "BLOC1S5-TXNDC5 rna"
  ],
  "BLOC1S6": [
    "BLOC1S6 cnv",
    "BLOC1S6 methyl",
    "BLOC1S6 proteo",
    "BLOC1S6 rna"
  ],
  "BLTP1": [
    "BLTP1 1323_1329_1_1_S1323 phospho",
    "BLTP1 1348_1355_1_1_S1355 phospho",
    "BLTP1 1361_1379_1_1_S1361 phospho",
    "BLTP1 1802_1808_2_2_S1805S1808 phospho",
    "BLTP1 2243_2249_1_1_S2247 phospho",
    "BLTP1 2243_2249_1_1_S2249 phospho",
    "BLTP1 2287_2287_1_1_S2287 phospho",
    "BLTP1 2597_2607_1_1_S2603 phospho",
    "BLTP1 2597_2607_2_2_S2601S2603 phospho",
    "BLTP1 2754_2757_1_1_S2755 phospho",
    "BLTP1 3830_3837_1_1_S3835 phospho",
    "BLTP1 4114_4124_1_1_S4124 phospho",
    "BLTP1 cnv",
    "BLTP1 methyl",
    "BLTP1 proteo",
    "BLTP1 rna"
  ],
  "BLTP2": [
    "BLTP2 2196_2198_1_0 phospho",
    "BLTP2 cnv",
    "BLTP2 methyl",
    "BLTP2 proteo",
    "BLTP2 rna"
  ],
  "BLTP3A": [
    "BLTP3A 273_308_1_1_T282 phospho",
    "BLTP3A 753_771_1_1_S755 phospho",
    "BLTP3A 918_928_1_1_S922 phospho",
    "BLTP3A 936_957_1_1_S950 phospho",
    "BLTP3A 983_988_1_1_S988 phospho",
    "BLTP3A cnv",
    "BLTP3A methyl",
    "BLTP3A proteo",
    "BLTP3A rna"
  ],
  "BLTP3B": [
    "BLTP3B 414_429_1_1_S418 phospho",
    "BLTP3B 414_429_2_2_S414S418 phospho",
    "BLTP3B 772_792_1_0 phospho",
    "BLTP3B 933_939_1_0 phospho",
    "BLTP3B 987_997_1_1_S989 phospho",
    "BLTP3B cnv",
    "BLTP3B methyl",
    "BLTP3B proteo",
    "BLTP3B rna"
  ],
  "BLVRA": [
    "BLVRA 235_237_1_1_S237 phospho",
    "BLVRA cnv",
    "BLVRA methyl",
    "BLVRA proteo",
    "BLVRA rna"
  ],
  "BLVRB": [
    "BLVRB cnv",
    "BLVRB methyl",
    "BLVRB proteo",
    "BLVRB rna"
  ],
  "BLZF1": [
    "BLZF1 cnv",
    "BLZF1 rna"
  ],
  "BMERB1": [
    "BMERB1 cnv",
    "BMERB1 methyl",
    "BMERB1 proteo",
    "BMERB1 rna"
  ],
  "BMF": [
    "BMF cnv",
    "BMF methyl",
    "BMF rna"
  ],
  "BMI1": [
    "BMI1 cnv",
    "BMI1 methyl",
    "BMI1 rna"
  ],
  "BMP1": [
    "BMP1 cnv",
    "BMP1 proteo",
    "BMP1 rna"
  ],
  "BMP10": [
    "BMP10 cnv"
  ],
  "BMP15": [
    "BMP15 rna"
  ],
  "BMP2": [
    "BMP2 cnv",
    "BMP2 methyl",
    "BMP2 rna"
  ],
  "BMP2K": [
    "BMP2K 1029_1041_1_1_S1029 phospho",
    "BMP2K 10_38_1_1_S14 phospho",
    "BMP2K 1107_1114_1_1_S1107 phospho",
    "BMP2K 1107_1114_2_2_S1107S1111 phospho",
    "BMP2K 665_689_1_1_S689 phospho",
    "BMP2K 727_728_1_1_S728 phospho",
    "BMP2K 947_965_1_1_S949 phospho",
    "BMP2K cnv",
    "BMP2K kinase",
    "BMP2K methyl",
    "BMP2K proteo",
    "BMP2K rna"
  ],
  "BMP3": [
    "BMP3 cnv",
    "BMP3 methyl",
    "BMP3 rna"
  ],
  "BMP4": [
    "BMP4 cnv",
    "BMP4 methyl",
    "BMP4 rna"
  ],
  "BMP5": [
    "BMP5 cnv",
    "BMP5 rna"
  ],
  "BMP6": [
    "BMP6 cnv",
    "BMP6 methyl",
    "BMP6 rna"
  ],
  "BMP7": [
    "BMP7 cnv",
    "BMP7 methyl",
    "BMP7 proteo",
    "BMP7 rna"
  ],
  "BMP8A": [
    "BMP8A cnv",
    "BMP8A methyl",
    "BMP8A rna"
  ],
  "BMP8B": [
    "BMP8B cnv",
    "BMP8B methyl",
    "BMP8B rna"
  ],
  "BMPER": [
    "BMPER cnv",
    "BMPER methyl",
    "BMPER rna"
  ],
  "BMPR1A": [
    "BMPR1A cnv",
    "BMPR1A kinase",
    "BMPR1A methyl",
    "BMPR1A rna"
  ],
  "BMPR1B": [
    "BMPR1B cnv",
    "BMPR1B kinase",
    "BMPR1B methyl",
    "BMPR1B proteo",
    "BMPR1B rna"
  ],
  "BMPR2": [
    "BMPR2 513_523_1_1_S515 phospho",
    "BMPR2 680_689_1_1_S681 phospho",
    "BMPR2 862_863_1_1_S863 phospho",
    "BMPR2 cnv",
    "BMPR2 kinase",
    "BMPR2 methyl",
    "BMPR2 proteo",
    "BMPR2 rna"
  ],
  "BMS1": [
    "BMS1 cnv",
    "BMS1 methyl",
    "BMS1 proteo",
    "BMS1 rna"
  ],
  "BMS1P4": [
    "BMS1P4 methyl"
  ],
  "BMS1P4-AGAP5": [
    "BMS1P4-AGAP5 cnv",
    "BMS1P4-AGAP5 methyl",
    "BMS1P4-AGAP5 rna"
  ],
  "BMT2": [
    "BMT2 cnv",
    "BMT2 rna"
  ],
  "BMX": [
    "BMX kinase",
    "BMX rna"
  ],
  "BNC1": [
    "BNC1 cnv",
    "BNC1 methyl",
    "BNC1 rna"
  ],
  "BNC2": [
    "BNC2 302_320_1_1_S308 phospho",
    "BNC2 cnv",
    "BNC2 methyl",
    "BNC2 proteo",
    "BNC2 rna"
  ],
  "BNIP1": [
    "BNIP1 cnv",
    "BNIP1 proteo",
    "BNIP1 rna"
  ],
  "BNIP2": [
    "BNIP2 235_240_1_0 phospho",
    "BNIP2 235_240_1_1_S235 phospho",
    "BNIP2 cnv",
    "BNIP2 methyl",
    "BNIP2 proteo",
    "BNIP2 rna"
  ],
  "BNIP3": [
    "BNIP3 126_131_1_1_S131 phospho",
    "BNIP3 145_151_1_1_S151 phospho",
    "BNIP3 cnv",
    "BNIP3 methyl",
    "BNIP3 proteo",
    "BNIP3 rna"
  ],
  "BNIP3L": [
    "BNIP3L 124_128_1_1_S124 phospho",
    "BNIP3L 22_25_1_0 phospho",
    "BNIP3L 22_25_1_1_S22 phospho",
    "BNIP3L 22_25_2_0 phospho",
    "BNIP3L 77_80_1_1_S80 phospho",
    "BNIP3L 77_80_2_2_S78S80 phospho",
    "BNIP3L cnv",
    "BNIP3L methyl",
    "BNIP3L proteo",
    "BNIP3L rna"
  ],
  "BNIP5": [
    "BNIP5 cnv",
    "BNIP5 rna"
  ],
  "BNIPL": [
    "BNIPL cnv",
    "BNIPL rna"
  ],
  "BOC": [
    "BOC cnv",
    "BOC methyl",
    "BOC rna"
  ],
  "BOD1": [
    "BOD1 cnv",
    "BOD1 methyl",
    "BOD1 proteo",
    "BOD1 rna"
  ],
  "BOD1L1": [
    "BOD1L1 2475_2490_1_1_S2475 phospho",
    "BOD1L1 2501_2501_1_1_S2501 phospho",
    "BOD1L1 2501_2515_1_1_S2501 phospho",
    "BOD1L1 2986_3003_1_1_S2986 phospho",
    "BOD1L1 480_489_1_1_S482 phospho",
    "BOD1L1 635_637_1_1_S635 phospho",
    "BOD1L1 cnv",
    "BOD1L1 methyl",
    "BOD1L1 proteo",
    "BOD1L1 rna"
  ],
  "BOD1L2": [
    "BOD1L2 cnv",
    "BOD1L2 rna"
  ],
  "BOK": [
    "BOK cnv",
    "BOK methyl",
    "BOK rna"
  ],
  "BOLA1": [
    "BOLA1 118_123_1_1_S123 phospho",
    "BOLA1 cnv",
    "BOLA1 methyl",
    "BOLA1 proteo",
    "BOLA1 rna"
  ],
  "BOLA2": [
    "BOLA2 cnv",
    "BOLA2 proteo",
    "BOLA2 rna"
  ],
  "BOLA2-SMG1P6": [
    "BOLA2-SMG1P6 cnv",
    "BOLA2-SMG1P6 methyl",
    "BOLA2-SMG1P6 rna"
  ],
  "BOLA2B": [
    "BOLA2B cnv",
    "BOLA2B methyl",
    "BOLA2B rna"
  ],
  "BOLA3": [
    "BOLA3 cnv",
    "BOLA3 methyl",
    "BOLA3 proteo",
    "BOLA3 rna"
  ],
  "BOLA3-DT": [
    "BOLA3-DT methyl"
  ],
  "BOLL": [
    "BOLL cnv",
    "BOLL methyl",
    "BOLL rna"
  ],
  "BOP1": [
    "BOP1 97_106_1_1_T106 phospho",
    "BOP1 cnv",
    "BOP1 methyl",
    "BOP1 proteo",
    "BOP1 rna"
  ],
  "BORA": [
    "BORA cnv",
    "BORA methyl",
    "BORA rna"
  ],
  "BORCS5": [
    "BORCS5 52_58_1_1_S56 phospho",
    "BORCS5 cnv",
    "BORCS5 methyl",
    "BORCS5 proteo",
    "BORCS5 rna"
  ],
  "BORCS6": [
    "BORCS6 166_187_1_1_S168 phospho",
    "BORCS6 168_187_1_1_S168 phospho",
    "BORCS6 196_208_1_1_T196 phospho",
    "BORCS6 87_93_1_1_S93 phospho",
    "BORCS6 cnv",
    "BORCS6 methyl",
    "BORCS6 proteo",
    "BORCS6 rna"
  ],
  "BORCS7": [
    "BORCS7 45_46_1_1_S45 phospho",
    "BORCS7 cnv",
    "BORCS7 methyl",
    "BORCS7 proteo",
    "BORCS7 rna"
  ],
  "BORCS7-ASMT": [
    "BORCS7-ASMT cnv",
    "BORCS7-ASMT rna"
  ],
  "BORCS8": [
    "BORCS8 104_118_1_0 phospho",
    "BORCS8 104_118_1_1_S109 phospho",
    "BORCS8 cnv",
    "BORCS8 methyl",
    "BORCS8 proteo",
    "BORCS8 rna"
  ],
  "BORCS8-MEF2B": [
    "BORCS8-MEF2B cnv",
    "BORCS8-MEF2B rna"
  ],
  "BPGM": [
    "BPGM 118_137_1_1_T122 phospho",
    "BPGM cnv",
    "BPGM proteo",
    "BPGM rna"
  ],
  "BPHL": [
    "BPHL cnv",
    "BPHL methyl",
    "BPHL proteo",
    "BPHL rna"
  ],
  "BPI": [
    "BPI cnv",
    "BPI proteo",
    "BPI rna"
  ],
  "BPIFA1": [
    "BPIFA1 cnv"
  ],
  "BPIFA2": [
    "BPIFA2 cnv",
    "BPIFA2 rna"
  ],
  "BPIFA3": [
    "BPIFA3 cnv"
  ],
  "BPIFB1": [
    "BPIFB1 cnv",
    "BPIFB1 rna"
  ],
  "BPIFB2": [
    "BPIFB2 cnv",
    "BPIFB2 rna"
  ],
  "BPIFB3": [
    "BPIFB3 cnv",
    "BPIFB3 rna"
  ],
  "BPIFB4": [
    "BPIFB4 cnv",
    "BPIFB4 rna"
  ],
  "BPIFB6": [
    "BPIFB6 cnv",
    "BPIFB6 rna"
  ],
  "BPIFC": [
    "BPIFC cnv",
    "BPIFC rna"
  ],
  "BPNT1": [
    "BPNT1 cnv",
    "BPNT1 proteo",
    "BPNT1 rna"
  ],
  "BPNT2": [
    "BPNT2 QVALQTFGNQTTIIPAGGAGYK-N2H8F0S0G0 glyco",
    "BPNT2 cnv",
    "BPNT2 methyl",
    "BPNT2 proteo",
    "BPNT2 rna"
  ],
  "BPTF": [
    "BPTF 1310_1310_1_1_S1310 phospho",
    "BPTF 216_216_1_1_S216 phospho",
    "BPTF cnv",
    "BPTF methyl",
    "BPTF proteo",
    "BPTF rna"
  ],
  "BRAF": [
    "BRAF 151_151_1_1_S151 phospho",
    "BRAF 306_337_1_1_S335 phospho",
    "BRAF 363_373_1_0 phospho",
    "BRAF 363_373_1_1_S365 phospho",
    "BRAF 394_411_1_1_T401 phospho",
    "BRAF 446_458_1_1_S446 phospho",
    "BRAF 740_750_1_1_S750 phospho",
    "BRAF cnv",
    "BRAF kinase",
    "BRAF methyl",
    "BRAF mut",
    "BRAF proteo",
    "BRAF rna"
  ],
  "BRAP": [
    "BRAP 117_119_1_1_S117 phospho",
    "BRAP 93_99_1_1_S94 phospho",
    "BRAP cnv",
    "BRAP methyl",
    "BRAP proteo",
    "BRAP rna"
  ],
  "BRAT1": [
    "BRAT1 802_811_1_1_S802 phospho",
    "BRAT1 cnv",
    "BRAT1 methyl",
    "BRAT1 proteo",
    "BRAT1 rna"
  ],
  "BRCA1": [
    "BRCA1 cnv",
    "BRCA1 methyl",
    "BRCA1 rna"
  ],
  "BRCA2": [
    "BRCA2 cnv",
    "BRCA2 methyl",
    "BRCA2 rna"
  ],
  "BRCC3": [
    "BRCC3 methyl",
    "BRCC3 proteo",
    "BRCC3 rna"
  ],
  "BRD1": [
    "BRD1 934_945_1_1_S934 phospho",
    "BRD1 cnv",
    "BRD1 methyl",
    "BRD1 proteo",
    "BRD1 rna"
  ],
  "BRD2": [
    "BRD2 622_644_1_1_S633 phospho",
    "BRD2 cnv",
    "BRD2 methyl",
    "BRD2 proteo",
    "BRD2 rna"
  ],
  "BRD3": [
    "BRD3 261_268_1_1_S263 phospho",
    "BRD3 558_574_1_1_S563 phospho",
    "BRD3 cnv",
    "BRD3 methyl",
    "BRD3 proteo",
    "BRD3 rna"
  ],
  "BRD3OS": [
    "BRD3OS cnv",
    "BRD3OS methyl",
    "BRD3OS rna"
  ],
  "BRD4": [
    "BRD4 1045_1045_1_1_S1045 phospho",
    "BRD4 1051_1056_1_1_S1051 phospho",
    "BRD4 1064_1083_1_0 phospho",
    "BRD4 1064_1083_1_1_S1083 phospho",
    "BRD4 1211_1216_1_1_T1212 phospho",
    "BRD4 469_477_1_0 phospho",
    "BRD4 593_601_1_1_S601 phospho",
    "BRD4 cnv",
    "BRD4 methyl",
    "BRD4 proteo",
    "BRD4 rna"
  ],
  "BRD7": [
    "BRD7 279_279_1_1_S279 phospho",
    "BRD7 cnv",
    "BRD7 proteo",
    "BRD7 rna"
  ],
  "BRD8": [
    "BRD8 390_390_1_1_S390 phospho",
    "BRD8 cnv",
    "BRD8 methyl",
    "BRD8 proteo",
    "BRD8 rna"
  ],
  "BRD9": [
    "BRD9 103_103_1_1_T103 phospho",
    "BRD9 566_568_1_1_S566 phospho",
    "BRD9 cnv",
    "BRD9 methyl",
    "BRD9 proteo",
    "BRD9 rna"
  ],
  "BRDT": [
    "BRDT cnv",
    "BRDT methyl",
    "BRDT rna"
  ],
  "BRF1": [
    "BRF1 454_473_1_1_S460 phospho",
    "BRF1 cnv",
    "BRF1 methyl",
    "BRF1 proteo",
    "BRF1 rna"
  ],
  "BRF2": [
    "BRF2 353_353_1_1_S353 phospho",
    "BRF2 cnv",
    "BRF2 methyl",
    "BRF2 rna"
  ],
  "BRI3": [
    "BRI3 cnv",
    "BRI3 methyl",
    "BRI3 proteo",
    "BRI3 rna"
  ],
  "BRI3BP": [
    "BRI3BP cnv",
    "BRI3BP methyl",
    "BRI3BP proteo",
    "BRI3BP rna"
  ],
  "BRICD5": [
    "BRICD5 cnv",
    "BRICD5 rna"
  ],
  "BRINP1": [
    "BRINP1 cnv",
    "BRINP1 methyl",
    "BRINP1 proteo",
    "BRINP1 rna"
  ],
  "BRINP2": [
    "BRINP2 cnv",
    "BRINP2 methyl",
    "BRINP2 rna"
  ],
  "BRINP3": [
    "BRINP3 cnv",
    "BRINP3 rna"
  ],
  "BRIP1": [
    "BRIP1 cnv",
    "BRIP1 methyl",
    "BRIP1 rna"
  ],
  "BRIX1": [
    "BRIX1 cnv",
    "BRIX1 methyl",
    "BRIX1 proteo",
    "BRIX1 rna"
  ],
  "BRK1": [
    "BRK1 cnv",
    "BRK1 methyl",
    "BRK1 proteo",
    "BRK1 rna"
  ],
  "BRME1": [
    "BRME1 503_509_1_1_S509 phospho",
    "BRME1 cnv",
    "BRME1 methyl",
    "BRME1 rna"
  ],
  "BRMS1": [
    "BRMS1 cnv",
    "BRMS1 methyl",
    "BRMS1 proteo",
    "BRMS1 rna"
  ],
  "BRMS1L": [
    "BRMS1L cnv",
    "BRMS1L methyl",
    "BRMS1L proteo",
    "BRMS1L rna"
  ],
  "BROX": [
    "BROX cnv",
    "BROX methyl",
    "BROX proteo",
    "BROX rna"
  ],
  "BRPF1": [
    "BRPF1 864_877_1_1_S866 phospho",
    "BRPF1 cnv",
    "BRPF1 methyl",
    "BRPF1 proteo",
    "BRPF1 rna"
  ],
  "BRPF3": [
    "BRPF3 17_22_2_2_S17S19 phospho",
    "BRPF3 cnv",
    "BRPF3 methyl",
    "BRPF3 rna"
  ],
  "BRS3": [
    "BRS3 rna"
  ],
  "BRSK1": [
    "BRSK1 384_388_1_1_S384 phospho",
    "BRSK1 399_417_1_1_S413 phospho",
    "BRSK1 432_447_1_1_S443 phospho",
    "BRSK1 499_508_1_1_S508 phospho",
    "BRSK1 511_523_1_1_S519 phospho",
    "BRSK1 743_758_1_1_S758 phospho",
    "BRSK1 cnv",
    "BRSK1 kinase",
    "BRSK1 methyl",
    "BRSK1 proteo",
    "BRSK1 rna"
  ],
  "BRSK2": [
    "BRSK2 291_308_1_1_S294 phospho",
    "BRSK2 367_367_1_1_S367 phospho",
    "BRSK2 382_393_1_1_S393 phospho",
    "BRSK2 412_427_1_1_S423 phospho",
    "BRSK2 431_435_1_1_S435 phospho",
    "BRSK2 501_513_1_0 phospho",
    "BRSK2 cnv",
    "BRSK2 kinase",
    "BRSK2 methyl",
    "BRSK2 proteo",
    "BRSK2 rna"
  ],
  "BRWD1": [
    "BRWD1 cnv",
    "BRWD1 methyl",
    "BRWD1 proteo",
    "BRWD1 rna"
  ],
  "BRWD1-AS2": [
    "BRWD1-AS2 methyl"
  ],
  "BRWD3": [
    "BRWD3 methyl",
    "BRWD3 proteo",
    "BRWD3 rna"
  ],
  "BSCL2": [
    "BSCL2 TDCDSSTTSLCSFPVANVSLTK-N2H5F0S0G0 glyco",
    "BSCL2 TDCDSSTTSLCSFPVANVSLTK-N2H6F0S0G0 glyco",
    "BSCL2 TDCDSSTTSLCSFPVANVSLTK-N2H8F0S0G0 glyco",
    "BSCL2 TDCDSSTTSLCSFPVANVSLTK-N2H9F0S0G0 glyco",
    "BSCL2 cnv",
    "BSCL2 methyl",
    "BSCL2 proteo",
    "BSCL2 rna"
  ],
  "BSDC1": [
    "BSDC1 404_409_1_1_S404 phospho",
    "BSDC1 cnv",
    "BSDC1 methyl",
    "BSDC1 proteo",
    "BSDC1 rna"
  ],
  "BSG": [
    "BSG 362_362_1_1_S362 phospho",
    "BSG ILLTCSLNDSATEVTGHR-N2H6F0S0G0 glyco",
    "BSG ILLTCSLNDSATEVTGHR-N2H8F0S0G0 glyco",
    "BSG ILLTCSLNDSATEVTGHR-N4H5F1S2G0 glyco",
    "BSG cnv",
    "BSG methyl",
    "BSG proteo",
    "BSG rna"
  ],
  "BSN": [
    "BSN 100_108_1_1_S108 phospho",
    "BSN 100_108_2_2_T103S108 phospho",
    "BSN 1090_1106_2_2_S1098S1104 phospho",
    "BSN 1090_1106_2_2_T1092S1098 phospho",
    "BSN 1090_1106_2_2_T1092S1104 phospho",
    "BSN 1149_1177_1_1_S1163 phospho",
    "BSN 1358_1367_1_1_S1362 phospho",
    "BSN 141_168_1_1_S145 phospho",
    "BSN 1455_1467_1_1_S1457 phospho",
    "BSN 1470_1492_1_1_S1477 phospho",
    "BSN 1660_1663_1_1_T1660 phospho",
    "BSN 1981_1996_1_0 phospho",
    "BSN 1981_1996_1_1_S1985 phospho",
    "BSN 2022_2024_1_1_S2024 phospho",
    "BSN 2032_2043_1_1_S2041 phospho",
    "BSN 2032_2049_1_1_S2041 phospho",
    "BSN 2061_2069_1_1_S2063 phospho",
    "BSN 238_252_2_2_S244S248 phospho",
    "BSN 2583_2594_1_1_T2587 phospho",
    "BSN 2607_2619_1_1_S2619 phospho",
    "BSN 2790_2802_1_1_S2802 phospho",
    "BSN 2823_2823_1_1_S2823 phospho",
    "BSN 2849_2863_1_1_S2851 phospho",
    "BSN 2849_2863_2_2_S2851S2857 phospho",
    "BSN 3291_3296_1_1_S3291 phospho",
    "BSN 3370_3373_1_1_S3373 phospho",
    "BSN 3373_3373_1_1_S3373 phospho",
    "BSN 3499_3509_1_1_S3502 phospho",
    "BSN 3499_3509_1_1_S3509 phospho",
    "BSN cnv",
    "BSN methyl",
    "BSN proteo",
    "BSN rna"
  ],
  "BSN-DT": [
    "BSN-DT methyl"
  ],
  "BSND": [
    "BSND cnv",
    "BSND rna"
  ],
  "BSPH1": [
    "BSPH1 cnv"
  ],
  "BSPRY": [
    "BSPRY cnv",
    "BSPRY methyl",
    "BSPRY rna"
  ],
  "BST1": [
    "BST1 DSSGVIHVMLNGSEPTGAYPIK-N2H6F0S0G0 glyco",
    "BST1 cnv",
    "BST1 methyl",
    "BST1 proteo",
    "BST1 rna"
  ],
  "BST2": [
    "BST2 cnv",
    "BST2 proteo",
    "BST2 rna"
  ],
  "BSX": [
    "BSX cnv",
    "BSX rna"
  ],
  "BTAF1": [
    "BTAF1 224_230_1_1_S224 phospho",
    "BTAF1 cnv",
    "BTAF1 methyl",
    "BTAF1 proteo",
    "BTAF1 rna"
  ],
  "BTBD1": [
    "BTBD1 cnv",
    "BTBD1 methyl",
    "BTBD1 proteo",
    "BTBD1 rna"
  ],
  "BTBD10": [
    "BTBD10 58_64_1_1_S64 phospho",
    "BTBD10 cnv",
    "BTBD10 methyl",
    "BTBD10 rna"
  ],
  "BTBD16": [
    "BTBD16 cnv",
    "BTBD16 rna"
  ],
  "BTBD17": [
    "BTBD17 FFDVNGSAFLPR-N2H8F0S0G0 glyco",
    "BTBD17 QGNASDVVLR-N2H5F0S0G0 glyco",
    "BTBD17 cnv",
    "BTBD17 proteo",
    "BTBD17 rna"
  ],
  "BTBD18": [
    "BTBD18 cnv",
    "BTBD18 methyl",
    "BTBD18 rna"
  ],
  "BTBD19": [
    "BTBD19 cnv",
    "BTBD19 methyl",
    "BTBD19 rna"
  ],
  "BTBD2": [
    "BTBD2 cnv",
    "BTBD2 methyl",
    "BTBD2 proteo",
    "BTBD2 rna"
  ],
  "BTBD3": [
    "BTBD3 cnv",
    "BTBD3 methyl",
    "BTBD3 rna"
  ],
  "BTBD6": [
    "BTBD6 cnv",
    "BTBD6 methyl",
    "BTBD6 rna"
  ],
  "BTBD7": [
    "BTBD7 cnv",
    "BTBD7 methyl",
    "BTBD7 rna"
  ],
  "BTBD8": [
    "BTBD8 346_356_1_1_S353 phospho",
    "BTBD8 359_366_1_1_S366 phospho",
    "BTBD8 cnv",
    "BTBD8 methyl",
    "BTBD8 proteo",
    "BTBD8 rna"
  ],
  "BTBD9": [
    "BTBD9 cnv",
    "BTBD9 methyl",
    "BTBD9 rna"
  ],
  "BTC": [
    "BTC cnv",
    "BTC methyl",
    "BTC rna"
  ],
  "BTD": [
    "BTD DVQIIVFPEDGIHGFNFTR-N4H5F0S2G0 glyco",
    "BTD cnv",
    "BTD methyl",
    "BTD proteo",
    "BTD rna"
  ],
  "BTF3": [
    "BTF3 cnv",
    "BTF3 methyl",
    "BTF3 proteo",
    "BTF3 rna"
  ],
  "BTF3L4": [
    "BTF3L4 cnv",
    "BTF3L4 methyl",
    "BTF3L4 proteo",
    "BTF3L4 rna"
  ],
  "BTG1": [
    "BTG1 cnv",
    "BTG1 methyl",
    "BTG1 rna"
  ],
  "BTG2": [
    "BTG2 cnv",
    "BTG2 methyl",
    "BTG2 rna"
  ],
  "BTG2-DT": [
    "BTG2-DT methyl"
  ],
  "BTG3": [
    "BTG3 cnv",
    "BTG3 methyl",
    "BTG3 rna"
  ],
  "BTG4": [
    "BTG4 cnv",
    "BTG4 methyl",
    "BTG4 rna"
  ],
  "BTK": [
    "BTK kinase",
    "BTK methyl",
    "BTK proteo",
    "BTK rna"
  ],
  "BTLA": [
    "BTLA cnv",
    "BTLA rna"
  ],
  "BTN1A1": [
    "BTN1A1 cnv",
    "BTN1A1 rna"
  ],
  "BTN2A1": [
    "BTN2A1 cnv",
    "BTN2A1 methyl",
    "BTN2A1 proteo",
    "BTN2A1 rna"
  ],
  "BTN2A2": [
    "BTN2A2 cnv",
    "BTN2A2 rna"
  ],
  "BTN3A1": [
    "BTN3A1 IHNVTASDSGK-N2H6F0S0G0 glyco",
    "BTN3A1 IHNVTASDSGK-N4H3F1S0G0 glyco",
    "BTN3A1 cnv",
    "BTN3A1 proteo",
    "BTN3A1 rna"
  ],
  "BTN3A2": [
    "BTN3A2 cnv",
    "BTN3A2 proteo",
    "BTN3A2 rna"
  ],
  "BTN3A3": [
    "BTN3A3 IHNVTASDSGK-N2H5F0S0G0 glyco",
    "BTN3A3 IHNVTASDSGK-N2H8F0S0G0 glyco",
    "BTN3A3 cnv",
    "BTN3A3 proteo",
    "BTN3A3 rna"
  ],
  "BTNL2": [
    "BTNL2 cnv",
    "BTNL2 rna"
  ],
  "BTNL3": [
    "BTNL3 cnv",
    "BTNL3 rna"
  ],
  "BTNL8": [
    "BTNL8 cnv",
    "BTNL8 rna"
  ],
  "BTNL9": [
    "BTNL9 cnv",
    "BTNL9 methyl",
    "BTNL9 rna"
  ],
  "BTRC": [
    "BTRC cnv",
    "BTRC methyl",
    "BTRC rna"
  ],
  "BUB1": [
    "BUB1 cnv",
    "BUB1 kinase",
    "BUB1 methyl",
    "BUB1 rna"
  ],
  "BUB1B": [
    "BUB1B 543_543_1_1_S543 phospho",
    "BUB1B 670_676_1_1_S670 phospho",
    "BUB1B LSQNISELK-N3H4F2S0G0 glyco",
    "BUB1B cnv",
    "BUB1B kinase",
    "BUB1B methyl",
    "BUB1B proteo",
    "BUB1B rna"
  ],
  "BUB1B-PAK6": [
    "BUB1B-PAK6 cnv",
    "BUB1B-PAK6 rna"
  ],
  "BUB3": [
    "BUB3 207_211_1_1_S211 phospho",
    "BUB3 cnv",
    "BUB3 methyl",
    "BUB3 proteo",
    "BUB3 rna"
  ],
  "BUD13": [
    "BUD13 123_127_1_1_S127 phospho",
    "BUD13 123_127_2_2_T123S127 phospho",
    "BUD13 135_139_1_1_T135 phospho",
    "BUD13 135_139_2_2_T135S139 phospho",
    "BUD13 147_151_2_2_T147S151 phospho",
    "BUD13 159_163_2_2_T159S163 phospho",
    "BUD13 172_175_2_0 phospho",
    "BUD13 197_201_2_2_S197S201 phospho",
    "BUD13 197_214_3_0 phospho",
    "BUD13 222_226_2_2_S222S226 phospho",
    "BUD13 248_252_1_1_S248 phospho",
    "BUD13 271_281_1_1_S271 phospho",
    "BUD13 316_325_1_1_S325 phospho",
    "BUD13 318_325_1_1_S325 phospho",
    "BUD13 cnv",
    "BUD13 methyl",
    "BUD13 proteo",
    "BUD13 rna"
  ],
  "BUD23": [
    "BUD23 cnv",
    "BUD23 methyl",
    "BUD23 rna"
  ],
  "BUD31": [
    "BUD31 cnv",
    "BUD31 methyl",
    "BUD31 proteo",
    "BUD31 rna"
  ],
  "BVES": [
    "BVES cnv",
    "BVES methyl",
    "BVES rna"
  ],
  "BVES-AS1": [
    "BVES-AS1 methyl"
  ],
  "BYSL": [
    "BYSL 98_107_1_1_S98 phospho",
    "BYSL cnv",
    "BYSL methyl",
    "BYSL proteo",
    "BYSL rna"
  ],
  "BZW1": [
    "BZW1 cnv",
    "BZW1 methyl",
    "BZW1 proteo",
    "BZW1 rna"
  ],
  "BZW1-AS1": [
    "BZW1-AS1 methyl"
  ],
  "BZW2": [
    "BZW2 cnv",
    "BZW2 methyl",
    "BZW2 proteo",
    "BZW2 rna"
  ],
  "C10orf105": [
    "C10orf105 cnv",
    "C10orf105 rna"
  ],
  "C10orf120": [
    "C10orf120 cnv"
  ],
  "C10orf143": [
    "C10orf143 cnv",
    "C10orf143 methyl",
    "C10orf143 rna"
  ],
  "C10orf53": [
    "C10orf53 cnv",
    "C10orf53 methyl",
    "C10orf53 rna"
  ],
  "C10orf62": [
    "C10orf62 cnv",
    "C10orf62 rna"
  ],
  "C10orf67": [
    "C10orf67 cnv",
    "C10orf67 rna"
  ],
  "C10orf67-AS1": [
    "C10orf67-AS1 methyl"
  ],
  "C10orf71": [
    "C10orf71 cnv",
    "C10orf71 rna"
  ],
  "C10orf82": [
    "C10orf82 cnv",
    "C10orf82 methyl",
    "C10orf82 rna"
  ],
  "C10orf88": [
    "C10orf88 cnv",
    "C10orf88 methyl",
    "C10orf88 rna"
  ],
  "C10orf90": [
    "C10orf90 cnv",
    "C10orf90 methyl",
    "C10orf90 rna"
  ],
  "C10orf95": [
    "C10orf95 cnv",
    "C10orf95 rna"
  ],
  "C10orf95-AS1": [
    "C10orf95-AS1 methyl"
  ],
  "C11orf1": [
    "C11orf1 cnv",
    "C11orf1 methyl",
    "C11orf1 rna"
  ],
  "C11orf16": [
    "C11orf16 cnv",
    "C11orf16 rna"
  ],
  "C11orf21": [
    "C11orf21 cnv",
    "C11orf21 rna"
  ],
  "C11orf24": [
    "C11orf24 cnv",
    "C11orf24 methyl",
    "C11orf24 rna"
  ],
  "C11orf42": [
    "C11orf42 cnv",
    "C11orf42 rna"
  ],
  "C11orf52": [
    "C11orf52 cnv",
    "C11orf52 rna"
  ],
  "C11orf54": [
    "C11orf54 cnv",
    "C11orf54 methyl",
    "C11orf54 proteo",
    "C11orf54 rna"
  ],
  "C11orf58": [
    "C11orf58 147_147_1_1_S147 phospho",
    "C11orf58 15_25_1_0 phospho",
    "C11orf58 15_25_1_1_S17 phospho",
    "C11orf58 cnv",
    "C11orf58 methyl",
    "C11orf58 proteo",
    "C11orf58 rna"
  ],
  "C11orf65": [
    "C11orf65 cnv",
    "C11orf65 rna"
  ],
  "C11orf68": [
    "C11orf68 cnv",
    "C11orf68 methyl",
    "C11orf68 proteo",
    "C11orf68 rna"
  ],
  "C11orf71": [
    "C11orf71 cnv",
    "C11orf71 methyl",
    "C11orf71 rna"
  ],
  "C11orf80": [
    "C11orf80 cnv",
    "C11orf80 methyl",
    "C11orf80 rna"
  ],
  "C11orf86": [
    "C11orf86 cnv",
    "C11orf86 rna"
  ],
  "C11orf87": [
    "C11orf87 cnv",
    "C11orf87 methyl",
    "C11orf87 rna"
  ],
  "C11orf91": [
    "C11orf91 cnv",
    "C11orf91 methyl",
    "C11orf91 rna"
  ],
  "C11orf94": [
    "C11orf94 cnv",
    "C11orf94 rna"
  ],
  "C11orf96": [
    "C11orf96 55_72_1_1_S72 phospho",
    "C11orf96 82_86_1_1_S86 phospho",
    "C11orf96 93_98_1_1_S93 phospho",
    "C11orf96 cnv",
    "C11orf96 methyl",
    "C11orf96 proteo",
    "C11orf96 rna"
  ],
  "C11orf97": [
    "C11orf97 cnv",
    "C11orf97 methyl",
    "C11orf97 rna"
  ],
  "C11orf98": [
    "C11orf98 cnv",
    "C11orf98 methyl",
    "C11orf98 proteo",
    "C11orf98 rna"
  ],
  "C12orf29": [
    "C12orf29 cnv",
    "C12orf29 methyl",
    "C12orf29 proteo",
    "C12orf29 rna"
  ],
  "C12orf4": [
    "C12orf4 cnv",
    "C12orf4 methyl",
    "C12orf4 proteo",
    "C12orf4 rna"
  ],
  "C12orf40": [
    "C12orf40 cnv",
    "C12orf40 rna"
  ],
  "C12orf42": [
    "C12orf42 cnv",
    "C12orf42 methyl",
    "C12orf42 rna"
  ],
  "C12orf43": [
    "C12orf43 169_169_1_1_S169 phospho",
    "C12orf43 198_213_1_1_S210 phospho",
    "C12orf43 cnv",
    "C12orf43 methyl",
    "C12orf43 proteo",
    "C12orf43 rna"
  ],
  "C12orf50": [
    "C12orf50 cnv",
    "C12orf50 rna"
  ],
  "C12orf54": [
    "C12orf54 cnv",
    "C12orf54 rna"
  ],
  "C12orf56": [
    "C12orf56 cnv",
    "C12orf56 methyl",
    "C12orf56 rna"
  ],
  "C12orf57": [
    "C12orf57 cnv",
    "C12orf57 methyl",
    "C12orf57 proteo",
    "C12orf57 rna"
  ],
  "C12orf60": [
    "C12orf60 cnv",
    "C12orf60 methyl",
    "C12orf60 rna"
  ],
  "C12orf71": [
    "C12orf71 cnv",
    "C12orf71 rna"
  ],
  "C12orf73": [
    "C12orf73 cnv",
    "C12orf73 methyl",
    "C12orf73 proteo",
    "C12orf73 rna"
  ],
  "C12orf75": [
    "C12orf75 cnv",
    "C12orf75 methyl",
    "C12orf75 proteo",
    "C12orf75 rna"
  ],
  "C12orf76": [
    "C12orf76 cnv",
    "C12orf76 methyl",
    "C12orf76 rna"
  ],
  "C13orf42": [
    "C13orf42 cnv",
    "C13orf42 rna"
  ],
  "C13orf46": [
    "C13orf46 cnv",
    "C13orf46 methyl",
    "C13orf46 rna"
  ],
  "C14orf119": [
    "C14orf119 cnv",
    "C14orf119 methyl",
    "C14orf119 rna"
  ],
  "C14orf132": [
    "C14orf132 cnv",
    "C14orf132 methyl",
    "C14orf132 rna"
  ],
  "C14orf178": [
    "C14orf178 cnv",
    "C14orf178 methyl",
    "C14orf178 rna"
  ],
  "C14orf180": [
    "C14orf180 cnv",
    "C14orf180 rna"
  ],
  "C14orf28": [
    "C14orf28 cnv",
    "C14orf28 methyl",
    "C14orf28 rna"
  ],
  "C14orf39": [
    "C14orf39 cnv",
    "C14orf39 methyl",
    "C14orf39 rna"
  ],
  "C14orf93": [
    "C14orf93 cnv",
    "C14orf93 methyl",
    "C14orf93 rna"
  ],
  "C15orf39": [
    "C15orf39 cnv",
    "C15orf39 methyl",
    "C15orf39 rna"
  ],
  "C15orf40": [
    "C15orf40 cnv",
    "C15orf40 methyl",
    "C15orf40 proteo",
    "C15orf40 rna"
  ],
  "C15orf48": [
    "C15orf48 cnv",
    "C15orf48 methyl",
    "C15orf48 rna"
  ],
  "C15orf61": [
    "C15orf61 cnv",
    "C15orf61 methyl",
    "C15orf61 rna"
  ],
  "C15orf62": [
    "C15orf62 cnv",
    "C15orf62 rna"
  ],
  "C16orf46": [
    "C16orf46 cnv",
    "C16orf46 methyl",
    "C16orf46 rna"
  ],
  "C16orf54": [
    "C16orf54 194_194_1_1_S194 phospho",
    "C16orf54 cnv",
    "C16orf54 rna"
  ],
  "C16orf72": [
    "C16orf72 cnv",
    "C16orf72 methyl",
    "C16orf72 rna"
  ],
  "C16orf74": [
    "C16orf74 41_46_1_1_T44 phospho",
    "C16orf74 cnv",
    "C16orf74 methyl",
    "C16orf74 rna"
  ],
  "C16orf78": [
    "C16orf78 cnv"
  ],
  "C16orf82": [
    "C16orf82 cnv",
    "C16orf82 rna"
  ],
  "C16orf86": [
    "C16orf86 cnv",
    "C16orf86 methyl",
    "C16orf86 rna"
  ],
  "C16orf87": [
    "C16orf87 89_93_1_1_S91 phospho",
    "C16orf87 cnv",
    "C16orf87 methyl",
    "C16orf87 rna"
  ],
  "C16orf89": [
    "C16orf89 cnv",
    "C16orf89 rna"
  ],
  "C16orf90": [
    "C16orf90 cnv",
    "C16orf90 methyl",
    "C16orf90 rna"
  ],
  "C16orf91": [
    "C16orf91 cnv",
    "C16orf91 methyl",
    "C16orf91 proteo",
    "C16orf91 rna"
  ],
  "C16orf92": [
    "C16orf92 cnv",
    "C16orf92 rna"
  ],
  "C16orf95": [
    "C16orf95 cnv",
    "C16orf95 methyl",
    "C16orf95 rna"
  ],
  "C16orf95-DT": [
    "C16orf95-DT methyl"
  ],
  "C16orf96": [
    "C16orf96 cnv",
    "C16orf96 rna"
  ],
  "C17orf100": [
    "C17orf100 cnv",
    "C17orf100 methyl",
    "C17orf100 proteo",
    "C17orf100 rna"
  ],
  "C17orf107": [
    "C17orf107 cnv",
    "C17orf107 methyl",
    "C17orf107 rna"
  ],
  "C17orf113": [
    "C17orf113 cnv",
    "C17orf113 methyl",
    "C17orf113 rna"
  ],
  "C17orf114": [
    "C17orf114 cnv",
    "C17orf114 rna"
  ],
  "C17orf49": [
    "C17orf49 51_62_1_1_S62 phospho",
    "C17orf49 72_88_1_1_S72 phospho",
    "C17orf49 cnv",
    "C17orf49 methyl",
    "C17orf49 proteo",
    "C17orf49 rna"
  ],
  "C17orf50": [
    "C17orf50 cnv",
    "C17orf50 rna"
  ],
  "C17orf58": [
    "C17orf58 cnv",
    "C17orf58 methyl",
    "C17orf58 rna"
  ],
  "C17orf64": [
    "C17orf64 cnv",
    "C17orf64 methyl",
    "C17orf64 rna"
  ],
  "C17orf67": [
    "C17orf67 cnv",
    "C17orf67 methyl",
    "C17orf67 rna"
  ],
  "C17orf75": [
    "C17orf75 cnv",
    "C17orf75 methyl",
    "C17orf75 proteo",
    "C17orf75 rna"
  ],
  "C17orf78": [
    "C17orf78 cnv",
    "C17orf78 rna"
  ],
  "C17orf80": [
    "C17orf80 cnv",
    "C17orf80 methyl",
    "C17orf80 proteo",
    "C17orf80 rna"
  ],
  "C17orf97": [
    "C17orf97 cnv",
    "C17orf97 methyl",
    "C17orf97 proteo",
    "C17orf97 rna"
  ],
  "C17orf98": [
    "C17orf98 cnv",
    "C17orf98 rna"
  ],
  "C17orf99": [
    "C17orf99 cnv",
    "C17orf99 rna"
  ],
  "C18orf21": [
    "C18orf21 cnv",
    "C18orf21 methyl",
    "C18orf21 rna"
  ],
  "C18orf25": [
    "C18orf25 143_151_1_1_S143 phospho",
    "C18orf25 143_151_1_1_S145 phospho",
    "C18orf25 143_151_2_0 phospho",
    "C18orf25 143_151_2_2_S143S145 phospho",
    "C18orf25 143_151_2_2_S145S147 phospho",
    "C18orf25 66_81_1_1_S67 phospho",
    "C18orf25 cnv",
    "C18orf25 methyl",
    "C18orf25 proteo",
    "C18orf25 rna"
  ],
  "C18orf32": [
    "C18orf32 cnv",
    "C18orf32 methyl",
    "C18orf32 proteo",
    "C18orf32 rna"
  ],
  "C18orf54": [
    "C18orf54 cnv",
    "C18orf54 methyl",
    "C18orf54 rna"
  ],
  "C18orf63": [
    "C18orf63 cnv",
    "C18orf63 methyl"
  ],
  "C19orf12": [
    "C19orf12 cnv",
    "C19orf12 methyl",
    "C19orf12 proteo",
    "C19orf12 rna"
  ],
  "C19orf18": [
    "C19orf18 cnv",
    "C19orf18 rna"
  ],
  "C19orf25": [
    "C19orf25 cnv",
    "C19orf25 methyl",
    "C19orf25 proteo",
    "C19orf25 rna"
  ],
  "C19orf33": [
    "C19orf33 cnv",
    "C19orf33 proteo",
    "C19orf33 rna"
  ],
  "C19orf38": [
    "C19orf38 cnv",
    "C19orf38 methyl",
    "C19orf38 rna"
  ],
  "C19orf44": [
    "C19orf44 cnv",
    "C19orf44 methyl",
    "C19orf44 rna"
  ],
  "C19orf47": [
    "C19orf47 118_126_1_1_S124 phospho",
    "C19orf47 144_155_1_1_S151 phospho",
    "C19orf47 cnv",
    "C19orf47 methyl",
    "C19orf47 rna"
  ],
  "C19orf48": [
    "C19orf48 cnv",
    "C19orf48 methyl",
    "C19orf48 rna"
  ],
  "C19orf53": [
    "C19orf53 cnv",
    "C19orf53 methyl",
    "C19orf53 proteo",
    "C19orf53 rna"
  ],
  "C19orf54": [
    "C19orf54 cnv",
    "C19orf54 methyl",
    "C19orf54 rna"
  ],
  "C19orf67": [
    "C19orf67 cnv",
    "C19orf67 methyl",
    "C19orf67 rna"
  ],
  "C19orf73": [
    "C19orf73 cnv",
    "C19orf73 methyl",
    "C19orf73 rna"
  ],
  "C19orf81": [
    "C19orf81 cnv",
    "C19orf81 rna"
  ],
  "C19orf84": [
    "C19orf84 cnv",
    "C19orf84 rna"
  ],
  "C19orf85": [
    "C19orf85 cnv"
  ],
  "C1D": [
    "C1D cnv",
    "C1D proteo",
    "C1D rna"
  ],
  "C1GALT1": [
    "C1GALT1 cnv",
    "C1GALT1 methyl",
    "C1GALT1 rna"
  ],
  "C1GALT1C1": [
    "C1GALT1C1 methyl",
    "C1GALT1C1 rna"
  ],
  "C1GALT1C1L": [
    "C1GALT1C1L cnv",
    "C1GALT1C1L rna"
  ],
  "C1QA": [
    "C1QA NPPMGGNVVIFDTVITNQEEPYQNHSGR-N4H5F0S1G0 glyco",
    "C1QA NPPMGGNVVIFDTVITNQEEPYQNHSGR-N4H5F0S2G0 glyco",
    "C1QA NPPMGGNVVIFDTVITNQEEPYQNHSGR-N4H5F1S1G0 glyco",
    "C1QA NPPMGGNVVIFDTVITNQEEPYQNHSGR-N4H5F1S2G0 glyco",
    "C1QA NPPMGGNVVIFDTVITNQEEPYQNHSGR-N4H5F2S1G0 glyco",
    "C1QA RNPPMGGNVVIFDTVITNQEEPYQNHSGR-N4H5F0S1G0 glyco",
    "C1QA RNPPMGGNVVIFDTVITNQEEPYQNHSGR-N4H5F0S2G0 glyco",
    "C1QA RNPPMGGNVVIFDTVITNQEEPYQNHSGR-N4H5F1S1G0 glyco",
    "C1QA RNPPMGGNVVIFDTVITNQEEPYQNHSGR-N4H5F1S2G0 glyco",
    "C1QA RNPPMGGNVVIFDTVITNQEEPYQNHSGR-N4H5F2S1G0 glyco",
    "C1QA RNPPMGGNVVIFDTVITNQEEPYQNHSGR-N4H5F3S1G0 glyco",
    "C1QA cnv",
    "C1QA proteo",
    "C1QA rna"
  ],
  "C1QB": [
    "C1QB cnv",
    "C1QB proteo",
    "C1QB rna"
  ],
  "C1QBP": [
    "C1QBP cnv",
    "C1QBP methyl",
    "C1QBP proteo",
    "C1QBP rna"
  ],
  "C1QC": [
    "C1QC cnv",
    "C1QC proteo",
    "C1QC rna"
  ],
  "C1QL1": [
    "C1QL1 cnv",
    "C1QL1 methyl",
    "C1QL1 proteo",
    "C1QL1 rna"
  ],
  "C1QL2": [
    "C1QL2 cnv",
    "C1QL2 methyl",
    "C1QL2 rna"
  ],
  "C1QL3": [
    "C1QL3 cnv",
    "C1QL3 methyl",
    "C1QL3 rna"
  ],
  "C1QL4": [
    "C1QL4 cnv",
    "C1QL4 methyl",
    "C1QL4 rna"
  ],
  "C1QTNF1": [
    "C1QTNF1 cnv",
    "C1QTNF1 methyl",
    "C1QTNF1 rna"
  ],
  "C1QTNF12": [
    "C1QTNF12 cnv",
    "C1QTNF12 methyl",
    "C1QTNF12 rna"
  ],
  "C1QTNF2": [
    "C1QTNF2 cnv",
    "C1QTNF2 methyl",
    "C1QTNF2 rna"
  ],
  "C1QTNF3": [
    "C1QTNF3 cnv",
    "C1QTNF3 proteo",
    "C1QTNF3 rna"
  ],
  "C1QTNF3-AMACR": [
    "C1QTNF3-AMACR cnv",
    "C1QTNF3-AMACR rna"
  ],
  "C1QTNF4": [
    "C1QTNF4 cnv",
    "C1QTNF4 methyl",
    "C1QTNF4 rna"
  ],
  "C1QTNF5": [
    "C1QTNF5 cnv",
    "C1QTNF5 methyl",
    "C1QTNF5 proteo",
    "C1QTNF5 rna"
  ],
  "C1QTNF6": [
    "C1QTNF6 cnv",
    "C1QTNF6 methyl",
    "C1QTNF6 rna"
  ],
  "C1QTNF7": [
    "C1QTNF7 cnv",
    "C1QTNF7 rna"
  ],
  "C1QTNF8": [
    "C1QTNF8 cnv",
    "C1QTNF8 rna"
  ],
  "C1QTNF9": [
    "C1QTNF9 cnv",
    "C1QTNF9 rna"
  ],
  "C1QTNF9B": [
    "C1QTNF9B cnv",
    "C1QTNF9B rna"
  ],
  "C1R": [
    "C1R 555_560_1_1_S555 phospho",
    "C1R EHEAQSNASLDVFLGHTNVEELMK-N4H5F0S2G0 glyco",
    "C1R EHEAQSNASLDVFLGHTNVEELMK-N4H5F2S1G0 glyco",
    "C1R cnv",
    "C1R proteo",
    "C1R rna"
  ],
  "C1RL": [
    "C1RL NQSVNVFLGHTAIDEMLK-N4H5F0S2G0 glyco",
    "C1RL cnv",
    "C1RL proteo",
    "C1RL rna"
  ],
  "C1S": [
    "C1S cnv",
    "C1S proteo",
    "C1S rna"
  ],
  "C1orf100": [
    "C1orf100 cnv",
    "C1orf100 rna"
  ],
  "C1orf105": [
    "C1orf105 cnv",
    "C1orf105 rna"
  ],
  "C1orf109": [
    "C1orf109 cnv",
    "C1orf109 methyl",
    "C1orf109 rna"
  ],
  "C1orf112": [
    "C1orf112 cnv",
    "C1orf112 methyl",
    "C1orf112 rna"
  ],
  "C1orf115": [
    "C1orf115 cnv",
    "C1orf115 methyl",
    "C1orf115 rna"
  ],
  "C1orf116": [
    "C1orf116 cnv",
    "C1orf116 rna"
  ],
  "C1orf122": [
    "C1orf122 cnv",
    "C1orf122 methyl",
    "C1orf122 proteo",
    "C1orf122 rna"
  ],
  "C1orf127": [
    "C1orf127 cnv",
    "C1orf127 rna"
  ],
  "C1orf131": [
    "C1orf131 cnv",
    "C1orf131 methyl",
    "C1orf131 rna"
  ],
  "C1orf141": [
    "C1orf141 cnv",
    "C1orf141 methyl",
    "C1orf141 rna"
  ],
  "C1orf146": [
    "C1orf146 cnv",
    "C1orf146 methyl"
  ],
  "C1orf159": [
    "C1orf159 cnv",
    "C1orf159 methyl",
    "C1orf159 proteo",
    "C1orf159 rna"
  ],
  "C1orf162": [
    "C1orf162 cnv",
    "C1orf162 rna"
  ],
  "C1orf167": [
    "C1orf167 cnv",
    "C1orf167 methyl",
    "C1orf167 rna"
  ],
  "C1orf174": [
    "C1orf174 145_158_1_1_S148 phospho",
    "C1orf174 40_47_1_1_S46 phospho",
    "C1orf174 cnv",
    "C1orf174 methyl",
    "C1orf174 proteo",
    "C1orf174 rna"
  ],
  "C1orf185": [
    "C1orf185 cnv",
    "C1orf185 rna"
  ],
  "C1orf198": [
    "C1orf198 234_251_1_1_S251 phospho",
    "C1orf198 251_251_1_1_S251 phospho",
    "C1orf198 251_265_1_1_S251 phospho",
    "C1orf198 91_118_1_1_S91 phospho",
    "C1orf198 cnv",
    "C1orf198 methyl",
    "C1orf198 proteo",
    "C1orf198 rna"
  ],
  "C1orf21": [
    "C1orf21 113_121_1_1_S115 phospho",
    "C1orf21 93_95_1_1_S95 phospho",
    "C1orf21 cnv",
    "C1orf21 methyl",
    "C1orf21 proteo",
    "C1orf21 rna"
  ],
  "C1orf210": [
    "C1orf210 cnv",
    "C1orf210 rna"
  ],
  "C1orf216": [
    "C1orf216 124_133_1_1_S126 phospho",
    "C1orf216 cnv",
    "C1orf216 methyl",
    "C1orf216 rna"
  ],
  "C1orf220": [
    "C1orf220 methyl"
  ],
  "C1orf226": [
    "C1orf226 18_23_1_1_S18 phospho",
    "C1orf226 196_198_1_1_S198 phospho",
    "C1orf226 222_225_1_1_S223 phospho",
    "C1orf226 222_225_2_2_S222S223 phospho",
    "C1orf226 235_249_1_1_S249 phospho",
    "C1orf226 256_270_1_1_S258 phospho",
    "C1orf226 cnv",
    "C1orf226 methyl",
    "C1orf226 proteo",
    "C1orf226 rna"
  ],
  "C1orf232": [
    "C1orf232 cnv",
    "C1orf232 methyl",
    "C1orf232 rna"
  ],
  "C1orf35": [
    "C1orf35 175_181_1_1_S177 phospho",
    "C1orf35 231_235_2_2_S231S235 phospho",
    "C1orf35 231_235_3_3_S231S233S235 phospho",
    "C1orf35 cnv",
    "C1orf35 methyl",
    "C1orf35 proteo",
    "C1orf35 rna"
  ],
  "C1orf43": [
    "C1orf43 cnv",
    "C1orf43 methyl",
    "C1orf43 proteo",
    "C1orf43 rna"
  ],
  "C1orf50": [
    "C1orf50 cnv",
    "C1orf50 methyl",
    "C1orf50 proteo",
    "C1orf50 rna"
  ],
  "C1orf52": [
    "C1orf52 155_158_1_1_S158 phospho",
    "C1orf52 155_167_1_1_S158 phospho",
    "C1orf52 cnv",
    "C1orf52 methyl",
    "C1orf52 proteo",
    "C1orf52 rna"
  ],
  "C1orf53": [
    "C1orf53 cnv",
    "C1orf53 methyl",
    "C1orf53 rna"
  ],
  "C1orf54": [
    "C1orf54 cnv",
    "C1orf54 methyl",
    "C1orf54 rna"
  ],
  "C1orf56": [
    "C1orf56 cnv",
    "C1orf56 methyl",
    "C1orf56 rna"
  ],
  "C1orf68": [
    "C1orf68 cnv"
  ],
  "C1orf74": [
    "C1orf74 cnv",
    "C1orf74 methyl",
    "C1orf74 rna"
  ],
  "C1orf87": [
    "C1orf87 cnv",
    "C1orf87 methyl",
    "C1orf87 rna"
  ],
  "C1orf94": [
    "C1orf94 cnv",
    "C1orf94 methyl",
    "C1orf94 rna"
  ],
  "C2": [
    "C2 cnv",
    "C2 methyl",
    "C2 proteo",
    "C2 rna"
  ],
  "C20orf141": [
    "C20orf141 cnv",
    "C20orf141 rna"
  ],
  "C20orf144": [
    "C20orf144 cnv",
    "C20orf144 rna"
  ],
  "C20orf173": [
    "C20orf173 cnv",
    "C20orf173 rna"
  ],
  "C20orf202": [
    "C20orf202 cnv",
    "C20orf202 methyl",
    "C20orf202 rna"
  ],
  "C20orf203": [
    "C20orf203 cnv",
    "C20orf203 methyl",
    "C20orf203 rna"
  ],
  "C20orf204": [
    "C20orf204 cnv",
    "C20orf204 methyl",
    "C20orf204 rna"
  ],
  "C20orf27": [
    "C20orf27 188_193_1_1_S190 phospho",
    "C20orf27 cnv",
    "C20orf27 methyl",
    "C20orf27 proteo",
    "C20orf27 rna"
  ],
  "C20orf85": [
    "C20orf85 cnv",
    "C20orf85 methyl",
    "C20orf85 rna"
  ],
  "C20orf96": [
    "C20orf96 cnv",
    "C20orf96 methyl",
    "C20orf96 rna"
  ],
  "C21orf140": [
    "C21orf140 cnv",
    "C21orf140 rna"
  ],
  "C21orf58": [
    "C21orf58 cnv",
    "C21orf58 methyl",
    "C21orf58 rna"
  ],
  "C21orf62": [
    "C21orf62 cnv",
    "C21orf62 rna"
  ],
  "C21orf91": [
    "C21orf91 cnv",
    "C21orf91 methyl",
    "C21orf91 rna"
  ],
  "C22orf15": [
    "C22orf15 cnv",
    "C22orf15 rna"
  ],
  "C22orf23": [
    "C22orf23 cnv",
    "C22orf23 methyl",
    "C22orf23 rna"
  ],
  "C22orf31": [
    "C22orf31 cnv",
    "C22orf31 rna"
  ],
  "C22orf39": [
    "C22orf39 cnv",
    "C22orf39 methyl",
    "C22orf39 rna"
  ],
  "C22orf42": [
    "C22orf42 cnv",
    "C22orf42 rna"
  ],
  "C22orf46": [
    "C22orf46 methyl"
  ],
  "C2CD2": [
    "C2CD2 435_441_1_1_S441 phospho",
    "C2CD2 511_519_1_1_S511 phospho",
    "C2CD2 647_662_1_1_S649 phospho",
    "C2CD2 cnv",
    "C2CD2 methyl",
    "C2CD2 proteo",
    "C2CD2 rna"
  ],
  "C2CD2L": [
    "C2CD2L 356_380_1_1_S374 phospho",
    "C2CD2L 400_411_1_1_S411 phospho",
    "C2CD2L 417_430_1_1_T417 phospho",
    "C2CD2L cnv",
    "C2CD2L methyl",
    "C2CD2L proteo",
    "C2CD2L rna"
  ],
  "C2CD3": [
    "C2CD3 2016_2028_2_2_S2018S2020 phospho",
    "C2CD3 cnv",
    "C2CD3 methyl",
    "C2CD3 proteo",
    "C2CD3 rna"
  ],
  "C2CD4A": [
    "C2CD4A cnv",
    "C2CD4A rna"
  ],
  "C2CD4B": [
    "C2CD4B cnv",
    "C2CD4B methyl",
    "C2CD4B rna"
  ],
  "C2CD4C": [
    "C2CD4C 146_159_1_1_S156 phospho",
    "C2CD4C 262_276_1_1_S262 phospho",
    "C2CD4C 262_276_1_1_S273 phospho",
    "C2CD4C 262_276_2_2_S262S273 phospho",
    "C2CD4C cnv",
    "C2CD4C methyl",
    "C2CD4C proteo",
    "C2CD4C rna"
  ],
  "C2CD4D": [
    "C2CD4D cnv",
    "C2CD4D methyl",
    "C2CD4D rna"
  ],
  "C2CD5": [
    "C2CD5 249_262_1_1_S250 phospho",
    "C2CD5 249_262_2_2_S250S260 phospho",
    "C2CD5 278_285_1_0 phospho",
    "C2CD5 278_285_1_1_S280 phospho",
    "C2CD5 278_285_1_1_T285 phospho",
    "C2CD5 278_285_2_0 phospho",
    "C2CD5 304_314_1_1_S305 phospho",
    "C2CD5 657_671_1_1_S659 phospho",
    "C2CD5 657_671_1_1_S662 phospho",
    "C2CD5 657_671_2_2_S659S662 phospho",
    "C2CD5 865_871_1_1_S866 phospho",
    "C2CD5 897_905_1_1_S905 phospho",
    "C2CD5 903_903_1_1_S903 phospho",
    "C2CD5 cnv",
    "C2CD5 methyl",
    "C2CD5 proteo",
    "C2CD5 rna"
  ],
  "C2CD6": [
    "C2CD6 cnv",
    "C2CD6 methyl",
    "C2CD6 rna"
  ],
  "C2orf15": [
    "C2orf15 cnv",
    "C2orf15 methyl",
    "C2orf15 rna"
  ],
  "C2orf16": [
    "C2orf16 cnv",
    "C2orf16 rna"
  ],
  "C2orf42": [
    "C2orf42 cnv",
    "C2orf42 methyl",
    "C2orf42 rna"
  ],
  "C2orf49": [
    "C2orf49 182_184_1_1_S182 phospho",
    "C2orf49 182_198_1_1_S189 phospho",
    "C2orf49 189_198_1_1_S193 phospho",
    "C2orf49 189_198_2_2_S189S193 phospho",
    "C2orf49 230_230_1_1_T230 phospho",
    "C2orf49 cnv",
    "C2orf49 methyl",
    "C2orf49 proteo",
    "C2orf49 rna"
  ],
  "C2orf50": [
    "C2orf50 cnv",
    "C2orf50 rna"
  ],
  "C2orf66": [
    "C2orf66 cnv",
    "C2orf66 rna"
  ],
  "C2orf68": [
    "C2orf68 cnv",
    "C2orf68 methyl",
    "C2orf68 rna"
  ],
  "C2orf69": [
    "C2orf69 221_227_1_1_S222 phospho",
    "C2orf69 cnv",
    "C2orf69 methyl",
    "C2orf69 proteo",
    "C2orf69 rna"
  ],
  "C2orf72": [
    "C2orf72 cnv",
    "C2orf72 proteo",
    "C2orf72 rna"
  ],
  "C2orf73": [
    "C2orf73 cnv",
    "C2orf73 methyl",
    "C2orf73 rna"
  ],
  "C2orf74": [
    "C2orf74 cnv",
    "C2orf74 rna"
  ],
  "C2orf76": [
    "C2orf76 cnv",
    "C2orf76 methyl",
    "C2orf76 proteo",
    "C2orf76 rna"
  ],
  "C2orf78": [
    "C2orf78 cnv",
    "C2orf78 rna"
  ],
  "C2orf80": [
    "C2orf80 cnv",
    "C2orf80 rna"
  ],
  "C2orf81": [
    "C2orf81 cnv",
    "C2orf81 methyl",
    "C2orf81 rna"
  ],
  "C2orf83": [
    "C2orf83 cnv",
    "C2orf83 rna"
  ],
  "C2orf88": [
    "C2orf88 40_61_1_1_S40 phospho",
    "C2orf88 cnv",
    "C2orf88 methyl",
    "C2orf88 proteo",
    "C2orf88 rna"
  ],
  "C2orf92": [
    "C2orf92 cnv",
    "C2orf92 methyl",
    "C2orf92 rna"
  ],
  "C3": [
    "C3 672_676_1_1_S672 phospho",
    "C3 TVLTPATNHMGNVTFTIPANR-N2H3F0S0G0 glyco",
    "C3 TVLTPATNHMGNVTFTIPANR-N2H4F0S0G0 glyco",
    "C3 TVLTPATNHMGNVTFTIPANR-N2H5F0S0G0 glyco",
    "C3 TVLTPATNHMGNVTFTIPANR-N2H6F0S0G0 glyco",
    "C3 TVLTPATNHMGNVTFTIPANR-N2H7F0S0G0 glyco",
    "C3 TVLTPATNHMGNVTFTIPANR-N2H8F0S0G0 glyco",
    "C3 TVLTPATNHMGNVTFTIPANR-N3H5F0S0G0 glyco",
    "C3 TVLTPATNHMGNVTFTIPANR-N3H5F0S1G0 glyco",
    "C3 TVLTPATNHMGNVTFTIPANR-N3H6F0S0G0 glyco",
    "C3 TVLTPATNHMGNVTFTIPANR-N3H6F0S1G0 glyco",
    "C3 TVLTPATNHMGNVTFTIPANR-N4H5F0S0G0 glyco",
    "C3 TVLTPATNHMGNVTFTIPANREFK-N2H6F0S0G0 glyco",
    "C3 cnv",
    "C3 methyl",
    "C3 proteo",
    "C3 rna"
  ],
  "C3AR1": [
    "C3AR1 465_475_1_1_S470 phospho",
    "C3AR1 465_481_1_0 phospho",
    "C3AR1 cnv",
    "C3AR1 proteo",
    "C3AR1 rna"
  ],
  "C3orf14": [
    "C3orf14 cnv",
    "C3orf14 methyl",
    "C3orf14 rna"
  ],
  "C3orf18": [
    "C3orf18 cnv",
    "C3orf18 methyl",
    "C3orf18 rna"
  ],
  "C3orf20": [
    "C3orf20 cnv",
    "C3orf20 rna"
  ],
  "C3orf22": [
    "C3orf22 cnv",
    "C3orf22 rna"
  ],
  "C3orf33": [
    "C3orf33 cnv",
    "C3orf33 methyl",
    "C3orf33 rna"
  ],
  "C3orf38": [
    "C3orf38 cnv",
    "C3orf38 methyl",
    "C3orf38 proteo",
    "C3orf38 rna"
  ],
  "C3orf49": [
    "C3orf49 cnv",
    "C3orf49 rna"
  ],
  "C3orf52": [
    "C3orf52 cnv",
    "C3orf52 methyl",
    "C3orf52 rna"
  ],
  "C3orf56": [
    "C3orf56 cnv"
  ],
  "C3orf62": [
    "C3orf62 cnv",
    "C3orf62 methyl",
    "C3orf62 rna"
  ],
  "C3orf70": [
    "C3orf70 cnv",
    "C3orf70 methyl",
    "C3orf70 rna"
  ],
  "C3orf80": [
    "C3orf80 cnv",
    "C3orf80 methyl",
    "C3orf80 rna"
  ],
  "C3orf84": [
    "C3orf84 cnv"
  ],
  "C3orf85": [
    "C3orf85 cnv",
    "C3orf85 methyl"
  ],
  "C4A": [
    "C4A FSDGLESNSSTQFEVK-N2H10F0S0G0 glyco",
    "C4A FSDGLESNSSTQFEVK-N2H7F0S0G0 glyco",
    "C4A FSDGLESNSSTQFEVK-N2H8F0S0G0 glyco",
    "C4A FSDGLESNSSTQFEVK-N2H9F0S0G0 glyco",
    "C4A FSDGLESNSSTQFEVK-N4H3F0S2G0 glyco",
    "C4A FSDGLESNSSTQFEVKK-N2H7F0S0G0 glyco",
    "C4A FSDGLESNSSTQFEVKK-N2H8F0S0G0 glyco",
    "C4A FSDGLESNSSTQFEVKK-N2H9F0S0G0 glyco",
    "C4A GLNVTLSSTGR-N2H5F0S0G0 glyco",
    "C4A GLNVTLSSTGR-N2H8F0S0G0 glyco",
    "C4A GLNVTLSSTGR-N3H4F0S1G0 glyco",
    "C4A GLNVTLSSTGR-N4H5F0S1G0 glyco",
    "C4A GLNVTLSSTGR-N4H5F0S2G0 glyco",
    "C4A NTTCQDLQIEVTVK-N4H5F0S1G0 glyco",
    "C4A NTTCQDLQIEVTVK-N4H5F0S2G0 glyco",
    "C4A NTTCQDLQIEVTVK-N5H3F1S0G0 glyco",
    "C4A TYNVLDMKNTTCQDLQIEVTVK-N4H5F0S1G0 glyco",
    "C4A TYNVLDMKNTTCQDLQIEVTVK-N4H5F0S2G0 glyco",
    "C4A TYNVLDMKNTTCQDLQIEVTVK-N4H5F2S1G0 glyco",
    "C4A cnv",
    "C4A rna"
  ],
  "C4B": [
    "C4B cnv",
    "C4B rna"
  ],
  "C4BPA": [
    "C4BPA FSLLGHASISCTVENETIGVWRPSPPTCEK-N6H3F5S0G0 glyco",
    "C4BPA cnv",
    "C4BPA proteo",
    "C4BPA rna"
  ],
  "C4BPB": [
    "C4BPB KTLFCNASK-N4H5F0S2G0 glyco",
    "C4BPB LGHCPDPVLVNGEFSSSGPVNVSDK-N4H5F0S2G0 glyco",
    "C4BPB TLFCNASK-N4H5F0S1G0 glyco",
    "C4BPB TLFCNASK-N4H5F0S2G0 glyco",
    "C4BPB cnv",
    "C4BPB proteo",
    "C4BPB rna"
  ],
  "C4orf17": [
    "C4orf17 cnv",
    "C4orf17 rna"
  ],
  "C4orf19": [
    "C4orf19 cnv",
    "C4orf19 methyl",
    "C4orf19 rna"
  ],
  "C4orf3": [
    "C4orf3 cnv",
    "C4orf3 methyl",
    "C4orf3 rna"
  ],
  "C4orf33": [
    "C4orf33 cnv",
    "C4orf33 methyl",
    "C4orf33 rna"
  ],
  "C4orf36": [
    "C4orf36 cnv",
    "C4orf36 methyl",
    "C4orf36 rna"
  ],
  "C4orf45": [
    "C4orf45 cnv",
    "C4orf45 rna"
  ],
  "C4orf46": [
    "C4orf46 cnv",
    "C4orf46 methyl",
    "C4orf46 rna"
  ],
  "C4orf47": [
    "C4orf47 cnv",
    "C4orf47 methyl",
    "C4orf47 rna"
  ],
  "C4orf48": [
    "C4orf48 cnv",
    "C4orf48 methyl",
    "C4orf48 rna"
  ],
  "C4orf50": [
    "C4orf50 cnv",
    "C4orf50 methyl",
    "C4orf50 rna"
  ],
  "C4orf51": [
    "C4orf51 cnv",
    "C4orf51 rna"
  ],
  "C4orf54": [
    "C4orf54 cnv",
    "C4orf54 rna"
  ],
  "C5": [
    "C5 cnv",
    "C5 methyl",
    "C5 proteo",
    "C5 rna"
  ],
  "C5AR1": [
    "C5AR1 cnv",
    "C5AR1 proteo",
    "C5AR1 rna"
  ],
  "C5AR2": [
    "C5AR2 cnv",
    "C5AR2 rna"
  ],
  "C5orf15": [
    "C5orf15 cnv",
    "C5orf15 methyl",
    "C5orf15 proteo",
    "C5orf15 rna"
  ],
  "C5orf22": [
    "C5orf22 cnv",
    "C5orf22 methyl",
    "C5orf22 proteo",
    "C5orf22 rna"
  ],
  "C5orf24": [
    "C5orf24 120_129_1_1_S121 phospho",
    "C5orf24 cnv",
    "C5orf24 methyl",
    "C5orf24 proteo",
    "C5orf24 rna"
  ],
  "C5orf34": [
    "C5orf34 cnv",
    "C5orf34 methyl",
    "C5orf34 rna"
  ],
  "C5orf46": [
    "C5orf46 cnv",
    "C5orf46 rna"
  ],
  "C5orf47": [
    "C5orf47 cnv",
    "C5orf47 methyl",
    "C5orf47 rna"
  ],
  "C5orf49": [
    "C5orf49 cnv",
    "C5orf49 methyl",
    "C5orf49 rna"
  ],
  "C5orf52": [
    "C5orf52 cnv",
    "C5orf52 methyl",
    "C5orf52 rna"
  ],
  "C5orf58": [
    "C5orf58 cnv",
    "C5orf58 methyl",
    "C5orf58 rna"
  ],
  "C5orf60": [
    "C5orf60 cnv",
    "C5orf60 rna"
  ],
  "C5orf63": [
    "C5orf63 cnv",
    "C5orf63 rna"
  ],
  "C6": [
    "C6 LSSNSTK-N4H5F0S1G0 glyco",
    "C6 LSSNSTK-N4H5F0S2G0 glyco",
    "C6 VLNFTTK-N3H4F0S1G0 glyco",
    "C6 VLNFTTK-N4H5F0S1G0 glyco",
    "C6 VLNFTTK-N4H5F0S2G0 glyco",
    "C6 cnv",
    "C6 proteo",
    "C6 rna"
  ],
  "C6orf118": [
    "C6orf118 cnv",
    "C6orf118 rna"
  ],
  "C6orf120": [
    "C6orf120 cnv",
    "C6orf120 methyl",
    "C6orf120 proteo",
    "C6orf120 rna"
  ],
  "C6orf132": [
    "C6orf132 cnv",
    "C6orf132 methyl",
    "C6orf132 rna"
  ],
  "C6orf136": [
    "C6orf136 cnv",
    "C6orf136 methyl",
    "C6orf136 proteo",
    "C6orf136 rna"
  ],
  "C6orf141": [
    "C6orf141 cnv",
    "C6orf141 methyl",
    "C6orf141 rna"
  ],
  "C6orf15": [
    "C6orf15 cnv",
    "C6orf15 rna"
  ],
  "C6orf163": [
    "C6orf163 cnv",
    "C6orf163 rna"
  ],
  "C6orf201": [
    "C6orf201 cnv",
    "C6orf201 methyl",
    "C6orf201 rna"
  ],
  "C6orf226": [
    "C6orf226 cnv",
    "C6orf226 methyl",
    "C6orf226 rna"
  ],
  "C6orf47": [
    "C6orf47 90_103_1_1_S90 phospho",
    "C6orf47 cnv",
    "C6orf47 methyl",
    "C6orf47 rna"
  ],
  "C6orf52": [
    "C6orf52 cnv",
    "C6orf52 methyl",
    "C6orf52 rna"
  ],
  "C6orf58": [
    "C6orf58 cnv",
    "C6orf58 rna"
  ],
  "C6orf62": [
    "C6orf62 cnv",
    "C6orf62 methyl",
    "C6orf62 rna"
  ],
  "C6orf89": [
    "C6orf89 cnv",
    "C6orf89 methyl",
    "C6orf89 proteo",
    "C6orf89 rna"
  ],
  "C7": [
    "C7 INNDFNYEFYNSTWSYVK-N2H5F0S0G0 glyco",
    "C7 cnv",
    "C7 proteo",
    "C7 rna"
  ],
  "C7orf25": [
    "C7orf25 cnv",
    "C7orf25 methyl",
    "C7orf25 proteo",
    "C7orf25 rna"
  ],
  "C7orf31": [
    "C7orf31 cnv",
    "C7orf31 methyl",
    "C7orf31 rna"
  ],
  "C7orf33": [
    "C7orf33 cnv",
    "C7orf33 rna"
  ],
  "C7orf50": [
    "C7orf50 175_175_1_1_S175 phospho",
    "C7orf50 cnv",
    "C7orf50 methyl",
    "C7orf50 proteo",
    "C7orf50 rna"
  ],
  "C7orf57": [
    "C7orf57 208_214_1_1_S209 phospho",
    "C7orf57 cnv",
    "C7orf57 methyl",
    "C7orf57 proteo",
    "C7orf57 rna"
  ],
  "C8A": [
    "C8A GGSSGWSGGLAQNR-N4H5F0S2G0 glyco",
    "C8A cnv",
    "C8A proteo",
    "C8A rna"
  ],
  "C8B": [
    "C8B EYESYSDFERNVTEK-N4H5F0S2G0 glyco",
    "C8B cnv",
    "C8B proteo",
    "C8B rna"
  ],
  "C8G": [
    "C8G cnv",
    "C8G methyl",
    "C8G proteo",
    "C8G rna"
  ],
  "C8orf33": [
    "C8orf33 82_82_1_1_S82 phospho",
    "C8orf33 cnv",
    "C8orf33 methyl",
    "C8orf33 proteo",
    "C8orf33 rna"
  ],
  "C8orf34": [
    "C8orf34 cnv",
    "C8orf34 methyl",
    "C8orf34 rna"
  ],
  "C8orf44": [
    "C8orf44 methyl"
  ],
  "C8orf44-SGK3": [
    "C8orf44-SGK3 cnv",
    "C8orf44-SGK3 methyl",
    "C8orf44-SGK3 rna"
  ],
  "C8orf48": [
    "C8orf48 cnv",
    "C8orf48 rna"
  ],
  "C8orf58": [
    "C8orf58 cnv",
    "C8orf58 methyl",
    "C8orf58 rna"
  ],
  "C8orf74": [
    "C8orf74 cnv",
    "C8orf74 rna"
  ],
  "C8orf76": [
    "C8orf76 cnv",
    "C8orf76 methyl",
    "C8orf76 rna"
  ],
  "C8orf82": [
    "C8orf82 cnv",
    "C8orf82 methyl",
    "C8orf82 proteo",
    "C8orf82 rna"
  ],
  "C8orf88": [
    "C8orf88 cnv",
    "C8orf88 methyl",
    "C8orf88 rna"
  ],
  "C8orf89": [
    "C8orf89 cnv",
    "C8orf89 rna"
  ],
  "C9": [
    "C9 AVNITSENLIDDVVSLIR-N4H5F0S1G0 glyco",
    "C9 AVNITSENLIDDVVSLIR-N4H5F0S2G0 glyco",
    "C9 NETYQLFLSYSSK-N4H5F0S2G0 glyco",
    "C9 cnv",
    "C9 methyl",
    "C9 proteo",
    "C9 rna"
  ],
  "C9orf131": [
    "C9orf131 cnv",
    "C9orf131 rna"
  ],
  "C9orf152": [
    "C9orf152 cnv",
    "C9orf152 rna"
  ],
  "C9orf153": [
    "C9orf153 cnv",
    "C9orf153 rna"
  ],
  "C9orf163": [
    "C9orf163 methyl"
  ],
  "C9orf24": [
    "C9orf24 cnv",
    "C9orf24 methyl",
    "C9orf24 rna"
  ],
  "C9orf40": [
    "C9orf40 76_83_1_1_S76 phospho",
    "C9orf40 cnv",
    "C9orf40 methyl",
    "C9orf40 proteo",
    "C9orf40 rna"
  ],
  "C9orf43": [
    "C9orf43 cnv",
    "C9orf43 methyl",
    "C9orf43 rna"
  ],
  "C9orf50": [
    "C9orf50 cnv",
    "C9orf50 methyl",
    "C9orf50 rna"
  ],
  "C9orf57": [
    "C9orf57 cnv",
    "C9orf57 rna"
  ],
  "C9orf64": [
    "C9orf64 cnv",
    "C9orf64 methyl",
    "C9orf64 proteo",
    "C9orf64 rna"
  ],
  "C9orf72": [
    "C9orf72 cnv",
    "C9orf72 methyl",
    "C9orf72 proteo",
    "C9orf72 rna"
  ],
  "C9orf78": [
    "C9orf78 15_24_2_2_S15S17 phospho",
    "C9orf78 253_261_1_1_S261 phospho",
    "C9orf78 cnv",
    "C9orf78 methyl",
    "C9orf78 proteo",
    "C9orf78 rna"
  ],
  "C9orf85": [
    "C9orf85 cnv",
    "C9orf85 methyl",
    "C9orf85 proteo",
    "C9orf85 rna"
  ],
  "CA1": [
    "CA1 216_221_1_1_S221 phospho",
    "CA1 cnv",
    "CA1 proteo",
    "CA1 rna"
  ],
  "CA10": [
    "CA10 cnv",
    "CA10 methyl",
    "CA10 rna"
  ],
  "CA11": [
    "CA11 cnv",
    "CA11 rna"
  ],
  "CA12": [
    "CA12 cnv",
    "CA12 methyl",
    "CA12 proteo",
    "CA12 rna"
  ],
  "CA13": [
    "CA13 cnv",
    "CA13 methyl",
    "CA13 proteo",
    "CA13 rna"
  ],
  "CA14": [
    "CA14 325_335_1_1_S325 phospho",
    "CA14 cnv",
    "CA14 proteo",
    "CA14 rna"
  ],
  "CA2": [
    "CA2 216_219_1_1_S216 phospho",
    "CA2 29_37_1_1_S29 phospho",
    "CA2 cnv",
    "CA2 methyl",
    "CA2 proteo",
    "CA2 rna"
  ],
  "CA3": [
    "CA3 cnv",
    "CA3 methyl",
    "CA3 proteo",
    "CA3 rna"
  ],
  "CA4": [
    "CA4 cnv",
    "CA4 methyl",
    "CA4 proteo",
    "CA4 rna"
  ],
  "CA5A": [
    "CA5A cnv",
    "CA5A rna"
  ],
  "CA5B": [
    "CA5B methyl",
    "CA5B proteo",
    "CA5B rna"
  ],
  "CA5BP1": [
    "CA5BP1 methyl"
  ],
  "CA6": [
    "CA6 cnv",
    "CA6 rna"
  ],
  "CA7": [
    "CA7 cnv",
    "CA7 methyl",
    "CA7 rna"
  ],
  "CA8": [
    "CA8 cnv",
    "CA8 methyl",
    "CA8 proteo",
    "CA8 rna"
  ],
  "CA9": [
    "CA9 102_107_1_1_S102 phospho",
    "CA9 cnv",
    "CA9 methyl",
    "CA9 proteo",
    "CA9 rna"
  ],
  "CAAP1": [
    "CAAP1 203_213_1_1_S203 phospho",
    "CAAP1 301_312_1_1_S312 phospho",
    "CAAP1 cnv",
    "CAAP1 methyl",
    "CAAP1 proteo",
    "CAAP1 rna"
  ],
  "CAB39": [
    "CAB39 cnv",
    "CAB39 methyl",
    "CAB39 proteo",
    "CAB39 rna"
  ],
  "CAB39L": [
    "CAB39L cnv",
    "CAB39L methyl",
    "CAB39L proteo",
    "CAB39L rna"
  ],
  "CABCOCO1": [
    "CABCOCO1 cnv",
    "CABCOCO1 methyl",
    "CABCOCO1 rna"
  ],
  "CABIN1": [
    "CABIN1 1921_1927_1_1_T1927 phospho",
    "CABIN1 cnv",
    "CABIN1 methyl",
    "CABIN1 proteo",
    "CABIN1 rna"
  ],
  "CABLES1": [
    "CABLES1 290_294_1_1_S291 phospho",
    "CABLES1 373_378_1_1_S373 phospho",
    "CABLES1 415_423_1_1_T415 phospho",
    "CABLES1 cnv",
    "CABLES1 methyl",
    "CABLES1 rna"
  ],
  "CABLES2": [
    "CABLES2 97_111_1_1_S105 phospho",
    "CABLES2 cnv",
    "CABLES2 methyl",
    "CABLES2 proteo",
    "CABLES2 rna"
  ],
  "CABP1": [
    "CABP1 cnv",
    "CABP1 methyl",
    "CABP1 proteo",
    "CABP1 rna"
  ],
  "CABP2": [
    "CABP2 cnv",
    "CABP2 rna"
  ],
  "CABP4": [
    "CABP4 cnv",
    "CABP4 rna"
  ],
  "CABP5": [
    "CABP5 cnv",
    "CABP5 rna"
  ],
  "CABP7": [
    "CABP7 cnv",
    "CABP7 methyl",
    "CABP7 rna"
  ],
  "CABS1": [
    "CABS1 cnv",
    "CABS1 rna"
  ],
  "CABYR": [
    "CABYR cnv",
    "CABYR methyl",
    "CABYR rna"
  ],
  "CACFD1": [
    "CACFD1 cnv",
    "CACFD1 methyl",
    "CACFD1 proteo",
    "CACFD1 rna"
  ],
  "CACHD1": [
    "CACHD1 1074_1087_1_1_S1087 phospho",
    "CACHD1 1127_1127_1_1_S1127 phospho",
    "CACHD1 cnv",
    "CACHD1 methyl",
    "CACHD1 proteo",
    "CACHD1 rna"
  ],
  "CACNA1A": [
    "CACNA1A 2130_2132_1_1_S2132 phospho",
    "CACNA1A 2252_2256_1_1_S2254 phospho",
    "CACNA1A 753_761_1_0 phospho",
    "CACNA1A 753_761_1_1_S753 phospho",
    "CACNA1A cnv",
    "CACNA1A methyl",
    "CACNA1A proteo",
    "CACNA1A rna"
  ],
  "CACNA1B": [
    "CACNA1B 1960_1961_1_1_S1960 phospho",
    "CACNA1B 2233_2233_1_1_S2233 phospho",
    "CACNA1B 745_753_1_1_S745 phospho",
    "CACNA1B 783_789_1_1_S783 phospho",
    "CACNA1B 923_923_1_1_S923 phospho",
    "CACNA1B cnv",
    "CACNA1B methyl",
    "CACNA1B proteo",
    "CACNA1B rna"
  ],
  "CACNA1C": [
    "CACNA1C 1735_1744_1_1_S1742 phospho",
    "CACNA1C 808_819_1_1_S815 phospho",
    "CACNA1C cnv",
    "CACNA1C methyl",
    "CACNA1C rna"
  ],
  "CACNA1C-AS1": [
    "CACNA1C-AS1 methyl"
  ],
  "CACNA1D": [
    "CACNA1D cnv",
    "CACNA1D methyl",
    "CACNA1D rna"
  ],
  "CACNA1E": [
    "CACNA1E 1047_1060_1_1_S1049 phospho",
    "CACNA1E 14_22_1_1_S14 phospho",
    "CACNA1E 2051_2055_1_1_S2051 phospho",
    "CACNA1E 736_745_1_1_S736 phospho",
    "CACNA1E cnv",
    "CACNA1E methyl",
    "CACNA1E proteo",
    "CACNA1E rna"
  ],
  "CACNA1F": [
    "CACNA1F methyl",
    "CACNA1F rna"
  ],
  "CACNA1G": [
    "CACNA1G 1981_1989_1_1_S1983 phospho",
    "CACNA1G cnv",
    "CACNA1G methyl",
    "CACNA1G rna"
  ],
  "CACNA1G-AS1": [
    "CACNA1G-AS1 methyl"
  ],
  "CACNA1H": [
    "CACNA1H 749_758_1_1_S758 phospho",
    "CACNA1H cnv",
    "CACNA1H methyl",
    "CACNA1H rna"
  ],
  "CACNA1I": [
    "CACNA1I cnv",
    "CACNA1I rna"
  ],
  "CACNA1S": [
    "CACNA1S cnv",
    "CACNA1S rna"
  ],
  "CACNA2D1": [
    "CACNA2D1 DAVNNITAK-N2H5F0S0G0 glyco",
    "CACNA2D1 DAVNNITAK-N2H6F0S0G0 glyco",
    "CACNA2D1 DAVNNITAK-N2H7F0S0G0 glyco",
    "CACNA2D1 DAVNNITAK-N2H8F0S0G0 glyco",
    "CACNA2D1 DAVNNITAK-N2H9F0S0G0 glyco",
    "CACNA2D1 HLVNISVYAFNK-N6H7F1S2G0 glyco",
    "CACNA2D1 IDVNSWIENFTK-N2H6F0S0G0 glyco",
    "CACNA2D1 IDVNSWIENFTK-N2H7F0S0G0 glyco",
    "CACNA2D1 IDVNSWIENFTK-N2H8F0S0G0 glyco",
    "CACNA2D1 cnv",
    "CACNA2D1 methyl",
    "CACNA2D1 proteo",
    "CACNA2D1 rna"
  ],
  "CACNA2D2": [
    "CACNA2D2 cnv",
    "CACNA2D2 methyl",
    "CACNA2D2 proteo",
    "CACNA2D2 rna"
  ],
  "CACNA2D3": [
    "CACNA2D3 cnv",
    "CACNA2D3 methyl",
    "CACNA2D3 proteo",
    "CACNA2D3 rna"
  ],
  "CACNA2D4": [
    "CACNA2D4 cnv",
    "CACNA2D4 methyl",
    "CACNA2D4 rna"
  ],
  "CACNB1": [
    "CACNB1 412_418_1_1_T418 phospho",
    "CACNB1 499_507_1_1_T499 phospho",
    "CACNB1 547_560_1_1_S547 phospho",
    "CACNB1 cnv",
    "CACNB1 methyl",
    "CACNB1 proteo",
    "CACNB1 rna"
  ],
  "CACNB2": [
    "CACNB2 217_230_1_1_S227 phospho",
    "CACNB2 451_470_1_1_S460 phospho",
    "CACNB2 484_493_1_1_S486 phospho",
    "CACNB2 526_534_1_1_T526 phospho",
    "CACNB2 cnv",
    "CACNB2 methyl",
    "CACNB2 proteo",
    "CACNB2 rna"
  ],
  "CACNB3": [
    "CACNB3 138_156_1_1_S152 phospho",
    "CACNB3 152_156_1_1_S152 phospho",
    "CACNB3 cnv",
    "CACNB3 methyl",
    "CACNB3 proteo",
    "CACNB3 rna"
  ],
  "CACNB4": [
    "CACNB4 cnv",
    "CACNB4 methyl",
    "CACNB4 proteo",
    "CACNB4 rna"
  ],
  "CACNG1": [
    "CACNG1 cnv",
    "CACNG1 methyl",
    "CACNG1 rna"
  ],
  "CACNG2": [
    "CACNG2 253_253_1_1_S253 phospho",
    "CACNG2 cnv",
    "CACNG2 methyl",
    "CACNG2 proteo",
    "CACNG2 rna"
  ],
  "CACNG3": [
    "CACNG3 cnv",
    "CACNG3 methyl",
    "CACNG3 proteo",
    "CACNG3 rna"
  ],
  "CACNG4": [
    "CACNG4 cnv",
    "CACNG4 methyl",
    "CACNG4 rna"
  ],
  "CACNG5": [
    "CACNG5 cnv",
    "CACNG5 methyl",
    "CACNG5 proteo",
    "CACNG5 rna"
  ],
  "CACNG6": [
    "CACNG6 cnv",
    "CACNG6 methyl",
    "CACNG6 rna"
  ],
  "CACNG7": [
    "CACNG7 264_273_1_1_S273 phospho",
    "CACNG7 cnv",
    "CACNG7 methyl",
    "CACNG7 proteo",
    "CACNG7 rna"
  ],
  "CACNG8": [
    "CACNG8 cnv",
    "CACNG8 methyl",
    "CACNG8 proteo",
    "CACNG8 rna"
  ],
  "CACTIN": [
    "CACTIN cnv",
    "CACTIN methyl",
    "CACTIN proteo",
    "CACTIN rna"
  ],
  "CACTIN-AS1": [
    "CACTIN-AS1 methyl"
  ],
  "CACUL1": [
    "CACUL1 cnv",
    "CACUL1 methyl",
    "CACUL1 proteo",
    "CACUL1 rna"
  ],
  "CACYBP": [
    "CACYBP cnv",
    "CACYBP methyl",
    "CACYBP proteo",
    "CACYBP rna"
  ],
  "CAD": [
    "CAD 1760_1770_1_0 phospho",
    "CAD 1796_1796_1_1_S1796 phospho",
    "CAD 1837_1870_1_1_S1837 phospho",
    "CAD cnv",
    "CAD methyl",
    "CAD proteo",
    "CAD rna"
  ],
  "CADM1": [
    "CADM1 394_406_1_1_S406 phospho",
    "CADM1 394_406_1_1_T394 phospho",
    "CADM1 DVTVIEGEVATISCQVNK-N5H4F2S0G0 glyco",
    "CADM1 cnv",
    "CADM1 methyl",
    "CADM1 proteo",
    "CADM1 rna"
  ],
  "CADM2": [
    "CADM2 415_423_1_1_S423 phospho",
    "CADM2 GSQGQFPLTQNVTVVEGGTAILTCR-N2H5F0S0G0 glyco",
    "CADM2 GSQGQFPLTQNVTVVEGGTAILTCR-N4H4F1S0G0 glyco",
    "CADM2 GSQGQFPLTQNVTVVEGGTAILTCR-N4H5F0S0G0 glyco",
    "CADM2 GSQGQFPLTQNVTVVEGGTAILTCR-N4H5F1S0G0 glyco",
    "CADM2 GSQGQFPLTQNVTVVEGGTAILTCR-N5H3F1S0G0 glyco",
    "CADM2 GSQGQFPLTQNVTVVEGGTAILTCR-N5H4F0S0G0 glyco",
    "CADM2 VDQNDNTSLQWSNPAQQTLYFDDKK-N7H6F3S1G0 glyco",
    "CADM2 cnv",
    "CADM2 methyl",
    "CADM2 proteo",
    "CADM2 rna"
  ],
  "CADM3": [
    "CADM3 MTQESALIFPFLNK-N3H5F2S0G0 glyco",
    "CADM3 cnv",
    "CADM3 methyl",
    "CADM3 proteo",
    "CADM3 rna"
  ],
  "CADM4": [
    "CADM4 354_361_1_1_S361 phospho",
    "CADM4 377_377_1_1_S377 phospho",
    "CADM4 AEAVGETLTLPGLVSADNGTYTCEASNK-N3H3F1S0G0 glyco",
    "CADM4 AEAVGETLTLPGLVSADNGTYTCEASNK-N3H5F2S0G0 glyco",
    "CADM4 AEAVGETLTLPGLVSADNGTYTCEASNK-N4H5F1S1G0 glyco",
    "CADM4 QTLFFNGTR-N3H5F1S0G0 glyco",
    "CADM4 QTLFFNGTR-N3H5F1S1G0 glyco",
    "CADM4 QTLFFNGTR-N3H5F2S0G0 glyco",
    "CADM4 QTLFFNGTR-N3H6F1S0G0 glyco",
    "CADM4 QTLFFNGTR-N3H6F1S1G0 glyco",
    "CADM4 QTLFFNGTR-N4H4F1S1G0 glyco",
    "CADM4 QTLFFNGTR-N4H5F1S1G0 glyco",
    "CADM4 QTLFFNGTR-N4H5F2S0G0 glyco",
    "CADM4 QTLFFNGTR-N4H5F2S1G0 glyco",
    "CADM4 QTLFFNGTR-N4H6F2S0G0 glyco",
    "CADM4 cnv",
    "CADM4 methyl",
    "CADM4 proteo",
    "CADM4 rna"
  ],
  "CADPS": [
    "CADPS 373_390_1_1_S377 phospho",
    "CADPS 485_488_1_1_S488 phospho",
    "CADPS cnv",
    "CADPS methyl",
    "CADPS proteo",
    "CADPS rna"
  ],
  "CADPS2": [
    "CADPS2 cnv",
    "CADPS2 methyl",
    "CADPS2 proteo",
    "CADPS2 rna"
  ],
  "CAGE1": [
    "CAGE1 cnv",
    "CAGE1 methyl",
    "CAGE1 rna"
  ],
  "CAHM": [
    "CAHM methyl"
  ],
  "CALB1": [
    "CALB1 cnv",
    "CALB1 proteo",
    "CALB1 rna"
  ],
  "CALB2": [
    "CALB2 cnv",
    "CALB2 methyl",
    "CALB2 proteo",
    "CALB2 rna"
  ],
  "CALCA": [
    "CALCA cnv",
    "CALCA rna"
  ],
  "CALCB": [
    "CALCB cnv",
    "CALCB methyl",
    "CALCB rna"
  ],
  "CALCOCO1": [
    "CALCOCO1 562_563_1_1_S563 phospho",
    "CALCOCO1 cnv",
    "CALCOCO1 proteo",
    "CALCOCO1 rna"
  ],
  "CALCOCO2": [
    "CALCOCO2 262_263_1_1_S262 phospho",
    "CALCOCO2 339_339_1_1_S339 phospho",
    "CALCOCO2 cnv",
    "CALCOCO2 methyl",
    "CALCOCO2 proteo",
    "CALCOCO2 rna"
  ],
  "CALCR": [
    "CALCR cnv",
    "CALCR methyl",
    "CALCR rna"
  ],
  "CALCRL": [
    "CALCRL 418_438_1_1_S420 phospho",
    "CALCRL 418_438_1_1_S427 phospho",
    "CALCRL TWTNYTQCNVNTHEK-N3H6F0S1G0 glyco",
    "CALCRL cnv",
    "CALCRL proteo",
    "CALCRL rna"
  ],
  "CALD1": [
    "CALD1 12_21_1_1_S12 phospho",
    "CALD1 196_196_1_1_S196 phospho",
    "CALD1 202_202_1_1_S202 phospho",
    "CALD1 257_260_1_1_S257 phospho",
    "CALD1 492_498_1_1_S498 phospho",
    "CALD1 522_530_1_1_S522 phospho",
    "CALD1 522_530_2_2_S522S528 phospho",
    "CALD1 cnv",
    "CALD1 proteo",
    "CALD1 rna"
  ],
  "CALHM1": [
    "CALHM1 cnv",
    "CALHM1 rna"
  ],
  "CALHM2": [
    "CALHM2 cnv",
    "CALHM2 methyl",
    "CALHM2 rna"
  ],
  "CALHM3": [
    "CALHM3 cnv",
    "CALHM3 rna"
  ],
  "CALHM4": [
    "CALHM4 cnv",
    "CALHM4 rna"
  ],
  "CALHM5": [
    "CALHM5 cnv",
    "CALHM5 proteo",
    "CALHM5 rna"
  ],
  "CALHM6": [
    "CALHM6 cnv",
    "CALHM6 methyl",
    "CALHM6 rna"
  ],
  "CALM1": [
    "CALM1 cnv",
    "CALM1 methyl",
    "CALM1 rna"
  ],
  "CALM2": [
    "CALM2 cnv",
    "CALM2 methyl",
    "CALM2 rna"
  ],
  "CALM3": [
    "CALM3 cnv",
    "CALM3 methyl",
    "CALM3 rna"
  ],
  "CALML3": [
    "CALML3 cnv",
    "CALML3 proteo",
    "CALML3 rna"
  ],
  "CALML4": [
    "CALML4 cnv",
    "CALML4 rna"
  ],
  "CALML5": [
    "CALML5 cnv",
    "CALML5 methyl",
    "CALML5 rna"
  ],
  "CALML6": [
    "CALML6 cnv",
    "CALML6 rna"
  ],
  "CALN1": [
    "CALN1 cnv",
    "CALN1 methyl",
    "CALN1 rna"
  ],
  "CALR": [
    "CALR cnv",
    "CALR methyl",
    "CALR proteo",
    "CALR rna"
  ],
  "CALR3": [
    "CALR3 cnv",
    "CALR3 methyl",
    "CALR3 rna"
  ],
  "CALU": [
    "CALU 52_55_1_1_Y55 phospho",
    "CALU 68_77_1_1_S77 phospho",
    "CALU NATYGYVLDDPDPDDGFNYK-N2H3F1S0G0 glyco",
    "CALU NATYGYVLDDPDPDDGFNYK-N2H5F0S0G0 glyco",
    "CALU NATYGYVLDDPDPDDGFNYK-N2H6F0S0G0 glyco",
    "CALU NATYGYVLDDPDPDDGFNYK-N3H3F1S0G0 glyco",
    "CALU NATYGYVLDDPDPDDGFNYK-N4H3F1S0G0 glyco",
    "CALU NATYGYVLDDPDPDDGFNYK-N5H3F1S0G0 glyco",
    "CALU NATYGYVLDDPDPDDGFNYK-N5H4F1S1G0 glyco",
    "CALU NVTYGTYLDDPDPDDGFNYK-N2H5F0S0G0 glyco",
    "CALU cnv",
    "CALU methyl",
    "CALU proteo",
    "CALU rna"
  ],
  "CALY": [
    "CALY cnv",
    "CALY methyl",
    "CALY rna"
  ],
  "CAMK1": [
    "CAMK1 323_339_1_0 phospho",
    "CAMK1 323_339_1_1_S324 phospho",
    "CAMK1 360_365_1_1_S363 phospho",
    "CAMK1 cnv",
    "CAMK1 kinase",
    "CAMK1 proteo",
    "CAMK1 rna"
  ],
  "CAMK1D": [
    "CAMK1D 179_199_1_1_T180 phospho",
    "CAMK1D 326_343_1_1_S327 phospho",
    "CAMK1D cnv",
    "CAMK1D kinase",
    "CAMK1D methyl",
    "CAMK1D proteo",
    "CAMK1D rna"
  ],
  "CAMK1G": [
    "CAMK1G cnv",
    "CAMK1G kinase",
    "CAMK1G rna"
  ],
  "CAMK2A": [
    "CAMK2A 272_272_1_1_S272 phospho",
    "CAMK2A 275_279_1_1_S275 phospho",
    "CAMK2A 275_279_1_1_S279 phospho",
    "CAMK2A 324_343_1_0 phospho",
    "CAMK2A 324_343_1_1_S331 phospho",
    "CAMK2A 324_343_2_0 phospho",
    "CAMK2A 324_343_3_0 phospho",
    "CAMK2A 330_343_1_0 phospho",
    "CAMK2A 330_343_1_1_T337 phospho",
    "CAMK2A 330_343_2_0 phospho",
    "CAMK2A cnv",
    "CAMK2A kinase",
    "CAMK2A proteo",
    "CAMK2A rna"
  ],
  "CAMK2B": [
    "CAMK2B 287_287_1_1_T287 phospho",
    "CAMK2B 362_367_1_1_S367 phospho",
    "CAMK2B 362_382_1_1_S367 phospho",
    "CAMK2B 394_401_1_1_S397 phospho",
    "CAMK2B 394_401_2_2_S397T401 phospho",
    "CAMK2B 423_447_1_1_S423 phospho",
    "CAMK2B cnv",
    "CAMK2B kinase",
    "CAMK2B methyl",
    "CAMK2B proteo",
    "CAMK2B rna"
  ],
  "CAMK2D": [
    "CAMK2D 319_319_1_1_S319 phospho",
    "CAMK2D 330_337_1_0 phospho",
    "CAMK2D 330_337_1_1_T337 phospho",
    "CAMK2D 330_337_2_0 phospho",
    "CAMK2D 345_371_1_0 phospho",
    "CAMK2D 470_474_1_1_S472 phospho",
    "CAMK2D 481_485_1_1_S483 phospho",
    "CAMK2D cnv",
    "CAMK2D kinase",
    "CAMK2D methyl",
    "CAMK2D proteo",
    "CAMK2D rna"
  ],
  "CAMK2G": [
    "CAMK2G 320_329_1_0 phospho",
    "CAMK2G 320_329_1_1_S321 phospho",
    "CAMK2G 320_329_2_2_S321S325 phospho",
    "CAMK2G 35_40_1_1_S36 phospho",
    "CAMK2G 35_40_1_1_T37 phospho",
    "CAMK2G 379_387_1_1_S382 phospho",
    "CAMK2G 415_430_1_1_S426 phospho",
    "CAMK2G cnv",
    "CAMK2G kinase",
    "CAMK2G methyl",
    "CAMK2G proteo",
    "CAMK2G rna"
  ],
  "CAMK2N1": [
    "CAMK2N1 cnv",
    "CAMK2N1 methyl",
    "CAMK2N1 proteo",
    "CAMK2N1 rna"
  ],
  "CAMK2N2": [
    "CAMK2N2 cnv",
    "CAMK2N2 methyl",
    "CAMK2N2 rna"
  ],
  "CAMK4": [
    "CAMK4 341_352_1_1_S341 phospho",
    "CAMK4 356_360_1_1_S360 phospho",
    "CAMK4 360_360_1_1_S360 phospho",
    "CAMK4 cnv",
    "CAMK4 kinase",
    "CAMK4 methyl",
    "CAMK4 proteo",
    "CAMK4 rna"
  ],
  "CAMKK1": [
    "CAMKK1 108_128_1_1_T108 phospho",
    "CAMKK1 458_458_1_1_S458 phospho",
    "CAMKK1 473_475_1_1_S475 phospho",
    "CAMKK1 52_59_1_1_S52 phospho",
    "CAMKK1 74_100_1_1_S100 phospho",
    "CAMKK1 74_100_1_1_S74 phospho",
    "CAMKK1 74_100_2_2_S74S100 phospho",
    "CAMKK1 cnv",
    "CAMKK1 kinase",
    "CAMKK1 methyl",
    "CAMKK1 proteo",
    "CAMKK1 rna"
  ],
  "CAMKK2": [
    "CAMKK2 125_137_1_1_S129 phospho",
    "CAMKK2 125_137_1_1_S133 phospho",
    "CAMKK2 495_503_1_1_S495 phospho",
    "CAMKK2 cnv",
    "CAMKK2 kinase",
    "CAMKK2 methyl",
    "CAMKK2 proteo",
    "CAMKK2 rna"
  ],
  "CAMKMT": [
    "CAMKMT cnv",
    "CAMKMT methyl",
    "CAMKMT rna"
  ],
  "CAMKV": [
    "CAMKV 425_454_1_1_T435 phospho",
    "CAMKV cnv",
    "CAMKV kinase",
    "CAMKV methyl",
    "CAMKV proteo",
    "CAMKV rna"
  ],
  "CAMLG": [
    "CAMLG 55_63_1_1_S55 phospho",
    "CAMLG cnv",
    "CAMLG methyl",
    "CAMLG proteo",
    "CAMLG rna"
  ],
  "CAMP": [
    "CAMP cnv",
    "CAMP proteo",
    "CAMP rna"
  ],
  "CAMSAP1": [
    "CAMSAP1 1396_1422_1_0 phospho",
    "CAMSAP1 1396_1422_1_1_S1398 phospho",
    "CAMSAP1 431_431_1_1_S431 phospho",
    "CAMSAP1 528_534_1_1_S534 phospho",
    "CAMSAP1 563_563_1_1_S563 phospho",
    "CAMSAP1 629_629_1_1_S629 phospho",
    "CAMSAP1 cnv",
    "CAMSAP1 methyl",
    "CAMSAP1 proteo",
    "CAMSAP1 rna"
  ],
  "CAMSAP2": [
    "CAMSAP2 1019_1027_1_1_S1019 phospho",
    "CAMSAP2 1144_1148_1_1_S1148 phospho",
    "CAMSAP2 1268_1276_1_1_S1268 phospho",
    "CAMSAP2 414_426_1_0 phospho",
    "CAMSAP2 414_426_1_1_S416 phospho",
    "CAMSAP2 462_476_1_1_S464 phospho",
    "CAMSAP2 511_528_1_1_S522 phospho",
    "CAMSAP2 598_606_1_1_S599 phospho",
    "CAMSAP2 844_851_1_1_S844 phospho",
    "CAMSAP2 927_936_1_1_S931 phospho",
    "CAMSAP2 cnv",
    "CAMSAP2 methyl",
    "CAMSAP2 proteo",
    "CAMSAP2 rna"
  ],
  "CAMSAP3": [
    "CAMSAP3 365_382_1_1_S368 phospho",
    "CAMSAP3 365_382_1_1_S378 phospho",
    "CAMSAP3 406_411_1_1_S409 phospho",
    "CAMSAP3 710_726_1_1_S712 phospho",
    "CAMSAP3 841_849_1_1_S841 phospho",
    "CAMSAP3 cnv",
    "CAMSAP3 methyl",
    "CAMSAP3 proteo",
    "CAMSAP3 rna"
  ],
  "CAMTA1": [
    "CAMTA1 cnv",
    "CAMTA1 methyl",
    "CAMTA1 rna"
  ],
  "CAMTA2": [
    "CAMTA2 cnv",
    "CAMTA2 methyl",
    "CAMTA2 rna"
  ],
  "CAND1": [
    "CAND1 1219_1230_1_0 phospho",
    "CAND1 1219_1230_1_1_S1220 phospho",
    "CAND1 1219_1230_1_1_S1226 phospho",
    "CAND1 557_564_1_1_S558 phospho",
    "CAND1 cnv",
    "CAND1 methyl",
    "CAND1 proteo",
    "CAND1 rna"
  ],
  "CAND2": [
    "CAND2 cnv",
    "CAND2 methyl",
    "CAND2 proteo",
    "CAND2 rna"
  ],
  "CANT1": [
    "CANT1 cnv",
    "CANT1 methyl",
    "CANT1 proteo",
    "CANT1 rna"
  ],
  "CANX": [
    "CANX 132_132_1_1_S132 phospho",
    "CANX 554_564_1_1_S554 phospho",
    "CANX 554_564_1_1_S564 phospho",
    "CANX 554_564_2_2_S554S564 phospho",
    "CANX 583_583_1_1_S583 phospho",
    "CANX cnv",
    "CANX methyl",
    "CANX proteo",
    "CANX rna"
  ],
  "CAP1": [
    "CAP1 255_268_1_1_S266 phospho",
    "CAP1 295_310_1_1_S308 phospho",
    "CAP1 295_310_2_2_S308S310 phospho",
    "CAP1 301_310_1_1_S308 phospho",
    "CAP1 301_310_2_2_S308S310 phospho",
    "CAP1 cnv",
    "CAP1 methyl",
    "CAP1 proteo",
    "CAP1 rna"
  ],
  "CAP2": [
    "CAP2 299_303_1_1_S301 phospho",
    "CAP2 305_312_1_1_S309 phospho",
    "CAP2 305_312_1_1_S312 phospho",
    "CAP2 305_312_2_2_S309S312 phospho",
    "CAP2 305_312_2_2_T307S309 phospho",
    "CAP2 305_312_3_3_T307S309S312 phospho",
    "CAP2 cnv",
    "CAP2 proteo",
    "CAP2 rna"
  ],
  "CAPG": [
    "CAPG 322_337_1_1_S337 phospho",
    "CAPG cnv",
    "CAPG methyl",
    "CAPG proteo",
    "CAPG rna"
  ],
  "CAPN1": [
    "CAPN1 cnv",
    "CAPN1 methyl",
    "CAPN1 proteo",
    "CAPN1 rna"
  ],
  "CAPN10": [
    "CAPN10 cnv",
    "CAPN10 methyl",
    "CAPN10 rna"
  ],
  "CAPN11": [
    "CAPN11 cnv",
    "CAPN11 rna"
  ],
  "CAPN12": [
    "CAPN12 cnv",
    "CAPN12 methyl",
    "CAPN12 rna"
  ],
  "CAPN13": [
    "CAPN13 cnv",
    "CAPN13 rna"
  ],
  "CAPN14": [
    "CAPN14 cnv",
    "CAPN14 methyl",
    "CAPN14 rna"
  ],
  "CAPN15": [
    "CAPN15 296_308_1_1_S296 phospho",
    "CAPN15 cnv",
    "CAPN15 methyl",
    "CAPN15 rna"
  ],
  "CAPN2": [
    "CAPN2 cnv",
    "CAPN2 methyl",
    "CAPN2 proteo",
    "CAPN2 rna"
  ],
  "CAPN3": [
    "CAPN3 cnv",
    "CAPN3 rna"
  ],
  "CAPN5": [
    "CAPN5 557_562_1_0 phospho",
    "CAPN5 cnv",
    "CAPN5 methyl",
    "CAPN5 proteo",
    "CAPN5 rna"
  ],
  "CAPN6": [
    "CAPN6 rna"
  ],
  "CAPN7": [
    "CAPN7 cnv",
    "CAPN7 methyl",
    "CAPN7 proteo",
    "CAPN7 rna"
  ],
  "CAPN8": [
    "CAPN8 cnv",
    "CAPN8 rna"
  ],
  "CAPN9": [
    "CAPN9 cnv",
    "CAPN9 rna"
  ],
  "CAPNS1": [
    "CAPNS1 cnv",
    "CAPNS1 methyl",
    "CAPNS1 proteo",
    "CAPNS1 rna"
  ],
  "CAPNS2": [
    "CAPNS2 cnv",
    "CAPNS2 rna"
  ],
  "CAPRIN1": [
    "CAPRIN1 cnv",
    "CAPRIN1 methyl",
    "CAPRIN1 proteo",
    "CAPRIN1 rna"
  ],
  "CAPRIN2": [
    "CAPRIN2 558_566_1_1_S566 phospho",
    "CAPRIN2 cnv",
    "CAPRIN2 methyl",
    "CAPRIN2 rna"
  ],
  "CAPS": [
    "CAPS 126_126_1_1_S126 phospho",
    "CAPS cnv",
    "CAPS methyl",
    "CAPS proteo",
    "CAPS rna"
  ],
  "CAPS2": [
    "CAPS2 cnv",
    "CAPS2 methyl",
    "CAPS2 rna"
  ],
  "CAPSL": [
    "CAPSL cnv",
    "CAPSL rna"
  ],
  "CAPZA1": [
    "CAPZA1 cnv",
    "CAPZA1 methyl",
    "CAPZA1 proteo",
    "CAPZA1 rna"
  ],
  "CAPZA2": [
    "CAPZA2 cnv",
    "CAPZA2 methyl",
    "CAPZA2 proteo",
    "CAPZA2 rna"
  ],
  "CAPZA3": [
    "CAPZA3 cnv",
    "CAPZA3 rna"
  ],
  "CAPZB": [
    "CAPZB cnv",
    "CAPZB methyl",
    "CAPZB proteo",
    "CAPZB rna"
  ],
  "CARD10": [
    "CARD10 cnv",
    "CARD10 methyl",
    "CARD10 rna"
  ],
  "CARD11": [
    "CARD11 871_886_1_1_S886 phospho",
    "CARD11 cnv",
    "CARD11 methyl",
    "CARD11 proteo",
    "CARD11 rna"
  ],
  "CARD14": [
    "CARD14 cnv",
    "CARD14 methyl",
    "CARD14 rna"
  ],
  "CARD16": [
    "CARD16 cnv",
    "CARD16 proteo",
    "CARD16 rna"
  ],
  "CARD18": [
    "CARD18 cnv",
    "CARD18 rna"
  ],
  "CARD19": [
    "CARD19 cnv",
    "CARD19 methyl",
    "CARD19 proteo",
    "CARD19 rna"
  ],
  "CARD6": [
    "CARD6 cnv",
    "CARD6 rna"
  ],
  "CARD8": [
    "CARD8 cnv",
    "CARD8 methyl",
    "CARD8 proteo",
    "CARD8 rna"
  ],
  "CARD9": [
    "CARD9 cnv",
    "CARD9 methyl",
    "CARD9 proteo",
    "CARD9 rna"
  ],
  "CARF": [
    "CARF cnv",
    "CARF methyl",
    "CARF rna"
  ],
  "CARHSP1": [
    "CARHSP1 139_147_1_1_S147 phospho",
    "CARHSP1 30_32_1_1_S30 phospho",
    "CARHSP1 30_45_1_1_S30 phospho",
    "CARHSP1 30_45_2_2_S30S32 phospho",
    "CARHSP1 30_45_2_2_S32S41 phospho",
    "CARHSP1 30_45_3_3_S30S32S41 phospho",
    "CARHSP1 cnv",
    "CARHSP1 methyl",
    "CARHSP1 proteo",
    "CARHSP1 rna"
  ],
  "CARM1": [
    "CARM1 cnv",
    "CARM1 methyl",
    "CARM1 proteo",
    "CARM1 rna"
  ],
  "CARMIL1": [
    "CARMIL1 1067_1068_1_1_S1068 phospho",
    "CARMIL1 1080_1094_1_1_S1094 phospho",
    "CARMIL1 1241_1259_1_1_S1248 phospho",
    "CARMIL1 1308_1313_1_1_S1309 phospho",
    "CARMIL1 1325_1333_1_1_S1325 phospho",
    "CARMIL1 1351_1354_1_1_S1354 phospho",
    "CARMIL1 874_880_1_1_S880 phospho",
    "CARMIL1 912_916_1_1_T916 phospho",
    "CARMIL1 967_976_1_1_S967 phospho",
    "CARMIL1 cnv",
    "CARMIL1 methyl",
    "CARMIL1 proteo",
    "CARMIL1 rna"
  ],
  "CARMIL2": [
    "CARMIL2 1115_1120_1_1_S1120 phospho",
    "CARMIL2 1246_1261_1_1_S1246 phospho",
    "CARMIL2 1266_1288_1_1_S1268 phospho",
    "CARMIL2 1381_1381_1_1_S1381 phospho",
    "CARMIL2 cnv",
    "CARMIL2 methyl",
    "CARMIL2 proteo",
    "CARMIL2 rna"
  ],
  "CARMIL3": [
    "CARMIL3 cnv",
    "CARMIL3 methyl",
    "CARMIL3 rna"
  ],
  "CARNMT1": [
    "CARNMT1 cnv",
    "CARNMT1 methyl",
    "CARNMT1 proteo",
    "CARNMT1 rna"
  ],
  "CARNS1": [
    "CARNS1 cnv",
    "CARNS1 methyl",
    "CARNS1 proteo",
    "CARNS1 rna"
  ],
  "CARS1": [
    "CARS1 102_107_1_1_S102 phospho",
    "CARS1 115_119_1_1_S117 phospho",
    "CARS1 cnv",
    "CARS1 methyl",
    "CARS1 proteo",
    "CARS1 rna"
  ],
  "CARS2": [
    "CARS2 cnv",
    "CARS2 methyl",
    "CARS2 proteo",
    "CARS2 rna"
  ],
  "CARTPT": [
    "CARTPT 41_48_1_1_S48 phospho",
    "CARTPT cnv",
    "CARTPT methyl",
    "CARTPT rna"
  ],
  "CASC11": [
    "CASC11 methyl"
  ],
  "CASC2": [
    "CASC2 methyl"
  ],
  "CASC3": [
    "CASC3 10_28_1_1_S28 phospho",
    "CASC3 140_155_1_1_S148 phospho",
    "CASC3 148_155_1_1_S148 phospho",
    "CASC3 263_265_1_1_S265 phospho",
    "CASC3 357_373_1_1_S363 phospho",
    "CASC3 cnv",
    "CASC3 methyl",
    "CASC3 proteo",
    "CASC3 rna"
  ],
  "CASD1": [
    "CASD1 cnv",
    "CASD1 methyl",
    "CASD1 rna"
  ],
  "CASK": [
    "CASK 567_579_1_1_S571 phospho",
    "CASK 567_579_2_2_S570S571 phospho",
    "CASK kinase",
    "CASK methyl",
    "CASK proteo",
    "CASK rna"
  ],
  "CASKIN1": [
    "CASKIN1 1104_1104_1_1_S1104 phospho",
    "CASKIN1 1242_1247_1_1_S1242 phospho",
    "CASKIN1 1257_1257_1_1_S1257 phospho",
    "CASKIN1 1364_1368_1_1_S1364 phospho",
    "CASKIN1 423_440_1_1_S423 phospho",
    "CASKIN1 704_722_1_0 phospho",
    "CASKIN1 724_737_1_1_T737 phospho",
    "CASKIN1 755_755_1_1_S755 phospho",
    "CASKIN1 771_781_1_1_T775 phospho",
    "CASKIN1 783_801_1_1_S787 phospho",
    "CASKIN1 807_819_1_0 phospho",
    "CASKIN1 cnv",
    "CASKIN1 methyl",
    "CASKIN1 proteo",
    "CASKIN1 rna"
  ],
  "CASKIN2": [
    "CASKIN2 311_330_1_1_S314 phospho",
    "CASKIN2 311_330_1_1_S321 phospho",
    "CASKIN2 584_618_1_1_S613 phospho",
    "CASKIN2 716_748_1_0 phospho",
    "CASKIN2 759_766_1_1_S760 phospho",
    "CASKIN2 863_877_1_0 phospho",
    "CASKIN2 cnv",
    "CASKIN2 methyl",
    "CASKIN2 proteo",
    "CASKIN2 rna"
  ],
  "CASP1": [
    "CASP1 cnv",
    "CASP1 proteo",
    "CASP1 rna"
  ],
  "CASP10": [
    "CASP10 cnv",
    "CASP10 proteo",
    "CASP10 rna"
  ],
  "CASP12": [
    "CASP12 cnv",
    "CASP12 rna"
  ],
  "CASP14": [
    "CASP14 cnv"
  ],
  "CASP2": [
    "CASP2 340_346_1_1_S340 phospho",
    "CASP2 cnv",
    "CASP2 methyl",
    "CASP2 proteo",
    "CASP2 rna"
  ],
  "CASP3": [
    "CASP3 cnv",
    "CASP3 methyl",
    "CASP3 proteo",
    "CASP3 rna"
  ],
  "CASP4": [
    "CASP4 cnv",
    "CASP4 proteo",
    "CASP4 rna"
  ],
  "CASP5": [
    "CASP5 cnv",
    "CASP5 rna"
  ],
  "CASP6": [
    "CASP6 cnv",
    "CASP6 methyl",
    "CASP6 proteo",
    "CASP6 rna"
  ],
  "CASP7": [
    "CASP7 cnv",
    "CASP7 methyl",
    "CASP7 proteo",
    "CASP7 rna"
  ],
  "CASP8": [
    "CASP8 cnv",
    "CASP8 proteo",
    "CASP8 rna"
  ],
  "CASP8AP2": [
    "CASP8AP2 cnv",
    "CASP8AP2 methyl",
    "CASP8AP2 rna"
  ],
  "CASP9": [
    "CASP9 cnv",
    "CASP9 methyl",
    "CASP9 proteo",
    "CASP9 rna"
  ],
  "CASQ1": [
    "CASQ1 cnv",
    "CASQ1 rna"
  ],
  "CASQ2": [
    "CASQ2 cnv",
    "CASQ2 rna"
  ],
  "CASR": [
    "CASR cnv",
    "CASR methyl",
    "CASR rna"
  ],
  "CASS4": [
    "CASS4 cnv",
    "CASS4 rna"
  ],
  "CAST": [
    "CAST 132_136_1_1_S132 phospho",
    "CAST 258_287_1_0 phospho",
    "CAST 258_287_1_1_S285 phospho",
    "CAST 297_306_1_1_S304 phospho",
    "CAST cnv",
    "CAST methyl",
    "CAST proteo",
    "CAST rna"
  ],
  "CASTOR1": [
    "CASTOR1 cnv",
    "CASTOR1 methyl",
    "CASTOR1 proteo",
    "CASTOR1 rna"
  ],
  "CASTOR2": [
    "CASTOR2 cnv",
    "CASTOR2 methyl",
    "CASTOR2 proteo",
    "CASTOR2 rna"
  ],
  "CASTOR3P": [
    "CASTOR3P methyl"
  ],
  "CASZ1": [
    "CASZ1 cnv",
    "CASZ1 methyl",
    "CASZ1 rna"
  ],
  "CAT": [
    "CAT 511_517_1_1_S515 phospho",
    "CAT cnv",
    "CAT methyl",
    "CAT proteo",
    "CAT rna"
  ],
  "CATIP": [
    "CATIP cnv",
    "CATIP rna"
  ],
  "CATSPER1": [
    "CATSPER1 cnv",
    "CATSPER1 rna"
  ],
  "CATSPER2": [
    "CATSPER2 cnv",
    "CATSPER2 methyl",
    "CATSPER2 rna"
  ],
  "CATSPER2P1": [
    "CATSPER2P1 methyl"
  ],
  "CATSPER3": [
    "CATSPER3 cnv",
    "CATSPER3 methyl",
    "CATSPER3 rna"
  ],
  "CATSPER4": [
    "CATSPER4 cnv",
    "CATSPER4 rna"
  ],
  "CATSPERB": [
    "CATSPERB cnv",
    "CATSPERB rna"
  ],
  "CATSPERD": [
    "CATSPERD cnv",
    "CATSPERD methyl",
    "CATSPERD rna"
  ],
  "CATSPERE": [
    "CATSPERE cnv",
    "CATSPERE methyl",
    "CATSPERE rna"
  ],
  "CATSPERG": [
    "CATSPERG cnv",
    "CATSPERG methyl",
    "CATSPERG rna"
  ],
  "CATSPERZ": [
    "CATSPERZ cnv",
    "CATSPERZ methyl",
    "CATSPERZ rna"
  ],
  "CAV1": [
    "CAV1 37_46_1_1_S37 phospho",
    "CAV1 6_15_1_1_S9 phospho",
    "CAV1 cnv",
    "CAV1 methyl",
    "CAV1 proteo",
    "CAV1 rna"
  ],
  "CAV2": [
    "CAV2 18_27_2_0 phospho",
    "CAV2 cnv",
    "CAV2 methyl",
    "CAV2 proteo",
    "CAV2 rna"
  ],
  "CAV3": [
    "CAV3 cnv",
    "CAV3 rna"
  ],
  "CAVIN1": [
    "CAVIN1 300_308_1_1_S300 phospho",
    "CAVIN1 300_308_1_1_T302 phospho",
    "CAVIN1 cnv",
    "CAVIN1 methyl",
    "CAVIN1 proteo",
    "CAVIN1 rna"
  ],
  "CAVIN2": [
    "CAVIN2 274_277_1_1_S274 phospho",
    "CAVIN2 287_296_1_1_S293 phospho",
    "CAVIN2 287_296_2_2_S288S293 phospho",
    "CAVIN2 cnv",
    "CAVIN2 proteo",
    "CAVIN2 rna"
  ],
  "CAVIN3": [
    "CAVIN3 cnv",
    "CAVIN3 methyl",
    "CAVIN3 proteo",
    "CAVIN3 rna"
  ],
  "CAVIN4": [
    "CAVIN4 cnv",
    "CAVIN4 rna"
  ],
  "CBARP": [
    "CBARP 133_143_1_1_S133 phospho",
    "CBARP 153_156_1_1_T154 phospho",
    "CBARP 180_200_1_1_S200 phospho",
    "CBARP 299_306_1_1_S299 phospho",
    "CBARP 299_306_2_2_S299S304 phospho",
    "CBARP 322_328_1_1_S328 phospho",
    "CBARP 378_378_1_1_S378 phospho",
    "CBARP 404_404_1_1_S404 phospho",
    "CBARP 414_420_1_1_S414 phospho",
    "CBARP cnv",
    "CBARP methyl",
    "CBARP proteo",
    "CBARP rna"
  ],
  "CBFA2T2": [
    "CBFA2T2 24_24_1_1_S24 phospho",
    "CBFA2T2 561_568_1_1_S568 phospho",
    "CBFA2T2 cnv",
    "CBFA2T2 methyl",
    "CBFA2T2 rna"
  ],
  "CBFA2T3": [
    "CBFA2T3 cnv",
    "CBFA2T3 methyl",
    "CBFA2T3 rna"
  ],
  "CBFB": [
    "CBFB 173_176_1_1_S173 phospho",
    "CBFB cnv",
    "CBFB methyl",
    "CBFB proteo",
    "CBFB rna"
  ],
  "CBL": [
    "CBL 452_466_1_1_S452 phospho",
    "CBL 483_492_1_1_S483 phospho",
    "CBL 667_675_1_0 phospho",
    "CBL 667_675_1_1_S667 phospho",
    "CBL cnv",
    "CBL methyl",
    "CBL proteo",
    "CBL rna"
  ],
  "CBLB": [
    "CBLB cnv",
    "CBLB methyl",
    "CBLB proteo",
    "CBLB rna"
  ],
  "CBLC": [
    "CBLC cnv",
    "CBLC methyl",
    "CBLC rna"
  ],
  "CBLIF": [
    "CBLIF cnv"
  ],
  "CBLL1": [
    "CBLL1 cnv",
    "CBLL1 methyl",
    "CBLL1 proteo",
    "CBLL1 rna"
  ],
  "CBLL1-AS1": [
    "CBLL1-AS1 methyl"
  ],
  "CBLL2": [
    "CBLL2 rna"
  ],
  "CBLN1": [
    "CBLN1 cnv",
    "CBLN1 methyl",
    "CBLN1 rna"
  ],
  "CBLN2": [
    "CBLN2 cnv",
    "CBLN2 methyl",
    "CBLN2 rna"
  ],
  "CBLN3": [
    "CBLN3 cnv",
    "CBLN3 methyl",
    "CBLN3 rna"
  ],
  "CBLN4": [
    "CBLN4 cnv",
    "CBLN4 methyl",
    "CBLN4 rna"
  ],
  "CBR1": [
    "CBR1 149_151_1_1_S151 phospho",
    "CBR1 cnv",
    "CBR1 methyl",
    "CBR1 proteo",
    "CBR1 rna"
  ],
  "CBR3": [
    "CBR3 192_197_1_1_S192 phospho",
    "CBR3 cnv",
    "CBR3 methyl",
    "CBR3 proteo",
    "CBR3 rna"
  ],
  "CBR3-AS1": [
    "CBR3-AS1 methyl"
  ],
  "CBR4": [
    "CBR4 cnv",
    "CBR4 methyl",
    "CBR4 proteo",
    "CBR4 rna"
  ],
  "CBS": [
    "CBS cnv",
    "CBS methyl",
    "CBS rna"
  ],
  "CBSL": [
    "CBSL cnv",
    "CBSL rna"
  ],
  "CBX1": [
    "CBX1 89_98_1_1_S89 phospho",
    "CBX1 cnv",
    "CBX1 methyl",
    "CBX1 proteo",
    "CBX1 rna"
  ],
  "CBX2": [
    "CBX2 cnv",
    "CBX2 methyl",
    "CBX2 proteo",
    "CBX2 rna"
  ],
  "CBX3": [
    "CBX3 93_102_1_1_S93 phospho",
    "CBX3 93_102_1_1_S95 phospho",
    "CBX3 93_102_1_1_S97 phospho",
    "CBX3 93_102_2_2_S93S95 phospho",
    "CBX3 93_102_2_2_S95S97 phospho",
    "CBX3 93_102_3_3_S93S95S97 phospho",
    "CBX3 cnv",
    "CBX3 methyl",
    "CBX3 proteo",
    "CBX3 rna"
  ],
  "CBX3P2": [
    "CBX3P2 methyl"
  ],
  "CBX4": [
    "CBX4 281_293_1_1_S291 phospho",
    "CBX4 cnv",
    "CBX4 methyl",
    "CBX4 proteo",
    "CBX4 rna"
  ],
  "CBX5": [
    "CBX5 8_20_1_1_S14 phospho",
    "CBX5 92_97_1_1_S97 phospho",
    "CBX5 cnv",
    "CBX5 methyl",
    "CBX5 proteo",
    "CBX5 rna"
  ],
  "CBX6": [
    "CBX6 cnv",
    "CBX6 methyl",
    "CBX6 proteo",
    "CBX6 rna"
  ],
  "CBX7": [
    "CBX7 cnv",
    "CBX7 methyl",
    "CBX7 rna"
  ],
  "CBX8": [
    "CBX8 106_118_1_1_S110 phospho",
    "CBX8 190_196_1_0 phospho",
    "CBX8 190_196_1_1_S191 phospho",
    "CBX8 311_321_1_1_S311 phospho",
    "CBX8 cnv",
    "CBX8 methyl",
    "CBX8 proteo",
    "CBX8 rna"
  ],
  "CBY1": [
    "CBY1 18_26_1_1_S20 phospho",
    "CBY1 cnv",
    "CBY1 methyl",
    "CBY1 rna"
  ],
  "CBY2": [
    "CBY2 cnv",
    "CBY2 rna"
  ],
  "CBY3": [
    "CBY3 cnv",
    "CBY3 rna"
  ],
  "CC2D1A": [
    "CC2D1A 118_139_1_1_T120 phospho",
    "CC2D1A 203_212_1_0 phospho",
    "CC2D1A 309_339_1_1_S327 phospho",
    "CC2D1A 455_460_1_1_S455 phospho",
    "CC2D1A 669_674_1_1_S674 phospho",
    "CC2D1A cnv",
    "CC2D1A methyl",
    "CC2D1A proteo",
    "CC2D1A rna"
  ],
  "CC2D1B": [
    "CC2D1B cnv",
    "CC2D1B methyl",
    "CC2D1B proteo",
    "CC2D1B rna"
  ],
  "CC2D2A": [
    "CC2D2A cnv",
    "CC2D2A rna"
  ],
  "CC2D2B": [
    "CC2D2B cnv",
    "CC2D2B methyl",
    "CC2D2B rna"
  ],
  "CCAR1": [
    "CCAR1 611_617_1_0 phospho",
    "CCAR1 cnv",
    "CCAR1 methyl",
    "CCAR1 proteo",
    "CCAR1 rna"
  ],
  "CCAR2": [
    "CCAR2 115_124_1_1_S124 phospho",
    "CCAR2 484_495_1_1_T484 phospho",
    "CCAR2 675_687_1_0 phospho",
    "CCAR2 675_687_1_1_S678 phospho",
    "CCAR2 804_814_1_1_S808 phospho",
    "CCAR2 912_922_1_1_S922 phospho",
    "CCAR2 cnv",
    "CCAR2 methyl",
    "CCAR2 proteo",
    "CCAR2 rna"
  ],
  "CCBE1": [
    "CCBE1 cnv",
    "CCBE1 methyl",
    "CCBE1 rna"
  ],
  "CCDC102A": [
    "CCDC102A cnv",
    "CCDC102A methyl",
    "CCDC102A proteo",
    "CCDC102A rna"
  ],
  "CCDC102B": [
    "CCDC102B cnv",
    "CCDC102B methyl",
    "CCDC102B rna"
  ],
  "CCDC103": [
    "CCDC103 cnv",
    "CCDC103 methyl",
    "CCDC103 rna"
  ],
  "CCDC105": [
    "CCDC105 cnv",
    "CCDC105 methyl"
  ],
  "CCDC106": [
    "CCDC106 130_149_1_1_S130 phospho",
    "CCDC106 cnv",
    "CCDC106 methyl",
    "CCDC106 rna"
  ],
  "CCDC107": [
    "CCDC107 cnv",
    "CCDC107 methyl",
    "CCDC107 rna"
  ],
  "CCDC110": [
    "CCDC110 cnv",
    "CCDC110 methyl",
    "CCDC110 rna"
  ],
  "CCDC112": [
    "CCDC112 cnv",
    "CCDC112 methyl",
    "CCDC112 rna"
  ],
  "CCDC113": [
    "CCDC113 cnv",
    "CCDC113 methyl",
    "CCDC113 rna"
  ],
  "CCDC115": [
    "CCDC115 cnv",
    "CCDC115 methyl",
    "CCDC115 proteo",
    "CCDC115 rna"
  ],
  "CCDC116": [
    "CCDC116 cnv",
    "CCDC116 rna"
  ],
  "CCDC117": [
    "CCDC117 52_57_1_1_S53 phospho",
    "CCDC117 cnv",
    "CCDC117 methyl",
    "CCDC117 proteo",
    "CCDC117 rna"
  ],
  "CCDC12": [
    "CCDC12 cnv",
    "CCDC12 methyl",
    "CCDC12 proteo",
    "CCDC12 rna"
  ],
  "CCDC120": [
    "CCDC120 315_323_1_1_S315 phospho",
    "CCDC120 393_396_1_1_S395 phospho",
    "CCDC120 411_421_1_1_S411 phospho",
    "CCDC120 methyl",
    "CCDC120 rna"
  ],
  "CCDC121": [
    "CCDC121 cnv",
    "CCDC121 rna"
  ],
  "CCDC122": [
    "CCDC122 cnv",
    "CCDC122 methyl",
    "CCDC122 rna"
  ],
  "CCDC124": [
    "CCDC124 cnv",
    "CCDC124 methyl",
    "CCDC124 proteo",
    "CCDC124 rna"
  ],
  "CCDC125": [
    "CCDC125 cnv",
    "CCDC125 methyl",
    "CCDC125 rna"
  ],
  "CCDC126": [
    "CCDC126 cnv",
    "CCDC126 methyl",
    "CCDC126 rna"
  ],
  "CCDC127": [
    "CCDC127 cnv",
    "CCDC127 methyl",
    "CCDC127 proteo",
    "CCDC127 rna"
  ],
  "CCDC13": [
    "CCDC13 cnv",
    "CCDC13 methyl",
    "CCDC13 rna"
  ],
  "CCDC134": [
    "CCDC134 cnv",
    "CCDC134 methyl",
    "CCDC134 proteo",
    "CCDC134 rna"
  ],
  "CCDC136": [
    "CCDC136 cnv",
    "CCDC136 methyl",
    "CCDC136 proteo",
    "CCDC136 rna"
  ],
  "CCDC137": [
    "CCDC137 cnv",
    "CCDC137 methyl",
    "CCDC137 rna"
  ],
  "CCDC138": [
    "CCDC138 cnv",
    "CCDC138 methyl",
    "CCDC138 rna"
  ],
  "CCDC14": [
    "CCDC14 cnv",
    "CCDC14 methyl",
    "CCDC14 rna"
  ],
  "CCDC140": [
    "CCDC140 methyl"
  ],
  "CCDC141": [
    "CCDC141 cnv",
    "CCDC141 proteo",
    "CCDC141 rna"
  ],
  "CCDC142": [
    "CCDC142 cnv",
    "CCDC142 methyl",
    "CCDC142 rna"
  ],
  "CCDC144A": [
    "CCDC144A cnv",
    "CCDC144A methyl",
    "CCDC144A rna"
  ],
  "CCDC144NL": [
    "CCDC144NL methyl"
  ],
  "CCDC146": [
    "CCDC146 cnv",
    "CCDC146 rna"
  ],
  "CCDC148": [
    "CCDC148 cnv",
    "CCDC148 methyl",
    "CCDC148 rna"
  ],
  "CCDC149": [
    "CCDC149 366_368_1_1_S368 phospho",
    "CCDC149 cnv",
    "CCDC149 methyl",
    "CCDC149 proteo",
    "CCDC149 rna"
  ],
  "CCDC15": [
    "CCDC15 cnv",
    "CCDC15 methyl",
    "CCDC15 rna"
  ],
  "CCDC150": [
    "CCDC150 cnv",
    "CCDC150 methyl",
    "CCDC150 rna"
  ],
  "CCDC152": [
    "CCDC152 cnv",
    "CCDC152 rna"
  ],
  "CCDC153": [
    "CCDC153 cnv",
    "CCDC153 rna"
  ],
  "CCDC154": [
    "CCDC154 cnv",
    "CCDC154 methyl",
    "CCDC154 rna"
  ],
  "CCDC157": [
    "CCDC157 cnv",
    "CCDC157 methyl",
    "CCDC157 rna"
  ],
  "CCDC158": [
    "CCDC158 cnv",
    "CCDC158 methyl",
    "CCDC158 proteo",
    "CCDC158 rna"
  ],
  "CCDC159": [
    "CCDC159 cnv",
    "CCDC159 methyl",
    "CCDC159 rna"
  ],
  "CCDC160": [
    "CCDC160 methyl",
    "CCDC160 rna"
  ],
  "CCDC163": [
    "CCDC163 cnv",
    "CCDC163 methyl",
    "CCDC163 rna"
  ],
  "CCDC166": [
    "CCDC166 cnv",
    "CCDC166 methyl",
    "CCDC166 rna"
  ],
  "CCDC167": [
    "CCDC167 cnv",
    "CCDC167 methyl",
    "CCDC167 proteo",
    "CCDC167 rna"
  ],
  "CCDC168": [
    "CCDC168 cnv",
    "CCDC168 rna"
  ],
  "CCDC169": [
    "CCDC169 cnv",
    "CCDC169 methyl",
    "CCDC169 rna"
  ],
  "CCDC169-SOHLH2": [
    "CCDC169-SOHLH2 cnv",
    "CCDC169-SOHLH2 methyl",
    "CCDC169-SOHLH2 rna"
  ],
  "CCDC17": [
    "CCDC17 cnv",
    "CCDC17 methyl",
    "CCDC17 rna"
  ],
  "CCDC170": [
    "CCDC170 cnv",
    "CCDC170 methyl",
    "CCDC170 rna"
  ],
  "CCDC171": [
    "CCDC171 cnv",
    "CCDC171 methyl",
    "CCDC171 rna"
  ],
  "CCDC172": [
    "CCDC172 cnv",
    "CCDC172 rna"
  ],
  "CCDC174": [
    "CCDC174 cnv",
    "CCDC174 methyl",
    "CCDC174 proteo",
    "CCDC174 rna"
  ],
  "CCDC175": [
    "CCDC175 cnv",
    "CCDC175 methyl",
    "CCDC175 rna"
  ],
  "CCDC177": [
    "CCDC177 302_314_1_1_S304 phospho",
    "CCDC177 421_424_1_1_S424 phospho",
    "CCDC177 cnv",
    "CCDC177 methyl",
    "CCDC177 proteo",
    "CCDC177 rna"
  ],
  "CCDC178": [
    "CCDC178 cnv",
    "CCDC178 methyl",
    "CCDC178 rna"
  ],
  "CCDC179": [
    "CCDC179 cnv"
  ],
  "CCDC18": [
    "CCDC18 cnv",
    "CCDC18 methyl",
    "CCDC18 proteo",
    "CCDC18 rna"
  ],
  "CCDC180": [
    "CCDC180 cnv",
    "CCDC180 methyl",
    "CCDC180 rna"
  ],
  "CCDC181": [
    "CCDC181 cnv",
    "CCDC181 methyl",
    "CCDC181 rna"
  ],
  "CCDC182": [
    "CCDC182 cnv",
    "CCDC182 rna"
  ],
  "CCDC183": [
    "CCDC183 cnv",
    "CCDC183 methyl",
    "CCDC183 rna"
  ],
  "CCDC184": [
    "CCDC184 cnv",
    "CCDC184 methyl",
    "CCDC184 rna"
  ],
  "CCDC185": [
    "CCDC185 cnv",
    "CCDC185 methyl",
    "CCDC185 rna"
  ],
  "CCDC186": [
    "CCDC186 cnv",
    "CCDC186 methyl",
    "CCDC186 proteo",
    "CCDC186 rna"
  ],
  "CCDC187": [
    "CCDC187 cnv",
    "CCDC187 rna"
  ],
  "CCDC188": [
    "CCDC188 cnv",
    "CCDC188 rna"
  ],
  "CCDC190": [
    "CCDC190 cnv",
    "CCDC190 rna"
  ],
  "CCDC191": [
    "CCDC191 cnv",
    "CCDC191 methyl",
    "CCDC191 rna"
  ],
  "CCDC192": [
    "CCDC192 cnv",
    "CCDC192 rna"
  ],
  "CCDC194": [
    "CCDC194 cnv",
    "CCDC194 methyl",
    "CCDC194 rna"
  ],
  "CCDC195": [
    "CCDC195 cnv",
    "CCDC195 rna"
  ],
  "CCDC196": [
    "CCDC196 cnv",
    "CCDC196 rna"
  ],
  "CCDC197": [
    "CCDC197 cnv",
    "CCDC197 rna"
  ],
  "CCDC198": [
    "CCDC198 cnv",
    "CCDC198 rna"
  ],
  "CCDC200": [
    "CCDC200 cnv",
    "CCDC200 rna"
  ],
  "CCDC201": [
    "CCDC201 cnv"
  ],
  "CCDC22": [
    "CCDC22 methyl",
    "CCDC22 proteo",
    "CCDC22 rna"
  ],
  "CCDC24": [
    "CCDC24 cnv",
    "CCDC24 methyl",
    "CCDC24 rna"
  ],
  "CCDC25": [
    "CCDC25 196_204_1_1_S204 phospho",
    "CCDC25 cnv",
    "CCDC25 methyl",
    "CCDC25 proteo",
    "CCDC25 rna"
  ],
  "CCDC27": [
    "CCDC27 cnv",
    "CCDC27 methyl",
    "CCDC27 rna"
  ],
  "CCDC28A": [
    "CCDC28A cnv",
    "CCDC28A methyl",
    "CCDC28A proteo",
    "CCDC28A rna"
  ],
  "CCDC28A-AS1": [
    "CCDC28A-AS1 methyl"
  ],
  "CCDC28B": [
    "CCDC28B cnv",
    "CCDC28B methyl",
    "CCDC28B proteo",
    "CCDC28B rna"
  ],
  "CCDC3": [
    "CCDC3 cnv",
    "CCDC3 methyl",
    "CCDC3 rna"
  ],
  "CCDC30": [
    "CCDC30 cnv",
    "CCDC30 methyl",
    "CCDC30 rna"
  ],
  "CCDC32": [
    "CCDC32 cnv",
    "CCDC32 rna"
  ],
  "CCDC33": [
    "CCDC33 cnv",
    "CCDC33 rna"
  ],
  "CCDC34": [
    "CCDC34 cnv",
    "CCDC34 methyl",
    "CCDC34 rna"
  ],
  "CCDC38": [
    "CCDC38 cnv",
    "CCDC38 methyl",
    "CCDC38 rna"
  ],
  "CCDC39": [
    "CCDC39 cnv",
    "CCDC39 methyl",
    "CCDC39 rna"
  ],
  "CCDC40": [
    "CCDC40 cnv",
    "CCDC40 methyl",
    "CCDC40 rna"
  ],
  "CCDC42": [
    "CCDC42 cnv",
    "CCDC42 methyl",
    "CCDC42 rna"
  ],
  "CCDC43": [
    "CCDC43 135_139_1_1_T139 phospho",
    "CCDC43 135_160_1_1_T139 phospho",
    "CCDC43 cnv",
    "CCDC43 methyl",
    "CCDC43 proteo",
    "CCDC43 rna"
  ],
  "CCDC47": [
    "CCDC47 cnv",
    "CCDC47 methyl",
    "CCDC47 proteo",
    "CCDC47 rna"
  ],
  "CCDC50": [
    "CCDC50 cnv",
    "CCDC50 methyl",
    "CCDC50 proteo",
    "CCDC50 rna"
  ],
  "CCDC51": [
    "CCDC51 cnv",
    "CCDC51 methyl",
    "CCDC51 proteo",
    "CCDC51 rna"
  ],
  "CCDC54": [
    "CCDC54 cnv",
    "CCDC54 rna"
  ],
  "CCDC57": [
    "CCDC57 cnv",
    "CCDC57 methyl",
    "CCDC57 rna"
  ],
  "CCDC59": [
    "CCDC59 cnv",
    "CCDC59 methyl",
    "CCDC59 rna"
  ],
  "CCDC6": [
    "CCDC6 240_244_2_2_S240S244 phospho",
    "CCDC6 323_328_1_1_S323 phospho",
    "CCDC6 323_341_1_1_S323 phospho",
    "CCDC6 349_386_1_1_S352 phospho",
    "CCDC6 367_386_1_1_S367 phospho",
    "CCDC6 cnv",
    "CCDC6 methyl",
    "CCDC6 proteo",
    "CCDC6 rna"
  ],
  "CCDC60": [
    "CCDC60 cnv",
    "CCDC60 methyl",
    "CCDC60 rna"
  ],
  "CCDC61": [
    "CCDC61 469_473_1_1_S473 phospho",
    "CCDC61 cnv",
    "CCDC61 rna"
  ],
  "CCDC62": [
    "CCDC62 cnv",
    "CCDC62 methyl",
    "CCDC62 rna"
  ],
  "CCDC63": [
    "CCDC63 cnv",
    "CCDC63 methyl",
    "CCDC63 rna"
  ],
  "CCDC65": [
    "CCDC65 cnv",
    "CCDC65 rna"
  ],
  "CCDC66": [
    "CCDC66 cnv",
    "CCDC66 methyl",
    "CCDC66 rna"
  ],
  "CCDC68": [
    "CCDC68 cnv",
    "CCDC68 methyl",
    "CCDC68 rna"
  ],
  "CCDC69": [
    "CCDC69 cnv",
    "CCDC69 methyl",
    "CCDC69 rna"
  ],
  "CCDC7": [
    "CCDC7 cnv",
    "CCDC7 rna"
  ],
  "CCDC70": [
    "CCDC70 cnv",
    "CCDC70 rna"
  ],
  "CCDC71": [
    "CCDC71 cnv",
    "CCDC71 methyl",
    "CCDC71 rna"
  ],
  "CCDC71L": [
    "CCDC71L cnv",
    "CCDC71L methyl",
    "CCDC71L rna"
  ],
  "CCDC73": [
    "CCDC73 cnv",
    "CCDC73 rna"
  ],
  "CCDC74A": [
    "CCDC74A cnv",
    "CCDC74A methyl",
    "CCDC74A rna"
  ],
  "CCDC74B": [
    "CCDC74B cnv",
    "CCDC74B rna"
  ],
  "CCDC77": [
    "CCDC77 cnv",
    "CCDC77 methyl",
    "CCDC77 rna"
  ],
  "CCDC78": [
    "CCDC78 cnv",
    "CCDC78 methyl",
    "CCDC78 rna"
  ],
  "CCDC8": [
    "CCDC8 261_261_1_1_S261 phospho",
    "CCDC8 cnv",
    "CCDC8 methyl",
    "CCDC8 proteo",
    "CCDC8 rna"
  ],
  "CCDC80": [
    "CCDC80 cnv",
    "CCDC80 rna"
  ],
  "CCDC81": [
    "CCDC81 cnv",
    "CCDC81 methyl",
    "CCDC81 rna"
  ],
  "CCDC82": [
    "CCDC82 131_131_1_1_S131 phospho",
    "CCDC82 219_220_1_1_S219 phospho",
    "CCDC82 cnv",
    "CCDC82 methyl",
    "CCDC82 proteo",
    "CCDC82 rna"
  ],
  "CCDC83": [
    "CCDC83 cnv",
    "CCDC83 methyl",
    "CCDC83 rna"
  ],
  "CCDC85A": [
    "CCDC85A 230_233_1_1_S233 phospho",
    "CCDC85A 300_304_1_1_S301 phospho",
    "CCDC85A 311_313_1_1_S313 phospho",
    "CCDC85A 347_347_1_1_S347 phospho",
    "CCDC85A 357_358_1_1_S358 phospho",
    "CCDC85A cnv",
    "CCDC85A methyl",
    "CCDC85A rna"
  ],
  "CCDC85B": [
    "CCDC85B cnv",
    "CCDC85B methyl",
    "CCDC85B proteo",
    "CCDC85B rna"
  ],
  "CCDC85C": [
    "CCDC85C 246_251_1_1_S246 phospho",
    "CCDC85C 258_270_1_1_S258 phospho",
    "CCDC85C cnv",
    "CCDC85C methyl",
    "CCDC85C proteo",
    "CCDC85C rna"
  ],
  "CCDC86": [
    "CCDC86 18_26_1_1_S18 phospho",
    "CCDC86 37_50_1_1_S47 phospho",
    "CCDC86 58_58_1_1_S58 phospho",
    "CCDC86 80_91_1_1_S91 phospho",
    "CCDC86 80_91_2_2_S80S91 phospho",
    "CCDC86 cnv",
    "CCDC86 methyl",
    "CCDC86 proteo",
    "CCDC86 rna"
  ],
  "CCDC87": [
    "CCDC87 cnv",
    "CCDC87 methyl",
    "CCDC87 rna"
  ],
  "CCDC88A": [
    "CCDC88A 1019_1024_1_1_S1020 phospho",
    "CCDC88A 1384_1387_1_1_S1387 phospho",
    "CCDC88A 1417_1423_1_1_S1417 phospho",
    "CCDC88A 1425_1458_1_1_S1439 phospho",
    "CCDC88A 1531_1550_1_1_S1533 phospho",
    "CCDC88A 1565_1575_1_1_S1575 phospho",
    "CCDC88A 1622_1625_2_0 phospho",
    "CCDC88A 1624_1625_1_1_S1625 phospho",
    "CCDC88A 1645_1662_1_1_S1647 phospho",
    "CCDC88A 1672_1674_1_1_S1674 phospho",
    "CCDC88A 1778_1788_1_1_S1779 phospho",
    "CCDC88A 1791_1798_1_0 phospho",
    "CCDC88A 1791_1798_1_1_S1792 phospho",
    "CCDC88A 243_250_1_1_S245 phospho",
    "CCDC88A cnv",
    "CCDC88A methyl",
    "CCDC88A proteo",
    "CCDC88A rna"
  ],
  "CCDC88B": [
    "CCDC88B 429_448_1_1_S436 phospho",
    "CCDC88B 596_612_1_1_S597 phospho",
    "CCDC88B cnv",
    "CCDC88B methyl",
    "CCDC88B proteo",
    "CCDC88B rna"
  ],
  "CCDC88C": [
    "CCDC88C cnv",
    "CCDC88C methyl",
    "CCDC88C proteo",
    "CCDC88C rna"
  ],
  "CCDC89": [
    "CCDC89 cnv",
    "CCDC89 rna"
  ],
  "CCDC9": [
    "CCDC9 361_370_1_1_S362 phospho",
    "CCDC9 376_390_1_1_S386 phospho",
    "CCDC9 80_90_1_1_S80 phospho",
    "CCDC9 95_95_1_1_T95 phospho",
    "CCDC9 cnv",
    "CCDC9 methyl",
    "CCDC9 proteo",
    "CCDC9 rna"
  ],
  "CCDC90B": [
    "CCDC90B cnv",
    "CCDC90B methyl",
    "CCDC90B proteo",
    "CCDC90B rna"
  ],
  "CCDC91": [
    "CCDC91 cnv",
    "CCDC91 methyl",
    "CCDC91 proteo",
    "CCDC91 rna"
  ],
  "CCDC92": [
    "CCDC92 cnv",
    "CCDC92 methyl",
    "CCDC92 proteo",
    "CCDC92 rna"
  ],
  "CCDC92B": [
    "CCDC92B cnv",
    "CCDC92B methyl",
    "CCDC92B proteo",
    "CCDC92B rna"
  ],
  "CCDC93": [
    "CCDC93 298_305_1_1_S305 phospho",
    "CCDC93 cnv",
    "CCDC93 methyl",
    "CCDC93 proteo",
    "CCDC93 rna"
  ],
  "CCDC96": [
    "CCDC96 cnv",
    "CCDC96 methyl",
    "CCDC96 rna"
  ],
  "CCDC97": [
    "CCDC97 137_163_1_1_S147 phospho",
    "CCDC97 cnv",
    "CCDC97 methyl",
    "CCDC97 proteo",
    "CCDC97 rna"
  ],
  "CCDC9B": [
    "CCDC9B 199_212_1_1_S201 phospho",
    "CCDC9B cnv",
    "CCDC9B proteo",
    "CCDC9B rna"
  ],
  "CCER1": [
    "CCER1 cnv",
    "CCER1 methyl"
  ],
  "CCER2": [
    "CCER2 68_76_1_1_S75 phospho",
    "CCER2 cnv",
    "CCER2 methyl",
    "CCER2 rna"
  ],
  "CCHCR1": [
    "CCHCR1 cnv",
    "CCHCR1 methyl",
    "CCHCR1 rna"
  ],
  "CCIN": [
    "CCIN cnv",
    "CCIN rna"
  ],
  "CCK": [
    "CCK cnv",
    "CCK methyl",
    "CCK proteo",
    "CCK rna"
  ],
  "CCKAR": [
    "CCKAR cnv",
    "CCKAR rna"
  ],
  "CCKBR": [
    "CCKBR 343_350_1_1_T343 phospho",
    "CCKBR cnv",
    "CCKBR methyl",
    "CCKBR rna"
  ],
  "CCL1": [
    "CCL1 cnv",
    "CCL1 rna"
  ],
  "CCL11": [
    "CCL11 cnv"
  ],
  "CCL13": [
    "CCL13 cnv",
    "CCL13 rna"
  ],
  "CCL14": [
    "CCL14 cnv",
    "CCL14 rna"
  ],
  "CCL15": [
    "CCL15 cnv",
    "CCL15 rna"
  ],
  "CCL15-CCL14": [
    "CCL15-CCL14 cnv",
    "CCL15-CCL14 rna"
  ],
  "CCL16": [
    "CCL16 cnv",
    "CCL16 rna"
  ],
  "CCL17": [
    "CCL17 cnv",
    "CCL17 rna"
  ],
  "CCL18": [
    "CCL18 cnv",
    "CCL18 rna"
  ],
  "CCL19": [
    "CCL19 cnv",
    "CCL19 rna"
  ],
  "CCL2": [
    "CCL2 cnv",
    "CCL2 rna"
  ],
  "CCL20": [
    "CCL20 cnv",
    "CCL20 rna"
  ],
  "CCL21": [
    "CCL21 cnv",
    "CCL21 rna"
  ],
  "CCL22": [
    "CCL22 cnv",
    "CCL22 rna"
  ],
  "CCL23": [
    "CCL23 cnv",
    "CCL23 rna"
  ],
  "CCL24": [
    "CCL24 cnv",
    "CCL24 rna"
  ],
  "CCL25": [
    "CCL25 cnv",
    "CCL25 rna"
  ],
  "CCL26": [
    "CCL26 cnv",
    "CCL26 rna"
  ],
  "CCL27": [
    "CCL27 cnv",
    "CCL27 rna"
  ],
  "CCL28": [
    "CCL28 cnv",
    "CCL28 methyl",
    "CCL28 rna"
  ],
  "CCL3": [
    "CCL3 cnv",
    "CCL3 rna"
  ],
  "CCL3L3": [
    "CCL3L3 cnv",
    "CCL3L3 rna"
  ],
  "CCL4": [
    "CCL4 cnv",
    "CCL4 rna"
  ],
  "CCL4L2": [
    "CCL4L2 cnv",
    "CCL4L2 rna"
  ],
  "CCL5": [
    "CCL5 cnv",
    "CCL5 proteo",
    "CCL5 rna"
  ],
  "CCL7": [
    "CCL7 cnv",
    "CCL7 rna"
  ],
  "CCL8": [
    "CCL8 cnv",
    "CCL8 rna"
  ],
  "CCM2": [
    "CCM2 238_253_1_1_T239 phospho",
    "CCM2 cnv",
    "CCM2 methyl",
    "CCM2 proteo",
    "CCM2 rna"
  ],
  "CCM2L": [
    "CCM2L cnv",
    "CCM2L rna"
  ],
  "CCN1": [
    "CCN1 cnv",
    "CCN1 methyl",
    "CCN1 proteo",
    "CCN1 rna"
  ],
  "CCN2": [
    "CCN2 cnv",
    "CCN2 methyl",
    "CCN2 proteo",
    "CCN2 rna"
  ],
  "CCN3": [
    "CCN3 cnv",
    "CCN3 methyl",
    "CCN3 rna"
  ],
  "CCN4": [
    "CCN4 cnv",
    "CCN4 rna"
  ],
  "CCN5": [
    "CCN5 cnv",
    "CCN5 rna"
  ],
  "CCN6": [
    "CCN6 cnv",
    "CCN6 rna"
  ],
  "CCNA1": [
    "CCNA1 cnv",
    "CCNA1 methyl",
    "CCNA1 rna"
  ],
  "CCNA2": [
    "CCNA2 cnv",
    "CCNA2 methyl",
    "CCNA2 proteo",
    "CCNA2 rna"
  ],
  "CCNB1": [
    "CCNB1 cnv",
    "CCNB1 methyl",
    "CCNB1 rna"
  ],
  "CCNB1IP1": [
    "CCNB1IP1 cnv",
    "CCNB1IP1 rna"
  ],
  "CCNB2": [
    "CCNB2 cnv",
    "CCNB2 methyl",
    "CCNB2 rna"
  ],
  "CCNB3": [
    "CCNB3 rna"
  ],
  "CCNC": [
    "CCNC cnv",
    "CCNC methyl",
    "CCNC rna"
  ],
  "CCND1": [
    "CCND1 cnv",
    "CCND1 methyl",
    "CCND1 proteo",
    "CCND1 rna"
  ],
  "CCND2": [
    "CCND2 269_282_1_1_S271 phospho",
    "CCND2 269_282_1_1_T280 phospho",
    "CCND2 cnv",
    "CCND2 methyl",
    "CCND2 proteo",
    "CCND2 rna"
  ],
  "CCND2-AS1": [
    "CCND2-AS1 methyl"
  ],
  "CCND3": [
    "CCND3 178_183_1_1_S183 phospho",
    "CCND3 cnv",
    "CCND3 methyl",
    "CCND3 rna"
  ],
  "CCNDBP1": [
    "CCNDBP1 cnv",
    "CCNDBP1 methyl",
    "CCNDBP1 rna"
  ],
  "CCNE1": [
    "CCNE1 cnv",
    "CCNE1 methyl",
    "CCNE1 rna"
  ],
  "CCNE2": [
    "CCNE2 cnv",
    "CCNE2 methyl",
    "CCNE2 rna"
  ],
  "CCNF": [
    "CCNF cnv",
    "CCNF methyl",
    "CCNF rna"
  ],
  "CCNG1": [
    "CCNG1 cnv",
    "CCNG1 methyl",
    "CCNG1 rna"
  ],
  "CCNG2": [
    "CCNG2 cnv",
    "CCNG2 methyl",
    "CCNG2 rna"
  ],
  "CCNH": [
    "CCNH 254_269_1_1_T262 phospho",
    "CCNH cnv",
    "CCNH methyl",
    "CCNH proteo",
    "CCNH rna"
  ],
  "CCNI": [
    "CCNI cnv",
    "CCNI methyl",
    "CCNI rna"
  ],
  "CCNI2": [
    "CCNI2 cnv",
    "CCNI2 methyl",
    "CCNI2 rna"
  ],
  "CCNJ": [
    "CCNJ cnv",
    "CCNJ methyl",
    "CCNJ rna"
  ],
  "CCNJL": [
    "CCNJL cnv",
    "CCNJL methyl",
    "CCNJL rna"
  ],
  "CCNK": [
    "CCNK 324_329_1_1_S324 phospho",
    "CCNK 324_329_2_2_S324S329 phospho",
    "CCNK 340_340_1_1_S340 phospho",
    "CCNK cnv",
    "CCNK methyl",
    "CCNK proteo",
    "CCNK rna"
  ],
  "CCNL1": [
    "CCNL1 325_342_1_1_S342 phospho",
    "CCNL1 325_342_2_2_S335S342 phospho",
    "CCNL1 352_355_1_1_S352 phospho",
    "CCNL1 445_445_1_1_S445 phospho",
    "CCNL1 cnv",
    "CCNL1 methyl",
    "CCNL1 proteo",
    "CCNL1 rna"
  ],
  "CCNL2": [
    "CCNL2 116_116_1_1_S116 phospho",
    "CCNL2 147_147_1_1_S147 phospho",
    "CCNL2 98_108_1_1_S108 phospho",
    "CCNL2 cnv",
    "CCNL2 methyl",
    "CCNL2 proteo",
    "CCNL2 rna"
  ],
  "CCNO": [
    "CCNO cnv",
    "CCNO methyl",
    "CCNO rna"
  ],
  "CCNP": [
    "CCNP cnv",
    "CCNP methyl",
    "CCNP rna"
  ],
  "CCNQ": [
    "CCNQ methyl",
    "CCNQ rna"
  ],
  "CCNT1": [
    "CCNT1 cnv",
    "CCNT1 methyl",
    "CCNT1 proteo",
    "CCNT1 rna"
  ],
  "CCNT2": [
    "CCNT2 470_480_1_1_S480 phospho",
    "CCNT2 548_553_1_1_S549 phospho",
    "CCNT2 cnv",
    "CCNT2 methyl",
    "CCNT2 proteo",
    "CCNT2 rna"
  ],
  "CCNY": [
    "CCNY 324_331_1_1_S326 phospho",
    "CCNY 83_83_1_1_S83 phospho",
    "CCNY 98_112_1_0 phospho",
    "CCNY cnv",
    "CCNY methyl",
    "CCNY proteo",
    "CCNY rna"
  ],
  "CCNYL1": [
    "CCNYL1 105_117_1_1_S112 phospho",
    "CCNYL1 120_134_1_0 phospho",
    "CCNYL1 342_344_1_1_S344 phospho",
    "CCNYL1 cnv",
    "CCNYL1 methyl",
    "CCNYL1 proteo",
    "CCNYL1 rna"
  ],
  "CCNYL2": [
    "CCNYL2 methyl"
  ],
  "CCNYL6": [
    "CCNYL6 methyl"
  ],
  "CCP110": [
    "CCP110 366_372_1_1_S372 phospho",
    "CCP110 cnv",
    "CCP110 methyl",
    "CCP110 proteo",
    "CCP110 rna"
  ],
  "CCPG1": [
    "CCPG1 cnv",
    "CCPG1 methyl",
    "CCPG1 proteo",
    "CCPG1 rna"
  ],
  "CCR1": [
    "CCR1 340_352_1_1_S352 phospho",
    "CCR1 cnv",
    "CCR1 proteo",
    "CCR1 rna"
  ],
  "CCR10": [
    "CCR10 cnv",
    "CCR10 methyl",
    "CCR10 rna"
  ],
  "CCR2": [
    "CCR2 cnv",
    "CCR2 rna"
  ],
  "CCR3": [
    "CCR3 cnv",
    "CCR3 rna"
  ],
  "CCR4": [
    "CCR4 cnv",
    "CCR4 rna"
  ],
  "CCR5": [
    "CCR5 cnv",
    "CCR5 rna"
  ],
  "CCR6": [
    "CCR6 cnv",
    "CCR6 methyl",
    "CCR6 rna"
  ],
  "CCR7": [
    "CCR7 cnv",
    "CCR7 rna"
  ],
  "CCR8": [
    "CCR8 cnv",
    "CCR8 rna"
  ],
  "CCR9": [
    "CCR9 cnv",
    "CCR9 rna"
  ],
  "CCRL2": [
    "CCRL2 cnv",
    "CCRL2 rna"
  ],
  "CCS": [
    "CCS 267_267_1_1_S267 phospho",
    "CCS cnv",
    "CCS methyl",
    "CCS proteo",
    "CCS rna"
  ],
  "CCSAP": [
    "CCSAP 142_149_1_1_S145 phospho",
    "CCSAP 240_240_1_1_S240 phospho",
    "CCSAP 80_89_1_1_S80 phospho",
    "CCSAP cnv",
    "CCSAP methyl",
    "CCSAP proteo",
    "CCSAP rna"
  ],
  "CCSER1": [
    "CCSER1 cnv",
    "CCSER1 methyl",
    "CCSER1 rna"
  ],
  "CCSER2": [
    "CCSER2 221_239_1_0 phospho",
    "CCSER2 cnv",
    "CCSER2 methyl",
    "CCSER2 proteo",
    "CCSER2 rna"
  ],
  "CCT2": [
    "CCT2 cnv",
    "CCT2 methyl",
    "CCT2 proteo",
    "CCT2 rna"
  ],
  "CCT3": [
    "CCT3 cnv",
    "CCT3 methyl",
    "CCT3 proteo",
    "CCT3 rna"
  ],
  "CCT4": [
    "CCT4 cnv",
    "CCT4 methyl",
    "CCT4 proteo",
    "CCT4 rna"
  ],
  "CCT5": [
    "CCT5 cnv",
    "CCT5 methyl",
    "CCT5 proteo",
    "CCT5 rna"
  ],
  "CCT6A": [
    "CCT6A cnv",
    "CCT6A methyl",
    "CCT6A proteo",
    "CCT6A rna"
  ],
  "CCT6B": [
    "CCT6B cnv",
    "CCT6B methyl",
    "CCT6B proteo",
    "CCT6B rna"
  ],
  "CCT7": [
    "CCT7 cnv",
    "CCT7 methyl",
    "CCT7 proteo",
    "CCT7 rna"
  ],
  "CCT8": [
    "CCT8 cnv",
    "CCT8 methyl",
    "CCT8 proteo",
    "CCT8 rna"
  ],
  "CCT8L2": [
    "CCT8L2 cnv",
    "CCT8L2 rna"
  ],
  "CCZ1": [
    "CCZ1 266_266_1_1_S266 phospho",
    "CCZ1 266_279_1_1_S266 phospho",
    "CCZ1 cnv",
    "CCZ1 methyl",
    "CCZ1 proteo",
    "CCZ1 rna"
  ],
  "CCZ1B": [
    "CCZ1B cnv",
    "CCZ1B methyl",
    "CCZ1B rna"
  ],
  "CD101": [
    "CD101 cnv",
    "CD101 rna"
  ],
  "CD101-AS1": [
    "CD101-AS1 methyl"
  ],
  "CD109": [
    "CD109 FLVTAPGIIRPGGNVTIGVELLEHCPSQVTVK-N2H5F0S0G0 glyco",
    "CD109 HLNGTITAK-N2H5F0S0G0 glyco",
    "CD109 HLNGTITAK-N2H6F0S0G0 glyco",
    "CD109 HLNGTITAK-N2H7F0S0G0 glyco",
    "CD109 HLNGTITAK-N2H8F0S0G0 glyco",
    "CD109 INGSANFSFNDEEMK-N2H6F0S0G0 glyco",
    "CD109 INGSANFSFNDEEMK-N2H8F0S0G0 glyco",
    "CD109 NVSTNVFFK-N2H6F0S0G0 glyco",
    "CD109 NVSTNVFFK-N2H7F0S0G0 glyco",
    "CD109 NVSTNVFFK-N2H8F0S0G0 glyco",
    "CD109 NVSTNVFFK-N2H9F0S0G0 glyco",
    "CD109 TQDEILFSNSTR-N2H4F0S0G0 glyco",
    "CD109 TQDEILFSNSTR-N2H5F0S0G0 glyco",
    "CD109 cnv",
    "CD109 methyl",
    "CD109 proteo",
    "CD109 rna"
  ],
  "CD109-AS1": [
    "CD109-AS1 methyl"
  ],
  "CD14": [
    "CD14 cnv",
    "CD14 methyl",
    "CD14 proteo",
    "CD14 rna"
  ],
  "CD151": [
    "CD151 cnv",
    "CD151 methyl",
    "CD151 proteo",
    "CD151 rna"
  ],
  "CD160": [
    "CD160 cnv",
    "CD160 rna"
  ],
  "CD163": [
    "CD163 EDAAVNCTDISVQK-N4H5F0S1G0 glyco",
    "CD163 EDAAVNCTDISVQK-N5H6F0S1G0 glyco",
    "CD163 QLGCGEAINATGSAHFGEGTGPIWLDEMK-N4H5F1S1G0 glyco",
    "CD163 cnv",
    "CD163 proteo",
    "CD163 rna"
  ],
  "CD163L1": [
    "CD163L1 cnv",
    "CD163L1 rna"
  ],
  "CD164": [
    "CD164 cnv",
    "CD164 methyl",
    "CD164 rna"
  ],
  "CD164L2": [
    "CD164L2 cnv",
    "CD164L2 methyl",
    "CD164L2 rna"
  ],
  "CD177": [
    "CD177 cnv",
    "CD177 proteo",
    "CD177 rna"
  ],
  "CD180": [
    "CD180 cnv",
    "CD180 proteo",
    "CD180 rna"
  ],
  "CD19": [
    "CD19 cnv",
    "CD19 methyl",
    "CD19 rna"
  ],
  "CD1A": [
    "CD1A cnv",
    "CD1A rna"
  ],
  "CD1B": [
    "CD1B cnv",
    "CD1B rna"
  ],
  "CD1C": [
    "CD1C cnv",
    "CD1C rna"
  ],
  "CD1D": [
    "CD1D cnv",
    "CD1D methyl",
    "CD1D rna"
  ],
  "CD1E": [
    "CD1E cnv",
    "CD1E rna"
  ],
  "CD2": [
    "CD2 cnv",
    "CD2 rna"
  ],
  "CD200": [
    "CD200 cnv",
    "CD200 methyl",
    "CD200 proteo",
    "CD200 rna"
  ],
  "CD200R1": [
    "CD200R1 cnv",
    "CD200R1 rna"
  ],
  "CD200R1L": [
    "CD200R1L cnv"
  ],
  "CD207": [
    "CD207 cnv",
    "CD207 rna"
  ],
  "CD209": [
    "CD209 cnv",
    "CD209 rna"
  ],
  "CD22": [
    "CD22 cnv",
    "CD22 rna"
  ],
  "CD226": [
    "CD226 cnv",
    "CD226 rna"
  ],
  "CD24": [
    "CD24 cnv",
    "CD24 rna"
  ],
  "CD244": [
    "CD244 cnv",
    "CD244 rna"
  ],
  "CD247": [
    "CD247 cnv",
    "CD247 methyl",
    "CD247 rna"
  ],
  "CD248": [
    "CD248 736_752_1_1_S746 phospho",
    "CD248 cnv",
    "CD248 proteo",
    "CD248 rna"
  ],
  "CD27": [
    "CD27 cnv",
    "CD27 rna"
  ],
  "CD274": [
    "CD274 169_176_1_1_S169 phospho",
    "CD274 cnv",
    "CD274 methyl",
    "CD274 proteo",
    "CD274 rna"
  ],
  "CD276": [
    "CD276 523_525_1_1_S525 phospho",
    "CD276 TALFPDLLAQGNASLR-N2H4F0S0G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N2H4F1S0G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N2H5F0S0G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N3H3F0S0G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N3H3F1S0G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N3H4F0S0G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N3H4F0S1G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N3H4F1S0G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N3H5F0S0G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N3H5F0S1G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N3H5F1S0G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N3H5F1S1G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N3H5F2S0G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N3H6F0S0G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N3H6F0S1G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N3H6F1S0G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N4H3F0S0G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N4H4F0S0G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N4H4F1S0G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N4H5F0S0G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N4H5F0S1G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N4H5F1S1G0 glyco",
    "CD276 TALFPDLLAQGNASLR-N5H3F0S0G0 glyco",
    "CD276 VVLGANGTYSCLVR-N2H5F0S0G0 glyco",
    "CD276 VVLGANGTYSCLVR-N4H5F1S1G0 glyco",
    "CD276 VVLGANGTYSCLVR-N5H3F1S0G0 glyco",
    "CD276 cnv",
    "CD276 methyl",
    "CD276 proteo",
    "CD276 rna"
  ],
  "CD28": [
    "CD28 cnv",
    "CD28 rna"
  ],
  "CD2AP": [
    "CD2AP 168_206_1_0 phospho",
    "CD2AP 254_264_1_1_S256 phospho",
    "CD2AP 510_514_1_1_S510 phospho",
    "CD2AP 510_514_2_2_S510S514 phospho",
    "CD2AP cnv",
    "CD2AP methyl",
    "CD2AP proteo",
    "CD2AP rna"
  ],
  "CD2BP2": [
    "CD2BP2 46_61_1_1_S49 phospho",
    "CD2BP2 46_81_1_1_S49 phospho",
    "CD2BP2 cnv",
    "CD2BP2 methyl",
    "CD2BP2 proteo",
    "CD2BP2 rna"
  ],
  "CD300A": [
    "CD300A 154_163_1_1_S156 phospho",
    "CD300A cnv",
    "CD300A proteo",
    "CD300A rna"
  ],
  "CD300C": [
    "CD300C cnv",
    "CD300C rna"
  ],
  "CD300E": [
    "CD300E cnv",
    "CD300E rna"
  ],
  "CD300H": [
    "CD300H cnv",
    "CD300H rna"
  ],
  "CD300LB": [
    "CD300LB cnv",
    "CD300LB rna"
  ],
  "CD300LD": [
    "CD300LD cnv",
    "CD300LD rna"
  ],
  "CD300LF": [
    "CD300LF cnv",
    "CD300LF rna"
  ],
  "CD300LG": [
    "CD300LG cnv",
    "CD300LG rna"
  ],
  "CD302": [
    "CD302 cnv",
    "CD302 methyl",
    "CD302 rna"
  ],
  "CD320": [
    "CD320 cnv",
    "CD320 methyl",
    "CD320 proteo",
    "CD320 rna"
  ],
  "CD33": [
    "CD33 172_180_1_1_S180 phospho",
    "CD33 172_180_2_2_T172S180 phospho",
    "CD33 cnv",
    "CD33 rna"
  ],
  "CD34": [
    "CD34 LTQGICLEQNK-N2H5F0S0G0 glyco",
    "CD34 cnv",
    "CD34 methyl",
    "CD34 proteo",
    "CD34 rna"
  ],
  "CD36": [
    "CD36 cnv",
    "CD36 proteo",
    "CD36 rna"
  ],
  "CD37": [
    "CD37 cnv",
    "CD37 rna"
  ],
  "CD38": [
    "CD38 FAEAACDVVHVMLNGSR-N2H5F0S0G0 glyco",
    "CD38 FAEAACDVVHVMLNGSR-N2H6F0S0G0 glyco",
    "CD38 FAEAACDVVHVMLNGSR-N2H7F0S0G0 glyco",
    "CD38 FAEAACDVVHVMLNGSR-N2H8F0S0G0 glyco",
    "CD38 FAEAACDVVHVMLNGSR-N2H9F0S0G0 glyco",
    "CD38 HPCNITEEDYQPLMK-N2H5F0S0G0 glyco",
    "CD38 IFDKNSTFGSVEVHNLQPEK-N2H5F0S0G0 glyco",
    "CD38 NSTFGSVEVHNLQPEK-N2H5F0S0G0 glyco",
    "CD38 NSTFGSVEVHNLQPEK-N2H6F0S0G0 glyco",
    "CD38 NSTFGSVEVHNLQPEK-N2H7F0S0G0 glyco",
    "CD38 cnv",
    "CD38 methyl",
    "CD38 proteo",
    "CD38 rna"
  ],
  "CD3D": [
    "CD3D cnv",
    "CD3D rna"
  ],
  "CD3E": [
    "CD3E cnv",
    "CD3E rna"
  ],
  "CD3G": [
    "CD3G cnv",
    "CD3G rna"
  ],
  "CD4": [
    "CD4 cnv",
    "CD4 proteo",
    "CD4 rna"
  ],
  "CD40": [
    "CD40 cnv",
    "CD40 methyl",
    "CD40 proteo",
    "CD40 rna"
  ],
  "CD40LG": [
    "CD40LG rna"
  ],
  "CD44": [
    "CD44 163_184_1_1_S183 phospho",
    "CD44 686_686_1_1_S686 phospho",
    "CD44 686_704_1_1_S697 phospho",
    "CD44 697_706_1_0 phospho",
    "CD44 697_706_1_1_S706 phospho",
    "CD44 706_730_1_0 phospho",
    "CD44 706_730_1_1_S718 phospho",
    "CD44 717_730_1_1_S718 phospho",
    "CD44 AFNSTLPTMAQMEK-N2H8F0S0G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N4H3F1S0G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N4H4F1S0G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N4H4F1S1G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N4H4F2S0G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N4H5F0S1G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N4H5F0S2G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N4H5F1S0G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N4H5F1S1G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N4H5F1S2G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N4H5F2S0G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N4H5F2S1G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N4H5F3S1G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N5H3F1S0G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N5H4F0S1G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N5H4F1S0G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N5H4F1S1G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N5H4F2S0G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N5H5F1S0G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N5H5F1S1G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N5H5F1S2G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N5H5F2S0G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N5H5F2S1G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N5H6F1S1G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N5H6F1S2G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N5H6F1S3G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N5H6F2S2G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N5H6F3S1G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N6H5F1S0G0 glyco",
    "CD44 AFNSTLPTMAQMEK-N6H5F1S1G0 glyco",
    "CD44 cnv",
    "CD44 methyl",
    "CD44 proteo",
    "CD44 rna"
  ],
  "CD44-DT": [
    "CD44-DT methyl"
  ],
  "CD46": [
    "CD46 cnv",
    "CD46 methyl",
    "CD46 proteo",
    "CD46 rna"
  ],
  "CD47": [
    "CD47 DIYTFDGALNK-N2H3F0S0G0 glyco",
    "CD47 DIYTFDGALNK-N2H4F0S0G0 glyco",
    "CD47 DIYTFDGALNK-N2H5F0S0G0 glyco",
    "CD47 DIYTFDGALNK-N2H6F0S0G0 glyco",
    "CD47 DIYTFDGALNK-N2H7F0S0G0 glyco",
    "CD47 DIYTFDGALNK-N2H8F0S0G0 glyco",
    "CD47 DIYTFDGALNK-N3H5F0S0G0 glyco",
    "CD47 DIYTFDGALNK-N3H5F1S0G0 glyco",
    "CD47 DIYTFDGALNK-N3H6F0S0G0 glyco",
    "CD47 DIYTFDGALNK-N3H6F0S1G0 glyco",
    "CD47 DIYTFDGALNK-N3H6F1S0G0 glyco",
    "CD47 DIYTFDGALNK-N3H6F2S0G0 glyco",
    "CD47 DIYTFDGALNK-N3H7F0S0G0 glyco",
    "CD47 GRDIYTFDGALNK-N2H5F0S0G0 glyco",
    "CD47 GRDIYTFDGALNK-N2H6F0S0G0 glyco",
    "CD47 GRDIYTFDGALNK-N2H7F0S0G0 glyco",
    "CD47 SDAVSHTGNYTCEVTELTR-N2H3F1S0G0 glyco",
    "CD47 SDAVSHTGNYTCEVTELTR-N2H5F0S0G0 glyco",
    "CD47 SDAVSHTGNYTCEVTELTR-N3H3F1S0G0 glyco",
    "CD47 SDAVSHTGNYTCEVTELTR-N3H4F1S0G0 glyco",
    "CD47 SDAVSHTGNYTCEVTELTR-N3H5F2S0G0 glyco",
    "CD47 SDAVSHTGNYTCEVTELTR-N4H4F1S0G0 glyco",
    "CD47 SDAVSHTGNYTCEVTELTR-N4H5F1S1G0 glyco",
    "CD47 SDAVSHTGNYTCEVTELTR-N5H3F1S0G0 glyco",
    "CD47 cnv",
    "CD47 methyl",
    "CD47 proteo",
    "CD47 rna"
  ],
  "CD48": [
    "CD48 cnv",
    "CD48 rna"
  ],
  "CD5": [
    "CD5 cnv",
    "CD5 rna"
  ],
  "CD52": [
    "CD52 cnv",
    "CD52 rna"
  ],
  "CD53": [
    "CD53 cnv",
    "CD53 proteo",
    "CD53 rna"
  ],
  "CD55": [
    "CD55 cnv",
    "CD55 methyl",
    "CD55 proteo",
    "CD55 rna"
  ],
  "CD58": [
    "CD58 NSTSIYFK-N2H5F0S0G0 glyco",
    "CD58 cnv",
    "CD58 methyl",
    "CD58 proteo",
    "CD58 rna"
  ],
  "CD59": [
    "CD59 TAVNCSSDFDACLITK-N3H4F1S2G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N4H3F1S0G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N4H4F0S1G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N4H4F1S1G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N4H4F2S0G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N4H5F1S1G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N4H5F1S2G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N4H5F2S1G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N4H5F3S0G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N5H3F1S0G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N5H4F0S0G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N5H4F0S1G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N5H4F1S0G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N5H4F1S1G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N5H4F2S0G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N5H4F2S1G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N5H5F1S0G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N5H5F1S1G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N5H5F2S0G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N5H5F2S1G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N5H5F3S0G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N5H6F2S1G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N6H4F2S0G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N6H5F1S1G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N6H5F2S1G0 glyco",
    "CD59 TAVNCSSDFDACLITK-N6H6F2S1G0 glyco",
    "CD59 cnv",
    "CD59 methyl",
    "CD59 proteo",
    "CD59 rna"
  ],
  "CD5L": [
    "CD5L cnv",
    "CD5L proteo",
    "CD5L rna"
  ],
  "CD6": [
    "CD6 cnv",
    "CD6 methyl",
    "CD6 rna"
  ],
  "CD63": [
    "CD63 NNHTASILDR-N2H5F0S0G0 glyco",
    "CD63 NNHTASILDR-N2H8F0S0G0 glyco",
    "CD63 cnv",
    "CD63 methyl",
    "CD63 proteo",
    "CD63 rna"
  ],
  "CD63-AS1": [
    "CD63-AS1 methyl"
  ],
  "CD68": [
    "CD68 VMYTTQGGGEAWGISVLNPNKTK-N5H6F1S1G0 glyco",
    "CD68 cnv",
    "CD68 rna"
  ],
  "CD69": [
    "CD69 cnv",
    "CD69 rna"
  ],
  "CD7": [
    "CD7 cnv",
    "CD7 rna"
  ],
  "CD70": [
    "CD70 cnv",
    "CD70 rna"
  ],
  "CD72": [
    "CD72 cnv",
    "CD72 methyl",
    "CD72 rna"
  ],
  "CD74": [
    "CD74 GHHNCSESLELEDPSSGLGVTK-N2H6F0S0G0 glyco",
    "CD74 YGNMTEDHVMHLLQNADPLK-N2H6F0S0G0 glyco",
    "CD74 YGNMTEDHVMHLLQNADPLK-N2H7F0S0G0 glyco",
    "CD74 YGNMTEDHVMHLLQNADPLK-N2H8F0S0G0 glyco",
    "CD74 YGNMTEDHVMHLLQNADPLK-N2H9F0S0G0 glyco",
    "CD74 cnv",
    "CD74 proteo",
    "CD74 rna"
  ],
  "CD79A": [
    "CD79A cnv",
    "CD79A rna"
  ],
  "CD79B": [
    "CD79B cnv",
    "CD79B rna"
  ],
  "CD80": [
    "CD80 cnv",
    "CD80 rna"
  ],
  "CD81": [
    "CD81 cnv",
    "CD81 methyl",
    "CD81 proteo",
    "CD81 rna"
  ],
  "CD81-AS1": [
    "CD81-AS1 methyl"
  ],
  "CD82": [
    "CD82 cnv",
    "CD82 methyl",
    "CD82 proteo",
    "CD82 rna"
  ],
  "CD83": [
    "CD83 cnv",
    "CD83 methyl",
    "CD83 rna"
  ],
  "CD84": [
    "CD84 cnv",
    "CD84 proteo",
    "CD84 rna"
  ],
  "CD86": [
    "CD86 cnv",
    "CD86 rna"
  ],
  "CD8A": [
    "CD8A cnv",
    "CD8A methyl",
    "CD8A rna"
  ],
  "CD8B": [
    "CD8B cnv",
    "CD8B methyl",
    "CD8B rna"
  ],
  "CD8B2": [
    "CD8B2 cnv",
    "CD8B2 methyl",
    "CD8B2 rna"
  ],
  "CD9": [
    "CD9 cnv",
    "CD9 methyl",
    "CD9 proteo",
    "CD9 rna"
  ],
  "CD93": [
    "CD93 cnv",
    "CD93 proteo",
    "CD93 rna"
  ],
  "CD96": [
    "CD96 cnv",
    "CD96 rna"
  ],
  "CD99": [
    "CD99 167_167_1_1_S167 phospho",
    "CD99 168_168_1_1_S168 phospho",
    "CD99 181_181_1_1_T181 phospho",
    "CD99 proteo",
    "CD99 rna"
  ],
  "CD99L2": [
    "CD99L2 253_260_1_1_T255 phospho",
    "CD99L2 methyl",
    "CD99L2 proteo",
    "CD99L2 rna"
  ],
  "CDA": [
    "CDA cnv",
    "CDA proteo",
    "CDA rna"
  ],
  "CDADC1": [
    "CDADC1 cnv",
    "CDADC1 methyl",
    "CDADC1 proteo",
    "CDADC1 rna"
  ],
  "CDAN1": [
    "CDAN1 265_281_1_1_S277 phospho",
    "CDAN1 cnv",
    "CDAN1 methyl",
    "CDAN1 proteo",
    "CDAN1 rna"
  ],
  "CDC123": [
    "CDC123 cnv",
    "CDC123 methyl",
    "CDC123 proteo",
    "CDC123 rna"
  ],
  "CDC14A": [
    "CDC14A cnv",
    "CDC14A methyl",
    "CDC14A rna"
  ],
  "CDC14B": [
    "CDC14B cnv",
    "CDC14B methyl",
    "CDC14B rna"
  ],
  "CDC14C": [
    "CDC14C cnv",
    "CDC14C methyl",
    "CDC14C rna"
  ],
  "CDC16": [
    "CDC16 cnv",
    "CDC16 methyl",
    "CDC16 proteo",
    "CDC16 rna"
  ],
  "CDC20": [
    "CDC20 cnv",
    "CDC20 methyl",
    "CDC20 proteo",
    "CDC20 rna"
  ],
  "CDC20B": [
    "CDC20B cnv",
    "CDC20B methyl",
    "CDC20B rna"
  ],
  "CDC23": [
    "CDC23 cnv",
    "CDC23 proteo",
    "CDC23 rna"
  ],
  "CDC25A": [
    "CDC25A cnv",
    "CDC25A methyl",
    "CDC25A rna"
  ],
  "CDC25B": [
    "CDC25B cnv",
    "CDC25B methyl",
    "CDC25B rna"
  ],
  "CDC25C": [
    "CDC25C cnv",
    "CDC25C methyl",
    "CDC25C rna"
  ],
  "CDC26": [
    "CDC26 42_52_1_1_S42 phospho",
    "CDC26 cnv",
    "CDC26 methyl",
    "CDC26 proteo",
    "CDC26 rna"
  ],
  "CDC27": [
    "CDC27 cnv",
    "CDC27 methyl",
    "CDC27 proteo",
    "CDC27 rna"
  ],
  "CDC34": [
    "CDC34 cnv",
    "CDC34 methyl",
    "CDC34 proteo",
    "CDC34 rna"
  ],
  "CDC37": [
    "CDC37 cnv",
    "CDC37 methyl",
    "CDC37 proteo",
    "CDC37 rna"
  ],
  "CDC37L1": [
    "CDC37L1 80_88_1_1_S88 phospho",
    "CDC37L1 cnv",
    "CDC37L1 methyl",
    "CDC37L1 proteo",
    "CDC37L1 rna"
  ],
  "CDC37L1-DT": [
    "CDC37L1-DT methyl"
  ],
  "CDC40": [
    "CDC40 cnv",
    "CDC40 methyl",
    "CDC40 proteo",
    "CDC40 rna"
  ],
  "CDC42": [
    "CDC42 cnv",
    "CDC42 methyl",
    "CDC42 proteo",
    "CDC42 rna"
  ],
  "CDC42BPA": [
    "CDC42BPA 1531_1532_1_1_S1532 phospho",
    "CDC42BPA 1614_1622_1_1_S1616 phospho",
    "CDC42BPA 1638_1643_1_1_S1638 phospho",
    "CDC42BPA 1706_1712_1_1_S1706 phospho",
    "CDC42BPA 672_687_1_0 phospho",
    "CDC42BPA cnv",
    "CDC42BPA kinase",
    "CDC42BPA methyl",
    "CDC42BPA proteo",
    "CDC42BPA rna"
  ],
  "CDC42BPB": [
    "CDC42BPB 1029_1029_1_1_S1029 phospho",
    "CDC42BPB 1677_1693_1_1_S1690 phospho",
    "CDC42BPB 464_475_1_1_S474 phospho",
    "CDC42BPB cnv",
    "CDC42BPB kinase",
    "CDC42BPB methyl",
    "CDC42BPB proteo",
    "CDC42BPB rna"
  ],
  "CDC42BPG": [
    "CDC42BPG cnv",
    "CDC42BPG kinase",
    "CDC42BPG methyl",
    "CDC42BPG rna"
  ],
  "CDC42EP1": [
    "CDC42EP1 101_113_1_1_S101 phospho",
    "CDC42EP1 121_132_1_1_S121 phospho",
    "CDC42EP1 139_164_1_1_S143 phospho",
    "CDC42EP1 190_195_1_1_S190 phospho",
    "CDC42EP1 19_27_1_1_S27 phospho",
    "CDC42EP1 302_303_1_1_S303 phospho",
    "CDC42EP1 34_39_1_1_T34 phospho",
    "CDC42EP1 350_353_1_1_S350 phospho",
    "CDC42EP1 350_365_2_2_S350S353 phospho",
    "CDC42EP1 61_77_1_1_S77 phospho",
    "CDC42EP1 cnv",
    "CDC42EP1 methyl",
    "CDC42EP1 proteo",
    "CDC42EP1 rna"
  ],
  "CDC42EP2": [
    "CDC42EP2 109_123_1_1_S109 phospho",
    "CDC42EP2 cnv",
    "CDC42EP2 methyl",
    "CDC42EP2 proteo",
    "CDC42EP2 rna"
  ],
  "CDC42EP3": [
    "CDC42EP3 108_130_1_1_S108 phospho",
    "CDC42EP3 cnv",
    "CDC42EP3 methyl",
    "CDC42EP3 rna"
  ],
  "CDC42EP4": [
    "CDC42EP4 105_109_1_1_S109 phospho",
    "CDC42EP4 118_118_1_1_S118 phospho",
    "CDC42EP4 18_28_1_1_S18 phospho",
    "CDC42EP4 275_295_1_1_S295 phospho",
    "CDC42EP4 275_295_2_2_S292S295 phospho",
    "CDC42EP4 307_315_1_1_S309 phospho",
    "CDC42EP4 307_322_1_1_S322 phospho",
    "CDC42EP4 322_322_1_1_S322 phospho",
    "CDC42EP4 50_55_1_1_S51 phospho",
    "CDC42EP4 64_74_1_0 phospho",
    "CDC42EP4 64_74_2_0 phospho",
    "CDC42EP4 9_14_1_1_S11 phospho",
    "CDC42EP4 9_14_2_2_S11S14 phospho",
    "CDC42EP4 cnv",
    "CDC42EP4 methyl",
    "CDC42EP4 proteo",
    "CDC42EP4 rna"
  ],
  "CDC42EP5": [
    "CDC42EP5 cnv",
    "CDC42EP5 methyl",
    "CDC42EP5 proteo",
    "CDC42EP5 rna"
  ],
  "CDC42SE1": [
    "CDC42SE1 cnv",
    "CDC42SE1 methyl",
    "CDC42SE1 rna"
  ],
  "CDC42SE2": [
    "CDC42SE2 cnv",
    "CDC42SE2 methyl",
    "CDC42SE2 proteo",
    "CDC42SE2 rna"
  ],
  "CDC45": [
    "CDC45 cnv",
    "CDC45 methyl",
    "CDC45 rna"
  ],
  "CDC5L": [
    "CDC5L 385_396_1_1_T396 phospho",
    "CDC5L 427_438_1_1_T430 phospho",
    "CDC5L cnv",
    "CDC5L methyl",
    "CDC5L proteo",
    "CDC5L rna"
  ],
  "CDC6": [
    "CDC6 cnv",
    "CDC6 methyl",
    "CDC6 rna"
  ],
  "CDC7": [
    "CDC7 cnv",
    "CDC7 kinase",
    "CDC7 methyl",
    "CDC7 rna"
  ],
  "CDC73": [
    "CDC73 cnv",
    "CDC73 methyl",
    "CDC73 proteo",
    "CDC73 rna"
  ],
  "CDCA2": [
    "CDCA2 cnv",
    "CDCA2 methyl",
    "CDCA2 rna"
  ],
  "CDCA3": [
    "CDCA3 cnv",
    "CDCA3 methyl",
    "CDCA3 rna"
  ],
  "CDCA4": [
    "CDCA4 cnv",
    "CDCA4 methyl",
    "CDCA4 rna"
  ],
  "CDCA5": [
    "CDCA5 cnv",
    "CDCA5 methyl",
    "CDCA5 rna"
  ],
  "CDCA7": [
    "CDCA7 cnv",
    "CDCA7 methyl",
    "CDCA7 rna"
  ],
  "CDCA7L": [
    "CDCA7L cnv",
    "CDCA7L methyl",
    "CDCA7L proteo",
    "CDCA7L rna"
  ],
  "CDCA8": [
    "CDCA8 cnv",
    "CDCA8 methyl",
    "CDCA8 rna"
  ],
  "CDCP1": [
    "CDCP1 cnv",
    "CDCP1 proteo",
    "CDCP1 rna"
  ],
  "CDCP2": [
    "CDCP2 cnv",
    "CDCP2 rna"
  ],
  "CDH1": [
    "CDH1 cnv",
    "CDH1 methyl",
    "CDH1 proteo",
    "CDH1 rna"
  ],
  "CDH10": [
    "CDH10 107_114_1_1_T107 phospho",
    "CDH10 185_194_1_1_S190 phospho",
    "CDH10 cnv",
    "CDH10 proteo",
    "CDH10 rna"
  ],
  "CDH11": [
    "CDH11 714_723_1_1_S714 phospho",
    "CDH11 786_796_1_1_S788 phospho",
    "CDH11 FIFSLPPEIIHNPNFTVR-N2H6F0S0G0 glyco",
    "CDH11 FIFSLPPEIIHNPNFTVR-N2H7F0S0G0 glyco",
    "CDH11 FIFSLPPEIIHNPNFTVR-N2H8F0S0G0 glyco",
    "CDH11 cnv",
    "CDH11 methyl",
    "CDH11 proteo",
    "CDH11 rna"
  ],
  "CDH12": [
    "CDH12 cnv",
    "CDH12 rna"
  ],
  "CDH13": [
    "CDH13 ANYNLPIMVTDSGKPPMTNITDLR-N2H5F0S0G0 glyco",
    "CDH13 INNTHALVSLLQNLNK-N2H5F0S0G0 glyco",
    "CDH13 INNTHALVSLLQNLNK-N2H7F0S0G0 glyco",
    "CDH13 INNTHALVSLLQNLNK-N3H6F1S0G0 glyco",
    "CDH13 INNTHALVSLLQNLNK-N4H5F0S0G0 glyco",
    "CDH13 NLSVVILGASDK-N2H5F0S0G0 glyco",
    "CDH13 NLSVVILGASDK-N2H5F1S0G0 glyco",
    "CDH13 cnv",
    "CDH13 methyl",
    "CDH13 proteo",
    "CDH13 rna"
  ],
  "CDH13-AS2": [
    "CDH13-AS2 methyl"
  ],
  "CDH15": [
    "CDH15 cnv",
    "CDH15 methyl",
    "CDH15 rna"
  ],
  "CDH16": [
    "CDH16 cnv",
    "CDH16 rna"
  ],
  "CDH17": [
    "CDH17 cnv",
    "CDH17 rna"
  ],
  "CDH18": [
    "CDH18 cnv",
    "CDH18 proteo",
    "CDH18 rna"
  ],
  "CDH19": [
    "CDH19 cnv",
    "CDH19 rna"
  ],
  "CDH2": [
    "CDH2 SNISILR-N2H3F0S0G0 glyco",
    "CDH2 SNISILR-N2H4F0S0G0 glyco",
    "CDH2 SNISILR-N2H5F0S0G0 glyco",
    "CDH2 cnv",
    "CDH2 methyl",
    "CDH2 proteo",
    "CDH2 rna"
  ],
  "CDH20": [
    "CDH20 cnv",
    "CDH20 methyl",
    "CDH20 proteo",
    "CDH20 rna"
  ],
  "CDH22": [
    "CDH22 cnv",
    "CDH22 methyl",
    "CDH22 rna"
  ],
  "CDH23": [
    "CDH23 cnv",
    "CDH23 methyl",
    "CDH23 rna"
  ],
  "CDH24": [
    "CDH24 cnv",
    "CDH24 methyl",
    "CDH24 rna"
  ],
  "CDH26": [
    "CDH26 cnv",
    "CDH26 rna"
  ],
  "CDH3": [
    "CDH3 cnv",
    "CDH3 methyl",
    "CDH3 rna"
  ],
  "CDH4": [
    "CDH4 cnv",
    "CDH4 methyl",
    "CDH4 proteo",
    "CDH4 rna"
  ],
  "CDH5": [
    "CDH5 cnv",
    "CDH5 proteo",
    "CDH5 rna"
  ],
  "CDH6": [
    "CDH6 781_790_1_1_S786 phospho",
    "CDH6 IFNIDSGNGSIFTSK-N2H5F0S0G0 glyco",
    "CDH6 IFNIDSGNGSIFTSK-N4H5F1S1G0 glyco",
    "CDH6 IFNIDSGNGSIFTSK-N5H3F1S0G0 glyco",
    "CDH6 cnv",
    "CDH6 methyl",
    "CDH6 proteo",
    "CDH6 rna"
  ],
  "CDH7": [
    "CDH7 cnv",
    "CDH7 rna"
  ],
  "CDH8": [
    "CDH8 790_799_1_1_S795 phospho",
    "CDH8 cnv",
    "CDH8 methyl",
    "CDH8 proteo",
    "CDH8 rna"
  ],
  "CDH9": [
    "CDH9 cnv",
    "CDH9 proteo",
    "CDH9 rna"
  ],
  "CDHR1": [
    "CDHR1 cnv",
    "CDHR1 methyl",
    "CDHR1 rna"
  ],
  "CDHR2": [
    "CDHR2 cnv",
    "CDHR2 methyl",
    "CDHR2 rna"
  ],
  "CDHR3": [
    "CDHR3 cnv",
    "CDHR3 methyl",
    "CDHR3 rna"
  ],
  "CDHR4": [
    "CDHR4 cnv",
    "CDHR4 rna"
  ],
  "CDHR5": [
    "CDHR5 cnv",
    "CDHR5 methyl",
    "CDHR5 rna"
  ],
  "CDIN1": [
    "CDIN1 cnv",
    "CDIN1 methyl",
    "CDIN1 rna"
  ],
  "CDIP1": [
    "CDIP1 cnv",
    "CDIP1 methyl",
    "CDIP1 proteo",
    "CDIP1 rna"
  ],
  "CDIPT": [
    "CDIPT cnv",
    "CDIPT methyl",
    "CDIPT proteo",
    "CDIPT rna"
  ],
  "CDIPTOSP": [
    "CDIPTOSP methyl"
  ],
  "CDK1": [
    "CDK1 160_169_1_1_T161 phospho",
    "CDK1 cnv",
    "CDK1 kinase",
    "CDK1 methyl",
    "CDK1 proteo",
    "CDK1 rna"
  ],
  "CDK10": [
    "CDK10 117_125_1_1_T125 phospho",
    "CDK10 cnv",
    "CDK10 kinase",
    "CDK10 methyl",
    "CDK10 rna"
  ],
  "CDK11A": [
    "CDK11A 579_588_1_1_T580 phospho",
    "CDK11A cnv",
    "CDK11A kinase",
    "CDK11A methyl",
    "CDK11A rna"
  ],
  "CDK11B": [
    "CDK11B 47_47_1_1_S47 phospho",
    "CDK11B 594_603_1_1_T595 phospho",
    "CDK11B cnv",
    "CDK11B kinase",
    "CDK11B methyl",
    "CDK11B proteo",
    "CDK11B rna"
  ],
  "CDK12": [
    "CDK12 1070_1083_1_1_S1083 phospho",
    "CDK12 1082_1083_1_1_S1083 phospho",
    "CDK12 357_363_1_1_S359 phospho",
    "CDK12 382_400_2_2_S383S385 phospho",
    "CDK12 420_423_1_1_S423 phospho",
    "CDK12 423_423_1_1_S423 phospho",
    "CDK12 692_698_1_1_T692 phospho",
    "CDK12 cnv",
    "CDK12 kinase",
    "CDK12 methyl",
    "CDK12 proteo",
    "CDK12 rna"
  ],
  "CDK13": [
    "CDK13 1083_1093_1_1_T1087 phospho",
    "CDK13 1083_1105_1_1_T1087 phospho",
    "CDK13 1186_1186_1_1_T1186 phospho",
    "CDK13 315_328_2_2_S317S325 phospho",
    "CDK13 315_328_3_3_S315S317S325 phospho",
    "CDK13 436_444_2_2_S437S439 phospho",
    "CDK13 525_531_1_1_S525 phospho",
    "CDK13 584_590_1_1_T588 phospho",
    "CDK13 cnv",
    "CDK13 kinase",
    "CDK13 methyl",
    "CDK13 proteo",
    "CDK13 rna"
  ],
  "CDK14": [
    "CDK14 119_126_1_1_S119 phospho",
    "CDK14 119_126_1_1_T125 phospho",
    "CDK14 119_126_2_2_S119S120 phospho",
    "CDK14 119_126_2_2_S119S123 phospho",
    "CDK14 76_79_1_0 phospho",
    "CDK14 76_79_1_1_S78 phospho",
    "CDK14 cnv",
    "CDK14 kinase",
    "CDK14 methyl",
    "CDK14 proteo",
    "CDK14 rna"
  ],
  "CDK15": [
    "CDK15 cnv",
    "CDK15 kinase",
    "CDK15 rna"
  ],
  "CDK16": [
    "CDK16 138_139_1_1_S139 phospho",
    "CDK16 152_169_1_1_S169 phospho",
    "CDK16 193_204_1_1_S193 phospho",
    "CDK16 209_212_1_1_S212 phospho",
    "CDK16 209_220_1_1_S212 phospho",
    "CDK16 227_229_1_1_S227 phospho",
    "CDK16 kinase",
    "CDK16 methyl",
    "CDK16 proteo",
    "CDK16 rna"
  ],
  "CDK17": [
    "CDK17 165_173_1_1_S165 phospho",
    "CDK17 180_182_1_1_S180 phospho",
    "CDK17 506_523_1_1_S523 phospho",
    "CDK17 75_83_1_0 phospho",
    "CDK17 cnv",
    "CDK17 kinase",
    "CDK17 methyl",
    "CDK17 proteo",
    "CDK17 rna"
  ],
  "CDK18": [
    "CDK18 117_125_1_1_S117 phospho",
    "CDK18 132_134_1_1_S132 phospho",
    "CDK18 14_16_1_1_S14 phospho",
    "CDK18 59_74_1_1_S74 phospho",
    "CDK18 89_94_1_1_S89 phospho",
    "CDK18 98_98_1_1_S98 phospho",
    "CDK18 cnv",
    "CDK18 kinase",
    "CDK18 methyl",
    "CDK18 proteo",
    "CDK18 rna"
  ],
  "CDK19": [
    "CDK19 cnv",
    "CDK19 kinase",
    "CDK19 methyl",
    "CDK19 rna"
  ],
  "CDK2": [
    "CDK2 cnv",
    "CDK2 kinase",
    "CDK2 methyl",
    "CDK2 proteo",
    "CDK2 rna"
  ],
  "CDK20": [
    "CDK20 cnv",
    "CDK20 kinase",
    "CDK20 methyl",
    "CDK20 proteo",
    "CDK20 rna"
  ],
  "CDK2AP1": [
    "CDK2AP1 cnv",
    "CDK2AP1 methyl",
    "CDK2AP1 proteo",
    "CDK2AP1 rna"
  ],
  "CDK2AP2": [
    "CDK2AP2 cnv",
    "CDK2AP2 methyl",
    "CDK2AP2 rna"
  ],
  "CDK3": [
    "CDK3 cnv",
    "CDK3 kinase",
    "CDK3 rna"
  ],
  "CDK4": [
    "CDK4 cnv",
    "CDK4 kinase",
    "CDK4 methyl",
    "CDK4 proteo",
    "CDK4 rna"
  ],
  "CDK5": [
    "CDK5 cnv",
    "CDK5 kinase",
    "CDK5 methyl",
    "CDK5 proteo",
    "CDK5 rna"
  ],
  "CDK5R1": [
    "CDK5R1 cnv",
    "CDK5R1 methyl",
    "CDK5R1 rna"
  ],
  "CDK5R2": [
    "CDK5R2 cnv",
    "CDK5R2 methyl",
    "CDK5R2 rna"
  ],
  "CDK5RAP1": [
    "CDK5RAP1 cnv",
    "CDK5RAP1 methyl",
    "CDK5RAP1 rna"
  ],
  "CDK5RAP2": [
    "CDK5RAP2 1806_1814_1_1_S1808 phospho",
    "CDK5RAP2 cnv",
    "CDK5RAP2 methyl",
    "CDK5RAP2 proteo",
    "CDK5RAP2 rna"
  ],
  "CDK5RAP3": [
    "CDK5RAP3 cnv",
    "CDK5RAP3 methyl",
    "CDK5RAP3 proteo",
    "CDK5RAP3 rna"
  ],
  "CDK6": [
    "CDK6 cnv",
    "CDK6 kinase",
    "CDK6 methyl",
    "CDK6 proteo",
    "CDK6 rna"
  ],
  "CDK6-AS1": [
    "CDK6-AS1 methyl"
  ],
  "CDK7": [
    "CDK7 128_134_1_1_T129 phospho",
    "CDK7 cnv",
    "CDK7 kinase",
    "CDK7 methyl",
    "CDK7 proteo",
    "CDK7 rna"
  ],
  "CDK8": [
    "CDK8 cnv",
    "CDK8 kinase",
    "CDK8 methyl",
    "CDK8 rna"
  ],
  "CDK9": [
    "CDK9 347_357_1_1_S347 phospho",
    "CDK9 cnv",
    "CDK9 kinase",
    "CDK9 methyl",
    "CDK9 proteo",
    "CDK9 rna"
  ],
  "CDKAL1": [
    "CDKAL1 cnv",
    "CDKAL1 proteo",
    "CDKAL1 rna"
  ],
  "CDKL1": [
    "CDKL1 cnv",
    "CDKL1 kinase",
    "CDKL1 methyl",
    "CDKL1 rna"
  ],
  "CDKL2": [
    "CDKL2 cnv",
    "CDKL2 kinase",
    "CDKL2 methyl",
    "CDKL2 rna"
  ],
  "CDKL3": [
    "CDKL3 cnv",
    "CDKL3 kinase",
    "CDKL3 methyl",
    "CDKL3 rna"
  ],
  "CDKL4": [
    "CDKL4 cnv",
    "CDKL4 kinase",
    "CDKL4 methyl",
    "CDKL4 rna"
  ],
  "CDKL5": [
    "CDKL5 306_308_1_1_S306 phospho",
    "CDKL5 365_381_1_1_S377 phospho",
    "CDKL5 398_407_1_1_S407 phospho",
    "CDKL5 kinase",
    "CDKL5 methyl",
    "CDKL5 proteo",
    "CDKL5 rna"
  ],
  "CDKN1A": [
    "CDKN1A 123_137_1_1_S130 phospho",
    "CDKN1A cnv",
    "CDKN1A methyl",
    "CDKN1A rna"
  ],
  "CDKN1B": [
    "CDKN1B 170_187_1_1_S178 phospho",
    "CDKN1B cnv",
    "CDKN1B methyl",
    "CDKN1B proteo",
    "CDKN1B rna"
  ],
  "CDKN1C": [
    "CDKN1C cnv",
    "CDKN1C methyl",
    "CDKN1C rna"
  ],
  "CDKN2A": [
    "CDKN2A cnv",
    "CDKN2A methyl",
    "CDKN2A proteo",
    "CDKN2A rna"
  ],
  "CDKN2AIP": [
    "CDKN2AIP cnv",
    "CDKN2AIP methyl",
    "CDKN2AIP proteo",
    "CDKN2AIP rna"
  ],
  "CDKN2AIPNL": [
    "CDKN2AIPNL cnv",
    "CDKN2AIPNL methyl",
    "CDKN2AIPNL proteo",
    "CDKN2AIPNL rna"
  ],
  "CDKN2B": [
    "CDKN2B cnv",
    "CDKN2B methyl",
    "CDKN2B rna"
  ],
  "CDKN2B-AS1": [
    "CDKN2B-AS1 methyl"
  ],
  "CDKN2C": [
    "CDKN2C cnv",
    "CDKN2C methyl",
    "CDKN2C proteo",
    "CDKN2C rna"
  ],
  "CDKN2D": [
    "CDKN2D cnv",
    "CDKN2D methyl",
    "CDKN2D rna"
  ],
  "CDKN3": [
    "CDKN3 cnv",
    "CDKN3 methyl",
    "CDKN3 rna"
  ],
  "CDNF": [
    "CDNF cnv",
    "CDNF methyl",
    "CDNF proteo",
    "CDNF rna"
  ],
  "CDO1": [
    "CDO1 cnv",
    "CDO1 methyl",
    "CDO1 proteo",
    "CDO1 rna"
  ],
  "CDON": [
    "CDON cnv",
    "CDON methyl",
    "CDON proteo",
    "CDON rna"
  ],
  "CDPF1": [
    "CDPF1 cnv",
    "CDPF1 methyl",
    "CDPF1 rna"
  ],
  "CDR1": [
    "CDR1 rna"
  ],
  "CDR2": [
    "CDR2 145_157_1_1_S145 phospho",
    "CDR2 309_321_1_0 phospho",
    "CDR2 309_321_1_1_S311 phospho",
    "CDR2 cnv",
    "CDR2 methyl",
    "CDR2 proteo",
    "CDR2 rna"
  ],
  "CDR2-DT": [
    "CDR2-DT methyl"
  ],
  "CDR2L": [
    "CDR2L 154_157_1_1_T154 phospho",
    "CDR2L 339_344_1_1_S344 phospho",
    "CDR2L cnv",
    "CDR2L methyl",
    "CDR2L proteo",
    "CDR2L rna"
  ],
  "CDRT15": [
    "CDRT15 cnv",
    "CDRT15 rna"
  ],
  "CDRT15L2": [
    "CDRT15L2 cnv",
    "CDRT15L2 rna"
  ],
  "CDRT15P3": [
    "CDRT15P3 methyl"
  ],
  "CDRT4": [
    "CDRT4 cnv",
    "CDRT4 rna"
  ],
  "CDS1": [
    "CDS1 33_41_1_0 phospho",
    "CDS1 cnv",
    "CDS1 methyl",
    "CDS1 rna"
  ],
  "CDS2": [
    "CDS2 21_23_1_1_S21 phospho",
    "CDS2 31_51_1_1_S33 phospho",
    "CDS2 cnv",
    "CDS2 methyl",
    "CDS2 proteo",
    "CDS2 rna"
  ],
  "CDSN": [
    "CDSN cnv",
    "CDSN rna"
  ],
  "CDT1": [
    "CDT1 cnv",
    "CDT1 methyl",
    "CDT1 rna"
  ],
  "CDV3": [
    "CDV3 106_107_1_1_S106 phospho",
    "CDV3 106_107_1_1_S107 phospho",
    "CDV3 30_75_1_1_S30 phospho",
    "CDV3 cnv",
    "CDV3 methyl",
    "CDV3 proteo",
    "CDV3 rna"
  ],
  "CDX1": [
    "CDX1 cnv",
    "CDX1 methyl",
    "CDX1 rna"
  ],
  "CDX2": [
    "CDX2 cnv",
    "CDX2 methyl",
    "CDX2 rna"
  ],
  "CDYL": [
    "CDYL cnv",
    "CDYL methyl",
    "CDYL proteo",
    "CDYL rna"
  ],
  "CDYL2": [
    "CDYL2 cnv",
    "CDYL2 methyl",
    "CDYL2 rna"
  ],
  "CEACAM1": [
    "CEACAM1 cnv",
    "CEACAM1 rna"
  ],
  "CEACAM16": [
    "CEACAM16 cnv",
    "CEACAM16 rna"
  ],
  "CEACAM18": [
    "CEACAM18 cnv"
  ],
  "CEACAM19": [
    "CEACAM19 cnv",
    "CEACAM19 rna"
  ],
  "CEACAM20": [
    "CEACAM20 cnv",
    "CEACAM20 rna"
  ],
  "CEACAM21": [
    "CEACAM21 cnv",
    "CEACAM21 rna"
  ],
  "CEACAM3": [
    "CEACAM3 cnv",
    "CEACAM3 rna"
  ],
  "CEACAM4": [
    "CEACAM4 cnv",
    "CEACAM4 rna"
  ],
  "CEACAM5": [
    "CEACAM5 cnv",
    "CEACAM5 rna"
  ],
  "CEACAM6": [
    "CEACAM6 cnv",
    "CEACAM6 rna"
  ],
  "CEACAM7": [
    "CEACAM7 cnv",
    "CEACAM7 rna"
  ],
  "CEACAM8": [
    "CEACAM8 cnv",
    "CEACAM8 proteo",
    "CEACAM8 rna"
  ],
  "CEBPA": [
    "CEBPA cnv",
    "CEBPA methyl",
    "CEBPA proteo",
    "CEBPA rna"
  ],
  "CEBPA-DT": [
    "CEBPA-DT methyl"
  ],
  "CEBPB": [
    "CEBPB 187_214_1_0 phospho",
    "CEBPB cnv",
    "CEBPB methyl",
    "CEBPB proteo",
    "CEBPB rna"
  ],
  "CEBPD": [
    "CEBPD cnv",
    "CEBPD methyl",
    "CEBPD rna"
  ],
  "CEBPE": [
    "CEBPE cnv",
    "CEBPE rna"
  ],
  "CEBPG": [
    "CEBPG cnv",
    "CEBPG methyl",
    "CEBPG rna"
  ],
  "CEBPZ": [
    "CEBPZ cnv",
    "CEBPZ methyl",
    "CEBPZ proteo",
    "CEBPZ rna"
  ],
  "CEBPZOS": [
    "CEBPZOS cnv",
    "CEBPZOS methyl",
    "CEBPZOS rna"
  ],
  "CECR2": [
    "CECR2 233_239_1_1_S239 phospho",
    "CECR2 cnv",
    "CECR2 methyl",
    "CECR2 rna"
  ],
  "CEL": [
    "CEL cnv",
    "CEL rna"
  ],
  "CELA1": [
    "CELA1 cnv",
    "CELA1 rna"
  ],
  "CELA2A": [
    "CELA2A cnv",
    "CELA2A rna"
  ],
  "CELA2B": [
    "CELA2B cnv",
    "CELA2B rna"
  ],
  "CELA3A": [
    "CELA3A cnv"
  ],
  "CELA3B": [
    "CELA3B cnv"
  ],
  "CELF1": [
    "CELF1 cnv",
    "CELF1 methyl",
    "CELF1 proteo",
    "CELF1 rna"
  ],
  "CELF2": [
    "CELF2 cnv",
    "CELF2 methyl",
    "CELF2 proteo",
    "CELF2 rna"
  ],
  "CELF3": [
    "CELF3 cnv",
    "CELF3 proteo",
    "CELF3 rna"
  ],
  "CELF4": [
    "CELF4 500_508_1_1_S500 phospho",
    "CELF4 cnv",
    "CELF4 methyl",
    "CELF4 rna"
  ],
  "CELF5": [
    "CELF5 cnv",
    "CELF5 methyl",
    "CELF5 proteo",
    "CELF5 rna"
  ],
  "CELF6": [
    "CELF6 cnv",
    "CELF6 methyl",
    "CELF6 proteo",
    "CELF6 rna"
  ],
  "CELSR1": [
    "CELSR1 2867_2877_1_1_S2867 phospho",
    "CELSR1 3001_3011_1_1_S3009 phospho",
    "CELSR1 cnv",
    "CELSR1 methyl",
    "CELSR1 proteo",
    "CELSR1 rna"
  ],
  "CELSR2": [
    "CELSR2 2638_2650_1_0 phospho",
    "CELSR2 2638_2650_1_1_S2648 phospho",
    "CELSR2 2656_2670_1_1_S2665 phospho",
    "CELSR2 2823_2831_1_1_S2823 phospho",
    "CELSR2 NATQHTAGYFGSDVK-N2H5F0S0G0 glyco",
    "CELSR2 cnv",
    "CELSR2 methyl",
    "CELSR2 proteo",
    "CELSR2 rna"
  ],
  "CELSR3": [
    "CELSR3 cnv",
    "CELSR3 methyl",
    "CELSR3 rna"
  ],
  "CEMIP": [
    "CEMIP cnv",
    "CEMIP methyl",
    "CEMIP rna"
  ],
  "CEMIP2": [
    "CEMIP2 NNISLVK-N2H9F0S0G0 glyco",
    "CEMIP2 cnv",
    "CEMIP2 methyl",
    "CEMIP2 proteo",
    "CEMIP2 rna"
  ],
  "CEMP1": [
    "CEMP1 cnv",
    "CEMP1 methyl",
    "CEMP1 rna"
  ],
  "CENATAC": [
    "CENATAC cnv",
    "CENATAC methyl",
    "CENATAC rna"
  ],
  "CEND1": [
    "CEND1 108_108_1_1_S108 phospho",
    "CEND1 76_91_1_0 phospho",
    "CEND1 76_91_1_1_S87 phospho",
    "CEND1 76_91_2_0 phospho",
    "CEND1 76_91_2_2_S86S87 phospho",
    "CEND1 7_15_1_1_S10 phospho",
    "CEND1 7_22_1_1_S10 phospho",
    "CEND1 83_91_1_1_S87 phospho",
    "CEND1 83_91_2_2_S86S87 phospho",
    "CEND1 cnv",
    "CEND1 methyl",
    "CEND1 proteo",
    "CEND1 rna"
  ],
  "CENPA": [
    "CENPA cnv",
    "CENPA methyl",
    "CENPA rna"
  ],
  "CENPB": [
    "CENPB 150_170_1_1_S156 phospho",
    "CENPB cnv",
    "CENPB methyl",
    "CENPB proteo",
    "CENPB rna"
  ],
  "CENPBD1P": [
    "CENPBD1P methyl"
  ],
  "CENPBD2P": [
    "CENPBD2P methyl"
  ],
  "CENPC": [
    "CENPC cnv",
    "CENPC methyl",
    "CENPC proteo",
    "CENPC rna"
  ],
  "CENPE": [
    "CENPE cnv",
    "CENPE methyl",
    "CENPE rna"
  ],
  "CENPF": [
    "CENPF 3054_3067_1_1_S3054 phospho",
    "CENPF 3069_3083_1_1_S3079 phospho",
    "CENPF cnv",
    "CENPF methyl",
    "CENPF proteo",
    "CENPF rna"
  ],
  "CENPH": [
    "CENPH cnv",
    "CENPH methyl",
    "CENPH rna"
  ],
  "CENPI": [
    "CENPI methyl",
    "CENPI rna"
  ],
  "CENPJ": [
    "CENPJ cnv",
    "CENPJ methyl",
    "CENPJ rna"
  ],
  "CENPK": [
    "CENPK cnv",
    "CENPK methyl",
    "CENPK proteo",
    "CENPK rna"
  ],
  "CENPL": [
    "CENPL cnv",
    "CENPL methyl",
    "CENPL rna"
  ],
  "CENPM": [
    "CENPM cnv",
    "CENPM methyl",
    "CENPM rna"
  ],
  "CENPN": [
    "CENPN cnv",
    "CENPN methyl",
    "CENPN rna"
  ],
  "CENPO": [
    "CENPO cnv",
    "CENPO methyl",
    "CENPO rna"
  ],
  "CENPP": [
    "CENPP cnv",
    "CENPP methyl",
    "CENPP rna"
  ],
  "CENPQ": [
    "CENPQ cnv",
    "CENPQ methyl",
    "CENPQ rna"
  ],
  "CENPS": [
    "CENPS cnv",
    "CENPS methyl",
    "CENPS rna"
  ],
  "CENPS-CORT": [
    "CENPS-CORT cnv",
    "CENPS-CORT methyl",
    "CENPS-CORT rna"
  ],
  "CENPT": [
    "CENPT cnv",
    "CENPT methyl",
    "CENPT rna"
  ],
  "CENPU": [
    "CENPU 94_98_1_1_T98 phospho",
    "CENPU cnv",
    "CENPU methyl",
    "CENPU rna"
  ],
  "CENPV": [
    "CENPV cnv",
    "CENPV methyl",
    "CENPV proteo",
    "CENPV rna"
  ],
  "CENPVL1": [
    "CENPVL1 rna"
  ],
  "CENPVL2": [
    "CENPVL2 rna"
  ],
  "CENPVL3": [
    "CENPVL3 rna"
  ],
  "CENPW": [
    "CENPW cnv",
    "CENPW methyl",
    "CENPW rna"
  ],
  "CENPX": [
    "CENPX cnv",
    "CENPX methyl",
    "CENPX proteo",
    "CENPX rna"
  ],
  "CEP104": [
    "CEP104 cnv",
    "CEP104 methyl",
    "CEP104 rna"
  ],
  "CEP112": [
    "CEP112 169_175_1_1_S173 phospho",
    "CEP112 169_184_2_2_S171S173 phospho",
    "CEP112 195_202_1_1_S198 phospho",
    "CEP112 240_250_1_1_S242 phospho",
    "CEP112 cnv",
    "CEP112 methyl",
    "CEP112 proteo",
    "CEP112 rna"
  ],
  "CEP120": [
    "CEP120 cnv",
    "CEP120 methyl",
    "CEP120 proteo",
    "CEP120 rna"
  ],
  "CEP126": [
    "CEP126 cnv",
    "CEP126 methyl",
    "CEP126 rna"
  ],
  "CEP128": [
    "CEP128 1008_1016_1_1_S1008 phospho",
    "CEP128 331_334_1_1_S331 phospho",
    "CEP128 cnv",
    "CEP128 methyl",
    "CEP128 proteo",
    "CEP128 rna"
  ],
  "CEP131": [
    "CEP131 381_387_1_1_S381 phospho",
    "CEP131 cnv",
    "CEP131 methyl",
    "CEP131 proteo",
    "CEP131 rna"
  ],
  "CEP135": [
    "CEP135 1121_1127_1_1_T1121 phospho",
    "CEP135 cnv",
    "CEP135 methyl",
    "CEP135 proteo",
    "CEP135 rna"
  ],
  "CEP152": [
    "CEP152 1461_1461_1_1_S1461 phospho",
    "CEP152 cnv",
    "CEP152 methyl",
    "CEP152 rna"
  ],
  "CEP162": [
    "CEP162 cnv",
    "CEP162 methyl",
    "CEP162 rna"
  ],
  "CEP164": [
    "CEP164 cnv",
    "CEP164 methyl",
    "CEP164 proteo",
    "CEP164 rna"
  ],
  "CEP170": [
    "CEP170 1019_1048_1_1_S1019 phospho",
    "CEP170 1055_1066_1_1_S1059 phospho",
    "CEP170 1076_1087_1_1_S1079 phospho",
    "CEP170 1112_1114_1_1_S1112 phospho",
    "CEP170 116_122_1_1_S122 phospho",
    "CEP170 1216_1228_1_1_S1225 phospho",
    "CEP170 1235_1247_1_1_S1241 phospho",
    "CEP170 1235_1251_1_1_S1251 phospho",
    "CEP170 1259_1260_1_1_S1260 phospho",
    "CEP170 1270_1280_1_1_S1280 phospho",
    "CEP170 1374_1376_1_1_T1376 phospho",
    "CEP170 1405_1425_1_1_S1407 phospho",
    "CEP170 1521_1535_1_0 phospho",
    "CEP170 1521_1535_1_1_S1522 phospho",
    "CEP170 1521_1535_1_1_S1529 phospho",
    "CEP170 1521_1535_2_2_S1522S1529 phospho",
    "CEP170 350_364_2_2_S356S359 phospho",
    "CEP170 356_364_1_1_S356 phospho",
    "CEP170 356_364_1_1_S359 phospho",
    "CEP170 356_364_2_2_S356S359 phospho",
    "CEP170 377_381_1_1_S379 phospho",
    "CEP170 446_458_1_1_S446 phospho",
    "CEP170 564_580_1_1_S571 phospho",
    "CEP170 644_644_1_1_T644 phospho",
    "CEP170 718_725_1_1_S725 phospho",
    "CEP170 968_973_1_1_S968 phospho",
    "CEP170 cnv",
    "CEP170 methyl",
    "CEP170 proteo",
    "CEP170 rna"
  ],
  "CEP170B": [
    "CEP170B 1065_1067_1_1_S1065 phospho",
    "CEP170B 1109_1114_1_1_S1109 phospho",
    "CEP170B 1185_1197_1_1_S1191 phospho",
    "CEP170B 1475_1481_1_1_S1475 phospho",
    "CEP170B 1475_1481_2_2_S1475S1478 phospho",
    "CEP170B 267_276_2_2_S267S270 phospho",
    "CEP170B 288_292_1_1_S290 phospho",
    "CEP170B 349_357_1_0 phospho",
    "CEP170B 349_357_1_1_S351 phospho",
    "CEP170B 566_585_1_1_S585 phospho",
    "CEP170B 702_710_1_1_S702 phospho",
    "CEP170B 783_783_1_1_S783 phospho",
    "CEP170B 916_932_2_2_S916S918 phospho",
    "CEP170B 970_975_1_1_S970 phospho",
    "CEP170B cnv",
    "CEP170B methyl",
    "CEP170B proteo",
    "CEP170B rna"
  ],
  "CEP19": [
    "CEP19 cnv",
    "CEP19 methyl",
    "CEP19 rna"
  ],
  "CEP192": [
    "CEP192 cnv",
    "CEP192 methyl",
    "CEP192 proteo",
    "CEP192 rna"
  ],
  "CEP20": [
    "CEP20 cnv",
    "CEP20 methyl",
    "CEP20 rna"
  ],
  "CEP250": [
    "CEP250 2229_2240_1_1_S2229 phospho",
    "CEP250 2329_2334_1_1_S2332 phospho",
    "CEP250 cnv",
    "CEP250 methyl",
    "CEP250 proteo",
    "CEP250 rna"
  ],
  "CEP290": [
    "CEP290 cnv",
    "CEP290 methyl",
    "CEP290 proteo",
    "CEP290 rna"
  ],
  "CEP295": [
    "CEP295 cnv",
    "CEP295 methyl",
    "CEP295 rna"
  ],
  "CEP295NL": [
    "CEP295NL cnv",
    "CEP295NL rna"
  ],
  "CEP350": [
    "CEP350 1648_1653_1_1_S1648 phospho",
    "CEP350 1805_1811_1_1_S1807 phospho",
    "CEP350 473_473_1_1_S473 phospho",
    "CEP350 cnv",
    "CEP350 methyl",
    "CEP350 proteo",
    "CEP350 rna"
  ],
  "CEP41": [
    "CEP41 119_135_1_1_S121 phospho",
    "CEP41 344_357_1_1_S344 phospho",
    "CEP41 361_364_1_1_S363 phospho",
    "CEP41 96_106_1_1_S99 phospho",
    "CEP41 cnv",
    "CEP41 methyl",
    "CEP41 proteo",
    "CEP41 rna"
  ],
  "CEP43": [
    "CEP43 143_160_1_1_S156 phospho",
    "CEP43 143_160_2_2_S156S160 phospho",
    "CEP43 cnv",
    "CEP43 methyl",
    "CEP43 proteo",
    "CEP43 rna"
  ],
  "CEP44": [
    "CEP44 cnv",
    "CEP44 methyl",
    "CEP44 proteo",
    "CEP44 rna"
  ],
  "CEP55": [
    "CEP55 cnv",
    "CEP55 methyl",
    "CEP55 proteo",
    "CEP55 rna"
  ],
  "CEP57": [
    "CEP57 44_57_1_1_S44 phospho",
    "CEP57 44_57_1_1_S46 phospho",
    "CEP57 cnv",
    "CEP57 methyl",
    "CEP57 rna"
  ],
  "CEP57L1": [
    "CEP57L1 cnv",
    "CEP57L1 methyl",
    "CEP57L1 rna"
  ],
  "CEP63": [
    "CEP63 cnv",
    "CEP63 methyl",
    "CEP63 rna"
  ],
  "CEP68": [
    "CEP68 435_435_1_1_S435 phospho",
    "CEP68 cnv",
    "CEP68 methyl",
    "CEP68 proteo",
    "CEP68 rna"
  ],
  "CEP70": [
    "CEP70 cnv",
    "CEP70 methyl",
    "CEP70 rna"
  ],
  "CEP72": [
    "CEP72 cnv",
    "CEP72 methyl",
    "CEP72 rna"
  ],
  "CEP76": [
    "CEP76 cnv",
    "CEP76 methyl",
    "CEP76 proteo",
    "CEP76 rna"
  ],
  "CEP78": [
    "CEP78 cnv",
    "CEP78 methyl",
    "CEP78 rna"
  ],
  "CEP83": [
    "CEP83 cnv",
    "CEP83 methyl",
    "CEP83 rna"
  ],
  "CEP83-DT": [
    "CEP83-DT methyl"
  ],
  "CEP85": [
    "CEP85 cnv",
    "CEP85 methyl",
    "CEP85 rna"
  ],
  "CEP85L": [
    "CEP85L cnv",
    "CEP85L methyl",
    "CEP85L rna"
  ],
  "CEP89": [
    "CEP89 cnv",
    "CEP89 methyl",
    "CEP89 rna"
  ],
  "CEP95": [
    "CEP95 cnv",
    "CEP95 methyl",
    "CEP95 rna"
  ],
  "CEP97": [
    "CEP97 cnv",
    "CEP97 methyl",
    "CEP97 proteo",
    "CEP97 rna"
  ],
  "CEPT1": [
    "CEPT1 cnv",
    "CEPT1 methyl",
    "CEPT1 proteo",
    "CEPT1 rna"
  ],
  "CER1": [
    "CER1 cnv",
    "CER1 rna"
  ],
  "CERCAM": [
    "CERCAM cnv",
    "CERCAM methyl",
    "CERCAM rna"
  ],
  "CERK": [
    "CERK cnv",
    "CERK methyl",
    "CERK proteo",
    "CERK rna"
  ],
  "CERKL": [
    "CERKL cnv",
    "CERKL methyl",
    "CERKL rna"
  ],
  "CERNA3": [
    "CERNA3 methyl"
  ],
  "CEROX1": [
    "CEROX1 methyl"
  ],
  "CERS1": [
    "CERS1 cnv",
    "CERS1 methyl",
    "CERS1 proteo",
    "CERS1 rna"
  ],
  "CERS2": [
    "CERS2 341_341_1_1_S341 phospho",
    "CERS2 cnv",
    "CERS2 methyl",
    "CERS2 proteo",
    "CERS2 rna"
  ],
  "CERS3": [
    "CERS3 cnv",
    "CERS3 methyl",
    "CERS3 rna"
  ],
  "CERS4": [
    "CERS4 cnv",
    "CERS4 methyl",
    "CERS4 proteo",
    "CERS4 rna"
  ],
  "CERS5": [
    "CERS5 cnv",
    "CERS5 methyl",
    "CERS5 rna"
  ],
  "CERS6": [
    "CERS6 cnv",
    "CERS6 methyl",
    "CERS6 proteo",
    "CERS6 rna"
  ],
  "CERT1": [
    "CERT1 503_515_1_1_S505 phospho",
    "CERT1 503_515_2_1_S508 phospho",
    "CERT1 cnv",
    "CERT1 methyl",
    "CERT1 proteo",
    "CERT1 rna"
  ],
  "CES1": [
    "CES1 cnv",
    "CES1 methyl",
    "CES1 proteo",
    "CES1 rna"
  ],
  "CES2": [
    "CES2 cnv",
    "CES2 methyl",
    "CES2 proteo",
    "CES2 rna"
  ],
  "CES3": [
    "CES3 cnv",
    "CES3 rna"
  ],
  "CES4A": [
    "CES4A cnv",
    "CES4A methyl",
    "CES4A rna"
  ],
  "CES5A": [
    "CES5A cnv",
    "CES5A rna"
  ],
  "CETN1": [
    "CETN1 cnv",
    "CETN1 methyl"
  ],
  "CETN2": [
    "CETN2 20_26_1_1_S20 phospho",
    "CETN2 methyl",
    "CETN2 proteo",
    "CETN2 rna"
  ],
  "CETN3": [
    "CETN3 cnv",
    "CETN3 methyl",
    "CETN3 proteo",
    "CETN3 rna"
  ],
  "CETP": [
    "CETP cnv",
    "CETP proteo",
    "CETP rna"
  ],
  "CFAP100": [
    "CFAP100 cnv",
    "CFAP100 methyl",
    "CFAP100 rna"
  ],
  "CFAP100-DT": [
    "CFAP100-DT methyl"
  ],
  "CFAP107": [
    "CFAP107 cnv",
    "CFAP107 rna"
  ],
  "CFAP119": [
    "CFAP119 cnv",
    "CFAP119 methyl",
    "CFAP119 rna"
  ],
  "CFAP126": [
    "CFAP126 cnv",
    "CFAP126 rna"
  ],
  "CFAP141": [
    "CFAP141 cnv",
    "CFAP141 rna"
  ],
  "CFAP157": [
    "CFAP157 cnv",
    "CFAP157 rna"
  ],
  "CFAP161": [
    "CFAP161 cnv",
    "CFAP161 methyl",
    "CFAP161 rna"
  ],
  "CFAP20": [
    "CFAP20 cnv",
    "CFAP20 methyl",
    "CFAP20 proteo",
    "CFAP20 rna"
  ],
  "CFAP206": [
    "CFAP206 cnv",
    "CFAP206 methyl",
    "CFAP206 rna"
  ],
  "CFAP20DC": [
    "CFAP20DC cnv",
    "CFAP20DC methyl",
    "CFAP20DC rna"
  ],
  "CFAP210": [
    "CFAP210 cnv",
    "CFAP210 methyl",
    "CFAP210 rna"
  ],
  "CFAP221": [
    "CFAP221 cnv",
    "CFAP221 methyl",
    "CFAP221 rna"
  ],
  "CFAP251": [
    "CFAP251 cnv",
    "CFAP251 methyl",
    "CFAP251 rna"
  ],
  "CFAP276": [
    "CFAP276 cnv",
    "CFAP276 methyl",
    "CFAP276 rna"
  ],
  "CFAP298": [
    "CFAP298 cnv",
    "CFAP298 methyl",
    "CFAP298 proteo",
    "CFAP298 rna"
  ],
  "CFAP298-TCP10L": [
    "CFAP298-TCP10L cnv",
    "CFAP298-TCP10L methyl",
    "CFAP298-TCP10L rna"
  ],
  "CFAP299": [
    "CFAP299 cnv",
    "CFAP299 rna"
  ],
  "CFAP300": [
    "CFAP300 cnv",
    "CFAP300 methyl",
    "CFAP300 rna"
  ],
  "CFAP36": [
    "CFAP36 84_85_1_1_S85 phospho",
    "CFAP36 cnv",
    "CFAP36 methyl",
    "CFAP36 proteo",
    "CFAP36 rna"
  ],
  "CFAP410": [
    "CFAP410 cnv",
    "CFAP410 methyl",
    "CFAP410 proteo",
    "CFAP410 rna"
  ],
  "CFAP418": [
    "CFAP418 cnv",
    "CFAP418 methyl",
    "CFAP418 proteo",
    "CFAP418 rna"
  ],
  "CFAP43": [
    "CFAP43 cnv",
    "CFAP43 methyl",
    "CFAP43 rna"
  ],
  "CFAP44": [
    "CFAP44 cnv",
    "CFAP44 methyl",
    "CFAP44 rna"
  ],
  "CFAP45": [
    "CFAP45 cnv",
    "CFAP45 methyl",
    "CFAP45 rna"
  ],
  "CFAP46": [
    "CFAP46 cnv",
    "CFAP46 methyl",
    "CFAP46 rna"
  ],
  "CFAP47": [
    "CFAP47 rna"
  ],
  "CFAP52": [
    "CFAP52 cnv",
    "CFAP52 methyl",
    "CFAP52 rna"
  ],
  "CFAP53": [
    "CFAP53 cnv",
    "CFAP53 methyl",
    "CFAP53 rna"
  ],
  "CFAP54": [
    "CFAP54 cnv",
    "CFAP54 methyl",
    "CFAP54 rna"
  ],
  "CFAP57": [
    "CFAP57 cnv",
    "CFAP57 methyl",
    "CFAP57 rna"
  ],
  "CFAP58": [
    "CFAP58 cnv",
    "CFAP58 rna"
  ],
  "CFAP61": [
    "CFAP61 cnv",
    "CFAP61 methyl",
    "CFAP61 rna"
  ],
  "CFAP65": [
    "CFAP65 cnv",
    "CFAP65 methyl",
    "CFAP65 rna"
  ],
  "CFAP69": [
    "CFAP69 cnv",
    "CFAP69 methyl",
    "CFAP69 rna"
  ],
  "CFAP70": [
    "CFAP70 cnv",
    "CFAP70 methyl",
    "CFAP70 rna"
  ],
  "CFAP73": [
    "CFAP73 cnv",
    "CFAP73 methyl",
    "CFAP73 rna"
  ],
  "CFAP74": [
    "CFAP74 cnv",
    "CFAP74 methyl",
    "CFAP74 rna"
  ],
  "CFAP77": [
    "CFAP77 cnv",
    "CFAP77 methyl",
    "CFAP77 rna"
  ],
  "CFAP91": [
    "CFAP91 cnv",
    "CFAP91 methyl",
    "CFAP91 rna"
  ],
  "CFAP92": [
    "CFAP92 cnv",
    "CFAP92 methyl",
    "CFAP92 rna"
  ],
  "CFAP95": [
    "CFAP95 cnv",
    "CFAP95 rna"
  ],
  "CFAP97": [
    "CFAP97 cnv",
    "CFAP97 methyl",
    "CFAP97 proteo",
    "CFAP97 rna"
  ],
  "CFAP97D1": [
    "CFAP97D1 cnv",
    "CFAP97D1 rna"
  ],
  "CFAP97D2": [
    "CFAP97D2 cnv",
    "CFAP97D2 rna"
  ],
  "CFAP99": [
    "CFAP99 cnv",
    "CFAP99 methyl",
    "CFAP99 rna"
  ],
  "CFB": [
    "CFB cnv",
    "CFB proteo",
    "CFB rna"
  ],
  "CFC1": [
    "CFC1 cnv",
    "CFC1 rna"
  ],
  "CFC1B": [
    "CFC1B cnv",
    "CFC1B rna"
  ],
  "CFD": [
    "CFD cnv",
    "CFD methyl",
    "CFD proteo",
    "CFD rna"
  ],
  "CFDP1": [
    "CFDP1 244_250_1_1_S250 phospho",
    "CFDP1 cnv",
    "CFDP1 methyl",
    "CFDP1 proteo",
    "CFDP1 rna"
  ],
  "CFH": [
    "CFH IPCSQPPQIEHGTINSSR-N4H5F0S1G0 glyco",
    "CFH IPCSQPPQIEHGTINSSR-N4H5F0S2G0 glyco",
    "CFH ISEENETTCYMGK-N3H4F0S1G0 glyco",
    "CFH ISEENETTCYMGK-N4H5F0S1G0 glyco",
    "CFH ISEENETTCYMGK-N4H5F0S2G0 glyco",
    "CFH ISEENETTCYMGK-N4H5F1S1G0 glyco",
    "CFH ISEENETTCYMGK-N4H5F1S2G0 glyco",
    "CFH ISEENETTCYMGK-N4H5F2S1G0 glyco",
    "CFH MDGASNVTCINSR-N4H5F0S1G0 glyco",
    "CFH MDGASNVTCINSR-N4H5F0S2G0 glyco",
    "CFH SPDVINGSPISQK-N4H5F0S2G0 glyco",
    "CFH SPYEMFGDEEVMCLNGNWTEPPQCK-N4H5F0S2G0 glyco",
    "CFH SPYEMFGDEEVMCLNGNWTEPPQCK-N4H5F2S1G0 glyco",
    "CFH SPYEMFGDEEVMCLNGNWTEPPQCK-N4H6F1S1G0 glyco",
    "CFH cnv",
    "CFH proteo",
    "CFH rna"
  ],
  "CFHR1": [
    "CFHR1 LQNNENNISCVER-N4H5F0S2G0 glyco",
    "CFHR1 cnv",
    "CFHR1 proteo",
    "CFHR1 rna"
  ],
  "CFHR2": [
    "CFHR2 LQNNENNISCVER-N4H5F0S1G0 glyco",
    "CFHR2 cnv",
    "CFHR2 proteo",
    "CFHR2 rna"
  ],
  "CFHR3": [
    "CFHR3 cnv",
    "CFHR3 proteo",
    "CFHR3 rna"
  ],
  "CFHR4": [
    "CFHR4 cnv",
    "CFHR4 proteo",
    "CFHR4 rna"
  ],
  "CFHR5": [
    "CFHR5 cnv",
    "CFHR5 proteo",
    "CFHR5 rna"
  ],
  "CFI": [
    "CFI 90_98_1_1_S90 phospho",
    "CFI FLNNGTCTAEGK-N2H9F0S0G0 glyco",
    "CFI FLNNGTCTAEGK-N4H5F0S1G0 glyco",
    "CFI FLNNGTCTAEGK-N4H5F0S2G0 glyco",
    "CFI LISNCSK-N2H5F0S0G0 glyco",
    "CFI LISNCSK-N2H6F0S0G0 glyco",
    "CFI LISNCSK-N2H7F0S0G0 glyco",
    "CFI LISNCSK-N2H8F0S0G0 glyco",
    "CFI LISNCSK-N2H9F0S0G0 glyco",
    "CFI LISNCSK-N3H3F2S0G0 glyco",
    "CFI LISNCSK-N3H4F0S1G0 glyco",
    "CFI LISNCSK-N4H5F0S1G0 glyco",
    "CFI LISNCSK-N4H5F0S2G0 glyco",
    "CFI LSDLSINSTECLHVHCR-N4H5F0S2G0 glyco",
    "CFI cnv",
    "CFI proteo",
    "CFI rna"
  ],
  "CFL1": [
    "CFL1 156_160_1_1_S156 phospho",
    "CFL1 23_25_1_0 phospho",
    "CFL1 23_25_1_1_S24 phospho",
    "CFL1 23_25_1_1_T25 phospho",
    "CFL1 3_8_1_1_S3 phospho",
    "CFL1 cnv",
    "CFL1 methyl",
    "CFL1 proteo",
    "CFL1 rna"
  ],
  "CFL1P1": [
    "CFL1P1 methyl"
  ],
  "CFL2": [
    "CFL2 cnv",
    "CFL2 methyl",
    "CFL2 proteo",
    "CFL2 rna"
  ],
  "CFLAR": [
    "CFLAR cnv",
    "CFLAR methyl",
    "CFLAR rna"
  ],
  "CFP": [
    "CFP proteo",
    "CFP rna"
  ],
  "CFTR": [
    "CFTR cnv",
    "CFTR rna"
  ],
  "CGA": [
    "CGA cnv",
    "CGA rna"
  ],
  "CGAS": [
    "CGAS cnv",
    "CGAS methyl",
    "CGAS rna"
  ],
  "CGB1": [
    "CGB1 cnv",
    "CGB1 rna"
  ],
  "CGB2": [
    "CGB2 cnv",
    "CGB2 rna"
  ],
  "CGB3": [
    "CGB3 cnv"
  ],
  "CGB5": [
    "CGB5 cnv"
  ],
  "CGB7": [
    "CGB7 cnv",
    "CGB7 methyl",
    "CGB7 rna"
  ],
  "CGB8": [
    "CGB8 cnv"
  ],
  "CGGBP1": [
    "CGGBP1 150_164_1_1_S164 phospho",
    "CGGBP1 cnv",
    "CGGBP1 methyl",
    "CGGBP1 proteo",
    "CGGBP1 rna"
  ],
  "CGN": [
    "CGN 135_150_1_1_S137 phospho",
    "CGN cnv",
    "CGN methyl",
    "CGN proteo",
    "CGN rna"
  ],
  "CGNL1": [
    "CGNL1 283_283_1_1_S283 phospho",
    "CGNL1 296_310_1_1_S297 phospho",
    "CGNL1 511_517_1_1_S514 phospho",
    "CGNL1 cnv",
    "CGNL1 methyl",
    "CGNL1 proteo",
    "CGNL1 rna"
  ],
  "CGREF1": [
    "CGREF1 cnv",
    "CGREF1 methyl",
    "CGREF1 proteo",
    "CGREF1 rna"
  ],
  "CGRRF1": [
    "CGRRF1 cnv",
    "CGRRF1 methyl",
    "CGRRF1 proteo",
    "CGRRF1 rna"
  ],
  "CH25H": [
    "CH25H cnv",
    "CH25H methyl",
    "CH25H rna"
  ],
  "CHAC1": [
    "CHAC1 cnv",
    "CHAC1 methyl",
    "CHAC1 rna"
  ],
  "CHAC2": [
    "CHAC2 cnv",
    "CHAC2 methyl",
    "CHAC2 proteo",
    "CHAC2 rna"
  ],
  "CHAD": [
    "CHAD cnv",
    "CHAD methyl",
    "CHAD rna"
  ],
  "CHADL": [
    "CHADL cnv",
    "CHADL proteo",
    "CHADL rna"
  ],
  "CHAF1A": [
    "CHAF1A 767_772_1_1_S772 phospho",
    "CHAF1A 775_794_1_1_S775 phospho",
    "CHAF1A 947_956_1_1_S951 phospho",
    "CHAF1A cnv",
    "CHAF1A methyl",
    "CHAF1A proteo",
    "CHAF1A rna"
  ],
  "CHAF1B": [
    "CHAF1B 409_422_1_1_S410 phospho",
    "CHAF1B 424_433_1_1_S429 phospho",
    "CHAF1B 424_433_2_2_S429T433 phospho",
    "CHAF1B cnv",
    "CHAF1B methyl",
    "CHAF1B rna"
  ],
  "CHAMP1": [
    "CHAMP1 103_108_1_1_S108 phospho",
    "CHAMP1 204_217_1_1_S204 phospho",
    "CHAMP1 204_217_1_1_S214 phospho",
    "CHAMP1 204_217_2_2_S204S214 phospho",
    "CHAMP1 282_297_1_0 phospho",
    "CHAMP1 282_297_1_1_S282 phospho",
    "CHAMP1 282_297_1_1_S286 phospho",
    "CHAMP1 282_297_2_2_S282S286 phospho",
    "CHAMP1 400_405_1_1_S405 phospho",
    "CHAMP1 427_436_2_2_S427S432 phospho",
    "CHAMP1 427_436_3_3_S427S432S436 phospho",
    "CHAMP1 443_445_1_1_S445 phospho",
    "CHAMP1 443_452_1_1_S452 phospho",
    "CHAMP1 443_452_2_2_S445S452 phospho",
    "CHAMP1 458_468_1_1_S459 phospho",
    "CHAMP1 476_476_1_1_S476 phospho",
    "CHAMP1 502_507_1_1_S507 phospho",
    "CHAMP1 603_603_1_1_S603 phospho",
    "CHAMP1 626_636_1_1_S627 phospho",
    "CHAMP1 651_666_1_1_S653 phospho",
    "CHAMP1 cnv",
    "CHAMP1 methyl",
    "CHAMP1 proteo",
    "CHAMP1 rna"
  ],
  "CHAT": [
    "CHAT cnv",
    "CHAT methyl",
    "CHAT proteo",
    "CHAT rna"
  ],
  "CHCHD1": [
    "CHCHD1 cnv",
    "CHCHD1 methyl",
    "CHCHD1 proteo",
    "CHCHD1 rna"
  ],
  "CHCHD10": [
    "CHCHD10 cnv",
    "CHCHD10 methyl",
    "CHCHD10 proteo",
    "CHCHD10 rna"
  ],
  "CHCHD2": [
    "CHCHD2 cnv",
    "CHCHD2 methyl",
    "CHCHD2 proteo",
    "CHCHD2 rna"
  ],
  "CHCHD3": [
    "CHCHD3 46_58_1_1_S50 phospho",
    "CHCHD3 49_58_1_1_S50 phospho",
    "CHCHD3 cnv",
    "CHCHD3 methyl",
    "CHCHD3 proteo",
    "CHCHD3 rna"
  ],
  "CHCHD4": [
    "CHCHD4 cnv",
    "CHCHD4 methyl",
    "CHCHD4 proteo",
    "CHCHD4 rna"
  ],
  "CHCHD5": [
    "CHCHD5 cnv",
    "CHCHD5 methyl",
    "CHCHD5 proteo",
    "CHCHD5 rna"
  ],
  "CHCHD6": [
    "CHCHD6 72_81_1_0 phospho",
    "CHCHD6 cnv",
    "CHCHD6 methyl",
    "CHCHD6 proteo",
    "CHCHD6 rna"
  ],
  "CHCHD7": [
    "CHCHD7 cnv",
    "CHCHD7 methyl",
    "CHCHD7 proteo",
    "CHCHD7 rna"
  ],
  "CHD1": [
    "CHD1 cnv",
    "CHD1 methyl",
    "CHD1 proteo",
    "CHD1 rna"
  ],
  "CHD1-DT": [
    "CHD1-DT methyl"
  ],
  "CHD1L": [
    "CHD1L 780_792_1_1_S788 phospho",
    "CHD1L cnv",
    "CHD1L methyl",
    "CHD1L proteo",
    "CHD1L rna"
  ],
  "CHD2": [
    "CHD2 207_208_2_2_S207S208 phospho",
    "CHD2 cnv",
    "CHD2 methyl",
    "CHD2 proteo",
    "CHD2 rna"
  ],
  "CHD3": [
    "CHD3 1654_1664_1_1_S1660 phospho",
    "CHD3 1654_1664_2_2_S1660S1664 phospho",
    "CHD3 771_778_1_0 phospho",
    "CHD3 771_778_1_1_S772 phospho",
    "CHD3 cnv",
    "CHD3 methyl",
    "CHD3 proteo",
    "CHD3 rna"
  ],
  "CHD4": [
    "CHD4 1531_1537_1_1_S1531 phospho",
    "CHD4 1531_1537_1_1_S1535 phospho",
    "CHD4 1531_1537_2_2_S1531S1535 phospho",
    "CHD4 cnv",
    "CHD4 methyl",
    "CHD4 proteo",
    "CHD4 rna"
  ],
  "CHD5": [
    "CHD5 cnv",
    "CHD5 methyl",
    "CHD5 rna"
  ],
  "CHD6": [
    "CHD6 cnv",
    "CHD6 methyl",
    "CHD6 rna"
  ],
  "CHD7": [
    "CHD7 cnv",
    "CHD7 methyl",
    "CHD7 rna"
  ],
  "CHD8": [
    "CHD8 1993_1995_1_1_S1995 phospho",
    "CHD8 2046_2055_1_1_S2046 phospho",
    "CHD8 cnv",
    "CHD8 methyl",
    "CHD8 proteo",
    "CHD8 rna"
  ],
  "CHD9": [
    "CHD9 cnv",
    "CHD9 methyl",
    "CHD9 rna"
  ],
  "CHDH": [
    "CHDH cnv",
    "CHDH methyl",
    "CHDH proteo",
    "CHDH rna"
  ],
  "CHEK1": [
    "CHEK1 cnv",
    "CHEK1 kinase",
    "CHEK1 methyl",
    "CHEK1 rna"
  ],
  "CHEK2": [
    "CHEK2 cnv",
    "CHEK2 kinase",
    "CHEK2 methyl",
    "CHEK2 proteo",
    "CHEK2 rna"
  ],
  "CHERP": [
    "CHERP 815_837_3_3_S815S817T819 phospho",
    "CHERP cnv",
    "CHERP methyl",
    "CHERP proteo",
    "CHERP rna"
  ],
  "CHFR": [
    "CHFR cnv",
    "CHFR methyl",
    "CHFR rna"
  ],
  "CHFR-DT": [
    "CHFR-DT methyl"
  ],
  "CHGA": [
    "CHGA 300_300_1_1_S300 phospho",
    "CHGA 322_322_1_1_S322 phospho",
    "CHGA cnv",
    "CHGA methyl",
    "CHGA proteo",
    "CHGA rna"
  ],
  "CHGB": [
    "CHGB 130_130_1_1_S130 phospho",
    "CHGB 140_149_1_1_S149 phospho",
    "CHGB 217_225_1_1_S225 phospho",
    "CHGB 259_272_1_1_S263 phospho",
    "CHGB 311_320_1_1_S311 phospho",
    "CHGB 329_341_2_2_S335Y341 phospho",
    "CHGB 401_405_1_1_S405 phospho",
    "CHGB cnv",
    "CHGB methyl",
    "CHGB proteo",
    "CHGB rna"
  ],
  "CHI3L1": [
    "CHI3L1 cnv",
    "CHI3L1 proteo",
    "CHI3L1 rna"
  ],
  "CHI3L2": [
    "CHI3L2 cnv",
    "CHI3L2 proteo",
    "CHI3L2 rna"
  ],
  "CHIA": [
    "CHIA cnv",
    "CHIA rna"
  ],
  "CHIC1": [
    "CHIC1 methyl",
    "CHIC1 rna"
  ],
  "CHIC2": [
    "CHIC2 cnv",
    "CHIC2 methyl",
    "CHIC2 rna"
  ],
  "CHID1": [
    "CHID1 cnv",
    "CHID1 methyl",
    "CHID1 proteo",
    "CHID1 rna"
  ],
  "CHIT1": [
    "CHIT1 cnv",
    "CHIT1 methyl",
    "CHIT1 rna"
  ],
  "CHKA": [
    "CHKA cnv",
    "CHKA methyl",
    "CHKA proteo",
    "CHKA rna"
  ],
  "CHKB": [
    "CHKB cnv",
    "CHKB methyl",
    "CHKB proteo",
    "CHKB rna"
  ],
  "CHKB-CPT1B": [
    "CHKB-CPT1B cnv",
    "CHKB-CPT1B rna"
  ],
  "CHKB-DT": [
    "CHKB-DT methyl"
  ],
  "CHL1": [
    "CHL1 1127_1127_1_1_S1127 phospho",
    "CHL1 1132_1139_1_1_S1137 phospho",
    "CHL1 LTVNSSNSIK-N5H3F1S0G0 glyco",
    "CHL1 VQAINQLGSGPDPQSVTLYSGEDYPDTAPVIHGVDVINSTLVK-N2H5F0S0G0 glyco",
    "CHL1 cnv",
    "CHL1 methyl",
    "CHL1 proteo",
    "CHL1 rna"
  ],
  "CHL1-AS2": [
    "CHL1-AS2 methyl"
  ],
  "CHM": [
    "CHM proteo",
    "CHM rna"
  ],
  "CHML": [
    "CHML cnv",
    "CHML methyl",
    "CHML proteo",
    "CHML rna"
  ],
  "CHMP1A": [
    "CHMP1A cnv",
    "CHMP1A methyl",
    "CHMP1A proteo",
    "CHMP1A rna"
  ],
  "CHMP1B": [
    "CHMP1B cnv",
    "CHMP1B methyl",
    "CHMP1B proteo",
    "CHMP1B rna"
  ],
  "CHMP1B2P": [
    "CHMP1B2P methyl"
  ],
  "CHMP2A": [
    "CHMP2A 203_203_1_1_S203 phospho",
    "CHMP2A cnv",
    "CHMP2A methyl",
    "CHMP2A proteo",
    "CHMP2A rna"
  ],
  "CHMP2B": [
    "CHMP2B cnv",
    "CHMP2B methyl",
    "CHMP2B proteo",
    "CHMP2B rna"
  ],
  "CHMP3": [
    "CHMP3 cnv",
    "CHMP3 methyl",
    "CHMP3 proteo",
    "CHMP3 rna"
  ],
  "CHMP4A": [
    "CHMP4A cnv",
    "CHMP4A methyl",
    "CHMP4A proteo",
    "CHMP4A rna"
  ],
  "CHMP4B": [
    "CHMP4B 223_223_1_1_S223 phospho",
    "CHMP4B cnv",
    "CHMP4B proteo",
    "CHMP4B rna"
  ],
  "CHMP4C": [
    "CHMP4C cnv",
    "CHMP4C methyl",
    "CHMP4C rna"
  ],
  "CHMP5": [
    "CHMP5 cnv",
    "CHMP5 methyl",
    "CHMP5 proteo",
    "CHMP5 rna"
  ],
  "CHMP6": [
    "CHMP6 119_119_1_1_S119 phospho",
    "CHMP6 cnv",
    "CHMP6 methyl",
    "CHMP6 proteo",
    "CHMP6 rna"
  ],
  "CHMP7": [
    "CHMP7 232_252_1_1_S232 phospho",
    "CHMP7 417_417_1_1_S417 phospho",
    "CHMP7 429_441_1_1_S441 phospho",
    "CHMP7 cnv",
    "CHMP7 methyl",
    "CHMP7 proteo",
    "CHMP7 rna"
  ],
  "CHN1": [
    "CHN1 192_192_1_1_T192 phospho",
    "CHN1 cnv",
    "CHN1 methyl",
    "CHN1 proteo",
    "CHN1 rna"
  ],
  "CHN2": [
    "CHN2 cnv",
    "CHN2 proteo",
    "CHN2 rna"
  ],
  "CHODL": [
    "CHODL 231_243_1_1_S234 phospho",
    "CHODL cnv",
    "CHODL methyl",
    "CHODL rna"
  ],
  "CHORDC1": [
    "CHORDC1 110_116_1_1_S110 phospho",
    "CHORDC1 199_212_1_0 phospho",
    "CHORDC1 cnv",
    "CHORDC1 methyl",
    "CHORDC1 proteo",
    "CHORDC1 rna"
  ],
  "CHP1": [
    "CHP1 cnv",
    "CHP1 methyl",
    "CHP1 proteo",
    "CHP1 rna"
  ],
  "CHP2": [
    "CHP2 cnv",
    "CHP2 methyl",
    "CHP2 rna"
  ],
  "CHPF": [
    "CHPF cnv",
    "CHPF methyl",
    "CHPF proteo",
    "CHPF rna"
  ],
  "CHPF2": [
    "CHPF2 ATLSTLAVAVNR-N2H8F0S0G0 glyco",
    "CHPF2 cnv",
    "CHPF2 methyl",
    "CHPF2 proteo",
    "CHPF2 rna"
  ],
  "CHPT1": [
    "CHPT1 cnv",
    "CHPT1 methyl",
    "CHPT1 proteo",
    "CHPT1 rna"
  ],
  "CHRAC1": [
    "CHRAC1 cnv",
    "CHRAC1 methyl",
    "CHRAC1 proteo",
    "CHRAC1 rna"
  ],
  "CHRD": [
    "CHRD cnv",
    "CHRD methyl",
    "CHRD proteo",
    "CHRD rna"
  ],
  "CHRDL1": [
    "CHRDL1 methyl",
    "CHRDL1 rna"
  ],
  "CHRDL2": [
    "CHRDL2 cnv",
    "CHRDL2 methyl",
    "CHRDL2 proteo",
    "CHRDL2 rna"
  ],
  "CHRFAM7A": [
    "CHRFAM7A cnv",
    "CHRFAM7A rna"
  ],
  "CHRM1": [
    "CHRM1 321_325_1_1_S322 phospho",
    "CHRM1 cnv",
    "CHRM1 rna"
  ],
  "CHRM2": [
    "CHRM2 232_234_1_1_S232 phospho",
    "CHRM2 cnv",
    "CHRM2 methyl",
    "CHRM2 rna"
  ],
  "CHRM3": [
    "CHRM3 cnv",
    "CHRM3 methyl",
    "CHRM3 proteo",
    "CHRM3 rna"
  ],
  "CHRM4": [
    "CHRM4 cnv",
    "CHRM4 methyl",
    "CHRM4 rna"
  ],
  "CHRM5": [
    "CHRM5 cnv",
    "CHRM5 rna"
  ],
  "CHRNA1": [
    "CHRNA1 cnv",
    "CHRNA1 rna"
  ],
  "CHRNA10": [
    "CHRNA10 cnv",
    "CHRNA10 methyl",
    "CHRNA10 rna"
  ],
  "CHRNA2": [
    "CHRNA2 cnv",
    "CHRNA2 rna"
  ],
  "CHRNA3": [
    "CHRNA3 cnv",
    "CHRNA3 methyl",
    "CHRNA3 rna"
  ],
  "CHRNA4": [
    "CHRNA4 cnv",
    "CHRNA4 methyl",
    "CHRNA4 rna"
  ],
  "CHRNA5": [
    "CHRNA5 cnv",
    "CHRNA5 methyl",
    "CHRNA5 rna"
  ],
  "CHRNA6": [
    "CHRNA6 cnv",
    "CHRNA6 rna"
  ],
  "CHRNA7": [
    "CHRNA7 cnv",
    "CHRNA7 methyl",
    "CHRNA7 rna"
  ],
  "CHRNA9": [
    "CHRNA9 cnv",
    "CHRNA9 rna"
  ],
  "CHRNB1": [
    "CHRNB1 cnv",
    "CHRNB1 methyl",
    "CHRNB1 rna"
  ],
  "CHRNB2": [
    "CHRNB2 cnv",
    "CHRNB2 methyl",
    "CHRNB2 rna"
  ],
  "CHRNB3": [
    "CHRNB3 cnv",
    "CHRNB3 rna"
  ],
  "CHRNB4": [
    "CHRNB4 cnv",
    "CHRNB4 methyl",
    "CHRNB4 rna"
  ],
  "CHRND": [
    "CHRND cnv",
    "CHRND rna"
  ],
  "CHRNE": [
    "CHRNE cnv",
    "CHRNE methyl",
    "CHRNE rna"
  ],
  "CHRNG": [
    "CHRNG cnv",
    "CHRNG rna"
  ],
  "CHROMR": [
    "CHROMR methyl"
  ],
  "CHST1": [
    "CHST1 cnv",
    "CHST1 methyl",
    "CHST1 rna"
  ],
  "CHST10": [
    "CHST10 cnv",
    "CHST10 methyl",
    "CHST10 proteo",
    "CHST10 rna"
  ],
  "CHST11": [
    "CHST11 cnv",
    "CHST11 methyl",
    "CHST11 proteo",
    "CHST11 rna"
  ],
  "CHST12": [
    "CHST12 cnv",
    "CHST12 methyl",
    "CHST12 rna"
  ],
  "CHST13": [
    "CHST13 cnv",
    "CHST13 methyl",
    "CHST13 rna"
  ],
  "CHST14": [
    "CHST14 cnv",
    "CHST14 methyl",
    "CHST14 proteo",
    "CHST14 rna"
  ],
  "CHST15": [
    "CHST15 cnv",
    "CHST15 methyl",
    "CHST15 rna"
  ],
  "CHST2": [
    "CHST2 cnv",
    "CHST2 methyl",
    "CHST2 rna"
  ],
  "CHST3": [
    "CHST3 cnv",
    "CHST3 methyl",
    "CHST3 proteo",
    "CHST3 rna"
  ],
  "CHST4": [
    "CHST4 cnv",
    "CHST4 rna"
  ],
  "CHST5": [
    "CHST5 cnv",
    "CHST5 rna"
  ],
  "CHST6": [
    "CHST6 cnv",
    "CHST6 methyl",
    "CHST6 rna"
  ],
  "CHST7": [
    "CHST7 methyl",
    "CHST7 proteo",
    "CHST7 rna"
  ],
  "CHST8": [
    "CHST8 cnv",
    "CHST8 methyl",
    "CHST8 rna"
  ],
  "CHST9": [
    "CHST9 cnv",
    "CHST9 methyl",
    "CHST9 proteo",
    "CHST9 rna"
  ],
  "CHSY1": [
    "CHSY1 cnv",
    "CHSY1 methyl",
    "CHSY1 proteo",
    "CHSY1 rna"
  ],
  "CHSY3": [
    "CHSY3 cnv",
    "CHSY3 methyl",
    "CHSY3 rna"
  ],
  "CHTF18": [
    "CHTF18 cnv",
    "CHTF18 methyl",
    "CHTF18 rna"
  ],
  "CHTF8": [
    "CHTF8 cnv",
    "CHTF8 methyl",
    "CHTF8 rna"
  ],
  "CHTOP": [
    "CHTOP cnv",
    "CHTOP methyl",
    "CHTOP proteo",
    "CHTOP rna"
  ],
  "CHUK": [
    "CHUK 576_584_1_1_S576 phospho",
    "CHUK cnv",
    "CHUK kinase",
    "CHUK methyl",
    "CHUK proteo",
    "CHUK rna"
  ],
  "CHURC1": [
    "CHURC1 cnv",
    "CHURC1 methyl",
    "CHURC1 proteo",
    "CHURC1 rna"
  ],
  "CHURC1-FNTB": [
    "CHURC1-FNTB cnv",
    "CHURC1-FNTB methyl",
    "CHURC1-FNTB rna"
  ],
  "CIAO1": [
    "CIAO1 cnv",
    "CIAO1 methyl",
    "CIAO1 proteo",
    "CIAO1 rna"
  ],
  "CIAO2A": [
    "CIAO2A cnv",
    "CIAO2A methyl",
    "CIAO2A proteo",
    "CIAO2A rna"
  ],
  "CIAO2B": [
    "CIAO2B cnv",
    "CIAO2B methyl",
    "CIAO2B proteo",
    "CIAO2B rna"
  ],
  "CIAO3": [
    "CIAO3 cnv",
    "CIAO3 methyl",
    "CIAO3 proteo",
    "CIAO3 rna"
  ],
  "CIAPIN1": [
    "CIAPIN1 169_172_1_1_S170 phospho",
    "CIAPIN1 274_277_1_1_S274 phospho",
    "CIAPIN1 292_294_1_1_S292 phospho",
    "CIAPIN1 cnv",
    "CIAPIN1 methyl",
    "CIAPIN1 proteo",
    "CIAPIN1 rna"
  ],
  "CIART": [
    "CIART cnv",
    "CIART methyl",
    "CIART rna"
  ],
  "CIB1": [
    "CIB1 cnv",
    "CIB1 methyl",
    "CIB1 proteo",
    "CIB1 rna"
  ],
  "CIB2": [
    "CIB2 cnv",
    "CIB2 methyl",
    "CIB2 rna"
  ],
  "CIB3": [
    "CIB3 cnv",
    "CIB3 rna"
  ],
  "CIB4": [
    "CIB4 cnv",
    "CIB4 rna"
  ],
  "CIBAR1": [
    "CIBAR1 cnv",
    "CIBAR1 methyl",
    "CIBAR1 rna"
  ],
  "CIBAR1-DT": [
    "CIBAR1-DT methyl"
  ],
  "CIBAR2": [
    "CIBAR2 cnv",
    "CIBAR2 rna"
  ],
  "CIC": [
    "CIC 1080_1084_1_1_S1082 phospho",
    "CIC 1186_1194_1_1_S1186 phospho",
    "CIC 1208_1237_1_1_S1210 phospho",
    "CIC 1340_1345_1_1_S1340 phospho",
    "CIC 1340_1345_1_1_S1345 phospho",
    "CIC 1410_1413_1_0 phospho",
    "CIC 1471_1494_1_1_T1492 phospho",
    "CIC 1609_1613_1_1_S1609 phospho",
    "CIC 1811_1823_1_1_S1813 phospho",
    "CIC 2052_2072_1_0 phospho",
    "CIC 2126_2151_1_1_T2137 phospho",
    "CIC 2154_2155_1_1_S2155 phospho",
    "CIC 2200_2220_1_1_S2203 phospho",
    "CIC 227_227_1_1_S227 phospho",
    "CIC 2282_2291_2_2_S2282S2291 phospho",
    "CIC 2306_2318_1_1_S2318 phospho",
    "CIC 2306_2318_2_0 phospho",
    "CIC 2306_2318_2_2_S2306S2318 phospho",
    "CIC 2327_2335_1_0 phospho",
    "CIC 301_313_1_1_S301 phospho",
    "CIC 472_475_1_1_T472 phospho",
    "CIC 674_674_1_1_T674 phospho",
    "CIC 768_774_1_1_S768 phospho",
    "CIC 809_809_1_1_S809 phospho",
    "CIC 986_1028_1_1_S1014 phospho",
    "CIC cnv",
    "CIC methyl",
    "CIC proteo",
    "CIC rna"
  ],
  "CIDEA": [
    "CIDEA cnv",
    "CIDEA methyl",
    "CIDEA rna"
  ],
  "CIDEB": [
    "CIDEB cnv",
    "CIDEB methyl",
    "CIDEB rna"
  ],
  "CIDEC": [
    "CIDEC cnv",
    "CIDEC rna"
  ],
  "CIITA": [
    "CIITA cnv",
    "CIITA methyl",
    "CIITA rna"
  ],
  "CILK1": [
    "CILK1 cnv",
    "CILK1 kinase",
    "CILK1 methyl",
    "CILK1 rna"
  ],
  "CILP": [
    "CILP cnv",
    "CILP rna"
  ],
  "CILP2": [
    "CILP2 cnv",
    "CILP2 methyl",
    "CILP2 rna"
  ],
  "CINP": [
    "CINP cnv",
    "CINP methyl",
    "CINP proteo",
    "CINP rna"
  ],
  "CIP2A": [
    "CIP2A cnv",
    "CIP2A methyl",
    "CIP2A proteo",
    "CIP2A rna"
  ],
  "CIPC": [
    "CIPC cnv",
    "CIPC methyl",
    "CIPC rna"
  ],
  "CIR1": [
    "CIR1 191_202_1_1_S202 phospho",
    "CIR1 392_398_1_1_S394 phospho",
    "CIR1 cnv",
    "CIR1 proteo",
    "CIR1 rna"
  ],
  "CIRBP": [
    "CIRBP 14_27_1_1_S14 phospho",
    "CIRBP 155_169_1_1_S163 phospho",
    "CIRBP cnv",
    "CIRBP methyl",
    "CIRBP proteo",
    "CIRBP rna"
  ],
  "CIROP": [
    "CIROP cnv",
    "CIROP rna"
  ],
  "CISD1": [
    "CISD1 cnv",
    "CISD1 methyl",
    "CISD1 proteo",
    "CISD1 rna"
  ],
  "CISD2": [
    "CISD2 cnv",
    "CISD2 methyl",
    "CISD2 proteo",
    "CISD2 rna"
  ],
  "CISD3": [
    "CISD3 cnv",
    "CISD3 methyl",
    "CISD3 proteo",
    "CISD3 rna"
  ],
  "CISH": [
    "CISH cnv",
    "CISH methyl",
    "CISH rna"
  ],
  "CIT": [
    "CIT 1359_1380_1_1_S1364 phospho",
    "CIT 2067_2068_1_1_S2068 phospho",
    "CIT 431_440_1_1_S440 phospho",
    "CIT 480_487_1_1_S480 phospho",
    "CIT cnv",
    "CIT kinase",
    "CIT methyl",
    "CIT proteo",
    "CIT rna"
  ],
  "CITED1": [
    "CITED1 41_58_1_1_S42 phospho",
    "CITED1 methyl",
    "CITED1 proteo",
    "CITED1 rna"
  ],
  "CITED2": [
    "CITED2 cnv",
    "CITED2 methyl",
    "CITED2 rna"
  ],
  "CITED4": [
    "CITED4 cnv",
    "CITED4 methyl",
    "CITED4 rna"
  ],
  "CIZ1": [
    "CIZ1 244_255_1_1_T244 phospho",
    "CIZ1 347_350_1_1_S350 phospho",
    "CIZ1 506_531_1_1_T511 phospho",
    "CIZ1 cnv",
    "CIZ1 methyl",
    "CIZ1 proteo",
    "CIZ1 rna"
  ],
  "CKAP2": [
    "CKAP2 cnv",
    "CKAP2 methyl",
    "CKAP2 proteo",
    "CKAP2 rna"
  ],
  "CKAP2L": [
    "CKAP2L cnv",
    "CKAP2L methyl",
    "CKAP2L rna"
  ],
  "CKAP4": [
    "CKAP4 cnv",
    "CKAP4 methyl",
    "CKAP4 proteo",
    "CKAP4 rna"
  ],
  "CKAP5": [
    "CKAP5 1428_1428_1_1_S1428 phospho",
    "CKAP5 1860_1861_1_1_Y1860 phospho",
    "CKAP5 569_571_1_1_T569 phospho",
    "CKAP5 828_845_1_1_T832 phospho",
    "CKAP5 cnv",
    "CKAP5 methyl",
    "CKAP5 proteo",
    "CKAP5 rna"
  ],
  "CKB": [
    "CKB 163_164_1_1_S164 phospho",
    "CKB 178_205_1_1_S199 phospho",
    "CKB 322_337_1_1_T322 phospho",
    "CKB 35_39_1_1_T35 phospho",
    "CKB 4_6_1_1_S4 phospho",
    "CKB 4_6_1_1_S6 phospho",
    "CKB cnv",
    "CKB methyl",
    "CKB proteo",
    "CKB rna"
  ],
  "CKLF": [
    "CKLF cnv",
    "CKLF methyl",
    "CKLF rna"
  ],
  "CKLF-CMTM1": [
    "CKLF-CMTM1 cnv",
    "CKLF-CMTM1 methyl",
    "CKLF-CMTM1 rna"
  ],
  "CKM": [
    "CKM cnv",
    "CKM methyl",
    "CKM proteo",
    "CKM rna"
  ],
  "CKMT1A": [
    "CKMT1A 355_370_1_1_T355 phospho",
    "CKMT1A cnv",
    "CKMT1A proteo",
    "CKMT1A rna"
  ],
  "CKMT1B": [
    "CKMT1B cnv",
    "CKMT1B rna"
  ],
  "CKMT2": [
    "CKMT2 cnv",
    "CKMT2 proteo",
    "CKMT2 rna"
  ],
  "CKMT2-AS1": [
    "CKMT2-AS1 methyl"
  ],
  "CKS1B": [
    "CKS1B cnv",
    "CKS1B methyl",
    "CKS1B proteo",
    "CKS1B rna"
  ],
  "CKS2": [
    "CKS2 cnv",
    "CKS2 methyl",
    "CKS2 proteo",
    "CKS2 rna"
  ],
  "CLASP1": [
    "CLASP1 1126_1129_1_1_S1129 phospho",
    "CLASP1 598_609_1_0 phospho",
    "CLASP1 615_636_1_0 phospho",
    "CLASP1 615_639_1_0 phospho",
    "CLASP1 646_656_1_1_S646 phospho",
    "CLASP1 646_656_2_2_S646S649 phospho",
    "CLASP1 cnv",
    "CLASP1 methyl",
    "CLASP1 proteo",
    "CLASP1 rna"
  ],
  "CLASP2": [
    "CLASP2 1003_1013_1_0 phospho",
    "CLASP2 1003_1013_1_1_S1013 phospho",
    "CLASP2 1019_1029_1_1_S1029 phospho",
    "CLASP2 368_370_1_1_S370 phospho",
    "CLASP2 368_370_2_2_S368S370 phospho",
    "CLASP2 389_389_1_1_S389 phospho",
    "CLASP2 404_420_1_1_S407 phospho",
    "CLASP2 453_463_1_1_S463 phospho",
    "CLASP2 557_580_1_1_S557 phospho",
    "CLASP2 594_596_1_1_S596 phospho",
    "CLASP2 614_634_1_1_S621 phospho",
    "CLASP2 8_25_1_1_S8 phospho",
    "CLASP2 945_955_1_1_S955 phospho",
    "CLASP2 955_955_1_1_S955 phospho",
    "CLASP2 cnv",
    "CLASP2 methyl",
    "CLASP2 proteo",
    "CLASP2 rna"
  ],
  "CLASRP": [
    "CLASRP 285_289_1_1_S285 phospho",
    "CLASRP 294_300_1_1_S294 phospho",
    "CLASRP 667_672_1_1_S669 phospho",
    "CLASRP cnv",
    "CLASRP methyl",
    "CLASRP proteo",
    "CLASRP rna"
  ],
  "CLBA1": [
    "CLBA1 cnv",
    "CLBA1 methyl",
    "CLBA1 rna"
  ],
  "CLC": [
    "CLC cnv",
    "CLC rna"
  ],
  "CLCA1": [
    "CLCA1 cnv",
    "CLCA1 rna"
  ],
  "CLCA2": [
    "CLCA2 cnv",
    "CLCA2 rna"
  ],
  "CLCA4": [
    "CLCA4 cnv",
    "CLCA4 rna"
  ],
  "CLCA4-AS1": [
    "CLCA4-AS1 methyl"
  ],
  "CLCC1": [
    "CLCC1 519_532_1_1_S532 phospho",
    "CLCC1 cnv",
    "CLCC1 methyl",
    "CLCC1 proteo",
    "CLCC1 rna"
  ],
  "CLCF1": [
    "CLCF1 cnv",
    "CLCF1 methyl",
    "CLCF1 rna"
  ],
  "CLCN1": [
    "CLCN1 cnv",
    "CLCN1 rna"
  ],
  "CLCN2": [
    "CLCN2 cnv",
    "CLCN2 methyl",
    "CLCN2 rna"
  ],
  "CLCN3": [
    "CLCN3 711_718_1_1_S718 phospho",
    "CLCN3 cnv",
    "CLCN3 methyl",
    "CLCN3 proteo",
    "CLCN3 rna"
  ],
  "CLCN4": [
    "CLCN4 methyl",
    "CLCN4 rna"
  ],
  "CLCN5": [
    "CLCN5 methyl",
    "CLCN5 rna"
  ],
  "CLCN6": [
    "CLCN6 692_709_1_1_S703 phospho",
    "CLCN6 cnv",
    "CLCN6 methyl",
    "CLCN6 proteo",
    "CLCN6 rna"
  ],
  "CLCN7": [
    "CLCN7 60_61_1_1_S61 phospho",
    "CLCN7 cnv",
    "CLCN7 methyl",
    "CLCN7 proteo",
    "CLCN7 rna"
  ],
  "CLCNKA": [
    "CLCNKA cnv",
    "CLCNKA proteo",
    "CLCNKA rna"
  ],
  "CLCNKB": [
    "CLCNKB cnv",
    "CLCNKB rna"
  ],
  "CLDN1": [
    "CLDN1 cnv",
    "CLDN1 methyl",
    "CLDN1 rna"
  ],
  "CLDN10": [
    "CLDN10 cnv",
    "CLDN10 methyl",
    "CLDN10 proteo",
    "CLDN10 rna"
  ],
  "CLDN11": [
    "CLDN11 107_116_1_1_S114 phospho",
    "CLDN11 cnv",
    "CLDN11 methyl",
    "CLDN11 proteo",
    "CLDN11 rna"
  ],
  "CLDN12": [
    "CLDN12 228_244_1_0 phospho",
    "CLDN12 228_244_1_1_S228 phospho",
    "CLDN12 cnv",
    "CLDN12 rna"
  ],
  "CLDN14": [
    "CLDN14 cnv",
    "CLDN14 rna"
  ],
  "CLDN15": [
    "CLDN15 cnv",
    "CLDN15 rna"
  ],
  "CLDN16": [
    "CLDN16 cnv",
    "CLDN16 methyl",
    "CLDN16 rna"
  ],
  "CLDN17": [
    "CLDN17 cnv"
  ],
  "CLDN18": [
    "CLDN18 cnv",
    "CLDN18 methyl",
    "CLDN18 rna"
  ],
  "CLDN19": [
    "CLDN19 cnv",
    "CLDN19 rna"
  ],
  "CLDN2": [
    "CLDN2 rna"
  ],
  "CLDN20": [
    "CLDN20 cnv",
    "CLDN20 rna"
  ],
  "CLDN22": [
    "CLDN22 cnv",
    "CLDN22 rna"
  ],
  "CLDN23": [
    "CLDN23 cnv",
    "CLDN23 methyl",
    "CLDN23 rna"
  ],
  "CLDN24": [
    "CLDN24 cnv",
    "CLDN24 rna"
  ],
  "CLDN25": [
    "CLDN25 cnv"
  ],
  "CLDN3": [
    "CLDN3 cnv",
    "CLDN3 methyl",
    "CLDN3 rna"
  ],
  "CLDN34": [
    "CLDN34 rna"
  ],
  "CLDN4": [
    "CLDN4 cnv",
    "CLDN4 methyl",
    "CLDN4 rna"
  ],
  "CLDN5": [
    "CLDN5 292_297_1_1_T292 phospho",
    "CLDN5 cnv",
    "CLDN5 methyl",
    "CLDN5 proteo",
    "CLDN5 rna"
  ],
  "CLDN6": [
    "CLDN6 cnv",
    "CLDN6 methyl",
    "CLDN6 rna"
  ],
  "CLDN7": [
    "CLDN7 cnv",
    "CLDN7 methyl",
    "CLDN7 rna"
  ],
  "CLDN8": [
    "CLDN8 cnv"
  ],
  "CLDN9": [
    "CLDN9 cnv",
    "CLDN9 rna"
  ],
  "CLDND1": [
    "CLDND1 cnv",
    "CLDND1 methyl",
    "CLDND1 proteo",
    "CLDND1 rna"
  ],
  "CLDND2": [
    "CLDND2 cnv",
    "CLDND2 methyl",
    "CLDND2 rna"
  ],
  "CLEC10A": [
    "CLEC10A cnv",
    "CLEC10A rna"
  ],
  "CLEC11A": [
    "CLEC11A cnv",
    "CLEC11A proteo",
    "CLEC11A rna"
  ],
  "CLEC12A": [
    "CLEC12A cnv",
    "CLEC12A rna"
  ],
  "CLEC12B": [
    "CLEC12B cnv",
    "CLEC12B rna"
  ],
  "CLEC14A": [
    "CLEC14A cnv",
    "CLEC14A methyl",
    "CLEC14A proteo",
    "CLEC14A rna"
  ],
  "CLEC16A": [
    "CLEC16A 863_867_1_1_S863 phospho",
    "CLEC16A cnv",
    "CLEC16A methyl",
    "CLEC16A proteo",
    "CLEC16A rna"
  ],
  "CLEC17A": [
    "CLEC17A cnv",
    "CLEC17A rna"
  ],
  "CLEC18A": [
    "CLEC18A cnv",
    "CLEC18A rna"
  ],
  "CLEC18B": [
    "CLEC18B cnv",
    "CLEC18B rna"
  ],
  "CLEC18C": [
    "CLEC18C cnv",
    "CLEC18C rna"
  ],
  "CLEC19A": [
    "CLEC19A cnv",
    "CLEC19A rna"
  ],
  "CLEC1A": [
    "CLEC1A cnv",
    "CLEC1A methyl",
    "CLEC1A rna"
  ],
  "CLEC1B": [
    "CLEC1B cnv",
    "CLEC1B rna"
  ],
  "CLEC20A": [
    "CLEC20A cnv",
    "CLEC20A methyl",
    "CLEC20A rna"
  ],
  "CLEC2A": [
    "CLEC2A cnv",
    "CLEC2A rna"
  ],
  "CLEC2B": [
    "CLEC2B cnv",
    "CLEC2B rna"
  ],
  "CLEC2D": [
    "CLEC2D cnv",
    "CLEC2D rna"
  ],
  "CLEC2L": [
    "CLEC2L 32_32_1_1_S32 phospho",
    "CLEC2L cnv",
    "CLEC2L proteo",
    "CLEC2L rna"
  ],
  "CLEC3A": [
    "CLEC3A cnv",
    "CLEC3A rna"
  ],
  "CLEC3B": [
    "CLEC3B cnv",
    "CLEC3B proteo",
    "CLEC3B rna"
  ],
  "CLEC4A": [
    "CLEC4A cnv",
    "CLEC4A rna"
  ],
  "CLEC4C": [
    "CLEC4C cnv",
    "CLEC4C rna"
  ],
  "CLEC4D": [
    "CLEC4D cnv",
    "CLEC4D rna"
  ],
  "CLEC4E": [
    "CLEC4E cnv",
    "CLEC4E rna"
  ],
  "CLEC4F": [
    "CLEC4F cnv",
    "CLEC4F rna"
  ],
  "CLEC4G": [
    "CLEC4G cnv",
    "CLEC4G rna"
  ],
  "CLEC4M": [
    "CLEC4M cnv",
    "CLEC4M rna"
  ],
  "CLEC5A": [
    "CLEC5A cnv",
    "CLEC5A rna"
  ],
  "CLEC6A": [
    "CLEC6A cnv",
    "CLEC6A rna"
  ],
  "CLEC7A": [
    "CLEC7A cnv",
    "CLEC7A rna"
  ],
  "CLEC9A": [
    "CLEC9A cnv",
    "CLEC9A rna"
  ],
  "CLECL1": [
    "CLECL1 cnv",
    "CLECL1 rna"
  ],
  "CLGN": [
    "CLGN cnv",
    "CLGN methyl",
    "CLGN proteo",
    "CLGN rna"
  ],
  "CLHC1": [
    "CLHC1 cnv",
    "CLHC1 rna"
  ],
  "CLIC1": [
    "CLIC1 cnv",
    "CLIC1 methyl",
    "CLIC1 proteo",
    "CLIC1 rna"
  ],
  "CLIC2": [
    "CLIC2 proteo",
    "CLIC2 rna"
  ],
  "CLIC3": [
    "CLIC3 cnv",
    "CLIC3 methyl",
    "CLIC3 rna"
  ],
  "CLIC4": [
    "CLIC4 cnv",
    "CLIC4 methyl",
    "CLIC4 proteo",
    "CLIC4 rna"
  ],
  "CLIC5": [
    "CLIC5 cnv",
    "CLIC5 methyl",
    "CLIC5 rna"
  ],
  "CLIC6": [
    "CLIC6 293_318_1_1_S293 phospho",
    "CLIC6 377_403_1_1_S377 phospho",
    "CLIC6 cnv",
    "CLIC6 methyl",
    "CLIC6 proteo",
    "CLIC6 rna"
  ],
  "CLINT1": [
    "CLINT1 227_234_1_1_S227 phospho",
    "CLINT1 227_234_2_2_S227S232 phospho",
    "CLINT1 227_234_3_3_S227S232S234 phospho",
    "CLINT1 232_234_1_1_S234 phospho",
    "CLINT1 284_312_1_0 phospho",
    "CLINT1 284_312_1_1_S299 phospho",
    "CLINT1 284_312_2_2_S299T308 phospho",
    "CLINT1 299_312_1_1_S299 phospho",
    "CLINT1 299_312_1_1_T308 phospho",
    "CLINT1 cnv",
    "CLINT1 proteo",
    "CLINT1 rna"
  ],
  "CLIP1": [
    "CLIP1 139_143_1_1_S143 phospho",
    "CLIP1 146_172_1_0 phospho",
    "CLIP1 146_172_1_1_S147 phospho",
    "CLIP1 146_189_1_1_S147 phospho",
    "CLIP1 191_204_1_1_S204 phospho",
    "CLIP1 191_204_2_2_S200S204 phospho",
    "CLIP1 cnv",
    "CLIP1 methyl",
    "CLIP1 proteo",
    "CLIP1 rna"
  ],
  "CLIP2": [
    "CLIP2 150_182_1_0 phospho",
    "CLIP2 150_182_1_1_T177 phospho",
    "CLIP2 17_18_1_1_S18 phospho",
    "CLIP2 198_211_1_1_S202 phospho",
    "CLIP2 198_211_1_1_S207 phospho",
    "CLIP2 198_211_1_1_S211 phospho",
    "CLIP2 198_211_3_3_S202S204S207 phospho",
    "CLIP2 198_211_3_3_S204S207S211 phospho",
    "CLIP2 23_38_1_0 phospho",
    "CLIP2 23_38_1_1_S38 phospho",
    "CLIP2 23_42_2_2_S38S42 phospho",
    "CLIP2 292_294_1_0 phospho",
    "CLIP2 292_294_1_1_S294 phospho",
    "CLIP2 42_42_1_1_S42 phospho",
    "CLIP2 48_54_1_0 phospho",
    "CLIP2 48_54_1_1_S49 phospho",
    "CLIP2 48_54_1_1_S54 phospho",
    "CLIP2 923_923_1_1_S923 phospho",
    "CLIP2 972_979_1_1_S973 phospho",
    "CLIP2 cnv",
    "CLIP2 methyl",
    "CLIP2 proteo",
    "CLIP2 rna"
  ],
  "CLIP3": [
    "CLIP3 2_34_1_1_S32 phospho",
    "CLIP3 369_377_1_1_T377 phospho",
    "CLIP3 399_407_1_1_S402 phospho",
    "CLIP3 488_495_1_1_S491 phospho",
    "CLIP3 cnv",
    "CLIP3 methyl",
    "CLIP3 proteo",
    "CLIP3 rna"
  ],
  "CLIP4": [
    "CLIP4 607_620_1_0 phospho",
    "CLIP4 607_620_1_1_S609 phospho",
    "CLIP4 cnv",
    "CLIP4 methyl",
    "CLIP4 proteo",
    "CLIP4 rna"
  ],
  "CLK1": [
    "CLK1 182_200_1_1_S182 phospho",
    "CLK1 cnv",
    "CLK1 kinase",
    "CLK1 methyl",
    "CLK1 rna"
  ],
  "CLK2": [
    "CLK2 142_153_1_1_S142 phospho",
    "CLK2 50_51_1_0 phospho",
    "CLK2 cnv",
    "CLK2 kinase",
    "CLK2 methyl",
    "CLK2 proteo",
    "CLK2 rna"
  ],
  "CLK3": [
    "CLK3 155_166_1_1_S157 phospho",
    "CLK3 215_218_1_1_S215 phospho",
    "CLK3 cnv",
    "CLK3 kinase",
    "CLK3 methyl",
    "CLK3 proteo",
    "CLK3 rna"
  ],
  "CLK4": [
    "CLK4 136_151_2_2_S136S138 phospho",
    "CLK4 138_151_1_1_S138 phospho",
    "CLK4 cnv",
    "CLK4 kinase",
    "CLK4 methyl",
    "CLK4 rna"
  ],
  "CLMN": [
    "CLMN 522_537_1_1_S526 phospho",
    "CLMN 619_619_1_1_S619 phospho",
    "CLMN 635_649_1_1_S635 phospho",
    "CLMN cnv",
    "CLMN proteo",
    "CLMN rna"
  ],
  "CLMP": [
    "CLMP cnv",
    "CLMP methyl",
    "CLMP rna"
  ],
  "CLN3": [
    "CLN3 12_19_1_1_S12 phospho",
    "CLN3 12_19_2_2_S12S14 phospho",
    "CLN3 cnv",
    "CLN3 methyl",
    "CLN3 rna"
  ],
  "CLN5": [
    "CLN5 cnv",
    "CLN5 methyl",
    "CLN5 proteo",
    "CLN5 rna"
  ],
  "CLN6": [
    "CLN6 13_23_1_1_S23 phospho",
    "CLN6 31_33_1_1_S31 phospho",
    "CLN6 cnv",
    "CLN6 methyl",
    "CLN6 proteo",
    "CLN6 rna"
  ],
  "CLN8": [
    "CLN8 cnv",
    "CLN8 methyl",
    "CLN8 rna"
  ],
  "CLNK": [
    "CLNK cnv",
    "CLNK rna"
  ],
  "CLNS1A": [
    "CLNS1A 102_110_1_1_S102 phospho",
    "CLNS1A 90_110_1_1_S102 phospho",
    "CLNS1A cnv",
    "CLNS1A methyl",
    "CLNS1A proteo",
    "CLNS1A rna"
  ],
  "CLOCK": [
    "CLOCK 427_434_1_1_S427 phospho",
    "CLOCK cnv",
    "CLOCK methyl",
    "CLOCK rna"
  ],
  "CLP1": [
    "CLP1 cnv",
    "CLP1 methyl",
    "CLP1 proteo",
    "CLP1 rna"
  ],
  "CLPB": [
    "CLPB cnv",
    "CLPB methyl",
    "CLPB proteo",
    "CLPB rna"
  ],
  "CLPP": [
    "CLPP cnv",
    "CLPP methyl",
    "CLPP proteo",
    "CLPP rna"
  ],
  "CLPS": [
    "CLPS cnv",
    "CLPS rna"
  ],
  "CLPSL1": [
    "CLPSL1 cnv",
    "CLPSL1 methyl",
    "CLPSL1 rna"
  ],
  "CLPSL2": [
    "CLPSL2 cnv",
    "CLPSL2 methyl",
    "CLPSL2 rna"
  ],
  "CLPTM1": [
    "CLPTM1 DYYPINESLASLPLR-N2H6F0S0G0 glyco",
    "CLPTM1 DYYPINESLASLPLR-N2H7F0S0G0 glyco",
    "CLPTM1 DYYPINESLASLPLR-N2H8F0S0G0 glyco",
    "CLPTM1 cnv",
    "CLPTM1 methyl",
    "CLPTM1 proteo",
    "CLPTM1 rna"
  ],
  "CLPTM1L": [
    "CLPTM1L TVNVSVPK-N2H5F0S0G0 glyco",
    "CLPTM1L TVNVSVPK-N2H6F0S0G0 glyco",
    "CLPTM1L TVNVSVPK-N2H7F0S0G0 glyco",
    "CLPTM1L TVNVSVPK-N2H8F0S0G0 glyco",
    "CLPTM1L VKDLMVINR-N2H8F0S0G0 glyco",
    "CLPTM1L cnv",
    "CLPTM1L methyl",
    "CLPTM1L proteo",
    "CLPTM1L rna"
  ],
  "CLPX": [
    "CLPX cnv",
    "CLPX methyl",
    "CLPX proteo",
    "CLPX rna"
  ],
  "CLRN1": [
    "CLRN1 cnv",
    "CLRN1 rna"
  ],
  "CLRN2": [
    "CLRN2 cnv",
    "CLRN2 rna"
  ],
  "CLRN3": [
    "CLRN3 cnv",
    "CLRN3 rna"
  ],
  "CLSPN": [
    "CLSPN cnv",
    "CLSPN methyl",
    "CLSPN proteo",
    "CLSPN rna"
  ],
  "CLSTN1": [
    "CLSTN1 cnv",
    "CLSTN1 methyl",
    "CLSTN1 proteo",
    "CLSTN1 rna"
  ],
  "CLSTN2": [
    "CLSTN2 cnv",
    "CLSTN2 methyl",
    "CLSTN2 proteo",
    "CLSTN2 rna"
  ],
  "CLSTN3": [
    "CLSTN3 951_956_1_1_T951 phospho",
    "CLSTN3 cnv",
    "CLSTN3 proteo",
    "CLSTN3 rna"
  ],
  "CLTA": [
    "CLTA 205_209_1_1_S206 phospho",
    "CLTA 236_240_1_1_S236 phospho",
    "CLTA cnv",
    "CLTA methyl",
    "CLTA proteo",
    "CLTA rna"
  ],
  "CLTB": [
    "CLTB cnv",
    "CLTB methyl",
    "CLTB proteo",
    "CLTB rna"
  ],
  "CLTC": [
    "CLTC 1486_1498_1_1_S1498 phospho",
    "CLTC 239_242_1_1_T239 phospho",
    "CLTC 398_401_1_1_T398 phospho",
    "CLTC 67_77_1_1_S67 phospho",
    "CLTC cnv",
    "CLTC methyl",
    "CLTC proteo",
    "CLTC rna"
  ],
  "CLTCL1": [
    "CLTCL1 cnv",
    "CLTCL1 methyl",
    "CLTCL1 rna"
  ],
  "CLTRN": [
    "CLTRN methyl",
    "CLTRN rna"
  ],
  "CLU": [
    "CLU 184_185_1_1_S185 phospho",
    "CLU 387_403_1_1_S396 phospho",
    "CLU ELPGVCNETMMALWEECKPCLK-N4H5F0S2G0 glyco",
    "CLU ELPGVCNETMMALWEECKPCLK-N4H5F1S1G0 glyco",
    "CLU ELPGVCNETMMALWEECKPCLK-N4H5F1S2G0 glyco",
    "CLU ELPGVCNETMMALWEECKPCLK-N4H5F2S1G0 glyco",
    "CLU HNSTGCLR-N2H5F0S0G0 glyco",
    "CLU HNSTGCLR-N2H7F0S0G0 glyco",
    "CLU HNSTGCLR-N2H8F0S0G0 glyco",
    "CLU HNSTGCLR-N4H5F0S0G0 glyco",
    "CLU HNSTGCLR-N4H5F0S1G0 glyco",
    "CLU KKEDALNETR-N4H5F0S2G0 glyco",
    "CLU KKEDALNETR-N4H5F1S2G0 glyco",
    "CLU LANLTQGEDQYYLR-N2H5F0S0G0 glyco",
    "CLU LANLTQGEDQYYLR-N2H6F0S0G0 glyco",
    "CLU LANLTQGEDQYYLR-N2H7F0S0G0 glyco",
    "CLU LANLTQGEDQYYLR-N2H8F0S0G0 glyco",
    "CLU LANLTQGEDQYYLR-N2H9F0S0G0 glyco",
    "CLU LANLTQGEDQYYLR-N3H3F1S0G0 glyco",
    "CLU LANLTQGEDQYYLR-N3H4F1S1G0 glyco",
    "CLU LANLTQGEDQYYLR-N4H3F1S0G0 glyco",
    "CLU LANLTQGEDQYYLR-N4H4F1S1G0 glyco",
    "CLU LANLTQGEDQYYLR-N4H4F2S0G0 glyco",
    "CLU LANLTQGEDQYYLR-N4H5F0S0G0 glyco",
    "CLU LANLTQGEDQYYLR-N4H5F0S1G0 glyco",
    "CLU LANLTQGEDQYYLR-N4H5F0S2G0 glyco",
    "CLU LANLTQGEDQYYLR-N4H5F1S0G0 glyco",
    "CLU LANLTQGEDQYYLR-N4H5F1S1G0 glyco",
    "CLU LANLTQGEDQYYLR-N4H5F1S2G0 glyco",
    "CLU LANLTQGEDQYYLR-N4H5F1S3G0 glyco",
    "CLU LANLTQGEDQYYLR-N4H5F2S1G0 glyco",
    "CLU LANLTQGEDQYYLR-N4H5F2S2G0 glyco",
    "CLU LANLTQGEDQYYLR-N5H3F1S0G0 glyco",
    "CLU LANLTQGEDQYYLR-N5H4F1S0G0 glyco",
    "CLU LANLTQGEDQYYLR-N5H4F1S1G0 glyco",
    "CLU LANLTQGEDQYYLR-N5H4F1S2G0 glyco",
    "CLU LANLTQGEDQYYLR-N5H4F2S0G0 glyco",
    "CLU LANLTQGEDQYYLR-N5H5F1S0G0 glyco",
    "CLU LANLTQGEDQYYLR-N5H5F1S2G0 glyco",
    "CLU LANLTQGEDQYYLR-N5H6F0S3G0 glyco",
    "CLU LANLTQGEDQYYLR-N5H6F1S3G0 glyco",
    "CLU LANLTQGEDQYYLR-N6H3F1S0G0 glyco",
    "CLU cnv",
    "CLU methyl",
    "CLU proteo",
    "CLU rna"
  ],
  "CLUAP1": [
    "CLUAP1 422_428_1_1_S428 phospho",
    "CLUAP1 cnv",
    "CLUAP1 methyl",
    "CLUAP1 proteo",
    "CLUAP1 rna"
  ],
  "CLUH": [
    "CLUH 654_672_1_1_S664 phospho",
    "CLUH cnv",
    "CLUH methyl",
    "CLUH proteo",
    "CLUH rna"
  ],
  "CLUHP3": [
    "CLUHP3 methyl"
  ],
  "CLUL1": [
    "CLUL1 cnv",
    "CLUL1 methyl",
    "CLUL1 rna"
  ],
  "CLVS1": [
    "CLVS1 327_335_1_1_S329 phospho",
    "CLVS1 cnv",
    "CLVS1 methyl",
    "CLVS1 proteo",
    "CLVS1 rna"
  ],
  "CLVS2": [
    "CLVS2 300_307_1_1_S302 phospho",
    "CLVS2 cnv",
    "CLVS2 methyl",
    "CLVS2 proteo",
    "CLVS2 rna"
  ],
  "CLXN": [
    "CLXN cnv",
    "CLXN methyl",
    "CLXN rna"
  ],
  "CLYBL": [
    "CLYBL cnv",
    "CLYBL proteo",
    "CLYBL rna"
  ],
  "CMA1": [
    "CMA1 cnv",
    "CMA1 rna"
  ],
  "CMAS": [
    "CMAS cnv",
    "CMAS methyl",
    "CMAS proteo",
    "CMAS rna"
  ],
  "CMBL": [
    "CMBL cnv",
    "CMBL methyl",
    "CMBL proteo",
    "CMBL rna"
  ],
  "CMC1": [
    "CMC1 cnv",
    "CMC1 methyl",
    "CMC1 proteo",
    "CMC1 rna"
  ],
  "CMC2": [
    "CMC2 cnv",
    "CMC2 methyl",
    "CMC2 proteo",
    "CMC2 rna"
  ],
  "CMC4": [
    "CMC4 methyl",
    "CMC4 proteo",
    "CMC4 rna"
  ],
  "CMIP": [
    "CMIP 283_294_1_1_S283 phospho",
    "CMIP cnv",
    "CMIP methyl",
    "CMIP proteo",
    "CMIP rna"
  ],
  "CMKLR1": [
    "CMKLR1 cnv",
    "CMKLR1 proteo",
    "CMKLR1 rna"
  ],
  "CMKLR2": [
    "CMKLR2 cnv",
    "CMKLR2 rna"
  ],
  "CMPK1": [
    "CMPK1 173_179_1_1_S179 phospho",
    "CMPK1 cnv",
    "CMPK1 methyl",
    "CMPK1 proteo",
    "CMPK1 rna"
  ],
  "CMPK2": [
    "CMPK2 cnv",
    "CMPK2 methyl",
    "CMPK2 proteo",
    "CMPK2 rna"
  ],
  "CMSS1": [
    "CMSS1 cnv",
    "CMSS1 methyl",
    "CMSS1 proteo",
    "CMSS1 rna"
  ],
  "CMTM1": [
    "CMTM1 cnv",
    "CMTM1 methyl",
    "CMTM1 rna"
  ],
  "CMTM2": [
    "CMTM2 cnv",
    "CMTM2 methyl",
    "CMTM2 rna"
  ],
  "CMTM3": [
    "CMTM3 163_168_1_1_S163 phospho",
    "CMTM3 cnv",
    "CMTM3 methyl",
    "CMTM3 rna"
  ],
  "CMTM4": [
    "CMTM4 192_199_1_1_S194 phospho",
    "CMTM4 199_208_1_1_T208 phospho",
    "CMTM4 cnv",
    "CMTM4 methyl",
    "CMTM4 proteo",
    "CMTM4 rna"
  ],
  "CMTM5": [
    "CMTM5 cnv",
    "CMTM5 proteo",
    "CMTM5 rna"
  ],
  "CMTM6": [
    "CMTM6 cnv",
    "CMTM6 methyl",
    "CMTM6 rna"
  ],
  "CMTM7": [
    "CMTM7 cnv",
    "CMTM7 methyl",
    "CMTM7 rna"
  ],
  "CMTM8": [
    "CMTM8 cnv",
    "CMTM8 methyl",
    "CMTM8 rna"
  ],
  "CMTR1": [
    "CMTR1 26_40_1_1_S31 phospho",
    "CMTR1 cnv",
    "CMTR1 proteo",
    "CMTR1 rna"
  ],
  "CMTR2": [
    "CMTR2 cnv",
    "CMTR2 methyl",
    "CMTR2 proteo",
    "CMTR2 rna"
  ],
  "CMYA5": [
    "CMYA5 cnv",
    "CMYA5 methyl",
    "CMYA5 rna"
  ],
  "CNBD1": [
    "CNBD1 cnv",
    "CNBD1 rna"
  ],
  "CNBD2": [
    "CNBD2 cnv",
    "CNBD2 methyl",
    "CNBD2 rna"
  ],
  "CNBP": [
    "CNBP cnv",
    "CNBP methyl",
    "CNBP proteo",
    "CNBP rna"
  ],
  "CNDP1": [
    "CNDP1 LVPHMNVSAVEK-N4H5F0S2G0 glyco",
    "CNDP1 cnv",
    "CNDP1 proteo",
    "CNDP1 rna"
  ],
  "CNDP2": [
    "CNDP2 58_58_1_1_S58 phospho",
    "CNDP2 cnv",
    "CNDP2 methyl",
    "CNDP2 proteo",
    "CNDP2 rna"
  ],
  "CNEP1R1": [
    "CNEP1R1 cnv",
    "CNEP1R1 methyl",
    "CNEP1R1 rna"
  ],
  "CNFN": [
    "CNFN cnv",
    "CNFN rna"
  ],
  "CNGA1": [
    "CNGA1 cnv",
    "CNGA1 methyl",
    "CNGA1 rna"
  ],
  "CNGA3": [
    "CNGA3 cnv",
    "CNGA3 methyl",
    "CNGA3 rna"
  ],
  "CNGA4": [
    "CNGA4 cnv",
    "CNGA4 methyl",
    "CNGA4 rna"
  ],
  "CNGB1": [
    "CNGB1 cnv",
    "CNGB1 rna"
  ],
  "CNGB3": [
    "CNGB3 cnv",
    "CNGB3 proteo",
    "CNGB3 rna"
  ],
  "CNIH1": [
    "CNIH1 cnv",
    "CNIH1 methyl",
    "CNIH1 rna"
  ],
  "CNIH2": [
    "CNIH2 cnv",
    "CNIH2 methyl",
    "CNIH2 rna"
  ],
  "CNIH3": [
    "CNIH3 cnv",
    "CNIH3 methyl",
    "CNIH3 proteo",
    "CNIH3 rna"
  ],
  "CNIH4": [
    "CNIH4 cnv",
    "CNIH4 methyl",
    "CNIH4 proteo",
    "CNIH4 rna"
  ],
  "CNKSR1": [
    "CNKSR1 cnv",
    "CNKSR1 rna"
  ],
  "CNKSR2": [
    "CNKSR2 339_350_1_1_S341 phospho",
    "CNKSR2 381_385_1_1_S381 phospho",
    "CNKSR2 759_763_1_1_S759 phospho",
    "CNKSR2 759_763_1_1_T760 phospho",
    "CNKSR2 859_864_1_1_S859 phospho",
    "CNKSR2 methyl",
    "CNKSR2 proteo",
    "CNKSR2 rna"
  ],
  "CNKSR3": [
    "CNKSR3 cnv",
    "CNKSR3 methyl",
    "CNKSR3 rna"
  ],
  "CNMD": [
    "CNMD cnv",
    "CNMD methyl",
    "CNMD rna"
  ],
  "CNN1": [
    "CNN1 cnv",
    "CNN1 proteo",
    "CNN1 rna"
  ],
  "CNN2": [
    "CNN2 cnv",
    "CNN2 methyl",
    "CNN2 proteo",
    "CNN2 rna"
  ],
  "CNN3": [
    "CNN3 162_170_1_1_S162 phospho",
    "CNN3 320_329_1_1_S323 phospho",
    "CNN3 cnv",
    "CNN3 methyl",
    "CNN3 proteo",
    "CNN3 rna"
  ],
  "CNNM1": [
    "CNNM1 cnv",
    "CNNM1 rna"
  ],
  "CNNM2": [
    "CNNM2 cnv",
    "CNNM2 methyl",
    "CNNM2 proteo",
    "CNNM2 rna"
  ],
  "CNNM3": [
    "CNNM3 661_675_1_1_S673 phospho",
    "CNNM3 682_700_1_1_S700 phospho",
    "CNNM3 cnv",
    "CNNM3 methyl",
    "CNNM3 proteo",
    "CNNM3 rna"
  ],
  "CNNM4": [
    "CNNM4 DLVVQQLVNVSR-N2H6F0S0G0 glyco",
    "CNNM4 DLVVQQLVNVSR-N2H7F0S0G0 glyco",
    "CNNM4 DLVVQQLVNVSR-N2H8F0S0G0 glyco",
    "CNNM4 cnv",
    "CNNM4 methyl",
    "CNNM4 proteo",
    "CNNM4 rna"
  ],
  "CNOT1": [
    "CNOT1 cnv",
    "CNOT1 methyl",
    "CNOT1 proteo",
    "CNOT1 rna"
  ],
  "CNOT10": [
    "CNOT10 cnv",
    "CNOT10 methyl",
    "CNOT10 proteo",
    "CNOT10 rna"
  ],
  "CNOT11": [
    "CNOT11 cnv",
    "CNOT11 methyl",
    "CNOT11 proteo",
    "CNOT11 rna"
  ],
  "CNOT2": [
    "CNOT2 155_165_1_1_S157 phospho",
    "CNOT2 155_165_1_1_S165 phospho",
    "CNOT2 cnv",
    "CNOT2 methyl",
    "CNOT2 proteo",
    "CNOT2 rna"
  ],
  "CNOT3": [
    "CNOT3 291_299_1_1_S291 phospho",
    "CNOT3 291_299_1_1_S299 phospho",
    "CNOT3 cnv",
    "CNOT3 methyl",
    "CNOT3 proteo",
    "CNOT3 rna"
  ],
  "CNOT4": [
    "CNOT4 267_304_1_1_S298 phospho",
    "CNOT4 272_307_1_1_S301 phospho",
    "CNOT4 421_442_1_1_S429 phospho",
    "CNOT4 cnv",
    "CNOT4 methyl",
    "CNOT4 proteo",
    "CNOT4 rna"
  ],
  "CNOT6": [
    "CNOT6 cnv",
    "CNOT6 methyl",
    "CNOT6 rna"
  ],
  "CNOT6L": [
    "CNOT6L cnv",
    "CNOT6L methyl",
    "CNOT6L proteo",
    "CNOT6L rna"
  ],
  "CNOT7": [
    "CNOT7 cnv",
    "CNOT7 methyl",
    "CNOT7 proteo",
    "CNOT7 rna"
  ],
  "CNOT8": [
    "CNOT8 cnv",
    "CNOT8 methyl",
    "CNOT8 proteo",
    "CNOT8 rna"
  ],
  "CNOT9": [
    "CNOT9 cnv",
    "CNOT9 methyl",
    "CNOT9 proteo",
    "CNOT9 rna"
  ],
  "CNP": [
    "CNP 170_170_1_1_S170 phospho",
    "CNP 303_320_1_1_S318 phospho",
    "CNP 9_11_1_1_S9 phospho",
    "CNP cnv",
    "CNP methyl",
    "CNP proteo",
    "CNP rna"
  ],
  "CNPPD1": [
    "CNPPD1 cnv",
    "CNPPD1 methyl",
    "CNPPD1 rna"
  ],
  "CNPY1": [
    "CNPY1 cnv",
    "CNPY1 methyl",
    "CNPY1 rna"
  ],
  "CNPY2": [
    "CNPY2 cnv",
    "CNPY2 methyl",
    "CNPY2 proteo",
    "CNPY2 rna"
  ],
  "CNPY3": [
    "CNPY3 cnv",
    "CNPY3 methyl",
    "CNPY3 proteo",
    "CNPY3 rna"
  ],
  "CNPY4": [
    "CNPY4 58_70_1_1_S58 phospho",
    "CNPY4 cnv",
    "CNPY4 proteo",
    "CNPY4 rna"
  ],
  "CNR1": [
    "CNR1 313_322_1_1_S316 phospho",
    "CNR1 316_322_1_1_S316 phospho",
    "CNR1 441_441_1_1_S441 phospho",
    "CNR1 cnv",
    "CNR1 methyl",
    "CNR1 proteo",
    "CNR1 rna"
  ],
  "CNR2": [
    "CNR2 cnv",
    "CNR2 rna"
  ],
  "CNRIP1": [
    "CNRIP1 cnv",
    "CNRIP1 methyl",
    "CNRIP1 proteo",
    "CNRIP1 rna"
  ],
  "CNST": [
    "CNST cnv",
    "CNST methyl",
    "CNST proteo",
    "CNST rna"
  ],
  "CNTD1": [
    "CNTD1 cnv",
    "CNTD1 methyl",
    "CNTD1 rna"
  ],
  "CNTF": [
    "CNTF cnv",
    "CNTF rna"
  ],
  "CNTFR": [
    "CNTFR cnv",
    "CNTFR methyl",
    "CNTFR proteo",
    "CNTFR rna"
  ],
  "CNTLN": [
    "CNTLN cnv",
    "CNTLN methyl",
    "CNTLN rna"
  ],
  "CNTN1": [
    "CNTN1 ANSTGTLVITDPTR-N4H3F0S0G0 glyco",
    "CNTN1 ANSTGTLVITDPTR-N4H3F1S0G0 glyco",
    "CNTN1 ANSTGTLVITDPTR-N5H3F0S0G0 glyco",
    "CNTN1 ANSTGTLVITDPTR-N5H3F1S0G0 glyco",
    "CNTN1 ANSTGTLVITDPTR-N5H4F1S0G0 glyco",
    "CNTN1 ANSTGTLVITDPTR-N5H4F2S0G0 glyco",
    "CNTN1 DVYALMGQNVTLECFALGNPVPDIR-N2H5F0S0G0 glyco",
    "CNTN1 DVYALMGQNVTLECFALGNPVPDIR-N2H7F0S0G0 glyco",
    "CNTN1 DVYALMGQNVTLECFALGNPVPDIR-N2H8F0S0G0 glyco",
    "CNTN1 DVYALMGQNVTLECFALGNPVPDIR-N5H4F0S0G0 glyco",
    "CNTN1 DVYALMGQNVTLECFALGNPVPDIR-N5H4F1S0G0 glyco",
    "CNTN1 DVYALMGQNVTLECFALGNPVPDIR-N5H5F0S0G0 glyco",
    "CNTN1 FVSQTNGNLYIANVEASDKGNYSCFVSSPSITK-N5H3F0S0G0 glyco",
    "CNTN1 GNYSCFVSSPSITK-N2H5F0S0G0 glyco",
    "CNTN1 GNYSCFVSSPSITK-N4H3F0S0G0 glyco",
    "CNTN1 GNYSCFVSSPSITK-N5H3F0S0G0 glyco",
    "CNTN1 GNYSCFVSSPSITK-N5H3F1S0G0 glyco",
    "CNTN1 GNYSCFVSSPSITK-N5H4F1S0G0 glyco",
    "CNTN1 GTEWLVNSSR-N2H3F0S0G0 glyco",
    "CNTN1 GTEWLVNSSR-N2H4F0S0G0 glyco",
    "CNTN1 GTEWLVNSSR-N2H5F0S0G0 glyco",
    "CNTN1 GTEWLVNSSR-N2H6F0S0G0 glyco",
    "CNTN1 GTEWLVNSSR-N2H7F0S0G0 glyco",
    "CNTN1 GTEWLVNSSR-N3H3F0S0G0 glyco",
    "CNTN1 GTEWLVNSSR-N3H3F1S0G0 glyco",
    "CNTN1 ILIWEDGSLEINNITR-N2H5F0S0G0 glyco",
    "CNTN1 ILIWEDGSLEINNITR-N4H3F1S0G0 glyco",
    "CNTN1 ILIWEDGSLEINNITR-N4H5F0S0G0 glyco",
    "CNTN1 ILIWEDGSLEINNITR-N5H3F1S0G0 glyco",
    "CNTN1 YIITWDHVVALSNESTVTGYK-N2H5F0S0G0 glyco",
    "CNTN1 YIITWDHVVALSNESTVTGYK-N2H6F0S0G0 glyco",
    "CNTN1 YIITWDHVVALSNESTVTGYK-N2H7F0S0G0 glyco",
    "CNTN1 YIITWDHVVALSNESTVTGYK-N2H8F0S0G0 glyco",
    "CNTN1 YIITWDHVVALSNESTVTGYK-N4H4F1S1G0 glyco",
    "CNTN1 YIITWDHVVALSNESTVTGYK-N5H3F1S0G0 glyco",
    "CNTN1 YIITWDHVVALSNESTVTGYK-N5H4F1S1G0 glyco",
    "CNTN1 YIITWDHVVALSNESTVTGYK-N5H4F2S0G0 glyco",
    "CNTN1 YIITWDHVVALSNESTVTGYK-N5H5F1S1G0 glyco",
    "CNTN1 YIITWDHVVALSNESTVTGYK-N5H5F2S1G0 glyco",
    "CNTN1 YIITWDHVVALSNESTVTGYK-N6H5F2S1G0 glyco",
    "CNTN1 YTCTAQTIVDNSSASADLVVR-N2H5F0S0G0 glyco",
    "CNTN1 YTCTAQTIVDNSSASADLVVR-N2H6F0S0G0 glyco",
    "CNTN1 YTCTAQTIVDNSSASADLVVR-N2H7F0S0G0 glyco",
    "CNTN1 YTCTAQTIVDNSSASADLVVR-N2H8F0S0G0 glyco",
    "CNTN1 YTCTAQTIVDNSSASADLVVR-N2H9F0S0G0 glyco",
    "CNTN1 cnv",
    "CNTN1 proteo",
    "CNTN1 rna"
  ],
  "CNTN2": [
    "CNTN2 GTEILVNSSR-N2H4F0S0G0 glyco",
    "CNTN2 GTEILVNSSR-N2H5F0S0G0 glyco",
    "CNTN2 GTEILVNSSR-N2H6F0S0G0 glyco",
    "CNTN2 VPGADAQYFVYSNESVRPYTPFEVK-N5H3F1S0G0 glyco",
    "CNTN2 cnv",
    "CNTN2 methyl",
    "CNTN2 proteo",
    "CNTN2 rna"
  ],
  "CNTN3": [
    "CNTN3 cnv",
    "CNTN3 methyl",
    "CNTN3 proteo",
    "CNTN3 rna"
  ],
  "CNTN4": [
    "CNTN4 cnv",
    "CNTN4 methyl",
    "CNTN4 proteo",
    "CNTN4 rna"
  ],
  "CNTN5": [
    "CNTN5 cnv",
    "CNTN5 methyl",
    "CNTN5 proteo",
    "CNTN5 rna"
  ],
  "CNTN6": [
    "CNTN6 cnv",
    "CNTN6 rna"
  ],
  "CNTNAP1": [
    "CNTNAP1 1381_1383_1_1_S1383 phospho",
    "CNTNAP1 ANHSLDVSFYFR-N2H10F0S0G0 glyco",
    "CNTNAP1 ANHSLDVSFYFR-N2H8F0S0G0 glyco",
    "CNTNAP1 DVNFTLDGYVQR-N2H8F0S0G0 glyco",
    "CNTNAP1 DVNFTLDGYVQR-N2H9F0S0G0 glyco",
    "CNTNAP1 GLLTFVDHLPVTQVVIGDTNR-N2H5F0S0G0 glyco",
    "CNTNAP1 TSGNFTIDPDGSGPLKPFVVYCDIR-N2H5F0S0G0 glyco",
    "CNTNAP1 VDGQLVNLTLVEGR-N2H5F0S0G0 glyco",
    "CNTNAP1 VDGQLVNLTLVEGR-N2H6F0S0G0 glyco",
    "CNTNAP1 VDGQLVNLTLVEGR-N2H7F0S0G0 glyco",
    "CNTNAP1 VDGQLVNLTLVEGR-N2H8F0S0G0 glyco",
    "CNTNAP1 VELNTSR-N2H3F0S0G0 glyco",
    "CNTNAP1 VELNTSR-N2H4F0S0G0 glyco",
    "CNTNAP1 VELNTSR-N2H5F0S0G0 glyco",
    "CNTNAP1 VELNTSR-N2H7F0S0G0 glyco",
    "CNTNAP1 VELNTSR-N2H8F0S0G0 glyco",
    "CNTNAP1 WDCHSNQTAFHGCMELLK-N2H5F0S0G0 glyco",
    "CNTNAP1 cnv",
    "CNTNAP1 methyl",
    "CNTNAP1 proteo",
    "CNTNAP1 rna"
  ],
  "CNTNAP2": [
    "CNTNAP2 GCMESINYNGVNITDLAR-N2H6F0S0G0 glyco",
    "CNTNAP2 GCMESINYNGVNITDLAR-N2H7F0S0G0 glyco",
    "CNTNAP2 NMANGQPHSVNITR-N2H6F0S0G0 glyco",
    "CNTNAP2 SINLTLDR-N2H4F0S0G0 glyco",
    "CNTNAP2 SINLTLDR-N2H5F0S0G0 glyco",
    "CNTNAP2 VGVHINITQTK-N2H5F0S0G0 glyco",
    "CNTNAP2 VGVHINITQTK-N4H4F0S0G0 glyco",
    "CNTNAP2 VGVHINITQTK-N5H3F0S0G0 glyco",
    "CNTNAP2 VYCNMTEDK-N2H5F0S0G0 glyco",
    "CNTNAP2 cnv",
    "CNTNAP2 methyl",
    "CNTNAP2 proteo",
    "CNTNAP2 rna"
  ],
  "CNTNAP3": [
    "CNTNAP3 cnv",
    "CNTNAP3 rna"
  ],
  "CNTNAP3B": [
    "CNTNAP3B cnv",
    "CNTNAP3B rna"
  ],
  "CNTNAP3C": [
    "CNTNAP3C cnv",
    "CNTNAP3C rna"
  ],
  "CNTNAP4": [
    "CNTNAP4 QVNFTVDEHR-N2H5F0S0G0 glyco",
    "CNTNAP4 cnv",
    "CNTNAP4 proteo",
    "CNTNAP4 rna"
  ],
  "CNTNAP5": [
    "CNTNAP5 IWTSVQHNNTELTR-N2H5F0S0G0 glyco",
    "CNTNAP5 QVNFTVDK-N2H5F0S0G0 glyco",
    "CNTNAP5 cnv",
    "CNTNAP5 methyl",
    "CNTNAP5 proteo",
    "CNTNAP5 rna"
  ],
  "CNTNAP5-DT": [
    "CNTNAP5-DT methyl"
  ],
  "CNTRL": [
    "CNTRL cnv",
    "CNTRL methyl",
    "CNTRL proteo",
    "CNTRL rna"
  ],
  "CNTROB": [
    "CNTROB cnv",
    "CNTROB methyl",
    "CNTROB proteo",
    "CNTROB rna"
  ],
  "COA1": [
    "COA1 cnv",
    "COA1 methyl",
    "COA1 proteo",
    "COA1 rna"
  ],
  "COA3": [
    "COA3 cnv",
    "COA3 methyl",
    "COA3 proteo",
    "COA3 rna"
  ],
  "COA4": [
    "COA4 cnv",
    "COA4 methyl",
    "COA4 proteo",
    "COA4 rna"
  ],
  "COA5": [
    "COA5 cnv",
    "COA5 methyl",
    "COA5 proteo",
    "COA5 rna"
  ],
  "COA6": [
    "COA6 cnv",
    "COA6 methyl",
    "COA6 proteo",
    "COA6 rna"
  ],
  "COA6-AS1": [
    "COA6-AS1 methyl"
  ],
  "COA7": [
    "COA7 cnv",
    "COA7 methyl",
    "COA7 proteo",
    "COA7 rna"
  ],
  "COA8": [
    "COA8 cnv",
    "COA8 methyl",
    "COA8 rna"
  ],
  "COASY": [
    "COASY 149_183_1_1_S178 phospho",
    "COASY cnv",
    "COASY methyl",
    "COASY proteo",
    "COASY rna"
  ],
  "COBL": [
    "COBL 920_927_1_0 phospho",
    "COBL cnv",
    "COBL methyl",
    "COBL proteo",
    "COBL rna"
  ],
  "COBLL1": [
    "COBLL1 320_326_1_1_T326 phospho",
    "COBLL1 909_926_1_1_S919 phospho",
    "COBLL1 cnv",
    "COBLL1 methyl",
    "COBLL1 proteo",
    "COBLL1 rna"
  ],
  "COCH": [
    "COCH cnv",
    "COCH methyl",
    "COCH rna"
  ],
  "COG1": [
    "COG1 cnv",
    "COG1 methyl",
    "COG1 proteo",
    "COG1 rna"
  ],
  "COG2": [
    "COG2 cnv",
    "COG2 methyl",
    "COG2 proteo",
    "COG2 rna"
  ],
  "COG3": [
    "COG3 531_557_1_0 phospho",
    "COG3 cnv",
    "COG3 methyl",
    "COG3 proteo",
    "COG3 rna"
  ],
  "COG4": [
    "COG4 cnv",
    "COG4 methyl",
    "COG4 proteo",
    "COG4 rna"
  ],
  "COG5": [
    "COG5 cnv",
    "COG5 methyl",
    "COG5 proteo",
    "COG5 rna"
  ],
  "COG6": [
    "COG6 cnv",
    "COG6 methyl",
    "COG6 proteo",
    "COG6 rna"
  ],
  "COG7": [
    "COG7 500_506_1_1_S506 phospho",
    "COG7 cnv",
    "COG7 methyl",
    "COG7 proteo",
    "COG7 rna"
  ],
  "COG8": [
    "COG8 cnv",
    "COG8 methyl",
    "COG8 proteo",
    "COG8 rna"
  ],
  "COIL": [
    "COIL 122_122_1_1_T122 phospho",
    "COIL 566_573_1_0 phospho",
    "COIL cnv",
    "COIL methyl",
    "COIL proteo",
    "COIL rna"
  ],
  "COL10A1": [
    "COL10A1 cnv",
    "COL10A1 rna"
  ],
  "COL11A1": [
    "COL11A1 cnv",
    "COL11A1 proteo",
    "COL11A1 rna"
  ],
  "COL11A2": [
    "COL11A2 cnv",
    "COL11A2 methyl",
    "COL11A2 proteo",
    "COL11A2 rna"
  ],
  "COL12A1": [
    "COL12A1 NLQVYNATSNSLTVK-N2H5F0S0G0 glyco",
    "COL12A1 cnv",
    "COL12A1 methyl",
    "COL12A1 proteo",
    "COL12A1 rna"
  ],
  "COL13A1": [
    "COL13A1 cnv",
    "COL13A1 methyl",
    "COL13A1 rna"
  ],
  "COL14A1": [
    "COL14A1 AIIQGLMPDQNYTVQIIAYNK-N5H3F1S0G0 glyco",
    "COL14A1 AIIQGLMPDQNYTVQIIAYNK-N5H4F1S0G0 glyco",
    "COL14A1 cnv",
    "COL14A1 methyl",
    "COL14A1 proteo",
    "COL14A1 rna"
  ],
  "COL15A1": [
    "COL15A1 cnv",
    "COL15A1 methyl",
    "COL15A1 proteo",
    "COL15A1 rna"
  ],
  "COL16A1": [
    "COL16A1 258_270_1_1_S260 phospho",
    "COL16A1 cnv",
    "COL16A1 methyl",
    "COL16A1 proteo",
    "COL16A1 rna"
  ],
  "COL17A1": [
    "COL17A1 cnv",
    "COL17A1 rna"
  ],
  "COL18A1": [
    "COL18A1 cnv",
    "COL18A1 methyl",
    "COL18A1 proteo",
    "COL18A1 rna"
  ],
  "COL19A1": [
    "COL19A1 cnv",
    "COL19A1 methyl",
    "COL19A1 rna"
  ],
  "COL1A1": [
    "COL1A1 LMSTEASQNITYHCK-N2H6F0S0G0 glyco",
    "COL1A1 LMSTEASQNITYHCK-N2H7F0S0G0 glyco",
    "COL1A1 cnv",
    "COL1A1 methyl",
    "COL1A1 proteo",
    "COL1A1 rna"
  ],
  "COL1A2": [
    "COL1A2 LLANYASQNITYHCK-N2H6F0S0G0 glyco",
    "COL1A2 LLANYASQNITYHCK-N2H7F0S0G0 glyco",
    "COL1A2 LLANYASQNITYHCK-N2H8F0S0G0 glyco",
    "COL1A2 cnv",
    "COL1A2 proteo",
    "COL1A2 rna"
  ],
  "COL20A1": [
    "COL20A1 cnv",
    "COL20A1 methyl",
    "COL20A1 proteo",
    "COL20A1 rna"
  ],
  "COL21A1": [
    "COL21A1 cnv",
    "COL21A1 methyl",
    "COL21A1 rna"
  ],
  "COL22A1": [
    "COL22A1 cnv",
    "COL22A1 proteo",
    "COL22A1 rna"
  ],
  "COL23A1": [
    "COL23A1 cnv",
    "COL23A1 methyl",
    "COL23A1 rna"
  ],
  "COL24A1": [
    "COL24A1 cnv",
    "COL24A1 methyl",
    "COL24A1 rna"
  ],
  "COL25A1": [
    "COL25A1 cnv",
    "COL25A1 methyl",
    "COL25A1 rna"
  ],
  "COL25A1-DT": [
    "COL25A1-DT methyl"
  ],
  "COL26A1": [
    "COL26A1 cnv",
    "COL26A1 methyl",
    "COL26A1 rna"
  ],
  "COL27A1": [
    "COL27A1 cnv",
    "COL27A1 methyl",
    "COL27A1 rna"
  ],
  "COL28A1": [
    "COL28A1 cnv",
    "COL28A1 proteo",
    "COL28A1 rna"
  ],
  "COL2A1": [
    "COL2A1 cnv",
    "COL2A1 methyl",
    "COL2A1 proteo",
    "COL2A1 rna"
  ],
  "COL3A1": [
    "COL3A1 ASQNITYHCK-N2H6F0S0G0 glyco",
    "COL3A1 ASQNITYHCK-N2H7F0S0G0 glyco",
    "COL3A1 ASQNITYHCK-N2H8F0S0G0 glyco",
    "COL3A1 cnv",
    "COL3A1 proteo",
    "COL3A1 rna"
  ],
  "COL4A1": [
    "COL4A1 cnv",
    "COL4A1 methyl",
    "COL4A1 proteo",
    "COL4A1 rna"
  ],
  "COL4A2": [
    "COL4A2 cnv",
    "COL4A2 methyl",
    "COL4A2 proteo",
    "COL4A2 rna"
  ],
  "COL4A3": [
    "COL4A3 cnv",
    "COL4A3 methyl",
    "COL4A3 rna"
  ],
  "COL4A4": [
    "COL4A4 cnv",
    "COL4A4 methyl",
    "COL4A4 rna"
  ],
  "COL4A5": [
    "COL4A5 rna"
  ],
  "COL4A6": [
    "COL4A6 rna"
  ],
  "COL5A1": [
    "COL5A1 cnv",
    "COL5A1 methyl",
    "COL5A1 proteo",
    "COL5A1 rna"
  ],
  "COL5A2": [
    "COL5A2 EASQNITYICK-N2H6F0S0G0 glyco",
    "COL5A2 EASQNITYICK-N2H9F0S0G0 glyco",
    "COL5A2 cnv",
    "COL5A2 proteo",
    "COL5A2 rna"
  ],
  "COL5A3": [
    "COL5A3 cnv",
    "COL5A3 methyl",
    "COL5A3 proteo",
    "COL5A3 rna"
  ],
  "COL6A1": [
    "COL6A1 NFTAADWGQSR-N2H6F0S0G0 glyco",
    "COL6A1 NFTAADWGQSR-N2H8F0S0G0 glyco",
    "COL6A1 NFTAADWGQSR-N4H5F1S0G0 glyco",
    "COL6A1 NVTAQICIDK-N2H3F0S0G0 glyco",
    "COL6A1 NVTAQICIDK-N2H4F0S0G0 glyco",
    "COL6A1 NVTAQICIDK-N2H5F0S0G0 glyco",
    "COL6A1 NVTAQICIDK-N2H6F0S0G0 glyco",
    "COL6A1 NVTAQICIDK-N2H7F0S0G0 glyco",
    "COL6A1 NVTAQICIDK-N2H8F0S0G0 glyco",
    "COL6A1 NVTAQICIDK-N3H4F0S0G0 glyco",
    "COL6A1 NVTAQICIDK-N3H4F0S1G0 glyco",
    "COL6A1 NVTAQICIDK-N3H5F0S0G0 glyco",
    "COL6A1 NVTAQICIDK-N3H5F0S1G0 glyco",
    "COL6A1 NVTAQICIDK-N3H6F0S0G0 glyco",
    "COL6A1 NVTAQICIDK-N3H6F0S1G0 glyco",
    "COL6A1 NVTAQICIDK-N5H3F1S0G0 glyco",
    "COL6A1 NVTAQICIDKK-N2H5F0S0G0 glyco",
    "COL6A1 cnv",
    "COL6A1 methyl",
    "COL6A1 proteo",
    "COL6A1 rna"
  ],
  "COL6A2": [
    "COL6A2 GTFTDCALANMTEQIR-N4H5F0S0G0 glyco",
    "COL6A2 GTFTDCALANMTEQIR-N4H5F0S1G0 glyco",
    "COL6A2 GTFTDCALANMTEQIR-N5H4F0S0G0 glyco",
    "COL6A2 GTFTDCALANMTEQIR-N5H5F0S0G0 glyco",
    "COL6A2 HAELSFVFLTDGVTGNDSLHESAHSMR-N4H5F1S0G0 glyco",
    "COL6A2 NMTLFSDLVAEK-N2H8F0S0G0 glyco",
    "COL6A2 NMTLFSDLVAEK-N4H3F1S0G0 glyco",
    "COL6A2 NMTLFSDLVAEK-N4H4F1S0G0 glyco",
    "COL6A2 NMTLFSDLVAEK-N4H5F0S0G0 glyco",
    "COL6A2 NMTLFSDLVAEK-N4H5F0S1G0 glyco",
    "COL6A2 NMTLFSDLVAEK-N4H5F1S0G0 glyco",
    "COL6A2 NMTLFSDLVAEK-N4H5F1S1G0 glyco",
    "COL6A2 NMTLFSDLVAEK-N4H5F1S2G0 glyco",
    "COL6A2 cnv",
    "COL6A2 methyl",
    "COL6A2 proteo",
    "COL6A2 rna"
  ],
  "COL6A3": [
    "COL6A3 QLINALQINNTAVGHALVLPAGR-N4H4F1S0G0 glyco",
    "COL6A3 QLINALQINNTAVGHALVLPAGR-N4H5F0S1G0 glyco",
    "COL6A3 QLINALQINNTAVGHALVLPAGR-N4H5F1S0G0 glyco",
    "COL6A3 QLINALQINNTAVGHALVLPAGR-N4H5F1S1G0 glyco",
    "COL6A3 QLINALQINNTAVGHALVLPAGR-N5H3F1S0G0 glyco",
    "COL6A3 QLINALQINNTAVGHALVLPAGR-N5H4F1S0G0 glyco",
    "COL6A3 QLINALQINNTAVGHALVLPAGR-N5H5F1S0G0 glyco",
    "COL6A3 cnv",
    "COL6A3 methyl",
    "COL6A3 proteo",
    "COL6A3 rna"
  ],
  "COL6A4P1": [
    "COL6A4P1 methyl"
  ],
  "COL6A5": [
    "COL6A5 cnv",
    "COL6A5 methyl",
    "COL6A5 rna"
  ],
  "COL6A6": [
    "COL6A6 cnv",
    "COL6A6 methyl",
    "COL6A6 rna"
  ],
  "COL7A1": [
    "COL7A1 cnv",
    "COL7A1 methyl",
    "COL7A1 rna"
  ],
  "COL8A1": [
    "COL8A1 cnv",
    "COL8A1 rna"
  ],
  "COL8A2": [
    "COL8A2 cnv",
    "COL8A2 methyl",
    "COL8A2 rna"
  ],
  "COL9A1": [
    "COL9A1 cnv",
    "COL9A1 methyl",
    "COL9A1 rna"
  ],
  "COL9A2": [
    "COL9A2 cnv",
    "COL9A2 methyl",
    "COL9A2 proteo",
    "COL9A2 rna"
  ],
  "COL9A3": [
    "COL9A3 cnv",
    "COL9A3 methyl",
    "COL9A3 proteo",
    "COL9A3 rna"
  ],
  "COLCA1": [
    "COLCA1 methyl"
  ],
  "COLCA2": [
    "COLCA2 cnv",
    "COLCA2 methyl",
    "COLCA2 rna"
  ],
  "COLEC10": [
    "COLEC10 cnv",
    "COLEC10 rna"
  ],
  "COLEC11": [
    "COLEC11 cnv",
    "COLEC11 methyl",
    "COLEC11 rna"
  ],
  "COLEC12": [
    "COLEC12 cnv",
    "COLEC12 methyl",
    "COLEC12 proteo",
    "COLEC12 rna"
  ],
  "COLGALT1": [
    "COLGALT1 AMNTSQVEALGIQMLPGYR-N2H6F0S0G0 glyco",
    "COLGALT1 TALWVATDHNMDNTSTVLR-N2H8F0S0G0 glyco",
    "COLGALT1 cnv",
    "COLGALT1 methyl",
    "COLGALT1 proteo",
    "COLGALT1 rna"
  ],
  "COLGALT2": [
    "COLGALT2 ALNTSQLK-N2H5F0S0G0 glyco",
    "COLGALT2 ALNTSQLK-N2H6F0S0G0 glyco",
    "COLGALT2 ALNTSQLK-N2H7F0S0G0 glyco",
    "COLGALT2 ALNTSQLK-N2H8F0S0G0 glyco",
    "COLGALT2 ALNTSQLK-N2H9F0S0G0 glyco",
    "COLGALT2 cnv",
    "COLGALT2 methyl",
    "COLGALT2 proteo",
    "COLGALT2 rna"
  ],
  "COLQ": [
    "COLQ cnv",
    "COLQ rna"
  ],
  "COMMD1": [
    "COMMD1 cnv",
    "COMMD1 methyl",
    "COMMD1 proteo",
    "COMMD1 rna"
  ],
  "COMMD10": [
    "COMMD10 141_155_1_1_S141 phospho",
    "COMMD10 cnv",
    "COMMD10 methyl",
    "COMMD10 proteo",
    "COMMD10 rna"
  ],
  "COMMD2": [
    "COMMD2 cnv",
    "COMMD2 methyl",
    "COMMD2 proteo",
    "COMMD2 rna"
  ],
  "COMMD3": [
    "COMMD3 cnv",
    "COMMD3 methyl",
    "COMMD3 proteo",
    "COMMD3 rna"
  ],
  "COMMD3-BMI1": [
    "COMMD3-BMI1 cnv",
    "COMMD3-BMI1 methyl",
    "COMMD3-BMI1 rna"
  ],
  "COMMD4": [
    "COMMD4 cnv",
    "COMMD4 methyl",
    "COMMD4 proteo",
    "COMMD4 rna"
  ],
  "COMMD5": [
    "COMMD5 cnv",
    "COMMD5 methyl",
    "COMMD5 proteo",
    "COMMD5 rna"
  ],
  "COMMD6": [
    "COMMD6 cnv",
    "COMMD6 methyl",
    "COMMD6 proteo",
    "COMMD6 rna"
  ],
  "COMMD7": [
    "COMMD7 cnv",
    "COMMD7 methyl",
    "COMMD7 proteo",
    "COMMD7 rna"
  ],
  "COMMD8": [
    "COMMD8 cnv",
    "COMMD8 methyl",
    "COMMD8 proteo",
    "COMMD8 rna"
  ],
  "COMMD9": [
    "COMMD9 cnv",
    "COMMD9 proteo",
    "COMMD9 rna"
  ],
  "COMP": [
    "COMP cnv",
    "COMP methyl",
    "COMP proteo",
    "COMP rna"
  ],
  "COMT": [
    "COMT 262_267_1_1_S267 phospho",
    "COMT 267_267_1_1_S267 phospho",
    "COMT cnv",
    "COMT methyl",
    "COMT proteo",
    "COMT rna"
  ],
  "COMTD1": [
    "COMTD1 cnv",
    "COMTD1 methyl",
    "COMTD1 proteo",
    "COMTD1 rna"
  ],
  "COP1": [
    "COP1 cnv",
    "COP1 methyl",
    "COP1 proteo",
    "COP1 rna"
  ],
  "COPA": [
    "COPA 173_179_1_1_S173 phospho",
    "COPA cnv",
    "COPA methyl",
    "COPA proteo",
    "COPA rna"
  ],
  "COPB1": [
    "COPB1 cnv",
    "COPB1 methyl",
    "COPB1 proteo",
    "COPB1 rna"
  ],
  "COPB2": [
    "COPB2 847_869_1_0 phospho",
    "COPB2 847_869_1_1_S859 phospho",
    "COPB2 847_869_1_1_T861 phospho",
    "COPB2 cnv",
    "COPB2 methyl",
    "COPB2 proteo",
    "COPB2 rna"
  ],
  "COPB2-DT": [
    "COPB2-DT methyl"
  ],
  "COPE": [
    "COPE 10_13_1_1_S13 phospho",
    "COPE 283_283_1_1_S283 phospho",
    "COPE cnv",
    "COPE methyl",
    "COPE proteo",
    "COPE rna"
  ],
  "COPG1": [
    "COPG1 cnv",
    "COPG1 proteo",
    "COPG1 rna"
  ],
  "COPG2": [
    "COPG2 cnv",
    "COPG2 methyl",
    "COPG2 proteo",
    "COPG2 rna"
  ],
  "COPRS": [
    "COPRS 31_43_1_1_S31 phospho",
    "COPRS 59_66_1_1_S66 phospho",
    "COPRS cnv",
    "COPRS methyl",
    "COPRS proteo",
    "COPRS rna"
  ],
  "COPS2": [
    "COPS2 cnv",
    "COPS2 methyl",
    "COPS2 proteo",
    "COPS2 rna"
  ],
  "COPS3": [
    "COPS3 407_423_1_1_S410 phospho",
    "COPS3 407_423_1_1_S423 phospho",
    "COPS3 cnv",
    "COPS3 methyl",
    "COPS3 proteo",
    "COPS3 rna"
  ],
  "COPS4": [
    "COPS4 cnv",
    "COPS4 proteo",
    "COPS4 rna"
  ],
  "COPS5": [
    "COPS5 cnv",
    "COPS5 methyl",
    "COPS5 proteo",
    "COPS5 rna"
  ],
  "COPS6": [
    "COPS6 cnv",
    "COPS6 proteo",
    "COPS6 rna"
  ],
  "COPS7A": [
    "COPS7A cnv",
    "COPS7A methyl",
    "COPS7A proteo",
    "COPS7A rna"
  ],
  "COPS7B": [
    "COPS7B cnv",
    "COPS7B methyl",
    "COPS7B proteo",
    "COPS7B rna"
  ],
  "COPS8": [
    "COPS8 175_175_1_1_S175 phospho",
    "COPS8 cnv",
    "COPS8 methyl",
    "COPS8 proteo",
    "COPS8 rna"
  ],
  "COPS9": [
    "COPS9 cnv",
    "COPS9 methyl",
    "COPS9 rna"
  ],
  "COPZ1": [
    "COPZ1 cnv",
    "COPZ1 proteo",
    "COPZ1 rna"
  ],
  "COPZ2": [
    "COPZ2 cnv",
    "COPZ2 methyl",
    "COPZ2 proteo",
    "COPZ2 rna"
  ],
  "COQ10A": [
    "COQ10A cnv",
    "COQ10A methyl",
    "COQ10A rna"
  ],
  "COQ10B": [
    "COQ10B cnv",
    "COQ10B methyl",
    "COQ10B proteo",
    "COQ10B rna"
  ],
  "COQ2": [
    "COQ2 cnv",
    "COQ2 methyl",
    "COQ2 rna"
  ],
  "COQ3": [
    "COQ3 cnv",
    "COQ3 methyl",
    "COQ3 proteo",
    "COQ3 rna"
  ],
  "COQ4": [
    "COQ4 cnv",
    "COQ4 methyl",
    "COQ4 rna"
  ],
  "COQ5": [
    "COQ5 cnv",
    "COQ5 methyl",
    "COQ5 proteo",
    "COQ5 rna"
  ],
  "COQ6": [
    "COQ6 cnv",
    "COQ6 methyl",
    "COQ6 proteo",
    "COQ6 rna"
  ],
  "COQ7": [
    "COQ7 cnv",
    "COQ7 methyl",
    "COQ7 proteo",
    "COQ7 rna"
  ],
  "COQ8A": [
    "COQ8A cnv",
    "COQ8A kinase",
    "COQ8A methyl",
    "COQ8A proteo",
    "COQ8A rna"
  ],
  "COQ8B": [
    "COQ8B cnv",
    "COQ8B kinase",
    "COQ8B methyl",
    "COQ8B proteo",
    "COQ8B rna"
  ],
  "COQ9": [
    "COQ9 cnv",
    "COQ9 methyl",
    "COQ9 proteo",
    "COQ9 rna"
  ],
  "CORIN": [
    "CORIN cnv",
    "CORIN methyl",
    "CORIN rna"
  ],
  "CORO1A": [
    "CORO1A cnv",
    "CORO1A methyl",
    "CORO1A proteo",
    "CORO1A rna"
  ],
  "CORO1B": [
    "CORO1B cnv",
    "CORO1B methyl",
    "CORO1B proteo",
    "CORO1B rna"
  ],
  "CORO1C": [
    "CORO1C cnv",
    "CORO1C methyl",
    "CORO1C proteo",
    "CORO1C rna"
  ],
  "CORO2A": [
    "CORO2A cnv",
    "CORO2A proteo",
    "CORO2A rna"
  ],
  "CORO2B": [
    "CORO2B cnv",
    "CORO2B methyl",
    "CORO2B proteo",
    "CORO2B rna"
  ],
  "CORO6": [
    "CORO6 cnv",
    "CORO6 methyl",
    "CORO6 rna"
  ],
  "CORO7": [
    "CORO7 915_915_1_1_S915 phospho",
    "CORO7 cnv",
    "CORO7 methyl",
    "CORO7 proteo",
    "CORO7 rna"
  ],
  "CORO7-PAM16": [
    "CORO7-PAM16 cnv",
    "CORO7-PAM16 methyl",
    "CORO7-PAM16 rna"
  ],
  "CORT": [
    "CORT cnv",
    "CORT rna"
  ],
  "COSMOC": [
    "COSMOC methyl"
  ],
  "COTL1": [
    "COTL1 137_141_1_1_T141 phospho",
    "COTL1 cnv",
    "COTL1 methyl",
    "COTL1 proteo",
    "COTL1 rna"
  ],
  "COX10": [
    "COX10 cnv",
    "COX10 methyl",
    "COX10 rna"
  ],
  "COX10-DT": [
    "COX10-DT methyl"
  ],
  "COX11": [
    "COX11 cnv",
    "COX11 methyl",
    "COX11 rna"
  ],
  "COX14": [
    "COX14 cnv",
    "COX14 methyl",
    "COX14 rna"
  ],
  "COX15": [
    "COX15 cnv",
    "COX15 methyl",
    "COX15 proteo",
    "COX15 rna"
  ],
  "COX16": [
    "COX16 cnv",
    "COX16 methyl",
    "COX16 rna"
  ],
  "COX17": [
    "COX17 cnv",
    "COX17 methyl",
    "COX17 proteo",
    "COX17 rna"
  ],
  "COX18": [
    "COX18 cnv",
    "COX18 methyl",
    "COX18 proteo",
    "COX18 rna"
  ],
  "COX19": [
    "COX19 cnv",
    "COX19 methyl",
    "COX19 proteo",
    "COX19 rna"
  ],
  "COX20": [
    "COX20 cnv",
    "COX20 methyl",
    "COX20 proteo",
    "COX20 rna"
  ],
  "COX4I1": [
    "COX4I1 cnv",
    "COX4I1 methyl",
    "COX4I1 proteo",
    "COX4I1 rna"
  ],
  "COX4I2": [
    "COX4I2 cnv",
    "COX4I2 methyl",
    "COX4I2 rna"
  ],
  "COX5A": [
    "COX5A cnv",
    "COX5A methyl",
    "COX5A proteo",
    "COX5A rna"
  ],
  "COX5B": [
    "COX5B cnv",
    "COX5B methyl",
    "COX5B proteo",
    "COX5B rna"
  ],
  "COX6A1": [
    "COX6A1 cnv",
    "COX6A1 methyl",
    "COX6A1 proteo",
    "COX6A1 rna"
  ],
  "COX6A2": [
    "COX6A2 cnv",
    "COX6A2 methyl",
    "COX6A2 rna"
  ],
  "COX6B1": [
    "COX6B1 cnv",
    "COX6B1 proteo",
    "COX6B1 rna"
  ],
  "COX6B2": [
    "COX6B2 cnv",
    "COX6B2 methyl",
    "COX6B2 rna"
  ],
  "COX6C": [
    "COX6C cnv",
    "COX6C methyl",
    "COX6C proteo",
    "COX6C rna"
  ],
  "COX7A1": [
    "COX7A1 cnv",
    "COX7A1 methyl",
    "COX7A1 rna"
  ],
  "COX7A2": [
    "COX7A2 cnv",
    "COX7A2 proteo",
    "COX7A2 rna"
  ],
  "COX7A2L": [
    "COX7A2L cnv",
    "COX7A2L methyl",
    "COX7A2L proteo",
    "COX7A2L rna"
  ],
  "COX7B": [
    "COX7B proteo",
    "COX7B rna"
  ],
  "COX7B2": [
    "COX7B2 cnv"
  ],
  "COX7C": [
    "COX7C cnv",
    "COX7C proteo",
    "COX7C rna"
  ],
  "COX8A": [
    "COX8A cnv",
    "COX8A methyl",
    "COX8A proteo",
    "COX8A rna"
  ],
  "COX8C": [
    "COX8C cnv",
    "COX8C methyl",
    "COX8C rna"
  ],
  "CP": [
    "CP AGLQAFFQVQECNK-N3H4F0S1G0 glyco",
    "CP AGLQAFFQVQECNK-N4H5F0S0G0 glyco",
    "CP AGLQAFFQVQECNK-N4H5F0S1G0 glyco",
    "CP AGLQAFFQVQECNK-N4H5F0S2G0 glyco",
    "CP AGLQAFFQVQECNK-N4H5F1S1G0 glyco",
    "CP AGLQAFFQVQECNK-N4H5F1S2G0 glyco",
    "CP AGLQAFFQVQECNK-N5H5F1S1G0 glyco",
    "CP EHEGAIYPDNTTDFQR-N4H5F0S1G0 glyco",
    "CP EHEGAIYPDNTTDFQR-N4H5F0S2G0 glyco",
    "CP EHEGAIYPDNTTDFQR-N4H5F1S2G0 glyco",
    "CP EHEGAIYPDNTTDFQR-N5H6F0S3G0 glyco",
    "CP ELHHLQEQNVSNAFLDK-N4H5F0S2G0 glyco",
    "CP ELHHLQEQNVSNAFLDK-N4H5F1S2G0 glyco",
    "CP ELHHLQEQNVSNAFLDK-N5H6F0S3G0 glyco",
    "CP ELHHLQEQNVSNAFLDK-N5H6F1S3G0 glyco",
    "CP ELHHLQEQNVSNAFLDK-N5H6F2S2G0 glyco",
    "CP ELHHLQEQNVSNAFLDKGEFYIGSK-N4H5F0S2G0 glyco",
    "CP ELHHLQEQNVSNAFLDKGEFYIGSK-N4H5F1S2G0 glyco",
    "CP ELHHLQEQNVSNAFLDKGEFYIGSK-N4H5F2S1G0 glyco",
    "CP ELHHLQEQNVSNAFLDKGEFYIGSK-N6H3F5S0G0 glyco",
    "CP ENLTAPGSDSAVFFEQGTTR-N4H5F0S1G0 glyco",
    "CP ENLTAPGSDSAVFFEQGTTR-N4H5F0S2G0 glyco",
    "CP ENLTAPGSDSAVFFEQGTTR-N4H5F1S2G0 glyco",
    "CP ENLTAPGSDSAVFFEQGTTR-N4H5F2S1G0 glyco",
    "CP cnv",
    "CP proteo",
    "CP rna"
  ],
  "CPA1": [
    "CPA1 cnv",
    "CPA1 methyl",
    "CPA1 rna"
  ],
  "CPA2": [
    "CPA2 cnv",
    "CPA2 rna"
  ],
  "CPA3": [
    "CPA3 cnv",
    "CPA3 rna"
  ],
  "CPA4": [
    "CPA4 cnv",
    "CPA4 rna"
  ],
  "CPA5": [
    "CPA5 cnv",
    "CPA5 rna"
  ],
  "CPA6": [
    "CPA6 cnv",
    "CPA6 rna"
  ],
  "CPAMD8": [
    "CPAMD8 cnv",
    "CPAMD8 methyl",
    "CPAMD8 rna"
  ],
  "CPB1": [
    "CPB1 cnv",
    "CPB1 rna"
  ],
  "CPB2": [
    "CPB2 QVHFFVNASDVDNVK-N4H5F0S2G0 glyco",
    "CPB2 cnv",
    "CPB2 proteo",
    "CPB2 rna"
  ],
  "CPB2-AS1": [
    "CPB2-AS1 methyl"
  ],
  "CPD": [
    "CPD 1358_1378_2_2_T1368T1370 phospho",
    "CPD GILNATISVAEINHPVTTYK-N2H5F0S0G0 glyco",
    "CPD SEGAIQVNFTLVR-N2H5F0S0G0 glyco",
    "CPD SEGAIQVNFTLVR-N2H6F0S0G0 glyco",
    "CPD SEGAIQVNFTLVR-N2H7F0S0G0 glyco",
    "CPD cnv",
    "CPD methyl",
    "CPD proteo",
    "CPD rna"
  ],
  "CPE": [
    "CPE DLQGNPIANATISVEGIDHDVTSAK-N2H5F0S0G0 glyco",
    "CPE GNETIVNLIHSTR-N2H5F0S0G0 glyco",
    "CPE GNETIVNLIHSTR-N2H6F0S0G0 glyco",
    "CPE GNETIVNLIHSTR-N2H7F0S0G0 glyco",
    "CPE cnv",
    "CPE methyl",
    "CPE proteo",
    "CPE rna"
  ],
  "CPEB1": [
    "CPEB1 cnv",
    "CPEB1 methyl",
    "CPEB1 rna"
  ],
  "CPEB1-AS1": [
    "CPEB1-AS1 methyl"
  ],
  "CPEB2": [
    "CPEB2 526_529_1_1_S526 phospho",
    "CPEB2 cnv",
    "CPEB2 methyl",
    "CPEB2 proteo",
    "CPEB2 rna"
  ],
  "CPEB2-DT": [
    "CPEB2-DT methyl"
  ],
  "CPEB3": [
    "CPEB3 192_201_1_1_S192 phospho",
    "CPEB3 192_201_1_1_S195 phospho",
    "CPEB3 cnv",
    "CPEB3 methyl",
    "CPEB3 proteo",
    "CPEB3 rna"
  ],
  "CPEB4": [
    "CPEB4 115_124_1_1_S124 phospho",
    "CPEB4 252_262_1_1_S252 phospho",
    "CPEB4 97_110_1_0 phospho",
    "CPEB4 97_110_1_1_S99 phospho",
    "CPEB4 cnv",
    "CPEB4 methyl",
    "CPEB4 proteo",
    "CPEB4 rna"
  ],
  "CPED1": [
    "CPED1 cnv",
    "CPED1 rna"
  ],
  "CPHXL": [
    "CPHXL cnv",
    "CPHXL rna"
  ],
  "CPHXL2": [
    "CPHXL2 cnv",
    "CPHXL2 rna"
  ],
  "CPLANE1": [
    "CPLANE1 cnv",
    "CPLANE1 methyl",
    "CPLANE1 rna"
  ],
  "CPLANE2": [
    "CPLANE2 cnv",
    "CPLANE2 methyl",
    "CPLANE2 rna"
  ],
  "CPLX1": [
    "CPLX1 cnv",
    "CPLX1 methyl",
    "CPLX1 proteo",
    "CPLX1 rna"
  ],
  "CPLX2": [
    "CPLX2 cnv",
    "CPLX2 methyl",
    "CPLX2 proteo",
    "CPLX2 rna"
  ],
  "CPLX3": [
    "CPLX3 cnv",
    "CPLX3 proteo",
    "CPLX3 rna"
  ],
  "CPLX4": [
    "CPLX4 cnv",
    "CPLX4 rna"
  ],
  "CPM": [
    "CPM TVAQNYSSVTHLHSIGK-N5H3F1S0G0 glyco",
    "CPM cnv",
    "CPM methyl",
    "CPM proteo",
    "CPM rna"
  ],
  "CPN1": [
    "CPN1 cnv",
    "CPN1 methyl",
    "CPN1 proteo"
  ],
  "CPN2": [
    "CPN2 AFGSNPNLTK-N3H4F0S1G0 glyco",
    "CPN2 AFGSNPNLTK-N4H5F0S1G0 glyco",
    "CPN2 AFGSNPNLTK-N4H5F0S2G0 glyco",
    "CPN2 AFGSNPNLTK-N5H6F0S3G0 glyco",
    "CPN2 cnv",
    "CPN2 proteo",
    "CPN2 rna"
  ],
  "CPNE1": [
    "CPNE1 59_64_1_1_S60 phospho",
    "CPNE1 cnv",
    "CPNE1 methyl",
    "CPNE1 proteo",
    "CPNE1 rna"
  ],
  "CPNE2": [
    "CPNE2 cnv",
    "CPNE2 methyl",
    "CPNE2 proteo",
    "CPNE2 rna"
  ],
  "CPNE3": [
    "CPNE3 14_14_1_1_S14 phospho",
    "CPNE3 240_243_1_0 phospho",
    "CPNE3 240_243_1_1_S243 phospho",
    "CPNE3 242_243_1_1_S243 phospho",
    "CPNE3 cnv",
    "CPNE3 methyl",
    "CPNE3 proteo",
    "CPNE3 rna"
  ],
  "CPNE4": [
    "CPNE4 cnv",
    "CPNE4 methyl",
    "CPNE4 proteo",
    "CPNE4 rna"
  ],
  "CPNE5": [
    "CPNE5 573_579_1_1_S575 phospho",
    "CPNE5 573_579_2_2_S575S579 phospho",
    "CPNE5 583_591_1_1_S587 phospho",
    "CPNE5 97_107_1_1_S103 phospho",
    "CPNE5 cnv",
    "CPNE5 methyl",
    "CPNE5 proteo",
    "CPNE5 rna"
  ],
  "CPNE6": [
    "CPNE6 154_155_1_1_S155 phospho",
    "CPNE6 377_385_1_1_S385 phospho",
    "CPNE6 588_611_1_1_S611 phospho",
    "CPNE6 603_611_1_1_S611 phospho",
    "CPNE6 cnv",
    "CPNE6 proteo",
    "CPNE6 rna"
  ],
  "CPNE7": [
    "CPNE7 619_632_1_1_T632 phospho",
    "CPNE7 cnv",
    "CPNE7 methyl",
    "CPNE7 proteo",
    "CPNE7 rna"
  ],
  "CPNE8": [
    "CPNE8 547_562_1_1_T554 phospho",
    "CPNE8 cnv",
    "CPNE8 methyl",
    "CPNE8 proteo",
    "CPNE8 rna"
  ],
  "CPNE9": [
    "CPNE9 cnv",
    "CPNE9 methyl",
    "CPNE9 rna"
  ],
  "CPO": [
    "CPO cnv",
    "CPO rna"
  ],
  "CPOX": [
    "CPOX cnv",
    "CPOX methyl",
    "CPOX proteo",
    "CPOX rna"
  ],
  "CPPED1": [
    "CPPED1 cnv",
    "CPPED1 methyl",
    "CPPED1 proteo",
    "CPPED1 rna"
  ],
  "CPQ": [
    "CPQ IVVYNQPYINYSR-N2H3F1S0G0 glyco",
    "CPQ IVVYNQPYINYSR-N2H5F1S0G0 glyco",
    "CPQ IVVYNQPYINYSR-N2H6F0S0G0 glyco",
    "CPQ IVVYNQPYINYSR-N2H6F1S0G0 glyco",
    "CPQ IVVYNQPYINYSR-N2H7F0S0G0 glyco",
    "CPQ cnv",
    "CPQ methyl",
    "CPQ proteo",
    "CPQ rna"
  ],
  "CPS1": [
    "CPS1 cnv",
    "CPS1 methyl",
    "CPS1 proteo",
    "CPS1 rna"
  ],
  "CPSF1": [
    "CPSF1 cnv",
    "CPSF1 methyl",
    "CPSF1 proteo",
    "CPSF1 rna"
  ],
  "CPSF2": [
    "CPSF2 cnv",
    "CPSF2 methyl",
    "CPSF2 proteo",
    "CPSF2 rna"
  ],
  "CPSF3": [
    "CPSF3 640_644_1_1_T644 phospho",
    "CPSF3 cnv",
    "CPSF3 methyl",
    "CPSF3 proteo",
    "CPSF3 rna"
  ],
  "CPSF4": [
    "CPSF4 200_212_1_1_S202 phospho",
    "CPSF4 200_212_1_1_S212 phospho",
    "CPSF4 cnv",
    "CPSF4 methyl",
    "CPSF4 proteo",
    "CPSF4 rna"
  ],
  "CPSF4L": [
    "CPSF4L cnv",
    "CPSF4L rna"
  ],
  "CPSF6": [
    "CPSF6 441_447_1_1_T444 phospho",
    "CPSF6 cnv",
    "CPSF6 methyl",
    "CPSF6 proteo",
    "CPSF6 rna"
  ],
  "CPSF7": [
    "CPSF7 191_212_3_3_S194S197T203 phospho",
    "CPSF7 194_212_1_1_T203 phospho",
    "CPSF7 46_60_1_1_S60 phospho",
    "CPSF7 60_60_1_1_S60 phospho",
    "CPSF7 cnv",
    "CPSF7 methyl",
    "CPSF7 proteo",
    "CPSF7 rna"
  ],
  "CPT1A": [
    "CPT1A cnv",
    "CPT1A methyl",
    "CPT1A proteo",
    "CPT1A rna"
  ],
  "CPT1B": [
    "CPT1B cnv",
    "CPT1B methyl",
    "CPT1B rna"
  ],
  "CPT1C": [
    "CPT1C cnv",
    "CPT1C methyl",
    "CPT1C proteo",
    "CPT1C rna"
  ],
  "CPT2": [
    "CPT2 cnv",
    "CPT2 methyl",
    "CPT2 proteo",
    "CPT2 rna"
  ],
  "CPTP": [
    "CPTP cnv",
    "CPTP methyl",
    "CPTP proteo",
    "CPTP rna"
  ],
  "CPVL": [
    "CPVL QAIHVGNQTFNDGTIVEK-N2H3F0S0G0 glyco",
    "CPVL QAIHVGNQTFNDGTIVEK-N2H3F1S0G0 glyco",
    "CPVL QAIHVGNQTFNDGTIVEK-N2H4F0S0G0 glyco",
    "CPVL QAIHVGNQTFNDGTIVEK-N2H4F1S0G0 glyco",
    "CPVL QAIHVGNQTFNDGTIVEK-N2H5F0S0G0 glyco",
    "CPVL QAIHVGNQTFNDGTIVEK-N2H5F1S0G0 glyco",
    "CPVL QAIHVGNQTFNDGTIVEK-N2H6F0S0G0 glyco",
    "CPVL QAIHVGNQTFNDGTIVEK-N2H7F0S0G0 glyco",
    "CPVL SYAGFLTVNK-N2H3F0S0G0 glyco",
    "CPVL SYAGFLTVNK-N2H4F0S0G0 glyco",
    "CPVL SYAGFLTVNK-N2H5F0S0G0 glyco",
    "CPVL SYAGFLTVNK-N2H6F0S0G0 glyco",
    "CPVL SYAGFLTVNK-N2H7F0S0G0 glyco",
    "CPVL SYAGFLTVNK-N3H6F0S1G0 glyco",
    "CPVL cnv",
    "CPVL methyl",
    "CPVL proteo",
    "CPVL rna"
  ],
  "CPXCR1": [
    "CPXCR1 rna"
  ],
  "CPXM1": [
    "CPXM1 cnv",
    "CPXM1 methyl",
    "CPXM1 proteo",
    "CPXM1 rna"
  ],
  "CPXM2": [
    "CPXM2 cnv",
    "CPXM2 methyl",
    "CPXM2 rna"
  ],
  "CPZ": [
    "CPZ cnv",
    "CPZ methyl",
    "CPZ rna"
  ],
  "CR1": [
    "CR1 cnv",
    "CR1 rna"
  ],
  "CR1L": [
    "CR1L cnv",
    "CR1L methyl",
    "CR1L rna"
  ],
  "CR2": [
    "CR2 cnv",
    "CR2 methyl",
    "CR2 rna"
  ],
  "CRABP1": [
    "CRABP1 cnv",
    "CRABP1 methyl",
    "CRABP1 proteo",
    "CRABP1 rna"
  ],
  "CRABP2": [
    "CRABP2 cnv",
    "CRABP2 methyl",
    "CRABP2 proteo",
    "CRABP2 rna"
  ],
  "CRACD": [
    "CRACD 1017_1017_1_1_S1017 phospho",
    "CRACD 1072_1076_1_1_S1072 phospho",
    "CRACD 132_139_1_0 phospho",
    "CRACD 920_926_1_1_S920 phospho",
    "CRACD 968_978_1_1_T971 phospho",
    "CRACD 96_113_1_1_S104 phospho",
    "CRACD cnv",
    "CRACD methyl",
    "CRACD proteo",
    "CRACD rna"
  ],
  "CRACDL": [
    "CRACDL 154_178_1_1_S163 phospho",
    "CRACDL 182_195_1_1_S185 phospho",
    "CRACDL 356_356_1_1_S356 phospho",
    "CRACDL 481_490_1_1_S490 phospho",
    "CRACDL 603_609_1_1_S609 phospho",
    "CRACDL 68_82_1_1_S75 phospho",
    "CRACDL 881_885_1_1_S881 phospho",
    "CRACDL 910_919_1_0 phospho",
    "CRACDL 910_919_1_1_S912 phospho",
    "CRACDL 92_106_1_1_S92 phospho",
    "CRACDL cnv",
    "CRACDL methyl",
    "CRACDL proteo",
    "CRACDL rna"
  ],
  "CRACR2A": [
    "CRACR2A 473_492_1_1_S473 phospho",
    "CRACR2A cnv",
    "CRACR2A methyl",
    "CRACR2A rna"
  ],
  "CRACR2B": [
    "CRACR2B 392_397_1_1_S392 phospho",
    "CRACR2B cnv",
    "CRACR2B methyl",
    "CRACR2B rna"
  ],
  "CRADD": [
    "CRADD cnv",
    "CRADD methyl",
    "CRADD proteo",
    "CRADD rna"
  ],
  "CRAMP1": [
    "CRAMP1 70_75_1_1_S70 phospho",
    "CRAMP1 cnv",
    "CRAMP1 methyl",
    "CRAMP1 rna"
  ],
  "CRAT": [
    "CRAT cnv",
    "CRAT methyl",
    "CRAT proteo",
    "CRAT rna"
  ],
  "CRB1": [
    "CRB1 cnv",
    "CRB1 rna"
  ],
  "CRB2": [
    "CRB2 cnv",
    "CRB2 proteo",
    "CRB2 rna"
  ],
  "CRB3": [
    "CRB3 cnv",
    "CRB3 methyl",
    "CRB3 rna"
  ],
  "CRBN": [
    "CRBN cnv",
    "CRBN methyl",
    "CRBN proteo",
    "CRBN rna"
  ],
  "CRCP": [
    "CRCP cnv",
    "CRCP methyl",
    "CRCP proteo",
    "CRCP rna"
  ],
  "CRCT1": [
    "CRCT1 cnv"
  ],
  "CREB1": [
    "CREB1 256_276_1_0 phospho",
    "CREB1 256_276_1_1_S271 phospho",
    "CREB1 336_340_1_1_S340 phospho",
    "CREB1 cnv",
    "CREB1 methyl",
    "CREB1 proteo",
    "CREB1 rna"
  ],
  "CREB3": [
    "CREB3 cnv",
    "CREB3 methyl",
    "CREB3 rna"
  ],
  "CREB3L1": [
    "CREB3L1 cnv",
    "CREB3L1 rna"
  ],
  "CREB3L2": [
    "CREB3L2 cnv",
    "CREB3L2 methyl",
    "CREB3L2 rna"
  ],
  "CREB3L3": [
    "CREB3L3 cnv",
    "CREB3L3 rna"
  ],
  "CREB3L4": [
    "CREB3L4 cnv",
    "CREB3L4 methyl",
    "CREB3L4 rna"
  ],
  "CREB5": [
    "CREB5 cnv",
    "CREB5 methyl",
    "CREB5 proteo",
    "CREB5 rna"
  ],
  "CREBBP": [
    "CREBBP cnv",
    "CREBBP methyl",
    "CREBBP proteo",
    "CREBBP rna"
  ],
  "CREBL2": [
    "CREBL2 cnv",
    "CREBL2 rna"
  ],
  "CREBRF": [
    "CREBRF cnv",
    "CREBRF methyl",
    "CREBRF rna"
  ],
  "CREBZF": [
    "CREBZF cnv",
    "CREBZF methyl",
    "CREBZF rna"
  ],
  "CREG1": [
    "CREG1 VNETEMDIAK-N2H5F0S0G0 glyco",
    "CREG1 VNETEMDIAK-N2H6F0S0G0 glyco",
    "CREG1 VNETEMDIAK-N2H7F0S0G0 glyco",
    "CREG1 cnv",
    "CREG1 methyl",
    "CREG1 proteo",
    "CREG1 rna"
  ],
  "CREG2": [
    "CREG2 cnv",
    "CREG2 methyl",
    "CREG2 rna"
  ],
  "CRELD1": [
    "CRELD1 cnv",
    "CRELD1 methyl",
    "CRELD1 proteo",
    "CRELD1 rna"
  ],
  "CRELD2": [
    "CRELD2 NANGSYTCEECDSSCVGCTGEGPGNCK-N2H6F0S0G0 glyco",
    "CRELD2 cnv",
    "CRELD2 methyl",
    "CRELD2 proteo",
    "CRELD2 rna"
  ],
  "CREM": [
    "CREM 196_223_1_1_S208 phospho",
    "CREM cnv",
    "CREM methyl",
    "CREM rna"
  ],
  "CRH": [
    "CRH cnv",
    "CRH rna"
  ],
  "CRHBP": [
    "CRHBP NCSFSIIYPVVIK-N2H5F0S0G0 glyco",
    "CRHBP cnv",
    "CRHBP proteo",
    "CRHBP rna"
  ],
  "CRHR1": [
    "CRHR1 cnv",
    "CRHR1 methyl",
    "CRHR1 rna"
  ],
  "CRHR2": [
    "CRHR2 cnv",
    "CRHR2 methyl",
    "CRHR2 rna"
  ],
  "CRIM1": [
    "CRIM1 cnv",
    "CRIM1 methyl",
    "CRIM1 proteo",
    "CRIM1 rna"
  ],
  "CRIP1": [
    "CRIP1 cnv",
    "CRIP1 methyl",
    "CRIP1 proteo",
    "CRIP1 rna"
  ],
  "CRIP2": [
    "CRIP2 185_199_1_1_S185 phospho",
    "CRIP2 cnv",
    "CRIP2 methyl",
    "CRIP2 proteo",
    "CRIP2 rna"
  ],
  "CRIP3": [
    "CRIP3 cnv",
    "CRIP3 methyl",
    "CRIP3 rna"
  ],
  "CRIPT": [
    "CRIPT cnv",
    "CRIPT methyl",
    "CRIPT proteo",
    "CRIPT rna"
  ],
  "CRISP1": [
    "CRISP1 cnv"
  ],
  "CRISP2": [
    "CRISP2 cnv",
    "CRISP2 rna"
  ],
  "CRISP3": [
    "CRISP3 cnv",
    "CRISP3 proteo",
    "CRISP3 rna"
  ],
  "CRISPLD1": [
    "CRISPLD1 cnv",
    "CRISPLD1 methyl",
    "CRISPLD1 proteo",
    "CRISPLD1 rna"
  ],
  "CRISPLD2": [
    "CRISPLD2 cnv",
    "CRISPLD2 methyl",
    "CRISPLD2 rna"
  ],
  "CRK": [
    "CRK 40_55_1_0 phospho",
    "CRK 40_55_1_1_S41 phospho",
    "CRK 58_85_1_1_S74 phospho",
    "CRK 58_85_1_1_S83 phospho",
    "CRK cnv",
    "CRK methyl",
    "CRK proteo",
    "CRK rna"
  ],
  "CRKL": [
    "CRKL 105_127_1_0 phospho",
    "CRKL 105_127_1_1_S107 phospho",
    "CRKL 195_233_1_0 phospho",
    "CRKL 195_233_1_1_Y207 phospho",
    "CRKL cnv",
    "CRKL methyl",
    "CRKL proteo",
    "CRKL rna"
  ],
  "CRLF1": [
    "CRLF1 cnv",
    "CRLF1 methyl",
    "CRLF1 proteo",
    "CRLF1 rna"
  ],
  "CRLF2": [
    "CRLF2 rna"
  ],
  "CRLF3": [
    "CRLF3 cnv",
    "CRLF3 methyl",
    "CRLF3 proteo",
    "CRLF3 rna"
  ],
  "CRLS1": [
    "CRLS1 cnv",
    "CRLS1 methyl",
    "CRLS1 rna"
  ],
  "CRMP1": [
    "CRMP1 10_27_1_1_T27 phospho",
    "CRMP1 613_623_1_1_T623 phospho",
    "CRMP1 613_623_1_1_Y618 phospho",
    "CRMP1 613_632_1_1_T623 phospho",
    "CRMP1 626_632_1_1_T628 phospho",
    "CRMP1 626_632_2_2_T628S632 phospho",
    "CRMP1 626_638_1_1_S636 phospho",
    "CRMP1 626_638_2_2_S635S636 phospho",
    "CRMP1 635_638_1_0 phospho",
    "CRMP1 635_638_1_1_S636 phospho",
    "CRMP1 651_656_1_1_S656 phospho",
    "CRMP1 cnv",
    "CRMP1 methyl",
    "CRMP1 proteo",
    "CRMP1 rna"
  ],
  "CRNKL1": [
    "CRNKL1 cnv",
    "CRNKL1 methyl",
    "CRNKL1 proteo",
    "CRNKL1 rna"
  ],
  "CRNN": [
    "CRNN cnv",
    "CRNN rna"
  ],
  "CROCC": [
    "CROCC 1451_1460_1_1_S1451 phospho",
    "CROCC 1451_1460_1_1_S1460 phospho",
    "CROCC 1660_1660_1_1_S1660 phospho",
    "CROCC 2004_2012_1_1_S2005 phospho",
    "CROCC 462_473_1_1_S462 phospho",
    "CROCC 488_494_2_2_T492S494 phospho",
    "CROCC 492_494_2_2_T492S494 phospho",
    "CROCC 512_526_1_1_S512 phospho",
    "CROCC cnv",
    "CROCC proteo",
    "CROCC rna"
  ],
  "CROCC2": [
    "CROCC2 cnv",
    "CROCC2 rna"
  ],
  "CROCCP2": [
    "CROCCP2 methyl"
  ],
  "CROCCP3": [
    "CROCCP3 methyl"
  ],
  "CROT": [
    "CROT cnv",
    "CROT methyl",
    "CROT proteo",
    "CROT rna"
  ],
  "CRP": [
    "CRP cnv",
    "CRP proteo",
    "CRP rna"
  ],
  "CRPPA": [
    "CRPPA cnv",
    "CRPPA methyl",
    "CRPPA proteo",
    "CRPPA rna"
  ],
  "CRTAC1": [
    "CRTAC1 cnv",
    "CRTAC1 methyl",
    "CRTAC1 proteo",
    "CRTAC1 rna"
  ],
  "CRTAM": [
    "CRTAM cnv",
    "CRTAM rna"
  ],
  "CRTAP": [
    "CRTAP NCSAAPQPEPAAGLASYPELR-N2H6F0S0G0 glyco",
    "CRTAP NCSAAPQPEPAAGLASYPELR-N2H8F0S0G0 glyco",
    "CRTAP cnv",
    "CRTAP methyl",
    "CRTAP proteo",
    "CRTAP rna"
  ],
  "CRTC1": [
    "CRTC1 149_172_1_0 phospho",
    "CRTC1 149_172_1_1_S151 phospho",
    "CRTC1 cnv",
    "CRTC1 methyl",
    "CRTC1 proteo",
    "CRTC1 rna"
  ],
  "CRTC2": [
    "CRTC2 127_142_1_1_S136 phospho",
    "CRTC2 169_199_1_0 phospho",
    "CRTC2 456_475_1_0 phospho",
    "CRTC2 613_628_2_2_S613S624 phospho",
    "CRTC2 cnv",
    "CRTC2 methyl",
    "CRTC2 proteo",
    "CRTC2 rna"
  ],
  "CRTC3": [
    "CRTC3 320_336_1_1_S329 phospho",
    "CRTC3 391_406_2_2_S391T394 phospho",
    "CRTC3 cnv",
    "CRTC3 methyl",
    "CRTC3 proteo",
    "CRTC3 rna"
  ],
  "CRTC3-AS1": [
    "CRTC3-AS1 methyl"
  ],
  "CRX": [
    "CRX cnv",
    "CRX rna"
  ],
  "CRY1": [
    "CRY1 555_575_1_1_S568 phospho",
    "CRY1 cnv",
    "CRY1 methyl",
    "CRY1 rna"
  ],
  "CRY2": [
    "CRY2 cnv",
    "CRY2 methyl",
    "CRY2 rna"
  ],
  "CRYAA": [
    "CRYAA cnv",
    "CRYAA rna"
  ],
  "CRYAA2": [
    "CRYAA2 cnv",
    "CRYAA2 rna"
  ],
  "CRYAB": [
    "CRYAB 19_21_1_1_S19 phospho",
    "CRYAB 59_66_1_1_S59 phospho",
    "CRYAB 76_76_1_1_S76 phospho",
    "CRYAB 85_85_1_1_S85 phospho",
    "CRYAB cnv",
    "CRYAB proteo",
    "CRYAB rna"
  ],
  "CRYBA1": [
    "CRYBA1 cnv",
    "CRYBA1 rna"
  ],
  "CRYBA2": [
    "CRYBA2 cnv",
    "CRYBA2 methyl",
    "CRYBA2 rna"
  ],
  "CRYBA4": [
    "CRYBA4 cnv",
    "CRYBA4 rna"
  ],
  "CRYBB1": [
    "CRYBB1 cnv",
    "CRYBB1 proteo",
    "CRYBB1 rna"
  ],
  "CRYBB2": [
    "CRYBB2 cnv",
    "CRYBB2 rna"
  ],
  "CRYBB3": [
    "CRYBB3 cnv",
    "CRYBB3 rna"
  ],
  "CRYBG1": [
    "CRYBG1 cnv",
    "CRYBG1 methyl",
    "CRYBG1 proteo",
    "CRYBG1 rna"
  ],
  "CRYBG2": [
    "CRYBG2 cnv",
    "CRYBG2 methyl",
    "CRYBG2 rna"
  ],
  "CRYBG3": [
    "CRYBG3 1966_1971_1_1_S1966 phospho",
    "CRYBG3 2890_2902_1_1_T2902 phospho",
    "CRYBG3 395_395_1_1_S395 phospho",
    "CRYBG3 918_931_1_1_S931 phospho",
    "CRYBG3 cnv",
    "CRYBG3 methyl",
    "CRYBG3 proteo",
    "CRYBG3 rna"
  ],
  "CRYGA": [
    "CRYGA cnv",
    "CRYGA rna"
  ],
  "CRYGB": [
    "CRYGB cnv"
  ],
  "CRYGC": [
    "CRYGC cnv"
  ],
  "CRYGD": [
    "CRYGD cnv",
    "CRYGD methyl",
    "CRYGD rna"
  ],
  "CRYGN": [
    "CRYGN cnv",
    "CRYGN methyl",
    "CRYGN rna"
  ],
  "CRYGS": [
    "CRYGS cnv",
    "CRYGS proteo",
    "CRYGS rna"
  ],
  "CRYL1": [
    "CRYL1 cnv",
    "CRYL1 methyl",
    "CRYL1 proteo",
    "CRYL1 rna"
  ],
  "CRYM": [
    "CRYM cnv",
    "CRYM methyl",
    "CRYM proteo",
    "CRYM rna"
  ],
  "CRYZ": [
    "CRYZ cnv",
    "CRYZ proteo",
    "CRYZ rna"
  ],
  "CRYZL1": [
    "CRYZL1 cnv",
    "CRYZL1 methyl",
    "CRYZL1 proteo",
    "CRYZL1 rna"
  ],
  "CRYZL2P": [
    "CRYZL2P methyl"
  ],
  "CRYZL2P-SEC16B": [
    "CRYZL2P-SEC16B cnv",
    "CRYZL2P-SEC16B rna"
  ],
  "CS": [
    "CS cnv",
    "CS methyl",
    "CS proteo",
    "CS rna"
  ],
  "CSAD": [
    "CSAD cnv",
    "CSAD methyl",
    "CSAD proteo",
    "CSAD rna"
  ],
  "CSAG1": [
    "CSAG1 rna"
  ],
  "CSAG2": [
    "CSAG2 rna"
  ],
  "CSAG3": [
    "CSAG3 rna"
  ],
  "CSDC2": [
    "CSDC2 47_51_1_1_S47 phospho",
    "CSDC2 cnv",
    "CSDC2 proteo",
    "CSDC2 rna"
  ],
  "CSDE1": [
    "CSDE1 162_176_1_1_S169 phospho",
    "CSDE1 463_470_1_1_S465 phospho",
    "CSDE1 628_644_1_1_S630 phospho",
    "CSDE1 723_723_1_1_T723 phospho",
    "CSDE1 cnv",
    "CSDE1 proteo",
    "CSDE1 rna"
  ],
  "CSE1L": [
    "CSE1L 931_931_1_1_S931 phospho",
    "CSE1L cnv",
    "CSE1L methyl",
    "CSE1L proteo",
    "CSE1L rna"
  ],
  "CSE1L-DT": [
    "CSE1L-DT methyl"
  ],
  "CSF1": [
    "CSF1 cnv",
    "CSF1 methyl",
    "CSF1 rna"
  ],
  "CSF1R": [
    "CSF1R VLTLNLDQVDFQHAGNYSCVASNVQGK-N4H5F0S1G0 glyco",
    "CSF1R VLTLNLDQVDFQHAGNYSCVASNVQGK-N4H5F1S1G0 glyco",
    "CSF1R cnv",
    "CSF1R kinase",
    "CSF1R proteo",
    "CSF1R rna"
  ],
  "CSF2": [
    "CSF2 cnv",
    "CSF2 rna"
  ],
  "CSF2RA": [
    "CSF2RA NYFLVNGTSR-N2H6F0S0G0 glyco",
    "CSF2RA rna"
  ],
  "CSF2RB": [
    "CSF2RB cnv",
    "CSF2RB rna"
  ],
  "CSF3": [
    "CSF3 cnv",
    "CSF3 rna"
  ],
  "CSF3R": [
    "CSF3R cnv",
    "CSF3R rna"
  ],
  "CSGALNACT1": [
    "CSGALNACT1 cnv",
    "CSGALNACT1 methyl",
    "CSGALNACT1 rna"
  ],
  "CSGALNACT2": [
    "CSGALNACT2 cnv",
    "CSGALNACT2 methyl",
    "CSGALNACT2 rna"
  ],
  "CSH1": [
    "CSH1 cnv"
  ],
  "CSH2": [
    "CSH2 cnv",
    "CSH2 rna"
  ],
  "CSHL1": [
    "CSHL1 cnv"
  ],
  "CSK": [
    "CSK cnv",
    "CSK kinase",
    "CSK methyl",
    "CSK proteo",
    "CSK rna"
  ],
  "CSKMT": [
    "CSKMT cnv",
    "CSKMT methyl",
    "CSKMT rna"
  ],
  "CSMD1": [
    "CSMD1 cnv",
    "CSMD1 methyl",
    "CSMD1 proteo",
    "CSMD1 rna"
  ],
  "CSMD2": [
    "CSMD2 IINCTDPGHQENSVR-N2H5F0S0G0 glyco",
    "CSMD2 cnv",
    "CSMD2 methyl",
    "CSMD2 proteo",
    "CSMD2 rna"
  ],
  "CSMD3": [
    "CSMD3 cnv",
    "CSMD3 proteo",
    "CSMD3 rna"
  ],
  "CSN1S1": [
    "CSN1S1 cnv",
    "CSN1S1 rna"
  ],
  "CSN2": [
    "CSN2 cnv"
  ],
  "CSN3": [
    "CSN3 cnv"
  ],
  "CSNK1A1": [
    "CSNK1A1 311_323_1_1_T321 phospho",
    "CSNK1A1 339_351_1_1_T349 phospho",
    "CSNK1A1 cnv",
    "CSNK1A1 kinase",
    "CSNK1A1 methyl",
    "CSNK1A1 proteo",
    "CSNK1A1 rna"
  ],
  "CSNK1A1L": [
    "CSNK1A1L cnv",
    "CSNK1A1L kinase",
    "CSNK1A1L rna"
  ],
  "CSNK1D": [
    "CSNK1D 337_361_1_0 phospho",
    "CSNK1D cnv",
    "CSNK1D kinase",
    "CSNK1D methyl",
    "CSNK1D proteo",
    "CSNK1D rna"
  ],
  "CSNK1E": [
    "CSNK1E cnv",
    "CSNK1E kinase",
    "CSNK1E methyl",
    "CSNK1E rna"
  ],
  "CSNK1G1": [
    "CSNK1G1 cnv",
    "CSNK1G1 kinase",
    "CSNK1G1 methyl",
    "CSNK1G1 proteo",
    "CSNK1G1 rna"
  ],
  "CSNK1G2": [
    "CSNK1G2 cnv",
    "CSNK1G2 kinase",
    "CSNK1G2 methyl",
    "CSNK1G2 proteo",
    "CSNK1G2 rna"
  ],
  "CSNK1G3": [
    "CSNK1G3 332_345_1_1_S345 phospho",
    "CSNK1G3 365_377_1_0 phospho",
    "CSNK1G3 cnv",
    "CSNK1G3 kinase",
    "CSNK1G3 methyl",
    "CSNK1G3 proteo",
    "CSNK1G3 rna"
  ],
  "CSNK2A1": [
    "CSNK2A1 cnv",
    "CSNK2A1 kinase",
    "CSNK2A1 methyl",
    "CSNK2A1 proteo",
    "CSNK2A1 rna"
  ],
  "CSNK2A2": [
    "CSNK2A2 cnv",
    "CSNK2A2 kinase",
    "CSNK2A2 methyl",
    "CSNK2A2 proteo",
    "CSNK2A2 rna"
  ],
  "CSNK2A3": [
    "CSNK2A3 cnv",
    "CSNK2A3 kinase",
    "CSNK2A3 rna"
  ],
  "CSNK2B": [
    "CSNK2B 194_206_1_1_S206 phospho",
    "CSNK2B cnv",
    "CSNK2B methyl",
    "CSNK2B proteo",
    "CSNK2B rna"
  ],
  "CSNKA2IP": [
    "CSNKA2IP cnv",
    "CSNKA2IP rna"
  ],
  "CSPG4": [
    "CSPG4 cnv",
    "CSPG4 proteo",
    "CSPG4 rna"
  ],
  "CSPG5": [
    "CSPG5 327_352_1_0 phospho",
    "CSPG5 327_352_1_1_S329 phospho",
    "CSPG5 465_483_1_1_S467 phospho",
    "CSPG5 cnv",
    "CSPG5 methyl",
    "CSPG5 proteo",
    "CSPG5 rna"
  ],
  "CSPP1": [
    "CSPP1 31_31_1_1_S31 phospho",
    "CSPP1 cnv",
    "CSPP1 methyl",
    "CSPP1 rna"
  ],
  "CSRNP1": [
    "CSRNP1 cnv",
    "CSRNP1 methyl",
    "CSRNP1 rna"
  ],
  "CSRNP2": [
    "CSRNP2 cnv",
    "CSRNP2 methyl",
    "CSRNP2 rna"
  ],
  "CSRNP3": [
    "CSRNP3 cnv",
    "CSRNP3 rna"
  ],
  "CSRP1": [
    "CSRP1 186_186_1_1_S186 phospho",
    "CSRP1 cnv",
    "CSRP1 methyl",
    "CSRP1 proteo",
    "CSRP1 rna"
  ],
  "CSRP2": [
    "CSRP2 cnv",
    "CSRP2 methyl",
    "CSRP2 proteo",
    "CSRP2 rna"
  ],
  "CSRP3": [
    "CSRP3 cnv",
    "CSRP3 rna"
  ],
  "CST1": [
    "CST1 cnv",
    "CST1 rna"
  ],
  "CST11": [
    "CST11 cnv"
  ],
  "CST2": [
    "CST2 cnv",
    "CST2 rna"
  ],
  "CST3": [
    "CST3 43_43_1_1_S43 phospho",
    "CST3 cnv",
    "CST3 methyl",
    "CST3 proteo",
    "CST3 rna"
  ],
  "CST4": [
    "CST4 cnv"
  ],
  "CST5": [
    "CST5 cnv"
  ],
  "CST6": [
    "CST6 cnv",
    "CST6 methyl",
    "CST6 rna"
  ],
  "CST7": [
    "CST7 cnv",
    "CST7 rna"
  ],
  "CST8": [
    "CST8 cnv"
  ],
  "CST9": [
    "CST9 cnv",
    "CST9 rna"
  ],
  "CST9L": [
    "CST9L cnv"
  ],
  "CSTA": [
    "CSTA cnv",
    "CSTA rna"
  ],
  "CSTB": [
    "CSTB cnv",
    "CSTB methyl",
    "CSTB proteo",
    "CSTB rna"
  ],
  "CSTF1": [
    "CSTF1 cnv",
    "CSTF1 methyl",
    "CSTF1 proteo",
    "CSTF1 rna"
  ],
  "CSTF2": [
    "CSTF2 103_129_1_0 phospho",
    "CSTF2 298_311_1_1_S302 phospho",
    "CSTF2 527_551_1_1_S544 phospho",
    "CSTF2 methyl",
    "CSTF2 proteo",
    "CSTF2 rna"
  ],
  "CSTF2T": [
    "CSTF2T 557_570_1_1_S563 phospho",
    "CSTF2T cnv",
    "CSTF2T methyl",
    "CSTF2T proteo",
    "CSTF2T rna"
  ],
  "CSTF3": [
    "CSTF3 691_691_1_1_S691 phospho",
    "CSTF3 691_708_1_1_S691 phospho",
    "CSTF3 cnv",
    "CSTF3 methyl",
    "CSTF3 proteo",
    "CSTF3 rna"
  ],
  "CSTF3-DT": [
    "CSTF3-DT methyl"
  ],
  "CSTL1": [
    "CSTL1 cnv",
    "CSTL1 rna"
  ],
  "CSTPP1": [
    "CSTPP1 cnv",
    "CSTPP1 methyl",
    "CSTPP1 rna"
  ],
  "CT45A1": [
    "CT45A1 rna"
  ],
  "CT45A10": [
    "CT45A10 rna"
  ],
  "CT45A3": [
    "CT45A3 rna"
  ],
  "CT45A5": [
    "CT45A5 rna"
  ],
  "CT45A6": [
    "CT45A6 rna"
  ],
  "CT47A12": [
    "CT47A12 rna"
  ],
  "CT55": [
    "CT55 rna"
  ],
  "CT62": [
    "CT62 methyl"
  ],
  "CT66": [
    "CT66 methyl"
  ],
  "CT75": [
    "CT75 methyl"
  ],
  "CTAG1B": [
    "CTAG1B rna"
  ],
  "CTAG2": [
    "CTAG2 rna"
  ],
  "CTAGE1": [
    "CTAGE1 cnv",
    "CTAGE1 rna"
  ],
  "CTAGE15": [
    "CTAGE15 cnv",
    "CTAGE15 rna"
  ],
  "CTAGE4": [
    "CTAGE4 cnv",
    "CTAGE4 rna"
  ],
  "CTAGE6": [
    "CTAGE6 cnv",
    "CTAGE6 rna"
  ],
  "CTAGE8": [
    "CTAGE8 cnv",
    "CTAGE8 rna"
  ],
  "CTAGE9": [
    "CTAGE9 cnv",
    "CTAGE9 rna"
  ],
  "CTBP1": [
    "CTBP1 cnv",
    "CTBP1 methyl",
    "CTBP1 proteo",
    "CTBP1 rna"
  ],
  "CTBP1-AS": [
    "CTBP1-AS methyl"
  ],
  "CTBP2": [
    "CTBP2 927_973_1_1_S968 phospho",
    "CTBP2 cnv",
    "CTBP2 methyl",
    "CTBP2 proteo",
    "CTBP2 rna"
  ],
  "CTBS": [
    "CTBS QINSSISGNLWDK-N2H6F0S0G0 glyco",
    "CTBS cnv",
    "CTBS methyl",
    "CTBS proteo",
    "CTBS rna"
  ],
  "CTC1": [
    "CTC1 cnv",
    "CTC1 methyl",
    "CTC1 rna"
  ],
  "CTCF": [
    "CTCF cnv",
    "CTCF methyl",
    "CTCF proteo",
    "CTCF rna"
  ],
  "CTCF-DT": [
    "CTCF-DT methyl"
  ],
  "CTCFL": [
    "CTCFL cnv",
    "CTCFL methyl",
    "CTCFL rna"
  ],
  "CTDNEP1": [
    "CTDNEP1 cnv",
    "CTDNEP1 methyl",
    "CTDNEP1 proteo",
    "CTDNEP1 rna"
  ],
  "CTDP1": [
    "CTDP1 621_634_1_1_S621 phospho",
    "CTDP1 720_729_1_0 phospho",
    "CTDP1 831_842_2_2_S831S833 phospho",
    "CTDP1 cnv",
    "CTDP1 methyl",
    "CTDP1 proteo",
    "CTDP1 rna"
  ],
  "CTDP1-DT": [
    "CTDP1-DT methyl"
  ],
  "CTDSP1": [
    "CTDSP1 cnv",
    "CTDSP1 methyl",
    "CTDSP1 proteo",
    "CTDSP1 rna"
  ],
  "CTDSP2": [
    "CTDSP2 cnv",
    "CTDSP2 methyl",
    "CTDSP2 rna"
  ],
  "CTDSPL": [
    "CTDSPL cnv",
    "CTDSPL methyl",
    "CTDSPL rna"
  ],
  "CTDSPL2": [
    "CTDSPL2 27_36_1_1_Y27 phospho",
    "CTDSPL2 cnv",
    "CTDSPL2 methyl",
    "CTDSPL2 proteo",
    "CTDSPL2 rna"
  ],
  "CTF1": [
    "CTF1 7_18_1_1_S7 phospho",
    "CTF1 cnv",
    "CTF1 methyl",
    "CTF1 proteo",
    "CTF1 rna"
  ],
  "CTH": [
    "CTH cnv",
    "CTH methyl",
    "CTH proteo",
    "CTH rna"
  ],
  "CTHRC1": [
    "CTHRC1 cnv",
    "CTHRC1 methyl",
    "CTHRC1 proteo",
    "CTHRC1 rna"
  ],
  "CTIF": [
    "CTIF 285_308_1_1_S299 phospho",
    "CTIF cnv",
    "CTIF methyl",
    "CTIF proteo",
    "CTIF rna"
  ],
  "CTLA4": [
    "CTLA4 cnv",
    "CTLA4 rna"
  ],
  "CTNNA1": [
    "CTNNA1 634_645_1_1_S641 phospho",
    "CTNNA1 cnv",
    "CTNNA1 methyl",
    "CTNNA1 proteo",
    "CTNNA1 rna"
  ],
  "CTNNA1-AS1": [
    "CTNNA1-AS1 methyl"
  ],
  "CTNNA2": [
    "CTNNA2 141_151_1_0 phospho",
    "CTNNA2 289_298_1_1_S296 phospho",
    "CTNNA2 569_573_1_1_T569 phospho",
    "CTNNA2 666_681_1_1_S674 phospho",
    "CTNNA2 880_891_1_1_S887 phospho",
    "CTNNA2 925_931_1_1_S925 phospho",
    "CTNNA2 cnv",
    "CTNNA2 methyl",
    "CTNNA2 proteo",
    "CTNNA2 rna"
  ],
  "CTNNA3": [
    "CTNNA3 629_637_1_1_S637 phospho",
    "CTNNA3 647_653_1_1_S650 phospho",
    "CTNNA3 837_837_1_1_S837 phospho",
    "CTNNA3 cnv",
    "CTNNA3 methyl",
    "CTNNA3 proteo",
    "CTNNA3 rna"
  ],
  "CTNNAL1": [
    "CTNNAL1 cnv",
    "CTNNAL1 methyl",
    "CTNNAL1 proteo",
    "CTNNAL1 rna"
  ],
  "CTNNB1": [
    "CTNNB1 179_179_1_1_S179 phospho",
    "CTNNB1 191_196_1_1_S191 phospho",
    "CTNNB1 214_222_1_1_S222 phospho",
    "CTNNB1 551_556_1_0 phospho",
    "CTNNB1 551_556_1_1_S552 phospho",
    "CTNNB1 675_681_1_1_S675 phospho",
    "CTNNB1 715_716_1_1_Y716 phospho",
    "CTNNB1 cnv",
    "CTNNB1 methyl",
    "CTNNB1 proteo",
    "CTNNB1 rna"
  ],
  "CTNNBIP1": [
    "CTNNBIP1 cnv",
    "CTNNBIP1 methyl",
    "CTNNBIP1 proteo",
    "CTNNBIP1 rna"
  ],
  "CTNNBL1": [
    "CTNNBL1 536_545_1_1_S545 phospho",
    "CTNNBL1 cnv",
    "CTNNBL1 methyl",
    "CTNNBL1 proteo",
    "CTNNBL1 rna"
  ],
  "CTNND1": [
    "CTNND1 193_201_1_1_T201 phospho",
    "CTNND1 217_232_1_1_S230 phospho",
    "CTNND1 268_269_1_0 phospho",
    "CTNND1 320_335_1_0 phospho",
    "CTNND1 320_335_1_1_S320 phospho",
    "CTNND1 320_352_1_1_S346 phospho",
    "CTNND1 346_352_1_1_S346 phospho",
    "CTNND1 47_61_1_1_S47 phospho",
    "CTNND1 47_61_1_1_T59 phospho",
    "CTNND1 587_588_1_0 phospho",
    "CTNND1 600_617_1_1_S617 phospho",
    "CTNND1 600_617_1_1_T611 phospho",
    "CTNND1 853_863_1_1_S858 phospho",
    "CTNND1 893_900_1_1_T900 phospho",
    "CTNND1 910_914_1_1_S914 phospho",
    "CTNND1 910_927_1_1_S914 phospho",
    "CTNND1 92_98_1_1_T98 phospho",
    "CTNND1 cnv",
    "CTNND1 methyl",
    "CTNND1 proteo",
    "CTNND1 rna"
  ],
  "CTNND2": [
    "CTNND2 1032_1042_1_0 phospho",
    "CTNND2 1056_1065_1_1_S1065 phospho",
    "CTNND2 1114_1128_1_1_S1127 phospho",
    "CTNND2 1154_1164_1_1_S1163 phospho",
    "CTNND2 267_278_1_1_S267 phospho",
    "CTNND2 267_278_1_1_S276 phospho",
    "CTNND2 267_278_2_2_S267S276 phospho",
    "CTNND2 28_54_1_0 phospho",
    "CTNND2 28_54_1_1_S43 phospho",
    "CTNND2 398_401_1_1_S398 phospho",
    "CTNND2 398_401_1_1_S401 phospho",
    "CTNND2 436_453_1_0 phospho",
    "CTNND2 436_453_1_1_S438 phospho",
    "CTNND2 436_453_1_1_S440 phospho",
    "CTNND2 455_466_1_1_S461 phospho",
    "CTNND2 472_485_1_0 phospho",
    "CTNND2 472_485_1_1_S474 phospho",
    "CTNND2 490_503_1_1_S490 phospho",
    "CTNND2 519_537_1_1_S532 phospho",
    "CTNND2 519_537_2_2_S532S534 phospho",
    "CTNND2 cnv",
    "CTNND2 methyl",
    "CTNND2 proteo",
    "CTNND2 rna"
  ],
  "CTNS": [
    "CTNS cnv",
    "CTNS methyl",
    "CTNS rna"
  ],
  "CTPS1": [
    "CTPS1 415_431_1_1_S419 phospho",
    "CTPS1 cnv",
    "CTPS1 methyl",
    "CTPS1 proteo",
    "CTPS1 rna"
  ],
  "CTPS2": [
    "CTPS2 methyl",
    "CTPS2 proteo",
    "CTPS2 rna"
  ],
  "CTR9": [
    "CTR9 1013_1019_2_2_S1017S1019 phospho",
    "CTR9 1030_1035_1_1_S1035 phospho",
    "CTR9 1057_1067_2_2_S1057S1061 phospho",
    "CTR9 1057_1067_2_2_S1061S1063 phospho",
    "CTR9 901_908_1_1_T901 phospho",
    "CTR9 917_919_1_1_S917 phospho",
    "CTR9 917_919_2_2_S917S919 phospho",
    "CTR9 946_951_1_1_S946 phospho",
    "CTR9 cnv",
    "CTR9 methyl",
    "CTR9 proteo",
    "CTR9 rna"
  ],
  "CTRB1": [
    "CTRB1 cnv",
    "CTRB1 rna"
  ],
  "CTRB2": [
    "CTRB2 cnv",
    "CTRB2 rna"
  ],
  "CTRC": [
    "CTRC cnv",
    "CTRC rna"
  ],
  "CTRL": [
    "CTRL cnv",
    "CTRL methyl",
    "CTRL rna"
  ],
  "CTSA": [
    "CTSA MDPPCTNTTAASTYLNNPYVR-N2H5F0S0G0 glyco",
    "CTSA MDPPCTNTTAASTYLNNPYVR-N2H6F0S0G0 glyco",
    "CTSA cnv",
    "CTSA methyl",
    "CTSA proteo",
    "CTSA rna"
  ],
  "CTSB": [
    "CTSB cnv",
    "CTSB methyl",
    "CTSB proteo",
    "CTSB rna"
  ],
  "CTSC": [
    "CTSC DVNCSVMGPQEK-N2H3F1S0G0 glyco",
    "CTSC DVNCSVMGPQEK-N2H5F0S0G0 glyco",
    "CTSC DVNCSVMGPQEK-N2H5F1S0G0 glyco",
    "CTSC DVNCSVMGPQEK-N2H6F0S0G0 glyco",
    "CTSC DVNCSVMGPQEK-N2H6F1S0G0 glyco",
    "CTSC DVNCSVMGPQEK-N2H7F0S0G0 glyco",
    "CTSC ILTNNSQTPILSPQEVVSCSQYAQGCEGGFPYLIAGK-N2H4F0S0G0 glyco",
    "CTSC VTTYCNETMTGWVHDVLGR-N2H5F0S0G0 glyco",
    "CTSC VTTYCNETMTGWVHDVLGR-N2H6F0S0G0 glyco",
    "CTSC VTTYCNETMTGWVHDVLGR-N2H7F0S0G0 glyco",
    "CTSC cnv",
    "CTSC methyl",
    "CTSC proteo",
    "CTSC rna"
  ],
  "CTSD": [
    "CTSD GSLSYLNVTR-N2H3F0S0G0 glyco",
    "CTSD GSLSYLNVTR-N2H3F1S0G0 glyco",
    "CTSD GSLSYLNVTR-N2H4F0S0G0 glyco",
    "CTSD GSLSYLNVTR-N2H4F1S0G0 glyco",
    "CTSD GSLSYLNVTR-N2H5F0S0G0 glyco",
    "CTSD GSLSYLNVTR-N2H5F1S0G0 glyco",
    "CTSD GSLSYLNVTR-N2H6F0S0G0 glyco",
    "CTSD GSLSYLNVTR-N2H6F1S0G0 glyco",
    "CTSD GSLSYLNVTR-N2H7F0S0G0 glyco",
    "CTSD GSLSYLNVTR-N2H8F0S0G0 glyco",
    "CTSD GSLSYLNVTRK-N2H5F0S0G0 glyco",
    "CTSD GSLSYLNVTRK-N2H6F0S0G0 glyco",
    "CTSD GSLSYLNVTRK-N2H7F0S0G0 glyco",
    "CTSD cnv",
    "CTSD methyl",
    "CTSD proteo",
    "CTSD rna"
  ],
  "CTSE": [
    "CTSE cnv",
    "CTSE rna"
  ],
  "CTSF": [
    "CTSF cnv",
    "CTSF methyl",
    "CTSF proteo",
    "CTSF rna"
  ],
  "CTSG": [
    "CTSG cnv",
    "CTSG proteo",
    "CTSG rna"
  ],
  "CTSH": [
    "CTSH cnv",
    "CTSH methyl",
    "CTSH proteo",
    "CTSH rna"
  ],
  "CTSK": [
    "CTSK cnv",
    "CTSK rna"
  ],
  "CTSL": [
    "CTSL YSVANDTGFVDIPK-N2H5F0S0G0 glyco",
    "CTSL YSVANDTGFVDIPKQEK-N2H5F0S0G0 glyco",
    "CTSL cnv",
    "CTSL methyl",
    "CTSL proteo",
    "CTSL rna"
  ],
  "CTSO": [
    "CTSO cnv",
    "CTSO methyl",
    "CTSO proteo",
    "CTSO rna"
  ],
  "CTSS": [
    "CTSS cnv",
    "CTSS proteo",
    "CTSS rna"
  ],
  "CTSV": [
    "CTSV cnv",
    "CTSV methyl",
    "CTSV rna"
  ],
  "CTSW": [
    "CTSW cnv",
    "CTSW rna"
  ],
  "CTSZ": [
    "CTSZ cnv",
    "CTSZ methyl",
    "CTSZ proteo",
    "CTSZ rna"
  ],
  "CTTN": [
    "CTTN 113_117_1_1_S117 phospho",
    "CTTN 298_303_1_1_S298 phospho",
    "CTTN 399_426_1_0 phospho",
    "CTTN 399_426_1_1_S418 phospho",
    "CTTN 399_426_1_1_T401 phospho",
    "CTTN 399_426_2_0 phospho",
    "CTTN 399_426_2_1_S405 phospho",
    "CTTN 399_426_2_1_T401 phospho",
    "CTTN 399_426_2_2_T401S405 phospho",
    "CTTN 399_426_3_2_T401S405 phospho",
    "CTTN 417_426_1_1_S418 phospho",
    "CTTN 432_453_1_0 phospho",
    "CTTN 438_453_1_1_S447 phospho",
    "CTTN 43_47_1_0 phospho",
    "CTTN 98_109_1_1_S109 phospho",
    "CTTN cnv",
    "CTTN methyl",
    "CTTN proteo",
    "CTTN rna"
  ],
  "CTTNBP2": [
    "CTTNBP2 1503_1506_1_1_S1506 phospho",
    "CTTNBP2 457_460_1_1_S457 phospho",
    "CTTNBP2 cnv",
    "CTTNBP2 methyl",
    "CTTNBP2 proteo",
    "CTTNBP2 rna"
  ],
  "CTTNBP2NL": [
    "CTTNBP2NL 468_484_1_1_S481 phospho",
    "CTTNBP2NL 488_495_1_1_S488 phospho",
    "CTTNBP2NL 556_563_1_1_S563 phospho",
    "CTTNBP2NL 556_570_1_0 phospho",
    "CTTNBP2NL cnv",
    "CTTNBP2NL methyl",
    "CTTNBP2NL proteo",
    "CTTNBP2NL rna"
  ],
  "CTU1": [
    "CTU1 cnv",
    "CTU1 methyl",
    "CTU1 proteo",
    "CTU1 rna"
  ],
  "CTU2": [
    "CTU2 415_426_1_1_S419 phospho",
    "CTU2 428_435_1_1_S435 phospho",
    "CTU2 508_515_1_1_S508 phospho",
    "CTU2 cnv",
    "CTU2 methyl",
    "CTU2 proteo",
    "CTU2 rna"
  ],
  "CTXN1": [
    "CTXN1 cnv",
    "CTXN1 methyl",
    "CTXN1 proteo",
    "CTXN1 rna"
  ],
  "CTXN2": [
    "CTXN2 cnv",
    "CTXN2 methyl",
    "CTXN2 rna"
  ],
  "CTXN3": [
    "CTXN3 cnv",
    "CTXN3 rna"
  ],
  "CTXND1": [
    "CTXND1 cnv",
    "CTXND1 methyl",
    "CTXND1 rna"
  ],
  "CTXND2": [
    "CTXND2 cnv",
    "CTXND2 rna"
  ],
  "CUBN": [
    "CUBN cnv",
    "CUBN rna"
  ],
  "CUEDC1": [
    "CUEDC1 cnv",
    "CUEDC1 methyl",
    "CUEDC1 proteo",
    "CUEDC1 rna"
  ],
  "CUEDC2": [
    "CUEDC2 cnv",
    "CUEDC2 methyl",
    "CUEDC2 proteo",
    "CUEDC2 rna"
  ],
  "CUL1": [
    "CUL1 cnv",
    "CUL1 methyl",
    "CUL1 proteo",
    "CUL1 rna"
  ],
  "CUL2": [
    "CUL2 cnv",
    "CUL2 methyl",
    "CUL2 proteo",
    "CUL2 rna"
  ],
  "CUL3": [
    "CUL3 671_671_1_1_S671 phospho",
    "CUL3 cnv",
    "CUL3 methyl",
    "CUL3 proteo",
    "CUL3 rna"
  ],
  "CUL4A": [
    "CUL4A cnv",
    "CUL4A methyl",
    "CUL4A proteo",
    "CUL4A rna"
  ],
  "CUL4B": [
    "CUL4B 27_40_1_1_T36 phospho",
    "CUL4B methyl",
    "CUL4B proteo",
    "CUL4B rna"
  ],
  "CUL5": [
    "CUL5 cnv",
    "CUL5 methyl",
    "CUL5 proteo",
    "CUL5 rna"
  ],
  "CUL7": [
    "CUL7 1208_1216_1_1_S1213 phospho",
    "CUL7 cnv",
    "CUL7 methyl",
    "CUL7 proteo",
    "CUL7 rna"
  ],
  "CUL9": [
    "CUL9 1457_1468_1_1_S1457 phospho",
    "CUL9 cnv",
    "CUL9 methyl",
    "CUL9 proteo",
    "CUL9 rna"
  ],
  "CUTA": [
    "CUTA cnv",
    "CUTA methyl",
    "CUTA proteo",
    "CUTA rna"
  ],
  "CUTALP": [
    "CUTALP methyl"
  ],
  "CUTC": [
    "CUTC cnv",
    "CUTC methyl",
    "CUTC proteo",
    "CUTC rna"
  ],
  "CUX1": [
    "CUX1 1080_1095_1_1_S1080 phospho",
    "CUX1 1465_1469_1_1_S1466 phospho",
    "CUX1 cnv",
    "CUX1 methyl",
    "CUX1 proteo",
    "CUX1 rna"
  ],
  "CUX2": [
    "CUX2 cnv",
    "CUX2 methyl",
    "CUX2 rna"
  ],
  "CUZD1": [
    "CUZD1 cnv",
    "CUZD1 rna"
  ],
  "CWC15": [
    "CWC15 46_47_1_1_T47 phospho",
    "CWC15 cnv",
    "CWC15 methyl",
    "CWC15 proteo",
    "CWC15 rna"
  ],
  "CWC22": [
    "CWC22 61_68_1_1_S61 phospho",
    "CWC22 829_831_1_1_S829 phospho",
    "CWC22 cnv",
    "CWC22 methyl",
    "CWC22 proteo",
    "CWC22 rna"
  ],
  "CWC25": [
    "CWC25 217_222_1_1_S218 phospho",
    "CWC25 cnv",
    "CWC25 methyl",
    "CWC25 rna"
  ],
  "CWC27": [
    "CWC27 cnv",
    "CWC27 methyl",
    "CWC27 proteo",
    "CWC27 rna"
  ],
  "CWF19L1": [
    "CWF19L1 cnv",
    "CWF19L1 methyl",
    "CWF19L1 proteo",
    "CWF19L1 rna"
  ],
  "CWF19L2": [
    "CWF19L2 474_489_1_1_S479 phospho",
    "CWF19L2 cnv",
    "CWF19L2 methyl",
    "CWF19L2 proteo",
    "CWF19L2 rna"
  ],
  "CWH43": [
    "CWH43 cnv",
    "CWH43 methyl",
    "CWH43 rna"
  ],
  "CX3CL1": [
    "CX3CL1 301_307_1_1_S306 phospho",
    "CX3CL1 cnv",
    "CX3CL1 rna"
  ],
  "CX3CR1": [
    "CX3CR1 cnv",
    "CX3CR1 rna"
  ],
  "CXADR": [
    "CXADR 293_314_1_0 phospho",
    "CXADR 293_314_1_1_S301 phospho",
    "CXADR 316_334_1_0 phospho",
    "CXADR 316_334_1_1_S332 phospho",
    "CXADR 329_334_1_0 phospho",
    "CXADR 329_334_1_1_S332 phospho",
    "CXADR SGDASINVTNLQLSDIGTYQCK-N4H5F0S1G0 glyco",
    "CXADR SGDASINVTNLQLSDIGTYQCK-N5H3F0S0G0 glyco",
    "CXADR SGDASINVTNLQLSDIGTYQCK-N5H4F1S0G0 glyco",
    "CXADR cnv",
    "CXADR methyl",
    "CXADR proteo",
    "CXADR rna"
  ],
  "CXCL1": [
    "CXCL1 cnv",
    "CXCL1 methyl",
    "CXCL1 rna"
  ],
  "CXCL10": [
    "CXCL10 cnv",
    "CXCL10 rna"
  ],
  "CXCL11": [
    "CXCL11 cnv",
    "CXCL11 rna"
  ],
  "CXCL12": [
    "CXCL12 cnv",
    "CXCL12 methyl",
    "CXCL12 rna"
  ],
  "CXCL13": [
    "CXCL13 cnv",
    "CXCL13 rna"
  ],
  "CXCL14": [
    "CXCL14 cnv",
    "CXCL14 methyl",
    "CXCL14 proteo",
    "CXCL14 rna"
  ],
  "CXCL16": [
    "CXCL16 cnv",
    "CXCL16 methyl",
    "CXCL16 rna"
  ],
  "CXCL17": [
    "CXCL17 cnv",
    "CXCL17 rna"
  ],
  "CXCL2": [
    "CXCL2 cnv",
    "CXCL2 methyl",
    "CXCL2 rna"
  ],
  "CXCL3": [
    "CXCL3 cnv",
    "CXCL3 methyl",
    "CXCL3 rna"
  ],
  "CXCL5": [
    "CXCL5 cnv",
    "CXCL5 methyl",
    "CXCL5 rna"
  ],
  "CXCL6": [
    "CXCL6 cnv",
    "CXCL6 methyl",
    "CXCL6 rna"
  ],
  "CXCL8": [
    "CXCL8 cnv",
    "CXCL8 rna"
  ],
  "CXCL9": [
    "CXCL9 cnv",
    "CXCL9 rna"
  ],
  "CXCR1": [
    "CXCR1 cnv",
    "CXCR1 rna"
  ],
  "CXCR2": [
    "CXCR2 cnv",
    "CXCR2 rna"
  ],
  "CXCR3": [
    "CXCR3 rna"
  ],
  "CXCR4": [
    "CXCR4 315_325_1_1_S323 phospho",
    "CXCR4 cnv",
    "CXCR4 methyl",
    "CXCR4 proteo",
    "CXCR4 rna"
  ],
  "CXCR5": [
    "CXCR5 cnv",
    "CXCR5 rna"
  ],
  "CXCR6": [
    "CXCR6 cnv",
    "CXCR6 rna"
  ],
  "CXXC1": [
    "CXXC1 218_231_1_1_S224 phospho",
    "CXXC1 cnv",
    "CXXC1 methyl",
    "CXXC1 proteo",
    "CXXC1 rna"
  ],
  "CXXC4": [
    "CXXC4 cnv",
    "CXXC4 rna"
  ],
  "CXXC5": [
    "CXXC5 cnv",
    "CXXC5 methyl",
    "CXXC5 proteo",
    "CXXC5 rna"
  ],
  "CXXC5-AS1": [
    "CXXC5-AS1 methyl"
  ],
  "CXorf38": [
    "CXorf38 methyl",
    "CXorf38 proteo",
    "CXorf38 rna"
  ],
  "CXorf49": [
    "CXorf49 rna"
  ],
  "CXorf49B": [
    "CXorf49B rna"
  ],
  "CXorf58": [
    "CXorf58 methyl",
    "CXorf58 rna"
  ],
  "CXorf65": [
    "CXorf65 rna"
  ],
  "CYB561": [
    "CYB561 241_250_1_1_S247 phospho",
    "CYB561 241_250_2_2_S247S250 phospho",
    "CYB561 cnv",
    "CYB561 methyl",
    "CYB561 proteo",
    "CYB561 rna"
  ],
  "CYB561A3": [
    "CYB561A3 cnv",
    "CYB561A3 methyl",
    "CYB561A3 rna"
  ],
  "CYB561D1": [
    "CYB561D1 cnv",
    "CYB561D1 methyl",
    "CYB561D1 rna"
  ],
  "CYB561D2": [
    "CYB561D2 cnv",
    "CYB561D2 methyl",
    "CYB561D2 proteo",
    "CYB561D2 rna"
  ],
  "CYB5A": [
    "CYB5A cnv",
    "CYB5A methyl",
    "CYB5A proteo",
    "CYB5A rna"
  ],
  "CYB5B": [
    "CYB5B cnv",
    "CYB5B methyl",
    "CYB5B proteo",
    "CYB5B rna"
  ],
  "CYB5D1": [
    "CYB5D1 cnv",
    "CYB5D1 methyl",
    "CYB5D1 rna"
  ],
  "CYB5D2": [
    "CYB5D2 cnv",
    "CYB5D2 methyl",
    "CYB5D2 rna"
  ],
  "CYB5R1": [
    "CYB5R1 cnv",
    "CYB5R1 methyl",
    "CYB5R1 proteo",
    "CYB5R1 rna"
  ],
  "CYB5R2": [
    "CYB5R2 cnv",
    "CYB5R2 methyl",
    "CYB5R2 proteo",
    "CYB5R2 rna"
  ],
  "CYB5R3": [
    "CYB5R3 cnv",
    "CYB5R3 methyl",
    "CYB5R3 proteo",
    "CYB5R3 rna"
  ],
  "CYB5R4": [
    "CYB5R4 cnv",
    "CYB5R4 methyl",
    "CYB5R4 proteo",
    "CYB5R4 rna"
  ],
  "CYB5RL": [
    "CYB5RL cnv",
    "CYB5RL methyl",
    "CYB5RL rna"
  ],
  "CYBA": [
    "CYBA 168_191_1_1_S168 phospho",
    "CYBA cnv",
    "CYBA methyl",
    "CYBA proteo",
    "CYBA rna"
  ],
  "CYBB": [
    "CYBB proteo",
    "CYBB rna"
  ],
  "CYBC1": [
    "CYBC1 cnv",
    "CYBC1 methyl",
    "CYBC1 proteo",
    "CYBC1 rna"
  ],
  "CYBRD1": [
    "CYBRD1 190_195_1_1_S190 phospho",
    "CYBRD1 190_208_1_1_S202 phospho",
    "CYBRD1 202_208_1_1_S202 phospho",
    "CYBRD1 226_227_1_1_T227 phospho",
    "CYBRD1 cnv",
    "CYBRD1 methyl",
    "CYBRD1 proteo",
    "CYBRD1 rna"
  ],
  "CYC1": [
    "CYC1 cnv",
    "CYC1 methyl",
    "CYC1 proteo",
    "CYC1 rna"
  ],
  "CYCS": [
    "CYCS cnv",
    "CYCS methyl",
    "CYCS proteo",
    "CYCS rna"
  ],
  "CYFIP1": [
    "CYFIP1 1228_1234_1_1_T1234 phospho",
    "CYFIP1 579_588_1_1_S583 phospho",
    "CYFIP1 cnv",
    "CYFIP1 methyl",
    "CYFIP1 proteo",
    "CYFIP1 rna"
  ],
  "CYFIP2": [
    "CYFIP2 cnv",
    "CYFIP2 methyl",
    "CYFIP2 proteo",
    "CYFIP2 rna"
  ],
  "CYGB": [
    "CYGB cnv",
    "CYGB methyl",
    "CYGB proteo",
    "CYGB rna"
  ],
  "CYLC1": [
    "CYLC1 rna"
  ],
  "CYLC2": [
    "CYLC2 cnv"
  ],
  "CYLD": [
    "CYLD 337_341_1_1_S341 phospho",
    "CYLD cnv",
    "CYLD methyl",
    "CYLD proteo",
    "CYLD rna"
  ],
  "CYP11A1": [
    "CYP11A1 cnv",
    "CYP11A1 methyl",
    "CYP11A1 rna"
  ],
  "CYP11B1": [
    "CYP11B1 cnv"
  ],
  "CYP11B2": [
    "CYP11B2 cnv"
  ],
  "CYP17A1": [
    "CYP17A1 cnv",
    "CYP17A1 rna"
  ],
  "CYP19A1": [
    "CYP19A1 cnv",
    "CYP19A1 rna"
  ],
  "CYP1A1": [
    "CYP1A1 cnv",
    "CYP1A1 methyl",
    "CYP1A1 rna"
  ],
  "CYP1A2": [
    "CYP1A2 cnv",
    "CYP1A2 rna"
  ],
  "CYP1B1": [
    "CYP1B1 cnv",
    "CYP1B1 methyl",
    "CYP1B1 proteo",
    "CYP1B1 rna"
  ],
  "CYP1B1-AS1": [
    "CYP1B1-AS1 methyl"
  ],
  "CYP20A1": [
    "CYP20A1 cnv",
    "CYP20A1 methyl",
    "CYP20A1 proteo",
    "CYP20A1 rna"
  ],
  "CYP21A2": [
    "CYP21A2 cnv",
    "CYP21A2 rna"
  ],
  "CYP24A1": [
    "CYP24A1 cnv",
    "CYP24A1 methyl",
    "CYP24A1 rna"
  ],
  "CYP26A1": [
    "CYP26A1 cnv",
    "CYP26A1 methyl",
    "CYP26A1 rna"
  ],
  "CYP26B1": [
    "CYP26B1 cnv",
    "CYP26B1 methyl",
    "CYP26B1 rna"
  ],
  "CYP26C1": [
    "CYP26C1 cnv",
    "CYP26C1 methyl",
    "CYP26C1 rna"
  ],
  "CYP27A1": [
    "CYP27A1 cnv",
    "CYP27A1 methyl",
    "CYP27A1 proteo",
    "CYP27A1 rna"
  ],
  "CYP27B1": [
    "CYP27B1 cnv",
    "CYP27B1 rna"
  ],
  "CYP27C1": [
    "CYP27C1 cnv",
    "CYP27C1 methyl",
    "CYP27C1 rna"
  ],
  "CYP2A13": [
    "CYP2A13 cnv",
    "CYP2A13 rna"
  ],
  "CYP2A6": [
    "CYP2A6 cnv",
    "CYP2A6 rna"
  ],
  "CYP2A7": [
    "CYP2A7 cnv",
    "CYP2A7 methyl",
    "CYP2A7 rna"
  ],
  "CYP2B6": [
    "CYP2B6 cnv",
    "CYP2B6 rna"
  ],
  "CYP2C18": [
    "CYP2C18 cnv",
    "CYP2C18 rna"
  ],
  "CYP2C19": [
    "CYP2C19 cnv",
    "CYP2C19 rna"
  ],
  "CYP2C8": [
    "CYP2C8 cnv",
    "CYP2C8 rna"
  ],
  "CYP2C9": [
    "CYP2C9 cnv",
    "CYP2C9 rna"
  ],
  "CYP2D6": [
    "CYP2D6 cnv",
    "CYP2D6 rna"
  ],
  "CYP2D7": [
    "CYP2D7 cnv",
    "CYP2D7 rna"
  ],
  "CYP2E1": [
    "CYP2E1 cnv",
    "CYP2E1 methyl",
    "CYP2E1 rna"
  ],
  "CYP2F1": [
    "CYP2F1 cnv",
    "CYP2F1 methyl",
    "CYP2F1 rna"
  ],
  "CYP2G1P": [
    "CYP2G1P methyl"
  ],
  "CYP2J2": [
    "CYP2J2 cnv",
    "CYP2J2 methyl",
    "CYP2J2 rna"
  ],
  "CYP2R1": [
    "CYP2R1 cnv",
    "CYP2R1 methyl",
    "CYP2R1 rna"
  ],
  "CYP2S1": [
    "CYP2S1 cnv",
    "CYP2S1 methyl",
    "CYP2S1 proteo",
    "CYP2S1 rna"
  ],
  "CYP2T1P": [
    "CYP2T1P methyl"
  ],
  "CYP2U1": [
    "CYP2U1 cnv",
    "CYP2U1 methyl",
    "CYP2U1 proteo",
    "CYP2U1 rna"
  ],
  "CYP2U1-AS1": [
    "CYP2U1-AS1 methyl"
  ],
  "CYP2W1": [
    "CYP2W1 cnv",
    "CYP2W1 methyl",
    "CYP2W1 rna"
  ],
  "CYP39A1": [
    "CYP39A1 cnv",
    "CYP39A1 methyl",
    "CYP39A1 rna"
  ],
  "CYP3A4": [
    "CYP3A4 cnv",
    "CYP3A4 rna"
  ],
  "CYP3A43": [
    "CYP3A43 cnv",
    "CYP3A43 rna"
  ],
  "CYP3A5": [
    "CYP3A5 cnv",
    "CYP3A5 rna"
  ],
  "CYP3A7": [
    "CYP3A7 cnv",
    "CYP3A7 rna"
  ],
  "CYP3A7-CYP3A51P": [
    "CYP3A7-CYP3A51P cnv",
    "CYP3A7-CYP3A51P rna"
  ],
  "CYP46A1": [
    "CYP46A1 cnv",
    "CYP46A1 methyl",
    "CYP46A1 proteo",
    "CYP46A1 rna"
  ],
  "CYP4A11": [
    "CYP4A11 cnv",
    "CYP4A11 rna"
  ],
  "CYP4A22": [
    "CYP4A22 cnv",
    "CYP4A22 rna"
  ],
  "CYP4B1": [
    "CYP4B1 cnv",
    "CYP4B1 rna"
  ],
  "CYP4F11": [
    "CYP4F11 cnv",
    "CYP4F11 proteo",
    "CYP4F11 rna"
  ],
  "CYP4F12": [
    "CYP4F12 cnv",
    "CYP4F12 rna"
  ],
  "CYP4F2": [
    "CYP4F2 cnv",
    "CYP4F2 rna"
  ],
  "CYP4F22": [
    "CYP4F22 cnv",
    "CYP4F22 rna"
  ],
  "CYP4F3": [
    "CYP4F3 cnv",
    "CYP4F3 rna"
  ],
  "CYP4F8": [
    "CYP4F8 cnv",
    "CYP4F8 rna"
  ],
  "CYP4V2": [
    "CYP4V2 cnv",
    "CYP4V2 methyl",
    "CYP4V2 rna"
  ],
  "CYP4X1": [
    "CYP4X1 cnv",
    "CYP4X1 methyl",
    "CYP4X1 proteo",
    "CYP4X1 rna"
  ],
  "CYP4Z1": [
    "CYP4Z1 cnv",
    "CYP4Z1 rna"
  ],
  "CYP51A1": [
    "CYP51A1 cnv",
    "CYP51A1 methyl",
    "CYP51A1 proteo",
    "CYP51A1 rna"
  ],
  "CYP51A1-AS1": [
    "CYP51A1-AS1 methyl"
  ],
  "CYP7A1": [
    "CYP7A1 cnv",
    "CYP7A1 rna"
  ],
  "CYP7B1": [
    "CYP7B1 cnv",
    "CYP7B1 methyl",
    "CYP7B1 proteo",
    "CYP7B1 rna"
  ],
  "CYP8B1": [
    "CYP8B1 cnv",
    "CYP8B1 rna"
  ],
  "CYREN": [
    "CYREN cnv",
    "CYREN methyl",
    "CYREN rna"
  ],
  "CYRIA": [
    "CYRIA cnv",
    "CYRIA proteo",
    "CYRIA rna"
  ],
  "CYRIB": [
    "CYRIB cnv",
    "CYRIB methyl",
    "CYRIB proteo",
    "CYRIB rna"
  ],
  "CYS1": [
    "CYS1 17_34_1_1_S17 phospho",
    "CYS1 cnv",
    "CYS1 methyl",
    "CYS1 rna"
  ],
  "CYSLTR1": [
    "CYSLTR1 rna"
  ],
  "CYSLTR2": [
    "CYSLTR2 cnv",
    "CYSLTR2 rna"
  ],
  "CYSRT1": [
    "CYSRT1 cnv",
    "CYSRT1 rna"
  ],
  "CYSTM1": [
    "CYSTM1 cnv",
    "CYSTM1 methyl",
    "CYSTM1 proteo",
    "CYSTM1 rna"
  ],
  "CYTH1": [
    "CYTH1 cnv",
    "CYTH1 methyl",
    "CYTH1 proteo",
    "CYTH1 rna"
  ],
  "CYTH2": [
    "CYTH2 cnv",
    "CYTH2 methyl",
    "CYTH2 proteo",
    "CYTH2 rna"
  ],
  "CYTH3": [
    "CYTH3 cnv",
    "CYTH3 methyl",
    "CYTH3 proteo",
    "CYTH3 rna"
  ],
  "CYTH4": [
    "CYTH4 cnv",
    "CYTH4 proteo",
    "CYTH4 rna"
  ],
  "CYTIP": [
    "CYTIP cnv",
    "CYTIP rna"
  ],
  "CYTL1": [
    "CYTL1 cnv",
    "CYTL1 methyl",
    "CYTL1 rna"
  ],
  "CYYR1": [
    "CYYR1 cnv",
    "CYYR1 methyl",
    "CYYR1 rna"
  ],
  "CZIB": [
    "CZIB cnv",
    "CZIB methyl",
    "CZIB proteo",
    "CZIB rna"
  ],
  "D2HGDH": [
    "D2HGDH cnv",
    "D2HGDH methyl",
    "D2HGDH proteo",
    "D2HGDH rna"
  ],
  "DAAM1": [
    "DAAM1 cnv",
    "DAAM1 methyl",
    "DAAM1 proteo",
    "DAAM1 rna"
  ],
  "DAAM2": [
    "DAAM2 cnv",
    "DAAM2 methyl",
    "DAAM2 proteo",
    "DAAM2 rna"
  ],
  "DAB1": [
    "DAB1 cnv",
    "DAB1 methyl",
    "DAB1 proteo",
    "DAB1 rna"
  ],
  "DAB2": [
    "DAB2 393_401_1_1_S401 phospho",
    "DAB2 393_407_1_1_S401 phospho",
    "DAB2 448_477_1_0 phospho",
    "DAB2 448_477_1_1_S464 phospho",
    "DAB2 cnv",
    "DAB2 methyl",
    "DAB2 proteo",
    "DAB2 rna"
  ],
  "DAB2IP": [
    "DAB2IP 1003_1008_1_1_S1003 phospho",
    "DAB2IP 698_702_1_0 phospho",
    "DAB2IP 698_702_1_1_S700 phospho",
    "DAB2IP 717_719_1_1_S719 phospho",
    "DAB2IP 943_950_1_1_S950 phospho",
    "DAB2IP cnv",
    "DAB2IP methyl",
    "DAB2IP proteo",
    "DAB2IP rna"
  ],
  "DACH1": [
    "DACH1 cnv",
    "DACH1 methyl",
    "DACH1 rna"
  ],
  "DACH2": [
    "DACH2 methyl",
    "DACH2 rna"
  ],
  "DACT1": [
    "DACT1 cnv",
    "DACT1 methyl",
    "DACT1 rna"
  ],
  "DACT2": [
    "DACT2 cnv",
    "DACT2 methyl",
    "DACT2 rna"
  ],
  "DACT3": [
    "DACT3 165_172_1_1_S165 phospho",
    "DACT3 186_205_1_1_S188 phospho",
    "DACT3 315_321_1_1_S316 phospho",
    "DACT3 505_507_1_1_S505 phospho",
    "DACT3 515_525_1_1_S520 phospho",
    "DACT3 cnv",
    "DACT3 methyl",
    "DACT3 proteo",
    "DACT3 rna"
  ],
  "DACT3-AS1": [
    "DACT3-AS1 methyl"
  ],
  "DAD1": [
    "DAD1 cnv",
    "DAD1 methyl",
    "DAD1 proteo",
    "DAD1 rna"
  ],
  "DAG1": [
    "DAG1 cnv",
    "DAG1 methyl",
    "DAG1 proteo",
    "DAG1 rna"
  ],
  "DAGLA": [
    "DAGLA 725_737_1_1_S727 phospho",
    "DAGLA 806_808_1_1_S806 phospho",
    "DAGLA cnv",
    "DAGLA methyl",
    "DAGLA proteo",
    "DAGLA rna"
  ],
  "DAGLB": [
    "DAGLB cnv",
    "DAGLB methyl",
    "DAGLB proteo",
    "DAGLB rna"
  ],
  "DALRD3": [
    "DALRD3 cnv",
    "DALRD3 methyl",
    "DALRD3 proteo",
    "DALRD3 rna"
  ],
  "DANCR": [
    "DANCR methyl"
  ],
  "DAND5": [
    "DAND5 cnv",
    "DAND5 rna"
  ],
  "DAO": [
    "DAO cnv",
    "DAO methyl",
    "DAO rna"
  ],
  "DAOA": [
    "DAOA cnv"
  ],
  "DAP": [
    "DAP 49_60_1_1_S51 phospho",
    "DAP 85_91_1_1_S91 phospho",
    "DAP cnv",
    "DAP methyl",
    "DAP proteo",
    "DAP rna"
  ],
  "DAP3": [
    "DAP3 cnv",
    "DAP3 methyl",
    "DAP3 proteo",
    "DAP3 rna"
  ],
  "DAPK1": [
    "DAPK1 289_289_1_1_S289 phospho",
    "DAPK1 cnv",
    "DAPK1 kinase",
    "DAPK1 methyl",
    "DAPK1 proteo",
    "DAPK1 rna"
  ],
  "DAPK2": [
    "DAPK2 349_351_1_1_S349 phospho",
    "DAPK2 cnv",
    "DAPK2 kinase",
    "DAPK2 methyl",
    "DAPK2 rna"
  ],
  "DAPK3": [
    "DAPK3 cnv",
    "DAPK3 kinase",
    "DAPK3 methyl",
    "DAPK3 proteo",
    "DAPK3 rna"
  ],
  "DAPL1": [
    "DAPL1 cnv",
    "DAPL1 rna"
  ],
  "DAPP1": [
    "DAPP1 cnv",
    "DAPP1 rna"
  ],
  "DARS1": [
    "DARS1 245_253_1_1_S249 phospho",
    "DARS1 cnv",
    "DARS1 methyl",
    "DARS1 proteo",
    "DARS1 rna"
  ],
  "DARS2": [
    "DARS2 cnv",
    "DARS2 methyl",
    "DARS2 proteo",
    "DARS2 rna"
  ],
  "DAW1": [
    "DAW1 cnv",
    "DAW1 methyl",
    "DAW1 rna"
  ],
  "DAXX": [
    "DAXX 150_178_1_1_S178 phospho",
    "DAXX 495_503_1_1_S495 phospho",
    "DAXX 665_684_1_1_S671 phospho",
    "DAXX 688_702_1_1_S688 phospho",
    "DAXX 707_719_1_1_T709 phospho",
    "DAXX cnv",
    "DAXX methyl",
    "DAXX proteo",
    "DAXX rna"
  ],
  "DAZ1": [
    "DAZ1 rna"
  ],
  "DAZ3": [
    "DAZ3 rna"
  ],
  "DAZ4": [
    "DAZ4 rna"
  ],
  "DAZAP1": [
    "DAZAP1 cnv",
    "DAZAP1 methyl",
    "DAZAP1 proteo",
    "DAZAP1 rna"
  ],
  "DAZAP2": [
    "DAZAP2 cnv",
    "DAZAP2 methyl",
    "DAZAP2 rna"
  ],
  "DAZL": [
    "DAZL cnv",
    "DAZL methyl",
    "DAZL rna"
  ],
  "DBF4": [
    "DBF4 cnv",
    "DBF4 methyl",
    "DBF4 rna"
  ],
  "DBF4B": [
    "DBF4B cnv",
    "DBF4B methyl",
    "DBF4B rna"
  ],
  "DBH": [
    "DBH cnv",
    "DBH proteo",
    "DBH rna"
  ],
  "DBI": [
    "DBI 18_32_1_1_Y29 phospho",
    "DBI cnv",
    "DBI methyl",
    "DBI proteo",
    "DBI rna"
  ],
  "DBN1": [
    "DBN1 141_142_1_1_S142 phospho",
    "DBN1 302_322_1_1_S312 phospho",
    "DBN1 302_324_1_0 phospho",
    "DBN1 302_324_1_1_S312 phospho",
    "DBN1 302_324_1_1_S320 phospho",
    "DBN1 302_324_1_1_S324 phospho",
    "DBN1 302_324_2_2_S320S324 phospho",
    "DBN1 329_352_1_0 phospho",
    "DBN1 329_352_1_1_S342 phospho",
    "DBN1 331_335_1_1_T331 phospho",
    "DBN1 331_346_1_0 phospho",
    "DBN1 331_346_1_1_S337 phospho",
    "DBN1 331_346_2_0 phospho",
    "DBN1 337_346_1_1_S339 phospho",
    "DBN1 360_389_1_1_S381 phospho",
    "DBN1 cnv",
    "DBN1 methyl",
    "DBN1 proteo",
    "DBN1 rna"
  ],
  "DBNDD1": [
    "DBNDD1 cnv",
    "DBNDD1 methyl",
    "DBNDD1 proteo",
    "DBNDD1 rna"
  ],
  "DBNDD2": [
    "DBNDD2 cnv",
    "DBNDD2 methyl",
    "DBNDD2 rna"
  ],
  "DBNL": [
    "DBNL 136_141_1_1_S141 phospho",
    "DBNL 224_235_1_1_S232 phospho",
    "DBNL 269_275_1_0 phospho",
    "DBNL 269_275_1_1_S269 phospho",
    "DBNL 269_275_2_0 phospho",
    "DBNL 291_295_1_1_T291 phospho",
    "DBNL cnv",
    "DBNL methyl",
    "DBNL proteo",
    "DBNL rna"
  ],
  "DBP": [
    "DBP cnv",
    "DBP methyl",
    "DBP rna"
  ],
  "DBR1": [
    "DBR1 514_514_1_1_S514 phospho",
    "DBR1 cnv",
    "DBR1 methyl",
    "DBR1 proteo",
    "DBR1 rna"
  ],
  "DBT": [
    "DBT cnv",
    "DBT proteo",
    "DBT rna"
  ],
  "DBX1": [
    "DBX1 cnv",
    "DBX1 methyl",
    "DBX1 rna"
  ],
  "DBX2": [
    "DBX2 cnv",
    "DBX2 methyl",
    "DBX2 rna"
  ],
  "DCAF1": [
    "DCAF1 978_986_1_1_S978 phospho",
    "DCAF1 999_1010_1_1_S999 phospho",
    "DCAF1 cnv",
    "DCAF1 methyl",
    "DCAF1 proteo",
    "DCAF1 rna"
  ],
  "DCAF10": [
    "DCAF10 347_360_1_1_T348 phospho",
    "DCAF10 68_92_1_1_S92 phospho",
    "DCAF10 cnv",
    "DCAF10 methyl",
    "DCAF10 proteo",
    "DCAF10 rna"
  ],
  "DCAF11": [
    "DCAF11 cnv",
    "DCAF11 methyl",
    "DCAF11 proteo",
    "DCAF11 rna"
  ],
  "DCAF12": [
    "DCAF12 15_32_1_1_S15 phospho",
    "DCAF12 cnv",
    "DCAF12 methyl",
    "DCAF12 rna"
  ],
  "DCAF12L1": [
    "DCAF12L1 methyl",
    "DCAF12L1 rna"
  ],
  "DCAF12L2": [
    "DCAF12L2 methyl",
    "DCAF12L2 rna"
  ],
  "DCAF13": [
    "DCAF13 cnv",
    "DCAF13 methyl",
    "DCAF13 proteo",
    "DCAF13 rna"
  ],
  "DCAF15": [
    "DCAF15 307_314_1_1_S310 phospho",
    "DCAF15 cnv",
    "DCAF15 methyl",
    "DCAF15 rna"
  ],
  "DCAF16": [
    "DCAF16 cnv",
    "DCAF16 methyl",
    "DCAF16 proteo",
    "DCAF16 rna"
  ],
  "DCAF17": [
    "DCAF17 cnv",
    "DCAF17 methyl",
    "DCAF17 rna"
  ],
  "DCAF4": [
    "DCAF4 cnv",
    "DCAF4 methyl",
    "DCAF4 rna"
  ],
  "DCAF4L1": [
    "DCAF4L1 cnv",
    "DCAF4L1 rna"
  ],
  "DCAF4L2": [
    "DCAF4L2 cnv",
    "DCAF4L2 methyl",
    "DCAF4L2 rna"
  ],
  "DCAF5": [
    "DCAF5 453_475_1_1_S467 phospho",
    "DCAF5 488_507_1_0 phospho",
    "DCAF5 635_654_1_1_S647 phospho",
    "DCAF5 793_793_1_1_S793 phospho",
    "DCAF5 cnv",
    "DCAF5 methyl",
    "DCAF5 proteo",
    "DCAF5 rna"
  ],
  "DCAF6": [
    "DCAF6 867_870_1_1_S870 phospho",
    "DCAF6 cnv",
    "DCAF6 methyl",
    "DCAF6 proteo",
    "DCAF6 rna"
  ],
  "DCAF7": [
    "DCAF7 cnv",
    "DCAF7 methyl",
    "DCAF7 proteo",
    "DCAF7 rna"
  ],
  "DCAF8": [
    "DCAF8 99_99_1_1_S99 phospho",
    "DCAF8 cnv",
    "DCAF8 methyl",
    "DCAF8 proteo",
    "DCAF8 rna"
  ],
  "DCAF8L2": [
    "DCAF8L2 rna"
  ],
  "DCAKD": [
    "DCAKD cnv",
    "DCAKD methyl",
    "DCAKD proteo",
    "DCAKD rna"
  ],
  "DCANP1": [
    "DCANP1 cnv",
    "DCANP1 rna"
  ],
  "DCBLD1": [
    "DCBLD1 cnv",
    "DCBLD1 rna"
  ],
  "DCBLD2": [
    "DCBLD2 cnv",
    "DCBLD2 methyl",
    "DCBLD2 proteo",
    "DCBLD2 rna"
  ],
  "DCC": [
    "DCC 1202_1219_1_1_T1219 phospho",
    "DCC cnv",
    "DCC proteo",
    "DCC rna"
  ],
  "DCD": [
    "DCD cnv",
    "DCD proteo"
  ],
  "DCDC1": [
    "DCDC1 cnv",
    "DCDC1 methyl",
    "DCDC1 rna"
  ],
  "DCDC2": [
    "DCDC2 261_270_1_1_S270 phospho",
    "DCDC2 cnv",
    "DCDC2 methyl",
    "DCDC2 proteo",
    "DCDC2 rna"
  ],
  "DCDC2B": [
    "DCDC2B cnv",
    "DCDC2B rna"
  ],
  "DCDC2C": [
    "DCDC2C cnv",
    "DCDC2C methyl",
    "DCDC2C rna"
  ],
  "DCHS1": [
    "DCHS1 2976_2985_1_1_S2985 phospho",
    "DCHS1 2995_3019_1_1_S2995 phospho",
    "DCHS1 AEDRDAGANASILYR-N2H5F0S0G0 glyco",
    "DCHS1 EAFALNSSTGELR-N2H5F0S0G0 glyco",
    "DCHS1 cnv",
    "DCHS1 methyl",
    "DCHS1 proteo",
    "DCHS1 rna"
  ],
  "DCHS2": [
    "DCHS2 cnv",
    "DCHS2 methyl",
    "DCHS2 rna"
  ],
  "DCK": [
    "DCK 63_74_1_1_S74 phospho",
    "DCK cnv",
    "DCK methyl",
    "DCK proteo",
    "DCK rna"
  ],
  "DCLK1": [
    "DCLK1 305_324_1_0 phospho",
    "DCLK1 305_324_1_1_S307 phospho",
    "DCLK1 305_324_2_0 phospho",
    "DCLK1 305_324_2_1_S307 phospho",
    "DCLK1 305_324_2_2_S305S307 phospho",
    "DCLK1 305_324_2_2_S307S313 phospho",
    "DCLK1 305_324_3_0 phospho",
    "DCLK1 307_324_1_1_S307 phospho",
    "DCLK1 307_324_1_1_S313 phospho",
    "DCLK1 32_42_1_1_S32 phospho",
    "DCLK1 32_42_1_1_S40 phospho",
    "DCLK1 32_42_2_2_S32S36 phospho",
    "DCLK1 32_42_2_2_T34S36 phospho",
    "DCLK1 330_340_1_1_S332 phospho",
    "DCLK1 330_340_1_1_S337 phospho",
    "DCLK1 330_340_2_2_S330S337 phospho",
    "DCLK1 330_340_2_2_S332S337 phospho",
    "DCLK1 346_359_1_1_S346 phospho",
    "DCLK1 346_359_1_1_S352 phospho",
    "DCLK1 346_359_2_0 phospho",
    "DCLK1 346_359_2_2_S346S352 phospho",
    "DCLK1 346_359_3_0 phospho",
    "DCLK1 363_387_1_1_S364 phospho",
    "DCLK1 41_55_1_1_S46 phospho",
    "DCLK1 41_55_1_1_S55 phospho",
    "DCLK1 44_52_1_1_T46 phospho",
    "DCLK1 720_732_1_1_S726 phospho",
    "DCLK1 722_727_1_1_S722 phospho",
    "DCLK1 cnv",
    "DCLK1 kinase",
    "DCLK1 methyl",
    "DCLK1 proteo",
    "DCLK1 rna"
  ],
  "DCLK2": [
    "DCLK2 166_166_1_1_S166 phospho",
    "DCLK2 29_37_1_0 phospho",
    "DCLK2 315_331_1_1_S317 phospho",
    "DCLK2 315_331_2_2_S315S317 phospho",
    "DCLK2 315_331_2_2_S317S320 phospho",
    "DCLK2 317_331_1_1_S317 phospho",
    "DCLK2 317_331_1_1_S320 phospho",
    "DCLK2 355_355_1_1_S355 phospho",
    "DCLK2 360_362_1_1_S362 phospho",
    "DCLK2 360_375_1_1_S375 phospho",
    "DCLK2 375_389_1_1_S375 phospho",
    "DCLK2 47_57_1_1_S47 phospho",
    "DCLK2 47_57_1_1_S55 phospho",
    "DCLK2 47_57_2_2_S47S51 phospho",
    "DCLK2 59_67_1_1_T61 phospho",
    "DCLK2 61_67_1_1_S67 phospho",
    "DCLK2 682_693_1_0 phospho",
    "DCLK2 682_693_1_1_T683 phospho",
    "DCLK2 6_6_1_1_S6 phospho",
    "DCLK2 cnv",
    "DCLK2 kinase",
    "DCLK2 methyl",
    "DCLK2 proteo",
    "DCLK2 rna"
  ],
  "DCLK3": [
    "DCLK3 cnv",
    "DCLK3 kinase",
    "DCLK3 methyl",
    "DCLK3 rna"
  ],
  "DCLRE1A": [
    "DCLRE1A cnv",
    "DCLRE1A methyl",
    "DCLRE1A rna"
  ],
  "DCLRE1B": [
    "DCLRE1B cnv",
    "DCLRE1B methyl",
    "DCLRE1B rna"
  ],
  "DCLRE1C": [
    "DCLRE1C cnv",
    "DCLRE1C methyl",
    "DCLRE1C proteo",
    "DCLRE1C rna"
  ],
  "DCN": [
    "DCN IADTNITSIPQGLPPSLTELHLDGNK-N2H5F0S0G0 glyco",
    "DCN IADTNITSIPQGLPPSLTELHLDGNK-N2H6F0S0G0 glyco",
    "DCN IADTNITSIPQGLPPSLTELHLDGNK-N3H4F0S0G0 glyco",
    "DCN IADTNITSIPQGLPPSLTELHLDGNK-N4H3F0S0G0 glyco",
    "DCN IADTNITSIPQGLPPSLTELHLDGNK-N4H5F0S0G0 glyco",
    "DCN IADTNITSIPQGLPPSLTELHLDGNK-N4H5F0S1G0 glyco",
    "DCN LGLSFNSISAVDNGSLANTPHLR-N4H3F1S0G0 glyco",
    "DCN LGLSFNSISAVDNGSLANTPHLR-N4H4F1S0G0 glyco",
    "DCN LGLSFNSISAVDNGSLANTPHLR-N4H4F1S1G0 glyco",
    "DCN LGLSFNSISAVDNGSLANTPHLR-N4H5F1S0G0 glyco",
    "DCN LGLSFNSISAVDNGSLANTPHLR-N4H5F1S1G0 glyco",
    "DCN LGLSFNSISAVDNGSLANTPHLR-N5H3F1S0G0 glyco",
    "DCN LGLSFNSISAVDNGSLANTPHLR-N5H4F1S0G0 glyco",
    "DCN LGLSFNSISAVDNGSLANTPHLR-N5H4F1S1G0 glyco",
    "DCN cnv",
    "DCN proteo",
    "DCN rna"
  ],
  "DCP1A": [
    "DCP1A 176_205_1_0 phospho",
    "DCP1A 176_205_1_1_S180 phospho",
    "DCP1A 353_373_1_1_S353 phospho",
    "DCP1A 401_409_1_1_T401 phospho",
    "DCP1A 522_534_1_0 phospho",
    "DCP1A 522_534_1_1_S523 phospho",
    "DCP1A 522_534_1_1_S525 phospho",
    "DCP1A 522_534_2_1_S525 phospho",
    "DCP1A 522_534_2_2_S522S525 phospho",
    "DCP1A 60_68_1_1_S62 phospho",
    "DCP1A cnv",
    "DCP1A methyl",
    "DCP1A proteo",
    "DCP1A rna"
  ],
  "DCP1B": [
    "DCP1B 142_153_1_1_S147 phospho",
    "DCP1B 283_283_1_1_S283 phospho",
    "DCP1B 301_343_1_1_S336 phospho",
    "DCP1B cnv",
    "DCP1B methyl",
    "DCP1B proteo",
    "DCP1B rna"
  ],
  "DCP2": [
    "DCP2 cnv",
    "DCP2 methyl",
    "DCP2 proteo",
    "DCP2 rna"
  ],
  "DCPS": [
    "DCPS 24_25_1_1_S24 phospho",
    "DCPS cnv",
    "DCPS methyl",
    "DCPS proteo",
    "DCPS rna"
  ],
  "DCST1": [
    "DCST1 cnv",
    "DCST1 rna"
  ],
  "DCST2": [
    "DCST2 cnv",
    "DCST2 rna"
  ],
  "DCSTAMP": [
    "DCSTAMP cnv",
    "DCSTAMP rna"
  ],
  "DCT": [
    "DCT cnv",
    "DCT rna"
  ],
  "DCTD": [
    "DCTD cnv",
    "DCTD methyl",
    "DCTD proteo",
    "DCTD rna"
  ],
  "DCTN1": [
    "DCTN1 92_114_1_1_S105 phospho",
    "DCTN1 cnv",
    "DCTN1 methyl",
    "DCTN1 proteo",
    "DCTN1 rna"
  ],
  "DCTN2": [
    "DCTN2 195_211_1_1_T198 phospho",
    "DCTN2 195_219_1_1_T198 phospho",
    "DCTN2 79_86_1_1_S83 phospho",
    "DCTN2 cnv",
    "DCTN2 methyl",
    "DCTN2 proteo",
    "DCTN2 rna"
  ],
  "DCTN3": [
    "DCTN3 cnv",
    "DCTN3 methyl",
    "DCTN3 proteo",
    "DCTN3 rna"
  ],
  "DCTN4": [
    "DCTN4 cnv",
    "DCTN4 methyl",
    "DCTN4 proteo",
    "DCTN4 rna"
  ],
  "DCTN5": [
    "DCTN5 cnv",
    "DCTN5 methyl",
    "DCTN5 proteo",
    "DCTN5 rna"
  ],
  "DCTN6": [
    "DCTN6 cnv",
    "DCTN6 methyl",
    "DCTN6 proteo",
    "DCTN6 rna"
  ],
  "DCTPP1": [
    "DCTPP1 cnv",
    "DCTPP1 methyl",
    "DCTPP1 proteo",
    "DCTPP1 rna"
  ],
  "DCUN1D1": [
    "DCUN1D1 cnv",
    "DCUN1D1 methyl",
    "DCUN1D1 proteo",
    "DCUN1D1 rna"
  ],
  "DCUN1D2": [
    "DCUN1D2 cnv",
    "DCUN1D2 methyl",
    "DCUN1D2 rna"
  ],
  "DCUN1D3": [
    "DCUN1D3 cnv",
    "DCUN1D3 methyl",
    "DCUN1D3 proteo",
    "DCUN1D3 rna"
  ],
  "DCUN1D4": [
    "DCUN1D4 cnv",
    "DCUN1D4 methyl",
    "DCUN1D4 proteo",
    "DCUN1D4 rna"
  ],
  "DCUN1D5": [
    "DCUN1D5 9_9_1_1_S9 phospho",
    "DCUN1D5 cnv",
    "DCUN1D5 methyl",
    "DCUN1D5 proteo",
    "DCUN1D5 rna"
  ],
  "DCX": [
    "DCX 279_289_1_1_S287 phospho",
    "DCX 28_38_1_1_S28 phospho",
    "DCX 304_326_1_0 phospho",
    "DCX 304_326_1_1_S306 phospho",
    "DCX 329_342_1_1_S332 phospho",
    "DCX 332_342_1_1_S339 phospho",
    "DCX 385_402_1_1_S387 phospho",
    "DCX proteo",
    "DCX rna"
  ],
  "DCXR": [
    "DCXR cnv",
    "DCXR methyl",
    "DCXR proteo",
    "DCXR rna"
  ],
  "DCXR-DT": [
    "DCXR-DT methyl"
  ],
  "DDA1": [
    "DDA1 93_102_1_1_S95 phospho",
    "DDA1 cnv",
    "DDA1 proteo",
    "DDA1 rna"
  ],
  "DDAH1": [
    "DDAH1 50_56_1_1_S56 phospho",
    "DDAH1 cnv",
    "DDAH1 methyl",
    "DDAH1 proteo",
    "DDAH1 rna"
  ],
  "DDAH2": [
    "DDAH2 cnv",
    "DDAH2 methyl",
    "DDAH2 proteo",
    "DDAH2 rna"
  ],
  "DDB1": [
    "DDB1 745_768_1_1_S766 phospho",
    "DDB1 cnv",
    "DDB1 methyl",
    "DDB1 proteo",
    "DDB1 rna"
  ],
  "DDB2": [
    "DDB2 24_26_1_1_S26 phospho",
    "DDB2 26_26_1_1_S26 phospho",
    "DDB2 cnv",
    "DDB2 proteo",
    "DDB2 rna"
  ],
  "DDC": [
    "DDC cnv",
    "DDC rna"
  ],
  "DDHD1": [
    "DDHD1 cnv",
    "DDHD1 methyl",
    "DDHD1 proteo",
    "DDHD1 rna"
  ],
  "DDHD1-DT": [
    "DDHD1-DT methyl"
  ],
  "DDHD2": [
    "DDHD2 cnv",
    "DDHD2 methyl",
    "DDHD2 proteo",
    "DDHD2 rna"
  ],
  "DDI1": [
    "DDI1 cnv",
    "DDI1 methyl",
    "DDI1 rna"
  ],
  "DDI2": [
    "DDI2 115_128_1_0 phospho",
    "DDI2 115_128_1_1_S121 phospho",
    "DDI2 115_128_2_1_S121 phospho",
    "DDI2 cnv",
    "DDI2 methyl",
    "DDI2 proteo",
    "DDI2 rna"
  ],
  "DDIAS": [
    "DDIAS cnv",
    "DDIAS methyl",
    "DDIAS rna"
  ],
  "DDIT3": [
    "DDIT3 cnv",
    "DDIT3 methyl",
    "DDIT3 rna"
  ],
  "DDIT4": [
    "DDIT4 cnv",
    "DDIT4 methyl",
    "DDIT4 rna"
  ],
  "DDIT4L": [
    "DDIT4L cnv",
    "DDIT4L methyl",
    "DDIT4L rna"
  ],
  "DDIT4L-AS1": [
    "DDIT4L-AS1 methyl"
  ],
  "DDN": [
    "DDN 563_578_1_1_S567 phospho",
    "DDN cnv",
    "DDN methyl",
    "DDN rna"
  ],
  "DDN-AS1": [
    "DDN-AS1 methyl"
  ],
  "DDO": [
    "DDO cnv",
    "DDO proteo",
    "DDO rna"
  ],
  "DDOST": [
    "DDOST cnv",
    "DDOST methyl",
    "DDOST proteo",
    "DDOST rna"
  ],
  "DDR1": [
    "DDR1 cnv",
    "DDR1 kinase",
    "DDR1 methyl",
    "DDR1 proteo",
    "DDR1 rna"
  ],
  "DDR2": [
    "DDR2 cnv",
    "DDR2 kinase",
    "DDR2 proteo",
    "DDR2 rna"
  ],
  "DDRGK1": [
    "DDRGK1 cnv",
    "DDRGK1 methyl",
    "DDRGK1 proteo",
    "DDRGK1 rna"
  ],
  "DDT": [
    "DDT cnv",
    "DDT proteo",
    "DDT rna"
  ],
  "DDTL": [
    "DDTL cnv",
    "DDTL rna"
  ],
  "DDX1": [
    "DDX1 475_486_1_1_S481 phospho",
    "DDX1 cnv",
    "DDX1 methyl",
    "DDX1 proteo",
    "DDX1 rna"
  ],
  "DDX10": [
    "DDX10 4_10_1_1_S7 phospho",
    "DDX10 539_541_1_1_S539 phospho",
    "DDX10 cnv",
    "DDX10 methyl",
    "DDX10 proteo",
    "DDX10 rna"
  ],
  "DDX11": [
    "DDX11 cnv",
    "DDX11 methyl",
    "DDX11 rna"
  ],
  "DDX11-AS1": [
    "DDX11-AS1 methyl"
  ],
  "DDX17": [
    "DDX17 571_582_1_0 phospho",
    "DDX17 571_582_1_1_S573 phospho",
    "DDX17 673_682_1_1_S674 phospho",
    "DDX17 cnv",
    "DDX17 methyl",
    "DDX17 proteo",
    "DDX17 rna"
  ],
  "DDX18": [
    "DDX18 cnv",
    "DDX18 methyl",
    "DDX18 proteo",
    "DDX18 rna"
  ],
  "DDX19A": [
    "DDX19A cnv",
    "DDX19A methyl",
    "DDX19A proteo",
    "DDX19A rna"
  ],
  "DDX19A-DT": [
    "DDX19A-DT methyl"
  ],
  "DDX19B": [
    "DDX19B cnv",
    "DDX19B methyl",
    "DDX19B proteo",
    "DDX19B rna"
  ],
  "DDX20": [
    "DDX20 520_522_1_1_S522 phospho",
    "DDX20 672_678_1_1_S678 phospho",
    "DDX20 cnv",
    "DDX20 methyl",
    "DDX20 proteo",
    "DDX20 rna"
  ],
  "DDX21": [
    "DDX21 121_121_1_1_S121 phospho",
    "DDX21 84_89_1_1_S89 phospho",
    "DDX21 cnv",
    "DDX21 methyl",
    "DDX21 proteo",
    "DDX21 rna"
  ],
  "DDX23": [
    "DDX23 cnv",
    "DDX23 methyl",
    "DDX23 proteo",
    "DDX23 rna"
  ],
  "DDX24": [
    "DDX24 82_82_1_1_S82 phospho",
    "DDX24 cnv",
    "DDX24 methyl",
    "DDX24 proteo",
    "DDX24 rna"
  ],
  "DDX25": [
    "DDX25 cnv",
    "DDX25 methyl",
    "DDX25 rna"
  ],
  "DDX27": [
    "DDX27 cnv",
    "DDX27 methyl",
    "DDX27 proteo",
    "DDX27 rna"
  ],
  "DDX28": [
    "DDX28 cnv",
    "DDX28 methyl",
    "DDX28 proteo",
    "DDX28 rna"
  ],
  "DDX31": [
    "DDX31 cnv",
    "DDX31 methyl",
    "DDX31 proteo",
    "DDX31 rna"
  ],
  "DDX39A": [
    "DDX39A cnv",
    "DDX39A methyl",
    "DDX39A proteo",
    "DDX39A rna"
  ],
  "DDX39B": [
    "DDX39B cnv",
    "DDX39B methyl",
    "DDX39B proteo",
    "DDX39B rna"
  ],
  "DDX39B-AS1": [
    "DDX39B-AS1 methyl"
  ],
  "DDX3X": [
    "DDX3X methyl",
    "DDX3X proteo",
    "DDX3X rna"
  ],
  "DDX3Y": [
    "DDX3Y methyl",
    "DDX3Y proteo",
    "DDX3Y rna"
  ],
  "DDX4": [
    "DDX4 cnv",
    "DDX4 methyl",
    "DDX4 rna"
  ],
  "DDX41": [
    "DDX41 13_36_1_1_S23 phospho",
    "DDX41 66_86_1_0 phospho",
    "DDX41 66_86_2_2_S66S68 phospho",
    "DDX41 cnv",
    "DDX41 methyl",
    "DDX41 proteo",
    "DDX41 rna"
  ],
  "DDX42": [
    "DDX42 163_193_1_0 phospho",
    "DDX42 723_758_1_1_S754 phospho",
    "DDX42 cnv",
    "DDX42 methyl",
    "DDX42 proteo",
    "DDX42 rna"
  ],
  "DDX43": [
    "DDX43 cnv",
    "DDX43 methyl",
    "DDX43 rna"
  ],
  "DDX46": [
    "DDX46 cnv",
    "DDX46 methyl",
    "DDX46 proteo",
    "DDX46 rna"
  ],
  "DDX47": [
    "DDX47 cnv",
    "DDX47 methyl",
    "DDX47 proteo",
    "DDX47 rna"
  ],
  "DDX49": [
    "DDX49 cnv",
    "DDX49 methyl",
    "DDX49 rna"
  ],
  "DDX5": [
    "DDX5 cnv",
    "DDX5 methyl",
    "DDX5 proteo",
    "DDX5 rna"
  ],
  "DDX50": [
    "DDX50 39_41_1_1_S41 phospho",
    "DDX50 cnv",
    "DDX50 methyl",
    "DDX50 proteo",
    "DDX50 rna"
  ],
  "DDX51": [
    "DDX51 83_83_1_1_S83 phospho",
    "DDX51 cnv",
    "DDX51 methyl",
    "DDX51 proteo",
    "DDX51 rna"
  ],
  "DDX52": [
    "DDX52 cnv",
    "DDX52 methyl",
    "DDX52 rna"
  ],
  "DDX53": [
    "DDX53 rna"
  ],
  "DDX54": [
    "DDX54 782_788_1_1_S782 phospho",
    "DDX54 cnv",
    "DDX54 methyl",
    "DDX54 proteo",
    "DDX54 rna"
  ],
  "DDX55": [
    "DDX55 cnv",
    "DDX55 methyl",
    "DDX55 rna"
  ],
  "DDX56": [
    "DDX56 cnv",
    "DDX56 methyl",
    "DDX56 proteo",
    "DDX56 rna"
  ],
  "DDX58": [
    "DDX58 cnv",
    "DDX58 methyl",
    "DDX58 proteo",
    "DDX58 rna"
  ],
  "DDX59": [
    "DDX59 156_168_1_1_S160 phospho",
    "DDX59 cnv",
    "DDX59 methyl",
    "DDX59 proteo",
    "DDX59 rna"
  ],
  "DDX6": [
    "DDX6 cnv",
    "DDX6 methyl",
    "DDX6 proteo",
    "DDX6 rna"
  ],
  "DDX60": [
    "DDX60 cnv",
    "DDX60 proteo",
    "DDX60 rna"
  ],
  "DDX60L": [
    "DDX60L cnv",
    "DDX60L methyl",
    "DDX60L rna"
  ],
  "DEAF1": [
    "DEAF1 171_179_1_1_S176 phospho",
    "DEAF1 cnv",
    "DEAF1 methyl",
    "DEAF1 rna"
  ],
  "DECR1": [
    "DECR1 cnv",
    "DECR1 methyl",
    "DECR1 proteo",
    "DECR1 rna"
  ],
  "DECR2": [
    "DECR2 cnv",
    "DECR2 methyl",
    "DECR2 proteo",
    "DECR2 rna"
  ],
  "DEDD": [
    "DEDD cnv",
    "DEDD rna"
  ],
  "DEDD2": [
    "DEDD2 cnv",
    "DEDD2 methyl",
    "DEDD2 rna"
  ],
  "DEF6": [
    "DEF6 595_600_1_1_S597 phospho",
    "DEF6 cnv",
    "DEF6 proteo",
    "DEF6 rna"
  ],
  "DEF8": [
    "DEF8 430_430_1_1_S430 phospho",
    "DEF8 cnv",
    "DEF8 methyl",
    "DEF8 proteo",
    "DEF8 rna"
  ],
  "DEFA1": [
    "DEFA1 cnv",
    "DEFA1 rna"
  ],
  "DEFA1B": [
    "DEFA1B cnv",
    "DEFA1B proteo",
    "DEFA1B rna"
  ],
  "DEFA3": [
    "DEFA3 cnv",
    "DEFA3 proteo",
    "DEFA3 rna"
  ],
  "DEFA4": [
    "DEFA4 cnv",
    "DEFA4 rna"
  ],
  "DEFA5": [
    "DEFA5 cnv"
  ],
  "DEFA6": [
    "DEFA6 cnv"
  ],
  "DEFB1": [
    "DEFB1 cnv",
    "DEFB1 rna"
  ],
  "DEFB103A": [
    "DEFB103A cnv"
  ],
  "DEFB103B": [
    "DEFB103B cnv"
  ],
  "DEFB104A": [
    "DEFB104A cnv"
  ],
  "DEFB104B": [
    "DEFB104B cnv"
  ],
  "DEFB105A": [
    "DEFB105A cnv"
  ],
  "DEFB105B": [
    "DEFB105B cnv"
  ],
  "DEFB106A": [
    "DEFB106A cnv"
  ],
  "DEFB106B": [
    "DEFB106B cnv"
  ],
  "DEFB107A": [
    "DEFB107A cnv"
  ],
  "DEFB107B": [
    "DEFB107B cnv"
  ],
  "DEFB108B": [
    "DEFB108B cnv"
  ],
  "DEFB109B": [
    "DEFB109B cnv"
  ],
  "DEFB110": [
    "DEFB110 cnv"
  ],
  "DEFB112": [
    "DEFB112 cnv"
  ],
  "DEFB113": [
    "DEFB113 cnv"
  ],
  "DEFB114": [
    "DEFB114 cnv"
  ],
  "DEFB115": [
    "DEFB115 cnv"
  ],
  "DEFB116": [
    "DEFB116 cnv"
  ],
  "DEFB118": [
    "DEFB118 cnv"
  ],
  "DEFB119": [
    "DEFB119 cnv"
  ],
  "DEFB121": [
    "DEFB121 cnv"
  ],
  "DEFB123": [
    "DEFB123 cnv"
  ],
  "DEFB124": [
    "DEFB124 cnv",
    "DEFB124 methyl",
    "DEFB124 rna"
  ],
  "DEFB125": [
    "DEFB125 cnv",
    "DEFB125 rna"
  ],
  "DEFB126": [
    "DEFB126 cnv"
  ],
  "DEFB127": [
    "DEFB127 cnv"
  ],
  "DEFB128": [
    "DEFB128 cnv"
  ],
  "DEFB129": [
    "DEFB129 cnv"
  ],
  "DEFB130A": [
    "DEFB130A cnv"
  ],
  "DEFB130B": [
    "DEFB130B cnv"
  ],
  "DEFB131A": [
    "DEFB131A cnv"
  ],
  "DEFB131B": [
    "DEFB131B cnv"
  ],
  "DEFB132": [
    "DEFB132 cnv"
  ],
  "DEFB134": [
    "DEFB134 cnv",
    "DEFB134 rna"
  ],
  "DEFB135": [
    "DEFB135 cnv"
  ],
  "DEFB136": [
    "DEFB136 cnv"
  ],
  "DEFB4A": [
    "DEFB4A cnv"
  ],
  "DEFB4B": [
    "DEFB4B cnv"
  ],
  "DEGS1": [
    "DEGS1 cnv",
    "DEGS1 methyl",
    "DEGS1 proteo",
    "DEGS1 rna"
  ],
  "DEGS2": [
    "DEGS2 cnv",
    "DEGS2 methyl",
    "DEGS2 rna"
  ],
  "DEK": [
    "DEK 251_251_1_1_S251 phospho",
    "DEK 301_307_1_1_S307 phospho",
    "DEK 32_32_1_1_S32 phospho",
    "DEK cnv",
    "DEK methyl",
    "DEK proteo",
    "DEK rna"
  ],
  "DELE1": [
    "DELE1 cnv",
    "DELE1 methyl",
    "DELE1 rna"
  ],
  "DENND10": [
    "DENND10 cnv",
    "DENND10 methyl",
    "DENND10 proteo",
    "DENND10 rna"
  ],
  "DENND11": [
    "DENND11 cnv",
    "DENND11 methyl",
    "DENND11 proteo",
    "DENND11 rna"
  ],
  "DENND1A": [
    "DENND1A 519_530_1_1_S523 phospho",
    "DENND1A 532_546_1_1_S536 phospho",
    "DENND1A 592_592_1_1_S592 phospho",
    "DENND1A 707_707_1_1_T707 phospho",
    "DENND1A 923_923_1_1_T923 phospho",
    "DENND1A cnv",
    "DENND1A proteo",
    "DENND1A rna"
  ],
  "DENND1B": [
    "DENND1B cnv",
    "DENND1B methyl",
    "DENND1B rna"
  ],
  "DENND1C": [
    "DENND1C cnv",
    "DENND1C methyl",
    "DENND1C rna"
  ],
  "DENND2A": [
    "DENND2A 404_414_1_0 phospho",
    "DENND2A 404_414_1_1_S404 phospho",
    "DENND2A 504_511_1_1_S504 phospho",
    "DENND2A cnv",
    "DENND2A methyl",
    "DENND2A proteo",
    "DENND2A rna"
  ],
  "DENND2B": [
    "DENND2B 357_371_1_1_S368 phospho",
    "DENND2B 404_431_1_0 phospho",
    "DENND2B 42_53_1_1_S48 phospho",
    "DENND2B 622_624_1_1_S622 phospho",
    "DENND2B cnv",
    "DENND2B methyl",
    "DENND2B proteo",
    "DENND2B rna"
  ],
  "DENND2C": [
    "DENND2C cnv",
    "DENND2C methyl",
    "DENND2C rna"
  ],
  "DENND2D": [
    "DENND2D cnv",
    "DENND2D methyl",
    "DENND2D rna"
  ],
  "DENND3": [
    "DENND3 cnv",
    "DENND3 methyl",
    "DENND3 proteo",
    "DENND3 rna"
  ],
  "DENND3-AS1": [
    "DENND3-AS1 methyl"
  ],
  "DENND4A": [
    "DENND4A 1283_1283_1_1_S1283 phospho",
    "DENND4A 1551_1568_1_0 phospho",
    "DENND4A 1551_1568_1_1_S1554 phospho",
    "DENND4A 1630_1642_1_1_S1630 phospho",
    "DENND4A cnv",
    "DENND4A methyl",
    "DENND4A proteo",
    "DENND4A rna"
  ],
  "DENND4B": [
    "DENND4B 732_736_2_2_S732S736 phospho",
    "DENND4B 947_953_1_1_S947 phospho",
    "DENND4B 947_953_1_1_S953 phospho",
    "DENND4B cnv",
    "DENND4B methyl",
    "DENND4B proteo",
    "DENND4B rna"
  ],
  "DENND4C": [
    "DENND4C 1014_1032_1_0 phospho",
    "DENND4C 1014_1032_2_1_S1017 phospho",
    "DENND4C 1014_1032_2_2_S1017S1022 phospho",
    "DENND4C 1109_1116_1_0 phospho",
    "DENND4C 1146_1159_1_1_S1148 phospho",
    "DENND4C 1232_1235_1_1_S1233 phospho",
    "DENND4C 1274_1274_1_1_S1274 phospho",
    "DENND4C 1326_1342_1_0 phospho",
    "DENND4C 1326_1342_1_1_S1327 phospho",
    "DENND4C 1381_1395_1_1_S1386 phospho",
    "DENND4C 1662_1667_1_1_S1662 phospho",
    "DENND4C 1847_1863_1_1_S1848 phospho",
    "DENND4C 734_739_1_1_S737 phospho",
    "DENND4C 734_741_1_1_S741 phospho",
    "DENND4C 953_970_1_1_S953 phospho",
    "DENND4C cnv",
    "DENND4C proteo",
    "DENND4C rna"
  ],
  "DENND5A": [
    "DENND5A 1067_1087_1_1_T1079 phospho",
    "DENND5A 833_846_2_2_T833S836 phospho",
    "DENND5A cnv",
    "DENND5A methyl",
    "DENND5A proteo",
    "DENND5A rna"
  ],
  "DENND5B": [
    "DENND5B 1097_1097_1_1_T1097 phospho",
    "DENND5B 1111_1116_1_1_S1111 phospho",
    "DENND5B 211_224_1_1_S213 phospho",
    "DENND5B cnv",
    "DENND5B methyl",
    "DENND5B proteo",
    "DENND5B rna"
  ],
  "DENND5B-AS1": [
    "DENND5B-AS1 methyl"
  ],
  "DENND6A": [
    "DENND6A 127_127_1_1_S127 phospho",
    "DENND6A cnv",
    "DENND6A methyl",
    "DENND6A proteo",
    "DENND6A rna"
  ],
  "DENND6A-DT": [
    "DENND6A-DT methyl"
  ],
  "DENND6B": [
    "DENND6B cnv",
    "DENND6B rna"
  ],
  "DENR": [
    "DENR 69_73_1_1_S73 phospho",
    "DENR 69_86_1_1_S73 phospho",
    "DENR cnv",
    "DENR methyl",
    "DENR proteo",
    "DENR rna"
  ],
  "DEPDC1": [
    "DEPDC1 cnv",
    "DEPDC1 methyl",
    "DEPDC1 rna"
  ],
  "DEPDC1-AS1": [
    "DEPDC1-AS1 methyl"
  ],
  "DEPDC1B": [
    "DEPDC1B cnv",
    "DEPDC1B methyl",
    "DEPDC1B rna"
  ],
  "DEPDC4": [
    "DEPDC4 cnv",
    "DEPDC4 methyl",
    "DEPDC4 rna"
  ],
  "DEPDC5": [
    "DEPDC5 1430_1434_1_1_S1430 phospho",
    "DEPDC5 518_525_1_1_S525 phospho",
    "DEPDC5 579_592_1_1_S579 phospho",
    "DEPDC5 741_759_1_0 phospho",
    "DEPDC5 cnv",
    "DEPDC5 methyl",
    "DEPDC5 proteo",
    "DEPDC5 rna"
  ],
  "DEPDC7": [
    "DEPDC7 cnv",
    "DEPDC7 methyl",
    "DEPDC7 rna"
  ],
  "DEPP1": [
    "DEPP1 cnv",
    "DEPP1 rna"
  ],
  "DEPTOR": [
    "DEPTOR 157_166_1_1_S164 phospho",
    "DEPTOR 178_198_1_0 phospho",
    "DEPTOR 178_198_2_0 phospho",
    "DEPTOR cnv",
    "DEPTOR methyl",
    "DEPTOR proteo",
    "DEPTOR rna"
  ],
  "DERA": [
    "DERA cnv",
    "DERA methyl",
    "DERA proteo",
    "DERA rna"
  ],
  "DERL1": [
    "DERL1 cnv",
    "DERL1 methyl",
    "DERL1 proteo",
    "DERL1 rna"
  ],
  "DERL2": [
    "DERL2 cnv",
    "DERL2 methyl",
    "DERL2 proteo",
    "DERL2 rna"
  ],
  "DERL3": [
    "DERL3 cnv",
    "DERL3 methyl",
    "DERL3 rna"
  ],
  "DERPC": [
    "DERPC cnv",
    "DERPC methyl",
    "DERPC rna"
  ],
  "DES": [
    "DES 17_32_1_1_S28 phospho",
    "DES 17_32_2_2_S28S32 phospho",
    "DES 431_432_1_1_S432 phospho",
    "DES cnv",
    "DES proteo",
    "DES rna"
  ],
  "DESI1": [
    "DESI1 25_25_1_1_S25 phospho",
    "DESI1 cnv",
    "DESI1 methyl",
    "DESI1 proteo",
    "DESI1 rna"
  ],
  "DESI2": [
    "DESI2 cnv",
    "DESI2 methyl",
    "DESI2 rna"
  ],
  "DET1": [
    "DET1 cnv",
    "DET1 proteo",
    "DET1 rna"
  ],
  "DEUP1": [
    "DEUP1 cnv",
    "DEUP1 methyl",
    "DEUP1 rna"
  ],
  "DEXI": [
    "DEXI cnv",
    "DEXI methyl",
    "DEXI rna"
  ],
  "DFFA": [
    "DFFA 308_315_1_1_S315 phospho",
    "DFFA 315_315_1_1_S315 phospho",
    "DFFA cnv",
    "DFFA methyl",
    "DFFA proteo",
    "DFFA rna"
  ],
  "DFFB": [
    "DFFB cnv",
    "DFFB methyl",
    "DFFB proteo",
    "DFFB rna"
  ],
  "DGAT1": [
    "DGAT1 cnv",
    "DGAT1 methyl",
    "DGAT1 proteo",
    "DGAT1 rna"
  ],
  "DGAT2": [
    "DGAT2 cnv",
    "DGAT2 methyl",
    "DGAT2 rna"
  ],
  "DGAT2-DT": [
    "DGAT2-DT methyl"
  ],
  "DGAT2L6": [
    "DGAT2L6 rna"
  ],
  "DGCR2": [
    "DGCR2 cnv",
    "DGCR2 methyl",
    "DGCR2 proteo",
    "DGCR2 rna"
  ],
  "DGCR5": [
    "DGCR5 methyl"
  ],
  "DGCR6": [
    "DGCR6 cnv",
    "DGCR6 methyl",
    "DGCR6 rna"
  ],
  "DGCR6L": [
    "DGCR6L cnv",
    "DGCR6L methyl",
    "DGCR6L rna"
  ],
  "DGCR8": [
    "DGCR8 267_286_1_1_S275 phospho",
    "DGCR8 267_286_2_2_S271S275 phospho",
    "DGCR8 367_383_1_1_S377 phospho",
    "DGCR8 92_95_1_1_S95 phospho",
    "DGCR8 cnv",
    "DGCR8 methyl",
    "DGCR8 proteo",
    "DGCR8 rna"
  ],
  "DGKA": [
    "DGKA cnv",
    "DGKA methyl",
    "DGKA proteo",
    "DGKA rna"
  ],
  "DGKB": [
    "DGKB 117_129_1_1_T117 phospho",
    "DGKB 94_95_1_1_S95 phospho",
    "DGKB cnv",
    "DGKB proteo",
    "DGKB rna"
  ],
  "DGKD": [
    "DGKD cnv",
    "DGKD methyl",
    "DGKD rna"
  ],
  "DGKE": [
    "DGKE cnv",
    "DGKE methyl",
    "DGKE proteo",
    "DGKE rna"
  ],
  "DGKG": [
    "DGKG cnv",
    "DGKG methyl",
    "DGKG proteo",
    "DGKG rna"
  ],
  "DGKH": [
    "DGKH cnv",
    "DGKH methyl",
    "DGKH proteo",
    "DGKH rna"
  ],
  "DGKI": [
    "DGKI cnv",
    "DGKI methyl",
    "DGKI proteo",
    "DGKI rna"
  ],
  "DGKK": [
    "DGKK methyl",
    "DGKK rna"
  ],
  "DGKQ": [
    "DGKQ cnv",
    "DGKQ methyl",
    "DGKQ proteo",
    "DGKQ rna"
  ],
  "DGKZ": [
    "DGKZ 706_708_1_0 phospho",
    "DGKZ cnv",
    "DGKZ methyl",
    "DGKZ proteo",
    "DGKZ rna"
  ],
  "DGLUCY": [
    "DGLUCY cnv",
    "DGLUCY methyl",
    "DGLUCY proteo",
    "DGLUCY rna"
  ],
  "DGUOK": [
    "DGUOK cnv",
    "DGUOK methyl",
    "DGUOK proteo",
    "DGUOK rna"
  ],
  "DHCR24": [
    "DHCR24 cnv",
    "DHCR24 methyl",
    "DHCR24 proteo",
    "DHCR24 rna"
  ],
  "DHCR7": [
    "DHCR7 cnv",
    "DHCR7 methyl",
    "DHCR7 proteo",
    "DHCR7 rna"
  ],
  "DHDDS": [
    "DHDDS cnv",
    "DHDDS methyl",
    "DHDDS rna"
  ],
  "DHDH": [
    "DHDH cnv",
    "DHDH methyl",
    "DHDH rna"
  ],
  "DHFR": [
    "DHFR cnv",
    "DHFR methyl",
    "DHFR proteo",
    "DHFR rna"
  ],
  "DHFR2": [
    "DHFR2 cnv",
    "DHFR2 methyl",
    "DHFR2 rna"
  ],
  "DHH": [
    "DHH cnv",
    "DHH rna"
  ],
  "DHODH": [
    "DHODH cnv",
    "DHODH methyl",
    "DHODH proteo",
    "DHODH rna"
  ],
  "DHPS": [
    "DHPS cnv",
    "DHPS methyl",
    "DHPS proteo",
    "DHPS rna"
  ],
  "DHRS1": [
    "DHRS1 cnv",
    "DHRS1 methyl",
    "DHRS1 proteo",
    "DHRS1 rna"
  ],
  "DHRS11": [
    "DHRS11 cnv",
    "DHRS11 methyl",
    "DHRS11 proteo",
    "DHRS11 rna"
  ],
  "DHRS12": [
    "DHRS12 cnv",
    "DHRS12 methyl",
    "DHRS12 rna"
  ],
  "DHRS13": [
    "DHRS13 cnv",
    "DHRS13 methyl",
    "DHRS13 proteo",
    "DHRS13 rna"
  ],
  "DHRS2": [
    "DHRS2 cnv",
    "DHRS2 rna"
  ],
  "DHRS3": [
    "DHRS3 cnv",
    "DHRS3 methyl",
    "DHRS3 proteo",
    "DHRS3 rna"
  ],
  "DHRS4": [
    "DHRS4 cnv",
    "DHRS4 methyl",
    "DHRS4 proteo",
    "DHRS4 rna"
  ],
  "DHRS4-AS1": [
    "DHRS4-AS1 methyl"
  ],
  "DHRS4L2": [
    "DHRS4L2 cnv",
    "DHRS4L2 methyl",
    "DHRS4L2 rna"
  ],
  "DHRS7": [
    "DHRS7 cnv",
    "DHRS7 methyl",
    "DHRS7 proteo",
    "DHRS7 rna"
  ],
  "DHRS7B": [
    "DHRS7B cnv",
    "DHRS7B methyl",
    "DHRS7B proteo",
    "DHRS7B rna"
  ],
  "DHRS7C": [
    "DHRS7C cnv",
    "DHRS7C rna"
  ],
  "DHRS9": [
    "DHRS9 cnv",
    "DHRS9 rna"
  ],
  "DHRSX": [
    "DHRSX proteo",
    "DHRSX rna"
  ],
  "DHTKD1": [
    "DHTKD1 cnv",
    "DHTKD1 methyl",
    "DHTKD1 proteo",
    "DHTKD1 rna"
  ],
  "DHX15": [
    "DHX15 cnv",
    "DHX15 methyl",
    "DHX15 proteo",
    "DHX15 rna"
  ],
  "DHX16": [
    "DHX16 43_52_2_2_S43S46 phospho",
    "DHX16 cnv",
    "DHX16 methyl",
    "DHX16 proteo",
    "DHX16 rna"
  ],
  "DHX29": [
    "DHX29 cnv",
    "DHX29 methyl",
    "DHX29 proteo",
    "DHX29 rna"
  ],
  "DHX30": [
    "DHX30 197_206_1_1_S198 phospho",
    "DHX30 cnv",
    "DHX30 methyl",
    "DHX30 proteo",
    "DHX30 rna"
  ],
  "DHX32": [
    "DHX32 cnv",
    "DHX32 methyl",
    "DHX32 proteo",
    "DHX32 rna"
  ],
  "DHX33": [
    "DHX33 cnv",
    "DHX33 methyl",
    "DHX33 proteo",
    "DHX33 rna"
  ],
  "DHX33-DT": [
    "DHX33-DT methyl"
  ],
  "DHX34": [
    "DHX34 cnv",
    "DHX34 methyl",
    "DHX34 rna"
  ],
  "DHX35": [
    "DHX35 cnv",
    "DHX35 methyl",
    "DHX35 rna"
  ],
  "DHX36": [
    "DHX36 cnv",
    "DHX36 proteo",
    "DHX36 rna"
  ],
  "DHX37": [
    "DHX37 cnv",
    "DHX37 methyl",
    "DHX37 proteo",
    "DHX37 rna"
  ],
  "DHX38": [
    "DHX38 cnv",
    "DHX38 methyl",
    "DHX38 proteo",
    "DHX38 rna"
  ],
  "DHX40": [
    "DHX40 cnv",
    "DHX40 methyl",
    "DHX40 proteo",
    "DHX40 rna"
  ],
  "DHX57": [
    "DHX57 132_132_1_1_S132 phospho",
    "DHX57 cnv",
    "DHX57 methyl",
    "DHX57 proteo",
    "DHX57 rna"
  ],
  "DHX58": [
    "DHX58 cnv",
    "DHX58 proteo",
    "DHX58 rna"
  ],
  "DHX8": [
    "DHX8 456_460_1_1_S460 phospho",
    "DHX8 cnv",
    "DHX8 methyl",
    "DHX8 proteo",
    "DHX8 rna"
  ],
  "DHX9": [
    "DHX9 125_138_1_1_S125 phospho",
    "DHX9 77_108_1_0 phospho",
    "DHX9 77_108_1_1_S87 phospho",
    "DHX9 cnv",
    "DHX9 methyl",
    "DHX9 proteo",
    "DHX9 rna"
  ],
  "DIABLO": [
    "DIABLO cnv",
    "DIABLO methyl",
    "DIABLO proteo",
    "DIABLO rna"
  ],
  "DIAPH1": [
    "DIAPH1 22_28_1_1_S22 phospho",
    "DIAPH1 cnv",
    "DIAPH1 methyl",
    "DIAPH1 proteo",
    "DIAPH1 rna"
  ],
  "DIAPH2": [
    "DIAPH2 methyl",
    "DIAPH2 proteo",
    "DIAPH2 rna"
  ],
  "DIAPH3": [
    "DIAPH3 cnv",
    "DIAPH3 methyl",
    "DIAPH3 rna"
  ],
  "DICER1": [
    "DICER1 cnv",
    "DICER1 methyl",
    "DICER1 proteo",
    "DICER1 rna"
  ],
  "DICER1-AS1": [
    "DICER1-AS1 methyl"
  ],
  "DIDO1": [
    "DIDO1 1011_1019_1_1_S1019 phospho",
    "DIDO1 1712_1719_1_1_S1714 phospho",
    "DIDO1 1712_1733_1_0 phospho",
    "DIDO1 1712_1733_1_1_S1714 phospho",
    "DIDO1 805_817_2_2_S805S809 phospho",
    "DIDO1 cnv",
    "DIDO1 methyl",
    "DIDO1 proteo",
    "DIDO1 rna"
  ],
  "DIMT1": [
    "DIMT1 cnv",
    "DIMT1 methyl",
    "DIMT1 proteo",
    "DIMT1 rna"
  ],
  "DINOL": [
    "DINOL methyl"
  ],
  "DIO1": [
    "DIO1 cnv",
    "DIO1 rna"
  ],
  "DIO2": [
    "DIO2 cnv",
    "DIO2 rna"
  ],
  "DIO3": [
    "DIO3 cnv",
    "DIO3 methyl",
    "DIO3 rna"
  ],
  "DIO3OS": [
    "DIO3OS methyl"
  ],
  "DIP2A": [
    "DIP2A cnv",
    "DIP2A methyl",
    "DIP2A proteo",
    "DIP2A rna"
  ],
  "DIP2B": [
    "DIP2B 178_193_1_1_S178 phospho",
    "DIP2B 178_193_1_1_S187 phospho",
    "DIP2B 255_271_1_1_S259 phospho",
    "DIP2B cnv",
    "DIP2B methyl",
    "DIP2B proteo",
    "DIP2B rna"
  ],
  "DIP2C": [
    "DIP2C cnv",
    "DIP2C methyl",
    "DIP2C proteo",
    "DIP2C rna"
  ],
  "DIPK1A": [
    "DIPK1A cnv",
    "DIPK1A methyl",
    "DIPK1A rna"
  ],
  "DIPK1B": [
    "DIPK1B cnv",
    "DIPK1B methyl",
    "DIPK1B rna"
  ],
  "DIPK1C": [
    "DIPK1C cnv",
    "DIPK1C methyl",
    "DIPK1C rna"
  ],
  "DIPK2A": [
    "DIPK2A cnv",
    "DIPK2A methyl",
    "DIPK2A proteo",
    "DIPK2A rna"
  ],
  "DIPK2B": [
    "DIPK2B rna"
  ],
  "DIRAS1": [
    "DIRAS1 cnv",
    "DIRAS1 methyl",
    "DIRAS1 proteo",
    "DIRAS1 rna"
  ],
  "DIRAS2": [
    "DIRAS2 126_134_1_1_S126 phospho",
    "DIRAS2 31_44_1_1_S35 phospho",
    "DIRAS2 cnv",
    "DIRAS2 methyl",
    "DIRAS2 proteo",
    "DIRAS2 rna"
  ],
  "DIRAS3": [
    "DIRAS3 cnv",
    "DIRAS3 methyl",
    "DIRAS3 rna"
  ],
  "DIS3": [
    "DIS3 cnv",
    "DIS3 methyl",
    "DIS3 proteo",
    "DIS3 rna"
  ],
  "DIS3L": [
    "DIS3L cnv",
    "DIS3L methyl",
    "DIS3L rna"
  ],
  "DIS3L2": [
    "DIS3L2 128_154_1_1_S139 phospho",
    "DIS3L2 cnv",
    "DIS3L2 methyl",
    "DIS3L2 proteo",
    "DIS3L2 rna"
  ],
  "DISC1": [
    "DISC1 237_241_1_1_S241 phospho",
    "DISC1 97_100_1_1_S97 phospho",
    "DISC1 cnv",
    "DISC1 methyl",
    "DISC1 proteo",
    "DISC1 rna"
  ],
  "DISP1": [
    "DISP1 cnv",
    "DISP1 methyl",
    "DISP1 rna"
  ],
  "DISP2": [
    "DISP2 1173_1183_1_1_S1173 phospho",
    "DISP2 1173_1183_1_1_S1175 phospho",
    "DISP2 1243_1243_1_1_S1243 phospho",
    "DISP2 cnv",
    "DISP2 methyl",
    "DISP2 proteo",
    "DISP2 rna"
  ],
  "DISP3": [
    "DISP3 cnv",
    "DISP3 methyl",
    "DISP3 rna"
  ],
  "DIXDC1": [
    "DIXDC1 590_601_1_1_S592 phospho",
    "DIXDC1 cnv",
    "DIXDC1 methyl",
    "DIXDC1 rna"
  ],
  "DKC1": [
    "DKC1 446_453_1_1_S450 phospho",
    "DKC1 446_453_2_0 phospho",
    "DKC1 446_453_2_2_S446S448 phospho",
    "DKC1 480_492_1_1_S489 phospho",
    "DKC1 480_492_2_2_S480S489 phospho",
    "DKC1 508_508_1_1_S508 phospho",
    "DKC1 methyl",
    "DKC1 proteo",
    "DKC1 rna"
  ],
  "DKFZP434A062": [
    "DKFZP434A062 methyl"
  ],
  "DKK1": [
    "DKK1 cnv",
    "DKK1 methyl",
    "DKK1 rna"
  ],
  "DKK2": [
    "DKK2 cnv",
    "DKK2 methyl",
    "DKK2 rna"
  ],
  "DKK3": [
    "DKK3 cnv",
    "DKK3 methyl",
    "DKK3 proteo",
    "DKK3 rna"
  ],
  "DKK4": [
    "DKK4 cnv",
    "DKK4 rna"
  ],
  "DKKL1": [
    "DKKL1 cnv",
    "DKKL1 methyl",
    "DKKL1 rna"
  ],
  "DLAT": [
    "DLAT cnv",
    "DLAT methyl",
    "DLAT proteo",
    "DLAT rna"
  ],
  "DLC1": [
    "DLC1 120_132_2_2_S120S123 phospho",
    "DLC1 163_167_1_1_S163 phospho",
    "DLC1 437_447_1_1_T437 phospho",
    "DLC1 cnv",
    "DLC1 methyl",
    "DLC1 rna"
  ],
  "DLD": [
    "DLD cnv",
    "DLD methyl",
    "DLD proteo",
    "DLD rna"
  ],
  "DLEC1": [
    "DLEC1 cnv",
    "DLEC1 methyl",
    "DLEC1 rna"
  ],
  "DLEU1": [
    "DLEU1 methyl"
  ],
  "DLEU2": [
    "DLEU2 methyl"
  ],
  "DLEU7": [
    "DLEU7 cnv",
    "DLEU7 methyl",
    "DLEU7 rna"
  ],
  "DLG1": [
    "DLG1 143_158_1_1_S158 phospho",
    "DLG1 373_410_1_1_S410 phospho",
    "DLG1 40_51_1_1_S40 phospho",
    "DLG1 534_542_1_1_S542 phospho",
    "DLG1 562_569_1_1_S565 phospho",
    "DLG1 671_681_1_1_S672 phospho",
    "DLG1 671_681_1_1_S675 phospho",
    "DLG1 cnv",
    "DLG1 methyl",
    "DLG1 proteo",
    "DLG1 rna"
  ],
  "DLG1-AS1": [
    "DLG1-AS1 methyl"
  ],
  "DLG2": [
    "DLG2 123_133_1_1_S133 phospho",
    "DLG2 155_170_1_1_S170 phospho",
    "DLG2 422_433_1_1_S433 phospho",
    "DLG2 422_433_2_2_S428S433 phospho",
    "DLG2 469_470_1_1_S470 phospho",
    "DLG2 756_778_1_1_S761 phospho",
    "DLG2 cnv",
    "DLG2 methyl",
    "DLG2 proteo",
    "DLG2 rna"
  ],
  "DLG3": [
    "DLG3 355_368_1_0 phospho",
    "DLG3 methyl",
    "DLG3 proteo",
    "DLG3 rna"
  ],
  "DLG4": [
    "DLG4 232_237_1_1_Y237 phospho",
    "DLG4 291_292_1_1_S292 phospho",
    "DLG4 411_419_1_1_S412 phospho",
    "DLG4 411_419_1_1_S415 phospho",
    "DLG4 cnv",
    "DLG4 methyl",
    "DLG4 proteo",
    "DLG4 rna"
  ],
  "DLG5": [
    "DLG5 1011_1011_1_1_T1011 phospho",
    "DLG5 1019_1021_1_1_S1021 phospho",
    "DLG5 1142_1161_1_1_S1146 phospho",
    "DLG5 1249_1258_1_0 phospho",
    "DLG5 1666_1677_1_1_S1666 phospho",
    "DLG5 264_264_1_1_S264 phospho",
    "DLG5 295_296_1_0 phospho",
    "DLG5 295_296_1_1_S295 phospho",
    "DLG5 984_1004_2_2_T984S1000 phospho",
    "DLG5 990_1004_1_1_S1000 phospho",
    "DLG5 cnv",
    "DLG5 methyl",
    "DLG5 proteo",
    "DLG5 rna"
  ],
  "DLGAP1": [
    "DLGAP1 152_159_1_1_S154 phospho",
    "DLGAP1 169_169_1_1_S169 phospho",
    "DLGAP1 356_366_1_1_S356 phospho",
    "DLGAP1 356_366_1_1_S362 phospho",
    "DLGAP1 356_366_2_2_S356S359 phospho",
    "DLGAP1 380_389_1_1_S383 phospho",
    "DLGAP1 393_397_1_1_S397 phospho",
    "DLGAP1 419_431_1_1_S431 phospho",
    "DLGAP1 503_510_1_1_S503 phospho",
    "DLGAP1 582_595_1_1_S589 phospho",
    "DLGAP1 582_595_1_1_S592 phospho",
    "DLGAP1 932_936_1_1_S932 phospho",
    "DLGAP1 958_975_1_1_S958 phospho",
    "DLGAP1 cnv",
    "DLGAP1 methyl",
    "DLGAP1 proteo",
    "DLGAP1 rna"
  ],
  "DLGAP2": [
    "DLGAP2 1008_1008_1_1_S1008 phospho",
    "DLGAP2 243_250_1_1_S245 phospho",
    "DLGAP2 733_745_1_1_S741 phospho",
    "DLGAP2 cnv",
    "DLGAP2 methyl",
    "DLGAP2 proteo",
    "DLGAP2 rna"
  ],
  "DLGAP3": [
    "DLGAP3 184_186_1_1_S186 phospho",
    "DLGAP3 714_714_1_1_S714 phospho",
    "DLGAP3 781_785_1_1_S781 phospho",
    "DLGAP3 781_789_1_1_S789 phospho",
    "DLGAP3 cnv",
    "DLGAP3 methyl",
    "DLGAP3 proteo",
    "DLGAP3 rna"
  ],
  "DLGAP4": [
    "DLGAP4 126_127_1_0 phospho",
    "DLGAP4 126_127_1_1_S127 phospho",
    "DLGAP4 156_160_1_1_S156 phospho",
    "DLGAP4 402_410_1_1_S405 phospho",
    "DLGAP4 711_722_1_1_S713 phospho",
    "DLGAP4 711_722_2_2_T711S713 phospho",
    "DLGAP4 729_741_1_1_S741 phospho",
    "DLGAP4 760_787_1_0 phospho",
    "DLGAP4 906_912_1_1_T912 phospho",
    "DLGAP4 970_987_1_1_S970 phospho",
    "DLGAP4 cnv",
    "DLGAP4 methyl",
    "DLGAP4 proteo",
    "DLGAP4 rna"
  ],
  "DLGAP4-AS1": [
    "DLGAP4-AS1 methyl"
  ],
  "DLGAP5": [
    "DLGAP5 cnv",
    "DLGAP5 methyl",
    "DLGAP5 rna"
  ],
  "DLK1": [
    "DLK1 cnv",
    "DLK1 methyl",
    "DLK1 rna"
  ],
  "DLK2": [
    "DLK2 cnv",
    "DLK2 methyl",
    "DLK2 rna"
  ],
  "DLL1": [
    "DLL1 cnv",
    "DLL1 methyl",
    "DLL1 rna"
  ],
  "DLL3": [
    "DLL3 cnv",
    "DLL3 methyl",
    "DLL3 proteo",
    "DLL3 rna"
  ],
  "DLL4": [
    "DLL4 cnv",
    "DLL4 methyl",
    "DLL4 rna"
  ],
  "DLST": [
    "DLST cnv",
    "DLST methyl",
    "DLST proteo",
    "DLST rna"
  ],
  "DLX1": [
    "DLX1 cnv",
    "DLX1 methyl",
    "DLX1 rna"
  ],
  "DLX2": [
    "DLX2 cnv",
    "DLX2 methyl",
    "DLX2 rna"
  ],
  "DLX2-DT": [
    "DLX2-DT methyl"
  ],
  "DLX3": [
    "DLX3 cnv",
    "DLX3 methyl",
    "DLX3 rna"
  ],
  "DLX4": [
    "DLX4 cnv",
    "DLX4 methyl",
    "DLX4 rna"
  ],
  "DLX5": [
    "DLX5 cnv",
    "DLX5 methyl",
    "DLX5 rna"
  ],
  "DLX6": [
    "DLX6 cnv",
    "DLX6 methyl",
    "DLX6 rna"
  ],
  "DM1-AS": [
    "DM1-AS methyl"
  ],
  "DMAC1": [
    "DMAC1 cnv",
    "DMAC1 methyl",
    "DMAC1 rna"
  ],
  "DMAC2": [
    "DMAC2 cnv",
    "DMAC2 methyl",
    "DMAC2 rna"
  ],
  "DMAC2L": [
    "DMAC2L cnv",
    "DMAC2L methyl",
    "DMAC2L proteo",
    "DMAC2L rna"
  ],
  "DMAP1": [
    "DMAP1 435_448_1_1_T445 phospho",
    "DMAP1 454_460_1_1_S454 phospho",
    "DMAP1 cnv",
    "DMAP1 methyl",
    "DMAP1 proteo",
    "DMAP1 rna"
  ],
  "DMBT1": [
    "DMBT1 cnv",
    "DMBT1 rna"
  ],
  "DMBX1": [
    "DMBX1 cnv",
    "DMBX1 methyl",
    "DMBX1 rna"
  ],
  "DMC1": [
    "DMC1 cnv",
    "DMC1 methyl",
    "DMC1 rna"
  ],
  "DMD": [
    "DMD 1136_1144_1_1_S1140 phospho",
    "DMD 934_962_1_0 phospho",
    "DMD methyl",
    "DMD proteo",
    "DMD rna"
  ],
  "DMGDH": [
    "DMGDH cnv",
    "DMGDH methyl",
    "DMGDH rna"
  ],
  "DMKN": [
    "DMKN cnv",
    "DMKN rna"
  ],
  "DMP1": [
    "DMP1 cnv",
    "DMP1 rna"
  ],
  "DMPK": [
    "DMPK cnv",
    "DMPK kinase",
    "DMPK methyl",
    "DMPK rna"
  ],
  "DMRT1": [
    "DMRT1 cnv",
    "DMRT1 methyl",
    "DMRT1 rna"
  ],
  "DMRT2": [
    "DMRT2 cnv",
    "DMRT2 methyl",
    "DMRT2 rna"
  ],
  "DMRT3": [
    "DMRT3 cnv",
    "DMRT3 methyl",
    "DMRT3 rna"
  ],
  "DMRTA1": [
    "DMRTA1 cnv",
    "DMRTA1 methyl",
    "DMRTA1 rna"
  ],
  "DMRTA2": [
    "DMRTA2 cnv",
    "DMRTA2 methyl",
    "DMRTA2 rna"
  ],
  "DMRTB1": [
    "DMRTB1 cnv",
    "DMRTB1 methyl",
    "DMRTB1 rna"
  ],
  "DMRTC1": [
    "DMRTC1 rna"
  ],
  "DMRTC1B": [
    "DMRTC1B rna"
  ],
  "DMRTC2": [
    "DMRTC2 cnv",
    "DMRTC2 methyl"
  ],
  "DMTF1": [
    "DMTF1 cnv",
    "DMTF1 methyl",
    "DMTF1 rna"
  ],
  "DMTF1-AS1": [
    "DMTF1-AS1 methyl"
  ],
  "DMTN": [
    "DMTN 10_18_1_1_S11 phospho",
    "DMTN 10_29_1_0 phospho",
    "DMTN 10_29_1_1_S16 phospho",
    "DMTN 10_29_2_0 phospho",
    "DMTN 123_141_1_1_S124 phospho",
    "DMTN 152_159_1_1_S152 phospho",
    "DMTN 226_226_1_1_S226 phospho",
    "DMTN 269_285_1_1_S269 phospho",
    "DMTN 274_285_1_0 phospho",
    "DMTN 303_315_1_0 phospho",
    "DMTN 303_329_1_0 phospho",
    "DMTN 333_333_1_1_S333 phospho",
    "DMTN 85_87_1_1_S85 phospho",
    "DMTN 90_103_1_1_S92 phospho",
    "DMTN 90_103_2_2_S92S96 phospho",
    "DMTN cnv",
    "DMTN methyl",
    "DMTN proteo",
    "DMTN rna"
  ],
  "DMWD": [
    "DMWD 388_419_1_1_S397 phospho",
    "DMWD 397_419_1_1_S397 phospho",
    "DMWD 459_476_1_1_T461 phospho",
    "DMWD 461_476_1_1_T469 phospho",
    "DMWD 489_495_2_0 phospho",
    "DMWD 493_495_1_1_S495 phospho",
    "DMWD 543_550_1_0 phospho",
    "DMWD 554_565_1_1_S554 phospho",
    "DMWD 636_654_1_1_S652 phospho",
    "DMWD 656_672_1_1_S668 phospho",
    "DMWD cnv",
    "DMWD methyl",
    "DMWD proteo",
    "DMWD rna"
  ],
  "DMXL1": [
    "DMXL1 1895_1901_1_1_S1896 phospho",
    "DMXL1 1905_1908_1_1_S1908 phospho",
    "DMXL1 204_213_1_1_S208 phospho",
    "DMXL1 324_333_1_1_S324 phospho",
    "DMXL1 905_918_1_0 phospho",
    "DMXL1 cnv",
    "DMXL1 methyl",
    "DMXL1 proteo",
    "DMXL1 rna"
  ],
  "DMXL2": [
    "DMXL2 1151_1156_1_1_S1151 phospho",
    "DMXL2 1398_1405_1_1_S1400 phospho",
    "DMXL2 1857_1864_1_1_S1857 phospho",
    "DMXL2 2400_2410_1_1_S2400 phospho",
    "DMXL2 2641_2649_1_1_S2641 phospho",
    "DMXL2 325_339_1_0 phospho",
    "DMXL2 325_339_1_1_S325 phospho",
    "DMXL2 325_339_1_1_S326 phospho",
    "DMXL2 451_473_1_1_S473 phospho",
    "DMXL2 574_596_1_1_S588 phospho",
    "DMXL2 925_935_1_1_S930 phospho",
    "DMXL2 cnv",
    "DMXL2 methyl",
    "DMXL2 proteo",
    "DMXL2 rna"
  ],
  "DNA2": [
    "DNA2 cnv",
    "DNA2 methyl",
    "DNA2 rna"
  ],
  "DNAAF1": [
    "DNAAF1 cnv",
    "DNAAF1 methyl",
    "DNAAF1 proteo",
    "DNAAF1 rna"
  ],
  "DNAAF10": [
    "DNAAF10 cnv",
    "DNAAF10 methyl",
    "DNAAF10 proteo",
    "DNAAF10 rna"
  ],
  "DNAAF11": [
    "DNAAF11 cnv",
    "DNAAF11 methyl",
    "DNAAF11 rna"
  ],
  "DNAAF2": [
    "DNAAF2 cnv",
    "DNAAF2 methyl",
    "DNAAF2 proteo",
    "DNAAF2 rna"
  ],
  "DNAAF3": [
    "DNAAF3 cnv",
    "DNAAF3 methyl",
    "DNAAF3 rna"
  ],
  "DNAAF4": [
    "DNAAF4 cnv",
    "DNAAF4 methyl",
    "DNAAF4 rna"
  ],
  "DNAAF4-CCPG1": [
    "DNAAF4-CCPG1 cnv",
    "DNAAF4-CCPG1 methyl",
    "DNAAF4-CCPG1 rna"
  ],
  "DNAAF5": [
    "DNAAF5 cnv",
    "DNAAF5 methyl",
    "DNAAF5 proteo",
    "DNAAF5 rna"
  ],
  "DNAAF6": [
    "DNAAF6 methyl",
    "DNAAF6 rna"
  ],
  "DNAAF8": [
    "DNAAF8 cnv",
    "DNAAF8 methyl",
    "DNAAF8 rna"
  ],
  "DNAAF9": [
    "DNAAF9 cnv",
    "DNAAF9 methyl",
    "DNAAF9 rna"
  ],
  "DNAH1": [
    "DNAH1 cnv",
    "DNAH1 rna"
  ],
  "DNAH10": [
    "DNAH10 cnv",
    "DNAH10 methyl",
    "DNAH10 rna"
  ],
  "DNAH10OS": [
    "DNAH10OS cnv",
    "DNAH10OS rna"
  ],
  "DNAH11": [
    "DNAH11 cnv",
    "DNAH11 methyl",
    "DNAH11 rna"
  ],
  "DNAH12": [
    "DNAH12 cnv",
    "DNAH12 rna"
  ],
  "DNAH14": [
    "DNAH14 cnv",
    "DNAH14 methyl",
    "DNAH14 rna"
  ],
  "DNAH17": [
    "DNAH17 cnv",
    "DNAH17 methyl",
    "DNAH17 rna"
  ],
  "DNAH2": [
    "DNAH2 cnv",
    "DNAH2 methyl",
    "DNAH2 rna"
  ],
  "DNAH3": [
    "DNAH3 cnv",
    "DNAH3 rna"
  ],
  "DNAH5": [
    "DNAH5 cnv",
    "DNAH5 methyl",
    "DNAH5 mut",
    "DNAH5 rna"
  ],
  "DNAH6": [
    "DNAH6 cnv",
    "DNAH6 methyl",
    "DNAH6 rna"
  ],
  "DNAH7": [
    "DNAH7 cnv",
    "DNAH7 methyl",
    "DNAH7 rna"
  ],
  "DNAH8": [
    "DNAH8 cnv",
    "DNAH8 methyl",
    "DNAH8 rna"
  ],
  "DNAH9": [
    "DNAH9 cnv",
    "DNAH9 methyl",
    "DNAH9 rna"
  ],
  "DNAI1": [
    "DNAI1 cnv",
    "DNAI1 methyl",
    "DNAI1 rna"
  ],
  "DNAI2": [
    "DNAI2 cnv",
    "DNAI2 methyl",
    "DNAI2 rna"
  ],
  "DNAI3": [
    "DNAI3 cnv",
    "DNAI3 methyl",
    "DNAI3 rna"
  ],
  "DNAI4": [
    "DNAI4 cnv",
    "DNAI4 methyl",
    "DNAI4 rna"
  ],
  "DNAI7": [
    "DNAI7 cnv",
    "DNAI7 methyl",
    "DNAI7 rna"
  ],
  "DNAJA1": [
    "DNAJA1 cnv",
    "DNAJA1 methyl",
    "DNAJA1 proteo",
    "DNAJA1 rna"
  ],
  "DNAJA2": [
    "DNAJA2 cnv",
    "DNAJA2 methyl",
    "DNAJA2 proteo",
    "DNAJA2 rna"
  ],
  "DNAJA3": [
    "DNAJA3 cnv",
    "DNAJA3 methyl",
    "DNAJA3 proteo",
    "DNAJA3 rna"
  ],
  "DNAJA4": [
    "DNAJA4 cnv",
    "DNAJA4 methyl",
    "DNAJA4 proteo",
    "DNAJA4 rna"
  ],
  "DNAJB1": [
    "DNAJB1 151_151_1_1_S151 phospho",
    "DNAJB1 cnv",
    "DNAJB1 methyl",
    "DNAJB1 proteo",
    "DNAJB1 rna"
  ],
  "DNAJB11": [
    "DNAJB11 188_188_1_1_T188 phospho",
    "DNAJB11 cnv",
    "DNAJB11 methyl",
    "DNAJB11 proteo",
    "DNAJB11 rna"
  ],
  "DNAJB12": [
    "DNAJB12 cnv",
    "DNAJB12 methyl",
    "DNAJB12 proteo",
    "DNAJB12 rna"
  ],
  "DNAJB13": [
    "DNAJB13 cnv",
    "DNAJB13 rna"
  ],
  "DNAJB14": [
    "DNAJB14 cnv",
    "DNAJB14 methyl",
    "DNAJB14 proteo",
    "DNAJB14 rna"
  ],
  "DNAJB2": [
    "DNAJB2 311_313_1_1_S313 phospho",
    "DNAJB2 311_313_2_2_S311S313 phospho",
    "DNAJB2 cnv",
    "DNAJB2 methyl",
    "DNAJB2 proteo",
    "DNAJB2 rna"
  ],
  "DNAJB3": [
    "DNAJB3 methyl"
  ],
  "DNAJB4": [
    "DNAJB4 cnv",
    "DNAJB4 methyl",
    "DNAJB4 proteo",
    "DNAJB4 rna"
  ],
  "DNAJB5": [
    "DNAJB5 cnv",
    "DNAJB5 methyl",
    "DNAJB5 proteo",
    "DNAJB5 rna"
  ],
  "DNAJB5-DT": [
    "DNAJB5-DT methyl"
  ],
  "DNAJB6": [
    "DNAJB6 277_277_1_1_S277 phospho",
    "DNAJB6 cnv",
    "DNAJB6 methyl",
    "DNAJB6 proteo",
    "DNAJB6 rna"
  ],
  "DNAJB7": [
    "DNAJB7 cnv",
    "DNAJB7 rna"
  ],
  "DNAJB8": [
    "DNAJB8 cnv",
    "DNAJB8 rna"
  ],
  "DNAJB9": [
    "DNAJB9 cnv",
    "DNAJB9 methyl",
    "DNAJB9 proteo",
    "DNAJB9 rna"
  ],
  "DNAJC1": [
    "DNAJC1 479_484_2_2_S479S480 phospho",
    "DNAJC1 cnv",
    "DNAJC1 methyl",
    "DNAJC1 proteo",
    "DNAJC1 rna"
  ],
  "DNAJC10": [
    "DNAJC10 cnv",
    "DNAJC10 methyl",
    "DNAJC10 proteo",
    "DNAJC10 rna"
  ],
  "DNAJC11": [
    "DNAJC11 cnv",
    "DNAJC11 methyl",
    "DNAJC11 proteo",
    "DNAJC11 rna"
  ],
  "DNAJC12": [
    "DNAJC12 158_167_1_1_S160 phospho",
    "DNAJC12 cnv",
    "DNAJC12 proteo",
    "DNAJC12 rna"
  ],
  "DNAJC13": [
    "DNAJC13 cnv",
    "DNAJC13 methyl",
    "DNAJC13 proteo",
    "DNAJC13 rna"
  ],
  "DNAJC14": [
    "DNAJC14 cnv",
    "DNAJC14 methyl",
    "DNAJC14 proteo",
    "DNAJC14 rna"
  ],
  "DNAJC15": [
    "DNAJC15 cnv",
    "DNAJC15 methyl",
    "DNAJC15 rna"
  ],
  "DNAJC16": [
    "DNAJC16 cnv",
    "DNAJC16 methyl",
    "DNAJC16 proteo",
    "DNAJC16 rna"
  ],
  "DNAJC17": [
    "DNAJC17 112_118_1_1_S112 phospho",
    "DNAJC17 cnv",
    "DNAJC17 methyl",
    "DNAJC17 proteo",
    "DNAJC17 rna"
  ],
  "DNAJC18": [
    "DNAJC18 cnv",
    "DNAJC18 rna"
  ],
  "DNAJC19": [
    "DNAJC19 cnv",
    "DNAJC19 methyl",
    "DNAJC19 proteo",
    "DNAJC19 rna"
  ],
  "DNAJC2": [
    "DNAJC2 47_49_1_1_S47 phospho",
    "DNAJC2 47_49_2_2_S47S49 phospho",
    "DNAJC2 cnv",
    "DNAJC2 methyl",
    "DNAJC2 proteo",
    "DNAJC2 rna"
  ],
  "DNAJC21": [
    "DNAJC21 283_283_1_1_S283 phospho",
    "DNAJC21 357_370_1_1_S370 phospho",
    "DNAJC21 cnv",
    "DNAJC21 methyl",
    "DNAJC21 proteo",
    "DNAJC21 rna"
  ],
  "DNAJC22": [
    "DNAJC22 cnv",
    "DNAJC22 methyl",
    "DNAJC22 rna"
  ],
  "DNAJC24": [
    "DNAJC24 cnv",
    "DNAJC24 methyl",
    "DNAJC24 rna"
  ],
  "DNAJC25": [
    "DNAJC25 cnv",
    "DNAJC25 methyl",
    "DNAJC25 proteo",
    "DNAJC25 rna"
  ],
  "DNAJC25-GNG10": [
    "DNAJC25-GNG10 cnv",
    "DNAJC25-GNG10 methyl",
    "DNAJC25-GNG10 rna"
  ],
  "DNAJC27": [
    "DNAJC27 cnv",
    "DNAJC27 methyl",
    "DNAJC27 rna"
  ],
  "DNAJC27-AS1": [
    "DNAJC27-AS1 methyl"
  ],
  "DNAJC28": [
    "DNAJC28 cnv",
    "DNAJC28 methyl",
    "DNAJC28 rna"
  ],
  "DNAJC3": [
    "DNAJC3 cnv",
    "DNAJC3 methyl",
    "DNAJC3 proteo",
    "DNAJC3 rna"
  ],
  "DNAJC3-DT": [
    "DNAJC3-DT methyl"
  ],
  "DNAJC30": [
    "DNAJC30 cnv",
    "DNAJC30 methyl",
    "DNAJC30 proteo",
    "DNAJC30 rna"
  ],
  "DNAJC4": [
    "DNAJC4 cnv",
    "DNAJC4 methyl",
    "DNAJC4 rna"
  ],
  "DNAJC5": [
    "DNAJC5 8_17_1_0 phospho",
    "DNAJC5 8_17_1_1_S10 phospho",
    "DNAJC5 8_17_1_1_S12 phospho",
    "DNAJC5 8_17_1_1_S15 phospho",
    "DNAJC5 8_17_2_2_S12S15 phospho",
    "DNAJC5 cnv",
    "DNAJC5 methyl",
    "DNAJC5 proteo",
    "DNAJC5 rna"
  ],
  "DNAJC5B": [
    "DNAJC5B cnv",
    "DNAJC5B rna"
  ],
  "DNAJC5G": [
    "DNAJC5G cnv",
    "DNAJC5G rna"
  ],
  "DNAJC6": [
    "DNAJC6 163_169_1_1_S169 phospho",
    "DNAJC6 496_522_1_1_S513 phospho",
    "DNAJC6 673_693_1_1_S673 phospho",
    "DNAJC6 673_709_1_1_S675 phospho",
    "DNAJC6 67_75_1_1_S68 phospho",
    "DNAJC6 797_814_1_0 phospho",
    "DNAJC6 797_814_1_1_S802 phospho",
    "DNAJC6 cnv",
    "DNAJC6 methyl",
    "DNAJC6 proteo",
    "DNAJC6 rna"
  ],
  "DNAJC7": [
    "DNAJC7 cnv",
    "DNAJC7 methyl",
    "DNAJC7 proteo",
    "DNAJC7 rna"
  ],
  "DNAJC8": [
    "DNAJC8 35_39_1_1_S35 phospho",
    "DNAJC8 cnv",
    "DNAJC8 methyl",
    "DNAJC8 proteo",
    "DNAJC8 rna"
  ],
  "DNAJC9": [
    "DNAJC9 cnv",
    "DNAJC9 methyl",
    "DNAJC9 proteo",
    "DNAJC9 rna"
  ],
  "DNAJC9-AS1": [
    "DNAJC9-AS1 methyl"
  ],
  "DNAL1": [
    "DNAL1 cnv",
    "DNAL1 methyl",
    "DNAL1 proteo",
    "DNAL1 rna"
  ],
  "DNAL4": [
    "DNAL4 cnv",
    "DNAL4 rna"
  ],
  "DNALI1": [
    "DNALI1 cnv",
    "DNALI1 methyl",
    "DNALI1 proteo",
    "DNALI1 rna"
  ],
  "DNASE1": [
    "DNASE1 cnv",
    "DNASE1 methyl",
    "DNASE1 rna"
  ],
  "DNASE1L1": [
    "DNASE1L1 methyl",
    "DNASE1L1 proteo",
    "DNASE1L1 rna"
  ],
  "DNASE1L2": [
    "DNASE1L2 cnv",
    "DNASE1L2 methyl",
    "DNASE1L2 rna"
  ],
  "DNASE1L3": [
    "DNASE1L3 cnv",
    "DNASE1L3 rna"
  ],
  "DNASE2": [
    "DNASE2 cnv",
    "DNASE2 methyl",
    "DNASE2 proteo",
    "DNASE2 rna"
  ],
  "DNASE2B": [
    "DNASE2B cnv",
    "DNASE2B rna"
  ],
  "DND1": [
    "DND1 cnv",
    "DND1 methyl",
    "DND1 rna"
  ],
  "DNER": [
    "DNER 685_696_1_1_S696 phospho",
    "DNER cnv",
    "DNER methyl",
    "DNER proteo",
    "DNER rna"
  ],
  "DNHD1": [
    "DNHD1 cnv",
    "DNHD1 rna"
  ],
  "DNLZ": [
    "DNLZ cnv",
    "DNLZ methyl",
    "DNLZ proteo",
    "DNLZ rna"
  ],
  "DNM1": [
    "DNM1 261_265_1_1_S264 phospho",
    "DNM1 774_780_1_1_S774 phospho",
    "DNM1 774_780_2_2_S774S778 phospho",
    "DNM1 807_834_1_0 phospho",
    "DNM1 807_834_1_1_S817 phospho",
    "DNM1 847_857_1_1_S857 phospho",
    "DNM1 cnv",
    "DNM1 methyl",
    "DNM1 proteo",
    "DNM1 rna"
  ],
  "DNM1L": [
    "DNM1L 596_605_1_0 phospho",
    "DNM1L cnv",
    "DNM1L methyl",
    "DNM1L proteo",
    "DNM1L rna"
  ],
  "DNM2": [
    "DNM2 cnv",
    "DNM2 methyl",
    "DNM2 proteo",
    "DNM2 rna"
  ],
  "DNM3": [
    "DNM3 759_766_1_1_S759 phospho",
    "DNM3 759_766_2_2_S759S763 phospho",
    "DNM3 791_829_1_1_S791 phospho",
    "DNM3 cnv",
    "DNM3 methyl",
    "DNM3 proteo",
    "DNM3 rna"
  ],
  "DNMBP": [
    "DNMBP cnv",
    "DNMBP methyl",
    "DNMBP proteo",
    "DNMBP rna"
  ],
  "DNMT1": [
    "DNMT1 cnv",
    "DNMT1 methyl",
    "DNMT1 proteo",
    "DNMT1 rna"
  ],
  "DNMT3A": [
    "DNMT3A 138_138_1_1_T138 phospho",
    "DNMT3A 97_105_1_1_S105 phospho",
    "DNMT3A cnv",
    "DNMT3A methyl",
    "DNMT3A proteo",
    "DNMT3A rna"
  ],
  "DNMT3B": [
    "DNMT3B cnv",
    "DNMT3B methyl",
    "DNMT3B rna"
  ],
  "DNMT3L": [
    "DNMT3L cnv",
    "DNMT3L rna"
  ],
  "DNPEP": [
    "DNPEP cnv",
    "DNPEP methyl",
    "DNPEP proteo",
    "DNPEP rna"
  ],
  "DNPH1": [
    "DNPH1 157_174_1_1_S169 phospho",
    "DNPH1 cnv",
    "DNPH1 methyl",
    "DNPH1 proteo",
    "DNPH1 rna"
  ],
  "DNTT": [
    "DNTT cnv",
    "DNTT rna"
  ],
  "DNTTIP1": [
    "DNTTIP1 161_161_1_1_S161 phospho",
    "DNTTIP1 cnv",
    "DNTTIP1 methyl",
    "DNTTIP1 proteo",
    "DNTTIP1 rna"
  ],
  "DNTTIP2": [
    "DNTTIP2 251_270_1_1_S253 phospho",
    "DNTTIP2 cnv",
    "DNTTIP2 methyl",
    "DNTTIP2 proteo",
    "DNTTIP2 rna"
  ],
  "DOC2A": [
    "DOC2A 221_226_1_1_S221 phospho",
    "DOC2A cnv",
    "DOC2A methyl",
    "DOC2A proteo",
    "DOC2A rna"
  ],
  "DOC2B": [
    "DOC2B cnv",
    "DOC2B methyl",
    "DOC2B rna"
  ],
  "DOCK1": [
    "DOCK1 1702_1702_1_1_S1702 phospho",
    "DOCK1 1777_1793_1_1_S1777 phospho",
    "DOCK1 1878_1882_1_1_S1879 phospho",
    "DOCK1 cnv",
    "DOCK1 methyl",
    "DOCK1 proteo",
    "DOCK1 rna"
  ],
  "DOCK10": [
    "DOCK10 1257_1263_1_1_S1257 phospho",
    "DOCK10 1289_1299_1_1_S1292 phospho",
    "DOCK10 1289_1299_2_2_S1292S1295 phospho",
    "DOCK10 302_329_1_0 phospho",
    "DOCK10 875_880_1_1_S877 phospho",
    "DOCK10 cnv",
    "DOCK10 methyl",
    "DOCK10 proteo",
    "DOCK10 rna"
  ],
  "DOCK11": [
    "DOCK11 1237_1259_1_1_S1237 phospho",
    "DOCK11 431_440_1_1_S440 phospho",
    "DOCK11 methyl",
    "DOCK11 proteo",
    "DOCK11 rna"
  ],
  "DOCK2": [
    "DOCK2 1705_1706_1_1_S1706 phospho",
    "DOCK2 1731_1736_1_1_S1731 phospho",
    "DOCK2 cnv",
    "DOCK2 methyl",
    "DOCK2 proteo",
    "DOCK2 rna"
  ],
  "DOCK3": [
    "DOCK3 1653_1661_1_1_S1658 phospho",
    "DOCK3 1824_1829_1_1_S1824 phospho",
    "DOCK3 cnv",
    "DOCK3 methyl",
    "DOCK3 proteo",
    "DOCK3 rna"
  ],
  "DOCK4": [
    "DOCK4 1594_1616_1_1_S1616 phospho",
    "DOCK4 1623_1633_1_1_S1623 phospho",
    "DOCK4 1623_1633_1_1_S1629 phospho",
    "DOCK4 1640_1644_1_1_S1640 phospho",
    "DOCK4 1709_1713_1_1_S1709 phospho",
    "DOCK4 1759_1764_1_1_S1759 phospho",
    "DOCK4 1773_1781_1_1_S1778 phospho",
    "DOCK4 1906_1915_1_1_T1908 phospho",
    "DOCK4 1928_1935_1_1_S1930 phospho",
    "DOCK4 cnv",
    "DOCK4 methyl",
    "DOCK4 proteo",
    "DOCK4 rna"
  ],
  "DOCK5": [
    "DOCK5 1742_1742_1_1_S1742 phospho",
    "DOCK5 1800_1814_1_0 phospho",
    "DOCK5 cnv",
    "DOCK5 methyl",
    "DOCK5 proteo",
    "DOCK5 rna"
  ],
  "DOCK6": [
    "DOCK6 1230_1239_1_1_S1230 phospho",
    "DOCK6 176_182_1_1_S178 phospho",
    "DOCK6 880_900_1_1_S884 phospho",
    "DOCK6 cnv",
    "DOCK6 methyl",
    "DOCK6 proteo",
    "DOCK6 rna"
  ],
  "DOCK7": [
    "DOCK7 1127_1163_1_1_T1142 phospho",
    "DOCK7 1383_1385_1_1_S1383 phospho",
    "DOCK7 1421_1429_1_1_S1421 phospho",
    "DOCK7 180_186_1_1_S180 phospho",
    "DOCK7 180_186_2_2_S180S182 phospho",
    "DOCK7 24_30_1_1_S30 phospho",
    "DOCK7 450_470_1_1_S452 phospho",
    "DOCK7 858_878_1_0 phospho",
    "DOCK7 858_878_1_1_S864 phospho",
    "DOCK7 896_910_1_1_S900 phospho",
    "DOCK7 896_910_1_1_S910 phospho",
    "DOCK7 896_910_2_2_S896S900 phospho",
    "DOCK7 896_910_2_2_S900S910 phospho",
    "DOCK7 927_933_1_0 phospho",
    "DOCK7 927_933_1_1_S929 phospho",
    "DOCK7 943_952_1_1_S946 phospho",
    "DOCK7 958_958_1_1_S958 phospho",
    "DOCK7 963_976_1_1_S964 phospho",
    "DOCK7 cnv",
    "DOCK7 methyl",
    "DOCK7 proteo",
    "DOCK7 rna"
  ],
  "DOCK8": [
    "DOCK8 383_391_1_1_S383 phospho",
    "DOCK8 834_845_1_0 phospho",
    "DOCK8 834_845_1_1_S836 phospho",
    "DOCK8 cnv",
    "DOCK8 methyl",
    "DOCK8 proteo",
    "DOCK8 rna"
  ],
  "DOCK9": [
    "DOCK9 1251_1263_1_1_S1254 phospho",
    "DOCK9 1272_1287_1_1_S1274 phospho",
    "DOCK9 430_444_1_1_S442 phospho",
    "DOCK9 cnv",
    "DOCK9 methyl",
    "DOCK9 proteo",
    "DOCK9 rna"
  ],
  "DOHH": [
    "DOHH cnv",
    "DOHH methyl",
    "DOHH proteo",
    "DOHH rna"
  ],
  "DOK1": [
    "DOK1 130_130_1_1_S130 phospho",
    "DOK1 130_163_1_1_S130 phospho",
    "DOK1 cnv",
    "DOK1 methyl",
    "DOK1 proteo",
    "DOK1 rna"
  ],
  "DOK2": [
    "DOK2 cnv",
    "DOK2 rna"
  ],
  "DOK3": [
    "DOK3 273_280_1_1_S274 phospho",
    "DOK3 cnv",
    "DOK3 proteo",
    "DOK3 rna"
  ],
  "DOK4": [
    "DOK4 cnv",
    "DOK4 rna"
  ],
  "DOK5": [
    "DOK5 277_282_1_1_S277 phospho",
    "DOK5 cnv",
    "DOK5 methyl",
    "DOK5 rna"
  ],
  "DOK6": [
    "DOK6 cnv",
    "DOK6 methyl",
    "DOK6 rna"
  ],
  "DOK7": [
    "DOK7 cnv",
    "DOK7 methyl",
    "DOK7 rna"
  ],
  "DOLK": [
    "DOLK cnv",
    "DOLK methyl",
    "DOLK proteo",
    "DOLK rna"
  ],
  "DOLPP1": [
    "DOLPP1 cnv",
    "DOLPP1 methyl",
    "DOLPP1 proteo",
    "DOLPP1 rna"
  ],
  "DONSON": [
    "DONSON cnv",
    "DONSON methyl",
    "DONSON rna"
  ],
  "DOP1A": [
    "DOP1A cnv",
    "DOP1A methyl",
    "DOP1A proteo",
    "DOP1A rna"
  ],
  "DOP1B": [
    "DOP1B 1021_1021_1_1_S1021 phospho",
    "DOP1B cnv",
    "DOP1B methyl",
    "DOP1B proteo",
    "DOP1B rna"
  ],
  "DOT1L": [
    "DOT1L 1093_1104_1_1_S1104 phospho",
    "DOT1L 1152_1157_1_1_S1153 phospho",
    "DOT1L 764_775_1_1_S775 phospho",
    "DOT1L 997_1009_1_1_S1001 phospho",
    "DOT1L cnv",
    "DOT1L methyl",
    "DOT1L proteo",
    "DOT1L rna"
  ],
  "DPAGT1": [
    "DPAGT1 cnv",
    "DPAGT1 methyl",
    "DPAGT1 rna"
  ],
  "DPCD": [
    "DPCD cnv",
    "DPCD methyl",
    "DPCD proteo",
    "DPCD rna"
  ],
  "DPEP1": [
    "DPEP1 cnv",
    "DPEP1 proteo",
    "DPEP1 rna"
  ],
  "DPEP2": [
    "DPEP2 cnv",
    "DPEP2 methyl",
    "DPEP2 rna"
  ],
  "DPEP2NB": [
    "DPEP2NB cnv",
    "DPEP2NB rna"
  ],
  "DPEP3": [
    "DPEP3 cnv",
    "DPEP3 methyl",
    "DPEP3 rna"
  ],
  "DPF1": [
    "DPF1 cnv",
    "DPF1 methyl",
    "DPF1 rna"
  ],
  "DPF2": [
    "DPF2 239_265_1_1_T262 phospho",
    "DPF2 cnv",
    "DPF2 methyl",
    "DPF2 proteo",
    "DPF2 rna"
  ],
  "DPF3": [
    "DPF3 224_247_1_1_S247 phospho",
    "DPF3 354_360_1_1_S358 phospho",
    "DPF3 cnv",
    "DPF3 methyl",
    "DPF3 proteo",
    "DPF3 rna"
  ],
  "DPH1": [
    "DPH1 cnv",
    "DPH1 methyl",
    "DPH1 proteo",
    "DPH1 rna"
  ],
  "DPH2": [
    "DPH2 cnv",
    "DPH2 methyl",
    "DPH2 proteo",
    "DPH2 rna"
  ],
  "DPH3": [
    "DPH3 cnv",
    "DPH3 methyl",
    "DPH3 proteo",
    "DPH3 rna"
  ],
  "DPH5": [
    "DPH5 cnv",
    "DPH5 methyl",
    "DPH5 proteo",
    "DPH5 rna"
  ],
  "DPH6": [
    "DPH6 cnv",
    "DPH6 methyl",
    "DPH6 proteo",
    "DPH6 rna"
  ],
  "DPH7": [
    "DPH7 cnv",
    "DPH7 methyl",
    "DPH7 rna"
  ],
  "DPM1": [
    "DPM1 cnv",
    "DPM1 methyl",
    "DPM1 proteo",
    "DPM1 rna"
  ],
  "DPM2": [
    "DPM2 cnv",
    "DPM2 methyl",
    "DPM2 rna"
  ],
  "DPM3": [
    "DPM3 cnv",
    "DPM3 methyl",
    "DPM3 proteo",
    "DPM3 rna"
  ],
  "DPP10": [
    "DPP10 AGVNYTMQVYPDEGHNVSEK-N2H9F0S0G0 glyco",
    "DPP10 LAFLMINDSLVPTMVIPR-N2H5F0S0G0 glyco",
    "DPP10 cnv",
    "DPP10 methyl",
    "DPP10 proteo",
    "DPP10 rna"
  ],
  "DPP10-AS1": [
    "DPP10-AS1 methyl"
  ],
  "DPP3": [
    "DPP3 cnv",
    "DPP3 methyl",
    "DPP3 proteo",
    "DPP3 rna"
  ],
  "DPP3-DT": [
    "DPP3-DT methyl"
  ],
  "DPP4": [
    "DPP4 cnv",
    "DPP4 methyl",
    "DPP4 rna"
  ],
  "DPP6": [
    "DPP6 ANYSLQIYPDESHYFTSSSLK-N2H8F0S0G0 glyco",
    "DPP6 ANYSLQIYPDESHYFTSSSLK-N2H9F0S0G0 glyco",
    "DPP6 AQNVSILTLCDATTGVCTK-N2H4F0S0G0 glyco",
    "DPP6 AQNVSILTLCDATTGVCTK-N2H5F0S0G0 glyco",
    "DPP6 AQNVSILTLCDATTGVCTK-N2H6F0S0G0 glyco",
    "DPP6 GKANYSLQIYPDESHYFTSSSLK-N2H8F0S0G0 glyco",
    "DPP6 LAYAAINDSR-N2H4F0S0G0 glyco",
    "DPP6 LAYAAINDSR-N2H5F0S0G0 glyco",
    "DPP6 LAYAAINDSR-N4H3F0S0G0 glyco",
    "DPP6 LAYAAINDSR-N4H4F0S0G0 glyco",
    "DPP6 LAYAAINDSR-N4H4F1S0G0 glyco",
    "DPP6 LAYAAINDSR-N5H3F0S0G0 glyco",
    "DPP6 LAYAAINDSR-N5H4F1S0G0 glyco",
    "DPP6 LWNVETNTSTVLIEGK-N2H5F0S0G0 glyco",
    "DPP6 LWNVETNTSTVLIEGK-N2H6F0S0G0 glyco",
    "DPP6 LWNVETNTSTVLIEGK-N2H7F0S0G0 glyco",
    "DPP6 LWNVETNTSTVLIEGK-N2H8F0S0G0 glyco",
    "DPP6 cnv",
    "DPP6 methyl",
    "DPP6 proteo",
    "DPP6 rna"
  ],
  "DPP7": [
    "DPP7 ALAGLVYNASGSEHCYDIYR-N2H3F0S0G0 glyco",
    "DPP7 ALAGLVYNASGSEHCYDIYR-N2H4F0S0G0 glyco",
    "DPP7 ALAGLVYNASGSEHCYDIYR-N2H5F0S0G0 glyco",
    "DPP7 NLSASVIAVTIQGGAHHLDLR-N2H5F0S0G0 glyco",
    "DPP7 NLSASVIAVTIQGGAHHLDLR-N2H6F0S0G0 glyco",
    "DPP7 NLSASVIAVTIQGGAHHLDLR-N2H7F0S0G0 glyco",
    "DPP7 NLSASVIAVTIQGGAHHLDLR-N2H8F0S0G0 glyco",
    "DPP7 cnv",
    "DPP7 methyl",
    "DPP7 proteo",
    "DPP7 rna"
  ],
  "DPP8": [
    "DPP8 cnv",
    "DPP8 methyl",
    "DPP8 proteo",
    "DPP8 rna"
  ],
  "DPP9": [
    "DPP9 cnv",
    "DPP9 methyl",
    "DPP9 proteo",
    "DPP9 rna"
  ],
  "DPPA2": [
    "DPPA2 cnv"
  ],
  "DPPA3": [
    "DPPA3 cnv",
    "DPPA3 rna"
  ],
  "DPPA4": [
    "DPPA4 cnv",
    "DPPA4 rna"
  ],
  "DPPA5": [
    "DPPA5 cnv",
    "DPPA5 methyl"
  ],
  "DPRX": [
    "DPRX cnv"
  ],
  "DPT": [
    "DPT cnv",
    "DPT proteo",
    "DPT rna"
  ],
  "DPY19L1": [
    "DPY19L1 cnv",
    "DPY19L1 methyl",
    "DPY19L1 proteo",
    "DPY19L1 rna"
  ],
  "DPY19L2": [
    "DPY19L2 cnv",
    "DPY19L2 methyl",
    "DPY19L2 rna"
  ],
  "DPY19L2P2": [
    "DPY19L2P2 methyl"
  ],
  "DPY19L2P3": [
    "DPY19L2P3 methyl"
  ],
  "DPY19L2P4": [
    "DPY19L2P4 methyl"
  ],
  "DPY19L3": [
    "DPY19L3 cnv",
    "DPY19L3 methyl",
    "DPY19L3 proteo",
    "DPY19L3 rna"
  ],
  "DPY19L3-DT": [
    "DPY19L3-DT methyl"
  ],
  "DPY19L4": [
    "DPY19L4 GVYELTHNNK-N2H6F0S0G0 glyco",
    "DPY19L4 cnv",
    "DPY19L4 methyl",
    "DPY19L4 rna"
  ],
  "DPY30": [
    "DPY30 cnv",
    "DPY30 methyl",
    "DPY30 proteo",
    "DPY30 rna"
  ],
  "DPYD": [
    "DPYD 905_905_1_1_S905 phospho",
    "DPYD cnv",
    "DPYD methyl",
    "DPYD proteo",
    "DPYD rna"
  ],
  "DPYS": [
    "DPYS cnv",
    "DPYS methyl",
    "DPYS rna"
  ],
  "DPYSL2": [
    "DPYSL2 25_27_1_0 phospho",
    "DPYSL2 25_27_1_1_S27 phospho",
    "DPYSL2 377_397_1_1_S397 phospho",
    "DPYSL2 529_536_1_1_S533 phospho",
    "DPYSL2 604_614_1_1_T614 phospho",
    "DPYSL2 604_614_2_2_S612T614 phospho",
    "DPYSL2 617_623_1_1_T619 phospho",
    "DPYSL2 617_623_2_2_T619S623 phospho",
    "DPYSL2 617_623_3_3_T619S622S623 phospho",
    "DPYSL2 617_627_1_1_S627 phospho",
    "DPYSL2 617_627_2_1_S623 phospho",
    "DPYSL2 617_627_3_0 phospho",
    "DPYSL2 617_627_3_2_T619S627 phospho",
    "DPYSL2 617_627_3_3_T619S622S623 phospho",
    "DPYSL2 642_647_1_0 phospho",
    "DPYSL2 642_647_1_1_S642 phospho",
    "DPYSL2 642_647_1_1_S645 phospho",
    "DPYSL2 642_647_2_2_S642S645 phospho",
    "DPYSL2 642_647_2_2_S645S647 phospho",
    "DPYSL2 7_7_1_1_S7 phospho",
    "DPYSL2 82_83_1_0 phospho",
    "DPYSL2 cnv",
    "DPYSL2 methyl",
    "DPYSL2 proteo",
    "DPYSL2 rna"
  ],
  "DPYSL3": [
    "DPYSL3 102_102_1_1_S102 phospho",
    "DPYSL3 10_19_1_1_S10 phospho",
    "DPYSL3 10_19_1_1_S11 phospho",
    "DPYSL3 10_26_1_0 phospho",
    "DPYSL3 10_26_1_1_S11 phospho",
    "DPYSL3 373_379_1_1_S373 phospho",
    "DPYSL3 516_521_1_1_S516 phospho",
    "DPYSL3 586_593_1_1_S586 phospho",
    "DPYSL3 613_623_1_1_T623 phospho",
    "DPYSL3 613_632_1_1_T623 phospho",
    "DPYSL3 613_632_2_0 phospho",
    "DPYSL3 628_638_3_3_T628S632S636 phospho",
    "DPYSL3 636_638_1_1_S636 phospho",
    "DPYSL3 636_657_1_0 phospho",
    "DPYSL3 636_657_1_1_S636 phospho",
    "DPYSL3 650_657_1_0 phospho",
    "DPYSL3 650_657_1_1_S650 phospho",
    "DPYSL3 650_657_1_1_S653 phospho",
    "DPYSL3 650_667_1_1_S665 phospho",
    "DPYSL3 95_102_1_1_S102 phospho",
    "DPYSL3 cnv",
    "DPYSL3 methyl",
    "DPYSL3 proteo",
    "DPYSL3 rna"
  ],
  "DPYSL4": [
    "DPYSL4 537_544_1_1_S540 phospho",
    "DPYSL4 cnv",
    "DPYSL4 methyl",
    "DPYSL4 proteo",
    "DPYSL4 rna"
  ],
  "DPYSL5": [
    "DPYSL5 490_492_1_1_T490 phospho",
    "DPYSL5 509_520_1_1_T509 phospho",
    "DPYSL5 509_520_1_1_T514 phospho",
    "DPYSL5 509_520_2_2_T509T514 phospho",
    "DPYSL5 531_538_1_0 phospho",
    "DPYSL5 531_538_1_1_S532 phospho",
    "DPYSL5 531_538_1_1_S534 phospho",
    "DPYSL5 531_538_1_1_S536 phospho",
    "DPYSL5 531_538_1_1_S538 phospho",
    "DPYSL5 531_538_2_2_S532S536 phospho",
    "DPYSL5 cnv",
    "DPYSL5 methyl",
    "DPYSL5 proteo",
    "DPYSL5 rna"
  ],
  "DQX1": [
    "DQX1 cnv",
    "DQX1 rna"
  ],
  "DR1": [
    "DR1 105_106_1_1_S105 phospho",
    "DR1 cnv",
    "DR1 methyl",
    "DR1 proteo",
    "DR1 rna"
  ],
  "DRAM1": [
    "DRAM1 cnv",
    "DRAM1 methyl",
    "DRAM1 rna"
  ],
  "DRAM2": [
    "DRAM2 cnv",
    "DRAM2 methyl",
    "DRAM2 rna"
  ],
  "DRAP1": [
    "DRAP1 cnv",
    "DRAP1 methyl",
    "DRAP1 proteo",
    "DRAP1 rna"
  ],
  "DRAXIN": [
    "DRAXIN cnv",
    "DRAXIN methyl",
    "DRAXIN proteo",
    "DRAXIN rna"
  ],
  "DRC1": [
    "DRC1 cnv",
    "DRC1 methyl",
    "DRC1 rna"
  ],
  "DRC3": [
    "DRC3 cnv",
    "DRC3 methyl",
    "DRC3 rna"
  ],
  "DRC7": [
    "DRC7 cnv",
    "DRC7 rna"
  ],
  "DRD1": [
    "DRD1 cnv",
    "DRD1 methyl",
    "DRD1 rna"
  ],
  "DRD2": [
    "DRD2 cnv",
    "DRD2 methyl",
    "DRD2 rna"
  ],
  "DRD3": [
    "DRD3 cnv",
    "DRD3 rna"
  ],
  "DRD4": [
    "DRD4 cnv",
    "DRD4 methyl",
    "DRD4 rna"
  ],
  "DRD5": [
    "DRD5 cnv",
    "DRD5 methyl",
    "DRD5 rna"
  ],
  "DRG1": [
    "DRG1 cnv",
    "DRG1 methyl",
    "DRG1 proteo",
    "DRG1 rna"
  ],
  "DRG2": [
    "DRG2 cnv",
    "DRG2 methyl",
    "DRG2 proteo",
    "DRG2 rna"
  ],
  "DRGX": [
    "DRGX cnv",
    "DRGX methyl",
    "DRGX rna"
  ],
  "DRICH1": [
    "DRICH1 cnv",
    "DRICH1 rna"
  ],
  "DROSHA": [
    "DROSHA cnv",
    "DROSHA methyl",
    "DROSHA rna"
  ],
  "DRP2": [
    "DRP2 rna"
  ],
  "DSC1": [
    "DSC1 cnv",
    "DSC1 rna"
  ],
  "DSC2": [
    "DSC2 cnv",
    "DSC2 methyl",
    "DSC2 rna"
  ],
  "DSC3": [
    "DSC3 cnv",
    "DSC3 methyl",
    "DSC3 rna"
  ],
  "DSCAM": [
    "DSCAM cnv",
    "DSCAM methyl",
    "DSCAM rna"
  ],
  "DSCAML1": [
    "DSCAML1 cnv",
    "DSCAML1 methyl",
    "DSCAML1 proteo",
    "DSCAML1 rna"
  ],
  "DSCAS": [
    "DSCAS methyl"
  ],
  "DSCC1": [
    "DSCC1 cnv",
    "DSCC1 methyl",
    "DSCC1 rna"
  ],
  "DSE": [
    "DSE cnv",
    "DSE methyl",
    "DSE rna"
  ],
  "DSEL": [
    "DSEL cnv",
    "DSEL methyl",
    "DSEL rna"
  ],
  "DSEL-AS1": [
    "DSEL-AS1 methyl"
  ],
  "DSG1": [
    "DSG1 cnv",
    "DSG1 rna"
  ],
  "DSG2": [
    "DSG2 cnv",
    "DSG2 methyl",
    "DSG2 rna"
  ],
  "DSG3": [
    "DSG3 cnv",
    "DSG3 rna"
  ],
  "DSG4": [
    "DSG4 cnv"
  ],
  "DSN1": [
    "DSN1 20_30_1_1_S30 phospho",
    "DSN1 57_58_1_1_S58 phospho",
    "DSN1 77_89_1_1_S81 phospho",
    "DSN1 cnv",
    "DSN1 methyl",
    "DSN1 proteo",
    "DSN1 rna"
  ],
  "DSP": [
    "DSP cnv",
    "DSP methyl",
    "DSP proteo",
    "DSP rna"
  ],
  "DSPP": [
    "DSPP cnv",
    "DSPP rna"
  ],
  "DST": [
    "DST 140_146_1_1_S141 phospho",
    "DST 149_163_1_1_S157 phospho",
    "DST 1556_1560_1_1_S1560 phospho",
    "DST 166_176_1_1_S170 phospho",
    "DST 2060_2067_1_1_S2060 phospho",
    "DST 414_415_1_1_S415 phospho",
    "DST 5615_5642_1_1_S5615 phospho",
    "DST 71_77_1_1_S77 phospho",
    "DST cnv",
    "DST methyl",
    "DST proteo",
    "DST rna"
  ],
  "DSTN": [
    "DSTN 138_138_1_1_S138 phospho",
    "DSTN 7_8_1_1_T8 phospho",
    "DSTN cnv",
    "DSTN methyl",
    "DSTN proteo",
    "DSTN rna"
  ],
  "DSTYK": [
    "DSTYK cnv",
    "DSTYK kinase",
    "DSTYK methyl",
    "DSTYK proteo",
    "DSTYK rna"
  ],
  "DTD1": [
    "DTD1 194_205_1_1_S197 phospho",
    "DTD1 194_205_2_2_S197S205 phospho",
    "DTD1 cnv",
    "DTD1 methyl",
    "DTD1 proteo",
    "DTD1 rna"
  ],
  "DTD2": [
    "DTD2 cnv",
    "DTD2 methyl",
    "DTD2 proteo",
    "DTD2 rna"
  ],
  "DTHD1": [
    "DTHD1 cnv",
    "DTHD1 rna"
  ],
  "DTL": [
    "DTL cnv",
    "DTL methyl",
    "DTL rna"
  ],
  "DTNA": [
    "DTNA 167_174_1_1_S167 phospho",
    "DTNA 272_279_1_1_S273 phospho",
    "DTNA 288_318_1_0 phospho",
    "DTNA 346_358_1_1_S350 phospho",
    "DTNA 50_60_1_1_S53 phospho",
    "DTNA cnv",
    "DTNA methyl",
    "DTNA proteo",
    "DTNA rna"
  ],
  "DTNB": [
    "DTNB 364_366_1_1_S364 phospho",
    "DTNB cnv",
    "DTNB methyl",
    "DTNB proteo",
    "DTNB rna"
  ],
  "DTNBP1": [
    "DTNBP1 325_334_1_1_S332 phospho",
    "DTNBP1 cnv",
    "DTNBP1 methyl",
    "DTNBP1 proteo",
    "DTNBP1 rna"
  ],
  "DTWD1": [
    "DTWD1 cnv",
    "DTWD1 methyl",
    "DTWD1 rna"
  ],
  "DTWD2": [
    "DTWD2 cnv",
    "DTWD2 methyl",
    "DTWD2 proteo",
    "DTWD2 rna"
  ],
  "DTX1": [
    "DTX1 cnv",
    "DTX1 methyl",
    "DTX1 rna"
  ],
  "DTX2": [
    "DTX2 cnv",
    "DTX2 rna"
  ],
  "DTX2P1-UPK3BP1-PMS2P11": [
    "DTX2P1-UPK3BP1-PMS2P11 cnv",
    "DTX2P1-UPK3BP1-PMS2P11 rna"
  ],
  "DTX3": [
    "DTX3 cnv",
    "DTX3 methyl",
    "DTX3 proteo",
    "DTX3 rna"
  ],
  "DTX3L": [
    "DTX3L 218_227_1_1_S221 phospho",
    "DTX3L 248_256_1_1_S256 phospho",
    "DTX3L 526_535_1_1_S532 phospho",
    "DTX3L cnv",
    "DTX3L methyl",
    "DTX3L proteo",
    "DTX3L rna"
  ],
  "DTX4": [
    "DTX4 cnv",
    "DTX4 methyl",
    "DTX4 rna"
  ],
  "DTYMK": [
    "DTYMK cnv",
    "DTYMK methyl",
    "DTYMK proteo",
    "DTYMK rna"
  ],
  "DUBR": [
    "DUBR methyl"
  ],
  "DUOX1": [
    "DUOX1 cnv",
    "DUOX1 methyl",
    "DUOX1 rna"
  ],
  "DUOX2": [
    "DUOX2 cnv",
    "DUOX2 methyl",
    "DUOX2 rna"
  ],
  "DUOXA1": [
    "DUOXA1 cnv",
    "DUOXA1 methyl",
    "DUOXA1 rna"
  ],
  "DUOXA2": [
    "DUOXA2 cnv",
    "DUOXA2 methyl",
    "DUOXA2 rna"
  ],
  "DUS1L": [
    "DUS1L cnv",
    "DUS1L methyl",
    "DUS1L proteo",
    "DUS1L rna"
  ],
  "DUS2": [
    "DUS2 cnv",
    "DUS2 methyl",
    "DUS2 proteo",
    "DUS2 rna"
  ],
  "DUS3L": [
    "DUS3L 236_249_1_1_S236 phospho",
    "DUS3L cnv",
    "DUS3L methyl",
    "DUS3L proteo",
    "DUS3L rna"
  ],
  "DUS4L": [
    "DUS4L cnv",
    "DUS4L methyl",
    "DUS4L rna"
  ],
  "DUS4L-BCAP29": [
    "DUS4L-BCAP29 cnv",
    "DUS4L-BCAP29 methyl",
    "DUS4L-BCAP29 rna"
  ],
  "DUSP1": [
    "DUSP1 cnv",
    "DUSP1 methyl",
    "DUSP1 rna"
  ],
  "DUSP10": [
    "DUSP10 cnv",
    "DUSP10 methyl",
    "DUSP10 rna"
  ],
  "DUSP11": [
    "DUSP11 cnv",
    "DUSP11 methyl",
    "DUSP11 rna"
  ],
  "DUSP12": [
    "DUSP12 cnv",
    "DUSP12 methyl",
    "DUSP12 proteo",
    "DUSP12 rna"
  ],
  "DUSP13": [
    "DUSP13 cnv",
    "DUSP13 rna"
  ],
  "DUSP14": [
    "DUSP14 cnv",
    "DUSP14 methyl",
    "DUSP14 proteo",
    "DUSP14 rna"
  ],
  "DUSP15": [
    "DUSP15 cnv",
    "DUSP15 methyl",
    "DUSP15 rna"
  ],
  "DUSP16": [
    "DUSP16 612_617_1_1_S612 phospho",
    "DUSP16 cnv",
    "DUSP16 methyl",
    "DUSP16 rna"
  ],
  "DUSP18": [
    "DUSP18 cnv",
    "DUSP18 methyl",
    "DUSP18 rna"
  ],
  "DUSP19": [
    "DUSP19 cnv",
    "DUSP19 proteo",
    "DUSP19 rna"
  ],
  "DUSP2": [
    "DUSP2 cnv",
    "DUSP2 methyl",
    "DUSP2 rna"
  ],
  "DUSP22": [
    "DUSP22 50_64_1_1_S58 phospho",
    "DUSP22 cnv",
    "DUSP22 methyl",
    "DUSP22 rna"
  ],
  "DUSP23": [
    "DUSP23 cnv",
    "DUSP23 methyl",
    "DUSP23 proteo",
    "DUSP23 rna"
  ],
  "DUSP26": [
    "DUSP26 cnv",
    "DUSP26 methyl",
    "DUSP26 rna"
  ],
  "DUSP28": [
    "DUSP28 cnv",
    "DUSP28 methyl",
    "DUSP28 rna"
  ],
  "DUSP29": [
    "DUSP29 cnv",
    "DUSP29 rna"
  ],
  "DUSP3": [
    "DUSP3 cnv",
    "DUSP3 methyl",
    "DUSP3 proteo",
    "DUSP3 rna"
  ],
  "DUSP4": [
    "DUSP4 cnv",
    "DUSP4 methyl",
    "DUSP4 rna"
  ],
  "DUSP5": [
    "DUSP5 cnv",
    "DUSP5 methyl",
    "DUSP5 rna"
  ],
  "DUSP6": [
    "DUSP6 cnv",
    "DUSP6 methyl",
    "DUSP6 rna"
  ],
  "DUSP7": [
    "DUSP7 cnv",
    "DUSP7 methyl",
    "DUSP7 rna"
  ],
  "DUSP8": [
    "DUSP8 cnv",
    "DUSP8 methyl",
    "DUSP8 rna"
  ],
  "DUSP9": [
    "DUSP9 methyl",
    "DUSP9 rna"
  ],
  "DUT": [
    "DUT 4_13_1_1_S11 phospho",
    "DUT 88_101_1_1_S88 phospho",
    "DUT 88_101_1_1_S99 phospho",
    "DUT cnv",
    "DUT methyl",
    "DUT proteo",
    "DUT rna"
  ],
  "DUX4": [
    "DUX4 cnv",
    "DUX4 rna"
  ],
  "DUXA": [
    "DUXA cnv"
  ],
  "DUXB": [
    "DUXB cnv",
    "DUXB rna"
  ],
  "DVL1": [
    "DVL1 cnv",
    "DVL1 methyl",
    "DVL1 proteo",
    "DVL1 rna"
  ],
  "DVL2": [
    "DVL2 cnv",
    "DVL2 methyl",
    "DVL2 proteo",
    "DVL2 rna"
  ],
  "DVL3": [
    "DVL3 106_140_1_1_S125 phospho",
    "DVL3 cnv",
    "DVL3 proteo",
    "DVL3 rna"
  ],
  "DXO": [
    "DXO cnv",
    "DXO methyl",
    "DXO proteo",
    "DXO rna"
  ],
  "DYDC1": [
    "DYDC1 cnv",
    "DYDC1 methyl",
    "DYDC1 rna"
  ],
  "DYDC2": [
    "DYDC2 cnv",
    "DYDC2 methyl",
    "DYDC2 rna"
  ],
  "DYM": [
    "DYM cnv",
    "DYM methyl",
    "DYM proteo",
    "DYM rna"
  ],
  "DYNAP": [
    "DYNAP cnv",
    "DYNAP rna"
  ],
  "DYNC1H1": [
    "DYNC1H1 1230_1230_1_1_S1230 phospho",
    "DYNC1H1 4366_4370_1_1_S4368 phospho",
    "DYNC1H1 cnv",
    "DYNC1H1 methyl",
    "DYNC1H1 proteo",
    "DYNC1H1 rna"
  ],
  "DYNC1I1": [
    "DYNC1I1 153_174_1_1_S162 phospho",
    "DYNC1I1 180_180_1_1_S180 phospho",
    "DYNC1I1 50_50_1_1_S50 phospho",
    "DYNC1I1 59_83_1_1_S80 phospho",
    "DYNC1I1 618_627_1_1_S618 phospho",
    "DYNC1I1 cnv",
    "DYNC1I1 methyl",
    "DYNC1I1 proteo",
    "DYNC1I1 rna"
  ],
  "DYNC1I2": [
    "DYNC1I2 51_51_1_1_S51 phospho",
    "DYNC1I2 66_84_1_1_S73 phospho",
    "DYNC1I2 66_84_1_1_S81 phospho",
    "DYNC1I2 66_84_2_2_S73S81 phospho",
    "DYNC1I2 84_102_1_1_S99 phospho",
    "DYNC1I2 86_105_1_1_S98 phospho",
    "DYNC1I2 86_105_2_2_S91S95 phospho",
    "DYNC1I2 86_105_2_2_S95S98 phospho",
    "DYNC1I2 cnv",
    "DYNC1I2 methyl",
    "DYNC1I2 proteo",
    "DYNC1I2 rna"
  ],
  "DYNC1LI1": [
    "DYNC1LI1 197_207_1_1_S207 phospho",
    "DYNC1LI1 412_427_1_1_S421 phospho",
    "DYNC1LI1 508_523_1_0 phospho",
    "DYNC1LI1 508_523_1_1_T513 phospho",
    "DYNC1LI1 cnv",
    "DYNC1LI1 methyl",
    "DYNC1LI1 proteo",
    "DYNC1LI1 rna"
  ],
  "DYNC1LI2": [
    "DYNC1LI2 184_194_1_1_S194 phospho",
    "DYNC1LI2 202_232_1_0 phospho",
    "DYNC1LI2 202_232_1_1_S205 phospho",
    "DYNC1LI2 402_411_1_1_S407 phospho",
    "DYNC1LI2 402_411_1_1_S411 phospho",
    "DYNC1LI2 441_455_1_1_S446 phospho",
    "DYNC1LI2 481_488_1_0 phospho",
    "DYNC1LI2 cnv",
    "DYNC1LI2 methyl",
    "DYNC1LI2 proteo",
    "DYNC1LI2 rna"
  ],
  "DYNC1LI2-DT": [
    "DYNC1LI2-DT methyl"
  ],
  "DYNC2H1": [
    "DYNC2H1 cnv",
    "DYNC2H1 proteo",
    "DYNC2H1 rna"
  ],
  "DYNC2I1": [
    "DYNC2I1 cnv",
    "DYNC2I1 methyl",
    "DYNC2I1 proteo",
    "DYNC2I1 rna"
  ],
  "DYNC2I2": [
    "DYNC2I2 cnv",
    "DYNC2I2 methyl",
    "DYNC2I2 proteo",
    "DYNC2I2 rna"
  ],
  "DYNC2LI1": [
    "DYNC2LI1 cnv",
    "DYNC2LI1 proteo",
    "DYNC2LI1 rna"
  ],
  "DYNLL1": [
    "DYNLL1 cnv",
    "DYNLL1 methyl",
    "DYNLL1 proteo",
    "DYNLL1 rna"
  ],
  "DYNLL2": [
    "DYNLL2 cnv",
    "DYNLL2 methyl",
    "DYNLL2 proteo",
    "DYNLL2 rna"
  ],
  "DYNLL2-DT": [
    "DYNLL2-DT methyl"
  ],
  "DYNLRB1": [
    "DYNLRB1 cnv",
    "DYNLRB1 methyl",
    "DYNLRB1 proteo",
    "DYNLRB1 rna"
  ],
  "DYNLRB2": [
    "DYNLRB2 cnv",
    "DYNLRB2 methyl",
    "DYNLRB2 rna"
  ],
  "DYNLT1": [
    "DYNLT1 cnv",
    "DYNLT1 methyl",
    "DYNLT1 proteo",
    "DYNLT1 rna"
  ],
  "DYNLT2": [
    "DYNLT2 cnv",
    "DYNLT2 methyl",
    "DYNLT2 rna"
  ],
  "DYNLT2B": [
    "DYNLT2B cnv",
    "DYNLT2B methyl",
    "DYNLT2B rna"
  ],
  "DYNLT3": [
    "DYNLT3 methyl",
    "DYNLT3 proteo",
    "DYNLT3 rna"
  ],
  "DYNLT4": [
    "DYNLT4 cnv",
    "DYNLT4 rna"
  ],
  "DYNLT5": [
    "DYNLT5 cnv",
    "DYNLT5 methyl",
    "DYNLT5 rna"
  ],
  "DYRK1A": [
    "DYRK1A 520_523_1_0 phospho",
    "DYRK1A 739_754_1_1_S749 phospho",
    "DYRK1A cnv",
    "DYRK1A kinase",
    "DYRK1A methyl",
    "DYRK1A proteo",
    "DYRK1A rna"
  ],
  "DYRK1B": [
    "DYRK1B cnv",
    "DYRK1B kinase",
    "DYRK1B methyl",
    "DYRK1B proteo",
    "DYRK1B rna"
  ],
  "DYRK2": [
    "DYRK2 cnv",
    "DYRK2 kinase",
    "DYRK2 methyl",
    "DYRK2 rna"
  ],
  "DYRK3": [
    "DYRK3 cnv",
    "DYRK3 kinase",
    "DYRK3 methyl",
    "DYRK3 rna"
  ],
  "DYRK4": [
    "DYRK4 cnv",
    "DYRK4 kinase",
    "DYRK4 methyl",
    "DYRK4 rna"
  ],
  "DYSF": [
    "DYSF 183_216_1_1_T197 phospho",
    "DYSF cnv",
    "DYSF methyl",
    "DYSF proteo",
    "DYSF rna"
  ],
  "DYTN": [
    "DYTN cnv",
    "DYTN rna"
  ],
  "DZANK1": [
    "DZANK1 cnv",
    "DZANK1 methyl",
    "DZANK1 rna"
  ],
  "DZIP1": [
    "DZIP1 cnv",
    "DZIP1 methyl",
    "DZIP1 rna"
  ],
  "DZIP1L": [
    "DZIP1L cnv",
    "DZIP1L methyl",
    "DZIP1L rna"
  ],
  "DZIP3": [
    "DZIP3 cnv",
    "DZIP3 methyl",
    "DZIP3 proteo",
    "DZIP3 rna"
  ],
  "E2F1": [
    "E2F1 cnv",
    "E2F1 methyl",
    "E2F1 rna"
  ],
  "E2F2": [
    "E2F2 cnv",
    "E2F2 methyl",
    "E2F2 rna"
  ],
  "E2F3": [
    "E2F3 cnv",
    "E2F3 methyl",
    "E2F3 rna"
  ],
  "E2F4": [
    "E2F4 cnv",
    "E2F4 methyl",
    "E2F4 proteo",
    "E2F4 rna"
  ],
  "E2F5": [
    "E2F5 cnv",
    "E2F5 methyl",
    "E2F5 rna"
  ],
  "E2F5-DT": [
    "E2F5-DT methyl"
  ],
  "E2F6": [
    "E2F6 cnv",
    "E2F6 methyl",
    "E2F6 rna"
  ],
  "E2F7": [
    "E2F7 cnv",
    "E2F7 methyl",
    "E2F7 rna"
  ],
  "E2F8": [
    "E2F8 cnv",
    "E2F8 methyl",
    "E2F8 rna"
  ],
  "E4F1": [
    "E4F1 cnv",
    "E4F1 methyl",
    "E4F1 proteo",
    "E4F1 rna"
  ],
  "EAF1": [
    "EAF1 157_165_2_2_S158S165 phospho",
    "EAF1 165_165_1_1_S165 phospho",
    "EAF1 cnv",
    "EAF1 methyl",
    "EAF1 rna"
  ],
  "EAF2": [
    "EAF2 cnv",
    "EAF2 methyl",
    "EAF2 rna"
  ],
  "EAPP": [
    "EAPP cnv",
    "EAPP methyl",
    "EAPP proteo",
    "EAPP rna"
  ],
  "EARS2": [
    "EARS2 cnv",
    "EARS2 methyl",
    "EARS2 proteo",
    "EARS2 rna"
  ],
  "EBAG9": [
    "EBAG9 cnv",
    "EBAG9 methyl",
    "EBAG9 proteo",
    "EBAG9 rna"
  ],
  "EBF1": [
    "EBF1 cnv",
    "EBF1 methyl",
    "EBF1 rna"
  ],
  "EBF2": [
    "EBF2 cnv",
    "EBF2 methyl",
    "EBF2 rna"
  ],
  "EBF3": [
    "EBF3 cnv",
    "EBF3 methyl",
    "EBF3 rna"
  ],
  "EBF4": [
    "EBF4 cnv",
    "EBF4 methyl",
    "EBF4 rna"
  ],
  "EBI3": [
    "EBI3 cnv",
    "EBI3 rna"
  ],
  "EBLN1": [
    "EBLN1 cnv",
    "EBLN1 rna"
  ],
  "EBLN2": [
    "EBLN2 cnv",
    "EBLN2 rna"
  ],
  "EBLN3P": [
    "EBLN3P methyl"
  ],
  "EBNA1BP2": [
    "EBNA1BP2 cnv",
    "EBNA1BP2 methyl",
    "EBNA1BP2 proteo",
    "EBNA1BP2 rna"
  ],
  "EBP": [
    "EBP methyl",
    "EBP proteo",
    "EBP rna"
  ],
  "EBPL": [
    "EBPL cnv",
    "EBPL methyl",
    "EBPL rna"
  ],
  "ECD": [
    "ECD cnv",
    "ECD methyl",
    "ECD proteo",
    "ECD rna"
  ],
  "ECE1": [
    "ECE1 HLLENSTASVSEAER-N2H5F0S0G0 glyco",
    "ECE1 HLLENSTASVSEAER-N2H6F0S0G0 glyco",
    "ECE1 HLLENSTASVSEAERK-N2H6F0S0G0 glyco",
    "ECE1 cnv",
    "ECE1 methyl",
    "ECE1 proteo",
    "ECE1 rna"
  ],
  "ECE2": [
    "ECE2 cnv",
    "ECE2 methyl",
    "ECE2 rna"
  ],
  "ECEL1": [
    "ECEL1 cnv",
    "ECEL1 methyl",
    "ECEL1 rna"
  ],
  "ECEL1P2": [
    "ECEL1P2 methyl"
  ],
  "ECH1": [
    "ECH1 cnv",
    "ECH1 methyl",
    "ECH1 proteo",
    "ECH1 rna"
  ],
  "ECHDC1": [
    "ECHDC1 cnv",
    "ECHDC1 methyl",
    "ECHDC1 proteo",
    "ECHDC1 rna"
  ],
  "ECHDC2": [
    "ECHDC2 cnv",
    "ECHDC2 methyl",
    "ECHDC2 proteo",
    "ECHDC2 rna"
  ],
  "ECHDC3": [
    "ECHDC3 cnv",
    "ECHDC3 methyl",
    "ECHDC3 proteo",
    "ECHDC3 rna"
  ],
  "ECHS1": [
    "ECHS1 cnv",
    "ECHS1 methyl",
    "ECHS1 proteo",
    "ECHS1 rna"
  ],
  "ECI1": [
    "ECI1 cnv",
    "ECI1 methyl",
    "ECI1 proteo",
    "ECI1 rna"
  ],
  "ECI2": [
    "ECI2 cnv",
    "ECI2 methyl",
    "ECI2 proteo",
    "ECI2 rna"
  ],
  "ECI2-DT": [
    "ECI2-DT methyl"
  ],
  "ECM1": [
    "ECM1 cnv",
    "ECM1 proteo",
    "ECM1 rna"
  ],
  "ECM2": [
    "ECM2 cnv",
    "ECM2 proteo",
    "ECM2 rna"
  ],
  "ECPAS": [
    "ECPAS 1002_1008_1_1_S1005 phospho",
    "ECPAS cnv",
    "ECPAS methyl",
    "ECPAS proteo",
    "ECPAS rna"
  ],
  "ECRG4": [
    "ECRG4 cnv",
    "ECRG4 methyl",
    "ECRG4 rna"
  ],
  "ECSCR": [
    "ECSCR cnv",
    "ECSCR rna"
  ],
  "ECSIT": [
    "ECSIT cnv",
    "ECSIT methyl",
    "ECSIT proteo",
    "ECSIT rna"
  ],
  "ECT2": [
    "ECT2 cnv",
    "ECT2 methyl",
    "ECT2 rna"
  ],
  "ECT2L": [
    "ECT2L cnv",
    "ECT2L methyl",
    "ECT2L rna"
  ],
  "EDA": [
    "EDA methyl",
    "EDA rna"
  ],
  "EDA2R": [
    "EDA2R rna"
  ],
  "EDAR": [
    "EDAR cnv",
    "EDAR rna"
  ],
  "EDARADD": [
    "EDARADD cnv",
    "EDARADD methyl",
    "EDARADD rna"
  ],
  "EDC3": [
    "EDC3 125_138_1_1_S131 phospho",
    "EDC3 cnv",
    "EDC3 methyl",
    "EDC3 proteo",
    "EDC3 rna"
  ],
  "EDC4": [
    "EDC4 30_60_1_0 phospho",
    "EDC4 30_60_1_1_S33 phospho",
    "EDC4 727_753_1_0 phospho",
    "EDC4 758_780_1_1_S780 phospho",
    "EDC4 871_897_1_1_S879 phospho",
    "EDC4 cnv",
    "EDC4 methyl",
    "EDC4 proteo",
    "EDC4 rna"
  ],
  "EDDM13": [
    "EDDM13 cnv",
    "EDDM13 rna"
  ],
  "EDDM3A": [
    "EDDM3A cnv",
    "EDDM3A rna"
  ],
  "EDDM3B": [
    "EDDM3B cnv"
  ],
  "EDEM1": [
    "EDEM1 cnv",
    "EDEM1 methyl",
    "EDEM1 rna"
  ],
  "EDEM2": [
    "EDEM2 cnv",
    "EDEM2 methyl",
    "EDEM2 rna"
  ],
  "EDEM3": [
    "EDEM3 LLPAFNTTSGLPYPR-N2H6F0S0G0 glyco",
    "EDEM3 LLPAFNTTSGLPYPR-N2H7F0S0G0 glyco",
    "EDEM3 LLPAFNTTSGLPYPR-N2H8F0S0G0 glyco",
    "EDEM3 cnv",
    "EDEM3 methyl",
    "EDEM3 proteo",
    "EDEM3 rna"
  ],
  "EDF1": [
    "EDF1 cnv",
    "EDF1 methyl",
    "EDF1 proteo",
    "EDF1 rna"
  ],
  "EDIL3": [
    "EDIL3 cnv",
    "EDIL3 methyl",
    "EDIL3 proteo",
    "EDIL3 rna"
  ],
  "EDN1": [
    "EDN1 cnv",
    "EDN1 rna"
  ],
  "EDN2": [
    "EDN2 cnv",
    "EDN2 rna"
  ],
  "EDN3": [
    "EDN3 cnv",
    "EDN3 methyl",
    "EDN3 rna"
  ],
  "EDNRA": [
    "EDNRA cnv",
    "EDNRA methyl",
    "EDNRA rna"
  ],
  "EDNRB": [
    "EDNRB 430_436_1_1_S436 phospho",
    "EDNRB cnv",
    "EDNRB methyl",
    "EDNRB proteo",
    "EDNRB rna"
  ],
  "EDRF1": [
    "EDRF1 cnv",
    "EDRF1 methyl",
    "EDRF1 proteo",
    "EDRF1 rna"
  ],
  "EDRF1-DT": [
    "EDRF1-DT methyl"
  ],
  "EEA1": [
    "EEA1 15_38_1_1_S15 phospho",
    "EEA1 354_359_1_1_S354 phospho",
    "EEA1 354_359_1_1_S359 phospho",
    "EEA1 cnv",
    "EEA1 methyl",
    "EEA1 proteo",
    "EEA1 rna"
  ],
  "EED": [
    "EED cnv",
    "EED methyl",
    "EED proteo",
    "EED rna"
  ],
  "EEF1A1": [
    "EEF1A1 cnv",
    "EEF1A1 methyl",
    "EEF1A1 proteo",
    "EEF1A1 rna"
  ],
  "EEF1A2": [
    "EEF1A2 cnv",
    "EEF1A2 methyl",
    "EEF1A2 proteo",
    "EEF1A2 rna"
  ],
  "EEF1AKMT1": [
    "EEF1AKMT1 cnv",
    "EEF1AKMT1 methyl",
    "EEF1AKMT1 proteo",
    "EEF1AKMT1 rna"
  ],
  "EEF1AKMT2": [
    "EEF1AKMT2 17_34_1_1_S21 phospho",
    "EEF1AKMT2 cnv",
    "EEF1AKMT2 methyl",
    "EEF1AKMT2 proteo",
    "EEF1AKMT2 rna"
  ],
  "EEF1AKMT3": [
    "EEF1AKMT3 cnv",
    "EEF1AKMT3 methyl",
    "EEF1AKMT3 rna"
  ],
  "EEF1AKMT4": [
    "EEF1AKMT4 cnv",
    "EEF1AKMT4 methyl",
    "EEF1AKMT4 rna"
  ],
  "EEF1AKMT4-ECE2": [
    "EEF1AKMT4-ECE2 cnv",
    "EEF1AKMT4-ECE2 methyl"
  ],
  "EEF1B2": [
    "EEF1B2 106_112_1_1_S106 phospho",
    "EEF1B2 140_153_1_1_S141 phospho",
    "EEF1B2 79_112_1_1_S106 phospho",
    "EEF1B2 79_95_1_1_S95 phospho",
    "EEF1B2 cnv",
    "EEF1B2 methyl",
    "EEF1B2 proteo",
    "EEF1B2 rna"
  ],
  "EEF1D": [
    "EEF1D 40_50_1_1_S41 phospho",
    "EEF1D 426_440_1_1_S426 phospho",
    "EEF1D 491_499_1_1_S499 phospho",
    "EEF1D 513_528_1_1_S528 phospho",
    "EEF1D 513_528_2_2_T513S528 phospho",
    "EEF1D cnv",
    "EEF1D methyl",
    "EEF1D proteo",
    "EEF1D rna"
  ],
  "EEF1E1": [
    "EEF1E1 cnv",
    "EEF1E1 methyl",
    "EEF1E1 proteo",
    "EEF1E1 rna"
  ],
  "EEF1E1-BLOC1S5": [
    "EEF1E1-BLOC1S5 cnv",
    "EEF1E1-BLOC1S5 rna"
  ],
  "EEF1G": [
    "EEF1G 33_46_1_1_T46 phospho",
    "EEF1G cnv",
    "EEF1G methyl",
    "EEF1G proteo",
    "EEF1G rna"
  ],
  "EEF2": [
    "EEF2 54_59_1_1_T57 phospho",
    "EEF2 cnv",
    "EEF2 methyl",
    "EEF2 proteo",
    "EEF2 rna"
  ],
  "EEF2K": [
    "EEF2K 462_464_1_0 phospho",
    "EEF2K 462_464_1_1_S462 phospho",
    "EEF2K 500_500_1_1_S500 phospho",
    "EEF2K cnv",
    "EEF2K kinase",
    "EEF2K methyl",
    "EEF2K proteo",
    "EEF2K rna"
  ],
  "EEF2KMT": [
    "EEF2KMT cnv",
    "EEF2KMT methyl",
    "EEF2KMT rna"
  ],
  "EEFSEC": [
    "EEFSEC cnv",
    "EEFSEC methyl",
    "EEFSEC proteo",
    "EEFSEC rna"
  ],
  "EEPD1": [
    "EEPD1 105_113_1_1_S110 phospho",
    "EEPD1 173_173_1_1_S173 phospho",
    "EEPD1 25_31_1_1_S25 phospho",
    "EEPD1 25_31_2_2_S25S31 phospho",
    "EEPD1 369_375_1_1_S373 phospho",
    "EEPD1 cnv",
    "EEPD1 methyl",
    "EEPD1 proteo",
    "EEPD1 rna"
  ],
  "EFCAB10": [
    "EFCAB10 cnv",
    "EFCAB10 rna"
  ],
  "EFCAB11": [
    "EFCAB11 cnv",
    "EFCAB11 methyl",
    "EFCAB11 rna"
  ],
  "EFCAB12": [
    "EFCAB12 cnv",
    "EFCAB12 methyl",
    "EFCAB12 rna"
  ],
  "EFCAB13": [
    "EFCAB13 cnv",
    "EFCAB13 methyl",
    "EFCAB13 rna"
  ],
  "EFCAB13-DT": [
    "EFCAB13-DT methyl"
  ],
  "EFCAB14": [
    "EFCAB14 cnv",
    "EFCAB14 methyl",
    "EFCAB14 proteo",
    "EFCAB14 rna"
  ],
  "EFCAB2": [
    "EFCAB2 cnv",
    "EFCAB2 methyl",
    "EFCAB2 rna"
  ],
  "EFCAB3": [
    "EFCAB3 cnv",
    "EFCAB3 rna"
  ],
  "EFCAB5": [
    "EFCAB5 cnv",
    "EFCAB5 methyl",
    "EFCAB5 rna"
  ],
  "EFCAB6": [
    "EFCAB6 cnv",
    "EFCAB6 methyl",
    "EFCAB6 rna"
  ],
  "EFCAB7": [
    "EFCAB7 200_212_1_1_S200 phospho",
    "EFCAB7 cnv",
    "EFCAB7 proteo",
    "EFCAB7 rna"
  ],
  "EFCAB8": [
    "EFCAB8 cnv",
    "EFCAB8 rna"
  ],
  "EFCAB9": [
    "EFCAB9 cnv",
    "EFCAB9 rna"
  ],
  "EFCC1": [
    "EFCC1 cnv",
    "EFCC1 methyl",
    "EFCC1 rna"
  ],
  "EFEMP1": [
    "EFEMP1 cnv",
    "EFEMP1 methyl",
    "EFEMP1 proteo",
    "EFEMP1 rna"
  ],
  "EFEMP2": [
    "EFEMP2 CQCEPGFQLGPNNR-N2H5F0S0G0 glyco",
    "EFEMP2 cnv",
    "EFEMP2 methyl",
    "EFEMP2 proteo",
    "EFEMP2 rna"
  ],
  "EFHB": [
    "EFHB cnv",
    "EFHB methyl",
    "EFHB rna"
  ],
  "EFHC1": [
    "EFHC1 cnv",
    "EFHC1 methyl",
    "EFHC1 rna"
  ],
  "EFHC2": [
    "EFHC2 methyl",
    "EFHC2 rna"
  ],
  "EFHD1": [
    "EFHD1 cnv",
    "EFHD1 methyl",
    "EFHD1 proteo",
    "EFHD1 rna"
  ],
  "EFHD2": [
    "EFHD2 74_76_1_1_S74 phospho",
    "EFHD2 cnv",
    "EFHD2 methyl",
    "EFHD2 proteo",
    "EFHD2 rna"
  ],
  "EFL1": [
    "EFL1 cnv",
    "EFL1 methyl",
    "EFL1 proteo",
    "EFL1 rna"
  ],
  "EFNA1": [
    "EFNA1 cnv",
    "EFNA1 methyl",
    "EFNA1 proteo",
    "EFNA1 rna"
  ],
  "EFNA2": [
    "EFNA2 cnv",
    "EFNA2 methyl",
    "EFNA2 rna"
  ],
  "EFNA3": [
    "EFNA3 HAVYWNSSNQHLR-N2H6F0S0G0 glyco",
    "EFNA3 cnv",
    "EFNA3 methyl",
    "EFNA3 proteo",
    "EFNA3 rna"
  ],
  "EFNA4": [
    "EFNA4 cnv",
    "EFNA4 methyl",
    "EFNA4 rna"
  ],
  "EFNA5": [
    "EFNA5 YAVYWNSSNPR-N2H5F0S0G0 glyco",
    "EFNA5 YAVYWNSSNPR-N2H6F0S0G0 glyco",
    "EFNA5 cnv",
    "EFNA5 methyl",
    "EFNA5 rna"
  ],
  "EFNB1": [
    "EFNB1 281_287_1_1_S283 phospho",
    "EFNB1 292_300_1_1_S292 phospho",
    "EFNB1 methyl",
    "EFNB1 proteo",
    "EFNB1 rna"
  ],
  "EFNB2": [
    "EFNB2 260_274_1_0 phospho",
    "EFNB2 cnv",
    "EFNB2 methyl",
    "EFNB2 proteo",
    "EFNB2 rna"
  ],
  "EFNB3": [
    "EFNB3 268_268_1_1_S268 phospho",
    "EFNB3 274_274_1_1_S274 phospho",
    "EFNB3 cnv",
    "EFNB3 methyl",
    "EFNB3 proteo",
    "EFNB3 rna"
  ],
  "EFR3A": [
    "EFR3A 183_188_1_1_S184 phospho",
    "EFR3A cnv",
    "EFR3A methyl",
    "EFR3A proteo",
    "EFR3A rna"
  ],
  "EFR3B": [
    "EFR3B 179_181_1_1_S181 phospho",
    "EFR3B 643_654_1_1_S654 phospho",
    "EFR3B cnv",
    "EFR3B methyl",
    "EFR3B proteo",
    "EFR3B rna"
  ],
  "EFS": [
    "EFS 118_118_1_1_S118 phospho",
    "EFS cnv",
    "EFS methyl",
    "EFS proteo",
    "EFS rna"
  ],
  "EFTUD2": [
    "EFTUD2 cnv",
    "EFTUD2 methyl",
    "EFTUD2 proteo",
    "EFTUD2 rna"
  ],
  "EGF": [
    "EGF cnv",
    "EGF rna"
  ],
  "EGFL6": [
    "EGFL6 methyl",
    "EGFL6 rna"
  ],
  "EGFL7": [
    "EGFL7 cnv",
    "EGFL7 methyl",
    "EGFL7 proteo",
    "EGFL7 rna"
  ],
  "EGFL8": [
    "EGFL8 cnv",
    "EGFL8 methyl",
    "EGFL8 rna"
  ],
  "EGFLAM": [
    "EGFLAM cnv",
    "EGFLAM methyl",
    "EGFLAM rna"
  ],
  "EGFR": [
    "EGFR 1012_1019_1_1_S1019 phospho",
    "EGFR 648_650_1_1_S650 phospho",
    "EGFR 946_953_1_1_S946 phospho",
    "EGFR 987_1001_1_1_S994 phospho",
    "EGFR 987_1001_1_1_S997 phospho",
    "EGFR CDPSCPNGSCWGAGEENCQK-N2H5F0S0G0 glyco",
    "EGFR DSLSINATNIK-N2H3F0S0G0 glyco",
    "EGFR DSLSINATNIK-N2H4F0S0G0 glyco",
    "EGFR DSLSINATNIK-N2H5F0S0G0 glyco",
    "EGFR DSLSINATNIK-N2H6F0S0G0 glyco",
    "EGFR DSLSINATNIK-N2H7F0S0G0 glyco",
    "EGFR DSLSINATNIK-N2H8F0S0G0 glyco",
    "EGFR DSLSINATNIK-N2H9F0S0G0 glyco",
    "EGFR EITGFLLIQAWPENR-N5H3F1S0G0 glyco",
    "EGFR NCTSISGDLHILPVAFR-N2H5F0S0G0 glyco",
    "EGFR NCTSISGDLHILPVAFR-N2H6F0S0G0 glyco",
    "EGFR NCTSISGDLHILPVAFR-N2H7F0S0G0 glyco",
    "EGFR NCTSISGDLHILPVAFR-N2H8F0S0G0 glyco",
    "EGFR QHGQFSLAVVSLNITSLGLR-N2H5F0S0G0 glyco",
    "EGFR TCPAGVMGENNTLVWK-N4H5F1S1G0 glyco",
    "EGFR TCPAGVMGENNTLVWK-N4H5F1S2G0 glyco",
    "EGFR VCNGIGIGEFKDSLSINATNIK-N2H6F0S0G0 glyco",
    "EGFR cnv",
    "EGFR kinase",
    "EGFR methyl",
    "EGFR proteo",
    "EGFR rna"
  ],
  "EGLN1": [
    "EGLN1 125_125_1_1_S125 phospho",
    "EGLN1 cnv",
    "EGLN1 methyl",
    "EGLN1 proteo",
    "EGLN1 rna"
  ],
  "EGLN2": [
    "EGLN2 cnv",
    "EGLN2 methyl",
    "EGLN2 rna"
  ],
  "EGLN3": [
    "EGLN3 cnv",
    "EGLN3 methyl",
    "EGLN3 rna"
  ],
  "EGR1": [
    "EGR1 cnv",
    "EGR1 methyl",
    "EGR1 rna"
  ],
  "EGR2": [
    "EGR2 cnv",
    "EGR2 methyl",
    "EGR2 rna"
  ],
  "EGR3": [
    "EGR3 cnv",
    "EGR3 methyl",
    "EGR3 rna"
  ],
  "EGR4": [
    "EGR4 cnv",
    "EGR4 methyl",
    "EGR4 rna"
  ],
  "EHBP1": [
    "EHBP1 1035_1040_1_1_S1035 phospho",
    "EHBP1 1051_1058_1_1_S1058 phospho",
    "EHBP1 316_340_1_1_S335 phospho",
    "EHBP1 377_393_1_1_T378 phospho",
    "EHBP1 408_408_1_1_S408 phospho",
    "EHBP1 426_436_1_1_S428 phospho",
    "EHBP1 571_578_1_1_S578 phospho",
    "EHBP1 647_651_1_1_S649 phospho",
    "EHBP1 656_678_1_0 phospho",
    "EHBP1 710_718_1_1_S710 phospho",
    "EHBP1 742_751_2_2_S747S751 phospho",
    "EHBP1 785_803_1_1_S787 phospho",
    "EHBP1 cnv",
    "EHBP1 methyl",
    "EHBP1 proteo",
    "EHBP1 rna"
  ],
  "EHBP1-AS1": [
    "EHBP1-AS1 methyl"
  ],
  "EHBP1L1": [
    "EHBP1L1 1016_1017_1_1_S1017 phospho",
    "EHBP1L1 1257_1264_1_1_S1257 phospho",
    "EHBP1L1 1273_1275_1_1_S1273 phospho",
    "EHBP1L1 284_285_1_0 phospho",
    "EHBP1L1 284_285_1_1_S285 phospho",
    "EHBP1L1 310_310_1_1_S310 phospho",
    "EHBP1L1 cnv",
    "EHBP1L1 methyl",
    "EHBP1L1 proteo",
    "EHBP1L1 rna"
  ],
  "EHD1": [
    "EHD1 349_355_1_1_S355 phospho",
    "EHD1 447_456_1_1_S456 phospho",
    "EHD1 cnv",
    "EHD1 methyl",
    "EHD1 proteo",
    "EHD1 rna"
  ],
  "EHD2": [
    "EHD2 438_447_1_1_S438 phospho",
    "EHD2 451_470_1_1_S468 phospho",
    "EHD2 cnv",
    "EHD2 methyl",
    "EHD2 proteo",
    "EHD2 rna"
  ],
  "EHD3": [
    "EHD3 448_456_1_1_S456 phospho",
    "EHD3 cnv",
    "EHD3 methyl",
    "EHD3 proteo",
    "EHD3 rna"
  ],
  "EHD4": [
    "EHD4 cnv",
    "EHD4 methyl",
    "EHD4 proteo",
    "EHD4 rna"
  ],
  "EHF": [
    "EHF cnv",
    "EHF rna"
  ],
  "EHHADH": [
    "EHHADH cnv",
    "EHHADH methyl",
    "EHHADH proteo",
    "EHHADH rna"
  ],
  "EHMT1": [
    "EHMT1 426_428_1_1_S428 phospho",
    "EHMT1 cnv",
    "EHMT1 methyl",
    "EHMT1 proteo",
    "EHMT1 rna"
  ],
  "EHMT2": [
    "EHMT2 210_230_1_0 phospho",
    "EHMT2 612_626_1_1_T612 phospho",
    "EHMT2 cnv",
    "EHMT2 methyl",
    "EHMT2 proteo",
    "EHMT2 rna"
  ],
  "EI24": [
    "EI24 294_316_1_1_S306 phospho",
    "EI24 312_316_1_1_S316 phospho",
    "EI24 cnv",
    "EI24 methyl",
    "EI24 proteo",
    "EI24 rna"
  ],
  "EID1": [
    "EID1 cnv",
    "EID1 methyl",
    "EID1 rna"
  ],
  "EID2": [
    "EID2 cnv",
    "EID2 methyl",
    "EID2 rna"
  ],
  "EID2B": [
    "EID2B cnv",
    "EID2B methyl",
    "EID2B rna"
  ],
  "EID3": [
    "EID3 cnv",
    "EID3 methyl",
    "EID3 rna"
  ],
  "EIF1": [
    "EIF1 cnv",
    "EIF1 methyl",
    "EIF1 proteo",
    "EIF1 rna"
  ],
  "EIF1AD": [
    "EIF1AD 152_159_1_1_S159 phospho",
    "EIF1AD 152_159_2_2_S155S159 phospho",
    "EIF1AD cnv",
    "EIF1AD methyl",
    "EIF1AD proteo",
    "EIF1AD rna"
  ],
  "EIF1AX": [
    "EIF1AX methyl",
    "EIF1AX proteo",
    "EIF1AX rna"
  ],
  "EIF1AY": [
    "EIF1AY rna"
  ],
  "EIF1B": [
    "EIF1B cnv",
    "EIF1B methyl",
    "EIF1B proteo",
    "EIF1B rna"
  ],
  "EIF1B-AS1": [
    "EIF1B-AS1 methyl"
  ],
  "EIF2A": [
    "EIF2A 4_9_1_1_T5 phospho",
    "EIF2A cnv",
    "EIF2A methyl",
    "EIF2A proteo",
    "EIF2A rna"
  ],
  "EIF2AK1": [
    "EIF2AK1 cnv",
    "EIF2AK1 kinase",
    "EIF2AK1 methyl",
    "EIF2AK1 rna"
  ],
  "EIF2AK2": [
    "EIF2AK2 323_351_1_0 phospho",
    "EIF2AK2 cnv",
    "EIF2AK2 kinase",
    "EIF2AK2 methyl",
    "EIF2AK2 proteo",
    "EIF2AK2 rna"
  ],
  "EIF2AK3": [
    "EIF2AK3 404_410_1_1_S404 phospho",
    "EIF2AK3 cnv",
    "EIF2AK3 kinase",
    "EIF2AK3 methyl",
    "EIF2AK3 proteo",
    "EIF2AK3 rna"
  ],
  "EIF2AK4": [
    "EIF2AK4 222_230_1_1_S230 phospho",
    "EIF2AK4 667_672_1_1_T667 phospho",
    "EIF2AK4 cnv",
    "EIF2AK4 kinase",
    "EIF2AK4 methyl",
    "EIF2AK4 proteo",
    "EIF2AK4 rna"
  ],
  "EIF2B1": [
    "EIF2B1 cnv",
    "EIF2B1 methyl",
    "EIF2B1 proteo",
    "EIF2B1 rna"
  ],
  "EIF2B2": [
    "EIF2B2 cnv",
    "EIF2B2 methyl",
    "EIF2B2 proteo",
    "EIF2B2 rna"
  ],
  "EIF2B3": [
    "EIF2B3 cnv",
    "EIF2B3 methyl",
    "EIF2B3 proteo",
    "EIF2B3 rna"
  ],
  "EIF2B4": [
    "EIF2B4 cnv",
    "EIF2B4 methyl",
    "EIF2B4 proteo",
    "EIF2B4 rna"
  ],
  "EIF2B5": [
    "EIF2B5 544_544_1_1_S544 phospho",
    "EIF2B5 cnv",
    "EIF2B5 methyl",
    "EIF2B5 proteo",
    "EIF2B5 rna"
  ],
  "EIF2D": [
    "EIF2D cnv",
    "EIF2D methyl",
    "EIF2D proteo",
    "EIF2D rna"
  ],
  "EIF2S1": [
    "EIF2S1 cnv",
    "EIF2S1 methyl",
    "EIF2S1 proteo",
    "EIF2S1 rna"
  ],
  "EIF2S2": [
    "EIF2S2 cnv",
    "EIF2S2 methyl",
    "EIF2S2 proteo",
    "EIF2S2 rna"
  ],
  "EIF2S3": [
    "EIF2S3 methyl",
    "EIF2S3 proteo",
    "EIF2S3 rna"
  ],
  "EIF2S3B": [
    "EIF2S3B cnv",
    "EIF2S3B rna"
  ],
  "EIF3A": [
    "EIF3A cnv",
    "EIF3A methyl",
    "EIF3A proteo",
    "EIF3A rna"
  ],
  "EIF3B": [
    "EIF3B 125_125_1_1_S125 phospho",
    "EIF3B 68_95_1_1_S83 phospho",
    "EIF3B cnv",
    "EIF3B methyl",
    "EIF3B proteo",
    "EIF3B rna"
  ],
  "EIF3C": [
    "EIF3C cnv",
    "EIF3C proteo",
    "EIF3C rna"
  ],
  "EIF3CL": [
    "EIF3CL cnv",
    "EIF3CL rna"
  ],
  "EIF3D": [
    "EIF3D cnv",
    "EIF3D methyl",
    "EIF3D proteo",
    "EIF3D rna"
  ],
  "EIF3E": [
    "EIF3E 399_401_1_1_S399 phospho",
    "EIF3E cnv",
    "EIF3E methyl",
    "EIF3E proteo",
    "EIF3E rna"
  ],
  "EIF3F": [
    "EIF3F 255_276_1_1_S258 phospho",
    "EIF3F cnv",
    "EIF3F proteo",
    "EIF3F rna"
  ],
  "EIF3G": [
    "EIF3G 38_42_1_1_S42 phospho",
    "EIF3G cnv",
    "EIF3G methyl",
    "EIF3G proteo",
    "EIF3G rna"
  ],
  "EIF3H": [
    "EIF3H cnv",
    "EIF3H methyl",
    "EIF3H proteo",
    "EIF3H rna"
  ],
  "EIF3I": [
    "EIF3I cnv",
    "EIF3I methyl",
    "EIF3I proteo",
    "EIF3I rna"
  ],
  "EIF3J": [
    "EIF3J 109_109_1_1_T109 phospho",
    "EIF3J 127_127_1_1_S127 phospho",
    "EIF3J cnv",
    "EIF3J methyl",
    "EIF3J proteo",
    "EIF3J rna"
  ],
  "EIF3J-DT": [
    "EIF3J-DT methyl"
  ],
  "EIF3K": [
    "EIF3K cnv",
    "EIF3K methyl",
    "EIF3K proteo",
    "EIF3K rna"
  ],
  "EIF3L": [
    "EIF3L cnv",
    "EIF3L methyl",
    "EIF3L proteo",
    "EIF3L rna"
  ],
  "EIF3M": [
    "EIF3M 335_338_1_1_S337 phospho",
    "EIF3M cnv",
    "EIF3M methyl",
    "EIF3M proteo",
    "EIF3M rna"
  ],
  "EIF4A1": [
    "EIF4A1 cnv",
    "EIF4A1 methyl",
    "EIF4A1 proteo",
    "EIF4A1 rna"
  ],
  "EIF4A2": [
    "EIF4A2 cnv",
    "EIF4A2 methyl",
    "EIF4A2 proteo",
    "EIF4A2 rna"
  ],
  "EIF4A3": [
    "EIF4A3 cnv",
    "EIF4A3 methyl",
    "EIF4A3 proteo",
    "EIF4A3 rna"
  ],
  "EIF4B": [
    "EIF4B 205_211_1_1_S207 phospho",
    "EIF4B 219_219_1_1_S219 phospho",
    "EIF4B 258_266_1_1_S263 phospho",
    "EIF4B 359_369_1_1_S359 phospho",
    "EIF4B 418_434_2_2_T420S422 phospho",
    "EIF4B 420_434_1_1_S422 phospho",
    "EIF4B 450_455_1_0 phospho",
    "EIF4B 464_467_1_1_S464 phospho",
    "EIF4B 493_494_1_1_S494 phospho",
    "EIF4B 500_512_1_0 phospho",
    "EIF4B 500_512_1_1_S503 phospho",
    "EIF4B 500_512_2_2_S502S503 phospho",
    "EIF4B 500_512_2_2_S503S509 phospho",
    "EIF4B 500_512_3_3_S502S503S509 phospho",
    "EIF4B 598_614_1_1_S602 phospho",
    "EIF4B cnv",
    "EIF4B methyl",
    "EIF4B proteo",
    "EIF4B rna"
  ],
  "EIF4E": [
    "EIF4E cnv",
    "EIF4E methyl",
    "EIF4E proteo",
    "EIF4E rna"
  ],
  "EIF4E1B": [
    "EIF4E1B cnv",
    "EIF4E1B methyl",
    "EIF4E1B rna"
  ],
  "EIF4E2": [
    "EIF4E2 cnv",
    "EIF4E2 methyl",
    "EIF4E2 proteo",
    "EIF4E2 rna"
  ],
  "EIF4E3": [
    "EIF4E3 cnv",
    "EIF4E3 methyl",
    "EIF4E3 proteo",
    "EIF4E3 rna"
  ],
  "EIF4EBP1": [
    "EIF4EBP1 34_50_2_0 phospho",
    "EIF4EBP1 34_54_2_0 phospho",
    "EIF4EBP1 65_68_1_1_S65 phospho",
    "EIF4EBP1 65_96_1_0 phospho",
    "EIF4EBP1 65_96_1_1_T70 phospho",
    "EIF4EBP1 70_101_2_0 phospho",
    "EIF4EBP1 70_101_2_2_T70S101 phospho",
    "EIF4EBP1 70_96_1_1_T70 phospho",
    "EIF4EBP1 77_101_1_0 phospho",
    "EIF4EBP1 77_101_1_1_S101 phospho",
    "EIF4EBP1 cnv",
    "EIF4EBP1 methyl",
    "EIF4EBP1 proteo",
    "EIF4EBP1 rna"
  ],
  "EIF4EBP2": [
    "EIF4EBP2 21_50_1_1_T46 phospho",
    "EIF4EBP2 21_50_2_2_T37T46 phospho",
    "EIF4EBP2 21_54_2_0 phospho",
    "EIF4EBP2 21_54_2_2_T37T46 phospho",
    "EIF4EBP2 65_91_1_1_S65 phospho",
    "EIF4EBP2 65_91_1_1_T70 phospho",
    "EIF4EBP2 cnv",
    "EIF4EBP2 methyl",
    "EIF4EBP2 proteo",
    "EIF4EBP2 rna"
  ],
  "EIF4EBP3": [
    "EIF4EBP3 20_36_1_1_T32 phospho",
    "EIF4EBP3 cnv",
    "EIF4EBP3 methyl",
    "EIF4EBP3 proteo",
    "EIF4EBP3 rna"
  ],
  "EIF4ENIF1": [
    "EIF4ENIF1 136_138_1_1_S138 phospho",
    "EIF4ENIF1 564_573_1_1_S564 phospho",
    "EIF4ENIF1 587_592_1_1_S587 phospho",
    "EIF4ENIF1 734_757_1_0 phospho",
    "EIF4ENIF1 734_757_1_1_S752 phospho",
    "EIF4ENIF1 77_82_1_1_S78 phospho",
    "EIF4ENIF1 932_946_1_1_S946 phospho",
    "EIF4ENIF1 949_951_1_1_S951 phospho",
    "EIF4ENIF1 cnv",
    "EIF4ENIF1 methyl",
    "EIF4ENIF1 proteo",
    "EIF4ENIF1 rna"
  ],
  "EIF4G1": [
    "EIF4G1 1080_1099_1_1_S1099 phospho",
    "EIF4G1 1238_1238_1_1_S1238 phospho",
    "EIF4G1 209_230_2_2_T212T214 phospho",
    "EIF4G1 cnv",
    "EIF4G1 methyl",
    "EIF4G1 proteo",
    "EIF4G1 rna"
  ],
  "EIF4G2": [
    "EIF4G2 432_454_1_1_S443 phospho",
    "EIF4G2 495_514_1_0 phospho",
    "EIF4G2 495_514_1_1_S500 phospho",
    "EIF4G2 506_514_1_1_T508 phospho",
    "EIF4G2 cnv",
    "EIF4G2 methyl",
    "EIF4G2 proteo",
    "EIF4G2 rna"
  ],
  "EIF4G3": [
    "EIF4G3 1192_1201_1_1_S1192 phospho",
    "EIF4G3 1443_1453_1_1_S1445 phospho",
    "EIF4G3 480_503_1_0 phospho",
    "EIF4G3 494_503_1_1_S494 phospho",
    "EIF4G3 cnv",
    "EIF4G3 methyl",
    "EIF4G3 proteo",
    "EIF4G3 rna"
  ],
  "EIF4H": [
    "EIF4H 217_230_1_1_S230 phospho",
    "EIF4H cnv",
    "EIF4H methyl",
    "EIF4H proteo",
    "EIF4H rna"
  ],
  "EIF5": [
    "EIF5 149_153_1_0 phospho",
    "EIF5 149_153_1_1_T153 phospho",
    "EIF5 389_406_1_1_S390 phospho",
    "EIF5 cnv",
    "EIF5 methyl",
    "EIF5 proteo",
    "EIF5 rna"
  ],
  "EIF5A": [
    "EIF5A cnv",
    "EIF5A methyl",
    "EIF5A proteo",
    "EIF5A rna"
  ],
  "EIF5A2": [
    "EIF5A2 cnv",
    "EIF5A2 methyl",
    "EIF5A2 rna"
  ],
  "EIF5AL1": [
    "EIF5AL1 cnv",
    "EIF5AL1 rna"
  ],
  "EIF5B": [
    "EIF5B 107_113_1_1_S107 phospho",
    "EIF5B 107_113_1_1_S113 phospho",
    "EIF5B 107_113_2_2_S107S113 phospho",
    "EIF5B 107_121_1_1_S113 phospho",
    "EIF5B 107_121_2_2_S107S113 phospho",
    "EIF5B 1168_1168_1_1_S1168 phospho",
    "EIF5B 134_137_1_1_S137 phospho",
    "EIF5B 134_137_2_0 phospho",
    "EIF5B 134_137_2_2_S135S137 phospho",
    "EIF5B 164_171_1_1_S164 phospho",
    "EIF5B 214_222_1_1_S214 phospho",
    "EIF5B cnv",
    "EIF5B methyl",
    "EIF5B proteo",
    "EIF5B rna"
  ],
  "EIF6": [
    "EIF6 230_245_1_1_S239 phospho",
    "EIF6 cnv",
    "EIF6 methyl",
    "EIF6 proteo",
    "EIF6 rna"
  ],
  "EIPR1": [
    "EIPR1 327_354_1_1_S347 phospho",
    "EIPR1 cnv",
    "EIPR1 methyl",
    "EIPR1 proteo",
    "EIPR1 rna"
  ],
  "ELAC1": [
    "ELAC1 cnv",
    "ELAC1 proteo",
    "ELAC1 rna"
  ],
  "ELAC2": [
    "ELAC2 cnv",
    "ELAC2 methyl",
    "ELAC2 proteo",
    "ELAC2 rna"
  ],
  "ELANE": [
    "ELANE cnv",
    "ELANE proteo",
    "ELANE rna"
  ],
  "ELAPOR1": [
    "ELAPOR1 cnv",
    "ELAPOR1 methyl",
    "ELAPOR1 proteo",
    "ELAPOR1 rna"
  ],
  "ELAPOR2": [
    "ELAPOR2 cnv",
    "ELAPOR2 proteo",
    "ELAPOR2 rna"
  ],
  "ELAVL1": [
    "ELAVL1 197_202_1_1_S202 phospho",
    "ELAVL1 cnv",
    "ELAVL1 methyl",
    "ELAVL1 proteo",
    "ELAVL1 rna"
  ],
  "ELAVL2": [
    "ELAVL2 210_221_1_1_S221 phospho",
    "ELAVL2 cnv",
    "ELAVL2 methyl",
    "ELAVL2 proteo",
    "ELAVL2 rna"
  ],
  "ELAVL3": [
    "ELAVL3 cnv",
    "ELAVL3 methyl",
    "ELAVL3 proteo",
    "ELAVL3 rna"
  ],
  "ELAVL4": [
    "ELAVL4 217_228_1_1_S228 phospho",
    "ELAVL4 33_44_1_1_S33 phospho",
    "ELAVL4 33_58_1_1_S33 phospho",
    "ELAVL4 cnv",
    "ELAVL4 methyl",
    "ELAVL4 proteo",
    "ELAVL4 rna"
  ],
  "ELF1": [
    "ELF1 136_144_1_1_S144 phospho",
    "ELF1 156_171_1_1_S163 phospho",
    "ELF1 cnv",
    "ELF1 methyl",
    "ELF1 proteo",
    "ELF1 rna"
  ],
  "ELF2": [
    "ELF2 110_119_1_1_S119 phospho",
    "ELF2 cnv",
    "ELF2 methyl",
    "ELF2 proteo",
    "ELF2 rna"
  ],
  "ELF3": [
    "ELF3 cnv",
    "ELF3 rna"
  ],
  "ELF4": [
    "ELF4 150_157_1_1_S151 phospho",
    "ELF4 methyl",
    "ELF4 rna"
  ],
  "ELF5": [
    "ELF5 cnv",
    "ELF5 rna"
  ],
  "ELFN1": [
    "ELFN1 cnv",
    "ELFN1 methyl",
    "ELFN1 proteo",
    "ELFN1 rna"
  ],
  "ELFN2": [
    "ELFN2 751_766_1_1_S757 phospho",
    "ELFN2 cnv",
    "ELFN2 methyl",
    "ELFN2 proteo",
    "ELFN2 rna"
  ],
  "ELK1": [
    "ELK1 methyl",
    "ELK1 rna"
  ],
  "ELK3": [
    "ELK3 396_404_1_1_S396 phospho",
    "ELK3 cnv",
    "ELK3 methyl",
    "ELK3 rna"
  ],
  "ELK4": [
    "ELK4 cnv",
    "ELK4 methyl",
    "ELK4 rna"
  ],
  "ELL": [
    "ELL 297_309_1_1_S309 phospho",
    "ELL 431_444_1_1_S442 phospho",
    "ELL cnv",
    "ELL methyl",
    "ELL proteo",
    "ELL rna"
  ],
  "ELL2": [
    "ELL2 cnv",
    "ELL2 methyl",
    "ELL2 rna"
  ],
  "ELL3": [
    "ELL3 cnv",
    "ELL3 methyl",
    "ELL3 rna"
  ],
  "ELMO1": [
    "ELMO1 336_344_1_1_S344 phospho",
    "ELMO1 cnv",
    "ELMO1 methyl",
    "ELMO1 proteo",
    "ELMO1 rna"
  ],
  "ELMO2": [
    "ELMO2 328_338_1_1_S336 phospho",
    "ELMO2 cnv",
    "ELMO2 methyl",
    "ELMO2 proteo",
    "ELMO2 rna"
  ],
  "ELMO3": [
    "ELMO3 cnv",
    "ELMO3 methyl",
    "ELMO3 rna"
  ],
  "ELMOD1": [
    "ELMOD1 cnv",
    "ELMOD1 methyl",
    "ELMOD1 proteo",
    "ELMOD1 rna"
  ],
  "ELMOD2": [
    "ELMOD2 cnv",
    "ELMOD2 methyl",
    "ELMOD2 proteo",
    "ELMOD2 rna"
  ],
  "ELMOD3": [
    "ELMOD3 cnv",
    "ELMOD3 methyl",
    "ELMOD3 rna"
  ],
  "ELN": [
    "ELN cnv",
    "ELN proteo",
    "ELN rna"
  ],
  "ELOA": [
    "ELOA cnv",
    "ELOA methyl",
    "ELOA proteo",
    "ELOA rna"
  ],
  "ELOA-AS1": [
    "ELOA-AS1 methyl"
  ],
  "ELOA2": [
    "ELOA2 cnv",
    "ELOA2 methyl",
    "ELOA2 rna"
  ],
  "ELOA3BP": [
    "ELOA3BP cnv",
    "ELOA3BP rna"
  ],
  "ELOA3CP": [
    "ELOA3CP cnv",
    "ELOA3CP rna"
  ],
  "ELOA3DP": [
    "ELOA3DP cnv",
    "ELOA3DP rna"
  ],
  "ELOA3P": [
    "ELOA3P cnv",
    "ELOA3P rna"
  ],
  "ELOB": [
    "ELOB cnv",
    "ELOB methyl",
    "ELOB proteo",
    "ELOB rna"
  ],
  "ELOC": [
    "ELOC cnv",
    "ELOC methyl",
    "ELOC proteo",
    "ELOC rna"
  ],
  "ELOF1": [
    "ELOF1 cnv",
    "ELOF1 methyl",
    "ELOF1 proteo",
    "ELOF1 rna"
  ],
  "ELOVL1": [
    "ELOVL1 cnv",
    "ELOVL1 methyl",
    "ELOVL1 proteo",
    "ELOVL1 rna"
  ],
  "ELOVL2": [
    "ELOVL2 cnv",
    "ELOVL2 methyl",
    "ELOVL2 proteo",
    "ELOVL2 rna"
  ],
  "ELOVL2-AS1": [
    "ELOVL2-AS1 methyl"
  ],
  "ELOVL3": [
    "ELOVL3 cnv",
    "ELOVL3 methyl",
    "ELOVL3 rna"
  ],
  "ELOVL4": [
    "ELOVL4 cnv",
    "ELOVL4 methyl",
    "ELOVL4 rna"
  ],
  "ELOVL5": [
    "ELOVL5 300_312_1_1_S300 phospho",
    "ELOVL5 cnv",
    "ELOVL5 methyl",
    "ELOVL5 proteo",
    "ELOVL5 rna"
  ],
  "ELOVL6": [
    "ELOVL6 cnv",
    "ELOVL6 methyl",
    "ELOVL6 rna"
  ],
  "ELOVL7": [
    "ELOVL7 cnv",
    "ELOVL7 methyl",
    "ELOVL7 rna"
  ],
  "ELP1": [
    "ELP1 cnv",
    "ELP1 methyl",
    "ELP1 proteo",
    "ELP1 rna"
  ],
  "ELP2": [
    "ELP2 cnv",
    "ELP2 methyl",
    "ELP2 proteo",
    "ELP2 rna"
  ],
  "ELP3": [
    "ELP3 cnv",
    "ELP3 methyl",
    "ELP3 proteo",
    "ELP3 rna"
  ],
  "ELP4": [
    "ELP4 cnv",
    "ELP4 methyl",
    "ELP4 proteo",
    "ELP4 rna"
  ],
  "ELP5": [
    "ELP5 cnv",
    "ELP5 methyl",
    "ELP5 proteo",
    "ELP5 rna"
  ],
  "ELP6": [
    "ELP6 cnv",
    "ELP6 methyl",
    "ELP6 proteo",
    "ELP6 rna"
  ],
  "ELSPBP1": [
    "ELSPBP1 cnv",
    "ELSPBP1 rna"
  ],
  "EMB": [
    "EMB cnv",
    "EMB methyl",
    "EMB rna"
  ],
  "EMBP1": [
    "EMBP1 methyl"
  ],
  "EMC1": [
    "EMC1 FINYNQTVSR-N2H7F0S0G0 glyco",
    "EMC1 FINYNQTVSR-N2H8F0S0G0 glyco",
    "EMC1 FINYNQTVSR-N2H9F0S0G0 glyco",
    "EMC1 cnv",
    "EMC1 methyl",
    "EMC1 proteo",
    "EMC1 rna"
  ],
  "EMC1-AS1": [
    "EMC1-AS1 methyl"
  ],
  "EMC10": [
    "EMC10 cnv",
    "EMC10 methyl",
    "EMC10 proteo",
    "EMC10 rna"
  ],
  "EMC2": [
    "EMC2 cnv",
    "EMC2 methyl",
    "EMC2 proteo",
    "EMC2 rna"
  ],
  "EMC3": [
    "EMC3 cnv",
    "EMC3 methyl",
    "EMC3 proteo",
    "EMC3 rna"
  ],
  "EMC4": [
    "EMC4 32_47_1_1_S36 phospho",
    "EMC4 cnv",
    "EMC4 proteo",
    "EMC4 rna"
  ],
  "EMC6": [
    "EMC6 cnv",
    "EMC6 methyl",
    "EMC6 rna"
  ],
  "EMC7": [
    "EMC7 cnv",
    "EMC7 methyl",
    "EMC7 proteo",
    "EMC7 rna"
  ],
  "EMC8": [
    "EMC8 cnv",
    "EMC8 methyl",
    "EMC8 proteo",
    "EMC8 rna"
  ],
  "EMC9": [
    "EMC9 cnv",
    "EMC9 methyl",
    "EMC9 proteo",
    "EMC9 rna"
  ],
  "EMCN": [
    "EMCN cnv",
    "EMCN proteo",
    "EMCN rna"
  ],
  "EMD": [
    "EMD 120_143_1_0 phospho",
    "EMD 120_143_1_1_S120 phospho",
    "EMD 19_30_1_1_S29 phospho",
    "EMD 49_67_1_1_S60 phospho",
    "EMD 49_74_1_1_S49 phospho",
    "EMD methyl",
    "EMD proteo",
    "EMD rna"
  ],
  "EME1": [
    "EME1 cnv",
    "EME1 methyl",
    "EME1 rna"
  ],
  "EME2": [
    "EME2 cnv",
    "EME2 methyl",
    "EME2 rna"
  ],
  "EMG1": [
    "EMG1 cnv",
    "EMG1 methyl",
    "EMG1 proteo",
    "EMG1 rna"
  ],
  "EMID1": [
    "EMID1 cnv",
    "EMID1 methyl",
    "EMID1 rna"
  ],
  "EMILIN1": [
    "EMILIN1 ETNTTSQMQAALLEK-N2H5F0S0G0 glyco",
    "EMILIN1 LGALNSSLQLLEDR-N5H4F0S0G0 glyco",
    "EMILIN1 cnv",
    "EMILIN1 methyl",
    "EMILIN1 proteo",
    "EMILIN1 rna"
  ],
  "EMILIN2": [
    "EMILIN2 cnv",
    "EMILIN2 methyl",
    "EMILIN2 proteo",
    "EMILIN2 rna"
  ],
  "EMILIN3": [
    "EMILIN3 cnv",
    "EMILIN3 proteo",
    "EMILIN3 rna"
  ],
  "EML1": [
    "EML1 cnv",
    "EML1 methyl",
    "EML1 proteo",
    "EML1 rna"
  ],
  "EML2": [
    "EML2 156_162_1_1_S162 phospho",
    "EML2 cnv",
    "EML2 methyl",
    "EML2 proteo",
    "EML2 rna"
  ],
  "EML2-AS1": [
    "EML2-AS1 methyl"
  ],
  "EML3": [
    "EML3 197_204_1_1_S198 phospho",
    "EML3 881_883_1_1_T881 phospho",
    "EML3 885_893_1_1_S889 phospho",
    "EML3 885_893_1_1_S893 phospho",
    "EML3 cnv",
    "EML3 methyl",
    "EML3 proteo",
    "EML3 rna"
  ],
  "EML4": [
    "EML4 144_151_1_1_S144 phospho",
    "EML4 144_151_1_1_S146 phospho",
    "EML4 144_151_1_1_S151 phospho",
    "EML4 144_151_2_2_S144S146 phospho",
    "EML4 176_176_1_1_S176 phospho",
    "EML4 887_914_1_1_T899 phospho",
    "EML4 887_914_2_2_T897T899 phospho",
    "EML4 94_100_1_1_S94 phospho",
    "EML4 969_981_1_1_S978 phospho",
    "EML4 cnv",
    "EML4 methyl",
    "EML4 proteo",
    "EML4 rna"
  ],
  "EML5": [
    "EML5 cnv",
    "EML5 methyl",
    "EML5 rna"
  ],
  "EML6": [
    "EML6 cnv",
    "EML6 methyl",
    "EML6 rna"
  ],
  "EMP1": [
    "EMP1 cnv",
    "EMP1 rna"
  ],
  "EMP2": [
    "EMP2 cnv",
    "EMP2 methyl",
    "EMP2 rna"
  ],
  "EMP3": [
    "EMP3 cnv",
    "EMP3 rna"
  ],
  "EMSY": [
    "EMSY 1144_1156_1_1_S1151 phospho",
    "EMSY 1225_1238_1_1_S1228 phospho",
    "EMSY 206_210_1_1_S210 phospho",
    "EMSY 222_228_1_0 phospho",
    "EMSY 245_253_1_1_S253 phospho",
    "EMSY cnv",
    "EMSY methyl",
    "EMSY proteo",
    "EMSY rna"
  ],
  "EMX1": [
    "EMX1 cnv",
    "EMX1 methyl",
    "EMX1 rna"
  ],
  "EMX2": [
    "EMX2 cnv",
    "EMX2 methyl",
    "EMX2 rna"
  ],
  "EMX2OS": [
    "EMX2OS methyl"
  ],
  "EN1": [
    "EN1 cnv",
    "EN1 methyl",
    "EN1 rna"
  ],
  "EN2": [
    "EN2 cnv",
    "EN2 methyl",
    "EN2 rna"
  ],
  "ENAH": [
    "ENAH 125_136_1_1_S125 phospho",
    "ENAH 500_512_1_1_S508 phospho",
    "ENAH 500_512_2_2_T502S508 phospho",
    "ENAH 508_512_1_1_S508 phospho",
    "ENAH 516_534_1_1_S523 phospho",
    "ENAH cnv",
    "ENAH methyl",
    "ENAH proteo",
    "ENAH rna"
  ],
  "ENAM": [
    "ENAM cnv",
    "ENAM rna"
  ],
  "ENC1": [
    "ENC1 391_410_1_1_S406 phospho",
    "ENC1 cnv",
    "ENC1 methyl",
    "ENC1 proteo",
    "ENC1 rna"
  ],
  "ENDOD1": [
    "ENDOD1 cnv",
    "ENDOD1 methyl",
    "ENDOD1 proteo",
    "ENDOD1 rna"
  ],
  "ENDOG": [
    "ENDOG cnv",
    "ENDOG methyl",
    "ENDOG proteo",
    "ENDOG rna"
  ],
  "ENDOU": [
    "ENDOU cnv",
    "ENDOU rna"
  ],
  "ENDOV": [
    "ENDOV cnv",
    "ENDOV methyl",
    "ENDOV rna"
  ],
  "ENG": [
    "ENG cnv",
    "ENG proteo",
    "ENG rna"
  ],
  "ENGASE": [
    "ENGASE cnv",
    "ENGASE proteo",
    "ENGASE rna"
  ],
  "ENHO": [
    "ENHO cnv",
    "ENHO methyl",
    "ENHO rna"
  ],
  "ENKD1": [
    "ENKD1 cnv",
    "ENKD1 methyl",
    "ENKD1 proteo",
    "ENKD1 rna"
  ],
  "ENKUR": [
    "ENKUR cnv",
    "ENKUR methyl",
    "ENKUR rna"
  ],
  "ENO1": [
    "ENO1 141_157_1_1_S141 phospho",
    "ENO1 19_27_1_1_S27 phospho",
    "ENO1 254_268_1_1_S263 phospho",
    "ENO1 257_268_1_1_S263 phospho",
    "ENO1 270_280_1_1_S272 phospho",
    "ENO1 cnv",
    "ENO1 methyl",
    "ENO1 proteo",
    "ENO1 rna"
  ],
  "ENO1-AS1": [
    "ENO1-AS1 methyl"
  ],
  "ENO2": [
    "ENO2 257_268_1_1_T265 phospho",
    "ENO2 cnv",
    "ENO2 methyl",
    "ENO2 proteo",
    "ENO2 rna"
  ],
  "ENO3": [
    "ENO3 cnv",
    "ENO3 methyl",
    "ENO3 proteo",
    "ENO3 rna"
  ],
  "ENO4": [
    "ENO4 cnv",
    "ENO4 methyl",
    "ENO4 rna"
  ],
  "ENOPH1": [
    "ENOPH1 cnv",
    "ENOPH1 methyl",
    "ENOPH1 proteo",
    "ENOPH1 rna"
  ],
  "ENOSF1": [
    "ENOSF1 cnv",
    "ENOSF1 methyl",
    "ENOSF1 proteo",
    "ENOSF1 rna"
  ],
  "ENOX1": [
    "ENOX1 cnv",
    "ENOX1 methyl",
    "ENOX1 rna"
  ],
  "ENOX2": [
    "ENOX2 211_224_1_1_S211 phospho",
    "ENOX2 methyl",
    "ENOX2 rna"
  ],
  "ENPEP": [
    "ENPEP HTAEYAANITK-N5H6F0S0G0 glyco",
    "ENPEP cnv",
    "ENPEP proteo",
    "ENPEP rna"
  ],
  "ENPP1": [
    "ENPP1 cnv",
    "ENPP1 methyl",
    "ENPP1 proteo",
    "ENPP1 rna"
  ],
  "ENPP2": [
    "ENPP2 cnv",
    "ENPP2 proteo",
    "ENPP2 rna"
  ],
  "ENPP3": [
    "ENPP3 cnv",
    "ENPP3 methyl",
    "ENPP3 rna"
  ],
  "ENPP4": [
    "ENPP4 cnv",
    "ENPP4 methyl",
    "ENPP4 proteo",
    "ENPP4 rna"
  ],
  "ENPP5": [
    "ENPP5 cnv",
    "ENPP5 rna"
  ],
  "ENPP6": [
    "ENPP6 cnv",
    "ENPP6 proteo",
    "ENPP6 rna"
  ],
  "ENPP7": [
    "ENPP7 cnv",
    "ENPP7 methyl",
    "ENPP7 rna"
  ],
  "ENSA": [
    "ENSA 108_113_1_1_S109 phospho",
    "ENSA 41_51_1_1_S43 phospho",
    "ENSA cnv",
    "ENSA methyl",
    "ENSA proteo",
    "ENSA rna"
  ],
  "ENSG00000100101": [
    "ENSG00000100101 cnv",
    "ENSG00000100101 rna"
  ],
  "ENSG00000111780": [
    "ENSG00000111780 cnv",
    "ENSG00000111780 rna"
  ],
  "ENSG00000124593": [
    "ENSG00000124593 cnv",
    "ENSG00000124593 rna"
  ],
  "ENSG00000125695": [
    "ENSG00000125695 cnv",
    "ENSG00000125695 rna"
  ],
  "ENSG00000131152": [
    "ENSG00000131152 cnv",
    "ENSG00000131152 rna"
  ],
  "ENSG00000141979": [
    "ENSG00000141979 cnv",
    "ENSG00000141979 rna"
  ],
  "ENSG00000142539": [
    "ENSG00000142539 cnv",
    "ENSG00000142539 rna"
  ],
  "ENSG00000144785": [
    "ENSG00000144785 cnv",
    "ENSG00000144785 rna"
  ],
  "ENSG00000146722": [
    "ENSG00000146722 methyl"
  ],
  "ENSG00000159239": [
    "ENSG00000159239 cnv",
    "ENSG00000159239 rna"
  ],
  "ENSG00000167774": [
    "ENSG00000167774 cnv",
    "ENSG00000167774 rna"
  ],
  "ENSG00000167807": [
    "ENSG00000167807 cnv",
    "ENSG00000167807 rna"
  ],
  "ENSG00000170846": [
    "ENSG00000170846 cnv",
    "ENSG00000170846 rna"
  ],
  "ENSG00000173366": [
    "ENSG00000173366 cnv",
    "ENSG00000173366 rna"
  ],
  "ENSG00000173867": [
    "ENSG00000173867 cnv",
    "ENSG00000173867 rna"
  ],
  "ENSG00000176593": [
    "ENSG00000176593 methyl"
  ],
  "ENSG00000176984": [
    "ENSG00000176984 methyl"
  ],
  "ENSG00000178836": [
    "ENSG00000178836 methyl"
  ],
  "ENSG00000183889": [
    "ENSG00000183889 cnv",
    "ENSG00000183889 rna"
  ],
  "ENSG00000187186": [
    "ENSG00000187186 cnv",
    "ENSG00000187186 methyl",
    "ENSG00000187186 rna"
  ],
  "ENSG00000187951": [
    "ENSG00000187951 methyl"
  ],
  "ENSG00000188223": [
    "ENSG00000188223 cnv",
    "ENSG00000188223 rna"
  ],
  "ENSG00000188897": [
    "ENSG00000188897 cnv",
    "ENSG00000188897 rna"
  ],
  "ENSG00000196826": [
    "ENSG00000196826 cnv",
    "ENSG00000196826 rna"
  ],
  "ENSG00000197991": [
    "ENSG00000197991 cnv",
    "ENSG00000197991 rna"
  ],
  "ENSG00000198211": [
    "ENSG00000198211 cnv",
    "ENSG00000198211 rna"
  ],
  "ENSG00000203546": [
    "ENSG00000203546 cnv",
    "ENSG00000203546 rna"
  ],
  "ENSG00000203987": [
    "ENSG00000203987 methyl"
  ],
  "ENSG00000204003": [
    "ENSG00000204003 cnv",
    "ENSG00000204003 rna"
  ],
  "ENSG00000204422": [
    "ENSG00000204422 cnv",
    "ENSG00000204422 rna"
  ],
  "ENSG00000205037": [
    "ENSG00000205037 methyl"
  ],
  "ENSG00000205236": [
    "ENSG00000205236 cnv",
    "ENSG00000205236 rna"
  ],
  "ENSG00000206549": [
    "ENSG00000206549 cnv",
    "ENSG00000206549 rna"
  ],
  "ENSG00000213204": [
    "ENSG00000213204 cnv",
    "ENSG00000213204 rna"
  ],
  "ENSG00000213963": [
    "ENSG00000213963 methyl"
  ],
  "ENSG00000214265": [
    "ENSG00000214265 cnv",
    "ENSG00000214265 rna"
  ],
  "ENSG00000214347": [
    "ENSG00000214347 methyl"
  ],
  "ENSG00000214999": [
    "ENSG00000214999 methyl"
  ],
  "ENSG00000215154": [
    "ENSG00000215154 methyl"
  ],
  "ENSG00000215838": [
    "ENSG00000215838 methyl"
  ],
  "ENSG00000216775": [
    "ENSG00000216775 methyl"
  ],
  "ENSG00000217801": [
    "ENSG00000217801 methyl"
  ],
  "ENSG00000222012": [
    "ENSG00000222012 methyl"
  ],
  "ENSG00000224090": [
    "ENSG00000224090 methyl"
  ],
  "ENSG00000225528": [
    "ENSG00000225528 cnv",
    "ENSG00000225528 rna"
  ],
  "ENSG00000226172": [
    "ENSG00000226172 methyl"
  ],
  "ENSG00000226490": [
    "ENSG00000226490 cnv",
    "ENSG00000226490 rna"
  ],
  "ENSG00000226690": [
    "ENSG00000226690 cnv",
    "ENSG00000226690 rna"
  ],
  "ENSG00000228144": [
    "ENSG00000228144 cnv",
    "ENSG00000228144 rna"
  ],
  "ENSG00000228484": [
    "ENSG00000228484 methyl"
  ],
  "ENSG00000228549": [
    "ENSG00000228549 methyl"
  ],
  "ENSG00000228919": [
    "ENSG00000228919 methyl"
  ],
  "ENSG00000230626": [
    "ENSG00000230626 cnv",
    "ENSG00000230626 rna"
  ],
  "ENSG00000230707": [
    "ENSG00000230707 methyl",
    "ENSG00000230707 rna"
  ],
  "ENSG00000230725": [
    "ENSG00000230725 methyl"
  ],
  "ENSG00000232197": [
    "ENSG00000232197 methyl"
  ],
  "ENSG00000232377": [
    "ENSG00000232377 methyl"
  ],
  "ENSG00000233223": [
    "ENSG00000233223 methyl"
  ],
  "ENSG00000233251": [
    "ENSG00000233251 methyl"
  ],
  "ENSG00000233437": [
    "ENSG00000233437 methyl"
  ],
  "ENSG00000233633": [
    "ENSG00000233633 methyl"
  ],
  "ENSG00000233757": [
    "ENSG00000233757 cnv",
    "ENSG00000233757 rna"
  ],
  "ENSG00000234352": [
    "ENSG00000234352 methyl"
  ],
  "ENSG00000235007": [
    "ENSG00000235007 cnv",
    "ENSG00000235007 rna"
  ],
  "ENSG00000235138": [
    "ENSG00000235138 methyl"
  ],
  "ENSG00000236064": [
    "ENSG00000236064 methyl"
  ],
  "ENSG00000236543": [
    "ENSG00000236543 cnv"
  ],
  "ENSG00000236829": [
    "ENSG00000236829 methyl"
  ],
  "ENSG00000237378": [
    "ENSG00000237378 cnv"
  ],
  "ENSG00000237461": [
    "ENSG00000237461 methyl"
  ],
  "ENSG00000238142": [
    "ENSG00000238142 methyl"
  ],
  "ENSG00000238158": [
    "ENSG00000238158 methyl"
  ],
  "ENSG00000239219": [
    "ENSG00000239219 methyl"
  ],
  "ENSG00000239395": [
    "ENSG00000239395 cnv"
  ],
  "ENSG00000239467": [
    "ENSG00000239467 methyl"
  ],
  "ENSG00000239920": [
    "ENSG00000239920 cnv",
    "ENSG00000239920 rna"
  ],
  "ENSG00000241489": [
    "ENSG00000241489 rna"
  ],
  "ENSG00000241525": [
    "ENSG00000241525 methyl"
  ],
  "ENSG00000241690": [
    "ENSG00000241690 cnv"
  ],
  "ENSG00000241962": [
    "ENSG00000241962 cnv",
    "ENSG00000241962 rna"
  ],
  "ENSG00000243062": [
    "ENSG00000243062 methyl"
  ],
  "ENSG00000243501": [
    "ENSG00000243501 cnv",
    "ENSG00000243501 rna"
  ],
  "ENSG00000243696": [
    "ENSG00000243696 cnv",
    "ENSG00000243696 rna"
  ],
  "ENSG00000244255": [
    "ENSG00000244255 cnv",
    "ENSG00000244255 rna"
  ],
  "ENSG00000245008": [
    "ENSG00000245008 methyl"
  ],
  "ENSG00000245651": [
    "ENSG00000245651 methyl"
  ],
  "ENSG00000246090": [
    "ENSG00000246090 methyl"
  ],
  "ENSG00000246130": [
    "ENSG00000246130 methyl"
  ],
  "ENSG00000246308": [
    "ENSG00000246308 methyl"
  ],
  "ENSG00000246331": [
    "ENSG00000246331 methyl"
  ],
  "ENSG00000247131": [
    "ENSG00000247131 methyl"
  ],
  "ENSG00000247193": [
    "ENSG00000247193 methyl"
  ],
  "ENSG00000247416": [
    "ENSG00000247416 methyl"
  ],
  "ENSG00000248235": [
    "ENSG00000248235 cnv",
    "ENSG00000248235 rna"
  ],
  "ENSG00000248540": [
    "ENSG00000248540 methyl"
  ],
  "ENSG00000248710": [
    "ENSG00000248710 cnv",
    "ENSG00000248710 rna"
  ],
  "ENSG00000248751": [
    "ENSG00000248751 cnv",
    "ENSG00000248751 rna"
  ],
  "ENSG00000248896": [
    "ENSG00000248896 methyl"
  ],
  "ENSG00000248993": [
    "ENSG00000248993 cnv",
    "ENSG00000248993 rna"
  ],
  "ENSG00000249141": [
    "ENSG00000249141 cnv",
    "ENSG00000249141 rna"
  ],
  "ENSG00000249209": [
    "ENSG00000249209 cnv",
    "ENSG00000249209 rna"
  ],
  "ENSG00000249240": [
    "ENSG00000249240 cnv",
    "ENSG00000249240 rna"
  ],
  "ENSG00000249319": [
    "ENSG00000249319 cnv",
    "ENSG00000249319 rna"
  ],
  "ENSG00000249590": [
    "ENSG00000249590 cnv",
    "ENSG00000249590 rna"
  ],
  "ENSG00000249624": [
    "ENSG00000249624 cnv",
    "ENSG00000249624 rna"
  ],
  "ENSG00000249738": [
    "ENSG00000249738 methyl"
  ],
  "ENSG00000249773": [
    "ENSG00000249773 cnv",
    "ENSG00000249773 rna"
  ],
  "ENSG00000249967": [
    "ENSG00000249967 cnv",
    "ENSG00000249967 rna"
  ],
  "ENSG00000250230": [
    "ENSG00000250230 methyl"
  ],
  "ENSG00000250264": [
    "ENSG00000250264 cnv",
    "ENSG00000250264 rna"
  ],
  "ENSG00000250349": [
    "ENSG00000250349 rna"
  ],
  "ENSG00000250424": [
    "ENSG00000250424 cnv",
    "ENSG00000250424 rna"
  ],
  "ENSG00000250644": [
    "ENSG00000250644 cnv",
    "ENSG00000250644 rna"
  ],
  "ENSG00000250654": [
    "ENSG00000250654 methyl"
  ],
  "ENSG00000250803": [
    "ENSG00000250803 cnv",
    "ENSG00000250803 rna"
  ],
  "ENSG00000251012": [
    "ENSG00000251012 cnv"
  ],
  "ENSG00000251184": [
    "ENSG00000251184 cnv",
    "ENSG00000251184 rna"
  ],
  "ENSG00000251246": [
    "ENSG00000251246 cnv",
    "ENSG00000251246 rna"
  ],
  "ENSG00000251314": [
    "ENSG00000251314 methyl"
  ],
  "ENSG00000251357": [
    "ENSG00000251357 cnv",
    "ENSG00000251357 rna"
  ],
  "ENSG00000251537": [
    "ENSG00000251537 cnv",
    "ENSG00000251537 rna"
  ],
  "ENSG00000251569": [
    "ENSG00000251569 cnv",
    "ENSG00000251569 rna"
  ],
  "ENSG00000251600": [
    "ENSG00000251600 methyl"
  ],
  "ENSG00000251652": [
    "ENSG00000251652 methyl"
  ],
  "ENSG00000253614": [
    "ENSG00000253614 methyl"
  ],
  "ENSG00000253736": [
    "ENSG00000253736 methyl"
  ],
  "ENSG00000253882": [
    "ENSG00000253882 methyl"
  ],
  "ENSG00000254019": [
    "ENSG00000254019 methyl"
  ],
  "ENSG00000254536": [
    "ENSG00000254536 cnv",
    "ENSG00000254536 rna"
  ],
  "ENSG00000254553": [
    "ENSG00000254553 cnv",
    "ENSG00000254553 rna"
  ],
  "ENSG00000254673": [
    "ENSG00000254673 cnv",
    "ENSG00000254673 rna"
  ],
  "ENSG00000254692": [
    "ENSG00000254692 cnv",
    "ENSG00000254692 rna"
  ],
  "ENSG00000254706": [
    "ENSG00000254706 cnv",
    "ENSG00000254706 rna"
  ],
  "ENSG00000254718": [
    "ENSG00000254718 methyl"
  ],
  "ENSG00000254732": [
    "ENSG00000254732 cnv",
    "ENSG00000254732 rna"
  ],
  "ENSG00000254979": [
    "ENSG00000254979 cnv",
    "ENSG00000254979 rna"
  ],
  "ENSG00000255054": [
    "ENSG00000255054 cnv",
    "ENSG00000255054 rna"
  ],
  "ENSG00000255292": [
    "ENSG00000255292 cnv",
    "ENSG00000255292 rna"
  ],
  "ENSG00000255326": [
    "ENSG00000255326 methyl"
  ],
  "ENSG00000255330": [
    "ENSG00000255330 cnv",
    "ENSG00000255330 rna"
  ],
  "ENSG00000255339": [
    "ENSG00000255339 cnv",
    "ENSG00000255339 rna"
  ],
  "ENSG00000255367": [
    "ENSG00000255367 methyl"
  ],
  "ENSG00000255432": [
    "ENSG00000255432 cnv",
    "ENSG00000255432 rna"
  ],
  "ENSG00000255439": [
    "ENSG00000255439 cnv",
    "ENSG00000255439 rna"
  ],
  "ENSG00000255508": [
    "ENSG00000255508 cnv",
    "ENSG00000255508 rna"
  ],
  "ENSG00000255595": [
    "ENSG00000255595 methyl"
  ],
  "ENSG00000255639": [
    "ENSG00000255639 cnv",
    "ENSG00000255639 rna"
  ],
  "ENSG00000255641": [
    "ENSG00000255641 cnv",
    "ENSG00000255641 rna"
  ],
  "ENSG00000255647": [
    "ENSG00000255647 methyl"
  ],
  "ENSG00000255663": [
    "ENSG00000255663 cnv",
    "ENSG00000255663 rna"
  ],
  "ENSG00000255730": [
    "ENSG00000255730 cnv",
    "ENSG00000255730 rna"
  ],
  "ENSG00000255835": [
    "ENSG00000255835 cnv",
    "ENSG00000255835 rna"
  ],
  "ENSG00000255872": [
    "ENSG00000255872 cnv",
    "ENSG00000255872 rna"
  ],
  "ENSG00000255916": [
    "ENSG00000255916 methyl"
  ],
  "ENSG00000256029": [
    "ENSG00000256029 cnv",
    "ENSG00000256029 rna"
  ],
  "ENSG00000256100": [
    "ENSG00000256100 cnv",
    "ENSG00000256100 rna"
  ],
  "ENSG00000256206": [
    "ENSG00000256206 cnv",
    "ENSG00000256206 rna"
  ],
  "ENSG00000256349": [
    "ENSG00000256349 cnv",
    "ENSG00000256349 rna"
  ],
  "ENSG00000256407": [
    "ENSG00000256407 cnv",
    "ENSG00000256407 rna"
  ],
  "ENSG00000256442": [
    "ENSG00000256442 methyl"
  ],
  "ENSG00000256500": [
    "ENSG00000256500 cnv",
    "ENSG00000256500 rna"
  ],
  "ENSG00000256514": [
    "ENSG00000256514 cnv",
    "ENSG00000256514 rna"
  ],
  "ENSG00000256566": [
    "ENSG00000256566 cnv",
    "ENSG00000256566 rna"
  ],
  "ENSG00000256591": [
    "ENSG00000256591 cnv",
    "ENSG00000256591 rna"
  ],
  "ENSG00000256594": [
    "ENSG00000256594 methyl"
  ],
  "ENSG00000256646": [
    "ENSG00000256646 cnv",
    "ENSG00000256646 rna"
  ],
  "ENSG00000256802": [
    "ENSG00000256802 methyl"
  ],
  "ENSG00000256825": [
    "ENSG00000256825 cnv"
  ],
  "ENSG00000256861": [
    "ENSG00000256861 cnv",
    "ENSG00000256861 rna"
  ],
  "ENSG00000256950": [
    "ENSG00000256950 cnv",
    "ENSG00000256950 rna"
  ],
  "ENSG00000256966": [
    "ENSG00000256966 cnv",
    "ENSG00000256966 rna"
  ],
  "ENSG00000257062": [
    "ENSG00000257062 cnv"
  ],
  "ENSG00000257065": [
    "ENSG00000257065 cnv",
    "ENSG00000257065 rna"
  ],
  "ENSG00000257184": [
    "ENSG00000257184 cnv",
    "ENSG00000257184 rna"
  ],
  "ENSG00000257207": [
    "ENSG00000257207 cnv",
    "ENSG00000257207 rna"
  ],
  "ENSG00000257341": [
    "ENSG00000257341 cnv",
    "ENSG00000257341 rna"
  ],
  "ENSG00000257355": [
    "ENSG00000257355 cnv",
    "ENSG00000257355 rna"
  ],
  "ENSG00000257390": [
    "ENSG00000257390 cnv",
    "ENSG00000257390 rna"
  ],
  "ENSG00000257411": [
    "ENSG00000257411 cnv",
    "ENSG00000257411 rna"
  ],
  "ENSG00000257524": [
    "ENSG00000257524 cnv",
    "ENSG00000257524 rna"
  ],
  "ENSG00000257545": [
    "ENSG00000257545 methyl"
  ],
  "ENSG00000257767": [
    "ENSG00000257767 cnv",
    "ENSG00000257767 rna"
  ],
  "ENSG00000257921": [
    "ENSG00000257921 cnv",
    "ENSG00000257921 rna"
  ],
  "ENSG00000258052": [
    "ENSG00000258052 cnv"
  ],
  "ENSG00000258064": [
    "ENSG00000258064 cnv",
    "ENSG00000258064 rna"
  ],
  "ENSG00000258137": [
    "ENSG00000258137 methyl"
  ],
  "ENSG00000258311": [
    "ENSG00000258311 cnv",
    "ENSG00000258311 rna"
  ],
  "ENSG00000258417": [
    "ENSG00000258417 cnv",
    "ENSG00000258417 rna"
  ],
  "ENSG00000258461": [
    "ENSG00000258461 cnv",
    "ENSG00000258461 rna"
  ],
  "ENSG00000258465": [
    "ENSG00000258465 cnv",
    "ENSG00000258465 rna"
  ],
  "ENSG00000258466": [
    "ENSG00000258466 cnv",
    "ENSG00000258466 rna"
  ],
  "ENSG00000258472": [
    "ENSG00000258472 cnv",
    "ENSG00000258472 rna"
  ],
  "ENSG00000258529": [
    "ENSG00000258529 cnv",
    "ENSG00000258529 rna"
  ],
  "ENSG00000258539": [
    "ENSG00000258539 cnv",
    "ENSG00000258539 rna"
  ],
  "ENSG00000258653": [
    "ENSG00000258653 cnv",
    "ENSG00000258653 rna"
  ],
  "ENSG00000258674": [
    "ENSG00000258674 cnv",
    "ENSG00000258674 rna"
  ],
  "ENSG00000258677": [
    "ENSG00000258677 cnv",
    "ENSG00000258677 rna"
  ],
  "ENSG00000258691": [
    "ENSG00000258691 cnv",
    "ENSG00000258691 rna"
  ],
  "ENSG00000258728": [
    "ENSG00000258728 cnv",
    "ENSG00000258728 rna"
  ],
  "ENSG00000258790": [
    "ENSG00000258790 cnv",
    "ENSG00000258790 rna"
  ],
  "ENSG00000258830": [
    "ENSG00000258830 cnv",
    "ENSG00000258830 rna"
  ],
  "ENSG00000258864": [
    "ENSG00000258864 cnv",
    "ENSG00000258864 rna"
  ],
  "ENSG00000258881": [
    "ENSG00000258881 cnv",
    "ENSG00000258881 rna"
  ],
  "ENSG00000258989": [
    "ENSG00000258989 cnv",
    "ENSG00000258989 rna"
  ],
  "ENSG00000259060": [
    "ENSG00000259060 cnv"
  ],
  "ENSG00000259066": [
    "ENSG00000259066 cnv",
    "ENSG00000259066 rna"
  ],
  "ENSG00000259132": [
    "ENSG00000259132 cnv",
    "ENSG00000259132 rna"
  ],
  "ENSG00000259164": [
    "ENSG00000259164 cnv"
  ],
  "ENSG00000259171": [
    "ENSG00000259171 cnv",
    "ENSG00000259171 rna"
  ],
  "ENSG00000259200": [
    "ENSG00000259200 methyl"
  ],
  "ENSG00000259316": [
    "ENSG00000259316 cnv",
    "ENSG00000259316 rna"
  ],
  "ENSG00000259371": [
    "ENSG00000259371 cnv",
    "ENSG00000259371 rna"
  ],
  "ENSG00000259522": [
    "ENSG00000259522 cnv",
    "ENSG00000259522 rna"
  ],
  "ENSG00000259529": [
    "ENSG00000259529 cnv",
    "ENSG00000259529 rna"
  ],
  "ENSG00000259540": [
    "ENSG00000259540 methyl"
  ],
  "ENSG00000259753": [
    "ENSG00000259753 cnv",
    "ENSG00000259753 rna"
  ],
  "ENSG00000259774": [
    "ENSG00000259774 methyl"
  ],
  "ENSG00000259784": [
    "ENSG00000259784 cnv",
    "ENSG00000259784 rna"
  ],
  "ENSG00000259900": [
    "ENSG00000259900 cnv",
    "ENSG00000259900 rna"
  ],
  "ENSG00000260007": [
    "ENSG00000260007 cnv",
    "ENSG00000260007 rna"
  ],
  "ENSG00000260092": [
    "ENSG00000260092 cnv",
    "ENSG00000260092 rna"
  ],
  "ENSG00000260170": [
    "ENSG00000260170 cnv",
    "ENSG00000260170 rna"
  ],
  "ENSG00000260234": [
    "ENSG00000260234 cnv"
  ],
  "ENSG00000260272": [
    "ENSG00000260272 cnv",
    "ENSG00000260272 rna"
  ],
  "ENSG00000260342": [
    "ENSG00000260342 cnv",
    "ENSG00000260342 rna"
  ],
  "ENSG00000260371": [
    "ENSG00000260371 cnv",
    "ENSG00000260371 rna"
  ],
  "ENSG00000260537": [
    "ENSG00000260537 cnv",
    "ENSG00000260537 rna"
  ],
  "ENSG00000260643": [
    "ENSG00000260643 cnv",
    "ENSG00000260643 rna"
  ],
  "ENSG00000260729": [
    "ENSG00000260729 cnv",
    "ENSG00000260729 rna"
  ],
  "ENSG00000260735": [
    "ENSG00000260735 methyl"
  ],
  "ENSG00000260836": [
    "ENSG00000260836 cnv",
    "ENSG00000260836 rna"
  ],
  "ENSG00000260851": [
    "ENSG00000260851 cnv",
    "ENSG00000260851 rna"
  ],
  "ENSG00000260861": [
    "ENSG00000260861 cnv",
    "ENSG00000260861 rna"
  ],
  "ENSG00000260914": [
    "ENSG00000260914 cnv",
    "ENSG00000260914 rna"
  ],
  "ENSG00000260926": [
    "ENSG00000260926 methyl"
  ],
  "ENSG00000261130": [
    "ENSG00000261130 cnv",
    "ENSG00000261130 methyl",
    "ENSG00000261130 rna"
  ],
  "ENSG00000261147": [
    "ENSG00000261147 cnv",
    "ENSG00000261147 rna"
  ],
  "ENSG00000261335": [
    "ENSG00000261335 methyl"
  ],
  "ENSG00000261341": [
    "ENSG00000261341 cnv",
    "ENSG00000261341 rna"
  ],
  "ENSG00000261459": [
    "ENSG00000261459 cnv",
    "ENSG00000261459 rna"
  ],
  "ENSG00000261582": [
    "ENSG00000261582 cnv",
    "ENSG00000261582 rna"
  ],
  "ENSG00000261611": [
    "ENSG00000261611 cnv",
    "ENSG00000261611 rna"
  ],
  "ENSG00000261717": [
    "ENSG00000261717 cnv",
    "ENSG00000261717 rna"
  ],
  "ENSG00000261732": [
    "ENSG00000261732 cnv",
    "ENSG00000261732 rna"
  ],
  "ENSG00000261793": [
    "ENSG00000261793 cnv",
    "ENSG00000261793 rna"
  ],
  "ENSG00000261798": [
    "ENSG00000261798 methyl"
  ],
  "ENSG00000261832": [
    "ENSG00000261832 cnv",
    "ENSG00000261832 rna"
  ],
  "ENSG00000261840": [
    "ENSG00000261840 methyl"
  ],
  "ENSG00000261884": [
    "ENSG00000261884 cnv",
    "ENSG00000261884 rna"
  ],
  "ENSG00000261915": [
    "ENSG00000261915 cnv",
    "ENSG00000261915 rna"
  ],
  "ENSG00000262050": [
    "ENSG00000262050 methyl"
  ],
  "ENSG00000262302": [
    "ENSG00000262302 cnv"
  ],
  "ENSG00000262304": [
    "ENSG00000262304 cnv",
    "ENSG00000262304 rna"
  ],
  "ENSG00000262526": [
    "ENSG00000262526 cnv"
  ],
  "ENSG00000262560": [
    "ENSG00000262560 cnv",
    "ENSG00000262560 rna"
  ],
  "ENSG00000262633": [
    "ENSG00000262633 cnv",
    "ENSG00000262633 rna"
  ],
  "ENSG00000262660": [
    "ENSG00000262660 cnv",
    "ENSG00000262660 rna"
  ],
  "ENSG00000262730": [
    "ENSG00000262730 cnv"
  ],
  "ENSG00000263020": [
    "ENSG00000263020 cnv",
    "ENSG00000263020 rna"
  ],
  "ENSG00000263063": [
    "ENSG00000263063 methyl"
  ],
  "ENSG00000263080": [
    "ENSG00000263080 methyl"
  ],
  "ENSG00000263620": [
    "ENSG00000263620 cnv",
    "ENSG00000263620 rna"
  ],
  "ENSG00000263809": [
    "ENSG00000263809 cnv",
    "ENSG00000263809 rna"
  ],
  "ENSG00000264058": [
    "ENSG00000264058 cnv",
    "ENSG00000264058 rna"
  ],
  "ENSG00000264187": [
    "ENSG00000264187 cnv",
    "ENSG00000264187 rna"
  ],
  "ENSG00000264324": [
    "ENSG00000264324 cnv",
    "ENSG00000264324 rna"
  ],
  "ENSG00000264545": [
    "ENSG00000264545 cnv",
    "ENSG00000264545 rna"
  ],
  "ENSG00000264668": [
    "ENSG00000264668 cnv",
    "ENSG00000264668 rna"
  ],
  "ENSG00000264813": [
    "ENSG00000264813 cnv"
  ],
  "ENSG00000264845": [
    "ENSG00000264845 methyl"
  ],
  "ENSG00000265118": [
    "ENSG00000265118 cnv",
    "ENSG00000265118 rna"
  ],
  "ENSG00000265303": [
    "ENSG00000265303 cnv",
    "ENSG00000265303 rna"
  ],
  "ENSG00000265690": [
    "ENSG00000265690 cnv",
    "ENSG00000265690 rna"
  ],
  "ENSG00000265702": [
    "ENSG00000265702 methyl"
  ],
  "ENSG00000266076": [
    "ENSG00000266076 cnv",
    "ENSG00000266076 rna"
  ],
  "ENSG00000266086": [
    "ENSG00000266086 cnv",
    "ENSG00000266086 rna"
  ],
  "ENSG00000266149": [
    "ENSG00000266149 methyl"
  ],
  "ENSG00000266202": [
    "ENSG00000266202 cnv",
    "ENSG00000266202 rna"
  ],
  "ENSG00000266302": [
    "ENSG00000266302 cnv",
    "ENSG00000266302 rna"
  ],
  "ENSG00000266728": [
    "ENSG00000266728 cnv",
    "ENSG00000266728 rna"
  ],
  "ENSG00000266865": [
    "ENSG00000266865 methyl"
  ],
  "ENSG00000266953": [
    "ENSG00000266953 cnv",
    "ENSG00000266953 rna"
  ],
  "ENSG00000266997": [
    "ENSG00000266997 cnv",
    "ENSG00000266997 rna"
  ],
  "ENSG00000267001": [
    "ENSG00000267001 cnv",
    "ENSG00000267001 rna"
  ],
  "ENSG00000267022": [
    "ENSG00000267022 cnv",
    "ENSG00000267022 rna"
  ],
  "ENSG00000267058": [
    "ENSG00000267058 methyl"
  ],
  "ENSG00000267059": [
    "ENSG00000267059 cnv",
    "ENSG00000267059 rna"
  ],
  "ENSG00000267110": [
    "ENSG00000267110 cnv"
  ],
  "ENSG00000267120": [
    "ENSG00000267120 cnv",
    "ENSG00000267120 rna"
  ],
  "ENSG00000267127": [
    "ENSG00000267127 cnv",
    "ENSG00000267127 rna"
  ],
  "ENSG00000267131": [
    "ENSG00000267131 methyl"
  ],
  "ENSG00000267140": [
    "ENSG00000267140 cnv",
    "ENSG00000267140 rna"
  ],
  "ENSG00000267157": [
    "ENSG00000267157 cnv",
    "ENSG00000267157 rna"
  ],
  "ENSG00000267168": [
    "ENSG00000267168 cnv",
    "ENSG00000267168 rna"
  ],
  "ENSG00000267173": [
    "ENSG00000267173 cnv",
    "ENSG00000267173 rna"
  ],
  "ENSG00000267179": [
    "ENSG00000267179 cnv",
    "ENSG00000267179 rna"
  ],
  "ENSG00000267202": [
    "ENSG00000267202 methyl"
  ],
  "ENSG00000267228": [
    "ENSG00000267228 cnv",
    "ENSG00000267228 rna"
  ],
  "ENSG00000267260": [
    "ENSG00000267260 methyl"
  ],
  "ENSG00000267261": [
    "ENSG00000267261 cnv",
    "ENSG00000267261 rna"
  ],
  "ENSG00000267303": [
    "ENSG00000267303 cnv",
    "ENSG00000267303 rna"
  ],
  "ENSG00000267314": [
    "ENSG00000267314 cnv",
    "ENSG00000267314 rna"
  ],
  "ENSG00000267318": [
    "ENSG00000267318 cnv",
    "ENSG00000267318 rna"
  ],
  "ENSG00000267335": [
    "ENSG00000267335 cnv"
  ],
  "ENSG00000267360": [
    "ENSG00000267360 cnv",
    "ENSG00000267360 rna"
  ],
  "ENSG00000267385": [
    "ENSG00000267385 cnv",
    "ENSG00000267385 rna"
  ],
  "ENSG00000267426": [
    "ENSG00000267426 cnv",
    "ENSG00000267426 rna"
  ],
  "ENSG00000267477": [
    "ENSG00000267477 cnv",
    "ENSG00000267477 rna"
  ],
  "ENSG00000267552": [
    "ENSG00000267552 cnv",
    "ENSG00000267552 rna"
  ],
  "ENSG00000267561": [
    "ENSG00000267561 cnv",
    "ENSG00000267561 rna"
  ],
  "ENSG00000267568": [
    "ENSG00000267568 methyl"
  ],
  "ENSG00000267618": [
    "ENSG00000267618 cnv",
    "ENSG00000267618 rna"
  ],
  "ENSG00000267645": [
    "ENSG00000267645 cnv",
    "ENSG00000267645 rna"
  ],
  "ENSG00000267665": [
    "ENSG00000267665 methyl"
  ],
  "ENSG00000267699": [
    "ENSG00000267699 cnv",
    "ENSG00000267699 rna"
  ],
  "ENSG00000267706": [
    "ENSG00000267706 cnv",
    "ENSG00000267706 rna"
  ],
  "ENSG00000267740": [
    "ENSG00000267740 cnv",
    "ENSG00000267740 rna"
  ],
  "ENSG00000267748": [
    "ENSG00000267748 cnv",
    "ENSG00000267748 rna"
  ],
  "ENSG00000267881": [
    "ENSG00000267881 cnv"
  ],
  "ENSG00000267952": [
    "ENSG00000267952 cnv",
    "ENSG00000267952 rna"
  ],
  "ENSG00000268083": [
    "ENSG00000268083 cnv",
    "ENSG00000268083 rna"
  ],
  "ENSG00000268107": [
    "ENSG00000268107 cnv",
    "ENSG00000268107 rna"
  ],
  "ENSG00000268133": [
    "ENSG00000268133 cnv"
  ],
  "ENSG00000268163": [
    "ENSG00000268163 cnv",
    "ENSG00000268163 rna"
  ],
  "ENSG00000268173": [
    "ENSG00000268173 cnv",
    "ENSG00000268173 rna"
  ],
  "ENSG00000268193": [
    "ENSG00000268193 cnv",
    "ENSG00000268193 rna"
  ],
  "ENSG00000268279": [
    "ENSG00000268279 cnv",
    "ENSG00000268279 rna"
  ],
  "ENSG00000268361": [
    "ENSG00000268361 cnv",
    "ENSG00000268361 rna"
  ],
  "ENSG00000268400": [
    "ENSG00000268400 cnv",
    "ENSG00000268400 rna"
  ],
  "ENSG00000268403": [
    "ENSG00000268403 methyl"
  ],
  "ENSG00000268434": [
    "ENSG00000268434 cnv",
    "ENSG00000268434 rna"
  ],
  "ENSG00000268465": [
    "ENSG00000268465 cnv",
    "ENSG00000268465 rna"
  ],
  "ENSG00000268533": [
    "ENSG00000268533 cnv",
    "ENSG00000268533 rna"
  ],
  "ENSG00000268614": [
    "ENSG00000268614 cnv",
    "ENSG00000268614 rna"
  ],
  "ENSG00000268643": [
    "ENSG00000268643 cnv",
    "ENSG00000268643 rna"
  ],
  "ENSG00000268650": [
    "ENSG00000268650 methyl"
  ],
  "ENSG00000268655": [
    "ENSG00000268655 cnv",
    "ENSG00000268655 methyl",
    "ENSG00000268655 rna"
  ],
  "ENSG00000268686": [
    "ENSG00000268686 methyl"
  ],
  "ENSG00000268750": [
    "ENSG00000268750 cnv",
    "ENSG00000268750 rna"
  ],
  "ENSG00000268790": [
    "ENSG00000268790 cnv",
    "ENSG00000268790 rna"
  ],
  "ENSG00000268797": [
    "ENSG00000268797 cnv"
  ],
  "ENSG00000268858": [
    "ENSG00000268858 methyl"
  ],
  "ENSG00000268870": [
    "ENSG00000268870 cnv",
    "ENSG00000268870 rna"
  ],
  "ENSG00000269026": [
    "ENSG00000269026 cnv",
    "ENSG00000269026 rna"
  ],
  "ENSG00000269035": [
    "ENSG00000269035 cnv",
    "ENSG00000269035 rna"
  ],
  "ENSG00000269072": [
    "ENSG00000269072 methyl"
  ],
  "ENSG00000269095": [
    "ENSG00000269095 cnv",
    "ENSG00000269095 rna"
  ],
  "ENSG00000269179": [
    "ENSG00000269179 cnv",
    "ENSG00000269179 rna"
  ],
  "ENSG00000269210": [
    "ENSG00000269210 methyl"
  ],
  "ENSG00000269237": [
    "ENSG00000269237 cnv",
    "ENSG00000269237 rna"
  ],
  "ENSG00000269242": [
    "ENSG00000269242 cnv",
    "ENSG00000269242 rna"
  ],
  "ENSG00000269307": [
    "ENSG00000269307 cnv",
    "ENSG00000269307 rna"
  ],
  "ENSG00000269403": [
    "ENSG00000269403 cnv",
    "ENSG00000269403 rna"
  ],
  "ENSG00000269469": [
    "ENSG00000269469 cnv",
    "ENSG00000269469 rna"
  ],
  "ENSG00000269476": [
    "ENSG00000269476 cnv",
    "ENSG00000269476 rna"
  ],
  "ENSG00000269533": [
    "ENSG00000269533 cnv",
    "ENSG00000269533 rna"
  ],
  "ENSG00000269547": [
    "ENSG00000269547 cnv",
    "ENSG00000269547 rna"
  ],
  "ENSG00000269590": [
    "ENSG00000269590 cnv"
  ],
  "ENSG00000269693": [
    "ENSG00000269693 cnv",
    "ENSG00000269693 rna"
  ],
  "ENSG00000269711": [
    "ENSG00000269711 cnv",
    "ENSG00000269711 rna"
  ],
  "ENSG00000269741": [
    "ENSG00000269741 cnv"
  ],
  "ENSG00000269755": [
    "ENSG00000269755 cnv",
    "ENSG00000269755 rna"
  ],
  "ENSG00000269825": [
    "ENSG00000269825 cnv",
    "ENSG00000269825 rna"
  ],
  "ENSG00000270099": [
    "ENSG00000270099 cnv",
    "ENSG00000270099 rna"
  ],
  "ENSG00000270149": [
    "ENSG00000270149 cnv",
    "ENSG00000270149 rna"
  ],
  "ENSG00000270249": [
    "ENSG00000270249 cnv",
    "ENSG00000270249 rna"
  ],
  "ENSG00000270299": [
    "ENSG00000270299 cnv",
    "ENSG00000270299 rna"
  ],
  "ENSG00000271698": [
    "ENSG00000271698 cnv",
    "ENSG00000271698 rna"
  ],
  "ENSG00000271741": [
    "ENSG00000271741 cnv",
    "ENSG00000271741 rna"
  ],
  "ENSG00000271776": [
    "ENSG00000271776 methyl"
  ],
  "ENSG00000271793": [
    "ENSG00000271793 cnv",
    "ENSG00000271793 rna"
  ],
  "ENSG00000271810": [
    "ENSG00000271810 cnv",
    "ENSG00000271810 rna"
  ],
  "ENSG00000271860": [
    "ENSG00000271860 methyl"
  ],
  "ENSG00000271949": [
    "ENSG00000271949 cnv",
    "ENSG00000271949 rna"
  ],
  "ENSG00000272104": [
    "ENSG00000272104 cnv",
    "ENSG00000272104 rna"
  ],
  "ENSG00000272162": [
    "ENSG00000272162 cnv",
    "ENSG00000272162 rna"
  ],
  "ENSG00000272297": [
    "ENSG00000272297 cnv",
    "ENSG00000272297 rna"
  ],
  "ENSG00000272305": [
    "ENSG00000272305 cnv",
    "ENSG00000272305 rna"
  ],
  "ENSG00000272410": [
    "ENSG00000272410 cnv",
    "ENSG00000272410 rna"
  ],
  "ENSG00000272442": [
    "ENSG00000272442 cnv",
    "ENSG00000272442 rna"
  ],
  "ENSG00000272617": [
    "ENSG00000272617 cnv",
    "ENSG00000272617 rna"
  ],
  "ENSG00000272647": [
    "ENSG00000272647 cnv",
    "ENSG00000272647 rna"
  ],
  "ENSG00000272668": [
    "ENSG00000272668 methyl"
  ],
  "ENSG00000272741": [
    "ENSG00000272741 cnv",
    "ENSG00000272741 rna"
  ],
  "ENSG00000272772": [
    "ENSG00000272772 cnv",
    "ENSG00000272772 rna"
  ],
  "ENSG00000272822": [
    "ENSG00000272822 cnv",
    "ENSG00000272822 rna"
  ],
  "ENSG00000272896": [
    "ENSG00000272896 cnv",
    "ENSG00000272896 rna"
  ],
  "ENSG00000272897": [
    "ENSG00000272897 cnv",
    "ENSG00000272897 rna"
  ],
  "ENSG00000272916": [
    "ENSG00000272916 cnv",
    "ENSG00000272916 rna"
  ],
  "ENSG00000272921": [
    "ENSG00000272921 cnv",
    "ENSG00000272921 rna"
  ],
  "ENSG00000272970": [
    "ENSG00000272970 methyl"
  ],
  "ENSG00000273025": [
    "ENSG00000273025 cnv",
    "ENSG00000273025 rna"
  ],
  "ENSG00000273047": [
    "ENSG00000273047 cnv",
    "ENSG00000273047 rna"
  ],
  "ENSG00000273049": [
    "ENSG00000273049 cnv",
    "ENSG00000273049 rna"
  ],
  "ENSG00000273088": [
    "ENSG00000273088 cnv",
    "ENSG00000273088 rna"
  ],
  "ENSG00000273154": [
    "ENSG00000273154 cnv",
    "ENSG00000273154 rna"
  ],
  "ENSG00000273155": [
    "ENSG00000273155 cnv",
    "ENSG00000273155 rna"
  ],
  "ENSG00000273167": [
    "ENSG00000273167 cnv",
    "ENSG00000273167 rna"
  ],
  "ENSG00000273171": [
    "ENSG00000273171 cnv",
    "ENSG00000273171 rna"
  ],
  "ENSG00000273217": [
    "ENSG00000273217 cnv"
  ],
  "ENSG00000273259": [
    "ENSG00000273259 cnv",
    "ENSG00000273259 rna"
  ],
  "ENSG00000273269": [
    "ENSG00000273269 cnv",
    "ENSG00000273269 rna"
  ],
  "ENSG00000273291": [
    "ENSG00000273291 cnv",
    "ENSG00000273291 rna"
  ],
  "ENSG00000273398": [
    "ENSG00000273398 cnv",
    "ENSG00000273398 rna"
  ],
  "ENSG00000273523": [
    "ENSG00000273523 methyl"
  ],
  "ENSG00000273734": [
    "ENSG00000273734 cnv",
    "ENSG00000273734 rna"
  ],
  "ENSG00000273756": [
    "ENSG00000273756 cnv",
    "ENSG00000273756 rna"
  ],
  "ENSG00000274253": [
    "ENSG00000274253 methyl"
  ],
  "ENSG00000274322": [
    "ENSG00000274322 cnv",
    "ENSG00000274322 rna"
  ],
  "ENSG00000274559": [
    "ENSG00000274559 cnv",
    "ENSG00000274559 rna"
  ],
  "ENSG00000274944": [
    "ENSG00000274944 cnv",
    "ENSG00000274944 rna"
  ],
  "ENSG00000275163": [
    "ENSG00000275163 cnv",
    "ENSG00000275163 rna"
  ],
  "ENSG00000275464": [
    "ENSG00000275464 cnv",
    "ENSG00000275464 rna"
  ],
  "ENSG00000275674": [
    "ENSG00000275674 cnv",
    "ENSG00000275674 rna"
  ],
  "ENSG00000275740": [
    "ENSG00000275740 cnv",
    "ENSG00000275740 rna"
  ],
  "ENSG00000275765": [
    "ENSG00000275765 methyl"
  ],
  "ENSG00000275778": [
    "ENSG00000275778 cnv",
    "ENSG00000275778 rna"
  ],
  "ENSG00000276087": [
    "ENSG00000276087 cnv",
    "ENSG00000276087 rna"
  ],
  "ENSG00000276302": [
    "ENSG00000276302 cnv",
    "ENSG00000276302 rna"
  ],
  "ENSG00000276418": [
    "ENSG00000276418 cnv",
    "ENSG00000276418 rna"
  ],
  "ENSG00000276490": [
    "ENSG00000276490 cnv",
    "ENSG00000276490 rna"
  ],
  "ENSG00000276612": [
    "ENSG00000276612 cnv",
    "ENSG00000276612 rna"
  ],
  "ENSG00000277117": [
    "ENSG00000277117 cnv",
    "ENSG00000277117 rna"
  ],
  "ENSG00000277611": [
    "ENSG00000277611 cnv",
    "ENSG00000277611 rna"
  ],
  "ENSG00000277639": [
    "ENSG00000277639 cnv",
    "ENSG00000277639 rna"
  ],
  "ENSG00000277971": [
    "ENSG00000277971 cnv",
    "ENSG00000277971 rna"
  ],
  "ENSG00000278390": [
    "ENSG00000278390 methyl"
  ],
  "ENSG00000278899": [
    "ENSG00000278899 methyl"
  ],
  "ENSG00000279073": [
    "ENSG00000279073 cnv",
    "ENSG00000279073 rna"
  ],
  "ENSG00000279493": [
    "ENSG00000279493 cnv"
  ],
  "ENSG00000279686": [
    "ENSG00000279686 cnv",
    "ENSG00000279686 rna"
  ],
  "ENSG00000279765": [
    "ENSG00000279765 cnv",
    "ENSG00000279765 rna"
  ],
  "ENSG00000279956": [
    "ENSG00000279956 cnv",
    "ENSG00000279956 rna"
  ],
  "ENSG00000279983": [
    "ENSG00000279983 cnv",
    "ENSG00000279983 rna"
  ],
  "ENSG00000280148": [
    "ENSG00000280148 cnv",
    "ENSG00000280148 rna"
  ],
  "ENSG00000280433": [
    "ENSG00000280433 cnv",
    "ENSG00000280433 rna"
  ],
  "ENSG00000280537": [
    "ENSG00000280537 cnv",
    "ENSG00000280537 rna"
  ],
  "ENSG00000280571": [
    "ENSG00000280571 cnv",
    "ENSG00000280571 rna"
  ],
  "ENSG00000280778": [
    "ENSG00000280778 cnv",
    "ENSG00000280778 rna"
  ],
  "ENSG00000280893": [
    "ENSG00000280893 cnv",
    "ENSG00000280893 rna"
  ],
  "ENSG00000281039": [
    "ENSG00000281039 cnv",
    "ENSG00000281039 rna"
  ],
  "ENSG00000281348": [
    "ENSG00000281348 cnv",
    "ENSG00000281348 rna"
  ],
  "ENSG00000281593": [
    "ENSG00000281593 cnv",
    "ENSG00000281593 rna"
  ],
  "ENSG00000281613": [
    "ENSG00000281613 cnv",
    "ENSG00000281613 rna"
  ],
  "ENSG00000281883": [
    "ENSG00000281883 cnv",
    "ENSG00000281883 rna"
  ],
  "ENSG00000281938": [
    "ENSG00000281938 cnv",
    "ENSG00000281938 rna"
  ],
  "ENSG00000282034": [
    "ENSG00000282034 cnv",
    "ENSG00000282034 rna"
  ],
  "ENSG00000282218": [
    "ENSG00000282218 cnv",
    "ENSG00000282218 rna"
  ],
  "ENSG00000282246": [
    "ENSG00000282246 cnv",
    "ENSG00000282246 rna"
  ],
  "ENSG00000282278": [
    "ENSG00000282278 cnv",
    "ENSG00000282278 rna"
  ],
  "ENSG00000282375": [
    "ENSG00000282375 methyl"
  ],
  "ENSG00000282804": [
    "ENSG00000282804 cnv",
    "ENSG00000282804 rna"
  ],
  "ENSG00000282904": [
    "ENSG00000282904 methyl"
  ],
  "ENSG00000282936": [
    "ENSG00000282936 cnv",
    "ENSG00000282936 rna"
  ],
  "ENSG00000282988": [
    "ENSG00000282988 cnv",
    "ENSG00000282988 rna"
  ],
  "ENSG00000283128": [
    "ENSG00000283128 cnv",
    "ENSG00000283128 rna"
  ],
  "ENSG00000283149": [
    "ENSG00000283149 cnv",
    "ENSG00000283149 rna"
  ],
  "ENSG00000283183": [
    "ENSG00000283183 methyl"
  ],
  "ENSG00000283189": [
    "ENSG00000283189 cnv",
    "ENSG00000283189 rna"
  ],
  "ENSG00000283201": [
    "ENSG00000283201 cnv",
    "ENSG00000283201 rna"
  ],
  "ENSG00000283205": [
    "ENSG00000283205 cnv"
  ],
  "ENSG00000283208": [
    "ENSG00000283208 cnv",
    "ENSG00000283208 rna"
  ],
  "ENSG00000283228": [
    "ENSG00000283228 cnv",
    "ENSG00000283228 rna"
  ],
  "ENSG00000283321": [
    "ENSG00000283321 cnv",
    "ENSG00000283321 rna"
  ],
  "ENSG00000283403": [
    "ENSG00000283403 methyl"
  ],
  "ENSG00000283515": [
    "ENSG00000283515 cnv",
    "ENSG00000283515 rna"
  ],
  "ENSG00000283536": [
    "ENSG00000283536 cnv",
    "ENSG00000283536 rna"
  ],
  "ENSG00000283563": [
    "ENSG00000283563 cnv",
    "ENSG00000283563 rna"
  ],
  "ENSG00000283580": [
    "ENSG00000283580 cnv",
    "ENSG00000283580 rna"
  ],
  "ENSG00000283599": [
    "ENSG00000283599 rna"
  ],
  "ENSG00000283663": [
    "ENSG00000283663 cnv",
    "ENSG00000283663 rna"
  ],
  "ENSG00000283674": [
    "ENSG00000283674 methyl"
  ],
  "ENSG00000283761": [
    "ENSG00000283761 cnv",
    "ENSG00000283761 rna"
  ],
  "ENSG00000283765": [
    "ENSG00000283765 cnv",
    "ENSG00000283765 rna"
  ],
  "ENSG00000283782": [
    "ENSG00000283782 cnv",
    "ENSG00000283782 rna"
  ],
  "ENSG00000283809": [
    "ENSG00000283809 cnv",
    "ENSG00000283809 rna"
  ],
  "ENSG00000283839": [
    "ENSG00000283839 methyl"
  ],
  "ENSG00000283877": [
    "ENSG00000283877 cnv"
  ],
  "ENSG00000283886": [
    "ENSG00000283886 cnv",
    "ENSG00000283886 rna"
  ],
  "ENSG00000283952": [
    "ENSG00000283952 cnv",
    "ENSG00000283952 rna"
  ],
  "ENSG00000283959": [
    "ENSG00000283959 methyl"
  ],
  "ENSG00000283977": [
    "ENSG00000283977 cnv",
    "ENSG00000283977 rna"
  ],
  "ENSG00000284057": [
    "ENSG00000284057 cnv",
    "ENSG00000284057 rna"
  ],
  "ENSG00000284188": [
    "ENSG00000284188 cnv",
    "ENSG00000284188 rna"
  ],
  "ENSG00000284292": [
    "ENSG00000284292 cnv",
    "ENSG00000284292 rna"
  ],
  "ENSG00000284299": [
    "ENSG00000284299 cnv",
    "ENSG00000284299 rna"
  ],
  "ENSG00000284337": [
    "ENSG00000284337 cnv",
    "ENSG00000284337 rna"
  ],
  "ENSG00000284341": [
    "ENSG00000284341 cnv",
    "ENSG00000284341 rna"
  ],
  "ENSG00000284393": [
    "ENSG00000284393 cnv"
  ],
  "ENSG00000284431": [
    "ENSG00000284431 cnv",
    "ENSG00000284431 rna"
  ],
  "ENSG00000284461": [
    "ENSG00000284461 cnv",
    "ENSG00000284461 rna"
  ],
  "ENSG00000284512": [
    "ENSG00000284512 cnv",
    "ENSG00000284512 rna"
  ],
  "ENSG00000284526": [
    "ENSG00000284526 cnv",
    "ENSG00000284526 rna"
  ],
  "ENSG00000284554": [
    "ENSG00000284554 cnv",
    "ENSG00000284554 rna"
  ],
  "ENSG00000284601": [
    "ENSG00000284601 methyl"
  ],
  "ENSG00000284626": [
    "ENSG00000284626 cnv",
    "ENSG00000284626 rna"
  ],
  "ENSG00000284684": [
    "ENSG00000284684 cnv"
  ],
  "ENSG00000284686": [
    "ENSG00000284686 cnv",
    "ENSG00000284686 rna"
  ],
  "ENSG00000284691": [
    "ENSG00000284691 cnv",
    "ENSG00000284691 rna"
  ],
  "ENSG00000284695": [
    "ENSG00000284695 cnv",
    "ENSG00000284695 rna"
  ],
  "ENSG00000284732": [
    "ENSG00000284732 cnv"
  ],
  "ENSG00000284738": [
    "ENSG00000284738 methyl"
  ],
  "ENSG00000284762": [
    "ENSG00000284762 cnv",
    "ENSG00000284762 methyl",
    "ENSG00000284762 rna"
  ],
  "ENSG00000284772": [
    "ENSG00000284772 cnv",
    "ENSG00000284772 rna"
  ],
  "ENSG00000284773": [
    "ENSG00000284773 cnv",
    "ENSG00000284773 rna"
  ],
  "ENSG00000284776": [
    "ENSG00000284776 cnv",
    "ENSG00000284776 rna"
  ],
  "ENSG00000284779": [
    "ENSG00000284779 cnv",
    "ENSG00000284779 rna"
  ],
  "ENSG00000284797": [
    "ENSG00000284797 cnv",
    "ENSG00000284797 rna"
  ],
  "ENSG00000284800": [
    "ENSG00000284800 rna"
  ],
  "ENSG00000284820": [
    "ENSG00000284820 cnv",
    "ENSG00000284820 rna"
  ],
  "ENSG00000284830": [
    "ENSG00000284830 methyl"
  ],
  "ENSG00000284874": [
    "ENSG00000284874 cnv",
    "ENSG00000284874 rna"
  ],
  "ENSG00000284895": [
    "ENSG00000284895 cnv"
  ],
  "ENSG00000284906": [
    "ENSG00000284906 cnv",
    "ENSG00000284906 rna"
  ],
  "ENSG00000284931": [
    "ENSG00000284931 cnv",
    "ENSG00000284931 rna"
  ],
  "ENSG00000284934": [
    "ENSG00000284934 cnv",
    "ENSG00000284934 rna"
  ],
  "ENSG00000284946": [
    "ENSG00000284946 cnv",
    "ENSG00000284946 rna"
  ],
  "ENSG00000284952": [
    "ENSG00000284952 cnv",
    "ENSG00000284952 rna"
  ],
  "ENSG00000284954": [
    "ENSG00000284954 methyl"
  ],
  "ENSG00000284956": [
    "ENSG00000284956 cnv",
    "ENSG00000284956 rna"
  ],
  "ENSG00000284969": [
    "ENSG00000284969 cnv",
    "ENSG00000284969 rna"
  ],
  "ENSG00000284976": [
    "ENSG00000284976 cnv",
    "ENSG00000284976 rna"
  ],
  "ENSG00000284987": [
    "ENSG00000284987 rna"
  ],
  "ENSG00000284989": [
    "ENSG00000284989 cnv",
    "ENSG00000284989 rna"
  ],
  "ENSG00000285000": [
    "ENSG00000285000 cnv",
    "ENSG00000285000 rna"
  ],
  "ENSG00000285025": [
    "ENSG00000285025 cnv",
    "ENSG00000285025 rna"
  ],
  "ENSG00000285043": [
    "ENSG00000285043 cnv",
    "ENSG00000285043 methyl",
    "ENSG00000285043 rna"
  ],
  "ENSG00000285064": [
    "ENSG00000285064 cnv"
  ],
  "ENSG00000285082": [
    "ENSG00000285082 cnv",
    "ENSG00000285082 rna"
  ],
  "ENSG00000285085": [
    "ENSG00000285085 cnv",
    "ENSG00000285085 rna"
  ],
  "ENSG00000285130": [
    "ENSG00000285130 cnv",
    "ENSG00000285130 rna"
  ],
  "ENSG00000285133": [
    "ENSG00000285133 cnv",
    "ENSG00000285133 rna"
  ],
  "ENSG00000285162": [
    "ENSG00000285162 cnv",
    "ENSG00000285162 methyl",
    "ENSG00000285162 rna"
  ],
  "ENSG00000285171": [
    "ENSG00000285171 rna"
  ],
  "ENSG00000285188": [
    "ENSG00000285188 cnv",
    "ENSG00000285188 rna"
  ],
  "ENSG00000285218": [
    "ENSG00000285218 cnv",
    "ENSG00000285218 rna"
  ],
  "ENSG00000285238": [
    "ENSG00000285238 cnv",
    "ENSG00000285238 rna"
  ],
  "ENSG00000285245": [
    "ENSG00000285245 cnv",
    "ENSG00000285245 rna"
  ],
  "ENSG00000285253": [
    "ENSG00000285253 cnv",
    "ENSG00000285253 rna"
  ],
  "ENSG00000285269": [
    "ENSG00000285269 cnv",
    "ENSG00000285269 methyl",
    "ENSG00000285269 rna"
  ],
  "ENSG00000285283": [
    "ENSG00000285283 cnv",
    "ENSG00000285283 rna"
  ],
  "ENSG00000285304": [
    "ENSG00000285304 cnv",
    "ENSG00000285304 rna"
  ],
  "ENSG00000285329": [
    "ENSG00000285329 cnv",
    "ENSG00000285329 rna"
  ],
  "ENSG00000285330": [
    "ENSG00000285330 cnv",
    "ENSG00000285330 rna"
  ],
  "ENSG00000285331": [
    "ENSG00000285331 methyl"
  ],
  "ENSG00000285382": [
    "ENSG00000285382 cnv",
    "ENSG00000285382 rna"
  ],
  "ENSG00000285404": [
    "ENSG00000285404 cnv"
  ],
  "ENSG00000285444": [
    "ENSG00000285444 cnv",
    "ENSG00000285444 rna"
  ],
  "ENSG00000285446": [
    "ENSG00000285446 cnv",
    "ENSG00000285446 rna"
  ],
  "ENSG00000285458": [
    "ENSG00000285458 cnv",
    "ENSG00000285458 rna"
  ],
  "ENSG00000285467": [
    "ENSG00000285467 methyl"
  ],
  "ENSG00000285471": [
    "ENSG00000285471 cnv",
    "ENSG00000285471 rna"
  ],
  "ENSG00000285476": [
    "ENSG00000285476 cnv",
    "ENSG00000285476 rna"
  ],
  "ENSG00000285505": [
    "ENSG00000285505 cnv",
    "ENSG00000285505 rna"
  ],
  "ENSG00000285526": [
    "ENSG00000285526 cnv",
    "ENSG00000285526 rna"
  ],
  "ENSG00000285528": [
    "ENSG00000285528 cnv",
    "ENSG00000285528 rna"
  ],
  "ENSG00000285542": [
    "ENSG00000285542 cnv",
    "ENSG00000285542 rna"
  ],
  "ENSG00000285547": [
    "ENSG00000285547 rna"
  ],
  "ENSG00000285558": [
    "ENSG00000285558 cnv",
    "ENSG00000285558 rna"
  ],
  "ENSG00000285566": [
    "ENSG00000285566 cnv",
    "ENSG00000285566 rna"
  ],
  "ENSG00000285585": [
    "ENSG00000285585 cnv",
    "ENSG00000285585 rna"
  ],
  "ENSG00000285589": [
    "ENSG00000285589 cnv",
    "ENSG00000285589 rna"
  ],
  "ENSG00000285602": [
    "ENSG00000285602 rna"
  ],
  "ENSG00000285625": [
    "ENSG00000285625 cnv",
    "ENSG00000285625 rna"
  ],
  "ENSG00000285629": [
    "ENSG00000285629 cnv",
    "ENSG00000285629 rna"
  ],
  "ENSG00000285635": [
    "ENSG00000285635 cnv"
  ],
  "ENSG00000285641": [
    "ENSG00000285641 cnv",
    "ENSG00000285641 rna"
  ],
  "ENSG00000285645": [
    "ENSG00000285645 cnv"
  ],
  "ENSG00000285655": [
    "ENSG00000285655 cnv",
    "ENSG00000285655 rna"
  ],
  "ENSG00000285708": [
    "ENSG00000285708 cnv",
    "ENSG00000285708 rna"
  ],
  "ENSG00000285713": [
    "ENSG00000285713 cnv",
    "ENSG00000285713 rna"
  ],
  "ENSG00000285733": [
    "ENSG00000285733 cnv",
    "ENSG00000285733 rna"
  ],
  "ENSG00000285749": [
    "ENSG00000285749 cnv",
    "ENSG00000285749 rna"
  ],
  "ENSG00000285762": [
    "ENSG00000285762 cnv",
    "ENSG00000285762 rna"
  ],
  "ENSG00000285772": [
    "ENSG00000285772 cnv",
    "ENSG00000285772 rna"
  ],
  "ENSG00000285777": [
    "ENSG00000285777 cnv",
    "ENSG00000285777 rna"
  ],
  "ENSG00000285779": [
    "ENSG00000285779 cnv",
    "ENSG00000285779 rna"
  ],
  "ENSG00000285791": [
    "ENSG00000285791 cnv",
    "ENSG00000285791 rna"
  ],
  "ENSG00000285816": [
    "ENSG00000285816 cnv",
    "ENSG00000285816 rna"
  ],
  "ENSG00000285827": [
    "ENSG00000285827 cnv",
    "ENSG00000285827 rna"
  ],
  "ENSG00000285837": [
    "ENSG00000285837 cnv",
    "ENSG00000285837 rna"
  ],
  "ENSG00000285839": [
    "ENSG00000285839 cnv",
    "ENSG00000285839 rna"
  ],
  "ENSG00000285854": [
    "ENSG00000285854 cnv",
    "ENSG00000285854 rna"
  ],
  "ENSG00000285868": [
    "ENSG00000285868 cnv",
    "ENSG00000285868 rna"
  ],
  "ENSG00000285873": [
    "ENSG00000285873 methyl"
  ],
  "ENSG00000285880": [
    "ENSG00000285880 cnv"
  ],
  "ENSG00000285897": [
    "ENSG00000285897 cnv",
    "ENSG00000285897 rna"
  ],
  "ENSG00000285901": [
    "ENSG00000285901 cnv",
    "ENSG00000285901 rna"
  ],
  "ENSG00000285920": [
    "ENSG00000285920 cnv",
    "ENSG00000285920 rna"
  ],
  "ENSG00000285932": [
    "ENSG00000285932 cnv",
    "ENSG00000285932 rna"
  ],
  "ENSG00000285938": [
    "ENSG00000285938 cnv",
    "ENSG00000285938 rna"
  ],
  "ENSG00000285942": [
    "ENSG00000285942 cnv",
    "ENSG00000285942 rna"
  ],
  "ENSG00000285943": [
    "ENSG00000285943 cnv",
    "ENSG00000285943 rna"
  ],
  "ENSG00000285947": [
    "ENSG00000285947 cnv"
  ],
  "ENSG00000285953": [
    "ENSG00000285953 cnv",
    "ENSG00000285953 rna"
  ],
  "ENSG00000285976": [
    "ENSG00000285976 cnv",
    "ENSG00000285976 rna"
  ],
  "ENSG00000285978": [
    "ENSG00000285978 cnv",
    "ENSG00000285978 rna"
  ],
  "ENSG00000285982": [
    "ENSG00000285982 cnv",
    "ENSG00000285982 rna"
  ],
  "ENSG00000285991": [
    "ENSG00000285991 cnv",
    "ENSG00000285991 rna"
  ],
  "ENSG00000286001": [
    "ENSG00000286001 cnv",
    "ENSG00000286001 rna"
  ],
  "ENSG00000286007": [
    "ENSG00000286007 cnv"
  ],
  "ENSG00000286015": [
    "ENSG00000286015 cnv",
    "ENSG00000286015 rna"
  ],
  "ENSG00000286022": [
    "ENSG00000286022 cnv",
    "ENSG00000286022 rna"
  ],
  "ENSG00000286070": [
    "ENSG00000286070 cnv",
    "ENSG00000286070 rna"
  ],
  "ENSG00000286075": [
    "ENSG00000286075 cnv"
  ],
  "ENSG00000286088": [
    "ENSG00000286088 cnv",
    "ENSG00000286088 rna"
  ],
  "ENSG00000286098": [
    "ENSG00000286098 cnv",
    "ENSG00000286098 methyl",
    "ENSG00000286098 rna"
  ],
  "ENSG00000286112": [
    "ENSG00000286112 cnv",
    "ENSG00000286112 methyl",
    "ENSG00000286112 rna"
  ],
  "ENSG00000286131": [
    "ENSG00000286131 cnv"
  ],
  "ENSG00000286132": [
    "ENSG00000286132 cnv",
    "ENSG00000286132 rna"
  ],
  "ENSG00000286135": [
    "ENSG00000286135 cnv"
  ],
  "ENSG00000286143": [
    "ENSG00000286143 cnv",
    "ENSG00000286143 rna"
  ],
  "ENSG00000286165": [
    "ENSG00000286165 cnv",
    "ENSG00000286165 rna"
  ],
  "ENSG00000286177": [
    "ENSG00000286177 methyl"
  ],
  "ENSG00000286185": [
    "ENSG00000286185 cnv",
    "ENSG00000286185 rna"
  ],
  "ENSG00000286190": [
    "ENSG00000286190 cnv",
    "ENSG00000286190 methyl",
    "ENSG00000286190 rna"
  ],
  "ENSG00000286192": [
    "ENSG00000286192 cnv",
    "ENSG00000286192 rna"
  ],
  "ENSG00000286221": [
    "ENSG00000286221 cnv",
    "ENSG00000286221 rna"
  ],
  "ENSG00000286224": [
    "ENSG00000286224 cnv",
    "ENSG00000286224 rna"
  ],
  "ENSG00000286231": [
    "ENSG00000286231 cnv",
    "ENSG00000286231 rna"
  ],
  "ENSG00000286235": [
    "ENSG00000286235 cnv",
    "ENSG00000286235 rna"
  ],
  "ENSG00000286239": [
    "ENSG00000286239 cnv",
    "ENSG00000286239 rna"
  ],
  "ENSG00000286264": [
    "ENSG00000286264 cnv",
    "ENSG00000286264 methyl",
    "ENSG00000286264 rna"
  ],
  "ENSG00000286268": [
    "ENSG00000286268 rna"
  ],
  "ENSG00000286352": [
    "ENSG00000286352 methyl"
  ],
  "ENSG00000286389": [
    "ENSG00000286389 methyl"
  ],
  "ENSG00000286391": [
    "ENSG00000286391 methyl"
  ],
  "ENSG00000286575": [
    "ENSG00000286575 methyl"
  ],
  "ENSG00000286724": [
    "ENSG00000286724 methyl"
  ],
  "ENSG00000286760": [
    "ENSG00000286760 methyl"
  ],
  "ENSG00000286794": [
    "ENSG00000286794 methyl"
  ],
  "ENSG00000286847": [
    "ENSG00000286847 methyl"
  ],
  "ENSG00000286905": [
    "ENSG00000286905 cnv",
    "ENSG00000286905 rna"
  ],
  "ENSG00000286923": [
    "ENSG00000286923 methyl"
  ],
  "ENSG00000287260": [
    "ENSG00000287260 methyl"
  ],
  "ENSG00000287275": [
    "ENSG00000287275 methyl"
  ],
  "ENSG00000287281": [
    "ENSG00000287281 methyl"
  ],
  "ENSG00000287337": [
    "ENSG00000287337 methyl"
  ],
  "ENSG00000287376": [
    "ENSG00000287376 methyl"
  ],
  "ENSG00000287542": [
    "ENSG00000287542 cnv",
    "ENSG00000287542 methyl",
    "ENSG00000287542 rna"
  ],
  "ENSG00000287672": [
    "ENSG00000287672 methyl"
  ],
  "ENSG00000287694": [
    "ENSG00000287694 cnv",
    "ENSG00000287694 rna"
  ],
  "ENSG00000287725": [
    "ENSG00000287725 cnv",
    "ENSG00000287725 rna"
  ],
  "ENSG00000287856": [
    "ENSG00000287856 cnv",
    "ENSG00000287856 rna"
  ],
  "ENSG00000287908": [
    "ENSG00000287908 cnv",
    "ENSG00000287908 rna"
  ],
  "ENSG00000288000": [
    "ENSG00000288000 cnv",
    "ENSG00000288000 rna"
  ],
  "ENSG00000288009": [
    "ENSG00000288009 methyl"
  ],
  "ENSG00000288053": [
    "ENSG00000288053 rna"
  ],
  "ENSG00000288208": [
    "ENSG00000288208 cnv",
    "ENSG00000288208 rna"
  ],
  "ENSG00000288258": [
    "ENSG00000288258 rna"
  ],
  "ENSG00000288520": [
    "ENSG00000288520 cnv",
    "ENSG00000288520 rna"
  ],
  "ENSG00000288529": [
    "ENSG00000288529 cnv",
    "ENSG00000288529 rna"
  ],
  "ENSG00000288534": [
    "ENSG00000288534 cnv",
    "ENSG00000288534 rna"
  ],
  "ENSG00000288550": [
    "ENSG00000288550 cnv",
    "ENSG00000288550 rna"
  ],
  "ENSG00000288564": [
    "ENSG00000288564 cnv",
    "ENSG00000288564 rna"
  ],
  "ENSG00000288570": [
    "ENSG00000288570 cnv",
    "ENSG00000288570 rna"
  ],
  "ENSG00000288591": [
    "ENSG00000288591 cnv",
    "ENSG00000288591 rna"
  ],
  "ENSG00000288608": [
    "ENSG00000288608 cnv"
  ],
  "ENSG00000288614": [
    "ENSG00000288614 cnv",
    "ENSG00000288614 rna"
  ],
  "ENSG00000288623": [
    "ENSG00000288623 cnv",
    "ENSG00000288623 rna"
  ],
  "ENSG00000288625": [
    "ENSG00000288625 cnv",
    "ENSG00000288625 rna"
  ],
  "ENSG00000288626": [
    "ENSG00000288626 cnv",
    "ENSG00000288626 rna"
  ],
  "ENSG00000288629": [
    "ENSG00000288629 cnv"
  ],
  "ENSG00000288634": [
    "ENSG00000288634 cnv",
    "ENSG00000288634 rna"
  ],
  "ENSG00000288635": [
    "ENSG00000288635 cnv",
    "ENSG00000288635 rna"
  ],
  "ENSG00000288636": [
    "ENSG00000288636 cnv",
    "ENSG00000288636 rna"
  ],
  "ENSG00000288637": [
    "ENSG00000288637 cnv",
    "ENSG00000288637 rna"
  ],
  "ENSG00000288640": [
    "ENSG00000288640 cnv",
    "ENSG00000288640 rna"
  ],
  "ENSG00000288643": [
    "ENSG00000288643 cnv"
  ],
  "ENSG00000288644": [
    "ENSG00000288644 cnv",
    "ENSG00000288644 rna"
  ],
  "ENSG00000288645": [
    "ENSG00000288645 cnv",
    "ENSG00000288645 rna"
  ],
  "ENSG00000288646": [
    "ENSG00000288646 cnv"
  ],
  "ENSG00000288654": [
    "ENSG00000288654 cnv"
  ],
  "ENSG00000288656": [
    "ENSG00000288656 cnv",
    "ENSG00000288656 rna"
  ],
  "ENSG00000288658": [
    "ENSG00000288658 cnv",
    "ENSG00000288658 rna"
  ],
  "ENSG00000288661": [
    "ENSG00000288661 rna"
  ],
  "ENSG00000288669": [
    "ENSG00000288669 cnv",
    "ENSG00000288669 rna"
  ],
  "ENSG00000288671": [
    "ENSG00000288671 cnv"
  ],
  "ENSG00000288674": [
    "ENSG00000288674 cnv",
    "ENSG00000288674 rna"
  ],
  "ENSG00000288678": [
    "ENSG00000288678 cnv"
  ],
  "ENSG00000288681": [
    "ENSG00000288681 cnv",
    "ENSG00000288681 rna"
  ],
  "ENSG00000288683": [
    "ENSG00000288683 cnv",
    "ENSG00000288683 rna"
  ],
  "ENSG00000288684": [
    "ENSG00000288684 cnv",
    "ENSG00000288684 rna"
  ],
  "ENSG00000288695": [
    "ENSG00000288695 cnv",
    "ENSG00000288695 rna"
  ],
  "ENSG00000288698": [
    "ENSG00000288698 cnv",
    "ENSG00000288698 rna"
  ],
  "ENSG00000288699": [
    "ENSG00000288699 cnv",
    "ENSG00000288699 rna"
  ],
  "ENSG00000288708": [
    "ENSG00000288708 cnv"
  ],
  "ENSG00000288710": [
    "ENSG00000288710 cnv",
    "ENSG00000288710 rna"
  ],
  "ENSG00000288711": [
    "ENSG00000288711 cnv",
    "ENSG00000288711 rna"
  ],
  "ENSG00000288712": [
    "ENSG00000288712 cnv"
  ],
  "ENSG00000288715": [
    "ENSG00000288715 cnv"
  ],
  "ENSG00000288716": [
    "ENSG00000288716 cnv"
  ],
  "ENSG00000288717": [
    "ENSG00000288717 methyl"
  ],
  "ENSG00000288721": [
    "ENSG00000288721 cnv",
    "ENSG00000288721 rna"
  ],
  "ENSG00000288725": [
    "ENSG00000288725 cnv",
    "ENSG00000288725 rna"
  ],
  "ENSG00000288743": [
    "ENSG00000288743 methyl"
  ],
  "ENSG00000288795": [
    "ENSG00000288795 methyl"
  ],
  "ENSG00000288796": [
    "ENSG00000288796 cnv",
    "ENSG00000288796 rna"
  ],
  "ENSG00000288841": [
    "ENSG00000288841 cnv",
    "ENSG00000288841 rna"
  ],
  "ENSG00000288894": [
    "ENSG00000288894 cnv",
    "ENSG00000288894 rna"
  ],
  "ENSG00000288907": [
    "ENSG00000288907 methyl"
  ],
  "ENSG00000288914": [
    "ENSG00000288914 cnv",
    "ENSG00000288914 rna"
  ],
  "ENSG00000288989": [
    "ENSG00000288989 methyl"
  ],
  "ENSG00000289011": [
    "ENSG00000289011 methyl"
  ],
  "ENSG00000289025": [
    "ENSG00000289025 cnv"
  ],
  "ENSG00000289027": [
    "ENSG00000289027 cnv",
    "ENSG00000289027 rna"
  ],
  "ENSG00000289051": [
    "ENSG00000289051 cnv"
  ],
  "ENSG00000289088": [
    "ENSG00000289088 methyl"
  ],
  "ENSG00000289133": [
    "ENSG00000289133 methyl"
  ],
  "ENSG00000289161": [
    "ENSG00000289161 methyl"
  ],
  "ENSG00000289258": [
    "ENSG00000289258 cnv",
    "ENSG00000289258 rna"
  ],
  "ENSG00000289281": [
    "ENSG00000289281 cnv",
    "ENSG00000289281 rna"
  ],
  "ENSG00000289282": [
    "ENSG00000289282 cnv"
  ],
  "ENSG00000289325": [
    "ENSG00000289325 cnv"
  ],
  "ENSG00000289346": [
    "ENSG00000289346 cnv",
    "ENSG00000289346 rna"
  ],
  "ENSG00000289360": [
    "ENSG00000289360 cnv"
  ],
  "ENSG00000289469": [
    "ENSG00000289469 methyl"
  ],
  "ENSG00000289490": [
    "ENSG00000289490 cnv"
  ],
  "ENSG00000289491": [
    "ENSG00000289491 cnv"
  ],
  "ENSG00000289503": [
    "ENSG00000289503 cnv",
    "ENSG00000289503 rna"
  ],
  "ENSG00000289517": [
    "ENSG00000289517 cnv",
    "ENSG00000289517 rna"
  ],
  "ENSG00000289565": [
    "ENSG00000289565 cnv",
    "ENSG00000289565 rna"
  ],
  "ENTHD1": [
    "ENTHD1 cnv",
    "ENTHD1 rna"
  ],
  "ENTPD1": [
    "ENTPD1 FLNLTSEK-N2H5F0S0G0 glyco",
    "ENTPD1 FLNLTSEK-N3H6F0S0G0 glyco",
    "ENTPD1 FLNLTSEK-N3H6F0S1G0 glyco",
    "ENTPD1 VVNVSDLYK-N5H6F1S2G0 glyco",
    "ENTPD1 cnv",
    "ENTPD1 proteo",
    "ENTPD1 rna"
  ],
  "ENTPD1-AS1": [
    "ENTPD1-AS1 methyl"
  ],
  "ENTPD2": [
    "ENTPD2 cnv",
    "ENTPD2 methyl",
    "ENTPD2 proteo",
    "ENTPD2 rna"
  ],
  "ENTPD3": [
    "ENTPD3 518_528_1_1_S528 phospho",
    "ENTPD3 cnv",
    "ENTPD3 methyl",
    "ENTPD3 proteo",
    "ENTPD3 rna"
  ],
  "ENTPD3-AS1": [
    "ENTPD3-AS1 methyl"
  ],
  "ENTPD4": [
    "ENTPD4 cnv",
    "ENTPD4 methyl",
    "ENTPD4 rna"
  ],
  "ENTPD5": [
    "ENTPD5 GYLTSFEMFNSTYK-N2H6F0S0G0 glyco",
    "ENTPD5 cnv",
    "ENTPD5 methyl",
    "ENTPD5 proteo",
    "ENTPD5 rna"
  ],
  "ENTPD6": [
    "ENTPD6 cnv",
    "ENTPD6 methyl",
    "ENTPD6 proteo",
    "ENTPD6 rna"
  ],
  "ENTPD7": [
    "ENTPD7 cnv",
    "ENTPD7 methyl",
    "ENTPD7 rna"
  ],
  "ENTPD8": [
    "ENTPD8 cnv",
    "ENTPD8 methyl",
    "ENTPD8 rna"
  ],
  "ENTR1": [
    "ENTR1 167_185_1_1_S170 phospho",
    "ENTR1 167_185_2_2_S170S174 phospho",
    "ENTR1 cnv",
    "ENTR1 methyl",
    "ENTR1 proteo",
    "ENTR1 rna"
  ],
  "ENTREP1": [
    "ENTREP1 426_435_1_1_S428 phospho",
    "ENTREP1 cnv",
    "ENTREP1 rna"
  ],
  "ENTREP2": [
    "ENTREP2 cnv",
    "ENTREP2 methyl",
    "ENTREP2 rna"
  ],
  "ENTREP3": [
    "ENTREP3 cnv",
    "ENTREP3 methyl",
    "ENTREP3 rna"
  ],
  "ENY2": [
    "ENY2 cnv",
    "ENY2 methyl",
    "ENY2 proteo",
    "ENY2 rna"
  ],
  "EOGT": [
    "EOGT cnv",
    "EOGT methyl",
    "EOGT proteo",
    "EOGT rna"
  ],
  "EOLA1": [
    "EOLA1 methyl",
    "EOLA1 rna"
  ],
  "EOLA1-DT": [
    "EOLA1-DT methyl"
  ],
  "EOLA2": [
    "EOLA2 methyl",
    "EOLA2 rna"
  ],
  "EOMES": [
    "EOMES cnv",
    "EOMES methyl",
    "EOMES rna"
  ],
  "EP300": [
    "EP300 1005_1018_1_1_S1012 phospho",
    "EP300 2283_2302_1_1_S2300 phospho",
    "EP300 859_880_1_1_T861 phospho",
    "EP300 995_1018_1_1_S1012 phospho",
    "EP300 cnv",
    "EP300 methyl",
    "EP300 proteo",
    "EP300 rna"
  ],
  "EP400": [
    "EP400 1690_1702_1_1_S1696 phospho",
    "EP400 297_323_1_1_S321 phospho",
    "EP400 cnv",
    "EP400 methyl",
    "EP400 proteo",
    "EP400 rna"
  ],
  "EPAS1": [
    "EPAS1 cnv",
    "EPAS1 methyl",
    "EPAS1 rna"
  ],
  "EPB41": [
    "EPB41 540_551_2_2_S540S542 phospho",
    "EPB41 542_551_1_1_S542 phospho",
    "EPB41 542_578_1_0 phospho",
    "EPB41 542_578_1_1_S555 phospho",
    "EPB41 56_67_1_1_T60 phospho",
    "EPB41 664_674_1_1_S674 phospho",
    "EPB41 684_686_1_1_S684 phospho",
    "EPB41 cnv",
    "EPB41 methyl",
    "EPB41 proteo",
    "EPB41 rna"
  ],
  "EPB41L1": [
    "EPB41L1 378_391_1_1_S378 phospho",
    "EPB41L1 578_591_1_1_S578 phospho",
    "EPB41L1 863_869_1_1_S869 phospho",
    "EPB41L1 866_869_1_1_S869 phospho",
    "EPB41L1 cnv",
    "EPB41L1 methyl",
    "EPB41L1 proteo",
    "EPB41L1 rna"
  ],
  "EPB41L2": [
    "EPB41L2 15_23_1_1_S16 phospho",
    "EPB41L2 386_392_1_1_S386 phospho",
    "EPB41L2 38_39_1_1_S39 phospho",
    "EPB41L2 38_58_1_0 phospho",
    "EPB41L2 38_58_2_0 phospho",
    "EPB41L2 402_404_1_1_S402 phospho",
    "EPB41L2 499_499_1_1_S499 phospho",
    "EPB41L2 550_562_1_1_S550 phospho",
    "EPB41L2 598_600_1_1_S598 phospho",
    "EPB41L2 647_649_1_1_S647 phospho",
    "EPB41L2 673_686_1_0 phospho",
    "EPB41L2 673_686_1_1_S683 phospho",
    "EPB41L2 682_686_1_0 phospho",
    "EPB41L2 706_718_1_1_S715 phospho",
    "EPB41L2 734_738_1_1_S735 phospho",
    "EPB41L2 cnv",
    "EPB41L2 methyl",
    "EPB41L2 proteo",
    "EPB41L2 rna"
  ],
  "EPB41L3": [
    "EPB41L3 2_11_1_1_S7 phospho",
    "EPB41L3 2_11_2_0 phospho",
    "EPB41L3 2_11_2_2_S5S7 phospho",
    "EPB41L3 443_456_1_0 phospho",
    "EPB41L3 443_456_1_1_S443 phospho",
    "EPB41L3 443_456_1_1_S448 phospho",
    "EPB41L3 443_456_2_2_S443S448 phospho",
    "EPB41L3 460_474_1_1_S462 phospho",
    "EPB41L3 478_487_1_0 phospho",
    "EPB41L3 478_487_1_1_S478 phospho",
    "EPB41L3 478_487_1_1_T487 phospho",
    "EPB41L3 478_487_2_2_S478T487 phospho",
    "EPB41L3 510_513_1_1_T510 phospho",
    "EPB41L3 521_539_1_1_S539 phospho",
    "EPB41L3 526_539_1_1_S539 phospho",
    "EPB41L3 526_539_2_2_T537S539 phospho",
    "EPB41L3 55_56_1_1_T56 phospho",
    "EPB41L3 564_567_1_1_S567 phospho",
    "EPB41L3 784_793_1_1_S793 phospho",
    "EPB41L3 784_803_1_1_S793 phospho",
    "EPB41L3 79_88_1_1_S88 phospho",
    "EPB41L3 909_912_1_1_T912 phospho",
    "EPB41L3 cnv",
    "EPB41L3 methyl",
    "EPB41L3 proteo",
    "EPB41L3 rna"
  ],
  "EPB41L4A": [
    "EPB41L4A 464_468_1_1_S464 phospho",
    "EPB41L4A 541_543_1_1_S543 phospho",
    "EPB41L4A cnv",
    "EPB41L4A methyl",
    "EPB41L4A proteo",
    "EPB41L4A rna"
  ],
  "EPB41L4A-DT": [
    "EPB41L4A-DT methyl"
  ],
  "EPB41L4B": [
    "EPB41L4B 535_540_1_1_S535 phospho",
    "EPB41L4B 594_602_1_1_S602 phospho",
    "EPB41L4B 725_730_1_1_S726 phospho",
    "EPB41L4B cnv",
    "EPB41L4B methyl",
    "EPB41L4B proteo",
    "EPB41L4B rna"
  ],
  "EPB41L5": [
    "EPB41L5 cnv",
    "EPB41L5 methyl",
    "EPB41L5 proteo",
    "EPB41L5 rna"
  ],
  "EPB42": [
    "EPB42 595_606_1_1_S601 phospho",
    "EPB42 cnv",
    "EPB42 proteo",
    "EPB42 rna"
  ],
  "EPC1": [
    "EPC1 cnv",
    "EPC1 methyl",
    "EPC1 proteo",
    "EPC1 rna"
  ],
  "EPC2": [
    "EPC2 cnv",
    "EPC2 methyl",
    "EPC2 proteo",
    "EPC2 rna"
  ],
  "EPCAM": [
    "EPCAM cnv",
    "EPCAM rna"
  ],
  "EPDR1": [
    "EPDR1 cnv",
    "EPDR1 methyl",
    "EPDR1 proteo",
    "EPDR1 rna"
  ],
  "EPG5": [
    "EPG5 cnv",
    "EPG5 methyl",
    "EPG5 proteo",
    "EPG5 rna"
  ],
  "EPGN": [
    "EPGN cnv",
    "EPGN rna"
  ],
  "EPHA1": [
    "EPHA1 cnv",
    "EPHA1 kinase",
    "EPHA1 rna"
  ],
  "EPHA10": [
    "EPHA10 cnv",
    "EPHA10 kinase",
    "EPHA10 methyl",
    "EPHA10 rna"
  ],
  "EPHA2": [
    "EPHA2 829_847_1_1_S838 phospho",
    "EPHA2 cnv",
    "EPHA2 kinase",
    "EPHA2 methyl",
    "EPHA2 proteo",
    "EPHA2 rna"
  ],
  "EPHA3": [
    "EPHA3 cnv",
    "EPHA3 kinase",
    "EPHA3 proteo",
    "EPHA3 rna"
  ],
  "EPHA4": [
    "EPHA4 cnv",
    "EPHA4 kinase",
    "EPHA4 methyl",
    "EPHA4 proteo",
    "EPHA4 rna"
  ],
  "EPHA5": [
    "EPHA5 954_968_1_1_S961 phospho",
    "EPHA5 cnv",
    "EPHA5 kinase",
    "EPHA5 methyl",
    "EPHA5 proteo",
    "EPHA5 rna"
  ],
  "EPHA5-AS1": [
    "EPHA5-AS1 methyl"
  ],
  "EPHA6": [
    "EPHA6 cnv",
    "EPHA6 kinase",
    "EPHA6 methyl",
    "EPHA6 rna"
  ],
  "EPHA7": [
    "EPHA7 cnv",
    "EPHA7 kinase",
    "EPHA7 methyl",
    "EPHA7 rna"
  ],
  "EPHA8": [
    "EPHA8 cnv",
    "EPHA8 kinase",
    "EPHA8 methyl",
    "EPHA8 rna"
  ],
  "EPHB1": [
    "EPHB1 582_584_1_0 phospho",
    "EPHB1 768_781_1_1_S774 phospho",
    "EPHB1 890_899_1_1_S899 phospho",
    "EPHB1 cnv",
    "EPHB1 kinase",
    "EPHB1 methyl",
    "EPHB1 proteo",
    "EPHB1 rna"
  ],
  "EPHB2": [
    "EPHB2 775_782_1_1_S776 phospho",
    "EPHB2 cnv",
    "EPHB2 kinase",
    "EPHB2 methyl",
    "EPHB2 proteo",
    "EPHB2 rna"
  ],
  "EPHB3": [
    "EPHB3 YAAVNITTNQAAPSEVPTLR-N2H5F0S0G0 glyco",
    "EPHB3 cnv",
    "EPHB3 kinase",
    "EPHB3 methyl",
    "EPHB3 proteo",
    "EPHB3 rna"
  ],
  "EPHB4": [
    "EPHB4 cnv",
    "EPHB4 kinase",
    "EPHB4 methyl",
    "EPHB4 proteo",
    "EPHB4 rna"
  ],
  "EPHB6": [
    "EPHB6 cnv",
    "EPHB6 kinase",
    "EPHB6 methyl",
    "EPHB6 proteo",
    "EPHB6 rna"
  ],
  "EPHX1": [
    "EPHX1 cnv",
    "EPHX1 methyl",
    "EPHX1 proteo",
    "EPHX1 rna"
  ],
  "EPHX2": [
    "EPHX2 cnv",
    "EPHX2 methyl",
    "EPHX2 proteo",
    "EPHX2 rna"
  ],
  "EPHX3": [
    "EPHX3 cnv",
    "EPHX3 methyl",
    "EPHX3 rna"
  ],
  "EPHX4": [
    "EPHX4 cnv",
    "EPHX4 methyl",
    "EPHX4 proteo",
    "EPHX4 rna"
  ],
  "EPIST": [
    "EPIST methyl"
  ],
  "EPM2A": [
    "EPM2A cnv",
    "EPM2A methyl",
    "EPM2A proteo",
    "EPM2A rna"
  ],
  "EPM2AIP1": [
    "EPM2AIP1 138_150_1_1_S146 phospho",
    "EPM2AIP1 cnv",
    "EPM2AIP1 methyl",
    "EPM2AIP1 proteo",
    "EPM2AIP1 rna"
  ],
  "EPN1": [
    "EPN1 435_442_1_1_S435 phospho",
    "EPN1 435_467_1_1_S447 phospho",
    "EPN1 447_467_1_1_S454 phospho",
    "EPN1 447_467_1_1_T460 phospho",
    "EPN1 447_467_1_1_T464 phospho",
    "EPN1 470_494_1_1_T470 phospho",
    "EPN1 cnv",
    "EPN1 methyl",
    "EPN1 proteo",
    "EPN1 rna"
  ],
  "EPN2": [
    "EPN2 172_186_1_0 phospho",
    "EPN2 172_186_1_1_S173 phospho",
    "EPN2 172_186_1_1_S182 phospho",
    "EPN2 172_186_2_2_S173S182 phospho",
    "EPN2 192_201_1_1_S192 phospho",
    "EPN2 192_201_2_2_S192S195 phospho",
    "EPN2 192_201_3_3_S192S195S201 phospho",
    "EPN2 192_203_1_0 phospho",
    "EPN2 192_203_2_2_S192S195 phospho",
    "EPN2 413_443_1_0 phospho",
    "EPN2 413_447_1_0 phospho",
    "EPN2 413_447_1_1_S429 phospho",
    "EPN2 cnv",
    "EPN2 methyl",
    "EPN2 proteo",
    "EPN2 rna"
  ],
  "EPN3": [
    "EPN3 cnv",
    "EPN3 rna"
  ],
  "EPO": [
    "EPO cnv",
    "EPO methyl",
    "EPO rna"
  ],
  "EPOP": [
    "EPOP cnv",
    "EPOP methyl",
    "EPOP rna"
  ],
  "EPOR": [
    "EPOR cnv",
    "EPOR methyl",
    "EPOR rna"
  ],
  "EPPIN": [
    "EPPIN cnv",
    "EPPIN rna"
  ],
  "EPPIN-WFDC6": [
    "EPPIN-WFDC6 cnv"
  ],
  "EPPK1": [
    "EPPK1 cnv",
    "EPPK1 methyl",
    "EPPK1 proteo",
    "EPPK1 rna"
  ],
  "EPRS1": [
    "EPRS1 737_754_1_0 phospho",
    "EPRS1 737_754_1_1_S747 phospho",
    "EPRS1 872_888_1_0 phospho",
    "EPRS1 872_888_2_0 phospho",
    "EPRS1 872_898_1_0 phospho",
    "EPRS1 872_898_2_0 phospho",
    "EPRS1 998_1000_1_1_S1000 phospho",
    "EPRS1 cnv",
    "EPRS1 methyl",
    "EPRS1 proteo",
    "EPRS1 rna"
  ],
  "EPS15": [
    "EPS15 106_116_1_1_S108 phospho",
    "EPS15 217_221_1_1_S221 phospho",
    "EPS15 323_330_1_1_S324 phospho",
    "EPS15 562_582_1_1_S563 phospho",
    "EPS15 741_753_1_1_S746 phospho",
    "EPS15 777_779_1_1_T777 phospho",
    "EPS15 790_796_1_1_S790 phospho",
    "EPS15 790_796_1_1_S796 phospho",
    "EPS15 796_796_1_1_S796 phospho",
    "EPS15 814_814_1_1_S814 phospho",
    "EPS15 841_851_1_1_S851 phospho",
    "EPS15 cnv",
    "EPS15 proteo",
    "EPS15 rna"
  ],
  "EPS15L1": [
    "EPS15L1 106_116_1_1_S108 phospho",
    "EPS15L1 217_235_1_1_S229 phospho",
    "EPS15L1 238_255_1_1_S244 phospho",
    "EPS15L1 238_255_1_1_S255 phospho",
    "EPS15L1 238_255_2_2_S244S255 phospho",
    "EPS15L1 355_362_1_1_S355 phospho",
    "EPS15L1 366_381_1_1_S377 phospho",
    "EPS15L1 cnv",
    "EPS15L1 methyl",
    "EPS15L1 proteo",
    "EPS15L1 rna"
  ],
  "EPS8": [
    "EPS8 51_65_1_1_S55 phospho",
    "EPS8 613_648_1_0 phospho",
    "EPS8 613_648_1_1_T629 phospho",
    "EPS8 685_685_1_1_S685 phospho",
    "EPS8 cnv",
    "EPS8 methyl",
    "EPS8 proteo",
    "EPS8 rna"
  ],
  "EPS8L1": [
    "EPS8L1 cnv",
    "EPS8L1 methyl",
    "EPS8L1 rna"
  ],
  "EPS8L2": [
    "EPS8L2 565_572_1_1_S570 phospho",
    "EPS8L2 cnv",
    "EPS8L2 methyl",
    "EPS8L2 proteo",
    "EPS8L2 rna"
  ],
  "EPS8L3": [
    "EPS8L3 cnv",
    "EPS8L3 rna"
  ],
  "EPSTI1": [
    "EPSTI1 cnv",
    "EPSTI1 methyl",
    "EPSTI1 proteo",
    "EPSTI1 rna"
  ],
  "EPX": [
    "EPX cnv",
    "EPX rna"
  ],
  "EPYC": [
    "EPYC cnv",
    "EPYC rna"
  ],
  "EQTN": [
    "EQTN cnv",
    "EQTN rna"
  ],
  "ERAL1": [
    "ERAL1 cnv",
    "ERAL1 methyl",
    "ERAL1 proteo",
    "ERAL1 rna"
  ],
  "ERAP1": [
    "ERAP1 CFDAMEVDALNSSHPVSTPVENPAQIR-N3H7F1S0G0 glyco",
    "ERAP1 cnv",
    "ERAP1 methyl",
    "ERAP1 proteo",
    "ERAP1 rna"
  ],
  "ERAP2": [
    "ERAP2 DLEITNATLQSEEDSR-N2H5F0S0G0 glyco",
    "ERAP2 DLEITNATLQSEEDSR-N2H6F0S0G0 glyco",
    "ERAP2 cnv",
    "ERAP2 proteo",
    "ERAP2 rna"
  ],
  "ERAS": [
    "ERAS methyl",
    "ERAS rna"
  ],
  "ERBB2": [
    "ERBB2 1082_1121_1_1_S1121 phospho",
    "ERBB2 cnv",
    "ERBB2 kinase",
    "ERBB2 methyl",
    "ERBB2 proteo",
    "ERBB2 rna"
  ],
  "ERBB3": [
    "ERBB3 982_996_1_1_S982 phospho",
    "ERBB3 FQTVDSSNIDGFVNCTK-N2H5F0S0G0 glyco",
    "ERBB3 cnv",
    "ERBB3 kinase",
    "ERBB3 methyl",
    "ERBB3 proteo",
    "ERBB3 rna"
  ],
  "ERBB4": [
    "ERBB4 cnv",
    "ERBB4 kinase",
    "ERBB4 proteo",
    "ERBB4 rna"
  ],
  "ERBIN": [
    "ERBIN 1013_1021_1_0 phospho",
    "ERBIN 1304_1310_1_1_S1310 phospho",
    "ERBIN cnv",
    "ERBIN methyl",
    "ERBIN proteo",
    "ERBIN rna"
  ],
  "ERC1": [
    "ERC1 14_21_1_1_S21 phospho",
    "ERC1 35_50_1_0 phospho",
    "ERC1 35_50_1_1_S37 phospho",
    "ERC1 35_50_2_1_S45 phospho",
    "ERC1 35_50_2_2_T35S37 phospho",
    "ERC1 53_84_1_1_S55 phospho",
    "ERC1 702_706_1_1_S702 phospho",
    "ERC1 cnv",
    "ERC1 methyl",
    "ERC1 proteo",
    "ERC1 rna"
  ],
  "ERC2": [
    "ERC2 7_18_1_1_S18 phospho",
    "ERC2 cnv",
    "ERC2 methyl",
    "ERC2 proteo",
    "ERC2 rna"
  ],
  "ERCC1": [
    "ERCC1 cnv",
    "ERCC1 methyl",
    "ERCC1 proteo",
    "ERCC1 rna"
  ],
  "ERCC2": [
    "ERCC2 cnv",
    "ERCC2 methyl",
    "ERCC2 proteo",
    "ERCC2 rna"
  ],
  "ERCC3": [
    "ERCC3 49_51_1_1_S49 phospho",
    "ERCC3 cnv",
    "ERCC3 methyl",
    "ERCC3 proteo",
    "ERCC3 rna"
  ],
  "ERCC4": [
    "ERCC4 cnv",
    "ERCC4 methyl",
    "ERCC4 proteo",
    "ERCC4 rna"
  ],
  "ERCC5": [
    "ERCC5 cnv",
    "ERCC5 methyl",
    "ERCC5 rna"
  ],
  "ERCC6": [
    "ERCC6 cnv",
    "ERCC6 methyl",
    "ERCC6 rna"
  ],
  "ERCC6L": [
    "ERCC6L methyl",
    "ERCC6L proteo",
    "ERCC6L rna"
  ],
  "ERCC6L2": [
    "ERCC6L2 cnv",
    "ERCC6L2 methyl",
    "ERCC6L2 rna"
  ],
  "ERCC6L2-AS1": [
    "ERCC6L2-AS1 methyl"
  ],
  "ERCC8": [
    "ERCC8 cnv",
    "ERCC8 methyl",
    "ERCC8 proteo",
    "ERCC8 rna"
  ],
  "EREG": [
    "EREG cnv",
    "EREG rna"
  ],
  "ERF": [
    "ERF 185_194_1_0 phospho",
    "ERF 185_194_1_1_S185 phospho",
    "ERF 313_327_1_1_S327 phospho",
    "ERF 3_24_1_0 phospho",
    "ERF 3_24_1_1_S21 phospho",
    "ERF 526_526_1_1_T526 phospho",
    "ERF 531_542_1_1_S531 phospho",
    "ERF cnv",
    "ERF methyl",
    "ERF proteo",
    "ERF rna"
  ],
  "ERFE": [
    "ERFE cnv",
    "ERFE methyl",
    "ERFE rna"
  ],
  "ERFL": [
    "ERFL cnv",
    "ERFL methyl",
    "ERFL rna"
  ],
  "ERG": [
    "ERG 80_93_1_1_S88 phospho",
    "ERG cnv",
    "ERG methyl",
    "ERG rna"
  ],
  "ERG28": [
    "ERG28 cnv",
    "ERG28 methyl",
    "ERG28 proteo",
    "ERG28 rna"
  ],
  "ERGIC1": [
    "ERGIC1 cnv",
    "ERGIC1 methyl",
    "ERGIC1 proteo",
    "ERGIC1 rna"
  ],
  "ERGIC2": [
    "ERGIC2 cnv",
    "ERGIC2 methyl",
    "ERGIC2 proteo",
    "ERGIC2 rna"
  ],
  "ERGIC3": [
    "ERGIC3 cnv",
    "ERGIC3 methyl",
    "ERGIC3 proteo",
    "ERGIC3 rna"
  ],
  "ERH": [
    "ERH cnv",
    "ERH methyl",
    "ERH proteo",
    "ERH rna"
  ],
  "ERI1": [
    "ERI1 cnv",
    "ERI1 methyl",
    "ERI1 proteo",
    "ERI1 rna"
  ],
  "ERI2": [
    "ERI2 cnv",
    "ERI2 methyl",
    "ERI2 rna"
  ],
  "ERI3": [
    "ERI3 cnv",
    "ERI3 methyl",
    "ERI3 proteo",
    "ERI3 rna"
  ],
  "ERICH1": [
    "ERICH1 cnv",
    "ERICH1 methyl",
    "ERICH1 proteo",
    "ERICH1 rna"
  ],
  "ERICH2": [
    "ERICH2 cnv",
    "ERICH2 rna"
  ],
  "ERICH2-DT": [
    "ERICH2-DT methyl"
  ],
  "ERICH3": [
    "ERICH3 cnv",
    "ERICH3 rna"
  ],
  "ERICH4": [
    "ERICH4 cnv",
    "ERICH4 rna"
  ],
  "ERICH5": [
    "ERICH5 cnv",
    "ERICH5 methyl",
    "ERICH5 rna"
  ],
  "ERICH6": [
    "ERICH6 cnv",
    "ERICH6 methyl",
    "ERICH6 rna"
  ],
  "ERICH6-AS1": [
    "ERICH6-AS1 methyl"
  ],
  "ERICH6B": [
    "ERICH6B cnv",
    "ERICH6B rna"
  ],
  "ERLEC1": [
    "ERLEC1 cnv",
    "ERLEC1 methyl",
    "ERLEC1 proteo",
    "ERLEC1 rna"
  ],
  "ERLIN1": [
    "ERLIN1 cnv",
    "ERLIN1 methyl",
    "ERLIN1 proteo",
    "ERLIN1 rna"
  ],
  "ERLIN2": [
    "ERLIN2 NYTADYDK-N2H5F0S0G0 glyco",
    "ERLIN2 NYTADYDK-N2H6F0S0G0 glyco",
    "ERLIN2 NYTADYDK-N2H7F0S0G0 glyco",
    "ERLIN2 NYTADYDK-N2H8F0S0G0 glyco",
    "ERLIN2 NYTADYDK-N2H9F0S0G0 glyco",
    "ERLIN2 cnv",
    "ERLIN2 methyl",
    "ERLIN2 proteo",
    "ERLIN2 rna"
  ],
  "ERMAP": [
    "ERMAP 406_421_1_1_S418 phospho",
    "ERMAP 458_474_1_1_S474 phospho",
    "ERMAP cnv",
    "ERMAP methyl",
    "ERMAP proteo",
    "ERMAP rna"
  ],
  "ERMARD": [
    "ERMARD cnv",
    "ERMARD methyl",
    "ERMARD rna"
  ],
  "ERMN": [
    "ERMN 179_186_1_1_S179 phospho",
    "ERMN cnv",
    "ERMN proteo",
    "ERMN rna"
  ],
  "ERMP1": [
    "ERMP1 cnv",
    "ERMP1 methyl",
    "ERMP1 proteo",
    "ERMP1 rna"
  ],
  "ERN1": [
    "ERN1 cnv",
    "ERN1 kinase",
    "ERN1 methyl",
    "ERN1 rna"
  ],
  "ERN2": [
    "ERN2 cnv",
    "ERN2 kinase",
    "ERN2 methyl",
    "ERN2 rna"
  ],
  "ERO1A": [
    "ERO1A 106_106_1_1_S106 phospho",
    "ERO1A KWGHNITEFQQR-N2H6F0S0G0 glyco",
    "ERO1A WGHNITEFQQR-N2H6F0S0G0 glyco",
    "ERO1A cnv",
    "ERO1A methyl",
    "ERO1A proteo",
    "ERO1A rna"
  ],
  "ERO1B": [
    "ERO1B cnv",
    "ERO1B methyl",
    "ERO1B rna"
  ],
  "ERP27": [
    "ERP27 cnv",
    "ERP27 rna"
  ],
  "ERP29": [
    "ERP29 QGQDNLSSVK-N2H5F0S0G0 glyco",
    "ERP29 QGQDNLSSVK-N2H6F0S0G0 glyco",
    "ERP29 cnv",
    "ERP29 methyl",
    "ERP29 proteo",
    "ERP29 rna"
  ],
  "ERP44": [
    "ERP44 cnv",
    "ERP44 methyl",
    "ERP44 proteo",
    "ERP44 rna"
  ],
  "ERRFI1": [
    "ERRFI1 249_256_1_1_S251 phospho",
    "ERRFI1 369_374_1_1_S369 phospho",
    "ERRFI1 cnv",
    "ERRFI1 methyl",
    "ERRFI1 rna"
  ],
  "ERV3-1": [
    "ERV3-1 cnv",
    "ERV3-1 rna"
  ],
  "ERVFRD-1": [
    "ERVFRD-1 cnv",
    "ERVFRD-1 rna"
  ],
  "ERVH48-1": [
    "ERVH48-1 cnv",
    "ERVH48-1 rna"
  ],
  "ERVK3-1": [
    "ERVK3-1 cnv",
    "ERVK3-1 rna"
  ],
  "ERVMER34-1": [
    "ERVMER34-1 cnv",
    "ERVMER34-1 methyl",
    "ERVMER34-1 rna"
  ],
  "ERVV-1": [
    "ERVV-1 cnv",
    "ERVV-1 rna"
  ],
  "ERVV-2": [
    "ERVV-2 cnv",
    "ERVV-2 rna"
  ],
  "ERVW-1": [
    "ERVW-1 cnv",
    "ERVW-1 rna"
  ],
  "ESAM": [
    "ESAM 349_371_1_1_S359 phospho",
    "ESAM 349_371_1_1_S366 phospho",
    "ESAM GSLSLTNLSSSMAGVYVCK-N2H7F0S0G0 glyco",
    "ESAM cnv",
    "ESAM methyl",
    "ESAM proteo",
    "ESAM rna"
  ],
  "ESAM-AS1": [
    "ESAM-AS1 methyl"
  ],
  "ESCO1": [
    "ESCO1 cnv",
    "ESCO1 methyl",
    "ESCO1 rna"
  ],
  "ESCO2": [
    "ESCO2 cnv",
    "ESCO2 methyl",
    "ESCO2 rna"
  ],
  "ESD": [
    "ESD cnv",
    "ESD methyl",
    "ESD proteo",
    "ESD rna"
  ],
  "ESF1": [
    "ESF1 cnv",
    "ESF1 methyl",
    "ESF1 proteo",
    "ESF1 rna"
  ],
  "ESM1": [
    "ESM1 cnv",
    "ESM1 rna"
  ],
  "ESPL1": [
    "ESPL1 cnv",
    "ESPL1 methyl",
    "ESPL1 rna"
  ],
  "ESPN": [
    "ESPN cnv",
    "ESPN methyl",
    "ESPN proteo",
    "ESPN rna"
  ],
  "ESPNL": [
    "ESPNL cnv",
    "ESPNL methyl",
    "ESPNL rna"
  ],
  "ESR1": [
    "ESR1 cnv",
    "ESR1 methyl",
    "ESR1 rna"
  ],
  "ESR2": [
    "ESR2 cnv",
    "ESR2 methyl",
    "ESR2 rna"
  ],
  "ESRP1": [
    "ESRP1 cnv",
    "ESRP1 methyl",
    "ESRP1 rna"
  ],
  "ESRP2": [
    "ESRP2 cnv",
    "ESRP2 methyl",
    "ESRP2 rna"
  ],
  "ESRRA": [
    "ESRRA cnv",
    "ESRRA methyl",
    "ESRRA rna"
  ],
  "ESRRAP2": [
    "ESRRAP2 methyl"
  ],
  "ESRRB": [
    "ESRRB cnv",
    "ESRRB methyl",
    "ESRRB rna"
  ],
  "ESRRG": [
    "ESRRG cnv",
    "ESRRG methyl",
    "ESRRG rna"
  ],
  "ESS2": [
    "ESS2 cnv",
    "ESS2 methyl",
    "ESS2 proteo",
    "ESS2 rna"
  ],
  "ESX1": [
    "ESX1 methyl",
    "ESX1 rna"
  ],
  "ESYT1": [
    "ESYT1 830_841_1_1_S830 phospho",
    "ESYT1 969_973_1_1_S973 phospho",
    "ESYT1 cnv",
    "ESYT1 methyl",
    "ESYT1 proteo",
    "ESYT1 rna"
  ],
  "ESYT2": [
    "ESYT2 641_641_1_1_S641 phospho",
    "ESYT2 660_683_1_0 phospho",
    "ESYT2 660_683_1_1_S665 phospho",
    "ESYT2 708_720_1_1_S710 phospho",
    "ESYT2 725_738_1_1_S730 phospho",
    "ESYT2 725_738_1_1_S733 phospho",
    "ESYT2 725_738_2_2_S730S733 phospho",
    "ESYT2 cnv",
    "ESYT2 methyl",
    "ESYT2 proteo",
    "ESYT2 rna"
  ],
  "ESYT3": [
    "ESYT3 cnv",
    "ESYT3 methyl",
    "ESYT3 rna"
  ],
  "ETAA1": [
    "ETAA1 cnv",
    "ETAA1 methyl",
    "ETAA1 rna"
  ],
  "ETDA": [
    "ETDA rna"
  ],
  "ETDB": [
    "ETDB rna"
  ],
  "ETF1": [
    "ETF1 cnv",
    "ETF1 methyl",
    "ETF1 proteo",
    "ETF1 rna"
  ],
  "ETFA": [
    "ETFA cnv",
    "ETFA methyl",
    "ETFA proteo",
    "ETFA rna"
  ],
  "ETFB": [
    "ETFB cnv",
    "ETFB methyl",
    "ETFB proteo",
    "ETFB rna"
  ],
  "ETFBKMT": [
    "ETFBKMT cnv",
    "ETFBKMT methyl",
    "ETFBKMT rna"
  ],
  "ETFDH": [
    "ETFDH cnv",
    "ETFDH methyl",
    "ETFDH proteo",
    "ETFDH rna"
  ],
  "ETFRF1": [
    "ETFRF1 cnv",
    "ETFRF1 methyl",
    "ETFRF1 rna"
  ],
  "ETHE1": [
    "ETHE1 cnv",
    "ETHE1 methyl",
    "ETHE1 proteo",
    "ETHE1 rna"
  ],
  "ETNK1": [
    "ETNK1 cnv",
    "ETNK1 methyl",
    "ETNK1 proteo",
    "ETNK1 rna"
  ],
  "ETNK2": [
    "ETNK2 cnv",
    "ETNK2 methyl",
    "ETNK2 rna"
  ],
  "ETNPPL": [
    "ETNPPL cnv",
    "ETNPPL methyl",
    "ETNPPL proteo",
    "ETNPPL rna"
  ],
  "ETS1": [
    "ETS1 cnv",
    "ETS1 methyl",
    "ETS1 rna"
  ],
  "ETS2": [
    "ETS2 cnv",
    "ETS2 methyl",
    "ETS2 rna"
  ],
  "ETV1": [
    "ETV1 191_202_1_1_S191 phospho",
    "ETV1 94_104_1_1_S94 phospho",
    "ETV1 cnv",
    "ETV1 methyl",
    "ETV1 proteo",
    "ETV1 rna"
  ],
  "ETV2": [
    "ETV2 cnv",
    "ETV2 methyl",
    "ETV2 rna"
  ],
  "ETV3": [
    "ETV3 157_161_1_1_S159 phospho",
    "ETV3 cnv",
    "ETV3 methyl",
    "ETV3 rna"
  ],
  "ETV3L": [
    "ETV3L cnv",
    "ETV3L rna"
  ],
  "ETV4": [
    "ETV4 cnv",
    "ETV4 methyl",
    "ETV4 rna"
  ],
  "ETV5": [
    "ETV5 248_248_1_1_S248 phospho",
    "ETV5 cnv",
    "ETV5 methyl",
    "ETV5 rna"
  ],
  "ETV6": [
    "ETV6 131_142_1_1_S139 phospho",
    "ETV6 16_31_1_1_T18 phospho",
    "ETV6 16_31_2_2_T18S22 phospho",
    "ETV6 213_213_1_1_S213 phospho",
    "ETV6 cnv",
    "ETV6 methyl",
    "ETV6 proteo",
    "ETV6 rna"
  ],
  "ETV7": [
    "ETV7 cnv",
    "ETV7 methyl",
    "ETV7 rna"
  ],
  "EVA1A": [
    "EVA1A cnv",
    "EVA1A methyl",
    "EVA1A rna"
  ],
  "EVA1B": [
    "EVA1B 138_158_1_1_T158 phospho",
    "EVA1B 70_87_1_1_S71 phospho",
    "EVA1B cnv",
    "EVA1B methyl",
    "EVA1B proteo",
    "EVA1B rna"
  ],
  "EVA1C": [
    "EVA1C cnv",
    "EVA1C methyl",
    "EVA1C rna"
  ],
  "EVC": [
    "EVC cnv",
    "EVC methyl",
    "EVC rna"
  ],
  "EVC2": [
    "EVC2 cnv",
    "EVC2 methyl",
    "EVC2 rna"
  ],
  "EVI2A": [
    "EVI2A cnv",
    "EVI2A proteo",
    "EVI2A rna"
  ],
  "EVI2B": [
    "EVI2B 267_273_1_1_S268 phospho",
    "EVI2B 267_278_1_1_S268 phospho",
    "EVI2B 267_278_2_2_S268S271 phospho",
    "EVI2B cnv",
    "EVI2B proteo",
    "EVI2B rna"
  ],
  "EVI5": [
    "EVI5 cnv",
    "EVI5 methyl",
    "EVI5 proteo",
    "EVI5 rna"
  ],
  "EVI5L": [
    "EVI5L 694_699_1_1_S696 phospho",
    "EVI5L cnv",
    "EVI5L methyl",
    "EVI5L proteo",
    "EVI5L rna"
  ],
  "EVL": [
    "EVL 130_130_1_1_S130 phospho",
    "EVL 242_251_1_1_S246 phospho",
    "EVL 296_309_1_1_S304 phospho",
    "EVL 329_341_1_1_S331 phospho",
    "EVL 343_349_2_2_S345S349 phospho",
    "EVL 349_362_1_1_S354 phospho",
    "EVL 369_369_1_1_S369 phospho",
    "EVL cnv",
    "EVL methyl",
    "EVL proteo",
    "EVL rna"
  ],
  "EVPL": [
    "EVPL cnv",
    "EVPL rna"
  ],
  "EVPLL": [
    "EVPLL cnv",
    "EVPLL rna"
  ],
  "EVX1": [
    "EVX1 cnv",
    "EVX1 methyl",
    "EVX1 rna"
  ],
  "EVX1-AS": [
    "EVX1-AS methyl"
  ],
  "EVX2": [
    "EVX2 cnv",
    "EVX2 methyl",
    "EVX2 rna"
  ],
  "EWSAT1": [
    "EWSAT1 methyl"
  ],
  "EWSR1": [
    "EWSR1 cnv",
    "EWSR1 methyl",
    "EWSR1 proteo",
    "EWSR1 rna"
  ],
  "EXD1": [
    "EXD1 cnv",
    "EXD1 methyl",
    "EXD1 rna"
  ],
  "EXD2": [
    "EXD2 600_600_1_1_S600 phospho",
    "EXD2 cnv",
    "EXD2 methyl",
    "EXD2 proteo",
    "EXD2 rna"
  ],
  "EXD3": [
    "EXD3 cnv",
    "EXD3 methyl",
    "EXD3 rna"
  ],
  "EXO1": [
    "EXO1 cnv",
    "EXO1 methyl",
    "EXO1 rna"
  ],
  "EXO5": [
    "EXO5 cnv",
    "EXO5 methyl",
    "EXO5 rna"
  ],
  "EXOC1": [
    "EXOC1 472_486_1_1_S486 phospho",
    "EXOC1 553_559_1_1_T553 phospho",
    "EXOC1 cnv",
    "EXOC1 methyl",
    "EXOC1 proteo",
    "EXOC1 rna"
  ],
  "EXOC1L": [
    "EXOC1L cnv",
    "EXOC1L rna"
  ],
  "EXOC2": [
    "EXOC2 404_426_1_0 phospho",
    "EXOC2 404_426_1_1_S426 phospho",
    "EXOC2 cnv",
    "EXOC2 methyl",
    "EXOC2 proteo",
    "EXOC2 rna"
  ],
  "EXOC3": [
    "EXOC3 cnv",
    "EXOC3 methyl",
    "EXOC3 proteo",
    "EXOC3 rna"
  ],
  "EXOC3L1": [
    "EXOC3L1 cnv",
    "EXOC3L1 rna"
  ],
  "EXOC3L2": [
    "EXOC3L2 cnv",
    "EXOC3L2 proteo",
    "EXOC3L2 rna"
  ],
  "EXOC3L4": [
    "EXOC3L4 cnv",
    "EXOC3L4 methyl",
    "EXOC3L4 rna"
  ],
  "EXOC4": [
    "EXOC4 468_485_1_1_S468 phospho",
    "EXOC4 cnv",
    "EXOC4 proteo",
    "EXOC4 rna"
  ],
  "EXOC5": [
    "EXOC5 122_122_1_1_T122 phospho",
    "EXOC5 cnv",
    "EXOC5 methyl",
    "EXOC5 proteo",
    "EXOC5 rna"
  ],
  "EXOC6": [
    "EXOC6 cnv",
    "EXOC6 methyl",
    "EXOC6 proteo",
    "EXOC6 rna"
  ],
  "EXOC6B": [
    "EXOC6B cnv",
    "EXOC6B methyl",
    "EXOC6B proteo",
    "EXOC6B rna"
  ],
  "EXOC7": [
    "EXOC7 241_250_1_0 phospho",
    "EXOC7 cnv",
    "EXOC7 methyl",
    "EXOC7 proteo",
    "EXOC7 rna"
  ],
  "EXOC8": [
    "EXOC8 cnv",
    "EXOC8 methyl",
    "EXOC8 proteo",
    "EXOC8 rna"
  ],
  "EXOG": [
    "EXOG cnv",
    "EXOG methyl",
    "EXOG proteo",
    "EXOG rna"
  ],
  "EXOSC1": [
    "EXOSC1 cnv",
    "EXOSC1 methyl",
    "EXOSC1 proteo",
    "EXOSC1 rna"
  ],
  "EXOSC10": [
    "EXOSC10 cnv",
    "EXOSC10 methyl",
    "EXOSC10 proteo",
    "EXOSC10 rna"
  ],
  "EXOSC2": [
    "EXOSC2 cnv",
    "EXOSC2 methyl",
    "EXOSC2 proteo",
    "EXOSC2 rna"
  ],
  "EXOSC3": [
    "EXOSC3 cnv",
    "EXOSC3 methyl",
    "EXOSC3 proteo",
    "EXOSC3 rna"
  ],
  "EXOSC4": [
    "EXOSC4 cnv",
    "EXOSC4 methyl",
    "EXOSC4 proteo",
    "EXOSC4 rna"
  ],
  "EXOSC5": [
    "EXOSC5 cnv",
    "EXOSC5 methyl",
    "EXOSC5 proteo",
    "EXOSC5 rna"
  ],
  "EXOSC6": [
    "EXOSC6 cnv",
    "EXOSC6 methyl",
    "EXOSC6 proteo",
    "EXOSC6 rna"
  ],
  "EXOSC7": [
    "EXOSC7 cnv",
    "EXOSC7 methyl",
    "EXOSC7 proteo",
    "EXOSC7 rna"
  ],
  "EXOSC8": [
    "EXOSC8 cnv",
    "EXOSC8 methyl",
    "EXOSC8 proteo",
    "EXOSC8 rna"
  ],
  "EXOSC9": [
    "EXOSC9 cnv",
    "EXOSC9 methyl",
    "EXOSC9 proteo",
    "EXOSC9 rna"
  ],
  "EXPH5": [
    "EXPH5 cnv",
    "EXPH5 rna"
  ],
  "EXT1": [
    "EXT1 cnv",
    "EXT1 methyl",
    "EXT1 rna"
  ],
  "EXT2": [
    "EXT2 cnv",
    "EXT2 methyl",
    "EXT2 proteo",
    "EXT2 rna"
  ],
  "EXTL1": [
    "EXTL1 cnv",
    "EXTL1 rna"
  ],
  "EXTL2": [
    "EXTL2 cnv",
    "EXTL2 methyl",
    "EXTL2 proteo",
    "EXTL2 rna"
  ],
  "EXTL3": [
    "EXTL3 cnv",
    "EXTL3 methyl",
    "EXTL3 proteo",
    "EXTL3 rna"
  ],
  "EXTL3-AS1": [
    "EXTL3-AS1 methyl"
  ],
  "EYA1": [
    "EYA1 314_319_1_1_S314 phospho",
    "EYA1 cnv",
    "EYA1 methyl",
    "EYA1 rna"
  ],
  "EYA2": [
    "EYA2 256_260_1_1_S257 phospho",
    "EYA2 cnv",
    "EYA2 rna"
  ],
  "EYA3": [
    "EYA3 cnv",
    "EYA3 methyl",
    "EYA3 proteo",
    "EYA3 rna"
  ],
  "EYA4": [
    "EYA4 367_372_1_1_S367 phospho",
    "EYA4 cnv",
    "EYA4 methyl",
    "EYA4 proteo",
    "EYA4 rna"
  ],
  "EYS": [
    "EYS cnv",
    "EYS rna"
  ],
  "EZH1": [
    "EZH1 cnv",
    "EZH1 methyl",
    "EZH1 rna"
  ],
  "EZH2": [
    "EZH2 cnv",
    "EZH2 methyl",
    "EZH2 rna"
  ],
  "EZHIP": [
    "EZHIP rna"
  ],
  "EZR": [
    "EZR 533_539_1_1_S536 phospho",
    "EZR cnv",
    "EZR methyl",
    "EZR proteo",
    "EZR rna"
  ],
  "F10": [
    "F10 cnv",
    "F10 proteo",
    "F10 rna"
  ],
  "F10-AS1": [
    "F10-AS1 methyl"
  ],
  "F11": [
    "F11 GINYNSSVAK-N4H5F0S2G0 glyco",
    "F11 cnv",
    "F11 proteo",
    "F11 rna"
  ],
  "F11-AS1": [
    "F11-AS1 methyl"
  ],
  "F11R": [
    "F11R 245_247_1_1_S247 phospho",
    "F11R cnv",
    "F11R methyl",
    "F11R proteo",
    "F11R rna"
  ],
  "F12": [
    "F12 NHSCEPCQTLAVR-N4H5F0S2G0 glyco",
    "F12 cnv",
    "F12 methyl",
    "F12 proteo",
    "F12 rna"
  ],
  "F13A1": [
    "F13A1 cnv",
    "F13A1 proteo",
    "F13A1 rna"
  ],
  "F13B": [
    "F13B EHETCLAPELYNGNYSTTQK-N4H5F0S2G0 glyco",
    "F13B cnv",
    "F13B proteo",
    "F13B rna"
  ],
  "F2": [
    "F2 GHVNITR-N3H3F2S0G0 glyco",
    "F2 GHVNITR-N3H4F0S1G0 glyco",
    "F2 GHVNITR-N4H4F0S1G0 glyco",
    "F2 GHVNITR-N4H5F0S0G0 glyco",
    "F2 GHVNITR-N4H5F0S1G0 glyco",
    "F2 NFTENDLLVR-N3H4F0S1G0 glyco",
    "F2 NFTENDLLVR-N4H5F0S1G0 glyco",
    "F2 NFTENDLLVR-N4H5F0S2G0 glyco",
    "F2 YPHKPEINSTTHPGADLQENFCR-N4H5F0S2G0 glyco",
    "F2 YPHKPEINSTTHPGADLQENFCR-N6H3F5S0G0 glyco",
    "F2 cnv",
    "F2 proteo",
    "F2 rna"
  ],
  "F2R": [
    "F2R 289_299_1_1_S297 phospho",
    "F2R cnv",
    "F2R methyl",
    "F2R rna"
  ],
  "F2RL1": [
    "F2RL1 cnv",
    "F2RL1 methyl",
    "F2RL1 rna"
  ],
  "F2RL2": [
    "F2RL2 cnv",
    "F2RL2 rna"
  ],
  "F2RL3": [
    "F2RL3 cnv",
    "F2RL3 rna"
  ],
  "F3": [
    "F3 285_295_1_1_S285 phospho",
    "F3 VNVTVEDER-N3H5F1S0G0 glyco",
    "F3 VNVTVEDER-N3H6F0S0G0 glyco",
    "F3 VNVTVEDER-N3H6F1S0G0 glyco",
    "F3 cnv",
    "F3 methyl",
    "F3 proteo",
    "F3 rna"
  ],
  "F5": [
    "F5 cnv",
    "F5 proteo",
    "F5 rna"
  ],
  "F7": [
    "F7 cnv",
    "F7 methyl",
    "F7 rna"
  ],
  "F8": [
    "F8 methyl",
    "F8 rna"
  ],
  "F8A1": [
    "F8A1 methyl",
    "F8A1 rna"
  ],
  "F8A2": [
    "F8A2 proteo",
    "F8A2 rna"
  ],
  "F8A3": [
    "F8A3 rna"
  ],
  "F9": [
    "F9 proteo"
  ],
  "FA2H": [
    "FA2H cnv",
    "FA2H methyl",
    "FA2H rna"
  ],
  "FAAH": [
    "FAAH cnv",
    "FAAH methyl",
    "FAAH proteo",
    "FAAH rna"
  ],
  "FAAH2": [
    "FAAH2 methyl",
    "FAAH2 rna"
  ],
  "FAAP100": [
    "FAAP100 667_682_1_1_S667 phospho",
    "FAAP100 667_695_1_1_S667 phospho",
    "FAAP100 cnv",
    "FAAP100 methyl",
    "FAAP100 proteo",
    "FAAP100 rna"
  ],
  "FAAP20": [
    "FAAP20 cnv",
    "FAAP20 methyl",
    "FAAP20 rna"
  ],
  "FAAP24": [
    "FAAP24 cnv",
    "FAAP24 methyl",
    "FAAP24 rna"
  ],
  "FABP1": [
    "FABP1 cnv",
    "FABP1 rna"
  ],
  "FABP12": [
    "FABP12 cnv",
    "FABP12 rna"
  ],
  "FABP2": [
    "FABP2 cnv"
  ],
  "FABP3": [
    "FABP3 cnv",
    "FABP3 proteo",
    "FABP3 rna"
  ],
  "FABP4": [
    "FABP4 cnv",
    "FABP4 proteo",
    "FABP4 rna"
  ],
  "FABP5": [
    "FABP5 cnv",
    "FABP5 methyl",
    "FABP5 proteo",
    "FABP5 rna"
  ],
  "FABP5P3": [
    "FABP5P3 methyl"
  ],
  "FABP6": [
    "FABP6 cnv",
    "FABP6 rna"
  ],
  "FABP7": [
    "FABP7 cnv",
    "FABP7 proteo",
    "FABP7 rna"
  ],
  "FABP9": [
    "FABP9 cnv"
  ],
  "FADD": [
    "FADD cnv",
    "FADD methyl",
    "FADD proteo",
    "FADD rna"
  ],
  "FADS1": [
    "FADS1 cnv",
    "FADS1 methyl",
    "FADS1 proteo",
    "FADS1 rna"
  ],
  "FADS2": [
    "FADS2 cnv",
    "FADS2 methyl",
    "FADS2 proteo",
    "FADS2 rna"
  ],
  "FADS3": [
    "FADS3 cnv",
    "FADS3 methyl",
    "FADS3 proteo",
    "FADS3 rna"
  ],
  "FADS6": [
    "FADS6 cnv",
    "FADS6 methyl",
    "FADS6 rna"
  ],
  "FAF1": [
    "FAF1 cnv",
    "FAF1 methyl",
    "FAF1 proteo",
    "FAF1 rna"
  ],
  "FAF2": [
    "FAF2 cnv",
    "FAF2 methyl",
    "FAF2 proteo",
    "FAF2 rna"
  ],
  "FAH": [
    "FAH cnv",
    "FAH methyl",
    "FAH proteo",
    "FAH rna"
  ],
  "FAHD1": [
    "FAHD1 cnv",
    "FAHD1 methyl",
    "FAHD1 proteo",
    "FAHD1 rna"
  ],
  "FAHD2A": [
    "FAHD2A cnv",
    "FAHD2A methyl",
    "FAHD2A proteo",
    "FAHD2A rna"
  ],
  "FAHD2B": [
    "FAHD2B cnv",
    "FAHD2B methyl",
    "FAHD2B proteo",
    "FAHD2B rna"
  ],
  "FAIM": [
    "FAIM cnv",
    "FAIM methyl",
    "FAIM proteo",
    "FAIM rna"
  ],
  "FAIM2": [
    "FAIM2 cnv",
    "FAIM2 methyl",
    "FAIM2 proteo",
    "FAIM2 rna"
  ],
  "FALEC": [
    "FALEC methyl"
  ],
  "FAM102A": [
    "FAM102A 249_256_1_1_S251 phospho",
    "FAM102A cnv",
    "FAM102A methyl",
    "FAM102A proteo",
    "FAM102A rna"
  ],
  "FAM102B": [
    "FAM102B 191_204_1_1_S193 phospho",
    "FAM102B 206_214_1_1_S208 phospho",
    "FAM102B 217_224_1_1_S224 phospho",
    "FAM102B 226_230_1_1_S228 phospho",
    "FAM102B cnv",
    "FAM102B methyl",
    "FAM102B proteo",
    "FAM102B rna"
  ],
  "FAM104A": [
    "FAM104A 10_27_1_1_S21 phospho",
    "FAM104A cnv",
    "FAM104A methyl",
    "FAM104A rna"
  ],
  "FAM104B": [
    "FAM104B methyl",
    "FAM104B rna"
  ],
  "FAM107A": [
    "FAM107A 19_19_1_1_S19 phospho",
    "FAM107A 74_74_1_1_S74 phospho",
    "FAM107A cnv",
    "FAM107A methyl",
    "FAM107A proteo",
    "FAM107A rna"
  ],
  "FAM107B": [
    "FAM107B cnv",
    "FAM107B methyl",
    "FAM107B proteo",
    "FAM107B rna"
  ],
  "FAM110A": [
    "FAM110A cnv",
    "FAM110A methyl",
    "FAM110A rna"
  ],
  "FAM110B": [
    "FAM110B 127_135_1_1_S131 phospho",
    "FAM110B 149_162_1_1_S158 phospho",
    "FAM110B 173_179_1_1_S173 phospho",
    "FAM110B 189_201_1_1_S199 phospho",
    "FAM110B 301_305_1_1_S301 phospho",
    "FAM110B cnv",
    "FAM110B methyl",
    "FAM110B proteo",
    "FAM110B rna"
  ],
  "FAM110C": [
    "FAM110C 238_245_1_1_S241 phospho",
    "FAM110C cnv",
    "FAM110C methyl",
    "FAM110C rna"
  ],
  "FAM110D": [
    "FAM110D cnv",
    "FAM110D rna"
  ],
  "FAM111A": [
    "FAM111A cnv",
    "FAM111A methyl",
    "FAM111A rna"
  ],
  "FAM111A-DT": [
    "FAM111A-DT methyl"
  ],
  "FAM111B": [
    "FAM111B cnv",
    "FAM111B methyl",
    "FAM111B rna"
  ],
  "FAM114A1": [
    "FAM114A1 cnv",
    "FAM114A1 methyl",
    "FAM114A1 proteo",
    "FAM114A1 rna"
  ],
  "FAM114A2": [
    "FAM114A2 145_165_1_1_S146 phospho",
    "FAM114A2 cnv",
    "FAM114A2 methyl",
    "FAM114A2 proteo",
    "FAM114A2 rna"
  ],
  "FAM117A": [
    "FAM117A 143_149_1_1_S145 phospho",
    "FAM117A 29_36_1_1_S29 phospho",
    "FAM117A 67_71_1_1_S67 phospho",
    "FAM117A cnv",
    "FAM117A methyl",
    "FAM117A rna"
  ],
  "FAM117B": [
    "FAM117B 105_120_1_0 phospho",
    "FAM117B 105_120_1_1_S106 phospho",
    "FAM117B 10_30_1_1_S10 phospho",
    "FAM117B 218_228_1_1_S220 phospho",
    "FAM117B 271_277_1_0 phospho",
    "FAM117B 271_277_1_1_S273 phospho",
    "FAM117B 449_449_1_1_S449 phospho",
    "FAM117B 454_464_1_1_S457 phospho",
    "FAM117B cnv",
    "FAM117B methyl",
    "FAM117B proteo",
    "FAM117B rna"
  ],
  "FAM118A": [
    "FAM118A 311_321_1_1_S311 phospho",
    "FAM118A cnv",
    "FAM118A methyl",
    "FAM118A proteo",
    "FAM118A rna"
  ],
  "FAM118B": [
    "FAM118B cnv",
    "FAM118B methyl",
    "FAM118B proteo",
    "FAM118B rna"
  ],
  "FAM120A": [
    "FAM120A cnv",
    "FAM120A methyl",
    "FAM120A proteo",
    "FAM120A rna"
  ],
  "FAM120AOS": [
    "FAM120AOS cnv",
    "FAM120AOS methyl",
    "FAM120AOS rna"
  ],
  "FAM120B": [
    "FAM120B 875_875_1_1_S875 phospho",
    "FAM120B cnv",
    "FAM120B methyl",
    "FAM120B proteo",
    "FAM120B rna"
  ],
  "FAM120C": [
    "FAM120C methyl",
    "FAM120C proteo",
    "FAM120C rna"
  ],
  "FAM124A": [
    "FAM124A cnv",
    "FAM124A methyl",
    "FAM124A rna"
  ],
  "FAM124B": [
    "FAM124B cnv",
    "FAM124B rna"
  ],
  "FAM126A": [
    "FAM126A 427_439_1_1_S433 phospho",
    "FAM126A 453_476_1_1_S453 phospho",
    "FAM126A 482_485_1_1_S485 phospho",
    "FAM126A cnv",
    "FAM126A methyl",
    "FAM126A proteo",
    "FAM126A rna"
  ],
  "FAM126B": [
    "FAM126B 564_570_1_1_S564 phospho",
    "FAM126B 575_584_1_1_S577 phospho",
    "FAM126B cnv",
    "FAM126B methyl",
    "FAM126B proteo",
    "FAM126B rna"
  ],
  "FAM131A": [
    "FAM131A cnv",
    "FAM131A methyl",
    "FAM131A rna"
  ],
  "FAM131B": [
    "FAM131B 122_133_1_1_S130 phospho",
    "FAM131B 138_145_1_1_S145 phospho",
    "FAM131B 341_350_1_1_S341 phospho",
    "FAM131B 341_350_1_1_S350 phospho",
    "FAM131B 75_78_1_1_S75 phospho",
    "FAM131B cnv",
    "FAM131B methyl",
    "FAM131B proteo",
    "FAM131B rna"
  ],
  "FAM131C": [
    "FAM131C cnv",
    "FAM131C rna"
  ],
  "FAM133A": [
    "FAM133A methyl",
    "FAM133A rna"
  ],
  "FAM133B": [
    "FAM133B 231_236_1_1_S236 phospho",
    "FAM133B cnv",
    "FAM133B methyl",
    "FAM133B rna"
  ],
  "FAM135A": [
    "FAM135A cnv",
    "FAM135A methyl",
    "FAM135A proteo",
    "FAM135A rna"
  ],
  "FAM135A-AS1": [
    "FAM135A-AS1 methyl"
  ],
  "FAM135B": [
    "FAM135B cnv",
    "FAM135B methyl",
    "FAM135B rna"
  ],
  "FAM136A": [
    "FAM136A cnv",
    "FAM136A methyl",
    "FAM136A proteo",
    "FAM136A rna"
  ],
  "FAM13A": [
    "FAM13A 589_597_1_1_S597 phospho",
    "FAM13A 650_669_1_1_S652 phospho",
    "FAM13A cnv",
    "FAM13A methyl",
    "FAM13A proteo",
    "FAM13A rna"
  ],
  "FAM13B": [
    "FAM13B cnv",
    "FAM13B rna"
  ],
  "FAM13C": [
    "FAM13C 126_131_1_1_S131 phospho",
    "FAM13C cnv",
    "FAM13C methyl",
    "FAM13C rna"
  ],
  "FAM149A": [
    "FAM149A cnv",
    "FAM149A methyl",
    "FAM149A rna"
  ],
  "FAM149B1": [
    "FAM149B1 cnv",
    "FAM149B1 methyl",
    "FAM149B1 rna"
  ],
  "FAM151A": [
    "FAM151A cnv",
    "FAM151A rna"
  ],
  "FAM151B": [
    "FAM151B cnv",
    "FAM151B methyl",
    "FAM151B rna"
  ],
  "FAM153A": [
    "FAM153A cnv",
    "FAM153A methyl",
    "FAM153A rna"
  ],
  "FAM153B": [
    "FAM153B cnv",
    "FAM153B methyl",
    "FAM153B rna"
  ],
  "FAM153CP": [
    "FAM153CP methyl"
  ],
  "FAM156A": [
    "FAM156A methyl",
    "FAM156A rna"
  ],
  "FAM156B": [
    "FAM156B rna"
  ],
  "FAM161A": [
    "FAM161A cnv",
    "FAM161A methyl",
    "FAM161A rna"
  ],
  "FAM161B": [
    "FAM161B cnv",
    "FAM161B methyl",
    "FAM161B rna"
  ],
  "FAM162A": [
    "FAM162A cnv",
    "FAM162A methyl",
    "FAM162A proteo",
    "FAM162A rna"
  ],
  "FAM162B": [
    "FAM162B cnv",
    "FAM162B methyl",
    "FAM162B rna"
  ],
  "FAM163A": [
    "FAM163A cnv",
    "FAM163A rna"
  ],
  "FAM163B": [
    "FAM163B cnv",
    "FAM163B methyl",
    "FAM163B rna"
  ],
  "FAM166A": [
    "FAM166A cnv",
    "FAM166A rna"
  ],
  "FAM166B": [
    "FAM166B cnv",
    "FAM166B rna"
  ],
  "FAM166C": [
    "FAM166C cnv",
    "FAM166C methyl",
    "FAM166C rna"
  ],
  "FAM167A": [
    "FAM167A cnv",
    "FAM167A methyl",
    "FAM167A proteo",
    "FAM167A rna"
  ],
  "FAM167B": [
    "FAM167B cnv",
    "FAM167B rna"
  ],
  "FAM168A": [
    "FAM168A cnv",
    "FAM168A methyl",
    "FAM168A proteo",
    "FAM168A rna"
  ],
  "FAM168B": [
    "FAM168B 62_85_1_1_S64 phospho",
    "FAM168B cnv",
    "FAM168B methyl",
    "FAM168B proteo",
    "FAM168B rna"
  ],
  "FAM169A": [
    "FAM169A 278_289_1_1_S278 phospho",
    "FAM169A 345_350_1_1_S350 phospho",
    "FAM169A 371_379_1_1_S378 phospho",
    "FAM169A 371_379_2_2_S378S379 phospho",
    "FAM169A 398_409_1_1_S399 phospho",
    "FAM169A 526_534_1_0 phospho",
    "FAM169A 611_628_1_1_S619 phospho",
    "FAM169A 611_628_2_2_S615S619 phospho",
    "FAM169A 635_637_2_2_S635S636 phospho",
    "FAM169A cnv",
    "FAM169A methyl",
    "FAM169A proteo",
    "FAM169A rna"
  ],
  "FAM169B": [
    "FAM169B cnv",
    "FAM169B rna"
  ],
  "FAM170A": [
    "FAM170A cnv",
    "FAM170A rna"
  ],
  "FAM170B": [
    "FAM170B cnv",
    "FAM170B rna"
  ],
  "FAM171A1": [
    "FAM171A1 356_367_1_1_S358 phospho",
    "FAM171A1 371_390_1_1_S371 phospho",
    "FAM171A1 440_452_1_1_T448 phospho",
    "FAM171A1 514_525_1_1_S525 phospho",
    "FAM171A1 716_724_1_0 phospho",
    "FAM171A1 824_836_1_1_S824 phospho",
    "FAM171A1 839_849_1_1_S849 phospho",
    "FAM171A1 855_855_1_1_S855 phospho",
    "FAM171A1 cnv",
    "FAM171A1 methyl",
    "FAM171A1 proteo",
    "FAM171A1 rna"
  ],
  "FAM171A2": [
    "FAM171A2 ASVDVFGNR-N2H4F0S0G0 glyco",
    "FAM171A2 ASVDVFGNR-N2H5F0S0G0 glyco",
    "FAM171A2 cnv",
    "FAM171A2 methyl",
    "FAM171A2 proteo",
    "FAM171A2 rna"
  ],
  "FAM171B": [
    "FAM171B 403_414_1_0 phospho",
    "FAM171B 403_414_1_1_S405 phospho",
    "FAM171B 502_504_1_1_S504 phospho",
    "FAM171B 583_585_1_1_T585 phospho",
    "FAM171B 688_688_1_1_S688 phospho",
    "FAM171B 768_779_1_1_S779 phospho",
    "FAM171B 784_796_1_1_S794 phospho",
    "FAM171B TNSTVTK-N2H5F0S0G0 glyco",
    "FAM171B cnv",
    "FAM171B methyl",
    "FAM171B proteo",
    "FAM171B rna"
  ],
  "FAM172A": [
    "FAM172A 169_174_1_1_S170 phospho",
    "FAM172A 169_174_1_1_S173 phospho",
    "FAM172A cnv",
    "FAM172A methyl",
    "FAM172A proteo",
    "FAM172A rna"
  ],
  "FAM174A": [
    "FAM174A cnv",
    "FAM174A methyl",
    "FAM174A rna"
  ],
  "FAM174B": [
    "FAM174B cnv",
    "FAM174B methyl",
    "FAM174B rna"
  ],
  "FAM174C": [
    "FAM174C cnv",
    "FAM174C methyl",
    "FAM174C rna"
  ],
  "FAM177A1": [
    "FAM177A1 cnv",
    "FAM177A1 methyl",
    "FAM177A1 proteo",
    "FAM177A1 rna"
  ],
  "FAM177B": [
    "FAM177B cnv",
    "FAM177B rna"
  ],
  "FAM178B": [
    "FAM178B cnv",
    "FAM178B methyl",
    "FAM178B rna"
  ],
  "FAM180A": [
    "FAM180A cnv",
    "FAM180A rna"
  ],
  "FAM180B": [
    "FAM180B cnv",
    "FAM180B rna"
  ],
  "FAM181A": [
    "FAM181A cnv",
    "FAM181A rna"
  ],
  "FAM181B": [
    "FAM181B 320_332_1_1_S330 phospho",
    "FAM181B cnv",
    "FAM181B methyl",
    "FAM181B rna"
  ],
  "FAM183A": [
    "FAM183A cnv",
    "FAM183A methyl",
    "FAM183A rna"
  ],
  "FAM184A": [
    "FAM184A cnv",
    "FAM184A methyl",
    "FAM184A rna"
  ],
  "FAM184B": [
    "FAM184B 1048_1055_1_1_S1048 phospho",
    "FAM184B 976_983_1_1_S976 phospho",
    "FAM184B cnv",
    "FAM184B methyl",
    "FAM184B proteo",
    "FAM184B rna"
  ],
  "FAM185A": [
    "FAM185A cnv",
    "FAM185A methyl",
    "FAM185A proteo",
    "FAM185A rna"
  ],
  "FAM186A": [
    "FAM186A cnv",
    "FAM186A rna"
  ],
  "FAM186B": [
    "FAM186B cnv",
    "FAM186B rna"
  ],
  "FAM187A": [
    "FAM187A cnv",
    "FAM187A rna"
  ],
  "FAM187B": [
    "FAM187B cnv",
    "FAM187B rna"
  ],
  "FAM193A": [
    "FAM193A 1120_1137_1_1_S1129 phospho",
    "FAM193A 1144_1144_1_1_S1144 phospho",
    "FAM193A 283_302_1_1_S293 phospho",
    "FAM193A 381_383_1_1_S383 phospho",
    "FAM193A cnv",
    "FAM193A methyl",
    "FAM193A proteo",
    "FAM193A rna"
  ],
  "FAM193B": [
    "FAM193B cnv",
    "FAM193B methyl",
    "FAM193B rna"
  ],
  "FAM197Y3": [
    "FAM197Y3 methyl"
  ],
  "FAM197Y5": [
    "FAM197Y5 methyl"
  ],
  "FAM197Y6": [
    "FAM197Y6 methyl"
  ],
  "FAM197Y8": [
    "FAM197Y8 methyl"
  ],
  "FAM197Y9": [
    "FAM197Y9 methyl"
  ],
  "FAM199X": [
    "FAM199X 316_323_1_1_S316 phospho",
    "FAM199X 316_323_2_2_S316S321 phospho",
    "FAM199X methyl",
    "FAM199X rna"
  ],
  "FAM200A": [
    "FAM200A cnv",
    "FAM200A methyl",
    "FAM200A rna"
  ],
  "FAM200B": [
    "FAM200B cnv",
    "FAM200B methyl",
    "FAM200B rna"
  ],
  "FAM204A": [
    "FAM204A cnv",
    "FAM204A methyl",
    "FAM204A rna"
  ],
  "FAM205A": [
    "FAM205A cnv",
    "FAM205A rna"
  ],
  "FAM205C": [
    "FAM205C cnv",
    "FAM205C rna"
  ],
  "FAM209A": [
    "FAM209A cnv",
    "FAM209A rna"
  ],
  "FAM209B": [
    "FAM209B cnv",
    "FAM209B rna"
  ],
  "FAM20A": [
    "FAM20A cnv",
    "FAM20A methyl",
    "FAM20A rna"
  ],
  "FAM20B": [
    "FAM20B cnv",
    "FAM20B methyl",
    "FAM20B proteo",
    "FAM20B rna"
  ],
  "FAM20C": [
    "FAM20C cnv",
    "FAM20C methyl",
    "FAM20C proteo",
    "FAM20C rna"
  ],
  "FAM210A": [
    "FAM210A cnv",
    "FAM210A methyl",
    "FAM210A proteo",
    "FAM210A rna"
  ],
  "FAM210B": [
    "FAM210B cnv",
    "FAM210B methyl",
    "FAM210B proteo",
    "FAM210B rna"
  ],
  "FAM214A": [
    "FAM214A cnv",
    "FAM214A methyl",
    "FAM214A rna"
  ],
  "FAM214B": [
    "FAM214B 268_278_1_1_S268 phospho",
    "FAM214B cnv",
    "FAM214B methyl",
    "FAM214B rna"
  ],
  "FAM216A": [
    "FAM216A cnv",
    "FAM216A methyl",
    "FAM216A rna"
  ],
  "FAM216B": [
    "FAM216B cnv",
    "FAM216B rna"
  ],
  "FAM217A": [
    "FAM217A cnv",
    "FAM217A methyl",
    "FAM217A rna"
  ],
  "FAM217B": [
    "FAM217B cnv",
    "FAM217B methyl",
    "FAM217B rna"
  ],
  "FAM218A": [
    "FAM218A methyl"
  ],
  "FAM219A": [
    "FAM219A cnv",
    "FAM219A methyl",
    "FAM219A proteo",
    "FAM219A rna"
  ],
  "FAM219B": [
    "FAM219B cnv",
    "FAM219B methyl",
    "FAM219B proteo",
    "FAM219B rna"
  ],
  "FAM21EP": [
    "FAM21EP methyl"
  ],
  "FAM220A": [
    "FAM220A cnv",
    "FAM220A methyl",
    "FAM220A rna"
  ],
  "FAM221A": [
    "FAM221A cnv",
    "FAM221A methyl",
    "FAM221A proteo",
    "FAM221A rna"
  ],
  "FAM221B": [
    "FAM221B cnv",
    "FAM221B methyl",
    "FAM221B rna"
  ],
  "FAM222A": [
    "FAM222A cnv",
    "FAM222A methyl",
    "FAM222A rna"
  ],
  "FAM222B": [
    "FAM222B cnv",
    "FAM222B methyl",
    "FAM222B rna"
  ],
  "FAM227A": [
    "FAM227A cnv",
    "FAM227A methyl",
    "FAM227A rna"
  ],
  "FAM227B": [
    "FAM227B cnv",
    "FAM227B methyl",
    "FAM227B rna"
  ],
  "FAM228A": [
    "FAM228A cnv",
    "FAM228A methyl",
    "FAM228A rna"
  ],
  "FAM228B": [
    "FAM228B cnv",
    "FAM228B methyl",
    "FAM228B rna"
  ],
  "FAM229A": [
    "FAM229A cnv",
    "FAM229A methyl",
    "FAM229A rna"
  ],
  "FAM229B": [
    "FAM229B cnv",
    "FAM229B methyl",
    "FAM229B rna"
  ],
  "FAM234A": [
    "FAM234A 21_29_1_1_S21 phospho",
    "FAM234A cnv",
    "FAM234A methyl",
    "FAM234A proteo",
    "FAM234A rna"
  ],
  "FAM234B": [
    "FAM234B 52_84_1_1_S62 phospho",
    "FAM234B MLSAFNATSGK-N2H5F0S0G0 glyco",
    "FAM234B MLSAFNATSGK-N2H6F0S0G0 glyco",
    "FAM234B MLSAFNATSGK-N2H7F0S0G0 glyco",
    "FAM234B cnv",
    "FAM234B methyl",
    "FAM234B proteo",
    "FAM234B rna"
  ],
  "FAM236A": [
    "FAM236A rna"
  ],
  "FAM237A": [
    "FAM237A cnv",
    "FAM237A methyl",
    "FAM237A rna"
  ],
  "FAM237B": [
    "FAM237B cnv",
    "FAM237B methyl",
    "FAM237B rna"
  ],
  "FAM240A": [
    "FAM240A cnv",
    "FAM240A rna"
  ],
  "FAM240B": [
    "FAM240B cnv",
    "FAM240B rna"
  ],
  "FAM240C": [
    "FAM240C cnv",
    "FAM240C methyl",
    "FAM240C rna"
  ],
  "FAM241A": [
    "FAM241A cnv",
    "FAM241A methyl",
    "FAM241A rna"
  ],
  "FAM241B": [
    "FAM241B cnv",
    "FAM241B methyl",
    "FAM241B proteo",
    "FAM241B rna"
  ],
  "FAM243B": [
    "FAM243B cnv",
    "FAM243B rna"
  ],
  "FAM246A": [
    "FAM246A cnv",
    "FAM246A rna"
  ],
  "FAM246B": [
    "FAM246B cnv",
    "FAM246B rna"
  ],
  "FAM246C": [
    "FAM246C cnv",
    "FAM246C rna"
  ],
  "FAM24A": [
    "FAM24A cnv"
  ],
  "FAM24B": [
    "FAM24B cnv",
    "FAM24B methyl",
    "FAM24B rna"
  ],
  "FAM25A": [
    "FAM25A cnv"
  ],
  "FAM25C": [
    "FAM25C cnv"
  ],
  "FAM25G": [
    "FAM25G cnv"
  ],
  "FAM32A": [
    "FAM32A cnv",
    "FAM32A proteo",
    "FAM32A rna"
  ],
  "FAM3A": [
    "FAM3A methyl",
    "FAM3A proteo",
    "FAM3A rna"
  ],
  "FAM3B": [
    "FAM3B cnv",
    "FAM3B methyl",
    "FAM3B rna"
  ],
  "FAM3C": [
    "FAM3C cnv",
    "FAM3C methyl",
    "FAM3C proteo",
    "FAM3C rna"
  ],
  "FAM3D": [
    "FAM3D cnv",
    "FAM3D rna"
  ],
  "FAM41C": [
    "FAM41C methyl"
  ],
  "FAM43A": [
    "FAM43A cnv",
    "FAM43A methyl",
    "FAM43A rna"
  ],
  "FAM43B": [
    "FAM43B cnv",
    "FAM43B methyl",
    "FAM43B rna"
  ],
  "FAM47C": [
    "FAM47C methyl",
    "FAM47C rna"
  ],
  "FAM47E": [
    "FAM47E cnv",
    "FAM47E methyl",
    "FAM47E rna"
  ],
  "FAM47E-STBD1": [
    "FAM47E-STBD1 cnv",
    "FAM47E-STBD1 methyl",
    "FAM47E-STBD1 rna"
  ],
  "FAM50A": [
    "FAM50A methyl",
    "FAM50A proteo",
    "FAM50A rna"
  ],
  "FAM50B": [
    "FAM50B cnv",
    "FAM50B rna"
  ],
  "FAM53A": [
    "FAM53A cnv",
    "FAM53A methyl",
    "FAM53A rna"
  ],
  "FAM53B": [
    "FAM53B 178_179_1_1_S179 phospho",
    "FAM53B 268_268_1_1_S268 phospho",
    "FAM53B cnv",
    "FAM53B methyl",
    "FAM53B rna"
  ],
  "FAM53C": [
    "FAM53C 150_162_1_1_S162 phospho",
    "FAM53C 232_242_1_1_S232 phospho",
    "FAM53C 232_242_2_2_S232S234 phospho",
    "FAM53C 271_273_1_1_S273 phospho",
    "FAM53C 273_273_1_1_S273 phospho",
    "FAM53C 299_299_1_1_S299 phospho",
    "FAM53C cnv",
    "FAM53C methyl",
    "FAM53C proteo",
    "FAM53C rna"
  ],
  "FAM72A": [
    "FAM72A cnv",
    "FAM72A methyl",
    "FAM72A rna"
  ],
  "FAM72B": [
    "FAM72B cnv",
    "FAM72B rna"
  ],
  "FAM72C": [
    "FAM72C cnv",
    "FAM72C methyl",
    "FAM72C rna"
  ],
  "FAM72D": [
    "FAM72D cnv",
    "FAM72D rna"
  ],
  "FAM76A": [
    "FAM76A cnv",
    "FAM76A methyl",
    "FAM76A proteo",
    "FAM76A rna"
  ],
  "FAM76B": [
    "FAM76B 190_193_1_1_S193 phospho",
    "FAM76B 207_215_1_1_T215 phospho",
    "FAM76B cnv",
    "FAM76B methyl",
    "FAM76B proteo",
    "FAM76B rna"
  ],
  "FAM78A": [
    "FAM78A cnv",
    "FAM78A methyl",
    "FAM78A rna"
  ],
  "FAM78B": [
    "FAM78B cnv",
    "FAM78B methyl",
    "FAM78B rna"
  ],
  "FAM81A": [
    "FAM81A cnv",
    "FAM81A methyl",
    "FAM81A proteo",
    "FAM81A rna"
  ],
  "FAM81B": [
    "FAM81B cnv",
    "FAM81B rna"
  ],
  "FAM83A": [
    "FAM83A cnv",
    "FAM83A rna"
  ],
  "FAM83B": [
    "FAM83B cnv",
    "FAM83B methyl",
    "FAM83B rna"
  ],
  "FAM83C": [
    "FAM83C cnv",
    "FAM83C methyl",
    "FAM83C rna"
  ],
  "FAM83C-AS1": [
    "FAM83C-AS1 methyl"
  ],
  "FAM83D": [
    "FAM83D 456_465_1_1_S462 phospho",
    "FAM83D cnv",
    "FAM83D methyl",
    "FAM83D rna"
  ],
  "FAM83E": [
    "FAM83E cnv",
    "FAM83E methyl",
    "FAM83E rna"
  ],
  "FAM83F": [
    "FAM83F cnv",
    "FAM83F methyl",
    "FAM83F rna"
  ],
  "FAM83G": [
    "FAM83G 356_356_1_1_S356 phospho",
    "FAM83G cnv",
    "FAM83G methyl",
    "FAM83G rna"
  ],
  "FAM83H": [
    "FAM83H cnv",
    "FAM83H methyl",
    "FAM83H rna"
  ],
  "FAM86B1": [
    "FAM86B1 cnv",
    "FAM86B1 methyl",
    "FAM86B1 rna"
  ],
  "FAM86B2": [
    "FAM86B2 cnv",
    "FAM86B2 methyl",
    "FAM86B2 rna"
  ],
  "FAM86B3P": [
    "FAM86B3P methyl"
  ],
  "FAM86C2P": [
    "FAM86C2P methyl"
  ],
  "FAM86DP": [
    "FAM86DP methyl"
  ],
  "FAM86EP": [
    "FAM86EP methyl"
  ],
  "FAM86JP": [
    "FAM86JP methyl"
  ],
  "FAM89A": [
    "FAM89A cnv",
    "FAM89A methyl",
    "FAM89A rna"
  ],
  "FAM89B": [
    "FAM89B cnv",
    "FAM89B methyl",
    "FAM89B proteo",
    "FAM89B rna"
  ],
  "FAM8A1": [
    "FAM8A1 212_212_1_1_S212 phospho",
    "FAM8A1 cnv",
    "FAM8A1 methyl",
    "FAM8A1 proteo",
    "FAM8A1 rna"
  ],
  "FAM90A1": [
    "FAM90A1 cnv",
    "FAM90A1 rna"
  ],
  "FAM90A10": [
    "FAM90A10 cnv"
  ],
  "FAM90A14": [
    "FAM90A14 cnv"
  ],
  "FAM90A16": [
    "FAM90A16 cnv",
    "FAM90A16 rna"
  ],
  "FAM90A17": [
    "FAM90A17 cnv",
    "FAM90A17 rna"
  ],
  "FAM90A18": [
    "FAM90A18 cnv"
  ],
  "FAM90A19": [
    "FAM90A19 cnv"
  ],
  "FAM90A22": [
    "FAM90A22 cnv"
  ],
  "FAM90A23": [
    "FAM90A23 cnv"
  ],
  "FAM90A26": [
    "FAM90A26 cnv"
  ],
  "FAM90A7": [
    "FAM90A7 cnv",
    "FAM90A7 rna"
  ],
  "FAM90A8": [
    "FAM90A8 cnv"
  ],
  "FAM90A9": [
    "FAM90A9 cnv"
  ],
  "FAM91A1": [
    "FAM91A1 cnv",
    "FAM91A1 methyl",
    "FAM91A1 proteo",
    "FAM91A1 rna"
  ],
  "FAM95C": [
    "FAM95C cnv",
    "FAM95C rna"
  ],
  "FAM98A": [
    "FAM98A cnv",
    "FAM98A methyl",
    "FAM98A proteo",
    "FAM98A rna"
  ],
  "FAM98B": [
    "FAM98B cnv",
    "FAM98B methyl",
    "FAM98B proteo",
    "FAM98B rna"
  ],
  "FAM98C": [
    "FAM98C cnv",
    "FAM98C methyl",
    "FAM98C proteo",
    "FAM98C rna"
  ],
  "FAM9A": [
    "FAM9A methyl",
    "FAM9A rna"
  ],
  "FAM9B": [
    "FAM9B rna"
  ],
  "FAM9C": [
    "FAM9C rna"
  ],
  "FAN1": [
    "FAN1 cnv",
    "FAN1 methyl",
    "FAN1 rna"
  ],
  "FANCA": [
    "FANCA cnv",
    "FANCA methyl",
    "FANCA rna"
  ],
  "FANCB": [
    "FANCB methyl",
    "FANCB rna"
  ],
  "FANCC": [
    "FANCC cnv",
    "FANCC methyl",
    "FANCC rna"
  ],
  "FANCD2": [
    "FANCD2 1401_1421_1_1_S1412 phospho",
    "FANCD2 cnv",
    "FANCD2 methyl",
    "FANCD2 proteo",
    "FANCD2 rna"
  ],
  "FANCD2OS": [
    "FANCD2OS cnv",
    "FANCD2OS methyl",
    "FANCD2OS rna"
  ],
  "FANCE": [
    "FANCE cnv",
    "FANCE methyl",
    "FANCE rna"
  ],
  "FANCF": [
    "FANCF cnv",
    "FANCF methyl",
    "FANCF rna"
  ],
  "FANCG": [
    "FANCG cnv",
    "FANCG methyl",
    "FANCG rna"
  ],
  "FANCI": [
    "FANCI cnv",
    "FANCI methyl",
    "FANCI proteo",
    "FANCI rna"
  ],
  "FANCL": [
    "FANCL cnv",
    "FANCL methyl",
    "FANCL rna"
  ],
  "FANCM": [
    "FANCM cnv",
    "FANCM methyl",
    "FANCM rna"
  ],
  "FANK1": [
    "FANK1 cnv",
    "FANK1 methyl",
    "FANK1 rna"
  ],
  "FAP": [
    "FAP cnv",
    "FAP proteo",
    "FAP rna"
  ],
  "FAR1": [
    "FAR1 cnv",
    "FAR1 methyl",
    "FAR1 proteo",
    "FAR1 rna"
  ],
  "FAR2": [
    "FAR2 cnv",
    "FAR2 methyl",
    "FAR2 rna"
  ],
  "FARP1": [
    "FARP1 20_24_1_1_S20 phospho",
    "FARP1 20_24_1_1_T24 phospho",
    "FARP1 34_36_1_1_T34 phospho",
    "FARP1 373_408_1_1_S403 phospho",
    "FARP1 418_427_1_1_S418 phospho",
    "FARP1 418_427_1_1_S427 phospho",
    "FARP1 418_433_1_1_S433 phospho",
    "FARP1 418_433_2_2_S427S433 phospho",
    "FARP1 433_433_1_1_S433 phospho",
    "FARP1 459_506_1_0 phospho",
    "FARP1 510_514_1_1_S510 phospho",
    "FARP1 613_613_1_1_S613 phospho",
    "FARP1 892_903_1_1_S894 phospho",
    "FARP1 892_903_1_1_S903 phospho",
    "FARP1 909_927_1_1_S920 phospho",
    "FARP1 cnv",
    "FARP1 methyl",
    "FARP1 proteo",
    "FARP1 rna"
  ],
  "FARP2": [
    "FARP2 425_439_1_1_S439 phospho",
    "FARP2 876_886_1_1_S886 phospho",
    "FARP2 cnv",
    "FARP2 methyl",
    "FARP2 proteo",
    "FARP2 rna"
  ],
  "FARS2": [
    "FARS2 cnv",
    "FARS2 methyl",
    "FARS2 proteo",
    "FARS2 rna"
  ],
  "FARSA": [
    "FARSA 299_310_1_1_S301 phospho",
    "FARSA cnv",
    "FARSA methyl",
    "FARSA proteo",
    "FARSA rna"
  ],
  "FARSB": [
    "FARSB cnv",
    "FARSB methyl",
    "FARSB proteo",
    "FARSB rna"
  ],
  "FAS": [
    "FAS cnv",
    "FAS methyl",
    "FAS proteo",
    "FAS rna"
  ],
  "FASLG": [
    "FASLG cnv",
    "FASLG rna"
  ],
  "FASN": [
    "FASN 1174_1174_1_1_S1174 phospho",
    "FASN 1407_1421_1_1_S1411 phospho",
    "FASN 207_211_1_1_S207 phospho",
    "FASN 2198_2204_1_1_T2204 phospho",
    "FASN 2198_2215_1_1_T2204 phospho",
    "FASN 2236_2262_1_1_S2236 phospho",
    "FASN 714_725_1_1_S725 phospho",
    "FASN cnv",
    "FASN methyl",
    "FASN proteo",
    "FASN rna"
  ],
  "FASTK": [
    "FASTK cnv",
    "FASTK kinase",
    "FASTK methyl",
    "FASTK rna"
  ],
  "FASTKD1": [
    "FASTKD1 cnv",
    "FASTKD1 rna"
  ],
  "FASTKD2": [
    "FASTKD2 cnv",
    "FASTKD2 methyl",
    "FASTKD2 proteo",
    "FASTKD2 rna"
  ],
  "FASTKD3": [
    "FASTKD3 cnv",
    "FASTKD3 methyl",
    "FASTKD3 rna"
  ],
  "FASTKD5": [
    "FASTKD5 cnv",
    "FASTKD5 methyl",
    "FASTKD5 proteo",
    "FASTKD5 rna"
  ],
  "FAT1": [
    "FAT1 TGALTVQNTTQLR-N2H5F0S0G0 glyco",
    "FAT1 TGALTVQNTTQLR-N2H6F0S0G0 glyco",
    "FAT1 TGALTVQNTTQLR-N2H7F0S0G0 glyco",
    "FAT1 cnv",
    "FAT1 methyl",
    "FAT1 proteo",
    "FAT1 rna"
  ],
  "FAT2": [
    "FAT2 cnv",
    "FAT2 rna"
  ],
  "FAT3": [
    "FAT3 4264_4270_1_1_S4270 phospho",
    "FAT3 YVLNVSVSDGR-N2H5F0S0G0 glyco",
    "FAT3 cnv",
    "FAT3 methyl",
    "FAT3 proteo",
    "FAT3 rna"
  ],
  "FAT4": [
    "FAT4 YQNVTGFSNVNINR-N2H5F0S0G0 glyco",
    "FAT4 cnv",
    "FAT4 methyl",
    "FAT4 rna"
  ],
  "FATE1": [
    "FATE1 rna"
  ],
  "FAU": [
    "FAU cnv",
    "FAU methyl",
    "FAU proteo",
    "FAU rna"
  ],
  "FAXC": [
    "FAXC cnv",
    "FAXC methyl",
    "FAXC rna"
  ],
  "FAXDC2": [
    "FAXDC2 cnv",
    "FAXDC2 rna"
  ],
  "FBF1": [
    "FBF1 cnv",
    "FBF1 methyl",
    "FBF1 proteo",
    "FBF1 rna"
  ],
  "FBH1": [
    "FBH1 cnv",
    "FBH1 methyl",
    "FBH1 proteo",
    "FBH1 rna"
  ],
  "FBL": [
    "FBL 124_126_1_1_S124 phospho",
    "FBL cnv",
    "FBL methyl",
    "FBL proteo",
    "FBL rna"
  ],
  "FBLIM1": [
    "FBLIM1 cnv",
    "FBLIM1 methyl",
    "FBLIM1 proteo",
    "FBLIM1 rna"
  ],
  "FBLL1": [
    "FBLL1 cnv",
    "FBLL1 methyl",
    "FBLL1 proteo",
    "FBLL1 rna"
  ],
  "FBLN1": [
    "FBLN1 CATPHGDNASLEATFVK-N4H5F1S1G0 glyco",
    "FBLN1 CATPHGDNASLEATFVK-N4H5F1S2G0 glyco",
    "FBLN1 CATPHGDNASLEATFVK-N5H6F1S3G0 glyco",
    "FBLN1 cnv",
    "FBLN1 methyl",
    "FBLN1 proteo",
    "FBLN1 rna"
  ],
  "FBLN2": [
    "FBLN2 274_277_1_1_S277 phospho",
    "FBLN2 cnv",
    "FBLN2 methyl",
    "FBLN2 proteo",
    "FBLN2 rna"
  ],
  "FBLN5": [
    "FBLN5 cnv",
    "FBLN5 methyl",
    "FBLN5 proteo",
    "FBLN5 rna"
  ],
  "FBLN7": [
    "FBLN7 cnv",
    "FBLN7 methyl",
    "FBLN7 proteo",
    "FBLN7 rna"
  ],
  "FBN1": [
    "FBN1 2702_2716_1_1_S2702 phospho",
    "FBN1 AWGTPCEMCPAVNTSEYK-N4H5F1S1G0 glyco",
    "FBN1 VLPVNVTDYCQLVR-N4H5F1S0G0 glyco",
    "FBN1 VLPVNVTDYCQLVR-N5H3F1S0G0 glyco",
    "FBN1 cnv",
    "FBN1 methyl",
    "FBN1 proteo",
    "FBN1 rna"
  ],
  "FBN2": [
    "FBN2 cnv",
    "FBN2 methyl",
    "FBN2 proteo",
    "FBN2 rna"
  ],
  "FBN3": [
    "FBN3 cnv",
    "FBN3 methyl",
    "FBN3 rna"
  ],
  "FBP1": [
    "FBP1 cnv",
    "FBP1 methyl",
    "FBP1 proteo",
    "FBP1 rna"
  ],
  "FBP2": [
    "FBP2 cnv",
    "FBP2 proteo",
    "FBP2 rna"
  ],
  "FBRS": [
    "FBRS 948_968_1_0 phospho",
    "FBRS cnv",
    "FBRS methyl",
    "FBRS proteo",
    "FBRS rna"
  ],
  "FBRSL1": [
    "FBRSL1 cnv",
    "FBRSL1 methyl",
    "FBRSL1 rna"
  ],
  "FBXL12": [
    "FBXL12 cnv",
    "FBXL12 methyl",
    "FBXL12 rna"
  ],
  "FBXL13": [
    "FBXL13 cnv",
    "FBXL13 methyl",
    "FBXL13 rna"
  ],
  "FBXL14": [
    "FBXL14 cnv",
    "FBXL14 methyl",
    "FBXL14 rna"
  ],
  "FBXL15": [
    "FBXL15 cnv",
    "FBXL15 methyl",
    "FBXL15 proteo",
    "FBXL15 rna"
  ],
  "FBXL16": [
    "FBXL16 cnv",
    "FBXL16 methyl",
    "FBXL16 proteo",
    "FBXL16 rna"
  ],
  "FBXL17": [
    "FBXL17 cnv",
    "FBXL17 methyl",
    "FBXL17 proteo",
    "FBXL17 rna"
  ],
  "FBXL18": [
    "FBXL18 cnv",
    "FBXL18 methyl",
    "FBXL18 proteo",
    "FBXL18 rna"
  ],
  "FBXL19": [
    "FBXL19 408_420_1_1_S408 phospho",
    "FBXL19 cnv",
    "FBXL19 methyl",
    "FBXL19 rna"
  ],
  "FBXL19-AS1": [
    "FBXL19-AS1 methyl"
  ],
  "FBXL2": [
    "FBXL2 430_443_1_1_T435 phospho",
    "FBXL2 cnv",
    "FBXL2 methyl",
    "FBXL2 rna"
  ],
  "FBXL20": [
    "FBXL20 380_393_1_1_T385 phospho",
    "FBXL20 380_393_2_2_T385S389 phospho",
    "FBXL20 cnv",
    "FBXL20 methyl",
    "FBXL20 proteo",
    "FBXL20 rna"
  ],
  "FBXL22": [
    "FBXL22 cnv",
    "FBXL22 rna"
  ],
  "FBXL3": [
    "FBXL3 cnv",
    "FBXL3 methyl",
    "FBXL3 proteo",
    "FBXL3 rna"
  ],
  "FBXL4": [
    "FBXL4 cnv",
    "FBXL4 methyl",
    "FBXL4 rna"
  ],
  "FBXL5": [
    "FBXL5 cnv",
    "FBXL5 methyl",
    "FBXL5 rna"
  ],
  "FBXL6": [
    "FBXL6 cnv",
    "FBXL6 methyl",
    "FBXL6 rna"
  ],
  "FBXL7": [
    "FBXL7 16_32_1_1_T30 phospho",
    "FBXL7 cnv",
    "FBXL7 methyl",
    "FBXL7 proteo",
    "FBXL7 rna"
  ],
  "FBXL8": [
    "FBXL8 cnv",
    "FBXL8 methyl",
    "FBXL8 proteo",
    "FBXL8 rna"
  ],
  "FBXO10": [
    "FBXO10 cnv",
    "FBXO10 methyl",
    "FBXO10 rna"
  ],
  "FBXO11": [
    "FBXO11 cnv",
    "FBXO11 methyl",
    "FBXO11 proteo",
    "FBXO11 rna"
  ],
  "FBXO15": [
    "FBXO15 cnv",
    "FBXO15 methyl",
    "FBXO15 rna"
  ],
  "FBXO16": [
    "FBXO16 cnv",
    "FBXO16 rna"
  ],
  "FBXO17": [
    "FBXO17 cnv",
    "FBXO17 methyl",
    "FBXO17 rna"
  ],
  "FBXO2": [
    "FBXO2 cnv",
    "FBXO2 methyl",
    "FBXO2 proteo",
    "FBXO2 rna"
  ],
  "FBXO21": [
    "FBXO21 cnv",
    "FBXO21 methyl",
    "FBXO21 proteo",
    "FBXO21 rna"
  ],
  "FBXO22": [
    "FBXO22 cnv",
    "FBXO22 methyl",
    "FBXO22 proteo",
    "FBXO22 rna"
  ],
  "FBXO24": [
    "FBXO24 cnv",
    "FBXO24 methyl",
    "FBXO24 rna"
  ],
  "FBXO25": [
    "FBXO25 cnv",
    "FBXO25 methyl",
    "FBXO25 rna"
  ],
  "FBXO27": [
    "FBXO27 cnv",
    "FBXO27 methyl",
    "FBXO27 rna"
  ],
  "FBXO28": [
    "FBXO28 cnv",
    "FBXO28 proteo",
    "FBXO28 rna"
  ],
  "FBXO3": [
    "FBXO3 cnv",
    "FBXO3 methyl",
    "FBXO3 proteo",
    "FBXO3 rna"
  ],
  "FBXO3-DT": [
    "FBXO3-DT methyl"
  ],
  "FBXO30": [
    "FBXO30 cnv",
    "FBXO30 methyl",
    "FBXO30 proteo",
    "FBXO30 rna"
  ],
  "FBXO31": [
    "FBXO31 cnv",
    "FBXO31 methyl",
    "FBXO31 rna"
  ],
  "FBXO32": [
    "FBXO32 cnv",
    "FBXO32 methyl",
    "FBXO32 rna"
  ],
  "FBXO33": [
    "FBXO33 cnv",
    "FBXO33 methyl",
    "FBXO33 rna"
  ],
  "FBXO34": [
    "FBXO34 cnv",
    "FBXO34 methyl",
    "FBXO34 rna"
  ],
  "FBXO36": [
    "FBXO36 cnv",
    "FBXO36 methyl",
    "FBXO36 rna"
  ],
  "FBXO38": [
    "FBXO38 cnv",
    "FBXO38 methyl",
    "FBXO38 proteo",
    "FBXO38 rna"
  ],
  "FBXO38-DT": [
    "FBXO38-DT methyl"
  ],
  "FBXO39": [
    "FBXO39 cnv",
    "FBXO39 methyl",
    "FBXO39 rna"
  ],
  "FBXO4": [
    "FBXO4 8_18_1_1_S12 phospho",
    "FBXO4 cnv",
    "FBXO4 methyl",
    "FBXO4 proteo",
    "FBXO4 rna"
  ],
  "FBXO40": [
    "FBXO40 cnv",
    "FBXO40 rna"
  ],
  "FBXO41": [
    "FBXO41 478_491_1_1_S478 phospho",
    "FBXO41 478_491_2_2_S478T479 phospho",
    "FBXO41 cnv",
    "FBXO41 methyl",
    "FBXO41 proteo",
    "FBXO41 rna"
  ],
  "FBXO42": [
    "FBXO42 488_488_1_1_S488 phospho",
    "FBXO42 534_552_2_2_T539S552 phospho",
    "FBXO42 cnv",
    "FBXO42 methyl",
    "FBXO42 proteo",
    "FBXO42 rna"
  ],
  "FBXO43": [
    "FBXO43 cnv",
    "FBXO43 methyl",
    "FBXO43 rna"
  ],
  "FBXO44": [
    "FBXO44 cnv",
    "FBXO44 methyl",
    "FBXO44 proteo",
    "FBXO44 rna"
  ],
  "FBXO45": [
    "FBXO45 cnv",
    "FBXO45 methyl",
    "FBXO45 proteo",
    "FBXO45 rna"
  ],
  "FBXO46": [
    "FBXO46 cnv",
    "FBXO46 methyl",
    "FBXO46 rna"
  ],
  "FBXO47": [
    "FBXO47 cnv",
    "FBXO47 rna"
  ],
  "FBXO48": [
    "FBXO48 cnv",
    "FBXO48 methyl",
    "FBXO48 rna"
  ],
  "FBXO5": [
    "FBXO5 cnv",
    "FBXO5 methyl",
    "FBXO5 rna"
  ],
  "FBXO6": [
    "FBXO6 284_286_1_1_S284 phospho",
    "FBXO6 cnv",
    "FBXO6 methyl",
    "FBXO6 proteo",
    "FBXO6 rna"
  ],
  "FBXO7": [
    "FBXO7 cnv",
    "FBXO7 methyl",
    "FBXO7 proteo",
    "FBXO7 rna"
  ],
  "FBXO8": [
    "FBXO8 cnv",
    "FBXO8 methyl",
    "FBXO8 rna"
  ],
  "FBXO9": [
    "FBXO9 cnv",
    "FBXO9 methyl",
    "FBXO9 proteo",
    "FBXO9 rna"
  ],
  "FBXW10": [
    "FBXW10 cnv",
    "FBXW10 rna"
  ],
  "FBXW10B": [
    "FBXW10B cnv",
    "FBXW10B rna"
  ],
  "FBXW11": [
    "FBXW11 cnv",
    "FBXW11 methyl",
    "FBXW11 proteo",
    "FBXW11 rna"
  ],
  "FBXW12": [
    "FBXW12 cnv",
    "FBXW12 rna"
  ],
  "FBXW2": [
    "FBXW2 cnv",
    "FBXW2 methyl",
    "FBXW2 proteo",
    "FBXW2 rna"
  ],
  "FBXW4": [
    "FBXW4 cnv",
    "FBXW4 methyl",
    "FBXW4 rna"
  ],
  "FBXW5": [
    "FBXW5 cnv",
    "FBXW5 methyl",
    "FBXW5 rna"
  ],
  "FBXW7": [
    "FBXW7 cnv",
    "FBXW7 methyl",
    "FBXW7 rna"
  ],
  "FBXW8": [
    "FBXW8 cnv",
    "FBXW8 methyl",
    "FBXW8 proteo",
    "FBXW8 rna"
  ],
  "FBXW9": [
    "FBXW9 13_24_1_1_S18 phospho",
    "FBXW9 13_24_2_2_S18S22 phospho",
    "FBXW9 cnv",
    "FBXW9 methyl",
    "FBXW9 proteo",
    "FBXW9 rna"
  ],
  "FCAMR": [
    "FCAMR cnv",
    "FCAMR rna"
  ],
  "FCAR": [
    "FCAR cnv",
    "FCAR rna"
  ],
  "FCER1A": [
    "FCER1A cnv",
    "FCER1A rna"
  ],
  "FCER1G": [
    "FCER1G 75_78_1_1_T78 phospho",
    "FCER1G cnv",
    "FCER1G proteo",
    "FCER1G rna"
  ],
  "FCER2": [
    "FCER2 cnv",
    "FCER2 rna"
  ],
  "FCF1": [
    "FCF1 cnv",
    "FCF1 methyl",
    "FCF1 rna"
  ],
  "FCGBP": [
    "FCGBP GLCVLSVGANLTTFDGAR-N4H5F1S1G0 glyco",
    "FCGBP GLCVLSVGANLTTFDGAR-N5H6F0S1G0 glyco",
    "FCGBP GLCVLSVGANLTTFDGAR-N5H6F1S1G0 glyco",
    "FCGBP KVTVRPGESVMVNISAK-N4H5F0S1G0 glyco",
    "FCGBP KVTVRPGESVMVNISAK-N4H5F1S1G0 glyco",
    "FCGBP LLISSLSESPASVSILSQADNTSK-N5H6F1S1G0 glyco",
    "FCGBP SVTLQIYNHSLTLSAR-N6H7F1S1G0 glyco",
    "FCGBP VITVQVANFTLR-N2H5F0S0G0 glyco",
    "FCGBP VITVQVANFTLR-N2H6F0S0G0 glyco",
    "FCGBP VITVQVANFTLR-N2H7F0S0G0 glyco",
    "FCGBP VITVQVANFTLR-N2H8F0S0G0 glyco",
    "FCGBP VITVQVANFTLR-N3H4F0S1G0 glyco",
    "FCGBP VITVQVANFTLR-N4H5F0S0G0 glyco",
    "FCGBP VITVQVANFTLR-N4H5F0S1G0 glyco",
    "FCGBP VITVQVANFTLR-N4H5F0S2G0 glyco",
    "FCGBP VITVQVANFTLR-N4H5F1S0G0 glyco",
    "FCGBP VITVQVANFTLR-N4H5F1S1G0 glyco",
    "FCGBP VITVQVANFTLR-N4H5F1S2G0 glyco",
    "FCGBP VITVQVANFTLR-N5H6F0S1G0 glyco",
    "FCGBP VITVQVANFTLR-N5H6F1S1G0 glyco",
    "FCGBP VTVRPGESVMVNISAK-N4H5F1S1G0 glyco",
    "FCGBP VVTVAALGTNISIHK-N4H5F0S1G0 glyco",
    "FCGBP VVTVAALGTNISIHKDEIGK-N4H5F0S1G0 glyco",
    "FCGBP VVTVAALGTNISIHKDEIGK-N5H6F0S1G0 glyco",
    "FCGBP VVTVAALGTNISIHKDEIGK-N6H3F3S0G0 glyco",
    "FCGBP VVTVAALGTNISIHKDEIGK-N7H4F1S1G0 glyco",
    "FCGBP YLPVNSSLLTSDCSER-N2H8F0S0G0 glyco",
    "FCGBP cnv",
    "FCGBP proteo",
    "FCGBP rna"
  ],
  "FCGR1A": [
    "FCGR1A cnv",
    "FCGR1A proteo",
    "FCGR1A rna"
  ],
  "FCGR1BP": [
    "FCGR1BP cnv",
    "FCGR1BP rna"
  ],
  "FCGR2A": [
    "FCGR2A cnv",
    "FCGR2A rna"
  ],
  "FCGR2B": [
    "FCGR2B cnv",
    "FCGR2B proteo",
    "FCGR2B rna"
  ],
  "FCGR2C": [
    "FCGR2C cnv",
    "FCGR2C rna"
  ],
  "FCGR3A": [
    "FCGR3A cnv",
    "FCGR3A proteo",
    "FCGR3A rna"
  ],
  "FCGR3B": [
    "FCGR3B cnv",
    "FCGR3B rna"
  ],
  "FCGRT": [
    "FCGRT GPYTLQGLLGCELGPDNTSVPTAK-N4H5F1S1G0 glyco",
    "FCGRT cnv",
    "FCGRT methyl",
    "FCGRT proteo",
    "FCGRT rna"
  ],
  "FCHO1": [
    "FCHO1 576_581_1_1_S576 phospho",
    "FCHO1 cnv",
    "FCHO1 methyl",
    "FCHO1 proteo",
    "FCHO1 rna"
  ],
  "FCHO2": [
    "FCHO2 380_394_1_1_S394 phospho",
    "FCHO2 394_394_1_1_S394 phospho",
    "FCHO2 478_496_1_1_S496 phospho",
    "FCHO2 508_529_1_0 phospho",
    "FCHO2 533_556_1_1_S533 phospho",
    "FCHO2 cnv",
    "FCHO2 methyl",
    "FCHO2 proteo",
    "FCHO2 rna"
  ],
  "FCHSD1": [
    "FCHSD1 cnv",
    "FCHSD1 methyl",
    "FCHSD1 proteo",
    "FCHSD1 rna"
  ],
  "FCHSD2": [
    "FCHSD2 674_677_1_1_S675 phospho",
    "FCHSD2 674_683_1_1_Y677 phospho",
    "FCHSD2 688_700_1_1_S693 phospho",
    "FCHSD2 cnv",
    "FCHSD2 methyl",
    "FCHSD2 proteo",
    "FCHSD2 rna"
  ],
  "FCMR": [
    "FCMR cnv",
    "FCMR rna"
  ],
  "FCN1": [
    "FCN1 cnv",
    "FCN1 proteo",
    "FCN1 rna"
  ],
  "FCN2": [
    "FCN2 cnv",
    "FCN2 proteo",
    "FCN2 rna"
  ],
  "FCN3": [
    "FCN3 cnv",
    "FCN3 proteo",
    "FCN3 rna"
  ],
  "FCRL1": [
    "FCRL1 cnv",
    "FCRL1 rna"
  ],
  "FCRL2": [
    "FCRL2 cnv",
    "FCRL2 rna"
  ],
  "FCRL3": [
    "FCRL3 cnv",
    "FCRL3 rna"
  ],
  "FCRL4": [
    "FCRL4 cnv"
  ],
  "FCRL5": [
    "FCRL5 cnv",
    "FCRL5 rna"
  ],
  "FCRL6": [
    "FCRL6 cnv",
    "FCRL6 rna"
  ],
  "FCRLA": [
    "FCRLA cnv",
    "FCRLA rna"
  ],
  "FCRLB": [
    "FCRLB cnv",
    "FCRLB methyl",
    "FCRLB rna"
  ],
  "FCSK": [
    "FCSK cnv",
    "FCSK methyl",
    "FCSK proteo",
    "FCSK rna"
  ],
  "FDCSP": [
    "FDCSP cnv",
    "FDCSP rna"
  ],
  "FDFT1": [
    "FDFT1 cnv",
    "FDFT1 methyl",
    "FDFT1 proteo",
    "FDFT1 rna"
  ],
  "FDPS": [
    "FDPS cnv",
    "FDPS methyl",
    "FDPS proteo",
    "FDPS rna"
  ],
  "FDX1": [
    "FDX1 cnv",
    "FDX1 methyl",
    "FDX1 proteo",
    "FDX1 rna"
  ],
  "FDX2": [
    "FDX2 cnv",
    "FDX2 methyl",
    "FDX2 proteo",
    "FDX2 rna"
  ],
  "FDXACB1": [
    "FDXACB1 cnv",
    "FDXACB1 methyl",
    "FDXACB1 rna"
  ],
  "FDXR": [
    "FDXR cnv",
    "FDXR methyl",
    "FDXR proteo",
    "FDXR rna"
  ],
  "FECH": [
    "FECH cnv",
    "FECH methyl",
    "FECH proteo",
    "FECH rna"
  ],
  "FEM1A": [
    "FEM1A cnv",
    "FEM1A methyl",
    "FEM1A proteo",
    "FEM1A rna"
  ],
  "FEM1B": [
    "FEM1B cnv",
    "FEM1B methyl",
    "FEM1B proteo",
    "FEM1B rna"
  ],
  "FEM1C": [
    "FEM1C cnv",
    "FEM1C methyl",
    "FEM1C rna"
  ],
  "FEN1": [
    "FEN1 cnv",
    "FEN1 methyl",
    "FEN1 proteo",
    "FEN1 rna"
  ],
  "FENDRR": [
    "FENDRR methyl"
  ],
  "FER": [
    "FER cnv",
    "FER kinase",
    "FER methyl",
    "FER proteo",
    "FER rna"
  ],
  "FER1L5": [
    "FER1L5 cnv",
    "FER1L5 rna"
  ],
  "FER1L6": [
    "FER1L6 cnv",
    "FER1L6 rna"
  ],
  "FERD3L": [
    "FERD3L cnv",
    "FERD3L rna"
  ],
  "FERMT1": [
    "FERMT1 cnv",
    "FERMT1 methyl",
    "FERMT1 proteo",
    "FERMT1 rna"
  ],
  "FERMT2": [
    "FERMT2 159_186_1_1_S159 phospho",
    "FERMT2 188_229_1_0 phospho",
    "FERMT2 188_229_1_1_S199 phospho",
    "FERMT2 cnv",
    "FERMT2 methyl",
    "FERMT2 proteo",
    "FERMT2 rna"
  ],
  "FERMT3": [
    "FERMT3 478_500_1_1_S480 phospho",
    "FERMT3 cnv",
    "FERMT3 methyl",
    "FERMT3 proteo",
    "FERMT3 rna"
  ],
  "FES": [
    "FES cnv",
    "FES kinase",
    "FES methyl",
    "FES proteo",
    "FES rna"
  ],
  "FETUB": [
    "FETUB 266_278_1_1_S278 phospho",
    "FETUB VLYLAAYNCTLRPVSK-N4H5F0S1G0 glyco",
    "FETUB VLYLAAYNCTLRPVSK-N4H5F0S2G0 glyco",
    "FETUB cnv",
    "FETUB proteo",
    "FETUB rna"
  ],
  "FEV": [
    "FEV cnv",
    "FEV methyl",
    "FEV rna"
  ],
  "FEZ1": [
    "FEZ1 316_326_1_1_S316 phospho",
    "FEZ1 58_58_1_1_S58 phospho",
    "FEZ1 cnv",
    "FEZ1 methyl",
    "FEZ1 proteo",
    "FEZ1 rna"
  ],
  "FEZ2": [
    "FEZ2 204_209_1_1_S205 phospho",
    "FEZ2 cnv",
    "FEZ2 proteo",
    "FEZ2 rna"
  ],
  "FEZF1": [
    "FEZF1 cnv",
    "FEZF1 methyl",
    "FEZF1 rna"
  ],
  "FEZF1-AS1": [
    "FEZF1-AS1 methyl"
  ],
  "FEZF2": [
    "FEZF2 cnv",
    "FEZF2 methyl",
    "FEZF2 rna"
  ],
  "FFAR1": [
    "FFAR1 cnv",
    "FFAR1 methyl",
    "FFAR1 rna"
  ],
  "FFAR2": [
    "FFAR2 cnv",
    "FFAR2 rna"
  ],
  "FFAR3": [
    "FFAR3 cnv",
    "FFAR3 rna"
  ],
  "FFAR4": [
    "FFAR4 cnv",
    "FFAR4 methyl",
    "FFAR4 rna"
  ],
  "FGA": [
    "FGA 290_305_1_1_S291 phospho",
    "FGA 325_365_1_1_S364 phospho",
    "FGA 484_505_1_1_S485 phospho",
    "FGA 522_525_1_1_S524 phospho",
    "FGA 609_619_1_1_S609 phospho",
    "FGA 609_619_1_1_S618 phospho",
    "FGA cnv",
    "FGA proteo",
    "FGA rna"
  ],
  "FGB": [
    "FGB 378_408_1_0 phospho",
    "FGB GTAGNALMDGASQLMGENR-N3H3F0S0G0 glyco",
    "FGB GTAGNALMDGASQLMGENR-N3H3F2S0G0 glyco",
    "FGB GTAGNALMDGASQLMGENR-N3H4F0S0G0 glyco",
    "FGB GTAGNALMDGASQLMGENR-N3H4F0S1G0 glyco",
    "FGB GTAGNALMDGASQLMGENR-N4H4F0S1G0 glyco",
    "FGB GTAGNALMDGASQLMGENR-N4H5F0S0G0 glyco",
    "FGB GTAGNALMDGASQLMGENR-N4H5F0S1G0 glyco",
    "FGB GTAGNALMDGASQLMGENR-N4H5F0S2G0 glyco",
    "FGB GTAGNALMDGASQLMGENR-N4H5F2S1G0 glyco",
    "FGB GTAGNALMDGASQLMGENR-N4H6F1S0G0 glyco",
    "FGB cnv",
    "FGB proteo",
    "FGB rna"
  ],
  "FGD1": [
    "FGD1 114_122_1_1_S116 phospho",
    "FGD1 135_149_2_2_S135S149 phospho",
    "FGD1 365_369_1_1_S365 phospho",
    "FGD1 48_67_1_1_S48 phospho",
    "FGD1 703_715_2_2_T711S715 phospho",
    "FGD1 methyl",
    "FGD1 proteo",
    "FGD1 rna"
  ],
  "FGD2": [
    "FGD2 48_48_1_1_S48 phospho",
    "FGD2 cnv",
    "FGD2 proteo",
    "FGD2 rna"
  ],
  "FGD3": [
    "FGD3 121_139_1_1_S128 phospho",
    "FGD3 cnv",
    "FGD3 proteo",
    "FGD3 rna"
  ],
  "FGD4": [
    "FGD4 491_504_1_1_S504 phospho",
    "FGD4 cnv",
    "FGD4 methyl",
    "FGD4 proteo",
    "FGD4 rna"
  ],
  "FGD5": [
    "FGD5 699_703_1_1_S703 phospho",
    "FGD5 cnv",
    "FGD5 proteo",
    "FGD5 rna"
  ],
  "FGD5-AS1": [
    "FGD5-AS1 methyl"
  ],
  "FGD6": [
    "FGD6 1288_1288_1_1_S1288 phospho",
    "FGD6 605_607_1_1_S605 phospho",
    "FGD6 cnv",
    "FGD6 methyl",
    "FGD6 proteo",
    "FGD6 rna"
  ],
  "FGF1": [
    "FGF1 cnv",
    "FGF1 proteo",
    "FGF1 rna"
  ],
  "FGF10": [
    "FGF10 cnv",
    "FGF10 rna"
  ],
  "FGF11": [
    "FGF11 cnv",
    "FGF11 methyl",
    "FGF11 rna"
  ],
  "FGF12": [
    "FGF12 146_150_1_1_S150 phospho",
    "FGF12 150_150_1_1_S150 phospho",
    "FGF12 164_169_1_1_S165 phospho",
    "FGF12 164_169_1_1_T167 phospho",
    "FGF12 180_181_1_0 phospho",
    "FGF12 cnv",
    "FGF12 methyl",
    "FGF12 proteo",
    "FGF12 rna"
  ],
  "FGF12-AS2": [
    "FGF12-AS2 methyl"
  ],
  "FGF13": [
    "FGF13 methyl",
    "FGF13 rna"
  ],
  "FGF13-AS1": [
    "FGF13-AS1 methyl"
  ],
  "FGF14": [
    "FGF14 cnv",
    "FGF14 rna"
  ],
  "FGF14-AS2": [
    "FGF14-AS2 methyl"
  ],
  "FGF14-IT1": [
    "FGF14-IT1 methyl"
  ],
  "FGF16": [
    "FGF16 rna"
  ],
  "FGF17": [
    "FGF17 cnv",
    "FGF17 rna"
  ],
  "FGF18": [
    "FGF18 cnv",
    "FGF18 methyl",
    "FGF18 rna"
  ],
  "FGF19": [
    "FGF19 cnv",
    "FGF19 methyl",
    "FGF19 rna"
  ],
  "FGF2": [
    "FGF2 cnv",
    "FGF2 methyl",
    "FGF2 proteo",
    "FGF2 rna"
  ],
  "FGF20": [
    "FGF20 cnv",
    "FGF20 methyl",
    "FGF20 rna"
  ],
  "FGF21": [
    "FGF21 cnv",
    "FGF21 rna"
  ],
  "FGF22": [
    "FGF22 cnv",
    "FGF22 methyl",
    "FGF22 rna"
  ],
  "FGF23": [
    "FGF23 cnv",
    "FGF23 rna"
  ],
  "FGF3": [
    "FGF3 cnv",
    "FGF3 methyl",
    "FGF3 rna"
  ],
  "FGF4": [
    "FGF4 cnv",
    "FGF4 methyl",
    "FGF4 rna"
  ],
  "FGF5": [
    "FGF5 cnv",
    "FGF5 methyl",
    "FGF5 rna"
  ],
  "FGF6": [
    "FGF6 cnv",
    "FGF6 rna"
  ],
  "FGF7": [
    "FGF7 cnv",
    "FGF7 rna"
  ],
  "FGF8": [
    "FGF8 cnv",
    "FGF8 methyl",
    "FGF8 rna"
  ],
  "FGF9": [
    "FGF9 cnv",
    "FGF9 methyl",
    "FGF9 rna"
  ],
  "FGFBP1": [
    "FGFBP1 cnv",
    "FGFBP1 rna"
  ],
  "FGFBP2": [
    "FGFBP2 cnv",
    "FGFBP2 rna"
  ],
  "FGFBP3": [
    "FGFBP3 cnv",
    "FGFBP3 methyl",
    "FGFBP3 rna"
  ],
  "FGFR1": [
    "FGFR1 cnv",
    "FGFR1 kinase",
    "FGFR1 methyl",
    "FGFR1 proteo",
    "FGFR1 rna"
  ],
  "FGFR1OP2": [
    "FGFR1OP2 cnv",
    "FGFR1OP2 methyl",
    "FGFR1OP2 proteo",
    "FGFR1OP2 rna"
  ],
  "FGFR2": [
    "FGFR2 431_442_1_1_T442 phospho",
    "FGFR2 cnv",
    "FGFR2 kinase",
    "FGFR2 methyl",
    "FGFR2 rna"
  ],
  "FGFR3": [
    "FGFR3 424_435_1_1_S424 phospho",
    "FGFR3 cnv",
    "FGFR3 kinase",
    "FGFR3 methyl",
    "FGFR3 proteo",
    "FGFR3 rna"
  ],
  "FGFR4": [
    "FGFR4 cnv",
    "FGFR4 kinase",
    "FGFR4 methyl",
    "FGFR4 rna"
  ],
  "FGFRL1": [
    "FGFRL1 cnv",
    "FGFRL1 methyl",
    "FGFRL1 proteo",
    "FGFRL1 rna"
  ],
  "FGG": [
    "FGG 442_448_1_1_Y448 phospho",
    "FGG DLQSLEDILHQVENK-N3H4F0S0G0 glyco",
    "FGG DLQSLEDILHQVENK-N4H4F0S1G0 glyco",
    "FGG DLQSLEDILHQVENK-N4H5F0S0G0 glyco",
    "FGG DLQSLEDILHQVENK-N4H5F0S1G0 glyco",
    "FGG DLQSLEDILHQVENK-N4H5F0S2G0 glyco",
    "FGG cnv",
    "FGG proteo",
    "FGG rna"
  ],
  "FGGY": [
    "FGGY cnv",
    "FGGY methyl",
    "FGGY proteo",
    "FGGY rna"
  ],
  "FGGY-DT": [
    "FGGY-DT methyl"
  ],
  "FGL1": [
    "FGL1 cnv",
    "FGL1 rna"
  ],
  "FGL2": [
    "FGL2 cnv",
    "FGL2 proteo",
    "FGL2 rna"
  ],
  "FGR": [
    "FGR cnv",
    "FGR kinase",
    "FGR methyl",
    "FGR rna"
  ],
  "FH": [
    "FH cnv",
    "FH methyl",
    "FH proteo",
    "FH rna"
  ],
  "FHAD1": [
    "FHAD1 cnv",
    "FHAD1 methyl",
    "FHAD1 rna"
  ],
  "FHDC1": [
    "FHDC1 498_508_1_1_S500 phospho",
    "FHDC1 cnv",
    "FHDC1 methyl",
    "FHDC1 rna"
  ],
  "FHIP1A": [
    "FHIP1A cnv",
    "FHIP1A methyl",
    "FHIP1A rna"
  ],
  "FHIP1B": [
    "FHIP1B 467_475_1_1_S467 phospho",
    "FHIP1B 571_590_1_1_S582 phospho",
    "FHIP1B 596_596_1_1_S596 phospho",
    "FHIP1B cnv",
    "FHIP1B methyl",
    "FHIP1B proteo",
    "FHIP1B rna"
  ],
  "FHIP2A": [
    "FHIP2A cnv",
    "FHIP2A methyl",
    "FHIP2A proteo",
    "FHIP2A rna"
  ],
  "FHIP2B": [
    "FHIP2B 524_526_1_1_S525 phospho",
    "FHIP2B cnv",
    "FHIP2B proteo",
    "FHIP2B rna"
  ],
  "FHIT": [
    "FHIT cnv",
    "FHIT methyl",
    "FHIT proteo",
    "FHIT rna"
  ],
  "FHL1": [
    "FHL1 272_272_1_1_S272 phospho",
    "FHL1 methyl",
    "FHL1 proteo",
    "FHL1 rna"
  ],
  "FHL2": [
    "FHL2 cnv",
    "FHL2 methyl",
    "FHL2 proteo",
    "FHL2 rna"
  ],
  "FHL3": [
    "FHL3 cnv",
    "FHL3 methyl",
    "FHL3 proteo",
    "FHL3 rna"
  ],
  "FHL5": [
    "FHL5 cnv",
    "FHL5 rna"
  ],
  "FHOD1": [
    "FHOD1 367_367_1_1_S367 phospho",
    "FHOD1 cnv",
    "FHOD1 methyl",
    "FHOD1 proteo",
    "FHOD1 rna"
  ],
  "FHOD3": [
    "FHOD3 761_775_1_0 phospho",
    "FHOD3 cnv",
    "FHOD3 methyl",
    "FHOD3 rna"
  ],
  "FIBCD1": [
    "FIBCD1 cnv",
    "FIBCD1 methyl",
    "FIBCD1 rna"
  ],
  "FIBIN": [
    "FIBIN cnv",
    "FIBIN proteo",
    "FIBIN rna"
  ],
  "FIBP": [
    "FIBP cnv",
    "FIBP methyl",
    "FIBP proteo",
    "FIBP rna"
  ],
  "FICD": [
    "FICD cnv",
    "FICD methyl",
    "FICD proteo",
    "FICD rna"
  ],
  "FIG4": [
    "FIG4 cnv",
    "FIG4 methyl",
    "FIG4 proteo",
    "FIG4 rna"
  ],
  "FIGLA": [
    "FIGLA cnv",
    "FIGLA methyl",
    "FIGLA rna"
  ],
  "FIGN": [
    "FIGN cnv",
    "FIGN methyl",
    "FIGN rna"
  ],
  "FIGNL1": [
    "FIGNL1 cnv",
    "FIGNL1 methyl",
    "FIGNL1 rna"
  ],
  "FIGNL2": [
    "FIGNL2 cnv",
    "FIGNL2 methyl",
    "FIGNL2 rna"
  ],
  "FIGNL2-DT": [
    "FIGNL2-DT methyl"
  ],
  "FILIP1": [
    "FILIP1 cnv",
    "FILIP1 rna"
  ],
  "FILIP1L": [
    "FILIP1L 791_797_1_1_S791 phospho",
    "FILIP1L 907_941_1_0 phospho",
    "FILIP1L 907_941_1_1_S921 phospho",
    "FILIP1L cnv",
    "FILIP1L methyl",
    "FILIP1L proteo",
    "FILIP1L rna"
  ],
  "FIP1L1": [
    "FIP1L1 304_304_1_1_S304 phospho",
    "FIP1L1 492_500_1_1_S492 phospho",
    "FIP1L1 492_500_2_0 phospho",
    "FIP1L1 492_500_2_2_S492T494 phospho",
    "FIP1L1 492_505_1_1_S492 phospho",
    "FIP1L1 492_505_2_2_S492S500 phospho",
    "FIP1L1 554_559_1_1_S554 phospho",
    "FIP1L1 cnv",
    "FIP1L1 methyl",
    "FIP1L1 proteo",
    "FIP1L1 rna"
  ],
  "FIRRE": [
    "FIRRE methyl"
  ],
  "FIS1": [
    "FIS1 cnv",
    "FIS1 methyl",
    "FIS1 proteo",
    "FIS1 rna"
  ],
  "FITM1": [
    "FITM1 cnv",
    "FITM1 rna"
  ],
  "FITM2": [
    "FITM2 cnv",
    "FITM2 methyl",
    "FITM2 proteo",
    "FITM2 rna"
  ],
  "FIZ1": [
    "FIZ1 cnv",
    "FIZ1 methyl",
    "FIZ1 rna"
  ],
  "FJX1": [
    "FJX1 cnv",
    "FJX1 methyl",
    "FJX1 rna"
  ],
  "FKBP10": [
    "FKBP10 NHTYNTYIGQGYIIPGMDQGLQGACMGER-N2H6F0S0G0 glyco",
    "FKBP10 RAGAGDFMRYHYNGSLMDGTLFDSSYSR-N3H3F0S0G0 glyco",
    "FKBP10 YHYNCSLLDGTQLFTSHDYGAPQEATLGANK-N2H5F0S0G0 glyco",
    "FKBP10 YHYNCSLLDGTQLFTSHDYGAPQEATLGANK-N2H6F0S0G0 glyco",
    "FKBP10 YHYNCSLLDGTQLFTSHDYGAPQEATLGANK-N2H7F0S0G0 glyco",
    "FKBP10 YHYNCSLLDGTQLFTSHDYGAPQEATLGANK-N2H8F0S0G0 glyco",
    "FKBP10 YHYNGSLMDGTLFDSSYSR-N2H8F0S0G0 glyco",
    "FKBP10 YHYNGSLMDGTLFDSSYSR-N2H9F0S0G0 glyco",
    "FKBP10 YHYNGSLMDGTLFDSSYSR-N8H3F0S0G0 glyco",
    "FKBP10 YHYNGTFEDGK-N2H5F0S0G0 glyco",
    "FKBP10 YHYNGTFEDGK-N2H6F0S0G0 glyco",
    "FKBP10 YHYNGTFEDGK-N2H7F0S0G0 glyco",
    "FKBP10 YHYNGTFEDGK-N2H8F0S0G0 glyco",
    "FKBP10 YHYNGTFEDGK-N4H3F1S0G0 glyco",
    "FKBP10 YHYNGTFEDGKK-N2H5F0S0G0 glyco",
    "FKBP10 YHYNGTFEDGKK-N2H6F0S0G0 glyco",
    "FKBP10 YHYNGTFEDGKK-N2H7F0S0G0 glyco",
    "FKBP10 YHYNGTFEDGKK-N3H3F1S0G0 glyco",
    "FKBP10 YHYNGTLLDGTSFDTSYSK-N2H5F0S0G0 glyco",
    "FKBP10 YHYNGTLLDGTSFDTSYSK-N2H6F0S0G0 glyco",
    "FKBP10 YHYNGTLLDGTSFDTSYSK-N2H7F0S0G0 glyco",
    "FKBP10 YHYNGTLLDGTSFDTSYSK-N2H8F0S0G0 glyco",
    "FKBP10 YHYNGTLLDGTSFDTSYSK-N2H9F0S0G0 glyco",
    "FKBP10 cnv",
    "FKBP10 methyl",
    "FKBP10 proteo",
    "FKBP10 rna"
  ],
  "FKBP11": [
    "FKBP11 cnv",
    "FKBP11 methyl",
    "FKBP11 proteo",
    "FKBP11 rna"
  ],
  "FKBP14": [
    "FKBP14 cnv",
    "FKBP14 methyl",
    "FKBP14 proteo",
    "FKBP14 rna"
  ],
  "FKBP15": [
    "FKBP15 1012_1018_1_1_S1012 phospho",
    "FKBP15 1092_1114_1_0 phospho",
    "FKBP15 1092_1114_2_0 phospho",
    "FKBP15 1161_1164_1_1_S1162 phospho",
    "FKBP15 1161_1164_1_1_S1164 phospho",
    "FKBP15 1161_1164_2_2_S1162S1164 phospho",
    "FKBP15 1161_1176_2_2_S1162S1164 phospho",
    "FKBP15 1195_1195_1_1_S1195 phospho",
    "FKBP15 295_304_1_1_S301 phospho",
    "FKBP15 295_330_2_2_S307S311 phospho",
    "FKBP15 344_356_1_0 phospho",
    "FKBP15 344_356_1_1_S344 phospho",
    "FKBP15 344_356_1_1_S356 phospho",
    "FKBP15 956_965_1_1_S956 phospho",
    "FKBP15 cnv",
    "FKBP15 methyl",
    "FKBP15 proteo",
    "FKBP15 rna"
  ],
  "FKBP1A": [
    "FKBP1A 7_9_1_1_S9 phospho",
    "FKBP1A cnv",
    "FKBP1A proteo",
    "FKBP1A rna"
  ],
  "FKBP1B": [
    "FKBP1B cnv",
    "FKBP1B proteo",
    "FKBP1B rna"
  ],
  "FKBP1C": [
    "FKBP1C cnv",
    "FKBP1C rna"
  ],
  "FKBP2": [
    "FKBP2 cnv",
    "FKBP2 methyl",
    "FKBP2 proteo",
    "FKBP2 rna"
  ],
  "FKBP3": [
    "FKBP3 34_36_1_1_S34 phospho",
    "FKBP3 34_36_1_1_S36 phospho",
    "FKBP3 cnv",
    "FKBP3 methyl",
    "FKBP3 proteo",
    "FKBP3 rna"
  ],
  "FKBP4": [
    "FKBP4 446_457_1_1_S451 phospho",
    "FKBP4 cnv",
    "FKBP4 methyl",
    "FKBP4 proteo",
    "FKBP4 rna"
  ],
  "FKBP5": [
    "FKBP5 13_27_1_1_S13 phospho",
    "FKBP5 443_445_1_1_S445 phospho",
    "FKBP5 cnv",
    "FKBP5 methyl",
    "FKBP5 proteo",
    "FKBP5 rna"
  ],
  "FKBP6": [
    "FKBP6 cnv",
    "FKBP6 methyl",
    "FKBP6 rna"
  ],
  "FKBP7": [
    "FKBP7 cnv",
    "FKBP7 methyl",
    "FKBP7 proteo",
    "FKBP7 rna"
  ],
  "FKBP8": [
    "FKBP8 294_296_1_0 phospho",
    "FKBP8 cnv",
    "FKBP8 methyl",
    "FKBP8 proteo",
    "FKBP8 rna"
  ],
  "FKBP9": [
    "FKBP9 YHYNASLLDGTLLDSTWNLGK-N2H6F0S0G0 glyco",
    "FKBP9 YHYNASLLDGTLLDSTWNLGK-N2H7F0S0G0 glyco",
    "FKBP9 YHYNASLLDGTLLDSTWNLGK-N2H8F0S0G0 glyco",
    "FKBP9 YHYNGTFLDGTLFDSSHNR-N2H5F0S0G0 glyco",
    "FKBP9 YHYNGTFLDGTLFDSSHNR-N2H6F0S0G0 glyco",
    "FKBP9 YHYNGTFLDGTLFDSSHNR-N2H7F0S0G0 glyco",
    "FKBP9 YHYNGTFLDGTLFDSSHNR-N2H8F0S0G0 glyco",
    "FKBP9 YHYNGTLLDGTLFDSSYSR-N2H6F0S0G0 glyco",
    "FKBP9 YHYNGTLLDGTLFDSSYSR-N2H7F0S0G0 glyco",
    "FKBP9 YHYNGTLLDGTLFDSSYSR-N2H8F0S0G0 glyco",
    "FKBP9 YHYNGTLLDGTLFDSSYSR-N2H9F0S0G0 glyco",
    "FKBP9 cnv",
    "FKBP9 methyl",
    "FKBP9 proteo",
    "FKBP9 rna"
  ],
  "FKBPL": [
    "FKBPL cnv",
    "FKBPL proteo",
    "FKBPL rna"
  ],
  "FKRP": [
    "FKRP cnv",
    "FKRP methyl",
    "FKRP rna"
  ],
  "FKTN": [
    "FKTN cnv",
    "FKTN methyl",
    "FKTN rna"
  ],
  "FLACC1": [
    "FLACC1 cnv",
    "FLACC1 rna"
  ],
  "FLAD1": [
    "FLAD1 563_574_1_1_S563 phospho",
    "FLAD1 cnv",
    "FLAD1 proteo",
    "FLAD1 rna"
  ],
  "FLCN": [
    "FLCN 62_73_1_1_S62 phospho",
    "FLCN 62_73_2_2_S62S73 phospho",
    "FLCN cnv",
    "FLCN methyl",
    "FLCN proteo",
    "FLCN rna"
  ],
  "FLG": [
    "FLG cnv",
    "FLG rna"
  ],
  "FLG-AS1": [
    "FLG-AS1 methyl"
  ],
  "FLG2": [
    "FLG2 cnv",
    "FLG2 rna"
  ],
  "FLI1": [
    "FLI1 236_251_1_1_S241 phospho",
    "FLI1 35_42_1_1_S39 phospho",
    "FLI1 70_86_1_1_S79 phospho",
    "FLI1 cnv",
    "FLI1 methyl",
    "FLI1 rna"
  ],
  "FLII": [
    "FLII 425_425_1_1_S425 phospho",
    "FLII 845_849_1_1_S845 phospho",
    "FLII cnv",
    "FLII methyl",
    "FLII proteo",
    "FLII rna"
  ],
  "FLJ12825": [
    "FLJ12825 methyl"
  ],
  "FLJ13224": [
    "FLJ13224 methyl"
  ],
  "FLJ16779": [
    "FLJ16779 methyl"
  ],
  "FLJ20021": [
    "FLJ20021 methyl"
  ],
  "FLJ30679": [
    "FLJ30679 methyl"
  ],
  "FLJ38576": [
    "FLJ38576 methyl"
  ],
  "FLJ40194": [
    "FLJ40194 methyl"
  ],
  "FLNA": [
    "FLNA 1734_1747_1_1_S1734 phospho",
    "FLNA 1967_1991_1_1_S1976 phospho",
    "FLNA 2152_2163_1_1_S2152 phospho",
    "FLNA 2152_2163_1_1_S2158 phospho",
    "FLNA 2152_2163_2_2_S2152S2158 phospho",
    "FLNA 2152_2182_1_0 phospho",
    "FLNA 2152_2182_1_1_S2152 phospho",
    "FLNA 2170_2182_1_1_S2180 phospho",
    "FLNA 2523_2539_1_1_S2526 phospho",
    "FLNA 2599_2599_1_1_T2599 phospho",
    "FLNA methyl",
    "FLNA proteo",
    "FLNA rna"
  ],
  "FLNB": [
    "FLNB 1467_1474_1_1_S1474 phospho",
    "FLNB 1528_1536_1_1_S1536 phospho",
    "FLNB 2138_2168_1_1_S2138 phospho",
    "FLNB 2509_2525_1_1_S2509 phospho",
    "FLNB cnv",
    "FLNB methyl",
    "FLNB proteo",
    "FLNB rna"
  ],
  "FLNC": [
    "FLNC 2146_2153_1_1_S2146 phospho",
    "FLNC 2412_2419_1_1_T2412 phospho",
    "FLNC 2655_2661_1_1_S2655 phospho",
    "FLNC cnv",
    "FLNC methyl",
    "FLNC proteo",
    "FLNC rna"
  ],
  "FLNC-AS1": [
    "FLNC-AS1 methyl"
  ],
  "FLOT1": [
    "FLOT1 379_387_1_1_S385 phospho",
    "FLOT1 cnv",
    "FLOT1 methyl",
    "FLOT1 proteo",
    "FLOT1 rna"
  ],
  "FLOT2": [
    "FLOT2 cnv",
    "FLOT2 methyl",
    "FLOT2 proteo",
    "FLOT2 rna"
  ],
  "FLRT1": [
    "FLRT1 cnv",
    "FLRT1 methyl",
    "FLRT1 proteo",
    "FLRT1 rna"
  ],
  "FLRT2": [
    "FLRT2 647_660_1_1_S651 phospho",
    "FLRT2 cnv",
    "FLRT2 methyl",
    "FLRT2 proteo",
    "FLRT2 rna"
  ],
  "FLRT3": [
    "FLRT3 cnv",
    "FLRT3 proteo",
    "FLRT3 rna"
  ],
  "FLT1": [
    "FLT1 SVNTSVHIYDK-N4H5F0S1G0 glyco",
    "FLT1 VTSPNITVTLK-N4H5F1S1G0 glyco",
    "FLT1 cnv",
    "FLT1 kinase",
    "FLT1 methyl",
    "FLT1 proteo",
    "FLT1 rna"
  ],
  "FLT3": [
    "FLT3 cnv",
    "FLT3 kinase",
    "FLT3 methyl",
    "FLT3 rna"
  ],
  "FLT3LG": [
    "FLT3LG cnv",
    "FLT3LG methyl",
    "FLT3LG rna"
  ],
  "FLT4": [
    "FLT4 cnv",
    "FLT4 kinase",
    "FLT4 methyl",
    "FLT4 rna"
  ],
  "FLVCR1": [
    "FLVCR1 cnv",
    "FLVCR1 methyl",
    "FLVCR1 proteo",
    "FLVCR1 rna"
  ],
  "FLVCR1-DT": [
    "FLVCR1-DT methyl"
  ],
  "FLVCR2": [
    "FLVCR2 cnv",
    "FLVCR2 methyl",
    "FLVCR2 rna"
  ],
  "FLYWCH1": [
    "FLYWCH1 cnv",
    "FLYWCH1 methyl",
    "FLYWCH1 rna"
  ],
  "FLYWCH2": [
    "FLYWCH2 17_26_1_1_S21 phospho",
    "FLYWCH2 cnv",
    "FLYWCH2 methyl",
    "FLYWCH2 proteo",
    "FLYWCH2 rna"
  ],
  "FMC1": [
    "FMC1 cnv",
    "FMC1 methyl",
    "FMC1 proteo",
    "FMC1 rna"
  ],
  "FMC1-LUC7L2": [
    "FMC1-LUC7L2 cnv",
    "FMC1-LUC7L2 methyl",
    "FMC1-LUC7L2 rna"
  ],
  "FMN1": [
    "FMN1 cnv",
    "FMN1 methyl",
    "FMN1 rna"
  ],
  "FMN2": [
    "FMN2 257_282_1_0 phospho",
    "FMN2 295_306_1_1_S295 phospho",
    "FMN2 345_345_1_1_T345 phospho",
    "FMN2 361_361_1_1_S361 phospho",
    "FMN2 396_404_1_1_S400 phospho",
    "FMN2 396_404_2_2_S396S400 phospho",
    "FMN2 427_440_1_1_S432 phospho",
    "FMN2 427_440_2_2_S432S440 phospho",
    "FMN2 427_440_3_3_S432S436S440 phospho",
    "FMN2 482_486_1_1_S482 phospho",
    "FMN2 509_516_1_1_S516 phospho",
    "FMN2 747_783_1_0 phospho",
    "FMN2 93_116_1_1_S93 phospho",
    "FMN2 cnv",
    "FMN2 methyl",
    "FMN2 proteo",
    "FMN2 rna"
  ],
  "FMNL1": [
    "FMNL1 1020_1031_1_1_S1031 phospho",
    "FMNL1 1031_1031_1_1_S1031 phospho",
    "FMNL1 184_189_1_1_S184 phospho",
    "FMNL1 624_624_1_1_S624 phospho",
    "FMNL1 cnv",
    "FMNL1 methyl",
    "FMNL1 proteo",
    "FMNL1 rna"
  ],
  "FMNL1-DT": [
    "FMNL1-DT methyl"
  ],
  "FMNL2": [
    "FMNL2 179_190_1_1_S183 phospho",
    "FMNL2 677_679_1_1_S679 phospho",
    "FMNL2 cnv",
    "FMNL2 methyl",
    "FMNL2 proteo",
    "FMNL2 rna"
  ],
  "FMNL3": [
    "FMNL3 174_191_1_1_S174 phospho",
    "FMNL3 cnv",
    "FMNL3 methyl",
    "FMNL3 proteo",
    "FMNL3 rna"
  ],
  "FMO1": [
    "FMO1 cnv",
    "FMO1 rna"
  ],
  "FMO2": [
    "FMO2 cnv",
    "FMO2 rna"
  ],
  "FMO3": [
    "FMO3 cnv",
    "FMO3 rna"
  ],
  "FMO4": [
    "FMO4 cnv",
    "FMO4 rna"
  ],
  "FMO5": [
    "FMO5 cnv",
    "FMO5 methyl",
    "FMO5 rna"
  ],
  "FMOD": [
    "FMOD LYLDHNNLTR-N4H3F1S0G0 glyco",
    "FMOD LYLDHNNLTR-N4H4F1S1G0 glyco",
    "FMOD LYLDHNNLTR-N4H5F1S1G0 glyco",
    "FMOD LYLDHNNLTR-N5H3F1S0G0 glyco",
    "FMOD LYLDHNNLTR-N5H4F1S0G0 glyco",
    "FMOD LYLDHNNLTR-N5H4F1S1G0 glyco",
    "FMOD cnv",
    "FMOD proteo",
    "FMOD rna"
  ],
  "FMR1": [
    "FMR1 599_599_1_1_S599 phospho",
    "FMR1 methyl",
    "FMR1 proteo",
    "FMR1 rna"
  ],
  "FMR1-AS1": [
    "FMR1-AS1 methyl"
  ],
  "FMR1NB": [
    "FMR1NB methyl",
    "FMR1NB rna"
  ],
  "FN1": [
    "FN1 2310_2323_1_1_S2323 phospho",
    "FN1 2330_2353_1_0 phospho",
    "FN1 2330_2353_1_1_S2353 phospho",
    "FN1 2330_2353_1_1_T2332 phospho",
    "FN1 DQCIVDDITYNVNDTFHK-N2H5F0S0G0 glyco",
    "FN1 DQCIVDDITYNVNDTFHK-N3H4F0S0G0 glyco",
    "FN1 DQCIVDDITYNVNDTFHK-N3H4F1S0G0 glyco",
    "FN1 DQCIVDDITYNVNDTFHK-N4H3F1S0G0 glyco",
    "FN1 DQCIVDDITYNVNDTFHK-N4H4F0S0G0 glyco",
    "FN1 DQCIVDDITYNVNDTFHK-N4H4F1S0G0 glyco",
    "FN1 DQCIVDDITYNVNDTFHK-N4H4F1S1G0 glyco",
    "FN1 DQCIVDDITYNVNDTFHK-N4H5F0S0G0 glyco",
    "FN1 DQCIVDDITYNVNDTFHK-N4H5F0S1G0 glyco",
    "FN1 DQCIVDDITYNVNDTFHK-N4H5F0S2G0 glyco",
    "FN1 DQCIVDDITYNVNDTFHK-N4H5F1S0G0 glyco",
    "FN1 DQCIVDDITYNVNDTFHK-N4H5F1S1G0 glyco",
    "FN1 DQCIVDDITYNVNDTFHK-N4H5F1S2G0 glyco",
    "FN1 DQCIVDDITYNVNDTFHK-N4H5F2S1G0 glyco",
    "FN1 DQCIVDDITYNVNDTFHK-N4H6F0S0G0 glyco",
    "FN1 DQCIVDDITYNVNDTFHK-N5H3F1S0G0 glyco",
    "FN1 DQCIVDDITYNVNDTFHK-N5H4F1S0G0 glyco",
    "FN1 DQCIVDDITYNVNDTFHK-N5H5F1S0G0 glyco",
    "FN1 DQCIVDDITYNVNDTFHK-N5H6F1S1G0 glyco",
    "FN1 GGNSNGALCHFPFLYNNHNYTDCTSEGR-N4H3F1S0G0 glyco",
    "FN1 GGNSNGALCHFPFLYNNHNYTDCTSEGR-N4H4F1S0G0 glyco",
    "FN1 GGNSNGALCHFPFLYNNHNYTDCTSEGR-N4H5F0S1G0 glyco",
    "FN1 GGNSNGALCHFPFLYNNHNYTDCTSEGR-N4H5F1S0G0 glyco",
    "FN1 GGNSNGALCHFPFLYNNHNYTDCTSEGR-N4H5F1S1G0 glyco",
    "FN1 GGNSNGALCHFPFLYNNHNYTDCTSEGR-N5H3F1S0G0 glyco",
    "FN1 GGNSNGALCHFPFLYNNHNYTDCTSEGR-N6H3F3S0G0 glyco",
    "FN1 GGNSNGALCHFPFLYNNHNYTDCTSEGRR-N4H3F1S0G0 glyco",
    "FN1 GGNSNGALCHFPFLYNNHNYTDCTSEGRR-N4H4F0S0G0 glyco",
    "FN1 GGNSNGALCHFPFLYNNHNYTDCTSEGRR-N4H4F1S0G0 glyco",
    "FN1 GGNSNGALCHFPFLYNNHNYTDCTSEGRR-N4H5F0S1G0 glyco",
    "FN1 GGNSNGALCHFPFLYNNHNYTDCTSEGRR-N4H5F1S0G0 glyco",
    "FN1 GGNSNGALCHFPFLYNNHNYTDCTSEGRR-N4H5F1S1G0 glyco",
    "FN1 GGNSNGALCHFPFLYNNHNYTDCTSEGRR-N4H6F0S0G0 glyco",
    "FN1 HEEGHMLNCTCFGQGR-N2H5F0S0G0 glyco",
    "FN1 ITTTPTNGQQGNSLEEVVHADQSSCTFDNLSPGLEYNVSVYTVK-N4H5F0S1G0 glyco",
    "FN1 LDAPTNLQFVNETDSTVLVR-N2H3F1S0G0 glyco",
    "FN1 LDAPTNLQFVNETDSTVLVR-N2H5F0S0G0 glyco",
    "FN1 LDAPTNLQFVNETDSTVLVR-N3H3F1S0G0 glyco",
    "FN1 LDAPTNLQFVNETDSTVLVR-N3H4F1S0G0 glyco",
    "FN1 LDAPTNLQFVNETDSTVLVR-N4H3F1S0G0 glyco",
    "FN1 LDAPTNLQFVNETDSTVLVR-N4H4F1S0G0 glyco",
    "FN1 LDAPTNLQFVNETDSTVLVR-N4H5F0S1G0 glyco",
    "FN1 LDAPTNLQFVNETDSTVLVR-N4H5F0S2G0 glyco",
    "FN1 LDAPTNLQFVNETDSTVLVR-N4H5F1S0G0 glyco",
    "FN1 LDAPTNLQFVNETDSTVLVR-N4H5F1S1G0 glyco",
    "FN1 LDAPTNLQFVNETDSTVLVR-N5H3F1S0G0 glyco",
    "FN1 LDAPTNLQFVNETDSTVLVR-N5H4F1S0G0 glyco",
    "FN1 LDAPTNLQFVNETDSTVLVR-N5H5F1S0G0 glyco",
    "FN1 cnv",
    "FN1 methyl",
    "FN1 proteo",
    "FN1 rna"
  ],
  "FN3K": [
    "FN3K 296_303_1_1_S298 phospho",
    "FN3K cnv",
    "FN3K methyl",
    "FN3K proteo",
    "FN3K rna"
  ],
  "FN3KRP": [
    "FN3KRP cnv",
    "FN3KRP methyl",
    "FN3KRP proteo",
    "FN3KRP rna"
  ],
  "FNBP1": [
    "FNBP1 332_359_1_1_S359 phospho",
    "FNBP1 497_507_1_1_S497 phospho",
    "FNBP1 cnv",
    "FNBP1 methyl",
    "FNBP1 proteo",
    "FNBP1 rna"
  ],
  "FNBP1L": [
    "FNBP1L 430_438_1_1_S430 phospho",
    "FNBP1L cnv",
    "FNBP1L methyl",
    "FNBP1L proteo",
    "FNBP1L rna"
  ],
  "FNBP4": [
    "FNBP4 429_434_1_1_S434 phospho",
    "FNBP4 477_494_1_1_T481 phospho",
    "FNBP4 cnv",
    "FNBP4 methyl",
    "FNBP4 proteo",
    "FNBP4 rna"
  ],
  "FNDC1": [
    "FNDC1 cnv",
    "FNDC1 methyl",
    "FNDC1 rna"
  ],
  "FNDC10": [
    "FNDC10 cnv",
    "FNDC10 methyl",
    "FNDC10 rna"
  ],
  "FNDC11": [
    "FNDC11 cnv",
    "FNDC11 methyl",
    "FNDC11 rna"
  ],
  "FNDC3A": [
    "FNDC3A 202_207_1_0 phospho",
    "FNDC3A 202_207_1_1_S203 phospho",
    "FNDC3A 202_207_2_0 phospho",
    "FNDC3A 202_207_2_2_S203S207 phospho",
    "FNDC3A 213_213_1_1_S213 phospho",
    "FNDC3A 232_234_1_1_S234 phospho",
    "FNDC3A cnv",
    "FNDC3A methyl",
    "FNDC3A proteo",
    "FNDC3A rna"
  ],
  "FNDC3B": [
    "FNDC3B 208_214_1_1_S208 phospho",
    "FNDC3B cnv",
    "FNDC3B methyl",
    "FNDC3B proteo",
    "FNDC3B rna"
  ],
  "FNDC4": [
    "FNDC4 cnv",
    "FNDC4 methyl",
    "FNDC4 rna"
  ],
  "FNDC5": [
    "FNDC5 cnv",
    "FNDC5 methyl",
    "FNDC5 rna"
  ],
  "FNDC7": [
    "FNDC7 cnv",
    "FNDC7 rna"
  ],
  "FNDC8": [
    "FNDC8 cnv",
    "FNDC8 rna"
  ],
  "FNDC9": [
    "FNDC9 188_188_1_1_S188 phospho",
    "FNDC9 cnv",
    "FNDC9 methyl",
    "FNDC9 rna"
  ],
  "FNIP1": [
    "FNIP1 938_956_1_1_S946 phospho",
    "FNIP1 cnv",
    "FNIP1 methyl",
    "FNIP1 proteo",
    "FNIP1 rna"
  ],
  "FNIP2": [
    "FNIP2 cnv",
    "FNIP2 methyl",
    "FNIP2 rna"
  ],
  "FNTA": [
    "FNTA 368_375_1_1_S373 phospho",
    "FNTA cnv",
    "FNTA methyl",
    "FNTA proteo",
    "FNTA rna"
  ],
  "FNTB": [
    "FNTB cnv",
    "FNTB methyl",
    "FNTB proteo",
    "FNTB rna"
  ],
  "FOCAD": [
    "FOCAD cnv",
    "FOCAD proteo",
    "FOCAD rna"
  ],
  "FOLH1": [
    "FOLH1 NFTEIASK-N2H8F0S0G0 glyco",
    "FOLH1 cnv",
    "FOLH1 methyl",
    "FOLH1 proteo",
    "FOLH1 rna"
  ],
  "FOLR1": [
    "FOLR1 cnv",
    "FOLR1 proteo",
    "FOLR1 rna"
  ],
  "FOLR2": [
    "FOLR2 cnv",
    "FOLR2 proteo",
    "FOLR2 rna"
  ],
  "FOLR3": [
    "FOLR3 cnv",
    "FOLR3 rna"
  ],
  "FOS": [
    "FOS cnv",
    "FOS methyl",
    "FOS proteo",
    "FOS rna"
  ],
  "FOSB": [
    "FOSB cnv",
    "FOSB methyl",
    "FOSB rna"
  ],
  "FOSL1": [
    "FOSL1 cnv",
    "FOSL1 methyl",
    "FOSL1 rna"
  ],
  "FOSL2": [
    "FOSL2 16_28_1_1_S19 phospho",
    "FOSL2 194_200_1_1_S200 phospho",
    "FOSL2 200_200_1_1_S200 phospho",
    "FOSL2 cnv",
    "FOSL2 methyl",
    "FOSL2 rna"
  ],
  "FOXA1": [
    "FOXA1 cnv",
    "FOXA1 methyl",
    "FOXA1 rna"
  ],
  "FOXA2": [
    "FOXA2 cnv",
    "FOXA2 methyl",
    "FOXA2 rna"
  ],
  "FOXA3": [
    "FOXA3 cnv",
    "FOXA3 methyl",
    "FOXA3 rna"
  ],
  "FOXB1": [
    "FOXB1 cnv",
    "FOXB1 methyl",
    "FOXB1 rna"
  ],
  "FOXB2": [
    "FOXB2 cnv",
    "FOXB2 methyl",
    "FOXB2 rna"
  ],
  "FOXC1": [
    "FOXC1 228_250_2_0 phospho",
    "FOXC1 521_540_1_1_S521 phospho",
    "FOXC1 cnv",
    "FOXC1 methyl",
    "FOXC1 rna"
  ],
  "FOXC2": [
    "FOXC2 cnv",
    "FOXC2 methyl",
    "FOXC2 rna"
  ],
  "FOXD1": [
    "FOXD1 cnv",
    "FOXD1 methyl",
    "FOXD1 rna"
  ],
  "FOXD2": [
    "FOXD2 cnv",
    "FOXD2 methyl",
    "FOXD2 rna"
  ],
  "FOXD2-AS1": [
    "FOXD2-AS1 methyl"
  ],
  "FOXD3": [
    "FOXD3 cnv",
    "FOXD3 methyl",
    "FOXD3 rna"
  ],
  "FOXD3-AS1": [
    "FOXD3-AS1 methyl"
  ],
  "FOXD4": [
    "FOXD4 cnv",
    "FOXD4 rna"
  ],
  "FOXD4L1": [
    "FOXD4L1 cnv",
    "FOXD4L1 methyl",
    "FOXD4L1 rna"
  ],
  "FOXD4L3": [
    "FOXD4L3 cnv",
    "FOXD4L3 rna"
  ],
  "FOXD4L4": [
    "FOXD4L4 cnv",
    "FOXD4L4 rna"
  ],
  "FOXD4L5": [
    "FOXD4L5 cnv",
    "FOXD4L5 rna"
  ],
  "FOXD4L6": [
    "FOXD4L6 cnv",
    "FOXD4L6 rna"
  ],
  "FOXE1": [
    "FOXE1 cnv",
    "FOXE1 methyl",
    "FOXE1 rna"
  ],
  "FOXE3": [
    "FOXE3 cnv",
    "FOXE3 rna"
  ],
  "FOXF1": [
    "FOXF1 cnv",
    "FOXF1 methyl",
    "FOXF1 rna"
  ],
  "FOXF2": [
    "FOXF2 cnv",
    "FOXF2 methyl",
    "FOXF2 rna"
  ],
  "FOXG1": [
    "FOXG1 cnv",
    "FOXG1 methyl",
    "FOXG1 proteo",
    "FOXG1 rna"
  ],
  "FOXH1": [
    "FOXH1 cnv",
    "FOXH1 rna"
  ],
  "FOXI1": [
    "FOXI1 cnv",
    "FOXI1 rna"
  ],
  "FOXI2": [
    "FOXI2 cnv",
    "FOXI2 methyl",
    "FOXI2 rna"
  ],
  "FOXI3": [
    "FOXI3 cnv",
    "FOXI3 methyl",
    "FOXI3 rna"
  ],
  "FOXJ1": [
    "FOXJ1 cnv",
    "FOXJ1 methyl",
    "FOXJ1 rna"
  ],
  "FOXJ2": [
    "FOXJ2 161_172_1_1_S172 phospho",
    "FOXJ2 161_172_2_2_S164S172 phospho",
    "FOXJ2 43_55_1_0 phospho",
    "FOXJ2 43_55_1_1_S46 phospho",
    "FOXJ2 cnv",
    "FOXJ2 methyl",
    "FOXJ2 rna"
  ],
  "FOXJ3": [
    "FOXJ3 212_223_1_1_S223 phospho",
    "FOXJ3 cnv",
    "FOXJ3 methyl",
    "FOXJ3 proteo",
    "FOXJ3 rna"
  ],
  "FOXK1": [
    "FOXK1 202_223_1_1_S213 phospho",
    "FOXK1 213_223_1_1_S213 phospho",
    "FOXK1 236_257_1_0 phospho",
    "FOXK1 236_257_1_1_S243 phospho",
    "FOXK1 236_257_2_0 phospho",
    "FOXK1 288_299_1_1_S299 phospho",
    "FOXK1 288_299_2_2_S295S299 phospho",
    "FOXK1 288_320_1_1_S299 phospho",
    "FOXK1 416_428_1_1_S416 phospho",
    "FOXK1 416_428_1_1_S420 phospho",
    "FOXK1 416_428_2_0 phospho",
    "FOXK1 416_428_2_2_S416S420 phospho",
    "FOXK1 416_428_3_3_S416S420S428 phospho",
    "FOXK1 431_455_2_2_S441S445 phospho",
    "FOXK1 431_455_3_3_T436S441S445 phospho",
    "FOXK1 445_455_1_1_S445 phospho",
    "FOXK1 cnv",
    "FOXK1 proteo",
    "FOXK1 rna"
  ],
  "FOXK2": [
    "FOXK2 168_170_1_1_S170 phospho",
    "FOXK2 369_394_1_1_S373 phospho",
    "FOXK2 398_398_1_1_S398 phospho",
    "FOXK2 cnv",
    "FOXK2 methyl",
    "FOXK2 proteo",
    "FOXK2 rna"
  ],
  "FOXL1": [
    "FOXL1 cnv",
    "FOXL1 methyl",
    "FOXL1 rna"
  ],
  "FOXL2": [
    "FOXL2 cnv",
    "FOXL2 methyl",
    "FOXL2 rna"
  ],
  "FOXL2NB": [
    "FOXL2NB cnv",
    "FOXL2NB methyl",
    "FOXL2NB rna"
  ],
  "FOXL3": [
    "FOXL3 cnv",
    "FOXL3 rna"
  ],
  "FOXM1": [
    "FOXM1 cnv",
    "FOXM1 methyl",
    "FOXM1 rna"
  ],
  "FOXN1": [
    "FOXN1 cnv"
  ],
  "FOXN2": [
    "FOXN2 cnv",
    "FOXN2 methyl",
    "FOXN2 rna"
  ],
  "FOXN3": [
    "FOXN3 cnv",
    "FOXN3 methyl",
    "FOXN3 rna"
  ],
  "FOXN3-AS1": [
    "FOXN3-AS1 methyl"
  ],
  "FOXN4": [
    "FOXN4 cnv",
    "FOXN4 methyl",
    "FOXN4 rna"
  ],
  "FOXO1": [
    "FOXO1 256_261_1_1_S256 phospho",
    "FOXO1 276_293_1_1_S287 phospho",
    "FOXO1 317_351_1_1_S329 phospho",
    "FOXO1 467_489_1_1_S470 phospho",
    "FOXO1 cnv",
    "FOXO1 methyl",
    "FOXO1 proteo",
    "FOXO1 rna"
  ],
  "FOXO3": [
    "FOXO3 215_218_1_1_S215 phospho",
    "FOXO3 253_261_1_1_S253 phospho",
    "FOXO3 276_289_1_1_S284 phospho",
    "FOXO3 30_55_1_0 phospho",
    "FOXO3 cnv",
    "FOXO3 methyl",
    "FOXO3 proteo",
    "FOXO3 rna"
  ],
  "FOXO3B": [
    "FOXO3B cnv",
    "FOXO3B methyl",
    "FOXO3B rna"
  ],
  "FOXO4": [
    "FOXO4 methyl",
    "FOXO4 rna"
  ],
  "FOXO6": [
    "FOXO6 cnv",
    "FOXO6 methyl",
    "FOXO6 rna"
  ],
  "FOXP1": [
    "FOXP1 cnv",
    "FOXP1 methyl",
    "FOXP1 proteo",
    "FOXP1 rna"
  ],
  "FOXP2": [
    "FOXP2 cnv",
    "FOXP2 methyl",
    "FOXP2 rna"
  ],
  "FOXP3": [
    "FOXP3 methyl",
    "FOXP3 rna"
  ],
  "FOXP4": [
    "FOXP4 291_304_1_0 phospho",
    "FOXP4 cnv",
    "FOXP4 methyl",
    "FOXP4 rna"
  ],
  "FOXP4-AS1": [
    "FOXP4-AS1 methyl"
  ],
  "FOXQ1": [
    "FOXQ1 cnv",
    "FOXQ1 methyl",
    "FOXQ1 rna"
  ],
  "FOXR1": [
    "FOXR1 cnv",
    "FOXR1 methyl",
    "FOXR1 rna"
  ],
  "FOXR2": [
    "FOXR2 rna"
  ],
  "FOXRED1": [
    "FOXRED1 cnv",
    "FOXRED1 methyl",
    "FOXRED1 proteo",
    "FOXRED1 rna"
  ],
  "FOXRED2": [
    "FOXRED2 cnv",
    "FOXRED2 methyl",
    "FOXRED2 proteo",
    "FOXRED2 rna"
  ],
  "FOXS1": [
    "FOXS1 cnv",
    "FOXS1 rna"
  ],
  "FPGS": [
    "FPGS cnv",
    "FPGS methyl",
    "FPGS proteo",
    "FPGS rna"
  ],
  "FPGT": [
    "FPGT cnv",
    "FPGT methyl",
    "FPGT proteo",
    "FPGT rna"
  ],
  "FPGT-TNNI3K": [
    "FPGT-TNNI3K cnv",
    "FPGT-TNNI3K methyl",
    "FPGT-TNNI3K rna"
  ],
  "FPR1": [
    "FPR1 cnv",
    "FPR1 proteo",
    "FPR1 rna"
  ],
  "FPR2": [
    "FPR2 cnv",
    "FPR2 rna"
  ],
  "FPR3": [
    "FPR3 cnv",
    "FPR3 rna"
  ],
  "FRA10AC1": [
    "FRA10AC1 270_287_1_1_S278 phospho",
    "FRA10AC1 cnv",
    "FRA10AC1 methyl",
    "FRA10AC1 rna"
  ],
  "FRAS1": [
    "FRAS1 cnv",
    "FRAS1 methyl",
    "FRAS1 rna"
  ],
  "FRAT1": [
    "FRAT1 cnv",
    "FRAT1 methyl",
    "FRAT1 rna"
  ],
  "FRAT2": [
    "FRAT2 cnv",
    "FRAT2 methyl",
    "FRAT2 rna"
  ],
  "FREM1": [
    "FREM1 cnv",
    "FREM1 rna"
  ],
  "FREM2": [
    "FREM2 cnv",
    "FREM2 methyl",
    "FREM2 proteo",
    "FREM2 rna"
  ],
  "FREM3": [
    "FREM3 cnv",
    "FREM3 methyl",
    "FREM3 rna"
  ],
  "FRG1": [
    "FRG1 cnv",
    "FRG1 methyl",
    "FRG1 proteo",
    "FRG1 rna"
  ],
  "FRG1-DT": [
    "FRG1-DT methyl"
  ],
  "FRG2": [
    "FRG2 cnv",
    "FRG2 rna"
  ],
  "FRG2B": [
    "FRG2B cnv"
  ],
  "FRG2C": [
    "FRG2C cnv",
    "FRG2C rna"
  ],
  "FRK": [
    "FRK cnv",
    "FRK kinase",
    "FRK methyl",
    "FRK rna"
  ],
  "FRMD1": [
    "FRMD1 cnv",
    "FRMD1 methyl",
    "FRMD1 rna"
  ],
  "FRMD3": [
    "FRMD3 409_416_1_1_S416 phospho",
    "FRMD3 cnv",
    "FRMD3 methyl",
    "FRMD3 rna"
  ],
  "FRMD4A": [
    "FRMD4A 349_362_1_1_S349 phospho",
    "FRMD4A 349_362_1_1_S351 phospho",
    "FRMD4A 617_620_1_1_S620 phospho",
    "FRMD4A 683_690_1_1_S683 phospho",
    "FRMD4A 697_704_1_1_S697 phospho",
    "FRMD4A 725_730_2_2_S725S727 phospho",
    "FRMD4A 737_748_1_1_S743 phospho",
    "FRMD4A 811_816_1_1_S816 phospho",
    "FRMD4A 837_848_1_1_S842 phospho",
    "FRMD4A cnv",
    "FRMD4A methyl",
    "FRMD4A proteo",
    "FRMD4A rna"
  ],
  "FRMD4B": [
    "FRMD4B 602_608_1_1_S608 phospho",
    "FRMD4B 627_636_1_1_S628 phospho",
    "FRMD4B cnv",
    "FRMD4B methyl",
    "FRMD4B rna"
  ],
  "FRMD5": [
    "FRMD5 351_356_1_1_S351 phospho",
    "FRMD5 351_356_1_1_S354 phospho",
    "FRMD5 375_382_1_1_S375 phospho",
    "FRMD5 394_400_1_1_S396 phospho",
    "FRMD5 cnv",
    "FRMD5 methyl",
    "FRMD5 proteo",
    "FRMD5 rna"
  ],
  "FRMD6": [
    "FRMD6 528_536_1_1_S534 phospho",
    "FRMD6 534_536_1_1_S536 phospho",
    "FRMD6 cnv",
    "FRMD6 methyl",
    "FRMD6 rna"
  ],
  "FRMD6-AS1": [
    "FRMD6-AS1 methyl"
  ],
  "FRMD6-AS2": [
    "FRMD6-AS2 methyl"
  ],
  "FRMD7": [
    "FRMD7 rna"
  ],
  "FRMD8": [
    "FRMD8 390_404_1_1_S390 phospho",
    "FRMD8 cnv",
    "FRMD8 methyl",
    "FRMD8 proteo",
    "FRMD8 rna"
  ],
  "FRMPD1": [
    "FRMPD1 cnv",
    "FRMPD1 rna"
  ],
  "FRMPD2": [
    "FRMPD2 cnv",
    "FRMPD2 rna"
  ],
  "FRMPD3": [
    "FRMPD3 1428_1431_1_1_S1429 phospho",
    "FRMPD3 methyl",
    "FRMPD3 rna"
  ],
  "FRMPD4": [
    "FRMPD4 methyl",
    "FRMPD4 rna"
  ],
  "FRRS1": [
    "FRRS1 cnv",
    "FRRS1 rna"
  ],
  "FRRS1L": [
    "FRRS1L cnv",
    "FRRS1L methyl",
    "FRRS1L proteo",
    "FRRS1L rna"
  ],
  "FRS2": [
    "FRS2 210_211_1_0 phospho",
    "FRS2 221_234_1_1_T227 phospho",
    "FRS2 cnv",
    "FRS2 methyl",
    "FRS2 proteo",
    "FRS2 rna"
  ],
  "FRS3": [
    "FRS3 cnv",
    "FRS3 methyl",
    "FRS3 rna"
  ],
  "FRY": [
    "FRY 1938_1947_1_1_S1940 phospho",
    "FRY 1955_1972_1_1_S1955 phospho",
    "FRY 2487_2490_1_1_S2487 phospho",
    "FRY 3000_3012_1_1_S3012 phospho",
    "FRY cnv",
    "FRY methyl",
    "FRY proteo",
    "FRY rna"
  ],
  "FRYL": [
    "FRYL 1914_1935_1_0 phospho",
    "FRYL 1914_1935_1_1_S1914 phospho",
    "FRYL 1957_1959_1_1_S1957 phospho",
    "FRYL 1957_1959_1_1_T1959 phospho",
    "FRYL 2265_2278_1_1_S2272 phospho",
    "FRYL 2309_2314_1_1_S2314 phospho",
    "FRYL 2330_2347_1_1_S2332 phospho",
    "FRYL 889_906_1_1_S889 phospho",
    "FRYL cnv",
    "FRYL methyl",
    "FRYL proteo",
    "FRYL rna"
  ],
  "FRZB": [
    "FRZB cnv",
    "FRZB methyl",
    "FRZB proteo",
    "FRZB rna"
  ],
  "FSBP": [
    "FSBP cnv",
    "FSBP rna"
  ],
  "FSCB": [
    "FSCB cnv",
    "FSCB rna"
  ],
  "FSCN1": [
    "FSCN1 230_239_1_1_T239 phospho",
    "FSCN1 cnv",
    "FSCN1 methyl",
    "FSCN1 proteo",
    "FSCN1 rna"
  ],
  "FSCN2": [
    "FSCN2 cnv",
    "FSCN2 methyl",
    "FSCN2 rna"
  ],
  "FSCN3": [
    "FSCN3 cnv",
    "FSCN3 rna"
  ],
  "FSD1": [
    "FSD1 311_317_2_2_S313S317 phospho",
    "FSD1 cnv",
    "FSD1 methyl",
    "FSD1 proteo",
    "FSD1 rna"
  ],
  "FSD1L": [
    "FSD1L cnv",
    "FSD1L methyl",
    "FSD1L proteo",
    "FSD1L rna"
  ],
  "FSD2": [
    "FSD2 cnv",
    "FSD2 rna"
  ],
  "FSHB": [
    "FSHB cnv"
  ],
  "FSHR": [
    "FSHR cnv",
    "FSHR rna"
  ],
  "FSIP1": [
    "FSIP1 cnv",
    "FSIP1 methyl",
    "FSIP1 rna"
  ],
  "FSIP2": [
    "FSIP2 cnv",
    "FSIP2 methyl",
    "FSIP2 proteo",
    "FSIP2 rna"
  ],
  "FSIP2-AS2": [
    "FSIP2-AS2 methyl"
  ],
  "FST": [
    "FST cnv",
    "FST methyl",
    "FST rna"
  ],
  "FSTL1": [
    "FSTL1 161_166_1_1_S165 phospho",
    "FSTL1 GSNYSEILDK-N2H8F0S0G0 glyco",
    "FSTL1 cnv",
    "FSTL1 methyl",
    "FSTL1 proteo",
    "FSTL1 rna"
  ],
  "FSTL3": [
    "FSTL3 cnv",
    "FSTL3 methyl",
    "FSTL3 rna"
  ],
  "FSTL4": [
    "FSTL4 cnv",
    "FSTL4 methyl",
    "FSTL4 rna"
  ],
  "FSTL5": [
    "FSTL5 cnv",
    "FSTL5 rna"
  ],
  "FTCD": [
    "FTCD cnv",
    "FTCD rna"
  ],
  "FTCDNL1": [
    "FTCDNL1 cnv",
    "FTCDNL1 methyl",
    "FTCDNL1 rna"
  ],
  "FTH1": [
    "FTH1 164_183_1_1_S179 phospho",
    "FTH1 175_183_1_1_S179 phospho",
    "FTH1 cnv",
    "FTH1 methyl",
    "FTH1 proteo",
    "FTH1 rna"
  ],
  "FTHL17": [
    "FTHL17 methyl"
  ],
  "FTL": [
    "FTL cnv",
    "FTL methyl",
    "FTL proteo",
    "FTL rna"
  ],
  "FTMT": [
    "FTMT cnv",
    "FTMT methyl"
  ],
  "FTO": [
    "FTO 240_260_1_1_S256 phospho",
    "FTO 266_270_1_1_S266 phospho",
    "FTO 4_6_1_1_T4 phospho",
    "FTO cnv",
    "FTO methyl",
    "FTO proteo",
    "FTO rna"
  ],
  "FTSJ1": [
    "FTSJ1 125_142_1_1_S134 phospho",
    "FTSJ1 methyl",
    "FTSJ1 proteo",
    "FTSJ1 rna"
  ],
  "FTSJ3": [
    "FTSJ3 cnv",
    "FTSJ3 methyl",
    "FTSJ3 proteo",
    "FTSJ3 rna"
  ],
  "FTX": [
    "FTX methyl"
  ],
  "FUBP1": [
    "FUBP1 147_159_1_1_T153 phospho",
    "FUBP1 51_60_1_1_S52 phospho",
    "FUBP1 625_630_1_0 phospho",
    "FUBP1 625_630_1_1_S630 phospho",
    "FUBP1 cnv",
    "FUBP1 methyl",
    "FUBP1 proteo",
    "FUBP1 rna"
  ],
  "FUBP3": [
    "FUBP3 528_551_1_0 phospho",
    "FUBP3 528_551_1_1_S539 phospho",
    "FUBP3 558_569_1_1_S569 phospho",
    "FUBP3 cnv",
    "FUBP3 methyl",
    "FUBP3 proteo",
    "FUBP3 rna"
  ],
  "FUCA1": [
    "FUCA1 NTTSVWYTSK-N2H6F0S0G0 glyco",
    "FUCA1 cnv",
    "FUCA1 methyl",
    "FUCA1 proteo",
    "FUCA1 rna"
  ],
  "FUCA2": [
    "FUCA2 cnv",
    "FUCA2 methyl",
    "FUCA2 proteo",
    "FUCA2 rna"
  ],
  "FUNDC1": [
    "FUNDC1 proteo",
    "FUNDC1 rna"
  ],
  "FUNDC2": [
    "FUNDC2 methyl",
    "FUNDC2 proteo",
    "FUNDC2 rna"
  ],
  "FUOM": [
    "FUOM cnv",
    "FUOM methyl",
    "FUOM proteo",
    "FUOM rna"
  ],
  "FURIN": [
    "FURIN cnv",
    "FURIN methyl",
    "FURIN proteo",
    "FURIN rna"
  ],
  "FUS": [
    "FUS 337_345_1_1_S339 phospho",
    "FUS cnv",
    "FUS methyl",
    "FUS proteo",
    "FUS rna"
  ],
  "FUT1": [
    "FUT1 cnv",
    "FUT1 methyl",
    "FUT1 rna"
  ],
  "FUT10": [
    "FUT10 cnv",
    "FUT10 methyl",
    "FUT10 rna"
  ],
  "FUT11": [
    "FUT11 cnv",
    "FUT11 methyl",
    "FUT11 proteo",
    "FUT11 rna"
  ],
  "FUT2": [
    "FUT2 cnv",
    "FUT2 rna"
  ],
  "FUT3": [
    "FUT3 cnv",
    "FUT3 rna"
  ],
  "FUT4": [
    "FUT4 cnv",
    "FUT4 methyl",
    "FUT4 rna"
  ],
  "FUT5": [
    "FUT5 cnv",
    "FUT5 methyl",
    "FUT5 rna"
  ],
  "FUT6": [
    "FUT6 cnv",
    "FUT6 rna"
  ],
  "FUT7": [
    "FUT7 cnv",
    "FUT7 rna"
  ],
  "FUT8": [
    "FUT8 cnv",
    "FUT8 methyl",
    "FUT8 proteo",
    "FUT8 rna"
  ],
  "FUT9": [
    "FUT9 cnv",
    "FUT9 methyl",
    "FUT9 rna"
  ],
  "FUZ": [
    "FUZ cnv",
    "FUZ methyl",
    "FUZ rna"
  ],
  "FXN": [
    "FXN cnv",
    "FXN methyl",
    "FXN proteo",
    "FXN rna"
  ],
  "FXR1": [
    "FXR1 395_413_1_1_S409 phospho",
    "FXR1 463_500_1_0 phospho",
    "FXR1 584_592_1_1_S587 phospho",
    "FXR1 cnv",
    "FXR1 methyl",
    "FXR1 proteo",
    "FXR1 rna"
  ],
  "FXR2": [
    "FXR2 598_616_2_2_S601S603 phospho",
    "FXR2 cnv",
    "FXR2 methyl",
    "FXR2 proteo",
    "FXR2 rna"
  ],
  "FXYD1": [
    "FXYD1 70_83_1_0 phospho",
    "FXYD1 70_83_1_1_S83 phospho",
    "FXYD1 cnv",
    "FXYD1 proteo",
    "FXYD1 rna"
  ],
  "FXYD2": [
    "FXYD2 cnv",
    "FXYD2 rna"
  ],
  "FXYD3": [
    "FXYD3 cnv",
    "FXYD3 rna"
  ],
  "FXYD4": [
    "FXYD4 cnv",
    "FXYD4 rna"
  ],
  "FXYD5": [
    "FXYD5 cnv",
    "FXYD5 methyl",
    "FXYD5 rna"
  ],
  "FXYD6": [
    "FXYD6 cnv",
    "FXYD6 methyl",
    "FXYD6 proteo",
    "FXYD6 rna"
  ],
  "FXYD6-FXYD2": [
    "FXYD6-FXYD2 cnv",
    "FXYD6-FXYD2 methyl",
    "FXYD6-FXYD2 rna"
  ],
  "FXYD7": [
    "FXYD7 65_73_1_1_S65 phospho",
    "FXYD7 65_73_1_1_S68 phospho",
    "FXYD7 68_73_1_1_S72 phospho",
    "FXYD7 cnv",
    "FXYD7 methyl",
    "FXYD7 proteo",
    "FXYD7 rna"
  ],
  "FYB1": [
    "FYB1 442_478_1_1_S467 phospho",
    "FYB1 56_62_1_1_S56 phospho",
    "FYB1 574_583_1_1_Y581 phospho",
    "FYB1 683_692_1_1_S683 phospho",
    "FYB1 cnv",
    "FYB1 proteo",
    "FYB1 rna"
  ],
  "FYB2": [
    "FYB2 cnv",
    "FYB2 rna"
  ],
  "FYCO1": [
    "FYCO1 cnv",
    "FYCO1 methyl",
    "FYCO1 proteo",
    "FYCO1 rna"
  ],
  "FYN": [
    "FYN cnv",
    "FYN kinase",
    "FYN methyl",
    "FYN proteo",
    "FYN rna"
  ],
  "FYTTD1": [
    "FYTTD1 12_16_1_1_S16 phospho",
    "FYTTD1 cnv",
    "FYTTD1 methyl",
    "FYTTD1 proteo",
    "FYTTD1 rna"
  ],
  "FZD1": [
    "FZD1 cnv",
    "FZD1 methyl",
    "FZD1 proteo",
    "FZD1 rna"
  ],
  "FZD10": [
    "FZD10 cnv",
    "FZD10 methyl",
    "FZD10 rna"
  ],
  "FZD10-AS1": [
    "FZD10-AS1 methyl"
  ],
  "FZD2": [
    "FZD2 cnv",
    "FZD2 methyl",
    "FZD2 rna"
  ],
  "FZD3": [
    "FZD3 583_588_1_1_S588 phospho",
    "FZD3 664_665_1_1_S665 phospho",
    "FZD3 cnv",
    "FZD3 methyl",
    "FZD3 rna"
  ],
  "FZD4": [
    "FZD4 cnv",
    "FZD4 methyl",
    "FZD4 rna"
  ],
  "FZD4-DT": [
    "FZD4-DT methyl"
  ],
  "FZD5": [
    "FZD5 cnv",
    "FZD5 methyl",
    "FZD5 rna"
  ],
  "FZD6": [
    "FZD6 cnv",
    "FZD6 methyl",
    "FZD6 proteo",
    "FZD6 rna"
  ],
  "FZD7": [
    "FZD7 cnv",
    "FZD7 methyl",
    "FZD7 proteo",
    "FZD7 rna"
  ],
  "FZD8": [
    "FZD8 cnv",
    "FZD8 methyl",
    "FZD8 proteo",
    "FZD8 rna"
  ],
  "FZD9": [
    "FZD9 cnv",
    "FZD9 methyl",
    "FZD9 rna"
  ],
  "FZR1": [
    "FZR1 cnv",
    "FZR1 methyl",
    "FZR1 rna"
  ],
  "G0S2": [
    "G0S2 cnv",
    "G0S2 methyl",
    "G0S2 rna"
  ],
  "G2E3": [
    "G2E3 cnv",
    "G2E3 methyl",
    "G2E3 rna"
  ],
  "G3BP1": [
    "G3BP1 133_149_1_1_S149 phospho",
    "G3BP1 230_241_1_1_S232 phospho",
    "G3BP1 cnv",
    "G3BP1 methyl",
    "G3BP1 proteo",
    "G3BP1 rna"
  ],
  "G3BP2": [
    "G3BP2 225_235_1_0 phospho",
    "G3BP2 225_235_1_1_T227 phospho",
    "G3BP2 cnv",
    "G3BP2 methyl",
    "G3BP2 proteo",
    "G3BP2 rna"
  ],
  "G6PC1": [
    "G6PC1 cnv",
    "G6PC1 rna"
  ],
  "G6PC2": [
    "G6PC2 cnv",
    "G6PC2 rna"
  ],
  "G6PC3": [
    "G6PC3 cnv",
    "G6PC3 methyl",
    "G6PC3 proteo",
    "G6PC3 rna"
  ],
  "G6PD": [
    "G6PD 431_432_1_1_Y431 phospho",
    "G6PD methyl",
    "G6PD proteo",
    "G6PD rna"
  ],
  "GAA": [
    "GAA GVFITNETGQPLIGK-N2H4F0S0G0 glyco",
    "GAA GVFITNETGQPLIGK-N2H5F0S0G0 glyco",
    "GAA GVFITNETGQPLIGK-N2H6F0S0G0 glyco",
    "GAA GVFITNETGQPLIGK-N2H7F0S0G0 glyco",
    "GAA GVFITNETGQPLIGK-N2H8F0S0G0 glyco",
    "GAA GVFITNETGQPLIGK-N2H9F0S0G0 glyco",
    "GAA LENLSSSEMGYTATLTR-N2H3F0S0G0 glyco",
    "GAA LENLSSSEMGYTATLTR-N2H4F0S0G0 glyco",
    "GAA LENLSSSEMGYTATLTR-N2H5F0S0G0 glyco",
    "GAA LENLSSSEMGYTATLTR-N2H6F0S0G0 glyco",
    "GAA NNTIVNELVR-N2H3F1S0G0 glyco",
    "GAA QVVENMTR-N2H3F0S0G0 glyco",
    "GAA QVVENMTR-N2H4F0S0G0 glyco",
    "GAA QVVENMTR-N2H5F0S0G0 glyco",
    "GAA QVVENMTR-N2H6F0S0G0 glyco",
    "GAA RGVFITNETGQPLIGK-N2H6F0S0G0 glyco",
    "GAA VTVLGVATAPQQVLSNGVPVSNFTYSPDTK-N2H3F1S0G0 glyco",
    "GAA cnv",
    "GAA methyl",
    "GAA proteo",
    "GAA rna"
  ],
  "GAB1": [
    "GAB1 206_219_1_1_S209 phospho",
    "GAB1 206_228_1_1_S209 phospho",
    "GAB1 251_259_1_1_S253 phospho",
    "GAB1 274_298_1_0 phospho",
    "GAB1 274_298_1_1_S274 phospho",
    "GAB1 304_317_1_0 phospho",
    "GAB1 304_317_1_1_S304 phospho",
    "GAB1 355_361_1_1_S355 phospho",
    "GAB1 365_383_1_0 phospho",
    "GAB1 365_383_1_1_S367 phospho",
    "GAB1 365_383_2_2_S367S381 phospho",
    "GAB1 385_390_1_0 phospho",
    "GAB1 385_390_1_1_T390 phospho",
    "GAB1 417_419_1_1_S419 phospho",
    "GAB1 434_454_1_1_S454 phospho",
    "GAB1 503_503_1_1_T503 phospho",
    "GAB1 545_555_1_1_S547 phospho",
    "GAB1 581_584_1_1_S581 phospho",
    "GAB1 657_668_1_1_T668 phospho",
    "GAB1 675_689_1_0 phospho",
    "GAB1 675_689_1_1_Y689 phospho",
    "GAB1 675_689_2_0 phospho",
    "GAB1 708_718_2_2_S713T714 phospho",
    "GAB1 713_718_1_1_T714 phospho",
    "GAB1 cnv",
    "GAB1 methyl",
    "GAB1 proteo",
    "GAB1 rna"
  ],
  "GAB2": [
    "GAB2 102_111_1_0 phospho",
    "GAB2 180_187_1_1_S185 phospho",
    "GAB2 221_228_1_1_S226 phospho",
    "GAB2 353_360_1_1_T353 phospho",
    "GAB2 366_373_1_1_S367 phospho",
    "GAB2 434_457_1_1_S442 phospho",
    "GAB2 570_587_1_1_S585 phospho",
    "GAB2 94_95_1_1_S95 phospho",
    "GAB2 cnv",
    "GAB2 methyl",
    "GAB2 proteo",
    "GAB2 rna"
  ],
  "GAB3": [
    "GAB3 345_347_1_1_S345 phospho",
    "GAB3 372_372_1_1_S372 phospho",
    "GAB3 methyl",
    "GAB3 rna"
  ],
  "GAB4": [
    "GAB4 cnv",
    "GAB4 methyl",
    "GAB4 rna"
  ],
  "GABARAP": [
    "GABARAP cnv",
    "GABARAP methyl",
    "GABARAP proteo",
    "GABARAP rna"
  ],
  "GABARAPL1": [
    "GABARAPL1 cnv",
    "GABARAPL1 methyl",
    "GABARAPL1 proteo",
    "GABARAPL1 rna"
  ],
  "GABARAPL2": [
    "GABARAPL2 10_10_1_1_S10 phospho",
    "GABARAPL2 cnv",
    "GABARAPL2 methyl",
    "GABARAPL2 proteo",
    "GABARAPL2 rna"
  ],
  "GABBR1": [
    "GABBR1 699_703_1_0 phospho",
    "GABBR1 753_758_1_1_T753 phospho",
    "GABBR1 SISNMTSQEFVEK-N2H5F0S0G0 glyco",
    "GABBR1 SISNMTSQEFVEK-N5H3F1S0G0 glyco",
    "GABBR1 cnv",
    "GABBR1 methyl",
    "GABBR1 proteo",
    "GABBR1 rna"
  ],
  "GABBR2": [
    "GABBR2 763_763_1_1_T763 phospho",
    "GABBR2 874_884_1_1_S884 phospho",
    "GABBR2 884_884_1_1_S884 phospho",
    "GABBR2 IQDFNYTDHTLGR-N5H3F1S0G0 glyco",
    "GABBR2 cnv",
    "GABBR2 methyl",
    "GABBR2 proteo",
    "GABBR2 rna"
  ],
  "GABPA": [
    "GABPA cnv",
    "GABPA methyl",
    "GABPA proteo",
    "GABPA rna"
  ],
  "GABPB1": [
    "GABPB1 cnv",
    "GABPB1 methyl",
    "GABPB1 proteo",
    "GABPB1 rna"
  ],
  "GABPB1-IT1": [
    "GABPB1-IT1 methyl"
  ],
  "GABPB2": [
    "GABPB2 cnv",
    "GABPB2 methyl",
    "GABPB2 rna"
  ],
  "GABRA1": [
    "GABRA1 SVAHNMTMPNK-N2H6F0S0G0 glyco",
    "GABRA1 cnv",
    "GABRA1 proteo",
    "GABRA1 rna"
  ],
  "GABRA2": [
    "GABRA2 cnv",
    "GABRA2 methyl",
    "GABRA2 proteo",
    "GABRA2 rna"
  ],
  "GABRA3": [
    "GABRA3 423_433_1_1_S433 phospho",
    "GABRA3 437_446_1_1_S442 phospho",
    "GABRA3 proteo",
    "GABRA3 rna"
  ],
  "GABRA4": [
    "GABRA4 cnv",
    "GABRA4 methyl",
    "GABRA4 rna"
  ],
  "GABRA5": [
    "GABRA5 cnv",
    "GABRA5 methyl",
    "GABRA5 rna"
  ],
  "GABRA6": [
    "GABRA6 cnv",
    "GABRA6 rna"
  ],
  "GABRB1": [
    "GABRB1 cnv",
    "GABRB1 methyl",
    "GABRB1 proteo",
    "GABRB1 rna"
  ],
  "GABRB2": [
    "GABRB2 LSYNVIPLNLTLDNR-N2H5F0S0G0 glyco",
    "GABRB2 cnv",
    "GABRB2 methyl",
    "GABRB2 proteo",
    "GABRB2 rna"
  ],
  "GABRB3": [
    "GABRB3 LAYSGIPLNLTLDNR-N2H5F0S0G0 glyco",
    "GABRB3 cnv",
    "GABRB3 methyl",
    "GABRB3 proteo",
    "GABRB3 rna"
  ],
  "GABRD": [
    "GABRD cnv",
    "GABRD methyl",
    "GABRD rna"
  ],
  "GABRE": [
    "GABRE methyl",
    "GABRE rna"
  ],
  "GABRG1": [
    "GABRG1 cnv",
    "GABRG1 rna"
  ],
  "GABRG2": [
    "GABRG2 NTTEVVK-N2H5F0S0G0 glyco",
    "GABRG2 cnv",
    "GABRG2 proteo",
    "GABRG2 rna"
  ],
  "GABRG3": [
    "GABRG3 cnv",
    "GABRG3 methyl",
    "GABRG3 rna"
  ],
  "GABRP": [
    "GABRP cnv",
    "GABRP rna"
  ],
  "GABRQ": [
    "GABRQ methyl",
    "GABRQ rna"
  ],
  "GABRR1": [
    "GABRR1 cnv",
    "GABRR1 rna"
  ],
  "GABRR2": [
    "GABRR2 cnv",
    "GABRR2 rna"
  ],
  "GABRR3": [
    "GABRR3 cnv",
    "GABRR3 rna"
  ],
  "GAD1": [
    "GAD1 cnv",
    "GAD1 methyl",
    "GAD1 proteo",
    "GAD1 rna"
  ],
  "GAD2": [
    "GAD2 cnv",
    "GAD2 methyl",
    "GAD2 proteo",
    "GAD2 rna"
  ],
  "GADD45A": [
    "GADD45A cnv",
    "GADD45A methyl",
    "GADD45A rna"
  ],
  "GADD45B": [
    "GADD45B cnv",
    "GADD45B methyl",
    "GADD45B rna"
  ],
  "GADD45G": [
    "GADD45G cnv",
    "GADD45G methyl",
    "GADD45G rna"
  ],
  "GADD45GIP1": [
    "GADD45GIP1 cnv",
    "GADD45GIP1 methyl",
    "GADD45GIP1 proteo",
    "GADD45GIP1 rna"
  ],
  "GADL1": [
    "GADL1 cnv",
    "GADL1 methyl",
    "GADL1 rna"
  ],
  "GAGE10": [
    "GAGE10 rna"
  ],
  "GAGE12F": [
    "GAGE12F rna"
  ],
  "GAGE12J": [
    "GAGE12J rna"
  ],
  "GAGE13": [
    "GAGE13 rna"
  ],
  "GAGE2A": [
    "GAGE2A rna"
  ],
  "GAGE2E": [
    "GAGE2E rna"
  ],
  "GAK": [
    "GAK cnv",
    "GAK kinase",
    "GAK methyl",
    "GAK proteo",
    "GAK rna"
  ],
  "GAL": [
    "GAL 116_123_1_1_S116 phospho",
    "GAL cnv",
    "GAL methyl",
    "GAL rna"
  ],
  "GAL3ST1": [
    "GAL3ST1 cnv",
    "GAL3ST1 methyl",
    "GAL3ST1 rna"
  ],
  "GAL3ST2": [
    "GAL3ST2 cnv",
    "GAL3ST2 rna"
  ],
  "GAL3ST3": [
    "GAL3ST3 cnv",
    "GAL3ST3 methyl",
    "GAL3ST3 rna"
  ],
  "GAL3ST4": [
    "GAL3ST4 cnv",
    "GAL3ST4 proteo",
    "GAL3ST4 rna"
  ],
  "GALC": [
    "GALC cnv",
    "GALC methyl",
    "GALC proteo",
    "GALC rna"
  ],
  "GALE": [
    "GALE cnv",
    "GALE methyl",
    "GALE proteo",
    "GALE rna"
  ],
  "GALK1": [
    "GALK1 cnv",
    "GALK1 methyl",
    "GALK1 proteo",
    "GALK1 rna"
  ],
  "GALK2": [
    "GALK2 cnv",
    "GALK2 methyl",
    "GALK2 proteo",
    "GALK2 rna"
  ],
  "GALM": [
    "GALM cnv",
    "GALM proteo",
    "GALM rna"
  ],
  "GALNS": [
    "GALNS QGIDFCPGQNVSGVTTHNLEDHTK-N2H8F0S0G0 glyco",
    "GALNS cnv",
    "GALNS methyl",
    "GALNS proteo",
    "GALNS rna"
  ],
  "GALNT1": [
    "GALNT1 cnv",
    "GALNT1 methyl",
    "GALNT1 proteo",
    "GALNT1 rna"
  ],
  "GALNT10": [
    "GALNT10 cnv",
    "GALNT10 methyl",
    "GALNT10 proteo",
    "GALNT10 rna"
  ],
  "GALNT11": [
    "GALNT11 cnv",
    "GALNT11 methyl",
    "GALNT11 proteo",
    "GALNT11 rna"
  ],
  "GALNT12": [
    "GALNT12 cnv",
    "GALNT12 methyl",
    "GALNT12 rna"
  ],
  "GALNT13": [
    "GALNT13 cnv",
    "GALNT13 methyl",
    "GALNT13 rna"
  ],
  "GALNT14": [
    "GALNT14 cnv",
    "GALNT14 methyl",
    "GALNT14 rna"
  ],
  "GALNT15": [
    "GALNT15 cnv",
    "GALNT15 rna"
  ],
  "GALNT16": [
    "GALNT16 cnv",
    "GALNT16 methyl",
    "GALNT16 proteo",
    "GALNT16 rna"
  ],
  "GALNT17": [
    "GALNT17 cnv",
    "GALNT17 methyl",
    "GALNT17 rna"
  ],
  "GALNT18": [
    "GALNT18 cnv",
    "GALNT18 methyl",
    "GALNT18 rna"
  ],
  "GALNT2": [
    "GALNT2 56_61_1_1_S56 phospho",
    "GALNT2 cnv",
    "GALNT2 methyl",
    "GALNT2 proteo",
    "GALNT2 rna"
  ],
  "GALNT3": [
    "GALNT3 cnv",
    "GALNT3 methyl",
    "GALNT3 rna"
  ],
  "GALNT4": [
    "GALNT4 cnv",
    "GALNT4 methyl",
    "GALNT4 rna"
  ],
  "GALNT5": [
    "GALNT5 cnv",
    "GALNT5 rna"
  ],
  "GALNT6": [
    "GALNT6 cnv",
    "GALNT6 methyl",
    "GALNT6 rna"
  ],
  "GALNT7": [
    "GALNT7 103_103_1_1_S103 phospho",
    "GALNT7 cnv",
    "GALNT7 methyl",
    "GALNT7 proteo",
    "GALNT7 rna"
  ],
  "GALNT7-DT": [
    "GALNT7-DT methyl"
  ],
  "GALNT8": [
    "GALNT8 cnv",
    "GALNT8 rna"
  ],
  "GALNT9": [
    "GALNT9 cnv",
    "GALNT9 methyl",
    "GALNT9 rna"
  ],
  "GALNTL5": [
    "GALNTL5 cnv",
    "GALNTL5 rna"
  ],
  "GALNTL6": [
    "GALNTL6 cnv",
    "GALNTL6 methyl",
    "GALNTL6 rna"
  ],
  "GALP": [
    "GALP cnv",
    "GALP rna"
  ],
  "GALR1": [
    "GALR1 cnv",
    "GALR1 methyl",
    "GALR1 rna"
  ],
  "GALR2": [
    "GALR2 cnv",
    "GALR2 methyl",
    "GALR2 rna"
  ],
  "GALR3": [
    "GALR3 cnv",
    "GALR3 rna"
  ],
  "GALT": [
    "GALT cnv",
    "GALT methyl",
    "GALT proteo",
    "GALT rna"
  ],
  "GAMT": [
    "GAMT cnv",
    "GAMT methyl",
    "GAMT proteo",
    "GAMT rna"
  ],
  "GAN": [
    "GAN cnv",
    "GAN methyl",
    "GAN proteo",
    "GAN rna"
  ],
  "GANAB": [
    "GANAB cnv",
    "GANAB methyl",
    "GANAB proteo",
    "GANAB rna"
  ],
  "GANC": [
    "GANC cnv",
    "GANC methyl",
    "GANC proteo",
    "GANC rna"
  ],
  "GAP43": [
    "GAP43 121_132_1_1_S132 phospho",
    "GAP43 143_145_1_1_T143 phospho",
    "GAP43 143_145_2_2_T143S145 phospho",
    "GAP43 156_167_1_1_S166 phospho",
    "GAP43 173_190_1_0 phospho",
    "GAP43 173_190_2_1_S187 phospho",
    "GAP43 183_190_1_1_S187 phospho",
    "GAP43 183_190_2_2_S187S190 phospho",
    "GAP43 211_217_1_0 phospho",
    "GAP43 211_217_1_1_T217 phospho",
    "GAP43 228_251_1_0 phospho",
    "GAP43 228_251_1_1_S239 phospho",
    "GAP43 cnv",
    "GAP43 proteo",
    "GAP43 rna"
  ],
  "GAPDH": [
    "GAPDH 148_154_1_0 phospho",
    "GAPDH 176_184_1_0 phospho",
    "GAPDH 176_192_1_1_T184 phospho",
    "GAPDH 210_211_1_1_S210 phospho",
    "GAPDH 210_211_1_1_T211 phospho",
    "GAPDH 237_246_1_1_S241 phospho",
    "GAPDH 333_333_1_1_S333 phospho",
    "GAPDH 75_83_1_1_S83 phospho",
    "GAPDH cnv",
    "GAPDH methyl",
    "GAPDH proteo",
    "GAPDH rna"
  ],
  "GAPDHS": [
    "GAPDHS cnv",
    "GAPDHS methyl",
    "GAPDHS proteo",
    "GAPDHS rna"
  ],
  "GAPT": [
    "GAPT 74_77_1_1_S74 phospho",
    "GAPT cnv",
    "GAPT rna"
  ],
  "GAPVD1": [
    "GAPVD1 452_470_1_0 phospho",
    "GAPVD1 914_917_1_1_S914 phospho",
    "GAPVD1 cnv",
    "GAPVD1 proteo",
    "GAPVD1 rna"
  ],
  "GAR1": [
    "GAR1 cnv",
    "GAR1 proteo",
    "GAR1 rna"
  ],
  "GAREM1": [
    "GAREM1 491_499_1_1_S492 phospho",
    "GAREM1 563_580_1_1_S565 phospho",
    "GAREM1 697_705_1_1_S699 phospho",
    "GAREM1 756_766_1_0 phospho",
    "GAREM1 756_766_1_1_S758 phospho",
    "GAREM1 cnv",
    "GAREM1 methyl",
    "GAREM1 proteo",
    "GAREM1 rna"
  ],
  "GAREM2": [
    "GAREM2 727_740_1_1_S735 phospho",
    "GAREM2 cnv",
    "GAREM2 methyl",
    "GAREM2 rna"
  ],
  "GARIN1A": [
    "GARIN1A cnv",
    "GARIN1A rna"
  ],
  "GARIN1B": [
    "GARIN1B cnv",
    "GARIN1B rna"
  ],
  "GARIN2": [
    "GARIN2 cnv",
    "GARIN2 rna"
  ],
  "GARIN3": [
    "GARIN3 cnv"
  ],
  "GARIN4": [
    "GARIN4 cnv",
    "GARIN4 rna"
  ],
  "GARIN5A": [
    "GARIN5A cnv",
    "GARIN5A methyl",
    "GARIN5A rna"
  ],
  "GARIN5B": [
    "GARIN5B cnv",
    "GARIN5B rna"
  ],
  "GARIN6": [
    "GARIN6 cnv",
    "GARIN6 rna"
  ],
  "GARNL3": [
    "GARNL3 402_410_1_1_S402 phospho",
    "GARNL3 402_410_1_1_S404 phospho",
    "GARNL3 840_851_1_1_S847 phospho",
    "GARNL3 cnv",
    "GARNL3 methyl",
    "GARNL3 rna"
  ],
  "GARRE1": [
    "GARRE1 673_680_1_1_S673 phospho",
    "GARRE1 709_723_1_1_S723 phospho",
    "GARRE1 945_962_1_0 phospho",
    "GARRE1 cnv",
    "GARRE1 methyl",
    "GARRE1 proteo",
    "GARRE1 rna"
  ],
  "GARS1": [
    "GARS1 cnv",
    "GARS1 methyl",
    "GARS1 proteo",
    "GARS1 rna"
  ],
  "GART": [
    "GART 344_349_1_1_Y348 phospho",
    "GART cnv",
    "GART methyl",
    "GART proteo",
    "GART rna"
  ],
  "GAS1": [
    "GAS1 cnv",
    "GAS1 methyl",
    "GAS1 proteo",
    "GAS1 rna"
  ],
  "GAS1RR": [
    "GAS1RR methyl"
  ],
  "GAS2": [
    "GAS2 281_286_1_1_S282 phospho",
    "GAS2 cnv",
    "GAS2 methyl",
    "GAS2 proteo",
    "GAS2 rna"
  ],
  "GAS2L1": [
    "GAS2L1 290_311_2_2_S297S306 phospho",
    "GAS2L1 297_311_1_1_S306 phospho",
    "GAS2L1 297_311_2_2_S297S306 phospho",
    "GAS2L1 351_369_1_1_S352 phospho",
    "GAS2L1 479_479_1_1_S479 phospho",
    "GAS2L1 489_501_1_1_S490 phospho",
    "GAS2L1 657_672_1_1_S657 phospho",
    "GAS2L1 cnv",
    "GAS2L1 methyl",
    "GAS2L1 proteo",
    "GAS2L1 rna"
  ],
  "GAS2L2": [
    "GAS2L2 cnv",
    "GAS2L2 rna"
  ],
  "GAS2L3": [
    "GAS2L3 cnv",
    "GAS2L3 methyl",
    "GAS2L3 rna"
  ],
  "GAS5": [
    "GAS5 methyl"
  ],
  "GAS6": [
    "GAS6 cnv",
    "GAS6 proteo",
    "GAS6 rna"
  ],
  "GAS7": [
    "GAS7 30_56_1_1_S53 phospho",
    "GAS7 30_56_2_2_S47S53 phospho",
    "GAS7 312_313_1_1_S312 phospho",
    "GAS7 88_101_1_0 phospho",
    "GAS7 88_101_1_1_S88 phospho",
    "GAS7 88_101_1_1_S92 phospho",
    "GAS7 88_101_1_1_S99 phospho",
    "GAS7 88_101_1_1_T89 phospho",
    "GAS7 88_101_2_0 phospho",
    "GAS7 cnv",
    "GAS7 methyl",
    "GAS7 proteo",
    "GAS7 rna"
  ],
  "GAS8": [
    "GAS8 cnv",
    "GAS8 methyl",
    "GAS8 rna"
  ],
  "GASK1A": [
    "GASK1A cnv",
    "GASK1A methyl",
    "GASK1A rna"
  ],
  "GASK1B": [
    "GASK1B cnv",
    "GASK1B proteo",
    "GASK1B rna"
  ],
  "GAST": [
    "GAST cnv",
    "GAST rna"
  ],
  "GATA1": [
    "GATA1 rna"
  ],
  "GATA2": [
    "GATA2 cnv",
    "GATA2 methyl",
    "GATA2 rna"
  ],
  "GATA3": [
    "GATA3 cnv",
    "GATA3 methyl",
    "GATA3 rna"
  ],
  "GATA3-AS1": [
    "GATA3-AS1 methyl"
  ],
  "GATA4": [
    "GATA4 cnv",
    "GATA4 methyl",
    "GATA4 rna"
  ],
  "GATA5": [
    "GATA5 cnv",
    "GATA5 methyl",
    "GATA5 rna"
  ],
  "GATA6": [
    "GATA6 cnv",
    "GATA6 methyl",
    "GATA6 rna"
  ],
  "GATA6-AS1": [
    "GATA6-AS1 methyl"
  ],
  "GATAD1": [
    "GATAD1 cnv",
    "GATAD1 methyl",
    "GATAD1 proteo",
    "GATAD1 rna"
  ],
  "GATAD2A": [
    "GATAD2A 100_114_1_1_S100 phospho",
    "GATAD2A 100_114_2_0 phospho",
    "GATAD2A 100_114_2_2_S100S107 phospho",
    "GATAD2A 100_114_3_2_S100S107 phospho",
    "GATAD2A cnv",
    "GATAD2A methyl",
    "GATAD2A proteo",
    "GATAD2A rna"
  ],
  "GATAD2B": [
    "GATAD2B 120_135_1_1_S122 phospho",
    "GATAD2B 120_135_1_1_T120 phospho",
    "GATAD2B 120_135_2_2_T120S122 phospho",
    "GATAD2B 120_135_2_2_T120S129 phospho",
    "GATAD2B 333_348_1_0 phospho",
    "GATAD2B 333_348_1_1_S334 phospho",
    "GATAD2B 333_348_2_2_S334S338 phospho",
    "GATAD2B 486_497_1_1_S486 phospho",
    "GATAD2B cnv",
    "GATAD2B methyl",
    "GATAD2B proteo",
    "GATAD2B rna"
  ],
  "GATB": [
    "GATB cnv",
    "GATB methyl",
    "GATB proteo",
    "GATB rna"
  ],
  "GATC": [
    "GATC cnv",
    "GATC methyl",
    "GATC proteo",
    "GATC rna"
  ],
  "GATD1": [
    "GATD1 cnv",
    "GATD1 methyl",
    "GATD1 proteo",
    "GATD1 rna"
  ],
  "GATD1-DT": [
    "GATD1-DT methyl"
  ],
  "GATD3": [
    "GATD3 cnv",
    "GATD3 methyl",
    "GATD3 rna"
  ],
  "GATD3B": [
    "GATD3B cnv",
    "GATD3B rna"
  ],
  "GATM": [
    "GATM cnv",
    "GATM methyl",
    "GATM proteo",
    "GATM rna"
  ],
  "GBA": [
    "GBA DLGPTLANSTHHNVR-N2H3F1S0G0 glyco",
    "GBA DLGPTLANSTHHNVR-N3H4F1S1G0 glyco",
    "GBA TYTYADTPDDFQLHNFSLPEEDTK-N2H3F1S0G0 glyco",
    "GBA TYTYADTPDDFQLHNFSLPEEDTK-N3H4F1S1G0 glyco",
    "GBA cnv",
    "GBA proteo",
    "GBA rna"
  ],
  "GBA2": [
    "GBA2 cnv",
    "GBA2 methyl",
    "GBA2 proteo",
    "GBA2 rna"
  ],
  "GBA3": [
    "GBA3 cnv",
    "GBA3 rna"
  ],
  "GBAP1": [
    "GBAP1 methyl"
  ],
  "GBE1": [
    "GBE1 cnv",
    "GBE1 methyl",
    "GBE1 proteo",
    "GBE1 rna"
  ],
  "GBF1": [
    "GBF1 1298_1311_1_1_S1298 phospho",
    "GBF1 1316_1324_1_1_S1318 phospho",
    "GBF1 1774_1787_1_1_S1785 phospho",
    "GBF1 cnv",
    "GBF1 methyl",
    "GBF1 proteo",
    "GBF1 rna"
  ],
  "GBGT1": [
    "GBGT1 cnv",
    "GBGT1 methyl",
    "GBGT1 rna"
  ],
  "GBP1": [
    "GBP1 cnv",
    "GBP1 proteo",
    "GBP1 rna"
  ],
  "GBP2": [
    "GBP2 cnv",
    "GBP2 proteo",
    "GBP2 rna"
  ],
  "GBP3": [
    "GBP3 cnv",
    "GBP3 rna"
  ],
  "GBP4": [
    "GBP4 cnv",
    "GBP4 proteo",
    "GBP4 rna"
  ],
  "GBP5": [
    "GBP5 cnv",
    "GBP5 proteo",
    "GBP5 rna"
  ],
  "GBP6": [
    "GBP6 cnv",
    "GBP6 rna"
  ],
  "GBP7": [
    "GBP7 cnv",
    "GBP7 rna"
  ],
  "GBX1": [
    "GBX1 cnv",
    "GBX1 methyl",
    "GBX1 rna"
  ],
  "GBX2": [
    "GBX2 cnv",
    "GBX2 methyl",
    "GBX2 rna"
  ],
  "GC": [
    "GC cnv",
    "GC proteo"
  ],
  "GCA": [
    "GCA cnv",
    "GCA methyl",
    "GCA proteo",
    "GCA rna"
  ],
  "GCAT": [
    "GCAT cnv",
    "GCAT methyl",
    "GCAT proteo",
    "GCAT rna"
  ],
  "GCAWKR": [
    "GCAWKR methyl"
  ],
  "GCC1": [
    "GCC1 cnv",
    "GCC1 methyl",
    "GCC1 proteo",
    "GCC1 rna"
  ],
  "GCC2": [
    "GCC2 1480_1490_1_1_S1483 phospho",
    "GCC2 cnv",
    "GCC2 methyl",
    "GCC2 proteo",
    "GCC2 rna"
  ],
  "GCC2-AS1": [
    "GCC2-AS1 methyl"
  ],
  "GCDH": [
    "GCDH cnv",
    "GCDH proteo",
    "GCDH rna"
  ],
  "GCFC2": [
    "GCFC2 16_25_1_1_S19 phospho",
    "GCFC2 16_25_2_2_S17S19 phospho",
    "GCFC2 174_180_1_1_S174 phospho",
    "GCFC2 174_180_1_1_S180 phospho",
    "GCFC2 cnv",
    "GCFC2 methyl",
    "GCFC2 proteo",
    "GCFC2 rna"
  ],
  "GCG": [
    "GCG cnv",
    "GCG rna"
  ],
  "GCGR": [
    "GCGR cnv",
    "GCGR rna"
  ],
  "GCH1": [
    "GCH1 cnv",
    "GCH1 methyl",
    "GCH1 rna"
  ],
  "GCHFR": [
    "GCHFR cnv",
    "GCHFR methyl",
    "GCHFR proteo",
    "GCHFR rna"
  ],
  "GCK": [
    "GCK cnv",
    "GCK methyl",
    "GCK rna"
  ],
  "GCKR": [
    "GCKR cnv",
    "GCKR rna"
  ],
  "GCLC": [
    "GCLC cnv",
    "GCLC methyl",
    "GCLC proteo",
    "GCLC rna"
  ],
  "GCLM": [
    "GCLM cnv",
    "GCLM methyl",
    "GCLM proteo",
    "GCLM rna"
  ],
  "GCM1": [
    "GCM1 cnv",
    "GCM1 rna"
  ],
  "GCM2": [
    "GCM2 cnv",
    "GCM2 methyl",
    "GCM2 rna"
  ],
  "GCN1": [
    "GCN1 777_786_1_1_S786 phospho",
    "GCN1 cnv",
    "GCN1 methyl",
    "GCN1 proteo",
    "GCN1 rna"
  ],
  "GCNA": [
    "GCNA methyl",
    "GCNA rna"
  ],
  "GCNT1": [
    "GCNT1 cnv",
    "GCNT1 methyl",
    "GCNT1 rna"
  ],
  "GCNT2": [
    "GCNT2 cnv",
    "GCNT2 rna"
  ],
  "GCNT3": [
    "GCNT3 cnv",
    "GCNT3 rna"
  ],
  "GCNT4": [
    "GCNT4 cnv",
    "GCNT4 methyl",
    "GCNT4 rna"
  ],
  "GCNT7": [
    "GCNT7 cnv",
    "GCNT7 rna"
  ],
  "GCOM1": [
    "GCOM1 cnv",
    "GCOM1 methyl",
    "GCOM1 rna"
  ],
  "GCSAM": [
    "GCSAM cnv",
    "GCSAM rna"
  ],
  "GCSAML": [
    "GCSAML cnv",
    "GCSAML methyl",
    "GCSAML rna"
  ],
  "GCSH": [
    "GCSH cnv",
    "GCSH methyl",
    "GCSH proteo",
    "GCSH rna"
  ],
  "GDA": [
    "GDA 377_379_1_1_S379 phospho",
    "GDA cnv",
    "GDA methyl",
    "GDA proteo",
    "GDA rna"
  ],
  "GDAP1": [
    "GDAP1 cnv",
    "GDAP1 methyl",
    "GDAP1 proteo",
    "GDAP1 rna"
  ],
  "GDAP1L1": [
    "GDAP1L1 cnv",
    "GDAP1L1 proteo",
    "GDAP1L1 rna"
  ],
  "GDAP2": [
    "GDAP2 cnv",
    "GDAP2 methyl",
    "GDAP2 proteo",
    "GDAP2 rna"
  ],
  "GDE1": [
    "GDE1 cnv",
    "GDE1 methyl",
    "GDE1 proteo",
    "GDE1 rna"
  ],
  "GDF1": [
    "GDF1 cnv",
    "GDF1 methyl",
    "GDF1 rna"
  ],
  "GDF10": [
    "GDF10 cnv",
    "GDF10 methyl",
    "GDF10 rna"
  ],
  "GDF11": [
    "GDF11 cnv",
    "GDF11 methyl",
    "GDF11 rna"
  ],
  "GDF15": [
    "GDF15 cnv",
    "GDF15 methyl",
    "GDF15 proteo",
    "GDF15 rna"
  ],
  "GDF2": [
    "GDF2 cnv"
  ],
  "GDF3": [
    "GDF3 cnv",
    "GDF3 rna"
  ],
  "GDF5": [
    "GDF5 cnv",
    "GDF5 methyl",
    "GDF5 rna"
  ],
  "GDF6": [
    "GDF6 cnv",
    "GDF6 methyl",
    "GDF6 rna"
  ],
  "GDF7": [
    "GDF7 cnv",
    "GDF7 methyl",
    "GDF7 rna"
  ],
  "GDF9": [
    "GDF9 cnv",
    "GDF9 methyl",
    "GDF9 rna"
  ],
  "GDI1": [
    "GDI1 methyl",
    "GDI1 proteo",
    "GDI1 rna"
  ],
  "GDI2": [
    "GDI2 61_65_1_1_S61 phospho",
    "GDI2 cnv",
    "GDI2 methyl",
    "GDI2 proteo",
    "GDI2 rna"
  ],
  "GDNF": [
    "GDNF cnv",
    "GDNF methyl",
    "GDNF rna"
  ],
  "GDPD1": [
    "GDPD1 cnv",
    "GDPD1 proteo",
    "GDPD1 rna"
  ],
  "GDPD2": [
    "GDPD2 proteo",
    "GDPD2 rna"
  ],
  "GDPD3": [
    "GDPD3 cnv",
    "GDPD3 rna"
  ],
  "GDPD4": [
    "GDPD4 cnv",
    "GDPD4 rna"
  ],
  "GDPD5": [
    "GDPD5 cnv",
    "GDPD5 methyl",
    "GDPD5 rna"
  ],
  "GDPGP1": [
    "GDPGP1 cnv",
    "GDPGP1 methyl",
    "GDPGP1 proteo",
    "GDPGP1 rna"
  ],
  "GEM": [
    "GEM cnv",
    "GEM methyl",
    "GEM rna"
  ],
  "GEMIN2": [
    "GEMIN2 81_112_1_1_S81 phospho",
    "GEMIN2 cnv",
    "GEMIN2 methyl",
    "GEMIN2 proteo",
    "GEMIN2 rna"
  ],
  "GEMIN4": [
    "GEMIN4 cnv",
    "GEMIN4 methyl",
    "GEMIN4 proteo",
    "GEMIN4 rna"
  ],
  "GEMIN5": [
    "GEMIN5 750_764_1_1_S756 phospho",
    "GEMIN5 769_777_1_1_S777 phospho",
    "GEMIN5 cnv",
    "GEMIN5 methyl",
    "GEMIN5 proteo",
    "GEMIN5 rna"
  ],
  "GEMIN6": [
    "GEMIN6 cnv",
    "GEMIN6 methyl",
    "GEMIN6 proteo",
    "GEMIN6 rna"
  ],
  "GEMIN7": [
    "GEMIN7 cnv",
    "GEMIN7 methyl",
    "GEMIN7 proteo",
    "GEMIN7 rna"
  ],
  "GEMIN8": [
    "GEMIN8 methyl",
    "GEMIN8 proteo",
    "GEMIN8 rna"
  ],
  "GEN1": [
    "GEN1 cnv",
    "GEN1 methyl",
    "GEN1 rna"
  ],
  "GET1": [
    "GET1 cnv",
    "GET1 methyl",
    "GET1 rna"
  ],
  "GET1-SH3BGR": [
    "GET1-SH3BGR cnv",
    "GET1-SH3BGR methyl",
    "GET1-SH3BGR rna"
  ],
  "GET3": [
    "GET3 cnv",
    "GET3 methyl",
    "GET3 proteo",
    "GET3 rna"
  ],
  "GET4": [
    "GET4 cnv",
    "GET4 methyl",
    "GET4 proteo",
    "GET4 rna"
  ],
  "GFAP": [
    "GFAP 13_17_1_0 phospho",
    "GFAP 13_17_1_1_S13 phospho",
    "GFAP 13_17_1_1_S16 phospho",
    "GFAP 13_17_1_1_S17 phospho",
    "GFAP 240_257_1_0 phospho",
    "GFAP 240_257_1_1_S247 phospho",
    "GFAP 285_285_1_1_Y285 phospho",
    "GFAP 291_298_1_1_S291 phospho",
    "GFAP 291_298_1_1_S298 phospho",
    "GFAP 378_385_1_1_S385 phospho",
    "GFAP 397_408_1_1_S397 phospho",
    "GFAP 397_408_1_1_S403 phospho",
    "GFAP 426_426_1_1_T426 phospho",
    "GFAP 426_436_1_1_T426 phospho",
    "GFAP 438_440_1_1_S438 phospho",
    "GFAP cnv",
    "GFAP methyl",
    "GFAP proteo",
    "GFAP rna"
  ],
  "GFER": [
    "GFER cnv",
    "GFER methyl",
    "GFER proteo",
    "GFER rna"
  ],
  "GFI1": [
    "GFI1 cnv",
    "GFI1 methyl",
    "GFI1 rna"
  ],
  "GFI1B": [
    "GFI1B cnv",
    "GFI1B methyl",
    "GFI1B rna"
  ],
  "GFM1": [
    "GFM1 cnv",
    "GFM1 methyl",
    "GFM1 proteo",
    "GFM1 rna"
  ],
  "GFM2": [
    "GFM2 cnv",
    "GFM2 methyl",
    "GFM2 proteo",
    "GFM2 rna"
  ],
  "GFOD1": [
    "GFOD1 cnv",
    "GFOD1 methyl",
    "GFOD1 proteo",
    "GFOD1 rna"
  ],
  "GFOD2": [
    "GFOD2 cnv",
    "GFOD2 methyl",
    "GFOD2 rna"
  ],
  "GFPT1": [
    "GFPT1 cnv",
    "GFPT1 methyl",
    "GFPT1 proteo",
    "GFPT1 rna"
  ],
  "GFPT2": [
    "GFPT2 244_245_1_1_S244 phospho",
    "GFPT2 cnv",
    "GFPT2 methyl",
    "GFPT2 proteo",
    "GFPT2 rna"
  ],
  "GFRA1": [
    "GFRA1 cnv",
    "GFRA1 methyl",
    "GFRA1 proteo",
    "GFRA1 rna"
  ],
  "GFRA2": [
    "GFRA2 NAIQAFGNGTDVNVSPK-N5H4F2S0G0 glyco",
    "GFRA2 cnv",
    "GFRA2 methyl",
    "GFRA2 proteo",
    "GFRA2 rna"
  ],
  "GFRA3": [
    "GFRA3 cnv",
    "GFRA3 methyl",
    "GFRA3 rna"
  ],
  "GFRA4": [
    "GFRA4 cnv",
    "GFRA4 rna"
  ],
  "GFRAL": [
    "GFRAL cnv"
  ],
  "GFUS": [
    "GFUS cnv",
    "GFUS methyl",
    "GFUS proteo",
    "GFUS rna"
  ],
  "GFY": [
    "GFY cnv",
    "GFY rna"
  ],
  "GGA1": [
    "GGA1 cnv",
    "GGA1 methyl",
    "GGA1 proteo",
    "GGA1 rna"
  ],
  "GGA2": [
    "GGA2 cnv",
    "GGA2 methyl",
    "GGA2 proteo",
    "GGA2 rna"
  ],
  "GGA3": [
    "GGA3 122_126_1_1_S126 phospho",
    "GGA3 cnv",
    "GGA3 methyl",
    "GGA3 proteo",
    "GGA3 rna"
  ],
  "GGACT": [
    "GGACT cnv",
    "GGACT methyl",
    "GGACT proteo",
    "GGACT rna"
  ],
  "GGCT": [
    "GGCT cnv",
    "GGCT methyl",
    "GGCT proteo",
    "GGCT rna"
  ],
  "GGCX": [
    "GGCX cnv",
    "GGCX methyl",
    "GGCX proteo",
    "GGCX rna"
  ],
  "GGH": [
    "GGH NFTMNEK-N2H5F0S0G0 glyco",
    "GGH NFTMNEK-N2H6F0S0G0 glyco",
    "GGH NFTMNEK-N2H7F0S0G0 glyco",
    "GGH cnv",
    "GGH methyl",
    "GGH proteo",
    "GGH rna"
  ],
  "GGN": [
    "GGN cnv",
    "GGN methyl",
    "GGN rna"
  ],
  "GGNBP2": [
    "GGNBP2 cnv",
    "GGNBP2 methyl",
    "GGNBP2 rna"
  ],
  "GGPS1": [
    "GGPS1 cnv",
    "GGPS1 methyl",
    "GGPS1 proteo",
    "GGPS1 rna"
  ],
  "GGT1": [
    "GGT1 cnv",
    "GGT1 methyl",
    "GGT1 proteo",
    "GGT1 rna"
  ],
  "GGT2P": [
    "GGT2P cnv",
    "GGT2P rna"
  ],
  "GGT5": [
    "GGT5 cnv",
    "GGT5 proteo",
    "GGT5 rna"
  ],
  "GGT6": [
    "GGT6 cnv",
    "GGT6 rna"
  ],
  "GGT7": [
    "GGT7 72_83_1_0 phospho",
    "GGT7 72_83_1_1_S72 phospho",
    "GGT7 72_88_1_1_S83 phospho",
    "GGT7 72_88_2_2_S79S83 phospho",
    "GGT7 cnv",
    "GGT7 methyl",
    "GGT7 proteo",
    "GGT7 rna"
  ],
  "GGTA1": [
    "GGTA1 cnv",
    "GGTA1 methyl",
    "GGTA1 rna"
  ],
  "GGTLC1": [
    "GGTLC1 cnv",
    "GGTLC1 methyl"
  ],
  "GGTLC2": [
    "GGTLC2 cnv",
    "GGTLC2 methyl",
    "GGTLC2 rna"
  ],
  "GGTLC3": [
    "GGTLC3 cnv",
    "GGTLC3 rna"
  ],
  "GH1": [
    "GH1 cnv",
    "GH1 rna"
  ],
  "GH2": [
    "GH2 cnv"
  ],
  "GHDC": [
    "GHDC cnv",
    "GHDC proteo",
    "GHDC rna"
  ],
  "GHITM": [
    "GHITM cnv",
    "GHITM methyl",
    "GHITM proteo",
    "GHITM rna"
  ],
  "GHR": [
    "GHR cnv",
    "GHR methyl",
    "GHR rna"
  ],
  "GHRH": [
    "GHRH cnv",
    "GHRH rna"
  ],
  "GHRHR": [
    "GHRHR cnv",
    "GHRHR rna"
  ],
  "GHRL": [
    "GHRL cnv",
    "GHRL rna"
  ],
  "GHSR": [
    "GHSR cnv",
    "GHSR methyl",
    "GHSR rna"
  ],
  "GID4": [
    "GID4 cnv",
    "GID4 methyl",
    "GID4 rna"
  ],
  "GID8": [
    "GID8 cnv",
    "GID8 methyl",
    "GID8 proteo",
    "GID8 rna"
  ],
  "GIGYF1": [
    "GIGYF1 17_28_1_1_S24 phospho",
    "GIGYF1 406_412_1_1_S406 phospho",
    "GIGYF1 755_756_1_0 phospho",
    "GIGYF1 cnv",
    "GIGYF1 methyl",
    "GIGYF1 proteo",
    "GIGYF1 rna"
  ],
  "GIGYF2": [
    "GIGYF2 19_30_1_1_S26 phospho",
    "GIGYF2 19_30_2_0 phospho",
    "GIGYF2 19_30_2_2_S26S30 phospho",
    "GIGYF2 258_258_1_1_S258 phospho",
    "GIGYF2 649_665_1_1_S650 phospho",
    "GIGYF2 cnv",
    "GIGYF2 methyl",
    "GIGYF2 proteo",
    "GIGYF2 rna"
  ],
  "GIMAP1": [
    "GIMAP1 cnv",
    "GIMAP1 proteo",
    "GIMAP1 rna"
  ],
  "GIMAP1-GIMAP5": [
    "GIMAP1-GIMAP5 cnv",
    "GIMAP1-GIMAP5 rna"
  ],
  "GIMAP2": [
    "GIMAP2 cnv",
    "GIMAP2 proteo",
    "GIMAP2 rna"
  ],
  "GIMAP4": [
    "GIMAP4 cnv",
    "GIMAP4 proteo",
    "GIMAP4 rna"
  ],
  "GIMAP5": [
    "GIMAP5 cnv",
    "GIMAP5 rna"
  ],
  "GIMAP6": [
    "GIMAP6 cnv",
    "GIMAP6 proteo",
    "GIMAP6 rna"
  ],
  "GIMAP7": [
    "GIMAP7 cnv",
    "GIMAP7 rna"
  ],
  "GIMAP8": [
    "GIMAP8 cnv",
    "GIMAP8 proteo",
    "GIMAP8 rna"
  ],
  "GIMD1": [
    "GIMD1 cnv"
  ],
  "GIN1": [
    "GIN1 cnv",
    "GIN1 methyl",
    "GIN1 rna"
  ],
  "GINM1": [
    "GINM1 cnv",
    "GINM1 methyl",
    "GINM1 rna"
  ],
  "GINS1": [
    "GINS1 cnv",
    "GINS1 methyl",
    "GINS1 proteo",
    "GINS1 rna"
  ],
  "GINS2": [
    "GINS2 cnv",
    "GINS2 methyl",
    "GINS2 proteo",
    "GINS2 rna"
  ],
  "GINS3": [
    "GINS3 cnv",
    "GINS3 methyl",
    "GINS3 proteo",
    "GINS3 rna"
  ],
  "GINS4": [
    "GINS4 cnv",
    "GINS4 methyl",
    "GINS4 proteo",
    "GINS4 rna"
  ],
  "GIP": [
    "GIP cnv"
  ],
  "GIPC1": [
    "GIPC1 cnv",
    "GIPC1 methyl",
    "GIPC1 proteo",
    "GIPC1 rna"
  ],
  "GIPC2": [
    "GIPC2 cnv",
    "GIPC2 methyl",
    "GIPC2 rna"
  ],
  "GIPC3": [
    "GIPC3 cnv",
    "GIPC3 methyl",
    "GIPC3 rna"
  ],
  "GIPR": [
    "GIPR cnv",
    "GIPR methyl",
    "GIPR rna"
  ],
  "GIT1": [
    "GIT1 368_379_1_1_S371 phospho",
    "GIT1 382_412_1_1_S397 phospho",
    "GIT1 419_435_1_1_S419 phospho",
    "GIT1 489_494_1_1_T489 phospho",
    "GIT1 500_508_1_1_S507 phospho",
    "GIT1 545_563_1_1_S545 phospho",
    "GIT1 570_590_1_0 phospho",
    "GIT1 570_590_1_1_S570 phospho",
    "GIT1 601_612_1_1_S601 phospho",
    "GIT1 601_612_2_2_S601S605 phospho",
    "GIT1 cnv",
    "GIT1 proteo",
    "GIT1 rna"
  ],
  "GIT2": [
    "GIT2 375_408_1_1_S397 phospho",
    "GIT2 415_426_1_1_S415 phospho",
    "GIT2 480_500_1_0 phospho",
    "GIT2 480_500_1_1_S500 phospho",
    "GIT2 551_570_1_1_S559 phospho",
    "GIT2 586_607_1_0 phospho",
    "GIT2 614_640_1_1_S614 phospho",
    "GIT2 717_740_1_1_T726 phospho",
    "GIT2 cnv",
    "GIT2 methyl",
    "GIT2 proteo",
    "GIT2 rna"
  ],
  "GJA1": [
    "GJA1 244_255_1_1_S251 phospho",
    "GJA1 244_255_1_1_S255 phospho",
    "GJA1 244_262_1_1_S262 phospho",
    "GJA1 262_286_1_1_S262 phospho",
    "GJA1 265_286_1_0 phospho",
    "GJA1 265_286_1_1_S273 phospho",
    "GJA1 265_286_1_1_S279 phospho",
    "GJA1 265_286_1_1_S282 phospho",
    "GJA1 265_286_1_1_T275 phospho",
    "GJA1 265_286_2_0 phospho",
    "GJA1 306_314_1_1_S314 phospho",
    "GJA1 306_314_2_2_S306S314 phospho",
    "GJA1 325_344_1_0 phospho",
    "GJA1 325_344_1_1_S328 phospho",
    "GJA1 325_344_1_1_S330 phospho",
    "GJA1 325_344_1_1_S344 phospho",
    "GJA1 325_344_2_0 phospho",
    "GJA1 364_365_1_0 phospho",
    "GJA1 364_365_1_1_S365 phospho",
    "GJA1 364_369_2_0 phospho",
    "GJA1 372_373_1_1_S372 phospho",
    "GJA1 372_373_2_2_S372S373 phospho",
    "GJA1 cnv",
    "GJA1 proteo",
    "GJA1 rna"
  ],
  "GJA10": [
    "GJA10 cnv",
    "GJA10 rna"
  ],
  "GJA3": [
    "GJA3 cnv",
    "GJA3 methyl",
    "GJA3 rna"
  ],
  "GJA4": [
    "GJA4 cnv",
    "GJA4 methyl",
    "GJA4 rna"
  ],
  "GJA5": [
    "GJA5 cnv",
    "GJA5 rna"
  ],
  "GJA8": [
    "GJA8 cnv",
    "GJA8 rna"
  ],
  "GJA9": [
    "GJA9 cnv",
    "GJA9 rna"
  ],
  "GJB1": [
    "GJB1 rna"
  ],
  "GJB2": [
    "GJB2 cnv",
    "GJB2 methyl",
    "GJB2 rna"
  ],
  "GJB3": [
    "GJB3 cnv",
    "GJB3 methyl",
    "GJB3 rna"
  ],
  "GJB4": [
    "GJB4 cnv",
    "GJB4 rna"
  ],
  "GJB5": [
    "GJB5 cnv",
    "GJB5 rna"
  ],
  "GJB6": [
    "GJB6 cnv",
    "GJB6 methyl",
    "GJB6 rna"
  ],
  "GJB7": [
    "GJB7 cnv",
    "GJB7 rna"
  ],
  "GJC1": [
    "GJC1 cnv",
    "GJC1 methyl",
    "GJC1 rna"
  ],
  "GJC2": [
    "GJC2 cnv",
    "GJC2 proteo",
    "GJC2 rna"
  ],
  "GJC3": [
    "GJC3 cnv",
    "GJC3 rna"
  ],
  "GJD2": [
    "GJD2 cnv",
    "GJD2 methyl",
    "GJD2 rna"
  ],
  "GJD3": [
    "GJD3 cnv",
    "GJD3 methyl",
    "GJD3 rna"
  ],
  "GJD4": [
    "GJD4 cnv",
    "GJD4 rna"
  ],
  "GJE1": [
    "GJE1 cnv"
  ],
  "GK": [
    "GK methyl",
    "GK proteo",
    "GK rna"
  ],
  "GK2": [
    "GK2 cnv"
  ],
  "GK3P": [
    "GK3P cnv",
    "GK3P rna"
  ],
  "GK5": [
    "GK5 cnv",
    "GK5 methyl",
    "GK5 rna"
  ],
  "GKAP1": [
    "GKAP1 cnv",
    "GKAP1 methyl",
    "GKAP1 proteo",
    "GKAP1 rna"
  ],
  "GKN1": [
    "GKN1 cnv"
  ],
  "GKN2": [
    "GKN2 cnv"
  ],
  "GLA": [
    "GLA LGIYADVGNK-N2H3F1S0G0 glyco",
    "GLA LGIYADVGNK-N4H5F1S2G0 glyco",
    "GLA methyl",
    "GLA proteo",
    "GLA rna"
  ],
  "GLB1": [
    "GLB1 NNVITLNITGK-N2H3F1S0G0 glyco",
    "GLB1 NNVITLNITGK-N2H4F0S0G0 glyco",
    "GLB1 NNVITLNITGK-N2H5F0S0G0 glyco",
    "GLB1 NNVITLNITGK-N2H5F1S0G0 glyco",
    "GLB1 NNVITLNITGK-N2H6F0S0G0 glyco",
    "GLB1 NNVITLNITGK-N2H7F0S0G0 glyco",
    "GLB1 NNVITLNITGK-N2H8F0S0G0 glyco",
    "GLB1 NNVITLNITGK-N3H4F1S1G0 glyco",
    "GLB1 NNVITLNITGK-N3H6F0S1G0 glyco",
    "GLB1 cnv",
    "GLB1 methyl",
    "GLB1 proteo",
    "GLB1 rna"
  ],
  "GLB1L": [
    "GLB1L cnv",
    "GLB1L methyl",
    "GLB1L rna"
  ],
  "GLB1L2": [
    "GLB1L2 cnv",
    "GLB1L2 methyl",
    "GLB1L2 rna"
  ],
  "GLB1L3": [
    "GLB1L3 cnv",
    "GLB1L3 methyl",
    "GLB1L3 rna"
  ],
  "GLCCI1": [
    "GLCCI1 105_110_1_1_S108 phospho",
    "GLCCI1 131_134_1_1_S131 phospho",
    "GLCCI1 145_148_2_2_S145S148 phospho",
    "GLCCI1 170_182_1_1_S172 phospho",
    "GLCCI1 221_226_1_0 phospho",
    "GLCCI1 258_275_1_1_S258 phospho",
    "GLCCI1 26_39_1_1_S30 phospho",
    "GLCCI1 303_303_1_1_S303 phospho",
    "GLCCI1 394_398_1_1_S398 phospho",
    "GLCCI1 403_413_1_1_S406 phospho",
    "GLCCI1 76_94_1_1_S79 phospho",
    "GLCCI1 cnv",
    "GLCCI1 methyl",
    "GLCCI1 proteo",
    "GLCCI1 rna"
  ],
  "GLCE": [
    "GLCE 73_73_1_1_S73 phospho",
    "GLCE cnv",
    "GLCE methyl",
    "GLCE proteo",
    "GLCE rna"
  ],
  "GLDC": [
    "GLDC cnv",
    "GLDC methyl",
    "GLDC proteo",
    "GLDC rna"
  ],
  "GLDN": [
    "GLDN cnv",
    "GLDN methyl",
    "GLDN proteo",
    "GLDN rna"
  ],
  "GLE1": [
    "GLE1 cnv",
    "GLE1 methyl",
    "GLE1 proteo",
    "GLE1 rna"
  ],
  "GLG1": [
    "GLG1 cnv",
    "GLG1 proteo",
    "GLG1 rna"
  ],
  "GLI1": [
    "GLI1 cnv",
    "GLI1 rna"
  ],
  "GLI2": [
    "GLI2 1011_1015_1_1_S1014 phospho",
    "GLI2 808_820_1_1_S808 phospho",
    "GLI2 823_832_1_1_S824 phospho",
    "GLI2 941_946_1_1_S941 phospho",
    "GLI2 cnv",
    "GLI2 methyl",
    "GLI2 rna"
  ],
  "GLI3": [
    "GLI3 664_684_1_1_S664 phospho",
    "GLI3 cnv",
    "GLI3 methyl",
    "GLI3 rna"
  ],
  "GLI4": [
    "GLI4 cnv",
    "GLI4 methyl",
    "GLI4 rna"
  ],
  "GLIPR1": [
    "GLIPR1 cnv",
    "GLIPR1 proteo",
    "GLIPR1 rna"
  ],
  "GLIPR1L1": [
    "GLIPR1L1 cnv",
    "GLIPR1L1 rna"
  ],
  "GLIPR1L2": [
    "GLIPR1L2 cnv",
    "GLIPR1L2 methyl",
    "GLIPR1L2 rna"
  ],
  "GLIPR2": [
    "GLIPR2 cnv",
    "GLIPR2 methyl",
    "GLIPR2 proteo",
    "GLIPR2 rna"
  ],
  "GLIS1": [
    "GLIS1 cnv",
    "GLIS1 methyl",
    "GLIS1 rna"
  ],
  "GLIS2": [
    "GLIS2 cnv",
    "GLIS2 methyl",
    "GLIS2 rna"
  ],
  "GLIS3": [
    "GLIS3 337_348_1_1_S342 phospho",
    "GLIS3 770_778_1_1_S778 phospho",
    "GLIS3 770_778_2_2_S773S778 phospho",
    "GLIS3 cnv",
    "GLIS3 methyl",
    "GLIS3 rna"
  ],
  "GLMN": [
    "GLMN cnv",
    "GLMN methyl",
    "GLMN proteo",
    "GLMN rna"
  ],
  "GLMP": [
    "GLMP cnv",
    "GLMP proteo",
    "GLMP rna"
  ],
  "GLO1": [
    "GLO1 cnv",
    "GLO1 methyl",
    "GLO1 proteo",
    "GLO1 rna"
  ],
  "GLOD4": [
    "GLOD4 cnv",
    "GLOD4 methyl",
    "GLOD4 proteo",
    "GLOD4 rna"
  ],
  "GLOD5": [
    "GLOD5 rna"
  ],
  "GLP1R": [
    "GLP1R cnv",
    "GLP1R methyl",
    "GLP1R rna"
  ],
  "GLP2R": [
    "GLP2R cnv",
    "GLP2R rna"
  ],
  "GLRA1": [
    "GLRA1 cnv",
    "GLRA1 methyl",
    "GLRA1 rna"
  ],
  "GLRA2": [
    "GLRA2 rna"
  ],
  "GLRA3": [
    "GLRA3 cnv",
    "GLRA3 methyl",
    "GLRA3 rna"
  ],
  "GLRB": [
    "GLRB cnv",
    "GLRB methyl",
    "GLRB rna"
  ],
  "GLRX": [
    "GLRX cnv",
    "GLRX proteo",
    "GLRX rna"
  ],
  "GLRX2": [
    "GLRX2 cnv",
    "GLRX2 methyl",
    "GLRX2 proteo",
    "GLRX2 rna"
  ],
  "GLRX3": [
    "GLRX3 cnv",
    "GLRX3 proteo",
    "GLRX3 rna"
  ],
  "GLRX5": [
    "GLRX5 cnv",
    "GLRX5 methyl",
    "GLRX5 proteo",
    "GLRX5 rna"
  ],
  "GLS": [
    "GLS cnv",
    "GLS methyl",
    "GLS proteo",
    "GLS rna"
  ],
  "GLS2": [
    "GLS2 cnv",
    "GLS2 methyl",
    "GLS2 rna"
  ],
  "GLT1D1": [
    "GLT1D1 cnv",
    "GLT1D1 methyl",
    "GLT1D1 rna"
  ],
  "GLT6D1": [
    "GLT6D1 cnv"
  ],
  "GLT8D1": [
    "GLT8D1 cnv",
    "GLT8D1 methyl",
    "GLT8D1 proteo",
    "GLT8D1 rna"
  ],
  "GLT8D2": [
    "GLT8D2 cnv",
    "GLT8D2 methyl",
    "GLT8D2 rna"
  ],
  "GLTP": [
    "GLTP cnv",
    "GLTP methyl",
    "GLTP proteo",
    "GLTP rna"
  ],
  "GLTPD2": [
    "GLTPD2 cnv",
    "GLTPD2 methyl",
    "GLTPD2 rna"
  ],
  "GLUD1": [
    "GLUD1 cnv",
    "GLUD1 methyl",
    "GLUD1 proteo",
    "GLUD1 rna"
  ],
  "GLUD1P2": [
    "GLUD1P2 methyl"
  ],
  "GLUD1P3": [
    "GLUD1P3 methyl"
  ],
  "GLUD2": [
    "GLUD2 methyl",
    "GLUD2 proteo",
    "GLUD2 rna"
  ],
  "GLUL": [
    "GLUL 17_19_1_1_S19 phospho",
    "GLUL 328_328_1_1_T328 phospho",
    "GLUL 336_352_1_1_S343 phospho",
    "GLUL 343_352_1_1_S343 phospho",
    "GLUL 44_49_1_1_T46 phospho",
    "GLUL cnv",
    "GLUL methyl",
    "GLUL proteo",
    "GLUL rna"
  ],
  "GLYAT": [
    "GLYAT cnv",
    "GLYAT rna"
  ],
  "GLYATL1": [
    "GLYATL1 cnv",
    "GLYATL1 methyl",
    "GLYATL1 rna"
  ],
  "GLYATL1B": [
    "GLYATL1B cnv"
  ],
  "GLYATL2": [
    "GLYATL2 cnv",
    "GLYATL2 rna"
  ],
  "GLYATL3": [
    "GLYATL3 cnv"
  ],
  "GLYCTK": [
    "GLYCTK cnv",
    "GLYCTK methyl",
    "GLYCTK rna"
  ],
  "GLYR1": [
    "GLYR1 cnv",
    "GLYR1 methyl",
    "GLYR1 proteo",
    "GLYR1 rna"
  ],
  "GM2A": [
    "GM2A cnv",
    "GM2A methyl",
    "GM2A proteo",
    "GM2A rna"
  ],
  "GMCL1": [
    "GMCL1 cnv",
    "GMCL1 methyl",
    "GMCL1 rna"
  ],
  "GMCL2": [
    "GMCL2 cnv",
    "GMCL2 methyl",
    "GMCL2 rna"
  ],
  "GMDS": [
    "GMDS 14_14_1_1_S14 phospho",
    "GMDS cnv",
    "GMDS methyl",
    "GMDS proteo",
    "GMDS rna"
  ],
  "GMEB1": [
    "GMEB1 cnv",
    "GMEB1 methyl",
    "GMEB1 proteo",
    "GMEB1 rna"
  ],
  "GMEB2": [
    "GMEB2 cnv",
    "GMEB2 methyl",
    "GMEB2 proteo",
    "GMEB2 rna"
  ],
  "GMFB": [
    "GMFB cnv",
    "GMFB methyl",
    "GMFB proteo",
    "GMFB rna"
  ],
  "GMFG": [
    "GMFG cnv",
    "GMFG methyl",
    "GMFG proteo",
    "GMFG rna"
  ],
  "GMIP": [
    "GMIP 231_247_1_1_S234 phospho",
    "GMIP 434_446_1_1_S437 phospho",
    "GMIP cnv",
    "GMIP methyl",
    "GMIP proteo",
    "GMIP rna"
  ],
  "GML": [
    "GML cnv",
    "GML methyl"
  ],
  "GMNC": [
    "GMNC cnv",
    "GMNC methyl",
    "GMNC rna"
  ],
  "GMNN": [
    "GMNN cnv",
    "GMNN methyl",
    "GMNN rna"
  ],
  "GMPPA": [
    "GMPPA cnv",
    "GMPPA methyl",
    "GMPPA proteo",
    "GMPPA rna"
  ],
  "GMPPB": [
    "GMPPB cnv",
    "GMPPB methyl",
    "GMPPB proteo",
    "GMPPB rna"
  ],
  "GMPR": [
    "GMPR cnv",
    "GMPR methyl",
    "GMPR proteo",
    "GMPR rna"
  ],
  "GMPR2": [
    "GMPR2 cnv",
    "GMPR2 methyl",
    "GMPR2 proteo",
    "GMPR2 rna"
  ],
  "GMPS": [
    "GMPS 302_318_1_1_T318 phospho",
    "GMPS 326_332_1_1_S332 phospho",
    "GMPS cnv",
    "GMPS methyl",
    "GMPS proteo",
    "GMPS rna"
  ],
  "GNA11": [
    "GNA11 cnv",
    "GNA11 methyl",
    "GNA11 proteo",
    "GNA11 rna"
  ],
  "GNA12": [
    "GNA12 cnv",
    "GNA12 methyl",
    "GNA12 proteo",
    "GNA12 rna"
  ],
  "GNA13": [
    "GNA13 cnv",
    "GNA13 methyl",
    "GNA13 proteo",
    "GNA13 rna"
  ],
  "GNA14": [
    "GNA14 cnv",
    "GNA14 methyl",
    "GNA14 proteo",
    "GNA14 rna"
  ],
  "GNA15": [
    "GNA15 cnv",
    "GNA15 rna"
  ],
  "GNAI1": [
    "GNAI1 cnv",
    "GNAI1 methyl",
    "GNAI1 proteo",
    "GNAI1 rna"
  ],
  "GNAI2": [
    "GNAI2 cnv",
    "GNAI2 methyl",
    "GNAI2 proteo",
    "GNAI2 rna"
  ],
  "GNAI3": [
    "GNAI3 cnv",
    "GNAI3 methyl",
    "GNAI3 proteo",
    "GNAI3 rna"
  ],
  "GNAL": [
    "GNAL cnv",
    "GNAL methyl",
    "GNAL proteo",
    "GNAL rna"
  ],
  "GNAO1": [
    "GNAO1 62_62_1_1_S62 phospho",
    "GNAO1 cnv",
    "GNAO1 methyl",
    "GNAO1 proteo",
    "GNAO1 rna"
  ],
  "GNAO1-DT": [
    "GNAO1-DT methyl"
  ],
  "GNAQ": [
    "GNAQ cnv",
    "GNAQ methyl",
    "GNAQ proteo",
    "GNAQ rna"
  ],
  "GNAS": [
    "GNAS 230_235_1_1_S230 phospho",
    "GNAS 375_390_1_1_S375 phospho",
    "GNAS 532_546_1_1_S532 phospho",
    "GNAS 992_1012_1_1_S995 phospho",
    "GNAS cnv",
    "GNAS methyl",
    "GNAS proteo",
    "GNAS rna"
  ],
  "GNAS-AS1": [
    "GNAS-AS1 methyl"
  ],
  "GNAT1": [
    "GNAT1 cnv",
    "GNAT1 methyl",
    "GNAT1 rna"
  ],
  "GNAT2": [
    "GNAT2 cnv",
    "GNAT2 methyl",
    "GNAT2 rna"
  ],
  "GNAT3": [
    "GNAT3 cnv",
    "GNAT3 rna"
  ],
  "GNAZ": [
    "GNAZ cnv",
    "GNAZ methyl",
    "GNAZ proteo",
    "GNAZ rna"
  ],
  "GNB1": [
    "GNB1 cnv",
    "GNB1 methyl",
    "GNB1 proteo",
    "GNB1 rna"
  ],
  "GNB1-DT": [
    "GNB1-DT methyl"
  ],
  "GNB1L": [
    "GNB1L cnv",
    "GNB1L methyl",
    "GNB1L proteo",
    "GNB1L rna"
  ],
  "GNB2": [
    "GNB2 216_216_1_1_S216 phospho",
    "GNB2 cnv",
    "GNB2 methyl",
    "GNB2 proteo",
    "GNB2 rna"
  ],
  "GNB3": [
    "GNB3 cnv",
    "GNB3 proteo",
    "GNB3 rna"
  ],
  "GNB4": [
    "GNB4 cnv",
    "GNB4 methyl",
    "GNB4 proteo",
    "GNB4 rna"
  ],
  "GNB5": [
    "GNB5 cnv",
    "GNB5 methyl",
    "GNB5 proteo",
    "GNB5 rna"
  ],
  "GNE": [
    "GNE cnv",
    "GNE methyl",
    "GNE proteo",
    "GNE rna"
  ],
  "GNG10": [
    "GNG10 cnv",
    "GNG10 methyl",
    "GNG10 rna"
  ],
  "GNG11": [
    "GNG11 cnv",
    "GNG11 proteo",
    "GNG11 rna"
  ],
  "GNG12": [
    "GNG12 36_59_1_1_S49 phospho",
    "GNG12 cnv",
    "GNG12 methyl",
    "GNG12 proteo",
    "GNG12 rna"
  ],
  "GNG13": [
    "GNG13 cnv",
    "GNG13 methyl",
    "GNG13 rna"
  ],
  "GNG14": [
    "GNG14 cnv",
    "GNG14 rna"
  ],
  "GNG2": [
    "GNG2 52_57_1_1_T52 phospho",
    "GNG2 cnv",
    "GNG2 proteo",
    "GNG2 rna"
  ],
  "GNG3": [
    "GNG3 5_12_1_0 phospho",
    "GNG3 5_12_1_1_T5 phospho",
    "GNG3 cnv",
    "GNG3 proteo",
    "GNG3 rna"
  ],
  "GNG4": [
    "GNG4 cnv",
    "GNG4 methyl",
    "GNG4 proteo",
    "GNG4 rna"
  ],
  "GNG5": [
    "GNG5 cnv",
    "GNG5 methyl",
    "GNG5 proteo",
    "GNG5 rna"
  ],
  "GNG5P2": [
    "GNG5P2 rna"
  ],
  "GNG7": [
    "GNG7 cnv",
    "GNG7 proteo",
    "GNG7 rna"
  ],
  "GNG8": [
    "GNG8 cnv",
    "GNG8 methyl",
    "GNG8 rna"
  ],
  "GNGT1": [
    "GNGT1 cnv",
    "GNGT1 rna"
  ],
  "GNGT2": [
    "GNGT2 cnv",
    "GNGT2 rna"
  ],
  "GNL1": [
    "GNL1 319_352_1_0 phospho",
    "GNL1 319_352_1_1_S324 phospho",
    "GNL1 48_57_1_1_S51 phospho",
    "GNL1 48_57_2_2_T50S51 phospho",
    "GNL1 48_57_3_3_T48T50S51 phospho",
    "GNL1 cnv",
    "GNL1 methyl",
    "GNL1 proteo",
    "GNL1 rna"
  ],
  "GNL2": [
    "GNL2 cnv",
    "GNL2 methyl",
    "GNL2 proteo",
    "GNL2 rna"
  ],
  "GNL3": [
    "GNL3 cnv",
    "GNL3 methyl",
    "GNL3 proteo",
    "GNL3 rna"
  ],
  "GNL3L": [
    "GNL3L methyl",
    "GNL3L proteo",
    "GNL3L rna"
  ],
  "GNLY": [
    "GNLY cnv",
    "GNLY rna"
  ],
  "GNMT": [
    "GNMT cnv",
    "GNMT methyl",
    "GNMT rna"
  ],
  "GNPAT": [
    "GNPAT cnv",
    "GNPAT methyl",
    "GNPAT proteo",
    "GNPAT rna"
  ],
  "GNPDA1": [
    "GNPDA1 cnv",
    "GNPDA1 methyl",
    "GNPDA1 proteo",
    "GNPDA1 rna"
  ],
  "GNPDA2": [
    "GNPDA2 cnv",
    "GNPDA2 methyl",
    "GNPDA2 proteo",
    "GNPDA2 rna"
  ],
  "GNPNAT1": [
    "GNPNAT1 cnv",
    "GNPNAT1 methyl",
    "GNPNAT1 proteo",
    "GNPNAT1 rna"
  ],
  "GNPTAB": [
    "GNPTAB cnv",
    "GNPTAB methyl",
    "GNPTAB rna"
  ],
  "GNPTG": [
    "GNPTG cnv",
    "GNPTG methyl",
    "GNPTG proteo",
    "GNPTG rna"
  ],
  "GNRH1": [
    "GNRH1 cnv",
    "GNRH1 rna"
  ],
  "GNRH2": [
    "GNRH2 cnv",
    "GNRH2 rna"
  ],
  "GNRHR": [
    "GNRHR cnv",
    "GNRHR rna"
  ],
  "GNRHR2": [
    "GNRHR2 methyl"
  ],
  "GNS": [
    "GNS GPGIKPNQTSK-N2H3F0S0G0 glyco",
    "GNS GPGIKPNQTSK-N2H5F0S0G0 glyco",
    "GNS GPGIKPNQTSK-N2H6F0S0G0 glyco",
    "GNS GPGIKPNQTSK-N2H7F0S0G0 glyco",
    "GNS TPMTNSSIQFLDNAFR-N2H4F0S0G0 glyco",
    "GNS TPMTNSSIQFLDNAFR-N2H5F0S0G0 glyco",
    "GNS TPMTNSSIQFLDNAFR-N2H5F1S0G0 glyco",
    "GNS TPMTNSSIQFLDNAFR-N2H6F0S0G0 glyco",
    "GNS TPMTNSSIQFLDNAFR-N2H7F0S0G0 glyco",
    "GNS TPMTNSSIQFLDNAFR-N2H8F0S0G0 glyco",
    "GNS YYNYTLSINGK-N2H3F0S0G0 glyco",
    "GNS YYNYTLSINGK-N2H3F1S0G0 glyco",
    "GNS YYNYTLSINGK-N2H4F0S0G0 glyco",
    "GNS YYNYTLSINGK-N2H4F1S0G0 glyco",
    "GNS YYNYTLSINGK-N2H5F0S0G0 glyco",
    "GNS YYNYTLSINGK-N2H5F1S0G0 glyco",
    "GNS YYNYTLSINGK-N2H6F0S0G0 glyco",
    "GNS YYNYTLSINGK-N2H8F0S0G0 glyco",
    "GNS cnv",
    "GNS methyl",
    "GNS proteo",
    "GNS rna"
  ],
  "GOLGA1": [
    "GOLGA1 194_194_1_1_S194 phospho",
    "GOLGA1 cnv",
    "GOLGA1 methyl",
    "GOLGA1 proteo",
    "GOLGA1 rna"
  ],
  "GOLGA2": [
    "GOLGA2 54_70_1_1_S66 phospho",
    "GOLGA2 cnv",
    "GOLGA2 methyl",
    "GOLGA2 proteo",
    "GOLGA2 rna"
  ],
  "GOLGA3": [
    "GOLGA3 16_22_1_1_S22 phospho",
    "GOLGA3 465_472_1_1_S465 phospho",
    "GOLGA3 983_987_1_1_S983 phospho",
    "GOLGA3 cnv",
    "GOLGA3 methyl",
    "GOLGA3 proteo",
    "GOLGA3 rna"
  ],
  "GOLGA4": [
    "GOLGA4 266_277_1_1_S266 phospho",
    "GOLGA4 39_50_1_1_S41 phospho",
    "GOLGA4 39_61_1_1_S41 phospho",
    "GOLGA4 cnv",
    "GOLGA4 methyl",
    "GOLGA4 proteo",
    "GOLGA4 rna"
  ],
  "GOLGA5": [
    "GOLGA5 cnv",
    "GOLGA5 methyl",
    "GOLGA5 proteo",
    "GOLGA5 rna"
  ],
  "GOLGA6A": [
    "GOLGA6A cnv",
    "GOLGA6A rna"
  ],
  "GOLGA6B": [
    "GOLGA6B cnv",
    "GOLGA6B rna"
  ],
  "GOLGA6C": [
    "GOLGA6C cnv",
    "GOLGA6C rna"
  ],
  "GOLGA6D": [
    "GOLGA6D cnv",
    "GOLGA6D rna"
  ],
  "GOLGA6L1": [
    "GOLGA6L1 cnv"
  ],
  "GOLGA6L10": [
    "GOLGA6L10 cnv",
    "GOLGA6L10 rna"
  ],
  "GOLGA6L2": [
    "GOLGA6L2 cnv",
    "GOLGA6L2 rna"
  ],
  "GOLGA6L22": [
    "GOLGA6L22 cnv"
  ],
  "GOLGA6L24P": [
    "GOLGA6L24P cnv"
  ],
  "GOLGA6L25P": [
    "GOLGA6L25P cnv"
  ],
  "GOLGA6L4": [
    "GOLGA6L4 cnv",
    "GOLGA6L4 rna"
  ],
  "GOLGA6L6": [
    "GOLGA6L6 cnv"
  ],
  "GOLGA6L7": [
    "GOLGA6L7 cnv",
    "GOLGA6L7 rna"
  ],
  "GOLGA6L9": [
    "GOLGA6L9 cnv",
    "GOLGA6L9 rna"
  ],
  "GOLGA7": [
    "GOLGA7 cnv",
    "GOLGA7 methyl",
    "GOLGA7 proteo",
    "GOLGA7 rna"
  ],
  "GOLGA7B": [
    "GOLGA7B cnv",
    "GOLGA7B methyl",
    "GOLGA7B rna"
  ],
  "GOLGA7B-DT": [
    "GOLGA7B-DT methyl"
  ],
  "GOLGA8A": [
    "GOLGA8A cnv",
    "GOLGA8A methyl",
    "GOLGA8A rna"
  ],
  "GOLGA8B": [
    "GOLGA8B cnv",
    "GOLGA8B methyl",
    "GOLGA8B rna"
  ],
  "GOLGA8F": [
    "GOLGA8F cnv",
    "GOLGA8F rna"
  ],
  "GOLGA8G": [
    "GOLGA8G cnv"
  ],
  "GOLGA8H": [
    "GOLGA8H cnv",
    "GOLGA8H rna"
  ],
  "GOLGA8J": [
    "GOLGA8J cnv",
    "GOLGA8J rna"
  ],
  "GOLGA8K": [
    "GOLGA8K cnv",
    "GOLGA8K rna"
  ],
  "GOLGA8M": [
    "GOLGA8M cnv",
    "GOLGA8M rna"
  ],
  "GOLGA8N": [
    "GOLGA8N cnv",
    "GOLGA8N rna"
  ],
  "GOLGA8O": [
    "GOLGA8O cnv",
    "GOLGA8O rna"
  ],
  "GOLGA8Q": [
    "GOLGA8Q cnv",
    "GOLGA8Q rna"
  ],
  "GOLGA8R": [
    "GOLGA8R cnv",
    "GOLGA8R rna"
  ],
  "GOLGA8S": [
    "GOLGA8S cnv",
    "GOLGA8S rna"
  ],
  "GOLGA8T": [
    "GOLGA8T cnv",
    "GOLGA8T rna"
  ],
  "GOLGB1": [
    "GOLGB1 542_558_1_1_S542 phospho",
    "GOLGB1 cnv",
    "GOLGB1 methyl",
    "GOLGB1 proteo",
    "GOLGB1 rna"
  ],
  "GOLIM4": [
    "GOLIM4 133_133_1_1_S133 phospho",
    "GOLIM4 645_645_1_1_Y645 phospho",
    "GOLIM4 cnv",
    "GOLIM4 methyl",
    "GOLIM4 proteo",
    "GOLIM4 rna"
  ],
  "GOLM1": [
    "GOLM1 299_309_1_1_S309 phospho",
    "GOLM1 AVLVNNITTGER-N2H8F0S0G0 glyco",
    "GOLM1 cnv",
    "GOLM1 proteo",
    "GOLM1 rna"
  ],
  "GOLM2": [
    "GOLM2 232_233_1_1_S233 phospho",
    "GOLM2 328_332_1_1_S328 phospho",
    "GOLM2 366_374_1_1_S366 phospho",
    "GOLM2 cnv",
    "GOLM2 methyl",
    "GOLM2 proteo",
    "GOLM2 rna"
  ],
  "GOLPH3": [
    "GOLPH3 35_42_1_1_S36 phospho",
    "GOLPH3 cnv",
    "GOLPH3 methyl",
    "GOLPH3 proteo",
    "GOLPH3 rna"
  ],
  "GOLPH3L": [
    "GOLPH3L cnv",
    "GOLPH3L proteo",
    "GOLPH3L rna"
  ],
  "GOLT1A": [
    "GOLT1A cnv",
    "GOLT1A rna"
  ],
  "GOLT1B": [
    "GOLT1B cnv",
    "GOLT1B methyl",
    "GOLT1B proteo",
    "GOLT1B rna"
  ],
  "GON4L": [
    "GON4L 198_206_1_1_S206 phospho",
    "GON4L cnv",
    "GON4L methyl",
    "GON4L proteo",
    "GON4L rna"
  ],
  "GON7": [
    "GON7 cnv",
    "GON7 methyl",
    "GON7 proteo",
    "GON7 rna"
  ],
  "GOPC": [
    "GOPC cnv",
    "GOPC methyl",
    "GOPC proteo",
    "GOPC rna"
  ],
  "GORAB": [
    "GORAB 360_360_1_1_S360 phospho",
    "GORAB cnv",
    "GORAB proteo",
    "GORAB rna"
  ],
  "GORASP1": [
    "GORASP1 121_153_1_0 phospho",
    "GORASP1 121_153_1_1_T121 phospho",
    "GORASP1 cnv",
    "GORASP1 methyl",
    "GORASP1 proteo",
    "GORASP1 rna"
  ],
  "GORASP2": [
    "GORASP2 214_225_1_1_T222 phospho",
    "GORASP2 432_436_1_1_T433 phospho",
    "GORASP2 432_451_1_1_S451 phospho",
    "GORASP2 432_451_1_1_T433 phospho",
    "GORASP2 432_451_2_2_T433S451 phospho",
    "GORASP2 cnv",
    "GORASP2 methyl",
    "GORASP2 proteo",
    "GORASP2 rna"
  ],
  "GOSR1": [
    "GOSR1 49_60_1_1_S49 phospho",
    "GOSR1 cnv",
    "GOSR1 methyl",
    "GOSR1 proteo",
    "GOSR1 rna"
  ],
  "GOSR2": [
    "GOSR2 cnv",
    "GOSR2 methyl",
    "GOSR2 proteo",
    "GOSR2 rna"
  ],
  "GOT1": [
    "GOT1 cnv",
    "GOT1 methyl",
    "GOT1 proteo",
    "GOT1 rna"
  ],
  "GOT1L1": [
    "GOT1L1 cnv"
  ],
  "GOT2": [
    "GOT2 cnv",
    "GOT2 methyl",
    "GOT2 proteo",
    "GOT2 rna"
  ],
  "GP1BA": [
    "GP1BA cnv",
    "GP1BA proteo",
    "GP1BA rna"
  ],
  "GP1BB": [
    "GP1BB 191_193_1_1_S191 phospho",
    "GP1BB cnv",
    "GP1BB methyl",
    "GP1BB proteo",
    "GP1BB rna"
  ],
  "GP2": [
    "GP2 cnv"
  ],
  "GP5": [
    "GP5 cnv",
    "GP5 rna"
  ],
  "GP6": [
    "GP6 cnv",
    "GP6 methyl",
    "GP6 rna"
  ],
  "GP9": [
    "GP9 cnv",
    "GP9 proteo",
    "GP9 rna"
  ],
  "GPA33": [
    "GPA33 cnv",
    "GPA33 rna"
  ],
  "GPAA1": [
    "GPAA1 cnv",
    "GPAA1 methyl",
    "GPAA1 proteo",
    "GPAA1 rna"
  ],
  "GPALPP1": [
    "GPALPP1 105_105_1_1_S105 phospho",
    "GPALPP1 cnv",
    "GPALPP1 methyl",
    "GPALPP1 proteo",
    "GPALPP1 rna"
  ],
  "GPAM": [
    "GPAM cnv",
    "GPAM methyl",
    "GPAM rna"
  ],
  "GPANK1": [
    "GPANK1 cnv",
    "GPANK1 methyl",
    "GPANK1 rna"
  ],
  "GPAT2": [
    "GPAT2 cnv",
    "GPAT2 rna"
  ],
  "GPAT3": [
    "GPAT3 cnv",
    "GPAT3 methyl",
    "GPAT3 rna"
  ],
  "GPAT4": [
    "GPAT4 cnv",
    "GPAT4 methyl",
    "GPAT4 proteo",
    "GPAT4 rna"
  ],
  "GPATCH1": [
    "GPATCH1 cnv",
    "GPATCH1 methyl",
    "GPATCH1 proteo",
    "GPATCH1 rna"
  ],
  "GPATCH11": [
    "GPATCH11 120_127_1_1_S127 phospho",
    "GPATCH11 cnv",
    "GPATCH11 methyl",
    "GPATCH11 proteo",
    "GPATCH11 rna"
  ],
  "GPATCH2": [
    "GPATCH2 115_117_2_2_S115S117 phospho",
    "GPATCH2 50_54_1_1_S54 phospho",
    "GPATCH2 cnv",
    "GPATCH2 methyl",
    "GPATCH2 proteo",
    "GPATCH2 rna"
  ],
  "GPATCH2L": [
    "GPATCH2L cnv",
    "GPATCH2L methyl",
    "GPATCH2L proteo",
    "GPATCH2L rna"
  ],
  "GPATCH3": [
    "GPATCH3 cnv",
    "GPATCH3 methyl",
    "GPATCH3 rna"
  ],
  "GPATCH4": [
    "GPATCH4 cnv",
    "GPATCH4 proteo",
    "GPATCH4 rna"
  ],
  "GPATCH8": [
    "GPATCH8 1009_1014_1_1_S1014 phospho",
    "GPATCH8 1033_1038_1_1_S1035 phospho",
    "GPATCH8 1076_1081_1_1_S1081 phospho",
    "GPATCH8 1107_1115_1_0 phospho",
    "GPATCH8 635_658_1_1_S653 phospho",
    "GPATCH8 650_658_1_1_S653 phospho",
    "GPATCH8 721_740_1_1_S740 phospho",
    "GPATCH8 738_740_1_1_S740 phospho",
    "GPATCH8 905_919_3_3_S908S911S914 phospho",
    "GPATCH8 908_919_2_2_S911S914 phospho",
    "GPATCH8 974_981_2_2_S974S976 phospho",
    "GPATCH8 cnv",
    "GPATCH8 methyl",
    "GPATCH8 proteo",
    "GPATCH8 rna"
  ],
  "GPBAR1": [
    "GPBAR1 cnv",
    "GPBAR1 rna"
  ],
  "GPBP1": [
    "GPBP1 329_344_1_1_S329 phospho",
    "GPBP1 376_388_1_1_S388 phospho",
    "GPBP1 56_62_1_1_S56 phospho",
    "GPBP1 cnv",
    "GPBP1 methyl",
    "GPBP1 proteo",
    "GPBP1 rna"
  ],
  "GPBP1L1": [
    "GPBP1L1 123_126_1_1_S123 phospho",
    "GPBP1L1 49_50_1_1_S49 phospho",
    "GPBP1L1 76_82_1_1_S76 phospho",
    "GPBP1L1 cnv",
    "GPBP1L1 methyl",
    "GPBP1L1 rna"
  ],
  "GPC1": [
    "GPC1 SFDDHFQHLLNDSER-N2H5F0S0G0 glyco",
    "GPC1 SFDDHFQHLLNDSER-N4H4F1S0G0 glyco",
    "GPC1 SFDDHFQHLLNDSER-N4H5F0S0G0 glyco",
    "GPC1 SFDDHFQHLLNDSER-N4H5F1S0G0 glyco",
    "GPC1 SFDDHFQHLLNDSER-N5H3F0S0G0 glyco",
    "GPC1 SFDDHFQHLLNDSER-N5H3F1S0G0 glyco",
    "GPC1 cnv",
    "GPC1 methyl",
    "GPC1 proteo",
    "GPC1 rna"
  ],
  "GPC1-AS1": [
    "GPC1-AS1 methyl"
  ],
  "GPC2": [
    "GPC2 cnv",
    "GPC2 methyl",
    "GPC2 proteo",
    "GPC2 rna"
  ],
  "GPC3": [
    "GPC3 rna"
  ],
  "GPC4": [
    "GPC4 methyl",
    "GPC4 proteo",
    "GPC4 rna"
  ],
  "GPC5": [
    "GPC5 cnv",
    "GPC5 methyl",
    "GPC5 proteo",
    "GPC5 rna"
  ],
  "GPC6": [
    "GPC6 cnv",
    "GPC6 methyl",
    "GPC6 proteo",
    "GPC6 rna"
  ],
  "GPCPD1": [
    "GPCPD1 162_177_1_1_S175 phospho",
    "GPCPD1 cnv",
    "GPCPD1 methyl",
    "GPCPD1 proteo",
    "GPCPD1 rna"
  ],
  "GPD1": [
    "GPD1 cnv",
    "GPD1 proteo",
    "GPD1 rna"
  ],
  "GPD1L": [
    "GPD1L cnv",
    "GPD1L methyl",
    "GPD1L proteo",
    "GPD1L rna"
  ],
  "GPD2": [
    "GPD2 cnv",
    "GPD2 methyl",
    "GPD2 proteo",
    "GPD2 rna"
  ],
  "GPER1": [
    "GPER1 cnv",
    "GPER1 methyl",
    "GPER1 rna"
  ],
  "GPHA2": [
    "GPHA2 cnv",
    "GPHA2 rna"
  ],
  "GPHB5": [
    "GPHB5 cnv",
    "GPHB5 rna"
  ],
  "GPHN": [
    "GPHN 188_200_1_1_S188 phospho",
    "GPHN 188_200_1_1_S194 phospho",
    "GPHN 188_200_2_2_S188S194 phospho",
    "GPHN 188_205_3_0 phospho",
    "GPHN 280_286_1_1_T286 phospho",
    "GPHN 303_310_1_1_S305 phospho",
    "GPHN cnv",
    "GPHN methyl",
    "GPHN proteo",
    "GPHN rna"
  ],
  "GPI": [
    "GPI 107_109_1_1_S107 phospho",
    "GPI 107_109_1_1_T109 phospho",
    "GPI 212_224_1_1_T215 phospho",
    "GPI 22_22_1_1_S22 phospho",
    "GPI 237_237_1_1_S237 phospho",
    "GPI 351_359_1_1_Y351 phospho",
    "GPI 455_455_1_1_S455 phospho",
    "GPI 532_542_1_1_S532 phospho",
    "GPI cnv",
    "GPI methyl",
    "GPI proteo",
    "GPI rna"
  ],
  "GPIHBP1": [
    "GPIHBP1 cnv",
    "GPIHBP1 rna"
  ],
  "GPKOW": [
    "GPKOW 35_42_1_1_S42 phospho",
    "GPKOW methyl",
    "GPKOW proteo",
    "GPKOW rna"
  ],
  "GPLD1": [
    "GPLD1 cnv",
    "GPLD1 methyl",
    "GPLD1 proteo",
    "GPLD1 rna"
  ],
  "GPM6A": [
    "GPM6A 216_233_1_1_S221 phospho",
    "GPM6A 221_233_1_1_S232 phospho",
    "GPM6A 221_235_1_1_S235 phospho",
    "GPM6A 221_235_2_2_S232S235 phospho",
    "GPM6A 232_233_1_1_S232 phospho",
    "GPM6A 232_235_2_2_S232S235 phospho",
    "GPM6A cnv",
    "GPM6A methyl",
    "GPM6A proteo",
    "GPM6A rna"
  ],
  "GPM6B": [
    "GPM6B methyl",
    "GPM6B proteo",
    "GPM6B rna"
  ],
  "GPN1": [
    "GPN1 316_328_1_1_S326 phospho",
    "GPN1 cnv",
    "GPN1 proteo",
    "GPN1 rna"
  ],
  "GPN2": [
    "GPN2 cnv",
    "GPN2 methyl",
    "GPN2 proteo",
    "GPN2 rna"
  ],
  "GPN3": [
    "GPN3 cnv",
    "GPN3 methyl",
    "GPN3 proteo",
    "GPN3 rna"
  ],
  "GPNMB": [
    "GPNMB NDRNSSDETFLK-N2H3F1S0G0 glyco",
    "GPNMB NSSDETFLK-N2H3F0S0G0 glyco",
    "GPNMB NSSDETFLK-N2H3F1S0G0 glyco",
    "GPNMB NSSDETFLK-N3H4F1S1G0 glyco",
    "GPNMB VSVNTANVTLGPQLMEVTVYR-N2H3F0S0G0 glyco",
    "GPNMB VSVNTANVTLGPQLMEVTVYR-N2H4F0S0G0 glyco",
    "GPNMB VSVNTANVTLGPQLMEVTVYR-N2H5F0S0G0 glyco",
    "GPNMB VSVNTANVTLGPQLMEVTVYR-N2H6F0S0G0 glyco",
    "GPNMB VSVNTANVTLGPQLMEVTVYR-N2H7F0S0G0 glyco",
    "GPNMB VSVNTANVTLGPQLMEVTVYR-N3H4F0S1G0 glyco",
    "GPNMB VSVNTANVTLGPQLMEVTVYR-N3H5F0S1G0 glyco",
    "GPNMB VSVNTANVTLGPQLMEVTVYR-N3H6F0S1G0 glyco",
    "GPNMB VSVNTANVTLGPQLMEVTVYR-N4H5F0S1G0 glyco",
    "GPNMB VSVNTANVTLGPQLMEVTVYRR-N2H5F0S0G0 glyco",
    "GPNMB VSVNTANVTLGPQLMEVTVYRR-N2H6F0S0G0 glyco",
    "GPNMB cnv",
    "GPNMB proteo",
    "GPNMB rna"
  ],
  "GPR101": [
    "GPR101 methyl",
    "GPR101 rna"
  ],
  "GPR107": [
    "GPR107 cnv",
    "GPR107 methyl",
    "GPR107 proteo",
    "GPR107 rna"
  ],
  "GPR108": [
    "GPR108 cnv",
    "GPR108 methyl",
    "GPR108 proteo",
    "GPR108 rna"
  ],
  "GPR119": [
    "GPR119 rna"
  ],
  "GPR12": [
    "GPR12 cnv",
    "GPR12 methyl",
    "GPR12 rna"
  ],
  "GPR132": [
    "GPR132 cnv",
    "GPR132 rna"
  ],
  "GPR135": [
    "GPR135 cnv",
    "GPR135 methyl",
    "GPR135 rna"
  ],
  "GPR137": [
    "GPR137 cnv",
    "GPR137 methyl",
    "GPR137 rna"
  ],
  "GPR137B": [
    "GPR137B cnv",
    "GPR137B methyl",
    "GPR137B rna"
  ],
  "GPR137C": [
    "GPR137C cnv",
    "GPR137C methyl",
    "GPR137C rna"
  ],
  "GPR139": [
    "GPR139 cnv",
    "GPR139 methyl",
    "GPR139 rna"
  ],
  "GPR141": [
    "GPR141 cnv",
    "GPR141 rna"
  ],
  "GPR142": [
    "GPR142 cnv",
    "GPR142 rna"
  ],
  "GPR143": [
    "GPR143 methyl",
    "GPR143 rna"
  ],
  "GPR146": [
    "GPR146 cnv",
    "GPR146 rna"
  ],
  "GPR148": [
    "GPR148 cnv",
    "GPR148 rna"
  ],
  "GPR149": [
    "GPR149 cnv",
    "GPR149 rna"
  ],
  "GPR15": [
    "GPR15 cnv",
    "GPR15 rna"
  ],
  "GPR150": [
    "GPR150 cnv",
    "GPR150 methyl",
    "GPR150 rna"
  ],
  "GPR151": [
    "GPR151 cnv",
    "GPR151 rna"
  ],
  "GPR152": [
    "GPR152 cnv",
    "GPR152 rna"
  ],
  "GPR153": [
    "GPR153 cnv",
    "GPR153 rna"
  ],
  "GPR155": [
    "GPR155 735_744_1_1_S741 phospho",
    "GPR155 861_867_1_1_S862 phospho",
    "GPR155 cnv",
    "GPR155 methyl",
    "GPR155 proteo",
    "GPR155 rna"
  ],
  "GPR156": [
    "GPR156 cnv",
    "GPR156 methyl",
    "GPR156 rna"
  ],
  "GPR157": [
    "GPR157 cnv",
    "GPR157 methyl",
    "GPR157 rna"
  ],
  "GPR158": [
    "GPR158 770_781_1_1_S770 phospho",
    "GPR158 865_872_1_1_S865 phospho",
    "GPR158 879_887_1_1_S881 phospho",
    "GPR158 902_908_1_1_S904 phospho",
    "GPR158 cnv",
    "GPR158 methyl",
    "GPR158 proteo",
    "GPR158 rna"
  ],
  "GPR158-AS1": [
    "GPR158-AS1 methyl"
  ],
  "GPR15LG": [
    "GPR15LG cnv",
    "GPR15LG rna"
  ],
  "GPR160": [
    "GPR160 cnv",
    "GPR160 methyl",
    "GPR160 rna"
  ],
  "GPR161": [
    "GPR161 cnv",
    "GPR161 methyl",
    "GPR161 rna"
  ],
  "GPR162": [
    "GPR162 255_262_1_1_S256 phospho",
    "GPR162 413_422_1_1_S413 phospho",
    "GPR162 561_568_1_1_S561 phospho",
    "GPR162 cnv",
    "GPR162 methyl",
    "GPR162 rna"
  ],
  "GPR17": [
    "GPR17 cnv",
    "GPR17 rna"
  ],
  "GPR171": [
    "GPR171 cnv",
    "GPR171 rna"
  ],
  "GPR173": [
    "GPR173 rna"
  ],
  "GPR174": [
    "GPR174 rna"
  ],
  "GPR176": [
    "GPR176 cnv",
    "GPR176 methyl",
    "GPR176 rna"
  ],
  "GPR179": [
    "GPR179 cnv",
    "GPR179 rna"
  ],
  "GPR18": [
    "GPR18 cnv",
    "GPR18 rna"
  ],
  "GPR180": [
    "GPR180 cnv",
    "GPR180 methyl",
    "GPR180 proteo",
    "GPR180 rna"
  ],
  "GPR182": [
    "GPR182 cnv",
    "GPR182 rna"
  ],
  "GPR183": [
    "GPR183 cnv",
    "GPR183 rna"
  ],
  "GPR19": [
    "GPR19 cnv",
    "GPR19 methyl",
    "GPR19 rna"
  ],
  "GPR199P": [
    "GPR199P methyl"
  ],
  "GPR20": [
    "GPR20 cnv",
    "GPR20 rna"
  ],
  "GPR21": [
    "GPR21 cnv",
    "GPR21 rna"
  ],
  "GPR22": [
    "GPR22 cnv",
    "GPR22 rna"
  ],
  "GPR25": [
    "GPR25 cnv",
    "GPR25 rna"
  ],
  "GPR26": [
    "GPR26 cnv",
    "GPR26 methyl",
    "GPR26 rna"
  ],
  "GPR27": [
    "GPR27 cnv",
    "GPR27 methyl",
    "GPR27 rna"
  ],
  "GPR3": [
    "GPR3 cnv",
    "GPR3 methyl",
    "GPR3 rna"
  ],
  "GPR31": [
    "GPR31 cnv",
    "GPR31 rna"
  ],
  "GPR32": [
    "GPR32 cnv",
    "GPR32 rna"
  ],
  "GPR33": [
    "GPR33 cnv",
    "GPR33 rna"
  ],
  "GPR34": [
    "GPR34 rna"
  ],
  "GPR35": [
    "GPR35 cnv",
    "GPR35 methyl",
    "GPR35 rna"
  ],
  "GPR37": [
    "GPR37 cnv",
    "GPR37 methyl",
    "GPR37 proteo",
    "GPR37 rna"
  ],
  "GPR37L1": [
    "GPR37L1 457_464_1_1_S462 phospho",
    "GPR37L1 457_479_1_1_S471 phospho",
    "GPR37L1 471_479_1_1_S471 phospho",
    "GPR37L1 cnv",
    "GPR37L1 proteo",
    "GPR37L1 rna"
  ],
  "GPR39": [
    "GPR39 cnv",
    "GPR39 methyl",
    "GPR39 rna"
  ],
  "GPR4": [
    "GPR4 cnv",
    "GPR4 methyl",
    "GPR4 rna"
  ],
  "GPR42": [
    "GPR42 cnv",
    "GPR42 rna"
  ],
  "GPR45": [
    "GPR45 cnv",
    "GPR45 rna"
  ],
  "GPR50": [
    "GPR50 methyl",
    "GPR50 rna"
  ],
  "GPR50-AS1": [
    "GPR50-AS1 methyl"
  ],
  "GPR52": [
    "GPR52 cnv",
    "GPR52 rna"
  ],
  "GPR55": [
    "GPR55 cnv",
    "GPR55 rna"
  ],
  "GPR6": [
    "GPR6 cnv",
    "GPR6 methyl",
    "GPR6 rna"
  ],
  "GPR61": [
    "GPR61 cnv",
    "GPR61 rna"
  ],
  "GPR62": [
    "GPR62 cnv",
    "GPR62 rna"
  ],
  "GPR63": [
    "GPR63 cnv",
    "GPR63 methyl",
    "GPR63 rna"
  ],
  "GPR65": [
    "GPR65 cnv",
    "GPR65 rna"
  ],
  "GPR68": [
    "GPR68 cnv",
    "GPR68 methyl",
    "GPR68 rna"
  ],
  "GPR75": [
    "GPR75 cnv",
    "GPR75 methyl",
    "GPR75 rna"
  ],
  "GPR78": [
    "GPR78 cnv",
    "GPR78 methyl",
    "GPR78 rna"
  ],
  "GPR82": [
    "GPR82 rna"
  ],
  "GPR83": [
    "GPR83 cnv",
    "GPR83 methyl",
    "GPR83 rna"
  ],
  "GPR84": [
    "GPR84 cnv",
    "GPR84 rna"
  ],
  "GPR85": [
    "GPR85 cnv",
    "GPR85 rna"
  ],
  "GPR87": [
    "GPR87 cnv",
    "GPR87 rna"
  ],
  "GPR88": [
    "GPR88 cnv",
    "GPR88 rna"
  ],
  "GPR89A": [
    "GPR89A cnv",
    "GPR89A methyl",
    "GPR89A rna"
  ],
  "GPR89B": [
    "GPR89B cnv",
    "GPR89B methyl",
    "GPR89B rna"
  ],
  "GPRASP1": [
    "GPRASP1 methyl",
    "GPRASP1 proteo",
    "GPRASP1 rna"
  ],
  "GPRASP2": [
    "GPRASP2 510_521_1_1_S512 phospho",
    "GPRASP2 methyl",
    "GPRASP2 proteo",
    "GPRASP2 rna"
  ],
  "GPRC5A": [
    "GPRC5A cnv",
    "GPRC5A methyl",
    "GPRC5A rna"
  ],
  "GPRC5B": [
    "GPRC5B 468_468_1_1_S468 phospho",
    "GPRC5B 478_485_1_1_S485 phospho",
    "GPRC5B cnv",
    "GPRC5B methyl",
    "GPRC5B proteo",
    "GPRC5B rna"
  ],
  "GPRC5C": [
    "GPRC5C cnv",
    "GPRC5C methyl",
    "GPRC5C rna"
  ],
  "GPRC5D": [
    "GPRC5D cnv",
    "GPRC5D rna"
  ],
  "GPRC5D-AS1": [
    "GPRC5D-AS1 methyl"
  ],
  "GPRC6A": [
    "GPRC6A cnv"
  ],
  "GPRIN1": [
    "GPRIN1 17_40_1_0 phospho",
    "GPRIN1 17_40_1_1_S18 phospho",
    "GPRIN1 429_436_1_1_S436 phospho",
    "GPRIN1 53_69_1_1_T60 phospho",
    "GPRIN1 53_69_2_2_T60S64 phospho",
    "GPRIN1 60_69_1_1_S64 phospho",
    "GPRIN1 615_620_1_1_S615 phospho",
    "GPRIN1 73_84_1_1_S73 phospho",
    "GPRIN1 73_84_1_1_S75 phospho",
    "GPRIN1 870_877_1_1_T877 phospho",
    "GPRIN1 895_914_1_1_S895 phospho",
    "GPRIN1 cnv",
    "GPRIN1 methyl",
    "GPRIN1 proteo",
    "GPRIN1 rna"
  ],
  "GPRIN2": [
    "GPRIN2 cnv",
    "GPRIN2 methyl",
    "GPRIN2 rna"
  ],
  "GPRIN3": [
    "GPRIN3 13_32_1_1_S32 phospho",
    "GPRIN3 210_214_1_1_S214 phospho",
    "GPRIN3 332_341_1_1_S336 phospho",
    "GPRIN3 332_341_2_2_S332S336 phospho",
    "GPRIN3 48_57_1_1_S57 phospho",
    "GPRIN3 734_741_1_1_S734 phospho",
    "GPRIN3 751_755_1_1_S751 phospho",
    "GPRIN3 cnv",
    "GPRIN3 methyl",
    "GPRIN3 proteo",
    "GPRIN3 rna"
  ],
  "GPS1": [
    "GPS1 308_315_1_1_S308 phospho",
    "GPS1 536_553_1_1_S536 phospho",
    "GPS1 542_553_1_1_T547 phospho",
    "GPS1 542_553_2_2_T547S551 phospho",
    "GPS1 cnv",
    "GPS1 methyl",
    "GPS1 proteo",
    "GPS1 rna"
  ],
  "GPS2": [
    "GPS2 cnv",
    "GPS2 methyl",
    "GPS2 proteo",
    "GPS2 rna"
  ],
  "GPSM1": [
    "GPSM1 134_134_1_1_S134 phospho",
    "GPSM1 492_503_1_1_S492 phospho",
    "GPSM1 569_572_1_1_S569 phospho",
    "GPSM1 cnv",
    "GPSM1 methyl",
    "GPSM1 proteo",
    "GPSM1 rna"
  ],
  "GPSM2": [
    "GPSM2 408_408_1_1_S408 phospho",
    "GPSM2 cnv",
    "GPSM2 methyl",
    "GPSM2 proteo",
    "GPSM2 rna"
  ],
  "GPSM3": [
    "GPSM3 35_45_1_1_S39 phospho",
    "GPSM3 35_45_2_2_S35S39 phospho",
    "GPSM3 cnv",
    "GPSM3 methyl",
    "GPSM3 proteo",
    "GPSM3 rna"
  ],
  "GPT": [
    "GPT cnv",
    "GPT proteo",
    "GPT rna"
  ],
  "GPT2": [
    "GPT2 cnv",
    "GPT2 methyl",
    "GPT2 proteo",
    "GPT2 rna"
  ],
  "GPX1": [
    "GPX1 cnv",
    "GPX1 methyl",
    "GPX1 proteo",
    "GPX1 rna"
  ],
  "GPX2": [
    "GPX2 cnv",
    "GPX2 rna"
  ],
  "GPX3": [
    "GPX3 cnv",
    "GPX3 methyl",
    "GPX3 proteo",
    "GPX3 rna"
  ],
  "GPX4": [
    "GPX4 cnv",
    "GPX4 methyl",
    "GPX4 proteo",
    "GPX4 rna"
  ],
  "GPX5": [
    "GPX5 cnv"
  ],
  "GPX6": [
    "GPX6 cnv"
  ],
  "GPX7": [
    "GPX7 cnv",
    "GPX7 methyl",
    "GPX7 proteo",
    "GPX7 rna"
  ],
  "GPX8": [
    "GPX8 cnv",
    "GPX8 proteo",
    "GPX8 rna"
  ],
  "GRAMD1A": [
    "GRAMD1A 270_274_1_1_T270 phospho",
    "GRAMD1A 277_278_1_0 phospho",
    "GRAMD1A 576_582_1_1_S579 phospho",
    "GRAMD1A cnv",
    "GRAMD1A methyl",
    "GRAMD1A proteo",
    "GRAMD1A rna"
  ],
  "GRAMD1B": [
    "GRAMD1B 272_281_1_1_S281 phospho",
    "GRAMD1B 28_40_1_1_S30 phospho",
    "GRAMD1B 545_557_1_1_S557 phospho",
    "GRAMD1B cnv",
    "GRAMD1B methyl",
    "GRAMD1B proteo",
    "GRAMD1B rna"
  ],
  "GRAMD1C": [
    "GRAMD1C 322_327_1_1_S326 phospho",
    "GRAMD1C cnv",
    "GRAMD1C methyl",
    "GRAMD1C rna"
  ],
  "GRAMD2A": [
    "GRAMD2A cnv",
    "GRAMD2A rna"
  ],
  "GRAMD2B": [
    "GRAMD2B 44_58_1_1_S49 phospho",
    "GRAMD2B cnv",
    "GRAMD2B methyl",
    "GRAMD2B proteo",
    "GRAMD2B rna"
  ],
  "GRAMD4": [
    "GRAMD4 cnv",
    "GRAMD4 methyl",
    "GRAMD4 proteo",
    "GRAMD4 rna"
  ],
  "GRAP": [
    "GRAP cnv",
    "GRAP rna"
  ],
  "GRAP2": [
    "GRAP2 cnv",
    "GRAP2 rna"
  ],
  "GRAPL": [
    "GRAPL cnv",
    "GRAPL rna"
  ],
  "GRASLND": [
    "GRASLND methyl"
  ],
  "GRB10": [
    "GRB10 cnv",
    "GRB10 methyl",
    "GRB10 proteo",
    "GRB10 rna"
  ],
  "GRB14": [
    "GRB14 cnv",
    "GRB14 rna"
  ],
  "GRB2": [
    "GRB2 88_98_1_1_S90 phospho",
    "GRB2 cnv",
    "GRB2 methyl",
    "GRB2 proteo",
    "GRB2 rna"
  ],
  "GRB7": [
    "GRB7 cnv",
    "GRB7 rna"
  ],
  "GREB1": [
    "GREB1 cnv",
    "GREB1 rna"
  ],
  "GREB1L": [
    "GREB1L cnv",
    "GREB1L methyl",
    "GREB1L rna"
  ],
  "GREM1": [
    "GREM1 cnv",
    "GREM1 methyl",
    "GREM1 rna"
  ],
  "GREM1-AS1": [
    "GREM1-AS1 methyl"
  ],
  "GREM2": [
    "GREM2 cnv",
    "GREM2 rna"
  ],
  "GREP1": [
    "GREP1 cnv",
    "GREP1 rna"
  ],
  "GRHL1": [
    "GRHL1 cnv",
    "GRHL1 methyl",
    "GRHL1 rna"
  ],
  "GRHL2": [
    "GRHL2 cnv",
    "GRHL2 methyl",
    "GRHL2 rna"
  ],
  "GRHL3": [
    "GRHL3 cnv",
    "GRHL3 methyl",
    "GRHL3 rna"
  ],
  "GRHPR": [
    "GRHPR cnv",
    "GRHPR methyl",
    "GRHPR proteo",
    "GRHPR rna"
  ],
  "GRIA1": [
    "GRIA1 849_849_1_1_S849 phospho",
    "GRIA1 cnv",
    "GRIA1 proteo",
    "GRIA1 rna"
  ],
  "GRIA2": [
    "GRIA2 858_869_2_2_S860S863 phospho",
    "GRIA2 IQFGGANVSGFQIVDYDDSLVSK-N2H5F0S0G0 glyco",
    "GRIA2 IQFGGANVSGFQIVDYDDSLVSK-N2H6F0S0G0 glyco",
    "GRIA2 IQFGGANVSGFQIVDYDDSLVSK-N2H7F0S0G0 glyco",
    "GRIA2 IQFGGANVSGFQIVDYDDSLVSK-N2H8F0S0G0 glyco",
    "GRIA2 RINYTINIMELK-N2H6F0S0G0 glyco",
    "GRIA2 cnv",
    "GRIA2 methyl",
    "GRIA2 proteo",
    "GRIA2 rna"
  ],
  "GRIA3": [
    "GRIA3 proteo",
    "GRIA3 rna"
  ],
  "GRIA4": [
    "GRIA4 FIHGGANVTGFQLVDFNTPMVIK-N2H6F0S0G0 glyco",
    "GRIA4 FIHGGANVTGFQLVDFNTPMVIK-N2H9F0S0G0 glyco",
    "GRIA4 cnv",
    "GRIA4 methyl",
    "GRIA4 proteo",
    "GRIA4 rna"
  ],
  "GRID1": [
    "GRID1 882_882_1_1_S882 phospho",
    "GRID1 970_979_1_1_S979 phospho",
    "GRID1 cnv",
    "GRID1 methyl",
    "GRID1 proteo",
    "GRID1 rna"
  ],
  "GRID2": [
    "GRID2 788_795_1_1_S788 phospho",
    "GRID2 cnv",
    "GRID2 proteo",
    "GRID2 rna"
  ],
  "GRID2IP": [
    "GRID2IP cnv",
    "GRID2IP methyl",
    "GRID2IP rna"
  ],
  "GRIFIN": [
    "GRIFIN cnv",
    "GRIFIN rna"
  ],
  "GRIK1": [
    "GRIK1 cnv",
    "GRIK1 methyl",
    "GRIK1 rna"
  ],
  "GRIK2": [
    "GRIK2 cnv",
    "GRIK2 methyl",
    "GRIK2 proteo",
    "GRIK2 rna"
  ],
  "GRIK3": [
    "GRIK3 NCNLTQIGGLIDSK-N2H7F0S0G0 glyco",
    "GRIK3 NCNLTQIGGLIDSK-N2H8F0S0G0 glyco",
    "GRIK3 NCNLTQIGGLIDSK-N2H9F0S0G0 glyco",
    "GRIK3 YSGVNLTGFR-N2H8F0S0G0 glyco",
    "GRIK3 cnv",
    "GRIK3 methyl",
    "GRIK3 proteo",
    "GRIK3 rna"
  ],
  "GRIK4": [
    "GRIK4 cnv",
    "GRIK4 methyl",
    "GRIK4 rna"
  ],
  "GRIK5": [
    "GRIK5 cnv",
    "GRIK5 rna"
  ],
  "GRIN1": [
    "GRIN1 FANYSIMNLQNR-N2H7F0S0G0 glyco",
    "GRIN1 FANYSIMNLQNR-N2H8F0S0G0 glyco",
    "GRIN1 NVTALLMEAK-N2H5F0S0G0 glyco",
    "GRIN1 QNVSLSILK-N2H8F0S0G0 glyco",
    "GRIN1 VICTGPNDTSPGSPR-N2H5F0S0G0 glyco",
    "GRIN1 cnv",
    "GRIN1 methyl",
    "GRIN1 proteo",
    "GRIN1 rna"
  ],
  "GRIN2A": [
    "GRIN2A 882_892_1_1_S882 phospho",
    "GRIN2A cnv",
    "GRIN2A methyl",
    "GRIN2A proteo",
    "GRIN2A rna"
  ],
  "GRIN2B": [
    "GRIN2B 1303_1306_1_1_S1303 phospho",
    "GRIN2B 882_896_1_1_S886 phospho",
    "GRIN2B 940_944_1_1_S940 phospho",
    "GRIN2B FGTVPNGSTER-N2H8F0S0G0 glyco",
    "GRIN2B YLINVTFEGR-N2H5F0S0G0 glyco",
    "GRIN2B YLINVTFEGR-N2H6F0S0G0 glyco",
    "GRIN2B cnv",
    "GRIN2B methyl",
    "GRIN2B proteo",
    "GRIN2B rna"
  ],
  "GRIN2C": [
    "GRIN2C cnv",
    "GRIN2C methyl",
    "GRIN2C rna"
  ],
  "GRIN2D": [
    "GRIN2D cnv",
    "GRIN2D rna"
  ],
  "GRIN3A": [
    "GRIN3A cnv",
    "GRIN3A methyl",
    "GRIN3A rna"
  ],
  "GRIN3B": [
    "GRIN3B cnv",
    "GRIN3B methyl",
    "GRIN3B rna"
  ],
  "GRINA": [
    "GRINA cnv",
    "GRINA methyl",
    "GRINA rna"
  ],
  "GRIP1": [
    "GRIP1 43_43_1_1_S43 phospho",
    "GRIP1 43_52_1_1_S43 phospho",
    "GRIP1 703_710_1_1_S710 phospho",
    "GRIP1 cnv",
    "GRIP1 methyl",
    "GRIP1 proteo",
    "GRIP1 rna"
  ],
  "GRIP2": [
    "GRIP2 38_38_1_1_S38 phospho",
    "GRIP2 cnv",
    "GRIP2 methyl",
    "GRIP2 rna"
  ],
  "GRIPAP1": [
    "GRIPAP1 659_672_1_1_S666 phospho",
    "GRIPAP1 proteo",
    "GRIPAP1 rna"
  ],
  "GRK1": [
    "GRK1 cnv",
    "GRK1 kinase",
    "GRK1 rna"
  ],
  "GRK2": [
    "GRK2 670_676_1_1_S670 phospho",
    "GRK2 cnv",
    "GRK2 kinase",
    "GRK2 methyl",
    "GRK2 proteo",
    "GRK2 rna"
  ],
  "GRK3": [
    "GRK3 cnv",
    "GRK3 kinase",
    "GRK3 methyl",
    "GRK3 proteo",
    "GRK3 rna"
  ],
  "GRK4": [
    "GRK4 cnv",
    "GRK4 kinase",
    "GRK4 methyl",
    "GRK4 rna"
  ],
  "GRK5": [
    "GRK5 cnv",
    "GRK5 kinase",
    "GRK5 methyl",
    "GRK5 proteo",
    "GRK5 rna"
  ],
  "GRK6": [
    "GRK6 572_587_1_1_S573 phospho",
    "GRK6 cnv",
    "GRK6 kinase",
    "GRK6 methyl",
    "GRK6 proteo",
    "GRK6 rna"
  ],
  "GRK7": [
    "GRK7 cnv",
    "GRK7 kinase",
    "GRK7 methyl",
    "GRK7 rna"
  ],
  "GRM1": [
    "GRM1 cnv",
    "GRM1 methyl",
    "GRM1 proteo",
    "GRM1 rna"
  ],
  "GRM2": [
    "GRM2 867_871_1_1_S871 phospho",
    "GRM2 cnv",
    "GRM2 methyl",
    "GRM2 proteo",
    "GRM2 rna"
  ],
  "GRM3": [
    "GRM3 874_878_1_1_S878 phospho",
    "GRM3 cnv",
    "GRM3 proteo",
    "GRM3 rna"
  ],
  "GRM4": [
    "GRM4 cnv",
    "GRM4 methyl",
    "GRM4 rna"
  ],
  "GRM5": [
    "GRM5 1173_1179_1_1_S1179 phospho",
    "GRM5 938_960_1_1_S960 phospho",
    "GRM5 969_994_2_2_S986S988 phospho",
    "GRM5 986_994_1_1_S988 phospho",
    "GRM5 cnv",
    "GRM5 methyl",
    "GRM5 proteo",
    "GRM5 rna"
  ],
  "GRM5P1": [
    "GRM5P1 methyl"
  ],
  "GRM6": [
    "GRM6 cnv",
    "GRM6 methyl",
    "GRM6 rna"
  ],
  "GRM7": [
    "GRM7 890_900_1_1_S900 phospho",
    "GRM7 cnv",
    "GRM7 methyl",
    "GRM7 proteo",
    "GRM7 rna"
  ],
  "GRM8": [
    "GRM8 cnv",
    "GRM8 methyl",
    "GRM8 rna"
  ],
  "GRN": [
    "GRN cnv",
    "GRN proteo",
    "GRN rna"
  ],
  "GRP": [
    "GRP cnv",
    "GRP methyl",
    "GRP rna"
  ],
  "GRPEL1": [
    "GRPEL1 cnv",
    "GRPEL1 methyl",
    "GRPEL1 proteo",
    "GRPEL1 rna"
  ],
  "GRPEL2": [
    "GRPEL2 cnv",
    "GRPEL2 methyl",
    "GRPEL2 rna"
  ],
  "GRPEL2-AS1": [
    "GRPEL2-AS1 methyl"
  ],
  "GRPR": [
    "GRPR rna"
  ],
  "GRSF1": [
    "GRSF1 243_244_1_1_S244 phospho",
    "GRSF1 cnv",
    "GRSF1 methyl",
    "GRSF1 proteo",
    "GRSF1 rna"
  ],
  "GRTP1": [
    "GRTP1 cnv",
    "GRTP1 methyl",
    "GRTP1 rna"
  ],
  "GRWD1": [
    "GRWD1 342_348_1_1_S344 phospho",
    "GRWD1 cnv",
    "GRWD1 methyl",
    "GRWD1 proteo",
    "GRWD1 rna"
  ],
  "GRXCR1": [
    "GRXCR1 cnv",
    "GRXCR1 rna"
  ],
  "GRXCR2": [
    "GRXCR2 cnv"
  ],
  "GSAP": [
    "GSAP cnv",
    "GSAP methyl",
    "GSAP rna"
  ],
  "GSC": [
    "GSC cnv",
    "GSC methyl",
    "GSC rna"
  ],
  "GSC2": [
    "GSC2 cnv",
    "GSC2 methyl",
    "GSC2 rna"
  ],
  "GSDMA": [
    "GSDMA cnv",
    "GSDMA methyl",
    "GSDMA rna"
  ],
  "GSDMB": [
    "GSDMB cnv",
    "GSDMB rna"
  ],
  "GSDMC": [
    "GSDMC cnv",
    "GSDMC rna"
  ],
  "GSDMD": [
    "GSDMD 181_201_1_1_S181 phospho",
    "GSDMD 250_264_1_0 phospho",
    "GSDMD cnv",
    "GSDMD methyl",
    "GSDMD proteo",
    "GSDMD rna"
  ],
  "GSDME": [
    "GSDME cnv",
    "GSDME methyl",
    "GSDME proteo",
    "GSDME rna"
  ],
  "GSE1": [
    "GSE1 619_639_1_1_S637 phospho",
    "GSE1 753_761_2_2_S753S755 phospho",
    "GSE1 826_836_1_1_S836 phospho",
    "GSE1 cnv",
    "GSE1 methyl",
    "GSE1 proteo",
    "GSE1 rna"
  ],
  "GSG1": [
    "GSG1 cnv",
    "GSG1 rna"
  ],
  "GSG1L": [
    "GSG1L 284_284_1_1_S284 phospho",
    "GSG1L cnv",
    "GSG1L methyl",
    "GSG1L rna"
  ],
  "GSG1L2": [
    "GSG1L2 cnv",
    "GSG1L2 rna"
  ],
  "GSK3A": [
    "GSK3A 19_46_1_1_S21 phospho",
    "GSK3A cnv",
    "GSK3A kinase",
    "GSK3A methyl",
    "GSK3A proteo",
    "GSK3A rna"
  ],
  "GSK3B": [
    "GSK3B 7_13_1_1_S9 phospho",
    "GSK3B 7_25_1_1_S25 phospho",
    "GSK3B 7_25_1_1_S9 phospho",
    "GSK3B 7_25_2_2_S9S25 phospho",
    "GSK3B cnv",
    "GSK3B kinase",
    "GSK3B methyl",
    "GSK3B proteo",
    "GSK3B rna"
  ],
  "GSKIP": [
    "GSKIP cnv",
    "GSKIP methyl",
    "GSKIP proteo",
    "GSKIP rna"
  ],
  "GSN": [
    "GSN 402_412_1_1_S408 phospho",
    "GSN 598_611_1_1_S600 phospho",
    "GSN 651_654_1_1_S654 phospho",
    "GSN cnv",
    "GSN methyl",
    "GSN proteo",
    "GSN rna"
  ],
  "GSPT1": [
    "GSPT1 cnv",
    "GSPT1 methyl",
    "GSPT1 proteo",
    "GSPT1 rna"
  ],
  "GSPT2": [
    "GSPT2 methyl",
    "GSPT2 proteo",
    "GSPT2 rna"
  ],
  "GSR": [
    "GSR 507_520_1_1_S515 phospho",
    "GSR cnv",
    "GSR methyl",
    "GSR proteo",
    "GSR rna"
  ],
  "GSS": [
    "GSS cnv",
    "GSS methyl",
    "GSS proteo",
    "GSS rna"
  ],
  "GSTA1": [
    "GSTA1 cnv",
    "GSTA1 rna"
  ],
  "GSTA2": [
    "GSTA2 cnv",
    "GSTA2 rna"
  ],
  "GSTA3": [
    "GSTA3 cnv"
  ],
  "GSTA4": [
    "GSTA4 cnv",
    "GSTA4 methyl",
    "GSTA4 proteo",
    "GSTA4 rna"
  ],
  "GSTA5": [
    "GSTA5 cnv"
  ],
  "GSTCD": [
    "GSTCD 223_234_1_1_S233 phospho",
    "GSTCD cnv",
    "GSTCD methyl",
    "GSTCD proteo",
    "GSTCD rna"
  ],
  "GSTK1": [
    "GSTK1 cnv",
    "GSTK1 proteo",
    "GSTK1 rna"
  ],
  "GSTM1": [
    "GSTM1 cnv",
    "GSTM1 methyl",
    "GSTM1 proteo",
    "GSTM1 rna"
  ],
  "GSTM2": [
    "GSTM2 cnv",
    "GSTM2 methyl",
    "GSTM2 proteo",
    "GSTM2 rna"
  ],
  "GSTM3": [
    "GSTM3 cnv",
    "GSTM3 methyl",
    "GSTM3 proteo",
    "GSTM3 rna"
  ],
  "GSTM4": [
    "GSTM4 cnv",
    "GSTM4 methyl",
    "GSTM4 proteo",
    "GSTM4 rna"
  ],
  "GSTM5": [
    "GSTM5 cnv",
    "GSTM5 proteo",
    "GSTM5 rna"
  ],
  "GSTO1": [
    "GSTO1 cnv",
    "GSTO1 methyl",
    "GSTO1 proteo",
    "GSTO1 rna"
  ],
  "GSTO2": [
    "GSTO2 cnv",
    "GSTO2 methyl",
    "GSTO2 rna"
  ],
  "GSTP1": [
    "GSTP1 cnv",
    "GSTP1 methyl",
    "GSTP1 proteo",
    "GSTP1 rna"
  ],
  "GSTT1": [
    "GSTT1 proteo"
  ],
  "GSTT2": [
    "GSTT2 cnv",
    "GSTT2 rna"
  ],
  "GSTT2B": [
    "GSTT2B cnv",
    "GSTT2B proteo",
    "GSTT2B rna"
  ],
  "GSTT4": [
    "GSTT4 cnv",
    "GSTT4 rna"
  ],
  "GSTZ1": [
    "GSTZ1 cnv",
    "GSTZ1 methyl",
    "GSTZ1 proteo",
    "GSTZ1 rna"
  ],
  "GSX1": [
    "GSX1 cnv",
    "GSX1 methyl",
    "GSX1 rna"
  ],
  "GSX2": [
    "GSX2 cnv",
    "GSX2 methyl",
    "GSX2 rna"
  ],
  "GTDC1": [
    "GTDC1 cnv",
    "GTDC1 methyl",
    "GTDC1 proteo",
    "GTDC1 rna"
  ],
  "GTF2A1": [
    "GTF2A1 cnv",
    "GTF2A1 methyl",
    "GTF2A1 proteo",
    "GTF2A1 rna"
  ],
  "GTF2A1L": [
    "GTF2A1L cnv",
    "GTF2A1L methyl",
    "GTF2A1L rna"
  ],
  "GTF2A2": [
    "GTF2A2 cnv",
    "GTF2A2 methyl",
    "GTF2A2 proteo",
    "GTF2A2 rna"
  ],
  "GTF2B": [
    "GTF2B cnv",
    "GTF2B methyl",
    "GTF2B proteo",
    "GTF2B rna"
  ],
  "GTF2E1": [
    "GTF2E1 cnv",
    "GTF2E1 proteo",
    "GTF2E1 rna"
  ],
  "GTF2E2": [
    "GTF2E2 cnv",
    "GTF2E2 methyl",
    "GTF2E2 proteo",
    "GTF2E2 rna"
  ],
  "GTF2F1": [
    "GTF2F1 331_331_1_1_T331 phospho",
    "GTF2F1 427_433_1_1_S433 phospho",
    "GTF2F1 436_442_1_1_T437 phospho",
    "GTF2F1 436_455_1_1_T446 phospho",
    "GTF2F1 cnv",
    "GTF2F1 methyl",
    "GTF2F1 proteo",
    "GTF2F1 rna"
  ],
  "GTF2F2": [
    "GTF2F2 242_248_1_1_S248 phospho",
    "GTF2F2 cnv",
    "GTF2F2 methyl",
    "GTF2F2 proteo",
    "GTF2F2 rna"
  ],
  "GTF2H1": [
    "GTF2H1 cnv",
    "GTF2H1 methyl",
    "GTF2H1 proteo",
    "GTF2H1 rna"
  ],
  "GTF2H2": [
    "GTF2H2 cnv",
    "GTF2H2 rna"
  ],
  "GTF2H2C": [
    "GTF2H2C cnv",
    "GTF2H2C methyl",
    "GTF2H2C rna"
  ],
  "GTF2H3": [
    "GTF2H3 cnv",
    "GTF2H3 methyl",
    "GTF2H3 proteo",
    "GTF2H3 rna"
  ],
  "GTF2H4": [
    "GTF2H4 cnv",
    "GTF2H4 methyl",
    "GTF2H4 proteo",
    "GTF2H4 rna"
  ],
  "GTF2H5": [
    "GTF2H5 cnv",
    "GTF2H5 methyl",
    "GTF2H5 proteo",
    "GTF2H5 rna"
  ],
  "GTF2I": [
    "GTF2I 674_699_1_1_S674 phospho",
    "GTF2I 687_710_1_0 phospho",
    "GTF2I 687_710_1_1_T703 phospho",
    "GTF2I cnv",
    "GTF2I methyl",
    "GTF2I proteo",
    "GTF2I rna"
  ],
  "GTF2IRD1": [
    "GTF2IRD1 473_490_1_1_S480 phospho",
    "GTF2IRD1 cnv",
    "GTF2IRD1 methyl",
    "GTF2IRD1 rna"
  ],
  "GTF2IRD1P1": [
    "GTF2IRD1P1 methyl"
  ],
  "GTF2IRD2": [
    "GTF2IRD2 cnv",
    "GTF2IRD2 methyl",
    "GTF2IRD2 rna"
  ],
  "GTF2IRD2B": [
    "GTF2IRD2B cnv",
    "GTF2IRD2B rna"
  ],
  "GTF3A": [
    "GTF3A cnv",
    "GTF3A methyl",
    "GTF3A proteo",
    "GTF3A rna"
  ],
  "GTF3C1": [
    "GTF3C1 1062_1073_1_0 phospho",
    "GTF3C1 1062_1073_2_0 phospho",
    "GTF3C1 1062_1073_2_2_S1062S1068 phospho",
    "GTF3C1 1840_1856_1_1_S1856 phospho",
    "GTF3C1 1865_1881_1_1_S1865 phospho",
    "GTF3C1 725_739_1_1_S739 phospho",
    "GTF3C1 cnv",
    "GTF3C1 methyl",
    "GTF3C1 proteo",
    "GTF3C1 rna"
  ],
  "GTF3C2": [
    "GTF3C2 762_776_1_1_S765 phospho",
    "GTF3C2 892_895_1_1_S893 phospho",
    "GTF3C2 892_904_1_0 phospho",
    "GTF3C2 892_904_1_1_S893 phospho",
    "GTF3C2 892_904_2_1_S901 phospho",
    "GTF3C2 cnv",
    "GTF3C2 methyl",
    "GTF3C2 proteo",
    "GTF3C2 rna"
  ],
  "GTF3C3": [
    "GTF3C3 43_62_1_1_S43 phospho",
    "GTF3C3 cnv",
    "GTF3C3 methyl",
    "GTF3C3 proteo",
    "GTF3C3 rna"
  ],
  "GTF3C4": [
    "GTF3C4 611_628_1_1_S611 phospho",
    "GTF3C4 cnv",
    "GTF3C4 methyl",
    "GTF3C4 proteo",
    "GTF3C4 rna"
  ],
  "GTF3C5": [
    "GTF3C5 cnv",
    "GTF3C5 methyl",
    "GTF3C5 proteo",
    "GTF3C5 rna"
  ],
  "GTF3C6": [
    "GTF3C6 cnv",
    "GTF3C6 methyl",
    "GTF3C6 proteo",
    "GTF3C6 rna"
  ],
  "GTPBP1": [
    "GTPBP1 44_63_2_2_S44S47 phospho",
    "GTPBP1 576_584_1_1_S580 phospho",
    "GTPBP1 8_25_1_0 phospho",
    "GTPBP1 8_25_1_1_S25 phospho",
    "GTPBP1 cnv",
    "GTPBP1 methyl",
    "GTPBP1 proteo",
    "GTPBP1 rna"
  ],
  "GTPBP10": [
    "GTPBP10 cnv",
    "GTPBP10 methyl",
    "GTPBP10 proteo",
    "GTPBP10 rna"
  ],
  "GTPBP2": [
    "GTPBP2 cnv",
    "GTPBP2 methyl",
    "GTPBP2 proteo",
    "GTPBP2 rna"
  ],
  "GTPBP3": [
    "GTPBP3 cnv",
    "GTPBP3 methyl",
    "GTPBP3 proteo",
    "GTPBP3 rna"
  ],
  "GTPBP4": [
    "GTPBP4 cnv",
    "GTPBP4 methyl",
    "GTPBP4 proteo",
    "GTPBP4 rna"
  ],
  "GTPBP6": [
    "GTPBP6 proteo",
    "GTPBP6 rna"
  ],
  "GTPBP8": [
    "GTPBP8 cnv",
    "GTPBP8 methyl",
    "GTPBP8 rna"
  ],
  "GTSE1": [
    "GTSE1 cnv",
    "GTSE1 methyl",
    "GTSE1 proteo",
    "GTSE1 rna"
  ],
  "GTSE1-DT": [
    "GTSE1-DT methyl"
  ],
  "GTSF1": [
    "GTSF1 cnv",
    "GTSF1 rna"
  ],
  "GTSF1L": [
    "GTSF1L cnv",
    "GTSF1L rna"
  ],
  "GUCA1A": [
    "GUCA1A cnv",
    "GUCA1A methyl",
    "GUCA1A rna"
  ],
  "GUCA1ANB": [
    "GUCA1ANB cnv",
    "GUCA1ANB rna"
  ],
  "GUCA1B": [
    "GUCA1B cnv",
    "GUCA1B rna"
  ],
  "GUCA1C": [
    "GUCA1C cnv",
    "GUCA1C rna"
  ],
  "GUCA2A": [
    "GUCA2A cnv",
    "GUCA2A rna"
  ],
  "GUCA2B": [
    "GUCA2B cnv"
  ],
  "GUCD1": [
    "GUCD1 cnv",
    "GUCD1 methyl",
    "GUCD1 rna"
  ],
  "GUCY1A1": [
    "GUCY1A1 261_280_1_1_S267 phospho",
    "GUCY1A1 cnv",
    "GUCY1A1 methyl",
    "GUCY1A1 proteo",
    "GUCY1A1 rna"
  ],
  "GUCY1A2": [
    "GUCY1A2 39_73_1_0 phospho",
    "GUCY1A2 cnv",
    "GUCY1A2 methyl",
    "GUCY1A2 proteo",
    "GUCY1A2 rna"
  ],
  "GUCY1B1": [
    "GUCY1B1 cnv",
    "GUCY1B1 methyl",
    "GUCY1B1 proteo",
    "GUCY1B1 rna"
  ],
  "GUCY2C": [
    "GUCY2C cnv",
    "GUCY2C kinase",
    "GUCY2C rna"
  ],
  "GUCY2D": [
    "GUCY2D cnv",
    "GUCY2D kinase",
    "GUCY2D methyl",
    "GUCY2D rna"
  ],
  "GUCY2F": [
    "GUCY2F kinase",
    "GUCY2F rna"
  ],
  "GUF1": [
    "GUF1 cnv",
    "GUF1 methyl",
    "GUF1 proteo",
    "GUF1 rna"
  ],
  "GUK1": [
    "GUK1 cnv",
    "GUK1 methyl",
    "GUK1 proteo",
    "GUK1 rna"
  ],
  "GULP1": [
    "GULP1 cnv",
    "GULP1 methyl",
    "GULP1 proteo",
    "GULP1 rna"
  ],
  "GUSB": [
    "GUSB VVANGTGTQGQLK-N2H6F0S0G0 glyco",
    "GUSB cnv",
    "GUSB methyl",
    "GUSB proteo",
    "GUSB rna"
  ],
  "GUSBP1": [
    "GUSBP1 methyl"
  ],
  "GUSBP11": [
    "GUSBP11 methyl"
  ],
  "GUSBP5": [
    "GUSBP5 methyl"
  ],
  "GVQW3": [
    "GVQW3 cnv",
    "GVQW3 methyl",
    "GVQW3 rna"
  ],
  "GXYLT1": [
    "GXYLT1 cnv",
    "GXYLT1 methyl",
    "GXYLT1 proteo",
    "GXYLT1 rna"
  ],
  "GXYLT2": [
    "GXYLT2 cnv",
    "GXYLT2 rna"
  ],
  "GYG1": [
    "GYG1 cnv",
    "GYG1 methyl",
    "GYG1 proteo",
    "GYG1 rna"
  ],
  "GYG2": [
    "GYG2 437_437_1_1_S437 phospho",
    "GYG2 methyl",
    "GYG2 proteo",
    "GYG2 rna"
  ],
  "GYPA": [
    "GYPA 108_135_1_0 phospho",
    "GYPA 108_135_1_1_S117 phospho",
    "GYPA 108_135_1_1_S126 phospho",
    "GYPA 108_135_1_1_S135 phospho",
    "GYPA cnv",
    "GYPA proteo",
    "GYPA rna"
  ],
  "GYPB": [
    "GYPB cnv",
    "GYPB rna"
  ],
  "GYPC": [
    "GYPC 78_101_1_1_S83 phospho",
    "GYPC cnv",
    "GYPC methyl",
    "GYPC proteo",
    "GYPC rna"
  ],
  "GYPE": [
    "GYPE cnv",
    "GYPE rna"
  ],
  "GYS1": [
    "GYS1 341_348_1_1_S348 phospho",
    "GYS1 588_593_1_1_S589 phospho",
    "GYS1 588_593_2_2_S589S593 phospho",
    "GYS1 588_611_1_1_S589 phospho",
    "GYS1 588_611_2_2_S589S593 phospho",
    "GYS1 634_642_1_1_S634 phospho",
    "GYS1 646_667_1_1_S646 phospho",
    "GYS1 cnv",
    "GYS1 methyl",
    "GYS1 proteo",
    "GYS1 rna"
  ],
  "GYS2": [
    "GYS2 cnv",
    "GYS2 methyl",
    "GYS2 rna"
  ],
  "GZF1": [
    "GZF1 cnv",
    "GZF1 methyl",
    "GZF1 rna"
  ],
  "GZMA": [
    "GZMA cnv",
    "GZMA rna"
  ],
  "GZMB": [
    "GZMB cnv",
    "GZMB rna"
  ],
  "GZMH": [
    "GZMH cnv",
    "GZMH rna"
  ],
  "GZMK": [
    "GZMK cnv",
    "GZMK rna"
  ],
  "GZMM": [
    "GZMM cnv",
    "GZMM rna"
  ],
  "H1-0": [
    "H1-0 2_7_1_1_S5 phospho",
    "H1-0 cnv",
    "H1-0 methyl",
    "H1-0 proteo",
    "H1-0 rna"
  ],
  "H1-1": [
    "H1-1 cnv",
    "H1-1 rna"
  ],
  "H1-10": [
    "H1-10 27_33_1_1_S31 phospho",
    "H1-10 cnv",
    "H1-10 methyl",
    "H1-10 proteo",
    "H1-10 rna"
  ],
  "H1-2": [
    "H1-2 cnv",
    "H1-2 methyl",
    "H1-2 proteo",
    "H1-2 rna"
  ],
  "H1-3": [
    "H1-3 180_180_1_1_T180 phospho",
    "H1-3 cnv",
    "H1-3 proteo",
    "H1-3 rna"
  ],
  "H1-4": [
    "H1-4 2_18_1_1_T18 phospho",
    "H1-4 cnv",
    "H1-4 methyl",
    "H1-4 proteo",
    "H1-4 rna"
  ],
  "H1-5": [
    "H1-5 2_18_1_1_S18 phospho",
    "H1-5 cnv",
    "H1-5 methyl",
    "H1-5 proteo",
    "H1-5 rna"
  ],
  "H1-6": [
    "H1-6 cnv",
    "H1-6 rna"
  ],
  "H1-7": [
    "H1-7 cnv",
    "H1-7 rna"
  ],
  "H1-8": [
    "H1-8 cnv",
    "H1-8 rna"
  ],
  "H19": [
    "H19 methyl"
  ],
  "H2AB1": [
    "H2AB1 rna"
  ],
  "H2AB2": [
    "H2AB2 rna"
  ],
  "H2AB3": [
    "H2AB3 rna"
  ],
  "H2AC1": [
    "H2AC1 cnv"
  ],
  "H2AC11": [
    "H2AC11 cnv",
    "H2AC11 methyl",
    "H2AC11 rna"
  ],
  "H2AC12": [
    "H2AC12 cnv",
    "H2AC12 methyl",
    "H2AC12 rna"
  ],
  "H2AC13": [
    "H2AC13 cnv",
    "H2AC13 methyl",
    "H2AC13 rna"
  ],
  "H2AC14": [
    "H2AC14 cnv",
    "H2AC14 rna"
  ],
  "H2AC15": [
    "H2AC15 cnv",
    "H2AC15 methyl",
    "H2AC15 rna"
  ],
  "H2AC16": [
    "H2AC16 cnv",
    "H2AC16 methyl",
    "H2AC16 rna"
  ],
  "H2AC17": [
    "H2AC17 cnv",
    "H2AC17 methyl",
    "H2AC17 rna"
  ],
  "H2AC18": [
    "H2AC18 cnv",
    "H2AC18 methyl",
    "H2AC18 rna"
  ],
  "H2AC19": [
    "H2AC19 cnv",
    "H2AC19 methyl",
    "H2AC19 rna"
  ],
  "H2AC20": [
    "H2AC20 cnv",
    "H2AC20 methyl",
    "H2AC20 rna"
  ],
  "H2AC21": [
    "H2AC21 cnv",
    "H2AC21 methyl",
    "H2AC21 proteo",
    "H2AC21 rna"
  ],
  "H2AC4": [
    "H2AC4 cnv",
    "H2AC4 rna"
  ],
  "H2AC6": [
    "H2AC6 cnv",
    "H2AC6 rna"
  ],
  "H2AC7": [
    "H2AC7 cnv",
    "H2AC7 methyl",
    "H2AC7 rna"
  ],
  "H2AC8": [
    "H2AC8 cnv",
    "H2AC8 rna"
  ],
  "H2AJ": [
    "H2AJ cnv",
    "H2AJ methyl",
    "H2AJ rna"
  ],
  "H2AL3": [
    "H2AL3 rna"
  ],
  "H2AP": [
    "H2AP rna"
  ],
  "H2AW": [
    "H2AW cnv",
    "H2AW methyl",
    "H2AW rna"
  ],
  "H2AX": [
    "H2AX 121_124_1_1_S122 phospho",
    "H2AX cnv",
    "H2AX methyl",
    "H2AX proteo",
    "H2AX rna"
  ],
  "H2AZ1": [
    "H2AZ1 cnv",
    "H2AZ1 methyl",
    "H2AZ1 rna"
  ],
  "H2AZ2": [
    "H2AZ2 cnv",
    "H2AZ2 methyl",
    "H2AZ2 rna"
  ],
  "H2BC1": [
    "H2BC1 cnv",
    "H2BC1 methyl",
    "H2BC1 rna"
  ],
  "H2BC10": [
    "H2BC10 cnv",
    "H2BC10 methyl",
    "H2BC10 rna"
  ],
  "H2BC11": [
    "H2BC11 cnv",
    "H2BC11 methyl",
    "H2BC11 rna"
  ],
  "H2BC12": [
    "H2BC12 cnv",
    "H2BC12 methyl",
    "H2BC12 rna"
  ],
  "H2BC12L": [
    "H2BC12L cnv",
    "H2BC12L methyl",
    "H2BC12L rna"
  ],
  "H2BC13": [
    "H2BC13 cnv",
    "H2BC13 methyl",
    "H2BC13 rna"
  ],
  "H2BC14": [
    "H2BC14 cnv",
    "H2BC14 rna"
  ],
  "H2BC15": [
    "H2BC15 cnv",
    "H2BC15 methyl",
    "H2BC15 rna"
  ],
  "H2BC17": [
    "H2BC17 cnv",
    "H2BC17 methyl",
    "H2BC17 rna"
  ],
  "H2BC18": [
    "H2BC18 cnv",
    "H2BC18 methyl",
    "H2BC18 rna"
  ],
  "H2BC21": [
    "H2BC21 cnv",
    "H2BC21 methyl",
    "H2BC21 rna"
  ],
  "H2BC3": [
    "H2BC3 cnv",
    "H2BC3 methyl",
    "H2BC3 rna"
  ],
  "H2BC4": [
    "H2BC4 cnv",
    "H2BC4 methyl",
    "H2BC4 rna"
  ],
  "H2BC5": [
    "H2BC5 cnv",
    "H2BC5 rna"
  ],
  "H2BC6": [
    "H2BC6 cnv",
    "H2BC6 rna"
  ],
  "H2BC7": [
    "H2BC7 cnv",
    "H2BC7 methyl",
    "H2BC7 rna"
  ],
  "H2BC8": [
    "H2BC8 cnv",
    "H2BC8 methyl",
    "H2BC8 rna"
  ],
  "H2BC9": [
    "H2BC9 cnv",
    "H2BC9 rna"
  ],
  "H2BK1": [
    "H2BK1 cnv",
    "H2BK1 rna"
  ],
  "H2BU1": [
    "H2BU1 cnv",
    "H2BU1 methyl",
    "H2BU1 rna"
  ],
  "H2BW1": [
    "H2BW1 methyl",
    "H2BW1 rna"
  ],
  "H2BW2": [
    "H2BW2 methyl",
    "H2BW2 rna"
  ],
  "H3-3A": [
    "H3-3A cnv",
    "H3-3A methyl",
    "H3-3A mut",
    "H3-3A proteo",
    "H3-3A rna"
  ],
  "H3-3B": [
    "H3-3B cnv",
    "H3-3B methyl",
    "H3-3B rna"
  ],
  "H3-4": [
    "H3-4 cnv",
    "H3-4 methyl",
    "H3-4 rna"
  ],
  "H3-5": [
    "H3-5 cnv",
    "H3-5 methyl",
    "H3-5 rna"
  ],
  "H3-7": [
    "H3-7 cnv",
    "H3-7 rna"
  ],
  "H3C1": [
    "H3C1 cnv",
    "H3C1 methyl",
    "H3C1 rna"
  ],
  "H3C10": [
    "H3C10 cnv",
    "H3C10 rna"
  ],
  "H3C11": [
    "H3C11 cnv",
    "H3C11 methyl",
    "H3C11 rna"
  ],
  "H3C12": [
    "H3C12 cnv",
    "H3C12 rna"
  ],
  "H3C13": [
    "H3C13 cnv",
    "H3C13 rna"
  ],
  "H3C14": [
    "H3C14 cnv",
    "H3C14 rna"
  ],
  "H3C15": [
    "H3C15 cnv",
    "H3C15 proteo",
    "H3C15 rna"
  ],
  "H3C2": [
    "H3C2 cnv",
    "H3C2 rna"
  ],
  "H3C3": [
    "H3C3 cnv",
    "H3C3 rna"
  ],
  "H3C4": [
    "H3C4 cnv",
    "H3C4 methyl",
    "H3C4 rna"
  ],
  "H3C6": [
    "H3C6 cnv",
    "H3C6 rna"
  ],
  "H3C7": [
    "H3C7 cnv",
    "H3C7 rna"
  ],
  "H3C8": [
    "H3C8 cnv",
    "H3C8 methyl",
    "H3C8 rna"
  ],
  "H3Y1": [
    "H3Y1 cnv",
    "H3Y1 rna"
  ],
  "H3Y2": [
    "H3Y2 cnv"
  ],
  "H4-16": [
    "H4-16 cnv",
    "H4-16 rna"
  ],
  "H4C1": [
    "H4C1 cnv",
    "H4C1 methyl",
    "H4C1 rna"
  ],
  "H4C11": [
    "H4C11 cnv",
    "H4C11 methyl",
    "H4C11 rna"
  ],
  "H4C12": [
    "H4C12 cnv",
    "H4C12 methyl",
    "H4C12 rna"
  ],
  "H4C13": [
    "H4C13 cnv",
    "H4C13 rna"
  ],
  "H4C14": [
    "H4C14 cnv",
    "H4C14 rna"
  ],
  "H4C15": [
    "H4C15 48_55_1_1_S48 phospho",
    "H4C15 cnv",
    "H4C15 proteo",
    "H4C15 rna"
  ],
  "H4C2": [
    "H4C2 cnv",
    "H4C2 methyl",
    "H4C2 rna"
  ],
  "H4C3": [
    "H4C3 cnv",
    "H4C3 rna"
  ],
  "H4C4": [
    "H4C4 cnv",
    "H4C4 rna"
  ],
  "H4C5": [
    "H4C5 cnv",
    "H4C5 methyl",
    "H4C5 rna"
  ],
  "H4C6": [
    "H4C6 cnv",
    "H4C6 rna"
  ],
  "H4C7": [
    "H4C7 cnv",
    "H4C7 rna"
  ],
  "H4C8": [
    "H4C8 cnv",
    "H4C8 methyl",
    "H4C8 rna"
  ],
  "H4C9": [
    "H4C9 cnv",
    "H4C9 rna"
  ],
  "H6PD": [
    "H6PD cnv",
    "H6PD methyl",
    "H6PD proteo",
    "H6PD rna"
  ],
  "HAAO": [
    "HAAO cnv",
    "HAAO methyl",
    "HAAO proteo",
    "HAAO rna"
  ],
  "HABP2": [
    "HABP2 cnv",
    "HABP2 proteo",
    "HABP2 rna"
  ],
  "HABP4": [
    "HABP4 74_79_1_1_S74 phospho",
    "HABP4 cnv",
    "HABP4 methyl",
    "HABP4 proteo",
    "HABP4 rna"
  ],
  "HACD1": [
    "HACD1 cnv",
    "HACD1 methyl",
    "HACD1 rna"
  ],
  "HACD2": [
    "HACD2 cnv",
    "HACD2 methyl",
    "HACD2 proteo",
    "HACD2 rna"
  ],
  "HACD3": [
    "HACD3 114_114_1_1_S114 phospho",
    "HACD3 cnv",
    "HACD3 methyl",
    "HACD3 proteo",
    "HACD3 rna"
  ],
  "HACD4": [
    "HACD4 cnv",
    "HACD4 methyl",
    "HACD4 rna"
  ],
  "HACE1": [
    "HACE1 341_346_1_1_S341 phospho",
    "HACE1 cnv",
    "HACE1 methyl",
    "HACE1 proteo",
    "HACE1 rna"
  ],
  "HACL1": [
    "HACL1 cnv",
    "HACL1 methyl",
    "HACL1 proteo",
    "HACL1 rna"
  ],
  "HADH": [
    "HADH cnv",
    "HADH methyl",
    "HADH proteo",
    "HADH rna"
  ],
  "HADHA": [
    "HADHA 745_756_1_0 phospho",
    "HADHA cnv",
    "HADHA methyl",
    "HADHA proteo",
    "HADHA rna"
  ],
  "HADHB": [
    "HADHB cnv",
    "HADHB methyl",
    "HADHB proteo",
    "HADHB rna"
  ],
  "HAGH": [
    "HAGH cnv",
    "HAGH methyl",
    "HAGH proteo",
    "HAGH rna"
  ],
  "HAGHL": [
    "HAGHL cnv",
    "HAGHL methyl",
    "HAGHL proteo",
    "HAGHL rna"
  ],
  "HAGLR": [
    "HAGLR methyl"
  ],
  "HAL": [
    "HAL cnv",
    "HAL methyl",
    "HAL rna"
  ],
  "HAMP": [
    "HAMP cnv",
    "HAMP rna"
  ],
  "HAND1": [
    "HAND1 cnv",
    "HAND1 methyl",
    "HAND1 rna"
  ],
  "HAND2": [
    "HAND2 cnv",
    "HAND2 methyl",
    "HAND2 rna"
  ],
  "HAND2-AS1": [
    "HAND2-AS1 methyl"
  ],
  "HAO1": [
    "HAO1 cnv",
    "HAO1 rna"
  ],
  "HAO2": [
    "HAO2 cnv",
    "HAO2 rna"
  ],
  "HAP1": [
    "HAP1 cnv",
    "HAP1 methyl",
    "HAP1 rna"
  ],
  "HAPLN1": [
    "HAPLN1 GGNVTLPCK-N5H3F1S0G0 glyco",
    "HAPLN1 GGNVTLPCK-N5H4F1S1G0 glyco",
    "HAPLN1 cnv",
    "HAPLN1 proteo",
    "HAPLN1 rna"
  ],
  "HAPLN2": [
    "HAPLN2 cnv",
    "HAPLN2 methyl",
    "HAPLN2 proteo",
    "HAPLN2 rna"
  ],
  "HAPLN3": [
    "HAPLN3 cnv",
    "HAPLN3 methyl",
    "HAPLN3 proteo",
    "HAPLN3 rna"
  ],
  "HAPLN4": [
    "HAPLN4 cnv",
    "HAPLN4 methyl",
    "HAPLN4 proteo",
    "HAPLN4 rna"
  ],
  "HAR1B": [
    "HAR1B methyl"
  ],
  "HARBI1": [
    "HARBI1 cnv",
    "HARBI1 methyl",
    "HARBI1 rna"
  ],
  "HARS1": [
    "HARS1 27_27_1_1_S27 phospho",
    "HARS1 cnv",
    "HARS1 methyl",
    "HARS1 proteo",
    "HARS1 rna"
  ],
  "HARS2": [
    "HARS2 73_73_1_1_S73 phospho",
    "HARS2 cnv",
    "HARS2 methyl",
    "HARS2 proteo",
    "HARS2 rna"
  ],
  "HAS1": [
    "HAS1 cnv",
    "HAS1 methyl",
    "HAS1 rna"
  ],
  "HAS2": [
    "HAS2 cnv",
    "HAS2 rna"
  ],
  "HAS3": [
    "HAS3 cnv",
    "HAS3 methyl",
    "HAS3 rna"
  ],
  "HASPIN": [
    "HASPIN cnv",
    "HASPIN kinase",
    "HASPIN methyl",
    "HASPIN rna"
  ],
  "HAT1": [
    "HAT1 cnv",
    "HAT1 methyl",
    "HAT1 proteo",
    "HAT1 rna"
  ],
  "HAUS1": [
    "HAUS1 cnv",
    "HAUS1 methyl",
    "HAUS1 proteo",
    "HAUS1 rna"
  ],
  "HAUS2": [
    "HAUS2 cnv",
    "HAUS2 methyl",
    "HAUS2 proteo",
    "HAUS2 rna"
  ],
  "HAUS3": [
    "HAUS3 cnv",
    "HAUS3 methyl",
    "HAUS3 proteo",
    "HAUS3 rna"
  ],
  "HAUS4": [
    "HAUS4 cnv",
    "HAUS4 methyl",
    "HAUS4 proteo",
    "HAUS4 rna"
  ],
  "HAUS5": [
    "HAUS5 cnv",
    "HAUS5 methyl",
    "HAUS5 proteo",
    "HAUS5 rna"
  ],
  "HAUS6": [
    "HAUS6 515_521_1_1_S517 phospho",
    "HAUS6 cnv",
    "HAUS6 methyl",
    "HAUS6 proteo",
    "HAUS6 rna"
  ],
  "HAUS7": [
    "HAUS7 methyl",
    "HAUS7 proteo",
    "HAUS7 rna"
  ],
  "HAUS8": [
    "HAUS8 cnv",
    "HAUS8 methyl",
    "HAUS8 proteo",
    "HAUS8 rna"
  ],
  "HAVCR1": [
    "HAVCR1 cnv",
    "HAVCR1 rna"
  ],
  "HAVCR2": [
    "HAVCR2 cnv",
    "HAVCR2 methyl",
    "HAVCR2 rna"
  ],
  "HAX1": [
    "HAX1 cnv",
    "HAX1 methyl",
    "HAX1 proteo",
    "HAX1 rna"
  ],
  "HBA1": [
    "HBA1 cnv",
    "HBA1 methyl",
    "HBA1 rna"
  ],
  "HBA2": [
    "HBA2 132_139_1_1_S132 phospho",
    "HBA2 132_139_1_1_S139 phospho",
    "HBA2 132_139_1_1_T138 phospho",
    "HBA2 25_25_1_1_Y25 phospho",
    "HBA2 4_9_1_1_S4 phospho",
    "HBA2 4_9_1_1_T9 phospho",
    "HBA2 68_85_1_1_S82 phospho",
    "HBA2 cnv",
    "HBA2 methyl",
    "HBA2 proteo",
    "HBA2 rna"
  ],
  "HBB": [
    "HBB 10_13_1_1_S10 phospho",
    "HBB 45_51_1_0 phospho",
    "HBB 45_51_1_1_S45 phospho",
    "HBB 5_13_1_1_S10 phospho",
    "HBB 85_90_1_1_T88 phospho",
    "HBB cnv",
    "HBB proteo",
    "HBB rna"
  ],
  "HBD": [
    "HBD 45_51_1_1_S51 phospho",
    "HBD cnv",
    "HBD proteo",
    "HBD rna"
  ],
  "HBE1": [
    "HBE1 cnv",
    "HBE1 rna"
  ],
  "HBEGF": [
    "HBEGF cnv",
    "HBEGF methyl",
    "HBEGF rna"
  ],
  "HBG1": [
    "HBG1 cnv",
    "HBG1 proteo",
    "HBG1 rna"
  ],
  "HBG2": [
    "HBG2 cnv",
    "HBG2 proteo",
    "HBG2 rna"
  ],
  "HBM": [
    "HBM cnv",
    "HBM methyl",
    "HBM proteo",
    "HBM rna"
  ],
  "HBP1": [
    "HBP1 144_153_1_1_S145 phospho",
    "HBP1 412_424_1_1_S412 phospho",
    "HBP1 432_440_1_1_S440 phospho",
    "HBP1 cnv",
    "HBP1 methyl",
    "HBP1 proteo",
    "HBP1 rna"
  ],
  "HBQ1": [
    "HBQ1 cnv",
    "HBQ1 methyl",
    "HBQ1 proteo",
    "HBQ1 rna"
  ],
  "HBS1L": [
    "HBS1L cnv",
    "HBS1L methyl",
    "HBS1L proteo",
    "HBS1L rna"
  ],
  "HBZ": [
    "HBZ cnv",
    "HBZ proteo",
    "HBZ rna"
  ],
  "HCAR1": [
    "HCAR1 cnv",
    "HCAR1 rna"
  ],
  "HCAR2": [
    "HCAR2 cnv",
    "HCAR2 rna"
  ],
  "HCAR3": [
    "HCAR3 cnv",
    "HCAR3 rna"
  ],
  "HCCS": [
    "HCCS methyl",
    "HCCS proteo",
    "HCCS rna"
  ],
  "HCFC1": [
    "HCFC1 1485_1507_1_1_S1507 phospho",
    "HCFC1 2019_2020_1_0 phospho",
    "HCFC1 2019_2020_1_1_S2020 phospho",
    "HCFC1 400_419_1_1_S411 phospho",
    "HCFC1 597_607_1_1_S598 phospho",
    "HCFC1 methyl",
    "HCFC1 proteo",
    "HCFC1 rna"
  ],
  "HCFC1R1": [
    "HCFC1R1 cnv",
    "HCFC1R1 methyl",
    "HCFC1R1 rna"
  ],
  "HCFC2": [
    "HCFC2 cnv",
    "HCFC2 methyl",
    "HCFC2 proteo",
    "HCFC2 rna"
  ],
  "HCG14": [
    "HCG14 methyl"
  ],
  "HCG17": [
    "HCG17 methyl"
  ],
  "HCG18": [
    "HCG18 methyl"
  ],
  "HCG20": [
    "HCG20 methyl"
  ],
  "HCG22": [
    "HCG22 cnv",
    "HCG22 rna"
  ],
  "HCG25": [
    "HCG25 methyl"
  ],
  "HCG27": [
    "HCG27 methyl"
  ],
  "HCG9": [
    "HCG9 methyl"
  ],
  "HCK": [
    "HCK cnv",
    "HCK kinase",
    "HCK methyl",
    "HCK proteo",
    "HCK rna"
  ],
  "HCLS1": [
    "HCLS1 235_238_1_0 phospho",
    "HCLS1 235_238_1_1_S238 phospho",
    "HCLS1 238_238_1_1_S238 phospho",
    "HCLS1 262_277_1_1_S262 phospho",
    "HCLS1 262_277_1_1_T271 phospho",
    "HCLS1 cnv",
    "HCLS1 proteo",
    "HCLS1 rna"
  ],
  "HCN1": [
    "HCN1 41_41_1_1_T41 phospho",
    "HCN1 cnv",
    "HCN1 methyl",
    "HCN1 proteo",
    "HCN1 rna"
  ],
  "HCN2": [
    "HCN2 132_146_1_1_S146 phospho",
    "HCN2 771_786_1_0 phospho",
    "HCN2 771_786_1_1_S779 phospho",
    "HCN2 771_786_2_2_S779S786 phospho",
    "HCN2 792_795_1_1_T792 phospho",
    "HCN2 866_880_1_1_S868 phospho",
    "HCN2 cnv",
    "HCN2 methyl",
    "HCN2 proteo",
    "HCN2 rna"
  ],
  "HCN3": [
    "HCN3 cnv",
    "HCN3 methyl",
    "HCN3 rna"
  ],
  "HCN4": [
    "HCN4 1071_1075_1_1_T1071 phospho",
    "HCN4 cnv",
    "HCN4 methyl",
    "HCN4 rna"
  ],
  "HCP5": [
    "HCP5 methyl"
  ],
  "HCRT": [
    "HCRT cnv",
    "HCRT rna"
  ],
  "HCRTR1": [
    "HCRTR1 cnv",
    "HCRTR1 methyl",
    "HCRTR1 rna"
  ],
  "HCRTR2": [
    "HCRTR2 cnv",
    "HCRTR2 methyl",
    "HCRTR2 rna"
  ],
  "HCST": [
    "HCST cnv",
    "HCST rna"
  ],
  "HDAC1": [
    "HDAC1 393_393_1_1_S393 phospho",
    "HDAC1 421_423_1_1_S421 phospho",
    "HDAC1 421_423_2_2_S421S423 phospho",
    "HDAC1 cnv",
    "HDAC1 methyl",
    "HDAC1 proteo",
    "HDAC1 rna"
  ],
  "HDAC10": [
    "HDAC10 cnv",
    "HDAC10 methyl",
    "HDAC10 proteo",
    "HDAC10 rna"
  ],
  "HDAC11": [
    "HDAC11 cnv",
    "HDAC11 methyl",
    "HDAC11 proteo",
    "HDAC11 rna"
  ],
  "HDAC11-AS1": [
    "HDAC11-AS1 methyl"
  ],
  "HDAC2": [
    "HDAC2 394_394_1_1_S394 phospho",
    "HDAC2 422_424_1_1_S422 phospho",
    "HDAC2 422_424_2_2_S422S424 phospho",
    "HDAC2 482_486_1_1_S486 phospho",
    "HDAC2 cnv",
    "HDAC2 methyl",
    "HDAC2 proteo",
    "HDAC2 rna"
  ],
  "HDAC2-AS2": [
    "HDAC2-AS2 methyl"
  ],
  "HDAC3": [
    "HDAC3 cnv",
    "HDAC3 methyl",
    "HDAC3 proteo",
    "HDAC3 rna"
  ],
  "HDAC4": [
    "HDAC4 196_197_1_0 phospho",
    "HDAC4 206_233_1_1_S210 phospho",
    "HDAC4 565_565_1_1_S565 phospho",
    "HDAC4 632_648_1_0 phospho",
    "HDAC4 632_648_1_1_S632 phospho",
    "HDAC4 632_648_1_1_S633 phospho",
    "HDAC4 cnv",
    "HDAC4 methyl",
    "HDAC4 proteo",
    "HDAC4 rna"
  ],
  "HDAC4-AS1": [
    "HDAC4-AS1 methyl"
  ],
  "HDAC5": [
    "HDAC5 1109_1109_1_1_S1109 phospho",
    "HDAC5 497_505_1_0 phospho",
    "HDAC5 660_663_1_0 phospho",
    "HDAC5 660_663_1_1_S662 phospho",
    "HDAC5 cnv",
    "HDAC5 methyl",
    "HDAC5 proteo",
    "HDAC5 rna"
  ],
  "HDAC6": [
    "HDAC6 22_31_1_1_S22 phospho",
    "HDAC6 methyl",
    "HDAC6 proteo",
    "HDAC6 rna"
  ],
  "HDAC7": [
    "HDAC7 358_368_1_1_S360 phospho",
    "HDAC7 488_503_1_1_S489 phospho",
    "HDAC7 cnv",
    "HDAC7 methyl",
    "HDAC7 proteo",
    "HDAC7 rna"
  ],
  "HDAC8": [
    "HDAC8 proteo",
    "HDAC8 rna"
  ],
  "HDAC9": [
    "HDAC9 cnv",
    "HDAC9 methyl",
    "HDAC9 proteo",
    "HDAC9 rna"
  ],
  "HDC": [
    "HDC cnv",
    "HDC rna"
  ],
  "HDDC2": [
    "HDDC2 cnv",
    "HDDC2 proteo",
    "HDDC2 rna"
  ],
  "HDDC3": [
    "HDDC3 cnv",
    "HDDC3 methyl",
    "HDDC3 proteo",
    "HDDC3 rna"
  ],
  "HDGF": [
    "HDGF 107_107_1_1_S107 phospho",
    "HDGF 132_133_1_0 phospho",
    "HDGF 132_133_1_1_S133 phospho",
    "HDGF 132_133_2_2_S132S133 phospho",
    "HDGF 165_165_1_1_S165 phospho",
    "HDGF 199_206_1_1_T200 phospho",
    "HDGF 239_239_1_1_S239 phospho",
    "HDGF cnv",
    "HDGF methyl",
    "HDGF proteo",
    "HDGF rna"
  ],
  "HDGFL1": [
    "HDGFL1 cnv",
    "HDGFL1 methyl",
    "HDGFL1 rna"
  ],
  "HDGFL2": [
    "HDGFL2 240_240_1_1_S240 phospho",
    "HDGFL2 366_370_1_0 phospho",
    "HDGFL2 366_370_2_2_S369S370 phospho",
    "HDGFL2 366_370_3_3_S366S369S370 phospho",
    "HDGFL2 454_458_1_1_S454 phospho",
    "HDGFL2 490_490_1_1_S490 phospho",
    "HDGFL2 633_634_1_1_S633 phospho",
    "HDGFL2 633_634_1_1_S634 phospho",
    "HDGFL2 651_651_1_1_S651 phospho",
    "HDGFL2 cnv",
    "HDGFL2 proteo",
    "HDGFL2 rna"
  ],
  "HDGFL3": [
    "HDGFL3 162_162_1_1_S162 phospho",
    "HDGFL3 178_189_2_0 phospho",
    "HDGFL3 178_189_2_2_S179S180 phospho",
    "HDGFL3 97_122_1_0 phospho",
    "HDGFL3 97_122_1_1_S121 phospho",
    "HDGFL3 cnv",
    "HDGFL3 methyl",
    "HDGFL3 proteo",
    "HDGFL3 rna"
  ],
  "HDHD2": [
    "HDHD2 cnv",
    "HDHD2 methyl",
    "HDHD2 proteo",
    "HDHD2 rna"
  ],
  "HDHD3": [
    "HDHD3 cnv",
    "HDHD3 methyl",
    "HDHD3 proteo",
    "HDHD3 rna"
  ],
  "HDHD5": [
    "HDHD5 cnv",
    "HDHD5 methyl",
    "HDHD5 proteo",
    "HDHD5 rna"
  ],
  "HDHD5-AS1": [
    "HDHD5-AS1 methyl"
  ],
  "HDLBP": [
    "HDLBP 64_76_1_1_S67 phospho",
    "HDLBP 911_911_1_1_S911 phospho",
    "HDLBP cnv",
    "HDLBP methyl",
    "HDLBP proteo",
    "HDLBP rna"
  ],
  "HDX": [
    "HDX rna"
  ],
  "HEATR1": [
    "HEATR1 cnv",
    "HEATR1 methyl",
    "HEATR1 proteo",
    "HEATR1 rna"
  ],
  "HEATR3": [
    "HEATR3 cnv",
    "HEATR3 methyl",
    "HEATR3 proteo",
    "HEATR3 rna"
  ],
  "HEATR4": [
    "HEATR4 cnv",
    "HEATR4 methyl",
    "HEATR4 rna"
  ],
  "HEATR5A": [
    "HEATR5A cnv",
    "HEATR5A methyl",
    "HEATR5A proteo",
    "HEATR5A rna"
  ],
  "HEATR5A-DT": [
    "HEATR5A-DT methyl"
  ],
  "HEATR5B": [
    "HEATR5B 1735_1743_1_1_S1737 phospho",
    "HEATR5B cnv",
    "HEATR5B methyl",
    "HEATR5B proteo",
    "HEATR5B rna"
  ],
  "HEATR6": [
    "HEATR6 1112_1124_1_1_S1124 phospho",
    "HEATR6 635_643_1_1_S643 phospho",
    "HEATR6 cnv",
    "HEATR6 methyl",
    "HEATR6 proteo",
    "HEATR6 rna"
  ],
  "HEATR6-DT": [
    "HEATR6-DT methyl"
  ],
  "HEATR9": [
    "HEATR9 cnv",
    "HEATR9 rna"
  ],
  "HEBP1": [
    "HEBP1 cnv",
    "HEBP1 methyl",
    "HEBP1 proteo",
    "HEBP1 rna"
  ],
  "HEBP2": [
    "HEBP2 cnv",
    "HEBP2 methyl",
    "HEBP2 proteo",
    "HEBP2 rna"
  ],
  "HECA": [
    "HECA cnv",
    "HECA methyl",
    "HECA proteo",
    "HECA rna"
  ],
  "HECTD1": [
    "HECTD1 1384_1402_1_1_S1384 phospho",
    "HECTD1 1772_1772_1_1_S1772 phospho",
    "HECTD1 625_640_1_1_S632 phospho",
    "HECTD1 cnv",
    "HECTD1 methyl",
    "HECTD1 proteo",
    "HECTD1 rna"
  ],
  "HECTD2": [
    "HECTD2 cnv",
    "HECTD2 methyl",
    "HECTD2 rna"
  ],
  "HECTD3": [
    "HECTD3 cnv",
    "HECTD3 methyl",
    "HECTD3 proteo",
    "HECTD3 rna"
  ],
  "HECTD4": [
    "HECTD4 1771_1792_1_1_S1781 phospho",
    "HECTD4 2365_2368_1_1_T2368 phospho",
    "HECTD4 cnv",
    "HECTD4 methyl",
    "HECTD4 proteo",
    "HECTD4 rna"
  ],
  "HECW1": [
    "HECW1 66_77_1_1_S68 phospho",
    "HECW1 783_795_1_1_S789 phospho",
    "HECW1 903_909_1_1_S903 phospho",
    "HECW1 903_909_1_1_S905 phospho",
    "HECW1 cnv",
    "HECW1 methyl",
    "HECW1 proteo",
    "HECW1 rna"
  ],
  "HECW2": [
    "HECW2 1167_1178_1_1_S1175 phospho",
    "HECW2 48_57_1_1_S48 phospho",
    "HECW2 850_852_1_1_S852 phospho",
    "HECW2 907_909_1_0 phospho",
    "HECW2 cnv",
    "HECW2 methyl",
    "HECW2 proteo",
    "HECW2 rna"
  ],
  "HEG1": [
    "HEG1 1319_1320_1_1_S1319 phospho",
    "HEG1 cnv",
    "HEG1 methyl",
    "HEG1 proteo",
    "HEG1 rna"
  ],
  "HEIH": [
    "HEIH methyl"
  ],
  "HELB": [
    "HELB cnv",
    "HELB rna"
  ],
  "HELLS": [
    "HELLS cnv",
    "HELLS methyl",
    "HELLS rna"
  ],
  "HELQ": [
    "HELQ cnv",
    "HELQ methyl",
    "HELQ rna"
  ],
  "HELT": [
    "HELT cnv",
    "HELT methyl",
    "HELT rna"
  ],
  "HELZ": [
    "HELZ 1127_1127_1_1_S1127 phospho",
    "HELZ 1312_1330_1_1_S1318 phospho",
    "HELZ 1764_1781_1_1_S1764 phospho",
    "HELZ cnv",
    "HELZ methyl",
    "HELZ proteo",
    "HELZ rna"
  ],
  "HELZ2": [
    "HELZ2 330_342_1_1_S338 phospho",
    "HELZ2 cnv",
    "HELZ2 methyl",
    "HELZ2 proteo",
    "HELZ2 rna"
  ],
  "HEMGN": [
    "HEMGN cnv",
    "HEMGN rna"
  ],
  "HEMK1": [
    "HEMK1 cnv",
    "HEMK1 methyl",
    "HEMK1 rna"
  ],
  "HENMT1": [
    "HENMT1 cnv",
    "HENMT1 methyl",
    "HENMT1 rna"
  ],
  "HEPACAM": [
    "HEPACAM 278_281_1_0 phospho",
    "HEPACAM 278_281_1_1_S278 phospho",
    "HEPACAM 278_295_1_1_S278 phospho",
    "HEPACAM 295_295_1_1_T295 phospho",
    "HEPACAM 295_299_1_1_S299 phospho",
    "HEPACAM 318_321_1_1_S318 phospho",
    "HEPACAM 331_343_1_1_S331 phospho",
    "HEPACAM 331_343_1_1_S343 phospho",
    "HEPACAM 331_350_1_1_S350 phospho",
    "HEPACAM 331_350_2_2_S331S350 phospho",
    "HEPACAM 331_350_2_2_S343S350 phospho",
    "HEPACAM 364_371_1_1_S368 phospho",
    "HEPACAM 364_371_2_2_S364S368 phospho",
    "HEPACAM 374_384_1_1_S377 phospho",
    "HEPACAM 415_415_1_1_S415 phospho",
    "HEPACAM DGKPLLNDSR-N3H3F1S0G0 glyco",
    "HEPACAM DGKPLLNDSR-N3H4F2S0G0 glyco",
    "HEPACAM DGKPLLNDSR-N3H5F1S0G0 glyco",
    "HEPACAM DGKPLLNDSR-N3H5F1S1G0 glyco",
    "HEPACAM DGKPLLNDSR-N3H5F2S0G0 glyco",
    "HEPACAM DGKPLLNDSR-N4H4F2S0G0 glyco",
    "HEPACAM cnv",
    "HEPACAM proteo",
    "HEPACAM rna"
  ],
  "HEPACAM2": [
    "HEPACAM2 cnv",
    "HEPACAM2 proteo",
    "HEPACAM2 rna"
  ],
  "HEPH": [
    "HEPH 1147_1152_1_1_S1147 phospho",
    "HEPH proteo",
    "HEPH rna"
  ],
  "HEPHL1": [
    "HEPHL1 cnv",
    "HEPHL1 rna"
  ],
  "HEPN1": [
    "HEPN1 cnv",
    "HEPN1 rna"
  ],
  "HERC1": [
    "HERC1 1428_1444_1_0 phospho",
    "HERC1 1428_1444_1_1_S1428 phospho",
    "HERC1 1510_1529_1_1_S1512 phospho",
    "HERC1 1510_1529_2_2_S1512S1521 phospho",
    "HERC1 2701_2712_1_1_T2701 phospho",
    "HERC1 2720_2728_1_1_S2720 phospho",
    "HERC1 2745_2763_1_0 phospho",
    "HERC1 2745_2763_1_1_S2747 phospho",
    "HERC1 4857_4861_1_1_S4857 phospho",
    "HERC1 cnv",
    "HERC1 methyl",
    "HERC1 proteo",
    "HERC1 rna"
  ],
  "HERC2": [
    "HERC2 cnv",
    "HERC2 methyl",
    "HERC2 proteo",
    "HERC2 rna"
  ],
  "HERC2P3": [
    "HERC2P3 methyl"
  ],
  "HERC3": [
    "HERC3 cnv",
    "HERC3 rna"
  ],
  "HERC4": [
    "HERC4 cnv",
    "HERC4 methyl",
    "HERC4 proteo",
    "HERC4 rna"
  ],
  "HERC5": [
    "HERC5 cnv",
    "HERC5 methyl",
    "HERC5 proteo",
    "HERC5 rna"
  ],
  "HERC6": [
    "HERC6 cnv",
    "HERC6 methyl",
    "HERC6 rna"
  ],
  "HERPUD1": [
    "HERPUD1 cnv",
    "HERPUD1 methyl",
    "HERPUD1 rna"
  ],
  "HERPUD2": [
    "HERPUD2 79_94_1_1_T90 phospho",
    "HERPUD2 cnv",
    "HERPUD2 methyl",
    "HERPUD2 proteo",
    "HERPUD2 rna"
  ],
  "HERPUD2-AS1": [
    "HERPUD2-AS1 methyl"
  ],
  "HES1": [
    "HES1 10_24_1_1_S12 phospho",
    "HES1 cnv",
    "HES1 methyl",
    "HES1 rna"
  ],
  "HES2": [
    "HES2 cnv",
    "HES2 methyl",
    "HES2 rna"
  ],
  "HES3": [
    "HES3 cnv",
    "HES3 rna"
  ],
  "HES4": [
    "HES4 cnv",
    "HES4 methyl",
    "HES4 rna"
  ],
  "HES5": [
    "HES5 cnv",
    "HES5 methyl",
    "HES5 rna"
  ],
  "HES6": [
    "HES6 cnv",
    "HES6 methyl",
    "HES6 rna"
  ],
  "HES7": [
    "HES7 cnv",
    "HES7 methyl",
    "HES7 rna"
  ],
  "HESX1": [
    "HESX1 cnv",
    "HESX1 methyl",
    "HESX1 rna"
  ],
  "HEXA": [
    "HEXA SAEGTFFINK-N2H5F0S0G0 glyco",
    "HEXA SAEGTFFINK-N2H6F0S0G0 glyco",
    "HEXA SAEGTFFINK-N2H7F0S0G0 glyco",
    "HEXA SAEGTFFINK-N2H8F0S0G0 glyco",
    "HEXA SAEGTFFINK-N2H9F0S0G0 glyco",
    "HEXA cnv",
    "HEXA methyl",
    "HEXA proteo",
    "HEXA rna"
  ],
  "HEXA-AS1": [
    "HEXA-AS1 methyl"
  ],
  "HEXB": [
    "HEXB cnv",
    "HEXB methyl",
    "HEXB proteo",
    "HEXB rna"
  ],
  "HEXD": [
    "HEXD cnv",
    "HEXD methyl",
    "HEXD proteo",
    "HEXD rna"
  ],
  "HEXIM1": [
    "HEXIM1 cnv",
    "HEXIM1 methyl",
    "HEXIM1 proteo",
    "HEXIM1 rna"
  ],
  "HEXIM2": [
    "HEXIM2 45_54_1_1_S51 phospho",
    "HEXIM2 45_54_2_2_S51T54 phospho",
    "HEXIM2 45_68_2_2_S51T54 phospho",
    "HEXIM2 73_91_1_1_S75 phospho",
    "HEXIM2 96_103_1_1_S98 phospho",
    "HEXIM2 cnv",
    "HEXIM2 methyl",
    "HEXIM2 proteo",
    "HEXIM2 rna"
  ],
  "HEY1": [
    "HEY1 cnv",
    "HEY1 methyl",
    "HEY1 rna"
  ],
  "HEY2": [
    "HEY2 cnv",
    "HEY2 methyl",
    "HEY2 rna"
  ],
  "HEYL": [
    "HEYL cnv",
    "HEYL methyl",
    "HEYL rna"
  ],
  "HFE": [
    "HFE cnv",
    "HFE proteo",
    "HFE rna"
  ],
  "HFM1": [
    "HFM1 cnv",
    "HFM1 methyl",
    "HFM1 rna"
  ],
  "HGD": [
    "HGD cnv",
    "HGD rna"
  ],
  "HGF": [
    "HGF cnv",
    "HGF proteo",
    "HGF rna"
  ],
  "HGFAC": [
    "HGFAC DSVSVVLGQHFFNR-N4H5F0S2G0 glyco",
    "HGFAC cnv",
    "HGFAC proteo",
    "HGFAC rna"
  ],
  "HGH1": [
    "HGH1 cnv",
    "HGH1 proteo",
    "HGH1 rna"
  ],
  "HGS": [
    "HGS cnv",
    "HGS methyl",
    "HGS proteo",
    "HGS rna"
  ],
  "HGSNAT": [
    "HGSNAT 211_230_1_1_S211 phospho",
    "HGSNAT FGEFGNYSLLVK-N2H5F0S0G0 glyco",
    "HGSNAT FGEFGNYSLLVK-N2H6F0S0G0 glyco",
    "HGSNAT FGEFGNYSLLVK-N2H7F0S0G0 glyco",
    "HGSNAT FGEFGNYSLLVK-N2H8F0S0G0 glyco",
    "HGSNAT FGEFGNYSLLVK-N3H6F0S0G0 glyco",
    "HGSNAT cnv",
    "HGSNAT methyl",
    "HGSNAT rna"
  ],
  "HHAT": [
    "HHAT cnv",
    "HHAT methyl",
    "HHAT rna"
  ],
  "HHATL": [
    "HHATL cnv",
    "HHATL rna"
  ],
  "HHEX": [
    "HHEX cnv",
    "HHEX methyl",
    "HHEX rna"
  ],
  "HHIP": [
    "HHIP cnv",
    "HHIP methyl",
    "HHIP rna"
  ],
  "HHIP-AS1": [
    "HHIP-AS1 methyl"
  ],
  "HHIPL1": [
    "HHIPL1 cnv",
    "HHIPL1 methyl",
    "HHIPL1 proteo",
    "HHIPL1 rna"
  ],
  "HHIPL2": [
    "HHIPL2 cnv",
    "HHIPL2 rna"
  ],
  "HHLA1": [
    "HHLA1 cnv",
    "HHLA1 rna"
  ],
  "HHLA2": [
    "HHLA2 cnv",
    "HHLA2 rna"
  ],
  "HHLA3": [
    "HHLA3 methyl"
  ],
  "HIBADH": [
    "HIBADH cnv",
    "HIBADH methyl",
    "HIBADH proteo",
    "HIBADH rna"
  ],
  "HIBCH": [
    "HIBCH cnv",
    "HIBCH methyl",
    "HIBCH proteo",
    "HIBCH rna"
  ],
  "HIC1": [
    "HIC1 cnv",
    "HIC1 methyl",
    "HIC1 rna"
  ],
  "HIC2": [
    "HIC2 cnv",
    "HIC2 methyl",
    "HIC2 rna"
  ],
  "HID1": [
    "HID1 591_612_1_1_S593 phospho",
    "HID1 cnv",
    "HID1 methyl",
    "HID1 proteo",
    "HID1 rna"
  ],
  "HIF1A": [
    "HIF1A cnv",
    "HIF1A methyl",
    "HIF1A rna"
  ],
  "HIF1A-AS3": [
    "HIF1A-AS3 methyl"
  ],
  "HIF1AN": [
    "HIF1AN cnv",
    "HIF1AN methyl",
    "HIF1AN proteo",
    "HIF1AN rna"
  ],
  "HIF3A": [
    "HIF3A cnv",
    "HIF3A methyl",
    "HIF3A rna"
  ],
  "HIGD1A": [
    "HIGD1A cnv",
    "HIGD1A methyl",
    "HIGD1A proteo",
    "HIGD1A rna"
  ],
  "HIGD1B": [
    "HIGD1B cnv",
    "HIGD1B rna"
  ],
  "HIGD1C": [
    "HIGD1C cnv",
    "HIGD1C rna"
  ],
  "HIGD2A": [
    "HIGD2A cnv",
    "HIGD2A methyl",
    "HIGD2A rna"
  ],
  "HIGD2B": [
    "HIGD2B cnv",
    "HIGD2B methyl",
    "HIGD2B rna"
  ],
  "HIKESHI": [
    "HIKESHI cnv",
    "HIKESHI proteo",
    "HIKESHI rna"
  ],
  "HILPDA": [
    "HILPDA cnv",
    "HILPDA methyl",
    "HILPDA rna"
  ],
  "HINFP": [
    "HINFP cnv",
    "HINFP methyl",
    "HINFP rna"
  ],
  "HINT1": [
    "HINT1 45_50_1_1_S45 phospho",
    "HINT1 cnv",
    "HINT1 methyl",
    "HINT1 proteo",
    "HINT1 rna"
  ],
  "HINT2": [
    "HINT2 cnv",
    "HINT2 methyl",
    "HINT2 proteo",
    "HINT2 rna"
  ],
  "HINT3": [
    "HINT3 cnv",
    "HINT3 methyl",
    "HINT3 proteo",
    "HINT3 rna"
  ],
  "HIP1": [
    "HIP1 cnv",
    "HIP1 methyl",
    "HIP1 proteo",
    "HIP1 rna"
  ],
  "HIP1R": [
    "HIP1R 6_6_1_1_S6 phospho",
    "HIP1R cnv",
    "HIP1R methyl",
    "HIP1R proteo",
    "HIP1R rna"
  ],
  "HIPK1": [
    "HIPK1 cnv",
    "HIPK1 kinase",
    "HIPK1 methyl",
    "HIPK1 rna"
  ],
  "HIPK1-AS1": [
    "HIPK1-AS1 methyl"
  ],
  "HIPK2": [
    "HIPK2 cnv",
    "HIPK2 kinase",
    "HIPK2 methyl",
    "HIPK2 rna"
  ],
  "HIPK3": [
    "HIPK3 cnv",
    "HIPK3 kinase",
    "HIPK3 methyl",
    "HIPK3 rna"
  ],
  "HIPK4": [
    "HIPK4 cnv",
    "HIPK4 kinase",
    "HIPK4 rna"
  ],
  "HIRA": [
    "HIRA cnv",
    "HIRA methyl",
    "HIRA proteo",
    "HIRA rna"
  ],
  "HIRIP3": [
    "HIRIP3 125_125_1_1_S125 phospho",
    "HIRIP3 142_143_2_2_S142S143 phospho",
    "HIRIP3 159_160_2_2_S159S160 phospho",
    "HIRIP3 196_199_1_1_S196 phospho",
    "HIRIP3 196_199_2_2_S196S199 phospho",
    "HIRIP3 219_227_1_1_S227 phospho",
    "HIRIP3 219_227_2_2_S223S227 phospho",
    "HIRIP3 223_227_1_1_S227 phospho",
    "HIRIP3 330_345_3_3_S330S332S333 phospho",
    "HIRIP3 527_543_1_1_S530 phospho",
    "HIRIP3 550_555_1_1_S555 phospho",
    "HIRIP3 550_555_2_2_S551S555 phospho",
    "HIRIP3 84_87_1_1_T84 phospho",
    "HIRIP3 84_87_2_2_T84S87 phospho",
    "HIRIP3 cnv",
    "HIRIP3 methyl",
    "HIRIP3 proteo",
    "HIRIP3 rna"
  ],
  "HIVEP1": [
    "HIVEP1 779_782_1_1_S779 phospho",
    "HIVEP1 cnv",
    "HIVEP1 methyl",
    "HIVEP1 rna"
  ],
  "HIVEP2": [
    "HIVEP2 1085_1102_1_1_S1085 phospho",
    "HIVEP2 cnv",
    "HIVEP2 methyl",
    "HIVEP2 rna"
  ],
  "HIVEP3": [
    "HIVEP3 1012_1024_1_1_S1012 phospho",
    "HIVEP3 2245_2255_1_1_S2245 phospho",
    "HIVEP3 2245_2255_2_2_S2245S2255 phospho",
    "HIVEP3 495_499_1_1_S496 phospho",
    "HIVEP3 720_733_1_1_S720 phospho",
    "HIVEP3 cnv",
    "HIVEP3 methyl",
    "HIVEP3 proteo",
    "HIVEP3 rna"
  ],
  "HJURP": [
    "HJURP cnv",
    "HJURP methyl",
    "HJURP rna"
  ],
  "HJV": [
    "HJV cnv",
    "HJV methyl",
    "HJV rna"
  ],
  "HK1": [
    "HK1 336_340_1_1_S337 phospho",
    "HK1 cnv",
    "HK1 methyl",
    "HK1 proteo",
    "HK1 rna"
  ],
  "HK2": [
    "HK2 cnv",
    "HK2 methyl",
    "HK2 proteo",
    "HK2 rna"
  ],
  "HK3": [
    "HK3 cnv",
    "HK3 proteo",
    "HK3 rna"
  ],
  "HKDC1": [
    "HKDC1 cnv",
    "HKDC1 proteo",
    "HKDC1 rna"
  ],
  "HLA-A": [
    "HLA-A 343_361_1_0 phospho",
    "HLA-A 343_361_1_1_S343 phospho",
    "HLA-A 343_361_1_1_S352 phospho",
    "HLA-A 343_361_1_1_S356 phospho",
    "HLA-A 343_361_1_1_S359 phospho",
    "HLA-A 343_361_2_2_S356S359 phospho",
    "HLA-A cnv",
    "HLA-A methyl",
    "HLA-A proteo",
    "HLA-A rna"
  ],
  "HLA-B": [
    "HLA-B cnv",
    "HLA-B methyl",
    "HLA-B proteo",
    "HLA-B rna"
  ],
  "HLA-C": [
    "HLA-C cnv",
    "HLA-C methyl",
    "HLA-C proteo",
    "HLA-C rna"
  ],
  "HLA-DMA": [
    "HLA-DMA cnv",
    "HLA-DMA methyl",
    "HLA-DMA proteo",
    "HLA-DMA rna"
  ],
  "HLA-DMB": [
    "HLA-DMB cnv",
    "HLA-DMB proteo",
    "HLA-DMB rna"
  ],
  "HLA-DOA": [
    "HLA-DOA cnv",
    "HLA-DOA methyl",
    "HLA-DOA rna"
  ],
  "HLA-DOB": [
    "HLA-DOB cnv",
    "HLA-DOB rna"
  ],
  "HLA-DPA1": [
    "HLA-DPA1 cnv",
    "HLA-DPA1 methyl",
    "HLA-DPA1 proteo",
    "HLA-DPA1 rna"
  ],
  "HLA-DPB1": [
    "HLA-DPB1 QECYAFNGTQR-N2H6F0S0G0 glyco",
    "HLA-DPB1 QECYAFNGTQR-N2H8F0S0G0 glyco",
    "HLA-DPB1 cnv",
    "HLA-DPB1 methyl",
    "HLA-DPB1 proteo",
    "HLA-DPB1 rna"
  ],
  "HLA-DQA1": [
    "HLA-DQA1 cnv",
    "HLA-DQA1 rna"
  ],
  "HLA-DQA2": [
    "HLA-DQA2 cnv",
    "HLA-DQA2 rna"
  ],
  "HLA-DQB1": [
    "HLA-DQB1 cnv",
    "HLA-DQB1 rna"
  ],
  "HLA-DQB2": [
    "HLA-DQB2 cnv",
    "HLA-DQB2 rna"
  ],
  "HLA-DRA": [
    "HLA-DRA FTPPVVNVTWLR-N2H5F0S0G0 glyco",
    "HLA-DRA FTPPVVNVTWLR-N2H6F0S0G0 glyco",
    "HLA-DRA FTPPVVNVTWLR-N2H7F0S0G0 glyco",
    "HLA-DRA FTPPVVNVTWLR-N2H8F0S0G0 glyco",
    "HLA-DRA cnv",
    "HLA-DRA proteo",
    "HLA-DRA rna"
  ],
  "HLA-DRB1": [
    "HLA-DRB1 cnv",
    "HLA-DRB1 proteo",
    "HLA-DRB1 rna"
  ],
  "HLA-DRB3": [
    "HLA-DRB3 proteo"
  ],
  "HLA-DRB4": [
    "HLA-DRB4 proteo"
  ],
  "HLA-DRB5": [
    "HLA-DRB5 cnv",
    "HLA-DRB5 proteo",
    "HLA-DRB5 rna"
  ],
  "HLA-E": [
    "HLA-E cnv",
    "HLA-E proteo",
    "HLA-E rna"
  ],
  "HLA-F": [
    "HLA-F cnv",
    "HLA-F methyl",
    "HLA-F proteo",
    "HLA-F rna"
  ],
  "HLA-F-AS1": [
    "HLA-F-AS1 methyl"
  ],
  "HLA-G": [
    "HLA-G cnv",
    "HLA-G methyl",
    "HLA-G rna"
  ],
  "HLA-L": [
    "HLA-L methyl"
  ],
  "HLA-V": [
    "HLA-V methyl"
  ],
  "HLCS": [
    "HLCS 79_89_1_1_S79 phospho",
    "HLCS cnv",
    "HLCS methyl",
    "HLCS proteo",
    "HLCS rna"
  ],
  "HLF": [
    "HLF cnv",
    "HLF methyl",
    "HLF rna"
  ],
  "HLTF": [
    "HLTF cnv",
    "HLTF methyl",
    "HLTF proteo",
    "HLTF rna"
  ],
  "HLTF-AS1": [
    "HLTF-AS1 methyl"
  ],
  "HLX": [
    "HLX cnv",
    "HLX methyl",
    "HLX rna"
  ],
  "HLX-AS1": [
    "HLX-AS1 methyl"
  ],
  "HM13": [
    "HM13 cnv",
    "HM13 methyl",
    "HM13 proteo",
    "HM13 rna"
  ],
  "HMBOX1": [
    "HMBOX1 cnv",
    "HMBOX1 proteo",
    "HMBOX1 rna"
  ],
  "HMBS": [
    "HMBS cnv",
    "HMBS methyl",
    "HMBS proteo",
    "HMBS rna"
  ],
  "HMCES": [
    "HMCES cnv",
    "HMCES methyl",
    "HMCES proteo",
    "HMCES rna"
  ],
  "HMCN1": [
    "HMCN1 cnv",
    "HMCN1 rna"
  ],
  "HMCN2": [
    "HMCN2 cnv",
    "HMCN2 methyl",
    "HMCN2 rna"
  ],
  "HMG20A": [
    "HMG20A cnv",
    "HMG20A methyl",
    "HMG20A proteo",
    "HMG20A rna"
  ],
  "HMG20B": [
    "HMG20B cnv",
    "HMG20B methyl",
    "HMG20B proteo",
    "HMG20B rna"
  ],
  "HMGA1": [
    "HMGA1 36_53_1_0 phospho",
    "HMGA1 36_53_1_1_S36 phospho",
    "HMGA1 36_53_1_1_T53 phospho",
    "HMGA1 38_42_1_1_T42 phospho",
    "HMGA1 99_103_1_0 phospho",
    "HMGA1 99_103_1_1_S103 phospho",
    "HMGA1 99_103_2_2_S102S103 phospho",
    "HMGA1 cnv",
    "HMGA1 methyl",
    "HMGA1 proteo",
    "HMGA1 rna"
  ],
  "HMGA2": [
    "HMGA2 40_44_1_1_S44 phospho",
    "HMGA2 97_105_2_0 phospho",
    "HMGA2 cnv",
    "HMGA2 methyl",
    "HMGA2 proteo",
    "HMGA2 rna"
  ],
  "HMGB1": [
    "HMGB1 cnv",
    "HMGB1 methyl",
    "HMGB1 proteo",
    "HMGB1 rna"
  ],
  "HMGB1P1": [
    "HMGB1P1 cnv",
    "HMGB1P1 rna"
  ],
  "HMGB2": [
    "HMGB2 cnv",
    "HMGB2 methyl",
    "HMGB2 proteo",
    "HMGB2 rna"
  ],
  "HMGB3": [
    "HMGB3 methyl",
    "HMGB3 proteo",
    "HMGB3 rna"
  ],
  "HMGB4": [
    "HMGB4 cnv",
    "HMGB4 rna"
  ],
  "HMGCL": [
    "HMGCL cnv",
    "HMGCL proteo",
    "HMGCL rna"
  ],
  "HMGCLL1": [
    "HMGCLL1 13_14_1_1_S13 phospho",
    "HMGCLL1 cnv",
    "HMGCLL1 methyl",
    "HMGCLL1 rna"
  ],
  "HMGCR": [
    "HMGCR cnv",
    "HMGCR methyl",
    "HMGCR rna"
  ],
  "HMGCS1": [
    "HMGCS1 471_495_1_1_S495 phospho",
    "HMGCS1 4_4_1_1_S4 phospho",
    "HMGCS1 506_516_1_1_S516 phospho",
    "HMGCS1 cnv",
    "HMGCS1 methyl",
    "HMGCS1 proteo",
    "HMGCS1 rna"
  ],
  "HMGCS2": [
    "HMGCS2 cnv",
    "HMGCS2 rna"
  ],
  "HMGN1": [
    "HMGN1 25_25_1_1_S25 phospho",
    "HMGN1 81_89_1_1_S89 phospho",
    "HMGN1 81_89_2_2_S86S89 phospho",
    "HMGN1 83_89_1_1_S89 phospho",
    "HMGN1 cnv",
    "HMGN1 methyl",
    "HMGN1 proteo",
    "HMGN1 rna"
  ],
  "HMGN2": [
    "HMGN2 cnv",
    "HMGN2 methyl",
    "HMGN2 proteo",
    "HMGN2 rna"
  ],
  "HMGN3": [
    "HMGN3 6_10_1_1_S6 phospho",
    "HMGN3 75_83_1_1_S78 phospho",
    "HMGN3 75_93_1_1_T83 phospho",
    "HMGN3 91_93_1_1_S93 phospho",
    "HMGN3 cnv",
    "HMGN3 methyl",
    "HMGN3 proteo",
    "HMGN3 rna"
  ],
  "HMGN4": [
    "HMGN4 cnv",
    "HMGN4 methyl",
    "HMGN4 proteo",
    "HMGN4 rna"
  ],
  "HMGN5": [
    "HMGN5 proteo",
    "HMGN5 rna"
  ],
  "HMGXB3": [
    "HMGXB3 cnv",
    "HMGXB3 methyl",
    "HMGXB3 rna"
  ],
  "HMGXB4": [
    "HMGXB4 101_108_1_1_S101 phospho",
    "HMGXB4 101_108_1_1_S102 phospho",
    "HMGXB4 79_94_1_0 phospho",
    "HMGXB4 cnv",
    "HMGXB4 methyl",
    "HMGXB4 proteo",
    "HMGXB4 rna"
  ],
  "HMHB1": [
    "HMHB1 cnv",
    "HMHB1 rna"
  ],
  "HMMR": [
    "HMMR cnv",
    "HMMR methyl",
    "HMMR rna"
  ],
  "HMOX1": [
    "HMOX1 241_252_1_1_S241 phospho",
    "HMOX1 cnv",
    "HMOX1 methyl",
    "HMOX1 proteo",
    "HMOX1 rna"
  ],
  "HMOX2": [
    "HMOX2 cnv",
    "HMOX2 methyl",
    "HMOX2 proteo",
    "HMOX2 rna"
  ],
  "HMSD": [
    "HMSD cnv",
    "HMSD rna"
  ],
  "HMX1": [
    "HMX1 cnv",
    "HMX1 rna"
  ],
  "HMX2": [
    "HMX2 cnv",
    "HMX2 methyl",
    "HMX2 rna"
  ],
  "HMX3": [
    "HMX3 cnv",
    "HMX3 methyl",
    "HMX3 rna"
  ],
  "HNF1A": [
    "HNF1A cnv",
    "HNF1A methyl",
    "HNF1A rna"
  ],
  "HNF1B": [
    "HNF1B cnv",
    "HNF1B methyl",
    "HNF1B rna"
  ],
  "HNF4A": [
    "HNF4A cnv",
    "HNF4A rna"
  ],
  "HNF4G": [
    "HNF4G cnv",
    "HNF4G methyl",
    "HNF4G rna"
  ],
  "HNMT": [
    "HNMT cnv",
    "HNMT proteo",
    "HNMT rna"
  ],
  "HNRNPA0": [
    "HNRNPA0 cnv",
    "HNRNPA0 methyl",
    "HNRNPA0 proteo",
    "HNRNPA0 rna"
  ],
  "HNRNPA1": [
    "HNRNPA1 305_316_1_1_S316 phospho",
    "HNRNPA1 4_6_1_1_S6 phospho",
    "HNRNPA1 SGSGNFGGGSYNDFGNYNNQSSNFGPMK-N5H3F0S0G0 glyco",
    "HNRNPA1 SGSGNFGGGSYNDFGNYNNQSSNFGPMK-N6H5F4S2G0 glyco",
    "HNRNPA1 cnv",
    "HNRNPA1 methyl",
    "HNRNPA1 proteo",
    "HNRNPA1 rna"
  ],
  "HNRNPA1L2": [
    "HNRNPA1L2 cnv",
    "HNRNPA1L2 methyl",
    "HNRNPA1L2 rna"
  ],
  "HNRNPA1L3": [
    "HNRNPA1L3 cnv",
    "HNRNPA1L3 rna"
  ],
  "HNRNPA2B1": [
    "HNRNPA2B1 162_164_1_1_T164 phospho",
    "HNRNPA2B1 17_24_1_1_S17 phospho",
    "HNRNPA2B1 213_213_1_1_S213 phospho",
    "HNRNPA2B1 232_250_1_1_S247 phospho",
    "HNRNPA2B1 306_312_1_1_S306 phospho",
    "HNRNPA2B1 319_335_1_1_S329 phospho",
    "HNRNPA2B1 319_335_1_1_S332 phospho",
    "HNRNPA2B1 56_73_1_1_S73 phospho",
    "HNRNPA2B1 90_98_1_1_S90 phospho",
    "HNRNPA2B1 cnv",
    "HNRNPA2B1 methyl",
    "HNRNPA2B1 proteo",
    "HNRNPA2B1 rna"
  ],
  "HNRNPA3": [
    "HNRNPA3 355_375_1_0 phospho",
    "HNRNPA3 355_375_1_1_S358 phospho",
    "HNRNPA3 cnv",
    "HNRNPA3 methyl",
    "HNRNPA3 proteo",
    "HNRNPA3 rna"
  ],
  "HNRNPAB": [
    "HNRNPAB 235_242_1_1_S242 phospho",
    "HNRNPAB 255_269_1_1_S255 phospho",
    "HNRNPAB 255_269_1_1_S266 phospho",
    "HNRNPAB cnv",
    "HNRNPAB methyl",
    "HNRNPAB proteo",
    "HNRNPAB rna"
  ],
  "HNRNPC": [
    "HNRNPC 220_228_1_1_S220 phospho",
    "HNRNPC 220_228_1_1_S228 phospho",
    "HNRNPC 220_228_2_0 phospho",
    "HNRNPC 220_228_2_2_S220S228 phospho",
    "HNRNPC 240_247_1_1_S247 phospho",
    "HNRNPC 286_293_1_1_S286 phospho",
    "HNRNPC cnv",
    "HNRNPC methyl",
    "HNRNPC proteo",
    "HNRNPC rna"
  ],
  "HNRNPCL1": [
    "HNRNPCL1 cnv",
    "HNRNPCL1 rna"
  ],
  "HNRNPCL2": [
    "HNRNPCL2 cnv",
    "HNRNPCL2 rna"
  ],
  "HNRNPCL3": [
    "HNRNPCL3 cnv"
  ],
  "HNRNPCL4": [
    "HNRNPCL4 cnv"
  ],
  "HNRNPD": [
    "HNRNPD 127_134_1_1_T127 phospho",
    "HNRNPD 190_193_1_1_S190 phospho",
    "HNRNPD 71_83_1_0 phospho",
    "HNRNPD 71_83_1_1_S83 phospho",
    "HNRNPD 71_83_2_0 phospho",
    "HNRNPD 80_83_1_1_S83 phospho",
    "HNRNPD cnv",
    "HNRNPD methyl",
    "HNRNPD proteo",
    "HNRNPD rna"
  ],
  "HNRNPD-DT": [
    "HNRNPD-DT methyl"
  ],
  "HNRNPDL": [
    "HNRNPDL 241_245_1_1_S241 phospho",
    "HNRNPDL cnv",
    "HNRNPDL methyl",
    "HNRNPDL proteo",
    "HNRNPDL rna"
  ],
  "HNRNPF": [
    "HNRNPF cnv",
    "HNRNPF methyl",
    "HNRNPF proteo",
    "HNRNPF rna"
  ],
  "HNRNPH1": [
    "HNRNPH1 21_23_1_1_S23 phospho",
    "HNRNPH1 54_63_1_1_S63 phospho",
    "HNRNPH1 cnv",
    "HNRNPH1 methyl",
    "HNRNPH1 proteo",
    "HNRNPH1 rna"
  ],
  "HNRNPH2": [
    "HNRNPH2 methyl",
    "HNRNPH2 proteo",
    "HNRNPH2 rna"
  ],
  "HNRNPH3": [
    "HNRNPH3 207_216_1_1_S216 phospho",
    "HNRNPH3 cnv",
    "HNRNPH3 methyl",
    "HNRNPH3 proteo",
    "HNRNPH3 rna"
  ],
  "HNRNPK": [
    "HNRNPK 107_138_1_0 phospho",
    "HNRNPK 107_138_1_1_S116 phospho",
    "HNRNPK 214_216_1_1_S216 phospho",
    "HNRNPK 280_284_1_1_S284 phospho",
    "HNRNPK cnv",
    "HNRNPK methyl",
    "HNRNPK proteo",
    "HNRNPK rna"
  ],
  "HNRNPL": [
    "HNRNPL 583_589_1_1_S589 phospho",
    "HNRNPL 98_101_1_1_S101 phospho",
    "HNRNPL cnv",
    "HNRNPL methyl",
    "HNRNPL proteo",
    "HNRNPL rna"
  ],
  "HNRNPLL": [
    "HNRNPLL 22_30_1_1_S30 phospho",
    "HNRNPLL 54_63_1_1_S54 phospho",
    "HNRNPLL 54_63_1_1_S56 phospho",
    "HNRNPLL cnv",
    "HNRNPLL methyl",
    "HNRNPLL proteo",
    "HNRNPLL rna"
  ],
  "HNRNPM": [
    "HNRNPM 467_468_1_0 phospho",
    "HNRNPM 467_468_1_1_S468 phospho",
    "HNRNPM 618_618_1_1_S618 phospho",
    "HNRNPM 633_637_1_0 phospho",
    "HNRNPM 633_637_2_2_S633S637 phospho",
    "HNRNPM cnv",
    "HNRNPM methyl",
    "HNRNPM proteo",
    "HNRNPM rna"
  ],
  "HNRNPR": [
    "HNRNPR cnv",
    "HNRNPR methyl",
    "HNRNPR proteo",
    "HNRNPR rna"
  ],
  "HNRNPU": [
    "HNRNPU 252_274_1_1_S252 phospho",
    "HNRNPU cnv",
    "HNRNPU methyl",
    "HNRNPU proteo",
    "HNRNPU rna"
  ],
  "HNRNPUL1": [
    "HNRNPUL1 194_216_1_1_S194 phospho",
    "HNRNPUL1 502_512_1_1_S512 phospho",
    "HNRNPUL1 716_718_1_0 phospho",
    "HNRNPUL1 716_729_1_0 phospho",
    "HNRNPUL1 cnv",
    "HNRNPUL1 methyl",
    "HNRNPUL1 proteo",
    "HNRNPUL1 rna"
  ],
  "HNRNPUL2": [
    "HNRNPUL2 161_168_1_0 phospho",
    "HNRNPUL2 161_168_1_1_S161 phospho",
    "HNRNPUL2 161_168_2_2_S161S168 phospho",
    "HNRNPUL2 161_168_2_2_S161T165 phospho",
    "HNRNPUL2 161_168_2_2_T165S168 phospho",
    "HNRNPUL2 161_185_1_1_S161 phospho",
    "HNRNPUL2 185_185_1_1_S185 phospho",
    "HNRNPUL2 185_193_2_2_S185S188 phospho",
    "HNRNPUL2 185_193_3_3_S185S188S193 phospho",
    "HNRNPUL2 226_228_1_1_S228 phospho",
    "HNRNPUL2 226_260_1_0 phospho",
    "HNRNPUL2 226_260_1_1_S226 phospho",
    "HNRNPUL2 226_260_1_1_S228 phospho",
    "HNRNPUL2 228_228_1_1_S228 phospho",
    "HNRNPUL2 cnv",
    "HNRNPUL2 methyl",
    "HNRNPUL2 proteo",
    "HNRNPUL2 rna"
  ],
  "HNRNPUL2-BSCL2": [
    "HNRNPUL2-BSCL2 cnv",
    "HNRNPUL2-BSCL2 rna"
  ],
  "HOATZ": [
    "HOATZ cnv",
    "HOATZ methyl",
    "HOATZ rna"
  ],
  "HOGA1": [
    "HOGA1 cnv",
    "HOGA1 proteo",
    "HOGA1 rna"
  ],
  "HOMER1": [
    "HOMER1 cnv",
    "HOMER1 methyl",
    "HOMER1 proteo",
    "HOMER1 rna"
  ],
  "HOMER2": [
    "HOMER2 cnv",
    "HOMER2 methyl",
    "HOMER2 proteo",
    "HOMER2 rna"
  ],
  "HOMER3": [
    "HOMER3 120_145_1_1_S120 phospho",
    "HOMER3 240_245_1_1_T243 phospho",
    "HOMER3 256_266_1_1_S256 phospho",
    "HOMER3 cnv",
    "HOMER3 methyl",
    "HOMER3 proteo",
    "HOMER3 rna"
  ],
  "HOMEZ": [
    "HOMEZ cnv",
    "HOMEZ methyl",
    "HOMEZ rna"
  ],
  "HOOK1": [
    "HOOK1 cnv",
    "HOOK1 methyl",
    "HOOK1 proteo",
    "HOOK1 rna"
  ],
  "HOOK2": [
    "HOOK2 cnv",
    "HOOK2 methyl",
    "HOOK2 proteo",
    "HOOK2 rna"
  ],
  "HOOK3": [
    "HOOK3 707_716_1_1_S707 phospho",
    "HOOK3 cnv",
    "HOOK3 methyl",
    "HOOK3 proteo",
    "HOOK3 rna"
  ],
  "HOPX": [
    "HOPX 61_66_1_1_S61 phospho",
    "HOPX cnv",
    "HOPX methyl",
    "HOPX proteo",
    "HOPX rna"
  ],
  "HORMAD1": [
    "HORMAD1 cnv",
    "HORMAD1 rna"
  ],
  "HORMAD2": [
    "HORMAD2 cnv",
    "HORMAD2 methyl",
    "HORMAD2 rna"
  ],
  "HORMAD2-AS1": [
    "HORMAD2-AS1 methyl"
  ],
  "HOTAIR": [
    "HOTAIR methyl"
  ],
  "HOXA-AS3": [
    "HOXA-AS3 methyl"
  ],
  "HOXA1": [
    "HOXA1 cnv",
    "HOXA1 methyl",
    "HOXA1 rna"
  ],
  "HOXA10": [
    "HOXA10 cnv",
    "HOXA10 methyl",
    "HOXA10 rna"
  ],
  "HOXA11": [
    "HOXA11 cnv",
    "HOXA11 methyl",
    "HOXA11 rna"
  ],
  "HOXA11-AS": [
    "HOXA11-AS methyl"
  ],
  "HOXA13": [
    "HOXA13 cnv",
    "HOXA13 methyl",
    "HOXA13 rna"
  ],
  "HOXA2": [
    "HOXA2 cnv",
    "HOXA2 methyl",
    "HOXA2 rna"
  ],
  "HOXA3": [
    "HOXA3 cnv",
    "HOXA3 methyl",
    "HOXA3 rna"
  ],
  "HOXA4": [
    "HOXA4 109_109_1_1_S109 phospho",
    "HOXA4 cnv",
    "HOXA4 methyl",
    "HOXA4 rna"
  ],
  "HOXA5": [
    "HOXA5 cnv",
    "HOXA5 methyl",
    "HOXA5 rna"
  ],
  "HOXA6": [
    "HOXA6 cnv",
    "HOXA6 methyl",
    "HOXA6 rna"
  ],
  "HOXA7": [
    "HOXA7 cnv",
    "HOXA7 methyl",
    "HOXA7 rna"
  ],
  "HOXA9": [
    "HOXA9 cnv",
    "HOXA9 methyl",
    "HOXA9 rna"
  ],
  "HOXB-AS1": [
    "HOXB-AS1 methyl"
  ],
  "HOXB-AS3": [
    "HOXB-AS3 methyl"
  ],
  "HOXB1": [
    "HOXB1 cnv",
    "HOXB1 methyl",
    "HOXB1 rna"
  ],
  "HOXB13": [
    "HOXB13 cnv",
    "HOXB13 methyl",
    "HOXB13 rna"
  ],
  "HOXB2": [
    "HOXB2 cnv",
    "HOXB2 methyl",
    "HOXB2 rna"
  ],
  "HOXB3": [
    "HOXB3 cnv",
    "HOXB3 methyl",
    "HOXB3 rna"
  ],
  "HOXB4": [
    "HOXB4 cnv",
    "HOXB4 rna"
  ],
  "HOXB5": [
    "HOXB5 cnv",
    "HOXB5 methyl",
    "HOXB5 rna"
  ],
  "HOXB6": [
    "HOXB6 cnv",
    "HOXB6 methyl",
    "HOXB6 rna"
  ],
  "HOXB7": [
    "HOXB7 cnv",
    "HOXB7 methyl",
    "HOXB7 rna"
  ],
  "HOXB8": [
    "HOXB8 cnv",
    "HOXB8 rna"
  ],
  "HOXB9": [
    "HOXB9 cnv",
    "HOXB9 methyl",
    "HOXB9 rna"
  ],
  "HOXC-AS1": [
    "HOXC-AS1 methyl"
  ],
  "HOXC-AS3": [
    "HOXC-AS3 methyl"
  ],
  "HOXC10": [
    "HOXC10 cnv",
    "HOXC10 methyl",
    "HOXC10 rna"
  ],
  "HOXC11": [
    "HOXC11 cnv",
    "HOXC11 methyl",
    "HOXC11 rna"
  ],
  "HOXC12": [
    "HOXC12 cnv",
    "HOXC12 methyl",
    "HOXC12 rna"
  ],
  "HOXC13": [
    "HOXC13 cnv",
    "HOXC13 rna"
  ],
  "HOXC4": [
    "HOXC4 cnv",
    "HOXC4 rna"
  ],
  "HOXC5": [
    "HOXC5 cnv",
    "HOXC5 methyl",
    "HOXC5 rna"
  ],
  "HOXC6": [
    "HOXC6 cnv",
    "HOXC6 methyl",
    "HOXC6 rna"
  ],
  "HOXC8": [
    "HOXC8 cnv",
    "HOXC8 methyl",
    "HOXC8 rna"
  ],
  "HOXC9": [
    "HOXC9 cnv",
    "HOXC9 methyl",
    "HOXC9 rna"
  ],
  "HOXD1": [
    "HOXD1 cnv",
    "HOXD1 methyl",
    "HOXD1 rna"
  ],
  "HOXD10": [
    "HOXD10 cnv",
    "HOXD10 methyl",
    "HOXD10 rna"
  ],
  "HOXD11": [
    "HOXD11 cnv",
    "HOXD11 methyl",
    "HOXD11 rna"
  ],
  "HOXD12": [
    "HOXD12 cnv",
    "HOXD12 methyl",
    "HOXD12 rna"
  ],
  "HOXD13": [
    "HOXD13 cnv",
    "HOXD13 methyl",
    "HOXD13 rna"
  ],
  "HOXD3": [
    "HOXD3 cnv",
    "HOXD3 methyl",
    "HOXD3 rna"
  ],
  "HOXD4": [
    "HOXD4 cnv",
    "HOXD4 rna"
  ],
  "HOXD8": [
    "HOXD8 cnv",
    "HOXD8 methyl",
    "HOXD8 rna"
  ],
  "HOXD9": [
    "HOXD9 cnv",
    "HOXD9 methyl",
    "HOXD9 rna"
  ],
  "HP": [
    "HP MVSHHNLTTGATLINEQWLLTTAK-N4H5F0S0G0 glyco",
    "HP MVSHHNLTTGATLINEQWLLTTAK-N4H5F0S1G0 glyco",
    "HP MVSHHNLTTGATLINEQWLLTTAK-N4H5F0S2G0 glyco",
    "HP MVSHHNLTTGATLINEQWLLTTAK-N4H5F2S1G0 glyco",
    "HP MVSHHNLTTGATLINEQWLLTTAK-N4H5F4S0G0 glyco",
    "HP MVSHHNLTTGATLINEQWLLTTAK-N4H6F1S1G0 glyco",
    "HP MVSHHNLTTGATLINEQWLLTTAK-N4H7F0S1G0 glyco",
    "HP MVSHHNLTTGATLINEQWLLTTAK-N5H5F1S1G0 glyco",
    "HP MVSHHNLTTGATLINEQWLLTTAK-N5H6F0S2G0 glyco",
    "HP MVSHHNLTTGATLINEQWLLTTAK-N5H6F0S3G0 glyco",
    "HP MVSHHNLTTGATLINEQWLLTTAK-N6H3F3S0G0 glyco",
    "HP MVSHHNLTTGATLINEQWLLTTAK-N6H3F5S0G0 glyco",
    "HP MVSHHNLTTGATLINEQWLLTTAK-N6H4F0S2G0 glyco",
    "HP MVSHHNLTTGATLINEQWLLTTAK-N6H4F2S0G0 glyco",
    "HP MVSHHNLTTGATLINEQWLLTTAK-N6H4F2S1G0 glyco",
    "HP MVSHHNLTTGATLINEQWLLTTAK-N7H5F0S0G0 glyco",
    "HP NLFLNHSENATAK-N4H5F0S1G0 glyco",
    "HP NLFLNHSENATAK-N4H5F0S2G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N2H3F0S0G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N3H3F2S0G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N3H4F0S0G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N3H4F0S1G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N4H5F0S0G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N4H5F0S1G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N4H5F0S2G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N4H5F1S2G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N4H5F2S0G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N4H5F2S1G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N4H5F3S3G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N4H6F0S1G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N4H6F1S1G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N4H7F0S1G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N5H5F1S1G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N5H6F0S1G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N5H6F0S2G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N5H6F0S3G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N5H6F1S2G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N5H6F2S1G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N5H6F2S2G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N5H6F3S2G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N6H3F3S0G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N6H3F5S0G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N6H7F0S3G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N6H7F2S1G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N7H4F3S1G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N7H4F3S2G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N7H4F5S1G0 glyco",
    "HP VVLHPNYSQVDIGLIK-N7H5F0S0G0 glyco",
    "HP VVLHPNYSQVDIGLIKLK-N4H5F0S2G0 glyco",
    "HP cnv",
    "HP proteo",
    "HP rna"
  ],
  "HP1BP3": [
    "HP1BP3 151_156_1_1_S156 phospho",
    "HP1BP3 431_446_3_3_S441S442S446 phospho",
    "HP1BP3 44_51_1_1_T51 phospho",
    "HP1BP3 cnv",
    "HP1BP3 methyl",
    "HP1BP3 proteo",
    "HP1BP3 rna"
  ],
  "HPCA": [
    "HPCA cnv",
    "HPCA methyl",
    "HPCA proteo",
    "HPCA rna"
  ],
  "HPCAL1": [
    "HPCAL1 cnv",
    "HPCAL1 methyl",
    "HPCAL1 proteo",
    "HPCAL1 rna"
  ],
  "HPCAL4": [
    "HPCAL4 cnv",
    "HPCAL4 methyl",
    "HPCAL4 proteo",
    "HPCAL4 rna"
  ],
  "HPD": [
    "HPD cnv",
    "HPD rna"
  ],
  "HPDL": [
    "HPDL cnv",
    "HPDL methyl",
    "HPDL rna"
  ],
  "HPF1": [
    "HPF1 cnv",
    "HPF1 methyl",
    "HPF1 proteo",
    "HPF1 rna"
  ],
  "HPGD": [
    "HPGD cnv",
    "HPGD methyl",
    "HPGD rna"
  ],
  "HPGDS": [
    "HPGDS cnv",
    "HPGDS rna"
  ],
  "HPN": [
    "HPN cnv",
    "HPN methyl",
    "HPN rna"
  ],
  "HPR": [
    "HPR cnv",
    "HPR proteo",
    "HPR rna"
  ],
  "HPRT1": [
    "HPRT1 methyl",
    "HPRT1 proteo",
    "HPRT1 rna"
  ],
  "HPS1": [
    "HPS1 cnv",
    "HPS1 methyl",
    "HPS1 proteo",
    "HPS1 rna"
  ],
  "HPS3": [
    "HPS3 cnv",
    "HPS3 methyl",
    "HPS3 proteo",
    "HPS3 rna"
  ],
  "HPS4": [
    "HPS4 269_280_1_1_S272 phospho",
    "HPS4 cnv",
    "HPS4 methyl",
    "HPS4 rna"
  ],
  "HPS5": [
    "HPS5 347_362_1_1_S347 phospho",
    "HPS5 418_424_1_1_S420 phospho",
    "HPS5 445_449_1_1_S449 phospho",
    "HPS5 cnv",
    "HPS5 methyl",
    "HPS5 proteo",
    "HPS5 rna"
  ],
  "HPS6": [
    "HPS6 cnv",
    "HPS6 methyl",
    "HPS6 proteo",
    "HPS6 rna"
  ],
  "HPSE": [
    "HPSE cnv",
    "HPSE methyl",
    "HPSE rna"
  ],
  "HPSE2": [
    "HPSE2 cnv",
    "HPSE2 rna"
  ],
  "HPX": [
    "HPX ALPQPQNVTSLLGCTH-N3H3F2S0G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N3H4F0S0G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N3H4F0S1G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N3H5F1S0G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N4H4F0S1G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N4H5F0S0G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N4H5F0S1G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N4H5F0S2G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N4H5F1S1G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N4H5F1S2G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N4H5F2S0G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N4H5F2S1G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N4H6F1S0G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N4H6F1S1G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N5H6F0S1G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N5H6F0S2G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N5H6F0S3G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N6H3F3S0G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N6H3F5S0G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N6H4F2S0G0 glyco",
    "HPX ALPQPQNVTSLLGCTH-N6H4F2S1G0 glyco",
    "HPX CSDGWSFDATTLDDNGTMLFFK-N4H5F0S1G0 glyco",
    "HPX CSDGWSFDATTLDDNGTMLFFK-N4H5F0S2G0 glyco",
    "HPX CSDGWSFDATTLDDNGTMLFFK-N4H5F1S2G0 glyco",
    "HPX CSDGWSFDATTLDDNGTMLFFK-N4H5F2S1G0 glyco",
    "HPX CSDGWSFDATTLDDNGTMLFFK-N4H6F1S1G0 glyco",
    "HPX CSDGWSFDATTLDDNGTMLFFK-N4H7F0S1G0 glyco",
    "HPX CSDGWSFDATTLDDNGTMLFFK-N7H5F0S0G0 glyco",
    "HPX SWPAVGNCSSALR-N3H4F0S1G0 glyco",
    "HPX SWPAVGNCSSALR-N4H5F0S1G0 glyco",
    "HPX SWPAVGNCSSALR-N4H5F0S2G0 glyco",
    "HPX SWPAVGNCSSALR-N4H5F1S2G0 glyco",
    "HPX SWPAVGNCSSALR-N4H6F1S1G0 glyco",
    "HPX cnv",
    "HPX proteo",
    "HPX rna"
  ],
  "HR": [
    "HR cnv",
    "HR methyl",
    "HR rna"
  ],
  "HRAS": [
    "HRAS cnv",
    "HRAS methyl",
    "HRAS proteo",
    "HRAS rna"
  ],
  "HRC": [
    "HRC 333_333_1_1_S333 phospho",
    "HRC 431_440_1_1_S431 phospho",
    "HRC 563_567_1_1_S567 phospho",
    "HRC cnv",
    "HRC rna"
  ],
  "HRCT1": [
    "HRCT1 cnv",
    "HRCT1 rna"
  ],
  "HRG": [
    "HRG VIDFNCTTSSVSSALANTK-N3H5F0S1G0 glyco",
    "HRG VIDFNCTTSSVSSALANTK-N3H6F0S1G0 glyco",
    "HRG VIDFNCTTSSVSSALANTK-N4H5F0S0G0 glyco",
    "HRG VIDFNCTTSSVSSALANTK-N4H5F0S1G0 glyco",
    "HRG VIDFNCTTSSVSSALANTK-N4H5F0S2G0 glyco",
    "HRG VIDFNCTTSSVSSALANTK-N4H5F2S1G0 glyco",
    "HRG VIDFNCTTSSVSSALANTK-N4H6F0S1G0 glyco",
    "HRG VIDFNCTTSSVSSALANTK-N4H6F1S1G0 glyco",
    "HRG VIDFNCTTSSVSSALANTK-N7H5F0S0G0 glyco",
    "HRG cnv",
    "HRG proteo",
    "HRG rna"
  ],
  "HRH1": [
    "HRH1 230_235_2_2_S230S233 phospho",
    "HRH1 378_386_1_1_S380 phospho",
    "HRH1 cnv",
    "HRH1 methyl",
    "HRH1 proteo",
    "HRH1 rna"
  ],
  "HRH2": [
    "HRH2 cnv",
    "HRH2 rna"
  ],
  "HRH3": [
    "HRH3 cnv",
    "HRH3 methyl",
    "HRH3 rna"
  ],
  "HRH4": [
    "HRH4 cnv",
    "HRH4 rna"
  ],
  "HRK": [
    "HRK cnv",
    "HRK methyl",
    "HRK rna"
  ],
  "HRNR": [
    "HRNR cnv",
    "HRNR proteo",
    "HRNR rna"
  ],
  "HROB": [
    "HROB cnv",
    "HROB methyl",
    "HROB rna"
  ],
  "HRURF": [
    "HRURF cnv",
    "HRURF methyl"
  ],
  "HS1BP3": [
    "HS1BP3 194_194_1_1_S194 phospho",
    "HS1BP3 249_259_1_1_S249 phospho",
    "HS1BP3 cnv",
    "HS1BP3 methyl",
    "HS1BP3 proteo",
    "HS1BP3 rna"
  ],
  "HS2ST1": [
    "HS2ST1 YHVLHINTTK-N4H5F1S0G0 glyco",
    "HS2ST1 cnv",
    "HS2ST1 methyl",
    "HS2ST1 proteo",
    "HS2ST1 rna"
  ],
  "HS3ST1": [
    "HS3ST1 cnv",
    "HS3ST1 methyl",
    "HS3ST1 proteo",
    "HS3ST1 rna"
  ],
  "HS3ST2": [
    "HS3ST2 cnv",
    "HS3ST2 methyl",
    "HS3ST2 rna"
  ],
  "HS3ST3A1": [
    "HS3ST3A1 cnv",
    "HS3ST3A1 methyl",
    "HS3ST3A1 rna"
  ],
  "HS3ST3B1": [
    "HS3ST3B1 cnv",
    "HS3ST3B1 methyl",
    "HS3ST3B1 rna"
  ],
  "HS3ST4": [
    "HS3ST4 cnv",
    "HS3ST4 methyl",
    "HS3ST4 rna"
  ],
  "HS3ST5": [
    "HS3ST5 cnv",
    "HS3ST5 methyl",
    "HS3ST5 rna"
  ],
  "HS3ST6": [
    "HS3ST6 cnv",
    "HS3ST6 methyl",
    "HS3ST6 rna"
  ],
  "HS6ST1": [
    "HS6ST1 cnv",
    "HS6ST1 methyl",
    "HS6ST1 proteo",
    "HS6ST1 rna"
  ],
  "HS6ST2": [
    "HS6ST2 methyl",
    "HS6ST2 rna"
  ],
  "HS6ST3": [
    "HS6ST3 cnv",
    "HS6ST3 methyl",
    "HS6ST3 rna"
  ],
  "HSBP1": [
    "HSBP1 cnv",
    "HSBP1 methyl",
    "HSBP1 proteo",
    "HSBP1 rna"
  ],
  "HSBP1L1": [
    "HSBP1L1 cnv",
    "HSBP1L1 methyl",
    "HSBP1L1 rna"
  ],
  "HSCB": [
    "HSCB cnv",
    "HSCB methyl",
    "HSCB proteo",
    "HSCB rna"
  ],
  "HSD11B1": [
    "HSD11B1 QSNGSIVVVSSLAGK-N2H8F0S0G0 glyco",
    "HSD11B1 cnv",
    "HSD11B1 rna"
  ],
  "HSD11B1-AS1": [
    "HSD11B1-AS1 methyl"
  ],
  "HSD11B1L": [
    "HSD11B1L cnv",
    "HSD11B1L methyl",
    "HSD11B1L rna"
  ],
  "HSD11B2": [
    "HSD11B2 cnv",
    "HSD11B2 methyl",
    "HSD11B2 rna"
  ],
  "HSD17B1": [
    "HSD17B1 cnv",
    "HSD17B1 rna"
  ],
  "HSD17B10": [
    "HSD17B10 methyl",
    "HSD17B10 proteo",
    "HSD17B10 rna"
  ],
  "HSD17B11": [
    "HSD17B11 cnv",
    "HSD17B11 proteo",
    "HSD17B11 rna"
  ],
  "HSD17B12": [
    "HSD17B12 cnv",
    "HSD17B12 methyl",
    "HSD17B12 proteo",
    "HSD17B12 rna"
  ],
  "HSD17B13": [
    "HSD17B13 cnv",
    "HSD17B13 rna"
  ],
  "HSD17B14": [
    "HSD17B14 cnv",
    "HSD17B14 methyl",
    "HSD17B14 proteo",
    "HSD17B14 rna"
  ],
  "HSD17B2": [
    "HSD17B2 cnv",
    "HSD17B2 rna"
  ],
  "HSD17B3": [
    "HSD17B3 cnv",
    "HSD17B3 rna"
  ],
  "HSD17B4": [
    "HSD17B4 265_265_1_1_T265 phospho",
    "HSD17B4 317_322_1_0 phospho",
    "HSD17B4 cnv",
    "HSD17B4 methyl",
    "HSD17B4 proteo",
    "HSD17B4 rna"
  ],
  "HSD17B6": [
    "HSD17B6 cnv",
    "HSD17B6 methyl",
    "HSD17B6 rna"
  ],
  "HSD17B7": [
    "HSD17B7 cnv",
    "HSD17B7 methyl",
    "HSD17B7 proteo",
    "HSD17B7 rna"
  ],
  "HSD17B7P2": [
    "HSD17B7P2 methyl"
  ],
  "HSD17B8": [
    "HSD17B8 cnv",
    "HSD17B8 methyl",
    "HSD17B8 proteo",
    "HSD17B8 rna"
  ],
  "HSD3B1": [
    "HSD3B1 cnv"
  ],
  "HSD3B2": [
    "HSD3B2 cnv",
    "HSD3B2 rna"
  ],
  "HSD3B7": [
    "HSD3B7 cnv",
    "HSD3B7 proteo",
    "HSD3B7 rna"
  ],
  "HSDL1": [
    "HSDL1 cnv",
    "HSDL1 methyl",
    "HSDL1 proteo",
    "HSDL1 rna"
  ],
  "HSDL2": [
    "HSDL2 cnv",
    "HSDL2 methyl",
    "HSDL2 proteo",
    "HSDL2 rna"
  ],
  "HSF1": [
    "HSF1 303_307_1_1_S303 phospho",
    "HSF1 303_307_2_2_S303S307 phospho",
    "HSF1 355_369_1_1_S363 phospho",
    "HSF1 cnv",
    "HSF1 methyl",
    "HSF1 proteo",
    "HSF1 rna"
  ],
  "HSF2": [
    "HSF2 cnv",
    "HSF2 methyl",
    "HSF2 rna"
  ],
  "HSF2BP": [
    "HSF2BP cnv",
    "HSF2BP methyl",
    "HSF2BP rna"
  ],
  "HSF4": [
    "HSF4 cnv",
    "HSF4 methyl",
    "HSF4 rna"
  ],
  "HSF5": [
    "HSF5 cnv",
    "HSF5 methyl",
    "HSF5 rna"
  ],
  "HSFX1": [
    "HSFX1 rna"
  ],
  "HSFX2": [
    "HSFX2 rna"
  ],
  "HSFX3": [
    "HSFX3 rna"
  ],
  "HSFX4": [
    "HSFX4 rna"
  ],
  "HSFY1": [
    "HSFY1 rna"
  ],
  "HSH2D": [
    "HSH2D cnv",
    "HSH2D rna"
  ],
  "HSP90AA1": [
    "HSP90AA1 353_353_1_1_S353 phospho",
    "HSP90AA1 374_385_1_1_S385 phospho",
    "HSP90AA1 575_575_1_1_S575 phospho",
    "HSP90AA1 763_767_1_1_S763 phospho",
    "HSP90AA1 cnv",
    "HSP90AA1 methyl",
    "HSP90AA1 proteo",
    "HSP90AA1 rna"
  ],
  "HSP90AB1": [
    "HSP90AB1 226_226_1_1_S226 phospho",
    "HSP90AB1 255_261_1_1_S255 phospho",
    "HSP90AB1 255_261_2_2_S255S261 phospho",
    "HSP90AB1 445_446_1_1_S445 phospho",
    "HSP90AB1 cnv",
    "HSP90AB1 methyl",
    "HSP90AB1 proteo",
    "HSP90AB1 rna"
  ],
  "HSP90B1": [
    "HSP90B1 286_306_1_1_S306 phospho",
    "HSP90B1 439_450_1_1_S447 phospho",
    "HSP90B1 EEEAIQLDGLNASQIR-N2H5F0S0G0 glyco",
    "HSP90B1 EEEAIQLDGLNASQIR-N2H6F0S0G0 glyco",
    "HSP90B1 GVVDSDDLPLNVSR-N2H7F0S0G0 glyco",
    "HSP90B1 GVVDSDDLPLNVSR-N2H8F0S0G0 glyco",
    "HSP90B1 HNNDTQHIWESDSNEFSVIADPR-N2H3F1S0G0 glyco",
    "HSP90B1 HNNDTQHIWESDSNEFSVIADPR-N2H5F0S0G0 glyco",
    "HSP90B1 HNNDTQHIWESDSNEFSVIADPR-N2H6F0S0G0 glyco",
    "HSP90B1 HNNDTQHIWESDSNEFSVIADPR-N2H7F0S0G0 glyco",
    "HSP90B1 HNNDTQHIWESDSNEFSVIADPR-N2H8F0S0G0 glyco",
    "HSP90B1 HNNDTQHIWESDSNEFSVIADPR-N3H3F1S0G0 glyco",
    "HSP90B1 LGVIEDHSNR-N2H6F0S0G0 glyco",
    "HSP90B1 LGVIEDHSNR-N2H7F0S0G0 glyco",
    "HSP90B1 LGVIEDHSNR-N2H8F0S0G0 glyco",
    "HSP90B1 TDDEVVQREEEAIQLDGLNASQIR-N2H4F0S0G0 glyco",
    "HSP90B1 TDDEVVQREEEAIQLDGLNASQIR-N2H5F0S0G0 glyco",
    "HSP90B1 TDDEVVQREEEAIQLDGLNASQIR-N2H6F0S0G0 glyco",
    "HSP90B1 TDDEVVQREEEAIQLDGLNASQIR-N2H8F0S0G0 glyco",
    "HSP90B1 TDDEVVQREEEAIQLDGLNASQIR-N3H3F1S0G0 glyco",
    "HSP90B1 cnv",
    "HSP90B1 methyl",
    "HSP90B1 proteo",
    "HSP90B1 rna"
  ],
  "HSPA12A": [
    "HSPA12A 30_40_1_1_S39 phospho",
    "HSPA12A 32_40_1_1_S40 phospho",
    "HSPA12A cnv",
    "HSPA12A methyl",
    "HSPA12A proteo",
    "HSPA12A rna"
  ],
  "HSPA12B": [
    "HSPA12B 275_279_1_1_S275 phospho",
    "HSPA12B 32_46_1_1_S46 phospho",
    "HSPA12B 32_46_1_1_T42 phospho",
    "HSPA12B 432_433_1_1_S433 phospho",
    "HSPA12B cnv",
    "HSPA12B methyl",
    "HSPA12B proteo",
    "HSPA12B rna"
  ],
  "HSPA13": [
    "HSPA13 NSTIEAANLAGLK-N2H5F0S0G0 glyco",
    "HSPA13 NSTIEAANLAGLK-N2H6F0S0G0 glyco",
    "HSPA13 NSTIEAANLAGLK-N2H7F0S0G0 glyco",
    "HSPA13 NSTIEAANLAGLK-N2H8F0S0G0 glyco",
    "HSPA13 cnv",
    "HSPA13 methyl",
    "HSPA13 proteo",
    "HSPA13 rna"
  ],
  "HSPA14": [
    "HSPA14 cnv",
    "HSPA14 methyl",
    "HSPA14 proteo",
    "HSPA14 rna"
  ],
  "HSPA1A": [
    "HSPA1A 631_636_1_1_S631 phospho",
    "HSPA1A cnv",
    "HSPA1A methyl",
    "HSPA1A proteo",
    "HSPA1A rna"
  ],
  "HSPA1B": [
    "HSPA1B cnv",
    "HSPA1B methyl",
    "HSPA1B rna"
  ],
  "HSPA1L": [
    "HSPA1L cnv",
    "HSPA1L methyl",
    "HSPA1L proteo",
    "HSPA1L rna"
  ],
  "HSPA2": [
    "HSPA2 cnv",
    "HSPA2 methyl",
    "HSPA2 proteo",
    "HSPA2 rna"
  ],
  "HSPA2-AS1": [
    "HSPA2-AS1 methyl"
  ],
  "HSPA4": [
    "HSPA4 641_649_1_1_S647 phospho",
    "HSPA4 76_76_1_1_S76 phospho",
    "HSPA4 776_784_1_1_S780 phospho",
    "HSPA4 cnv",
    "HSPA4 methyl",
    "HSPA4 proteo",
    "HSPA4 rna"
  ],
  "HSPA4L": [
    "HSPA4L 105_113_1_1_S105 phospho",
    "HSPA4L 576_584_1_1_T576 phospho",
    "HSPA4L cnv",
    "HSPA4L methyl",
    "HSPA4L proteo",
    "HSPA4L rna"
  ],
  "HSPA5": [
    "HSPA5 635_648_1_1_T648 phospho",
    "HSPA5 cnv",
    "HSPA5 methyl",
    "HSPA5 proteo",
    "HSPA5 rna"
  ],
  "HSPA6": [
    "HSPA6 cnv",
    "HSPA6 methyl",
    "HSPA6 proteo",
    "HSPA6 rna"
  ],
  "HSPA8": [
    "HSPA8 525_525_1_1_Y525 phospho",
    "HSPA8 611_641_1_0 phospho",
    "HSPA8 cnv",
    "HSPA8 methyl",
    "HSPA8 proteo",
    "HSPA8 rna"
  ],
  "HSPA9": [
    "HSPA9 cnv",
    "HSPA9 methyl",
    "HSPA9 proteo",
    "HSPA9 rna"
  ],
  "HSPB1": [
    "HSPB1 142_164_1_0 phospho",
    "HSPB1 15_26_1_1_S15 phospho",
    "HSPB1 174_187_1_1_S187 phospho",
    "HSPB1 78_86_1_1_S82 phospho",
    "HSPB1 82_86_1_0 phospho",
    "HSPB1 cnv",
    "HSPB1 methyl",
    "HSPB1 proteo",
    "HSPB1 rna"
  ],
  "HSPB11": [
    "HSPB11 cnv",
    "HSPB11 methyl",
    "HSPB11 proteo",
    "HSPB11 rna"
  ],
  "HSPB2": [
    "HSPB2 cnv",
    "HSPB2 proteo",
    "HSPB2 rna"
  ],
  "HSPB2-C11orf52": [
    "HSPB2-C11orf52 cnv",
    "HSPB2-C11orf52 rna"
  ],
  "HSPB3": [
    "HSPB3 cnv",
    "HSPB3 rna"
  ],
  "HSPB6": [
    "HSPB6 16_23_1_1_S16 phospho",
    "HSPB6 cnv",
    "HSPB6 methyl",
    "HSPB6 proteo",
    "HSPB6 rna"
  ],
  "HSPB7": [
    "HSPB7 cnv",
    "HSPB7 proteo",
    "HSPB7 rna"
  ],
  "HSPB8": [
    "HSPB8 24_28_1_1_S24 phospho",
    "HSPB8 57_63_1_1_S57 phospho",
    "HSPB8 cnv",
    "HSPB8 proteo",
    "HSPB8 rna"
  ],
  "HSPB9": [
    "HSPB9 cnv",
    "HSPB9 methyl",
    "HSPB9 rna"
  ],
  "HSPBAP1": [
    "HSPBAP1 cnv",
    "HSPBAP1 methyl",
    "HSPBAP1 proteo",
    "HSPBAP1 rna"
  ],
  "HSPBP1": [
    "HSPBP1 347_356_1_1_S351 phospho",
    "HSPBP1 cnv",
    "HSPBP1 methyl",
    "HSPBP1 proteo",
    "HSPBP1 rna"
  ],
  "HSPD1": [
    "HSPD1 61_70_1_1_S70 phospho",
    "HSPD1 cnv",
    "HSPD1 methyl",
    "HSPD1 proteo",
    "HSPD1 rna"
  ],
  "HSPE1": [
    "HSPE1 cnv",
    "HSPE1 methyl",
    "HSPE1 proteo",
    "HSPE1 rna"
  ],
  "HSPE1-MOB4": [
    "HSPE1-MOB4 cnv",
    "HSPE1-MOB4 methyl",
    "HSPE1-MOB4 rna"
  ],
  "HSPG2": [
    "HSPG2 ALVNFTR-N4H5F0S0G0 glyco",
    "HSPG2 IQGEEIVFHDLNLTAHGISHCPTCR-N4H5F1S0G0 glyco",
    "HSPG2 IQGEEIVFHDLNLTAHGISHCPTCR-N4H5F1S1G0 glyco",
    "HSPG2 IQGEEIVFHDLNLTAHGISHCPTCR-N4H5F2S1G0 glyco",
    "HSPG2 IQGEEIVFHDLNLTAHGISHCPTCR-N4H6F0S0G0 glyco",
    "HSPG2 IQGEEIVFHDLNLTAHGISHCPTCR-N4H6F0S1G0 glyco",
    "HSPG2 NLHQSNTSR-N2H5F0S0G0 glyco",
    "HSPG2 NLHQSNTSR-N3H4F1S0G0 glyco",
    "HSPG2 NLHQSNTSR-N4H4F0S0G0 glyco",
    "HSPG2 NLHQSNTSR-N4H4F1S0G0 glyco",
    "HSPG2 NLHQSNTSR-N4H5F0S0G0 glyco",
    "HSPG2 NLHQSNTSR-N4H5F1S0G0 glyco",
    "HSPG2 NLHQSNTSR-N4H5F1S1G0 glyco",
    "HSPG2 SLTQGSLIVGDLAPVNGTSQGK-N3H3F1S0G0 glyco",
    "HSPG2 SLTQGSLIVGDLAPVNGTSQGK-N3H4F1S0G0 glyco",
    "HSPG2 SLTQGSLIVGDLAPVNGTSQGK-N3H4F1S1G0 glyco",
    "HSPG2 SLTQGSLIVGDLAPVNGTSQGK-N3H5F1S0G0 glyco",
    "HSPG2 SLTQGSLIVGDLAPVNGTSQGK-N3H5F1S1G0 glyco",
    "HSPG2 SLTQGSLIVGDLAPVNGTSQGK-N3H6F1S0G0 glyco",
    "HSPG2 SLTQGSLIVGDLAPVNGTSQGK-N3H6F1S1G0 glyco",
    "HSPG2 SLTQGSLIVGDLAPVNGTSQGK-N4H4F1S0G0 glyco",
    "HSPG2 SLTQGSLIVGDLAPVNGTSQGK-N4H4F1S1G0 glyco",
    "HSPG2 SLTQGSLIVGDLAPVNGTSQGK-N4H5F0S1G0 glyco",
    "HSPG2 SLTQGSLIVGDLAPVNGTSQGK-N4H5F1S0G0 glyco",
    "HSPG2 SLTQGSLIVGDLAPVNGTSQGK-N4H5F1S1G0 glyco",
    "HSPG2 SLTQGSLIVGDLAPVNGTSQGK-N4H5F2S0G0 glyco",
    "HSPG2 SLTQGSLIVGDLAPVNGTSQGK-N4H5F2S1G0 glyco",
    "HSPG2 SLTQGSLIVGDLAPVNGTSQGK-N5H3F1S0G0 glyco",
    "HSPG2 cnv",
    "HSPG2 methyl",
    "HSPG2 proteo",
    "HSPG2 rna"
  ],
  "HSPH1": [
    "HSPH1 536_562_1_1_S557 phospho",
    "HSPH1 809_809_1_1_S809 phospho",
    "HSPH1 cnv",
    "HSPH1 methyl",
    "HSPH1 proteo",
    "HSPH1 rna"
  ],
  "HTATIP2": [
    "HTATIP2 cnv",
    "HTATIP2 methyl",
    "HTATIP2 proteo",
    "HTATIP2 rna"
  ],
  "HTATSF1": [
    "HTATSF1 403_409_1_1_S409 phospho",
    "HTATSF1 485_498_1_1_S498 phospho",
    "HTATSF1 579_579_1_1_S579 phospho",
    "HTATSF1 616_624_2_2_S616S624 phospho",
    "HTATSF1 616_634_2_2_T633Y634 phospho",
    "HTATSF1 642_642_1_1_S642 phospho",
    "HTATSF1 642_650_1_1_S642 phospho",
    "HTATSF1 676_676_1_1_S676 phospho",
    "HTATSF1 702_702_1_1_S702 phospho",
    "HTATSF1 713_714_1_1_S714 phospho",
    "HTATSF1 methyl",
    "HTATSF1 proteo",
    "HTATSF1 rna"
  ],
  "HTD2": [
    "HTD2 cnv",
    "HTD2 methyl",
    "HTD2 rna"
  ],
  "HTN1": [
    "HTN1 cnv"
  ],
  "HTN3": [
    "HTN3 cnv"
  ],
  "HTR1A": [
    "HTR1A cnv",
    "HTR1A methyl",
    "HTR1A proteo",
    "HTR1A rna"
  ],
  "HTR1B": [
    "HTR1B cnv",
    "HTR1B methyl",
    "HTR1B rna"
  ],
  "HTR1D": [
    "HTR1D cnv",
    "HTR1D methyl",
    "HTR1D rna"
  ],
  "HTR1E": [
    "HTR1E cnv",
    "HTR1E methyl",
    "HTR1E rna"
  ],
  "HTR1F": [
    "HTR1F cnv",
    "HTR1F rna"
  ],
  "HTR2A": [
    "HTR2A cnv",
    "HTR2A rna"
  ],
  "HTR2B": [
    "HTR2B cnv",
    "HTR2B rna"
  ],
  "HTR2C": [
    "HTR2C methyl",
    "HTR2C rna"
  ],
  "HTR3A": [
    "HTR3A cnv",
    "HTR3A rna"
  ],
  "HTR3B": [
    "HTR3B cnv",
    "HTR3B rna"
  ],
  "HTR3C": [
    "HTR3C cnv",
    "HTR3C rna"
  ],
  "HTR3D": [
    "HTR3D cnv",
    "HTR3D rna"
  ],
  "HTR3E": [
    "HTR3E cnv",
    "HTR3E rna"
  ],
  "HTR4": [
    "HTR4 cnv",
    "HTR4 methyl",
    "HTR4 rna"
  ],
  "HTR5A": [
    "HTR5A cnv",
    "HTR5A methyl",
    "HTR5A rna"
  ],
  "HTR6": [
    "HTR6 cnv",
    "HTR6 methyl",
    "HTR6 rna"
  ],
  "HTR7": [
    "HTR7 cnv",
    "HTR7 methyl",
    "HTR7 rna"
  ],
  "HTR7P1": [
    "HTR7P1 methyl"
  ],
  "HTRA1": [
    "HTRA1 cnv",
    "HTRA1 methyl",
    "HTRA1 proteo",
    "HTRA1 rna"
  ],
  "HTRA2": [
    "HTRA2 cnv",
    "HTRA2 methyl",
    "HTRA2 proteo",
    "HTRA2 rna"
  ],
  "HTRA3": [
    "HTRA3 cnv",
    "HTRA3 methyl",
    "HTRA3 rna"
  ],
  "HTRA4": [
    "HTRA4 cnv",
    "HTRA4 methyl",
    "HTRA4 rna"
  ],
  "HTT": [
    "HTT 1173_1181_1_1_S1181 phospho",
    "HTT 1864_1868_1_1_S1866 phospho",
    "HTT 419_438_1_1_S434 phospho",
    "HTT 419_438_2_2_S421S434 phospho",
    "HTT 642_645_1_1_S642 phospho",
    "HTT cnv",
    "HTT methyl",
    "HTT proteo",
    "HTT rna"
  ],
  "HULC": [
    "HULC methyl"
  ],
  "HUNK": [
    "HUNK cnv",
    "HUNK kinase",
    "HUNK methyl",
    "HUNK rna"
  ],
  "HUS1": [
    "HUS1 cnv",
    "HUS1 methyl",
    "HUS1 proteo",
    "HUS1 rna"
  ],
  "HUS1B": [
    "HUS1B cnv",
    "HUS1B methyl",
    "HUS1B rna"
  ],
  "HUWE1": [
    "HUWE1 1382_1395_1_1_S1395 phospho",
    "HUWE1 1903_1907_1_1_S1907 phospho",
    "HUWE1 2526_2537_1_1_S2527 phospho",
    "HUWE1 2554_2565_1_1_T2554 phospho",
    "HUWE1 2584_2600_1_1_S2595 phospho",
    "HUWE1 2887_2889_1_1_T2889 phospho",
    "HUWE1 2904_2928_1_1_S2918 phospho",
    "HUWE1 3373_3386_1_1_S3373 phospho",
    "HUWE1 3752_3760_1_1_S3753 phospho",
    "HUWE1 3808_3830_1_0 phospho",
    "HUWE1 3808_3830_1_1_S3816 phospho",
    "HUWE1 methyl",
    "HUWE1 proteo",
    "HUWE1 rna"
  ],
  "HVCN1": [
    "HVCN1 60_63_1_1_T60 phospho",
    "HVCN1 cnv",
    "HVCN1 methyl",
    "HVCN1 proteo",
    "HVCN1 rna"
  ],
  "HYAL1": [
    "HYAL1 cnv",
    "HYAL1 rna"
  ],
  "HYAL2": [
    "HYAL2 cnv",
    "HYAL2 methyl",
    "HYAL2 rna"
  ],
  "HYAL3": [
    "HYAL3 cnv",
    "HYAL3 methyl",
    "HYAL3 rna"
  ],
  "HYAL4": [
    "HYAL4 cnv",
    "HYAL4 rna"
  ],
  "HYDIN": [
    "HYDIN cnv",
    "HYDIN methyl",
    "HYDIN rna"
  ],
  "HYI": [
    "HYI cnv",
    "HYI methyl",
    "HYI proteo",
    "HYI rna"
  ],
  "HYKK": [
    "HYKK cnv",
    "HYKK methyl",
    "HYKK rna"
  ],
  "HYLS1": [
    "HYLS1 cnv",
    "HYLS1 methyl",
    "HYLS1 rna"
  ],
  "HYMAI": [
    "HYMAI methyl"
  ],
  "HYOU1": [
    "HYOU1 AEPPLNASASDQGEK-N2H3F1S0G0 glyco",
    "HYOU1 AEPPLNASASDQGEK-N2H4F0S0G0 glyco",
    "HYOU1 AEPPLNASASDQGEK-N2H5F0S0G0 glyco",
    "HYOU1 AEPPLNASASDQGEK-N2H5F1S0G0 glyco",
    "HYOU1 AEPPLNASASDQGEK-N2H6F0S0G0 glyco",
    "HYOU1 AEPPLNASASDQGEK-N2H7F0S0G0 glyco",
    "HYOU1 AEPPLNASASDQGEK-N2H8F0S0G0 glyco",
    "HYOU1 AEPPLNASASDQGEK-N3H3F1S0G0 glyco",
    "HYOU1 AEPPLNASASDQGEK-N4H3F1S0G0 glyco",
    "HYOU1 ENGTDTVQEEEESPAEGSK-N2H5F0S0G0 glyco",
    "HYOU1 ENGTDTVQEEEESPAEGSK-N2H6F0S0G0 glyco",
    "HYOU1 LSALDNLLNHSSMFLK-N2H5F0S0G0 glyco",
    "HYOU1 LSALDNLLNHSSMFLK-N2H6F0S0G0 glyco",
    "HYOU1 LSALDNLLNHSSMFLK-N2H7F0S0G0 glyco",
    "HYOU1 LSALDNLLNHSSMFLK-N2H8F0S0G0 glyco",
    "HYOU1 LSALDNLLNHSSMFLKGAR-N5H3F0S0G0 glyco",
    "HYOU1 LSALDNLLNHSSMFLKGAR-N5H3F1S0G0 glyco",
    "HYOU1 LSALDNLLNHSSMFLKGAR-N5H4F0S0G0 glyco",
    "HYOU1 NATLAEQAK-N2H3F0S0G0 glyco",
    "HYOU1 NATLAEQAK-N2H4F0S0G0 glyco",
    "HYOU1 NATLAEQAK-N2H5F0S0G0 glyco",
    "HYOU1 NATLAEQAK-N2H6F0S0G0 glyco",
    "HYOU1 NATLAEQAK-N2H7F0S0G0 glyco",
    "HYOU1 NATLAEQAK-N2H8F0S0G0 glyco",
    "HYOU1 NATLAEQAK-N2H9F0S0G0 glyco",
    "HYOU1 VFGSQNLTTVK-N2H10F0S0G0 glyco",
    "HYOU1 VFGSQNLTTVK-N2H3F0S0G0 glyco",
    "HYOU1 VFGSQNLTTVK-N2H4F0S0G0 glyco",
    "HYOU1 VFGSQNLTTVK-N2H5F0S0G0 glyco",
    "HYOU1 VFGSQNLTTVK-N2H6F0S0G0 glyco",
    "HYOU1 VFGSQNLTTVK-N2H7F0S0G0 glyco",
    "HYOU1 VFGSQNLTTVK-N2H8F0S0G0 glyco",
    "HYOU1 VFGSQNLTTVK-N2H9F0S0G0 glyco",
    "HYOU1 VFGSQNLTTVK-N3H3F0S0G0 glyco",
    "HYOU1 VFGSQNLTTVK-N3H3F1S0G0 glyco",
    "HYOU1 VFGSQNLTTVK-N4H3F0S0G0 glyco",
    "HYOU1 VFGSQNLTTVK-N4H3F0S2G0 glyco",
    "HYOU1 VFGSQNLTTVK-N4H3F1S0G0 glyco",
    "HYOU1 VINETWAWK-N2H5F0S0G0 glyco",
    "HYOU1 VINETWAWK-N2H6F0S0G0 glyco",
    "HYOU1 VINETWAWK-N2H7F0S0G0 glyco",
    "HYOU1 VINETWAWK-N2H8F0S0G0 glyco",
    "HYOU1 cnv",
    "HYOU1 methyl",
    "HYOU1 proteo",
    "HYOU1 rna"
  ],
  "HYPK": [
    "HYPK 38_38_1_1_S38 phospho",
    "HYPK cnv",
    "HYPK methyl",
    "HYPK proteo",
    "HYPK rna"
  ],
  "IAH1": [
    "IAH1 cnv",
    "IAH1 methyl",
    "IAH1 proteo",
    "IAH1 rna"
  ],
  "IAPP": [
    "IAPP cnv",
    "IAPP rna"
  ],
  "IARS1": [
    "IARS1 1044_1049_1_1_S1047 phospho",
    "IARS1 cnv",
    "IARS1 methyl",
    "IARS1 proteo",
    "IARS1 rna"
  ],
  "IARS2": [
    "IARS2 cnv",
    "IARS2 methyl",
    "IARS2 proteo",
    "IARS2 rna"
  ],
  "IBA57": [
    "IBA57 cnv",
    "IBA57 methyl",
    "IBA57 proteo",
    "IBA57 rna"
  ],
  "IBA57-DT": [
    "IBA57-DT methyl"
  ],
  "IBSP": [
    "IBSP cnv",
    "IBSP rna"
  ],
  "IBTK": [
    "IBTK 1045_1054_1_1_S1045 phospho",
    "IBTK cnv",
    "IBTK methyl",
    "IBTK proteo",
    "IBTK rna"
  ],
  "ICA1": [
    "ICA1 cnv",
    "ICA1 methyl",
    "ICA1 proteo",
    "ICA1 rna"
  ],
  "ICA1L": [
    "ICA1L cnv",
    "ICA1L methyl",
    "ICA1L proteo",
    "ICA1L rna"
  ],
  "ICAM1": [
    "ICAM1 521_530_1_1_T530 phospho",
    "ICAM1 cnv",
    "ICAM1 methyl",
    "ICAM1 proteo",
    "ICAM1 rna"
  ],
  "ICAM2": [
    "ICAM2 cnv",
    "ICAM2 proteo",
    "ICAM2 rna"
  ],
  "ICAM3": [
    "ICAM3 cnv",
    "ICAM3 methyl",
    "ICAM3 proteo",
    "ICAM3 rna"
  ],
  "ICAM4": [
    "ICAM4 cnv",
    "ICAM4 methyl",
    "ICAM4 rna"
  ],
  "ICAM5": [
    "ICAM5 AELDLRPHGLGLFENSSAPR-N2H5F0S0G0 glyco",
    "ICAM5 QLVCNVTLGGENR-N4H4F0S0G0 glyco",
    "ICAM5 QLVCNVTLGGENR-N4H5F0S0G0 glyco",
    "ICAM5 QLVCNVTLGGENR-N5H3F0S0G0 glyco",
    "ICAM5 QLVCNVTLGGENR-N5H4F0S0G0 glyco",
    "ICAM5 QLVCNVTLGGENR-N6H3F0S0G0 glyco",
    "ICAM5 VLAPGIYVCNATNR-N4H3F1S0G0 glyco",
    "ICAM5 VLAPGIYVCNATNR-N5H3F1S0G0 glyco",
    "ICAM5 VLAPGIYVCNATNR-N5H4F2S0G0 glyco",
    "ICAM5 cnv",
    "ICAM5 methyl",
    "ICAM5 proteo",
    "ICAM5 rna"
  ],
  "ICE1": [
    "ICE1 1692_1706_1_1_S1692 phospho",
    "ICE1 528_533_1_1_S533 phospho",
    "ICE1 cnv",
    "ICE1 methyl",
    "ICE1 rna"
  ],
  "ICE2": [
    "ICE2 cnv",
    "ICE2 methyl",
    "ICE2 rna"
  ],
  "ICMT": [
    "ICMT cnv",
    "ICMT methyl",
    "ICMT proteo",
    "ICMT rna"
  ],
  "ICOS": [
    "ICOS cnv",
    "ICOS rna"
  ],
  "ICOSLG": [
    "ICOSLG cnv",
    "ICOSLG methyl",
    "ICOSLG rna"
  ],
  "ID1": [
    "ID1 cnv",
    "ID1 methyl",
    "ID1 rna"
  ],
  "ID2": [
    "ID2 cnv",
    "ID2 methyl",
    "ID2 rna"
  ],
  "ID3": [
    "ID3 cnv",
    "ID3 methyl",
    "ID3 rna"
  ],
  "ID4": [
    "ID4 cnv",
    "ID4 methyl",
    "ID4 proteo",
    "ID4 rna"
  ],
  "IDE": [
    "IDE cnv",
    "IDE methyl",
    "IDE proteo",
    "IDE rna"
  ],
  "IDH1": [
    "IDH1 cnv",
    "IDH1 methyl",
    "IDH1 mut",
    "IDH1 proteo",
    "IDH1 rna"
  ],
  "IDH1-AS1": [
    "IDH1-AS1 methyl"
  ],
  "IDH2": [
    "IDH2 cnv",
    "IDH2 methyl",
    "IDH2 proteo",
    "IDH2 rna"
  ],
  "IDH3A": [
    "IDH3A cnv",
    "IDH3A methyl",
    "IDH3A proteo",
    "IDH3A rna"
  ],
  "IDH3B": [
    "IDH3B cnv",
    "IDH3B methyl",
    "IDH3B proteo",
    "IDH3B rna"
  ],
  "IDH3G": [
    "IDH3G methyl",
    "IDH3G proteo",
    "IDH3G rna"
  ],
  "IDI1": [
    "IDI1 cnv",
    "IDI1 methyl",
    "IDI1 proteo",
    "IDI1 rna"
  ],
  "IDI2": [
    "IDI2 cnv",
    "IDI2 rna"
  ],
  "IDNK": [
    "IDNK cnv",
    "IDNK methyl",
    "IDNK proteo",
    "IDNK rna"
  ],
  "IDO1": [
    "IDO1 cnv",
    "IDO1 rna"
  ],
  "IDO2": [
    "IDO2 cnv",
    "IDO2 rna"
  ],
  "IDS": [
    "IDS VHAGNFSTIPQYFK-N2H5F0S0G0 glyco",
    "IDS VHAGNFSTIPQYFK-N2H6F0S0G0 glyco",
    "IDS methyl",
    "IDS proteo",
    "IDS rna"
  ],
  "IDUA": [
    "IDUA cnv",
    "IDUA methyl",
    "IDUA proteo",
    "IDUA rna"
  ],
  "IER2": [
    "IER2 cnv",
    "IER2 methyl",
    "IER2 rna"
  ],
  "IER3": [
    "IER3 cnv",
    "IER3 methyl",
    "IER3 rna"
  ],
  "IER3-AS1": [
    "IER3-AS1 methyl"
  ],
  "IER3IP1": [
    "IER3IP1 cnv",
    "IER3IP1 methyl",
    "IER3IP1 proteo",
    "IER3IP1 rna"
  ],
  "IER5": [
    "IER5 cnv",
    "IER5 methyl",
    "IER5 rna"
  ],
  "IER5L": [
    "IER5L cnv",
    "IER5L methyl",
    "IER5L rna"
  ],
  "IFFO1": [
    "IFFO1 cnv",
    "IFFO1 methyl",
    "IFFO1 proteo",
    "IFFO1 rna"
  ],
  "IFFO2": [
    "IFFO2 cnv",
    "IFFO2 methyl",
    "IFFO2 rna"
  ],
  "IFI16": [
    "IFI16 105_114_1_1_S106 phospho",
    "IFI16 145_161_1_1_S153 phospho",
    "IFI16 cnv",
    "IFI16 proteo",
    "IFI16 rna"
  ],
  "IFI27": [
    "IFI27 cnv",
    "IFI27 rna"
  ],
  "IFI27L1": [
    "IFI27L1 cnv",
    "IFI27L1 methyl",
    "IFI27L1 rna"
  ],
  "IFI27L2": [
    "IFI27L2 cnv",
    "IFI27L2 rna"
  ],
  "IFI30": [
    "IFI30 cnv",
    "IFI30 methyl",
    "IFI30 proteo",
    "IFI30 rna"
  ],
  "IFI35": [
    "IFI35 cnv",
    "IFI35 proteo",
    "IFI35 rna"
  ],
  "IFI44": [
    "IFI44 cnv",
    "IFI44 rna"
  ],
  "IFI44L": [
    "IFI44L cnv",
    "IFI44L rna"
  ],
  "IFI6": [
    "IFI6 cnv",
    "IFI6 rna"
  ],
  "IFIH1": [
    "IFIH1 cnv",
    "IFIH1 proteo",
    "IFIH1 rna"
  ],
  "IFIT1": [
    "IFIT1 cnv",
    "IFIT1 proteo",
    "IFIT1 rna"
  ],
  "IFIT1B": [
    "IFIT1B cnv",
    "IFIT1B rna"
  ],
  "IFIT2": [
    "IFIT2 cnv",
    "IFIT2 proteo",
    "IFIT2 rna"
  ],
  "IFIT3": [
    "IFIT3 cnv",
    "IFIT3 proteo",
    "IFIT3 rna"
  ],
  "IFIT5": [
    "IFIT5 cnv",
    "IFIT5 methyl",
    "IFIT5 proteo",
    "IFIT5 rna"
  ],
  "IFITM1": [
    "IFITM1 cnv",
    "IFITM1 proteo",
    "IFITM1 rna"
  ],
  "IFITM10": [
    "IFITM10 cnv",
    "IFITM10 methyl",
    "IFITM10 rna"
  ],
  "IFITM2": [
    "IFITM2 cnv",
    "IFITM2 rna"
  ],
  "IFITM3": [
    "IFITM3 cnv",
    "IFITM3 proteo",
    "IFITM3 rna"
  ],
  "IFITM5": [
    "IFITM5 cnv",
    "IFITM5 methyl",
    "IFITM5 rna"
  ],
  "IFNA1": [
    "IFNA1 cnv"
  ],
  "IFNA10": [
    "IFNA10 cnv"
  ],
  "IFNA13": [
    "IFNA13 cnv",
    "IFNA13 rna"
  ],
  "IFNA14": [
    "IFNA14 cnv"
  ],
  "IFNA16": [
    "IFNA16 cnv"
  ],
  "IFNA17": [
    "IFNA17 cnv"
  ],
  "IFNA2": [
    "IFNA2 cnv",
    "IFNA2 rna"
  ],
  "IFNA21": [
    "IFNA21 cnv"
  ],
  "IFNA4": [
    "IFNA4 cnv"
  ],
  "IFNA5": [
    "IFNA5 cnv",
    "IFNA5 rna"
  ],
  "IFNA6": [
    "IFNA6 cnv",
    "IFNA6 rna"
  ],
  "IFNA7": [
    "IFNA7 cnv"
  ],
  "IFNA8": [
    "IFNA8 cnv"
  ],
  "IFNAR1": [
    "IFNAR1 493_495_1_1_S495 phospho",
    "IFNAR1 cnv",
    "IFNAR1 methyl",
    "IFNAR1 rna"
  ],
  "IFNAR2": [
    "IFNAR2 400_417_1_1_S400 phospho",
    "IFNAR2 cnv",
    "IFNAR2 methyl",
    "IFNAR2 rna"
  ],
  "IFNB1": [
    "IFNB1 cnv",
    "IFNB1 rna"
  ],
  "IFNE": [
    "IFNE cnv",
    "IFNE rna"
  ],
  "IFNG": [
    "IFNG cnv",
    "IFNG rna"
  ],
  "IFNGR1": [
    "IFNGR1 cnv",
    "IFNGR1 methyl",
    "IFNGR1 rna"
  ],
  "IFNGR2": [
    "IFNGR2 cnv",
    "IFNGR2 methyl",
    "IFNGR2 rna"
  ],
  "IFNK": [
    "IFNK cnv",
    "IFNK rna"
  ],
  "IFNL1": [
    "IFNL1 cnv",
    "IFNL1 rna"
  ],
  "IFNL2": [
    "IFNL2 cnv"
  ],
  "IFNL3": [
    "IFNL3 cnv",
    "IFNL3 rna"
  ],
  "IFNL4": [
    "IFNL4 cnv",
    "IFNL4 rna"
  ],
  "IFNLR1": [
    "IFNLR1 cnv",
    "IFNLR1 methyl",
    "IFNLR1 rna"
  ],
  "IFNW1": [
    "IFNW1 cnv",
    "IFNW1 rna"
  ],
  "IFRD1": [
    "IFRD1 cnv",
    "IFRD1 methyl",
    "IFRD1 proteo",
    "IFRD1 rna"
  ],
  "IFRD2": [
    "IFRD2 cnv",
    "IFRD2 methyl",
    "IFRD2 rna"
  ],
  "IFT122": [
    "IFT122 cnv",
    "IFT122 methyl",
    "IFT122 proteo",
    "IFT122 rna"
  ],
  "IFT140": [
    "IFT140 1204_1209_1_1_S1204 phospho",
    "IFT140 1434_1443_1_1_S1443 phospho",
    "IFT140 1443_1443_1_1_S1443 phospho",
    "IFT140 360_360_1_1_S360 phospho",
    "IFT140 cnv",
    "IFT140 methyl",
    "IFT140 proteo",
    "IFT140 rna"
  ],
  "IFT172": [
    "IFT172 cnv",
    "IFT172 methyl",
    "IFT172 proteo",
    "IFT172 rna"
  ],
  "IFT20": [
    "IFT20 cnv",
    "IFT20 methyl",
    "IFT20 proteo",
    "IFT20 rna"
  ],
  "IFT22": [
    "IFT22 cnv",
    "IFT22 methyl",
    "IFT22 proteo",
    "IFT22 rna"
  ],
  "IFT27": [
    "IFT27 cnv",
    "IFT27 methyl",
    "IFT27 proteo",
    "IFT27 rna"
  ],
  "IFT43": [
    "IFT43 67_67_1_1_S67 phospho",
    "IFT43 78_78_1_1_S78 phospho",
    "IFT43 cnv",
    "IFT43 methyl",
    "IFT43 proteo",
    "IFT43 rna"
  ],
  "IFT46": [
    "IFT46 cnv",
    "IFT46 methyl",
    "IFT46 proteo",
    "IFT46 rna"
  ],
  "IFT52": [
    "IFT52 cnv",
    "IFT52 methyl",
    "IFT52 proteo",
    "IFT52 rna"
  ],
  "IFT57": [
    "IFT57 cnv",
    "IFT57 methyl",
    "IFT57 proteo",
    "IFT57 rna"
  ],
  "IFT74": [
    "IFT74 cnv",
    "IFT74 methyl",
    "IFT74 proteo",
    "IFT74 rna"
  ],
  "IFT74-AS1": [
    "IFT74-AS1 methyl"
  ],
  "IFT80": [
    "IFT80 cnv",
    "IFT80 methyl",
    "IFT80 proteo",
    "IFT80 rna"
  ],
  "IFT81": [
    "IFT81 cnv",
    "IFT81 methyl",
    "IFT81 proteo",
    "IFT81 rna"
  ],
  "IFT88": [
    "IFT88 cnv",
    "IFT88 methyl",
    "IFT88 proteo",
    "IFT88 rna"
  ],
  "IFTAP": [
    "IFTAP cnv",
    "IFTAP rna"
  ],
  "IGBP1": [
    "IGBP1 methyl",
    "IGBP1 proteo",
    "IGBP1 rna"
  ],
  "IGBP1P2": [
    "IGBP1P2 cnv",
    "IGBP1P2 rna"
  ],
  "IGDCC3": [
    "IGDCC3 cnv",
    "IGDCC3 methyl",
    "IGDCC3 rna"
  ],
  "IGDCC4": [
    "IGDCC4 cnv",
    "IGDCC4 methyl",
    "IGDCC4 proteo",
    "IGDCC4 rna"
  ],
  "IGF1": [
    "IGF1 cnv",
    "IGF1 rna"
  ],
  "IGF1R": [
    "IGF1R 1364_1366_1_1_T1366 phospho",
    "IGF1R cnv",
    "IGF1R kinase",
    "IGF1R methyl",
    "IGF1R proteo",
    "IGF1R rna"
  ],
  "IGF2": [
    "IGF2 cnv",
    "IGF2 methyl",
    "IGF2 proteo",
    "IGF2 rna"
  ],
  "IGF2-AS": [
    "IGF2-AS methyl"
  ],
  "IGF2BP1": [
    "IGF2BP1 181_181_1_1_S181 phospho",
    "IGF2BP1 cnv",
    "IGF2BP1 methyl",
    "IGF2BP1 proteo",
    "IGF2BP1 rna"
  ],
  "IGF2BP2": [
    "IGF2BP2 153_164_1_1_S162 phospho",
    "IGF2BP2 153_164_1_1_S164 phospho",
    "IGF2BP2 cnv",
    "IGF2BP2 methyl",
    "IGF2BP2 proteo",
    "IGF2BP2 rna"
  ],
  "IGF2BP3": [
    "IGF2BP3 184_189_1_1_S184 phospho",
    "IGF2BP3 cnv",
    "IGF2BP3 methyl",
    "IGF2BP3 proteo",
    "IGF2BP3 rna"
  ],
  "IGF2R": [
    "IGF2R 2346_2351_1_1_S2347 phospho",
    "IGF2R 2479_2484_1_1_S2484 phospho",
    "IGF2R MNFTGGDTCHK-N2H7F0S0G0 glyco",
    "IGF2R MNFTGGDTCHK-N2H8F0S0G0 glyco",
    "IGF2R NGSSIVDLSPLIHR-N2H5F0S0G0 glyco",
    "IGF2R SLLEFNTTVSCDQQGTNHR-N2H3F1S0G0 glyco",
    "IGF2R TNITLVCKPGDLESAPVLR-N2H5F0S0G0 glyco",
    "IGF2R TNITLVCKPGDLESAPVLR-N2H6F0S0G0 glyco",
    "IGF2R TNITLVCKPGDLESAPVLR-N2H7F0S0G0 glyco",
    "IGF2R TNITLVCKPGDLESAPVLR-N2H8F0S0G0 glyco",
    "IGF2R YHNQTLR-N2H5F0S0G0 glyco",
    "IGF2R YHNQTLR-N2H6F0S0G0 glyco",
    "IGF2R cnv",
    "IGF2R methyl",
    "IGF2R proteo",
    "IGF2R rna"
  ],
  "IGFALS": [
    "IGFALS cnv",
    "IGFALS proteo",
    "IGFALS rna"
  ],
  "IGFBP1": [
    "IGFBP1 193_199_1_1_S194 phospho",
    "IGFBP1 cnv",
    "IGFBP1 methyl",
    "IGFBP1 rna"
  ],
  "IGFBP2": [
    "IGFBP2 cnv",
    "IGFBP2 methyl",
    "IGFBP2 proteo",
    "IGFBP2 rna"
  ],
  "IGFBP3": [
    "IGFBP3 cnv",
    "IGFBP3 methyl",
    "IGFBP3 proteo",
    "IGFBP3 rna"
  ],
  "IGFBP4": [
    "IGFBP4 cnv",
    "IGFBP4 methyl",
    "IGFBP4 proteo",
    "IGFBP4 rna"
  ],
  "IGFBP5": [
    "IGFBP5 116_133_1_1_S116 phospho",
    "IGFBP5 116_133_2_1_S116 phospho",
    "IGFBP5 256_269_1_0 phospho",
    "IGFBP5 cnv",
    "IGFBP5 methyl",
    "IGFBP5 proteo",
    "IGFBP5 rna"
  ],
  "IGFBP6": [
    "IGFBP6 cnv",
    "IGFBP6 methyl",
    "IGFBP6 proteo",
    "IGFBP6 rna"
  ],
  "IGFBP7": [
    "IGFBP7 cnv",
    "IGFBP7 methyl",
    "IGFBP7 proteo",
    "IGFBP7 rna"
  ],
  "IGFBPL1": [
    "IGFBPL1 cnv",
    "IGFBPL1 rna"
  ],
  "IGFL1": [
    "IGFL1 cnv",
    "IGFL1 rna"
  ],
  "IGFL2": [
    "IGFL2 cnv",
    "IGFL2 rna"
  ],
  "IGFL3": [
    "IGFL3 cnv",
    "IGFL3 rna"
  ],
  "IGFL4": [
    "IGFL4 cnv",
    "IGFL4 methyl",
    "IGFL4 rna"
  ],
  "IGFLR1": [
    "IGFLR1 cnv",
    "IGFLR1 methyl",
    "IGFLR1 rna"
  ],
  "IGFN1": [
    "IGFN1 cnv",
    "IGFN1 rna"
  ],
  "IGHA1": [
    "IGHA1 cnv",
    "IGHA1 rna"
  ],
  "IGHA2": [
    "IGHA2 LSLHRPALEDLLLGSEANLTCTLTGLR-N4H5F0S1G0 glyco",
    "IGHA2 LSLHRPALEDLLLGSEANLTCTLTGLR-N5H4F0S1G0 glyco",
    "IGHA2 LSLHRPALEDLLLGSEANLTCTLTGLR-N5H5F0S1G0 glyco",
    "IGHA2 TPLTANITK-N3H4F1S0G0 glyco",
    "IGHA2 TPLTANITK-N3H4F1S1G0 glyco",
    "IGHA2 TPLTANITK-N4H4F1S0G0 glyco",
    "IGHA2 TPLTANITK-N4H4F1S1G0 glyco",
    "IGHA2 TPLTANITK-N4H5F0S1G0 glyco",
    "IGHA2 TPLTANITK-N4H5F1S0G0 glyco",
    "IGHA2 TPLTANITK-N4H5F1S1G0 glyco",
    "IGHA2 TPLTANITK-N4H5F1S2G0 glyco",
    "IGHA2 TPLTANITK-N5H3F1S0G0 glyco",
    "IGHA2 TPLTANITK-N5H4F1S0G0 glyco",
    "IGHA2 TPLTANITK-N5H4F1S1G0 glyco",
    "IGHA2 TPLTANITK-N5H5F0S0G0 glyco",
    "IGHA2 TPLTANITK-N5H5F0S1G0 glyco",
    "IGHA2 TPLTANITK-N5H5F1S0G0 glyco",
    "IGHA2 TPLTANITK-N5H5F1S1G0 glyco",
    "IGHA2 TPLTANITK-N5H5F1S2G0 glyco",
    "IGHA2 TPLTANITK-N5H6F1S1G0 glyco",
    "IGHA2 cnv",
    "IGHA2 rna"
  ],
  "IGHD": [
    "IGHD cnv",
    "IGHD rna"
  ],
  "IGHD1-1": [
    "IGHD1-1 cnv"
  ],
  "IGHD1-14": [
    "IGHD1-14 cnv"
  ],
  "IGHD1-20": [
    "IGHD1-20 cnv"
  ],
  "IGHD1-26": [
    "IGHD1-26 cnv"
  ],
  "IGHD1-7": [
    "IGHD1-7 cnv"
  ],
  "IGHD1OR15-1A": [
    "IGHD1OR15-1A cnv"
  ],
  "IGHD1OR15-1B": [
    "IGHD1OR15-1B cnv"
  ],
  "IGHD2-15": [
    "IGHD2-15 cnv"
  ],
  "IGHD2-2": [
    "IGHD2-2 cnv"
  ],
  "IGHD2-21": [
    "IGHD2-21 cnv"
  ],
  "IGHD2-8": [
    "IGHD2-8 cnv"
  ],
  "IGHD2OR15-2A": [
    "IGHD2OR15-2A cnv"
  ],
  "IGHD2OR15-2B": [
    "IGHD2OR15-2B cnv"
  ],
  "IGHD3-10": [
    "IGHD3-10 cnv"
  ],
  "IGHD3-16": [
    "IGHD3-16 cnv"
  ],
  "IGHD3-22": [
    "IGHD3-22 cnv"
  ],
  "IGHD3-3": [
    "IGHD3-3 cnv"
  ],
  "IGHD3-9": [
    "IGHD3-9 cnv"
  ],
  "IGHD3OR15-3A": [
    "IGHD3OR15-3A cnv"
  ],
  "IGHD3OR15-3B": [
    "IGHD3OR15-3B cnv"
  ],
  "IGHD4-11": [
    "IGHD4-11 cnv"
  ],
  "IGHD4-17": [
    "IGHD4-17 cnv"
  ],
  "IGHD4-23": [
    "IGHD4-23 cnv"
  ],
  "IGHD4-4": [
    "IGHD4-4 cnv"
  ],
  "IGHD4OR15-4A": [
    "IGHD4OR15-4A cnv"
  ],
  "IGHD4OR15-4B": [
    "IGHD4OR15-4B cnv"
  ],
  "IGHD5-12": [
    "IGHD5-12 cnv"
  ],
  "IGHD5-18": [
    "IGHD5-18 cnv"
  ],
  "IGHD5-24": [
    "IGHD5-24 cnv"
  ],
  "IGHD5-5": [
    "IGHD5-5 cnv"
  ],
  "IGHD5OR15-5A": [
    "IGHD5OR15-5A cnv"
  ],
  "IGHD5OR15-5B": [
    "IGHD5OR15-5B cnv"
  ],
  "IGHD6-13": [
    "IGHD6-13 cnv"
  ],
  "IGHD6-19": [
    "IGHD6-19 cnv"
  ],
  "IGHD6-25": [
    "IGHD6-25 cnv"
  ],
  "IGHD6-6": [
    "IGHD6-6 cnv"
  ],
  "IGHD7-27": [
    "IGHD7-27 cnv"
  ],
  "IGHE": [
    "IGHE cnv",
    "IGHE rna"
  ],
  "IGHG1": [
    "IGHG1 EEQYNSTYR-N2H3F1S0G0 glyco",
    "IGHG1 EEQYNSTYR-N3H3F0S0G0 glyco",
    "IGHG1 EEQYNSTYR-N3H3F1S0G0 glyco",
    "IGHG1 EEQYNSTYR-N3H4F1S0G0 glyco",
    "IGHG1 EEQYNSTYR-N4H3F0S0G0 glyco",
    "IGHG1 EEQYNSTYR-N4H3F1S0G0 glyco",
    "IGHG1 EEQYNSTYR-N4H4F0S0G0 glyco",
    "IGHG1 EEQYNSTYR-N4H4F1S0G0 glyco",
    "IGHG1 EEQYNSTYR-N4H5F0S0G0 glyco",
    "IGHG1 EEQYNSTYR-N4H5F1S0G0 glyco",
    "IGHG1 EEQYNSTYR-N5H3F1S0G0 glyco",
    "IGHG1 EEQYNSTYR-N5H4F1S0G0 glyco",
    "IGHG1 TKPREEQYNSTYR-N3H3F1S0G0 glyco",
    "IGHG1 TKPREEQYNSTYR-N3H4F1S0G0 glyco",
    "IGHG1 TKPREEQYNSTYR-N4H3F0S0G0 glyco",
    "IGHG1 TKPREEQYNSTYR-N4H3F1S0G0 glyco",
    "IGHG1 TKPREEQYNSTYR-N4H4F0S0G0 glyco",
    "IGHG1 TKPREEQYNSTYR-N4H4F1S0G0 glyco",
    "IGHG1 TKPREEQYNSTYR-N4H4F1S1G0 glyco",
    "IGHG1 TKPREEQYNSTYR-N4H5F1S0G0 glyco",
    "IGHG1 TKPREEQYNSTYR-N5H3F1S0G0 glyco",
    "IGHG1 TKPREEQYNSTYR-N5H4F1S0G0 glyco",
    "IGHG1 cnv",
    "IGHG1 rna"
  ],
  "IGHG2": [
    "IGHG2 EEQFNSTFR-N3H3F1S0G0 glyco",
    "IGHG2 EEQFNSTFR-N3H4F1S0G0 glyco",
    "IGHG2 EEQFNSTFR-N3H4F1S1G0 glyco",
    "IGHG2 EEQFNSTFR-N4H3F0S0G0 glyco",
    "IGHG2 EEQFNSTFR-N4H3F1S0G0 glyco",
    "IGHG2 EEQFNSTFR-N4H4F0S0G0 glyco",
    "IGHG2 EEQFNSTFR-N4H4F1S0G0 glyco",
    "IGHG2 EEQFNSTFR-N4H4F1S1G0 glyco",
    "IGHG2 EEQFNSTFR-N4H5F0S0G0 glyco",
    "IGHG2 EEQFNSTFR-N4H5F1S0G0 glyco",
    "IGHG2 EEQFNSTFR-N4H5F1S1G0 glyco",
    "IGHG2 EEQFNSTFR-N5H3F1S0G0 glyco",
    "IGHG2 EEQFNSTFR-N5H4F1S0G0 glyco",
    "IGHG2 EEQFNSTFR-N5H5F1S0G0 glyco",
    "IGHG2 TKPREEQFNSTFR-N3H3F1S0G0 glyco",
    "IGHG2 TKPREEQFNSTFR-N3H4F1S0G0 glyco",
    "IGHG2 TKPREEQFNSTFR-N3H4F1S1G0 glyco",
    "IGHG2 TKPREEQFNSTFR-N4H3F0S0G0 glyco",
    "IGHG2 TKPREEQFNSTFR-N4H3F1S0G0 glyco",
    "IGHG2 TKPREEQFNSTFR-N4H4F1S0G0 glyco",
    "IGHG2 TKPREEQFNSTFR-N4H4F1S1G0 glyco",
    "IGHG2 TKPREEQFNSTFR-N4H5F1S0G0 glyco",
    "IGHG2 TKPREEQFNSTFR-N4H5F1S1G0 glyco",
    "IGHG2 TKPREEQFNSTFR-N5H3F1S0G0 glyco",
    "IGHG2 TKPREEQFNSTFR-N5H4F1S0G0 glyco",
    "IGHG2 TKPREEQFNSTFR-N5H5F1S0G0 glyco",
    "IGHG2 cnv",
    "IGHG2 rna"
  ],
  "IGHG3": [
    "IGHG3 TKPREEQYNSTFR-N4H3F1S0G0 glyco",
    "IGHG3 TKPREEQYNSTFR-N4H4F1S0G0 glyco",
    "IGHG3 cnv",
    "IGHG3 rna"
  ],
  "IGHG4": [
    "IGHG4 EEQFNSTYR-N4H5F1S0G0 glyco",
    "IGHG4 TKPREEQFNSTYR-N3H3F0S0G0 glyco",
    "IGHG4 TKPREEQFNSTYR-N4H3F1S0G0 glyco",
    "IGHG4 TKPREEQFNSTYR-N5H3F1S0G0 glyco",
    "IGHG4 cnv",
    "IGHG4 rna"
  ],
  "IGHGP": [
    "IGHGP cnv",
    "IGHGP rna"
  ],
  "IGHJ1": [
    "IGHJ1 cnv"
  ],
  "IGHJ2": [
    "IGHJ2 cnv"
  ],
  "IGHJ3": [
    "IGHJ3 cnv"
  ],
  "IGHJ4": [
    "IGHJ4 cnv"
  ],
  "IGHJ5": [
    "IGHJ5 cnv"
  ],
  "IGHJ6": [
    "IGHJ6 cnv"
  ],
  "IGHM": [
    "IGHM GLTFQQNASSMCVPDQDTAIR-N3H4F2S2G0 glyco",
    "IGHM GLTFQQNASSMCVPDQDTAIR-N3H5F2S2G0 glyco",
    "IGHM GLTFQQNASSMCVPDQDTAIR-N4H5F0S1G0 glyco",
    "IGHM GLTFQQNASSMCVPDQDTAIR-N4H5F1S0G0 glyco",
    "IGHM GLTFQQNASSMCVPDQDTAIR-N4H5F1S1G0 glyco",
    "IGHM GLTFQQNASSMCVPDQDTAIR-N4H5F1S2G0 glyco",
    "IGHM GLTFQQNASSMCVPDQDTAIR-N4H5F3S1G0 glyco",
    "IGHM GLTFQQNASSMCVPDQDTAIR-N4H6F0S1G0 glyco",
    "IGHM GLTFQQNASSMCVPDQDTAIR-N5H4F1S1G0 glyco",
    "IGHM GLTFQQNASSMCVPDQDTAIR-N5H5F0S1G0 glyco",
    "IGHM GLTFQQNASSMCVPDQDTAIR-N5H5F1S0G0 glyco",
    "IGHM GLTFQQNASSMCVPDQDTAIR-N5H5F1S1G0 glyco",
    "IGHM GLTFQQNASSMCVPDQDTAIR-N5H5F1S2G0 glyco",
    "IGHM GLTFQQNASSMCVPDQDTAIR-N5H6F0S1G0 glyco",
    "IGHM NNSDISSTR-N2H5F0S0G0 glyco",
    "IGHM NNSDISSTR-N3H4F1S1G0 glyco",
    "IGHM cnv",
    "IGHM rna"
  ],
  "IGHMBP2": [
    "IGHMBP2 cnv",
    "IGHMBP2 methyl",
    "IGHMBP2 rna"
  ],
  "IGHV1-18": [
    "IGHV1-18 cnv",
    "IGHV1-18 rna"
  ],
  "IGHV1-2": [
    "IGHV1-2 cnv",
    "IGHV1-2 rna"
  ],
  "IGHV1-24": [
    "IGHV1-24 cnv",
    "IGHV1-24 rna"
  ],
  "IGHV1-3": [
    "IGHV1-3 cnv",
    "IGHV1-3 rna"
  ],
  "IGHV1-45": [
    "IGHV1-45 cnv"
  ],
  "IGHV1-46": [
    "IGHV1-46 cnv",
    "IGHV1-46 rna"
  ],
  "IGHV1-58": [
    "IGHV1-58 cnv",
    "IGHV1-58 rna"
  ],
  "IGHV1-69": [
    "IGHV1-69 cnv",
    "IGHV1-69 rna"
  ],
  "IGHV1-69-2": [
    "IGHV1-69-2 cnv",
    "IGHV1-69-2 rna"
  ],
  "IGHV1-69D": [
    "IGHV1-69D cnv",
    "IGHV1-69D rna"
  ],
  "IGHV1OR15-1": [
    "IGHV1OR15-1 cnv",
    "IGHV1OR15-1 rna"
  ],
  "IGHV1OR15-9": [
    "IGHV1OR15-9 cnv"
  ],
  "IGHV1OR21-1": [
    "IGHV1OR21-1 cnv"
  ],
  "IGHV2-26": [
    "IGHV2-26 cnv",
    "IGHV2-26 rna"
  ],
  "IGHV2-5": [
    "IGHV2-5 cnv",
    "IGHV2-5 rna"
  ],
  "IGHV2-70": [
    "IGHV2-70 cnv",
    "IGHV2-70 rna"
  ],
  "IGHV2-70D": [
    "IGHV2-70D cnv",
    "IGHV2-70D rna"
  ],
  "IGHV2OR16-5": [
    "IGHV2OR16-5 cnv"
  ],
  "IGHV3-11": [
    "IGHV3-11 cnv",
    "IGHV3-11 rna"
  ],
  "IGHV3-13": [
    "IGHV3-13 cnv",
    "IGHV3-13 rna"
  ],
  "IGHV3-15": [
    "IGHV3-15 cnv",
    "IGHV3-15 rna"
  ],
  "IGHV3-16": [
    "IGHV3-16 cnv"
  ],
  "IGHV3-20": [
    "IGHV3-20 cnv",
    "IGHV3-20 rna"
  ],
  "IGHV3-21": [
    "IGHV3-21 cnv",
    "IGHV3-21 rna"
  ],
  "IGHV3-23": [
    "IGHV3-23 cnv",
    "IGHV3-23 rna"
  ],
  "IGHV3-30": [
    "IGHV3-30 cnv",
    "IGHV3-30 rna"
  ],
  "IGHV3-33": [
    "IGHV3-33 cnv",
    "IGHV3-33 rna"
  ],
  "IGHV3-35": [
    "IGHV3-35 cnv"
  ],
  "IGHV3-38": [
    "IGHV3-38 cnv"
  ],
  "IGHV3-43": [
    "IGHV3-43 cnv",
    "IGHV3-43 rna"
  ],
  "IGHV3-48": [
    "IGHV3-48 cnv",
    "IGHV3-48 rna"
  ],
  "IGHV3-49": [
    "IGHV3-49 cnv",
    "IGHV3-49 rna"
  ],
  "IGHV3-53": [
    "IGHV3-53 cnv",
    "IGHV3-53 rna"
  ],
  "IGHV3-64": [
    "IGHV3-64 cnv",
    "IGHV3-64 rna"
  ],
  "IGHV3-64D": [
    "IGHV3-64D cnv",
    "IGHV3-64D rna"
  ],
  "IGHV3-66": [
    "IGHV3-66 cnv",
    "IGHV3-66 rna"
  ],
  "IGHV3-7": [
    "IGHV3-7 cnv",
    "IGHV3-7 rna"
  ],
  "IGHV3-72": [
    "IGHV3-72 cnv",
    "IGHV3-72 rna"
  ],
  "IGHV3-73": [
    "IGHV3-73 cnv",
    "IGHV3-73 rna"
  ],
  "IGHV3-74": [
    "IGHV3-74 cnv",
    "IGHV3-74 rna"
  ],
  "IGHV3OR16-10": [
    "IGHV3OR16-10 cnv"
  ],
  "IGHV3OR16-12": [
    "IGHV3OR16-12 cnv"
  ],
  "IGHV3OR16-13": [
    "IGHV3OR16-13 cnv"
  ],
  "IGHV3OR16-17": [
    "IGHV3OR16-17 cnv"
  ],
  "IGHV3OR16-8": [
    "IGHV3OR16-8 cnv"
  ],
  "IGHV3OR16-9": [
    "IGHV3OR16-9 cnv"
  ],
  "IGHV4-28": [
    "IGHV4-28 cnv",
    "IGHV4-28 rna"
  ],
  "IGHV4-31": [
    "IGHV4-31 cnv",
    "IGHV4-31 rna"
  ],
  "IGHV4-34": [
    "IGHV4-34 cnv",
    "IGHV4-34 rna"
  ],
  "IGHV4-39": [
    "IGHV4-39 cnv",
    "IGHV4-39 rna"
  ],
  "IGHV4-4": [
    "IGHV4-4 cnv",
    "IGHV4-4 rna"
  ],
  "IGHV4-59": [
    "IGHV4-59 cnv",
    "IGHV4-59 rna"
  ],
  "IGHV4-61": [
    "IGHV4-61 cnv",
    "IGHV4-61 rna"
  ],
  "IGHV4OR15-8": [
    "IGHV4OR15-8 cnv"
  ],
  "IGHV5-10-1": [
    "IGHV5-10-1 cnv",
    "IGHV5-10-1 rna"
  ],
  "IGHV5-51": [
    "IGHV5-51 cnv",
    "IGHV5-51 rna"
  ],
  "IGHV6-1": [
    "IGHV6-1 cnv",
    "IGHV6-1 rna"
  ],
  "IGHV7-4-1": [
    "IGHV7-4-1 cnv",
    "IGHV7-4-1 rna"
  ],
  "IGHV7-81": [
    "IGHV7-81 cnv"
  ],
  "IGHV8-51-1": [
    "IGHV8-51-1 cnv"
  ],
  "IGIP": [
    "IGIP cnv",
    "IGIP rna"
  ],
  "IGKC": [
    "IGKC cnv",
    "IGKC rna"
  ],
  "IGKJ1": [
    "IGKJ1 cnv"
  ],
  "IGKJ2": [
    "IGKJ2 cnv"
  ],
  "IGKJ3": [
    "IGKJ3 cnv"
  ],
  "IGKJ4": [
    "IGKJ4 cnv"
  ],
  "IGKJ5": [
    "IGKJ5 cnv"
  ],
  "IGKV1-12": [
    "IGKV1-12 cnv",
    "IGKV1-12 rna"
  ],
  "IGKV1-13": [
    "IGKV1-13 cnv"
  ],
  "IGKV1-16": [
    "IGKV1-16 cnv",
    "IGKV1-16 rna"
  ],
  "IGKV1-17": [
    "IGKV1-17 cnv",
    "IGKV1-17 rna"
  ],
  "IGKV1-27": [
    "IGKV1-27 cnv",
    "IGKV1-27 rna"
  ],
  "IGKV1-33": [
    "IGKV1-33 cnv",
    "IGKV1-33 rna"
  ],
  "IGKV1-37": [
    "IGKV1-37 cnv"
  ],
  "IGKV1-39": [
    "IGKV1-39 cnv",
    "IGKV1-39 rna"
  ],
  "IGKV1-5": [
    "IGKV1-5 cnv",
    "IGKV1-5 rna"
  ],
  "IGKV1-6": [
    "IGKV1-6 cnv",
    "IGKV1-6 rna"
  ],
  "IGKV1-8": [
    "IGKV1-8 cnv",
    "IGKV1-8 rna"
  ],
  "IGKV1-9": [
    "IGKV1-9 cnv",
    "IGKV1-9 rna"
  ],
  "IGKV1D-12": [
    "IGKV1D-12 cnv",
    "IGKV1D-12 rna"
  ],
  "IGKV1D-13": [
    "IGKV1D-13 cnv",
    "IGKV1D-13 rna"
  ],
  "IGKV1D-16": [
    "IGKV1D-16 cnv",
    "IGKV1D-16 rna"
  ],
  "IGKV1D-17": [
    "IGKV1D-17 cnv",
    "IGKV1D-17 rna"
  ],
  "IGKV1D-33": [
    "IGKV1D-33 cnv"
  ],
  "IGKV1D-37": [
    "IGKV1D-37 cnv"
  ],
  "IGKV1D-39": [
    "IGKV1D-39 cnv",
    "IGKV1D-39 rna"
  ],
  "IGKV1D-42": [
    "IGKV1D-42 cnv"
  ],
  "IGKV1D-43": [
    "IGKV1D-43 cnv"
  ],
  "IGKV1D-8": [
    "IGKV1D-8 cnv",
    "IGKV1D-8 rna"
  ],
  "IGKV1OR2-108": [
    "IGKV1OR2-108 cnv",
    "IGKV1OR2-108 rna"
  ],
  "IGKV2-24": [
    "IGKV2-24 cnv",
    "IGKV2-24 rna"
  ],
  "IGKV2-28": [
    "IGKV2-28 cnv",
    "IGKV2-28 rna"
  ],
  "IGKV2-29": [
    "IGKV2-29 cnv",
    "IGKV2-29 rna"
  ],
  "IGKV2-30": [
    "IGKV2-30 cnv",
    "IGKV2-30 rna"
  ],
  "IGKV2-40": [
    "IGKV2-40 cnv",
    "IGKV2-40 rna"
  ],
  "IGKV2D-24": [
    "IGKV2D-24 cnv"
  ],
  "IGKV2D-26": [
    "IGKV2D-26 cnv"
  ],
  "IGKV2D-28": [
    "IGKV2D-28 cnv"
  ],
  "IGKV2D-29": [
    "IGKV2D-29 cnv",
    "IGKV2D-29 rna"
  ],
  "IGKV2D-30": [
    "IGKV2D-30 cnv",
    "IGKV2D-30 rna"
  ],
  "IGKV2D-40": [
    "IGKV2D-40 cnv"
  ],
  "IGKV3-11": [
    "IGKV3-11 cnv",
    "IGKV3-11 rna"
  ],
  "IGKV3-15": [
    "IGKV3-15 cnv",
    "IGKV3-15 rna"
  ],
  "IGKV3-20": [
    "IGKV3-20 cnv",
    "IGKV3-20 rna"
  ],
  "IGKV3-7": [
    "IGKV3-7 cnv"
  ],
  "IGKV3D-11": [
    "IGKV3D-11 cnv",
    "IGKV3D-11 rna"
  ],
  "IGKV3D-15": [
    "IGKV3D-15 cnv",
    "IGKV3D-15 rna"
  ],
  "IGKV3D-20": [
    "IGKV3D-20 cnv",
    "IGKV3D-20 rna"
  ],
  "IGKV3D-7": [
    "IGKV3D-7 cnv"
  ],
  "IGKV3OR2-268": [
    "IGKV3OR2-268 cnv",
    "IGKV3OR2-268 rna"
  ],
  "IGKV4-1": [
    "IGKV4-1 cnv",
    "IGKV4-1 rna"
  ],
  "IGKV5-2": [
    "IGKV5-2 cnv",
    "IGKV5-2 rna"
  ],
  "IGKV6-21": [
    "IGKV6-21 cnv",
    "IGKV6-21 rna"
  ],
  "IGKV6D-21": [
    "IGKV6D-21 cnv",
    "IGKV6D-21 rna"
  ],
  "IGKV6D-41": [
    "IGKV6D-41 cnv"
  ],
  "IGLC1": [
    "IGLC1 cnv",
    "IGLC1 rna"
  ],
  "IGLC2": [
    "IGLC2 cnv",
    "IGLC2 rna"
  ],
  "IGLC3": [
    "IGLC3 cnv",
    "IGLC3 rna"
  ],
  "IGLC6": [
    "IGLC6 cnv"
  ],
  "IGLC7": [
    "IGLC7 cnv",
    "IGLC7 rna"
  ],
  "IGLJ1": [
    "IGLJ1 cnv"
  ],
  "IGLJ2": [
    "IGLJ2 cnv"
  ],
  "IGLJ3": [
    "IGLJ3 cnv"
  ],
  "IGLJ4": [
    "IGLJ4 cnv"
  ],
  "IGLJ5": [
    "IGLJ5 cnv"
  ],
  "IGLJ6": [
    "IGLJ6 cnv"
  ],
  "IGLJ7": [
    "IGLJ7 cnv"
  ],
  "IGLL1": [
    "IGLL1 cnv",
    "IGLL1 proteo",
    "IGLL1 rna"
  ],
  "IGLL5": [
    "IGLL5 cnv",
    "IGLL5 proteo",
    "IGLL5 rna"
  ],
  "IGLON5": [
    "IGLON5 cnv",
    "IGLON5 methyl",
    "IGLON5 proteo",
    "IGLON5 rna"
  ],
  "IGLV1-36": [
    "IGLV1-36 cnv"
  ],
  "IGLV1-40": [
    "IGLV1-40 cnv",
    "IGLV1-40 rna"
  ],
  "IGLV1-44": [
    "IGLV1-44 cnv",
    "IGLV1-44 rna"
  ],
  "IGLV1-47": [
    "IGLV1-47 cnv",
    "IGLV1-47 rna"
  ],
  "IGLV1-50": [
    "IGLV1-50 cnv",
    "IGLV1-50 rna"
  ],
  "IGLV1-51": [
    "IGLV1-51 cnv",
    "IGLV1-51 rna"
  ],
  "IGLV10-54": [
    "IGLV10-54 cnv",
    "IGLV10-54 rna"
  ],
  "IGLV11-55": [
    "IGLV11-55 cnv"
  ],
  "IGLV2-11": [
    "IGLV2-11 cnv",
    "IGLV2-11 rna"
  ],
  "IGLV2-14": [
    "IGLV2-14 cnv",
    "IGLV2-14 rna"
  ],
  "IGLV2-18": [
    "IGLV2-18 cnv",
    "IGLV2-18 rna"
  ],
  "IGLV2-23": [
    "IGLV2-23 cnv",
    "IGLV2-23 rna"
  ],
  "IGLV2-33": [
    "IGLV2-33 cnv"
  ],
  "IGLV2-8": [
    "IGLV2-8 cnv",
    "IGLV2-8 rna"
  ],
  "IGLV3-1": [
    "IGLV3-1 cnv",
    "IGLV3-1 rna"
  ],
  "IGLV3-10": [
    "IGLV3-10 cnv",
    "IGLV3-10 rna"
  ],
  "IGLV3-12": [
    "IGLV3-12 cnv"
  ],
  "IGLV3-16": [
    "IGLV3-16 cnv"
  ],
  "IGLV3-19": [
    "IGLV3-19 cnv",
    "IGLV3-19 rna"
  ],
  "IGLV3-21": [
    "IGLV3-21 cnv",
    "IGLV3-21 rna"
  ],
  "IGLV3-22": [
    "IGLV3-22 cnv"
  ],
  "IGLV3-25": [
    "IGLV3-25 cnv",
    "IGLV3-25 rna"
  ],
  "IGLV3-27": [
    "IGLV3-27 cnv",
    "IGLV3-27 rna"
  ],
  "IGLV3-32": [
    "IGLV3-32 cnv"
  ],
  "IGLV3-9": [
    "IGLV3-9 cnv",
    "IGLV3-9 rna"
  ],
  "IGLV4-3": [
    "IGLV4-3 cnv"
  ],
  "IGLV4-60": [
    "IGLV4-60 cnv",
    "IGLV4-60 rna"
  ],
  "IGLV4-69": [
    "IGLV4-69 cnv",
    "IGLV4-69 rna"
  ],
  "IGLV5-37": [
    "IGLV5-37 cnv",
    "IGLV5-37 rna"
  ],
  "IGLV5-45": [
    "IGLV5-45 cnv",
    "IGLV5-45 rna"
  ],
  "IGLV5-48": [
    "IGLV5-48 cnv"
  ],
  "IGLV5-52": [
    "IGLV5-52 cnv",
    "IGLV5-52 rna"
  ],
  "IGLV6-57": [
    "IGLV6-57 cnv",
    "IGLV6-57 rna"
  ],
  "IGLV7-43": [
    "IGLV7-43 cnv",
    "IGLV7-43 rna"
  ],
  "IGLV7-46": [
    "IGLV7-46 cnv",
    "IGLV7-46 rna"
  ],
  "IGLV8-61": [
    "IGLV8-61 cnv",
    "IGLV8-61 rna"
  ],
  "IGLV9-49": [
    "IGLV9-49 cnv",
    "IGLV9-49 rna"
  ],
  "IGSF1": [
    "IGSF1 proteo",
    "IGSF1 rna"
  ],
  "IGSF10": [
    "IGSF10 cnv",
    "IGSF10 rna"
  ],
  "IGSF11": [
    "IGSF11 380_386_1_1_S381 phospho",
    "IGSF11 cnv",
    "IGSF11 methyl",
    "IGSF11 rna"
  ],
  "IGSF21": [
    "IGSF21 VPAELNGSMYR-N2H5F0S0G0 glyco",
    "IGSF21 cnv",
    "IGSF21 methyl",
    "IGSF21 proteo",
    "IGSF21 rna"
  ],
  "IGSF22": [
    "IGSF22 cnv",
    "IGSF22 methyl",
    "IGSF22 rna"
  ],
  "IGSF23": [
    "IGSF23 cnv",
    "IGSF23 rna"
  ],
  "IGSF3": [
    "IGSF3 QVQLECVVLNR-N2H5F0S0G0 glyco",
    "IGSF3 cnv",
    "IGSF3 methyl",
    "IGSF3 proteo",
    "IGSF3 rna"
  ],
  "IGSF5": [
    "IGSF5 cnv",
    "IGSF5 rna"
  ],
  "IGSF6": [
    "IGSF6 cnv",
    "IGSF6 rna"
  ],
  "IGSF8": [
    "IGSF8 GETASLLCNISVR-N4H3F1S0G0 glyco",
    "IGSF8 GETASLLCNISVR-N5H3F1S0G0 glyco",
    "IGSF8 IGPGEPLELLCNVSGALPPAGR-N2H5F0S0G0 glyco",
    "IGSF8 IGPGEPLELLCNVSGALPPAGR-N4H5F0S0G0 glyco",
    "IGSF8 IGPGEPLELLCNVSGALPPAGR-N4H5F1S0G0 glyco",
    "IGSF8 IGPGEPLELLCNVSGALPPAGR-N5H3F1S0G0 glyco",
    "IGSF8 cnv",
    "IGSF8 methyl",
    "IGSF8 proteo",
    "IGSF8 rna"
  ],
  "IGSF9": [
    "IGSF9 cnv",
    "IGSF9 methyl",
    "IGSF9 rna"
  ],
  "IGSF9B": [
    "IGSF9B cnv",
    "IGSF9B methyl",
    "IGSF9B proteo",
    "IGSF9B rna"
  ],
  "IHH": [
    "IHH cnv",
    "IHH methyl",
    "IHH rna"
  ],
  "IHO1": [
    "IHO1 cnv",
    "IHO1 methyl",
    "IHO1 rna"
  ],
  "IK": [
    "IK cnv",
    "IK methyl",
    "IK proteo",
    "IK rna"
  ],
  "IKBIP": [
    "IKBIP FQNITDFWK-N2H5F0S0G0 glyco",
    "IKBIP FQNITDFWK-N2H6F0S0G0 glyco",
    "IKBIP ISNLTIVQAEIK-N2H6F0S0G0 glyco",
    "IKBIP QDILNNSLTTLSQDITK-N2H6F0S0G0 glyco",
    "IKBIP cnv",
    "IKBIP methyl",
    "IKBIP proteo",
    "IKBIP rna"
  ],
  "IKBKB": [
    "IKBKB 668_677_1_1_S670 phospho",
    "IKBKB cnv",
    "IKBKB kinase",
    "IKBKB methyl",
    "IKBKB proteo",
    "IKBKB rna"
  ],
  "IKBKE": [
    "IKBKE cnv",
    "IKBKE kinase",
    "IKBKE rna"
  ],
  "IKBKG": [
    "IKBKG 455_455_1_1_S455 phospho",
    "IKBKG methyl",
    "IKBKG proteo",
    "IKBKG rna"
  ],
  "IKZF1": [
    "IKZF1 cnv",
    "IKZF1 methyl",
    "IKZF1 rna"
  ],
  "IKZF2": [
    "IKZF2 cnv",
    "IKZF2 methyl",
    "IKZF2 rna"
  ],
  "IKZF3": [
    "IKZF3 cnv",
    "IKZF3 methyl",
    "IKZF3 rna"
  ],
  "IKZF4": [
    "IKZF4 236_248_1_1_S241 phospho",
    "IKZF4 cnv",
    "IKZF4 rna"
  ],
  "IKZF5": [
    "IKZF5 cnv",
    "IKZF5 methyl",
    "IKZF5 proteo",
    "IKZF5 rna"
  ],
  "IL10": [
    "IL10 cnv",
    "IL10 rna"
  ],
  "IL10RA": [
    "IL10RA cnv",
    "IL10RA methyl",
    "IL10RA rna"
  ],
  "IL10RB": [
    "IL10RB 261_261_1_1_S261 phospho",
    "IL10RB cnv",
    "IL10RB methyl",
    "IL10RB proteo",
    "IL10RB rna"
  ],
  "IL11": [
    "IL11 cnv",
    "IL11 methyl",
    "IL11 rna"
  ],
  "IL11RA": [
    "IL11RA cnv",
    "IL11RA rna"
  ],
  "IL12A": [
    "IL12A cnv",
    "IL12A methyl",
    "IL12A rna"
  ],
  "IL12A-AS1": [
    "IL12A-AS1 methyl"
  ],
  "IL12B": [
    "IL12B cnv",
    "IL12B methyl",
    "IL12B rna"
  ],
  "IL12RB1": [
    "IL12RB1 cnv",
    "IL12RB1 methyl",
    "IL12RB1 rna"
  ],
  "IL12RB2": [
    "IL12RB2 cnv",
    "IL12RB2 rna"
  ],
  "IL13": [
    "IL13 cnv",
    "IL13 methyl",
    "IL13 rna"
  ],
  "IL13RA1": [
    "IL13RA1 methyl",
    "IL13RA1 rna"
  ],
  "IL13RA2": [
    "IL13RA2 rna"
  ],
  "IL15": [
    "IL15 cnv",
    "IL15 methyl",
    "IL15 rna"
  ],
  "IL15RA": [
    "IL15RA cnv",
    "IL15RA methyl",
    "IL15RA rna"
  ],
  "IL16": [
    "IL16 cnv",
    "IL16 proteo",
    "IL16 rna"
  ],
  "IL17A": [
    "IL17A cnv"
  ],
  "IL17B": [
    "IL17B cnv",
    "IL17B rna"
  ],
  "IL17C": [
    "IL17C cnv",
    "IL17C rna"
  ],
  "IL17D": [
    "IL17D cnv",
    "IL17D methyl",
    "IL17D proteo",
    "IL17D rna"
  ],
  "IL17F": [
    "IL17F cnv"
  ],
  "IL17RA": [
    "IL17RA 674_674_1_1_S674 phospho",
    "IL17RA cnv",
    "IL17RA methyl",
    "IL17RA proteo",
    "IL17RA rna"
  ],
  "IL17RB": [
    "IL17RB cnv",
    "IL17RB methyl",
    "IL17RB rna"
  ],
  "IL17RC": [
    "IL17RC cnv",
    "IL17RC rna"
  ],
  "IL17RD": [
    "IL17RD cnv",
    "IL17RD methyl",
    "IL17RD proteo",
    "IL17RD rna"
  ],
  "IL17RE": [
    "IL17RE cnv",
    "IL17RE rna"
  ],
  "IL17REL": [
    "IL17REL cnv",
    "IL17REL rna"
  ],
  "IL18": [
    "IL18 cnv",
    "IL18 proteo",
    "IL18 rna"
  ],
  "IL18BP": [
    "IL18BP cnv",
    "IL18BP rna"
  ],
  "IL18R1": [
    "IL18R1 cnv",
    "IL18R1 methyl",
    "IL18R1 rna"
  ],
  "IL18RAP": [
    "IL18RAP cnv",
    "IL18RAP rna"
  ],
  "IL19": [
    "IL19 cnv",
    "IL19 rna"
  ],
  "IL1A": [
    "IL1A cnv",
    "IL1A rna"
  ],
  "IL1B": [
    "IL1B cnv",
    "IL1B rna"
  ],
  "IL1F10": [
    "IL1F10 cnv"
  ],
  "IL1R1": [
    "IL1R1 cnv",
    "IL1R1 methyl",
    "IL1R1 rna"
  ],
  "IL1R2": [
    "IL1R2 cnv",
    "IL1R2 rna"
  ],
  "IL1RAP": [
    "IL1RAP 555_566_1_0 phospho",
    "IL1RAP 555_566_1_1_S555 phospho",
    "IL1RAP 555_566_1_1_S557 phospho",
    "IL1RAP 555_566_2_2_S556S557 phospho",
    "IL1RAP 555_566_2_2_S557S566 phospho",
    "IL1RAP cnv",
    "IL1RAP methyl",
    "IL1RAP proteo",
    "IL1RAP rna"
  ],
  "IL1RAPL1": [
    "IL1RAPL1 proteo",
    "IL1RAPL1 rna"
  ],
  "IL1RAPL2": [
    "IL1RAPL2 methyl",
    "IL1RAPL2 rna"
  ],
  "IL1RL1": [
    "IL1RL1 cnv",
    "IL1RL1 rna"
  ],
  "IL1RL2": [
    "IL1RL2 cnv",
    "IL1RL2 methyl",
    "IL1RL2 rna"
  ],
  "IL1RN": [
    "IL1RN cnv",
    "IL1RN rna"
  ],
  "IL2": [
    "IL2 cnv",
    "IL2 rna"
  ],
  "IL20": [
    "IL20 cnv",
    "IL20 rna"
  ],
  "IL20RA": [
    "IL20RA cnv",
    "IL20RA methyl",
    "IL20RA rna"
  ],
  "IL20RB": [
    "IL20RB cnv",
    "IL20RB rna"
  ],
  "IL21": [
    "IL21 cnv"
  ],
  "IL21R": [
    "IL21R cnv",
    "IL21R rna"
  ],
  "IL22": [
    "IL22 cnv",
    "IL22 rna"
  ],
  "IL22RA1": [
    "IL22RA1 cnv",
    "IL22RA1 rna"
  ],
  "IL22RA2": [
    "IL22RA2 cnv",
    "IL22RA2 rna"
  ],
  "IL23A": [
    "IL23A cnv",
    "IL23A methyl",
    "IL23A rna"
  ],
  "IL23R": [
    "IL23R cnv",
    "IL23R rna"
  ],
  "IL24": [
    "IL24 cnv",
    "IL24 rna"
  ],
  "IL25": [
    "IL25 cnv",
    "IL25 rna"
  ],
  "IL26": [
    "IL26 cnv",
    "IL26 rna"
  ],
  "IL27": [
    "IL27 cnv",
    "IL27 rna"
  ],
  "IL27RA": [
    "IL27RA cnv",
    "IL27RA methyl",
    "IL27RA rna"
  ],
  "IL2RA": [
    "IL2RA cnv",
    "IL2RA rna"
  ],
  "IL2RB": [
    "IL2RB cnv",
    "IL2RB rna"
  ],
  "IL2RG": [
    "IL2RG rna"
  ],
  "IL3": [
    "IL3 cnv"
  ],
  "IL31": [
    "IL31 cnv"
  ],
  "IL31RA": [
    "IL31RA cnv",
    "IL31RA rna"
  ],
  "IL32": [
    "IL32 cnv",
    "IL32 rna"
  ],
  "IL33": [
    "IL33 cnv",
    "IL33 proteo",
    "IL33 rna"
  ],
  "IL34": [
    "IL34 cnv",
    "IL34 rna"
  ],
  "IL36A": [
    "IL36A cnv"
  ],
  "IL36B": [
    "IL36B cnv",
    "IL36B rna"
  ],
  "IL36G": [
    "IL36G cnv",
    "IL36G rna"
  ],
  "IL36RN": [
    "IL36RN cnv",
    "IL36RN rna"
  ],
  "IL37": [
    "IL37 cnv",
    "IL37 rna"
  ],
  "IL3RA": [
    "IL3RA rna"
  ],
  "IL4": [
    "IL4 cnv",
    "IL4 rna"
  ],
  "IL4I1": [
    "IL4I1 LCQGLGLNLTK-N2H7F0S0G0 glyco",
    "IL4I1 cnv",
    "IL4I1 methyl",
    "IL4I1 proteo",
    "IL4I1 rna"
  ],
  "IL4R": [
    "IL4R cnv",
    "IL4R methyl",
    "IL4R rna"
  ],
  "IL5": [
    "IL5 cnv",
    "IL5 methyl",
    "IL5 rna"
  ],
  "IL5RA": [
    "IL5RA cnv",
    "IL5RA methyl",
    "IL5RA rna"
  ],
  "IL6": [
    "IL6 cnv",
    "IL6 rna"
  ],
  "IL6R": [
    "IL6R cnv",
    "IL6R methyl",
    "IL6R rna"
  ],
  "IL6ST": [
    "IL6ST 600_609_1_1_S606 phospho",
    "IL6ST 600_617_1_1_T609 phospho",
    "IL6ST 719_728_1_1_S721 phospho",
    "IL6ST EQYTIINR-N2H5F0S0G0 glyco",
    "IL6ST ETHLETNFTLK-N2H5F0S0G0 glyco",
    "IL6ST cnv",
    "IL6ST methyl",
    "IL6ST proteo",
    "IL6ST rna"
  ],
  "IL6ST-DT": [
    "IL6ST-DT methyl"
  ],
  "IL7": [
    "IL7 cnv",
    "IL7 methyl",
    "IL7 rna"
  ],
  "IL7R": [
    "IL7R cnv",
    "IL7R rna"
  ],
  "IL9": [
    "IL9 cnv"
  ],
  "IL9R": [
    "IL9R rna"
  ],
  "ILDR1": [
    "ILDR1 cnv",
    "ILDR1 methyl",
    "ILDR1 rna"
  ],
  "ILDR2": [
    "ILDR2 524_531_1_1_S531 phospho",
    "ILDR2 562_574_1_1_S564 phospho",
    "ILDR2 562_574_1_1_S569 phospho",
    "ILDR2 578_600_1_1_S587 phospho",
    "ILDR2 612_616_1_1_S616 phospho",
    "ILDR2 cnv",
    "ILDR2 methyl",
    "ILDR2 proteo",
    "ILDR2 rna"
  ],
  "ILF2": [
    "ILF2 cnv",
    "ILF2 methyl",
    "ILF2 proteo",
    "ILF2 rna"
  ],
  "ILF3": [
    "ILF3 476_514_1_0 phospho",
    "ILF3 476_514_2_0 phospho",
    "ILF3 476_522_1_0 phospho",
    "ILF3 482_514_1_1_S482 phospho",
    "ILF3 592_592_1_1_T592 phospho",
    "ILF3 777_805_1_1_S792 phospho",
    "ILF3 cnv",
    "ILF3 methyl",
    "ILF3 proteo",
    "ILF3 rna"
  ],
  "ILF3-DT": [
    "ILF3-DT methyl"
  ],
  "ILK": [
    "ILK 232_232_1_1_S232 phospho",
    "ILK cnv",
    "ILK kinase",
    "ILK methyl",
    "ILK proteo",
    "ILK rna"
  ],
  "ILKAP": [
    "ILKAP cnv",
    "ILKAP methyl",
    "ILKAP proteo",
    "ILKAP rna"
  ],
  "ILRUN": [
    "ILRUN 199_220_1_1_S206 phospho",
    "ILRUN cnv",
    "ILRUN methyl",
    "ILRUN rna"
  ],
  "ILRUN-AS1": [
    "ILRUN-AS1 methyl"
  ],
  "ILVBL": [
    "ILVBL cnv",
    "ILVBL methyl",
    "ILVBL proteo",
    "ILVBL rna"
  ],
  "IMMP1L": [
    "IMMP1L cnv",
    "IMMP1L methyl",
    "IMMP1L rna"
  ],
  "IMMP2L": [
    "IMMP2L cnv",
    "IMMP2L methyl",
    "IMMP2L rna"
  ],
  "IMMT": [
    "IMMT 103_106_1_1_S103 phospho",
    "IMMT cnv",
    "IMMT methyl",
    "IMMT proteo",
    "IMMT rna"
  ],
  "IMP3": [
    "IMP3 cnv",
    "IMP3 methyl",
    "IMP3 proteo",
    "IMP3 rna"
  ],
  "IMP4": [
    "IMP4 cnv",
    "IMP4 methyl",
    "IMP4 proteo",
    "IMP4 rna"
  ],
  "IMPA1": [
    "IMPA1 216_230_1_1_T227 phospho",
    "IMPA1 96_105_1_0 phospho",
    "IMPA1 96_105_1_1_S97 phospho",
    "IMPA1 cnv",
    "IMPA1 methyl",
    "IMPA1 proteo",
    "IMPA1 rna"
  ],
  "IMPA2": [
    "IMPA2 cnv",
    "IMPA2 methyl",
    "IMPA2 rna"
  ],
  "IMPACT": [
    "IMPACT 294_302_1_1_S297 phospho",
    "IMPACT cnv",
    "IMPACT methyl",
    "IMPACT proteo",
    "IMPACT rna"
  ],
  "IMPDH1": [
    "IMPDH1 cnv",
    "IMPDH1 methyl",
    "IMPDH1 proteo",
    "IMPDH1 rna"
  ],
  "IMPDH2": [
    "IMPDH2 416_416_1_1_S416 phospho",
    "IMPDH2 cnv",
    "IMPDH2 methyl",
    "IMPDH2 proteo",
    "IMPDH2 rna"
  ],
  "IMPG1": [
    "IMPG1 cnv",
    "IMPG1 rna"
  ],
  "IMPG2": [
    "IMPG2 cnv",
    "IMPG2 rna"
  ],
  "INA": [
    "INA 463_481_1_1_S469 phospho",
    "INA 46_66_1_1_S58 phospho",
    "INA 72_78_1_1_S72 phospho",
    "INA cnv",
    "INA methyl",
    "INA proteo",
    "INA rna"
  ],
  "INAFM1": [
    "INAFM1 cnv",
    "INAFM1 methyl",
    "INAFM1 proteo",
    "INAFM1 rna"
  ],
  "INAFM2": [
    "INAFM2 cnv",
    "INAFM2 methyl",
    "INAFM2 rna"
  ],
  "INAVA": [
    "INAVA cnv",
    "INAVA methyl",
    "INAVA rna"
  ],
  "INCA1": [
    "INCA1 cnv",
    "INCA1 methyl",
    "INCA1 rna"
  ],
  "INCENP": [
    "INCENP 298_314_1_1_S306 phospho",
    "INCENP cnv",
    "INCENP methyl",
    "INCENP rna"
  ],
  "INF2": [
    "INF2 371_378_1_1_S372 phospho",
    "INF2 371_404_1_0 phospho",
    "INF2 371_404_1_1_S372 phospho",
    "INF2 582_601_1_1_S589 phospho",
    "INF2 cnv",
    "INF2 methyl",
    "INF2 proteo",
    "INF2 rna"
  ],
  "ING1": [
    "ING1 146_158_2_2_S146S147 phospho",
    "ING1 cnv",
    "ING1 methyl",
    "ING1 proteo",
    "ING1 rna"
  ],
  "ING2": [
    "ING2 cnv",
    "ING2 methyl",
    "ING2 rna"
  ],
  "ING3": [
    "ING3 cnv",
    "ING3 methyl",
    "ING3 proteo",
    "ING3 rna"
  ],
  "ING4": [
    "ING4 150_150_1_1_S150 phospho",
    "ING4 cnv",
    "ING4 methyl",
    "ING4 proteo",
    "ING4 rna"
  ],
  "ING5": [
    "ING5 120_125_1_1_S120 phospho",
    "ING5 149_154_1_1_S150 phospho",
    "ING5 cnv",
    "ING5 methyl",
    "ING5 proteo",
    "ING5 rna"
  ],
  "INGX": [
    "INGX methyl"
  ],
  "INHA": [
    "INHA cnv",
    "INHA rna"
  ],
  "INHBA": [
    "INHBA cnv",
    "INHBA methyl",
    "INHBA rna"
  ],
  "INHBA-AS1": [
    "INHBA-AS1 methyl"
  ],
  "INHBB": [
    "INHBB cnv",
    "INHBB methyl",
    "INHBB rna"
  ],
  "INHBC": [
    "INHBC cnv",
    "INHBC rna"
  ],
  "INHBE": [
    "INHBE cnv",
    "INHBE rna"
  ],
  "INIP": [
    "INIP cnv",
    "INIP methyl",
    "INIP proteo",
    "INIP rna"
  ],
  "INKA1": [
    "INKA1 cnv",
    "INKA1 methyl",
    "INKA1 rna"
  ],
  "INKA2": [
    "INKA2 cnv",
    "INKA2 methyl",
    "INKA2 rna"
  ],
  "INMT": [
    "INMT cnv",
    "INMT rna"
  ],
  "INMT-MINDY4": [
    "INMT-MINDY4 cnv",
    "INMT-MINDY4 rna"
  ],
  "INO80": [
    "INO80 cnv",
    "INO80 methyl",
    "INO80 rna"
  ],
  "INO80B": [
    "INO80B 351_356_1_1_S351 phospho",
    "INO80B cnv",
    "INO80B methyl",
    "INO80B rna"
  ],
  "INO80B-WBP1": [
    "INO80B-WBP1 cnv",
    "INO80B-WBP1 rna"
  ],
  "INO80C": [
    "INO80C cnv",
    "INO80C methyl",
    "INO80C rna"
  ],
  "INO80D": [
    "INO80D cnv",
    "INO80D rna"
  ],
  "INO80E": [
    "INO80E cnv",
    "INO80E methyl",
    "INO80E proteo",
    "INO80E rna"
  ],
  "INPP1": [
    "INPP1 cnv",
    "INPP1 methyl",
    "INPP1 proteo",
    "INPP1 rna"
  ],
  "INPP4A": [
    "INPP4A cnv",
    "INPP4A methyl",
    "INPP4A proteo",
    "INPP4A rna"
  ],
  "INPP4B": [
    "INPP4B cnv",
    "INPP4B methyl",
    "INPP4B proteo",
    "INPP4B rna"
  ],
  "INPP5A": [
    "INPP5A cnv",
    "INPP5A methyl",
    "INPP5A proteo",
    "INPP5A rna"
  ],
  "INPP5B": [
    "INPP5B cnv",
    "INPP5B methyl",
    "INPP5B proteo",
    "INPP5B rna"
  ],
  "INPP5D": [
    "INPP5D 1039_1039_1_1_S1039 phospho",
    "INPP5D 1085_1091_1_1_S1085 phospho",
    "INPP5D 243_263_1_1_S243 phospho",
    "INPP5D 289_300_1_1_S289 phospho",
    "INPP5D 289_300_1_1_S294 phospho",
    "INPP5D 932_944_1_1_S934 phospho",
    "INPP5D 932_951_1_1_S934 phospho",
    "INPP5D 960_971_1_1_S971 phospho",
    "INPP5D 960_971_2_2_T963S971 phospho",
    "INPP5D cnv",
    "INPP5D methyl",
    "INPP5D proteo",
    "INPP5D rna"
  ],
  "INPP5E": [
    "INPP5E 99_99_1_1_S99 phospho",
    "INPP5E cnv",
    "INPP5E methyl",
    "INPP5E rna"
  ],
  "INPP5F": [
    "INPP5F 1103_1103_1_1_S1103 phospho",
    "INPP5F 257_267_1_1_T261 phospho",
    "INPP5F 827_837_1_1_S827 phospho",
    "INPP5F 935_950_1_1_S940 phospho",
    "INPP5F 935_950_2_2_S935S940 phospho",
    "INPP5F 940_950_1_1_S940 phospho",
    "INPP5F 940_950_1_1_S942 phospho",
    "INPP5F 940_959_1_1_S942 phospho",
    "INPP5F cnv",
    "INPP5F methyl",
    "INPP5F proteo",
    "INPP5F rna"
  ],
  "INPP5J": [
    "INPP5J cnv",
    "INPP5J rna"
  ],
  "INPP5K": [
    "INPP5K cnv",
    "INPP5K methyl",
    "INPP5K proteo",
    "INPP5K rna"
  ],
  "INPPL1": [
    "INPPL1 1176_1176_1_1_S1176 phospho",
    "INPPL1 145_185_1_0 phospho",
    "INPPL1 145_185_1_1_S157 phospho",
    "INPPL1 145_185_1_1_S158 phospho",
    "INPPL1 240_245_1_1_S241 phospho",
    "INPPL1 980_1013_1_1_S1003 phospho",
    "INPPL1 cnv",
    "INPPL1 methyl",
    "INPPL1 proteo",
    "INPPL1 rna"
  ],
  "INS": [
    "INS cnv",
    "INS rna"
  ],
  "INS-IGF2": [
    "INS-IGF2 cnv"
  ],
  "INSC": [
    "INSC cnv",
    "INSC methyl",
    "INSC rna"
  ],
  "INSIG1": [
    "INSIG1 cnv",
    "INSIG1 methyl",
    "INSIG1 rna"
  ],
  "INSIG2": [
    "INSIG2 cnv",
    "INSIG2 methyl",
    "INSIG2 rna"
  ],
  "INSL3": [
    "INSL3 cnv",
    "INSL3 methyl",
    "INSL3 rna"
  ],
  "INSL4": [
    "INSL4 cnv"
  ],
  "INSL5": [
    "INSL5 cnv",
    "INSL5 rna"
  ],
  "INSL6": [
    "INSL6 cnv",
    "INSL6 methyl",
    "INSL6 rna"
  ],
  "INSM1": [
    "INSM1 cnv",
    "INSM1 methyl",
    "INSM1 rna"
  ],
  "INSM2": [
    "INSM2 cnv",
    "INSM2 methyl",
    "INSM2 rna"
  ],
  "INSR": [
    "INSR CVNFSFCQDLHHK-N2H5F0S0G0 glyco",
    "INSR cnv",
    "INSR kinase",
    "INSR methyl",
    "INSR proteo",
    "INSR rna"
  ],
  "INSRR": [
    "INSRR cnv",
    "INSRR kinase",
    "INSRR methyl",
    "INSRR rna"
  ],
  "INSYN1": [
    "INSYN1 cnv",
    "INSYN1 methyl",
    "INSYN1 rna"
  ],
  "INSYN2A": [
    "INSYN2A cnv",
    "INSYN2A methyl",
    "INSYN2A rna"
  ],
  "INSYN2B": [
    "INSYN2B cnv",
    "INSYN2B rna"
  ],
  "INTS1": [
    "INTS1 1326_1327_1_1_S1327 phospho",
    "INTS1 cnv",
    "INTS1 methyl",
    "INTS1 proteo",
    "INTS1 rna"
  ],
  "INTS10": [
    "INTS10 213_233_1_1_S231 phospho",
    "INTS10 379_388_1_1_S382 phospho",
    "INTS10 379_388_2_2_S381S382 phospho",
    "INTS10 cnv",
    "INTS10 methyl",
    "INTS10 proteo",
    "INTS10 rna"
  ],
  "INTS11": [
    "INTS11 cnv",
    "INTS11 methyl",
    "INTS11 proteo",
    "INTS11 rna"
  ],
  "INTS12": [
    "INTS12 389_418_1_1_S389 phospho",
    "INTS12 cnv",
    "INTS12 methyl",
    "INTS12 proteo",
    "INTS12 rna"
  ],
  "INTS13": [
    "INTS13 623_626_1_1_S626 phospho",
    "INTS13 cnv",
    "INTS13 methyl",
    "INTS13 proteo",
    "INTS13 rna"
  ],
  "INTS14": [
    "INTS14 cnv",
    "INTS14 methyl",
    "INTS14 proteo",
    "INTS14 rna"
  ],
  "INTS15": [
    "INTS15 cnv",
    "INTS15 methyl",
    "INTS15 rna"
  ],
  "INTS2": [
    "INTS2 cnv",
    "INTS2 methyl",
    "INTS2 proteo",
    "INTS2 rna"
  ],
  "INTS3": [
    "INTS3 1034_1041_1_1_S1041 phospho",
    "INTS3 498_501_1_1_S501 phospho",
    "INTS3 526_544_1_1_S536 phospho",
    "INTS3 cnv",
    "INTS3 methyl",
    "INTS3 proteo",
    "INTS3 rna"
  ],
  "INTS4": [
    "INTS4 cnv",
    "INTS4 methyl",
    "INTS4 proteo",
    "INTS4 rna"
  ],
  "INTS5": [
    "INTS5 cnv",
    "INTS5 methyl",
    "INTS5 proteo",
    "INTS5 rna"
  ],
  "INTS6": [
    "INTS6 cnv",
    "INTS6 methyl",
    "INTS6 proteo",
    "INTS6 rna"
  ],
  "INTS6L": [
    "INTS6L rna"
  ],
  "INTS7": [
    "INTS7 cnv",
    "INTS7 methyl",
    "INTS7 proteo",
    "INTS7 rna"
  ],
  "INTS8": [
    "INTS8 cnv",
    "INTS8 methyl",
    "INTS8 proteo",
    "INTS8 rna"
  ],
  "INTS9": [
    "INTS9 551_551_1_1_S551 phospho",
    "INTS9 cnv",
    "INTS9 proteo",
    "INTS9 rna"
  ],
  "INTU": [
    "INTU cnv",
    "INTU methyl",
    "INTU rna"
  ],
  "INVS": [
    "INVS 518_538_1_1_S518 phospho",
    "INVS cnv",
    "INVS methyl",
    "INVS rna"
  ],
  "IP6K1": [
    "IP6K1 cnv",
    "IP6K1 methyl",
    "IP6K1 proteo",
    "IP6K1 rna"
  ],
  "IP6K2": [
    "IP6K2 cnv",
    "IP6K2 methyl",
    "IP6K2 proteo",
    "IP6K2 rna"
  ],
  "IP6K3": [
    "IP6K3 cnv",
    "IP6K3 rna"
  ],
  "IPCEF1": [
    "IPCEF1 412_421_1_1_S412 phospho",
    "IPCEF1 428_437_1_1_S430 phospho",
    "IPCEF1 cnv",
    "IPCEF1 proteo",
    "IPCEF1 rna"
  ],
  "IPMK": [
    "IPMK cnv",
    "IPMK methyl",
    "IPMK rna"
  ],
  "IPO11": [
    "IPO11 cnv",
    "IPO11 methyl",
    "IPO11 proteo",
    "IPO11 rna"
  ],
  "IPO13": [
    "IPO13 cnv",
    "IPO13 methyl",
    "IPO13 proteo",
    "IPO13 rna"
  ],
  "IPO4": [
    "IPO4 cnv",
    "IPO4 methyl",
    "IPO4 proteo",
    "IPO4 rna"
  ],
  "IPO5": [
    "IPO5 cnv",
    "IPO5 methyl",
    "IPO5 proteo",
    "IPO5 rna"
  ],
  "IPO7": [
    "IPO7 1017_1027_1_1_S1020 phospho",
    "IPO7 cnv",
    "IPO7 methyl",
    "IPO7 proteo",
    "IPO7 rna"
  ],
  "IPO8": [
    "IPO8 cnv",
    "IPO8 methyl",
    "IPO8 proteo",
    "IPO8 rna"
  ],
  "IPO9": [
    "IPO9 cnv",
    "IPO9 methyl",
    "IPO9 proteo",
    "IPO9 rna"
  ],
  "IPO9-AS1": [
    "IPO9-AS1 methyl"
  ],
  "IPP": [
    "IPP cnv",
    "IPP methyl",
    "IPP rna"
  ],
  "IPPK": [
    "IPPK cnv",
    "IPPK methyl",
    "IPPK rna"
  ],
  "IQANK1": [
    "IQANK1 cnv",
    "IQANK1 methyl",
    "IQANK1 rna"
  ],
  "IQCA1": [
    "IQCA1 cnv",
    "IQCA1 methyl",
    "IQCA1 rna"
  ],
  "IQCA1L": [
    "IQCA1L cnv",
    "IQCA1L rna"
  ],
  "IQCB1": [
    "IQCB1 cnv",
    "IQCB1 methyl",
    "IQCB1 proteo",
    "IQCB1 rna"
  ],
  "IQCC": [
    "IQCC cnv",
    "IQCC methyl",
    "IQCC rna"
  ],
  "IQCD": [
    "IQCD cnv",
    "IQCD methyl",
    "IQCD rna"
  ],
  "IQCE": [
    "IQCE 128_140_1_1_S130 phospho",
    "IQCE 590_610_1_1_S590 phospho",
    "IQCE cnv",
    "IQCE methyl",
    "IQCE proteo",
    "IQCE rna"
  ],
  "IQCF1": [
    "IQCF1 cnv",
    "IQCF1 rna"
  ],
  "IQCF2": [
    "IQCF2 cnv"
  ],
  "IQCF3": [
    "IQCF3 cnv",
    "IQCF3 rna"
  ],
  "IQCF5": [
    "IQCF5 cnv",
    "IQCF5 rna"
  ],
  "IQCF6": [
    "IQCF6 cnv"
  ],
  "IQCG": [
    "IQCG cnv",
    "IQCG methyl",
    "IQCG rna"
  ],
  "IQCH": [
    "IQCH cnv",
    "IQCH methyl",
    "IQCH rna"
  ],
  "IQCH-AS1": [
    "IQCH-AS1 methyl"
  ],
  "IQCJ": [
    "IQCJ cnv",
    "IQCJ rna"
  ],
  "IQCJ-SCHIP1": [
    "IQCJ-SCHIP1 cnv",
    "IQCJ-SCHIP1 rna"
  ],
  "IQCK": [
    "IQCK cnv",
    "IQCK methyl",
    "IQCK rna"
  ],
  "IQCM": [
    "IQCM cnv",
    "IQCM rna"
  ],
  "IQCN": [
    "IQCN cnv",
    "IQCN rna"
  ],
  "IQGAP1": [
    "IQGAP1 1443_1451_1_1_S1443 phospho",
    "IQGAP1 cnv",
    "IQGAP1 methyl",
    "IQGAP1 proteo",
    "IQGAP1 rna"
  ],
  "IQGAP2": [
    "IQGAP2 1356_1358_1_1_S1358 phospho",
    "IQGAP2 14_16_1_1_S16 phospho",
    "IQGAP2 14_24_1_1_S16 phospho",
    "IQGAP2 cnv",
    "IQGAP2 methyl",
    "IQGAP2 proteo",
    "IQGAP2 rna"
  ],
  "IQGAP3": [
    "IQGAP3 cnv",
    "IQGAP3 methyl",
    "IQGAP3 rna"
  ],
  "IQSEC1": [
    "IQSEC1 145_148_1_1_S146 phospho",
    "IQSEC1 166_166_1_1_S166 phospho",
    "IQSEC1 184_208_1_1_S184 phospho",
    "IQSEC1 184_208_1_1_S197 phospho",
    "IQSEC1 396_403_1_1_S403 phospho",
    "IQSEC1 498_505_1_1_S498 phospho",
    "IQSEC1 498_505_1_1_S501 phospho",
    "IQSEC1 798_808_1_1_S803 phospho",
    "IQSEC1 91_100_1_1_S91 phospho",
    "IQSEC1 925_941_1_0 phospho",
    "IQSEC1 925_941_1_1_S926 phospho",
    "IQSEC1 925_941_2_0 phospho",
    "IQSEC1 925_941_2_1_S929 phospho",
    "IQSEC1 cnv",
    "IQSEC1 methyl",
    "IQSEC1 proteo",
    "IQSEC1 rna"
  ],
  "IQSEC2": [
    "IQSEC2 1123_1129_1_1_S1124 phospho",
    "IQSEC2 1158_1173_1_1_S1158 phospho",
    "IQSEC2 212_232_1_1_S214 phospho",
    "IQSEC2 393_397_1_1_S393 phospho",
    "IQSEC2 405_412_1_1_S412 phospho",
    "IQSEC2 621_631_1_1_S627 phospho",
    "IQSEC2 738_744_1_1_S741 phospho",
    "IQSEC2 741_744_1_1_S744 phospho",
    "IQSEC2 methyl",
    "IQSEC2 proteo",
    "IQSEC2 rna"
  ],
  "IQSEC3": [
    "IQSEC3 134_137_1_1_S137 phospho",
    "IQSEC3 cnv",
    "IQSEC3 proteo",
    "IQSEC3 rna"
  ],
  "IQUB": [
    "IQUB cnv",
    "IQUB methyl",
    "IQUB rna"
  ],
  "IRAG1": [
    "IRAG1 246_269_1_1_S256 phospho",
    "IRAG1 303_306_1_1_S303 phospho",
    "IRAG1 395_406_1_1_S398 phospho",
    "IRAG1 606_606_1_1_S606 phospho",
    "IRAG1 93_115_1_1_S111 phospho",
    "IRAG1 cnv",
    "IRAG1 proteo",
    "IRAG1 rna"
  ],
  "IRAG1-AS1": [
    "IRAG1-AS1 methyl"
  ],
  "IRAG2": [
    "IRAG2 319_322_1_1_T319 phospho",
    "IRAG2 384_395_1_1_S388 phospho",
    "IRAG2 73_97_1_1_S75 phospho",
    "IRAG2 cnv",
    "IRAG2 proteo",
    "IRAG2 rna"
  ],
  "IRAK1": [
    "IRAK1 kinase",
    "IRAK1 methyl",
    "IRAK1 proteo",
    "IRAK1 rna"
  ],
  "IRAK1BP1": [
    "IRAK1BP1 cnv",
    "IRAK1BP1 methyl",
    "IRAK1BP1 rna"
  ],
  "IRAK2": [
    "IRAK2 cnv",
    "IRAK2 kinase",
    "IRAK2 methyl",
    "IRAK2 rna"
  ],
  "IRAK3": [
    "IRAK3 cnv",
    "IRAK3 kinase",
    "IRAK3 methyl",
    "IRAK3 rna"
  ],
  "IRAK4": [
    "IRAK4 cnv",
    "IRAK4 kinase",
    "IRAK4 methyl",
    "IRAK4 proteo",
    "IRAK4 rna"
  ],
  "IREB2": [
    "IREB2 cnv",
    "IREB2 methyl",
    "IREB2 proteo",
    "IREB2 rna"
  ],
  "IRF1": [
    "IRF1 cnv",
    "IRF1 methyl",
    "IRF1 rna"
  ],
  "IRF2": [
    "IRF2 cnv",
    "IRF2 methyl",
    "IRF2 proteo",
    "IRF2 rna"
  ],
  "IRF2BP1": [
    "IRF2BP1 384_384_1_1_S384 phospho",
    "IRF2BP1 436_436_1_1_S436 phospho",
    "IRF2BP1 453_464_1_1_S453 phospho",
    "IRF2BP1 58_66_1_1_S66 phospho",
    "IRF2BP1 66_66_1_1_S66 phospho",
    "IRF2BP1 cnv",
    "IRF2BP1 methyl",
    "IRF2BP1 proteo",
    "IRF2BP1 rna"
  ],
  "IRF2BP2": [
    "IRF2BP2 344_344_1_1_S344 phospho",
    "IRF2BP2 376_393_1_0 phospho",
    "IRF2BP2 376_393_1_1_S390 phospho",
    "IRF2BP2 439_447_1_1_S441 phospho",
    "IRF2BP2 439_447_1_1_S444 phospho",
    "IRF2BP2 439_447_2_2_S439S441 phospho",
    "IRF2BP2 439_447_2_2_S441S444 phospho",
    "IRF2BP2 439_447_3_3_S439S441S444 phospho",
    "IRF2BP2 cnv",
    "IRF2BP2 methyl",
    "IRF2BP2 proteo",
    "IRF2BP2 rna"
  ],
  "IRF2BPL": [
    "IRF2BPL 203_227_1_1_S215 phospho",
    "IRF2BPL 334_338_1_1_S334 phospho",
    "IRF2BPL 519_533_1_1_S519 phospho",
    "IRF2BPL 547_553_1_1_S547 phospho",
    "IRF2BPL 610_639_1_1_S639 phospho",
    "IRF2BPL 657_665_1_0 phospho",
    "IRF2BPL 657_665_1_1_S657 phospho",
    "IRF2BPL 657_665_2_2_S659S662 phospho",
    "IRF2BPL 657_665_3_3_S657S659S662 phospho",
    "IRF2BPL cnv",
    "IRF2BPL methyl",
    "IRF2BPL proteo",
    "IRF2BPL rna"
  ],
  "IRF3": [
    "IRF3 cnv",
    "IRF3 methyl",
    "IRF3 proteo",
    "IRF3 rna"
  ],
  "IRF4": [
    "IRF4 cnv",
    "IRF4 methyl",
    "IRF4 rna"
  ],
  "IRF5": [
    "IRF5 cnv",
    "IRF5 methyl",
    "IRF5 proteo",
    "IRF5 rna"
  ],
  "IRF6": [
    "IRF6 cnv",
    "IRF6 methyl",
    "IRF6 rna"
  ],
  "IRF7": [
    "IRF7 cnv",
    "IRF7 methyl",
    "IRF7 rna"
  ],
  "IRF8": [
    "IRF8 172_174_2_2_S172S174 phospho",
    "IRF8 cnv",
    "IRF8 methyl",
    "IRF8 proteo",
    "IRF8 rna"
  ],
  "IRF9": [
    "IRF9 cnv",
    "IRF9 proteo",
    "IRF9 rna"
  ],
  "IRGC": [
    "IRGC cnv",
    "IRGC rna"
  ],
  "IRGM": [
    "IRGM cnv",
    "IRGM rna"
  ],
  "IRGQ": [
    "IRGQ cnv",
    "IRGQ methyl",
    "IRGQ proteo",
    "IRGQ rna"
  ],
  "IRS1": [
    "IRS1 1100_1111_1_1_S1100 phospho",
    "IRS1 329_351_1_1_S330 phospho",
    "IRS1 374_380_1_1_S374 phospho",
    "IRS1 cnv",
    "IRS1 methyl",
    "IRS1 proteo",
    "IRS1 rna"
  ],
  "IRS2": [
    "IRS2 1148_1164_1_1_S1148 phospho",
    "IRS2 1148_1164_2_2_S1148S1162 phospho",
    "IRS2 1174_1181_1_1_S1174 phospho",
    "IRS2 1174_1181_1_1_S1176 phospho",
    "IRS2 1185_1203_1_0 phospho",
    "IRS2 1185_1203_1_1_S1186 phospho",
    "IRS2 162_194_1_0 phospho",
    "IRS2 304_318_1_1_S306 phospho",
    "IRS2 306_318_1_1_S306 phospho",
    "IRS2 344_350_1_1_T350 phospho",
    "IRS2 363_365_1_1_S365 phospho",
    "IRS2 384_391_1_1_S388 phospho",
    "IRS2 384_391_1_1_S391 phospho",
    "IRS2 518_527_1_1_T520 phospho",
    "IRS2 518_527_1_1_T527 phospho",
    "IRS2 518_527_2_2_T520T527 phospho",
    "IRS2 560_560_1_1_S560 phospho",
    "IRS2 591_599_1_1_S594 phospho",
    "IRS2 615_620_1_1_S620 phospho",
    "IRS2 672_684_1_1_S679 phospho",
    "IRS2 730_742_1_1_S731 phospho",
    "IRS2 730_742_1_1_S736 phospho",
    "IRS2 730_742_2_1_S731 phospho",
    "IRS2 730_742_2_2_S731S736 phospho",
    "IRS2 915_919_1_1_S915 phospho",
    "IRS2 973_985_1_1_S973 phospho",
    "IRS2 cnv",
    "IRS2 methyl",
    "IRS2 proteo",
    "IRS2 rna"
  ],
  "IRS4": [
    "IRS4 methyl",
    "IRS4 rna"
  ],
  "IRX1": [
    "IRX1 cnv",
    "IRX1 methyl",
    "IRX1 rna"
  ],
  "IRX2": [
    "IRX2 186_197_1_1_S186 phospho",
    "IRX2 cnv",
    "IRX2 methyl",
    "IRX2 rna"
  ],
  "IRX3": [
    "IRX3 cnv",
    "IRX3 methyl",
    "IRX3 rna"
  ],
  "IRX4": [
    "IRX4 cnv",
    "IRX4 methyl",
    "IRX4 rna"
  ],
  "IRX5": [
    "IRX5 cnv",
    "IRX5 methyl",
    "IRX5 rna"
  ],
  "IRX6": [
    "IRX6 cnv",
    "IRX6 methyl",
    "IRX6 rna"
  ],
  "ISCA1": [
    "ISCA1 cnv",
    "ISCA1 methyl",
    "ISCA1 proteo",
    "ISCA1 rna"
  ],
  "ISCA2": [
    "ISCA2 39_42_1_1_S42 phospho",
    "ISCA2 cnv",
    "ISCA2 methyl",
    "ISCA2 proteo",
    "ISCA2 rna"
  ],
  "ISCU": [
    "ISCU cnv",
    "ISCU methyl",
    "ISCU proteo",
    "ISCU rna"
  ],
  "ISG15": [
    "ISG15 cnv",
    "ISG15 methyl",
    "ISG15 proteo",
    "ISG15 rna"
  ],
  "ISG20": [
    "ISG20 cnv",
    "ISG20 proteo",
    "ISG20 rna"
  ],
  "ISG20L2": [
    "ISG20L2 cnv",
    "ISG20L2 methyl",
    "ISG20L2 proteo",
    "ISG20L2 rna"
  ],
  "ISL1": [
    "ISL1 cnv",
    "ISL1 methyl",
    "ISL1 rna"
  ],
  "ISL2": [
    "ISL2 cnv",
    "ISL2 methyl",
    "ISL2 rna"
  ],
  "ISLR": [
    "ISLR cnv",
    "ISLR proteo",
    "ISLR rna"
  ],
  "ISLR2": [
    "ISLR2 cnv",
    "ISLR2 methyl",
    "ISLR2 proteo",
    "ISLR2 rna"
  ],
  "ISM1": [
    "ISM1 cnv",
    "ISM1 methyl",
    "ISM1 rna"
  ],
  "ISM2": [
    "ISM2 cnv",
    "ISM2 methyl",
    "ISM2 rna"
  ],
  "ISOC1": [
    "ISOC1 cnv",
    "ISOC1 methyl",
    "ISOC1 proteo",
    "ISOC1 rna"
  ],
  "ISOC2": [
    "ISOC2 cnv",
    "ISOC2 methyl",
    "ISOC2 proteo",
    "ISOC2 rna"
  ],
  "IST1": [
    "IST1 cnv",
    "IST1 methyl",
    "IST1 proteo",
    "IST1 rna"
  ],
  "ISX": [
    "ISX cnv"
  ],
  "ISY1": [
    "ISY1 cnv",
    "ISY1 methyl",
    "ISY1 rna"
  ],
  "ISY1-RAB43": [
    "ISY1-RAB43 cnv",
    "ISY1-RAB43 methyl",
    "ISY1-RAB43 rna"
  ],
  "ISYNA1": [
    "ISYNA1 cnv",
    "ISYNA1 methyl",
    "ISYNA1 proteo",
    "ISYNA1 rna"
  ],
  "ITCH": [
    "ITCH 217_221_1_1_S221 phospho",
    "ITCH cnv",
    "ITCH methyl",
    "ITCH proteo",
    "ITCH rna"
  ],
  "ITFG1": [
    "ITFG1 cnv",
    "ITFG1 methyl",
    "ITFG1 proteo",
    "ITFG1 rna"
  ],
  "ITFG2": [
    "ITFG2 218_231_1_1_S220 phospho",
    "ITFG2 cnv",
    "ITFG2 methyl",
    "ITFG2 proteo",
    "ITFG2 rna"
  ],
  "ITFG2-AS1": [
    "ITFG2-AS1 methyl"
  ],
  "ITGA1": [
    "ITGA1 NTTFNVESTK-N2H5F0S0G0 glyco",
    "ITGA1 NTTFNVESTK-N2H6F0S0G0 glyco",
    "ITGA1 NTTFNVESTK-N2H7F0S0G0 glyco",
    "ITGA1 NTTFNVESTK-N2H8F0S0G0 glyco",
    "ITGA1 SENASLVLSSSNQK-N2H5F0S0G0 glyco",
    "ITGA1 SENASLVLSSSNQK-N2H7F0S0G0 glyco",
    "ITGA1 SENASLVLSSSNQK-N2H8F0S0G0 glyco",
    "ITGA1 SQNDKFNVSLTVK-N2H5F0S0G0 glyco",
    "ITGA1 SQNDKFNVSLTVK-N2H6F0S0G0 glyco",
    "ITGA1 SYFSSLNLTIR-N2H8F0S0G0 glyco",
    "ITGA1 VYVYALNQTR-N4H4F1S0G0 glyco",
    "ITGA1 VYVYALNQTR-N4H5F1S0G0 glyco",
    "ITGA1 VYVYALNQTR-N5H4F1S0G0 glyco",
    "ITGA1 YNHTGQVIIYR-N2H7F0S0G0 glyco",
    "ITGA1 YNHTGQVIIYR-N2H8F0S0G0 glyco",
    "ITGA1 YNHTGQVIIYR-N2H9F0S0G0 glyco",
    "ITGA1 cnv",
    "ITGA1 methyl",
    "ITGA1 proteo",
    "ITGA1 rna"
  ],
  "ITGA10": [
    "ITGA10 cnv",
    "ITGA10 rna"
  ],
  "ITGA11": [
    "ITGA11 cnv",
    "ITGA11 methyl",
    "ITGA11 rna"
  ],
  "ITGA2": [
    "ITGA2 1176_1181_1_0 phospho",
    "ITGA2 GEYFVNVTTR-N2H5F0S0G0 glyco",
    "ITGA2 GEYFVNVTTR-N2H6F0S0G0 glyco",
    "ITGA2 GEYFVNVTTR-N2H7F0S0G0 glyco",
    "ITGA2 LNLQTSTSIPNVTEMK-N4H5F1S1G0 glyco",
    "ITGA2 TNMSLGLILTR-N2H8F0S0G0 glyco",
    "ITGA2 YFFNVSDEAALLEK-N2H5F0S0G0 glyco",
    "ITGA2 YFFNVSDEAALLEK-N5H3F0S0G0 glyco",
    "ITGA2 cnv",
    "ITGA2 methyl",
    "ITGA2 proteo",
    "ITGA2 rna"
  ],
  "ITGA2B": [
    "ITGA2B cnv",
    "ITGA2B methyl",
    "ITGA2B proteo",
    "ITGA2B rna"
  ],
  "ITGA3": [
    "ITGA3 ELAVPDGYTNR-N2H8F0S0G0 glyco",
    "ITGA3 KLLLSINVTNTR-N2H5F0S0G0 glyco",
    "ITGA3 LLLSINVTNTR-N2H4F0S0G0 glyco",
    "ITGA3 LLLSINVTNTR-N2H5F0S0G0 glyco",
    "ITGA3 LLLSINVTNTR-N2H6F0S0G0 glyco",
    "ITGA3 NITIVTGAPR-N2H4F0S0G0 glyco",
    "ITGA3 NITIVTGAPR-N2H5F0S0G0 glyco",
    "ITGA3 SLDAYPILNQAQALENHTEVQFQK-N2H6F0S0G0 glyco",
    "ITGA3 SLDAYPILNQAQALENHTEVQFQK-N2H7F0S0G0 glyco",
    "ITGA3 SLDAYPILNQAQALENHTEVQFQK-N2H8F0S0G0 glyco",
    "ITGA3 TSIPTINMENK-N2H5F0S0G0 glyco",
    "ITGA3 VWNSTFIEDYRDFDR-N2H8F0S0G0 glyco",
    "ITGA3 cnv",
    "ITGA3 methyl",
    "ITGA3 proteo",
    "ITGA3 rna"
  ],
  "ITGA4": [
    "ITGA4 1011_1027_1_1_S1021 phospho",
    "ITGA4 1021_1027_1_1_S1021 phospho",
    "ITGA4 cnv",
    "ITGA4 methyl",
    "ITGA4 proteo",
    "ITGA4 rna"
  ],
  "ITGA5": [
    "ITGA5 123_136_1_1_S127 phospho",
    "ITGA5 cnv",
    "ITGA5 methyl",
    "ITGA5 proteo",
    "ITGA5 rna"
  ],
  "ITGA6": [
    "ITGA6 ANHSGAVVLLK-N2H4F0S0G0 glyco",
    "ITGA6 ANHSGAVVLLK-N2H5F0S0G0 glyco",
    "ITGA6 ANHSGAVVLLK-N2H6F0S0G0 glyco",
    "ITGA6 ANHSGAVVLLK-N2H7F0S0G0 glyco",
    "ITGA6 ANHSGAVVLLK-N2H8F0S0G0 glyco",
    "ITGA6 LWNSTFLEEYSK-N4H3F0S2G0 glyco",
    "ITGA6 QLSCVANQNGSQADCELGNPFK-N4H5F1S1G0 glyco",
    "ITGA6 YQTLNCSVNVNCVNIR-N2H5F0S0G0 glyco",
    "ITGA6 YQTLNCSVNVNCVNIR-N2H6F0S0G0 glyco",
    "ITGA6 YQTLNCSVNVNCVNIR-N2H7F0S0G0 glyco",
    "ITGA6 cnv",
    "ITGA6 methyl",
    "ITGA6 proteo",
    "ITGA6 rna"
  ],
  "ITGA7": [
    "ITGA7 LWNSTFLEEYSAVK-N2H8F0S0G0 glyco",
    "ITGA7 cnv",
    "ITGA7 methyl",
    "ITGA7 proteo",
    "ITGA7 rna"
  ],
  "ITGA8": [
    "ITGA8 cnv",
    "ITGA8 methyl",
    "ITGA8 rna"
  ],
  "ITGA9": [
    "ITGA9 cnv",
    "ITGA9 methyl",
    "ITGA9 proteo",
    "ITGA9 rna"
  ],
  "ITGA9-AS1": [
    "ITGA9-AS1 methyl"
  ],
  "ITGAD": [
    "ITGAD cnv",
    "ITGAD rna"
  ],
  "ITGAE": [
    "ITGAE cnv",
    "ITGAE methyl",
    "ITGAE rna"
  ],
  "ITGAL": [
    "ITGAL ALSCNVSSPIFK-N2H6F0S0G0 glyco",
    "ITGAL ALSCNVSSPIFK-N2H7F0S0G0 glyco",
    "ITGAL cnv",
    "ITGAL methyl",
    "ITGAL proteo",
    "ITGAL rna"
  ],
  "ITGAM": [
    "ITGAM APVVNCSIAVCQR-N2H8F0S0G0 glyco",
    "ITGAM ELFNITNGAR-N4H5F0S1G0 glyco",
    "ITGAM ELFNITNGAR-N4H5F0S2G0 glyco",
    "ITGAM cnv",
    "ITGAM proteo",
    "ITGAM rna"
  ],
  "ITGAV": [
    "ITGAV 1000_1002_1_1_S1000 phospho",
    "ITGAV ANTTQPGIVEGGQVLK-N2H3F0S0G0 glyco",
    "ITGAV ANTTQPGIVEGGQVLK-N2H4F0S0G0 glyco",
    "ITGAV ANTTQPGIVEGGQVLK-N2H5F0S0G0 glyco",
    "ITGAV ANTTQPGIVEGGQVLK-N2H6F0S0G0 glyco",
    "ITGAV ANTTQPGIVEGGQVLK-N2H7F0S0G0 glyco",
    "ITGAV ANTTQPGIVEGGQVLK-N2H8F0S0G0 glyco",
    "ITGAV ANTTQPGIVEGGQVLK-N3H3F1S0G0 glyco",
    "ITGAV ANTTQPGIVEGGQVLK-N3H4F1S0G0 glyco",
    "ITGAV ANTTQPGIVEGGQVLK-N3H5F0S0G0 glyco",
    "ITGAV ANTTQPGIVEGGQVLK-N3H5F1S0G0 glyco",
    "ITGAV ANTTQPGIVEGGQVLK-N3H5F1S1G0 glyco",
    "ITGAV ANTTQPGIVEGGQVLK-N3H5F2S0G0 glyco",
    "ITGAV ANTTQPGIVEGGQVLK-N4H4F1S0G0 glyco",
    "ITGAV ANTTQPGIVEGGQVLK-N4H5F0S0G0 glyco",
    "ITGAV ANTTQPGIVEGGQVLK-N4H5F1S0G0 glyco",
    "ITGAV ANTTQPGIVEGGQVLK-N4H5F1S1G0 glyco",
    "ITGAV ANTTQPGIVEGGQVLK-N5H3F1S0G0 glyco",
    "ITGAV ARPVITVNAGLEVYPSILNQDNK-N2H5F0S0G0 glyco",
    "ITGAV ENQNHSYSLK-N2H4F0S0G0 glyco",
    "ITGAV ENQNHSYSLK-N2H5F0S0G0 glyco",
    "ITGAV ENQNHSYSLK-N2H6F0S0G0 glyco",
    "ITGAV ENQNHSYSLK-N2H7F0S0G0 glyco",
    "ITGAV ENQNHSYSLK-N2H8F0S0G0 glyco",
    "ITGAV ENQNHSYSLK-N2H9F0S0G0 glyco",
    "ITGAV ENQNHSYSLK-N3H6F0S0G0 glyco",
    "ITGAV TAADTTGLQPILNQFTPANISR-N2H7F0S0G0 glyco",
    "ITGAV TAADTTGLQPILNQFTPANISR-N2H8F0S0G0 glyco",
    "ITGAV TAADTTGLQPILNQFTPANISR-N2H9F0S0G0 glyco",
    "ITGAV cnv",
    "ITGAV methyl",
    "ITGAV proteo",
    "ITGAV rna"
  ],
  "ITGAX": [
    "ITGAX LLLTANVSSENNTPR-N5H6F0S2G0 glyco",
    "ITGAX LNFTLVGKPLLAFR-N2H8F0S0G0 glyco",
    "ITGAX cnv",
    "ITGAX proteo",
    "ITGAX rna"
  ],
  "ITGB1": [
    "ITGB1 KDTCTQECSYFNITK-N2H6F0S0G0 glyco",
    "ITGB1 KDTCTQECSYFNITK-N4H5F1S1G0 glyco",
    "ITGB1 KDTCTQECSYFNITK-N4H5F3S0G0 glyco",
    "ITGB1 LRNPCTSEQNCTSPFSYK-N2H5F0S0G0 glyco",
    "ITGB1 LRNPCTSEQNCTSPFSYK-N2H7F0S0G0 glyco",
    "ITGB1 LRNPCTSEQNCTSPFSYK-N4H5F1S1G0 glyco",
    "ITGB1 LRNPCTSEQNCTSPFSYK-N4H5F4S2G0 glyco",
    "ITGB1 LRNPCTSEQNCTSPFSYK-N5H3F1S0G0 glyco",
    "ITGB1 NGVNGTGENGR-N2H5F0S0G0 glyco",
    "ITGB1 NGVNGTGENGRK-N2H5F0S0G0 glyco",
    "ITGB1 NPCTSEQNCTSPFSYK-N2H5F0S0G0 glyco",
    "ITGB1 cnv",
    "ITGB1 methyl",
    "ITGB1 proteo",
    "ITGB1 rna"
  ],
  "ITGB1BP1": [
    "ITGB1BP1 36_47_1_1_S41 phospho",
    "ITGB1BP1 cnv",
    "ITGB1BP1 methyl",
    "ITGB1BP1 proteo",
    "ITGB1BP1 rna"
  ],
  "ITGB1BP2": [
    "ITGB1BP2 rna"
  ],
  "ITGB2": [
    "ITGB2 756_760_1_1_T758 phospho",
    "ITGB2 LNFTGPGDPDSIR-N2H8F0S0G0 glyco",
    "ITGB2 LTNNSNQFQTEVGK-N2H7F0S0G0 glyco",
    "ITGB2 LTNNSNQFQTEVGK-N2H8F0S0G0 glyco",
    "ITGB2 LTNNSNQFQTEVGK-N4H5F4S2G0 glyco",
    "ITGB2 NCSAACPGLQLSNNPVK-N2H5F0S0G0 glyco",
    "ITGB2 NCSAACPGLQLSNNPVK-N2H6F0S0G0 glyco",
    "ITGB2 NCSAACPGLQLSNNPVK-N2H7F0S0G0 glyco",
    "ITGB2 NCSAACPGLQLSNNPVK-N2H8F0S0G0 glyco",
    "ITGB2 NCSAACPGLQLSNNPVK-N3H5F0S1G0 glyco",
    "ITGB2 NCSAACPGLQLSNNPVK-N3H6F0S0G0 glyco",
    "ITGB2 NCSAACPGLQLSNNPVK-N3H6F0S1G0 glyco",
    "ITGB2 cnv",
    "ITGB2 methyl",
    "ITGB2 proteo",
    "ITGB2 rna"
  ],
  "ITGB3": [
    "ITGB3 DAVNCTYK-N2H5F0S0G0 glyco",
    "ITGB3 DAVNCTYK-N2H8F0S0G0 glyco",
    "ITGB3 NFSIQVR-N2H5F0S0G0 glyco",
    "ITGB3 cnv",
    "ITGB3 methyl",
    "ITGB3 proteo",
    "ITGB3 rna"
  ],
  "ITGB3BP": [
    "ITGB3BP cnv",
    "ITGB3BP methyl",
    "ITGB3BP rna"
  ],
  "ITGB4": [
    "ITGB4 1454_1457_1_1_S1457 phospho",
    "ITGB4 1462_1474_1_1_S1474 phospho",
    "ITGB4 1696_1699_1_1_S1696 phospho",
    "ITGB4 cnv",
    "ITGB4 methyl",
    "ITGB4 proteo",
    "ITGB4 rna"
  ],
  "ITGB5": [
    "ITGB5 cnv",
    "ITGB5 methyl",
    "ITGB5 proteo",
    "ITGB5 rna"
  ],
  "ITGB6": [
    "ITGB6 cnv",
    "ITGB6 rna"
  ],
  "ITGB7": [
    "ITGB7 cnv",
    "ITGB7 methyl",
    "ITGB7 rna"
  ],
  "ITGB8": [
    "ITGB8 NYAIIKPIGFNETAK-N2H6F0S0G0 glyco",
    "ITGB8 NYAIIKPIGFNETAK-N2H7F0S0G0 glyco",
    "ITGB8 NYAIIKPIGFNETAK-N2H8F0S0G0 glyco",
    "ITGB8 VQVENQVQGIYFNITAICPDGSR-N2H4F0S0G0 glyco",
    "ITGB8 VQVENQVQGIYFNITAICPDGSR-N2H5F0S0G0 glyco",
    "ITGB8 VQVENQVQGIYFNITAICPDGSR-N2H6F0S0G0 glyco",
    "ITGB8 VQVENQVQGIYFNITAICPDGSR-N2H7F0S0G0 glyco",
    "ITGB8 cnv",
    "ITGB8 methyl",
    "ITGB8 proteo",
    "ITGB8 rna"
  ],
  "ITGB8-AS1": [
    "ITGB8-AS1 methyl"
  ],
  "ITGBL1": [
    "ITGBL1 cnv",
    "ITGBL1 rna"
  ],
  "ITIH1": [
    "ITIH1 ICDLLVANNHFAHFFAPQNLTNMNK-N4H5F0S1G0 glyco",
    "ITIH1 ICDLLVANNHFAHFFAPQNLTNMNK-N4H5F0S2G0 glyco",
    "ITIH1 ICDLLVANNHFAHFFAPQNLTNMNK-N4H5F2S1G0 glyco",
    "ITIH1 ICDLLVANNHFAHFFAPQNLTNMNK-N4H6F1S1G0 glyco",
    "ITIH1 ICDLLVANNHFAHFFAPQNLTNMNK-N5H5F1S1G0 glyco",
    "ITIH1 cnv",
    "ITIH1 proteo",
    "ITIH1 rna"
  ],
  "ITIH2": [
    "ITIH2 55_75_1_1_S60 phospho",
    "ITIH2 GAFISNFSMTVDGK-N3H4F0S1G0 glyco",
    "ITIH2 GAFISNFSMTVDGK-N4H5F0S0G0 glyco",
    "ITIH2 GAFISNFSMTVDGK-N4H5F0S1G0 glyco",
    "ITIH2 GAFISNFSMTVDGK-N4H5F0S2G0 glyco",
    "ITIH2 GAFISNFSMTVDGK-N4H5F2S1G0 glyco",
    "ITIH2 cnv",
    "ITIH2 proteo",
    "ITIH2 rna"
  ],
  "ITIH3": [
    "ITIH3 cnv",
    "ITIH3 proteo",
    "ITIH3 rna"
  ],
  "ITIH4": [
    "ITIH4 620_626_1_1_S626 phospho",
    "ITIH4 AFITNFSMIIDGMTYPGIIK-N4H5F0S2G0 glyco",
    "ITIH4 AFITNFSMIIDGMTYPGIIK-N4H5F2S1G0 glyco",
    "ITIH4 LPTQNITFQTESSVAEQEAEFQSPK-N4H5F0S1G0 glyco",
    "ITIH4 LPTQNITFQTESSVAEQEAEFQSPK-N4H5F0S2G0 glyco",
    "ITIH4 LPTQNITFQTESSVAEQEAEFQSPK-N4H5F1S2G0 glyco",
    "ITIH4 LPTQNITFQTESSVAEQEAEFQSPK-N4H5F2S1G0 glyco",
    "ITIH4 cnv",
    "ITIH4 proteo",
    "ITIH4 rna"
  ],
  "ITIH5": [
    "ITIH5 TLFPNYFNGSEIIIAGK-N2H5F0S0G0 glyco",
    "ITIH5 cnv",
    "ITIH5 methyl",
    "ITIH5 proteo",
    "ITIH5 rna"
  ],
  "ITIH6": [
    "ITIH6 rna"
  ],
  "ITK": [
    "ITK cnv",
    "ITK kinase",
    "ITK methyl",
    "ITK rna"
  ],
  "ITLN1": [
    "ITLN1 cnv",
    "ITLN1 rna"
  ],
  "ITLN2": [
    "ITLN2 cnv",
    "ITLN2 rna"
  ],
  "ITM2A": [
    "ITM2A proteo",
    "ITM2A rna"
  ],
  "ITM2B": [
    "ITM2B CYVIPLNTSIVMPPR-N2H5F0S0G0 glyco",
    "ITM2B cnv",
    "ITM2B methyl",
    "ITM2B proteo",
    "ITM2B rna"
  ],
  "ITM2C": [
    "ITM2C 22_37_1_1_T37 phospho",
    "ITM2C cnv",
    "ITM2C methyl",
    "ITM2C proteo",
    "ITM2C rna"
  ],
  "ITPA": [
    "ITPA cnv",
    "ITPA methyl",
    "ITPA proteo",
    "ITPA rna"
  ],
  "ITPK1": [
    "ITPK1 396_409_1_1_S396 phospho",
    "ITPK1 cnv",
    "ITPK1 methyl",
    "ITPK1 proteo",
    "ITPK1 rna"
  ],
  "ITPKA": [
    "ITPKA cnv",
    "ITPKA methyl",
    "ITPKA proteo",
    "ITPKA rna"
  ],
  "ITPKB": [
    "ITPKB 118_120_1_1_S120 phospho",
    "ITPKB 174_176_1_1_S174 phospho",
    "ITPKB 174_176_2_2_S174S176 phospho",
    "ITPKB 202_217_1_1_S204 phospho",
    "ITPKB 22_33_1_1_T33 phospho",
    "ITPKB 269_271_1_1_S269 phospho",
    "ITPKB 352_355_1_1_S355 phospho",
    "ITPKB 562_588_1_1_S588 phospho",
    "ITPKB 84_101_1_0 phospho",
    "ITPKB cnv",
    "ITPKB methyl",
    "ITPKB proteo",
    "ITPKB rna"
  ],
  "ITPKC": [
    "ITPKC cnv",
    "ITPKC methyl",
    "ITPKC proteo",
    "ITPKC rna"
  ],
  "ITPR1": [
    "ITPR1 1566_1568_1_1_S1568 phospho",
    "ITPR1 1716_1746_1_1_S1716 phospho",
    "ITPR1 VESGENCSSPAPR-N2H5F0S0G0 glyco",
    "ITPR1 VESGENCSSPAPR-N2H6F0S0G0 glyco",
    "ITPR1 cnv",
    "ITPR1 methyl",
    "ITPR1 proteo",
    "ITPR1 rna"
  ],
  "ITPR1-DT": [
    "ITPR1-DT methyl"
  ],
  "ITPR2": [
    "ITPR2 1855_1856_1_1_T1856 phospho",
    "ITPR2 cnv",
    "ITPR2 methyl",
    "ITPR2 proteo",
    "ITPR2 rna"
  ],
  "ITPR3": [
    "ITPR3 934_946_1_1_S934 phospho",
    "ITPR3 cnv",
    "ITPR3 methyl",
    "ITPR3 proteo",
    "ITPR3 rna"
  ],
  "ITPRID1": [
    "ITPRID1 cnv",
    "ITPRID1 rna"
  ],
  "ITPRID2": [
    "ITPRID2 111_128_1_1_S111 phospho",
    "ITPRID2 1152_1161_1_1_T1156 phospho",
    "ITPRID2 1163_1175_1_0 phospho",
    "ITPRID2 270_276_1_1_S270 phospho",
    "ITPRID2 270_287_1_0 phospho",
    "ITPRID2 309_320_2_2_S316S318 phospho",
    "ITPRID2 437_455_1_1_T442 phospho",
    "ITPRID2 461_491_1_1_S466 phospho",
    "ITPRID2 591_607_1_1_S593 phospho",
    "ITPRID2 641_644_1_1_S641 phospho",
    "ITPRID2 737_746_1_1_S737 phospho",
    "ITPRID2 737_746_2_2_S739S746 phospho",
    "ITPRID2 cnv",
    "ITPRID2 methyl",
    "ITPRID2 proteo",
    "ITPRID2 rna"
  ],
  "ITPRIP": [
    "ITPRIP cnv",
    "ITPRIP methyl",
    "ITPRIP proteo",
    "ITPRIP rna"
  ],
  "ITPRIPL1": [
    "ITPRIPL1 cnv",
    "ITPRIPL1 methyl",
    "ITPRIPL1 rna"
  ],
  "ITPRIPL2": [
    "ITPRIPL2 cnv",
    "ITPRIPL2 methyl",
    "ITPRIPL2 rna"
  ],
  "ITSN1": [
    "ITSN1 1066_1075_1_1_T1073 phospho",
    "ITSN1 1073_1075_1_1_T1073 phospho",
    "ITSN1 313_324_1_0 phospho",
    "ITSN1 559_567_1_1_S559 phospho",
    "ITSN1 891_904_1_1_S904 phospho",
    "ITSN1 976_989_1_0 phospho",
    "ITSN1 976_989_1_1_S978 phospho",
    "ITSN1 cnv",
    "ITSN1 methyl",
    "ITSN1 proteo",
    "ITSN1 rna"
  ],
  "ITSN2": [
    "ITSN2 196_216_1_1_S196 phospho",
    "ITSN2 868_875_1_1_S870 phospho",
    "ITSN2 868_875_1_1_S875 phospho",
    "ITSN2 868_875_2_2_S870S875 phospho",
    "ITSN2 cnv",
    "ITSN2 methyl",
    "ITSN2 proteo",
    "ITSN2 rna"
  ],
  "IVD": [
    "IVD cnv",
    "IVD proteo",
    "IVD rna"
  ],
  "IVL": [
    "IVL cnv",
    "IVL rna"
  ],
  "IVNS1ABP": [
    "IVNS1ABP 268_284_1_0 phospho",
    "IVNS1ABP 268_284_1_1_S277 phospho",
    "IVNS1ABP 322_330_1_1_S322 phospho",
    "IVNS1ABP 322_330_1_1_S326 phospho",
    "IVNS1ABP 336_338_1_1_S338 phospho",
    "IVNS1ABP 336_356_1_1_S338 phospho",
    "IVNS1ABP cnv",
    "IVNS1ABP proteo",
    "IVNS1ABP rna"
  ],
  "IWS1": [
    "IWS1 196_198_2_2_S196S198 phospho",
    "IWS1 25_44_1_1_S27 phospho",
    "IWS1 300_304_1_1_S300 phospho",
    "IWS1 313_321_2_2_S313S315 phospho",
    "IWS1 362_365_1_1_S363 phospho",
    "IWS1 362_365_1_1_S365 phospho",
    "IWS1 362_365_2_2_S363S365 phospho",
    "IWS1 362_365_3_3_S362S363S365 phospho",
    "IWS1 377_377_1_1_S377 phospho",
    "IWS1 398_400_1_1_S400 phospho",
    "IWS1 398_400_2_2_S398S400 phospho",
    "IWS1 398_407_2_2_S398S400 phospho",
    "IWS1 435_440_1_1_S440 phospho",
    "IWS1 435_440_2_2_S438S440 phospho",
    "IWS1 511_513_1_1_S513 phospho",
    "IWS1 511_513_2_2_S511S513 phospho",
    "IWS1 720_725_1_1_S720 phospho",
    "IWS1 cnv",
    "IWS1 methyl",
    "IWS1 proteo",
    "IWS1 rna"
  ],
  "IYD": [
    "IYD cnv",
    "IYD rna"
  ],
  "IZUMO1": [
    "IZUMO1 cnv",
    "IZUMO1 rna"
  ],
  "IZUMO1R": [
    "IZUMO1R cnv",
    "IZUMO1R rna"
  ],
  "IZUMO2": [
    "IZUMO2 cnv",
    "IZUMO2 methyl",
    "IZUMO2 rna"
  ],
  "IZUMO3": [
    "IZUMO3 cnv"
  ],
  "IZUMO4": [
    "IZUMO4 cnv",
    "IZUMO4 methyl",
    "IZUMO4 rna"
  ],
  "JADE1": [
    "JADE1 727_731_1_1_S731 phospho",
    "JADE1 cnv",
    "JADE1 methyl",
    "JADE1 rna"
  ],
  "JADE2": [
    "JADE2 cnv",
    "JADE2 methyl",
    "JADE2 proteo",
    "JADE2 rna"
  ],
  "JADE3": [
    "JADE3 556_575_1_1_S566 phospho",
    "JADE3 methyl",
    "JADE3 proteo",
    "JADE3 rna"
  ],
  "JAG1": [
    "JAG1 cnv",
    "JAG1 methyl",
    "JAG1 proteo",
    "JAG1 rna"
  ],
  "JAG2": [
    "JAG2 cnv",
    "JAG2 methyl",
    "JAG2 proteo",
    "JAG2 rna"
  ],
  "JAGN1": [
    "JAGN1 12_15_1_1_S15 phospho",
    "JAGN1 cnv",
    "JAGN1 methyl",
    "JAGN1 proteo",
    "JAGN1 rna"
  ],
  "JAK1": [
    "JAK1 cnv",
    "JAK1 kinase",
    "JAK1 methyl",
    "JAK1 proteo",
    "JAK1 rna"
  ],
  "JAK2": [
    "JAK2 514_530_1_1_S523 phospho",
    "JAK2 cnv",
    "JAK2 kinase",
    "JAK2 methyl",
    "JAK2 proteo",
    "JAK2 rna"
  ],
  "JAK3": [
    "JAK3 cnv",
    "JAK3 kinase",
    "JAK3 methyl",
    "JAK3 proteo",
    "JAK3 rna"
  ],
  "JAKMIP1": [
    "JAKMIP1 381_389_1_1_S382 phospho",
    "JAKMIP1 cnv",
    "JAKMIP1 methyl",
    "JAKMIP1 proteo",
    "JAKMIP1 rna"
  ],
  "JAKMIP2": [
    "JAKMIP2 273_278_1_1_S278 phospho",
    "JAKMIP2 376_389_1_1_S376 phospho",
    "JAKMIP2 cnv",
    "JAKMIP2 proteo",
    "JAKMIP2 rna"
  ],
  "JAKMIP3": [
    "JAKMIP3 cnv",
    "JAKMIP3 methyl",
    "JAKMIP3 rna"
  ],
  "JAM2": [
    "JAM2 283_286_1_1_S286 phospho",
    "JAM2 LGSQSTNSSYTMNTK-N2H5F0S0G0 glyco",
    "JAM2 LGSQSTNSSYTMNTK-N3H5F1S1G0 glyco",
    "JAM2 LGSQSTNSSYTMNTK-N3H5F2S0G0 glyco",
    "JAM2 LGSQSTNSSYTMNTK-N4H5F1S2G0 glyco",
    "JAM2 LGSQSTNSSYTMNTK-N4H5F2S1G0 glyco",
    "JAM2 cnv",
    "JAM2 methyl",
    "JAM2 proteo",
    "JAM2 rna"
  ],
  "JAM3": [
    "JAM3 cnv",
    "JAM3 methyl",
    "JAM3 proteo",
    "JAM3 rna"
  ],
  "JAML": [
    "JAML cnv",
    "JAML rna"
  ],
  "JARID2": [
    "JARID2 cnv",
    "JARID2 methyl",
    "JARID2 rna"
  ],
  "JAZF1": [
    "JAZF1 cnv",
    "JAZF1 rna"
  ],
  "JCAD": [
    "JCAD 1281_1281_1_1_S1281 phospho",
    "JCAD 1317_1321_1_1_S1319 phospho",
    "JCAD 200_200_1_1_S200 phospho",
    "JCAD 237_255_1_1_S255 phospho",
    "JCAD 348_377_1_1_S375 phospho",
    "JCAD 383_400_1_1_S400 phospho",
    "JCAD 542_556_1_1_S543 phospho",
    "JCAD 678_680_1_0 phospho",
    "JCAD 678_680_1_1_S680 phospho",
    "JCAD 686_702_1_0 phospho",
    "JCAD 686_702_1_1_S694 phospho",
    "JCAD 755_765_2_2_S755S757 phospho",
    "JCAD 767_776_1_1_S770 phospho",
    "JCAD 885_885_1_1_S885 phospho",
    "JCAD 901_901_1_1_S901 phospho",
    "JCAD cnv",
    "JCAD methyl",
    "JCAD proteo",
    "JCAD rna"
  ],
  "JCHAIN": [
    "JCHAIN ENISDPTSPLR-N4H5F0S1G0 glyco",
    "JCHAIN IIVPLNNRENISDPTSPLR-N3H4F1S1G0 glyco",
    "JCHAIN IIVPLNNRENISDPTSPLR-N3H5F1S1G0 glyco",
    "JCHAIN IIVPLNNRENISDPTSPLR-N4H5F0S1G0 glyco",
    "JCHAIN IIVPLNNRENISDPTSPLR-N4H5F0S2G0 glyco",
    "JCHAIN IIVPLNNRENISDPTSPLR-N4H5F1S1G0 glyco",
    "JCHAIN IIVPLNNRENISDPTSPLR-N4H5F1S2G0 glyco",
    "JCHAIN IIVPLNNRENISDPTSPLR-N5H5F0S0G0 glyco",
    "JCHAIN IIVPLNNRENISDPTSPLR-N5H5F0S1G0 glyco",
    "JCHAIN cnv",
    "JCHAIN proteo",
    "JCHAIN rna"
  ],
  "JDP2": [
    "JDP2 cnv",
    "JDP2 methyl",
    "JDP2 rna"
  ],
  "JHY": [
    "JHY cnv",
    "JHY methyl",
    "JHY rna"
  ],
  "JKAMP": [
    "JKAMP cnv",
    "JKAMP methyl",
    "JKAMP rna"
  ],
  "JMJD1C": [
    "JMJD1C 1003_1014_1_1_S1003 phospho",
    "JMJD1C 135_138_1_1_S135 phospho",
    "JMJD1C 435_440_1_1_S435 phospho",
    "JMJD1C 456_459_1_1_S459 phospho",
    "JMJD1C 468_473_1_1_S470 phospho",
    "JMJD1C 757_765_1_1_S761 phospho",
    "JMJD1C cnv",
    "JMJD1C methyl",
    "JMJD1C proteo",
    "JMJD1C rna"
  ],
  "JMJD4": [
    "JMJD4 cnv",
    "JMJD4 methyl",
    "JMJD4 rna"
  ],
  "JMJD6": [
    "JMJD6 cnv",
    "JMJD6 methyl",
    "JMJD6 proteo",
    "JMJD6 rna"
  ],
  "JMJD7": [
    "JMJD7 cnv",
    "JMJD7 methyl",
    "JMJD7 rna"
  ],
  "JMJD7-PLA2G4B": [
    "JMJD7-PLA2G4B cnv",
    "JMJD7-PLA2G4B methyl",
    "JMJD7-PLA2G4B rna"
  ],
  "JMJD8": [
    "JMJD8 TPEFHPNK-N2H8F0S0G0 glyco",
    "JMJD8 cnv",
    "JMJD8 methyl",
    "JMJD8 rna"
  ],
  "JMY": [
    "JMY 130_133_1_1_S130 phospho",
    "JMY 713_726_1_1_S713 phospho",
    "JMY 971_984_1_1_S974 phospho",
    "JMY cnv",
    "JMY methyl",
    "JMY proteo",
    "JMY rna"
  ],
  "JOSD1": [
    "JOSD1 13_27_1_1_S15 phospho",
    "JOSD1 cnv",
    "JOSD1 methyl",
    "JOSD1 rna"
  ],
  "JOSD2": [
    "JOSD2 cnv",
    "JOSD2 methyl",
    "JOSD2 proteo",
    "JOSD2 rna"
  ],
  "JPH1": [
    "JPH1 216_220_1_1_S216 phospho",
    "JPH1 460_469_3_3_T461S465S469 phospho",
    "JPH1 cnv",
    "JPH1 methyl",
    "JPH1 proteo",
    "JPH1 rna"
  ],
  "JPH2": [
    "JPH2 146_157_1_1_S157 phospho",
    "JPH2 477_490_1_1_T490 phospho",
    "JPH2 cnv",
    "JPH2 rna"
  ],
  "JPH3": [
    "JPH3 420_422_1_1_S420 phospho",
    "JPH3 cnv",
    "JPH3 methyl",
    "JPH3 rna"
  ],
  "JPH4": [
    "JPH4 146_157_1_1_S157 phospho",
    "JPH4 cnv",
    "JPH4 methyl",
    "JPH4 rna"
  ],
  "JPT1": [
    "JPT1 110_140_1_1_S131 phospho",
    "JPT1 131_140_1_1_S131 phospho",
    "JPT1 28_38_1_1_S31 phospho",
    "JPT1 49_61_1_1_T54 phospho",
    "JPT1 87_92_1_0 phospho",
    "JPT1 87_92_1_1_S87 phospho",
    "JPT1 87_92_1_1_S88 phospho",
    "JPT1 cnv",
    "JPT1 methyl",
    "JPT1 proteo",
    "JPT1 rna"
  ],
  "JPT2": [
    "JPT2 61_80_1_1_S69 phospho",
    "JPT2 cnv",
    "JPT2 methyl",
    "JPT2 proteo",
    "JPT2 rna"
  ],
  "JRK": [
    "JRK cnv",
    "JRK methyl",
    "JRK rna"
  ],
  "JRKL": [
    "JRKL cnv",
    "JRKL methyl",
    "JRKL rna"
  ],
  "JSRP1": [
    "JSRP1 cnv",
    "JSRP1 methyl",
    "JSRP1 rna"
  ],
  "JTB": [
    "JTB cnv",
    "JTB methyl",
    "JTB proteo",
    "JTB rna"
  ],
  "JUN": [
    "JUN 231_249_1_1_S243 phospho",
    "JUN 58_63_1_1_S58 phospho",
    "JUN 58_63_1_1_S63 phospho",
    "JUN 83_95_1_1_T93 phospho",
    "JUN cnv",
    "JUN methyl",
    "JUN proteo",
    "JUN rna"
  ],
  "JUNB": [
    "JUNB cnv",
    "JUNB methyl",
    "JUNB proteo",
    "JUNB rna"
  ],
  "JUND": [
    "JUND cnv",
    "JUND methyl",
    "JUND proteo",
    "JUND rna"
  ],
  "JUP": [
    "JUP 665_671_1_1_S665 phospho",
    "JUP cnv",
    "JUP methyl",
    "JUP proteo",
    "JUP rna"
  ],
  "KAAG1": [
    "KAAG1 cnv",
    "KAAG1 rna"
  ],
  "KALRN": [
    "KALRN 1799_1817_1_1_S1799 phospho",
    "KALRN 1799_1821_1_1_S1799 phospho",
    "KALRN cnv",
    "KALRN kinase",
    "KALRN methyl",
    "KALRN proteo",
    "KALRN rna"
  ],
  "KANK1": [
    "KANK1 186_202_1_1_S186 phospho",
    "KANK1 323_336_1_1_S325 phospho",
    "KANK1 cnv",
    "KANK1 methyl",
    "KANK1 proteo",
    "KANK1 rna"
  ],
  "KANK2": [
    "KANK2 375_375_1_1_S375 phospho",
    "KANK2 411_438_1_0 phospho",
    "KANK2 79_95_1_0 phospho",
    "KANK2 cnv",
    "KANK2 methyl",
    "KANK2 proteo",
    "KANK2 rna"
  ],
  "KANK3": [
    "KANK3 160_160_1_1_S160 phospho",
    "KANK3 167_177_1_1_S177 phospho",
    "KANK3 271_271_1_1_S271 phospho",
    "KANK3 280_300_1_1_S293 phospho",
    "KANK3 cnv",
    "KANK3 methyl",
    "KANK3 proteo",
    "KANK3 rna"
  ],
  "KANK4": [
    "KANK4 cnv",
    "KANK4 methyl",
    "KANK4 rna"
  ],
  "KANSL1": [
    "KANSL1 1039_1045_1_1_S1045 phospho",
    "KANSL1 1076_1082_1_1_S1082 phospho",
    "KANSL1 827_847_1_0 phospho",
    "KANSL1 cnv",
    "KANSL1 methyl",
    "KANSL1 rna"
  ],
  "KANSL1-AS1": [
    "KANSL1-AS1 methyl"
  ],
  "KANSL1L": [
    "KANSL1L cnv",
    "KANSL1L methyl",
    "KANSL1L rna"
  ],
  "KANSL2": [
    "KANSL2 cnv",
    "KANSL2 methyl",
    "KANSL2 proteo",
    "KANSL2 rna"
  ],
  "KANSL3": [
    "KANSL3 cnv",
    "KANSL3 methyl",
    "KANSL3 proteo",
    "KANSL3 rna"
  ],
  "KANTR": [
    "KANTR rna"
  ],
  "KARS1": [
    "KARS1 cnv",
    "KARS1 methyl",
    "KARS1 proteo",
    "KARS1 rna"
  ],
  "KASH5": [
    "KASH5 cnv",
    "KASH5 methyl",
    "KASH5 rna"
  ],
  "KAT14": [
    "KAT14 cnv",
    "KAT14 methyl",
    "KAT14 rna"
  ],
  "KAT2A": [
    "KAT2A cnv",
    "KAT2A methyl",
    "KAT2A rna"
  ],
  "KAT2B": [
    "KAT2B cnv",
    "KAT2B methyl",
    "KAT2B rna"
  ],
  "KAT5": [
    "KAT5 cnv",
    "KAT5 methyl",
    "KAT5 proteo",
    "KAT5 rna"
  ],
  "KAT6A": [
    "KAT6A 1861_1875_1_1_S1861 phospho",
    "KAT6A cnv",
    "KAT6A methyl",
    "KAT6A rna"
  ],
  "KAT6B": [
    "KAT6B cnv",
    "KAT6B methyl",
    "KAT6B rna"
  ],
  "KAT7": [
    "KAT7 50_74_1_1_S57 phospho",
    "KAT7 80_88_1_1_T88 phospho",
    "KAT7 cnv",
    "KAT7 methyl",
    "KAT7 proteo",
    "KAT7 rna"
  ],
  "KAT8": [
    "KAT8 cnv",
    "KAT8 methyl",
    "KAT8 proteo",
    "KAT8 rna"
  ],
  "KATNA1": [
    "KATNA1 cnv",
    "KATNA1 methyl",
    "KATNA1 proteo",
    "KATNA1 rna"
  ],
  "KATNAL1": [
    "KATNAL1 cnv",
    "KATNAL1 methyl",
    "KATNAL1 proteo",
    "KATNAL1 rna"
  ],
  "KATNAL2": [
    "KATNAL2 cnv",
    "KATNAL2 methyl",
    "KATNAL2 rna"
  ],
  "KATNB1": [
    "KATNB1 cnv",
    "KATNB1 methyl",
    "KATNB1 proteo",
    "KATNB1 rna"
  ],
  "KATNBL1": [
    "KATNBL1 cnv",
    "KATNBL1 methyl",
    "KATNBL1 rna"
  ],
  "KATNIP": [
    "KATNIP 660_665_1_1_S660 phospho",
    "KATNIP 691_698_1_1_S691 phospho",
    "KATNIP cnv",
    "KATNIP methyl",
    "KATNIP proteo",
    "KATNIP rna"
  ],
  "KAZALD1": [
    "KAZALD1 cnv",
    "KAZALD1 methyl",
    "KAZALD1 rna"
  ],
  "KAZN": [
    "KAZN 318_324_1_1_S318 phospho",
    "KAZN 344_352_1_1_S346 phospho",
    "KAZN 344_352_1_1_S352 phospho",
    "KAZN 344_352_2_2_S346S352 phospho",
    "KAZN 695_695_1_1_T695 phospho",
    "KAZN cnv",
    "KAZN methyl",
    "KAZN proteo",
    "KAZN rna"
  ],
  "KBTBD11": [
    "KBTBD11 107_107_1_1_S107 phospho",
    "KBTBD11 310_316_1_1_S314 phospho",
    "KBTBD11 310_328_1_1_S314 phospho",
    "KBTBD11 310_328_2_2_S310S314 phospho",
    "KBTBD11 82_93_1_1_S82 phospho",
    "KBTBD11 82_93_1_1_S87 phospho",
    "KBTBD11 82_93_2_2_S82S87 phospho",
    "KBTBD11 82_93_2_2_S87S93 phospho",
    "KBTBD11 cnv",
    "KBTBD11 methyl",
    "KBTBD11 proteo",
    "KBTBD11 rna"
  ],
  "KBTBD11-AS1": [
    "KBTBD11-AS1 methyl"
  ],
  "KBTBD11-OT1": [
    "KBTBD11-OT1 cnv",
    "KBTBD11-OT1 rna"
  ],
  "KBTBD12": [
    "KBTBD12 cnv",
    "KBTBD12 methyl",
    "KBTBD12 rna"
  ],
  "KBTBD13": [
    "KBTBD13 cnv",
    "KBTBD13 methyl",
    "KBTBD13 rna"
  ],
  "KBTBD2": [
    "KBTBD2 cnv",
    "KBTBD2 methyl",
    "KBTBD2 proteo",
    "KBTBD2 rna"
  ],
  "KBTBD3": [
    "KBTBD3 cnv",
    "KBTBD3 methyl",
    "KBTBD3 proteo",
    "KBTBD3 rna"
  ],
  "KBTBD4": [
    "KBTBD4 cnv",
    "KBTBD4 methyl",
    "KBTBD4 proteo",
    "KBTBD4 rna"
  ],
  "KBTBD6": [
    "KBTBD6 cnv",
    "KBTBD6 methyl",
    "KBTBD6 proteo",
    "KBTBD6 rna"
  ],
  "KBTBD7": [
    "KBTBD7 683_683_1_1_S683 phospho",
    "KBTBD7 cnv",
    "KBTBD7 methyl",
    "KBTBD7 rna"
  ],
  "KBTBD8": [
    "KBTBD8 cnv",
    "KBTBD8 methyl",
    "KBTBD8 rna"
  ],
  "KCMF1": [
    "KCMF1 212_225_1_0 phospho",
    "KCMF1 cnv",
    "KCMF1 methyl",
    "KCMF1 proteo",
    "KCMF1 rna"
  ],
  "KCNA1": [
    "KCNA1 cnv",
    "KCNA1 methyl",
    "KCNA1 proteo",
    "KCNA1 rna"
  ],
  "KCNA10": [
    "KCNA10 cnv",
    "KCNA10 rna"
  ],
  "KCNA2": [
    "KCNA2 440_441_1_1_S441 phospho",
    "KCNA2 440_441_2_2_S440S441 phospho",
    "KCNA2 456_468_1_1_S468 phospho",
    "KCNA2 cnv",
    "KCNA2 methyl",
    "KCNA2 proteo",
    "KCNA2 rna"
  ],
  "KCNA3": [
    "KCNA3 cnv",
    "KCNA3 methyl",
    "KCNA3 rna"
  ],
  "KCNA4": [
    "KCNA4 cnv",
    "KCNA4 methyl",
    "KCNA4 rna"
  ],
  "KCNA5": [
    "KCNA5 cnv",
    "KCNA5 methyl",
    "KCNA5 rna"
  ],
  "KCNA6": [
    "KCNA6 cnv",
    "KCNA6 methyl",
    "KCNA6 rna"
  ],
  "KCNA7": [
    "KCNA7 cnv",
    "KCNA7 methyl",
    "KCNA7 rna"
  ],
  "KCNAB1": [
    "KCNAB1 cnv",
    "KCNAB1 methyl",
    "KCNAB1 rna"
  ],
  "KCNAB2": [
    "KCNAB2 18_27_1_1_S20 phospho",
    "KCNAB2 cnv",
    "KCNAB2 methyl",
    "KCNAB2 proteo",
    "KCNAB2 rna"
  ],
  "KCNAB3": [
    "KCNAB3 cnv",
    "KCNAB3 methyl",
    "KCNAB3 rna"
  ],
  "KCNB1": [
    "KCNB1 484_484_1_1_S484 phospho",
    "KCNB1 539_547_1_1_S541 phospho",
    "KCNB1 720_737_2_2_T733S737 phospho",
    "KCNB1 733_737_1_1_T733 phospho",
    "KCNB1 799_805_1_1_S805 phospho",
    "KCNB1 cnv",
    "KCNB1 methyl",
    "KCNB1 proteo",
    "KCNB1 rna"
  ],
  "KCNB2": [
    "KCNB2 cnv",
    "KCNB2 methyl",
    "KCNB2 rna"
  ],
  "KCNC1": [
    "KCNC1 158_160_1_1_S160 phospho",
    "KCNC1 468_471_1_1_S468 phospho",
    "KCNC1 cnv",
    "KCNC1 methyl",
    "KCNC1 rna"
  ],
  "KCNC2": [
    "KCNC2 cnv",
    "KCNC2 methyl",
    "KCNC2 rna"
  ],
  "KCNC3": [
    "KCNC3 cnv",
    "KCNC3 methyl",
    "KCNC3 rna"
  ],
  "KCNC4": [
    "KCNC4 cnv",
    "KCNC4 methyl",
    "KCNC4 rna"
  ],
  "KCND1": [
    "KCND1 methyl",
    "KCND1 rna"
  ],
  "KCND2": [
    "KCND2 546_558_1_1_S552 phospho",
    "KCND2 546_558_2_2_S548S552 phospho",
    "KCND2 cnv",
    "KCND2 methyl",
    "KCND2 proteo",
    "KCND2 rna"
  ],
  "KCND3": [
    "KCND3 cnv",
    "KCND3 methyl",
    "KCND3 proteo",
    "KCND3 rna"
  ],
  "KCNE1": [
    "KCNE1 cnv",
    "KCNE1 methyl",
    "KCNE1 rna"
  ],
  "KCNE1B": [
    "KCNE1B cnv",
    "KCNE1B rna"
  ],
  "KCNE2": [
    "KCNE2 cnv",
    "KCNE2 rna"
  ],
  "KCNE3": [
    "KCNE3 cnv",
    "KCNE3 methyl",
    "KCNE3 rna"
  ],
  "KCNE4": [
    "KCNE4 cnv",
    "KCNE4 rna"
  ],
  "KCNE5": [
    "KCNE5 methyl",
    "KCNE5 rna"
  ],
  "KCNF1": [
    "KCNF1 cnv",
    "KCNF1 methyl",
    "KCNF1 rna"
  ],
  "KCNG1": [
    "KCNG1 cnv",
    "KCNG1 methyl",
    "KCNG1 rna"
  ],
  "KCNG2": [
    "KCNG2 cnv",
    "KCNG2 methyl",
    "KCNG2 rna"
  ],
  "KCNG3": [
    "KCNG3 cnv",
    "KCNG3 methyl",
    "KCNG3 rna"
  ],
  "KCNG4": [
    "KCNG4 cnv",
    "KCNG4 rna"
  ],
  "KCNH1": [
    "KCNH1 cnv",
    "KCNH1 methyl",
    "KCNH1 rna"
  ],
  "KCNH2": [
    "KCNH2 cnv",
    "KCNH2 methyl",
    "KCNH2 rna"
  ],
  "KCNH3": [
    "KCNH3 cnv",
    "KCNH3 methyl",
    "KCNH3 rna"
  ],
  "KCNH4": [
    "KCNH4 cnv",
    "KCNH4 methyl",
    "KCNH4 rna"
  ],
  "KCNH5": [
    "KCNH5 cnv",
    "KCNH5 methyl",
    "KCNH5 rna"
  ],
  "KCNH6": [
    "KCNH6 cnv",
    "KCNH6 methyl",
    "KCNH6 rna"
  ],
  "KCNH7": [
    "KCNH7 1161_1178_1_1_S1170 phospho",
    "KCNH7 1189_1189_1_1_S1189 phospho",
    "KCNH7 cnv",
    "KCNH7 rna"
  ],
  "KCNH8": [
    "KCNH8 cnv",
    "KCNH8 methyl",
    "KCNH8 rna"
  ],
  "KCNIP1": [
    "KCNIP1 cnv",
    "KCNIP1 methyl",
    "KCNIP1 proteo",
    "KCNIP1 rna"
  ],
  "KCNIP2": [
    "KCNIP2 cnv",
    "KCNIP2 methyl",
    "KCNIP2 rna"
  ],
  "KCNIP3": [
    "KCNIP3 11_25_1_1_S14 phospho",
    "KCNIP3 cnv",
    "KCNIP3 methyl",
    "KCNIP3 proteo",
    "KCNIP3 rna"
  ],
  "KCNIP4": [
    "KCNIP4 cnv",
    "KCNIP4 methyl",
    "KCNIP4 proteo",
    "KCNIP4 rna"
  ],
  "KCNJ1": [
    "KCNJ1 cnv",
    "KCNJ1 rna"
  ],
  "KCNJ10": [
    "KCNJ10 cnv",
    "KCNJ10 methyl",
    "KCNJ10 proteo",
    "KCNJ10 rna"
  ],
  "KCNJ11": [
    "KCNJ11 cnv",
    "KCNJ11 methyl",
    "KCNJ11 rna"
  ],
  "KCNJ12": [
    "KCNJ12 cnv",
    "KCNJ12 methyl",
    "KCNJ12 rna"
  ],
  "KCNJ13": [
    "KCNJ13 cnv",
    "KCNJ13 rna"
  ],
  "KCNJ14": [
    "KCNJ14 cnv",
    "KCNJ14 rna"
  ],
  "KCNJ15": [
    "KCNJ15 cnv",
    "KCNJ15 rna"
  ],
  "KCNJ16": [
    "KCNJ16 cnv",
    "KCNJ16 rna"
  ],
  "KCNJ18": [
    "KCNJ18 cnv",
    "KCNJ18 rna"
  ],
  "KCNJ2": [
    "KCNJ2 cnv",
    "KCNJ2 methyl",
    "KCNJ2 rna"
  ],
  "KCNJ2-AS1": [
    "KCNJ2-AS1 methyl"
  ],
  "KCNJ3": [
    "KCNJ3 cnv",
    "KCNJ3 methyl",
    "KCNJ3 rna"
  ],
  "KCNJ4": [
    "KCNJ4 cnv",
    "KCNJ4 methyl",
    "KCNJ4 rna"
  ],
  "KCNJ5": [
    "KCNJ5 cnv",
    "KCNJ5 methyl",
    "KCNJ5 rna"
  ],
  "KCNJ5-AS1": [
    "KCNJ5-AS1 cnv",
    "KCNJ5-AS1 rna"
  ],
  "KCNJ6": [
    "KCNJ6 cnv",
    "KCNJ6 methyl",
    "KCNJ6 rna"
  ],
  "KCNJ8": [
    "KCNJ8 cnv",
    "KCNJ8 methyl",
    "KCNJ8 rna"
  ],
  "KCNJ9": [
    "KCNJ9 cnv",
    "KCNJ9 rna"
  ],
  "KCNK1": [
    "KCNK1 cnv",
    "KCNK1 methyl",
    "KCNK1 proteo",
    "KCNK1 rna"
  ],
  "KCNK10": [
    "KCNK10 388_393_1_1_S388 phospho",
    "KCNK10 cnv",
    "KCNK10 methyl",
    "KCNK10 rna"
  ],
  "KCNK12": [
    "KCNK12 cnv",
    "KCNK12 methyl",
    "KCNK12 rna"
  ],
  "KCNK13": [
    "KCNK13 cnv",
    "KCNK13 methyl",
    "KCNK13 rna"
  ],
  "KCNK15": [
    "KCNK15 cnv",
    "KCNK15 methyl",
    "KCNK15 rna"
  ],
  "KCNK16": [
    "KCNK16 cnv",
    "KCNK16 rna"
  ],
  "KCNK17": [
    "KCNK17 cnv",
    "KCNK17 methyl",
    "KCNK17 rna"
  ],
  "KCNK18": [
    "KCNK18 cnv",
    "KCNK18 rna"
  ],
  "KCNK2": [
    "KCNK2 cnv",
    "KCNK2 methyl",
    "KCNK2 rna"
  ],
  "KCNK3": [
    "KCNK3 cnv",
    "KCNK3 rna"
  ],
  "KCNK4": [
    "KCNK4 cnv",
    "KCNK4 methyl",
    "KCNK4 rna"
  ],
  "KCNK4-TEX40": [
    "KCNK4-TEX40 methyl"
  ],
  "KCNK5": [
    "KCNK5 cnv",
    "KCNK5 methyl",
    "KCNK5 rna"
  ],
  "KCNK6": [
    "KCNK6 cnv",
    "KCNK6 methyl",
    "KCNK6 rna"
  ],
  "KCNK7": [
    "KCNK7 cnv",
    "KCNK7 rna"
  ],
  "KCNK9": [
    "KCNK9 cnv",
    "KCNK9 methyl",
    "KCNK9 rna"
  ],
  "KCNMA1": [
    "KCNMA1 1161_1173_1_1_S1161 phospho",
    "KCNMA1 544_556_1_1_S556 phospho",
    "KCNMA1 708_711_1_1_S711 phospho",
    "KCNMA1 724_728_2_2_S724S728 phospho",
    "KCNMA1 cnv",
    "KCNMA1 methyl",
    "KCNMA1 proteo",
    "KCNMA1 rna"
  ],
  "KCNMB1": [
    "KCNMB1 cnv",
    "KCNMB1 rna"
  ],
  "KCNMB2": [
    "KCNMB2 cnv",
    "KCNMB2 rna"
  ],
  "KCNMB3": [
    "KCNMB3 cnv",
    "KCNMB3 rna"
  ],
  "KCNMB4": [
    "KCNMB4 cnv",
    "KCNMB4 methyl",
    "KCNMB4 proteo",
    "KCNMB4 rna"
  ],
  "KCNN1": [
    "KCNN1 cnv",
    "KCNN1 methyl",
    "KCNN1 rna"
  ],
  "KCNN2": [
    "KCNN2 cnv",
    "KCNN2 methyl",
    "KCNN2 rna"
  ],
  "KCNN3": [
    "KCNN3 159_159_1_1_S159 phospho",
    "KCNN3 167_177_1_1_S167 phospho",
    "KCNN3 637_647_1_1_S637 phospho",
    "KCNN3 cnv",
    "KCNN3 proteo",
    "KCNN3 rna"
  ],
  "KCNN4": [
    "KCNN4 cnv",
    "KCNN4 methyl",
    "KCNN4 rna"
  ],
  "KCNQ1": [
    "KCNQ1 27_27_1_1_S27 phospho",
    "KCNQ1 cnv",
    "KCNQ1 methyl",
    "KCNQ1 rna"
  ],
  "KCNQ1DN": [
    "KCNQ1DN methyl"
  ],
  "KCNQ1OT1": [
    "KCNQ1OT1 methyl"
  ],
  "KCNQ2": [
    "KCNQ2 438_450_1_1_S438 phospho",
    "KCNQ2 479_483_1_1_S479 phospho",
    "KCNQ2 642_648_1_1_S644 phospho",
    "KCNQ2 702_710_1_1_S703 phospho",
    "KCNQ2 805_819_1_1_S811 phospho",
    "KCNQ2 cnv",
    "KCNQ2 methyl",
    "KCNQ2 proteo",
    "KCNQ2 rna"
  ],
  "KCNQ3": [
    "KCNQ3 639_655_1_1_S655 phospho",
    "KCNQ3 cnv",
    "KCNQ3 methyl",
    "KCNQ3 rna"
  ],
  "KCNQ4": [
    "KCNQ4 cnv",
    "KCNQ4 methyl",
    "KCNQ4 rna"
  ],
  "KCNQ5": [
    "KCNQ5 402_406_1_1_S404 phospho",
    "KCNQ5 447_459_1_1_S457 phospho",
    "KCNQ5 cnv",
    "KCNQ5 methyl",
    "KCNQ5 rna"
  ],
  "KCNRG": [
    "KCNRG cnv",
    "KCNRG methyl",
    "KCNRG rna"
  ],
  "KCNS1": [
    "KCNS1 cnv",
    "KCNS1 methyl",
    "KCNS1 rna"
  ],
  "KCNS2": [
    "KCNS2 cnv",
    "KCNS2 methyl",
    "KCNS2 rna"
  ],
  "KCNS3": [
    "KCNS3 cnv",
    "KCNS3 methyl",
    "KCNS3 rna"
  ],
  "KCNT1": [
    "KCNT1 cnv",
    "KCNT1 methyl",
    "KCNT1 rna"
  ],
  "KCNT2": [
    "KCNT2 cnv",
    "KCNT2 methyl",
    "KCNT2 rna"
  ],
  "KCNU1": [
    "KCNU1 cnv",
    "KCNU1 rna"
  ],
  "KCNV1": [
    "KCNV1 cnv",
    "KCNV1 methyl",
    "KCNV1 rna"
  ],
  "KCNV2": [
    "KCNV2 cnv",
    "KCNV2 rna"
  ],
  "KCP": [
    "KCP cnv",
    "KCP methyl",
    "KCP rna"
  ],
  "KCTD1": [
    "KCTD1 617_634_1_1_S620 phospho",
    "KCTD1 cnv",
    "KCTD1 methyl",
    "KCTD1 proteo",
    "KCTD1 rna"
  ],
  "KCTD10": [
    "KCTD10 cnv",
    "KCTD10 methyl",
    "KCTD10 proteo",
    "KCTD10 rna"
  ],
  "KCTD11": [
    "KCTD11 cnv",
    "KCTD11 methyl",
    "KCTD11 rna"
  ],
  "KCTD12": [
    "KCTD12 151_183_1_1_S151 phospho",
    "KCTD12 151_183_2_2_S151S176 phospho",
    "KCTD12 185_204_1_1_S185 phospho",
    "KCTD12 185_204_1_1_S187 phospho",
    "KCTD12 185_204_1_1_S200 phospho",
    "KCTD12 185_204_2_2_T196S200 phospho",
    "KCTD12 252_256_1_1_S256 phospho",
    "KCTD12 cnv",
    "KCTD12 methyl",
    "KCTD12 proteo",
    "KCTD12 rna"
  ],
  "KCTD13": [
    "KCTD13 cnv",
    "KCTD13 methyl",
    "KCTD13 proteo",
    "KCTD13 rna"
  ],
  "KCTD14": [
    "KCTD14 cnv",
    "KCTD14 rna"
  ],
  "KCTD15": [
    "KCTD15 cnv",
    "KCTD15 methyl",
    "KCTD15 proteo",
    "KCTD15 rna"
  ],
  "KCTD16": [
    "KCTD16 123_148_1_1_S130 phospho",
    "KCTD16 cnv",
    "KCTD16 methyl",
    "KCTD16 proteo",
    "KCTD16 rna"
  ],
  "KCTD17": [
    "KCTD17 cnv",
    "KCTD17 methyl",
    "KCTD17 proteo",
    "KCTD17 rna"
  ],
  "KCTD18": [
    "KCTD18 cnv",
    "KCTD18 rna"
  ],
  "KCTD19": [
    "KCTD19 cnv",
    "KCTD19 rna"
  ],
  "KCTD2": [
    "KCTD2 cnv",
    "KCTD2 methyl",
    "KCTD2 proteo",
    "KCTD2 rna"
  ],
  "KCTD20": [
    "KCTD20 cnv",
    "KCTD20 methyl",
    "KCTD20 proteo",
    "KCTD20 rna"
  ],
  "KCTD21": [
    "KCTD21 cnv",
    "KCTD21 methyl",
    "KCTD21 proteo",
    "KCTD21 rna"
  ],
  "KCTD21-AS1": [
    "KCTD21-AS1 methyl"
  ],
  "KCTD3": [
    "KCTD3 660_666_1_1_S662 phospho",
    "KCTD3 709_709_1_1_S709 phospho",
    "KCTD3 cnv",
    "KCTD3 methyl",
    "KCTD3 proteo",
    "KCTD3 rna"
  ],
  "KCTD4": [
    "KCTD4 cnv",
    "KCTD4 proteo",
    "KCTD4 rna"
  ],
  "KCTD5": [
    "KCTD5 cnv",
    "KCTD5 methyl",
    "KCTD5 proteo",
    "KCTD5 rna"
  ],
  "KCTD6": [
    "KCTD6 cnv",
    "KCTD6 methyl",
    "KCTD6 proteo",
    "KCTD6 rna"
  ],
  "KCTD7": [
    "KCTD7 cnv",
    "KCTD7 methyl",
    "KCTD7 proteo",
    "KCTD7 rna"
  ],
  "KCTD8": [
    "KCTD8 328_328_1_1_S328 phospho",
    "KCTD8 410_418_1_1_S410 phospho",
    "KCTD8 60_78_1_1_S78 phospho",
    "KCTD8 cnv",
    "KCTD8 methyl",
    "KCTD8 proteo",
    "KCTD8 rna"
  ],
  "KCTD9": [
    "KCTD9 cnv",
    "KCTD9 methyl",
    "KCTD9 proteo",
    "KCTD9 rna"
  ],
  "KDELR1": [
    "KDELR1 cnv",
    "KDELR1 rna"
  ],
  "KDELR2": [
    "KDELR2 cnv",
    "KDELR2 methyl",
    "KDELR2 rna"
  ],
  "KDELR3": [
    "KDELR3 cnv",
    "KDELR3 methyl",
    "KDELR3 rna"
  ],
  "KDF1": [
    "KDF1 cnv",
    "KDF1 methyl",
    "KDF1 rna"
  ],
  "KDM1A": [
    "KDM1A 126_137_1_1_S131 phospho",
    "KDM1A 166_181_1_1_S166 phospho",
    "KDM1A 69_104_1_1_S69 phospho",
    "KDM1A 847_857_1_1_S855 phospho",
    "KDM1A cnv",
    "KDM1A methyl",
    "KDM1A proteo",
    "KDM1A rna"
  ],
  "KDM1B": [
    "KDM1B 13_20_1_1_S17 phospho",
    "KDM1B cnv",
    "KDM1B methyl",
    "KDM1B proteo",
    "KDM1B rna"
  ],
  "KDM2A": [
    "KDM2A 22_28_1_1_S28 phospho",
    "KDM2A 692_692_1_1_S692 phospho",
    "KDM2A cnv",
    "KDM2A methyl",
    "KDM2A proteo",
    "KDM2A rna"
  ],
  "KDM2B": [
    "KDM2B cnv",
    "KDM2B methyl",
    "KDM2B proteo",
    "KDM2B rna"
  ],
  "KDM3A": [
    "KDM3A 445_450_1_1_S445 phospho",
    "KDM3A 461_468_1_1_S463 phospho",
    "KDM3A cnv",
    "KDM3A methyl",
    "KDM3A proteo",
    "KDM3A rna"
  ],
  "KDM3B": [
    "KDM3B 1251_1263_1_1_S1253 phospho",
    "KDM3B 278_278_1_1_S278 phospho",
    "KDM3B 725_751_1_0 phospho",
    "KDM3B 725_751_1_1_S727 phospho",
    "KDM3B 725_751_2_0 phospho",
    "KDM3B 773_784_1_1_S779 phospho",
    "KDM3B cnv",
    "KDM3B methyl",
    "KDM3B proteo",
    "KDM3B rna"
  ],
  "KDM4A": [
    "KDM4A cnv",
    "KDM4A methyl",
    "KDM4A proteo",
    "KDM4A rna"
  ],
  "KDM4B": [
    "KDM4B cnv",
    "KDM4B methyl",
    "KDM4B proteo",
    "KDM4B rna"
  ],
  "KDM4C": [
    "KDM4C cnv",
    "KDM4C methyl",
    "KDM4C rna"
  ],
  "KDM4D": [
    "KDM4D cnv",
    "KDM4D methyl",
    "KDM4D rna"
  ],
  "KDM4E": [
    "KDM4E cnv",
    "KDM4E rna"
  ],
  "KDM4F": [
    "KDM4F cnv"
  ],
  "KDM5A": [
    "KDM5A cnv",
    "KDM5A methyl",
    "KDM5A proteo",
    "KDM5A rna"
  ],
  "KDM5B": [
    "KDM5B cnv",
    "KDM5B methyl",
    "KDM5B rna"
  ],
  "KDM5C": [
    "KDM5C 223_239_1_1_S234 phospho",
    "KDM5C methyl",
    "KDM5C proteo",
    "KDM5C rna"
  ],
  "KDM5D": [
    "KDM5D rna"
  ],
  "KDM6A": [
    "KDM6A methyl",
    "KDM6A proteo",
    "KDM6A rna"
  ],
  "KDM6B": [
    "KDM6B cnv",
    "KDM6B methyl",
    "KDM6B rna"
  ],
  "KDM7A": [
    "KDM7A cnv",
    "KDM7A methyl",
    "KDM7A rna"
  ],
  "KDM7A-DT": [
    "KDM7A-DT methyl"
  ],
  "KDM8": [
    "KDM8 cnv",
    "KDM8 methyl",
    "KDM8 proteo",
    "KDM8 rna"
  ],
  "KDR": [
    "KDR cnv",
    "KDR kinase",
    "KDR methyl",
    "KDR rna"
  ],
  "KDSR": [
    "KDSR cnv",
    "KDSR methyl",
    "KDSR proteo",
    "KDSR rna"
  ],
  "KEAP1": [
    "KEAP1 cnv",
    "KEAP1 methyl",
    "KEAP1 proteo",
    "KEAP1 rna"
  ],
  "KEL": [
    "KEL cnv",
    "KEL rna"
  ],
  "KERA": [
    "KERA cnv",
    "KERA rna"
  ],
  "KHDC1": [
    "KHDC1 cnv",
    "KHDC1 methyl",
    "KHDC1 rna"
  ],
  "KHDC1L": [
    "KHDC1L cnv",
    "KHDC1L rna"
  ],
  "KHDC3L": [
    "KHDC3L cnv",
    "KHDC3L rna"
  ],
  "KHDC4": [
    "KHDC4 cnv",
    "KHDC4 methyl",
    "KHDC4 proteo",
    "KHDC4 rna"
  ],
  "KHDRBS1": [
    "KHDRBS1 18_29_1_1_S29 phospho",
    "KHDRBS1 cnv",
    "KHDRBS1 methyl",
    "KHDRBS1 proteo",
    "KHDRBS1 rna"
  ],
  "KHDRBS2": [
    "KHDRBS2 cnv",
    "KHDRBS2 methyl",
    "KHDRBS2 rna"
  ],
  "KHDRBS3": [
    "KHDRBS3 cnv",
    "KHDRBS3 methyl",
    "KHDRBS3 proteo",
    "KHDRBS3 rna"
  ],
  "KHK": [
    "KHK cnv",
    "KHK methyl",
    "KHK proteo",
    "KHK rna"
  ],
  "KHNYN": [
    "KHNYN 10_17_1_1_S10 phospho",
    "KHNYN 3_17_1_1_S10 phospho",
    "KHNYN cnv",
    "KHNYN methyl",
    "KHNYN proteo",
    "KHNYN rna"
  ],
  "KHSRP": [
    "KHSRP 181_184_1_1_S181 phospho",
    "KHSRP 191_200_1_1_S193 phospho",
    "KHSRP 480_480_1_1_S480 phospho",
    "KHSRP 94_100_1_0 phospho",
    "KHSRP 94_100_1_1_T100 phospho",
    "KHSRP cnv",
    "KHSRP methyl",
    "KHSRP proteo",
    "KHSRP rna"
  ],
  "KIAA0040": [
    "KIAA0040 cnv",
    "KIAA0040 methyl",
    "KIAA0040 rna"
  ],
  "KIAA0232": [
    "KIAA0232 807_822_1_1_S814 phospho",
    "KIAA0232 cnv",
    "KIAA0232 methyl",
    "KIAA0232 proteo",
    "KIAA0232 rna"
  ],
  "KIAA0319": [
    "KIAA0319 cnv",
    "KIAA0319 methyl",
    "KIAA0319 rna"
  ],
  "KIAA0319L": [
    "KIAA0319L cnv",
    "KIAA0319L methyl",
    "KIAA0319L proteo",
    "KIAA0319L rna"
  ],
  "KIAA0408": [
    "KIAA0408 cnv",
    "KIAA0408 rna"
  ],
  "KIAA0513": [
    "KIAA0513 276_279_1_1_S279 phospho",
    "KIAA0513 cnv",
    "KIAA0513 methyl",
    "KIAA0513 proteo",
    "KIAA0513 rna"
  ],
  "KIAA0586": [
    "KIAA0586 251_251_1_1_S251 phospho",
    "KIAA0586 cnv",
    "KIAA0586 methyl",
    "KIAA0586 rna"
  ],
  "KIAA0753": [
    "KIAA0753 cnv",
    "KIAA0753 methyl",
    "KIAA0753 rna"
  ],
  "KIAA0825": [
    "KIAA0825 cnv",
    "KIAA0825 methyl",
    "KIAA0825 rna"
  ],
  "KIAA0895": [
    "KIAA0895 cnv",
    "KIAA0895 methyl",
    "KIAA0895 rna"
  ],
  "KIAA0895L": [
    "KIAA0895L cnv",
    "KIAA0895L methyl",
    "KIAA0895L rna"
  ],
  "KIAA0930": [
    "KIAA0930 262_279_1_1_S267 phospho",
    "KIAA0930 cnv",
    "KIAA0930 methyl",
    "KIAA0930 proteo",
    "KIAA0930 rna"
  ],
  "KIAA1143": [
    "KIAA1143 142_146_1_1_S146 phospho",
    "KIAA1143 50_50_1_1_S50 phospho",
    "KIAA1143 cnv",
    "KIAA1143 methyl",
    "KIAA1143 proteo",
    "KIAA1143 rna"
  ],
  "KIAA1191": [
    "KIAA1191 13_33_1_1_T25 phospho",
    "KIAA1191 152_164_1_1_S164 phospho",
    "KIAA1191 152_164_2_2_T160S164 phospho",
    "KIAA1191 cnv",
    "KIAA1191 methyl",
    "KIAA1191 proteo",
    "KIAA1191 rna"
  ],
  "KIAA1210": [
    "KIAA1210 methyl",
    "KIAA1210 rna"
  ],
  "KIAA1217": [
    "KIAA1217 1027_1033_1_1_S1030 phospho",
    "KIAA1217 1044_1044_1_1_S1044 phospho",
    "KIAA1217 1084_1094_1_1_S1085 phospho",
    "KIAA1217 1786_1800_1_1_S1794 phospho",
    "KIAA1217 302_328_1_1_S313 phospho",
    "KIAA1217 458_474_1_1_T470 phospho",
    "KIAA1217 458_474_2_2_T470S474 phospho",
    "KIAA1217 cnv",
    "KIAA1217 methyl",
    "KIAA1217 proteo",
    "KIAA1217 rna"
  ],
  "KIAA1328": [
    "KIAA1328 478_486_1_1_S480 phospho",
    "KIAA1328 cnv",
    "KIAA1328 methyl",
    "KIAA1328 proteo",
    "KIAA1328 rna"
  ],
  "KIAA1522": [
    "KIAA1522 545_545_1_1_S545 phospho",
    "KIAA1522 cnv",
    "KIAA1522 methyl",
    "KIAA1522 proteo",
    "KIAA1522 rna"
  ],
  "KIAA1549": [
    "KIAA1549 1385_1395_1_1_S1395 phospho",
    "KIAA1549 1503_1503_1_1_S1503 phospho",
    "KIAA1549 1545_1558_1_1_S1554 phospho",
    "KIAA1549 cnv",
    "KIAA1549 methyl",
    "KIAA1549 proteo",
    "KIAA1549 rna"
  ],
  "KIAA1549L": [
    "KIAA1549L 1310_1310_1_1_S1310 phospho",
    "KIAA1549L 1333_1346_1_1_S1333 phospho",
    "KIAA1549L 1646_1653_1_1_S1653 phospho",
    "KIAA1549L 1657_1663_1_1_S1659 phospho",
    "KIAA1549L cnv",
    "KIAA1549L methyl",
    "KIAA1549L proteo",
    "KIAA1549L rna"
  ],
  "KIAA1586": [
    "KIAA1586 cnv",
    "KIAA1586 methyl",
    "KIAA1586 rna"
  ],
  "KIAA1614": [
    "KIAA1614 1026_1043_1_1_S1028 phospho",
    "KIAA1614 1047_1057_2_2_S1047S1055 phospho",
    "KIAA1614 1065_1075_1_1_S1065 phospho",
    "KIAA1614 962_972_1_1_S964 phospho",
    "KIAA1614 cnv",
    "KIAA1614 methyl",
    "KIAA1614 rna"
  ],
  "KIAA1671": [
    "KIAA1671 1019_1019_1_1_S1019 phospho",
    "KIAA1671 1363_1369_1_1_S1366 phospho",
    "KIAA1671 1441_1443_1_1_S1441 phospho",
    "KIAA1671 1701_1708_1_1_S1701 phospho",
    "KIAA1671 1800_1802_1_1_S1800 phospho",
    "KIAA1671 448_467_1_1_S465 phospho",
    "KIAA1671 633_635_1_1_T635 phospho",
    "KIAA1671 745_749_1_1_S749 phospho",
    "KIAA1671 cnv",
    "KIAA1671 methyl",
    "KIAA1671 proteo",
    "KIAA1671 rna"
  ],
  "KIAA1755": [
    "KIAA1755 cnv",
    "KIAA1755 methyl",
    "KIAA1755 proteo",
    "KIAA1755 rna"
  ],
  "KIAA1958": [
    "KIAA1958 cnv",
    "KIAA1958 methyl",
    "KIAA1958 rna"
  ],
  "KIAA2012": [
    "KIAA2012 cnv",
    "KIAA2012 rna"
  ],
  "KIAA2013": [
    "KIAA2013 cnv",
    "KIAA2013 proteo",
    "KIAA2013 rna"
  ],
  "KIAA2026": [
    "KIAA2026 cnv",
    "KIAA2026 methyl",
    "KIAA2026 rna"
  ],
  "KICS2": [
    "KICS2 cnv",
    "KICS2 methyl",
    "KICS2 rna"
  ],
  "KIDINS220": [
    "KIDINS220 1358_1374_1_0 phospho",
    "KIDINS220 1358_1374_2_2_S1360S1363 phospho",
    "KIDINS220 1411_1430_1_1_S1412 phospho",
    "KIDINS220 1517_1535_1_1_S1522 phospho",
    "KIDINS220 1522_1535_1_0 phospho",
    "KIDINS220 1632_1634_1_1_S1634 phospho",
    "KIDINS220 1653_1663_1_0 phospho",
    "KIDINS220 1653_1663_1_1_S1663 phospho",
    "KIDINS220 919_923_1_1_S919 phospho",
    "KIDINS220 cnv",
    "KIDINS220 methyl",
    "KIDINS220 proteo",
    "KIDINS220 rna"
  ],
  "KIF11": [
    "KIF11 cnv",
    "KIF11 methyl",
    "KIF11 proteo",
    "KIF11 rna"
  ],
  "KIF12": [
    "KIF12 cnv",
    "KIF12 methyl",
    "KIF12 rna"
  ],
  "KIF13A": [
    "KIF13A 1369_1386_1_1_S1371 phospho",
    "KIF13A 1648_1659_1_1_S1650 phospho",
    "KIF13A cnv",
    "KIF13A methyl",
    "KIF13A proteo",
    "KIF13A rna"
  ],
  "KIF13B": [
    "KIF13B 1379_1382_1_1_S1379 phospho",
    "KIF13B 1644_1644_1_1_S1644 phospho",
    "KIF13B 1791_1805_1_1_S1797 phospho",
    "KIF13B 1791_1805_1_1_T1793 phospho",
    "KIF13B cnv",
    "KIF13B methyl",
    "KIF13B proteo",
    "KIF13B rna"
  ],
  "KIF14": [
    "KIF14 cnv",
    "KIF14 methyl",
    "KIF14 rna"
  ],
  "KIF15": [
    "KIF15 568_568_1_1_S568 phospho",
    "KIF15 cnv",
    "KIF15 methyl",
    "KIF15 proteo",
    "KIF15 rna"
  ],
  "KIF16B": [
    "KIF16B cnv",
    "KIF16B methyl",
    "KIF16B proteo",
    "KIF16B rna"
  ],
  "KIF17": [
    "KIF17 cnv",
    "KIF17 methyl",
    "KIF17 rna"
  ],
  "KIF18A": [
    "KIF18A cnv",
    "KIF18A rna"
  ],
  "KIF18B": [
    "KIF18B 674_686_1_1_S674 phospho",
    "KIF18B cnv",
    "KIF18B methyl",
    "KIF18B proteo",
    "KIF18B rna"
  ],
  "KIF19": [
    "KIF19 cnv",
    "KIF19 methyl",
    "KIF19 rna"
  ],
  "KIF1A": [
    "KIF1A 1423_1438_1_1_S1438 phospho",
    "KIF1A 1469_1471_1_1_S1471 phospho",
    "KIF1A 1568_1580_1_0 phospho",
    "KIF1A 1624_1644_1_1_S1633 phospho",
    "KIF1A 1624_1644_2_2_S1629S1633 phospho",
    "KIF1A 425_428_1_1_S428 phospho",
    "KIF1A cnv",
    "KIF1A methyl",
    "KIF1A proteo",
    "KIF1A rna"
  ],
  "KIF1B": [
    "KIF1B 1024_1035_1_1_T1029 phospho",
    "KIF1B 1051_1053_1_1_S1053 phospho",
    "KIF1B 1141_1141_1_1_S1141 phospho",
    "KIF1B 1404_1408_1_1_S1408 phospho",
    "KIF1B 1441_1441_1_1_S1441 phospho",
    "KIF1B 663_669_2_2_S663S665 phospho",
    "KIF1B 846_847_1_1_S847 phospho",
    "KIF1B cnv",
    "KIF1B methyl",
    "KIF1B proteo",
    "KIF1B rna"
  ],
  "KIF1C": [
    "KIF1C 1033_1033_1_1_S1033 phospho",
    "KIF1C 1092_1092_1_1_S1092 phospho",
    "KIF1C cnv",
    "KIF1C methyl",
    "KIF1C proteo",
    "KIF1C rna"
  ],
  "KIF20A": [
    "KIF20A 528_534_1_1_S532 phospho",
    "KIF20A cnv",
    "KIF20A methyl",
    "KIF20A proteo",
    "KIF20A rna"
  ],
  "KIF20B": [
    "KIF20B cnv",
    "KIF20B methyl",
    "KIF20B rna"
  ],
  "KIF21A": [
    "KIF21A 1212_1219_1_1_S1212 phospho",
    "KIF21A 1239_1242_1_1_S1239 phospho",
    "KIF21A 1261_1278_2_1_S1271 phospho",
    "KIF21A 1261_1278_2_2_S1271S1275 phospho",
    "KIF21A 1291_1312_1_1_S1307 phospho",
    "KIF21A 1662_1673_1_1_S1662 phospho",
    "KIF21A 1662_1673_1_1_S1673 phospho",
    "KIF21A 516_530_1_1_S524 phospho",
    "KIF21A 853_874_1_0 phospho",
    "KIF21A cnv",
    "KIF21A methyl",
    "KIF21A proteo",
    "KIF21A rna"
  ],
  "KIF21B": [
    "KIF21B 1149_1161_1_1_S1149 phospho",
    "KIF21B 1231_1244_1_0 phospho",
    "KIF21B cnv",
    "KIF21B methyl",
    "KIF21B proteo",
    "KIF21B rna"
  ],
  "KIF22": [
    "KIF22 cnv",
    "KIF22 methyl",
    "KIF22 proteo",
    "KIF22 rna"
  ],
  "KIF23": [
    "KIF23 cnv",
    "KIF23 methyl",
    "KIF23 rna"
  ],
  "KIF23-AS1": [
    "KIF23-AS1 methyl"
  ],
  "KIF24": [
    "KIF24 cnv",
    "KIF24 methyl",
    "KIF24 rna"
  ],
  "KIF25": [
    "KIF25 cnv",
    "KIF25 methyl",
    "KIF25 rna"
  ],
  "KIF26A": [
    "KIF26A cnv",
    "KIF26A methyl",
    "KIF26A rna"
  ],
  "KIF26B": [
    "KIF26B 1004_1021_1_1_S1006 phospho",
    "KIF26B 1713_1724_1_1_S1717 phospho",
    "KIF26B 1762_1773_1_1_S1773 phospho",
    "KIF26B cnv",
    "KIF26B methyl",
    "KIF26B proteo",
    "KIF26B rna"
  ],
  "KIF27": [
    "KIF27 845_848_1_1_S845 phospho",
    "KIF27 cnv",
    "KIF27 methyl",
    "KIF27 rna"
  ],
  "KIF2A": [
    "KIF2A 121_140_1_1_S140 phospho",
    "KIF2A 207_215_1_1_S207 phospho",
    "KIF2A 556_586_1_1_S573 phospho",
    "KIF2A 592_624_1_0 phospho",
    "KIF2A 592_624_1_1_S624 phospho",
    "KIF2A 97_107_1_1_S100 phospho",
    "KIF2A cnv",
    "KIF2A methyl",
    "KIF2A proteo",
    "KIF2A rna"
  ],
  "KIF2B": [
    "KIF2B cnv"
  ],
  "KIF2C": [
    "KIF2C cnv",
    "KIF2C methyl",
    "KIF2C rna"
  ],
  "KIF3A": [
    "KIF3A 660_660_1_1_T660 phospho",
    "KIF3A 714_723_1_1_S714 phospho",
    "KIF3A cnv",
    "KIF3A methyl",
    "KIF3A proteo",
    "KIF3A rna"
  ],
  "KIF3B": [
    "KIF3B cnv",
    "KIF3B proteo",
    "KIF3B rna"
  ],
  "KIF3C": [
    "KIF3C cnv",
    "KIF3C methyl",
    "KIF3C proteo",
    "KIF3C rna"
  ],
  "KIF4A": [
    "KIF4A methyl",
    "KIF4A proteo",
    "KIF4A rna"
  ],
  "KIF4B": [
    "KIF4B cnv",
    "KIF4B rna"
  ],
  "KIF5A": [
    "KIF5A 826_849_1_1_S842 phospho",
    "KIF5A 838_849_1_1_S842 phospho",
    "KIF5A cnv",
    "KIF5A methyl",
    "KIF5A proteo",
    "KIF5A rna"
  ],
  "KIF5B": [
    "KIF5B 933_938_1_1_S933 phospho",
    "KIF5B cnv",
    "KIF5B methyl",
    "KIF5B proteo",
    "KIF5B rna"
  ],
  "KIF5C": [
    "KIF5C 396_411_1_1_T396 phospho",
    "KIF5C 919_937_1_1_S935 phospho",
    "KIF5C 931_937_1_1_S934 phospho",
    "KIF5C cnv",
    "KIF5C methyl",
    "KIF5C proteo",
    "KIF5C rna"
  ],
  "KIF6": [
    "KIF6 cnv",
    "KIF6 rna"
  ],
  "KIF7": [
    "KIF7 1280_1289_1_1_S1281 phospho",
    "KIF7 893_901_1_0 phospho",
    "KIF7 893_901_1_1_S895 phospho",
    "KIF7 cnv",
    "KIF7 methyl",
    "KIF7 proteo",
    "KIF7 rna"
  ],
  "KIF9": [
    "KIF9 cnv",
    "KIF9 methyl",
    "KIF9 rna"
  ],
  "KIFAP3": [
    "KIFAP3 58_60_1_1_S58 phospho",
    "KIFAP3 cnv",
    "KIFAP3 methyl",
    "KIFAP3 proteo",
    "KIFAP3 rna"
  ],
  "KIFBP": [
    "KIFBP cnv",
    "KIFBP methyl",
    "KIFBP proteo",
    "KIFBP rna"
  ],
  "KIFC1": [
    "KIFC1 cnv",
    "KIFC1 methyl",
    "KIFC1 proteo",
    "KIFC1 rna"
  ],
  "KIFC2": [
    "KIFC2 cnv",
    "KIFC2 methyl",
    "KIFC2 rna"
  ],
  "KIFC3": [
    "KIFC3 cnv",
    "KIFC3 methyl",
    "KIFC3 proteo",
    "KIFC3 rna"
  ],
  "KIN": [
    "KIN cnv",
    "KIN methyl",
    "KIN proteo",
    "KIN rna"
  ],
  "KIR2DL1": [
    "KIR2DL1 cnv",
    "KIR2DL1 rna"
  ],
  "KIR2DL3": [
    "KIR2DL3 cnv",
    "KIR2DL3 rna"
  ],
  "KIR2DL4": [
    "KIR2DL4 cnv",
    "KIR2DL4 rna"
  ],
  "KIR2DS4": [
    "KIR2DS4 cnv",
    "KIR2DS4 rna"
  ],
  "KIR3DL1": [
    "KIR3DL1 cnv",
    "KIR3DL1 rna"
  ],
  "KIR3DL2": [
    "KIR3DL2 cnv",
    "KIR3DL2 rna"
  ],
  "KIR3DL3": [
    "KIR3DL3 cnv"
  ],
  "KIRREL1": [
    "KIRREL1 cnv",
    "KIRREL1 methyl",
    "KIRREL1 proteo",
    "KIRREL1 rna"
  ],
  "KIRREL2": [
    "KIRREL2 cnv",
    "KIRREL2 methyl",
    "KIRREL2 rna"
  ],
  "KIRREL3": [
    "KIRREL3 cnv",
    "KIRREL3 methyl",
    "KIRREL3 proteo",
    "KIRREL3 rna"
  ],
  "KISS1": [
    "KISS1 cnv",
    "KISS1 rna"
  ],
  "KISS1R": [
    "KISS1R cnv",
    "KISS1R methyl",
    "KISS1R rna"
  ],
  "KIT": [
    "KIT 929_943_1_1_S943 phospho",
    "KIT 959_967_1_1_S959 phospho",
    "KIT cnv",
    "KIT kinase",
    "KIT methyl",
    "KIT proteo",
    "KIT rna"
  ],
  "KITLG": [
    "KITLG cnv",
    "KITLG methyl",
    "KITLG rna"
  ],
  "KIZ": [
    "KIZ 214_228_1_1_S214 phospho",
    "KIZ cnv",
    "KIZ methyl",
    "KIZ proteo",
    "KIZ rna"
  ],
  "KL": [
    "KL cnv",
    "KL methyl",
    "KL rna"
  ],
  "KLB": [
    "KLB cnv",
    "KLB rna"
  ],
  "KLC1": [
    "KLC1 157_164_1_1_S162 phospho",
    "KLC1 418_418_1_1_S418 phospho",
    "KLC1 460_466_1_1_S460 phospho",
    "KLC1 521_524_1_1_S524 phospho",
    "KLC1 521_524_2_2_S521S524 phospho",
    "KLC1 cnv",
    "KLC1 methyl",
    "KLC1 proteo",
    "KLC1 rna"
  ],
  "KLC2": [
    "KLC2 151_151_1_1_S151 phospho",
    "KLC2 428_438_1_1_S428 phospho",
    "KLC2 445_451_1_1_S445 phospho",
    "KLC2 556_557_1_1_S556 phospho",
    "KLC2 556_557_1_1_S557 phospho",
    "KLC2 581_582_1_1_S582 phospho",
    "KLC2 589_604_1_1_S589 phospho",
    "KLC2 cnv",
    "KLC2 methyl",
    "KLC2 proteo",
    "KLC2 rna"
  ],
  "KLC3": [
    "KLC3 cnv",
    "KLC3 methyl",
    "KLC3 rna"
  ],
  "KLC4": [
    "KLC4 156_163_1_1_S163 phospho",
    "KLC4 518_526_1_1_S519 phospho",
    "KLC4 590_605_1_1_S590 phospho",
    "KLC4 609_619_1_0 phospho",
    "KLC4 609_619_1_1_S609 phospho",
    "KLC4 609_619_1_1_T612 phospho",
    "KLC4 cnv",
    "KLC4 methyl",
    "KLC4 proteo",
    "KLC4 rna"
  ],
  "KLF1": [
    "KLF1 cnv",
    "KLF1 rna"
  ],
  "KLF10": [
    "KLF10 232_238_1_1_S238 phospho",
    "KLF10 cnv",
    "KLF10 methyl",
    "KLF10 rna"
  ],
  "KLF11": [
    "KLF11 cnv",
    "KLF11 methyl",
    "KLF11 rna"
  ],
  "KLF12": [
    "KLF12 273_276_1_1_S273 phospho",
    "KLF12 cnv",
    "KLF12 methyl",
    "KLF12 proteo",
    "KLF12 rna"
  ],
  "KLF13": [
    "KLF13 cnv",
    "KLF13 methyl",
    "KLF13 proteo",
    "KLF13 rna"
  ],
  "KLF14": [
    "KLF14 cnv",
    "KLF14 methyl",
    "KLF14 rna"
  ],
  "KLF15": [
    "KLF15 cnv",
    "KLF15 methyl",
    "KLF15 rna"
  ],
  "KLF16": [
    "KLF16 224_246_1_1_S228 phospho",
    "KLF16 cnv",
    "KLF16 methyl",
    "KLF16 rna"
  ],
  "KLF17": [
    "KLF17 cnv",
    "KLF17 rna"
  ],
  "KLF18": [
    "KLF18 cnv"
  ],
  "KLF2": [
    "KLF2 cnv",
    "KLF2 methyl",
    "KLF2 rna"
  ],
  "KLF3": [
    "KLF3 250_253_1_1_S250 phospho",
    "KLF3 70_81_1_0 phospho",
    "KLF3 92_101_1_1_S92 phospho",
    "KLF3 92_101_2_0 phospho",
    "KLF3 92_101_2_2_S92S101 phospho",
    "KLF3 cnv",
    "KLF3 methyl",
    "KLF3 proteo",
    "KLF3 rna"
  ],
  "KLF4": [
    "KLF4 cnv",
    "KLF4 methyl",
    "KLF4 rna"
  ],
  "KLF5": [
    "KLF5 62_68_1_1_S62 phospho",
    "KLF5 cnv",
    "KLF5 methyl",
    "KLF5 rna"
  ],
  "KLF6": [
    "KLF6 cnv",
    "KLF6 methyl",
    "KLF6 proteo",
    "KLF6 rna"
  ],
  "KLF7": [
    "KLF7 cnv",
    "KLF7 methyl",
    "KLF7 rna"
  ],
  "KLF8": [
    "KLF8 methyl",
    "KLF8 rna"
  ],
  "KLF9": [
    "KLF9 cnv",
    "KLF9 methyl",
    "KLF9 rna"
  ],
  "KLHDC1": [
    "KLHDC1 cnv",
    "KLHDC1 methyl",
    "KLHDC1 rna"
  ],
  "KLHDC10": [
    "KLHDC10 cnv",
    "KLHDC10 methyl",
    "KLHDC10 rna"
  ],
  "KLHDC2": [
    "KLHDC2 cnv",
    "KLHDC2 methyl",
    "KLHDC2 proteo",
    "KLHDC2 rna"
  ],
  "KLHDC3": [
    "KLHDC3 cnv",
    "KLHDC3 methyl",
    "KLHDC3 proteo",
    "KLHDC3 rna"
  ],
  "KLHDC4": [
    "KLHDC4 356_367_1_1_S361 phospho",
    "KLHDC4 cnv",
    "KLHDC4 methyl",
    "KLHDC4 proteo",
    "KLHDC4 rna"
  ],
  "KLHDC7A": [
    "KLHDC7A cnv",
    "KLHDC7A rna"
  ],
  "KLHDC7B": [
    "KLHDC7B cnv",
    "KLHDC7B methyl",
    "KLHDC7B rna"
  ],
  "KLHDC8A": [
    "KLHDC8A cnv",
    "KLHDC8A methyl",
    "KLHDC8A rna"
  ],
  "KLHDC8B": [
    "KLHDC8B cnv",
    "KLHDC8B methyl",
    "KLHDC8B rna"
  ],
  "KLHDC9": [
    "KLHDC9 cnv",
    "KLHDC9 methyl",
    "KLHDC9 rna"
  ],
  "KLHL1": [
    "KLHL1 cnv",
    "KLHL1 methyl",
    "KLHL1 rna"
  ],
  "KLHL10": [
    "KLHL10 cnv",
    "KLHL10 rna"
  ],
  "KLHL11": [
    "KLHL11 cnv",
    "KLHL11 methyl",
    "KLHL11 proteo",
    "KLHL11 rna"
  ],
  "KLHL12": [
    "KLHL12 cnv",
    "KLHL12 methyl",
    "KLHL12 rna"
  ],
  "KLHL13": [
    "KLHL13 methyl",
    "KLHL13 proteo",
    "KLHL13 rna"
  ],
  "KLHL14": [
    "KLHL14 cnv",
    "KLHL14 methyl",
    "KLHL14 rna"
  ],
  "KLHL15": [
    "KLHL15 methyl",
    "KLHL15 rna"
  ],
  "KLHL17": [
    "KLHL17 cnv",
    "KLHL17 methyl",
    "KLHL17 rna"
  ],
  "KLHL18": [
    "KLHL18 cnv",
    "KLHL18 methyl",
    "KLHL18 rna"
  ],
  "KLHL2": [
    "KLHL2 cnv",
    "KLHL2 methyl",
    "KLHL2 rna"
  ],
  "KLHL20": [
    "KLHL20 cnv",
    "KLHL20 proteo",
    "KLHL20 rna"
  ],
  "KLHL21": [
    "KLHL21 cnv",
    "KLHL21 methyl",
    "KLHL21 rna"
  ],
  "KLHL22": [
    "KLHL22 596_605_1_1_T605 phospho",
    "KLHL22 cnv",
    "KLHL22 methyl",
    "KLHL22 proteo",
    "KLHL22 rna"
  ],
  "KLHL23": [
    "KLHL23 cnv",
    "KLHL23 methyl",
    "KLHL23 rna"
  ],
  "KLHL24": [
    "KLHL24 cnv",
    "KLHL24 methyl",
    "KLHL24 rna"
  ],
  "KLHL25": [
    "KLHL25 284_285_1_1_S285 phospho",
    "KLHL25 cnv",
    "KLHL25 methyl",
    "KLHL25 proteo",
    "KLHL25 rna"
  ],
  "KLHL26": [
    "KLHL26 cnv",
    "KLHL26 proteo",
    "KLHL26 rna"
  ],
  "KLHL28": [
    "KLHL28 cnv",
    "KLHL28 methyl",
    "KLHL28 rna"
  ],
  "KLHL29": [
    "KLHL29 cnv",
    "KLHL29 methyl",
    "KLHL29 proteo",
    "KLHL29 rna"
  ],
  "KLHL3": [
    "KLHL3 cnv",
    "KLHL3 rna"
  ],
  "KLHL30": [
    "KLHL30 cnv",
    "KLHL30 methyl",
    "KLHL30 rna"
  ],
  "KLHL31": [
    "KLHL31 cnv",
    "KLHL31 rna"
  ],
  "KLHL32": [
    "KLHL32 cnv",
    "KLHL32 methyl",
    "KLHL32 rna"
  ],
  "KLHL33": [
    "KLHL33 cnv",
    "KLHL33 methyl",
    "KLHL33 rna"
  ],
  "KLHL34": [
    "KLHL34 methyl",
    "KLHL34 rna"
  ],
  "KLHL35": [
    "KLHL35 cnv",
    "KLHL35 methyl",
    "KLHL35 rna"
  ],
  "KLHL36": [
    "KLHL36 cnv",
    "KLHL36 methyl",
    "KLHL36 proteo",
    "KLHL36 rna"
  ],
  "KLHL38": [
    "KLHL38 cnv",
    "KLHL38 rna"
  ],
  "KLHL4": [
    "KLHL4 144_153_1_1_S147 phospho",
    "KLHL4 proteo",
    "KLHL4 rna"
  ],
  "KLHL40": [
    "KLHL40 cnv",
    "KLHL40 rna"
  ],
  "KLHL41": [
    "KLHL41 cnv",
    "KLHL41 rna"
  ],
  "KLHL42": [
    "KLHL42 cnv",
    "KLHL42 methyl",
    "KLHL42 proteo",
    "KLHL42 rna"
  ],
  "KLHL5": [
    "KLHL5 cnv",
    "KLHL5 methyl",
    "KLHL5 proteo",
    "KLHL5 rna"
  ],
  "KLHL6": [
    "KLHL6 cnv",
    "KLHL6 rna"
  ],
  "KLHL7": [
    "KLHL7 cnv",
    "KLHL7 methyl",
    "KLHL7 proteo",
    "KLHL7 rna"
  ],
  "KLHL8": [
    "KLHL8 cnv",
    "KLHL8 methyl",
    "KLHL8 proteo",
    "KLHL8 rna"
  ],
  "KLHL9": [
    "KLHL9 cnv",
    "KLHL9 methyl",
    "KLHL9 proteo",
    "KLHL9 rna"
  ],
  "KLK1": [
    "KLK1 cnv",
    "KLK1 rna"
  ],
  "KLK10": [
    "KLK10 cnv",
    "KLK10 methyl",
    "KLK10 rna"
  ],
  "KLK11": [
    "KLK11 cnv",
    "KLK11 rna"
  ],
  "KLK12": [
    "KLK12 cnv"
  ],
  "KLK13": [
    "KLK13 cnv",
    "KLK13 rna"
  ],
  "KLK14": [
    "KLK14 cnv",
    "KLK14 rna"
  ],
  "KLK15": [
    "KLK15 cnv",
    "KLK15 rna"
  ],
  "KLK2": [
    "KLK2 cnv",
    "KLK2 rna"
  ],
  "KLK3": [
    "KLK3 cnv",
    "KLK3 rna"
  ],
  "KLK4": [
    "KLK4 cnv",
    "KLK4 rna"
  ],
  "KLK5": [
    "KLK5 cnv",
    "KLK5 rna"
  ],
  "KLK6": [
    "KLK6 cnv",
    "KLK6 proteo",
    "KLK6 rna"
  ],
  "KLK7": [
    "KLK7 cnv",
    "KLK7 rna"
  ],
  "KLK8": [
    "KLK8 cnv",
    "KLK8 methyl",
    "KLK8 rna"
  ],
  "KLK9": [
    "KLK9 cnv"
  ],
  "KLKB1": [
    "KLKB1 GVNFNVSK-N3H4F0S1G0 glyco",
    "KLKB1 GVNFNVSK-N4H5F0S1G0 glyco",
    "KLKB1 GVNFNVSK-N4H5F0S2G0 glyco",
    "KLKB1 IYPGVDFGGEELNVTFVK-N4H5F0S1G0 glyco",
    "KLKB1 IYPGVDFGGEELNVTFVK-N4H5F0S2G0 glyco",
    "KLKB1 IYSGILNLSDITK-N4H5F0S1G0 glyco",
    "KLKB1 IYSGILNLSDITK-N4H5F0S2G0 glyco",
    "KLKB1 cnv",
    "KLKB1 proteo",
    "KLKB1 rna"
  ],
  "KLLN": [
    "KLLN cnv",
    "KLLN methyl",
    "KLLN rna"
  ],
  "KLRB1": [
    "KLRB1 cnv",
    "KLRB1 rna"
  ],
  "KLRC1": [
    "KLRC1 cnv",
    "KLRC1 rna"
  ],
  "KLRC2": [
    "KLRC2 cnv",
    "KLRC2 rna"
  ],
  "KLRC3": [
    "KLRC3 cnv",
    "KLRC3 rna"
  ],
  "KLRC4": [
    "KLRC4 cnv",
    "KLRC4 rna"
  ],
  "KLRC4-KLRK1": [
    "KLRC4-KLRK1 cnv",
    "KLRC4-KLRK1 rna"
  ],
  "KLRD1": [
    "KLRD1 cnv",
    "KLRD1 rna"
  ],
  "KLRF1": [
    "KLRF1 cnv",
    "KLRF1 rna"
  ],
  "KLRF2": [
    "KLRF2 cnv",
    "KLRF2 rna"
  ],
  "KLRG1": [
    "KLRG1 cnv",
    "KLRG1 methyl",
    "KLRG1 rna"
  ],
  "KLRG2": [
    "KLRG2 cnv",
    "KLRG2 methyl",
    "KLRG2 rna"
  ],
  "KLRK1": [
    "KLRK1 cnv",
    "KLRK1 rna"
  ],
  "KMO": [
    "KMO cnv",
    "KMO rna"
  ],
  "KMT2A": [
    "KMT2A 1840_1854_1_1_S1840 phospho",
    "KMT2A 2097_2110_1_1_S2101 phospho",
    "KMT2A 2159_2188_1_0 phospho",
    "KMT2A 346_351_1_1_S351 phospho",
    "KMT2A 3505_3524_1_0 phospho",
    "KMT2A 3528_3537_1_1_S3530 phospho",
    "KMT2A cnv",
    "KMT2A methyl",
    "KMT2A proteo",
    "KMT2A rna"
  ],
  "KMT2B": [
    "KMT2B 346_351_1_1_S351 phospho",
    "KMT2B 632_641_1_1_S632 phospho",
    "KMT2B cnv",
    "KMT2B methyl",
    "KMT2B proteo",
    "KMT2B rna"
  ],
  "KMT2C": [
    "KMT2C 3968_3977_1_1_T3977 phospho",
    "KMT2C 4260_4274_1_1_S4267 phospho",
    "KMT2C 46_46_1_1_S46 phospho",
    "KMT2C 89_101_1_1_S89 phospho",
    "KMT2C cnv",
    "KMT2C methyl",
    "KMT2C proteo",
    "KMT2C rna"
  ],
  "KMT2D": [
    "KMT2D 1175_1180_1_1_S1180 phospho",
    "KMT2D 1604_1606_1_1_S1606 phospho",
    "KMT2D 2251_2260_1_1_S2260 phospho",
    "KMT2D 2323_2332_1_1_T2332 phospho",
    "KMT2D 3130_3138_1_1_S3130 phospho",
    "KMT2D 4738_4738_1_1_S4738 phospho",
    "KMT2D cnv",
    "KMT2D methyl",
    "KMT2D proteo",
    "KMT2D rna"
  ],
  "KMT2E": [
    "KMT2E 1444_1444_1_1_S1444 phospho",
    "KMT2E cnv",
    "KMT2E methyl",
    "KMT2E rna"
  ],
  "KMT5A": [
    "KMT5A cnv",
    "KMT5A methyl",
    "KMT5A rna"
  ],
  "KMT5B": [
    "KMT5B cnv",
    "KMT5B methyl",
    "KMT5B rna"
  ],
  "KMT5C": [
    "KMT5C cnv",
    "KMT5C methyl",
    "KMT5C rna"
  ],
  "KNCN": [
    "KNCN cnv",
    "KNCN rna"
  ],
  "KNDC1": [
    "KNDC1 964_988_1_1_S985 phospho",
    "KNDC1 cnv",
    "KNDC1 methyl",
    "KNDC1 proteo",
    "KNDC1 rna"
  ],
  "KNG1": [
    "KNG1 400_409_1_1_S406 phospho",
    "KNG1 HGIQYFNNNTQHSSLFMLNEVK-N11H6F0S0G0 glyco",
    "KNG1 HGIQYFNNNTQHSSLFMLNEVK-N4H5F0S2G0 glyco",
    "KNG1 HGIQYFNNNTQHSSLFMLNEVK-N4H5F2S1G0 glyco",
    "KNG1 HGIQYFNNNTQHSSLFMLNEVK-N5H6F1S3G0 glyco",
    "KNG1 HGIQYFNNNTQHSSLFMLNEVK-N5H6F2S2G0 glyco",
    "KNG1 HGIQYFNNNTQHSSLFMLNEVK-N6H4F0S0G0 glyco",
    "KNG1 HGIQYFNNNTQHSSLFMLNEVK-N6H4F0S1G0 glyco",
    "KNG1 HGIQYFNNNTQHSSLFMLNEVK-N6H4F2S1G0 glyco",
    "KNG1 HGIQYFNNNTQHSSLFMLNEVK-N6H5F1S0G0 glyco",
    "KNG1 HGIQYFNNNTQHSSLFMLNEVK-N7H6F1S0G0 glyco",
    "KNG1 HGIQYFNNNTQHSSLFMLNEVK-N7H6F1S1G0 glyco",
    "KNG1 HGIQYFNNNTQHSSLFMLNEVKR-N5H4F2S1G0 glyco",
    "KNG1 ITYSIVQTNCSK-N3H4F0S1G0 glyco",
    "KNG1 ITYSIVQTNCSK-N4H5F0S1G0 glyco",
    "KNG1 ITYSIVQTNCSK-N4H5F0S2G0 glyco",
    "KNG1 ITYSIVQTNCSK-N4H5F1S2G0 glyco",
    "KNG1 ITYSIVQTNCSK-N4H5F2S1G0 glyco",
    "KNG1 ITYSIVQTNCSK-N5H6F0S1G0 glyco",
    "KNG1 ITYSIVQTNCSK-N5H6F0S2G0 glyco",
    "KNG1 ITYSIVQTNCSK-N5H6F0S3G0 glyco",
    "KNG1 ITYSIVQTNCSK-N5H6F1S2G0 glyco",
    "KNG1 ITYSIVQTNCSK-N5H6F1S3G0 glyco",
    "KNG1 ITYSIVQTNCSK-N5H6F2S1G0 glyco",
    "KNG1 ITYSIVQTNCSK-N5H6F2S2G0 glyco",
    "KNG1 KYNSQNQSNNQFVLYR-N4H5F0S2G0 glyco",
    "KNG1 LNAENNATFYFK-N3H5F2S2G0 glyco",
    "KNG1 LNAENNATFYFK-N4H5F0S1G0 glyco",
    "KNG1 LNAENNATFYFK-N4H5F0S2G0 glyco",
    "KNG1 LNAENNATFYFK-N4H5F1S1G0 glyco",
    "KNG1 LNAENNATFYFK-N4H5F1S2G0 glyco",
    "KNG1 LNAENNATFYFK-N4H5F2S1G0 glyco",
    "KNG1 LNAENNATFYFK-N5H6F0S2G0 glyco",
    "KNG1 LNAENNATFYFK-N5H6F0S3G0 glyco",
    "KNG1 LNAENNATFYFK-N5H6F1S3G0 glyco",
    "KNG1 LNAENNATFYFK-N5H6F2S2G0 glyco",
    "KNG1 YNSQNQSNNQFVLYR-N4H5F0S2G0 glyco",
    "KNG1 cnv",
    "KNG1 proteo",
    "KNG1 rna"
  ],
  "KNL1": [
    "KNL1 cnv",
    "KNL1 methyl",
    "KNL1 rna"
  ],
  "KNOP1": [
    "KNOP1 cnv",
    "KNOP1 methyl",
    "KNOP1 proteo",
    "KNOP1 rna"
  ],
  "KNSTRN": [
    "KNSTRN cnv",
    "KNSTRN methyl",
    "KNSTRN proteo",
    "KNSTRN rna"
  ],
  "KNTC1": [
    "KNTC1 cnv",
    "KNTC1 methyl",
    "KNTC1 proteo",
    "KNTC1 rna"
  ],
  "KPNA1": [
    "KPNA1 244_244_1_1_S244 phospho",
    "KPNA1 cnv",
    "KPNA1 methyl",
    "KPNA1 proteo",
    "KPNA1 rna"
  ],
  "KPNA2": [
    "KPNA2 54_62_1_1_S62 phospho",
    "KPNA2 cnv",
    "KPNA2 methyl",
    "KPNA2 proteo",
    "KPNA2 rna"
  ],
  "KPNA3": [
    "KPNA3 cnv",
    "KPNA3 methyl",
    "KPNA3 proteo",
    "KPNA3 rna"
  ],
  "KPNA4": [
    "KPNA4 cnv",
    "KPNA4 methyl",
    "KPNA4 proteo",
    "KPNA4 rna"
  ],
  "KPNA5": [
    "KPNA5 cnv",
    "KPNA5 methyl",
    "KPNA5 rna"
  ],
  "KPNA6": [
    "KPNA6 109_122_1_1_S113 phospho",
    "KPNA6 cnv",
    "KPNA6 proteo",
    "KPNA6 rna"
  ],
  "KPNA7": [
    "KPNA7 cnv",
    "KPNA7 rna"
  ],
  "KPNB1": [
    "KPNB1 10_12_1_1_S12 phospho",
    "KPNB1 cnv",
    "KPNB1 methyl",
    "KPNB1 proteo",
    "KPNB1 rna"
  ],
  "KPNB1-DT": [
    "KPNB1-DT methyl"
  ],
  "KPRP": [
    "KPRP cnv",
    "KPRP rna"
  ],
  "KPTN": [
    "KPTN cnv",
    "KPTN methyl",
    "KPTN proteo",
    "KPTN rna"
  ],
  "KRAS": [
    "KRAS cnv",
    "KRAS methyl",
    "KRAS proteo",
    "KRAS rna"
  ],
  "KRBA1": [
    "KRBA1 cnv",
    "KRBA1 methyl",
    "KRBA1 rna"
  ],
  "KRBA2": [
    "KRBA2 cnv",
    "KRBA2 methyl",
    "KRBA2 rna"
  ],
  "KRBOX1": [
    "KRBOX1 cnv",
    "KRBOX1 methyl",
    "KRBOX1 rna"
  ],
  "KRBOX4": [
    "KRBOX4 methyl",
    "KRBOX4 rna"
  ],
  "KRBOX5": [
    "KRBOX5 cnv",
    "KRBOX5 methyl",
    "KRBOX5 rna"
  ],
  "KRCC1": [
    "KRCC1 cnv",
    "KRCC1 methyl",
    "KRCC1 rna"
  ],
  "KREMEN1": [
    "KREMEN1 cnv",
    "KREMEN1 methyl",
    "KREMEN1 rna"
  ],
  "KREMEN2": [
    "KREMEN2 cnv",
    "KREMEN2 methyl",
    "KREMEN2 rna"
  ],
  "KRI1": [
    "KRI1 136_147_1_1_S142 phospho",
    "KRI1 177_189_1_1_S177 phospho",
    "KRI1 628_645_1_1_S634 phospho",
    "KRI1 628_645_2_2_S634S645 phospho",
    "KRI1 cnv",
    "KRI1 methyl",
    "KRI1 proteo",
    "KRI1 rna"
  ],
  "KRIT1": [
    "KRIT1 cnv",
    "KRIT1 methyl",
    "KRIT1 proteo",
    "KRIT1 rna"
  ],
  "KRR1": [
    "KRR1 cnv",
    "KRR1 methyl",
    "KRR1 proteo",
    "KRR1 rna"
  ],
  "KRT1": [
    "KRT1 cnv",
    "KRT1 proteo",
    "KRT1 rna"
  ],
  "KRT10": [
    "KRT10 cnv",
    "KRT10 proteo",
    "KRT10 rna"
  ],
  "KRT10-AS1": [
    "KRT10-AS1 methyl"
  ],
  "KRT12": [
    "KRT12 cnv",
    "KRT12 rna"
  ],
  "KRT13": [
    "KRT13 cnv",
    "KRT13 rna"
  ],
  "KRT14": [
    "KRT14 cnv",
    "KRT14 rna"
  ],
  "KRT15": [
    "KRT15 cnv",
    "KRT15 rna"
  ],
  "KRT16": [
    "KRT16 cnv",
    "KRT16 rna"
  ],
  "KRT17": [
    "KRT17 cnv",
    "KRT17 rna"
  ],
  "KRT18": [
    "KRT18 cnv",
    "KRT18 methyl",
    "KRT18 proteo",
    "KRT18 rna"
  ],
  "KRT18P55": [
    "KRT18P55 methyl"
  ],
  "KRT19": [
    "KRT19 35_40_1_1_S35 phospho",
    "KRT19 cnv",
    "KRT19 methyl",
    "KRT19 proteo",
    "KRT19 rna"
  ],
  "KRT2": [
    "KRT2 cnv",
    "KRT2 proteo",
    "KRT2 rna"
  ],
  "KRT20": [
    "KRT20 cnv",
    "KRT20 rna"
  ],
  "KRT222": [
    "KRT222 282_293_1_1_S284 phospho",
    "KRT222 cnv",
    "KRT222 rna"
  ],
  "KRT23": [
    "KRT23 cnv",
    "KRT23 rna"
  ],
  "KRT24": [
    "KRT24 cnv"
  ],
  "KRT25": [
    "KRT25 cnv"
  ],
  "KRT26": [
    "KRT26 cnv"
  ],
  "KRT27": [
    "KRT27 cnv"
  ],
  "KRT28": [
    "KRT28 cnv"
  ],
  "KRT3": [
    "KRT3 cnv",
    "KRT3 rna"
  ],
  "KRT31": [
    "KRT31 cnv",
    "KRT31 rna"
  ],
  "KRT32": [
    "KRT32 cnv",
    "KRT32 rna"
  ],
  "KRT33A": [
    "KRT33A cnv",
    "KRT33A rna"
  ],
  "KRT33B": [
    "KRT33B cnv",
    "KRT33B rna"
  ],
  "KRT34": [
    "KRT34 cnv",
    "KRT34 rna"
  ],
  "KRT35": [
    "KRT35 cnv"
  ],
  "KRT36": [
    "KRT36 cnv",
    "KRT36 rna"
  ],
  "KRT37": [
    "KRT37 cnv",
    "KRT37 rna"
  ],
  "KRT38": [
    "KRT38 cnv"
  ],
  "KRT39": [
    "KRT39 cnv",
    "KRT39 rna"
  ],
  "KRT4": [
    "KRT4 cnv",
    "KRT4 rna"
  ],
  "KRT40": [
    "KRT40 cnv",
    "KRT40 rna"
  ],
  "KRT5": [
    "KRT5 cnv",
    "KRT5 rna"
  ],
  "KRT6A": [
    "KRT6A cnv",
    "KRT6A rna"
  ],
  "KRT6B": [
    "KRT6B cnv",
    "KRT6B rna"
  ],
  "KRT6C": [
    "KRT6C cnv",
    "KRT6C rna"
  ],
  "KRT7": [
    "KRT7 cnv",
    "KRT7 methyl",
    "KRT7 rna"
  ],
  "KRT71": [
    "KRT71 cnv",
    "KRT71 proteo",
    "KRT71 rna"
  ],
  "KRT72": [
    "KRT72 cnv",
    "KRT72 methyl",
    "KRT72 rna"
  ],
  "KRT73": [
    "KRT73 cnv"
  ],
  "KRT73-AS1": [
    "KRT73-AS1 methyl"
  ],
  "KRT74": [
    "KRT74 cnv",
    "KRT74 rna"
  ],
  "KRT75": [
    "KRT75 cnv",
    "KRT75 rna"
  ],
  "KRT76": [
    "KRT76 cnv"
  ],
  "KRT77": [
    "KRT77 cnv",
    "KRT77 rna"
  ],
  "KRT78": [
    "KRT78 cnv",
    "KRT78 rna"
  ],
  "KRT79": [
    "KRT79 cnv",
    "KRT79 rna"
  ],
  "KRT8": [
    "KRT8 cnv",
    "KRT8 methyl",
    "KRT8 proteo",
    "KRT8 rna"
  ],
  "KRT80": [
    "KRT80 cnv",
    "KRT80 rna"
  ],
  "KRT81": [
    "KRT81 cnv",
    "KRT81 rna"
  ],
  "KRT82": [
    "KRT82 cnv"
  ],
  "KRT83": [
    "KRT83 cnv",
    "KRT83 rna"
  ],
  "KRT84": [
    "KRT84 cnv",
    "KRT84 rna"
  ],
  "KRT85": [
    "KRT85 cnv",
    "KRT85 rna"
  ],
  "KRT86": [
    "KRT86 cnv",
    "KRT86 rna"
  ],
  "KRT87P": [
    "KRT87P methyl"
  ],
  "KRT9": [
    "KRT9 cnv",
    "KRT9 proteo",
    "KRT9 rna"
  ],
  "KRTAP1-1": [
    "KRTAP1-1 cnv"
  ],
  "KRTAP1-3": [
    "KRTAP1-3 cnv"
  ],
  "KRTAP1-4": [
    "KRTAP1-4 cnv"
  ],
  "KRTAP1-5": [
    "KRTAP1-5 cnv",
    "KRTAP1-5 rna"
  ],
  "KRTAP10-1": [
    "KRTAP10-1 cnv"
  ],
  "KRTAP10-10": [
    "KRTAP10-10 cnv"
  ],
  "KRTAP10-11": [
    "KRTAP10-11 cnv"
  ],
  "KRTAP10-12": [
    "KRTAP10-12 cnv"
  ],
  "KRTAP10-2": [
    "KRTAP10-2 cnv",
    "KRTAP10-2 rna"
  ],
  "KRTAP10-3": [
    "KRTAP10-3 cnv",
    "KRTAP10-3 rna"
  ],
  "KRTAP10-4": [
    "KRTAP10-4 cnv"
  ],
  "KRTAP10-5": [
    "KRTAP10-5 cnv"
  ],
  "KRTAP10-6": [
    "KRTAP10-6 cnv"
  ],
  "KRTAP10-7": [
    "KRTAP10-7 cnv"
  ],
  "KRTAP10-8": [
    "KRTAP10-8 cnv"
  ],
  "KRTAP10-9": [
    "KRTAP10-9 cnv"
  ],
  "KRTAP11-1": [
    "KRTAP11-1 cnv",
    "KRTAP11-1 rna"
  ],
  "KRTAP12-1": [
    "KRTAP12-1 cnv"
  ],
  "KRTAP12-2": [
    "KRTAP12-2 cnv",
    "KRTAP12-2 rna"
  ],
  "KRTAP12-3": [
    "KRTAP12-3 cnv"
  ],
  "KRTAP12-4": [
    "KRTAP12-4 cnv"
  ],
  "KRTAP13-1": [
    "KRTAP13-1 cnv"
  ],
  "KRTAP13-2": [
    "KRTAP13-2 cnv"
  ],
  "KRTAP13-3": [
    "KRTAP13-3 cnv"
  ],
  "KRTAP13-4": [
    "KRTAP13-4 cnv"
  ],
  "KRTAP15-1": [
    "KRTAP15-1 cnv"
  ],
  "KRTAP16-1": [
    "KRTAP16-1 cnv",
    "KRTAP16-1 rna"
  ],
  "KRTAP17-1": [
    "KRTAP17-1 cnv"
  ],
  "KRTAP19-1": [
    "KRTAP19-1 cnv"
  ],
  "KRTAP19-2": [
    "KRTAP19-2 cnv"
  ],
  "KRTAP19-3": [
    "KRTAP19-3 cnv"
  ],
  "KRTAP19-4": [
    "KRTAP19-4 cnv"
  ],
  "KRTAP19-5": [
    "KRTAP19-5 cnv"
  ],
  "KRTAP19-6": [
    "KRTAP19-6 cnv"
  ],
  "KRTAP19-7": [
    "KRTAP19-7 cnv"
  ],
  "KRTAP19-8": [
    "KRTAP19-8 cnv",
    "KRTAP19-8 rna"
  ],
  "KRTAP2-1": [
    "KRTAP2-1 cnv"
  ],
  "KRTAP2-2": [
    "KRTAP2-2 cnv"
  ],
  "KRTAP2-3": [
    "KRTAP2-3 cnv"
  ],
  "KRTAP2-4": [
    "KRTAP2-4 cnv"
  ],
  "KRTAP20-1": [
    "KRTAP20-1 cnv"
  ],
  "KRTAP20-2": [
    "KRTAP20-2 cnv"
  ],
  "KRTAP20-3": [
    "KRTAP20-3 cnv"
  ],
  "KRTAP20-4": [
    "KRTAP20-4 cnv"
  ],
  "KRTAP21-1": [
    "KRTAP21-1 cnv"
  ],
  "KRTAP21-2": [
    "KRTAP21-2 cnv",
    "KRTAP21-2 rna"
  ],
  "KRTAP21-3": [
    "KRTAP21-3 cnv"
  ],
  "KRTAP22-1": [
    "KRTAP22-1 cnv"
  ],
  "KRTAP22-2": [
    "KRTAP22-2 cnv"
  ],
  "KRTAP23-1": [
    "KRTAP23-1 cnv"
  ],
  "KRTAP24-1": [
    "KRTAP24-1 cnv"
  ],
  "KRTAP25-1": [
    "KRTAP25-1 cnv"
  ],
  "KRTAP26-1": [
    "KRTAP26-1 cnv"
  ],
  "KRTAP27-1": [
    "KRTAP27-1 cnv"
  ],
  "KRTAP29-1": [
    "KRTAP29-1 cnv",
    "KRTAP29-1 rna"
  ],
  "KRTAP3-1": [
    "KRTAP3-1 cnv"
  ],
  "KRTAP3-2": [
    "KRTAP3-2 cnv",
    "KRTAP3-2 rna"
  ],
  "KRTAP3-3": [
    "KRTAP3-3 cnv"
  ],
  "KRTAP4-1": [
    "KRTAP4-1 cnv"
  ],
  "KRTAP4-11": [
    "KRTAP4-11 cnv"
  ],
  "KRTAP4-12": [
    "KRTAP4-12 cnv",
    "KRTAP4-12 rna"
  ],
  "KRTAP4-16": [
    "KRTAP4-16 cnv"
  ],
  "KRTAP4-2": [
    "KRTAP4-2 cnv"
  ],
  "KRTAP4-3": [
    "KRTAP4-3 cnv"
  ],
  "KRTAP4-4": [
    "KRTAP4-4 cnv"
  ],
  "KRTAP4-5": [
    "KRTAP4-5 cnv"
  ],
  "KRTAP4-6": [
    "KRTAP4-6 cnv"
  ],
  "KRTAP4-7": [
    "KRTAP4-7 cnv"
  ],
  "KRTAP4-8": [
    "KRTAP4-8 cnv"
  ],
  "KRTAP4-9": [
    "KRTAP4-9 cnv"
  ],
  "KRTAP5-1": [
    "KRTAP5-1 cnv",
    "KRTAP5-1 rna"
  ],
  "KRTAP5-10": [
    "KRTAP5-10 cnv",
    "KRTAP5-10 rna"
  ],
  "KRTAP5-11": [
    "KRTAP5-11 cnv",
    "KRTAP5-11 rna"
  ],
  "KRTAP5-2": [
    "KRTAP5-2 cnv",
    "KRTAP5-2 rna"
  ],
  "KRTAP5-3": [
    "KRTAP5-3 cnv",
    "KRTAP5-3 rna"
  ],
  "KRTAP5-4": [
    "KRTAP5-4 cnv",
    "KRTAP5-4 rna"
  ],
  "KRTAP5-5": [
    "KRTAP5-5 cnv"
  ],
  "KRTAP5-6": [
    "KRTAP5-6 cnv",
    "KRTAP5-6 rna"
  ],
  "KRTAP5-7": [
    "KRTAP5-7 cnv",
    "KRTAP5-7 rna"
  ],
  "KRTAP5-8": [
    "KRTAP5-8 cnv",
    "KRTAP5-8 rna"
  ],
  "KRTAP5-9": [
    "KRTAP5-9 cnv",
    "KRTAP5-9 rna"
  ],
  "KRTAP5-AS1": [
    "KRTAP5-AS1 methyl"
  ],
  "KRTAP6-1": [
    "KRTAP6-1 cnv"
  ],
  "KRTAP6-2": [
    "KRTAP6-2 cnv"
  ],
  "KRTAP6-3": [
    "KRTAP6-3 cnv"
  ],
  "KRTAP7-1": [
    "KRTAP7-1 cnv",
    "KRTAP7-1 rna"
  ],
  "KRTAP8-1": [
    "KRTAP8-1 cnv",
    "KRTAP8-1 rna"
  ],
  "KRTAP9-1": [
    "KRTAP9-1 cnv"
  ],
  "KRTAP9-2": [
    "KRTAP9-2 cnv"
  ],
  "KRTAP9-3": [
    "KRTAP9-3 cnv"
  ],
  "KRTAP9-4": [
    "KRTAP9-4 cnv"
  ],
  "KRTAP9-6": [
    "KRTAP9-6 cnv"
  ],
  "KRTAP9-7": [
    "KRTAP9-7 cnv"
  ],
  "KRTAP9-8": [
    "KRTAP9-8 cnv"
  ],
  "KRTAP9-9": [
    "KRTAP9-9 cnv"
  ],
  "KRTCAP2": [
    "KRTCAP2 cnv",
    "KRTCAP2 methyl",
    "KRTCAP2 proteo",
    "KRTCAP2 rna"
  ],
  "KRTCAP3": [
    "KRTCAP3 cnv",
    "KRTCAP3 methyl",
    "KRTCAP3 rna"
  ],
  "KRTDAP": [
    "KRTDAP cnv",
    "KRTDAP rna"
  ],
  "KSR1": [
    "KSR1 130_137_1_1_T133 phospho",
    "KSR1 130_137_2_0 phospho",
    "KSR1 151_156_1_1_T151 phospho",
    "KSR1 174_177_1_1_S174 phospho",
    "KSR1 194_197_1_1_S197 phospho",
    "KSR1 267_272_1_1_S269 phospho",
    "KSR1 288_288_1_1_T288 phospho",
    "KSR1 432_447_1_1_S432 phospho",
    "KSR1 55_76_1_0 phospho",
    "KSR1 cnv",
    "KSR1 kinase",
    "KSR1 methyl",
    "KSR1 proteo",
    "KSR1 rna"
  ],
  "KSR2": [
    "KSR2 cnv",
    "KSR2 kinase",
    "KSR2 methyl",
    "KSR2 proteo",
    "KSR2 rna"
  ],
  "KTI12": [
    "KTI12 cnv",
    "KTI12 methyl",
    "KTI12 proteo",
    "KTI12 rna"
  ],
  "KTN1": [
    "KTN1 1304_1319_1_1_S1313 phospho",
    "KTN1 149_161_1_1_T153 phospho",
    "KTN1 153_161_1_1_T153 phospho",
    "KTN1 75_79_1_1_S75 phospho",
    "KTN1 75_79_2_2_S75S77 phospho",
    "KTN1 cnv",
    "KTN1 methyl",
    "KTN1 proteo",
    "KTN1 rna"
  ],
  "KTN1-AS1": [
    "KTN1-AS1 methyl"
  ],
  "KXD1": [
    "KXD1 cnv",
    "KXD1 methyl",
    "KXD1 proteo",
    "KXD1 rna"
  ],
  "KY": [
    "KY cnv",
    "KY methyl",
    "KY rna"
  ],
  "KYAT1": [
    "KYAT1 cnv",
    "KYAT1 proteo",
    "KYAT1 rna"
  ],
  "KYAT3": [
    "KYAT3 cnv",
    "KYAT3 methyl",
    "KYAT3 proteo",
    "KYAT3 rna"
  ],
  "KYNU": [
    "KYNU cnv",
    "KYNU proteo",
    "KYNU rna"
  ],
  "L1CAM": [
    "L1CAM 1172_1181_2_2_S1178S1181 phospho",
    "L1CAM 1178_1181_1_1_S1181 phospho",
    "L1CAM 1243_1248_1_0 phospho",
    "L1CAM 1243_1248_1_1_S1248 phospho",
    "L1CAM FFPYANGTLGIR-N2H5F0S0G0 glyco",
    "L1CAM GYNVTYWR-N2H4F0S0G0 glyco",
    "L1CAM GYNVTYWR-N2H5F0S0G0 glyco",
    "L1CAM THNLTDLSPHLR-N2H5F0S0G0 glyco",
    "L1CAM THNLTDLSPHLR-N4H4F1S0G0 glyco",
    "L1CAM THNLTDLSPHLR-N4H5F0S0G0 glyco",
    "L1CAM THNLTDLSPHLR-N4H5F1S0G0 glyco",
    "L1CAM THNLTDLSPHLR-N4H5F2S0G0 glyco",
    "L1CAM THNLTDLSPHLR-N5H3F1S0G0 glyco",
    "L1CAM VPGNQTSTTLK-N2H5F0S0G0 glyco",
    "L1CAM VPGNQTSTTLK-N4H3F1S0G0 glyco",
    "L1CAM VPGNQTSTTLK-N4H4F1S0G0 glyco",
    "L1CAM VPGNQTSTTLK-N4H5F1S0G0 glyco",
    "L1CAM VPGNQTSTTLK-N5H3F1S0G0 glyco",
    "L1CAM VTMGQNGNLYFANVLTSDNHSDYICHAHFPGTR-N5H3F1S0G0 glyco",
    "L1CAM VTYQNHNK-N2H5F0S0G0 glyco",
    "L1CAM VTYQNHNK-N4H3F1S0G0 glyco",
    "L1CAM VTYQNHNK-N5H3F0S0G0 glyco",
    "L1CAM VTYQNHNK-N5H3F1S0G0 glyco",
    "L1CAM VTYQNHNK-N5H4F1S0G0 glyco",
    "L1CAM methyl",
    "L1CAM proteo",
    "L1CAM rna"
  ],
  "L1TD1": [
    "L1TD1 cnv",
    "L1TD1 methyl",
    "L1TD1 rna"
  ],
  "L2HGDH": [
    "L2HGDH cnv",
    "L2HGDH methyl",
    "L2HGDH proteo",
    "L2HGDH rna"
  ],
  "L3HYPDH": [
    "L3HYPDH cnv",
    "L3HYPDH methyl",
    "L3HYPDH proteo",
    "L3HYPDH rna"
  ],
  "L3MBTL1": [
    "L3MBTL1 cnv",
    "L3MBTL1 methyl",
    "L3MBTL1 rna"
  ],
  "L3MBTL2": [
    "L3MBTL2 cnv",
    "L3MBTL2 methyl",
    "L3MBTL2 rna"
  ],
  "L3MBTL3": [
    "L3MBTL3 cnv",
    "L3MBTL3 methyl",
    "L3MBTL3 proteo",
    "L3MBTL3 rna"
  ],
  "L3MBTL4": [
    "L3MBTL4 cnv",
    "L3MBTL4 methyl",
    "L3MBTL4 rna"
  ],
  "LACC1": [
    "LACC1 cnv",
    "LACC1 methyl",
    "LACC1 rna"
  ],
  "LACRT": [
    "LACRT cnv"
  ],
  "LACTB": [
    "LACTB cnv",
    "LACTB methyl",
    "LACTB proteo",
    "LACTB rna"
  ],
  "LACTB2": [
    "LACTB2 cnv",
    "LACTB2 methyl",
    "LACTB2 proteo",
    "LACTB2 rna"
  ],
  "LACTB2-AS1": [
    "LACTB2-AS1 methyl"
  ],
  "LACTBL1": [
    "LACTBL1 cnv",
    "LACTBL1 rna"
  ],
  "LAD1": [
    "LAD1 cnv",
    "LAD1 methyl",
    "LAD1 rna"
  ],
  "LAG3": [
    "LAG3 cnv",
    "LAG3 rna"
  ],
  "LAGE3": [
    "LAGE3 methyl",
    "LAGE3 proteo",
    "LAGE3 rna"
  ],
  "LAIR1": [
    "LAIR1 cnv",
    "LAIR1 rna"
  ],
  "LAIR2": [
    "LAIR2 cnv",
    "LAIR2 rna"
  ],
  "LALBA": [
    "LALBA cnv",
    "LALBA rna"
  ],
  "LAMA1": [
    "LAMA1 YNNGTWYK-N2H7F0S0G0 glyco",
    "LAMA1 YNNGTWYK-N2H8F0S0G0 glyco",
    "LAMA1 cnv",
    "LAMA1 methyl",
    "LAMA1 proteo",
    "LAMA1 rna"
  ],
  "LAMA2": [
    "LAMA2 LSAIPNDTAAK-N4H3F1S0G0 glyco",
    "LAMA2 LSAIPNDTAAK-N4H4F1S0G0 glyco",
    "LAMA2 LSAIPNDTAAK-N4H5F1S0G0 glyco",
    "LAMA2 LSAIPNDTAAK-N4H5F1S1G0 glyco",
    "LAMA2 NMTALEK-N2H5F0S0G0 glyco",
    "LAMA2 QEGILYVDGASNR-N2H5F0S0G0 glyco",
    "LAMA2 cnv",
    "LAMA2 proteo",
    "LAMA2 rna"
  ],
  "LAMA3": [
    "LAMA3 cnv",
    "LAMA3 methyl",
    "LAMA3 rna"
  ],
  "LAMA4": [
    "LAMA4 HVNEINATIYLLK-N4H3F1S0G0 glyco",
    "LAMA4 HVNEINATIYLLK-N4H4F1S0G0 glyco",
    "LAMA4 HVNEINATIYLLK-N4H5F1S0G0 glyco",
    "LAMA4 HVNEINATIYLLK-N4H5F1S1G0 glyco",
    "LAMA4 HVNEINATIYLLK-N4H5F1S2G0 glyco",
    "LAMA4 HVNEINATIYLLK-N5H3F1S0G0 glyco",
    "LAMA4 HVNEINATIYLLK-N5H4F1S0G0 glyco",
    "LAMA4 LITEEANR-N4H5F1S1G0 glyco",
    "LAMA4 NASGIYAEIDGAK-N2H5F0S0G0 glyco",
    "LAMA4 NASGIYAEIDGAK-N3H4F0S0G0 glyco",
    "LAMA4 NASGIYAEIDGAK-N3H6F0S0G0 glyco",
    "LAMA4 NASGIYAEIDGAK-N4H5F0S0G0 glyco",
    "LAMA4 NLTEVVPQLLDQLR-N4H5F1S0G0 glyco",
    "LAMA4 NTTGEHCEK-N4H5F0S0G0 glyco",
    "LAMA4 NTTGEHCEK-N4H5F0S1G0 glyco",
    "LAMA4 cnv",
    "LAMA4 methyl",
    "LAMA4 proteo",
    "LAMA4 rna"
  ],
  "LAMA5": [
    "LAMA5 LNTTGVSAGCTADLLVGR-N2H5F0S0G0 glyco",
    "LAMA5 LVGGPVAGGDPNQTIR-N2H5F0S0G0 glyco",
    "LAMA5 LVGGPVAGGDPNQTIR-N2H8F0S0G0 glyco",
    "LAMA5 RLNTTGVSAGCTADLLVGR-N2H5F0S0G0 glyco",
    "LAMA5 VWQGHANASFCPHGYGCR-N2H9F0S0G0 glyco",
    "LAMA5 cnv",
    "LAMA5 methyl",
    "LAMA5 proteo",
    "LAMA5 rna"
  ],
  "LAMA5-AS1": [
    "LAMA5-AS1 methyl"
  ],
  "LAMB1": [
    "LAMB1 LSDTTSQSNSTAK-N2H5F0S0G0 glyco",
    "LAMB1 LSDTTSQSNSTAK-N2H6F0S0G0 glyco",
    "LAMB1 LSDTTSQSNSTAK-N2H8F0S0G0 glyco",
    "LAMB1 LSDTTSQSNSTAK-N4H5F1S0G0 glyco",
    "LAMB1 LSDTTSQSNSTAK-N4H5F1S1G0 glyco",
    "LAMB1 cnv",
    "LAMB1 methyl",
    "LAMB1 proteo",
    "LAMB1 rna"
  ],
  "LAMB2": [
    "LAMB2 ANTSALAVPSPVSNSASAR-N2H5F0S0G0 glyco",
    "LAMB2 LALNLTLR-N2H5F0S0G0 glyco",
    "LAMB2 cnv",
    "LAMB2 proteo",
    "LAMB2 rna"
  ],
  "LAMB3": [
    "LAMB3 cnv",
    "LAMB3 rna"
  ],
  "LAMB4": [
    "LAMB4 cnv",
    "LAMB4 rna"
  ],
  "LAMC1": [
    "LAMC1 IPAINQTITEANEK-N5H3F1S0G0 glyco",
    "LAMC1 KIPAINQTITEANEK-N4H3F1S0G0 glyco",
    "LAMC1 KIPAINQTITEANEK-N4H4F1S0G0 glyco",
    "LAMC1 KIPAINQTITEANEK-N4H5F1S0G0 glyco",
    "LAMC1 KIPAINQTITEANEK-N5H3F1S0G0 glyco",
    "LAMC1 KIPAINQTITEANEK-N5H4F1S0G0 glyco",
    "LAMC1 KYEQAKNISQDLEK-N4H5F1S0G0 glyco",
    "LAMC1 LLNNLTSIK-N2H4F0S0G0 glyco",
    "LAMC1 LLNNLTSIK-N2H5F0S0G0 glyco",
    "LAMC1 LLNNLTSIK-N2H6F0S0G0 glyco",
    "LAMC1 LLNNLTSIK-N2H7F0S0G0 glyco",
    "LAMC1 LLNNLTSIK-N2H8F0S0G0 glyco",
    "LAMC1 LLNNLTSIK-N2H9F0S0G0 glyco",
    "LAMC1 LLNNLTSIK-N4H3F0S2G0 glyco",
    "LAMC1 NISQDLEK-N2H6F0S0G0 glyco",
    "LAMC1 NISQDLEK-N2H8F0S0G0 glyco",
    "LAMC1 NISQDLEK-N4H3F1S0G0 glyco",
    "LAMC1 NISQDLEK-N4H4F1S0G0 glyco",
    "LAMC1 NISQDLEK-N4H5F1S0G0 glyco",
    "LAMC1 NISQDLEK-N4H5F1S1G0 glyco",
    "LAMC1 NISQDLEK-N5H3F1S0G0 glyco",
    "LAMC1 NISQDLEK-N5H4F1S0G0 glyco",
    "LAMC1 QVLSYGQNLSFSFR-N2H5F0S0G0 glyco",
    "LAMC1 QVLSYGQNLSFSFR-N2H6F0S0G0 glyco",
    "LAMC1 QVLSYGQNLSFSFR-N2H9F0S0G0 glyco",
    "LAMC1 QVLSYGQNLSFSFR-N3H3F0S0G0 glyco",
    "LAMC1 QVLSYGQNLSFSFR-N3H4F0S0G0 glyco",
    "LAMC1 QVLSYGQNLSFSFR-N3H6F0S0G0 glyco",
    "LAMC1 QVLSYGQNLSFSFR-N4H5F0S0G0 glyco",
    "LAMC1 TANDTSTEAYNLLLR-N2H4F0S0G0 glyco",
    "LAMC1 TANDTSTEAYNLLLR-N2H5F0S0G0 glyco",
    "LAMC1 TANDTSTEAYNLLLR-N2H6F0S0G0 glyco",
    "LAMC1 TANDTSTEAYNLLLR-N2H7F0S0G0 glyco",
    "LAMC1 TANDTSTEAYNLLLR-N2H8F0S0G0 glyco",
    "LAMC1 TANDTSTEAYNLLLR-N3H4F0S0G0 glyco",
    "LAMC1 TANDTSTEAYNLLLR-N3H5F0S0G0 glyco",
    "LAMC1 TANDTSTEAYNLLLR-N3H6F0S0G0 glyco",
    "LAMC1 TLAGENQTAFEIEELNR-N2H5F0S0G0 glyco",
    "LAMC1 TLAGENQTAFEIEELNR-N2H6F0S0G0 glyco",
    "LAMC1 TLAGENQTAFEIEELNR-N2H8F0S0G0 glyco",
    "LAMC1 TLAGENQTAFEIEELNR-N3H3F1S0G0 glyco",
    "LAMC1 TLAGENQTAFEIEELNR-N3H4F1S0G0 glyco",
    "LAMC1 TLAGENQTAFEIEELNR-N4H3F1S0G0 glyco",
    "LAMC1 TLAGENQTAFEIEELNR-N4H5F1S0G0 glyco",
    "LAMC1 TLAGENQTAFEIEELNR-N5H3F1S0G0 glyco",
    "LAMC1 TLAGENQTAFEIEELNR-N5H6F1S1G0 glyco",
    "LAMC1 VNDNKTAAEEALR-N4H5F1S0G0 glyco",
    "LAMC1 VNNTLSSQISR-N2H5F0S0G0 glyco",
    "LAMC1 VNNTLSSQISR-N2H8F0S0G0 glyco",
    "LAMC1 VNNTLSSQISR-N3H4F0S0G0 glyco",
    "LAMC1 VNNTLSSQISR-N4H4F0S0G0 glyco",
    "LAMC1 VNNTLSSQISR-N4H5F0S0G0 glyco",
    "LAMC1 cnv",
    "LAMC1 methyl",
    "LAMC1 proteo",
    "LAMC1 rna"
  ],
  "LAMC2": [
    "LAMC2 cnv",
    "LAMC2 rna"
  ],
  "LAMC3": [
    "LAMC3 cnv",
    "LAMC3 methyl",
    "LAMC3 proteo",
    "LAMC3 rna"
  ],
  "LAMP1": [
    "LAMP1 AANGSLR-N2H3F0S0G0 glyco",
    "LAMP1 AANGSLR-N2H4F0S0G0 glyco",
    "LAMP1 AANGSLR-N2H5F0S0G0 glyco",
    "LAMP1 AANGSLR-N2H6F0S0G0 glyco",
    "LAMP1 AANGSLR-N2H7F0S0G0 glyco",
    "LAMP1 AANGSLR-N2H8F0S0G0 glyco",
    "LAMP1 DNTTVTR-N2H3F1S0G0 glyco",
    "LAMP1 ENTSDPSLVIAFGR-N2H3F1S0G0 glyco",
    "LAMP1 GHTLTLNFTR-N2H3F0S0G0 glyco",
    "LAMP1 GHTLTLNFTR-N2H4F0S0G0 glyco",
    "LAMP1 GHTLTLNFTR-N2H5F0S0G0 glyco",
    "LAMP1 GHTLTLNFTR-N2H6F0S0G0 glyco",
    "LAMP1 GHTLTLNFTR-N2H7F0S0G0 glyco",
    "LAMP1 GHTLTLNFTR-N2H8F0S0G0 glyco",
    "LAMP1 GHTLTLNFTR-N2H9F0S0G0 glyco",
    "LAMP1 GHTLTLNFTR-N3H4F0S1G0 glyco",
    "LAMP1 GHTLTLNFTR-N3H5F0S0G0 glyco",
    "LAMP1 GHTLTLNFTR-N3H5F0S1G0 glyco",
    "LAMP1 GHTLTLNFTR-N3H6F0S0G0 glyco",
    "LAMP1 GHTLTLNFTR-N3H6F0S1G0 glyco",
    "LAMP1 GHTLTLNFTR-N3H6F1S0G0 glyco",
    "LAMP1 GHTLTLNFTR-N4H5F0S1G0 glyco",
    "LAMP1 GHTLTLNFTR-N4H6F0S0G0 glyco",
    "LAMP1 GHTLTLNFTR-N4H6F0S1G0 glyco",
    "LAMP1 GHTLTLNFTR-N4H7F0S0G0 glyco",
    "LAMP1 KDNTTVTR-N2H3F1S0G0 glyco",
    "LAMP1 KDNTTVTR-N3H4F1S0G0 glyco",
    "LAMP1 KDNTTVTR-N3H4F1S1G0 glyco",
    "LAMP1 LLNINPNK-N2H3F1S0G0 glyco",
    "LAMP1 LLNINPNK-N2H4F0S0G0 glyco",
    "LAMP1 LLNINPNK-N2H4F1S0G0 glyco",
    "LAMP1 LLNINPNK-N2H5F0S0G0 glyco",
    "LAMP1 LLNINPNK-N2H5F1S0G0 glyco",
    "LAMP1 LLNINPNK-N2H6F0S0G0 glyco",
    "LAMP1 LLNINPNK-N2H7F0S0G0 glyco",
    "LAMP1 LLNINPNK-N2H8F0S0G0 glyco",
    "LAMP1 LLNINPNK-N3H4F1S0G0 glyco",
    "LAMP1 LLNINPNK-N3H4F2S0G0 glyco",
    "LAMP1 LLNINPNK-N3H5F0S0G0 glyco",
    "LAMP1 LLNINPNK-N3H5F1S0G0 glyco",
    "LAMP1 LLNINPNK-N3H5F1S1G0 glyco",
    "LAMP1 LLNINPNK-N3H5F2S0G0 glyco",
    "LAMP1 LLNINPNK-N3H6F0S0G0 glyco",
    "LAMP1 LLNINPNK-N3H6F0S1G0 glyco",
    "LAMP1 LLNINPNK-N3H6F1S0G0 glyco",
    "LAMP1 LLNINPNK-N3H6F2S0G0 glyco",
    "LAMP1 LLNINPNK-N4H5F1S0G0 glyco",
    "LAMP1 LLNINPNK-N4H5F4S1G0 glyco",
    "LAMP1 SSCGKENTSDPSLVIAFGR-N2H3F1S0G0 glyco",
    "LAMP1 SSCGKENTSDPSLVIAFGR-N3H4F1S1G0 glyco",
    "LAMP1 SSCGKENTSDPSLVIAFGR-N4H3F1S0G0 glyco",
    "LAMP1 cnv",
    "LAMP1 methyl",
    "LAMP1 proteo",
    "LAMP1 rna"
  ],
  "LAMP2": [
    "LAMP2 LNSSTIK-N2H3F0S0G0 glyco",
    "LAMP2 LNSSTIK-N2H3F1S0G0 glyco",
    "LAMP2 LNSSTIK-N2H4F0S0G0 glyco",
    "LAMP2 LNSSTIK-N2H5F0S0G0 glyco",
    "LAMP2 LNSSTIK-N2H7F0S0G0 glyco",
    "LAMP2 LNSSTIK-N3H3F0S0G0 glyco",
    "LAMP2 LNSSTIK-N3H3F1S0G0 glyco",
    "LAMP2 LNSSTIK-N3H4F0S0G0 glyco",
    "LAMP2 LNSSTIK-N3H4F0S1G0 glyco",
    "LAMP2 LNSSTIK-N3H4F1S0G0 glyco",
    "LAMP2 LNSSTIK-N3H4F1S1G0 glyco",
    "LAMP2 LNSSTIK-N4H3F0S0G0 glyco",
    "LAMP2 LNSSTIK-N4H4F0S0G0 glyco",
    "LAMP2 LNSSTIK-N4H4F0S1G0 glyco",
    "LAMP2 LNSSTIK-N4H5F0S1G0 glyco",
    "LAMP2 LNSSTIK-N5H4F0S0G0 glyco",
    "LAMP2 LNSSTIK-N5H6F0S1G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N2H3F1S0G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N2H4F0S0G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N2H4F1S0G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N2H5F0S0G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N2H5F1S0G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N3H3F1S0G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N3H4F1S0G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N3H4F1S1G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N3H4F2S0G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N3H4F2S2G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N3H5F0S0G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N3H5F1S0G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N3H5F1S1G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N3H5F2S0G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N4H3F1S0G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N4H4F1S0G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N4H4F1S1G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N4H4F2S0G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N4H5F1S0G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N4H5F1S1G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N5H3F1S0G0 glyco",
    "LAMP2 VASVININPNTTHSTGSCR-N5H6F1S1G0 glyco",
    "LAMP2 VQPFNVTQGK-N2H3F1S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N2H4F0S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N2H4F1S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N2H5F0S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N2H5F1S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N2H6F0S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N2H7F0S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N2H8F0S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N3H3F1S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N3H4F0S1G0 glyco",
    "LAMP2 VQPFNVTQGK-N3H4F1S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N3H4F2S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N3H5F0S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N3H5F0S1G0 glyco",
    "LAMP2 VQPFNVTQGK-N3H5F1S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N3H5F1S1G0 glyco",
    "LAMP2 VQPFNVTQGK-N3H5F2S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N3H6F0S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N3H6F0S1G0 glyco",
    "LAMP2 VQPFNVTQGK-N3H6F1S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N3H6F1S1G0 glyco",
    "LAMP2 VQPFNVTQGK-N4H4F1S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N4H5F0S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N4H5F0S1G0 glyco",
    "LAMP2 VQPFNVTQGK-N4H5F0S2G0 glyco",
    "LAMP2 VQPFNVTQGK-N4H5F1S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N4H5F1S1G0 glyco",
    "LAMP2 VQPFNVTQGK-N5H3F1S0G0 glyco",
    "LAMP2 VQPFNVTQGK-N5H6F0S1G0 glyco",
    "LAMP2 VQPFNVTQGK-N5H6F1S1G0 glyco",
    "LAMP2 proteo",
    "LAMP2 rna"
  ],
  "LAMP3": [
    "LAMP3 cnv",
    "LAMP3 methyl",
    "LAMP3 rna"
  ],
  "LAMP5": [
    "LAMP5 cnv",
    "LAMP5 methyl",
    "LAMP5 proteo",
    "LAMP5 rna"
  ],
  "LAMP5-AS1": [
    "LAMP5-AS1 methyl"
  ],
  "LAMTOR1": [
    "LAMTOR1 26_30_1_1_S27 phospho",
    "LAMTOR1 40_45_1_1_S42 phospho",
    "LAMTOR1 61_81_1_1_S63 phospho",
    "LAMTOR1 cnv",
    "LAMTOR1 methyl",
    "LAMTOR1 proteo",
    "LAMTOR1 rna"
  ],
  "LAMTOR2": [
    "LAMTOR2 cnv",
    "LAMTOR2 methyl",
    "LAMTOR2 proteo",
    "LAMTOR2 rna"
  ],
  "LAMTOR3": [
    "LAMTOR3 cnv",
    "LAMTOR3 proteo",
    "LAMTOR3 rna"
  ],
  "LAMTOR4": [
    "LAMTOR4 cnv",
    "LAMTOR4 methyl",
    "LAMTOR4 rna"
  ],
  "LAMTOR5": [
    "LAMTOR5 cnv",
    "LAMTOR5 methyl",
    "LAMTOR5 proteo",
    "LAMTOR5 rna"
  ],
  "LANCL1": [
    "LANCL1 cnv",
    "LANCL1 methyl",
    "LANCL1 proteo",
    "LANCL1 rna"
  ],
  "LANCL2": [
    "LANCL2 cnv",
    "LANCL2 methyl",
    "LANCL2 proteo",
    "LANCL2 rna"
  ],
  "LANCL3": [
    "LANCL3 methyl",
    "LANCL3 rna"
  ],
  "LAP3": [
    "LAP3 178_180_1_1_S180 phospho",
    "LAP3 cnv",
    "LAP3 methyl",
    "LAP3 proteo",
    "LAP3 rna"
  ],
  "LAPTM4A": [
    "LAPTM4A cnv",
    "LAPTM4A methyl",
    "LAPTM4A rna"
  ],
  "LAPTM4B": [
    "LAPTM4B cnv",
    "LAPTM4B methyl",
    "LAPTM4B rna"
  ],
  "LAPTM5": [
    "LAPTM5 cnv",
    "LAPTM5 rna"
  ],
  "LARGE1": [
    "LARGE1 cnv",
    "LARGE1 methyl",
    "LARGE1 rna"
  ],
  "LARGE2": [
    "LARGE2 cnv",
    "LARGE2 methyl",
    "LARGE2 rna"
  ],
  "LARP1": [
    "LARP1 214_250_2_0 phospho",
    "LARP1 449_453_1_1_T449 phospho",
    "LARP1 449_459_1_1_T449 phospho",
    "LARP1 469_477_1_1_S471 phospho",
    "LARP1 545_556_1_1_S550 phospho",
    "LARP1 545_556_2_2_S550S554 phospho",
    "LARP1 570_575_1_1_T572 phospho",
    "LARP1 689_700_2_2_S689S697 phospho",
    "LARP1 705_711_2_2_T708T711 phospho",
    "LARP1 708_711_1_1_T711 phospho",
    "LARP1 708_711_2_2_T708T711 phospho",
    "LARP1 768_791_1_0 phospho",
    "LARP1 768_791_1_1_S770 phospho",
    "LARP1 768_791_1_1_S774 phospho",
    "LARP1 768_791_2_0 phospho",
    "LARP1 963_963_1_1_S963 phospho",
    "LARP1 cnv",
    "LARP1 methyl",
    "LARP1 proteo",
    "LARP1 rna"
  ],
  "LARP1B": [
    "LARP1B 60_67_1_1_S60 phospho",
    "LARP1B cnv",
    "LARP1B methyl",
    "LARP1B proteo",
    "LARP1B rna"
  ],
  "LARP4": [
    "LARP4 584_597_1_1_S589 phospho",
    "LARP4 600_613_1_1_S603 phospho",
    "LARP4 723_728_1_1_S728 phospho",
    "LARP4 cnv",
    "LARP4 methyl",
    "LARP4 proteo",
    "LARP4 rna"
  ],
  "LARP4B": [
    "LARP4B 510_533_1_0 phospho",
    "LARP4B 510_533_2_0 phospho",
    "LARP4B 510_533_2_1_T518 phospho",
    "LARP4B 599_601_1_1_S601 phospho",
    "LARP4B 692_699_1_1_S699 phospho",
    "LARP4B 698_699_1_1_S699 phospho",
    "LARP4B 753_755_1_1_S753 phospho",
    "LARP4B 766_771_1_1_S771 phospho",
    "LARP4B 766_771_1_1_T767 phospho",
    "LARP4B 766_771_2_0 phospho",
    "LARP4B cnv",
    "LARP4B methyl",
    "LARP4B proteo",
    "LARP4B rna"
  ],
  "LARP4B-DT": [
    "LARP4B-DT methyl"
  ],
  "LARP6": [
    "LARP6 49_63_1_1_S56 phospho",
    "LARP6 cnv",
    "LARP6 methyl",
    "LARP6 proteo",
    "LARP6 rna"
  ],
  "LARP7": [
    "LARP7 261_273_1_1_S268 phospho",
    "LARP7 261_273_2_2_S265S268 phospho",
    "LARP7 305_312_1_1_S305 phospho",
    "LARP7 305_312_1_1_S307 phospho",
    "LARP7 344_351_2_2_S344T345 phospho",
    "LARP7 cnv",
    "LARP7 methyl",
    "LARP7 proteo",
    "LARP7 rna"
  ],
  "LARS1": [
    "LARS1 cnv",
    "LARS1 proteo",
    "LARS1 rna"
  ],
  "LARS2": [
    "LARS2 cnv",
    "LARS2 methyl",
    "LARS2 proteo",
    "LARS2 rna"
  ],
  "LAS1L": [
    "LAS1L 543_543_1_1_S543 phospho",
    "LAS1L 595_602_1_1_S600 phospho",
    "LAS1L methyl",
    "LAS1L proteo",
    "LAS1L rna"
  ],
  "LASP1": [
    "LASP1 134_152_1_0 phospho",
    "LASP1 134_152_1_1_S146 phospho",
    "LASP1 146_152_1_1_S146 phospho",
    "LASP1 61_68_1_1_S61 phospho",
    "LASP1 cnv",
    "LASP1 methyl",
    "LASP1 proteo",
    "LASP1 rna"
  ],
  "LAT": [
    "LAT 191_195_1_1_S195 phospho",
    "LAT cnv",
    "LAT rna"
  ],
  "LAT2": [
    "LAT2 44_55_1_1_S44 phospho",
    "LAT2 cnv",
    "LAT2 rna"
  ],
  "LATS1": [
    "LATS1 139_141_1_1_T141 phospho",
    "LATS1 506_511_1_1_S508 phospho",
    "LATS1 cnv",
    "LATS1 kinase",
    "LATS1 methyl",
    "LATS1 proteo",
    "LATS1 rna"
  ],
  "LATS2": [
    "LATS2 cnv",
    "LATS2 kinase",
    "LATS2 methyl",
    "LATS2 mut",
    "LATS2 rna"
  ],
  "LAX1": [
    "LAX1 cnv",
    "LAX1 rna"
  ],
  "LAYN": [
    "LAYN 299_306_1_1_S299 phospho",
    "LAYN cnv",
    "LAYN methyl",
    "LAYN rna"
  ],
  "LBH": [
    "LBH 63_75_1_1_S63 phospho",
    "LBH cnv",
    "LBH methyl",
    "LBH proteo",
    "LBH rna"
  ],
  "LBHD1": [
    "LBHD1 cnv",
    "LBHD1 methyl",
    "LBHD1 rna"
  ],
  "LBHD2": [
    "LBHD2 cnv",
    "LBHD2 methyl",
    "LBHD2 rna"
  ],
  "LBP": [
    "LBP cnv",
    "LBP proteo",
    "LBP rna"
  ],
  "LBR": [
    "LBR 86_86_1_1_S86 phospho",
    "LBR 97_101_1_1_S97 phospho",
    "LBR 97_101_1_1_S99 phospho",
    "LBR 97_101_2_2_S97S99 phospho",
    "LBR cnv",
    "LBR methyl",
    "LBR proteo",
    "LBR rna"
  ],
  "LBX1": [
    "LBX1 cnv",
    "LBX1 methyl",
    "LBX1 rna"
  ],
  "LBX2": [
    "LBX2 cnv",
    "LBX2 methyl",
    "LBX2 rna"
  ],
  "LBX2-AS1": [
    "LBX2-AS1 methyl"
  ],
  "LCA5": [
    "LCA5 501_505_2_2_S501S505 phospho",
    "LCA5 cnv",
    "LCA5 methyl",
    "LCA5 rna"
  ],
  "LCA5L": [
    "LCA5L cnv",
    "LCA5L methyl",
    "LCA5L rna"
  ],
  "LCAT": [
    "LCAT cnv",
    "LCAT proteo",
    "LCAT rna"
  ],
  "LCE1A": [
    "LCE1A cnv"
  ],
  "LCE1B": [
    "LCE1B cnv"
  ],
  "LCE1C": [
    "LCE1C cnv",
    "LCE1C rna"
  ],
  "LCE1D": [
    "LCE1D cnv",
    "LCE1D rna"
  ],
  "LCE1E": [
    "LCE1E cnv",
    "LCE1E rna"
  ],
  "LCE1F": [
    "LCE1F cnv",
    "LCE1F rna"
  ],
  "LCE2A": [
    "LCE2A cnv"
  ],
  "LCE2B": [
    "LCE2B cnv"
  ],
  "LCE2C": [
    "LCE2C cnv"
  ],
  "LCE2D": [
    "LCE2D cnv"
  ],
  "LCE3A": [
    "LCE3A cnv"
  ],
  "LCE3B": [
    "LCE3B cnv"
  ],
  "LCE3C": [
    "LCE3C cnv"
  ],
  "LCE3D": [
    "LCE3D cnv"
  ],
  "LCE3E": [
    "LCE3E cnv"
  ],
  "LCE4A": [
    "LCE4A cnv"
  ],
  "LCE5A": [
    "LCE5A cnv",
    "LCE5A rna"
  ],
  "LCE6A": [
    "LCE6A cnv"
  ],
  "LCE7A": [
    "LCE7A cnv"
  ],
  "LCK": [
    "LCK cnv",
    "LCK kinase",
    "LCK methyl",
    "LCK rna"
  ],
  "LCLAT1": [
    "LCLAT1 cnv",
    "LCLAT1 methyl",
    "LCLAT1 proteo",
    "LCLAT1 rna"
  ],
  "LCMT1": [
    "LCMT1 cnv",
    "LCMT1 methyl",
    "LCMT1 proteo",
    "LCMT1 rna"
  ],
  "LCMT2": [
    "LCMT2 cnv",
    "LCMT2 methyl",
    "LCMT2 rna"
  ],
  "LCN1": [
    "LCN1 cnv",
    "LCN1 rna"
  ],
  "LCN10": [
    "LCN10 cnv",
    "LCN10 rna"
  ],
  "LCN12": [
    "LCN12 cnv",
    "LCN12 methyl",
    "LCN12 rna"
  ],
  "LCN15": [
    "LCN15 cnv",
    "LCN15 rna"
  ],
  "LCN2": [
    "LCN2 SYNVTSVLFR-N4H5F1S1G0 glyco",
    "LCN2 SYNVTSVLFR-N4H5F2S1G0 glyco",
    "LCN2 cnv",
    "LCN2 proteo",
    "LCN2 rna"
  ],
  "LCN6": [
    "LCN6 cnv",
    "LCN6 methyl",
    "LCN6 rna"
  ],
  "LCN8": [
    "LCN8 cnv",
    "LCN8 rna"
  ],
  "LCN9": [
    "LCN9 cnv",
    "LCN9 rna"
  ],
  "LCNL1": [
    "LCNL1 cnv",
    "LCNL1 rna"
  ],
  "LCOR": [
    "LCOR cnv",
    "LCOR methyl",
    "LCOR rna"
  ],
  "LCORL": [
    "LCORL cnv",
    "LCORL methyl",
    "LCORL rna"
  ],
  "LCP1": [
    "LCP1 5_7_1_1_S5 phospho",
    "LCP1 cnv",
    "LCP1 proteo",
    "LCP1 rna"
  ],
  "LCP2": [
    "LCP2 207_220_1_1_S207 phospho",
    "LCP2 cnv",
    "LCP2 proteo",
    "LCP2 rna"
  ],
  "LCT": [
    "LCT cnv",
    "LCT rna"
  ],
  "LCTL": [
    "LCTL cnv",
    "LCTL rna"
  ],
  "LDAF1": [
    "LDAF1 cnv",
    "LDAF1 methyl",
    "LDAF1 rna"
  ],
  "LDAH": [
    "LDAH cnv",
    "LDAH methyl",
    "LDAH proteo",
    "LDAH rna"
  ],
  "LDB1": [
    "LDB1 402_410_1_1_S410 phospho",
    "LDB1 cnv",
    "LDB1 methyl",
    "LDB1 proteo",
    "LDB1 rna"
  ],
  "LDB2": [
    "LDB2 263_281_1_0 phospho",
    "LDB2 263_281_1_1_S263 phospho",
    "LDB2 cnv",
    "LDB2 rna"
  ],
  "LDB3": [
    "LDB3 cnv",
    "LDB3 rna"
  ],
  "LDHA": [
    "LDHA cnv",
    "LDHA methyl",
    "LDHA proteo",
    "LDHA rna"
  ],
  "LDHAL6A": [
    "LDHAL6A cnv",
    "LDHAL6A methyl",
    "LDHAL6A rna"
  ],
  "LDHAL6B": [
    "LDHAL6B cnv",
    "LDHAL6B methyl",
    "LDHAL6B rna"
  ],
  "LDHB": [
    "LDHB cnv",
    "LDHB methyl",
    "LDHB proteo",
    "LDHB rna"
  ],
  "LDHC": [
    "LDHC cnv",
    "LDHC rna"
  ],
  "LDHD": [
    "LDHD cnv",
    "LDHD proteo",
    "LDHD rna"
  ],
  "LDLR": [
    "LDLR cnv",
    "LDLR methyl",
    "LDLR proteo",
    "LDLR rna"
  ],
  "LDLRAD1": [
    "LDLRAD1 cnv"
  ],
  "LDLRAD2": [
    "LDLRAD2 cnv",
    "LDLRAD2 rna"
  ],
  "LDLRAD3": [
    "LDLRAD3 cnv",
    "LDLRAD3 rna"
  ],
  "LDLRAD4": [
    "LDLRAD4 cnv",
    "LDLRAD4 methyl",
    "LDLRAD4 rna"
  ],
  "LDLRAP1": [
    "LDLRAP1 cnv",
    "LDLRAP1 methyl",
    "LDLRAP1 rna"
  ],
  "LDOC1": [
    "LDOC1 methyl",
    "LDOC1 rna"
  ],
  "LEAP2": [
    "LEAP2 cnv",
    "LEAP2 rna"
  ],
  "LECT2": [
    "LECT2 cnv"
  ],
  "LEF1": [
    "LEF1 cnv",
    "LEF1 methyl",
    "LEF1 proteo",
    "LEF1 rna"
  ],
  "LEF1-AS1": [
    "LEF1-AS1 methyl"
  ],
  "LEFTY1": [
    "LEFTY1 cnv",
    "LEFTY1 methyl",
    "LEFTY1 rna"
  ],
  "LEFTY2": [
    "LEFTY2 cnv",
    "LEFTY2 rna"
  ],
  "LEKR1": [
    "LEKR1 cnv",
    "LEKR1 methyl",
    "LEKR1 rna"
  ],
  "LELP1": [
    "LELP1 cnv"
  ],
  "LEMD1": [
    "LEMD1 cnv",
    "LEMD1 methyl",
    "LEMD1 rna"
  ],
  "LEMD1-DT": [
    "LEMD1-DT methyl"
  ],
  "LEMD2": [
    "LEMD2 134_139_2_2_S138S139 phospho",
    "LEMD2 134_139_3_3_S134S138S139 phospho",
    "LEMD2 cnv",
    "LEMD2 methyl",
    "LEMD2 proteo",
    "LEMD2 rna"
  ],
  "LEMD3": [
    "LEMD3 cnv",
    "LEMD3 methyl",
    "LEMD3 proteo",
    "LEMD3 rna"
  ],
  "LENEP": [
    "LENEP cnv",
    "LENEP rna"
  ],
  "LENG1": [
    "LENG1 cnv",
    "LENG1 methyl",
    "LENG1 proteo",
    "LENG1 rna"
  ],
  "LENG8": [
    "LENG8 cnv",
    "LENG8 methyl",
    "LENG8 proteo",
    "LENG8 rna"
  ],
  "LENG8-AS1": [
    "LENG8-AS1 methyl"
  ],
  "LENG9": [
    "LENG9 cnv",
    "LENG9 methyl",
    "LENG9 rna"
  ],
  "LEO1": [
    "LEO1 162_171_2_2_S162S171 phospho",
    "LEO1 179_179_1_1_S179 phospho",
    "LEO1 212_220_1_1_S212 phospho",
    "LEO1 212_220_2_2_S212S220 phospho",
    "LEO1 629_637_1_1_S630 phospho",
    "LEO1 629_637_2_2_T629S630 phospho",
    "LEO1 655_658_1_1_S658 phospho",
    "LEO1 cnv",
    "LEO1 methyl",
    "LEO1 proteo",
    "LEO1 rna"
  ],
  "LEP": [
    "LEP cnv",
    "LEP methyl",
    "LEP rna"
  ],
  "LEPR": [
    "LEPR cnv",
    "LEPR methyl",
    "LEPR rna"
  ],
  "LEPROT": [
    "LEPROT cnv",
    "LEPROT methyl",
    "LEPROT rna"
  ],
  "LEPROTL1": [
    "LEPROTL1 cnv",
    "LEPROTL1 methyl",
    "LEPROTL1 rna"
  ],
  "LETM1": [
    "LETM1 cnv",
    "LETM1 methyl",
    "LETM1 proteo",
    "LETM1 rna"
  ],
  "LETM2": [
    "LETM2 cnv",
    "LETM2 methyl",
    "LETM2 rna"
  ],
  "LETMD1": [
    "LETMD1 cnv",
    "LETMD1 methyl",
    "LETMD1 proteo",
    "LETMD1 rna"
  ],
  "LETR1": [
    "LETR1 methyl"
  ],
  "LEUTX": [
    "LEUTX cnv"
  ],
  "LEXM": [
    "LEXM cnv",
    "LEXM methyl",
    "LEXM rna"
  ],
  "LFNG": [
    "LFNG cnv",
    "LFNG methyl",
    "LFNG proteo",
    "LFNG rna"
  ],
  "LGALS1": [
    "LGALS1 30_30_1_1_S30 phospho",
    "LGALS1 30_39_1_1_S39 phospho",
    "LGALS1 cnv",
    "LGALS1 proteo",
    "LGALS1 rna"
  ],
  "LGALS12": [
    "LGALS12 cnv",
    "LGALS12 rna"
  ],
  "LGALS13": [
    "LGALS13 cnv"
  ],
  "LGALS14": [
    "LGALS14 cnv"
  ],
  "LGALS16": [
    "LGALS16 cnv"
  ],
  "LGALS2": [
    "LGALS2 cnv",
    "LGALS2 rna"
  ],
  "LGALS3": [
    "LGALS3 cnv",
    "LGALS3 methyl",
    "LGALS3 proteo",
    "LGALS3 rna"
  ],
  "LGALS3BP": [
    "LGALS3BP 442_453_1_1_S444 phospho",
    "LGALS3BP AAIPSALDTNSSK-N2H3F1S0G0 glyco",
    "LGALS3BP AAIPSALDTNSSK-N2H5F0S0G0 glyco",
    "LGALS3BP AAIPSALDTNSSK-N2H6F0S0G0 glyco",
    "LGALS3BP AAIPSALDTNSSK-N2H7F0S0G0 glyco",
    "LGALS3BP AAIPSALDTNSSK-N2H8F0S0G0 glyco",
    "LGALS3BP AAIPSALDTNSSK-N3H4F1S0G0 glyco",
    "LGALS3BP AAIPSALDTNSSK-N3H4F1S1G0 glyco",
    "LGALS3BP AAIPSALDTNSSK-N4H5F0S2G0 glyco",
    "LGALS3BP AAIPSALDTNSSK-N4H5F1S0G0 glyco",
    "LGALS3BP AAIPSALDTNSSK-N4H5F1S1G0 glyco",
    "LGALS3BP AAIPSALDTNSSK-N4H5F1S2G0 glyco",
    "LGALS3BP AAIPSALDTNSSK-N5H4F1S0G0 glyco",
    "LGALS3BP ALGFENATQALGR-N2H3F1S0G0 glyco",
    "LGALS3BP ALGFENATQALGR-N2H5F0S0G0 glyco",
    "LGALS3BP ALGFENATQALGR-N2H6F0S0G0 glyco",
    "LGALS3BP ALGFENATQALGR-N2H7F0S0G0 glyco",
    "LGALS3BP ALGFENATQALGR-N2H8F0S0G0 glyco",
    "LGALS3BP ALGFENATQALGR-N2H9F0S0G0 glyco",
    "LGALS3BP ALGFENATQALGR-N3H4F1S1G0 glyco",
    "LGALS3BP ALGFENATQALGR-N4H5F1S1G0 glyco",
    "LGALS3BP DAGVVCTNETR-N2H3F1S0G0 glyco",
    "LGALS3BP DAGVVCTNETR-N2H4F0S0G0 glyco",
    "LGALS3BP DAGVVCTNETR-N2H5F0S0G0 glyco",
    "LGALS3BP DAGVVCTNETR-N2H6F0S0G0 glyco",
    "LGALS3BP DAGVVCTNETR-N2H8F0S0G0 glyco",
    "LGALS3BP GLNLTEDTYKPR-N2H8F0S0G0 glyco",
    "LGALS3BP TVIRPFYLTNSSGVD-N2H5F0S0G0 glyco",
    "LGALS3BP TVIRPFYLTNSSGVD-N2H6F0S0G0 glyco",
    "LGALS3BP TVIRPFYLTNSSGVD-N2H7F0S0G0 glyco",
    "LGALS3BP TVIRPFYLTNSSGVD-N2H8F0S0G0 glyco",
    "LGALS3BP cnv",
    "LGALS3BP proteo",
    "LGALS3BP rna"
  ],
  "LGALS4": [
    "LGALS4 cnv",
    "LGALS4 rna"
  ],
  "LGALS7": [
    "LGALS7 cnv",
    "LGALS7 rna"
  ],
  "LGALS7B": [
    "LGALS7B cnv",
    "LGALS7B rna"
  ],
  "LGALS8": [
    "LGALS8 cnv",
    "LGALS8 methyl",
    "LGALS8 proteo",
    "LGALS8 rna"
  ],
  "LGALS9": [
    "LGALS9 cnv",
    "LGALS9 proteo",
    "LGALS9 rna"
  ],
  "LGALS9B": [
    "LGALS9B cnv",
    "LGALS9B rna"
  ],
  "LGALS9C": [
    "LGALS9C cnv",
    "LGALS9C rna"
  ],
  "LGALSL": [
    "LGALSL 22_32_1_0 phospho",
    "LGALSL 22_32_1_1_S25 phospho",
    "LGALSL cnv",
    "LGALSL methyl",
    "LGALSL proteo",
    "LGALSL rna"
  ],
  "LGI1": [
    "LGI1 cnv",
    "LGI1 proteo",
    "LGI1 rna"
  ],
  "LGI2": [
    "LGI2 cnv",
    "LGI2 methyl",
    "LGI2 rna"
  ],
  "LGI3": [
    "LGI3 cnv",
    "LGI3 methyl",
    "LGI3 proteo",
    "LGI3 rna"
  ],
  "LGI4": [
    "LGI4 cnv",
    "LGI4 methyl",
    "LGI4 proteo",
    "LGI4 rna"
  ],
  "LGMN": [
    "LGMN DLNETIHYMYK-N2H5F0S0G0 glyco",
    "LGMN DLNETIHYMYK-N2H6F0S0G0 glyco",
    "LGMN DLNETIHYMYK-N2H7F0S0G0 glyco",
    "LGMN cnv",
    "LGMN proteo",
    "LGMN rna"
  ],
  "LGR4": [
    "LGR4 cnv",
    "LGR4 methyl",
    "LGR4 rna"
  ],
  "LGR5": [
    "LGR5 cnv",
    "LGR5 methyl",
    "LGR5 rna"
  ],
  "LGR6": [
    "LGR6 cnv",
    "LGR6 methyl",
    "LGR6 rna"
  ],
  "LGSN": [
    "LGSN cnv",
    "LGSN rna"
  ],
  "LHB": [
    "LHB cnv",
    "LHB methyl",
    "LHB rna"
  ],
  "LHCGR": [
    "LHCGR cnv",
    "LHCGR methyl",
    "LHCGR rna"
  ],
  "LHFPL1": [
    "LHFPL1 rna"
  ],
  "LHFPL2": [
    "LHFPL2 cnv",
    "LHFPL2 methyl",
    "LHFPL2 proteo",
    "LHFPL2 rna"
  ],
  "LHFPL3": [
    "LHFPL3 231_234_1_1_S234 phospho",
    "LHFPL3 cnv",
    "LHFPL3 methyl",
    "LHFPL3 proteo",
    "LHFPL3 rna"
  ],
  "LHFPL4": [
    "LHFPL4 cnv",
    "LHFPL4 methyl",
    "LHFPL4 rna"
  ],
  "LHFPL5": [
    "LHFPL5 cnv",
    "LHFPL5 rna"
  ],
  "LHFPL6": [
    "LHFPL6 cnv",
    "LHFPL6 methyl",
    "LHFPL6 proteo",
    "LHFPL6 rna"
  ],
  "LHFPL7": [
    "LHFPL7 cnv"
  ],
  "LHPP": [
    "LHPP cnv",
    "LHPP methyl",
    "LHPP proteo",
    "LHPP rna"
  ],
  "LHX1": [
    "LHX1 cnv",
    "LHX1 methyl",
    "LHX1 rna"
  ],
  "LHX1-DT": [
    "LHX1-DT methyl"
  ],
  "LHX2": [
    "LHX2 cnv",
    "LHX2 methyl",
    "LHX2 rna"
  ],
  "LHX2-AS1": [
    "LHX2-AS1 methyl"
  ],
  "LHX3": [
    "LHX3 cnv",
    "LHX3 methyl",
    "LHX3 rna"
  ],
  "LHX4": [
    "LHX4 cnv",
    "LHX4 methyl",
    "LHX4 rna"
  ],
  "LHX5": [
    "LHX5 cnv",
    "LHX5 methyl",
    "LHX5 rna"
  ],
  "LHX6": [
    "LHX6 cnv",
    "LHX6 methyl",
    "LHX6 rna"
  ],
  "LHX8": [
    "LHX8 cnv",
    "LHX8 methyl",
    "LHX8 rna"
  ],
  "LHX9": [
    "LHX9 cnv",
    "LHX9 methyl",
    "LHX9 rna"
  ],
  "LIAS": [
    "LIAS cnv",
    "LIAS methyl",
    "LIAS proteo",
    "LIAS rna"
  ],
  "LIF": [
    "LIF cnv",
    "LIF rna"
  ],
  "LIFR": [
    "LIFR 1025_1044_1_1_S1044 phospho",
    "LIFR 887_893_1_1_S887 phospho",
    "LIFR cnv",
    "LIFR methyl",
    "LIFR proteo",
    "LIFR rna"
  ],
  "LIFR-AS1": [
    "LIFR-AS1 methyl"
  ],
  "LIG1": [
    "LIG1 132_141_1_1_S141 phospho",
    "LIG1 182_183_1_1_T183 phospho",
    "LIG1 47_51_1_1_S51 phospho",
    "LIG1 66_76_1_1_S66 phospho",
    "LIG1 66_76_2_2_S66S76 phospho",
    "LIG1 cnv",
    "LIG1 methyl",
    "LIG1 proteo",
    "LIG1 rna"
  ],
  "LIG3": [
    "LIG3 203_210_1_1_S210 phospho",
    "LIG3 227_244_1_1_S242 phospho",
    "LIG3 236_244_1_1_S242 phospho",
    "LIG3 cnv",
    "LIG3 methyl",
    "LIG3 proteo",
    "LIG3 rna"
  ],
  "LIG4": [
    "LIG4 cnv",
    "LIG4 methyl",
    "LIG4 rna"
  ],
  "LILRA1": [
    "LILRA1 cnv",
    "LILRA1 rna"
  ],
  "LILRA2": [
    "LILRA2 cnv",
    "LILRA2 proteo",
    "LILRA2 rna"
  ],
  "LILRA4": [
    "LILRA4 cnv",
    "LILRA4 rna"
  ],
  "LILRA5": [
    "LILRA5 cnv",
    "LILRA5 rna"
  ],
  "LILRA6": [
    "LILRA6 cnv",
    "LILRA6 rna"
  ],
  "LILRB1": [
    "LILRB1 cnv",
    "LILRB1 rna"
  ],
  "LILRB2": [
    "LILRB2 cnv",
    "LILRB2 rna"
  ],
  "LILRB3": [
    "LILRB3 502_514_1_0 phospho",
    "LILRB3 502_514_1_1_S503 phospho",
    "LILRB3 cnv",
    "LILRB3 rna"
  ],
  "LILRB4": [
    "LILRB4 318_319_1_0 phospho",
    "LILRB4 318_319_1_1_S319 phospho",
    "LILRB4 318_330_1_1_S319 phospho",
    "LILRB4 cnv",
    "LILRB4 proteo",
    "LILRB4 rna"
  ],
  "LILRB5": [
    "LILRB5 cnv",
    "LILRB5 rna"
  ],
  "LIM2": [
    "LIM2 cnv"
  ],
  "LIMA1": [
    "LIMA1 132_132_1_1_S132 phospho",
    "LIMA1 225_248_1_0 phospho",
    "LIMA1 225_248_1_1_S225 phospho",
    "LIMA1 336_347_1_1_S343 phospho",
    "LIMA1 351_366_1_1_S363 phospho",
    "LIMA1 351_375_3_0 phospho",
    "LIMA1 369_375_1_0 phospho",
    "LIMA1 369_375_1_1_S375 phospho",
    "LIMA1 369_375_2_0 phospho",
    "LIMA1 55_61_1_1_S61 phospho",
    "LIMA1 589_602_1_1_S602 phospho",
    "LIMA1 618_626_1_1_S618 phospho",
    "LIMA1 667_693_1_1_S687 phospho",
    "LIMA1 672_693_1_1_S687 phospho",
    "LIMA1 672_699_2_2_S687S699 phospho",
    "LIMA1 699_699_1_1_S699 phospho",
    "LIMA1 727_727_1_1_S727 phospho",
    "LIMA1 cnv",
    "LIMA1 methyl",
    "LIMA1 proteo",
    "LIMA1 rna"
  ],
  "LIMCH1": [
    "LIMCH1 10_15_1_1_S15 phospho",
    "LIMCH1 143_149_1_1_S149 phospho",
    "LIMCH1 159_173_1_1_T163 phospho",
    "LIMCH1 223_225_1_1_S223 phospho",
    "LIMCH1 315_324_1_0 phospho",
    "LIMCH1 315_324_1_1_S317 phospho",
    "LIMCH1 315_324_1_1_T318 phospho",
    "LIMCH1 357_371_1_1_S369 phospho",
    "LIMCH1 467_476_1_1_S467 phospho",
    "LIMCH1 47_56_1_1_S47 phospho",
    "LIMCH1 516_527_1_1_S516 phospho",
    "LIMCH1 516_535_1_1_S516 phospho",
    "LIMCH1 564_572_1_1_S564 phospho",
    "LIMCH1 58_63_2_2_T61S63 phospho",
    "LIMCH1 592_599_1_1_S596 phospho",
    "LIMCH1 61_63_1_1_S63 phospho",
    "LIMCH1 71_81_1_1_S77 phospho",
    "LIMCH1 71_81_2_0 phospho",
    "LIMCH1 71_81_2_2_S77S79 phospho",
    "LIMCH1 743_757_1_1_S752 phospho",
    "LIMCH1 811_820_1_1_S818 phospho",
    "LIMCH1 837_847_1_1_S847 phospho",
    "LIMCH1 921_927_1_1_T927 phospho",
    "LIMCH1 cnv",
    "LIMCH1 methyl",
    "LIMCH1 proteo",
    "LIMCH1 rna"
  ],
  "LIMD1": [
    "LIMD1 153_187_1_1_S187 phospho",
    "LIMD1 272_277_1_1_S272 phospho",
    "LIMD1 294_304_1_1_S296 phospho",
    "LIMD1 314_327_1_0 phospho",
    "LIMD1 667_669_1_1_S667 phospho",
    "LIMD1 cnv",
    "LIMD1 methyl",
    "LIMD1 proteo",
    "LIMD1 rna"
  ],
  "LIMD2": [
    "LIMD2 cnv",
    "LIMD2 methyl",
    "LIMD2 proteo",
    "LIMD2 rna"
  ],
  "LIME1": [
    "LIME1 cnv",
    "LIME1 methyl",
    "LIME1 rna"
  ],
  "LIMK1": [
    "LIMK1 210_210_1_1_S210 phospho",
    "LIMK1 253_287_1_1_S271 phospho",
    "LIMK1 296_313_1_1_S298 phospho",
    "LIMK1 cnv",
    "LIMK1 kinase",
    "LIMK1 methyl",
    "LIMK1 proteo",
    "LIMK1 rna"
  ],
  "LIMK2": [
    "LIMK2 cnv",
    "LIMK2 kinase",
    "LIMK2 methyl",
    "LIMK2 proteo",
    "LIMK2 rna"
  ],
  "LIMS1": [
    "LIMS1 cnv",
    "LIMS1 methyl",
    "LIMS1 proteo",
    "LIMS1 rna"
  ],
  "LIMS2": [
    "LIMS2 cnv",
    "LIMS2 methyl",
    "LIMS2 rna"
  ],
  "LIMS3": [
    "LIMS3 cnv",
    "LIMS3 rna"
  ],
  "LIMS4": [
    "LIMS4 cnv",
    "LIMS4 rna"
  ],
  "LIN28A": [
    "LIN28A cnv",
    "LIN28A rna"
  ],
  "LIN28B": [
    "LIN28B cnv",
    "LIN28B methyl",
    "LIN28B rna"
  ],
  "LIN28B-AS1": [
    "LIN28B-AS1 methyl"
  ],
  "LIN37": [
    "LIN37 cnv",
    "LIN37 methyl",
    "LIN37 rna"
  ],
  "LIN52": [
    "LIN52 cnv",
    "LIN52 methyl",
    "LIN52 proteo",
    "LIN52 rna"
  ],
  "LIN54": [
    "LIN54 53_61_1_1_T59 phospho",
    "LIN54 cnv",
    "LIN54 methyl",
    "LIN54 proteo",
    "LIN54 rna"
  ],
  "LIN7A": [
    "LIN7A cnv",
    "LIN7A methyl",
    "LIN7A proteo",
    "LIN7A rna"
  ],
  "LIN7B": [
    "LIN7B 199_205_1_1_S202 phospho",
    "LIN7B cnv",
    "LIN7B methyl",
    "LIN7B proteo",
    "LIN7B rna"
  ],
  "LIN7C": [
    "LIN7C cnv",
    "LIN7C methyl",
    "LIN7C proteo",
    "LIN7C rna"
  ],
  "LIN9": [
    "LIN9 cnv",
    "LIN9 methyl",
    "LIN9 rna"
  ],
  "LINC-PINT": [
    "LINC-PINT methyl"
  ],
  "LINC00092": [
    "LINC00092 methyl"
  ],
  "LINC00115": [
    "LINC00115 methyl"
  ],
  "LINC00205": [
    "LINC00205 methyl"
  ],
  "LINC00221": [
    "LINC00221 methyl"
  ],
  "LINC00237": [
    "LINC00237 methyl"
  ],
  "LINC00240": [
    "LINC00240 methyl"
  ],
  "LINC00261": [
    "LINC00261 methyl"
  ],
  "LINC00301": [
    "LINC00301 methyl"
  ],
  "LINC00327": [
    "LINC00327 methyl"
  ],
  "LINC00334": [
    "LINC00334 methyl"
  ],
  "LINC00336": [
    "LINC00336 methyl"
  ],
  "LINC00339": [
    "LINC00339 methyl"
  ],
  "LINC00350": [
    "LINC00350 methyl"
  ],
  "LINC00354": [
    "LINC00354 methyl"
  ],
  "LINC00391": [
    "LINC00391 methyl"
  ],
  "LINC00398": [
    "LINC00398 methyl"
  ],
  "LINC00421": [
    "LINC00421 methyl"
  ],
  "LINC00449": [
    "LINC00449 methyl"
  ],
  "LINC00461": [
    "LINC00461 methyl"
  ],
  "LINC00471": [
    "LINC00471 methyl"
  ],
  "LINC00472": [
    "LINC00472 methyl"
  ],
  "LINC00484": [
    "LINC00484 methyl"
  ],
  "LINC00485": [
    "LINC00485 methyl"
  ],
  "LINC00506": [
    "LINC00506 methyl"
  ],
  "LINC00511": [
    "LINC00511 methyl"
  ],
  "LINC00554": [
    "LINC00554 methyl"
  ],
  "LINC00567": [
    "LINC00567 methyl"
  ],
  "LINC00571": [
    "LINC00571 methyl"
  ],
  "LINC00574": [
    "LINC00574 methyl"
  ],
  "LINC00605": [
    "LINC00605 methyl"
  ],
  "LINC00612": [
    "LINC00612 methyl"
  ],
  "LINC00629": [
    "LINC00629 methyl"
  ],
  "LINC00636": [
    "LINC00636 methyl"
  ],
  "LINC00649": [
    "LINC00649 methyl"
  ],
  "LINC00662": [
    "LINC00662 methyl"
  ],
  "LINC00664": [
    "LINC00664 methyl"
  ],
  "LINC00665": [
    "LINC00665 methyl"
  ],
  "LINC00667": [
    "LINC00667 methyl"
  ],
  "LINC00668": [
    "LINC00668 methyl"
  ],
  "LINC00672": [
    "LINC00672 cnv",
    "LINC00672 rna"
  ],
  "LINC00677": [
    "LINC00677 methyl"
  ],
  "LINC00680": [
    "LINC00680 methyl"
  ],
  "LINC00682": [
    "LINC00682 methyl"
  ],
  "LINC00839": [
    "LINC00839 methyl"
  ],
  "LINC00847": [
    "LINC00847 methyl"
  ],
  "LINC00857": [
    "LINC00857 methyl"
  ],
  "LINC00863": [
    "LINC00863 methyl"
  ],
  "LINC00869": [
    "LINC00869 methyl"
  ],
  "LINC00879": [
    "LINC00879 methyl"
  ],
  "LINC00886": [
    "LINC00886 methyl"
  ],
  "LINC00888": [
    "LINC00888 methyl"
  ],
  "LINC00933": [
    "LINC00933 methyl"
  ],
  "LINC00937": [
    "LINC00937 methyl"
  ],
  "LINC00954": [
    "LINC00954 methyl"
  ],
  "LINC00960": [
    "LINC00960 methyl"
  ],
  "LINC00987": [
    "LINC00987 methyl"
  ],
  "LINC01013": [
    "LINC01013 methyl"
  ],
  "LINC01019": [
    "LINC01019 methyl"
  ],
  "LINC01023": [
    "LINC01023 methyl"
  ],
  "LINC01044": [
    "LINC01044 methyl"
  ],
  "LINC01089": [
    "LINC01089 methyl"
  ],
  "LINC01115": [
    "LINC01115 methyl"
  ],
  "LINC01118": [
    "LINC01118 methyl"
  ],
  "LINC01124": [
    "LINC01124 methyl"
  ],
  "LINC01126": [
    "LINC01126 methyl"
  ],
  "LINC01128": [
    "LINC01128 methyl"
  ],
  "LINC01134": [
    "LINC01134 methyl"
  ],
  "LINC01140": [
    "LINC01140 methyl"
  ],
  "LINC01143": [
    "LINC01143 methyl"
  ],
  "LINC01144": [
    "LINC01144 methyl"
  ],
  "LINC01159": [
    "LINC01159 methyl"
  ],
  "LINC01191": [
    "LINC01191 methyl"
  ],
  "LINC01201": [
    "LINC01201 methyl"
  ],
  "LINC01210": [
    "LINC01210 methyl"
  ],
  "LINC01233": [
    "LINC01233 methyl"
  ],
  "LINC01237": [
    "LINC01237 methyl"
  ],
  "LINC01254": [
    "LINC01254 methyl"
  ],
  "LINC01285": [
    "LINC01285 methyl"
  ],
  "LINC01305": [
    "LINC01305 methyl"
  ],
  "LINC01342": [
    "LINC01342 methyl"
  ],
  "LINC01356": [
    "LINC01356 methyl"
  ],
  "LINC01381": [
    "LINC01381 methyl"
  ],
  "LINC01395": [
    "LINC01395 methyl"
  ],
  "LINC01409": [
    "LINC01409 methyl"
  ],
  "LINC01410": [
    "LINC01410 methyl"
  ],
  "LINC01414": [
    "LINC01414 methyl"
  ],
  "LINC01431": [
    "LINC01431 methyl"
  ],
  "LINC01475": [
    "LINC01475 methyl"
  ],
  "LINC01535": [
    "LINC01535 methyl"
  ],
  "LINC01547": [
    "LINC01547 methyl"
  ],
  "LINC01551": [
    "LINC01551 methyl"
  ],
  "LINC01558": [
    "LINC01558 methyl"
  ],
  "LINC01572": [
    "LINC01572 methyl"
  ],
  "LINC01586": [
    "LINC01586 methyl"
  ],
  "LINC01600": [
    "LINC01600 methyl"
  ],
  "LINC01607": [
    "LINC01607 methyl"
  ],
  "LINC01624": [
    "LINC01624 methyl"
  ],
  "LINC01635": [
    "LINC01635 methyl"
  ],
  "LINC01637": [
    "LINC01637 methyl"
  ],
  "LINC01664": [
    "LINC01664 methyl"
  ],
  "LINC01679": [
    "LINC01679 methyl"
  ],
  "LINC01686": [
    "LINC01686 methyl"
  ],
  "LINC01694": [
    "LINC01694 methyl"
  ],
  "LINC01704": [
    "LINC01704 methyl"
  ],
  "LINC01725": [
    "LINC01725 methyl"
  ],
  "LINC01726": [
    "LINC01726 methyl"
  ],
  "LINC01749": [
    "LINC01749 methyl"
  ],
  "LINC01750": [
    "LINC01750 methyl"
  ],
  "LINC01757": [
    "LINC01757 methyl"
  ],
  "LINC01775": [
    "LINC01775 methyl"
  ],
  "LINC01780": [
    "LINC01780 methyl"
  ],
  "LINC01783": [
    "LINC01783 methyl"
  ],
  "LINC01801": [
    "LINC01801 methyl"
  ],
  "LINC01833": [
    "LINC01833 methyl"
  ],
  "LINC01838": [
    "LINC01838 methyl"
  ],
  "LINC01842": [
    "LINC01842 methyl"
  ],
  "LINC01852": [
    "LINC01852 methyl"
  ],
  "LINC01918": [
    "LINC01918 methyl"
  ],
  "LINC01925": [
    "LINC01925 methyl"
  ],
  "LINC01970": [
    "LINC01970 methyl"
  ],
  "LINC01976": [
    "LINC01976 methyl"
  ],
  "LINC01979": [
    "LINC01979 methyl"
  ],
  "LINC02004": [
    "LINC02004 methyl"
  ],
  "LINC02011": [
    "LINC02011 methyl"
  ],
  "LINC02018": [
    "LINC02018 methyl"
  ],
  "LINC02021": [
    "LINC02021 methyl"
  ],
  "LINC02028": [
    "LINC02028 methyl"
  ],
  "LINC02110": [
    "LINC02110 methyl"
  ],
  "LINC02116": [
    "LINC02116 methyl"
  ],
  "LINC02125": [
    "LINC02125 methyl"
  ],
  "LINC02175": [
    "LINC02175 methyl"
  ],
  "LINC02182": [
    "LINC02182 methyl"
  ],
  "LINC02202": [
    "LINC02202 methyl"
  ],
  "LINC02203": [
    "LINC02203 cnv",
    "LINC02203 rna"
  ],
  "LINC02210": [
    "LINC02210 methyl"
  ],
  "LINC02210-CRHR1": [
    "LINC02210-CRHR1 cnv",
    "LINC02210-CRHR1 rna"
  ],
  "LINC02218": [
    "LINC02218 cnv",
    "LINC02218 rna"
  ],
  "LINC02226": [
    "LINC02226 methyl"
  ],
  "LINC02235": [
    "LINC02235 methyl"
  ],
  "LINC02245": [
    "LINC02245 methyl"
  ],
  "LINC02256": [
    "LINC02256 methyl"
  ],
  "LINC02259": [
    "LINC02259 methyl"
  ],
  "LINC02282": [
    "LINC02282 methyl"
  ],
  "LINC02292": [
    "LINC02292 methyl"
  ],
  "LINC02323": [
    "LINC02323 methyl"
  ],
  "LINC02356": [
    "LINC02356 methyl"
  ],
  "LINC02361": [
    "LINC02361 methyl"
  ],
  "LINC02381": [
    "LINC02381 methyl"
  ],
  "LINC02395": [
    "LINC02395 methyl"
  ],
  "LINC02453": [
    "LINC02453 methyl"
  ],
  "LINC02572": [
    "LINC02572 methyl"
  ],
  "LINC02585": [
    "LINC02585 methyl"
  ],
  "LINC02591": [
    "LINC02591 methyl"
  ],
  "LINC02593": [
    "LINC02593 methyl"
  ],
  "LINC02603": [
    "LINC02603 methyl"
  ],
  "LINC02606": [
    "LINC02606 methyl"
  ],
  "LINC02608": [
    "LINC02608 methyl"
  ],
  "LINC02609": [
    "LINC02609 methyl"
  ],
  "LINC02610": [
    "LINC02610 methyl"
  ],
  "LINC02614": [
    "LINC02614 methyl"
  ],
  "LINC02622": [
    "LINC02622 methyl"
  ],
  "LINC02696": [
    "LINC02696 methyl"
  ],
  "LINC02709": [
    "LINC02709 methyl"
  ],
  "LINC02714": [
    "LINC02714 methyl"
  ],
  "LINC02724": [
    "LINC02724 methyl"
  ],
  "LINC02746": [
    "LINC02746 methyl"
  ],
  "LINC02774": [
    "LINC02774 methyl"
  ],
  "LINC02777": [
    "LINC02777 methyl"
  ],
  "LINC02828": [
    "LINC02828 methyl"
  ],
  "LINC02872": [
    "LINC02872 methyl"
  ],
  "LINC02875": [
    "LINC02875 methyl"
  ],
  "LINC02894": [
    "LINC02894 methyl"
  ],
  "LINC02897": [
    "LINC02897 methyl"
  ],
  "LINC02901": [
    "LINC02901 methyl"
  ],
  "LINC02983": [
    "LINC02983 methyl"
  ],
  "LINC02987": [
    "LINC02987 methyl"
  ],
  "LINC03006": [
    "LINC03006 methyl"
  ],
  "LINC03008": [
    "LINC03008 methyl"
  ],
  "LINC03009": [
    "LINC03009 methyl"
  ],
  "LINC03011": [
    "LINC03011 methyl"
  ],
  "LINC03014": [
    "LINC03014 methyl"
  ],
  "LINC03026": [
    "LINC03026 methyl"
  ],
  "LINGO1": [
    "LINGO1 591_602_1_1_S596 phospho",
    "LINGO1 596_602_1_1_S596 phospho",
    "LINGO1 cnv",
    "LINGO1 methyl",
    "LINGO1 proteo",
    "LINGO1 rna"
  ],
  "LINGO2": [
    "LINGO2 cnv",
    "LINGO2 methyl",
    "LINGO2 rna"
  ],
  "LINGO3": [
    "LINGO3 cnv",
    "LINGO3 methyl",
    "LINGO3 rna"
  ],
  "LINGO4": [
    "LINGO4 cnv",
    "LINGO4 rna"
  ],
  "LINS1": [
    "LINS1 cnv",
    "LINS1 methyl",
    "LINS1 rna"
  ],
  "LIPA": [
    "LIPA NYFHYNQSYPPTYNVK-N2H3F1S0G0 glyco",
    "LIPA cnv",
    "LIPA methyl",
    "LIPA proteo",
    "LIPA rna"
  ],
  "LIPC": [
    "LIPC cnv",
    "LIPC rna"
  ],
  "LIPE": [
    "LIPE 853_870_1_1_S855 phospho",
    "LIPE 950_962_1_0 phospho",
    "LIPE cnv",
    "LIPE methyl",
    "LIPE proteo",
    "LIPE rna"
  ],
  "LIPE-AS1": [
    "LIPE-AS1 methyl"
  ],
  "LIPF": [
    "LIPF cnv",
    "LIPF rna"
  ],
  "LIPG": [
    "LIPG cnv",
    "LIPG methyl",
    "LIPG rna"
  ],
  "LIPH": [
    "LIPH cnv",
    "LIPH rna"
  ],
  "LIPI": [
    "LIPI cnv",
    "LIPI rna"
  ],
  "LIPJ": [
    "LIPJ cnv",
    "LIPJ rna"
  ],
  "LIPK": [
    "LIPK cnv"
  ],
  "LIPM": [
    "LIPM cnv"
  ],
  "LIPN": [
    "LIPN cnv",
    "LIPN rna"
  ],
  "LIPT1": [
    "LIPT1 cnv",
    "LIPT1 methyl",
    "LIPT1 rna"
  ],
  "LIPT2": [
    "LIPT2 cnv",
    "LIPT2 methyl",
    "LIPT2 rna"
  ],
  "LIPT2-AS1": [
    "LIPT2-AS1 methyl"
  ],
  "LITAF": [
    "LITAF cnv",
    "LITAF methyl",
    "LITAF rna"
  ],
  "LITAFD": [
    "LITAFD cnv",
    "LITAFD rna"
  ],
  "LIX1": [
    "LIX1 cnv",
    "LIX1 rna"
  ],
  "LIX1L": [
    "LIX1L cnv",
    "LIX1L methyl",
    "LIX1L proteo",
    "LIX1L rna"
  ],
  "LIX1L-AS1": [
    "LIX1L-AS1 methyl"
  ],
  "LKAAEAR1": [
    "LKAAEAR1 cnv",
    "LKAAEAR1 methyl",
    "LKAAEAR1 rna"
  ],
  "LLCFC1": [
    "LLCFC1 cnv",
    "LLCFC1 rna"
  ],
  "LLGL1": [
    "LLGL1 704_704_1_1_T704 phospho",
    "LLGL1 cnv",
    "LLGL1 methyl",
    "LLGL1 proteo",
    "LLGL1 rna"
  ],
  "LLGL2": [
    "LLGL2 cnv",
    "LLGL2 methyl",
    "LLGL2 rna"
  ],
  "LLPH": [
    "LLPH cnv",
    "LLPH methyl",
    "LLPH proteo",
    "LLPH rna"
  ],
  "LLPH-DT": [
    "LLPH-DT methyl"
  ],
  "LMAN1": [
    "LMAN1 cnv",
    "LMAN1 methyl",
    "LMAN1 proteo",
    "LMAN1 rna"
  ],
  "LMAN1L": [
    "LMAN1L cnv",
    "LMAN1L rna"
  ],
  "LMAN2": [
    "LMAN2 VFPYISVMVNNGSLSYDHSK-N4H3F1S0G0 glyco",
    "LMAN2 VFPYISVMVNNGSLSYDHSK-N5H3F1S0G0 glyco",
    "LMAN2 cnv",
    "LMAN2 methyl",
    "LMAN2 proteo",
    "LMAN2 rna"
  ],
  "LMAN2L": [
    "LMAN2L VFPYISAMVNNGSLSYDHER-N4H3F1S0G0 glyco",
    "LMAN2L cnv",
    "LMAN2L methyl",
    "LMAN2L proteo",
    "LMAN2L rna"
  ],
  "LMBR1": [
    "LMBR1 cnv",
    "LMBR1 methyl",
    "LMBR1 proteo",
    "LMBR1 rna"
  ],
  "LMBR1L": [
    "LMBR1L cnv",
    "LMBR1L methyl",
    "LMBR1L rna"
  ],
  "LMBRD1": [
    "LMBRD1 NQNGTFK-N2H5F0S0G0 glyco",
    "LMBRD1 NQNGTFK-N2H7F0S0G0 glyco",
    "LMBRD1 cnv",
    "LMBRD1 methyl",
    "LMBRD1 proteo",
    "LMBRD1 rna"
  ],
  "LMBRD2": [
    "LMBRD2 cnv",
    "LMBRD2 methyl",
    "LMBRD2 proteo",
    "LMBRD2 rna"
  ],
  "LMCD1": [
    "LMCD1 cnv",
    "LMCD1 methyl",
    "LMCD1 proteo",
    "LMCD1 rna"
  ],
  "LMCD1-AS1": [
    "LMCD1-AS1 methyl"
  ],
  "LMF1": [
    "LMF1 cnv",
    "LMF1 methyl",
    "LMF1 proteo",
    "LMF1 rna"
  ],
  "LMF2": [
    "LMF2 SANSTLAQALHWTR-N2H6F0S0G0 glyco",
    "LMF2 SANSTLAQALHWTR-N2H7F0S0G0 glyco",
    "LMF2 SANSTLAQALHWTR-N2H8F0S0G0 glyco",
    "LMF2 cnv",
    "LMF2 methyl",
    "LMF2 proteo",
    "LMF2 rna"
  ],
  "LMLN": [
    "LMLN cnv",
    "LMLN methyl",
    "LMLN rna"
  ],
  "LMNA": [
    "LMNA 12_24_2_2_T19S22 phospho",
    "LMNA 390_395_2_2_S390S392 phospho",
    "LMNA 403_416_2_2_S403S407 phospho",
    "LMNA 403_416_3_2_S406S407 phospho",
    "LMNA cnv",
    "LMNA methyl",
    "LMNA proteo",
    "LMNA rna"
  ],
  "LMNB1": [
    "LMNB1 19_25_2_2_T20S23 phospho",
    "LMNB1 cnv",
    "LMNB1 methyl",
    "LMNB1 proteo",
    "LMNB1 rna"
  ],
  "LMNB1-DT": [
    "LMNB1-DT methyl"
  ],
  "LMNB2": [
    "LMNB2 316_322_1_1_S316 phospho",
    "LMNB2 cnv",
    "LMNB2 methyl",
    "LMNB2 proteo",
    "LMNB2 rna"
  ],
  "LMNTD1": [
    "LMNTD1 cnv",
    "LMNTD1 rna"
  ],
  "LMNTD2": [
    "LMNTD2 cnv",
    "LMNTD2 methyl",
    "LMNTD2 rna"
  ],
  "LMO1": [
    "LMO1 cnv",
    "LMO1 methyl",
    "LMO1 rna"
  ],
  "LMO2": [
    "LMO2 cnv",
    "LMO2 methyl",
    "LMO2 rna"
  ],
  "LMO3": [
    "LMO3 cnv",
    "LMO3 rna"
  ],
  "LMO4": [
    "LMO4 cnv",
    "LMO4 methyl",
    "LMO4 proteo",
    "LMO4 rna"
  ],
  "LMO7": [
    "LMO7 1087_1098_1_1_S1089 phospho",
    "LMO7 1157_1166_1_1_S1159 phospho",
    "LMO7 1176_1182_1_1_S1176 phospho",
    "LMO7 1242_1254_1_1_S1252 phospho",
    "LMO7 1257_1267_1_1_S1259 phospho",
    "LMO7 246_255_1_1_S246 phospho",
    "LMO7 300_300_1_1_S300 phospho",
    "LMO7 342_356_1_1_S342 phospho",
    "LMO7 417_420_1_1_S417 phospho",
    "LMO7 524_545_1_1_S533 phospho",
    "LMO7 645_670_1_0 phospho",
    "LMO7 673_692_1_1_S692 phospho",
    "LMO7 673_698_1_1_S692 phospho",
    "LMO7 cnv",
    "LMO7 methyl",
    "LMO7 proteo",
    "LMO7 rna"
  ],
  "LMO7-AS1": [
    "LMO7-AS1 methyl"
  ],
  "LMOD1": [
    "LMOD1 119_119_1_1_S119 phospho",
    "LMOD1 85_89_1_1_S85 phospho",
    "LMOD1 cnv",
    "LMOD1 proteo",
    "LMOD1 rna"
  ],
  "LMOD2": [
    "LMOD2 cnv",
    "LMOD2 rna"
  ],
  "LMOD3": [
    "LMOD3 cnv",
    "LMOD3 rna"
  ],
  "LMTK2": [
    "LMTK2 883_893_1_1_S886 phospho",
    "LMTK2 cnv",
    "LMTK2 kinase",
    "LMTK2 methyl",
    "LMTK2 proteo",
    "LMTK2 rna"
  ],
  "LMTK3": [
    "LMTK3 1010_1010_1_1_S1010 phospho",
    "LMTK3 261_261_1_1_S261 phospho",
    "LMTK3 cnv",
    "LMTK3 kinase",
    "LMTK3 methyl",
    "LMTK3 proteo",
    "LMTK3 rna"
  ],
  "LMX1A": [
    "LMX1A cnv",
    "LMX1A methyl",
    "LMX1A rna"
  ],
  "LMX1B": [
    "LMX1B cnv",
    "LMX1B methyl",
    "LMX1B rna"
  ],
  "LNC-LBCS": [
    "LNC-LBCS methyl"
  ],
  "LNCOC1": [
    "LNCOC1 methyl"
  ],
  "LNCRNA-IUR": [
    "LNCRNA-IUR methyl"
  ],
  "LNCTAM34A": [
    "LNCTAM34A methyl"
  ],
  "LNP1": [
    "LNP1 47_48_1_1_S48 phospho",
    "LNP1 70_70_1_1_S70 phospho",
    "LNP1 cnv",
    "LNP1 methyl",
    "LNP1 rna"
  ],
  "LNPEP": [
    "LNPEP NQSIGLIQPFATNGK-N2H6F0S0G0 glyco",
    "LNPEP NQSIGLIQPFATNGK-N2H7F0S0G0 glyco",
    "LNPEP NQSIGLIQPFATNGK-N2H8F0S0G0 glyco",
    "LNPEP cnv",
    "LNPEP methyl",
    "LNPEP proteo",
    "LNPEP rna"
  ],
  "LNPK": [
    "LNPK 243_260_1_0 phospho",
    "LNPK 243_260_1_1_S248 phospho",
    "LNPK 243_260_1_1_S260 phospho",
    "LNPK 450_452_1_1_S450 phospho",
    "LNPK cnv",
    "LNPK methyl",
    "LNPK proteo",
    "LNPK rna"
  ],
  "LNX1": [
    "LNX1 cnv",
    "LNX1 rna"
  ],
  "LNX2": [
    "LNX2 cnv",
    "LNX2 methyl",
    "LNX2 rna"
  ],
  "LOH12CR2": [
    "LOH12CR2 methyl"
  ],
  "LONP1": [
    "LONP1 cnv",
    "LONP1 methyl",
    "LONP1 proteo",
    "LONP1 rna"
  ],
  "LONP2": [
    "LONP2 cnv",
    "LONP2 proteo",
    "LONP2 rna"
  ],
  "LONRF1": [
    "LONRF1 cnv",
    "LONRF1 methyl",
    "LONRF1 rna"
  ],
  "LONRF2": [
    "LONRF2 cnv",
    "LONRF2 methyl",
    "LONRF2 proteo",
    "LONRF2 rna"
  ],
  "LONRF3": [
    "LONRF3 methyl",
    "LONRF3 rna"
  ],
  "LORICRIN": [
    "LORICRIN cnv",
    "LORICRIN rna"
  ],
  "LOX": [
    "LOX cnv",
    "LOX methyl",
    "LOX proteo",
    "LOX rna"
  ],
  "LOXHD1": [
    "LOXHD1 cnv",
    "LOXHD1 methyl",
    "LOXHD1 rna"
  ],
  "LOXL1": [
    "LOXL1 cnv",
    "LOXL1 methyl",
    "LOXL1 proteo",
    "LOXL1 rna"
  ],
  "LOXL1-AS1": [
    "LOXL1-AS1 methyl"
  ],
  "LOXL2": [
    "LOXL2 cnv",
    "LOXL2 methyl",
    "LOXL2 proteo",
    "LOXL2 rna"
  ],
  "LOXL3": [
    "LOXL3 cnv",
    "LOXL3 methyl",
    "LOXL3 proteo",
    "LOXL3 rna"
  ],
  "LOXL4": [
    "LOXL4 cnv",
    "LOXL4 methyl",
    "LOXL4 rna"
  ],
  "LPA": [
    "LPA cnv",
    "LPA proteo",
    "LPA rna"
  ],
  "LPAR1": [
    "LPAR1 344_362_1_0 phospho",
    "LPAR1 344_362_1_1_S346 phospho",
    "LPAR1 344_362_1_1_S358 phospho",
    "LPAR1 cnv",
    "LPAR1 methyl",
    "LPAR1 proteo",
    "LPAR1 rna"
  ],
  "LPAR2": [
    "LPAR2 cnv",
    "LPAR2 methyl",
    "LPAR2 rna"
  ],
  "LPAR3": [
    "LPAR3 cnv",
    "LPAR3 methyl",
    "LPAR3 rna"
  ],
  "LPAR4": [
    "LPAR4 rna"
  ],
  "LPAR5": [
    "LPAR5 cnv",
    "LPAR5 rna"
  ],
  "LPAR6": [
    "LPAR6 cnv",
    "LPAR6 rna"
  ],
  "LPCAT1": [
    "LPCAT1 cnv",
    "LPCAT1 methyl",
    "LPCAT1 proteo",
    "LPCAT1 rna"
  ],
  "LPCAT2": [
    "LPCAT2 cnv",
    "LPCAT2 methyl",
    "LPCAT2 proteo",
    "LPCAT2 rna"
  ],
  "LPCAT3": [
    "LPCAT3 cnv",
    "LPCAT3 methyl",
    "LPCAT3 proteo",
    "LPCAT3 rna"
  ],
  "LPCAT4": [
    "LPCAT4 cnv",
    "LPCAT4 methyl",
    "LPCAT4 proteo",
    "LPCAT4 rna"
  ],
  "LPGAT1": [
    "LPGAT1 cnv",
    "LPGAT1 methyl",
    "LPGAT1 proteo",
    "LPGAT1 rna"
  ],
  "LPGAT1-AS1": [
    "LPGAT1-AS1 methyl"
  ],
  "LPIN1": [
    "LPIN1 168_172_1_1_S168 phospho",
    "LPIN1 cnv",
    "LPIN1 methyl",
    "LPIN1 proteo",
    "LPIN1 rna"
  ],
  "LPIN2": [
    "LPIN2 102_110_1_1_S106 phospho",
    "LPIN2 287_296_1_1_T291 phospho",
    "LPIN2 cnv",
    "LPIN2 methyl",
    "LPIN2 proteo",
    "LPIN2 rna"
  ],
  "LPIN3": [
    "LPIN3 cnv",
    "LPIN3 methyl",
    "LPIN3 rna"
  ],
  "LPL": [
    "LPL cnv",
    "LPL proteo",
    "LPL rna"
  ],
  "LPO": [
    "LPO cnv",
    "LPO rna"
  ],
  "LPP": [
    "LPP 332_349_1_1_T333 phospho",
    "LPP cnv",
    "LPP methyl",
    "LPP proteo",
    "LPP rna"
  ],
  "LPP-AS2": [
    "LPP-AS2 methyl"
  ],
  "LPXN": [
    "LPXN 19_39_1_1_S24 phospho",
    "LPXN 332_342_1_1_T332 phospho",
    "LPXN cnv",
    "LPXN methyl",
    "LPXN proteo",
    "LPXN rna"
  ],
  "LRAT": [
    "LRAT cnv",
    "LRAT methyl",
    "LRAT rna"
  ],
  "LRATD1": [
    "LRATD1 62_69_1_1_S67 phospho",
    "LRATD1 cnv",
    "LRATD1 methyl",
    "LRATD1 proteo",
    "LRATD1 rna"
  ],
  "LRATD2": [
    "LRATD2 288_300_1_1_S300 phospho",
    "LRATD2 288_300_1_1_T289 phospho",
    "LRATD2 cnv",
    "LRATD2 methyl",
    "LRATD2 proteo",
    "LRATD2 rna"
  ],
  "LRBA": [
    "LRBA 1118_1139_1_1_S1118 phospho",
    "LRBA 1231_1237_1_1_S1231 phospho",
    "LRBA 1733_1770_1_1_S1767 phospho",
    "LRBA cnv",
    "LRBA methyl",
    "LRBA proteo",
    "LRBA rna"
  ],
  "LRCH1": [
    "LRCH1 532_542_1_1_S536 phospho",
    "LRCH1 cnv",
    "LRCH1 methyl",
    "LRCH1 proteo",
    "LRCH1 rna"
  ],
  "LRCH2": [
    "LRCH2 493_495_1_1_S495 phospho",
    "LRCH2 proteo",
    "LRCH2 rna"
  ],
  "LRCH3": [
    "LRCH3 324_333_1_1_S324 phospho",
    "LRCH3 415_419_1_1_S415 phospho",
    "LRCH3 cnv",
    "LRCH3 methyl",
    "LRCH3 proteo",
    "LRCH3 rna"
  ],
  "LRCH4": [
    "LRCH4 267_281_1_1_S281 phospho",
    "LRCH4 cnv",
    "LRCH4 methyl",
    "LRCH4 proteo",
    "LRCH4 rna"
  ],
  "LRCOL1": [
    "LRCOL1 cnv",
    "LRCOL1 methyl",
    "LRCOL1 rna"
  ],
  "LRFN1": [
    "LRFN1 704_719_1_1_S718 phospho",
    "LRFN1 cnv",
    "LRFN1 proteo",
    "LRFN1 rna"
  ],
  "LRFN2": [
    "LRFN2 cnv",
    "LRFN2 methyl",
    "LRFN2 rna"
  ],
  "LRFN3": [
    "LRFN3 cnv",
    "LRFN3 methyl",
    "LRFN3 proteo",
    "LRFN3 rna"
  ],
  "LRFN4": [
    "LRFN4 554_567_1_1_S565 phospho",
    "LRFN4 575_575_1_1_S575 phospho",
    "LRFN4 583_596_1_1_S585 phospho",
    "LRFN4 608_610_1_1_S610 phospho",
    "LRFN4 cnv",
    "LRFN4 methyl",
    "LRFN4 rna"
  ],
  "LRFN5": [
    "LRFN5 cnv",
    "LRFN5 methyl",
    "LRFN5 proteo",
    "LRFN5 rna"
  ],
  "LRG1": [
    "LRG1 LPPGLLANFTLLR-N4H5F0S2G0 glyco",
    "LRG1 cnv",
    "LRG1 proteo",
    "LRG1 rna"
  ],
  "LRGUK": [
    "LRGUK cnv",
    "LRGUK methyl",
    "LRGUK rna"
  ],
  "LRIF1": [
    "LRIF1 cnv",
    "LRIF1 methyl",
    "LRIF1 proteo",
    "LRIF1 rna"
  ],
  "LRIG1": [
    "LRIG1 1029_1058_1_0 phospho",
    "LRIG1 1069_1076_1_1_S1069 phospho",
    "LRIG1 LHELVLSFNNLTR-N2H5F0S0G0 glyco",
    "LRIG1 SLNLSYNK-N2H5F0S0G0 glyco",
    "LRIG1 SLNLSYNK-N2H6F0S0G0 glyco",
    "LRIG1 SLNLSYNK-N2H7F0S0G0 glyco",
    "LRIG1 cnv",
    "LRIG1 methyl",
    "LRIG1 proteo",
    "LRIG1 rna"
  ],
  "LRIG2": [
    "LRIG2 cnv",
    "LRIG2 methyl",
    "LRIG2 rna"
  ],
  "LRIG2-DT": [
    "LRIG2-DT methyl"
  ],
  "LRIG3": [
    "LRIG3 cnv",
    "LRIG3 methyl",
    "LRIG3 rna"
  ],
  "LRIT1": [
    "LRIT1 cnv",
    "LRIT1 rna"
  ],
  "LRIT2": [
    "LRIT2 cnv",
    "LRIT2 rna"
  ],
  "LRIT3": [
    "LRIT3 cnv",
    "LRIT3 rna"
  ],
  "LRMDA": [
    "LRMDA 174_181_1_1_S181 phospho",
    "LRMDA cnv",
    "LRMDA methyl",
    "LRMDA proteo",
    "LRMDA rna"
  ],
  "LRP1": [
    "LRP1 4460_4473_1_1_T4460 phospho",
    "LRP1 4520_4524_1_1_S4523 phospho",
    "LRP1 4520_4524_2_2_S4520S4523 phospho",
    "LRP1 AFINGTGVETVVSADLPNAHGLAVDWVSR-N3H3F0S0G0 glyco",
    "LRP1 CDMDGQNR-N2H4F0S0G0 glyco",
    "LRP1 CDMDGQNR-N2H5F0S0G0 glyco",
    "LRP1 CNASSQFLCSSGR-N2H5F0S0G0 glyco",
    "LRP1 CNASSQFLCSSGR-N5H3F1S0G0 glyco",
    "LRP1 DGTCIGNSSR-N2H3F0S0G0 glyco",
    "LRP1 DGTCIGNSSR-N2H4F0S0G0 glyco",
    "LRP1 DGTCIGNSSR-N2H5F0S0G0 glyco",
    "LRP1 DNTTCYEFK-N2H5F0S0G0 glyco",
    "LRP1 DNTTCYEFKK-N2H5F0S0G0 glyco",
    "LRP1 FGTCSQLCNNTK-N2H4F0S0G0 glyco",
    "LRP1 FGTCSQLCNNTK-N2H5F0S0G0 glyco",
    "LRP1 FGTCSQLCNNTK-N2H6F0S0G0 glyco",
    "LRP1 FGTCSQLCNNTK-N2H7F0S0G0 glyco",
    "LRP1 FGTCSQLCNNTK-N2H8F0S0G0 glyco",
    "LRP1 FGTCSQLCNNTK-N3H4F1S0G0 glyco",
    "LRP1 FGTCSQLCNNTK-N3H5F0S0G0 glyco",
    "LRP1 FGTCSQLCNNTK-N3H5F1S0G0 glyco",
    "LRP1 FGTCSQLCNNTK-N3H6F0S0G0 glyco",
    "LRP1 FGTCSQLCNNTK-N4H4F1S0G0 glyco",
    "LRP1 FGTCSQLCNNTK-N4H5F0S0G0 glyco",
    "LRP1 FGTCSQLCNNTK-N4H5F1S0G0 glyco",
    "LRP1 FNSTEYQVVTR-N2H4F0S0G0 glyco",
    "LRP1 FNSTEYQVVTR-N2H5F0S0G0 glyco",
    "LRP1 GVTHLNISGLK-N2H10F0S0G0 glyco",
    "LRP1 GVTHLNISGLK-N2H5F0S0G0 glyco",
    "LRP1 GVTHLNISGLK-N2H8F0S0G0 glyco",
    "LRP1 GVTHLNISGLK-N4H3F1S0G0 glyco",
    "LRP1 GVTHLNISGLK-N4H4F1S0G0 glyco",
    "LRP1 GVTHLNISGLK-N4H5F0S0G0 glyco",
    "LRP1 GVTHLNISGLK-N4H5F1S0G0 glyco",
    "LRP1 GVTHLNISGLK-N4H5F1S1G0 glyco",
    "LRP1 GVTHLNISGLK-N5H3F1S0G0 glyco",
    "LRP1 GVTHLNISGLK-N5H4F1S0G0 glyco",
    "LRP1 IETILLNGTDR-N2H5F0S0G0 glyco",
    "LRP1 INNGGCQDLCLLTHQGHVNCSCR-N2H5F0S0G0 glyco",
    "LRP1 INNGGCQDLCLLTHQGHVNCSCR-N3H3F0S0G0 glyco",
    "LRP1 LGCQHHCVPTLDGPTCYCNSSFQLQADGK-N5H3F1S0G0 glyco",
    "LRP1 LGCQHHCVPTLDGPTCYCNSSFQLQADGK-N5H4F0S0G0 glyco",
    "LRP1 LNGTDPIVAADSK-N2H5F0S0G0 glyco",
    "LRP1 LNGTDPIVAADSK-N2H6F0S0G0 glyco",
    "LRP1 LNGTDPIVAADSK-N2H7F0S0G0 glyco",
    "LRP1 LNGTDPIVAADSK-N2H8F0S0G0 glyco",
    "LRP1 LNGTDPIVAADSK-N4H5F0S1G0 glyco",
    "LRP1 LNGTDPIVAADSKR-N2H5F0S0G0 glyco",
    "LRP1 LNGTDPIVAADSKR-N2H6F0S0G0 glyco",
    "LRP1 LNLDGSNYTLLK-N2H8F0S0G0 glyco",
    "LRP1 LNLDGSNYTLLK-N2H9F0S0G0 glyco",
    "LRP1 LNLDGSNYTLLK-N4H3F1S0G0 glyco",
    "LRP1 LNLDGSNYTLLK-N5H3F1S0G0 glyco",
    "LRP1 LNLDGSNYTLLK-N5H4F1S0G0 glyco",
    "LRP1 LNLDGSNYTLLK-N5H4F2S0G0 glyco",
    "LRP1 LNLDGSNYTLLK-N6H3F1S0G0 glyco",
    "LRP1 LTSCATNASICGDEAR-N2H3F1S0G0 glyco",
    "LRP1 LTSCATNASICGDEAR-N3H3F1S0G0 glyco",
    "LRP1 LTSCATNASICGDEAR-N5H3F1S0G0 glyco",
    "LRP1 LYWISSGNHTINR-N2H5F0S0G0 glyco",
    "LRP1 LYWISSGNHTINR-N2H6F0S0G0 glyco",
    "LRP1 LYWISSGNHTINR-N2H7F0S0G0 glyco",
    "LRP1 MHLNGSNVQVLHR-N2H8F0S0G0 glyco",
    "LRP1 MHLNGSNVQVLHR-N2H9F0S0G0 glyco",
    "LRP1 MHLNGSNVQVLHR-N4H3F1S0G0 glyco",
    "LRP1 MHLNGSNVQVLHR-N4H4F1S0G0 glyco",
    "LRP1 MHLNGSNVQVLHR-N4H4F1S1G0 glyco",
    "LRP1 MHLNGSNVQVLHR-N4H4F2S0G0 glyco",
    "LRP1 MHLNGSNVQVLHR-N4H5F1S0G0 glyco",
    "LRP1 MHLNGSNVQVLHR-N4H5F1S1G0 glyco",
    "LRP1 MHLNGSNVQVLHR-N5H3F1S0G0 glyco",
    "LRP1 MHLNGSNVQVLHR-N5H4F1S0G0 glyco",
    "LRP1 MHLNGSNVQVLHR-N5H4F2S0G0 glyco",
    "LRP1 NSTTLVMHMK-N2H3F0S0G0 glyco",
    "LRP1 NSTTLVMHMK-N2H4F0S0G0 glyco",
    "LRP1 NSTTLVMHMK-N2H5F0S0G0 glyco",
    "LRP1 NSTTLVMHMK-N2H6F0S0G0 glyco",
    "LRP1 NSTTLVMHMK-N2H7F0S0G0 glyco",
    "LRP1 NSTTLVMHMK-N2H9F0S0G0 glyco",
    "LRP1 QPMAPNPCEANGGQGPCSHLCLINYNR-N2H5F0S0G0 glyco",
    "LRP1 QSGDVTCNCTDGR-N2H3F1S0G0 glyco",
    "LRP1 QSGDVTCNCTDGR-N2H8F0S0G0 glyco",
    "LRP1 QTTAMDFSYANETVCWVHVGDSAAQTQLK-N2H5F0S0G0 glyco",
    "LRP1 TCVSNCTASQFVCK-N2H5F0S0G0 glyco",
    "LRP1 TCVSNCTASQFVCK-N3H3F1S0G0 glyco",
    "LRP1 TCVSNCTASQFVCK-N4H3F1S0G0 glyco",
    "LRP1 TCVSNCTASQFVCK-N4H5F1S0G0 glyco",
    "LRP1 TCVSNCTASQFVCK-N4H5F1S1G0 glyco",
    "LRP1 TCVSNCTASQFVCK-N4H5F1S2G0 glyco",
    "LRP1 TCVSNCTASQFVCK-N5H3F1S0G0 glyco",
    "LRP1 THANGSIK-N2H3F1S0G0 glyco",
    "LRP1 THANGSIK-N2H5F0S0G0 glyco",
    "LRP1 THANGSIK-N2H6F0S0G0 glyco",
    "LRP1 THANGSIK-N2H8F0S0G0 glyco",
    "LRP1 THANGSIK-N2H9F0S0G0 glyco",
    "LRP1 THANGSIK-N3H3F1S0G0 glyco",
    "LRP1 THANGSIK-N3H4F2S0G0 glyco",
    "LRP1 THANGSIK-N3H5F2S0G0 glyco",
    "LRP1 THANGSIK-N4H3F1S0G0 glyco",
    "LRP1 THANGSIK-N4H4F1S0G0 glyco",
    "LRP1 THANGSIK-N4H5F1S0G0 glyco",
    "LRP1 THANGSIK-N5H3F1S0G0 glyco",
    "LRP1 THANGSIK-N5H4F1S0G0 glyco",
    "LRP1 VDIPQQPMGIIAVANDTNSCELSPCR-N2H5F0S0G0 glyco",
    "LRP1 VNRFNSTEYQVVTR-N2H5F0S0G0 glyco",
    "LRP1 WTGHNVTVVQR-N2H5F0S0G0 glyco",
    "LRP1 WTGHNVTVVQR-N5H3F1S0G0 glyco",
    "LRP1 cnv",
    "LRP1 methyl",
    "LRP1 proteo",
    "LRP1 rna"
  ],
  "LRP10": [
    "LRP10 cnv",
    "LRP10 methyl",
    "LRP10 proteo",
    "LRP10 rna"
  ],
  "LRP11": [
    "LRP11 cnv",
    "LRP11 methyl",
    "LRP11 rna"
  ],
  "LRP12": [
    "LRP12 cnv",
    "LRP12 methyl",
    "LRP12 rna"
  ],
  "LRP1B": [
    "LRP1B ADEFLCNNSLCK-N2H5F0S0G0 glyco",
    "LRP1B AFINGTGLETVISR-N2H5F0S0G0 glyco",
    "LRP1B AFINGTGLETVISR-N2H7F0S0G0 glyco",
    "LRP1B LYWISSGNGTINR-N2H5F0S0G0 glyco",
    "LRP1B TCLSNCTASQFR-N2H5F0S0G0 glyco",
    "LRP1B VGMDGTNQSVVIETK-N2H5F0S0G0 glyco",
    "LRP1B VGMDGTNQSVVIETK-N2H6F0S0G0 glyco",
    "LRP1B cnv",
    "LRP1B methyl",
    "LRP1B proteo",
    "LRP1B rna"
  ],
  "LRP2": [
    "LRP2 cnv",
    "LRP2 methyl",
    "LRP2 rna"
  ],
  "LRP2BP": [
    "LRP2BP cnv",
    "LRP2BP methyl",
    "LRP2BP rna"
  ],
  "LRP3": [
    "LRP3 cnv",
    "LRP3 methyl",
    "LRP3 rna"
  ],
  "LRP4": [
    "LRP4 1887_1891_1_1_S1887 phospho",
    "LRP4 cnv",
    "LRP4 methyl",
    "LRP4 proteo",
    "LRP4 rna"
  ],
  "LRP4-AS1": [
    "LRP4-AS1 methyl"
  ],
  "LRP5": [
    "LRP5 cnv",
    "LRP5 methyl",
    "LRP5 rna"
  ],
  "LRP6": [
    "LRP6 1479_1493_1_1_S1490 phospho",
    "LRP6 cnv",
    "LRP6 methyl",
    "LRP6 proteo",
    "LRP6 rna"
  ],
  "LRP8": [
    "LRP8 cnv",
    "LRP8 methyl",
    "LRP8 proteo",
    "LRP8 rna"
  ],
  "LRP8-DT": [
    "LRP8-DT methyl"
  ],
  "LRPAP1": [
    "LRPAP1 242_248_1_1_S247 phospho",
    "LRPAP1 310_310_1_1_S310 phospho",
    "LRPAP1 50_50_1_1_S50 phospho",
    "LRPAP1 cnv",
    "LRPAP1 methyl",
    "LRPAP1 proteo",
    "LRPAP1 rna"
  ],
  "LRPPRC": [
    "LRPPRC cnv",
    "LRPPRC methyl",
    "LRPPRC proteo",
    "LRPPRC rna"
  ],
  "LRR1": [
    "LRR1 cnv",
    "LRR1 methyl",
    "LRR1 rna"
  ],
  "LRRC1": [
    "LRRC1 480_480_1_1_T480 phospho",
    "LRRC1 cnv",
    "LRRC1 methyl",
    "LRRC1 proteo",
    "LRRC1 rna"
  ],
  "LRRC10": [
    "LRRC10 cnv",
    "LRRC10 rna"
  ],
  "LRRC10B": [
    "LRRC10B cnv",
    "LRRC10B methyl",
    "LRRC10B rna"
  ],
  "LRRC14": [
    "LRRC14 cnv",
    "LRRC14 methyl",
    "LRRC14 proteo",
    "LRRC14 rna"
  ],
  "LRRC14B": [
    "LRRC14B cnv",
    "LRRC14B rna"
  ],
  "LRRC15": [
    "LRRC15 cnv",
    "LRRC15 rna"
  ],
  "LRRC17": [
    "LRRC17 cnv",
    "LRRC17 proteo",
    "LRRC17 rna"
  ],
  "LRRC18": [
    "LRRC18 cnv",
    "LRRC18 rna"
  ],
  "LRRC19": [
    "LRRC19 cnv",
    "LRRC19 rna"
  ],
  "LRRC2": [
    "LRRC2 cnv",
    "LRRC2 methyl",
    "LRRC2 rna"
  ],
  "LRRC20": [
    "LRRC20 cnv",
    "LRRC20 methyl",
    "LRRC20 proteo",
    "LRRC20 rna"
  ],
  "LRRC23": [
    "LRRC23 cnv",
    "LRRC23 methyl",
    "LRRC23 rna"
  ],
  "LRRC24": [
    "LRRC24 cnv",
    "LRRC24 methyl",
    "LRRC24 rna"
  ],
  "LRRC25": [
    "LRRC25 cnv",
    "LRRC25 proteo",
    "LRRC25 rna"
  ],
  "LRRC26": [
    "LRRC26 cnv",
    "LRRC26 methyl",
    "LRRC26 rna"
  ],
  "LRRC27": [
    "LRRC27 cnv",
    "LRRC27 methyl",
    "LRRC27 rna"
  ],
  "LRRC28": [
    "LRRC28 cnv",
    "LRRC28 methyl",
    "LRRC28 rna"
  ],
  "LRRC29": [
    "LRRC29 cnv",
    "LRRC29 rna"
  ],
  "LRRC3": [
    "LRRC3 cnv",
    "LRRC3 methyl",
    "LRRC3 rna"
  ],
  "LRRC3-DT": [
    "LRRC3-DT methyl"
  ],
  "LRRC30": [
    "LRRC30 cnv"
  ],
  "LRRC31": [
    "LRRC31 cnv",
    "LRRC31 rna"
  ],
  "LRRC32": [
    "LRRC32 cnv",
    "LRRC32 methyl",
    "LRRC32 rna"
  ],
  "LRRC34": [
    "LRRC34 cnv",
    "LRRC34 methyl",
    "LRRC34 rna"
  ],
  "LRRC36": [
    "LRRC36 cnv",
    "LRRC36 rna"
  ],
  "LRRC37A": [
    "LRRC37A cnv",
    "LRRC37A rna"
  ],
  "LRRC37A2": [
    "LRRC37A2 cnv",
    "LRRC37A2 methyl",
    "LRRC37A2 rna"
  ],
  "LRRC37A3": [
    "LRRC37A3 cnv",
    "LRRC37A3 methyl",
    "LRRC37A3 rna"
  ],
  "LRRC37A5P": [
    "LRRC37A5P methyl"
  ],
  "LRRC37B": [
    "LRRC37B cnv",
    "LRRC37B methyl",
    "LRRC37B rna"
  ],
  "LRRC38": [
    "LRRC38 cnv",
    "LRRC38 methyl",
    "LRRC38 rna"
  ],
  "LRRC39": [
    "LRRC39 cnv",
    "LRRC39 rna"
  ],
  "LRRC3B": [
    "LRRC3B cnv",
    "LRRC3B methyl",
    "LRRC3B rna"
  ],
  "LRRC3B-AS1": [
    "LRRC3B-AS1 methyl"
  ],
  "LRRC3C": [
    "LRRC3C cnv",
    "LRRC3C methyl",
    "LRRC3C rna"
  ],
  "LRRC4": [
    "LRRC4 cnv",
    "LRRC4 methyl",
    "LRRC4 rna"
  ],
  "LRRC40": [
    "LRRC40 71_75_1_1_S71 phospho",
    "LRRC40 cnv",
    "LRRC40 methyl",
    "LRRC40 proteo",
    "LRRC40 rna"
  ],
  "LRRC41": [
    "LRRC41 cnv",
    "LRRC41 methyl",
    "LRRC41 proteo",
    "LRRC41 rna"
  ],
  "LRRC42": [
    "LRRC42 cnv",
    "LRRC42 methyl",
    "LRRC42 proteo",
    "LRRC42 rna"
  ],
  "LRRC43": [
    "LRRC43 cnv",
    "LRRC43 methyl",
    "LRRC43 rna"
  ],
  "LRRC45": [
    "LRRC45 cnv",
    "LRRC45 methyl",
    "LRRC45 proteo",
    "LRRC45 rna"
  ],
  "LRRC46": [
    "LRRC46 cnv",
    "LRRC46 methyl",
    "LRRC46 rna"
  ],
  "LRRC47": [
    "LRRC47 431_433_1_1_S431 phospho",
    "LRRC47 509_539_1_0 phospho",
    "LRRC47 509_539_1_1_S520 phospho",
    "LRRC47 509_539_1_1_T522 phospho",
    "LRRC47 509_546_1_1_S520 phospho",
    "LRRC47 518_539_1_1_S520 phospho",
    "LRRC47 cnv",
    "LRRC47 methyl",
    "LRRC47 proteo",
    "LRRC47 rna"
  ],
  "LRRC49": [
    "LRRC49 cnv",
    "LRRC49 methyl",
    "LRRC49 proteo",
    "LRRC49 rna"
  ],
  "LRRC4B": [
    "LRRC4B 693_693_1_1_S693 phospho",
    "LRRC4B 702_711_1_1_S704 phospho",
    "LRRC4B cnv",
    "LRRC4B proteo",
    "LRRC4B rna"
  ],
  "LRRC4C": [
    "LRRC4C 631_638_1_1_S631 phospho",
    "LRRC4C cnv",
    "LRRC4C rna"
  ],
  "LRRC51": [
    "LRRC51 cnv",
    "LRRC51 methyl",
    "LRRC51 rna"
  ],
  "LRRC52": [
    "LRRC52 cnv",
    "LRRC52 rna"
  ],
  "LRRC53": [
    "LRRC53 cnv",
    "LRRC53 rna"
  ],
  "LRRC55": [
    "LRRC55 cnv",
    "LRRC55 rna"
  ],
  "LRRC56": [
    "LRRC56 cnv",
    "LRRC56 methyl",
    "LRRC56 rna"
  ],
  "LRRC57": [
    "LRRC57 cnv",
    "LRRC57 methyl",
    "LRRC57 proteo",
    "LRRC57 rna"
  ],
  "LRRC58": [
    "LRRC58 cnv",
    "LRRC58 methyl",
    "LRRC58 proteo",
    "LRRC58 rna"
  ],
  "LRRC59": [
    "LRRC59 cnv",
    "LRRC59 methyl",
    "LRRC59 proteo",
    "LRRC59 rna"
  ],
  "LRRC61": [
    "LRRC61 cnv",
    "LRRC61 methyl",
    "LRRC61 rna"
  ],
  "LRRC63": [
    "LRRC63 cnv",
    "LRRC63 rna"
  ],
  "LRRC66": [
    "LRRC66 cnv",
    "LRRC66 rna"
  ],
  "LRRC69": [
    "LRRC69 cnv",
    "LRRC69 rna"
  ],
  "LRRC7": [
    "LRRC7 1123_1128_1_1_S1123 phospho",
    "LRRC7 1161_1168_1_1_S1162 phospho",
    "LRRC7 933_938_1_1_S938 phospho",
    "LRRC7 952_963_1_1_S954 phospho",
    "LRRC7 cnv",
    "LRRC7 methyl",
    "LRRC7 proteo",
    "LRRC7 rna"
  ],
  "LRRC70": [
    "LRRC70 cnv",
    "LRRC70 rna"
  ],
  "LRRC71": [
    "LRRC71 cnv",
    "LRRC71 methyl",
    "LRRC71 rna"
  ],
  "LRRC72": [
    "LRRC72 cnv",
    "LRRC72 methyl"
  ],
  "LRRC73": [
    "LRRC73 cnv",
    "LRRC73 methyl",
    "LRRC73 proteo",
    "LRRC73 rna"
  ],
  "LRRC74A": [
    "LRRC74A cnv",
    "LRRC74A rna"
  ],
  "LRRC74B": [
    "LRRC74B cnv",
    "LRRC74B methyl",
    "LRRC74B rna"
  ],
  "LRRC75A": [
    "LRRC75A cnv",
    "LRRC75A methyl",
    "LRRC75A proteo",
    "LRRC75A rna"
  ],
  "LRRC75B": [
    "LRRC75B cnv",
    "LRRC75B methyl",
    "LRRC75B rna"
  ],
  "LRRC8A": [
    "LRRC8A cnv",
    "LRRC8A methyl",
    "LRRC8A proteo",
    "LRRC8A rna"
  ],
  "LRRC8B": [
    "LRRC8B cnv",
    "LRRC8B methyl",
    "LRRC8B proteo",
    "LRRC8B rna"
  ],
  "LRRC8C": [
    "LRRC8C 196_212_1_1_S212 phospho",
    "LRRC8C 196_212_1_1_T198 phospho",
    "LRRC8C cnv",
    "LRRC8C methyl",
    "LRRC8C proteo",
    "LRRC8C rna"
  ],
  "LRRC8C-DT": [
    "LRRC8C-DT methyl"
  ],
  "LRRC8D": [
    "LRRC8D cnv",
    "LRRC8D methyl",
    "LRRC8D proteo",
    "LRRC8D rna"
  ],
  "LRRC8E": [
    "LRRC8E cnv",
    "LRRC8E methyl",
    "LRRC8E rna"
  ],
  "LRRC9": [
    "LRRC9 cnv",
    "LRRC9 methyl",
    "LRRC9 rna"
  ],
  "LRRCC1": [
    "LRRCC1 cnv",
    "LRRCC1 methyl",
    "LRRCC1 rna"
  ],
  "LRRD1": [
    "LRRD1 cnv",
    "LRRD1 methyl",
    "LRRD1 rna"
  ],
  "LRRFIP1": [
    "LRRFIP1 104_116_1_1_S116 phospho",
    "LRRFIP1 711_714_1_1_S714 phospho",
    "LRRFIP1 cnv",
    "LRRFIP1 methyl",
    "LRRFIP1 proteo",
    "LRRFIP1 rna"
  ],
  "LRRFIP2": [
    "LRRFIP2 18_25_1_1_S18 phospho",
    "LRRFIP2 312_324_1_1_S312 phospho",
    "LRRFIP2 328_342_1_1_S328 phospho",
    "LRRFIP2 328_348_1_1_S328 phospho",
    "LRRFIP2 cnv",
    "LRRFIP2 methyl",
    "LRRFIP2 proteo",
    "LRRFIP2 rna"
  ],
  "LRRIQ1": [
    "LRRIQ1 cnv",
    "LRRIQ1 rna"
  ],
  "LRRIQ3": [
    "LRRIQ3 cnv",
    "LRRIQ3 methyl",
    "LRRIQ3 rna"
  ],
  "LRRIQ4": [
    "LRRIQ4 cnv",
    "LRRIQ4 methyl",
    "LRRIQ4 rna"
  ],
  "LRRK1": [
    "LRRK1 cnv",
    "LRRK1 kinase",
    "LRRK1 methyl",
    "LRRK1 rna"
  ],
  "LRRK2": [
    "LRRK2 933_935_1_1_S935 phospho",
    "LRRK2 cnv",
    "LRRK2 kinase",
    "LRRK2 methyl",
    "LRRK2 rna"
  ],
  "LRRN1": [
    "LRRN1 661_664_1_1_S664 phospho",
    "LRRN1 cnv",
    "LRRN1 methyl",
    "LRRN1 proteo",
    "LRRN1 rna"
  ],
  "LRRN2": [
    "LRRN2 cnv",
    "LRRN2 methyl",
    "LRRN2 rna"
  ],
  "LRRN3": [
    "LRRN3 cnv",
    "LRRN3 rna"
  ],
  "LRRN4": [
    "LRRN4 cnv",
    "LRRN4 rna"
  ],
  "LRRN4CL": [
    "LRRN4CL cnv",
    "LRRN4CL proteo",
    "LRRN4CL rna"
  ],
  "LRRTM1": [
    "LRRTM1 cnv",
    "LRRTM1 methyl",
    "LRRTM1 rna"
  ],
  "LRRTM2": [
    "LRRTM2 459_459_1_1_S459 phospho",
    "LRRTM2 cnv",
    "LRRTM2 proteo",
    "LRRTM2 rna"
  ],
  "LRRTM3": [
    "LRRTM3 cnv",
    "LRRTM3 proteo",
    "LRRTM3 rna"
  ],
  "LRRTM4": [
    "LRRTM4 461_461_1_1_S461 phospho",
    "LRRTM4 cnv",
    "LRRTM4 proteo",
    "LRRTM4 rna"
  ],
  "LRSAM1": [
    "LRSAM1 cnv",
    "LRSAM1 methyl",
    "LRSAM1 proteo",
    "LRSAM1 rna"
  ],
  "LRTM1": [
    "LRTM1 cnv",
    "LRTM1 rna"
  ],
  "LRTM2": [
    "LRTM2 cnv",
    "LRTM2 rna"
  ],
  "LRTOMT": [
    "LRTOMT cnv",
    "LRTOMT methyl",
    "LRTOMT rna"
  ],
  "LRWD1": [
    "LRWD1 60_60_1_1_S60 phospho",
    "LRWD1 89_93_1_1_S91 phospho",
    "LRWD1 99_115_1_1_S99 phospho",
    "LRWD1 cnv",
    "LRWD1 methyl",
    "LRWD1 proteo",
    "LRWD1 rna"
  ],
  "LSAMP": [
    "LSAMP LGVTNASLVLFRPGSVR-N5H4F1S0G0 glyco",
    "LSAMP LGVTNASLVLFRPGSVR-N5H4F2S0G0 glyco",
    "LSAMP cnv",
    "LSAMP proteo",
    "LSAMP rna"
  ],
  "LSG1": [
    "LSG1 cnv",
    "LSG1 methyl",
    "LSG1 proteo",
    "LSG1 rna"
  ],
  "LSM1": [
    "LSM1 129_133_1_1_T129 phospho",
    "LSM1 cnv",
    "LSM1 methyl",
    "LSM1 proteo",
    "LSM1 rna"
  ],
  "LSM10": [
    "LSM10 cnv",
    "LSM10 methyl",
    "LSM10 rna"
  ],
  "LSM11": [
    "LSM11 cnv",
    "LSM11 methyl",
    "LSM11 rna"
  ],
  "LSM12": [
    "LSM12 73_85_1_1_T75 phospho",
    "LSM12 cnv",
    "LSM12 proteo",
    "LSM12 rna"
  ],
  "LSM14A": [
    "LSM14A 182_203_1_1_S192 phospho",
    "LSM14A 182_203_2_0 phospho",
    "LSM14A 182_203_2_1_S192 phospho",
    "LSM14A 182_203_2_2_S183S192 phospho",
    "LSM14A 216_227_1_1_S216 phospho",
    "LSM14A cnv",
    "LSM14A methyl",
    "LSM14A proteo",
    "LSM14A rna"
  ],
  "LSM14B": [
    "LSM14B 154_165_1_1_S165 phospho",
    "LSM14B cnv",
    "LSM14B methyl",
    "LSM14B proteo",
    "LSM14B rna"
  ],
  "LSM2": [
    "LSM2 cnv",
    "LSM2 methyl",
    "LSM2 proteo",
    "LSM2 rna"
  ],
  "LSM3": [
    "LSM3 cnv",
    "LSM3 methyl",
    "LSM3 proteo",
    "LSM3 rna"
  ],
  "LSM4": [
    "LSM4 cnv",
    "LSM4 methyl",
    "LSM4 proteo",
    "LSM4 rna"
  ],
  "LSM5": [
    "LSM5 cnv",
    "LSM5 methyl",
    "LSM5 proteo",
    "LSM5 rna"
  ],
  "LSM6": [
    "LSM6 cnv",
    "LSM6 methyl",
    "LSM6 proteo",
    "LSM6 rna"
  ],
  "LSM7": [
    "LSM7 cnv",
    "LSM7 methyl",
    "LSM7 proteo",
    "LSM7 rna"
  ],
  "LSM8": [
    "LSM8 cnv",
    "LSM8 methyl",
    "LSM8 proteo",
    "LSM8 rna"
  ],
  "LSMEM1": [
    "LSMEM1 cnv",
    "LSMEM1 rna"
  ],
  "LSMEM2": [
    "LSMEM2 cnv",
    "LSMEM2 rna"
  ],
  "LSP1": [
    "LSP1 103_125_1_1_S111 phospho",
    "LSP1 111_125_1_1_S111 phospho",
    "LSP1 130_141_1_1_S130 phospho",
    "LSP1 175_196_1_1_S189 phospho",
    "LSP1 175_196_1_1_S193 phospho",
    "LSP1 175_196_2_2_S189S193 phospho",
    "LSP1 175_196_2_2_T175S177 phospho",
    "LSP1 175_196_3_2_T175S177 phospho",
    "LSP1 252_263_1_1_S252 phospho",
    "LSP1 cnv",
    "LSP1 methyl",
    "LSP1 proteo",
    "LSP1 rna"
  ],
  "LSR": [
    "LSR 510_520_1_1_S510 phospho",
    "LSR cnv",
    "LSR methyl",
    "LSR rna"
  ],
  "LSS": [
    "LSS cnv",
    "LSS methyl",
    "LSS proteo",
    "LSS rna"
  ],
  "LST1": [
    "LST1 13_27_1_1_S19 phospho",
    "LST1 13_27_2_2_S19S27 phospho",
    "LST1 cnv",
    "LST1 proteo",
    "LST1 rna"
  ],
  "LTA": [
    "LTA cnv",
    "LTA rna"
  ],
  "LTA4H": [
    "LTA4H cnv",
    "LTA4H methyl",
    "LTA4H proteo",
    "LTA4H rna"
  ],
  "LTB": [
    "LTB cnv",
    "LTB rna"
  ],
  "LTB4R": [
    "LTB4R cnv",
    "LTB4R methyl",
    "LTB4R rna"
  ],
  "LTB4R2": [
    "LTB4R2 cnv",
    "LTB4R2 rna"
  ],
  "LTBP1": [
    "LTBP1 1087_1096_1_1_S1088 phospho",
    "LTBP1 cnv",
    "LTBP1 methyl",
    "LTBP1 proteo",
    "LTBP1 rna"
  ],
  "LTBP2": [
    "LTBP2 cnv",
    "LTBP2 methyl",
    "LTBP2 proteo",
    "LTBP2 rna"
  ],
  "LTBP3": [
    "LTBP3 1184_1218_1_0 phospho",
    "LTBP3 cnv",
    "LTBP3 methyl",
    "LTBP3 proteo",
    "LTBP3 rna"
  ],
  "LTBP4": [
    "LTBP4 cnv",
    "LTBP4 methyl",
    "LTBP4 proteo",
    "LTBP4 rna"
  ],
  "LTBR": [
    "LTBR cnv",
    "LTBR methyl",
    "LTBR proteo",
    "LTBR rna"
  ],
  "LTC4S": [
    "LTC4S cnv",
    "LTC4S rna"
  ],
  "LTF": [
    "LTF TAGWNIPMGLLFNQTGSCK-N4H5F1S1G0 glyco",
    "LTF TAGWNIPMGLLFNQTGSCK-N4H5F2S1G0 glyco",
    "LTF cnv",
    "LTF methyl",
    "LTF proteo",
    "LTF rna"
  ],
  "LTK": [
    "LTK cnv",
    "LTK kinase",
    "LTK rna"
  ],
  "LTN1": [
    "LTN1 cnv",
    "LTN1 methyl",
    "LTN1 proteo",
    "LTN1 rna"
  ],
  "LTO1": [
    "LTO1 cnv",
    "LTO1 methyl",
    "LTO1 rna"
  ],
  "LTV1": [
    "LTV1 cnv",
    "LTV1 methyl",
    "LTV1 proteo",
    "LTV1 rna"
  ],
  "LUC7L": [
    "LUC7L cnv",
    "LUC7L methyl",
    "LUC7L proteo",
    "LUC7L rna"
  ],
  "LUC7L2": [
    "LUC7L2 17_24_1_0 phospho",
    "LUC7L2 17_24_1_1_S18 phospho",
    "LUC7L2 cnv",
    "LUC7L2 methyl",
    "LUC7L2 rna"
  ],
  "LUC7L3": [
    "LUC7L3 410_431_1_1_S431 phospho",
    "LUC7L3 410_431_2_2_S425S431 phospho",
    "LUC7L3 419_431_1_1_S425 phospho",
    "LUC7L3 419_431_2_2_S425S431 phospho",
    "LUC7L3 cnv",
    "LUC7L3 methyl",
    "LUC7L3 proteo",
    "LUC7L3 rna"
  ],
  "LUM": [
    "LUM KLHINHNNLTESVGPLPK-N4H5F1S0G0 glyco",
    "LUM KLHINHNNLTESVGPLPK-N4H5F1S1G0 glyco",
    "LUM KLHINHNNLTESVGPLPK-N4H5F1S2G0 glyco",
    "LUM KLHINHNNLTESVGPLPK-N5H3F1S0G0 glyco",
    "LUM KLHINHNNLTESVGPLPK-N5H4F1S0G0 glyco",
    "LUM KLHINHNNLTESVGPLPK-N5H5F1S0G0 glyco",
    "LUM KLHINHNNLTESVGPLPK-N5H5F1S1G0 glyco",
    "LUM KLHINHNNLTESVGPLPK-N5H6F1S1G0 glyco",
    "LUM LHINHNNLTESVGPLPK-N2H5F0S0G0 glyco",
    "LUM LHINHNNLTESVGPLPK-N3H4F2S2G0 glyco",
    "LUM LHINHNNLTESVGPLPK-N4H4F1S0G0 glyco",
    "LUM LHINHNNLTESVGPLPK-N4H4F1S1G0 glyco",
    "LUM LHINHNNLTESVGPLPK-N4H5F1S0G0 glyco",
    "LUM LHINHNNLTESVGPLPK-N4H5F1S1G0 glyco",
    "LUM LHINHNNLTESVGPLPK-N4H5F1S2G0 glyco",
    "LUM LHINHNNLTESVGPLPK-N4H5F3S1G0 glyco",
    "LUM LHINHNNLTESVGPLPK-N4H5F4S2G0 glyco",
    "LUM LHINHNNLTESVGPLPK-N5H3F1S0G0 glyco",
    "LUM LHINHNNLTESVGPLPK-N5H4F1S0G0 glyco",
    "LUM LHINHNNLTESVGPLPK-N5H5F1S0G0 glyco",
    "LUM LHINHNNLTESVGPLPK-N5H5F1S1G0 glyco",
    "LUM LHINHNNLTESVGPLPK-N5H6F1S0G0 glyco",
    "LUM LHINHNNLTESVGPLPK-N5H6F1S1G0 glyco",
    "LUM LHINHNNLTESVGPLPK-N5H6F1S2G0 glyco",
    "LUM LHINHNNLTESVGPLPK-N5H6F4S2G0 glyco",
    "LUM LHINHNNLTESVGPLPK-N7H4F1S0G0 glyco",
    "LUM cnv",
    "LUM proteo",
    "LUM rna"
  ],
  "LURAP1": [
    "LURAP1 213_218_1_1_S213 phospho",
    "LURAP1 99_118_1_1_S118 phospho",
    "LURAP1 cnv",
    "LURAP1 methyl",
    "LURAP1 rna"
  ],
  "LURAP1L": [
    "LURAP1L cnv",
    "LURAP1L methyl",
    "LURAP1L proteo",
    "LURAP1L rna"
  ],
  "LUZP1": [
    "LUZP1 1042_1046_1_1_S1042 phospho",
    "LUZP1 394_394_1_1_S394 phospho",
    "LUZP1 611_622_1_1_S611 phospho",
    "LUZP1 877_884_1_1_S878 phospho",
    "LUZP1 903_913_1_1_S905 phospho",
    "LUZP1 cnv",
    "LUZP1 methyl",
    "LUZP1 proteo",
    "LUZP1 rna"
  ],
  "LUZP2": [
    "LUZP2 cnv",
    "LUZP2 methyl",
    "LUZP2 rna"
  ],
  "LUZP4": [
    "LUZP4 rna"
  ],
  "LVRN": [
    "LVRN cnv",
    "LVRN methyl",
    "LVRN rna"
  ],
  "LXN": [
    "LXN cnv",
    "LXN proteo",
    "LXN rna"
  ],
  "LY6D": [
    "LY6D cnv",
    "LY6D rna"
  ],
  "LY6E": [
    "LY6E cnv",
    "LY6E methyl",
    "LY6E rna"
  ],
  "LY6G5B": [
    "LY6G5B cnv",
    "LY6G5B methyl",
    "LY6G5B rna"
  ],
  "LY6G5C": [
    "LY6G5C cnv",
    "LY6G5C methyl",
    "LY6G5C rna"
  ],
  "LY6G6C": [
    "LY6G6C cnv",
    "LY6G6C rna"
  ],
  "LY6G6D": [
    "LY6G6D cnv",
    "LY6G6D rna"
  ],
  "LY6G6E": [
    "LY6G6E cnv",
    "LY6G6E rna"
  ],
  "LY6G6F": [
    "LY6G6F cnv",
    "LY6G6F rna"
  ],
  "LY6G6F-LY6G6D": [
    "LY6G6F-LY6G6D cnv",
    "LY6G6F-LY6G6D rna"
  ],
  "LY6H": [
    "LY6H cnv",
    "LY6H methyl",
    "LY6H proteo",
    "LY6H rna"
  ],
  "LY6K": [
    "LY6K cnv",
    "LY6K methyl",
    "LY6K rna"
  ],
  "LY6L": [
    "LY6L cnv"
  ],
  "LY75": [
    "LY75 cnv",
    "LY75 methyl",
    "LY75 rna"
  ],
  "LY75-CD302": [
    "LY75-CD302 cnv",
    "LY75-CD302 methyl",
    "LY75-CD302 rna"
  ],
  "LY86": [
    "LY86 cnv",
    "LY86 rna"
  ],
  "LY9": [
    "LY9 cnv",
    "LY9 rna"
  ],
  "LY96": [
    "LY96 cnv",
    "LY96 rna"
  ],
  "LYAR": [
    "LYAR 276_282_1_1_S276 phospho",
    "LYAR cnv",
    "LYAR methyl",
    "LYAR proteo",
    "LYAR rna"
  ],
  "LYG1": [
    "LYG1 cnv",
    "LYG1 rna"
  ],
  "LYG2": [
    "LYG2 cnv",
    "LYG2 rna"
  ],
  "LYL1": [
    "LYL1 cnv",
    "LYL1 methyl",
    "LYL1 rna"
  ],
  "LYN": [
    "LYN 11_13_1_1_S13 phospho",
    "LYN 6_13_1_1_S13 phospho",
    "LYN cnv",
    "LYN kinase",
    "LYN methyl",
    "LYN proteo",
    "LYN rna"
  ],
  "LYNX1": [
    "LYNX1 cnv",
    "LYNX1 methyl",
    "LYNX1 proteo",
    "LYNX1 rna"
  ],
  "LYNX1-SLURP2": [
    "LYNX1-SLURP2 cnv",
    "LYNX1-SLURP2 methyl",
    "LYNX1-SLURP2 rna"
  ],
  "LYPD1": [
    "LYPD1 cnv",
    "LYPD1 methyl",
    "LYPD1 proteo",
    "LYPD1 rna"
  ],
  "LYPD2": [
    "LYPD2 cnv"
  ],
  "LYPD3": [
    "LYPD3 cnv",
    "LYPD3 methyl",
    "LYPD3 rna"
  ],
  "LYPD4": [
    "LYPD4 cnv",
    "LYPD4 methyl"
  ],
  "LYPD5": [
    "LYPD5 cnv",
    "LYPD5 methyl",
    "LYPD5 rna"
  ],
  "LYPD6": [
    "LYPD6 cnv",
    "LYPD6 methyl",
    "LYPD6 rna"
  ],
  "LYPD6B": [
    "LYPD6B cnv",
    "LYPD6B methyl",
    "LYPD6B rna"
  ],
  "LYPD8": [
    "LYPD8 cnv",
    "LYPD8 rna"
  ],
  "LYPLA1": [
    "LYPLA1 cnv",
    "LYPLA1 methyl",
    "LYPLA1 proteo",
    "LYPLA1 rna"
  ],
  "LYPLA2": [
    "LYPLA2 cnv",
    "LYPLA2 methyl",
    "LYPLA2 proteo",
    "LYPLA2 rna"
  ],
  "LYPLAL1": [
    "LYPLAL1 cnv",
    "LYPLAL1 methyl",
    "LYPLAL1 proteo",
    "LYPLAL1 rna"
  ],
  "LYPLAL1-DT": [
    "LYPLAL1-DT methyl"
  ],
  "LYRM1": [
    "LYRM1 cnv",
    "LYRM1 methyl",
    "LYRM1 proteo",
    "LYRM1 rna"
  ],
  "LYRM2": [
    "LYRM2 cnv",
    "LYRM2 methyl",
    "LYRM2 proteo",
    "LYRM2 rna"
  ],
  "LYRM4": [
    "LYRM4 cnv",
    "LYRM4 methyl",
    "LYRM4 proteo",
    "LYRM4 rna"
  ],
  "LYRM4-AS1": [
    "LYRM4-AS1 methyl"
  ],
  "LYRM7": [
    "LYRM7 cnv",
    "LYRM7 methyl",
    "LYRM7 proteo",
    "LYRM7 rna"
  ],
  "LYRM9": [
    "LYRM9 cnv",
    "LYRM9 methyl",
    "LYRM9 proteo",
    "LYRM9 rna"
  ],
  "LYSMD1": [
    "LYSMD1 23_33_1_1_S23 phospho",
    "LYSMD1 cnv",
    "LYSMD1 proteo",
    "LYSMD1 rna"
  ],
  "LYSMD2": [
    "LYSMD2 21_24_1_1_S24 phospho",
    "LYSMD2 cnv",
    "LYSMD2 methyl",
    "LYSMD2 proteo",
    "LYSMD2 rna"
  ],
  "LYSMD3": [
    "LYSMD3 53_66_1_1_S55 phospho",
    "LYSMD3 cnv",
    "LYSMD3 methyl",
    "LYSMD3 rna"
  ],
  "LYSMD4": [
    "LYSMD4 cnv",
    "LYSMD4 methyl",
    "LYSMD4 rna"
  ],
  "LYST": [
    "LYST 2149_2155_1_1_S2149 phospho",
    "LYST 2213_2222_1_1_S2217 phospho",
    "LYST cnv",
    "LYST methyl",
    "LYST proteo",
    "LYST rna"
  ],
  "LYVE1": [
    "LYVE1 cnv",
    "LYVE1 proteo",
    "LYVE1 rna"
  ],
  "LYZ": [
    "LYZ cnv",
    "LYZ proteo",
    "LYZ rna"
  ],
  "LYZL1": [
    "LYZL1 cnv"
  ],
  "LYZL2": [
    "LYZL2 cnv"
  ],
  "LYZL4": [
    "LYZL4 cnv",
    "LYZL4 rna"
  ],
  "LYZL6": [
    "LYZL6 cnv"
  ],
  "LZIC": [
    "LZIC cnv",
    "LZIC methyl",
    "LZIC proteo",
    "LZIC rna"
  ],
  "LZTFL1": [
    "LZTFL1 cnv",
    "LZTFL1 methyl",
    "LZTFL1 proteo",
    "LZTFL1 rna"
  ],
  "LZTR1": [
    "LZTR1 cnv",
    "LZTR1 methyl",
    "LZTR1 proteo",
    "LZTR1 rna"
  ],
  "LZTS1": [
    "LZTS1 110_117_1_1_S117 phospho",
    "LZTS1 134_146_1_1_S141 phospho",
    "LZTS1 209_226_1_1_S209 phospho",
    "LZTS1 283_283_1_1_S283 phospho",
    "LZTS1 47_50_1_1_S50 phospho",
    "LZTS1 cnv",
    "LZTS1 methyl",
    "LZTS1 proteo",
    "LZTS1 rna"
  ],
  "LZTS2": [
    "LZTS2 296_306_1_1_S301 phospho",
    "LZTS2 301_306_1_1_S301 phospho",
    "LZTS2 cnv",
    "LZTS2 methyl",
    "LZTS2 proteo",
    "LZTS2 rna"
  ],
  "LZTS3": [
    "LZTS3 601_604_1_1_T602 phospho",
    "LZTS3 cnv",
    "LZTS3 methyl",
    "LZTS3 proteo",
    "LZTS3 rna"
  ],
  "M1AP": [
    "M1AP cnv",
    "M1AP methyl",
    "M1AP rna"
  ],
  "M6PR": [
    "M6PR 181_181_1_1_S181 phospho",
    "M6PR EAGNHTSGAGLVQINK-N2H5F0S0G0 glyco",
    "M6PR EAGNHTSGAGLVQINK-N4H5F1S0G0 glyco",
    "M6PR EAGNHTSGAGLVQINK-N4H5F1S1G0 glyco",
    "M6PR EAGNHTSGAGLVQINK-N4H5F1S2G0 glyco",
    "M6PR EAGNHTSGAGLVQINK-N5H3F1S0G0 glyco",
    "M6PR EAGNHTSGAGLVQINK-N5H5F1S1G0 glyco",
    "M6PR LKPLFNK-N2H5F0S0G0 glyco",
    "M6PR LKPLFNK-N2H6F0S0G0 glyco",
    "M6PR LKPLFNK-N2H7F0S0G0 glyco",
    "M6PR LKPLFNK-N2H8F0S0G0 glyco",
    "M6PR cnv",
    "M6PR methyl",
    "M6PR proteo",
    "M6PR rna"
  ],
  "MAB21L1": [
    "MAB21L1 cnv",
    "MAB21L1 rna"
  ],
  "MAB21L2": [
    "MAB21L2 cnv",
    "MAB21L2 methyl",
    "MAB21L2 rna"
  ],
  "MAB21L3": [
    "MAB21L3 cnv",
    "MAB21L3 rna"
  ],
  "MAB21L4": [
    "MAB21L4 cnv",
    "MAB21L4 rna"
  ],
  "MACC1": [
    "MACC1 cnv",
    "MACC1 rna"
  ],
  "MACF1": [
    "MACF1 1376_1382_1_0 phospho",
    "MACF1 1846_1853_1_1_S1847 phospho",
    "MACF1 1860_1867_1_1_S1860 phospho",
    "MACF1 2423_2431_1_1_S2429 phospho",
    "MACF1 2423_2435_1_0 phospho",
    "MACF1 2423_2435_1_1_S2429 phospho",
    "MACF1 2454_2454_1_1_S2454 phospho",
    "MACF1 2769_2769_1_1_S2769 phospho",
    "MACF1 280_280_1_1_S280 phospho",
    "MACF1 31_42_1_0 phospho",
    "MACF1 31_42_1_1_S35 phospho",
    "MACF1 31_42_2_2_S33S35 phospho",
    "MACF1 3629_3636_1_1_S3634 phospho",
    "MACF1 3850_3850_1_1_S3850 phospho",
    "MACF1 4321_4324_1_1_T4321 phospho",
    "MACF1 4395_4409_1_1_S4395 phospho",
    "MACF1 5009_5024_1_1_S5009 phospho",
    "MACF1 5323_5338_1_1_S5324 phospho",
    "MACF1 533_546_1_1_S534 phospho",
    "MACF1 5372_5401_1_1_S5372 phospho",
    "MACF1 57_60_1_1_S57 phospho",
    "MACF1 cnv",
    "MACF1 methyl",
    "MACF1 mut",
    "MACF1 proteo",
    "MACF1 rna"
  ],
  "MACIR": [
    "MACIR 11_25_1_1_S25 phospho",
    "MACIR cnv",
    "MACIR methyl",
    "MACIR rna"
  ],
  "MACO1": [
    "MACO1 244_252_1_1_S244 phospho",
    "MACO1 326_332_1_1_S332 phospho",
    "MACO1 cnv",
    "MACO1 methyl",
    "MACO1 proteo",
    "MACO1 rna"
  ],
  "MACROD1": [
    "MACROD1 cnv",
    "MACROD1 methyl",
    "MACROD1 proteo",
    "MACROD1 rna"
  ],
  "MACROD2": [
    "MACROD2 cnv",
    "MACROD2 methyl",
    "MACROD2 proteo",
    "MACROD2 rna"
  ],
  "MACROH2A1": [
    "MACROH2A1 129_129_1_1_T129 phospho",
    "MACROH2A1 169_187_1_1_S172 phospho",
    "MACROH2A1 169_187_1_1_T177 phospho",
    "MACROH2A1 cnv",
    "MACROH2A1 methyl",
    "MACROH2A1 proteo",
    "MACROH2A1 rna"
  ],
  "MACROH2A2": [
    "MACROH2A2 cnv",
    "MACROH2A2 methyl",
    "MACROH2A2 proteo",
    "MACROH2A2 rna"
  ],
  "MAD1L1": [
    "MAD1L1 417_432_1_1_S428 phospho",
    "MAD1L1 cnv",
    "MAD1L1 methyl",
    "MAD1L1 proteo",
    "MAD1L1 rna"
  ],
  "MAD2L1": [
    "MAD2L1 cnv",
    "MAD2L1 methyl",
    "MAD2L1 proteo",
    "MAD2L1 rna"
  ],
  "MAD2L1BP": [
    "MAD2L1BP 134_134_1_1_S134 phospho",
    "MAD2L1BP cnv",
    "MAD2L1BP methyl",
    "MAD2L1BP rna"
  ],
  "MAD2L2": [
    "MAD2L2 cnv",
    "MAD2L2 methyl",
    "MAD2L2 proteo",
    "MAD2L2 rna"
  ],
  "MADCAM1": [
    "MADCAM1 cnv",
    "MADCAM1 methyl",
    "MADCAM1 rna"
  ],
  "MADD": [
    "MADD 1059_1066_1_1_S1059 phospho",
    "MADD 1110_1119_1_1_S1110 phospho",
    "MADD 1237_1251_1_1_S1239 phospho",
    "MADD 1270_1279_1_1_S1270 phospho",
    "MADD 1503_1505_1_1_S1503 phospho",
    "MADD 818_826_1_1_S818 phospho",
    "MADD 858_870_1_1_S862 phospho",
    "MADD 930_930_1_1_S930 phospho",
    "MADD cnv",
    "MADD methyl",
    "MADD proteo",
    "MADD rna"
  ],
  "MAEA": [
    "MAEA cnv",
    "MAEA methyl",
    "MAEA proteo",
    "MAEA rna"
  ],
  "MAEL": [
    "MAEL cnv",
    "MAEL methyl",
    "MAEL rna"
  ],
  "MAF": [
    "MAF cnv",
    "MAF methyl",
    "MAF rna"
  ],
  "MAF1": [
    "MAF1 60_70_1_0 phospho",
    "MAF1 60_70_1_1_S68 phospho",
    "MAF1 73_85_1_1_S75 phospho",
    "MAF1 cnv",
    "MAF1 methyl",
    "MAF1 proteo",
    "MAF1 rna"
  ],
  "MAFA": [
    "MAFA cnv",
    "MAFA methyl",
    "MAFA rna"
  ],
  "MAFB": [
    "MAFB cnv",
    "MAFB methyl",
    "MAFB proteo",
    "MAFB rna"
  ],
  "MAFF": [
    "MAFF cnv",
    "MAFF methyl",
    "MAFF rna"
  ],
  "MAFG": [
    "MAFG cnv",
    "MAFG methyl",
    "MAFG proteo",
    "MAFG rna"
  ],
  "MAFK": [
    "MAFK cnv",
    "MAFK methyl",
    "MAFK rna"
  ],
  "MAG": [
    "MAG 518_535_1_0 phospho",
    "MAG 518_535_1_1_S522 phospho",
    "MAG LGCQASFPNTTLQFEGYASMDVK-N5H3F1S0G0 glyco",
    "MAG NCTLLLSNVSPELGGK-N2H4F0S0G0 glyco",
    "MAG NCTLLLSNVSPELGGK-N2H5F0S0G0 glyco",
    "MAG NCTLLLSNVSPELGGK-N2H6F0S0G0 glyco",
    "MAG NCTLLLSNVSPELGGK-N5H3F0S0G0 glyco",
    "MAG cnv",
    "MAG methyl",
    "MAG proteo",
    "MAG rna"
  ],
  "MAGEA1": [
    "MAGEA1 rna"
  ],
  "MAGEA10": [
    "MAGEA10 rna"
  ],
  "MAGEA11": [
    "MAGEA11 rna"
  ],
  "MAGEA12": [
    "MAGEA12 rna"
  ],
  "MAGEA2": [
    "MAGEA2 rna"
  ],
  "MAGEA2B": [
    "MAGEA2B rna"
  ],
  "MAGEA3": [
    "MAGEA3 rna"
  ],
  "MAGEA4": [
    "MAGEA4 rna"
  ],
  "MAGEA6": [
    "MAGEA6 rna"
  ],
  "MAGEA8": [
    "MAGEA8 rna"
  ],
  "MAGEA9": [
    "MAGEA9 rna"
  ],
  "MAGEA9B": [
    "MAGEA9B rna"
  ],
  "MAGEB1": [
    "MAGEB1 methyl"
  ],
  "MAGEB16": [
    "MAGEB16 rna"
  ],
  "MAGEB17": [
    "MAGEB17 rna"
  ],
  "MAGEB2": [
    "MAGEB2 rna"
  ],
  "MAGEB3": [
    "MAGEB3 rna"
  ],
  "MAGEB6": [
    "MAGEB6 rna"
  ],
  "MAGEC1": [
    "MAGEC1 rna"
  ],
  "MAGEC2": [
    "MAGEC2 rna"
  ],
  "MAGEC3": [
    "MAGEC3 rna"
  ],
  "MAGED1": [
    "MAGED1 methyl",
    "MAGED1 proteo",
    "MAGED1 rna"
  ],
  "MAGED2": [
    "MAGED2 190_200_1_1_S191 phospho",
    "MAGED2 190_200_2_2_S190S191 phospho",
    "MAGED2 methyl",
    "MAGED2 proteo",
    "MAGED2 rna"
  ],
  "MAGED4": [
    "MAGED4 rna"
  ],
  "MAGED4B": [
    "MAGED4B rna"
  ],
  "MAGEE1": [
    "MAGEE1 rna"
  ],
  "MAGEE2": [
    "MAGEE2 rna"
  ],
  "MAGEF1": [
    "MAGEF1 cnv",
    "MAGEF1 methyl",
    "MAGEF1 rna"
  ],
  "MAGEH1": [
    "MAGEH1 rna"
  ],
  "MAGEL2": [
    "MAGEL2 cnv",
    "MAGEL2 rna"
  ],
  "MAGI1": [
    "MAGI1 1457_1461_1_1_S1461 phospho",
    "MAGI1 611_643_1_0 phospho",
    "MAGI1 741_751_1_1_S741 phospho",
    "MAGI1 800_816_1_1_S808 phospho",
    "MAGI1 cnv",
    "MAGI1 methyl",
    "MAGI1 proteo",
    "MAGI1 rna"
  ],
  "MAGI2": [
    "MAGI2 1014_1021_1_1_S1014 phospho",
    "MAGI2 618_624_1_1_S622 phospho",
    "MAGI2 726_732_1_1_S727 phospho",
    "MAGI2 875_885_1_1_S885 phospho",
    "MAGI2 cnv",
    "MAGI2 methyl",
    "MAGI2 proteo",
    "MAGI2 rna"
  ],
  "MAGI2-AS3": [
    "MAGI2-AS3 methyl"
  ],
  "MAGI3": [
    "MAGI3 697_708_1_1_S699 phospho",
    "MAGI3 821_832_1_1_S832 phospho",
    "MAGI3 953_964_1_1_S953 phospho",
    "MAGI3 cnv",
    "MAGI3 methyl",
    "MAGI3 proteo",
    "MAGI3 rna"
  ],
  "MAGIX": [
    "MAGIX methyl",
    "MAGIX rna"
  ],
  "MAGOH": [
    "MAGOH cnv",
    "MAGOH methyl",
    "MAGOH rna"
  ],
  "MAGOH-DT": [
    "MAGOH-DT methyl"
  ],
  "MAGOHB": [
    "MAGOHB cnv",
    "MAGOHB methyl",
    "MAGOHB rna"
  ],
  "MAGT1": [
    "MAGT1 methyl",
    "MAGT1 proteo",
    "MAGT1 rna"
  ],
  "MAIP1": [
    "MAIP1 cnv",
    "MAIP1 methyl",
    "MAIP1 proteo",
    "MAIP1 rna"
  ],
  "MAJIN": [
    "MAJIN cnv",
    "MAJIN methyl",
    "MAJIN rna"
  ],
  "MAK": [
    "MAK cnv",
    "MAK kinase",
    "MAK methyl",
    "MAK rna"
  ],
  "MAK16": [
    "MAK16 cnv",
    "MAK16 methyl",
    "MAK16 proteo",
    "MAK16 rna"
  ],
  "MAL": [
    "MAL cnv",
    "MAL methyl",
    "MAL rna"
  ],
  "MAL2": [
    "MAL2 cnv",
    "MAL2 methyl",
    "MAL2 rna"
  ],
  "MALAT1": [
    "MALAT1 methyl"
  ],
  "MALL": [
    "MALL cnv",
    "MALL methyl",
    "MALL rna"
  ],
  "MALRD1": [
    "MALRD1 cnv",
    "MALRD1 rna"
  ],
  "MALSU1": [
    "MALSU1 cnv",
    "MALSU1 methyl",
    "MALSU1 proteo",
    "MALSU1 rna"
  ],
  "MALT1": [
    "MALT1 cnv",
    "MALT1 methyl",
    "MALT1 proteo",
    "MALT1 rna"
  ],
  "MAMDC2": [
    "MAMDC2 cnv",
    "MAMDC2 methyl",
    "MAMDC2 proteo",
    "MAMDC2 rna"
  ],
  "MAMDC4": [
    "MAMDC4 cnv",
    "MAMDC4 methyl",
    "MAMDC4 rna"
  ],
  "MAML1": [
    "MAML1 360_367_1_1_S360 phospho",
    "MAML1 cnv",
    "MAML1 methyl",
    "MAML1 proteo",
    "MAML1 rna"
  ],
  "MAML2": [
    "MAML2 1074_1094_1_1_S1089 phospho",
    "MAML2 cnv",
    "MAML2 proteo",
    "MAML2 rna"
  ],
  "MAML3": [
    "MAML3 cnv",
    "MAML3 methyl",
    "MAML3 rna"
  ],
  "MAMLD1": [
    "MAMLD1 651_656_1_1_S651 phospho",
    "MAMLD1 methyl",
    "MAMLD1 rna"
  ],
  "MAMSTR": [
    "MAMSTR cnv",
    "MAMSTR methyl",
    "MAMSTR rna"
  ],
  "MAN1A1": [
    "MAN1A1 cnv",
    "MAN1A1 methyl",
    "MAN1A1 proteo",
    "MAN1A1 rna"
  ],
  "MAN1A2": [
    "MAN1A2 cnv",
    "MAN1A2 methyl",
    "MAN1A2 proteo",
    "MAN1A2 rna"
  ],
  "MAN1B1": [
    "MAN1B1 cnv",
    "MAN1B1 methyl",
    "MAN1B1 proteo",
    "MAN1B1 rna"
  ],
  "MAN1B1-DT": [
    "MAN1B1-DT methyl"
  ],
  "MAN1C1": [
    "MAN1C1 164_169_1_1_S164 phospho",
    "MAN1C1 cnv",
    "MAN1C1 methyl",
    "MAN1C1 proteo",
    "MAN1C1 rna"
  ],
  "MAN2A1": [
    "MAN2A1 cnv",
    "MAN2A1 methyl",
    "MAN2A1 proteo",
    "MAN2A1 rna"
  ],
  "MAN2A2": [
    "MAN2A2 cnv",
    "MAN2A2 methyl",
    "MAN2A2 proteo",
    "MAN2A2 rna"
  ],
  "MAN2B1": [
    "MAN2B1 LEHQFAVGEDSGRNLSAPVTLNLR-N2H5F0S0G0 glyco",
    "MAN2B1 LEHQFAVGEDSGRNLSAPVTLNLR-N2H5F1S0G0 glyco",
    "MAN2B1 LEHQFAVGEDSGRNLSAPVTLNLR-N2H6F0S0G0 glyco",
    "MAN2B1 LNQTEPVAGNYYPVNTR-N2H3F1S0G0 glyco",
    "MAN2B1 NLSAPVTLNLR-N2H6F0S0G0 glyco",
    "MAN2B1 NLSAPVTLNLR-N2H7F0S0G0 glyco",
    "MAN2B1 TPLVQEVHQNFSAWCSQVVR-N2H3F0S0G0 glyco",
    "MAN2B1 TPLVQEVHQNFSAWCSQVVR-N2H5F0S0G0 glyco",
    "MAN2B1 TPLVQEVHQNFSAWCSQVVR-N3H4F0S1G0 glyco",
    "MAN2B1 cnv",
    "MAN2B1 methyl",
    "MAN2B1 proteo",
    "MAN2B1 rna"
  ],
  "MAN2B2": [
    "MAN2B2 cnv",
    "MAN2B2 proteo",
    "MAN2B2 rna"
  ],
  "MAN2C1": [
    "MAN2C1 cnv",
    "MAN2C1 methyl",
    "MAN2C1 proteo",
    "MAN2C1 rna"
  ],
  "MANBA": [
    "MANBA cnv",
    "MANBA methyl",
    "MANBA proteo",
    "MANBA rna"
  ],
  "MANBAL": [
    "MANBAL cnv",
    "MANBAL methyl",
    "MANBAL proteo",
    "MANBAL rna"
  ],
  "MANEA": [
    "MANEA cnv",
    "MANEA methyl",
    "MANEA rna"
  ],
  "MANEA-DT": [
    "MANEA-DT methyl"
  ],
  "MANEAL": [
    "MANEAL cnv",
    "MANEAL methyl",
    "MANEAL proteo",
    "MANEAL rna"
  ],
  "MANF": [
    "MANF cnv",
    "MANF methyl",
    "MANF proteo",
    "MANF rna"
  ],
  "MANSC1": [
    "MANSC1 cnv",
    "MANSC1 methyl",
    "MANSC1 rna"
  ],
  "MANSC4": [
    "MANSC4 cnv",
    "MANSC4 methyl",
    "MANSC4 rna"
  ],
  "MAOA": [
    "MAOA methyl",
    "MAOA proteo",
    "MAOA rna"
  ],
  "MAOB": [
    "MAOB methyl",
    "MAOB proteo",
    "MAOB rna"
  ],
  "MAP10": [
    "MAP10 cnv",
    "MAP10 methyl",
    "MAP10 rna"
  ],
  "MAP1A": [
    "MAP1A 1069_1087_1_1_S1069 phospho",
    "MAP1A 1144_1169_1_0 phospho",
    "MAP1A 1144_1169_1_1_S1144 phospho",
    "MAP1A 1144_1169_1_1_S1146 phospho",
    "MAP1A 114_121_1_1_S114 phospho",
    "MAP1A 114_121_1_1_S117 phospho",
    "MAP1A 1172_1180_1_1_S1172 phospho",
    "MAP1A 1190_1205_1_1_S1203 phospho",
    "MAP1A 1190_1214_1_1_S1203 phospho",
    "MAP1A 1218_1224_1_1_S1218 phospho",
    "MAP1A 1273_1299_1_0 phospho",
    "MAP1A 1273_1299_1_1_S1288 phospho",
    "MAP1A 1288_1299_1_1_S1288 phospho",
    "MAP1A 1304_1324_1_1_S1311 phospho",
    "MAP1A 1304_1324_1_1_T1318 phospho",
    "MAP1A 1326_1329_1_1_S1326 phospho",
    "MAP1A 155_162_1_1_S155 phospho",
    "MAP1A 1600_1600_1_1_S1600 phospho",
    "MAP1A 1640_1656_1_1_S1654 phospho",
    "MAP1A 1653_1656_1_1_S1654 phospho",
    "MAP1A 1674_1675_1_1_S1675 phospho",
    "MAP1A 1674_1682_1_0 phospho",
    "MAP1A 1674_1682_1_1_S1675 phospho",
    "MAP1A 1761_1762_1_1_S1762 phospho",
    "MAP1A 1776_1776_1_1_S1776 phospho",
    "MAP1A 1776_1789_1_1_S1776 phospho",
    "MAP1A 1791_1801_1_1_S1797 phospho",
    "MAP1A 1791_1801_1_1_S1801 phospho",
    "MAP1A 1791_1801_2_2_S1797S1801 phospho",
    "MAP1A 1812_1818_1_1_S1818 phospho",
    "MAP1A 1834_1837_1_1_T1835 phospho",
    "MAP1A 1940_1959_1_1_T1957 phospho",
    "MAP1A 2018_2022_1_1_S2019 phospho",
    "MAP1A 2018_2022_1_1_S2022 phospho",
    "MAP1A 2018_2022_2_2_S2019S2022 phospho",
    "MAP1A 2025_2058_1_0 phospho",
    "MAP1A 2025_2058_1_1_T2058 phospho",
    "MAP1A 2025_2070_1_0 phospho",
    "MAP1A 2074_2085_1_1_S2074 phospho",
    "MAP1A 2074_2085_1_1_S2085 phospho",
    "MAP1A 2074_2085_2_0 phospho",
    "MAP1A 2074_2085_2_2_S2074S2085 phospho",
    "MAP1A 2074_2092_2_0 phospho",
    "MAP1A 2074_2092_2_2_S2090S2092 phospho",
    "MAP1A 2074_2092_3_2_S2090S2092 phospho",
    "MAP1A 2074_2092_3_3_S2074S2090S2092 phospho",
    "MAP1A 2074_2092_3_3_S2085S2090S2092 phospho",
    "MAP1A 2099_2108_1_1_S2106 phospho",
    "MAP1A 2099_2108_2_2_T2105S2106 phospho",
    "MAP1A 2160_2182_1_1_S2182 phospho",
    "MAP1A 2188_2197_1_1_S2188 phospho",
    "MAP1A 2348_2366_1_0 phospho",
    "MAP1A 2400_2439_1_1_S2427 phospho",
    "MAP1A 2400_2439_2_0 phospho",
    "MAP1A 2449_2460_1_1_S2449 phospho",
    "MAP1A 2449_2468_1_1_S2449 phospho",
    "MAP1A 2629_2631_1_1_S2629 phospho",
    "MAP1A 2649_2655_1_1_S2649 phospho",
    "MAP1A 2649_2667_1_1_S2664 phospho",
    "MAP1A 2664_2667_1_1_S2664 phospho",
    "MAP1A 499_504_1_1_T504 phospho",
    "MAP1A 526_532_1_1_S527 phospho",
    "MAP1A 526_532_2_2_S526S527 phospho",
    "MAP1A 552_579_1_1_T576 phospho",
    "MAP1A 605_605_1_1_S605 phospho",
    "MAP1A 612_616_1_1_S612 phospho",
    "MAP1A 612_616_2_2_S612T616 phospho",
    "MAP1A 612_622_1_1_S612 phospho",
    "MAP1A 612_622_2_2_S612T616 phospho",
    "MAP1A 667_675_1_1_S667 phospho",
    "MAP1A 667_681_1_1_S667 phospho",
    "MAP1A 770_798_1_0 phospho",
    "MAP1A 865_878_1_1_S874 phospho",
    "MAP1A 880_900_1_1_S896 phospho",
    "MAP1A 880_900_1_1_S900 phospho",
    "MAP1A 880_900_2_0 phospho",
    "MAP1A 880_900_2_2_S896S900 phospho",
    "MAP1A 880_921_2_0 phospho",
    "MAP1A 909_921_1_1_S909 phospho",
    "MAP1A 986_991_1_1_S986 phospho",
    "MAP1A 996_1013_1_1_S996 phospho",
    "MAP1A 996_1013_2_2_S996S1013 phospho",
    "MAP1A 996_1013_3_3_S996S1004S1013 phospho",
    "MAP1A 996_1033_2_0 phospho",
    "MAP1A cnv",
    "MAP1A methyl",
    "MAP1A proteo",
    "MAP1A rna"
  ],
  "MAP1B": [
    "MAP1B 1016_1016_1_1_S1016 phospho",
    "MAP1B 1016_1034_1_1_S1016 phospho",
    "MAP1B 1062_1069_1_1_T1067 phospho",
    "MAP1B 1144_1163_1_0 phospho",
    "MAP1B 1144_1163_1_1_S1154 phospho",
    "MAP1B 1165_1175_1_1_S1171 phospho",
    "MAP1B 1181_1190_1_1_S1187 phospho",
    "MAP1B 1192_1212_1_1_S1208 phospho",
    "MAP1B 1192_1219_1_0 phospho",
    "MAP1B 1192_1219_1_1_S1208 phospho",
    "MAP1B 1200_1212_1_1_S1208 phospho",
    "MAP1B 1200_1212_2_2_S1208S1212 phospho",
    "MAP1B 1200_1219_1_1_S1208 phospho",
    "MAP1B 1221_1229_1_1_S1221 phospho",
    "MAP1B 1252_1265_1_1_S1256 phospho",
    "MAP1B 1252_1265_1_1_S1265 phospho",
    "MAP1B 1252_1265_2_2_S1256S1265 phospho",
    "MAP1B 1256_1265_1_1_S1265 phospho",
    "MAP1B 1256_1265_2_2_S1262S1265 phospho",
    "MAP1B 1256_1265_3_3_S1256S1260S1265 phospho",
    "MAP1B 1256_1270_1_1_S1265 phospho",
    "MAP1B 1276_1282_1_1_S1276 phospho",
    "MAP1B 1276_1282_1_1_S1280 phospho",
    "MAP1B 1276_1282_1_1_T1282 phospho",
    "MAP1B 1289_1312_1_0 phospho",
    "MAP1B 1289_1312_1_1_S1298 phospho",
    "MAP1B 1289_1312_1_1_S1312 phospho",
    "MAP1B 1289_1312_2_2_S1298S1312 phospho",
    "MAP1B 1317_1341_1_0 phospho",
    "MAP1B 1317_1341_1_1_S1322 phospho",
    "MAP1B 1317_1341_1_1_S1339 phospho",
    "MAP1B 1317_1341_2_0 phospho",
    "MAP1B 1317_1341_2_1_S1339 phospho",
    "MAP1B 1317_1341_2_2_S1330S1339 phospho",
    "MAP1B 1317_1341_3_0 phospho",
    "MAP1B 1345_1366_1_1_S1345 phospho",
    "MAP1B 1376_1389_1_0 phospho",
    "MAP1B 1376_1389_1_1_S1378 phospho",
    "MAP1B 1376_1389_1_1_S1389 phospho",
    "MAP1B 1376_1389_2_2_S1376S1378 phospho",
    "MAP1B 1376_1389_2_2_S1378S1389 phospho",
    "MAP1B 1376_1389_2_2_S1387S1389 phospho",
    "MAP1B 1396_1415_1_1_S1396 phospho",
    "MAP1B 1396_1415_1_1_S1400 phospho",
    "MAP1B 1396_1415_2_2_S1396S1400 phospho",
    "MAP1B 1400_1415_1_1_S1400 phospho",
    "MAP1B 1433_1454_1_0 phospho",
    "MAP1B 1433_1454_1_1_S1438 phospho",
    "MAP1B 1433_1454_2_1_S1443 phospho",
    "MAP1B 1433_1454_2_2_S1438S1443 phospho",
    "MAP1B 1438_1454_1_0 phospho",
    "MAP1B 1438_1454_1_1_S1438 phospho",
    "MAP1B 1438_1454_1_1_S1443 phospho",
    "MAP1B 1438_1454_2_2_S1438S1443 phospho",
    "MAP1B 1478_1486_1_1_S1486 phospho",
    "MAP1B 1501_1512_1_0 phospho",
    "MAP1B 1501_1512_1_1_S1501 phospho",
    "MAP1B 1501_1517_1_0 phospho",
    "MAP1B 1501_1517_1_1_S1512 phospho",
    "MAP1B 1501_1517_2_2_S1501S1512 phospho",
    "MAP1B 1517_1527_1_1_S1520 phospho",
    "MAP1B 1520_1527_1_1_S1527 phospho",
    "MAP1B 1618_1625_1_1_S1620 phospho",
    "MAP1B 1618_1625_1_1_S1625 phospho",
    "MAP1B 1618_1625_2_2_S1618S1620 phospho",
    "MAP1B 1618_1625_2_2_S1620S1625 phospho",
    "MAP1B 1631_1633_1_0 phospho",
    "MAP1B 1631_1633_1_1_T1633 phospho",
    "MAP1B 1633_1633_1_1_T1633 phospho",
    "MAP1B 1640_1663_1_0 phospho",
    "MAP1B 1640_1663_1_1_S1653 phospho",
    "MAP1B 1666_1700_1_0 phospho",
    "MAP1B 1666_1700_1_1_S1666 phospho",
    "MAP1B 1666_1700_1_1_S1690 phospho",
    "MAP1B 1666_1700_2_2_S1666S1690 phospho",
    "MAP1B 1760_1767_1_1_S1764 phospho",
    "MAP1B 1772_1779_2_2_S1772S1779 phospho",
    "MAP1B 1772_1788_2_2_S1779S1782 phospho",
    "MAP1B 1772_1788_3_3_S1779S1782S1785 phospho",
    "MAP1B 1772_1788_3_3_S1779S1782T1788 phospho",
    "MAP1B 1782_1788_1_1_S1782 phospho",
    "MAP1B 1792_1805_1_0 phospho",
    "MAP1B 1792_1805_1_1_S1793 phospho",
    "MAP1B 1792_1805_2_2_S1793S1797 phospho",
    "MAP1B 1811_1830_1_0 phospho",
    "MAP1B 1811_1830_1_1_S1819 phospho",
    "MAP1B 1811_1830_2_0 phospho",
    "MAP1B 1835_1840_1_1_S1835 phospho",
    "MAP1B 1835_1853_1_1_S1852 phospho",
    "MAP1B 1852_1853_1_0 phospho",
    "MAP1B 1852_1853_1_1_T1853 phospho",
    "MAP1B 1864_1892_1_0 phospho",
    "MAP1B 1864_1892_1_1_S1881 phospho",
    "MAP1B 1878_1892_1_1_S1881 phospho",
    "MAP1B 1881_1892_1_1_S1881 phospho",
    "MAP1B 1895_1906_1_1_S1899 phospho",
    "MAP1B 1898_1906_1_1_S1899 phospho",
    "MAP1B 1912_1925_1_0 phospho",
    "MAP1B 1912_1925_1_1_S1915 phospho",
    "MAP1B 1915_1925_1_1_S1915 phospho",
    "MAP1B 1915_1925_1_1_S1917 phospho",
    "MAP1B 1915_1925_1_1_S1919 phospho",
    "MAP1B 1929_1940_1_1_T1932 phospho",
    "MAP1B 1929_1940_2_2_T1932S1939 phospho",
    "MAP1B 1932_1940_1_1_T1932 phospho",
    "MAP1B 1946_1960_1_1_T1949 phospho",
    "MAP1B 1949_1960_1_1_T1949 phospho",
    "MAP1B 1963_1974_1_1_S1965 phospho",
    "MAP1B 1963_1977_1_1_S1965 phospho",
    "MAP1B 1988_2011_1_0 phospho",
    "MAP1B 1988_2011_1_1_S1988 phospho",
    "MAP1B 1988_2011_1_1_T2000 phospho",
    "MAP1B 1988_2011_1_1_Y1991 phospho",
    "MAP1B 2015_2029_1_1_S2016 phospho",
    "MAP1B 2015_2029_1_1_Y2025 phospho",
    "MAP1B 2031_2044_1_0 phospho",
    "MAP1B 2031_2044_1_1_T2034 phospho",
    "MAP1B 2034_2044_1_1_T2034 phospho",
    "MAP1B 2049_2067_1_1_T2051 phospho",
    "MAP1B 2051_2074_1_1_S2072 phospho",
    "MAP1B 2072_2090_1_1_S2072 phospho",
    "MAP1B 2086_2090_1_1_S2086 phospho",
    "MAP1B 2086_2090_1_1_S2087 phospho",
    "MAP1B 2124_2126_1_1_S2126 phospho",
    "MAP1B 2209_2211_1_1_S2209 phospho",
    "MAP1B 2209_2211_2_2_S2209S2211 phospho",
    "MAP1B 2265_2271_1_1_S2271 phospho",
    "MAP1B 2271_2271_1_1_S2271 phospho",
    "MAP1B 2414_2426_1_1_S2414 phospho",
    "MAP1B 336_343_1_0 phospho",
    "MAP1B 336_343_1_1_S336 phospho",
    "MAP1B 336_343_1_1_S339 phospho",
    "MAP1B 336_343_1_1_S343 phospho",
    "MAP1B 336_343_2_0 phospho",
    "MAP1B 522_527_1_1_T527 phospho",
    "MAP1B 561_569_1_1_S561 phospho",
    "MAP1B 609_614_1_1_S614 phospho",
    "MAP1B 614_614_1_1_S614 phospho",
    "MAP1B 626_626_1_1_T626 phospho",
    "MAP1B 742_747_1_1_T744 phospho",
    "MAP1B 828_837_1_0 phospho",
    "MAP1B 828_837_1_1_S831 phospho",
    "MAP1B 828_837_1_1_S832 phospho",
    "MAP1B 828_837_2_2_S831S832 phospho",
    "MAP1B 828_851_2_2_S831S832 phospho",
    "MAP1B 87_91_1_1_S91 phospho",
    "MAP1B 891_908_1_1_S891 phospho",
    "MAP1B 91_91_1_1_S91 phospho",
    "MAP1B 936_942_1_1_S937 phospho",
    "MAP1B 948_967_1_1_S965 phospho",
    "MAP1B 948_967_1_1_T948 phospho",
    "MAP1B 970_977_1_1_S970 phospho",
    "MAP1B 970_977_2_2_S970S977 phospho",
    "MAP1B 970_985_1_1_S970 phospho",
    "MAP1B 992_995_1_1_S992 phospho",
    "MAP1B 992_995_1_1_S995 phospho",
    "MAP1B 992_995_2_2_S992S995 phospho",
    "MAP1B cnv",
    "MAP1B methyl",
    "MAP1B proteo",
    "MAP1B rna"
  ],
  "MAP1LC3A": [
    "MAP1LC3A cnv",
    "MAP1LC3A methyl",
    "MAP1LC3A proteo",
    "MAP1LC3A rna"
  ],
  "MAP1LC3B": [
    "MAP1LC3B cnv",
    "MAP1LC3B methyl",
    "MAP1LC3B rna"
  ],
  "MAP1LC3B2": [
    "MAP1LC3B2 cnv",
    "MAP1LC3B2 rna"
  ],
  "MAP1LC3C": [
    "MAP1LC3C cnv",
    "MAP1LC3C rna"
  ],
  "MAP1S": [
    "MAP1S 541_559_1_1_S556 phospho",
    "MAP1S 566_584_1_1_S566 phospho",
    "MAP1S 566_584_1_1_S584 phospho",
    "MAP1S 605_617_2_2_T612S614 phospho",
    "MAP1S 612_617_2_2_T612S614 phospho",
    "MAP1S 612_625_3_3_T612S614S620 phospho",
    "MAP1S 703_715_1_1_S705 phospho",
    "MAP1S 703_715_2_2_S703S705 phospho",
    "MAP1S 703_715_2_2_S705S715 phospho",
    "MAP1S 733_741_1_0 phospho",
    "MAP1S cnv",
    "MAP1S methyl",
    "MAP1S proteo",
    "MAP1S rna"
  ],
  "MAP2": [
    "MAP2 1005_1012_1_1_S1005 phospho",
    "MAP2 1020_1031_1_1_S1021 phospho",
    "MAP2 1130_1144_1_0 phospho",
    "MAP2 1130_1144_1_1_S1133 phospho",
    "MAP2 1130_1144_2_0 phospho",
    "MAP2 1130_1144_2_2_S1133S1134 phospho",
    "MAP2 1154_1159_1_0 phospho",
    "MAP2 1154_1159_1_1_S1155 phospho",
    "MAP2 1154_1159_2_2_S1155S1159 phospho",
    "MAP2 120_153_1_1_S136 phospho",
    "MAP2 120_153_2_0 phospho",
    "MAP2 120_153_2_2_S136S140 phospho",
    "MAP2 120_157_1_0 phospho",
    "MAP2 120_157_1_1_S136 phospho",
    "MAP2 120_157_2_0 phospho",
    "MAP2 120_162_1_1_S136 phospho",
    "MAP2 120_162_2_0 phospho",
    "MAP2 1252_1263_1_1_T1254 phospho",
    "MAP2 1252_1275_1_1_S1263 phospho",
    "MAP2 1324_1324_1_1_S1324 phospho",
    "MAP2 1347_1353_1_1_S1347 phospho",
    "MAP2 1347_1353_2_2_S1347S1353 phospho",
    "MAP2 1347_1364_2_2_S1347S1353 phospho",
    "MAP2 1474_1482_1_1_S1480 phospho",
    "MAP2 1528_1534_1_1_S1534 phospho",
    "MAP2 1539_1546_1_0 phospho",
    "MAP2 1539_1546_1_1_S1540 phospho",
    "MAP2 1555_1572_1_1_S1555 phospho",
    "MAP2 1588_1611_1_0 phospho",
    "MAP2 1588_1611_1_1_T1605 phospho",
    "MAP2 1588_1611_2_0 phospho",
    "MAP2 1588_1611_2_1_T1605 phospho",
    "MAP2 1588_1611_2_2_T1605S1608 phospho",
    "MAP2 1588_1611_3_0 phospho",
    "MAP2 1613_1622_1_1_T1613 phospho",
    "MAP2 1613_1622_1_1_T1616 phospho",
    "MAP2 1613_1622_2_2_T1616T1619 phospho",
    "MAP2 1613_1631_1_1_T1625 phospho",
    "MAP2 1625_1631_1_1_T1625 phospho",
    "MAP2 1625_1631_1_1_T1628 phospho",
    "MAP2 1625_1631_1_1_T1631 phospho",
    "MAP2 1625_1631_2_2_T1628T1631 phospho",
    "MAP2 1625_1640_3_3_T1628T1631S1634 phospho",
    "MAP2 1634_1640_1_1_S1634 phospho",
    "MAP2 1649_1649_1_1_T1649 phospho",
    "MAP2 1649_1656_1_1_S1653 phospho",
    "MAP2 1649_1656_1_1_T1649 phospho",
    "MAP2 1649_1656_2_2_S1653T1656 phospho",
    "MAP2 1649_1656_2_2_T1649S1653 phospho",
    "MAP2 1649_1656_3_3_T1649S1653T1656 phospho",
    "MAP2 1702_1706_1_1_S1706 phospho",
    "MAP2 1727_1727_1_1_S1727 phospho",
    "MAP2 1742_1742_1_1_S1742 phospho",
    "MAP2 1780_1782_1_1_S1782 phospho",
    "MAP2 1780_1790_1_1_S1782 phospho",
    "MAP2 1780_1790_1_1_S1790 phospho",
    "MAP2 1780_1790_2_2_S1782S1790 phospho",
    "MAP2 1780_1790_2_2_S1787S1790 phospho",
    "MAP2 1780_1790_3_0 phospho",
    "MAP2 1780_1790_3_2_S1782S1790 phospho",
    "MAP2 1795_1819_1_0 phospho",
    "MAP2 1795_1819_1_1_S1795 phospho",
    "MAP2 1795_1819_1_1_S1802 phospho",
    "MAP2 1795_1819_1_1_S1808 phospho",
    "MAP2 1795_1819_2_0 phospho",
    "MAP2 1795_1819_2_1_S1802 phospho",
    "MAP2 1795_1819_3_0 phospho",
    "MAP2 185_186_1_1_S185 phospho",
    "MAP2 229_233_1_1_S233 phospho",
    "MAP2 241_258_1_1_T258 phospho",
    "MAP2 285_290_1_1_S285 phospho",
    "MAP2 285_290_1_1_T290 phospho",
    "MAP2 285_290_2_2_S285T290 phospho",
    "MAP2 311_323_1_0 phospho",
    "MAP2 311_323_1_1_S311 phospho",
    "MAP2 311_323_2_0 phospho",
    "MAP2 311_323_2_2_S311S315 phospho",
    "MAP2 352_361_1_1_S357 phospho",
    "MAP2 425_436_1_1_T427 phospho",
    "MAP2 522_525_1_1_T522 phospho",
    "MAP2 601_610_1_1_S610 phospho",
    "MAP2 622_654_1_0 phospho",
    "MAP2 622_654_1_1_S629 phospho",
    "MAP2 626_654_1_1_S654 phospho",
    "MAP2 686_686_1_1_S686 phospho",
    "MAP2 699_711_1_1_S701 phospho",
    "MAP2 725_750_1_0 phospho",
    "MAP2 725_750_1_1_S725 phospho",
    "MAP2 725_750_1_1_T750 phospho",
    "MAP2 775_788_1_1_S788 phospho",
    "MAP2 821_823_1_1_S821 phospho",
    "MAP2 833_843_1_1_S833 phospho",
    "MAP2 860_869_1_1_S862 phospho",
    "MAP2 875_900_1_0 phospho",
    "MAP2 875_900_1_1_S881 phospho",
    "MAP2 cnv",
    "MAP2 methyl",
    "MAP2 proteo",
    "MAP2 rna"
  ],
  "MAP2K1": [
    "MAP2K1 292_316_1_0 phospho",
    "MAP2K1 364_388_1_0 phospho",
    "MAP2K1 cnv",
    "MAP2K1 kinase",
    "MAP2K1 methyl",
    "MAP2K1 proteo",
    "MAP2K1 rna"
  ],
  "MAP2K2": [
    "MAP2K2 13_30_1_0 phospho",
    "MAP2K2 13_30_1_1_S23 phospho",
    "MAP2K2 293_295_1_1_S295 phospho",
    "MAP2K2 cnv",
    "MAP2K2 kinase",
    "MAP2K2 methyl",
    "MAP2K2 proteo",
    "MAP2K2 rna"
  ],
  "MAP2K3": [
    "MAP2K3 cnv",
    "MAP2K3 kinase",
    "MAP2K3 methyl",
    "MAP2K3 proteo",
    "MAP2K3 rna"
  ],
  "MAP2K4": [
    "MAP2K4 101_109_1_1_S101 phospho",
    "MAP2K4 262_268_1_1_S268 phospho",
    "MAP2K4 402_408_1_0 phospho",
    "MAP2K4 402_408_1_1_S405 phospho",
    "MAP2K4 89_95_1_0 phospho",
    "MAP2K4 cnv",
    "MAP2K4 kinase",
    "MAP2K4 methyl",
    "MAP2K4 proteo",
    "MAP2K4 rna"
  ],
  "MAP2K4P1": [
    "MAP2K4P1 methyl"
  ],
  "MAP2K5": [
    "MAP2K5 cnv",
    "MAP2K5 kinase",
    "MAP2K5 methyl",
    "MAP2K5 proteo",
    "MAP2K5 rna"
  ],
  "MAP2K6": [
    "MAP2K6 25_35_1_0 phospho",
    "MAP2K6 cnv",
    "MAP2K6 kinase",
    "MAP2K6 proteo",
    "MAP2K6 rna"
  ],
  "MAP2K7": [
    "MAP2K7 cnv",
    "MAP2K7 kinase",
    "MAP2K7 methyl",
    "MAP2K7 proteo",
    "MAP2K7 rna"
  ],
  "MAP3K1": [
    "MAP3K1 20_21_1_1_S21 phospho",
    "MAP3K1 292_304_1_1_S292 phospho",
    "MAP3K1 cnv",
    "MAP3K1 kinase",
    "MAP3K1 methyl",
    "MAP3K1 proteo",
    "MAP3K1 rna"
  ],
  "MAP3K10": [
    "MAP3K10 558_564_1_1_T558 phospho",
    "MAP3K10 828_830_1_0 phospho",
    "MAP3K10 cnv",
    "MAP3K10 kinase",
    "MAP3K10 methyl",
    "MAP3K10 proteo",
    "MAP3K10 rna"
  ],
  "MAP3K11": [
    "MAP3K11 548_548_1_1_S548 phospho",
    "MAP3K11 cnv",
    "MAP3K11 kinase",
    "MAP3K11 methyl",
    "MAP3K11 rna"
  ],
  "MAP3K12": [
    "MAP3K12 533_536_1_1_S533 phospho",
    "MAP3K12 cnv",
    "MAP3K12 kinase",
    "MAP3K12 methyl",
    "MAP3K12 rna"
  ],
  "MAP3K13": [
    "MAP3K13 cnv",
    "MAP3K13 kinase",
    "MAP3K13 methyl",
    "MAP3K13 rna"
  ],
  "MAP3K14": [
    "MAP3K14 cnv",
    "MAP3K14 kinase",
    "MAP3K14 methyl",
    "MAP3K14 rna"
  ],
  "MAP3K15": [
    "MAP3K15 kinase",
    "MAP3K15 methyl",
    "MAP3K15 rna"
  ],
  "MAP3K19": [
    "MAP3K19 cnv",
    "MAP3K19 kinase",
    "MAP3K19 rna"
  ],
  "MAP3K2": [
    "MAP3K2 153_159_1_1_S153 phospho",
    "MAP3K2 163_169_1_0 phospho",
    "MAP3K2 163_169_1_1_S164 phospho",
    "MAP3K2 331_347_1_1_S331 phospho",
    "MAP3K2 cnv",
    "MAP3K2 kinase",
    "MAP3K2 methyl",
    "MAP3K2 proteo",
    "MAP3K2 rna"
  ],
  "MAP3K2-DT": [
    "MAP3K2-DT methyl"
  ],
  "MAP3K20": [
    "MAP3K20 635_644_1_1_S637 phospho",
    "MAP3K20 cnv",
    "MAP3K20 kinase",
    "MAP3K20 methyl",
    "MAP3K20 proteo",
    "MAP3K20 rna"
  ],
  "MAP3K21": [
    "MAP3K21 cnv",
    "MAP3K21 kinase",
    "MAP3K21 methyl",
    "MAP3K21 rna"
  ],
  "MAP3K3": [
    "MAP3K3 166_169_1_1_S166 phospho",
    "MAP3K3 333_341_1_1_S333 phospho",
    "MAP3K3 cnv",
    "MAP3K3 kinase",
    "MAP3K3 methyl",
    "MAP3K3 rna"
  ],
  "MAP3K4": [
    "MAP3K4 cnv",
    "MAP3K4 kinase",
    "MAP3K4 methyl",
    "MAP3K4 proteo",
    "MAP3K4 rna"
  ],
  "MAP3K5": [
    "MAP3K5 1015_1033_1_1_S1033 phospho",
    "MAP3K5 cnv",
    "MAP3K5 kinase",
    "MAP3K5 methyl",
    "MAP3K5 proteo",
    "MAP3K5 rna"
  ],
  "MAP3K6": [
    "MAP3K6 cnv",
    "MAP3K6 kinase",
    "MAP3K6 methyl",
    "MAP3K6 proteo",
    "MAP3K6 rna"
  ],
  "MAP3K7": [
    "MAP3K7 cnv",
    "MAP3K7 kinase",
    "MAP3K7 methyl",
    "MAP3K7 proteo",
    "MAP3K7 rna"
  ],
  "MAP3K7CL": [
    "MAP3K7CL cnv",
    "MAP3K7CL rna"
  ],
  "MAP3K8": [
    "MAP3K8 cnv",
    "MAP3K8 kinase",
    "MAP3K8 methyl",
    "MAP3K8 rna"
  ],
  "MAP3K9": [
    "MAP3K9 cnv",
    "MAP3K9 kinase",
    "MAP3K9 methyl",
    "MAP3K9 rna"
  ],
  "MAP3K9-DT": [
    "MAP3K9-DT methyl"
  ],
  "MAP4": [
    "MAP4 1073_1073_1_1_S1073 phospho",
    "MAP4 1142_1151_1_1_S1151 phospho",
    "MAP4 270_287_1_1_S280 phospho",
    "MAP4 280_287_1_1_S280 phospho",
    "MAP4 354_367_1_1_S358 phospho",
    "MAP4 358_367_1_1_S358 phospho",
    "MAP4 507_512_1_1_S507 phospho",
    "MAP4 507_526_1_0 phospho",
    "MAP4 507_526_1_1_S507 phospho",
    "MAP4 507_526_1_1_T521 phospho",
    "MAP4 507_526_2_2_S507T521 phospho",
    "MAP4 521_526_1_1_T521 phospho",
    "MAP4 565_571_1_1_T571 phospho",
    "MAP4 602_631_1_1_S624 phospho",
    "MAP4 68_101_1_0 phospho",
    "MAP4 68_101_1_1_S99 phospho",
    "MAP4 696_696_1_1_S696 phospho",
    "MAP4 701_715_1_1_S713 phospho",
    "MAP4 810_823_1_0 phospho",
    "MAP4 810_828_1_0 phospho",
    "MAP4 810_828_1_1_S825 phospho",
    "MAP4 82_101_1_1_S99 phospho",
    "MAP4 925_928_1_1_S928 phospho",
    "MAP4 925_928_1_1_T925 phospho",
    "MAP4 cnv",
    "MAP4 methyl",
    "MAP4 proteo",
    "MAP4 rna"
  ],
  "MAP4K1": [
    "MAP4K1 cnv",
    "MAP4K1 kinase",
    "MAP4K1 methyl",
    "MAP4K1 rna"
  ],
  "MAP4K1-AS1": [
    "MAP4K1-AS1 methyl"
  ],
  "MAP4K2": [
    "MAP4K2 385_401_1_1_S394 phospho",
    "MAP4K2 cnv",
    "MAP4K2 kinase",
    "MAP4K2 methyl",
    "MAP4K2 proteo",
    "MAP4K2 rna"
  ],
  "MAP4K3": [
    "MAP4K3 327_332_1_1_S329 phospho",
    "MAP4K3 cnv",
    "MAP4K3 kinase",
    "MAP4K3 methyl",
    "MAP4K3 proteo",
    "MAP4K3 rna"
  ],
  "MAP4K4": [
    "MAP4K4 516_519_1_1_S519 phospho",
    "MAP4K4 520_523_1_1_S523 phospho",
    "MAP4K4 541_545_1_1_S545 phospho",
    "MAP4K4 545_554_1_1_S549 phospho",
    "MAP4K4 556_563_1_1_S558 phospho",
    "MAP4K4 556_563_1_1_S563 phospho",
    "MAP4K4 556_563_2_2_S558S563 phospho",
    "MAP4K4 619_627_1_1_S623 phospho",
    "MAP4K4 631_641_1_1_S631 phospho",
    "MAP4K4 631_641_1_1_S641 phospho",
    "MAP4K4 631_651_1_1_S648 phospho",
    "MAP4K4 648_651_1_1_S648 phospho",
    "MAP4K4 796_807_1_0 phospho",
    "MAP4K4 796_807_1_1_S801 phospho",
    "MAP4K4 836_842_1_1_S838 phospho",
    "MAP4K4 836_842_1_1_T842 phospho",
    "MAP4K4 896_911_1_0 phospho",
    "MAP4K4 896_911_1_1_S896 phospho",
    "MAP4K4 896_911_1_1_T911 phospho",
    "MAP4K4 cnv",
    "MAP4K4 kinase",
    "MAP4K4 methyl",
    "MAP4K4 proteo",
    "MAP4K4 rna"
  ],
  "MAP4K5": [
    "MAP4K5 333_335_1_1_S335 phospho",
    "MAP4K5 433_453_1_0 phospho",
    "MAP4K5 cnv",
    "MAP4K5 kinase",
    "MAP4K5 methyl",
    "MAP4K5 proteo",
    "MAP4K5 rna"
  ],
  "MAP6": [
    "MAP6 487_487_1_1_S487 phospho",
    "MAP6 510_523_1_1_S519 phospho",
    "MAP6 519_523_1_1_S519 phospho",
    "MAP6 663_666_1_1_S663 phospho",
    "MAP6 802_812_1_1_S812 phospho",
    "MAP6 cnv",
    "MAP6 methyl",
    "MAP6 proteo",
    "MAP6 rna"
  ],
  "MAP6D1": [
    "MAP6D1 158_167_1_1_S167 phospho",
    "MAP6D1 cnv",
    "MAP6D1 methyl",
    "MAP6D1 proteo",
    "MAP6D1 rna"
  ],
  "MAP7": [
    "MAP7 cnv",
    "MAP7 methyl",
    "MAP7 proteo",
    "MAP7 rna"
  ],
  "MAP7D1": [
    "MAP7D1 112_128_1_0 phospho",
    "MAP7D1 112_128_1_1_S113 phospho",
    "MAP7D1 112_128_1_1_S116 phospho",
    "MAP7D1 112_128_2_0 phospho",
    "MAP7D1 112_128_2_1_S116 phospho",
    "MAP7D1 112_128_2_2_S113S116 phospho",
    "MAP7D1 21_21_1_1_T21 phospho",
    "MAP7D1 21_51_1_1_S34 phospho",
    "MAP7D1 252_254_1_1_S252 phospho",
    "MAP7D1 252_254_1_1_S254 phospho",
    "MAP7D1 332_344_1_1_S334 phospho",
    "MAP7D1 378_378_1_1_S378 phospho",
    "MAP7D1 410_414_1_1_S410 phospho",
    "MAP7D1 420_428_1_1_S428 phospho",
    "MAP7D1 507_522_1_1_S512 phospho",
    "MAP7D1 507_522_3_3_S512S516S520 phospho",
    "MAP7D1 708_709_1_0 phospho",
    "MAP7D1 708_709_1_1_S709 phospho",
    "MAP7D1 70_89_1_1_S70 phospho",
    "MAP7D1 70_89_1_1_S86 phospho",
    "MAP7D1 70_89_2_2_S70S86 phospho",
    "MAP7D1 86_89_1_1_S86 phospho",
    "MAP7D1 97_97_1_1_T97 phospho",
    "MAP7D1 cnv",
    "MAP7D1 methyl",
    "MAP7D1 proteo",
    "MAP7D1 rna"
  ],
  "MAP7D2": [
    "MAP7D2 348_356_1_1_S356 phospho",
    "MAP7D2 methyl",
    "MAP7D2 proteo",
    "MAP7D2 rna"
  ],
  "MAP7D3": [
    "MAP7D3 211_217_1_1_S211 phospho",
    "MAP7D3 methyl",
    "MAP7D3 proteo",
    "MAP7D3 rna"
  ],
  "MAP9": [
    "MAP9 79_87_1_1_S79 phospho",
    "MAP9 cnv",
    "MAP9 methyl",
    "MAP9 proteo",
    "MAP9 rna"
  ],
  "MAPK1": [
    "MAPK1 cnv",
    "MAPK1 kinase",
    "MAPK1 methyl",
    "MAPK1 proteo",
    "MAPK1 rna"
  ],
  "MAPK10": [
    "MAPK10 377_379_1_1_S377 phospho",
    "MAPK10 cnv",
    "MAPK10 kinase",
    "MAPK10 methyl",
    "MAPK10 proteo",
    "MAPK10 rna"
  ],
  "MAPK11": [
    "MAPK11 cnv",
    "MAPK11 kinase",
    "MAPK11 methyl",
    "MAPK11 rna"
  ],
  "MAPK12": [
    "MAPK12 cnv",
    "MAPK12 kinase",
    "MAPK12 methyl",
    "MAPK12 proteo",
    "MAPK12 rna"
  ],
  "MAPK13": [
    "MAPK13 cnv",
    "MAPK13 kinase",
    "MAPK13 methyl",
    "MAPK13 rna"
  ],
  "MAPK14": [
    "MAPK14 175_185_1_1_Y182 phospho",
    "MAPK14 175_185_2_2_T180Y182 phospho",
    "MAPK14 cnv",
    "MAPK14 kinase",
    "MAPK14 methyl",
    "MAPK14 proteo",
    "MAPK14 rna"
  ],
  "MAPK15": [
    "MAPK15 cnv",
    "MAPK15 kinase",
    "MAPK15 methyl",
    "MAPK15 rna"
  ],
  "MAPK1IP1L": [
    "MAPK1IP1L cnv",
    "MAPK1IP1L methyl",
    "MAPK1IP1L proteo",
    "MAPK1IP1L rna"
  ],
  "MAPK3": [
    "MAPK3 cnv",
    "MAPK3 kinase",
    "MAPK3 methyl",
    "MAPK3 proteo",
    "MAPK3 rna"
  ],
  "MAPK4": [
    "MAPK4 386_386_1_1_S386 phospho",
    "MAPK4 424_430_1_1_S427 phospho",
    "MAPK4 499_508_1_1_S508 phospho",
    "MAPK4 cnv",
    "MAPK4 kinase",
    "MAPK4 methyl",
    "MAPK4 proteo",
    "MAPK4 rna"
  ],
  "MAPK6": [
    "MAPK6 189_194_1_1_S189 phospho",
    "MAPK6 cnv",
    "MAPK6 kinase",
    "MAPK6 methyl",
    "MAPK6 rna"
  ],
  "MAPK6-DT": [
    "MAPK6-DT methyl"
  ],
  "MAPK7": [
    "MAPK7 cnv",
    "MAPK7 kinase",
    "MAPK7 methyl",
    "MAPK7 proteo",
    "MAPK7 rna"
  ],
  "MAPK8": [
    "MAPK8 cnv",
    "MAPK8 kinase",
    "MAPK8 methyl",
    "MAPK8 proteo",
    "MAPK8 rna"
  ],
  "MAPK8IP1": [
    "MAPK8IP1 173_181_1_1_S181 phospho",
    "MAPK8IP1 cnv",
    "MAPK8IP1 methyl",
    "MAPK8IP1 proteo",
    "MAPK8IP1 rna"
  ],
  "MAPK8IP2": [
    "MAPK8IP2 cnv",
    "MAPK8IP2 methyl",
    "MAPK8IP2 rna"
  ],
  "MAPK8IP3": [
    "MAPK8IP3 1184_1206_1_1_S1185 phospho",
    "MAPK8IP3 206_217_1_1_S207 phospho",
    "MAPK8IP3 273_302_1_1_T275 phospho",
    "MAPK8IP3 273_302_1_1_T286 phospho",
    "MAPK8IP3 362_367_1_1_S365 phospho",
    "MAPK8IP3 575_579_1_1_S579 phospho",
    "MAPK8IP3 575_594_1_1_S579 phospho",
    "MAPK8IP3 614_631_1_1_S614 phospho",
    "MAPK8IP3 670_678_1_1_S670 phospho",
    "MAPK8IP3 744_748_1_1_S748 phospho",
    "MAPK8IP3 744_748_2_2_S744S748 phospho",
    "MAPK8IP3 cnv",
    "MAPK8IP3 methyl",
    "MAPK8IP3 proteo",
    "MAPK8IP3 rna"
  ],
  "MAPK9": [
    "MAPK9 cnv",
    "MAPK9 kinase",
    "MAPK9 methyl",
    "MAPK9 proteo",
    "MAPK9 rna"
  ],
  "MAPKAP1": [
    "MAPKAP1 509_512_1_1_S510 phospho",
    "MAPKAP1 cnv",
    "MAPKAP1 methyl",
    "MAPKAP1 proteo",
    "MAPKAP1 rna"
  ],
  "MAPKAPK2": [
    "MAPKAPK2 214_229_1_0 phospho",
    "MAPKAPK2 cnv",
    "MAPKAPK2 kinase",
    "MAPKAPK2 methyl",
    "MAPKAPK2 proteo",
    "MAPKAPK2 rna"
  ],
  "MAPKAPK3": [
    "MAPKAPK3 cnv",
    "MAPKAPK3 kinase",
    "MAPKAPK3 methyl",
    "MAPKAPK3 proteo",
    "MAPKAPK3 rna"
  ],
  "MAPKAPK5": [
    "MAPKAPK5 cnv",
    "MAPKAPK5 kinase",
    "MAPKAPK5 methyl",
    "MAPKAPK5 rna"
  ],
  "MAPKAPK5-AS1": [
    "MAPKAPK5-AS1 methyl"
  ],
  "MAPKBP1": [
    "MAPKBP1 1198_1201_1_1_S1198 phospho",
    "MAPKBP1 1261_1263_1_1_S1263 phospho",
    "MAPKBP1 cnv",
    "MAPKBP1 methyl",
    "MAPKBP1 proteo",
    "MAPKBP1 rna"
  ],
  "MAPRE1": [
    "MAPRE1 cnv",
    "MAPRE1 methyl",
    "MAPRE1 proteo",
    "MAPRE1 rna"
  ],
  "MAPRE2": [
    "MAPRE2 195_202_1_1_S200 phospho",
    "MAPRE2 5_25_1_1_S9 phospho",
    "MAPRE2 cnv",
    "MAPRE2 methyl",
    "MAPRE2 proteo",
    "MAPRE2 rna"
  ],
  "MAPRE3": [
    "MAPRE3 149_149_1_1_S149 phospho",
    "MAPRE3 155_164_1_1_S162 phospho",
    "MAPRE3 171_176_1_1_S176 phospho",
    "MAPRE3 cnv",
    "MAPRE3 methyl",
    "MAPRE3 proteo",
    "MAPRE3 rna"
  ],
  "MAPT": [
    "MAPT 29_64_1_1_S46 phospho",
    "MAPT 29_64_2_0 phospho",
    "MAPT 29_65_1_1_S55 phospho",
    "MAPT 416_438_1_0 phospho",
    "MAPT 416_438_1_1_S438 phospho",
    "MAPT 46_64_1_1_S61 phospho",
    "MAPT 492_492_1_1_T492 phospho",
    "MAPT 492_502_1_1_T498 phospho",
    "MAPT 492_502_2_2_T492T498 phospho",
    "MAPT 492_508_1_1_T498 phospho",
    "MAPT 498_502_1_1_T498 phospho",
    "MAPT 498_525_1_1_S519 phospho",
    "MAPT 512_525_1_1_S516 phospho",
    "MAPT 512_525_1_1_S519 phospho",
    "MAPT 512_525_2_2_S515S516 phospho",
    "MAPT 512_525_2_2_S516S519 phospho",
    "MAPT 512_525_2_2_S519T522 phospho",
    "MAPT 512_525_3_3_S515S516S519 phospho",
    "MAPT 512_525_3_3_S516S519T522 phospho",
    "MAPT 527_537_1_1_T529 phospho",
    "MAPT 527_537_2_2_T529S531 phospho",
    "MAPT 527_537_2_2_T529T534 phospho",
    "MAPT 529_537_1_1_S531 phospho",
    "MAPT 529_537_1_1_T534 phospho",
    "MAPT 548_548_1_1_T548 phospho",
    "MAPT 548_555_1_1_T548 phospho",
    "MAPT 548_555_2_2_T548S552 phospho",
    "MAPT 548_555_2_2_T548S554 phospho",
    "MAPT 641_641_1_1_S641 phospho",
    "MAPT 68_94_2_2_T82S84 phospho",
    "MAPT 703_721_1_1_S713 phospho",
    "MAPT 703_721_1_1_S717 phospho",
    "MAPT 703_721_1_1_S721 phospho",
    "MAPT 703_721_2_0 phospho",
    "MAPT 703_721_2_2_S713S717 phospho",
    "MAPT 703_721_2_2_S713S721 phospho",
    "MAPT 703_721_2_2_S717S721 phospho",
    "MAPT 703_721_2_2_Y711S713 phospho",
    "MAPT 703_721_3_0 phospho",
    "MAPT 703_721_3_2_S713S717 phospho",
    "MAPT 703_721_3_3_S713S717S721 phospho",
    "MAPT 713_721_1_1_S721 phospho",
    "MAPT 713_721_2_0 phospho",
    "MAPT 713_721_2_2_S717S721 phospho",
    "MAPT 726_752_1_0 phospho",
    "MAPT 726_752_1_1_S733 phospho",
    "MAPT 726_752_2_0 phospho",
    "MAPT 726_752_2_2_S726S730 phospho",
    "MAPT 82_94_1_1_S84 phospho",
    "MAPT cnv",
    "MAPT methyl",
    "MAPT proteo",
    "MAPT rna"
  ],
  "MAPT-IT1": [
    "MAPT-IT1 methyl"
  ],
  "MARCHF1": [
    "MARCHF1 cnv",
    "MARCHF1 methyl",
    "MARCHF1 rna"
  ],
  "MARCHF10": [
    "MARCHF10 cnv",
    "MARCHF10 methyl",
    "MARCHF10 rna"
  ],
  "MARCHF10-DT": [
    "MARCHF10-DT methyl"
  ],
  "MARCHF11": [
    "MARCHF11 cnv",
    "MARCHF11 methyl",
    "MARCHF11 rna"
  ],
  "MARCHF2": [
    "MARCHF2 cnv",
    "MARCHF2 methyl",
    "MARCHF2 rna"
  ],
  "MARCHF3": [
    "MARCHF3 cnv",
    "MARCHF3 methyl",
    "MARCHF3 rna"
  ],
  "MARCHF4": [
    "MARCHF4 cnv",
    "MARCHF4 methyl",
    "MARCHF4 rna"
  ],
  "MARCHF5": [
    "MARCHF5 cnv",
    "MARCHF5 methyl",
    "MARCHF5 proteo",
    "MARCHF5 rna"
  ],
  "MARCHF6": [
    "MARCHF6 cnv",
    "MARCHF6 methyl",
    "MARCHF6 rna"
  ],
  "MARCHF7": [
    "MARCHF7 13_21_1_1_S13 phospho",
    "MARCHF7 cnv",
    "MARCHF7 methyl",
    "MARCHF7 proteo",
    "MARCHF7 rna"
  ],
  "MARCHF8": [
    "MARCHF8 cnv",
    "MARCHF8 methyl",
    "MARCHF8 rna"
  ],
  "MARCHF9": [
    "MARCHF9 cnv",
    "MARCHF9 methyl",
    "MARCHF9 rna"
  ],
  "MARCKS": [
    "MARCKS 101_101_1_1_S101 phospho",
    "MARCKS 118_135_1_0 phospho",
    "MARCKS 118_135_1_1_S118 phospho",
    "MARCKS 118_135_2_0 phospho",
    "MARCKS 118_150_1_0 phospho",
    "MARCKS 118_150_2_0 phospho",
    "MARCKS 118_150_3_0 phospho",
    "MARCKS 143_150_1_0 phospho",
    "MARCKS 143_150_1_1_S147 phospho",
    "MARCKS 143_150_1_1_T150 phospho",
    "MARCKS 143_150_2_0 phospho",
    "MARCKS 143_150_2_2_S145T150 phospho",
    "MARCKS 143_150_2_2_T143S145 phospho",
    "MARCKS 143_150_2_2_T143T150 phospho",
    "MARCKS 143_150_3_3_T143S145T150 phospho",
    "MARCKS 26_29_1_0 phospho",
    "MARCKS 26_29_1_1_S27 phospho",
    "MARCKS 26_29_1_1_S29 phospho",
    "MARCKS 46_52_1_1_S46 phospho",
    "MARCKS 46_83_1_0 phospho",
    "MARCKS 46_83_1_1_S77 phospho",
    "MARCKS 63_101_2_0 phospho",
    "MARCKS 63_63_1_1_S63 phospho",
    "MARCKS 77_83_1_1_S81 phospho",
    "MARCKS 77_83_2_2_S77S81 phospho",
    "MARCKS 8_29_1_1_S27 phospho",
    "MARCKS cnv",
    "MARCKS proteo",
    "MARCKS rna"
  ],
  "MARCKSL1": [
    "MARCKSL1 116_139_1_0 phospho",
    "MARCKSL1 116_139_2_0 phospho",
    "MARCKSL1 148_151_1_1_S151 phospho",
    "MARCKSL1 148_151_1_1_T148 phospho",
    "MARCKSL1 148_151_2_2_T148S151 phospho",
    "MARCKSL1 14_22_1_1_S22 phospho",
    "MARCKSL1 14_41_1_1_S36 phospho",
    "MARCKSL1 162_190_1_0 phospho",
    "MARCKSL1 36_41_1_1_S36 phospho",
    "MARCKSL1 36_71_1_0 phospho",
    "MARCKSL1 36_71_1_1_S41 phospho",
    "MARCKSL1 48_71_1_0 phospho",
    "MARCKSL1 48_71_1_1_S48 phospho",
    "MARCKSL1 48_85_1_1_T85 phospho",
    "MARCKSL1 85_85_1_1_T85 phospho",
    "MARCKSL1 cnv",
    "MARCKSL1 methyl",
    "MARCKSL1 proteo",
    "MARCKSL1 rna"
  ],
  "MARCO": [
    "MARCO cnv",
    "MARCO rna"
  ],
  "MARCOL": [
    "MARCOL cnv"
  ],
  "MARF1": [
    "MARF1 1088_1101_1_1_S1090 phospho",
    "MARF1 cnv",
    "MARF1 methyl",
    "MARF1 proteo",
    "MARF1 rna"
  ],
  "MARK1": [
    "MARK1 380_383_1_1_S382 phospho",
    "MARK1 390_403_1_0 phospho",
    "MARK1 390_403_2_0 phospho",
    "MARK1 46_60_1_1_S46 phospho",
    "MARK1 504_505_1_1_T504 phospho",
    "MARK1 554_558_1_1_S556 phospho",
    "MARK1 589_599_1_1_S589 phospho",
    "MARK1 613_614_1_1_T614 phospho",
    "MARK1 649_655_1_1_S650 phospho",
    "MARK1 667_672_1_1_S667 phospho",
    "MARK1 cnv",
    "MARK1 kinase",
    "MARK1 methyl",
    "MARK1 proteo",
    "MARK1 rna"
  ],
  "MARK2": [
    "MARK2 332_359_1_1_S357 phospho",
    "MARK2 347_359_1_1_S357 phospho",
    "MARK2 409_423_1_1_S409 phospho",
    "MARK2 409_423_1_1_S421 phospho",
    "MARK2 409_424_1_1_S409 phospho",
    "MARK2 422_422_1_1_S422 phospho",
    "MARK2 432_446_1_1_T433 phospho",
    "MARK2 449_452_1_1_S452 phospho",
    "MARK2 535_544_1_1_S535 phospho",
    "MARK2 535_544_1_1_S537 phospho",
    "MARK2 561_562_1_1_T562 phospho",
    "MARK2 7_20_1_1_S7 phospho",
    "MARK2 cnv",
    "MARK2 kinase",
    "MARK2 methyl",
    "MARK2 proteo",
    "MARK2 rna"
  ],
  "MARK3": [
    "MARK3 368_383_1_1_S378 phospho",
    "MARK3 368_384_1_1_S384 phospho",
    "MARK3 390_400_1_1_S400 phospho",
    "MARK3 390_400_2_2_S391S400 phospho",
    "MARK3 418_432_1_1_S419 phospho",
    "MARK3 42_56_1_1_S42 phospho",
    "MARK3 469_476_1_1_S469 phospho",
    "MARK3 507_511_1_1_T507 phospho",
    "MARK3 536_549_1_1_S540 phospho",
    "MARK3 563_564_1_1_T564 phospho",
    "MARK3 574_596_1_1_S583 phospho",
    "MARK3 598_606_1_1_S598 phospho",
    "MARK3 cnv",
    "MARK3 kinase",
    "MARK3 methyl",
    "MARK3 proteo",
    "MARK3 rna"
  ],
  "MARK4": [
    "MARK4 423_429_1_1_S423 phospho",
    "MARK4 438_442_1_1_S438 phospho",
    "MARK4 cnv",
    "MARK4 kinase",
    "MARK4 methyl",
    "MARK4 proteo",
    "MARK4 rna"
  ],
  "MARS1": [
    "MARS1 209_209_1_1_S209 phospho",
    "MARS1 824_836_1_1_S825 phospho",
    "MARS1 824_850_1_1_S825 phospho",
    "MARS1 cnv",
    "MARS1 methyl",
    "MARS1 proteo",
    "MARS1 rna"
  ],
  "MARS2": [
    "MARS2 cnv",
    "MARS2 methyl",
    "MARS2 proteo",
    "MARS2 rna"
  ],
  "MARVELD1": [
    "MARVELD1 cnv",
    "MARVELD1 methyl",
    "MARVELD1 proteo",
    "MARVELD1 rna"
  ],
  "MARVELD2": [
    "MARVELD2 cnv",
    "MARVELD2 methyl",
    "MARVELD2 rna"
  ],
  "MARVELD3": [
    "MARVELD3 cnv",
    "MARVELD3 methyl",
    "MARVELD3 rna"
  ],
  "MAS1": [
    "MAS1 cnv",
    "MAS1 rna"
  ],
  "MAS1L": [
    "MAS1L cnv"
  ],
  "MASP1": [
    "MASP1 FGYILHTDNR-N2H6F0S0G0 glyco",
    "MASP1 FGYILHTDNR-N4H5F0S2G0 glyco",
    "MASP1 NNLTTYK-N4H5F0S2G0 glyco",
    "MASP1 cnv",
    "MASP1 proteo",
    "MASP1 rna"
  ],
  "MASP2": [
    "MASP2 cnv",
    "MASP2 rna"
  ],
  "MAST1": [
    "MAST1 139_144_1_1_S139 phospho",
    "MAST1 1424_1431_1_1_S1425 phospho",
    "MAST1 715_722_1_1_S717 phospho",
    "MAST1 cnv",
    "MAST1 kinase",
    "MAST1 methyl",
    "MAST1 proteo",
    "MAST1 rna"
  ],
  "MAST2": [
    "MAST2 1239_1244_1_1_S1239 phospho",
    "MAST2 1361_1375_1_1_S1363 phospho",
    "MAST2 1380_1380_1_1_S1380 phospho",
    "MAST2 144_153_1_1_S148 phospho",
    "MAST2 74_82_1_1_S74 phospho",
    "MAST2 92_92_1_1_S92 phospho",
    "MAST2 931_931_1_1_S931 phospho",
    "MAST2 cnv",
    "MAST2 kinase",
    "MAST2 methyl",
    "MAST2 proteo",
    "MAST2 rna"
  ],
  "MAST3": [
    "MAST3 134_146_2_2_S134S146 phospho",
    "MAST3 792_793_1_1_S793 phospho",
    "MAST3 85_109_1_1_S85 phospho",
    "MAST3 cnv",
    "MAST3 kinase",
    "MAST3 methyl",
    "MAST3 proteo",
    "MAST3 rna"
  ],
  "MAST4": [
    "MAST4 1370_1377_1_1_S1370 phospho",
    "MAST4 137_143_1_1_S137 phospho",
    "MAST4 1382_1391_1_1_S1391 phospho",
    "MAST4 1419_1422_1_1_S1419 phospho",
    "MAST4 cnv",
    "MAST4 kinase",
    "MAST4 methyl",
    "MAST4 proteo",
    "MAST4 rna"
  ],
  "MASTL": [
    "MASTL cnv",
    "MASTL kinase",
    "MASTL methyl",
    "MASTL proteo",
    "MASTL rna"
  ],
  "MAT1A": [
    "MAT1A cnv",
    "MAT1A rna"
  ],
  "MAT2A": [
    "MAT2A cnv",
    "MAT2A methyl",
    "MAT2A proteo",
    "MAT2A rna"
  ],
  "MAT2B": [
    "MAT2B 259_282_1_1_S282 phospho",
    "MAT2B cnv",
    "MAT2B methyl",
    "MAT2B proteo",
    "MAT2B rna"
  ],
  "MATK": [
    "MATK 485_502_1_1_S502 phospho",
    "MATK cnv",
    "MATK kinase",
    "MATK methyl",
    "MATK rna"
  ],
  "MATN1": [
    "MATN1 cnv",
    "MATN1 rna"
  ],
  "MATN1-AS1": [
    "MATN1-AS1 methyl"
  ],
  "MATN2": [
    "MATN2 cnv",
    "MATN2 methyl",
    "MATN2 proteo",
    "MATN2 rna"
  ],
  "MATN3": [
    "MATN3 cnv",
    "MATN3 methyl",
    "MATN3 rna"
  ],
  "MATN4": [
    "MATN4 cnv",
    "MATN4 methyl",
    "MATN4 rna"
  ],
  "MATR3": [
    "MATR3 188_206_1_1_S188 phospho",
    "MATR3 188_206_1_1_S206 phospho",
    "MATR3 208_214_1_1_S208 phospho",
    "MATR3 234_243_1_1_S234 phospho",
    "MATR3 234_250_1_1_S240 phospho",
    "MATR3 4_11_1_1_S4 phospho",
    "MATR3 596_598_1_1_S598 phospho",
    "MATR3 596_598_2_2_S596S598 phospho",
    "MATR3 596_606_1_1_S598 phospho",
    "MATR3 596_606_2_0 phospho",
    "MATR3 596_606_2_2_S598S604 phospho",
    "MATR3 741_748_1_0 phospho",
    "MATR3 758_766_1_1_S766 phospho",
    "MATR3 758_779_1_1_S766 phospho",
    "MATR3 cnv",
    "MATR3 methyl",
    "MATR3 proteo",
    "MATR3 rna"
  ],
  "MAU2": [
    "MAU2 cnv",
    "MAU2 methyl",
    "MAU2 proteo",
    "MAU2 rna"
  ],
  "MAVS": [
    "MAVS 139_165_1_1_S152 phospho",
    "MAVS 139_165_1_1_S165 phospho",
    "MAVS 244_263_1_0 phospho",
    "MAVS 244_263_1_1_S253 phospho",
    "MAVS cnv",
    "MAVS methyl",
    "MAVS proteo",
    "MAVS rna"
  ],
  "MAX": [
    "MAX cnv",
    "MAX methyl",
    "MAX proteo",
    "MAX rna"
  ],
  "MAZ": [
    "MAZ cnv",
    "MAZ methyl",
    "MAZ proteo",
    "MAZ rna"
  ],
  "MB": [
    "MB cnv",
    "MB proteo",
    "MB rna"
  ],
  "MB21D2": [
    "MB21D2 433_442_1_1_S433 phospho",
    "MB21D2 cnv",
    "MB21D2 methyl",
    "MB21D2 proteo",
    "MB21D2 rna"
  ],
  "MBD1": [
    "MBD1 320_326_1_1_S322 phospho",
    "MBD1 385_411_1_1_S386 phospho",
    "MBD1 441_467_1_1_S442 phospho",
    "MBD1 489_502_1_1_S490 phospho",
    "MBD1 cnv",
    "MBD1 methyl",
    "MBD1 proteo",
    "MBD1 rna"
  ],
  "MBD2": [
    "MBD2 398_407_1_1_S407 phospho",
    "MBD2 cnv",
    "MBD2 methyl",
    "MBD2 proteo",
    "MBD2 rna"
  ],
  "MBD3": [
    "MBD3 52_61_1_1_S56 phospho",
    "MBD3 cnv",
    "MBD3 methyl",
    "MBD3 proteo",
    "MBD3 rna"
  ],
  "MBD3L1": [
    "MBD3L1 cnv",
    "MBD3L1 methyl"
  ],
  "MBD3L2": [
    "MBD3L2 cnv"
  ],
  "MBD3L2B": [
    "MBD3L2B cnv"
  ],
  "MBD3L3": [
    "MBD3L3 cnv"
  ],
  "MBD3L4": [
    "MBD3L4 cnv"
  ],
  "MBD3L5": [
    "MBD3L5 cnv"
  ],
  "MBD4": [
    "MBD4 cnv",
    "MBD4 methyl",
    "MBD4 rna"
  ],
  "MBD5": [
    "MBD5 cnv",
    "MBD5 methyl",
    "MBD5 rna"
  ],
  "MBD6": [
    "MBD6 cnv",
    "MBD6 methyl",
    "MBD6 rna"
  ],
  "MBIP": [
    "MBIP cnv",
    "MBIP proteo",
    "MBIP rna"
  ],
  "MBL2": [
    "MBL2 cnv",
    "MBL2 proteo"
  ],
  "MBLAC1": [
    "MBLAC1 cnv",
    "MBLAC1 proteo",
    "MBLAC1 rna"
  ],
  "MBLAC2": [
    "MBLAC2 cnv",
    "MBLAC2 methyl",
    "MBLAC2 proteo",
    "MBLAC2 rna"
  ],
  "MBNL1": [
    "MBNL1 cnv",
    "MBNL1 methyl",
    "MBNL1 proteo",
    "MBNL1 rna"
  ],
  "MBNL2": [
    "MBNL2 cnv",
    "MBNL2 proteo",
    "MBNL2 rna"
  ],
  "MBNL3": [
    "MBNL3 methyl",
    "MBNL3 proteo",
    "MBNL3 rna"
  ],
  "MBOAT1": [
    "MBOAT1 cnv",
    "MBOAT1 methyl",
    "MBOAT1 rna"
  ],
  "MBOAT2": [
    "MBOAT2 cnv",
    "MBOAT2 methyl",
    "MBOAT2 proteo",
    "MBOAT2 rna"
  ],
  "MBOAT4": [
    "MBOAT4 cnv",
    "MBOAT4 rna"
  ],
  "MBOAT7": [
    "MBOAT7 204_212_1_1_S212 phospho",
    "MBOAT7 386_390_1_1_S386 phospho",
    "MBOAT7 cnv",
    "MBOAT7 methyl",
    "MBOAT7 proteo",
    "MBOAT7 rna"
  ],
  "MBP": [
    "MBP 146_154_1_1_S146 phospho",
    "MBP 148_154_1_1_S153 phospho",
    "MBP 169_174_1_1_T169 phospho",
    "MBP 200_205_1_1_S205 phospho",
    "MBP 200_205_1_1_Y203 phospho",
    "MBP 200_210_1_1_S205 phospho",
    "MBP 229_236_2_2_T229T232 phospho",
    "MBP 232_236_1_1_T232 phospho",
    "MBP 249_261_1_1_S249 phospho",
    "MBP 249_268_1_1_S249 phospho",
    "MBP 283_285_1_1_S285 phospho",
    "MBP 283_285_1_1_T283 phospho",
    "MBP 295_299_1_1_S299 phospho",
    "MBP 297_299_1_1_S299 phospho",
    "MBP 38_67_1_0 phospho",
    "MBP 38_67_1_1_S40 phospho",
    "MBP 68_72_1_1_S68 phospho",
    "MBP cnv",
    "MBP methyl",
    "MBP proteo",
    "MBP rna"
  ],
  "MBTD1": [
    "MBTD1 cnv",
    "MBTD1 methyl",
    "MBTD1 rna"
  ],
  "MBTPS1": [
    "MBTPS1 cnv",
    "MBTPS1 methyl",
    "MBTPS1 rna"
  ],
  "MBTPS2": [
    "MBTPS2 methyl",
    "MBTPS2 rna"
  ],
  "MC1R": [
    "MC1R cnv",
    "MC1R rna"
  ],
  "MC2R": [
    "MC2R cnv"
  ],
  "MC3R": [
    "MC3R cnv",
    "MC3R rna"
  ],
  "MC4R": [
    "MC4R cnv",
    "MC4R rna"
  ],
  "MC5R": [
    "MC5R cnv",
    "MC5R methyl",
    "MC5R rna"
  ],
  "MCAM": [
    "MCAM 606_606_1_1_S606 phospho",
    "MCAM CGLSQSQGNLSHVDWFSVHK-N5H3F1S0G0 glyco",
    "MCAM CVASVPSIPGLNR-N4H5F0S1G0 glyco",
    "MCAM CVASVPSIPGLNR-N5H3F0S0G0 glyco",
    "MCAM CVASVPSIPGLNR-N5H4F0S0G0 glyco",
    "MCAM cnv",
    "MCAM methyl",
    "MCAM proteo",
    "MCAM rna"
  ],
  "MCAT": [
    "MCAT cnv",
    "MCAT methyl",
    "MCAT proteo",
    "MCAT rna"
  ],
  "MCC": [
    "MCC 1010_1018_1_1_S1018 phospho",
    "MCC 305_318_2_2_S308S310 phospho",
    "MCC 476_484_1_1_S484 phospho",
    "MCC cnv",
    "MCC methyl",
    "MCC proteo",
    "MCC rna"
  ],
  "MCCC1": [
    "MCCC1 cnv",
    "MCCC1 methyl",
    "MCCC1 proteo",
    "MCCC1 rna"
  ],
  "MCCC2": [
    "MCCC2 cnv",
    "MCCC2 methyl",
    "MCCC2 proteo",
    "MCCC2 rna"
  ],
  "MCCD1": [
    "MCCD1 cnv",
    "MCCD1 rna"
  ],
  "MCEE": [
    "MCEE cnv",
    "MCEE methyl",
    "MCEE proteo",
    "MCEE rna"
  ],
  "MCEMP1": [
    "MCEMP1 cnv",
    "MCEMP1 rna"
  ],
  "MCF2": [
    "MCF2 methyl",
    "MCF2 rna"
  ],
  "MCF2L": [
    "MCF2L 559_564_1_1_S559 phospho",
    "MCF2L 590_597_1_1_S590 phospho",
    "MCF2L 933_947_1_1_S935 phospho",
    "MCF2L 933_947_1_1_S945 phospho",
    "MCF2L 933_947_2_2_S935S945 phospho",
    "MCF2L 933_951_1_1_S945 phospho",
    "MCF2L cnv",
    "MCF2L methyl",
    "MCF2L proteo",
    "MCF2L rna"
  ],
  "MCF2L2": [
    "MCF2L2 cnv",
    "MCF2L2 methyl",
    "MCF2L2 rna"
  ],
  "MCFD2": [
    "MCFD2 cnv",
    "MCFD2 methyl",
    "MCFD2 proteo",
    "MCFD2 rna"
  ],
  "MCHR1": [
    "MCHR1 cnv",
    "MCHR1 rna"
  ],
  "MCHR2": [
    "MCHR2 cnv",
    "MCHR2 methyl",
    "MCHR2 rna"
  ],
  "MCHR2-AS1": [
    "MCHR2-AS1 methyl"
  ],
  "MCIDAS": [
    "MCIDAS cnv",
    "MCIDAS methyl",
    "MCIDAS rna"
  ],
  "MCL1": [
    "MCL1 cnv",
    "MCL1 methyl",
    "MCL1 proteo",
    "MCL1 rna"
  ],
  "MCM10": [
    "MCM10 cnv",
    "MCM10 methyl",
    "MCM10 rna"
  ],
  "MCM2": [
    "MCM2 137_139_1_1_S139 phospho",
    "MCM2 25_27_1_1_S27 phospho",
    "MCM2 35_41_1_1_S41 phospho",
    "MCM2 90_108_1_1_S108 phospho",
    "MCM2 cnv",
    "MCM2 methyl",
    "MCM2 proteo",
    "MCM2 rna"
  ],
  "MCM3": [
    "MCM3 713_719_1_1_S717 phospho",
    "MCM3 713_719_2_2_S713S717 phospho",
    "MCM3 713_719_2_2_S717T719 phospho",
    "MCM3 713_719_3_3_S713S717T719 phospho",
    "MCM3 713_726_1_1_S717 phospho",
    "MCM3 713_726_2_2_S717T719 phospho",
    "MCM3 749_767_1_1_S756 phospho",
    "MCM3 749_767_1_1_T767 phospho",
    "MCM3 749_767_2_1_T767 phospho",
    "MCM3 749_767_2_2_S756T767 phospho",
    "MCM3 cnv",
    "MCM3 methyl",
    "MCM3 proteo",
    "MCM3 rna"
  ],
  "MCM3AP": [
    "MCM3AP cnv",
    "MCM3AP methyl",
    "MCM3AP proteo",
    "MCM3AP rna"
  ],
  "MCM3AP-AS1": [
    "MCM3AP-AS1 methyl"
  ],
  "MCM4": [
    "MCM4 cnv",
    "MCM4 methyl",
    "MCM4 proteo",
    "MCM4 rna"
  ],
  "MCM5": [
    "MCM5 cnv",
    "MCM5 methyl",
    "MCM5 proteo",
    "MCM5 rna"
  ],
  "MCM6": [
    "MCM6 cnv",
    "MCM6 methyl",
    "MCM6 proteo",
    "MCM6 rna"
  ],
  "MCM7": [
    "MCM7 cnv",
    "MCM7 methyl",
    "MCM7 proteo",
    "MCM7 rna"
  ],
  "MCM8": [
    "MCM8 cnv",
    "MCM8 methyl",
    "MCM8 rna"
  ],
  "MCM9": [
    "MCM9 cnv",
    "MCM9 methyl",
    "MCM9 rna"
  ],
  "MCMBP": [
    "MCMBP 298_302_1_1_S298 phospho",
    "MCMBP cnv",
    "MCMBP methyl",
    "MCMBP proteo",
    "MCMBP rna"
  ],
  "MCMDC2": [
    "MCMDC2 cnv",
    "MCMDC2 rna"
  ],
  "MCOLN1": [
    "MCOLN1 17_34_1_1_T34 phospho",
    "MCOLN1 LVNVTIHFR-N2H9F0S0G0 glyco",
    "MCOLN1 cnv",
    "MCOLN1 methyl",
    "MCOLN1 proteo",
    "MCOLN1 rna"
  ],
  "MCOLN2": [
    "MCOLN2 cnv",
    "MCOLN2 methyl",
    "MCOLN2 rna"
  ],
  "MCOLN3": [
    "MCOLN3 cnv",
    "MCOLN3 methyl",
    "MCOLN3 rna"
  ],
  "MCPH1": [
    "MCPH1 330_339_1_1_S333 phospho",
    "MCPH1 cnv",
    "MCPH1 methyl",
    "MCPH1 rna"
  ],
  "MCPH1-DT": [
    "MCPH1-DT methyl"
  ],
  "MCRIP1": [
    "MCRIP1 16_30_1_1_S21 phospho",
    "MCRIP1 21_30_1_1_S21 phospho",
    "MCRIP1 cnv",
    "MCRIP1 methyl",
    "MCRIP1 proteo",
    "MCRIP1 rna"
  ],
  "MCRIP2": [
    "MCRIP2 cnv",
    "MCRIP2 methyl",
    "MCRIP2 rna"
  ],
  "MCRS1": [
    "MCRS1 282_291_1_1_S282 phospho",
    "MCRS1 cnv",
    "MCRS1 methyl",
    "MCRS1 rna"
  ],
  "MCTP1": [
    "MCTP1 cnv",
    "MCTP1 methyl",
    "MCTP1 proteo",
    "MCTP1 rna"
  ],
  "MCTP2": [
    "MCTP2 cnv",
    "MCTP2 methyl",
    "MCTP2 rna"
  ],
  "MCTS1": [
    "MCTS1 proteo",
    "MCTS1 rna"
  ],
  "MCTS2": [
    "MCTS2 cnv",
    "MCTS2 rna"
  ],
  "MCU": [
    "MCU cnv",
    "MCU methyl",
    "MCU proteo",
    "MCU rna"
  ],
  "MCUB": [
    "MCUB cnv",
    "MCUB methyl",
    "MCUB proteo",
    "MCUB rna"
  ],
  "MCUR1": [
    "MCUR1 cnv",
    "MCUR1 methyl",
    "MCUR1 proteo",
    "MCUR1 rna"
  ],
  "MDC1": [
    "MDC1 108_112_1_1_S108 phospho",
    "MDC1 1153_1187_1_1_T1157 phospho",
    "MDC1 1235_1269_1_1_T1239 phospho",
    "MDC1 1481_1512_1_1_T1485 phospho",
    "MDC1 168_176_1_1_S168 phospho",
    "MDC1 1814_1820_1_1_S1814 phospho",
    "MDC1 292_307_2_2_S299T301 phospho",
    "MDC1 372_378_1_1_S376 phospho",
    "MDC1 445_455_1_1_S453 phospho",
    "MDC1 495_498_2_2_S495S498 phospho",
    "MDC1 544_551_1_1_S544 phospho",
    "MDC1 760_780_1_1_S780 phospho",
    "MDC1 793_797_1_1_S793 phospho",
    "MDC1 cnv",
    "MDC1 methyl",
    "MDC1 proteo",
    "MDC1 rna"
  ],
  "MDFI": [
    "MDFI cnv",
    "MDFI methyl",
    "MDFI rna"
  ],
  "MDFIC": [
    "MDFIC 124_128_1_1_S124 phospho",
    "MDFIC cnv",
    "MDFIC methyl",
    "MDFIC rna"
  ],
  "MDFIC2": [
    "MDFIC2 cnv"
  ],
  "MDGA1": [
    "MDGA1 cnv",
    "MDGA1 methyl",
    "MDGA1 proteo",
    "MDGA1 rna"
  ],
  "MDGA2": [
    "MDGA2 cnv",
    "MDGA2 methyl",
    "MDGA2 proteo",
    "MDGA2 rna"
  ],
  "MDH1": [
    "MDH1 206_210_1_0 phospho",
    "MDH1 206_210_1_1_S207 phospho",
    "MDH1 259_263_1_1_S259 phospho",
    "MDH1 344_351_1_1_S351 phospho",
    "MDH1 cnv",
    "MDH1 methyl",
    "MDH1 proteo",
    "MDH1 rna"
  ],
  "MDH1B": [
    "MDH1B cnv",
    "MDH1B methyl",
    "MDH1B rna"
  ],
  "MDH2": [
    "MDH2 cnv",
    "MDH2 methyl",
    "MDH2 proteo",
    "MDH2 rna"
  ],
  "MDK": [
    "MDK cnv",
    "MDK methyl",
    "MDK proteo",
    "MDK rna"
  ],
  "MDM1": [
    "MDM1 492_510_1_1_S508 phospho",
    "MDM1 cnv",
    "MDM1 methyl",
    "MDM1 proteo",
    "MDM1 rna"
  ],
  "MDM2": [
    "MDM2 cnv",
    "MDM2 methyl",
    "MDM2 rna"
  ],
  "MDM4": [
    "MDM4 cnv",
    "MDM4 methyl",
    "MDM4 rna"
  ],
  "MDN1": [
    "MDN1 4534_4543_1_1_S4538 phospho",
    "MDN1 cnv",
    "MDN1 methyl",
    "MDN1 proteo",
    "MDN1 rna"
  ],
  "MDP1": [
    "MDP1 cnv",
    "MDP1 rna"
  ],
  "ME1": [
    "ME1 cnv",
    "ME1 methyl",
    "ME1 proteo",
    "ME1 rna"
  ],
  "ME2": [
    "ME2 cnv",
    "ME2 methyl",
    "ME2 proteo",
    "ME2 rna"
  ],
  "ME3": [
    "ME3 cnv",
    "ME3 methyl",
    "ME3 proteo",
    "ME3 rna"
  ],
  "MEA1": [
    "MEA1 101_117_1_1_S101 phospho",
    "MEA1 cnv",
    "MEA1 methyl",
    "MEA1 proteo",
    "MEA1 rna"
  ],
  "MEAF6": [
    "MEAF6 118_146_1_0 phospho",
    "MEAF6 cnv",
    "MEAF6 methyl",
    "MEAF6 proteo",
    "MEAF6 rna"
  ],
  "MEAK7": [
    "MEAK7 446_446_1_1_S446 phospho",
    "MEAK7 cnv",
    "MEAK7 methyl",
    "MEAK7 proteo",
    "MEAK7 rna"
  ],
  "MECOM": [
    "MECOM 919_925_1_1_S925 phospho",
    "MECOM cnv",
    "MECOM methyl",
    "MECOM rna"
  ],
  "MECP2": [
    "MECP2 76_92_1_1_S92 phospho",
    "MECP2 methyl",
    "MECP2 proteo",
    "MECP2 rna"
  ],
  "MECR": [
    "MECR cnv",
    "MECR methyl",
    "MECR proteo",
    "MECR rna"
  ],
  "MED1": [
    "MED1 1049_1057_1_1_T1051 phospho",
    "MED1 1207_1219_1_1_T1215 phospho",
    "MED1 1401_1403_1_1_S1401 phospho",
    "MED1 1431_1440_1_1_S1433 phospho",
    "MED1 1475_1494_2_1_S1479 phospho",
    "MED1 cnv",
    "MED1 methyl",
    "MED1 proteo",
    "MED1 rna"
  ],
  "MED10": [
    "MED10 cnv",
    "MED10 methyl",
    "MED10 proteo",
    "MED10 rna"
  ],
  "MED11": [
    "MED11 cnv",
    "MED11 methyl",
    "MED11 proteo",
    "MED11 rna"
  ],
  "MED12": [
    "MED12 635_635_1_1_S635 phospho",
    "MED12 methyl",
    "MED12 proteo",
    "MED12 rna"
  ],
  "MED12L": [
    "MED12L cnv",
    "MED12L methyl",
    "MED12L rna"
  ],
  "MED13": [
    "MED13 474_474_1_1_T474 phospho",
    "MED13 890_894_1_1_S890 phospho",
    "MED13 cnv",
    "MED13 methyl",
    "MED13 rna"
  ],
  "MED13L": [
    "MED13L 923_923_1_1_S923 phospho",
    "MED13L cnv",
    "MED13L methyl",
    "MED13L rna"
  ],
  "MED14": [
    "MED14 methyl",
    "MED14 proteo",
    "MED14 rna"
  ],
  "MED14OS": [
    "MED14OS rna"
  ],
  "MED15": [
    "MED15 497_532_1_0 phospho",
    "MED15 603_612_1_1_T603 phospho",
    "MED15 cnv",
    "MED15 methyl",
    "MED15 proteo",
    "MED15 rna"
  ],
  "MED16": [
    "MED16 cnv",
    "MED16 methyl",
    "MED16 proteo",
    "MED16 rna"
  ],
  "MED17": [
    "MED17 cnv",
    "MED17 methyl",
    "MED17 proteo",
    "MED17 rna"
  ],
  "MED18": [
    "MED18 cnv",
    "MED18 methyl",
    "MED18 proteo",
    "MED18 rna"
  ],
  "MED19": [
    "MED19 243_259_1_1_S243 phospho",
    "MED19 cnv",
    "MED19 methyl",
    "MED19 proteo",
    "MED19 rna"
  ],
  "MED20": [
    "MED20 cnv",
    "MED20 methyl",
    "MED20 proteo",
    "MED20 rna"
  ],
  "MED21": [
    "MED21 cnv",
    "MED21 methyl",
    "MED21 proteo",
    "MED21 rna"
  ],
  "MED22": [
    "MED22 cnv",
    "MED22 methyl",
    "MED22 proteo",
    "MED22 rna"
  ],
  "MED23": [
    "MED23 cnv",
    "MED23 methyl",
    "MED23 proteo",
    "MED23 rna"
  ],
  "MED24": [
    "MED24 cnv",
    "MED24 methyl",
    "MED24 proteo",
    "MED24 rna"
  ],
  "MED25": [
    "MED25 cnv",
    "MED25 methyl",
    "MED25 proteo",
    "MED25 rna"
  ],
  "MED26": [
    "MED26 cnv",
    "MED26 methyl",
    "MED26 proteo",
    "MED26 rna"
  ],
  "MED27": [
    "MED27 cnv",
    "MED27 methyl",
    "MED27 proteo",
    "MED27 rna"
  ],
  "MED28": [
    "MED28 cnv",
    "MED28 methyl",
    "MED28 proteo",
    "MED28 rna"
  ],
  "MED29": [
    "MED29 cnv",
    "MED29 methyl",
    "MED29 proteo",
    "MED29 rna"
  ],
  "MED30": [
    "MED30 cnv",
    "MED30 methyl",
    "MED30 proteo",
    "MED30 rna"
  ],
  "MED31": [
    "MED31 cnv",
    "MED31 methyl",
    "MED31 rna"
  ],
  "MED4": [
    "MED4 cnv",
    "MED4 methyl",
    "MED4 proteo",
    "MED4 rna"
  ],
  "MED6": [
    "MED6 cnv",
    "MED6 methyl",
    "MED6 proteo",
    "MED6 rna"
  ],
  "MED7": [
    "MED7 186_198_1_1_S194 phospho",
    "MED7 cnv",
    "MED7 methyl",
    "MED7 proteo",
    "MED7 rna"
  ],
  "MED8": [
    "MED8 cnv",
    "MED8 methyl",
    "MED8 proteo",
    "MED8 rna"
  ],
  "MED9": [
    "MED9 19_53_1_0 phospho",
    "MED9 19_53_1_1_S53 phospho",
    "MED9 19_53_2_2_S46S53 phospho",
    "MED9 cnv",
    "MED9 methyl",
    "MED9 proteo",
    "MED9 rna"
  ],
  "MEDAG": [
    "MEDAG cnv",
    "MEDAG methyl",
    "MEDAG rna"
  ],
  "MEF2A": [
    "MEF2A 253_268_1_1_S255 phospho",
    "MEF2A 471_488_1_1_S486 phospho",
    "MEF2A cnv",
    "MEF2A methyl",
    "MEF2A proteo",
    "MEF2A rna"
  ],
  "MEF2B": [
    "MEF2B cnv",
    "MEF2B methyl",
    "MEF2B rna"
  ],
  "MEF2C": [
    "MEF2C 222_228_1_1_S222 phospho",
    "MEF2C 222_228_2_2_S222S228 phospho",
    "MEF2C 240_240_1_1_S240 phospho",
    "MEF2C 419_434_1_1_S419 phospho",
    "MEF2C 98_113_2_2_S98S110 phospho",
    "MEF2C cnv",
    "MEF2C methyl",
    "MEF2C proteo",
    "MEF2C rna"
  ],
  "MEF2C-AS2": [
    "MEF2C-AS2 methyl"
  ],
  "MEF2D": [
    "MEF2D 231_242_1_1_S231 phospho",
    "MEF2D 251_265_1_1_S251 phospho",
    "MEF2D cnv",
    "MEF2D methyl",
    "MEF2D proteo",
    "MEF2D rna"
  ],
  "MEFV": [
    "MEFV cnv",
    "MEFV rna"
  ],
  "MEG3": [
    "MEG3 methyl"
  ],
  "MEGF10": [
    "MEGF10 977_979_1_1_T979 phospho",
    "MEGF10 cnv",
    "MEGF10 methyl",
    "MEGF10 proteo",
    "MEGF10 rna"
  ],
  "MEGF11": [
    "MEGF11 cnv",
    "MEGF11 proteo",
    "MEGF11 rna"
  ],
  "MEGF6": [
    "MEGF6 cnv",
    "MEGF6 methyl",
    "MEGF6 rna"
  ],
  "MEGF8": [
    "MEGF8 ALLTNVSSVALGSR-N2H8F0S0G0 glyco",
    "MEGF8 VNSTELFHVDR-N2H9F0S0G0 glyco",
    "MEGF8 cnv",
    "MEGF8 methyl",
    "MEGF8 proteo",
    "MEGF8 rna"
  ],
  "MEGF9": [
    "MEGF9 cnv",
    "MEGF9 methyl",
    "MEGF9 proteo",
    "MEGF9 rna"
  ],
  "MEI1": [
    "MEI1 cnv",
    "MEI1 methyl",
    "MEI1 rna"
  ],
  "MEI4": [
    "MEI4 cnv",
    "MEI4 methyl",
    "MEI4 rna"
  ],
  "MEIG1": [
    "MEIG1 cnv",
    "MEIG1 methyl",
    "MEIG1 rna"
  ],
  "MEIKIN": [
    "MEIKIN cnv",
    "MEIKIN methyl",
    "MEIKIN rna"
  ],
  "MEIOB": [
    "MEIOB cnv",
    "MEIOB methyl",
    "MEIOB rna"
  ],
  "MEIOC": [
    "MEIOC cnv",
    "MEIOC methyl",
    "MEIOC rna"
  ],
  "MEIOSIN": [
    "MEIOSIN cnv",
    "MEIOSIN methyl",
    "MEIOSIN rna"
  ],
  "MEIS1": [
    "MEIS1 196_202_1_1_S196 phospho",
    "MEIS1 cnv",
    "MEIS1 methyl",
    "MEIS1 proteo",
    "MEIS1 rna"
  ],
  "MEIS2": [
    "MEIS2 cnv",
    "MEIS2 methyl",
    "MEIS2 rna"
  ],
  "MEIS3": [
    "MEIS3 cnv",
    "MEIS3 methyl",
    "MEIS3 rna"
  ],
  "MELK": [
    "MELK cnv",
    "MELK kinase",
    "MELK rna"
  ],
  "MELTF": [
    "MELTF SCHTGINR-N2H6F0S0G0 glyco",
    "MELTF cnv",
    "MELTF methyl",
    "MELTF proteo",
    "MELTF rna"
  ],
  "MELTF-AS1": [
    "MELTF-AS1 methyl"
  ],
  "MEMO1": [
    "MEMO1 cnv",
    "MEMO1 methyl",
    "MEMO1 proteo",
    "MEMO1 rna"
  ],
  "MEN1": [
    "MEN1 492_492_1_1_S492 phospho",
    "MEN1 538_560_1_1_S548 phospho",
    "MEN1 cnv",
    "MEN1 methyl",
    "MEN1 proteo",
    "MEN1 rna"
  ],
  "MEOX1": [
    "MEOX1 cnv",
    "MEOX1 rna"
  ],
  "MEOX2": [
    "MEOX2 155_155_1_1_S155 phospho",
    "MEOX2 cnv",
    "MEOX2 rna"
  ],
  "MEP1A": [
    "MEP1A cnv",
    "MEP1A rna"
  ],
  "MEP1B": [
    "MEP1B cnv",
    "MEP1B rna"
  ],
  "MEPCE": [
    "MEPCE 152_152_1_1_S152 phospho",
    "MEPCE 236_254_1_1_S254 phospho",
    "MEPCE 279_300_1_1_T291 phospho",
    "MEPCE 390_390_1_1_S390 phospho",
    "MEPCE 57_60_1_1_S60 phospho",
    "MEPCE 57_78_1_1_S69 phospho",
    "MEPCE 57_78_2_2_S60S69 phospho",
    "MEPCE 69_78_1_1_S69 phospho",
    "MEPCE cnv",
    "MEPCE methyl",
    "MEPCE proteo",
    "MEPCE rna"
  ],
  "MEPE": [
    "MEPE cnv",
    "MEPE rna"
  ],
  "MERTK": [
    "MERTK NCSIQVK-N2H5F0S0G0 glyco",
    "MERTK SDNGSYICK-N2H5F0S0G0 glyco",
    "MERTK SDNGSYICK-N2H6F0S0G0 glyco",
    "MERTK SDNGSYICK-N4H5F0S1G0 glyco",
    "MERTK cnv",
    "MERTK kinase",
    "MERTK methyl",
    "MERTK proteo",
    "MERTK rna"
  ],
  "MESD": [
    "MESD cnv",
    "MESD methyl",
    "MESD proteo",
    "MESD rna"
  ],
  "MESP1": [
    "MESP1 cnv",
    "MESP1 methyl",
    "MESP1 rna"
  ],
  "MESP2": [
    "MESP2 cnv",
    "MESP2 methyl",
    "MESP2 rna"
  ],
  "MEST": [
    "MEST cnv",
    "MEST methyl",
    "MEST proteo",
    "MEST rna"
  ],
  "MESTIT1": [
    "MESTIT1 methyl"
  ],
  "MET": [
    "MET 977_977_1_1_T977 phospho",
    "MET cnv",
    "MET kinase",
    "MET methyl",
    "MET proteo",
    "MET rna"
  ],
  "METAP1": [
    "METAP1 cnv",
    "METAP1 methyl",
    "METAP1 proteo",
    "METAP1 rna"
  ],
  "METAP1D": [
    "METAP1D cnv",
    "METAP1D methyl",
    "METAP1D proteo",
    "METAP1D rna"
  ],
  "METAP2": [
    "METAP2 cnv",
    "METAP2 methyl",
    "METAP2 proteo",
    "METAP2 rna"
  ],
  "METRN": [
    "METRN cnv",
    "METRN methyl",
    "METRN rna"
  ],
  "METRNL": [
    "METRNL cnv",
    "METRNL methyl",
    "METRNL proteo",
    "METRNL rna"
  ],
  "METTL1": [
    "METTL1 cnv",
    "METTL1 methyl",
    "METTL1 proteo",
    "METTL1 rna"
  ],
  "METTL13": [
    "METTL13 cnv",
    "METTL13 methyl",
    "METTL13 proteo",
    "METTL13 rna"
  ],
  "METTL14": [
    "METTL14 cnv",
    "METTL14 methyl",
    "METTL14 proteo",
    "METTL14 rna"
  ],
  "METTL14-DT": [
    "METTL14-DT methyl"
  ],
  "METTL15": [
    "METTL15 cnv",
    "METTL15 methyl",
    "METTL15 proteo",
    "METTL15 rna"
  ],
  "METTL16": [
    "METTL16 cnv",
    "METTL16 methyl",
    "METTL16 proteo",
    "METTL16 rna"
  ],
  "METTL17": [
    "METTL17 cnv",
    "METTL17 methyl",
    "METTL17 rna"
  ],
  "METTL18": [
    "METTL18 cnv",
    "METTL18 methyl",
    "METTL18 rna"
  ],
  "METTL21A": [
    "METTL21A cnv",
    "METTL21A methyl",
    "METTL21A rna"
  ],
  "METTL21C": [
    "METTL21C cnv",
    "METTL21C rna"
  ],
  "METTL22": [
    "METTL22 cnv",
    "METTL22 methyl",
    "METTL22 rna"
  ],
  "METTL23": [
    "METTL23 cnv",
    "METTL23 methyl",
    "METTL23 rna"
  ],
  "METTL24": [
    "METTL24 cnv",
    "METTL24 methyl",
    "METTL24 rna"
  ],
  "METTL25": [
    "METTL25 cnv",
    "METTL25 methyl",
    "METTL25 rna"
  ],
  "METTL25B": [
    "METTL25B cnv",
    "METTL25B methyl",
    "METTL25B rna"
  ],
  "METTL26": [
    "METTL26 cnv",
    "METTL26 methyl",
    "METTL26 proteo",
    "METTL26 rna"
  ],
  "METTL27": [
    "METTL27 cnv",
    "METTL27 methyl",
    "METTL27 rna"
  ],
  "METTL2A": [
    "METTL2A cnv",
    "METTL2A methyl",
    "METTL2A proteo",
    "METTL2A rna"
  ],
  "METTL2B": [
    "METTL2B 152_162_1_1_T154 phospho",
    "METTL2B cnv",
    "METTL2B methyl",
    "METTL2B proteo",
    "METTL2B rna"
  ],
  "METTL3": [
    "METTL3 48_58_1_1_S50 phospho",
    "METTL3 48_74_1_1_S50 phospho",
    "METTL3 cnv",
    "METTL3 methyl",
    "METTL3 proteo",
    "METTL3 rna"
  ],
  "METTL4": [
    "METTL4 cnv",
    "METTL4 methyl",
    "METTL4 rna"
  ],
  "METTL5": [
    "METTL5 cnv",
    "METTL5 proteo",
    "METTL5 rna"
  ],
  "METTL6": [
    "METTL6 cnv",
    "METTL6 methyl",
    "METTL6 rna"
  ],
  "METTL7A": [
    "METTL7A cnv",
    "METTL7A proteo",
    "METTL7A rna"
  ],
  "METTL7B": [
    "METTL7B cnv",
    "METTL7B proteo",
    "METTL7B rna"
  ],
  "METTL8": [
    "METTL8 cnv",
    "METTL8 methyl",
    "METTL8 rna"
  ],
  "METTL9": [
    "METTL9 cnv",
    "METTL9 methyl",
    "METTL9 proteo",
    "METTL9 rna"
  ],
  "MEX3A": [
    "MEX3A 338_349_1_1_S338 phospho",
    "MEX3A 462_462_1_1_S462 phospho",
    "MEX3A cnv",
    "MEX3A methyl",
    "MEX3A proteo",
    "MEX3A rna"
  ],
  "MEX3B": [
    "MEX3B cnv",
    "MEX3B methyl",
    "MEX3B rna"
  ],
  "MEX3C": [
    "MEX3C 229_241_1_1_S229 phospho",
    "MEX3C 537_541_1_1_S537 phospho",
    "MEX3C 537_551_2_0 phospho",
    "MEX3C cnv",
    "MEX3C methyl",
    "MEX3C proteo",
    "MEX3C rna"
  ],
  "MEX3D": [
    "MEX3D 514_516_1_1_S514 phospho",
    "MEX3D cnv",
    "MEX3D methyl",
    "MEX3D proteo",
    "MEX3D rna"
  ],
  "MFAP1": [
    "MFAP1 258_276_1_1_T267 phospho",
    "MFAP1 47_53_2_2_S52S53 phospho",
    "MFAP1 cnv",
    "MFAP1 methyl",
    "MFAP1 proteo",
    "MFAP1 rna"
  ],
  "MFAP2": [
    "MFAP2 cnv",
    "MFAP2 methyl",
    "MFAP2 proteo",
    "MFAP2 rna"
  ],
  "MFAP3": [
    "MFAP3 cnv",
    "MFAP3 methyl",
    "MFAP3 rna"
  ],
  "MFAP3L": [
    "MFAP3L 193_204_1_1_S204 phospho",
    "MFAP3L cnv",
    "MFAP3L methyl",
    "MFAP3L rna"
  ],
  "MFAP4": [
    "MFAP4 VDLEDFENNTAYAK-N4H3F1S0G0 glyco",
    "MFAP4 VDLEDFENNTAYAK-N4H5F1S1G0 glyco",
    "MFAP4 VDLEDFENNTAYAK-N5H4F1S0G0 glyco",
    "MFAP4 cnv",
    "MFAP4 proteo",
    "MFAP4 rna"
  ],
  "MFAP5": [
    "MFAP5 cnv",
    "MFAP5 rna"
  ],
  "MFF": [
    "MFF 129_131_2_2_S129S131 phospho",
    "MFF 146_151_1_1_S146 phospho",
    "MFF 193_202_1_1_S202 phospho",
    "MFF 207_212_1_1_S207 phospho",
    "MFF cnv",
    "MFF methyl",
    "MFF proteo",
    "MFF rna"
  ],
  "MFGE8": [
    "MFGE8 42_42_1_1_S42 phospho",
    "MFGE8 NNSIPDK-N2H5F0S0G0 glyco",
    "MFGE8 NNSIPDK-N2H6F0S0G0 glyco",
    "MFGE8 NNSIPDK-N2H7F0S0G0 glyco",
    "MFGE8 cnv",
    "MFGE8 methyl",
    "MFGE8 proteo",
    "MFGE8 rna"
  ],
  "MFHAS1": [
    "MFHAS1 cnv",
    "MFHAS1 methyl",
    "MFHAS1 proteo",
    "MFHAS1 rna"
  ],
  "MFN1": [
    "MFN1 cnv",
    "MFN1 methyl",
    "MFN1 proteo",
    "MFN1 rna"
  ],
  "MFN2": [
    "MFN2 cnv",
    "MFN2 methyl",
    "MFN2 proteo",
    "MFN2 rna"
  ],
  "MFNG": [
    "MFNG cnv",
    "MFNG rna"
  ],
  "MFRP": [
    "MFRP cnv",
    "MFRP rna"
  ],
  "MFSD1": [
    "MFSD1 cnv",
    "MFSD1 methyl",
    "MFSD1 proteo",
    "MFSD1 rna"
  ],
  "MFSD10": [
    "MFSD10 cnv",
    "MFSD10 methyl",
    "MFSD10 proteo",
    "MFSD10 rna"
  ],
  "MFSD11": [
    "MFSD11 cnv",
    "MFSD11 methyl",
    "MFSD11 rna"
  ],
  "MFSD12": [
    "MFSD12 cnv",
    "MFSD12 methyl",
    "MFSD12 rna"
  ],
  "MFSD13A": [
    "MFSD13A cnv",
    "MFSD13A methyl",
    "MFSD13A rna"
  ],
  "MFSD14A": [
    "MFSD14A cnv",
    "MFSD14A methyl",
    "MFSD14A rna"
  ],
  "MFSD14B": [
    "MFSD14B cnv",
    "MFSD14B methyl",
    "MFSD14B rna"
  ],
  "MFSD14CP": [
    "MFSD14CP methyl"
  ],
  "MFSD2A": [
    "MFSD2A cnv",
    "MFSD2A methyl",
    "MFSD2A rna"
  ],
  "MFSD2B": [
    "MFSD2B cnv",
    "MFSD2B methyl",
    "MFSD2B rna"
  ],
  "MFSD3": [
    "MFSD3 cnv",
    "MFSD3 methyl",
    "MFSD3 rna"
  ],
  "MFSD4A": [
    "MFSD4A cnv",
    "MFSD4A methyl",
    "MFSD4A rna"
  ],
  "MFSD4B": [
    "MFSD4B cnv",
    "MFSD4B methyl",
    "MFSD4B proteo",
    "MFSD4B rna"
  ],
  "MFSD5": [
    "MFSD5 cnv",
    "MFSD5 methyl",
    "MFSD5 rna"
  ],
  "MFSD6": [
    "MFSD6 10_10_1_1_T10 phospho",
    "MFSD6 718_733_1_1_S733 phospho",
    "MFSD6 cnv",
    "MFSD6 methyl",
    "MFSD6 proteo",
    "MFSD6 rna"
  ],
  "MFSD6L": [
    "MFSD6L cnv",
    "MFSD6L methyl",
    "MFSD6L rna"
  ],
  "MFSD8": [
    "MFSD8 cnv",
    "MFSD8 methyl",
    "MFSD8 rna"
  ],
  "MFSD9": [
    "MFSD9 cnv",
    "MFSD9 rna"
  ],
  "MGA": [
    "MGA 448_451_1_1_S449 phospho",
    "MGA cnv",
    "MGA methyl",
    "MGA proteo",
    "MGA rna"
  ],
  "MGAM": [
    "MGAM cnv",
    "MGAM rna"
  ],
  "MGAM2": [
    "MGAM2 cnv",
    "MGAM2 rna"
  ],
  "MGARP": [
    "MGARP cnv",
    "MGARP methyl",
    "MGARP proteo",
    "MGARP rna"
  ],
  "MGAT1": [
    "MGAT1 cnv",
    "MGAT1 methyl",
    "MGAT1 proteo",
    "MGAT1 rna"
  ],
  "MGAT2": [
    "MGAT2 cnv",
    "MGAT2 methyl",
    "MGAT2 proteo",
    "MGAT2 rna"
  ],
  "MGAT3": [
    "MGAT3 cnv",
    "MGAT3 methyl",
    "MGAT3 rna"
  ],
  "MGAT4A": [
    "MGAT4A cnv",
    "MGAT4A methyl",
    "MGAT4A rna"
  ],
  "MGAT4B": [
    "MGAT4B cnv",
    "MGAT4B methyl",
    "MGAT4B rna"
  ],
  "MGAT4C": [
    "MGAT4C cnv",
    "MGAT4C rna"
  ],
  "MGAT4D": [
    "MGAT4D cnv",
    "MGAT4D methyl",
    "MGAT4D rna"
  ],
  "MGAT5": [
    "MGAT5 cnv",
    "MGAT5 methyl",
    "MGAT5 proteo",
    "MGAT5 rna"
  ],
  "MGAT5B": [
    "MGAT5B cnv",
    "MGAT5B methyl",
    "MGAT5B rna"
  ],
  "MGC16275": [
    "MGC16275 methyl"
  ],
  "MGC4859": [
    "MGC4859 methyl"
  ],
  "MGLL": [
    "MGLL 274_281_1_1_S281 phospho",
    "MGLL cnv",
    "MGLL methyl",
    "MGLL proteo",
    "MGLL rna"
  ],
  "MGME1": [
    "MGME1 cnv",
    "MGME1 methyl",
    "MGME1 proteo",
    "MGME1 rna"
  ],
  "MGMT": [
    "MGMT 229_232_1_1_S232 phospho",
    "MGMT cnv",
    "MGMT methyl",
    "MGMT proteo",
    "MGMT rna"
  ],
  "MGP": [
    "MGP cnv",
    "MGP proteo",
    "MGP rna"
  ],
  "MGRN1": [
    "MGRN1 100_108_1_1_S106 phospho",
    "MGRN1 490_511_1_1_S506 phospho",
    "MGRN1 515_524_1_1_S515 phospho",
    "MGRN1 cnv",
    "MGRN1 methyl",
    "MGRN1 proteo",
    "MGRN1 rna"
  ],
  "MGST1": [
    "MGST1 cnv",
    "MGST1 proteo",
    "MGST1 rna"
  ],
  "MGST2": [
    "MGST2 cnv",
    "MGST2 proteo",
    "MGST2 rna"
  ],
  "MGST3": [
    "MGST3 cnv",
    "MGST3 methyl",
    "MGST3 proteo",
    "MGST3 rna"
  ],
  "MHENCR": [
    "MHENCR methyl"
  ],
  "MIA": [
    "MIA cnv",
    "MIA rna"
  ],
  "MIA-RAB4B": [
    "MIA-RAB4B cnv",
    "MIA-RAB4B rna"
  ],
  "MIA2": [
    "MIA2 522_536_1_1_S527 phospho",
    "MIA2 588_601_1_1_S601 phospho",
    "MIA2 cnv",
    "MIA2 methyl",
    "MIA2 proteo",
    "MIA2 rna"
  ],
  "MIA2-AS1": [
    "MIA2-AS1 methyl"
  ],
  "MIA3": [
    "MIA3 1603_1634_1_1_S1619 phospho",
    "MIA3 1823_1847_1_1_S1847 phospho",
    "MIA3 725_727_1_1_S727 phospho",
    "MIA3 864_883_1_1_S876 phospho",
    "MIA3 cnv",
    "MIA3 methyl",
    "MIA3 proteo",
    "MIA3 rna"
  ],
  "MIAT": [
    "MIAT methyl"
  ],
  "MIB1": [
    "MIB1 cnv",
    "MIB1 methyl",
    "MIB1 proteo",
    "MIB1 rna"
  ],
  "MIB2": [
    "MIB2 366_369_1_1_S366 phospho",
    "MIB2 cnv",
    "MIB2 methyl",
    "MIB2 proteo",
    "MIB2 rna"
  ],
  "MICA": [
    "MICA cnv",
    "MICA methyl",
    "MICA rna"
  ],
  "MICAL1": [
    "MICAL1 527_550_1_1_S531 phospho",
    "MICAL1 731_736_1_1_S732 phospho",
    "MICAL1 874_876_1_1_S874 phospho",
    "MICAL1 971_977_1_1_S971 phospho",
    "MICAL1 cnv",
    "MICAL1 methyl",
    "MICAL1 proteo",
    "MICAL1 rna"
  ],
  "MICAL2": [
    "MICAL2 cnv",
    "MICAL2 methyl",
    "MICAL2 rna"
  ],
  "MICAL3": [
    "MICAL3 1371_1371_1_1_S1371 phospho",
    "MICAL3 1423_1435_1_1_S1433 phospho",
    "MICAL3 1439_1471_2_1_T1454 phospho",
    "MICAL3 1792_1801_1_0 phospho",
    "MICAL3 684_687_1_1_S685 phospho",
    "MICAL3 684_687_2_2_S685S687 phospho",
    "MICAL3 977_984_1_1_S977 phospho",
    "MICAL3 cnv",
    "MICAL3 methyl",
    "MICAL3 proteo",
    "MICAL3 rna"
  ],
  "MICALL1": [
    "MICALL1 309_318_1_1_S309 phospho",
    "MICALL1 389_399_1_1_S391 phospho",
    "MICALL1 459_471_1_1_S471 phospho",
    "MICALL1 459_471_2_2_T467S471 phospho",
    "MICALL1 484_493_1_1_S486 phospho",
    "MICALL1 578_578_1_1_S578 phospho",
    "MICALL1 588_621_1_1_S612 phospho",
    "MICALL1 612_621_1_1_S621 phospho",
    "MICALL1 640_647_1_1_S640 phospho",
    "MICALL1 640_647_1_1_S644 phospho",
    "MICALL1 640_647_2_2_S640S644 phospho",
    "MICALL1 740_744_1_1_S740 phospho",
    "MICALL1 cnv",
    "MICALL1 methyl",
    "MICALL1 proteo",
    "MICALL1 rna"
  ],
  "MICALL2": [
    "MICALL2 122_130_1_1_S122 phospho",
    "MICALL2 122_130_1_1_S125 phospho",
    "MICALL2 122_130_2_2_S122S125 phospho",
    "MICALL2 153_157_1_1_S153 phospho",
    "MICALL2 644_653_1_1_S649 phospho",
    "MICALL2 644_660_2_2_S658S660 phospho",
    "MICALL2 712_726_1_1_S712 phospho",
    "MICALL2 cnv",
    "MICALL2 methyl",
    "MICALL2 proteo",
    "MICALL2 rna"
  ],
  "MICB": [
    "MICB cnv",
    "MICB methyl",
    "MICB rna"
  ],
  "MICB-DT": [
    "MICB-DT methyl"
  ],
  "MICOS10": [
    "MICOS10 cnv",
    "MICOS10 methyl",
    "MICOS10 proteo",
    "MICOS10 rna"
  ],
  "MICOS10-DT": [
    "MICOS10-DT methyl"
  ],
  "MICOS10-NBL1": [
    "MICOS10-NBL1 cnv",
    "MICOS10-NBL1 rna"
  ],
  "MICOS13": [
    "MICOS13 cnv",
    "MICOS13 methyl",
    "MICOS13 proteo",
    "MICOS13 rna"
  ],
  "MICU1": [
    "MICU1 cnv",
    "MICU1 methyl",
    "MICU1 proteo",
    "MICU1 rna"
  ],
  "MICU2": [
    "MICU2 cnv",
    "MICU2 methyl",
    "MICU2 proteo",
    "MICU2 rna"
  ],
  "MICU3": [
    "MICU3 cnv",
    "MICU3 methyl",
    "MICU3 proteo",
    "MICU3 rna"
  ],
  "MID1": [
    "MID1 methyl",
    "MID1 proteo",
    "MID1 rna"
  ],
  "MID1IP1": [
    "MID1IP1 methyl",
    "MID1IP1 proteo",
    "MID1IP1 rna"
  ],
  "MID2": [
    "MID2 proteo",
    "MID2 rna"
  ],
  "MIDEAS": [
    "MIDEAS 617_636_1_1_S636 phospho",
    "MIDEAS cnv",
    "MIDEAS methyl",
    "MIDEAS proteo",
    "MIDEAS rna"
  ],
  "MIDN": [
    "MIDN cnv",
    "MIDN methyl",
    "MIDN rna"
  ],
  "MIEF1": [
    "MIEF1 94_109_1_1_S94 phospho",
    "MIEF1 cnv",
    "MIEF1 methyl",
    "MIEF1 proteo",
    "MIEF1 rna"
  ],
  "MIEF2": [
    "MIEF2 cnv",
    "MIEF2 methyl",
    "MIEF2 rna"
  ],
  "MIEN1": [
    "MIEN1 97_101_1_1_S97 phospho",
    "MIEN1 cnv",
    "MIEN1 methyl",
    "MIEN1 proteo",
    "MIEN1 rna"
  ],
  "MIER1": [
    "MIER1 430_443_1_1_S430 phospho",
    "MIER1 cnv",
    "MIER1 methyl",
    "MIER1 proteo",
    "MIER1 rna"
  ],
  "MIER2": [
    "MIER2 cnv",
    "MIER2 methyl",
    "MIER2 rna"
  ],
  "MIER3": [
    "MIER3 cnv",
    "MIER3 methyl",
    "MIER3 proteo",
    "MIER3 rna"
  ],
  "MIF": [
    "MIF cnv",
    "MIF methyl",
    "MIF proteo",
    "MIF rna"
  ],
  "MIF4GD": [
    "MIF4GD cnv",
    "MIF4GD methyl",
    "MIF4GD proteo",
    "MIF4GD rna"
  ],
  "MIF4GD-DT": [
    "MIF4GD-DT methyl"
  ],
  "MIGA1": [
    "MIGA1 147_159_1_1_S147 phospho",
    "MIGA1 cnv",
    "MIGA1 rna"
  ],
  "MIGA2": [
    "MIGA2 cnv",
    "MIGA2 methyl",
    "MIGA2 proteo",
    "MIGA2 rna"
  ],
  "MIIP": [
    "MIIP 303_309_1_1_S303 phospho",
    "MIIP cnv",
    "MIIP methyl",
    "MIIP rna"
  ],
  "MILIP": [
    "MILIP methyl"
  ],
  "MILR1": [
    "MILR1 cnv",
    "MILR1 rna"
  ],
  "MIMT1": [
    "MIMT1 methyl"
  ],
  "MINAR1": [
    "MINAR1 cnv",
    "MINAR1 methyl",
    "MINAR1 rna"
  ],
  "MINAR2": [
    "MINAR2 cnv",
    "MINAR2 rna"
  ],
  "MINDY1": [
    "MINDY1 428_430_1_1_S430 phospho",
    "MINDY1 cnv",
    "MINDY1 methyl",
    "MINDY1 proteo",
    "MINDY1 rna"
  ],
  "MINDY2": [
    "MINDY2 62_82_1_1_S62 phospho",
    "MINDY2 cnv",
    "MINDY2 methyl",
    "MINDY2 proteo",
    "MINDY2 rna"
  ],
  "MINDY2-DT": [
    "MINDY2-DT methyl"
  ],
  "MINDY3": [
    "MINDY3 cnv",
    "MINDY3 methyl",
    "MINDY3 proteo",
    "MINDY3 rna"
  ],
  "MINDY4": [
    "MINDY4 cnv",
    "MINDY4 methyl",
    "MINDY4 proteo",
    "MINDY4 rna"
  ],
  "MINDY4B": [
    "MINDY4B cnv",
    "MINDY4B rna"
  ],
  "MINK1": [
    "MINK1 540_565_1_0 phospho",
    "MINK1 540_565_1_1_S563 phospho",
    "MINK1 672_687_1_1_S674 phospho",
    "MINK1 747_763_1_1_S763 phospho",
    "MINK1 772_782_1_1_S778 phospho",
    "MINK1 772_782_1_1_S782 phospho",
    "MINK1 772_782_2_2_S778S782 phospho",
    "MINK1 903_923_1_1_S918 phospho",
    "MINK1 927_930_1_1_S927 phospho",
    "MINK1 927_939_1_1_S927 phospho",
    "MINK1 cnv",
    "MINK1 kinase",
    "MINK1 methyl",
    "MINK1 proteo",
    "MINK1 rna"
  ],
  "MINPP1": [
    "MINPP1 cnv",
    "MINPP1 methyl",
    "MINPP1 proteo",
    "MINPP1 rna"
  ],
  "MIOS": [
    "MIOS 759_768_1_1_S766 phospho",
    "MIOS cnv",
    "MIOS methyl",
    "MIOS proteo",
    "MIOS rna"
  ],
  "MIOX": [
    "MIOX cnv",
    "MIOX rna"
  ],
  "MIP": [
    "MIP cnv",
    "MIP methyl",
    "MIP rna"
  ],
  "MIPEP": [
    "MIPEP cnv",
    "MIPEP methyl",
    "MIPEP proteo",
    "MIPEP rna"
  ],
  "MIPOL1": [
    "MIPOL1 cnv",
    "MIPOL1 methyl",
    "MIPOL1 rna"
  ],
  "MIR1-1": [
    "MIR1-1 methyl"
  ],
  "MIR1-1HG": [
    "MIR1-1HG methyl"
  ],
  "MIR10A": [
    "MIR10A methyl"
  ],
  "MIR10B": [
    "MIR10B methyl"
  ],
  "MIR1180": [
    "MIR1180 methyl"
  ],
  "MIR1181": [
    "MIR1181 methyl"
  ],
  "MIR1199": [
    "MIR1199 methyl"
  ],
  "MIR1224": [
    "MIR1224 methyl"
  ],
  "MIR1225": [
    "MIR1225 methyl"
  ],
  "MIR1237": [
    "MIR1237 methyl"
  ],
  "MIR124-1": [
    "MIR124-1 methyl"
  ],
  "MIR124-1HG": [
    "MIR124-1HG methyl"
  ],
  "MIR124-2": [
    "MIR124-2 methyl"
  ],
  "MIR124-3": [
    "MIR124-3 methyl"
  ],
  "MIR1244-3": [
    "MIR1244-3 methyl"
  ],
  "MIR1247": [
    "MIR1247 methyl"
  ],
  "MIR1258": [
    "MIR1258 methyl"
  ],
  "MIR126": [
    "MIR126 methyl"
  ],
  "MIR127": [
    "MIR127 methyl"
  ],
  "MIR1281": [
    "MIR1281 methyl"
  ],
  "MIR1289-1": [
    "MIR1289-1 methyl"
  ],
  "MIR129-2": [
    "MIR129-2 methyl"
  ],
  "MIR1292": [
    "MIR1292 methyl"
  ],
  "MIR1302-10": [
    "MIR1302-10 methyl"
  ],
  "MIR1302-2": [
    "MIR1302-2 methyl"
  ],
  "MIR1302-3": [
    "MIR1302-3 methyl"
  ],
  "MIR1306": [
    "MIR1306 methyl"
  ],
  "MIR130B": [
    "MIR130B methyl"
  ],
  "MIR132": [
    "MIR132 methyl"
  ],
  "MIR137HG": [
    "MIR137HG methyl"
  ],
  "MIR1469": [
    "MIR1469 methyl"
  ],
  "MIR148A": [
    "MIR148A methyl"
  ],
  "MIR149": [
    "MIR149 methyl"
  ],
  "MIR152": [
    "MIR152 methyl"
  ],
  "MIR153-1": [
    "MIR153-1 methyl"
  ],
  "MIR1538": [
    "MIR1538 methyl"
  ],
  "MIR1539": [
    "MIR1539 methyl"
  ],
  "MIR17HG": [
    "MIR17HG methyl"
  ],
  "MIR181C": [
    "MIR181C methyl"
  ],
  "MIR181D": [
    "MIR181D methyl"
  ],
  "MIR1908": [
    "MIR1908 methyl"
  ],
  "MIR1909": [
    "MIR1909 methyl"
  ],
  "MIR191": [
    "MIR191 methyl"
  ],
  "MIR1915": [
    "MIR1915 methyl"
  ],
  "MIR1915HG": [
    "MIR1915HG methyl"
  ],
  "MIR193A": [
    "MIR193A methyl"
  ],
  "MIR193B": [
    "MIR193B methyl"
  ],
  "MIR193BHG": [
    "MIR193BHG methyl"
  ],
  "MIR196B": [
    "MIR196B methyl"
  ],
  "MIR203A": [
    "MIR203A methyl"
  ],
  "MIR203B": [
    "MIR203B methyl"
  ],
  "MIR210": [
    "MIR210 methyl"
  ],
  "MIR210HG": [
    "MIR210HG methyl"
  ],
  "MIR2110": [
    "MIR2110 methyl"
  ],
  "MIR212": [
    "MIR212 methyl"
  ],
  "MIR219A2": [
    "MIR219A2 methyl"
  ],
  "MIR219B": [
    "MIR219B methyl"
  ],
  "MIR2277": [
    "MIR2277 methyl"
  ],
  "MIR22HG": [
    "MIR22HG methyl"
  ],
  "MIR24-1": [
    "MIR24-1 methyl"
  ],
  "MIR2682": [
    "MIR2682 methyl"
  ],
  "MIR2861": [
    "MIR2861 methyl"
  ],
  "MIR301B": [
    "MIR301B methyl"
  ],
  "MIR3074": [
    "MIR3074 methyl"
  ],
  "MIR3124": [
    "MIR3124 methyl"
  ],
  "MIR3143": [
    "MIR3143 methyl"
  ],
  "MIR3147": [
    "MIR3147 methyl"
  ],
  "MIR3150B": [
    "MIR3150B methyl"
  ],
  "MIR3150BHG": [
    "MIR3150BHG methyl"
  ],
  "MIR3153": [
    "MIR3153 methyl"
  ],
  "MIR3164": [
    "MIR3164 methyl"
  ],
  "MIR3166": [
    "MIR3166 methyl"
  ],
  "MIR3175": [
    "MIR3175 methyl"
  ],
  "MIR3178": [
    "MIR3178 methyl"
  ],
  "MIR3180-4": [
    "MIR3180-4 methyl"
  ],
  "MIR3180-5": [
    "MIR3180-5 methyl"
  ],
  "MIR3181": [
    "MIR3181 methyl"
  ],
  "MIR3183": [
    "MIR3183 methyl"
  ],
  "MIR3185": [
    "MIR3185 methyl"
  ],
  "MIR3188": [
    "MIR3188 methyl"
  ],
  "MIR3189": [
    "MIR3189 methyl"
  ],
  "MIR3190": [
    "MIR3190 methyl"
  ],
  "MIR3193": [
    "MIR3193 methyl"
  ],
  "MIR3195": [
    "MIR3195 methyl"
  ],
  "MIR3199-2": [
    "MIR3199-2 methyl"
  ],
  "MIR31HG": [
    "MIR31HG methyl"
  ],
  "MIR339": [
    "MIR339 methyl"
  ],
  "MIR345": [
    "MIR345 methyl"
  ],
  "MIR34AHG": [
    "MIR34AHG methyl"
  ],
  "MIR34B": [
    "MIR34B methyl"
  ],
  "MIR34C": [
    "MIR34C methyl"
  ],
  "MIR3610": [
    "MIR3610 methyl"
  ],
  "MIR3613": [
    "MIR3613 methyl"
  ],
  "MIR3615": [
    "MIR3615 methyl"
  ],
  "MIR3621": [
    "MIR3621 methyl"
  ],
  "MIR3651": [
    "MIR3651 methyl"
  ],
  "MIR3652": [
    "MIR3652 methyl"
  ],
  "MIR3655": [
    "MIR3655 methyl"
  ],
  "MIR3661": [
    "MIR3661 methyl"
  ],
  "MIR3663": [
    "MIR3663 methyl"
  ],
  "MIR3665": [
    "MIR3665 methyl"
  ],
  "MIR3675": [
    "MIR3675 methyl"
  ],
  "MIR3677HG": [
    "MIR3677HG methyl"
  ],
  "MIR3678": [
    "MIR3678 methyl"
  ],
  "MIR3684": [
    "MIR3684 methyl"
  ],
  "MIR369": [
    "MIR369 methyl"
  ],
  "MIR375": [
    "MIR375 methyl"
  ],
  "MIR378A": [
    "MIR378A methyl"
  ],
  "MIR378D2": [
    "MIR378D2 methyl"
  ],
  "MIR378D2HG": [
    "MIR378D2HG methyl"
  ],
  "MIR3912": [
    "MIR3912 methyl"
  ],
  "MIR3913-1": [
    "MIR3913-1 methyl"
  ],
  "MIR3917": [
    "MIR3917 methyl"
  ],
  "MIR3928": [
    "MIR3928 methyl"
  ],
  "MIR3936HG": [
    "MIR3936HG methyl"
  ],
  "MIR3939": [
    "MIR3939 methyl"
  ],
  "MIR3960": [
    "MIR3960 methyl"
  ],
  "MIR410": [
    "MIR410 methyl"
  ],
  "MIR412": [
    "MIR412 methyl"
  ],
  "MIR423": [
    "MIR423 methyl"
  ],
  "MIR425": [
    "MIR425 methyl"
  ],
  "MIR4258": [
    "MIR4258 methyl"
  ],
  "MIR4259": [
    "MIR4259 methyl"
  ],
  "MIR4281": [
    "MIR4281 methyl"
  ],
  "MIR4285": [
    "MIR4285 methyl"
  ],
  "MIR4311": [
    "MIR4311 methyl"
  ],
  "MIR4321": [
    "MIR4321 methyl"
  ],
  "MIR4322": [
    "MIR4322 methyl"
  ],
  "MIR4326": [
    "MIR4326 methyl"
  ],
  "MIR4441": [
    "MIR4441 methyl"
  ],
  "MIR4442": [
    "MIR4442 methyl"
  ],
  "MIR4444-1": [
    "MIR4444-1 methyl"
  ],
  "MIR4449": [
    "MIR4449 methyl"
  ],
  "MIR4453": [
    "MIR4453 methyl"
  ],
  "MIR4453HG": [
    "MIR4453HG methyl"
  ],
  "MIR4458HG": [
    "MIR4458HG methyl"
  ],
  "MIR4469": [
    "MIR4469 methyl"
  ],
  "MIR4470": [
    "MIR4470 methyl"
  ],
  "MIR4479": [
    "MIR4479 methyl"
  ],
  "MIR4482": [
    "MIR4482 methyl"
  ],
  "MIR4487": [
    "MIR4487 methyl"
  ],
  "MIR4488": [
    "MIR4488 methyl"
  ],
  "MIR449C": [
    "MIR449C methyl"
  ],
  "MIR4500HG": [
    "MIR4500HG methyl"
  ],
  "MIR4512": [
    "MIR4512 methyl"
  ],
  "MIR4515": [
    "MIR4515 methyl"
  ],
  "MIR4519": [
    "MIR4519 methyl"
  ],
  "MIR4520-1": [
    "MIR4520-1 methyl"
  ],
  "MIR4520-2": [
    "MIR4520-2 methyl"
  ],
  "MIR4521": [
    "MIR4521 methyl"
  ],
  "MIR4522": [
    "MIR4522 methyl"
  ],
  "MIR4523": [
    "MIR4523 methyl"
  ],
  "MIR4530": [
    "MIR4530 methyl"
  ],
  "MIR4632": [
    "MIR4632 methyl"
  ],
  "MIR4634": [
    "MIR4634 methyl"
  ],
  "MIR4638": [
    "MIR4638 methyl"
  ],
  "MIR4648": [
    "MIR4648 methyl"
  ],
  "MIR4651": [
    "MIR4651 methyl"
  ],
  "MIR4656": [
    "MIR4656 methyl"
  ],
  "MIR4664": [
    "MIR4664 methyl"
  ],
  "MIR4665": [
    "MIR4665 methyl"
  ],
  "MIR4674": [
    "MIR4674 methyl"
  ],
  "MIR4683": [
    "MIR4683 methyl"
  ],
  "MIR4687": [
    "MIR4687 methyl"
  ],
  "MIR4690": [
    "MIR4690 methyl"
  ],
  "MIR4695": [
    "MIR4695 methyl"
  ],
  "MIR4710": [
    "MIR4710 methyl"
  ],
  "MIR4727": [
    "MIR4727 methyl"
  ],
  "MIR4733": [
    "MIR4733 methyl"
  ],
  "MIR4734": [
    "MIR4734 methyl"
  ],
  "MIR4738": [
    "MIR4738 methyl"
  ],
  "MIR4740": [
    "MIR4740 methyl"
  ],
  "MIR4741": [
    "MIR4741 methyl"
  ],
  "MIR4745": [
    "MIR4745 methyl"
  ],
  "MIR4747": [
    "MIR4747 methyl"
  ],
  "MIR4754": [
    "MIR4754 methyl"
  ],
  "MIR4757": [
    "MIR4757 methyl"
  ],
  "MIR4767": [
    "MIR4767 methyl"
  ],
  "MIR4781": [
    "MIR4781 methyl"
  ],
  "MIR4783": [
    "MIR4783 methyl"
  ],
  "MIR4784": [
    "MIR4784 methyl"
  ],
  "MIR4787": [
    "MIR4787 methyl"
  ],
  "MIR4795": [
    "MIR4795 methyl"
  ],
  "MIR484": [
    "MIR484 methyl"
  ],
  "MIR4999": [
    "MIR4999 methyl"
  ],
  "MIR5001": [
    "MIR5001 methyl"
  ],
  "MIR503": [
    "MIR503 methyl"
  ],
  "MIR5087": [
    "MIR5087 methyl"
  ],
  "MIR5090": [
    "MIR5090 methyl"
  ],
  "MIR5091": [
    "MIR5091 methyl"
  ],
  "MIR5188": [
    "MIR5188 methyl"
  ],
  "MIR5189": [
    "MIR5189 methyl"
  ],
  "MIR548AL": [
    "MIR548AL methyl"
  ],
  "MIR548AW": [
    "MIR548AW methyl"
  ],
  "MIR5588": [
    "MIR5588 methyl"
  ],
  "MIR564": [
    "MIR564 methyl"
  ],
  "MIR5680": [
    "MIR5680 methyl"
  ],
  "MIR5691": [
    "MIR5691 methyl"
  ],
  "MIR5695": [
    "MIR5695 methyl"
  ],
  "MIR5696": [
    "MIR5696 methyl"
  ],
  "MIR5703": [
    "MIR5703 methyl"
  ],
  "MIR574": [
    "MIR574 methyl"
  ],
  "MIR5787": [
    "MIR5787 methyl"
  ],
  "MIR596": [
    "MIR596 methyl"
  ],
  "MIR6080": [
    "MIR6080 methyl"
  ],
  "MIR6084": [
    "MIR6084 methyl"
  ],
  "MIR6090": [
    "MIR6090 methyl"
  ],
  "MIR611": [
    "MIR611 methyl"
  ],
  "MIR6125": [
    "MIR6125 methyl"
  ],
  "MIR615": [
    "MIR615 methyl"
  ],
  "MIR616": [
    "MIR616 methyl"
  ],
  "MIR618": [
    "MIR618 methyl"
  ],
  "MIR632": [
    "MIR632 methyl"
  ],
  "MIR636": [
    "MIR636 methyl"
  ],
  "MIR638": [
    "MIR638 methyl"
  ],
  "MIR639": [
    "MIR639 methyl"
  ],
  "MIR646HG": [
    "MIR646HG methyl"
  ],
  "MIR6511A1": [
    "MIR6511A1 methyl"
  ],
  "MIR6516": [
    "MIR6516 methyl"
  ],
  "MIR656": [
    "MIR656 methyl"
  ],
  "MIR658": [
    "MIR658 methyl"
  ],
  "MIR663A": [
    "MIR663A methyl"
  ],
  "MIR663AHG": [
    "MIR663AHG methyl"
  ],
  "MIR663B": [
    "MIR663B methyl"
  ],
  "MIR671": [
    "MIR671 methyl"
  ],
  "MIR6720": [
    "MIR6720 methyl"
  ],
  "MIR6726": [
    "MIR6726 methyl"
  ],
  "MIR6727": [
    "MIR6727 methyl"
  ],
  "MIR6733": [
    "MIR6733 methyl"
  ],
  "MIR6737": [
    "MIR6737 methyl"
  ],
  "MIR6743": [
    "MIR6743 methyl"
  ],
  "MIR675": [
    "MIR675 methyl"
  ],
  "MIR6765": [
    "MIR6765 methyl"
  ],
  "MIR6781": [
    "MIR6781 methyl"
  ],
  "MIR6789": [
    "MIR6789 methyl"
  ],
  "MIR6790": [
    "MIR6790 methyl"
  ],
  "MIR6791": [
    "MIR6791 methyl"
  ],
  "MIR6808": [
    "MIR6808 methyl"
  ],
  "MIR6815": [
    "MIR6815 methyl"
  ],
  "MIR6821": [
    "MIR6821 methyl"
  ],
  "MIR6831": [
    "MIR6831 methyl"
  ],
  "MIR6846": [
    "MIR6846 methyl"
  ],
  "MIR6847": [
    "MIR6847 methyl"
  ],
  "MIR6850": [
    "MIR6850 methyl"
  ],
  "MIR6853": [
    "MIR6853 methyl"
  ],
  "MIR6872": [
    "MIR6872 methyl"
  ],
  "MIR6891": [
    "MIR6891 methyl"
  ],
  "MIR6892": [
    "MIR6892 methyl"
  ],
  "MIR7107": [
    "MIR7107 methyl"
  ],
  "MIR7155": [
    "MIR7155 methyl"
  ],
  "MIR718": [
    "MIR718 methyl"
  ],
  "MIR760": [
    "MIR760 methyl"
  ],
  "MIR762": [
    "MIR762 methyl"
  ],
  "MIR762HG": [
    "MIR762HG methyl"
  ],
  "MIR7704": [
    "MIR7704 methyl"
  ],
  "MIR7706": [
    "MIR7706 methyl"
  ],
  "MIR7845": [
    "MIR7845 methyl"
  ],
  "MIR7846": [
    "MIR7846 methyl"
  ],
  "MIR8069": [
    "MIR8069 methyl"
  ],
  "MIR8072": [
    "MIR8072 methyl"
  ],
  "MIR8075": [
    "MIR8075 methyl"
  ],
  "MIR8078": [
    "MIR8078 methyl"
  ],
  "MIR8083": [
    "MIR8083 methyl"
  ],
  "MIR8085": [
    "MIR8085 methyl"
  ],
  "MIR9-1": [
    "MIR9-1 methyl"
  ],
  "MIR9-1HG": [
    "MIR9-1HG methyl"
  ],
  "MIR9-3": [
    "MIR9-3 methyl"
  ],
  "MIR9-3HG": [
    "MIR9-3HG methyl"
  ],
  "MIR92B": [
    "MIR92B methyl"
  ],
  "MIR933": [
    "MIR933 methyl"
  ],
  "MIR935": [
    "MIR935 methyl"
  ],
  "MIR939": [
    "MIR939 methyl"
  ],
  "MIR941-1": [
    "MIR941-1 methyl"
  ],
  "MIR941-2": [
    "MIR941-2 methyl"
  ],
  "MIR941-3": [
    "MIR941-3 methyl"
  ],
  "MIR941-4": [
    "MIR941-4 methyl"
  ],
  "MIR941-5": [
    "MIR941-5 methyl"
  ],
  "MIRLET7BHG": [
    "MIRLET7BHG methyl"
  ],
  "MIRLET7I": [
    "MIRLET7I methyl"
  ],
  "MIS12": [
    "MIS12 cnv",
    "MIS12 methyl",
    "MIS12 proteo",
    "MIS12 rna"
  ],
  "MIS18A": [
    "MIS18A cnv",
    "MIS18A methyl",
    "MIS18A rna"
  ],
  "MIS18BP1": [
    "MIS18BP1 cnv",
    "MIS18BP1 methyl",
    "MIS18BP1 rna"
  ],
  "MISP": [
    "MISP cnv",
    "MISP methyl",
    "MISP rna"
  ],
  "MISP3": [
    "MISP3 91_91_1_1_S91 phospho",
    "MISP3 cnv",
    "MISP3 methyl",
    "MISP3 rna"
  ],
  "MITD1": [
    "MITD1 cnv",
    "MITD1 methyl",
    "MITD1 rna"
  ],
  "MITF": [
    "MITF 298_307_1_1_S307 phospho",
    "MITF cnv",
    "MITF methyl",
    "MITF proteo",
    "MITF rna"
  ],
  "MIX23": [
    "MIX23 cnv",
    "MIX23 methyl",
    "MIX23 proteo",
    "MIX23 rna"
  ],
  "MIXL1": [
    "MIXL1 cnv",
    "MIXL1 methyl",
    "MIXL1 rna"
  ],
  "MKI67": [
    "MKI67 347_357_1_1_S357 phospho",
    "MKI67 374_374_1_1_S374 phospho",
    "MKI67 575_584_1_1_S584 phospho",
    "MKI67 cnv",
    "MKI67 methyl",
    "MKI67 proteo",
    "MKI67 rna"
  ],
  "MKKS": [
    "MKKS cnv",
    "MKKS methyl",
    "MKKS rna"
  ],
  "MKLN1": [
    "MKLN1 cnv",
    "MKLN1 methyl",
    "MKLN1 proteo",
    "MKLN1 rna"
  ],
  "MKLN1-AS": [
    "MKLN1-AS methyl"
  ],
  "MKNK1": [
    "MKNK1 cnv",
    "MKNK1 kinase",
    "MKNK1 methyl",
    "MKNK1 proteo",
    "MKNK1 rna"
  ],
  "MKNK2": [
    "MKNK2 cnv",
    "MKNK2 kinase",
    "MKNK2 methyl",
    "MKNK2 rna"
  ],
  "MKRN1": [
    "MKRN1 cnv",
    "MKRN1 methyl",
    "MKRN1 proteo",
    "MKRN1 rna"
  ],
  "MKRN2": [
    "MKRN2 cnv",
    "MKRN2 methyl",
    "MKRN2 proteo",
    "MKRN2 rna"
  ],
  "MKRN2OS": [
    "MKRN2OS cnv",
    "MKRN2OS rna"
  ],
  "MKRN3": [
    "MKRN3 cnv",
    "MKRN3 proteo",
    "MKRN3 rna"
  ],
  "MKS1": [
    "MKS1 cnv",
    "MKS1 methyl",
    "MKS1 rna"
  ],
  "MKX": [
    "MKX cnv",
    "MKX methyl",
    "MKX rna"
  ],
  "MLANA": [
    "MLANA cnv",
    "MLANA rna"
  ],
  "MLC1": [
    "MLC1 177_181_1_0 phospho",
    "MLC1 177_181_1_1_S177 phospho",
    "MLC1 177_181_1_1_S181 phospho",
    "MLC1 27_40_1_1_S35 phospho",
    "MLC1 cnv",
    "MLC1 proteo",
    "MLC1 rna"
  ],
  "MLEC": [
    "MLEC cnv",
    "MLEC methyl",
    "MLEC proteo",
    "MLEC rna"
  ],
  "MLF1": [
    "MLF1 cnv",
    "MLF1 methyl",
    "MLF1 proteo",
    "MLF1 rna"
  ],
  "MLF1-DT": [
    "MLF1-DT methyl"
  ],
  "MLF2": [
    "MLF2 238_240_1_1_S238 phospho",
    "MLF2 cnv",
    "MLF2 methyl",
    "MLF2 proteo",
    "MLF2 rna"
  ],
  "MLH1": [
    "MLH1 386_401_1_1_S388 phospho",
    "MLH1 477_486_1_1_S477 phospho",
    "MLH1 cnv",
    "MLH1 methyl",
    "MLH1 proteo",
    "MLH1 rna"
  ],
  "MLH3": [
    "MLH3 cnv",
    "MLH3 methyl",
    "MLH3 rna"
  ],
  "MLIP": [
    "MLIP 129_143_1_1_S135 phospho",
    "MLIP 488_500_1_1_S498 phospho",
    "MLIP 63_70_1_0 phospho",
    "MLIP cnv",
    "MLIP proteo",
    "MLIP rna"
  ],
  "MLKL": [
    "MLKL cnv",
    "MLKL kinase",
    "MLKL methyl",
    "MLKL rna"
  ],
  "MLLT1": [
    "MLLT1 265_267_1_0 phospho",
    "MLLT1 289_296_1_1_S292 phospho",
    "MLLT1 475_480_1_1_S475 phospho",
    "MLLT1 cnv",
    "MLLT1 methyl",
    "MLLT1 proteo",
    "MLLT1 rna"
  ],
  "MLLT10": [
    "MLLT10 cnv",
    "MLLT10 methyl",
    "MLLT10 proteo",
    "MLLT10 rna"
  ],
  "MLLT11": [
    "MLLT11 cnv",
    "MLLT11 methyl",
    "MLLT11 proteo",
    "MLLT11 rna"
  ],
  "MLLT3": [
    "MLLT3 cnv",
    "MLLT3 methyl",
    "MLLT3 rna"
  ],
  "MLLT6": [
    "MLLT6 218_225_3_3_S218S220S222 phospho",
    "MLLT6 258_270_1_1_S258 phospho",
    "MLLT6 423_427_1_1_S423 phospho",
    "MLLT6 cnv",
    "MLLT6 methyl",
    "MLLT6 rna"
  ],
  "MLN": [
    "MLN cnv",
    "MLN rna"
  ],
  "MLNR": [
    "MLNR cnv",
    "MLNR rna"
  ],
  "MLPH": [
    "MLPH cnv",
    "MLPH methyl",
    "MLPH rna"
  ],
  "MLST8": [
    "MLST8 cnv",
    "MLST8 methyl",
    "MLST8 proteo",
    "MLST8 rna"
  ],
  "MLX": [
    "MLX cnv",
    "MLX methyl",
    "MLX rna"
  ],
  "MLXIP": [
    "MLXIP cnv",
    "MLXIP methyl",
    "MLXIP proteo",
    "MLXIP rna"
  ],
  "MLXIPL": [
    "MLXIPL cnv",
    "MLXIPL methyl",
    "MLXIPL rna"
  ],
  "MLYCD": [
    "MLYCD cnv",
    "MLYCD methyl",
    "MLYCD proteo",
    "MLYCD rna"
  ],
  "MMAA": [
    "MMAA cnv",
    "MMAA methyl",
    "MMAA proteo",
    "MMAA rna"
  ],
  "MMAB": [
    "MMAB cnv",
    "MMAB methyl",
    "MMAB proteo",
    "MMAB rna"
  ],
  "MMACHC": [
    "MMACHC cnv",
    "MMACHC methyl",
    "MMACHC proteo",
    "MMACHC rna"
  ],
  "MMADHC": [
    "MMADHC cnv",
    "MMADHC proteo",
    "MMADHC rna"
  ],
  "MMD": [
    "MMD cnv",
    "MMD methyl",
    "MMD rna"
  ],
  "MMD2": [
    "MMD2 cnv",
    "MMD2 methyl",
    "MMD2 rna"
  ],
  "MME": [
    "MME cnv",
    "MME methyl",
    "MME rna"
  ],
  "MMEL1": [
    "MMEL1 cnv",
    "MMEL1 rna"
  ],
  "MMGT1": [
    "MMGT1 104_120_1_1_S120 phospho",
    "MMGT1 methyl",
    "MMGT1 proteo",
    "MMGT1 rna"
  ],
  "MMP1": [
    "MMP1 cnv",
    "MMP1 rna"
  ],
  "MMP10": [
    "MMP10 cnv",
    "MMP10 rna"
  ],
  "MMP11": [
    "MMP11 cnv",
    "MMP11 methyl",
    "MMP11 rna"
  ],
  "MMP12": [
    "MMP12 cnv",
    "MMP12 rna"
  ],
  "MMP13": [
    "MMP13 cnv",
    "MMP13 rna"
  ],
  "MMP14": [
    "MMP14 cnv",
    "MMP14 methyl",
    "MMP14 proteo",
    "MMP14 rna"
  ],
  "MMP15": [
    "MMP15 cnv",
    "MMP15 methyl",
    "MMP15 proteo",
    "MMP15 rna"
  ],
  "MMP16": [
    "MMP16 cnv",
    "MMP16 methyl",
    "MMP16 proteo",
    "MMP16 rna"
  ],
  "MMP17": [
    "MMP17 cnv",
    "MMP17 methyl",
    "MMP17 proteo",
    "MMP17 rna"
  ],
  "MMP19": [
    "MMP19 cnv",
    "MMP19 rna"
  ],
  "MMP2": [
    "MMP2 cnv",
    "MMP2 methyl",
    "MMP2 proteo",
    "MMP2 rna"
  ],
  "MMP20": [
    "MMP20 cnv"
  ],
  "MMP21": [
    "MMP21 cnv",
    "MMP21 methyl",
    "MMP21 rna"
  ],
  "MMP23B": [
    "MMP23B cnv",
    "MMP23B methyl",
    "MMP23B rna"
  ],
  "MMP24": [
    "MMP24 cnv",
    "MMP24 rna"
  ],
  "MMP24OS": [
    "MMP24OS cnv",
    "MMP24OS methyl",
    "MMP24OS proteo",
    "MMP24OS rna"
  ],
  "MMP25": [
    "MMP25 cnv",
    "MMP25 methyl",
    "MMP25 rna"
  ],
  "MMP26": [
    "MMP26 cnv"
  ],
  "MMP27": [
    "MMP27 cnv"
  ],
  "MMP28": [
    "MMP28 cnv",
    "MMP28 methyl",
    "MMP28 rna"
  ],
  "MMP3": [
    "MMP3 cnv",
    "MMP3 rna"
  ],
  "MMP7": [
    "MMP7 cnv",
    "MMP7 rna"
  ],
  "MMP8": [
    "MMP8 cnv",
    "MMP8 proteo",
    "MMP8 rna"
  ],
  "MMP9": [
    "MMP9 cnv",
    "MMP9 proteo",
    "MMP9 rna"
  ],
  "MMRN1": [
    "MMRN1 YQQNMSHLEEK-N2H5F0S0G0 glyco",
    "MMRN1 cnv",
    "MMRN1 proteo",
    "MMRN1 rna"
  ],
  "MMRN2": [
    "MMRN2 NLSLDVEANR-N3H4F2S2G0 glyco",
    "MMRN2 QVEELQVNHTALR-N4H5F1S0G0 glyco",
    "MMRN2 SFNQSLHSLTQAIR-N2H5F0S0G0 glyco",
    "MMRN2 cnv",
    "MMRN2 proteo",
    "MMRN2 rna"
  ],
  "MMS19": [
    "MMS19 cnv",
    "MMS19 methyl",
    "MMS19 proteo",
    "MMS19 rna"
  ],
  "MMS22L": [
    "MMS22L cnv",
    "MMS22L methyl",
    "MMS22L rna"
  ],
  "MMUT": [
    "MMUT cnv",
    "MMUT methyl",
    "MMUT proteo",
    "MMUT rna"
  ],
  "MN1": [
    "MN1 cnv",
    "MN1 methyl",
    "MN1 rna"
  ],
  "MNAT1": [
    "MNAT1 cnv",
    "MNAT1 proteo",
    "MNAT1 rna"
  ],
  "MND1": [
    "MND1 cnv",
    "MND1 methyl",
    "MND1 rna"
  ],
  "MNDA": [
    "MNDA cnv",
    "MNDA proteo",
    "MNDA rna"
  ],
  "MNS1": [
    "MNS1 cnv",
    "MNS1 methyl",
    "MNS1 rna"
  ],
  "MNT": [
    "MNT cnv",
    "MNT methyl",
    "MNT proteo",
    "MNT rna"
  ],
  "MNX1": [
    "MNX1 cnv",
    "MNX1 methyl",
    "MNX1 rna"
  ],
  "MNX1-AS1": [
    "MNX1-AS1 methyl"
  ],
  "MNX1-AS2": [
    "MNX1-AS2 methyl"
  ],
  "MOAP1": [
    "MOAP1 cnv",
    "MOAP1 methyl",
    "MOAP1 rna"
  ],
  "MOB1A": [
    "MOB1A cnv",
    "MOB1A methyl",
    "MOB1A rna"
  ],
  "MOB1B": [
    "MOB1B cnv",
    "MOB1B methyl",
    "MOB1B rna"
  ],
  "MOB2": [
    "MOB2 cnv",
    "MOB2 proteo",
    "MOB2 rna"
  ],
  "MOB3A": [
    "MOB3A cnv",
    "MOB3A methyl",
    "MOB3A proteo",
    "MOB3A rna"
  ],
  "MOB3B": [
    "MOB3B cnv",
    "MOB3B proteo",
    "MOB3B rna"
  ],
  "MOB3C": [
    "MOB3C cnv",
    "MOB3C methyl",
    "MOB3C rna"
  ],
  "MOB4": [
    "MOB4 cnv",
    "MOB4 methyl",
    "MOB4 rna"
  ],
  "MOBP": [
    "MOBP 186_195_1_1_S187 phospho",
    "MOBP cnv",
    "MOBP proteo",
    "MOBP rna"
  ],
  "MOCOS": [
    "MOCOS cnv",
    "MOCOS methyl",
    "MOCOS rna"
  ],
  "MOCS1": [
    "MOCS1 cnv",
    "MOCS1 methyl",
    "MOCS1 proteo",
    "MOCS1 rna"
  ],
  "MOCS2": [
    "MOCS2 cnv",
    "MOCS2 methyl",
    "MOCS2 proteo",
    "MOCS2 rna"
  ],
  "MOCS2-DT": [
    "MOCS2-DT methyl"
  ],
  "MOCS3": [
    "MOCS3 cnv",
    "MOCS3 methyl",
    "MOCS3 proteo",
    "MOCS3 rna"
  ],
  "MOG": [
    "MOG cnv",
    "MOG proteo",
    "MOG rna"
  ],
  "MOGAT1": [
    "MOGAT1 cnv",
    "MOGAT1 methyl",
    "MOGAT1 rna"
  ],
  "MOGAT2": [
    "MOGAT2 cnv",
    "MOGAT2 rna"
  ],
  "MOGAT3": [
    "MOGAT3 cnv",
    "MOGAT3 methyl",
    "MOGAT3 rna"
  ],
  "MOGS": [
    "MOGS cnv",
    "MOGS methyl",
    "MOGS proteo",
    "MOGS rna"
  ],
  "MOK": [
    "MOK cnv",
    "MOK kinase",
    "MOK methyl",
    "MOK rna"
  ],
  "MON1A": [
    "MON1A 107_122_1_0 phospho",
    "MON1A 153_169_1_1_S153 phospho",
    "MON1A cnv",
    "MON1A methyl",
    "MON1A proteo",
    "MON1A rna"
  ],
  "MON1B": [
    "MON1B 59_73_1_1_S61 phospho",
    "MON1B 59_73_2_2_S59S61 phospho",
    "MON1B cnv",
    "MON1B methyl",
    "MON1B proteo",
    "MON1B rna"
  ],
  "MON2": [
    "MON2 cnv",
    "MON2 methyl",
    "MON2 proteo",
    "MON2 rna"
  ],
  "MORC1": [
    "MORC1 cnv",
    "MORC1 methyl",
    "MORC1 rna"
  ],
  "MORC2": [
    "MORC2 615_615_1_1_S615 phospho",
    "MORC2 856_889_1_1_S856 phospho",
    "MORC2 cnv",
    "MORC2 methyl",
    "MORC2 proteo",
    "MORC2 rna"
  ],
  "MORC2-AS1": [
    "MORC2-AS1 methyl"
  ],
  "MORC3": [
    "MORC3 cnv",
    "MORC3 methyl",
    "MORC3 proteo",
    "MORC3 rna"
  ],
  "MORC4": [
    "MORC4 methyl",
    "MORC4 rna"
  ],
  "MORF4L1": [
    "MORF4L1 cnv",
    "MORF4L1 methyl",
    "MORF4L1 proteo",
    "MORF4L1 rna"
  ],
  "MORF4L2": [
    "MORF4L2 methyl",
    "MORF4L2 proteo",
    "MORF4L2 rna"
  ],
  "MORN1": [
    "MORN1 cnv",
    "MORN1 methyl",
    "MORN1 rna"
  ],
  "MORN2": [
    "MORN2 cnv",
    "MORN2 methyl",
    "MORN2 rna"
  ],
  "MORN3": [
    "MORN3 cnv",
    "MORN3 rna"
  ],
  "MORN4": [
    "MORN4 cnv",
    "MORN4 methyl",
    "MORN4 proteo",
    "MORN4 rna"
  ],
  "MORN5": [
    "MORN5 cnv",
    "MORN5 methyl",
    "MORN5 rna"
  ],
  "MOS": [
    "MOS cnv",
    "MOS kinase",
    "MOS methyl",
    "MOS rna"
  ],
  "MOSMO": [
    "MOSMO cnv",
    "MOSMO methyl",
    "MOSMO rna"
  ],
  "MOSPD1": [
    "MOSPD1 methyl",
    "MOSPD1 rna"
  ],
  "MOSPD2": [
    "MOSPD2 methyl",
    "MOSPD2 proteo",
    "MOSPD2 rna"
  ],
  "MOSPD3": [
    "MOSPD3 cnv",
    "MOSPD3 methyl",
    "MOSPD3 rna"
  ],
  "MOV10": [
    "MOV10 cnv",
    "MOV10 methyl",
    "MOV10 proteo",
    "MOV10 rna"
  ],
  "MOV10L1": [
    "MOV10L1 cnv",
    "MOV10L1 methyl",
    "MOV10L1 rna"
  ],
  "MOXD1": [
    "MOXD1 DAQQDYHLEYAMENSTHTIIEFTR-N2H5F0S0G0 glyco",
    "MOXD1 DAQQDYHLEYAMENSTHTIIEFTR-N2H6F0S0G0 glyco",
    "MOXD1 cnv",
    "MOXD1 methyl",
    "MOXD1 proteo",
    "MOXD1 rna"
  ],
  "MPC1": [
    "MPC1 cnv",
    "MPC1 methyl",
    "MPC1 proteo",
    "MPC1 rna"
  ],
  "MPC1L": [
    "MPC1L methyl",
    "MPC1L rna"
  ],
  "MPC2": [
    "MPC2 cnv",
    "MPC2 methyl",
    "MPC2 proteo",
    "MPC2 rna"
  ],
  "MPDU1": [
    "MPDU1 cnv",
    "MPDU1 methyl",
    "MPDU1 proteo",
    "MPDU1 rna"
  ],
  "MPDZ": [
    "MPDZ 1250_1254_1_1_S1250 phospho",
    "MPDZ 1551_1567_1_1_S1562 phospho",
    "MPDZ 1785_1815_1_0 phospho",
    "MPDZ 342_358_1_1_S354 phospho",
    "MPDZ 477_488_1_1_S483 phospho",
    "MPDZ 483_488_1_1_S483 phospho",
    "MPDZ cnv",
    "MPDZ methyl",
    "MPDZ proteo",
    "MPDZ rna"
  ],
  "MPEG1": [
    "MPEG1 cnv",
    "MPEG1 rna"
  ],
  "MPG": [
    "MPG cnv",
    "MPG methyl",
    "MPG proteo",
    "MPG rna"
  ],
  "MPHOSPH10": [
    "MPHOSPH10 cnv",
    "MPHOSPH10 methyl",
    "MPHOSPH10 proteo",
    "MPHOSPH10 rna"
  ],
  "MPHOSPH10P1": [
    "MPHOSPH10P1 methyl"
  ],
  "MPHOSPH6": [
    "MPHOSPH6 cnv",
    "MPHOSPH6 methyl",
    "MPHOSPH6 proteo",
    "MPHOSPH6 rna"
  ],
  "MPHOSPH8": [
    "MPHOSPH8 400_403_1_1_S403 phospho",
    "MPHOSPH8 83_89_1_1_S85 phospho",
    "MPHOSPH8 cnv",
    "MPHOSPH8 methyl",
    "MPHOSPH8 proteo",
    "MPHOSPH8 rna"
  ],
  "MPHOSPH9": [
    "MPHOSPH9 cnv",
    "MPHOSPH9 methyl",
    "MPHOSPH9 rna"
  ],
  "MPI": [
    "MPI cnv",
    "MPI methyl",
    "MPI proteo",
    "MPI rna"
  ],
  "MPIG6B": [
    "MPIG6B cnv",
    "MPIG6B rna"
  ],
  "MPL": [
    "MPL cnv",
    "MPL methyl",
    "MPL rna"
  ],
  "MPLKIP": [
    "MPLKIP 133_139_1_1_S133 phospho",
    "MPLKIP 93_115_1_1_S115 phospho",
    "MPLKIP cnv",
    "MPLKIP methyl",
    "MPLKIP rna"
  ],
  "MPND": [
    "MPND cnv",
    "MPND methyl",
    "MPND rna"
  ],
  "MPO": [
    "MPO ALLPFDNLHDDPCLLTNR-N2H6F0S0G0 glyco",
    "MPO NLRNMSNQLGLLAVNQR-N2H5F0S0G0 glyco",
    "MPO NLRNMSNQLGLLAVNQR-N2H6F0S0G0 glyco",
    "MPO NMSNQLGLLAVNQR-N2H5F0S0G0 glyco",
    "MPO NMSNQLGLLAVNQR-N2H6F0S0G0 glyco",
    "MPO NMSNQLGLLAVNQR-N2H7F0S0G0 glyco",
    "MPO SCPACPGSNITIR-N2H6F0S0G0 glyco",
    "MPO SCPACPGSNITIR-N2H7F0S0G0 glyco",
    "MPO SYNDSVDPR-N2H3F1S0G0 glyco",
    "MPO cnv",
    "MPO methyl",
    "MPO proteo",
    "MPO rna"
  ],
  "MPP1": [
    "MPP1 93_112_1_1_S93 phospho",
    "MPP1 methyl",
    "MPP1 proteo",
    "MPP1 rna"
  ],
  "MPP2": [
    "MPP2 159_174_1_0 phospho",
    "MPP2 159_174_1_1_T162 phospho",
    "MPP2 159_174_2_0 phospho",
    "MPP2 159_174_2_2_T162S166 phospho",
    "MPP2 cnv",
    "MPP2 methyl",
    "MPP2 proteo",
    "MPP2 rna"
  ],
  "MPP3": [
    "MPP3 cnv",
    "MPP3 methyl",
    "MPP3 rna"
  ],
  "MPP4": [
    "MPP4 cnv",
    "MPP4 rna"
  ],
  "MPP7": [
    "MPP7 cnv",
    "MPP7 methyl",
    "MPP7 proteo",
    "MPP7 rna"
  ],
  "MPPE1": [
    "MPPE1 cnv",
    "MPPE1 methyl",
    "MPPE1 rna"
  ],
  "MPPED1": [
    "MPPED1 cnv",
    "MPPED1 methyl",
    "MPPED1 rna"
  ],
  "MPPED2": [
    "MPPED2 cnv",
    "MPPED2 methyl",
    "MPPED2 proteo",
    "MPPED2 rna"
  ],
  "MPRIP": [
    "MPRIP 217_243_2_2_S220S224 phospho",
    "MPRIP 289_295_1_1_S289 phospho",
    "MPRIP 289_295_1_1_S292 phospho",
    "MPRIP 289_295_2_2_S289S292 phospho",
    "MPRIP 501_512_1_1_S504 phospho",
    "MPRIP 540_542_1_1_T542 phospho",
    "MPRIP 619_625_1_1_S619 phospho",
    "MPRIP 878_891_1_1_S891 phospho",
    "MPRIP 970_986_1_1_S977 phospho",
    "MPRIP 991_993_1_1_S993 phospho",
    "MPRIP 993_993_1_1_S993 phospho",
    "MPRIP cnv",
    "MPRIP methyl",
    "MPRIP proteo",
    "MPRIP rna"
  ],
  "MPST": [
    "MPST 15_23_1_1_S15 phospho",
    "MPST 15_23_1_1_S17 phospho",
    "MPST cnv",
    "MPST methyl",
    "MPST proteo",
    "MPST rna"
  ],
  "MPV17": [
    "MPV17 cnv",
    "MPV17 proteo",
    "MPV17 rna"
  ],
  "MPV17L": [
    "MPV17L cnv",
    "MPV17L rna"
  ],
  "MPV17L2": [
    "MPV17L2 cnv",
    "MPV17L2 methyl",
    "MPV17L2 rna"
  ],
  "MPZ": [
    "MPZ cnv",
    "MPZ proteo",
    "MPZ rna"
  ],
  "MPZL1": [
    "MPZL1 200_210_1_1_S210 phospho",
    "MPZL1 219_223_1_1_S219 phospho",
    "MPZL1 219_223_1_1_S221 phospho",
    "MPZL1 258_263_1_1_S260 phospho",
    "MPZL1 EIFVANGTQGK-N2H8F0S0G0 glyco",
    "MPZL1 EIFVANGTQGK-N3H4F1S1G0 glyco",
    "MPZL1 EIFVANGTQGK-N3H5F0S1G0 glyco",
    "MPZL1 EIFVANGTQGK-N3H5F1S1G0 glyco",
    "MPZL1 EIFVANGTQGK-N3H5F2S0G0 glyco",
    "MPZL1 EIFVANGTQGK-N3H6F1S1G0 glyco",
    "MPZL1 EIFVANGTQGK-N4H4F1S1G0 glyco",
    "MPZL1 cnv",
    "MPZL1 methyl",
    "MPZL1 proteo",
    "MPZL1 rna"
  ],
  "MPZL2": [
    "MPZL2 cnv",
    "MPZL2 rna"
  ],
  "MPZL3": [
    "MPZL3 cnv",
    "MPZL3 rna"
  ],
  "MR1": [
    "MR1 cnv",
    "MR1 rna"
  ],
  "MRAP": [
    "MRAP cnv",
    "MRAP rna"
  ],
  "MRAP2": [
    "MRAP2 cnv",
    "MRAP2 methyl",
    "MRAP2 rna"
  ],
  "MRAS": [
    "MRAS cnv",
    "MRAS methyl",
    "MRAS proteo",
    "MRAS rna"
  ],
  "MRC1": [
    "MRC1 cnv",
    "MRC1 proteo",
    "MRC1 rna"
  ],
  "MRC2": [
    "MRC2 1455_1463_1_1_S1456 phospho",
    "MRC2 1455_1463_1_1_S1458 phospho",
    "MRC2 GTDPSLSPSPAALPPAPGTELSYLNGTFR-N2H5F0S0G0 glyco",
    "MRC2 GTDPSLSPSPAALPPAPGTELSYLNGTFR-N4H3F1S0G0 glyco",
    "MRC2 VTPACNTSLPAQR-N2H5F0S0G0 glyco",
    "MRC2 VTPACNTSLPAQR-N4H4F1S1G0 glyco",
    "MRC2 VTPACNTSLPAQR-N4H5F1S0G0 glyco",
    "MRC2 VTPACNTSLPAQR-N4H5F1S1G0 glyco",
    "MRC2 cnv",
    "MRC2 methyl",
    "MRC2 proteo",
    "MRC2 rna"
  ],
  "MRE11": [
    "MRE11 687_701_1_0 phospho",
    "MRE11 687_701_1_1_S688 phospho",
    "MRE11 cnv",
    "MRE11 methyl",
    "MRE11 proteo",
    "MRE11 rna"
  ],
  "MREG": [
    "MREG cnv",
    "MREG methyl",
    "MREG rna"
  ],
  "MRFAP1": [
    "MRFAP1 cnv",
    "MRFAP1 methyl",
    "MRFAP1 proteo",
    "MRFAP1 rna"
  ],
  "MRFAP1L1": [
    "MRFAP1L1 cnv",
    "MRFAP1L1 methyl",
    "MRFAP1L1 rna"
  ],
  "MRFAP1P1": [
    "MRFAP1P1 methyl"
  ],
  "MRGBP": [
    "MRGBP 188_197_1_1_S191 phospho",
    "MRGBP 188_197_1_1_S195 phospho",
    "MRGBP 188_197_2_2_S191S195 phospho",
    "MRGBP cnv",
    "MRGBP methyl",
    "MRGBP proteo",
    "MRGBP rna"
  ],
  "MRGPRD": [
    "MRGPRD cnv",
    "MRGPRD rna"
  ],
  "MRGPRE": [
    "MRGPRE cnv",
    "MRGPRE methyl",
    "MRGPRE rna"
  ],
  "MRGPRF": [
    "MRGPRF cnv",
    "MRGPRF rna"
  ],
  "MRGPRF-AS1": [
    "MRGPRF-AS1 methyl"
  ],
  "MRGPRG": [
    "MRGPRG cnv"
  ],
  "MRGPRG-AS1": [
    "MRGPRG-AS1 methyl"
  ],
  "MRGPRX1": [
    "MRGPRX1 cnv"
  ],
  "MRGPRX2": [
    "MRGPRX2 cnv"
  ],
  "MRGPRX3": [
    "MRGPRX3 cnv",
    "MRGPRX3 rna"
  ],
  "MRGPRX4": [
    "MRGPRX4 cnv",
    "MRGPRX4 rna"
  ],
  "MRI1": [
    "MRI1 cnv",
    "MRI1 methyl",
    "MRI1 proteo",
    "MRI1 rna"
  ],
  "MRLN": [
    "MRLN cnv",
    "MRLN rna"
  ],
  "MRM1": [
    "MRM1 cnv",
    "MRM1 methyl",
    "MRM1 proteo",
    "MRM1 rna"
  ],
  "MRM2": [
    "MRM2 cnv",
    "MRM2 methyl",
    "MRM2 proteo",
    "MRM2 rna"
  ],
  "MRM3": [
    "MRM3 cnv",
    "MRM3 methyl",
    "MRM3 proteo",
    "MRM3 rna"
  ],
  "MRNIP": [
    "MRNIP cnv",
    "MRNIP methyl",
    "MRNIP proteo",
    "MRNIP rna"
  ],
  "MRNIP-DT": [
    "MRNIP-DT methyl"
  ],
  "MRO": [
    "MRO cnv",
    "MRO rna"
  ],
  "MROH1": [
    "MROH1 cnv",
    "MROH1 methyl",
    "MROH1 proteo",
    "MROH1 rna"
  ],
  "MROH2A": [
    "MROH2A cnv",
    "MROH2A rna"
  ],
  "MROH2B": [
    "MROH2B cnv",
    "MROH2B rna"
  ],
  "MROH5": [
    "MROH5 cnv"
  ],
  "MROH6": [
    "MROH6 cnv",
    "MROH6 methyl",
    "MROH6 rna"
  ],
  "MROH7": [
    "MROH7 cnv",
    "MROH7 rna"
  ],
  "MROH7-TTC4": [
    "MROH7-TTC4 cnv",
    "MROH7-TTC4 rna"
  ],
  "MROH8": [
    "MROH8 cnv",
    "MROH8 methyl",
    "MROH8 rna"
  ],
  "MROH9": [
    "MROH9 cnv",
    "MROH9 rna"
  ],
  "MRPL1": [
    "MRPL1 cnv",
    "MRPL1 methyl",
    "MRPL1 proteo",
    "MRPL1 rna"
  ],
  "MRPL10": [
    "MRPL10 cnv",
    "MRPL10 methyl",
    "MRPL10 proteo",
    "MRPL10 rna"
  ],
  "MRPL11": [
    "MRPL11 cnv",
    "MRPL11 methyl",
    "MRPL11 proteo",
    "MRPL11 rna"
  ],
  "MRPL12": [
    "MRPL12 cnv",
    "MRPL12 methyl",
    "MRPL12 proteo",
    "MRPL12 rna"
  ],
  "MRPL13": [
    "MRPL13 cnv",
    "MRPL13 methyl",
    "MRPL13 proteo",
    "MRPL13 rna"
  ],
  "MRPL14": [
    "MRPL14 cnv",
    "MRPL14 methyl",
    "MRPL14 proteo",
    "MRPL14 rna"
  ],
  "MRPL15": [
    "MRPL15 cnv",
    "MRPL15 methyl",
    "MRPL15 proteo",
    "MRPL15 rna"
  ],
  "MRPL16": [
    "MRPL16 cnv",
    "MRPL16 methyl",
    "MRPL16 proteo",
    "MRPL16 rna"
  ],
  "MRPL17": [
    "MRPL17 cnv",
    "MRPL17 methyl",
    "MRPL17 proteo",
    "MRPL17 rna"
  ],
  "MRPL18": [
    "MRPL18 cnv",
    "MRPL18 methyl",
    "MRPL18 proteo",
    "MRPL18 rna"
  ],
  "MRPL19": [
    "MRPL19 cnv",
    "MRPL19 methyl",
    "MRPL19 proteo",
    "MRPL19 rna"
  ],
  "MRPL2": [
    "MRPL2 cnv",
    "MRPL2 methyl",
    "MRPL2 proteo",
    "MRPL2 rna"
  ],
  "MRPL20": [
    "MRPL20 cnv",
    "MRPL20 methyl",
    "MRPL20 proteo",
    "MRPL20 rna"
  ],
  "MRPL20-AS1": [
    "MRPL20-AS1 methyl"
  ],
  "MRPL21": [
    "MRPL21 cnv",
    "MRPL21 methyl",
    "MRPL21 proteo",
    "MRPL21 rna"
  ],
  "MRPL22": [
    "MRPL22 cnv",
    "MRPL22 proteo",
    "MRPL22 rna"
  ],
  "MRPL23": [
    "MRPL23 cnv",
    "MRPL23 methyl",
    "MRPL23 proteo",
    "MRPL23 rna"
  ],
  "MRPL24": [
    "MRPL24 cnv",
    "MRPL24 methyl",
    "MRPL24 proteo",
    "MRPL24 rna"
  ],
  "MRPL27": [
    "MRPL27 cnv",
    "MRPL27 methyl",
    "MRPL27 proteo",
    "MRPL27 rna"
  ],
  "MRPL28": [
    "MRPL28 cnv",
    "MRPL28 methyl",
    "MRPL28 proteo",
    "MRPL28 rna"
  ],
  "MRPL3": [
    "MRPL3 cnv",
    "MRPL3 methyl",
    "MRPL3 proteo",
    "MRPL3 rna"
  ],
  "MRPL30": [
    "MRPL30 cnv",
    "MRPL30 methyl",
    "MRPL30 proteo",
    "MRPL30 rna"
  ],
  "MRPL32": [
    "MRPL32 cnv",
    "MRPL32 methyl",
    "MRPL32 proteo",
    "MRPL32 rna"
  ],
  "MRPL33": [
    "MRPL33 cnv",
    "MRPL33 methyl",
    "MRPL33 proteo",
    "MRPL33 rna"
  ],
  "MRPL34": [
    "MRPL34 cnv",
    "MRPL34 methyl",
    "MRPL34 rna"
  ],
  "MRPL35": [
    "MRPL35 cnv",
    "MRPL35 rna"
  ],
  "MRPL36": [
    "MRPL36 cnv",
    "MRPL36 methyl",
    "MRPL36 rna"
  ],
  "MRPL37": [
    "MRPL37 cnv",
    "MRPL37 methyl",
    "MRPL37 proteo",
    "MRPL37 rna"
  ],
  "MRPL38": [
    "MRPL38 cnv",
    "MRPL38 methyl",
    "MRPL38 proteo",
    "MRPL38 rna"
  ],
  "MRPL39": [
    "MRPL39 cnv",
    "MRPL39 methyl",
    "MRPL39 proteo",
    "MRPL39 rna"
  ],
  "MRPL4": [
    "MRPL4 cnv",
    "MRPL4 methyl",
    "MRPL4 proteo",
    "MRPL4 rna"
  ],
  "MRPL40": [
    "MRPL40 cnv",
    "MRPL40 methyl",
    "MRPL40 proteo",
    "MRPL40 rna"
  ],
  "MRPL41": [
    "MRPL41 cnv",
    "MRPL41 methyl",
    "MRPL41 proteo",
    "MRPL41 rna"
  ],
  "MRPL42": [
    "MRPL42 cnv",
    "MRPL42 methyl",
    "MRPL42 proteo",
    "MRPL42 rna"
  ],
  "MRPL43": [
    "MRPL43 cnv",
    "MRPL43 methyl",
    "MRPL43 proteo",
    "MRPL43 rna"
  ],
  "MRPL44": [
    "MRPL44 cnv",
    "MRPL44 methyl",
    "MRPL44 proteo",
    "MRPL44 rna"
  ],
  "MRPL45": [
    "MRPL45 cnv",
    "MRPL45 methyl",
    "MRPL45 proteo",
    "MRPL45 rna"
  ],
  "MRPL46": [
    "MRPL46 cnv",
    "MRPL46 methyl",
    "MRPL46 proteo",
    "MRPL46 rna"
  ],
  "MRPL47": [
    "MRPL47 cnv",
    "MRPL47 methyl",
    "MRPL47 proteo",
    "MRPL47 rna"
  ],
  "MRPL48": [
    "MRPL48 cnv",
    "MRPL48 methyl",
    "MRPL48 proteo",
    "MRPL48 rna"
  ],
  "MRPL49": [
    "MRPL49 cnv",
    "MRPL49 methyl",
    "MRPL49 proteo",
    "MRPL49 rna"
  ],
  "MRPL50": [
    "MRPL50 cnv",
    "MRPL50 methyl",
    "MRPL50 proteo",
    "MRPL50 rna"
  ],
  "MRPL51": [
    "MRPL51 cnv",
    "MRPL51 methyl",
    "MRPL51 rna"
  ],
  "MRPL52": [
    "MRPL52 cnv",
    "MRPL52 methyl",
    "MRPL52 proteo",
    "MRPL52 rna"
  ],
  "MRPL53": [
    "MRPL53 cnv",
    "MRPL53 methyl",
    "MRPL53 proteo",
    "MRPL53 rna"
  ],
  "MRPL54": [
    "MRPL54 cnv",
    "MRPL54 methyl",
    "MRPL54 proteo",
    "MRPL54 rna"
  ],
  "MRPL55": [
    "MRPL55 cnv",
    "MRPL55 methyl",
    "MRPL55 proteo",
    "MRPL55 rna"
  ],
  "MRPL57": [
    "MRPL57 cnv",
    "MRPL57 methyl",
    "MRPL57 proteo",
    "MRPL57 rna"
  ],
  "MRPL58": [
    "MRPL58 cnv",
    "MRPL58 methyl",
    "MRPL58 proteo",
    "MRPL58 rna"
  ],
  "MRPL9": [
    "MRPL9 cnv",
    "MRPL9 methyl",
    "MRPL9 proteo",
    "MRPL9 rna"
  ],
  "MRPS10": [
    "MRPS10 cnv",
    "MRPS10 proteo",
    "MRPS10 rna"
  ],
  "MRPS11": [
    "MRPS11 cnv",
    "MRPS11 methyl",
    "MRPS11 proteo",
    "MRPS11 rna"
  ],
  "MRPS12": [
    "MRPS12 cnv",
    "MRPS12 methyl",
    "MRPS12 proteo",
    "MRPS12 rna"
  ],
  "MRPS14": [
    "MRPS14 cnv",
    "MRPS14 methyl",
    "MRPS14 proteo",
    "MRPS14 rna"
  ],
  "MRPS15": [
    "MRPS15 cnv",
    "MRPS15 methyl",
    "MRPS15 proteo",
    "MRPS15 rna"
  ],
  "MRPS16": [
    "MRPS16 125_137_1_1_T130 phospho",
    "MRPS16 cnv",
    "MRPS16 methyl",
    "MRPS16 proteo",
    "MRPS16 rna"
  ],
  "MRPS17": [
    "MRPS17 cnv",
    "MRPS17 methyl",
    "MRPS17 proteo",
    "MRPS17 rna"
  ],
  "MRPS18A": [
    "MRPS18A cnv",
    "MRPS18A methyl",
    "MRPS18A proteo",
    "MRPS18A rna"
  ],
  "MRPS18B": [
    "MRPS18B cnv",
    "MRPS18B methyl",
    "MRPS18B proteo",
    "MRPS18B rna"
  ],
  "MRPS18C": [
    "MRPS18C cnv",
    "MRPS18C methyl",
    "MRPS18C proteo",
    "MRPS18C rna"
  ],
  "MRPS2": [
    "MRPS2 cnv",
    "MRPS2 methyl",
    "MRPS2 proteo",
    "MRPS2 rna"
  ],
  "MRPS21": [
    "MRPS21 cnv",
    "MRPS21 methyl",
    "MRPS21 rna"
  ],
  "MRPS22": [
    "MRPS22 cnv",
    "MRPS22 methyl",
    "MRPS22 proteo",
    "MRPS22 rna"
  ],
  "MRPS23": [
    "MRPS23 cnv",
    "MRPS23 methyl",
    "MRPS23 proteo",
    "MRPS23 rna"
  ],
  "MRPS24": [
    "MRPS24 cnv",
    "MRPS24 methyl",
    "MRPS24 proteo",
    "MRPS24 rna"
  ],
  "MRPS25": [
    "MRPS25 cnv",
    "MRPS25 methyl",
    "MRPS25 proteo",
    "MRPS25 rna"
  ],
  "MRPS26": [
    "MRPS26 cnv",
    "MRPS26 methyl",
    "MRPS26 proteo",
    "MRPS26 rna"
  ],
  "MRPS27": [
    "MRPS27 cnv",
    "MRPS27 methyl",
    "MRPS27 proteo",
    "MRPS27 rna"
  ],
  "MRPS28": [
    "MRPS28 cnv",
    "MRPS28 methyl",
    "MRPS28 proteo",
    "MRPS28 rna"
  ],
  "MRPS30": [
    "MRPS30 cnv",
    "MRPS30 methyl",
    "MRPS30 proteo",
    "MRPS30 rna"
  ],
  "MRPS31": [
    "MRPS31 cnv",
    "MRPS31 methyl",
    "MRPS31 proteo",
    "MRPS31 rna"
  ],
  "MRPS31P5": [
    "MRPS31P5 methyl"
  ],
  "MRPS33": [
    "MRPS33 cnv",
    "MRPS33 methyl",
    "MRPS33 proteo",
    "MRPS33 rna"
  ],
  "MRPS34": [
    "MRPS34 cnv",
    "MRPS34 methyl",
    "MRPS34 proteo",
    "MRPS34 rna"
  ],
  "MRPS35": [
    "MRPS35 cnv",
    "MRPS35 methyl",
    "MRPS35 proteo",
    "MRPS35 rna"
  ],
  "MRPS36": [
    "MRPS36 59_73_1_0 phospho",
    "MRPS36 59_73_1_1_S61 phospho",
    "MRPS36 cnv",
    "MRPS36 methyl",
    "MRPS36 proteo",
    "MRPS36 rna"
  ],
  "MRPS5": [
    "MRPS5 cnv",
    "MRPS5 methyl",
    "MRPS5 proteo",
    "MRPS5 rna"
  ],
  "MRPS6": [
    "MRPS6 cnv",
    "MRPS6 methyl",
    "MRPS6 proteo",
    "MRPS6 rna"
  ],
  "MRPS7": [
    "MRPS7 cnv",
    "MRPS7 methyl",
    "MRPS7 proteo",
    "MRPS7 rna"
  ],
  "MRPS9": [
    "MRPS9 cnv",
    "MRPS9 methyl",
    "MRPS9 proteo",
    "MRPS9 rna"
  ],
  "MRPS9-AS2": [
    "MRPS9-AS2 methyl"
  ],
  "MRRF": [
    "MRRF cnv",
    "MRRF methyl",
    "MRRF proteo",
    "MRRF rna"
  ],
  "MRS2": [
    "MRS2 cnv",
    "MRS2 methyl",
    "MRS2 rna"
  ],
  "MRTFA": [
    "MRTFA 345_355_1_0 phospho",
    "MRTFA 368_372_1_0 phospho",
    "MRTFA 368_372_1_1_S370 phospho",
    "MRTFA 415_420_1_1_S420 phospho",
    "MRTFA 41_41_1_1_S41 phospho",
    "MRTFA 481_493_1_1_T485 phospho",
    "MRTFA 481_493_2_2_T485S489 phospho",
    "MRTFA cnv",
    "MRTFA methyl",
    "MRTFA proteo",
    "MRTFA rna"
  ],
  "MRTFB": [
    "MRTFB 547_561_1_1_S554 phospho",
    "MRTFB 77_77_1_1_S77 phospho",
    "MRTFB 845_874_1_0 phospho",
    "MRTFB cnv",
    "MRTFB methyl",
    "MRTFB proteo",
    "MRTFB rna"
  ],
  "MRTO4": [
    "MRTO4 cnv",
    "MRTO4 methyl",
    "MRTO4 proteo",
    "MRTO4 rna"
  ],
  "MS4A1": [
    "MS4A1 cnv",
    "MS4A1 rna"
  ],
  "MS4A10": [
    "MS4A10 cnv",
    "MS4A10 rna"
  ],
  "MS4A12": [
    "MS4A12 cnv"
  ],
  "MS4A13": [
    "MS4A13 cnv",
    "MS4A13 methyl"
  ],
  "MS4A14": [
    "MS4A14 cnv",
    "MS4A14 rna"
  ],
  "MS4A15": [
    "MS4A15 cnv",
    "MS4A15 rna"
  ],
  "MS4A18": [
    "MS4A18 cnv"
  ],
  "MS4A2": [
    "MS4A2 cnv",
    "MS4A2 rna"
  ],
  "MS4A3": [
    "MS4A3 cnv",
    "MS4A3 rna"
  ],
  "MS4A4A": [
    "MS4A4A cnv",
    "MS4A4A rna"
  ],
  "MS4A4E": [
    "MS4A4E cnv",
    "MS4A4E rna"
  ],
  "MS4A5": [
    "MS4A5 cnv"
  ],
  "MS4A6A": [
    "MS4A6A cnv",
    "MS4A6A rna"
  ],
  "MS4A6E": [
    "MS4A6E cnv",
    "MS4A6E rna"
  ],
  "MS4A7": [
    "MS4A7 cnv",
    "MS4A7 rna"
  ],
  "MS4A8": [
    "MS4A8 cnv",
    "MS4A8 rna"
  ],
  "MSANTD1": [
    "MSANTD1 cnv",
    "MSANTD1 methyl",
    "MSANTD1 rna"
  ],
  "MSANTD2": [
    "MSANTD2 24_43_1_1_S27 phospho",
    "MSANTD2 419_443_1_1_S436 phospho",
    "MSANTD2 48_63_1_1_S48 phospho",
    "MSANTD2 cnv",
    "MSANTD2 methyl",
    "MSANTD2 rna"
  ],
  "MSANTD2-AS1": [
    "MSANTD2-AS1 methyl"
  ],
  "MSANTD3": [
    "MSANTD3 cnv",
    "MSANTD3 methyl",
    "MSANTD3 rna"
  ],
  "MSANTD3-TMEFF1": [
    "MSANTD3-TMEFF1 cnv",
    "MSANTD3-TMEFF1 rna"
  ],
  "MSANTD4": [
    "MSANTD4 cnv",
    "MSANTD4 methyl",
    "MSANTD4 proteo",
    "MSANTD4 rna"
  ],
  "MSANTD5": [
    "MSANTD5 cnv",
    "MSANTD5 methyl",
    "MSANTD5 rna"
  ],
  "MSANTD7": [
    "MSANTD7 cnv",
    "MSANTD7 methyl",
    "MSANTD7 rna"
  ],
  "MSC": [
    "MSC cnv",
    "MSC methyl",
    "MSC rna"
  ],
  "MSC-AS1": [
    "MSC-AS1 methyl"
  ],
  "MSGN1": [
    "MSGN1 cnv",
    "MSGN1 rna"
  ],
  "MSH2": [
    "MSH2 cnv",
    "MSH2 methyl",
    "MSH2 proteo",
    "MSH2 rna"
  ],
  "MSH3": [
    "MSH3 cnv",
    "MSH3 methyl",
    "MSH3 proteo",
    "MSH3 rna"
  ],
  "MSH4": [
    "MSH4 cnv",
    "MSH4 methyl",
    "MSH4 rna"
  ],
  "MSH5": [
    "MSH5 cnv",
    "MSH5 methyl",
    "MSH5 rna"
  ],
  "MSH5-SAPCD1": [
    "MSH5-SAPCD1 cnv",
    "MSH5-SAPCD1 rna"
  ],
  "MSH6": [
    "MSH6 137_139_1_1_S137 phospho",
    "MSH6 219_227_1_1_S227 phospho",
    "MSH6 cnv",
    "MSH6 methyl",
    "MSH6 mut",
    "MSH6 proteo",
    "MSH6 rna"
  ],
  "MSI1": [
    "MSI1 cnv",
    "MSI1 methyl",
    "MSI1 proteo",
    "MSI1 rna"
  ],
  "MSI2": [
    "MSI2 cnv",
    "MSI2 methyl",
    "MSI2 proteo",
    "MSI2 rna"
  ],
  "MSL1": [
    "MSL1 cnv",
    "MSL1 methyl",
    "MSL1 rna"
  ],
  "MSL2": [
    "MSL2 cnv",
    "MSL2 methyl",
    "MSL2 rna"
  ],
  "MSL3": [
    "MSL3 292_322_1_1_S299 phospho",
    "MSL3 350_355_1_1_S355 phospho",
    "MSL3 386_395_1_1_S388 phospho",
    "MSL3 386_395_2_2_S388T393 phospho",
    "MSL3 methyl",
    "MSL3 rna"
  ],
  "MSL3P1": [
    "MSL3P1 methyl"
  ],
  "MSLN": [
    "MSLN cnv",
    "MSLN rna"
  ],
  "MSLNL": [
    "MSLNL cnv",
    "MSLNL rna"
  ],
  "MSMB": [
    "MSMB cnv"
  ],
  "MSMO1": [
    "MSMO1 cnv",
    "MSMO1 methyl",
    "MSMO1 proteo",
    "MSMO1 rna"
  ],
  "MSMP": [
    "MSMP cnv",
    "MSMP methyl",
    "MSMP rna"
  ],
  "MSN": [
    "MSN 74_74_1_1_S74 phospho",
    "MSN methyl",
    "MSN proteo",
    "MSN rna"
  ],
  "MSR1": [
    "MSR1 45_47_1_1_S45 phospho",
    "MSR1 cnv",
    "MSR1 proteo",
    "MSR1 rna"
  ],
  "MSRA": [
    "MSRA cnv",
    "MSRA methyl",
    "MSRA proteo",
    "MSRA rna"
  ],
  "MSRB1": [
    "MSRB1 cnv",
    "MSRB1 methyl",
    "MSRB1 rna"
  ],
  "MSRB2": [
    "MSRB2 cnv",
    "MSRB2 proteo",
    "MSRB2 rna"
  ],
  "MSRB3": [
    "MSRB3 cnv",
    "MSRB3 methyl",
    "MSRB3 proteo",
    "MSRB3 rna"
  ],
  "MSS51": [
    "MSS51 cnv",
    "MSS51 rna"
  ],
  "MST1": [
    "MST1 cnv",
    "MST1 methyl",
    "MST1 proteo",
    "MST1 rna"
  ],
  "MST1R": [
    "MST1R cnv",
    "MST1R kinase",
    "MST1R methyl",
    "MST1R rna"
  ],
  "MSTN": [
    "MSTN cnv",
    "MSTN rna"
  ],
  "MSTO1": [
    "MSTO1 cnv",
    "MSTO1 methyl",
    "MSTO1 proteo",
    "MSTO1 rna"
  ],
  "MSX1": [
    "MSX1 cnv",
    "MSX1 methyl",
    "MSX1 rna"
  ],
  "MSX2": [
    "MSX2 cnv",
    "MSX2 methyl",
    "MSX2 rna"
  ],
  "MT-ATP6": [
    "MT-ATP6 proteo",
    "MT-ATP6 rna"
  ],
  "MT-ATP8": [
    "MT-ATP8 proteo",
    "MT-ATP8 rna"
  ],
  "MT-CO1": [
    "MT-CO1 rna"
  ],
  "MT-CO2": [
    "MT-CO2 proteo",
    "MT-CO2 rna"
  ],
  "MT-CO3": [
    "MT-CO3 proteo",
    "MT-CO3 rna"
  ],
  "MT-CYB": [
    "MT-CYB rna"
  ],
  "MT-ND1": [
    "MT-ND1 proteo",
    "MT-ND1 rna"
  ],
  "MT-ND2": [
    "MT-ND2 rna"
  ],
  "MT-ND3": [
    "MT-ND3 proteo",
    "MT-ND3 rna"
  ],
  "MT-ND4": [
    "MT-ND4 proteo",
    "MT-ND4 rna"
  ],
  "MT-ND4L": [
    "MT-ND4L rna"
  ],
  "MT-ND5": [
    "MT-ND5 mut",
    "MT-ND5 proteo",
    "MT-ND5 rna"
  ],
  "MT-ND6": [
    "MT-ND6 rna"
  ],
  "MT1A": [
    "MT1A cnv",
    "MT1A methyl",
    "MT1A rna"
  ],
  "MT1B": [
    "MT1B cnv"
  ],
  "MT1E": [
    "MT1E cnv",
    "MT1E methyl",
    "MT1E proteo",
    "MT1E rna"
  ],
  "MT1F": [
    "MT1F cnv",
    "MT1F methyl",
    "MT1F proteo",
    "MT1F rna"
  ],
  "MT1G": [
    "MT1G cnv",
    "MT1G proteo",
    "MT1G rna"
  ],
  "MT1H": [
    "MT1H cnv",
    "MT1H methyl",
    "MT1H rna"
  ],
  "MT1HL1": [
    "MT1HL1 cnv"
  ],
  "MT1JP": [
    "MT1JP methyl"
  ],
  "MT1L": [
    "MT1L methyl"
  ],
  "MT1M": [
    "MT1M cnv",
    "MT1M methyl",
    "MT1M proteo",
    "MT1M rna"
  ],
  "MT1X": [
    "MT1X cnv",
    "MT1X methyl",
    "MT1X proteo",
    "MT1X rna"
  ],
  "MT2A": [
    "MT2A cnv",
    "MT2A methyl",
    "MT2A proteo",
    "MT2A rna"
  ],
  "MT3": [
    "MT3 33_36_1_0 phospho",
    "MT3 33_36_1_1_S33 phospho",
    "MT3 65_65_1_1_S65 phospho",
    "MT3 cnv",
    "MT3 methyl",
    "MT3 proteo",
    "MT3 rna"
  ],
  "MT4": [
    "MT4 cnv"
  ],
  "MTA1": [
    "MTA1 380_386_1_1_S386 phospho",
    "MTA1 446_449_1_1_S449 phospho",
    "MTA1 555_564_1_1_T564 phospho",
    "MTA1 576_578_1_1_S576 phospho",
    "MTA1 cnv",
    "MTA1 methyl",
    "MTA1 proteo",
    "MTA1 rna"
  ],
  "MTA1-DT": [
    "MTA1-DT methyl"
  ],
  "MTA2": [
    "MTA2 cnv",
    "MTA2 methyl",
    "MTA2 proteo",
    "MTA2 rna"
  ],
  "MTA3": [
    "MTA3 371_376_1_1_S373 phospho",
    "MTA3 cnv",
    "MTA3 methyl",
    "MTA3 proteo",
    "MTA3 rna"
  ],
  "MTAP": [
    "MTAP cnv",
    "MTAP methyl",
    "MTAP proteo",
    "MTAP rna"
  ],
  "MTARC1": [
    "MTARC1 cnv",
    "MTARC1 methyl",
    "MTARC1 proteo",
    "MTARC1 rna"
  ],
  "MTARC2": [
    "MTARC2 cnv",
    "MTARC2 methyl",
    "MTARC2 proteo",
    "MTARC2 rna"
  ],
  "MTBP": [
    "MTBP cnv",
    "MTBP methyl",
    "MTBP rna"
  ],
  "MTCH1": [
    "MTCH1 381_384_1_1_S382 phospho",
    "MTCH1 cnv",
    "MTCH1 methyl",
    "MTCH1 proteo",
    "MTCH1 rna"
  ],
  "MTCH2": [
    "MTCH2 cnv",
    "MTCH2 methyl",
    "MTCH2 proteo",
    "MTCH2 rna"
  ],
  "MTCL1": [
    "MTCL1 1195_1195_1_1_S1195 phospho",
    "MTCL1 1204_1217_1_1_S1204 phospho",
    "MTCL1 1337_1342_1_1_S1342 phospho",
    "MTCL1 1493_1501_2_2_S1493S1495 phospho",
    "MTCL1 258_272_1_0 phospho",
    "MTCL1 416_418_1_1_S416 phospho",
    "MTCL1 cnv",
    "MTCL1 methyl",
    "MTCL1 proteo",
    "MTCL1 rna"
  ],
  "MTCP1": [
    "MTCP1 methyl",
    "MTCP1 rna"
  ],
  "MTDH": [
    "MTDH 132_148_1_0 phospho",
    "MTDH 212_244_1_1_S216 phospho",
    "MTDH 294_311_1_1_S298 phospho",
    "MTDH 415_426_1_1_S426 phospho",
    "MTDH 457_462_1_0 phospho",
    "MTDH 562_568_1_1_S568 phospho",
    "MTDH cnv",
    "MTDH methyl",
    "MTDH proteo",
    "MTDH rna"
  ],
  "MTERF1": [
    "MTERF1 cnv",
    "MTERF1 methyl",
    "MTERF1 rna"
  ],
  "MTERF2": [
    "MTERF2 cnv",
    "MTERF2 methyl",
    "MTERF2 rna"
  ],
  "MTERF3": [
    "MTERF3 cnv",
    "MTERF3 methyl",
    "MTERF3 rna"
  ],
  "MTERF4": [
    "MTERF4 cnv",
    "MTERF4 methyl",
    "MTERF4 rna"
  ],
  "MTF1": [
    "MTF1 654_698_1_0 phospho",
    "MTF1 cnv",
    "MTF1 methyl",
    "MTF1 rna"
  ],
  "MTF2": [
    "MTF2 cnv",
    "MTF2 methyl",
    "MTF2 rna"
  ],
  "MTFMT": [
    "MTFMT cnv",
    "MTFMT methyl",
    "MTFMT proteo",
    "MTFMT rna"
  ],
  "MTFP1": [
    "MTFP1 cnv",
    "MTFP1 methyl",
    "MTFP1 rna"
  ],
  "MTFR1": [
    "MTFR1 253_257_1_1_S257 phospho",
    "MTFR1 86_91_1_1_S86 phospho",
    "MTFR1 cnv",
    "MTFR1 methyl",
    "MTFR1 proteo",
    "MTFR1 rna"
  ],
  "MTFR1L": [
    "MTFR1L 237_238_1_1_S238 phospho",
    "MTFR1L cnv",
    "MTFR1L methyl",
    "MTFR1L proteo",
    "MTFR1L rna"
  ],
  "MTFR2": [
    "MTFR2 cnv",
    "MTFR2 methyl",
    "MTFR2 rna"
  ],
  "MTG1": [
    "MTG1 cnv",
    "MTG1 methyl",
    "MTG1 proteo",
    "MTG1 rna"
  ],
  "MTG2": [
    "MTG2 cnv",
    "MTG2 methyl",
    "MTG2 proteo",
    "MTG2 rna"
  ],
  "MTHFD1": [
    "MTHFD1 cnv",
    "MTHFD1 methyl",
    "MTHFD1 proteo",
    "MTHFD1 rna"
  ],
  "MTHFD1L": [
    "MTHFD1L cnv",
    "MTHFD1L methyl",
    "MTHFD1L proteo",
    "MTHFD1L rna"
  ],
  "MTHFD2": [
    "MTHFD2 cnv",
    "MTHFD2 methyl",
    "MTHFD2 proteo",
    "MTHFD2 rna"
  ],
  "MTHFD2L": [
    "MTHFD2L cnv",
    "MTHFD2L methyl",
    "MTHFD2L proteo",
    "MTHFD2L rna"
  ],
  "MTHFR": [
    "MTHFR cnv",
    "MTHFR methyl",
    "MTHFR proteo",
    "MTHFR rna"
  ],
  "MTHFS": [
    "MTHFS cnv",
    "MTHFS methyl",
    "MTHFS proteo",
    "MTHFS rna"
  ],
  "MTHFSD": [
    "MTHFSD cnv",
    "MTHFSD methyl",
    "MTHFSD proteo",
    "MTHFSD rna"
  ],
  "MTIF2": [
    "MTIF2 cnv",
    "MTIF2 methyl",
    "MTIF2 proteo",
    "MTIF2 rna"
  ],
  "MTIF3": [
    "MTIF3 cnv",
    "MTIF3 methyl",
    "MTIF3 proteo",
    "MTIF3 rna"
  ],
  "MTLN": [
    "MTLN cnv",
    "MTLN methyl",
    "MTLN rna"
  ],
  "MTM1": [
    "MTM1 583_601_1_0 phospho",
    "MTM1 583_601_1_1_S588 phospho",
    "MTM1 583_601_1_1_S591 phospho",
    "MTM1 9_18_1_1_S13 phospho",
    "MTM1 9_18_1_1_S18 phospho",
    "MTM1 methyl",
    "MTM1 proteo",
    "MTM1 rna"
  ],
  "MTMR1": [
    "MTMR1 36_53_1_1_S43 phospho",
    "MTMR1 660_672_1_1_S661 phospho",
    "MTMR1 methyl",
    "MTMR1 proteo",
    "MTMR1 rna"
  ],
  "MTMR10": [
    "MTMR10 561_569_1_1_S569 phospho",
    "MTMR10 607_607_1_1_S607 phospho",
    "MTMR10 751_758_1_1_S751 phospho",
    "MTMR10 769_772_1_0 phospho",
    "MTMR10 cnv",
    "MTMR10 methyl",
    "MTMR10 proteo",
    "MTMR10 rna"
  ],
  "MTMR11": [
    "MTMR11 cnv",
    "MTMR11 proteo",
    "MTMR11 rna"
  ],
  "MTMR12": [
    "MTMR12 564_570_1_1_S564 phospho",
    "MTMR12 715_723_1_1_S716 phospho",
    "MTMR12 cnv",
    "MTMR12 methyl",
    "MTMR12 proteo",
    "MTMR12 rna"
  ],
  "MTMR14": [
    "MTMR14 cnv",
    "MTMR14 proteo",
    "MTMR14 rna"
  ],
  "MTMR2": [
    "MTMR2 41_58_1_1_S58 phospho",
    "MTMR2 630_641_1_1_S631 phospho",
    "MTMR2 cnv",
    "MTMR2 methyl",
    "MTMR2 proteo",
    "MTMR2 rna"
  ],
  "MTMR3": [
    "MTMR3 1173_1197_1_1_S1184 phospho",
    "MTMR3 611_629_1_1_S613 phospho",
    "MTMR3 613_629_1_1_S613 phospho",
    "MTMR3 633_636_1_1_S633 phospho",
    "MTMR3 731_735_1_1_T731 phospho",
    "MTMR3 cnv",
    "MTMR3 methyl",
    "MTMR3 proteo",
    "MTMR3 rna"
  ],
  "MTMR4": [
    "MTMR4 627_629_1_1_S629 phospho",
    "MTMR4 cnv",
    "MTMR4 methyl",
    "MTMR4 rna"
  ],
  "MTMR6": [
    "MTMR6 cnv",
    "MTMR6 methyl",
    "MTMR6 proteo",
    "MTMR6 rna"
  ],
  "MTMR7": [
    "MTMR7 cnv",
    "MTMR7 methyl",
    "MTMR7 proteo",
    "MTMR7 rna"
  ],
  "MTMR8": [
    "MTMR8 methyl",
    "MTMR8 rna"
  ],
  "MTMR9": [
    "MTMR9 541_548_1_0 phospho",
    "MTMR9 541_548_1_1_S548 phospho",
    "MTMR9 cnv",
    "MTMR9 methyl",
    "MTMR9 proteo",
    "MTMR9 rna"
  ],
  "MTNR1A": [
    "MTNR1A cnv",
    "MTNR1A methyl",
    "MTNR1A rna"
  ],
  "MTNR1B": [
    "MTNR1B cnv",
    "MTNR1B methyl",
    "MTNR1B rna"
  ],
  "MTO1": [
    "MTO1 cnv",
    "MTO1 methyl",
    "MTO1 proteo",
    "MTO1 rna"
  ],
  "MTOR": [
    "MTOR 1261_1262_1_0 phospho",
    "MTOR 2471_2481_1_1_S2478 phospho",
    "MTOR cnv",
    "MTOR kinase",
    "MTOR methyl",
    "MTOR proteo",
    "MTOR rna"
  ],
  "MTPAP": [
    "MTPAP cnv",
    "MTPAP methyl",
    "MTPAP proteo",
    "MTPAP rna"
  ],
  "MTPN": [
    "MTPN 31_31_1_1_T31 phospho",
    "MTPN cnv",
    "MTPN methyl",
    "MTPN proteo",
    "MTPN rna"
  ],
  "MTR": [
    "MTR cnv",
    "MTR methyl",
    "MTR proteo",
    "MTR rna"
  ],
  "MTRES1": [
    "MTRES1 106_127_1_1_S106 phospho",
    "MTRES1 cnv",
    "MTRES1 methyl",
    "MTRES1 proteo",
    "MTRES1 rna"
  ],
  "MTREX": [
    "MTREX cnv",
    "MTREX methyl",
    "MTREX proteo",
    "MTREX rna"
  ],
  "MTRF1": [
    "MTRF1 cnv",
    "MTRF1 proteo",
    "MTRF1 rna"
  ],
  "MTRF1L": [
    "MTRF1L cnv",
    "MTRF1L methyl",
    "MTRF1L proteo",
    "MTRF1L rna"
  ],
  "MTRFR": [
    "MTRFR cnv",
    "MTRFR methyl",
    "MTRFR rna"
  ],
  "MTRNR2L1": [
    "MTRNR2L1 cnv",
    "MTRNR2L1 rna"
  ],
  "MTRNR2L11": [
    "MTRNR2L11 cnv"
  ],
  "MTRNR2L12": [
    "MTRNR2L12 cnv",
    "MTRNR2L12 rna"
  ],
  "MTRNR2L13": [
    "MTRNR2L13 cnv"
  ],
  "MTRNR2L3": [
    "MTRNR2L3 cnv"
  ],
  "MTRNR2L4": [
    "MTRNR2L4 cnv",
    "MTRNR2L4 rna"
  ],
  "MTRNR2L5": [
    "MTRNR2L5 cnv"
  ],
  "MTRNR2L6": [
    "MTRNR2L6 cnv"
  ],
  "MTRNR2L7": [
    "MTRNR2L7 cnv"
  ],
  "MTRNR2L8": [
    "MTRNR2L8 cnv",
    "MTRNR2L8 rna"
  ],
  "MTRR": [
    "MTRR cnv",
    "MTRR methyl",
    "MTRR proteo",
    "MTRR rna"
  ],
  "MTSS1": [
    "MTSS1 275_289_1_1_S276 phospho",
    "MTSS1 573_592_1_0 phospho",
    "MTSS1 607_607_1_1_T607 phospho",
    "MTSS1 cnv",
    "MTSS1 methyl",
    "MTSS1 proteo",
    "MTSS1 rna"
  ],
  "MTSS2": [
    "MTSS2 252_270_1_0 phospho",
    "MTSS2 252_270_1_1_S264 phospho",
    "MTSS2 252_270_1_1_T260 phospho",
    "MTSS2 252_270_2_1_T260 phospho",
    "MTSS2 252_270_2_2_T260S264 phospho",
    "MTSS2 273_284_1_0 phospho",
    "MTSS2 273_284_1_1_S274 phospho",
    "MTSS2 298_304_1_1_S300 phospho",
    "MTSS2 321_350_1_1_S342 phospho",
    "MTSS2 353_379_1_1_S373 phospho",
    "MTSS2 383_391_1_1_T391 phospho",
    "MTSS2 428_431_1_1_S428 phospho",
    "MTSS2 538_563_1_0 phospho",
    "MTSS2 538_563_1_1_S538 phospho",
    "MTSS2 579_580_1_1_S579 phospho",
    "MTSS2 612_624_1_1_S612 phospho",
    "MTSS2 612_624_1_1_S624 phospho",
    "MTSS2 612_634_1_1_S634 phospho",
    "MTSS2 612_634_2_2_S612S634 phospho",
    "MTSS2 639_655_1_1_S639 phospho",
    "MTSS2 639_673_1_1_S673 phospho",
    "MTSS2 639_673_2_2_S639S673 phospho",
    "MTSS2 cnv",
    "MTSS2 methyl",
    "MTSS2 proteo",
    "MTSS2 rna"
  ],
  "MTTP": [
    "MTTP cnv",
    "MTTP methyl",
    "MTTP proteo",
    "MTTP rna"
  ],
  "MTURN": [
    "MTURN cnv",
    "MTURN methyl",
    "MTURN proteo",
    "MTURN rna"
  ],
  "MTUS1": [
    "MTUS1 1203_1212_1_1_S1203 phospho",
    "MTUS1 cnv",
    "MTUS1 methyl",
    "MTUS1 rna"
  ],
  "MTUS2": [
    "MTUS2 cnv",
    "MTUS2 methyl",
    "MTUS2 proteo",
    "MTUS2 rna"
  ],
  "MTX1": [
    "MTX1 cnv",
    "MTX1 methyl",
    "MTX1 proteo",
    "MTX1 rna"
  ],
  "MTX2": [
    "MTX2 cnv",
    "MTX2 methyl",
    "MTX2 proteo",
    "MTX2 rna"
  ],
  "MTX3": [
    "MTX3 183_194_1_1_S188 phospho",
    "MTX3 cnv",
    "MTX3 methyl",
    "MTX3 proteo",
    "MTX3 rna"
  ],
  "MUC1": [
    "MUC1 cnv",
    "MUC1 methyl",
    "MUC1 rna"
  ],
  "MUC12": [
    "MUC12 cnv",
    "MUC12 rna"
  ],
  "MUC13": [
    "MUC13 cnv",
    "MUC13 rna"
  ],
  "MUC15": [
    "MUC15 cnv",
    "MUC15 rna"
  ],
  "MUC16": [
    "MUC16 cnv",
    "MUC16 mut",
    "MUC16 rna"
  ],
  "MUC17": [
    "MUC17 cnv",
    "MUC17 mut",
    "MUC17 rna"
  ],
  "MUC19": [
    "MUC19 cnv",
    "MUC19 rna"
  ],
  "MUC2": [
    "MUC2 cnv",
    "MUC2 rna"
  ],
  "MUC20": [
    "MUC20 cnv",
    "MUC20 rna"
  ],
  "MUC21": [
    "MUC21 cnv",
    "MUC21 rna"
  ],
  "MUC22": [
    "MUC22 cnv",
    "MUC22 rna"
  ],
  "MUC3A": [
    "MUC3A cnv",
    "MUC3A rna"
  ],
  "MUC4": [
    "MUC4 cnv",
    "MUC4 rna"
  ],
  "MUC5AC": [
    "MUC5AC cnv"
  ],
  "MUC5B": [
    "MUC5B cnv",
    "MUC5B rna"
  ],
  "MUC6": [
    "MUC6 cnv",
    "MUC6 methyl",
    "MUC6 rna"
  ],
  "MUC7": [
    "MUC7 cnv",
    "MUC7 rna"
  ],
  "MUCL1": [
    "MUCL1 cnv",
    "MUCL1 rna"
  ],
  "MUCL3": [
    "MUCL3 cnv",
    "MUCL3 rna"
  ],
  "MUL1": [
    "MUL1 cnv",
    "MUL1 methyl",
    "MUL1 proteo",
    "MUL1 rna"
  ],
  "MUS81": [
    "MUS81 86_101_1_1_S95 phospho",
    "MUS81 cnv",
    "MUS81 methyl",
    "MUS81 rna"
  ],
  "MUSK": [
    "MUSK cnv",
    "MUSK kinase",
    "MUSK rna"
  ],
  "MUSTN1": [
    "MUSTN1 cnv",
    "MUSTN1 proteo",
    "MUSTN1 rna"
  ],
  "MUTYH": [
    "MUTYH cnv",
    "MUTYH methyl",
    "MUTYH rna"
  ],
  "MVB12A": [
    "MVB12A 110_129_1_0 phospho",
    "MVB12A 110_129_1_1_S110 phospho",
    "MVB12A 138_151_1_1_S140 phospho",
    "MVB12A 78_86_1_1_S78 phospho",
    "MVB12A cnv",
    "MVB12A methyl",
    "MVB12A proteo",
    "MVB12A rna"
  ],
  "MVB12B": [
    "MVB12B cnv",
    "MVB12B methyl",
    "MVB12B proteo",
    "MVB12B rna"
  ],
  "MVD": [
    "MVD 96_107_1_1_S96 phospho",
    "MVD cnv",
    "MVD methyl",
    "MVD proteo",
    "MVD rna"
  ],
  "MVK": [
    "MVK cnv",
    "MVK methyl",
    "MVK proteo",
    "MVK rna"
  ],
  "MVP": [
    "MVP 804_816_1_0 phospho",
    "MVP 804_816_1_1_S813 phospho",
    "MVP cnv",
    "MVP proteo",
    "MVP rna"
  ],
  "MX1": [
    "MX1 cnv",
    "MX1 methyl",
    "MX1 proteo",
    "MX1 rna"
  ],
  "MX2": [
    "MX2 cnv",
    "MX2 proteo",
    "MX2 rna"
  ],
  "MXD1": [
    "MXD1 cnv",
    "MXD1 methyl",
    "MXD1 rna"
  ],
  "MXD3": [
    "MXD3 cnv",
    "MXD3 methyl",
    "MXD3 rna"
  ],
  "MXD4": [
    "MXD4 cnv",
    "MXD4 methyl",
    "MXD4 proteo",
    "MXD4 rna"
  ],
  "MXI1": [
    "MXI1 cnv",
    "MXI1 methyl",
    "MXI1 rna"
  ],
  "MXRA5": [
    "MXRA5 ITVHGNGSLDIR-N2H5F0S0G0 glyco",
    "MXRA5 VFANGTLVVK-N2H5F0S0G0 glyco",
    "MXRA5 VFANGTLVVK-N2H6F0S0G0 glyco",
    "MXRA5 VFANGTLVVK-N2H7F0S0G0 glyco",
    "MXRA5 VSLLDNGTLTVR-N2H5F0S0G0 glyco",
    "MXRA5 methyl",
    "MXRA5 proteo",
    "MXRA5 rna"
  ],
  "MXRA7": [
    "MXRA7 127_144_1_0 phospho",
    "MXRA7 127_144_1_1_S144 phospho",
    "MXRA7 cnv",
    "MXRA7 methyl",
    "MXRA7 proteo",
    "MXRA7 rna"
  ],
  "MXRA8": [
    "MXRA8 cnv",
    "MXRA8 methyl",
    "MXRA8 proteo",
    "MXRA8 rna"
  ],
  "MYADM": [
    "MYADM 8_28_1_1_S22 phospho",
    "MYADM cnv",
    "MYADM methyl",
    "MYADM proteo",
    "MYADM rna"
  ],
  "MYADML2": [
    "MYADML2 cnv",
    "MYADML2 rna"
  ],
  "MYB": [
    "MYB cnv",
    "MYB methyl",
    "MYB rna"
  ],
  "MYBBP1A": [
    "MYBBP1A 1159_1166_1_1_S1163 phospho",
    "MYBBP1A 1259_1269_1_1_S1267 phospho",
    "MYBBP1A cnv",
    "MYBBP1A methyl",
    "MYBBP1A proteo",
    "MYBBP1A rna"
  ],
  "MYBL1": [
    "MYBL1 cnv",
    "MYBL1 methyl",
    "MYBL1 rna"
  ],
  "MYBL2": [
    "MYBL2 cnv",
    "MYBL2 methyl",
    "MYBL2 rna"
  ],
  "MYBPC1": [
    "MYBPC1 cnv",
    "MYBPC1 rna"
  ],
  "MYBPC2": [
    "MYBPC2 cnv",
    "MYBPC2 methyl",
    "MYBPC2 rna"
  ],
  "MYBPC3": [
    "MYBPC3 cnv",
    "MYBPC3 rna"
  ],
  "MYBPH": [
    "MYBPH cnv",
    "MYBPH rna"
  ],
  "MYBPHL": [
    "MYBPHL cnv",
    "MYBPHL rna"
  ],
  "MYC": [
    "MYC cnv",
    "MYC methyl",
    "MYC rna"
  ],
  "MYCBP": [
    "MYCBP cnv",
    "MYCBP methyl",
    "MYCBP proteo",
    "MYCBP rna"
  ],
  "MYCBP2": [
    "MYCBP2 1624_1630_1_0 phospho",
    "MYCBP2 2787_2797_1_1_S2789 phospho",
    "MYCBP2 3424_3448_1_0 phospho",
    "MYCBP2 3476_3484_1_1_S3478 phospho",
    "MYCBP2 3505_3513_1_1_S3505 phospho",
    "MYCBP2 3915_3921_1_1_T3921 phospho",
    "MYCBP2 3931_3932_1_1_S3932 phospho",
    "MYCBP2 cnv",
    "MYCBP2 methyl",
    "MYCBP2 proteo",
    "MYCBP2 rna"
  ],
  "MYCBP2-AS1": [
    "MYCBP2-AS1 methyl"
  ],
  "MYCBPAP": [
    "MYCBPAP cnv",
    "MYCBPAP methyl",
    "MYCBPAP proteo",
    "MYCBPAP rna"
  ],
  "MYCL": [
    "MYCL cnv",
    "MYCL methyl",
    "MYCL rna"
  ],
  "MYCN": [
    "MYCN 142_156_1_1_S156 phospho",
    "MYCN cnv",
    "MYCN methyl",
    "MYCN rna"
  ],
  "MYCNOS": [
    "MYCNOS methyl"
  ],
  "MYCT1": [
    "MYCT1 cnv",
    "MYCT1 rna"
  ],
  "MYD88": [
    "MYD88 cnv",
    "MYD88 methyl",
    "MYD88 proteo",
    "MYD88 rna"
  ],
  "MYDGF": [
    "MYDGF cnv",
    "MYDGF methyl",
    "MYDGF proteo",
    "MYDGF rna"
  ],
  "MYEF2": [
    "MYEF2 13_17_1_1_S17 phospho",
    "MYEF2 46_49_1_0 phospho",
    "MYEF2 cnv",
    "MYEF2 methyl",
    "MYEF2 proteo",
    "MYEF2 rna"
  ],
  "MYEOV": [
    "MYEOV cnv",
    "MYEOV rna"
  ],
  "MYF5": [
    "MYF5 cnv",
    "MYF5 methyl"
  ],
  "MYF6": [
    "MYF6 cnv",
    "MYF6 rna"
  ],
  "MYG1": [
    "MYG1 cnv",
    "MYG1 methyl",
    "MYG1 proteo",
    "MYG1 rna"
  ],
  "MYH1": [
    "MYH1 cnv",
    "MYH1 rna"
  ],
  "MYH10": [
    "MYH10 1983_1993_1_1_S1983 phospho",
    "MYH10 1983_1993_1_1_S1987 phospho",
    "MYH10 1983_1993_2_2_S1983S1987 phospho",
    "MYH10 1995_2006_1_1_S2006 phospho",
    "MYH10 213_213_1_1_S213 phospho",
    "MYH10 214_214_1_1_S214 phospho",
    "MYH10 cnv",
    "MYH10 methyl",
    "MYH10 proteo",
    "MYH10 rna"
  ],
  "MYH11": [
    "MYH11 1961_1967_1_1_S1961 phospho",
    "MYH11 1961_1975_1_1_S1961 phospho",
    "MYH11 cnv",
    "MYH11 methyl",
    "MYH11 proteo",
    "MYH11 rna"
  ],
  "MYH13": [
    "MYH13 cnv",
    "MYH13 rna"
  ],
  "MYH14": [
    "MYH14 1037_1038_1_0 phospho",
    "MYH14 cnv",
    "MYH14 methyl",
    "MYH14 proteo",
    "MYH14 rna"
  ],
  "MYH15": [
    "MYH15 cnv",
    "MYH15 rna"
  ],
  "MYH2": [
    "MYH2 cnv",
    "MYH2 rna"
  ],
  "MYH3": [
    "MYH3 cnv",
    "MYH3 rna"
  ],
  "MYH4": [
    "MYH4 cnv",
    "MYH4 rna"
  ],
  "MYH6": [
    "MYH6 cnv",
    "MYH6 rna"
  ],
  "MYH7": [
    "MYH7 cnv",
    "MYH7 rna"
  ],
  "MYH7B": [
    "MYH7B cnv",
    "MYH7B methyl",
    "MYH7B rna"
  ],
  "MYH8": [
    "MYH8 cnv"
  ],
  "MYH9": [
    "MYH9 1943_1943_1_1_S1943 phospho",
    "MYH9 cnv",
    "MYH9 methyl",
    "MYH9 proteo",
    "MYH9 rna"
  ],
  "MYL1": [
    "MYL1 cnv",
    "MYL1 rna"
  ],
  "MYL10": [
    "MYL10 cnv",
    "MYL10 rna"
  ],
  "MYL11": [
    "MYL11 cnv",
    "MYL11 methyl",
    "MYL11 proteo",
    "MYL11 rna"
  ],
  "MYL12-AS1": [
    "MYL12-AS1 methyl"
  ],
  "MYL12A": [
    "MYL12A cnv",
    "MYL12A methyl",
    "MYL12A rna"
  ],
  "MYL12B": [
    "MYL12B cnv",
    "MYL12B methyl",
    "MYL12B rna"
  ],
  "MYL2": [
    "MYL2 cnv",
    "MYL2 rna"
  ],
  "MYL3": [
    "MYL3 cnv",
    "MYL3 methyl",
    "MYL3 rna"
  ],
  "MYL4": [
    "MYL4 cnv",
    "MYL4 proteo",
    "MYL4 rna"
  ],
  "MYL5": [
    "MYL5 cnv",
    "MYL5 methyl",
    "MYL5 rna"
  ],
  "MYL6": [
    "MYL6 cnv",
    "MYL6 proteo",
    "MYL6 rna"
  ],
  "MYL6B": [
    "MYL6B cnv",
    "MYL6B proteo",
    "MYL6B rna"
  ],
  "MYL7": [
    "MYL7 cnv",
    "MYL7 rna"
  ],
  "MYL9": [
    "MYL9 cnv",
    "MYL9 methyl",
    "MYL9 proteo",
    "MYL9 rna"
  ],
  "MYLIP": [
    "MYLIP cnv",
    "MYLIP methyl",
    "MYLIP rna"
  ],
  "MYLK": [
    "MYLK 1262_1273_1_1_S1262 phospho",
    "MYLK 129_136_1_1_S129 phospho",
    "MYLK 1583_1592_1_1_S1584 phospho",
    "MYLK 1596_1603_1_0 phospho",
    "MYLK 1596_1603_1_1_S1597 phospho",
    "MYLK 1596_1603_1_1_S1600 phospho",
    "MYLK 1596_1603_1_1_S1603 phospho",
    "MYLK 771_771_1_1_S771 phospho",
    "MYLK cnv",
    "MYLK kinase",
    "MYLK methyl",
    "MYLK proteo",
    "MYLK rna"
  ],
  "MYLK-AS1": [
    "MYLK-AS1 methyl"
  ],
  "MYLK2": [
    "MYLK2 cnv",
    "MYLK2 kinase",
    "MYLK2 rna"
  ],
  "MYLK3": [
    "MYLK3 cnv",
    "MYLK3 kinase",
    "MYLK3 rna"
  ],
  "MYLK4": [
    "MYLK4 cnv",
    "MYLK4 kinase",
    "MYLK4 methyl",
    "MYLK4 rna"
  ],
  "MYMK": [
    "MYMK cnv",
    "MYMK rna"
  ],
  "MYMX": [
    "MYMX cnv",
    "MYMX rna"
  ],
  "MYNN": [
    "MYNN cnv",
    "MYNN methyl",
    "MYNN rna"
  ],
  "MYO10": [
    "MYO10 1882_1888_1_1_S1883 phospho",
    "MYO10 cnv",
    "MYO10 methyl",
    "MYO10 proteo",
    "MYO10 rna"
  ],
  "MYO15A": [
    "MYO15A cnv",
    "MYO15A rna"
  ],
  "MYO15B": [
    "MYO15B cnv",
    "MYO15B methyl",
    "MYO15B rna"
  ],
  "MYO16": [
    "MYO16 cnv",
    "MYO16 mut",
    "MYO16 rna"
  ],
  "MYO18A": [
    "MYO18A 1067_1076_1_1_S1067 phospho",
    "MYO18A 1970_1974_2_2_S1970S1974 phospho",
    "MYO18A 2014_2031_1_1_S2020 phospho",
    "MYO18A 2035_2045_1_1_S2041 phospho",
    "MYO18A 2035_2045_1_1_S2043 phospho",
    "MYO18A 2035_2045_2_2_S2041S2043 phospho",
    "MYO18A 2035_2052_1_1_S2043 phospho",
    "MYO18A 2035_2052_2_2_S2041S2043 phospho",
    "MYO18A 726_742_1_1_S728 phospho",
    "MYO18A 980_995_1_1_S987 phospho",
    "MYO18A cnv",
    "MYO18A methyl",
    "MYO18A proteo",
    "MYO18A rna"
  ],
  "MYO18B": [
    "MYO18B cnv",
    "MYO18B rna"
  ],
  "MYO19": [
    "MYO19 cnv",
    "MYO19 methyl",
    "MYO19 proteo",
    "MYO19 rna"
  ],
  "MYO1A": [
    "MYO1A cnv",
    "MYO1A rna"
  ],
  "MYO1B": [
    "MYO1B cnv",
    "MYO1B methyl",
    "MYO1B proteo",
    "MYO1B rna"
  ],
  "MYO1C": [
    "MYO1C cnv",
    "MYO1C methyl",
    "MYO1C proteo",
    "MYO1C rna"
  ],
  "MYO1D": [
    "MYO1D cnv",
    "MYO1D methyl",
    "MYO1D proteo",
    "MYO1D rna"
  ],
  "MYO1E": [
    "MYO1E 1002_1014_1_1_S1002 phospho",
    "MYO1E 1002_1014_2_0 phospho",
    "MYO1E cnv",
    "MYO1E methyl",
    "MYO1E proteo",
    "MYO1E rna"
  ],
  "MYO1F": [
    "MYO1F 1019_1019_1_1_S1019 phospho",
    "MYO1F 997_1001_1_1_S997 phospho",
    "MYO1F cnv",
    "MYO1F methyl",
    "MYO1F proteo",
    "MYO1F rna"
  ],
  "MYO1G": [
    "MYO1G cnv",
    "MYO1G proteo",
    "MYO1G rna"
  ],
  "MYO1H": [
    "MYO1H cnv",
    "MYO1H rna"
  ],
  "MYO3A": [
    "MYO3A cnv",
    "MYO3A kinase",
    "MYO3A methyl",
    "MYO3A rna"
  ],
  "MYO3B": [
    "MYO3B cnv",
    "MYO3B kinase",
    "MYO3B rna"
  ],
  "MYO5A": [
    "MYO5A 1113_1144_1_0 phospho",
    "MYO5A 1452_1452_1_1_S1452 phospho",
    "MYO5A 600_607_1_1_S600 phospho",
    "MYO5A cnv",
    "MYO5A methyl",
    "MYO5A proteo",
    "MYO5A rna"
  ],
  "MYO5B": [
    "MYO5B cnv",
    "MYO5B methyl",
    "MYO5B proteo",
    "MYO5B rna"
  ],
  "MYO5C": [
    "MYO5C cnv",
    "MYO5C methyl",
    "MYO5C proteo",
    "MYO5C rna"
  ],
  "MYO6": [
    "MYO6 cnv",
    "MYO6 methyl",
    "MYO6 proteo",
    "MYO6 rna"
  ],
  "MYO7A": [
    "MYO7A cnv",
    "MYO7A methyl",
    "MYO7A proteo",
    "MYO7A rna"
  ],
  "MYO7B": [
    "MYO7B cnv",
    "MYO7B rna"
  ],
  "MYO9A": [
    "MYO9A 1258_1258_1_1_S1258 phospho",
    "MYO9A 1731_1738_1_1_S1733 phospho",
    "MYO9A cnv",
    "MYO9A methyl",
    "MYO9A proteo",
    "MYO9A rna"
  ],
  "MYO9B": [
    "MYO9B 1043_1049_1_1_S1043 phospho",
    "MYO9B 1109_1115_1_1_S1115 phospho",
    "MYO9B 1109_1122_1_1_S1115 phospho",
    "MYO9B 1261_1271_2_2_S1267T1271 phospho",
    "MYO9B 1290_1295_1_1_S1290 phospho",
    "MYO9B 1323_1335_1_1_S1331 phospho",
    "MYO9B 1341_1348_1_1_T1346 phospho",
    "MYO9B 1353_1361_1_1_T1353 phospho",
    "MYO9B 1397_1412_1_1_S1405 phospho",
    "MYO9B 1992_2007_1_1_S1992 phospho",
    "MYO9B 2140_2155_1_0 phospho",
    "MYO9B 2140_2155_1_1_S2141 phospho",
    "MYO9B 716_722_1_0 phospho",
    "MYO9B 716_722_1_1_S717 phospho",
    "MYO9B cnv",
    "MYO9B methyl",
    "MYO9B proteo",
    "MYO9B rna"
  ],
  "MYOC": [
    "MYOC cnv",
    "MYOC proteo",
    "MYOC rna"
  ],
  "MYOCD": [
    "MYOCD cnv",
    "MYOCD methyl",
    "MYOCD rna"
  ],
  "MYOCOS": [
    "MYOCOS cnv",
    "MYOCOS rna"
  ],
  "MYOD1": [
    "MYOD1 cnv",
    "MYOD1 methyl",
    "MYOD1 rna"
  ],
  "MYOF": [
    "MYOF cnv",
    "MYOF proteo",
    "MYOF rna"
  ],
  "MYOG": [
    "MYOG cnv",
    "MYOG rna"
  ],
  "MYOM1": [
    "MYOM1 cnv",
    "MYOM1 rna"
  ],
  "MYOM2": [
    "MYOM2 cnv",
    "MYOM2 methyl",
    "MYOM2 rna"
  ],
  "MYOM3": [
    "MYOM3 cnv",
    "MYOM3 rna"
  ],
  "MYORG": [
    "MYORG cnv",
    "MYORG methyl",
    "MYORG proteo",
    "MYORG rna"
  ],
  "MYOT": [
    "MYOT cnv",
    "MYOT rna"
  ],
  "MYOZ1": [
    "MYOZ1 cnv",
    "MYOZ1 rna"
  ],
  "MYOZ2": [
    "MYOZ2 cnv",
    "MYOZ2 rna"
  ],
  "MYOZ3": [
    "MYOZ3 cnv",
    "MYOZ3 methyl",
    "MYOZ3 rna"
  ],
  "MYPN": [
    "MYPN cnv",
    "MYPN rna"
  ],
  "MYPOP": [
    "MYPOP 202_206_1_1_S202 phospho",
    "MYPOP cnv",
    "MYPOP methyl",
    "MYPOP rna"
  ],
  "MYRF": [
    "MYRF cnv",
    "MYRF methyl",
    "MYRF rna"
  ],
  "MYRFL": [
    "MYRFL cnv",
    "MYRFL rna"
  ],
  "MYRIP": [
    "MYRIP 534_545_1_1_S543 phospho",
    "MYRIP cnv",
    "MYRIP methyl",
    "MYRIP rna"
  ],
  "MYSM1": [
    "MYSM1 340_340_1_1_S340 phospho",
    "MYSM1 cnv",
    "MYSM1 rna"
  ],
  "MYT1": [
    "MYT1 333_341_1_1_S333 phospho",
    "MYT1 606_610_1_1_S610 phospho",
    "MYT1 cnv",
    "MYT1 methyl",
    "MYT1 rna"
  ],
  "MYT1L": [
    "MYT1L cnv",
    "MYT1L methyl",
    "MYT1L rna"
  ],
  "MYZAP": [
    "MYZAP cnv",
    "MYZAP methyl",
    "MYZAP rna"
  ],
  "MZB1": [
    "MZB1 cnv",
    "MZB1 proteo",
    "MZB1 rna"
  ],
  "MZF1": [
    "MZF1 cnv",
    "MZF1 methyl",
    "MZF1 rna"
  ],
  "MZF1-AS1": [
    "MZF1-AS1 methyl"
  ],
  "MZT1": [
    "MZT1 cnv",
    "MZT1 methyl",
    "MZT1 proteo",
    "MZT1 rna"
  ],
  "MZT2A": [
    "MZT2A 152_158_1_0 phospho",
    "MZT2A cnv",
    "MZT2A methyl",
    "MZT2A rna"
  ],
  "MZT2B": [
    "MZT2B cnv",
    "MZT2B methyl",
    "MZT2B rna"
  ],
  "N4BP1": [
    "N4BP1 cnv",
    "N4BP1 proteo",
    "N4BP1 rna"
  ],
  "N4BP2": [
    "N4BP2 cnv",
    "N4BP2 methyl",
    "N4BP2 proteo",
    "N4BP2 rna"
  ],
  "N4BP2L1": [
    "N4BP2L1 cnv",
    "N4BP2L1 rna"
  ],
  "N4BP2L2": [
    "N4BP2L2 cnv",
    "N4BP2L2 proteo",
    "N4BP2L2 rna"
  ],
  "N4BP3": [
    "N4BP3 cnv",
    "N4BP3 methyl",
    "N4BP3 rna"
  ],
  "N6AMT1": [
    "N6AMT1 cnv",
    "N6AMT1 proteo",
    "N6AMT1 rna"
  ],
  "NAA10": [
    "NAA10 186_190_1_1_S186 phospho",
    "NAA10 205_209_1_1_S205 phospho",
    "NAA10 methyl",
    "NAA10 proteo",
    "NAA10 rna"
  ],
  "NAA11": [
    "NAA11 cnv",
    "NAA11 proteo",
    "NAA11 rna"
  ],
  "NAA15": [
    "NAA15 cnv",
    "NAA15 methyl",
    "NAA15 proteo",
    "NAA15 rna"
  ],
  "NAA16": [
    "NAA16 cnv",
    "NAA16 methyl",
    "NAA16 proteo",
    "NAA16 rna"
  ],
  "NAA20": [
    "NAA20 cnv",
    "NAA20 methyl",
    "NAA20 proteo",
    "NAA20 rna"
  ],
  "NAA25": [
    "NAA25 cnv",
    "NAA25 methyl",
    "NAA25 proteo",
    "NAA25 rna"
  ],
  "NAA30": [
    "NAA30 148_160_1_1_S152 phospho",
    "NAA30 188_201_1_1_S199 phospho",
    "NAA30 39_53_1_1_S39 phospho",
    "NAA30 55_63_1_1_S55 phospho",
    "NAA30 89_89_1_1_S89 phospho",
    "NAA30 cnv",
    "NAA30 methyl",
    "NAA30 proteo",
    "NAA30 rna"
  ],
  "NAA35": [
    "NAA35 cnv",
    "NAA35 methyl",
    "NAA35 proteo",
    "NAA35 rna"
  ],
  "NAA38": [
    "NAA38 cnv",
    "NAA38 methyl",
    "NAA38 proteo",
    "NAA38 rna"
  ],
  "NAA40": [
    "NAA40 cnv",
    "NAA40 methyl",
    "NAA40 proteo",
    "NAA40 rna"
  ],
  "NAA50": [
    "NAA50 cnv",
    "NAA50 methyl",
    "NAA50 proteo",
    "NAA50 rna"
  ],
  "NAA60": [
    "NAA60 cnv",
    "NAA60 methyl",
    "NAA60 rna"
  ],
  "NAA80": [
    "NAA80 cnv",
    "NAA80 methyl",
    "NAA80 proteo",
    "NAA80 rna"
  ],
  "NAAA": [
    "NAAA FNVSLDSVPELR-N2H6F0S0G0 glyco",
    "NAAA FNVSLDSVPELR-N2H7F0S0G0 glyco",
    "NAAA cnv",
    "NAAA methyl",
    "NAAA proteo",
    "NAAA rna"
  ],
  "NAALAD2": [
    "NAALAD2 cnv",
    "NAALAD2 rna"
  ],
  "NAALADL1": [
    "NAALADL1 cnv",
    "NAALADL1 methyl",
    "NAALADL1 rna"
  ],
  "NAALADL2": [
    "NAALADL2 cnv",
    "NAALADL2 methyl",
    "NAALADL2 rna"
  ],
  "NAB1": [
    "NAB1 402_416_1_1_S403 phospho",
    "NAB1 402_416_2_2_S403S407 phospho",
    "NAB1 cnv",
    "NAB1 methyl",
    "NAB1 proteo",
    "NAB1 rna"
  ],
  "NAB2": [
    "NAB2 140_147_1_0 phospho",
    "NAB2 140_147_1_1_S140 phospho",
    "NAB2 140_147_1_1_S147 phospho",
    "NAB2 162_171_1_1_S171 phospho",
    "NAB2 6_18_1_1_S6 phospho",
    "NAB2 cnv",
    "NAB2 methyl",
    "NAB2 proteo",
    "NAB2 rna"
  ],
  "NABP1": [
    "NABP1 cnv",
    "NABP1 methyl",
    "NABP1 rna"
  ],
  "NABP2": [
    "NABP2 cnv",
    "NABP2 methyl",
    "NABP2 proteo",
    "NABP2 rna"
  ],
  "NACA": [
    "NACA 151_174_1_0 phospho",
    "NACA cnv",
    "NACA methyl",
    "NACA proteo",
    "NACA rna"
  ],
  "NACA2": [
    "NACA2 cnv",
    "NACA2 rna"
  ],
  "NACAD": [
    "NACAD 1060_1068_1_1_S1068 phospho",
    "NACAD 125_131_1_1_S131 phospho",
    "NACAD 1298_1307_1_1_S1300 phospho",
    "NACAD 1298_1307_1_1_S1303 phospho",
    "NACAD 1298_1307_1_1_S1307 phospho",
    "NACAD cnv",
    "NACAD methyl",
    "NACAD proteo",
    "NACAD rna"
  ],
  "NACC1": [
    "NACC1 cnv",
    "NACC1 methyl",
    "NACC1 proteo",
    "NACC1 rna"
  ],
  "NACC2": [
    "NACC2 cnv",
    "NACC2 methyl",
    "NACC2 proteo",
    "NACC2 rna"
  ],
  "NADK": [
    "NADK 46_56_1_1_S46 phospho",
    "NADK 46_56_1_1_S48 phospho",
    "NADK cnv",
    "NADK methyl",
    "NADK proteo",
    "NADK rna"
  ],
  "NADK2": [
    "NADK2 183_188_1_1_S188 phospho",
    "NADK2 357_367_1_1_S367 phospho",
    "NADK2 cnv",
    "NADK2 methyl",
    "NADK2 proteo",
    "NADK2 rna"
  ],
  "NADSYN1": [
    "NADSYN1 cnv",
    "NADSYN1 methyl",
    "NADSYN1 proteo",
    "NADSYN1 rna"
  ],
  "NAE1": [
    "NAE1 cnv",
    "NAE1 methyl",
    "NAE1 proteo",
    "NAE1 rna"
  ],
  "NAF1": [
    "NAF1 315_315_1_1_S315 phospho",
    "NAF1 cnv",
    "NAF1 methyl",
    "NAF1 proteo",
    "NAF1 rna"
  ],
  "NAGA": [
    "NAGA cnv",
    "NAGA methyl",
    "NAGA proteo",
    "NAGA rna"
  ],
  "NAGK": [
    "NAGK 19_25_1_1_S25 phospho",
    "NAGK 19_25_2_2_S23S25 phospho",
    "NAGK cnv",
    "NAGK methyl",
    "NAGK proteo",
    "NAGK rna"
  ],
  "NAGLU": [
    "NAGLU VFPQVNVTK-N2H5F0S0G0 glyco",
    "NAGLU VFPQVNVTK-N2H6F0S0G0 glyco",
    "NAGLU cnv",
    "NAGLU methyl",
    "NAGLU proteo",
    "NAGLU rna"
  ],
  "NAGPA": [
    "NAGPA cnv",
    "NAGPA methyl",
    "NAGPA proteo",
    "NAGPA rna"
  ],
  "NAGS": [
    "NAGS cnv",
    "NAGS methyl",
    "NAGS rna"
  ],
  "NAIF1": [
    "NAIF1 cnv",
    "NAIF1 methyl",
    "NAIF1 rna"
  ],
  "NAIP": [
    "NAIP 982_989_1_1_S982 phospho",
    "NAIP cnv",
    "NAIP proteo",
    "NAIP rna"
  ],
  "NALCN": [
    "NALCN cnv",
    "NALCN methyl",
    "NALCN rna"
  ],
  "NALF1": [
    "NALF1 cnv",
    "NALF1 methyl",
    "NALF1 rna"
  ],
  "NALF2": [
    "NALF2 methyl",
    "NALF2 rna"
  ],
  "NAMPT": [
    "NAMPT cnv",
    "NAMPT methyl",
    "NAMPT proteo",
    "NAMPT rna"
  ],
  "NANOG": [
    "NANOG cnv",
    "NANOG rna"
  ],
  "NANOGNB": [
    "NANOGNB cnv"
  ],
  "NANOGP8": [
    "NANOGP8 cnv",
    "NANOGP8 rna"
  ],
  "NANOS1": [
    "NANOS1 cnv",
    "NANOS1 methyl",
    "NANOS1 rna"
  ],
  "NANOS2": [
    "NANOS2 cnv",
    "NANOS2 rna"
  ],
  "NANOS3": [
    "NANOS3 cnv",
    "NANOS3 methyl",
    "NANOS3 rna"
  ],
  "NANP": [
    "NANP cnv",
    "NANP methyl",
    "NANP proteo",
    "NANP rna"
  ],
  "NANS": [
    "NANS 275_277_1_1_S275 phospho",
    "NANS cnv",
    "NANS methyl",
    "NANS proteo",
    "NANS rna"
  ],
  "NAP1L1": [
    "NAP1L1 cnv",
    "NAP1L1 methyl",
    "NAP1L1 proteo",
    "NAP1L1 rna"
  ],
  "NAP1L2": [
    "NAP1L2 rna"
  ],
  "NAP1L3": [
    "NAP1L3 methyl",
    "NAP1L3 rna"
  ],
  "NAP1L4": [
    "NAP1L4 111_125_1_0 phospho",
    "NAP1L4 111_125_1_1_S125 phospho",
    "NAP1L4 51_58_1_0 phospho",
    "NAP1L4 51_58_1_1_T58 phospho",
    "NAP1L4 cnv",
    "NAP1L4 methyl",
    "NAP1L4 proteo",
    "NAP1L4 rna"
  ],
  "NAP1L5": [
    "NAP1L5 cnv",
    "NAP1L5 methyl",
    "NAP1L5 proteo",
    "NAP1L5 rna"
  ],
  "NAPA": [
    "NAPA 185_195_1_1_S195 phospho",
    "NAPA cnv",
    "NAPA methyl",
    "NAPA proteo",
    "NAPA rna"
  ],
  "NAPA-AS1": [
    "NAPA-AS1 methyl"
  ],
  "NAPB": [
    "NAPB cnv",
    "NAPB methyl",
    "NAPB proteo",
    "NAPB rna"
  ],
  "NAPEPLD": [
    "NAPEPLD 43_48_1_1_S43 phospho",
    "NAPEPLD cnv",
    "NAPEPLD methyl",
    "NAPEPLD proteo",
    "NAPEPLD rna"
  ],
  "NAPG": [
    "NAPG 284_308_1_1_T287 phospho",
    "NAPG cnv",
    "NAPG methyl",
    "NAPG proteo",
    "NAPG rna"
  ],
  "NAPRT": [
    "NAPRT cnv",
    "NAPRT methyl",
    "NAPRT proteo",
    "NAPRT rna"
  ],
  "NAPSA": [
    "NAPSA cnv",
    "NAPSA rna"
  ],
  "NARF": [
    "NARF cnv",
    "NARF methyl",
    "NARF proteo",
    "NARF rna"
  ],
  "NARS1": [
    "NARS1 cnv",
    "NARS1 methyl",
    "NARS1 proteo",
    "NARS1 rna"
  ],
  "NARS2": [
    "NARS2 cnv",
    "NARS2 methyl",
    "NARS2 proteo",
    "NARS2 rna"
  ],
  "NASP": [
    "NASP 123_141_1_1_S141 phospho",
    "NASP 244_248_1_1_S244 phospho",
    "NASP 384_397_1_1_T390 phospho",
    "NASP 421_425_1_1_S421 phospho",
    "NASP 421_441_1_1_S428 phospho",
    "NASP 477_480_1_1_S480 phospho",
    "NASP 726_726_1_1_S726 phospho",
    "NASP cnv",
    "NASP methyl",
    "NASP proteo",
    "NASP rna"
  ],
  "NAT1": [
    "NAT1 cnv",
    "NAT1 proteo",
    "NAT1 rna"
  ],
  "NAT10": [
    "NAT10 cnv",
    "NAT10 methyl",
    "NAT10 proteo",
    "NAT10 rna"
  ],
  "NAT14": [
    "NAT14 cnv",
    "NAT14 methyl",
    "NAT14 proteo",
    "NAT14 rna"
  ],
  "NAT16": [
    "NAT16 cnv",
    "NAT16 methyl",
    "NAT16 rna"
  ],
  "NAT2": [
    "NAT2 cnv",
    "NAT2 rna"
  ],
  "NAT8": [
    "NAT8 cnv",
    "NAT8 rna"
  ],
  "NAT8B": [
    "NAT8B cnv",
    "NAT8B rna"
  ],
  "NAT8L": [
    "NAT8L cnv",
    "NAT8L methyl",
    "NAT8L proteo",
    "NAT8L rna"
  ],
  "NAT9": [
    "NAT9 cnv",
    "NAT9 methyl",
    "NAT9 rna"
  ],
  "NATD1": [
    "NATD1 cnv",
    "NATD1 methyl",
    "NATD1 proteo",
    "NATD1 rna"
  ],
  "NAV1": [
    "NAV1 1012_1035_1_0 phospho",
    "NAV1 1012_1035_1_1_S1014 phospho",
    "NAV1 1181_1200_1_1_S1181 phospho",
    "NAV1 1233_1253_1_1_S1253 phospho",
    "NAV1 1260_1267_1_1_S1260 phospho",
    "NAV1 1366_1382_1_1_S1382 phospho",
    "NAV1 142_145_1_1_S142 phospho",
    "NAV1 282_296_1_1_S296 phospho",
    "NAV1 354_357_1_1_T357 phospho",
    "NAV1 354_364_1_1_S362 phospho",
    "NAV1 387_393_1_1_S391 phospho",
    "NAV1 452_453_1_1_S452 phospho",
    "NAV1 507_512_1_1_S507 phospho",
    "NAV1 522_528_1_1_S528 phospho",
    "NAV1 534_549_1_1_S541 phospho",
    "NAV1 647_654_1_1_S648 phospho",
    "NAV1 695_705_1_1_S695 phospho",
    "NAV1 750_754_1_1_S754 phospho",
    "NAV1 757_764_1_1_S760 phospho",
    "NAV1 806_821_1_1_S808 phospho",
    "NAV1 90_100_1_1_S90 phospho",
    "NAV1 950_958_1_1_S954 phospho",
    "NAV1 964_990_1_1_S981 phospho",
    "NAV1 cnv",
    "NAV1 methyl",
    "NAV1 proteo",
    "NAV1 rna"
  ],
  "NAV2": [
    "NAV2 1103_1120_1_0 phospho",
    "NAV2 1103_1120_1_1_S1104 phospho",
    "NAV2 1502_1518_1_1_S1504 phospho",
    "NAV2 222_228_1_1_S224 phospho",
    "NAV2 cnv",
    "NAV2 methyl",
    "NAV2 proteo",
    "NAV2 rna"
  ],
  "NAV3": [
    "NAV3 1112_1129_1_1_S1113 phospho",
    "NAV3 1189_1197_1_1_S1190 phospho",
    "NAV3 cnv",
    "NAV3 proteo",
    "NAV3 rna"
  ],
  "NAXD": [
    "NAXD 85_95_1_1_Y85 phospho",
    "NAXD LSQALGNVTVVQK-N2H5F0S0G0 glyco",
    "NAXD LSQALGNVTVVQK-N2H6F0S0G0 glyco",
    "NAXD cnv",
    "NAXD methyl",
    "NAXD proteo",
    "NAXD rna"
  ],
  "NAXE": [
    "NAXE cnv",
    "NAXE methyl",
    "NAXE proteo",
    "NAXE rna"
  ],
  "NBAS": [
    "NBAS 1937_1937_1_1_S1937 phospho",
    "NBAS 473_480_1_1_S475 phospho",
    "NBAS cnv",
    "NBAS methyl",
    "NBAS proteo",
    "NBAS rna"
  ],
  "NBDY": [
    "NBDY proteo",
    "NBDY rna"
  ],
  "NBEA": [
    "NBEA 1259_1267_1_1_S1267 phospho",
    "NBEA 1259_1273_1_1_S1267 phospho",
    "NBEA 1519_1529_1_1_S1529 phospho",
    "NBEA 1714_1738_1_0 phospho",
    "NBEA cnv",
    "NBEA methyl",
    "NBEA proteo",
    "NBEA rna"
  ],
  "NBEAL1": [
    "NBEAL1 2679_2693_1_1_S2679 phospho",
    "NBEAL1 cnv",
    "NBEAL1 methyl",
    "NBEAL1 proteo",
    "NBEAL1 rna"
  ],
  "NBEAL2": [
    "NBEAL2 2739_2751_1_1_S2739 phospho",
    "NBEAL2 cnv",
    "NBEAL2 methyl",
    "NBEAL2 proteo",
    "NBEAL2 rna"
  ],
  "NBL1": [
    "NBL1 cnv",
    "NBL1 methyl",
    "NBL1 rna"
  ],
  "NBN": [
    "NBN 253_265_1_1_T255 phospho",
    "NBN 315_320_1_1_S315 phospho",
    "NBN 347_352_1_1_S350 phospho",
    "NBN 347_356_1_1_S350 phospho",
    "NBN cnv",
    "NBN methyl",
    "NBN proteo",
    "NBN rna"
  ],
  "NBPF1": [
    "NBPF1 cnv",
    "NBPF1 methyl",
    "NBPF1 rna"
  ],
  "NBPF10": [
    "NBPF10 cnv",
    "NBPF10 methyl",
    "NBPF10 rna"
  ],
  "NBPF11": [
    "NBPF11 cnv",
    "NBPF11 methyl",
    "NBPF11 rna"
  ],
  "NBPF12": [
    "NBPF12 cnv",
    "NBPF12 rna"
  ],
  "NBPF14": [
    "NBPF14 cnv",
    "NBPF14 rna"
  ],
  "NBPF15": [
    "NBPF15 cnv",
    "NBPF15 methyl",
    "NBPF15 rna"
  ],
  "NBPF19": [
    "NBPF19 cnv",
    "NBPF19 rna"
  ],
  "NBPF20": [
    "NBPF20 cnv",
    "NBPF20 rna"
  ],
  "NBPF25P": [
    "NBPF25P methyl"
  ],
  "NBPF26": [
    "NBPF26 cnv",
    "NBPF26 rna"
  ],
  "NBPF3": [
    "NBPF3 cnv",
    "NBPF3 methyl",
    "NBPF3 rna"
  ],
  "NBPF4": [
    "NBPF4 cnv",
    "NBPF4 rna"
  ],
  "NBPF6": [
    "NBPF6 cnv",
    "NBPF6 rna"
  ],
  "NBPF8": [
    "NBPF8 methyl"
  ],
  "NBPF9": [
    "NBPF9 cnv",
    "NBPF9 methyl",
    "NBPF9 rna"
  ],
  "NBR1": [
    "NBR1 cnv",
    "NBR1 methyl",
    "NBR1 proteo",
    "NBR1 rna"
  ],
  "NCALD": [
    "NCALD cnv",
    "NCALD methyl",
    "NCALD proteo",
    "NCALD rna"
  ],
  "NCAM1": [
    "NCAM1 784_784_1_1_S784 phospho",
    "NCAM1 793_798_1_1_T798 phospho",
    "NCAM1 807_816_1_0 phospho",
    "NCAM1 807_816_1_1_T813 phospho",
    "NCAM1 DGQLLPSSNYSNIK-N4H3F1S0G0 glyco",
    "NCAM1 DGQLLPSSNYSNIK-N4H5F1S1G0 glyco",
    "NCAM1 DGQLLPSSNYSNIK-N4H5F1S2G0 glyco",
    "NCAM1 DGQLLPSSNYSNIK-N4H5F2S2G0 glyco",
    "NCAM1 DGQLLPSSNYSNIK-N5H3F1S0G0 glyco",
    "NCAM1 DGQLLPSSNYSNIK-N5H4F1S1G0 glyco",
    "NCAM1 DGQLLPSSNYSNIK-N5H4F2S0G0 glyco",
    "NCAM1 DGQLLPSSNYSNIK-N5H5F1S1G0 glyco",
    "NCAM1 DGQLLPSSNYSNIK-N5H5F1S2G0 glyco",
    "NCAM1 DGQLLPSSNYSNIK-N5H6F1S3G0 glyco",
    "NCAM1 DGQLLPSSNYSNIK-N6H3F1S0G0 glyco",
    "NCAM1 DGQLLPSSNYSNIK-N6H4F1S0G0 glyco",
    "NCAM1 DGQLLPSSNYSNIK-N6H4F1S1G0 glyco",
    "NCAM1 DGQLLPSSNYSNIK-N6H5F2S1G0 glyco",
    "NCAM1 NISSEEK-N3H3F1S0G0 glyco",
    "NCAM1 NISSEEK-N4H3F1S0G0 glyco",
    "NCAM1 NISSEEK-N5H3F1S0G0 glyco",
    "NCAM1 NISSEEK-N5H4F1S0G0 glyco",
    "NCAM1 NISSEEK-N6H4F1S0G0 glyco",
    "NCAM1 cnv",
    "NCAM1 proteo",
    "NCAM1 rna"
  ],
  "NCAM2": [
    "NCAM2 785_790_1_1_S790 phospho",
    "NCAM2 790_790_1_1_S790 phospho",
    "NCAM2 805_823_1_1_S811 phospho",
    "NCAM2 FAMLANNNLQILNINK-N5H4F1S1G0 glyco",
    "NCAM2 FAMLANNNLQILNINK-N5H4F2S0G0 glyco",
    "NCAM2 LVLPAKNTTNLK-N5H3F1S0G0 glyco",
    "NCAM2 LVLPAKNTTNLK-N5H4F2S0G0 glyco",
    "NCAM2 MILEIAPTSDNDFGRYNCTATNHIGTR-N2H5F0S0G0 glyco",
    "NCAM2 MILEIAPTSDNDFGRYNCTATNHIGTR-N2H6F0S0G0 glyco",
    "NCAM2 YNCTATNHIGTR-N2H4F0S0G0 glyco",
    "NCAM2 YNCTATNHIGTR-N2H5F0S0G0 glyco",
    "NCAM2 YNCTATNHIGTR-N2H6F0S0G0 glyco",
    "NCAM2 cnv",
    "NCAM2 methyl",
    "NCAM2 proteo",
    "NCAM2 rna"
  ],
  "NCAN": [
    "NCAN ANATLLLGPLR-N2H3F0S0G0 glyco",
    "NCAN ANATLLLGPLR-N2H4F0S0G0 glyco",
    "NCAN ANATLLLGPLR-N2H5F0S0G0 glyco",
    "NCAN ANATLLLGPLR-N2H6F0S0G0 glyco",
    "NCAN ANATLLLGPLR-N2H7F0S0G0 glyco",
    "NCAN ANATLLLGPLR-N3H6F0S1G0 glyco",
    "NCAN ANATLLLGPLR-N3H6F1S0G0 glyco",
    "NCAN cnv",
    "NCAN methyl",
    "NCAN proteo",
    "NCAN rna"
  ],
  "NCAPD2": [
    "NCAPD2 cnv",
    "NCAPD2 methyl",
    "NCAPD2 proteo",
    "NCAPD2 rna"
  ],
  "NCAPD3": [
    "NCAPD3 cnv",
    "NCAPD3 methyl",
    "NCAPD3 proteo",
    "NCAPD3 rna"
  ],
  "NCAPG": [
    "NCAPG 664_680_1_1_S674 phospho",
    "NCAPG 968_984_2_2_S973S975 phospho",
    "NCAPG cnv",
    "NCAPG methyl",
    "NCAPG proteo",
    "NCAPG rna"
  ],
  "NCAPG2": [
    "NCAPG2 cnv",
    "NCAPG2 methyl",
    "NCAPG2 proteo",
    "NCAPG2 rna"
  ],
  "NCAPH": [
    "NCAPH cnv",
    "NCAPH methyl",
    "NCAPH proteo",
    "NCAPH rna"
  ],
  "NCAPH2": [
    "NCAPH2 282_288_1_1_S284 phospho",
    "NCAPH2 cnv",
    "NCAPH2 methyl",
    "NCAPH2 proteo",
    "NCAPH2 rna"
  ],
  "NCBP1": [
    "NCBP1 21_33_1_1_S22 phospho",
    "NCBP1 7_7_1_1_S7 phospho",
    "NCBP1 cnv",
    "NCBP1 methyl",
    "NCBP1 proteo",
    "NCBP1 rna"
  ],
  "NCBP2": [
    "NCBP2 cnv",
    "NCBP2 methyl",
    "NCBP2 proteo",
    "NCBP2 rna"
  ],
  "NCBP2AS2": [
    "NCBP2AS2 cnv",
    "NCBP2AS2 methyl",
    "NCBP2AS2 proteo",
    "NCBP2AS2 rna"
  ],
  "NCBP2L": [
    "NCBP2L rna"
  ],
  "NCBP3": [
    "NCBP3 25_30_1_1_S25 phospho",
    "NCBP3 cnv",
    "NCBP3 methyl",
    "NCBP3 proteo",
    "NCBP3 rna"
  ],
  "NCCRP1": [
    "NCCRP1 cnv",
    "NCCRP1 rna"
  ],
  "NCDN": [
    "NCDN cnv",
    "NCDN methyl",
    "NCDN proteo",
    "NCDN rna"
  ],
  "NCEH1": [
    "NCEH1 cnv",
    "NCEH1 methyl",
    "NCEH1 proteo",
    "NCEH1 rna"
  ],
  "NCF1": [
    "NCF1 320_324_1_1_S320 phospho",
    "NCF1 cnv",
    "NCF1 proteo",
    "NCF1 rna"
  ],
  "NCF2": [
    "NCF2 203_233_1_1_T233 phospho",
    "NCF2 cnv",
    "NCF2 proteo",
    "NCF2 rna"
  ],
  "NCF4": [
    "NCF4 cnv",
    "NCF4 proteo",
    "NCF4 rna"
  ],
  "NCK1": [
    "NCK1 147_176_1_1_S166 phospho",
    "NCK1 85_96_1_0 phospho",
    "NCK1 85_96_1_1_S85 phospho",
    "NCK1 cnv",
    "NCK1 methyl",
    "NCK1 proteo",
    "NCK1 rna"
  ],
  "NCK2": [
    "NCK2 90_104_1_1_S90 phospho",
    "NCK2 90_104_2_1_S90 phospho",
    "NCK2 cnv",
    "NCK2 methyl",
    "NCK2 proteo",
    "NCK2 rna"
  ],
  "NCKAP1": [
    "NCKAP1 333_337_1_1_S337 phospho",
    "NCKAP1 cnv",
    "NCKAP1 methyl",
    "NCKAP1 proteo",
    "NCKAP1 rna"
  ],
  "NCKAP1L": [
    "NCKAP1L cnv",
    "NCKAP1L proteo",
    "NCKAP1L rna"
  ],
  "NCKAP5": [
    "NCKAP5 cnv",
    "NCKAP5 rna"
  ],
  "NCKAP5L": [
    "NCKAP5L 468_477_1_1_S477 phospho",
    "NCKAP5L 628_630_1_1_S630 phospho",
    "NCKAP5L 733_735_1_1_S735 phospho",
    "NCKAP5L 752_756_1_1_S756 phospho",
    "NCKAP5L cnv",
    "NCKAP5L methyl",
    "NCKAP5L proteo",
    "NCKAP5L rna"
  ],
  "NCKIPSD": [
    "NCKIPSD 110_122_1_0 phospho",
    "NCKIPSD 110_122_1_1_S122 phospho",
    "NCKIPSD 147_168_1_0 phospho",
    "NCKIPSD 180_181_1_1_T181 phospho",
    "NCKIPSD cnv",
    "NCKIPSD methyl",
    "NCKIPSD proteo",
    "NCKIPSD rna"
  ],
  "NCL": [
    "NCL 145_153_1_1_S145 phospho",
    "NCL 184_214_1_1_S206 phospho",
    "NCL 184_214_2_2_S184S206 phospho",
    "NCL 563_563_1_1_S563 phospho",
    "NCL 580_587_1_1_S580 phospho",
    "NCL 67_69_1_1_S67 phospho",
    "NCL cnv",
    "NCL methyl",
    "NCL proteo",
    "NCL rna"
  ],
  "NCLN": [
    "NCLN VIYNLTEK-N2H3F0S0G0 glyco",
    "NCLN VIYNLTEK-N2H5F0S0G0 glyco",
    "NCLN VIYNLTEK-N2H6F0S0G0 glyco",
    "NCLN VIYNLTEK-N2H8F0S0G0 glyco",
    "NCLN VIYNLTEK-N3H3F0S0G0 glyco",
    "NCLN VIYNLTEK-N4H3F0S0G0 glyco",
    "NCLN cnv",
    "NCLN methyl",
    "NCLN proteo",
    "NCLN rna"
  ],
  "NCMAP": [
    "NCMAP cnv",
    "NCMAP methyl",
    "NCMAP rna"
  ],
  "NCOA1": [
    "NCOA1 cnv",
    "NCOA1 methyl",
    "NCOA1 proteo",
    "NCOA1 rna"
  ],
  "NCOA2": [
    "NCOA2 29_29_1_1_S29 phospho",
    "NCOA2 493_499_1_1_S493 phospho",
    "NCOA2 697_699_1_1_S699 phospho",
    "NCOA2 716_736_1_1_S736 phospho",
    "NCOA2 cnv",
    "NCOA2 methyl",
    "NCOA2 proteo",
    "NCOA2 rna"
  ],
  "NCOA3": [
    "NCOA3 203_214_1_1_S214 phospho",
    "NCOA3 728_728_1_1_S728 phospho",
    "NCOA3 cnv",
    "NCOA3 methyl",
    "NCOA3 proteo",
    "NCOA3 rna"
  ],
  "NCOA4": [
    "NCOA4 cnv",
    "NCOA4 methyl",
    "NCOA4 proteo",
    "NCOA4 rna"
  ],
  "NCOA5": [
    "NCOA5 148_151_1_1_S151 phospho",
    "NCOA5 265_274_1_1_T274 phospho",
    "NCOA5 29_34_1_1_S34 phospho",
    "NCOA5 377_381_2_2_S378S381 phospho",
    "NCOA5 96_96_1_1_S96 phospho",
    "NCOA5 cnv",
    "NCOA5 methyl",
    "NCOA5 proteo",
    "NCOA5 rna"
  ],
  "NCOA6": [
    "NCOA6 1890_1913_1_1_S1892 phospho",
    "NCOA6 2018_2029_1_1_S2018 phospho",
    "NCOA6 cnv",
    "NCOA6 methyl",
    "NCOA6 proteo",
    "NCOA6 rna"
  ],
  "NCOA7": [
    "NCOA7 208_211_1_1_S208 phospho",
    "NCOA7 208_211_1_1_S211 phospho",
    "NCOA7 208_211_2_0 phospho",
    "NCOA7 295_304_1_1_S295 phospho",
    "NCOA7 343_357_1_1_T347 phospho",
    "NCOA7 369_377_1_1_S373 phospho",
    "NCOA7 430_430_1_1_S430 phospho",
    "NCOA7 489_494_1_1_S491 phospho",
    "NCOA7 87_89_1_1_S89 phospho",
    "NCOA7 cnv",
    "NCOA7 methyl",
    "NCOA7 proteo",
    "NCOA7 rna"
  ],
  "NCOR1": [
    "NCOR1 1322_1322_1_1_S1322 phospho",
    "NCOR1 1367_1386_1_1_T1367 phospho",
    "NCOR1 1528_1545_1_1_S1533 phospho",
    "NCOR1 157_174_1_1_S158 phospho",
    "NCOR1 1966_1981_1_1_S1977 phospho",
    "NCOR1 2097_2117_1_1_S2102 phospho",
    "NCOR1 2120_2120_1_1_S2120 phospho",
    "NCOR1 2140_2151_1_1_S2151 phospho",
    "NCOR1 2184_2196_1_1_S2184 phospho",
    "NCOR1 224_224_1_1_S224 phospho",
    "NCOR1 2335_2362_1_1_S2337 phospho",
    "NCOR1 2394_2406_1_1_T2396 phospho",
    "NCOR1 87_106_1_0 phospho",
    "NCOR1 999_1016_1_1_S999 phospho",
    "NCOR1 cnv",
    "NCOR1 methyl",
    "NCOR1 proteo",
    "NCOR1 rna"
  ],
  "NCOR2": [
    "NCOR2 1009_1018_1_0 phospho",
    "NCOR2 1023_1025_1_1_S1025 phospho",
    "NCOR2 1341_1341_1_1_S1341 phospho",
    "NCOR2 1383_1390_1_1_T1383 phospho",
    "NCOR2 140_156_2_2_S149S152 phospho",
    "NCOR2 149_156_1_1_S152 phospho",
    "NCOR2 149_156_2_2_S149S152 phospho",
    "NCOR2 1539_1543_1_1_S1539 phospho",
    "NCOR2 1773_1794_1_1_S1775 phospho",
    "NCOR2 1773_1794_1_1_S1778 phospho",
    "NCOR2 1773_1794_2_2_S1775S1778 phospho",
    "NCOR2 1964_1973_1_1_S1971 phospho",
    "NCOR2 2005_2016_1_1_S2005 phospho",
    "NCOR2 2037_2062_2_2_S2046S2054 phospho",
    "NCOR2 215_221_1_1_S215 phospho",
    "NCOR2 2203_2203_1_1_S2203 phospho",
    "NCOR2 2209_2234_1_1_S2223 phospho",
    "NCOR2 2256_2270_1_1_S2258 phospho",
    "NCOR2 2258_2270_1_1_S2258 phospho",
    "NCOR2 2387_2393_1_1_S2393 phospho",
    "NCOR2 2413_2432_1_1_S2413 phospho",
    "NCOR2 2452_2461_1_1_S2453 phospho",
    "NCOR2 550_554_1_1_S554 phospho",
    "NCOR2 908_922_1_1_S922 phospho",
    "NCOR2 939_948_1_1_S939 phospho",
    "NCOR2 956_956_1_1_S956 phospho",
    "NCOR2 cnv",
    "NCOR2 methyl",
    "NCOR2 proteo",
    "NCOR2 rna"
  ],
  "NCR1": [
    "NCR1 cnv",
    "NCR1 rna"
  ],
  "NCR2": [
    "NCR2 cnv"
  ],
  "NCR3": [
    "NCR3 cnv",
    "NCR3 rna"
  ],
  "NCR3LG1": [
    "NCR3LG1 cnv",
    "NCR3LG1 methyl",
    "NCR3LG1 rna"
  ],
  "NCS1": [
    "NCS1 cnv",
    "NCS1 methyl",
    "NCS1 proteo",
    "NCS1 rna"
  ],
  "NCSTN": [
    "NCSTN ALYELAGGTNFSDTVQADPQTVTR-N2H6F0S0G0 glyco",
    "NCSTN ANNSWFQSILR-N2H8F0S0G0 glyco",
    "NCSTN IYIPLNK-N2H10F0S0G0 glyco",
    "NCSTN IYIPLNK-N2H7F0S0G0 glyco",
    "NCSTN IYIPLNK-N2H8F0S0G0 glyco",
    "NCSTN IYIPLNK-N2H9F0S0G0 glyco",
    "NCSTN NISGVVLADHSGAFHNK-N2H6F0S0G0 glyco",
    "NCSTN NISGVVLADHSGAFHNK-N2H7F0S0G0 glyco",
    "NCSTN NISGVVLADHSGAFHNK-N2H8F0S0G0 glyco",
    "NCSTN cnv",
    "NCSTN methyl",
    "NCSTN proteo",
    "NCSTN rna"
  ],
  "NDC1": [
    "NDC1 cnv",
    "NDC1 methyl",
    "NDC1 proteo",
    "NDC1 rna"
  ],
  "NDC80": [
    "NDC80 cnv",
    "NDC80 methyl",
    "NDC80 proteo",
    "NDC80 rna"
  ],
  "NDE1": [
    "NDE1 202_215_1_1_S211 phospho",
    "NDE1 223_231_1_1_S231 phospho",
    "NDE1 279_282_1_1_S282 phospho",
    "NDE1 306_309_1_1_S306 phospho",
    "NDE1 cnv",
    "NDE1 methyl",
    "NDE1 proteo",
    "NDE1 rna"
  ],
  "NDEL1": [
    "NDEL1 194_200_1_1_S198 phospho",
    "NDEL1 194_200_2_2_S194S198 phospho",
    "NDEL1 208_219_2_2_S215T219 phospho",
    "NDEL1 225_231_1_1_S231 phospho",
    "NDEL1 cnv",
    "NDEL1 methyl",
    "NDEL1 proteo",
    "NDEL1 rna"
  ],
  "NDFIP1": [
    "NDFIP1 cnv",
    "NDFIP1 methyl",
    "NDFIP1 rna"
  ],
  "NDFIP2": [
    "NDFIP2 cnv",
    "NDFIP2 methyl",
    "NDFIP2 rna"
  ],
  "NDFIP2-AS1": [
    "NDFIP2-AS1 methyl"
  ],
  "NDN": [
    "NDN cnv",
    "NDN methyl",
    "NDN proteo",
    "NDN rna"
  ],
  "NDNF": [
    "NDNF cnv",
    "NDNF methyl",
    "NDNF rna"
  ],
  "NDOR1": [
    "NDOR1 cnv",
    "NDOR1 methyl",
    "NDOR1 proteo",
    "NDOR1 rna"
  ],
  "NDP": [
    "NDP rna"
  ],
  "NDRG1": [
    "NDRG1 326_340_1_1_T328 phospho",
    "NDRG1 326_340_2_0 phospho",
    "NDRG1 328_340_1_1_T328 phospho",
    "NDRG1 362_384_1_0 phospho",
    "NDRG1 362_384_2_0 phospho",
    "NDRG1 364_384_1_0 phospho",
    "NDRG1 364_384_1_1_S367 phospho",
    "NDRG1 364_384_1_1_T366 phospho",
    "NDRG1 cnv",
    "NDRG1 methyl",
    "NDRG1 proteo",
    "NDRG1 rna"
  ],
  "NDRG2": [
    "NDRG2 305_322_1_0 phospho",
    "NDRG2 324_334_1_1_T326 phospho",
    "NDRG2 324_334_2_2_T326S328 phospho",
    "NDRG2 326_334_2_2_T326S328 phospho",
    "NDRG2 342_366_1_0 phospho",
    "NDRG2 344_366_1_0 phospho",
    "NDRG2 344_366_1_1_S346 phospho",
    "NDRG2 344_366_1_1_S349 phospho",
    "NDRG2 344_366_2_0 phospho",
    "NDRG2 36_53_1_1_T53 phospho",
    "NDRG2 cnv",
    "NDRG2 methyl",
    "NDRG2 proteo",
    "NDRG2 rna"
  ],
  "NDRG3": [
    "NDRG3 327_344_2_2_T329S331 phospho",
    "NDRG3 329_344_1_0 phospho",
    "NDRG3 329_344_1_1_S331 phospho",
    "NDRG3 370_374_1_1_S374 phospho",
    "NDRG3 cnv",
    "NDRG3 methyl",
    "NDRG3 proteo",
    "NDRG3 rna"
  ],
  "NDRG4": [
    "NDRG4 27_45_1_1_S27 phospho",
    "NDRG4 298_308_1_1_S298 phospho",
    "NDRG4 315_351_1_0 phospho",
    "NDRG4 cnv",
    "NDRG4 methyl",
    "NDRG4 proteo",
    "NDRG4 rna"
  ],
  "NDST1": [
    "NDST1 cnv",
    "NDST1 methyl",
    "NDST1 rna"
  ],
  "NDST1-AS1": [
    "NDST1-AS1 methyl"
  ],
  "NDST2": [
    "NDST2 cnv",
    "NDST2 methyl",
    "NDST2 rna"
  ],
  "NDST3": [
    "NDST3 cnv",
    "NDST3 methyl",
    "NDST3 rna"
  ],
  "NDST4": [
    "NDST4 cnv",
    "NDST4 rna"
  ],
  "NDUFA1": [
    "NDUFA1 methyl",
    "NDUFA1 rna"
  ],
  "NDUFA10": [
    "NDUFA10 cnv",
    "NDUFA10 methyl",
    "NDUFA10 proteo",
    "NDUFA10 rna"
  ],
  "NDUFA11": [
    "NDUFA11 cnv",
    "NDUFA11 methyl",
    "NDUFA11 proteo",
    "NDUFA11 rna"
  ],
  "NDUFA12": [
    "NDUFA12 cnv",
    "NDUFA12 methyl",
    "NDUFA12 proteo",
    "NDUFA12 rna"
  ],
  "NDUFA13": [
    "NDUFA13 cnv",
    "NDUFA13 methyl",
    "NDUFA13 proteo",
    "NDUFA13 rna"
  ],
  "NDUFA2": [
    "NDUFA2 cnv",
    "NDUFA2 methyl",
    "NDUFA2 proteo",
    "NDUFA2 rna"
  ],
  "NDUFA3": [
    "NDUFA3 cnv",
    "NDUFA3 methyl",
    "NDUFA3 proteo",
    "NDUFA3 rna"
  ],
  "NDUFA4": [
    "NDUFA4 cnv",
    "NDUFA4 methyl",
    "NDUFA4 proteo",
    "NDUFA4 rna"
  ],
  "NDUFA4L2": [
    "NDUFA4L2 cnv",
    "NDUFA4L2 methyl",
    "NDUFA4L2 rna"
  ],
  "NDUFA5": [
    "NDUFA5 cnv",
    "NDUFA5 methyl",
    "NDUFA5 proteo",
    "NDUFA5 rna"
  ],
  "NDUFA6": [
    "NDUFA6 cnv",
    "NDUFA6 methyl",
    "NDUFA6 proteo",
    "NDUFA6 rna"
  ],
  "NDUFA7": [
    "NDUFA7 cnv",
    "NDUFA7 methyl",
    "NDUFA7 proteo",
    "NDUFA7 rna"
  ],
  "NDUFA8": [
    "NDUFA8 cnv",
    "NDUFA8 methyl",
    "NDUFA8 proteo",
    "NDUFA8 rna"
  ],
  "NDUFA9": [
    "NDUFA9 cnv",
    "NDUFA9 methyl",
    "NDUFA9 proteo",
    "NDUFA9 rna"
  ],
  "NDUFAB1": [
    "NDUFAB1 cnv",
    "NDUFAB1 methyl",
    "NDUFAB1 proteo",
    "NDUFAB1 rna"
  ],
  "NDUFAF1": [
    "NDUFAF1 cnv",
    "NDUFAF1 methyl",
    "NDUFAF1 proteo",
    "NDUFAF1 rna"
  ],
  "NDUFAF2": [
    "NDUFAF2 cnv",
    "NDUFAF2 methyl",
    "NDUFAF2 proteo",
    "NDUFAF2 rna"
  ],
  "NDUFAF3": [
    "NDUFAF3 cnv",
    "NDUFAF3 methyl",
    "NDUFAF3 proteo",
    "NDUFAF3 rna"
  ],
  "NDUFAF4": [
    "NDUFAF4 cnv",
    "NDUFAF4 methyl",
    "NDUFAF4 proteo",
    "NDUFAF4 rna"
  ],
  "NDUFAF5": [
    "NDUFAF5 cnv",
    "NDUFAF5 methyl",
    "NDUFAF5 proteo",
    "NDUFAF5 rna"
  ],
  "NDUFAF6": [
    "NDUFAF6 cnv",
    "NDUFAF6 methyl",
    "NDUFAF6 proteo",
    "NDUFAF6 rna"
  ],
  "NDUFAF7": [
    "NDUFAF7 cnv",
    "NDUFAF7 methyl",
    "NDUFAF7 proteo",
    "NDUFAF7 rna"
  ],
  "NDUFAF8": [
    "NDUFAF8 cnv",
    "NDUFAF8 methyl",
    "NDUFAF8 proteo",
    "NDUFAF8 rna"
  ],
  "NDUFB1": [
    "NDUFB1 cnv",
    "NDUFB1 methyl",
    "NDUFB1 proteo",
    "NDUFB1 rna"
  ],
  "NDUFB10": [
    "NDUFB10 cnv",
    "NDUFB10 methyl",
    "NDUFB10 proteo",
    "NDUFB10 rna"
  ],
  "NDUFB11": [
    "NDUFB11 methyl",
    "NDUFB11 proteo",
    "NDUFB11 rna"
  ],
  "NDUFB2": [
    "NDUFB2 cnv",
    "NDUFB2 methyl",
    "NDUFB2 proteo",
    "NDUFB2 rna"
  ],
  "NDUFB2-AS1": [
    "NDUFB2-AS1 methyl"
  ],
  "NDUFB3": [
    "NDUFB3 cnv",
    "NDUFB3 methyl",
    "NDUFB3 proteo",
    "NDUFB3 rna"
  ],
  "NDUFB4": [
    "NDUFB4 cnv",
    "NDUFB4 methyl",
    "NDUFB4 proteo",
    "NDUFB4 rna"
  ],
  "NDUFB5": [
    "NDUFB5 cnv",
    "NDUFB5 methyl",
    "NDUFB5 proteo",
    "NDUFB5 rna"
  ],
  "NDUFB6": [
    "NDUFB6 cnv",
    "NDUFB6 methyl",
    "NDUFB6 proteo",
    "NDUFB6 rna"
  ],
  "NDUFB7": [
    "NDUFB7 cnv",
    "NDUFB7 methyl",
    "NDUFB7 proteo",
    "NDUFB7 rna"
  ],
  "NDUFB8": [
    "NDUFB8 cnv",
    "NDUFB8 methyl",
    "NDUFB8 proteo",
    "NDUFB8 rna"
  ],
  "NDUFB9": [
    "NDUFB9 cnv",
    "NDUFB9 methyl",
    "NDUFB9 proteo",
    "NDUFB9 rna"
  ],
  "NDUFC1": [
    "NDUFC1 cnv",
    "NDUFC1 methyl",
    "NDUFC1 proteo",
    "NDUFC1 rna"
  ],
  "NDUFC2": [
    "NDUFC2 cnv",
    "NDUFC2 methyl",
    "NDUFC2 proteo",
    "NDUFC2 rna"
  ],
  "NDUFC2-KCTD14": [
    "NDUFC2-KCTD14 cnv",
    "NDUFC2-KCTD14 methyl",
    "NDUFC2-KCTD14 rna"
  ],
  "NDUFS1": [
    "NDUFS1 cnv",
    "NDUFS1 methyl",
    "NDUFS1 proteo",
    "NDUFS1 rna"
  ],
  "NDUFS2": [
    "NDUFS2 cnv",
    "NDUFS2 methyl",
    "NDUFS2 proteo",
    "NDUFS2 rna"
  ],
  "NDUFS3": [
    "NDUFS3 cnv",
    "NDUFS3 methyl",
    "NDUFS3 proteo",
    "NDUFS3 rna"
  ],
  "NDUFS4": [
    "NDUFS4 cnv",
    "NDUFS4 proteo",
    "NDUFS4 rna"
  ],
  "NDUFS5": [
    "NDUFS5 cnv",
    "NDUFS5 proteo",
    "NDUFS5 rna"
  ],
  "NDUFS6": [
    "NDUFS6 cnv",
    "NDUFS6 methyl",
    "NDUFS6 proteo",
    "NDUFS6 rna"
  ],
  "NDUFS7": [
    "NDUFS7 cnv",
    "NDUFS7 methyl",
    "NDUFS7 proteo",
    "NDUFS7 rna"
  ],
  "NDUFS8": [
    "NDUFS8 cnv",
    "NDUFS8 methyl",
    "NDUFS8 proteo",
    "NDUFS8 rna"
  ],
  "NDUFV1": [
    "NDUFV1 cnv",
    "NDUFV1 methyl",
    "NDUFV1 proteo",
    "NDUFV1 rna"
  ],
  "NDUFV1-DT": [
    "NDUFV1-DT methyl"
  ],
  "NDUFV2": [
    "NDUFV2 cnv",
    "NDUFV2 methyl",
    "NDUFV2 proteo",
    "NDUFV2 rna"
  ],
  "NDUFV3": [
    "NDUFV3 149_174_1_1_S164 phospho",
    "NDUFV3 465_470_1_1_S470 phospho",
    "NDUFV3 98_108_1_1_S98 phospho",
    "NDUFV3 cnv",
    "NDUFV3 methyl",
    "NDUFV3 proteo",
    "NDUFV3 rna"
  ],
  "NEAT1": [
    "NEAT1 methyl"
  ],
  "NEB": [
    "NEB cnv",
    "NEB rna"
  ],
  "NEBL": [
    "NEBL 150_158_1_1_T150 phospho",
    "NEBL 205_209_1_1_S209 phospho",
    "NEBL cnv",
    "NEBL methyl",
    "NEBL proteo",
    "NEBL rna"
  ],
  "NECAB1": [
    "NECAB1 cnv",
    "NECAB1 methyl",
    "NECAB1 proteo",
    "NECAB1 rna"
  ],
  "NECAB2": [
    "NECAB2 44_57_1_1_S57 phospho",
    "NECAB2 cnv",
    "NECAB2 methyl",
    "NECAB2 proteo",
    "NECAB2 rna"
  ],
  "NECAB3": [
    "NECAB3 cnv",
    "NECAB3 methyl",
    "NECAB3 rna"
  ],
  "NECAP1": [
    "NECAP1 196_211_1_1_T211 phospho",
    "NECAP1 cnv",
    "NECAP1 methyl",
    "NECAP1 proteo",
    "NECAP1 rna"
  ],
  "NECAP2": [
    "NECAP2 155_160_1_0 phospho",
    "NECAP2 cnv",
    "NECAP2 methyl",
    "NECAP2 proteo",
    "NECAP2 rna"
  ],
  "NECTIN1": [
    "NECTIN1 418_422_1_1_S422 phospho",
    "NECTIN1 434_436_1_0 phospho",
    "NECTIN1 cnv",
    "NECTIN1 methyl",
    "NECTIN1 proteo",
    "NECTIN1 rna"
  ],
  "NECTIN1-DT": [
    "NECTIN1-DT methyl"
  ],
  "NECTIN2": [
    "NECTIN2 390_410_1_1_T410 phospho",
    "NECTIN2 cnv",
    "NECTIN2 methyl",
    "NECTIN2 proteo",
    "NECTIN2 rna"
  ],
  "NECTIN3": [
    "NECTIN3 cnv",
    "NECTIN3 methyl",
    "NECTIN3 rna"
  ],
  "NECTIN4": [
    "NECTIN4 cnv",
    "NECTIN4 rna"
  ],
  "NEDD1": [
    "NEDD1 512_529_1_1_S523 phospho",
    "NEDD1 cnv",
    "NEDD1 methyl",
    "NEDD1 proteo",
    "NEDD1 rna"
  ],
  "NEDD4": [
    "NEDD4 670_675_1_1_S670 phospho",
    "NEDD4 725_743_1_0 phospho",
    "NEDD4 725_743_1_1_S743 phospho",
    "NEDD4 747_767_1_1_S747 phospho",
    "NEDD4 cnv",
    "NEDD4 methyl",
    "NEDD4 proteo",
    "NEDD4 rna"
  ],
  "NEDD4L": [
    "NEDD4L 332_361_1_0 phospho",
    "NEDD4L 418_427_1_1_S418 phospho",
    "NEDD4L 418_427_1_1_S420 phospho",
    "NEDD4L 418_436_1_1_S436 phospho",
    "NEDD4L 445_459_1_1_S447 phospho",
    "NEDD4L 445_459_2_2_S447S459 phospho",
    "NEDD4L 445_459_2_2_S451S459 phospho",
    "NEDD4L 445_459_3_3_S451S455S459 phospho",
    "NEDD4L cnv",
    "NEDD4L methyl",
    "NEDD4L proteo",
    "NEDD4L rna"
  ],
  "NEDD8": [
    "NEDD8 cnv",
    "NEDD8 methyl",
    "NEDD8 proteo",
    "NEDD8 rna"
  ],
  "NEDD8-MDP1": [
    "NEDD8-MDP1 cnv",
    "NEDD8-MDP1 methyl",
    "NEDD8-MDP1 rna"
  ],
  "NEDD9": [
    "NEDD9 cnv",
    "NEDD9 proteo",
    "NEDD9 rna"
  ],
  "NEFH": [
    "NEFH 501_511_1_1_S503 phospho",
    "NEFH 501_511_2_0 phospho",
    "NEFH 501_511_2_2_S503S511 phospho",
    "NEFH 503_511_2_2_S503S511 phospho",
    "NEFH 526_532_2_2_S526S532 phospho",
    "NEFH 53_63_1_1_S54 phospho",
    "NEFH 540_546_1_1_S546 phospho",
    "NEFH 560_560_1_1_S560 phospho",
    "NEFH 560_566_1_1_S566 phospho",
    "NEFH 560_566_2_2_S560S566 phospho",
    "NEFH 614_620_2_2_S614S620 phospho",
    "NEFH 758_763_1_1_S763 phospho",
    "NEFH 758_768_2_2_S763T768 phospho",
    "NEFH 776_776_1_1_S776 phospho",
    "NEFH 905_905_1_1_T905 phospho",
    "NEFH cnv",
    "NEFH methyl",
    "NEFH proteo",
    "NEFH rna"
  ],
  "NEFL": [
    "NEFL 38_52_1_1_S52 phospho",
    "NEFL 472_472_1_1_S472 phospho",
    "NEFL 502_502_1_1_S502 phospho",
    "NEFL 56_80_1_0 phospho",
    "NEFL 56_80_1_1_S58 phospho",
    "NEFL cnv",
    "NEFL methyl",
    "NEFL proteo",
    "NEFL rna"
  ],
  "NEFM": [
    "NEFM 44_52_1_1_S44 phospho",
    "NEFM 511_511_1_1_S511 phospho",
    "NEFM 545_553_1_1_S545 phospho",
    "NEFM 545_553_1_1_S553 phospho",
    "NEFM 545_553_2_2_S545S553 phospho",
    "NEFM 558_571_1_0 phospho",
    "NEFM 615_620_1_1_S620 phospho",
    "NEFM 615_620_2_2_S615S620 phospho",
    "NEFM 628_633_1_1_S633 phospho",
    "NEFM 628_633_2_2_S628S633 phospho",
    "NEFM 667_672_1_1_S672 phospho",
    "NEFM 667_672_2_2_S667S672 phospho",
    "NEFM 680_685_1_1_S685 phospho",
    "NEFM 680_685_2_2_S680S685 phospho",
    "NEFM 685_685_1_1_S685 phospho",
    "NEFM 736_750_1_1_S736 phospho",
    "NEFM 783_788_1_1_S783 phospho",
    "NEFM 783_788_2_2_S783S788 phospho",
    "NEFM 831_837_1_0 phospho",
    "NEFM 831_837_1_1_S837 phospho",
    "NEFM cnv",
    "NEFM methyl",
    "NEFM proteo",
    "NEFM rna"
  ],
  "NEGR1": [
    "NEGR1 KLFNGQQGIIIQNFSTR-N2H5F0S0G0 glyco",
    "NEGR1 LFNGQQGIIIQNFSTR-N2H5F0S0G0 glyco",
    "NEGR1 cnv",
    "NEGR1 methyl",
    "NEGR1 proteo",
    "NEGR1 rna"
  ],
  "NEIL1": [
    "NEIL1 cnv",
    "NEIL1 methyl",
    "NEIL1 rna"
  ],
  "NEIL2": [
    "NEIL2 cnv",
    "NEIL2 methyl",
    "NEIL2 proteo",
    "NEIL2 rna"
  ],
  "NEIL3": [
    "NEIL3 cnv",
    "NEIL3 methyl",
    "NEIL3 rna"
  ],
  "NEK1": [
    "NEK1 1078_1085_1_1_S1080 phospho",
    "NEK1 1153_1159_1_1_S1154 phospho",
    "NEK1 428_439_1_1_S436 phospho",
    "NEK1 677_694_1_1_S681 phospho",
    "NEK1 677_694_1_1_S692 phospho",
    "NEK1 cnv",
    "NEK1 kinase",
    "NEK1 methyl",
    "NEK1 proteo",
    "NEK1 rna"
  ],
  "NEK10": [
    "NEK10 cnv",
    "NEK10 kinase",
    "NEK10 methyl",
    "NEK10 rna"
  ],
  "NEK11": [
    "NEK11 cnv",
    "NEK11 kinase",
    "NEK11 methyl",
    "NEK11 proteo",
    "NEK11 rna"
  ],
  "NEK2": [
    "NEK2 cnv",
    "NEK2 kinase",
    "NEK2 methyl",
    "NEK2 rna"
  ],
  "NEK3": [
    "NEK3 337_338_1_1_S338 phospho",
    "NEK3 cnv",
    "NEK3 kinase",
    "NEK3 methyl",
    "NEK3 rna"
  ],
  "NEK4": [
    "NEK4 550_552_1_1_S550 phospho",
    "NEK4 572_578_1_1_S572 phospho",
    "NEK4 cnv",
    "NEK4 kinase",
    "NEK4 methyl",
    "NEK4 proteo",
    "NEK4 rna"
  ],
  "NEK5": [
    "NEK5 cnv",
    "NEK5 kinase",
    "NEK5 methyl",
    "NEK5 rna"
  ],
  "NEK6": [
    "NEK6 232_249_1_0 phospho",
    "NEK6 232_249_1_1_S240 phospho",
    "NEK6 cnv",
    "NEK6 kinase",
    "NEK6 methyl",
    "NEK6 proteo",
    "NEK6 rna"
  ],
  "NEK7": [
    "NEK7 cnv",
    "NEK7 kinase",
    "NEK7 methyl",
    "NEK7 proteo",
    "NEK7 rna"
  ],
  "NEK8": [
    "NEK8 cnv",
    "NEK8 kinase",
    "NEK8 methyl",
    "NEK8 rna"
  ],
  "NEK9": [
    "NEK9 331_344_1_1_T333 phospho",
    "NEK9 867_881_1_1_S881 phospho",
    "NEK9 895_906_1_1_T898 phospho",
    "NEK9 cnv",
    "NEK9 kinase",
    "NEK9 methyl",
    "NEK9 proteo",
    "NEK9 rna"
  ],
  "NELFA": [
    "NELFA 288_288_1_1_T288 phospho",
    "NELFA 364_376_1_0 phospho",
    "NELFA cnv",
    "NELFA methyl",
    "NELFA proteo",
    "NELFA rna"
  ],
  "NELFB": [
    "NELFB 605_621_1_1_S605 phospho",
    "NELFB cnv",
    "NELFB methyl",
    "NELFB proteo",
    "NELFB rna"
  ],
  "NELFCD": [
    "NELFCD cnv",
    "NELFCD methyl",
    "NELFCD proteo",
    "NELFCD rna"
  ],
  "NELFE": [
    "NELFE 113_124_1_1_S115 phospho",
    "NELFE 174_181_1_1_S181 phospho",
    "NELFE 343_353_1_1_S353 phospho",
    "NELFE 36_42_1_1_S37 phospho",
    "NELFE 49_62_1_0 phospho",
    "NELFE 89_91_1_1_T91 phospho",
    "NELFE cnv",
    "NELFE methyl",
    "NELFE proteo",
    "NELFE rna"
  ],
  "NELL1": [
    "NELL1 cnv",
    "NELL1 methyl",
    "NELL1 rna"
  ],
  "NELL2": [
    "NELL2 cnv",
    "NELL2 methyl",
    "NELL2 proteo",
    "NELL2 rna"
  ],
  "NEMF": [
    "NEMF 414_435_1_1_S417 phospho",
    "NEMF cnv",
    "NEMF methyl",
    "NEMF proteo",
    "NEMF rna"
  ],
  "NEMP1": [
    "NEMP1 cnv",
    "NEMP1 methyl",
    "NEMP1 proteo",
    "NEMP1 rna"
  ],
  "NEMP2": [
    "NEMP2 cnv",
    "NEMP2 methyl",
    "NEMP2 rna"
  ],
  "NEMP2-DT": [
    "NEMP2-DT methyl"
  ],
  "NENF": [
    "NENF cnv",
    "NENF methyl",
    "NENF proteo",
    "NENF rna"
  ],
  "NEO1": [
    "NEO1 1178_1188_1_1_S1178 phospho",
    "NEO1 1214_1226_1_1_S1214 phospho",
    "NEO1 TPASDPHGDNLTYSVFYTK-N5H3F1S0G0 glyco",
    "NEO1 cnv",
    "NEO1 methyl",
    "NEO1 proteo",
    "NEO1 rna"
  ],
  "NEPRO": [
    "NEPRO cnv",
    "NEPRO methyl",
    "NEPRO rna"
  ],
  "NES": [
    "NES 1003_1016_1_1_S1016 phospho",
    "NES 1261_1282_1_1_S1282 phospho",
    "NES 1286_1304_1_1_S1286 phospho",
    "NES 1339_1347_1_1_S1347 phospho",
    "NES 1409_1418_1_1_S1418 phospho",
    "NES 1409_1418_2_2_S1409S1418 phospho",
    "NES 1441_1452_1_1_S1442 phospho",
    "NES 1441_1452_1_1_S1445 phospho",
    "NES 1441_1452_1_1_S1450 phospho",
    "NES 1483_1506_1_0 phospho",
    "NES 1483_1506_1_1_S1502 phospho",
    "NES 1483_1506_2_2_S1496S1498 phospho",
    "NES 1546_1585_1_0 phospho",
    "NES 1546_1585_1_1_S1571 phospho",
    "NES 1546_1585_1_1_S1577 phospho",
    "NES 1577_1585_1_1_S1577 phospho",
    "NES 1577_1590_1_1_S1590 phospho",
    "NES 1589_1590_1_1_S1590 phospho",
    "NES 1615_1618_1_1_S1618 phospho",
    "NES 315_320_1_1_T315 phospho",
    "NES 322_325_1_1_S323 phospho",
    "NES 322_325_1_1_S325 phospho",
    "NES 322_338_1_1_T338 phospho",
    "NES 338_338_1_1_T338 phospho",
    "NES 346_366_1_0 phospho",
    "NES 346_366_1_1_S346 phospho",
    "NES 346_366_1_1_S352 phospho",
    "NES 346_366_1_1_S358 phospho",
    "NES 346_366_2_0 phospho",
    "NES 346_366_2_2_S346S358 phospho",
    "NES 346_366_2_2_S352S358 phospho",
    "NES 382_398_1_1_S398 phospho",
    "NES 382_398_1_1_T382 phospho",
    "NES 382_398_1_1_T388 phospho",
    "NES 382_398_1_1_T393 phospho",
    "NES 413_417_1_1_S413 phospho",
    "NES 439_476_1_1_S471 phospho",
    "NES 439_476_2_0 phospho",
    "NES 455_476_1_0 phospho",
    "NES 455_476_1_1_S471 phospho",
    "NES 455_476_2_2_S459S471 phospho",
    "NES 455_476_2_2_S471S476 phospho",
    "NES 455_487_1_1_S471 phospho",
    "NES 517_518_1_1_S518 phospho",
    "NES 548_556_1_1_S548 phospho",
    "NES 559_567_1_1_S564 phospho",
    "NES 559_585_1_1_S578 phospho",
    "NES 622_627_1_1_S627 phospho",
    "NES 680_680_1_1_S680 phospho",
    "NES 680_693_1_1_S680 phospho",
    "NES 702_702_1_1_S702 phospho",
    "NES 724_738_1_1_S731 phospho",
    "NES 743_754_1_1_S746 phospho",
    "NES 746_754_1_1_S746 phospho",
    "NES 768_776_1_1_S768 phospho",
    "NES 790_790_1_1_S790 phospho",
    "NES 809_814_1_1_S809 phospho",
    "NES 820_828_1_1_S820 phospho",
    "NES 831_851_1_1_S842 phospho",
    "NES 831_851_2_2_S842T851 phospho",
    "NES 842_851_1_1_S842 phospho",
    "NES 842_851_1_1_T851 phospho",
    "NES 894_905_1_1_S905 phospho",
    "NES 894_913_1_1_S905 phospho",
    "NES 928_945_1_1_S934 phospho",
    "NES 928_945_2_2_S931S934 phospho",
    "NES 934_945_1_1_S945 phospho",
    "NES 965_965_1_1_S965 phospho",
    "NES 989_1016_1_1_S1016 phospho",
    "NES cnv",
    "NES methyl",
    "NES proteo",
    "NES rna"
  ],
  "NET1": [
    "NET1 cnv",
    "NET1 methyl",
    "NET1 rna"
  ],
  "NETO1": [
    "NETO1 cnv",
    "NETO1 methyl",
    "NETO1 rna"
  ],
  "NETO1-DT": [
    "NETO1-DT methyl"
  ],
  "NETO2": [
    "NETO2 cnv",
    "NETO2 proteo",
    "NETO2 rna"
  ],
  "NEU1": [
    "NEU1 cnv",
    "NEU1 methyl",
    "NEU1 proteo",
    "NEU1 rna"
  ],
  "NEU2": [
    "NEU2 cnv",
    "NEU2 rna"
  ],
  "NEU3": [
    "NEU3 cnv",
    "NEU3 methyl",
    "NEU3 proteo",
    "NEU3 rna"
  ],
  "NEU4": [
    "NEU4 cnv",
    "NEU4 methyl",
    "NEU4 proteo",
    "NEU4 rna"
  ],
  "NEURL1": [
    "NEURL1 cnv",
    "NEURL1 methyl",
    "NEURL1 rna"
  ],
  "NEURL1B": [
    "NEURL1B cnv",
    "NEURL1B methyl",
    "NEURL1B rna"
  ],
  "NEURL2": [
    "NEURL2 cnv",
    "NEURL2 methyl",
    "NEURL2 rna"
  ],
  "NEURL3": [
    "NEURL3 cnv",
    "NEURL3 methyl",
    "NEURL3 rna"
  ],
  "NEURL4": [
    "NEURL4 900_905_1_1_S905 phospho",
    "NEURL4 cnv",
    "NEURL4 methyl",
    "NEURL4 proteo",
    "NEURL4 rna"
  ],
  "NEUROD1": [
    "NEUROD1 cnv",
    "NEUROD1 methyl",
    "NEUROD1 rna"
  ],
  "NEUROD2": [
    "NEUROD2 cnv",
    "NEUROD2 methyl",
    "NEUROD2 rna"
  ],
  "NEUROD4": [
    "NEUROD4 cnv",
    "NEUROD4 rna"
  ],
  "NEUROD6": [
    "NEUROD6 cnv",
    "NEUROD6 rna"
  ],
  "NEUROG1": [
    "NEUROG1 cnv",
    "NEUROG1 methyl",
    "NEUROG1 rna"
  ],
  "NEUROG2": [
    "NEUROG2 cnv",
    "NEUROG2 methyl",
    "NEUROG2 rna"
  ],
  "NEUROG3": [
    "NEUROG3 cnv",
    "NEUROG3 methyl",
    "NEUROG3 rna"
  ],
  "NEXMIF": [
    "NEXMIF methyl",
    "NEXMIF rna"
  ],
  "NEXN": [
    "NEXN 16_24_1_0 phospho",
    "NEXN 16_24_1_1_S16 phospho",
    "NEXN 299_306_1_1_S301 phospho",
    "NEXN cnv",
    "NEXN methyl",
    "NEXN proteo",
    "NEXN rna"
  ],
  "NF1": [
    "NF1 2470_2475_1_1_S2475 phospho",
    "NF1 2479_2494_1_1_S2494 phospho",
    "NF1 2540_2544_1_1_T2544 phospho",
    "NF1 2781_2789_1_1_S2781 phospho",
    "NF1 856_871_1_1_S864 phospho",
    "NF1 cnv",
    "NF1 methyl",
    "NF1 mut",
    "NF1 proteo",
    "NF1 rna"
  ],
  "NF2": [
    "NF2 518_518_1_1_S518 phospho",
    "NF2 581_584_1_1_T581 phospho",
    "NF2 cnv",
    "NF2 methyl",
    "NF2 proteo",
    "NF2 rna"
  ],
  "NFAM1": [
    "NFAM1 cnv",
    "NFAM1 rna"
  ],
  "NFASC": [
    "NFASC 1221_1238_1_1_S1231 phospho",
    "NFASC AVYQCNTSNEHGYLLANAFVSVLDVPPR-N2H6F0S0G0 glyco",
    "NFASC AVYQCNTSNEHGYLLANAFVSVLDVPPR-N2H7F0S0G0 glyco",
    "NFASC EAWNNVTVWGSR-N5H3F1S0G0 glyco",
    "NFASC EAWNNVTVWGSR-N5H4F2S0G0 glyco",
    "NFASC ITNVSEEDSGEYFCLASNK-N2H5F0S0G0 glyco",
    "NFASC NGQGSNLDGGNYHVYENGSLEIK-N2H5F0S0G0 glyco",
    "NFASC NGQGSNLDGGNYHVYENGSLEIK-N2H6F0S0G0 glyco",
    "NFASC NGQGSNLDGGNYHVYENGSLEIK-N2H9F0S0G0 glyco",
    "NFASC QIVENFSPNQTK-N4H3F1S0G0 glyco",
    "NFASC QIVENFSPNQTK-N4H5F1S1G0 glyco",
    "NFASC QIVENFSPNQTK-N5H3F1S0G0 glyco",
    "NFASC QIVENFSPNQTK-N5H4F1S0G0 glyco",
    "NFASC QIVENFSPNQTK-N5H4F2S0G0 glyco",
    "NFASC VMNSTAISLQWNR-N2H5F0S0G0 glyco",
    "NFASC YVAFNGTK-N2H4F0S0G0 glyco",
    "NFASC YVAFNGTK-N2H5F0S0G0 glyco",
    "NFASC YVAFNGTK-N2H6F0S0G0 glyco",
    "NFASC YVAFNGTK-N2H7F0S0G0 glyco",
    "NFASC YVAFNGTK-N2H8F0S0G0 glyco",
    "NFASC cnv",
    "NFASC proteo",
    "NFASC rna"
  ],
  "NFAT5": [
    "NFAT5 143_153_1_1_T153 phospho",
    "NFAT5 577_584_1_1_S578 phospho",
    "NFAT5 cnv",
    "NFAT5 methyl",
    "NFAT5 proteo",
    "NFAT5 rna"
  ],
  "NFATC1": [
    "NFATC1 cnv",
    "NFATC1 methyl",
    "NFATC1 proteo",
    "NFATC1 rna"
  ],
  "NFATC2": [
    "NFATC2 196_201_1_1_S197 phospho",
    "NFATC2 836_851_1_1_S836 phospho",
    "NFATC2 cnv",
    "NFATC2 methyl",
    "NFATC2 proteo",
    "NFATC2 rna"
  ],
  "NFATC2IP": [
    "NFATC2IP 190_204_1_1_S204 phospho",
    "NFATC2IP cnv",
    "NFATC2IP methyl",
    "NFATC2IP proteo",
    "NFATC2IP rna"
  ],
  "NFATC3": [
    "NFATC3 cnv",
    "NFATC3 methyl",
    "NFATC3 proteo",
    "NFATC3 rna"
  ],
  "NFATC4": [
    "NFATC4 334_348_1_1_S335 phospho",
    "NFATC4 352_358_1_1_S352 phospho",
    "NFATC4 396_398_1_1_S397 phospho",
    "NFATC4 cnv",
    "NFATC4 methyl",
    "NFATC4 rna"
  ],
  "NFE2": [
    "NFE2 cnv",
    "NFE2 rna"
  ],
  "NFE2L1": [
    "NFE2L1 cnv",
    "NFE2L1 methyl",
    "NFE2L1 rna"
  ],
  "NFE2L1-DT": [
    "NFE2L1-DT methyl"
  ],
  "NFE2L2": [
    "NFE2L2 cnv",
    "NFE2L2 methyl",
    "NFE2L2 rna"
  ],
  "NFE2L3": [
    "NFE2L3 cnv",
    "NFE2L3 methyl",
    "NFE2L3 rna"
  ],
  "NFIA": [
    "NFIA 265_275_1_1_T269 phospho",
    "NFIA 280_295_1_0 phospho",
    "NFIA cnv",
    "NFIA methyl",
    "NFIA proteo",
    "NFIA rna"
  ],
  "NFIB": [
    "NFIB cnv",
    "NFIB methyl",
    "NFIB proteo",
    "NFIB rna"
  ],
  "NFIC": [
    "NFIC 284_310_1_0 phospho",
    "NFIC 284_310_1_1_S305 phospho",
    "NFIC 284_310_2_1_S294 phospho",
    "NFIC 314_323_1_0 phospho",
    "NFIC 314_323_1_1_S323 phospho",
    "NFIC 328_343_1_1_S333 phospho",
    "NFIC 328_343_1_1_S339 phospho",
    "NFIC 333_343_1_1_S339 phospho",
    "NFIC 333_343_1_1_S343 phospho",
    "NFIC cnv",
    "NFIC methyl",
    "NFIC proteo",
    "NFIC rna"
  ],
  "NFIL3": [
    "NFIL3 301_301_1_1_S301 phospho",
    "NFIL3 352_359_1_1_S353 phospho",
    "NFIL3 cnv",
    "NFIL3 methyl",
    "NFIL3 rna"
  ],
  "NFILZ": [
    "NFILZ cnv",
    "NFILZ rna"
  ],
  "NFIX": [
    "NFIX 273_283_1_1_S276 phospho",
    "NFIX 288_306_1_0 phospho",
    "NFIX 288_306_1_1_S296 phospho",
    "NFIX 288_306_2_0 phospho",
    "NFIX 309_330_1_1_S309 phospho",
    "NFIX 355_369_1_1_S369 phospho",
    "NFIX 460_484_1_1_S474 phospho",
    "NFIX 460_484_1_1_T471 phospho",
    "NFIX 460_484_2_2_T471S474 phospho",
    "NFIX cnv",
    "NFIX methyl",
    "NFIX proteo",
    "NFIX rna"
  ],
  "NFKB1": [
    "NFKB1 cnv",
    "NFKB1 methyl",
    "NFKB1 proteo",
    "NFKB1 rna"
  ],
  "NFKB2": [
    "NFKB2 cnv",
    "NFKB2 methyl",
    "NFKB2 proteo",
    "NFKB2 rna"
  ],
  "NFKBIA": [
    "NFKBIA cnv",
    "NFKBIA methyl",
    "NFKBIA proteo",
    "NFKBIA rna"
  ],
  "NFKBIB": [
    "NFKBIB cnv",
    "NFKBIB methyl",
    "NFKBIB proteo",
    "NFKBIB rna"
  ],
  "NFKBID": [
    "NFKBID cnv",
    "NFKBID methyl",
    "NFKBID rna"
  ],
  "NFKBIE": [
    "NFKBIE cnv",
    "NFKBIE proteo",
    "NFKBIE rna"
  ],
  "NFKBIL1": [
    "NFKBIL1 cnv",
    "NFKBIL1 proteo",
    "NFKBIL1 rna"
  ],
  "NFKBIZ": [
    "NFKBIZ cnv",
    "NFKBIZ methyl",
    "NFKBIZ rna"
  ],
  "NFRKB": [
    "NFRKB 1282_1291_1_1_S1291 phospho",
    "NFRKB 226_228_1_1_S228 phospho",
    "NFRKB cnv",
    "NFRKB methyl",
    "NFRKB proteo",
    "NFRKB rna"
  ],
  "NFS1": [
    "NFS1 cnv",
    "NFS1 methyl",
    "NFS1 proteo",
    "NFS1 rna"
  ],
  "NFU1": [
    "NFU1 cnv",
    "NFU1 methyl",
    "NFU1 proteo",
    "NFU1 rna"
  ],
  "NFX1": [
    "NFX1 140_154_1_1_S150 phospho",
    "NFX1 150_154_1_1_S150 phospho",
    "NFX1 48_57_1_1_S50 phospho",
    "NFX1 cnv",
    "NFX1 methyl",
    "NFX1 proteo",
    "NFX1 rna"
  ],
  "NFXL1": [
    "NFXL1 331_331_1_1_S331 phospho",
    "NFXL1 cnv",
    "NFXL1 methyl",
    "NFXL1 proteo",
    "NFXL1 rna"
  ],
  "NFYA": [
    "NFYA 326_341_1_1_S326 phospho",
    "NFYA cnv",
    "NFYA methyl",
    "NFYA proteo",
    "NFYA rna"
  ],
  "NFYB": [
    "NFYB cnv",
    "NFYB methyl",
    "NFYB proteo",
    "NFYB rna"
  ],
  "NFYC": [
    "NFYC cnv",
    "NFYC methyl",
    "NFYC proteo",
    "NFYC rna"
  ],
  "NGB": [
    "NGB cnv",
    "NGB methyl",
    "NGB rna"
  ],
  "NGDN": [
    "NGDN cnv",
    "NGDN proteo",
    "NGDN rna"
  ],
  "NGEF": [
    "NGEF 604_604_1_1_S604 phospho",
    "NGEF cnv",
    "NGEF methyl",
    "NGEF proteo",
    "NGEF rna"
  ],
  "NGF": [
    "NGF cnv",
    "NGF methyl",
    "NGF rna"
  ],
  "NGFR": [
    "NGFR 287_293_1_1_T293 phospho",
    "NGFR 303_325_1_1_S313 phospho",
    "NGFR 303_325_2_2_S311S313 phospho",
    "NGFR cnv",
    "NGFR methyl",
    "NGFR proteo",
    "NGFR rna"
  ],
  "NGLY1": [
    "NGLY1 cnv",
    "NGLY1 methyl",
    "NGLY1 proteo",
    "NGLY1 rna"
  ],
  "NGRN": [
    "NGRN cnv",
    "NGRN methyl",
    "NGRN proteo",
    "NGRN rna"
  ],
  "NHEJ1": [
    "NHEJ1 cnv",
    "NHEJ1 methyl",
    "NHEJ1 proteo",
    "NHEJ1 rna"
  ],
  "NHIP": [
    "NHIP methyl"
  ],
  "NHLH1": [
    "NHLH1 cnv",
    "NHLH1 rna"
  ],
  "NHLH2": [
    "NHLH2 cnv",
    "NHLH2 rna"
  ],
  "NHLRC1": [
    "NHLRC1 cnv",
    "NHLRC1 methyl",
    "NHLRC1 rna"
  ],
  "NHLRC2": [
    "NHLRC2 cnv",
    "NHLRC2 methyl",
    "NHLRC2 proteo",
    "NHLRC2 rna"
  ],
  "NHLRC3": [
    "NHLRC3 cnv",
    "NHLRC3 methyl",
    "NHLRC3 proteo",
    "NHLRC3 rna"
  ],
  "NHLRC4": [
    "NHLRC4 cnv",
    "NHLRC4 rna"
  ],
  "NHP2": [
    "NHP2 cnv",
    "NHP2 methyl",
    "NHP2 proteo",
    "NHP2 rna"
  ],
  "NHS": [
    "NHS 154_155_1_1_T155 phospho",
    "NHS 819_825_1_1_T820 phospho",
    "NHS methyl",
    "NHS proteo",
    "NHS rna"
  ],
  "NHSL1": [
    "NHSL1 1085_1093_1_1_S1085 phospho",
    "NHSL1 1454_1470_1_0 phospho",
    "NHSL1 318_324_1_1_S324 phospho",
    "NHSL1 926_937_1_1_S937 phospho",
    "NHSL1 cnv",
    "NHSL1 methyl",
    "NHSL1 proteo",
    "NHSL1 rna"
  ],
  "NHSL2": [
    "NHSL2 1034_1043_1_1_S1034 phospho",
    "NHSL2 1139_1143_1_1_S1143 phospho",
    "NHSL2 498_512_1_1_S500 phospho",
    "NHSL2 574_590_1_1_S576 phospho",
    "NHSL2 685_691_1_1_T686 phospho",
    "NHSL2 801_803_1_0 phospho",
    "NHSL2 801_803_1_1_S801 phospho",
    "NHSL2 methyl",
    "NHSL2 proteo",
    "NHSL2 rna"
  ],
  "NIBAN1": [
    "NIBAN1 577_596_1_0 phospho",
    "NIBAN1 577_596_1_1_S582 phospho",
    "NIBAN1 577_596_2_0 phospho",
    "NIBAN1 639_658_1_1_S641 phospho",
    "NIBAN1 cnv",
    "NIBAN1 methyl",
    "NIBAN1 proteo",
    "NIBAN1 rna"
  ],
  "NIBAN2": [
    "NIBAN2 652_668_1_1_S668 phospho",
    "NIBAN2 652_668_2_2_S652S668 phospho",
    "NIBAN2 678_683_1_1_S679 phospho",
    "NIBAN2 cnv",
    "NIBAN2 methyl",
    "NIBAN2 proteo",
    "NIBAN2 rna"
  ],
  "NIBAN3": [
    "NIBAN3 cnv",
    "NIBAN3 methyl",
    "NIBAN3 rna"
  ],
  "NICN1": [
    "NICN1 cnv",
    "NICN1 methyl",
    "NICN1 rna"
  ],
  "NID1": [
    "NID1 cnv",
    "NID1 methyl",
    "NID1 proteo",
    "NID1 rna"
  ],
  "NID2": [
    "NID2 DYSLTFGAINQTWSYR-N4H3F1S0G0 glyco",
    "NID2 DYSLTFGAINQTWSYR-N4H4F1S0G0 glyco",
    "NID2 DYSLTFGAINQTWSYR-N4H5F1S0G0 glyco",
    "NID2 DYSLTFGAINQTWSYR-N4H5F1S1G0 glyco",
    "NID2 DYSLTFGAINQTWSYR-N5H3F1S0G0 glyco",
    "NID2 IHQNITYQVCR-N3H3F1S0G0 glyco",
    "NID2 IHQNITYQVCR-N3H4F1S0G0 glyco",
    "NID2 IHQNITYQVCR-N4H3F1S0G0 glyco",
    "NID2 IHQNITYQVCR-N4H4F1S0G0 glyco",
    "NID2 IHQNITYQVCR-N4H4F1S1G0 glyco",
    "NID2 IHQNITYQVCR-N4H5F1S0G0 glyco",
    "NID2 IHQNITYQVCR-N4H5F1S1G0 glyco",
    "NID2 IHQNITYQVCR-N5H3F1S0G0 glyco",
    "NID2 IHQNITYQVCR-N5H4F1S0G0 glyco",
    "NID2 IHQNITYQVCR-N5H5F1S0G0 glyco",
    "NID2 TNIQGQVPYVSANFTAHISPYK-N7H4F0S0G0 glyco",
    "NID2 cnv",
    "NID2 methyl",
    "NID2 proteo",
    "NID2 rna"
  ],
  "NIF3L1": [
    "NIF3L1 cnv",
    "NIF3L1 proteo",
    "NIF3L1 rna"
  ],
  "NIFK": [
    "NIFK cnv",
    "NIFK methyl",
    "NIFK proteo",
    "NIFK rna"
  ],
  "NIFK-AS1": [
    "NIFK-AS1 methyl"
  ],
  "NIM1K": [
    "NIM1K cnv",
    "NIM1K kinase",
    "NIM1K methyl",
    "NIM1K rna"
  ],
  "NIN": [
    "NIN 149_155_1_1_S152 phospho",
    "NIN 1546_1550_1_1_S1550 phospho",
    "NIN 269_276_1_1_S269 phospho",
    "NIN cnv",
    "NIN methyl",
    "NIN proteo",
    "NIN rna"
  ],
  "NINJ1": [
    "NINJ1 cnv",
    "NINJ1 methyl",
    "NINJ1 proteo",
    "NINJ1 rna"
  ],
  "NINJ2": [
    "NINJ2 cnv",
    "NINJ2 proteo",
    "NINJ2 rna"
  ],
  "NINJ2-AS1": [
    "NINJ2-AS1 methyl"
  ],
  "NINL": [
    "NINL cnv",
    "NINL methyl",
    "NINL rna"
  ],
  "NIP7": [
    "NIP7 cnv",
    "NIP7 methyl",
    "NIP7 proteo",
    "NIP7 rna"
  ],
  "NIPA1": [
    "NIPA1 cnv",
    "NIPA1 methyl",
    "NIPA1 proteo",
    "NIPA1 rna"
  ],
  "NIPA2": [
    "NIPA2 cnv",
    "NIPA2 methyl",
    "NIPA2 rna"
  ],
  "NIPAL1": [
    "NIPAL1 cnv",
    "NIPAL1 methyl",
    "NIPAL1 rna"
  ],
  "NIPAL2": [
    "NIPAL2 cnv",
    "NIPAL2 methyl",
    "NIPAL2 rna"
  ],
  "NIPAL3": [
    "NIPAL3 cnv",
    "NIPAL3 proteo",
    "NIPAL3 rna"
  ],
  "NIPAL4": [
    "NIPAL4 cnv",
    "NIPAL4 methyl",
    "NIPAL4 rna"
  ],
  "NIPBL": [
    "NIPBL 2651_2658_1_1_S2658 phospho",
    "NIPBL 2663_2684_1_1_S2672 phospho",
    "NIPBL 2663_2684_2_2_T2667S2672 phospho",
    "NIPBL 274_287_1_1_S280 phospho",
    "NIPBL 291_306_1_1_S306 phospho",
    "NIPBL 318_318_1_1_S318 phospho",
    "NIPBL 345_352_1_1_S350 phospho",
    "NIPBL 591_599_1_1_T599 phospho",
    "NIPBL 718_724_1_1_T724 phospho",
    "NIPBL 735_735_1_1_T735 phospho",
    "NIPBL cnv",
    "NIPBL methyl",
    "NIPBL proteo",
    "NIPBL rna"
  ],
  "NIPBL-DT": [
    "NIPBL-DT methyl"
  ],
  "NIPSNAP1": [
    "NIPSNAP1 cnv",
    "NIPSNAP1 methyl",
    "NIPSNAP1 proteo",
    "NIPSNAP1 rna"
  ],
  "NIPSNAP2": [
    "NIPSNAP2 cnv",
    "NIPSNAP2 methyl",
    "NIPSNAP2 proteo",
    "NIPSNAP2 rna"
  ],
  "NIPSNAP3A": [
    "NIPSNAP3A cnv",
    "NIPSNAP3A methyl",
    "NIPSNAP3A proteo",
    "NIPSNAP3A rna"
  ],
  "NIPSNAP3B": [
    "NIPSNAP3B cnv",
    "NIPSNAP3B methyl",
    "NIPSNAP3B rna"
  ],
  "NISCH": [
    "NISCH 50_51_1_1_S51 phospho",
    "NISCH cnv",
    "NISCH methyl",
    "NISCH proteo",
    "NISCH rna"
  ],
  "NIT1": [
    "NIT1 cnv",
    "NIT1 methyl",
    "NIT1 proteo",
    "NIT1 rna"
  ],
  "NIT2": [
    "NIT2 cnv",
    "NIT2 methyl",
    "NIT2 proteo",
    "NIT2 rna"
  ],
  "NKAIN1": [
    "NKAIN1 cnv",
    "NKAIN1 rna"
  ],
  "NKAIN2": [
    "NKAIN2 cnv",
    "NKAIN2 methyl",
    "NKAIN2 rna"
  ],
  "NKAIN3": [
    "NKAIN3 cnv",
    "NKAIN3 methyl",
    "NKAIN3 proteo",
    "NKAIN3 rna"
  ],
  "NKAIN4": [
    "NKAIN4 cnv",
    "NKAIN4 methyl",
    "NKAIN4 rna"
  ],
  "NKAP": [
    "NKAP 149_149_1_1_S149 phospho",
    "NKAP methyl",
    "NKAP proteo",
    "NKAP rna"
  ],
  "NKAPD1": [
    "NKAPD1 cnv",
    "NKAPD1 methyl",
    "NKAPD1 proteo",
    "NKAPD1 rna"
  ],
  "NKAPL": [
    "NKAPL cnv",
    "NKAPL methyl",
    "NKAPL rna"
  ],
  "NKAPP1": [
    "NKAPP1 methyl"
  ],
  "NKD1": [
    "NKD1 cnv",
    "NKD1 methyl",
    "NKD1 rna"
  ],
  "NKD2": [
    "NKD2 cnv",
    "NKD2 methyl",
    "NKD2 rna"
  ],
  "NKG7": [
    "NKG7 cnv",
    "NKG7 rna"
  ],
  "NKILA": [
    "NKILA methyl"
  ],
  "NKIRAS1": [
    "NKIRAS1 cnv",
    "NKIRAS1 methyl",
    "NKIRAS1 proteo",
    "NKIRAS1 rna"
  ],
  "NKIRAS2": [
    "NKIRAS2 cnv",
    "NKIRAS2 methyl",
    "NKIRAS2 proteo",
    "NKIRAS2 rna"
  ],
  "NKPD1": [
    "NKPD1 cnv",
    "NKPD1 rna"
  ],
  "NKRF": [
    "NKRF 436_444_1_1_S444 phospho",
    "NKRF methyl",
    "NKRF proteo",
    "NKRF rna"
  ],
  "NKTR": [
    "NKTR 463_468_1_1_S463 phospho",
    "NKTR cnv",
    "NKTR methyl",
    "NKTR proteo",
    "NKTR rna"
  ],
  "NKX1-1": [
    "NKX1-1 cnv",
    "NKX1-1 methyl",
    "NKX1-1 rna"
  ],
  "NKX1-2": [
    "NKX1-2 cnv",
    "NKX1-2 methyl",
    "NKX1-2 rna"
  ],
  "NKX2-1": [
    "NKX2-1 cnv",
    "NKX2-1 methyl",
    "NKX2-1 rna"
  ],
  "NKX2-1-AS1": [
    "NKX2-1-AS1 methyl"
  ],
  "NKX2-2": [
    "NKX2-2 cnv",
    "NKX2-2 methyl",
    "NKX2-2 rna"
  ],
  "NKX2-3": [
    "NKX2-3 cnv",
    "NKX2-3 methyl",
    "NKX2-3 rna"
  ],
  "NKX2-4": [
    "NKX2-4 cnv",
    "NKX2-4 methyl",
    "NKX2-4 rna"
  ],
  "NKX2-5": [
    "NKX2-5 cnv",
    "NKX2-5 methyl",
    "NKX2-5 rna"
  ],
  "NKX2-6": [
    "NKX2-6 cnv",
    "NKX2-6 methyl"
  ],
  "NKX2-8": [
    "NKX2-8 cnv",
    "NKX2-8 methyl",
    "NKX2-8 rna"
  ],
  "NKX3-1": [
    "NKX3-1 cnv",
    "NKX3-1 methyl",
    "NKX3-1 rna"
  ],
  "NKX3-2": [
    "NKX3-2 cnv",
    "NKX3-2 methyl",
    "NKX3-2 rna"
  ],
  "NKX6-1": [
    "NKX6-1 cnv",
    "NKX6-1 methyl",
    "NKX6-1 rna"
  ],
  "NKX6-2": [
    "NKX6-2 cnv",
    "NKX6-2 methyl",
    "NKX6-2 rna"
  ],
  "NKX6-3": [
    "NKX6-3 cnv",
    "NKX6-3 rna"
  ],
  "NLE1": [
    "NLE1 cnv",
    "NLE1 methyl",
    "NLE1 proteo",
    "NLE1 rna"
  ],
  "NLGN1": [
    "NLGN1 cnv",
    "NLGN1 methyl",
    "NLGN1 proteo",
    "NLGN1 rna"
  ],
  "NLGN2": [
    "NLGN2 713_720_1_0 phospho",
    "NLGN2 713_720_1_1_S713 phospho",
    "NLGN2 cnv",
    "NLGN2 methyl",
    "NLGN2 proteo",
    "NLGN2 rna"
  ],
  "NLGN3": [
    "NLGN3 proteo",
    "NLGN3 rna"
  ],
  "NLGN4X": [
    "NLGN4X methyl",
    "NLGN4X proteo",
    "NLGN4X rna"
  ],
  "NLGN4Y": [
    "NLGN4Y methyl",
    "NLGN4Y rna"
  ],
  "NLK": [
    "NLK 298_306_1_1_T298 phospho",
    "NLK cnv",
    "NLK kinase",
    "NLK methyl",
    "NLK rna"
  ],
  "NLN": [
    "NLN cnv",
    "NLN methyl",
    "NLN proteo",
    "NLN rna"
  ],
  "NLRC3": [
    "NLRC3 cnv",
    "NLRC3 rna"
  ],
  "NLRC4": [
    "NLRC4 cnv",
    "NLRC4 rna"
  ],
  "NLRC5": [
    "NLRC5 cnv",
    "NLRC5 methyl",
    "NLRC5 rna"
  ],
  "NLRP1": [
    "NLRP1 cnv",
    "NLRP1 rna"
  ],
  "NLRP10": [
    "NLRP10 cnv",
    "NLRP10 rna"
  ],
  "NLRP11": [
    "NLRP11 cnv",
    "NLRP11 rna"
  ],
  "NLRP12": [
    "NLRP12 cnv",
    "NLRP12 rna"
  ],
  "NLRP13": [
    "NLRP13 cnv"
  ],
  "NLRP14": [
    "NLRP14 cnv",
    "NLRP14 methyl",
    "NLRP14 rna"
  ],
  "NLRP2": [
    "NLRP2 cnv",
    "NLRP2 methyl",
    "NLRP2 rna"
  ],
  "NLRP2B": [
    "NLRP2B rna"
  ],
  "NLRP3": [
    "NLRP3 cnv",
    "NLRP3 methyl",
    "NLRP3 rna"
  ],
  "NLRP4": [
    "NLRP4 cnv",
    "NLRP4 methyl",
    "NLRP4 rna"
  ],
  "NLRP5": [
    "NLRP5 cnv"
  ],
  "NLRP6": [
    "NLRP6 cnv",
    "NLRP6 rna"
  ],
  "NLRP7": [
    "NLRP7 cnv",
    "NLRP7 rna"
  ],
  "NLRP8": [
    "NLRP8 cnv"
  ],
  "NLRP9": [
    "NLRP9 cnv"
  ],
  "NLRX1": [
    "NLRX1 cnv",
    "NLRX1 methyl",
    "NLRX1 proteo",
    "NLRX1 rna"
  ],
  "NMB": [
    "NMB cnv",
    "NMB methyl",
    "NMB rna"
  ],
  "NMBR": [
    "NMBR cnv",
    "NMBR methyl",
    "NMBR rna"
  ],
  "NMD3": [
    "NMD3 cnv",
    "NMD3 methyl",
    "NMD3 proteo",
    "NMD3 rna"
  ],
  "NME1": [
    "NME1 120_125_1_1_S120 phospho",
    "NME1 120_125_1_1_S122 phospho",
    "NME1 cnv",
    "NME1 methyl",
    "NME1 proteo",
    "NME1 rna"
  ],
  "NME1-NME2": [
    "NME1-NME2 cnv",
    "NME1-NME2 methyl",
    "NME1-NME2 rna"
  ],
  "NME2": [
    "NME2 cnv",
    "NME2 methyl",
    "NME2 rna"
  ],
  "NME3": [
    "NME3 cnv",
    "NME3 methyl",
    "NME3 proteo",
    "NME3 rna"
  ],
  "NME4": [
    "NME4 30_36_1_1_S30 phospho",
    "NME4 cnv",
    "NME4 methyl",
    "NME4 proteo",
    "NME4 rna"
  ],
  "NME5": [
    "NME5 cnv",
    "NME5 rna"
  ],
  "NME6": [
    "NME6 cnv",
    "NME6 methyl",
    "NME6 proteo",
    "NME6 rna"
  ],
  "NME7": [
    "NME7 cnv",
    "NME7 proteo",
    "NME7 rna"
  ],
  "NME8": [
    "NME8 cnv",
    "NME8 rna"
  ],
  "NME9": [
    "NME9 cnv",
    "NME9 methyl",
    "NME9 rna"
  ],
  "NMI": [
    "NMI cnv",
    "NMI methyl",
    "NMI proteo",
    "NMI rna"
  ],
  "NMNAT1": [
    "NMNAT1 109_119_1_1_S117 phospho",
    "NMNAT1 cnv",
    "NMNAT1 methyl",
    "NMNAT1 proteo",
    "NMNAT1 rna"
  ],
  "NMNAT2": [
    "NMNAT2 cnv",
    "NMNAT2 methyl",
    "NMNAT2 rna"
  ],
  "NMNAT3": [
    "NMNAT3 cnv",
    "NMNAT3 methyl",
    "NMNAT3 proteo",
    "NMNAT3 rna"
  ],
  "NMRAL1": [
    "NMRAL1 cnv",
    "NMRAL1 methyl",
    "NMRAL1 proteo",
    "NMRAL1 rna"
  ],
  "NMRK1": [
    "NMRK1 cnv",
    "NMRK1 methyl",
    "NMRK1 proteo",
    "NMRK1 rna"
  ],
  "NMRK2": [
    "NMRK2 cnv",
    "NMRK2 methyl",
    "NMRK2 rna"
  ],
  "NMS": [
    "NMS cnv"
  ],
  "NMT1": [
    "NMT1 47_52_1_1_S47 phospho",
    "NMT1 69_73_1_1_S69 phospho",
    "NMT1 69_73_1_1_S73 phospho",
    "NMT1 cnv",
    "NMT1 methyl",
    "NMT1 proteo",
    "NMT1 rna"
  ],
  "NMT2": [
    "NMT2 61_72_1_0 phospho",
    "NMT2 61_72_2_2_S66S68 phospho",
    "NMT2 cnv",
    "NMT2 methyl",
    "NMT2 proteo",
    "NMT2 rna"
  ],
  "NMU": [
    "NMU cnv",
    "NMU methyl",
    "NMU rna"
  ],
  "NMUR1": [
    "NMUR1 cnv",
    "NMUR1 methyl",
    "NMUR1 rna"
  ],
  "NMUR2": [
    "NMUR2 cnv",
    "NMUR2 rna"
  ],
  "NNAT": [
    "NNAT cnv",
    "NNAT methyl",
    "NNAT rna"
  ],
  "NNMT": [
    "NNMT cnv",
    "NNMT proteo",
    "NNMT rna"
  ],
  "NNT": [
    "NNT cnv",
    "NNT methyl",
    "NNT proteo",
    "NNT rna"
  ],
  "NOA1": [
    "NOA1 cnv",
    "NOA1 methyl",
    "NOA1 rna"
  ],
  "NOB1": [
    "NOB1 201_212_1_1_S201 phospho",
    "NOB1 cnv",
    "NOB1 methyl",
    "NOB1 proteo",
    "NOB1 rna"
  ],
  "NOBOX": [
    "NOBOX cnv",
    "NOBOX methyl",
    "NOBOX rna"
  ],
  "NOC2L": [
    "NOC2L 49_60_1_1_S49 phospho",
    "NOC2L 49_60_2_2_S49S56 phospho",
    "NOC2L cnv",
    "NOC2L methyl",
    "NOC2L proteo",
    "NOC2L rna"
  ],
  "NOC3L": [
    "NOC3L cnv",
    "NOC3L methyl",
    "NOC3L proteo",
    "NOC3L rna"
  ],
  "NOC4L": [
    "NOC4L cnv",
    "NOC4L methyl",
    "NOC4L proteo",
    "NOC4L rna"
  ],
  "NOCT": [
    "NOCT cnv",
    "NOCT methyl",
    "NOCT proteo",
    "NOCT rna"
  ],
  "NOD1": [
    "NOD1 cnv",
    "NOD1 methyl",
    "NOD1 rna"
  ],
  "NOD2": [
    "NOD2 cnv",
    "NOD2 rna"
  ],
  "NODAL": [
    "NODAL cnv",
    "NODAL rna"
  ],
  "NOG": [
    "NOG cnv",
    "NOG methyl",
    "NOG rna"
  ],
  "NOL10": [
    "NOL10 cnv",
    "NOL10 methyl",
    "NOL10 proteo",
    "NOL10 rna"
  ],
  "NOL11": [
    "NOL11 cnv",
    "NOL11 methyl",
    "NOL11 proteo",
    "NOL11 rna"
  ],
  "NOL12": [
    "NOL12 124_145_1_1_S134 phospho",
    "NOL12 cnv",
    "NOL12 methyl",
    "NOL12 proteo",
    "NOL12 rna"
  ],
  "NOL3": [
    "NOL3 131_162_1_1_T149 phospho",
    "NOL3 cnv",
    "NOL3 methyl",
    "NOL3 proteo",
    "NOL3 rna"
  ],
  "NOL4": [
    "NOL4 cnv",
    "NOL4 methyl",
    "NOL4 rna"
  ],
  "NOL4L": [
    "NOL4L 17_21_1_1_S17 phospho",
    "NOL4L 370_384_1_1_S374 phospho",
    "NOL4L 536_539_1_1_S539 phospho",
    "NOL4L cnv",
    "NOL4L methyl",
    "NOL4L proteo",
    "NOL4L rna"
  ],
  "NOL6": [
    "NOL6 cnv",
    "NOL6 proteo",
    "NOL6 rna"
  ],
  "NOL7": [
    "NOL7 cnv",
    "NOL7 methyl",
    "NOL7 proteo",
    "NOL7 rna"
  ],
  "NOL8": [
    "NOL8 293_297_1_1_S297 phospho",
    "NOL8 cnv",
    "NOL8 methyl",
    "NOL8 proteo",
    "NOL8 rna"
  ],
  "NOL9": [
    "NOL9 cnv",
    "NOL9 methyl",
    "NOL9 proteo",
    "NOL9 rna"
  ],
  "NOLC1": [
    "NOLC1 433_443_1_1_S443 phospho",
    "NOLC1 548_548_1_1_S548 phospho",
    "NOLC1 696_708_1_1_S708 phospho",
    "NOLC1 cnv",
    "NOLC1 methyl",
    "NOLC1 proteo",
    "NOLC1 rna"
  ],
  "NOM1": [
    "NOM1 cnv",
    "NOM1 methyl",
    "NOM1 proteo",
    "NOM1 rna"
  ],
  "NOMO1": [
    "NOMO1 ADGSFRLENITTGTYTIHAQK-N2H6F0S0G0 glyco",
    "NOMO1 ENVGIYNLSK-N2H6F0S0G0 glyco",
    "NOMO1 ENVGIYNLSK-N2H7F0S0G0 glyco",
    "NOMO1 ENVGIYNLSK-N2H8F0S0G0 glyco",
    "NOMO1 LENITTGTYTIHAQK-N2H5F0S0G0 glyco",
    "NOMO1 LENITTGTYTIHAQK-N2H6F0S0G0 glyco",
    "NOMO1 LENITTGTYTIHAQK-N2H7F0S0G0 glyco",
    "NOMO1 LENITTGTYTIHAQK-N2H8F0S0G0 glyco",
    "NOMO1 VTNSNANAASPLIVAGYNVSGSVR-N2H7F0S0G0 glyco",
    "NOMO1 VTNSNANAASPLIVAGYNVSGSVR-N2H9F0S0G0 glyco",
    "NOMO1 cnv",
    "NOMO1 rna"
  ],
  "NOMO2": [
    "NOMO2 cnv",
    "NOMO2 methyl",
    "NOMO2 rna"
  ],
  "NOMO3": [
    "NOMO3 cnv",
    "NOMO3 rna"
  ],
  "NONO": [
    "NONO 410_432_1_0 phospho",
    "NONO 410_432_1_1_T428 phospho",
    "NONO methyl",
    "NONO proteo",
    "NONO rna"
  ],
  "NOP10": [
    "NOP10 cnv",
    "NOP10 proteo",
    "NOP10 rna"
  ],
  "NOP14": [
    "NOP14 cnv",
    "NOP14 methyl",
    "NOP14 proteo",
    "NOP14 rna"
  ],
  "NOP16": [
    "NOP16 cnv",
    "NOP16 methyl",
    "NOP16 proteo",
    "NOP16 rna"
  ],
  "NOP2": [
    "NOP2 719_730_1_1_S728 phospho",
    "NOP2 cnv",
    "NOP2 methyl",
    "NOP2 proteo",
    "NOP2 rna"
  ],
  "NOP53": [
    "NOP53 cnv",
    "NOP53 methyl",
    "NOP53 proteo",
    "NOP53 rna"
  ],
  "NOP56": [
    "NOP56 511_530_1_0 phospho",
    "NOP56 511_530_1_1_S519 phospho",
    "NOP56 511_530_1_1_S520 phospho",
    "NOP56 519_530_1_1_S520 phospho",
    "NOP56 563_570_1_1_S570 phospho",
    "NOP56 563_570_2_2_S569S570 phospho",
    "NOP56 569_570_1_1_S570 phospho",
    "NOP56 591_591_1_1_S591 phospho",
    "NOP56 cnv",
    "NOP56 methyl",
    "NOP56 proteo",
    "NOP56 rna"
  ],
  "NOP58": [
    "NOP58 502_514_1_1_S502 phospho",
    "NOP58 502_514_2_2_S502S514 phospho",
    "NOP58 cnv",
    "NOP58 methyl",
    "NOP58 proteo",
    "NOP58 rna"
  ],
  "NOP9": [
    "NOP9 cnv",
    "NOP9 methyl",
    "NOP9 proteo",
    "NOP9 rna"
  ],
  "NOPCHAP1": [
    "NOPCHAP1 178_181_1_1_S178 phospho",
    "NOPCHAP1 cnv",
    "NOPCHAP1 methyl",
    "NOPCHAP1 proteo",
    "NOPCHAP1 rna"
  ],
  "NOS1": [
    "NOS1 852_859_1_1_S852 phospho",
    "NOS1 cnv",
    "NOS1 methyl",
    "NOS1 proteo",
    "NOS1 rna"
  ],
  "NOS1AP": [
    "NOS1AP 167_183_1_1_S183 phospho",
    "NOS1AP 251_261_1_1_S261 phospho",
    "NOS1AP 359_374_1_1_S366 phospho",
    "NOS1AP 377_412_1_1_S412 phospho",
    "NOS1AP cnv",
    "NOS1AP methyl",
    "NOS1AP proteo",
    "NOS1AP rna"
  ],
  "NOS2": [
    "NOS2 cnv",
    "NOS2 methyl",
    "NOS2 rna"
  ],
  "NOS3": [
    "NOS3 cnv",
    "NOS3 methyl",
    "NOS3 proteo",
    "NOS3 rna"
  ],
  "NOSIP": [
    "NOSIP 135_152_1_1_S138 phospho",
    "NOSIP cnv",
    "NOSIP methyl",
    "NOSIP proteo",
    "NOSIP rna"
  ],
  "NOSTRIN": [
    "NOSTRIN cnv",
    "NOSTRIN proteo",
    "NOSTRIN rna"
  ],
  "NOTCH1": [
    "NOTCH1 1938_1941_1_1_S1941 phospho",
    "NOTCH1 cnv",
    "NOTCH1 methyl",
    "NOTCH1 proteo",
    "NOTCH1 rna"
  ],
  "NOTCH2": [
    "NOTCH2 2110_2115_1_1_S2115 phospho",
    "NOTCH2 cnv",
    "NOTCH2 methyl",
    "NOTCH2 proteo",
    "NOTCH2 rna"
  ],
  "NOTCH2NLA": [
    "NOTCH2NLA cnv",
    "NOTCH2NLA methyl",
    "NOTCH2NLA rna"
  ],
  "NOTCH2NLB": [
    "NOTCH2NLB cnv",
    "NOTCH2NLB rna"
  ],
  "NOTCH2NLC": [
    "NOTCH2NLC cnv",
    "NOTCH2NLC rna"
  ],
  "NOTCH2NLR": [
    "NOTCH2NLR cnv",
    "NOTCH2NLR rna"
  ],
  "NOTCH3": [
    "NOTCH3 cnv",
    "NOTCH3 methyl",
    "NOTCH3 proteo",
    "NOTCH3 rna"
  ],
  "NOTCH4": [
    "NOTCH4 cnv",
    "NOTCH4 rna"
  ],
  "NOTO": [
    "NOTO cnv",
    "NOTO methyl",
    "NOTO rna"
  ],
  "NOTUM": [
    "NOTUM cnv",
    "NOTUM methyl",
    "NOTUM rna"
  ],
  "NOVA1": [
    "NOVA1 150_158_1_1_S154 phospho",
    "NOVA1 cnv",
    "NOVA1 proteo",
    "NOVA1 rna"
  ],
  "NOVA2": [
    "NOVA2 15_22_1_1_T15 phospho",
    "NOVA2 cnv",
    "NOVA2 proteo",
    "NOVA2 rna"
  ],
  "NOX1": [
    "NOX1 rna"
  ],
  "NOX3": [
    "NOX3 cnv",
    "NOX3 rna"
  ],
  "NOX4": [
    "NOX4 cnv",
    "NOX4 methyl",
    "NOX4 rna"
  ],
  "NOX5": [
    "NOX5 cnv",
    "NOX5 methyl",
    "NOX5 rna"
  ],
  "NOXA1": [
    "NOXA1 cnv",
    "NOXA1 methyl",
    "NOXA1 rna"
  ],
  "NOXO1": [
    "NOXO1 cnv",
    "NOXO1 methyl",
    "NOXO1 rna"
  ],
  "NOXRED1": [
    "NOXRED1 cnv",
    "NOXRED1 rna"
  ],
  "NPAP1": [
    "NPAP1 cnv",
    "NPAP1 methyl",
    "NPAP1 rna"
  ],
  "NPAP1L": [
    "NPAP1L cnv"
  ],
  "NPAS1": [
    "NPAS1 cnv",
    "NPAS1 methyl",
    "NPAS1 rna"
  ],
  "NPAS2": [
    "NPAS2 cnv",
    "NPAS2 methyl",
    "NPAS2 rna"
  ],
  "NPAS3": [
    "NPAS3 483_493_2_2_S490S493 phospho",
    "NPAS3 490_493_2_2_S490S493 phospho",
    "NPAS3 638_644_1_1_S639 phospho",
    "NPAS3 cnv",
    "NPAS3 methyl",
    "NPAS3 proteo",
    "NPAS3 rna"
  ],
  "NPAS4": [
    "NPAS4 cnv",
    "NPAS4 methyl",
    "NPAS4 rna"
  ],
  "NPAT": [
    "NPAT cnv",
    "NPAT methyl",
    "NPAT rna"
  ],
  "NPB": [
    "NPB cnv",
    "NPB methyl",
    "NPB rna"
  ],
  "NPBWR1": [
    "NPBWR1 cnv",
    "NPBWR1 methyl",
    "NPBWR1 rna"
  ],
  "NPBWR2": [
    "NPBWR2 cnv",
    "NPBWR2 rna"
  ],
  "NPC1": [
    "NPC1 DNGQAPFTITPVFSDFPVHGMEPMNNATK-N2H8F0S0G0 glyco",
    "NPC1 cnv",
    "NPC1 methyl",
    "NPC1 proteo",
    "NPC1 rna"
  ],
  "NPC1L1": [
    "NPC1L1 cnv",
    "NPC1L1 rna"
  ],
  "NPC2": [
    "NPC2 GQSYSVNVTFTSNIQSK-N2H3F0S0G0 glyco",
    "NPC2 GQSYSVNVTFTSNIQSK-N2H4F0S0G0 glyco",
    "NPC2 cnv",
    "NPC2 methyl",
    "NPC2 proteo",
    "NPC2 rna"
  ],
  "NPDC1": [
    "NPDC1 229_229_1_1_S229 phospho",
    "NPDC1 229_236_2_2_S229S236 phospho",
    "NPDC1 cnv",
    "NPDC1 methyl",
    "NPDC1 proteo",
    "NPDC1 rna"
  ],
  "NPEPL1": [
    "NPEPL1 cnv",
    "NPEPL1 methyl",
    "NPEPL1 proteo",
    "NPEPL1 rna"
  ],
  "NPEPPS": [
    "NPEPPS cnv",
    "NPEPPS methyl",
    "NPEPPS proteo",
    "NPEPPS rna"
  ],
  "NPFF": [
    "NPFF cnv",
    "NPFF rna"
  ],
  "NPFFR1": [
    "NPFFR1 cnv",
    "NPFFR1 methyl",
    "NPFFR1 rna"
  ],
  "NPFFR2": [
    "NPFFR2 cnv",
    "NPFFR2 methyl",
    "NPFFR2 rna"
  ],
  "NPHP1": [
    "NPHP1 cnv",
    "NPHP1 methyl",
    "NPHP1 rna"
  ],
  "NPHP3": [
    "NPHP3 cnv",
    "NPHP3 methyl",
    "NPHP3 rna"
  ],
  "NPHP3-ACAD11": [
    "NPHP3-ACAD11 cnv",
    "NPHP3-ACAD11 rna"
  ],
  "NPHP3-AS1": [
    "NPHP3-AS1 methyl"
  ],
  "NPHP4": [
    "NPHP4 137_147_1_1_S142 phospho",
    "NPHP4 cnv",
    "NPHP4 methyl",
    "NPHP4 rna"
  ],
  "NPHS1": [
    "NPHS1 cnv",
    "NPHS1 methyl",
    "NPHS1 rna"
  ],
  "NPHS2": [
    "NPHS2 cnv",
    "NPHS2 methyl",
    "NPHS2 rna"
  ],
  "NPIPA1": [
    "NPIPA1 cnv",
    "NPIPA1 rna"
  ],
  "NPIPA2": [
    "NPIPA2 cnv",
    "NPIPA2 rna"
  ],
  "NPIPA3": [
    "NPIPA3 cnv",
    "NPIPA3 rna"
  ],
  "NPIPA5": [
    "NPIPA5 cnv",
    "NPIPA5 rna"
  ],
  "NPIPA7": [
    "NPIPA7 cnv",
    "NPIPA7 rna"
  ],
  "NPIPA8": [
    "NPIPA8 cnv",
    "NPIPA8 rna"
  ],
  "NPIPA9": [
    "NPIPA9 cnv",
    "NPIPA9 rna"
  ],
  "NPIPB11": [
    "NPIPB11 cnv",
    "NPIPB11 rna"
  ],
  "NPIPB12": [
    "NPIPB12 cnv",
    "NPIPB12 rna"
  ],
  "NPIPB13": [
    "NPIPB13 cnv",
    "NPIPB13 rna"
  ],
  "NPIPB15": [
    "NPIPB15 cnv",
    "NPIPB15 rna"
  ],
  "NPIPB2": [
    "NPIPB2 cnv",
    "NPIPB2 methyl",
    "NPIPB2 rna"
  ],
  "NPIPB3": [
    "NPIPB3 cnv",
    "NPIPB3 rna"
  ],
  "NPIPB4": [
    "NPIPB4 cnv",
    "NPIPB4 rna"
  ],
  "NPIPB5": [
    "NPIPB5 cnv",
    "NPIPB5 rna"
  ],
  "NPIPB6": [
    "NPIPB6 cnv",
    "NPIPB6 rna"
  ],
  "NPIPB7": [
    "NPIPB7 cnv",
    "NPIPB7 rna"
  ],
  "NPIPB8": [
    "NPIPB8 cnv",
    "NPIPB8 rna"
  ],
  "NPIPB9": [
    "NPIPB9 cnv",
    "NPIPB9 rna"
  ],
  "NPL": [
    "NPL cnv",
    "NPL methyl",
    "NPL proteo",
    "NPL rna"
  ],
  "NPLOC4": [
    "NPLOC4 cnv",
    "NPLOC4 methyl",
    "NPLOC4 proteo",
    "NPLOC4 rna"
  ],
  "NPM1": [
    "NPM1 106_125_1_1_S125 phospho",
    "NPM1 106_139_1_1_S125 phospho",
    "NPM1 195_199_1_1_S195 phospho",
    "NPM1 46_70_1_1_S70 phospho",
    "NPM1 46_78_1_1_S70 phospho",
    "NPM1 67_70_1_1_S70 phospho",
    "NPM1 cnv",
    "NPM1 methyl",
    "NPM1 proteo",
    "NPM1 rna"
  ],
  "NPM2": [
    "NPM2 cnv",
    "NPM2 methyl",
    "NPM2 rna"
  ],
  "NPM3": [
    "NPM3 cnv",
    "NPM3 methyl",
    "NPM3 proteo",
    "NPM3 rna"
  ],
  "NPNT": [
    "NPNT cnv",
    "NPNT methyl",
    "NPNT proteo",
    "NPNT rna"
  ],
  "NPPA": [
    "NPPA cnv",
    "NPPA rna"
  ],
  "NPPB": [
    "NPPB cnv",
    "NPPB methyl",
    "NPPB rna"
  ],
  "NPPC": [
    "NPPC cnv",
    "NPPC methyl",
    "NPPC rna"
  ],
  "NPR1": [
    "NPR1 cnv",
    "NPR1 kinase",
    "NPR1 methyl",
    "NPR1 rna"
  ],
  "NPR2": [
    "NPR2 522_529_1_1_S523 phospho",
    "NPR2 cnv",
    "NPR2 kinase",
    "NPR2 methyl",
    "NPR2 proteo",
    "NPR2 rna"
  ],
  "NPR3": [
    "NPR3 cnv",
    "NPR3 methyl",
    "NPR3 rna"
  ],
  "NPRL2": [
    "NPRL2 cnv",
    "NPRL2 methyl",
    "NPRL2 proteo",
    "NPRL2 rna"
  ],
  "NPRL3": [
    "NPRL3 cnv",
    "NPRL3 methyl",
    "NPRL3 proteo",
    "NPRL3 rna"
  ],
  "NPS": [
    "NPS cnv",
    "NPS rna"
  ],
  "NPSR1": [
    "NPSR1 cnv",
    "NPSR1 rna"
  ],
  "NPTN": [
    "NPTN ANATIEVK-N2H3F0S0G0 glyco",
    "NPTN ANATIEVK-N2H4F0S0G0 glyco",
    "NPTN ANATIEVK-N2H5F0S0G0 glyco",
    "NPTN ANATIEVK-N2H6F0S0G0 glyco",
    "NPTN ANATIEVK-N2H7F0S0G0 glyco",
    "NPTN ANATIEVK-N2H8F0S0G0 glyco",
    "NPTN ANATIEVK-N2H9F0S0G0 glyco",
    "NPTN ANATIEVK-N4H3F0S0G0 glyco",
    "NPTN ANATIEVK-N4H4F0S0G0 glyco",
    "NPTN ANATIEVK-N4H4F1S0G0 glyco",
    "NPTN ANATIEVK-N4H5F2S0G0 glyco",
    "NPTN ANATIEVK-N5H3F0S0G0 glyco",
    "NPTN ANATIEVK-N5H4F0S0G0 glyco",
    "NPTN ANATIEVK-N5H4F1S0G0 glyco",
    "NPTN ANATIEVK-N5H5F1S0G0 glyco",
    "NPTN ANATIEVK-N5H5F2S0G0 glyco",
    "NPTN ANATIEVK-N5H6F2S0G0 glyco",
    "NPTN ANATIEVK-N6H3F0S0G0 glyco",
    "NPTN ANATIEVK-N6H4F0S0G0 glyco",
    "NPTN ANATIEVK-N6H4F1S0G0 glyco",
    "NPTN ANATIEVK-N6H5F1S0G0 glyco",
    "NPTN cnv",
    "NPTN methyl",
    "NPTN proteo",
    "NPTN rna"
  ],
  "NPTX1": [
    "NPTX1 LNSSSQTNSLK-N2H5F0S0G0 glyco",
    "NPTX1 LNSSSQTNSLK-N5H3F1S0G0 glyco",
    "NPTX1 cnv",
    "NPTX1 methyl",
    "NPTX1 proteo",
    "NPTX1 rna"
  ],
  "NPTX2": [
    "NPTX2 cnv",
    "NPTX2 methyl",
    "NPTX2 proteo",
    "NPTX2 rna"
  ],
  "NPTXR": [
    "NPTXR cnv",
    "NPTXR methyl",
    "NPTXR proteo",
    "NPTXR rna"
  ],
  "NPVF": [
    "NPVF cnv",
    "NPVF rna"
  ],
  "NPW": [
    "NPW cnv",
    "NPW methyl",
    "NPW rna"
  ],
  "NPY": [
    "NPY 68_83_1_1_S82 phospho",
    "NPY cnv",
    "NPY methyl",
    "NPY proteo",
    "NPY rna"
  ],
  "NPY1R": [
    "NPY1R 368_368_1_1_S368 phospho",
    "NPY1R cnv",
    "NPY1R methyl",
    "NPY1R rna"
  ],
  "NPY2R": [
    "NPY2R cnv",
    "NPY2R methyl",
    "NPY2R rna"
  ],
  "NPY4R": [
    "NPY4R cnv",
    "NPY4R rna"
  ],
  "NPY4R2": [
    "NPY4R2 cnv",
    "NPY4R2 rna"
  ],
  "NPY5R": [
    "NPY5R cnv",
    "NPY5R methyl",
    "NPY5R rna"
  ],
  "NQO1": [
    "NQO1 cnv",
    "NQO1 methyl",
    "NQO1 proteo",
    "NQO1 rna"
  ],
  "NQO2": [
    "NQO2 cnv",
    "NQO2 methyl",
    "NQO2 proteo",
    "NQO2 rna"
  ],
  "NR0B1": [
    "NR0B1 methyl",
    "NR0B1 rna"
  ],
  "NR0B2": [
    "NR0B2 cnv",
    "NR0B2 rna"
  ],
  "NR1D1": [
    "NR1D1 cnv",
    "NR1D1 methyl",
    "NR1D1 rna"
  ],
  "NR1D2": [
    "NR1D2 cnv",
    "NR1D2 methyl",
    "NR1D2 rna"
  ],
  "NR1H2": [
    "NR1H2 cnv",
    "NR1H2 methyl",
    "NR1H2 rna"
  ],
  "NR1H3": [
    "NR1H3 cnv",
    "NR1H3 methyl",
    "NR1H3 rna"
  ],
  "NR1H4": [
    "NR1H4 cnv",
    "NR1H4 rna"
  ],
  "NR1I2": [
    "NR1I2 cnv",
    "NR1I2 methyl",
    "NR1I2 rna"
  ],
  "NR1I3": [
    "NR1I3 cnv",
    "NR1I3 rna"
  ],
  "NR2C1": [
    "NR2C1 cnv",
    "NR2C1 methyl",
    "NR2C1 rna"
  ],
  "NR2C2": [
    "NR2C2 12_19_1_1_S19 phospho",
    "NR2C2 cnv",
    "NR2C2 methyl",
    "NR2C2 proteo",
    "NR2C2 rna"
  ],
  "NR2C2AP": [
    "NR2C2AP cnv",
    "NR2C2AP methyl",
    "NR2C2AP proteo",
    "NR2C2AP rna"
  ],
  "NR2E1": [
    "NR2E1 cnv",
    "NR2E1 methyl",
    "NR2E1 rna"
  ],
  "NR2E3": [
    "NR2E3 cnv",
    "NR2E3 rna"
  ],
  "NR2F1": [
    "NR2F1 cnv",
    "NR2F1 methyl",
    "NR2F1 rna"
  ],
  "NR2F1-AS1": [
    "NR2F1-AS1 methyl"
  ],
  "NR2F2": [
    "NR2F2 cnv",
    "NR2F2 methyl",
    "NR2F2 rna"
  ],
  "NR2F6": [
    "NR2F6 cnv",
    "NR2F6 methyl",
    "NR2F6 rna"
  ],
  "NR3C1": [
    "NR3C1 42_56_1_1_S45 phospho",
    "NR3C1 cnv",
    "NR3C1 methyl",
    "NR3C1 proteo",
    "NR3C1 rna"
  ],
  "NR3C2": [
    "NR3C2 cnv",
    "NR3C2 methyl",
    "NR3C2 rna"
  ],
  "NR4A1": [
    "NR4A1 cnv",
    "NR4A1 methyl",
    "NR4A1 rna"
  ],
  "NR4A2": [
    "NR4A2 cnv",
    "NR4A2 methyl",
    "NR4A2 rna"
  ],
  "NR4A3": [
    "NR4A3 cnv",
    "NR4A3 methyl",
    "NR4A3 rna"
  ],
  "NR5A1": [
    "NR5A1 cnv",
    "NR5A1 rna"
  ],
  "NR5A2": [
    "NR5A2 cnv",
    "NR5A2 methyl",
    "NR5A2 rna"
  ],
  "NR6A1": [
    "NR6A1 cnv",
    "NR6A1 methyl",
    "NR6A1 rna"
  ],
  "NRAP": [
    "NRAP cnv",
    "NRAP rna"
  ],
  "NRARP": [
    "NRARP cnv",
    "NRARP methyl",
    "NRARP rna"
  ],
  "NRAS": [
    "NRAS cnv",
    "NRAS proteo",
    "NRAS rna"
  ],
  "NRAV": [
    "NRAV methyl"
  ],
  "NRBF2": [
    "NRBF2 cnv",
    "NRBF2 methyl",
    "NRBF2 proteo",
    "NRBF2 rna"
  ],
  "NRBP1": [
    "NRBP1 20_59_1_1_S49 phospho",
    "NRBP1 402_441_1_0 phospho",
    "NRBP1 431_441_1_0 phospho",
    "NRBP1 431_441_1_1_T433 phospho",
    "NRBP1 cnv",
    "NRBP1 kinase",
    "NRBP1 methyl",
    "NRBP1 proteo",
    "NRBP1 rna"
  ],
  "NRBP2": [
    "NRBP2 200_209_1_1_S209 phospho",
    "NRBP2 22_32_1_0 phospho",
    "NRBP2 22_32_1_1_S22 phospho",
    "NRBP2 409_419_1_1_T409 phospho",
    "NRBP2 409_419_1_1_T411 phospho",
    "NRBP2 409_419_2_2_T409T411 phospho",
    "NRBP2 cnv",
    "NRBP2 kinase",
    "NRBP2 methyl",
    "NRBP2 proteo",
    "NRBP2 rna"
  ],
  "NRCAM": [
    "NRCAM 1097_1102_1_0 phospho",
    "NRCAM 1097_1102_1_1_S1102 phospho",
    "NRCAM 1166_1178_1_0 phospho",
    "NRCAM 1166_1178_1_1_S1171 phospho",
    "NRCAM 1166_1178_2_0 phospho",
    "NRCAM DGDDEWTSVVVANVSK-N4H5F1S1G0 glyco",
    "NRCAM ERPPTFLTPEGNASNK-N5H3F1S0G0 glyco",
    "NRCAM FNHTQTIQQK-N2H3F0S0G0 glyco",
    "NRCAM FNHTQTIQQK-N2H4F0S0G0 glyco",
    "NRCAM FNHTQTIQQK-N2H5F0S0G0 glyco",
    "NRCAM FNHTQTIQQK-N2H6F0S0G0 glyco",
    "NRCAM FNHTQTIQQK-N2H7F0S0G0 glyco",
    "NRCAM FNHTQTIQQK-N2H8F0S0G0 glyco",
    "NRCAM GSALHEDIYVLHENGTLEIPVAQK-N2H6F0S0G0 glyco",
    "NRCAM GSALHEDIYVLHENGTLEIPVAQK-N2H8F0S0G0 glyco",
    "NRCAM GSALHEDIYVLHENGTLEIPVAQK-N2H9F0S0G0 glyco",
    "NRCAM NGTHFDIDK-N2H5F0S0G0 glyco",
    "NRCAM NGTHFDIDK-N2H6F0S0G0 glyco",
    "NRCAM NGTHFDIDK-N2H7F0S0G0 glyco",
    "NRCAM NLNFSTR-N2H3F0S0G0 glyco",
    "NRCAM NLNFSTR-N2H4F0S0G0 glyco",
    "NRCAM NLNFSTR-N2H5F0S0G0 glyco",
    "NRCAM VNVVNSTLAEVHWDPVPLK-N2H5F0S0G0 glyco",
    "NRCAM VNVVNSTLAEVHWDPVPLK-N3H5F2S0G0 glyco",
    "NRCAM VNVVNSTLAEVHWDPVPLK-N4H4F1S0G0 glyco",
    "NRCAM VNVVNSTLAEVHWDPVPLK-N4H5F1S0G0 glyco",
    "NRCAM VNVVNSTLAEVHWDPVPLK-N4H5F2S0G0 glyco",
    "NRCAM VNVVNSTLAEVHWDPVPLK-N5H3F1S0G0 glyco",
    "NRCAM VNVVNSTLAEVHWDPVPLK-N5H4F2S0G0 glyco",
    "NRCAM YQPINSTHELGPLVDLK-N4H5F1S2G0 glyco",
    "NRCAM YQPINSTHELGPLVDLK-N4H5F2S1G0 glyco",
    "NRCAM YQPINSTHELGPLVDLK-N5H4F2S0G0 glyco",
    "NRCAM cnv",
    "NRCAM methyl",
    "NRCAM proteo",
    "NRCAM rna"
  ],
  "NRDC": [
    "NRDC 86_96_1_1_S94 phospho",
    "NRDC 94_96_1_1_S94 phospho",
    "NRDC cnv",
    "NRDC methyl",
    "NRDC proteo",
    "NRDC rna"
  ],
  "NRDE2": [
    "NRDE2 cnv",
    "NRDE2 methyl",
    "NRDE2 proteo",
    "NRDE2 rna"
  ],
  "NREP": [
    "NREP cnv",
    "NREP methyl",
    "NREP rna"
  ],
  "NRF1": [
    "NRF1 cnv",
    "NRF1 methyl",
    "NRF1 proteo",
    "NRF1 rna"
  ],
  "NRG1": [
    "NRG1 cnv",
    "NRG1 methyl",
    "NRG1 rna"
  ],
  "NRG2": [
    "NRG2 cnv",
    "NRG2 methyl",
    "NRG2 rna"
  ],
  "NRG3": [
    "NRG3 cnv",
    "NRG3 methyl",
    "NRG3 rna"
  ],
  "NRG4": [
    "NRG4 cnv",
    "NRG4 methyl",
    "NRG4 rna"
  ],
  "NRGN": [
    "NRGN cnv",
    "NRGN methyl",
    "NRGN proteo",
    "NRGN rna"
  ],
  "NRIP1": [
    "NRIP1 564_572_1_1_S564 phospho",
    "NRIP1 cnv",
    "NRIP1 methyl",
    "NRIP1 rna"
  ],
  "NRIP2": [
    "NRIP2 89_104_1_1_S96 phospho",
    "NRIP2 cnv",
    "NRIP2 proteo",
    "NRIP2 rna"
  ],
  "NRIP3": [
    "NRIP3 cnv",
    "NRIP3 methyl",
    "NRIP3 rna"
  ],
  "NRK": [
    "NRK kinase",
    "NRK methyl",
    "NRK rna"
  ],
  "NRL": [
    "NRL cnv",
    "NRL methyl",
    "NRL rna"
  ],
  "NRM": [
    "NRM cnv",
    "NRM methyl",
    "NRM proteo",
    "NRM rna"
  ],
  "NRN1": [
    "NRN1 cnv",
    "NRN1 methyl",
    "NRN1 proteo",
    "NRN1 rna"
  ],
  "NRN1L": [
    "NRN1L cnv",
    "NRN1L rna"
  ],
  "NRP1": [
    "NRP1 RGPECSQNYTTPSGVIK-N4H5F0S1G0 glyco",
    "NRP1 cnv",
    "NRP1 methyl",
    "NRP1 proteo",
    "NRP1 rna"
  ],
  "NRP2": [
    "NRP2 871_877_1_1_S874 phospho",
    "NRP2 cnv",
    "NRP2 methyl",
    "NRP2 proteo",
    "NRP2 rna"
  ],
  "NRROS": [
    "NRROS cnv",
    "NRROS methyl",
    "NRROS rna"
  ],
  "NRSN1": [
    "NRSN1 cnv",
    "NRSN1 methyl",
    "NRSN1 rna"
  ],
  "NRSN2": [
    "NRSN2 cnv",
    "NRSN2 methyl",
    "NRSN2 rna"
  ],
  "NRSN2-AS1": [
    "NRSN2-AS1 methyl"
  ],
  "NRTN": [
    "NRTN cnv",
    "NRTN methyl",
    "NRTN rna"
  ],
  "NRXN1": [
    "NRXN1 NTTLFIDQVEAK-N2H5F0S0G0 glyco",
    "NRXN1 cnv",
    "NRXN1 methyl",
    "NRXN1 proteo",
    "NRXN1 rna"
  ],
  "NRXN2": [
    "NRXN2 1698_1700_1_0 phospho",
    "NRXN2 cnv",
    "NRXN2 methyl",
    "NRXN2 proteo",
    "NRXN2 rna"
  ],
  "NRXN3": [
    "NRXN3 cnv",
    "NRXN3 methyl",
    "NRXN3 proteo",
    "NRXN3 rna"
  ],
  "NSA2": [
    "NSA2 cnv",
    "NSA2 methyl",
    "NSA2 proteo",
    "NSA2 rna"
  ],
  "NSD1": [
    "NSD1 2471_2476_1_1_S2471 phospho",
    "NSD1 478_486_1_1_S486 phospho",
    "NSD1 cnv",
    "NSD1 methyl",
    "NSD1 rna"
  ],
  "NSD2": [
    "NSD2 cnv",
    "NSD2 methyl",
    "NSD2 proteo",
    "NSD2 rna"
  ],
  "NSD3": [
    "NSD3 cnv",
    "NSD3 methyl",
    "NSD3 proteo",
    "NSD3 rna"
  ],
  "NSDHL": [
    "NSDHL methyl",
    "NSDHL proteo",
    "NSDHL rna"
  ],
  "NSF": [
    "NSF cnv",
    "NSF proteo",
    "NSF rna"
  ],
  "NSFL1C": [
    "NSFL1C 114_114_1_1_S114 phospho",
    "NSFL1C 176_177_1_1_S176 phospho",
    "NSFL1C 262_272_1_1_S272 phospho",
    "NSFL1C cnv",
    "NSFL1C methyl",
    "NSFL1C proteo",
    "NSFL1C rna"
  ],
  "NSG1": [
    "NSG1 cnv",
    "NSG1 methyl",
    "NSG1 rna"
  ],
  "NSG2": [
    "NSG2 cnv",
    "NSG2 rna"
  ],
  "NSL1": [
    "NSL1 cnv",
    "NSL1 methyl",
    "NSL1 proteo",
    "NSL1 rna"
  ],
  "NSMAF": [
    "NSMAF cnv",
    "NSMAF methyl",
    "NSMAF proteo",
    "NSMAF rna"
  ],
  "NSMCE1": [
    "NSMCE1 cnv",
    "NSMCE1 methyl",
    "NSMCE1 proteo",
    "NSMCE1 rna"
  ],
  "NSMCE1-DT": [
    "NSMCE1-DT methyl"
  ],
  "NSMCE2": [
    "NSMCE2 cnv",
    "NSMCE2 methyl",
    "NSMCE2 proteo",
    "NSMCE2 rna"
  ],
  "NSMCE3": [
    "NSMCE3 57_64_1_1_S64 phospho",
    "NSMCE3 cnv",
    "NSMCE3 methyl",
    "NSMCE3 proteo",
    "NSMCE3 rna"
  ],
  "NSMCE4A": [
    "NSMCE4A cnv",
    "NSMCE4A methyl",
    "NSMCE4A proteo",
    "NSMCE4A rna"
  ],
  "NSMF": [
    "NSMF 164_178_1_1_S164 phospho",
    "NSMF 290_295_1_1_S292 phospho",
    "NSMF cnv",
    "NSMF methyl",
    "NSMF proteo",
    "NSMF rna"
  ],
  "NSRP1": [
    "NSRP1 cnv",
    "NSRP1 methyl",
    "NSRP1 proteo",
    "NSRP1 rna"
  ],
  "NSUN2": [
    "NSUN2 452_469_1_1_S456 phospho",
    "NSUN2 743_755_1_1_S751 phospho",
    "NSUN2 743_755_2_2_S743S751 phospho",
    "NSUN2 cnv",
    "NSUN2 methyl",
    "NSUN2 proteo",
    "NSUN2 rna"
  ],
  "NSUN3": [
    "NSUN3 cnv",
    "NSUN3 methyl",
    "NSUN3 rna"
  ],
  "NSUN4": [
    "NSUN4 cnv",
    "NSUN4 methyl",
    "NSUN4 proteo",
    "NSUN4 rna"
  ],
  "NSUN5": [
    "NSUN5 437_444_1_1_S444 phospho",
    "NSUN5 437_444_2_2_T442S444 phospho",
    "NSUN5 442_444_1_1_S444 phospho",
    "NSUN5 cnv",
    "NSUN5 methyl",
    "NSUN5 proteo",
    "NSUN5 rna"
  ],
  "NSUN6": [
    "NSUN6 cnv",
    "NSUN6 methyl",
    "NSUN6 proteo",
    "NSUN6 rna"
  ],
  "NSUN7": [
    "NSUN7 cnv",
    "NSUN7 methyl",
    "NSUN7 rna"
  ],
  "NT5C": [
    "NT5C cnv",
    "NT5C methyl",
    "NT5C proteo",
    "NT5C rna"
  ],
  "NT5C1A": [
    "NT5C1A cnv",
    "NT5C1A methyl",
    "NT5C1A proteo",
    "NT5C1A rna"
  ],
  "NT5C1B": [
    "NT5C1B cnv",
    "NT5C1B methyl",
    "NT5C1B rna"
  ],
  "NT5C1B-RDH14": [
    "NT5C1B-RDH14 cnv"
  ],
  "NT5C2": [
    "NT5C2 510_511_1_1_S511 phospho",
    "NT5C2 cnv",
    "NT5C2 methyl",
    "NT5C2 proteo",
    "NT5C2 rna"
  ],
  "NT5C3A": [
    "NT5C3A cnv",
    "NT5C3A methyl",
    "NT5C3A proteo",
    "NT5C3A rna"
  ],
  "NT5C3B": [
    "NT5C3B cnv",
    "NT5C3B methyl",
    "NT5C3B proteo",
    "NT5C3B rna"
  ],
  "NT5DC1": [
    "NT5DC1 cnv",
    "NT5DC1 methyl",
    "NT5DC1 proteo",
    "NT5DC1 rna"
  ],
  "NT5DC2": [
    "NT5DC2 cnv",
    "NT5DC2 methyl",
    "NT5DC2 proteo",
    "NT5DC2 rna"
  ],
  "NT5DC3": [
    "NT5DC3 cnv",
    "NT5DC3 methyl",
    "NT5DC3 proteo",
    "NT5DC3 rna"
  ],
  "NT5DC4": [
    "NT5DC4 cnv",
    "NT5DC4 rna"
  ],
  "NT5E": [
    "NT5E GNVISSHGNPILLNSSIPEDPSIK-N2H6F0S0G0 glyco",
    "NT5E IEFDERGNVISSHGNPILLNSSIPEDPSIK-N2H5F0S0G0 glyco",
    "NT5E IKLDNYSTQELGK-N4H5F1S1G0 glyco",
    "NT5E cnv",
    "NT5E methyl",
    "NT5E proteo",
    "NT5E rna"
  ],
  "NT5M": [
    "NT5M cnv",
    "NT5M methyl",
    "NT5M rna"
  ],
  "NTAN1": [
    "NTAN1 cnv",
    "NTAN1 methyl",
    "NTAN1 proteo",
    "NTAN1 rna"
  ],
  "NTAQ1": [
    "NTAQ1 cnv",
    "NTAQ1 methyl",
    "NTAQ1 proteo",
    "NTAQ1 rna"
  ],
  "NTF3": [
    "NTF3 cnv",
    "NTF3 methyl",
    "NTF3 rna"
  ],
  "NTF4": [
    "NTF4 cnv",
    "NTF4 methyl",
    "NTF4 rna"
  ],
  "NTHL1": [
    "NTHL1 cnv",
    "NTHL1 methyl",
    "NTHL1 rna"
  ],
  "NTM": [
    "NTM LGHTNASIMLFEVK-N4H5F1S1G0 glyco",
    "NTM LGHTNASIMLFEVK-N5H3F0S0G0 glyco",
    "NTM LGHTNASIMLFEVK-N5H3F1S0G0 glyco",
    "NTM LGHTNASIMLFEVK-N5H4F1S0G0 glyco",
    "NTM cnv",
    "NTM methyl",
    "NTM proteo",
    "NTM rna"
  ],
  "NTMT1": [
    "NTMT1 cnv",
    "NTMT1 methyl",
    "NTMT1 proteo",
    "NTMT1 rna"
  ],
  "NTMT2": [
    "NTMT2 cnv",
    "NTMT2 rna"
  ],
  "NTN1": [
    "NTN1 cnv",
    "NTN1 methyl",
    "NTN1 proteo",
    "NTN1 rna"
  ],
  "NTN3": [
    "NTN3 cnv",
    "NTN3 methyl",
    "NTN3 rna"
  ],
  "NTN4": [
    "NTN4 cnv",
    "NTN4 methyl",
    "NTN4 rna"
  ],
  "NTN5": [
    "NTN5 cnv",
    "NTN5 rna"
  ],
  "NTNG1": [
    "NTNG1 cnv",
    "NTNG1 methyl",
    "NTNG1 proteo",
    "NTNG1 rna"
  ],
  "NTNG2": [
    "NTNG2 cnv",
    "NTNG2 methyl",
    "NTNG2 proteo",
    "NTNG2 rna"
  ],
  "NTPCR": [
    "NTPCR cnv",
    "NTPCR methyl",
    "NTPCR proteo",
    "NTPCR rna"
  ],
  "NTRK1": [
    "NTRK1 cnv",
    "NTRK1 kinase",
    "NTRK1 methyl",
    "NTRK1 rna"
  ],
  "NTRK2": [
    "NTRK2 HMNETSHTQGSLR-N2H5F0S0G0 glyco",
    "NTRK2 ITNISSDDSGK-N5H3F1S0G0 glyco",
    "NTRK2 ITNISSDDSGK-N5H4F2S0G0 glyco",
    "NTRK2 LEPNSVDPENITEIFIANQK-N5H3F1S0G0 glyco",
    "NTRK2 LEPNSVDPENITEIFIANQK-N5H4F2S0G0 glyco",
    "NTRK2 NLTIVDSGLK-N2H3F0S0G0 glyco",
    "NTRK2 NLTIVDSGLK-N2H4F0S0G0 glyco",
    "NTRK2 NLTIVDSGLK-N2H5F0S0G0 glyco",
    "NTRK2 NLTIVDSGLK-N2H6F0S0G0 glyco",
    "NTRK2 NLTIVDSGLK-N2H7F0S0G0 glyco",
    "NTRK2 NLTIVDSGLK-N2H8F0S0G0 glyco",
    "NTRK2 NSNLQHINFTR-N2H3F0S0G0 glyco",
    "NTRK2 NSNLQHINFTR-N2H4F0S0G0 glyco",
    "NTRK2 NSNLQHINFTR-N2H5F0S0G0 glyco",
    "NTRK2 NSNLQHINFTR-N2H6F0S0G0 glyco",
    "NTRK2 NSNLQHINFTR-N2H7F0S0G0 glyco",
    "NTRK2 NSNLQHINFTR-N2H8F0S0G0 glyco",
    "NTRK2 SSPDTQDLYCLNESSK-N5H4F2S0G0 glyco",
    "NTRK2 SSPDTQDLYCLNESSK-N5H5F1S1G0 glyco",
    "NTRK2 cnv",
    "NTRK2 kinase",
    "NTRK2 methyl",
    "NTRK2 proteo",
    "NTRK2 rna"
  ],
  "NTRK3": [
    "NTRK3 472_506_1_0 phospho",
    "NTRK3 558_563_1_1_S561 phospho",
    "NTRK3 NPLGTANQTINGHFLK-N2H5F0S0G0 glyco",
    "NTRK3 cnv",
    "NTRK3 kinase",
    "NTRK3 methyl",
    "NTRK3 proteo",
    "NTRK3 rna"
  ],
  "NTS": [
    "NTS cnv",
    "NTS rna"
  ],
  "NTSR1": [
    "NTSR1 cnv",
    "NTSR1 methyl",
    "NTSR1 rna"
  ],
  "NTSR2": [
    "NTSR2 cnv",
    "NTSR2 methyl",
    "NTSR2 rna"
  ],
  "NUAK1": [
    "NUAK1 438_445_1_1_S445 phospho",
    "NUAK1 438_455_1_1_S455 phospho",
    "NUAK1 438_455_2_2_S445S455 phospho",
    "NUAK1 513_518_1_1_S518 phospho",
    "NUAK1 cnv",
    "NUAK1 kinase",
    "NUAK1 methyl",
    "NUAK1 proteo",
    "NUAK1 rna"
  ],
  "NUAK2": [
    "NUAK2 cnv",
    "NUAK2 kinase",
    "NUAK2 methyl",
    "NUAK2 rna"
  ],
  "NUB1": [
    "NUB1 cnv",
    "NUB1 methyl",
    "NUB1 proteo",
    "NUB1 rna"
  ],
  "NUBP1": [
    "NUBP1 cnv",
    "NUBP1 methyl",
    "NUBP1 proteo",
    "NUBP1 rna"
  ],
  "NUBP2": [
    "NUBP2 cnv",
    "NUBP2 methyl",
    "NUBP2 proteo",
    "NUBP2 rna"
  ],
  "NUBPL": [
    "NUBPL cnv",
    "NUBPL proteo",
    "NUBPL rna"
  ],
  "NUCB1": [
    "NUCB1 148_148_1_1_T148 phospho",
    "NUCB1 cnv",
    "NUCB1 methyl",
    "NUCB1 proteo",
    "NUCB1 rna"
  ],
  "NUCB2": [
    "NUCB2 cnv",
    "NUCB2 methyl",
    "NUCB2 proteo",
    "NUCB2 rna"
  ],
  "NUCKS1": [
    "NUCKS1 113_113_1_1_S113 phospho",
    "NUCKS1 130_149_1_1_S144 phospho",
    "NUCKS1 13_26_1_1_S19 phospho",
    "NUCKS1 13_34_1_1_S19 phospho",
    "NUCKS1 177_181_1_1_S181 phospho",
    "NUCKS1 177_181_1_1_T179 phospho",
    "NUCKS1 177_181_2_2_T179S181 phospho",
    "NUCKS1 202_214_1_1_S204 phospho",
    "NUCKS1 202_214_1_1_S214 phospho",
    "NUCKS1 202_214_2_0 phospho",
    "NUCKS1 202_214_2_2_S204S214 phospho",
    "NUCKS1 202_214_2_2_T202S204 phospho",
    "NUCKS1 202_214_3_3_T202S204S214 phospho",
    "NUCKS1 214_214_1_1_S214 phospho",
    "NUCKS1 220_223_1_1_S223 phospho",
    "NUCKS1 220_240_1_1_S229 phospho",
    "NUCKS1 220_240_2_1_S223 phospho",
    "NUCKS1 220_240_2_2_S223S229 phospho",
    "NUCKS1 220_240_2_2_S229S234 phospho",
    "NUCKS1 220_240_2_2_S229S240 phospho",
    "NUCKS1 220_240_3_0 phospho",
    "NUCKS1 220_240_3_3_S223S229S234 phospho",
    "NUCKS1 220_240_3_3_S223S234S240 phospho",
    "NUCKS1 220_240_3_3_S229S234S240 phospho",
    "NUCKS1 229_240_1_1_S240 phospho",
    "NUCKS1 50_61_1_1_S54 phospho",
    "NUCKS1 50_61_2_2_S58S61 phospho",
    "NUCKS1 50_61_3_3_S54S58S61 phospho",
    "NUCKS1 54_61_1_1_S58 phospho",
    "NUCKS1 54_61_1_1_S61 phospho",
    "NUCKS1 54_61_2_2_S58S61 phospho",
    "NUCKS1 68_79_1_0 phospho",
    "NUCKS1 68_79_1_1_S75 phospho",
    "NUCKS1 68_79_1_1_S79 phospho",
    "NUCKS1 68_79_2_2_S75S79 phospho",
    "NUCKS1 68_79_3_3_S73S75S79 phospho",
    "NUCKS1 73_79_1_0 phospho",
    "NUCKS1 73_79_1_1_S73 phospho",
    "NUCKS1 73_79_1_1_S75 phospho",
    "NUCKS1 73_79_1_1_S79 phospho",
    "NUCKS1 73_79_2_2_S73S75 phospho",
    "NUCKS1 73_79_2_2_S75S79 phospho",
    "NUCKS1 73_79_3_3_S73S75S79 phospho",
    "NUCKS1 cnv",
    "NUCKS1 methyl",
    "NUCKS1 proteo",
    "NUCKS1 rna"
  ],
  "NUDC": [
    "NUDC 136_139_1_1_S139 phospho",
    "NUDC 136_145_1_0 phospho",
    "NUDC 136_145_1_1_S139 phospho",
    "NUDC 136_145_1_1_T145 phospho",
    "NUDC 136_145_2_2_S139T145 phospho",
    "NUDC 259_266_1_1_S260 phospho",
    "NUDC 298_304_1_1_S298 phospho",
    "NUDC cnv",
    "NUDC methyl",
    "NUDC proteo",
    "NUDC rna"
  ],
  "NUDCD1": [
    "NUDCD1 cnv",
    "NUDCD1 methyl",
    "NUDCD1 proteo",
    "NUDCD1 rna"
  ],
  "NUDCD2": [
    "NUDCD2 cnv",
    "NUDCD2 methyl",
    "NUDCD2 proteo",
    "NUDCD2 rna"
  ],
  "NUDCD3": [
    "NUDCD3 cnv",
    "NUDCD3 methyl",
    "NUDCD3 proteo",
    "NUDCD3 rna"
  ],
  "NUDT1": [
    "NUDT1 cnv",
    "NUDT1 methyl",
    "NUDT1 proteo",
    "NUDT1 rna"
  ],
  "NUDT10": [
    "NUDT10 methyl",
    "NUDT10 proteo",
    "NUDT10 rna"
  ],
  "NUDT11": [
    "NUDT11 methyl",
    "NUDT11 proteo",
    "NUDT11 rna"
  ],
  "NUDT12": [
    "NUDT12 cnv",
    "NUDT12 proteo",
    "NUDT12 rna"
  ],
  "NUDT13": [
    "NUDT13 cnv",
    "NUDT13 rna"
  ],
  "NUDT14": [
    "NUDT14 cnv",
    "NUDT14 methyl",
    "NUDT14 proteo",
    "NUDT14 rna"
  ],
  "NUDT15": [
    "NUDT15 cnv",
    "NUDT15 methyl",
    "NUDT15 proteo",
    "NUDT15 rna"
  ],
  "NUDT16": [
    "NUDT16 cnv",
    "NUDT16 methyl",
    "NUDT16 proteo",
    "NUDT16 rna"
  ],
  "NUDT16-DT": [
    "NUDT16-DT methyl"
  ],
  "NUDT16L1": [
    "NUDT16L1 cnv",
    "NUDT16L1 methyl",
    "NUDT16L1 proteo",
    "NUDT16L1 rna"
  ],
  "NUDT16L2P": [
    "NUDT16L2P methyl"
  ],
  "NUDT17": [
    "NUDT17 cnv",
    "NUDT17 methyl",
    "NUDT17 rna"
  ],
  "NUDT18": [
    "NUDT18 cnv",
    "NUDT18 methyl",
    "NUDT18 proteo",
    "NUDT18 rna"
  ],
  "NUDT19": [
    "NUDT19 cnv",
    "NUDT19 methyl",
    "NUDT19 proteo",
    "NUDT19 rna"
  ],
  "NUDT2": [
    "NUDT2 cnv",
    "NUDT2 methyl",
    "NUDT2 proteo",
    "NUDT2 rna"
  ],
  "NUDT21": [
    "NUDT21 cnv",
    "NUDT21 methyl",
    "NUDT21 proteo",
    "NUDT21 rna"
  ],
  "NUDT22": [
    "NUDT22 cnv",
    "NUDT22 methyl",
    "NUDT22 rna"
  ],
  "NUDT3": [
    "NUDT3 cnv",
    "NUDT3 methyl",
    "NUDT3 proteo",
    "NUDT3 rna"
  ],
  "NUDT4": [
    "NUDT4 cnv",
    "NUDT4 methyl",
    "NUDT4 rna"
  ],
  "NUDT4B": [
    "NUDT4B cnv",
    "NUDT4B methyl",
    "NUDT4B rna"
  ],
  "NUDT5": [
    "NUDT5 43_48_1_1_T45 phospho",
    "NUDT5 cnv",
    "NUDT5 methyl",
    "NUDT5 proteo",
    "NUDT5 rna"
  ],
  "NUDT6": [
    "NUDT6 cnv",
    "NUDT6 methyl",
    "NUDT6 proteo",
    "NUDT6 rna"
  ],
  "NUDT7": [
    "NUDT7 cnv",
    "NUDT7 methyl",
    "NUDT7 rna"
  ],
  "NUDT8": [
    "NUDT8 cnv",
    "NUDT8 methyl",
    "NUDT8 rna"
  ],
  "NUDT9": [
    "NUDT9 cnv",
    "NUDT9 methyl",
    "NUDT9 proteo",
    "NUDT9 rna"
  ],
  "NUF2": [
    "NUF2 247_247_1_1_S247 phospho",
    "NUF2 cnv",
    "NUF2 methyl",
    "NUF2 proteo",
    "NUF2 rna"
  ],
  "NUFIP1": [
    "NUFIP1 cnv",
    "NUFIP1 methyl",
    "NUFIP1 rna"
  ],
  "NUFIP2": [
    "NUFIP2 212_220_1_0 phospho",
    "NUFIP2 212_220_1_1_S212 phospho",
    "NUFIP2 212_220_1_1_S214 phospho",
    "NUFIP2 212_220_1_1_T220 phospho",
    "NUFIP2 212_220_2_2_S212S214 phospho",
    "NUFIP2 571_578_1_1_S572 phospho",
    "NUFIP2 80_87_1_1_T87 phospho",
    "NUFIP2 cnv",
    "NUFIP2 methyl",
    "NUFIP2 proteo",
    "NUFIP2 rna"
  ],
  "NUGGC": [
    "NUGGC cnv",
    "NUGGC rna"
  ],
  "NUMA1": [
    "NUMA1 1225_1235_1_1_S1225 phospho",
    "NUMA1 158_172_1_1_S169 phospho",
    "NUMA1 1848_1866_1_1_S1848 phospho",
    "NUMA1 1993_2001_1_1_T2001 phospho",
    "NUMA1 2033_2041_1_1_S2033 phospho",
    "NUMA1 2033_2041_1_1_T2041 phospho",
    "NUMA1 cnv",
    "NUMA1 methyl",
    "NUMA1 proteo",
    "NUMA1 rna"
  ],
  "NUMB": [
    "NUMB 228_252_1_0 phospho",
    "NUMB 228_252_2_0 phospho",
    "NUMB 513_538_1_1_T513 phospho",
    "NUMB cnv",
    "NUMB methyl",
    "NUMB proteo",
    "NUMB rna"
  ],
  "NUMBL": [
    "NUMBL 210_229_1_0 phospho",
    "NUMBL 210_229_1_1_S222 phospho",
    "NUMBL 210_229_2_0 phospho",
    "NUMBL 210_245_1_0 phospho",
    "NUMBL cnv",
    "NUMBL methyl",
    "NUMBL proteo",
    "NUMBL rna"
  ],
  "NUP107": [
    "NUP107 37_46_1_1_S37 phospho",
    "NUP107 cnv",
    "NUP107 methyl",
    "NUP107 proteo",
    "NUP107 rna"
  ],
  "NUP107-DT": [
    "NUP107-DT methyl"
  ],
  "NUP133": [
    "NUP133 cnv",
    "NUP133 methyl",
    "NUP133 proteo",
    "NUP133 rna"
  ],
  "NUP153": [
    "NUP153 192_199_1_1_S192 phospho",
    "NUP153 202_209_1_1_S209 phospho",
    "NUP153 215_226_1_1_S217 phospho",
    "NUP153 297_307_1_1_S297 phospho",
    "NUP153 319_320_1_1_S320 phospho",
    "NUP153 330_338_1_1_S334 phospho",
    "NUP153 330_338_2_2_S334S338 phospho",
    "NUP153 546_553_1_0 phospho",
    "NUP153 546_553_1_1_S553 phospho",
    "NUP153 645_650_1_1_S645 phospho",
    "NUP153 cnv",
    "NUP153 methyl",
    "NUP153 proteo",
    "NUP153 rna"
  ],
  "NUP155": [
    "NUP155 3_15_1_1_S4 phospho",
    "NUP155 928_948_1_0 phospho",
    "NUP155 cnv",
    "NUP155 methyl",
    "NUP155 proteo",
    "NUP155 rna"
  ],
  "NUP160": [
    "NUP160 1139_1157_1_1_S1157 phospho",
    "NUP160 cnv",
    "NUP160 methyl",
    "NUP160 proteo",
    "NUP160 rna"
  ],
  "NUP188": [
    "NUP188 1523_1532_1_1_S1523 phospho",
    "NUP188 1708_1717_1_1_S1709 phospho",
    "NUP188 cnv",
    "NUP188 methyl",
    "NUP188 proteo",
    "NUP188 rna"
  ],
  "NUP205": [
    "NUP205 cnv",
    "NUP205 proteo",
    "NUP205 rna"
  ],
  "NUP210": [
    "NUP210 EGSGYFFLNTSTADVVK-N2H5F0S0G0 glyco",
    "NUP210 EGSGYFFLNTSTADVVK-N2H6F0S0G0 glyco",
    "NUP210 LPNSTIYVVEPGYLGFTVHPGDR-N2H6F0S0G0 glyco",
    "NUP210 VNFTLEASEGCYR-N2H8F0S0G0 glyco",
    "NUP210 cnv",
    "NUP210 methyl",
    "NUP210 proteo",
    "NUP210 rna"
  ],
  "NUP210L": [
    "NUP210L cnv",
    "NUP210L rna"
  ],
  "NUP214": [
    "NUP214 430_441_2_2_S433T437 phospho",
    "NUP214 450_488_1_0 phospho",
    "NUP214 cnv",
    "NUP214 methyl",
    "NUP214 proteo",
    "NUP214 rna"
  ],
  "NUP35": [
    "NUP35 241_248_1_1_S242 phospho",
    "NUP35 241_248_1_1_T248 phospho",
    "NUP35 279_291_1_1_T291 phospho",
    "NUP35 76_93_1_1_T89 phospho",
    "NUP35 cnv",
    "NUP35 proteo",
    "NUP35 rna"
  ],
  "NUP37": [
    "NUP37 cnv",
    "NUP37 methyl",
    "NUP37 proteo",
    "NUP37 rna"
  ],
  "NUP42": [
    "NUP42 cnv",
    "NUP42 methyl",
    "NUP42 proteo",
    "NUP42 rna"
  ],
  "NUP43": [
    "NUP43 cnv",
    "NUP43 methyl",
    "NUP43 proteo",
    "NUP43 rna"
  ],
  "NUP50": [
    "NUP50 219_228_1_1_S221 phospho",
    "NUP50 cnv",
    "NUP50 methyl",
    "NUP50 proteo",
    "NUP50 rna"
  ],
  "NUP50-DT": [
    "NUP50-DT methyl"
  ],
  "NUP54": [
    "NUP54 cnv",
    "NUP54 methyl",
    "NUP54 proteo",
    "NUP54 rna"
  ],
  "NUP58": [
    "NUP58 cnv",
    "NUP58 methyl",
    "NUP58 proteo",
    "NUP58 rna"
  ],
  "NUP62": [
    "NUP62 cnv",
    "NUP62 methyl",
    "NUP62 proteo",
    "NUP62 rna"
  ],
  "NUP62CL": [
    "NUP62CL methyl",
    "NUP62CL rna"
  ],
  "NUP85": [
    "NUP85 606_610_1_1_S606 phospho",
    "NUP85 cnv",
    "NUP85 methyl",
    "NUP85 proteo",
    "NUP85 rna"
  ],
  "NUP88": [
    "NUP88 35_37_1_1_S35 phospho",
    "NUP88 35_57_1_1_S35 phospho",
    "NUP88 cnv",
    "NUP88 methyl",
    "NUP88 proteo",
    "NUP88 rna"
  ],
  "NUP93": [
    "NUP93 47_55_1_1_S52 phospho",
    "NUP93 cnv",
    "NUP93 methyl",
    "NUP93 proteo",
    "NUP93 rna"
  ],
  "NUP98": [
    "NUP98 1037_1047_1_1_S1043 phospho",
    "NUP98 1037_1053_1_1_T1053 phospho",
    "NUP98 528_533_1_1_T529 phospho",
    "NUP98 601_610_1_1_S606 phospho",
    "NUP98 653_656_1_1_T653 phospho",
    "NUP98 866_880_1_1_S871 phospho",
    "NUP98 889_917_1_0 phospho",
    "NUP98 889_917_1_1_S917 phospho",
    "NUP98 915_917_1_1_S917 phospho",
    "NUP98 cnv",
    "NUP98 methyl",
    "NUP98 proteo",
    "NUP98 rna"
  ],
  "NUPR1": [
    "NUPR1 cnv",
    "NUPR1 proteo",
    "NUPR1 rna"
  ],
  "NUPR2": [
    "NUPR2 cnv",
    "NUPR2 rna"
  ],
  "NUS1": [
    "NUS1 76_76_1_1_S76 phospho",
    "NUS1 cnv",
    "NUS1 methyl",
    "NUS1 rna"
  ],
  "NUSAP1": [
    "NUSAP1 cnv",
    "NUSAP1 methyl",
    "NUSAP1 rna"
  ],
  "NUTF2": [
    "NUTF2 cnv",
    "NUTF2 methyl",
    "NUTF2 proteo",
    "NUTF2 rna"
  ],
  "NUTM1": [
    "NUTM1 cnv",
    "NUTM1 rna"
  ],
  "NUTM2A": [
    "NUTM2A cnv",
    "NUTM2A rna"
  ],
  "NUTM2A-AS1": [
    "NUTM2A-AS1 methyl"
  ],
  "NUTM2B": [
    "NUTM2B cnv",
    "NUTM2B rna"
  ],
  "NUTM2B-AS1": [
    "NUTM2B-AS1 methyl"
  ],
  "NUTM2D": [
    "NUTM2D cnv",
    "NUTM2D rna"
  ],
  "NUTM2E": [
    "NUTM2E cnv",
    "NUTM2E methyl",
    "NUTM2E rna"
  ],
  "NUTM2F": [
    "NUTM2F cnv",
    "NUTM2F rna"
  ],
  "NUTM2G": [
    "NUTM2G cnv",
    "NUTM2G rna"
  ],
  "NVL": [
    "NVL cnv",
    "NVL methyl",
    "NVL proteo",
    "NVL rna"
  ],
  "NWD1": [
    "NWD1 cnv",
    "NWD1 rna"
  ],
  "NWD2": [
    "NWD2 cnv",
    "NWD2 methyl",
    "NWD2 proteo",
    "NWD2 rna"
  ],
  "NXF1": [
    "NXF1 cnv",
    "NXF1 methyl",
    "NXF1 proteo",
    "NXF1 rna"
  ],
  "NXF2": [
    "NXF2 rna"
  ],
  "NXF2B": [
    "NXF2B rna"
  ],
  "NXF3": [
    "NXF3 rna"
  ],
  "NXF5": [
    "NXF5 rna"
  ],
  "NXN": [
    "NXN cnv",
    "NXN methyl",
    "NXN proteo",
    "NXN rna"
  ],
  "NXNL1": [
    "NXNL1 cnv",
    "NXNL1 rna"
  ],
  "NXNL2": [
    "NXNL2 cnv",
    "NXNL2 methyl",
    "NXNL2 rna"
  ],
  "NXPE1": [
    "NXPE1 cnv",
    "NXPE1 rna"
  ],
  "NXPE2": [
    "NXPE2 cnv",
    "NXPE2 rna"
  ],
  "NXPE3": [
    "NXPE3 cnv",
    "NXPE3 methyl",
    "NXPE3 rna"
  ],
  "NXPE4": [
    "NXPE4 cnv",
    "NXPE4 rna"
  ],
  "NXPH1": [
    "NXPH1 cnv",
    "NXPH1 methyl",
    "NXPH1 rna"
  ],
  "NXPH2": [
    "NXPH2 cnv",
    "NXPH2 methyl",
    "NXPH2 rna"
  ],
  "NXPH3": [
    "NXPH3 cnv",
    "NXPH3 methyl",
    "NXPH3 proteo",
    "NXPH3 rna"
  ],
  "NXPH4": [
    "NXPH4 cnv",
    "NXPH4 methyl",
    "NXPH4 rna"
  ],
  "NXT1": [
    "NXT1 cnv",
    "NXT1 methyl",
    "NXT1 proteo",
    "NXT1 rna"
  ],
  "NXT2": [
    "NXT2 20_32_1_1_S32 phospho",
    "NXT2 37_52_1_1_T43 phospho",
    "NXT2 methyl",
    "NXT2 proteo",
    "NXT2 rna"
  ],
  "NYAP1": [
    "NYAP1 cnv",
    "NYAP1 methyl",
    "NYAP1 rna"
  ],
  "NYAP2": [
    "NYAP2 118_135_1_1_S120 phospho",
    "NYAP2 cnv",
    "NYAP2 methyl",
    "NYAP2 proteo",
    "NYAP2 rna"
  ],
  "NYNRIN": [
    "NYNRIN cnv",
    "NYNRIN methyl",
    "NYNRIN rna"
  ],
  "NYX": [
    "NYX rna"
  ],
  "OAF": [
    "OAF cnv",
    "OAF methyl",
    "OAF rna"
  ],
  "OARD1": [
    "OARD1 cnv",
    "OARD1 methyl",
    "OARD1 proteo",
    "OARD1 rna"
  ],
  "OAS1": [
    "OAS1 cnv",
    "OAS1 proteo",
    "OAS1 rna"
  ],
  "OAS2": [
    "OAS2 cnv",
    "OAS2 proteo",
    "OAS2 rna"
  ],
  "OAS3": [
    "OAS3 cnv",
    "OAS3 methyl",
    "OAS3 proteo",
    "OAS3 rna"
  ],
  "OASL": [
    "OASL cnv",
    "OASL proteo",
    "OASL rna"
  ],
  "OAT": [
    "OAT cnv",
    "OAT methyl",
    "OAT proteo",
    "OAT rna"
  ],
  "OAZ1": [
    "OAZ1 cnv",
    "OAZ1 methyl",
    "OAZ1 rna"
  ],
  "OAZ2": [
    "OAZ2 cnv",
    "OAZ2 methyl",
    "OAZ2 rna"
  ],
  "OAZ3": [
    "OAZ3 cnv",
    "OAZ3 methyl",
    "OAZ3 rna"
  ],
  "OBI1": [
    "OBI1 210_210_1_1_S210 phospho",
    "OBI1 524_534_1_1_S526 phospho",
    "OBI1 713_721_1_1_S719 phospho",
    "OBI1 cnv",
    "OBI1 methyl",
    "OBI1 rna"
  ],
  "OBI1-AS1": [
    "OBI1-AS1 methyl"
  ],
  "OBP2A": [
    "OBP2A cnv",
    "OBP2A rna"
  ],
  "OBP2B": [
    "OBP2B cnv",
    "OBP2B rna"
  ],
  "OBSCN": [
    "OBSCN cnv",
    "OBSCN kinase",
    "OBSCN methyl",
    "OBSCN rna"
  ],
  "OBSCN-AS1": [
    "OBSCN-AS1 methyl"
  ],
  "OBSL1": [
    "OBSL1 4_10_1_1_S10 phospho",
    "OBSL1 cnv",
    "OBSL1 methyl",
    "OBSL1 proteo",
    "OBSL1 rna"
  ],
  "OC90": [
    "OC90 cnv",
    "OC90 rna"
  ],
  "OCA2": [
    "OCA2 cnv",
    "OCA2 methyl",
    "OCA2 rna"
  ],
  "OCEL1": [
    "OCEL1 cnv",
    "OCEL1 methyl",
    "OCEL1 rna"
  ],
  "OCIAD1": [
    "OCIAD1 108_108_1_1_S108 phospho",
    "OCIAD1 122_129_1_0 phospho",
    "OCIAD1 122_129_1_1_S123 phospho",
    "OCIAD1 cnv",
    "OCIAD1 methyl",
    "OCIAD1 proteo",
    "OCIAD1 rna"
  ],
  "OCIAD2": [
    "OCIAD2 cnv",
    "OCIAD2 methyl",
    "OCIAD2 proteo",
    "OCIAD2 rna"
  ],
  "OCLN": [
    "OCLN 368_378_1_1_S369 phospho",
    "OCLN cnv",
    "OCLN methyl",
    "OCLN rna"
  ],
  "OCM": [
    "OCM cnv",
    "OCM rna"
  ],
  "OCM2": [
    "OCM2 cnv",
    "OCM2 rna"
  ],
  "OCRL": [
    "OCRL methyl",
    "OCRL proteo",
    "OCRL rna"
  ],
  "OCSTAMP": [
    "OCSTAMP cnv",
    "OCSTAMP rna"
  ],
  "ODAD1": [
    "ODAD1 cnv",
    "ODAD1 methyl",
    "ODAD1 rna"
  ],
  "ODAD2": [
    "ODAD2 cnv",
    "ODAD2 methyl",
    "ODAD2 rna"
  ],
  "ODAD3": [
    "ODAD3 cnv",
    "ODAD3 methyl",
    "ODAD3 rna"
  ],
  "ODAD4": [
    "ODAD4 cnv",
    "ODAD4 methyl",
    "ODAD4 rna"
  ],
  "ODAM": [
    "ODAM cnv",
    "ODAM rna"
  ],
  "ODAPH": [
    "ODAPH cnv",
    "ODAPH rna"
  ],
  "ODC1": [
    "ODC1 cnv",
    "ODC1 methyl",
    "ODC1 rna"
  ],
  "ODF1": [
    "ODF1 cnv",
    "ODF1 rna"
  ],
  "ODF2": [
    "ODF2 5_18_1_1_T7 phospho",
    "ODF2 cnv",
    "ODF2 methyl",
    "ODF2 proteo",
    "ODF2 rna"
  ],
  "ODF2L": [
    "ODF2L cnv",
    "ODF2L methyl",
    "ODF2L rna"
  ],
  "ODF3": [
    "ODF3 cnv",
    "ODF3 rna"
  ],
  "ODF3B": [
    "ODF3B cnv",
    "ODF3B methyl",
    "ODF3B rna"
  ],
  "ODF3L1": [
    "ODF3L1 cnv",
    "ODF3L1 rna"
  ],
  "ODF3L2": [
    "ODF3L2 cnv",
    "ODF3L2 rna"
  ],
  "ODF4": [
    "ODF4 cnv"
  ],
  "ODR4": [
    "ODR4 cnv",
    "ODR4 methyl",
    "ODR4 proteo",
    "ODR4 rna"
  ],
  "OFD1": [
    "OFD1 695_697_1_1_S695 phospho",
    "OFD1 859_859_1_1_S859 phospho",
    "OFD1 methyl",
    "OFD1 rna"
  ],
  "OGA": [
    "OGA 364_375_1_1_S364 phospho",
    "OGA 709_712_1_1_T709 phospho",
    "OGA cnv",
    "OGA methyl",
    "OGA proteo",
    "OGA rna"
  ],
  "OGDH": [
    "OGDH cnv",
    "OGDH methyl",
    "OGDH proteo",
    "OGDH rna"
  ],
  "OGDHL": [
    "OGDHL cnv",
    "OGDHL methyl",
    "OGDHL proteo",
    "OGDHL rna"
  ],
  "OGFOD1": [
    "OGFOD1 cnv",
    "OGFOD1 methyl",
    "OGFOD1 proteo",
    "OGFOD1 rna"
  ],
  "OGFOD2": [
    "OGFOD2 cnv",
    "OGFOD2 methyl",
    "OGFOD2 proteo",
    "OGFOD2 rna"
  ],
  "OGFOD3": [
    "OGFOD3 FMFMEEGANK-N2H6F0S0G0 glyco",
    "OGFOD3 FMFMEEGANK-N2H8F0S0G0 glyco",
    "OGFOD3 cnv",
    "OGFOD3 methyl",
    "OGFOD3 proteo",
    "OGFOD3 rna"
  ],
  "OGFR": [
    "OGFR 315_325_1_1_S315 phospho",
    "OGFR 361_378_1_1_S378 phospho",
    "OGFR 397_405_1_1_S403 phospho",
    "OGFR 468_488_1_1_S484 phospho",
    "OGFR cnv",
    "OGFR methyl",
    "OGFR proteo",
    "OGFR rna"
  ],
  "OGFRL1": [
    "OGFRL1 cnv",
    "OGFRL1 methyl",
    "OGFRL1 proteo",
    "OGFRL1 rna"
  ],
  "OGG1": [
    "OGG1 cnv",
    "OGG1 methyl",
    "OGG1 rna"
  ],
  "OGN": [
    "OGN cnv",
    "OGN proteo",
    "OGN rna"
  ],
  "OGT": [
    "OGT 20_20_1_1_S20 phospho",
    "OGT methyl",
    "OGT proteo",
    "OGT rna"
  ],
  "OIP5": [
    "OIP5 cnv",
    "OIP5 methyl",
    "OIP5 rna"
  ],
  "OIP5-AS1": [
    "OIP5-AS1 methyl"
  ],
  "OIT3": [
    "OIT3 cnv",
    "OIT3 rna"
  ],
  "OLA1": [
    "OLA1 cnv",
    "OLA1 methyl",
    "OLA1 proteo",
    "OLA1 rna"
  ],
  "OLAH": [
    "OLAH cnv",
    "OLAH rna"
  ],
  "OLFM1": [
    "OLFM1 LDPVSLQTLQTWNTSYPK-N5H3F1S0G0 glyco",
    "OLFM1 VHYAYQTNASTYEYIDIPFQNK-N2H5F0S0G0 glyco",
    "OLFM1 cnv",
    "OLFM1 methyl",
    "OLFM1 proteo",
    "OLFM1 rna"
  ],
  "OLFM2": [
    "OLFM2 cnv",
    "OLFM2 methyl",
    "OLFM2 proteo",
    "OLFM2 rna"
  ],
  "OLFM3": [
    "OLFM3 cnv",
    "OLFM3 proteo",
    "OLFM3 rna"
  ],
  "OLFM4": [
    "OLFM4 VNLTTNTIAVTQTLPNAAYNNR-N2H5F0S0G0 glyco",
    "OLFM4 VNLTTNTIAVTQTLPNAAYNNR-N2H6F0S0G0 glyco",
    "OLFM4 cnv",
    "OLFM4 proteo",
    "OLFM4 rna"
  ],
  "OLFML1": [
    "OLFML1 cnv",
    "OLFML1 proteo",
    "OLFML1 rna"
  ],
  "OLFML2A": [
    "OLFML2A 113_120_1_1_S120 phospho",
    "OLFML2A cnv",
    "OLFML2A methyl",
    "OLFML2A rna"
  ],
  "OLFML2B": [
    "OLFML2B cnv",
    "OLFML2B methyl",
    "OLFML2B proteo",
    "OLFML2B rna"
  ],
  "OLFML3": [
    "OLFML3 IYVLDGTQNDTAFVFPR-N4H3F1S0G0 glyco",
    "OLFML3 IYVLDGTQNDTAFVFPR-N4H4F1S0G0 glyco",
    "OLFML3 IYVLDGTQNDTAFVFPR-N5H3F1S0G0 glyco",
    "OLFML3 cnv",
    "OLFML3 proteo",
    "OLFML3 rna"
  ],
  "OLIG1": [
    "OLIG1 cnv",
    "OLIG1 methyl",
    "OLIG1 rna"
  ],
  "OLIG2": [
    "OLIG2 cnv",
    "OLIG2 methyl",
    "OLIG2 proteo",
    "OLIG2 rna"
  ],
  "OLIG3": [
    "OLIG3 cnv",
    "OLIG3 methyl",
    "OLIG3 rna"
  ],
  "OLMALINC": [
    "OLMALINC methyl"
  ],
  "OLR1": [
    "OLR1 cnv",
    "OLR1 rna"
  ],
  "OMA1": [
    "OMA1 cnv",
    "OMA1 methyl",
    "OMA1 rna"
  ],
  "OMD": [
    "OMD cnv",
    "OMD proteo",
    "OMD rna"
  ],
  "OMG": [
    "OMG QNITYLLK-N2H5F0S0G0 glyco",
    "OMG QNITYLLK-N4H5F1S0G0 glyco",
    "OMG QNITYLLK-N5H3F1S0G0 glyco",
    "OMG QNITYLLK-N5H4F2S0G0 glyco",
    "OMG SLEVLNLSSNK-N2H10F0S0G0 glyco",
    "OMG SLEVLNLSSNK-N2H4F0S0G0 glyco",
    "OMG SLEVLNLSSNK-N2H5F0S0G0 glyco",
    "OMG SLEVLNLSSNK-N2H7F0S0G0 glyco",
    "OMG SLEVLNLSSNK-N2H8F0S0G0 glyco",
    "OMG SLEVLNLSSNK-N2H9F0S0G0 glyco",
    "OMG SLEVLNLSSNK-N4H3F0S2G0 glyco",
    "OMG SLEVLNLSSNK-N4H4F0S2G0 glyco",
    "OMG SLWNMSAANNNIK-N2H6F0S0G0 glyco",
    "OMG SLWNMSAANNNIK-N2H7F0S0G0 glyco",
    "OMG SLWNMSAANNNIK-N2H8F0S0G0 glyco",
    "OMG SLWNMSAANNNIK-N2H9F0S0G0 glyco",
    "OMG cnv",
    "OMG proteo",
    "OMG rna"
  ],
  "OMP": [
    "OMP cnv",
    "OMP rna"
  ],
  "ONECUT1": [
    "ONECUT1 cnv",
    "ONECUT1 methyl",
    "ONECUT1 rna"
  ],
  "ONECUT2": [
    "ONECUT2 cnv",
    "ONECUT2 methyl",
    "ONECUT2 rna"
  ],
  "ONECUT3": [
    "ONECUT3 cnv",
    "ONECUT3 methyl",
    "ONECUT3 rna"
  ],
  "OOEP": [
    "OOEP cnv",
    "OOEP methyl",
    "OOEP rna"
  ],
  "OOSP1": [
    "OOSP1 cnv",
    "OOSP1 rna"
  ],
  "OOSP2": [
    "OOSP2 cnv"
  ],
  "OOSP3": [
    "OOSP3 cnv",
    "OOSP3 rna"
  ],
  "OOSP4A": [
    "OOSP4A cnv"
  ],
  "OOSP4B": [
    "OOSP4B cnv"
  ],
  "OPA1": [
    "OPA1 cnv",
    "OPA1 methyl",
    "OPA1 proteo",
    "OPA1 rna"
  ],
  "OPA3": [
    "OPA3 cnv",
    "OPA3 methyl",
    "OPA3 proteo",
    "OPA3 rna"
  ],
  "OPALIN": [
    "OPALIN cnv",
    "OPALIN proteo",
    "OPALIN rna"
  ],
  "OPCML": [
    "OPCML DYGNYTCVATNK-N4H3F1S0G0 glyco",
    "OPCML DYGNYTCVATNK-N4H4F2S0G0 glyco",
    "OPCML DYGNYTCVATNK-N5H3F1S0G0 glyco",
    "OPCML DYGNYTCVATNK-N5H4F2S0G0 glyco",
    "OPCML MSTLTFFNVSEK-N5H3F1S0G0 glyco",
    "OPCML MSTLTFFNVSEK-N6H5F2S1G0 glyco",
    "OPCML cnv",
    "OPCML methyl",
    "OPCML proteo",
    "OPCML rna"
  ],
  "OPHN1": [
    "OPHN1 643_646_1_1_S643 phospho",
    "OPHN1 652_654_1_1_S652 phospho",
    "OPHN1 methyl",
    "OPHN1 proteo",
    "OPHN1 rna"
  ],
  "OPLAH": [
    "OPLAH cnv",
    "OPLAH proteo",
    "OPLAH rna"
  ],
  "OPN1SW": [
    "OPN1SW cnv",
    "OPN1SW rna"
  ],
  "OPN3": [
    "OPN3 cnv",
    "OPN3 methyl",
    "OPN3 rna"
  ],
  "OPN4": [
    "OPN4 cnv",
    "OPN4 rna"
  ],
  "OPN5": [
    "OPN5 cnv",
    "OPN5 rna"
  ],
  "OPRD1": [
    "OPRD1 cnv",
    "OPRD1 rna"
  ],
  "OPRK1": [
    "OPRK1 cnv",
    "OPRK1 methyl",
    "OPRK1 rna"
  ],
  "OPRL1": [
    "OPRL1 cnv",
    "OPRL1 methyl",
    "OPRL1 rna"
  ],
  "OPRM1": [
    "OPRM1 cnv",
    "OPRM1 methyl",
    "OPRM1 rna"
  ],
  "OPRPN": [
    "OPRPN cnv"
  ],
  "OPTC": [
    "OPTC cnv",
    "OPTC rna"
  ],
  "OPTN": [
    "OPTN 198_202_1_1_S198 phospho",
    "OPTN 342_346_1_1_S342 phospho",
    "OPTN cnv",
    "OPTN methyl",
    "OPTN proteo",
    "OPTN rna"
  ],
  "OR10A2": [
    "OR10A2 cnv"
  ],
  "OR10A3": [
    "OR10A3 cnv"
  ],
  "OR10A4": [
    "OR10A4 cnv"
  ],
  "OR10A5": [
    "OR10A5 cnv"
  ],
  "OR10A6": [
    "OR10A6 cnv"
  ],
  "OR10A7": [
    "OR10A7 cnv"
  ],
  "OR10AC1": [
    "OR10AC1 cnv",
    "OR10AC1 rna"
  ],
  "OR10AD1": [
    "OR10AD1 cnv",
    "OR10AD1 rna"
  ],
  "OR10AG1": [
    "OR10AG1 cnv"
  ],
  "OR10C1": [
    "OR10C1 cnv",
    "OR10C1 rna"
  ],
  "OR10D3": [
    "OR10D3 cnv",
    "OR10D3 rna"
  ],
  "OR10G2": [
    "OR10G2 cnv"
  ],
  "OR10G3": [
    "OR10G3 cnv"
  ],
  "OR10G4": [
    "OR10G4 cnv"
  ],
  "OR10G6": [
    "OR10G6 cnv"
  ],
  "OR10G7": [
    "OR10G7 cnv"
  ],
  "OR10G8": [
    "OR10G8 cnv"
  ],
  "OR10G9": [
    "OR10G9 cnv"
  ],
  "OR10H1": [
    "OR10H1 cnv",
    "OR10H1 rna"
  ],
  "OR10H2": [
    "OR10H2 cnv",
    "OR10H2 rna"
  ],
  "OR10H3": [
    "OR10H3 cnv"
  ],
  "OR10H4": [
    "OR10H4 cnv"
  ],
  "OR10H5": [
    "OR10H5 cnv",
    "OR10H5 rna"
  ],
  "OR10J1": [
    "OR10J1 cnv"
  ],
  "OR10J3": [
    "OR10J3 cnv"
  ],
  "OR10J4": [
    "OR10J4 cnv"
  ],
  "OR10J5": [
    "OR10J5 cnv"
  ],
  "OR10K1": [
    "OR10K1 cnv",
    "OR10K1 rna"
  ],
  "OR10K2": [
    "OR10K2 cnv"
  ],
  "OR10P1": [
    "OR10P1 cnv"
  ],
  "OR10Q1": [
    "OR10Q1 cnv",
    "OR10Q1 rna"
  ],
  "OR10R2": [
    "OR10R2 cnv"
  ],
  "OR10S1": [
    "OR10S1 cnv"
  ],
  "OR10T2": [
    "OR10T2 cnv"
  ],
  "OR10V1": [
    "OR10V1 cnv",
    "OR10V1 rna"
  ],
  "OR10W1": [
    "OR10W1 cnv",
    "OR10W1 rna"
  ],
  "OR10X1": [
    "OR10X1 cnv"
  ],
  "OR10Z1": [
    "OR10Z1 cnv"
  ],
  "OR11A1": [
    "OR11A1 cnv"
  ],
  "OR11G2": [
    "OR11G2 cnv"
  ],
  "OR11H1": [
    "OR11H1 cnv"
  ],
  "OR11H12": [
    "OR11H12 cnv",
    "OR11H12 rna"
  ],
  "OR11H2": [
    "OR11H2 cnv",
    "OR11H2 rna"
  ],
  "OR11H4": [
    "OR11H4 cnv"
  ],
  "OR11H6": [
    "OR11H6 cnv"
  ],
  "OR11H7": [
    "OR11H7 cnv"
  ],
  "OR11L1": [
    "OR11L1 cnv",
    "OR11L1 rna"
  ],
  "OR12D1": [
    "OR12D1 cnv",
    "OR12D1 rna"
  ],
  "OR12D2": [
    "OR12D2 cnv",
    "OR12D2 rna"
  ],
  "OR12D3": [
    "OR12D3 cnv"
  ],
  "OR13A1": [
    "OR13A1 cnv",
    "OR13A1 rna"
  ],
  "OR13C2": [
    "OR13C2 cnv",
    "OR13C2 rna"
  ],
  "OR13C3": [
    "OR13C3 cnv",
    "OR13C3 rna"
  ],
  "OR13C4": [
    "OR13C4 cnv",
    "OR13C4 rna"
  ],
  "OR13C5": [
    "OR13C5 cnv",
    "OR13C5 rna"
  ],
  "OR13C7": [
    "OR13C7 cnv"
  ],
  "OR13C8": [
    "OR13C8 cnv"
  ],
  "OR13C9": [
    "OR13C9 cnv",
    "OR13C9 rna"
  ],
  "OR13D1": [
    "OR13D1 cnv"
  ],
  "OR13F1": [
    "OR13F1 cnv"
  ],
  "OR13G1": [
    "OR13G1 cnv"
  ],
  "OR13J1": [
    "OR13J1 cnv",
    "OR13J1 rna"
  ],
  "OR14A16": [
    "OR14A16 cnv"
  ],
  "OR14A2": [
    "OR14A2 cnv"
  ],
  "OR14C36": [
    "OR14C36 cnv"
  ],
  "OR14I1": [
    "OR14I1 cnv",
    "OR14I1 rna"
  ],
  "OR14J1": [
    "OR14J1 cnv",
    "OR14J1 rna"
  ],
  "OR14K1": [
    "OR14K1 cnv",
    "OR14K1 rna"
  ],
  "OR14L1P": [
    "OR14L1P cnv"
  ],
  "OR1A1": [
    "OR1A1 cnv",
    "OR1A1 rna"
  ],
  "OR1A2": [
    "OR1A2 cnv"
  ],
  "OR1B1": [
    "OR1B1 cnv",
    "OR1B1 rna"
  ],
  "OR1C1": [
    "OR1C1 cnv"
  ],
  "OR1D2": [
    "OR1D2 cnv"
  ],
  "OR1D4": [
    "OR1D4 cnv"
  ],
  "OR1D5": [
    "OR1D5 cnv",
    "OR1D5 rna"
  ],
  "OR1E1": [
    "OR1E1 cnv",
    "OR1E1 rna"
  ],
  "OR1E2": [
    "OR1E2 cnv",
    "OR1E2 rna"
  ],
  "OR1E3": [
    "OR1E3 cnv"
  ],
  "OR1F1": [
    "OR1F1 cnv",
    "OR1F1 rna"
  ],
  "OR1G1": [
    "OR1G1 cnv",
    "OR1G1 rna"
  ],
  "OR1I1": [
    "OR1I1 cnv"
  ],
  "OR1J1": [
    "OR1J1 cnv"
  ],
  "OR1J2": [
    "OR1J2 cnv",
    "OR1J2 rna"
  ],
  "OR1J4": [
    "OR1J4 cnv",
    "OR1J4 rna"
  ],
  "OR1K1": [
    "OR1K1 cnv",
    "OR1K1 rna"
  ],
  "OR1L1": [
    "OR1L1 cnv",
    "OR1L1 rna"
  ],
  "OR1L3": [
    "OR1L3 cnv",
    "OR1L3 rna"
  ],
  "OR1L4": [
    "OR1L4 cnv",
    "OR1L4 rna"
  ],
  "OR1L6": [
    "OR1L6 cnv"
  ],
  "OR1L8": [
    "OR1L8 cnv",
    "OR1L8 rna"
  ],
  "OR1M1": [
    "OR1M1 cnv"
  ],
  "OR1N1": [
    "OR1N1 cnv",
    "OR1N1 rna"
  ],
  "OR1N2": [
    "OR1N2 cnv",
    "OR1N2 rna"
  ],
  "OR1P1": [
    "OR1P1 cnv",
    "OR1P1 rna"
  ],
  "OR1Q1": [
    "OR1Q1 cnv",
    "OR1Q1 rna"
  ],
  "OR1R1P": [
    "OR1R1P cnv",
    "OR1R1P rna"
  ],
  "OR1S1": [
    "OR1S1 cnv"
  ],
  "OR1S2": [
    "OR1S2 cnv"
  ],
  "OR2A1": [
    "OR2A1 cnv",
    "OR2A1 rna"
  ],
  "OR2A12": [
    "OR2A12 cnv"
  ],
  "OR2A14": [
    "OR2A14 cnv"
  ],
  "OR2A2": [
    "OR2A2 cnv"
  ],
  "OR2A25": [
    "OR2A25 cnv"
  ],
  "OR2A4": [
    "OR2A4 cnv",
    "OR2A4 rna"
  ],
  "OR2A42": [
    "OR2A42 cnv",
    "OR2A42 rna"
  ],
  "OR2A5": [
    "OR2A5 cnv"
  ],
  "OR2A7": [
    "OR2A7 cnv",
    "OR2A7 rna"
  ],
  "OR2AE1": [
    "OR2AE1 cnv",
    "OR2AE1 rna"
  ],
  "OR2AG1": [
    "OR2AG1 cnv"
  ],
  "OR2AG2": [
    "OR2AG2 cnv",
    "OR2AG2 rna"
  ],
  "OR2AJ1": [
    "OR2AJ1 cnv"
  ],
  "OR2AK2": [
    "OR2AK2 cnv",
    "OR2AK2 rna"
  ],
  "OR2AP1": [
    "OR2AP1 cnv"
  ],
  "OR2AT4": [
    "OR2AT4 cnv",
    "OR2AT4 rna"
  ],
  "OR2B11": [
    "OR2B11 cnv",
    "OR2B11 rna"
  ],
  "OR2B2": [
    "OR2B2 cnv",
    "OR2B2 rna"
  ],
  "OR2B3": [
    "OR2B3 cnv"
  ],
  "OR2B6": [
    "OR2B6 cnv",
    "OR2B6 rna"
  ],
  "OR2C1": [
    "OR2C1 cnv",
    "OR2C1 rna"
  ],
  "OR2C3": [
    "OR2C3 cnv",
    "OR2C3 rna"
  ],
  "OR2D2": [
    "OR2D2 cnv",
    "OR2D2 rna"
  ],
  "OR2D3": [
    "OR2D3 cnv"
  ],
  "OR2F1": [
    "OR2F1 cnv",
    "OR2F1 rna"
  ],
  "OR2F2": [
    "OR2F2 cnv"
  ],
  "OR2G2": [
    "OR2G2 cnv"
  ],
  "OR2G3": [
    "OR2G3 cnv"
  ],
  "OR2G6": [
    "OR2G6 cnv"
  ],
  "OR2H1": [
    "OR2H1 cnv",
    "OR2H1 rna"
  ],
  "OR2H2": [
    "OR2H2 cnv",
    "OR2H2 rna"
  ],
  "OR2I1P": [
    "OR2I1P cnv",
    "OR2I1P rna"
  ],
  "OR2J1": [
    "OR2J1 cnv",
    "OR2J1 rna"
  ],
  "OR2J2": [
    "OR2J2 cnv",
    "OR2J2 rna"
  ],
  "OR2J3": [
    "OR2J3 cnv",
    "OR2J3 rna"
  ],
  "OR2K2": [
    "OR2K2 cnv",
    "OR2K2 rna"
  ],
  "OR2L13": [
    "OR2L13 cnv",
    "OR2L13 rna"
  ],
  "OR2L2": [
    "OR2L2 cnv",
    "OR2L2 rna"
  ],
  "OR2L3": [
    "OR2L3 cnv",
    "OR2L3 rna"
  ],
  "OR2L5": [
    "OR2L5 cnv",
    "OR2L5 rna"
  ],
  "OR2L8": [
    "OR2L8 cnv",
    "OR2L8 rna"
  ],
  "OR2M2": [
    "OR2M2 cnv",
    "OR2M2 rna"
  ],
  "OR2M3": [
    "OR2M3 cnv",
    "OR2M3 rna"
  ],
  "OR2M4": [
    "OR2M4 cnv",
    "OR2M4 rna"
  ],
  "OR2M5": [
    "OR2M5 cnv",
    "OR2M5 rna"
  ],
  "OR2M7": [
    "OR2M7 cnv"
  ],
  "OR2S2": [
    "OR2S2 cnv",
    "OR2S2 rna"
  ],
  "OR2T1": [
    "OR2T1 cnv"
  ],
  "OR2T10": [
    "OR2T10 cnv",
    "OR2T10 rna"
  ],
  "OR2T11": [
    "OR2T11 cnv"
  ],
  "OR2T12": [
    "OR2T12 cnv"
  ],
  "OR2T2": [
    "OR2T2 cnv"
  ],
  "OR2T27": [
    "OR2T27 cnv"
  ],
  "OR2T29": [
    "OR2T29 cnv"
  ],
  "OR2T3": [
    "OR2T3 cnv"
  ],
  "OR2T33": [
    "OR2T33 cnv",
    "OR2T33 rna"
  ],
  "OR2T34": [
    "OR2T34 cnv"
  ],
  "OR2T35": [
    "OR2T35 cnv"
  ],
  "OR2T4": [
    "OR2T4 cnv",
    "OR2T4 rna"
  ],
  "OR2T5": [
    "OR2T5 cnv"
  ],
  "OR2T6": [
    "OR2T6 cnv",
    "OR2T6 rna"
  ],
  "OR2T7": [
    "OR2T7 cnv"
  ],
  "OR2T8": [
    "OR2T8 cnv",
    "OR2T8 rna"
  ],
  "OR2V1": [
    "OR2V1 cnv"
  ],
  "OR2V2": [
    "OR2V2 cnv"
  ],
  "OR2W1": [
    "OR2W1 cnv"
  ],
  "OR2W3": [
    "OR2W3 cnv",
    "OR2W3 rna"
  ],
  "OR2Y1": [
    "OR2Y1 cnv"
  ],
  "OR2Z1": [
    "OR2Z1 cnv"
  ],
  "OR3A1": [
    "OR3A1 cnv",
    "OR3A1 rna"
  ],
  "OR3A2": [
    "OR3A2 cnv",
    "OR3A2 methyl",
    "OR3A2 rna"
  ],
  "OR3A3": [
    "OR3A3 cnv",
    "OR3A3 rna"
  ],
  "OR4A15": [
    "OR4A15 cnv"
  ],
  "OR4A16": [
    "OR4A16 cnv",
    "OR4A16 rna"
  ],
  "OR4A47": [
    "OR4A47 cnv",
    "OR4A47 rna"
  ],
  "OR4A5": [
    "OR4A5 cnv"
  ],
  "OR4A8": [
    "OR4A8 cnv"
  ],
  "OR4B1": [
    "OR4B1 cnv"
  ],
  "OR4C11": [
    "OR4C11 cnv"
  ],
  "OR4C12": [
    "OR4C12 cnv"
  ],
  "OR4C13": [
    "OR4C13 cnv"
  ],
  "OR4C15": [
    "OR4C15 cnv"
  ],
  "OR4C16": [
    "OR4C16 cnv"
  ],
  "OR4C3": [
    "OR4C3 cnv"
  ],
  "OR4C45": [
    "OR4C45 cnv"
  ],
  "OR4C46": [
    "OR4C46 cnv"
  ],
  "OR4C5": [
    "OR4C5 cnv"
  ],
  "OR4C6": [
    "OR4C6 cnv"
  ],
  "OR4D1": [
    "OR4D1 cnv",
    "OR4D1 rna"
  ],
  "OR4D10": [
    "OR4D10 cnv"
  ],
  "OR4D11": [
    "OR4D11 cnv"
  ],
  "OR4D2": [
    "OR4D2 cnv",
    "OR4D2 rna"
  ],
  "OR4D5": [
    "OR4D5 cnv",
    "OR4D5 rna"
  ],
  "OR4D6": [
    "OR4D6 cnv"
  ],
  "OR4D9": [
    "OR4D9 cnv"
  ],
  "OR4E1": [
    "OR4E1 cnv"
  ],
  "OR4E2": [
    "OR4E2 cnv"
  ],
  "OR4F15": [
    "OR4F15 cnv",
    "OR4F15 rna"
  ],
  "OR4F16": [
    "OR4F16 cnv",
    "OR4F16 rna"
  ],
  "OR4F17": [
    "OR4F17 cnv",
    "OR4F17 rna"
  ],
  "OR4F21": [
    "OR4F21 cnv",
    "OR4F21 rna"
  ],
  "OR4F29": [
    "OR4F29 cnv",
    "OR4F29 rna"
  ],
  "OR4F3": [
    "OR4F3 cnv",
    "OR4F3 rna"
  ],
  "OR4F4": [
    "OR4F4 cnv"
  ],
  "OR4F5": [
    "OR4F5 cnv"
  ],
  "OR4F6": [
    "OR4F6 cnv",
    "OR4F6 rna"
  ],
  "OR4K1": [
    "OR4K1 cnv",
    "OR4K1 rna"
  ],
  "OR4K13": [
    "OR4K13 cnv"
  ],
  "OR4K14": [
    "OR4K14 cnv"
  ],
  "OR4K15": [
    "OR4K15 cnv"
  ],
  "OR4K17": [
    "OR4K17 cnv"
  ],
  "OR4K2": [
    "OR4K2 cnv",
    "OR4K2 rna"
  ],
  "OR4K3": [
    "OR4K3 cnv"
  ],
  "OR4K5": [
    "OR4K5 cnv"
  ],
  "OR4L1": [
    "OR4L1 cnv"
  ],
  "OR4M1": [
    "OR4M1 cnv"
  ],
  "OR4M2": [
    "OR4M2 cnv",
    "OR4M2 rna"
  ],
  "OR4M2-OT1": [
    "OR4M2-OT1 cnv",
    "OR4M2-OT1 rna"
  ],
  "OR4M2B": [
    "OR4M2B cnv",
    "OR4M2B rna"
  ],
  "OR4N2": [
    "OR4N2 cnv",
    "OR4N2 rna"
  ],
  "OR4N4": [
    "OR4N4 cnv",
    "OR4N4 rna"
  ],
  "OR4N4C": [
    "OR4N4C cnv",
    "OR4N4C rna"
  ],
  "OR4N5": [
    "OR4N5 cnv"
  ],
  "OR4P4": [
    "OR4P4 cnv"
  ],
  "OR4Q2": [
    "OR4Q2 cnv"
  ],
  "OR4Q3": [
    "OR4Q3 cnv"
  ],
  "OR4S1": [
    "OR4S1 cnv"
  ],
  "OR4S2": [
    "OR4S2 cnv"
  ],
  "OR4X1": [
    "OR4X1 cnv"
  ],
  "OR4X2": [
    "OR4X2 cnv",
    "OR4X2 rna"
  ],
  "OR51A2": [
    "OR51A2 cnv"
  ],
  "OR51A4": [
    "OR51A4 cnv"
  ],
  "OR51A7": [
    "OR51A7 cnv"
  ],
  "OR51B2": [
    "OR51B2 cnv",
    "OR51B2 rna"
  ],
  "OR51B4": [
    "OR51B4 cnv",
    "OR51B4 rna"
  ],
  "OR51B5": [
    "OR51B5 cnv",
    "OR51B5 rna"
  ],
  "OR51B6": [
    "OR51B6 cnv"
  ],
  "OR51C1P": [
    "OR51C1P cnv",
    "OR51C1P rna"
  ],
  "OR51D1": [
    "OR51D1 cnv"
  ],
  "OR51E1": [
    "OR51E1 cnv",
    "OR51E1 rna"
  ],
  "OR51E2": [
    "OR51E2 cnv",
    "OR51E2 rna"
  ],
  "OR51F1": [
    "OR51F1 cnv"
  ],
  "OR51F2": [
    "OR51F2 cnv"
  ],
  "OR51G1": [
    "OR51G1 cnv"
  ],
  "OR51G2": [
    "OR51G2 cnv"
  ],
  "OR51H1": [
    "OR51H1 cnv"
  ],
  "OR51I1": [
    "OR51I1 cnv",
    "OR51I1 rna"
  ],
  "OR51I2": [
    "OR51I2 cnv"
  ],
  "OR51J1": [
    "OR51J1 cnv",
    "OR51J1 rna"
  ],
  "OR51L1": [
    "OR51L1 cnv"
  ],
  "OR51M1": [
    "OR51M1 cnv",
    "OR51M1 rna"
  ],
  "OR51Q1": [
    "OR51Q1 cnv",
    "OR51Q1 rna"
  ],
  "OR51S1": [
    "OR51S1 cnv"
  ],
  "OR51T1": [
    "OR51T1 cnv"
  ],
  "OR51V1": [
    "OR51V1 cnv"
  ],
  "OR52A1": [
    "OR52A1 cnv"
  ],
  "OR52A5": [
    "OR52A5 cnv"
  ],
  "OR52B2": [
    "OR52B2 cnv",
    "OR52B2 rna"
  ],
  "OR52B4": [
    "OR52B4 cnv",
    "OR52B4 rna"
  ],
  "OR52B6": [
    "OR52B6 cnv",
    "OR52B6 rna"
  ],
  "OR52D1": [
    "OR52D1 cnv",
    "OR52D1 rna"
  ],
  "OR52E1": [
    "OR52E1 cnv"
  ],
  "OR52E2": [
    "OR52E2 cnv",
    "OR52E2 rna"
  ],
  "OR52E4": [
    "OR52E4 cnv"
  ],
  "OR52E5": [
    "OR52E5 cnv"
  ],
  "OR52E6": [
    "OR52E6 cnv",
    "OR52E6 rna"
  ],
  "OR52E8": [
    "OR52E8 cnv",
    "OR52E8 rna"
  ],
  "OR52H1": [
    "OR52H1 cnv",
    "OR52H1 rna"
  ],
  "OR52I1": [
    "OR52I1 cnv",
    "OR52I1 rna"
  ],
  "OR52I2": [
    "OR52I2 cnv",
    "OR52I2 rna"
  ],
  "OR52J3": [
    "OR52J3 cnv"
  ],
  "OR52K1": [
    "OR52K1 cnv",
    "OR52K1 rna"
  ],
  "OR52K2": [
    "OR52K2 cnv",
    "OR52K2 rna"
  ],
  "OR52L1": [
    "OR52L1 cnv",
    "OR52L1 rna"
  ],
  "OR52M1": [
    "OR52M1 cnv",
    "OR52M1 rna"
  ],
  "OR52N1": [
    "OR52N1 cnv",
    "OR52N1 rna"
  ],
  "OR52N2": [
    "OR52N2 cnv",
    "OR52N2 rna"
  ],
  "OR52N4": [
    "OR52N4 cnv",
    "OR52N4 rna"
  ],
  "OR52N5": [
    "OR52N5 cnv",
    "OR52N5 rna"
  ],
  "OR52P1": [
    "OR52P1 cnv",
    "OR52P1 rna"
  ],
  "OR52R1": [
    "OR52R1 cnv"
  ],
  "OR52W1": [
    "OR52W1 cnv",
    "OR52W1 rna"
  ],
  "OR56A1": [
    "OR56A1 cnv",
    "OR56A1 rna"
  ],
  "OR56A3": [
    "OR56A3 cnv"
  ],
  "OR56A4": [
    "OR56A4 cnv",
    "OR56A4 rna"
  ],
  "OR56A5": [
    "OR56A5 cnv",
    "OR56A5 rna"
  ],
  "OR56B1": [
    "OR56B1 cnv",
    "OR56B1 rna"
  ],
  "OR56B2P": [
    "OR56B2P cnv",
    "OR56B2P rna"
  ],
  "OR56B4": [
    "OR56B4 cnv",
    "OR56B4 rna"
  ],
  "OR5A1": [
    "OR5A1 cnv"
  ],
  "OR5A2": [
    "OR5A2 cnv"
  ],
  "OR5AC1": [
    "OR5AC1 cnv"
  ],
  "OR5AC2": [
    "OR5AC2 cnv"
  ],
  "OR5AK2": [
    "OR5AK2 cnv"
  ],
  "OR5AL1": [
    "OR5AL1 cnv"
  ],
  "OR5AN1": [
    "OR5AN1 cnv"
  ],
  "OR5AP2": [
    "OR5AP2 cnv"
  ],
  "OR5AR1": [
    "OR5AR1 cnv"
  ],
  "OR5AS1": [
    "OR5AS1 cnv"
  ],
  "OR5AU1": [
    "OR5AU1 cnv",
    "OR5AU1 rna"
  ],
  "OR5B12": [
    "OR5B12 cnv",
    "OR5B12 rna"
  ],
  "OR5B17": [
    "OR5B17 cnv"
  ],
  "OR5B2": [
    "OR5B2 cnv",
    "OR5B2 rna"
  ],
  "OR5B21": [
    "OR5B21 cnv",
    "OR5B21 rna"
  ],
  "OR5B3": [
    "OR5B3 cnv"
  ],
  "OR5BS1P": [
    "OR5BS1P cnv"
  ],
  "OR5C1": [
    "OR5C1 cnv",
    "OR5C1 rna"
  ],
  "OR5D13": [
    "OR5D13 cnv"
  ],
  "OR5D14": [
    "OR5D14 cnv"
  ],
  "OR5D16": [
    "OR5D16 cnv"
  ],
  "OR5D18": [
    "OR5D18 cnv"
  ],
  "OR5D3P": [
    "OR5D3P cnv"
  ],
  "OR5F1": [
    "OR5F1 cnv"
  ],
  "OR5G3": [
    "OR5G3 cnv",
    "OR5G3 rna"
  ],
  "OR5H1": [
    "OR5H1 cnv"
  ],
  "OR5H14": [
    "OR5H14 cnv"
  ],
  "OR5H15": [
    "OR5H15 cnv"
  ],
  "OR5H2": [
    "OR5H2 cnv"
  ],
  "OR5H6": [
    "OR5H6 cnv"
  ],
  "OR5H8": [
    "OR5H8 cnv"
  ],
  "OR5I1": [
    "OR5I1 cnv"
  ],
  "OR5J2": [
    "OR5J2 cnv"
  ],
  "OR5K1": [
    "OR5K1 cnv"
  ],
  "OR5K2": [
    "OR5K2 cnv",
    "OR5K2 rna"
  ],
  "OR5K3": [
    "OR5K3 cnv"
  ],
  "OR5K4": [
    "OR5K4 cnv"
  ],
  "OR5L1": [
    "OR5L1 cnv"
  ],
  "OR5L2": [
    "OR5L2 cnv"
  ],
  "OR5M1": [
    "OR5M1 cnv"
  ],
  "OR5M10": [
    "OR5M10 cnv"
  ],
  "OR5M11": [
    "OR5M11 cnv"
  ],
  "OR5M3": [
    "OR5M3 cnv"
  ],
  "OR5M8": [
    "OR5M8 cnv"
  ],
  "OR5M9": [
    "OR5M9 cnv"
  ],
  "OR5P2": [
    "OR5P2 cnv"
  ],
  "OR5P3": [
    "OR5P3 cnv"
  ],
  "OR5T1": [
    "OR5T1 cnv"
  ],
  "OR5T2": [
    "OR5T2 cnv"
  ],
  "OR5T3": [
    "OR5T3 cnv"
  ],
  "OR5V1": [
    "OR5V1 cnv"
  ],
  "OR5W2": [
    "OR5W2 cnv"
  ],
  "OR6A2": [
    "OR6A2 cnv",
    "OR6A2 rna"
  ],
  "OR6B1": [
    "OR6B1 cnv"
  ],
  "OR6B2": [
    "OR6B2 cnv",
    "OR6B2 rna"
  ],
  "OR6B3": [
    "OR6B3 cnv",
    "OR6B3 rna"
  ],
  "OR6C1": [
    "OR6C1 cnv"
  ],
  "OR6C2": [
    "OR6C2 cnv"
  ],
  "OR6C3": [
    "OR6C3 cnv"
  ],
  "OR6C4": [
    "OR6C4 cnv"
  ],
  "OR6C6": [
    "OR6C6 cnv"
  ],
  "OR6C65": [
    "OR6C65 cnv"
  ],
  "OR6C68": [
    "OR6C68 cnv"
  ],
  "OR6C70": [
    "OR6C70 cnv"
  ],
  "OR6C74": [
    "OR6C74 cnv"
  ],
  "OR6C75": [
    "OR6C75 cnv"
  ],
  "OR6C76": [
    "OR6C76 cnv"
  ],
  "OR6F1": [
    "OR6F1 cnv"
  ],
  "OR6J1": [
    "OR6J1 cnv",
    "OR6J1 rna"
  ],
  "OR6K2": [
    "OR6K2 cnv"
  ],
  "OR6K3": [
    "OR6K3 cnv"
  ],
  "OR6K6": [
    "OR6K6 cnv"
  ],
  "OR6M1": [
    "OR6M1 cnv"
  ],
  "OR6N1": [
    "OR6N1 cnv"
  ],
  "OR6N2": [
    "OR6N2 cnv"
  ],
  "OR6P1": [
    "OR6P1 cnv"
  ],
  "OR6Q1": [
    "OR6Q1 cnv"
  ],
  "OR6S1": [
    "OR6S1 cnv"
  ],
  "OR6T1": [
    "OR6T1 cnv"
  ],
  "OR6V1": [
    "OR6V1 cnv",
    "OR6V1 rna"
  ],
  "OR6X1": [
    "OR6X1 cnv"
  ],
  "OR6Y1": [
    "OR6Y1 cnv"
  ],
  "OR7A10": [
    "OR7A10 cnv"
  ],
  "OR7A17": [
    "OR7A17 cnv"
  ],
  "OR7A5": [
    "OR7A5 cnv",
    "OR7A5 rna"
  ],
  "OR7C1": [
    "OR7C1 cnv",
    "OR7C1 rna"
  ],
  "OR7C2": [
    "OR7C2 cnv"
  ],
  "OR7D2": [
    "OR7D2 cnv",
    "OR7D2 rna"
  ],
  "OR7D4": [
    "OR7D4 cnv"
  ],
  "OR7E104P": [
    "OR7E104P methyl"
  ],
  "OR7E24": [
    "OR7E24 cnv"
  ],
  "OR7G1": [
    "OR7G1 cnv"
  ],
  "OR7G2": [
    "OR7G2 cnv"
  ],
  "OR7G3": [
    "OR7G3 cnv"
  ],
  "OR8A1": [
    "OR8A1 cnv"
  ],
  "OR8B12": [
    "OR8B12 cnv"
  ],
  "OR8B2": [
    "OR8B2 cnv"
  ],
  "OR8B3": [
    "OR8B3 cnv"
  ],
  "OR8B4": [
    "OR8B4 cnv"
  ],
  "OR8B8": [
    "OR8B8 cnv"
  ],
  "OR8D1": [
    "OR8D1 cnv"
  ],
  "OR8D2": [
    "OR8D2 cnv"
  ],
  "OR8D4": [
    "OR8D4 cnv",
    "OR8D4 rna"
  ],
  "OR8G1": [
    "OR8G1 cnv"
  ],
  "OR8G5": [
    "OR8G5 cnv"
  ],
  "OR8H1": [
    "OR8H1 cnv"
  ],
  "OR8H2": [
    "OR8H2 cnv"
  ],
  "OR8H3": [
    "OR8H3 cnv"
  ],
  "OR8I2": [
    "OR8I2 cnv"
  ],
  "OR8J1": [
    "OR8J1 cnv"
  ],
  "OR8J2": [
    "OR8J2 cnv"
  ],
  "OR8J3": [
    "OR8J3 cnv"
  ],
  "OR8K1": [
    "OR8K1 cnv"
  ],
  "OR8K3": [
    "OR8K3 cnv"
  ],
  "OR8K5": [
    "OR8K5 cnv"
  ],
  "OR8S1": [
    "OR8S1 cnv",
    "OR8S1 rna"
  ],
  "OR8U1": [
    "OR8U1 cnv"
  ],
  "OR8U3": [
    "OR8U3 cnv"
  ],
  "OR9A2": [
    "OR9A2 cnv",
    "OR9A2 rna"
  ],
  "OR9A4": [
    "OR9A4 cnv",
    "OR9A4 rna"
  ],
  "OR9G1": [
    "OR9G1 cnv"
  ],
  "OR9G4": [
    "OR9G4 cnv"
  ],
  "OR9I1": [
    "OR9I1 cnv"
  ],
  "OR9K2": [
    "OR9K2 cnv"
  ],
  "OR9Q1": [
    "OR9Q1 cnv",
    "OR9Q1 rna"
  ],
  "OR9Q2": [
    "OR9Q2 cnv"
  ],
  "ORAI1": [
    "ORAI1 cnv",
    "ORAI1 methyl",
    "ORAI1 proteo",
    "ORAI1 rna"
  ],
  "ORAI2": [
    "ORAI2 cnv",
    "ORAI2 methyl",
    "ORAI2 proteo",
    "ORAI2 rna"
  ],
  "ORAI3": [
    "ORAI3 cnv",
    "ORAI3 methyl",
    "ORAI3 rna"
  ],
  "ORC1": [
    "ORC1 cnv",
    "ORC1 methyl",
    "ORC1 rna"
  ],
  "ORC2": [
    "ORC2 219_228_1_1_T226 phospho",
    "ORC2 cnv",
    "ORC2 methyl",
    "ORC2 proteo",
    "ORC2 rna"
  ],
  "ORC3": [
    "ORC3 cnv",
    "ORC3 methyl",
    "ORC3 proteo",
    "ORC3 rna"
  ],
  "ORC4": [
    "ORC4 cnv",
    "ORC4 methyl",
    "ORC4 proteo",
    "ORC4 rna"
  ],
  "ORC5": [
    "ORC5 cnv",
    "ORC5 rna"
  ],
  "ORC6": [
    "ORC6 cnv",
    "ORC6 methyl",
    "ORC6 rna"
  ],
  "ORM1": [
    "ORM1 QDQCIYNTTYLNVQR-N4H5F0S2G0 glyco",
    "ORM1 QDQCIYNTTYLNVQR-N4H5F3S3G0 glyco",
    "ORM1 QDQCIYNTTYLNVQR-N5H6F0S2G0 glyco",
    "ORM1 QDQCIYNTTYLNVQR-N5H6F0S3G0 glyco",
    "ORM1 QDQCIYNTTYLNVQR-N5H6F1S2G0 glyco",
    "ORM1 QDQCIYNTTYLNVQR-N5H6F1S3G0 glyco",
    "ORM1 QDQCIYNTTYLNVQR-N5H6F2S1G0 glyco",
    "ORM1 QDQCIYNTTYLNVQR-N6H7F0S2G0 glyco",
    "ORM1 QDQCIYNTTYLNVQR-N6H7F0S3G0 glyco",
    "ORM1 QDQCIYNTTYLNVQR-N6H7F1S2G0 glyco",
    "ORM1 cnv",
    "ORM1 proteo",
    "ORM1 rna"
  ],
  "ORM2": [
    "ORM2 QNQCFYNSSYLNVQR-N5H6F0S2G0 glyco",
    "ORM2 SVQEIQATFFYFTPNK-N4H5F0S1G0 glyco",
    "ORM2 SVQEIQATFFYFTPNK-N4H5F0S2G0 glyco",
    "ORM2 SVQEIQATFFYFTPNK-N5H6F0S2G0 glyco",
    "ORM2 SVQEIQATFFYFTPNK-N5H6F0S3G0 glyco",
    "ORM2 SVQEIQATFFYFTPNK-N6H7F0S3G0 glyco",
    "ORM2 cnv",
    "ORM2 proteo",
    "ORM2 rna"
  ],
  "ORMDL1": [
    "ORMDL1 cnv",
    "ORMDL1 methyl",
    "ORMDL1 rna"
  ],
  "ORMDL2": [
    "ORMDL2 cnv",
    "ORMDL2 methyl",
    "ORMDL2 rna"
  ],
  "ORMDL3": [
    "ORMDL3 cnv",
    "ORMDL3 methyl",
    "ORMDL3 rna"
  ],
  "OS9": [
    "OS9 494_494_1_1_S494 phospho",
    "OS9 RYHSQTYGNGSK-N2H6F0S0G0 glyco",
    "OS9 RYHSQTYGNGSK-N2H7F0S0G0 glyco",
    "OS9 YHSQTYGNGSK-N2H6F0S0G0 glyco",
    "OS9 YHSQTYGNGSK-N2H7F0S0G0 glyco",
    "OS9 YHSQTYGNGSK-N2H8F0S0G0 glyco",
    "OS9 YHSQTYGNGSK-N2H9F0S0G0 glyco",
    "OS9 cnv",
    "OS9 methyl",
    "OS9 proteo",
    "OS9 rna"
  ],
  "OSBP": [
    "OSBP 190_202_2_2_S190S193 phospho",
    "OSBP 190_210_1_1_S193 phospho",
    "OSBP 190_210_2_2_S190S193 phospho",
    "OSBP 238_251_1_1_S240 phospho",
    "OSBP 345_367_1_1_S351 phospho",
    "OSBP 351_367_1_1_S351 phospho",
    "OSBP 377_394_1_1_S382 phospho",
    "OSBP 377_394_2_2_S379S382 phospho",
    "OSBP cnv",
    "OSBP methyl",
    "OSBP proteo",
    "OSBP rna"
  ],
  "OSBP2": [
    "OSBP2 117_130_2_2_S119S122 phospho",
    "OSBP2 117_140_2_2_S119S122 phospho",
    "OSBP2 596_603_1_1_S596 phospho",
    "OSBP2 596_603_1_1_S597 phospho",
    "OSBP2 596_603_1_1_S600 phospho",
    "OSBP2 cnv",
    "OSBP2 methyl",
    "OSBP2 proteo",
    "OSBP2 rna"
  ],
  "OSBPL10": [
    "OSBPL10 324_327_1_1_S326 phospho",
    "OSBPL10 cnv",
    "OSBPL10 methyl",
    "OSBPL10 proteo",
    "OSBPL10 rna"
  ],
  "OSBPL11": [
    "OSBPL11 172_184_1_1_S174 phospho",
    "OSBPL11 189_201_1_1_S189 phospho",
    "OSBPL11 cnv",
    "OSBPL11 methyl",
    "OSBPL11 proteo",
    "OSBPL11 rna"
  ],
  "OSBPL1A": [
    "OSBPL1A 499_509_1_1_S499 phospho",
    "OSBPL1A cnv",
    "OSBPL1A methyl",
    "OSBPL1A proteo",
    "OSBPL1A rna"
  ],
  "OSBPL2": [
    "OSBPL2 cnv",
    "OSBPL2 methyl",
    "OSBPL2 proteo",
    "OSBPL2 rna"
  ],
  "OSBPL3": [
    "OSBPL3 249_251_1_1_S251 phospho",
    "OSBPL3 249_265_1_1_S251 phospho",
    "OSBPL3 249_265_2_2_S251S265 phospho",
    "OSBPL3 303_310_1_1_S304 phospho",
    "OSBPL3 370_374_1_1_S372 phospho",
    "OSBPL3 405_410_1_1_S410 phospho",
    "OSBPL3 437_440_1_1_S437 phospho",
    "OSBPL3 cnv",
    "OSBPL3 methyl",
    "OSBPL3 proteo",
    "OSBPL3 rna"
  ],
  "OSBPL5": [
    "OSBPL5 cnv",
    "OSBPL5 methyl",
    "OSBPL5 proteo",
    "OSBPL5 rna"
  ],
  "OSBPL6": [
    "OSBPL6 288_306_1_1_S290 phospho",
    "OSBPL6 312_341_1_1_S313 phospho",
    "OSBPL6 9_9_1_1_S9 phospho",
    "OSBPL6 cnv",
    "OSBPL6 methyl",
    "OSBPL6 proteo",
    "OSBPL6 rna"
  ],
  "OSBPL7": [
    "OSBPL7 272_277_1_1_S272 phospho",
    "OSBPL7 cnv",
    "OSBPL7 proteo",
    "OSBPL7 rna"
  ],
  "OSBPL8": [
    "OSBPL8 21_29_1_1_S26 phospho",
    "OSBPL8 300_300_1_1_S300 phospho",
    "OSBPL8 755_777_1_1_S765 phospho",
    "OSBPL8 755_777_2_2_S765S766 phospho",
    "OSBPL8 755_777_3_3_S765S766S768 phospho",
    "OSBPL8 cnv",
    "OSBPL8 methyl",
    "OSBPL8 proteo",
    "OSBPL8 rna"
  ],
  "OSBPL9": [
    "OSBPL9 314_329_1_1_S326 phospho",
    "OSBPL9 cnv",
    "OSBPL9 methyl",
    "OSBPL9 proteo",
    "OSBPL9 rna"
  ],
  "OSCAR": [
    "OSCAR cnv",
    "OSCAR methyl",
    "OSCAR rna"
  ],
  "OSCP1": [
    "OSCP1 cnv",
    "OSCP1 methyl",
    "OSCP1 proteo",
    "OSCP1 rna"
  ],
  "OSER1": [
    "OSER1 cnv",
    "OSER1 methyl",
    "OSER1 rna"
  ],
  "OSER1-DT": [
    "OSER1-DT methyl"
  ],
  "OSGEP": [
    "OSGEP cnv",
    "OSGEP methyl",
    "OSGEP proteo",
    "OSGEP rna"
  ],
  "OSGEPL1": [
    "OSGEPL1 ALEILTNATQCTLLCPPPR-N3H5F0S2G0 glyco",
    "OSGEPL1 cnv",
    "OSGEPL1 proteo",
    "OSGEPL1 rna"
  ],
  "OSGIN1": [
    "OSGIN1 cnv",
    "OSGIN1 rna"
  ],
  "OSGIN2": [
    "OSGIN2 cnv",
    "OSGIN2 methyl",
    "OSGIN2 rna"
  ],
  "OSM": [
    "OSM cnv",
    "OSM rna"
  ],
  "OSMR": [
    "OSMR cnv",
    "OSMR methyl",
    "OSMR proteo",
    "OSMR rna"
  ],
  "OSMR-DT": [
    "OSMR-DT methyl"
  ],
  "OSR1": [
    "OSR1 cnv",
    "OSR1 methyl",
    "OSR1 rna"
  ],
  "OSR2": [
    "OSR2 cnv",
    "OSR2 methyl",
    "OSR2 rna"
  ],
  "OST4": [
    "OST4 cnv",
    "OST4 methyl",
    "OST4 rna"
  ],
  "OSTC": [
    "OSTC cnv",
    "OSTC methyl",
    "OSTC proteo",
    "OSTC rna"
  ],
  "OSTF1": [
    "OSTF1 200_213_1_1_S213 phospho",
    "OSTF1 cnv",
    "OSTF1 methyl",
    "OSTF1 proteo",
    "OSTF1 rna"
  ],
  "OSTM1": [
    "OSTM1 322_333_1_1_S325 phospho",
    "OSTM1 322_333_2_0 phospho",
    "OSTM1 322_333_2_2_S322S325 phospho",
    "OSTM1 NYSEVCK-N2H8F0S0G0 glyco",
    "OSTM1 cnv",
    "OSTM1 methyl",
    "OSTM1 proteo",
    "OSTM1 rna"
  ],
  "OSTN": [
    "OSTN cnv",
    "OSTN rna"
  ],
  "OTC": [
    "OTC rna"
  ],
  "OTOA": [
    "OTOA cnv",
    "OTOA methyl",
    "OTOA rna"
  ],
  "OTOF": [
    "OTOF cnv",
    "OTOF rna"
  ],
  "OTOG": [
    "OTOG cnv",
    "OTOG rna"
  ],
  "OTOGL": [
    "OTOGL cnv",
    "OTOGL rna"
  ],
  "OTOL1": [
    "OTOL1 cnv",
    "OTOL1 rna"
  ],
  "OTOP1": [
    "OTOP1 cnv",
    "OTOP1 methyl",
    "OTOP1 rna"
  ],
  "OTOP2": [
    "OTOP2 cnv",
    "OTOP2 methyl",
    "OTOP2 rna"
  ],
  "OTOP3": [
    "OTOP3 cnv",
    "OTOP3 methyl"
  ],
  "OTOR": [
    "OTOR cnv",
    "OTOR rna"
  ],
  "OTOS": [
    "OTOS cnv",
    "OTOS rna"
  ],
  "OTP": [
    "OTP cnv",
    "OTP methyl",
    "OTP rna"
  ],
  "OTUB1": [
    "OTUB1 16_26_1_1_S16 phospho",
    "OTUB1 cnv",
    "OTUB1 methyl",
    "OTUB1 proteo",
    "OTUB1 rna"
  ],
  "OTUB2": [
    "OTUB2 cnv",
    "OTUB2 methyl",
    "OTUB2 rna"
  ],
  "OTUD1": [
    "OTUD1 cnv",
    "OTUD1 methyl",
    "OTUD1 rna"
  ],
  "OTUD3": [
    "OTUD3 cnv",
    "OTUD3 methyl",
    "OTUD3 rna"
  ],
  "OTUD4": [
    "OTUD4 cnv",
    "OTUD4 methyl",
    "OTUD4 proteo",
    "OTUD4 rna"
  ],
  "OTUD5": [
    "OTUD5 426_447_1_1_S447 phospho",
    "OTUD5 64_64_1_1_S64 phospho",
    "OTUD5 methyl",
    "OTUD5 proteo",
    "OTUD5 rna"
  ],
  "OTUD6B": [
    "OTUD6B cnv",
    "OTUD6B methyl",
    "OTUD6B proteo",
    "OTUD6B rna"
  ],
  "OTUD7A": [
    "OTUD7A 571_584_1_1_S571 phospho",
    "OTUD7A cnv",
    "OTUD7A methyl",
    "OTUD7A rna"
  ],
  "OTUD7B": [
    "OTUD7B 100_108_1_1_S105 phospho",
    "OTUD7B 460_478_2_2_S464S467 phospho",
    "OTUD7B 460_478_2_2_S467S471 phospho",
    "OTUD7B cnv",
    "OTUD7B methyl",
    "OTUD7B proteo",
    "OTUD7B rna"
  ],
  "OTULIN": [
    "OTULIN cnv",
    "OTULIN methyl",
    "OTULIN proteo",
    "OTULIN rna"
  ],
  "OTULIN-DT": [
    "OTULIN-DT methyl"
  ],
  "OTULINL": [
    "OTULINL cnv",
    "OTULINL methyl",
    "OTULINL proteo",
    "OTULINL rna"
  ],
  "OTX1": [
    "OTX1 cnv",
    "OTX1 methyl",
    "OTX1 rna"
  ],
  "OTX2": [
    "OTX2 cnv",
    "OTX2 methyl",
    "OTX2 rna"
  ],
  "OVCA2": [
    "OVCA2 cnv",
    "OVCA2 methyl",
    "OVCA2 proteo",
    "OVCA2 rna"
  ],
  "OVCH1": [
    "OVCH1 cnv",
    "OVCH1 rna"
  ],
  "OVCH2": [
    "OVCH2 cnv"
  ],
  "OVGP1": [
    "OVGP1 cnv",
    "OVGP1 rna"
  ],
  "OVOL1": [
    "OVOL1 cnv",
    "OVOL1 methyl",
    "OVOL1 rna"
  ],
  "OVOL2": [
    "OVOL2 cnv",
    "OVOL2 methyl",
    "OVOL2 rna"
  ],
  "OVOL3": [
    "OVOL3 cnv",
    "OVOL3 rna"
  ],
  "OXA1L": [
    "OXA1L cnv",
    "OXA1L methyl",
    "OXA1L proteo",
    "OXA1L rna"
  ],
  "OXCT1": [
    "OXCT1 cnv",
    "OXCT1 methyl",
    "OXCT1 proteo",
    "OXCT1 rna"
  ],
  "OXCT1-AS1": [
    "OXCT1-AS1 methyl"
  ],
  "OXCT2": [
    "OXCT2 cnv",
    "OXCT2 rna"
  ],
  "OXER1": [
    "OXER1 cnv",
    "OXER1 rna"
  ],
  "OXGR1": [
    "OXGR1 cnv",
    "OXGR1 methyl",
    "OXGR1 rna"
  ],
  "OXLD1": [
    "OXLD1 cnv",
    "OXLD1 methyl",
    "OXLD1 proteo",
    "OXLD1 rna"
  ],
  "OXNAD1": [
    "OXNAD1 cnv",
    "OXNAD1 methyl",
    "OXNAD1 proteo",
    "OXNAD1 rna"
  ],
  "OXR1": [
    "OXR1 14_16_1_1_S16 phospho",
    "OXR1 201_211_1_0 phospho",
    "OXR1 201_211_1_1_S204 phospho",
    "OXR1 386_391_1_1_T391 phospho",
    "OXR1 526_526_1_1_S526 phospho",
    "OXR1 91_91_1_1_S91 phospho",
    "OXR1 cnv",
    "OXR1 methyl",
    "OXR1 proteo",
    "OXR1 rna"
  ],
  "OXSM": [
    "OXSM cnv",
    "OXSM methyl",
    "OXSM proteo",
    "OXSM rna"
  ],
  "OXSR1": [
    "OXSR1 331_347_1_1_S339 phospho",
    "OXSR1 cnv",
    "OXSR1 kinase",
    "OXSR1 methyl",
    "OXSR1 proteo",
    "OXSR1 rna"
  ],
  "OXT": [
    "OXT cnv",
    "OXT methyl",
    "OXT rna"
  ],
  "OXTR": [
    "OXTR cnv",
    "OXTR methyl",
    "OXTR proteo",
    "OXTR rna"
  ],
  "P2RX1": [
    "P2RX1 cnv",
    "P2RX1 rna"
  ],
  "P2RX2": [
    "P2RX2 cnv",
    "P2RX2 methyl",
    "P2RX2 rna"
  ],
  "P2RX3": [
    "P2RX3 cnv",
    "P2RX3 rna"
  ],
  "P2RX4": [
    "P2RX4 AAENFTLLVK-N2H6F0S0G0 glyco",
    "P2RX4 AAENFTLLVK-N2H8F0S0G0 glyco",
    "P2RX4 CVAFNGSVK-N2H5F0S0G0 glyco",
    "P2RX4 cnv",
    "P2RX4 methyl",
    "P2RX4 proteo",
    "P2RX4 rna"
  ],
  "P2RX5": [
    "P2RX5 cnv",
    "P2RX5 methyl",
    "P2RX5 rna"
  ],
  "P2RX5-TAX1BP3": [
    "P2RX5-TAX1BP3 cnv",
    "P2RX5-TAX1BP3 rna"
  ],
  "P2RX6": [
    "P2RX6 cnv",
    "P2RX6 methyl",
    "P2RX6 rna"
  ],
  "P2RX7": [
    "P2RX7 NILPGLNITCTFHK-N2H6F0S0G0 glyco",
    "P2RX7 NILPGLNITCTFHK-N2H7F0S0G0 glyco",
    "P2RX7 NNIDFPGHNYTTR-N2H8F0S0G0 glyco",
    "P2RX7 TTNVSLYPGYNFR-N2H5F0S0G0 glyco",
    "P2RX7 TTNVSLYPGYNFR-N2H6F0S0G0 glyco",
    "P2RX7 TTNVSLYPGYNFR-N2H7F0S0G0 glyco",
    "P2RX7 cnv",
    "P2RX7 proteo",
    "P2RX7 rna"
  ],
  "P2RY1": [
    "P2RY1 346_352_1_1_S346 phospho",
    "P2RY1 cnv",
    "P2RY1 methyl",
    "P2RY1 proteo",
    "P2RY1 rna"
  ],
  "P2RY10": [
    "P2RY10 rna"
  ],
  "P2RY11": [
    "P2RY11 cnv",
    "P2RY11 rna"
  ],
  "P2RY12": [
    "P2RY12 318_323_1_1_S323 phospho",
    "P2RY12 340_340_1_1_T340 phospho",
    "P2RY12 cnv",
    "P2RY12 proteo",
    "P2RY12 rna"
  ],
  "P2RY13": [
    "P2RY13 cnv",
    "P2RY13 rna"
  ],
  "P2RY14": [
    "P2RY14 cnv",
    "P2RY14 rna"
  ],
  "P2RY2": [
    "P2RY2 cnv",
    "P2RY2 methyl",
    "P2RY2 rna"
  ],
  "P2RY4": [
    "P2RY4 rna"
  ],
  "P2RY6": [
    "P2RY6 cnv",
    "P2RY6 methyl",
    "P2RY6 rna"
  ],
  "P2RY8": [
    "P2RY8 rna"
  ],
  "P3H1": [
    "P3H1 LLNGSQR-N2H5F0S0G0 glyco",
    "P3H1 VPLQSAHLYYNVTEK-N2H5F0S0G0 glyco",
    "P3H1 VPLQSAHLYYNVTEK-N2H6F0S0G0 glyco",
    "P3H1 VPLQSAHLYYNVTEK-N2H7F0S0G0 glyco",
    "P3H1 VPLQSAHLYYNVTEK-N2H8F0S0G0 glyco",
    "P3H1 cnv",
    "P3H1 methyl",
    "P3H1 proteo",
    "P3H1 rna"
  ],
  "P3H2": [
    "P3H2 cnv",
    "P3H2 methyl",
    "P3H2 proteo",
    "P3H2 rna"
  ],
  "P3H3": [
    "P3H3 cnv",
    "P3H3 methyl",
    "P3H3 proteo",
    "P3H3 rna"
  ],
  "P3H4": [
    "P3H4 cnv",
    "P3H4 methyl",
    "P3H4 proteo",
    "P3H4 rna"
  ],
  "P3R3URF": [
    "P3R3URF cnv"
  ],
  "P3R3URF-PIK3R3": [
    "P3R3URF-PIK3R3 cnv",
    "P3R3URF-PIK3R3 rna"
  ],
  "P4HA1": [
    "P4HA1 DMSDGFISNLTIQR-N2H5F0S0G0 glyco",
    "P4HA1 DMSDGFISNLTIQR-N2H6F0S0G0 glyco",
    "P4HA1 DMSDGFISNLTIQR-N2H7F0S0G0 glyco",
    "P4HA1 DMSDGFISNLTIQR-N2H8F0S0G0 glyco",
    "P4HA1 DMSDGFISNLTIQR-N2H9F0S0G0 glyco",
    "P4HA1 cnv",
    "P4HA1 methyl",
    "P4HA1 proteo",
    "P4HA1 rna"
  ],
  "P4HA2": [
    "P4HA2 cnv",
    "P4HA2 methyl",
    "P4HA2 proteo",
    "P4HA2 rna"
  ],
  "P4HA3": [
    "P4HA3 cnv",
    "P4HA3 rna"
  ],
  "P4HB": [
    "P4HB cnv",
    "P4HB methyl",
    "P4HB proteo",
    "P4HB rna"
  ],
  "P4HTM": [
    "P4HTM LVANESVPFETSCR-N2H5F0S0G0 glyco",
    "P4HTM LVANESVPFETSCR-N2H6F0S0G0 glyco",
    "P4HTM cnv",
    "P4HTM methyl",
    "P4HTM proteo",
    "P4HTM rna"
  ],
  "PA2G4": [
    "PA2G4 377_386_1_1_S383 phospho",
    "PA2G4 cnv",
    "PA2G4 methyl",
    "PA2G4 proteo",
    "PA2G4 rna"
  ],
  "PAAF1": [
    "PAAF1 cnv",
    "PAAF1 methyl",
    "PAAF1 proteo",
    "PAAF1 rna"
  ],
  "PABIR1": [
    "PABIR1 185_191_1_1_S189 phospho",
    "PABIR1 185_191_2_2_S185S189 phospho",
    "PABIR1 229_239_1_1_S231 phospho",
    "PABIR1 304_328_1_0 phospho",
    "PABIR1 cnv",
    "PABIR1 methyl",
    "PABIR1 proteo",
    "PABIR1 rna"
  ],
  "PABIR2": [
    "PABIR2 112_121_1_1_S115 phospho",
    "PABIR2 112_121_1_1_S119 phospho",
    "PABIR2 112_121_2_2_S115S119 phospho",
    "PABIR2 130_141_1_1_S137 phospho",
    "PABIR2 23_43_1_1_S25 phospho",
    "PABIR2 50_55_1_1_S50 phospho",
    "PABIR2 58_58_1_1_S58 phospho",
    "PABIR2 methyl",
    "PABIR2 proteo",
    "PABIR2 rna"
  ],
  "PABIR3": [
    "PABIR3 methyl",
    "PABIR3 rna"
  ],
  "PABPC1": [
    "PABPC1 cnv",
    "PABPC1 methyl",
    "PABPC1 proteo",
    "PABPC1 rna"
  ],
  "PABPC1L": [
    "PABPC1L cnv",
    "PABPC1L methyl",
    "PABPC1L proteo",
    "PABPC1L rna"
  ],
  "PABPC1L2A": [
    "PABPC1L2A 181_198_1_1_T193 phospho",
    "PABPC1L2A rna"
  ],
  "PABPC1L2B": [
    "PABPC1L2B methyl",
    "PABPC1L2B rna"
  ],
  "PABPC1L2B-AS1": [
    "PABPC1L2B-AS1 methyl"
  ],
  "PABPC3": [
    "PABPC3 cnv",
    "PABPC3 methyl",
    "PABPC3 rna"
  ],
  "PABPC4": [
    "PABPC4 cnv",
    "PABPC4 methyl",
    "PABPC4 proteo",
    "PABPC4 rna"
  ],
  "PABPC4L": [
    "PABPC4L cnv",
    "PABPC4L rna"
  ],
  "PABPC5": [
    "PABPC5 methyl",
    "PABPC5 rna"
  ],
  "PABPC5-AS1": [
    "PABPC5-AS1 methyl"
  ],
  "PABPN1": [
    "PABPN1 cnv",
    "PABPN1 methyl",
    "PABPN1 proteo",
    "PABPN1 rna"
  ],
  "PABPN1L": [
    "PABPN1L cnv",
    "PABPN1L rna"
  ],
  "PACC1": [
    "PACC1 cnv",
    "PACC1 methyl",
    "PACC1 proteo",
    "PACC1 rna"
  ],
  "PACRG": [
    "PACRG cnv",
    "PACRG methyl",
    "PACRG rna"
  ],
  "PACRGL": [
    "PACRGL cnv",
    "PACRGL methyl",
    "PACRGL rna"
  ],
  "PACS1": [
    "PACS1 23_46_1_1_S28 phospho",
    "PACS1 23_46_1_1_T46 phospho",
    "PACS1 407_420_1_0 phospho",
    "PACS1 407_420_1_1_S411 phospho",
    "PACS1 407_420_1_1_T413 phospho",
    "PACS1 428_430_1_1_S430 phospho",
    "PACS1 488_497_1_1_S495 phospho",
    "PACS1 488_504_1_1_S495 phospho",
    "PACS1 760_789_1_1_S781 phospho",
    "PACS1 cnv",
    "PACS1 methyl",
    "PACS1 proteo",
    "PACS1 rna"
  ],
  "PACS2": [
    "PACS2 171_171_1_1_S171 phospho",
    "PACS2 247_265_1_1_S256 phospho",
    "PACS2 268_274_1_1_S274 phospho",
    "PACS2 291_297_1_1_S291 phospho",
    "PACS2 339_347_1_0 phospho",
    "PACS2 378_378_1_1_S378 phospho",
    "PACS2 588_594_1_1_S588 phospho",
    "PACS2 612_638_1_0 phospho",
    "PACS2 612_638_1_1_S619 phospho",
    "PACS2 cnv",
    "PACS2 methyl",
    "PACS2 proteo",
    "PACS2 rna"
  ],
  "PACSIN1": [
    "PACSIN1 179_184_1_1_T184 phospho",
    "PACSIN1 329_350_1_1_S346 phospho",
    "PACSIN1 356_385_1_0 phospho",
    "PACSIN1 356_385_1_1_S361 phospho",
    "PACSIN1 cnv",
    "PACSIN1 methyl",
    "PACSIN1 proteo",
    "PACSIN1 rna"
  ],
  "PACSIN2": [
    "PACSIN2 321_347_1_0 phospho",
    "PACSIN2 321_347_1_1_S342 phospho",
    "PACSIN2 321_347_2_0 phospho",
    "PACSIN2 cnv",
    "PACSIN2 methyl",
    "PACSIN2 proteo",
    "PACSIN2 rna"
  ],
  "PACSIN3": [
    "PACSIN3 319_331_1_1_S319 phospho",
    "PACSIN3 335_358_1_1_S354 phospho",
    "PACSIN3 cnv",
    "PACSIN3 methyl",
    "PACSIN3 proteo",
    "PACSIN3 rna"
  ],
  "PADI1": [
    "PADI1 cnv",
    "PADI1 rna"
  ],
  "PADI2": [
    "PADI2 cnv",
    "PADI2 methyl",
    "PADI2 proteo",
    "PADI2 rna"
  ],
  "PADI3": [
    "PADI3 cnv",
    "PADI3 rna"
  ],
  "PADI4": [
    "PADI4 cnv",
    "PADI4 proteo",
    "PADI4 rna"
  ],
  "PADI6": [
    "PADI6 cnv",
    "PADI6 rna"
  ],
  "PAEP": [
    "PAEP cnv",
    "PAEP rna"
  ],
  "PAF1": [
    "PAF1 394_394_1_1_S394 phospho",
    "PAF1 cnv",
    "PAF1 methyl",
    "PAF1 proteo",
    "PAF1 rna"
  ],
  "PAFAH1B1": [
    "PAFAH1B1 cnv",
    "PAFAH1B1 methyl",
    "PAFAH1B1 proteo",
    "PAFAH1B1 rna"
  ],
  "PAFAH1B2": [
    "PAFAH1B2 220_220_1_1_T220 phospho",
    "PAFAH1B2 64_78_1_1_S64 phospho",
    "PAFAH1B2 cnv",
    "PAFAH1B2 methyl",
    "PAFAH1B2 proteo",
    "PAFAH1B2 rna"
  ],
  "PAFAH1B3": [
    "PAFAH1B3 cnv",
    "PAFAH1B3 methyl",
    "PAFAH1B3 proteo",
    "PAFAH1B3 rna"
  ],
  "PAFAH2": [
    "PAFAH2 cnv",
    "PAFAH2 methyl",
    "PAFAH2 proteo",
    "PAFAH2 rna"
  ],
  "PAG1": [
    "PAG1 282_290_1_1_S288 phospho",
    "PAG1 351_361_1_1_S354 phospho",
    "PAG1 50_61_1_1_S50 phospho",
    "PAG1 50_61_1_1_S61 phospho",
    "PAG1 50_67_1_1_S61 phospho",
    "PAG1 cnv",
    "PAG1 methyl",
    "PAG1 proteo",
    "PAG1 rna"
  ],
  "PAGE2": [
    "PAGE2 rna"
  ],
  "PAGE2B": [
    "PAGE2B rna"
  ],
  "PAGE5": [
    "PAGE5 rna"
  ],
  "PAGR1": [
    "PAGR1 138_148_3_3_T138S143S148 phospho",
    "PAGR1 cnv",
    "PAGR1 methyl",
    "PAGR1 proteo",
    "PAGR1 rna"
  ],
  "PAH": [
    "PAH cnv",
    "PAH methyl",
    "PAH rna"
  ],
  "PAICS": [
    "PAICS 18_27_1_1_S27 phospho",
    "PAICS 22_27_1_1_S27 phospho",
    "PAICS 274_276_1_1_S274 phospho",
    "PAICS cnv",
    "PAICS methyl",
    "PAICS proteo",
    "PAICS rna"
  ],
  "PAIP1": [
    "PAIP1 cnv",
    "PAIP1 methyl",
    "PAIP1 proteo",
    "PAIP1 rna"
  ],
  "PAIP2": [
    "PAIP2 cnv",
    "PAIP2 methyl",
    "PAIP2 proteo",
    "PAIP2 rna"
  ],
  "PAIP2B": [
    "PAIP2B cnv",
    "PAIP2B methyl",
    "PAIP2B proteo",
    "PAIP2B rna"
  ],
  "PAK1": [
    "PAK1 142_146_1_1_S144 phospho",
    "PAK1 149_156_1_1_S155 phospho",
    "PAK1 165_197_1_1_S174 phospho",
    "PAK1 165_197_2_2_S174T185 phospho",
    "PAK1 204_214_1_1_T212 phospho",
    "PAK1 204_236_1_0 phospho",
    "PAK1 219_236_1_1_S220 phospho",
    "PAK1 219_236_1_1_T225 phospho",
    "PAK1 219_236_1_1_T230 phospho",
    "PAK1 219_236_2_1_S220 phospho",
    "PAK1 cnv",
    "PAK1 kinase",
    "PAK1 methyl",
    "PAK1 proteo",
    "PAK1 rna"
  ],
  "PAK1IP1": [
    "PAK1IP1 cnv",
    "PAK1IP1 methyl",
    "PAK1IP1 proteo",
    "PAK1IP1 rna"
  ],
  "PAK2": [
    "PAK2 139_143_1_1_S141 phospho",
    "PAK2 139_143_1_1_T143 phospho",
    "PAK2 139_154_1_0 phospho",
    "PAK2 139_154_1_1_S141 phospho",
    "PAK2 139_154_1_1_T143 phospho",
    "PAK2 152_154_1_1_S152 phospho",
    "PAK2 197_209_1_1_S197 phospho",
    "PAK2 19_42_1_0 phospho",
    "PAK2 cnv",
    "PAK2 kinase",
    "PAK2 methyl",
    "PAK2 proteo",
    "PAK2 rna"
  ],
  "PAK3": [
    "PAK3 160_198_1_1_S171 phospho",
    "PAK3 kinase",
    "PAK3 methyl",
    "PAK3 proteo",
    "PAK3 rna"
  ],
  "PAK4": [
    "PAK4 104_104_1_1_S104 phospho",
    "PAK4 142_148_1_1_S148 phospho",
    "PAK4 258_291_1_1_S291 phospho",
    "PAK4 474_488_1_1_S474 phospho",
    "PAK4 cnv",
    "PAK4 kinase",
    "PAK4 methyl",
    "PAK4 proteo",
    "PAK4 rna"
  ],
  "PAK5": [
    "PAK5 cnv",
    "PAK5 kinase",
    "PAK5 methyl",
    "PAK5 proteo",
    "PAK5 rna"
  ],
  "PAK6": [
    "PAK6 cnv",
    "PAK6 kinase",
    "PAK6 methyl",
    "PAK6 rna"
  ],
  "PAK6-AS1": [
    "PAK6-AS1 methyl"
  ],
  "PALB2": [
    "PALB2 cnv",
    "PALB2 methyl",
    "PALB2 rna"
  ],
  "PALD1": [
    "PALD1 406_413_1_1_S406 phospho",
    "PALD1 cnv",
    "PALD1 methyl",
    "PALD1 proteo",
    "PALD1 rna"
  ],
  "PALLD": [
    "PALLD 182_189_1_1_S182 phospho",
    "PALLD 36_57_1_1_S55 phospho",
    "PALLD 390_395_1_1_S393 phospho",
    "PALLD 393_395_1_1_S393 phospho",
    "PALLD 405_410_3_3_S405S407S410 phospho",
    "PALLD 407_410_1_1_S410 phospho",
    "PALLD 407_410_2_2_S407S410 phospho",
    "PALLD 448_468_1_1_S468 phospho",
    "PALLD 615_625_1_1_S622 phospho",
    "PALLD cnv",
    "PALLD methyl",
    "PALLD proteo",
    "PALLD rna"
  ],
  "PALM": [
    "PALM 116_124_1_1_S116 phospho",
    "PALM 116_124_1_1_S124 phospho",
    "PALM 116_124_2_2_S116S124 phospho",
    "PALM 124_124_1_1_S124 phospho",
    "PALM 132_145_1_1_T141 phospho",
    "PALM 132_145_1_1_T145 phospho",
    "PALM 158_162_1_1_S162 phospho",
    "PALM cnv",
    "PALM methyl",
    "PALM proteo",
    "PALM rna"
  ],
  "PALM2AKAP2": [
    "PALM2AKAP2 cnv",
    "PALM2AKAP2 methyl",
    "PALM2AKAP2 proteo",
    "PALM2AKAP2 rna"
  ],
  "PALM3": [
    "PALM3 375_375_1_1_S375 phospho",
    "PALM3 cnv",
    "PALM3 methyl",
    "PALM3 proteo",
    "PALM3 rna"
  ],
  "PALMD": [
    "PALMD 251_271_1_1_S253 phospho",
    "PALMD 486_494_1_1_S486 phospho",
    "PALMD cnv",
    "PALMD proteo",
    "PALMD rna"
  ],
  "PALS1": [
    "PALS1 cnv",
    "PALS1 methyl",
    "PALS1 proteo",
    "PALS1 rna"
  ],
  "PALS2": [
    "PALS2 104_117_1_0 phospho",
    "PALS2 104_117_1_1_S106 phospho",
    "PALS2 cnv",
    "PALS2 methyl",
    "PALS2 proteo",
    "PALS2 rna"
  ],
  "PAM": [
    "PAM cnv",
    "PAM methyl",
    "PAM proteo",
    "PAM rna"
  ],
  "PAM16": [
    "PAM16 cnv",
    "PAM16 methyl",
    "PAM16 rna"
  ],
  "PAMR1": [
    "PAMR1 cnv",
    "PAMR1 rna"
  ],
  "PAN2": [
    "PAN2 1188_1189_1_1_S1189 phospho",
    "PAN2 cnv",
    "PAN2 methyl",
    "PAN2 proteo",
    "PAN2 rna"
  ],
  "PAN3": [
    "PAN3 cnv",
    "PAN3 kinase",
    "PAN3 methyl",
    "PAN3 proteo",
    "PAN3 rna"
  ],
  "PANK1": [
    "PANK1 cnv",
    "PANK1 methyl",
    "PANK1 rna"
  ],
  "PANK2": [
    "PANK2 140_146_1_1_S140 phospho",
    "PANK2 168_182_1_1_S168 phospho",
    "PANK2 168_182_1_1_S169 phospho",
    "PANK2 168_182_2_2_S168S169 phospho",
    "PANK2 cnv",
    "PANK2 methyl",
    "PANK2 proteo",
    "PANK2 rna"
  ],
  "PANK3": [
    "PANK3 cnv",
    "PANK3 methyl",
    "PANK3 rna"
  ],
  "PANK4": [
    "PANK4 385_401_1_1_S401 phospho",
    "PANK4 71_75_1_1_S71 phospho",
    "PANK4 71_79_1_1_S71 phospho",
    "PANK4 cnv",
    "PANK4 methyl",
    "PANK4 proteo",
    "PANK4 rna"
  ],
  "PANO1": [
    "PANO1 cnv",
    "PANO1 rna"
  ],
  "PANTR1": [
    "PANTR1 methyl"
  ],
  "PANX1": [
    "PANX1 cnv",
    "PANX1 methyl",
    "PANX1 proteo",
    "PANX1 rna"
  ],
  "PANX2": [
    "PANX2 cnv",
    "PANX2 methyl",
    "PANX2 rna"
  ],
  "PANX3": [
    "PANX3 cnv",
    "PANX3 rna"
  ],
  "PAOX": [
    "PAOX cnv",
    "PAOX methyl",
    "PAOX rna"
  ],
  "PAPLN": [
    "PAPLN cnv",
    "PAPLN methyl",
    "PAPLN proteo",
    "PAPLN rna"
  ],
  "PAPOLA": [
    "PAPOLA 20_27_1_1_S24 phospho",
    "PAPOLA 544_553_1_1_S545 phospho",
    "PAPOLA 652_660_1_1_S654 phospho",
    "PAPOLA cnv",
    "PAPOLA methyl",
    "PAPOLA proteo",
    "PAPOLA rna"
  ],
  "PAPOLB": [
    "PAPOLB cnv",
    "PAPOLB methyl",
    "PAPOLB rna"
  ],
  "PAPOLG": [
    "PAPOLG 646_654_1_1_S648 phospho",
    "PAPOLG cnv",
    "PAPOLG methyl",
    "PAPOLG rna"
  ],
  "PAPPA": [
    "PAPPA cnv",
    "PAPPA rna"
  ],
  "PAPPA2": [
    "PAPPA2 cnv",
    "PAPPA2 proteo",
    "PAPPA2 rna"
  ],
  "PAPSS1": [
    "PAPSS1 cnv",
    "PAPSS1 methyl",
    "PAPSS1 proteo",
    "PAPSS1 rna"
  ],
  "PAPSS2": [
    "PAPSS2 cnv",
    "PAPSS2 methyl",
    "PAPSS2 proteo",
    "PAPSS2 rna"
  ],
  "PAQR3": [
    "PAQR3 cnv",
    "PAQR3 methyl",
    "PAQR3 rna"
  ],
  "PAQR4": [
    "PAQR4 cnv",
    "PAQR4 methyl",
    "PAQR4 proteo",
    "PAQR4 rna"
  ],
  "PAQR5": [
    "PAQR5 cnv",
    "PAQR5 methyl",
    "PAQR5 rna"
  ],
  "PAQR6": [
    "PAQR6 cnv",
    "PAQR6 methyl",
    "PAQR6 rna"
  ],
  "PAQR7": [
    "PAQR7 cnv",
    "PAQR7 methyl",
    "PAQR7 rna"
  ],
  "PAQR8": [
    "PAQR8 cnv",
    "PAQR8 methyl",
    "PAQR8 rna"
  ],
  "PAQR9": [
    "PAQR9 cnv",
    "PAQR9 methyl",
    "PAQR9 rna"
  ],
  "PAQR9-AS1": [
    "PAQR9-AS1 methyl"
  ],
  "PARD3": [
    "PARD3 1173_1175_1_1_S1175 phospho",
    "PARD3 143_166_1_0 phospho",
    "PARD3 143_166_1_1_S144 phospho",
    "PARD3 220_225_1_1_S221 phospho",
    "PARD3 377_388_1_1_S383 phospho",
    "PARD3 715_730_1_1_S715 phospho",
    "PARD3 715_730_1_1_S728 phospho",
    "PARD3 847_858_1_0 phospho",
    "PARD3 847_858_1_1_S849 phospho",
    "PARD3 849_858_1_1_S849 phospho",
    "PARD3 955_970_1_1_S959 phospho",
    "PARD3 cnv",
    "PARD3 methyl",
    "PARD3 proteo",
    "PARD3 rna"
  ],
  "PARD3B": [
    "PARD3B 363_375_1_0 phospho",
    "PARD3B 744_752_1_1_S746 phospho",
    "PARD3B cnv",
    "PARD3B methyl",
    "PARD3B proteo",
    "PARD3B rna"
  ],
  "PARD6A": [
    "PARD6A 100_109_1_1_S109 phospho",
    "PARD6A 264_283_1_1_S278 phospho",
    "PARD6A cnv",
    "PARD6A methyl",
    "PARD6A rna"
  ],
  "PARD6B": [
    "PARD6B 11_16_1_1_S11 phospho",
    "PARD6B cnv",
    "PARD6B methyl",
    "PARD6B proteo",
    "PARD6B rna"
  ],
  "PARD6G": [
    "PARD6G cnv",
    "PARD6G methyl",
    "PARD6G rna"
  ],
  "PARD6G-AS1": [
    "PARD6G-AS1 methyl"
  ],
  "PARG": [
    "PARG 216_227_1_1_S220 phospho",
    "PARG 48_57_1_1_S55 phospho",
    "PARG cnv",
    "PARG proteo",
    "PARG rna"
  ],
  "PARK7": [
    "PARK7 cnv",
    "PARK7 methyl",
    "PARK7 proteo",
    "PARK7 rna"
  ],
  "PARL": [
    "PARL cnv",
    "PARL methyl",
    "PARL proteo",
    "PARL rna"
  ],
  "PARM1": [
    "PARM1 cnv",
    "PARM1 methyl",
    "PARM1 proteo",
    "PARM1 rna"
  ],
  "PARN": [
    "PARN 558_564_1_1_S558 phospho",
    "PARN cnv",
    "PARN methyl",
    "PARN proteo",
    "PARN rna"
  ],
  "PARP1": [
    "PARP1 361_385_1_1_T368 phospho",
    "PARP1 361_391_1_1_T368 phospho",
    "PARP1 782_794_1_1_S782 phospho",
    "PARP1 cnv",
    "PARP1 methyl",
    "PARP1 proteo",
    "PARP1 rna"
  ],
  "PARP10": [
    "PARP10 cnv",
    "PARP10 methyl",
    "PARP10 proteo",
    "PARP10 rna"
  ],
  "PARP11": [
    "PARP11 cnv",
    "PARP11 methyl",
    "PARP11 rna"
  ],
  "PARP12": [
    "PARP12 258_278_1_1_S263 phospho",
    "PARP12 cnv",
    "PARP12 methyl",
    "PARP12 proteo",
    "PARP12 rna"
  ],
  "PARP14": [
    "PARP14 cnv",
    "PARP14 proteo",
    "PARP14 rna"
  ],
  "PARP15": [
    "PARP15 cnv",
    "PARP15 rna"
  ],
  "PARP16": [
    "PARP16 cnv",
    "PARP16 methyl",
    "PARP16 rna"
  ],
  "PARP2": [
    "PARP2 28_34_1_1_S34 phospho",
    "PARP2 cnv",
    "PARP2 rna"
  ],
  "PARP3": [
    "PARP3 cnv",
    "PARP3 methyl",
    "PARP3 rna"
  ],
  "PARP4": [
    "PARP4 1223_1236_1_1_S1236 phospho",
    "PARP4 1335_1344_1_1_S1335 phospho",
    "PARP4 1710_1713_1_1_S1713 phospho",
    "PARP4 92_101_1_1_T101 phospho",
    "PARP4 cnv",
    "PARP4 methyl",
    "PARP4 proteo",
    "PARP4 rna"
  ],
  "PARP6": [
    "PARP6 cnv",
    "PARP6 methyl",
    "PARP6 rna"
  ],
  "PARP8": [
    "PARP8 cnv",
    "PARP8 methyl",
    "PARP8 rna"
  ],
  "PARP9": [
    "PARP9 849_851_1_1_S851 phospho",
    "PARP9 cnv",
    "PARP9 methyl",
    "PARP9 proteo",
    "PARP9 rna"
  ],
  "PARPBP": [
    "PARPBP cnv",
    "PARPBP methyl",
    "PARPBP rna"
  ],
  "PARS2": [
    "PARS2 cnv",
    "PARS2 methyl",
    "PARS2 proteo",
    "PARS2 rna"
  ],
  "PARVA": [
    "PARVA 28_28_1_1_S28 phospho",
    "PARVA 8_16_1_1_S14 phospho",
    "PARVA cnv",
    "PARVA methyl",
    "PARVA proteo",
    "PARVA rna"
  ],
  "PARVB": [
    "PARVB 20_20_1_1_S20 phospho",
    "PARVB cnv",
    "PARVB methyl",
    "PARVB proteo",
    "PARVB rna"
  ],
  "PARVG": [
    "PARVG cnv",
    "PARVG proteo",
    "PARVG rna"
  ],
  "PASD1": [
    "PASD1 rna"
  ],
  "PASK": [
    "PASK cnv",
    "PASK kinase",
    "PASK methyl",
    "PASK proteo",
    "PASK rna"
  ],
  "PATE1": [
    "PATE1 cnv",
    "PATE1 rna"
  ],
  "PATE2": [
    "PATE2 cnv",
    "PATE2 rna"
  ],
  "PATE3": [
    "PATE3 cnv",
    "PATE3 rna"
  ],
  "PATE4": [
    "PATE4 cnv",
    "PATE4 rna"
  ],
  "PATJ": [
    "PATJ cnv",
    "PATJ methyl",
    "PATJ proteo",
    "PATJ rna"
  ],
  "PATL1": [
    "PATL1 177_184_1_1_S179 phospho",
    "PATL1 cnv",
    "PATL1 methyl",
    "PATL1 proteo",
    "PATL1 rna"
  ],
  "PATL2": [
    "PATL2 cnv",
    "PATL2 methyl",
    "PATL2 rna"
  ],
  "PATZ1": [
    "PATZ1 cnv",
    "PATZ1 methyl",
    "PATZ1 proteo",
    "PATZ1 rna"
  ],
  "PAUPAR": [
    "PAUPAR methyl"
  ],
  "PAWR": [
    "PAWR 228_239_1_1_S231 phospho",
    "PAWR cnv",
    "PAWR methyl",
    "PAWR proteo",
    "PAWR rna"
  ],
  "PAX1": [
    "PAX1 cnv",
    "PAX1 methyl",
    "PAX1 rna"
  ],
  "PAX2": [
    "PAX2 cnv",
    "PAX2 methyl",
    "PAX2 rna"
  ],
  "PAX3": [
    "PAX3 cnv",
    "PAX3 methyl",
    "PAX3 rna"
  ],
  "PAX4": [
    "PAX4 cnv",
    "PAX4 rna"
  ],
  "PAX5": [
    "PAX5 cnv",
    "PAX5 methyl",
    "PAX5 rna"
  ],
  "PAX6": [
    "PAX6 cnv",
    "PAX6 methyl",
    "PAX6 rna"
  ],
  "PAX7": [
    "PAX7 cnv",
    "PAX7 methyl",
    "PAX7 rna"
  ],
  "PAX8": [
    "PAX8 cnv",
    "PAX8 methyl",
    "PAX8 rna"
  ],
  "PAX8-AS1": [
    "PAX8-AS1 methyl"
  ],
  "PAX9": [
    "PAX9 cnv",
    "PAX9 methyl",
    "PAX9 rna"
  ],
  "PAXBP1": [
    "PAXBP1 262_262_1_1_S262 phospho",
    "PAXBP1 cnv",
    "PAXBP1 methyl",
    "PAXBP1 proteo",
    "PAXBP1 rna"
  ],
  "PAXBP1-AS1": [
    "PAXBP1-AS1 methyl"
  ],
  "PAXIP1": [
    "PAXIP1 cnv",
    "PAXIP1 methyl",
    "PAXIP1 proteo",
    "PAXIP1 rna"
  ],
  "PAXIP1-DT": [
    "PAXIP1-DT methyl"
  ],
  "PAXX": [
    "PAXX 152_152_1_1_S152 phospho",
    "PAXX cnv",
    "PAXX methyl",
    "PAXX proteo",
    "PAXX rna"
  ],
  "PBDC1": [
    "PBDC1 181_187_1_1_S181 phospho",
    "PBDC1 proteo",
    "PBDC1 rna"
  ],
  "PBK": [
    "PBK 57_59_1_1_S59 phospho",
    "PBK cnv",
    "PBK kinase",
    "PBK methyl",
    "PBK proteo",
    "PBK rna"
  ],
  "PBLD": [
    "PBLD cnv",
    "PBLD methyl",
    "PBLD proteo",
    "PBLD rna"
  ],
  "PBOV1": [
    "PBOV1 cnv",
    "PBOV1 rna"
  ],
  "PBRM1": [
    "PBRM1 60_77_1_1_S60 phospho",
    "PBRM1 cnv",
    "PBRM1 methyl",
    "PBRM1 proteo",
    "PBRM1 rna"
  ],
  "PBX1": [
    "PBX1 cnv",
    "PBX1 methyl",
    "PBX1 proteo",
    "PBX1 rna"
  ],
  "PBX2": [
    "PBX2 136_161_1_1_S151 phospho",
    "PBX2 320_330_1_1_S330 phospho",
    "PBX2 cnv",
    "PBX2 proteo",
    "PBX2 rna"
  ],
  "PBX3": [
    "PBX3 cnv",
    "PBX3 methyl",
    "PBX3 rna"
  ],
  "PBX4": [
    "PBX4 cnv",
    "PBX4 methyl",
    "PBX4 rna"
  ],
  "PBXIP1": [
    "PBXIP1 117_123_1_0 phospho",
    "PBXIP1 117_123_1_1_S119 phospho",
    "PBXIP1 14_16_1_1_S14 phospho",
    "PBXIP1 14_18_1_1_S14 phospho",
    "PBXIP1 516_522_1_1_S518 phospho",
    "PBXIP1 516_522_1_1_S522 phospho",
    "PBXIP1 LQGLENWGQDPGVSANASK-N2H5F0S0G0 glyco",
    "PBXIP1 LQGLENWGQDPGVSANASK-N2H6F0S0G0 glyco",
    "PBXIP1 LQGLENWGQDPGVSANASK-N2H7F0S0G0 glyco",
    "PBXIP1 LQGLENWGQDPGVSANASK-N2H8F0S0G0 glyco",
    "PBXIP1 cnv",
    "PBXIP1 proteo",
    "PBXIP1 rna"
  ],
  "PC": [
    "PC cnv",
    "PC methyl",
    "PC proteo",
    "PC rna"
  ],
  "PCARE": [
    "PCARE cnv",
    "PCARE rna"
  ],
  "PCAT6": [
    "PCAT6 methyl"
  ],
  "PCBD1": [
    "PCBD1 cnv",
    "PCBD1 methyl",
    "PCBD1 rna"
  ],
  "PCBD2": [
    "PCBD2 cnv",
    "PCBD2 methyl",
    "PCBD2 proteo",
    "PCBD2 rna"
  ],
  "PCBP1": [
    "PCBP1 169_173_1_1_S173 phospho",
    "PCBP1 180_190_1_0 phospho",
    "PCBP1 180_190_1_1_S189 phospho",
    "PCBP1 180_190_1_1_S190 phospho",
    "PCBP1 202_231_1_0 phospho",
    "PCBP1 246_264_1_0 phospho",
    "PCBP1 246_264_1_1_S264 phospho",
    "PCBP1 cnv",
    "PCBP1 methyl",
    "PCBP1 proteo",
    "PCBP1 rna"
  ],
  "PCBP1-AS1": [
    "PCBP1-AS1 methyl"
  ],
  "PCBP2": [
    "PCBP2 169_173_1_1_S173 phospho",
    "PCBP2 179_189_1_1_S188 phospho",
    "PCBP2 179_189_1_1_S189 phospho",
    "PCBP2 187_189_1_1_S189 phospho",
    "PCBP2 cnv",
    "PCBP2 methyl",
    "PCBP2 proteo",
    "PCBP2 rna"
  ],
  "PCBP3": [
    "PCBP3 cnv",
    "PCBP3 methyl",
    "PCBP3 proteo",
    "PCBP3 rna"
  ],
  "PCBP4": [
    "PCBP4 cnv",
    "PCBP4 methyl",
    "PCBP4 proteo",
    "PCBP4 rna"
  ],
  "PCCA": [
    "PCCA cnv",
    "PCCA methyl",
    "PCCA proteo",
    "PCCA rna"
  ],
  "PCCA-DT": [
    "PCCA-DT methyl"
  ],
  "PCCB": [
    "PCCB cnv",
    "PCCB methyl",
    "PCCB proteo",
    "PCCB rna"
  ],
  "PCDH1": [
    "PCDH1 1125_1142_1_0 phospho",
    "PCDH1 1125_1142_1_1_S1140 phospho",
    "PCDH1 1171_1173_1_1_S1171 phospho",
    "PCDH1 1171_1173_1_1_S1173 phospho",
    "PCDH1 1171_1173_2_2_S1171S1173 phospho",
    "PCDH1 943_949_1_1_S949 phospho",
    "PCDH1 958_962_1_1_S962 phospho",
    "PCDH1 971_988_1_1_S973 phospho",
    "PCDH1 971_988_1_1_S984 phospho",
    "PCDH1 971_988_2_2_S973S984 phospho",
    "PCDH1 cnv",
    "PCDH1 methyl",
    "PCDH1 proteo",
    "PCDH1 rna"
  ],
  "PCDH10": [
    "PCDH10 897_908_1_1_S897 phospho",
    "PCDH10 cnv",
    "PCDH10 methyl",
    "PCDH10 proteo",
    "PCDH10 rna"
  ],
  "PCDH11X": [
    "PCDH11X methyl",
    "PCDH11X rna"
  ],
  "PCDH11Y": [
    "PCDH11Y methyl",
    "PCDH11Y rna"
  ],
  "PCDH12": [
    "PCDH12 cnv",
    "PCDH12 rna"
  ],
  "PCDH15": [
    "PCDH15 cnv",
    "PCDH15 methyl",
    "PCDH15 rna"
  ],
  "PCDH17": [
    "PCDH17 1026_1040_1_1_S1038 phospho",
    "PCDH17 DGGSPPLNSTK-N2H5F0S0G0 glyco",
    "PCDH17 DSGAPAHLESNATVR-N5H3F1S0G0 glyco",
    "PCDH17 cnv",
    "PCDH17 methyl",
    "PCDH17 proteo",
    "PCDH17 rna"
  ],
  "PCDH18": [
    "PCDH18 cnv",
    "PCDH18 proteo",
    "PCDH18 rna"
  ],
  "PCDH19": [
    "PCDH19 methyl",
    "PCDH19 proteo",
    "PCDH19 rna"
  ],
  "PCDH20": [
    "PCDH20 cnv",
    "PCDH20 rna"
  ],
  "PCDH7": [
    "PCDH7 1151_1164_1_0 phospho",
    "PCDH7 972_976_1_1_S974 phospho",
    "PCDH7 998_1013_2_2_S1000S1011 phospho",
    "PCDH7 cnv",
    "PCDH7 methyl",
    "PCDH7 proteo",
    "PCDH7 rna"
  ],
  "PCDH8": [
    "PCDH8 cnv",
    "PCDH8 methyl",
    "PCDH8 rna"
  ],
  "PCDH9": [
    "PCDH9 926_932_1_1_S932 phospho",
    "PCDH9 941_957_1_1_S943 phospho",
    "PCDH9 941_957_1_1_T954 phospho",
    "PCDH9 IVASDSGKPSLNQTALVR-N2H5F0S0G0 glyco",
    "PCDH9 LFALNNTTGLITVQR-N2H5F0S0G0 glyco",
    "PCDH9 LFALNNTTGLITVQR-N5H3F1S0G0 glyco",
    "PCDH9 LVVNISDLGYPK-N2H5F0S0G0 glyco",
    "PCDH9 LVVNISDLGYPK-N2H6F0S0G0 glyco",
    "PCDH9 LVVNISDLGYPK-N2H7F0S0G0 glyco",
    "PCDH9 VTINVMDVNDNSPVVISPPSNTSFK-N2H5F0S0G0 glyco",
    "PCDH9 cnv",
    "PCDH9 methyl",
    "PCDH9 proteo",
    "PCDH9 rna"
  ],
  "PCDHA1": [
    "PCDHA1 cnv",
    "PCDHA1 rna"
  ],
  "PCDHA10": [
    "PCDHA10 cnv",
    "PCDHA10 methyl",
    "PCDHA10 rna"
  ],
  "PCDHA11": [
    "PCDHA11 cnv",
    "PCDHA11 methyl",
    "PCDHA11 rna"
  ],
  "PCDHA12": [
    "PCDHA12 cnv",
    "PCDHA12 rna"
  ],
  "PCDHA13": [
    "PCDHA13 cnv",
    "PCDHA13 rna"
  ],
  "PCDHA2": [
    "PCDHA2 cnv",
    "PCDHA2 rna"
  ],
  "PCDHA3": [
    "PCDHA3 cnv",
    "PCDHA3 rna"
  ],
  "PCDHA4": [
    "PCDHA4 cnv",
    "PCDHA4 rna"
  ],
  "PCDHA5": [
    "PCDHA5 cnv",
    "PCDHA5 rna"
  ],
  "PCDHA6": [
    "PCDHA6 cnv",
    "PCDHA6 rna"
  ],
  "PCDHA7": [
    "PCDHA7 cnv",
    "PCDHA7 rna"
  ],
  "PCDHA8": [
    "PCDHA8 cnv",
    "PCDHA8 rna"
  ],
  "PCDHA9": [
    "PCDHA9 cnv",
    "PCDHA9 rna"
  ],
  "PCDHAC1": [
    "PCDHAC1 cnv",
    "PCDHAC1 methyl",
    "PCDHAC1 rna"
  ],
  "PCDHAC2": [
    "PCDHAC2 cnv",
    "PCDHAC2 methyl",
    "PCDHAC2 proteo",
    "PCDHAC2 rna"
  ],
  "PCDHB1": [
    "PCDHB1 cnv",
    "PCDHB1 rna"
  ],
  "PCDHB10": [
    "PCDHB10 cnv",
    "PCDHB10 rna"
  ],
  "PCDHB11": [
    "PCDHB11 cnv",
    "PCDHB11 rna"
  ],
  "PCDHB12": [
    "PCDHB12 cnv",
    "PCDHB12 rna"
  ],
  "PCDHB13": [
    "PCDHB13 cnv",
    "PCDHB13 rna"
  ],
  "PCDHB14": [
    "PCDHB14 cnv",
    "PCDHB14 rna"
  ],
  "PCDHB15": [
    "PCDHB15 cnv",
    "PCDHB15 rna"
  ],
  "PCDHB16": [
    "PCDHB16 cnv",
    "PCDHB16 rna"
  ],
  "PCDHB2": [
    "PCDHB2 cnv",
    "PCDHB2 rna"
  ],
  "PCDHB3": [
    "PCDHB3 cnv",
    "PCDHB3 rna"
  ],
  "PCDHB4": [
    "PCDHB4 cnv",
    "PCDHB4 rna"
  ],
  "PCDHB5": [
    "PCDHB5 cnv",
    "PCDHB5 rna"
  ],
  "PCDHB6": [
    "PCDHB6 cnv",
    "PCDHB6 rna"
  ],
  "PCDHB7": [
    "PCDHB7 cnv",
    "PCDHB7 rna"
  ],
  "PCDHB8": [
    "PCDHB8 cnv",
    "PCDHB8 rna"
  ],
  "PCDHB9": [
    "PCDHB9 cnv",
    "PCDHB9 rna"
  ],
  "PCDHGA1": [
    "PCDHGA1 cnv",
    "PCDHGA1 rna"
  ],
  "PCDHGA10": [
    "PCDHGA10 cnv",
    "PCDHGA10 rna"
  ],
  "PCDHGA11": [
    "PCDHGA11 cnv",
    "PCDHGA11 methyl",
    "PCDHGA11 rna"
  ],
  "PCDHGA12": [
    "PCDHGA12 cnv",
    "PCDHGA12 rna"
  ],
  "PCDHGA2": [
    "PCDHGA2 cnv",
    "PCDHGA2 rna"
  ],
  "PCDHGA3": [
    "PCDHGA3 cnv",
    "PCDHGA3 methyl",
    "PCDHGA3 rna"
  ],
  "PCDHGA4": [
    "PCDHGA4 cnv",
    "PCDHGA4 rna"
  ],
  "PCDHGA5": [
    "PCDHGA5 cnv",
    "PCDHGA5 rna"
  ],
  "PCDHGA6": [
    "PCDHGA6 cnv",
    "PCDHGA6 rna"
  ],
  "PCDHGA7": [
    "PCDHGA7 cnv",
    "PCDHGA7 methyl",
    "PCDHGA7 rna"
  ],
  "PCDHGA8": [
    "PCDHGA8 cnv",
    "PCDHGA8 methyl",
    "PCDHGA8 rna"
  ],
  "PCDHGA9": [
    "PCDHGA9 cnv",
    "PCDHGA9 rna"
  ],
  "PCDHGB1": [
    "PCDHGB1 cnv",
    "PCDHGB1 rna"
  ],
  "PCDHGB2": [
    "PCDHGB2 cnv",
    "PCDHGB2 proteo",
    "PCDHGB2 rna"
  ],
  "PCDHGB3": [
    "PCDHGB3 cnv",
    "PCDHGB3 rna"
  ],
  "PCDHGB4": [
    "PCDHGB4 cnv",
    "PCDHGB4 methyl",
    "PCDHGB4 rna"
  ],
  "PCDHGB5": [
    "PCDHGB5 cnv",
    "PCDHGB5 methyl",
    "PCDHGB5 rna"
  ],
  "PCDHGB6": [
    "PCDHGB6 cnv",
    "PCDHGB6 methyl",
    "PCDHGB6 rna"
  ],
  "PCDHGB7": [
    "PCDHGB7 cnv",
    "PCDHGB7 methyl",
    "PCDHGB7 rna"
  ],
  "PCDHGC3": [
    "PCDHGC3 737_741_1_1_S741 phospho",
    "PCDHGC3 780_784_1_1_S780 phospho",
    "PCDHGC3 VLDANDNAPVFNQSLYR-N4H4F2S0G0 glyco",
    "PCDHGC3 VLDANDNAPVFNQSLYR-N4H5F1S1G0 glyco",
    "PCDHGC3 VLDANDNAPVFNQSLYR-N5H3F1S0G0 glyco",
    "PCDHGC3 cnv",
    "PCDHGC3 methyl",
    "PCDHGC3 proteo",
    "PCDHGC3 rna"
  ],
  "PCDHGC4": [
    "PCDHGC4 cnv",
    "PCDHGC4 methyl",
    "PCDHGC4 rna"
  ],
  "PCDHGC5": [
    "PCDHGC5 736_742_1_1_S736 phospho",
    "PCDHGC5 LNISDVNDNAPR-N2H5F0S0G0 glyco",
    "PCDHGC5 cnv",
    "PCDHGC5 rna"
  ],
  "PCED1A": [
    "PCED1A cnv",
    "PCED1A methyl",
    "PCED1A rna"
  ],
  "PCED1B": [
    "PCED1B cnv",
    "PCED1B methyl",
    "PCED1B rna"
  ],
  "PCF11": [
    "PCF11 487_494_1_1_S489 phospho",
    "PCF11 487_494_2_2_S489S494 phospho",
    "PCF11 509_515_1_1_S511 phospho",
    "PCF11 509_515_2_2_S509S511 phospho",
    "PCF11 cnv",
    "PCF11 methyl",
    "PCF11 proteo",
    "PCF11 rna"
  ],
  "PCGF1": [
    "PCGF1 cnv",
    "PCGF1 methyl",
    "PCGF1 rna"
  ],
  "PCGF2": [
    "PCGF2 cnv",
    "PCGF2 methyl",
    "PCGF2 rna"
  ],
  "PCGF3": [
    "PCGF3 cnv",
    "PCGF3 methyl",
    "PCGF3 rna"
  ],
  "PCGF3-AS1": [
    "PCGF3-AS1 methyl"
  ],
  "PCGF5": [
    "PCGF5 cnv",
    "PCGF5 methyl",
    "PCGF5 proteo",
    "PCGF5 rna"
  ],
  "PCGF6": [
    "PCGF6 115_115_1_1_S115 phospho",
    "PCGF6 cnv",
    "PCGF6 methyl",
    "PCGF6 rna"
  ],
  "PCID2": [
    "PCID2 cnv",
    "PCID2 methyl",
    "PCID2 proteo",
    "PCID2 rna"
  ],
  "PCIF1": [
    "PCIF1 135_152_1_0 phospho",
    "PCIF1 14_30_2_2_S19S30 phospho",
    "PCIF1 cnv",
    "PCIF1 methyl",
    "PCIF1 proteo",
    "PCIF1 rna"
  ],
  "PCK1": [
    "PCK1 cnv",
    "PCK1 rna"
  ],
  "PCK2": [
    "PCK2 136_136_1_1_S136 phospho",
    "PCK2 297_304_1_1_S304 phospho",
    "PCK2 cnv",
    "PCK2 methyl",
    "PCK2 proteo",
    "PCK2 rna"
  ],
  "PCLAF": [
    "PCLAF cnv",
    "PCLAF methyl",
    "PCLAF rna"
  ],
  "PCLO": [
    "PCLO 113_118_1_1_T115 phospho",
    "PCLO 1884_1900_1_1_S1894 phospho",
    "PCLO cnv",
    "PCLO methyl",
    "PCLO proteo",
    "PCLO rna"
  ],
  "PCM1": [
    "PCM1 1283_1290_1_1_S1283 phospho",
    "PCM1 157_168_1_1_S159 phospho",
    "PCM1 1950_1950_1_1_S1950 phospho",
    "PCM1 428_431_1_1_S431 phospho",
    "PCM1 61_69_1_1_S65 phospho",
    "PCM1 643_644_1_1_S644 phospho",
    "PCM1 859_866_1_1_S861 phospho",
    "PCM1 88_93_1_1_S93 phospho",
    "PCM1 cnv",
    "PCM1 methyl",
    "PCM1 proteo",
    "PCM1 rna"
  ],
  "PCMT1": [
    "PCMT1 cnv",
    "PCMT1 methyl",
    "PCMT1 proteo",
    "PCMT1 rna"
  ],
  "PCMTD1": [
    "PCMTD1 cnv",
    "PCMTD1 methyl",
    "PCMTD1 rna"
  ],
  "PCMTD2": [
    "PCMTD2 cnv",
    "PCMTD2 methyl",
    "PCMTD2 proteo",
    "PCMTD2 rna"
  ],
  "PCNA": [
    "PCNA cnv",
    "PCNA methyl",
    "PCNA proteo",
    "PCNA rna"
  ],
  "PCNP": [
    "PCNP 105_118_1_1_S118 phospho",
    "PCNP 92_100_1_1_S93 phospho",
    "PCNP cnv",
    "PCNP methyl",
    "PCNP proteo",
    "PCNP rna"
  ],
  "PCNT": [
    "PCNT 1653_1653_1_1_S1653 phospho",
    "PCNT 3274_3277_1_1_S3274 phospho",
    "PCNT cnv",
    "PCNT methyl",
    "PCNT proteo",
    "PCNT rna"
  ],
  "PCNX1": [
    "PCNX1 2040_2046_1_1_S2041 phospho",
    "PCNX1 cnv",
    "PCNX1 methyl",
    "PCNX1 rna"
  ],
  "PCNX2": [
    "PCNX2 cnv",
    "PCNX2 methyl",
    "PCNX2 rna"
  ],
  "PCNX3": [
    "PCNX3 1947_1955_1_1_S1955 phospho",
    "PCNX3 287_291_1_1_S287 phospho",
    "PCNX3 402_402_1_1_S402 phospho",
    "PCNX3 cnv",
    "PCNX3 methyl",
    "PCNX3 proteo",
    "PCNX3 rna"
  ],
  "PCNX4": [
    "PCNX4 cnv",
    "PCNX4 methyl",
    "PCNX4 rna"
  ],
  "PCOLCE": [
    "PCOLCE cnv",
    "PCOLCE methyl",
    "PCOLCE proteo",
    "PCOLCE rna"
  ],
  "PCOLCE-AS1": [
    "PCOLCE-AS1 methyl"
  ],
  "PCOLCE2": [
    "PCOLCE2 cnv",
    "PCOLCE2 methyl",
    "PCOLCE2 proteo",
    "PCOLCE2 rna"
  ],
  "PCOTH": [
    "PCOTH methyl"
  ],
  "PCP2": [
    "PCP2 cnv",
    "PCP2 rna"
  ],
  "PCP4": [
    "PCP4 cnv",
    "PCP4 proteo",
    "PCP4 rna"
  ],
  "PCP4L1": [
    "PCP4L1 8_12_1_1_S9 phospho",
    "PCP4L1 cnv",
    "PCP4L1 methyl",
    "PCP4L1 proteo",
    "PCP4L1 rna"
  ],
  "PCSK1": [
    "PCSK1 cnv",
    "PCSK1 methyl",
    "PCSK1 proteo",
    "PCSK1 rna"
  ],
  "PCSK1N": [
    "PCSK1N methyl",
    "PCSK1N proteo",
    "PCSK1N rna"
  ],
  "PCSK2": [
    "PCSK2 RGDLNINMTSPMGTK-N2H6F0S0G0 glyco",
    "PCSK2 YLEHVQAVITVNATR-N2H5F0S0G0 glyco",
    "PCSK2 cnv",
    "PCSK2 methyl",
    "PCSK2 proteo",
    "PCSK2 rna"
  ],
  "PCSK4": [
    "PCSK4 cnv",
    "PCSK4 methyl",
    "PCSK4 rna"
  ],
  "PCSK5": [
    "PCSK5 cnv",
    "PCSK5 methyl",
    "PCSK5 rna"
  ],
  "PCSK6": [
    "PCSK6 cnv",
    "PCSK6 methyl",
    "PCSK6 rna"
  ],
  "PCSK7": [
    "PCSK7 cnv",
    "PCSK7 methyl",
    "PCSK7 rna"
  ],
  "PCSK9": [
    "PCSK9 688_688_1_1_S688 phospho",
    "PCSK9 cnv",
    "PCSK9 methyl",
    "PCSK9 proteo",
    "PCSK9 rna"
  ],
  "PCTP": [
    "PCTP cnv",
    "PCTP methyl",
    "PCTP proteo",
    "PCTP rna"
  ],
  "PCYOX1": [
    "PCYOX1 GELNTSIFSSRPIDK-N2H5F0S0G0 glyco",
    "PCYOX1 GELNTSIFSSRPIDK-N2H6F0S0G0 glyco",
    "PCYOX1 GELNTSIFSSRPIDK-N2H7F0S0G0 glyco",
    "PCYOX1 GELNTSIFSSRPIDK-N2H8F0S0G0 glyco",
    "PCYOX1 LLHALGGDDFLGMLNR-N2H5F0S0G0 glyco",
    "PCYOX1 LLHALGGDDFLGMLNR-N2H6F0S0G0 glyco",
    "PCYOX1 LLHALGGDDFLGMLNR-N2H7F0S0G0 glyco",
    "PCYOX1 LLHALGGDDFLGMLNR-N2H8F0S0G0 glyco",
    "PCYOX1 cnv",
    "PCYOX1 methyl",
    "PCYOX1 proteo",
    "PCYOX1 rna"
  ],
  "PCYOX1L": [
    "PCYOX1L cnv",
    "PCYOX1L methyl",
    "PCYOX1L proteo",
    "PCYOX1L rna"
  ],
  "PCYT1A": [
    "PCYT1A 329_333_1_1_S329 phospho",
    "PCYT1A 342_352_1_1_S343 phospho",
    "PCYT1A 342_352_2_2_S343S347 phospho",
    "PCYT1A 359_362_1_1_S362 phospho",
    "PCYT1A cnv",
    "PCYT1A methyl",
    "PCYT1A proteo",
    "PCYT1A rna"
  ],
  "PCYT1B": [
    "PCYT1B proteo",
    "PCYT1B rna"
  ],
  "PCYT2": [
    "PCYT2 354_360_1_1_T360 phospho",
    "PCYT2 cnv",
    "PCYT2 methyl",
    "PCYT2 proteo",
    "PCYT2 rna"
  ],
  "PDAP1": [
    "PDAP1 17_19_1_1_S19 phospho",
    "PDAP1 57_70_1_0 phospho",
    "PDAP1 57_70_1_1_S60 phospho",
    "PDAP1 57_70_1_1_S63 phospho",
    "PDAP1 57_70_2_2_S60S63 phospho",
    "PDAP1 cnv",
    "PDAP1 methyl",
    "PDAP1 proteo",
    "PDAP1 rna"
  ],
  "PDC": [
    "PDC cnv",
    "PDC rna"
  ],
  "PDCD1": [
    "PDCD1 cnv",
    "PDCD1 methyl",
    "PDCD1 rna"
  ],
  "PDCD10": [
    "PDCD10 cnv",
    "PDCD10 methyl",
    "PDCD10 proteo",
    "PDCD10 rna"
  ],
  "PDCD11": [
    "PDCD11 cnv",
    "PDCD11 methyl",
    "PDCD11 proteo",
    "PDCD11 rna"
  ],
  "PDCD1LG2": [
    "PDCD1LG2 cnv",
    "PDCD1LG2 rna"
  ],
  "PDCD2": [
    "PDCD2 cnv",
    "PDCD2 methyl",
    "PDCD2 proteo",
    "PDCD2 rna"
  ],
  "PDCD2L": [
    "PDCD2L cnv",
    "PDCD2L methyl",
    "PDCD2L proteo",
    "PDCD2L rna"
  ],
  "PDCD4": [
    "PDCD4 299_309_1_1_S299 phospho",
    "PDCD4 57_68_1_1_S62 phospho",
    "PDCD4 73_80_1_0 phospho",
    "PDCD4 73_80_2_2_T76S80 phospho",
    "PDCD4 cnv",
    "PDCD4 methyl",
    "PDCD4 proteo",
    "PDCD4 rna"
  ],
  "PDCD5": [
    "PDCD5 119_125_1_0 phospho",
    "PDCD5 119_125_1_1_S119 phospho",
    "PDCD5 cnv",
    "PDCD5 methyl",
    "PDCD5 proteo",
    "PDCD5 rna"
  ],
  "PDCD6": [
    "PDCD6 cnv",
    "PDCD6 methyl",
    "PDCD6 proteo",
    "PDCD6 rna"
  ],
  "PDCD6-AHRR": [
    "PDCD6-AHRR cnv",
    "PDCD6-AHRR rna"
  ],
  "PDCD6IP": [
    "PDCD6IP cnv",
    "PDCD6IP methyl",
    "PDCD6IP proteo",
    "PDCD6IP rna"
  ],
  "PDCD7": [
    "PDCD7 cnv",
    "PDCD7 methyl",
    "PDCD7 proteo",
    "PDCD7 rna"
  ],
  "PDCL": [
    "PDCL 288_296_1_1_S296 phospho",
    "PDCL cnv",
    "PDCL proteo",
    "PDCL rna"
  ],
  "PDCL2": [
    "PDCL2 cnv",
    "PDCL2 rna"
  ],
  "PDCL3": [
    "PDCL3 cnv",
    "PDCL3 methyl",
    "PDCL3 proteo",
    "PDCL3 rna"
  ],
  "PDE10A": [
    "PDE10A cnv",
    "PDE10A methyl",
    "PDE10A proteo",
    "PDE10A rna"
  ],
  "PDE11A": [
    "PDE11A cnv",
    "PDE11A methyl",
    "PDE11A rna"
  ],
  "PDE12": [
    "PDE12 cnv",
    "PDE12 methyl",
    "PDE12 proteo",
    "PDE12 rna"
  ],
  "PDE1A": [
    "PDE1A cnv",
    "PDE1A proteo",
    "PDE1A rna"
  ],
  "PDE1B": [
    "PDE1B 466_480_1_1_S466 phospho",
    "PDE1B cnv",
    "PDE1B proteo",
    "PDE1B rna"
  ],
  "PDE1C": [
    "PDE1C 528_536_1_1_S529 phospho",
    "PDE1C cnv",
    "PDE1C methyl",
    "PDE1C proteo",
    "PDE1C rna"
  ],
  "PDE2A": [
    "PDE2A cnv",
    "PDE2A methyl",
    "PDE2A proteo",
    "PDE2A rna"
  ],
  "PDE3A": [
    "PDE3A 311_312_1_1_S312 phospho",
    "PDE3A 520_540_1_1_S520 phospho",
    "PDE3A cnv",
    "PDE3A methyl",
    "PDE3A proteo",
    "PDE3A rna"
  ],
  "PDE3B": [
    "PDE3B 441_454_1_1_S442 phospho",
    "PDE3B cnv",
    "PDE3B methyl",
    "PDE3B rna"
  ],
  "PDE4A": [
    "PDE4A 318_324_1_1_S320 phospho",
    "PDE4A cnv",
    "PDE4A methyl",
    "PDE4A proteo",
    "PDE4A rna"
  ],
  "PDE4B": [
    "PDE4B 182_191_1_1_S182 phospho",
    "PDE4B 275_277_1_1_S275 phospho",
    "PDE4B 291_294_1_1_S294 phospho",
    "PDE4B 302_311_1_1_S304 phospho",
    "PDE4B 49_54_2_2_S50S54 phospho",
    "PDE4B 703_721_1_1_S717 phospho",
    "PDE4B cnv",
    "PDE4B methyl",
    "PDE4B proteo",
    "PDE4B rna"
  ],
  "PDE4C": [
    "PDE4C cnv",
    "PDE4C methyl",
    "PDE4C rna"
  ],
  "PDE4D": [
    "PDE4D 348_350_1_1_S348 phospho",
    "PDE4D 373_380_1_1_S375 phospho",
    "PDE4D cnv",
    "PDE4D methyl",
    "PDE4D proteo",
    "PDE4D rna"
  ],
  "PDE4DIP": [
    "PDE4DIP 1483_1489_1_1_S1483 phospho",
    "PDE4DIP 275_275_1_1_S275 phospho",
    "PDE4DIP cnv",
    "PDE4DIP methyl",
    "PDE4DIP proteo",
    "PDE4DIP rna"
  ],
  "PDE5A": [
    "PDE5A cnv",
    "PDE5A methyl",
    "PDE5A proteo",
    "PDE5A rna"
  ],
  "PDE6A": [
    "PDE6A cnv",
    "PDE6A rna"
  ],
  "PDE6B": [
    "PDE6B cnv",
    "PDE6B methyl",
    "PDE6B rna"
  ],
  "PDE6B-AS1": [
    "PDE6B-AS1 methyl"
  ],
  "PDE6C": [
    "PDE6C cnv",
    "PDE6C rna"
  ],
  "PDE6D": [
    "PDE6D cnv",
    "PDE6D methyl",
    "PDE6D proteo",
    "PDE6D rna"
  ],
  "PDE6G": [
    "PDE6G cnv",
    "PDE6G rna"
  ],
  "PDE6H": [
    "PDE6H cnv",
    "PDE6H rna"
  ],
  "PDE7A": [
    "PDE7A 84_87_1_1_S84 phospho",
    "PDE7A cnv",
    "PDE7A methyl",
    "PDE7A rna"
  ],
  "PDE7B": [
    "PDE7B 45_46_1_1_S45 phospho",
    "PDE7B cnv",
    "PDE7B rna"
  ],
  "PDE8A": [
    "PDE8A 385_393_1_1_S385 phospho",
    "PDE8A cnv",
    "PDE8A methyl",
    "PDE8A rna"
  ],
  "PDE8B": [
    "PDE8B 351_354_1_1_S351 phospho",
    "PDE8B 397_407_1_1_S397 phospho",
    "PDE8B 462_469_1_1_S462 phospho",
    "PDE8B cnv",
    "PDE8B proteo",
    "PDE8B rna"
  ],
  "PDE9A": [
    "PDE9A cnv",
    "PDE9A methyl",
    "PDE9A rna"
  ],
  "PDF": [
    "PDF cnv",
    "PDF methyl",
    "PDF proteo",
    "PDF rna"
  ],
  "PDGFA": [
    "PDGFA cnv",
    "PDGFA methyl",
    "PDGFA rna"
  ],
  "PDGFA-DT": [
    "PDGFA-DT methyl"
  ],
  "PDGFB": [
    "PDGFB cnv",
    "PDGFB methyl",
    "PDGFB rna"
  ],
  "PDGFC": [
    "PDGFC cnv",
    "PDGFC methyl",
    "PDGFC rna"
  ],
  "PDGFD": [
    "PDGFD cnv",
    "PDGFD methyl",
    "PDGFD proteo",
    "PDGFD rna"
  ],
  "PDGFRA": [
    "PDGFRA 1066_1083_1_0 phospho",
    "PDGFRA cnv",
    "PDGFRA kinase",
    "PDGFRA methyl",
    "PDGFRA mut",
    "PDGFRA proteo",
    "PDGFRA rna"
  ],
  "PDGFRB": [
    "PDGFRB 635_641_1_1_S641 phospho",
    "PDGFRB cnv",
    "PDGFRB kinase",
    "PDGFRB proteo",
    "PDGFRB rna"
  ],
  "PDGFRL": [
    "PDGFRL cnv",
    "PDGFRL methyl",
    "PDGFRL rna"
  ],
  "PDHA1": [
    "PDHA1 methyl",
    "PDHA1 proteo",
    "PDHA1 rna"
  ],
  "PDHA2": [
    "PDHA2 cnv"
  ],
  "PDHB": [
    "PDHB cnv",
    "PDHB methyl",
    "PDHB proteo",
    "PDHB rna"
  ],
  "PDHX": [
    "PDHX cnv",
    "PDHX methyl",
    "PDHX proteo",
    "PDHX rna"
  ],
  "PDIA2": [
    "PDIA2 cnv",
    "PDIA2 methyl",
    "PDIA2 proteo",
    "PDIA2 rna"
  ],
  "PDIA3": [
    "PDIA3 cnv",
    "PDIA3 methyl",
    "PDIA3 proteo",
    "PDIA3 rna"
  ],
  "PDIA4": [
    "PDIA4 cnv",
    "PDIA4 methyl",
    "PDIA4 proteo",
    "PDIA4 rna"
  ],
  "PDIA5": [
    "PDIA5 cnv",
    "PDIA5 methyl",
    "PDIA5 proteo",
    "PDIA5 rna"
  ],
  "PDIA6": [
    "PDIA6 cnv",
    "PDIA6 methyl",
    "PDIA6 proteo",
    "PDIA6 rna"
  ],
  "PDIK1L": [
    "PDIK1L cnv",
    "PDIK1L kinase",
    "PDIK1L methyl",
    "PDIK1L rna"
  ],
  "PDILT": [
    "PDILT cnv"
  ],
  "PDK1": [
    "PDK1 cnv",
    "PDK1 kinase",
    "PDK1 methyl",
    "PDK1 proteo",
    "PDK1 rna"
  ],
  "PDK2": [
    "PDK2 cnv",
    "PDK2 kinase",
    "PDK2 methyl",
    "PDK2 proteo",
    "PDK2 rna"
  ],
  "PDK3": [
    "PDK3 kinase",
    "PDK3 methyl",
    "PDK3 proteo",
    "PDK3 rna"
  ],
  "PDK4": [
    "PDK4 cnv",
    "PDK4 kinase",
    "PDK4 methyl",
    "PDK4 rna"
  ],
  "PDLIM1": [
    "PDLIM1 123_136_1_1_S130 phospho",
    "PDLIM1 90_94_1_1_S90 phospho",
    "PDLIM1 cnv",
    "PDLIM1 methyl",
    "PDLIM1 proteo",
    "PDLIM1 rna"
  ],
  "PDLIM2": [
    "PDLIM2 384_402_1_1_S384 phospho",
    "PDLIM2 507_524_1_1_S516 phospho",
    "PDLIM2 529_535_1_1_T529 phospho",
    "PDLIM2 cnv",
    "PDLIM2 methyl",
    "PDLIM2 proteo",
    "PDLIM2 rna"
  ],
  "PDLIM3": [
    "PDLIM3 169_186_1_0 phospho",
    "PDLIM3 169_186_1_1_S170 phospho",
    "PDLIM3 85_93_1_1_S89 phospho",
    "PDLIM3 85_93_1_1_S93 phospho",
    "PDLIM3 cnv",
    "PDLIM3 methyl",
    "PDLIM3 proteo",
    "PDLIM3 rna"
  ],
  "PDLIM4": [
    "PDLIM4 120_137_1_1_S120 phospho",
    "PDLIM4 150_169_1_1_S165 phospho",
    "PDLIM4 cnv",
    "PDLIM4 proteo",
    "PDLIM4 rna"
  ],
  "PDLIM5": [
    "PDLIM5 110_115_1_1_S111 phospho",
    "PDLIM5 228_232_1_1_S228 phospho",
    "PDLIM5 309_323_1_1_S313 phospho",
    "PDLIM5 325_355_1_0 phospho",
    "PDLIM5 325_355_1_1_S332 phospho",
    "PDLIM5 593_593_1_1_S593 phospho",
    "PDLIM5 cnv",
    "PDLIM5 methyl",
    "PDLIM5 proteo",
    "PDLIM5 rna"
  ],
  "PDLIM7": [
    "PDLIM7 104_111_1_1_S111 phospho",
    "PDLIM7 cnv",
    "PDLIM7 methyl",
    "PDLIM7 proteo",
    "PDLIM7 rna"
  ],
  "PDP1": [
    "PDP1 cnv",
    "PDP1 methyl",
    "PDP1 proteo",
    "PDP1 rna"
  ],
  "PDP2": [
    "PDP2 cnv",
    "PDP2 methyl",
    "PDP2 proteo",
    "PDP2 rna"
  ],
  "PDPK1": [
    "PDPK1 cnv",
    "PDPK1 kinase",
    "PDPK1 methyl",
    "PDPK1 proteo",
    "PDPK1 rna"
  ],
  "PDPK2P": [
    "PDPK2P kinase"
  ],
  "PDPN": [
    "PDPN cnv",
    "PDPN methyl",
    "PDPN rna"
  ],
  "PDPR": [
    "PDPR cnv",
    "PDPR methyl",
    "PDPR proteo",
    "PDPR rna"
  ],
  "PDRG1": [
    "PDRG1 cnv",
    "PDRG1 methyl",
    "PDRG1 proteo",
    "PDRG1 rna"
  ],
  "PDS5A": [
    "PDS5A 1305_1305_1_1_S1305 phospho",
    "PDS5A cnv",
    "PDS5A methyl",
    "PDS5A proteo",
    "PDS5A rna"
  ],
  "PDS5B": [
    "PDS5B 1154_1166_1_1_S1166 phospho",
    "PDS5B 1220_1223_1_1_T1220 phospho",
    "PDS5B 1255_1259_1_0 phospho",
    "PDS5B 1283_1283_1_1_S1283 phospho",
    "PDS5B 1358_1370_1_1_S1358 phospho",
    "PDS5B 1381_1385_1_1_S1383 phospho",
    "PDS5B cnv",
    "PDS5B methyl",
    "PDS5B proteo",
    "PDS5B rna"
  ],
  "PDSS1": [
    "PDSS1 cnv",
    "PDSS1 methyl",
    "PDSS1 proteo",
    "PDSS1 rna"
  ],
  "PDSS2": [
    "PDSS2 cnv",
    "PDSS2 methyl",
    "PDSS2 proteo",
    "PDSS2 rna"
  ],
  "PDX1": [
    "PDX1 cnv",
    "PDX1 methyl",
    "PDX1 rna"
  ],
  "PDXDC1": [
    "PDXDC1 cnv",
    "PDXDC1 methyl",
    "PDXDC1 proteo",
    "PDXDC1 rna"
  ],
  "PDXDC2P-NPIPB14P": [
    "PDXDC2P-NPIPB14P methyl"
  ],
  "PDXK": [
    "PDXK cnv",
    "PDXK methyl",
    "PDXK proteo",
    "PDXK rna"
  ],
  "PDXP": [
    "PDXP cnv",
    "PDXP methyl",
    "PDXP proteo",
    "PDXP rna"
  ],
  "PDXP-DT": [
    "PDXP-DT methyl"
  ],
  "PDYN": [
    "PDYN cnv",
    "PDYN proteo",
    "PDYN rna"
  ],
  "PDYN-AS1": [
    "PDYN-AS1 methyl"
  ],
  "PDZD11": [
    "PDZD11 methyl",
    "PDZD11 proteo",
    "PDZD11 rna"
  ],
  "PDZD2": [
    "PDZD2 1005_1009_1_1_S1005 phospho",
    "PDZD2 1280_1291_1_1_S1280 phospho",
    "PDZD2 1480_1482_1_1_S1482 phospho",
    "PDZD2 2373_2381_1_0 phospho",
    "PDZD2 2396_2409_1_0 phospho",
    "PDZD2 2396_2409_1_1_S2398 phospho",
    "PDZD2 2521_2530_1_1_S2521 phospho",
    "PDZD2 543_557_1_1_S543 phospho",
    "PDZD2 920_926_1_1_S920 phospho",
    "PDZD2 cnv",
    "PDZD2 methyl",
    "PDZD2 proteo",
    "PDZD2 rna"
  ],
  "PDZD3": [
    "PDZD3 cnv",
    "PDZD3 rna"
  ],
  "PDZD4": [
    "PDZD4 485_496_1_1_S496 phospho",
    "PDZD4 methyl",
    "PDZD4 rna"
  ],
  "PDZD7": [
    "PDZD7 cnv",
    "PDZD7 methyl",
    "PDZD7 rna"
  ],
  "PDZD8": [
    "PDZD8 517_521_1_1_S521 phospho",
    "PDZD8 527_538_1_1_S538 phospho",
    "PDZD8 971_991_1_1_S975 phospho",
    "PDZD8 971_991_1_1_S980 phospho",
    "PDZD8 971_991_2_2_S975S980 phospho",
    "PDZD8 cnv",
    "PDZD8 methyl",
    "PDZD8 proteo",
    "PDZD8 rna"
  ],
  "PDZD9": [
    "PDZD9 cnv",
    "PDZD9 rna"
  ],
  "PDZK1": [
    "PDZK1 cnv",
    "PDZK1 rna"
  ],
  "PDZK1IP1": [
    "PDZK1IP1 cnv",
    "PDZK1IP1 rna"
  ],
  "PDZRN3": [
    "PDZRN3 464_476_1_1_S472 phospho",
    "PDZRN3 cnv",
    "PDZRN3 methyl",
    "PDZRN3 proteo",
    "PDZRN3 rna"
  ],
  "PDZRN4": [
    "PDZRN4 747_759_1_1_S755 phospho",
    "PDZRN4 cnv",
    "PDZRN4 rna"
  ],
  "PEA15": [
    "PEA15 111_125_1_1_S125 phospho",
    "PEA15 129_137_1_1_S137 phospho",
    "PEA15 cnv",
    "PEA15 methyl",
    "PEA15 proteo",
    "PEA15 rna"
  ],
  "PEAK1": [
    "PEAK1 1140_1151_1_1_T1151 phospho",
    "PEAK1 212_219_1_1_S214 phospho",
    "PEAK1 370_377_1_1_S370 phospho",
    "PEAK1 568_580_1_1_S572 phospho",
    "PEAK1 568_580_2_2_S568S572 phospho",
    "PEAK1 723_730_1_1_S730 phospho",
    "PEAK1 764_786_1_1_S779 phospho",
    "PEAK1 792_797_1_1_S792 phospho",
    "PEAK1 860_864_1_1_S861 phospho",
    "PEAK1 cnv",
    "PEAK1 kinase",
    "PEAK1 methyl",
    "PEAK1 proteo",
    "PEAK1 rna"
  ],
  "PEAK3": [
    "PEAK3 cnv",
    "PEAK3 rna"
  ],
  "PEAR1": [
    "PEAR1 cnv",
    "PEAR1 methyl",
    "PEAR1 proteo",
    "PEAR1 rna"
  ],
  "PEBP1": [
    "PEBP1 51_60_1_1_S52 phospho",
    "PEBP1 51_60_1_1_S54 phospho",
    "PEBP1 51_60_1_1_S60 phospho",
    "PEBP1 81_81_1_1_Y81 phospho",
    "PEBP1 98_109_1_0 phospho",
    "PEBP1 cnv",
    "PEBP1 methyl",
    "PEBP1 proteo",
    "PEBP1 rna"
  ],
  "PEBP4": [
    "PEBP4 cnv",
    "PEBP4 methyl",
    "PEBP4 rna"
  ],
  "PECAM1": [
    "PECAM1 731_738_1_1_S734 phospho",
    "PECAM1 cnv",
    "PECAM1 proteo",
    "PECAM1 rna"
  ],
  "PECR": [
    "PECR cnv",
    "PECR methyl",
    "PECR proteo",
    "PECR rna"
  ],
  "PEDS1": [
    "PEDS1 cnv",
    "PEDS1 methyl",
    "PEDS1 rna"
  ],
  "PEDS1-UBE2V1": [
    "PEDS1-UBE2V1 cnv",
    "PEDS1-UBE2V1 methyl",
    "PEDS1-UBE2V1 rna"
  ],
  "PEF1": [
    "PEF1 cnv",
    "PEF1 methyl",
    "PEF1 proteo",
    "PEF1 rna"
  ],
  "PEG10": [
    "PEG10 389_397_1_1_S392 phospho",
    "PEG10 cnv",
    "PEG10 methyl",
    "PEG10 proteo",
    "PEG10 rna"
  ],
  "PEG13": [
    "PEG13 methyl"
  ],
  "PEG3": [
    "PEG3 cnv",
    "PEG3 methyl",
    "PEG3 proteo",
    "PEG3 rna"
  ],
  "PELI1": [
    "PELI1 cnv",
    "PELI1 methyl",
    "PELI1 rna"
  ],
  "PELI2": [
    "PELI2 cnv",
    "PELI2 methyl",
    "PELI2 proteo",
    "PELI2 rna"
  ],
  "PELI3": [
    "PELI3 cnv",
    "PELI3 methyl",
    "PELI3 rna"
  ],
  "PELO": [
    "PELO 49_58_1_1_S55 phospho",
    "PELO cnv",
    "PELO methyl",
    "PELO proteo",
    "PELO rna"
  ],
  "PELP1": [
    "PELP1 784_805_1_0 phospho",
    "PELP1 784_805_1_1_T795 phospho",
    "PELP1 cnv",
    "PELP1 methyl",
    "PELP1 proteo",
    "PELP1 rna"
  ],
  "PELP1-DT": [
    "PELP1-DT methyl"
  ],
  "PEMT": [
    "PEMT cnv",
    "PEMT methyl",
    "PEMT proteo",
    "PEMT rna"
  ],
  "PENK": [
    "PENK 243_251_1_1_S251 phospho",
    "PENK cnv",
    "PENK methyl",
    "PENK rna"
  ],
  "PENK-AS1": [
    "PENK-AS1 methyl"
  ],
  "PEPD": [
    "PEPD cnv",
    "PEPD proteo",
    "PEPD rna"
  ],
  "PER1": [
    "PER1 830_830_1_1_S830 phospho",
    "PER1 cnv",
    "PER1 methyl",
    "PER1 proteo",
    "PER1 rna"
  ],
  "PER2": [
    "PER2 cnv",
    "PER2 methyl",
    "PER2 rna"
  ],
  "PER3": [
    "PER3 cnv",
    "PER3 methyl",
    "PER3 rna"
  ],
  "PERCC1": [
    "PERCC1 cnv",
    "PERCC1 methyl",
    "PERCC1 rna"
  ],
  "PERM1": [
    "PERM1 cnv",
    "PERM1 methyl",
    "PERM1 rna"
  ],
  "PERP": [
    "PERP cnv",
    "PERP methyl",
    "PERP rna"
  ],
  "PES1": [
    "PES1 cnv",
    "PES1 methyl",
    "PES1 proteo",
    "PES1 rna"
  ],
  "PET100": [
    "PET100 cnv",
    "PET100 methyl",
    "PET100 rna"
  ],
  "PET117": [
    "PET117 cnv",
    "PET117 methyl",
    "PET117 rna"
  ],
  "PEX1": [
    "PEX1 1179_1189_1_1_S1181 phospho",
    "PEX1 1207_1216_1_0 phospho",
    "PEX1 1207_1216_1_1_S1209 phospho",
    "PEX1 1209_1216_1_1_S1211 phospho",
    "PEX1 cnv",
    "PEX1 methyl",
    "PEX1 proteo",
    "PEX1 rna"
  ],
  "PEX10": [
    "PEX10 cnv",
    "PEX10 methyl",
    "PEX10 proteo",
    "PEX10 rna"
  ],
  "PEX11A": [
    "PEX11A cnv",
    "PEX11A methyl",
    "PEX11A rna"
  ],
  "PEX11B": [
    "PEX11B cnv",
    "PEX11B methyl",
    "PEX11B proteo",
    "PEX11B rna"
  ],
  "PEX11G": [
    "PEX11G 169_170_1_1_T170 phospho",
    "PEX11G cnv",
    "PEX11G methyl",
    "PEX11G rna"
  ],
  "PEX12": [
    "PEX12 cnv",
    "PEX12 methyl",
    "PEX12 proteo",
    "PEX12 rna"
  ],
  "PEX13": [
    "PEX13 cnv",
    "PEX13 rna"
  ],
  "PEX14": [
    "PEX14 282_290_1_1_S282 phospho",
    "PEX14 44_48_1_1_S44 phospho",
    "PEX14 cnv",
    "PEX14 methyl",
    "PEX14 proteo",
    "PEX14 rna"
  ],
  "PEX16": [
    "PEX16 177_186_1_1_S183 phospho",
    "PEX16 cnv",
    "PEX16 methyl",
    "PEX16 proteo",
    "PEX16 rna"
  ],
  "PEX19": [
    "PEX19 141_154_1_1_S147 phospho",
    "PEX19 35_48_1_1_S35 phospho",
    "PEX19 54_58_1_1_S54 phospho",
    "PEX19 cnv",
    "PEX19 proteo",
    "PEX19 rna"
  ],
  "PEX2": [
    "PEX2 cnv",
    "PEX2 methyl",
    "PEX2 proteo",
    "PEX2 rna"
  ],
  "PEX26": [
    "PEX26 cnv",
    "PEX26 methyl",
    "PEX26 rna"
  ],
  "PEX3": [
    "PEX3 cnv",
    "PEX3 methyl",
    "PEX3 proteo",
    "PEX3 rna"
  ],
  "PEX5": [
    "PEX5 cnv",
    "PEX5 methyl",
    "PEX5 rna"
  ],
  "PEX5L": [
    "PEX5L 259_259_1_1_S259 phospho",
    "PEX5L 435_439_1_1_S435 phospho",
    "PEX5L 443_450_1_1_S445 phospho",
    "PEX5L 445_450_1_1_S445 phospho",
    "PEX5L cnv",
    "PEX5L methyl",
    "PEX5L proteo",
    "PEX5L rna"
  ],
  "PEX6": [
    "PEX6 cnv",
    "PEX6 methyl",
    "PEX6 proteo",
    "PEX6 rna"
  ],
  "PEX7": [
    "PEX7 cnv",
    "PEX7 methyl",
    "PEX7 proteo",
    "PEX7 rna"
  ],
  "PF4": [
    "PF4 cnv",
    "PF4 methyl",
    "PF4 proteo",
    "PF4 rna"
  ],
  "PF4V1": [
    "PF4V1 cnv",
    "PF4V1 rna"
  ],
  "PFAS": [
    "PFAS cnv",
    "PFAS methyl",
    "PFAS proteo",
    "PFAS rna"
  ],
  "PFDN1": [
    "PFDN1 cnv",
    "PFDN1 proteo",
    "PFDN1 rna"
  ],
  "PFDN2": [
    "PFDN2 cnv",
    "PFDN2 methyl",
    "PFDN2 proteo",
    "PFDN2 rna"
  ],
  "PFDN4": [
    "PFDN4 125_134_1_1_S125 phospho",
    "PFDN4 cnv",
    "PFDN4 methyl",
    "PFDN4 proteo",
    "PFDN4 rna"
  ],
  "PFDN5": [
    "PFDN5 cnv",
    "PFDN5 methyl",
    "PFDN5 proteo",
    "PFDN5 rna"
  ],
  "PFDN6": [
    "PFDN6 cnv",
    "PFDN6 methyl",
    "PFDN6 proteo",
    "PFDN6 rna"
  ],
  "PFKFB1": [
    "PFKFB1 rna"
  ],
  "PFKFB2": [
    "PFKFB2 463_466_1_1_S463 phospho",
    "PFKFB2 466_475_1_1_S466 phospho",
    "PFKFB2 cnv",
    "PFKFB2 methyl",
    "PFKFB2 proteo",
    "PFKFB2 rna"
  ],
  "PFKFB3": [
    "PFKFB3 461_471_1_1_S461 phospho",
    "PFKFB3 461_471_2_2_S461S467 phospho",
    "PFKFB3 cnv",
    "PFKFB3 methyl",
    "PFKFB3 proteo",
    "PFKFB3 rna"
  ],
  "PFKFB4": [
    "PFKFB4 cnv",
    "PFKFB4 methyl",
    "PFKFB4 proteo",
    "PFKFB4 rna"
  ],
  "PFKL": [
    "PFKL 377_385_1_1_S377 phospho",
    "PFKL cnv",
    "PFKL methyl",
    "PFKL proteo",
    "PFKL rna"
  ],
  "PFKM": [
    "PFKM 377_385_1_1_S377 phospho",
    "PFKM 667_669_1_1_S667 phospho",
    "PFKM 775_775_1_1_S775 phospho",
    "PFKM cnv",
    "PFKM methyl",
    "PFKM proteo",
    "PFKM rna"
  ],
  "PFKP": [
    "PFKP 386_394_1_1_S386 phospho",
    "PFKP cnv",
    "PFKP methyl",
    "PFKP proteo",
    "PFKP rna"
  ],
  "PFN1": [
    "PFN1 92_104_1_1_S92 phospho",
    "PFN1 cnv",
    "PFN1 methyl",
    "PFN1 proteo",
    "PFN1 rna"
  ],
  "PFN2": [
    "PFN2 123_123_1_1_T123 phospho",
    "PFN2 cnv",
    "PFN2 methyl",
    "PFN2 proteo",
    "PFN2 rna"
  ],
  "PFN3": [
    "PFN3 cnv",
    "PFN3 methyl",
    "PFN3 rna"
  ],
  "PFN4": [
    "PFN4 cnv",
    "PFN4 methyl",
    "PFN4 rna"
  ],
  "PGA3": [
    "PGA3 cnv",
    "PGA3 rna"
  ],
  "PGA4": [
    "PGA4 cnv",
    "PGA4 rna"
  ],
  "PGA5": [
    "PGA5 cnv",
    "PGA5 rna"
  ],
  "PGAM1": [
    "PGAM1 14_14_1_1_S14 phospho",
    "PGAM1 cnv",
    "PGAM1 methyl",
    "PGAM1 proteo",
    "PGAM1 rna"
  ],
  "PGAM2": [
    "PGAM2 cnv",
    "PGAM2 proteo",
    "PGAM2 rna"
  ],
  "PGAM4": [
    "PGAM4 rna"
  ],
  "PGAM5": [
    "PGAM5 cnv",
    "PGAM5 methyl",
    "PGAM5 proteo",
    "PGAM5 rna"
  ],
  "PGAP1": [
    "PGAP1 HINLTTLSVAGGFR-N2H5F0S0G0 glyco",
    "PGAP1 HINLTTLSVAGGFR-N2H6F0S0G0 glyco",
    "PGAP1 LHIAQPENNTHVALFK-N2H8F0S0G0 glyco",
    "PGAP1 cnv",
    "PGAP1 proteo",
    "PGAP1 rna"
  ],
  "PGAP2": [
    "PGAP2 cnv",
    "PGAP2 methyl",
    "PGAP2 rna"
  ],
  "PGAP3": [
    "PGAP3 cnv",
    "PGAP3 methyl",
    "PGAP3 rna"
  ],
  "PGAP4": [
    "PGAP4 cnv",
    "PGAP4 methyl",
    "PGAP4 proteo",
    "PGAP4 rna"
  ],
  "PGAP6": [
    "PGAP6 cnv",
    "PGAP6 methyl",
    "PGAP6 rna"
  ],
  "PGBD1": [
    "PGBD1 cnv",
    "PGBD1 methyl",
    "PGBD1 rna"
  ],
  "PGBD2": [
    "PGBD2 cnv",
    "PGBD2 methyl",
    "PGBD2 rna"
  ],
  "PGBD4": [
    "PGBD4 cnv",
    "PGBD4 methyl",
    "PGBD4 rna"
  ],
  "PGBD5": [
    "PGBD5 521_523_1_1_S521 phospho",
    "PGBD5 cnv",
    "PGBD5 methyl",
    "PGBD5 proteo",
    "PGBD5 rna"
  ],
  "PGC": [
    "PGC TLPVSNLSR-N4H5F1S1G0 glyco",
    "PGC cnv",
    "PGC rna"
  ],
  "PGD": [
    "PGD 22_24_1_1_S24 phospho",
    "PGD cnv",
    "PGD methyl",
    "PGD proteo",
    "PGD rna"
  ],
  "PGF": [
    "PGF cnv",
    "PGF methyl",
    "PGF rna"
  ],
  "PGGHG": [
    "PGGHG cnv",
    "PGGHG methyl",
    "PGGHG proteo",
    "PGGHG rna"
  ],
  "PGGT1B": [
    "PGGT1B cnv",
    "PGGT1B methyl",
    "PGGT1B proteo",
    "PGGT1B rna"
  ],
  "PGK1": [
    "PGK1 203_203_1_1_S203 phospho",
    "PGK1 methyl",
    "PGK1 proteo",
    "PGK1 rna"
  ],
  "PGK2": [
    "PGK2 cnv",
    "PGK2 proteo"
  ],
  "PGLS": [
    "PGLS 46_52_1_1_S49 phospho",
    "PGLS cnv",
    "PGLS methyl",
    "PGLS proteo",
    "PGLS rna"
  ],
  "PGLS-DT": [
    "PGLS-DT methyl"
  ],
  "PGLYRP1": [
    "PGLYRP1 cnv",
    "PGLYRP1 methyl",
    "PGLYRP1 proteo",
    "PGLYRP1 rna"
  ],
  "PGLYRP2": [
    "PGLYRP2 GFGVAIVGNYTAALPTEAALR-N4H5F0S2G0 glyco",
    "PGLYRP2 LEPVHLQLQCMSQEQLAQVAANATK-N4H5F0S2G0 glyco",
    "PGLYRP2 LEPVHLQLQCMSQEQLAQVAANATK-N4H5F2S1G0 glyco",
    "PGLYRP2 cnv",
    "PGLYRP2 proteo",
    "PGLYRP2 rna"
  ],
  "PGLYRP3": [
    "PGLYRP3 cnv"
  ],
  "PGLYRP4": [
    "PGLYRP4 cnv"
  ],
  "PGM1": [
    "PGM1 115_117_1_1_S117 phospho",
    "PGM1 cnv",
    "PGM1 methyl",
    "PGM1 proteo",
    "PGM1 rna"
  ],
  "PGM2": [
    "PGM2 163_165_1_1_S165 phospho",
    "PGM2 163_174_1_1_S165 phospho",
    "PGM2 cnv",
    "PGM2 methyl",
    "PGM2 proteo",
    "PGM2 rna"
  ],
  "PGM2L1": [
    "PGM2L1 173_175_1_0 phospho",
    "PGM2L1 173_175_1_1_S175 phospho",
    "PGM2L1 173_184_1_1_S175 phospho",
    "PGM2L1 cnv",
    "PGM2L1 methyl",
    "PGM2L1 proteo",
    "PGM2L1 rna"
  ],
  "PGM3": [
    "PGM3 83_92_1_1_S92 phospho",
    "PGM3 cnv",
    "PGM3 methyl",
    "PGM3 proteo",
    "PGM3 rna"
  ],
  "PGM5": [
    "PGM5 120_122_1_1_S122 phospho",
    "PGM5 cnv",
    "PGM5 methyl",
    "PGM5 proteo",
    "PGM5 rna"
  ],
  "PGM5P2": [
    "PGM5P2 methyl"
  ],
  "PGM5P3-AS1": [
    "PGM5P3-AS1 methyl"
  ],
  "PGP": [
    "PGP cnv",
    "PGP methyl",
    "PGP proteo",
    "PGP rna"
  ],
  "PGPEP1": [
    "PGPEP1 cnv",
    "PGPEP1 methyl",
    "PGPEP1 proteo",
    "PGPEP1 rna"
  ],
  "PGPEP1L": [
    "PGPEP1L cnv",
    "PGPEP1L rna"
  ],
  "PGR": [
    "PGR cnv",
    "PGR methyl",
    "PGR rna"
  ],
  "PGRMC1": [
    "PGRMC1 178_181_1_1_S181 phospho",
    "PGRMC1 178_190_1_1_S181 phospho",
    "PGRMC1 54_57_1_1_S57 phospho",
    "PGRMC1 methyl",
    "PGRMC1 proteo",
    "PGRMC1 rna"
  ],
  "PGRMC2": [
    "PGRMC2 114_118_1_1_S114 phospho",
    "PGRMC2 232_240_1_1_T235 phospho",
    "PGRMC2 cnv",
    "PGRMC2 methyl",
    "PGRMC2 proteo",
    "PGRMC2 rna"
  ],
  "PGS1": [
    "PGS1 cnv",
    "PGS1 methyl",
    "PGS1 proteo",
    "PGS1 rna"
  ],
  "PHACTR1": [
    "PHACTR1 237_237_1_1_S237 phospho",
    "PHACTR1 467_471_1_1_S467 phospho",
    "PHACTR1 65_71_1_1_S67 phospho",
    "PHACTR1 95_104_1_1_S97 phospho",
    "PHACTR1 95_104_1_1_T104 phospho",
    "PHACTR1 cnv",
    "PHACTR1 proteo",
    "PHACTR1 rna"
  ],
  "PHACTR2": [
    "PHACTR2 cnv",
    "PHACTR2 methyl",
    "PHACTR2 proteo",
    "PHACTR2 rna"
  ],
  "PHACTR3": [
    "PHACTR3 cnv",
    "PHACTR3 methyl",
    "PHACTR3 proteo",
    "PHACTR3 rna"
  ],
  "PHACTR4": [
    "PHACTR4 116_118_1_1_S118 phospho",
    "PHACTR4 12_31_1_0 phospho",
    "PHACTR4 176_182_1_1_S176 phospho",
    "PHACTR4 21_31_1_1_T28 phospho",
    "PHACTR4 342_349_1_1_S344 phospho",
    "PHACTR4 342_358_2_0 phospho",
    "PHACTR4 342_358_2_2_S344T358 phospho",
    "PHACTR4 443_458_1_1_S443 phospho",
    "PHACTR4 464_468_1_1_S464 phospho",
    "PHACTR4 557_565_1_1_S557 phospho",
    "PHACTR4 590_594_1_1_S590 phospho",
    "PHACTR4 cnv",
    "PHACTR4 methyl",
    "PHACTR4 proteo",
    "PHACTR4 rna"
  ],
  "PHAF1": [
    "PHAF1 270_272_1_1_S272 phospho",
    "PHAF1 cnv",
    "PHAF1 methyl",
    "PHAF1 proteo",
    "PHAF1 rna"
  ],
  "PHAX": [
    "PHAX cnv",
    "PHAX methyl",
    "PHAX proteo",
    "PHAX rna"
  ],
  "PHB1": [
    "PHB1 cnv",
    "PHB1 proteo",
    "PHB1 rna"
  ],
  "PHB2": [
    "PHB2 cnv",
    "PHB2 methyl",
    "PHB2 proteo",
    "PHB2 rna"
  ],
  "PHC1": [
    "PHC1 664_669_1_1_S664 phospho",
    "PHC1 cnv",
    "PHC1 methyl",
    "PHC1 proteo",
    "PHC1 rna"
  ],
  "PHC2": [
    "PHC2 cnv",
    "PHC2 methyl",
    "PHC2 proteo",
    "PHC2 rna"
  ],
  "PHC2-AS1": [
    "PHC2-AS1 methyl"
  ],
  "PHC3": [
    "PHC3 258_266_1_1_S263 phospho",
    "PHC3 285_304_1_0 phospho",
    "PHC3 609_621_1_1_T609 phospho",
    "PHC3 609_621_2_2_T609S616 phospho",
    "PHC3 cnv",
    "PHC3 methyl",
    "PHC3 proteo",
    "PHC3 rna"
  ],
  "PHETA1": [
    "PHETA1 226_226_1_1_S226 phospho",
    "PHETA1 cnv",
    "PHETA1 methyl",
    "PHETA1 proteo",
    "PHETA1 rna"
  ],
  "PHETA2": [
    "PHETA2 cnv",
    "PHETA2 methyl",
    "PHETA2 rna"
  ],
  "PHEX": [
    "PHEX rna"
  ],
  "PHF1": [
    "PHF1 cnv",
    "PHF1 methyl",
    "PHF1 proteo",
    "PHF1 rna"
  ],
  "PHF10": [
    "PHF10 269_270_1_1_S270 phospho",
    "PHF10 318_339_1_1_S327 phospho",
    "PHF10 36_43_1_1_S36 phospho",
    "PHF10 cnv",
    "PHF10 methyl",
    "PHF10 proteo",
    "PHF10 rna"
  ],
  "PHF11": [
    "PHF11 cnv",
    "PHF11 methyl",
    "PHF11 rna"
  ],
  "PHF12": [
    "PHF12 586_597_1_1_T586 phospho",
    "PHF12 645_667_1_1_S662 phospho",
    "PHF12 671_684_1_1_T671 phospho",
    "PHF12 877_884_1_1_T880 phospho",
    "PHF12 cnv",
    "PHF12 methyl",
    "PHF12 proteo",
    "PHF12 rna"
  ],
  "PHF13": [
    "PHF13 cnv",
    "PHF13 methyl",
    "PHF13 rna"
  ],
  "PHF14": [
    "PHF14 277_296_1_1_S280 phospho",
    "PHF14 280_296_1_1_S290 phospho",
    "PHF14 280_296_2_2_T287S290 phospho",
    "PHF14 835_835_1_1_S835 phospho",
    "PHF14 cnv",
    "PHF14 methyl",
    "PHF14 proteo",
    "PHF14 rna"
  ],
  "PHF19": [
    "PHF19 cnv",
    "PHF19 methyl",
    "PHF19 rna"
  ],
  "PHF2": [
    "PHF2 1056_1064_1_1_S1056 phospho",
    "PHF2 1056_1064_1_1_S1059 phospho",
    "PHF2 1056_1064_2_2_S1056S1059 phospho",
    "PHF2 625_625_1_1_S625 phospho",
    "PHF2 899_907_1_1_S899 phospho",
    "PHF2 cnv",
    "PHF2 methyl",
    "PHF2 proteo",
    "PHF2 rna"
  ],
  "PHF20": [
    "PHF20 892_902_1_1_S902 phospho",
    "PHF20 cnv",
    "PHF20 methyl",
    "PHF20 rna"
  ],
  "PHF20L1": [
    "PHF20L1 406_412_1_1_S407 phospho",
    "PHF20L1 cnv",
    "PHF20L1 methyl",
    "PHF20L1 proteo",
    "PHF20L1 rna"
  ],
  "PHF21A": [
    "PHF21A 348_350_1_1_T350 phospho",
    "PHF21A cnv",
    "PHF21A methyl",
    "PHF21A proteo",
    "PHF21A rna"
  ],
  "PHF21B": [
    "PHF21B cnv",
    "PHF21B methyl",
    "PHF21B rna"
  ],
  "PHF23": [
    "PHF23 cnv",
    "PHF23 methyl",
    "PHF23 proteo",
    "PHF23 rna"
  ],
  "PHF24": [
    "PHF24 333_354_1_0 phospho",
    "PHF24 333_354_1_1_S348 phospho",
    "PHF24 37_43_1_1_S43 phospho",
    "PHF24 47_51_1_1_T47 phospho",
    "PHF24 cnv",
    "PHF24 methyl",
    "PHF24 proteo",
    "PHF24 rna"
  ],
  "PHF3": [
    "PHF3 195_195_1_1_S195 phospho",
    "PHF3 614_622_1_1_S614 phospho",
    "PHF3 cnv",
    "PHF3 methyl",
    "PHF3 proteo",
    "PHF3 rna"
  ],
  "PHF5A": [
    "PHF5A cnv",
    "PHF5A methyl",
    "PHF5A proteo",
    "PHF5A rna"
  ],
  "PHF6": [
    "PHF6 134_155_1_0 phospho",
    "PHF6 134_155_1_1_S155 phospho",
    "PHF6 203_208_1_1_S204 phospho",
    "PHF6 methyl",
    "PHF6 proteo",
    "PHF6 rna"
  ],
  "PHF7": [
    "PHF7 cnv",
    "PHF7 methyl",
    "PHF7 rna"
  ],
  "PHF8": [
    "PHF8 790_807_1_1_S804 phospho",
    "PHF8 850_857_1_1_S857 phospho",
    "PHF8 methyl",
    "PHF8 rna"
  ],
  "PHGDH": [
    "PHGDH 353_362_1_1_S362 phospho",
    "PHGDH 55_60_1_1_S55 phospho",
    "PHGDH 78_89_1_1_T78 phospho",
    "PHGDH cnv",
    "PHGDH methyl",
    "PHGDH proteo",
    "PHGDH rna"
  ],
  "PHGR1": [
    "PHGR1 cnv"
  ],
  "PHIP": [
    "PHIP 1281_1297_2_2_S1281S1283 phospho",
    "PHIP 1775_1783_1_1_S1783 phospho",
    "PHIP 674_683_1_1_S674 phospho",
    "PHIP cnv",
    "PHIP methyl",
    "PHIP proteo",
    "PHIP rna"
  ],
  "PHKA1": [
    "PHKA1 methyl",
    "PHKA1 proteo",
    "PHKA1 rna"
  ],
  "PHKA2": [
    "PHKA2 1015_1034_1_1_S1015 phospho",
    "PHKA2 1039_1053_1_1_S1044 phospho",
    "PHKA2 729_735_1_1_S729 phospho",
    "PHKA2 methyl",
    "PHKA2 proteo",
    "PHKA2 rna"
  ],
  "PHKB": [
    "PHKB 700_717_1_0 phospho",
    "PHKB cnv",
    "PHKB methyl",
    "PHKB proteo",
    "PHKB rna"
  ],
  "PHKG1": [
    "PHKG1 cnv",
    "PHKG1 kinase",
    "PHKG1 proteo",
    "PHKG1 rna"
  ],
  "PHKG2": [
    "PHKG2 cnv",
    "PHKG2 kinase",
    "PHKG2 methyl",
    "PHKG2 proteo",
    "PHKG2 rna"
  ],
  "PHLDA1": [
    "PHLDA1 cnv",
    "PHLDA1 methyl",
    "PHLDA1 proteo",
    "PHLDA1 rna"
  ],
  "PHLDA2": [
    "PHLDA2 cnv",
    "PHLDA2 methyl",
    "PHLDA2 rna"
  ],
  "PHLDA3": [
    "PHLDA3 cnv",
    "PHLDA3 methyl",
    "PHLDA3 proteo",
    "PHLDA3 rna"
  ],
  "PHLDB1": [
    "PHLDB1 1007_1017_1_1_S1017 phospho",
    "PHLDB1 156_177_1_1_S157 phospho",
    "PHLDB1 219_223_1_1_S220 phospho",
    "PHLDB1 362_381_1_1_S381 phospho",
    "PHLDB1 437_443_1_1_S443 phospho",
    "PHLDB1 461_465_1_1_S465 phospho",
    "PHLDB1 489_489_1_1_S489 phospho",
    "PHLDB1 516_526_1_1_S518 phospho",
    "PHLDB1 516_526_2_2_S518S520 phospho",
    "PHLDB1 518_526_1_1_S520 phospho",
    "PHLDB1 518_526_2_2_S518S520 phospho",
    "PHLDB1 539_555_1_1_S539 phospho",
    "PHLDB1 539_555_1_1_S543 phospho",
    "PHLDB1 539_555_1_1_S551 phospho",
    "PHLDB1 539_555_1_1_S555 phospho",
    "PHLDB1 578_592_1_1_S578 phospho",
    "PHLDB1 578_592_1_1_S583 phospho",
    "PHLDB1 578_592_2_0 phospho",
    "PHLDB1 664_672_1_1_S664 phospho",
    "PHLDB1 970_971_1_1_S971 phospho",
    "PHLDB1 cnv",
    "PHLDB1 methyl",
    "PHLDB1 proteo",
    "PHLDB1 rna"
  ],
  "PHLDB2": [
    "PHLDB2 223_231_1_1_S231 phospho",
    "PHLDB2 239_243_1_1_S239 phospho",
    "PHLDB2 343_361_1_1_S361 phospho",
    "PHLDB2 540_561_1_1_S540 phospho",
    "PHLDB2 cnv",
    "PHLDB2 methyl",
    "PHLDB2 proteo",
    "PHLDB2 rna"
  ],
  "PHLDB3": [
    "PHLDB3 cnv",
    "PHLDB3 methyl",
    "PHLDB3 rna"
  ],
  "PHLPP1": [
    "PHLPP1 1524_1526_1_1_S1526 phospho",
    "PHLPP1 317_336_1_1_S317 phospho",
    "PHLPP1 409_412_1_1_S412 phospho",
    "PHLPP1 425_425_1_1_S425 phospho",
    "PHLPP1 cnv",
    "PHLPP1 methyl",
    "PHLPP1 proteo",
    "PHLPP1 rna"
  ],
  "PHLPP2": [
    "PHLPP2 1052_1059_1_1_S1052 phospho",
    "PHLPP2 cnv",
    "PHLPP2 methyl",
    "PHLPP2 rna"
  ],
  "PHOSPHO1": [
    "PHOSPHO1 cnv",
    "PHOSPHO1 methyl",
    "PHOSPHO1 rna"
  ],
  "PHOSPHO2": [
    "PHOSPHO2 cnv",
    "PHOSPHO2 methyl",
    "PHOSPHO2 rna"
  ],
  "PHOX2A": [
    "PHOX2A cnv",
    "PHOX2A methyl",
    "PHOX2A rna"
  ],
  "PHOX2B": [
    "PHOX2B cnv",
    "PHOX2B methyl",
    "PHOX2B rna"
  ],
  "PHPT1": [
    "PHPT1 cnv",
    "PHPT1 methyl",
    "PHPT1 proteo",
    "PHPT1 rna"
  ],
  "PHRF1": [
    "PHRF1 1032_1036_1_1_S1034 phospho",
    "PHRF1 1202_1218_1_1_S1202 phospho",
    "PHRF1 1202_1234_1_1_S1202 phospho",
    "PHRF1 1359_1360_1_1_S1360 phospho",
    "PHRF1 1359_1375_1_1_S1360 phospho",
    "PHRF1 1359_1375_1_1_S1371 phospho",
    "PHRF1 1359_1375_2_2_S1360S1371 phospho",
    "PHRF1 814_818_1_1_S814 phospho",
    "PHRF1 936_955_1_1_S936 phospho",
    "PHRF1 959_981_1_1_S973 phospho",
    "PHRF1 cnv",
    "PHRF1 methyl",
    "PHRF1 proteo",
    "PHRF1 rna"
  ],
  "PHTF1": [
    "PHTF1 cnv",
    "PHTF1 methyl",
    "PHTF1 rna"
  ],
  "PHTF2": [
    "PHTF2 cnv",
    "PHTF2 methyl",
    "PHTF2 rna"
  ],
  "PHYH": [
    "PHYH cnv",
    "PHYH methyl",
    "PHYH proteo",
    "PHYH rna"
  ],
  "PHYHD1": [
    "PHYHD1 cnv",
    "PHYHD1 proteo",
    "PHYHD1 rna"
  ],
  "PHYHIP": [
    "PHYHIP cnv",
    "PHYHIP proteo",
    "PHYHIP rna"
  ],
  "PHYHIPL": [
    "PHYHIPL 12_15_1_0 phospho",
    "PHYHIPL 12_15_1_1_S12 phospho",
    "PHYHIPL 12_15_1_1_S15 phospho",
    "PHYHIPL 12_15_2_0 phospho",
    "PHYHIPL 12_15_2_2_S12S15 phospho",
    "PHYHIPL 25_25_1_1_S25 phospho",
    "PHYHIPL cnv",
    "PHYHIPL methyl",
    "PHYHIPL proteo",
    "PHYHIPL rna"
  ],
  "PHYKPL": [
    "PHYKPL cnv",
    "PHYKPL methyl",
    "PHYKPL proteo",
    "PHYKPL rna"
  ],
  "PI15": [
    "PI15 cnv",
    "PI15 rna"
  ],
  "PI16": [
    "PI16 cnv",
    "PI16 methyl",
    "PI16 proteo",
    "PI16 rna"
  ],
  "PI3": [
    "PI3 cnv",
    "PI3 rna"
  ],
  "PI4K2A": [
    "PI4K2A 44_51_1_1_S47 phospho",
    "PI4K2A 44_51_1_1_S51 phospho",
    "PI4K2A 44_51_2_2_S47S51 phospho",
    "PI4K2A cnv",
    "PI4K2A methyl",
    "PI4K2A proteo",
    "PI4K2A rna"
  ],
  "PI4K2B": [
    "PI4K2B cnv",
    "PI4K2B methyl",
    "PI4K2B rna"
  ],
  "PI4KA": [
    "PI4KA 1389_1403_1_1_S1393 phospho",
    "PI4KA 1795_1803_1_1_S1797 phospho",
    "PI4KA 255_265_1_1_S257 phospho",
    "PI4KA cnv",
    "PI4KA kinase",
    "PI4KA methyl",
    "PI4KA proteo",
    "PI4KA rna"
  ],
  "PI4KAP1": [
    "PI4KAP1 methyl"
  ],
  "PI4KB": [
    "PI4KB 275_287_1_1_S277 phospho",
    "PI4KB 292_294_1_1_S294 phospho",
    "PI4KB 410_423_2_0 phospho",
    "PI4KB 413_423_1_1_S413 phospho",
    "PI4KB 496_504_1_1_S496 phospho",
    "PI4KB cnv",
    "PI4KB methyl",
    "PI4KB proteo",
    "PI4KB rna"
  ],
  "PIANP": [
    "PIANP cnv",
    "PIANP methyl",
    "PIANP proteo",
    "PIANP rna"
  ],
  "PIAS1": [
    "PIAS1 482_490_1_1_S487 phospho",
    "PIAS1 499_508_1_1_S505 phospho",
    "PIAS1 cnv",
    "PIAS1 methyl",
    "PIAS1 proteo",
    "PIAS1 rna"
  ],
  "PIAS2": [
    "PIAS2 485_492_1_1_S490 phospho",
    "PIAS2 cnv",
    "PIAS2 methyl",
    "PIAS2 rna"
  ],
  "PIAS3": [
    "PIAS3 cnv",
    "PIAS3 methyl",
    "PIAS3 rna"
  ],
  "PIAS4": [
    "PIAS4 cnv",
    "PIAS4 methyl",
    "PIAS4 rna"
  ],
  "PIBF1": [
    "PIBF1 cnv",
    "PIBF1 methyl",
    "PIBF1 proteo",
    "PIBF1 rna"
  ],
  "PICALM": [
    "PICALM 11_23_1_1_S16 phospho",
    "PICALM 352_387_1_1_S359 phospho",
    "PICALM cnv",
    "PICALM methyl",
    "PICALM proteo",
    "PICALM rna"
  ],
  "PICART1": [
    "PICART1 methyl"
  ],
  "PICK1": [
    "PICK1 cnv",
    "PICK1 methyl",
    "PICK1 proteo",
    "PICK1 rna"
  ],
  "PID1": [
    "PID1 201_214_1_1_S214 phospho",
    "PID1 cnv",
    "PID1 methyl",
    "PID1 proteo",
    "PID1 rna"
  ],
  "PIDD1": [
    "PIDD1 cnv",
    "PIDD1 methyl",
    "PIDD1 rna"
  ],
  "PIERCE1": [
    "PIERCE1 cnv",
    "PIERCE1 methyl",
    "PIERCE1 rna"
  ],
  "PIERCE2": [
    "PIERCE2 cnv",
    "PIERCE2 methyl",
    "PIERCE2 rna"
  ],
  "PIEZO1": [
    "PIEZO1 1391_1396_1_1_S1391 phospho",
    "PIEZO1 1619_1626_1_1_S1621 phospho",
    "PIEZO1 HMLALAPNSTAR-N2H5F0S0G0 glyco",
    "PIEZO1 cnv",
    "PIEZO1 methyl",
    "PIEZO1 proteo",
    "PIEZO1 rna"
  ],
  "PIEZO2": [
    "PIEZO2 cnv",
    "PIEZO2 methyl",
    "PIEZO2 rna"
  ],
  "PIF1": [
    "PIF1 cnv",
    "PIF1 rna"
  ],
  "PIFO": [
    "PIFO cnv",
    "PIFO methyl",
    "PIFO rna"
  ],
  "PIGA": [
    "PIGA methyl",
    "PIGA rna"
  ],
  "PIGB": [
    "PIGB cnv",
    "PIGB methyl",
    "PIGB rna"
  ],
  "PIGBOS1": [
    "PIGBOS1 cnv",
    "PIGBOS1 methyl",
    "PIGBOS1 proteo",
    "PIGBOS1 rna"
  ],
  "PIGC": [
    "PIGC cnv",
    "PIGC methyl",
    "PIGC rna"
  ],
  "PIGF": [
    "PIGF cnv",
    "PIGF methyl",
    "PIGF rna"
  ],
  "PIGG": [
    "PIGG cnv",
    "PIGG methyl",
    "PIGG proteo",
    "PIGG rna"
  ],
  "PIGH": [
    "PIGH cnv",
    "PIGH methyl",
    "PIGH proteo",
    "PIGH rna"
  ],
  "PIGK": [
    "PIGK cnv",
    "PIGK methyl",
    "PIGK proteo",
    "PIGK rna"
  ],
  "PIGL": [
    "PIGL cnv",
    "PIGL rna"
  ],
  "PIGM": [
    "PIGM cnv",
    "PIGM methyl",
    "PIGM proteo",
    "PIGM rna"
  ],
  "PIGN": [
    "PIGN NNQSLFSK-N2H8F0S0G0 glyco",
    "PIGN cnv",
    "PIGN methyl",
    "PIGN proteo",
    "PIGN rna"
  ],
  "PIGO": [
    "PIGO cnv",
    "PIGO methyl",
    "PIGO proteo",
    "PIGO rna"
  ],
  "PIGP": [
    "PIGP cnv",
    "PIGP methyl",
    "PIGP rna"
  ],
  "PIGQ": [
    "PIGQ cnv",
    "PIGQ methyl",
    "PIGQ proteo",
    "PIGQ rna"
  ],
  "PIGR": [
    "PIGR cnv",
    "PIGR proteo",
    "PIGR rna"
  ],
  "PIGS": [
    "PIGS TYNASVLPVR-N2H5F0S0G0 glyco",
    "PIGS cnv",
    "PIGS methyl",
    "PIGS proteo",
    "PIGS rna"
  ],
  "PIGT": [
    "PIGT TYAIYDLLDTAMINNSR-N2H5F0S0G0 glyco",
    "PIGT TYAIYDLLDTAMINNSR-N2H6F0S0G0 glyco",
    "PIGT cnv",
    "PIGT methyl",
    "PIGT proteo",
    "PIGT rna"
  ],
  "PIGU": [
    "PIGU cnv",
    "PIGU methyl",
    "PIGU proteo",
    "PIGU rna"
  ],
  "PIGV": [
    "PIGV cnv",
    "PIGV methyl",
    "PIGV rna"
  ],
  "PIGW": [
    "PIGW cnv",
    "PIGW methyl",
    "PIGW rna"
  ],
  "PIGX": [
    "PIGX cnv",
    "PIGX methyl",
    "PIGX proteo",
    "PIGX rna"
  ],
  "PIGY": [
    "PIGY cnv",
    "PIGY rna"
  ],
  "PIGZ": [
    "PIGZ cnv",
    "PIGZ methyl",
    "PIGZ rna"
  ],
  "PIH1D1": [
    "PIH1D1 cnv",
    "PIH1D1 methyl",
    "PIH1D1 proteo",
    "PIH1D1 rna"
  ],
  "PIH1D2": [
    "PIH1D2 cnv",
    "PIH1D2 methyl",
    "PIH1D2 rna"
  ],
  "PIK3AP1": [
    "PIK3AP1 cnv",
    "PIK3AP1 methyl",
    "PIK3AP1 rna"
  ],
  "PIK3C2A": [
    "PIK3C2A 1281_1281_1_1_S1281 phospho",
    "PIK3C2A cnv",
    "PIK3C2A methyl",
    "PIK3C2A proteo",
    "PIK3C2A rna"
  ],
  "PIK3C2B": [
    "PIK3C2B cnv",
    "PIK3C2B kinase",
    "PIK3C2B methyl",
    "PIK3C2B proteo",
    "PIK3C2B rna"
  ],
  "PIK3C2G": [
    "PIK3C2G cnv",
    "PIK3C2G kinase",
    "PIK3C2G rna"
  ],
  "PIK3C3": [
    "PIK3C3 cnv",
    "PIK3C3 proteo",
    "PIK3C3 rna"
  ],
  "PIK3CA": [
    "PIK3CA 312_324_1_1_S312 phospho",
    "PIK3CA cnv",
    "PIK3CA kinase",
    "PIK3CA methyl",
    "PIK3CA mut",
    "PIK3CA proteo",
    "PIK3CA rna"
  ],
  "PIK3CA-DT": [
    "PIK3CA-DT methyl"
  ],
  "PIK3CB": [
    "PIK3CB cnv",
    "PIK3CB kinase",
    "PIK3CB methyl",
    "PIK3CB proteo",
    "PIK3CB rna"
  ],
  "PIK3CD": [
    "PIK3CD 519_523_1_1_S519 phospho",
    "PIK3CD cnv",
    "PIK3CD kinase",
    "PIK3CD methyl",
    "PIK3CD proteo",
    "PIK3CD rna"
  ],
  "PIK3CG": [
    "PIK3CG cnv",
    "PIK3CG kinase",
    "PIK3CG rna"
  ],
  "PIK3IP1": [
    "PIK3IP1 cnv",
    "PIK3IP1 methyl",
    "PIK3IP1 proteo",
    "PIK3IP1 rna"
  ],
  "PIK3R1": [
    "PIK3R1 213_222_1_1_Y217 phospho",
    "PIK3R1 89_91_1_1_Y89 phospho",
    "PIK3R1 cnv",
    "PIK3R1 methyl",
    "PIK3R1 mut",
    "PIK3R1 proteo",
    "PIK3R1 rna"
  ],
  "PIK3R2": [
    "PIK3R2 262_276_1_0 phospho",
    "PIK3R2 cnv",
    "PIK3R2 methyl",
    "PIK3R2 proteo",
    "PIK3R2 rna"
  ],
  "PIK3R3": [
    "PIK3R3 cnv",
    "PIK3R3 methyl",
    "PIK3R3 rna"
  ],
  "PIK3R4": [
    "PIK3R4 808_814_1_1_S813 phospho",
    "PIK3R4 853_853_1_1_S853 phospho",
    "PIK3R4 892_913_1_0 phospho",
    "PIK3R4 cnv",
    "PIK3R4 kinase",
    "PIK3R4 methyl",
    "PIK3R4 proteo",
    "PIK3R4 rna"
  ],
  "PIK3R5": [
    "PIK3R5 458_471_1_1_S458 phospho",
    "PIK3R5 cnv",
    "PIK3R5 methyl",
    "PIK3R5 rna"
  ],
  "PIK3R6": [
    "PIK3R6 cnv",
    "PIK3R6 rna"
  ],
  "PIKFYVE": [
    "PIKFYVE 1549_1549_1_1_S1549 phospho",
    "PIKFYVE 1712_1726_1_1_S1714 phospho",
    "PIKFYVE 1750_1759_1_0 phospho",
    "PIKFYVE 291_299_1_1_S299 phospho",
    "PIKFYVE 316_329_1_1_S329 phospho",
    "PIKFYVE cnv",
    "PIKFYVE methyl",
    "PIKFYVE proteo",
    "PIKFYVE rna"
  ],
  "PILRA": [
    "PILRA cnv",
    "PILRA rna"
  ],
  "PILRB": [
    "PILRB cnv",
    "PILRB rna"
  ],
  "PIM1": [
    "PIM1 cnv",
    "PIM1 kinase",
    "PIM1 methyl",
    "PIM1 rna"
  ],
  "PIM2": [
    "PIM2 kinase",
    "PIM2 methyl",
    "PIM2 rna"
  ],
  "PIM3": [
    "PIM3 cnv",
    "PIM3 kinase",
    "PIM3 methyl",
    "PIM3 rna"
  ],
  "PIMREG": [
    "PIMREG 129_137_1_1_S131 phospho",
    "PIMREG 16_26_1_1_S16 phospho",
    "PIMREG cnv",
    "PIMREG methyl",
    "PIMREG proteo",
    "PIMREG rna"
  ],
  "PIN1": [
    "PIN1 cnv",
    "PIN1 methyl",
    "PIN1 proteo",
    "PIN1 rna"
  ],
  "PIN4": [
    "PIN4 proteo",
    "PIN4 rna"
  ],
  "PINK1": [
    "PINK1 cnv",
    "PINK1 kinase",
    "PINK1 methyl",
    "PINK1 rna"
  ],
  "PINLYP": [
    "PINLYP cnv",
    "PINLYP methyl",
    "PINLYP rna"
  ],
  "PINX1": [
    "PINX1 cnv",
    "PINX1 methyl",
    "PINX1 rna"
  ],
  "PIP": [
    "PIP cnv"
  ],
  "PIP4K2A": [
    "PIP4K2A cnv",
    "PIP4K2A methyl",
    "PIP4K2A proteo",
    "PIP4K2A rna"
  ],
  "PIP4K2B": [
    "PIP4K2B cnv",
    "PIP4K2B methyl",
    "PIP4K2B proteo",
    "PIP4K2B rna"
  ],
  "PIP4K2C": [
    "PIP4K2C cnv",
    "PIP4K2C kinase",
    "PIP4K2C methyl",
    "PIP4K2C proteo",
    "PIP4K2C rna"
  ],
  "PIP4P1": [
    "PIP4P1 169_169_1_1_S169 phospho",
    "PIP4P1 cnv",
    "PIP4P1 methyl",
    "PIP4P1 proteo",
    "PIP4P1 rna"
  ],
  "PIP4P2": [
    "PIP4P2 10_33_1_1_S18 phospho",
    "PIP4P2 cnv",
    "PIP4P2 proteo",
    "PIP4P2 rna"
  ],
  "PIP5K1A": [
    "PIP5K1A 435_448_1_0 phospho",
    "PIP5K1A 435_448_1_1_S446 phospho",
    "PIP5K1A cnv",
    "PIP5K1A kinase",
    "PIP5K1A methyl",
    "PIP5K1A proteo",
    "PIP5K1A rna"
  ],
  "PIP5K1B": [
    "PIP5K1B cnv",
    "PIP5K1B kinase",
    "PIP5K1B methyl",
    "PIP5K1B rna"
  ],
  "PIP5K1C": [
    "PIP5K1C 646_668_1_0 phospho",
    "PIP5K1C cnv",
    "PIP5K1C kinase",
    "PIP5K1C methyl",
    "PIP5K1C proteo",
    "PIP5K1C rna"
  ],
  "PIP5KL1": [
    "PIP5KL1 cnv",
    "PIP5KL1 methyl",
    "PIP5KL1 proteo",
    "PIP5KL1 rna"
  ],
  "PIPOX": [
    "PIPOX cnv",
    "PIPOX methyl",
    "PIPOX proteo",
    "PIPOX rna"
  ],
  "PIR": [
    "PIR methyl",
    "PIR proteo",
    "PIR rna"
  ],
  "PIRT": [
    "PIRT cnv",
    "PIRT rna"
  ],
  "PISD": [
    "PISD cnv",
    "PISD methyl",
    "PISD proteo",
    "PISD rna"
  ],
  "PITHD1": [
    "PITHD1 cnv",
    "PITHD1 methyl",
    "PITHD1 proteo",
    "PITHD1 rna"
  ],
  "PITPNA": [
    "PITPNA cnv",
    "PITPNA methyl",
    "PITPNA proteo",
    "PITPNA rna"
  ],
  "PITPNA-AS1": [
    "PITPNA-AS1 methyl"
  ],
  "PITPNB": [
    "PITPNB cnv",
    "PITPNB methyl",
    "PITPNB proteo",
    "PITPNB rna"
  ],
  "PITPNC1": [
    "PITPNC1 270_289_1_1_S270 phospho",
    "PITPNC1 270_289_1_1_S274 phospho",
    "PITPNC1 299_305_1_1_S299 phospho",
    "PITPNC1 cnv",
    "PITPNC1 methyl",
    "PITPNC1 proteo",
    "PITPNC1 rna"
  ],
  "PITPNM1": [
    "PITPNM1 280_304_1_1_S300 phospho",
    "PITPNM1 664_683_1_0 phospho",
    "PITPNM1 cnv",
    "PITPNM1 methyl",
    "PITPNM1 proteo",
    "PITPNM1 rna"
  ],
  "PITPNM2": [
    "PITPNM2 1296_1305_1_1_S1298 phospho",
    "PITPNM2 644_644_1_1_S644 phospho",
    "PITPNM2 863_867_1_1_S867 phospho",
    "PITPNM2 cnv",
    "PITPNM2 methyl",
    "PITPNM2 proteo",
    "PITPNM2 rna"
  ],
  "PITPNM3": [
    "PITPNM3 259_279_1_0 phospho",
    "PITPNM3 285_291_1_1_S285 phospho",
    "PITPNM3 871_871_1_1_S871 phospho",
    "PITPNM3 890_892_1_1_S892 phospho",
    "PITPNM3 cnv",
    "PITPNM3 proteo",
    "PITPNM3 rna"
  ],
  "PITRM1": [
    "PITRM1 cnv",
    "PITRM1 methyl",
    "PITRM1 proteo",
    "PITRM1 rna"
  ],
  "PITX1": [
    "PITX1 cnv",
    "PITX1 methyl",
    "PITX1 rna"
  ],
  "PITX1-AS1": [
    "PITX1-AS1 methyl"
  ],
  "PITX2": [
    "PITX2 cnv",
    "PITX2 methyl",
    "PITX2 rna"
  ],
  "PITX3": [
    "PITX3 cnv",
    "PITX3 methyl",
    "PITX3 rna"
  ],
  "PIWIL1": [
    "PIWIL1 cnv",
    "PIWIL1 methyl",
    "PIWIL1 rna"
  ],
  "PIWIL2": [
    "PIWIL2 cnv",
    "PIWIL2 methyl",
    "PIWIL2 rna"
  ],
  "PIWIL2-DT": [
    "PIWIL2-DT methyl"
  ],
  "PIWIL3": [
    "PIWIL3 cnv",
    "PIWIL3 rna"
  ],
  "PIWIL4": [
    "PIWIL4 cnv",
    "PIWIL4 methyl",
    "PIWIL4 rna"
  ],
  "PIWIL4-AS1": [
    "PIWIL4-AS1 methyl"
  ],
  "PJA1": [
    "PJA1 13_20_1_1_S15 phospho",
    "PJA1 60_71_1_1_S71 phospho",
    "PJA1 proteo",
    "PJA1 rna"
  ],
  "PJA2": [
    "PJA2 308_309_1_1_S309 phospho",
    "PJA2 323_331_1_0 phospho",
    "PJA2 323_331_1_1_S323 phospho",
    "PJA2 cnv",
    "PJA2 methyl",
    "PJA2 proteo",
    "PJA2 rna"
  ],
  "PJVK": [
    "PJVK cnv",
    "PJVK methyl",
    "PJVK rna"
  ],
  "PKD1": [
    "PKD1 cnv",
    "PKD1 methyl",
    "PKD1 rna"
  ],
  "PKD1-AS1": [
    "PKD1-AS1 methyl"
  ],
  "PKD1L1": [
    "PKD1L1 cnv",
    "PKD1L1 rna"
  ],
  "PKD1L2": [
    "PKD1L2 cnv",
    "PKD1L2 rna"
  ],
  "PKD1L3": [
    "PKD1L3 cnv",
    "PKD1L3 rna"
  ],
  "PKD1P6-NPIPP1": [
    "PKD1P6-NPIPP1 methyl"
  ],
  "PKD2": [
    "PKD2 144_151_1_1_S151 phospho",
    "PKD2 808_824_1_1_S812 phospho",
    "PKD2 829_836_1_1_S829 phospho",
    "PKD2 cnv",
    "PKD2 methyl",
    "PKD2 proteo",
    "PKD2 rna"
  ],
  "PKD2L1": [
    "PKD2L1 cnv",
    "PKD2L1 rna"
  ],
  "PKD2L2": [
    "PKD2L2 cnv",
    "PKD2L2 methyl",
    "PKD2L2 rna"
  ],
  "PKDCC": [
    "PKDCC cnv",
    "PKDCC kinase",
    "PKDCC methyl",
    "PKDCC rna"
  ],
  "PKDREJ": [
    "PKDREJ cnv",
    "PKDREJ methyl",
    "PKDREJ rna"
  ],
  "PKHD1": [
    "PKHD1 cnv",
    "PKHD1 rna"
  ],
  "PKHD1L1": [
    "PKHD1L1 cnv",
    "PKHD1L1 methyl",
    "PKHD1L1 rna"
  ],
  "PKIA": [
    "PKIA cnv",
    "PKIA methyl",
    "PKIA proteo",
    "PKIA rna"
  ],
  "PKIB": [
    "PKIB cnv",
    "PKIB methyl",
    "PKIB proteo",
    "PKIB rna"
  ],
  "PKIG": [
    "PKIG cnv",
    "PKIG proteo",
    "PKIG rna"
  ],
  "PKLR": [
    "PKLR cnv",
    "PKLR proteo",
    "PKLR rna"
  ],
  "PKM": [
    "PKM 195_205_1_1_S202 phospho",
    "PKM 249_249_1_1_S249 phospho",
    "PKM 37_41_1_1_S37 phospho",
    "PKM 513_524_1_1_S519 phospho",
    "PKM 77_87_1_1_S77 phospho",
    "PKM cnv",
    "PKM methyl",
    "PKM proteo",
    "PKM rna"
  ],
  "PKMYT1": [
    "PKMYT1 cnv",
    "PKMYT1 kinase",
    "PKMYT1 methyl",
    "PKMYT1 proteo",
    "PKMYT1 rna"
  ],
  "PKN1": [
    "PKN1 106_126_1_0 phospho",
    "PKN1 527_540_1_1_S533 phospho",
    "PKN1 527_540_1_1_S537 phospho",
    "PKN1 557_562_1_1_S562 phospho",
    "PKN1 566_603_1_0 phospho",
    "PKN1 572_603_1_1_S573 phospho",
    "PKN1 899_916_1_1_S916 phospho",
    "PKN1 cnv",
    "PKN1 kinase",
    "PKN1 methyl",
    "PKN1 proteo",
    "PKN1 rna"
  ],
  "PKN2": [
    "PKN2 110_116_1_1_S110 phospho",
    "PKN2 121_124_1_1_T124 phospho",
    "PKN2 352_364_1_1_S360 phospho",
    "PKN2 352_370_1_1_S367 phospho",
    "PKN2 896_910_1_1_T910 phospho",
    "PKN2 cnv",
    "PKN2 kinase",
    "PKN2 methyl",
    "PKN2 proteo",
    "PKN2 rna"
  ],
  "PKN3": [
    "PKN3 cnv",
    "PKN3 kinase",
    "PKN3 methyl",
    "PKN3 rna"
  ],
  "PKNOX1": [
    "PKNOX1 cnv",
    "PKNOX1 methyl",
    "PKNOX1 proteo",
    "PKNOX1 rna"
  ],
  "PKNOX2": [
    "PKNOX2 cnv",
    "PKNOX2 proteo",
    "PKNOX2 rna"
  ],
  "PKNOX2-DT": [
    "PKNOX2-DT methyl"
  ],
  "PKP1": [
    "PKP1 cnv",
    "PKP1 methyl",
    "PKP1 rna"
  ],
  "PKP2": [
    "PKP2 151_155_1_1_S151 phospho",
    "PKP2 cnv",
    "PKP2 methyl",
    "PKP2 proteo",
    "PKP2 rna"
  ],
  "PKP3": [
    "PKP3 cnv",
    "PKP3 methyl",
    "PKP3 rna"
  ],
  "PKP4": [
    "PKP4 1012_1016_1_0 phospho",
    "PKP4 1012_1016_1_1_T1012 phospho",
    "PKP4 1012_1016_1_1_T1016 phospho",
    "PKP4 1083_1099_1_1_S1090 phospho",
    "PKP4 179_184_1_1_S179 phospho",
    "PKP4 327_337_1_1_S337 phospho",
    "PKP4 327_337_2_2_S327S337 phospho",
    "PKP4 403_415_2_2_S406T412 phospho",
    "PKP4 419_443_1_1_S427 phospho",
    "PKP4 75_84_1_1_S75 phospho",
    "PKP4 cnv",
    "PKP4 methyl",
    "PKP4 proteo",
    "PKP4 rna"
  ],
  "PLA1A": [
    "PLA1A cnv",
    "PLA1A rna"
  ],
  "PLA2G10": [
    "PLA2G10 cnv",
    "PLA2G10 rna"
  ],
  "PLA2G12A": [
    "PLA2G12A cnv",
    "PLA2G12A methyl",
    "PLA2G12A proteo",
    "PLA2G12A rna"
  ],
  "PLA2G12B": [
    "PLA2G12B cnv",
    "PLA2G12B rna"
  ],
  "PLA2G15": [
    "PLA2G15 VFVQTPTINYTLR-N2H5F0S0G0 glyco",
    "PLA2G15 VFVQTPTINYTLR-N2H6F0S0G0 glyco",
    "PLA2G15 cnv",
    "PLA2G15 methyl",
    "PLA2G15 proteo",
    "PLA2G15 rna"
  ],
  "PLA2G1B": [
    "PLA2G1B cnv",
    "PLA2G1B rna"
  ],
  "PLA2G2A": [
    "PLA2G2A cnv",
    "PLA2G2A rna"
  ],
  "PLA2G2C": [
    "PLA2G2C cnv",
    "PLA2G2C rna"
  ],
  "PLA2G2D": [
    "PLA2G2D cnv",
    "PLA2G2D rna"
  ],
  "PLA2G2E": [
    "PLA2G2E cnv"
  ],
  "PLA2G2F": [
    "PLA2G2F cnv",
    "PLA2G2F rna"
  ],
  "PLA2G3": [
    "PLA2G3 cnv",
    "PLA2G3 rna"
  ],
  "PLA2G4A": [
    "PLA2G4A 371_381_1_1_S377 phospho",
    "PLA2G4A 664_671_1_1_S667 phospho",
    "PLA2G4A cnv",
    "PLA2G4A proteo",
    "PLA2G4A rna"
  ],
  "PLA2G4B": [
    "PLA2G4B cnv",
    "PLA2G4B rna"
  ],
  "PLA2G4C": [
    "PLA2G4C 347_349_1_1_S347 phospho",
    "PLA2G4C cnv",
    "PLA2G4C proteo",
    "PLA2G4C rna"
  ],
  "PLA2G4D": [
    "PLA2G4D cnv",
    "PLA2G4D rna"
  ],
  "PLA2G4E": [
    "PLA2G4E cnv",
    "PLA2G4E rna"
  ],
  "PLA2G4E-AS1": [
    "PLA2G4E-AS1 methyl"
  ],
  "PLA2G4F": [
    "PLA2G4F cnv",
    "PLA2G4F rna"
  ],
  "PLA2G5": [
    "PLA2G5 cnv",
    "PLA2G5 rna"
  ],
  "PLA2G6": [
    "PLA2G6 cnv",
    "PLA2G6 methyl",
    "PLA2G6 proteo",
    "PLA2G6 rna"
  ],
  "PLA2G7": [
    "PLA2G7 cnv",
    "PLA2G7 methyl",
    "PLA2G7 rna"
  ],
  "PLA2R1": [
    "PLA2R1 cnv",
    "PLA2R1 methyl",
    "PLA2R1 rna"
  ],
  "PLAA": [
    "PLAA 477_495_1_0 phospho",
    "PLAA cnv",
    "PLAA methyl",
    "PLAA proteo",
    "PLAA rna"
  ],
  "PLAAT1": [
    "PLAAT1 cnv",
    "PLAAT1 methyl",
    "PLAAT1 rna"
  ],
  "PLAAT2": [
    "PLAAT2 cnv",
    "PLAAT2 rna"
  ],
  "PLAAT3": [
    "PLAAT3 cnv",
    "PLAAT3 methyl",
    "PLAAT3 proteo",
    "PLAAT3 rna"
  ],
  "PLAAT4": [
    "PLAAT4 cnv",
    "PLAAT4 rna"
  ],
  "PLAAT5": [
    "PLAAT5 cnv",
    "PLAAT5 methyl",
    "PLAAT5 rna"
  ],
  "PLAC1": [
    "PLAC1 rna"
  ],
  "PLAC8": [
    "PLAC8 cnv",
    "PLAC8 methyl",
    "PLAC8 rna"
  ],
  "PLAC8L1": [
    "PLAC8L1 cnv",
    "PLAC8L1 rna"
  ],
  "PLAC9": [
    "PLAC9 cnv",
    "PLAC9 methyl",
    "PLAC9 proteo",
    "PLAC9 rna"
  ],
  "PLAC9P1": [
    "PLAC9P1 methyl"
  ],
  "PLAG1": [
    "PLAG1 cnv",
    "PLAG1 methyl",
    "PLAG1 rna"
  ],
  "PLAGL1": [
    "PLAGL1 cnv",
    "PLAGL1 methyl",
    "PLAGL1 rna"
  ],
  "PLAGL2": [
    "PLAGL2 cnv",
    "PLAGL2 methyl",
    "PLAGL2 rna"
  ],
  "PLAT": [
    "PLAT cnv",
    "PLAT proteo",
    "PLAT rna"
  ],
  "PLAU": [
    "PLAU cnv",
    "PLAU methyl",
    "PLAU rna"
  ],
  "PLAUR": [
    "PLAUR cnv",
    "PLAUR methyl",
    "PLAUR proteo",
    "PLAUR rna"
  ],
  "PLB1": [
    "PLB1 cnv",
    "PLB1 rna"
  ],
  "PLBD1": [
    "PLBD1 IYNWSGYPLLVQK-N2H8F0S0G0 glyco",
    "PLBD1 IYNWSGYPLLVQK-N2H9F0S0G0 glyco",
    "PLBD1 NGDAYGFYNNSVK-N2H5F0S0G0 glyco",
    "PLBD1 NGDAYGFYNNSVK-N2H6F0S0G0 glyco",
    "PLBD1 NGDAYGFYNNSVK-N2H7F0S0G0 glyco",
    "PLBD1 cnv",
    "PLBD1 methyl",
    "PLBD1 proteo",
    "PLBD1 rna"
  ],
  "PLBD2": [
    "PLBD2 HPDAVAWANLTNAIR-N2H6F0S0G0 glyco",
    "PLBD2 SDLNPANGSYPFQALR-N2H3F1S0G0 glyco",
    "PLBD2 SDLNPANGSYPFQALR-N2H5F1S0G0 glyco",
    "PLBD2 cnv",
    "PLBD2 methyl",
    "PLBD2 proteo",
    "PLBD2 rna"
  ],
  "PLCB1": [
    "PLCB1 1145_1164_1_0 phospho",
    "PLCB1 1197_1200_1_1_S1199 phospho",
    "PLCB1 978_1002_1_0 phospho",
    "PLCB1 978_1002_1_1_S982 phospho",
    "PLCB1 cnv",
    "PLCB1 methyl",
    "PLCB1 proteo",
    "PLCB1 rna"
  ],
  "PLCB2": [
    "PLCB2 954_960_1_1_S954 phospho",
    "PLCB2 cnv",
    "PLCB2 methyl",
    "PLCB2 proteo",
    "PLCB2 rna"
  ],
  "PLCB3": [
    "PLCB3 1105_1107_1_1_S1105 phospho",
    "PLCB3 537_537_1_1_S537 phospho",
    "PLCB3 cnv",
    "PLCB3 methyl",
    "PLCB3 proteo",
    "PLCB3 rna"
  ],
  "PLCB4": [
    "PLCB4 cnv",
    "PLCB4 methyl",
    "PLCB4 proteo",
    "PLCB4 rna"
  ],
  "PLCD1": [
    "PLCD1 153_155_1_1_S155 phospho",
    "PLCD1 168_168_1_1_S168 phospho",
    "PLCD1 212_226_1_1_S216 phospho",
    "PLCD1 478_481_1_0 phospho",
    "PLCD1 478_481_1_1_S481 phospho",
    "PLCD1 671_671_1_1_S671 phospho",
    "PLCD1 cnv",
    "PLCD1 methyl",
    "PLCD1 proteo",
    "PLCD1 rna"
  ],
  "PLCD3": [
    "PLCD3 105_105_1_1_S105 phospho",
    "PLCD3 34_43_1_1_T37 phospho",
    "PLCD3 496_496_1_1_S496 phospho",
    "PLCD3 cnv",
    "PLCD3 methyl",
    "PLCD3 proteo",
    "PLCD3 rna"
  ],
  "PLCD4": [
    "PLCD4 cnv",
    "PLCD4 proteo",
    "PLCD4 rna"
  ],
  "PLCE1": [
    "PLCE1 1060_1064_1_1_S1060 phospho",
    "PLCE1 cnv",
    "PLCE1 methyl",
    "PLCE1 proteo",
    "PLCE1 rna"
  ],
  "PLCG1": [
    "PLCG1 1222_1228_1_1_S1228 phospho",
    "PLCG1 1234_1237_2_2_S1234S1237 phospho",
    "PLCG1 cnv",
    "PLCG1 methyl",
    "PLCG1 proteo",
    "PLCG1 rna"
  ],
  "PLCG2": [
    "PLCG2 cnv",
    "PLCG2 methyl",
    "PLCG2 proteo",
    "PLCG2 rna"
  ],
  "PLCH1": [
    "PLCH1 cnv",
    "PLCH1 rna"
  ],
  "PLCH2": [
    "PLCH2 568_583_1_1_S568 phospho",
    "PLCH2 cnv",
    "PLCH2 methyl",
    "PLCH2 rna"
  ],
  "PLCL1": [
    "PLCL1 546_565_1_1_T556 phospho",
    "PLCL1 569_572_1_1_S569 phospho",
    "PLCL1 76_83_1_1_S77 phospho",
    "PLCL1 93_101_1_1_S95 phospho",
    "PLCL1 93_101_2_2_T93S95 phospho",
    "PLCL1 cnv",
    "PLCL1 methyl",
    "PLCL1 proteo",
    "PLCL1 rna"
  ],
  "PLCL2": [
    "PLCL2 105_112_1_1_S106 phospho",
    "PLCL2 1113_1113_1_1_S1113 phospho",
    "PLCL2 121_129_1_1_S123 phospho",
    "PLCL2 573_593_1_1_T584 phospho",
    "PLCL2 cnv",
    "PLCL2 methyl",
    "PLCL2 proteo",
    "PLCL2 rna"
  ],
  "PLCXD1": [
    "PLCXD1 rna"
  ],
  "PLCXD2": [
    "PLCXD2 cnv",
    "PLCXD2 methyl",
    "PLCXD2 rna"
  ],
  "PLCXD3": [
    "PLCXD3 cnv",
    "PLCXD3 methyl",
    "PLCXD3 proteo",
    "PLCXD3 rna"
  ],
  "PLCZ1": [
    "PLCZ1 cnv",
    "PLCZ1 rna"
  ],
  "PLD1": [
    "PLD1 cnv",
    "PLD1 methyl",
    "PLD1 proteo",
    "PLD1 rna"
  ],
  "PLD2": [
    "PLD2 cnv",
    "PLD2 methyl",
    "PLD2 proteo",
    "PLD2 rna"
  ],
  "PLD3": [
    "PLD3 AFLLSLAALRDNHTHSDIQVK-N2H3F1S0G0 glyco",
    "PLD3 DNHTHSDIQVK-N2H3F1S0G0 glyco",
    "PLD3 DNHTHSDIQVK-N2H8F0S0G0 glyco",
    "PLD3 ELGVVMYNCSCLAR-N2H3F0S0G0 glyco",
    "PLD3 ELGVVMYNCSCLAR-N2H3F1S0G0 glyco",
    "PLD3 ELGVVMYNCSCLAR-N2H4F0S0G0 glyco",
    "PLD3 ELGVVMYNCSCLAR-N2H4F1S0G0 glyco",
    "PLD3 ELGVVMYNCSCLAR-N2H5F0S0G0 glyco",
    "PLD3 ELGVVMYNCSCLAR-N2H9F0S0G0 glyco",
    "PLD3 cnv",
    "PLD3 methyl",
    "PLD3 proteo",
    "PLD3 rna"
  ],
  "PLD4": [
    "PLD4 NISLAVATSSPTLAR-N2H3F1S0G0 glyco",
    "PLD4 cnv",
    "PLD4 methyl",
    "PLD4 proteo",
    "PLD4 rna"
  ],
  "PLD5": [
    "PLD5 cnv",
    "PLD5 methyl",
    "PLD5 rna"
  ],
  "PLD5P1": [
    "PLD5P1 cnv",
    "PLD5P1 rna"
  ],
  "PLD6": [
    "PLD6 cnv",
    "PLD6 methyl",
    "PLD6 rna"
  ],
  "PLEC": [
    "PLEC 113_125_1_1_S125 phospho",
    "PLEC 12_28_1_0 phospho",
    "PLEC 12_28_1_1_S22 phospho",
    "PLEC 1325_1325_1_1_S1325 phospho",
    "PLEC 149_159_1_1_S149 phospho",
    "PLEC 1611_1611_1_1_S1611 phospho",
    "PLEC 1616_1622_1_1_S1622 phospho",
    "PLEC 19_26_1_1_S21 phospho",
    "PLEC 2468_2468_1_1_S2468 phospho",
    "PLEC 2776_2776_1_1_T2776 phospho",
    "PLEC 3675_3675_1_1_T3675 phospho",
    "PLEC 4253_4272_1_1_S4272 phospho",
    "PLEC 4272_4290_1_0 phospho",
    "PLEC 4274_4290_1_0 phospho",
    "PLEC 4274_4290_1_1_S4276 phospho",
    "PLEC 4274_4290_2_2_S4276S4286 phospho",
    "PLEC 4501_4516_1_1_S4503 phospho",
    "PLEC 4501_4516_1_1_S4508 phospho",
    "PLEC 4501_4516_1_1_S4516 phospho",
    "PLEC 4501_4516_1_1_T4513 phospho",
    "PLEC 4501_4516_2_0 phospho",
    "PLEC 4501_4516_2_2_S4510S4512 phospho",
    "PLEC 4532_4554_1_1_S4532 phospho",
    "PLEC 4558_4571_1_1_S4562 phospho",
    "PLEC 4558_4571_1_1_S4565 phospho",
    "PLEC cnv",
    "PLEC methyl",
    "PLEC proteo",
    "PLEC rna"
  ],
  "PLEK": [
    "PLEK 117_132_1_0 phospho",
    "PLEK 117_132_1_1_S117 phospho",
    "PLEK cnv",
    "PLEK proteo",
    "PLEK rna"
  ],
  "PLEK2": [
    "PLEK2 cnv",
    "PLEK2 methyl",
    "PLEK2 rna"
  ],
  "PLEKHA1": [
    "PLEKHA1 308_308_1_1_S308 phospho",
    "PLEKHA1 372_375_1_1_S375 phospho",
    "PLEKHA1 cnv",
    "PLEKHA1 methyl",
    "PLEKHA1 proteo",
    "PLEKHA1 rna"
  ],
  "PLEKHA2": [
    "PLEKHA2 349_358_1_1_S349 phospho",
    "PLEKHA2 401_401_1_1_S401 phospho",
    "PLEKHA2 cnv",
    "PLEKHA2 methyl",
    "PLEKHA2 proteo",
    "PLEKHA2 rna"
  ],
  "PLEKHA3": [
    "PLEKHA3 242_264_1_1_S244 phospho",
    "PLEKHA3 289_300_1_1_S289 phospho",
    "PLEKHA3 cnv",
    "PLEKHA3 methyl",
    "PLEKHA3 proteo",
    "PLEKHA3 rna"
  ],
  "PLEKHA4": [
    "PLEKHA4 211_220_1_1_S213 phospho",
    "PLEKHA4 229_244_1_1_S241 phospho",
    "PLEKHA4 575_580_1_1_S575 phospho",
    "PLEKHA4 cnv",
    "PLEKHA4 proteo",
    "PLEKHA4 rna"
  ],
  "PLEKHA5": [
    "PLEKHA5 1146_1169_1_1_S1150 phospho",
    "PLEKHA5 120_140_1_1_S140 phospho",
    "PLEKHA5 454_460_1_1_T460 phospho",
    "PLEKHA5 522_526_1_1_S526 phospho",
    "PLEKHA5 55_67_1_1_S55 phospho",
    "PLEKHA5 596_610_1_1_S607 phospho",
    "PLEKHA5 865_880_1_1_S867 phospho",
    "PLEKHA5 867_880_1_1_S880 phospho",
    "PLEKHA5 913_926_1_1_S913 phospho",
    "PLEKHA5 988_997_1_1_S991 phospho",
    "PLEKHA5 988_997_2_2_S991S995 phospho",
    "PLEKHA5 cnv",
    "PLEKHA5 methyl",
    "PLEKHA5 proteo",
    "PLEKHA5 rna"
  ],
  "PLEKHA6": [
    "PLEKHA6 1010_1036_1_1_S1017 phospho",
    "PLEKHA6 313_314_1_1_S314 phospho",
    "PLEKHA6 433_443_1_1_S443 phospho",
    "PLEKHA6 775_786_1_1_S777 phospho",
    "PLEKHA6 808_808_1_1_S808 phospho",
    "PLEKHA6 842_854_1_1_S842 phospho",
    "PLEKHA6 842_859_1_1_S842 phospho",
    "PLEKHA6 867_874_1_1_S867 phospho",
    "PLEKHA6 cnv",
    "PLEKHA6 methyl",
    "PLEKHA6 proteo",
    "PLEKHA6 rna"
  ],
  "PLEKHA7": [
    "PLEKHA7 363_379_1_1_S363 phospho",
    "PLEKHA7 536_549_1_1_S536 phospho",
    "PLEKHA7 843_875_2_1_S867 phospho",
    "PLEKHA7 843_875_2_2_S867S871 phospho",
    "PLEKHA7 902_909_1_1_S903 phospho",
    "PLEKHA7 902_909_2_2_S903S907 phospho",
    "PLEKHA7 cnv",
    "PLEKHA7 methyl",
    "PLEKHA7 proteo",
    "PLEKHA7 rna"
  ],
  "PLEKHA8": [
    "PLEKHA8 cnv",
    "PLEKHA8 methyl",
    "PLEKHA8 rna"
  ],
  "PLEKHA8P1": [
    "PLEKHA8P1 methyl"
  ],
  "PLEKHB1": [
    "PLEKHB1 cnv",
    "PLEKHB1 proteo",
    "PLEKHB1 rna"
  ],
  "PLEKHB2": [
    "PLEKHB2 cnv",
    "PLEKHB2 methyl",
    "PLEKHB2 rna"
  ],
  "PLEKHD1": [
    "PLEKHD1 cnv",
    "PLEKHD1 methyl",
    "PLEKHD1 rna"
  ],
  "PLEKHF1": [
    "PLEKHF1 227_227_1_1_S227 phospho",
    "PLEKHF1 cnv",
    "PLEKHF1 methyl",
    "PLEKHF1 proteo",
    "PLEKHF1 rna"
  ],
  "PLEKHF2": [
    "PLEKHF2 16_30_1_1_S16 phospho",
    "PLEKHF2 cnv",
    "PLEKHF2 methyl",
    "PLEKHF2 proteo",
    "PLEKHF2 rna"
  ],
  "PLEKHG1": [
    "PLEKHG1 101_108_1_1_S108 phospho",
    "PLEKHG1 1150_1152_1_1_S1152 phospho",
    "PLEKHG1 1168_1173_1_1_S1171 phospho",
    "PLEKHG1 597_612_1_1_S597 phospho",
    "PLEKHG1 cnv",
    "PLEKHG1 proteo",
    "PLEKHG1 rna"
  ],
  "PLEKHG2": [
    "PLEKHG2 1047_1056_1_1_S1049 phospho",
    "PLEKHG2 1317_1318_1_1_S1318 phospho",
    "PLEKHG2 466_473_1_1_T466 phospho",
    "PLEKHG2 482_482_1_1_S482 phospho",
    "PLEKHG2 482_489_1_1_S482 phospho",
    "PLEKHG2 cnv",
    "PLEKHG2 methyl",
    "PLEKHG2 proteo",
    "PLEKHG2 rna"
  ],
  "PLEKHG3": [
    "PLEKHG3 1079_1092_1_1_S1081 phospho",
    "PLEKHG3 432_439_1_1_S433 phospho",
    "PLEKHG3 617_624_1_1_S618 phospho",
    "PLEKHG3 638_647_1_1_S640 phospho",
    "PLEKHG3 741_744_1_1_S741 phospho",
    "PLEKHG3 cnv",
    "PLEKHG3 methyl",
    "PLEKHG3 proteo",
    "PLEKHG3 rna"
  ],
  "PLEKHG4": [
    "PLEKHG4 cnv",
    "PLEKHG4 methyl",
    "PLEKHG4 rna"
  ],
  "PLEKHG4B": [
    "PLEKHG4B cnv",
    "PLEKHG4B methyl",
    "PLEKHG4B rna"
  ],
  "PLEKHG5": [
    "PLEKHG5 249_249_1_1_S249 phospho",
    "PLEKHG5 cnv",
    "PLEKHG5 methyl",
    "PLEKHG5 rna"
  ],
  "PLEKHG6": [
    "PLEKHG6 cnv",
    "PLEKHG6 methyl",
    "PLEKHG6 rna"
  ],
  "PLEKHG7": [
    "PLEKHG7 cnv",
    "PLEKHG7 rna"
  ],
  "PLEKHH1": [
    "PLEKHH1 cnv",
    "PLEKHH1 methyl",
    "PLEKHH1 rna"
  ],
  "PLEKHH2": [
    "PLEKHH2 cnv",
    "PLEKHH2 methyl",
    "PLEKHH2 rna"
  ],
  "PLEKHH3": [
    "PLEKHH3 cnv",
    "PLEKHH3 methyl",
    "PLEKHH3 rna"
  ],
  "PLEKHJ1": [
    "PLEKHJ1 cnv",
    "PLEKHJ1 methyl",
    "PLEKHJ1 proteo",
    "PLEKHJ1 rna"
  ],
  "PLEKHM1": [
    "PLEKHM1 cnv",
    "PLEKHM1 methyl",
    "PLEKHM1 proteo",
    "PLEKHM1 rna"
  ],
  "PLEKHM2": [
    "PLEKHM2 250_258_1_1_S253 phospho",
    "PLEKHM2 327_341_1_1_S327 phospho",
    "PLEKHM2 327_341_1_1_S329 phospho",
    "PLEKHM2 329_341_1_1_S341 phospho",
    "PLEKHM2 439_465_1_0 phospho",
    "PLEKHM2 439_465_1_1_S441 phospho",
    "PLEKHM2 cnv",
    "PLEKHM2 methyl",
    "PLEKHM2 proteo",
    "PLEKHM2 rna"
  ],
  "PLEKHM3": [
    "PLEKHM3 150_155_1_1_S152 phospho",
    "PLEKHM3 cnv",
    "PLEKHM3 methyl",
    "PLEKHM3 rna"
  ],
  "PLEKHN1": [
    "PLEKHN1 cnv",
    "PLEKHN1 methyl",
    "PLEKHN1 rna"
  ],
  "PLEKHO1": [
    "PLEKHO1 342_355_1_1_S342 phospho",
    "PLEKHO1 cnv",
    "PLEKHO1 methyl",
    "PLEKHO1 proteo",
    "PLEKHO1 rna"
  ],
  "PLEKHO2": [
    "PLEKHO2 311_311_1_1_T311 phospho",
    "PLEKHO2 324_364_1_1_T364 phospho",
    "PLEKHO2 356_364_1_1_T364 phospho",
    "PLEKHO2 389_390_1_1_S390 phospho",
    "PLEKHO2 cnv",
    "PLEKHO2 methyl",
    "PLEKHO2 proteo",
    "PLEKHO2 rna"
  ],
  "PLEKHS1": [
    "PLEKHS1 cnv",
    "PLEKHS1 rna"
  ],
  "PLET1": [
    "PLET1 cnv",
    "PLET1 rna"
  ],
  "PLG": [
    "PLG 45_45_1_1_S45 phospho",
    "PLG 741_760_1_0 phospho",
    "PLG cnv",
    "PLG proteo",
    "PLG rna"
  ],
  "PLGLB1": [
    "PLGLB1 cnv",
    "PLGLB1 rna"
  ],
  "PLGLB2": [
    "PLGLB2 cnv",
    "PLGLB2 rna"
  ],
  "PLGRKT": [
    "PLGRKT cnv",
    "PLGRKT methyl",
    "PLGRKT proteo",
    "PLGRKT rna"
  ],
  "PLIN1": [
    "PLIN1 cnv",
    "PLIN1 rna"
  ],
  "PLIN2": [
    "PLIN2 cnv",
    "PLIN2 methyl",
    "PLIN2 proteo",
    "PLIN2 rna"
  ],
  "PLIN3": [
    "PLIN3 126_138_1_1_S130 phospho",
    "PLIN3 216_225_1_1_S217 phospho",
    "PLIN3 31_49_1_0 phospho",
    "PLIN3 31_49_1_1_S31 phospho",
    "PLIN3 cnv",
    "PLIN3 proteo",
    "PLIN3 rna"
  ],
  "PLIN4": [
    "PLIN4 cnv",
    "PLIN4 proteo",
    "PLIN4 rna"
  ],
  "PLIN5": [
    "PLIN5 cnv",
    "PLIN5 methyl",
    "PLIN5 rna"
  ],
  "PLK1": [
    "PLK1 cnv",
    "PLK1 kinase",
    "PLK1 methyl",
    "PLK1 rna"
  ],
  "PLK2": [
    "PLK2 cnv",
    "PLK2 kinase",
    "PLK2 methyl",
    "PLK2 rna"
  ],
  "PLK3": [
    "PLK3 cnv",
    "PLK3 kinase",
    "PLK3 methyl",
    "PLK3 rna"
  ],
  "PLK4": [
    "PLK4 cnv",
    "PLK4 kinase",
    "PLK4 methyl",
    "PLK4 rna"
  ],
  "PLK5": [
    "PLK5 cnv",
    "PLK5 kinase",
    "PLK5 methyl",
    "PLK5 rna"
  ],
  "PLLP": [
    "PLLP cnv",
    "PLLP methyl",
    "PLLP proteo",
    "PLLP rna"
  ],
  "PLN": [
    "PLN 16_17_1_1_S16 phospho",
    "PLN cnv",
    "PLN rna"
  ],
  "PLOD1": [
    "PLOD1 EQINITLDHR-N2H5F0S0G0 glyco",
    "PLOD1 EQINITLDHR-N2H6F0S0G0 glyco",
    "PLOD1 EQINITLDHR-N2H7F0S0G0 glyco",
    "PLOD1 YIHQNYTK-N2H4F0S0G0 glyco",
    "PLOD1 YIHQNYTK-N2H5F0S0G0 glyco",
    "PLOD1 YIHQNYTK-N2H6F0S0G0 glyco",
    "PLOD1 YIHQNYTK-N2H7F0S0G0 glyco",
    "PLOD1 YIHQNYTK-N2H8F0S0G0 glyco",
    "PLOD1 YIHQNYTK-N2H9F0S0G0 glyco",
    "PLOD1 cnv",
    "PLOD1 proteo",
    "PLOD1 rna"
  ],
  "PLOD2": [
    "PLOD2 EAINITLDHK-N2H7F0S0G0 glyco",
    "PLOD2 EAINITLDHK-N2H8F0S0G0 glyco",
    "PLOD2 REAINITLDHK-N2H8F0S0G0 glyco",
    "PLOD2 YFNYTVK-N2H6F0S0G0 glyco",
    "PLOD2 YFNYTVK-N2H7F0S0G0 glyco",
    "PLOD2 YFNYTVK-N2H8F0S0G0 glyco",
    "PLOD2 cnv",
    "PLOD2 methyl",
    "PLOD2 proteo",
    "PLOD2 rna"
  ],
  "PLOD3": [
    "PLOD3 EQYIHENYSR-N2H4F0S0G0 glyco",
    "PLOD3 EQYIHENYSR-N2H5F0S0G0 glyco",
    "PLOD3 EQYIHENYSR-N2H6F0S0G0 glyco",
    "PLOD3 EQYIHENYSR-N2H8F0S0G0 glyco",
    "PLOD3 SAEFFNYTVR-N2H4F0S0G0 glyco",
    "PLOD3 SAEFFNYTVR-N2H5F0S0G0 glyco",
    "PLOD3 SAEFFNYTVR-N2H6F0S0G0 glyco",
    "PLOD3 SAEFFNYTVR-N2H7F0S0G0 glyco",
    "PLOD3 SAEFFNYTVR-N2H8F0S0G0 glyco",
    "PLOD3 cnv",
    "PLOD3 methyl",
    "PLOD3 proteo",
    "PLOD3 rna"
  ],
  "PLP1": [
    "PLP1 114_118_1_1_T116 phospho",
    "PLP1 134_134_1_1_S134 phospho",
    "PLP1 193_199_1_1_S194 phospho",
    "PLP1 proteo",
    "PLP1 rna"
  ],
  "PLP2": [
    "PLP2 methyl",
    "PLP2 proteo",
    "PLP2 rna"
  ],
  "PLPBP": [
    "PLPBP cnv",
    "PLPBP methyl",
    "PLPBP proteo",
    "PLPBP rna"
  ],
  "PLPP1": [
    "PLPP1 264_280_1_1_T271 phospho",
    "PLPP1 cnv",
    "PLPP1 methyl",
    "PLPP1 rna"
  ],
  "PLPP2": [
    "PLPP2 cnv",
    "PLPP2 methyl",
    "PLPP2 rna"
  ],
  "PLPP3": [
    "PLPP3 19_19_1_1_S19 phospho",
    "PLPP3 cnv",
    "PLPP3 methyl",
    "PLPP3 proteo",
    "PLPP3 rna"
  ],
  "PLPP4": [
    "PLPP4 cnv",
    "PLPP4 methyl",
    "PLPP4 rna"
  ],
  "PLPP5": [
    "PLPP5 cnv",
    "PLPP5 methyl",
    "PLPP5 rna"
  ],
  "PLPP6": [
    "PLPP6 cnv",
    "PLPP6 methyl",
    "PLPP6 proteo",
    "PLPP6 rna"
  ],
  "PLPP7": [
    "PLPP7 43_46_1_1_S43 phospho",
    "PLPP7 62_76_1_1_S62 phospho",
    "PLPP7 cnv",
    "PLPP7 rna"
  ],
  "PLPPR1": [
    "PLPPR1 307_325_1_0 phospho",
    "PLPPR1 cnv",
    "PLPPR1 methyl",
    "PLPPR1 rna"
  ],
  "PLPPR2": [
    "PLPPR2 330_334_1_1_S330 phospho",
    "PLPPR2 cnv",
    "PLPPR2 rna"
  ],
  "PLPPR3": [
    "PLPPR3 428_428_1_1_S428 phospho",
    "PLPPR3 503_508_1_1_S508 phospho",
    "PLPPR3 cnv",
    "PLPPR3 methyl",
    "PLPPR3 proteo",
    "PLPPR3 rna"
  ],
  "PLPPR4": [
    "PLPPR4 288_290_1_1_S288 phospho",
    "PLPPR4 403_414_1_1_S403 phospho",
    "PLPPR4 403_414_1_1_S414 phospho",
    "PLPPR4 465_489_1_1_S489 phospho",
    "PLPPR4 472_489_1_1_S489 phospho",
    "PLPPR4 533_534_1_1_S534 phospho",
    "PLPPR4 cnv",
    "PLPPR4 proteo",
    "PLPPR4 rna"
  ],
  "PLPPR5": [
    "PLPPR5 cnv",
    "PLPPR5 methyl",
    "PLPPR5 rna"
  ],
  "PLRG1": [
    "PLRG1 cnv",
    "PLRG1 methyl",
    "PLRG1 proteo",
    "PLRG1 rna"
  ],
  "PLS1": [
    "PLS1 cnv",
    "PLS1 methyl",
    "PLS1 proteo",
    "PLS1 rna"
  ],
  "PLS3": [
    "PLS3 339_339_1_1_S339 phospho",
    "PLS3 methyl",
    "PLS3 proteo",
    "PLS3 rna"
  ],
  "PLSCR1": [
    "PLSCR1 cnv",
    "PLSCR1 methyl",
    "PLSCR1 proteo",
    "PLSCR1 rna"
  ],
  "PLSCR2": [
    "PLSCR2 cnv",
    "PLSCR2 methyl",
    "PLSCR2 rna"
  ],
  "PLSCR3": [
    "PLSCR3 cnv",
    "PLSCR3 methyl",
    "PLSCR3 proteo",
    "PLSCR3 rna"
  ],
  "PLSCR4": [
    "PLSCR4 cnv",
    "PLSCR4 methyl",
    "PLSCR4 proteo",
    "PLSCR4 rna"
  ],
  "PLSCR5": [
    "PLSCR5 cnv",
    "PLSCR5 rna"
  ],
  "PLTP": [
    "PLTP EGHFYYNISEVK-N2H5F0S0G0 glyco",
    "PLTP EGHFYYNISEVK-N4H5F1S1G0 glyco",
    "PLTP EGHFYYNISEVK-N5H6F1S1G0 glyco",
    "PLTP cnv",
    "PLTP methyl",
    "PLTP proteo",
    "PLTP rna"
  ],
  "PLVAP": [
    "PLVAP cnv",
    "PLVAP proteo",
    "PLVAP rna"
  ],
  "PLXDC1": [
    "PLXDC1 cnv",
    "PLXDC1 methyl",
    "PLXDC1 proteo",
    "PLXDC1 rna"
  ],
  "PLXDC2": [
    "PLXDC2 457_462_1_1_S457 phospho",
    "PLXDC2 457_477_1_1_S457 phospho",
    "PLXDC2 cnv",
    "PLXDC2 methyl",
    "PLXDC2 proteo",
    "PLXDC2 rna"
  ],
  "PLXNA1": [
    "PLXNA1 ENGCLVYNDTTMVCR-N2H5F0S0G0 glyco",
    "PLXNA1 cnv",
    "PLXNA1 methyl",
    "PLXNA1 proteo",
    "PLXNA1 rna"
  ],
  "PLXNA2": [
    "PLXNA2 EHYLSSVNK-N2H5F0S0G0 glyco",
    "PLXNA2 EHYLSSVNK-N2H6F0S0G0 glyco",
    "PLXNA2 LTGNLTIQVAHK-N5H3F1S0G0 glyco",
    "PLXNA2 cnv",
    "PLXNA2 methyl",
    "PLXNA2 proteo",
    "PLXNA2 rna"
  ],
  "PLXNA3": [
    "PLXNA3 methyl",
    "PLXNA3 proteo",
    "PLXNA3 rna"
  ],
  "PLXNA4": [
    "PLXNA4 NHSLAFVGTK-N2H5F0S0G0 glyco",
    "PLXNA4 SPSYIVCNTTSSDEVLEMK-N2H5F0S0G0 glyco",
    "PLXNA4 SPSYIVCNTTSSDEVLEMK-N2H6F0S0G0 glyco",
    "PLXNA4 cnv",
    "PLXNA4 methyl",
    "PLXNA4 proteo",
    "PLXNA4 rna"
  ],
  "PLXNB1": [
    "PLXNB1 1534_1535_1_1_S1535 phospho",
    "PLXNB1 LTLNGSK-N5H3F1S0G0 glyco",
    "PLXNB1 YTLDPNITSAGPTK-N4H5F2S1G0 glyco",
    "PLXNB1 YTLDPNITSAGPTK-N5H3F1S0G0 glyco",
    "PLXNB1 YTLDPNITSAGPTK-N5H4F2S0G0 glyco",
    "PLXNB1 cnv",
    "PLXNB1 methyl",
    "PLXNB1 proteo",
    "PLXNB1 rna"
  ],
  "PLXNB2": [
    "PLXNB2 1564_1570_1_1_S1570 phospho",
    "PLXNB2 EAESLQPMTVVGTDYVFHNDTK-N2H5F0S0G0 glyco",
    "PLXNB2 LHVTLYNCSFGR-N2H5F0S0G0 glyco",
    "PLXNB2 LHVTLYNCSFGR-N2H6F0S0G0 glyco",
    "PLXNB2 LSHDANETLPLHLYVK-N2H5F0S0G0 glyco",
    "PLXNB2 LSHDANETLPLHLYVK-N4H5F1S0G0 glyco",
    "PLXNB2 LSHDANETLPLHLYVK-N4H5F1S1G0 glyco",
    "PLXNB2 LSHDANETLPLHLYVK-N4H5F2S0G0 glyco",
    "PLXNB2 LSHDANETLPLHLYVK-N4H5F2S1G0 glyco",
    "PLXNB2 SCVAVTSAQPQNMSR-N2H5F0S0G0 glyco",
    "PLXNB2 SCVAVTSAQPQNMSR-N3H3F0S0G0 glyco",
    "PLXNB2 SCVAVTSAQPQNMSR-N5H3F0S0G0 glyco",
    "PLXNB2 SINVTGQGFSLIQR-N2H5F0S0G0 glyco",
    "PLXNB2 SINVTGQGFSLIQR-N2H6F0S0G0 glyco",
    "PLXNB2 SINVTGQGFSLIQR-N2H7F0S0G0 glyco",
    "PLXNB2 SINVTGQGFSLIQR-N2H8F0S0G0 glyco",
    "PLXNB2 SINVTGQGFSLIQR-N2H9F0S0G0 glyco",
    "PLXNB2 TEAGAFEYVPDPTFENFTGGVK-N3H5F2S0G0 glyco",
    "PLXNB2 TEAGAFEYVPDPTFENFTGGVK-N4H5F1S1G0 glyco",
    "PLXNB2 cnv",
    "PLXNB2 methyl",
    "PLXNB2 proteo",
    "PLXNB2 rna"
  ],
  "PLXNB3": [
    "PLXNB3 1603_1620_1_1_S1612 phospho",
    "PLXNB3 LVVGDFSDYNNSYVGAFADAR-N2H5F0S0G0 glyco",
    "PLXNB3 methyl",
    "PLXNB3 proteo",
    "PLXNB3 rna"
  ],
  "PLXNC1": [
    "PLXNC1 978_986_1_1_S978 phospho",
    "PLXNC1 ASNITMILK-N2H5F0S0G0 glyco",
    "PLXNC1 DVIQVSHVLNDTHMK-N2H8F0S0G0 glyco",
    "PLXNC1 SNVIVTGANFTR-N2H5F0S0G0 glyco",
    "PLXNC1 TASTIANSSK-N2H6F0S0G0 glyco",
    "PLXNC1 TASTIANSSK-N2H7F0S0G0 glyco",
    "PLXNC1 TASTIANSSK-N2H8F0S0G0 glyco",
    "PLXNC1 VILGENLTSNCPEVIYEIK-N2H5F0S0G0 glyco",
    "PLXNC1 VQPIASSTLIHSDLTSVYGTVVMNR-N2H5F0S0G0 glyco",
    "PLXNC1 cnv",
    "PLXNC1 methyl",
    "PLXNC1 proteo",
    "PLXNC1 rna"
  ],
  "PLXND1": [
    "PLXND1 ANFTIYDCSR-N2H5F0S0G0 glyco",
    "PLXND1 ANFTIYDCSR-N2H6F0S0G0 glyco",
    "PLXND1 cnv",
    "PLXND1 methyl",
    "PLXND1 proteo",
    "PLXND1 rna"
  ],
  "PM20D1": [
    "PM20D1 cnv",
    "PM20D1 rna"
  ],
  "PM20D2": [
    "PM20D2 cnv",
    "PM20D2 methyl",
    "PM20D2 proteo",
    "PM20D2 rna"
  ],
  "PMAIP1": [
    "PMAIP1 cnv",
    "PMAIP1 methyl",
    "PMAIP1 rna"
  ],
  "PMCH": [
    "PMCH cnv",
    "PMCH rna"
  ],
  "PMEL": [
    "PMEL cnv",
    "PMEL methyl",
    "PMEL rna"
  ],
  "PMEPA1": [
    "PMEPA1 cnv",
    "PMEPA1 methyl",
    "PMEPA1 rna"
  ],
  "PMF1": [
    "PMF1 cnv",
    "PMF1 methyl",
    "PMF1 proteo",
    "PMF1 rna"
  ],
  "PMF1-BGLAP": [
    "PMF1-BGLAP cnv",
    "PMF1-BGLAP methyl",
    "PMF1-BGLAP rna"
  ],
  "PMFBP1": [
    "PMFBP1 cnv",
    "PMFBP1 rna"
  ],
  "PMIS2": [
    "PMIS2 cnv"
  ],
  "PML": [
    "PML 403_409_1_1_S403 phospho",
    "PML 403_409_2_0 phospho",
    "PML 403_425_1_1_S403 phospho",
    "PML 480_482_1_1_S480 phospho",
    "PML 504_505_1_1_S505 phospho",
    "PML 504_514_1_1_S505 phospho",
    "PML 504_514_2_2_S504S505 phospho",
    "PML 504_514_2_2_S505S512 phospho",
    "PML 518_527_1_1_S518 phospho",
    "PML 518_527_1_1_S527 phospho",
    "PML 518_527_2_2_S518S527 phospho",
    "PML 518_547_3_3_S518S527S530 phospho",
    "PML 672_672_1_1_S672 phospho",
    "PML cnv",
    "PML methyl",
    "PML proteo",
    "PML rna"
  ],
  "PMM1": [
    "PMM1 235_246_1_1_S242 phospho",
    "PMM1 cnv",
    "PMM1 methyl",
    "PMM1 proteo",
    "PMM1 rna"
  ],
  "PMM2": [
    "PMM2 cnv",
    "PMM2 methyl",
    "PMM2 proteo",
    "PMM2 rna"
  ],
  "PMP2": [
    "PMP2 cnv",
    "PMP2 proteo",
    "PMP2 rna"
  ],
  "PMP22": [
    "PMP22 cnv",
    "PMP22 methyl",
    "PMP22 rna"
  ],
  "PMPCA": [
    "PMPCA cnv",
    "PMPCA methyl",
    "PMPCA proteo",
    "PMPCA rna"
  ],
  "PMPCB": [
    "PMPCB cnv",
    "PMPCB proteo",
    "PMPCB rna"
  ],
  "PMS1": [
    "PMS1 cnv",
    "PMS1 methyl",
    "PMS1 proteo",
    "PMS1 rna"
  ],
  "PMS2": [
    "PMS2 445_445_1_1_S445 phospho",
    "PMS2 cnv",
    "PMS2 methyl",
    "PMS2 proteo",
    "PMS2 rna"
  ],
  "PMS2P3": [
    "PMS2P3 methyl"
  ],
  "PMS2P4": [
    "PMS2P4 methyl"
  ],
  "PMVK": [
    "PMVK cnv",
    "PMVK methyl",
    "PMVK proteo",
    "PMVK rna"
  ],
  "PNCK": [
    "PNCK kinase",
    "PNCK methyl",
    "PNCK rna"
  ],
  "PNISR": [
    "PNISR 211_211_1_1_S211 phospho",
    "PNISR 286_305_1_1_S290 phospho",
    "PNISR 485_491_1_1_T485 phospho",
    "PNISR cnv",
    "PNISR proteo",
    "PNISR rna"
  ],
  "PNKD": [
    "PNKD cnv",
    "PNKD methyl",
    "PNKD proteo",
    "PNKD rna"
  ],
  "PNKP": [
    "PNKP 111_126_1_1_T118 phospho",
    "PNKP cnv",
    "PNKP methyl",
    "PNKP proteo",
    "PNKP rna"
  ],
  "PNLDC1": [
    "PNLDC1 cnv",
    "PNLDC1 methyl",
    "PNLDC1 rna"
  ],
  "PNLIP": [
    "PNLIP cnv"
  ],
  "PNLIPRP1": [
    "PNLIPRP1 cnv",
    "PNLIPRP1 rna"
  ],
  "PNLIPRP2": [
    "PNLIPRP2 cnv",
    "PNLIPRP2 rna"
  ],
  "PNLIPRP3": [
    "PNLIPRP3 cnv",
    "PNLIPRP3 rna"
  ],
  "PNMA1": [
    "PNMA1 cnv",
    "PNMA1 methyl",
    "PNMA1 proteo",
    "PNMA1 rna"
  ],
  "PNMA2": [
    "PNMA2 cnv",
    "PNMA2 methyl",
    "PNMA2 proteo",
    "PNMA2 rna"
  ],
  "PNMA3": [
    "PNMA3 methyl",
    "PNMA3 rna"
  ],
  "PNMA5": [
    "PNMA5 methyl",
    "PNMA5 rna"
  ],
  "PNMA6A": [
    "PNMA6A rna"
  ],
  "PNMA6E": [
    "PNMA6E rna"
  ],
  "PNMA6F": [
    "PNMA6F methyl",
    "PNMA6F rna"
  ],
  "PNMA8A": [
    "PNMA8A cnv",
    "PNMA8A methyl",
    "PNMA8A rna"
  ],
  "PNMA8B": [
    "PNMA8B cnv",
    "PNMA8B methyl",
    "PNMA8B proteo",
    "PNMA8B rna"
  ],
  "PNMA8C": [
    "PNMA8C cnv",
    "PNMA8C methyl",
    "PNMA8C rna"
  ],
  "PNMT": [
    "PNMT cnv",
    "PNMT methyl",
    "PNMT rna"
  ],
  "PNN": [
    "PNN 100_120_1_1_S100 phospho",
    "PNN 347_347_1_1_S347 phospho",
    "PNN 441_450_1_1_S443 phospho",
    "PNN 96_100_1_1_S100 phospho",
    "PNN 96_100_2_2_S96S100 phospho",
    "PNN cnv",
    "PNN methyl",
    "PNN proteo",
    "PNN rna"
  ],
  "PNO1": [
    "PNO1 cnv",
    "PNO1 methyl",
    "PNO1 proteo",
    "PNO1 rna"
  ],
  "PNOC": [
    "PNOC cnv",
    "PNOC proteo",
    "PNOC rna"
  ],
  "PNP": [
    "PNP cnv",
    "PNP methyl",
    "PNP proteo",
    "PNP rna"
  ],
  "PNPLA1": [
    "PNPLA1 cnv",
    "PNPLA1 rna"
  ],
  "PNPLA2": [
    "PNPLA2 404_415_1_1_S404 phospho",
    "PNPLA2 428_428_1_1_S428 phospho",
    "PNPLA2 cnv",
    "PNPLA2 methyl",
    "PNPLA2 proteo",
    "PNPLA2 rna"
  ],
  "PNPLA3": [
    "PNPLA3 cnv",
    "PNPLA3 methyl",
    "PNPLA3 rna"
  ],
  "PNPLA4": [
    "PNPLA4 methyl",
    "PNPLA4 rna"
  ],
  "PNPLA5": [
    "PNPLA5 cnv",
    "PNPLA5 methyl",
    "PNPLA5 rna"
  ],
  "PNPLA6": [
    "PNPLA6 354_362_1_1_S362 phospho",
    "PNPLA6 354_367_1_1_S362 phospho",
    "PNPLA6 cnv",
    "PNPLA6 methyl",
    "PNPLA6 proteo",
    "PNPLA6 rna"
  ],
  "PNPLA7": [
    "PNPLA7 cnv",
    "PNPLA7 methyl",
    "PNPLA7 rna"
  ],
  "PNPLA8": [
    "PNPLA8 cnv",
    "PNPLA8 methyl",
    "PNPLA8 proteo",
    "PNPLA8 rna"
  ],
  "PNPO": [
    "PNPO 238_247_1_1_S241 phospho",
    "PNPO 238_256_1_1_S241 phospho",
    "PNPO cnv",
    "PNPO proteo",
    "PNPO rna"
  ],
  "PNPT1": [
    "PNPT1 cnv",
    "PNPT1 methyl",
    "PNPT1 proteo",
    "PNPT1 rna"
  ],
  "PNRC1": [
    "PNRC1 cnv",
    "PNRC1 methyl",
    "PNRC1 rna"
  ],
  "PNRC2": [
    "PNRC2 cnv",
    "PNRC2 methyl",
    "PNRC2 rna"
  ],
  "POC1A": [
    "POC1A cnv",
    "POC1A methyl",
    "POC1A rna"
  ],
  "POC1B": [
    "POC1B cnv",
    "POC1B methyl",
    "POC1B rna"
  ],
  "POC1B-GALNT4": [
    "POC1B-GALNT4 cnv",
    "POC1B-GALNT4 methyl",
    "POC1B-GALNT4 rna"
  ],
  "POC5": [
    "POC5 101_109_1_1_S105 phospho",
    "POC5 cnv",
    "POC5 methyl",
    "POC5 proteo",
    "POC5 rna"
  ],
  "PODN": [
    "PODN cnv",
    "PODN methyl",
    "PODN proteo",
    "PODN rna"
  ],
  "PODNL1": [
    "PODNL1 cnv",
    "PODNL1 methyl",
    "PODNL1 rna"
  ],
  "PODXL": [
    "PODXL QLVLNLTGNTLCAGGASDEK-N4H5F1S1G0 glyco",
    "PODXL QLVLNLTGNTLCAGGASDEK-N4H5F1S2G0 glyco",
    "PODXL QLVLNLTGNTLCAGGASDEK-N4H5F2S1G0 glyco",
    "PODXL QLVLNLTGNTLCAGGASDEK-N4H5F3S1G0 glyco",
    "PODXL cnv",
    "PODXL methyl",
    "PODXL proteo",
    "PODXL rna"
  ],
  "PODXL2": [
    "PODXL2 596_603_1_1_S596 phospho",
    "PODXL2 cnv",
    "PODXL2 methyl",
    "PODXL2 proteo",
    "PODXL2 rna"
  ],
  "POF1B": [
    "POF1B rna"
  ],
  "POFUT1": [
    "POFUT1 cnv",
    "POFUT1 methyl",
    "POFUT1 proteo",
    "POFUT1 rna"
  ],
  "POFUT2": [
    "POFUT2 cnv",
    "POFUT2 methyl",
    "POFUT2 proteo",
    "POFUT2 rna"
  ],
  "POGK": [
    "POGK cnv",
    "POGK methyl",
    "POGK proteo",
    "POGK rna"
  ],
  "POGLUT1": [
    "POGLUT1 cnv",
    "POGLUT1 proteo",
    "POGLUT1 rna"
  ],
  "POGLUT2": [
    "POGLUT2 cnv",
    "POGLUT2 methyl",
    "POGLUT2 proteo",
    "POGLUT2 rna"
  ],
  "POGLUT3": [
    "POGLUT3 GVTNDLLSIQGNTGPSWINK-N2H6F0S0G0 glyco",
    "POGLUT3 YFYLQAVNSEGQNLTR-N2H7F0S0G0 glyco",
    "POGLUT3 YFYLQAVNSEGQNLTR-N2H8F0S0G0 glyco",
    "POGLUT3 YFYLQAVNSEGQNLTR-N2H9F0S0G0 glyco",
    "POGLUT3 YFYLQAVNSEGQNLTR-N4H4F1S1G0 glyco",
    "POGLUT3 cnv",
    "POGLUT3 methyl",
    "POGLUT3 proteo",
    "POGLUT3 rna"
  ],
  "POGZ": [
    "POGZ 1351_1359_1_1_S1355 phospho",
    "POGZ 1351_1359_1_1_T1359 phospho",
    "POGZ 251_282_1_0 phospho",
    "POGZ 401_416_1_1_S416 phospho",
    "POGZ 420_454_1_1_S436 phospho",
    "POGZ cnv",
    "POGZ methyl",
    "POGZ proteo",
    "POGZ rna"
  ],
  "POLA1": [
    "POLA1 methyl",
    "POLA1 proteo",
    "POLA1 rna"
  ],
  "POLA2": [
    "POLA2 141_158_1_1_S141 phospho",
    "POLA2 cnv",
    "POLA2 methyl",
    "POLA2 proteo",
    "POLA2 rna"
  ],
  "POLB": [
    "POLB cnv",
    "POLB methyl",
    "POLB proteo",
    "POLB rna"
  ],
  "POLD1": [
    "POLD1 cnv",
    "POLD1 methyl",
    "POLD1 proteo",
    "POLD1 rna"
  ],
  "POLD2": [
    "POLD2 cnv",
    "POLD2 methyl",
    "POLD2 proteo",
    "POLD2 rna"
  ],
  "POLD3": [
    "POLD3 268_272_1_1_S268 phospho",
    "POLD3 cnv",
    "POLD3 methyl",
    "POLD3 proteo",
    "POLD3 rna"
  ],
  "POLD4": [
    "POLD4 cnv",
    "POLD4 methyl",
    "POLD4 rna"
  ],
  "POLDIP2": [
    "POLDIP2 cnv",
    "POLDIP2 methyl",
    "POLDIP2 proteo",
    "POLDIP2 rna"
  ],
  "POLDIP3": [
    "POLDIP3 126_140_1_0 phospho",
    "POLDIP3 126_140_1_1_S127 phospho",
    "POLDIP3 354_368_1_0 phospho",
    "POLDIP3 cnv",
    "POLDIP3 methyl",
    "POLDIP3 proteo",
    "POLDIP3 rna"
  ],
  "POLE": [
    "POLE cnv",
    "POLE methyl",
    "POLE rna"
  ],
  "POLE2": [
    "POLE2 cnv",
    "POLE2 methyl",
    "POLE2 rna"
  ],
  "POLE3": [
    "POLE3 cnv",
    "POLE3 methyl",
    "POLE3 proteo",
    "POLE3 rna"
  ],
  "POLE4": [
    "POLE4 cnv",
    "POLE4 methyl",
    "POLE4 proteo",
    "POLE4 rna"
  ],
  "POLG": [
    "POLG cnv",
    "POLG methyl",
    "POLG proteo",
    "POLG rna"
  ],
  "POLG2": [
    "POLG2 cnv",
    "POLG2 methyl",
    "POLG2 rna"
  ],
  "POLH": [
    "POLH cnv",
    "POLH methyl",
    "POLH rna"
  ],
  "POLI": [
    "POLI cnv",
    "POLI methyl",
    "POLI proteo",
    "POLI rna"
  ],
  "POLK": [
    "POLK cnv",
    "POLK methyl",
    "POLK rna"
  ],
  "POLL": [
    "POLL cnv",
    "POLL methyl",
    "POLL rna"
  ],
  "POLM": [
    "POLM cnv",
    "POLM methyl",
    "POLM rna"
  ],
  "POLN": [
    "POLN cnv",
    "POLN methyl",
    "POLN rna"
  ],
  "POLQ": [
    "POLQ cnv",
    "POLQ methyl",
    "POLQ rna"
  ],
  "POLR1A": [
    "POLR1A 1427_1429_1_1_S1429 phospho",
    "POLR1A cnv",
    "POLR1A methyl",
    "POLR1A proteo",
    "POLR1A rna"
  ],
  "POLR1B": [
    "POLR1B cnv",
    "POLR1B methyl",
    "POLR1B proteo",
    "POLR1B rna"
  ],
  "POLR1C": [
    "POLR1C cnv",
    "POLR1C methyl",
    "POLR1C proteo",
    "POLR1C rna"
  ],
  "POLR1D": [
    "POLR1D cnv",
    "POLR1D methyl",
    "POLR1D proteo",
    "POLR1D rna"
  ],
  "POLR1E": [
    "POLR1E cnv",
    "POLR1E methyl",
    "POLR1E proteo",
    "POLR1E rna"
  ],
  "POLR1F": [
    "POLR1F 316_322_1_1_S316 phospho",
    "POLR1F cnv",
    "POLR1F methyl",
    "POLR1F proteo",
    "POLR1F rna"
  ],
  "POLR1G": [
    "POLR1G cnv",
    "POLR1G methyl",
    "POLR1G proteo",
    "POLR1G rna"
  ],
  "POLR1H": [
    "POLR1H cnv",
    "POLR1H methyl",
    "POLR1H proteo",
    "POLR1H rna"
  ],
  "POLR2A": [
    "POLR2A 1811_1836_1_0 phospho",
    "POLR2A 1811_1836_2_0 phospho",
    "POLR2A 1839_1857_1_1_S1850 phospho",
    "POLR2A 1839_1857_1_1_S1857 phospho",
    "POLR2A 1874_1885_1_1_S1878 phospho",
    "POLR2A 1874_1885_1_1_S1882 phospho",
    "POLR2A 1888_1906_1_0 phospho",
    "POLR2A 1888_1906_1_1_S1906 phospho",
    "POLR2A 1909_1920_1_1_S1913 phospho",
    "POLR2A 1909_1920_1_1_S1917 phospho",
    "POLR2A cnv",
    "POLR2A methyl",
    "POLR2A proteo",
    "POLR2A rna"
  ],
  "POLR2B": [
    "POLR2B cnv",
    "POLR2B methyl",
    "POLR2B proteo",
    "POLR2B rna"
  ],
  "POLR2C": [
    "POLR2C cnv",
    "POLR2C methyl",
    "POLR2C proteo",
    "POLR2C rna"
  ],
  "POLR2D": [
    "POLR2D cnv",
    "POLR2D methyl",
    "POLR2D proteo",
    "POLR2D rna"
  ],
  "POLR2E": [
    "POLR2E cnv",
    "POLR2E methyl",
    "POLR2E proteo",
    "POLR2E rna"
  ],
  "POLR2F": [
    "POLR2F cnv",
    "POLR2F methyl",
    "POLR2F proteo",
    "POLR2F rna"
  ],
  "POLR2G": [
    "POLR2G cnv",
    "POLR2G methyl",
    "POLR2G proteo",
    "POLR2G rna"
  ],
  "POLR2H": [
    "POLR2H cnv",
    "POLR2H methyl",
    "POLR2H proteo",
    "POLR2H rna"
  ],
  "POLR2I": [
    "POLR2I cnv",
    "POLR2I methyl",
    "POLR2I proteo",
    "POLR2I rna"
  ],
  "POLR2J": [
    "POLR2J cnv",
    "POLR2J methyl",
    "POLR2J rna"
  ],
  "POLR2J2": [
    "POLR2J2 cnv",
    "POLR2J2 methyl",
    "POLR2J2 rna"
  ],
  "POLR2J3": [
    "POLR2J3 cnv",
    "POLR2J3 rna"
  ],
  "POLR2J4": [
    "POLR2J4 methyl"
  ],
  "POLR2K": [
    "POLR2K cnv",
    "POLR2K proteo",
    "POLR2K rna"
  ],
  "POLR2L": [
    "POLR2L cnv",
    "POLR2L methyl",
    "POLR2L proteo",
    "POLR2L rna"
  ],
  "POLR2M": [
    "POLR2M cnv",
    "POLR2M methyl",
    "POLR2M rna"
  ],
  "POLR3A": [
    "POLR3A cnv",
    "POLR3A methyl",
    "POLR3A proteo",
    "POLR3A rna"
  ],
  "POLR3B": [
    "POLR3B cnv",
    "POLR3B methyl",
    "POLR3B proteo",
    "POLR3B rna"
  ],
  "POLR3C": [
    "POLR3C 217_218_1_1_S217 phospho",
    "POLR3C 217_218_1_1_S218 phospho",
    "POLR3C 217_218_2_2_S217S218 phospho",
    "POLR3C cnv",
    "POLR3C methyl",
    "POLR3C proteo",
    "POLR3C rna"
  ],
  "POLR3D": [
    "POLR3D cnv",
    "POLR3D methyl",
    "POLR3D proteo",
    "POLR3D rna"
  ],
  "POLR3E": [
    "POLR3E 161_162_1_1_S162 phospho",
    "POLR3E 161_162_2_2_S161S162 phospho",
    "POLR3E cnv",
    "POLR3E methyl",
    "POLR3E proteo",
    "POLR3E rna"
  ],
  "POLR3F": [
    "POLR3F cnv",
    "POLR3F methyl",
    "POLR3F proteo",
    "POLR3F rna"
  ],
  "POLR3G": [
    "POLR3G cnv",
    "POLR3G methyl",
    "POLR3G rna"
  ],
  "POLR3GL": [
    "POLR3GL cnv",
    "POLR3GL methyl",
    "POLR3GL rna"
  ],
  "POLR3H": [
    "POLR3H cnv",
    "POLR3H methyl",
    "POLR3H proteo",
    "POLR3H rna"
  ],
  "POLR3K": [
    "POLR3K cnv",
    "POLR3K methyl",
    "POLR3K proteo",
    "POLR3K rna"
  ],
  "POLRMT": [
    "POLRMT cnv",
    "POLRMT methyl",
    "POLRMT proteo",
    "POLRMT rna"
  ],
  "POM121": [
    "POM121 cnv",
    "POM121 methyl",
    "POM121 proteo",
    "POM121 rna"
  ],
  "POM121C": [
    "POM121C 126_144_1_1_S128 phospho",
    "POM121C cnv",
    "POM121C methyl",
    "POM121C proteo",
    "POM121C rna"
  ],
  "POM121L12": [
    "POM121L12 cnv",
    "POM121L12 methyl"
  ],
  "POM121L2": [
    "POM121L2 cnv",
    "POM121L2 methyl",
    "POM121L2 rna"
  ],
  "POM121L9P": [
    "POM121L9P methyl"
  ],
  "POMC": [
    "POMC cnv",
    "POMC methyl",
    "POMC rna"
  ],
  "POMGNT1": [
    "POMGNT1 cnv",
    "POMGNT1 methyl",
    "POMGNT1 proteo",
    "POMGNT1 rna"
  ],
  "POMGNT2": [
    "POMGNT2 cnv",
    "POMGNT2 methyl",
    "POMGNT2 proteo",
    "POMGNT2 rna"
  ],
  "POMK": [
    "POMK cnv",
    "POMK kinase",
    "POMK methyl",
    "POMK proteo",
    "POMK rna"
  ],
  "POMP": [
    "POMP cnv",
    "POMP methyl",
    "POMP proteo",
    "POMP rna"
  ],
  "POMT1": [
    "POMT1 FVHVNTSAVLK-N2H6F0S0G0 glyco",
    "POMT1 FVHVNTSAVLK-N2H7F0S0G0 glyco",
    "POMT1 FVHVNTSAVLK-N2H8F0S0G0 glyco",
    "POMT1 cnv",
    "POMT1 methyl",
    "POMT1 proteo",
    "POMT1 rna"
  ],
  "POMT2": [
    "POMT2 cnv",
    "POMT2 methyl",
    "POMT2 proteo",
    "POMT2 rna"
  ],
  "POMZP3": [
    "POMZP3 cnv",
    "POMZP3 methyl",
    "POMZP3 rna"
  ],
  "PON1": [
    "PON1 HANWTLTPLK-N3H4F0S1G0 glyco",
    "PON1 HANWTLTPLK-N4H5F0S1G0 glyco",
    "PON1 HANWTLTPLK-N4H5F0S2G0 glyco",
    "PON1 VTQVYAENGTVLQGSTVASVYK-N4H5F0S2G0 glyco",
    "PON1 VTQVYAENGTVLQGSTVASVYK-N4H5F2S1G0 glyco",
    "PON1 VTQVYAENGTVLQGSTVASVYK-N5H6F0S3G0 glyco",
    "PON1 VTQVYAENGTVLQGSTVASVYK-N5H6F1S3G0 glyco",
    "PON1 VTQVYAENGTVLQGSTVASVYK-N5H6F2S2G0 glyco",
    "PON1 cnv",
    "PON1 methyl",
    "PON1 proteo",
    "PON1 rna"
  ],
  "PON2": [
    "PON2 HTNMNLTQLK-N2H10F0S0G0 glyco",
    "PON2 HTNMNLTQLK-N2H4F0S0G0 glyco",
    "PON2 HTNMNLTQLK-N2H5F0S0G0 glyco",
    "PON2 HTNMNLTQLK-N2H6F0S0G0 glyco",
    "PON2 HTNMNLTQLK-N2H7F0S0G0 glyco",
    "PON2 HTNMNLTQLK-N2H8F0S0G0 glyco",
    "PON2 HTNMNLTQLK-N2H9F0S0G0 glyco",
    "PON2 IQNILSEKPTVTTVYANNGSVLQGSSVASVYDGK-N2H4F0S0G0 glyco",
    "PON2 IQNILSEKPTVTTVYANNGSVLQGSSVASVYDGK-N2H5F0S0G0 glyco",
    "PON2 IQNILSEKPTVTTVYANNGSVLQGSSVASVYDGK-N2H6F0S0G0 glyco",
    "PON2 IQNILSEKPTVTTVYANNGSVLQGSSVASVYDGK-N2H7F0S0G0 glyco",
    "PON2 IQNILSEKPTVTTVYANNGSVLQGSSVASVYDGK-N2H8F0S0G0 glyco",
    "PON2 cnv",
    "PON2 methyl",
    "PON2 proteo",
    "PON2 rna"
  ],
  "PON3": [
    "PON3 cnv",
    "PON3 methyl",
    "PON3 rna"
  ],
  "POP1": [
    "POP1 722_730_1_1_S730 phospho",
    "POP1 722_736_1_0 phospho",
    "POP1 722_736_1_1_S730 phospho",
    "POP1 cnv",
    "POP1 methyl",
    "POP1 proteo",
    "POP1 rna"
  ],
  "POP4": [
    "POP4 cnv",
    "POP4 methyl",
    "POP4 proteo",
    "POP4 rna"
  ],
  "POP5": [
    "POP5 145_154_1_1_S154 phospho",
    "POP5 cnv",
    "POP5 methyl",
    "POP5 rna"
  ],
  "POP7": [
    "POP7 cnv",
    "POP7 methyl",
    "POP7 proteo",
    "POP7 rna"
  ],
  "POPDC2": [
    "POPDC2 cnv",
    "POPDC2 methyl",
    "POPDC2 rna"
  ],
  "POPDC3": [
    "POPDC3 cnv",
    "POPDC3 methyl",
    "POPDC3 rna"
  ],
  "POR": [
    "POR cnv",
    "POR methyl",
    "POR proteo",
    "POR rna"
  ],
  "PORCN": [
    "PORCN methyl",
    "PORCN proteo",
    "PORCN rna"
  ],
  "PORCN-DT": [
    "PORCN-DT methyl"
  ],
  "POSTN": [
    "POSTN EVNDTLLVNELK-N2H5F0S0G0 glyco",
    "POSTN EVNDTLLVNELK-N3H3F1S0G0 glyco",
    "POSTN EVNDTLLVNELK-N4H3F1S0G0 glyco",
    "POSTN EVNDTLLVNELK-N4H4F0S0G0 glyco",
    "POSTN EVNDTLLVNELK-N4H4F1S0G0 glyco",
    "POSTN EVNDTLLVNELK-N4H4F1S1G0 glyco",
    "POSTN EVNDTLLVNELK-N4H5F1S0G0 glyco",
    "POSTN EVNDTLLVNELK-N4H5F1S1G0 glyco",
    "POSTN EVNDTLLVNELK-N5H3F1S0G0 glyco",
    "POSTN EVNDTLLVNELK-N5H4F1S0G0 glyco",
    "POSTN cnv",
    "POSTN proteo",
    "POSTN rna"
  ],
  "POT1": [
    "POT1 cnv",
    "POT1 methyl",
    "POT1 proteo",
    "POT1 rna"
  ],
  "POT1-AS1": [
    "POT1-AS1 methyl"
  ],
  "POTEA": [
    "POTEA cnv"
  ],
  "POTEB": [
    "POTEB cnv"
  ],
  "POTEB2": [
    "POTEB2 cnv"
  ],
  "POTEB3": [
    "POTEB3 cnv",
    "POTEB3 rna"
  ],
  "POTEC": [
    "POTEC cnv"
  ],
  "POTED": [
    "POTED cnv",
    "POTED methyl"
  ],
  "POTEE": [
    "POTEE cnv",
    "POTEE rna"
  ],
  "POTEF": [
    "POTEF cnv",
    "POTEF proteo",
    "POTEF rna"
  ],
  "POTEG": [
    "POTEG cnv",
    "POTEG methyl",
    "POTEG rna"
  ],
  "POTEH": [
    "POTEH cnv",
    "POTEH methyl",
    "POTEH rna"
  ],
  "POTEI": [
    "POTEI cnv",
    "POTEI proteo",
    "POTEI rna"
  ],
  "POTEJ": [
    "POTEJ cnv",
    "POTEJ proteo",
    "POTEJ rna"
  ],
  "POTEM": [
    "POTEM cnv",
    "POTEM rna"
  ],
  "POU1F1": [
    "POU1F1 cnv",
    "POU1F1 rna"
  ],
  "POU2AF1": [
    "POU2AF1 cnv",
    "POU2AF1 rna"
  ],
  "POU2AF2": [
    "POU2AF2 cnv",
    "POU2AF2 rna"
  ],
  "POU2F1": [
    "POU2F1 453_460_1_1_S460 phospho",
    "POU2F1 cnv",
    "POU2F1 methyl",
    "POU2F1 proteo",
    "POU2F1 rna"
  ],
  "POU2F2": [
    "POU2F2 cnv",
    "POU2F2 methyl",
    "POU2F2 rna"
  ],
  "POU2F3": [
    "POU2F3 cnv",
    "POU2F3 methyl",
    "POU2F3 rna"
  ],
  "POU3F1": [
    "POU3F1 cnv",
    "POU3F1 methyl",
    "POU3F1 rna"
  ],
  "POU3F2": [
    "POU3F2 337_344_1_1_S341 phospho",
    "POU3F2 413_440_1_0 phospho",
    "POU3F2 413_440_1_1_T432 phospho",
    "POU3F2 cnv",
    "POU3F2 methyl",
    "POU3F2 proteo",
    "POU3F2 rna"
  ],
  "POU3F3": [
    "POU3F3 465_498_1_1_T488 phospho",
    "POU3F3 cnv",
    "POU3F3 methyl",
    "POU3F3 proteo",
    "POU3F3 rna"
  ],
  "POU3F4": [
    "POU3F4 proteo",
    "POU3F4 rna"
  ],
  "POU4F1": [
    "POU4F1 cnv",
    "POU4F1 rna"
  ],
  "POU4F2": [
    "POU4F2 cnv",
    "POU4F2 methyl",
    "POU4F2 rna"
  ],
  "POU4F3": [
    "POU4F3 cnv",
    "POU4F3 methyl",
    "POU4F3 rna"
  ],
  "POU5F1": [
    "POU5F1 cnv",
    "POU5F1 methyl",
    "POU5F1 rna"
  ],
  "POU5F1B": [
    "POU5F1B cnv",
    "POU5F1B rna"
  ],
  "POU5F2": [
    "POU5F2 cnv",
    "POU5F2 rna"
  ],
  "POU6F1": [
    "POU6F1 cnv",
    "POU6F1 methyl",
    "POU6F1 rna"
  ],
  "POU6F2": [
    "POU6F2 cnv",
    "POU6F2 rna"
  ],
  "PP2D1": [
    "PP2D1 cnv",
    "PP2D1 rna"
  ],
  "PP7080": [
    "PP7080 methyl"
  ],
  "PPA1": [
    "PPA1 cnv",
    "PPA1 methyl",
    "PPA1 proteo",
    "PPA1 rna"
  ],
  "PPA2": [
    "PPA2 309_317_1_1_S317 phospho",
    "PPA2 cnv",
    "PPA2 methyl",
    "PPA2 proteo",
    "PPA2 rna"
  ],
  "PPAN": [
    "PPAN cnv",
    "PPAN methyl",
    "PPAN rna"
  ],
  "PPAN-P2RY11": [
    "PPAN-P2RY11 cnv",
    "PPAN-P2RY11 methyl",
    "PPAN-P2RY11 rna"
  ],
  "PPARA": [
    "PPARA cnv",
    "PPARA methyl",
    "PPARA rna"
  ],
  "PPARD": [
    "PPARD cnv",
    "PPARD methyl",
    "PPARD rna"
  ],
  "PPARG": [
    "PPARG cnv",
    "PPARG methyl",
    "PPARG rna"
  ],
  "PPARGC1A": [
    "PPARGC1A cnv",
    "PPARGC1A methyl",
    "PPARGC1A rna"
  ],
  "PPARGC1B": [
    "PPARGC1B cnv",
    "PPARGC1B methyl",
    "PPARGC1B rna"
  ],
  "PPAT": [
    "PPAT cnv",
    "PPAT methyl",
    "PPAT proteo",
    "PPAT rna"
  ],
  "PPBP": [
    "PPBP 52_58_1_1_S52 phospho",
    "PPBP cnv",
    "PPBP proteo",
    "PPBP rna"
  ],
  "PPCDC": [
    "PPCDC cnv",
    "PPCDC methyl",
    "PPCDC proteo",
    "PPCDC rna"
  ],
  "PPCS": [
    "PPCS cnv",
    "PPCS methyl",
    "PPCS proteo",
    "PPCS rna"
  ],
  "PPDPF": [
    "PPDPF cnv",
    "PPDPF methyl",
    "PPDPF proteo",
    "PPDPF rna"
  ],
  "PPDPFL": [
    "PPDPFL cnv",
    "PPDPFL rna"
  ],
  "PPEF1": [
    "PPEF1 methyl",
    "PPEF1 rna"
  ],
  "PPEF2": [
    "PPEF2 cnv",
    "PPEF2 rna"
  ],
  "PPFIA1": [
    "PPFIA1 1167_1174_1_1_S1172 phospho",
    "PPFIA1 238_244_1_1_S239 phospho",
    "PPFIA1 238_244_2_0 phospho",
    "PPFIA1 520_530_1_0 phospho",
    "PPFIA1 677_697_1_1_S693 phospho",
    "PPFIA1 761_763_1_1_S763 phospho",
    "PPFIA1 773_793_1_0 phospho",
    "PPFIA1 773_793_1_1_S793 phospho",
    "PPFIA1 77_77_1_1_S77 phospho",
    "PPFIA1 cnv",
    "PPFIA1 methyl",
    "PPFIA1 proteo",
    "PPFIA1 rna"
  ],
  "PPFIA2": [
    "PPFIA2 773_778_1_1_S774 phospho",
    "PPFIA2 cnv",
    "PPFIA2 methyl",
    "PPFIA2 proteo",
    "PPFIA2 rna"
  ],
  "PPFIA3": [
    "PPFIA3 142_148_1_1_S142 phospho",
    "PPFIA3 17_17_1_1_S17 phospho",
    "PPFIA3 714_718_1_1_T714 phospho",
    "PPFIA3 cnv",
    "PPFIA3 methyl",
    "PPFIA3 proteo",
    "PPFIA3 rna"
  ],
  "PPFIA4": [
    "PPFIA4 cnv",
    "PPFIA4 methyl",
    "PPFIA4 proteo",
    "PPFIA4 rna"
  ],
  "PPFIBP1": [
    "PPFIBP1 507_516_1_1_S509 phospho",
    "PPFIBP1 532_541_1_1_S534 phospho",
    "PPFIBP1 540_551_1_1_S548 phospho",
    "PPFIBP1 568_579_1_0 phospho",
    "PPFIBP1 568_579_1_1_S570 phospho",
    "PPFIBP1 968_978_1_1_S968 phospho",
    "PPFIBP1 cnv",
    "PPFIBP1 proteo",
    "PPFIBP1 rna"
  ],
  "PPFIBP2": [
    "PPFIBP2 385_395_1_1_S387 phospho",
    "PPFIBP2 cnv",
    "PPFIBP2 methyl",
    "PPFIBP2 proteo",
    "PPFIBP2 rna"
  ],
  "PPHLN1": [
    "PPHLN1 128_133_1_1_S133 phospho",
    "PPHLN1 161_167_1_1_S161 phospho",
    "PPHLN1 161_167_1_1_S167 phospho",
    "PPHLN1 172_179_1_1_S172 phospho",
    "PPHLN1 200_215_1_0 phospho",
    "PPHLN1 200_215_1_1_S205 phospho",
    "PPHLN1 200_215_2_2_S201S205 phospho",
    "PPHLN1 204_215_1_0 phospho",
    "PPHLN1 204_215_1_1_S205 phospho",
    "PPHLN1 cnv",
    "PPHLN1 methyl",
    "PPHLN1 proteo",
    "PPHLN1 rna"
  ],
  "PPIA": [
    "PPIA cnv",
    "PPIA methyl",
    "PPIA proteo",
    "PPIA rna"
  ],
  "PPIAL4A": [
    "PPIAL4A cnv",
    "PPIAL4A rna"
  ],
  "PPIAL4C": [
    "PPIAL4C cnv",
    "PPIAL4C rna"
  ],
  "PPIAL4D": [
    "PPIAL4D cnv",
    "PPIAL4D rna"
  ],
  "PPIAL4E": [
    "PPIAL4E cnv",
    "PPIAL4E rna"
  ],
  "PPIAL4F": [
    "PPIAL4F cnv",
    "PPIAL4F rna"
  ],
  "PPIAL4G": [
    "PPIAL4G cnv",
    "PPIAL4G rna"
  ],
  "PPIAL4H": [
    "PPIAL4H cnv",
    "PPIAL4H rna"
  ],
  "PPIB": [
    "PPIB cnv",
    "PPIB methyl",
    "PPIB proteo",
    "PPIB rna"
  ],
  "PPIC": [
    "PPIC cnv",
    "PPIC methyl",
    "PPIC proteo",
    "PPIC rna"
  ],
  "PPID": [
    "PPID cnv",
    "PPID methyl",
    "PPID proteo",
    "PPID rna"
  ],
  "PPIE": [
    "PPIE cnv",
    "PPIE methyl",
    "PPIE proteo",
    "PPIE rna"
  ],
  "PPIF": [
    "PPIF cnv",
    "PPIF methyl",
    "PPIF proteo",
    "PPIF rna"
  ],
  "PPIG": [
    "PPIG 290_290_1_1_S290 phospho",
    "PPIG 356_358_1_1_T358 phospho",
    "PPIG 356_358_2_2_S356T358 phospho",
    "PPIG 397_397_1_1_S397 phospho",
    "PPIG 611_611_1_1_T611 phospho",
    "PPIG 687_690_1_1_S687 phospho",
    "PPIG 695_696_1_1_S696 phospho",
    "PPIG 744_748_1_1_S745 phospho",
    "PPIG 744_748_2_2_S745T748 phospho",
    "PPIG 744_748_3_3_S744S745T748 phospho",
    "PPIG 744_753_1_1_T748 phospho",
    "PPIG 744_753_2_2_S745T748 phospho",
    "PPIG 744_753_3_3_S744S745T748 phospho",
    "PPIG cnv",
    "PPIG methyl",
    "PPIG proteo",
    "PPIG rna"
  ],
  "PPIH": [
    "PPIH cnv",
    "PPIH methyl",
    "PPIH proteo",
    "PPIH rna"
  ],
  "PPIL1": [
    "PPIL1 147_149_1_0 phospho",
    "PPIL1 147_149_1_1_S149 phospho",
    "PPIL1 cnv",
    "PPIL1 methyl",
    "PPIL1 proteo",
    "PPIL1 rna"
  ],
  "PPIL2": [
    "PPIL2 cnv",
    "PPIL2 methyl",
    "PPIL2 proteo",
    "PPIL2 rna"
  ],
  "PPIL3": [
    "PPIL3 cnv",
    "PPIL3 proteo",
    "PPIL3 rna"
  ],
  "PPIL4": [
    "PPIL4 159_188_1_1_S178 phospho",
    "PPIL4 cnv",
    "PPIL4 methyl",
    "PPIL4 proteo",
    "PPIL4 rna"
  ],
  "PPIL6": [
    "PPIL6 cnv",
    "PPIL6 methyl",
    "PPIL6 rna"
  ],
  "PPIP5K1": [
    "PPIP5K1 1149_1152_1_1_S1152 phospho",
    "PPIP5K1 940_944_1_1_S944 phospho",
    "PPIP5K1 963_964_1_1_S964 phospho",
    "PPIP5K1 987_1002_1_1_S987 phospho",
    "PPIP5K1 cnv",
    "PPIP5K1 proteo",
    "PPIP5K1 rna"
  ],
  "PPIP5K2": [
    "PPIP5K2 1006_1016_1_1_S1006 phospho",
    "PPIP5K2 1006_1016_1_1_S1016 phospho",
    "PPIP5K2 1161_1172_1_1_S1172 phospho",
    "PPIP5K2 38_38_1_1_S38 phospho",
    "PPIP5K2 491_504_1_0 phospho",
    "PPIP5K2 cnv",
    "PPIP5K2 methyl",
    "PPIP5K2 proteo",
    "PPIP5K2 rna"
  ],
  "PPL": [
    "PPL 1657_1665_1_1_S1657 phospho",
    "PPL cnv",
    "PPL methyl",
    "PPL proteo",
    "PPL rna"
  ],
  "PPM1A": [
    "PPM1A cnv",
    "PPM1A methyl",
    "PPM1A proteo",
    "PPM1A rna"
  ],
  "PPM1B": [
    "PPM1B cnv",
    "PPM1B methyl",
    "PPM1B proteo",
    "PPM1B rna"
  ],
  "PPM1D": [
    "PPM1D cnv",
    "PPM1D methyl",
    "PPM1D rna"
  ],
  "PPM1E": [
    "PPM1E 535_542_1_1_S535 phospho",
    "PPM1E cnv",
    "PPM1E methyl",
    "PPM1E proteo",
    "PPM1E rna"
  ],
  "PPM1F": [
    "PPM1F cnv",
    "PPM1F methyl",
    "PPM1F proteo",
    "PPM1F rna"
  ],
  "PPM1G": [
    "PPM1G cnv",
    "PPM1G methyl",
    "PPM1G proteo",
    "PPM1G rna"
  ],
  "PPM1H": [
    "PPM1H 123_124_1_0 phospho",
    "PPM1H 123_124_1_1_S124 phospho",
    "PPM1H 211_227_1_1_S211 phospho",
    "PPM1H cnv",
    "PPM1H methyl",
    "PPM1H proteo",
    "PPM1H rna"
  ],
  "PPM1J": [
    "PPM1J 25_45_1_1_S45 phospho",
    "PPM1J cnv",
    "PPM1J methyl",
    "PPM1J proteo",
    "PPM1J rna"
  ],
  "PPM1K": [
    "PPM1K cnv",
    "PPM1K methyl",
    "PPM1K proteo",
    "PPM1K rna"
  ],
  "PPM1K-DT": [
    "PPM1K-DT methyl"
  ],
  "PPM1L": [
    "PPM1L cnv",
    "PPM1L methyl",
    "PPM1L proteo",
    "PPM1L rna"
  ],
  "PPM1M": [
    "PPM1M cnv",
    "PPM1M methyl",
    "PPM1M rna"
  ],
  "PPM1N": [
    "PPM1N cnv",
    "PPM1N methyl",
    "PPM1N rna"
  ],
  "PPME1": [
    "PPME1 cnv",
    "PPME1 methyl",
    "PPME1 proteo",
    "PPME1 rna"
  ],
  "PPOX": [
    "PPOX cnv",
    "PPOX methyl",
    "PPOX proteo",
    "PPOX rna"
  ],
  "PPP1CA": [
    "PPP1CA cnv",
    "PPP1CA methyl",
    "PPP1CA proteo",
    "PPP1CA rna"
  ],
  "PPP1CB": [
    "PPP1CB 304_316_1_1_T316 phospho",
    "PPP1CB cnv",
    "PPP1CB methyl",
    "PPP1CB proteo",
    "PPP1CB rna"
  ],
  "PPP1CB-DT": [
    "PPP1CB-DT methyl"
  ],
  "PPP1CC": [
    "PPP1CC cnv",
    "PPP1CC methyl",
    "PPP1CC proteo",
    "PPP1CC rna"
  ],
  "PPP1R10": [
    "PPP1R10 cnv",
    "PPP1R10 methyl",
    "PPP1R10 proteo",
    "PPP1R10 rna"
  ],
  "PPP1R11": [
    "PPP1R11 102_117_1_1_T109 phospho",
    "PPP1R11 73_88_2_2_T75S77 phospho",
    "PPP1R11 73_88_3_3_S74T75S77 phospho",
    "PPP1R11 cnv",
    "PPP1R11 proteo",
    "PPP1R11 rna"
  ],
  "PPP1R12A": [
    "PPP1R12A 299_313_1_1_S299 phospho",
    "PPP1R12A 374_409_1_1_S409 phospho",
    "PPP1R12A 470_479_2_2_S472S473 phospho",
    "PPP1R12A 507_509_1_1_S507 phospho",
    "PPP1R12A 668_680_1_1_S668 phospho",
    "PPP1R12A 695_702_1_1_T696 phospho",
    "PPP1R12A 852_877_1_1_S871 phospho",
    "PPP1R12A 852_888_1_1_S871 phospho",
    "PPP1R12A 995_995_1_1_S995 phospho",
    "PPP1R12A cnv",
    "PPP1R12A methyl",
    "PPP1R12A proteo",
    "PPP1R12A rna"
  ],
  "PPP1R12B": [
    "PPP1R12B 17_29_1_1_S21 phospho",
    "PPP1R12B 445_457_1_1_S447 phospho",
    "PPP1R12B 772_772_1_1_S772 phospho",
    "PPP1R12B cnv",
    "PPP1R12B methyl",
    "PPP1R12B proteo",
    "PPP1R12B rna"
  ],
  "PPP1R12C": [
    "PPP1R12C 393_416_1_0 phospho",
    "PPP1R12C 393_416_1_1_S407 phospho",
    "PPP1R12C 407_417_1_1_S407 phospho",
    "PPP1R12C 559_566_1_1_T560 phospho",
    "PPP1R12C cnv",
    "PPP1R12C methyl",
    "PPP1R12C proteo",
    "PPP1R12C rna"
  ],
  "PPP1R13B": [
    "PPP1R13B 562_566_1_1_S566 phospho",
    "PPP1R13B 709_712_1_1_S710 phospho",
    "PPP1R13B cnv",
    "PPP1R13B methyl",
    "PPP1R13B proteo",
    "PPP1R13B rna"
  ],
  "PPP1R13B-DT": [
    "PPP1R13B-DT methyl"
  ],
  "PPP1R13L": [
    "PPP1R13L 158_158_1_1_S158 phospho",
    "PPP1R13L cnv",
    "PPP1R13L methyl",
    "PPP1R13L proteo",
    "PPP1R13L rna"
  ],
  "PPP1R14A": [
    "PPP1R14A 128_136_1_1_S128 phospho",
    "PPP1R14A 128_136_2_0 phospho",
    "PPP1R14A 128_136_2_2_S128S136 phospho",
    "PPP1R14A 128_136_3_3_S130S134S136 phospho",
    "PPP1R14A 26_26_1_1_S26 phospho",
    "PPP1R14A cnv",
    "PPP1R14A methyl",
    "PPP1R14A proteo",
    "PPP1R14A rna"
  ],
  "PPP1R14B": [
    "PPP1R14B cnv",
    "PPP1R14B methyl",
    "PPP1R14B proteo",
    "PPP1R14B rna"
  ],
  "PPP1R14C": [
    "PPP1R14C cnv",
    "PPP1R14C methyl",
    "PPP1R14C proteo",
    "PPP1R14C rna"
  ],
  "PPP1R14D": [
    "PPP1R14D cnv",
    "PPP1R14D rna"
  ],
  "PPP1R15A": [
    "PPP1R15A cnv",
    "PPP1R15A methyl",
    "PPP1R15A rna"
  ],
  "PPP1R15B": [
    "PPP1R15B cnv",
    "PPP1R15B methyl",
    "PPP1R15B rna"
  ],
  "PPP1R16A": [
    "PPP1R16A 431_446_1_1_S433 phospho",
    "PPP1R16A cnv",
    "PPP1R16A methyl",
    "PPP1R16A proteo",
    "PPP1R16A rna"
  ],
  "PPP1R16B": [
    "PPP1R16B cnv",
    "PPP1R16B methyl",
    "PPP1R16B rna"
  ],
  "PPP1R17": [
    "PPP1R17 cnv",
    "PPP1R17 proteo",
    "PPP1R17 rna"
  ],
  "PPP1R18": [
    "PPP1R18 125_125_1_1_S125 phospho",
    "PPP1R18 125_133_1_1_S133 phospho",
    "PPP1R18 195_199_1_1_S195 phospho",
    "PPP1R18 221_230_1_1_S224 phospho",
    "PPP1R18 224_230_1_1_S224 phospho",
    "PPP1R18 368_368_1_1_S368 phospho",
    "PPP1R18 398_410_1_1_S401 phospho",
    "PPP1R18 432_450_1_1_S432 phospho",
    "PPP1R18 cnv",
    "PPP1R18 methyl",
    "PPP1R18 proteo",
    "PPP1R18 rna"
  ],
  "PPP1R1A": [
    "PPP1R1A cnv",
    "PPP1R1A methyl",
    "PPP1R1A proteo",
    "PPP1R1A rna"
  ],
  "PPP1R1B": [
    "PPP1R1B 42_52_1_1_S42 phospho",
    "PPP1R1B 42_52_1_1_S46 phospho",
    "PPP1R1B 42_52_2_2_S45S46 phospho",
    "PPP1R1B 88_102_1_1_S102 phospho",
    "PPP1R1B cnv",
    "PPP1R1B methyl",
    "PPP1R1B proteo",
    "PPP1R1B rna"
  ],
  "PPP1R1C": [
    "PPP1R1C 57_65_1_1_S65 phospho",
    "PPP1R1C 72_78_1_0 phospho",
    "PPP1R1C 72_78_1_1_T75 phospho",
    "PPP1R1C cnv",
    "PPP1R1C proteo",
    "PPP1R1C rna"
  ],
  "PPP1R2": [
    "PPP1R2 72_92_1_1_S87 phospho",
    "PPP1R2 cnv",
    "PPP1R2 methyl",
    "PPP1R2 proteo",
    "PPP1R2 rna"
  ],
  "PPP1R21": [
    "PPP1R21 93_101_1_1_S101 phospho",
    "PPP1R21 cnv",
    "PPP1R21 methyl",
    "PPP1R21 proteo",
    "PPP1R21 rna"
  ],
  "PPP1R26": [
    "PPP1R26 cnv",
    "PPP1R26 methyl",
    "PPP1R26 rna"
  ],
  "PPP1R27": [
    "PPP1R27 cnv",
    "PPP1R27 rna"
  ],
  "PPP1R2B": [
    "PPP1R2B cnv",
    "PPP1R2B rna"
  ],
  "PPP1R2C": [
    "PPP1R2C methyl"
  ],
  "PPP1R32": [
    "PPP1R32 cnv",
    "PPP1R32 methyl",
    "PPP1R32 rna"
  ],
  "PPP1R35": [
    "PPP1R35 cnv",
    "PPP1R35 methyl",
    "PPP1R35 proteo",
    "PPP1R35 rna"
  ],
  "PPP1R36": [
    "PPP1R36 cnv",
    "PPP1R36 methyl",
    "PPP1R36 rna"
  ],
  "PPP1R37": [
    "PPP1R37 cnv",
    "PPP1R37 methyl",
    "PPP1R37 proteo",
    "PPP1R37 rna"
  ],
  "PPP1R3A": [
    "PPP1R3A cnv",
    "PPP1R3A rna"
  ],
  "PPP1R3B": [
    "PPP1R3B cnv",
    "PPP1R3B methyl",
    "PPP1R3B rna"
  ],
  "PPP1R3C": [
    "PPP1R3C cnv",
    "PPP1R3C methyl",
    "PPP1R3C rna"
  ],
  "PPP1R3D": [
    "PPP1R3D 46_58_1_1_S46 phospho",
    "PPP1R3D cnv",
    "PPP1R3D methyl",
    "PPP1R3D proteo",
    "PPP1R3D rna"
  ],
  "PPP1R3E": [
    "PPP1R3E 29_47_1_1_S33 phospho",
    "PPP1R3E cnv",
    "PPP1R3E methyl",
    "PPP1R3E proteo",
    "PPP1R3E rna"
  ],
  "PPP1R3F": [
    "PPP1R3F methyl",
    "PPP1R3F proteo",
    "PPP1R3F rna"
  ],
  "PPP1R3G": [
    "PPP1R3G cnv",
    "PPP1R3G methyl",
    "PPP1R3G proteo",
    "PPP1R3G rna"
  ],
  "PPP1R42": [
    "PPP1R42 cnv",
    "PPP1R42 methyl",
    "PPP1R42 rna"
  ],
  "PPP1R7": [
    "PPP1R7 24_27_1_1_S24 phospho",
    "PPP1R7 24_27_1_1_S27 phospho",
    "PPP1R7 24_27_2_2_S24S27 phospho",
    "PPP1R7 cnv",
    "PPP1R7 methyl",
    "PPP1R7 proteo",
    "PPP1R7 rna"
  ],
  "PPP1R8": [
    "PPP1R8 cnv",
    "PPP1R8 methyl",
    "PPP1R8 proteo",
    "PPP1R8 rna"
  ],
  "PPP1R9A": [
    "PPP1R9A 149_160_1_1_S160 phospho",
    "PPP1R9A 180_193_1_1_S184 phospho",
    "PPP1R9A 195_220_1_1_S199 phospho",
    "PPP1R9A 334_341_1_1_S338 phospho",
    "PPP1R9A 370_378_1_1_S371 phospho",
    "PPP1R9A 839_845_1_1_S840 phospho",
    "PPP1R9A 839_849_1_0 phospho",
    "PPP1R9A 839_849_1_1_S840 phospho",
    "PPP1R9A cnv",
    "PPP1R9A methyl",
    "PPP1R9A proteo",
    "PPP1R9A rna"
  ],
  "PPP1R9B": [
    "PPP1R9B cnv",
    "PPP1R9B methyl",
    "PPP1R9B proteo",
    "PPP1R9B rna"
  ],
  "PPP2CA": [
    "PPP2CA cnv",
    "PPP2CA methyl",
    "PPP2CA proteo",
    "PPP2CA rna"
  ],
  "PPP2CB": [
    "PPP2CB cnv",
    "PPP2CB proteo",
    "PPP2CB rna"
  ],
  "PPP2R1A": [
    "PPP2R1A cnv",
    "PPP2R1A methyl",
    "PPP2R1A proteo",
    "PPP2R1A rna"
  ],
  "PPP2R1B": [
    "PPP2R1B cnv",
    "PPP2R1B methyl",
    "PPP2R1B proteo",
    "PPP2R1B rna"
  ],
  "PPP2R2A": [
    "PPP2R2A cnv",
    "PPP2R2A proteo",
    "PPP2R2A rna"
  ],
  "PPP2R2B": [
    "PPP2R2B cnv",
    "PPP2R2B methyl",
    "PPP2R2B proteo",
    "PPP2R2B rna"
  ],
  "PPP2R2C": [
    "PPP2R2C cnv",
    "PPP2R2C methyl",
    "PPP2R2C proteo",
    "PPP2R2C rna"
  ],
  "PPP2R2D": [
    "PPP2R2D cnv",
    "PPP2R2D proteo",
    "PPP2R2D rna"
  ],
  "PPP2R3A": [
    "PPP2R3A 676_706_2_0 phospho",
    "PPP2R3A cnv",
    "PPP2R3A proteo",
    "PPP2R3A rna"
  ],
  "PPP2R3B": [
    "PPP2R3B proteo",
    "PPP2R3B rna"
  ],
  "PPP2R3C": [
    "PPP2R3C cnv",
    "PPP2R3C methyl",
    "PPP2R3C rna"
  ],
  "PPP2R5A": [
    "PPP2R5A 46_49_1_1_S49 phospho",
    "PPP2R5A 472_484_1_1_S472 phospho",
    "PPP2R5A cnv",
    "PPP2R5A methyl",
    "PPP2R5A proteo",
    "PPP2R5A rna"
  ],
  "PPP2R5B": [
    "PPP2R5B cnv",
    "PPP2R5B methyl",
    "PPP2R5B proteo",
    "PPP2R5B rna"
  ],
  "PPP2R5C": [
    "PPP2R5C 39_48_1_1_S39 phospho",
    "PPP2R5C 513_521_1_1_S513 phospho",
    "PPP2R5C cnv",
    "PPP2R5C methyl",
    "PPP2R5C proteo",
    "PPP2R5C rna"
  ],
  "PPP2R5D": [
    "PPP2R5D 60_70_1_1_T63 phospho",
    "PPP2R5D cnv",
    "PPP2R5D methyl",
    "PPP2R5D proteo",
    "PPP2R5D rna"
  ],
  "PPP2R5E": [
    "PPP2R5E cnv",
    "PPP2R5E methyl",
    "PPP2R5E proteo",
    "PPP2R5E rna"
  ],
  "PPP3CA": [
    "PPP3CA 462_462_1_1_S462 phospho",
    "PPP3CA 492_498_1_1_S492 phospho",
    "PPP3CA cnv",
    "PPP3CA methyl",
    "PPP3CA proteo",
    "PPP3CA rna"
  ],
  "PPP3CB": [
    "PPP3CB 472_472_1_1_S472 phospho",
    "PPP3CB 479_479_1_1_S479 phospho",
    "PPP3CB cnv",
    "PPP3CB proteo",
    "PPP3CB rna"
  ],
  "PPP3CB-AS1": [
    "PPP3CB-AS1 methyl"
  ],
  "PPP3CC": [
    "PPP3CC 492_492_1_1_S492 phospho",
    "PPP3CC cnv",
    "PPP3CC methyl",
    "PPP3CC proteo",
    "PPP3CC rna"
  ],
  "PPP3R1": [
    "PPP3R1 cnv",
    "PPP3R1 methyl",
    "PPP3R1 proteo",
    "PPP3R1 rna"
  ],
  "PPP3R2": [
    "PPP3R2 cnv",
    "PPP3R2 rna"
  ],
  "PPP4C": [
    "PPP4C cnv",
    "PPP4C methyl",
    "PPP4C proteo",
    "PPP4C rna"
  ],
  "PPP4R1": [
    "PPP4R1 537_547_1_1_S538 phospho",
    "PPP4R1 cnv",
    "PPP4R1 methyl",
    "PPP4R1 proteo",
    "PPP4R1 rna"
  ],
  "PPP4R1-AS1": [
    "PPP4R1-AS1 methyl"
  ],
  "PPP4R2": [
    "PPP4R2 102_106_1_1_S102 phospho",
    "PPP4R2 156_169_1_1_S169 phospho",
    "PPP4R2 cnv",
    "PPP4R2 methyl",
    "PPP4R2 proteo",
    "PPP4R2 rna"
  ],
  "PPP4R3A": [
    "PPP4R3A 741_770_1_0 phospho",
    "PPP4R3A 741_770_1_1_S758 phospho",
    "PPP4R3A 741_770_1_1_S767 phospho",
    "PPP4R3A cnv",
    "PPP4R3A methyl",
    "PPP4R3A proteo",
    "PPP4R3A rna"
  ],
  "PPP4R3B": [
    "PPP4R3B cnv",
    "PPP4R3B methyl",
    "PPP4R3B proteo",
    "PPP4R3B rna"
  ],
  "PPP4R4": [
    "PPP4R4 692_694_1_1_S694 phospho",
    "PPP4R4 cnv",
    "PPP4R4 methyl",
    "PPP4R4 rna"
  ],
  "PPP5C": [
    "PPP5C cnv",
    "PPP5C methyl",
    "PPP5C proteo",
    "PPP5C rna"
  ],
  "PPP6C": [
    "PPP6C cnv",
    "PPP6C methyl",
    "PPP6C proteo",
    "PPP6C rna"
  ],
  "PPP6R1": [
    "PPP6R1 524_531_1_1_S531 phospho",
    "PPP6R1 730_759_1_1_S759 phospho",
    "PPP6R1 cnv",
    "PPP6R1 methyl",
    "PPP6R1 proteo",
    "PPP6R1 rna"
  ],
  "PPP6R2": [
    "PPP6R2 283_291_1_1_S289 phospho",
    "PPP6R2 770_783_1_1_S771 phospho",
    "PPP6R2 cnv",
    "PPP6R2 methyl",
    "PPP6R2 proteo",
    "PPP6R2 rna"
  ],
  "PPP6R3": [
    "PPP6R3 617_617_1_1_S617 phospho",
    "PPP6R3 851_853_1_1_S853 phospho",
    "PPP6R3 cnv",
    "PPP6R3 methyl",
    "PPP6R3 proteo",
    "PPP6R3 rna"
  ],
  "PPRC1": [
    "PPRC1 cnv",
    "PPRC1 methyl",
    "PPRC1 rna"
  ],
  "PPT1": [
    "PPT1 EDVYRNHSIFLADINQER-N2H3F1S0G0 glyco",
    "PPT1 FLNDSIVDPVDSEWFGFYR-N2H6F0S0G0 glyco",
    "PPT1 GINESYK-N2H5F0S0G0 glyco",
    "PPT1 GINESYK-N2H6F0S0G0 glyco",
    "PPT1 GINESYK-N2H7F0S0G0 glyco",
    "PPT1 GINESYKK-N2H3F0S0G0 glyco",
    "PPT1 GINESYKK-N2H4F0S0G0 glyco",
    "PPT1 GINESYKK-N2H5F0S0G0 glyco",
    "PPT1 GINESYKK-N2H6F0S0G0 glyco",
    "PPT1 GINESYKK-N2H7F0S0G0 glyco",
    "PPT1 NHSIFLADINQER-N2H3F0S0G0 glyco",
    "PPT1 NHSIFLADINQER-N2H3F1S0G0 glyco",
    "PPT1 NHSIFLADINQER-N2H4F0S0G0 glyco",
    "PPT1 NHSIFLADINQER-N2H5F0S0G0 glyco",
    "PPT1 NHSIFLADINQER-N2H6F0S0G0 glyco",
    "PPT1 NHSIFLADINQER-N2H7F0S0G0 glyco",
    "PPT1 cnv",
    "PPT1 methyl",
    "PPT1 proteo",
    "PPT1 rna"
  ],
  "PPT2": [
    "PPT2 cnv",
    "PPT2 methyl",
    "PPT2 rna"
  ],
  "PPT2-EGFL8": [
    "PPT2-EGFL8 cnv",
    "PPT2-EGFL8 rna"
  ],
  "PPTC7": [
    "PPTC7 cnv",
    "PPTC7 proteo",
    "PPTC7 rna"
  ],
  "PPWD1": [
    "PPWD1 cnv",
    "PPWD1 methyl",
    "PPWD1 proteo",
    "PPWD1 rna"
  ],
  "PPY": [
    "PPY cnv",
    "PPY rna"
  ],
  "PQBP1": [
    "PQBP1 methyl",
    "PQBP1 proteo",
    "PQBP1 rna"
  ],
  "PRAC1": [
    "PRAC1 cnv",
    "PRAC1 methyl",
    "PRAC1 rna"
  ],
  "PRAC2": [
    "PRAC2 cnv",
    "PRAC2 methyl",
    "PRAC2 rna"
  ],
  "PRADC1": [
    "PRADC1 cnv",
    "PRADC1 methyl",
    "PRADC1 proteo",
    "PRADC1 rna"
  ],
  "PRAF2": [
    "PRAF2 methyl",
    "PRAF2 proteo",
    "PRAF2 rna"
  ],
  "PRAG1": [
    "PRAG1 146_153_1_1_S148 phospho",
    "PRAG1 243_263_1_1_S263 phospho",
    "PRAG1 651_653_1_1_S653 phospho",
    "PRAG1 694_696_1_1_S696 phospho",
    "PRAG1 754_767_1_1_S759 phospho",
    "PRAG1 769_786_1_1_S782 phospho",
    "PRAG1 769_786_2_2_S782S786 phospho",
    "PRAG1 798_807_1_0 phospho",
    "PRAG1 826_837_1_1_S826 phospho",
    "PRAG1 907_907_1_1_S907 phospho",
    "PRAG1 cnv",
    "PRAG1 kinase",
    "PRAG1 methyl",
    "PRAG1 proteo",
    "PRAG1 rna"
  ],
  "PRAM1": [
    "PRAM1 296_303_1_1_S298 phospho",
    "PRAM1 358_363_1_1_S358 phospho",
    "PRAM1 386_402_1_1_S389 phospho",
    "PRAM1 407_415_1_1_S407 phospho",
    "PRAM1 473_476_1_1_S473 phospho",
    "PRAM1 484_484_1_1_S484 phospho",
    "PRAM1 48_53_1_1_S48 phospho",
    "PRAM1 cnv",
    "PRAM1 proteo",
    "PRAM1 rna"
  ],
  "PRAME": [
    "PRAME cnv",
    "PRAME methyl",
    "PRAME rna"
  ],
  "PRAMEF1": [
    "PRAMEF1 cnv"
  ],
  "PRAMEF10": [
    "PRAMEF10 cnv"
  ],
  "PRAMEF11": [
    "PRAMEF11 cnv"
  ],
  "PRAMEF12": [
    "PRAMEF12 cnv",
    "PRAMEF12 rna"
  ],
  "PRAMEF13": [
    "PRAMEF13 cnv"
  ],
  "PRAMEF14": [
    "PRAMEF14 cnv"
  ],
  "PRAMEF15": [
    "PRAMEF15 cnv"
  ],
  "PRAMEF17": [
    "PRAMEF17 cnv",
    "PRAMEF17 proteo"
  ],
  "PRAMEF18": [
    "PRAMEF18 cnv"
  ],
  "PRAMEF19": [
    "PRAMEF19 cnv"
  ],
  "PRAMEF2": [
    "PRAMEF2 cnv"
  ],
  "PRAMEF20": [
    "PRAMEF20 cnv"
  ],
  "PRAMEF25": [
    "PRAMEF25 cnv"
  ],
  "PRAMEF26": [
    "PRAMEF26 cnv"
  ],
  "PRAMEF27": [
    "PRAMEF27 cnv"
  ],
  "PRAMEF33": [
    "PRAMEF33 cnv"
  ],
  "PRAMEF4": [
    "PRAMEF4 cnv"
  ],
  "PRAMEF5": [
    "PRAMEF5 cnv"
  ],
  "PRAMEF6": [
    "PRAMEF6 cnv"
  ],
  "PRAMEF7": [
    "PRAMEF7 cnv",
    "PRAMEF7 rna"
  ],
  "PRAMEF8": [
    "PRAMEF8 cnv"
  ],
  "PRAMEF9": [
    "PRAMEF9 cnv"
  ],
  "PRANCR": [
    "PRANCR methyl"
  ],
  "PRAP1": [
    "PRAP1 cnv",
    "PRAP1 rna"
  ],
  "PRB1": [
    "PRB1 cnv",
    "PRB1 rna"
  ],
  "PRB2": [
    "PRB2 cnv",
    "PRB2 rna"
  ],
  "PRB3": [
    "PRB3 cnv",
    "PRB3 rna"
  ],
  "PRB4": [
    "PRB4 cnv"
  ],
  "PRC1": [
    "PRC1 417_431_1_1_T429 phospho",
    "PRC1 440_440_1_1_T440 phospho",
    "PRC1 cnv",
    "PRC1 methyl",
    "PRC1 proteo",
    "PRC1 rna"
  ],
  "PRCC": [
    "PRCC 157_165_1_1_S157 phospho",
    "PRCC 209_218_1_0 phospho",
    "PRCC 261_278_1_1_S267 phospho",
    "PRCC 97_114_1_1_S114 phospho",
    "PRCC cnv",
    "PRCC methyl",
    "PRCC proteo",
    "PRCC rna"
  ],
  "PRCD": [
    "PRCD cnv",
    "PRCD methyl",
    "PRCD rna"
  ],
  "PRCP": [
    "PRCP NISSHTNIVFSNGELDPWSGGGVTK-N2H7F0S0G0 glyco",
    "PRCP NISSHTNIVFSNGELDPWSGGGVTK-N2H8F0S0G0 glyco",
    "PRCP NISSHTNIVFSNGELDPWSGGGVTK-N4H3F0S2G0 glyco",
    "PRCP NYSVLYFQQK-N2H3F1S0G0 glyco",
    "PRCP NYSVLYFQQK-N2H5F0S0G0 glyco",
    "PRCP NYSVLYFQQK-N2H5F1S0G0 glyco",
    "PRCP NYSVLYFQQK-N2H6F0S0G0 glyco",
    "PRCP NYSVLYFQQK-N2H7F0S0G0 glyco",
    "PRCP NYSVLYFQQK-N2H9F0S0G0 glyco",
    "PRCP cnv",
    "PRCP methyl",
    "PRCP proteo",
    "PRCP rna"
  ],
  "PRDM1": [
    "PRDM1 cnv",
    "PRDM1 methyl",
    "PRDM1 rna"
  ],
  "PRDM10": [
    "PRDM10 cnv",
    "PRDM10 methyl",
    "PRDM10 rna"
  ],
  "PRDM11": [
    "PRDM11 cnv",
    "PRDM11 methyl",
    "PRDM11 rna"
  ],
  "PRDM12": [
    "PRDM12 cnv",
    "PRDM12 methyl",
    "PRDM12 rna"
  ],
  "PRDM13": [
    "PRDM13 cnv",
    "PRDM13 methyl",
    "PRDM13 rna"
  ],
  "PRDM14": [
    "PRDM14 cnv",
    "PRDM14 methyl",
    "PRDM14 rna"
  ],
  "PRDM15": [
    "PRDM15 cnv",
    "PRDM15 methyl",
    "PRDM15 rna"
  ],
  "PRDM16": [
    "PRDM16 cnv",
    "PRDM16 methyl",
    "PRDM16 proteo",
    "PRDM16 rna"
  ],
  "PRDM16-DT": [
    "PRDM16-DT methyl"
  ],
  "PRDM2": [
    "PRDM2 220_226_1_1_S220 phospho",
    "PRDM2 440_442_1_1_S442 phospho",
    "PRDM2 cnv",
    "PRDM2 methyl",
    "PRDM2 rna"
  ],
  "PRDM4": [
    "PRDM4 cnv",
    "PRDM4 methyl",
    "PRDM4 rna"
  ],
  "PRDM5": [
    "PRDM5 cnv",
    "PRDM5 methyl",
    "PRDM5 rna"
  ],
  "PRDM6": [
    "PRDM6 cnv",
    "PRDM6 methyl",
    "PRDM6 rna"
  ],
  "PRDM7": [
    "PRDM7 cnv",
    "PRDM7 methyl",
    "PRDM7 rna"
  ],
  "PRDM8": [
    "PRDM8 cnv",
    "PRDM8 methyl",
    "PRDM8 rna"
  ],
  "PRDM9": [
    "PRDM9 cnv",
    "PRDM9 rna"
  ],
  "PRDX1": [
    "PRDX1 cnv",
    "PRDX1 methyl",
    "PRDX1 proteo",
    "PRDX1 rna"
  ],
  "PRDX2": [
    "PRDX2 112_115_1_1_S112 phospho",
    "PRDX2 112_126_1_1_T120 phospho",
    "PRDX2 cnv",
    "PRDX2 methyl",
    "PRDX2 proteo",
    "PRDX2 rna"
  ],
  "PRDX3": [
    "PRDX3 cnv",
    "PRDX3 methyl",
    "PRDX3 proteo",
    "PRDX3 rna"
  ],
  "PRDX4": [
    "PRDX4 methyl",
    "PRDX4 proteo",
    "PRDX4 rna"
  ],
  "PRDX5": [
    "PRDX5 cnv",
    "PRDX5 methyl",
    "PRDX5 proteo",
    "PRDX5 rna"
  ],
  "PRDX6": [
    "PRDX6 44_49_1_1_T44 phospho",
    "PRDX6 cnv",
    "PRDX6 methyl",
    "PRDX6 proteo",
    "PRDX6 rna"
  ],
  "PRDX6-AS1": [
    "PRDX6-AS1 methyl"
  ],
  "PREB": [
    "PREB cnv",
    "PREB methyl",
    "PREB proteo",
    "PREB rna"
  ],
  "PRELID1": [
    "PRELID1 cnv",
    "PRELID1 methyl",
    "PRELID1 rna"
  ],
  "PRELID2": [
    "PRELID2 cnv",
    "PRELID2 methyl",
    "PRELID2 rna"
  ],
  "PRELID3A": [
    "PRELID3A cnv",
    "PRELID3A methyl",
    "PRELID3A rna"
  ],
  "PRELID3B": [
    "PRELID3B cnv",
    "PRELID3B methyl",
    "PRELID3B rna"
  ],
  "PRELP": [
    "PRELP NSFNISNLLVLHLSHNR-N5H4F0S0G0 glyco",
    "PRELP cnv",
    "PRELP proteo",
    "PRELP rna"
  ],
  "PREP": [
    "PREP cnv",
    "PREP methyl",
    "PREP proteo",
    "PREP rna"
  ],
  "PREPL": [
    "PREPL cnv",
    "PREPL methyl",
    "PREPL proteo",
    "PREPL rna"
  ],
  "PREX1": [
    "PREX1 1001_1029_1_1_S1001 phospho",
    "PREX1 1049_1056_1_1_S1049 phospho",
    "PREX1 1188_1200_1_1_S1200 phospho",
    "PREX1 1256_1256_1_1_S1256 phospho",
    "PREX1 cnv",
    "PREX1 methyl",
    "PREX1 proteo",
    "PREX1 rna"
  ],
  "PREX2": [
    "PREX2 1064_1073_1_1_S1065 phospho",
    "PREX2 cnv",
    "PREX2 methyl",
    "PREX2 proteo",
    "PREX2 rna"
  ],
  "PRF1": [
    "PRF1 cnv",
    "PRF1 rna"
  ],
  "PRG2": [
    "PRG2 cnv",
    "PRG2 proteo",
    "PRG2 rna"
  ],
  "PRG3": [
    "PRG3 cnv"
  ],
  "PRG4": [
    "PRG4 253_255_1_1_T253 phospho",
    "PRG4 cnv",
    "PRG4 proteo",
    "PRG4 rna"
  ],
  "PRH1": [
    "PRH1 cnv",
    "PRH1 methyl",
    "PRH1 rna"
  ],
  "PRH2": [
    "PRH2 cnv",
    "PRH2 rna"
  ],
  "PRICKLE1": [
    "PRICKLE1 681_691_1_1_S683 phospho",
    "PRICKLE1 cnv",
    "PRICKLE1 methyl",
    "PRICKLE1 rna"
  ],
  "PRICKLE2": [
    "PRICKLE2 311_324_1_1_S319 phospho",
    "PRICKLE2 452_463_1_1_S463 phospho",
    "PRICKLE2 571_576_1_1_S571 phospho",
    "PRICKLE2 642_652_1_1_S642 phospho",
    "PRICKLE2 693_703_1_1_S695 phospho",
    "PRICKLE2 751_753_1_1_S753 phospho",
    "PRICKLE2 803_806_1_1_S806 phospho",
    "PRICKLE2 cnv",
    "PRICKLE2 methyl",
    "PRICKLE2 proteo",
    "PRICKLE2 rna"
  ],
  "PRICKLE2-DT": [
    "PRICKLE2-DT methyl"
  ],
  "PRICKLE3": [
    "PRICKLE3 methyl",
    "PRICKLE3 rna"
  ],
  "PRICKLE4": [
    "PRICKLE4 cnv",
    "PRICKLE4 methyl",
    "PRICKLE4 rna"
  ],
  "PRIM1": [
    "PRIM1 cnv",
    "PRIM1 methyl",
    "PRIM1 proteo",
    "PRIM1 rna"
  ],
  "PRIM2": [
    "PRIM2 cnv",
    "PRIM2 proteo",
    "PRIM2 rna"
  ],
  "PRIMA1": [
    "PRIMA1 cnv",
    "PRIMA1 methyl",
    "PRIMA1 rna"
  ],
  "PRIMPOL": [
    "PRIMPOL cnv",
    "PRIMPOL methyl",
    "PRIMPOL proteo",
    "PRIMPOL rna"
  ],
  "PRKAA1": [
    "PRKAA1 326_342_1_1_S330 phospho",
    "PRKAA1 476_482_1_1_S480 phospho",
    "PRKAA1 480_482_1_1_S482 phospho",
    "PRKAA1 cnv",
    "PRKAA1 kinase",
    "PRKAA1 methyl",
    "PRKAA1 proteo",
    "PRKAA1 rna"
  ],
  "PRKAA2": [
    "PRKAA2 338_355_1_0 phospho",
    "PRKAA2 cnv",
    "PRKAA2 kinase",
    "PRKAA2 methyl",
    "PRKAA2 proteo",
    "PRKAA2 rna"
  ],
  "PRKAB1": [
    "PRKAB1 174_192_1_0 phospho",
    "PRKAB1 174_192_1_1_S182 phospho",
    "PRKAB1 24_28_1_1_S24 phospho",
    "PRKAB1 cnv",
    "PRKAB1 methyl",
    "PRKAB1 proteo",
    "PRKAB1 rna"
  ],
  "PRKAB2": [
    "PRKAB2 182_194_1_1_S184 phospho",
    "PRKAB2 21_21_1_1_S21 phospho",
    "PRKAB2 39_51_1_0 phospho",
    "PRKAB2 cnv",
    "PRKAB2 methyl",
    "PRKAB2 proteo",
    "PRKAB2 rna"
  ],
  "PRKACA": [
    "PRKACA 401_415_1_1_S415 phospho",
    "PRKACA cnv",
    "PRKACA kinase",
    "PRKACA methyl",
    "PRKACA proteo",
    "PRKACA rna"
  ],
  "PRKACB": [
    "PRKACB 326_345_1_1_S343 phospho",
    "PRKACB 34_34_1_1_S34 phospho",
    "PRKACB 7_19_1_1_S8 phospho",
    "PRKACB 7_21_1_1_S8 phospho",
    "PRKACB cnv",
    "PRKACB kinase",
    "PRKACB methyl",
    "PRKACB proteo",
    "PRKACB rna"
  ],
  "PRKACG": [
    "PRKACG cnv",
    "PRKACG kinase",
    "PRKACG rna"
  ],
  "PRKAG1": [
    "PRKAG1 cnv",
    "PRKAG1 methyl",
    "PRKAG1 proteo",
    "PRKAG1 rna"
  ],
  "PRKAG2": [
    "PRKAG2 148_156_1_1_S152 phospho",
    "PRKAG2 163_182_1_1_S175 phospho",
    "PRKAG2 21_29_2_2_S21S27 phospho",
    "PRKAG2 cnv",
    "PRKAG2 methyl",
    "PRKAG2 proteo",
    "PRKAG2 rna"
  ],
  "PRKAG3": [
    "PRKAG3 cnv",
    "PRKAG3 rna"
  ],
  "PRKAR1A": [
    "PRKAR1A 73_83_1_1_S77 phospho",
    "PRKAR1A 75_83_1_1_S83 phospho",
    "PRKAR1A 75_83_2_2_S77S83 phospho",
    "PRKAR1A 83_83_1_1_S83 phospho",
    "PRKAR1A cnv",
    "PRKAR1A methyl",
    "PRKAR1A proteo",
    "PRKAR1A rna"
  ],
  "PRKAR1B": [
    "PRKAR1B 71_85_1_1_S83 phospho",
    "PRKAR1B cnv",
    "PRKAR1B methyl",
    "PRKAR1B proteo",
    "PRKAR1B rna"
  ],
  "PRKAR1B-AS2": [
    "PRKAR1B-AS2 methyl"
  ],
  "PRKAR2A": [
    "PRKAR2A 395_396_1_0 phospho",
    "PRKAR2A 48_58_2_2_T54S58 phospho",
    "PRKAR2A 78_92_1_1_S78 phospho",
    "PRKAR2A 78_92_1_1_S80 phospho",
    "PRKAR2A 78_92_2_2_S78S80 phospho",
    "PRKAR2A 99_114_1_1_S99 phospho",
    "PRKAR2A cnv",
    "PRKAR2A methyl",
    "PRKAR2A proteo",
    "PRKAR2A rna"
  ],
  "PRKAR2A-AS1": [
    "PRKAR2A-AS1 methyl"
  ],
  "PRKAR2B": [
    "PRKAR2B 114_131_1_1_S114 phospho",
    "PRKAR2B 57_71_1_1_T69 phospho",
    "PRKAR2B cnv",
    "PRKAR2B methyl",
    "PRKAR2B proteo",
    "PRKAR2B rna"
  ],
  "PRKCA": [
    "PRKCA 217_228_1_1_S226 phospho",
    "PRKCA 494_515_1_0 phospho",
    "PRKCA 494_515_1_1_T497 phospho",
    "PRKCA 494_515_1_1_T501 phospho",
    "PRKCA 638_670_1_1_T638 phospho",
    "PRKCA cnv",
    "PRKCA kinase",
    "PRKCA methyl",
    "PRKCA proteo",
    "PRKCA rna"
  ],
  "PRKCB": [
    "PRKCB 206_208_1_1_S206 phospho",
    "PRKCB 641_641_1_1_T641 phospho",
    "PRKCB 642_644_1_1_T642 phospho",
    "PRKCB 654_664_1_1_S660 phospho",
    "PRKCB cnv",
    "PRKCB kinase",
    "PRKCB methyl",
    "PRKCB proteo",
    "PRKCB rna"
  ],
  "PRKCD": [
    "PRKCD 302_313_1_0 phospho",
    "PRKCD 302_313_1_1_S302 phospho",
    "PRKCD 506_514_1_1_T507 phospho",
    "PRKCD 654_664_1_1_S664 phospho",
    "PRKCD cnv",
    "PRKCD kinase",
    "PRKCD methyl",
    "PRKCD proteo",
    "PRKCD rna"
  ],
  "PRKCE": [
    "PRKCE 228_234_1_1_S234 phospho",
    "PRKCE 329_339_1_1_S329 phospho",
    "PRKCE 329_339_1_1_S337 phospho",
    "PRKCE 329_344_1_0 phospho",
    "PRKCE 344_350_2_2_S346S350 phospho",
    "PRKCE 346_350_1_1_S346 phospho",
    "PRKCE 346_350_1_1_S350 phospho",
    "PRKCE 346_350_2_2_S346S350 phospho",
    "PRKCE 380_388_1_1_S381 phospho",
    "PRKCE 380_388_1_1_S388 phospho",
    "PRKCE 710_710_1_1_T710 phospho",
    "PRKCE 729_730_1_1_S729 phospho",
    "PRKCE cnv",
    "PRKCE kinase",
    "PRKCE methyl",
    "PRKCE proteo",
    "PRKCE rna"
  ],
  "PRKCG": [
    "PRKCG 320_332_1_1_S330 phospho",
    "PRKCG 655_655_1_1_T655 phospho",
    "PRKCG 687_690_1_1_S690 phospho",
    "PRKCG 70_70_1_1_S70 phospho",
    "PRKCG cnv",
    "PRKCG kinase",
    "PRKCG methyl",
    "PRKCG proteo",
    "PRKCG rna"
  ],
  "PRKCH": [
    "PRKCH cnv",
    "PRKCH kinase",
    "PRKCH methyl",
    "PRKCH rna"
  ],
  "PRKCI": [
    "PRKCI 409_419_1_1_T412 phospho",
    "PRKCI cnv",
    "PRKCI kinase",
    "PRKCI methyl",
    "PRKCI proteo",
    "PRKCI rna"
  ],
  "PRKCQ": [
    "PRKCQ cnv",
    "PRKCQ kinase",
    "PRKCQ methyl",
    "PRKCQ proteo",
    "PRKCQ rna"
  ],
  "PRKCQ-AS1": [
    "PRKCQ-AS1 methyl"
  ],
  "PRKCSH": [
    "PRKCSH YEQGTGCWQGPNR-N2H5F0S0G0 glyco",
    "PRKCSH YEQGTGCWQGPNR-N2H6F0S0G0 glyco",
    "PRKCSH cnv",
    "PRKCSH methyl",
    "PRKCSH proteo",
    "PRKCSH rna"
  ],
  "PRKCZ": [
    "PRKCZ cnv",
    "PRKCZ kinase",
    "PRKCZ methyl",
    "PRKCZ rna"
  ],
  "PRKCZ-AS1": [
    "PRKCZ-AS1 methyl"
  ],
  "PRKD1": [
    "PRKD1 205_214_1_1_S205 phospho",
    "PRKD1 217_236_1_1_S219 phospho",
    "PRKD1 548_554_1_1_S548 phospho",
    "PRKD1 548_554_1_1_S549 phospho",
    "PRKD1 cnv",
    "PRKD1 kinase",
    "PRKD1 methyl",
    "PRKD1 proteo",
    "PRKD1 rna"
  ],
  "PRKD2": [
    "PRKD2 197_206_1_1_S197 phospho",
    "PRKD2 197_206_2_2_S197S198 phospho",
    "PRKD2 374_378_1_0 phospho",
    "PRKD2 cnv",
    "PRKD2 kinase",
    "PRKD2 methyl",
    "PRKD2 proteo",
    "PRKD2 rna"
  ],
  "PRKD3": [
    "PRKD3 213_247_1_1_S213 phospho",
    "PRKD3 41_53_1_1_S41 phospho",
    "PRKD3 535_543_1_1_T535 phospho",
    "PRKD3 cnv",
    "PRKD3 kinase",
    "PRKD3 methyl",
    "PRKD3 rna"
  ],
  "PRKDC": [
    "PRKDC 3198_3215_1_1_S3205 phospho",
    "PRKDC 4026_4026_1_1_S4026 phospho",
    "PRKDC cnv",
    "PRKDC kinase",
    "PRKDC methyl",
    "PRKDC proteo",
    "PRKDC rna"
  ],
  "PRKG1": [
    "PRKG1 cnv",
    "PRKG1 kinase",
    "PRKG1 methyl",
    "PRKG1 proteo",
    "PRKG1 rna"
  ],
  "PRKG2": [
    "PRKG2 cnv",
    "PRKG2 kinase",
    "PRKG2 methyl",
    "PRKG2 rna"
  ],
  "PRKN": [
    "PRKN cnv",
    "PRKN methyl",
    "PRKN proteo",
    "PRKN rna"
  ],
  "PRKRA": [
    "PRKRA 18_22_1_1_S18 phospho",
    "PRKRA cnv",
    "PRKRA methyl",
    "PRKRA proteo",
    "PRKRA rna"
  ],
  "PRKRIP1": [
    "PRKRIP1 cnv",
    "PRKRIP1 methyl",
    "PRKRIP1 proteo",
    "PRKRIP1 rna"
  ],
  "PRKX": [
    "PRKX kinase",
    "PRKX methyl",
    "PRKX rna"
  ],
  "PRKY": [
    "PRKY kinase",
    "PRKY methyl"
  ],
  "PRL": [
    "PRL cnv",
    "PRL rna"
  ],
  "PRLH": [
    "PRLH cnv"
  ],
  "PRLHR": [
    "PRLHR cnv",
    "PRLHR methyl",
    "PRLHR rna"
  ],
  "PRLR": [
    "PRLR cnv",
    "PRLR rna"
  ],
  "PRM1": [
    "PRM1 cnv"
  ],
  "PRM2": [
    "PRM2 cnv"
  ],
  "PRM3": [
    "PRM3 cnv"
  ],
  "PRMT1": [
    "PRMT1 cnv",
    "PRMT1 methyl",
    "PRMT1 proteo",
    "PRMT1 rna"
  ],
  "PRMT2": [
    "PRMT2 cnv",
    "PRMT2 methyl",
    "PRMT2 proteo",
    "PRMT2 rna"
  ],
  "PRMT3": [
    "PRMT3 cnv",
    "PRMT3 methyl",
    "PRMT3 proteo",
    "PRMT3 rna"
  ],
  "PRMT5": [
    "PRMT5 cnv",
    "PRMT5 methyl",
    "PRMT5 proteo",
    "PRMT5 rna"
  ],
  "PRMT5-DT": [
    "PRMT5-DT methyl"
  ],
  "PRMT6": [
    "PRMT6 cnv",
    "PRMT6 methyl",
    "PRMT6 proteo",
    "PRMT6 rna"
  ],
  "PRMT7": [
    "PRMT7 cnv",
    "PRMT7 methyl",
    "PRMT7 proteo",
    "PRMT7 rna"
  ],
  "PRMT8": [
    "PRMT8 cnv",
    "PRMT8 methyl",
    "PRMT8 proteo",
    "PRMT8 rna"
  ],
  "PRMT9": [
    "PRMT9 cnv",
    "PRMT9 methyl",
    "PRMT9 proteo",
    "PRMT9 rna"
  ],
  "PRND": [
    "PRND cnv",
    "PRND rna"
  ],
  "PRNP": [
    "PRNP cnv",
    "PRNP methyl",
    "PRNP proteo",
    "PRNP rna"
  ],
  "PROB1": [
    "PROB1 260_274_1_1_S260 phospho",
    "PROB1 372_372_1_1_S372 phospho",
    "PROB1 776_777_1_1_S777 phospho",
    "PROB1 cnv",
    "PROB1 methyl",
    "PROB1 rna"
  ],
  "PROC": [
    "PROC EVFVHPNYSK-N4H5F0S2G0 glyco",
    "PROC cnv",
    "PROC methyl",
    "PROC proteo",
    "PROC rna"
  ],
  "PROCA1": [
    "PROCA1 cnv",
    "PROCA1 methyl",
    "PROCA1 rna"
  ],
  "PROCR": [
    "PROCR cnv",
    "PROCR methyl",
    "PROCR proteo",
    "PROCR rna"
  ],
  "PRODH": [
    "PRODH cnv",
    "PRODH methyl",
    "PRODH proteo",
    "PRODH rna"
  ],
  "PRODH2": [
    "PRODH2 cnv"
  ],
  "PROK1": [
    "PROK1 cnv",
    "PROK1 rna"
  ],
  "PROK2": [
    "PROK2 cnv",
    "PROK2 methyl",
    "PROK2 rna"
  ],
  "PROKR1": [
    "PROKR1 cnv",
    "PROKR1 methyl",
    "PROKR1 rna"
  ],
  "PROKR2": [
    "PROKR2 cnv",
    "PROKR2 methyl",
    "PROKR2 rna"
  ],
  "PROM1": [
    "PROM1 YILAQYNTTK-N5H3F1S0G0 glyco",
    "PROM1 cnv",
    "PROM1 methyl",
    "PROM1 proteo",
    "PROM1 rna"
  ],
  "PROM2": [
    "PROM2 cnv",
    "PROM2 rna"
  ],
  "PROP1": [
    "PROP1 cnv",
    "PROP1 rna"
  ],
  "PRORP": [
    "PRORP cnv",
    "PRORP methyl",
    "PRORP proteo",
    "PRORP rna"
  ],
  "PRORSD1P": [
    "PRORSD1P methyl"
  ],
  "PROS1": [
    "PROS1 cnv",
    "PROS1 methyl",
    "PROS1 proteo",
    "PROS1 rna"
  ],
  "PROSER1": [
    "PROSER1 609_617_1_1_S613 phospho",
    "PROSER1 cnv",
    "PROSER1 methyl",
    "PROSER1 proteo",
    "PROSER1 rna"
  ],
  "PROSER2": [
    "PROSER2 cnv",
    "PROSER2 methyl",
    "PROSER2 proteo",
    "PROSER2 rna"
  ],
  "PROSER2-AS1": [
    "PROSER2-AS1 methyl"
  ],
  "PROSER3": [
    "PROSER3 cnv",
    "PROSER3 methyl",
    "PROSER3 rna"
  ],
  "PROX1": [
    "PROX1 177_181_1_1_S179 phospho",
    "PROX1 220_226_1_1_S220 phospho",
    "PROX1 291_295_1_1_S295 phospho",
    "PROX1 511_518_1_1_S511 phospho",
    "PROX1 79_94_1_0 phospho",
    "PROX1 cnv",
    "PROX1 methyl",
    "PROX1 proteo",
    "PROX1 rna"
  ],
  "PROX2": [
    "PROX2 cnv",
    "PROX2 rna"
  ],
  "PROZ": [
    "PROZ cnv",
    "PROZ proteo",
    "PROZ rna"
  ],
  "PRPF18": [
    "PRPF18 cnv",
    "PRPF18 methyl",
    "PRPF18 proteo",
    "PRPF18 rna"
  ],
  "PRPF19": [
    "PRPF19 cnv",
    "PRPF19 methyl",
    "PRPF19 proteo",
    "PRPF19 rna"
  ],
  "PRPF3": [
    "PRPF3 619_619_1_1_S619 phospho",
    "PRPF3 cnv",
    "PRPF3 methyl",
    "PRPF3 proteo",
    "PRPF3 rna"
  ],
  "PRPF31": [
    "PRPF31 445_455_2_1_T455 phospho",
    "PRPF31 cnv",
    "PRPF31 methyl",
    "PRPF31 proteo",
    "PRPF31 rna"
  ],
  "PRPF38A": [
    "PRPF38A 209_209_1_1_S209 phospho",
    "PRPF38A cnv",
    "PRPF38A methyl",
    "PRPF38A proteo",
    "PRPF38A rna"
  ],
  "PRPF38B": [
    "PRPF38B 473_481_2_2_S473S475 phospho",
    "PRPF38B 527_534_1_1_S527 phospho",
    "PRPF38B 527_534_2_2_S527S529 phospho",
    "PRPF38B cnv",
    "PRPF38B methyl",
    "PRPF38B proteo",
    "PRPF38B rna"
  ],
  "PRPF39": [
    "PRPF39 cnv",
    "PRPF39 proteo",
    "PRPF39 rna"
  ],
  "PRPF4": [
    "PRPF4 cnv",
    "PRPF4 methyl",
    "PRPF4 proteo",
    "PRPF4 rna"
  ],
  "PRPF40A": [
    "PRPF40A 838_843_3_3_S838S840S843 phospho",
    "PRPF40A 882_893_1_1_S893 phospho",
    "PRPF40A cnv",
    "PRPF40A methyl",
    "PRPF40A proteo",
    "PRPF40A rna"
  ],
  "PRPF40B": [
    "PRPF40B 785_788_1_1_S785 phospho",
    "PRPF40B 853_853_1_1_S853 phospho",
    "PRPF40B cnv",
    "PRPF40B methyl",
    "PRPF40B proteo",
    "PRPF40B rna"
  ],
  "PRPF4B": [
    "PRPF4B 131_144_2_0 phospho",
    "PRPF4B 131_144_2_2_S142S144 phospho",
    "PRPF4B 20_20_1_1_S20 phospho",
    "PRPF4B 20_36_2_2_S20S23 phospho",
    "PRPF4B 23_36_1_1_S23 phospho",
    "PRPF4B 23_36_2_2_S23S32 phospho",
    "PRPF4B 23_36_2_2_S32S36 phospho",
    "PRPF4B 257_259_1_1_S257 phospho",
    "PRPF4B 277_283_1_1_S277 phospho",
    "PRPF4B 292_294_1_1_S294 phospho",
    "PRPF4B 366_368_1_1_S368 phospho",
    "PRPF4B 427_431_1_1_S431 phospho",
    "PRPF4B 576_580_2_2_S578S580 phospho",
    "PRPF4B 837_852_1_1_Y849 phospho",
    "PRPF4B 87_93_2_2_S87S93 phospho",
    "PRPF4B 93_93_1_1_S93 phospho",
    "PRPF4B cnv",
    "PRPF4B kinase",
    "PRPF4B methyl",
    "PRPF4B proteo",
    "PRPF4B rna"
  ],
  "PRPF6": [
    "PRPF6 cnv",
    "PRPF6 methyl",
    "PRPF6 proteo",
    "PRPF6 rna"
  ],
  "PRPF8": [
    "PRPF8 cnv",
    "PRPF8 methyl",
    "PRPF8 proteo",
    "PRPF8 rna"
  ],
  "PRPH": [
    "PRPH 20_38_1_1_S28 phospho",
    "PRPH cnv",
    "PRPH methyl",
    "PRPH proteo",
    "PRPH rna"
  ],
  "PRPH2": [
    "PRPH2 cnv",
    "PRPH2 rna"
  ],
  "PRPS1": [
    "PRPS1 methyl",
    "PRPS1 proteo",
    "PRPS1 rna"
  ],
  "PRPS1L1": [
    "PRPS1L1 cnv",
    "PRPS1L1 rna"
  ],
  "PRPS2": [
    "PRPS2 methyl",
    "PRPS2 proteo",
    "PRPS2 rna"
  ],
  "PRPSAP1": [
    "PRPSAP1 234_244_1_1_S244 phospho",
    "PRPSAP1 cnv",
    "PRPSAP1 methyl",
    "PRPSAP1 proteo",
    "PRPSAP1 rna"
  ],
  "PRPSAP2": [
    "PRPSAP2 179_187_1_1_S187 phospho",
    "PRPSAP2 cnv",
    "PRPSAP2 methyl",
    "PRPSAP2 proteo",
    "PRPSAP2 rna"
  ],
  "PRR11": [
    "PRR11 cnv",
    "PRR11 methyl",
    "PRR11 rna"
  ],
  "PRR12": [
    "PRR12 1299_1308_1_1_S1308 phospho",
    "PRR12 1554_1568_2_2_T1561S1568 phospho",
    "PRR12 332_347_1_1_S332 phospho",
    "PRR12 433_470_1_1_S444 phospho",
    "PRR12 915_921_1_1_S917 phospho",
    "PRR12 cnv",
    "PRR12 methyl",
    "PRR12 proteo",
    "PRR12 rna"
  ],
  "PRR13": [
    "PRR13 cnv",
    "PRR13 methyl",
    "PRR13 rna"
  ],
  "PRR14": [
    "PRR14 cnv",
    "PRR14 methyl",
    "PRR14 rna"
  ],
  "PRR14L": [
    "PRR14L 1018_1029_1_1_S1029 phospho",
    "PRR14L cnv",
    "PRR14L methyl",
    "PRR14L proteo",
    "PRR14L rna"
  ],
  "PRR15": [
    "PRR15 cnv",
    "PRR15 methyl",
    "PRR15 rna"
  ],
  "PRR15L": [
    "PRR15L cnv",
    "PRR15L rna"
  ],
  "PRR16": [
    "PRR16 cnv",
    "PRR16 methyl",
    "PRR16 rna"
  ],
  "PRR18": [
    "PRR18 193_200_1_1_S193 phospho",
    "PRR18 cnv",
    "PRR18 methyl",
    "PRR18 rna"
  ],
  "PRR19": [
    "PRR19 cnv",
    "PRR19 methyl",
    "PRR19 rna"
  ],
  "PRR20A": [
    "PRR20A cnv"
  ],
  "PRR20B": [
    "PRR20B cnv"
  ],
  "PRR20C": [
    "PRR20C cnv"
  ],
  "PRR20D": [
    "PRR20D cnv"
  ],
  "PRR20E": [
    "PRR20E cnv"
  ],
  "PRR20G": [
    "PRR20G cnv",
    "PRR20G rna"
  ],
  "PRR22": [
    "PRR22 cnv",
    "PRR22 methyl",
    "PRR22 rna"
  ],
  "PRR23A": [
    "PRR23A cnv",
    "PRR23A methyl"
  ],
  "PRR23B": [
    "PRR23B cnv",
    "PRR23B methyl"
  ],
  "PRR23C": [
    "PRR23C cnv",
    "PRR23C methyl"
  ],
  "PRR23D1": [
    "PRR23D1 cnv"
  ],
  "PRR23D2": [
    "PRR23D2 cnv",
    "PRR23D2 rna"
  ],
  "PRR27": [
    "PRR27 cnv"
  ],
  "PRR29": [
    "PRR29 cnv",
    "PRR29 methyl",
    "PRR29 rna"
  ],
  "PRR3": [
    "PRR3 cnv",
    "PRR3 methyl",
    "PRR3 proteo",
    "PRR3 rna"
  ],
  "PRR30": [
    "PRR30 cnv"
  ],
  "PRR32": [
    "PRR32 rna"
  ],
  "PRR33": [
    "PRR33 cnv",
    "PRR33 rna"
  ],
  "PRR35": [
    "PRR35 cnv",
    "PRR35 methyl",
    "PRR35 rna"
  ],
  "PRR36": [
    "PRR36 109_116_2_2_S110S116 phospho",
    "PRR36 1136_1163_1_1_S1147 phospho",
    "PRR36 164_173_1_1_S173 phospho",
    "PRR36 208_221_1_1_S221 phospho",
    "PRR36 cnv",
    "PRR36 methyl",
    "PRR36 proteo",
    "PRR36 rna"
  ],
  "PRR4": [
    "PRR4 cnv",
    "PRR4 rna"
  ],
  "PRR5": [
    "PRR5 231_231_1_1_S231 phospho",
    "PRR5 245_268_1_1_S245 phospho",
    "PRR5 cnv",
    "PRR5 methyl",
    "PRR5 proteo",
    "PRR5 rna"
  ],
  "PRR5-ARHGAP8": [
    "PRR5-ARHGAP8 cnv",
    "PRR5-ARHGAP8 methyl",
    "PRR5-ARHGAP8 rna"
  ],
  "PRR5L": [
    "PRR5L cnv",
    "PRR5L methyl",
    "PRR5L rna"
  ],
  "PRR7": [
    "PRR7 cnv",
    "PRR7 methyl",
    "PRR7 rna"
  ],
  "PRR9": [
    "PRR9 cnv"
  ],
  "PRRC1": [
    "PRRC1 cnv",
    "PRRC1 methyl",
    "PRRC1 proteo",
    "PRRC1 rna"
  ],
  "PRRC2A": [
    "PRRC2A 1083_1094_1_1_S1089 phospho",
    "PRRC2A 1083_1094_2_2_S1085S1089 phospho",
    "PRRC2A 141_148_1_1_S146 phospho",
    "PRRC2A 166_172_1_1_S166 phospho",
    "PRRC2A 1690_1704_1_0 phospho",
    "PRRC2A 342_350_2_2_S342S350 phospho",
    "PRRC2A 380_387_1_1_S380 phospho",
    "PRRC2A 609_610_1_0 phospho",
    "PRRC2A 671_686_1_1_T686 phospho",
    "PRRC2A 797_808_1_1_S808 phospho",
    "PRRC2A 997_1004_1_1_S1004 phospho",
    "PRRC2A cnv",
    "PRRC2A methyl",
    "PRRC2A proteo",
    "PRRC2A rna"
  ],
  "PRRC2B": [
    "PRRC2B 1132_1141_1_1_S1136 phospho",
    "PRRC2B 1395_1409_1_1_S1395 phospho",
    "PRRC2B 1690_1702_1_1_S1691 phospho",
    "PRRC2B 219_232_1_1_S226 phospho",
    "PRRC2B 388_388_1_1_S388 phospho",
    "PRRC2B 416_422_1_0 phospho",
    "PRRC2B 556_558_1_1_S556 phospho",
    "PRRC2B 563_563_1_1_S563 phospho",
    "PRRC2B 853_853_1_1_S853 phospho",
    "PRRC2B 907_919_1_1_S907 phospho",
    "PRRC2B cnv",
    "PRRC2B methyl",
    "PRRC2B proteo",
    "PRRC2B rna"
  ],
  "PRRC2C": [
    "PRRC2C 1246_1249_1_1_S1249 phospho",
    "PRRC2C 1962_1974_1_1_T1965 phospho",
    "PRRC2C 2105_2105_1_1_S2105 phospho",
    "PRRC2C 2691_2700_1_1_S2694 phospho",
    "PRRC2C 866_867_1_1_S867 phospho",
    "PRRC2C 924_932_1_0 phospho",
    "PRRC2C 924_932_1_1_S924 phospho",
    "PRRC2C cnv",
    "PRRC2C methyl",
    "PRRC2C proteo",
    "PRRC2C rna"
  ],
  "PRRG1": [
    "PRRG1 methyl",
    "PRRG1 rna"
  ],
  "PRRG2": [
    "PRRG2 cnv",
    "PRRG2 methyl",
    "PRRG2 rna"
  ],
  "PRRG3": [
    "PRRG3 methyl",
    "PRRG3 proteo",
    "PRRG3 rna"
  ],
  "PRRG4": [
    "PRRG4 cnv",
    "PRRG4 methyl",
    "PRRG4 rna"
  ],
  "PRRT1": [
    "PRRT1 cnv",
    "PRRT1 methyl",
    "PRRT1 proteo",
    "PRRT1 rna"
  ],
  "PRRT1B": [
    "PRRT1B cnv",
    "PRRT1B rna"
  ],
  "PRRT2": [
    "PRRT2 100_115_1_1_S100 phospho",
    "PRRT2 100_124_1_1_S100 phospho",
    "PRRT2 202_205_1_1_S202 phospho",
    "PRRT2 202_208_2_0 phospho",
    "PRRT2 208_208_1_1_S208 phospho",
    "PRRT2 233_238_1_1_S238 phospho",
    "PRRT2 71_95_1_1_S90 phospho",
    "PRRT2 cnv",
    "PRRT2 methyl",
    "PRRT2 proteo",
    "PRRT2 rna"
  ],
  "PRRT3": [
    "PRRT3 798_813_1_1_S808 phospho",
    "PRRT3 815_815_1_1_S815 phospho",
    "PRRT3 841_841_1_1_S841 phospho",
    "PRRT3 854_866_1_1_S854 phospho",
    "PRRT3 cnv",
    "PRRT3 methyl",
    "PRRT3 proteo",
    "PRRT3 rna"
  ],
  "PRRT3-AS1": [
    "PRRT3-AS1 methyl"
  ],
  "PRRT4": [
    "PRRT4 cnv",
    "PRRT4 methyl",
    "PRRT4 rna"
  ],
  "PRRX1": [
    "PRRX1 cnv",
    "PRRX1 proteo",
    "PRRX1 rna"
  ],
  "PRRX2": [
    "PRRX2 cnv",
    "PRRX2 methyl",
    "PRRX2 rna"
  ],
  "PRSS1": [
    "PRSS1 cnv"
  ],
  "PRSS12": [
    "PRSS12 cnv",
    "PRSS12 methyl",
    "PRSS12 rna"
  ],
  "PRSS16": [
    "PRSS16 cnv",
    "PRSS16 methyl",
    "PRSS16 rna"
  ],
  "PRSS2": [
    "PRSS2 cnv",
    "PRSS2 rna"
  ],
  "PRSS21": [
    "PRSS21 cnv",
    "PRSS21 methyl",
    "PRSS21 rna"
  ],
  "PRSS22": [
    "PRSS22 cnv",
    "PRSS22 rna"
  ],
  "PRSS23": [
    "PRSS23 cnv",
    "PRSS23 methyl",
    "PRSS23 rna"
  ],
  "PRSS27": [
    "PRSS27 cnv",
    "PRSS27 methyl",
    "PRSS27 rna"
  ],
  "PRSS3": [
    "PRSS3 cnv",
    "PRSS3 methyl",
    "PRSS3 rna"
  ],
  "PRSS30P": [
    "PRSS30P methyl"
  ],
  "PRSS33": [
    "PRSS33 cnv",
    "PRSS33 rna"
  ],
  "PRSS35": [
    "PRSS35 cnv",
    "PRSS35 rna"
  ],
  "PRSS36": [
    "PRSS36 cnv",
    "PRSS36 rna"
  ],
  "PRSS37": [
    "PRSS37 cnv",
    "PRSS37 rna"
  ],
  "PRSS38": [
    "PRSS38 cnv"
  ],
  "PRSS41": [
    "PRSS41 cnv",
    "PRSS41 rna"
  ],
  "PRSS42P": [
    "PRSS42P methyl"
  ],
  "PRSS45P": [
    "PRSS45P cnv",
    "PRSS45P rna"
  ],
  "PRSS48": [
    "PRSS48 cnv",
    "PRSS48 rna"
  ],
  "PRSS50": [
    "PRSS50 cnv",
    "PRSS50 methyl",
    "PRSS50 rna"
  ],
  "PRSS51": [
    "PRSS51 cnv",
    "PRSS51 rna"
  ],
  "PRSS53": [
    "PRSS53 cnv",
    "PRSS53 methyl",
    "PRSS53 rna"
  ],
  "PRSS54": [
    "PRSS54 cnv",
    "PRSS54 rna"
  ],
  "PRSS55": [
    "PRSS55 cnv",
    "PRSS55 rna"
  ],
  "PRSS56": [
    "PRSS56 cnv",
    "PRSS56 methyl",
    "PRSS56 rna"
  ],
  "PRSS57": [
    "PRSS57 cnv",
    "PRSS57 rna"
  ],
  "PRSS58": [
    "PRSS58 cnv"
  ],
  "PRSS8": [
    "PRSS8 cnv",
    "PRSS8 rna"
  ],
  "PRTFDC1": [
    "PRTFDC1 cnv",
    "PRTFDC1 proteo",
    "PRTFDC1 rna"
  ],
  "PRTG": [
    "PRTG cnv",
    "PRTG methyl",
    "PRTG rna"
  ],
  "PRTN3": [
    "PRTN3 cnv",
    "PRTN3 proteo",
    "PRTN3 rna"
  ],
  "PRUNE1": [
    "PRUNE1 266_268_1_1_S268 phospho",
    "PRUNE1 338_361_1_1_S346 phospho",
    "PRUNE1 cnv",
    "PRUNE1 methyl",
    "PRUNE1 proteo",
    "PRUNE1 rna"
  ],
  "PRUNE2": [
    "PRUNE2 1262_1281_1_1_S1264 phospho",
    "PRUNE2 1788_1803_1_0 phospho",
    "PRUNE2 1788_1803_1_1_S1803 phospho",
    "PRUNE2 1788_1803_2_1_S1803 phospho",
    "PRUNE2 2211_2211_1_1_S2211 phospho",
    "PRUNE2 2860_2871_1_1_S2866 phospho",
    "PRUNE2 562_581_1_1_S576 phospho",
    "PRUNE2 586_597_1_1_S586 phospho",
    "PRUNE2 586_597_1_1_S597 phospho",
    "PRUNE2 699_701_1_1_S699 phospho",
    "PRUNE2 883_893_1_1_T889 phospho",
    "PRUNE2 cnv",
    "PRUNE2 methyl",
    "PRUNE2 proteo",
    "PRUNE2 rna"
  ],
  "PRX": [
    "PRX 1401_1401_1_1_S1401 phospho",
    "PRX cnv",
    "PRX methyl",
    "PRX rna"
  ],
  "PRXL2A": [
    "PRXL2A cnv",
    "PRXL2A methyl",
    "PRXL2A proteo",
    "PRXL2A rna"
  ],
  "PRXL2B": [
    "PRXL2B cnv",
    "PRXL2B methyl",
    "PRXL2B proteo",
    "PRXL2B rna"
  ],
  "PRXL2C": [
    "PRXL2C cnv",
    "PRXL2C methyl",
    "PRXL2C rna"
  ],
  "PRY": [
    "PRY rna"
  ],
  "PRYP3": [
    "PRYP3 rna"
  ],
  "PSAP": [
    "PSAP DNATEEEILVYLEK-N2H3F1S0G0 glyco",
    "PSAP DNATEEEILVYLEK-N2H5F0S0G0 glyco",
    "PSAP DVVTAAGDMLKDNATEEEILVYLEK-N2H3F1S0G0 glyco",
    "PSAP LIDNNKTEK-N2H3F0S0G0 glyco",
    "PSAP LIDNNKTEK-N2H3F1S0G0 glyco",
    "PSAP LIDNNKTEK-N2H4F0S0G0 glyco",
    "PSAP LIDNNKTEK-N2H4F1S0G0 glyco",
    "PSAP LIDNNKTEK-N2H5F0S0G0 glyco",
    "PSAP LIDNNKTEK-N2H5F1S0G0 glyco",
    "PSAP LIDNNKTEK-N2H6F0S0G0 glyco",
    "PSAP LIDNNKTEK-N2H6F1S0G0 glyco",
    "PSAP LIDNNKTEK-N2H7F0S0G0 glyco",
    "PSAP NSTKQEILAALEK-N2H3F0S0G0 glyco",
    "PSAP NSTKQEILAALEK-N2H3F1S0G0 glyco",
    "PSAP NSTKQEILAALEK-N2H4F0S0G0 glyco",
    "PSAP NSTKQEILAALEK-N2H4F1S0G0 glyco",
    "PSAP NSTKQEILAALEK-N2H5F0S0G0 glyco",
    "PSAP NSTKQEILAALEK-N2H5F1S0G0 glyco",
    "PSAP NSTKQEILAALEK-N2H6F0S0G0 glyco",
    "PSAP NSTKQEILAALEK-N2H6F1S0G0 glyco",
    "PSAP NSTKQEILAALEK-N2H8F0S0G0 glyco",
    "PSAP TCDWLPKPNMSASCK-N2H3F0S0G0 glyco",
    "PSAP TCDWLPKPNMSASCK-N2H3F1S0G0 glyco",
    "PSAP TCDWLPKPNMSASCK-N3H4F1S1G0 glyco",
    "PSAP TNSTFVQALVEHVK-N2H3F1S0G0 glyco",
    "PSAP TNSTFVQALVEHVK-N3H5F1S0G0 glyco",
    "PSAP TNSTFVQALVEHVKEECDR-N2H3F0S0G0 glyco",
    "PSAP TNSTFVQALVEHVKEECDR-N2H3F1S0G0 glyco",
    "PSAP cnv",
    "PSAP methyl",
    "PSAP proteo",
    "PSAP rna"
  ],
  "PSAPL1": [
    "PSAPL1 cnv",
    "PSAPL1 rna"
  ],
  "PSAT1": [
    "PSAT1 20_20_1_1_S20 phospho",
    "PSAT1 331_331_1_1_S331 phospho",
    "PSAT1 cnv",
    "PSAT1 methyl",
    "PSAT1 proteo",
    "PSAT1 rna"
  ],
  "PSCA": [
    "PSCA cnv",
    "PSCA methyl",
    "PSCA rna"
  ],
  "PSD": [
    "PSD 154_156_1_1_S156 phospho",
    "PSD 244_269_1_1_S263 phospho",
    "PSD 720_722_1_1_S720 phospho",
    "PSD 81_99_1_0 phospho",
    "PSD cnv",
    "PSD methyl",
    "PSD proteo",
    "PSD rna"
  ],
  "PSD2": [
    "PSD2 191_220_1_1_S191 phospho",
    "PSD2 36_45_1_1_S45 phospho",
    "PSD2 523_532_1_1_T532 phospho",
    "PSD2 746_760_1_1_S748 phospho",
    "PSD2 746_760_1_1_S749 phospho",
    "PSD2 746_760_2_2_S748S749 phospho",
    "PSD2 cnv",
    "PSD2 methyl",
    "PSD2 proteo",
    "PSD2 rna"
  ],
  "PSD3": [
    "PSD3 1008_1022_1_0 phospho",
    "PSD3 1008_1022_1_1_S1011 phospho",
    "PSD3 1008_1022_1_1_T1018 phospho",
    "PSD3 1008_1022_2_0 phospho",
    "PSD3 1008_1022_2_2_S1010S1011 phospho",
    "PSD3 1008_1022_2_2_S1010S1019 phospho",
    "PSD3 1008_1022_2_2_S1011S1019 phospho",
    "PSD3 1008_1022_3_3_S1010S1011S1019 phospho",
    "PSD3 1039_1041_1_1_T1039 phospho",
    "PSD3 747_752_1_1_S747 phospho",
    "PSD3 804_804_1_1_T804 phospho",
    "PSD3 915_924_1_1_S915 phospho",
    "PSD3 cnv",
    "PSD3 methyl",
    "PSD3 proteo",
    "PSD3 rna"
  ],
  "PSD4": [
    "PSD4 129_143_2_2_S134S143 phospho",
    "PSD4 cnv",
    "PSD4 methyl",
    "PSD4 rna"
  ],
  "PSEN1": [
    "PSEN1 365_367_1_1_S367 phospho",
    "PSEN1 43_59_1_1_S43 phospho",
    "PSEN1 cnv",
    "PSEN1 methyl",
    "PSEN1 proteo",
    "PSEN1 rna"
  ],
  "PSEN2": [
    "PSEN2 18_27_1_1_S25 phospho",
    "PSEN2 cnv",
    "PSEN2 methyl",
    "PSEN2 rna"
  ],
  "PSENEN": [
    "PSENEN cnv",
    "PSENEN methyl",
    "PSENEN rna"
  ],
  "PSG1": [
    "PSG1 cnv",
    "PSG1 rna"
  ],
  "PSG11": [
    "PSG11 cnv",
    "PSG11 rna"
  ],
  "PSG2": [
    "PSG2 cnv"
  ],
  "PSG3": [
    "PSG3 cnv"
  ],
  "PSG4": [
    "PSG4 cnv",
    "PSG4 rna"
  ],
  "PSG5": [
    "PSG5 cnv",
    "PSG5 rna"
  ],
  "PSG6": [
    "PSG6 cnv"
  ],
  "PSG7": [
    "PSG7 cnv"
  ],
  "PSG8": [
    "PSG8 cnv"
  ],
  "PSG9": [
    "PSG9 cnv",
    "PSG9 rna"
  ],
  "PSIP1": [
    "PSIP1 102_106_1_1_S106 phospho",
    "PSIP1 102_122_2_1_S106 phospho",
    "PSIP1 115_134_2_2_T122S129 phospho",
    "PSIP1 122_134_1_1_S129 phospho",
    "PSIP1 122_134_2_2_T122S129 phospho",
    "PSIP1 140_141_1_1_T141 phospho",
    "PSIP1 159_177_1_1_S177 phospho",
    "PSIP1 206_212_1_1_S206 phospho",
    "PSIP1 267_275_1_1_S273 phospho",
    "PSIP1 267_275_1_1_S275 phospho",
    "PSIP1 267_275_2_2_S273S275 phospho",
    "PSIP1 cnv",
    "PSIP1 methyl",
    "PSIP1 proteo",
    "PSIP1 rna"
  ],
  "PSKH1": [
    "PSKH1 cnv",
    "PSKH1 kinase",
    "PSKH1 methyl",
    "PSKH1 rna"
  ],
  "PSKH2": [
    "PSKH2 cnv",
    "PSKH2 kinase",
    "PSKH2 methyl",
    "PSKH2 rna"
  ],
  "PSMA1": [
    "PSMA1 cnv",
    "PSMA1 methyl",
    "PSMA1 proteo",
    "PSMA1 rna"
  ],
  "PSMA2": [
    "PSMA2 cnv",
    "PSMA2 methyl",
    "PSMA2 proteo",
    "PSMA2 rna"
  ],
  "PSMA3": [
    "PSMA3 243_250_1_1_S250 phospho",
    "PSMA3 cnv",
    "PSMA3 methyl",
    "PSMA3 proteo",
    "PSMA3 rna"
  ],
  "PSMA3-AS1": [
    "PSMA3-AS1 methyl"
  ],
  "PSMA4": [
    "PSMA4 cnv",
    "PSMA4 methyl",
    "PSMA4 proteo",
    "PSMA4 rna"
  ],
  "PSMA5": [
    "PSMA5 cnv",
    "PSMA5 methyl",
    "PSMA5 proteo",
    "PSMA5 rna"
  ],
  "PSMA6": [
    "PSMA6 cnv",
    "PSMA6 methyl",
    "PSMA6 proteo",
    "PSMA6 rna"
  ],
  "PSMA7": [
    "PSMA7 cnv",
    "PSMA7 methyl",
    "PSMA7 proteo",
    "PSMA7 rna"
  ],
  "PSMA8": [
    "PSMA8 cnv",
    "PSMA8 methyl",
    "PSMA8 rna"
  ],
  "PSMB1": [
    "PSMB1 cnv",
    "PSMB1 methyl",
    "PSMB1 proteo",
    "PSMB1 rna"
  ],
  "PSMB10": [
    "PSMB10 227_232_1_1_S230 phospho",
    "PSMB10 cnv",
    "PSMB10 methyl",
    "PSMB10 proteo",
    "PSMB10 rna"
  ],
  "PSMB11": [
    "PSMB11 cnv",
    "PSMB11 rna"
  ],
  "PSMB2": [
    "PSMB2 cnv",
    "PSMB2 methyl",
    "PSMB2 proteo",
    "PSMB2 rna"
  ],
  "PSMB3": [
    "PSMB3 cnv",
    "PSMB3 methyl",
    "PSMB3 proteo",
    "PSMB3 rna"
  ],
  "PSMB4": [
    "PSMB4 cnv",
    "PSMB4 methyl",
    "PSMB4 proteo",
    "PSMB4 rna"
  ],
  "PSMB5": [
    "PSMB5 247_262_1_1_T262 phospho",
    "PSMB5 cnv",
    "PSMB5 proteo",
    "PSMB5 rna"
  ],
  "PSMB6": [
    "PSMB6 cnv",
    "PSMB6 methyl",
    "PSMB6 proteo",
    "PSMB6 rna"
  ],
  "PSMB7": [
    "PSMB7 cnv",
    "PSMB7 methyl",
    "PSMB7 proteo",
    "PSMB7 rna"
  ],
  "PSMB8": [
    "PSMB8 cnv",
    "PSMB8 methyl",
    "PSMB8 proteo",
    "PSMB8 rna"
  ],
  "PSMB8-AS1": [
    "PSMB8-AS1 methyl"
  ],
  "PSMB9": [
    "PSMB9 cnv",
    "PSMB9 methyl",
    "PSMB9 proteo",
    "PSMB9 rna"
  ],
  "PSMC1": [
    "PSMC1 53_56_1_1_T53 phospho",
    "PSMC1 cnv",
    "PSMC1 methyl",
    "PSMC1 proteo",
    "PSMC1 rna"
  ],
  "PSMC2": [
    "PSMC2 cnv",
    "PSMC2 methyl",
    "PSMC2 proteo",
    "PSMC2 rna"
  ],
  "PSMC3": [
    "PSMC3 cnv",
    "PSMC3 methyl",
    "PSMC3 proteo",
    "PSMC3 rna"
  ],
  "PSMC3IP": [
    "PSMC3IP cnv",
    "PSMC3IP methyl",
    "PSMC3IP proteo",
    "PSMC3IP rna"
  ],
  "PSMC4": [
    "PSMC4 cnv",
    "PSMC4 methyl",
    "PSMC4 proteo",
    "PSMC4 rna"
  ],
  "PSMC5": [
    "PSMC5 cnv",
    "PSMC5 methyl",
    "PSMC5 proteo",
    "PSMC5 rna"
  ],
  "PSMC6": [
    "PSMC6 cnv",
    "PSMC6 methyl",
    "PSMC6 proteo",
    "PSMC6 rna"
  ],
  "PSMD1": [
    "PSMD1 270_290_1_1_T273 phospho",
    "PSMD1 270_299_1_1_T273 phospho",
    "PSMD1 303_315_1_1_T311 phospho",
    "PSMD1 303_315_2_2_T311S315 phospho",
    "PSMD1 303_322_2_2_T311S315 phospho",
    "PSMD1 311_315_1_1_S315 phospho",
    "PSMD1 311_322_1_1_S315 phospho",
    "PSMD1 cnv",
    "PSMD1 methyl",
    "PSMD1 proteo",
    "PSMD1 rna"
  ],
  "PSMD10": [
    "PSMD10 108_115_1_1_S115 phospho",
    "PSMD10 methyl",
    "PSMD10 proteo",
    "PSMD10 rna"
  ],
  "PSMD11": [
    "PSMD11 cnv",
    "PSMD11 methyl",
    "PSMD11 proteo",
    "PSMD11 rna"
  ],
  "PSMD12": [
    "PSMD12 cnv",
    "PSMD12 methyl",
    "PSMD12 proteo",
    "PSMD12 rna"
  ],
  "PSMD13": [
    "PSMD13 cnv",
    "PSMD13 methyl",
    "PSMD13 proteo",
    "PSMD13 rna"
  ],
  "PSMD14": [
    "PSMD14 cnv",
    "PSMD14 methyl",
    "PSMD14 proteo",
    "PSMD14 rna"
  ],
  "PSMD2": [
    "PSMD2 16_24_1_1_S16 phospho",
    "PSMD2 16_29_1_1_S16 phospho",
    "PSMD2 cnv",
    "PSMD2 methyl",
    "PSMD2 proteo",
    "PSMD2 rna"
  ],
  "PSMD3": [
    "PSMD3 cnv",
    "PSMD3 methyl",
    "PSMD3 proteo",
    "PSMD3 rna"
  ],
  "PSMD4": [
    "PSMD4 cnv",
    "PSMD4 proteo",
    "PSMD4 rna"
  ],
  "PSMD5": [
    "PSMD5 cnv",
    "PSMD5 methyl",
    "PSMD5 proteo",
    "PSMD5 rna"
  ],
  "PSMD6": [
    "PSMD6 cnv",
    "PSMD6 methyl",
    "PSMD6 proteo",
    "PSMD6 rna"
  ],
  "PSMD7": [
    "PSMD7 cnv",
    "PSMD7 methyl",
    "PSMD7 proteo",
    "PSMD7 rna"
  ],
  "PSMD7-DT": [
    "PSMD7-DT methyl"
  ],
  "PSMD8": [
    "PSMD8 328_333_1_1_T333 phospho",
    "PSMD8 cnv",
    "PSMD8 methyl",
    "PSMD8 proteo",
    "PSMD8 rna"
  ],
  "PSMD9": [
    "PSMD9 cnv",
    "PSMD9 methyl",
    "PSMD9 proteo",
    "PSMD9 rna"
  ],
  "PSME1": [
    "PSME1 cnv",
    "PSME1 methyl",
    "PSME1 proteo",
    "PSME1 rna"
  ],
  "PSME2": [
    "PSME2 cnv",
    "PSME2 methyl",
    "PSME2 proteo",
    "PSME2 rna"
  ],
  "PSME3": [
    "PSME3 258_265_1_1_S258 phospho",
    "PSME3 34_35_1_1_S35 phospho",
    "PSME3 cnv",
    "PSME3 methyl",
    "PSME3 proteo",
    "PSME3 rna"
  ],
  "PSME3IP1": [
    "PSME3IP1 cnv",
    "PSME3IP1 methyl",
    "PSME3IP1 proteo",
    "PSME3IP1 rna"
  ],
  "PSME4": [
    "PSME4 cnv",
    "PSME4 methyl",
    "PSME4 proteo",
    "PSME4 rna"
  ],
  "PSMF1": [
    "PSMF1 152_153_1_1_S153 phospho",
    "PSMF1 152_162_1_0 phospho",
    "PSMF1 152_162_1_1_S153 phospho",
    "PSMF1 163_164_1_1_S164 phospho",
    "PSMF1 251_270_1_1_S252 phospho",
    "PSMF1 cnv",
    "PSMF1 methyl",
    "PSMF1 proteo",
    "PSMF1 rna"
  ],
  "PSMG1": [
    "PSMG1 cnv",
    "PSMG1 methyl",
    "PSMG1 proteo",
    "PSMG1 rna"
  ],
  "PSMG2": [
    "PSMG2 cnv",
    "PSMG2 methyl",
    "PSMG2 proteo",
    "PSMG2 rna"
  ],
  "PSMG3": [
    "PSMG3 cnv",
    "PSMG3 methyl",
    "PSMG3 proteo",
    "PSMG3 rna"
  ],
  "PSMG3-AS1": [
    "PSMG3-AS1 methyl"
  ],
  "PSMG4": [
    "PSMG4 cnv",
    "PSMG4 methyl",
    "PSMG4 proteo",
    "PSMG4 rna"
  ],
  "PSORS1C1": [
    "PSORS1C1 cnv",
    "PSORS1C1 rna"
  ],
  "PSORS1C2": [
    "PSORS1C2 cnv",
    "PSORS1C2 rna"
  ],
  "PSPC1": [
    "PSPC1 cnv",
    "PSPC1 methyl",
    "PSPC1 proteo",
    "PSPC1 rna"
  ],
  "PSPH": [
    "PSPH cnv",
    "PSPH methyl",
    "PSPH proteo",
    "PSPH rna"
  ],
  "PSPN": [
    "PSPN cnv",
    "PSPN rna"
  ],
  "PSRC1": [
    "PSRC1 cnv",
    "PSRC1 methyl",
    "PSRC1 proteo",
    "PSRC1 rna"
  ],
  "PSTK": [
    "PSTK cnv",
    "PSTK methyl",
    "PSTK rna"
  ],
  "PSTPIP1": [
    "PSTPIP1 cnv",
    "PSTPIP1 methyl",
    "PSTPIP1 proteo",
    "PSTPIP1 rna"
  ],
  "PSTPIP2": [
    "PSTPIP2 cnv",
    "PSTPIP2 methyl",
    "PSTPIP2 rna"
  ],
  "PTAFR": [
    "PTAFR cnv",
    "PTAFR rna"
  ],
  "PTAR1": [
    "PTAR1 cnv",
    "PTAR1 methyl",
    "PTAR1 proteo",
    "PTAR1 rna"
  ],
  "PTBP1": [
    "PTBP1 53_58_1_1_S53 phospho",
    "PTBP1 cnv",
    "PTBP1 methyl",
    "PTBP1 proteo",
    "PTBP1 rna"
  ],
  "PTBP2": [
    "PTBP2 306_316_1_1_S316 phospho",
    "PTBP2 cnv",
    "PTBP2 methyl",
    "PTBP2 proteo",
    "PTBP2 rna"
  ],
  "PTBP3": [
    "PTBP3 cnv",
    "PTBP3 methyl",
    "PTBP3 proteo",
    "PTBP3 rna"
  ],
  "PTCD1": [
    "PTCD1 cnv",
    "PTCD1 methyl",
    "PTCD1 rna"
  ],
  "PTCD2": [
    "PTCD2 cnv",
    "PTCD2 methyl",
    "PTCD2 rna"
  ],
  "PTCD3": [
    "PTCD3 cnv",
    "PTCD3 methyl",
    "PTCD3 proteo",
    "PTCD3 rna"
  ],
  "PTCH1": [
    "PTCH1 cnv",
    "PTCH1 methyl",
    "PTCH1 rna"
  ],
  "PTCH2": [
    "PTCH2 cnv",
    "PTCH2 methyl",
    "PTCH2 rna"
  ],
  "PTCHD1": [
    "PTCHD1 methyl",
    "PTCHD1 rna"
  ],
  "PTCHD3": [
    "PTCHD3 cnv",
    "PTCHD3 rna"
  ],
  "PTCHD4": [
    "PTCHD4 cnv",
    "PTCHD4 rna"
  ],
  "PTCRA": [
    "PTCRA cnv",
    "PTCRA rna"
  ],
  "PTDSS1": [
    "PTDSS1 415_429_1_0 phospho",
    "PTDSS1 439_442_1_1_S442 phospho",
    "PTDSS1 cnv",
    "PTDSS1 methyl",
    "PTDSS1 proteo",
    "PTDSS1 rna"
  ],
  "PTDSS2": [
    "PTDSS2 16_16_1_1_S16 phospho",
    "PTDSS2 cnv",
    "PTDSS2 methyl",
    "PTDSS2 proteo",
    "PTDSS2 rna"
  ],
  "PTEN": [
    "PTEN cnv",
    "PTEN methyl",
    "PTEN mut",
    "PTEN proteo",
    "PTEN rna"
  ],
  "PTENP1": [
    "PTENP1 methyl"
  ],
  "PTENP1-AS": [
    "PTENP1-AS methyl"
  ],
  "PTER": [
    "PTER cnv",
    "PTER methyl",
    "PTER proteo",
    "PTER rna"
  ],
  "PTF1A": [
    "PTF1A cnv",
    "PTF1A methyl",
    "PTF1A rna"
  ],
  "PTGDR": [
    "PTGDR cnv",
    "PTGDR methyl",
    "PTGDR rna"
  ],
  "PTGDR2": [
    "PTGDR2 cnv",
    "PTGDR2 rna"
  ],
  "PTGDS": [
    "PTGDS SVVAPATDGGLNLTSTFLR-N2H7F0S0G0 glyco",
    "PTGDS SVVAPATDGGLNLTSTFLR-N2H8F0S0G0 glyco",
    "PTGDS SVVAPATDGGLNLTSTFLR-N4H3F1S0G0 glyco",
    "PTGDS SVVAPATDGGLNLTSTFLR-N4H4F1S0G0 glyco",
    "PTGDS SVVAPATDGGLNLTSTFLR-N4H4F1S1G0 glyco",
    "PTGDS SVVAPATDGGLNLTSTFLR-N4H4F2S0G0 glyco",
    "PTGDS SVVAPATDGGLNLTSTFLR-N4H5F1S0G0 glyco",
    "PTGDS SVVAPATDGGLNLTSTFLR-N4H5F1S1G0 glyco",
    "PTGDS SVVAPATDGGLNLTSTFLR-N4H5F1S2G0 glyco",
    "PTGDS SVVAPATDGGLNLTSTFLR-N4H5F2S1G0 glyco",
    "PTGDS SVVAPATDGGLNLTSTFLR-N4H5F3S0G0 glyco",
    "PTGDS SVVAPATDGGLNLTSTFLR-N5H3F1S0G0 glyco",
    "PTGDS SVVAPATDGGLNLTSTFLR-N5H4F1S0G0 glyco",
    "PTGDS SVVAPATDGGLNLTSTFLR-N5H4F1S1G0 glyco",
    "PTGDS SVVAPATDGGLNLTSTFLR-N5H4F2S0G0 glyco",
    "PTGDS SVVAPATDGGLNLTSTFLR-N5H4F2S1G0 glyco",
    "PTGDS SVVAPATDGGLNLTSTFLR-N5H5F1S0G0 glyco",
    "PTGDS SVVAPATDGGLNLTSTFLR-N5H5F1S1G0 glyco",
    "PTGDS SVVAPATDGGLNLTSTFLRK-N5H4F2S0G0 glyco",
    "PTGDS SVVAPATDGGLNLTSTFLRK-N5H5F1S1G0 glyco",
    "PTGDS cnv",
    "PTGDS methyl",
    "PTGDS proteo",
    "PTGDS rna"
  ],
  "PTGER1": [
    "PTGER1 cnv",
    "PTGER1 rna"
  ],
  "PTGER2": [
    "PTGER2 cnv",
    "PTGER2 methyl",
    "PTGER2 rna"
  ],
  "PTGER3": [
    "PTGER3 cnv",
    "PTGER3 methyl",
    "PTGER3 rna"
  ],
  "PTGER4": [
    "PTGER4 cnv",
    "PTGER4 methyl",
    "PTGER4 rna"
  ],
  "PTGES": [
    "PTGES cnv",
    "PTGES proteo",
    "PTGES rna"
  ],
  "PTGES2": [
    "PTGES2 cnv",
    "PTGES2 methyl",
    "PTGES2 proteo",
    "PTGES2 rna"
  ],
  "PTGES2-AS1": [
    "PTGES2-AS1 methyl"
  ],
  "PTGES3": [
    "PTGES3 113_118_1_1_S113 phospho",
    "PTGES3 34_44_1_1_S44 phospho",
    "PTGES3 cnv",
    "PTGES3 methyl",
    "PTGES3 proteo",
    "PTGES3 rna"
  ],
  "PTGES3L": [
    "PTGES3L cnv",
    "PTGES3L methyl",
    "PTGES3L rna"
  ],
  "PTGES3L-AARSD1": [
    "PTGES3L-AARSD1 cnv",
    "PTGES3L-AARSD1 methyl",
    "PTGES3L-AARSD1 rna"
  ],
  "PTGFR": [
    "PTGFR cnv",
    "PTGFR methyl",
    "PTGFR rna"
  ],
  "PTGFRN": [
    "PTGFRN 875_875_1_1_S875 phospho",
    "PTGFRN ELDLTCNITTDR-N2H5F0S0G0 glyco",
    "PTGFRN NVSVAEGK-N2H5F0S0G0 glyco",
    "PTGFRN NVSVAEGK-N5H3F1S0G0 glyco",
    "PTGFRN cnv",
    "PTGFRN methyl",
    "PTGFRN proteo",
    "PTGFRN rna"
  ],
  "PTGIR": [
    "PTGIR cnv",
    "PTGIR methyl",
    "PTGIR rna"
  ],
  "PTGIS": [
    "PTGIS cnv",
    "PTGIS methyl",
    "PTGIS proteo",
    "PTGIS rna"
  ],
  "PTGR1": [
    "PTGR1 16_20_1_1_S20 phospho",
    "PTGR1 cnv",
    "PTGR1 proteo",
    "PTGR1 rna"
  ],
  "PTGR2": [
    "PTGR2 cnv",
    "PTGR2 methyl",
    "PTGR2 proteo",
    "PTGR2 rna"
  ],
  "PTGR3": [
    "PTGR3 cnv",
    "PTGR3 methyl",
    "PTGR3 proteo",
    "PTGR3 rna"
  ],
  "PTGS1": [
    "PTGS1 cnv",
    "PTGS1 proteo",
    "PTGS1 rna"
  ],
  "PTGS2": [
    "PTGS2 cnv",
    "PTGS2 methyl",
    "PTGS2 rna"
  ],
  "PTH": [
    "PTH cnv"
  ],
  "PTH1R": [
    "PTH1R cnv",
    "PTH1R methyl",
    "PTH1R rna"
  ],
  "PTH2": [
    "PTH2 cnv",
    "PTH2 rna"
  ],
  "PTH2R": [
    "PTH2R cnv",
    "PTH2R methyl",
    "PTH2R rna"
  ],
  "PTHLH": [
    "PTHLH cnv",
    "PTHLH methyl",
    "PTHLH rna"
  ],
  "PTK2": [
    "PTK2 386_412_1_1_S390 phospho",
    "PTK2 570_577_1_1_Y570 phospho",
    "PTK2 570_577_1_1_Y576 phospho",
    "PTK2 700_722_1_1_S722 phospho",
    "PTK2 843_861_1_1_S843 phospho",
    "PTK2 cnv",
    "PTK2 kinase",
    "PTK2 methyl",
    "PTK2 proteo",
    "PTK2 rna"
  ],
  "PTK2B": [
    "PTK2B 375_375_1_1_S375 phospho",
    "PTK2B 746_765_1_1_T765 phospho",
    "PTK2B 778_789_1_1_S778 phospho",
    "PTK2B cnv",
    "PTK2B kinase",
    "PTK2B methyl",
    "PTK2B proteo",
    "PTK2B rna"
  ],
  "PTK6": [
    "PTK6 cnv",
    "PTK6 kinase",
    "PTK6 methyl",
    "PTK6 rna"
  ],
  "PTK7": [
    "PTK7 ATVFANGSLLLTQVRPR-N2H5F0S0G0 glyco",
    "PTK7 DGTPLSDGQSNHTVSSK-N5H3F1S0G0 glyco",
    "PTK7 FEVFKNGTLR-N2H6F0S0G0 glyco",
    "PTK7 RQDVNITVATVPSWLK-N5H3F1S0G0 glyco",
    "PTK7 SANASFNIK-N5H3F1S0G0 glyco",
    "PTK7 cnv",
    "PTK7 kinase",
    "PTK7 methyl",
    "PTK7 proteo",
    "PTK7 rna"
  ],
  "PTMA": [
    "PTMA cnv",
    "PTMA methyl",
    "PTMA proteo",
    "PTMA rna"
  ],
  "PTMS": [
    "PTMS 5_13_1_1_S5 phospho",
    "PTMS cnv",
    "PTMS methyl",
    "PTMS proteo",
    "PTMS rna"
  ],
  "PTN": [
    "PTN cnv",
    "PTN proteo",
    "PTN rna"
  ],
  "PTOV1": [
    "PTOV1 34_40_1_1_S36 phospho",
    "PTOV1 53_53_1_1_S53 phospho",
    "PTOV1 cnv",
    "PTOV1 methyl",
    "PTOV1 rna"
  ],
  "PTOV1-AS1": [
    "PTOV1-AS1 methyl"
  ],
  "PTP4A1": [
    "PTP4A1 cnv",
    "PTP4A1 methyl",
    "PTP4A1 proteo",
    "PTP4A1 rna"
  ],
  "PTP4A2": [
    "PTP4A2 cnv",
    "PTP4A2 methyl",
    "PTP4A2 proteo",
    "PTP4A2 rna"
  ],
  "PTP4A3": [
    "PTP4A3 cnv",
    "PTP4A3 methyl",
    "PTP4A3 rna"
  ],
  "PTPA": [
    "PTPA cnv",
    "PTPA methyl",
    "PTPA proteo",
    "PTPA rna"
  ],
  "PTPDC1": [
    "PTPDC1 598_608_1_1_S601 phospho",
    "PTPDC1 cnv",
    "PTPDC1 methyl",
    "PTPDC1 proteo",
    "PTPDC1 rna"
  ],
  "PTPMT1": [
    "PTPMT1 cnv",
    "PTPMT1 methyl",
    "PTPMT1 proteo",
    "PTPMT1 rna"
  ],
  "PTPN1": [
    "PTPN1 cnv",
    "PTPN1 methyl",
    "PTPN1 proteo",
    "PTPN1 rna"
  ],
  "PTPN11": [
    "PTPN11 546_547_1_1_Y546 phospho",
    "PTPN11 551_570_1_1_S562 phospho",
    "PTPN11 59_66_1_1_Y62 phospho",
    "PTPN11 cnv",
    "PTPN11 methyl",
    "PTPN11 mut",
    "PTPN11 proteo",
    "PTPN11 rna"
  ],
  "PTPN12": [
    "PTPN12 19_19_1_1_S19 phospho",
    "PTPN12 318_332_1_1_S332 phospho",
    "PTPN12 332_332_1_1_S332 phospho",
    "PTPN12 340_342_1_1_S342 phospho",
    "PTPN12 507_519_1_1_T509 phospho",
    "PTPN12 565_588_1_1_S571 phospho",
    "PTPN12 565_588_1_1_S588 phospho",
    "PTPN12 565_588_2_0 phospho",
    "PTPN12 593_618_1_1_S603 phospho",
    "PTPN12 593_618_1_1_S608 phospho",
    "PTPN12 593_618_2_2_S603S606 phospho",
    "PTPN12 658_673_1_1_S673 phospho",
    "PTPN12 670_673_1_1_S673 phospho",
    "PTPN12 670_693_1_1_S673 phospho",
    "PTPN12 81_88_1_1_S83 phospho",
    "PTPN12 cnv",
    "PTPN12 methyl",
    "PTPN12 proteo",
    "PTPN12 rna"
  ],
  "PTPN13": [
    "PTPN13 1026_1033_1_1_S1033 phospho",
    "PTPN13 1063_1067_1_1_S1063 phospho",
    "PTPN13 1210_1217_1_1_S1213 phospho",
    "PTPN13 1599_1617_1_0 phospho",
    "PTPN13 1599_1617_1_1_S1610 phospho",
    "PTPN13 2013_2017_1_1_S2013 phospho",
    "PTPN13 936_950_1_0 phospho",
    "PTPN13 936_950_1_1_S936 phospho",
    "PTPN13 936_950_1_1_S938 phospho",
    "PTPN13 969_979_1_1_S969 phospho",
    "PTPN13 cnv",
    "PTPN13 methyl",
    "PTPN13 proteo",
    "PTPN13 rna"
  ],
  "PTPN14": [
    "PTPN14 309_314_1_1_S314 phospho",
    "PTPN14 459_465_1_1_S465 phospho",
    "PTPN14 589_599_1_1_S594 phospho",
    "PTPN14 794_815_1_1_S809 phospho",
    "PTPN14 cnv",
    "PTPN14 methyl",
    "PTPN14 rna"
  ],
  "PTPN18": [
    "PTPN18 cnv",
    "PTPN18 methyl",
    "PTPN18 proteo",
    "PTPN18 rna"
  ],
  "PTPN2": [
    "PTPN2 321_327_1_1_S327 phospho",
    "PTPN2 cnv",
    "PTPN2 methyl",
    "PTPN2 proteo",
    "PTPN2 rna"
  ],
  "PTPN20": [
    "PTPN20 cnv",
    "PTPN20 methyl",
    "PTPN20 rna"
  ],
  "PTPN21": [
    "PTPN21 560_582_1_1_S577 phospho",
    "PTPN21 586_596_1_1_S590 phospho",
    "PTPN21 637_644_1_1_S637 phospho",
    "PTPN21 cnv",
    "PTPN21 methyl",
    "PTPN21 proteo",
    "PTPN21 rna"
  ],
  "PTPN22": [
    "PTPN22 cnv",
    "PTPN22 rna"
  ],
  "PTPN23": [
    "PTPN23 1121_1144_1_0 phospho",
    "PTPN23 1121_1144_1_1_S1123 phospho",
    "PTPN23 cnv",
    "PTPN23 methyl",
    "PTPN23 proteo",
    "PTPN23 rna"
  ],
  "PTPN3": [
    "PTPN3 357_365_1_1_S359 phospho",
    "PTPN3 cnv",
    "PTPN3 methyl",
    "PTPN3 rna"
  ],
  "PTPN4": [
    "PTPN4 358_360_1_1_S358 phospho",
    "PTPN4 cnv",
    "PTPN4 methyl",
    "PTPN4 rna"
  ],
  "PTPN5": [
    "PTPN5 cnv",
    "PTPN5 methyl",
    "PTPN5 proteo",
    "PTPN5 rna"
  ],
  "PTPN6": [
    "PTPN6 cnv",
    "PTPN6 proteo",
    "PTPN6 rna"
  ],
  "PTPN7": [
    "PTPN7 118_118_1_1_S118 phospho",
    "PTPN7 217_228_1_1_S217 phospho",
    "PTPN7 cnv",
    "PTPN7 proteo",
    "PTPN7 rna"
  ],
  "PTPN9": [
    "PTPN9 cnv",
    "PTPN9 methyl",
    "PTPN9 proteo",
    "PTPN9 rna"
  ],
  "PTPRA": [
    "PTPRA 185_189_1_1_S189 phospho",
    "PTPRA 197_214_1_1_S211 phospho",
    "PTPRA 197_214_2_2_S211S213 phospho",
    "PTPRA 791_798_1_1_Y798 phospho",
    "PTPRA cnv",
    "PTPRA methyl",
    "PTPRA proteo",
    "PTPRA rna"
  ],
  "PTPRB": [
    "PTPRB cnv",
    "PTPRB methyl",
    "PTPRB rna"
  ],
  "PTPRC": [
    "PTPRC 1281_1306_1_1_S1299 phospho",
    "PTPRC 975_982_1_1_S975 phospho",
    "PTPRC 994_994_1_1_S994 phospho",
    "PTPRC NGSAAMCHFTTK-N5H6F0S1G0 glyco",
    "PTPRC YANITVDYLYNK-N6H7F1S1G0 glyco",
    "PTPRC cnv",
    "PTPRC proteo",
    "PTPRC rna"
  ],
  "PTPRCAP": [
    "PTPRCAP cnv",
    "PTPRCAP rna"
  ],
  "PTPRD": [
    "PTPRD 892_893_1_1_S893 phospho",
    "PTPRD KVEVEAVNSTSVK-N2H5F0S0G0 glyco",
    "PTPRD cnv",
    "PTPRD methyl",
    "PTPRD proteo",
    "PTPRD rna"
  ],
  "PTPRD-DT": [
    "PTPRD-DT methyl"
  ],
  "PTPRE": [
    "PTPRE cnv",
    "PTPRE methyl",
    "PTPRE proteo",
    "PTPRE rna"
  ],
  "PTPRF": [
    "PTPRF DINSQQELQNITTDTR-N5H3F1S0G0 glyco",
    "PTPRF cnv",
    "PTPRF methyl",
    "PTPRF proteo",
    "PTPRF rna"
  ],
  "PTPRG": [
    "PTPRG cnv",
    "PTPRG methyl",
    "PTPRG proteo",
    "PTPRG rna"
  ],
  "PTPRG-AS1": [
    "PTPRG-AS1 methyl"
  ],
  "PTPRH": [
    "PTPRH cnv",
    "PTPRH rna"
  ],
  "PTPRJ": [
    "PTPRJ ACVAGFTNITFHPQNK-N2H6F0S0G0 glyco",
    "PTPRJ cnv",
    "PTPRJ methyl",
    "PTPRJ proteo",
    "PTPRJ rna"
  ],
  "PTPRK": [
    "PTPRK 850_861_1_1_S857 phospho",
    "PTPRK cnv",
    "PTPRK methyl",
    "PTPRK proteo",
    "PTPRK rna"
  ],
  "PTPRM": [
    "PTPRM cnv",
    "PTPRM methyl",
    "PTPRM proteo",
    "PTPRM rna"
  ],
  "PTPRN": [
    "PTPRN cnv",
    "PTPRN methyl",
    "PTPRN proteo",
    "PTPRN rna"
  ],
  "PTPRN2": [
    "PTPRN2 322_322_1_1_S322 phospho",
    "PTPRN2 390_403_1_1_S399 phospho",
    "PTPRN2 653_668_1_1_S666 phospho",
    "PTPRN2 cnv",
    "PTPRN2 methyl",
    "PTPRN2 proteo",
    "PTPRN2 rna"
  ],
  "PTPRO": [
    "PTPRO 859_865_1_1_S865 phospho",
    "PTPRO cnv",
    "PTPRO methyl",
    "PTPRO proteo",
    "PTPRO rna"
  ],
  "PTPRQ": [
    "PTPRQ cnv",
    "PTPRQ rna"
  ],
  "PTPRR": [
    "PTPRR 160_169_1_1_S160 phospho",
    "PTPRR cnv",
    "PTPRR rna"
  ],
  "PTPRS": [
    "PTPRS KVEAEALNATAIR-N2H5F0S0G0 glyco",
    "PTPRS cnv",
    "PTPRS methyl",
    "PTPRS proteo",
    "PTPRS rna"
  ],
  "PTPRT": [
    "PTPRT cnv",
    "PTPRT methyl",
    "PTPRT proteo",
    "PTPRT rna"
  ],
  "PTPRU": [
    "PTPRU 853_857_1_1_S853 phospho",
    "PTPRU cnv",
    "PTPRU methyl",
    "PTPRU rna"
  ],
  "PTPRZ1": [
    "PTPRZ1 1333_1340_1_1_S1333 phospho",
    "PTPRZ1 1683_1693_1_1_T1684 phospho",
    "PTPRZ1 1683_1693_1_1_T1687 phospho",
    "PTPRZ1 1683_1693_2_2_S1683T1687 phospho",
    "PTPRZ1 1683_1693_2_2_T1684T1687 phospho",
    "PTPRZ1 2175_2179_1_1_Y2179 phospho",
    "PTPRZ1 ESFLQTNYTEIR-N2H8F0S0G0 glyco",
    "PTPRZ1 GDVPNTSLNSTSQPVTK-N2H8F0S0G0 glyco",
    "PTPRZ1 GDVPNTSLNSTSQPVTK-N6H4F1S0G0 glyco",
    "PTPRZ1 GDVPNTSLNSTSQPVTK-N6H4F1S1G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N2H3F0S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N2H4F0S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N2H5F0S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N2H6F0S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N2H7F0S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N2H8F0S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N3H3F0S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N3H4F0S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N3H4F1S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N3H5F0S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N3H5F1S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N3H6F0S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N3H6F0S1G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N3H6F1S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N4H3F0S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N4H4F0S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N4H4F0S1G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N4H4F1S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N4H5F0S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N4H5F0S1G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N4H5F1S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N5H3F0S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N5H4F0S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N5H4F0S1G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N5H4F1S0G0 glyco",
    "PTPRZ1 TVEINLTNDYR-N5H4F1S1G0 glyco",
    "PTPRZ1 cnv",
    "PTPRZ1 methyl",
    "PTPRZ1 proteo",
    "PTPRZ1 rna"
  ],
  "PTRH1": [
    "PTRH1 cnv",
    "PTRH1 methyl",
    "PTRH1 proteo",
    "PTRH1 rna"
  ],
  "PTRH2": [
    "PTRH2 cnv",
    "PTRH2 methyl",
    "PTRH2 proteo",
    "PTRH2 rna"
  ],
  "PTRHD1": [
    "PTRHD1 cnv",
    "PTRHD1 methyl",
    "PTRHD1 proteo",
    "PTRHD1 rna"
  ],
  "PTS": [
    "PTS cnv",
    "PTS methyl",
    "PTS proteo",
    "PTS rna"
  ],
  "PTTG1": [
    "PTTG1 cnv",
    "PTTG1 methyl",
    "PTTG1 rna"
  ],
  "PTTG1IP": [
    "PTTG1IP NVSCLWCNTNK-N2H6F0S0G0 glyco",
    "PTTG1IP NVSCLWCNTNK-N2H7F0S0G0 glyco",
    "PTTG1IP cnv",
    "PTTG1IP methyl",
    "PTTG1IP proteo",
    "PTTG1IP rna"
  ],
  "PTTG1IP2": [
    "PTTG1IP2 cnv",
    "PTTG1IP2 rna"
  ],
  "PTTG2": [
    "PTTG2 cnv",
    "PTTG2 rna"
  ],
  "PTX3": [
    "PTX3 cnv",
    "PTX3 proteo",
    "PTX3 rna"
  ],
  "PTX4": [
    "PTX4 cnv",
    "PTX4 rna"
  ],
  "PUDP": [
    "PUDP methyl",
    "PUDP proteo",
    "PUDP rna"
  ],
  "PUF60": [
    "PUF60 cnv",
    "PUF60 methyl",
    "PUF60 proteo",
    "PUF60 rna"
  ],
  "PUM1": [
    "PUM1 124_124_1_1_S124 phospho",
    "PUM1 197_209_1_1_S209 phospho",
    "PUM1 709_717_1_1_S709 phospho",
    "PUM1 797_815_1_1_S806 phospho",
    "PUM1 98_106_1_1_S98 phospho",
    "PUM1 QHGEQLGGGGSGGGGYNNSK-N2H5F1S0G0 glyco",
    "PUM1 cnv",
    "PUM1 methyl",
    "PUM1 proteo",
    "PUM1 rna"
  ],
  "PUM2": [
    "PUM2 119_122_1_1_T119 phospho",
    "PUM2 531_539_1_1_S531 phospho",
    "PUM2 80_80_1_1_S80 phospho",
    "PUM2 cnv",
    "PUM2 methyl",
    "PUM2 proteo",
    "PUM2 rna"
  ],
  "PUM3": [
    "PUM3 cnv",
    "PUM3 methyl",
    "PUM3 proteo",
    "PUM3 rna"
  ],
  "PURA": [
    "PURA 182_187_1_0 phospho",
    "PURA cnv",
    "PURA methyl",
    "PURA proteo",
    "PURA rna"
  ],
  "PURB": [
    "PURB cnv",
    "PURB methyl",
    "PURB proteo",
    "PURB rna"
  ],
  "PURG": [
    "PURG 153_169_1_1_S156 phospho",
    "PURG 153_169_3_3_S156S160S163 phospho",
    "PURG 339_339_1_1_S339 phospho",
    "PURG cnv",
    "PURG methyl",
    "PURG proteo",
    "PURG rna"
  ],
  "PUS1": [
    "PUS1 387_398_1_1_T398 phospho",
    "PUS1 cnv",
    "PUS1 methyl",
    "PUS1 proteo",
    "PUS1 rna"
  ],
  "PUS10": [
    "PUS10 cnv",
    "PUS10 rna"
  ],
  "PUS3": [
    "PUS3 cnv",
    "PUS3 methyl",
    "PUS3 proteo",
    "PUS3 rna"
  ],
  "PUS7": [
    "PUS7 cnv",
    "PUS7 methyl",
    "PUS7 proteo",
    "PUS7 rna"
  ],
  "PUS7L": [
    "PUS7L cnv",
    "PUS7L methyl",
    "PUS7L rna"
  ],
  "PUSL1": [
    "PUSL1 cnv",
    "PUSL1 methyl",
    "PUSL1 rna"
  ],
  "PVALB": [
    "PVALB cnv",
    "PVALB methyl",
    "PVALB proteo",
    "PVALB rna"
  ],
  "PVALEF": [
    "PVALEF cnv",
    "PVALEF rna"
  ],
  "PVR": [
    "PVR cnv",
    "PVR methyl",
    "PVR proteo",
    "PVR rna"
  ],
  "PVRIG": [
    "PVRIG cnv",
    "PVRIG rna"
  ],
  "PWP1": [
    "PWP1 50_65_1_1_S50 phospho",
    "PWP1 50_65_2_2_S50S57 phospho",
    "PWP1 cnv",
    "PWP1 methyl",
    "PWP1 proteo",
    "PWP1 rna"
  ],
  "PWP2": [
    "PWP2 cnv",
    "PWP2 methyl",
    "PWP2 proteo",
    "PWP2 rna"
  ],
  "PWWP2A": [
    "PWWP2A 81_81_1_1_S81 phospho",
    "PWWP2A cnv",
    "PWWP2A methyl",
    "PWWP2A rna"
  ],
  "PWWP2B": [
    "PWWP2B cnv",
    "PWWP2B methyl",
    "PWWP2B rna"
  ],
  "PWWP3A": [
    "PWWP3A cnv",
    "PWWP3A methyl",
    "PWWP3A rna"
  ],
  "PWWP3B": [
    "PWWP3B rna"
  ],
  "PWWP4": [
    "PWWP4 rna"
  ],
  "PXDC1": [
    "PXDC1 cnv",
    "PXDC1 methyl",
    "PXDC1 proteo",
    "PXDC1 rna"
  ],
  "PXDN": [
    "PXDN ILCDNADNITR-N2H5F0S0G0 glyco",
    "PXDN ILCDNADNITR-N2H6F0S0G0 glyco",
    "PXDN ILCDNADNITR-N2H7F0S0G0 glyco",
    "PXDN ILCDNADNITR-N2H8F0S0G0 glyco",
    "PXDN cnv",
    "PXDN methyl",
    "PXDN proteo",
    "PXDN rna"
  ],
  "PXDNL": [
    "PXDNL cnv",
    "PXDNL methyl",
    "PXDNL rna"
  ],
  "PXK": [
    "PXK cnv",
    "PXK kinase",
    "PXK methyl",
    "PXK proteo",
    "PXK rna"
  ],
  "PXMP2": [
    "PXMP2 cnv",
    "PXMP2 methyl",
    "PXMP2 rna"
  ],
  "PXMP4": [
    "PXMP4 cnv",
    "PXMP4 methyl",
    "PXMP4 rna"
  ],
  "PXN": [
    "PXN 118_119_1_1_Y118 phospho",
    "PXN 126_143_1_1_S137 phospho",
    "PXN 126_143_2_2_S126S130 phospho",
    "PXN 169_188_1_0 phospho",
    "PXN 302_303_1_1_S303 phospho",
    "PXN 318_322_1_1_S322 phospho",
    "PXN 318_343_1_1_S322 phospho",
    "PXN 83_91_1_1_S85 phospho",
    "PXN cnv",
    "PXN methyl",
    "PXN proteo",
    "PXN rna"
  ],
  "PXT1": [
    "PXT1 cnv",
    "PXT1 methyl",
    "PXT1 rna"
  ],
  "PXYLP1": [
    "PXYLP1 cnv",
    "PXYLP1 methyl",
    "PXYLP1 proteo",
    "PXYLP1 rna"
  ],
  "PYCARD": [
    "PYCARD cnv",
    "PYCARD methyl",
    "PYCARD proteo",
    "PYCARD rna"
  ],
  "PYCR1": [
    "PYCR1 cnv",
    "PYCR1 methyl",
    "PYCR1 proteo",
    "PYCR1 rna"
  ],
  "PYCR2": [
    "PYCR2 cnv",
    "PYCR2 methyl",
    "PYCR2 proteo",
    "PYCR2 rna"
  ],
  "PYCR3": [
    "PYCR3 cnv",
    "PYCR3 methyl",
    "PYCR3 proteo",
    "PYCR3 rna"
  ],
  "PYDC1": [
    "PYDC1 cnv",
    "PYDC1 methyl",
    "PYDC1 rna"
  ],
  "PYDC2": [
    "PYDC2 cnv",
    "PYDC2 rna"
  ],
  "PYGB": [
    "PYGB 430_430_1_1_S430 phospho",
    "PYGB cnv",
    "PYGB methyl",
    "PYGB proteo",
    "PYGB rna"
  ],
  "PYGL": [
    "PYGL cnv",
    "PYGL methyl",
    "PYGL proteo",
    "PYGL rna"
  ],
  "PYGM": [
    "PYGM cnv",
    "PYGM proteo",
    "PYGM rna"
  ],
  "PYGO1": [
    "PYGO1 cnv",
    "PYGO1 methyl",
    "PYGO1 rna"
  ],
  "PYGO2": [
    "PYGO2 302_307_1_1_T302 phospho",
    "PYGO2 48_75_1_1_S48 phospho",
    "PYGO2 cnv",
    "PYGO2 methyl",
    "PYGO2 proteo",
    "PYGO2 rna"
  ],
  "PYHIN1": [
    "PYHIN1 cnv",
    "PYHIN1 rna"
  ],
  "PYM1": [
    "PYM1 111_130_1_1_S116 phospho",
    "PYM1 cnv",
    "PYM1 methyl",
    "PYM1 proteo",
    "PYM1 rna"
  ],
  "PYROXD1": [
    "PYROXD1 cnv",
    "PYROXD1 methyl",
    "PYROXD1 proteo",
    "PYROXD1 rna"
  ],
  "PYROXD2": [
    "PYROXD2 cnv",
    "PYROXD2 proteo",
    "PYROXD2 rna"
  ],
  "PYURF": [
    "PYURF cnv",
    "PYURF methyl",
    "PYURF rna"
  ],
  "PYY": [
    "PYY cnv",
    "PYY methyl",
    "PYY rna"
  ],
  "PZP": [
    "PZP cnv",
    "PZP proteo",
    "PZP rna"
  ],
  "QARS1": [
    "QARS1 cnv",
    "QARS1 methyl",
    "QARS1 proteo",
    "QARS1 rna"
  ],
  "QDPR": [
    "QDPR 223_233_1_1_S223 phospho",
    "QDPR cnv",
    "QDPR methyl",
    "QDPR proteo",
    "QDPR rna"
  ],
  "QKI": [
    "QKI 211_221_1_1_S211 phospho",
    "QKI cnv",
    "QKI methyl",
    "QKI proteo",
    "QKI rna"
  ],
  "QPCT": [
    "QPCT cnv",
    "QPCT methyl",
    "QPCT proteo",
    "QPCT rna"
  ],
  "QPCTL": [
    "QPCTL cnv",
    "QPCTL methyl",
    "QPCTL rna"
  ],
  "QPRT": [
    "QPRT cnv",
    "QPRT proteo",
    "QPRT rna"
  ],
  "QRFP": [
    "QRFP cnv",
    "QRFP rna"
  ],
  "QRFPR": [
    "QRFPR cnv",
    "QRFPR methyl",
    "QRFPR rna"
  ],
  "QRICH1": [
    "QRICH1 326_347_1_1_S345 phospho",
    "QRICH1 cnv",
    "QRICH1 methyl",
    "QRICH1 proteo",
    "QRICH1 rna"
  ],
  "QRICH2": [
    "QRICH2 cnv",
    "QRICH2 methyl",
    "QRICH2 rna"
  ],
  "QRSL1": [
    "QRSL1 cnv",
    "QRSL1 proteo",
    "QRSL1 rna"
  ],
  "QSER1": [
    "QSER1 cnv",
    "QSER1 methyl",
    "QSER1 proteo",
    "QSER1 rna"
  ],
  "QSOX1": [
    "QSOX1 426_426_1_1_S426 phospho",
    "QSOX1 cnv",
    "QSOX1 methyl",
    "QSOX1 proteo",
    "QSOX1 rna"
  ],
  "QSOX2": [
    "QSOX2 570_583_1_1_S578 phospho",
    "QSOX2 cnv",
    "QSOX2 methyl",
    "QSOX2 proteo",
    "QSOX2 rna"
  ],
  "QTRT1": [
    "QTRT1 cnv",
    "QTRT1 methyl",
    "QTRT1 proteo",
    "QTRT1 rna"
  ],
  "QTRT2": [
    "QTRT2 cnv",
    "QTRT2 methyl",
    "QTRT2 proteo",
    "QTRT2 rna"
  ],
  "R3HCC1": [
    "R3HCC1 cnv",
    "R3HCC1 methyl",
    "R3HCC1 proteo",
    "R3HCC1 rna"
  ],
  "R3HCC1L": [
    "R3HCC1L cnv",
    "R3HCC1L methyl",
    "R3HCC1L proteo",
    "R3HCC1L rna"
  ],
  "R3HDM1": [
    "R3HDM1 340_348_1_1_S347 phospho",
    "R3HDM1 354_368_1_1_S362 phospho",
    "R3HDM1 cnv",
    "R3HDM1 methyl",
    "R3HDM1 proteo",
    "R3HDM1 rna"
  ],
  "R3HDM2": [
    "R3HDM2 354_368_1_1_S362 phospho",
    "R3HDM2 cnv",
    "R3HDM2 proteo",
    "R3HDM2 rna"
  ],
  "R3HDM4": [
    "R3HDM4 cnv",
    "R3HDM4 methyl",
    "R3HDM4 rna"
  ],
  "R3HDML": [
    "R3HDML cnv",
    "R3HDML rna"
  ],
  "RAB10": [
    "RAB10 73_79_1_1_T73 phospho",
    "RAB10 cnv",
    "RAB10 methyl",
    "RAB10 proteo",
    "RAB10 rna"
  ],
  "RAB11A": [
    "RAB11A cnv",
    "RAB11A methyl",
    "RAB11A rna"
  ],
  "RAB11B": [
    "RAB11B cnv",
    "RAB11B methyl",
    "RAB11B proteo",
    "RAB11B rna"
  ],
  "RAB11B-AS1": [
    "RAB11B-AS1 methyl"
  ],
  "RAB11FIP1": [
    "RAB11FIP1 356_365_1_0 phospho",
    "RAB11FIP1 356_377_1_0 phospho",
    "RAB11FIP1 434_441_1_1_S435 phospho",
    "RAB11FIP1 cnv",
    "RAB11FIP1 methyl",
    "RAB11FIP1 rna"
  ],
  "RAB11FIP2": [
    "RAB11FIP2 cnv",
    "RAB11FIP2 methyl",
    "RAB11FIP2 proteo",
    "RAB11FIP2 rna"
  ],
  "RAB11FIP3": [
    "RAB11FIP3 cnv",
    "RAB11FIP3 methyl",
    "RAB11FIP3 proteo",
    "RAB11FIP3 rna"
  ],
  "RAB11FIP4": [
    "RAB11FIP4 cnv",
    "RAB11FIP4 methyl",
    "RAB11FIP4 rna"
  ],
  "RAB11FIP5": [
    "RAB11FIP5 174_181_1_1_S176 phospho",
    "RAB11FIP5 305_307_1_1_S307 phospho",
    "RAB11FIP5 356_373_1_1_S357 phospho",
    "RAB11FIP5 356_373_1_1_S364 phospho",
    "RAB11FIP5 393_407_1_1_S395 phospho",
    "RAB11FIP5 481_482_1_1_S482 phospho",
    "RAB11FIP5 494_500_1_1_S494 phospho",
    "RAB11FIP5 531_538_1_1_S538 phospho",
    "RAB11FIP5 cnv",
    "RAB11FIP5 methyl",
    "RAB11FIP5 proteo",
    "RAB11FIP5 rna"
  ],
  "RAB12": [
    "RAB12 cnv",
    "RAB12 methyl",
    "RAB12 proteo",
    "RAB12 rna"
  ],
  "RAB13": [
    "RAB13 cnv",
    "RAB13 proteo",
    "RAB13 rna"
  ],
  "RAB14": [
    "RAB14 173_195_1_1_S180 phospho",
    "RAB14 173_195_1_1_S195 phospho",
    "RAB14 cnv",
    "RAB14 methyl",
    "RAB14 proteo",
    "RAB14 rna"
  ],
  "RAB15": [
    "RAB15 cnv",
    "RAB15 methyl",
    "RAB15 proteo",
    "RAB15 rna"
  ],
  "RAB17": [
    "RAB17 cnv",
    "RAB17 rna"
  ],
  "RAB18": [
    "RAB18 173_180_1_1_S173 phospho",
    "RAB18 cnv",
    "RAB18 methyl",
    "RAB18 proteo",
    "RAB18 rna"
  ],
  "RAB19": [
    "RAB19 cnv",
    "RAB19 rna"
  ],
  "RAB1A": [
    "RAB1A cnv",
    "RAB1A methyl",
    "RAB1A proteo",
    "RAB1A rna"
  ],
  "RAB1B": [
    "RAB1B cnv",
    "RAB1B methyl",
    "RAB1B proteo",
    "RAB1B rna"
  ],
  "RAB20": [
    "RAB20 cnv",
    "RAB20 methyl",
    "RAB20 rna"
  ],
  "RAB21": [
    "RAB21 cnv",
    "RAB21 methyl",
    "RAB21 proteo",
    "RAB21 rna"
  ],
  "RAB22A": [
    "RAB22A cnv",
    "RAB22A methyl",
    "RAB22A proteo",
    "RAB22A rna"
  ],
  "RAB23": [
    "RAB23 184_188_1_1_S186 phospho",
    "RAB23 196_208_1_1_T208 phospho",
    "RAB23 cnv",
    "RAB23 methyl",
    "RAB23 proteo",
    "RAB23 rna"
  ],
  "RAB24": [
    "RAB24 cnv",
    "RAB24 methyl",
    "RAB24 proteo",
    "RAB24 rna"
  ],
  "RAB25": [
    "RAB25 cnv",
    "RAB25 rna"
  ],
  "RAB26": [
    "RAB26 cnv",
    "RAB26 methyl",
    "RAB26 rna"
  ],
  "RAB27A": [
    "RAB27A cnv",
    "RAB27A methyl",
    "RAB27A proteo",
    "RAB27A rna"
  ],
  "RAB27B": [
    "RAB27B cnv",
    "RAB27B methyl",
    "RAB27B proteo",
    "RAB27B rna"
  ],
  "RAB28": [
    "RAB28 cnv",
    "RAB28 methyl",
    "RAB28 proteo",
    "RAB28 rna"
  ],
  "RAB29": [
    "RAB29 cnv",
    "RAB29 methyl",
    "RAB29 proteo",
    "RAB29 rna"
  ],
  "RAB2A": [
    "RAB2A cnv",
    "RAB2A methyl",
    "RAB2A proteo",
    "RAB2A rna"
  ],
  "RAB2B": [
    "RAB2B 192_202_1_1_S192 phospho",
    "RAB2B 192_202_1_1_S202 phospho",
    "RAB2B cnv",
    "RAB2B methyl",
    "RAB2B proteo",
    "RAB2B rna"
  ],
  "RAB30": [
    "RAB30 cnv",
    "RAB30 proteo",
    "RAB30 rna"
  ],
  "RAB31": [
    "RAB31 36_45_1_0 phospho",
    "RAB31 36_45_1_1_S36 phospho",
    "RAB31 36_45_1_1_T38 phospho",
    "RAB31 cnv",
    "RAB31 methyl",
    "RAB31 proteo",
    "RAB31 rna"
  ],
  "RAB32": [
    "RAB32 cnv",
    "RAB32 methyl",
    "RAB32 proteo",
    "RAB32 rna"
  ],
  "RAB33A": [
    "RAB33A methyl",
    "RAB33A proteo",
    "RAB33A rna"
  ],
  "RAB33B": [
    "RAB33B cnv",
    "RAB33B methyl",
    "RAB33B proteo",
    "RAB33B rna"
  ],
  "RAB34": [
    "RAB34 290_300_1_1_S293 phospho",
    "RAB34 cnv",
    "RAB34 methyl",
    "RAB34 proteo",
    "RAB34 rna"
  ],
  "RAB35": [
    "RAB35 cnv",
    "RAB35 methyl",
    "RAB35 proteo",
    "RAB35 rna"
  ],
  "RAB36": [
    "RAB36 cnv",
    "RAB36 methyl",
    "RAB36 proteo",
    "RAB36 rna"
  ],
  "RAB37": [
    "RAB37 cnv",
    "RAB37 methyl",
    "RAB37 proteo",
    "RAB37 rna"
  ],
  "RAB38": [
    "RAB38 cnv",
    "RAB38 methyl",
    "RAB38 rna"
  ],
  "RAB39A": [
    "RAB39A cnv",
    "RAB39A methyl",
    "RAB39A proteo",
    "RAB39A rna"
  ],
  "RAB39B": [
    "RAB39B methyl",
    "RAB39B proteo",
    "RAB39B rna"
  ],
  "RAB3A": [
    "RAB3A 188_199_1_1_S188 phospho",
    "RAB3A 188_199_1_1_S190 phospho",
    "RAB3A cnv",
    "RAB3A methyl",
    "RAB3A proteo",
    "RAB3A rna"
  ],
  "RAB3B": [
    "RAB3B cnv",
    "RAB3B methyl",
    "RAB3B proteo",
    "RAB3B rna"
  ],
  "RAB3C": [
    "RAB3C cnv",
    "RAB3C methyl",
    "RAB3C proteo",
    "RAB3C rna"
  ],
  "RAB3D": [
    "RAB3D cnv",
    "RAB3D methyl",
    "RAB3D proteo",
    "RAB3D rna"
  ],
  "RAB3GAP1": [
    "RAB3GAP1 368_386_1_1_S379 phospho",
    "RAB3GAP1 536_545_1_0 phospho",
    "RAB3GAP1 536_545_1_1_S537 phospho",
    "RAB3GAP1 663_664_1_1_S664 phospho",
    "RAB3GAP1 cnv",
    "RAB3GAP1 methyl",
    "RAB3GAP1 proteo",
    "RAB3GAP1 rna"
  ],
  "RAB3GAP2": [
    "RAB3GAP2 450_459_1_1_S450 phospho",
    "RAB3GAP2 cnv",
    "RAB3GAP2 methyl",
    "RAB3GAP2 proteo",
    "RAB3GAP2 rna"
  ],
  "RAB3IL1": [
    "RAB3IL1 159_181_1_1_S168 phospho",
    "RAB3IL1 179_181_1_1_S179 phospho",
    "RAB3IL1 194_212_1_0 phospho",
    "RAB3IL1 cnv",
    "RAB3IL1 methyl",
    "RAB3IL1 proteo",
    "RAB3IL1 rna"
  ],
  "RAB3IP": [
    "RAB3IP 241_252_1_1_S247 phospho",
    "RAB3IP 241_252_1_1_S250 phospho",
    "RAB3IP 272_285_1_0 phospho",
    "RAB3IP 272_285_1_1_S272 phospho",
    "RAB3IP 272_285_2_0 phospho",
    "RAB3IP cnv",
    "RAB3IP methyl",
    "RAB3IP proteo",
    "RAB3IP rna"
  ],
  "RAB40A": [
    "RAB40A rna"
  ],
  "RAB40AL": [
    "RAB40AL methyl",
    "RAB40AL rna"
  ],
  "RAB40B": [
    "RAB40B cnv",
    "RAB40B methyl",
    "RAB40B rna"
  ],
  "RAB40C": [
    "RAB40C cnv",
    "RAB40C methyl",
    "RAB40C rna"
  ],
  "RAB41": [
    "RAB41 rna"
  ],
  "RAB42": [
    "RAB42 cnv",
    "RAB42 rna"
  ],
  "RAB43": [
    "RAB43 cnv",
    "RAB43 methyl",
    "RAB43 proteo",
    "RAB43 rna"
  ],
  "RAB44": [
    "RAB44 cnv",
    "RAB44 rna"
  ],
  "RAB4A": [
    "RAB4A cnv",
    "RAB4A methyl",
    "RAB4A proteo",
    "RAB4A rna"
  ],
  "RAB4A-AS1": [
    "RAB4A-AS1 methyl"
  ],
  "RAB4B": [
    "RAB4B cnv",
    "RAB4B methyl",
    "RAB4B proteo",
    "RAB4B rna"
  ],
  "RAB4B-EGLN2": [
    "RAB4B-EGLN2 cnv",
    "RAB4B-EGLN2 rna"
  ],
  "RAB5A": [
    "RAB5A 193_193_1_1_S193 phospho",
    "RAB5A cnv",
    "RAB5A methyl",
    "RAB5A proteo",
    "RAB5A rna"
  ],
  "RAB5B": [
    "RAB5B 123_125_1_1_S123 phospho",
    "RAB5B cnv",
    "RAB5B methyl",
    "RAB5B proteo",
    "RAB5B rna"
  ],
  "RAB5C": [
    "RAB5C 157_157_1_1_S157 phospho",
    "RAB5C cnv",
    "RAB5C methyl",
    "RAB5C proteo",
    "RAB5C rna"
  ],
  "RAB5IF": [
    "RAB5IF cnv",
    "RAB5IF methyl",
    "RAB5IF proteo",
    "RAB5IF rna"
  ],
  "RAB6A": [
    "RAB6A 179_184_1_1_S184 phospho",
    "RAB6A cnv",
    "RAB6A methyl",
    "RAB6A proteo",
    "RAB6A rna"
  ],
  "RAB6B": [
    "RAB6B cnv",
    "RAB6B methyl",
    "RAB6B proteo",
    "RAB6B rna"
  ],
  "RAB6C": [
    "RAB6C cnv",
    "RAB6C methyl",
    "RAB6C rna"
  ],
  "RAB6D": [
    "RAB6D cnv",
    "RAB6D methyl",
    "RAB6D rna"
  ],
  "RAB7A": [
    "RAB7A cnv",
    "RAB7A methyl",
    "RAB7A proteo",
    "RAB7A rna"
  ],
  "RAB7B": [
    "RAB7B cnv",
    "RAB7B rna"
  ],
  "RAB8A": [
    "RAB8A 181_185_1_1_S181 phospho",
    "RAB8A 181_185_1_1_S185 phospho",
    "RAB8A 181_185_2_2_S181S185 phospho",
    "RAB8A cnv",
    "RAB8A methyl",
    "RAB8A proteo",
    "RAB8A rna"
  ],
  "RAB8B": [
    "RAB8B 180_182_1_1_S182 phospho",
    "RAB8B cnv",
    "RAB8B methyl",
    "RAB8B proteo",
    "RAB8B rna"
  ],
  "RAB9A": [
    "RAB9A methyl",
    "RAB9A proteo",
    "RAB9A rna"
  ],
  "RAB9B": [
    "RAB9B proteo",
    "RAB9B rna"
  ],
  "RABAC1": [
    "RABAC1 cnv",
    "RABAC1 methyl",
    "RABAC1 proteo",
    "RABAC1 rna"
  ],
  "RABEP1": [
    "RABEP1 407_419_1_0 phospho",
    "RABEP1 407_419_1_1_S407 phospho",
    "RABEP1 407_419_1_1_S410 phospho",
    "RABEP1 407_419_2_1_S410 phospho",
    "RABEP1 cnv",
    "RABEP1 methyl",
    "RABEP1 proteo",
    "RABEP1 rna"
  ],
  "RABEP2": [
    "RABEP2 189_200_1_1_S193 phospho",
    "RABEP2 cnv",
    "RABEP2 methyl",
    "RABEP2 proteo",
    "RABEP2 rna"
  ],
  "RABEPK": [
    "RABEPK cnv",
    "RABEPK methyl",
    "RABEPK proteo",
    "RABEPK rna"
  ],
  "RABGAP1": [
    "RABGAP1 35_42_1_1_S42 phospho",
    "RABGAP1 499_530_1_1_S501 phospho",
    "RABGAP1 499_530_1_1_S508 phospho",
    "RABGAP1 56_56_1_1_S56 phospho",
    "RABGAP1 996_1002_1_1_T996 phospho",
    "RABGAP1 996_996_1_1_T996 phospho",
    "RABGAP1 cnv",
    "RABGAP1 methyl",
    "RABGAP1 proteo",
    "RABGAP1 rna"
  ],
  "RABGAP1L": [
    "RABGAP1L cnv",
    "RABGAP1L methyl",
    "RABGAP1L proteo",
    "RABGAP1L rna"
  ],
  "RABGAP1L-DT": [
    "RABGAP1L-DT methyl"
  ],
  "RABGEF1": [
    "RABGEF1 138_140_1_1_S138 phospho",
    "RABGEF1 145_153_1_1_S146 phospho",
    "RABGEF1 387_404_1_0 phospho",
    "RABGEF1 387_404_1_1_S404 phospho",
    "RABGEF1 398_404_1_1_S404 phospho",
    "RABGEF1 cnv",
    "RABGEF1 methyl",
    "RABGEF1 proteo",
    "RABGEF1 rna"
  ],
  "RABGGTA": [
    "RABGGTA cnv",
    "RABGGTA methyl",
    "RABGGTA proteo",
    "RABGGTA rna"
  ],
  "RABGGTB": [
    "RABGGTB cnv",
    "RABGGTB proteo",
    "RABGGTB rna"
  ],
  "RABIF": [
    "RABIF cnv",
    "RABIF methyl",
    "RABIF rna"
  ],
  "RABL2A": [
    "RABL2A cnv",
    "RABL2A methyl",
    "RABL2A rna"
  ],
  "RABL2B": [
    "RABL2B cnv",
    "RABL2B methyl",
    "RABL2B proteo",
    "RABL2B rna"
  ],
  "RABL3": [
    "RABL3 cnv",
    "RABL3 proteo",
    "RABL3 rna"
  ],
  "RABL6": [
    "RABL6 493_497_1_1_S493 phospho",
    "RABL6 597_600_2_2_S597T600 phospho",
    "RABL6 cnv",
    "RABL6 methyl",
    "RABL6 proteo",
    "RABL6 rna"
  ],
  "RAC1": [
    "RAC1 cnv",
    "RAC1 methyl",
    "RAC1 proteo",
    "RAC1 rna"
  ],
  "RAC2": [
    "RAC2 cnv",
    "RAC2 methyl",
    "RAC2 proteo",
    "RAC2 rna"
  ],
  "RAC3": [
    "RAC3 cnv",
    "RAC3 methyl",
    "RAC3 proteo",
    "RAC3 rna"
  ],
  "RACGAP1": [
    "RACGAP1 cnv",
    "RACGAP1 methyl",
    "RACGAP1 proteo",
    "RACGAP1 rna"
  ],
  "RACK1": [
    "RACK1 cnv",
    "RACK1 methyl",
    "RACK1 proteo",
    "RACK1 rna"
  ],
  "RAD1": [
    "RAD1 cnv",
    "RAD1 methyl",
    "RAD1 proteo",
    "RAD1 rna"
  ],
  "RAD17": [
    "RAD17 cnv",
    "RAD17 methyl",
    "RAD17 rna"
  ],
  "RAD18": [
    "RAD18 cnv",
    "RAD18 methyl",
    "RAD18 rna"
  ],
  "RAD21": [
    "RAD21 394_394_1_1_T394 phospho",
    "RAD21 545_545_1_1_S545 phospho",
    "RAD21 cnv",
    "RAD21 methyl",
    "RAD21 proteo",
    "RAD21 rna"
  ],
  "RAD21-AS1": [
    "RAD21-AS1 methyl"
  ],
  "RAD21L1": [
    "RAD21L1 cnv",
    "RAD21L1 methyl",
    "RAD21L1 rna"
  ],
  "RAD23A": [
    "RAD23A cnv",
    "RAD23A methyl",
    "RAD23A proteo",
    "RAD23A rna"
  ],
  "RAD23B": [
    "RAD23B 155_172_1_1_S160 phospho",
    "RAD23B cnv",
    "RAD23B methyl",
    "RAD23B proteo",
    "RAD23B rna"
  ],
  "RAD50": [
    "RAD50 cnv",
    "RAD50 methyl",
    "RAD50 proteo",
    "RAD50 rna"
  ],
  "RAD51": [
    "RAD51 cnv",
    "RAD51 methyl",
    "RAD51 rna"
  ],
  "RAD51-AS1": [
    "RAD51-AS1 methyl"
  ],
  "RAD51AP1": [
    "RAD51AP1 cnv",
    "RAD51AP1 methyl",
    "RAD51AP1 rna"
  ],
  "RAD51AP2": [
    "RAD51AP2 cnv",
    "RAD51AP2 rna"
  ],
  "RAD51B": [
    "RAD51B cnv",
    "RAD51B rna"
  ],
  "RAD51C": [
    "RAD51C cnv",
    "RAD51C methyl",
    "RAD51C rna"
  ],
  "RAD51D": [
    "RAD51D cnv",
    "RAD51D methyl",
    "RAD51D rna"
  ],
  "RAD52": [
    "RAD52 cnv",
    "RAD52 methyl",
    "RAD52 rna"
  ],
  "RAD54B": [
    "RAD54B cnv",
    "RAD54B methyl",
    "RAD54B rna"
  ],
  "RAD54L": [
    "RAD54L cnv",
    "RAD54L methyl",
    "RAD54L rna"
  ],
  "RAD54L2": [
    "RAD54L2 1260_1268_1_1_T1260 phospho",
    "RAD54L2 cnv",
    "RAD54L2 methyl",
    "RAD54L2 proteo",
    "RAD54L2 rna"
  ],
  "RAD9A": [
    "RAD9A 287_311_2_2_S299S311 phospho",
    "RAD9A 299_311_1_1_S311 phospho",
    "RAD9A cnv",
    "RAD9A methyl",
    "RAD9A proteo",
    "RAD9A rna"
  ],
  "RAD9B": [
    "RAD9B cnv",
    "RAD9B methyl",
    "RAD9B rna"
  ],
  "RADIL": [
    "RADIL 163_163_1_1_S163 phospho",
    "RADIL 214_221_1_0 phospho",
    "RADIL 214_221_1_1_S216 phospho",
    "RADIL cnv",
    "RADIL methyl",
    "RADIL proteo",
    "RADIL rna"
  ],
  "RADX": [
    "RADX methyl",
    "RADX rna"
  ],
  "RAE1": [
    "RAE1 cnv",
    "RAE1 methyl",
    "RAE1 proteo",
    "RAE1 rna"
  ],
  "RAET1E": [
    "RAET1E cnv",
    "RAET1E rna"
  ],
  "RAET1E-AS1": [
    "RAET1E-AS1 methyl"
  ],
  "RAET1G": [
    "RAET1G cnv",
    "RAET1G methyl",
    "RAET1G rna"
  ],
  "RAET1K": [
    "RAET1K methyl"
  ],
  "RAET1L": [
    "RAET1L cnv",
    "RAET1L rna"
  ],
  "RAF1": [
    "RAF1 227_252_1_0 phospho",
    "RAF1 257_274_1_1_S259 phospho",
    "RAF1 303_326_1_1_S321 phospho",
    "RAF1 303_326_2_2_S316S321 phospho",
    "RAF1 651_662_1_1_S662 phospho",
    "RAF1 cnv",
    "RAF1 kinase",
    "RAF1 methyl",
    "RAF1 proteo",
    "RAF1 rna"
  ],
  "RAG1": [
    "RAG1 cnv",
    "RAG1 methyl",
    "RAG1 rna"
  ],
  "RAG2": [
    "RAG2 cnv",
    "RAG2 rna"
  ],
  "RAI1": [
    "RAI1 1374_1387_1_1_S1374 phospho",
    "RAI1 cnv",
    "RAI1 methyl",
    "RAI1 proteo",
    "RAI1 rna"
  ],
  "RAI14": [
    "RAI14 293_300_1_1_T297 phospho",
    "RAI14 411_419_1_1_S412 phospho",
    "RAI14 667_675_1_1_S667 phospho",
    "RAI14 cnv",
    "RAI14 methyl",
    "RAI14 proteo",
    "RAI14 rna"
  ],
  "RAI2": [
    "RAI2 methyl",
    "RAI2 rna"
  ],
  "RALA": [
    "RALA 11_11_1_1_S11 phospho",
    "RALA cnv",
    "RALA methyl",
    "RALA proteo",
    "RALA rna"
  ],
  "RALB": [
    "RALB cnv",
    "RALB methyl",
    "RALB proteo",
    "RALB rna"
  ],
  "RALBP1": [
    "RALBP1 27_36_1_1_S29 phospho",
    "RALBP1 44_62_1_1_S62 phospho",
    "RALBP1 44_62_2_2_S48S62 phospho",
    "RALBP1 461_463_1_1_S463 phospho",
    "RALBP1 82_101_2_2_S92S93 phospho",
    "RALBP1 cnv",
    "RALBP1 methyl",
    "RALBP1 proteo",
    "RALBP1 rna"
  ],
  "RALGAPA1": [
    "RALGAPA1 1210_1226_1_1_S1212 phospho",
    "RALGAPA1 1319_1323_1_1_S1319 phospho",
    "RALGAPA1 1319_1323_1_1_S1320 phospho",
    "RALGAPA1 1319_1323_2_2_S1319S1323 phospho",
    "RALGAPA1 1459_1466_1_1_S1463 phospho",
    "RALGAPA1 1459_1466_2_2_T1461S1463 phospho",
    "RALGAPA1 1937_1940_1_1_S1937 phospho",
    "RALGAPA1 734_743_1_1_T736 phospho",
    "RALGAPA1 761_771_1_1_S761 phospho",
    "RALGAPA1 773_778_1_0 phospho",
    "RALGAPA1 777_785_1_1_S777 phospho",
    "RALGAPA1 795_806_1_1_S797 phospho",
    "RALGAPA1 826_837_1_1_S830 phospho",
    "RALGAPA1 826_837_1_1_S835 phospho",
    "RALGAPA1 cnv",
    "RALGAPA1 methyl",
    "RALGAPA1 proteo",
    "RALGAPA1 rna"
  ],
  "RALGAPA2": [
    "RALGAPA2 373_379_1_1_S373 phospho",
    "RALGAPA2 373_379_2_2_S373S376 phospho",
    "RALGAPA2 764_779_1_0 phospho",
    "RALGAPA2 819_834_1_0 phospho",
    "RALGAPA2 819_834_1_1_S821 phospho",
    "RALGAPA2 cnv",
    "RALGAPA2 methyl",
    "RALGAPA2 proteo",
    "RALGAPA2 rna"
  ],
  "RALGAPB": [
    "RALGAPB 1300_1323_1_1_S1320 phospho",
    "RALGAPB 357_363_2_2_S359T363 phospho",
    "RALGAPB 369_379_1_0 phospho",
    "RALGAPB 718_737_1_0 phospho",
    "RALGAPB 718_737_1_1_S720 phospho",
    "RALGAPB 718_737_1_1_T734 phospho",
    "RALGAPB cnv",
    "RALGAPB methyl",
    "RALGAPB proteo",
    "RALGAPB rna"
  ],
  "RALGDS": [
    "RALGDS cnv",
    "RALGDS methyl",
    "RALGDS proteo",
    "RALGDS rna"
  ],
  "RALGPS1": [
    "RALGPS1 cnv",
    "RALGPS1 methyl",
    "RALGPS1 rna"
  ],
  "RALGPS2": [
    "RALGPS2 315_329_1_1_S329 phospho",
    "RALGPS2 315_329_2_2_T326S329 phospho",
    "RALGPS2 343_346_1_1_S343 phospho",
    "RALGPS2 cnv",
    "RALGPS2 methyl",
    "RALGPS2 proteo",
    "RALGPS2 rna"
  ],
  "RALY": [
    "RALY 135_135_1_1_S135 phospho",
    "RALY 275_298_1_1_S288 phospho",
    "RALY 286_298_1_1_S288 phospho",
    "RALY cnv",
    "RALY methyl",
    "RALY proteo",
    "RALY rna"
  ],
  "RALY-AS1": [
    "RALY-AS1 methyl"
  ],
  "RALYL": [
    "RALYL cnv",
    "RALYL methyl",
    "RALYL proteo",
    "RALYL rna"
  ],
  "RAMAC": [
    "RAMAC 36_45_1_1_S36 phospho",
    "RAMAC cnv",
    "RAMAC methyl",
    "RAMAC proteo",
    "RAMAC rna"
  ],
  "RAMACL": [
    "RAMACL cnv",
    "RAMACL rna"
  ],
  "RAMP1": [
    "RAMP1 cnv",
    "RAMP1 methyl",
    "RAMP1 proteo",
    "RAMP1 rna"
  ],
  "RAMP2": [
    "RAMP2 cnv",
    "RAMP2 methyl",
    "RAMP2 mut",
    "RAMP2 rna"
  ],
  "RAMP2-AS1": [
    "RAMP2-AS1 methyl"
  ],
  "RAMP3": [
    "RAMP3 cnv",
    "RAMP3 methyl",
    "RAMP3 rna"
  ],
  "RAN": [
    "RAN cnv",
    "RAN methyl",
    "RAN proteo",
    "RAN rna"
  ],
  "RANBP1": [
    "RANBP1 cnv",
    "RANBP1 methyl",
    "RANBP1 proteo",
    "RANBP1 rna"
  ],
  "RANBP10": [
    "RANBP10 cnv",
    "RANBP10 methyl",
    "RANBP10 proteo",
    "RANBP10 rna"
  ],
  "RANBP17": [
    "RANBP17 cnv",
    "RANBP17 methyl",
    "RANBP17 rna"
  ],
  "RANBP2": [
    "RANBP2 1156_1160_1_1_S1160 phospho",
    "RANBP2 1374_1381_1_1_S1374 phospho",
    "RANBP2 1573_1583_1_0 phospho",
    "RANBP2 1573_1583_1_1_S1573 phospho",
    "RANBP2 1832_1839_1_1_S1832 phospho",
    "RANBP2 2666_2679_1_1_S2668 phospho",
    "RANBP2 2802_2812_1_0 phospho",
    "RANBP2 2802_2821_1_0 phospho",
    "RANBP2 2900_2917_1_1_S2900 phospho",
    "RANBP2 773_783_2_2_T779S781 phospho",
    "RANBP2 832_837_1_1_S833 phospho",
    "RANBP2 832_837_1_1_S837 phospho",
    "RANBP2 cnv",
    "RANBP2 methyl",
    "RANBP2 proteo",
    "RANBP2 rna"
  ],
  "RANBP3": [
    "RANBP3 124_135_1_0 phospho",
    "RANBP3 124_135_1_1_S126 phospho",
    "RANBP3 186_214_1_1_S211 phospho",
    "RANBP3 240_244_1_1_S244 phospho",
    "RANBP3 333_342_1_1_S333 phospho",
    "RANBP3 533_567_1_0 phospho",
    "RANBP3 96_115_1_1_S101 phospho",
    "RANBP3 96_115_1_1_S108 phospho",
    "RANBP3 96_115_2_2_S101S108 phospho",
    "RANBP3 96_115_3_3_S100S101S108 phospho",
    "RANBP3 cnv",
    "RANBP3 methyl",
    "RANBP3 proteo",
    "RANBP3 rna"
  ],
  "RANBP3-DT": [
    "RANBP3-DT methyl"
  ],
  "RANBP3L": [
    "RANBP3L cnv",
    "RANBP3L rna"
  ],
  "RANBP6": [
    "RANBP6 cnv",
    "RANBP6 proteo",
    "RANBP6 rna"
  ],
  "RANBP9": [
    "RANBP9 467_467_1_1_S467 phospho",
    "RANBP9 470_499_1_1_S487 phospho",
    "RANBP9 cnv",
    "RANBP9 methyl",
    "RANBP9 proteo",
    "RANBP9 rna"
  ],
  "RANGAP1": [
    "RANGAP1 419_442_1_1_S428 phospho",
    "RANGAP1 419_442_1_1_S442 phospho",
    "RANGAP1 cnv",
    "RANGAP1 methyl",
    "RANGAP1 proteo",
    "RANGAP1 rna"
  ],
  "RANGRF": [
    "RANGRF cnv",
    "RANGRF methyl",
    "RANGRF proteo",
    "RANGRF rna"
  ],
  "RAP1A": [
    "RAP1A cnv",
    "RAP1A methyl",
    "RAP1A proteo",
    "RAP1A rna"
  ],
  "RAP1B": [
    "RAP1B cnv",
    "RAP1B methyl",
    "RAP1B proteo",
    "RAP1B rna"
  ],
  "RAP1GAP": [
    "RAP1GAP 118_141_1_1_S138 phospho",
    "RAP1GAP 493_499_1_1_S493 phospho",
    "RAP1GAP 493_503_1_1_S493 phospho",
    "RAP1GAP 518_526_1_1_S524 phospho",
    "RAP1GAP 562_563_1_0 phospho",
    "RAP1GAP 562_563_1_1_S563 phospho",
    "RAP1GAP 579_579_1_1_S579 phospho",
    "RAP1GAP 598_612_1_1_S606 phospho",
    "RAP1GAP 598_612_2_2_S605S606 phospho",
    "RAP1GAP cnv",
    "RAP1GAP methyl",
    "RAP1GAP proteo",
    "RAP1GAP rna"
  ],
  "RAP1GAP2": [
    "RAP1GAP2 34_53_1_0 phospho",
    "RAP1GAP2 34_53_1_1_S45 phospho",
    "RAP1GAP2 34_53_1_1_T49 phospho",
    "RAP1GAP2 490_495_1_1_S492 phospho",
    "RAP1GAP2 557_565_1_1_S559 phospho",
    "RAP1GAP2 571_585_1_1_T578 phospho",
    "RAP1GAP2 590_598_1_1_S598 phospho",
    "RAP1GAP2 590_598_2_2_S594S598 phospho",
    "RAP1GAP2 cnv",
    "RAP1GAP2 methyl",
    "RAP1GAP2 proteo",
    "RAP1GAP2 rna"
  ],
  "RAP1GDS1": [
    "RAP1GDS1 cnv",
    "RAP1GDS1 methyl",
    "RAP1GDS1 proteo",
    "RAP1GDS1 rna"
  ],
  "RAP2A": [
    "RAP2A cnv",
    "RAP2A methyl",
    "RAP2A proteo",
    "RAP2A rna"
  ],
  "RAP2B": [
    "RAP2B cnv",
    "RAP2B methyl",
    "RAP2B proteo",
    "RAP2B rna"
  ],
  "RAP2C": [
    "RAP2C methyl",
    "RAP2C proteo",
    "RAP2C rna"
  ],
  "RAP2C-AS1": [
    "RAP2C-AS1 methyl"
  ],
  "RAPGEF1": [
    "RAPGEF1 10_14_1_1_S10 phospho",
    "RAPGEF1 298_298_1_1_S298 phospho",
    "RAPGEF1 352_362_1_1_S352 phospho",
    "RAPGEF1 352_362_1_1_S362 phospho",
    "RAPGEF1 352_370_2_2_S352S366 phospho",
    "RAPGEF1 480_489_1_1_S480 phospho",
    "RAPGEF1 cnv",
    "RAPGEF1 methyl",
    "RAPGEF1 proteo",
    "RAPGEF1 rna"
  ],
  "RAPGEF2": [
    "RAPGEF2 1091_1110_1_1_S1091 phospho",
    "RAPGEF2 1091_1110_1_1_S1094 phospho",
    "RAPGEF2 1120_1121_1_1_S1121 phospho",
    "RAPGEF2 1267_1285_1_0 phospho",
    "RAPGEF2 1267_1285_1_1_S1277 phospho",
    "RAPGEF2 1267_1285_2_0 phospho",
    "RAPGEF2 1338_1352_1_1_S1345 phospho",
    "RAPGEF2 1434_1448_1_1_S1442 phospho",
    "RAPGEF2 cnv",
    "RAPGEF2 methyl",
    "RAPGEF2 proteo",
    "RAPGEF2 rna"
  ],
  "RAPGEF3": [
    "RAPGEF3 cnv",
    "RAPGEF3 methyl",
    "RAPGEF3 rna"
  ],
  "RAPGEF4": [
    "RAPGEF4 cnv",
    "RAPGEF4 methyl",
    "RAPGEF4 proteo",
    "RAPGEF4 rna"
  ],
  "RAPGEF4-AS1": [
    "RAPGEF4-AS1 methyl"
  ],
  "RAPGEF5": [
    "RAPGEF5 375_375_1_1_S375 phospho",
    "RAPGEF5 cnv",
    "RAPGEF5 methyl",
    "RAPGEF5 rna"
  ],
  "RAPGEF6": [
    "RAPGEF6 cnv",
    "RAPGEF6 methyl",
    "RAPGEF6 proteo",
    "RAPGEF6 rna"
  ],
  "RAPGEFL1": [
    "RAPGEFL1 cnv",
    "RAPGEFL1 methyl",
    "RAPGEFL1 rna"
  ],
  "RAPH1": [
    "RAPH1 1005_1014_1_1_S1012 phospho",
    "RAPH1 1060_1098_1_0 phospho",
    "RAPH1 1130_1154_1_0 phospho",
    "RAPH1 1134_1154_1_1_S1154 phospho",
    "RAPH1 520_533_1_1_S533 phospho",
    "RAPH1 569_578_1_1_S571 phospho",
    "RAPH1 845_860_2_2_S845S856 phospho",
    "RAPH1 867_894_1_1_S894 phospho",
    "RAPH1 cnv",
    "RAPH1 methyl",
    "RAPH1 proteo",
    "RAPH1 rna"
  ],
  "RAPSN": [
    "RAPSN cnv",
    "RAPSN rna"
  ],
  "RARA": [
    "RARA cnv",
    "RARA methyl",
    "RARA rna"
  ],
  "RARB": [
    "RARB cnv",
    "RARB methyl",
    "RARB rna"
  ],
  "RARG": [
    "RARG cnv",
    "RARG methyl",
    "RARG rna"
  ],
  "RARRES1": [
    "RARRES1 cnv",
    "RARRES1 methyl",
    "RARRES1 rna"
  ],
  "RARRES2": [
    "RARRES2 cnv",
    "RARRES2 methyl",
    "RARRES2 proteo",
    "RARRES2 rna"
  ],
  "RARS1": [
    "RARS1 cnv",
    "RARS1 methyl",
    "RARS1 proteo",
    "RARS1 rna"
  ],
  "RARS2": [
    "RARS2 cnv",
    "RARS2 methyl",
    "RARS2 proteo",
    "RARS2 rna"
  ],
  "RASA1": [
    "RASA1 cnv",
    "RASA1 methyl",
    "RASA1 proteo",
    "RASA1 rna"
  ],
  "RASA2": [
    "RASA2 cnv",
    "RASA2 methyl",
    "RASA2 proteo",
    "RASA2 rna"
  ],
  "RASA3": [
    "RASA3 58_58_1_1_S58 phospho",
    "RASA3 773_777_1_1_S777 phospho",
    "RASA3 775_777_1_1_S777 phospho",
    "RASA3 795_801_1_1_S801 phospho",
    "RASA3 cnv",
    "RASA3 methyl",
    "RASA3 proteo",
    "RASA3 rna"
  ],
  "RASA4": [
    "RASA4 cnv",
    "RASA4 rna"
  ],
  "RASA4B": [
    "RASA4B cnv",
    "RASA4B methyl",
    "RASA4B rna"
  ],
  "RASAL1": [
    "RASAL1 cnv",
    "RASAL1 methyl",
    "RASAL1 proteo",
    "RASAL1 rna"
  ],
  "RASAL2": [
    "RASAL2 159_159_1_1_S159 phospho",
    "RASAL2 164_171_1_1_S164 phospho",
    "RASAL2 164_183_1_1_S164 phospho",
    "RASAL2 756_761_1_1_T761 phospho",
    "RASAL2 cnv",
    "RASAL2 methyl",
    "RASAL2 proteo",
    "RASAL2 rna"
  ],
  "RASAL2-AS1": [
    "RASAL2-AS1 methyl"
  ],
  "RASAL3": [
    "RASAL3 51_59_1_1_S51 phospho",
    "RASAL3 841_843_1_1_S841 phospho",
    "RASAL3 991_996_1_0 phospho",
    "RASAL3 cnv",
    "RASAL3 methyl",
    "RASAL3 proteo",
    "RASAL3 rna"
  ],
  "RASD1": [
    "RASD1 cnv",
    "RASD1 methyl",
    "RASD1 rna"
  ],
  "RASD2": [
    "RASD2 cnv",
    "RASD2 methyl",
    "RASD2 rna"
  ],
  "RASEF": [
    "RASEF cnv",
    "RASEF methyl",
    "RASEF rna"
  ],
  "RASGEF1A": [
    "RASGEF1A cnv",
    "RASGEF1A methyl",
    "RASGEF1A rna"
  ],
  "RASGEF1B": [
    "RASGEF1B cnv",
    "RASGEF1B methyl",
    "RASGEF1B rna"
  ],
  "RASGEF1C": [
    "RASGEF1C cnv",
    "RASGEF1C methyl",
    "RASGEF1C rna"
  ],
  "RASGRF1": [
    "RASGRF1 cnv",
    "RASGRF1 methyl",
    "RASGRF1 proteo",
    "RASGRF1 rna"
  ],
  "RASGRF2": [
    "RASGRF2 726_734_1_1_S726 phospho",
    "RASGRF2 746_753_1_1_S746 phospho",
    "RASGRF2 838_855_1_1_S852 phospho",
    "RASGRF2 cnv",
    "RASGRF2 methyl",
    "RASGRF2 proteo",
    "RASGRF2 rna"
  ],
  "RASGRF2-AS1": [
    "RASGRF2-AS1 methyl"
  ],
  "RASGRP1": [
    "RASGRP1 cnv",
    "RASGRP1 methyl",
    "RASGRP1 rna"
  ],
  "RASGRP2": [
    "RASGRP2 554_569_1_1_S554 phospho",
    "RASGRP2 cnv",
    "RASGRP2 methyl",
    "RASGRP2 proteo",
    "RASGRP2 rna"
  ],
  "RASGRP3": [
    "RASGRP3 cnv",
    "RASGRP3 rna"
  ],
  "RASGRP4": [
    "RASGRP4 cnv",
    "RASGRP4 methyl",
    "RASGRP4 rna"
  ],
  "RASIP1": [
    "RASIP1 292_312_1_1_S292 phospho",
    "RASIP1 961_962_1_1_S962 phospho",
    "RASIP1 cnv",
    "RASIP1 methyl",
    "RASIP1 proteo",
    "RASIP1 rna"
  ],
  "RASL10A": [
    "RASL10A cnv",
    "RASL10A methyl",
    "RASL10A rna"
  ],
  "RASL10B": [
    "RASL10B cnv",
    "RASL10B methyl",
    "RASL10B rna"
  ],
  "RASL11A": [
    "RASL11A cnv",
    "RASL11A methyl",
    "RASL11A rna"
  ],
  "RASL11B": [
    "RASL11B cnv",
    "RASL11B methyl",
    "RASL11B rna"
  ],
  "RASL12": [
    "RASL12 cnv",
    "RASL12 methyl",
    "RASL12 proteo",
    "RASL12 rna"
  ],
  "RASSF1": [
    "RASSF1 cnv",
    "RASSF1 methyl",
    "RASSF1 rna"
  ],
  "RASSF1-AS1": [
    "RASSF1-AS1 methyl"
  ],
  "RASSF10": [
    "RASSF10 cnv",
    "RASSF10 methyl",
    "RASSF10 rna"
  ],
  "RASSF2": [
    "RASSF2 cnv",
    "RASSF2 methyl",
    "RASSF2 proteo",
    "RASSF2 rna"
  ],
  "RASSF3": [
    "RASSF3 cnv",
    "RASSF3 methyl",
    "RASSF3 rna"
  ],
  "RASSF4": [
    "RASSF4 91_110_1_1_S91 phospho",
    "RASSF4 cnv",
    "RASSF4 methyl",
    "RASSF4 proteo",
    "RASSF4 rna"
  ],
  "RASSF5": [
    "RASSF5 cnv",
    "RASSF5 methyl",
    "RASSF5 proteo",
    "RASSF5 rna"
  ],
  "RASSF6": [
    "RASSF6 cnv",
    "RASSF6 methyl",
    "RASSF6 rna"
  ],
  "RASSF7": [
    "RASSF7 cnv",
    "RASSF7 methyl",
    "RASSF7 rna"
  ],
  "RASSF8": [
    "RASSF8 129_133_1_1_S129 phospho",
    "RASSF8 cnv",
    "RASSF8 methyl",
    "RASSF8 proteo",
    "RASSF8 rna"
  ],
  "RASSF9": [
    "RASSF9 cnv",
    "RASSF9 rna"
  ],
  "RAVER1": [
    "RAVER1 458_480_1_1_T480 phospho",
    "RAVER1 634_638_1_1_S634 phospho",
    "RAVER1 684_704_1_1_S697 phospho",
    "RAVER1 717_749_1_1_S724 phospho",
    "RAVER1 cnv",
    "RAVER1 methyl",
    "RAVER1 proteo",
    "RAVER1 rna"
  ],
  "RAVER2": [
    "RAVER2 cnv",
    "RAVER2 methyl",
    "RAVER2 proteo",
    "RAVER2 rna"
  ],
  "RAX": [
    "RAX cnv",
    "RAX methyl",
    "RAX rna"
  ],
  "RAX2": [
    "RAX2 cnv",
    "RAX2 rna"
  ],
  "RB1": [
    "RB1 241_249_1_1_S249 phospho",
    "RB1 342_356_1_1_T356 phospho",
    "RB1 360_373_1_1_T373 phospho",
    "RB1 583_612_1_1_S612 phospho",
    "RB1 583_612_1_1_Y606 phospho",
    "RB1 816_823_1_1_T821 phospho",
    "RB1 816_826_1_1_T826 phospho",
    "RB1 816_826_2_2_T821T826 phospho",
    "RB1 9_37_1_1_S37 phospho",
    "RB1 cnv",
    "RB1 methyl",
    "RB1 proteo",
    "RB1 rna"
  ],
  "RB1-DT": [
    "RB1-DT methyl"
  ],
  "RB1CC1": [
    "RB1CC1 237_243_1_1_S243 phospho",
    "RB1CC1 249_257_1_1_S257 phospho",
    "RB1CC1 261_274_1_1_S266 phospho",
    "RB1CC1 624_637_1_1_S624 phospho",
    "RB1CC1 642_653_1_1_S653 phospho",
    "RB1CC1 cnv",
    "RB1CC1 methyl",
    "RB1CC1 proteo",
    "RB1CC1 rna"
  ],
  "RBAK": [
    "RBAK cnv",
    "RBAK methyl",
    "RBAK rna"
  ],
  "RBAK-RBAKDN": [
    "RBAK-RBAKDN cnv",
    "RBAK-RBAKDN methyl",
    "RBAK-RBAKDN rna"
  ],
  "RBBP4": [
    "RBBP4 355_374_1_1_S355 phospho",
    "RBBP4 cnv",
    "RBBP4 methyl",
    "RBBP4 proteo",
    "RBBP4 rna"
  ],
  "RBBP5": [
    "RBBP5 cnv",
    "RBBP5 proteo",
    "RBBP5 rna"
  ],
  "RBBP6": [
    "RBBP6 1173_1179_1_1_S1179 phospho",
    "RBBP6 1256_1277_1_1_S1277 phospho",
    "RBBP6 770_772_1_1_S772 phospho",
    "RBBP6 873_876_1_1_S873 phospho",
    "RBBP6 cnv",
    "RBBP6 methyl",
    "RBBP6 proteo",
    "RBBP6 rna"
  ],
  "RBBP7": [
    "RBBP7 methyl",
    "RBBP7 proteo",
    "RBBP7 rna"
  ],
  "RBBP8": [
    "RBBP8 cnv",
    "RBBP8 methyl",
    "RBBP8 rna"
  ],
  "RBBP8NL": [
    "RBBP8NL cnv",
    "RBBP8NL rna"
  ],
  "RBBP9": [
    "RBBP9 cnv",
    "RBBP9 methyl",
    "RBBP9 proteo",
    "RBBP9 rna"
  ],
  "RBCK1": [
    "RBCK1 cnv",
    "RBCK1 methyl",
    "RBCK1 proteo",
    "RBCK1 rna"
  ],
  "RBFA": [
    "RBFA cnv",
    "RBFA methyl",
    "RBFA proteo",
    "RBFA rna"
  ],
  "RBFOX1": [
    "RBFOX1 cnv",
    "RBFOX1 methyl",
    "RBFOX1 rna"
  ],
  "RBFOX2": [
    "RBFOX2 cnv",
    "RBFOX2 methyl",
    "RBFOX2 proteo",
    "RBFOX2 rna"
  ],
  "RBFOX3": [
    "RBFOX3 cnv",
    "RBFOX3 methyl",
    "RBFOX3 proteo",
    "RBFOX3 rna"
  ],
  "RBIS": [
    "RBIS cnv",
    "RBIS methyl",
    "RBIS proteo",
    "RBIS rna"
  ],
  "RBKS": [
    "RBKS cnv",
    "RBKS methyl",
    "RBKS proteo",
    "RBKS rna"
  ],
  "RBL1": [
    "RBL1 cnv",
    "RBL1 methyl",
    "RBL1 rna"
  ],
  "RBL2": [
    "RBL2 1110_1112_1_1_S1112 phospho",
    "RBL2 413_427_1_1_S413 phospho",
    "RBL2 639_642_1_1_S639 phospho",
    "RBL2 948_954_1_1_S952 phospho",
    "RBL2 965_966_1_0 phospho",
    "RBL2 965_966_1_1_S966 phospho",
    "RBL2 cnv",
    "RBL2 methyl",
    "RBL2 proteo",
    "RBL2 rna"
  ],
  "RBM10": [
    "RBM10 154_156_1_1_S154 phospho",
    "RBM10 573_596_1_1_S596 phospho",
    "RBM10 774_775_1_1_S775 phospho",
    "RBM10 783_788_1_1_S788 phospho",
    "RBM10 797_803_1_1_S801 phospho",
    "RBM10 797_803_2_2_S801S803 phospho",
    "RBM10 862_862_1_1_S862 phospho",
    "RBM10 903_917_1_1_S910 phospho",
    "RBM10 methyl",
    "RBM10 proteo",
    "RBM10 rna"
  ],
  "RBM11": [
    "RBM11 cnv",
    "RBM11 rna"
  ],
  "RBM12": [
    "RBM12 420_433_3_3_S420S422S424 phospho",
    "RBM12 422_433_1_1_S424 phospho",
    "RBM12 422_433_2_2_S422S424 phospho",
    "RBM12 424_433_1_1_S424 phospho",
    "RBM12 cnv",
    "RBM12 methyl",
    "RBM12 proteo",
    "RBM12 rna"
  ],
  "RBM12B": [
    "RBM12B 250_254_1_1_S254 phospho",
    "RBM12B 278_285_1_1_S280 phospho",
    "RBM12B 278_285_2_2_S278S280 phospho",
    "RBM12B 280_285_1_1_S280 phospho",
    "RBM12B 575_575_1_1_S575 phospho",
    "RBM12B 591_591_1_1_S591 phospho",
    "RBM12B 638_640_1_1_S638 phospho",
    "RBM12B 710_710_1_1_S710 phospho",
    "RBM12B 710_718_1_1_S718 phospho",
    "RBM12B 829_839_1_1_S839 phospho",
    "RBM12B cnv",
    "RBM12B methyl",
    "RBM12B proteo",
    "RBM12B rna"
  ],
  "RBM14": [
    "RBM14 206_206_1_1_T206 phospho",
    "RBM14 220_237_1_1_S220 phospho",
    "RBM14 548_576_1_0 phospho",
    "RBM14 548_576_1_1_T572 phospho",
    "RBM14 579_582_1_1_S582 phospho",
    "RBM14 579_592_1_1_S582 phospho",
    "RBM14 618_623_1_1_S618 phospho",
    "RBM14 663_665_1_1_S663 phospho",
    "RBM14 cnv",
    "RBM14 methyl",
    "RBM14 proteo",
    "RBM14 rna"
  ],
  "RBM14-RBM4": [
    "RBM14-RBM4 cnv",
    "RBM14-RBM4 methyl",
    "RBM14-RBM4 rna"
  ],
  "RBM15": [
    "RBM15 125_131_1_1_S128 phospho",
    "RBM15 205_212_1_1_S212 phospho",
    "RBM15 257_259_1_1_S259 phospho",
    "RBM15 257_276_2_2_S257S259 phospho",
    "RBM15 568_573_1_1_T568 phospho",
    "RBM15 656_659_1_1_S656 phospho",
    "RBM15 670_680_2_2_S670S674 phospho",
    "RBM15 765_781_1_1_S765 phospho",
    "RBM15 774_781_1_1_S781 phospho",
    "RBM15 cnv",
    "RBM15 methyl",
    "RBM15 proteo",
    "RBM15 rna"
  ],
  "RBM15-AS1": [
    "RBM15-AS1 methyl"
  ],
  "RBM15B": [
    "RBM15B 100_109_1_1_S109 phospho",
    "RBM15B 100_138_2_2_S109S113 phospho",
    "RBM15B 113_138_1_1_S113 phospho",
    "RBM15B 229_261_1_0 phospho",
    "RBM15B 229_261_1_1_T238 phospho",
    "RBM15B 265_267_1_1_S267 phospho",
    "RBM15B 532_539_1_1_T532 phospho",
    "RBM15B 544_554_1_1_S552 phospho",
    "RBM15B 606_611_1_1_S609 phospho",
    "RBM15B cnv",
    "RBM15B methyl",
    "RBM15B proteo",
    "RBM15B rna"
  ],
  "RBM17": [
    "RBM17 155_161_1_1_S155 phospho",
    "RBM17 169_180_1_1_S169 phospho",
    "RBM17 214_237_1_0 phospho",
    "RBM17 214_237_1_1_S222 phospho",
    "RBM17 222_237_1_1_S222 phospho",
    "RBM17 262_266_1_1_S266 phospho",
    "RBM17 71_71_1_1_T71 phospho",
    "RBM17 cnv",
    "RBM17 methyl",
    "RBM17 proteo",
    "RBM17 rna"
  ],
  "RBM18": [
    "RBM18 cnv",
    "RBM18 methyl",
    "RBM18 proteo",
    "RBM18 rna"
  ],
  "RBM19": [
    "RBM19 cnv",
    "RBM19 methyl",
    "RBM19 proteo",
    "RBM19 rna"
  ],
  "RBM20": [
    "RBM20 740_752_1_1_S742 phospho",
    "RBM20 876_881_1_1_S876 phospho",
    "RBM20 cnv",
    "RBM20 methyl",
    "RBM20 rna"
  ],
  "RBM22": [
    "RBM22 cnv",
    "RBM22 methyl",
    "RBM22 proteo",
    "RBM22 rna"
  ],
  "RBM23": [
    "RBM23 137_142_1_1_S142 phospho",
    "RBM23 149_159_1_1_S149 phospho",
    "RBM23 cnv",
    "RBM23 methyl",
    "RBM23 rna"
  ],
  "RBM24": [
    "RBM24 cnv",
    "RBM24 methyl",
    "RBM24 rna"
  ],
  "RBM25": [
    "RBM25 583_583_1_1_S583 phospho",
    "RBM25 675_683_1_1_S677 phospho",
    "RBM25 675_683_1_1_S683 phospho",
    "RBM25 675_683_2_2_S677S683 phospho",
    "RBM25 cnv",
    "RBM25 methyl",
    "RBM25 proteo",
    "RBM25 rna"
  ],
  "RBM26": [
    "RBM26 cnv",
    "RBM26 methyl",
    "RBM26 proteo",
    "RBM26 rna"
  ],
  "RBM26-AS1": [
    "RBM26-AS1 methyl"
  ],
  "RBM27": [
    "RBM27 cnv",
    "RBM27 methyl",
    "RBM27 proteo",
    "RBM27 rna"
  ],
  "RBM28": [
    "RBM28 cnv",
    "RBM28 methyl",
    "RBM28 proteo",
    "RBM28 rna"
  ],
  "RBM3": [
    "RBM3 methyl",
    "RBM3 proteo",
    "RBM3 rna"
  ],
  "RBM33": [
    "RBM33 205_215_1_1_S205 phospho",
    "RBM33 765_765_1_1_S765 phospho",
    "RBM33 cnv",
    "RBM33 methyl",
    "RBM33 proteo",
    "RBM33 rna"
  ],
  "RBM33-DT": [
    "RBM33-DT methyl"
  ],
  "RBM34": [
    "RBM34 cnv",
    "RBM34 methyl",
    "RBM34 rna"
  ],
  "RBM38": [
    "RBM38 cnv",
    "RBM38 methyl",
    "RBM38 rna"
  ],
  "RBM39": [
    "RBM39 136_146_1_1_S136 phospho",
    "RBM39 95_100_1_1_S97 phospho",
    "RBM39 97_100_1_1_S97 phospho",
    "RBM39 cnv",
    "RBM39 methyl",
    "RBM39 proteo",
    "RBM39 rna"
  ],
  "RBM4": [
    "RBM4 86_90_1_1_S86 phospho",
    "RBM4 cnv",
    "RBM4 methyl",
    "RBM4 proteo",
    "RBM4 rna"
  ],
  "RBM41": [
    "RBM41 rna"
  ],
  "RBM42": [
    "RBM42 cnv",
    "RBM42 methyl",
    "RBM42 proteo",
    "RBM42 rna"
  ],
  "RBM43": [
    "RBM43 cnv",
    "RBM43 methyl",
    "RBM43 rna"
  ],
  "RBM44": [
    "RBM44 cnv",
    "RBM44 methyl",
    "RBM44 rna"
  ],
  "RBM45": [
    "RBM45 cnv",
    "RBM45 methyl",
    "RBM45 proteo",
    "RBM45 rna"
  ],
  "RBM46": [
    "RBM46 cnv",
    "RBM46 methyl",
    "RBM46 rna"
  ],
  "RBM47": [
    "RBM47 cnv",
    "RBM47 methyl",
    "RBM47 proteo",
    "RBM47 rna"
  ],
  "RBM48": [
    "RBM48 cnv",
    "RBM48 methyl",
    "RBM48 rna"
  ],
  "RBM4B": [
    "RBM4B 86_90_1_1_S86 phospho",
    "RBM4B cnv",
    "RBM4B methyl",
    "RBM4B proteo",
    "RBM4B rna"
  ],
  "RBM5": [
    "RBM5 51_59_1_1_S59 phospho",
    "RBM5 620_624_1_1_S624 phospho",
    "RBM5 69_87_3_3_S69S72S78 phospho",
    "RBM5 72_87_1_1_S78 phospho",
    "RBM5 72_92_1_1_S78 phospho",
    "RBM5 72_97_1_1_S78 phospho",
    "RBM5 cnv",
    "RBM5 methyl",
    "RBM5 proteo",
    "RBM5 rna"
  ],
  "RBM6": [
    "RBM6 344_362_1_1_S362 phospho",
    "RBM6 746_756_1_1_S746 phospho",
    "RBM6 891_891_1_1_S891 phospho",
    "RBM6 cnv",
    "RBM6 methyl",
    "RBM6 proteo",
    "RBM6 rna"
  ],
  "RBM7": [
    "RBM7 cnv",
    "RBM7 methyl",
    "RBM7 proteo",
    "RBM7 rna"
  ],
  "RBM8A": [
    "RBM8A 54_56_1_1_S56 phospho",
    "RBM8A cnv",
    "RBM8A methyl",
    "RBM8A proteo",
    "RBM8A rna"
  ],
  "RBMS1": [
    "RBMS1 27_60_1_0 phospho",
    "RBMS1 cnv",
    "RBMS1 methyl",
    "RBMS1 proteo",
    "RBMS1 rna"
  ],
  "RBMS2": [
    "RBMS2 cnv",
    "RBMS2 proteo",
    "RBMS2 rna"
  ],
  "RBMS3": [
    "RBMS3 cnv",
    "RBMS3 methyl",
    "RBMS3 rna"
  ],
  "RBMX": [
    "RBMX 326_337_1_1_S332 phospho",
    "RBMX methyl",
    "RBMX proteo",
    "RBMX rna"
  ],
  "RBMX2": [
    "RBMX2 185_188_1_1_S188 phospho",
    "RBMX2 methyl",
    "RBMX2 proteo",
    "RBMX2 rna"
  ],
  "RBMXL1": [
    "RBMXL1 326_337_1_1_S332 phospho",
    "RBMXL1 cnv",
    "RBMXL1 methyl",
    "RBMXL1 proteo",
    "RBMXL1 rna"
  ],
  "RBMXL2": [
    "RBMXL2 cnv",
    "RBMXL2 methyl",
    "RBMXL2 rna"
  ],
  "RBMXL3": [
    "RBMXL3 methyl",
    "RBMXL3 rna"
  ],
  "RBMY1J": [
    "RBMY1J methyl"
  ],
  "RBMY2EP": [
    "RBMY2EP methyl"
  ],
  "RBMY2FP": [
    "RBMY2FP methyl"
  ],
  "RBP1": [
    "RBP1 20_23_1_1_S20 phospho",
    "RBP1 cnv",
    "RBP1 methyl",
    "RBP1 proteo",
    "RBP1 rna"
  ],
  "RBP2": [
    "RBP2 cnv",
    "RBP2 rna"
  ],
  "RBP3": [
    "RBP3 cnv",
    "RBP3 rna"
  ],
  "RBP4": [
    "RBP4 cnv",
    "RBP4 methyl",
    "RBP4 proteo",
    "RBP4 rna"
  ],
  "RBP5": [
    "RBP5 cnv",
    "RBP5 rna"
  ],
  "RBP7": [
    "RBP7 cnv",
    "RBP7 methyl",
    "RBP7 proteo",
    "RBP7 rna"
  ],
  "RBPJ": [
    "RBPJ cnv",
    "RBPJ methyl",
    "RBPJ proteo",
    "RBPJ rna"
  ],
  "RBPJL": [
    "RBPJL cnv",
    "RBPJL methyl",
    "RBPJL rna"
  ],
  "RBPMS": [
    "RBPMS cnv",
    "RBPMS methyl",
    "RBPMS proteo",
    "RBPMS rna"
  ],
  "RBPMS-AS1": [
    "RBPMS-AS1 methyl"
  ],
  "RBPMS2": [
    "RBPMS2 cnv",
    "RBPMS2 methyl",
    "RBPMS2 rna"
  ],
  "RBSN": [
    "RBSN 209_226_1_1_S215 phospho",
    "RBSN 209_226_1_1_S226 phospho",
    "RBSN 209_226_2_2_S215S219 phospho",
    "RBSN 230_239_1_1_S230 phospho",
    "RBSN cnv",
    "RBSN methyl",
    "RBSN proteo",
    "RBSN rna"
  ],
  "RBX1": [
    "RBX1 cnv",
    "RBX1 methyl",
    "RBX1 proteo",
    "RBX1 rna"
  ],
  "RC3H1": [
    "RC3H1 cnv",
    "RC3H1 methyl",
    "RC3H1 proteo",
    "RC3H1 rna"
  ],
  "RC3H1-DT": [
    "RC3H1-DT methyl"
  ],
  "RC3H2": [
    "RC3H2 1119_1119_1_1_S1119 phospho",
    "RC3H2 736_751_1_1_S738 phospho",
    "RC3H2 982_989_1_0 phospho",
    "RC3H2 982_989_1_1_S983 phospho",
    "RC3H2 cnv",
    "RC3H2 methyl",
    "RC3H2 proteo",
    "RC3H2 rna"
  ],
  "RCAN1": [
    "RCAN1 118_137_1_1_S137 phospho",
    "RCAN1 cnv",
    "RCAN1 methyl",
    "RCAN1 proteo",
    "RCAN1 rna"
  ],
  "RCAN2": [
    "RCAN2 cnv",
    "RCAN2 methyl",
    "RCAN2 proteo",
    "RCAN2 rna"
  ],
  "RCAN3": [
    "RCAN3 cnv",
    "RCAN3 methyl",
    "RCAN3 rna"
  ],
  "RCAN3AS": [
    "RCAN3AS methyl"
  ],
  "RCBTB1": [
    "RCBTB1 cnv",
    "RCBTB1 methyl",
    "RCBTB1 proteo",
    "RCBTB1 rna"
  ],
  "RCBTB2": [
    "RCBTB2 cnv",
    "RCBTB2 methyl",
    "RCBTB2 proteo",
    "RCBTB2 rna"
  ],
  "RCC1": [
    "RCC1 cnv",
    "RCC1 methyl",
    "RCC1 proteo",
    "RCC1 rna"
  ],
  "RCC1L": [
    "RCC1L cnv",
    "RCC1L methyl",
    "RCC1L proteo",
    "RCC1L rna"
  ],
  "RCC2": [
    "RCC2 cnv",
    "RCC2 methyl",
    "RCC2 proteo",
    "RCC2 rna"
  ],
  "RCCD1": [
    "RCCD1 cnv",
    "RCCD1 methyl",
    "RCCD1 proteo",
    "RCCD1 rna"
  ],
  "RCE1": [
    "RCE1 cnv",
    "RCE1 methyl",
    "RCE1 rna"
  ],
  "RCHY1": [
    "RCHY1 cnv",
    "RCHY1 methyl",
    "RCHY1 proteo",
    "RCHY1 rna"
  ],
  "RCL1": [
    "RCL1 cnv",
    "RCL1 methyl",
    "RCL1 proteo",
    "RCL1 rna"
  ],
  "RCN1": [
    "RCN1 71_80_1_1_S80 phospho",
    "RCN1 VVRPDSELGERPPEDNQSFQYDHEAFLGK-N2H3F1S0G0 glyco",
    "RCN1 VVRPDSELGERPPEDNQSFQYDHEAFLGK-N2H5F0S0G0 glyco",
    "RCN1 VVRPDSELGERPPEDNQSFQYDHEAFLGK-N2H6F0S0G0 glyco",
    "RCN1 VVRPDSELGERPPEDNQSFQYDHEAFLGK-N4H3F1S0G0 glyco",
    "RCN1 cnv",
    "RCN1 methyl",
    "RCN1 proteo",
    "RCN1 rna"
  ],
  "RCN2": [
    "RCN2 cnv",
    "RCN2 methyl",
    "RCN2 proteo",
    "RCN2 rna"
  ],
  "RCN3": [
    "RCN3 cnv",
    "RCN3 methyl",
    "RCN3 proteo",
    "RCN3 rna"
  ],
  "RCOR1": [
    "RCOR1 127_145_1_1_S127 phospho",
    "RCOR1 260_260_1_1_S260 phospho",
    "RCOR1 cnv",
    "RCOR1 methyl",
    "RCOR1 proteo",
    "RCOR1 rna"
  ],
  "RCOR2": [
    "RCOR2 50_63_1_1_S63 phospho",
    "RCOR2 cnv",
    "RCOR2 methyl",
    "RCOR2 proteo",
    "RCOR2 rna"
  ],
  "RCOR3": [
    "RCOR3 214_231_1_1_S214 phospho",
    "RCOR3 214_231_2_2_S214S229 phospho",
    "RCOR3 cnv",
    "RCOR3 methyl",
    "RCOR3 proteo",
    "RCOR3 rna"
  ],
  "RCSD1": [
    "RCSD1 116_127_1_0 phospho",
    "RCSD1 116_127_1_1_S120 phospho",
    "RCSD1 116_127_2_0 phospho",
    "RCSD1 116_127_2_2_S116S120 phospho",
    "RCSD1 177_179_1_1_S177 phospho",
    "RCSD1 177_179_1_1_S179 phospho",
    "RCSD1 211_220_1_1_S216 phospho",
    "RCSD1 216_220_1_1_S216 phospho",
    "RCSD1 242_246_1_1_S242 phospho",
    "RCSD1 267_288_1_0 phospho",
    "RCSD1 267_288_1_1_S268 phospho",
    "RCSD1 267_288_2_2_S267S268 phospho",
    "RCSD1 298_298_1_1_S298 phospho",
    "RCSD1 348_351_1_1_S351 phospho",
    "RCSD1 68_73_1_1_S68 phospho",
    "RCSD1 82_83_1_1_S83 phospho",
    "RCSD1 94_108_2_2_S105S108 phospho",
    "RCSD1 cnv",
    "RCSD1 methyl",
    "RCSD1 proteo",
    "RCSD1 rna"
  ],
  "RCVRN": [
    "RCVRN cnv",
    "RCVRN rna"
  ],
  "RD3": [
    "RD3 cnv",
    "RD3 rna"
  ],
  "RD3L": [
    "RD3L cnv"
  ],
  "RDH10": [
    "RDH10 cnv",
    "RDH10 methyl",
    "RDH10 proteo",
    "RDH10 rna"
  ],
  "RDH11": [
    "RDH11 cnv",
    "RDH11 proteo",
    "RDH11 rna"
  ],
  "RDH12": [
    "RDH12 cnv",
    "RDH12 rna"
  ],
  "RDH13": [
    "RDH13 cnv",
    "RDH13 methyl",
    "RDH13 proteo",
    "RDH13 rna"
  ],
  "RDH14": [
    "RDH14 cnv",
    "RDH14 methyl",
    "RDH14 proteo",
    "RDH14 rna"
  ],
  "RDH16": [
    "RDH16 cnv",
    "RDH16 rna"
  ],
  "RDH5": [
    "RDH5 cnv",
    "RDH5 rna"
  ],
  "RDH8": [
    "RDH8 cnv",
    "RDH8 rna"
  ],
  "RDM1": [
    "RDM1 cnv",
    "RDM1 methyl",
    "RDM1 rna"
  ],
  "RDX": [
    "RDX 532_533_1_1_S532 phospho",
    "RDX cnv",
    "RDX methyl",
    "RDX proteo",
    "RDX rna"
  ],
  "REC114": [
    "REC114 cnv",
    "REC114 methyl"
  ],
  "REC8": [
    "REC8 cnv",
    "REC8 methyl",
    "REC8 rna"
  ],
  "RECK": [
    "RECK cnv",
    "RECK methyl",
    "RECK proteo",
    "RECK rna"
  ],
  "RECQL": [
    "RECQL cnv",
    "RECQL methyl",
    "RECQL proteo",
    "RECQL rna"
  ],
  "RECQL4": [
    "RECQL4 cnv",
    "RECQL4 methyl",
    "RECQL4 rna"
  ],
  "RECQL5": [
    "RECQL5 484_491_2_2_S488S491 phospho",
    "RECQL5 804_821_1_1_S815 phospho",
    "RECQL5 cnv",
    "RECQL5 methyl",
    "RECQL5 proteo",
    "RECQL5 rna"
  ],
  "REELD1": [
    "REELD1 cnv",
    "REELD1 rna"
  ],
  "REEP1": [
    "REEP1 157_182_1_1_S159 phospho",
    "REEP1 197_207_1_1_S199 phospho",
    "REEP1 cnv",
    "REEP1 methyl",
    "REEP1 proteo",
    "REEP1 rna"
  ],
  "REEP2": [
    "REEP2 150_157_1_1_S152 phospho",
    "REEP2 cnv",
    "REEP2 methyl",
    "REEP2 proteo",
    "REEP2 rna"
  ],
  "REEP3": [
    "REEP3 150_170_1_0 phospho",
    "REEP3 150_170_1_1_S152 phospho",
    "REEP3 cnv",
    "REEP3 methyl",
    "REEP3 proteo",
    "REEP3 rna"
  ],
  "REEP4": [
    "REEP4 cnv",
    "REEP4 methyl",
    "REEP4 proteo",
    "REEP4 rna"
  ],
  "REEP5": [
    "REEP5 cnv",
    "REEP5 methyl",
    "REEP5 proteo",
    "REEP5 rna"
  ],
  "REEP6": [
    "REEP6 cnv",
    "REEP6 methyl",
    "REEP6 proteo",
    "REEP6 rna"
  ],
  "REG1A": [
    "REG1A cnv",
    "REG1A rna"
  ],
  "REG1B": [
    "REG1B cnv"
  ],
  "REG3A": [
    "REG3A cnv"
  ],
  "REG3G": [
    "REG3G cnv",
    "REG3G rna"
  ],
  "REG4": [
    "REG4 cnv",
    "REG4 rna"
  ],
  "REL": [
    "REL cnv",
    "REL methyl",
    "REL proteo",
    "REL rna"
  ],
  "REL-DT": [
    "REL-DT methyl"
  ],
  "RELA": [
    "RELA cnv",
    "RELA methyl",
    "RELA proteo",
    "RELA rna"
  ],
  "RELB": [
    "RELB cnv",
    "RELB methyl",
    "RELB proteo",
    "RELB rna"
  ],
  "RELCH": [
    "RELCH 141_143_1_1_T143 phospho",
    "RELCH 141_170_1_1_T143 phospho",
    "RELCH 192_200_1_1_S193 phospho",
    "RELCH 243_244_1_1_S244 phospho",
    "RELCH 453_456_1_1_S453 phospho",
    "RELCH 45_66_1_1_S56 phospho",
    "RELCH cnv",
    "RELCH methyl",
    "RELCH proteo",
    "RELCH rna"
  ],
  "RELL1": [
    "RELL1 244_261_1_0 phospho",
    "RELL1 244_261_1_1_S244 phospho",
    "RELL1 244_261_1_1_T261 phospho",
    "RELL1 cnv",
    "RELL1 methyl",
    "RELL1 proteo",
    "RELL1 rna"
  ],
  "RELL2": [
    "RELL2 178_189_1_1_S187 phospho",
    "RELL2 cnv",
    "RELL2 methyl",
    "RELL2 rna"
  ],
  "RELN": [
    "RELN cnv",
    "RELN methyl",
    "RELN proteo",
    "RELN rna"
  ],
  "RELT": [
    "RELT cnv",
    "RELT methyl",
    "RELT rna"
  ],
  "REM1": [
    "REM1 18_24_1_1_S18 phospho",
    "REM1 cnv",
    "REM1 methyl",
    "REM1 rna"
  ],
  "REM2": [
    "REM2 27_39_1_1_S27 phospho",
    "REM2 27_39_2_2_S27T31 phospho",
    "REM2 cnv",
    "REM2 rna"
  ],
  "REN": [
    "REN cnv",
    "REN methyl",
    "REN rna"
  ],
  "RENBP": [
    "RENBP 416_420_1_1_S416 phospho",
    "RENBP proteo",
    "RENBP rna"
  ],
  "REP15": [
    "REP15 cnv",
    "REP15 rna"
  ],
  "REPIN1": [
    "REPIN1 cnv",
    "REPIN1 methyl",
    "REPIN1 proteo",
    "REPIN1 rna"
  ],
  "REPS1": [
    "REPS1 115_127_1_0 phospho",
    "REPS1 115_127_1_1_S118 phospho",
    "REPS1 272_275_1_1_S272 phospho",
    "REPS1 272_275_1_1_S273 phospho",
    "REPS1 272_275_2_2_S272S273 phospho",
    "REPS1 272_282_1_1_S273 phospho",
    "REPS1 272_282_2_2_S272S273 phospho",
    "REPS1 377_399_1_0 phospho",
    "REPS1 377_399_1_1_S390 phospho",
    "REPS1 428_448_1_0 phospho",
    "REPS1 428_461_1_1_T459 phospho",
    "REPS1 473_489_1_0 phospho",
    "REPS1 473_489_1_1_S482 phospho",
    "REPS1 473_500_1_1_S482 phospho",
    "REPS1 535_558_1_1_S540 phospho",
    "REPS1 535_558_2_1_S540 phospho",
    "REPS1 cnv",
    "REPS1 methyl",
    "REPS1 proteo",
    "REPS1 rna"
  ],
  "REPS2": [
    "REPS2 216_226_1_0 phospho",
    "REPS2 460_465_1_0 phospho",
    "REPS2 460_465_1_1_S460 phospho",
    "REPS2 478_478_1_1_T478 phospho",
    "REPS2 491_492_1_1_S492 phospho",
    "REPS2 methyl",
    "REPS2 proteo",
    "REPS2 rna"
  ],
  "RER1": [
    "RER1 cnv",
    "RER1 methyl",
    "RER1 proteo",
    "RER1 rna"
  ],
  "RERE": [
    "RERE 1255_1268_1_1_S1266 phospho",
    "RERE 1266_1268_1_1_S1266 phospho",
    "RERE 50_72_2_2_S53S56 phospho",
    "RERE 594_600_2_0 phospho",
    "RERE 599_600_1_1_S600 phospho",
    "RERE 608_624_1_1_S613 phospho",
    "RERE 613_624_1_1_S613 phospho",
    "RERE 641_642_1_1_S642 phospho",
    "RERE 656_658_1_1_S656 phospho",
    "RERE 656_666_1_1_S656 phospho",
    "RERE 671_690_1_1_S679 phospho",
    "RERE 671_690_2_2_S679S681 phospho",
    "RERE cnv",
    "RERE methyl",
    "RERE proteo",
    "RERE rna"
  ],
  "RERG": [
    "RERG cnv",
    "RERG methyl",
    "RERG rna"
  ],
  "RERGL": [
    "RERGL cnv",
    "RERGL rna"
  ],
  "RESF1": [
    "RESF1 cnv",
    "RESF1 methyl",
    "RESF1 rna"
  ],
  "RESP18": [
    "RESP18 cnv",
    "RESP18 methyl",
    "RESP18 rna"
  ],
  "REST": [
    "REST cnv",
    "REST methyl",
    "REST rna"
  ],
  "RET": [
    "RET cnv",
    "RET kinase",
    "RET methyl",
    "RET proteo",
    "RET rna"
  ],
  "RETN": [
    "RETN cnv",
    "RETN proteo",
    "RETN rna"
  ],
  "RETNLB": [
    "RETNLB cnv"
  ],
  "RETREG1": [
    "RETREG1 cnv",
    "RETREG1 methyl",
    "RETREG1 proteo",
    "RETREG1 rna"
  ],
  "RETREG2": [
    "RETREG2 129_145_1_1_S138 phospho",
    "RETREG2 129_153_1_1_S132 phospho",
    "RETREG2 329_354_1_1_S344 phospho",
    "RETREG2 385_385_1_1_S385 phospho",
    "RETREG2 cnv",
    "RETREG2 methyl",
    "RETREG2 proteo",
    "RETREG2 rna"
  ],
  "RETREG3": [
    "RETREG3 258_275_1_1_S258 phospho",
    "RETREG3 258_275_2_2_S258S260 phospho",
    "RETREG3 307_325_1_1_S320 phospho",
    "RETREG3 307_325_2_2_S313S320 phospho",
    "RETREG3 cnv",
    "RETREG3 methyl",
    "RETREG3 proteo",
    "RETREG3 rna"
  ],
  "RETSAT": [
    "RETSAT cnv",
    "RETSAT methyl",
    "RETSAT proteo",
    "RETSAT rna"
  ],
  "REV1": [
    "REV1 cnv",
    "REV1 methyl",
    "REV1 rna"
  ],
  "REV3L": [
    "REV3L cnv",
    "REV3L methyl",
    "REV3L rna"
  ],
  "REX1BD": [
    "REX1BD cnv",
    "REX1BD methyl",
    "REX1BD rna"
  ],
  "REXO1": [
    "REXO1 213_218_1_1_S213 phospho",
    "REXO1 340_365_1_1_S358 phospho",
    "REXO1 cnv",
    "REXO1 methyl",
    "REXO1 rna"
  ],
  "REXO2": [
    "REXO2 cnv",
    "REXO2 methyl",
    "REXO2 proteo",
    "REXO2 rna"
  ],
  "REXO4": [
    "REXO4 14_15_1_1_S15 phospho",
    "REXO4 cnv",
    "REXO4 methyl",
    "REXO4 proteo",
    "REXO4 rna"
  ],
  "REXO5": [
    "REXO5 cnv",
    "REXO5 methyl",
    "REXO5 rna"
  ],
  "RFC1": [
    "RFC1 cnv",
    "RFC1 methyl",
    "RFC1 proteo",
    "RFC1 rna"
  ],
  "RFC2": [
    "RFC2 cnv",
    "RFC2 methyl",
    "RFC2 proteo",
    "RFC2 rna"
  ],
  "RFC3": [
    "RFC3 cnv",
    "RFC3 methyl",
    "RFC3 proteo",
    "RFC3 rna"
  ],
  "RFC4": [
    "RFC4 cnv",
    "RFC4 methyl",
    "RFC4 proteo",
    "RFC4 rna"
  ],
  "RFC5": [
    "RFC5 cnv",
    "RFC5 methyl",
    "RFC5 proteo",
    "RFC5 rna"
  ],
  "RFESD": [
    "RFESD cnv",
    "RFESD methyl",
    "RFESD proteo",
    "RFESD rna"
  ],
  "RFFL": [
    "RFFL 224_232_1_1_S226 phospho",
    "RFFL 224_232_2_2_S226S229 phospho",
    "RFFL cnv",
    "RFFL proteo",
    "RFFL rna"
  ],
  "RFK": [
    "RFK cnv",
    "RFK methyl",
    "RFK proteo",
    "RFK rna"
  ],
  "RFLNA": [
    "RFLNA cnv",
    "RFLNA methyl",
    "RFLNA rna"
  ],
  "RFLNB": [
    "RFLNB 6_6_1_1_S6 phospho",
    "RFLNB cnv",
    "RFLNB proteo",
    "RFLNB rna"
  ],
  "RFNG": [
    "RFNG cnv",
    "RFNG methyl",
    "RFNG rna"
  ],
  "RFPL1": [
    "RFPL1 cnv",
    "RFPL1 rna"
  ],
  "RFPL2": [
    "RFPL2 cnv",
    "RFPL2 rna"
  ],
  "RFPL3": [
    "RFPL3 cnv",
    "RFPL3 rna"
  ],
  "RFPL4A": [
    "RFPL4A cnv",
    "RFPL4A rna"
  ],
  "RFPL4AL1": [
    "RFPL4AL1 cnv",
    "RFPL4AL1 rna"
  ],
  "RFPL4B": [
    "RFPL4B cnv",
    "RFPL4B rna"
  ],
  "RFT1": [
    "RFT1 cnv",
    "RFT1 methyl",
    "RFT1 proteo",
    "RFT1 rna"
  ],
  "RFTN1": [
    "RFTN1 199_199_1_1_S199 phospho",
    "RFTN1 199_212_1_1_S199 phospho",
    "RFTN1 220_225_1_1_S220 phospho",
    "RFTN1 238_255_1_0 phospho",
    "RFTN1 552_555_1_1_S555 phospho",
    "RFTN1 cnv",
    "RFTN1 methyl",
    "RFTN1 proteo",
    "RFTN1 rna"
  ],
  "RFTN2": [
    "RFTN2 196_233_1_1_S229 phospho",
    "RFTN2 405_409_1_1_T409 phospho",
    "RFTN2 453_455_1_1_S453 phospho",
    "RFTN2 453_460_1_1_S453 phospho",
    "RFTN2 470_477_1_1_S470 phospho",
    "RFTN2 cnv",
    "RFTN2 proteo",
    "RFTN2 rna"
  ],
  "RFWD3": [
    "RFWD3 cnv",
    "RFWD3 methyl",
    "RFWD3 rna"
  ],
  "RFX1": [
    "RFX1 159_175_1_1_S159 phospho",
    "RFX1 cnv",
    "RFX1 methyl",
    "RFX1 proteo",
    "RFX1 rna"
  ],
  "RFX2": [
    "RFX2 cnv",
    "RFX2 methyl",
    "RFX2 proteo",
    "RFX2 rna"
  ],
  "RFX3": [
    "RFX3 cnv",
    "RFX3 methyl",
    "RFX3 proteo",
    "RFX3 rna"
  ],
  "RFX3-DT": [
    "RFX3-DT methyl"
  ],
  "RFX4": [
    "RFX4 39_49_1_1_S49 phospho",
    "RFX4 cnv",
    "RFX4 methyl",
    "RFX4 proteo",
    "RFX4 rna"
  ],
  "RFX5": [
    "RFX5 cnv",
    "RFX5 methyl",
    "RFX5 proteo",
    "RFX5 rna"
  ],
  "RFX6": [
    "RFX6 cnv",
    "RFX6 methyl",
    "RFX6 rna"
  ],
  "RFX7": [
    "RFX7 1166_1168_1_1_S1168 phospho",
    "RFX7 296_299_1_1_S299 phospho",
    "RFX7 322_328_1_1_S322 phospho",
    "RFX7 cnv",
    "RFX7 methyl",
    "RFX7 rna"
  ],
  "RFX8": [
    "RFX8 cnv",
    "RFX8 methyl",
    "RFX8 rna"
  ],
  "RFXANK": [
    "RFXANK cnv",
    "RFXANK methyl",
    "RFXANK proteo",
    "RFXANK rna"
  ],
  "RFXAP": [
    "RFXAP cnv",
    "RFXAP methyl",
    "RFXAP proteo",
    "RFXAP rna"
  ],
  "RGCC": [
    "RGCC 97_111_1_1_S97 phospho",
    "RGCC cnv",
    "RGCC methyl",
    "RGCC proteo",
    "RGCC rna"
  ],
  "RGL1": [
    "RGL1 518_533_1_1_S518 phospho",
    "RGL1 cnv",
    "RGL1 methyl",
    "RGL1 proteo",
    "RGL1 rna"
  ],
  "RGL2": [
    "RGL2 736_761_1_0 phospho",
    "RGL2 cnv",
    "RGL2 methyl",
    "RGL2 proteo",
    "RGL2 rna"
  ],
  "RGL3": [
    "RGL3 cnv",
    "RGL3 methyl",
    "RGL3 rna"
  ],
  "RGL4": [
    "RGL4 cnv",
    "RGL4 rna"
  ],
  "RGMA": [
    "RGMA cnv",
    "RGMA methyl",
    "RGMA proteo",
    "RGMA rna"
  ],
  "RGMB": [
    "RGMB cnv",
    "RGMB methyl",
    "RGMB proteo",
    "RGMB rna"
  ],
  "RGMB-AS1": [
    "RGMB-AS1 methyl"
  ],
  "RGN": [
    "RGN methyl",
    "RGN proteo",
    "RGN rna"
  ],
  "RGP1": [
    "RGP1 cnv",
    "RGP1 methyl",
    "RGP1 proteo",
    "RGP1 rna"
  ],
  "RGPD1": [
    "RGPD1 cnv",
    "RGPD1 methyl",
    "RGPD1 rna"
  ],
  "RGPD2": [
    "RGPD2 cnv",
    "RGPD2 rna"
  ],
  "RGPD3": [
    "RGPD3 cnv",
    "RGPD3 methyl",
    "RGPD3 rna"
  ],
  "RGPD4": [
    "RGPD4 cnv",
    "RGPD4 methyl",
    "RGPD4 rna"
  ],
  "RGPD4-AS1": [
    "RGPD4-AS1 methyl"
  ],
  "RGPD5": [
    "RGPD5 cnv",
    "RGPD5 rna"
  ],
  "RGPD6": [
    "RGPD6 cnv",
    "RGPD6 rna"
  ],
  "RGPD8": [
    "RGPD8 cnv",
    "RGPD8 methyl",
    "RGPD8 rna"
  ],
  "RGR": [
    "RGR cnv",
    "RGR rna"
  ],
  "RGS1": [
    "RGS1 cnv",
    "RGS1 rna"
  ],
  "RGS10": [
    "RGS10 16_31_1_1_S16 phospho",
    "RGS10 cnv",
    "RGS10 methyl",
    "RGS10 proteo",
    "RGS10 rna"
  ],
  "RGS11": [
    "RGS11 cnv",
    "RGS11 methyl",
    "RGS11 rna"
  ],
  "RGS12": [
    "RGS12 104_114_1_1_S107 phospho",
    "RGS12 473_492_1_1_S483 phospho",
    "RGS12 844_853_1_1_S850 phospho",
    "RGS12 876_889_1_1_S879 phospho",
    "RGS12 934_947_1_1_S934 phospho",
    "RGS12 cnv",
    "RGS12 methyl",
    "RGS12 proteo",
    "RGS12 rna"
  ],
  "RGS13": [
    "RGS13 cnv",
    "RGS13 rna"
  ],
  "RGS14": [
    "RGS14 203_207_1_1_S203 phospho",
    "RGS14 288_298_1_1_S288 phospho",
    "RGS14 cnv",
    "RGS14 methyl",
    "RGS14 proteo",
    "RGS14 rna"
  ],
  "RGS16": [
    "RGS16 cnv",
    "RGS16 methyl",
    "RGS16 rna"
  ],
  "RGS17": [
    "RGS17 cnv",
    "RGS17 methyl",
    "RGS17 proteo",
    "RGS17 rna"
  ],
  "RGS18": [
    "RGS18 cnv",
    "RGS18 rna"
  ],
  "RGS19": [
    "RGS19 cnv",
    "RGS19 methyl",
    "RGS19 proteo",
    "RGS19 rna"
  ],
  "RGS2": [
    "RGS2 cnv",
    "RGS2 methyl",
    "RGS2 rna"
  ],
  "RGS20": [
    "RGS20 cnv",
    "RGS20 methyl",
    "RGS20 proteo",
    "RGS20 rna"
  ],
  "RGS21": [
    "RGS21 cnv"
  ],
  "RGS22": [
    "RGS22 cnv",
    "RGS22 methyl",
    "RGS22 rna"
  ],
  "RGS3": [
    "RGS3 237_251_1_0 phospho",
    "RGS3 237_251_1_1_S238 phospho",
    "RGS3 262_267_1_1_S264 phospho",
    "RGS3 328_340_1_1_S328 phospho",
    "RGS3 365_365_1_1_S365 phospho",
    "RGS3 cnv",
    "RGS3 methyl",
    "RGS3 proteo",
    "RGS3 rna"
  ],
  "RGS4": [
    "RGS4 cnv",
    "RGS4 rna"
  ],
  "RGS5": [
    "RGS5 cnv",
    "RGS5 methyl",
    "RGS5 rna"
  ],
  "RGS6": [
    "RGS6 232_250_1_1_S244 phospho",
    "RGS6 cnv",
    "RGS6 methyl",
    "RGS6 proteo",
    "RGS6 rna"
  ],
  "RGS7": [
    "RGS7 176_178_1_1_S176 phospho",
    "RGS7 186_201_1_0 phospho",
    "RGS7 cnv",
    "RGS7 methyl",
    "RGS7 proteo",
    "RGS7 rna"
  ],
  "RGS7BP": [
    "RGS7BP cnv",
    "RGS7BP methyl",
    "RGS7BP rna"
  ],
  "RGS8": [
    "RGS8 cnv",
    "RGS8 rna"
  ],
  "RGS9": [
    "RGS9 cnv",
    "RGS9 rna"
  ],
  "RGS9BP": [
    "RGS9BP cnv",
    "RGS9BP methyl",
    "RGS9BP rna"
  ],
  "RGSL1": [
    "RGSL1 cnv",
    "RGSL1 rna"
  ],
  "RHAG": [
    "RHAG cnv",
    "RHAG rna"
  ],
  "RHBDD1": [
    "RHBDD1 cnv",
    "RHBDD1 methyl",
    "RHBDD1 proteo",
    "RHBDD1 rna"
  ],
  "RHBDD2": [
    "RHBDD2 cnv",
    "RHBDD2 methyl",
    "RHBDD2 proteo",
    "RHBDD2 rna"
  ],
  "RHBDD3": [
    "RHBDD3 cnv",
    "RHBDD3 methyl",
    "RHBDD3 proteo",
    "RHBDD3 rna"
  ],
  "RHBDF1": [
    "RHBDF1 49_61_1_1_S61 phospho",
    "RHBDF1 49_61_2_0 phospho",
    "RHBDF1 85_92_1_1_S92 phospho",
    "RHBDF1 cnv",
    "RHBDF1 methyl",
    "RHBDF1 proteo",
    "RHBDF1 rna"
  ],
  "RHBDF2": [
    "RHBDF2 114_119_1_1_S114 phospho",
    "RHBDF2 114_119_1_1_S119 phospho",
    "RHBDF2 114_119_2_2_S114S119 phospho",
    "RHBDF2 137_148_1_1_S148 phospho",
    "RHBDF2 294_299_1_1_S299 phospho",
    "RHBDF2 294_299_2_2_S296S299 phospho",
    "RHBDF2 SNHTGFLHMDCEIK-N2H5F0S0G0 glyco",
    "RHBDF2 cnv",
    "RHBDF2 methyl",
    "RHBDF2 proteo",
    "RHBDF2 rna"
  ],
  "RHBDL1": [
    "RHBDL1 cnv",
    "RHBDL1 rna"
  ],
  "RHBDL2": [
    "RHBDL2 cnv",
    "RHBDL2 rna"
  ],
  "RHBDL3": [
    "RHBDL3 cnv",
    "RHBDL3 methyl",
    "RHBDL3 rna"
  ],
  "RHBG": [
    "RHBG cnv",
    "RHBG methyl",
    "RHBG rna"
  ],
  "RHCE": [
    "RHCE cnv",
    "RHCE methyl",
    "RHCE rna"
  ],
  "RHCG": [
    "RHCG cnv",
    "RHCG methyl",
    "RHCG rna"
  ],
  "RHD": [
    "RHD cnv",
    "RHD rna"
  ],
  "RHEB": [
    "RHEB cnv",
    "RHEB methyl",
    "RHEB proteo",
    "RHEB rna"
  ],
  "RHEBL1": [
    "RHEBL1 cnv",
    "RHEBL1 methyl",
    "RHEBL1 rna"
  ],
  "RHEX": [
    "RHEX cnv",
    "RHEX rna"
  ],
  "RHNO1": [
    "RHNO1 cnv",
    "RHNO1 methyl",
    "RHNO1 rna"
  ],
  "RHO": [
    "RHO cnv",
    "RHO rna"
  ],
  "RHOA": [
    "RHOA cnv",
    "RHOA methyl",
    "RHOA proteo",
    "RHOA rna"
  ],
  "RHOB": [
    "RHOB 123_123_1_1_S123 phospho",
    "RHOB cnv",
    "RHOB methyl",
    "RHOB proteo",
    "RHOB rna"
  ],
  "RHOBTB1": [
    "RHOBTB1 cnv",
    "RHOBTB1 methyl",
    "RHOBTB1 rna"
  ],
  "RHOBTB2": [
    "RHOBTB2 cnv",
    "RHOBTB2 methyl",
    "RHOBTB2 rna"
  ],
  "RHOBTB3": [
    "RHOBTB3 cnv",
    "RHOBTB3 methyl",
    "RHOBTB3 proteo",
    "RHOBTB3 rna"
  ],
  "RHOC": [
    "RHOC cnv",
    "RHOC methyl",
    "RHOC proteo",
    "RHOC rna"
  ],
  "RHOD": [
    "RHOD cnv",
    "RHOD methyl",
    "RHOD rna"
  ],
  "RHOF": [
    "RHOF cnv",
    "RHOF methyl",
    "RHOF rna"
  ],
  "RHOG": [
    "RHOG cnv",
    "RHOG methyl",
    "RHOG proteo",
    "RHOG rna"
  ],
  "RHOH": [
    "RHOH cnv",
    "RHOH rna"
  ],
  "RHOJ": [
    "RHOJ cnv",
    "RHOJ proteo",
    "RHOJ rna"
  ],
  "RHOQ": [
    "RHOQ cnv",
    "RHOQ methyl",
    "RHOQ proteo",
    "RHOQ rna"
  ],
  "RHOT1": [
    "RHOT1 cnv",
    "RHOT1 methyl",
    "RHOT1 proteo",
    "RHOT1 rna"
  ],
  "RHOT2": [
    "RHOT2 cnv",
    "RHOT2 methyl",
    "RHOT2 proteo",
    "RHOT2 rna"
  ],
  "RHOU": [
    "RHOU cnv",
    "RHOU methyl",
    "RHOU rna"
  ],
  "RHOV": [
    "RHOV cnv",
    "RHOV methyl",
    "RHOV rna"
  ],
  "RHOXF1": [
    "RHOXF1 methyl",
    "RHOXF1 rna"
  ],
  "RHOXF1P1": [
    "RHOXF1P1 methyl"
  ],
  "RHOXF2": [
    "RHOXF2 rna"
  ],
  "RHOXF2B": [
    "RHOXF2B rna"
  ],
  "RHPN1": [
    "RHPN1 cnv",
    "RHPN1 methyl",
    "RHPN1 rna"
  ],
  "RHPN1-AS1": [
    "RHPN1-AS1 methyl"
  ],
  "RHPN2": [
    "RHPN2 592_599_1_1_S599 phospho",
    "RHPN2 652_660_1_1_S654 phospho",
    "RHPN2 cnv",
    "RHPN2 methyl",
    "RHPN2 proteo",
    "RHPN2 rna"
  ],
  "RIBC1": [
    "RIBC1 methyl",
    "RIBC1 rna"
  ],
  "RIBC2": [
    "RIBC2 cnv",
    "RIBC2 methyl",
    "RIBC2 rna"
  ],
  "RIC1": [
    "RIC1 1015_1028_1_1_S1019 phospho",
    "RIC1 cnv",
    "RIC1 methyl",
    "RIC1 proteo",
    "RIC1 rna"
  ],
  "RIC3": [
    "RIC3 cnv",
    "RIC3 methyl",
    "RIC3 rna"
  ],
  "RIC8A": [
    "RIC8A 435_446_1_1_S436 phospho",
    "RIC8A 435_446_1_1_T441 phospho",
    "RIC8A 435_446_2_2_S436T441 phospho",
    "RIC8A 502_502_1_1_S502 phospho",
    "RIC8A cnv",
    "RIC8A methyl",
    "RIC8A proteo",
    "RIC8A rna"
  ],
  "RIC8B": [
    "RIC8B cnv",
    "RIC8B methyl",
    "RIC8B proteo",
    "RIC8B rna"
  ],
  "RICTOR": [
    "RICTOR 1217_1237_1_1_S1219 phospho",
    "RICTOR 1409_1426_1_1_S1412 phospho",
    "RICTOR cnv",
    "RICTOR methyl",
    "RICTOR proteo",
    "RICTOR rna"
  ],
  "RIDA": [
    "RIDA cnv",
    "RIDA methyl",
    "RIDA proteo",
    "RIDA rna"
  ],
  "RIF1": [
    "RIF1 1422_1431_1_1_S1422 phospho",
    "RIF1 1542_1557_1_1_S1542 phospho",
    "RIF1 1576_1579_1_1_S1579 phospho",
    "RIF1 1688_1698_1_1_S1688 phospho",
    "RIF1 cnv",
    "RIF1 methyl",
    "RIF1 proteo",
    "RIF1 rna"
  ],
  "RIIAD1": [
    "RIIAD1 cnv",
    "RIIAD1 methyl",
    "RIIAD1 rna"
  ],
  "RILP": [
    "RILP cnv",
    "RILP methyl",
    "RILP proteo",
    "RILP rna"
  ],
  "RILPL1": [
    "RILPL1 259_277_1_1_S259 phospho",
    "RILPL1 345_351_1_1_S346 phospho",
    "RILPL1 cnv",
    "RILPL1 methyl",
    "RILPL1 proteo",
    "RILPL1 rna"
  ],
  "RILPL2": [
    "RILPL2 cnv",
    "RILPL2 methyl",
    "RILPL2 rna"
  ],
  "RIMBP2": [
    "RIMBP2 713_729_1_1_S721 phospho",
    "RIMBP2 849_858_1_1_S849 phospho",
    "RIMBP2 cnv",
    "RIMBP2 proteo",
    "RIMBP2 rna"
  ],
  "RIMBP3": [
    "RIMBP3 cnv",
    "RIMBP3 rna"
  ],
  "RIMBP3B": [
    "RIMBP3B cnv",
    "RIMBP3B rna"
  ],
  "RIMBP3C": [
    "RIMBP3C cnv",
    "RIMBP3C rna"
  ],
  "RIMKLA": [
    "RIMKLA cnv",
    "RIMKLA methyl",
    "RIMKLA rna"
  ],
  "RIMKLB": [
    "RIMKLB cnv",
    "RIMKLB methyl",
    "RIMKLB rna"
  ],
  "RIMOC1": [
    "RIMOC1 cnv",
    "RIMOC1 methyl",
    "RIMOC1 proteo",
    "RIMOC1 rna"
  ],
  "RIMS1": [
    "RIMS1 1677_1685_1_1_S1677 phospho",
    "RIMS1 1677_1685_2_2_S1677S1680 phospho",
    "RIMS1 216_236_1_0 phospho",
    "RIMS1 324_330_1_1_S324 phospho",
    "RIMS1 391_391_1_1_S391 phospho",
    "RIMS1 420_424_1_1_S420 phospho",
    "RIMS1 420_424_2_2_S420S424 phospho",
    "RIMS1 445_448_1_1_S448 phospho",
    "RIMS1 504_512_1_1_S504 phospho",
    "RIMS1 577_590_1_1_S578 phospho",
    "RIMS1 626_633_1_1_S628 phospho",
    "RIMS1 723_731_1_1_S728 phospho",
    "RIMS1 869_881_1_1_S881 phospho",
    "RIMS1 977_984_1_1_S977 phospho",
    "RIMS1 cnv",
    "RIMS1 methyl",
    "RIMS1 proteo",
    "RIMS1 rna"
  ],
  "RIMS2": [
    "RIMS2 1086_1096_1_1_S1092 phospho",
    "RIMS2 1304_1311_1_1_S1304 phospho",
    "RIMS2 1534_1547_1_1_S1534 phospho",
    "RIMS2 369_381_1_1_S369 phospho",
    "RIMS2 428_435_1_1_S432 phospho",
    "RIMS2 cnv",
    "RIMS2 methyl",
    "RIMS2 proteo",
    "RIMS2 rna"
  ],
  "RIMS3": [
    "RIMS3 104_126_1_1_S104 phospho",
    "RIMS3 20_41_1_0 phospho",
    "RIMS3 20_41_1_1_S22 phospho",
    "RIMS3 295_308_1_1_S295 phospho",
    "RIMS3 295_308_2_2_S295S298 phospho",
    "RIMS3 cnv",
    "RIMS3 methyl",
    "RIMS3 proteo",
    "RIMS3 rna"
  ],
  "RIMS4": [
    "RIMS4 cnv",
    "RIMS4 methyl",
    "RIMS4 rna"
  ],
  "RIN1": [
    "RIN1 333_337_1_1_S337 phospho",
    "RIN1 349_356_1_1_S351 phospho",
    "RIN1 36_42_1_1_Y36 phospho",
    "RIN1 cnv",
    "RIN1 proteo",
    "RIN1 rna"
  ],
  "RIN2": [
    "RIN2 533_535_1_1_S535 phospho",
    "RIN2 cnv",
    "RIN2 methyl",
    "RIN2 proteo",
    "RIN2 rna"
  ],
  "RIN3": [
    "RIN3 503_524_1_1_S524 phospho",
    "RIN3 cnv",
    "RIN3 methyl",
    "RIN3 proteo",
    "RIN3 rna"
  ],
  "RING1": [
    "RING1 138_140_1_1_S140 phospho",
    "RING1 24_38_1_1_S38 phospho",
    "RING1 cnv",
    "RING1 methyl",
    "RING1 proteo",
    "RING1 rna"
  ],
  "RINL": [
    "RINL cnv",
    "RINL methyl",
    "RINL rna"
  ],
  "RINT1": [
    "RINT1 cnv",
    "RINT1 methyl",
    "RINT1 proteo",
    "RINT1 rna"
  ],
  "RIOK1": [
    "RIOK1 21_24_1_0 phospho",
    "RIOK1 21_24_1_1_S22 phospho",
    "RIOK1 cnv",
    "RIOK1 kinase",
    "RIOK1 methyl",
    "RIOK1 proteo",
    "RIOK1 rna"
  ],
  "RIOK2": [
    "RIOK2 cnv",
    "RIOK2 kinase",
    "RIOK2 methyl",
    "RIOK2 rna"
  ],
  "RIOK3": [
    "RIOK3 cnv",
    "RIOK3 kinase",
    "RIOK3 methyl",
    "RIOK3 proteo",
    "RIOK3 rna"
  ],
  "RIOX1": [
    "RIOX1 cnv",
    "RIOX1 methyl",
    "RIOX1 proteo",
    "RIOX1 rna"
  ],
  "RIOX2": [
    "RIOX2 cnv",
    "RIOX2 methyl",
    "RIOX2 proteo",
    "RIOX2 rna"
  ],
  "RIPK1": [
    "RIPK1 170_213_1_0 phospho",
    "RIPK1 221_226_1_1_S226 phospho",
    "RIPK1 cnv",
    "RIPK1 kinase",
    "RIPK1 methyl",
    "RIPK1 proteo",
    "RIPK1 rna"
  ],
  "RIPK2": [
    "RIPK2 332_361_1_1_S357 phospho",
    "RIPK2 363_374_1_1_S363 phospho",
    "RIPK2 cnv",
    "RIPK2 kinase",
    "RIPK2 methyl",
    "RIPK2 proteo",
    "RIPK2 rna"
  ],
  "RIPK2-DT": [
    "RIPK2-DT methyl"
  ],
  "RIPK3": [
    "RIPK3 316_325_1_1_S316 phospho",
    "RIPK3 cnv",
    "RIPK3 kinase",
    "RIPK3 rna"
  ],
  "RIPK4": [
    "RIPK4 cnv",
    "RIPK4 kinase",
    "RIPK4 methyl",
    "RIPK4 rna"
  ],
  "RIPOR1": [
    "RIPOR1 20_29_1_1_S22 phospho",
    "RIPOR1 346_357_1_1_S351 phospho",
    "RIPOR1 698_719_1_1_S711 phospho",
    "RIPOR1 cnv",
    "RIPOR1 methyl",
    "RIPOR1 proteo",
    "RIPOR1 rna"
  ],
  "RIPOR2": [
    "RIPOR2 551_559_1_1_S552 phospho",
    "RIPOR2 66_72_1_1_S66 phospho",
    "RIPOR2 cnv",
    "RIPOR2 methyl",
    "RIPOR2 proteo",
    "RIPOR2 rna"
  ],
  "RIPOR3": [
    "RIPOR3 cnv",
    "RIPOR3 rna"
  ],
  "RIPPLY1": [
    "RIPPLY1 rna"
  ],
  "RIPPLY2": [
    "RIPPLY2 cnv",
    "RIPPLY2 methyl",
    "RIPPLY2 rna"
  ],
  "RIPPLY3": [
    "RIPPLY3 cnv",
    "RIPPLY3 methyl",
    "RIPPLY3 rna"
  ],
  "RIT1": [
    "RIT1 cnv",
    "RIT1 proteo",
    "RIT1 rna"
  ],
  "RIT2": [
    "RIT2 cnv",
    "RIT2 proteo",
    "RIT2 rna"
  ],
  "RITA1": [
    "RITA1 cnv",
    "RITA1 methyl",
    "RITA1 rna"
  ],
  "RLBP1": [
    "RLBP1 cnv",
    "RLBP1 proteo",
    "RLBP1 rna"
  ],
  "RLF": [
    "RLF 632_642_1_1_S632 phospho",
    "RLF cnv",
    "RLF methyl",
    "RLF rna"
  ],
  "RLIM": [
    "RLIM methyl",
    "RLIM proteo",
    "RLIM rna"
  ],
  "RLN1": [
    "RLN1 cnv",
    "RLN1 methyl",
    "RLN1 rna"
  ],
  "RLN2": [
    "RLN2 cnv",
    "RLN2 rna"
  ],
  "RLN3": [
    "RLN3 cnv",
    "RLN3 rna"
  ],
  "RMC1": [
    "RMC1 cnv",
    "RMC1 methyl",
    "RMC1 proteo",
    "RMC1 rna"
  ],
  "RMDN1": [
    "RMDN1 cnv",
    "RMDN1 methyl",
    "RMDN1 proteo",
    "RMDN1 rna"
  ],
  "RMDN2": [
    "RMDN2 116_121_1_1_S121 phospho",
    "RMDN2 cnv",
    "RMDN2 methyl",
    "RMDN2 proteo",
    "RMDN2 rna"
  ],
  "RMDN3": [
    "RMDN3 44_57_1_1_S46 phospho",
    "RMDN3 cnv",
    "RMDN3 methyl",
    "RMDN3 proteo",
    "RMDN3 rna"
  ],
  "RMI1": [
    "RMI1 cnv",
    "RMI1 methyl",
    "RMI1 proteo",
    "RMI1 rna"
  ],
  "RMI2": [
    "RMI2 cnv",
    "RMI2 methyl",
    "RMI2 rna"
  ],
  "RMND1": [
    "RMND1 cnv",
    "RMND1 methyl",
    "RMND1 proteo",
    "RMND1 rna"
  ],
  "RMND5A": [
    "RMND5A cnv",
    "RMND5A methyl",
    "RMND5A proteo",
    "RMND5A rna"
  ],
  "RMND5B": [
    "RMND5B cnv",
    "RMND5B methyl",
    "RMND5B rna"
  ],
  "RMRP": [
    "RMRP methyl"
  ],
  "RN7SK": [
    "RN7SK methyl"
  ],
  "RN7SL1": [
    "RN7SL1 methyl"
  ],
  "RN7SL2": [
    "RN7SL2 methyl"
  ],
  "RNA5S13": [
    "RNA5S13 methyl"
  ],
  "RNA5S14": [
    "RNA5S14 methyl"
  ],
  "RNA5S15": [
    "RNA5S15 methyl"
  ],
  "RNA5S17": [
    "RNA5S17 methyl"
  ],
  "RNASE1": [
    "RNASE1 cnv",
    "RNASE1 proteo",
    "RNASE1 rna"
  ],
  "RNASE10": [
    "RNASE10 cnv",
    "RNASE10 rna"
  ],
  "RNASE11": [
    "RNASE11 cnv",
    "RNASE11 methyl"
  ],
  "RNASE12": [
    "RNASE12 cnv",
    "RNASE12 methyl"
  ],
  "RNASE13": [
    "RNASE13 cnv",
    "RNASE13 rna"
  ],
  "RNASE2": [
    "RNASE2 cnv",
    "RNASE2 proteo",
    "RNASE2 rna"
  ],
  "RNASE3": [
    "RNASE3 cnv",
    "RNASE3 proteo",
    "RNASE3 rna"
  ],
  "RNASE4": [
    "RNASE4 cnv",
    "RNASE4 methyl",
    "RNASE4 proteo",
    "RNASE4 rna"
  ],
  "RNASE6": [
    "RNASE6 cnv",
    "RNASE6 proteo",
    "RNASE6 rna"
  ],
  "RNASE7": [
    "RNASE7 cnv",
    "RNASE7 rna"
  ],
  "RNASE8": [
    "RNASE8 cnv"
  ],
  "RNASE9": [
    "RNASE9 cnv"
  ],
  "RNASEH1": [
    "RNASEH1 48_65_1_1_S50 phospho",
    "RNASEH1 48_65_2_2_S48S50 phospho",
    "RNASEH1 cnv",
    "RNASEH1 methyl",
    "RNASEH1 proteo",
    "RNASEH1 rna"
  ],
  "RNASEH1-DT": [
    "RNASEH1-DT methyl"
  ],
  "RNASEH2A": [
    "RNASEH2A cnv",
    "RNASEH2A methyl",
    "RNASEH2A proteo",
    "RNASEH2A rna"
  ],
  "RNASEH2B": [
    "RNASEH2B cnv",
    "RNASEH2B methyl",
    "RNASEH2B proteo",
    "RNASEH2B rna"
  ],
  "RNASEH2C": [
    "RNASEH2C cnv",
    "RNASEH2C methyl",
    "RNASEH2C proteo",
    "RNASEH2C rna"
  ],
  "RNASEK": [
    "RNASEK cnv",
    "RNASEK methyl",
    "RNASEK rna"
  ],
  "RNASEK-C17orf49": [
    "RNASEK-C17orf49 cnv",
    "RNASEK-C17orf49 rna"
  ],
  "RNASEL": [
    "RNASEL cnv",
    "RNASEL kinase",
    "RNASEL proteo",
    "RNASEL rna"
  ],
  "RNASET2": [
    "RNASET2 AYWPDVIHSFPNR-N2H4F0S0G0 glyco",
    "RNASET2 AYWPDVIHSFPNR-N2H6F0S0G0 glyco",
    "RNASET2 cnv",
    "RNASET2 methyl",
    "RNASET2 proteo",
    "RNASET2 rna"
  ],
  "RND1": [
    "RND1 cnv",
    "RND1 rna"
  ],
  "RND2": [
    "RND2 cnv",
    "RND2 methyl",
    "RND2 proteo",
    "RND2 rna"
  ],
  "RND3": [
    "RND3 cnv",
    "RND3 methyl",
    "RND3 proteo",
    "RND3 rna"
  ],
  "RNF10": [
    "RNF10 cnv",
    "RNF10 methyl",
    "RNF10 rna"
  ],
  "RNF103": [
    "RNF103 cnv",
    "RNF103 methyl",
    "RNF103 rna"
  ],
  "RNF103-CHMP3": [
    "RNF103-CHMP3 cnv",
    "RNF103-CHMP3 methyl",
    "RNF103-CHMP3 rna"
  ],
  "RNF11": [
    "RNF11 cnv",
    "RNF11 methyl",
    "RNF11 proteo",
    "RNF11 rna"
  ],
  "RNF111": [
    "RNF111 cnv",
    "RNF111 methyl",
    "RNF111 rna"
  ],
  "RNF112": [
    "RNF112 cnv",
    "RNF112 rna"
  ],
  "RNF113A": [
    "RNF113A 241_253_1_1_S253 phospho",
    "RNF113A 80_100_2_2_S84S85 phospho",
    "RNF113A methyl",
    "RNF113A proteo",
    "RNF113A rna"
  ],
  "RNF113B": [
    "RNF113B cnv",
    "RNF113B rna"
  ],
  "RNF114": [
    "RNF114 cnv",
    "RNF114 methyl",
    "RNF114 proteo",
    "RNF114 rna"
  ],
  "RNF115": [
    "RNF115 cnv",
    "RNF115 methyl",
    "RNF115 rna"
  ],
  "RNF121": [
    "RNF121 cnv",
    "RNF121 rna"
  ],
  "RNF122": [
    "RNF122 cnv",
    "RNF122 methyl",
    "RNF122 rna"
  ],
  "RNF123": [
    "RNF123 cnv",
    "RNF123 methyl",
    "RNF123 proteo",
    "RNF123 rna"
  ],
  "RNF125": [
    "RNF125 cnv",
    "RNF125 methyl",
    "RNF125 rna"
  ],
  "RNF126": [
    "RNF126 11_17_1_1_S17 phospho",
    "RNF126 cnv",
    "RNF126 methyl",
    "RNF126 proteo",
    "RNF126 rna"
  ],
  "RNF126P1": [
    "RNF126P1 methyl"
  ],
  "RNF128": [
    "RNF128 methyl",
    "RNF128 rna"
  ],
  "RNF13": [
    "RNF13 cnv",
    "RNF13 methyl",
    "RNF13 proteo",
    "RNF13 rna"
  ],
  "RNF130": [
    "RNF130 cnv",
    "RNF130 methyl",
    "RNF130 proteo",
    "RNF130 rna"
  ],
  "RNF133": [
    "RNF133 cnv",
    "RNF133 rna"
  ],
  "RNF135": [
    "RNF135 cnv",
    "RNF135 methyl",
    "RNF135 proteo",
    "RNF135 rna"
  ],
  "RNF138": [
    "RNF138 cnv",
    "RNF138 methyl",
    "RNF138 proteo",
    "RNF138 rna"
  ],
  "RNF139": [
    "RNF139 625_635_1_1_S634 phospho",
    "RNF139 652_663_1_1_T663 phospho",
    "RNF139 cnv",
    "RNF139 methyl",
    "RNF139 rna"
  ],
  "RNF139-DT": [
    "RNF139-DT methyl"
  ],
  "RNF14": [
    "RNF14 451_451_1_1_S451 phospho",
    "RNF14 cnv",
    "RNF14 methyl",
    "RNF14 proteo",
    "RNF14 rna"
  ],
  "RNF141": [
    "RNF141 cnv",
    "RNF141 methyl",
    "RNF141 proteo",
    "RNF141 rna"
  ],
  "RNF144A": [
    "RNF144A cnv",
    "RNF144A methyl",
    "RNF144A rna"
  ],
  "RNF144B": [
    "RNF144B cnv",
    "RNF144B methyl",
    "RNF144B rna"
  ],
  "RNF145": [
    "RNF145 cnv",
    "RNF145 methyl",
    "RNF145 rna"
  ],
  "RNF146": [
    "RNF146 cnv",
    "RNF146 methyl",
    "RNF146 proteo",
    "RNF146 rna"
  ],
  "RNF148": [
    "RNF148 cnv",
    "RNF148 rna"
  ],
  "RNF149": [
    "RNF149 cnv",
    "RNF149 methyl",
    "RNF149 rna"
  ],
  "RNF150": [
    "RNF150 cnv",
    "RNF150 methyl",
    "RNF150 proteo",
    "RNF150 rna"
  ],
  "RNF151": [
    "RNF151 cnv",
    "RNF151 rna"
  ],
  "RNF152": [
    "RNF152 cnv",
    "RNF152 methyl",
    "RNF152 rna"
  ],
  "RNF157": [
    "RNF157 cnv",
    "RNF157 methyl",
    "RNF157 rna"
  ],
  "RNF165": [
    "RNF165 cnv",
    "RNF165 methyl",
    "RNF165 rna"
  ],
  "RNF166": [
    "RNF166 cnv",
    "RNF166 methyl",
    "RNF166 proteo",
    "RNF166 rna"
  ],
  "RNF167": [
    "RNF167 cnv",
    "RNF167 methyl",
    "RNF167 proteo",
    "RNF167 rna"
  ],
  "RNF168": [
    "RNF168 cnv",
    "RNF168 methyl",
    "RNF168 rna"
  ],
  "RNF169": [
    "RNF169 247_255_1_1_S247 phospho",
    "RNF169 339_344_1_1_S339 phospho",
    "RNF169 366_391_1_1_S368 phospho",
    "RNF169 cnv",
    "RNF169 proteo",
    "RNF169 rna"
  ],
  "RNF17": [
    "RNF17 cnv",
    "RNF17 methyl",
    "RNF17 rna"
  ],
  "RNF170": [
    "RNF170 cnv",
    "RNF170 methyl",
    "RNF170 proteo",
    "RNF170 rna"
  ],
  "RNF175": [
    "RNF175 cnv",
    "RNF175 methyl",
    "RNF175 rna"
  ],
  "RNF180": [
    "RNF180 228_236_1_1_S230 phospho",
    "RNF180 cnv",
    "RNF180 methyl",
    "RNF180 rna"
  ],
  "RNF181": [
    "RNF181 cnv",
    "RNF181 methyl",
    "RNF181 proteo",
    "RNF181 rna"
  ],
  "RNF182": [
    "RNF182 cnv",
    "RNF182 methyl",
    "RNF182 rna"
  ],
  "RNF183": [
    "RNF183 cnv",
    "RNF183 rna"
  ],
  "RNF185": [
    "RNF185 cnv",
    "RNF185 methyl",
    "RNF185 proteo",
    "RNF185 rna"
  ],
  "RNF186": [
    "RNF186 cnv"
  ],
  "RNF187": [
    "RNF187 cnv",
    "RNF187 methyl",
    "RNF187 rna"
  ],
  "RNF19A": [
    "RNF19A cnv",
    "RNF19A methyl",
    "RNF19A rna"
  ],
  "RNF19B": [
    "RNF19B cnv",
    "RNF19B methyl",
    "RNF19B rna"
  ],
  "RNF2": [
    "RNF2 141_143_1_1_S143 phospho",
    "RNF2 cnv",
    "RNF2 methyl",
    "RNF2 proteo",
    "RNF2 rna"
  ],
  "RNF20": [
    "RNF20 515_526_1_1_S525 phospho",
    "RNF20 515_550_1_0 phospho",
    "RNF20 515_550_1_1_S525 phospho",
    "RNF20 cnv",
    "RNF20 methyl",
    "RNF20 proteo",
    "RNF20 rna"
  ],
  "RNF207": [
    "RNF207 cnv",
    "RNF207 methyl",
    "RNF207 rna"
  ],
  "RNF207-AS1": [
    "RNF207-AS1 methyl"
  ],
  "RNF208": [
    "RNF208 cnv",
    "RNF208 methyl",
    "RNF208 rna"
  ],
  "RNF212": [
    "RNF212 cnv",
    "RNF212 methyl",
    "RNF212 rna"
  ],
  "RNF212B": [
    "RNF212B cnv",
    "RNF212B rna"
  ],
  "RNF213": [
    "RNF213 217_232_1_1_S217 phospho",
    "RNF213 cnv",
    "RNF213 methyl",
    "RNF213 proteo",
    "RNF213 rna"
  ],
  "RNF213-AS1": [
    "RNF213-AS1 methyl"
  ],
  "RNF214": [
    "RNF214 47_58_1_1_S47 phospho",
    "RNF214 47_58_1_1_S54 phospho",
    "RNF214 511_530_1_1_S511 phospho",
    "RNF214 cnv",
    "RNF214 methyl",
    "RNF214 proteo",
    "RNF214 rna"
  ],
  "RNF215": [
    "RNF215 cnv",
    "RNF215 methyl",
    "RNF215 rna"
  ],
  "RNF216": [
    "RNF216 cnv",
    "RNF216 methyl",
    "RNF216 proteo",
    "RNF216 rna"
  ],
  "RNF216P1": [
    "RNF216P1 methyl"
  ],
  "RNF217": [
    "RNF217 cnv",
    "RNF217 methyl",
    "RNF217 rna"
  ],
  "RNF220": [
    "RNF220 cnv",
    "RNF220 methyl",
    "RNF220 proteo",
    "RNF220 rna"
  ],
  "RNF222": [
    "RNF222 cnv",
    "RNF222 rna"
  ],
  "RNF223": [
    "RNF223 cnv",
    "RNF223 rna"
  ],
  "RNF224": [
    "RNF224 cnv",
    "RNF224 rna"
  ],
  "RNF225": [
    "RNF225 cnv",
    "RNF225 methyl",
    "RNF225 rna"
  ],
  "RNF227": [
    "RNF227 cnv",
    "RNF227 methyl",
    "RNF227 rna"
  ],
  "RNF24": [
    "RNF24 cnv",
    "RNF24 methyl",
    "RNF24 rna"
  ],
  "RNF25": [
    "RNF25 450_459_1_1_S450 phospho",
    "RNF25 cnv",
    "RNF25 methyl",
    "RNF25 proteo",
    "RNF25 rna"
  ],
  "RNF26": [
    "RNF26 cnv",
    "RNF26 methyl",
    "RNF26 rna"
  ],
  "RNF31": [
    "RNF31 284_300_1_1_S286 phospho",
    "RNF31 315_321_1_1_S315 phospho",
    "RNF31 cnv",
    "RNF31 methyl",
    "RNF31 proteo",
    "RNF31 rna"
  ],
  "RNF32": [
    "RNF32 cnv",
    "RNF32 methyl",
    "RNF32 rna"
  ],
  "RNF32-DT": [
    "RNF32-DT methyl"
  ],
  "RNF34": [
    "RNF34 254_268_1_1_S254 phospho",
    "RNF34 cnv",
    "RNF34 methyl",
    "RNF34 proteo",
    "RNF34 rna"
  ],
  "RNF38": [
    "RNF38 cnv",
    "RNF38 methyl",
    "RNF38 rna"
  ],
  "RNF39": [
    "RNF39 cnv",
    "RNF39 methyl",
    "RNF39 rna"
  ],
  "RNF4": [
    "RNF4 90_101_2_2_S94S95 phospho",
    "RNF4 cnv",
    "RNF4 methyl",
    "RNF4 rna"
  ],
  "RNF40": [
    "RNF40 cnv",
    "RNF40 methyl",
    "RNF40 proteo",
    "RNF40 rna"
  ],
  "RNF41": [
    "RNF41 cnv",
    "RNF41 methyl",
    "RNF41 proteo",
    "RNF41 rna"
  ],
  "RNF43": [
    "RNF43 cnv",
    "RNF43 rna"
  ],
  "RNF44": [
    "RNF44 cnv",
    "RNF44 methyl",
    "RNF44 rna"
  ],
  "RNF5": [
    "RNF5 cnv",
    "RNF5 proteo",
    "RNF5 rna"
  ],
  "RNF6": [
    "RNF6 cnv",
    "RNF6 methyl",
    "RNF6 rna"
  ],
  "RNF7": [
    "RNF7 cnv",
    "RNF7 methyl",
    "RNF7 proteo",
    "RNF7 rna"
  ],
  "RNF8": [
    "RNF8 cnv",
    "RNF8 methyl",
    "RNF8 rna"
  ],
  "RNFT1": [
    "RNFT1 cnv",
    "RNFT1 methyl",
    "RNFT1 rna"
  ],
  "RNFT1-DT": [
    "RNFT1-DT methyl"
  ],
  "RNFT2": [
    "RNFT2 cnv",
    "RNFT2 methyl",
    "RNFT2 rna"
  ],
  "RNGTT": [
    "RNGTT cnv",
    "RNGTT methyl",
    "RNGTT proteo",
    "RNGTT rna"
  ],
  "RNH1": [
    "RNH1 cnv",
    "RNH1 methyl",
    "RNH1 proteo",
    "RNH1 rna"
  ],
  "RNLS": [
    "RNLS cnv",
    "RNLS methyl",
    "RNLS proteo",
    "RNLS rna"
  ],
  "RNMT": [
    "RNMT cnv",
    "RNMT methyl",
    "RNMT proteo",
    "RNMT rna"
  ],
  "RNPC3": [
    "RNPC3 108_115_1_1_S108 phospho",
    "RNPC3 cnv",
    "RNPC3 methyl",
    "RNPC3 proteo",
    "RNPC3 rna"
  ],
  "RNPC3-DT": [
    "RNPC3-DT methyl"
  ],
  "RNPEP": [
    "RNPEP cnv",
    "RNPEP methyl",
    "RNPEP proteo",
    "RNPEP rna"
  ],
  "RNPEPL1": [
    "RNPEPL1 cnv",
    "RNPEPL1 methyl",
    "RNPEPL1 rna"
  ],
  "RNPS1": [
    "RNPS1 155_161_1_1_S157 phospho",
    "RNPS1 155_161_2_2_S155S157 phospho",
    "RNPS1 251_251_1_1_S251 phospho",
    "RNPS1 cnv",
    "RNPS1 methyl",
    "RNPS1 proteo",
    "RNPS1 rna"
  ],
  "RNU1-1": [
    "RNU1-1 methyl"
  ],
  "RNU1-2": [
    "RNU1-2 methyl"
  ],
  "RNU12": [
    "RNU12 methyl"
  ],
  "RNU4ATAC": [
    "RNU4ATAC methyl"
  ],
  "RNU6-1": [
    "RNU6-1 methyl"
  ],
  "RNU6-2": [
    "RNU6-2 methyl"
  ],
  "RNU6-7": [
    "RNU6-7 methyl"
  ],
  "RNU6-8": [
    "RNU6-8 methyl"
  ],
  "RNU6-9": [
    "RNU6-9 methyl"
  ],
  "RNU6ATAC": [
    "RNU6ATAC methyl"
  ],
  "RNVU1-18": [
    "RNVU1-18 methyl"
  ],
  "RNVU1-19": [
    "RNVU1-19 methyl"
  ],
  "RNVU1-6": [
    "RNVU1-6 methyl"
  ],
  "RNVU1-8": [
    "RNVU1-8 methyl"
  ],
  "RNY3": [
    "RNY3 methyl"
  ],
  "RO60": [
    "RO60 19_28_1_1_S19 phospho",
    "RO60 cnv",
    "RO60 methyl",
    "RO60 proteo",
    "RO60 rna"
  ],
  "ROBO1": [
    "ROBO1 1224_1240_1_1_T1240 phospho",
    "ROBO1 1435_1451_1_0 phospho",
    "ROBO1 1435_1451_1_1_S1442 phospho",
    "ROBO1 1435_1451_1_1_T1441 phospho",
    "ROBO1 940_949_1_1_S940 phospho",
    "ROBO1 cnv",
    "ROBO1 methyl",
    "ROBO1 proteo",
    "ROBO1 rna"
  ],
  "ROBO2": [
    "ROBO2 1256_1269_1_1_S1260 phospho",
    "ROBO2 cnv",
    "ROBO2 methyl",
    "ROBO2 proteo",
    "ROBO2 rna"
  ],
  "ROBO3": [
    "ROBO3 cnv",
    "ROBO3 methyl",
    "ROBO3 rna"
  ],
  "ROBO4": [
    "ROBO4 cnv",
    "ROBO4 rna"
  ],
  "ROCK1": [
    "ROCK1 1098_1119_1_1_S1105 phospho",
    "ROCK1 cnv",
    "ROCK1 kinase",
    "ROCK1 methyl",
    "ROCK1 proteo",
    "ROCK1 rna"
  ],
  "ROCK2": [
    "ROCK2 337_341_1_1_S339 phospho",
    "ROCK2 cnv",
    "ROCK2 kinase",
    "ROCK2 methyl",
    "ROCK2 proteo",
    "ROCK2 rna"
  ],
  "ROGDI": [
    "ROGDI cnv",
    "ROGDI methyl",
    "ROGDI proteo",
    "ROGDI rna"
  ],
  "ROM1": [
    "ROM1 cnv",
    "ROM1 methyl",
    "ROM1 rna"
  ],
  "ROMO1": [
    "ROMO1 cnv",
    "ROMO1 methyl",
    "ROMO1 proteo",
    "ROMO1 rna"
  ],
  "ROPN1": [
    "ROPN1 cnv",
    "ROPN1 rna"
  ],
  "ROPN1B": [
    "ROPN1B cnv",
    "ROPN1B rna"
  ],
  "ROPN1L": [
    "ROPN1L cnv",
    "ROPN1L methyl",
    "ROPN1L rna"
  ],
  "ROR1": [
    "ROR1 cnv",
    "ROR1 kinase",
    "ROR1 methyl",
    "ROR1 rna"
  ],
  "ROR2": [
    "ROR2 cnv",
    "ROR2 kinase",
    "ROR2 methyl",
    "ROR2 rna"
  ],
  "RORA": [
    "RORA cnv",
    "RORA methyl",
    "RORA rna"
  ],
  "RORA-AS1": [
    "RORA-AS1 methyl"
  ],
  "RORB": [
    "RORB cnv",
    "RORB methyl",
    "RORB rna"
  ],
  "RORC": [
    "RORC cnv",
    "RORC rna"
  ],
  "ROS1": [
    "ROS1 cnv",
    "ROS1 kinase",
    "ROS1 rna"
  ],
  "RP1": [
    "RP1 cnv",
    "RP1 rna"
  ],
  "RP1L1": [
    "RP1L1 cnv",
    "RP1L1 rna"
  ],
  "RP2": [
    "RP2 methyl",
    "RP2 proteo",
    "RP2 rna"
  ],
  "RP9": [
    "RP9 cnv",
    "RP9 methyl",
    "RP9 proteo",
    "RP9 rna"
  ],
  "RP9P": [
    "RP9P methyl"
  ],
  "RPA1": [
    "RPA1 cnv",
    "RPA1 methyl",
    "RPA1 proteo",
    "RPA1 rna"
  ],
  "RPA2": [
    "RPA2 246_249_1_1_S246 phospho",
    "RPA2 cnv",
    "RPA2 methyl",
    "RPA2 proteo",
    "RPA2 rna"
  ],
  "RPA3": [
    "RPA3 cnv",
    "RPA3 methyl",
    "RPA3 proteo",
    "RPA3 rna"
  ],
  "RPA4": [
    "RPA4 rna"
  ],
  "RPAIN": [
    "RPAIN cnv",
    "RPAIN methyl",
    "RPAIN rna"
  ],
  "RPAP1": [
    "RPAP1 264_290_1_1_S266 phospho",
    "RPAP1 80_80_1_1_S80 phospho",
    "RPAP1 cnv",
    "RPAP1 methyl",
    "RPAP1 proteo",
    "RPAP1 rna"
  ],
  "RPAP2": [
    "RPAP2 cnv",
    "RPAP2 methyl",
    "RPAP2 proteo",
    "RPAP2 rna"
  ],
  "RPAP3": [
    "RPAP3 446_457_1_1_S447 phospho",
    "RPAP3 cnv",
    "RPAP3 methyl",
    "RPAP3 proteo",
    "RPAP3 rna"
  ],
  "RPE": [
    "RPE cnv",
    "RPE methyl",
    "RPE proteo",
    "RPE rna"
  ],
  "RPE65": [
    "RPE65 cnv",
    "RPE65 rna"
  ],
  "RPEL1": [
    "RPEL1 cnv",
    "RPEL1 rna"
  ],
  "RPF1": [
    "RPF1 cnv",
    "RPF1 rna"
  ],
  "RPF2": [
    "RPF2 cnv",
    "RPF2 methyl",
    "RPF2 proteo",
    "RPF2 rna"
  ],
  "RPGR": [
    "RPGR 418_423_1_1_S418 phospho",
    "RPGR methyl",
    "RPGR proteo",
    "RPGR rna"
  ],
  "RPGRIP1": [
    "RPGRIP1 cnv",
    "RPGRIP1 methyl",
    "RPGRIP1 rna"
  ],
  "RPGRIP1L": [
    "RPGRIP1L cnv",
    "RPGRIP1L methyl",
    "RPGRIP1L rna"
  ],
  "RPH3A": [
    "RPH3A 206_206_1_1_S206 phospho",
    "RPH3A 248_263_1_1_S263 phospho",
    "RPH3A 272_300_1_1_S272 phospho",
    "RPH3A 424_431_1_1_S424 phospho",
    "RPH3A 692_693_1_1_S693 phospho",
    "RPH3A cnv",
    "RPH3A methyl",
    "RPH3A proteo",
    "RPH3A rna"
  ],
  "RPH3AL": [
    "RPH3AL cnv",
    "RPH3AL methyl",
    "RPH3AL rna"
  ],
  "RPIA": [
    "RPIA cnv",
    "RPIA methyl",
    "RPIA proteo",
    "RPIA rna"
  ],
  "RPL10": [
    "RPL10 methyl",
    "RPL10 proteo",
    "RPL10 rna"
  ],
  "RPL10A": [
    "RPL10A cnv",
    "RPL10A methyl",
    "RPL10A proteo",
    "RPL10A rna"
  ],
  "RPL10L": [
    "RPL10L cnv",
    "RPL10L methyl",
    "RPL10L rna"
  ],
  "RPL11": [
    "RPL11 cnv",
    "RPL11 methyl",
    "RPL11 proteo",
    "RPL11 rna"
  ],
  "RPL12": [
    "RPL12 cnv",
    "RPL12 methyl",
    "RPL12 proteo",
    "RPL12 rna"
  ],
  "RPL13": [
    "RPL13 139_140_1_1_S140 phospho",
    "RPL13 cnv",
    "RPL13 methyl",
    "RPL13 proteo",
    "RPL13 rna"
  ],
  "RPL13A": [
    "RPL13A cnv",
    "RPL13A methyl",
    "RPL13A proteo",
    "RPL13A rna"
  ],
  "RPL14": [
    "RPL14 cnv",
    "RPL14 methyl",
    "RPL14 proteo",
    "RPL14 rna"
  ],
  "RPL15": [
    "RPL15 197_197_1_1_T197 phospho",
    "RPL15 cnv",
    "RPL15 methyl",
    "RPL15 proteo",
    "RPL15 rna"
  ],
  "RPL17": [
    "RPL17 cnv",
    "RPL17 methyl",
    "RPL17 rna"
  ],
  "RPL17-C18orf32": [
    "RPL17-C18orf32 cnv",
    "RPL17-C18orf32 methyl",
    "RPL17-C18orf32 rna"
  ],
  "RPL18": [
    "RPL18 cnv",
    "RPL18 methyl",
    "RPL18 proteo",
    "RPL18 rna"
  ],
  "RPL18A": [
    "RPL18A 24_28_1_1_T24 phospho",
    "RPL18A cnv",
    "RPL18A methyl",
    "RPL18A proteo",
    "RPL18A rna"
  ],
  "RPL19": [
    "RPL19 cnv",
    "RPL19 methyl",
    "RPL19 proteo",
    "RPL19 rna"
  ],
  "RPL21": [
    "RPL21 cnv",
    "RPL21 methyl",
    "RPL21 proteo",
    "RPL21 rna"
  ],
  "RPL22": [
    "RPL22 cnv",
    "RPL22 methyl",
    "RPL22 proteo",
    "RPL22 rna"
  ],
  "RPL22L1": [
    "RPL22L1 cnv",
    "RPL22L1 methyl",
    "RPL22L1 proteo",
    "RPL22L1 rna"
  ],
  "RPL23": [
    "RPL23 cnv",
    "RPL23 methyl",
    "RPL23 proteo",
    "RPL23 rna"
  ],
  "RPL23A": [
    "RPL23A 42_45_1_1_S43 phospho",
    "RPL23A cnv",
    "RPL23A methyl",
    "RPL23A proteo",
    "RPL23A rna"
  ],
  "RPL23AP82": [
    "RPL23AP82 methyl"
  ],
  "RPL24": [
    "RPL24 cnv",
    "RPL24 methyl",
    "RPL24 proteo",
    "RPL24 rna"
  ],
  "RPL26": [
    "RPL26 cnv",
    "RPL26 methyl",
    "RPL26 proteo",
    "RPL26 rna"
  ],
  "RPL26L1": [
    "RPL26L1 cnv",
    "RPL26L1 methyl",
    "RPL26L1 rna"
  ],
  "RPL26L1-AS1": [
    "RPL26L1-AS1 methyl"
  ],
  "RPL27": [
    "RPL27 cnv",
    "RPL27 methyl",
    "RPL27 proteo",
    "RPL27 rna"
  ],
  "RPL27A": [
    "RPL27A cnv",
    "RPL27A methyl",
    "RPL27A proteo",
    "RPL27A rna"
  ],
  "RPL28": [
    "RPL28 cnv",
    "RPL28 methyl",
    "RPL28 proteo",
    "RPL28 rna"
  ],
  "RPL29": [
    "RPL29 cnv",
    "RPL29 methyl",
    "RPL29 proteo",
    "RPL29 rna"
  ],
  "RPL3": [
    "RPL3 cnv",
    "RPL3 methyl",
    "RPL3 proteo",
    "RPL3 rna"
  ],
  "RPL30": [
    "RPL30 cnv",
    "RPL30 methyl",
    "RPL30 proteo",
    "RPL30 rna"
  ],
  "RPL31": [
    "RPL31 cnv",
    "RPL31 methyl",
    "RPL31 proteo",
    "RPL31 rna"
  ],
  "RPL32": [
    "RPL32 cnv",
    "RPL32 methyl",
    "RPL32 proteo",
    "RPL32 rna"
  ],
  "RPL34": [
    "RPL34 cnv",
    "RPL34 proteo",
    "RPL34 rna"
  ],
  "RPL35": [
    "RPL35 cnv",
    "RPL35 methyl",
    "RPL35 proteo",
    "RPL35 rna"
  ],
  "RPL35A": [
    "RPL35A cnv",
    "RPL35A proteo",
    "RPL35A rna"
  ],
  "RPL36": [
    "RPL36 cnv",
    "RPL36 methyl",
    "RPL36 proteo",
    "RPL36 rna"
  ],
  "RPL36A": [
    "RPL36A methyl",
    "RPL36A rna"
  ],
  "RPL36A-HNRNPH2": [
    "RPL36A-HNRNPH2 methyl",
    "RPL36A-HNRNPH2 rna"
  ],
  "RPL36AL": [
    "RPL36AL cnv",
    "RPL36AL methyl",
    "RPL36AL rna"
  ],
  "RPL37": [
    "RPL37 94_97_1_0 phospho",
    "RPL37 cnv",
    "RPL37 methyl",
    "RPL37 proteo",
    "RPL37 rna"
  ],
  "RPL37A": [
    "RPL37A cnv",
    "RPL37A methyl",
    "RPL37A proteo",
    "RPL37A rna"
  ],
  "RPL38": [
    "RPL38 cnv",
    "RPL38 methyl",
    "RPL38 proteo",
    "RPL38 rna"
  ],
  "RPL39": [
    "RPL39 methyl",
    "RPL39 rna"
  ],
  "RPL39L": [
    "RPL39L cnv",
    "RPL39L methyl",
    "RPL39L rna"
  ],
  "RPL3L": [
    "RPL3L cnv",
    "RPL3L rna"
  ],
  "RPL4": [
    "RPL4 cnv",
    "RPL4 proteo",
    "RPL4 rna"
  ],
  "RPL41": [
    "RPL41 cnv",
    "RPL41 rna"
  ],
  "RPL5": [
    "RPL5 cnv",
    "RPL5 methyl",
    "RPL5 proteo",
    "RPL5 rna"
  ],
  "RPL6": [
    "RPL6 cnv",
    "RPL6 methyl",
    "RPL6 proteo",
    "RPL6 rna"
  ],
  "RPL7": [
    "RPL7 cnv",
    "RPL7 methyl",
    "RPL7 proteo",
    "RPL7 rna"
  ],
  "RPL7A": [
    "RPL7A cnv",
    "RPL7A methyl",
    "RPL7A proteo",
    "RPL7A rna"
  ],
  "RPL7L1": [
    "RPL7L1 cnv",
    "RPL7L1 proteo",
    "RPL7L1 rna"
  ],
  "RPL8": [
    "RPL8 cnv",
    "RPL8 methyl",
    "RPL8 proteo",
    "RPL8 rna"
  ],
  "RPL9": [
    "RPL9 cnv",
    "RPL9 methyl",
    "RPL9 proteo",
    "RPL9 rna"
  ],
  "RPLP0": [
    "RPLP0 304_307_1_1_S307 phospho",
    "RPLP0 304_307_2_2_S304S307 phospho",
    "RPLP0 cnv",
    "RPLP0 methyl",
    "RPLP0 proteo",
    "RPLP0 rna"
  ],
  "RPLP1": [
    "RPLP1 cnv",
    "RPLP1 methyl",
    "RPLP1 proteo",
    "RPLP1 rna"
  ],
  "RPLP2": [
    "RPLP2 3_19_1_1_S17 phospho",
    "RPLP2 64_86_1_1_S79 phospho",
    "RPLP2 64_86_1_1_S86 phospho",
    "RPLP2 cnv",
    "RPLP2 methyl",
    "RPLP2 proteo",
    "RPLP2 rna"
  ],
  "RPN1": [
    "RPN1 TILPAAAQDVYYRDEIGNVSTSHLLILDDSVEMEIRPR-N2H6F0S0G0 glyco",
    "RPN1 cnv",
    "RPN1 methyl",
    "RPN1 proteo",
    "RPN1 rna"
  ],
  "RPN2": [
    "RPN2 SNLDPSNVDSLFYAAQASQALSGCEISISNETK-N2H5F0S0G0 glyco",
    "RPN2 SNLDPSNVDSLFYAAQASQALSGCEISISNETK-N2H6F0S0G0 glyco",
    "RPN2 cnv",
    "RPN2 methyl",
    "RPN2 proteo",
    "RPN2 rna"
  ],
  "RPP14": [
    "RPP14 cnv",
    "RPP14 methyl",
    "RPP14 proteo",
    "RPP14 rna"
  ],
  "RPP21": [
    "RPP21 cnv",
    "RPP21 methyl",
    "RPP21 rna"
  ],
  "RPP25": [
    "RPP25 151_169_1_1_S162 phospho",
    "RPP25 cnv",
    "RPP25 methyl",
    "RPP25 proteo",
    "RPP25 rna"
  ],
  "RPP25L": [
    "RPP25L cnv",
    "RPP25L methyl",
    "RPP25L proteo",
    "RPP25L rna"
  ],
  "RPP30": [
    "RPP30 251_261_1_1_S251 phospho",
    "RPP30 cnv",
    "RPP30 proteo",
    "RPP30 rna"
  ],
  "RPP38": [
    "RPP38 cnv",
    "RPP38 methyl",
    "RPP38 proteo",
    "RPP38 rna"
  ],
  "RPP38-DT": [
    "RPP38-DT methyl"
  ],
  "RPP40": [
    "RPP40 cnv",
    "RPP40 methyl",
    "RPP40 proteo",
    "RPP40 rna"
  ],
  "RPRD1A": [
    "RPRD1A cnv",
    "RPRD1A methyl",
    "RPRD1A proteo",
    "RPRD1A rna"
  ],
  "RPRD1B": [
    "RPRD1B 128_134_1_1_S134 phospho",
    "RPRD1B 128_140_1_1_S134 phospho",
    "RPRD1B cnv",
    "RPRD1B methyl",
    "RPRD1B proteo",
    "RPRD1B rna"
  ],
  "RPRD2": [
    "RPRD2 1073_1082_1_1_S1073 phospho",
    "RPRD2 348_355_1_1_S348 phospho",
    "RPRD2 444_465_1_1_S459 phospho",
    "RPRD2 563_581_1_1_S567 phospho",
    "RPRD2 635_641_1_1_S639 phospho",
    "RPRD2 704_728_1_0 phospho",
    "RPRD2 704_728_1_1_T706 phospho",
    "RPRD2 732_743_1_1_S743 phospho",
    "RPRD2 732_752_1_1_S743 phospho",
    "RPRD2 911_916_1_1_S914 phospho",
    "RPRD2 923_923_1_1_S923 phospho",
    "RPRD2 cnv",
    "RPRD2 methyl",
    "RPRD2 proteo",
    "RPRD2 rna"
  ],
  "RPRM": [
    "RPRM cnv",
    "RPRM methyl",
    "RPRM rna"
  ],
  "RPRML": [
    "RPRML cnv",
    "RPRML methyl",
    "RPRML rna"
  ],
  "RPS10": [
    "RPS10 cnv",
    "RPS10 methyl",
    "RPS10 proteo",
    "RPS10 rna"
  ],
  "RPS10-NUDT3": [
    "RPS10-NUDT3 cnv",
    "RPS10-NUDT3 methyl",
    "RPS10-NUDT3 rna"
  ],
  "RPS11": [
    "RPS11 cnv",
    "RPS11 methyl",
    "RPS11 proteo",
    "RPS11 rna"
  ],
  "RPS12": [
    "RPS12 cnv",
    "RPS12 methyl",
    "RPS12 proteo",
    "RPS12 rna"
  ],
  "RPS13": [
    "RPS13 cnv",
    "RPS13 methyl",
    "RPS13 proteo",
    "RPS13 rna"
  ],
  "RPS14": [
    "RPS14 cnv",
    "RPS14 methyl",
    "RPS14 proteo",
    "RPS14 rna"
  ],
  "RPS15": [
    "RPS15 cnv",
    "RPS15 methyl",
    "RPS15 proteo",
    "RPS15 rna"
  ],
  "RPS15A": [
    "RPS15A cnv",
    "RPS15A methyl",
    "RPS15A proteo",
    "RPS15A rna"
  ],
  "RPS16": [
    "RPS16 cnv",
    "RPS16 methyl",
    "RPS16 proteo",
    "RPS16 rna"
  ],
  "RPS17": [
    "RPS17 113_123_1_1_S113 phospho",
    "RPS17 cnv",
    "RPS17 methyl",
    "RPS17 proteo",
    "RPS17 rna"
  ],
  "RPS18": [
    "RPS18 cnv",
    "RPS18 methyl",
    "RPS18 proteo",
    "RPS18 rna"
  ],
  "RPS19": [
    "RPS19 cnv",
    "RPS19 methyl",
    "RPS19 proteo",
    "RPS19 rna"
  ],
  "RPS19BP1": [
    "RPS19BP1 cnv",
    "RPS19BP1 methyl",
    "RPS19BP1 rna"
  ],
  "RPS2": [
    "RPS2 cnv",
    "RPS2 methyl",
    "RPS2 proteo",
    "RPS2 rna"
  ],
  "RPS20": [
    "RPS20 6_9_1_1_T9 phospho",
    "RPS20 cnv",
    "RPS20 methyl",
    "RPS20 proteo",
    "RPS20 rna"
  ],
  "RPS21": [
    "RPS21 cnv",
    "RPS21 methyl",
    "RPS21 proteo",
    "RPS21 rna"
  ],
  "RPS23": [
    "RPS23 cnv",
    "RPS23 methyl",
    "RPS23 proteo",
    "RPS23 rna"
  ],
  "RPS24": [
    "RPS24 cnv",
    "RPS24 methyl",
    "RPS24 proteo",
    "RPS24 rna"
  ],
  "RPS25": [
    "RPS25 cnv",
    "RPS25 methyl",
    "RPS25 proteo",
    "RPS25 rna"
  ],
  "RPS26": [
    "RPS26 cnv",
    "RPS26 methyl",
    "RPS26 proteo",
    "RPS26 rna"
  ],
  "RPS27": [
    "RPS27 11_11_1_1_S11 phospho",
    "RPS27 cnv",
    "RPS27 methyl",
    "RPS27 proteo",
    "RPS27 rna"
  ],
  "RPS27A": [
    "RPS27A cnv",
    "RPS27A proteo",
    "RPS27A rna"
  ],
  "RPS27AP5": [
    "RPS27AP5 cnv",
    "RPS27AP5 rna"
  ],
  "RPS27L": [
    "RPS27L cnv",
    "RPS27L methyl",
    "RPS27L proteo",
    "RPS27L rna"
  ],
  "RPS28": [
    "RPS28 cnv",
    "RPS28 methyl",
    "RPS28 proteo",
    "RPS28 rna"
  ],
  "RPS29": [
    "RPS29 7_9_1_1_S9 phospho",
    "RPS29 cnv",
    "RPS29 methyl",
    "RPS29 proteo",
    "RPS29 rna"
  ],
  "RPS3": [
    "RPS3 209_224_1_1_T221 phospho",
    "RPS3 220_224_1_1_T221 phospho",
    "RPS3 cnv",
    "RPS3 methyl",
    "RPS3 proteo",
    "RPS3 rna"
  ],
  "RPS3A": [
    "RPS3A 256_263_1_1_S263 phospho",
    "RPS3A cnv",
    "RPS3A methyl",
    "RPS3A proteo",
    "RPS3A rna"
  ],
  "RPS4X": [
    "RPS4X methyl",
    "RPS4X proteo",
    "RPS4X rna"
  ],
  "RPS4Y1": [
    "RPS4Y1 proteo",
    "RPS4Y1 rna"
  ],
  "RPS5": [
    "RPS5 cnv",
    "RPS5 methyl",
    "RPS5 proteo",
    "RPS5 rna"
  ],
  "RPS6": [
    "RPS6 235_242_2_2_S235S236 phospho",
    "RPS6 cnv",
    "RPS6 methyl",
    "RPS6 proteo",
    "RPS6 rna"
  ],
  "RPS6KA1": [
    "RPS6KA1 389_393_1_1_S389 phospho",
    "RPS6KA1 cnv",
    "RPS6KA1 kinase",
    "RPS6KA1 methyl",
    "RPS6KA1 proteo",
    "RPS6KA1 rna"
  ],
  "RPS6KA2": [
    "RPS6KA2 225_233_1_1_S226 phospho",
    "RPS6KA2 cnv",
    "RPS6KA2 kinase",
    "RPS6KA2 methyl",
    "RPS6KA2 proteo",
    "RPS6KA2 rna"
  ],
  "RPS6KA3": [
    "RPS6KA3 365_375_1_1_S369 phospho",
    "RPS6KA3 415_422_1_1_S415 phospho",
    "RPS6KA3 715_715_1_1_S715 phospho",
    "RPS6KA3 kinase",
    "RPS6KA3 methyl",
    "RPS6KA3 proteo",
    "RPS6KA3 rna"
  ],
  "RPS6KA4": [
    "RPS6KA4 342_347_1_1_S347 phospho",
    "RPS6KA4 675_688_2_2_S676T681 phospho",
    "RPS6KA4 cnv",
    "RPS6KA4 kinase",
    "RPS6KA4 methyl",
    "RPS6KA4 proteo",
    "RPS6KA4 rna"
  ],
  "RPS6KA5": [
    "RPS6KA5 339_345_1_1_S340 phospho",
    "RPS6KA5 cnv",
    "RPS6KA5 kinase",
    "RPS6KA5 methyl",
    "RPS6KA5 proteo",
    "RPS6KA5 rna"
  ],
  "RPS6KA6": [
    "RPS6KA6 kinase",
    "RPS6KA6 methyl",
    "RPS6KA6 rna"
  ],
  "RPS6KB1": [
    "RPS6KB1 cnv",
    "RPS6KB1 kinase",
    "RPS6KB1 methyl",
    "RPS6KB1 proteo",
    "RPS6KB1 rna"
  ],
  "RPS6KB2": [
    "RPS6KB2 cnv",
    "RPS6KB2 kinase",
    "RPS6KB2 methyl",
    "RPS6KB2 rna"
  ],
  "RPS6KC1": [
    "RPS6KC1 269_272_1_0 phospho",
    "RPS6KC1 269_272_1_1_S270 phospho",
    "RPS6KC1 411_415_1_1_S411 phospho",
    "RPS6KC1 411_415_2_2_S411S415 phospho",
    "RPS6KC1 435_446_1_1_S437 phospho",
    "RPS6KC1 570_571_1_0 phospho",
    "RPS6KC1 570_571_1_1_S571 phospho",
    "RPS6KC1 581_584_1_1_S584 phospho",
    "RPS6KC1 647_660_1_1_S652 phospho",
    "RPS6KC1 cnv",
    "RPS6KC1 kinase",
    "RPS6KC1 methyl",
    "RPS6KC1 proteo",
    "RPS6KC1 rna"
  ],
  "RPS6KL1": [
    "RPS6KL1 cnv",
    "RPS6KL1 kinase",
    "RPS6KL1 methyl",
    "RPS6KL1 rna"
  ],
  "RPS7": [
    "RPS7 cnv",
    "RPS7 methyl",
    "RPS7 proteo",
    "RPS7 rna"
  ],
  "RPS8": [
    "RPS8 130_130_1_1_T130 phospho",
    "RPS8 cnv",
    "RPS8 methyl",
    "RPS8 proteo",
    "RPS8 rna"
  ],
  "RPS9": [
    "RPS9 cnv",
    "RPS9 methyl",
    "RPS9 proteo",
    "RPS9 rna"
  ],
  "RPSA": [
    "RPSA cnv",
    "RPSA methyl",
    "RPSA proteo",
    "RPSA rna"
  ],
  "RPSAP58": [
    "RPSAP58 cnv",
    "RPSAP58 methyl",
    "RPSAP58 rna"
  ],
  "RPTN": [
    "RPTN cnv"
  ],
  "RPTOR": [
    "RPTOR 695_707_1_1_S701 phospho",
    "RPTOR 695_707_1_1_S705 phospho",
    "RPTOR 695_707_2_2_S701S705 phospho",
    "RPTOR 719_731_1_0 phospho",
    "RPTOR 719_731_1_1_S719 phospho",
    "RPTOR cnv",
    "RPTOR methyl",
    "RPTOR proteo",
    "RPTOR rna"
  ],
  "RPUSD1": [
    "RPUSD1 cnv",
    "RPUSD1 methyl",
    "RPUSD1 rna"
  ],
  "RPUSD2": [
    "RPUSD2 cnv",
    "RPUSD2 methyl",
    "RPUSD2 proteo",
    "RPUSD2 rna"
  ],
  "RPUSD3": [
    "RPUSD3 cnv",
    "RPUSD3 methyl",
    "RPUSD3 rna"
  ],
  "RPUSD4": [
    "RPUSD4 cnv",
    "RPUSD4 methyl",
    "RPUSD4 rna"
  ],
  "RRAD": [
    "RRAD 39_39_1_1_S39 phospho",
    "RRAD cnv",
    "RRAD methyl",
    "RRAD rna"
  ],
  "RRAGA": [
    "RRAGA cnv",
    "RRAGA methyl",
    "RRAGA rna"
  ],
  "RRAGB": [
    "RRAGB proteo",
    "RRAGB rna"
  ],
  "RRAGC": [
    "RRAGC 376_385_1_1_S385 phospho",
    "RRAGC 376_385_2_2_S382S385 phospho",
    "RRAGC cnv",
    "RRAGC methyl",
    "RRAGC proteo",
    "RRAGC rna"
  ],
  "RRAGD": [
    "RRAGD 391_395_1_1_T391 phospho",
    "RRAGD cnv",
    "RRAGD methyl",
    "RRAGD proteo",
    "RRAGD rna"
  ],
  "RRAS": [
    "RRAS cnv",
    "RRAS methyl",
    "RRAS proteo",
    "RRAS rna"
  ],
  "RRAS2": [
    "RRAS2 151_155_1_1_S151 phospho",
    "RRAS2 cnv",
    "RRAS2 methyl",
    "RRAS2 proteo",
    "RRAS2 rna"
  ],
  "RRBP1": [
    "RRBP1 180_185_1_1_S185 phospho",
    "RRBP1 526_526_1_1_S526 phospho",
    "RRBP1 830_844_1_0 phospho",
    "RRBP1 830_844_1_1_S844 phospho",
    "RRBP1 cnv",
    "RRBP1 methyl",
    "RRBP1 proteo",
    "RRBP1 rna"
  ],
  "RREB1": [
    "RREB1 cnv",
    "RREB1 methyl",
    "RREB1 proteo",
    "RREB1 rna"
  ],
  "RRH": [
    "RRH cnv",
    "RRH rna"
  ],
  "RRM1": [
    "RRM1 cnv",
    "RRM1 methyl",
    "RRM1 proteo",
    "RRM1 rna"
  ],
  "RRM2": [
    "RRM2 12_20_1_1_S20 phospho",
    "RRM2 cnv",
    "RRM2 methyl",
    "RRM2 proteo",
    "RRM2 rna"
  ],
  "RRM2B": [
    "RRM2B cnv",
    "RRM2B methyl",
    "RRM2B proteo",
    "RRM2B rna"
  ],
  "RRN3": [
    "RRN3 cnv",
    "RRN3 methyl",
    "RRN3 rna"
  ],
  "RRP1": [
    "RRP1 cnv",
    "RRP1 methyl",
    "RRP1 proteo",
    "RRP1 rna"
  ],
  "RRP12": [
    "RRP12 1011_1019_1_1_S1019 phospho",
    "RRP12 cnv",
    "RRP12 methyl",
    "RRP12 proteo",
    "RRP12 rna"
  ],
  "RRP15": [
    "RRP15 cnv",
    "RRP15 methyl",
    "RRP15 proteo",
    "RRP15 rna"
  ],
  "RRP1B": [
    "RRP1B 728_736_1_1_S732 phospho",
    "RRP1B 728_736_1_1_S736 phospho",
    "RRP1B cnv",
    "RRP1B methyl",
    "RRP1B proteo",
    "RRP1B rna"
  ],
  "RRP36": [
    "RRP36 cnv",
    "RRP36 methyl",
    "RRP36 rna"
  ],
  "RRP7A": [
    "RRP7A cnv",
    "RRP7A methyl",
    "RRP7A proteo",
    "RRP7A rna"
  ],
  "RRP7BP": [
    "RRP7BP methyl"
  ],
  "RRP8": [
    "RRP8 104_106_2_2_S104S106 phospho",
    "RRP8 cnv",
    "RRP8 methyl",
    "RRP8 proteo",
    "RRP8 rna"
  ],
  "RRP9": [
    "RRP9 cnv",
    "RRP9 methyl",
    "RRP9 proteo",
    "RRP9 rna"
  ],
  "RRS1": [
    "RRS1 cnv",
    "RRS1 methyl",
    "RRS1 proteo",
    "RRS1 rna"
  ],
  "RRS1-DT": [
    "RRS1-DT methyl"
  ],
  "RS1": [
    "RS1 rna"
  ],
  "RSAD1": [
    "RSAD1 cnv",
    "RSAD1 methyl",
    "RSAD1 proteo",
    "RSAD1 rna"
  ],
  "RSAD2": [
    "RSAD2 cnv",
    "RSAD2 methyl",
    "RSAD2 rna"
  ],
  "RSBN1": [
    "RSBN1 cnv",
    "RSBN1 methyl",
    "RSBN1 proteo",
    "RSBN1 rna"
  ],
  "RSBN1L": [
    "RSBN1L cnv",
    "RSBN1L methyl",
    "RSBN1L proteo",
    "RSBN1L rna"
  ],
  "RSC1A1": [
    "RSC1A1 cnv",
    "RSC1A1 rna"
  ],
  "RSF1": [
    "RSF1 1277_1296_1_1_S1277 phospho",
    "RSF1 1277_1296_2_2_S1277S1282 phospho",
    "RSF1 1305_1310_1_1_T1305 phospho",
    "RSF1 1305_1310_2_2_T1305S1310 phospho",
    "RSF1 1305_1325_2_2_T1305S1325 phospho",
    "RSF1 1341_1345_1_1_S1345 phospho",
    "RSF1 1345_1345_1_1_S1345 phospho",
    "RSF1 1359_1375_2_2_S1359S1375 phospho",
    "RSF1 217_235_1_1_S227 phospho",
    "RSF1 604_604_1_1_S604 phospho",
    "RSF1 613_632_1_1_S622 phospho",
    "RSF1 613_632_2_1_S622 phospho",
    "RSF1 613_632_2_2_S622S629 phospho",
    "RSF1 748_748_1_1_S748 phospho",
    "RSF1 cnv",
    "RSF1 methyl",
    "RSF1 proteo",
    "RSF1 rna"
  ],
  "RSKR": [
    "RSKR cnv",
    "RSKR kinase",
    "RSKR rna"
  ],
  "RSL1D1": [
    "RSL1D1 358_361_1_1_S361 phospho",
    "RSL1D1 421_427_1_1_S427 phospho",
    "RSL1D1 cnv",
    "RSL1D1 methyl",
    "RSL1D1 proteo",
    "RSL1D1 rna"
  ],
  "RSL24D1": [
    "RSL24D1 cnv",
    "RSL24D1 methyl",
    "RSL24D1 proteo",
    "RSL24D1 rna"
  ],
  "RSPH1": [
    "RSPH1 cnv",
    "RSPH1 methyl",
    "RSPH1 proteo",
    "RSPH1 rna"
  ],
  "RSPH1-DT": [
    "RSPH1-DT methyl"
  ],
  "RSPH10B": [
    "RSPH10B cnv",
    "RSPH10B methyl",
    "RSPH10B rna"
  ],
  "RSPH10B2": [
    "RSPH10B2 cnv",
    "RSPH10B2 methyl",
    "RSPH10B2 rna"
  ],
  "RSPH14": [
    "RSPH14 cnv",
    "RSPH14 methyl",
    "RSPH14 rna"
  ],
  "RSPH3": [
    "RSPH3 cnv",
    "RSPH3 methyl",
    "RSPH3 rna"
  ],
  "RSPH4A": [
    "RSPH4A cnv",
    "RSPH4A proteo",
    "RSPH4A rna"
  ],
  "RSPH6A": [
    "RSPH6A cnv",
    "RSPH6A methyl",
    "RSPH6A rna"
  ],
  "RSPH9": [
    "RSPH9 cnv",
    "RSPH9 methyl",
    "RSPH9 rna"
  ],
  "RSPO1": [
    "RSPO1 cnv",
    "RSPO1 methyl",
    "RSPO1 rna"
  ],
  "RSPO2": [
    "RSPO2 cnv",
    "RSPO2 methyl",
    "RSPO2 rna"
  ],
  "RSPO3": [
    "RSPO3 cnv",
    "RSPO3 methyl",
    "RSPO3 rna"
  ],
  "RSPO4": [
    "RSPO4 cnv",
    "RSPO4 methyl",
    "RSPO4 rna"
  ],
  "RSPRY1": [
    "RSPRY1 cnv",
    "RSPRY1 methyl",
    "RSPRY1 proteo",
    "RSPRY1 rna"
  ],
  "RSRC1": [
    "RSRC1 cnv",
    "RSRC1 methyl",
    "RSRC1 proteo",
    "RSRC1 rna"
  ],
  "RSRC2": [
    "RSRC2 104_105_2_2_S104S105 phospho",
    "RSRC2 376_390_1_1_S376 phospho",
    "RSRC2 cnv",
    "RSRC2 methyl",
    "RSRC2 proteo",
    "RSRC2 rna"
  ],
  "RSRP1": [
    "RSRP1 cnv",
    "RSRP1 methyl",
    "RSRP1 rna"
  ],
  "RSU1": [
    "RSU1 cnv",
    "RSU1 methyl",
    "RSU1 proteo",
    "RSU1 rna"
  ],
  "RTBDN": [
    "RTBDN cnv",
    "RTBDN rna"
  ],
  "RTCA": [
    "RTCA cnv",
    "RTCA methyl",
    "RTCA proteo",
    "RTCA rna"
  ],
  "RTCB": [
    "RTCB cnv",
    "RTCB methyl",
    "RTCB proteo",
    "RTCB rna"
  ],
  "RTEL1": [
    "RTEL1 cnv",
    "RTEL1 methyl",
    "RTEL1 rna"
  ],
  "RTEL1-TNFRSF6B": [
    "RTEL1-TNFRSF6B cnv",
    "RTEL1-TNFRSF6B rna"
  ],
  "RTF1": [
    "RTF1 cnv",
    "RTF1 methyl",
    "RTF1 proteo",
    "RTF1 rna"
  ],
  "RTF2": [
    "RTF2 310_317_1_1_S317 phospho",
    "RTF2 cnv",
    "RTF2 methyl",
    "RTF2 proteo",
    "RTF2 rna"
  ],
  "RTKN": [
    "RTKN 106_108_1_1_S106 phospho",
    "RTKN 232_248_1_0 phospho",
    "RTKN 232_248_1_1_S232 phospho",
    "RTKN 232_248_1_1_S242 phospho",
    "RTKN 518_529_1_1_S520 phospho",
    "RTKN 534_543_1_1_S543 phospho",
    "RTKN cnv",
    "RTKN methyl",
    "RTKN proteo",
    "RTKN rna"
  ],
  "RTKN2": [
    "RTKN2 cnv",
    "RTKN2 methyl",
    "RTKN2 rna"
  ],
  "RTL1": [
    "RTL1 cnv",
    "RTL1 rna"
  ],
  "RTL10": [
    "RTL10 cnv",
    "RTL10 methyl",
    "RTL10 rna"
  ],
  "RTL3": [
    "RTL3 rna"
  ],
  "RTL4": [
    "RTL4 rna"
  ],
  "RTL5": [
    "RTL5 methyl",
    "RTL5 rna"
  ],
  "RTL6": [
    "RTL6 cnv",
    "RTL6 methyl",
    "RTL6 rna"
  ],
  "RTL8A": [
    "RTL8A methyl",
    "RTL8A rna"
  ],
  "RTL8B": [
    "RTL8B methyl",
    "RTL8B rna"
  ],
  "RTL8C": [
    "RTL8C methyl",
    "RTL8C rna"
  ],
  "RTL9": [
    "RTL9 rna"
  ],
  "RTN1": [
    "RTN1 135_158_1_1_S139 phospho",
    "RTN1 135_158_1_1_T145 phospho",
    "RTN1 163_176_1_1_S166 phospho",
    "RTN1 278_279_1_1_T279 phospho",
    "RTN1 278_296_1_1_T279 phospho",
    "RTN1 284_300_1_1_T300 phospho",
    "RTN1 300_345_1_0 phospho",
    "RTN1 311_345_1_0 phospho",
    "RTN1 311_345_2_2_S330T332 phospho",
    "RTN1 34_34_1_1_T34 phospho",
    "RTN1 350_358_1_1_S352 phospho",
    "RTN1 39_48_1_1_S48 phospho",
    "RTN1 487_487_1_1_S487 phospho",
    "RTN1 487_493_1_1_S487 phospho",
    "RTN1 487_502_1_1_S487 phospho",
    "RTN1 558_567_1_1_S563 phospho",
    "RTN1 65_97_1_1_S71 phospho",
    "RTN1 cnv",
    "RTN1 methyl",
    "RTN1 proteo",
    "RTN1 rna"
  ],
  "RTN2": [
    "RTN2 cnv",
    "RTN2 methyl",
    "RTN2 proteo",
    "RTN2 rna"
  ],
  "RTN3": [
    "RTN3 224_231_1_1_S229 phospho",
    "RTN3 446_453_1_1_S453 phospho",
    "RTN3 446_467_1_1_S453 phospho",
    "RTN3 560_583_1_1_S575 phospho",
    "RTN3 649_661_1_0 phospho",
    "RTN3 cnv",
    "RTN3 methyl",
    "RTN3 proteo",
    "RTN3 rna"
  ],
  "RTN4": [
    "RTN4 107_131_1_1_S107 phospho",
    "RTN4 107_131_1_1_S111 phospho",
    "RTN4 150_172_1_0 phospho",
    "RTN4 150_172_1_1_T172 phospho",
    "RTN4 181_191_1_1_S181 phospho",
    "RTN4 181_196_1_0 phospho",
    "RTN4 181_196_1_1_S181 phospho",
    "RTN4 181_196_1_1_S184 phospho",
    "RTN4 181_196_2_0 phospho",
    "RTN4 181_196_2_2_S181S184 phospho",
    "RTN4 216_245_1_0 phospho",
    "RTN4 428_450_1_1_S441 phospho",
    "RTN4 438_450_1_1_S441 phospho",
    "RTN4 856_877_1_1_S860 phospho",
    "RTN4 856_877_1_1_S863 phospho",
    "RTN4 889_895_1_1_T890 phospho",
    "RTN4 898_920_1_1_S920 phospho",
    "RTN4 991_1001_1_1_S991 phospho",
    "RTN4 cnv",
    "RTN4 methyl",
    "RTN4 proteo",
    "RTN4 rna"
  ],
  "RTN4IP1": [
    "RTN4IP1 cnv",
    "RTN4IP1 proteo",
    "RTN4IP1 rna"
  ],
  "RTN4R": [
    "RTN4R cnv",
    "RTN4R methyl",
    "RTN4R proteo",
    "RTN4R rna"
  ],
  "RTN4RL1": [
    "RTN4RL1 cnv",
    "RTN4RL1 methyl",
    "RTN4RL1 proteo",
    "RTN4RL1 rna"
  ],
  "RTN4RL2": [
    "RTN4RL2 cnv",
    "RTN4RL2 methyl",
    "RTN4RL2 proteo",
    "RTN4RL2 rna"
  ],
  "RTP1": [
    "RTP1 cnv",
    "RTP1 rna"
  ],
  "RTP2": [
    "RTP2 cnv",
    "RTP2 rna"
  ],
  "RTP3": [
    "RTP3 cnv",
    "RTP3 rna"
  ],
  "RTP4": [
    "RTP4 cnv",
    "RTP4 rna"
  ],
  "RTP5": [
    "RTP5 cnv",
    "RTP5 rna"
  ],
  "RTRAF": [
    "RTRAF cnv",
    "RTRAF methyl",
    "RTRAF proteo",
    "RTRAF rna"
  ],
  "RTTN": [
    "RTTN cnv",
    "RTTN methyl",
    "RTTN rna"
  ],
  "RUBCN": [
    "RUBCN 197_202_1_1_S197 phospho",
    "RUBCN 266_281_1_1_S266 phospho",
    "RUBCN 387_399_1_0 phospho",
    "RUBCN 408_416_1_1_S410 phospho",
    "RUBCN cnv",
    "RUBCN methyl",
    "RUBCN proteo",
    "RUBCN rna"
  ],
  "RUBCNL": [
    "RUBCNL cnv",
    "RUBCNL methyl",
    "RUBCNL rna"
  ],
  "RUFY1": [
    "RUFY1 319_327_1_1_S319 phospho",
    "RUFY1 74_83_1_1_T74 phospho",
    "RUFY1 cnv",
    "RUFY1 methyl",
    "RUFY1 proteo",
    "RUFY1 rna"
  ],
  "RUFY2": [
    "RUFY2 cnv",
    "RUFY2 methyl",
    "RUFY2 proteo",
    "RUFY2 rna"
  ],
  "RUFY3": [
    "RUFY3 34_34_1_1_S34 phospho",
    "RUFY3 49_63_1_1_T51 phospho",
    "RUFY3 615_620_1_1_T617 phospho",
    "RUFY3 91_116_1_1_S94 phospho",
    "RUFY3 91_116_1_1_S97 phospho",
    "RUFY3 cnv",
    "RUFY3 methyl",
    "RUFY3 proteo",
    "RUFY3 rna"
  ],
  "RUFY4": [
    "RUFY4 cnv",
    "RUFY4 methyl",
    "RUFY4 rna"
  ],
  "RUNDC1": [
    "RUNDC1 cnv",
    "RUNDC1 methyl",
    "RUNDC1 rna"
  ],
  "RUNDC3A": [
    "RUNDC3A 366_383_1_1_S366 phospho",
    "RUNDC3A cnv",
    "RUNDC3A methyl",
    "RUNDC3A proteo",
    "RUNDC3A rna"
  ],
  "RUNDC3B": [
    "RUNDC3B cnv",
    "RUNDC3B methyl",
    "RUNDC3B rna"
  ],
  "RUNX1": [
    "RUNX1 14_21_1_1_T14 phospho",
    "RUNX1 207_219_1_1_S212 phospho",
    "RUNX1 212_219_1_1_S212 phospho",
    "RUNX1 cnv",
    "RUNX1 methyl",
    "RUNX1 proteo",
    "RUNX1 rna"
  ],
  "RUNX1T1": [
    "RUNX1T1 cnv",
    "RUNX1T1 methyl",
    "RUNX1T1 rna"
  ],
  "RUNX2": [
    "RUNX2 cnv",
    "RUNX2 methyl",
    "RUNX2 rna"
  ],
  "RUNX3": [
    "RUNX3 cnv",
    "RUNX3 methyl",
    "RUNX3 rna"
  ],
  "RUSC1": [
    "RUSC1 cnv",
    "RUSC1 methyl",
    "RUSC1 rna"
  ],
  "RUSC1-AS1": [
    "RUSC1-AS1 methyl"
  ],
  "RUSC2": [
    "RUSC2 502_506_1_1_S506 phospho",
    "RUSC2 525_536_1_1_S536 phospho",
    "RUSC2 cnv",
    "RUSC2 proteo",
    "RUSC2 rna"
  ],
  "RUSF1": [
    "RUSF1 cnv",
    "RUSF1 methyl",
    "RUSF1 proteo",
    "RUSF1 rna"
  ],
  "RUVBL1": [
    "RUVBL1 cnv",
    "RUVBL1 methyl",
    "RUVBL1 proteo",
    "RUVBL1 rna"
  ],
  "RUVBL1-AS1": [
    "RUVBL1-AS1 methyl"
  ],
  "RUVBL2": [
    "RUVBL2 cnv",
    "RUVBL2 methyl",
    "RUVBL2 proteo",
    "RUVBL2 rna"
  ],
  "RWDD1": [
    "RWDD1 cnv",
    "RWDD1 methyl",
    "RWDD1 proteo",
    "RWDD1 rna"
  ],
  "RWDD2A": [
    "RWDD2A cnv",
    "RWDD2A methyl",
    "RWDD2A proteo",
    "RWDD2A rna"
  ],
  "RWDD2B": [
    "RWDD2B cnv",
    "RWDD2B methyl",
    "RWDD2B proteo",
    "RWDD2B rna"
  ],
  "RWDD3": [
    "RWDD3 cnv",
    "RWDD3 methyl",
    "RWDD3 proteo",
    "RWDD3 rna"
  ],
  "RWDD3-DT": [
    "RWDD3-DT methyl"
  ],
  "RWDD4": [
    "RWDD4 cnv",
    "RWDD4 methyl",
    "RWDD4 proteo",
    "RWDD4 rna"
  ],
  "RXFP1": [
    "RXFP1 cnv",
    "RXFP1 rna"
  ],
  "RXFP2": [
    "RXFP2 cnv",
    "RXFP2 rna"
  ],
  "RXFP3": [
    "RXFP3 cnv",
    "RXFP3 methyl",
    "RXFP3 rna"
  ],
  "RXFP4": [
    "RXFP4 cnv",
    "RXFP4 rna"
  ],
  "RXRA": [
    "RXRA cnv",
    "RXRA methyl",
    "RXRA proteo",
    "RXRA rna"
  ],
  "RXRB": [
    "RXRB cnv",
    "RXRB methyl",
    "RXRB proteo",
    "RXRB rna"
  ],
  "RXRG": [
    "RXRG cnv",
    "RXRG rna"
  ],
  "RXYLT1": [
    "RXYLT1 cnv",
    "RXYLT1 methyl",
    "RXYLT1 rna"
  ],
  "RXYLT1-AS1": [
    "RXYLT1-AS1 methyl"
  ],
  "RYBP": [
    "RYBP 115_135_2_2_S127S130 phospho",
    "RYBP cnv",
    "RYBP methyl",
    "RYBP proteo",
    "RYBP rna"
  ],
  "RYK": [
    "RYK cnv",
    "RYK kinase",
    "RYK methyl",
    "RYK rna"
  ],
  "RYR1": [
    "RYR1 cnv",
    "RYR1 methyl",
    "RYR1 mut",
    "RYR1 rna"
  ],
  "RYR2": [
    "RYR2 1856_1863_1_1_T1856 phospho",
    "RYR2 2693_2712_1_1_S2694 phospho",
    "RYR2 cnv",
    "RYR2 methyl",
    "RYR2 proteo",
    "RYR2 rna"
  ],
  "RYR3": [
    "RYR3 cnv",
    "RYR3 methyl",
    "RYR3 rna"
  ],
  "RYR3-DT": [
    "RYR3-DT methyl"
  ],
  "S100A1": [
    "S100A1 cnv",
    "S100A1 proteo",
    "S100A1 rna"
  ],
  "S100A10": [
    "S100A10 cnv",
    "S100A10 methyl",
    "S100A10 proteo",
    "S100A10 rna"
  ],
  "S100A11": [
    "S100A11 cnv",
    "S100A11 proteo",
    "S100A11 rna"
  ],
  "S100A12": [
    "S100A12 cnv",
    "S100A12 proteo",
    "S100A12 rna"
  ],
  "S100A13": [
    "S100A13 32_34_1_1_S32 phospho",
    "S100A13 cnv",
    "S100A13 methyl",
    "S100A13 proteo",
    "S100A13 rna"
  ],
  "S100A14": [
    "S100A14 cnv",
    "S100A14 rna"
  ],
  "S100A16": [
    "S100A16 101_103_1_1_S103 phospho",
    "S100A16 cnv",
    "S100A16 proteo",
    "S100A16 rna"
  ],
  "S100A2": [
    "S100A2 cnv",
    "S100A2 proteo",
    "S100A2 rna"
  ],
  "S100A3": [
    "S100A3 cnv",
    "S100A3 proteo",
    "S100A3 rna"
  ],
  "S100A4": [
    "S100A4 cnv",
    "S100A4 proteo",
    "S100A4 rna"
  ],
  "S100A5": [
    "S100A5 cnv",
    "S100A5 rna"
  ],
  "S100A6": [
    "S100A6 cnv",
    "S100A6 methyl",
    "S100A6 proteo",
    "S100A6 rna"
  ],
  "S100A7": [
    "S100A7 cnv",
    "S100A7 rna"
  ],
  "S100A7A": [
    "S100A7A cnv"
  ],
  "S100A7L2": [
    "S100A7L2 cnv"
  ],
  "S100A8": [
    "S100A8 cnv",
    "S100A8 proteo",
    "S100A8 rna"
  ],
  "S100A9": [
    "S100A9 113_113_1_1_T113 phospho",
    "S100A9 cnv",
    "S100A9 proteo",
    "S100A9 rna"
  ],
  "S100B": [
    "S100B cnv",
    "S100B proteo",
    "S100B rna"
  ],
  "S100P": [
    "S100P cnv",
    "S100P proteo",
    "S100P rna"
  ],
  "S100PBP": [
    "S100PBP cnv",
    "S100PBP methyl",
    "S100PBP rna"
  ],
  "S100Z": [
    "S100Z cnv",
    "S100Z rna"
  ],
  "S1PR1": [
    "S1PR1 353_382_1_0 phospho",
    "S1PR1 cnv",
    "S1PR1 methyl",
    "S1PR1 rna"
  ],
  "S1PR2": [
    "S1PR2 cnv",
    "S1PR2 methyl",
    "S1PR2 rna"
  ],
  "S1PR3": [
    "S1PR3 326_335_1_1_S326 phospho",
    "S1PR3 326_337_1_1_S337 phospho",
    "S1PR3 cnv",
    "S1PR3 methyl",
    "S1PR3 proteo",
    "S1PR3 rna"
  ],
  "S1PR4": [
    "S1PR4 cnv",
    "S1PR4 methyl",
    "S1PR4 rna"
  ],
  "S1PR5": [
    "S1PR5 cnv",
    "S1PR5 methyl",
    "S1PR5 rna"
  ],
  "SAA1": [
    "SAA1 cnv",
    "SAA1 proteo",
    "SAA1 rna"
  ],
  "SAA2": [
    "SAA2 cnv",
    "SAA2 proteo",
    "SAA2 rna"
  ],
  "SAA2-SAA4": [
    "SAA2-SAA4 cnv",
    "SAA2-SAA4 rna"
  ],
  "SAA4": [
    "SAA4 cnv",
    "SAA4 rna"
  ],
  "SAAL1": [
    "SAAL1 cnv",
    "SAAL1 methyl",
    "SAAL1 proteo",
    "SAAL1 rna"
  ],
  "SAC3D1": [
    "SAC3D1 cnv",
    "SAC3D1 methyl",
    "SAC3D1 rna"
  ],
  "SACM1L": [
    "SACM1L cnv",
    "SACM1L methyl",
    "SACM1L proteo",
    "SACM1L rna"
  ],
  "SACS": [
    "SACS 2362_2373_1_1_S2364 phospho",
    "SACS 4110_4123_1_1_S4117 phospho",
    "SACS cnv",
    "SACS methyl",
    "SACS proteo",
    "SACS rna"
  ],
  "SAE1": [
    "SAE1 cnv",
    "SAE1 methyl",
    "SAE1 proteo",
    "SAE1 rna"
  ],
  "SAFB": [
    "SAFB 372_391_1_1_S383 phospho",
    "SAFB 372_391_2_0 phospho",
    "SAFB 372_391_2_2_S383S384 phospho",
    "SAFB 383_391_1_1_S384 phospho",
    "SAFB 601_604_1_1_S601 phospho",
    "SAFB 601_604_1_1_S604 phospho",
    "SAFB cnv",
    "SAFB methyl",
    "SAFB proteo",
    "SAFB rna"
  ],
  "SAFB2": [
    "SAFB2 190_195_1_1_S194 phospho",
    "SAFB2 190_195_1_1_S195 phospho",
    "SAFB2 cnv",
    "SAFB2 methyl",
    "SAFB2 proteo",
    "SAFB2 rna"
  ],
  "SAG": [
    "SAG cnv",
    "SAG rna"
  ],
  "SAGE1": [
    "SAGE1 rna"
  ],
  "SALL1": [
    "SALL1 1006_1022_1_1_S1022 phospho",
    "SALL1 162_177_1_1_S172 phospho",
    "SALL1 475_493_1_1_S489 phospho",
    "SALL1 857_878_1_1_S864 phospho",
    "SALL1 cnv",
    "SALL1 methyl",
    "SALL1 proteo",
    "SALL1 rna"
  ],
  "SALL2": [
    "SALL2 253_269_1_1_T269 phospho",
    "SALL2 797_820_1_1_S802 phospho",
    "SALL2 797_820_2_2_S802S806 phospho",
    "SALL2 802_820_1_1_S806 phospho",
    "SALL2 cnv",
    "SALL2 proteo",
    "SALL2 rna"
  ],
  "SALL3": [
    "SALL3 1265_1273_1_1_S1268 phospho",
    "SALL3 45_51_1_1_S45 phospho",
    "SALL3 919_919_1_1_S919 phospho",
    "SALL3 935_947_1_1_S940 phospho",
    "SALL3 cnv",
    "SALL3 methyl",
    "SALL3 proteo",
    "SALL3 rna"
  ],
  "SALL4": [
    "SALL4 cnv",
    "SALL4 methyl",
    "SALL4 rna"
  ],
  "SAMD1": [
    "SAMD1 107_107_1_1_T107 phospho",
    "SAMD1 157_161_1_1_S161 phospho",
    "SAMD1 416_444_1_0 phospho",
    "SAMD1 416_444_1_1_S425 phospho",
    "SAMD1 416_444_1_1_S427 phospho",
    "SAMD1 cnv",
    "SAMD1 methyl",
    "SAMD1 proteo",
    "SAMD1 rna"
  ],
  "SAMD10": [
    "SAMD10 cnv",
    "SAMD10 methyl",
    "SAMD10 rna"
  ],
  "SAMD11": [
    "SAMD11 cnv",
    "SAMD11 methyl",
    "SAMD11 rna"
  ],
  "SAMD12": [
    "SAMD12 153_160_1_1_S160 phospho",
    "SAMD12 cnv",
    "SAMD12 methyl",
    "SAMD12 proteo",
    "SAMD12 rna"
  ],
  "SAMD13": [
    "SAMD13 cnv",
    "SAMD13 methyl",
    "SAMD13 rna"
  ],
  "SAMD14": [
    "SAMD14 122_140_1_1_S140 phospho",
    "SAMD14 144_153_1_1_S151 phospho",
    "SAMD14 165_181_1_1_S173 phospho",
    "SAMD14 165_181_3_3_S165S173S179 phospho",
    "SAMD14 248_260_1_1_S256 phospho",
    "SAMD14 248_260_2_2_S256S260 phospho",
    "SAMD14 267_267_1_1_S267 phospho",
    "SAMD14 72_77_1_1_S77 phospho",
    "SAMD14 cnv",
    "SAMD14 methyl",
    "SAMD14 proteo",
    "SAMD14 rna"
  ],
  "SAMD15": [
    "SAMD15 cnv",
    "SAMD15 methyl",
    "SAMD15 rna"
  ],
  "SAMD3": [
    "SAMD3 cnv",
    "SAMD3 methyl",
    "SAMD3 rna"
  ],
  "SAMD4A": [
    "SAMD4A 166_177_1_1_S168 phospho",
    "SAMD4A 183_193_1_1_S183 phospho",
    "SAMD4A 418_424_1_1_S420 phospho",
    "SAMD4A 578_586_1_1_S580 phospho",
    "SAMD4A 649_654_1_1_S651 phospho",
    "SAMD4A cnv",
    "SAMD4A methyl",
    "SAMD4A proteo",
    "SAMD4A rna"
  ],
  "SAMD4B": [
    "SAMD4B 172_172_1_1_S172 phospho",
    "SAMD4B 236_252_1_1_S238 phospho",
    "SAMD4B 555_563_1_1_S557 phospho",
    "SAMD4B 606_609_1_1_S607 phospho",
    "SAMD4B 606_609_1_1_T606 phospho",
    "SAMD4B 626_633_1_1_S628 phospho",
    "SAMD4B cnv",
    "SAMD4B methyl",
    "SAMD4B proteo",
    "SAMD4B rna"
  ],
  "SAMD5": [
    "SAMD5 cnv",
    "SAMD5 methyl",
    "SAMD5 rna"
  ],
  "SAMD7": [
    "SAMD7 cnv",
    "SAMD7 rna"
  ],
  "SAMD8": [
    "SAMD8 cnv",
    "SAMD8 methyl",
    "SAMD8 rna"
  ],
  "SAMD9": [
    "SAMD9 cnv",
    "SAMD9 proteo",
    "SAMD9 rna"
  ],
  "SAMD9L": [
    "SAMD9L cnv",
    "SAMD9L proteo",
    "SAMD9L rna"
  ],
  "SAMHD1": [
    "SAMHD1 18_42_1_1_S18 phospho",
    "SAMHD1 18_42_1_1_T21 phospho",
    "SAMHD1 18_42_2_2_S18T21 phospho",
    "SAMHD1 18_42_2_2_T21S33 phospho",
    "SAMHD1 21_42_1_1_S33 phospho",
    "SAMHD1 579_592_1_1_T592 phospho",
    "SAMHD1 6_10_1_1_S6 phospho",
    "SAMHD1 cnv",
    "SAMHD1 methyl",
    "SAMHD1 proteo",
    "SAMHD1 rna"
  ],
  "SAMM50": [
    "SAMM50 cnv",
    "SAMM50 methyl",
    "SAMM50 proteo",
    "SAMM50 rna"
  ],
  "SAMSN1": [
    "SAMSN1 21_23_1_1_S23 phospho",
    "SAMSN1 338_360_1_1_S347 phospho",
    "SAMSN1 34_57_1_1_S34 phospho",
    "SAMSN1 34_57_1_1_S36 phospho",
    "SAMSN1 cnv",
    "SAMSN1 proteo",
    "SAMSN1 rna"
  ],
  "SANBR": [
    "SANBR cnv",
    "SANBR methyl",
    "SANBR rna"
  ],
  "SAP130": [
    "SAP130 705_709_1_1_S709 phospho",
    "SAP130 cnv",
    "SAP130 methyl",
    "SAP130 proteo",
    "SAP130 rna"
  ],
  "SAP18": [
    "SAP18 cnv",
    "SAP18 methyl",
    "SAP18 proteo",
    "SAP18 rna"
  ],
  "SAP25": [
    "SAP25 cnv",
    "SAP25 methyl",
    "SAP25 rna"
  ],
  "SAP30": [
    "SAP30 cnv",
    "SAP30 methyl",
    "SAP30 proteo",
    "SAP30 rna"
  ],
  "SAP30-DT": [
    "SAP30-DT methyl"
  ],
  "SAP30BP": [
    "SAP30BP 147_147_1_1_S147 phospho",
    "SAP30BP cnv",
    "SAP30BP methyl",
    "SAP30BP proteo",
    "SAP30BP rna"
  ],
  "SAP30L": [
    "SAP30L cnv",
    "SAP30L methyl",
    "SAP30L rna"
  ],
  "SAP30L-AS1": [
    "SAP30L-AS1 methyl"
  ],
  "SAPCD1": [
    "SAPCD1 cnv",
    "SAPCD1 rna"
  ],
  "SAPCD2": [
    "SAPCD2 cnv",
    "SAPCD2 methyl",
    "SAPCD2 rna"
  ],
  "SAR1A": [
    "SAR1A 139_143_1_1_T139 phospho",
    "SAR1A cnv",
    "SAR1A methyl",
    "SAR1A proteo",
    "SAR1A rna"
  ],
  "SAR1B": [
    "SAR1B cnv",
    "SAR1B methyl",
    "SAR1B proteo",
    "SAR1B rna"
  ],
  "SARAF": [
    "SARAF cnv",
    "SARAF methyl",
    "SARAF proteo",
    "SARAF rna"
  ],
  "SARDH": [
    "SARDH cnv",
    "SARDH proteo",
    "SARDH rna"
  ],
  "SARM1": [
    "SARM1 548_568_1_1_S548 phospho",
    "SARM1 54_59_1_1_S54 phospho",
    "SARM1 572_578_1_1_S572 phospho",
    "SARM1 cnv",
    "SARM1 methyl",
    "SARM1 proteo",
    "SARM1 rna"
  ],
  "SARNP": [
    "SARNP cnv",
    "SARNP methyl",
    "SARNP proteo",
    "SARNP rna"
  ],
  "SARS1": [
    "SARS1 cnv",
    "SARS1 proteo",
    "SARS1 rna"
  ],
  "SARS2": [
    "SARS2 cnv",
    "SARS2 methyl",
    "SARS2 proteo",
    "SARS2 rna"
  ],
  "SART1": [
    "SART1 448_448_1_1_S448 phospho",
    "SART1 448_466_1_1_S448 phospho",
    "SART1 591_608_1_1_S598 phospho",
    "SART1 cnv",
    "SART1 methyl",
    "SART1 proteo",
    "SART1 rna"
  ],
  "SART3": [
    "SART3 650_657_1_1_S650 phospho",
    "SART3 769_778_1_1_S769 phospho",
    "SART3 cnv",
    "SART3 methyl",
    "SART3 proteo",
    "SART3 rna"
  ],
  "SASH1": [
    "SASH1 1000_1024_1_1_S1006 phospho",
    "SASH1 203_210_1_1_S203 phospho",
    "SASH1 275_298_1_0 phospho",
    "SASH1 342_344_1_1_S342 phospho",
    "SASH1 360_369_1_1_S362 phospho",
    "SASH1 424_445_1_1_S441 phospho",
    "SASH1 45_59_1_1_S45 phospho",
    "SASH1 45_59_1_1_S56 phospho",
    "SASH1 669_676_1_1_S676 phospho",
    "SASH1 680_686_1_0 phospho",
    "SASH1 698_701_1_1_S698 phospho",
    "SASH1 776_788_1_1_S776 phospho",
    "SASH1 792_813_1_1_S794 phospho",
    "SASH1 90_96_1_1_S92 phospho",
    "SASH1 980_988_1_1_S983 phospho",
    "SASH1 980_988_1_1_S986 phospho",
    "SASH1 cnv",
    "SASH1 methyl",
    "SASH1 proteo",
    "SASH1 rna"
  ],
  "SASH3": [
    "SASH3 131_142_1_1_S142 phospho",
    "SASH3 146_171_1_0 phospho",
    "SASH3 25_27_2_2_S25S27 phospho",
    "SASH3 34_42_1_1_S38 phospho",
    "SASH3 34_61_2_2_S37S42 phospho",
    "SASH3 97_120_1_1_S97 phospho",
    "SASH3 proteo",
    "SASH3 rna"
  ],
  "SASS6": [
    "SASS6 cnv",
    "SASS6 methyl",
    "SASS6 rna"
  ],
  "SAT1": [
    "SAT1 methyl",
    "SAT1 rna"
  ],
  "SAT2": [
    "SAT2 cnv",
    "SAT2 methyl",
    "SAT2 proteo",
    "SAT2 rna"
  ],
  "SATB1": [
    "SATB1 cnv",
    "SATB1 methyl",
    "SATB1 rna"
  ],
  "SATB2": [
    "SATB2 593_610_1_1_S593 phospho",
    "SATB2 cnv",
    "SATB2 methyl",
    "SATB2 rna"
  ],
  "SATB2-AS1": [
    "SATB2-AS1 methyl"
  ],
  "SATL1": [
    "SATL1 methyl",
    "SATL1 rna"
  ],
  "SAV1": [
    "SAV1 cnv",
    "SAV1 methyl",
    "SAV1 proteo",
    "SAV1 rna"
  ],
  "SAXO1": [
    "SAXO1 cnv",
    "SAXO1 methyl",
    "SAXO1 rna"
  ],
  "SAXO2": [
    "SAXO2 cnv",
    "SAXO2 methyl",
    "SAXO2 rna"
  ],
  "SAYSD1": [
    "SAYSD1 cnv",
    "SAYSD1 methyl",
    "SAYSD1 rna"
  ],
  "SBDS": [
    "SBDS cnv",
    "SBDS methyl",
    "SBDS proteo",
    "SBDS rna"
  ],
  "SBDSP1": [
    "SBDSP1 methyl"
  ],
  "SBF1": [
    "SBF1 1772_1785_1_1_S1772 phospho",
    "SBF1 1772_1785_1_1_T1775 phospho",
    "SBF1 553_559_1_1_S559 phospho",
    "SBF1 cnv",
    "SBF1 methyl",
    "SBF1 proteo",
    "SBF1 rna"
  ],
  "SBF2": [
    "SBF2 1101_1105_1_1_T1105 phospho",
    "SBF2 1211_1228_1_1_S1214 phospho",
    "SBF2 1687_1698_1_1_S1687 phospho",
    "SBF2 cnv",
    "SBF2 methyl",
    "SBF2 proteo",
    "SBF2 rna"
  ],
  "SBK1": [
    "SBK1 cnv",
    "SBK1 kinase",
    "SBK1 methyl",
    "SBK1 rna"
  ],
  "SBK2": [
    "SBK2 cnv",
    "SBK2 kinase",
    "SBK2 rna"
  ],
  "SBK3": [
    "SBK3 cnv",
    "SBK3 kinase",
    "SBK3 rna"
  ],
  "SBNO1": [
    "SBNO1 cnv",
    "SBNO1 methyl",
    "SBNO1 proteo",
    "SBNO1 rna"
  ],
  "SBNO1-AS1": [
    "SBNO1-AS1 methyl"
  ],
  "SBNO2": [
    "SBNO2 cnv",
    "SBNO2 methyl",
    "SBNO2 rna"
  ],
  "SBSN": [
    "SBSN cnv",
    "SBSN rna"
  ],
  "SBSPON": [
    "SBSPON cnv",
    "SBSPON methyl",
    "SBSPON proteo",
    "SBSPON rna"
  ],
  "SC5D": [
    "SC5D cnv",
    "SC5D methyl",
    "SC5D rna"
  ],
  "SCAANT1": [
    "SCAANT1 methyl"
  ],
  "SCAF1": [
    "SCAF1 228_239_1_1_S239 phospho",
    "SCAF1 498_515_1_1_S498 phospho",
    "SCAF1 498_515_2_2_S498S500 phospho",
    "SCAF1 534_552_1_1_S548 phospho",
    "SCAF1 612_625_2_2_S612S614 phospho",
    "SCAF1 719_725_2_2_S719S725 phospho",
    "SCAF1 989_998_1_1_T989 phospho",
    "SCAF1 cnv",
    "SCAF1 methyl",
    "SCAF1 proteo",
    "SCAF1 rna"
  ],
  "SCAF11": [
    "SCAF11 331_364_1_1_S338 phospho",
    "SCAF11 400_416_1_1_S405 phospho",
    "SCAF11 400_416_2_2_S405S413 phospho",
    "SCAF11 769_780_1_1_S776 phospho",
    "SCAF11 796_802_1_1_S796 phospho",
    "SCAF11 cnv",
    "SCAF11 methyl",
    "SCAF11 proteo",
    "SCAF11 rna"
  ],
  "SCAF4": [
    "SCAF4 123_139_1_1_S139 phospho",
    "SCAF4 221_227_1_1_T222 phospho",
    "SCAF4 634_641_1_1_S641 phospho",
    "SCAF4 cnv",
    "SCAF4 methyl",
    "SCAF4 proteo",
    "SCAF4 rna"
  ],
  "SCAF8": [
    "SCAF8 682_697_1_1_S695 phospho",
    "SCAF8 689_697_1_1_S695 phospho",
    "SCAF8 cnv",
    "SCAF8 methyl",
    "SCAF8 proteo",
    "SCAF8 rna"
  ],
  "SCAI": [
    "SCAI cnv",
    "SCAI methyl",
    "SCAI proteo",
    "SCAI rna"
  ],
  "SCAMP1": [
    "SCAMP1 112_112_1_1_S112 phospho",
    "SCAMP1 37_45_1_0 phospho",
    "SCAMP1 37_45_1_1_T45 phospho",
    "SCAMP1 cnv",
    "SCAMP1 methyl",
    "SCAMP1 proteo",
    "SCAMP1 rna"
  ],
  "SCAMP1-AS1": [
    "SCAMP1-AS1 methyl"
  ],
  "SCAMP2": [
    "SCAMP2 362_363_1_0 phospho",
    "SCAMP2 cnv",
    "SCAMP2 methyl",
    "SCAMP2 proteo",
    "SCAMP2 rna"
  ],
  "SCAMP3": [
    "SCAMP3 15_32_1_1_S32 phospho",
    "SCAMP3 76_78_1_1_S76 phospho",
    "SCAMP3 76_96_1_0 phospho",
    "SCAMP3 83_96_1_0 phospho",
    "SCAMP3 cnv",
    "SCAMP3 methyl",
    "SCAMP3 proteo",
    "SCAMP3 rna"
  ],
  "SCAMP4": [
    "SCAMP4 cnv",
    "SCAMP4 methyl",
    "SCAMP4 proteo",
    "SCAMP4 rna"
  ],
  "SCAMP5": [
    "SCAMP5 cnv",
    "SCAMP5 methyl",
    "SCAMP5 proteo",
    "SCAMP5 rna"
  ],
  "SCAND1": [
    "SCAND1 38_63_1_0 phospho",
    "SCAND1 cnv",
    "SCAND1 methyl",
    "SCAND1 rna"
  ],
  "SCAP": [
    "SCAP 566_577_1_1_S566 phospho",
    "SCAP 595_595_1_1_S595 phospho",
    "SCAP 664_696_1_1_S681 phospho",
    "SCAP cnv",
    "SCAP methyl",
    "SCAP proteo",
    "SCAP rna"
  ],
  "SCAPER": [
    "SCAPER cnv",
    "SCAPER methyl",
    "SCAPER proteo",
    "SCAPER rna"
  ],
  "SCARA3": [
    "SCARA3 cnv",
    "SCARA3 methyl",
    "SCARA3 proteo",
    "SCARA3 rna"
  ],
  "SCARA5": [
    "SCARA5 cnv",
    "SCARA5 rna"
  ],
  "SCARB1": [
    "SCARB1 cnv",
    "SCARB1 methyl",
    "SCARB1 proteo",
    "SCARB1 rna"
  ],
  "SCARB2": [
    "SCARB2 ANIQFGDNGTTISAVSNK-N4H5F4S1G0 glyco",
    "SCARB2 ANIQFGDNGTTISAVSNK-N6H7F1S2G0 glyco",
    "SCARB2 ANIQFGDNGTTISAVSNK-N6H7F1S3G0 glyco",
    "SCARB2 ANIQFGDNGTTISAVSNK-N6H7F3S2G0 glyco",
    "SCARB2 CNMINGTDGDSFHPLITK-N2H8F0S0G0 glyco",
    "SCARB2 CNMINGTDGDSFHPLITK-N2H9F0S0G0 glyco",
    "SCARB2 TMVFPVMYLNESVHIDK-N2H9F0S0G0 glyco",
    "SCARB2 TMVFPVMYLNESVHIDKETASR-N2H9F0S0G0 glyco",
    "SCARB2 TMVFPVMYLNESVHIDKETASR-N8H3F0S0G0 glyco",
    "SCARB2 cnv",
    "SCARB2 methyl",
    "SCARB2 proteo",
    "SCARB2 rna"
  ],
  "SCARF1": [
    "SCARF1 589_596_1_1_S589 phospho",
    "SCARF1 cnv",
    "SCARF1 proteo",
    "SCARF1 rna"
  ],
  "SCARF2": [
    "SCARF2 687_700_1_1_S687 phospho",
    "SCARF2 687_700_2_2_S687S698 phospho",
    "SCARF2 710_718_1_1_S718 phospho",
    "SCARF2 721_742_1_1_S742 phospho",
    "SCARF2 cnv",
    "SCARF2 methyl",
    "SCARF2 proteo",
    "SCARF2 rna"
  ],
  "SCARNA13": [
    "SCARNA13 methyl"
  ],
  "SCARNA16": [
    "SCARNA16 methyl"
  ],
  "SCARNA2": [
    "SCARNA2 methyl"
  ],
  "SCART1": [
    "SCART1 cnv",
    "SCART1 rna"
  ],
  "SCCPDH": [
    "SCCPDH 217_217_1_1_S217 phospho",
    "SCCPDH cnv",
    "SCCPDH methyl",
    "SCCPDH proteo",
    "SCCPDH rna"
  ],
  "SCD": [
    "SCD 164_173_1_1_S173 phospho",
    "SCD 198_203_1_0 phospho",
    "SCD 198_203_1_1_T199 phospho",
    "SCD cnv",
    "SCD methyl",
    "SCD proteo",
    "SCD rna"
  ],
  "SCD5": [
    "SCD5 cnv",
    "SCD5 methyl",
    "SCD5 proteo",
    "SCD5 rna"
  ],
  "SCEL": [
    "SCEL cnv",
    "SCEL rna"
  ],
  "SCFD1": [
    "SCFD1 205_211_1_1_S211 phospho",
    "SCFD1 cnv",
    "SCFD1 proteo",
    "SCFD1 rna"
  ],
  "SCFD2": [
    "SCFD2 cnv",
    "SCFD2 methyl",
    "SCFD2 proteo",
    "SCFD2 rna"
  ],
  "SCG2": [
    "SCG2 259_268_1_1_S268 phospho",
    "SCG2 532_533_1_0 phospho",
    "SCG2 555_559_1_1_S556 phospho",
    "SCG2 555_559_2_2_S555S556 phospho",
    "SCG2 555_566_1_1_S556 phospho",
    "SCG2 97_106_1_1_S104 phospho",
    "SCG2 cnv",
    "SCG2 proteo",
    "SCG2 rna"
  ],
  "SCG3": [
    "SCG3 37_37_1_1_S37 phospho",
    "SCG3 NATDNISK-N5H3F1S0G0 glyco",
    "SCG3 TYPPENKPGQSNYSFVDNLNLLK-N5H4F0S1G0 glyco",
    "SCG3 cnv",
    "SCG3 methyl",
    "SCG3 proteo",
    "SCG3 rna"
  ],
  "SCG5": [
    "SCG5 200_205_1_1_S205 phospho",
    "SCG5 cnv",
    "SCG5 proteo",
    "SCG5 rna"
  ],
  "SCGB1A1": [
    "SCGB1A1 cnv",
    "SCGB1A1 rna"
  ],
  "SCGB1C1": [
    "SCGB1C1 cnv"
  ],
  "SCGB1C2": [
    "SCGB1C2 cnv"
  ],
  "SCGB1D1": [
    "SCGB1D1 cnv"
  ],
  "SCGB1D2": [
    "SCGB1D2 cnv",
    "SCGB1D2 rna"
  ],
  "SCGB1D4": [
    "SCGB1D4 cnv",
    "SCGB1D4 rna"
  ],
  "SCGB2A1": [
    "SCGB2A1 cnv",
    "SCGB2A1 rna"
  ],
  "SCGB2A2": [
    "SCGB2A2 cnv",
    "SCGB2A2 rna"
  ],
  "SCGB2B2": [
    "SCGB2B2 cnv",
    "SCGB2B2 methyl",
    "SCGB2B2 rna"
  ],
  "SCGB3A1": [
    "SCGB3A1 cnv",
    "SCGB3A1 methyl",
    "SCGB3A1 rna"
  ],
  "SCGB3A2": [
    "SCGB3A2 cnv",
    "SCGB3A2 rna"
  ],
  "SCGN": [
    "SCGN cnv",
    "SCGN methyl",
    "SCGN proteo",
    "SCGN rna"
  ],
  "SCHIP1": [
    "SCHIP1 cnv",
    "SCHIP1 methyl",
    "SCHIP1 proteo",
    "SCHIP1 rna"
  ],
  "SCIMP": [
    "SCIMP cnv",
    "SCIMP rna"
  ],
  "SCIN": [
    "SCIN cnv",
    "SCIN methyl",
    "SCIN proteo",
    "SCIN rna"
  ],
  "SCIRT": [
    "SCIRT methyl"
  ],
  "SCLT1": [
    "SCLT1 cnv",
    "SCLT1 methyl",
    "SCLT1 rna"
  ],
  "SCLY": [
    "SCLY 132_137_1_1_S137 phospho",
    "SCLY cnv",
    "SCLY methyl",
    "SCLY proteo",
    "SCLY rna"
  ],
  "SCMH1": [
    "SCMH1 cnv",
    "SCMH1 methyl",
    "SCMH1 rna"
  ],
  "SCML1": [
    "SCML1 methyl",
    "SCML1 rna"
  ],
  "SCML2": [
    "SCML2 methyl",
    "SCML2 rna"
  ],
  "SCML4": [
    "SCML4 cnv",
    "SCML4 rna"
  ],
  "SCN10A": [
    "SCN10A cnv",
    "SCN10A rna"
  ],
  "SCN11A": [
    "SCN11A cnv",
    "SCN11A methyl",
    "SCN11A rna"
  ],
  "SCN1A": [
    "SCN1A cnv",
    "SCN1A proteo",
    "SCN1A rna"
  ],
  "SCN1B": [
    "SCN1B cnv",
    "SCN1B methyl",
    "SCN1B rna"
  ],
  "SCN2A": [
    "SCN2A 468_471_1_1_S468 phospho",
    "SCN2A 475_491_1_1_S484 phospho",
    "SCN2A 553_561_1_1_S558 phospho",
    "SCN2A cnv",
    "SCN2A proteo",
    "SCN2A rna"
  ],
  "SCN2B": [
    "SCN2B 198_204_1_1_T204 phospho",
    "SCN2B cnv",
    "SCN2B proteo",
    "SCN2B rna"
  ],
  "SCN3A": [
    "SCN3A cnv",
    "SCN3A rna"
  ],
  "SCN3B": [
    "SCN3B LQWNGSK-N2H5F0S0G0 glyco",
    "SCN3B cnv",
    "SCN3B methyl",
    "SCN3B proteo",
    "SCN3B rna"
  ],
  "SCN4A": [
    "SCN4A cnv",
    "SCN4A rna"
  ],
  "SCN4B": [
    "SCN4B cnv",
    "SCN4B methyl",
    "SCN4B proteo",
    "SCN4B rna"
  ],
  "SCN5A": [
    "SCN5A cnv",
    "SCN5A methyl",
    "SCN5A rna"
  ],
  "SCN7A": [
    "SCN7A 905_914_1_1_S905 phospho",
    "SCN7A cnv",
    "SCN7A rna"
  ],
  "SCN8A": [
    "SCN8A cnv",
    "SCN8A methyl",
    "SCN8A proteo",
    "SCN8A rna"
  ],
  "SCN9A": [
    "SCN9A cnv",
    "SCN9A methyl",
    "SCN9A rna"
  ],
  "SCNM1": [
    "SCNM1 cnv",
    "SCNM1 rna"
  ],
  "SCNN1A": [
    "SCNN1A cnv",
    "SCNN1A methyl",
    "SCNN1A rna"
  ],
  "SCNN1B": [
    "SCNN1B cnv",
    "SCNN1B methyl",
    "SCNN1B rna"
  ],
  "SCNN1D": [
    "SCNN1D cnv",
    "SCNN1D methyl",
    "SCNN1D rna"
  ],
  "SCNN1G": [
    "SCNN1G cnv",
    "SCNN1G methyl",
    "SCNN1G rna"
  ],
  "SCO1": [
    "SCO1 cnv",
    "SCO1 methyl",
    "SCO1 proteo",
    "SCO1 rna"
  ],
  "SCO2": [
    "SCO2 cnv",
    "SCO2 methyl",
    "SCO2 proteo",
    "SCO2 rna"
  ],
  "SCOC": [
    "SCOC cnv",
    "SCOC methyl",
    "SCOC proteo",
    "SCOC rna"
  ],
  "SCOC-AS1": [
    "SCOC-AS1 methyl"
  ],
  "SCP2": [
    "SCP2 cnv",
    "SCP2 methyl",
    "SCP2 proteo",
    "SCP2 rna"
  ],
  "SCP2D1": [
    "SCP2D1 cnv",
    "SCP2D1 rna"
  ],
  "SCPEP1": [
    "SCPEP1 cnv",
    "SCPEP1 proteo",
    "SCPEP1 rna"
  ],
  "SCRG1": [
    "SCRG1 cnv",
    "SCRG1 proteo",
    "SCRG1 rna"
  ],
  "SCRIB": [
    "SCRIB 1220_1226_1_1_S1220 phospho",
    "SCRIB 1295_1309_1_1_S1309 phospho",
    "SCRIB 1295_1309_2_2_S1306S1309 phospho",
    "SCRIB 1329_1353_1_1_S1348 phospho",
    "SCRIB 1508_1508_1_1_S1508 phospho",
    "SCRIB 1541_1561_1_1_S1547 phospho",
    "SCRIB 1541_1561_1_1_S1561 phospho",
    "SCRIB 1541_1566_1_0 phospho",
    "SCRIB 1541_1568_1_1_S1561 phospho",
    "SCRIB 23_32_1_1_S23 phospho",
    "SCRIB 475_479_1_1_T475 phospho",
    "SCRIB 493_504_1_1_S504 phospho",
    "SCRIB 607_610_1_1_T607 phospho",
    "SCRIB 824_835_1_0 phospho",
    "SCRIB 824_835_1_1_S835 phospho",
    "SCRIB 853_853_1_1_S853 phospho",
    "SCRIB cnv",
    "SCRIB methyl",
    "SCRIB proteo",
    "SCRIB rna"
  ],
  "SCRN1": [
    "SCRN1 cnv",
    "SCRN1 methyl",
    "SCRN1 proteo",
    "SCRN1 rna"
  ],
  "SCRN2": [
    "SCRN2 33_55_1_1_T52 phospho",
    "SCRN2 50_55_1_1_T52 phospho",
    "SCRN2 cnv",
    "SCRN2 methyl",
    "SCRN2 proteo",
    "SCRN2 rna"
  ],
  "SCRN3": [
    "SCRN3 cnv",
    "SCRN3 proteo",
    "SCRN3 rna"
  ],
  "SCRT1": [
    "SCRT1 cnv",
    "SCRT1 methyl",
    "SCRT1 rna"
  ],
  "SCRT2": [
    "SCRT2 cnv",
    "SCRT2 methyl",
    "SCRT2 rna"
  ],
  "SCT": [
    "SCT cnv",
    "SCT methyl",
    "SCT rna"
  ],
  "SCTR": [
    "SCTR cnv",
    "SCTR methyl",
    "SCTR rna"
  ],
  "SCUBE1": [
    "SCUBE1 cnv",
    "SCUBE1 methyl",
    "SCUBE1 rna"
  ],
  "SCUBE2": [
    "SCUBE2 cnv",
    "SCUBE2 methyl",
    "SCUBE2 proteo",
    "SCUBE2 rna"
  ],
  "SCUBE3": [
    "SCUBE3 cnv",
    "SCUBE3 methyl",
    "SCUBE3 rna"
  ],
  "SCX": [
    "SCX cnv",
    "SCX rna"
  ],
  "SCYGR1": [
    "SCYGR1 cnv",
    "SCYGR1 rna"
  ],
  "SCYGR10": [
    "SCYGR10 cnv"
  ],
  "SCYGR2": [
    "SCYGR2 cnv"
  ],
  "SCYGR3": [
    "SCYGR3 cnv"
  ],
  "SCYGR4": [
    "SCYGR4 cnv",
    "SCYGR4 rna"
  ],
  "SCYGR5": [
    "SCYGR5 cnv"
  ],
  "SCYGR6": [
    "SCYGR6 cnv"
  ],
  "SCYGR7": [
    "SCYGR7 cnv"
  ],
  "SCYGR8": [
    "SCYGR8 cnv"
  ],
  "SCYGR9": [
    "SCYGR9 cnv"
  ],
  "SCYL1": [
    "SCYL1 cnv",
    "SCYL1 kinase",
    "SCYL1 methyl",
    "SCYL1 proteo",
    "SCYL1 rna"
  ],
  "SCYL2": [
    "SCYL2 698_712_1_1_T708 phospho",
    "SCYL2 cnv",
    "SCYL2 kinase",
    "SCYL2 methyl",
    "SCYL2 proteo",
    "SCYL2 rna"
  ],
  "SCYL3": [
    "SCYL3 653_660_1_1_S653 phospho",
    "SCYL3 cnv",
    "SCYL3 kinase",
    "SCYL3 proteo",
    "SCYL3 rna"
  ],
  "SDAD1": [
    "SDAD1 cnv",
    "SDAD1 methyl",
    "SDAD1 rna"
  ],
  "SDAD1P1": [
    "SDAD1P1 methyl"
  ],
  "SDC1": [
    "SDC1 cnv",
    "SDC1 methyl",
    "SDC1 rna"
  ],
  "SDC2": [
    "SDC2 cnv",
    "SDC2 methyl",
    "SDC2 proteo",
    "SDC2 rna"
  ],
  "SDC3": [
    "SDC3 428_431_1_1_S428 phospho",
    "SDC3 428_441_1_1_S428 phospho",
    "SDC3 cnv",
    "SDC3 methyl",
    "SDC3 proteo",
    "SDC3 rna"
  ],
  "SDC4": [
    "SDC4 cnv",
    "SDC4 methyl",
    "SDC4 proteo",
    "SDC4 rna"
  ],
  "SDCBP": [
    "SDCBP cnv",
    "SDCBP methyl",
    "SDCBP proteo",
    "SDCBP rna"
  ],
  "SDCBP2": [
    "SDCBP2 cnv",
    "SDCBP2 methyl",
    "SDCBP2 rna"
  ],
  "SDCBP2-AS1": [
    "SDCBP2-AS1 methyl"
  ],
  "SDCCAG8": [
    "SDCCAG8 cnv",
    "SDCCAG8 methyl",
    "SDCCAG8 proteo",
    "SDCCAG8 rna"
  ],
  "SDE2": [
    "SDE2 274_289_1_1_S278 phospho",
    "SDE2 cnv",
    "SDE2 methyl",
    "SDE2 proteo",
    "SDE2 rna"
  ],
  "SDF2": [
    "SDF2 cnv",
    "SDF2 methyl",
    "SDF2 proteo",
    "SDF2 rna"
  ],
  "SDF2L1": [
    "SDF2L1 cnv",
    "SDF2L1 methyl",
    "SDF2L1 proteo",
    "SDF2L1 rna"
  ],
  "SDF4": [
    "SDF4 cnv",
    "SDF4 methyl",
    "SDF4 proteo",
    "SDF4 rna"
  ],
  "SDHA": [
    "SDHA cnv",
    "SDHA methyl",
    "SDHA proteo",
    "SDHA rna"
  ],
  "SDHAF1": [
    "SDHAF1 cnv",
    "SDHAF1 methyl",
    "SDHAF1 rna"
  ],
  "SDHAF2": [
    "SDHAF2 cnv",
    "SDHAF2 methyl",
    "SDHAF2 proteo",
    "SDHAF2 rna"
  ],
  "SDHAF3": [
    "SDHAF3 cnv",
    "SDHAF3 methyl",
    "SDHAF3 rna"
  ],
  "SDHAF4": [
    "SDHAF4 cnv",
    "SDHAF4 methyl",
    "SDHAF4 proteo",
    "SDHAF4 rna"
  ],
  "SDHAP1": [
    "SDHAP1 methyl"
  ],
  "SDHAP4": [
    "SDHAP4 methyl"
  ],
  "SDHB": [
    "SDHB cnv",
    "SDHB methyl",
    "SDHB proteo",
    "SDHB rna"
  ],
  "SDHC": [
    "SDHC cnv",
    "SDHC methyl",
    "SDHC proteo",
    "SDHC rna"
  ],
  "SDHD": [
    "SDHD cnv",
    "SDHD methyl",
    "SDHD proteo",
    "SDHD rna"
  ],
  "SDK1": [
    "SDK1 572_584_1_1_S584 phospho",
    "SDK1 cnv",
    "SDK1 methyl",
    "SDK1 proteo",
    "SDK1 rna"
  ],
  "SDK2": [
    "SDK2 2014_2031_1_1_S2026 phospho",
    "SDK2 cnv",
    "SDK2 methyl",
    "SDK2 proteo",
    "SDK2 rna"
  ],
  "SDR16C5": [
    "SDR16C5 cnv",
    "SDR16C5 methyl",
    "SDR16C5 rna"
  ],
  "SDR39U1": [
    "SDR39U1 cnv",
    "SDR39U1 proteo",
    "SDR39U1 rna"
  ],
  "SDR42E1": [
    "SDR42E1 cnv",
    "SDR42E1 methyl",
    "SDR42E1 rna"
  ],
  "SDR42E2": [
    "SDR42E2 cnv",
    "SDR42E2 methyl",
    "SDR42E2 rna"
  ],
  "SDR9C7": [
    "SDR9C7 cnv",
    "SDR9C7 rna"
  ],
  "SDS": [
    "SDS cnv",
    "SDS rna"
  ],
  "SDSL": [
    "SDSL cnv",
    "SDSL proteo",
    "SDSL rna"
  ],
  "SEBOX": [
    "SEBOX cnv",
    "SEBOX rna"
  ],
  "SEC11A": [
    "SEC11A cnv",
    "SEC11A methyl",
    "SEC11A proteo",
    "SEC11A rna"
  ],
  "SEC11C": [
    "SEC11C cnv",
    "SEC11C methyl",
    "SEC11C proteo",
    "SEC11C rna"
  ],
  "SEC13": [
    "SEC13 cnv",
    "SEC13 methyl",
    "SEC13 proteo",
    "SEC13 rna"
  ],
  "SEC14L1": [
    "SEC14L1 cnv",
    "SEC14L1 methyl",
    "SEC14L1 proteo",
    "SEC14L1 rna"
  ],
  "SEC14L2": [
    "SEC14L2 318_318_1_1_T318 phospho",
    "SEC14L2 cnv",
    "SEC14L2 methyl",
    "SEC14L2 proteo",
    "SEC14L2 rna"
  ],
  "SEC14L3": [
    "SEC14L3 cnv",
    "SEC14L3 rna"
  ],
  "SEC14L4": [
    "SEC14L4 cnv",
    "SEC14L4 methyl",
    "SEC14L4 proteo",
    "SEC14L4 rna"
  ],
  "SEC14L5": [
    "SEC14L5 cnv",
    "SEC14L5 methyl",
    "SEC14L5 rna"
  ],
  "SEC14L6": [
    "SEC14L6 cnv",
    "SEC14L6 methyl",
    "SEC14L6 rna"
  ],
  "SEC16A": [
    "SEC16A 1069_1069_1_1_S1069 phospho",
    "SEC16A 1356_1365_1_1_S1356 phospho",
    "SEC16A 1356_1365_1_1_S1362 phospho",
    "SEC16A 1368_1380_1_1_S1369 phospho",
    "SEC16A 1410_1441_1_0 phospho",
    "SEC16A 1410_1441_2_0 phospho",
    "SEC16A 1410_1446_1_0 phospho",
    "SEC16A 2022_2042_1_1_S2037 phospho",
    "SEC16A 2252_2265_1_1_S2253 phospho",
    "SEC16A 2267_2291_1_1_S2271 phospho",
    "SEC16A 314_314_1_1_S314 phospho",
    "SEC16A 568_584_1_1_S569 phospho",
    "SEC16A 587_610_1_0 phospho",
    "SEC16A 587_610_1_1_S595 phospho",
    "SEC16A 73_97_1_1_S74 phospho",
    "SEC16A cnv",
    "SEC16A methyl",
    "SEC16A proteo",
    "SEC16A rna"
  ],
  "SEC16B": [
    "SEC16B cnv",
    "SEC16B rna"
  ],
  "SEC1P": [
    "SEC1P methyl"
  ],
  "SEC22A": [
    "SEC22A cnv",
    "SEC22A methyl",
    "SEC22A proteo",
    "SEC22A rna"
  ],
  "SEC22B": [
    "SEC22B 164_168_1_1_S168 phospho",
    "SEC22B cnv",
    "SEC22B methyl",
    "SEC22B proteo",
    "SEC22B rna"
  ],
  "SEC22C": [
    "SEC22C cnv",
    "SEC22C methyl",
    "SEC22C rna"
  ],
  "SEC23A": [
    "SEC23A cnv",
    "SEC23A methyl",
    "SEC23A proteo",
    "SEC23A rna"
  ],
  "SEC23A-AS1": [
    "SEC23A-AS1 methyl"
  ],
  "SEC23B": [
    "SEC23B cnv",
    "SEC23B methyl",
    "SEC23B proteo",
    "SEC23B rna"
  ],
  "SEC23IP": [
    "SEC23IP cnv",
    "SEC23IP methyl",
    "SEC23IP proteo",
    "SEC23IP rna"
  ],
  "SEC24A": [
    "SEC24A cnv",
    "SEC24A methyl",
    "SEC24A proteo",
    "SEC24A rna"
  ],
  "SEC24B": [
    "SEC24B 1185_1189_1_1_S1189 phospho",
    "SEC24B 310_347_1_0 phospho",
    "SEC24B cnv",
    "SEC24B methyl",
    "SEC24B proteo",
    "SEC24B rna"
  ],
  "SEC24B-AS1": [
    "SEC24B-AS1 methyl"
  ],
  "SEC24C": [
    "SEC24C 888_891_1_1_S891 phospho",
    "SEC24C cnv",
    "SEC24C methyl",
    "SEC24C proteo",
    "SEC24C rna"
  ],
  "SEC24D": [
    "SEC24D cnv",
    "SEC24D methyl",
    "SEC24D proteo",
    "SEC24D rna"
  ],
  "SEC31A": [
    "SEC31A 1047_1054_1_1_S1049 phospho",
    "SEC31A 521_532_1_1_S527 phospho",
    "SEC31A 521_532_2_2_S527S532 phospho",
    "SEC31A 799_799_1_1_S799 phospho",
    "SEC31A 799_804_1_1_S799 phospho",
    "SEC31A cnv",
    "SEC31A methyl",
    "SEC31A proteo",
    "SEC31A rna"
  ],
  "SEC31B": [
    "SEC31B cnv",
    "SEC31B methyl",
    "SEC31B rna"
  ],
  "SEC61A1": [
    "SEC61A1 cnv",
    "SEC61A1 methyl",
    "SEC61A1 proteo",
    "SEC61A1 rna"
  ],
  "SEC61A2": [
    "SEC61A2 cnv",
    "SEC61A2 methyl",
    "SEC61A2 proteo",
    "SEC61A2 rna"
  ],
  "SEC61B": [
    "SEC61B cnv",
    "SEC61B methyl",
    "SEC61B proteo",
    "SEC61B rna"
  ],
  "SEC61G": [
    "SEC61G cnv",
    "SEC61G methyl",
    "SEC61G rna"
  ],
  "SEC61G-DT": [
    "SEC61G-DT methyl"
  ],
  "SEC62": [
    "SEC62 155_158_1_1_T158 phospho",
    "SEC62 332_335_1_1_S335 phospho",
    "SEC62 353_367_1_0 phospho",
    "SEC62 353_367_1_1_S356 phospho",
    "SEC62 375_391_1_1_T375 phospho",
    "SEC62 cnv",
    "SEC62 methyl",
    "SEC62 proteo",
    "SEC62 rna"
  ],
  "SEC63": [
    "SEC63 593_597_2_2_S593S597 phospho",
    "SEC63 cnv",
    "SEC63 methyl",
    "SEC63 proteo",
    "SEC63 rna"
  ],
  "SECISBP2": [
    "SECISBP2 cnv",
    "SECISBP2 methyl",
    "SECISBP2 proteo",
    "SECISBP2 rna"
  ],
  "SECISBP2L": [
    "SECISBP2L cnv",
    "SECISBP2L methyl",
    "SECISBP2L proteo",
    "SECISBP2L rna"
  ],
  "SECTM1": [
    "SECTM1 cnv",
    "SECTM1 methyl",
    "SECTM1 rna"
  ],
  "SEH1L": [
    "SEH1L cnv",
    "SEH1L methyl",
    "SEH1L proteo",
    "SEH1L rna"
  ],
  "SEL1L": [
    "SEL1L 37_44_1_1_S41 phospho",
    "SEL1L AASMNHTK-N2H5F0S0G0 glyco",
    "SEL1L AASMNHTK-N2H6F0S0G0 glyco",
    "SEL1L AASMNHTK-N2H7F0S0G0 glyco",
    "SEL1L AASMNHTK-N2H8F0S0G0 glyco",
    "SEL1L AASMNHTK-N2H9F0S0G0 glyco",
    "SEL1L EASIVGENETYPR-N2H8F0S0G0 glyco",
    "SEL1L GQTALGFLYASGLGVNSSQAK-N2H8F0S0G0 glyco",
    "SEL1L GQTALGFLYASGLGVNSSQAK-N2H9F0S0G0 glyco",
    "SEL1L ILNGSNK-N2H8F0S0G0 glyco",
    "SEL1L ILNGSNKK-N2H8F0S0G0 glyco",
    "SEL1L MYSEGSDIVPQSNETALHYFK-N2H6F0S0G0 glyco",
    "SEL1L cnv",
    "SEL1L methyl",
    "SEL1L proteo",
    "SEL1L rna"
  ],
  "SEL1L2": [
    "SEL1L2 cnv",
    "SEL1L2 methyl",
    "SEL1L2 rna"
  ],
  "SEL1L3": [
    "SEL1L3 cnv",
    "SEL1L3 methyl",
    "SEL1L3 rna"
  ],
  "SELE": [
    "SELE cnv",
    "SELE rna"
  ],
  "SELENBP1": [
    "SELENBP1 cnv",
    "SELENBP1 proteo",
    "SELENBP1 rna"
  ],
  "SELENOF": [
    "SELENOF cnv",
    "SELENOF methyl",
    "SELENOF proteo",
    "SELENOF rna"
  ],
  "SELENOH": [
    "SELENOH 78_95_1_1_S78 phospho",
    "SELENOH cnv",
    "SELENOH methyl",
    "SELENOH proteo",
    "SELENOH rna"
  ],
  "SELENOI": [
    "SELENOI cnv",
    "SELENOI methyl",
    "SELENOI proteo",
    "SELENOI rna"
  ],
  "SELENOK": [
    "SELENOK cnv",
    "SELENOK methyl",
    "SELENOK proteo",
    "SELENOK rna"
  ],
  "SELENOM": [
    "SELENOM cnv",
    "SELENOM methyl",
    "SELENOM proteo",
    "SELENOM rna"
  ],
  "SELENON": [
    "SELENON NWTAAASPSAVFATR-N2H6F0S0G0 glyco",
    "SELENON cnv",
    "SELENON proteo",
    "SELENON rna"
  ],
  "SELENOO": [
    "SELENOO cnv",
    "SELENOO methyl",
    "SELENOO proteo",
    "SELENOO rna"
  ],
  "SELENOP": [
    "SELENOP cnv",
    "SELENOP proteo",
    "SELENOP rna"
  ],
  "SELENOS": [
    "SELENOS cnv",
    "SELENOS methyl",
    "SELENOS proteo",
    "SELENOS rna"
  ],
  "SELENOT": [
    "SELENOT cnv",
    "SELENOT methyl",
    "SELENOT proteo",
    "SELENOT rna"
  ],
  "SELENOV": [
    "SELENOV cnv",
    "SELENOV methyl",
    "SELENOV rna"
  ],
  "SELENOW": [
    "SELENOW cnv",
    "SELENOW methyl",
    "SELENOW proteo",
    "SELENOW rna"
  ],
  "SELL": [
    "SELL cnv",
    "SELL proteo",
    "SELL rna"
  ],
  "SELP": [
    "SELP cnv",
    "SELP rna"
  ],
  "SELPLG": [
    "SELPLG 405_409_2_2_S405T409 phospho",
    "SELPLG cnv",
    "SELPLG proteo",
    "SELPLG rna"
  ],
  "SEM1": [
    "SEM1 cnv",
    "SEM1 methyl",
    "SEM1 proteo",
    "SEM1 rna"
  ],
  "SEMA3A": [
    "SEMA3A cnv",
    "SEMA3A rna"
  ],
  "SEMA3B": [
    "SEMA3B cnv",
    "SEMA3B methyl",
    "SEMA3B rna"
  ],
  "SEMA3C": [
    "SEMA3C cnv",
    "SEMA3C methyl",
    "SEMA3C rna"
  ],
  "SEMA3D": [
    "SEMA3D cnv",
    "SEMA3D rna"
  ],
  "SEMA3E": [
    "SEMA3E cnv",
    "SEMA3E rna"
  ],
  "SEMA3F": [
    "SEMA3F cnv",
    "SEMA3F methyl",
    "SEMA3F rna"
  ],
  "SEMA3G": [
    "SEMA3G cnv",
    "SEMA3G rna"
  ],
  "SEMA4A": [
    "SEMA4A 738_738_1_1_S738 phospho",
    "SEMA4A cnv",
    "SEMA4A proteo",
    "SEMA4A rna"
  ],
  "SEMA4B": [
    "SEMA4B 649_659_1_1_S655 phospho",
    "SEMA4B FEAEHISNYTALLLSR-N2H6F0S0G0 glyco",
    "SEMA4B FEAEHISNYTALLLSR-N2H7F0S0G0 glyco",
    "SEMA4B cnv",
    "SEMA4B methyl",
    "SEMA4B proteo",
    "SEMA4B rna"
  ],
  "SEMA4C": [
    "SEMA4C cnv",
    "SEMA4C methyl",
    "SEMA4C proteo",
    "SEMA4C rna"
  ],
  "SEMA4D": [
    "SEMA4D 828_840_1_1_S833 phospho",
    "SEMA4D 857_857_1_1_S857 phospho",
    "SEMA4D AANYTSSLNLPDK-N5H3F1S0G0 glyco",
    "SEMA4D EAVFAVNALNISEK-N5H3F1S0G0 glyco",
    "SEMA4D EAVFAVNALNISEK-N5H4F0S1G0 glyco",
    "SEMA4D NSSHSPLR-N2H6F0S0G0 glyco",
    "SEMA4D cnv",
    "SEMA4D proteo",
    "SEMA4D rna"
  ],
  "SEMA4F": [
    "SEMA4F cnv",
    "SEMA4F methyl",
    "SEMA4F rna"
  ],
  "SEMA4G": [
    "SEMA4G cnv",
    "SEMA4G methyl",
    "SEMA4G rna"
  ],
  "SEMA5A": [
    "SEMA5A cnv",
    "SEMA5A methyl",
    "SEMA5A proteo",
    "SEMA5A rna"
  ],
  "SEMA5B": [
    "SEMA5B cnv",
    "SEMA5B methyl",
    "SEMA5B proteo",
    "SEMA5B rna"
  ],
  "SEMA6A": [
    "SEMA6A 715_720_1_1_S715 phospho",
    "SEMA6A 770_780_2_0 phospho",
    "SEMA6A 904_918_1_1_S904 phospho",
    "SEMA6A IAVDTAAGPYQNHTVVFLGSEK-N2H5F0S0G0 glyco",
    "SEMA6A cnv",
    "SEMA6A methyl",
    "SEMA6A proteo",
    "SEMA6A rna"
  ],
  "SEMA6A-AS2": [
    "SEMA6A-AS2 methyl"
  ],
  "SEMA6B": [
    "SEMA6B cnv",
    "SEMA6B methyl",
    "SEMA6B rna"
  ],
  "SEMA6C": [
    "SEMA6C cnv",
    "SEMA6C methyl",
    "SEMA6C proteo",
    "SEMA6C rna"
  ],
  "SEMA6D": [
    "SEMA6D 666_672_1_1_S672 phospho",
    "SEMA6D 711_715_2_0 phospho",
    "SEMA6D cnv",
    "SEMA6D methyl",
    "SEMA6D proteo",
    "SEMA6D rna"
  ],
  "SEMA7A": [
    "SEMA7A cnv",
    "SEMA7A methyl",
    "SEMA7A proteo",
    "SEMA7A rna"
  ],
  "SEMG1": [
    "SEMG1 cnv",
    "SEMG1 rna"
  ],
  "SEMG2": [
    "SEMG2 cnv",
    "SEMG2 rna"
  ],
  "SENP1": [
    "SENP1 cnv",
    "SENP1 methyl",
    "SENP1 rna"
  ],
  "SENP2": [
    "SENP2 cnv",
    "SENP2 methyl",
    "SENP2 rna"
  ],
  "SENP3": [
    "SENP3 169_181_1_1_S169 phospho",
    "SENP3 169_181_1_1_S181 phospho",
    "SENP3 169_181_2_2_S169S181 phospho",
    "SENP3 188_188_1_1_S188 phospho",
    "SENP3 307_307_1_1_S307 phospho",
    "SENP3 cnv",
    "SENP3 methyl",
    "SENP3 proteo",
    "SENP3 rna"
  ],
  "SENP3-EIF4A1": [
    "SENP3-EIF4A1 cnv",
    "SENP3-EIF4A1 rna"
  ],
  "SENP5": [
    "SENP5 cnv",
    "SENP5 methyl",
    "SENP5 rna"
  ],
  "SENP6": [
    "SENP6 908_912_1_1_S912 phospho",
    "SENP6 cnv",
    "SENP6 methyl",
    "SENP6 rna"
  ],
  "SENP7": [
    "SENP7 368_379_2_2_S378S379 phospho",
    "SENP7 cnv",
    "SENP7 methyl",
    "SENP7 rna"
  ],
  "SENP8": [
    "SENP8 cnv",
    "SENP8 methyl",
    "SENP8 proteo",
    "SENP8 rna"
  ],
  "SEPHS1": [
    "SEPHS1 cnv",
    "SEPHS1 methyl",
    "SEPHS1 proteo",
    "SEPHS1 rna"
  ],
  "SEPHS2": [
    "SEPHS2 cnv",
    "SEPHS2 proteo",
    "SEPHS2 rna"
  ],
  "SEPSECS": [
    "SEPSECS cnv",
    "SEPSECS methyl",
    "SEPSECS proteo",
    "SEPSECS rna"
  ],
  "SEPTIN1": [
    "SEPTIN1 cnv",
    "SEPTIN1 proteo",
    "SEPTIN1 rna"
  ],
  "SEPTIN10": [
    "SEPTIN10 20_28_1_1_S28 phospho",
    "SEPTIN10 426_440_1_1_S432 phospho",
    "SEPTIN10 426_440_1_1_S434 phospho",
    "SEPTIN10 cnv",
    "SEPTIN10 methyl",
    "SEPTIN10 proteo",
    "SEPTIN10 rna"
  ],
  "SEPTIN11": [
    "SEPTIN11 27_36_1_1_S29 phospho",
    "SEPTIN11 cnv",
    "SEPTIN11 methyl",
    "SEPTIN11 proteo",
    "SEPTIN11 rna"
  ],
  "SEPTIN12": [
    "SEPTIN12 cnv",
    "SEPTIN12 methyl",
    "SEPTIN12 rna"
  ],
  "SEPTIN14": [
    "SEPTIN14 cnv",
    "SEPTIN14 proteo",
    "SEPTIN14 rna"
  ],
  "SEPTIN2": [
    "SEPTIN2 211_218_1_1_S218 phospho",
    "SEPTIN2 211_228_1_1_S218 phospho",
    "SEPTIN2 cnv",
    "SEPTIN2 methyl",
    "SEPTIN2 proteo",
    "SEPTIN2 rna"
  ],
  "SEPTIN3": [
    "SEPTIN3 cnv",
    "SEPTIN3 methyl",
    "SEPTIN3 proteo",
    "SEPTIN3 rna"
  ],
  "SEPTIN4": [
    "SEPTIN4 107_110_1_1_S109 phospho",
    "SEPTIN4 310_317_1_1_S317 phospho",
    "SEPTIN4 421_441_1_0 phospho",
    "SEPTIN4 421_441_1_1_S424 phospho",
    "SEPTIN4 99_99_1_1_S99 phospho",
    "SEPTIN4 cnv",
    "SEPTIN4 methyl",
    "SEPTIN4 proteo",
    "SEPTIN4 rna"
  ],
  "SEPTIN5": [
    "SEPTIN5 218_225_1_1_S225 phospho",
    "SEPTIN5 327_341_1_1_S327 phospho",
    "SEPTIN5 9_13_1_1_T13 phospho",
    "SEPTIN5 cnv",
    "SEPTIN5 methyl",
    "SEPTIN5 proteo",
    "SEPTIN5 rna"
  ],
  "SEPTIN6": [
    "SEPTIN6 401_418_1_1_S416 phospho",
    "SEPTIN6 methyl",
    "SEPTIN6 proteo",
    "SEPTIN6 rna"
  ],
  "SEPTIN7": [
    "SEPTIN7 331_333_1_1_S333 phospho",
    "SEPTIN7 333_333_1_1_S333 phospho",
    "SEPTIN7 63_83_1_1_S76 phospho",
    "SEPTIN7 cnv",
    "SEPTIN7 methyl",
    "SEPTIN7 proteo",
    "SEPTIN7 rna"
  ],
  "SEPTIN7P11": [
    "SEPTIN7P11 methyl"
  ],
  "SEPTIN8": [
    "SEPTIN8 410_417_1_1_S417 phospho",
    "SEPTIN8 431_445_1_0 phospho",
    "SEPTIN8 cnv",
    "SEPTIN8 methyl",
    "SEPTIN8 proteo",
    "SEPTIN8 rna"
  ],
  "SEPTIN9": [
    "SEPTIN9 12_24_1_0 phospho",
    "SEPTIN9 12_24_1_1_S12 phospho",
    "SEPTIN9 309_314_1_1_S309 phospho",
    "SEPTIN9 464_464_1_1_S464 phospho",
    "SEPTIN9 62_67_1_1_S67 phospho",
    "SEPTIN9 cnv",
    "SEPTIN9 methyl",
    "SEPTIN9 proteo",
    "SEPTIN9 rna"
  ],
  "SEPTIN9-DT": [
    "SEPTIN9-DT methyl"
  ],
  "SERAC1": [
    "SERAC1 cnv",
    "SERAC1 methyl",
    "SERAC1 proteo",
    "SERAC1 rna"
  ],
  "SERBP1": [
    "SERBP1 197_208_1_1_S203 phospho",
    "SERBP1 202_208_1_1_S203 phospho",
    "SERBP1 219_234_1_1_S234 phospho",
    "SERBP1 219_237_1_1_S234 phospho",
    "SERBP1 232_234_1_1_S234 phospho",
    "SERBP1 232_237_1_1_S234 phospho",
    "SERBP1 243_270_1_0 phospho",
    "SERBP1 328_338_1_0 phospho",
    "SERBP1 53_63_1_1_S63 phospho",
    "SERBP1 cnv",
    "SERBP1 methyl",
    "SERBP1 proteo",
    "SERBP1 rna"
  ],
  "SERF1A": [
    "SERF1A cnv",
    "SERF1A rna"
  ],
  "SERF1B": [
    "SERF1B cnv",
    "SERF1B rna"
  ],
  "SERF2": [
    "SERF2 cnv",
    "SERF2 methyl",
    "SERF2 proteo",
    "SERF2 rna"
  ],
  "SERGEF": [
    "SERGEF cnv",
    "SERGEF methyl",
    "SERGEF proteo",
    "SERGEF rna"
  ],
  "SERHL": [
    "SERHL methyl"
  ],
  "SERHL2": [
    "SERHL2 cnv",
    "SERHL2 methyl",
    "SERHL2 rna"
  ],
  "SERINC1": [
    "SERINC1 361_364_1_1_S364 phospho",
    "SERINC1 cnv",
    "SERINC1 methyl",
    "SERINC1 proteo",
    "SERINC1 rna"
  ],
  "SERINC2": [
    "SERINC2 cnv",
    "SERINC2 methyl",
    "SERINC2 rna"
  ],
  "SERINC3": [
    "SERINC3 cnv",
    "SERINC3 methyl",
    "SERINC3 proteo",
    "SERINC3 rna"
  ],
  "SERINC4": [
    "SERINC4 cnv",
    "SERINC4 methyl",
    "SERINC4 rna"
  ],
  "SERINC5": [
    "SERINC5 cnv",
    "SERINC5 methyl",
    "SERINC5 rna"
  ],
  "SERP1": [
    "SERP1 cnv",
    "SERP1 methyl",
    "SERP1 rna"
  ],
  "SERP2": [
    "SERP2 cnv",
    "SERP2 methyl",
    "SERP2 rna"
  ],
  "SERPINA1": [
    "SERPINA1 35_46_1_1_T37 phospho",
    "SERPINA1 ADTHDEILEGLNFNLTEIPEAQIHEGFQELLR-N4H5F0S2G0 glyco",
    "SERPINA1 QLAHQSNSTNIFFSPVSIATAFAMLSLGTK-N4H4F1S2G0 glyco",
    "SERPINA1 QLAHQSNSTNIFFSPVSIATAFAMLSLGTK-N4H4F2S2G0 glyco",
    "SERPINA1 QLAHQSNSTNIFFSPVSIATAFAMLSLGTK-N4H5F0S1G0 glyco",
    "SERPINA1 QLAHQSNSTNIFFSPVSIATAFAMLSLGTK-N4H5F0S2G0 glyco",
    "SERPINA1 QLAHQSNSTNIFFSPVSIATAFAMLSLGTK-N4H5F1S1G0 glyco",
    "SERPINA1 QLAHQSNSTNIFFSPVSIATAFAMLSLGTK-N4H5F1S2G0 glyco",
    "SERPINA1 QLAHQSNSTNIFFSPVSIATAFAMLSLGTK-N4H5F2S1G0 glyco",
    "SERPINA1 QLAHQSNSTNIFFSPVSIATAFAMLSLGTK-N4H5F3S1G0 glyco",
    "SERPINA1 QLAHQSNSTNIFFSPVSIATAFAMLSLGTK-N4H6F1S1G0 glyco",
    "SERPINA1 QLAHQSNSTNIFFSPVSIATAFAMLSLGTK-N5H6F1S2G0 glyco",
    "SERPINA1 QLAHQSNSTNIFFSPVSIATAFAMLSLGTK-N5H6F1S3G0 glyco",
    "SERPINA1 QLAHQSNSTNIFFSPVSIATAFAMLSLGTK-N5H6F2S1G0 glyco",
    "SERPINA1 QLAHQSNSTNIFFSPVSIATAFAMLSLGTK-N6H3F3S0G0 glyco",
    "SERPINA1 QLAHQSNSTNIFFSPVSIATAFAMLSLGTK-N6H3F5S0G0 glyco",
    "SERPINA1 QLAHQSNSTNIFFSPVSIATAFAMLSLGTK-N6H4F2S1G0 glyco",
    "SERPINA1 QLAHQSNSTNIFFSPVSIATAFAMLSLGTK-N6H5F0S1G0 glyco",
    "SERPINA1 QLAHQSNSTNIFFSPVSIATAFAMLSLGTK-N7H4F5S1G0 glyco",
    "SERPINA1 QLAHQSNSTNIFFSPVSIATAFAMLSLGTK-N8H5F1S0G0 glyco",
    "SERPINA1 YLGNATAIFFLPDEGK-N2H3F0S0G0 glyco",
    "SERPINA1 YLGNATAIFFLPDEGK-N3H3F2S0G0 glyco",
    "SERPINA1 YLGNATAIFFLPDEGK-N3H4F0S0G0 glyco",
    "SERPINA1 YLGNATAIFFLPDEGK-N3H4F0S1G0 glyco",
    "SERPINA1 YLGNATAIFFLPDEGK-N4H5F0S0G0 glyco",
    "SERPINA1 YLGNATAIFFLPDEGK-N4H5F0S1G0 glyco",
    "SERPINA1 YLGNATAIFFLPDEGK-N4H5F0S2G0 glyco",
    "SERPINA1 YLGNATAIFFLPDEGK-N4H5F1S1G0 glyco",
    "SERPINA1 YLGNATAIFFLPDEGK-N4H5F1S2G0 glyco",
    "SERPINA1 YLGNATAIFFLPDEGK-N4H5F2S1G0 glyco",
    "SERPINA1 YLGNATAIFFLPDEGK-N4H6F0S1G0 glyco",
    "SERPINA1 YLGNATAIFFLPDEGK-N4H6F1S1G0 glyco",
    "SERPINA1 YLGNATAIFFLPDEGK-N5H6F1S2G0 glyco",
    "SERPINA1 YLGNATAIFFLPDEGK-N6H5F1S0G0 glyco",
    "SERPINA1 cnv",
    "SERPINA1 proteo",
    "SERPINA1 rna"
  ],
  "SERPINA10": [
    "SERPINA10 56_61_2_2_S56S61 phospho",
    "SERPINA10 ETFFNLSK-N4H5F0S2G0 glyco",
    "SERPINA10 LPYQGNATMLVVLMEK-N4H5F0S2G0 glyco",
    "SERPINA10 LPYQGNATMLVVLMEK-N4H5F2S1G0 glyco",
    "SERPINA10 cnv",
    "SERPINA10 proteo",
    "SERPINA10 rna"
  ],
  "SERPINA11": [
    "SERPINA11 cnv",
    "SERPINA11 rna"
  ],
  "SERPINA12": [
    "SERPINA12 cnv",
    "SERPINA12 rna"
  ],
  "SERPINA2": [
    "SERPINA2 cnv"
  ],
  "SERPINA3": [
    "SERPINA3 NVIFSPLSISTALAFLSLGAHNTTLTEILK-N7H4F5S1G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N2H5F0S0G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N2H8F0S0G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N2H9F0S0G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N3H4F0S1G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N4H3F0S2G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N4H3F1S0G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N4H5F0S0G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N4H5F0S1G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N4H5F0S2G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N4H5F2S0G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N4H5F2S1G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N5H3F1S0G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N5H4F2S0G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N5H6F0S1G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N5H6F0S2G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N5H6F0S3G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N5H6F1S3G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N5H6F2S1G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N5H6F2S2G0 glyco",
    "SERPINA3 TLNQSSDELQLSMGNAMFVK-N5H6F4S1G0 glyco",
    "SERPINA3 YTGNASALFILPDQDK-N5H6F0S2G0 glyco",
    "SERPINA3 YTGNASALFILPDQDK-N5H6F0S3G0 glyco",
    "SERPINA3 YTGNASALFILPDQDK-N5H6F2S2G0 glyco",
    "SERPINA3 cnv",
    "SERPINA3 proteo",
    "SERPINA3 rna"
  ],
  "SERPINA4": [
    "SERPINA4 FLNDTMAVYEAK-N4H5F0S1G0 glyco",
    "SERPINA4 FLNDTMAVYEAK-N4H5F0S2G0 glyco",
    "SERPINA4 FLNDTMAVYEAK-N4H5F2S1G0 glyco",
    "SERPINA4 cnv",
    "SERPINA4 proteo"
  ],
  "SERPINA5": [
    "SERPINA5 cnv",
    "SERPINA5 proteo",
    "SERPINA5 rna"
  ],
  "SERPINA6": [
    "SERPINA6 AQLLQGLGFNLTER-N4H5F0S2G0 glyco",
    "SERPINA6 cnv",
    "SERPINA6 proteo",
    "SERPINA6 rna"
  ],
  "SERPINA7": [
    "SERPINA7 TLYETEVFSTDFSNISAAK-N4H5F0S2G0 glyco",
    "SERPINA7 VTACHSSQPNATLYK-N4H5F0S2G0 glyco",
    "SERPINA7 VTACHSSQPNATLYK-N4H5F1S2G0 glyco",
    "SERPINA7 proteo"
  ],
  "SERPINA9": [
    "SERPINA9 cnv",
    "SERPINA9 rna"
  ],
  "SERPINB1": [
    "SERPINB1 cnv",
    "SERPINB1 methyl",
    "SERPINB1 proteo",
    "SERPINB1 rna"
  ],
  "SERPINB10": [
    "SERPINB10 cnv",
    "SERPINB10 proteo",
    "SERPINB10 rna"
  ],
  "SERPINB11": [
    "SERPINB11 cnv"
  ],
  "SERPINB12": [
    "SERPINB12 cnv",
    "SERPINB12 rna"
  ],
  "SERPINB13": [
    "SERPINB13 cnv",
    "SERPINB13 rna"
  ],
  "SERPINB2": [
    "SERPINB2 cnv",
    "SERPINB2 rna"
  ],
  "SERPINB3": [
    "SERPINB3 cnv",
    "SERPINB3 rna"
  ],
  "SERPINB4": [
    "SERPINB4 cnv",
    "SERPINB4 rna"
  ],
  "SERPINB5": [
    "SERPINB5 cnv",
    "SERPINB5 rna"
  ],
  "SERPINB6": [
    "SERPINB6 cnv",
    "SERPINB6 methyl",
    "SERPINB6 proteo",
    "SERPINB6 rna"
  ],
  "SERPINB7": [
    "SERPINB7 cnv",
    "SERPINB7 rna"
  ],
  "SERPINB8": [
    "SERPINB8 cnv",
    "SERPINB8 methyl",
    "SERPINB8 proteo",
    "SERPINB8 rna"
  ],
  "SERPINB9": [
    "SERPINB9 cnv",
    "SERPINB9 methyl",
    "SERPINB9 proteo",
    "SERPINB9 rna"
  ],
  "SERPINC1": [
    "SERPINC1 LGACNDTLQQLMEVFK-N4H5F0S1G0 glyco",
    "SERPINC1 LGACNDTLQQLMEVFK-N4H5F0S2G0 glyco",
    "SERPINC1 LGACNDTLQQLMEVFK-N4H5F2S1G0 glyco",
    "SERPINC1 LGACNDTLQQLMEVFK-N4H6F1S1G0 glyco",
    "SERPINC1 LGACNDTLQQLMEVFKFDTISEK-N4H5F0S2G0 glyco",
    "SERPINC1 SLTFNETYQDISELVYGAK-N4H5F0S1G0 glyco",
    "SERPINC1 SLTFNETYQDISELVYGAK-N4H5F0S2G0 glyco",
    "SERPINC1 SLTFNETYQDISELVYGAK-N7H5F0S0G0 glyco",
    "SERPINC1 cnv",
    "SERPINC1 proteo",
    "SERPINC1 rna"
  ],
  "SERPIND1": [
    "SERPIND1 DFVNASSK-N3H4F0S1G0 glyco",
    "SERPIND1 DFVNASSK-N4H5F0S1G0 glyco",
    "SERPIND1 DFVNASSK-N4H5F0S2G0 glyco",
    "SERPIND1 NLSMPLLPADFHK-N4H5F0S1G0 glyco",
    "SERPIND1 NLSMPLLPADFHK-N4H5F0S2G0 glyco",
    "SERPIND1 cnv",
    "SERPIND1 proteo",
    "SERPIND1 rna"
  ],
  "SERPINE1": [
    "SERPINE1 cnv",
    "SERPINE1 proteo",
    "SERPINE1 rna"
  ],
  "SERPINE2": [
    "SERPINE2 cnv",
    "SERPINE2 methyl",
    "SERPINE2 proteo",
    "SERPINE2 rna"
  ],
  "SERPINE3": [
    "SERPINE3 cnv",
    "SERPINE3 rna"
  ],
  "SERPINF1": [
    "SERPINF1 cnv",
    "SERPINF1 proteo",
    "SERPINF1 rna"
  ],
  "SERPINF2": [
    "SERPINF2 cnv",
    "SERPINF2 proteo",
    "SERPINF2 rna"
  ],
  "SERPING1": [
    "SERPING1 DTFVNASR-N3H4F0S1G0 glyco",
    "SERPING1 DTFVNASR-N4H5F0S1G0 glyco",
    "SERPING1 GVTSVSQIFHSPDLAIRDTFVNASR-N4H5F0S1G0 glyco",
    "SERPING1 GVTSVSQIFHSPDLAIRDTFVNASR-N4H5F0S2G0 glyco",
    "SERPING1 VGQLQLSHNLSLVILVPQNLK-N4H5F0S2G0 glyco",
    "SERPING1 VGQLQLSHNLSLVILVPQNLK-N4H5F2S1G0 glyco",
    "SERPING1 VGQLQLSHNLSLVILVPQNLK-N6H3F5S0G0 glyco",
    "SERPING1 VLSNNSDANLELINTWVAK-N4H5F0S1G0 glyco",
    "SERPING1 VLSNNSDANLELINTWVAK-N4H5F0S2G0 glyco",
    "SERPING1 VLSNNSDANLELINTWVAK-N4H5F1S2G0 glyco",
    "SERPING1 cnv",
    "SERPING1 proteo",
    "SERPING1 rna"
  ],
  "SERPINH1": [
    "SERPINH1 SLSNSTAR-N2H3F0S0G0 glyco",
    "SERPINH1 SLSNSTAR-N2H4F0S0G0 glyco",
    "SERPINH1 SLSNSTAR-N2H5F0S0G0 glyco",
    "SERPINH1 SLSNSTAR-N2H6F0S0G0 glyco",
    "SERPINH1 SLSNSTAR-N2H7F0S0G0 glyco",
    "SERPINH1 SLSNSTAR-N2H8F0S0G0 glyco",
    "SERPINH1 SLSNSTAR-N2H9F0S0G0 glyco",
    "SERPINH1 cnv",
    "SERPINH1 methyl",
    "SERPINH1 proteo",
    "SERPINH1 rna"
  ],
  "SERPINI1": [
    "SERPINI1 cnv",
    "SERPINI1 methyl",
    "SERPINI1 proteo",
    "SERPINI1 rna"
  ],
  "SERPINI2": [
    "SERPINI2 cnv",
    "SERPINI2 rna"
  ],
  "SERTAD1": [
    "SERTAD1 cnv",
    "SERTAD1 methyl",
    "SERTAD1 rna"
  ],
  "SERTAD2": [
    "SERTAD2 cnv",
    "SERTAD2 methyl",
    "SERTAD2 rna"
  ],
  "SERTAD3": [
    "SERTAD3 cnv",
    "SERTAD3 methyl",
    "SERTAD3 rna"
  ],
  "SERTAD4": [
    "SERTAD4 cnv",
    "SERTAD4 methyl",
    "SERTAD4 rna"
  ],
  "SERTM1": [
    "SERTM1 100_107_1_1_S107 phospho",
    "SERTM1 cnv",
    "SERTM1 methyl",
    "SERTM1 rna"
  ],
  "SERTM2": [
    "SERTM2 rna"
  ],
  "SESN1": [
    "SESN1 cnv",
    "SESN1 methyl",
    "SESN1 proteo",
    "SESN1 rna"
  ],
  "SESN2": [
    "SESN2 cnv",
    "SESN2 methyl",
    "SESN2 proteo",
    "SESN2 rna"
  ],
  "SESN3": [
    "SESN3 7_18_1_1_S7 phospho",
    "SESN3 cnv",
    "SESN3 methyl",
    "SESN3 proteo",
    "SESN3 rna"
  ],
  "SESTD1": [
    "SESTD1 cnv",
    "SESTD1 methyl",
    "SESTD1 proteo",
    "SESTD1 rna"
  ],
  "SET": [
    "SET 15_24_1_0 phospho",
    "SET 15_24_1_1_S15 phospho",
    "SET 15_24_1_1_S24 phospho",
    "SET 7_7_1_1_S7 phospho",
    "SET cnv",
    "SET methyl",
    "SET proteo",
    "SET rna"
  ],
  "SETBP1": [
    "SETBP1 cnv",
    "SETBP1 methyl",
    "SETBP1 rna"
  ],
  "SETD1A": [
    "SETD1A 458_464_1_1_S464 phospho",
    "SETD1A 468_490_1_1_S470 phospho",
    "SETD1A 915_916_1_0 phospho",
    "SETD1A 915_916_1_1_T916 phospho",
    "SETD1A cnv",
    "SETD1A methyl",
    "SETD1A proteo",
    "SETD1A rna"
  ],
  "SETD1B": [
    "SETD1B 197_221_1_1_S211 phospho",
    "SETD1B cnv",
    "SETD1B methyl",
    "SETD1B mut",
    "SETD1B proteo",
    "SETD1B rna"
  ],
  "SETD2": [
    "SETD2 1809_1818_1_1_T1809 phospho",
    "SETD2 488_488_1_1_S488 phospho",
    "SETD2 580_582_1_1_S580 phospho",
    "SETD2 698_710_1_1_S700 phospho",
    "SETD2 cnv",
    "SETD2 methyl",
    "SETD2 proteo",
    "SETD2 rna"
  ],
  "SETD3": [
    "SETD3 12_21_1_1_S21 phospho",
    "SETD3 cnv",
    "SETD3 methyl",
    "SETD3 proteo",
    "SETD3 rna"
  ],
  "SETD4": [
    "SETD4 cnv",
    "SETD4 methyl",
    "SETD4 rna"
  ],
  "SETD5": [
    "SETD5 cnv",
    "SETD5 methyl",
    "SETD5 proteo",
    "SETD5 rna"
  ],
  "SETD6": [
    "SETD6 cnv",
    "SETD6 methyl",
    "SETD6 rna"
  ],
  "SETD7": [
    "SETD7 cnv",
    "SETD7 methyl",
    "SETD7 proteo",
    "SETD7 rna"
  ],
  "SETD9": [
    "SETD9 cnv",
    "SETD9 methyl",
    "SETD9 rna"
  ],
  "SETDB1": [
    "SETDB1 cnv",
    "SETDB1 methyl",
    "SETDB1 proteo",
    "SETDB1 rna"
  ],
  "SETDB2": [
    "SETDB2 cnv",
    "SETDB2 methyl",
    "SETDB2 rna"
  ],
  "SETMAR": [
    "SETMAR 369_369_1_1_S369 phospho",
    "SETMAR cnv",
    "SETMAR methyl",
    "SETMAR proteo",
    "SETMAR rna"
  ],
  "SETSIP": [
    "SETSIP cnv",
    "SETSIP rna"
  ],
  "SETX": [
    "SETX 1366_1371_1_1_S1366 phospho",
    "SETX cnv",
    "SETX methyl",
    "SETX proteo",
    "SETX rna"
  ],
  "SEZ6": [
    "SEZ6 cnv",
    "SEZ6 methyl",
    "SEZ6 proteo",
    "SEZ6 rna"
  ],
  "SEZ6L": [
    "SEZ6L cnv",
    "SEZ6L proteo",
    "SEZ6L rna"
  ],
  "SEZ6L2": [
    "SEZ6L2 cnv",
    "SEZ6L2 methyl",
    "SEZ6L2 proteo",
    "SEZ6L2 rna"
  ],
  "SF1": [
    "SF1 112_112_1_1_S112 phospho",
    "SF1 20_26_1_1_S20 phospho",
    "SF1 551_557_1_1_S555 phospho",
    "SF1 67_89_2_2_S80S82 phospho",
    "SF1 80_89_2_2_S80S82 phospho",
    "SF1 cnv",
    "SF1 methyl",
    "SF1 proteo",
    "SF1 rna"
  ],
  "SF3A1": [
    "SF3A1 320_329_1_1_S329 phospho",
    "SF3A1 344_359_1_1_S359 phospho",
    "SF3A1 cnv",
    "SF3A1 methyl",
    "SF3A1 proteo",
    "SF3A1 rna"
  ],
  "SF3A2": [
    "SF3A2 cnv",
    "SF3A2 methyl",
    "SF3A2 proteo",
    "SF3A2 rna"
  ],
  "SF3A3": [
    "SF3A3 cnv",
    "SF3A3 methyl",
    "SF3A3 proteo",
    "SF3A3 rna"
  ],
  "SF3B1": [
    "SF3B1 125_129_1_0 phospho",
    "SF3B1 125_142_2_2_S129T142 phospho",
    "SF3B1 142_142_1_1_T142 phospho",
    "SF3B1 190_194_1_1_S194 phospho",
    "SF3B1 203_211_2_2_T207T211 phospho",
    "SF3B1 216_229_1_1_T223 phospho",
    "SF3B1 216_229_2_2_T223T227 phospho",
    "SF3B1 235_235_1_1_T235 phospho",
    "SF3B1 242_251_1_1_T244 phospho",
    "SF3B1 242_251_2_2_T244T248 phospho",
    "SF3B1 303_316_1_1_T313 phospho",
    "SF3B1 322_332_1_1_T326 phospho",
    "SF3B1 322_332_2_2_T326T328 phospho",
    "SF3B1 341_354_1_1_T350 phospho",
    "SF3B1 421_426_1_1_T426 phospho",
    "SF3B1 cnv",
    "SF3B1 methyl",
    "SF3B1 proteo",
    "SF3B1 rna"
  ],
  "SF3B2": [
    "SF3B2 302_319_1_1_S307 phospho",
    "SF3B2 302_319_1_1_S309 phospho",
    "SF3B2 302_319_2_2_S307S309 phospho",
    "SF3B2 431_436_3_3_S431S435S436 phospho",
    "SF3B2 778_785_1_0 phospho",
    "SF3B2 778_785_1_1_T780 phospho",
    "SF3B2 861_861_1_1_S861 phospho",
    "SF3B2 cnv",
    "SF3B2 methyl",
    "SF3B2 proteo",
    "SF3B2 rna"
  ],
  "SF3B3": [
    "SF3B3 cnv",
    "SF3B3 methyl",
    "SF3B3 proteo",
    "SF3B3 rna"
  ],
  "SF3B4": [
    "SF3B4 cnv",
    "SF3B4 methyl",
    "SF3B4 proteo",
    "SF3B4 rna"
  ],
  "SF3B5": [
    "SF3B5 cnv",
    "SF3B5 methyl",
    "SF3B5 proteo",
    "SF3B5 rna"
  ],
  "SF3B6": [
    "SF3B6 cnv",
    "SF3B6 methyl",
    "SF3B6 proteo",
    "SF3B6 rna"
  ],
  "SFI1": [
    "SFI1 cnv",
    "SFI1 methyl",
    "SFI1 proteo",
    "SFI1 rna"
  ],
  "SFMBT1": [
    "SFMBT1 cnv",
    "SFMBT1 methyl",
    "SFMBT1 rna"
  ],
  "SFMBT2": [
    "SFMBT2 cnv",
    "SFMBT2 methyl",
    "SFMBT2 rna"
  ],
  "SFN": [
    "SFN cnv",
    "SFN proteo",
    "SFN rna"
  ],
  "SFPQ": [
    "SFPQ 225_226_1_1_T226 phospho",
    "SFPQ cnv",
    "SFPQ methyl",
    "SFPQ proteo",
    "SFPQ rna"
  ],
  "SFR1": [
    "SFR1 cnv",
    "SFR1 methyl",
    "SFR1 rna"
  ],
  "SFRP1": [
    "SFRP1 cnv",
    "SFRP1 methyl",
    "SFRP1 proteo",
    "SFRP1 rna"
  ],
  "SFRP2": [
    "SFRP2 cnv",
    "SFRP2 methyl",
    "SFRP2 rna"
  ],
  "SFRP4": [
    "SFRP4 cnv",
    "SFRP4 methyl",
    "SFRP4 proteo",
    "SFRP4 rna"
  ],
  "SFRP5": [
    "SFRP5 cnv",
    "SFRP5 methyl",
    "SFRP5 rna"
  ],
  "SFSWAP": [
    "SFSWAP 279_304_1_1_S283 phospho",
    "SFSWAP 604_610_1_1_S604 phospho",
    "SFSWAP 604_623_1_1_S604 phospho",
    "SFSWAP 884_890_1_1_S886 phospho",
    "SFSWAP cnv",
    "SFSWAP methyl",
    "SFSWAP proteo",
    "SFSWAP rna"
  ],
  "SFT2D1": [
    "SFT2D1 cnv",
    "SFT2D1 methyl",
    "SFT2D1 rna"
  ],
  "SFT2D2": [
    "SFT2D2 9_13_1_1_S9 phospho",
    "SFT2D2 cnv",
    "SFT2D2 methyl",
    "SFT2D2 proteo",
    "SFT2D2 rna"
  ],
  "SFT2D3": [
    "SFT2D3 cnv",
    "SFT2D3 methyl",
    "SFT2D3 proteo",
    "SFT2D3 rna"
  ],
  "SFTA2": [
    "SFTA2 cnv",
    "SFTA2 methyl",
    "SFTA2 rna"
  ],
  "SFTA3": [
    "SFTA3 cnv",
    "SFTA3 methyl"
  ],
  "SFTPA1": [
    "SFTPA1 cnv",
    "SFTPA1 rna"
  ],
  "SFTPA2": [
    "SFTPA2 cnv",
    "SFTPA2 rna"
  ],
  "SFTPB": [
    "SFTPB cnv",
    "SFTPB rna"
  ],
  "SFTPC": [
    "SFTPC cnv",
    "SFTPC methyl",
    "SFTPC rna"
  ],
  "SFTPD": [
    "SFTPD cnv",
    "SFTPD methyl",
    "SFTPD rna"
  ],
  "SFXN1": [
    "SFXN1 cnv",
    "SFXN1 methyl",
    "SFXN1 proteo",
    "SFXN1 rna"
  ],
  "SFXN2": [
    "SFXN2 cnv",
    "SFXN2 methyl",
    "SFXN2 proteo",
    "SFXN2 rna"
  ],
  "SFXN3": [
    "SFXN3 cnv",
    "SFXN3 methyl",
    "SFXN3 proteo",
    "SFXN3 rna"
  ],
  "SFXN4": [
    "SFXN4 cnv",
    "SFXN4 methyl",
    "SFXN4 proteo",
    "SFXN4 rna"
  ],
  "SFXN5": [
    "SFXN5 cnv",
    "SFXN5 methyl",
    "SFXN5 proteo",
    "SFXN5 rna"
  ],
  "SGCA": [
    "SGCA cnv",
    "SGCA rna"
  ],
  "SGCB": [
    "SGCB ITSNATSDLNIK-N2H5F0S0G0 glyco",
    "SGCB ITSNATSDLNIK-N2H8F0S0G0 glyco",
    "SGCB LSVENNK-N2H5F0S0G0 glyco",
    "SGCB LSVENNK-N2H8F0S0G0 glyco",
    "SGCB cnv",
    "SGCB methyl",
    "SGCB proteo",
    "SGCB rna"
  ],
  "SGCD": [
    "SGCD NVTVNILNDQTK-N2H5F0S0G0 glyco",
    "SGCD NVTVNILNDQTK-N2H6F0S0G0 glyco",
    "SGCD cnv",
    "SGCD proteo",
    "SGCD rna"
  ],
  "SGCE": [
    "SGCE LNAINITSALDR-N2H5F0S0G0 glyco",
    "SGCE LNAINITSALDR-N2H6F0S0G0 glyco",
    "SGCE LNAINITSALDR-N2H7F0S0G0 glyco",
    "SGCE cnv",
    "SGCE methyl",
    "SGCE proteo",
    "SGCE rna"
  ],
  "SGCG": [
    "SGCG cnv",
    "SGCG rna"
  ],
  "SGCZ": [
    "SGCZ cnv",
    "SGCZ methyl",
    "SGCZ rna"
  ],
  "SGF29": [
    "SGF29 cnv",
    "SGF29 methyl",
    "SGF29 proteo",
    "SGF29 rna"
  ],
  "SGIP1": [
    "SGIP1 142_151_1_1_S149 phospho",
    "SGIP1 160_160_1_1_S160 phospho",
    "SGIP1 179_187_1_1_T180 phospho",
    "SGIP1 179_187_1_1_T182 phospho",
    "SGIP1 179_187_2_2_T180T182 phospho",
    "SGIP1 214_236_1_1_S236 phospho",
    "SGIP1 227_249_2_1_T227 phospho",
    "SGIP1 240_247_1_1_T247 phospho",
    "SGIP1 259_259_1_1_T259 phospho",
    "SGIP1 259_278_1_0 phospho",
    "SGIP1 259_278_1_1_T259 phospho",
    "SGIP1 259_278_2_0 phospho",
    "SGIP1 259_278_2_1_T259 phospho",
    "SGIP1 259_278_2_2_T259S265 phospho",
    "SGIP1 263_278_1_1_S265 phospho",
    "SGIP1 287_300_1_1_S300 phospho",
    "SGIP1 316_328_1_1_S319 phospho",
    "SGIP1 316_328_2_0 phospho",
    "SGIP1 335_358_1_1_S335 phospho",
    "SGIP1 335_358_2_2_S335T339 phospho",
    "SGIP1 372_372_1_1_S372 phospho",
    "SGIP1 393_399_1_1_S399 phospho",
    "SGIP1 410_419_1_1_T410 phospho",
    "SGIP1 421_448_1_0 phospho",
    "SGIP1 421_448_1_1_S425 phospho",
    "SGIP1 421_448_2_0 phospho",
    "SGIP1 455_467_1_0 phospho",
    "SGIP1 455_467_1_1_T457 phospho",
    "SGIP1 455_467_2_2_T457S467 phospho",
    "SGIP1 482_493_1_1_S493 phospho",
    "SGIP1 482_493_2_0 phospho",
    "SGIP1 482_493_2_2_S486S493 phospho",
    "SGIP1 550_573_1_1_S550 phospho",
    "SGIP1 cnv",
    "SGIP1 methyl",
    "SGIP1 proteo",
    "SGIP1 rna"
  ],
  "SGK1": [
    "SGK1 cnv",
    "SGK1 kinase",
    "SGK1 methyl",
    "SGK1 rna"
  ],
  "SGK2": [
    "SGK2 cnv",
    "SGK2 kinase",
    "SGK2 rna"
  ],
  "SGK3": [
    "SGK3 126_137_2_2_S126S129 phospho",
    "SGK3 cnv",
    "SGK3 kinase",
    "SGK3 methyl",
    "SGK3 rna"
  ],
  "SGMS1": [
    "SGMS1 cnv",
    "SGMS1 methyl",
    "SGMS1 rna"
  ],
  "SGMS2": [
    "SGMS2 cnv",
    "SGMS2 methyl",
    "SGMS2 rna"
  ],
  "SGO1": [
    "SGO1 cnv",
    "SGO1 methyl",
    "SGO1 rna"
  ],
  "SGO2": [
    "SGO2 cnv",
    "SGO2 methyl",
    "SGO2 rna"
  ],
  "SGPL1": [
    "SGPL1 542_564_1_1_S564 phospho",
    "SGPL1 cnv",
    "SGPL1 methyl",
    "SGPL1 proteo",
    "SGPL1 rna"
  ],
  "SGPP1": [
    "SGPP1 112_114_1_1_S112 phospho",
    "SGPP1 cnv",
    "SGPP1 methyl",
    "SGPP1 proteo",
    "SGPP1 rna"
  ],
  "SGPP2": [
    "SGPP2 cnv",
    "SGPP2 methyl",
    "SGPP2 rna"
  ],
  "SGSH": [
    "SGSH cnv",
    "SGSH methyl",
    "SGSH proteo",
    "SGSH rna"
  ],
  "SGSM1": [
    "SGSM1 684_691_1_1_S688 phospho",
    "SGSM1 701_713_1_1_S701 phospho",
    "SGSM1 cnv",
    "SGSM1 methyl",
    "SGSM1 proteo",
    "SGSM1 rna"
  ],
  "SGSM2": [
    "SGSM2 633_640_1_1_S637 phospho",
    "SGSM2 cnv",
    "SGSM2 methyl",
    "SGSM2 rna"
  ],
  "SGSM3": [
    "SGSM3 cnv",
    "SGSM3 methyl",
    "SGSM3 proteo",
    "SGSM3 rna"
  ],
  "SGTA": [
    "SGTA 303_307_1_1_T303 phospho",
    "SGTA 77_77_1_1_S77 phospho",
    "SGTA 77_88_1_1_S77 phospho",
    "SGTA 77_88_2_2_S77T81 phospho",
    "SGTA 77_88_2_2_T81S84 phospho",
    "SGTA cnv",
    "SGTA methyl",
    "SGTA proteo",
    "SGTA rna"
  ],
  "SGTB": [
    "SGTB 293_304_1_1_S295 phospho",
    "SGTB 295_304_1_1_S295 phospho",
    "SGTB 295_304_1_1_S297 phospho",
    "SGTB 75_77_1_1_S77 phospho",
    "SGTB cnv",
    "SGTB methyl",
    "SGTB proteo",
    "SGTB rna"
  ],
  "SH2B1": [
    "SH2B1 123_145_1_0 phospho",
    "SH2B1 123_145_1_1_S125 phospho",
    "SH2B1 125_145_1_1_S125 phospho",
    "SH2B1 215_219_1_1_S219 phospho",
    "SH2B1 cnv",
    "SH2B1 methyl",
    "SH2B1 proteo",
    "SH2B1 rna"
  ],
  "SH2B2": [
    "SH2B2 117_127_1_1_S117 phospho",
    "SH2B2 157_157_1_1_S157 phospho",
    "SH2B2 296_319_1_1_S310 phospho",
    "SH2B2 cnv",
    "SH2B2 methyl",
    "SH2B2 proteo",
    "SH2B2 rna"
  ],
  "SH2B3": [
    "SH2B3 150_172_1_1_S150 phospho",
    "SH2B3 cnv",
    "SH2B3 methyl",
    "SH2B3 rna"
  ],
  "SH2D1A": [
    "SH2D1A rna"
  ],
  "SH2D1B": [
    "SH2D1B cnv",
    "SH2D1B rna"
  ],
  "SH2D2A": [
    "SH2D2A cnv",
    "SH2D2A methyl",
    "SH2D2A rna"
  ],
  "SH2D3A": [
    "SH2D3A cnv",
    "SH2D3A methyl",
    "SH2D3A rna"
  ],
  "SH2D3C": [
    "SH2D3C 169_190_1_1_S185 phospho",
    "SH2D3C 169_190_1_1_S188 phospho",
    "SH2D3C 201_209_1_1_S201 phospho",
    "SH2D3C 275_282_1_1_S282 phospho",
    "SH2D3C 288_297_1_0 phospho",
    "SH2D3C cnv",
    "SH2D3C methyl",
    "SH2D3C proteo",
    "SH2D3C rna"
  ],
  "SH2D4A": [
    "SH2D4A cnv",
    "SH2D4A methyl",
    "SH2D4A proteo",
    "SH2D4A rna"
  ],
  "SH2D4B": [
    "SH2D4B cnv",
    "SH2D4B rna"
  ],
  "SH2D5": [
    "SH2D5 189_197_1_1_S197 phospho",
    "SH2D5 229_233_1_1_S231 phospho",
    "SH2D5 cnv",
    "SH2D5 methyl",
    "SH2D5 proteo",
    "SH2D5 rna"
  ],
  "SH2D6": [
    "SH2D6 cnv",
    "SH2D6 methyl",
    "SH2D6 rna"
  ],
  "SH2D7": [
    "SH2D7 cnv",
    "SH2D7 methyl",
    "SH2D7 rna"
  ],
  "SH3BGR": [
    "SH3BGR cnv",
    "SH3BGR methyl",
    "SH3BGR rna"
  ],
  "SH3BGRL": [
    "SH3BGRL proteo",
    "SH3BGRL rna"
  ],
  "SH3BGRL2": [
    "SH3BGRL2 cnv",
    "SH3BGRL2 methyl",
    "SH3BGRL2 proteo",
    "SH3BGRL2 rna"
  ],
  "SH3BGRL3": [
    "SH3BGRL3 cnv",
    "SH3BGRL3 methyl",
    "SH3BGRL3 proteo",
    "SH3BGRL3 rna"
  ],
  "SH3BP1": [
    "SH3BP1 241_268_1_1_S262 phospho",
    "SH3BP1 262_268_1_1_S262 phospho",
    "SH3BP1 534_544_1_1_S544 phospho",
    "SH3BP1 548_554_1_1_S550 phospho",
    "SH3BP1 585_601_1_0 phospho",
    "SH3BP1 585_601_1_1_S586 phospho",
    "SH3BP1 cnv",
    "SH3BP1 methyl",
    "SH3BP1 proteo",
    "SH3BP1 rna"
  ],
  "SH3BP2": [
    "SH3BP2 225_228_1_1_S225 phospho",
    "SH3BP2 278_287_1_1_S278 phospho",
    "SH3BP2 416_422_1_1_S416 phospho",
    "SH3BP2 435_448_1_1_S444 phospho",
    "SH3BP2 cnv",
    "SH3BP2 methyl",
    "SH3BP2 proteo",
    "SH3BP2 rna"
  ],
  "SH3BP4": [
    "SH3BP4 117_131_1_1_S131 phospho",
    "SH3BP4 244_251_1_1_S246 phospho",
    "SH3BP4 296_317_1_1_S296 phospho",
    "SH3BP4 cnv",
    "SH3BP4 methyl",
    "SH3BP4 proteo",
    "SH3BP4 rna"
  ],
  "SH3BP5": [
    "SH3BP5 cnv",
    "SH3BP5 methyl",
    "SH3BP5 rna"
  ],
  "SH3BP5L": [
    "SH3BP5L 13_44_1_1_S30 phospho",
    "SH3BP5L 358_370_1_1_S362 phospho",
    "SH3BP5L cnv",
    "SH3BP5L methyl",
    "SH3BP5L proteo",
    "SH3BP5L rna"
  ],
  "SH3D19": [
    "SH3D19 367_369_1_1_S369 phospho",
    "SH3D19 cnv",
    "SH3D19 methyl",
    "SH3D19 proteo",
    "SH3D19 rna"
  ],
  "SH3D21": [
    "SH3D21 cnv",
    "SH3D21 methyl",
    "SH3D21 rna"
  ],
  "SH3GL1": [
    "SH3GL1 cnv",
    "SH3GL1 methyl",
    "SH3GL1 proteo",
    "SH3GL1 rna"
  ],
  "SH3GL2": [
    "SH3GL2 262_286_1_0 phospho",
    "SH3GL2 262_286_1_1_S262 phospho",
    "SH3GL2 cnv",
    "SH3GL2 methyl",
    "SH3GL2 proteo",
    "SH3GL2 rna"
  ],
  "SH3GL3": [
    "SH3GL3 263_274_1_0 phospho",
    "SH3GL3 cnv",
    "SH3GL3 methyl",
    "SH3GL3 proteo",
    "SH3GL3 rna"
  ],
  "SH3GLB1": [
    "SH3GLB1 cnv",
    "SH3GLB1 methyl",
    "SH3GLB1 proteo",
    "SH3GLB1 rna"
  ],
  "SH3GLB2": [
    "SH3GLB2 cnv",
    "SH3GLB2 proteo",
    "SH3GLB2 rna"
  ],
  "SH3KBP1": [
    "SH3KBP1 119_134_1_0 phospho",
    "SH3KBP1 136_154_1_0 phospho",
    "SH3KBP1 141_154_1_1_S146 phospho",
    "SH3KBP1 141_154_2_2_S144S146 phospho",
    "SH3KBP1 193_193_1_1_S193 phospho",
    "SH3KBP1 42_51_1_1_S42 phospho",
    "SH3KBP1 456_474_1_1_S474 phospho",
    "SH3KBP1 456_484_1_1_S474 phospho",
    "SH3KBP1 71_72_1_1_Y72 phospho",
    "SH3KBP1 methyl",
    "SH3KBP1 proteo",
    "SH3KBP1 rna"
  ],
  "SH3PXD2A": [
    "SH3PXD2A 1010_1015_1_1_S1010 phospho",
    "SH3PXD2A 351_362_1_1_S351 phospho",
    "SH3PXD2A 511_519_1_1_S519 phospho",
    "SH3PXD2A 790_806_1_0 phospho",
    "SH3PXD2A 790_806_1_1_S790 phospho",
    "SH3PXD2A 974_978_1_1_S974 phospho",
    "SH3PXD2A cnv",
    "SH3PXD2A methyl",
    "SH3PXD2A proteo",
    "SH3PXD2A rna"
  ],
  "SH3PXD2B": [
    "SH3PXD2B 279_304_1_1_S291 phospho",
    "SH3PXD2B 713_720_1_1_S720 phospho",
    "SH3PXD2B 809_818_1_1_S811 phospho",
    "SH3PXD2B cnv",
    "SH3PXD2B methyl",
    "SH3PXD2B proteo",
    "SH3PXD2B rna"
  ],
  "SH3RF1": [
    "SH3RF1 304_309_1_1_S304 phospho",
    "SH3RF1 99_109_1_0 phospho",
    "SH3RF1 cnv",
    "SH3RF1 methyl",
    "SH3RF1 proteo",
    "SH3RF1 rna"
  ],
  "SH3RF2": [
    "SH3RF2 cnv",
    "SH3RF2 methyl",
    "SH3RF2 rna"
  ],
  "SH3RF3": [
    "SH3RF3 381_388_1_0 phospho",
    "SH3RF3 381_388_1_1_S381 phospho",
    "SH3RF3 797_806_1_1_S797 phospho",
    "SH3RF3 cnv",
    "SH3RF3 methyl",
    "SH3RF3 proteo",
    "SH3RF3 rna"
  ],
  "SH3TC1": [
    "SH3TC1 cnv",
    "SH3TC1 rna"
  ],
  "SH3TC2": [
    "SH3TC2 cnv",
    "SH3TC2 rna"
  ],
  "SH3YL1": [
    "SH3YL1 cnv",
    "SH3YL1 methyl",
    "SH3YL1 rna"
  ],
  "SHANK1": [
    "SHANK1 1285_1298_1_1_S1287 phospho",
    "SHANK1 413_413_1_1_S413 phospho",
    "SHANK1 413_416_1_1_S413 phospho",
    "SHANK1 890_900_1_1_S890 phospho",
    "SHANK1 cnv",
    "SHANK1 methyl",
    "SHANK1 proteo",
    "SHANK1 rna"
  ],
  "SHANK2": [
    "SHANK2 1099_1105_1_0 phospho",
    "SHANK2 1709_1715_1_1_S1713 phospho",
    "SHANK2 1709_1715_2_2_S1709S1713 phospho",
    "SHANK2 444_455_1_1_S446 phospho",
    "SHANK2 473_477_1_1_S475 phospho",
    "SHANK2 825_831_1_1_S831 phospho",
    "SHANK2 959_968_1_1_S960 phospho",
    "SHANK2 cnv",
    "SHANK2 methyl",
    "SHANK2 proteo",
    "SHANK2 rna"
  ],
  "SHANK3": [
    "SHANK3 1127_1133_1_1_S1133 phospho",
    "SHANK3 1234_1253_1_1_S1253 phospho",
    "SHANK3 1234_1253_1_1_T1234 phospho",
    "SHANK3 1234_1253_2_2_T1234S1253 phospho",
    "SHANK3 1577_1583_1_1_S1577 phospho",
    "SHANK3 373_392_1_1_S375 phospho",
    "SHANK3 373_392_2_2_S375S388 phospho",
    "SHANK3 483_483_1_1_S483 phospho",
    "SHANK3 782_782_1_1_S782 phospho",
    "SHANK3 cnv",
    "SHANK3 methyl",
    "SHANK3 proteo",
    "SHANK3 rna"
  ],
  "SHARPIN": [
    "SHARPIN 129_152_1_1_S131 phospho",
    "SHARPIN 309_312_1_1_S312 phospho",
    "SHARPIN cnv",
    "SHARPIN methyl",
    "SHARPIN proteo",
    "SHARPIN rna"
  ],
  "SHB": [
    "SHB 388_388_1_1_S388 phospho",
    "SHB cnv",
    "SHB methyl",
    "SHB proteo",
    "SHB rna"
  ],
  "SHBG": [
    "SHBG LDVDQALNR-N4H5F0S2G0 glyco",
    "SHBG cnv",
    "SHBG methyl",
    "SHBG proteo",
    "SHBG rna"
  ],
  "SHC1": [
    "SHC1 cnv",
    "SHC1 methyl",
    "SHC1 proteo",
    "SHC1 rna"
  ],
  "SHC2": [
    "SHC2 414_428_1_1_S428 phospho",
    "SHC2 cnv",
    "SHC2 methyl",
    "SHC2 rna"
  ],
  "SHC3": [
    "SHC3 324_347_1_1_S324 phospho",
    "SHC3 474_482_1_1_S479 phospho",
    "SHC3 474_482_1_1_S482 phospho",
    "SHC3 474_482_2_2_S474S479 phospho",
    "SHC3 474_482_2_2_S479S482 phospho",
    "SHC3 524_534_1_1_T526 phospho",
    "SHC3 97_114_1_1_S101 phospho",
    "SHC3 cnv",
    "SHC3 proteo",
    "SHC3 rna"
  ],
  "SHC4": [
    "SHC4 cnv",
    "SHC4 methyl",
    "SHC4 proteo",
    "SHC4 rna"
  ],
  "SHCBP1": [
    "SHCBP1 cnv",
    "SHCBP1 methyl",
    "SHCBP1 rna"
  ],
  "SHCBP1L": [
    "SHCBP1L cnv",
    "SHCBP1L methyl",
    "SHCBP1L rna"
  ],
  "SHD": [
    "SHD cnv",
    "SHD methyl",
    "SHD proteo",
    "SHD rna"
  ],
  "SHE": [
    "SHE cnv",
    "SHE methyl",
    "SHE rna"
  ],
  "SHF": [
    "SHF 135_135_1_1_S135 phospho",
    "SHF cnv",
    "SHF methyl",
    "SHF proteo",
    "SHF rna"
  ],
  "SHFL": [
    "SHFL cnv",
    "SHFL methyl",
    "SHFL proteo",
    "SHFL rna"
  ],
  "SHH": [
    "SHH cnv",
    "SHH methyl",
    "SHH rna"
  ],
  "SHISA2": [
    "SHISA2 cnv",
    "SHISA2 methyl",
    "SHISA2 rna"
  ],
  "SHISA3": [
    "SHISA3 cnv",
    "SHISA3 methyl",
    "SHISA3 rna"
  ],
  "SHISA4": [
    "SHISA4 cnv",
    "SHISA4 methyl",
    "SHISA4 proteo",
    "SHISA4 rna"
  ],
  "SHISA5": [
    "SHISA5 cnv",
    "SHISA5 methyl",
    "SHISA5 proteo",
    "SHISA5 rna"
  ],
  "SHISA6": [
    "SHISA6 cnv",
    "SHISA6 methyl",
    "SHISA6 proteo",
    "SHISA6 rna"
  ],
  "SHISA7": [
    "SHISA7 284_295_1_1_S284 phospho",
    "SHISA7 409_417_1_1_S417 phospho",
    "SHISA7 512_512_1_1_T512 phospho",
    "SHISA7 cnv",
    "SHISA7 methyl",
    "SHISA7 proteo",
    "SHISA7 rna"
  ],
  "SHISA8": [
    "SHISA8 cnv",
    "SHISA8 methyl",
    "SHISA8 rna"
  ],
  "SHISA9": [
    "SHISA9 337_337_1_1_S337 phospho",
    "SHISA9 cnv",
    "SHISA9 methyl",
    "SHISA9 proteo",
    "SHISA9 rna"
  ],
  "SHISAL1": [
    "SHISAL1 cnv",
    "SHISAL1 rna"
  ],
  "SHISAL2A": [
    "SHISAL2A cnv",
    "SHISAL2A methyl",
    "SHISAL2A rna"
  ],
  "SHISAL2B": [
    "SHISAL2B cnv",
    "SHISAL2B methyl",
    "SHISAL2B rna"
  ],
  "SHKBP1": [
    "SHKBP1 cnv",
    "SHKBP1 methyl",
    "SHKBP1 proteo",
    "SHKBP1 rna"
  ],
  "SHLD1": [
    "SHLD1 cnv",
    "SHLD1 rna"
  ],
  "SHLD2": [
    "SHLD2 cnv",
    "SHLD2 methyl",
    "SHLD2 rna"
  ],
  "SHLD3": [
    "SHLD3 cnv",
    "SHLD3 methyl",
    "SHLD3 rna"
  ],
  "SHMT1": [
    "SHMT1 cnv",
    "SHMT1 methyl",
    "SHMT1 proteo",
    "SHMT1 rna"
  ],
  "SHMT2": [
    "SHMT2 cnv",
    "SHMT2 methyl",
    "SHMT2 proteo",
    "SHMT2 rna"
  ],
  "SHOC1": [
    "SHOC1 cnv",
    "SHOC1 methyl",
    "SHOC1 rna"
  ],
  "SHOC2": [
    "SHOC2 cnv",
    "SHOC2 methyl",
    "SHOC2 proteo",
    "SHOC2 rna"
  ],
  "SHOX": [
    "SHOX rna"
  ],
  "SHOX2": [
    "SHOX2 cnv",
    "SHOX2 methyl",
    "SHOX2 rna"
  ],
  "SHPK": [
    "SHPK cnv",
    "SHPK methyl",
    "SHPK proteo",
    "SHPK rna"
  ],
  "SHPRH": [
    "SHPRH cnv",
    "SHPRH methyl",
    "SHPRH proteo",
    "SHPRH rna"
  ],
  "SHQ1": [
    "SHQ1 cnv",
    "SHQ1 methyl",
    "SHQ1 rna"
  ],
  "SHROOM1": [
    "SHROOM1 cnv",
    "SHROOM1 methyl",
    "SHROOM1 rna"
  ],
  "SHROOM2": [
    "SHROOM2 1036_1039_1_1_S1036 phospho",
    "SHROOM2 1171_1173_1_1_S1173 phospho",
    "SHROOM2 1217_1219_1_1_S1219 phospho",
    "SHROOM2 1296_1303_1_1_S1297 phospho",
    "SHROOM2 193_204_1_1_S193 phospho",
    "SHROOM2 778_779_1_1_S779 phospho",
    "SHROOM2 845_856_1_1_S847 phospho",
    "SHROOM2 974_983_1_1_S974 phospho",
    "SHROOM2 methyl",
    "SHROOM2 proteo",
    "SHROOM2 rna"
  ],
  "SHROOM3": [
    "SHROOM3 1012_1012_1_1_T1012 phospho",
    "SHROOM3 1441_1447_1_1_S1441 phospho",
    "SHROOM3 1490_1504_1_1_S1497 phospho",
    "SHROOM3 910_921_1_1_S910 phospho",
    "SHROOM3 cnv",
    "SHROOM3 methyl",
    "SHROOM3 proteo",
    "SHROOM3 rna"
  ],
  "SHROOM4": [
    "SHROOM4 1059_1070_1_1_S1059 phospho",
    "SHROOM4 282_286_1_1_S282 phospho",
    "SHROOM4 299_299_1_1_S299 phospho",
    "SHROOM4 377_388_1_1_S378 phospho",
    "SHROOM4 686_700_1_1_S686 phospho",
    "SHROOM4 methyl",
    "SHROOM4 proteo",
    "SHROOM4 rna"
  ],
  "SHTN1": [
    "SHTN1 249_256_1_1_S249 phospho",
    "SHTN1 487_504_1_1_S494 phospho",
    "SHTN1 506_517_1_1_S506 phospho",
    "SHTN1 cnv",
    "SHTN1 methyl",
    "SHTN1 proteo",
    "SHTN1 rna"
  ],
  "SI": [
    "SI cnv"
  ],
  "SIAE": [
    "SIAE cnv",
    "SIAE methyl",
    "SIAE proteo",
    "SIAE rna"
  ],
  "SIAH1": [
    "SIAH1 cnv",
    "SIAH1 methyl",
    "SIAH1 proteo",
    "SIAH1 rna"
  ],
  "SIAH2": [
    "SIAH2 cnv",
    "SIAH2 methyl",
    "SIAH2 rna"
  ],
  "SIAH3": [
    "SIAH3 cnv",
    "SIAH3 rna"
  ],
  "SIDT1": [
    "SIDT1 cnv",
    "SIDT1 methyl",
    "SIDT1 rna"
  ],
  "SIDT2": [
    "SIDT2 cnv",
    "SIDT2 methyl",
    "SIDT2 proteo",
    "SIDT2 rna"
  ],
  "SIGIRR": [
    "SIGIRR cnv",
    "SIGIRR methyl",
    "SIGIRR rna"
  ],
  "SIGLEC1": [
    "SIGLEC1 cnv",
    "SIGLEC1 proteo",
    "SIGLEC1 rna"
  ],
  "SIGLEC10": [
    "SIGLEC10 cnv",
    "SIGLEC10 proteo",
    "SIGLEC10 rna"
  ],
  "SIGLEC11": [
    "SIGLEC11 cnv",
    "SIGLEC11 rna"
  ],
  "SIGLEC12": [
    "SIGLEC12 cnv",
    "SIGLEC12 rna"
  ],
  "SIGLEC14": [
    "SIGLEC14 cnv",
    "SIGLEC14 rna"
  ],
  "SIGLEC15": [
    "SIGLEC15 cnv",
    "SIGLEC15 methyl",
    "SIGLEC15 rna"
  ],
  "SIGLEC16": [
    "SIGLEC16 cnv",
    "SIGLEC16 rna"
  ],
  "SIGLEC5": [
    "SIGLEC5 cnv",
    "SIGLEC5 rna"
  ],
  "SIGLEC6": [
    "SIGLEC6 cnv",
    "SIGLEC6 rna"
  ],
  "SIGLEC7": [
    "SIGLEC7 cnv",
    "SIGLEC7 rna"
  ],
  "SIGLEC8": [
    "SIGLEC8 319_328_1_1_S319 phospho",
    "SIGLEC8 cnv",
    "SIGLEC8 rna"
  ],
  "SIGLEC9": [
    "SIGLEC9 cnv",
    "SIGLEC9 proteo",
    "SIGLEC9 rna"
  ],
  "SIGLECL1": [
    "SIGLECL1 cnv"
  ],
  "SIGMAR1": [
    "SIGMAR1 cnv",
    "SIGMAR1 methyl",
    "SIGMAR1 proteo",
    "SIGMAR1 rna"
  ],
  "SIK1": [
    "SIK1 cnv",
    "SIK1 kinase",
    "SIK1 methyl",
    "SIK1 rna"
  ],
  "SIK1B": [
    "SIK1B cnv",
    "SIK1B rna"
  ],
  "SIK2": [
    "SIK2 358_364_1_1_S358 phospho",
    "SIK2 484_489_1_1_T484 phospho",
    "SIK2 576_579_1_1_S576 phospho",
    "SIK2 587_592_1_1_S587 phospho",
    "SIK2 cnv",
    "SIK2 kinase",
    "SIK2 methyl",
    "SIK2 proteo",
    "SIK2 rna"
  ],
  "SIK3": [
    "SIK3 1012_1040_1_0 phospho",
    "SIK3 1157_1175_1_1_T1157 phospho",
    "SIK3 503_503_1_1_S503 phospho",
    "SIK3 626_631_1_1_S626 phospho",
    "SIK3 730_731_1_1_S731 phospho",
    "SIK3 866_874_1_1_S866 phospho",
    "SIK3 918_923_1_1_S918 phospho",
    "SIK3 cnv",
    "SIK3 kinase",
    "SIK3 methyl",
    "SIK3 proteo",
    "SIK3 rna"
  ],
  "SIKE1": [
    "SIKE1 cnv",
    "SIKE1 methyl",
    "SIKE1 proteo",
    "SIKE1 rna"
  ],
  "SIL1": [
    "SIL1 cnv",
    "SIL1 methyl",
    "SIL1 proteo",
    "SIL1 rna"
  ],
  "SIM1": [
    "SIM1 cnv",
    "SIM1 methyl",
    "SIM1 rna"
  ],
  "SIM2": [
    "SIM2 cnv",
    "SIM2 methyl",
    "SIM2 rna"
  ],
  "SIMC1": [
    "SIMC1 cnv",
    "SIMC1 methyl",
    "SIMC1 rna"
  ],
  "SIN3A": [
    "SIN3A 1105_1112_1_1_S1112 phospho",
    "SIN3A 277_310_1_1_S277 phospho",
    "SIN3A 277_310_2_2_S277T284 phospho",
    "SIN3A 832_848_1_1_S832 phospho",
    "SIN3A cnv",
    "SIN3A methyl",
    "SIN3A proteo",
    "SIN3A rna"
  ],
  "SIN3B": [
    "SIN3B 262_266_1_1_T262 phospho",
    "SIN3B 707_708_1_1_S708 phospho",
    "SIN3B cnv",
    "SIN3B methyl",
    "SIN3B proteo",
    "SIN3B rna"
  ],
  "SINHCAF": [
    "SINHCAF cnv",
    "SINHCAF methyl",
    "SINHCAF rna"
  ],
  "SIPA1": [
    "SIPA1 1036_1038_1_1_S1036 phospho",
    "SIPA1 53_67_2_2_S55S67 phospho",
    "SIPA1 817_817_1_1_S817 phospho",
    "SIPA1 829_839_1_1_S839 phospho",
    "SIPA1 867_888_1_1_S884 phospho",
    "SIPA1 cnv",
    "SIPA1 methyl",
    "SIPA1 proteo",
    "SIPA1 rna"
  ],
  "SIPA1L1": [
    "SIPA1L1 1144_1166_1_1_S1149 phospho",
    "SIPA1L1 1170_1178_1_1_S1170 phospho",
    "SIPA1L1 1200_1225_1_1_S1207 phospho",
    "SIPA1L1 1249_1249_1_1_S1249 phospho",
    "SIPA1L1 1344_1350_1_1_S1346 phospho",
    "SIPA1L1 1391_1407_1_0 phospho",
    "SIPA1L1 1391_1407_1_1_S1391 phospho",
    "SIPA1L1 1410_1418_1_1_S1412 phospho",
    "SIPA1L1 1507_1512_1_1_S1507 phospho",
    "SIPA1L1 1528_1533_1_1_S1528 phospho",
    "SIPA1L1 1543_1555_1_1_S1547 phospho",
    "SIPA1L1 159_162_1_0 phospho",
    "SIPA1L1 159_162_1_1_S162 phospho",
    "SIPA1L1 1611_1613_1_1_S1611 phospho",
    "SIPA1L1 1712_1718_1_1_S1713 phospho",
    "SIPA1L1 310_326_1_1_S318 phospho",
    "SIPA1L1 cnv",
    "SIPA1L1 methyl",
    "SIPA1L1 proteo",
    "SIPA1L1 rna"
  ],
  "SIPA1L2": [
    "SIPA1L2 1029_1029_1_1_S1029 phospho",
    "SIPA1L2 1538_1541_1_1_S1538 phospho",
    "SIPA1L2 160_184_1_1_S162 phospho",
    "SIPA1L2 1645_1655_2_2_S1650S1652 phospho",
    "SIPA1L2 1650_1655_1_1_S1652 phospho",
    "SIPA1L2 cnv",
    "SIPA1L2 methyl",
    "SIPA1L2 proteo",
    "SIPA1L2 rna"
  ],
  "SIPA1L3": [
    "SIPA1L3 1364_1373_1_1_S1364 phospho",
    "SIPA1L3 146_146_1_1_S146 phospho",
    "SIPA1L3 170_177_1_1_S172 phospho",
    "SIPA1L3 cnv",
    "SIPA1L3 methyl",
    "SIPA1L3 proteo",
    "SIPA1L3 rna"
  ],
  "SIRPA": [
    "SIRPA 404_408_1_1_S407 phospho",
    "SIRPA 421_429_1_1_T421 phospho",
    "SIRPA 451_470_1_0 phospho",
    "SIRPA 492_498_1_1_Y496 phospho",
    "SIRPA AENQVNVTCQVR-N2H4F0S0G0 glyco",
    "SIRPA AENQVNVTCQVR-N2H5F0S0G0 glyco",
    "SIRPA AENQVNVTCQVR-N2H6F0S0G0 glyco",
    "SIRPA AENQVNVTCQVR-N2H7F0S0G0 glyco",
    "SIRPA AENQVNVTCQVR-N3H6F0S1G0 glyco",
    "SIRPA GTANLSETIR-N5H3F1S0G0 glyco",
    "SIRPA IGNITPADAGTYYCVK-N4H3F1S0G0 glyco",
    "SIRPA IGNITPADAGTYYCVK-N5H3F1S0G0 glyco",
    "SIRPA IGNITPADAGTYYCVK-N5H4F2S0G0 glyco",
    "SIRPA IGNITPADAGTYYCVK-N5H5F1S1G0 glyco",
    "SIRPA IGNITPADAGTYYCVK-N6H3F1S0G0 glyco",
    "SIRPA IGNITPADAGTYYCVK-N6H4F2S0G0 glyco",
    "SIRPA IGNITPADAGTYYCVK-N6H5F1S1G0 glyco",
    "SIRPA IGNITPADAGTYYCVK-N6H6F2S1G0 glyco",
    "SIRPA VPPTLEVTQQPVRAENQVNVTCQVR-N2H5F0S0G0 glyco",
    "SIRPA VPPTLEVTQQPVRAENQVNVTCQVR-N2H7F0S0G0 glyco",
    "SIRPA cnv",
    "SIRPA methyl",
    "SIRPA proteo",
    "SIRPA rna"
  ],
  "SIRPB1": [
    "SIRPB1 cnv",
    "SIRPB1 rna"
  ],
  "SIRPB2": [
    "SIRPB2 cnv",
    "SIRPB2 rna"
  ],
  "SIRPD": [
    "SIRPD cnv",
    "SIRPD rna"
  ],
  "SIRPG": [
    "SIRPG cnv",
    "SIRPG rna"
  ],
  "SIRT1": [
    "SIRT1 26_27_1_1_S27 phospho",
    "SIRT1 47_47_1_1_S47 phospho",
    "SIRT1 cnv",
    "SIRT1 methyl",
    "SIRT1 proteo",
    "SIRT1 rna"
  ],
  "SIRT2": [
    "SIRT2 351_368_1_0 phospho",
    "SIRT2 351_368_1_1_S368 phospho",
    "SIRT2 372_372_1_1_S372 phospho",
    "SIRT2 cnv",
    "SIRT2 methyl",
    "SIRT2 proteo",
    "SIRT2 rna"
  ],
  "SIRT3": [
    "SIRT3 cnv",
    "SIRT3 methyl",
    "SIRT3 proteo",
    "SIRT3 rna"
  ],
  "SIRT4": [
    "SIRT4 cnv",
    "SIRT4 rna"
  ],
  "SIRT5": [
    "SIRT5 cnv",
    "SIRT5 methyl",
    "SIRT5 proteo",
    "SIRT5 rna"
  ],
  "SIRT6": [
    "SIRT6 267_267_1_1_T267 phospho",
    "SIRT6 276_283_1_1_S276 phospho",
    "SIRT6 283_303_1_1_S303 phospho",
    "SIRT6 299_303_1_1_S303 phospho",
    "SIRT6 cnv",
    "SIRT6 methyl",
    "SIRT6 proteo",
    "SIRT6 rna"
  ],
  "SIRT7": [
    "SIRT7 cnv",
    "SIRT7 methyl",
    "SIRT7 rna"
  ],
  "SIT1": [
    "SIT1 cnv",
    "SIT1 rna"
  ],
  "SIVA1": [
    "SIVA1 cnv",
    "SIVA1 methyl",
    "SIVA1 rna"
  ],
  "SIX1": [
    "SIX1 cnv",
    "SIX1 methyl",
    "SIX1 rna"
  ],
  "SIX2": [
    "SIX2 cnv",
    "SIX2 methyl",
    "SIX2 rna"
  ],
  "SIX3": [
    "SIX3 cnv",
    "SIX3 rna"
  ],
  "SIX3-AS1": [
    "SIX3-AS1 methyl"
  ],
  "SIX4": [
    "SIX4 cnv",
    "SIX4 methyl",
    "SIX4 rna"
  ],
  "SIX5": [
    "SIX5 cnv",
    "SIX5 methyl",
    "SIX5 rna"
  ],
  "SIX6": [
    "SIX6 cnv",
    "SIX6 methyl",
    "SIX6 rna"
  ],
  "SKA1": [
    "SKA1 cnv",
    "SKA1 methyl",
    "SKA1 rna"
  ],
  "SKA2": [
    "SKA2 cnv",
    "SKA2 methyl",
    "SKA2 proteo",
    "SKA2 rna"
  ],
  "SKA3": [
    "SKA3 152_159_1_1_S155 phospho",
    "SKA3 cnv",
    "SKA3 methyl",
    "SKA3 rna"
  ],
  "SKAP1": [
    "SKAP1 cnv",
    "SKAP1 rna"
  ],
  "SKAP2": [
    "SKAP2 283_291_1_1_S283 phospho",
    "SKAP2 283_291_2_2_S283S286 phospho",
    "SKAP2 5_11_1_1_T7 phospho",
    "SKAP2 cnv",
    "SKAP2 methyl",
    "SKAP2 proteo",
    "SKAP2 rna"
  ],
  "SKI": [
    "SKI 336_347_1_1_S343 phospho",
    "SKI 377_389_1_1_S383 phospho",
    "SKI cnv",
    "SKI methyl",
    "SKI proteo",
    "SKI rna"
  ],
  "SKIDA1": [
    "SKIDA1 cnv",
    "SKIDA1 methyl",
    "SKIDA1 rna"
  ],
  "SKIL": [
    "SKIL cnv",
    "SKIL methyl",
    "SKIL rna"
  ],
  "SKIV2L": [
    "SKIV2L 255_256_1_1_S256 phospho",
    "SKIV2L cnv",
    "SKIV2L methyl",
    "SKIV2L proteo",
    "SKIV2L rna"
  ],
  "SKOR1": [
    "SKOR1 cnv",
    "SKOR1 methyl",
    "SKOR1 rna"
  ],
  "SKOR2": [
    "SKOR2 cnv",
    "SKOR2 methyl",
    "SKOR2 rna"
  ],
  "SKP1": [
    "SKP1 cnv",
    "SKP1 methyl",
    "SKP1 proteo",
    "SKP1 rna"
  ],
  "SKP2": [
    "SKP2 cnv",
    "SKP2 methyl",
    "SKP2 rna"
  ],
  "SLA": [
    "SLA cnv",
    "SLA rna"
  ],
  "SLA2": [
    "SLA2 cnv",
    "SLA2 rna"
  ],
  "SLAIN1": [
    "SLAIN1 287_302_1_1_S289 phospho",
    "SLAIN1 cnv",
    "SLAIN1 methyl",
    "SLAIN1 proteo",
    "SLAIN1 rna"
  ],
  "SLAIN2": [
    "SLAIN2 35_48_1_1_S48 phospho",
    "SLAIN2 373_383_1_1_S377 phospho",
    "SLAIN2 430_435_1_1_S433 phospho",
    "SLAIN2 cnv",
    "SLAIN2 methyl",
    "SLAIN2 proteo",
    "SLAIN2 rna"
  ],
  "SLAMF1": [
    "SLAMF1 cnv",
    "SLAMF1 rna"
  ],
  "SLAMF6": [
    "SLAMF6 cnv",
    "SLAMF6 rna"
  ],
  "SLAMF7": [
    "SLAMF7 cnv",
    "SLAMF7 rna"
  ],
  "SLAMF8": [
    "SLAMF8 cnv",
    "SLAMF8 rna"
  ],
  "SLAMF9": [
    "SLAMF9 cnv",
    "SLAMF9 rna"
  ],
  "SLBP": [
    "SLBP 20_23_2_2_S20S23 phospho",
    "SLBP cnv",
    "SLBP methyl",
    "SLBP rna"
  ],
  "SLC10A1": [
    "SLC10A1 cnv",
    "SLC10A1 rna"
  ],
  "SLC10A2": [
    "SLC10A2 cnv",
    "SLC10A2 rna"
  ],
  "SLC10A3": [
    "SLC10A3 methyl",
    "SLC10A3 rna"
  ],
  "SLC10A4": [
    "SLC10A4 cnv",
    "SLC10A4 methyl",
    "SLC10A4 proteo",
    "SLC10A4 rna"
  ],
  "SLC10A5": [
    "SLC10A5 cnv",
    "SLC10A5 rna"
  ],
  "SLC10A6": [
    "SLC10A6 cnv",
    "SLC10A6 rna"
  ],
  "SLC10A7": [
    "SLC10A7 cnv",
    "SLC10A7 methyl",
    "SLC10A7 rna"
  ],
  "SLC11A1": [
    "SLC11A1 cnv",
    "SLC11A1 rna"
  ],
  "SLC11A2": [
    "SLC11A2 cnv",
    "SLC11A2 methyl",
    "SLC11A2 rna"
  ],
  "SLC12A1": [
    "SLC12A1 cnv",
    "SLC12A1 methyl",
    "SLC12A1 rna"
  ],
  "SLC12A2": [
    "SLC12A2 cnv",
    "SLC12A2 methyl",
    "SLC12A2 proteo",
    "SLC12A2 rna"
  ],
  "SLC12A2-DT": [
    "SLC12A2-DT methyl"
  ],
  "SLC12A3": [
    "SLC12A3 cnv",
    "SLC12A3 rna"
  ],
  "SLC12A4": [
    "SLC12A4 958_967_1_1_S961 phospho",
    "SLC12A4 cnv",
    "SLC12A4 methyl",
    "SLC12A4 proteo",
    "SLC12A4 rna"
  ],
  "SLC12A5": [
    "SLC12A5 1045_1049_1_1_S1045 phospho",
    "SLC12A5 cnv",
    "SLC12A5 methyl",
    "SLC12A5 proteo",
    "SLC12A5 rna"
  ],
  "SLC12A5-AS1": [
    "SLC12A5-AS1 methyl"
  ],
  "SLC12A6": [
    "SLC12A6 1019_1032_1_1_S1023 phospho",
    "SLC12A6 1039_1041_1_1_T1039 phospho",
    "SLC12A6 9_28_1_0 phospho",
    "SLC12A6 cnv",
    "SLC12A6 methyl",
    "SLC12A6 proteo",
    "SLC12A6 rna"
  ],
  "SLC12A7": [
    "SLC12A7 25_40_1_1_T30 phospho",
    "SLC12A7 cnv",
    "SLC12A7 methyl",
    "SLC12A7 proteo",
    "SLC12A7 rna"
  ],
  "SLC12A8": [
    "SLC12A8 cnv",
    "SLC12A8 methyl",
    "SLC12A8 rna"
  ],
  "SLC12A9": [
    "SLC12A9 cnv",
    "SLC12A9 methyl",
    "SLC12A9 mut",
    "SLC12A9 proteo",
    "SLC12A9 rna"
  ],
  "SLC12A9-AS1": [
    "SLC12A9-AS1 methyl"
  ],
  "SLC13A1": [
    "SLC13A1 cnv",
    "SLC13A1 rna"
  ],
  "SLC13A2": [
    "SLC13A2 cnv",
    "SLC13A2 rna"
  ],
  "SLC13A3": [
    "SLC13A3 126_133_1_1_S129 phospho",
    "SLC13A3 cnv",
    "SLC13A3 rna"
  ],
  "SLC13A4": [
    "SLC13A4 cnv",
    "SLC13A4 rna"
  ],
  "SLC13A5": [
    "SLC13A5 cnv",
    "SLC13A5 methyl",
    "SLC13A5 rna"
  ],
  "SLC14A1": [
    "SLC14A1 cnv",
    "SLC14A1 proteo",
    "SLC14A1 rna"
  ],
  "SLC14A2": [
    "SLC14A2 cnv",
    "SLC14A2 rna"
  ],
  "SLC15A1": [
    "SLC15A1 cnv",
    "SLC15A1 methyl",
    "SLC15A1 rna"
  ],
  "SLC15A2": [
    "SLC15A2 cnv",
    "SLC15A2 proteo",
    "SLC15A2 rna"
  ],
  "SLC15A3": [
    "SLC15A3 cnv",
    "SLC15A3 methyl",
    "SLC15A3 rna"
  ],
  "SLC15A4": [
    "SLC15A4 cnv",
    "SLC15A4 methyl",
    "SLC15A4 proteo",
    "SLC15A4 rna"
  ],
  "SLC15A5": [
    "SLC15A5 cnv",
    "SLC15A5 rna"
  ],
  "SLC16A1": [
    "SLC16A1 461_478_1_1_S467 phospho",
    "SLC16A1 466_478_1_1_S467 phospho",
    "SLC16A1 489_498_1_1_S498 phospho",
    "SLC16A1 cnv",
    "SLC16A1 methyl",
    "SLC16A1 proteo",
    "SLC16A1 rna"
  ],
  "SLC16A1-AS1": [
    "SLC16A1-AS1 methyl"
  ],
  "SLC16A10": [
    "SLC16A10 cnv",
    "SLC16A10 methyl",
    "SLC16A10 rna"
  ],
  "SLC16A11": [
    "SLC16A11 cnv",
    "SLC16A11 methyl",
    "SLC16A11 rna"
  ],
  "SLC16A12": [
    "SLC16A12 cnv",
    "SLC16A12 methyl",
    "SLC16A12 rna"
  ],
  "SLC16A13": [
    "SLC16A13 cnv",
    "SLC16A13 methyl",
    "SLC16A13 rna"
  ],
  "SLC16A14": [
    "SLC16A14 cnv",
    "SLC16A14 methyl",
    "SLC16A14 rna"
  ],
  "SLC16A2": [
    "SLC16A2 80_85_1_1_T80 phospho",
    "SLC16A2 methyl",
    "SLC16A2 proteo",
    "SLC16A2 rna"
  ],
  "SLC16A3": [
    "SLC16A3 cnv",
    "SLC16A3 methyl",
    "SLC16A3 proteo",
    "SLC16A3 rna"
  ],
  "SLC16A4": [
    "SLC16A4 cnv",
    "SLC16A4 proteo",
    "SLC16A4 rna"
  ],
  "SLC16A5": [
    "SLC16A5 cnv",
    "SLC16A5 methyl",
    "SLC16A5 rna"
  ],
  "SLC16A6": [
    "SLC16A6 cnv",
    "SLC16A6 methyl",
    "SLC16A6 rna"
  ],
  "SLC16A7": [
    "SLC16A7 cnv",
    "SLC16A7 methyl",
    "SLC16A7 proteo",
    "SLC16A7 rna"
  ],
  "SLC16A8": [
    "SLC16A8 cnv",
    "SLC16A8 rna"
  ],
  "SLC16A9": [
    "SLC16A9 cnv",
    "SLC16A9 methyl",
    "SLC16A9 rna"
  ],
  "SLC17A1": [
    "SLC17A1 cnv",
    "SLC17A1 rna"
  ],
  "SLC17A2": [
    "SLC17A2 cnv"
  ],
  "SLC17A3": [
    "SLC17A3 cnv",
    "SLC17A3 methyl",
    "SLC17A3 rna"
  ],
  "SLC17A4": [
    "SLC17A4 cnv"
  ],
  "SLC17A5": [
    "SLC17A5 cnv",
    "SLC17A5 methyl",
    "SLC17A5 proteo",
    "SLC17A5 rna"
  ],
  "SLC17A6": [
    "SLC17A6 cnv",
    "SLC17A6 rna"
  ],
  "SLC17A7": [
    "SLC17A7 cnv",
    "SLC17A7 methyl",
    "SLC17A7 proteo",
    "SLC17A7 rna"
  ],
  "SLC17A8": [
    "SLC17A8 cnv",
    "SLC17A8 rna"
  ],
  "SLC17A9": [
    "SLC17A9 cnv",
    "SLC17A9 methyl",
    "SLC17A9 rna"
  ],
  "SLC18A1": [
    "SLC18A1 cnv",
    "SLC18A1 rna"
  ],
  "SLC18A2": [
    "SLC18A2 cnv",
    "SLC18A2 rna"
  ],
  "SLC18A3": [
    "SLC18A3 cnv",
    "SLC18A3 methyl",
    "SLC18A3 rna"
  ],
  "SLC18B1": [
    "SLC18B1 436_444_1_1_S438 phospho",
    "SLC18B1 cnv",
    "SLC18B1 methyl",
    "SLC18B1 rna"
  ],
  "SLC19A1": [
    "SLC19A1 cnv",
    "SLC19A1 methyl",
    "SLC19A1 rna"
  ],
  "SLC19A2": [
    "SLC19A2 cnv",
    "SLC19A2 methyl",
    "SLC19A2 rna"
  ],
  "SLC19A3": [
    "SLC19A3 210_241_1_1_S210 phospho",
    "SLC19A3 210_241_1_1_S212 phospho",
    "SLC19A3 cnv",
    "SLC19A3 methyl",
    "SLC19A3 rna"
  ],
  "SLC1A1": [
    "SLC1A1 cnv",
    "SLC1A1 methyl",
    "SLC1A1 proteo",
    "SLC1A1 rna"
  ],
  "SLC1A2": [
    "SLC1A2 21_25_1_1_S21 phospho",
    "SLC1A2 517_523_1_1_S521 phospho",
    "SLC1A2 519_523_1_1_S521 phospho",
    "SLC1A2 532_544_1_0 phospho",
    "SLC1A2 532_544_1_1_S532 phospho",
    "SLC1A2 532_544_1_1_S534 phospho",
    "SLC1A2 532_544_1_1_S544 phospho",
    "SLC1A2 560_564_1_1_S560 phospho",
    "SLC1A2 560_564_1_1_S564 phospho",
    "SLC1A2 cnv",
    "SLC1A2 methyl",
    "SLC1A2 proteo",
    "SLC1A2 rna"
  ],
  "SLC1A3": [
    "SLC1A3 467_467_1_1_S467 phospho",
    "SLC1A3 cnv",
    "SLC1A3 proteo",
    "SLC1A3 rna"
  ],
  "SLC1A4": [
    "SLC1A4 502_527_1_1_S507 phospho",
    "SLC1A4 cnv",
    "SLC1A4 methyl",
    "SLC1A4 proteo",
    "SLC1A4 rna"
  ],
  "SLC1A5": [
    "SLC1A5 9_9_1_1_S9 phospho",
    "SLC1A5 cnv",
    "SLC1A5 methyl",
    "SLC1A5 proteo",
    "SLC1A5 rna"
  ],
  "SLC1A6": [
    "SLC1A6 cnv",
    "SLC1A6 methyl",
    "SLC1A6 rna"
  ],
  "SLC1A7": [
    "SLC1A7 cnv",
    "SLC1A7 rna"
  ],
  "SLC20A1": [
    "SLC20A1 265_269_2_0 phospho",
    "SLC20A1 cnv",
    "SLC20A1 methyl",
    "SLC20A1 rna"
  ],
  "SLC20A2": [
    "SLC20A2 253_261_1_1_S256 phospho",
    "SLC20A2 253_268_2_2_S256S259 phospho",
    "SLC20A2 268_268_1_1_S268 phospho",
    "SLC20A2 316_337_2_0 phospho",
    "SLC20A2 339_346_1_1_T346 phospho",
    "SLC20A2 339_354_1_1_S351 phospho",
    "SLC20A2 385_401_1_0 phospho",
    "SLC20A2 385_401_1_1_S385 phospho",
    "SLC20A2 cnv",
    "SLC20A2 methyl",
    "SLC20A2 proteo",
    "SLC20A2 rna"
  ],
  "SLC22A1": [
    "SLC22A1 cnv",
    "SLC22A1 rna"
  ],
  "SLC22A10": [
    "SLC22A10 cnv",
    "SLC22A10 rna"
  ],
  "SLC22A11": [
    "SLC22A11 cnv",
    "SLC22A11 rna"
  ],
  "SLC22A12": [
    "SLC22A12 cnv",
    "SLC22A12 rna"
  ],
  "SLC22A13": [
    "SLC22A13 cnv",
    "SLC22A13 rna"
  ],
  "SLC22A14": [
    "SLC22A14 cnv",
    "SLC22A14 rna"
  ],
  "SLC22A15": [
    "SLC22A15 cnv",
    "SLC22A15 methyl",
    "SLC22A15 rna"
  ],
  "SLC22A16": [
    "SLC22A16 cnv",
    "SLC22A16 methyl",
    "SLC22A16 rna"
  ],
  "SLC22A17": [
    "SLC22A17 cnv",
    "SLC22A17 methyl",
    "SLC22A17 proteo",
    "SLC22A17 rna"
  ],
  "SLC22A18": [
    "SLC22A18 cnv",
    "SLC22A18 methyl",
    "SLC22A18 proteo",
    "SLC22A18 rna"
  ],
  "SLC22A18AS": [
    "SLC22A18AS cnv",
    "SLC22A18AS rna"
  ],
  "SLC22A2": [
    "SLC22A2 cnv",
    "SLC22A2 rna"
  ],
  "SLC22A23": [
    "SLC22A23 cnv",
    "SLC22A23 methyl",
    "SLC22A23 proteo",
    "SLC22A23 rna"
  ],
  "SLC22A24": [
    "SLC22A24 cnv"
  ],
  "SLC22A25": [
    "SLC22A25 cnv",
    "SLC22A25 rna"
  ],
  "SLC22A3": [
    "SLC22A3 cnv",
    "SLC22A3 methyl",
    "SLC22A3 rna"
  ],
  "SLC22A31": [
    "SLC22A31 cnv",
    "SLC22A31 methyl",
    "SLC22A31 rna"
  ],
  "SLC22A4": [
    "SLC22A4 cnv",
    "SLC22A4 methyl",
    "SLC22A4 proteo",
    "SLC22A4 rna"
  ],
  "SLC22A5": [
    "SLC22A5 cnv",
    "SLC22A5 methyl",
    "SLC22A5 proteo",
    "SLC22A5 rna"
  ],
  "SLC22A6": [
    "SLC22A6 cnv",
    "SLC22A6 rna"
  ],
  "SLC22A7": [
    "SLC22A7 cnv",
    "SLC22A7 rna"
  ],
  "SLC22A8": [
    "SLC22A8 cnv",
    "SLC22A8 rna"
  ],
  "SLC22A9": [
    "SLC22A9 cnv",
    "SLC22A9 rna"
  ],
  "SLC23A1": [
    "SLC23A1 cnv",
    "SLC23A1 rna"
  ],
  "SLC23A2": [
    "SLC23A2 70_81_1_1_S81 phospho",
    "SLC23A2 70_81_2_2_S78S81 phospho",
    "SLC23A2 cnv",
    "SLC23A2 methyl",
    "SLC23A2 proteo",
    "SLC23A2 rna"
  ],
  "SLC23A3": [
    "SLC23A3 cnv",
    "SLC23A3 rna"
  ],
  "SLC24A1": [
    "SLC24A1 cnv",
    "SLC24A1 methyl",
    "SLC24A1 rna"
  ],
  "SLC24A2": [
    "SLC24A2 333_340_1_1_S333 phospho",
    "SLC24A2 333_340_1_1_S336 phospho",
    "SLC24A2 cnv",
    "SLC24A2 methyl",
    "SLC24A2 proteo",
    "SLC24A2 rna"
  ],
  "SLC24A3": [
    "SLC24A3 cnv",
    "SLC24A3 methyl",
    "SLC24A3 proteo",
    "SLC24A3 rna"
  ],
  "SLC24A4": [
    "SLC24A4 cnv",
    "SLC24A4 methyl",
    "SLC24A4 rna"
  ],
  "SLC24A5": [
    "SLC24A5 cnv",
    "SLC24A5 rna"
  ],
  "SLC25A1": [
    "SLC25A1 cnv",
    "SLC25A1 methyl",
    "SLC25A1 proteo",
    "SLC25A1 rna"
  ],
  "SLC25A10": [
    "SLC25A10 cnv",
    "SLC25A10 methyl",
    "SLC25A10 proteo",
    "SLC25A10 rna"
  ],
  "SLC25A11": [
    "SLC25A11 cnv",
    "SLC25A11 methyl",
    "SLC25A11 proteo",
    "SLC25A11 rna"
  ],
  "SLC25A12": [
    "SLC25A12 cnv",
    "SLC25A12 methyl",
    "SLC25A12 proteo",
    "SLC25A12 rna"
  ],
  "SLC25A13": [
    "SLC25A13 cnv",
    "SLC25A13 methyl",
    "SLC25A13 proteo",
    "SLC25A13 rna"
  ],
  "SLC25A14": [
    "SLC25A14 methyl",
    "SLC25A14 proteo",
    "SLC25A14 rna"
  ],
  "SLC25A15": [
    "SLC25A15 cnv",
    "SLC25A15 methyl",
    "SLC25A15 rna"
  ],
  "SLC25A16": [
    "SLC25A16 cnv",
    "SLC25A16 methyl",
    "SLC25A16 rna"
  ],
  "SLC25A17": [
    "SLC25A17 cnv",
    "SLC25A17 methyl",
    "SLC25A17 proteo",
    "SLC25A17 rna"
  ],
  "SLC25A18": [
    "SLC25A18 cnv",
    "SLC25A18 proteo",
    "SLC25A18 rna"
  ],
  "SLC25A19": [
    "SLC25A19 cnv",
    "SLC25A19 methyl",
    "SLC25A19 proteo",
    "SLC25A19 rna"
  ],
  "SLC25A2": [
    "SLC25A2 cnv",
    "SLC25A2 methyl",
    "SLC25A2 rna"
  ],
  "SLC25A20": [
    "SLC25A20 cnv",
    "SLC25A20 methyl",
    "SLC25A20 proteo",
    "SLC25A20 rna"
  ],
  "SLC25A21": [
    "SLC25A21 cnv",
    "SLC25A21 methyl",
    "SLC25A21 rna"
  ],
  "SLC25A22": [
    "SLC25A22 cnv",
    "SLC25A22 methyl",
    "SLC25A22 proteo",
    "SLC25A22 rna"
  ],
  "SLC25A23": [
    "SLC25A23 cnv",
    "SLC25A23 methyl",
    "SLC25A23 proteo",
    "SLC25A23 rna"
  ],
  "SLC25A24": [
    "SLC25A24 cnv",
    "SLC25A24 methyl",
    "SLC25A24 proteo",
    "SLC25A24 rna"
  ],
  "SLC25A25": [
    "SLC25A25 cnv",
    "SLC25A25 methyl",
    "SLC25A25 proteo",
    "SLC25A25 rna"
  ],
  "SLC25A26": [
    "SLC25A26 cnv",
    "SLC25A26 proteo",
    "SLC25A26 rna"
  ],
  "SLC25A27": [
    "SLC25A27 cnv",
    "SLC25A27 methyl",
    "SLC25A27 proteo",
    "SLC25A27 rna"
  ],
  "SLC25A28": [
    "SLC25A28 cnv",
    "SLC25A28 methyl",
    "SLC25A28 rna"
  ],
  "SLC25A29": [
    "SLC25A29 cnv",
    "SLC25A29 methyl",
    "SLC25A29 proteo",
    "SLC25A29 rna"
  ],
  "SLC25A3": [
    "SLC25A3 cnv",
    "SLC25A3 methyl",
    "SLC25A3 proteo",
    "SLC25A3 rna"
  ],
  "SLC25A30": [
    "SLC25A30 cnv",
    "SLC25A30 methyl",
    "SLC25A30 rna"
  ],
  "SLC25A30-AS1": [
    "SLC25A30-AS1 methyl"
  ],
  "SLC25A31": [
    "SLC25A31 cnv",
    "SLC25A31 methyl",
    "SLC25A31 rna"
  ],
  "SLC25A32": [
    "SLC25A32 cnv",
    "SLC25A32 methyl",
    "SLC25A32 rna"
  ],
  "SLC25A33": [
    "SLC25A33 cnv",
    "SLC25A33 methyl",
    "SLC25A33 rna"
  ],
  "SLC25A34": [
    "SLC25A34 cnv",
    "SLC25A34 rna"
  ],
  "SLC25A35": [
    "SLC25A35 cnv",
    "SLC25A35 methyl",
    "SLC25A35 rna"
  ],
  "SLC25A36": [
    "SLC25A36 cnv",
    "SLC25A36 methyl",
    "SLC25A36 proteo",
    "SLC25A36 rna"
  ],
  "SLC25A37": [
    "SLC25A37 cnv",
    "SLC25A37 methyl",
    "SLC25A37 rna"
  ],
  "SLC25A38": [
    "SLC25A38 cnv",
    "SLC25A38 methyl",
    "SLC25A38 rna"
  ],
  "SLC25A39": [
    "SLC25A39 cnv",
    "SLC25A39 methyl",
    "SLC25A39 rna"
  ],
  "SLC25A3P1": [
    "SLC25A3P1 methyl"
  ],
  "SLC25A4": [
    "SLC25A4 cnv",
    "SLC25A4 methyl",
    "SLC25A4 proteo",
    "SLC25A4 rna"
  ],
  "SLC25A40": [
    "SLC25A40 cnv",
    "SLC25A40 methyl",
    "SLC25A40 proteo",
    "SLC25A40 rna"
  ],
  "SLC25A41": [
    "SLC25A41 cnv",
    "SLC25A41 rna"
  ],
  "SLC25A42": [
    "SLC25A42 cnv",
    "SLC25A42 methyl",
    "SLC25A42 proteo",
    "SLC25A42 rna"
  ],
  "SLC25A43": [
    "SLC25A43 methyl",
    "SLC25A43 rna"
  ],
  "SLC25A44": [
    "SLC25A44 cnv",
    "SLC25A44 methyl",
    "SLC25A44 rna"
  ],
  "SLC25A45": [
    "SLC25A45 cnv",
    "SLC25A45 rna"
  ],
  "SLC25A46": [
    "SLC25A46 32_52_1_0 phospho",
    "SLC25A46 32_52_1_1_S34 phospho",
    "SLC25A46 32_52_1_1_T45 phospho",
    "SLC25A46 32_52_2_0 phospho",
    "SLC25A46 61_94_1_0 phospho",
    "SLC25A46 61_94_1_1_S61 phospho",
    "SLC25A46 61_94_2_0 phospho",
    "SLC25A46 cnv",
    "SLC25A46 methyl",
    "SLC25A46 proteo",
    "SLC25A46 rna"
  ],
  "SLC25A47": [
    "SLC25A47 cnv",
    "SLC25A47 rna"
  ],
  "SLC25A48": [
    "SLC25A48 cnv",
    "SLC25A48 methyl",
    "SLC25A48 rna"
  ],
  "SLC25A5": [
    "SLC25A5 methyl",
    "SLC25A5 proteo",
    "SLC25A5 rna"
  ],
  "SLC25A5-AS1": [
    "SLC25A5-AS1 methyl"
  ],
  "SLC25A51": [
    "SLC25A51 cnv",
    "SLC25A51 methyl",
    "SLC25A51 proteo",
    "SLC25A51 rna"
  ],
  "SLC25A51P4": [
    "SLC25A51P4 methyl"
  ],
  "SLC25A52": [
    "SLC25A52 cnv",
    "SLC25A52 rna"
  ],
  "SLC25A53": [
    "SLC25A53 methyl",
    "SLC25A53 proteo",
    "SLC25A53 rna"
  ],
  "SLC25A6": [
    "SLC25A6 proteo",
    "SLC25A6 rna"
  ],
  "SLC26A1": [
    "SLC26A1 cnv",
    "SLC26A1 methyl",
    "SLC26A1 rna"
  ],
  "SLC26A11": [
    "SLC26A11 cnv",
    "SLC26A11 methyl",
    "SLC26A11 rna"
  ],
  "SLC26A2": [
    "SLC26A2 cnv",
    "SLC26A2 methyl",
    "SLC26A2 proteo",
    "SLC26A2 rna"
  ],
  "SLC26A3": [
    "SLC26A3 cnv",
    "SLC26A3 rna"
  ],
  "SLC26A4": [
    "SLC26A4 cnv",
    "SLC26A4 methyl",
    "SLC26A4 rna"
  ],
  "SLC26A5": [
    "SLC26A5 cnv",
    "SLC26A5 methyl",
    "SLC26A5 rna"
  ],
  "SLC26A5-AS1": [
    "SLC26A5-AS1 methyl"
  ],
  "SLC26A6": [
    "SLC26A6 cnv",
    "SLC26A6 methyl",
    "SLC26A6 rna"
  ],
  "SLC26A7": [
    "SLC26A7 cnv",
    "SLC26A7 rna"
  ],
  "SLC26A8": [
    "SLC26A8 cnv",
    "SLC26A8 rna"
  ],
  "SLC26A9": [
    "SLC26A9 cnv",
    "SLC26A9 rna"
  ],
  "SLC27A1": [
    "SLC27A1 cnv",
    "SLC27A1 methyl",
    "SLC27A1 proteo",
    "SLC27A1 rna"
  ],
  "SLC27A2": [
    "SLC27A2 cnv",
    "SLC27A2 methyl",
    "SLC27A2 rna"
  ],
  "SLC27A3": [
    "SLC27A3 cnv",
    "SLC27A3 methyl",
    "SLC27A3 proteo",
    "SLC27A3 rna"
  ],
  "SLC27A4": [
    "SLC27A4 cnv",
    "SLC27A4 methyl",
    "SLC27A4 proteo",
    "SLC27A4 rna"
  ],
  "SLC27A5": [
    "SLC27A5 cnv",
    "SLC27A5 methyl",
    "SLC27A5 rna"
  ],
  "SLC27A6": [
    "SLC27A6 cnv",
    "SLC27A6 methyl",
    "SLC27A6 rna"
  ],
  "SLC28A1": [
    "SLC28A1 cnv",
    "SLC28A1 rna"
  ],
  "SLC28A2": [
    "SLC28A2 cnv",
    "SLC28A2 rna"
  ],
  "SLC28A3": [
    "SLC28A3 cnv",
    "SLC28A3 rna"
  ],
  "SLC29A1": [
    "SLC29A1 cnv",
    "SLC29A1 methyl",
    "SLC29A1 rna"
  ],
  "SLC29A2": [
    "SLC29A2 244_252_1_1_S252 phospho",
    "SLC29A2 cnv",
    "SLC29A2 methyl",
    "SLC29A2 rna"
  ],
  "SLC29A3": [
    "SLC29A3 cnv",
    "SLC29A3 rna"
  ],
  "SLC29A4": [
    "SLC29A4 cnv",
    "SLC29A4 methyl",
    "SLC29A4 rna"
  ],
  "SLC2A1": [
    "SLC2A1 473_490_1_1_S475 phospho",
    "SLC2A1 473_490_1_1_S490 phospho",
    "SLC2A1 473_490_1_1_T478 phospho",
    "SLC2A1 cnv",
    "SLC2A1 methyl",
    "SLC2A1 proteo",
    "SLC2A1 rna"
  ],
  "SLC2A1-DT": [
    "SLC2A1-DT methyl"
  ],
  "SLC2A10": [
    "SLC2A10 cnv",
    "SLC2A10 methyl",
    "SLC2A10 rna"
  ],
  "SLC2A11": [
    "SLC2A11 cnv",
    "SLC2A11 methyl",
    "SLC2A11 rna"
  ],
  "SLC2A12": [
    "SLC2A12 cnv",
    "SLC2A12 rna"
  ],
  "SLC2A13": [
    "SLC2A13 34_53_1_0 phospho",
    "SLC2A13 635_645_1_1_S640 phospho",
    "SLC2A13 635_645_1_1_S645 phospho",
    "SLC2A13 cnv",
    "SLC2A13 methyl",
    "SLC2A13 proteo",
    "SLC2A13 rna"
  ],
  "SLC2A14": [
    "SLC2A14 cnv",
    "SLC2A14 methyl",
    "SLC2A14 rna"
  ],
  "SLC2A2": [
    "SLC2A2 cnv",
    "SLC2A2 rna"
  ],
  "SLC2A3": [
    "SLC2A3 cnv",
    "SLC2A3 proteo",
    "SLC2A3 rna"
  ],
  "SLC2A4": [
    "SLC2A4 cnv",
    "SLC2A4 methyl",
    "SLC2A4 rna"
  ],
  "SLC2A4RG": [
    "SLC2A4RG cnv",
    "SLC2A4RG methyl",
    "SLC2A4RG rna"
  ],
  "SLC2A5": [
    "SLC2A5 cnv",
    "SLC2A5 methyl",
    "SLC2A5 proteo",
    "SLC2A5 rna"
  ],
  "SLC2A6": [
    "SLC2A6 cnv",
    "SLC2A6 methyl",
    "SLC2A6 rna"
  ],
  "SLC2A7": [
    "SLC2A7 cnv",
    "SLC2A7 rna"
  ],
  "SLC2A8": [
    "SLC2A8 cnv",
    "SLC2A8 methyl",
    "SLC2A8 rna"
  ],
  "SLC2A9": [
    "SLC2A9 cnv",
    "SLC2A9 methyl",
    "SLC2A9 rna"
  ],
  "SLC30A1": [
    "SLC30A1 167_199_1_0 phospho",
    "SLC30A1 505_506_1_1_S506 phospho",
    "SLC30A1 cnv",
    "SLC30A1 methyl",
    "SLC30A1 proteo",
    "SLC30A1 rna"
  ],
  "SLC30A10": [
    "SLC30A10 cnv",
    "SLC30A10 methyl",
    "SLC30A10 rna"
  ],
  "SLC30A2": [
    "SLC30A2 cnv",
    "SLC30A2 methyl",
    "SLC30A2 rna"
  ],
  "SLC30A3": [
    "SLC30A3 cnv",
    "SLC30A3 methyl",
    "SLC30A3 proteo",
    "SLC30A3 rna"
  ],
  "SLC30A4": [
    "SLC30A4 420_428_1_1_S428 phospho",
    "SLC30A4 cnv",
    "SLC30A4 methyl",
    "SLC30A4 rna"
  ],
  "SLC30A5": [
    "SLC30A5 cnv",
    "SLC30A5 methyl",
    "SLC30A5 proteo",
    "SLC30A5 rna"
  ],
  "SLC30A6": [
    "SLC30A6 407_431_1_1_S421 phospho",
    "SLC30A6 cnv",
    "SLC30A6 methyl",
    "SLC30A6 proteo",
    "SLC30A6 rna"
  ],
  "SLC30A7": [
    "SLC30A7 cnv",
    "SLC30A7 methyl",
    "SLC30A7 proteo",
    "SLC30A7 rna"
  ],
  "SLC30A8": [
    "SLC30A8 cnv",
    "SLC30A8 rna"
  ],
  "SLC30A9": [
    "SLC30A9 cnv",
    "SLC30A9 methyl",
    "SLC30A9 proteo",
    "SLC30A9 rna"
  ],
  "SLC31A1": [
    "SLC31A1 cnv",
    "SLC31A1 methyl",
    "SLC31A1 proteo",
    "SLC31A1 rna"
  ],
  "SLC31A2": [
    "SLC31A2 cnv",
    "SLC31A2 methyl",
    "SLC31A2 rna"
  ],
  "SLC32A1": [
    "SLC32A1 89_98_1_1_S98 phospho",
    "SLC32A1 cnv",
    "SLC32A1 methyl",
    "SLC32A1 proteo",
    "SLC32A1 rna"
  ],
  "SLC33A1": [
    "SLC33A1 20_22_1_1_S22 phospho",
    "SLC33A1 cnv",
    "SLC33A1 methyl",
    "SLC33A1 proteo",
    "SLC33A1 rna"
  ],
  "SLC34A1": [
    "SLC34A1 cnv",
    "SLC34A1 rna"
  ],
  "SLC34A2": [
    "SLC34A2 cnv",
    "SLC34A2 methyl",
    "SLC34A2 rna"
  ],
  "SLC34A3": [
    "SLC34A3 cnv",
    "SLC34A3 rna"
  ],
  "SLC35A1": [
    "SLC35A1 cnv",
    "SLC35A1 methyl",
    "SLC35A1 rna"
  ],
  "SLC35A2": [
    "SLC35A2 methyl",
    "SLC35A2 proteo",
    "SLC35A2 rna"
  ],
  "SLC35A3": [
    "SLC35A3 cnv",
    "SLC35A3 methyl",
    "SLC35A3 rna"
  ],
  "SLC35A4": [
    "SLC35A4 cnv",
    "SLC35A4 methyl",
    "SLC35A4 rna"
  ],
  "SLC35A5": [
    "SLC35A5 cnv",
    "SLC35A5 methyl",
    "SLC35A5 rna"
  ],
  "SLC35B1": [
    "SLC35B1 cnv",
    "SLC35B1 rna"
  ],
  "SLC35B2": [
    "SLC35B2 422_422_1_1_S422 phospho",
    "SLC35B2 cnv",
    "SLC35B2 methyl",
    "SLC35B2 proteo",
    "SLC35B2 rna"
  ],
  "SLC35B3": [
    "SLC35B3 cnv",
    "SLC35B3 methyl",
    "SLC35B3 rna"
  ],
  "SLC35B4": [
    "SLC35B4 cnv",
    "SLC35B4 methyl",
    "SLC35B4 rna"
  ],
  "SLC35C1": [
    "SLC35C1 cnv",
    "SLC35C1 methyl",
    "SLC35C1 rna"
  ],
  "SLC35C2": [
    "SLC35C2 cnv",
    "SLC35C2 methyl",
    "SLC35C2 rna"
  ],
  "SLC35D1": [
    "SLC35D1 cnv",
    "SLC35D1 methyl",
    "SLC35D1 rna"
  ],
  "SLC35D2": [
    "SLC35D2 cnv",
    "SLC35D2 rna"
  ],
  "SLC35D3": [
    "SLC35D3 cnv",
    "SLC35D3 methyl",
    "SLC35D3 rna"
  ],
  "SLC35E1": [
    "SLC35E1 cnv",
    "SLC35E1 methyl",
    "SLC35E1 proteo",
    "SLC35E1 rna"
  ],
  "SLC35E2A": [
    "SLC35E2A cnv",
    "SLC35E2A methyl",
    "SLC35E2A rna"
  ],
  "SLC35E2B": [
    "SLC35E2B cnv",
    "SLC35E2B methyl",
    "SLC35E2B rna"
  ],
  "SLC35E3": [
    "SLC35E3 cnv",
    "SLC35E3 methyl",
    "SLC35E3 rna"
  ],
  "SLC35E4": [
    "SLC35E4 cnv",
    "SLC35E4 methyl",
    "SLC35E4 rna"
  ],
  "SLC35F1": [
    "SLC35F1 374_399_1_1_S374 phospho",
    "SLC35F1 cnv",
    "SLC35F1 methyl",
    "SLC35F1 rna"
  ],
  "SLC35F2": [
    "SLC35F2 cnv",
    "SLC35F2 methyl",
    "SLC35F2 rna"
  ],
  "SLC35F3": [
    "SLC35F3 cnv",
    "SLC35F3 methyl",
    "SLC35F3 rna"
  ],
  "SLC35F4": [
    "SLC35F4 cnv",
    "SLC35F4 methyl",
    "SLC35F4 rna"
  ],
  "SLC35F5": [
    "SLC35F5 cnv",
    "SLC35F5 methyl",
    "SLC35F5 rna"
  ],
  "SLC35F6": [
    "SLC35F6 cnv",
    "SLC35F6 methyl",
    "SLC35F6 proteo",
    "SLC35F6 rna"
  ],
  "SLC35G1": [
    "SLC35G1 cnv",
    "SLC35G1 methyl",
    "SLC35G1 rna"
  ],
  "SLC35G2": [
    "SLC35G2 403_409_1_1_S409 phospho",
    "SLC35G2 cnv",
    "SLC35G2 methyl",
    "SLC35G2 rna"
  ],
  "SLC35G3": [
    "SLC35G3 cnv"
  ],
  "SLC35G4": [
    "SLC35G4 cnv"
  ],
  "SLC35G5": [
    "SLC35G5 cnv",
    "SLC35G5 rna"
  ],
  "SLC35G6": [
    "SLC35G6 cnv",
    "SLC35G6 rna"
  ],
  "SLC36A1": [
    "SLC36A1 cnv",
    "SLC36A1 methyl",
    "SLC36A1 rna"
  ],
  "SLC36A2": [
    "SLC36A2 cnv",
    "SLC36A2 rna"
  ],
  "SLC36A3": [
    "SLC36A3 cnv"
  ],
  "SLC36A4": [
    "SLC36A4 cnv",
    "SLC36A4 methyl",
    "SLC36A4 rna"
  ],
  "SLC37A1": [
    "SLC37A1 cnv",
    "SLC37A1 methyl",
    "SLC37A1 rna"
  ],
  "SLC37A2": [
    "SLC37A2 cnv",
    "SLC37A2 methyl",
    "SLC37A2 rna"
  ],
  "SLC37A3": [
    "SLC37A3 cnv",
    "SLC37A3 methyl",
    "SLC37A3 proteo",
    "SLC37A3 rna"
  ],
  "SLC37A4": [
    "SLC37A4 cnv",
    "SLC37A4 methyl",
    "SLC37A4 proteo",
    "SLC37A4 rna"
  ],
  "SLC38A1": [
    "SLC38A1 52_56_1_1_S52 phospho",
    "SLC38A1 cnv",
    "SLC38A1 methyl",
    "SLC38A1 proteo",
    "SLC38A1 rna"
  ],
  "SLC38A10": [
    "SLC38A10 997_997_1_1_S997 phospho",
    "SLC38A10 cnv",
    "SLC38A10 methyl",
    "SLC38A10 proteo",
    "SLC38A10 rna"
  ],
  "SLC38A11": [
    "SLC38A11 cnv",
    "SLC38A11 rna"
  ],
  "SLC38A2": [
    "SLC38A2 cnv",
    "SLC38A2 methyl",
    "SLC38A2 proteo",
    "SLC38A2 rna"
  ],
  "SLC38A3": [
    "SLC38A3 52_60_1_1_S54 phospho",
    "SLC38A3 cnv",
    "SLC38A3 methyl",
    "SLC38A3 proteo",
    "SLC38A3 rna"
  ],
  "SLC38A4": [
    "SLC38A4 cnv",
    "SLC38A4 rna"
  ],
  "SLC38A5": [
    "SLC38A5 rna"
  ],
  "SLC38A6": [
    "SLC38A6 cnv",
    "SLC38A6 methyl",
    "SLC38A6 rna"
  ],
  "SLC38A7": [
    "SLC38A7 28_33_1_1_S28 phospho",
    "SLC38A7 cnv",
    "SLC38A7 methyl",
    "SLC38A7 rna"
  ],
  "SLC38A8": [
    "SLC38A8 cnv",
    "SLC38A8 rna"
  ],
  "SLC38A9": [
    "SLC38A9 cnv",
    "SLC38A9 methyl",
    "SLC38A9 proteo",
    "SLC38A9 rna"
  ],
  "SLC39A1": [
    "SLC39A1 cnv",
    "SLC39A1 methyl",
    "SLC39A1 rna"
  ],
  "SLC39A10": [
    "SLC39A10 DLNEDDHHHECLNVTQLLK-N2H5F0S0G0 glyco",
    "SLC39A10 cnv",
    "SLC39A10 methyl",
    "SLC39A10 proteo",
    "SLC39A10 rna"
  ],
  "SLC39A11": [
    "SLC39A11 cnv",
    "SLC39A11 proteo",
    "SLC39A11 rna"
  ],
  "SLC39A12": [
    "SLC39A12 cnv",
    "SLC39A12 proteo",
    "SLC39A12 rna"
  ],
  "SLC39A13": [
    "SLC39A13 cnv",
    "SLC39A13 methyl",
    "SLC39A13 rna"
  ],
  "SLC39A14": [
    "SLC39A14 cnv",
    "SLC39A14 methyl",
    "SLC39A14 proteo",
    "SLC39A14 rna"
  ],
  "SLC39A2": [
    "SLC39A2 cnv",
    "SLC39A2 rna"
  ],
  "SLC39A3": [
    "SLC39A3 cnv",
    "SLC39A3 methyl",
    "SLC39A3 rna"
  ],
  "SLC39A4": [
    "SLC39A4 cnv",
    "SLC39A4 methyl",
    "SLC39A4 rna"
  ],
  "SLC39A5": [
    "SLC39A5 cnv",
    "SLC39A5 rna"
  ],
  "SLC39A6": [
    "SLC39A6 473_479_1_0 phospho",
    "SLC39A6 NTNENPQECFNASK-N2H5F0S0G0 glyco",
    "SLC39A6 cnv",
    "SLC39A6 methyl",
    "SLC39A6 proteo",
    "SLC39A6 rna"
  ],
  "SLC39A7": [
    "SLC39A7 cnv",
    "SLC39A7 methyl",
    "SLC39A7 rna"
  ],
  "SLC39A8": [
    "SLC39A8 cnv",
    "SLC39A8 methyl",
    "SLC39A8 rna"
  ],
  "SLC39A9": [
    "SLC39A9 cnv",
    "SLC39A9 methyl",
    "SLC39A9 rna"
  ],
  "SLC3A1": [
    "SLC3A1 cnv",
    "SLC3A1 methyl",
    "SLC3A1 rna"
  ],
  "SLC3A2": [
    "SLC3A2 cnv",
    "SLC3A2 methyl",
    "SLC3A2 proteo",
    "SLC3A2 rna"
  ],
  "SLC40A1": [
    "SLC40A1 cnv",
    "SLC40A1 methyl",
    "SLC40A1 rna"
  ],
  "SLC41A1": [
    "SLC41A1 cnv",
    "SLC41A1 methyl",
    "SLC41A1 rna"
  ],
  "SLC41A2": [
    "SLC41A2 cnv",
    "SLC41A2 methyl",
    "SLC41A2 rna"
  ],
  "SLC41A3": [
    "SLC41A3 13_35_1_1_S13 phospho",
    "SLC41A3 cnv",
    "SLC41A3 methyl",
    "SLC41A3 proteo",
    "SLC41A3 rna"
  ],
  "SLC43A1": [
    "SLC43A1 cnv",
    "SLC43A1 methyl",
    "SLC43A1 rna"
  ],
  "SLC43A2": [
    "SLC43A2 274_278_1_1_S274 phospho",
    "SLC43A2 cnv",
    "SLC43A2 methyl",
    "SLC43A2 proteo",
    "SLC43A2 rna"
  ],
  "SLC43A3": [
    "SLC43A3 cnv",
    "SLC43A3 methyl",
    "SLC43A3 proteo",
    "SLC43A3 rna"
  ],
  "SLC44A1": [
    "SLC44A1 CAPVNISCYAK-N2H5F0S0G0 glyco",
    "SLC44A1 cnv",
    "SLC44A1 methyl",
    "SLC44A1 proteo",
    "SLC44A1 rna"
  ],
  "SLC44A2": [
    "SLC44A2 14_21_1_1_T14 phospho",
    "SLC44A2 cnv",
    "SLC44A2 methyl",
    "SLC44A2 proteo",
    "SLC44A2 rna"
  ],
  "SLC44A3": [
    "SLC44A3 cnv",
    "SLC44A3 methyl",
    "SLC44A3 rna"
  ],
  "SLC44A3-AS1": [
    "SLC44A3-AS1 methyl"
  ],
  "SLC44A4": [
    "SLC44A4 cnv",
    "SLC44A4 rna"
  ],
  "SLC44A5": [
    "SLC44A5 cnv",
    "SLC44A5 methyl",
    "SLC44A5 rna"
  ],
  "SLC45A1": [
    "SLC45A1 cnv",
    "SLC45A1 methyl",
    "SLC45A1 rna"
  ],
  "SLC45A2": [
    "SLC45A2 cnv",
    "SLC45A2 rna"
  ],
  "SLC45A3": [
    "SLC45A3 cnv",
    "SLC45A3 methyl",
    "SLC45A3 rna"
  ],
  "SLC45A4": [
    "SLC45A4 cnv",
    "SLC45A4 methyl",
    "SLC45A4 rna"
  ],
  "SLC46A1": [
    "SLC46A1 cnv",
    "SLC46A1 methyl",
    "SLC46A1 rna"
  ],
  "SLC46A2": [
    "SLC46A2 cnv",
    "SLC46A2 methyl",
    "SLC46A2 rna"
  ],
  "SLC46A3": [
    "SLC46A3 cnv",
    "SLC46A3 methyl",
    "SLC46A3 rna"
  ],
  "SLC47A1": [
    "SLC47A1 cnv",
    "SLC47A1 methyl",
    "SLC47A1 rna"
  ],
  "SLC47A2": [
    "SLC47A2 cnv",
    "SLC47A2 rna"
  ],
  "SLC48A1": [
    "SLC48A1 cnv",
    "SLC48A1 methyl",
    "SLC48A1 rna"
  ],
  "SLC49A3": [
    "SLC49A3 cnv",
    "SLC49A3 methyl",
    "SLC49A3 rna"
  ],
  "SLC49A4": [
    "SLC49A4 cnv",
    "SLC49A4 methyl",
    "SLC49A4 rna"
  ],
  "SLC4A1": [
    "SLC4A1 181_214_1_0 phospho",
    "SLC4A1 181_214_1_1_S194 phospho",
    "SLC4A1 347_359_1_1_S350 phospho",
    "SLC4A1 347_359_1_1_S356 phospho",
    "SLC4A1 347_359_1_1_S357 phospho",
    "SLC4A1 cnv",
    "SLC4A1 proteo",
    "SLC4A1 rna"
  ],
  "SLC4A10": [
    "SLC4A10 247_251_1_1_S247 phospho",
    "SLC4A10 296_297_1_1_S297 phospho",
    "SLC4A10 81_96_1_1_S89 phospho",
    "SLC4A10 cnv",
    "SLC4A10 methyl",
    "SLC4A10 proteo",
    "SLC4A10 rna"
  ],
  "SLC4A11": [
    "SLC4A11 cnv",
    "SLC4A11 methyl",
    "SLC4A11 rna"
  ],
  "SLC4A1AP": [
    "SLC4A1AP 312_321_1_1_S312 phospho",
    "SLC4A1AP 464_470_1_1_S466 phospho",
    "SLC4A1AP 82_82_1_1_S82 phospho",
    "SLC4A1AP cnv",
    "SLC4A1AP methyl",
    "SLC4A1AP proteo",
    "SLC4A1AP rna"
  ],
  "SLC4A2": [
    "SLC4A2 113_132_1_1_S113 phospho",
    "SLC4A2 169_183_1_1_S173 phospho",
    "SLC4A2 443_476_1_1_S443 phospho",
    "SLC4A2 cnv",
    "SLC4A2 methyl",
    "SLC4A2 proteo",
    "SLC4A2 rna"
  ],
  "SLC4A3": [
    "SLC4A3 167_175_1_1_S170 phospho",
    "SLC4A3 291_299_1_1_S297 phospho",
    "SLC4A3 cnv",
    "SLC4A3 methyl",
    "SLC4A3 rna"
  ],
  "SLC4A4": [
    "SLC4A4 1026_1039_1_1_S1026 phospho",
    "SLC4A4 1026_1039_1_1_S1029 phospho",
    "SLC4A4 1026_1039_1_1_S1034 phospho",
    "SLC4A4 1026_1039_2_2_S1026S1029 phospho",
    "SLC4A4 1026_1039_2_2_S1029S1034 phospho",
    "SLC4A4 1044_1064_1_1_S1044 phospho",
    "SLC4A4 1069_1071_1_1_S1069 phospho",
    "SLC4A4 219_223_1_1_S223 phospho",
    "SLC4A4 239_249_1_1_S245 phospho",
    "SLC4A4 254_262_1_1_S257 phospho",
    "SLC4A4 254_262_1_1_T254 phospho",
    "SLC4A4 254_262_2_0 phospho",
    "SLC4A4 254_262_2_2_T254S257 phospho",
    "SLC4A4 61_79_1_1_S68 phospho",
    "SLC4A4 61_79_2_2_S65S68 phospho",
    "SLC4A4 61_86_1_1_S68 phospho",
    "SLC4A4 68_79_1_1_S68 phospho",
    "SLC4A4 cnv",
    "SLC4A4 methyl",
    "SLC4A4 proteo",
    "SLC4A4 rna"
  ],
  "SLC4A5": [
    "SLC4A5 cnv",
    "SLC4A5 rna"
  ],
  "SLC4A7": [
    "SLC4A7 1072_1082_1_1_S1077 phospho",
    "SLC4A7 1106_1115_1_1_S1109 phospho",
    "SLC4A7 1128_1134_1_1_S1134 phospho",
    "SLC4A7 18_19_1_1_S19 phospho",
    "SLC4A7 441_448_1_1_S441 phospho",
    "SLC4A7 53_64_1_1_S64 phospho",
    "SLC4A7 85_100_1_1_S93 phospho",
    "SLC4A7 93_100_1_1_S93 phospho",
    "SLC4A7 cnv",
    "SLC4A7 methyl",
    "SLC4A7 proteo",
    "SLC4A7 rna"
  ],
  "SLC4A8": [
    "SLC4A8 1080_1083_1_1_S1080 phospho",
    "SLC4A8 237_237_1_1_S237 phospho",
    "SLC4A8 246_246_1_1_S246 phospho",
    "SLC4A8 279_284_1_1_S279 phospho",
    "SLC4A8 cnv",
    "SLC4A8 methyl",
    "SLC4A8 proteo",
    "SLC4A8 rna"
  ],
  "SLC4A9": [
    "SLC4A9 cnv",
    "SLC4A9 rna"
  ],
  "SLC50A1": [
    "SLC50A1 cnv",
    "SLC50A1 methyl",
    "SLC50A1 rna"
  ],
  "SLC51A": [
    "SLC51A cnv",
    "SLC51A rna"
  ],
  "SLC51B": [
    "SLC51B cnv",
    "SLC51B rna"
  ],
  "SLC52A1": [
    "SLC52A1 cnv",
    "SLC52A1 rna"
  ],
  "SLC52A2": [
    "SLC52A2 cnv",
    "SLC52A2 methyl",
    "SLC52A2 proteo",
    "SLC52A2 rna"
  ],
  "SLC52A3": [
    "SLC52A3 cnv",
    "SLC52A3 rna"
  ],
  "SLC5A1": [
    "SLC5A1 cnv",
    "SLC5A1 methyl",
    "SLC5A1 rna"
  ],
  "SLC5A10": [
    "SLC5A10 cnv",
    "SLC5A10 rna"
  ],
  "SLC5A11": [
    "SLC5A11 cnv",
    "SLC5A11 rna"
  ],
  "SLC5A12": [
    "SLC5A12 cnv",
    "SLC5A12 rna"
  ],
  "SLC5A2": [
    "SLC5A2 cnv",
    "SLC5A2 methyl",
    "SLC5A2 rna"
  ],
  "SLC5A3": [
    "SLC5A3 559_565_1_1_S559 phospho",
    "SLC5A3 cnv",
    "SLC5A3 methyl",
    "SLC5A3 proteo",
    "SLC5A3 rna"
  ],
  "SLC5A4": [
    "SLC5A4 cnv",
    "SLC5A4 rna"
  ],
  "SLC5A5": [
    "SLC5A5 cnv",
    "SLC5A5 methyl",
    "SLC5A5 rna"
  ],
  "SLC5A6": [
    "SLC5A6 cnv",
    "SLC5A6 methyl",
    "SLC5A6 proteo",
    "SLC5A6 rna"
  ],
  "SLC5A7": [
    "SLC5A7 cnv",
    "SLC5A7 methyl",
    "SLC5A7 rna"
  ],
  "SLC5A8": [
    "SLC5A8 cnv",
    "SLC5A8 methyl",
    "SLC5A8 rna"
  ],
  "SLC5A9": [
    "SLC5A9 cnv",
    "SLC5A9 rna"
  ],
  "SLC66A1": [
    "SLC66A1 cnv",
    "SLC66A1 methyl",
    "SLC66A1 rna"
  ],
  "SLC66A1L": [
    "SLC66A1L methyl"
  ],
  "SLC66A2": [
    "SLC66A2 110_116_1_1_S110 phospho",
    "SLC66A2 cnv",
    "SLC66A2 methyl",
    "SLC66A2 rna"
  ],
  "SLC66A3": [
    "SLC66A3 cnv",
    "SLC66A3 methyl",
    "SLC66A3 rna"
  ],
  "SLC6A1": [
    "SLC6A1 cnv",
    "SLC6A1 methyl",
    "SLC6A1 proteo",
    "SLC6A1 rna"
  ],
  "SLC6A11": [
    "SLC6A11 21_30_1_1_S29 phospho",
    "SLC6A11 608_608_1_1_T608 phospho",
    "SLC6A11 cnv",
    "SLC6A11 methyl",
    "SLC6A11 proteo",
    "SLC6A11 rna"
  ],
  "SLC6A12": [
    "SLC6A12 cnv",
    "SLC6A12 methyl",
    "SLC6A12 proteo",
    "SLC6A12 rna"
  ],
  "SLC6A12-AS1": [
    "SLC6A12-AS1 methyl"
  ],
  "SLC6A13": [
    "SLC6A13 cnv",
    "SLC6A13 rna"
  ],
  "SLC6A14": [
    "SLC6A14 rna"
  ],
  "SLC6A15": [
    "SLC6A15 592_599_1_1_S594 phospho",
    "SLC6A15 592_599_2_2_S592S594 phospho",
    "SLC6A15 cnv",
    "SLC6A15 methyl",
    "SLC6A15 rna"
  ],
  "SLC6A16": [
    "SLC6A16 cnv",
    "SLC6A16 methyl",
    "SLC6A16 rna"
  ],
  "SLC6A17": [
    "SLC6A17 13_33_1_0 phospho",
    "SLC6A17 665_673_1_1_S665 phospho",
    "SLC6A17 665_678_1_1_S665 phospho",
    "SLC6A17 682_690_1_1_S682 phospho",
    "SLC6A17 682_690_1_1_S686 phospho",
    "SLC6A17 682_690_2_2_S682S686 phospho",
    "SLC6A17 693_706_1_1_S701 phospho",
    "SLC6A17 713_725_1_1_T722 phospho",
    "SLC6A17 cnv",
    "SLC6A17 methyl",
    "SLC6A17 proteo",
    "SLC6A17 rna"
  ],
  "SLC6A18": [
    "SLC6A18 cnv"
  ],
  "SLC6A19": [
    "SLC6A19 cnv",
    "SLC6A19 methyl",
    "SLC6A19 rna"
  ],
  "SLC6A2": [
    "SLC6A2 cnv",
    "SLC6A2 methyl",
    "SLC6A2 rna"
  ],
  "SLC6A20": [
    "SLC6A20 cnv",
    "SLC6A20 methyl",
    "SLC6A20 rna"
  ],
  "SLC6A3": [
    "SLC6A3 cnv",
    "SLC6A3 methyl",
    "SLC6A3 rna"
  ],
  "SLC6A4": [
    "SLC6A4 cnv",
    "SLC6A4 methyl",
    "SLC6A4 rna"
  ],
  "SLC6A5": [
    "SLC6A5 cnv",
    "SLC6A5 rna"
  ],
  "SLC6A6": [
    "SLC6A6 cnv",
    "SLC6A6 methyl",
    "SLC6A6 rna"
  ],
  "SLC6A7": [
    "SLC6A7 588_600_1_1_S600 phospho",
    "SLC6A7 cnv",
    "SLC6A7 methyl",
    "SLC6A7 rna"
  ],
  "SLC6A8": [
    "SLC6A8 methyl",
    "SLC6A8 rna"
  ],
  "SLC6A9": [
    "SLC6A9 cnv",
    "SLC6A9 methyl",
    "SLC6A9 proteo",
    "SLC6A9 rna"
  ],
  "SLC7A1": [
    "SLC7A1 cnv",
    "SLC7A1 methyl",
    "SLC7A1 proteo",
    "SLC7A1 rna"
  ],
  "SLC7A10": [
    "SLC7A10 19_31_1_1_S21 phospho",
    "SLC7A10 cnv",
    "SLC7A10 methyl",
    "SLC7A10 proteo",
    "SLC7A10 rna"
  ],
  "SLC7A11": [
    "SLC7A11 26_26_1_1_S26 phospho",
    "SLC7A11 cnv",
    "SLC7A11 proteo",
    "SLC7A11 rna"
  ],
  "SLC7A13": [
    "SLC7A13 cnv"
  ],
  "SLC7A14": [
    "SLC7A14 465_480_1_1_S465 phospho",
    "SLC7A14 465_480_2_2_S465S468 phospho",
    "SLC7A14 757_769_1_1_S769 phospho",
    "SLC7A14 cnv",
    "SLC7A14 methyl",
    "SLC7A14 proteo",
    "SLC7A14 rna"
  ],
  "SLC7A2": [
    "SLC7A2 cnv",
    "SLC7A2 methyl",
    "SLC7A2 rna"
  ],
  "SLC7A3": [
    "SLC7A3 methyl",
    "SLC7A3 rna"
  ],
  "SLC7A4": [
    "SLC7A4 cnv",
    "SLC7A4 methyl",
    "SLC7A4 rna"
  ],
  "SLC7A5": [
    "SLC7A5 cnv",
    "SLC7A5 methyl",
    "SLC7A5 proteo",
    "SLC7A5 rna"
  ],
  "SLC7A6": [
    "SLC7A6 cnv",
    "SLC7A6 methyl",
    "SLC7A6 rna"
  ],
  "SLC7A6OS": [
    "SLC7A6OS 16_16_1_1_S16 phospho",
    "SLC7A6OS 300_308_1_1_S308 phospho",
    "SLC7A6OS cnv",
    "SLC7A6OS methyl",
    "SLC7A6OS proteo",
    "SLC7A6OS rna"
  ],
  "SLC7A7": [
    "SLC7A7 cnv",
    "SLC7A7 methyl",
    "SLC7A7 rna"
  ],
  "SLC7A8": [
    "SLC7A8 21_29_1_1_S24 phospho",
    "SLC7A8 cnv",
    "SLC7A8 rna"
  ],
  "SLC7A9": [
    "SLC7A9 cnv",
    "SLC7A9 rna"
  ],
  "SLC8A1": [
    "SLC8A1 284_287_1_0 phospho",
    "SLC8A1 392_407_1_1_S392 phospho",
    "SLC8A1 cnv",
    "SLC8A1 methyl",
    "SLC8A1 proteo",
    "SLC8A1 rna"
  ],
  "SLC8A2": [
    "SLC8A2 622_622_1_1_S622 phospho",
    "SLC8A2 cnv",
    "SLC8A2 methyl",
    "SLC8A2 proteo",
    "SLC8A2 rna"
  ],
  "SLC8A3": [
    "SLC8A3 cnv",
    "SLC8A3 methyl",
    "SLC8A3 rna"
  ],
  "SLC8B1": [
    "SLC8B1 cnv",
    "SLC8B1 methyl",
    "SLC8B1 rna"
  ],
  "SLC9A1": [
    "SLC9A1 599_605_1_1_S605 phospho",
    "SLC9A1 683_697_1_1_S693 phospho",
    "SLC9A1 693_697_1_1_S693 phospho",
    "SLC9A1 769_788_1_1_S785 phospho",
    "SLC9A1 cnv",
    "SLC9A1 methyl",
    "SLC9A1 proteo",
    "SLC9A1 rna"
  ],
  "SLC9A2": [
    "SLC9A2 cnv",
    "SLC9A2 methyl",
    "SLC9A2 rna"
  ],
  "SLC9A3": [
    "SLC9A3 cnv",
    "SLC9A3 methyl",
    "SLC9A3 rna"
  ],
  "SLC9A3R1": [
    "SLC9A3R1 162_170_1_1_S162 phospho",
    "SLC9A3R1 247_280_1_1_S269 phospho",
    "SLC9A3R1 280_280_1_1_S280 phospho",
    "SLC9A3R1 288_302_1_1_S290 phospho",
    "SLC9A3R1 cnv",
    "SLC9A3R1 methyl",
    "SLC9A3R1 proteo",
    "SLC9A3R1 rna"
  ],
  "SLC9A3R2": [
    "SLC9A3R2 20_20_1_1_S20 phospho",
    "SLC9A3R2 cnv",
    "SLC9A3R2 proteo",
    "SLC9A3R2 rna"
  ],
  "SLC9A4": [
    "SLC9A4 cnv",
    "SLC9A4 rna"
  ],
  "SLC9A5": [
    "SLC9A5 cnv",
    "SLC9A5 methyl",
    "SLC9A5 rna"
  ],
  "SLC9A6": [
    "SLC9A6 methyl",
    "SLC9A6 proteo",
    "SLC9A6 rna"
  ],
  "SLC9A7": [
    "SLC9A7 methyl",
    "SLC9A7 proteo",
    "SLC9A7 rna"
  ],
  "SLC9A7P1": [
    "SLC9A7P1 methyl"
  ],
  "SLC9A8": [
    "SLC9A8 cnv",
    "SLC9A8 methyl",
    "SLC9A8 rna"
  ],
  "SLC9A9": [
    "SLC9A9 612_631_1_1_S612 phospho",
    "SLC9A9 cnv",
    "SLC9A9 proteo",
    "SLC9A9 rna"
  ],
  "SLC9B1": [
    "SLC9B1 cnv",
    "SLC9B1 methyl",
    "SLC9B1 rna"
  ],
  "SLC9B2": [
    "SLC9B2 46_49_1_1_S49 phospho",
    "SLC9B2 cnv",
    "SLC9B2 methyl",
    "SLC9B2 proteo",
    "SLC9B2 rna"
  ],
  "SLC9C1": [
    "SLC9C1 cnv",
    "SLC9C1 rna"
  ],
  "SLC9C2": [
    "SLC9C2 cnv",
    "SLC9C2 rna"
  ],
  "SLCO1A2": [
    "SLCO1A2 cnv",
    "SLCO1A2 rna"
  ],
  "SLCO1B1": [
    "SLCO1B1 cnv",
    "SLCO1B1 rna"
  ],
  "SLCO1B3": [
    "SLCO1B3 cnv",
    "SLCO1B3 rna"
  ],
  "SLCO1B3-SLCO1B7": [
    "SLCO1B3-SLCO1B7 cnv"
  ],
  "SLCO1B7": [
    "SLCO1B7 cnv",
    "SLCO1B7 rna"
  ],
  "SLCO1C1": [
    "SLCO1C1 cnv",
    "SLCO1C1 rna"
  ],
  "SLCO2A1": [
    "SLCO2A1 cnv",
    "SLCO2A1 methyl",
    "SLCO2A1 proteo",
    "SLCO2A1 rna"
  ],
  "SLCO2B1": [
    "SLCO2B1 296_298_1_1_S298 phospho",
    "SLCO2B1 cnv",
    "SLCO2B1 proteo",
    "SLCO2B1 rna"
  ],
  "SLCO3A1": [
    "SLCO3A1 cnv",
    "SLCO3A1 methyl",
    "SLCO3A1 proteo",
    "SLCO3A1 rna"
  ],
  "SLCO4A1": [
    "SLCO4A1 cnv",
    "SLCO4A1 methyl",
    "SLCO4A1 rna"
  ],
  "SLCO4C1": [
    "SLCO4C1 cnv",
    "SLCO4C1 methyl",
    "SLCO4C1 rna"
  ],
  "SLCO5A1": [
    "SLCO5A1 cnv",
    "SLCO5A1 methyl",
    "SLCO5A1 rna"
  ],
  "SLCO6A1": [
    "SLCO6A1 cnv",
    "SLCO6A1 methyl",
    "SLCO6A1 rna"
  ],
  "SLF1": [
    "SLF1 cnv",
    "SLF1 methyl",
    "SLF1 rna"
  ],
  "SLF2": [
    "SLF2 cnv",
    "SLF2 methyl",
    "SLF2 rna"
  ],
  "SLFN11": [
    "SLFN11 cnv",
    "SLFN11 methyl",
    "SLFN11 proteo",
    "SLFN11 rna"
  ],
  "SLFN12": [
    "SLFN12 cnv",
    "SLFN12 rna"
  ],
  "SLFN12L": [
    "SLFN12L cnv",
    "SLFN12L methyl",
    "SLFN12L rna"
  ],
  "SLFN13": [
    "SLFN13 cnv",
    "SLFN13 methyl",
    "SLFN13 rna"
  ],
  "SLFN14": [
    "SLFN14 cnv",
    "SLFN14 rna"
  ],
  "SLFN5": [
    "SLFN5 cnv",
    "SLFN5 methyl",
    "SLFN5 proteo",
    "SLFN5 rna"
  ],
  "SLFNL1": [
    "SLFNL1 cnv",
    "SLFNL1 rna"
  ],
  "SLIRP": [
    "SLIRP 99_100_1_1_S100 phospho",
    "SLIRP cnv",
    "SLIRP methyl",
    "SLIRP proteo",
    "SLIRP rna"
  ],
  "SLIT1": [
    "SLIT1 cnv",
    "SLIT1 methyl",
    "SLIT1 proteo",
    "SLIT1 rna"
  ],
  "SLIT2": [
    "SLIT2 cnv",
    "SLIT2 methyl",
    "SLIT2 proteo",
    "SLIT2 rna"
  ],
  "SLIT3": [
    "SLIT3 cnv",
    "SLIT3 methyl",
    "SLIT3 rna"
  ],
  "SLITRK1": [
    "SLITRK1 cnv",
    "SLITRK1 proteo",
    "SLITRK1 rna"
  ],
  "SLITRK2": [
    "SLITRK2 methyl",
    "SLITRK2 proteo",
    "SLITRK2 rna"
  ],
  "SLITRK3": [
    "SLITRK3 cnv",
    "SLITRK3 proteo",
    "SLITRK3 rna"
  ],
  "SLITRK4": [
    "SLITRK4 methyl",
    "SLITRK4 proteo",
    "SLITRK4 rna"
  ],
  "SLITRK5": [
    "SLITRK5 cnv",
    "SLITRK5 methyl",
    "SLITRK5 rna"
  ],
  "SLITRK6": [
    "SLITRK6 cnv",
    "SLITRK6 rna"
  ],
  "SLK": [
    "SLK 189_207_1_1_S189 phospho",
    "SLK 340_348_1_1_S340 phospho",
    "SLK 565_571_1_0 phospho",
    "SLK cnv",
    "SLK kinase",
    "SLK methyl",
    "SLK proteo",
    "SLK rna"
  ],
  "SLMAP": [
    "SLMAP 139_148_1_1_S148 phospho",
    "SLMAP 445_454_1_1_S452 phospho",
    "SLMAP cnv",
    "SLMAP methyl",
    "SLMAP proteo",
    "SLMAP rna"
  ],
  "SLN": [
    "SLN cnv",
    "SLN rna"
  ],
  "SLPI": [
    "SLPI cnv",
    "SLPI rna"
  ],
  "SLTM": [
    "SLTM 271_271_1_1_S271 phospho",
    "SLTM 271_276_1_1_S271 phospho",
    "SLTM 271_279_1_1_S271 phospho",
    "SLTM 532_545_1_0 phospho",
    "SLTM 532_545_1_1_S535 phospho",
    "SLTM 532_545_2_2_S533S535 phospho",
    "SLTM 535_545_1_1_S535 phospho",
    "SLTM 977_984_1_1_S984 phospho",
    "SLTM cnv",
    "SLTM methyl",
    "SLTM proteo",
    "SLTM rna"
  ],
  "SLU7": [
    "SLU7 215_215_1_1_S215 phospho",
    "SLU7 235_235_1_1_S235 phospho",
    "SLU7 cnv",
    "SLU7 methyl",
    "SLU7 proteo",
    "SLU7 rna"
  ],
  "SLURP1": [
    "SLURP1 cnv",
    "SLURP1 rna"
  ],
  "SLURP2": [
    "SLURP2 cnv",
    "SLURP2 rna"
  ],
  "SLX1A": [
    "SLX1A cnv",
    "SLX1A rna"
  ],
  "SLX1A-SULT1A3": [
    "SLX1A-SULT1A3 cnv",
    "SLX1A-SULT1A3 rna"
  ],
  "SLX1B": [
    "SLX1B cnv",
    "SLX1B rna"
  ],
  "SLX1B-SULT1A4": [
    "SLX1B-SULT1A4 cnv",
    "SLX1B-SULT1A4 rna"
  ],
  "SLX4": [
    "SLX4 cnv",
    "SLX4 methyl",
    "SLX4 rna"
  ],
  "SLX4IP": [
    "SLX4IP cnv",
    "SLX4IP methyl",
    "SLX4IP rna"
  ],
  "SLX9": [
    "SLX9 cnv",
    "SLX9 methyl",
    "SLX9 proteo",
    "SLX9 rna"
  ],
  "SMAD1": [
    "SMAD1 cnv",
    "SMAD1 methyl",
    "SMAD1 proteo",
    "SMAD1 rna"
  ],
  "SMAD2": [
    "SMAD2 cnv",
    "SMAD2 methyl",
    "SMAD2 proteo",
    "SMAD2 rna"
  ],
  "SMAD3": [
    "SMAD3 cnv",
    "SMAD3 methyl",
    "SMAD3 proteo",
    "SMAD3 rna"
  ],
  "SMAD4": [
    "SMAD4 cnv",
    "SMAD4 methyl",
    "SMAD4 proteo",
    "SMAD4 rna"
  ],
  "SMAD5": [
    "SMAD5 cnv",
    "SMAD5 methyl",
    "SMAD5 proteo",
    "SMAD5 rna"
  ],
  "SMAD6": [
    "SMAD6 cnv",
    "SMAD6 methyl",
    "SMAD6 rna"
  ],
  "SMAD7": [
    "SMAD7 cnv",
    "SMAD7 methyl",
    "SMAD7 rna"
  ],
  "SMAD9": [
    "SMAD9 cnv",
    "SMAD9 methyl",
    "SMAD9 rna"
  ],
  "SMAGP": [
    "SMAGP cnv",
    "SMAGP methyl",
    "SMAGP rna"
  ],
  "SMAP1": [
    "SMAP1 137_154_1_1_S152 phospho",
    "SMAP1 cnv",
    "SMAP1 methyl",
    "SMAP1 proteo",
    "SMAP1 rna"
  ],
  "SMAP2": [
    "SMAP2 186_195_1_1_S189 phospho",
    "SMAP2 201_223_1_1_S210 phospho",
    "SMAP2 cnv",
    "SMAP2 methyl",
    "SMAP2 proteo",
    "SMAP2 rna"
  ],
  "SMARCA1": [
    "SMARCA1 methyl",
    "SMARCA1 proteo",
    "SMARCA1 rna"
  ],
  "SMARCA2": [
    "SMARCA2 1377_1377_1_1_S1377 phospho",
    "SMARCA2 1568_1572_1_1_S1572 phospho",
    "SMARCA2 288_316_1_1_S288 phospho",
    "SMARCA2 cnv",
    "SMARCA2 methyl",
    "SMARCA2 proteo",
    "SMARCA2 rna"
  ],
  "SMARCA4": [
    "SMARCA4 1387_1398_1_1_T1393 phospho",
    "SMARCA4 1422_1429_1_1_S1422 phospho",
    "SMARCA4 1597_1601_1_1_S1601 phospho",
    "SMARCA4 1597_1601_2_2_S1597S1601 phospho",
    "SMARCA4 695_699_1_1_S699 phospho",
    "SMARCA4 cnv",
    "SMARCA4 methyl",
    "SMARCA4 proteo",
    "SMARCA4 rna"
  ],
  "SMARCA5": [
    "SMARCA5 cnv",
    "SMARCA5 methyl",
    "SMARCA5 proteo",
    "SMARCA5 rna"
  ],
  "SMARCAD1": [
    "SMARCAD1 119_137_2_2_S124S127 phospho",
    "SMARCAD1 91_109_1_1_S96 phospho",
    "SMARCAD1 cnv",
    "SMARCAD1 methyl",
    "SMARCAD1 proteo",
    "SMARCAD1 rna"
  ],
  "SMARCAD1-DT": [
    "SMARCAD1-DT methyl"
  ],
  "SMARCAL1": [
    "SMARCAL1 cnv",
    "SMARCAL1 methyl",
    "SMARCAL1 proteo",
    "SMARCAL1 rna"
  ],
  "SMARCB1": [
    "SMARCB1 cnv",
    "SMARCB1 proteo",
    "SMARCB1 rna"
  ],
  "SMARCC1": [
    "SMARCC1 310_310_1_1_S310 phospho",
    "SMARCC1 328_339_1_1_S328 phospho",
    "SMARCC1 328_339_2_2_S328S330 phospho",
    "SMARCC1 328_339_3_3_S328S330T335 phospho",
    "SMARCC1 cnv",
    "SMARCC1 methyl",
    "SMARCC1 proteo",
    "SMARCC1 rna"
  ],
  "SMARCC2": [
    "SMARCC2 340_356_1_1_S347 phospho",
    "SMARCC2 583_586_1_1_S586 phospho",
    "SMARCC2 cnv",
    "SMARCC2 methyl",
    "SMARCC2 proteo",
    "SMARCC2 rna"
  ],
  "SMARCD1": [
    "SMARCD1 cnv",
    "SMARCD1 methyl",
    "SMARCD1 proteo",
    "SMARCD1 rna"
  ],
  "SMARCD2": [
    "SMARCD2 cnv",
    "SMARCD2 methyl",
    "SMARCD2 proteo",
    "SMARCD2 rna"
  ],
  "SMARCD3": [
    "SMARCD3 cnv",
    "SMARCD3 methyl",
    "SMARCD3 proteo",
    "SMARCD3 rna"
  ],
  "SMARCE1": [
    "SMARCE1 cnv",
    "SMARCE1 methyl",
    "SMARCE1 proteo",
    "SMARCE1 rna"
  ],
  "SMC1A": [
    "SMC1A 924_944_1_1_S934 phospho",
    "SMC1A methyl",
    "SMC1A proteo",
    "SMC1A rna"
  ],
  "SMC1B": [
    "SMC1B cnv",
    "SMC1B methyl",
    "SMC1B rna"
  ],
  "SMC2": [
    "SMC2 cnv",
    "SMC2 methyl",
    "SMC2 proteo",
    "SMC2 rna"
  ],
  "SMC3": [
    "SMC3 1065_1077_1_0 phospho",
    "SMC3 1065_1077_1_1_S1067 phospho",
    "SMC3 1065_1077_1_1_S1074 phospho",
    "SMC3 1065_1077_2_2_S1065S1067 phospho",
    "SMC3 1065_1077_2_2_S1067S1074 phospho",
    "SMC3 cnv",
    "SMC3 methyl",
    "SMC3 proteo",
    "SMC3 rna"
  ],
  "SMC4": [
    "SMC4 22_36_1_1_S28 phospho",
    "SMC4 22_36_2_0 phospho",
    "SMC4 39_50_1_1_S41 phospho",
    "SMC4 cnv",
    "SMC4 methyl",
    "SMC4 proteo",
    "SMC4 rna"
  ],
  "SMC5": [
    "SMC5 8_16_1_1_S12 phospho",
    "SMC5 cnv",
    "SMC5 methyl",
    "SMC5 proteo",
    "SMC5 rna"
  ],
  "SMC6": [
    "SMC6 cnv",
    "SMC6 methyl",
    "SMC6 proteo",
    "SMC6 rna"
  ],
  "SMCHD1": [
    "SMCHD1 cnv",
    "SMCHD1 methyl",
    "SMCHD1 proteo",
    "SMCHD1 rna"
  ],
  "SMCO1": [
    "SMCO1 cnv",
    "SMCO1 rna"
  ],
  "SMCO2": [
    "SMCO2 cnv",
    "SMCO2 rna"
  ],
  "SMCO3": [
    "SMCO3 cnv",
    "SMCO3 rna"
  ],
  "SMCO4": [
    "SMCO4 cnv",
    "SMCO4 methyl",
    "SMCO4 rna"
  ],
  "SMCP": [
    "SMCP cnv",
    "SMCP rna"
  ],
  "SMCR8": [
    "SMCR8 487_498_1_1_S489 phospho",
    "SMCR8 487_498_1_1_S498 phospho",
    "SMCR8 790_801_1_1_S790 phospho",
    "SMCR8 cnv",
    "SMCR8 methyl",
    "SMCR8 proteo",
    "SMCR8 rna"
  ],
  "SMDT1": [
    "SMDT1 cnv",
    "SMDT1 methyl",
    "SMDT1 rna"
  ],
  "SMG1": [
    "SMG1 cnv",
    "SMG1 kinase",
    "SMG1 methyl",
    "SMG1 proteo",
    "SMG1 rna"
  ],
  "SMG1P5": [
    "SMG1P5 methyl"
  ],
  "SMG5": [
    "SMG5 cnv",
    "SMG5 methyl",
    "SMG5 proteo",
    "SMG5 rna"
  ],
  "SMG6": [
    "SMG6 cnv",
    "SMG6 methyl",
    "SMG6 proteo",
    "SMG6 rna"
  ],
  "SMG7": [
    "SMG7 739_755_1_1_S739 phospho",
    "SMG7 cnv",
    "SMG7 methyl",
    "SMG7 proteo",
    "SMG7 rna"
  ],
  "SMG8": [
    "SMG8 742_753_1_0 phospho",
    "SMG8 742_753_1_1_S742 phospho",
    "SMG8 cnv",
    "SMG8 methyl",
    "SMG8 proteo",
    "SMG8 rna"
  ],
  "SMG9": [
    "SMG9 114_122_1_1_T118 phospho",
    "SMG9 450_460_1_1_S451 phospho",
    "SMG9 cnv",
    "SMG9 methyl",
    "SMG9 proteo",
    "SMG9 rna"
  ],
  "SMIM1": [
    "SMIM1 cnv",
    "SMIM1 methyl",
    "SMIM1 proteo",
    "SMIM1 rna"
  ],
  "SMIM10": [
    "SMIM10 methyl",
    "SMIM10 rna"
  ],
  "SMIM10L1": [
    "SMIM10L1 cnv",
    "SMIM10L1 methyl",
    "SMIM10L1 rna"
  ],
  "SMIM10L2A": [
    "SMIM10L2A methyl",
    "SMIM10L2A rna"
  ],
  "SMIM10L2B": [
    "SMIM10L2B methyl",
    "SMIM10L2B rna"
  ],
  "SMIM11": [
    "SMIM11 cnv",
    "SMIM11 methyl",
    "SMIM11 rna"
  ],
  "SMIM11B": [
    "SMIM11B cnv",
    "SMIM11B rna"
  ],
  "SMIM12": [
    "SMIM12 cnv",
    "SMIM12 methyl",
    "SMIM12 proteo",
    "SMIM12 rna"
  ],
  "SMIM13": [
    "SMIM13 48_69_1_1_S50 phospho",
    "SMIM13 48_69_2_2_S58S60 phospho",
    "SMIM13 cnv",
    "SMIM13 methyl",
    "SMIM13 proteo",
    "SMIM13 rna"
  ],
  "SMIM14": [
    "SMIM14 cnv",
    "SMIM14 methyl",
    "SMIM14 rna"
  ],
  "SMIM15": [
    "SMIM15 cnv",
    "SMIM15 methyl",
    "SMIM15 rna"
  ],
  "SMIM17": [
    "SMIM17 cnv",
    "SMIM17 methyl",
    "SMIM17 rna"
  ],
  "SMIM18": [
    "SMIM18 cnv",
    "SMIM18 rna"
  ],
  "SMIM19": [
    "SMIM19 cnv",
    "SMIM19 methyl",
    "SMIM19 rna"
  ],
  "SMIM2": [
    "SMIM2 cnv",
    "SMIM2 rna"
  ],
  "SMIM20": [
    "SMIM20 cnv",
    "SMIM20 methyl",
    "SMIM20 proteo",
    "SMIM20 rna"
  ],
  "SMIM21": [
    "SMIM21 cnv"
  ],
  "SMIM22": [
    "SMIM22 cnv",
    "SMIM22 rna"
  ],
  "SMIM23": [
    "SMIM23 cnv"
  ],
  "SMIM24": [
    "SMIM24 cnv",
    "SMIM24 rna"
  ],
  "SMIM26": [
    "SMIM26 cnv",
    "SMIM26 methyl",
    "SMIM26 rna"
  ],
  "SMIM27": [
    "SMIM27 cnv",
    "SMIM27 methyl",
    "SMIM27 rna"
  ],
  "SMIM28": [
    "SMIM28 cnv",
    "SMIM28 rna"
  ],
  "SMIM29": [
    "SMIM29 cnv",
    "SMIM29 methyl",
    "SMIM29 rna"
  ],
  "SMIM3": [
    "SMIM3 cnv",
    "SMIM3 rna"
  ],
  "SMIM30": [
    "SMIM30 cnv",
    "SMIM30 rna"
  ],
  "SMIM31": [
    "SMIM31 cnv",
    "SMIM31 rna"
  ],
  "SMIM32": [
    "SMIM32 cnv",
    "SMIM32 methyl",
    "SMIM32 rna"
  ],
  "SMIM33": [
    "SMIM33 cnv",
    "SMIM33 rna"
  ],
  "SMIM34": [
    "SMIM34 cnv",
    "SMIM34 rna"
  ],
  "SMIM34B": [
    "SMIM34B cnv",
    "SMIM34B rna"
  ],
  "SMIM35": [
    "SMIM35 cnv",
    "SMIM35 rna"
  ],
  "SMIM36": [
    "SMIM36 cnv",
    "SMIM36 rna"
  ],
  "SMIM38": [
    "SMIM38 cnv",
    "SMIM38 methyl",
    "SMIM38 rna"
  ],
  "SMIM39": [
    "SMIM39 cnv",
    "SMIM39 rna"
  ],
  "SMIM4": [
    "SMIM4 cnv",
    "SMIM4 methyl",
    "SMIM4 rna"
  ],
  "SMIM40": [
    "SMIM40 cnv",
    "SMIM40 rna"
  ],
  "SMIM41": [
    "SMIM41 cnv",
    "SMIM41 methyl",
    "SMIM41 rna"
  ],
  "SMIM42": [
    "SMIM42 cnv"
  ],
  "SMIM43": [
    "SMIM43 cnv",
    "SMIM43 methyl",
    "SMIM43 rna"
  ],
  "SMIM44": [
    "SMIM44 cnv",
    "SMIM44 rna"
  ],
  "SMIM45": [
    "SMIM45 cnv",
    "SMIM45 rna"
  ],
  "SMIM5": [
    "SMIM5 cnv",
    "SMIM5 rna"
  ],
  "SMIM6": [
    "SMIM6 cnv",
    "SMIM6 rna"
  ],
  "SMIM7": [
    "SMIM7 cnv",
    "SMIM7 methyl",
    "SMIM7 rna"
  ],
  "SMIM8": [
    "SMIM8 cnv",
    "SMIM8 methyl",
    "SMIM8 rna"
  ],
  "SMIM9": [
    "SMIM9 rna"
  ],
  "SMKR1": [
    "SMKR1 cnv",
    "SMKR1 methyl",
    "SMKR1 rna"
  ],
  "SMLR1": [
    "SMLR1 cnv",
    "SMLR1 rna"
  ],
  "SMN1": [
    "SMN1 cnv",
    "SMN1 rna"
  ],
  "SMN2": [
    "SMN2 cnv",
    "SMN2 rna"
  ],
  "SMNDC1": [
    "SMNDC1 cnv",
    "SMNDC1 methyl",
    "SMNDC1 proteo",
    "SMNDC1 rna"
  ],
  "SMO": [
    "SMO cnv",
    "SMO methyl",
    "SMO rna"
  ],
  "SMOC1": [
    "SMOC1 cnv",
    "SMOC1 methyl",
    "SMOC1 proteo",
    "SMOC1 rna"
  ],
  "SMOC2": [
    "SMOC2 cnv",
    "SMOC2 methyl",
    "SMOC2 rna"
  ],
  "SMOX": [
    "SMOX cnv",
    "SMOX methyl",
    "SMOX proteo",
    "SMOX rna"
  ],
  "SMPD1": [
    "SMPD1 cnv",
    "SMPD1 methyl",
    "SMPD1 proteo",
    "SMPD1 rna"
  ],
  "SMPD2": [
    "SMPD2 cnv",
    "SMPD2 methyl",
    "SMPD2 proteo",
    "SMPD2 rna"
  ],
  "SMPD3": [
    "SMPD3 279_298_1_1_S291 phospho",
    "SMPD3 cnv",
    "SMPD3 methyl",
    "SMPD3 proteo",
    "SMPD3 rna"
  ],
  "SMPD4": [
    "SMPD4 cnv",
    "SMPD4 methyl",
    "SMPD4 proteo",
    "SMPD4 rna"
  ],
  "SMPD4BP": [
    "SMPD4BP methyl"
  ],
  "SMPDL3A": [
    "SMPDL3A cnv",
    "SMPDL3A methyl",
    "SMPDL3A rna"
  ],
  "SMPDL3B": [
    "SMPDL3B cnv",
    "SMPDL3B rna"
  ],
  "SMPX": [
    "SMPX rna"
  ],
  "SMR3A": [
    "SMR3A cnv"
  ],
  "SMR3B": [
    "SMR3B cnv"
  ],
  "SMS": [
    "SMS methyl",
    "SMS proteo",
    "SMS rna"
  ],
  "SMTN": [
    "SMTN 875_885_1_1_S877 phospho",
    "SMTN cnv",
    "SMTN methyl",
    "SMTN proteo",
    "SMTN rna"
  ],
  "SMTNL1": [
    "SMTNL1 cnv",
    "SMTNL1 rna"
  ],
  "SMTNL2": [
    "SMTNL2 cnv",
    "SMTNL2 methyl",
    "SMTNL2 rna"
  ],
  "SMU1": [
    "SMU1 cnv",
    "SMU1 methyl",
    "SMU1 proteo",
    "SMU1 rna"
  ],
  "SMUG1": [
    "SMUG1 cnv",
    "SMUG1 proteo",
    "SMUG1 rna"
  ],
  "SMURF1": [
    "SMURF1 cnv",
    "SMURF1 methyl",
    "SMURF1 rna"
  ],
  "SMURF2": [
    "SMURF2 cnv",
    "SMURF2 methyl",
    "SMURF2 proteo",
    "SMURF2 rna"
  ],
  "SMYD1": [
    "SMYD1 cnv",
    "SMYD1 rna"
  ],
  "SMYD2": [
    "SMYD2 cnv",
    "SMYD2 methyl",
    "SMYD2 proteo",
    "SMYD2 rna"
  ],
  "SMYD3": [
    "SMYD3 22_22_1_1_T22 phospho",
    "SMYD3 cnv",
    "SMYD3 methyl",
    "SMYD3 proteo",
    "SMYD3 rna"
  ],
  "SMYD4": [
    "SMYD4 cnv",
    "SMYD4 methyl",
    "SMYD4 proteo",
    "SMYD4 rna"
  ],
  "SMYD5": [
    "SMYD5 cnv",
    "SMYD5 methyl",
    "SMYD5 proteo",
    "SMYD5 rna"
  ],
  "SNAI1": [
    "SNAI1 cnv",
    "SNAI1 methyl",
    "SNAI1 rna"
  ],
  "SNAI2": [
    "SNAI2 cnv",
    "SNAI2 rna"
  ],
  "SNAI3": [
    "SNAI3 cnv",
    "SNAI3 methyl",
    "SNAI3 rna"
  ],
  "SNAI3-AS1": [
    "SNAI3-AS1 methyl"
  ],
  "SNAP23": [
    "SNAP23 101_116_1_1_S110 phospho",
    "SNAP23 cnv",
    "SNAP23 methyl",
    "SNAP23 proteo",
    "SNAP23 rna"
  ],
  "SNAP25": [
    "SNAP25 cnv",
    "SNAP25 methyl",
    "SNAP25 proteo",
    "SNAP25 rna"
  ],
  "SNAP29": [
    "SNAP29 cnv",
    "SNAP29 methyl",
    "SNAP29 proteo",
    "SNAP29 rna"
  ],
  "SNAP47": [
    "SNAP47 cnv",
    "SNAP47 methyl",
    "SNAP47 proteo",
    "SNAP47 rna"
  ],
  "SNAP91": [
    "SNAP91 296_303_1_1_S296 phospho",
    "SNAP91 296_303_1_1_S300 phospho",
    "SNAP91 296_303_2_2_S296S300 phospho",
    "SNAP91 305_317_1_1_S313 phospho",
    "SNAP91 321_343_1_1_S325 phospho",
    "SNAP91 cnv",
    "SNAP91 methyl",
    "SNAP91 proteo",
    "SNAP91 rna"
  ],
  "SNAPC1": [
    "SNAPC1 cnv",
    "SNAPC1 methyl",
    "SNAPC1 rna"
  ],
  "SNAPC2": [
    "SNAPC2 cnv",
    "SNAPC2 methyl",
    "SNAPC2 rna"
  ],
  "SNAPC3": [
    "SNAPC3 cnv",
    "SNAPC3 methyl",
    "SNAPC3 rna"
  ],
  "SNAPC4": [
    "SNAPC4 cnv",
    "SNAPC4 methyl",
    "SNAPC4 proteo",
    "SNAPC4 rna"
  ],
  "SNAPC5": [
    "SNAPC5 cnv",
    "SNAPC5 methyl",
    "SNAPC5 proteo",
    "SNAPC5 rna"
  ],
  "SNAPIN": [
    "SNAPIN 126_133_1_1_S133 phospho",
    "SNAPIN cnv",
    "SNAPIN methyl",
    "SNAPIN proteo",
    "SNAPIN rna"
  ],
  "SNCA": [
    "SNCA cnv",
    "SNCA methyl",
    "SNCA proteo",
    "SNCA rna"
  ],
  "SNCAIP": [
    "SNCAIP 721_732_1_1_S723 phospho",
    "SNCAIP cnv",
    "SNCAIP methyl",
    "SNCAIP proteo",
    "SNCAIP rna"
  ],
  "SNCB": [
    "SNCB cnv",
    "SNCB methyl",
    "SNCB proteo",
    "SNCB rna"
  ],
  "SNCG": [
    "SNCG cnv",
    "SNCG proteo",
    "SNCG rna"
  ],
  "SND1": [
    "SND1 238_240_1_1_T240 phospho",
    "SND1 418_436_1_1_S426 phospho",
    "SND1 908_909_1_1_S909 phospho",
    "SND1 cnv",
    "SND1 methyl",
    "SND1 proteo",
    "SND1 rna"
  ],
  "SNED1": [
    "SNED1 cnv",
    "SNED1 methyl",
    "SNED1 proteo",
    "SNED1 rna"
  ],
  "SNF8": [
    "SNF8 cnv",
    "SNF8 methyl",
    "SNF8 proteo",
    "SNF8 rna"
  ],
  "SNHG1": [
    "SNHG1 methyl"
  ],
  "SNHG10": [
    "SNHG10 methyl"
  ],
  "SNHG11": [
    "SNHG11 methyl"
  ],
  "SNHG12": [
    "SNHG12 methyl"
  ],
  "SNHG15": [
    "SNHG15 methyl"
  ],
  "SNHG16": [
    "SNHG16 methyl"
  ],
  "SNHG17": [
    "SNHG17 methyl"
  ],
  "SNHG20": [
    "SNHG20 methyl"
  ],
  "SNHG21": [
    "SNHG21 methyl"
  ],
  "SNHG22": [
    "SNHG22 methyl"
  ],
  "SNHG26": [
    "SNHG26 methyl"
  ],
  "SNHG28": [
    "SNHG28 methyl"
  ],
  "SNHG29": [
    "SNHG29 methyl"
  ],
  "SNHG32": [
    "SNHG32 methyl"
  ],
  "SNHG7": [
    "SNHG7 methyl"
  ],
  "SNIP1": [
    "SNIP1 35_35_1_1_S35 phospho",
    "SNIP1 49_58_1_1_S52 phospho",
    "SNIP1 49_58_2_2_S52S54 phospho",
    "SNIP1 74_76_1_1_S76 phospho",
    "SNIP1 cnv",
    "SNIP1 proteo",
    "SNIP1 rna"
  ],
  "SNN": [
    "SNN cnv",
    "SNN methyl",
    "SNN proteo",
    "SNN rna"
  ],
  "SNORA13": [
    "SNORA13 methyl"
  ],
  "SNORA14B": [
    "SNORA14B methyl"
  ],
  "SNORA16A": [
    "SNORA16A methyl"
  ],
  "SNORA17A": [
    "SNORA17A methyl"
  ],
  "SNORA21B": [
    "SNORA21B methyl"
  ],
  "SNORA24": [
    "SNORA24 methyl"
  ],
  "SNORA24B": [
    "SNORA24B methyl"
  ],
  "SNORA26": [
    "SNORA26 methyl"
  ],
  "SNORA48": [
    "SNORA48 methyl"
  ],
  "SNORA50C": [
    "SNORA50C methyl"
  ],
  "SNORA57": [
    "SNORA57 methyl"
  ],
  "SNORA78": [
    "SNORA78 methyl"
  ],
  "SNORA7A": [
    "SNORA7A methyl"
  ],
  "SNORA84": [
    "SNORA84 methyl"
  ],
  "SNORA9": [
    "SNORA9 methyl"
  ],
  "SNORC": [
    "SNORC cnv",
    "SNORC rna"
  ],
  "SNORD101": [
    "SNORD101 methyl"
  ],
  "SNORD15A": [
    "SNORD15A methyl"
  ],
  "SNORD24": [
    "SNORD24 methyl"
  ],
  "SNORD25": [
    "SNORD25 methyl"
  ],
  "SNORD26": [
    "SNORD26 methyl"
  ],
  "SNORD27": [
    "SNORD27 methyl"
  ],
  "SNORD37": [
    "SNORD37 methyl"
  ],
  "SNORD42B": [
    "SNORD42B methyl"
  ],
  "SNORD43": [
    "SNORD43 methyl"
  ],
  "SNORD46": [
    "SNORD46 methyl"
  ],
  "SNORD48": [
    "SNORD48 methyl"
  ],
  "SNORD49A": [
    "SNORD49A methyl"
  ],
  "SNORD54": [
    "SNORD54 methyl"
  ],
  "SNORD55": [
    "SNORD55 methyl"
  ],
  "SNORD58A": [
    "SNORD58A methyl"
  ],
  "SNORD58B": [
    "SNORD58B methyl"
  ],
  "SNORD59A": [
    "SNORD59A methyl"
  ],
  "SNORD60": [
    "SNORD60 methyl"
  ],
  "SNORD61": [
    "SNORD61 methyl"
  ],
  "SNORD84": [
    "SNORD84 methyl"
  ],
  "SNORD95": [
    "SNORD95 methyl"
  ],
  "SNPH": [
    "SNPH 523_536_1_1_S530 phospho",
    "SNPH 63_68_1_1_S64 phospho",
    "SNPH cnv",
    "SNPH methyl",
    "SNPH proteo",
    "SNPH rna"
  ],
  "SNRK": [
    "SNRK 518_521_1_1_S518 phospho",
    "SNRK 569_584_1_1_S569 phospho",
    "SNRK cnv",
    "SNRK kinase",
    "SNRK methyl",
    "SNRK proteo",
    "SNRK rna"
  ],
  "SNRNP200": [
    "SNRNP200 225_225_1_1_S225 phospho",
    "SNRNP200 cnv",
    "SNRNP200 methyl",
    "SNRNP200 proteo",
    "SNRNP200 rna"
  ],
  "SNRNP25": [
    "SNRNP25 cnv",
    "SNRNP25 methyl",
    "SNRNP25 rna"
  ],
  "SNRNP27": [
    "SNRNP27 123_132_1_1_S132 phospho",
    "SNRNP27 cnv",
    "SNRNP27 proteo",
    "SNRNP27 rna"
  ],
  "SNRNP35": [
    "SNRNP35 cnv",
    "SNRNP35 methyl",
    "SNRNP35 rna"
  ],
  "SNRNP40": [
    "SNRNP40 cnv",
    "SNRNP40 methyl",
    "SNRNP40 proteo",
    "SNRNP40 rna"
  ],
  "SNRNP48": [
    "SNRNP48 cnv",
    "SNRNP48 methyl",
    "SNRNP48 proteo",
    "SNRNP48 rna"
  ],
  "SNRNP70": [
    "SNRNP70 219_226_1_1_S226 phospho",
    "SNRNP70 320_320_1_1_S320 phospho",
    "SNRNP70 410_410_1_1_S410 phospho",
    "SNRNP70 cnv",
    "SNRNP70 methyl",
    "SNRNP70 proteo",
    "SNRNP70 rna"
  ],
  "SNRPA": [
    "SNRPA cnv",
    "SNRPA methyl",
    "SNRPA proteo",
    "SNRPA rna"
  ],
  "SNRPA1": [
    "SNRPA1 cnv",
    "SNRPA1 methyl",
    "SNRPA1 proteo",
    "SNRPA1 rna"
  ],
  "SNRPB": [
    "SNRPB cnv",
    "SNRPB methyl",
    "SNRPB proteo",
    "SNRPB rna"
  ],
  "SNRPB2": [
    "SNRPB2 cnv",
    "SNRPB2 methyl",
    "SNRPB2 proteo",
    "SNRPB2 rna"
  ],
  "SNRPC": [
    "SNRPC 5_19_1_1_S17 phospho",
    "SNRPC cnv",
    "SNRPC methyl",
    "SNRPC proteo",
    "SNRPC rna"
  ],
  "SNRPD1": [
    "SNRPD1 cnv",
    "SNRPD1 methyl",
    "SNRPD1 proteo",
    "SNRPD1 rna"
  ],
  "SNRPD2": [
    "SNRPD2 cnv",
    "SNRPD2 methyl",
    "SNRPD2 proteo",
    "SNRPD2 rna"
  ],
  "SNRPD3": [
    "SNRPD3 cnv",
    "SNRPD3 methyl",
    "SNRPD3 proteo",
    "SNRPD3 rna"
  ],
  "SNRPE": [
    "SNRPE cnv",
    "SNRPE methyl",
    "SNRPE proteo",
    "SNRPE rna"
  ],
  "SNRPF": [
    "SNRPF cnv",
    "SNRPF methyl",
    "SNRPF proteo",
    "SNRPF rna"
  ],
  "SNRPF-DT": [
    "SNRPF-DT methyl"
  ],
  "SNRPG": [
    "SNRPG cnv",
    "SNRPG methyl",
    "SNRPG proteo",
    "SNRPG rna"
  ],
  "SNRPN": [
    "SNRPN cnv",
    "SNRPN methyl",
    "SNRPN rna"
  ],
  "SNTA1": [
    "SNTA1 101_101_1_1_S101 phospho",
    "SNTA1 179_193_1_1_S189 phospho",
    "SNTA1 179_193_1_1_S193 phospho",
    "SNTA1 179_193_2_2_S189S193 phospho",
    "SNTA1 200_205_1_1_S201 phospho",
    "SNTA1 200_205_2_2_S200S201 phospho",
    "SNTA1 200_210_1_1_S201 phospho",
    "SNTA1 cnv",
    "SNTA1 methyl",
    "SNTA1 proteo",
    "SNTA1 rna"
  ],
  "SNTB1": [
    "SNTB1 205_219_1_1_S205 phospho",
    "SNTB1 205_219_1_1_S219 phospho",
    "SNTB1 205_219_1_1_T214 phospho",
    "SNTB1 205_219_2_2_S205S219 phospho",
    "SNTB1 205_219_2_2_T214S219 phospho",
    "SNTB1 205_236_1_1_S219 phospho",
    "SNTB1 225_236_1_0 phospho",
    "SNTB1 383_400_1_1_S389 phospho",
    "SNTB1 389_400_1_1_S389 phospho",
    "SNTB1 cnv",
    "SNTB1 methyl",
    "SNTB1 proteo",
    "SNTB1 rna"
  ],
  "SNTB2": [
    "SNTB2 110_110_1_1_S110 phospho",
    "SNTB2 208_233_1_0 phospho",
    "SNTB2 208_233_1_1_S233 phospho",
    "SNTB2 208_240_1_0 phospho",
    "SNTB2 208_240_1_1_S233 phospho",
    "SNTB2 387_404_1_1_S393 phospho",
    "SNTB2 95_110_1_1_S110 phospho",
    "SNTB2 95_95_1_1_S95 phospho",
    "SNTB2 cnv",
    "SNTB2 methyl",
    "SNTB2 proteo",
    "SNTB2 rna"
  ],
  "SNTG1": [
    "SNTG1 cnv",
    "SNTG1 methyl",
    "SNTG1 rna"
  ],
  "SNTG2": [
    "SNTG2 cnv",
    "SNTG2 methyl",
    "SNTG2 rna"
  ],
  "SNTN": [
    "SNTN cnv",
    "SNTN rna"
  ],
  "SNU13": [
    "SNU13 118_122_1_1_S122 phospho",
    "SNU13 cnv",
    "SNU13 methyl",
    "SNU13 proteo",
    "SNU13 rna"
  ],
  "SNUPN": [
    "SNUPN cnv",
    "SNUPN methyl",
    "SNUPN proteo",
    "SNUPN rna"
  ],
  "SNURF": [
    "SNURF cnv",
    "SNURF methyl",
    "SNURF rna"
  ],
  "SNW1": [
    "SNW1 224_234_1_1_S224 phospho",
    "SNW1 224_234_2_2_S224S232 phospho",
    "SNW1 cnv",
    "SNW1 methyl",
    "SNW1 proteo",
    "SNW1 rna"
  ],
  "SNX1": [
    "SNX1 cnv",
    "SNX1 methyl",
    "SNX1 proteo",
    "SNX1 rna"
  ],
  "SNX10": [
    "SNX10 cnv",
    "SNX10 methyl",
    "SNX10 proteo",
    "SNX10 rna"
  ],
  "SNX11": [
    "SNX11 160_162_1_1_S160 phospho",
    "SNX11 183_190_2_2_S184S186 phospho",
    "SNX11 cnv",
    "SNX11 methyl",
    "SNX11 proteo",
    "SNX11 rna"
  ],
  "SNX12": [
    "SNX12 72_73_1_1_S73 phospho",
    "SNX12 proteo",
    "SNX12 rna"
  ],
  "SNX13": [
    "SNX13 cnv",
    "SNX13 methyl",
    "SNX13 proteo",
    "SNX13 rna"
  ],
  "SNX14": [
    "SNX14 433_435_1_1_S433 phospho",
    "SNX14 cnv",
    "SNX14 methyl",
    "SNX14 proteo",
    "SNX14 rna"
  ],
  "SNX15": [
    "SNX15 148_148_1_1_T148 phospho",
    "SNX15 cnv",
    "SNX15 methyl",
    "SNX15 proteo",
    "SNX15 rna"
  ],
  "SNX16": [
    "SNX16 27_40_1_1_S29 phospho",
    "SNX16 cnv",
    "SNX16 methyl",
    "SNX16 proteo",
    "SNX16 rna"
  ],
  "SNX17": [
    "SNX17 312_324_1_0 phospho",
    "SNX17 312_324_1_1_S324 phospho",
    "SNX17 395_397_1_1_S397 phospho",
    "SNX17 395_413_1_1_S403 phospho",
    "SNX17 403_413_1_1_S409 phospho",
    "SNX17 cnv",
    "SNX17 methyl",
    "SNX17 proteo",
    "SNX17 rna"
  ],
  "SNX18": [
    "SNX18 209_217_1_1_S209 phospho",
    "SNX18 cnv",
    "SNX18 methyl",
    "SNX18 proteo",
    "SNX18 rna"
  ],
  "SNX19": [
    "SNX19 cnv",
    "SNX19 methyl",
    "SNX19 rna"
  ],
  "SNX2": [
    "SNX2 117_119_1_1_S119 phospho",
    "SNX2 185_192_1_0 phospho",
    "SNX2 185_192_1_1_S185 phospho",
    "SNX2 cnv",
    "SNX2 methyl",
    "SNX2 proteo",
    "SNX2 rna"
  ],
  "SNX20": [
    "SNX20 cnv",
    "SNX20 rna"
  ],
  "SNX21": [
    "SNX21 cnv",
    "SNX21 methyl",
    "SNX21 proteo",
    "SNX21 rna"
  ],
  "SNX22": [
    "SNX22 cnv",
    "SNX22 methyl",
    "SNX22 rna"
  ],
  "SNX24": [
    "SNX24 113_126_1_1_S116 phospho",
    "SNX24 113_126_2_2_S113S116 phospho",
    "SNX24 cnv",
    "SNX24 methyl",
    "SNX24 proteo",
    "SNX24 rna"
  ],
  "SNX25": [
    "SNX25 cnv",
    "SNX25 methyl",
    "SNX25 proteo",
    "SNX25 rna"
  ],
  "SNX27": [
    "SNX27 26_26_1_1_S26 phospho",
    "SNX27 cnv",
    "SNX27 methyl",
    "SNX27 proteo",
    "SNX27 rna"
  ],
  "SNX29": [
    "SNX29 328_337_1_1_S330 phospho",
    "SNX29 344_362_1_1_S344 phospho",
    "SNX29 370_388_1_1_S372 phospho",
    "SNX29 810_810_1_1_S810 phospho",
    "SNX29 cnv",
    "SNX29 methyl",
    "SNX29 proteo",
    "SNX29 rna"
  ],
  "SNX3": [
    "SNX3 49_50_1_1_S50 phospho",
    "SNX3 cnv",
    "SNX3 methyl",
    "SNX3 proteo",
    "SNX3 rna"
  ],
  "SNX30": [
    "SNX30 27_40_1_1_S40 phospho",
    "SNX30 61_73_1_1_S67 phospho",
    "SNX30 cnv",
    "SNX30 methyl",
    "SNX30 proteo",
    "SNX30 rna"
  ],
  "SNX31": [
    "SNX31 cnv",
    "SNX31 methyl",
    "SNX31 rna"
  ],
  "SNX32": [
    "SNX32 cnv",
    "SNX32 methyl",
    "SNX32 proteo",
    "SNX32 rna"
  ],
  "SNX33": [
    "SNX33 169_172_1_1_S169 phospho",
    "SNX33 cnv",
    "SNX33 methyl",
    "SNX33 proteo",
    "SNX33 rna"
  ],
  "SNX4": [
    "SNX4 cnv",
    "SNX4 methyl",
    "SNX4 proteo",
    "SNX4 rna"
  ],
  "SNX5": [
    "SNX5 151_157_1_1_S152 phospho",
    "SNX5 20_40_1_1_S22 phospho",
    "SNX5 cnv",
    "SNX5 methyl",
    "SNX5 proteo",
    "SNX5 rna"
  ],
  "SNX6": [
    "SNX6 cnv",
    "SNX6 methyl",
    "SNX6 proteo",
    "SNX6 rna"
  ],
  "SNX7": [
    "SNX7 cnv",
    "SNX7 methyl",
    "SNX7 proteo",
    "SNX7 rna"
  ],
  "SNX8": [
    "SNX8 cnv",
    "SNX8 methyl",
    "SNX8 proteo",
    "SNX8 rna"
  ],
  "SNX9": [
    "SNX9 116_122_1_1_S116 phospho",
    "SNX9 cnv",
    "SNX9 methyl",
    "SNX9 proteo",
    "SNX9 rna"
  ],
  "SOAT1": [
    "SOAT1 cnv",
    "SOAT1 methyl",
    "SOAT1 proteo",
    "SOAT1 rna"
  ],
  "SOAT2": [
    "SOAT2 cnv",
    "SOAT2 rna"
  ],
  "SOBP": [
    "SOBP 313_343_1_1_S313 phospho",
    "SOBP 594_611_1_1_S597 phospho",
    "SOBP 699_727_1_1_S699 phospho",
    "SOBP cnv",
    "SOBP methyl",
    "SOBP proteo",
    "SOBP rna"
  ],
  "SOCS1": [
    "SOCS1 cnv",
    "SOCS1 methyl",
    "SOCS1 rna"
  ],
  "SOCS2": [
    "SOCS2 cnv",
    "SOCS2 methyl",
    "SOCS2 rna"
  ],
  "SOCS2-AS1": [
    "SOCS2-AS1 methyl"
  ],
  "SOCS3": [
    "SOCS3 cnv",
    "SOCS3 methyl",
    "SOCS3 rna"
  ],
  "SOCS3-DT": [
    "SOCS3-DT methyl"
  ],
  "SOCS4": [
    "SOCS4 cnv",
    "SOCS4 methyl",
    "SOCS4 rna"
  ],
  "SOCS5": [
    "SOCS5 cnv",
    "SOCS5 methyl",
    "SOCS5 rna"
  ],
  "SOCS6": [
    "SOCS6 cnv",
    "SOCS6 methyl",
    "SOCS6 rna"
  ],
  "SOCS7": [
    "SOCS7 cnv",
    "SOCS7 methyl",
    "SOCS7 rna"
  ],
  "SOD1": [
    "SOD1 cnv",
    "SOD1 methyl",
    "SOD1 proteo",
    "SOD1 rna"
  ],
  "SOD2": [
    "SOD2 cnv",
    "SOD2 methyl",
    "SOD2 proteo",
    "SOD2 rna"
  ],
  "SOD2-OT1": [
    "SOD2-OT1 methyl"
  ],
  "SOD3": [
    "SOD3 cnv",
    "SOD3 proteo",
    "SOD3 rna"
  ],
  "SOGA1": [
    "SOGA1 1541_1551_1_1_S1541 phospho",
    "SOGA1 156_189_1_1_S175 phospho",
    "SOGA1 cnv",
    "SOGA1 methyl",
    "SOGA1 proteo",
    "SOGA1 rna"
  ],
  "SOGA3": [
    "SOGA3 736_747_1_1_S747 phospho",
    "SOGA3 781_783_1_1_S781 phospho",
    "SOGA3 cnv",
    "SOGA3 methyl",
    "SOGA3 proteo",
    "SOGA3 rna"
  ],
  "SOHLH1": [
    "SOHLH1 cnv",
    "SOHLH1 methyl",
    "SOHLH1 rna"
  ],
  "SOHLH2": [
    "SOHLH2 cnv",
    "SOHLH2 methyl",
    "SOHLH2 rna"
  ],
  "SON": [
    "SON 1549_1556_1_0 phospho",
    "SON 1549_1556_1_1_S1556 phospho",
    "SON 1688_1697_1_1_S1697 phospho",
    "SON 1688_1702_1_1_S1697 phospho",
    "SON 1766_1774_1_1_S1769 phospho",
    "SON 1780_1790_1_1_S1782 phospho",
    "SON 2115_2139_1_1_S2129 phospho",
    "SON 2129_2139_1_1_S2129 phospho",
    "SON 278_287_1_1_S283 phospho",
    "SON cnv",
    "SON methyl",
    "SON proteo",
    "SON rna"
  ],
  "SORBS1": [
    "SORBS1 293_300_1_1_S294 phospho",
    "SORBS1 309_318_1_0 phospho",
    "SORBS1 309_318_1_1_S318 phospho",
    "SORBS1 337_345_1_0 phospho",
    "SORBS1 351_371_1_0 phospho",
    "SORBS1 351_371_1_1_S355 phospho",
    "SORBS1 379_392_1_1_S387 phospho",
    "SORBS1 386_397_1_1_S394 phospho",
    "SORBS1 401_407_1_1_S403 phospho",
    "SORBS1 417_419_1_1_T419 phospho",
    "SORBS1 474_494_1_1_S478 phospho",
    "SORBS1 503_512_1_1_S503 phospho",
    "SORBS1 50_61_2_2_S53S57 phospho",
    "SORBS1 526_526_1_1_S526 phospho",
    "SORBS1 526_538_1_1_S526 phospho",
    "SORBS1 719_729_1_1_S727 phospho",
    "SORBS1 731_735_1_1_S735 phospho",
    "SORBS1 731_735_2_2_S731S735 phospho",
    "SORBS1 800_811_1_1_S804 phospho",
    "SORBS1 83_96_1_1_S85 phospho",
    "SORBS1 cnv",
    "SORBS1 methyl",
    "SORBS1 proteo",
    "SORBS1 rna"
  ],
  "SORBS2": [
    "SORBS2 1107_1118_1_1_S1118 phospho",
    "SORBS2 136_139_1_1_S136 phospho",
    "SORBS2 252_257_1_1_S254 phospho",
    "SORBS2 252_257_1_1_S257 phospho",
    "SORBS2 265_266_1_1_S266 phospho",
    "SORBS2 27_28_1_1_S27 phospho",
    "SORBS2 359_359_1_1_S359 phospho",
    "SORBS2 377_392_1_1_S378 phospho",
    "SORBS2 38_43_1_1_S40 phospho",
    "SORBS2 394_404_1_1_S394 phospho",
    "SORBS2 435_439_1_1_S439 phospho",
    "SORBS2 448_448_1_1_S448 phospho",
    "SORBS2 650_661_1_1_S650 phospho",
    "SORBS2 938_938_1_1_S938 phospho",
    "SORBS2 cnv",
    "SORBS2 proteo",
    "SORBS2 rna"
  ],
  "SORBS3": [
    "SORBS3 348_348_1_1_S348 phospho",
    "SORBS3 529_530_1_1_S530 phospho",
    "SORBS3 544_547_1_1_S545 phospho",
    "SORBS3 544_547_2_2_S544S545 phospho",
    "SORBS3 551_563_1_1_S563 phospho",
    "SORBS3 597_617_1_1_S606 phospho",
    "SORBS3 97_108_1_1_T106 phospho",
    "SORBS3 cnv",
    "SORBS3 methyl",
    "SORBS3 proteo",
    "SORBS3 rna"
  ],
  "SORCS1": [
    "SORCS1 DCSLGQSYLNSTGYR-N2H5F0S0G0 glyco",
    "SORCS1 cnv",
    "SORCS1 methyl",
    "SORCS1 proteo",
    "SORCS1 rna"
  ],
  "SORCS2": [
    "SORCS2 cnv",
    "SORCS2 proteo",
    "SORCS2 rna"
  ],
  "SORCS3": [
    "SORCS3 IVSNNCTDGLR-N2H5F0S0G0 glyco",
    "SORCS3 cnv",
    "SORCS3 methyl",
    "SORCS3 proteo",
    "SORCS3 rna"
  ],
  "SORD": [
    "SORD cnv",
    "SORD methyl",
    "SORD proteo",
    "SORD rna"
  ],
  "SORL1": [
    "SORL1 AASNFTEIK-N2H8F0S0G0 glyco",
    "SORL1 AASNFTEIK-N4H5F1S2G0 glyco",
    "SORL1 AINQTAVECTWTGPR-N2H7F0S0G0 glyco",
    "SORL1 AINQTAVECTWTGPR-N2H8F0S0G0 glyco",
    "SORL1 CPNGTCIPSSK-N2H5F0S0G0 glyco",
    "SORL1 GIGNWSDSK-N2H5F0S0G0 glyco",
    "SORL1 GIGNWSDSK-N2H6F0S0G0 glyco",
    "SORL1 GIGNWSDSK-N2H7F0S0G0 glyco",
    "SORL1 GIGNWSDSK-N2H8F0S0G0 glyco",
    "SORL1 LTIVNSSVLDRPR-N4H4F2S0G0 glyco",
    "SORL1 SLTTSLHNK-N2H5F0S0G0 glyco",
    "SORL1 SLTTSLHNK-N2H6F0S0G0 glyco",
    "SORL1 SLTTSLHNK-N2H7F0S0G0 glyco",
    "SORL1 TLETHSNK-N2H5F0S0G0 glyco",
    "SORL1 TLETHSNK-N2H6F0S0G0 glyco",
    "SORL1 TLETHSNK-N2H7F0S0G0 glyco",
    "SORL1 YHIIVQLGNMSK-N2H5F0S0G0 glyco",
    "SORL1 YHIIVQLGNMSK-N2H6F0S0G0 glyco",
    "SORL1 YHIIVQLGNMSK-N2H7F0S0G0 glyco",
    "SORL1 YHIIVQLGNMSK-N2H8F0S0G0 glyco",
    "SORL1 YHIIVQLGNMSK-N2H9F0S0G0 glyco",
    "SORL1 cnv",
    "SORL1 methyl",
    "SORL1 proteo",
    "SORL1 rna"
  ],
  "SORT1": [
    "SORT1 655_679_1_0 phospho",
    "SORT1 655_679_1_1_S656 phospho",
    "SORT1 655_679_1_1_S677 phospho",
    "SORT1 682_688_1_1_S688 phospho",
    "SORT1 DITDLINNTFIR-N5H3F1S0G0 glyco",
    "SORT1 HLYTTTGGETDFTNVTSLR-N2H10F0S0G0 glyco",
    "SORT1 HLYTTTGGETDFTNVTSLR-N2H9F0S0G0 glyco",
    "SORT1 LANNTHQHVFDDLR-N4H5F1S2G0 glyco",
    "SORT1 LANNTHQHVFDDLR-N5H3F1S0G0 glyco",
    "SORT1 cnv",
    "SORT1 methyl",
    "SORT1 proteo",
    "SORT1 rna"
  ],
  "SOS1": [
    "SOS1 1071_1082_1_1_S1082 phospho",
    "SOS1 1161_1169_1_1_S1167 phospho",
    "SOS1 1202_1210_1_1_S1210 phospho",
    "SOS1 1222_1229_1_1_S1229 phospho",
    "SOS1 1275_1286_1_1_S1275 phospho",
    "SOS1 cnv",
    "SOS1 methyl",
    "SOS1 proteo",
    "SOS1 rna"
  ],
  "SOS2": [
    "SOS2 cnv",
    "SOS2 methyl",
    "SOS2 proteo",
    "SOS2 rna"
  ],
  "SOST": [
    "SOST cnv",
    "SOST rna"
  ],
  "SOSTDC1": [
    "SOSTDC1 cnv",
    "SOSTDC1 rna"
  ],
  "SOWAHA": [
    "SOWAHA cnv",
    "SOWAHA methyl",
    "SOWAHA rna"
  ],
  "SOWAHB": [
    "SOWAHB cnv",
    "SOWAHB methyl",
    "SOWAHB rna"
  ],
  "SOWAHC": [
    "SOWAHC 212_213_1_1_S213 phospho",
    "SOWAHC 219_231_1_1_S226 phospho",
    "SOWAHC cnv",
    "SOWAHC methyl",
    "SOWAHC proteo",
    "SOWAHC rna"
  ],
  "SOWAHD": [
    "SOWAHD methyl",
    "SOWAHD rna"
  ],
  "SOX1": [
    "SOX1 320_332_1_1_S325 phospho",
    "SOX1 93_93_1_1_S93 phospho",
    "SOX1 cnv",
    "SOX1 methyl",
    "SOX1 rna"
  ],
  "SOX1-OT": [
    "SOX1-OT methyl"
  ],
  "SOX10": [
    "SOX10 221_244_1_1_T240 phospho",
    "SOX10 24_40_1_1_S24 phospho",
    "SOX10 24_45_1_1_S45 phospho",
    "SOX10 24_45_2_2_S24S45 phospho",
    "SOX10 45_45_1_1_S45 phospho",
    "SOX10 cnv",
    "SOX10 methyl",
    "SOX10 proteo",
    "SOX10 rna"
  ],
  "SOX11": [
    "SOX11 129_137_1_1_S137 phospho",
    "SOX11 cnv",
    "SOX11 methyl",
    "SOX11 proteo",
    "SOX11 rna"
  ],
  "SOX12": [
    "SOX12 cnv",
    "SOX12 methyl",
    "SOX12 rna"
  ],
  "SOX13": [
    "SOX13 307_312_1_1_S310 phospho",
    "SOX13 334_351_1_1_S335 phospho",
    "SOX13 382_386_1_1_S386 phospho",
    "SOX13 72_83_1_1_S83 phospho",
    "SOX13 cnv",
    "SOX13 methyl",
    "SOX13 proteo",
    "SOX13 rna"
  ],
  "SOX14": [
    "SOX14 cnv",
    "SOX14 methyl",
    "SOX14 rna"
  ],
  "SOX15": [
    "SOX15 cnv",
    "SOX15 rna"
  ],
  "SOX17": [
    "SOX17 cnv",
    "SOX17 methyl",
    "SOX17 rna"
  ],
  "SOX18": [
    "SOX18 cnv",
    "SOX18 methyl",
    "SOX18 rna"
  ],
  "SOX2": [
    "SOX2 246_261_1_1_S251 phospho",
    "SOX2 246_261_2_0 phospho",
    "SOX2 295_315_1_1_S295 phospho",
    "SOX2 37_37_1_1_S37 phospho",
    "SOX2 cnv",
    "SOX2 proteo",
    "SOX2 rna"
  ],
  "SOX2-OT": [
    "SOX2-OT methyl"
  ],
  "SOX21": [
    "SOX21 cnv",
    "SOX21 methyl",
    "SOX21 proteo",
    "SOX21 rna"
  ],
  "SOX21-AS1": [
    "SOX21-AS1 methyl"
  ],
  "SOX3": [
    "SOX3 methyl",
    "SOX3 rna"
  ],
  "SOX30": [
    "SOX30 cnv",
    "SOX30 methyl",
    "SOX30 rna"
  ],
  "SOX4": [
    "SOX4 cnv",
    "SOX4 rna"
  ],
  "SOX5": [
    "SOX5 110_121_1_1_T121 phospho",
    "SOX5 11_25_1_1_S11 phospho",
    "SOX5 360_366_1_1_S360 phospho",
    "SOX5 89_99_1_0 phospho",
    "SOX5 89_99_1_1_S99 phospho",
    "SOX5 cnv",
    "SOX5 methyl",
    "SOX5 proteo",
    "SOX5 rna"
  ],
  "SOX6": [
    "SOX6 108_119_1_0 phospho",
    "SOX6 20_39_1_1_S21 phospho",
    "SOX6 400_414_1_1_S412 phospho",
    "SOX6 423_427_1_1_S424 phospho",
    "SOX6 446_464_1_0 phospho",
    "SOX6 446_464_1_1_S455 phospho",
    "SOX6 446_464_2_0 phospho",
    "SOX6 452_464_1_1_S455 phospho",
    "SOX6 466_467_1_1_S467 phospho",
    "SOX6 475_484_1_1_S479 phospho",
    "SOX6 cnv",
    "SOX6 methyl",
    "SOX6 proteo",
    "SOX6 rna"
  ],
  "SOX7": [
    "SOX7 cnv",
    "SOX7 methyl",
    "SOX7 rna"
  ],
  "SOX8": [
    "SOX8 218_230_1_1_T226 phospho",
    "SOX8 320_331_1_1_S327 phospho",
    "SOX8 320_331_2_2_S323S327 phospho",
    "SOX8 340_348_1_1_S344 phospho",
    "SOX8 cnv",
    "SOX8 methyl",
    "SOX8 proteo",
    "SOX8 rna"
  ],
  "SOX9": [
    "SOX9 193_199_1_1_S199 phospho",
    "SOX9 211_240_1_1_T236 phospho",
    "SOX9 cnv",
    "SOX9 methyl",
    "SOX9 proteo",
    "SOX9 rna"
  ],
  "SOX9-AS1": [
    "SOX9-AS1 methyl"
  ],
  "SP1": [
    "SP1 33_62_1_1_S52 phospho",
    "SP1 cnv",
    "SP1 methyl",
    "SP1 proteo",
    "SP1 rna"
  ],
  "SP100": [
    "SP100 476_478_1_1_S476 phospho",
    "SP100 cnv",
    "SP100 proteo",
    "SP100 rna"
  ],
  "SP110": [
    "SP110 250_254_1_1_S250 phospho",
    "SP110 262_279_1_1_S262 phospho",
    "SP110 381_386_1_1_S386 phospho",
    "SP110 cnv",
    "SP110 proteo",
    "SP110 rna"
  ],
  "SP140": [
    "SP140 cnv",
    "SP140 rna"
  ],
  "SP140L": [
    "SP140L cnv",
    "SP140L rna"
  ],
  "SP2": [
    "SP2 78_78_1_1_S78 phospho",
    "SP2 cnv",
    "SP2 methyl",
    "SP2 proteo",
    "SP2 rna"
  ],
  "SP2-DT": [
    "SP2-DT methyl"
  ],
  "SP3": [
    "SP3 70_96_1_1_S70 phospho",
    "SP3 cnv",
    "SP3 methyl",
    "SP3 proteo",
    "SP3 rna"
  ],
  "SP4": [
    "SP4 101_121_1_1_S119 phospho",
    "SP4 20_39_1_1_S29 phospho",
    "SP4 cnv",
    "SP4 methyl",
    "SP4 proteo",
    "SP4 rna"
  ],
  "SP5": [
    "SP5 cnv",
    "SP5 methyl",
    "SP5 rna"
  ],
  "SP6": [
    "SP6 cnv",
    "SP6 methyl",
    "SP6 rna"
  ],
  "SP7": [
    "SP7 cnv",
    "SP7 methyl",
    "SP7 rna"
  ],
  "SP8": [
    "SP8 cnv",
    "SP8 mut",
    "SP8 rna"
  ],
  "SP9": [
    "SP9 cnv",
    "SP9 methyl",
    "SP9 rna"
  ],
  "SPA17": [
    "SPA17 cnv",
    "SPA17 methyl",
    "SPA17 proteo",
    "SPA17 rna"
  ],
  "SPAAR": [
    "SPAAR cnv",
    "SPAAR rna"
  ],
  "SPACA1": [
    "SPACA1 cnv",
    "SPACA1 methyl"
  ],
  "SPACA3": [
    "SPACA3 cnv",
    "SPACA3 rna"
  ],
  "SPACA4": [
    "SPACA4 cnv",
    "SPACA4 rna"
  ],
  "SPACA5": [
    "SPACA5 methyl",
    "SPACA5 rna"
  ],
  "SPACA5B": [
    "SPACA5B rna"
  ],
  "SPACA6": [
    "SPACA6 cnv",
    "SPACA6 methyl",
    "SPACA6 rna"
  ],
  "SPACA7": [
    "SPACA7 cnv"
  ],
  "SPACA9": [
    "SPACA9 cnv",
    "SPACA9 methyl",
    "SPACA9 rna"
  ],
  "SPACDR": [
    "SPACDR cnv",
    "SPACDR rna"
  ],
  "SPAG1": [
    "SPAG1 409_418_1_1_S418 phospho",
    "SPAG1 423_433_1_1_S423 phospho",
    "SPAG1 cnv",
    "SPAG1 methyl",
    "SPAG1 proteo",
    "SPAG1 rna"
  ],
  "SPAG11A": [
    "SPAG11A cnv"
  ],
  "SPAG11B": [
    "SPAG11B cnv"
  ],
  "SPAG16": [
    "SPAG16 cnv",
    "SPAG16 methyl",
    "SPAG16 rna"
  ],
  "SPAG17": [
    "SPAG17 cnv",
    "SPAG17 methyl",
    "SPAG17 rna"
  ],
  "SPAG4": [
    "SPAG4 cnv",
    "SPAG4 methyl",
    "SPAG4 rna"
  ],
  "SPAG5": [
    "SPAG5 cnv",
    "SPAG5 methyl",
    "SPAG5 rna"
  ],
  "SPAG6": [
    "SPAG6 cnv",
    "SPAG6 methyl",
    "SPAG6 proteo",
    "SPAG6 rna"
  ],
  "SPAG7": [
    "SPAG7 158_163_1_1_S158 phospho",
    "SPAG7 cnv",
    "SPAG7 methyl",
    "SPAG7 proteo",
    "SPAG7 rna"
  ],
  "SPAG8": [
    "SPAG8 cnv",
    "SPAG8 methyl",
    "SPAG8 rna"
  ],
  "SPAG9": [
    "SPAG9 1256_1264_1_1_T1264 phospho",
    "SPAG9 203_217_1_1_S203 phospho",
    "SPAG9 203_217_1_1_T217 phospho",
    "SPAG9 226_229_1_1_T226 phospho",
    "SPAG9 249_251_1_1_S251 phospho",
    "SPAG9 578_588_1_1_S588 phospho",
    "SPAG9 593_597_1_0 phospho",
    "SPAG9 593_597_1_1_S594 phospho",
    "SPAG9 705_713_1_1_S705 phospho",
    "SPAG9 728_733_1_1_S733 phospho",
    "SPAG9 728_733_2_0 phospho",
    "SPAG9 728_733_2_2_S730S733 phospho",
    "SPAG9 cnv",
    "SPAG9 methyl",
    "SPAG9 proteo",
    "SPAG9 rna"
  ],
  "SPAM1": [
    "SPAM1 cnv",
    "SPAM1 rna"
  ],
  "SPANXA2": [
    "SPANXA2 rna"
  ],
  "SPANXA2-OT1": [
    "SPANXA2-OT1 methyl"
  ],
  "SPANXB1": [
    "SPANXB1 rna"
  ],
  "SPARC": [
    "SPARC VCSNDNK-N2H7F0S0G0 glyco",
    "SPARC cnv",
    "SPARC proteo",
    "SPARC rna"
  ],
  "SPARCL1": [
    "SPARCL1 198_198_1_1_S198 phospho",
    "SPARCL1 198_213_1_1_S198 phospho",
    "SPARCL1 272_282_1_1_S272 phospho",
    "SPARCL1 291_295_1_1_S295 phospho",
    "SPARCL1 413_421_1_0 phospho",
    "SPARCL1 413_421_1_1_S414 phospho",
    "SPARCL1 413_421_1_1_S420 phospho",
    "SPARCL1 413_421_2_2_S414S420 phospho",
    "SPARCL1 56_64_1_1_S59 phospho",
    "SPARCL1 56_64_2_2_S59S64 phospho",
    "SPARCL1 76_84_1_1_S76 phospho",
    "SPARCL1 76_84_1_1_S80 phospho",
    "SPARCL1 76_84_1_1_S84 phospho",
    "SPARCL1 76_84_2_2_S76S80 phospho",
    "SPARCL1 76_84_2_2_S80S84 phospho",
    "SPARCL1 76_84_3_3_S76S80S84 phospho",
    "SPARCL1 80_84_1_1_S80 phospho",
    "SPARCL1 80_84_2_2_S80S84 phospho",
    "SPARCL1 cnv",
    "SPARCL1 proteo",
    "SPARCL1 rna"
  ],
  "SPART": [
    "SPART 392_400_1_0 phospho",
    "SPART cnv",
    "SPART methyl",
    "SPART proteo",
    "SPART rna"
  ],
  "SPAST": [
    "SPAST 239_244_1_1_S244 phospho",
    "SPAST 254_260_1_1_S256 phospho",
    "SPAST 267_275_1_0 phospho",
    "SPAST 267_275_1_1_S267 phospho",
    "SPAST 281_291_1_1_T291 phospho",
    "SPAST cnv",
    "SPAST methyl",
    "SPAST proteo",
    "SPAST rna"
  ],
  "SPATA1": [
    "SPATA1 cnv",
    "SPATA1 methyl",
    "SPATA1 rna"
  ],
  "SPATA12": [
    "SPATA12 cnv",
    "SPATA12 rna"
  ],
  "SPATA13": [
    "SPATA13 252_255_1_1_S254 phospho",
    "SPATA13 254_255_1_1_S254 phospho",
    "SPATA13 561_569_1_1_S563 phospho",
    "SPATA13 cnv",
    "SPATA13 methyl",
    "SPATA13 proteo",
    "SPATA13 rna"
  ],
  "SPATA16": [
    "SPATA16 cnv",
    "SPATA16 rna"
  ],
  "SPATA17": [
    "SPATA17 cnv",
    "SPATA17 methyl",
    "SPATA17 rna"
  ],
  "SPATA18": [
    "SPATA18 242_247_1_1_S244 phospho",
    "SPATA18 cnv",
    "SPATA18 methyl",
    "SPATA18 proteo",
    "SPATA18 rna"
  ],
  "SPATA19": [
    "SPATA19 cnv",
    "SPATA19 rna"
  ],
  "SPATA2": [
    "SPATA2 253_263_1_1_S253 phospho",
    "SPATA2 418_428_1_1_S428 phospho",
    "SPATA2 cnv",
    "SPATA2 methyl",
    "SPATA2 proteo",
    "SPATA2 rna"
  ],
  "SPATA20": [
    "SPATA20 cnv",
    "SPATA20 methyl",
    "SPATA20 proteo",
    "SPATA20 rna"
  ],
  "SPATA21": [
    "SPATA21 cnv",
    "SPATA21 rna"
  ],
  "SPATA22": [
    "SPATA22 cnv",
    "SPATA22 methyl",
    "SPATA22 rna"
  ],
  "SPATA24": [
    "SPATA24 cnv",
    "SPATA24 methyl",
    "SPATA24 rna"
  ],
  "SPATA25": [
    "SPATA25 cnv",
    "SPATA25 rna"
  ],
  "SPATA2L": [
    "SPATA2L cnv",
    "SPATA2L methyl",
    "SPATA2L proteo",
    "SPATA2L rna"
  ],
  "SPATA3": [
    "SPATA3 cnv",
    "SPATA3 rna"
  ],
  "SPATA31A1": [
    "SPATA31A1 cnv",
    "SPATA31A1 rna"
  ],
  "SPATA31A3": [
    "SPATA31A3 cnv",
    "SPATA31A3 rna"
  ],
  "SPATA31A5": [
    "SPATA31A5 cnv",
    "SPATA31A5 rna"
  ],
  "SPATA31A6": [
    "SPATA31A6 cnv",
    "SPATA31A6 rna"
  ],
  "SPATA31A7": [
    "SPATA31A7 cnv",
    "SPATA31A7 rna"
  ],
  "SPATA31C2": [
    "SPATA31C2 cnv",
    "SPATA31C2 rna"
  ],
  "SPATA31D1": [
    "SPATA31D1 cnv"
  ],
  "SPATA31D3": [
    "SPATA31D3 cnv"
  ],
  "SPATA31D4": [
    "SPATA31D4 cnv"
  ],
  "SPATA31E1": [
    "SPATA31E1 cnv",
    "SPATA31E1 rna"
  ],
  "SPATA32": [
    "SPATA32 cnv",
    "SPATA32 methyl",
    "SPATA32 rna"
  ],
  "SPATA33": [
    "SPATA33 cnv",
    "SPATA33 methyl",
    "SPATA33 proteo",
    "SPATA33 rna"
  ],
  "SPATA4": [
    "SPATA4 cnv",
    "SPATA4 methyl",
    "SPATA4 rna"
  ],
  "SPATA45": [
    "SPATA45 cnv",
    "SPATA45 rna"
  ],
  "SPATA46": [
    "SPATA46 cnv",
    "SPATA46 rna"
  ],
  "SPATA48": [
    "SPATA48 cnv",
    "SPATA48 rna"
  ],
  "SPATA5": [
    "SPATA5 cnv",
    "SPATA5 methyl",
    "SPATA5 proteo",
    "SPATA5 rna"
  ],
  "SPATA5L1": [
    "SPATA5L1 cnv",
    "SPATA5L1 methyl",
    "SPATA5L1 proteo",
    "SPATA5L1 rna"
  ],
  "SPATA6": [
    "SPATA6 215_222_1_1_S217 phospho",
    "SPATA6 265_265_1_1_S265 phospho",
    "SPATA6 338_347_1_1_S343 phospho",
    "SPATA6 352_354_1_1_S354 phospho",
    "SPATA6 404_414_1_1_S408 phospho",
    "SPATA6 cnv",
    "SPATA6 methyl",
    "SPATA6 rna"
  ],
  "SPATA6L": [
    "SPATA6L cnv",
    "SPATA6L rna"
  ],
  "SPATA7": [
    "SPATA7 cnv",
    "SPATA7 methyl",
    "SPATA7 rna"
  ],
  "SPATA9": [
    "SPATA9 cnv",
    "SPATA9 rna"
  ],
  "SPATC1": [
    "SPATC1 cnv",
    "SPATC1 rna"
  ],
  "SPATC1L": [
    "SPATC1L cnv",
    "SPATC1L rna"
  ],
  "SPATS1": [
    "SPATS1 cnv",
    "SPATS1 rna"
  ],
  "SPATS2": [
    "SPATS2 cnv",
    "SPATS2 methyl",
    "SPATS2 proteo",
    "SPATS2 rna"
  ],
  "SPATS2L": [
    "SPATS2L 135_141_1_1_S135 phospho",
    "SPATS2L cnv",
    "SPATS2L methyl",
    "SPATS2L proteo",
    "SPATS2L rna"
  ],
  "SPC24": [
    "SPC24 cnv",
    "SPC24 methyl",
    "SPC24 proteo",
    "SPC24 rna"
  ],
  "SPC25": [
    "SPC25 cnv",
    "SPC25 methyl",
    "SPC25 proteo",
    "SPC25 rna"
  ],
  "SPCS1": [
    "SPCS1 cnv",
    "SPCS1 methyl",
    "SPCS1 proteo",
    "SPCS1 rna"
  ],
  "SPCS2": [
    "SPCS2 cnv",
    "SPCS2 methyl",
    "SPCS2 proteo",
    "SPCS2 rna"
  ],
  "SPCS3": [
    "SPCS3 cnv",
    "SPCS3 methyl",
    "SPCS3 proteo",
    "SPCS3 rna"
  ],
  "SPDEF": [
    "SPDEF cnv",
    "SPDEF rna"
  ],
  "SPDL1": [
    "SPDL1 cnv",
    "SPDL1 methyl",
    "SPDL1 rna"
  ],
  "SPDYA": [
    "SPDYA cnv",
    "SPDYA methyl",
    "SPDYA rna"
  ],
  "SPDYC": [
    "SPDYC cnv",
    "SPDYC rna"
  ],
  "SPDYE1": [
    "SPDYE1 cnv",
    "SPDYE1 rna"
  ],
  "SPDYE10": [
    "SPDYE10 cnv",
    "SPDYE10 rna"
  ],
  "SPDYE11": [
    "SPDYE11 cnv",
    "SPDYE11 rna"
  ],
  "SPDYE12": [
    "SPDYE12 cnv",
    "SPDYE12 rna"
  ],
  "SPDYE13": [
    "SPDYE13 cnv"
  ],
  "SPDYE14": [
    "SPDYE14 cnv",
    "SPDYE14 rna"
  ],
  "SPDYE15": [
    "SPDYE15 cnv"
  ],
  "SPDYE16": [
    "SPDYE16 cnv",
    "SPDYE16 rna"
  ],
  "SPDYE17": [
    "SPDYE17 cnv",
    "SPDYE17 rna"
  ],
  "SPDYE18": [
    "SPDYE18 cnv",
    "SPDYE18 rna"
  ],
  "SPDYE2": [
    "SPDYE2 cnv",
    "SPDYE2 rna"
  ],
  "SPDYE21": [
    "SPDYE21 cnv",
    "SPDYE21 rna"
  ],
  "SPDYE2B": [
    "SPDYE2B cnv",
    "SPDYE2B rna"
  ],
  "SPDYE3": [
    "SPDYE3 cnv",
    "SPDYE3 rna"
  ],
  "SPDYE4": [
    "SPDYE4 cnv",
    "SPDYE4 rna"
  ],
  "SPDYE5": [
    "SPDYE5 cnv",
    "SPDYE5 rna"
  ],
  "SPDYE6": [
    "SPDYE6 cnv",
    "SPDYE6 rna"
  ],
  "SPDYE8": [
    "SPDYE8 cnv",
    "SPDYE8 rna"
  ],
  "SPDYE9": [
    "SPDYE9 cnv",
    "SPDYE9 rna"
  ],
  "SPECC1": [
    "SPECC1 131_144_1_1_S131 phospho",
    "SPECC1 199_222_1_1_S218 phospho",
    "SPECC1 241_241_1_1_S241 phospho",
    "SPECC1 323_347_1_1_S325 phospho",
    "SPECC1 356_374_1_1_S361 phospho",
    "SPECC1 54_68_1_1_S55 phospho",
    "SPECC1 76_88_1_1_T78 phospho",
    "SPECC1 809_819_1_1_S810 phospho",
    "SPECC1 809_819_1_1_T809 phospho",
    "SPECC1 844_850_1_1_S847 phospho",
    "SPECC1 912_929_1_1_S914 phospho",
    "SPECC1 cnv",
    "SPECC1 methyl",
    "SPECC1 proteo",
    "SPECC1 rna"
  ],
  "SPECC1L": [
    "SPECC1L 220_220_1_1_S220 phospho",
    "SPECC1L 220_226_1_1_S220 phospho",
    "SPECC1L 384_397_1_1_S384 phospho",
    "SPECC1L 52_69_1_0 phospho",
    "SPECC1L 831_840_1_0 phospho",
    "SPECC1L 831_840_1_1_S832 phospho",
    "SPECC1L 887_895_1_1_S887 phospho",
    "SPECC1L 887_902_1_1_S887 phospho",
    "SPECC1L cnv",
    "SPECC1L methyl",
    "SPECC1L proteo",
    "SPECC1L rna"
  ],
  "SPECC1L-ADORA2A": [
    "SPECC1L-ADORA2A cnv",
    "SPECC1L-ADORA2A rna"
  ],
  "SPEF1": [
    "SPEF1 cnv",
    "SPEF1 rna"
  ],
  "SPEF2": [
    "SPEF2 cnv",
    "SPEF2 methyl",
    "SPEF2 rna"
  ],
  "SPEG": [
    "SPEG 2109_2110_1_1_S2109 phospho",
    "SPEG 2495_2500_1_1_S2496 phospho",
    "SPEG 2844_2844_1_1_T2844 phospho",
    "SPEG 320_334_1_0 phospho",
    "SPEG 385_390_1_1_S390 phospho",
    "SPEG 449_462_1_1_T449 phospho",
    "SPEG 449_462_2_2_T449S453 phospho",
    "SPEG 549_560_1_1_S557 phospho",
    "SPEG cnv",
    "SPEG kinase",
    "SPEG methyl",
    "SPEG proteo",
    "SPEG rna"
  ],
  "SPEGNB": [
    "SPEGNB cnv",
    "SPEGNB methyl",
    "SPEGNB rna"
  ],
  "SPEM1": [
    "SPEM1 cnv",
    "SPEM1 rna"
  ],
  "SPEM2": [
    "SPEM2 cnv",
    "SPEM2 rna"
  ],
  "SPEM3": [
    "SPEM3 cnv",
    "SPEM3 rna"
  ],
  "SPEN": [
    "SPEN 1005_1006_1_1_S1006 phospho",
    "SPEN 1059_1062_1_1_S1062 phospho",
    "SPEN 1206_1225_1_1_S1222 phospho",
    "SPEN 1268_1278_1_1_S1278 phospho",
    "SPEN 1380_1382_1_1_S1380 phospho",
    "SPEN 1613_1622_1_1_T1619 phospho",
    "SPEN 1906_1918_1_1_S1918 phospho",
    "SPEN 2387_2403_1_1_T2393 phospho",
    "SPEN 3138_3162_1_1_T3139 phospho",
    "SPEN 623_626_1_1_S623 phospho",
    "SPEN 725_727_1_1_S727 phospho",
    "SPEN 736_742_2_2_S736S740 phospho",
    "SPEN cnv",
    "SPEN methyl",
    "SPEN proteo",
    "SPEN rna"
  ],
  "SPEN-AS1": [
    "SPEN-AS1 methyl"
  ],
  "SPESP1": [
    "SPESP1 cnv",
    "SPESP1 methyl",
    "SPESP1 rna"
  ],
  "SPG11": [
    "SPG11 1827_1844_1_1_S1827 phospho",
    "SPG11 1955_1961_1_1_S1958 phospho",
    "SPG11 1955_1961_2_2_S1955S1958 phospho",
    "SPG11 cnv",
    "SPG11 methyl",
    "SPG11 proteo",
    "SPG11 rna"
  ],
  "SPG21": [
    "SPG21 300_304_1_1_S304 phospho",
    "SPG21 cnv",
    "SPG21 methyl",
    "SPG21 proteo",
    "SPG21 rna"
  ],
  "SPG7": [
    "SPG7 cnv",
    "SPG7 methyl",
    "SPG7 proteo",
    "SPG7 rna"
  ],
  "SPHK1": [
    "SPHK1 cnv",
    "SPHK1 methyl",
    "SPHK1 rna"
  ],
  "SPHK2": [
    "SPHK2 340_355_1_1_S340 phospho",
    "SPHK2 340_355_1_1_S355 phospho",
    "SPHK2 340_355_2_2_S340S355 phospho",
    "SPHK2 425_444_1_1_S425 phospho",
    "SPHK2 46_61_1_1_S48 phospho",
    "SPHK2 cnv",
    "SPHK2 methyl",
    "SPHK2 proteo",
    "SPHK2 rna"
  ],
  "SPHKAP": [
    "SPHKAP 1237_1242_1_1_S1238 phospho",
    "SPHKAP 1474_1488_1_1_S1485 phospho",
    "SPHKAP cnv",
    "SPHKAP methyl",
    "SPHKAP proteo",
    "SPHKAP rna"
  ],
  "SPI1": [
    "SPI1 cnv",
    "SPI1 methyl",
    "SPI1 rna"
  ],
  "SPIB": [
    "SPIB cnv",
    "SPIB rna"
  ],
  "SPIC": [
    "SPIC cnv",
    "SPIC rna"
  ],
  "SPICE1": [
    "SPICE1 cnv",
    "SPICE1 methyl",
    "SPICE1 proteo",
    "SPICE1 rna"
  ],
  "SPIDR": [
    "SPIDR cnv",
    "SPIDR methyl",
    "SPIDR rna"
  ],
  "SPIN1": [
    "SPIN1 196_212_1_1_S199 phospho",
    "SPIN1 cnv",
    "SPIN1 methyl",
    "SPIN1 proteo",
    "SPIN1 rna"
  ],
  "SPIN2A": [
    "SPIN2A methyl",
    "SPIN2A rna"
  ],
  "SPIN2B": [
    "SPIN2B methyl",
    "SPIN2B rna"
  ],
  "SPIN3": [
    "SPIN3 methyl",
    "SPIN3 rna"
  ],
  "SPIN4": [
    "SPIN4 methyl",
    "SPIN4 rna"
  ],
  "SPINDOC": [
    "SPINDOC 108_123_1_1_S121 phospho",
    "SPINDOC 148_154_2_2_S148S152 phospho",
    "SPINDOC 248_255_1_1_S251 phospho",
    "SPINDOC 308_310_1_1_S308 phospho",
    "SPINDOC cnv",
    "SPINDOC methyl",
    "SPINDOC rna"
  ],
  "SPINK1": [
    "SPINK1 cnv",
    "SPINK1 rna"
  ],
  "SPINK13": [
    "SPINK13 cnv",
    "SPINK13 rna"
  ],
  "SPINK14": [
    "SPINK14 cnv"
  ],
  "SPINK2": [
    "SPINK2 cnv",
    "SPINK2 methyl",
    "SPINK2 rna"
  ],
  "SPINK4": [
    "SPINK4 cnv"
  ],
  "SPINK5": [
    "SPINK5 cnv",
    "SPINK5 rna"
  ],
  "SPINK6": [
    "SPINK6 cnv",
    "SPINK6 rna"
  ],
  "SPINK7": [
    "SPINK7 cnv",
    "SPINK7 rna"
  ],
  "SPINK8": [
    "SPINK8 cnv",
    "SPINK8 rna"
  ],
  "SPINK9": [
    "SPINK9 cnv",
    "SPINK9 rna"
  ],
  "SPINT1": [
    "SPINT1 cnv",
    "SPINT1 methyl",
    "SPINT1 rna"
  ],
  "SPINT2": [
    "SPINT2 cnv",
    "SPINT2 methyl",
    "SPINT2 rna"
  ],
  "SPINT3": [
    "SPINT3 cnv"
  ],
  "SPINT4": [
    "SPINT4 cnv"
  ],
  "SPIRE1": [
    "SPIRE1 267_267_1_1_S267 phospho",
    "SPIRE1 373_375_1_1_T375 phospho",
    "SPIRE1 542_548_1_1_S544 phospho",
    "SPIRE1 599_615_1_1_S601 phospho",
    "SPIRE1 599_615_1_1_Y603 phospho",
    "SPIRE1 cnv",
    "SPIRE1 methyl",
    "SPIRE1 proteo",
    "SPIRE1 rna"
  ],
  "SPIRE2": [
    "SPIRE2 cnv",
    "SPIRE2 methyl",
    "SPIRE2 proteo",
    "SPIRE2 rna"
  ],
  "SPN": [
    "SPN 341_344_1_1_T341 phospho",
    "SPN 351_355_2_2_S351S355 phospho",
    "SPN 355_355_1_1_S355 phospho",
    "SPN cnv",
    "SPN rna"
  ],
  "SPNS1": [
    "SPNS1 518_525_1_1_T519 phospho",
    "SPNS1 cnv",
    "SPNS1 methyl",
    "SPNS1 proteo",
    "SPNS1 rna"
  ],
  "SPNS2": [
    "SPNS2 cnv",
    "SPNS2 methyl",
    "SPNS2 rna"
  ],
  "SPNS3": [
    "SPNS3 cnv",
    "SPNS3 rna"
  ],
  "SPO11": [
    "SPO11 cnv",
    "SPO11 methyl"
  ],
  "SPOCD1": [
    "SPOCD1 cnv",
    "SPOCD1 rna"
  ],
  "SPOCK1": [
    "SPOCK1 cnv",
    "SPOCK1 methyl",
    "SPOCK1 proteo",
    "SPOCK1 rna"
  ],
  "SPOCK2": [
    "SPOCK2 72_86_1_1_S72 phospho",
    "SPOCK2 QNGSASSVAGPASGLDK-N2H6F0S0G0 glyco",
    "SPOCK2 QNGSASSVAGPASGLDK-N2H8F0S0G0 glyco",
    "SPOCK2 cnv",
    "SPOCK2 methyl",
    "SPOCK2 proteo",
    "SPOCK2 rna"
  ],
  "SPOCK3": [
    "SPOCK3 cnv",
    "SPOCK3 rna"
  ],
  "SPON1": [
    "SPON1 LTFYGNWSEK-N2H5F0S0G0 glyco",
    "SPON1 LTFYGNWSEK-N2H6F0S0G0 glyco",
    "SPON1 cnv",
    "SPON1 methyl",
    "SPON1 proteo",
    "SPON1 rna"
  ],
  "SPON2": [
    "SPON2 cnv",
    "SPON2 methyl",
    "SPON2 rna"
  ],
  "SPOP": [
    "SPOP cnv",
    "SPOP methyl",
    "SPOP rna"
  ],
  "SPOPL": [
    "SPOPL cnv",
    "SPOPL methyl",
    "SPOPL rna"
  ],
  "SPOUT1": [
    "SPOUT1 cnv",
    "SPOUT1 methyl",
    "SPOUT1 proteo",
    "SPOUT1 rna"
  ],
  "SPP1": [
    "SPP1 181_202_1_0 phospho",
    "SPP1 181_202_1_1_S195 phospho",
    "SPP1 181_202_2_0 phospho",
    "SPP1 181_202_2_2_S191S195 phospho",
    "SPP1 181_202_2_2_T185S195 phospho",
    "SPP1 215_219_1_1_S215 phospho",
    "SPP1 215_219_1_1_S219 phospho",
    "SPP1 215_239_2_0 phospho",
    "SPP1 215_239_3_0 phospho",
    "SPP1 224_239_1_1_S224 phospho",
    "SPP1 224_239_1_1_S234 phospho",
    "SPP1 224_239_2_0 phospho",
    "SPP1 224_239_2_2_S224S234 phospho",
    "SPP1 224_239_2_2_S228S234 phospho",
    "SPP1 224_239_3_3_S224S228S234 phospho",
    "SPP1 24_27_2_2_S26S27 phospho",
    "SPP1 254_267_1_1_S254 phospho",
    "SPP1 254_267_1_1_S263 phospho",
    "SPP1 254_267_2_2_S254S258 phospho",
    "SPP1 254_267_2_2_S254S263 phospho",
    "SPP1 254_267_3_3_S254S258S263 phospho",
    "SPP1 254_270_1_1_S270 phospho",
    "SPP1 254_270_2_2_S263S270 phospho",
    "SPP1 270_280_3_3_S270S275S280 phospho",
    "SPP1 275_280_1_1_S275 phospho",
    "SPP1 275_280_1_1_S280 phospho",
    "SPP1 275_280_2_2_S275S280 phospho",
    "SPP1 303_311_1_0 phospho",
    "SPP1 303_311_1_1_S303 phospho",
    "SPP1 303_311_2_0 phospho",
    "SPP1 303_311_2_2_S303S311 phospho",
    "SPP1 59_62_1_1_S62 phospho",
    "SPP1 62_66_1_1_S62 phospho",
    "SPP1 62_66_1_1_S63 phospho",
    "SPP1 62_66_2_2_S62S63 phospho",
    "SPP1 62_76_1_0 phospho",
    "SPP1 62_76_1_1_S62 phospho",
    "SPP1 62_76_1_1_S63 phospho",
    "SPP1 62_76_2_2_S62S63 phospho",
    "SPP1 cnv",
    "SPP1 proteo",
    "SPP1 rna"
  ],
  "SPP2": [
    "SPP2 96_102_1_1_S96 phospho",
    "SPP2 cnv",
    "SPP2 proteo",
    "SPP2 rna"
  ],
  "SPPL2A": [
    "SPPL2A DMNQTLGDNITVK-N2H6F0S0G0 glyco",
    "SPPL2A cnv",
    "SPPL2A methyl",
    "SPPL2A proteo",
    "SPPL2A rna"
  ],
  "SPPL2B": [
    "SPPL2B cnv",
    "SPPL2B methyl",
    "SPPL2B rna"
  ],
  "SPPL2C": [
    "SPPL2C cnv",
    "SPPL2C rna"
  ],
  "SPPL3": [
    "SPPL3 cnv",
    "SPPL3 methyl",
    "SPPL3 rna"
  ],
  "SPR": [
    "SPR cnv",
    "SPR methyl",
    "SPR proteo",
    "SPR rna"
  ],
  "SPRED1": [
    "SPRED1 cnv",
    "SPRED1 methyl",
    "SPRED1 proteo",
    "SPRED1 rna"
  ],
  "SPRED2": [
    "SPRED2 162_168_1_1_S165 phospho",
    "SPRED2 203_203_1_1_S203 phospho",
    "SPRED2 cnv",
    "SPRED2 methyl",
    "SPRED2 proteo",
    "SPRED2 rna"
  ],
  "SPRED3": [
    "SPRED3 cnv",
    "SPRED3 methyl",
    "SPRED3 proteo",
    "SPRED3 rna"
  ],
  "SPRING1": [
    "SPRING1 cnv",
    "SPRING1 methyl",
    "SPRING1 rna"
  ],
  "SPRN": [
    "SPRN cnv",
    "SPRN methyl",
    "SPRN rna"
  ],
  "SPRR1A": [
    "SPRR1A cnv",
    "SPRR1A rna"
  ],
  "SPRR1B": [
    "SPRR1B cnv",
    "SPRR1B rna"
  ],
  "SPRR2A": [
    "SPRR2A cnv",
    "SPRR2A rna"
  ],
  "SPRR2B": [
    "SPRR2B cnv"
  ],
  "SPRR2D": [
    "SPRR2D cnv",
    "SPRR2D rna"
  ],
  "SPRR2E": [
    "SPRR2E cnv"
  ],
  "SPRR2F": [
    "SPRR2F cnv"
  ],
  "SPRR2G": [
    "SPRR2G cnv",
    "SPRR2G rna"
  ],
  "SPRR3": [
    "SPRR3 cnv",
    "SPRR3 rna"
  ],
  "SPRR4": [
    "SPRR4 cnv"
  ],
  "SPRR5": [
    "SPRR5 cnv"
  ],
  "SPRTN": [
    "SPRTN cnv",
    "SPRTN methyl",
    "SPRTN rna"
  ],
  "SPRY1": [
    "SPRY1 114_131_1_0 phospho",
    "SPRY1 cnv",
    "SPRY1 methyl",
    "SPRY1 proteo",
    "SPRY1 rna"
  ],
  "SPRY2": [
    "SPRY2 cnv",
    "SPRY2 methyl",
    "SPRY2 proteo",
    "SPRY2 rna"
  ],
  "SPRY3": [
    "SPRY3 274_277_1_1_S274 phospho",
    "SPRY3 methyl",
    "SPRY3 proteo",
    "SPRY3 rna"
  ],
  "SPRY4": [
    "SPRY4 125_125_1_1_S125 phospho",
    "SPRY4 278_280_1_1_S280 phospho",
    "SPRY4 cnv",
    "SPRY4 methyl",
    "SPRY4 proteo",
    "SPRY4 rna"
  ],
  "SPRY4-AS1": [
    "SPRY4-AS1 methyl"
  ],
  "SPRYD3": [
    "SPRYD3 cnv",
    "SPRYD3 methyl",
    "SPRYD3 proteo",
    "SPRYD3 rna"
  ],
  "SPRYD4": [
    "SPRYD4 cnv",
    "SPRYD4 methyl",
    "SPRYD4 proteo",
    "SPRYD4 rna"
  ],
  "SPRYD7": [
    "SPRYD7 cnv",
    "SPRYD7 methyl",
    "SPRYD7 proteo",
    "SPRYD7 rna"
  ],
  "SPSB1": [
    "SPSB1 cnv",
    "SPSB1 methyl",
    "SPSB1 rna"
  ],
  "SPSB2": [
    "SPSB2 cnv",
    "SPSB2 methyl",
    "SPSB2 rna"
  ],
  "SPSB3": [
    "SPSB3 cnv",
    "SPSB3 methyl",
    "SPSB3 rna"
  ],
  "SPSB4": [
    "SPSB4 cnv",
    "SPSB4 methyl",
    "SPSB4 rna"
  ],
  "SPTA1": [
    "SPTA1 1284_1284_1_1_S1284 phospho",
    "SPTA1 986_992_1_1_S992 phospho",
    "SPTA1 cnv",
    "SPTA1 proteo",
    "SPTA1 rna"
  ],
  "SPTAN1": [
    "SPTAN1 1197_1197_1_1_S1197 phospho",
    "SPTAN1 1206_1211_1_1_S1211 phospho",
    "SPTAN1 1295_1303_1_1_S1303 phospho",
    "SPTAN1 cnv",
    "SPTAN1 methyl",
    "SPTAN1 proteo",
    "SPTAN1 rna"
  ],
  "SPTB": [
    "SPTB 2089_2110_1_1_S2105 phospho",
    "SPTB 2113_2120_1_1_S2114 phospho",
    "SPTB 2123_2137_1_1_S2123 phospho",
    "SPTB 2123_2137_1_1_S2125 phospho",
    "SPTB 2123_2137_2_2_S2125S2128 phospho",
    "SPTB 381_382_1_1_T382 phospho",
    "SPTB cnv",
    "SPTB methyl",
    "SPTB proteo",
    "SPTB rna"
  ],
  "SPTBN1": [
    "SPTBN1 1386_1388_1_1_S1388 phospho",
    "SPTBN1 1462_1465_1_1_T1462 phospho",
    "SPTBN1 2102_2107_1_1_S2102 phospho",
    "SPTBN1 2110_2138_1_1_S2128 phospho",
    "SPTBN1 2110_2138_1_1_S2138 phospho",
    "SPTBN1 2110_2138_2_2_S2128S2138 phospho",
    "SPTBN1 2128_2138_1_1_S2128 phospho",
    "SPTBN1 2128_2138_1_1_S2138 phospho",
    "SPTBN1 2128_2138_2_2_S2128S2138 phospho",
    "SPTBN1 2144_2161_2_0 phospho",
    "SPTBN1 2144_2161_2_2_S2160S2161 phospho",
    "SPTBN1 2164_2172_1_0 phospho",
    "SPTBN1 2164_2172_2_2_S2165S2169 phospho",
    "SPTBN1 2178_2187_1_1_T2187 phospho",
    "SPTBN1 2192_2197_1_1_T2195 phospho",
    "SPTBN1 2314_2324_1_1_S2319 phospho",
    "SPTBN1 2314_2324_2_2_S2319T2320 phospho",
    "SPTBN1 2328_2341_1_0 phospho",
    "SPTBN1 2328_2341_1_1_S2341 phospho",
    "SPTBN1 257_257_1_1_S257 phospho",
    "SPTBN1 768_781_1_1_S781 phospho",
    "SPTBN1 796_817_1_1_S817 phospho",
    "SPTBN1 cnv",
    "SPTBN1 methyl",
    "SPTBN1 proteo",
    "SPTBN1 rna"
  ],
  "SPTBN2": [
    "SPTBN2 2254_2258_1_1_S2254 phospho",
    "SPTBN2 2354_2359_1_1_S2359 phospho",
    "SPTBN2 cnv",
    "SPTBN2 methyl",
    "SPTBN2 proteo",
    "SPTBN2 rna"
  ],
  "SPTBN4": [
    "SPTBN4 2165_2169_1_1_S2165 phospho",
    "SPTBN4 2254_2258_1_1_S2254 phospho",
    "SPTBN4 2272_2282_1_1_S2272 phospho",
    "SPTBN4 2305_2306_1_1_S2305 phospho",
    "SPTBN4 2400_2418_1_1_S2400 phospho",
    "SPTBN4 cnv",
    "SPTBN4 methyl",
    "SPTBN4 proteo",
    "SPTBN4 rna"
  ],
  "SPTBN5": [
    "SPTBN5 cnv",
    "SPTBN5 rna"
  ],
  "SPTLC1": [
    "SPTLC1 cnv",
    "SPTLC1 methyl",
    "SPTLC1 proteo",
    "SPTLC1 rna"
  ],
  "SPTLC2": [
    "SPTLC2 cnv",
    "SPTLC2 methyl",
    "SPTLC2 proteo",
    "SPTLC2 rna"
  ],
  "SPTLC3": [
    "SPTLC3 cnv",
    "SPTLC3 rna"
  ],
  "SPTSSA": [
    "SPTSSA cnv",
    "SPTSSA methyl",
    "SPTSSA rna"
  ],
  "SPTSSB": [
    "SPTSSB cnv",
    "SPTSSB methyl",
    "SPTSSB rna"
  ],
  "SPTY2D1": [
    "SPTY2D1 cnv",
    "SPTY2D1 methyl",
    "SPTY2D1 rna"
  ],
  "SPTY2D1OS": [
    "SPTY2D1OS cnv",
    "SPTY2D1OS methyl",
    "SPTY2D1OS rna"
  ],
  "SPX": [
    "SPX cnv",
    "SPX methyl",
    "SPX rna"
  ],
  "SPZ1": [
    "SPZ1 cnv",
    "SPZ1 rna"
  ],
  "SQLE": [
    "SQLE cnv",
    "SQLE methyl",
    "SQLE proteo",
    "SQLE rna"
  ],
  "SQLE-DT": [
    "SQLE-DT methyl"
  ],
  "SQOR": [
    "SQOR 328_343_1_1_S343 phospho",
    "SQOR cnv",
    "SQOR methyl",
    "SQOR proteo",
    "SQOR rna"
  ],
  "SQSTM1": [
    "SQSTM1 143_152_1_1_S152 phospho",
    "SQSTM1 24_28_1_1_S24 phospho",
    "SQSTM1 24_28_1_1_S28 phospho",
    "SQSTM1 266_278_1_1_T269 phospho",
    "SQSTM1 266_278_2_2_T269S272 phospho",
    "SQSTM1 269_278_1_1_S272 phospho",
    "SQSTM1 269_278_1_1_S277 phospho",
    "SQSTM1 318_343_1_1_S332 phospho",
    "SQSTM1 349_375_1_0 phospho",
    "SQSTM1 cnv",
    "SQSTM1 methyl",
    "SQSTM1 proteo",
    "SQSTM1 rna"
  ],
  "SRA1": [
    "SRA1 cnv",
    "SRA1 methyl",
    "SRA1 proteo",
    "SRA1 rna"
  ],
  "SRARP": [
    "SRARP cnv",
    "SRARP rna"
  ],
  "SRBD1": [
    "SRBD1 cnv",
    "SRBD1 methyl",
    "SRBD1 proteo",
    "SRBD1 rna"
  ],
  "SRC": [
    "SRC 17_39_1_1_S17 phospho",
    "SRC 17_43_1_1_S17 phospho",
    "SRC 17_51_1_1_S17 phospho",
    "SRC cnv",
    "SRC kinase",
    "SRC methyl",
    "SRC proteo",
    "SRC rna"
  ],
  "SRCAP": [
    "SRCAP 1322_1322_1_1_T1322 phospho",
    "SRCAP 262_280_1_1_S274 phospho",
    "SRCAP cnv",
    "SRCAP methyl",
    "SRCAP rna"
  ],
  "SRCIN1": [
    "SRCIN1 1043_1043_1_1_S1043 phospho",
    "SRCIN1 1148_1164_1_1_S1155 phospho",
    "SRCIN1 225_228_1_1_S225 phospho",
    "SRCIN1 298_326_1_0 phospho",
    "SRCIN1 298_326_1_1_S307 phospho",
    "SRCIN1 331_343_1_1_S343 phospho",
    "SRCIN1 331_343_2_2_S339S343 phospho",
    "SRCIN1 45_53_1_1_S45 phospho",
    "SRCIN1 45_53_1_1_S53 phospho",
    "SRCIN1 493_503_1_0 phospho",
    "SRCIN1 513_522_1_1_S522 phospho",
    "SRCIN1 513_522_2_0 phospho",
    "SRCIN1 513_522_2_2_S513S522 phospho",
    "SRCIN1 604_616_1_1_S616 phospho",
    "SRCIN1 842_844_1_0 phospho",
    "SRCIN1 842_844_1_1_S844 phospho",
    "SRCIN1 987_991_1_1_S987 phospho",
    "SRCIN1 cnv",
    "SRCIN1 methyl",
    "SRCIN1 proteo",
    "SRCIN1 rna"
  ],
  "SRD5A1": [
    "SRD5A1 cnv",
    "SRD5A1 methyl",
    "SRD5A1 rna"
  ],
  "SRD5A2": [
    "SRD5A2 cnv",
    "SRD5A2 methyl",
    "SRD5A2 rna"
  ],
  "SRD5A3": [
    "SRD5A3 cnv",
    "SRD5A3 methyl",
    "SRD5A3 proteo",
    "SRD5A3 rna"
  ],
  "SRD5A3-AS1": [
    "SRD5A3-AS1 methyl"
  ],
  "SREBF1": [
    "SREBF1 cnv",
    "SREBF1 methyl",
    "SREBF1 rna"
  ],
  "SREBF2": [
    "SREBF2 cnv",
    "SREBF2 methyl",
    "SREBF2 rna"
  ],
  "SREK1": [
    "SREK1 cnv",
    "SREK1 methyl",
    "SREK1 proteo",
    "SREK1 rna"
  ],
  "SREK1IP1": [
    "SREK1IP1 144_153_1_1_T146 phospho",
    "SREK1IP1 cnv",
    "SREK1IP1 methyl",
    "SREK1IP1 proteo",
    "SREK1IP1 rna"
  ],
  "SRF": [
    "SRF 217_224_1_1_S224 phospho",
    "SRF 217_232_1_1_S224 phospho",
    "SRF cnv",
    "SRF methyl",
    "SRF rna"
  ],
  "SRFBP1": [
    "SRFBP1 199_208_1_1_S203 phospho",
    "SRFBP1 260_265_1_1_S264 phospho",
    "SRFBP1 cnv",
    "SRFBP1 methyl",
    "SRFBP1 proteo",
    "SRFBP1 rna"
  ],
  "SRGAP1": [
    "SRGAP1 691_716_1_0 phospho",
    "SRGAP1 812_821_1_1_S812 phospho",
    "SRGAP1 883_883_1_1_S883 phospho",
    "SRGAP1 894_899_1_1_S894 phospho",
    "SRGAP1 915_922_1_1_S917 phospho",
    "SRGAP1 976_987_1_1_S982 phospho",
    "SRGAP1 976_987_1_1_S987 phospho",
    "SRGAP1 976_987_2_2_T978S982 phospho",
    "SRGAP1 cnv",
    "SRGAP1 methyl",
    "SRGAP1 proteo",
    "SRGAP1 rna"
  ],
  "SRGAP2": [
    "SRGAP2 1048_1064_1_1_S1060 phospho",
    "SRGAP2 499_509_1_0 phospho",
    "SRGAP2 694_723_1_0 phospho",
    "SRGAP2 694_723_1_1_T722 phospho",
    "SRGAP2 694_723_2_0 phospho",
    "SRGAP2 893_904_1_1_S899 phospho",
    "SRGAP2 981_997_1_0 phospho",
    "SRGAP2 981_997_1_1_S993 phospho",
    "SRGAP2 981_997_2_2_S989S993 phospho",
    "SRGAP2 cnv",
    "SRGAP2 methyl",
    "SRGAP2 proteo",
    "SRGAP2 rna"
  ],
  "SRGAP2B": [
    "SRGAP2B cnv",
    "SRGAP2B rna"
  ],
  "SRGAP2C": [
    "SRGAP2C cnv",
    "SRGAP2C rna"
  ],
  "SRGAP3": [
    "SRGAP3 1006_1015_1_1_S1011 phospho",
    "SRGAP3 1068_1084_1_0 phospho",
    "SRGAP3 1068_1084_1_1_S1069 phospho",
    "SRGAP3 1068_1084_1_1_T1082 phospho",
    "SRGAP3 1091_1098_1_1_T1098 phospho",
    "SRGAP3 407_421_2_2_S407S410 phospho",
    "SRGAP3 715_740_1_0 phospho",
    "SRGAP3 755_759_1_1_S759 phospho",
    "SRGAP3 837_845_1_1_S837 phospho",
    "SRGAP3 858_858_1_1_S858 phospho",
    "SRGAP3 868_874_1_1_S874 phospho",
    "SRGAP3 868_885_1_1_S874 phospho",
    "SRGAP3 894_895_1_1_S895 phospho",
    "SRGAP3 894_902_1_1_S895 phospho",
    "SRGAP3 916_925_1_1_S919 phospho",
    "SRGAP3 cnv",
    "SRGAP3 methyl",
    "SRGAP3 proteo",
    "SRGAP3 rna"
  ],
  "SRGN": [
    "SRGN cnv",
    "SRGN proteo",
    "SRGN rna"
  ],
  "SRI": [
    "SRI 96_99_1_1_S96 phospho",
    "SRI cnv",
    "SRI methyl",
    "SRI proteo",
    "SRI rna"
  ],
  "SRL": [
    "SRL cnv",
    "SRL rna"
  ],
  "SRM": [
    "SRM cnv",
    "SRM methyl",
    "SRM proteo",
    "SRM rna"
  ],
  "SRMS": [
    "SRMS cnv",
    "SRMS kinase",
    "SRMS methyl",
    "SRMS rna"
  ],
  "SRP14": [
    "SRP14 cnv",
    "SRP14 methyl",
    "SRP14 proteo",
    "SRP14 rna"
  ],
  "SRP14-DT": [
    "SRP14-DT methyl"
  ],
  "SRP19": [
    "SRP19 98_111_1_1_S111 phospho",
    "SRP19 cnv",
    "SRP19 methyl",
    "SRP19 proteo",
    "SRP19 rna"
  ],
  "SRP54": [
    "SRP54 cnv",
    "SRP54 methyl",
    "SRP54 proteo",
    "SRP54 rna"
  ],
  "SRP68": [
    "SRP68 16_27_1_1_S27 phospho",
    "SRP68 cnv",
    "SRP68 methyl",
    "SRP68 proteo",
    "SRP68 rna"
  ],
  "SRP72": [
    "SRP72 566_571_1_1_T571 phospho",
    "SRP72 618_639_1_0 phospho",
    "SRP72 618_639_1_1_S621 phospho",
    "SRP72 618_639_2_0 phospho",
    "SRP72 618_639_2_1_S620 phospho",
    "SRP72 cnv",
    "SRP72 methyl",
    "SRP72 proteo",
    "SRP72 rna"
  ],
  "SRP9": [
    "SRP9 31_34_1_1_S34 phospho",
    "SRP9 cnv",
    "SRP9 methyl",
    "SRP9 proteo",
    "SRP9 rna"
  ],
  "SRPK1": [
    "SRPK1 33_62_1_1_S51 phospho",
    "SRPK1 cnv",
    "SRPK1 kinase",
    "SRPK1 methyl",
    "SRPK1 proteo",
    "SRPK1 rna"
  ],
  "SRPK2": [
    "SRPK2 41_63_1_0 phospho",
    "SRPK2 41_63_1_1_T41 phospho",
    "SRPK2 492_498_1_0 phospho",
    "SRPK2 492_498_2_0 phospho",
    "SRPK2 cnv",
    "SRPK2 kinase",
    "SRPK2 methyl",
    "SRPK2 proteo",
    "SRPK2 rna"
  ],
  "SRPK3": [
    "SRPK3 kinase",
    "SRPK3 methyl",
    "SRPK3 rna"
  ],
  "SRPRA": [
    "SRPRA 256_285_1_1_S270 phospho",
    "SRPRA cnv",
    "SRPRA methyl",
    "SRPRA proteo",
    "SRPRA rna"
  ],
  "SRPRB": [
    "SRPRB cnv",
    "SRPRB methyl",
    "SRPRB proteo",
    "SRPRB rna"
  ],
  "SRPX": [
    "SRPX methyl",
    "SRPX proteo",
    "SRPX rna"
  ],
  "SRPX2": [
    "SRPX2 proteo",
    "SRPX2 rna"
  ],
  "SRR": [
    "SRR cnv",
    "SRR methyl",
    "SRR proteo",
    "SRR rna"
  ],
  "SRRD": [
    "SRRD cnv",
    "SRRD methyl",
    "SRRD rna"
  ],
  "SRRM1": [
    "SRRM1 207_211_1_1_S209 phospho",
    "SRRM1 207_211_2_2_S209S211 phospho",
    "SRRM1 207_211_3_3_S207S209S211 phospho",
    "SRRM1 220_227_1_1_T220 phospho",
    "SRRM1 234_242_1_1_S234 phospho",
    "SRRM1 260_260_1_1_S260 phospho",
    "SRRM1 389_393_1_1_S389 phospho",
    "SRRM1 389_393_2_2_S389S393 phospho",
    "SRRM1 389_393_3_3_S389S391S393 phospho",
    "SRRM1 402_406_1_1_S402 phospho",
    "SRRM1 402_406_2_2_S402T406 phospho",
    "SRRM1 411_420_2_2_T411T416 phospho",
    "SRRM1 448_450_1_1_S448 phospho",
    "SRRM1 448_450_2_2_S448S450 phospho",
    "SRRM1 461_463_1_0 phospho",
    "SRRM1 461_463_1_1_S463 phospho",
    "SRRM1 461_463_2_2_S461S463 phospho",
    "SRRM1 550_553_1_1_S550 phospho",
    "SRRM1 561_567_2_2_S561S563 phospho",
    "SRRM1 572_574_1_0 phospho",
    "SRRM1 572_574_1_1_S572 phospho",
    "SRRM1 572_574_1_1_S574 phospho",
    "SRRM1 572_574_2_2_S572S574 phospho",
    "SRRM1 584_586_2_2_T584T586 phospho",
    "SRRM1 593_595_1_1_S595 phospho",
    "SRRM1 593_595_2_2_T593S595 phospho",
    "SRRM1 608_609_1_1_S609 phospho",
    "SRRM1 616_619_1_1_S617 phospho",
    "SRRM1 616_619_2_2_S617S619 phospho",
    "SRRM1 626_628_1_1_S628 phospho",
    "SRRM1 626_628_2_2_T626S628 phospho",
    "SRRM1 628_628_1_1_S628 phospho",
    "SRRM1 638_640_1_1_S638 phospho",
    "SRRM1 638_640_1_1_S640 phospho",
    "SRRM1 638_640_2_2_S638S640 phospho",
    "SRRM1 648_650_1_1_S650 phospho",
    "SRRM1 648_650_2_2_S648S650 phospho",
    "SRRM1 657_661_1_1_S658 phospho",
    "SRRM1 705_708_1_0 phospho",
    "SRRM1 705_708_1_1_S708 phospho",
    "SRRM1 705_708_2_0 phospho",
    "SRRM1 737_739_1_1_T739 phospho",
    "SRRM1 750_755_1_1_S750 phospho",
    "SRRM1 750_755_2_2_S750S752 phospho",
    "SRRM1 750_755_3_3_S750S752S755 phospho",
    "SRRM1 764_768_1_1_S768 phospho",
    "SRRM1 764_768_3_3_S764S766S768 phospho",
    "SRRM1 781_793_1_1_S781 phospho",
    "SRRM1 781_793_1_1_S787 phospho",
    "SRRM1 781_793_2_0 phospho",
    "SRRM1 781_793_2_1_S781 phospho",
    "SRRM1 781_793_2_2_S781S787 phospho",
    "SRRM1 781_793_2_2_S781S793 phospho",
    "SRRM1 781_793_3_0 phospho",
    "SRRM1 781_793_3_3_S781S787S793 phospho",
    "SRRM1 884_886_1_1_S886 phospho",
    "SRRM1 884_886_2_2_T884S886 phospho",
    "SRRM1 913_916_1_1_S916 phospho",
    "SRRM1 913_916_2_2_S913S916 phospho",
    "SRRM1 9_10_1_1_S10 phospho",
    "SRRM1 cnv",
    "SRRM1 methyl",
    "SRRM1 proteo",
    "SRRM1 rna"
  ],
  "SRRM2": [
    "SRRM2 1003_1012_1_1_T1003 phospho",
    "SRRM2 1003_1014_1_1_S1014 phospho",
    "SRRM2 1003_1014_2_2_T1003S1014 phospho",
    "SRRM2 1041_1054_1_1_T1043 phospho",
    "SRRM2 1061_1064_1_1_S1064 phospho",
    "SRRM2 1079_1088_1_1_S1083 phospho",
    "SRRM2 1079_1088_2_2_S1081S1083 phospho",
    "SRRM2 1101_1110_1_1_S1103 phospho",
    "SRRM2 1101_1110_2_2_S1101S1103 phospho",
    "SRRM2 1101_1112_2_2_S1103S1112 phospho",
    "SRRM2 1122_1124_1_1_S1124 phospho",
    "SRRM2 1140_1157_1_1_S1152 phospho",
    "SRRM2 1177_1179_1_0 phospho",
    "SRRM2 1177_1179_1_1_S1179 phospho",
    "SRRM2 1188_1199_1_1_S1188 phospho",
    "SRRM2 1205_1208_1_1_T1208 phospho",
    "SRRM2 1214_1222_1_1_S1219 phospho",
    "SRRM2 1245_1258_1_1_S1257 phospho",
    "SRRM2 1318_1329_2_2_S1320S1329 phospho",
    "SRRM2 1378_1387_1_1_S1387 phospho",
    "SRRM2 1397_1404_1_1_S1404 phospho",
    "SRRM2 1397_1415_1_1_T1413 phospho",
    "SRRM2 1397_1415_2_2_S1404T1413 phospho",
    "SRRM2 1397_1415_2_2_T1413S1415 phospho",
    "SRRM2 1419_1424_1_1_S1421 phospho",
    "SRRM2 1419_1424_1_1_S1424 phospho",
    "SRRM2 1419_1424_2_2_S1419S1421 phospho",
    "SRRM2 1419_1424_2_2_S1423S1424 phospho",
    "SRRM2 1434_1436_1_1_S1436 phospho",
    "SRRM2 1434_1436_1_1_T1434 phospho",
    "SRRM2 1458_1463_1_1_S1463 phospho",
    "SRRM2 1472_1474_1_1_T1472 phospho",
    "SRRM2 1478_1483_1_1_S1478 phospho",
    "SRRM2 1478_1483_1_1_S1483 phospho",
    "SRRM2 1478_1483_2_2_S1478S1483 phospho",
    "SRRM2 1478_1483_2_2_S1482S1483 phospho",
    "SRRM2 1478_1483_3_3_S1478S1482S1483 phospho",
    "SRRM2 1492_1492_1_1_T1492 phospho",
    "SRRM2 1497_1502_1_1_S1499 phospho",
    "SRRM2 1497_1502_2_2_S1499S1502 phospho",
    "SRRM2 1497_1502_3_3_S1497S1499S1502 phospho",
    "SRRM2 1517_1522_1_0 phospho",
    "SRRM2 1517_1522_1_1_S1517 phospho",
    "SRRM2 1517_1522_2_2_S1517S1519 phospho",
    "SRRM2 1527_1531_1_1_T1531 phospho",
    "SRRM2 1539_1552_1_1_S1541 phospho",
    "SRRM2 1539_1552_1_1_S1542 phospho",
    "SRRM2 1579_1587_1_1_S1582 phospho",
    "SRRM2 1579_1587_2_2_S1581S1582 phospho",
    "SRRM2 1598_1601_1_1_S1601 phospho",
    "SRRM2 1598_1601_2_2_S1600S1601 phospho",
    "SRRM2 1598_1601_3_3_S1598S1600S1601 phospho",
    "SRRM2 1616_1621_1_1_S1621 phospho",
    "SRRM2 1616_1621_2_2_S1620S1621 phospho",
    "SRRM2 1693_1698_1_1_S1694 phospho",
    "SRRM2 1842_1848_1_1_T1844 phospho",
    "SRRM2 1854_1857_2_2_S1854S1857 phospho",
    "SRRM2 1856_1857_1_1_S1857 phospho",
    "SRRM2 1866_1872_1_1_S1869 phospho",
    "SRRM2 1866_1872_2_2_S1866S1869 phospho",
    "SRRM2 1878_1884_1_1_T1880 phospho",
    "SRRM2 1925_1931_2_2_S1925T1927 phospho",
    "SRRM2 2020_2022_1_1_T2022 phospho",
    "SRRM2 2044_2046_1_1_S2046 phospho",
    "SRRM2 2067_2071_1_1_S2071 phospho",
    "SRRM2 2100_2112_1_1_T2104 phospho",
    "SRRM2 2100_2112_2_2_S2100T2104 phospho",
    "SRRM2 2115_2125_1_1_S2123 phospho",
    "SRRM2 2261_2272_1_1_S2272 phospho",
    "SRRM2 2275_2291_1_1_T2289 phospho",
    "SRRM2 231_233_1_1_S231 phospho",
    "SRRM2 2343_2355_1_1_S2343 phospho",
    "SRRM2 2376_2382_1_1_S2382 phospho",
    "SRRM2 2376_2390_1_0 phospho",
    "SRRM2 2376_2390_1_1_S2382 phospho",
    "SRRM2 2394_2398_1_1_S2398 phospho",
    "SRRM2 2407_2417_1_1_T2409 phospho",
    "SRRM2 2407_2417_2_2_S2407T2409 phospho",
    "SRRM2 2436_2459_1_1_S2449 phospho",
    "SRRM2 2449_2459_1_1_S2449 phospho",
    "SRRM2 248_252_2_2_S248S250 phospho",
    "SRRM2 250_252_1_1_S250 phospho",
    "SRRM2 2581_2583_1_1_S2581 phospho",
    "SRRM2 2664_2664_1_1_S2664 phospho",
    "SRRM2 2702_2706_1_1_S2702 phospho",
    "SRRM2 2702_2706_2_2_S2702S2706 phospho",
    "SRRM2 286_300_2_2_S295S297 phospho",
    "SRRM2 295_300_2_2_S295S297 phospho",
    "SRRM2 311_328_1_0 phospho",
    "SRRM2 311_328_1_1_S323 phospho",
    "SRRM2 311_328_2_0 phospho",
    "SRRM2 311_328_2_2_S322S323 phospho",
    "SRRM2 332_335_1_1_S333 phospho",
    "SRRM2 346_367_3_0 phospho",
    "SRRM2 357_367_1_1_T367 phospho",
    "SRRM2 377_400_1_1_S377 phospho",
    "SRRM2 377_400_2_2_S377S398 phospho",
    "SRRM2 404_408_1_1_S404 phospho",
    "SRRM2 435_449_1_1_S440 phospho",
    "SRRM2 435_449_2_0 phospho",
    "SRRM2 435_449_2_2_S435S437 phospho",
    "SRRM2 435_449_2_2_S435S440 phospho",
    "SRRM2 435_449_3_3_S435S436S437 phospho",
    "SRRM2 435_449_3_3_S436S437S440 phospho",
    "SRRM2 484_489_1_1_S486 phospho",
    "SRRM2 484_489_2_2_S484S486 phospho",
    "SRRM2 508_510_1_1_S510 phospho",
    "SRRM2 536_543_1_1_S536 phospho",
    "SRRM2 778_783_1_1_S778 phospho",
    "SRRM2 778_783_2_2_S778S780 phospho",
    "SRRM2 778_783_2_2_S778S783 phospho",
    "SRRM2 817_820_2_2_S818S820 phospho",
    "SRRM2 834_839_1_1_S839 phospho",
    "SRRM2 846_866_1_1_T848 phospho",
    "SRRM2 846_866_2_2_T848S857 phospho",
    "SRRM2 854_866_1_1_S857 phospho",
    "SRRM2 854_866_1_1_T866 phospho",
    "SRRM2 871_876_1_1_S876 phospho",
    "SRRM2 871_876_2_2_S871S876 phospho",
    "SRRM2 890_895_1_0 phospho",
    "SRRM2 890_895_1_1_S895 phospho",
    "SRRM2 950_961_3_3_S950S952S954 phospho",
    "SRRM2 952_961_2_2_S952S954 phospho",
    "SRRM2 967_977_1_1_S970 phospho",
    "SRRM2 967_977_1_1_S974 phospho",
    "SRRM2 967_977_2_2_S970S974 phospho",
    "SRRM2 967_977_2_2_S973S974 phospho",
    "SRRM2 967_977_3_3_S970S973S974 phospho",
    "SRRM2 967_977_3_3_S972S973S974 phospho",
    "SRRM2 983_996_1_1_T983 phospho",
    "SRRM2 983_996_2_2_T983S990 phospho",
    "SRRM2 983_996_2_2_T983S994 phospho",
    "SRRM2 988_996_1_1_S994 phospho",
    "SRRM2 cnv",
    "SRRM2 methyl",
    "SRRM2 proteo",
    "SRRM2 rna"
  ],
  "SRRM2-AS1": [
    "SRRM2-AS1 methyl"
  ],
  "SRRM3": [
    "SRRM3 cnv",
    "SRRM3 methyl",
    "SRRM3 rna"
  ],
  "SRRM4": [
    "SRRM4 500_502_1_1_S500 phospho",
    "SRRM4 cnv",
    "SRRM4 methyl",
    "SRRM4 rna"
  ],
  "SRRM5": [
    "SRRM5 cnv",
    "SRRM5 rna"
  ],
  "SRRT": [
    "SRRT 534_552_1_1_T543 phospho",
    "SRRT cnv",
    "SRRT methyl",
    "SRRT proteo",
    "SRRT rna"
  ],
  "SRSF1": [
    "SRSF1 199_202_1_1_S199 phospho",
    "SRSF1 cnv",
    "SRSF1 methyl",
    "SRSF1 proteo",
    "SRSF1 rna"
  ],
  "SRSF10": [
    "SRSF10 131_138_1_1_S133 phospho",
    "SRSF10 131_138_2_2_S131S133 phospho",
    "SRSF10 133_138_1_1_S133 phospho",
    "SRSF10 155_159_1_1_S157 phospho",
    "SRSF10 156_167_3_3_S156S158S160 phospho",
    "SRSF10 157_159_1_1_S157 phospho",
    "SRSF10 157_179_1_1_S157 phospho",
    "SRSF10 158_167_1_1_S158 phospho",
    "SRSF10 21_23_1_1_S23 phospho",
    "SRSF10 250_255_1_1_S252 phospho",
    "SRSF10 cnv",
    "SRSF10 methyl",
    "SRSF10 proteo",
    "SRSF10 rna"
  ],
  "SRSF11": [
    "SRSF11 207_216_1_1_S207 phospho",
    "SRSF11 453_455_1_1_S455 phospho",
    "SRSF11 462_470_1_1_S462 phospho",
    "SRSF11 489_489_1_1_S489 phospho",
    "SRSF11 cnv",
    "SRSF11 methyl",
    "SRSF11 proteo",
    "SRSF11 rna"
  ],
  "SRSF12": [
    "SRSF12 105_107_1_1_S105 phospho",
    "SRSF12 146_150_1_1_S146 phospho",
    "SRSF12 217_223_1_1_S223 phospho",
    "SRSF12 cnv",
    "SRSF12 methyl",
    "SRSF12 proteo",
    "SRSF12 rna"
  ],
  "SRSF2": [
    "SRSF2 189_196_2_2_S189S191 phospho",
    "SRSF2 206_221_1_1_S208 phospho",
    "SRSF2 206_221_2_2_S208S221 phospho",
    "SRSF2 208_221_1_1_S212 phospho",
    "SRSF2 212_221_1_1_S221 phospho",
    "SRSF2 22_29_1_1_S26 phospho",
    "SRSF2 25_29_1_1_S26 phospho",
    "SRSF2 25_29_1_1_T25 phospho",
    "SRSF2 cnv",
    "SRSF2 methyl",
    "SRSF2 proteo",
    "SRSF2 rna"
  ],
  "SRSF3": [
    "SRSF3 5_5_1_1_S5 phospho",
    "SRSF3 cnv",
    "SRSF3 methyl",
    "SRSF3 proteo",
    "SRSF3 rna"
  ],
  "SRSF4": [
    "SRSF4 cnv",
    "SRSF4 methyl",
    "SRSF4 proteo",
    "SRSF4 rna"
  ],
  "SRSF5": [
    "SRSF5 229_233_1_1_S233 phospho",
    "SRSF5 cnv",
    "SRSF5 methyl",
    "SRSF5 proteo",
    "SRSF5 rna"
  ],
  "SRSF6": [
    "SRSF6 301_310_1_1_S303 phospho",
    "SRSF6 314_316_2_2_S314S316 phospho",
    "SRSF6 cnv",
    "SRSF6 methyl",
    "SRSF6 proteo",
    "SRSF6 rna"
  ],
  "SRSF7": [
    "SRSF7 cnv",
    "SRSF7 methyl",
    "SRSF7 proteo",
    "SRSF7 rna"
  ],
  "SRSF8": [
    "SRSF8 155_161_1_1_S158 phospho",
    "SRSF8 185_198_1_1_S191 phospho",
    "SRSF8 22_29_1_1_S26 phospho",
    "SRSF8 273_282_1_0 phospho",
    "SRSF8 273_282_1_1_S273 phospho",
    "SRSF8 273_282_1_1_S282 phospho",
    "SRSF8 273_282_2_2_S273S282 phospho",
    "SRSF8 cnv",
    "SRSF8 methyl",
    "SRSF8 proteo",
    "SRSF8 rna"
  ],
  "SRSF9": [
    "SRSF9 204_208_1_1_S204 phospho",
    "SRSF9 211_221_1_1_S211 phospho",
    "SRSF9 211_221_1_1_S216 phospho",
    "SRSF9 211_221_2_2_S211S216 phospho",
    "SRSF9 cnv",
    "SRSF9 methyl",
    "SRSF9 proteo",
    "SRSF9 rna"
  ],
  "SRXN1": [
    "SRXN1 cnv",
    "SRXN1 methyl",
    "SRXN1 proteo",
    "SRXN1 rna"
  ],
  "SRY": [
    "SRY rna"
  ],
  "SS18": [
    "SS18 cnv",
    "SS18 methyl",
    "SS18 proteo",
    "SS18 rna"
  ],
  "SS18L1": [
    "SS18L1 cnv",
    "SS18L1 methyl",
    "SS18L1 proteo",
    "SS18L1 rna"
  ],
  "SS18L2": [
    "SS18L2 cnv",
    "SS18L2 methyl",
    "SS18L2 rna"
  ],
  "SSB": [
    "SSB 362_379_1_0 phospho",
    "SSB 362_379_1_1_S366 phospho",
    "SSB 362_379_1_1_T362 phospho",
    "SSB 366_379_1_1_S366 phospho",
    "SSB 389_396_1_1_T389 phospho",
    "SSB 92_104_1_1_S92 phospho",
    "SSB cnv",
    "SSB methyl",
    "SSB proteo",
    "SSB rna"
  ],
  "SSBP1": [
    "SSBP1 cnv",
    "SSBP1 methyl",
    "SSBP1 proteo",
    "SSBP1 rna"
  ],
  "SSBP2": [
    "SSBP2 329_341_1_1_T341 phospho",
    "SSBP2 cnv",
    "SSBP2 methyl",
    "SSBP2 proteo",
    "SSBP2 rna"
  ],
  "SSBP3": [
    "SSBP3 320_333_1_1_T333 phospho",
    "SSBP3 347_360_1_1_S354 phospho",
    "SSBP3 cnv",
    "SSBP3 methyl",
    "SSBP3 proteo",
    "SSBP3 rna"
  ],
  "SSBP4": [
    "SSBP4 cnv",
    "SSBP4 methyl",
    "SSBP4 proteo",
    "SSBP4 rna"
  ],
  "SSC4D": [
    "SSC4D cnv",
    "SSC4D methyl",
    "SSC4D rna"
  ],
  "SSC5D": [
    "SSC5D cnv",
    "SSC5D methyl",
    "SSC5D proteo",
    "SSC5D rna"
  ],
  "SSH1": [
    "SSH1 794_812_1_1_S812 phospho",
    "SSH1 834_843_1_1_S834 phospho",
    "SSH1 883_903_1_1_S897 phospho",
    "SSH1 908_912_1_1_S910 phospho",
    "SSH1 935_943_1_1_S937 phospho",
    "SSH1 cnv",
    "SSH1 methyl",
    "SSH1 proteo",
    "SSH1 rna"
  ],
  "SSH2": [
    "SSH2 1215_1218_1_1_S1217 phospho",
    "SSH2 1415_1422_1_1_T1422 phospho",
    "SSH2 459_466_1_1_S461 phospho",
    "SSH2 485_487_1_1_S487 phospho",
    "SSH2 899_904_1_1_S899 phospho",
    "SSH2 cnv",
    "SSH2 methyl",
    "SSH2 rna"
  ],
  "SSH3": [
    "SSH3 649_653_1_1_S649 phospho",
    "SSH3 649_653_2_2_S649S653 phospho",
    "SSH3 cnv",
    "SSH3 methyl",
    "SSH3 proteo",
    "SSH3 rna"
  ],
  "SSMEM1": [
    "SSMEM1 cnv",
    "SSMEM1 methyl",
    "SSMEM1 rna"
  ],
  "SSNA1": [
    "SSNA1 cnv",
    "SSNA1 methyl",
    "SSNA1 proteo",
    "SSNA1 rna"
  ],
  "SSPN": [
    "SSPN cnv",
    "SSPN methyl",
    "SSPN rna"
  ],
  "SSR1": [
    "SSR1 177_200_1_0 phospho",
    "SSR1 177_200_1_1_S200 phospho",
    "SSR1 cnv",
    "SSR1 methyl",
    "SSR1 proteo",
    "SSR1 rna"
  ],
  "SSR2": [
    "SSR2 IAPASNVSHTVVLRPLK-N2H6F0S0G0 glyco",
    "SSR2 IAPASNVSHTVVLRPLK-N2H7F0S0G0 glyco",
    "SSR2 IAPASNVSHTVVLRPLK-N2H8F0S0G0 glyco",
    "SSR2 IAPASNVSHTVVLRPLK-N2H9F0S0G0 glyco",
    "SSR2 cnv",
    "SSR2 methyl",
    "SSR2 rna"
  ],
  "SSR3": [
    "SSR3 cnv",
    "SSR3 methyl",
    "SSR3 proteo",
    "SSR3 rna"
  ],
  "SSR4": [
    "SSR4 methyl",
    "SSR4 proteo",
    "SSR4 rna"
  ],
  "SSR4P1": [
    "SSR4P1 methyl"
  ],
  "SSRP1": [
    "SSRP1 437_452_1_1_S444 phospho",
    "SSRP1 662_673_1_1_S668 phospho",
    "SSRP1 667_673_1_1_S672 phospho",
    "SSRP1 cnv",
    "SSRP1 methyl",
    "SSRP1 proteo",
    "SSRP1 rna"
  ],
  "SST": [
    "SST cnv",
    "SST methyl",
    "SST rna"
  ],
  "SSTR1": [
    "SSTR1 cnv",
    "SSTR1 methyl",
    "SSTR1 rna"
  ],
  "SSTR2": [
    "SSTR2 333_343_1_1_S343 phospho",
    "SSTR2 cnv",
    "SSTR2 methyl",
    "SSTR2 rna"
  ],
  "SSTR3": [
    "SSTR3 cnv",
    "SSTR3 rna"
  ],
  "SSTR4": [
    "SSTR4 cnv",
    "SSTR4 methyl",
    "SSTR4 rna"
  ],
  "SSTR5": [
    "SSTR5 cnv",
    "SSTR5 methyl",
    "SSTR5 rna"
  ],
  "SSTR5-AS1": [
    "SSTR5-AS1 methyl"
  ],
  "SSU72": [
    "SSU72 cnv",
    "SSU72 methyl",
    "SSU72 proteo",
    "SSU72 rna"
  ],
  "SSU72P2": [
    "SSU72P2 cnv"
  ],
  "SSU72P3": [
    "SSU72P3 cnv"
  ],
  "SSU72P4": [
    "SSU72P4 cnv"
  ],
  "SSU72P5": [
    "SSU72P5 cnv"
  ],
  "SSU72P7": [
    "SSU72P7 cnv"
  ],
  "SSU72P8": [
    "SSU72P8 cnv"
  ],
  "SSUH2": [
    "SSUH2 cnv",
    "SSUH2 rna"
  ],
  "SSX1": [
    "SSX1 rna"
  ],
  "SSX2IP": [
    "SSX2IP cnv",
    "SSX2IP methyl",
    "SSX2IP proteo",
    "SSX2IP rna"
  ],
  "ST13": [
    "ST13 75_79_1_1_S76 phospho",
    "ST13 75_79_1_1_S79 phospho",
    "ST13 75_79_2_2_S76S79 phospho",
    "ST13 cnv",
    "ST13 methyl",
    "ST13 proteo",
    "ST13 rna"
  ],
  "ST14": [
    "ST14 cnv",
    "ST14 methyl",
    "ST14 proteo",
    "ST14 rna"
  ],
  "ST18": [
    "ST18 cnv",
    "ST18 rna"
  ],
  "ST20": [
    "ST20 cnv",
    "ST20 rna"
  ],
  "ST20-MTHFS": [
    "ST20-MTHFS cnv",
    "ST20-MTHFS methyl",
    "ST20-MTHFS rna"
  ],
  "ST3GAL1": [
    "ST3GAL1 cnv",
    "ST3GAL1 methyl",
    "ST3GAL1 rna"
  ],
  "ST3GAL2": [
    "ST3GAL2 cnv",
    "ST3GAL2 methyl",
    "ST3GAL2 rna"
  ],
  "ST3GAL3": [
    "ST3GAL3 cnv",
    "ST3GAL3 methyl",
    "ST3GAL3 rna"
  ],
  "ST3GAL4": [
    "ST3GAL4 cnv",
    "ST3GAL4 methyl",
    "ST3GAL4 proteo",
    "ST3GAL4 rna"
  ],
  "ST3GAL5": [
    "ST3GAL5 cnv",
    "ST3GAL5 methyl",
    "ST3GAL5 rna"
  ],
  "ST3GAL6": [
    "ST3GAL6 cnv",
    "ST3GAL6 methyl",
    "ST3GAL6 rna"
  ],
  "ST6GAL1": [
    "ST6GAL1 cnv",
    "ST6GAL1 methyl",
    "ST6GAL1 proteo",
    "ST6GAL1 rna"
  ],
  "ST6GAL2": [
    "ST6GAL2 cnv",
    "ST6GAL2 methyl",
    "ST6GAL2 rna"
  ],
  "ST6GALNAC1": [
    "ST6GALNAC1 cnv",
    "ST6GALNAC1 rna"
  ],
  "ST6GALNAC2": [
    "ST6GALNAC2 cnv",
    "ST6GALNAC2 methyl",
    "ST6GALNAC2 rna"
  ],
  "ST6GALNAC3": [
    "ST6GALNAC3 cnv",
    "ST6GALNAC3 rna"
  ],
  "ST6GALNAC4": [
    "ST6GALNAC4 cnv",
    "ST6GALNAC4 methyl",
    "ST6GALNAC4 rna"
  ],
  "ST6GALNAC5": [
    "ST6GALNAC5 cnv",
    "ST6GALNAC5 methyl",
    "ST6GALNAC5 rna"
  ],
  "ST6GALNAC6": [
    "ST6GALNAC6 cnv",
    "ST6GALNAC6 methyl",
    "ST6GALNAC6 rna"
  ],
  "ST7": [
    "ST7 cnv",
    "ST7 methyl",
    "ST7 proteo",
    "ST7 rna"
  ],
  "ST7-OT4": [
    "ST7-OT4 methyl"
  ],
  "ST7L": [
    "ST7L cnv",
    "ST7L methyl",
    "ST7L rna"
  ],
  "ST8SIA1": [
    "ST8SIA1 cnv",
    "ST8SIA1 methyl",
    "ST8SIA1 rna"
  ],
  "ST8SIA2": [
    "ST8SIA2 cnv",
    "ST8SIA2 methyl",
    "ST8SIA2 rna"
  ],
  "ST8SIA3": [
    "ST8SIA3 cnv",
    "ST8SIA3 methyl",
    "ST8SIA3 rna"
  ],
  "ST8SIA4": [
    "ST8SIA4 cnv",
    "ST8SIA4 methyl",
    "ST8SIA4 rna"
  ],
  "ST8SIA5": [
    "ST8SIA5 cnv",
    "ST8SIA5 methyl",
    "ST8SIA5 rna"
  ],
  "ST8SIA6": [
    "ST8SIA6 cnv",
    "ST8SIA6 methyl",
    "ST8SIA6 rna"
  ],
  "STAB1": [
    "STAB1 TMNASLAQQLCR-N4H5F1S1G0 glyco",
    "STAB1 cnv",
    "STAB1 proteo",
    "STAB1 rna"
  ],
  "STAB2": [
    "STAB2 cnv",
    "STAB2 rna"
  ],
  "STAC": [
    "STAC cnv",
    "STAC methyl",
    "STAC rna"
  ],
  "STAC2": [
    "STAC2 48_48_1_1_S48 phospho",
    "STAC2 64_84_1_1_S78 phospho",
    "STAC2 cnv",
    "STAC2 methyl",
    "STAC2 rna"
  ],
  "STAC3": [
    "STAC3 cnv",
    "STAC3 rna"
  ],
  "STAG1": [
    "STAG1 1051_1070_1_1_S1062 phospho",
    "STAG1 1051_1070_2_2_S1062S1065 phospho",
    "STAG1 cnv",
    "STAG1 methyl",
    "STAG1 proteo",
    "STAG1 rna"
  ],
  "STAG2": [
    "STAG2 1047_1065_1_1_S1061 phospho",
    "STAG2 1109_1124_1_1_T1112 phospho",
    "STAG2 1197_1215_1_0 phospho",
    "STAG2 methyl",
    "STAG2 proteo",
    "STAG2 rna"
  ],
  "STAG3": [
    "STAG3 cnv",
    "STAG3 methyl",
    "STAG3 rna"
  ],
  "STAG3L4": [
    "STAG3L4 methyl"
  ],
  "STAG3L5P": [
    "STAG3L5P methyl"
  ],
  "STAG3L5P-PVRIG2P-PILRB": [
    "STAG3L5P-PVRIG2P-PILRB cnv",
    "STAG3L5P-PVRIG2P-PILRB methyl",
    "STAG3L5P-PVRIG2P-PILRB rna"
  ],
  "STAM": [
    "STAM cnv",
    "STAM methyl",
    "STAM proteo",
    "STAM rna"
  ],
  "STAM-DT": [
    "STAM-DT methyl"
  ],
  "STAM2": [
    "STAM2 cnv",
    "STAM2 methyl",
    "STAM2 proteo",
    "STAM2 rna"
  ],
  "STAMBP": [
    "STAMBP cnv",
    "STAMBP methyl",
    "STAMBP proteo",
    "STAMBP rna"
  ],
  "STAMBPL1": [
    "STAMBPL1 233_242_1_1_S242 phospho",
    "STAMBPL1 cnv",
    "STAMBPL1 methyl",
    "STAMBPL1 proteo",
    "STAMBPL1 rna"
  ],
  "STAP1": [
    "STAP1 cnv",
    "STAP1 rna"
  ],
  "STAP2": [
    "STAP2 cnv",
    "STAP2 methyl",
    "STAP2 rna"
  ],
  "STAR": [
    "STAR cnv",
    "STAR rna"
  ],
  "STARD10": [
    "STARD10 284_291_1_1_S284 phospho",
    "STARD10 cnv",
    "STARD10 methyl",
    "STARD10 proteo",
    "STARD10 rna"
  ],
  "STARD13": [
    "STARD13 125_133_1_1_S125 phospho",
    "STARD13 306_306_1_1_S306 phospho",
    "STARD13 403_413_1_1_S403 phospho",
    "STARD13 cnv",
    "STARD13 proteo",
    "STARD13 rna"
  ],
  "STARD3": [
    "STARD3 cnv",
    "STARD3 methyl",
    "STARD3 proteo",
    "STARD3 rna"
  ],
  "STARD3NL": [
    "STARD3NL cnv",
    "STARD3NL methyl",
    "STARD3NL proteo",
    "STARD3NL rna"
  ],
  "STARD4": [
    "STARD4 cnv",
    "STARD4 methyl",
    "STARD4 rna"
  ],
  "STARD4-AS1": [
    "STARD4-AS1 methyl"
  ],
  "STARD5": [
    "STARD5 cnv",
    "STARD5 methyl",
    "STARD5 rna"
  ],
  "STARD6": [
    "STARD6 cnv",
    "STARD6 methyl",
    "STARD6 rna"
  ],
  "STARD7": [
    "STARD7 cnv",
    "STARD7 methyl",
    "STARD7 proteo",
    "STARD7 rna"
  ],
  "STARD8": [
    "STARD8 methyl",
    "STARD8 rna"
  ],
  "STARD9": [
    "STARD9 cnv",
    "STARD9 methyl",
    "STARD9 rna"
  ],
  "STAT1": [
    "STAT1 532_540_1_1_S532 phospho",
    "STAT1 719_735_1_1_S727 phospho",
    "STAT1 cnv",
    "STAT1 methyl",
    "STAT1 proteo",
    "STAT1 rna"
  ],
  "STAT2": [
    "STAT2 cnv",
    "STAT2 methyl",
    "STAT2 proteo",
    "STAT2 rna"
  ],
  "STAT3": [
    "STAT3 686_704_1_1_Y704 phospho",
    "STAT3 686_705_1_1_Y705 phospho",
    "STAT3 708_727_1_1_S727 phospho",
    "STAT3 714_727_1_1_S727 phospho",
    "STAT3 714_727_2_0 phospho",
    "STAT3 cnv",
    "STAT3 methyl",
    "STAT3 proteo",
    "STAT3 rna"
  ],
  "STAT4": [
    "STAT4 cnv",
    "STAT4 rna"
  ],
  "STAT4-AS1": [
    "STAT4-AS1 methyl"
  ],
  "STAT5A": [
    "STAT5A cnv",
    "STAT5A methyl",
    "STAT5A proteo",
    "STAT5A rna"
  ],
  "STAT5B": [
    "STAT5B 127_138_1_0 phospho",
    "STAT5B 127_138_1_1_S128 phospho",
    "STAT5B cnv",
    "STAT5B methyl",
    "STAT5B proteo",
    "STAT5B rna"
  ],
  "STAT6": [
    "STAT6 cnv",
    "STAT6 proteo",
    "STAT6 rna"
  ],
  "STATH": [
    "STATH cnv"
  ],
  "STAU1": [
    "STAU1 194_214_1_1_S203 phospho",
    "STAU1 309_322_1_1_S315 phospho",
    "STAU1 cnv",
    "STAU1 methyl",
    "STAU1 proteo",
    "STAU1 rna"
  ],
  "STAU2": [
    "STAU2 432_440_1_1_S440 phospho",
    "STAU2 cnv",
    "STAU2 methyl",
    "STAU2 proteo",
    "STAU2 rna"
  ],
  "STBD1": [
    "STBD1 cnv",
    "STBD1 methyl",
    "STBD1 proteo",
    "STBD1 rna"
  ],
  "STC1": [
    "STC1 cnv",
    "STC1 rna"
  ],
  "STC2": [
    "STC2 cnv",
    "STC2 methyl",
    "STC2 proteo",
    "STC2 rna"
  ],
  "STEAP1": [
    "STEAP1 cnv",
    "STEAP1 methyl",
    "STEAP1 rna"
  ],
  "STEAP1B": [
    "STEAP1B cnv",
    "STEAP1B methyl",
    "STEAP1B rna"
  ],
  "STEAP2": [
    "STEAP2 cnv",
    "STEAP2 methyl",
    "STEAP2 rna"
  ],
  "STEAP2-AS1": [
    "STEAP2-AS1 methyl"
  ],
  "STEAP3": [
    "STEAP3 cnv",
    "STEAP3 methyl",
    "STEAP3 proteo",
    "STEAP3 rna"
  ],
  "STEAP4": [
    "STEAP4 cnv",
    "STEAP4 rna"
  ],
  "STEEP1": [
    "STEEP1 proteo",
    "STEEP1 rna"
  ],
  "STH": [
    "STH cnv",
    "STH rna"
  ],
  "STIL": [
    "STIL cnv",
    "STIL methyl",
    "STIL rna"
  ],
  "STIM1": [
    "STIM1 257_257_1_1_S257 phospho",
    "STIM1 504_512_1_1_S512 phospho",
    "STIM1 517_528_1_1_S521 phospho",
    "STIM1 517_528_2_2_S523S524 phospho",
    "STIM1 567_575_1_1_S575 phospho",
    "STIM1 595_614_1_1_S608 phospho",
    "STIM1 616_633_1_1_S618 phospho",
    "STIM1 616_633_2_2_S618S621 phospho",
    "STIM1 660_668_1_0 phospho",
    "STIM1 660_668_1_1_S668 phospho",
    "STIM1 LAVTNTTMTGTVLK-N2H5F0S0G0 glyco",
    "STIM1 LAVTNTTMTGTVLK-N2H6F0S0G0 glyco",
    "STIM1 LAVTNTTMTGTVLK-N2H7F0S0G0 glyco",
    "STIM1 LAVTNTTMTGTVLK-N2H8F0S0G0 glyco",
    "STIM1 cnv",
    "STIM1 methyl",
    "STIM1 proteo",
    "STIM1 rna"
  ],
  "STIM2": [
    "STIM2 343_346_1_1_S346 phospho",
    "STIM2 526_531_1_1_S531 phospho",
    "STIM2 601_611_1_0 phospho",
    "STIM2 617_629_1_1_S617 phospho",
    "STIM2 669_676_1_1_S669 phospho",
    "STIM2 704_721_1_0 phospho",
    "STIM2 726_727_1_1_S727 phospho",
    "STIM2 cnv",
    "STIM2 methyl",
    "STIM2 proteo",
    "STIM2 rna"
  ],
  "STIMATE": [
    "STIMATE cnv",
    "STIMATE methyl",
    "STIMATE rna"
  ],
  "STIMATE-MUSTN1": [
    "STIMATE-MUSTN1 cnv",
    "STIMATE-MUSTN1 methyl",
    "STIMATE-MUSTN1 rna"
  ],
  "STING1": [
    "STING1 cnv",
    "STING1 proteo",
    "STING1 rna"
  ],
  "STIP1": [
    "STIP1 528_528_1_1_S528 phospho",
    "STIP1 cnv",
    "STIP1 methyl",
    "STIP1 proteo",
    "STIP1 rna"
  ],
  "STK10": [
    "STK10 438_438_1_1_S438 phospho",
    "STK10 448_459_1_0 phospho",
    "STK10 448_459_2_0 phospho",
    "STK10 514_516_1_1_S514 phospho",
    "STK10 cnv",
    "STK10 kinase",
    "STK10 methyl",
    "STK10 proteo",
    "STK10 rna"
  ],
  "STK11": [
    "STK11 31_36_1_1_S31 phospho",
    "STK11 cnv",
    "STK11 kinase",
    "STK11 methyl",
    "STK11 proteo",
    "STK11 rna"
  ],
  "STK11IP": [
    "STK11IP 387_394_1_1_S387 phospho",
    "STK11IP 435_470_1_1_S470 phospho",
    "STK11IP 482_482_1_1_S482 phospho",
    "STK11IP 761_768_1_1_S761 phospho",
    "STK11IP cnv",
    "STK11IP methyl",
    "STK11IP proteo",
    "STK11IP rna"
  ],
  "STK16": [
    "STK16 cnv",
    "STK16 kinase",
    "STK16 methyl",
    "STK16 proteo",
    "STK16 rna"
  ],
  "STK17A": [
    "STK17A cnv",
    "STK17A kinase",
    "STK17A proteo",
    "STK17A rna"
  ],
  "STK17B": [
    "STK17B cnv",
    "STK17B kinase",
    "STK17B methyl",
    "STK17B proteo",
    "STK17B rna"
  ],
  "STK19": [
    "STK19 cnv",
    "STK19 kinase",
    "STK19 methyl",
    "STK19 rna"
  ],
  "STK24": [
    "STK24 cnv",
    "STK24 kinase",
    "STK24 methyl",
    "STK24 proteo",
    "STK24 rna"
  ],
  "STK25": [
    "STK25 cnv",
    "STK25 kinase",
    "STK25 methyl",
    "STK25 proteo",
    "STK25 rna"
  ],
  "STK26": [
    "STK26 kinase",
    "STK26 methyl",
    "STK26 proteo",
    "STK26 rna"
  ],
  "STK3": [
    "STK3 316_325_1_1_S316 phospho",
    "STK3 384_396_1_1_S385 phospho",
    "STK3 cnv",
    "STK3 kinase",
    "STK3 methyl",
    "STK3 proteo",
    "STK3 rna"
  ],
  "STK31": [
    "STK31 cnv",
    "STK31 kinase",
    "STK31 rna"
  ],
  "STK32A": [
    "STK32A cnv",
    "STK32A kinase",
    "STK32A methyl",
    "STK32A rna"
  ],
  "STK32B": [
    "STK32B cnv",
    "STK32B kinase",
    "STK32B methyl",
    "STK32B rna"
  ],
  "STK32C": [
    "STK32C 10_18_1_0 phospho",
    "STK32C 10_18_1_1_S18 phospho",
    "STK32C 10_18_2_2_S10S18 phospho",
    "STK32C 70_76_1_1_S71 phospho",
    "STK32C cnv",
    "STK32C kinase",
    "STK32C methyl",
    "STK32C proteo",
    "STK32C rna"
  ],
  "STK33": [
    "STK33 427_441_1_1_S441 phospho",
    "STK33 468_474_1_1_S470 phospho",
    "STK33 cnv",
    "STK33 kinase",
    "STK33 methyl",
    "STK33 proteo",
    "STK33 rna"
  ],
  "STK35": [
    "STK35 cnv",
    "STK35 kinase",
    "STK35 methyl",
    "STK35 rna"
  ],
  "STK36": [
    "STK36 cnv",
    "STK36 kinase",
    "STK36 methyl",
    "STK36 rna"
  ],
  "STK38": [
    "STK38 281_299_1_0 phospho",
    "STK38 cnv",
    "STK38 kinase",
    "STK38 methyl",
    "STK38 proteo",
    "STK38 rna"
  ],
  "STK38L": [
    "STK38L cnv",
    "STK38L kinase",
    "STK38L methyl",
    "STK38L proteo",
    "STK38L rna"
  ],
  "STK39": [
    "STK39 352_354_1_1_T354 phospho",
    "STK39 370_371_1_0 phospho",
    "STK39 370_371_1_1_S370 phospho",
    "STK39 370_371_1_1_S371 phospho",
    "STK39 370_371_2_2_S370S371 phospho",
    "STK39 377_385_1_1_S385 phospho",
    "STK39 377_393_1_1_S385 phospho",
    "STK39 cnv",
    "STK39 kinase",
    "STK39 methyl",
    "STK39 proteo",
    "STK39 rna"
  ],
  "STK4": [
    "STK4 cnv",
    "STK4 kinase",
    "STK4 methyl",
    "STK4 proteo",
    "STK4 rna"
  ],
  "STK4-DT": [
    "STK4-DT methyl"
  ],
  "STK40": [
    "STK40 cnv",
    "STK40 kinase",
    "STK40 methyl",
    "STK40 rna"
  ],
  "STKLD1": [
    "STKLD1 cnv",
    "STKLD1 kinase",
    "STKLD1 methyl",
    "STKLD1 rna"
  ],
  "STMN1": [
    "STMN1 16_25_2_2_S16S25 phospho",
    "STMN1 28_38_1_1_S38 phospho",
    "STMN1 31_38_1_1_S38 phospho",
    "STMN1 63_63_1_1_S63 phospho",
    "STMN1 cnv",
    "STMN1 methyl",
    "STMN1 proteo",
    "STMN1 rna"
  ],
  "STMN2": [
    "STMN2 cnv",
    "STMN2 proteo",
    "STMN2 rna"
  ],
  "STMN3": [
    "STMN3 39_42_1_1_S39 phospho",
    "STMN3 49_62_1_1_S54 phospho",
    "STMN3 49_62_1_1_S57 phospho",
    "STMN3 69_70_1_1_S70 phospho",
    "STMN3 cnv",
    "STMN3 methyl",
    "STMN3 proteo",
    "STMN3 rna"
  ],
  "STMN4": [
    "STMN4 117_117_1_1_S117 phospho",
    "STMN4 cnv",
    "STMN4 proteo",
    "STMN4 rna"
  ],
  "STMND1": [
    "STMND1 cnv",
    "STMND1 methyl",
    "STMND1 rna"
  ],
  "STMP1": [
    "STMP1 cnv",
    "STMP1 methyl",
    "STMP1 rna"
  ],
  "STN1": [
    "STN1 cnv",
    "STN1 methyl",
    "STN1 rna"
  ],
  "STOM": [
    "STOM cnv",
    "STOM methyl",
    "STOM proteo",
    "STOM rna"
  ],
  "STOML1": [
    "STOML1 cnv",
    "STOML1 methyl",
    "STOML1 rna"
  ],
  "STOML2": [
    "STOML2 282_291_1_1_T282 phospho",
    "STOML2 cnv",
    "STOML2 methyl",
    "STOML2 proteo",
    "STOML2 rna"
  ],
  "STOML3": [
    "STOML3 cnv",
    "STOML3 rna"
  ],
  "STON1": [
    "STON1 cnv",
    "STON1 rna"
  ],
  "STON1-GTF2A1L": [
    "STON1-GTF2A1L cnv",
    "STON1-GTF2A1L rna"
  ],
  "STON2": [
    "STON2 746_746_1_1_S746 phospho",
    "STON2 762_771_1_1_S762 phospho",
    "STON2 cnv",
    "STON2 methyl",
    "STON2 proteo",
    "STON2 rna"
  ],
  "STOX1": [
    "STOX1 cnv",
    "STOX1 methyl",
    "STOX1 rna"
  ],
  "STOX2": [
    "STOX2 886_886_1_1_S886 phospho",
    "STOX2 cnv",
    "STOX2 methyl",
    "STOX2 proteo",
    "STOX2 rna"
  ],
  "STPG1": [
    "STPG1 cnv",
    "STPG1 methyl",
    "STPG1 rna"
  ],
  "STPG2": [
    "STPG2 cnv",
    "STPG2 methyl",
    "STPG2 rna"
  ],
  "STPG3": [
    "STPG3 cnv",
    "STPG3 rna"
  ],
  "STPG4": [
    "STPG4 cnv",
    "STPG4 methyl",
    "STPG4 rna"
  ],
  "STRA6": [
    "STRA6 cnv",
    "STRA6 proteo",
    "STRA6 rna"
  ],
  "STRA8": [
    "STRA8 cnv",
    "STRA8 methyl",
    "STRA8 rna"
  ],
  "STRADA": [
    "STRADA 42_54_1_1_S46 phospho",
    "STRADA cnv",
    "STRADA kinase",
    "STRADA methyl",
    "STRADA proteo",
    "STRADA rna"
  ],
  "STRADB": [
    "STRADB cnv",
    "STRADB kinase",
    "STRADB methyl",
    "STRADB rna"
  ],
  "STRAP": [
    "STRAP 312_312_1_1_S312 phospho",
    "STRAP cnv",
    "STRAP methyl",
    "STRAP proteo",
    "STRAP rna"
  ],
  "STRBP": [
    "STRBP cnv",
    "STRBP methyl",
    "STRBP proteo",
    "STRBP rna"
  ],
  "STRC": [
    "STRC cnv",
    "STRC rna"
  ],
  "STRIP1": [
    "STRIP1 335_341_1_1_S335 phospho",
    "STRIP1 335_341_2_2_S335S339 phospho",
    "STRIP1 59_75_1_1_S59 phospho",
    "STRIP1 cnv",
    "STRIP1 proteo",
    "STRIP1 rna"
  ],
  "STRIP2": [
    "STRIP2 cnv",
    "STRIP2 methyl",
    "STRIP2 proteo",
    "STRIP2 rna"
  ],
  "STRIT1": [
    "STRIT1 cnv",
    "STRIT1 rna"
  ],
  "STRN": [
    "STRN 121_151_1_0 phospho",
    "STRN 121_151_1_1_S137 phospho",
    "STRN 239_245_1_1_S245 phospho",
    "STRN 369_383_1_1_S376 phospho",
    "STRN cnv",
    "STRN methyl",
    "STRN proteo",
    "STRN rna"
  ],
  "STRN3": [
    "STRN3 202_217_1_1_S202 phospho",
    "STRN3 202_217_1_1_S214 phospho",
    "STRN3 229_229_1_1_S229 phospho",
    "STRN3 cnv",
    "STRN3 methyl",
    "STRN3 proteo",
    "STRN3 rna"
  ],
  "STRN4": [
    "STRN4 206_216_1_1_S206 phospho",
    "STRN4 338_348_1_1_S342 phospho",
    "STRN4 371_377_1_1_T377 phospho",
    "STRN4 53_64_1_0 phospho",
    "STRN4 cnv",
    "STRN4 methyl",
    "STRN4 proteo",
    "STRN4 rna"
  ],
  "STS": [
    "STS methyl",
    "STS rna"
  ],
  "STT3A": [
    "STT3A TILVDNNTWNNTHISR-N2H8F0S0G0 glyco",
    "STT3A TILVDNNTWNNTHISR-N8H3F0S0G0 glyco",
    "STT3A cnv",
    "STT3A methyl",
    "STT3A proteo",
    "STT3A rna"
  ],
  "STT3B": [
    "STT3B 13_29_1_1_S14 phospho",
    "STT3B 498_499_2_2_S498S499 phospho",
    "STT3B 498_511_1_1_S498 phospho",
    "STT3B AMSSNETAAYK-N2H6F0S0G0 glyco",
    "STT3B AMSSNETAAYK-N2H7F0S0G0 glyco",
    "STT3B AMSSNETAAYK-N2H8F0S0G0 glyco",
    "STT3B AMSSNETAAYK-N2H9F0S0G0 glyco",
    "STT3B TTLVDNNTWNNSHIALVGK-N2H10F0S0G0 glyco",
    "STT3B TTLVDNNTWNNSHIALVGK-N2H8F0S0G0 glyco",
    "STT3B TTLVDNNTWNNSHIALVGK-N2H9F0S0G0 glyco",
    "STT3B TTLVDNNTWNNSHIALVGK-N4H3F0S2G0 glyco",
    "STT3B TTLVDNNTWNNSHIALVGK-N5H4F2S0G0 glyco",
    "STT3B cnv",
    "STT3B methyl",
    "STT3B proteo",
    "STT3B rna"
  ],
  "STUB1": [
    "STUB1 19_25_1_1_S19 phospho",
    "STUB1 19_25_1_1_S23 phospho",
    "STUB1 19_25_2_2_S19S23 phospho",
    "STUB1 271_276_1_1_S273 phospho",
    "STUB1 cnv",
    "STUB1 methyl",
    "STUB1 proteo",
    "STUB1 rna"
  ],
  "STUB1-DT": [
    "STUB1-DT methyl"
  ],
  "STUM": [
    "STUM cnv",
    "STUM methyl",
    "STUM proteo",
    "STUM rna"
  ],
  "STX10": [
    "STX10 cnv",
    "STX10 methyl",
    "STX10 rna"
  ],
  "STX11": [
    "STX11 cnv",
    "STX11 methyl",
    "STX11 rna"
  ],
  "STX12": [
    "STX12 86_94_1_1_S94 phospho",
    "STX12 cnv",
    "STX12 methyl",
    "STX12 proteo",
    "STX12 rna"
  ],
  "STX16": [
    "STX16 29_39_1_1_S35 phospho",
    "STX16 cnv",
    "STX16 methyl",
    "STX16 proteo",
    "STX16 rna"
  ],
  "STX16-NPEPL1": [
    "STX16-NPEPL1 cnv",
    "STX16-NPEPL1 rna"
  ],
  "STX17": [
    "STX17 287_297_1_1_S289 phospho",
    "STX17 cnv",
    "STX17 methyl",
    "STX17 proteo",
    "STX17 rna"
  ],
  "STX18": [
    "STX18 cnv",
    "STX18 methyl",
    "STX18 proteo",
    "STX18 rna"
  ],
  "STX18-AS1": [
    "STX18-AS1 methyl"
  ],
  "STX19": [
    "STX19 cnv",
    "STX19 rna"
  ],
  "STX1A": [
    "STX1A 10_23_1_1_S14 phospho",
    "STX1A 59_64_1_1_S59 phospho",
    "STX1A 59_64_1_1_S64 phospho",
    "STX1A 95_99_1_1_S95 phospho",
    "STX1A cnv",
    "STX1A methyl",
    "STX1A proteo",
    "STX1A rna"
  ],
  "STX1B": [
    "STX1B 10_14_1_1_S14 phospho",
    "STX1B 58_58_1_1_S58 phospho",
    "STX1B cnv",
    "STX1B methyl",
    "STX1B proteo",
    "STX1B rna"
  ],
  "STX2": [
    "STX2 cnv",
    "STX2 proteo",
    "STX2 rna"
  ],
  "STX3": [
    "STX3 cnv",
    "STX3 methyl",
    "STX3 proteo",
    "STX3 rna"
  ],
  "STX4": [
    "STX4 115_120_1_1_S117 phospho",
    "STX4 14_15_2_2_S14S15 phospho",
    "STX4 5_15_2_2_S14S15 phospho",
    "STX4 cnv",
    "STX4 methyl",
    "STX4 proteo",
    "STX4 rna"
  ],
  "STX5": [
    "STX5 cnv",
    "STX5 methyl",
    "STX5 proteo",
    "STX5 rna"
  ],
  "STX5-DT": [
    "STX5-DT methyl"
  ],
  "STX6": [
    "STX6 cnv",
    "STX6 methyl",
    "STX6 proteo",
    "STX6 rna"
  ],
  "STX7": [
    "STX7 129_137_1_1_S129 phospho",
    "STX7 35_45_1_1_S45 phospho",
    "STX7 35_45_1_1_T41 phospho",
    "STX7 75_81_1_1_T79 phospho",
    "STX7 cnv",
    "STX7 methyl",
    "STX7 proteo",
    "STX7 rna"
  ],
  "STX8": [
    "STX8 cnv",
    "STX8 methyl",
    "STX8 proteo",
    "STX8 rna"
  ],
  "STXBP1": [
    "STXBP1 588_594_1_1_S594 phospho",
    "STXBP1 590_601_1_1_S594 phospho",
    "STXBP1 cnv",
    "STXBP1 methyl",
    "STXBP1 proteo",
    "STXBP1 rna"
  ],
  "STXBP2": [
    "STXBP2 cnv",
    "STXBP2 methyl",
    "STXBP2 proteo",
    "STXBP2 rna"
  ],
  "STXBP3": [
    "STXBP3 cnv",
    "STXBP3 methyl",
    "STXBP3 proteo",
    "STXBP3 rna"
  ],
  "STXBP4": [
    "STXBP4 cnv",
    "STXBP4 methyl",
    "STXBP4 proteo",
    "STXBP4 rna"
  ],
  "STXBP5": [
    "STXBP5 1058_1070_1_1_S1058 phospho",
    "STXBP5 759_762_1_1_S759 phospho",
    "STXBP5 900_919_1_0 phospho",
    "STXBP5 900_919_1_1_S902 phospho",
    "STXBP5 900_919_2_0 phospho",
    "STXBP5 cnv",
    "STXBP5 methyl",
    "STXBP5 proteo",
    "STXBP5 rna"
  ],
  "STXBP5L": [
    "STXBP5L 722_742_1_1_S734 phospho",
    "STXBP5L 747_752_1_1_S747 phospho",
    "STXBP5L 769_781_1_1_S769 phospho",
    "STXBP5L cnv",
    "STXBP5L methyl",
    "STXBP5L proteo",
    "STXBP5L rna"
  ],
  "STXBP6": [
    "STXBP6 cnv",
    "STXBP6 methyl",
    "STXBP6 proteo",
    "STXBP6 rna"
  ],
  "STYK1": [
    "STYK1 cnv",
    "STYK1 kinase",
    "STYK1 methyl",
    "STYK1 rna"
  ],
  "STYX": [
    "STYX 191_201_1_1_S193 phospho",
    "STYX cnv",
    "STYX methyl",
    "STYX rna"
  ],
  "STYXL1": [
    "STYXL1 cnv",
    "STYXL1 methyl",
    "STYXL1 rna"
  ],
  "STYXL2": [
    "STYXL2 cnv",
    "STYXL2 rna"
  ],
  "SUB1": [
    "SUB1 55_58_1_1_S56 phospho",
    "SUB1 55_58_1_1_S58 phospho",
    "SUB1 9_19_1_1_S10 phospho",
    "SUB1 9_19_1_1_S12 phospho",
    "SUB1 9_19_1_1_S17 phospho",
    "SUB1 9_19_1_1_S19 phospho",
    "SUB1 9_19_2_0 phospho",
    "SUB1 cnv",
    "SUB1 methyl",
    "SUB1 proteo",
    "SUB1 rna"
  ],
  "SUCLA2": [
    "SUCLA2 cnv",
    "SUCLA2 methyl",
    "SUCLA2 proteo",
    "SUCLA2 rna"
  ],
  "SUCLG1": [
    "SUCLG1 cnv",
    "SUCLG1 methyl",
    "SUCLG1 proteo",
    "SUCLG1 rna"
  ],
  "SUCLG2": [
    "SUCLG2 cnv",
    "SUCLG2 proteo",
    "SUCLG2 rna"
  ],
  "SUCLG2-DT": [
    "SUCLG2-DT methyl"
  ],
  "SUCNR1": [
    "SUCNR1 cnv",
    "SUCNR1 rna"
  ],
  "SUCO": [
    "SUCO 853_858_1_1_S855 phospho",
    "SUCO SISENATATAAPK-N2H6F0S0G0 glyco",
    "SUCO SISENATATAAPK-N2H8F0S0G0 glyco",
    "SUCO TEDLTEGNK-N2H6F0S0G0 glyco",
    "SUCO TEDLTEGNK-N2H8F0S0G0 glyco",
    "SUCO cnv",
    "SUCO methyl",
    "SUCO proteo",
    "SUCO rna"
  ],
  "SUDS3": [
    "SUDS3 234_248_1_1_S234 phospho",
    "SUDS3 234_248_2_2_S234S236 phospho",
    "SUDS3 cnv",
    "SUDS3 methyl",
    "SUDS3 proteo",
    "SUDS3 rna"
  ],
  "SUFU": [
    "SUFU cnv",
    "SUFU methyl",
    "SUFU proteo",
    "SUFU rna"
  ],
  "SUGCT": [
    "SUGCT cnv",
    "SUGCT methyl",
    "SUGCT proteo",
    "SUGCT rna"
  ],
  "SUGP1": [
    "SUGP1 483_495_1_1_S485 phospho",
    "SUGP1 cnv",
    "SUGP1 methyl",
    "SUGP1 proteo",
    "SUGP1 rna"
  ],
  "SUGP2": [
    "SUGP2 1032_1032_1_1_S1032 phospho",
    "SUGP2 275_288_1_1_S277 phospho",
    "SUGP2 572_575_1_1_S573 phospho",
    "SUGP2 745_777_1_0 phospho",
    "SUGP2 745_777_1_1_S750 phospho",
    "SUGP2 745_777_2_0 phospho",
    "SUGP2 cnv",
    "SUGP2 methyl",
    "SUGP2 proteo",
    "SUGP2 rna"
  ],
  "SUGT1": [
    "SUGT1 cnv",
    "SUGT1 methyl",
    "SUGT1 proteo",
    "SUGT1 rna"
  ],
  "SUGT1-DT": [
    "SUGT1-DT methyl"
  ],
  "SUGT1P3": [
    "SUGT1P3 methyl"
  ],
  "SUGT1P4-STRA6LP": [
    "SUGT1P4-STRA6LP cnv",
    "SUGT1P4-STRA6LP methyl",
    "SUGT1P4-STRA6LP rna"
  ],
  "SUGT1P4-STRA6LP-CCDC180": [
    "SUGT1P4-STRA6LP-CCDC180 cnv",
    "SUGT1P4-STRA6LP-CCDC180 methyl",
    "SUGT1P4-STRA6LP-CCDC180 rna"
  ],
  "SULF1": [
    "SULF1 cnv",
    "SULF1 proteo",
    "SULF1 rna"
  ],
  "SULF2": [
    "SULF2 TFAVYLNSTGYR-N2H5F0S0G0 glyco",
    "SULF2 cnv",
    "SULF2 methyl",
    "SULF2 proteo",
    "SULF2 rna"
  ],
  "SULT1A1": [
    "SULT1A1 cnv",
    "SULT1A1 methyl",
    "SULT1A1 proteo",
    "SULT1A1 rna"
  ],
  "SULT1A2": [
    "SULT1A2 cnv",
    "SULT1A2 methyl",
    "SULT1A2 rna"
  ],
  "SULT1A3": [
    "SULT1A3 cnv",
    "SULT1A3 rna"
  ],
  "SULT1A4": [
    "SULT1A4 cnv",
    "SULT1A4 rna"
  ],
  "SULT1B1": [
    "SULT1B1 cnv",
    "SULT1B1 rna"
  ],
  "SULT1C2": [
    "SULT1C2 52_53_1_0 phospho",
    "SULT1C2 cnv",
    "SULT1C2 rna"
  ],
  "SULT1C3": [
    "SULT1C3 cnv"
  ],
  "SULT1C4": [
    "SULT1C4 18_21_1_1_S18 phospho",
    "SULT1C4 cnv",
    "SULT1C4 rna"
  ],
  "SULT1E1": [
    "SULT1E1 cnv",
    "SULT1E1 rna"
  ],
  "SULT2A1": [
    "SULT2A1 cnv"
  ],
  "SULT2B1": [
    "SULT2B1 cnv",
    "SULT2B1 rna"
  ],
  "SULT4A1": [
    "SULT4A1 cnv",
    "SULT4A1 methyl",
    "SULT4A1 proteo",
    "SULT4A1 rna"
  ],
  "SULT6B1": [
    "SULT6B1 cnv",
    "SULT6B1 methyl",
    "SULT6B1 rna"
  ],
  "SUMF1": [
    "SUMF1 FVNSTGYLTEAEK-N2H6F0S0G0 glyco",
    "SUMF1 cnv",
    "SUMF1 proteo",
    "SUMF1 rna"
  ],
  "SUMF2": [
    "SUMF2 cnv",
    "SUMF2 methyl",
    "SUMF2 proteo",
    "SUMF2 rna"
  ],
  "SUMO1": [
    "SUMO1 cnv",
    "SUMO1 methyl",
    "SUMO1 proteo",
    "SUMO1 rna"
  ],
  "SUMO2": [
    "SUMO2 cnv",
    "SUMO2 methyl",
    "SUMO2 proteo",
    "SUMO2 rna"
  ],
  "SUMO2P17": [
    "SUMO2P17 methyl"
  ],
  "SUMO3": [
    "SUMO3 cnv",
    "SUMO3 methyl",
    "SUMO3 proteo",
    "SUMO3 rna"
  ],
  "SUMO4": [
    "SUMO4 cnv",
    "SUMO4 rna"
  ],
  "SUN1": [
    "SUN1 TLSPTGNISSAPK-N2H6F0S0G0 glyco",
    "SUN1 cnv",
    "SUN1 methyl",
    "SUN1 proteo",
    "SUN1 rna"
  ],
  "SUN2": [
    "SUN2 ALSPNSTISSAPK-N2H5F0S0G0 glyco",
    "SUN2 ALSPNSTISSAPK-N2H6F0S0G0 glyco",
    "SUN2 ALSPNSTISSAPK-N2H7F0S0G0 glyco",
    "SUN2 ALSPNSTISSAPK-N2H8F0S0G0 glyco",
    "SUN2 cnv",
    "SUN2 methyl",
    "SUN2 proteo",
    "SUN2 rna"
  ],
  "SUN3": [
    "SUN3 cnv",
    "SUN3 rna"
  ],
  "SUN5": [
    "SUN5 cnv"
  ],
  "SUOX": [
    "SUOX cnv",
    "SUOX proteo",
    "SUOX rna"
  ],
  "SUPT16H": [
    "SUPT16H cnv",
    "SUPT16H methyl",
    "SUPT16H proteo",
    "SUPT16H rna"
  ],
  "SUPT20H": [
    "SUPT20H 492_503_1_1_T494 phospho",
    "SUPT20H cnv",
    "SUPT20H methyl",
    "SUPT20H proteo",
    "SUPT20H rna"
  ],
  "SUPT20HL1": [
    "SUPT20HL1 methyl",
    "SUPT20HL1 rna"
  ],
  "SUPT20HL2": [
    "SUPT20HL2 methyl",
    "SUPT20HL2 rna"
  ],
  "SUPT3H": [
    "SUPT3H cnv",
    "SUPT3H methyl",
    "SUPT3H proteo",
    "SUPT3H rna"
  ],
  "SUPT4H1": [
    "SUPT4H1 cnv",
    "SUPT4H1 methyl",
    "SUPT4H1 proteo",
    "SUPT4H1 rna"
  ],
  "SUPT5H": [
    "SUPT5H 1024_1036_1_1_T1034 phospho",
    "SUPT5H 655_666_1_1_S666 phospho",
    "SUPT5H 670_676_1_1_S671 phospho",
    "SUPT5H 784_797_1_1_T791 phospho",
    "SUPT5H 799_812_1_1_T806 phospho",
    "SUPT5H cnv",
    "SUPT5H methyl",
    "SUPT5H proteo",
    "SUPT5H rna"
  ],
  "SUPT6H": [
    "SUPT6H 125_135_1_1_S125 phospho",
    "SUPT6H 1515_1528_1_1_T1523 phospho",
    "SUPT6H cnv",
    "SUPT6H methyl",
    "SUPT6H proteo",
    "SUPT6H rna"
  ],
  "SUPT7L": [
    "SUPT7L cnv",
    "SUPT7L methyl",
    "SUPT7L proteo",
    "SUPT7L rna"
  ],
  "SUPV3L1": [
    "SUPV3L1 cnv",
    "SUPV3L1 methyl",
    "SUPV3L1 proteo",
    "SUPV3L1 rna"
  ],
  "SURF1": [
    "SURF1 cnv",
    "SURF1 methyl",
    "SURF1 proteo",
    "SURF1 rna"
  ],
  "SURF2": [
    "SURF2 cnv",
    "SURF2 methyl",
    "SURF2 proteo",
    "SURF2 rna"
  ],
  "SURF4": [
    "SURF4 cnv",
    "SURF4 methyl",
    "SURF4 proteo",
    "SURF4 rna"
  ],
  "SURF6": [
    "SURF6 138_138_1_1_S138 phospho",
    "SURF6 cnv",
    "SURF6 methyl",
    "SURF6 proteo",
    "SURF6 rna"
  ],
  "SUSD1": [
    "SUSD1 cnv",
    "SUSD1 methyl",
    "SUSD1 rna"
  ],
  "SUSD2": [
    "SUSD2 cnv",
    "SUSD2 proteo",
    "SUSD2 rna"
  ],
  "SUSD3": [
    "SUSD3 cnv",
    "SUSD3 methyl",
    "SUSD3 rna"
  ],
  "SUSD4": [
    "SUSD4 cnv",
    "SUSD4 methyl",
    "SUSD4 rna"
  ],
  "SUSD5": [
    "SUSD5 cnv",
    "SUSD5 methyl",
    "SUSD5 proteo",
    "SUSD5 rna"
  ],
  "SUSD6": [
    "SUSD6 cnv",
    "SUSD6 methyl",
    "SUSD6 rna"
  ],
  "SUV39H1": [
    "SUV39H1 rna"
  ],
  "SUV39H2": [
    "SUV39H2 cnv",
    "SUV39H2 methyl",
    "SUV39H2 rna"
  ],
  "SUZ12": [
    "SUZ12 cnv",
    "SUZ12 methyl",
    "SUZ12 proteo",
    "SUZ12 rna"
  ],
  "SV2A": [
    "SV2A 127_127_1_1_S127 phospho",
    "SV2A 45_66_1_1_S45 phospho",
    "SV2A cnv",
    "SV2A proteo",
    "SV2A rna"
  ],
  "SV2B": [
    "SV2B 25_50_1_1_S25 phospho",
    "SV2B 25_50_2_2_S33T36 phospho",
    "SV2B 73_78_1_1_S73 phospho",
    "SV2B cnv",
    "SV2B methyl",
    "SV2B proteo",
    "SV2B rna"
  ],
  "SV2C": [
    "SV2C cnv",
    "SV2C methyl",
    "SV2C rna"
  ],
  "SVBP": [
    "SVBP cnv",
    "SVBP methyl",
    "SVBP proteo",
    "SVBP rna"
  ],
  "SVEP1": [
    "SVEP1 cnv",
    "SVEP1 methyl",
    "SVEP1 proteo",
    "SVEP1 rna"
  ],
  "SVIL": [
    "SVIL 237_245_2_2_S238S245 phospho",
    "SVIL 278_285_1_1_S279 phospho",
    "SVIL 313_313_1_1_S313 phospho",
    "SVIL 424_439_1_1_T426 phospho",
    "SVIL 540_550_1_1_S542 phospho",
    "SVIL cnv",
    "SVIL methyl",
    "SVIL proteo",
    "SVIL rna"
  ],
  "SVIL-AS1": [
    "SVIL-AS1 methyl"
  ],
  "SVIP": [
    "SVIP cnv",
    "SVIP methyl",
    "SVIP proteo",
    "SVIP rna"
  ],
  "SVOP": [
    "SVOP cnv",
    "SVOP proteo",
    "SVOP rna"
  ],
  "SVOPL": [
    "SVOPL cnv",
    "SVOPL methyl",
    "SVOPL rna"
  ],
  "SWAP70": [
    "SWAP70 cnv",
    "SWAP70 methyl",
    "SWAP70 proteo",
    "SWAP70 rna"
  ],
  "SWI5": [
    "SWI5 cnv",
    "SWI5 methyl",
    "SWI5 rna"
  ],
  "SWSAP1": [
    "SWSAP1 cnv",
    "SWSAP1 methyl",
    "SWSAP1 rna"
  ],
  "SWT1": [
    "SWT1 cnv",
    "SWT1 methyl",
    "SWT1 rna"
  ],
  "SYAP1": [
    "SYAP1 248_248_1_1_T248 phospho",
    "SYAP1 methyl",
    "SYAP1 proteo",
    "SYAP1 rna"
  ],
  "SYBU": [
    "SYBU 213_234_1_1_S213 phospho",
    "SYBU cnv",
    "SYBU methyl",
    "SYBU proteo",
    "SYBU rna"
  ],
  "SYCE1": [
    "SYCE1 cnv",
    "SYCE1 methyl",
    "SYCE1 rna"
  ],
  "SYCE1L": [
    "SYCE1L cnv",
    "SYCE1L methyl",
    "SYCE1L rna"
  ],
  "SYCE2": [
    "SYCE2 cnv",
    "SYCE2 methyl",
    "SYCE2 rna"
  ],
  "SYCE3": [
    "SYCE3 cnv",
    "SYCE3 methyl",
    "SYCE3 rna"
  ],
  "SYCN": [
    "SYCN cnv",
    "SYCN methyl"
  ],
  "SYCP1": [
    "SYCP1 cnv",
    "SYCP1 methyl",
    "SYCP1 rna"
  ],
  "SYCP2": [
    "SYCP2 cnv",
    "SYCP2 methyl",
    "SYCP2 rna"
  ],
  "SYCP2L": [
    "SYCP2L cnv",
    "SYCP2L methyl",
    "SYCP2L rna"
  ],
  "SYCP3": [
    "SYCP3 cnv",
    "SYCP3 methyl",
    "SYCP3 rna"
  ],
  "SYDE1": [
    "SYDE1 cnv",
    "SYDE1 rna"
  ],
  "SYDE2": [
    "SYDE2 cnv",
    "SYDE2 methyl",
    "SYDE2 rna"
  ],
  "SYF2": [
    "SYF2 cnv",
    "SYF2 methyl",
    "SYF2 proteo",
    "SYF2 rna"
  ],
  "SYK": [
    "SYK cnv",
    "SYK kinase",
    "SYK methyl",
    "SYK proteo",
    "SYK rna"
  ],
  "SYMPK": [
    "SYMPK 1168_1177_1_1_S1171 phospho",
    "SYMPK 1243_1246_1_1_S1243 phospho",
    "SYMPK 1243_1259_1_1_S1259 phospho",
    "SYMPK 1243_1259_2_2_T1257S1259 phospho",
    "SYMPK 1257_1259_1_1_S1259 phospho",
    "SYMPK 494_510_1_1_S494 phospho",
    "SYMPK cnv",
    "SYMPK methyl",
    "SYMPK proteo",
    "SYMPK rna"
  ],
  "SYN1": [
    "SYN1 39_50_1_1_S39 phospho",
    "SYN1 427_438_1_1_S427 phospho",
    "SYN1 432_438_1_1_S438 phospho",
    "SYN1 448_449_1_1_S449 phospho",
    "SYN1 510_526_1_1_S510 phospho",
    "SYN1 510_526_1_1_S520 phospho",
    "SYN1 533_553_2_2_S551S553 phospho",
    "SYN1 54_81_1_0 phospho",
    "SYN1 54_81_1_1_S62 phospho",
    "SYN1 54_81_1_1_S67 phospho",
    "SYN1 54_81_1_1_S81 phospho",
    "SYN1 551_553_1_1_S553 phospho",
    "SYN1 551_553_2_2_S551S553 phospho",
    "SYN1 567_570_1_1_S568 phospho",
    "SYN1 641_649_1_1_S641 phospho",
    "SYN1 663_663_1_1_S663 phospho",
    "SYN1 663_683_1_0 phospho",
    "SYN1 663_683_1_1_S665 phospho",
    "SYN1 663_691_1_1_S665 phospho",
    "SYN1 9_23_1_1_S9 phospho",
    "SYN1 9_50_1_0 phospho",
    "SYN1 9_50_1_1_S39 phospho",
    "SYN1 9_50_1_1_S9 phospho",
    "SYN1 9_50_2_2_S9S39 phospho",
    "SYN1 methyl",
    "SYN1 proteo",
    "SYN1 rna"
  ],
  "SYN2": [
    "SYN2 419_439_1_0 phospho",
    "SYN2 419_439_1_1_T421 phospho",
    "SYN2 419_439_2_0 phospho",
    "SYN2 419_439_2_2_T421S425 phospho",
    "SYN2 421_439_1_1_S425 phospho",
    "SYN2 421_439_1_1_T421 phospho",
    "SYN2 421_439_2_2_T421S425 phospho",
    "SYN2 421_446_1_1_S425 phospho",
    "SYN2 540_553_1_1_S542 phospho",
    "SYN2 cnv",
    "SYN2 methyl",
    "SYN2 proteo",
    "SYN2 rna"
  ],
  "SYN3": [
    "SYN3 446_446_1_1_S446 phospho",
    "SYN3 452_474_1_1_S461 phospho",
    "SYN3 452_474_2_2_S461S469 phospho",
    "SYN3 461_474_1_1_S469 phospho",
    "SYN3 461_474_1_1_S474 phospho",
    "SYN3 461_474_2_2_S469S474 phospho",
    "SYN3 480_487_2_2_S480S483 phospho",
    "SYN3 517_525_1_0 phospho",
    "SYN3 538_551_1_1_S540 phospho",
    "SYN3 cnv",
    "SYN3 methyl",
    "SYN3 proteo",
    "SYN3 rna"
  ],
  "SYNC": [
    "SYNC cnv",
    "SYNC methyl",
    "SYNC proteo",
    "SYNC rna"
  ],
  "SYNCRIP": [
    "SYNCRIP cnv",
    "SYNCRIP methyl",
    "SYNCRIP proteo",
    "SYNCRIP rna"
  ],
  "SYNDIG1": [
    "SYNDIG1 cnv",
    "SYNDIG1 methyl",
    "SYNDIG1 rna"
  ],
  "SYNDIG1L": [
    "SYNDIG1L cnv",
    "SYNDIG1L methyl",
    "SYNDIG1L rna"
  ],
  "SYNE1": [
    "SYNE1 5943_5946_1_1_S5943 phospho",
    "SYNE1 8223_8236_1_1_S8223 phospho",
    "SYNE1 8305_8317_1_1_S8305 phospho",
    "SYNE1 8358_8370_1_1_T8360 phospho",
    "SYNE1 8360_8370_1_1_T8360 phospho",
    "SYNE1 8704_8717_1_1_S8704 phospho",
    "SYNE1 cnv",
    "SYNE1 methyl",
    "SYNE1 mut",
    "SYNE1 proteo",
    "SYNE1 rna"
  ],
  "SYNE2": [
    "SYNE2 2781_2784_1_1_S2781 phospho",
    "SYNE2 cnv",
    "SYNE2 methyl",
    "SYNE2 proteo",
    "SYNE2 rna"
  ],
  "SYNE3": [
    "SYNE3 cnv",
    "SYNE3 methyl",
    "SYNE3 proteo",
    "SYNE3 rna"
  ],
  "SYNE4": [
    "SYNE4 cnv",
    "SYNE4 rna"
  ],
  "SYNGAP1": [
    "SYNGAP1 1124_1137_1_0 phospho",
    "SYNGAP1 1140_1164_1_1_S1151 phospho",
    "SYNGAP1 116_134_1_1_S117 phospho",
    "SYNGAP1 1182_1188_1_1_S1188 phospho",
    "SYNGAP1 165_165_1_1_S165 phospho",
    "SYNGAP1 85_100_1_1_S87 phospho",
    "SYNGAP1 cnv",
    "SYNGAP1 proteo",
    "SYNGAP1 rna"
  ],
  "SYNGR1": [
    "SYNGR1 cnv",
    "SYNGR1 methyl",
    "SYNGR1 proteo",
    "SYNGR1 rna"
  ],
  "SYNGR2": [
    "SYNGR2 cnv",
    "SYNGR2 methyl",
    "SYNGR2 proteo",
    "SYNGR2 rna"
  ],
  "SYNGR3": [
    "SYNGR3 133_140_1_1_T140 phospho",
    "SYNGR3 cnv",
    "SYNGR3 methyl",
    "SYNGR3 proteo",
    "SYNGR3 rna"
  ],
  "SYNGR4": [
    "SYNGR4 cnv",
    "SYNGR4 methyl",
    "SYNGR4 rna"
  ],
  "SYNJ1": [
    "SYNJ1 1087_1108_1_1_S1088 phospho",
    "SYNJ1 1087_1108_1_1_S1092 phospho",
    "SYNJ1 1087_1108_2_2_S1088S1092 phospho",
    "SYNJ1 1114_1131_1_1_S1123 phospho",
    "SYNJ1 1189_1189_1_1_S1189 phospho",
    "SYNJ1 1254_1264_1_1_T1259 phospho",
    "SYNJ1 1331_1341_1_1_S1331 phospho",
    "SYNJ1 1331_1349_1_1_S1331 phospho",
    "SYNJ1 cnv",
    "SYNJ1 methyl",
    "SYNJ1 proteo",
    "SYNJ1 rna"
  ],
  "SYNJ2": [
    "SYNJ2 885_904_1_1_S887 phospho",
    "SYNJ2 cnv",
    "SYNJ2 methyl",
    "SYNJ2 proteo",
    "SYNJ2 rna"
  ],
  "SYNJ2BP": [
    "SYNJ2BP cnv",
    "SYNJ2BP rna"
  ],
  "SYNJ2BP-COX16": [
    "SYNJ2BP-COX16 cnv",
    "SYNJ2BP-COX16 rna"
  ],
  "SYNM": [
    "SYNM 1044_1049_1_1_S1044 phospho",
    "SYNM 1044_1049_1_1_S1049 phospho",
    "SYNM 1044_1049_2_2_S1044S1049 phospho",
    "SYNM 1175_1184_1_1_S1181 phospho",
    "SYNM 1312_1312_1_1_S1312 phospho",
    "SYNM 1426_1435_1_1_S1432 phospho",
    "SYNM 1504_1504_1_1_S1504 phospho",
    "SYNM 341_347_1_1_S341 phospho",
    "SYNM 367_389_1_1_S376 phospho",
    "SYNM 384_389_1_1_S384 phospho",
    "SYNM 598_607_1_1_T598 phospho",
    "SYNM 622_645_1_0 phospho",
    "SYNM 622_645_1_1_S628 phospho",
    "SYNM 651_666_1_1_S653 phospho",
    "SYNM 805_834_1_1_S824 phospho",
    "SYNM 897_905_1_1_S897 phospho",
    "SYNM 913_921_1_1_S913 phospho",
    "SYNM 935_936_1_1_S936 phospho",
    "SYNM cnv",
    "SYNM methyl",
    "SYNM proteo",
    "SYNM rna"
  ],
  "SYNPO": [
    "SYNPO 239_257_1_0 phospho",
    "SYNPO 239_257_1_1_S257 phospho",
    "SYNPO 276_281_1_1_S281 phospho",
    "SYNPO 336_347_1_1_S336 phospho",
    "SYNPO 38_45_1_1_S45 phospho",
    "SYNPO 441_454_1_1_S441 phospho",
    "SYNPO 441_458_1_1_S458 phospho",
    "SYNPO 494_502_1_1_T502 phospho",
    "SYNPO 510_518_1_0 phospho",
    "SYNPO 510_518_1_1_S510 phospho",
    "SYNPO 535_560_1_1_T539 phospho",
    "SYNPO 565_575_1_1_S575 phospho",
    "SYNPO 589_595_1_1_S589 phospho",
    "SYNPO 589_595_1_1_S595 phospho",
    "SYNPO 619_651_1_0 phospho",
    "SYNPO 619_651_1_1_S638 phospho",
    "SYNPO 736_750_1_1_S738 phospho",
    "SYNPO 774_784_1_1_S784 phospho",
    "SYNPO 804_812_1_1_S804 phospho",
    "SYNPO 826_851_1_1_S840 phospho",
    "SYNPO 854_867_1_1_S854 phospho",
    "SYNPO 854_877_1_1_S871 phospho",
    "SYNPO 871_877_1_1_S871 phospho",
    "SYNPO cnv",
    "SYNPO proteo",
    "SYNPO rna"
  ],
  "SYNPO2": [
    "SYNPO2 564_575_1_1_S573 phospho",
    "SYNPO2 579_602_1_0 phospho",
    "SYNPO2 579_602_1_1_S580 phospho",
    "SYNPO2 724_724_1_1_T724 phospho",
    "SYNPO2 736_767_1_1_S746 phospho",
    "SYNPO2 871_879_1_0 phospho",
    "SYNPO2 871_879_1_1_S871 phospho",
    "SYNPO2 cnv",
    "SYNPO2 proteo",
    "SYNPO2 rna"
  ],
  "SYNPO2L": [
    "SYNPO2L cnv",
    "SYNPO2L rna"
  ],
  "SYNPR": [
    "SYNPR cnv",
    "SYNPR methyl",
    "SYNPR proteo",
    "SYNPR rna"
  ],
  "SYNRG": [
    "SYNRG 1020_1022_1_1_T1022 phospho",
    "SYNRG 389_406_1_1_S391 phospho",
    "SYNRG 497_508_1_1_S502 phospho",
    "SYNRG 674_678_1_1_S674 phospho",
    "SYNRG 734_744_1_1_S734 phospho",
    "SYNRG 774_784_1_1_S774 phospho",
    "SYNRG 853_867_1_0 phospho",
    "SYNRG 853_867_1_1_S857 phospho",
    "SYNRG cnv",
    "SYNRG methyl",
    "SYNRG proteo",
    "SYNRG rna"
  ],
  "SYP": [
    "SYP 186_189_1_1_T186 phospho",
    "SYP 81_86_1_1_Y81 phospho",
    "SYP methyl",
    "SYP proteo",
    "SYP rna"
  ],
  "SYPL1": [
    "SYPL1 GQTEIQVNCPPAVTENK-N2H5F0S0G0 glyco",
    "SYPL1 GQTEIQVNCPPAVTENK-N3H6F0S1G0 glyco",
    "SYPL1 GQTEIQVNCPPAVTENK-N3H6F1S0G0 glyco",
    "SYPL1 cnv",
    "SYPL1 methyl",
    "SYPL1 proteo",
    "SYPL1 rna"
  ],
  "SYPL2": [
    "SYPL2 cnv",
    "SYPL2 methyl",
    "SYPL2 rna"
  ],
  "SYS1": [
    "SYS1 cnv",
    "SYS1 methyl",
    "SYS1 rna"
  ],
  "SYS1-DBNDD2": [
    "SYS1-DBNDD2 cnv",
    "SYS1-DBNDD2 rna"
  ],
  "SYT1": [
    "SYT1 123_126_1_1_T126 phospho",
    "SYT1 cnv",
    "SYT1 proteo",
    "SYT1 rna"
  ],
  "SYT10": [
    "SYT10 cnv",
    "SYT10 methyl",
    "SYT10 rna"
  ],
  "SYT11": [
    "SYT11 128_144_1_1_S134 phospho",
    "SYT11 417_417_1_1_S417 phospho",
    "SYT11 cnv",
    "SYT11 methyl",
    "SYT11 proteo",
    "SYT11 rna"
  ],
  "SYT12": [
    "SYT12 cnv",
    "SYT12 proteo",
    "SYT12 rna"
  ],
  "SYT13": [
    "SYT13 cnv",
    "SYT13 methyl",
    "SYT13 rna"
  ],
  "SYT14": [
    "SYT14 cnv",
    "SYT14 methyl",
    "SYT14 rna"
  ],
  "SYT15": [
    "SYT15 cnv",
    "SYT15 methyl",
    "SYT15 rna"
  ],
  "SYT15B": [
    "SYT15B cnv",
    "SYT15B rna"
  ],
  "SYT16": [
    "SYT16 cnv",
    "SYT16 methyl",
    "SYT16 rna"
  ],
  "SYT17": [
    "SYT17 cnv",
    "SYT17 methyl",
    "SYT17 proteo",
    "SYT17 rna"
  ],
  "SYT2": [
    "SYT2 cnv",
    "SYT2 methyl",
    "SYT2 proteo",
    "SYT2 rna"
  ],
  "SYT3": [
    "SYT3 cnv",
    "SYT3 methyl",
    "SYT3 proteo",
    "SYT3 rna"
  ],
  "SYT4": [
    "SYT4 108_122_1_1_S114 phospho",
    "SYT4 cnv",
    "SYT4 rna"
  ],
  "SYT5": [
    "SYT5 cnv",
    "SYT5 methyl",
    "SYT5 proteo",
    "SYT5 rna"
  ],
  "SYT6": [
    "SYT6 101_118_1_1_S102 phospho",
    "SYT6 131_131_1_1_S131 phospho",
    "SYT6 cnv",
    "SYT6 methyl",
    "SYT6 proteo",
    "SYT6 rna"
  ],
  "SYT7": [
    "SYT7 52_61_1_1_S61 phospho",
    "SYT7 52_61_1_1_T58 phospho",
    "SYT7 52_61_2_2_T58S61 phospho",
    "SYT7 cnv",
    "SYT7 methyl",
    "SYT7 proteo",
    "SYT7 rna"
  ],
  "SYT8": [
    "SYT8 cnv",
    "SYT8 rna"
  ],
  "SYT9": [
    "SYT9 207_207_1_1_S207 phospho",
    "SYT9 cnv",
    "SYT9 methyl",
    "SYT9 rna"
  ],
  "SYT9-AS1": [
    "SYT9-AS1 methyl"
  ],
  "SYTL1": [
    "SYTL1 cnv",
    "SYTL1 methyl",
    "SYTL1 rna"
  ],
  "SYTL2": [
    "SYTL2 cnv",
    "SYTL2 methyl",
    "SYTL2 proteo",
    "SYTL2 rna"
  ],
  "SYTL3": [
    "SYTL3 cnv",
    "SYTL3 rna"
  ],
  "SYTL4": [
    "SYTL4 69_74_1_1_S74 phospho",
    "SYTL4 methyl",
    "SYTL4 proteo",
    "SYTL4 rna"
  ],
  "SYTL5": [
    "SYTL5 methyl",
    "SYTL5 rna"
  ],
  "SYVN1": [
    "SYVN1 612_612_1_1_S612 phospho",
    "SYVN1 cnv",
    "SYVN1 methyl",
    "SYVN1 proteo",
    "SYVN1 rna"
  ],
  "SZRD1": [
    "SZRD1 105_107_1_1_S107 phospho",
    "SZRD1 37_51_1_0 phospho",
    "SZRD1 37_51_1_1_S39 phospho",
    "SZRD1 37_51_2_2_S37S39 phospho",
    "SZRD1 67_82_1_1_S68 phospho",
    "SZRD1 cnv",
    "SZRD1 methyl",
    "SZRD1 proteo",
    "SZRD1 rna"
  ],
  "SZT2": [
    "SZT2 2065_2086_1_1_S2079 phospho",
    "SZT2 cnv",
    "SZT2 methyl",
    "SZT2 proteo",
    "SZT2 rna"
  ],
  "TAAR1": [
    "TAAR1 cnv"
  ],
  "TAAR2": [
    "TAAR2 cnv"
  ],
  "TAAR5": [
    "TAAR5 cnv",
    "TAAR5 rna"
  ],
  "TAAR6": [
    "TAAR6 cnv",
    "TAAR6 rna"
  ],
  "TAAR8": [
    "TAAR8 cnv",
    "TAAR8 rna"
  ],
  "TAAR9": [
    "TAAR9 cnv",
    "TAAR9 rna"
  ],
  "TAB1": [
    "TAB1 367_378_1_1_S378 phospho",
    "TAB1 cnv",
    "TAB1 methyl",
    "TAB1 proteo",
    "TAB1 rna"
  ],
  "TAB2": [
    "TAB2 366_381_1_1_S372 phospho",
    "TAB2 cnv",
    "TAB2 methyl",
    "TAB2 proteo",
    "TAB2 rna"
  ],
  "TAB3": [
    "TAB3 383_392_1_1_S385 phospho",
    "TAB3 398_411_1_0 phospho",
    "TAB3 398_411_1_1_T404 phospho",
    "TAB3 504_515_1_1_S506 phospho",
    "TAB3 53_60_1_1_S60 phospho",
    "TAB3 97_103_1_1_S103 phospho",
    "TAB3 methyl",
    "TAB3 proteo",
    "TAB3 rna"
  ],
  "TAC1": [
    "TAC1 cnv",
    "TAC1 methyl",
    "TAC1 rna"
  ],
  "TAC3": [
    "TAC3 cnv",
    "TAC3 rna"
  ],
  "TAC4": [
    "TAC4 cnv",
    "TAC4 rna"
  ],
  "TACC1": [
    "TACC1 129_147_1_1_S147 phospho",
    "TACC1 60_64_1_1_S60 phospho",
    "TACC1 cnv",
    "TACC1 methyl",
    "TACC1 proteo",
    "TACC1 rna"
  ],
  "TACC2": [
    "TACC2 2027_2034_1_1_S2027 phospho",
    "TACC2 2181_2181_1_1_S2181 phospho",
    "TACC2 2188_2211_1_1_S2211 phospho",
    "TACC2 2262_2276_1_1_S2272 phospho",
    "TACC2 2262_2276_2_2_S2272S2276 phospho",
    "TACC2 2269_2276_1_1_S2272 phospho",
    "TACC2 2269_2276_2_2_S2272S2276 phospho",
    "TACC2 2314_2332_1_1_S2314 phospho",
    "TACC2 2466_2474_1_1_S2467 phospho",
    "TACC2 2522_2542_1_1_S2524 phospho",
    "TACC2 cnv",
    "TACC2 methyl",
    "TACC2 proteo",
    "TACC2 rna"
  ],
  "TACC3": [
    "TACC3 315_331_1_1_S317 phospho",
    "TACC3 424_437_1_1_S434 phospho",
    "TACC3 cnv",
    "TACC3 methyl",
    "TACC3 proteo",
    "TACC3 rna"
  ],
  "TACO1": [
    "TACO1 cnv",
    "TACO1 methyl",
    "TACO1 proteo",
    "TACO1 rna"
  ],
  "TACR1": [
    "TACR1 341_349_1_1_S347 phospho",
    "TACR1 cnv",
    "TACR1 methyl",
    "TACR1 rna"
  ],
  "TACR2": [
    "TACR2 cnv",
    "TACR2 methyl",
    "TACR2 rna"
  ],
  "TACR3": [
    "TACR3 cnv",
    "TACR3 rna"
  ],
  "TACSTD2": [
    "TACSTD2 cnv",
    "TACSTD2 methyl",
    "TACSTD2 rna"
  ],
  "TADA1": [
    "TADA1 cnv",
    "TADA1 methyl",
    "TADA1 rna"
  ],
  "TADA2A": [
    "TADA2A cnv",
    "TADA2A methyl",
    "TADA2A rna"
  ],
  "TADA2B": [
    "TADA2B cnv",
    "TADA2B methyl",
    "TADA2B rna"
  ],
  "TADA3": [
    "TADA3 cnv",
    "TADA3 methyl",
    "TADA3 proteo",
    "TADA3 rna"
  ],
  "TAF1": [
    "TAF1 methyl",
    "TAF1 proteo",
    "TAF1 rna"
  ],
  "TAF10": [
    "TAF10 cnv",
    "TAF10 methyl",
    "TAF10 proteo",
    "TAF10 rna"
  ],
  "TAF11": [
    "TAF11 cnv",
    "TAF11 methyl",
    "TAF11 rna"
  ],
  "TAF11L10": [
    "TAF11L10 cnv",
    "TAF11L10 rna"
  ],
  "TAF11L11": [
    "TAF11L11 cnv"
  ],
  "TAF11L12": [
    "TAF11L12 cnv"
  ],
  "TAF11L13": [
    "TAF11L13 cnv"
  ],
  "TAF11L14": [
    "TAF11L14 cnv"
  ],
  "TAF11L2": [
    "TAF11L2 cnv"
  ],
  "TAF11L3": [
    "TAF11L3 cnv"
  ],
  "TAF11L4": [
    "TAF11L4 cnv"
  ],
  "TAF11L5": [
    "TAF11L5 cnv",
    "TAF11L5 rna"
  ],
  "TAF11L6": [
    "TAF11L6 cnv"
  ],
  "TAF11L7": [
    "TAF11L7 cnv"
  ],
  "TAF11L8": [
    "TAF11L8 cnv"
  ],
  "TAF11L9": [
    "TAF11L9 cnv",
    "TAF11L9 rna"
  ],
  "TAF12": [
    "TAF12 43_59_1_1_S51 phospho",
    "TAF12 43_59_2_2_T43S51 phospho",
    "TAF12 51_59_1_1_S51 phospho",
    "TAF12 cnv",
    "TAF12 methyl",
    "TAF12 proteo",
    "TAF12 rna"
  ],
  "TAF12-DT": [
    "TAF12-DT methyl"
  ],
  "TAF13": [
    "TAF13 cnv",
    "TAF13 methyl",
    "TAF13 rna"
  ],
  "TAF15": [
    "TAF15 cnv",
    "TAF15 methyl",
    "TAF15 proteo",
    "TAF15 rna"
  ],
  "TAF1A": [
    "TAF1A cnv",
    "TAF1A methyl",
    "TAF1A rna"
  ],
  "TAF1B": [
    "TAF1B cnv",
    "TAF1B methyl",
    "TAF1B rna"
  ],
  "TAF1C": [
    "TAF1C cnv",
    "TAF1C methyl",
    "TAF1C rna"
  ],
  "TAF1D": [
    "TAF1D cnv",
    "TAF1D methyl",
    "TAF1D rna"
  ],
  "TAF1L": [
    "TAF1L cnv",
    "TAF1L rna"
  ],
  "TAF2": [
    "TAF2 cnv",
    "TAF2 methyl",
    "TAF2 proteo",
    "TAF2 rna"
  ],
  "TAF3": [
    "TAF3 183_183_1_1_S183 phospho",
    "TAF3 327_349_1_1_T339 phospho",
    "TAF3 364_364_1_1_T364 phospho",
    "TAF3 cnv",
    "TAF3 methyl",
    "TAF3 rna"
  ],
  "TAF4": [
    "TAF4 cnv",
    "TAF4 methyl",
    "TAF4 proteo",
    "TAF4 rna"
  ],
  "TAF4B": [
    "TAF4B cnv",
    "TAF4B methyl",
    "TAF4B rna"
  ],
  "TAF5": [
    "TAF5 cnv",
    "TAF5 methyl",
    "TAF5 proteo",
    "TAF5 rna"
  ],
  "TAF5L": [
    "TAF5L cnv",
    "TAF5L methyl",
    "TAF5L proteo",
    "TAF5L rna"
  ],
  "TAF6": [
    "TAF6 569_573_1_1_S569 phospho",
    "TAF6 690_697_1_1_S690 phospho",
    "TAF6 703_709_1_1_S709 phospho",
    "TAF6 cnv",
    "TAF6 methyl",
    "TAF6 proteo",
    "TAF6 rna"
  ],
  "TAF6L": [
    "TAF6L cnv",
    "TAF6L methyl",
    "TAF6L proteo",
    "TAF6L rna"
  ],
  "TAF7": [
    "TAF7 171_179_1_1_S171 phospho",
    "TAF7 200_205_1_1_S201 phospho",
    "TAF7 213_213_1_1_S213 phospho",
    "TAF7 264_274_1_1_S264 phospho",
    "TAF7 cnv",
    "TAF7 methyl",
    "TAF7 proteo",
    "TAF7 rna"
  ],
  "TAF7L": [
    "TAF7L methyl",
    "TAF7L rna"
  ],
  "TAF8": [
    "TAF8 cnv",
    "TAF8 methyl",
    "TAF8 proteo",
    "TAF8 rna"
  ],
  "TAF9": [
    "TAF9 cnv",
    "TAF9 methyl",
    "TAF9 proteo",
    "TAF9 rna"
  ],
  "TAF9B": [
    "TAF9B 147_167_1_1_T157 phospho",
    "TAF9B methyl",
    "TAF9B proteo",
    "TAF9B rna"
  ],
  "TAFA1": [
    "TAFA1 cnv",
    "TAFA1 rna"
  ],
  "TAFA2": [
    "TAFA2 cnv",
    "TAFA2 methyl",
    "TAFA2 rna"
  ],
  "TAFA3": [
    "TAFA3 cnv",
    "TAFA3 rna"
  ],
  "TAFA4": [
    "TAFA4 cnv",
    "TAFA4 methyl",
    "TAFA4 rna"
  ],
  "TAFA5": [
    "TAFA5 cnv",
    "TAFA5 methyl",
    "TAFA5 proteo",
    "TAFA5 rna"
  ],
  "TAFAZZIN": [
    "TAFAZZIN methyl",
    "TAFAZZIN rna"
  ],
  "TAGAP": [
    "TAGAP 651_662_1_1_S651 phospho",
    "TAGAP cnv",
    "TAGAP rna"
  ],
  "TAGAP-AS1": [
    "TAGAP-AS1 methyl"
  ],
  "TAGLN": [
    "TAGLN 181_181_1_1_S181 phospho",
    "TAGLN cnv",
    "TAGLN proteo",
    "TAGLN rna"
  ],
  "TAGLN2": [
    "TAGLN2 163_163_1_1_S163 phospho",
    "TAGLN2 cnv",
    "TAGLN2 methyl",
    "TAGLN2 proteo",
    "TAGLN2 rna"
  ],
  "TAGLN3": [
    "TAGLN3 cnv",
    "TAGLN3 proteo",
    "TAGLN3 rna"
  ],
  "TAL1": [
    "TAL1 cnv",
    "TAL1 methyl",
    "TAL1 rna"
  ],
  "TAL2": [
    "TAL2 cnv",
    "TAL2 rna"
  ],
  "TALDO1": [
    "TALDO1 cnv",
    "TALDO1 methyl",
    "TALDO1 proteo",
    "TALDO1 rna"
  ],
  "TAMALIN": [
    "TAMALIN 92_94_1_1_S94 phospho",
    "TAMALIN cnv",
    "TAMALIN methyl",
    "TAMALIN rna"
  ],
  "TAMM41": [
    "TAMM41 cnv",
    "TAMM41 methyl",
    "TAMM41 proteo",
    "TAMM41 rna"
  ],
  "TANC1": [
    "TANC1 1659_1672_1_1_S1668 phospho",
    "TANC1 1676_1689_1_1_S1687 phospho",
    "TANC1 207_221_1_1_S214 phospho",
    "TANC1 270_284_1_1_S270 phospho",
    "TANC1 290_320_1_1_S313 phospho",
    "TANC1 442_448_1_1_S444 phospho",
    "TANC1 85_85_1_1_S85 phospho",
    "TANC1 cnv",
    "TANC1 methyl",
    "TANC1 proteo",
    "TANC1 rna"
  ],
  "TANC2": [
    "TANC2 129_158_1_0 phospho",
    "TANC2 1452_1462_1_1_S1458 phospho",
    "TANC2 163_176_1_1_S169 phospho",
    "TANC2 1720_1731_1_1_S1722 phospho",
    "TANC2 398_404_1_1_S400 phospho",
    "TANC2 398_404_1_1_S404 phospho",
    "TANC2 398_404_2_2_S400S404 phospho",
    "TANC2 cnv",
    "TANC2 methyl",
    "TANC2 proteo",
    "TANC2 rna"
  ],
  "TANGO2": [
    "TANGO2 cnv",
    "TANGO2 methyl",
    "TANGO2 proteo",
    "TANGO2 rna"
  ],
  "TANGO6": [
    "TANGO6 cnv",
    "TANGO6 methyl",
    "TANGO6 proteo",
    "TANGO6 rna"
  ],
  "TANK": [
    "TANK 126_129_1_1_S129 phospho",
    "TANK cnv",
    "TANK methyl",
    "TANK proteo",
    "TANK rna"
  ],
  "TAOK1": [
    "TAOK1 417_426_1_1_S421 phospho",
    "TAOK1 669_669_1_1_T669 phospho",
    "TAOK1 958_965_1_1_S965 phospho",
    "TAOK1 965_965_1_1_S965 phospho",
    "TAOK1 cnv",
    "TAOK1 kinase",
    "TAOK1 methyl",
    "TAOK1 proteo",
    "TAOK1 rna"
  ],
  "TAOK2": [
    "TAOK2 1011_1031_1_1_S1011 phospho",
    "TAOK2 486_495_1_1_S486 phospho",
    "TAOK2 cnv",
    "TAOK2 kinase",
    "TAOK2 methyl",
    "TAOK2 proteo",
    "TAOK2 rna"
  ],
  "TAOK3": [
    "TAOK3 675_675_1_1_T675 phospho",
    "TAOK3 cnv",
    "TAOK3 kinase",
    "TAOK3 methyl",
    "TAOK3 proteo",
    "TAOK3 rna"
  ],
  "TAP1": [
    "TAP1 cnv",
    "TAP1 methyl",
    "TAP1 proteo",
    "TAP1 rna"
  ],
  "TAP2": [
    "TAP2 cnv",
    "TAP2 methyl",
    "TAP2 proteo",
    "TAP2 rna"
  ],
  "TAPBP": [
    "TAPBP cnv",
    "TAPBP methyl",
    "TAPBP proteo",
    "TAPBP rna"
  ],
  "TAPBPL": [
    "TAPBPL cnv",
    "TAPBPL proteo",
    "TAPBPL rna"
  ],
  "TAPT1": [
    "TAPT1 cnv",
    "TAPT1 methyl",
    "TAPT1 proteo",
    "TAPT1 rna"
  ],
  "TARBP1": [
    "TARBP1 cnv",
    "TARBP1 methyl",
    "TARBP1 rna"
  ],
  "TARBP2": [
    "TARBP2 121_135_1_0 phospho",
    "TARBP2 cnv",
    "TARBP2 methyl",
    "TARBP2 proteo",
    "TARBP2 rna"
  ],
  "TARDBP": [
    "TARDBP cnv",
    "TARDBP methyl",
    "TARDBP proteo",
    "TARDBP rna"
  ],
  "TARID": [
    "TARID methyl"
  ],
  "TARM1": [
    "TARM1 cnv",
    "TARM1 rna"
  ],
  "TARS1": [
    "TARS1 39_56_1_1_S39 phospho",
    "TARS1 cnv",
    "TARS1 methyl",
    "TARS1 proteo",
    "TARS1 rna"
  ],
  "TARS2": [
    "TARS2 cnv",
    "TARS2 proteo",
    "TARS2 rna"
  ],
  "TARS3": [
    "TARS3 cnv",
    "TARS3 methyl",
    "TARS3 proteo",
    "TARS3 rna"
  ],
  "TAS1R1": [
    "TAS1R1 cnv",
    "TAS1R1 methyl",
    "TAS1R1 rna"
  ],
  "TAS1R2": [
    "TAS1R2 cnv",
    "TAS1R2 rna"
  ],
  "TAS1R3": [
    "TAS1R3 cnv",
    "TAS1R3 rna"
  ],
  "TAS2R1": [
    "TAS2R1 cnv",
    "TAS2R1 rna"
  ],
  "TAS2R10": [
    "TAS2R10 cnv",
    "TAS2R10 rna"
  ],
  "TAS2R13": [
    "TAS2R13 cnv",
    "TAS2R13 rna"
  ],
  "TAS2R14": [
    "TAS2R14 cnv",
    "TAS2R14 rna"
  ],
  "TAS2R16": [
    "TAS2R16 cnv"
  ],
  "TAS2R19": [
    "TAS2R19 cnv",
    "TAS2R19 rna"
  ],
  "TAS2R20": [
    "TAS2R20 cnv",
    "TAS2R20 rna"
  ],
  "TAS2R3": [
    "TAS2R3 cnv",
    "TAS2R3 rna"
  ],
  "TAS2R30": [
    "TAS2R30 cnv",
    "TAS2R30 rna"
  ],
  "TAS2R31": [
    "TAS2R31 cnv",
    "TAS2R31 rna"
  ],
  "TAS2R38": [
    "TAS2R38 cnv",
    "TAS2R38 rna"
  ],
  "TAS2R39": [
    "TAS2R39 cnv"
  ],
  "TAS2R4": [
    "TAS2R4 cnv",
    "TAS2R4 rna"
  ],
  "TAS2R40": [
    "TAS2R40 cnv",
    "TAS2R40 rna"
  ],
  "TAS2R41": [
    "TAS2R41 cnv",
    "TAS2R41 rna"
  ],
  "TAS2R42": [
    "TAS2R42 cnv",
    "TAS2R42 rna"
  ],
  "TAS2R43": [
    "TAS2R43 cnv",
    "TAS2R43 rna"
  ],
  "TAS2R46": [
    "TAS2R46 cnv",
    "TAS2R46 rna"
  ],
  "TAS2R5": [
    "TAS2R5 cnv",
    "TAS2R5 rna"
  ],
  "TAS2R50": [
    "TAS2R50 cnv",
    "TAS2R50 rna"
  ],
  "TAS2R60": [
    "TAS2R60 cnv",
    "TAS2R60 rna"
  ],
  "TAS2R7": [
    "TAS2R7 cnv",
    "TAS2R7 rna"
  ],
  "TAS2R8": [
    "TAS2R8 cnv",
    "TAS2R8 rna"
  ],
  "TAS2R9": [
    "TAS2R9 cnv",
    "TAS2R9 rna"
  ],
  "TASL": [
    "TASL rna"
  ],
  "TASOR": [
    "TASOR 633_648_1_1_S633 phospho",
    "TASOR 670_676_1_1_S673 phospho",
    "TASOR 694_701_1_1_S694 phospho",
    "TASOR 694_701_1_1_S699 phospho",
    "TASOR 921_927_1_1_S927 phospho",
    "TASOR cnv",
    "TASOR methyl",
    "TASOR proteo",
    "TASOR rna"
  ],
  "TASOR2": [
    "TASOR2 1014_1034_1_1_S1025 phospho",
    "TASOR2 683_690_1_1_S685 phospho",
    "TASOR2 cnv",
    "TASOR2 methyl",
    "TASOR2 proteo",
    "TASOR2 rna"
  ],
  "TASP1": [
    "TASP1 cnv",
    "TASP1 methyl",
    "TASP1 rna"
  ],
  "TAT": [
    "TAT cnv",
    "TAT rna"
  ],
  "TATDN1": [
    "TATDN1 cnv",
    "TATDN1 methyl",
    "TATDN1 proteo",
    "TATDN1 rna"
  ],
  "TATDN2": [
    "TATDN2 cnv",
    "TATDN2 methyl",
    "TATDN2 proteo",
    "TATDN2 rna"
  ],
  "TATDN3": [
    "TATDN3 cnv",
    "TATDN3 methyl",
    "TATDN3 proteo",
    "TATDN3 rna"
  ],
  "TAX1BP1": [
    "TAX1BP1 624_634_1_1_S624 phospho",
    "TAX1BP1 cnv",
    "TAX1BP1 methyl",
    "TAX1BP1 proteo",
    "TAX1BP1 rna"
  ],
  "TAX1BP3": [
    "TAX1BP3 cnv",
    "TAX1BP3 methyl",
    "TAX1BP3 proteo",
    "TAX1BP3 rna"
  ],
  "TBATA": [
    "TBATA cnv",
    "TBATA rna"
  ],
  "TBC1D1": [
    "TBC1D1 565_585_1_1_S585 phospho",
    "TBC1D1 596_598_1_1_T596 phospho",
    "TBC1D1 625_632_1_1_S627 phospho",
    "TBC1D1 665_668_1_1_S667 phospho",
    "TBC1D1 704_707_1_1_S707 phospho",
    "TBC1D1 743_746_1_1_T746 phospho",
    "TBC1D1 cnv",
    "TBC1D1 methyl",
    "TBC1D1 proteo",
    "TBC1D1 rna"
  ],
  "TBC1D10A": [
    "TBC1D10A 390_390_1_1_S390 phospho",
    "TBC1D10A cnv",
    "TBC1D10A methyl",
    "TBC1D10A proteo",
    "TBC1D10A rna"
  ],
  "TBC1D10B": [
    "TBC1D10B 132_132_1_1_S132 phospho",
    "TBC1D10B 132_135_1_1_S132 phospho",
    "TBC1D10B 132_154_1_0 phospho",
    "TBC1D10B 132_154_1_1_S132 phospho",
    "TBC1D10B 132_154_2_2_S132T148 phospho",
    "TBC1D10B 135_154_1_1_T148 phospho",
    "TBC1D10B 22_22_1_1_S22 phospho",
    "TBC1D10B 656_661_1_1_S658 phospho",
    "TBC1D10B 656_661_2_2_S658S661 phospho",
    "TBC1D10B 678_678_1_1_S678 phospho",
    "TBC1D10B 687_718_1_0 phospho",
    "TBC1D10B 687_718_1_1_S687 phospho",
    "TBC1D10B 687_718_1_1_S707 phospho",
    "TBC1D10B 687_718_2_1_S687 phospho",
    "TBC1D10B 687_718_2_2_S687S707 phospho",
    "TBC1D10B cnv",
    "TBC1D10B methyl",
    "TBC1D10B proteo",
    "TBC1D10B rna"
  ],
  "TBC1D10C": [
    "TBC1D10C cnv",
    "TBC1D10C rna"
  ],
  "TBC1D12": [
    "TBC1D12 cnv",
    "TBC1D12 methyl",
    "TBC1D12 proteo",
    "TBC1D12 rna"
  ],
  "TBC1D13": [
    "TBC1D13 177_184_1_1_S184 phospho",
    "TBC1D13 cnv",
    "TBC1D13 methyl",
    "TBC1D13 proteo",
    "TBC1D13 rna"
  ],
  "TBC1D14": [
    "TBC1D14 91_93_1_1_S91 phospho",
    "TBC1D14 cnv",
    "TBC1D14 methyl",
    "TBC1D14 rna"
  ],
  "TBC1D15": [
    "TBC1D15 658_666_1_1_S658 phospho",
    "TBC1D15 70_77_1_1_S70 phospho",
    "TBC1D15 cnv",
    "TBC1D15 methyl",
    "TBC1D15 proteo",
    "TBC1D15 rna"
  ],
  "TBC1D16": [
    "TBC1D16 252_280_1_1_S260 phospho",
    "TBC1D16 cnv",
    "TBC1D16 methyl",
    "TBC1D16 proteo",
    "TBC1D16 rna"
  ],
  "TBC1D17": [
    "TBC1D17 16_20_1_1_S20 phospho",
    "TBC1D17 620_648_1_1_T620 phospho",
    "TBC1D17 cnv",
    "TBC1D17 methyl",
    "TBC1D17 proteo",
    "TBC1D17 rna"
  ],
  "TBC1D19": [
    "TBC1D19 cnv",
    "TBC1D19 methyl",
    "TBC1D19 rna"
  ],
  "TBC1D2": [
    "TBC1D2 915_920_1_1_S920 phospho",
    "TBC1D2 cnv",
    "TBC1D2 methyl",
    "TBC1D2 proteo",
    "TBC1D2 rna"
  ],
  "TBC1D20": [
    "TBC1D20 cnv",
    "TBC1D20 methyl",
    "TBC1D20 proteo",
    "TBC1D20 rna"
  ],
  "TBC1D21": [
    "TBC1D21 cnv",
    "TBC1D21 rna"
  ],
  "TBC1D22A": [
    "TBC1D22A 132_135_1_1_S132 phospho",
    "TBC1D22A cnv",
    "TBC1D22A methyl",
    "TBC1D22A proteo",
    "TBC1D22A rna"
  ],
  "TBC1D22B": [
    "TBC1D22B 114_125_1_0 phospho",
    "TBC1D22B 114_125_1_1_S116 phospho",
    "TBC1D22B 57_58_1_1_S58 phospho",
    "TBC1D22B cnv",
    "TBC1D22B methyl",
    "TBC1D22B proteo",
    "TBC1D22B rna"
  ],
  "TBC1D23": [
    "TBC1D23 465_479_1_1_S474 phospho",
    "TBC1D23 507_514_1_1_T514 phospho",
    "TBC1D23 cnv",
    "TBC1D23 methyl",
    "TBC1D23 proteo",
    "TBC1D23 rna"
  ],
  "TBC1D24": [
    "TBC1D24 453_480_1_1_S480 phospho",
    "TBC1D24 cnv",
    "TBC1D24 methyl",
    "TBC1D24 proteo",
    "TBC1D24 rna"
  ],
  "TBC1D25": [
    "TBC1D25 methyl",
    "TBC1D25 proteo",
    "TBC1D25 rna"
  ],
  "TBC1D26": [
    "TBC1D26 cnv",
    "TBC1D26 methyl",
    "TBC1D26 rna"
  ],
  "TBC1D28": [
    "TBC1D28 cnv",
    "TBC1D28 rna"
  ],
  "TBC1D2B": [
    "TBC1D2B 154_157_1_1_S155 phospho",
    "TBC1D2B 277_277_1_1_T277 phospho",
    "TBC1D2B 458_475_1_1_S473 phospho",
    "TBC1D2B 948_963_1_0 phospho",
    "TBC1D2B 948_963_1_1_S957 phospho",
    "TBC1D2B 948_963_2_2_S949S957 phospho",
    "TBC1D2B 957_963_1_1_S957 phospho",
    "TBC1D2B cnv",
    "TBC1D2B methyl",
    "TBC1D2B proteo",
    "TBC1D2B rna"
  ],
  "TBC1D3": [
    "TBC1D3 cnv",
    "TBC1D3 rna"
  ],
  "TBC1D30": [
    "TBC1D30 cnv",
    "TBC1D30 methyl",
    "TBC1D30 rna"
  ],
  "TBC1D31": [
    "TBC1D31 cnv",
    "TBC1D31 methyl",
    "TBC1D31 rna"
  ],
  "TBC1D32": [
    "TBC1D32 cnv",
    "TBC1D32 methyl",
    "TBC1D32 rna"
  ],
  "TBC1D3B": [
    "TBC1D3B cnv",
    "TBC1D3B rna"
  ],
  "TBC1D3C": [
    "TBC1D3C cnv",
    "TBC1D3C rna"
  ],
  "TBC1D3D": [
    "TBC1D3D cnv",
    "TBC1D3D rna"
  ],
  "TBC1D3E": [
    "TBC1D3E cnv",
    "TBC1D3E rna"
  ],
  "TBC1D3F": [
    "TBC1D3F cnv",
    "TBC1D3F rna"
  ],
  "TBC1D3G": [
    "TBC1D3G cnv",
    "TBC1D3G rna"
  ],
  "TBC1D3H": [
    "TBC1D3H cnv",
    "TBC1D3H rna"
  ],
  "TBC1D3I": [
    "TBC1D3I cnv",
    "TBC1D3I rna"
  ],
  "TBC1D3K": [
    "TBC1D3K cnv",
    "TBC1D3K rna"
  ],
  "TBC1D3L": [
    "TBC1D3L cnv",
    "TBC1D3L rna"
  ],
  "TBC1D3P1-DHX40P1": [
    "TBC1D3P1-DHX40P1 cnv",
    "TBC1D3P1-DHX40P1 rna"
  ],
  "TBC1D4": [
    "TBC1D4 341_351_1_1_S341 phospho",
    "TBC1D4 666_666_1_1_S666 phospho",
    "TBC1D4 cnv",
    "TBC1D4 methyl",
    "TBC1D4 proteo",
    "TBC1D4 rna"
  ],
  "TBC1D5": [
    "TBC1D5 42_55_1_1_S43 phospho",
    "TBC1D5 520_522_1_1_S522 phospho",
    "TBC1D5 559_566_1_1_S561 phospho",
    "TBC1D5 559_566_1_1_S563 phospho",
    "TBC1D5 559_566_2_2_S563S566 phospho",
    "TBC1D5 574_582_1_1_S576 phospho",
    "TBC1D5 752_754_1_1_S752 phospho",
    "TBC1D5 cnv",
    "TBC1D5 methyl",
    "TBC1D5 proteo",
    "TBC1D5 rna"
  ],
  "TBC1D7": [
    "TBC1D7 cnv",
    "TBC1D7 methyl",
    "TBC1D7 proteo",
    "TBC1D7 rna"
  ],
  "TBC1D8": [
    "TBC1D8 cnv",
    "TBC1D8 methyl",
    "TBC1D8 proteo",
    "TBC1D8 rna"
  ],
  "TBC1D8-AS1": [
    "TBC1D8-AS1 methyl"
  ],
  "TBC1D8B": [
    "TBC1D8B rna"
  ],
  "TBC1D9": [
    "TBC1D9 471_471_1_1_S471 phospho",
    "TBC1D9 cnv",
    "TBC1D9 methyl",
    "TBC1D9 proteo",
    "TBC1D9 rna"
  ],
  "TBC1D9B": [
    "TBC1D9B 1221_1232_1_1_S1221 phospho",
    "TBC1D9B 1221_1232_2_0 phospho",
    "TBC1D9B 411_439_1_1_S435 phospho",
    "TBC1D9B 411_439_2_2_S411S435 phospho",
    "TBC1D9B 411_452_1_0 phospho",
    "TBC1D9B 442_452_1_1_S442 phospho",
    "TBC1D9B 976_981_1_1_S978 phospho",
    "TBC1D9B cnv",
    "TBC1D9B proteo",
    "TBC1D9B rna"
  ],
  "TBCA": [
    "TBCA cnv",
    "TBCA methyl",
    "TBCA proteo",
    "TBCA rna"
  ],
  "TBCB": [
    "TBCB 31_33_1_1_S31 phospho",
    "TBCB cnv",
    "TBCB methyl",
    "TBCB proteo",
    "TBCB rna"
  ],
  "TBCC": [
    "TBCC cnv",
    "TBCC methyl",
    "TBCC proteo",
    "TBCC rna"
  ],
  "TBCCD1": [
    "TBCCD1 cnv",
    "TBCCD1 methyl",
    "TBCCD1 rna"
  ],
  "TBCD": [
    "TBCD 802_814_1_1_S805 phospho",
    "TBCD cnv",
    "TBCD methyl",
    "TBCD proteo",
    "TBCD rna"
  ],
  "TBCE": [
    "TBCE cnv",
    "TBCE methyl",
    "TBCE proteo",
    "TBCE rna"
  ],
  "TBCEL": [
    "TBCEL cnv",
    "TBCEL methyl",
    "TBCEL proteo",
    "TBCEL rna"
  ],
  "TBCEL-TECTA": [
    "TBCEL-TECTA cnv",
    "TBCEL-TECTA rna"
  ],
  "TBCK": [
    "TBCK 883_890_1_1_S890 phospho",
    "TBCK cnv",
    "TBCK kinase",
    "TBCK proteo",
    "TBCK rna"
  ],
  "TBK1": [
    "TBK1 cnv",
    "TBK1 kinase",
    "TBK1 methyl",
    "TBK1 proteo",
    "TBK1 rna"
  ],
  "TBKBP1": [
    "TBKBP1 365_365_1_1_S365 phospho",
    "TBKBP1 cnv",
    "TBKBP1 methyl",
    "TBKBP1 rna"
  ],
  "TBL1X": [
    "TBL1X methyl",
    "TBL1X proteo",
    "TBL1X rna"
  ],
  "TBL1XR1": [
    "TBL1XR1 cnv",
    "TBL1XR1 methyl",
    "TBL1XR1 proteo",
    "TBL1XR1 rna"
  ],
  "TBL1Y": [
    "TBL1Y methyl",
    "TBL1Y proteo",
    "TBL1Y rna"
  ],
  "TBL2": [
    "TBL2 cnv",
    "TBL2 methyl",
    "TBL2 proteo",
    "TBL2 rna"
  ],
  "TBL3": [
    "TBL3 cnv",
    "TBL3 methyl",
    "TBL3 proteo",
    "TBL3 rna"
  ],
  "TBP": [
    "TBP cnv",
    "TBP methyl",
    "TBP rna"
  ],
  "TBPL1": [
    "TBPL1 cnv",
    "TBPL1 methyl",
    "TBPL1 proteo",
    "TBPL1 rna"
  ],
  "TBPL2": [
    "TBPL2 cnv",
    "TBPL2 methyl",
    "TBPL2 rna"
  ],
  "TBR1": [
    "TBR1 81_91_1_1_S84 phospho",
    "TBR1 cnv",
    "TBR1 methyl",
    "TBR1 proteo",
    "TBR1 rna"
  ],
  "TBRG1": [
    "TBRG1 cnv",
    "TBRG1 methyl",
    "TBRG1 rna"
  ],
  "TBRG4": [
    "TBRG4 cnv",
    "TBRG4 methyl",
    "TBRG4 proteo",
    "TBRG4 rna"
  ],
  "TBX1": [
    "TBX1 cnv",
    "TBX1 methyl",
    "TBX1 rna"
  ],
  "TBX10": [
    "TBX10 cnv",
    "TBX10 rna"
  ],
  "TBX15": [
    "TBX15 cnv",
    "TBX15 methyl",
    "TBX15 rna"
  ],
  "TBX18": [
    "TBX18 cnv",
    "TBX18 methyl",
    "TBX18 rna"
  ],
  "TBX19": [
    "TBX19 cnv",
    "TBX19 rna"
  ],
  "TBX2": [
    "TBX2 355_360_1_1_S360 phospho",
    "TBX2 355_368_1_1_S360 phospho",
    "TBX2 379_388_2_2_S379S386 phospho",
    "TBX2 705_710_1_1_S710 phospho",
    "TBX2 cnv",
    "TBX2 methyl",
    "TBX2 rna"
  ],
  "TBX2-AS1": [
    "TBX2-AS1 methyl"
  ],
  "TBX20": [
    "TBX20 cnv",
    "TBX20 methyl",
    "TBX20 rna"
  ],
  "TBX21": [
    "TBX21 cnv",
    "TBX21 methyl",
    "TBX21 rna"
  ],
  "TBX22": [
    "TBX22 rna"
  ],
  "TBX3": [
    "TBX3 cnv",
    "TBX3 methyl",
    "TBX3 rna"
  ],
  "TBX4": [
    "TBX4 cnv",
    "TBX4 methyl",
    "TBX4 rna"
  ],
  "TBX5": [
    "TBX5 cnv",
    "TBX5 methyl",
    "TBX5 rna"
  ],
  "TBX6": [
    "TBX6 cnv",
    "TBX6 methyl",
    "TBX6 rna"
  ],
  "TBXA2R": [
    "TBXA2R cnv",
    "TBXA2R methyl",
    "TBXA2R rna"
  ],
  "TBXAS1": [
    "TBXAS1 cnv",
    "TBXAS1 methyl",
    "TBXAS1 proteo",
    "TBXAS1 rna"
  ],
  "TBXT": [
    "TBXT cnv",
    "TBXT methyl",
    "TBXT rna"
  ],
  "TC2N": [
    "TC2N cnv",
    "TC2N methyl",
    "TC2N rna"
  ],
  "TCAF1": [
    "TCAF1 cnv",
    "TCAF1 methyl",
    "TCAF1 proteo",
    "TCAF1 rna"
  ],
  "TCAF2": [
    "TCAF2 cnv",
    "TCAF2 methyl",
    "TCAF2 proteo",
    "TCAF2 rna"
  ],
  "TCAF2C": [
    "TCAF2C cnv",
    "TCAF2C rna"
  ],
  "TCAIM": [
    "TCAIM cnv",
    "TCAIM methyl",
    "TCAIM rna"
  ],
  "TCAM1P": [
    "TCAM1P methyl"
  ],
  "TCAP": [
    "TCAP cnv",
    "TCAP rna"
  ],
  "TCEA1": [
    "TCEA1 96_100_1_1_S100 phospho",
    "TCEA1 cnv",
    "TCEA1 methyl",
    "TCEA1 proteo",
    "TCEA1 rna"
  ],
  "TCEA2": [
    "TCEA2 cnv",
    "TCEA2 methyl",
    "TCEA2 proteo",
    "TCEA2 rna"
  ],
  "TCEA3": [
    "TCEA3 cnv",
    "TCEA3 methyl",
    "TCEA3 rna"
  ],
  "TCEAL1": [
    "TCEAL1 18_28_1_1_S28 phospho",
    "TCEAL1 proteo",
    "TCEAL1 rna"
  ],
  "TCEAL2": [
    "TCEAL2 108_122_1_1_S114 phospho",
    "TCEAL2 proteo",
    "TCEAL2 rna"
  ],
  "TCEAL3": [
    "TCEAL3 30_30_1_1_S30 phospho",
    "TCEAL3 42_65_1_1_S65 phospho",
    "TCEAL3 65_65_1_1_S65 phospho",
    "TCEAL3 methyl",
    "TCEAL3 proteo",
    "TCEAL3 rna"
  ],
  "TCEAL4": [
    "TCEAL4 102_110_1_1_S102 phospho",
    "TCEAL4 proteo",
    "TCEAL4 rna"
  ],
  "TCEAL5": [
    "TCEAL5 36_36_1_1_S36 phospho",
    "TCEAL5 proteo",
    "TCEAL5 rna"
  ],
  "TCEAL6": [
    "TCEAL6 methyl",
    "TCEAL6 proteo",
    "TCEAL6 rna"
  ],
  "TCEAL7": [
    "TCEAL7 proteo",
    "TCEAL7 rna"
  ],
  "TCEAL8": [
    "TCEAL8 rna"
  ],
  "TCEAL9": [
    "TCEAL9 rna"
  ],
  "TCEANC": [
    "TCEANC methyl",
    "TCEANC rna"
  ],
  "TCEANC2": [
    "TCEANC2 cnv",
    "TCEANC2 methyl",
    "TCEANC2 rna"
  ],
  "TCERG1": [
    "TCERG1 cnv",
    "TCERG1 methyl",
    "TCERG1 proteo",
    "TCERG1 rna"
  ],
  "TCERG1L": [
    "TCERG1L cnv",
    "TCERG1L methyl",
    "TCERG1L rna"
  ],
  "TCERG1L-AS1": [
    "TCERG1L-AS1 methyl"
  ],
  "TCF12": [
    "TCF12 301_325_1_1_T313 phospho",
    "TCF12 332_335_1_1_S333 phospho",
    "TCF12 557_560_1_0 phospho",
    "TCF12 557_560_1_1_S559 phospho",
    "TCF12 57_73_1_1_S67 phospho",
    "TCF12 98_105_1_0 phospho",
    "TCF12 cnv",
    "TCF12 methyl",
    "TCF12 proteo",
    "TCF12 rna"
  ],
  "TCF15": [
    "TCF15 cnv",
    "TCF15 methyl",
    "TCF15 rna"
  ],
  "TCF19": [
    "TCF19 cnv",
    "TCF19 methyl",
    "TCF19 rna"
  ],
  "TCF20": [
    "TCF20 1005_1009_1_1_S1005 phospho",
    "TCF20 1259_1266_1_1_S1259 phospho",
    "TCF20 1669_1679_1_1_T1671 phospho",
    "TCF20 1755_1764_2_2_T1762T1764 phospho",
    "TCF20 1792_1792_1_1_S1792 phospho",
    "TCF20 558_559_1_1_S559 phospho",
    "TCF20 582_583_1_1_S583 phospho",
    "TCF20 627_640_1_1_S640 phospho",
    "TCF20 cnv",
    "TCF20 methyl",
    "TCF20 proteo",
    "TCF20 rna"
  ],
  "TCF21": [
    "TCF21 cnv",
    "TCF21 rna"
  ],
  "TCF23": [
    "TCF23 cnv",
    "TCF23 rna"
  ],
  "TCF24": [
    "TCF24 cnv",
    "TCF24 methyl",
    "TCF24 rna"
  ],
  "TCF25": [
    "TCF25 137_143_1_1_S138 phospho",
    "TCF25 cnv",
    "TCF25 methyl",
    "TCF25 proteo",
    "TCF25 rna"
  ],
  "TCF3": [
    "TCF3 528_536_1_1_S530 phospho",
    "TCF3 cnv",
    "TCF3 methyl",
    "TCF3 proteo",
    "TCF3 rna"
  ],
  "TCF4": [
    "TCF4 286_305_1_1_T297 phospho",
    "TCF4 312_320_1_1_S318 phospho",
    "TCF4 370_384_1_1_S372 phospho",
    "TCF4 505_526_1_0 phospho",
    "TCF4 505_526_1_1_S515 phospho",
    "TCF4 515_526_1_1_S515 phospho",
    "TCF4 549_558_1_1_S549 phospho",
    "TCF4 54_68_1_1_S66 phospho",
    "TCF4 87_98_1_1_S92 phospho",
    "TCF4 cnv",
    "TCF4 methyl",
    "TCF4 proteo",
    "TCF4 rna"
  ],
  "TCF7": [
    "TCF7 cnv",
    "TCF7 methyl",
    "TCF7 rna"
  ],
  "TCF7L1": [
    "TCF7L1 cnv",
    "TCF7L1 methyl",
    "TCF7L1 rna"
  ],
  "TCF7L2": [
    "TCF7L2 cnv",
    "TCF7L2 methyl",
    "TCF7L2 proteo",
    "TCF7L2 rna"
  ],
  "TCFL5": [
    "TCFL5 cnv",
    "TCFL5 methyl",
    "TCFL5 rna"
  ],
  "TCHH": [
    "TCHH cnv",
    "TCHH rna"
  ],
  "TCHHL1": [
    "TCHHL1 cnv"
  ],
  "TCHP": [
    "TCHP cnv",
    "TCHP methyl",
    "TCHP proteo",
    "TCHP rna"
  ],
  "TCIM": [
    "TCIM cnv",
    "TCIM rna"
  ],
  "TCIRG1": [
    "TCIRG1 cnv",
    "TCIRG1 methyl",
    "TCIRG1 proteo",
    "TCIRG1 rna"
  ],
  "TCL1A": [
    "TCL1A cnv",
    "TCL1A methyl",
    "TCL1A rna"
  ],
  "TCL1B": [
    "TCL1B cnv",
    "TCL1B rna"
  ],
  "TCN1": [
    "TCN1 cnv",
    "TCN1 rna"
  ],
  "TCN2": [
    "TCN2 cnv",
    "TCN2 rna"
  ],
  "TCOF1": [
    "TCOF1 1060_1078_1_0 phospho",
    "TCOF1 1094_1116_1_1_S1111 phospho",
    "TCOF1 1227_1234_1_1_S1227 phospho",
    "TCOF1 1350_1350_1_1_S1350 phospho",
    "TCOF1 1376_1378_1_1_S1378 phospho",
    "TCOF1 375_381_1_1_S381 phospho",
    "TCOF1 571_583_1_0 phospho",
    "TCOF1 cnv",
    "TCOF1 methyl",
    "TCOF1 proteo",
    "TCOF1 rna"
  ],
  "TCP1": [
    "TCP1 544_551_1_1_S544 phospho",
    "TCP1 cnv",
    "TCP1 methyl",
    "TCP1 proteo",
    "TCP1 rna"
  ],
  "TCP10L": [
    "TCP10L cnv",
    "TCP10L rna"
  ],
  "TCP10L2": [
    "TCP10L2 cnv",
    "TCP10L2 rna"
  ],
  "TCP11": [
    "TCP11 cnv",
    "TCP11 methyl",
    "TCP11 rna"
  ],
  "TCP11L1": [
    "TCP11L1 cnv",
    "TCP11L1 methyl",
    "TCP11L1 proteo",
    "TCP11L1 rna"
  ],
  "TCP11L2": [
    "TCP11L2 cnv",
    "TCP11L2 methyl",
    "TCP11L2 rna"
  ],
  "TCP11X1": [
    "TCP11X1 rna"
  ],
  "TCP11X2": [
    "TCP11X2 rna"
  ],
  "TCTA": [
    "TCTA cnv",
    "TCTA methyl",
    "TCTA rna"
  ],
  "TCTE1": [
    "TCTE1 cnv",
    "TCTE1 methyl",
    "TCTE1 rna"
  ],
  "TCTN1": [
    "TCTN1 cnv",
    "TCTN1 methyl",
    "TCTN1 proteo",
    "TCTN1 rna"
  ],
  "TCTN2": [
    "TCTN2 cnv",
    "TCTN2 methyl",
    "TCTN2 proteo",
    "TCTN2 rna"
  ],
  "TCTN3": [
    "TCTN3 cnv",
    "TCTN3 methyl",
    "TCTN3 proteo",
    "TCTN3 rna"
  ],
  "TDG": [
    "TDG cnv",
    "TDG methyl",
    "TDG rna"
  ],
  "TDGF1": [
    "TDGF1 cnv",
    "TDGF1 methyl",
    "TDGF1 rna"
  ],
  "TDGF1P3": [
    "TDGF1P3 rna"
  ],
  "TDH": [
    "TDH methyl"
  ],
  "TDH-AS1": [
    "TDH-AS1 methyl"
  ],
  "TDO2": [
    "TDO2 cnv",
    "TDO2 rna"
  ],
  "TDP1": [
    "TDP1 cnv",
    "TDP1 methyl",
    "TDP1 proteo",
    "TDP1 rna"
  ],
  "TDP2": [
    "TDP2 cnv",
    "TDP2 methyl",
    "TDP2 proteo",
    "TDP2 rna"
  ],
  "TDRD1": [
    "TDRD1 cnv",
    "TDRD1 rna"
  ],
  "TDRD10": [
    "TDRD10 cnv",
    "TDRD10 methyl",
    "TDRD10 rna"
  ],
  "TDRD12": [
    "TDRD12 cnv",
    "TDRD12 methyl",
    "TDRD12 rna"
  ],
  "TDRD15": [
    "TDRD15 cnv",
    "TDRD15 rna"
  ],
  "TDRD3": [
    "TDRD3 551_560_1_1_S551 phospho",
    "TDRD3 580_582_1_1_S582 phospho",
    "TDRD3 cnv",
    "TDRD3 methyl",
    "TDRD3 proteo",
    "TDRD3 rna"
  ],
  "TDRD5": [
    "TDRD5 cnv",
    "TDRD5 methyl",
    "TDRD5 rna"
  ],
  "TDRD6": [
    "TDRD6 cnv",
    "TDRD6 methyl",
    "TDRD6 rna"
  ],
  "TDRD6-AS1": [
    "TDRD6-AS1 methyl"
  ],
  "TDRD7": [
    "TDRD7 cnv",
    "TDRD7 proteo",
    "TDRD7 rna"
  ],
  "TDRD9": [
    "TDRD9 cnv",
    "TDRD9 methyl",
    "TDRD9 rna"
  ],
  "TDRKH": [
    "TDRKH 240_252_1_1_T252 phospho",
    "TDRKH cnv",
    "TDRKH methyl",
    "TDRKH proteo",
    "TDRKH rna"
  ],
  "TDRKH-AS1": [
    "TDRKH-AS1 methyl"
  ],
  "TDRP": [
    "TDRP cnv",
    "TDRP methyl",
    "TDRP rna"
  ],
  "TEAD1": [
    "TEAD1 cnv",
    "TEAD1 methyl",
    "TEAD1 proteo",
    "TEAD1 rna"
  ],
  "TEAD2": [
    "TEAD2 cnv",
    "TEAD2 methyl",
    "TEAD2 rna"
  ],
  "TEAD3": [
    "TEAD3 cnv",
    "TEAD3 methyl",
    "TEAD3 rna"
  ],
  "TEAD4": [
    "TEAD4 cnv",
    "TEAD4 methyl",
    "TEAD4 rna"
  ],
  "TEC": [
    "TEC cnv",
    "TEC kinase",
    "TEC methyl",
    "TEC rna"
  ],
  "TECPR1": [
    "TECPR1 1099_1103_1_1_S1101 phospho",
    "TECPR1 cnv",
    "TECPR1 methyl",
    "TECPR1 proteo",
    "TECPR1 rna"
  ],
  "TECPR2": [
    "TECPR2 410_430_1_1_S412 phospho",
    "TECPR2 cnv",
    "TECPR2 methyl",
    "TECPR2 proteo",
    "TECPR2 rna"
  ],
  "TECR": [
    "TECR cnv",
    "TECR methyl",
    "TECR proteo",
    "TECR rna"
  ],
  "TECRL": [
    "TECRL cnv",
    "TECRL rna"
  ],
  "TECTA": [
    "TECTA cnv",
    "TECTA rna"
  ],
  "TECTB": [
    "TECTB cnv",
    "TECTB rna"
  ],
  "TEDC1": [
    "TEDC1 cnv",
    "TEDC1 methyl",
    "TEDC1 rna"
  ],
  "TEDC2": [
    "TEDC2 cnv",
    "TEDC2 methyl",
    "TEDC2 rna"
  ],
  "TEDC2-AS1": [
    "TEDC2-AS1 methyl"
  ],
  "TEDDM1": [
    "TEDDM1 cnv",
    "TEDDM1 rna"
  ],
  "TEF": [
    "TEF cnv",
    "TEF methyl",
    "TEF rna"
  ],
  "TEFM": [
    "TEFM cnv",
    "TEFM methyl",
    "TEFM proteo",
    "TEFM rna"
  ],
  "TEK": [
    "TEK cnv",
    "TEK kinase",
    "TEK rna"
  ],
  "TEKT1": [
    "TEKT1 cnv",
    "TEKT1 rna"
  ],
  "TEKT2": [
    "TEKT2 cnv",
    "TEKT2 methyl",
    "TEKT2 rna"
  ],
  "TEKT3": [
    "TEKT3 cnv",
    "TEKT3 methyl",
    "TEKT3 rna"
  ],
  "TEKT4": [
    "TEKT4 cnv",
    "TEKT4 methyl",
    "TEKT4 rna"
  ],
  "TEKT5": [
    "TEKT5 cnv",
    "TEKT5 rna"
  ],
  "TEKTIP1": [
    "TEKTIP1 cnv",
    "TEKTIP1 rna"
  ],
  "TELO2": [
    "TELO2 cnv",
    "TELO2 methyl",
    "TELO2 proteo",
    "TELO2 rna"
  ],
  "TEN1": [
    "TEN1 cnv",
    "TEN1 methyl",
    "TEN1 rna"
  ],
  "TEN1-CDK3": [
    "TEN1-CDK3 cnv",
    "TEN1-CDK3 methyl",
    "TEN1-CDK3 rna"
  ],
  "TENM1": [
    "TENM1 methyl",
    "TENM1 proteo",
    "TENM1 rna"
  ],
  "TENM2": [
    "TENM2 GQVVTTDGTPLVGVNVSFVK-N2H5F0S0G0 glyco",
    "TENM2 VLESGVNVTVSQPTLLVNGR-N2H6F0S0G0 glyco",
    "TENM2 cnv",
    "TENM2 methyl",
    "TENM2 proteo",
    "TENM2 rna"
  ],
  "TENM3": [
    "TENM3 ISFLIGSDSTHVIPGESPFNK-N2H8F0S0G0 glyco",
    "TENM3 cnv",
    "TENM3 methyl",
    "TENM3 proteo",
    "TENM3 rna"
  ],
  "TENM4": [
    "TENM4 150_164_1_1_S150 phospho",
    "TENM4 89_96_1_1_T89 phospho",
    "TENM4 FNVSLGK-N2H5F0S0G0 glyco",
    "TENM4 LTNVTFPTGQVSSFR-N2H6F0S0G0 glyco",
    "TENM4 LTNVTFPTGQVSSFR-N2H7F0S0G0 glyco",
    "TENM4 LTNVTFPTGQVSSFR-N2H8F0S0G0 glyco",
    "TENM4 NIYQPPEGNASVIQDFTEDGHLLHTFYLGTGR-N2H5F0S0G0 glyco",
    "TENM4 TLENGVNVTVSQINTVLNGR-N2H5F0S0G0 glyco",
    "TENM4 TLENGVNVTVSQINTVLNGR-N2H6F0S0G0 glyco",
    "TENM4 cnv",
    "TENM4 methyl",
    "TENM4 proteo",
    "TENM4 rna"
  ],
  "TENT2": [
    "TENT2 cnv",
    "TENT2 methyl",
    "TENT2 rna"
  ],
  "TENT4A": [
    "TENT4A cnv",
    "TENT4A methyl",
    "TENT4A rna"
  ],
  "TENT4B": [
    "TENT4B cnv",
    "TENT4B methyl",
    "TENT4B proteo",
    "TENT4B rna"
  ],
  "TENT5A": [
    "TENT5A cnv",
    "TENT5A methyl",
    "TENT5A rna"
  ],
  "TENT5B": [
    "TENT5B cnv",
    "TENT5B methyl",
    "TENT5B rna"
  ],
  "TENT5C": [
    "TENT5C cnv",
    "TENT5C methyl",
    "TENT5C rna"
  ],
  "TENT5D": [
    "TENT5D methyl",
    "TENT5D rna"
  ],
  "TEP1": [
    "TEP1 397_405_1_1_S397 phospho",
    "TEP1 cnv",
    "TEP1 methyl",
    "TEP1 proteo",
    "TEP1 rna"
  ],
  "TEPP": [
    "TEPP cnv",
    "TEPP methyl",
    "TEPP rna"
  ],
  "TEPSIN": [
    "TEPSIN 175_185_1_1_S177 phospho",
    "TEPSIN 390_406_1_1_S401 phospho",
    "TEPSIN 419_424_1_1_S424 phospho",
    "TEPSIN cnv",
    "TEPSIN methyl",
    "TEPSIN proteo",
    "TEPSIN rna"
  ],
  "TERB1": [
    "TERB1 cnv",
    "TERB1 methyl",
    "TERB1 rna"
  ],
  "TERB2": [
    "TERB2 cnv"
  ],
  "TERF1": [
    "TERF1 cnv",
    "TERF1 methyl",
    "TERF1 rna"
  ],
  "TERF2": [
    "TERF2 359_365_1_1_S365 phospho",
    "TERF2 410_434_1_0 phospho",
    "TERF2 cnv",
    "TERF2 methyl",
    "TERF2 proteo",
    "TERF2 rna"
  ],
  "TERF2IP": [
    "TERF2IP 154_159_1_1_S154 phospho",
    "TERF2IP 195_206_1_1_S203 phospho",
    "TERF2IP 195_206_1_1_S206 phospho",
    "TERF2IP 43_52_1_1_S43 phospho",
    "TERF2IP cnv",
    "TERF2IP methyl",
    "TERF2IP proteo",
    "TERF2IP rna"
  ],
  "TERT": [
    "TERT cnv",
    "TERT methyl",
    "TERT rna"
  ],
  "TES": [
    "TES cnv",
    "TES methyl",
    "TES proteo",
    "TES rna"
  ],
  "TESC": [
    "TESC cnv",
    "TESC methyl",
    "TESC proteo",
    "TESC rna"
  ],
  "TESK1": [
    "TESK1 277_281_1_1_S277 phospho",
    "TESK1 380_380_1_1_S380 phospho",
    "TESK1 cnv",
    "TESK1 kinase",
    "TESK1 methyl",
    "TESK1 proteo",
    "TESK1 rna"
  ],
  "TESK2": [
    "TESK2 cnv",
    "TESK2 kinase",
    "TESK2 methyl",
    "TESK2 rna"
  ],
  "TESMIN": [
    "TESMIN cnv",
    "TESMIN methyl",
    "TESMIN rna"
  ],
  "TESPA1": [
    "TESPA1 454_460_1_1_S454 phospho",
    "TESPA1 cnv",
    "TESPA1 rna"
  ],
  "TET1": [
    "TET1 cnv",
    "TET1 methyl",
    "TET1 rna"
  ],
  "TET2": [
    "TET2 cnv",
    "TET2 methyl",
    "TET2 rna"
  ],
  "TET3": [
    "TET3 cnv",
    "TET3 methyl",
    "TET3 rna"
  ],
  "TEX10": [
    "TEX10 cnv",
    "TEX10 methyl",
    "TEX10 proteo",
    "TEX10 rna"
  ],
  "TEX101": [
    "TEX101 cnv",
    "TEX101 methyl",
    "TEX101 rna"
  ],
  "TEX11": [
    "TEX11 rna"
  ],
  "TEX12": [
    "TEX12 cnv",
    "TEX12 rna"
  ],
  "TEX13A": [
    "TEX13A rna"
  ],
  "TEX13B": [
    "TEX13B rna"
  ],
  "TEX13C": [
    "TEX13C methyl",
    "TEX13C rna"
  ],
  "TEX13D": [
    "TEX13D rna"
  ],
  "TEX14": [
    "TEX14 cnv",
    "TEX14 kinase",
    "TEX14 methyl",
    "TEX14 rna"
  ],
  "TEX15": [
    "TEX15 cnv",
    "TEX15 rna"
  ],
  "TEX19": [
    "TEX19 cnv",
    "TEX19 rna"
  ],
  "TEX2": [
    "TEX2 262_274_1_1_S266 phospho",
    "TEX2 262_274_1_1_S270 phospho",
    "TEX2 295_306_1_1_S295 phospho",
    "TEX2 736_744_1_1_S736 phospho",
    "TEX2 746_757_1_1_S748 phospho",
    "TEX2 788_804_2_2_S790S794 phospho",
    "TEX2 790_804_1_1_S794 phospho",
    "TEX2 794_804_1_1_S802 phospho",
    "TEX2 cnv",
    "TEX2 methyl",
    "TEX2 proteo",
    "TEX2 rna"
  ],
  "TEX22": [
    "TEX22 cnv",
    "TEX22 methyl",
    "TEX22 rna"
  ],
  "TEX26": [
    "TEX26 cnv",
    "TEX26 rna"
  ],
  "TEX261": [
    "TEX261 cnv",
    "TEX261 methyl",
    "TEX261 rna"
  ],
  "TEX264": [
    "TEX264 cnv",
    "TEX264 methyl",
    "TEX264 proteo",
    "TEX264 rna"
  ],
  "TEX28": [
    "TEX28 methyl"
  ],
  "TEX29": [
    "TEX29 cnv",
    "TEX29 rna"
  ],
  "TEX30": [
    "TEX30 cnv",
    "TEX30 methyl",
    "TEX30 rna"
  ],
  "TEX33": [
    "TEX33 cnv"
  ],
  "TEX35": [
    "TEX35 cnv",
    "TEX35 rna"
  ],
  "TEX36": [
    "TEX36 cnv",
    "TEX36 rna"
  ],
  "TEX37": [
    "TEX37 cnv"
  ],
  "TEX38": [
    "TEX38 cnv",
    "TEX38 methyl",
    "TEX38 rna"
  ],
  "TEX43": [
    "TEX43 cnv",
    "TEX43 rna"
  ],
  "TEX44": [
    "TEX44 cnv",
    "TEX44 rna"
  ],
  "TEX45": [
    "TEX45 cnv",
    "TEX45 methyl",
    "TEX45 rna"
  ],
  "TEX46": [
    "TEX46 cnv",
    "TEX46 methyl",
    "TEX46 rna"
  ],
  "TEX47": [
    "TEX47 cnv",
    "TEX47 rna"
  ],
  "TEX48": [
    "TEX48 cnv"
  ],
  "TEX49": [
    "TEX49 cnv"
  ],
  "TEX50": [
    "TEX50 cnv"
  ],
  "TEX51": [
    "TEX51 cnv"
  ],
  "TEX52": [
    "TEX52 cnv",
    "TEX52 rna"
  ],
  "TEX53": [
    "TEX53 cnv"
  ],
  "TEX54": [
    "TEX54 cnv",
    "TEX54 rna"
  ],
  "TEX55": [
    "TEX55 cnv",
    "TEX55 rna"
  ],
  "TEX9": [
    "TEX9 cnv",
    "TEX9 methyl",
    "TEX9 rna"
  ],
  "TF": [
    "TF CGLVPVLAENYNK-N2H5F0S0G0 glyco",
    "TF CGLVPVLAENYNK-N3H3F2S0G0 glyco",
    "TF CGLVPVLAENYNK-N3H4F0S0G0 glyco",
    "TF CGLVPVLAENYNK-N3H4F0S1G0 glyco",
    "TF CGLVPVLAENYNK-N4H5F0S0G0 glyco",
    "TF CGLVPVLAENYNK-N4H5F0S1G0 glyco",
    "TF CGLVPVLAENYNK-N4H5F0S2G0 glyco",
    "TF CGLVPVLAENYNK-N4H5F1S1G0 glyco",
    "TF CGLVPVLAENYNK-N4H5F1S2G0 glyco",
    "TF CGLVPVLAENYNK-N4H5F2S0G0 glyco",
    "TF CGLVPVLAENYNK-N4H5F2S1G0 glyco",
    "TF CGLVPVLAENYNK-N4H6F0S1G0 glyco",
    "TF CGLVPVLAENYNK-N4H6F1S1G0 glyco",
    "TF CGLVPVLAENYNK-N5H6F0S1G0 glyco",
    "TF CGLVPVLAENYNK-N5H6F0S2G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N3H4F0S1G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N4H4F0S1G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N4H5F0S0G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N4H5F0S1G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N4H5F0S2G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N4H5F1S1G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N4H5F1S2G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N4H5F2S0G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N4H5F2S1G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N4H5F3S1G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N4H6F0S2G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N4H6F1S0G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N4H6F1S1G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N4H7F0S1G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N5H3F1S0G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N5H4F0S0G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N5H5F1S1G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N5H6F0S2G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N6H3F3S0G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N6H3F5S0G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N6H4F2S0G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N6H4F2S1G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N6H5F1S0G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N6H5F1S1G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N7H5F0S0G0 glyco",
    "TF QQQHLFGSNVTDCSGNFCLFR-N8H5F1S0G0 glyco",
    "TF cnv",
    "TF methyl",
    "TF proteo",
    "TF rna"
  ],
  "TFAM": [
    "TFAM cnv",
    "TFAM methyl",
    "TFAM proteo",
    "TFAM rna"
  ],
  "TFAP2A": [
    "TFAP2A cnv",
    "TFAP2A methyl",
    "TFAP2A rna"
  ],
  "TFAP2A-AS2": [
    "TFAP2A-AS2 methyl"
  ],
  "TFAP2B": [
    "TFAP2B cnv",
    "TFAP2B rna"
  ],
  "TFAP2C": [
    "TFAP2C cnv",
    "TFAP2C methyl",
    "TFAP2C rna"
  ],
  "TFAP2D": [
    "TFAP2D cnv",
    "TFAP2D rna"
  ],
  "TFAP2E": [
    "TFAP2E cnv",
    "TFAP2E methyl",
    "TFAP2E rna"
  ],
  "TFAP4": [
    "TFAP4 121_124_1_1_S124 phospho",
    "TFAP4 cnv",
    "TFAP4 methyl",
    "TFAP4 proteo",
    "TFAP4 rna"
  ],
  "TFB1M": [
    "TFB1M cnv",
    "TFB1M methyl",
    "TFB1M proteo",
    "TFB1M rna"
  ],
  "TFB2M": [
    "TFB2M cnv",
    "TFB2M methyl",
    "TFB2M proteo",
    "TFB2M rna"
  ],
  "TFCP2": [
    "TFCP2 cnv",
    "TFCP2 methyl",
    "TFCP2 proteo",
    "TFCP2 rna"
  ],
  "TFCP2L1": [
    "TFCP2L1 cnv",
    "TFCP2L1 methyl",
    "TFCP2L1 rna"
  ],
  "TFDP1": [
    "TFDP1 cnv",
    "TFDP1 methyl",
    "TFDP1 proteo",
    "TFDP1 rna"
  ],
  "TFDP2": [
    "TFDP2 24_26_1_1_S24 phospho",
    "TFDP2 cnv",
    "TFDP2 methyl",
    "TFDP2 rna"
  ],
  "TFDP3": [
    "TFDP3 rna"
  ],
  "TFE3": [
    "TFE3 443_455_1_1_S451 phospho",
    "TFE3 443_455_2_2_S443S451 phospho",
    "TFE3 methyl",
    "TFE3 proteo",
    "TFE3 rna"
  ],
  "TFEB": [
    "TFEB 344_348_1_0 phospho",
    "TFEB 344_348_1_1_S346 phospho",
    "TFEB cnv",
    "TFEB methyl",
    "TFEB proteo",
    "TFEB rna"
  ],
  "TFEC": [
    "TFEC cnv",
    "TFEC rna"
  ],
  "TFF1": [
    "TFF1 cnv",
    "TFF1 rna"
  ],
  "TFF2": [
    "TFF2 cnv"
  ],
  "TFF3": [
    "TFF3 cnv",
    "TFF3 rna"
  ],
  "TFG": [
    "TFG 183_197_1_1_S193 phospho",
    "TFG 183_197_1_1_S197 phospho",
    "TFG cnv",
    "TFG methyl",
    "TFG proteo",
    "TFG rna"
  ],
  "TFIP11": [
    "TFIP11 198_210_1_1_S210 phospho",
    "TFIP11 50_65_1_1_S59 phospho",
    "TFIP11 98_98_1_1_S98 phospho",
    "TFIP11 cnv",
    "TFIP11 methyl",
    "TFIP11 proteo",
    "TFIP11 rna"
  ],
  "TFIP11-DT": [
    "TFIP11-DT methyl"
  ],
  "TFPI": [
    "TFPI cnv",
    "TFPI proteo",
    "TFPI rna"
  ],
  "TFPI2": [
    "TFPI2 cnv",
    "TFPI2 methyl",
    "TFPI2 rna"
  ],
  "TFPI2-DT": [
    "TFPI2-DT methyl"
  ],
  "TFPT": [
    "TFPT 198_198_1_1_T198 phospho",
    "TFPT 235_243_1_1_S243 phospho",
    "TFPT cnv",
    "TFPT methyl",
    "TFPT rna"
  ],
  "TFR2": [
    "TFR2 cnv",
    "TFR2 methyl",
    "TFR2 rna"
  ],
  "TFRC": [
    "TFRC 34_34_1_1_S34 phospho",
    "TFRC KQNNGAFNETLFR-N2H7F0S0G0 glyco",
    "TFRC QNNGAFNETLFR-N2H6F0S0G0 glyco",
    "TFRC QNNGAFNETLFR-N2H7F0S0G0 glyco",
    "TFRC QNNGAFNETLFR-N2H8F0S0G0 glyco",
    "TFRC cnv",
    "TFRC methyl",
    "TFRC proteo",
    "TFRC rna"
  ],
  "TG": [
    "TG cnv",
    "TG rna"
  ],
  "TGDS": [
    "TGDS cnv",
    "TGDS methyl",
    "TGDS rna"
  ],
  "TGFA": [
    "TGFA cnv",
    "TGFA methyl",
    "TGFA rna"
  ],
  "TGFB1": [
    "TGFB1 cnv",
    "TGFB1 methyl",
    "TGFB1 proteo",
    "TGFB1 rna"
  ],
  "TGFB1I1": [
    "TGFB1I1 137_143_1_1_S137 phospho",
    "TGFB1I1 137_143_2_2_S137S141 phospho",
    "TGFB1I1 177_199_1_1_S194 phospho",
    "TGFB1I1 177_199_2_0 phospho",
    "TGFB1I1 403_413_1_1_S403 phospho",
    "TGFB1I1 68_88_1_1_S68 phospho",
    "TGFB1I1 cnv",
    "TGFB1I1 proteo",
    "TGFB1I1 rna"
  ],
  "TGFB2": [
    "TGFB2 NASNLVK-N2H8F0S0G0 glyco",
    "TGFB2 cnv",
    "TGFB2 methyl",
    "TGFB2 proteo",
    "TGFB2 rna"
  ],
  "TGFB3": [
    "TGFB3 cnv",
    "TGFB3 methyl",
    "TGFB3 proteo",
    "TGFB3 rna"
  ],
  "TGFBI": [
    "TGFBI cnv",
    "TGFBI methyl",
    "TGFBI proteo",
    "TGFBI rna"
  ],
  "TGFBR1": [
    "TGFBR1 cnv",
    "TGFBR1 kinase",
    "TGFBR1 methyl",
    "TGFBR1 proteo",
    "TGFBR1 rna"
  ],
  "TGFBR2": [
    "TGFBR2 576_591_1_1_S578 phospho",
    "TGFBR2 cnv",
    "TGFBR2 kinase",
    "TGFBR2 methyl",
    "TGFBR2 rna"
  ],
  "TGFBR3": [
    "TGFBR3 cnv",
    "TGFBR3 methyl",
    "TGFBR3 proteo",
    "TGFBR3 rna"
  ],
  "TGFBR3L": [
    "TGFBR3L cnv",
    "TGFBR3L methyl",
    "TGFBR3L rna"
  ],
  "TGFBRAP1": [
    "TGFBRAP1 849_858_1_1_S855 phospho",
    "TGFBRAP1 849_860_1_1_S855 phospho",
    "TGFBRAP1 cnv",
    "TGFBRAP1 methyl",
    "TGFBRAP1 proteo",
    "TGFBRAP1 rna"
  ],
  "TGIF1": [
    "TGIF1 cnv",
    "TGIF1 methyl",
    "TGIF1 rna"
  ],
  "TGIF2": [
    "TGIF2 cnv",
    "TGIF2 methyl",
    "TGIF2 rna"
  ],
  "TGIF2-RAB5IF": [
    "TGIF2-RAB5IF cnv",
    "TGIF2-RAB5IF methyl",
    "TGIF2-RAB5IF rna"
  ],
  "TGIF2LX": [
    "TGIF2LX rna"
  ],
  "TGM1": [
    "TGM1 cnv",
    "TGM1 rna"
  ],
  "TGM2": [
    "TGM2 215_219_1_1_S216 phospho",
    "TGM2 cnv",
    "TGM2 methyl",
    "TGM2 proteo",
    "TGM2 rna"
  ],
  "TGM3": [
    "TGM3 cnv",
    "TGM3 methyl",
    "TGM3 proteo",
    "TGM3 rna"
  ],
  "TGM4": [
    "TGM4 cnv",
    "TGM4 rna"
  ],
  "TGM5": [
    "TGM5 cnv",
    "TGM5 rna"
  ],
  "TGM6": [
    "TGM6 cnv"
  ],
  "TGM7": [
    "TGM7 cnv",
    "TGM7 rna"
  ],
  "TGOLN2": [
    "TGOLN2 140_154_1_1_S154 phospho",
    "TGOLN2 221_236_1_1_S221 phospho",
    "TGOLN2 290_306_1_1_S298 phospho",
    "TGOLN2 296_306_1_1_S298 phospho",
    "TGOLN2 66_80_1_1_S71 phospho",
    "TGOLN2 70_80_1_0 phospho",
    "TGOLN2 cnv",
    "TGOLN2 methyl",
    "TGOLN2 proteo",
    "TGOLN2 rna"
  ],
  "TGS1": [
    "TGS1 405_422_1_1_S412 phospho",
    "TGS1 405_422_2_2_T407S412 phospho",
    "TGS1 405_422_3_3_S405T407S412 phospho",
    "TGS1 cnv",
    "TGS1 methyl",
    "TGS1 proteo",
    "TGS1 rna"
  ],
  "TH": [
    "TH cnv",
    "TH methyl",
    "TH rna"
  ],
  "TH2LCRR": [
    "TH2LCRR methyl"
  ],
  "THADA": [
    "THADA 1015_1015_1_1_S1015 phospho",
    "THADA cnv",
    "THADA methyl",
    "THADA proteo",
    "THADA rna"
  ],
  "THAP1": [
    "THAP1 cnv",
    "THAP1 methyl",
    "THAP1 rna"
  ],
  "THAP10": [
    "THAP10 cnv",
    "THAP10 rna"
  ],
  "THAP11": [
    "THAP11 cnv",
    "THAP11 methyl",
    "THAP11 proteo",
    "THAP11 rna"
  ],
  "THAP12": [
    "THAP12 cnv",
    "THAP12 methyl",
    "THAP12 proteo",
    "THAP12 rna"
  ],
  "THAP2": [
    "THAP2 cnv",
    "THAP2 methyl",
    "THAP2 rna"
  ],
  "THAP3": [
    "THAP3 cnv",
    "THAP3 methyl",
    "THAP3 rna"
  ],
  "THAP4": [
    "THAP4 cnv",
    "THAP4 methyl",
    "THAP4 proteo",
    "THAP4 rna"
  ],
  "THAP5": [
    "THAP5 cnv",
    "THAP5 methyl",
    "THAP5 rna"
  ],
  "THAP6": [
    "THAP6 cnv",
    "THAP6 methyl",
    "THAP6 rna"
  ],
  "THAP7": [
    "THAP7 cnv",
    "THAP7 methyl",
    "THAP7 rna"
  ],
  "THAP7-AS1": [
    "THAP7-AS1 methyl"
  ],
  "THAP8": [
    "THAP8 cnv",
    "THAP8 methyl",
    "THAP8 rna"
  ],
  "THAP9": [
    "THAP9 cnv",
    "THAP9 methyl",
    "THAP9 rna"
  ],
  "THBD": [
    "THBD cnv",
    "THBD methyl",
    "THBD proteo",
    "THBD rna"
  ],
  "THBS1": [
    "THBS1 GCSSSTSVLLTLDNNVVNGSSPAIR-N4H5F1S1G0 glyco",
    "THBS1 VVNSTTGPGEHLR-N4H5F0S0G0 glyco",
    "THBS1 VVNSTTGPGEHLR-N4H5F0S1G0 glyco",
    "THBS1 VVNSTTGPGEHLR-N5H4F0S0G0 glyco",
    "THBS1 cnv",
    "THBS1 methyl",
    "THBS1 proteo",
    "THBS1 rna"
  ],
  "THBS2": [
    "THBS2 cnv",
    "THBS2 methyl",
    "THBS2 proteo",
    "THBS2 rna"
  ],
  "THBS3": [
    "THBS3 cnv",
    "THBS3 methyl",
    "THBS3 proteo",
    "THBS3 rna"
  ],
  "THBS4": [
    "THBS4 cnv",
    "THBS4 methyl",
    "THBS4 proteo",
    "THBS4 rna"
  ],
  "THCAT155": [
    "THCAT155 methyl"
  ],
  "THEG": [
    "THEG cnv",
    "THEG methyl",
    "THEG rna"
  ],
  "THEGL": [
    "THEGL cnv",
    "THEGL methyl",
    "THEGL rna"
  ],
  "THEM4": [
    "THEM4 cnv",
    "THEM4 methyl",
    "THEM4 proteo",
    "THEM4 rna"
  ],
  "THEM5": [
    "THEM5 cnv",
    "THEM5 rna"
  ],
  "THEM6": [
    "THEM6 cnv",
    "THEM6 methyl",
    "THEM6 proteo",
    "THEM6 rna"
  ],
  "THEMIS": [
    "THEMIS cnv",
    "THEMIS proteo",
    "THEMIS rna"
  ],
  "THEMIS2": [
    "THEMIS2 cnv",
    "THEMIS2 proteo",
    "THEMIS2 rna"
  ],
  "THG1L": [
    "THG1L cnv",
    "THG1L methyl",
    "THG1L proteo",
    "THG1L rna"
  ],
  "THNSL1": [
    "THNSL1 cnv",
    "THNSL1 methyl",
    "THNSL1 proteo",
    "THNSL1 rna"
  ],
  "THNSL2": [
    "THNSL2 cnv",
    "THNSL2 methyl",
    "THNSL2 proteo",
    "THNSL2 rna"
  ],
  "THOC1": [
    "THOC1 cnv",
    "THOC1 methyl",
    "THOC1 proteo",
    "THOC1 rna"
  ],
  "THOC2": [
    "THOC2 1285_1289_1_1_T1285 phospho",
    "THOC2 1414_1423_1_1_S1417 phospho",
    "THOC2 1514_1522_1_1_S1516 phospho",
    "THOC2 1514_1522_2_2_S1514S1516 phospho",
    "THOC2 methyl",
    "THOC2 proteo",
    "THOC2 rna"
  ],
  "THOC3": [
    "THOC3 cnv",
    "THOC3 methyl",
    "THOC3 proteo",
    "THOC3 rna"
  ],
  "THOC5": [
    "THOC5 cnv",
    "THOC5 methyl",
    "THOC5 proteo",
    "THOC5 rna"
  ],
  "THOC6": [
    "THOC6 180_185_1_1_S180 phospho",
    "THOC6 cnv",
    "THOC6 methyl",
    "THOC6 proteo",
    "THOC6 rna"
  ],
  "THOC7": [
    "THOC7 188_200_1_1_S188 phospho",
    "THOC7 cnv",
    "THOC7 methyl",
    "THOC7 proteo",
    "THOC7 rna"
  ],
  "THOP1": [
    "THOP1 16_19_1_1_S16 phospho",
    "THOP1 cnv",
    "THOP1 methyl",
    "THOP1 proteo",
    "THOP1 rna"
  ],
  "THORLNC": [
    "THORLNC methyl"
  ],
  "THPO": [
    "THPO cnv",
    "THPO methyl",
    "THPO rna"
  ],
  "THRA": [
    "THRA cnv",
    "THRA methyl",
    "THRA rna"
  ],
  "THRAP3": [
    "THRAP3 205_214_1_1_S211 phospho",
    "THRAP3 217_243_1_1_S243 phospho",
    "THRAP3 248_248_1_1_S248 phospho",
    "THRAP3 248_257_1_1_S248 phospho",
    "THRAP3 264_268_1_1_S264 phospho",
    "THRAP3 315_331_1_1_S320 phospho",
    "THRAP3 315_331_2_2_S315S320 phospho",
    "THRAP3 320_331_1_1_S320 phospho",
    "THRAP3 377_381_1_1_S377 phospho",
    "THRAP3 377_381_1_1_S379 phospho",
    "THRAP3 468_476_1_1_S468 phospho",
    "THRAP3 533_535_1_1_S535 phospho",
    "THRAP3 575_575_1_1_S575 phospho",
    "THRAP3 575_584_1_1_S575 phospho",
    "THRAP3 622_633_1_1_S622 phospho",
    "THRAP3 622_633_1_1_S624 phospho",
    "THRAP3 672_672_1_1_S672 phospho",
    "THRAP3 682_685_1_1_S682 phospho",
    "THRAP3 698_698_1_1_S698 phospho",
    "THRAP3 698_704_1_1_S698 phospho",
    "THRAP3 873_874_1_1_T874 phospho",
    "THRAP3 928_941_1_1_S939 phospho",
    "THRAP3 928_941_2_2_S928S939 phospho",
    "THRAP3 953_954_1_1_T954 phospho",
    "THRAP3 cnv",
    "THRAP3 methyl",
    "THRAP3 proteo",
    "THRAP3 rna"
  ],
  "THRB": [
    "THRB cnv",
    "THRB methyl",
    "THRB rna"
  ],
  "THRSP": [
    "THRSP cnv",
    "THRSP rna"
  ],
  "THSD1": [
    "THSD1 453_458_1_1_S453 phospho",
    "THSD1 653_655_1_1_S655 phospho",
    "THSD1 cnv",
    "THSD1 methyl",
    "THSD1 rna"
  ],
  "THSD4": [
    "THSD4 cnv",
    "THSD4 methyl",
    "THSD4 proteo",
    "THSD4 rna"
  ],
  "THSD7A": [
    "THSD7A NISCVVSDGSADDFSK-N2H5F0S0G0 glyco",
    "THSD7A cnv",
    "THSD7A proteo",
    "THSD7A rna"
  ],
  "THSD7B": [
    "THSD7B cnv",
    "THSD7B methyl",
    "THSD7B rna"
  ],
  "THSD8": [
    "THSD8 cnv",
    "THSD8 methyl",
    "THSD8 rna"
  ],
  "THTPA": [
    "THTPA cnv",
    "THTPA methyl",
    "THTPA proteo",
    "THTPA rna"
  ],
  "THUMPD1": [
    "THUMPD1 79_88_1_1_S86 phospho",
    "THUMPD1 79_88_2_2_S86S88 phospho",
    "THUMPD1 86_88_2_2_S86S88 phospho",
    "THUMPD1 cnv",
    "THUMPD1 methyl",
    "THUMPD1 proteo",
    "THUMPD1 rna"
  ],
  "THUMPD2": [
    "THUMPD2 cnv",
    "THUMPD2 methyl",
    "THUMPD2 rna"
  ],
  "THUMPD3": [
    "THUMPD3 cnv",
    "THUMPD3 methyl",
    "THUMPD3 proteo",
    "THUMPD3 rna"
  ],
  "THUMPD3-AS1": [
    "THUMPD3-AS1 methyl"
  ],
  "THY1": [
    "THY1 66_74_1_1_T73 phospho",
    "THY1 90_96_1_1_S96 phospho",
    "THY1 DEGTYTCALHHSGHSPPISSQNVTVLR-N2H5F0S0G0 glyco",
    "THY1 DEGTYTCALHHSGHSPPISSQNVTVLR-N5H3F1S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N2H5F0S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N3H4F1S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N3H4F2S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N3H5F1S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N3H5F1S1G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N3H5F2S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N3H5F2S1G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N3H6F1S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N3H6F1S1G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N4H3F1S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N4H4F1S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N4H4F2S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N4H5F1S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N4H5F1S1G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N4H5F1S2G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N4H5F2S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N4H5F2S1G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N4H6F1S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N4H6F1S1G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N4H6F2S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N5H3F1S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N5H3F4S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N5H4F1S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N5H4F1S1G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N5H4F2S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N5H5F1S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N5H6F1S1G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N6H4F1S1G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N6H4F2S0G0 glyco",
    "THY1 HENTSSSPIQYEFSLTR-N6H5F1S1G0 glyco",
    "THY1 VLYLSAFTSKDEGTYTCALHHSGHSPPISSQNVTVLR-N2H5F0S0G0 glyco",
    "THY1 cnv",
    "THY1 methyl",
    "THY1 proteo",
    "THY1 rna"
  ],
  "THYN1": [
    "THYN1 cnv",
    "THYN1 methyl",
    "THYN1 proteo",
    "THYN1 rna"
  ],
  "TIA1": [
    "TIA1 cnv",
    "TIA1 methyl",
    "TIA1 proteo",
    "TIA1 rna"
  ],
  "TIAF1": [
    "TIAF1 cnv",
    "TIAF1 rna"
  ],
  "TIAL1": [
    "TIAL1 cnv",
    "TIAL1 methyl",
    "TIAL1 proteo",
    "TIAL1 rna"
  ],
  "TIAM1": [
    "TIAM1 1405_1414_1_0 phospho",
    "TIAM1 1405_1414_1_1_S1407 phospho",
    "TIAM1 1456_1466_1_1_S1466 phospho",
    "TIAM1 1456_1466_1_1_T1456 phospho",
    "TIAM1 231_236_1_1_S231 phospho",
    "TIAM1 294_311_1_0 phospho",
    "TIAM1 cnv",
    "TIAM1 methyl",
    "TIAM1 proteo",
    "TIAM1 rna"
  ],
  "TIAM1-AS1": [
    "TIAM1-AS1 methyl"
  ],
  "TIAM2": [
    "TIAM2 1543_1549_1_0 phospho",
    "TIAM2 1543_1549_1_1_S1545 phospho",
    "TIAM2 1565_1578_1_1_S1569 phospho",
    "TIAM2 1658_1672_1_1_S1658 phospho",
    "TIAM2 cnv",
    "TIAM2 methyl",
    "TIAM2 proteo",
    "TIAM2 rna"
  ],
  "TICAM1": [
    "TICAM1 cnv",
    "TICAM1 methyl",
    "TICAM1 rna"
  ],
  "TICAM2": [
    "TICAM2 22_34_1_1_S22 phospho",
    "TICAM2 cnv",
    "TICAM2 methyl",
    "TICAM2 rna"
  ],
  "TICRR": [
    "TICRR cnv",
    "TICRR methyl",
    "TICRR rna"
  ],
  "TIE1": [
    "TIE1 cnv",
    "TIE1 kinase",
    "TIE1 rna"
  ],
  "TIFA": [
    "TIFA cnv",
    "TIFA methyl",
    "TIFA rna"
  ],
  "TIFAB": [
    "TIFAB cnv",
    "TIFAB rna"
  ],
  "TIGAR": [
    "TIGAR cnv",
    "TIGAR methyl",
    "TIGAR proteo",
    "TIGAR rna"
  ],
  "TIGD1": [
    "TIGD1 cnv",
    "TIGD1 methyl",
    "TIGD1 rna"
  ],
  "TIGD2": [
    "TIGD2 cnv",
    "TIGD2 methyl",
    "TIGD2 rna"
  ],
  "TIGD3": [
    "TIGD3 cnv",
    "TIGD3 methyl",
    "TIGD3 rna"
  ],
  "TIGD4": [
    "TIGD4 cnv",
    "TIGD4 methyl",
    "TIGD4 rna"
  ],
  "TIGD5": [
    "TIGD5 cnv",
    "TIGD5 methyl",
    "TIGD5 rna"
  ],
  "TIGD6": [
    "TIGD6 cnv",
    "TIGD6 methyl",
    "TIGD6 rna"
  ],
  "TIGD7": [
    "TIGD7 cnv",
    "TIGD7 methyl",
    "TIGD7 rna"
  ],
  "TIGIT": [
    "TIGIT cnv",
    "TIGIT rna"
  ],
  "TIMD4": [
    "TIMD4 cnv",
    "TIMD4 rna"
  ],
  "TIMELESS": [
    "TIMELESS cnv",
    "TIMELESS methyl",
    "TIMELESS rna"
  ],
  "TIMM10": [
    "TIMM10 cnv",
    "TIMM10 proteo",
    "TIMM10 rna"
  ],
  "TIMM10B": [
    "TIMM10B cnv",
    "TIMM10B methyl",
    "TIMM10B proteo",
    "TIMM10B rna"
  ],
  "TIMM13": [
    "TIMM13 cnv",
    "TIMM13 methyl",
    "TIMM13 proteo",
    "TIMM13 rna"
  ],
  "TIMM17A": [
    "TIMM17A cnv",
    "TIMM17A methyl",
    "TIMM17A proteo",
    "TIMM17A rna"
  ],
  "TIMM17B": [
    "TIMM17B methyl",
    "TIMM17B proteo",
    "TIMM17B rna"
  ],
  "TIMM21": [
    "TIMM21 cnv",
    "TIMM21 methyl",
    "TIMM21 proteo",
    "TIMM21 rna"
  ],
  "TIMM22": [
    "TIMM22 cnv",
    "TIMM22 methyl",
    "TIMM22 proteo",
    "TIMM22 rna"
  ],
  "TIMM23": [
    "TIMM23 cnv",
    "TIMM23 methyl",
    "TIMM23 proteo",
    "TIMM23 rna"
  ],
  "TIMM23B": [
    "TIMM23B cnv",
    "TIMM23B rna"
  ],
  "TIMM23B-AGAP6": [
    "TIMM23B-AGAP6 cnv",
    "TIMM23B-AGAP6 rna"
  ],
  "TIMM29": [
    "TIMM29 cnv",
    "TIMM29 methyl",
    "TIMM29 proteo",
    "TIMM29 rna"
  ],
  "TIMM44": [
    "TIMM44 cnv",
    "TIMM44 methyl",
    "TIMM44 proteo",
    "TIMM44 rna"
  ],
  "TIMM50": [
    "TIMM50 cnv",
    "TIMM50 methyl",
    "TIMM50 proteo",
    "TIMM50 rna"
  ],
  "TIMM8A": [
    "TIMM8A methyl",
    "TIMM8A proteo",
    "TIMM8A rna"
  ],
  "TIMM8B": [
    "TIMM8B cnv",
    "TIMM8B methyl",
    "TIMM8B proteo",
    "TIMM8B rna"
  ],
  "TIMM9": [
    "TIMM9 cnv",
    "TIMM9 methyl",
    "TIMM9 proteo",
    "TIMM9 rna"
  ],
  "TIMMDC1": [
    "TIMMDC1 cnv",
    "TIMMDC1 methyl",
    "TIMMDC1 proteo",
    "TIMMDC1 rna"
  ],
  "TIMP1": [
    "TIMP1 FVGTPEVNQTTLYQR-N2H6F0S0G0 glyco",
    "TIMP1 FVGTPEVNQTTLYQR-N2H7F0S0G0 glyco",
    "TIMP1 FVGTPEVNQTTLYQR-N2H8F0S0G0 glyco",
    "TIMP1 FVGTPEVNQTTLYQR-N2H9F0S0G0 glyco",
    "TIMP1 FVGTPEVNQTTLYQR-N4H5F1S1G0 glyco",
    "TIMP1 FVGTPEVNQTTLYQR-N4H5F1S2G0 glyco",
    "TIMP1 FVGTPEVNQTTLYQR-N5H3F1S0G0 glyco",
    "TIMP1 FVGTPEVNQTTLYQR-N5H4F1S0G0 glyco",
    "TIMP1 FVGTPEVNQTTLYQR-N5H4F1S1G0 glyco",
    "TIMP1 FVGTPEVNQTTLYQR-N5H5F1S1G0 glyco",
    "TIMP1 SHNRSEEFLIAGK-N4H5F1S2G0 glyco",
    "TIMP1 proteo",
    "TIMP1 rna"
  ],
  "TIMP2": [
    "TIMP2 cnv",
    "TIMP2 methyl",
    "TIMP2 proteo",
    "TIMP2 rna"
  ],
  "TIMP3": [
    "TIMP3 cnv",
    "TIMP3 methyl",
    "TIMP3 proteo",
    "TIMP3 rna"
  ],
  "TIMP4": [
    "TIMP4 cnv",
    "TIMP4 methyl",
    "TIMP4 rna"
  ],
  "TINAG": [
    "TINAG cnv",
    "TINAG rna"
  ],
  "TINAGL1": [
    "TINAGL1 cnv",
    "TINAGL1 proteo",
    "TINAGL1 rna"
  ],
  "TINCR": [
    "TINCR cnv",
    "TINCR rna"
  ],
  "TINF2": [
    "TINF2 cnv",
    "TINF2 methyl",
    "TINF2 proteo",
    "TINF2 rna"
  ],
  "TIPARP": [
    "TIPARP cnv",
    "TIPARP methyl",
    "TIPARP rna"
  ],
  "TIPIN": [
    "TIPIN cnv",
    "TIPIN methyl",
    "TIPIN rna"
  ],
  "TIPRL": [
    "TIPRL cnv",
    "TIPRL methyl",
    "TIPRL proteo",
    "TIPRL rna"
  ],
  "TIRAP": [
    "TIRAP cnv",
    "TIRAP methyl",
    "TIRAP rna"
  ],
  "TJAP1": [
    "TJAP1 300_300_1_1_S300 phospho",
    "TJAP1 524_531_1_1_S531 phospho",
    "TJAP1 545_547_1_1_S545 phospho",
    "TJAP1 cnv",
    "TJAP1 proteo",
    "TJAP1 rna"
  ],
  "TJP1": [
    "TJP1 1005_1012_1_1_S1005 phospho",
    "TJP1 1019_1045_1_1_S1020 phospho",
    "TJP1 1053_1066_1_1_S1061 phospho",
    "TJP1 1053_1072_1_0 phospho",
    "TJP1 1180_1209_1_0 phospho",
    "TJP1 1180_1209_1_1_S1204 phospho",
    "TJP1 1193_1209_1_1_S1204 phospho",
    "TJP1 210_225_1_1_S224 phospho",
    "TJP1 210_225_2_0 phospho",
    "TJP1 210_225_2_2_S218S224 phospho",
    "TJP1 268_278_2_2_S271S272 phospho",
    "TJP1 360_377_1_1_S370 phospho",
    "TJP1 360_393_1_1_S370 phospho",
    "TJP1 422_430_1_1_S422 phospho",
    "TJP1 422_430_1_1_S430 phospho",
    "TJP1 440_456_1_1_T447 phospho",
    "TJP1 472_514_1_1_S495 phospho",
    "TJP1 678_682_1_1_T682 phospho",
    "TJP1 710_721_1_1_S710 phospho",
    "TJP1 916_927_1_1_S916 phospho",
    "TJP1 970_992_1_0 phospho",
    "TJP1 970_992_1_1_S992 phospho",
    "TJP1 cnv",
    "TJP1 methyl",
    "TJP1 proteo",
    "TJP1 rna"
  ],
  "TJP2": [
    "TJP2 1009_1017_1_1_S1017 phospho",
    "TJP2 1009_1017_2_0 phospho",
    "TJP2 1009_1017_2_2_S1009S1017 phospho",
    "TJP2 1079_1099_1_0 phospho",
    "TJP2 1155_1168_1_1_T1162 phospho",
    "TJP2 1187_1205_1_1_S1190 phospho",
    "TJP2 199_205_1_1_S201 phospho",
    "TJP2 201_205_1_1_S201 phospho",
    "TJP2 275_280_1_1_S275 phospho",
    "TJP2 454_463_1_1_S462 phospho",
    "TJP2 454_463_2_2_S461S462 phospho",
    "TJP2 525_541_1_1_S530 phospho",
    "TJP2 733_745_1_1_S733 phospho",
    "TJP2 983_997_1_1_S997 phospho",
    "TJP2 997_997_1_1_S997 phospho",
    "TJP2 cnv",
    "TJP2 methyl",
    "TJP2 proteo",
    "TJP2 rna"
  ],
  "TJP3": [
    "TJP3 cnv",
    "TJP3 methyl",
    "TJP3 rna"
  ],
  "TK1": [
    "TK1 cnv",
    "TK1 methyl",
    "TK1 proteo",
    "TK1 rna"
  ],
  "TK2": [
    "TK2 cnv",
    "TK2 methyl",
    "TK2 proteo",
    "TK2 rna"
  ],
  "TKFC": [
    "TKFC cnv",
    "TKFC methyl",
    "TKFC proteo",
    "TKFC rna"
  ],
  "TKT": [
    "TKT 249_256_1_1_S256 phospho",
    "TKT 275_280_1_1_Y275 phospho",
    "TKT 287_295_1_1_S295 phospho",
    "TKT 287_295_1_1_T287 phospho",
    "TKT cnv",
    "TKT methyl",
    "TKT proteo",
    "TKT rna"
  ],
  "TKTL1": [
    "TKTL1 methyl",
    "TKTL1 rna"
  ],
  "TKTL2": [
    "TKTL2 cnv",
    "TKTL2 methyl",
    "TKTL2 rna"
  ],
  "TLCD1": [
    "TLCD1 cnv",
    "TLCD1 methyl",
    "TLCD1 rna"
  ],
  "TLCD2": [
    "TLCD2 cnv",
    "TLCD2 methyl",
    "TLCD2 rna"
  ],
  "TLCD3A": [
    "TLCD3A cnv",
    "TLCD3A methyl",
    "TLCD3A rna"
  ],
  "TLCD3B": [
    "TLCD3B cnv",
    "TLCD3B methyl",
    "TLCD3B rna"
  ],
  "TLCD4": [
    "TLCD4 cnv",
    "TLCD4 methyl",
    "TLCD4 rna"
  ],
  "TLCD4-RWDD3": [
    "TLCD4-RWDD3 cnv",
    "TLCD4-RWDD3 methyl",
    "TLCD4-RWDD3 rna"
  ],
  "TLCD5": [
    "TLCD5 cnv",
    "TLCD5 methyl",
    "TLCD5 rna"
  ],
  "TLDC2": [
    "TLDC2 cnv",
    "TLDC2 rna"
  ],
  "TLE1": [
    "TLE1 244_249_1_1_S249 phospho",
    "TLE1 294_308_1_1_S296 phospho",
    "TLE1 cnv",
    "TLE1 methyl",
    "TLE1 proteo",
    "TLE1 rna"
  ],
  "TLE1-DT": [
    "TLE1-DT methyl"
  ],
  "TLE2": [
    "TLE2 cnv",
    "TLE2 methyl",
    "TLE2 rna"
  ],
  "TLE3": [
    "TLE3 196_207_1_1_S203 phospho",
    "TLE3 263_267_1_1_S267 phospho",
    "TLE3 263_267_2_2_S263S267 phospho",
    "TLE3 285_299_1_1_S286 phospho",
    "TLE3 328_334_1_1_T334 phospho",
    "TLE3 cnv",
    "TLE3 methyl",
    "TLE3 proteo",
    "TLE3 rna"
  ],
  "TLE4": [
    "TLE4 cnv",
    "TLE4 methyl",
    "TLE4 rna"
  ],
  "TLE5": [
    "TLE5 187_196_1_1_S196 phospho",
    "TLE5 cnv",
    "TLE5 methyl",
    "TLE5 proteo",
    "TLE5 rna"
  ],
  "TLE6": [
    "TLE6 cnv",
    "TLE6 methyl",
    "TLE6 rna"
  ],
  "TLE7": [
    "TLE7 cnv",
    "TLE7 methyl"
  ],
  "TLK1": [
    "TLK1 147_159_1_1_S159 phospho",
    "TLK1 33_41_1_1_T38 phospho",
    "TLK1 741_766_1_0 phospho",
    "TLK1 cnv",
    "TLK1 kinase",
    "TLK1 methyl",
    "TLK1 proteo",
    "TLK1 rna"
  ],
  "TLK2": [
    "TLK2 110_117_1_1_S117 phospho",
    "TLK2 748_771_1_0 phospho",
    "TLK2 748_771_1_1_S771 phospho",
    "TLK2 cnv",
    "TLK2 kinase",
    "TLK2 methyl",
    "TLK2 proteo",
    "TLK2 rna"
  ],
  "TLL1": [
    "TLL1 cnv",
    "TLL1 methyl",
    "TLL1 rna"
  ],
  "TLL2": [
    "TLL2 cnv",
    "TLL2 methyl",
    "TLL2 rna"
  ],
  "TLN1": [
    "TLN1 1007_1021_1_1_S1021 phospho",
    "TLN1 1225_1240_1_1_S1225 phospho",
    "TLN1 1502_1508_1_1_S1508 phospho",
    "TLN1 2009_2011_1_1_T2009 phospho",
    "TLN1 2040_2040_1_1_S2040 phospho",
    "TLN1 2270_2273_1_1_T2270 phospho",
    "TLN1 405_425_1_1_S405 phospho",
    "TLN1 405_425_1_1_S425 phospho",
    "TLN1 417_425_1_1_S425 phospho",
    "TLN1 927_941_1_1_T941 phospho",
    "TLN1 973_992_1_1_S979 phospho",
    "TLN1 cnv",
    "TLN1 methyl",
    "TLN1 proteo",
    "TLN1 rna"
  ],
  "TLN2": [
    "TLN2 1843_1843_1_1_T1843 phospho",
    "TLN2 2170_2176_1_1_S2172 phospho",
    "TLN2 420_428_1_1_S428 phospho",
    "TLN2 458_473_1_0 phospho",
    "TLN2 cnv",
    "TLN2 proteo",
    "TLN2 rna"
  ],
  "TLNRD1": [
    "TLNRD1 cnv",
    "TLNRD1 methyl",
    "TLNRD1 proteo",
    "TLNRD1 rna"
  ],
  "TLR1": [
    "TLR1 cnv",
    "TLR1 rna"
  ],
  "TLR10": [
    "TLR10 cnv",
    "TLR10 rna"
  ],
  "TLR2": [
    "TLR2 cnv",
    "TLR2 methyl",
    "TLR2 proteo",
    "TLR2 rna"
  ],
  "TLR3": [
    "TLR3 cnv",
    "TLR3 proteo",
    "TLR3 rna"
  ],
  "TLR4": [
    "TLR4 cnv",
    "TLR4 rna"
  ],
  "TLR5": [
    "TLR5 cnv",
    "TLR5 methyl",
    "TLR5 rna"
  ],
  "TLR6": [
    "TLR6 cnv",
    "TLR6 rna"
  ],
  "TLR7": [
    "TLR7 proteo",
    "TLR7 rna"
  ],
  "TLR8": [
    "TLR8 rna"
  ],
  "TLR9": [
    "TLR9 cnv",
    "TLR9 rna"
  ],
  "TLX1": [
    "TLX1 cnv",
    "TLX1 methyl",
    "TLX1 rna"
  ],
  "TLX1NB": [
    "TLX1NB methyl"
  ],
  "TLX2": [
    "TLX2 cnv",
    "TLX2 methyl",
    "TLX2 rna"
  ],
  "TLX3": [
    "TLX3 cnv",
    "TLX3 methyl",
    "TLX3 rna"
  ],
  "TM2D1": [
    "TM2D1 LSITNETFRK-N2H8F0S0G0 glyco",
    "TM2D1 cnv",
    "TM2D1 methyl",
    "TM2D1 rna"
  ],
  "TM2D2": [
    "TM2D2 cnv",
    "TM2D2 methyl",
    "TM2D2 rna"
  ],
  "TM2D3": [
    "TM2D3 cnv",
    "TM2D3 methyl",
    "TM2D3 proteo",
    "TM2D3 rna"
  ],
  "TM4SF1": [
    "TM4SF1 cnv",
    "TM4SF1 rna"
  ],
  "TM4SF18": [
    "TM4SF18 cnv",
    "TM4SF18 rna"
  ],
  "TM4SF19": [
    "TM4SF19 cnv",
    "TM4SF19 rna"
  ],
  "TM4SF19-AS1": [
    "TM4SF19-AS1 methyl"
  ],
  "TM4SF19-DYNLT2B": [
    "TM4SF19-DYNLT2B cnv",
    "TM4SF19-DYNLT2B rna"
  ],
  "TM4SF20": [
    "TM4SF20 cnv",
    "TM4SF20 rna"
  ],
  "TM4SF4": [
    "TM4SF4 cnv",
    "TM4SF4 rna"
  ],
  "TM4SF5": [
    "TM4SF5 cnv",
    "TM4SF5 rna"
  ],
  "TM6SF1": [
    "TM6SF1 cnv",
    "TM6SF1 methyl",
    "TM6SF1 rna"
  ],
  "TM6SF2": [
    "TM6SF2 cnv",
    "TM6SF2 methyl",
    "TM6SF2 rna"
  ],
  "TM7SF2": [
    "TM7SF2 cnv",
    "TM7SF2 methyl",
    "TM7SF2 proteo",
    "TM7SF2 rna"
  ],
  "TM7SF3": [
    "TM7SF3 cnv",
    "TM7SF3 methyl",
    "TM7SF3 rna"
  ],
  "TM9SF1": [
    "TM9SF1 cnv",
    "TM9SF1 methyl",
    "TM9SF1 proteo",
    "TM9SF1 rna"
  ],
  "TM9SF2": [
    "TM9SF2 cnv",
    "TM9SF2 methyl",
    "TM9SF2 proteo",
    "TM9SF2 rna"
  ],
  "TM9SF3": [
    "TM9SF3 IVDVNLTSEGK-N4H5F0S2G0 glyco",
    "TM9SF3 cnv",
    "TM9SF3 methyl",
    "TM9SF3 proteo",
    "TM9SF3 rna"
  ],
  "TM9SF4": [
    "TM9SF4 cnv",
    "TM9SF4 proteo",
    "TM9SF4 rna"
  ],
  "TMA16": [
    "TMA16 cnv",
    "TMA16 methyl",
    "TMA16 proteo",
    "TMA16 rna"
  ],
  "TMA7": [
    "TMA7 cnv",
    "TMA7 methyl",
    "TMA7 rna"
  ],
  "TMBIM1": [
    "TMBIM1 cnv",
    "TMBIM1 methyl",
    "TMBIM1 proteo",
    "TMBIM1 rna"
  ],
  "TMBIM4": [
    "TMBIM4 cnv",
    "TMBIM4 methyl",
    "TMBIM4 rna"
  ],
  "TMBIM6": [
    "TMBIM6 cnv",
    "TMBIM6 methyl",
    "TMBIM6 rna"
  ],
  "TMC1": [
    "TMC1 cnv",
    "TMC1 rna"
  ],
  "TMC2": [
    "TMC2 cnv",
    "TMC2 rna"
  ],
  "TMC3": [
    "TMC3 cnv",
    "TMC3 rna"
  ],
  "TMC4": [
    "TMC4 cnv",
    "TMC4 rna"
  ],
  "TMC5": [
    "TMC5 cnv",
    "TMC5 methyl",
    "TMC5 rna"
  ],
  "TMC6": [
    "TMC6 cnv",
    "TMC6 methyl",
    "TMC6 proteo",
    "TMC6 rna"
  ],
  "TMC7": [
    "TMC7 cnv",
    "TMC7 methyl",
    "TMC7 rna"
  ],
  "TMC8": [
    "TMC8 cnv",
    "TMC8 methyl",
    "TMC8 rna"
  ],
  "TMCC1": [
    "TMCC1 382_382_1_1_S382 phospho",
    "TMCC1 409_414_1_1_S414 phospho",
    "TMCC1 cnv",
    "TMCC1 methyl",
    "TMCC1 proteo",
    "TMCC1 rna"
  ],
  "TMCC1-DT": [
    "TMCC1-DT methyl"
  ],
  "TMCC2": [
    "TMCC2 107_116_1_1_S116 phospho",
    "TMCC2 360_360_1_1_S360 phospho",
    "TMCC2 88_102_1_1_S88 phospho",
    "TMCC2 cnv",
    "TMCC2 methyl",
    "TMCC2 proteo",
    "TMCC2 rna"
  ],
  "TMCC3": [
    "TMCC3 cnv",
    "TMCC3 proteo",
    "TMCC3 rna"
  ],
  "TMCO1": [
    "TMCO1 cnv",
    "TMCO1 methyl",
    "TMCO1 proteo",
    "TMCO1 rna"
  ],
  "TMCO2": [
    "TMCO2 cnv",
    "TMCO2 rna"
  ],
  "TMCO3": [
    "TMCO3 cnv",
    "TMCO3 methyl",
    "TMCO3 proteo",
    "TMCO3 rna"
  ],
  "TMCO4": [
    "TMCO4 cnv",
    "TMCO4 methyl",
    "TMCO4 proteo",
    "TMCO4 rna"
  ],
  "TMCO5A": [
    "TMCO5A cnv"
  ],
  "TMCO6": [
    "TMCO6 cnv",
    "TMCO6 methyl",
    "TMCO6 rna"
  ],
  "TMDD1": [
    "TMDD1 cnv",
    "TMDD1 rna"
  ],
  "TMED1": [
    "TMED1 cnv",
    "TMED1 methyl",
    "TMED1 proteo",
    "TMED1 rna"
  ],
  "TMED10": [
    "TMED10 cnv",
    "TMED10 methyl",
    "TMED10 proteo",
    "TMED10 rna"
  ],
  "TMED2": [
    "TMED2 cnv",
    "TMED2 methyl",
    "TMED2 proteo",
    "TMED2 rna"
  ],
  "TMED3": [
    "TMED3 cnv",
    "TMED3 methyl",
    "TMED3 proteo",
    "TMED3 rna"
  ],
  "TMED4": [
    "TMED4 cnv",
    "TMED4 methyl",
    "TMED4 proteo",
    "TMED4 rna"
  ],
  "TMED5": [
    "TMED5 cnv",
    "TMED5 methyl",
    "TMED5 proteo",
    "TMED5 rna"
  ],
  "TMED6": [
    "TMED6 cnv",
    "TMED6 rna"
  ],
  "TMED7": [
    "TMED7 cnv",
    "TMED7 methyl",
    "TMED7 proteo",
    "TMED7 rna"
  ],
  "TMED7-TICAM2": [
    "TMED7-TICAM2 cnv",
    "TMED7-TICAM2 methyl",
    "TMED7-TICAM2 rna"
  ],
  "TMED8": [
    "TMED8 cnv",
    "TMED8 methyl",
    "TMED8 proteo",
    "TMED8 rna"
  ],
  "TMED9": [
    "TMED9 FTFTSHTPGEHQICLHSNSTK-N2H5F0S0G0 glyco",
    "TMED9 FTFTSHTPGEHQICLHSNSTK-N2H6F0S0G0 glyco",
    "TMED9 FTFTSHTPGEHQICLHSNSTK-N4H3F1S0G0 glyco",
    "TMED9 FTFTSHTPGEHQICLHSNSTK-N5H3F1S0G0 glyco",
    "TMED9 cnv",
    "TMED9 methyl",
    "TMED9 proteo",
    "TMED9 rna"
  ],
  "TMEFF1": [
    "TMEFF1 cnv",
    "TMEFF1 methyl",
    "TMEFF1 rna"
  ],
  "TMEFF2": [
    "TMEFF2 cnv",
    "TMEFF2 methyl",
    "TMEFF2 proteo",
    "TMEFF2 rna"
  ],
  "TMEM100": [
    "TMEM100 121_123_1_1_S121 phospho",
    "TMEM100 cnv",
    "TMEM100 rna"
  ],
  "TMEM101": [
    "TMEM101 cnv",
    "TMEM101 methyl",
    "TMEM101 rna"
  ],
  "TMEM102": [
    "TMEM102 cnv",
    "TMEM102 methyl",
    "TMEM102 rna"
  ],
  "TMEM104": [
    "TMEM104 cnv",
    "TMEM104 methyl",
    "TMEM104 rna"
  ],
  "TMEM106A": [
    "TMEM106A cnv",
    "TMEM106A methyl",
    "TMEM106A rna"
  ],
  "TMEM106B": [
    "TMEM106B 33_33_1_1_S33 phospho",
    "TMEM106B LNNITIIGPLDMK-N2H5F0S0G0 glyco",
    "TMEM106B LNNITIIGPLDMK-N2H6F0S0G0 glyco",
    "TMEM106B LNNITIIGPLDMK-N2H7F0S0G0 glyco",
    "TMEM106B LNNITIIGPLDMK-N2H8F0S0G0 glyco",
    "TMEM106B cnv",
    "TMEM106B methyl",
    "TMEM106B proteo",
    "TMEM106B rna"
  ],
  "TMEM106C": [
    "TMEM106C cnv",
    "TMEM106C methyl",
    "TMEM106C rna"
  ],
  "TMEM107": [
    "TMEM107 cnv",
    "TMEM107 methyl",
    "TMEM107 rna"
  ],
  "TMEM108": [
    "TMEM108 cnv",
    "TMEM108 methyl",
    "TMEM108 proteo",
    "TMEM108 rna"
  ],
  "TMEM109": [
    "TMEM109 cnv",
    "TMEM109 methyl",
    "TMEM109 proteo",
    "TMEM109 rna"
  ],
  "TMEM11": [
    "TMEM11 cnv",
    "TMEM11 methyl",
    "TMEM11 proteo",
    "TMEM11 rna"
  ],
  "TMEM11-DT": [
    "TMEM11-DT methyl"
  ],
  "TMEM114": [
    "TMEM114 cnv",
    "TMEM114 rna"
  ],
  "TMEM115": [
    "TMEM115 320_329_1_1_T329 phospho",
    "TMEM115 cnv",
    "TMEM115 methyl",
    "TMEM115 proteo",
    "TMEM115 rna"
  ],
  "TMEM116": [
    "TMEM116 cnv",
    "TMEM116 methyl",
    "TMEM116 rna"
  ],
  "TMEM117": [
    "TMEM117 cnv",
    "TMEM117 methyl",
    "TMEM117 rna"
  ],
  "TMEM119": [
    "TMEM119 cnv",
    "TMEM119 proteo",
    "TMEM119 rna"
  ],
  "TMEM120A": [
    "TMEM120A cnv",
    "TMEM120A methyl",
    "TMEM120A proteo",
    "TMEM120A rna"
  ],
  "TMEM120B": [
    "TMEM120B cnv",
    "TMEM120B methyl",
    "TMEM120B proteo",
    "TMEM120B rna"
  ],
  "TMEM121": [
    "TMEM121 cnv",
    "TMEM121 methyl",
    "TMEM121 rna"
  ],
  "TMEM121B": [
    "TMEM121B cnv",
    "TMEM121B methyl",
    "TMEM121B rna"
  ],
  "TMEM123": [
    "TMEM123 cnv",
    "TMEM123 methyl",
    "TMEM123 rna"
  ],
  "TMEM123-DT": [
    "TMEM123-DT methyl"
  ],
  "TMEM125": [
    "TMEM125 cnv",
    "TMEM125 rna"
  ],
  "TMEM126A": [
    "TMEM126A cnv",
    "TMEM126A methyl",
    "TMEM126A proteo",
    "TMEM126A rna"
  ],
  "TMEM126B": [
    "TMEM126B cnv",
    "TMEM126B methyl",
    "TMEM126B rna"
  ],
  "TMEM127": [
    "TMEM127 cnv",
    "TMEM127 methyl",
    "TMEM127 rna"
  ],
  "TMEM128": [
    "TMEM128 cnv",
    "TMEM128 methyl",
    "TMEM128 rna"
  ],
  "TMEM129": [
    "TMEM129 cnv",
    "TMEM129 methyl",
    "TMEM129 rna"
  ],
  "TMEM130": [
    "TMEM130 cnv",
    "TMEM130 methyl",
    "TMEM130 rna"
  ],
  "TMEM131": [
    "TMEM131 1155_1159_1_1_S1155 phospho",
    "TMEM131 1363_1375_1_1_S1375 phospho",
    "TMEM131 1870_1877_1_0 phospho",
    "TMEM131 1870_1877_1_1_S1871 phospho",
    "TMEM131 EADNHTAFIR-N2H6F0S0G0 glyco",
    "TMEM131 cnv",
    "TMEM131 methyl",
    "TMEM131 proteo",
    "TMEM131 rna"
  ],
  "TMEM131L": [
    "TMEM131L cnv",
    "TMEM131L methyl",
    "TMEM131L rna"
  ],
  "TMEM132A": [
    "TMEM132A 530_530_1_1_S530 phospho",
    "TMEM132A 914_951_1_1_S914 phospho",
    "TMEM132A cnv",
    "TMEM132A methyl",
    "TMEM132A proteo",
    "TMEM132A rna"
  ],
  "TMEM132B": [
    "TMEM132B 304_312_1_1_S305 phospho",
    "TMEM132B cnv",
    "TMEM132B methyl",
    "TMEM132B proteo",
    "TMEM132B rna"
  ],
  "TMEM132C": [
    "TMEM132C 1046_1049_1_1_S1046 phospho",
    "TMEM132C cnv",
    "TMEM132C methyl",
    "TMEM132C proteo",
    "TMEM132C rna"
  ],
  "TMEM132D": [
    "TMEM132D cnv",
    "TMEM132D methyl",
    "TMEM132D rna"
  ],
  "TMEM132E": [
    "TMEM132E 1004_1008_1_1_S1005 phospho",
    "TMEM132E cnv",
    "TMEM132E methyl",
    "TMEM132E proteo",
    "TMEM132E rna"
  ],
  "TMEM132E-DT": [
    "TMEM132E-DT methyl"
  ],
  "TMEM134": [
    "TMEM134 89_101_1_1_S93 phospho",
    "TMEM134 cnv",
    "TMEM134 methyl",
    "TMEM134 proteo",
    "TMEM134 rna"
  ],
  "TMEM135": [
    "TMEM135 cnv",
    "TMEM135 methyl",
    "TMEM135 proteo",
    "TMEM135 rna"
  ],
  "TMEM138": [
    "TMEM138 cnv",
    "TMEM138 methyl",
    "TMEM138 rna"
  ],
  "TMEM139": [
    "TMEM139 cnv",
    "TMEM139 rna"
  ],
  "TMEM140": [
    "TMEM140 cnv",
    "TMEM140 rna"
  ],
  "TMEM141": [
    "TMEM141 cnv",
    "TMEM141 methyl",
    "TMEM141 rna"
  ],
  "TMEM143": [
    "TMEM143 cnv",
    "TMEM143 methyl",
    "TMEM143 rna"
  ],
  "TMEM144": [
    "TMEM144 cnv",
    "TMEM144 methyl",
    "TMEM144 rna"
  ],
  "TMEM145": [
    "TMEM145 cnv",
    "TMEM145 methyl",
    "TMEM145 rna"
  ],
  "TMEM147": [
    "TMEM147 cnv",
    "TMEM147 methyl",
    "TMEM147 rna"
  ],
  "TMEM147-AS1": [
    "TMEM147-AS1 methyl"
  ],
  "TMEM14A": [
    "TMEM14A cnv",
    "TMEM14A methyl",
    "TMEM14A rna"
  ],
  "TMEM14B": [
    "TMEM14B cnv",
    "TMEM14B methyl",
    "TMEM14B rna"
  ],
  "TMEM14C": [
    "TMEM14C cnv",
    "TMEM14C methyl",
    "TMEM14C proteo",
    "TMEM14C rna"
  ],
  "TMEM150A": [
    "TMEM150A cnv",
    "TMEM150A methyl",
    "TMEM150A rna"
  ],
  "TMEM150B": [
    "TMEM150B cnv",
    "TMEM150B rna"
  ],
  "TMEM150C": [
    "TMEM150C cnv",
    "TMEM150C rna"
  ],
  "TMEM151A": [
    "TMEM151A cnv",
    "TMEM151A rna"
  ],
  "TMEM151B": [
    "TMEM151B cnv",
    "TMEM151B methyl",
    "TMEM151B rna"
  ],
  "TMEM154": [
    "TMEM154 cnv",
    "TMEM154 rna"
  ],
  "TMEM156": [
    "TMEM156 cnv",
    "TMEM156 rna"
  ],
  "TMEM158": [
    "TMEM158 cnv",
    "TMEM158 methyl",
    "TMEM158 rna"
  ],
  "TMEM160": [
    "TMEM160 cnv",
    "TMEM160 methyl",
    "TMEM160 proteo",
    "TMEM160 rna"
  ],
  "TMEM161A": [
    "TMEM161A cnv",
    "TMEM161A methyl",
    "TMEM161A proteo",
    "TMEM161A rna"
  ],
  "TMEM161B": [
    "TMEM161B cnv",
    "TMEM161B methyl",
    "TMEM161B rna"
  ],
  "TMEM161B-DT": [
    "TMEM161B-DT methyl"
  ],
  "TMEM163": [
    "TMEM163 11_16_1_1_S11 phospho",
    "TMEM163 11_16_1_1_S12 phospho",
    "TMEM163 37_38_1_1_S38 phospho",
    "TMEM163 cnv",
    "TMEM163 methyl",
    "TMEM163 proteo",
    "TMEM163 rna"
  ],
  "TMEM164": [
    "TMEM164 methyl",
    "TMEM164 rna"
  ],
  "TMEM165": [
    "TMEM165 cnv",
    "TMEM165 methyl",
    "TMEM165 proteo",
    "TMEM165 rna"
  ],
  "TMEM167A": [
    "TMEM167A cnv",
    "TMEM167A methyl",
    "TMEM167A proteo",
    "TMEM167A rna"
  ],
  "TMEM167B": [
    "TMEM167B cnv",
    "TMEM167B methyl",
    "TMEM167B rna"
  ],
  "TMEM168": [
    "TMEM168 cnv",
    "TMEM168 methyl",
    "TMEM168 proteo",
    "TMEM168 rna"
  ],
  "TMEM169": [
    "TMEM169 cnv",
    "TMEM169 methyl",
    "TMEM169 rna"
  ],
  "TMEM17": [
    "TMEM17 cnv",
    "TMEM17 methyl",
    "TMEM17 rna"
  ],
  "TMEM170A": [
    "TMEM170A cnv",
    "TMEM170A methyl",
    "TMEM170A rna"
  ],
  "TMEM170B": [
    "TMEM170B cnv",
    "TMEM170B methyl",
    "TMEM170B rna"
  ],
  "TMEM171": [
    "TMEM171 cnv",
    "TMEM171 methyl",
    "TMEM171 rna"
  ],
  "TMEM174": [
    "TMEM174 cnv",
    "TMEM174 rna"
  ],
  "TMEM175": [
    "TMEM175 cnv",
    "TMEM175 methyl",
    "TMEM175 proteo",
    "TMEM175 rna"
  ],
  "TMEM176A": [
    "TMEM176A cnv",
    "TMEM176A methyl",
    "TMEM176A rna"
  ],
  "TMEM176B": [
    "TMEM176B cnv",
    "TMEM176B methyl",
    "TMEM176B proteo",
    "TMEM176B rna"
  ],
  "TMEM177": [
    "TMEM177 cnv",
    "TMEM177 methyl",
    "TMEM177 rna"
  ],
  "TMEM178A": [
    "TMEM178A cnv",
    "TMEM178A methyl",
    "TMEM178A rna"
  ],
  "TMEM178B": [
    "TMEM178B cnv",
    "TMEM178B methyl",
    "TMEM178B proteo",
    "TMEM178B rna"
  ],
  "TMEM179": [
    "TMEM179 cnv",
    "TMEM179 methyl",
    "TMEM179 rna"
  ],
  "TMEM179B": [
    "TMEM179B 191_200_1_1_S192 phospho",
    "TMEM179B cnv",
    "TMEM179B methyl",
    "TMEM179B rna"
  ],
  "TMEM18": [
    "TMEM18 cnv",
    "TMEM18 methyl",
    "TMEM18 rna"
  ],
  "TMEM181": [
    "TMEM181 cnv",
    "TMEM181 methyl",
    "TMEM181 proteo",
    "TMEM181 rna"
  ],
  "TMEM182": [
    "TMEM182 cnv",
    "TMEM182 methyl",
    "TMEM182 rna"
  ],
  "TMEM183A": [
    "TMEM183A cnv",
    "TMEM183A methyl",
    "TMEM183A rna"
  ],
  "TMEM184A": [
    "TMEM184A cnv",
    "TMEM184A rna"
  ],
  "TMEM184B": [
    "TMEM184B 398_403_1_1_S403 phospho",
    "TMEM184B cnv",
    "TMEM184B methyl",
    "TMEM184B rna"
  ],
  "TMEM184C": [
    "TMEM184C cnv",
    "TMEM184C methyl",
    "TMEM184C proteo",
    "TMEM184C rna"
  ],
  "TMEM185A": [
    "TMEM185A methyl",
    "TMEM185A rna"
  ],
  "TMEM185B": [
    "TMEM185B 331_337_1_1_S333 phospho",
    "TMEM185B cnv",
    "TMEM185B methyl",
    "TMEM185B rna"
  ],
  "TMEM186": [
    "TMEM186 cnv",
    "TMEM186 methyl",
    "TMEM186 rna"
  ],
  "TMEM187": [
    "TMEM187 methyl",
    "TMEM187 rna"
  ],
  "TMEM19": [
    "TMEM19 cnv",
    "TMEM19 methyl",
    "TMEM19 proteo",
    "TMEM19 rna"
  ],
  "TMEM190": [
    "TMEM190 cnv",
    "TMEM190 rna"
  ],
  "TMEM191A": [
    "TMEM191A methyl"
  ],
  "TMEM191B": [
    "TMEM191B cnv",
    "TMEM191B methyl",
    "TMEM191B rna"
  ],
  "TMEM191C": [
    "TMEM191C cnv",
    "TMEM191C methyl",
    "TMEM191C rna"
  ],
  "TMEM192": [
    "TMEM192 cnv",
    "TMEM192 methyl",
    "TMEM192 proteo",
    "TMEM192 rna"
  ],
  "TMEM196": [
    "TMEM196 cnv",
    "TMEM196 rna"
  ],
  "TMEM198": [
    "TMEM198 cnv",
    "TMEM198 methyl",
    "TMEM198 rna"
  ],
  "TMEM198B": [
    "TMEM198B methyl"
  ],
  "TMEM199": [
    "TMEM199 cnv",
    "TMEM199 methyl",
    "TMEM199 proteo",
    "TMEM199 rna"
  ],
  "TMEM200A": [
    "TMEM200A cnv",
    "TMEM200A methyl",
    "TMEM200A rna"
  ],
  "TMEM200B": [
    "TMEM200B cnv",
    "TMEM200B methyl",
    "TMEM200B rna"
  ],
  "TMEM200C": [
    "TMEM200C 301_308_1_1_S301 phospho",
    "TMEM200C cnv",
    "TMEM200C methyl",
    "TMEM200C rna"
  ],
  "TMEM201": [
    "TMEM201 440_444_1_1_S441 phospho",
    "TMEM201 cnv",
    "TMEM201 methyl",
    "TMEM201 proteo",
    "TMEM201 rna"
  ],
  "TMEM202": [
    "TMEM202 cnv"
  ],
  "TMEM202-AS1": [
    "TMEM202-AS1 methyl"
  ],
  "TMEM203": [
    "TMEM203 cnv",
    "TMEM203 methyl",
    "TMEM203 rna"
  ],
  "TMEM204": [
    "TMEM204 cnv",
    "TMEM204 methyl",
    "TMEM204 rna"
  ],
  "TMEM205": [
    "TMEM205 cnv",
    "TMEM205 methyl",
    "TMEM205 proteo",
    "TMEM205 rna"
  ],
  "TMEM207": [
    "TMEM207 cnv"
  ],
  "TMEM208": [
    "TMEM208 cnv",
    "TMEM208 methyl",
    "TMEM208 rna"
  ],
  "TMEM209": [
    "TMEM209 cnv",
    "TMEM209 methyl",
    "TMEM209 proteo",
    "TMEM209 rna"
  ],
  "TMEM210": [
    "TMEM210 cnv",
    "TMEM210 rna"
  ],
  "TMEM212": [
    "TMEM212 cnv",
    "TMEM212 rna"
  ],
  "TMEM213": [
    "TMEM213 cnv",
    "TMEM213 rna"
  ],
  "TMEM214": [
    "TMEM214 cnv",
    "TMEM214 methyl",
    "TMEM214 proteo",
    "TMEM214 rna"
  ],
  "TMEM215": [
    "TMEM215 cnv",
    "TMEM215 methyl",
    "TMEM215 rna"
  ],
  "TMEM216": [
    "TMEM216 cnv",
    "TMEM216 methyl",
    "TMEM216 rna"
  ],
  "TMEM217": [
    "TMEM217 cnv",
    "TMEM217 methyl",
    "TMEM217 rna"
  ],
  "TMEM217B": [
    "TMEM217B cnv",
    "TMEM217B rna"
  ],
  "TMEM218": [
    "TMEM218 cnv",
    "TMEM218 methyl",
    "TMEM218 rna"
  ],
  "TMEM219": [
    "TMEM219 cnv",
    "TMEM219 methyl",
    "TMEM219 rna"
  ],
  "TMEM220": [
    "TMEM220 cnv",
    "TMEM220 methyl",
    "TMEM220 rna"
  ],
  "TMEM220-AS1": [
    "TMEM220-AS1 methyl"
  ],
  "TMEM221": [
    "TMEM221 cnv",
    "TMEM221 methyl",
    "TMEM221 proteo",
    "TMEM221 rna"
  ],
  "TMEM222": [
    "TMEM222 cnv",
    "TMEM222 methyl",
    "TMEM222 proteo",
    "TMEM222 rna"
  ],
  "TMEM223": [
    "TMEM223 cnv",
    "TMEM223 methyl",
    "TMEM223 proteo",
    "TMEM223 rna"
  ],
  "TMEM225": [
    "TMEM225 cnv"
  ],
  "TMEM225B": [
    "TMEM225B cnv",
    "TMEM225B methyl",
    "TMEM225B rna"
  ],
  "TMEM229A": [
    "TMEM229A 4_8_1_1_S4 phospho",
    "TMEM229A cnv",
    "TMEM229A methyl",
    "TMEM229A rna"
  ],
  "TMEM229B": [
    "TMEM229B cnv",
    "TMEM229B methyl",
    "TMEM229B rna"
  ],
  "TMEM230": [
    "TMEM230 69_78_1_1_S77 phospho",
    "TMEM230 cnv",
    "TMEM230 methyl",
    "TMEM230 proteo",
    "TMEM230 rna"
  ],
  "TMEM231": [
    "TMEM231 cnv",
    "TMEM231 methyl",
    "TMEM231 proteo",
    "TMEM231 rna"
  ],
  "TMEM232": [
    "TMEM232 cnv",
    "TMEM232 methyl",
    "TMEM232 rna"
  ],
  "TMEM233": [
    "TMEM233 cnv",
    "TMEM233 methyl",
    "TMEM233 rna"
  ],
  "TMEM234": [
    "TMEM234 cnv",
    "TMEM234 methyl",
    "TMEM234 rna"
  ],
  "TMEM235": [
    "TMEM235 cnv",
    "TMEM235 rna"
  ],
  "TMEM236": [
    "TMEM236 cnv",
    "TMEM236 rna"
  ],
  "TMEM237": [
    "TMEM237 44_56_1_1_S49 phospho",
    "TMEM237 62_69_1_1_S62 phospho",
    "TMEM237 cnv",
    "TMEM237 methyl",
    "TMEM237 proteo",
    "TMEM237 rna"
  ],
  "TMEM238": [
    "TMEM238 cnv",
    "TMEM238 methyl",
    "TMEM238 rna"
  ],
  "TMEM238L": [
    "TMEM238L cnv",
    "TMEM238L rna"
  ],
  "TMEM239": [
    "TMEM239 cnv",
    "TMEM239 rna"
  ],
  "TMEM240": [
    "TMEM240 163_169_1_1_S169 phospho",
    "TMEM240 cnv",
    "TMEM240 methyl",
    "TMEM240 proteo",
    "TMEM240 rna"
  ],
  "TMEM241": [
    "TMEM241 cnv",
    "TMEM241 methyl",
    "TMEM241 rna"
  ],
  "TMEM242": [
    "TMEM242 cnv",
    "TMEM242 methyl",
    "TMEM242 rna"
  ],
  "TMEM243": [
    "TMEM243 cnv",
    "TMEM243 methyl",
    "TMEM243 rna"
  ],
  "TMEM244": [
    "TMEM244 cnv",
    "TMEM244 rna"
  ],
  "TMEM245": [
    "TMEM245 12_16_1_1_S16 phospho",
    "TMEM245 313_334_1_1_S332 phospho",
    "TMEM245 cnv",
    "TMEM245 methyl",
    "TMEM245 proteo",
    "TMEM245 rna"
  ],
  "TMEM247": [
    "TMEM247 cnv"
  ],
  "TMEM248": [
    "TMEM248 cnv",
    "TMEM248 methyl",
    "TMEM248 rna"
  ],
  "TMEM249": [
    "TMEM249 cnv",
    "TMEM249 methyl",
    "TMEM249 rna"
  ],
  "TMEM25": [
    "TMEM25 253_267_1_1_S253 phospho",
    "TMEM25 cnv",
    "TMEM25 methyl",
    "TMEM25 rna"
  ],
  "TMEM250": [
    "TMEM250 cnv",
    "TMEM250 methyl",
    "TMEM250 rna"
  ],
  "TMEM251": [
    "TMEM251 cnv",
    "TMEM251 methyl",
    "TMEM251 rna"
  ],
  "TMEM252": [
    "TMEM252 cnv",
    "TMEM252 rna"
  ],
  "TMEM253": [
    "TMEM253 cnv",
    "TMEM253 methyl",
    "TMEM253 rna"
  ],
  "TMEM254": [
    "TMEM254 cnv",
    "TMEM254 methyl",
    "TMEM254 rna"
  ],
  "TMEM255A": [
    "TMEM255A methyl",
    "TMEM255A proteo",
    "TMEM255A rna"
  ],
  "TMEM255B": [
    "TMEM255B cnv",
    "TMEM255B rna"
  ],
  "TMEM256": [
    "TMEM256 cnv",
    "TMEM256 methyl",
    "TMEM256 rna"
  ],
  "TMEM256-PLSCR3": [
    "TMEM256-PLSCR3 cnv",
    "TMEM256-PLSCR3 rna"
  ],
  "TMEM258": [
    "TMEM258 cnv",
    "TMEM258 methyl",
    "TMEM258 rna"
  ],
  "TMEM259": [
    "TMEM259 cnv",
    "TMEM259 methyl",
    "TMEM259 proteo",
    "TMEM259 rna"
  ],
  "TMEM26": [
    "TMEM26 cnv",
    "TMEM26 methyl",
    "TMEM26 rna"
  ],
  "TMEM260": [
    "TMEM260 cnv",
    "TMEM260 methyl",
    "TMEM260 rna"
  ],
  "TMEM262": [
    "TMEM262 cnv",
    "TMEM262 rna"
  ],
  "TMEM263": [
    "TMEM263 cnv",
    "TMEM263 methyl",
    "TMEM263 proteo",
    "TMEM263 rna"
  ],
  "TMEM265": [
    "TMEM265 cnv",
    "TMEM265 rna"
  ],
  "TMEM266": [
    "TMEM266 cnv",
    "TMEM266 methyl",
    "TMEM266 rna"
  ],
  "TMEM267": [
    "TMEM267 cnv",
    "TMEM267 methyl",
    "TMEM267 rna"
  ],
  "TMEM268": [
    "TMEM268 cnv",
    "TMEM268 methyl",
    "TMEM268 rna"
  ],
  "TMEM269": [
    "TMEM269 cnv",
    "TMEM269 rna"
  ],
  "TMEM270": [
    "TMEM270 cnv",
    "TMEM270 rna"
  ],
  "TMEM271": [
    "TMEM271 cnv",
    "TMEM271 methyl",
    "TMEM271 rna"
  ],
  "TMEM272": [
    "TMEM272 cnv",
    "TMEM272 rna"
  ],
  "TMEM273": [
    "TMEM273 cnv",
    "TMEM273 rna"
  ],
  "TMEM275": [
    "TMEM275 cnv",
    "TMEM275 methyl",
    "TMEM275 rna"
  ],
  "TMEM30A": [
    "TMEM30A YSLNVTYNYPVHYFDGR-N2H5F0S0G0 glyco",
    "TMEM30A cnv",
    "TMEM30A methyl",
    "TMEM30A proteo",
    "TMEM30A rna"
  ],
  "TMEM30B": [
    "TMEM30B cnv",
    "TMEM30B methyl",
    "TMEM30B rna"
  ],
  "TMEM31": [
    "TMEM31 rna"
  ],
  "TMEM33": [
    "TMEM33 cnv",
    "TMEM33 methyl",
    "TMEM33 proteo",
    "TMEM33 rna"
  ],
  "TMEM35A": [
    "TMEM35A 154_156_1_1_S154 phospho",
    "TMEM35A proteo",
    "TMEM35A rna"
  ],
  "TMEM35B": [
    "TMEM35B cnv",
    "TMEM35B methyl",
    "TMEM35B rna"
  ],
  "TMEM37": [
    "TMEM37 cnv",
    "TMEM37 methyl",
    "TMEM37 rna"
  ],
  "TMEM38A": [
    "TMEM38A cnv",
    "TMEM38A methyl",
    "TMEM38A rna"
  ],
  "TMEM38B": [
    "TMEM38B cnv",
    "TMEM38B methyl",
    "TMEM38B rna"
  ],
  "TMEM39A": [
    "TMEM39A cnv",
    "TMEM39A methyl",
    "TMEM39A rna"
  ],
  "TMEM39B": [
    "TMEM39B cnv",
    "TMEM39B methyl",
    "TMEM39B rna"
  ],
  "TMEM40": [
    "TMEM40 153_163_1_1_S153 phospho",
    "TMEM40 cnv",
    "TMEM40 rna"
  ],
  "TMEM41A": [
    "TMEM41A cnv",
    "TMEM41A methyl",
    "TMEM41A rna"
  ],
  "TMEM41B": [
    "TMEM41B cnv",
    "TMEM41B methyl",
    "TMEM41B proteo",
    "TMEM41B rna"
  ],
  "TMEM42": [
    "TMEM42 cnv",
    "TMEM42 methyl",
    "TMEM42 rna"
  ],
  "TMEM43": [
    "TMEM43 cnv",
    "TMEM43 methyl",
    "TMEM43 proteo",
    "TMEM43 rna"
  ],
  "TMEM44": [
    "TMEM44 421_425_1_1_S425 phospho",
    "TMEM44 cnv",
    "TMEM44 methyl",
    "TMEM44 rna"
  ],
  "TMEM45A": [
    "TMEM45A cnv",
    "TMEM45A methyl",
    "TMEM45A rna"
  ],
  "TMEM45B": [
    "TMEM45B cnv",
    "TMEM45B methyl",
    "TMEM45B rna"
  ],
  "TMEM47": [
    "TMEM47 methyl",
    "TMEM47 rna"
  ],
  "TMEM50A": [
    "TMEM50A cnv",
    "TMEM50A methyl",
    "TMEM50A rna"
  ],
  "TMEM50B": [
    "TMEM50B cnv",
    "TMEM50B methyl",
    "TMEM50B rna"
  ],
  "TMEM51": [
    "TMEM51 104_127_1_1_S115 phospho",
    "TMEM51 182_182_1_1_S182 phospho",
    "TMEM51 182_192_1_1_S192 phospho",
    "TMEM51 229_239_1_1_T234 phospho",
    "TMEM51 cnv",
    "TMEM51 methyl",
    "TMEM51 rna"
  ],
  "TMEM51-AS1": [
    "TMEM51-AS1 methyl"
  ],
  "TMEM52": [
    "TMEM52 cnv",
    "TMEM52 methyl",
    "TMEM52 rna"
  ],
  "TMEM52B": [
    "TMEM52B cnv",
    "TMEM52B rna"
  ],
  "TMEM53": [
    "TMEM53 cnv",
    "TMEM53 methyl",
    "TMEM53 rna"
  ],
  "TMEM54": [
    "TMEM54 cnv",
    "TMEM54 methyl",
    "TMEM54 rna"
  ],
  "TMEM59": [
    "TMEM59 cnv",
    "TMEM59 methyl",
    "TMEM59 rna"
  ],
  "TMEM59L": [
    "TMEM59L cnv",
    "TMEM59L methyl",
    "TMEM59L rna"
  ],
  "TMEM60": [
    "TMEM60 cnv",
    "TMEM60 methyl",
    "TMEM60 rna"
  ],
  "TMEM61": [
    "TMEM61 cnv",
    "TMEM61 methyl",
    "TMEM61 rna"
  ],
  "TMEM62": [
    "TMEM62 cnv",
    "TMEM62 methyl",
    "TMEM62 rna"
  ],
  "TMEM63A": [
    "TMEM63A cnv",
    "TMEM63A methyl",
    "TMEM63A proteo",
    "TMEM63A rna"
  ],
  "TMEM63B": [
    "TMEM63B 110_115_1_1_S111 phospho",
    "TMEM63B 110_115_1_1_S114 phospho",
    "TMEM63B cnv",
    "TMEM63B methyl",
    "TMEM63B proteo",
    "TMEM63B rna"
  ],
  "TMEM63C": [
    "TMEM63C cnv",
    "TMEM63C methyl",
    "TMEM63C rna"
  ],
  "TMEM64": [
    "TMEM64 cnv",
    "TMEM64 methyl",
    "TMEM64 rna"
  ],
  "TMEM65": [
    "TMEM65 cnv",
    "TMEM65 methyl",
    "TMEM65 proteo",
    "TMEM65 rna"
  ],
  "TMEM67": [
    "TMEM67 cnv",
    "TMEM67 methyl",
    "TMEM67 proteo",
    "TMEM67 rna"
  ],
  "TMEM68": [
    "TMEM68 cnv",
    "TMEM68 methyl",
    "TMEM68 proteo",
    "TMEM68 rna"
  ],
  "TMEM69": [
    "TMEM69 cnv",
    "TMEM69 methyl",
    "TMEM69 rna"
  ],
  "TMEM70": [
    "TMEM70 cnv",
    "TMEM70 methyl",
    "TMEM70 proteo",
    "TMEM70 rna"
  ],
  "TMEM71": [
    "TMEM71 cnv",
    "TMEM71 rna"
  ],
  "TMEM72": [
    "TMEM72 cnv",
    "TMEM72 rna"
  ],
  "TMEM72-AS1": [
    "TMEM72-AS1 methyl"
  ],
  "TMEM74": [
    "TMEM74 cnv",
    "TMEM74 methyl",
    "TMEM74 rna"
  ],
  "TMEM74B": [
    "TMEM74B cnv",
    "TMEM74B methyl",
    "TMEM74B rna"
  ],
  "TMEM78": [
    "TMEM78 cnv",
    "TMEM78 rna"
  ],
  "TMEM79": [
    "TMEM79 cnv",
    "TMEM79 methyl",
    "TMEM79 rna"
  ],
  "TMEM80": [
    "TMEM80 cnv",
    "TMEM80 methyl",
    "TMEM80 rna"
  ],
  "TMEM81": [
    "TMEM81 cnv",
    "TMEM81 rna"
  ],
  "TMEM82": [
    "TMEM82 cnv",
    "TMEM82 rna"
  ],
  "TMEM86A": [
    "TMEM86A cnv",
    "TMEM86A methyl",
    "TMEM86A rna"
  ],
  "TMEM86B": [
    "TMEM86B cnv",
    "TMEM86B rna"
  ],
  "TMEM87A": [
    "TMEM87A NTTIFLK-N3H6F0S1G0 glyco",
    "TMEM87A NTTIFLK-N3H6F1S0G0 glyco",
    "TMEM87A cnv",
    "TMEM87A methyl",
    "TMEM87A proteo",
    "TMEM87A rna"
  ],
  "TMEM87B": [
    "TMEM87B 494_505_1_1_S494 phospho",
    "TMEM87B cnv",
    "TMEM87B methyl",
    "TMEM87B proteo",
    "TMEM87B rna"
  ],
  "TMEM88": [
    "TMEM88 cnv",
    "TMEM88 methyl",
    "TMEM88 rna"
  ],
  "TMEM88B": [
    "TMEM88B cnv",
    "TMEM88B proteo",
    "TMEM88B rna"
  ],
  "TMEM89": [
    "TMEM89 cnv",
    "TMEM89 rna"
  ],
  "TMEM8B": [
    "TMEM8B cnv",
    "TMEM8B methyl",
    "TMEM8B rna"
  ],
  "TMEM9": [
    "TMEM9 NISGHIYNQNVSQK-N2H6F0S0G0 glyco",
    "TMEM9 cnv",
    "TMEM9 methyl",
    "TMEM9 proteo",
    "TMEM9 rna"
  ],
  "TMEM91": [
    "TMEM91 cnv",
    "TMEM91 methyl",
    "TMEM91 rna"
  ],
  "TMEM92": [
    "TMEM92 cnv",
    "TMEM92 rna"
  ],
  "TMEM94": [
    "TMEM94 1364_1364_1_1_S1364 phospho",
    "TMEM94 454_465_1_1_S455 phospho",
    "TMEM94 801_805_1_1_S802 phospho",
    "TMEM94 cnv",
    "TMEM94 proteo",
    "TMEM94 rna"
  ],
  "TMEM95": [
    "TMEM95 cnv",
    "TMEM95 rna"
  ],
  "TMEM97": [
    "TMEM97 cnv",
    "TMEM97 methyl",
    "TMEM97 proteo",
    "TMEM97 rna"
  ],
  "TMEM98": [
    "TMEM98 cnv",
    "TMEM98 methyl",
    "TMEM98 rna"
  ],
  "TMEM9B": [
    "TMEM9B cnv",
    "TMEM9B methyl",
    "TMEM9B proteo",
    "TMEM9B rna"
  ],
  "TMEM9B-AS1": [
    "TMEM9B-AS1 methyl"
  ],
  "TMF1": [
    "TMF1 338_349_1_1_S344 phospho",
    "TMF1 399_422_1_1_T401 phospho",
    "TMF1 cnv",
    "TMF1 methyl",
    "TMF1 proteo",
    "TMF1 rna"
  ],
  "TMIE": [
    "TMIE cnv",
    "TMIE methyl",
    "TMIE rna"
  ],
  "TMIGD1": [
    "TMIGD1 cnv"
  ],
  "TMIGD2": [
    "TMIGD2 cnv",
    "TMIGD2 rna"
  ],
  "TMIGD3": [
    "TMIGD3 cnv",
    "TMIGD3 rna"
  ],
  "TMLHE": [
    "TMLHE methyl",
    "TMLHE proteo",
    "TMLHE rna"
  ],
  "TMOD1": [
    "TMOD1 cnv",
    "TMOD1 methyl",
    "TMOD1 proteo",
    "TMOD1 rna"
  ],
  "TMOD2": [
    "TMOD2 cnv",
    "TMOD2 methyl",
    "TMOD2 proteo",
    "TMOD2 rna"
  ],
  "TMOD3": [
    "TMOD3 cnv",
    "TMOD3 methyl",
    "TMOD3 proteo",
    "TMOD3 rna"
  ],
  "TMOD4": [
    "TMOD4 cnv",
    "TMOD4 rna"
  ],
  "TMPO": [
    "TMPO 154_172_2_2_S159T160 phospho",
    "TMPO 158_172_1_1_T160 phospho",
    "TMPO 177_184_1_1_S184 phospho",
    "TMPO 177_190_1_1_S184 phospho",
    "TMPO 177_190_2_2_S180S184 phospho",
    "TMPO 345_355_1_1_S351 phospho",
    "TMPO 66_79_1_1_T74 phospho",
    "TMPO 66_79_2_2_S66S67 phospho",
    "TMPO 66_79_3_3_S66S67T74 phospho",
    "TMPO cnv",
    "TMPO methyl",
    "TMPO proteo",
    "TMPO rna"
  ],
  "TMPO-AS1": [
    "TMPO-AS1 methyl"
  ],
  "TMPPE": [
    "TMPPE cnv",
    "TMPPE methyl",
    "TMPPE proteo",
    "TMPPE rna"
  ],
  "TMPRSS11A": [
    "TMPRSS11A cnv",
    "TMPRSS11A rna"
  ],
  "TMPRSS11B": [
    "TMPRSS11B cnv",
    "TMPRSS11B rna"
  ],
  "TMPRSS11D": [
    "TMPRSS11D cnv",
    "TMPRSS11D rna"
  ],
  "TMPRSS11E": [
    "TMPRSS11E cnv",
    "TMPRSS11E rna"
  ],
  "TMPRSS11F": [
    "TMPRSS11F cnv",
    "TMPRSS11F rna"
  ],
  "TMPRSS12": [
    "TMPRSS12 cnv",
    "TMPRSS12 methyl",
    "TMPRSS12 rna"
  ],
  "TMPRSS13": [
    "TMPRSS13 cnv",
    "TMPRSS13 rna"
  ],
  "TMPRSS15": [
    "TMPRSS15 cnv",
    "TMPRSS15 rna"
  ],
  "TMPRSS2": [
    "TMPRSS2 cnv",
    "TMPRSS2 methyl",
    "TMPRSS2 rna"
  ],
  "TMPRSS3": [
    "TMPRSS3 cnv",
    "TMPRSS3 rna"
  ],
  "TMPRSS4": [
    "TMPRSS4 cnv",
    "TMPRSS4 rna"
  ],
  "TMPRSS5": [
    "TMPRSS5 cnv",
    "TMPRSS5 proteo",
    "TMPRSS5 rna"
  ],
  "TMPRSS6": [
    "TMPRSS6 cnv",
    "TMPRSS6 rna"
  ],
  "TMPRSS7": [
    "TMPRSS7 cnv",
    "TMPRSS7 rna"
  ],
  "TMPRSS9": [
    "TMPRSS9 cnv",
    "TMPRSS9 methyl",
    "TMPRSS9 rna"
  ],
  "TMSB10": [
    "TMSB10 cnv",
    "TMSB10 methyl",
    "TMSB10 proteo",
    "TMSB10 rna"
  ],
  "TMSB15A": [
    "TMSB15A methyl",
    "TMSB15A rna"
  ],
  "TMSB15B": [
    "TMSB15B methyl",
    "TMSB15B proteo",
    "TMSB15B rna"
  ],
  "TMSB4X": [
    "TMSB4X 31_34_1_1_T34 phospho",
    "TMSB4X 31_44_1_1_S44 phospho",
    "TMSB4X methyl",
    "TMSB4X proteo",
    "TMSB4X rna"
  ],
  "TMSB4Y": [
    "TMSB4Y methyl",
    "TMSB4Y rna"
  ],
  "TMTC1": [
    "TMTC1 cnv",
    "TMTC1 methyl",
    "TMTC1 rna"
  ],
  "TMTC2": [
    "TMTC2 cnv",
    "TMTC2 methyl",
    "TMTC2 rna"
  ],
  "TMTC3": [
    "TMTC3 cnv",
    "TMTC3 methyl",
    "TMTC3 proteo",
    "TMTC3 rna"
  ],
  "TMTC4": [
    "TMTC4 cnv",
    "TMTC4 methyl",
    "TMTC4 proteo",
    "TMTC4 rna"
  ],
  "TMUB1": [
    "TMUB1 cnv",
    "TMUB1 methyl",
    "TMUB1 proteo",
    "TMUB1 rna"
  ],
  "TMUB2": [
    "TMUB2 cnv",
    "TMUB2 methyl",
    "TMUB2 proteo",
    "TMUB2 rna"
  ],
  "TMX1": [
    "TMX1 226_228_1_1_S226 phospho",
    "TMX1 226_253_1_1_S247 phospho",
    "TMX1 247_253_1_1_S247 phospho",
    "TMX1 247_257_1_1_S247 phospho",
    "TMX1 270_277_1_1_S270 phospho",
    "TMX1 cnv",
    "TMX1 methyl",
    "TMX1 proteo",
    "TMX1 rna"
  ],
  "TMX2": [
    "TMX2 cnv",
    "TMX2 methyl",
    "TMX2 proteo",
    "TMX2 rna"
  ],
  "TMX3": [
    "TMX3 LVALAVIDEKNTSVEHTR-N2H5F0S0G0 glyco",
    "TMX3 LVALAVIDEKNTSVEHTR-N2H6F0S0G0 glyco",
    "TMX3 LVALAVIDEKNTSVEHTR-N2H7F0S0G0 glyco",
    "TMX3 LVALAVIDEKNTSVEHTR-N2H8F0S0G0 glyco",
    "TMX3 NTSVEHTR-N2H6F0S0G0 glyco",
    "TMX3 NTSVEHTR-N2H7F0S0G0 glyco",
    "TMX3 cnv",
    "TMX3 methyl",
    "TMX3 proteo",
    "TMX3 rna"
  ],
  "TMX4": [
    "TMX4 251_259_2_2_S251S259 phospho",
    "TMX4 cnv",
    "TMX4 methyl",
    "TMX4 proteo",
    "TMX4 rna"
  ],
  "TNC": [
    "TNC 62_101_1_0 phospho",
    "TNC 62_101_1_1_S72 phospho",
    "TNC 62_72_1_1_S72 phospho",
    "TNC 62_72_2_2_S65S72 phospho",
    "TNC 62_72_2_2_S70S72 phospho",
    "TNC 903_910_1_1_S903 phospho",
    "TNC CINGTCYCEEGFTGEDCGKPTCPHACHTQGR-N4H5F1S1G0 glyco",
    "TNC CINGTCYCEEGFTGEDCGKPTCPHACHTQGR-N5H5F1S1G0 glyco",
    "TNC GPNCSEPECPGNCHLR-N2H5F0S0G0 glyco",
    "TNC LLETVEYNISGAER-N2H6F0S0G0 glyco",
    "TNC LLETVEYNISGAER-N2H8F0S0G0 glyco",
    "TNC LNYSLPTGQWVGVQLPR-N2H3F0S0G0 glyco",
    "TNC LNYSLPTGQWVGVQLPR-N2H4F0S0G0 glyco",
    "TNC LNYSLPTGQWVGVQLPR-N2H5F0S0G0 glyco",
    "TNC LNYSLPTGQWVGVQLPR-N2H6F0S0G0 glyco",
    "TNC LNYSLPTGQWVGVQLPR-N2H7F0S0G0 glyco",
    "TNC LNYSLPTGQWVGVQLPR-N2H8F0S0G0 glyco",
    "TNC LNYSLPTGQWVGVQLPR-N2H9F0S0G0 glyco",
    "TNC NTTSYVLR-N2H4F0S0G0 glyco",
    "TNC SFNMSWTTQAGLFAK-N2H5F0S0G0 glyco",
    "TNC VEAAQNLTLPGSLR-N4H5F1S1G0 glyco",
    "TNC VEAAQNLTLPGSLR-N5H4F1S0G0 glyco",
    "TNC VEAAQNLTLPGSLR-N5H4F2S0G0 glyco",
    "TNC YRLNYSLPTGQWVGVQLPR-N2H5F0S0G0 glyco",
    "TNC cnv",
    "TNC proteo",
    "TNC rna"
  ],
  "TNF": [
    "TNF cnv",
    "TNF rna"
  ],
  "TNFAIP1": [
    "TNFAIP1 cnv",
    "TNFAIP1 methyl",
    "TNFAIP1 proteo",
    "TNFAIP1 rna"
  ],
  "TNFAIP2": [
    "TNFAIP2 cnv",
    "TNFAIP2 methyl",
    "TNFAIP2 proteo",
    "TNFAIP2 rna"
  ],
  "TNFAIP3": [
    "TNFAIP3 573_578_1_1_S575 phospho",
    "TNFAIP3 cnv",
    "TNFAIP3 methyl",
    "TNFAIP3 proteo",
    "TNFAIP3 rna"
  ],
  "TNFAIP6": [
    "TNFAIP6 cnv",
    "TNFAIP6 rna"
  ],
  "TNFAIP8": [
    "TNFAIP8 cnv",
    "TNFAIP8 methyl",
    "TNFAIP8 proteo",
    "TNFAIP8 rna"
  ],
  "TNFAIP8L1": [
    "TNFAIP8L1 cnv",
    "TNFAIP8L1 methyl",
    "TNFAIP8L1 rna"
  ],
  "TNFAIP8L2": [
    "TNFAIP8L2 cnv",
    "TNFAIP8L2 proteo",
    "TNFAIP8L2 rna"
  ],
  "TNFAIP8L3": [
    "TNFAIP8L3 cnv",
    "TNFAIP8L3 methyl",
    "TNFAIP8L3 proteo",
    "TNFAIP8L3 rna"
  ],
  "TNFRSF10A": [
    "TNFRSF10A cnv",
    "TNFRSF10A methyl",
    "TNFRSF10A rna"
  ],
  "TNFRSF10A-DT": [
    "TNFRSF10A-DT methyl"
  ],
  "TNFRSF10B": [
    "TNFRSF10B cnv",
    "TNFRSF10B methyl",
    "TNFRSF10B rna"
  ],
  "TNFRSF10C": [
    "TNFRSF10C cnv",
    "TNFRSF10C methyl",
    "TNFRSF10C proteo",
    "TNFRSF10C rna"
  ],
  "TNFRSF10D": [
    "TNFRSF10D cnv",
    "TNFRSF10D methyl",
    "TNFRSF10D rna"
  ],
  "TNFRSF11A": [
    "TNFRSF11A cnv",
    "TNFRSF11A methyl",
    "TNFRSF11A rna"
  ],
  "TNFRSF11B": [
    "TNFRSF11B cnv",
    "TNFRSF11B methyl",
    "TNFRSF11B rna"
  ],
  "TNFRSF12A": [
    "TNFRSF12A cnv",
    "TNFRSF12A methyl",
    "TNFRSF12A rna"
  ],
  "TNFRSF13B": [
    "TNFRSF13B cnv",
    "TNFRSF13B rna"
  ],
  "TNFRSF13C": [
    "TNFRSF13C cnv",
    "TNFRSF13C rna"
  ],
  "TNFRSF14": [
    "TNFRSF14 cnv",
    "TNFRSF14 rna"
  ],
  "TNFRSF17": [
    "TNFRSF17 cnv",
    "TNFRSF17 rna"
  ],
  "TNFRSF18": [
    "TNFRSF18 cnv",
    "TNFRSF18 methyl",
    "TNFRSF18 rna"
  ],
  "TNFRSF19": [
    "TNFRSF19 241_244_1_1_S241 phospho",
    "TNFRSF19 cnv",
    "TNFRSF19 methyl",
    "TNFRSF19 rna"
  ],
  "TNFRSF1A": [
    "TNFRSF1A cnv",
    "TNFRSF1A proteo",
    "TNFRSF1A rna"
  ],
  "TNFRSF1B": [
    "TNFRSF1B cnv",
    "TNFRSF1B methyl",
    "TNFRSF1B rna"
  ],
  "TNFRSF21": [
    "TNFRSF21 533_541_1_1_S541 phospho",
    "TNFRSF21 cnv",
    "TNFRSF21 methyl",
    "TNFRSF21 proteo",
    "TNFRSF21 rna"
  ],
  "TNFRSF25": [
    "TNFRSF25 cnv",
    "TNFRSF25 methyl",
    "TNFRSF25 rna"
  ],
  "TNFRSF4": [
    "TNFRSF4 cnv",
    "TNFRSF4 methyl",
    "TNFRSF4 rna"
  ],
  "TNFRSF6B": [
    "TNFRSF6B cnv",
    "TNFRSF6B methyl",
    "TNFRSF6B rna"
  ],
  "TNFRSF8": [
    "TNFRSF8 cnv",
    "TNFRSF8 methyl",
    "TNFRSF8 rna"
  ],
  "TNFRSF9": [
    "TNFRSF9 cnv",
    "TNFRSF9 rna"
  ],
  "TNFSF10": [
    "TNFSF10 cnv",
    "TNFSF10 rna"
  ],
  "TNFSF11": [
    "TNFSF11 cnv",
    "TNFSF11 rna"
  ],
  "TNFSF12": [
    "TNFSF12 cnv",
    "TNFSF12 methyl",
    "TNFSF12 rna"
  ],
  "TNFSF12-TNFSF13": [
    "TNFSF12-TNFSF13 cnv",
    "TNFSF12-TNFSF13 methyl",
    "TNFSF12-TNFSF13 rna"
  ],
  "TNFSF13": [
    "TNFSF13 cnv",
    "TNFSF13 rna"
  ],
  "TNFSF13B": [
    "TNFSF13B cnv",
    "TNFSF13B rna"
  ],
  "TNFSF14": [
    "TNFSF14 cnv",
    "TNFSF14 rna"
  ],
  "TNFSF15": [
    "TNFSF15 cnv",
    "TNFSF15 rna"
  ],
  "TNFSF18": [
    "TNFSF18 cnv",
    "TNFSF18 rna"
  ],
  "TNFSF4": [
    "TNFSF4 cnv",
    "TNFSF4 rna"
  ],
  "TNFSF8": [
    "TNFSF8 cnv",
    "TNFSF8 rna"
  ],
  "TNFSF9": [
    "TNFSF9 cnv",
    "TNFSF9 methyl",
    "TNFSF9 rna"
  ],
  "TNIK": [
    "TNIK 1013_1028_1_1_S1013 phospho",
    "TNIK 499_502_1_1_S502 phospho",
    "TNIK 547_548_1_1_S548 phospho",
    "TNIK 568_581_1_1_T581 phospho",
    "TNIK 600_616_1_1_S610 phospho",
    "TNIK 620_630_1_1_T629 phospho",
    "TNIK 640_651_1_1_S640 phospho",
    "TNIK 688_693_1_1_S688 phospho",
    "TNIK 701_707_1_1_S707 phospho",
    "TNIK 764_769_1_1_S764 phospho",
    "TNIK 764_769_2_2_S764S769 phospho",
    "TNIK 766_769_1_1_S769 phospho",
    "TNIK 943_961_1_1_S946 phospho",
    "TNIK cnv",
    "TNIK kinase",
    "TNIK methyl",
    "TNIK proteo",
    "TNIK rna"
  ],
  "TNIP1": [
    "TNIP1 cnv",
    "TNIP1 methyl",
    "TNIP1 proteo",
    "TNIP1 rna"
  ],
  "TNIP2": [
    "TNIP2 cnv",
    "TNIP2 methyl",
    "TNIP2 proteo",
    "TNIP2 rna"
  ],
  "TNIP3": [
    "TNIP3 cnv",
    "TNIP3 rna"
  ],
  "TNK1": [
    "TNK1 cnv",
    "TNK1 kinase",
    "TNK1 methyl",
    "TNK1 rna"
  ],
  "TNK2": [
    "TNK2 cnv",
    "TNK2 kinase",
    "TNK2 methyl",
    "TNK2 proteo",
    "TNK2 rna"
  ],
  "TNKS": [
    "TNKS cnv",
    "TNKS methyl",
    "TNKS proteo",
    "TNKS rna"
  ],
  "TNKS1BP1": [
    "TNKS1BP1 1024_1032_1_1_S1024 phospho",
    "TNKS1BP1 1297_1301_1_1_S1297 phospho",
    "TNKS1BP1 1383_1385_2_2_S1383S1385 phospho",
    "TNKS1BP1 1545_1545_1_1_S1545 phospho",
    "TNKS1BP1 1552_1571_1_1_S1554 phospho",
    "TNKS1BP1 1616_1631_2_2_S1620S1621 phospho",
    "TNKS1BP1 1620_1631_2_2_S1620S1621 phospho",
    "TNKS1BP1 1652_1654_1_1_S1652 phospho",
    "TNKS1BP1 1689_1689_1_1_S1689 phospho",
    "TNKS1BP1 351_387_1_0 phospho",
    "TNKS1BP1 429_437_1_1_S429 phospho",
    "TNKS1BP1 429_437_1_1_S435 phospho",
    "TNKS1BP1 494_519_2_2_S494S498 phospho",
    "TNKS1BP1 590_607_1_1_S601 phospho",
    "TNKS1BP1 663_682_1_1_S672 phospho",
    "TNKS1BP1 672_682_1_1_S672 phospho",
    "TNKS1BP1 710_724_1_0 phospho",
    "TNKS1BP1 710_724_1_1_S714 phospho",
    "TNKS1BP1 833_836_1_1_S836 phospho",
    "TNKS1BP1 836_836_1_1_S836 phospho",
    "TNKS1BP1 872_878_1_1_S872 phospho",
    "TNKS1BP1 918_920_1_1_S920 phospho",
    "TNKS1BP1 976_987_1_1_S983 phospho",
    "TNKS1BP1 976_987_1_1_S987 phospho",
    "TNKS1BP1 cnv",
    "TNKS1BP1 methyl",
    "TNKS1BP1 proteo",
    "TNKS1BP1 rna"
  ],
  "TNKS2": [
    "TNKS2 cnv",
    "TNKS2 methyl",
    "TNKS2 proteo",
    "TNKS2 rna"
  ],
  "TNKS2-DT": [
    "TNKS2-DT methyl"
  ],
  "TNMD": [
    "TNMD rna"
  ],
  "TNN": [
    "TNN cnv",
    "TNN proteo",
    "TNN rna"
  ],
  "TNNC1": [
    "TNNC1 cnv",
    "TNNC1 rna"
  ],
  "TNNC2": [
    "TNNC2 cnv",
    "TNNC2 methyl",
    "TNNC2 rna"
  ],
  "TNNI1": [
    "TNNI1 cnv",
    "TNNI1 rna"
  ],
  "TNNI2": [
    "TNNI2 cnv",
    "TNNI2 rna"
  ],
  "TNNI3": [
    "TNNI3 cnv",
    "TNNI3 methyl",
    "TNNI3 rna"
  ],
  "TNNI3K": [
    "TNNI3K cnv",
    "TNNI3K kinase",
    "TNNI3K rna"
  ],
  "TNNT1": [
    "TNNT1 cnv",
    "TNNT1 rna"
  ],
  "TNNT2": [
    "TNNT2 cnv",
    "TNNT2 rna"
  ],
  "TNNT3": [
    "TNNT3 cnv",
    "TNNT3 methyl",
    "TNNT3 rna"
  ],
  "TNP1": [
    "TNP1 cnv"
  ],
  "TNP2": [
    "TNP2 cnv"
  ],
  "TNPO1": [
    "TNPO1 cnv",
    "TNPO1 methyl",
    "TNPO1 proteo",
    "TNPO1 rna"
  ],
  "TNPO2": [
    "TNPO2 342_368_1_1_S355 phospho",
    "TNPO2 cnv",
    "TNPO2 methyl",
    "TNPO2 proteo",
    "TNPO2 rna"
  ],
  "TNPO3": [
    "TNPO3 cnv",
    "TNPO3 methyl",
    "TNPO3 proteo",
    "TNPO3 rna"
  ],
  "TNR": [
    "TNR 719_731_1_1_S724 phospho",
    "TNR DITISNVTK-N4H4F1S1G0 glyco",
    "TNR DITISNVTK-N5H3F1S0G0 glyco",
    "TNR DITISNVTK-N5H4F1S0G0 glyco",
    "TNR GTNESDSATTQFTTEIDAPK-N2H5F0S0G0 glyco",
    "TNR GTNESDSATTQFTTEIDAPK-N3H3F1S0G0 glyco",
    "TNR GTNESDSATTQFTTEIDAPK-N4H3F1S0G0 glyco",
    "TNR GTNESDSATTQFTTEIDAPK-N4H4F1S0G0 glyco",
    "TNR GTNESDSATTQFTTEIDAPK-N5H3F1S0G0 glyco",
    "TNR GTNESDSATTQFTTEIDAPK-N5H4F1S0G0 glyco",
    "TNR GTNESDSATTQFTTEIDAPK-N5H4F2S0G0 glyco",
    "TNR NNEGGVIAQVPSDVTSFNQTGLKPGEEYIVNVVALK-N5H3F1S0G0 glyco",
    "TNR NNEGGVIAQVPSDVTSFNQTGLKPGEEYIVNVVALK-N6H3F1S0G0 glyco",
    "TNR NNEGGVIAQVPSDVTSFNQTGLKPGEEYIVNVVALK-N6H4F1S0G0 glyco",
    "TNR QSVEEEGGIANYNTSSK-N2H8F0S0G0 glyco",
    "TNR QSVEEEGGIANYNTSSK-N5H3F1S0G0 glyco",
    "TNR cnv",
    "TNR proteo",
    "TNR rna"
  ],
  "TNRC18": [
    "TNRC18 1127_1127_1_1_S1127 phospho",
    "TNRC18 cnv",
    "TNRC18 methyl",
    "TNRC18 proteo",
    "TNRC18 rna"
  ],
  "TNRC6A": [
    "TNRC6A 1209_1224_1_1_S1217 phospho",
    "TNRC6A 1835_1844_1_1_S1841 phospho",
    "TNRC6A cnv",
    "TNRC6A methyl",
    "TNRC6A proteo",
    "TNRC6A rna"
  ],
  "TNRC6B": [
    "TNRC6B 1432_1464_1_1_S1461 phospho",
    "TNRC6B 561_576_1_0 phospho",
    "TNRC6B 561_576_1_1_S564 phospho",
    "TNRC6B 873_884_1_1_S879 phospho",
    "TNRC6B cnv",
    "TNRC6B proteo",
    "TNRC6B rna"
  ],
  "TNRC6C": [
    "TNRC6C 1344_1365_1_1_S1355 phospho",
    "TNRC6C 704_717_1_1_S714 phospho",
    "TNRC6C cnv",
    "TNRC6C methyl",
    "TNRC6C proteo",
    "TNRC6C rna"
  ],
  "TNS1": [
    "TNS1 1154_1164_1_1_S1164 phospho",
    "TNS1 1171_1179_2_2_T1176S1179 phospho",
    "TNS1 1294_1301_1_1_S1301 phospho",
    "TNS1 1310_1315_1_1_T1315 phospho",
    "TNS1 1368_1370_1_1_S1368 phospho",
    "TNS1 1387_1393_1_1_S1387 phospho",
    "TNS1 1399_1425_1_1_S1408 phospho",
    "TNS1 338_366_1_0 phospho",
    "TNS1 415_433_1_1_S433 phospho",
    "TNS1 575_591_1_0 phospho",
    "TNS1 575_591_1_1_S583 phospho",
    "TNS1 619_623_1_0 phospho",
    "TNS1 619_623_1_1_S621 phospho",
    "TNS1 731_753_1_1_S733 phospho",
    "TNS1 764_775_1_1_S772 phospho",
    "TNS1 764_775_1_1_T775 phospho",
    "TNS1 792_811_1_1_S794 phospho",
    "TNS1 854_860_1_1_T860 phospho",
    "TNS1 899_912_1_1_S899 phospho",
    "TNS1 899_912_1_1_S907 phospho",
    "TNS1 899_912_2_2_S899S907 phospho",
    "TNS1 899_912_2_2_S907S912 phospho",
    "TNS1 899_915_1_1_S915 phospho",
    "TNS1 899_915_2_2_S907S915 phospho",
    "TNS1 959_967_1_1_S963 phospho",
    "TNS1 cnv",
    "TNS1 methyl",
    "TNS1 proteo",
    "TNS1 rna"
  ],
  "TNS1-AS1": [
    "TNS1-AS1 methyl"
  ],
  "TNS2": [
    "TNS2 1001_1010_1_1_S1010 phospho",
    "TNS2 1013_1018_1_1_S1013 phospho",
    "TNS2 112_113_1_1_S112 phospho",
    "TNS2 128_130_1_1_S130 phospho",
    "TNS2 491_493_1_1_Y493 phospho",
    "TNS2 656_664_1_1_S658 phospho",
    "TNS2 656_678_1_1_S658 phospho",
    "TNS2 818_821_1_1_S821 phospho",
    "TNS2 828_835_1_1_S835 phospho",
    "TNS2 840_851_1_1_S842 phospho",
    "TNS2 840_851_1_1_S845 phospho",
    "TNS2 895_903_1_1_S903 phospho",
    "TNS2 939_947_1_1_S941 phospho",
    "TNS2 951_964_1_1_S951 phospho",
    "TNS2 cnv",
    "TNS2 proteo",
    "TNS2 rna"
  ],
  "TNS2-AS1": [
    "TNS2-AS1 methyl"
  ],
  "TNS3": [
    "TNS3 1441_1441_1_1_S1441 phospho",
    "TNS3 332_354_1_0 phospho",
    "TNS3 649_662_1_1_S660 phospho",
    "TNS3 840_855_1_1_S850 phospho",
    "TNS3 cnv",
    "TNS3 methyl",
    "TNS3 proteo",
    "TNS3 rna"
  ],
  "TNS4": [
    "TNS4 cnv",
    "TNS4 rna"
  ],
  "TNXB": [
    "TNXB 3635_3652_1_1_S3649 phospho",
    "TNXB cnv",
    "TNXB proteo",
    "TNXB rna"
  ],
  "TOB1": [
    "TOB1 cnv",
    "TOB1 methyl",
    "TOB1 rna"
  ],
  "TOB1-AS1": [
    "TOB1-AS1 methyl"
  ],
  "TOB2": [
    "TOB2 cnv",
    "TOB2 methyl",
    "TOB2 rna"
  ],
  "TOE1": [
    "TOE1 419_428_1_1_S428 phospho",
    "TOE1 5_21_1_1_S5 phospho",
    "TOE1 cnv",
    "TOE1 methyl",
    "TOE1 proteo",
    "TOE1 rna"
  ],
  "TOGARAM1": [
    "TOGARAM1 cnv",
    "TOGARAM1 proteo",
    "TOGARAM1 rna"
  ],
  "TOGARAM2": [
    "TOGARAM2 cnv",
    "TOGARAM2 rna"
  ],
  "TOLLIP": [
    "TOLLIP cnv",
    "TOLLIP methyl",
    "TOLLIP proteo",
    "TOLLIP rna"
  ],
  "TOLLIP-DT": [
    "TOLLIP-DT methyl"
  ],
  "TOM1": [
    "TOM1 154_164_1_1_S160 phospho",
    "TOM1 461_473_1_0 phospho",
    "TOM1 cnv",
    "TOM1 methyl",
    "TOM1 proteo",
    "TOM1 rna"
  ],
  "TOM1L1": [
    "TOM1L1 304_323_1_1_S321 phospho",
    "TOM1L1 304_323_1_1_S323 phospho",
    "TOM1L1 cnv",
    "TOM1L1 methyl",
    "TOM1L1 proteo",
    "TOM1L1 rna"
  ],
  "TOM1L2": [
    "TOM1L2 160_164_1_1_T164 phospho",
    "TOM1L2 160_164_2_2_S160T164 phospho",
    "TOM1L2 423_431_1_1_S423 phospho",
    "TOM1L2 508_521_1_1_S508 phospho",
    "TOM1L2 cnv",
    "TOM1L2 methyl",
    "TOM1L2 proteo",
    "TOM1L2 rna"
  ],
  "TOMM20": [
    "TOMM20 135_138_1_1_S135 phospho",
    "TOMM20 cnv",
    "TOMM20 methyl",
    "TOMM20 proteo",
    "TOMM20 rna"
  ],
  "TOMM20L": [
    "TOMM20L cnv",
    "TOMM20L rna"
  ],
  "TOMM22": [
    "TOMM22 cnv",
    "TOMM22 methyl",
    "TOMM22 proteo",
    "TOMM22 rna"
  ],
  "TOMM34": [
    "TOMM34 cnv",
    "TOMM34 methyl",
    "TOMM34 proteo",
    "TOMM34 rna"
  ],
  "TOMM40": [
    "TOMM40 cnv",
    "TOMM40 methyl",
    "TOMM40 proteo",
    "TOMM40 rna"
  ],
  "TOMM40L": [
    "TOMM40L cnv",
    "TOMM40L proteo",
    "TOMM40L rna"
  ],
  "TOMM5": [
    "TOMM5 cnv",
    "TOMM5 methyl",
    "TOMM5 proteo",
    "TOMM5 rna"
  ],
  "TOMM6": [
    "TOMM6 cnv",
    "TOMM6 methyl",
    "TOMM6 proteo",
    "TOMM6 rna"
  ],
  "TOMM7": [
    "TOMM7 cnv",
    "TOMM7 methyl",
    "TOMM7 proteo",
    "TOMM7 rna"
  ],
  "TOMM70": [
    "TOMM70 85_110_1_1_S91 phospho",
    "TOMM70 91_110_1_1_S91 phospho",
    "TOMM70 cnv",
    "TOMM70 methyl",
    "TOMM70 proteo",
    "TOMM70 rna"
  ],
  "TOMT": [
    "TOMT cnv"
  ],
  "TONSL": [
    "TONSL cnv",
    "TONSL methyl",
    "TONSL proteo",
    "TONSL rna"
  ],
  "TOP1": [
    "TOP1 cnv",
    "TOP1 methyl",
    "TOP1 proteo",
    "TOP1 rna"
  ],
  "TOP1MT": [
    "TOP1MT cnv",
    "TOP1MT methyl",
    "TOP1MT rna"
  ],
  "TOP2A": [
    "TOP2A 1106_1106_1_1_S1106 phospho",
    "TOP2A 1244_1247_1_1_S1247 phospho",
    "TOP2A 1387_1406_1_1_S1393 phospho",
    "TOP2A 1521_1525_1_1_S1525 phospho",
    "TOP2A cnv",
    "TOP2A methyl",
    "TOP2A proteo",
    "TOP2A rna"
  ],
  "TOP2B": [
    "TOP2B 1395_1408_1_1_S1395 phospho",
    "TOP2B 1395_1408_1_1_S1408 phospho",
    "TOP2B 1395_1408_2_2_S1395S1408 phospho",
    "TOP2B 1395_1419_2_2_S1395S1408 phospho",
    "TOP2B 1452_1473_1_1_S1461 phospho",
    "TOP2B 1461_1473_1_1_S1461 phospho",
    "TOP2B 1517_1521_1_1_S1517 phospho",
    "TOP2B 1517_1521_2_2_S1517S1519 phospho",
    "TOP2B 1545_1553_1_1_S1545 phospho",
    "TOP2B 1545_1553_2_2_S1545S1547 phospho",
    "TOP2B 1570_1591_1_1_S1576 phospho",
    "TOP2B cnv",
    "TOP2B methyl",
    "TOP2B proteo",
    "TOP2B rna"
  ],
  "TOP3A": [
    "TOP3A cnv",
    "TOP3A methyl",
    "TOP3A rna"
  ],
  "TOP3B": [
    "TOP3B cnv",
    "TOP3B methyl",
    "TOP3B proteo",
    "TOP3B rna"
  ],
  "TOPAZ1": [
    "TOPAZ1 cnv",
    "TOPAZ1 methyl",
    "TOPAZ1 rna"
  ],
  "TOPBP1": [
    "TOPBP1 cnv",
    "TOPBP1 methyl",
    "TOPBP1 rna"
  ],
  "TOPORS": [
    "TOPORS 27_36_1_1_S33 phospho",
    "TOPORS 519_522_1_1_S520 phospho",
    "TOPORS cnv",
    "TOPORS methyl",
    "TOPORS rna"
  ],
  "TOR1A": [
    "TOR1A GNVSACAR-N2H9F0S0G0 glyco",
    "TOR1A cnv",
    "TOR1A methyl",
    "TOR1A proteo",
    "TOR1A rna"
  ],
  "TOR1AIP1": [
    "TOR1AIP1 135_147_1_1_S143 phospho",
    "TOR1AIP1 154_173_1_0 phospho",
    "TOR1AIP1 154_173_1_1_S157 phospho",
    "TOR1AIP1 154_173_2_2_S156S157 phospho",
    "TOR1AIP1 215_234_1_1_T220 phospho",
    "TOR1AIP1 79_79_1_1_S79 phospho",
    "TOR1AIP1 HLNSSHPR-N2H6F0S0G0 glyco",
    "TOR1AIP1 HLNSSHPR-N2H8F0S0G0 glyco",
    "TOR1AIP1 cnv",
    "TOR1AIP1 methyl",
    "TOR1AIP1 proteo",
    "TOR1AIP1 rna"
  ],
  "TOR1AIP2": [
    "TOR1AIP2 HLNASNPTEPATIIFTAAR-N2H6F0S0G0 glyco",
    "TOR1AIP2 HLNASNPTEPATIIFTAAR-N2H7F0S0G0 glyco",
    "TOR1AIP2 HLNASNPTEPATIIFTAAR-N2H8F0S0G0 glyco",
    "TOR1AIP2 cnv",
    "TOR1AIP2 methyl",
    "TOR1AIP2 proteo",
    "TOR1AIP2 rna"
  ],
  "TOR1B": [
    "TOR1B EERPLNASALK-N2H8F0S0G0 glyco",
    "TOR1B cnv",
    "TOR1B methyl",
    "TOR1B proteo",
    "TOR1B rna"
  ],
  "TOR2A": [
    "TOR2A cnv",
    "TOR2A methyl",
    "TOR2A proteo",
    "TOR2A rna"
  ],
  "TOR3A": [
    "TOR3A ISNNFTGLEWDLNVR-N2H8F0S0G0 glyco",
    "TOR3A cnv",
    "TOR3A methyl",
    "TOR3A proteo",
    "TOR3A rna"
  ],
  "TOR4A": [
    "TOR4A 55_63_1_1_S63 phospho",
    "TOR4A cnv",
    "TOR4A proteo",
    "TOR4A rna"
  ],
  "TOX": [
    "TOX cnv",
    "TOX methyl",
    "TOX rna"
  ],
  "TOX-DT": [
    "TOX-DT methyl"
  ],
  "TOX2": [
    "TOX2 cnv",
    "TOX2 methyl",
    "TOX2 rna"
  ],
  "TOX3": [
    "TOX3 cnv",
    "TOX3 methyl",
    "TOX3 rna"
  ],
  "TOX4": [
    "TOX4 cnv",
    "TOX4 methyl",
    "TOX4 proteo",
    "TOX4 rna"
  ],
  "TP53": [
    "TP53 312_315_1_1_S315 phospho",
    "TP53 cnv",
    "TP53 methyl",
    "TP53 mut",
    "TP53 proteo",
    "TP53 rna"
  ],
  "TP53AIP1": [
    "TP53AIP1 cnv",
    "TP53AIP1 rna"
  ],
  "TP53BP1": [
    "TP53BP1 1024_1033_1_1_S1033 phospho",
    "TP53BP1 1055_1061_1_1_T1061 phospho",
    "TP53BP1 1055_1073_1_0 phospho",
    "TP53BP1 1055_1073_1_1_T1061 phospho",
    "TP53BP1 1055_1073_2_0 phospho",
    "TP53BP1 1072_1087_1_1_S1073 phospho",
    "TP53BP1 1091_1109_1_1_S1099 phospho",
    "TP53BP1 1091_1109_1_1_S1106 phospho",
    "TP53BP1 1091_1109_2_2_S1099S1106 phospho",
    "TP53BP1 1106_1109_1_1_S1106 phospho",
    "TP53BP1 1118_1127_1_0 phospho",
    "TP53BP1 1118_1127_1_1_S1119 phospho",
    "TP53BP1 1207_1224_1_1_S1224 phospho",
    "TP53BP1 1207_1224_2_2_S1221S1224 phospho",
    "TP53BP1 122_132_1_1_S124 phospho",
    "TP53BP1 1275_1312_1_0 phospho",
    "TP53BP1 1320_1335_1_0 phospho",
    "TP53BP1 1320_1335_1_1_S1322 phospho",
    "TP53BP1 1320_1335_2_2_S1322S1325 phospho",
    "TP53BP1 1346_1359_1_1_S1347 phospho",
    "TP53BP1 1346_1367_1_1_S1367 phospho",
    "TP53BP1 1419_1435_1_1_S1435 phospho",
    "TP53BP1 1465_1490_1_1_S1467 phospho",
    "TP53BP1 1636_1655_1_0 phospho",
    "TP53BP1 1636_1655_1_1_S1640 phospho",
    "TP53BP1 1636_1655_1_1_T1643 phospho",
    "TP53BP1 1636_1655_1_1_T1653 phospho",
    "TP53BP1 1677_1683_1_1_S1683 phospho",
    "TP53BP1 227_238_1_1_S227 phospho",
    "TP53BP1 264_270_1_1_S270 phospho",
    "TP53BP1 285_315_1_1_S299 phospho",
    "TP53BP1 299_315_1_1_S299 phospho",
    "TP53BP1 318_328_1_1_T326 phospho",
    "TP53BP1 318_350_1_0 phospho",
    "TP53BP1 318_350_1_1_T326 phospho",
    "TP53BP1 377_387_1_1_S385 phospho",
    "TP53BP1 377_403_1_0 phospho",
    "TP53BP1 399_403_1_1_S403 phospho",
    "TP53BP1 497_517_1_1_S505 phospho",
    "TP53BP1 505_517_1_1_S505 phospho",
    "TP53BP1 523_530_1_0 phospho",
    "TP53BP1 523_530_1_1_S530 phospho",
    "TP53BP1 523_530_1_1_T524 phospho",
    "TP53BP1 523_530_2_2_S528S530 phospho",
    "TP53BP1 523_538_2_2_S528S530 phospho",
    "TP53BP1 548_562_1_1_S557 phospho",
    "TP53BP1 548_562_2_2_T548S557 phospho",
    "TP53BP1 571_585_1_1_S585 phospho",
    "TP53BP1 823_839_1_1_S836 phospho",
    "TP53BP1 864_872_1_1_S867 phospho",
    "TP53BP1 998_1017_1_1_S998 phospho",
    "TP53BP1 cnv",
    "TP53BP1 methyl",
    "TP53BP1 proteo",
    "TP53BP1 rna"
  ],
  "TP53BP2": [
    "TP53BP2 302_302_1_1_S302 phospho",
    "TP53BP2 742_745_1_1_S743 phospho",
    "TP53BP2 cnv",
    "TP53BP2 methyl",
    "TP53BP2 proteo",
    "TP53BP2 rna"
  ],
  "TP53I11": [
    "TP53I11 cnv",
    "TP53I11 methyl",
    "TP53I11 proteo",
    "TP53I11 rna"
  ],
  "TP53I13": [
    "TP53I13 cnv",
    "TP53I13 methyl",
    "TP53I13 rna"
  ],
  "TP53I3": [
    "TP53I3 cnv",
    "TP53I3 methyl",
    "TP53I3 proteo",
    "TP53I3 rna"
  ],
  "TP53INP1": [
    "TP53INP1 cnv",
    "TP53INP1 methyl",
    "TP53INP1 rna"
  ],
  "TP53INP2": [
    "TP53INP2 cnv",
    "TP53INP2 methyl",
    "TP53INP2 proteo",
    "TP53INP2 rna"
  ],
  "TP53RK": [
    "TP53RK 7_8_1_1_T8 phospho",
    "TP53RK cnv",
    "TP53RK kinase",
    "TP53RK methyl",
    "TP53RK proteo",
    "TP53RK rna"
  ],
  "TP53TG3": [
    "TP53TG3 cnv",
    "TP53TG3 rna"
  ],
  "TP53TG3B": [
    "TP53TG3B cnv",
    "TP53TG3B rna"
  ],
  "TP53TG3C": [
    "TP53TG3C cnv",
    "TP53TG3C rna"
  ],
  "TP53TG3D": [
    "TP53TG3D cnv",
    "TP53TG3D methyl",
    "TP53TG3D rna"
  ],
  "TP53TG3E": [
    "TP53TG3E cnv"
  ],
  "TP53TG3F": [
    "TP53TG3F cnv",
    "TP53TG3F rna"
  ],
  "TP53TG5": [
    "TP53TG5 cnv",
    "TP53TG5 methyl",
    "TP53TG5 rna"
  ],
  "TP63": [
    "TP63 cnv",
    "TP63 rna"
  ],
  "TP73": [
    "TP73 cnv",
    "TP73 methyl",
    "TP73 rna"
  ],
  "TP73-AS1": [
    "TP73-AS1 methyl"
  ],
  "TPBG": [
    "TPBG HLDLSNNSLVSLTYVSFR-N2H6F0S0G0 glyco",
    "TPBG cnv",
    "TPBG methyl",
    "TPBG proteo",
    "TPBG rna"
  ],
  "TPBGL": [
    "TPBGL cnv",
    "TPBGL methyl",
    "TPBGL proteo",
    "TPBGL rna"
  ],
  "TPCN1": [
    "TPCN1 cnv",
    "TPCN1 methyl",
    "TPCN1 proteo",
    "TPCN1 rna"
  ],
  "TPCN2": [
    "TPCN2 cnv",
    "TPCN2 methyl",
    "TPCN2 rna"
  ],
  "TPD52": [
    "TPD52 174_178_1_1_S176 phospho",
    "TPD52 181_187_1_1_S187 phospho",
    "TPD52 cnv",
    "TPD52 methyl",
    "TPD52 proteo",
    "TPD52 rna"
  ],
  "TPD52L1": [
    "TPD52L1 130_136_1_1_S132 phospho",
    "TPD52L1 173_199_1_1_S179 phospho",
    "TPD52L1 cnv",
    "TPD52L1 methyl",
    "TPD52L1 proteo",
    "TPD52L1 rna"
  ],
  "TPD52L2": [
    "TPD52L2 164_171_1_1_S166 phospho",
    "TPD52L2 96_106_1_1_S96 phospho",
    "TPD52L2 cnv",
    "TPD52L2 methyl",
    "TPD52L2 proteo",
    "TPD52L2 rna"
  ],
  "TPD52L3": [
    "TPD52L3 cnv"
  ],
  "TPGS1": [
    "TPGS1 cnv",
    "TPGS1 methyl",
    "TPGS1 rna"
  ],
  "TPGS2": [
    "TPGS2 cnv",
    "TPGS2 methyl",
    "TPGS2 proteo",
    "TPGS2 rna"
  ],
  "TPH1": [
    "TPH1 cnv",
    "TPH1 methyl",
    "TPH1 rna"
  ],
  "TPH2": [
    "TPH2 cnv",
    "TPH2 rna"
  ],
  "TPI1": [
    "TPI1 195_205_1_1_S195 phospho",
    "TPI1 209_217_1_1_S212 phospho",
    "TPI1 21_28_1_1_S21 phospho",
    "TPI1 71_80_1_1_S80 phospho",
    "TPI1 cnv",
    "TPI1 methyl",
    "TPI1 proteo",
    "TPI1 rna"
  ],
  "TPI1P2": [
    "TPI1P2 methyl"
  ],
  "TPK1": [
    "TPK1 cnv",
    "TPK1 methyl",
    "TPK1 proteo",
    "TPK1 rna"
  ],
  "TPM1": [
    "TPM1 cnv",
    "TPM1 methyl",
    "TPM1 proteo",
    "TPM1 rna"
  ],
  "TPM2": [
    "TPM2 cnv",
    "TPM2 methyl",
    "TPM2 proteo",
    "TPM2 rna"
  ],
  "TPM3": [
    "TPM3 cnv",
    "TPM3 methyl",
    "TPM3 proteo",
    "TPM3 rna"
  ],
  "TPM3P9": [
    "TPM3P9 methyl"
  ],
  "TPM4": [
    "TPM4 cnv",
    "TPM4 methyl",
    "TPM4 proteo",
    "TPM4 rna"
  ],
  "TPMT": [
    "TPMT 6_16_1_1_S14 phospho",
    "TPMT cnv",
    "TPMT methyl",
    "TPMT proteo",
    "TPMT rna"
  ],
  "TPO": [
    "TPO cnv",
    "TPO methyl",
    "TPO rna"
  ],
  "TPP1": [
    "TPP1 FLSSSPHLPPSSYFNASGR-N2H3F0S0G0 glyco",
    "TPP1 FLSSSPHLPPSSYFNASGR-N2H3F1S0G0 glyco",
    "TPP1 cnv",
    "TPP1 proteo",
    "TPP1 rna"
  ],
  "TPP2": [
    "TPP2 cnv",
    "TPP2 methyl",
    "TPP2 proteo",
    "TPP2 rna"
  ],
  "TPPP": [
    "TPPP 14_23_1_1_S18 phospho",
    "TPPP 14_23_1_1_T14 phospho",
    "TPPP 14_23_2_2_T14S18 phospho",
    "TPPP 199_205_1_1_S203 phospho",
    "TPPP 32_49_1_0 phospho",
    "TPPP 32_49_1_1_S32 phospho",
    "TPPP 32_49_1_1_S45 phospho",
    "TPPP 32_49_2_2_S32S35 phospho",
    "TPPP cnv",
    "TPPP methyl",
    "TPPP proteo",
    "TPPP rna"
  ],
  "TPPP2": [
    "TPPP2 cnv",
    "TPPP2 rna"
  ],
  "TPPP3": [
    "TPPP3 158_164_1_1_S162 phospho",
    "TPPP3 cnv",
    "TPPP3 methyl",
    "TPPP3 proteo",
    "TPPP3 rna"
  ],
  "TPR": [
    "TPR 1660_1679_1_0 phospho",
    "TPR 2133_2139_1_1_T2137 phospho",
    "TPR 2146_2155_1_1_S2155 phospho",
    "TPR 371_381_1_1_S379 phospho",
    "TPR 522_540_1_1_S523 phospho",
    "TPR 646_663_1_0 phospho",
    "TPR cnv",
    "TPR methyl",
    "TPR proteo",
    "TPR rna"
  ],
  "TPRA1": [
    "TPRA1 cnv",
    "TPRA1 methyl",
    "TPRA1 rna"
  ],
  "TPRG1": [
    "TPRG1 cnv",
    "TPRG1 rna"
  ],
  "TPRG1L": [
    "TPRG1L 7_40_1_1_T40 phospho",
    "TPRG1L cnv",
    "TPRG1L methyl",
    "TPRG1L proteo",
    "TPRG1L rna"
  ],
  "TPRKB": [
    "TPRKB cnv",
    "TPRKB methyl",
    "TPRKB proteo",
    "TPRKB rna"
  ],
  "TPRN": [
    "TPRN 241_245_1_1_S241 phospho",
    "TPRN cnv",
    "TPRN methyl",
    "TPRN rna"
  ],
  "TPRX1": [
    "TPRX1 cnv",
    "TPRX1 rna"
  ],
  "TPRX2": [
    "TPRX2 cnv",
    "TPRX2 rna"
  ],
  "TPSAB1": [
    "TPSAB1 cnv",
    "TPSAB1 rna"
  ],
  "TPSB2": [
    "TPSB2 cnv",
    "TPSB2 rna"
  ],
  "TPSD1": [
    "TPSD1 cnv",
    "TPSD1 rna"
  ],
  "TPSG1": [
    "TPSG1 cnv",
    "TPSG1 rna"
  ],
  "TPST1": [
    "TPST1 cnv",
    "TPST1 methyl",
    "TPST1 proteo",
    "TPST1 rna"
  ],
  "TPST2": [
    "TPST2 cnv",
    "TPST2 methyl",
    "TPST2 proteo",
    "TPST2 rna"
  ],
  "TPT1": [
    "TPT1 cnv",
    "TPT1 methyl",
    "TPT1 proteo",
    "TPT1 rna"
  ],
  "TPTE": [
    "TPTE cnv",
    "TPTE methyl",
    "TPTE rna"
  ],
  "TPTE2": [
    "TPTE2 cnv",
    "TPTE2 methyl",
    "TPTE2 rna"
  ],
  "TPTEP1": [
    "TPTEP1 methyl"
  ],
  "TPTEP2-CSNK1E": [
    "TPTEP2-CSNK1E cnv",
    "TPTEP2-CSNK1E methyl",
    "TPTEP2-CSNK1E proteo",
    "TPTEP2-CSNK1E rna"
  ],
  "TPX2": [
    "TPX2 369_374_1_1_T369 phospho",
    "TPX2 728_738_1_1_S738 phospho",
    "TPX2 cnv",
    "TPX2 methyl",
    "TPX2 proteo",
    "TPX2 rna"
  ],
  "TRA2A": [
    "TRA2A 202_208_1_1_T202 phospho",
    "TRA2A 202_215_1_1_T202 phospho",
    "TRA2A 98_103_2_2_S98S100 phospho",
    "TRA2A cnv",
    "TRA2A methyl",
    "TRA2A proteo",
    "TRA2A rna"
  ],
  "TRA2B": [
    "TRA2B 201_207_1_1_T201 phospho",
    "TRA2B 201_216_1_1_T201 phospho",
    "TRA2B 20_26_1_1_S22 phospho",
    "TRA2B 20_26_2_2_S22S26 phospho",
    "TRA2B 95_103_1_1_S99 phospho",
    "TRA2B 95_103_2_2_S97S99 phospho",
    "TRA2B 95_103_3_3_S95S97S99 phospho",
    "TRA2B cnv",
    "TRA2B methyl",
    "TRA2B proteo",
    "TRA2B rna"
  ],
  "TRABD": [
    "TRABD cnv",
    "TRABD methyl",
    "TRABD proteo",
    "TRABD rna"
  ],
  "TRABD2A": [
    "TRABD2A cnv",
    "TRABD2A methyl",
    "TRABD2A rna"
  ],
  "TRABD2B": [
    "TRABD2B cnv",
    "TRABD2B methyl",
    "TRABD2B rna"
  ],
  "TRAC": [
    "TRAC cnv",
    "TRAC rna"
  ],
  "TRADD": [
    "TRADD cnv",
    "TRADD methyl",
    "TRADD proteo",
    "TRADD rna"
  ],
  "TRAF1": [
    "TRAF1 cnv",
    "TRAF1 methyl",
    "TRAF1 proteo",
    "TRAF1 rna"
  ],
  "TRAF2": [
    "TRAF2 cnv",
    "TRAF2 methyl",
    "TRAF2 proteo",
    "TRAF2 rna"
  ],
  "TRAF3": [
    "TRAF3 cnv",
    "TRAF3 methyl",
    "TRAF3 proteo",
    "TRAF3 rna"
  ],
  "TRAF3IP1": [
    "TRAF3IP1 410_410_1_1_S410 phospho",
    "TRAF3IP1 cnv",
    "TRAF3IP1 methyl",
    "TRAF3IP1 proteo",
    "TRAF3IP1 rna"
  ],
  "TRAF3IP2": [
    "TRAF3IP2 cnv",
    "TRAF3IP2 rna"
  ],
  "TRAF3IP2-AS1": [
    "TRAF3IP2-AS1 methyl"
  ],
  "TRAF3IP3": [
    "TRAF3IP3 cnv",
    "TRAF3IP3 rna"
  ],
  "TRAF4": [
    "TRAF4 426_436_1_1_S426 phospho",
    "TRAF4 cnv",
    "TRAF4 methyl",
    "TRAF4 proteo",
    "TRAF4 rna"
  ],
  "TRAF5": [
    "TRAF5 cnv",
    "TRAF5 methyl",
    "TRAF5 proteo",
    "TRAF5 rna"
  ],
  "TRAF6": [
    "TRAF6 cnv",
    "TRAF6 methyl",
    "TRAF6 proteo",
    "TRAF6 rna"
  ],
  "TRAF7": [
    "TRAF7 cnv",
    "TRAF7 methyl",
    "TRAF7 proteo",
    "TRAF7 rna"
  ],
  "TRAFD1": [
    "TRAFD1 205_209_1_1_S209 phospho",
    "TRAFD1 320_327_1_1_S327 phospho",
    "TRAFD1 409_415_1_1_S415 phospho",
    "TRAFD1 cnv",
    "TRAFD1 methyl",
    "TRAFD1 proteo",
    "TRAFD1 rna"
  ],
  "TRAIP": [
    "TRAIP cnv",
    "TRAIP methyl",
    "TRAIP rna"
  ],
  "TRAJ1": [
    "TRAJ1 cnv"
  ],
  "TRAJ10": [
    "TRAJ10 cnv"
  ],
  "TRAJ11": [
    "TRAJ11 cnv"
  ],
  "TRAJ12": [
    "TRAJ12 cnv"
  ],
  "TRAJ13": [
    "TRAJ13 cnv"
  ],
  "TRAJ14": [
    "TRAJ14 cnv"
  ],
  "TRAJ16": [
    "TRAJ16 cnv"
  ],
  "TRAJ17": [
    "TRAJ17 cnv"
  ],
  "TRAJ18": [
    "TRAJ18 cnv"
  ],
  "TRAJ19": [
    "TRAJ19 cnv"
  ],
  "TRAJ2": [
    "TRAJ2 cnv"
  ],
  "TRAJ20": [
    "TRAJ20 cnv"
  ],
  "TRAJ21": [
    "TRAJ21 cnv"
  ],
  "TRAJ22": [
    "TRAJ22 cnv"
  ],
  "TRAJ23": [
    "TRAJ23 cnv"
  ],
  "TRAJ24": [
    "TRAJ24 cnv"
  ],
  "TRAJ25": [
    "TRAJ25 cnv"
  ],
  "TRAJ26": [
    "TRAJ26 cnv"
  ],
  "TRAJ27": [
    "TRAJ27 cnv"
  ],
  "TRAJ28": [
    "TRAJ28 cnv"
  ],
  "TRAJ29": [
    "TRAJ29 cnv"
  ],
  "TRAJ3": [
    "TRAJ3 cnv"
  ],
  "TRAJ30": [
    "TRAJ30 cnv"
  ],
  "TRAJ31": [
    "TRAJ31 cnv"
  ],
  "TRAJ32": [
    "TRAJ32 cnv"
  ],
  "TRAJ33": [
    "TRAJ33 cnv"
  ],
  "TRAJ34": [
    "TRAJ34 cnv"
  ],
  "TRAJ35": [
    "TRAJ35 cnv"
  ],
  "TRAJ36": [
    "TRAJ36 cnv"
  ],
  "TRAJ37": [
    "TRAJ37 cnv"
  ],
  "TRAJ38": [
    "TRAJ38 cnv"
  ],
  "TRAJ39": [
    "TRAJ39 cnv"
  ],
  "TRAJ4": [
    "TRAJ4 cnv"
  ],
  "TRAJ40": [
    "TRAJ40 cnv"
  ],
  "TRAJ41": [
    "TRAJ41 cnv"
  ],
  "TRAJ42": [
    "TRAJ42 cnv"
  ],
  "TRAJ43": [
    "TRAJ43 cnv"
  ],
  "TRAJ44": [
    "TRAJ44 cnv"
  ],
  "TRAJ45": [
    "TRAJ45 cnv"
  ],
  "TRAJ46": [
    "TRAJ46 cnv"
  ],
  "TRAJ47": [
    "TRAJ47 cnv"
  ],
  "TRAJ48": [
    "TRAJ48 cnv"
  ],
  "TRAJ49": [
    "TRAJ49 cnv"
  ],
  "TRAJ5": [
    "TRAJ5 cnv"
  ],
  "TRAJ50": [
    "TRAJ50 cnv"
  ],
  "TRAJ52": [
    "TRAJ52 cnv"
  ],
  "TRAJ53": [
    "TRAJ53 cnv"
  ],
  "TRAJ54": [
    "TRAJ54 cnv"
  ],
  "TRAJ56": [
    "TRAJ56 cnv"
  ],
  "TRAJ57": [
    "TRAJ57 cnv"
  ],
  "TRAJ58": [
    "TRAJ58 cnv"
  ],
  "TRAJ59": [
    "TRAJ59 cnv"
  ],
  "TRAJ6": [
    "TRAJ6 cnv"
  ],
  "TRAJ61": [
    "TRAJ61 cnv"
  ],
  "TRAJ7": [
    "TRAJ7 cnv"
  ],
  "TRAJ8": [
    "TRAJ8 cnv"
  ],
  "TRAJ9": [
    "TRAJ9 cnv"
  ],
  "TRAK1": [
    "TRAK1 200_212_1_1_S200 phospho",
    "TRAK1 535_551_1_1_T539 phospho",
    "TRAK1 719_727_1_1_S719 phospho",
    "TRAK1 cnv",
    "TRAK1 methyl",
    "TRAK1 proteo",
    "TRAK1 rna"
  ],
  "TRAK2": [
    "TRAK2 cnv",
    "TRAK2 methyl",
    "TRAK2 rna"
  ],
  "TRAM1": [
    "TRAM1 319_334_1_0 phospho",
    "TRAM1 319_334_1_1_S334 phospho",
    "TRAM1 cnv",
    "TRAM1 methyl",
    "TRAM1 proteo",
    "TRAM1 rna"
  ],
  "TRAM1L1": [
    "TRAM1L1 cnv",
    "TRAM1L1 methyl",
    "TRAM1L1 rna"
  ],
  "TRAM2": [
    "TRAM2 cnv",
    "TRAM2 methyl",
    "TRAM2 proteo",
    "TRAM2 rna"
  ],
  "TRAM2-AS1": [
    "TRAM2-AS1 methyl"
  ],
  "TRANK1": [
    "TRANK1 cnv",
    "TRANK1 methyl",
    "TRANK1 rna"
  ],
  "TRAP1": [
    "TRAP1 cnv",
    "TRAP1 methyl",
    "TRAP1 proteo",
    "TRAP1 rna"
  ],
  "TRAPPC1": [
    "TRAPPC1 cnv",
    "TRAPPC1 methyl",
    "TRAPPC1 proteo",
    "TRAPPC1 rna"
  ],
  "TRAPPC10": [
    "TRAPPC10 216_225_1_1_S218 phospho",
    "TRAPPC10 241_249_1_0 phospho",
    "TRAPPC10 241_249_1_1_S241 phospho",
    "TRAPPC10 241_249_2_0 phospho",
    "TRAPPC10 739_749_1_1_S739 phospho",
    "TRAPPC10 cnv",
    "TRAPPC10 proteo",
    "TRAPPC10 rna"
  ],
  "TRAPPC11": [
    "TRAPPC11 70_75_1_1_S71 phospho",
    "TRAPPC11 cnv",
    "TRAPPC11 methyl",
    "TRAPPC11 proteo",
    "TRAPPC11 rna"
  ],
  "TRAPPC12": [
    "TRAPPC12 107_127_2_0 phospho",
    "TRAPPC12 cnv",
    "TRAPPC12 methyl",
    "TRAPPC12 proteo",
    "TRAPPC12 rna"
  ],
  "TRAPPC13": [
    "TRAPPC13 cnv",
    "TRAPPC13 methyl",
    "TRAPPC13 proteo",
    "TRAPPC13 rna"
  ],
  "TRAPPC14": [
    "TRAPPC14 246_255_1_1_S248 phospho",
    "TRAPPC14 cnv",
    "TRAPPC14 methyl",
    "TRAPPC14 proteo",
    "TRAPPC14 rna"
  ],
  "TRAPPC2": [
    "TRAPPC2 methyl",
    "TRAPPC2 proteo",
    "TRAPPC2 rna"
  ],
  "TRAPPC2B": [
    "TRAPPC2B cnv",
    "TRAPPC2B methyl",
    "TRAPPC2B rna"
  ],
  "TRAPPC2L": [
    "TRAPPC2L cnv",
    "TRAPPC2L methyl",
    "TRAPPC2L proteo",
    "TRAPPC2L rna"
  ],
  "TRAPPC3": [
    "TRAPPC3 cnv",
    "TRAPPC3 methyl",
    "TRAPPC3 proteo",
    "TRAPPC3 rna"
  ],
  "TRAPPC3L": [
    "TRAPPC3L cnv",
    "TRAPPC3L rna"
  ],
  "TRAPPC4": [
    "TRAPPC4 cnv",
    "TRAPPC4 methyl",
    "TRAPPC4 proteo",
    "TRAPPC4 rna"
  ],
  "TRAPPC5": [
    "TRAPPC5 cnv",
    "TRAPPC5 methyl",
    "TRAPPC5 proteo",
    "TRAPPC5 rna"
  ],
  "TRAPPC6A": [
    "TRAPPC6A cnv",
    "TRAPPC6A methyl",
    "TRAPPC6A rna"
  ],
  "TRAPPC6B": [
    "TRAPPC6B cnv",
    "TRAPPC6B methyl",
    "TRAPPC6B proteo",
    "TRAPPC6B rna"
  ],
  "TRAPPC8": [
    "TRAPPC8 1088_1090_1_1_S1090 phospho",
    "TRAPPC8 253_269_1_0 phospho",
    "TRAPPC8 320_327_1_1_S323 phospho",
    "TRAPPC8 654_675_1_1_S657 phospho",
    "TRAPPC8 cnv",
    "TRAPPC8 methyl",
    "TRAPPC8 proteo",
    "TRAPPC8 rna"
  ],
  "TRAPPC9": [
    "TRAPPC9 949_953_1_1_S953 phospho",
    "TRAPPC9 cnv",
    "TRAPPC9 methyl",
    "TRAPPC9 proteo",
    "TRAPPC9 rna"
  ],
  "TRARG1": [
    "TRARG1 cnv",
    "TRARG1 rna"
  ],
  "TRAT1": [
    "TRAT1 cnv",
    "TRAT1 rna"
  ],
  "TRAV1-1": [
    "TRAV1-1 cnv"
  ],
  "TRAV1-2": [
    "TRAV1-2 cnv",
    "TRAV1-2 rna"
  ],
  "TRAV10": [
    "TRAV10 cnv",
    "TRAV10 rna"
  ],
  "TRAV12-1": [
    "TRAV12-1 cnv",
    "TRAV12-1 rna"
  ],
  "TRAV12-2": [
    "TRAV12-2 cnv",
    "TRAV12-2 rna"
  ],
  "TRAV12-3": [
    "TRAV12-3 cnv",
    "TRAV12-3 rna"
  ],
  "TRAV13-1": [
    "TRAV13-1 cnv",
    "TRAV13-1 rna"
  ],
  "TRAV13-2": [
    "TRAV13-2 cnv",
    "TRAV13-2 rna"
  ],
  "TRAV14DV4": [
    "TRAV14DV4 cnv",
    "TRAV14DV4 rna"
  ],
  "TRAV16": [
    "TRAV16 cnv",
    "TRAV16 rna"
  ],
  "TRAV17": [
    "TRAV17 cnv",
    "TRAV17 rna"
  ],
  "TRAV18": [
    "TRAV18 cnv",
    "TRAV18 rna"
  ],
  "TRAV19": [
    "TRAV19 cnv",
    "TRAV19 rna"
  ],
  "TRAV2": [
    "TRAV2 cnv",
    "TRAV2 rna"
  ],
  "TRAV20": [
    "TRAV20 cnv",
    "TRAV20 rna"
  ],
  "TRAV21": [
    "TRAV21 cnv",
    "TRAV21 rna"
  ],
  "TRAV22": [
    "TRAV22 cnv",
    "TRAV22 rna"
  ],
  "TRAV23DV6": [
    "TRAV23DV6 cnv",
    "TRAV23DV6 rna"
  ],
  "TRAV24": [
    "TRAV24 cnv",
    "TRAV24 rna"
  ],
  "TRAV25": [
    "TRAV25 cnv",
    "TRAV25 rna"
  ],
  "TRAV26-1": [
    "TRAV26-1 cnv",
    "TRAV26-1 rna"
  ],
  "TRAV26-2": [
    "TRAV26-2 cnv"
  ],
  "TRAV27": [
    "TRAV27 cnv",
    "TRAV27 rna"
  ],
  "TRAV29DV5": [
    "TRAV29DV5 cnv",
    "TRAV29DV5 rna"
  ],
  "TRAV3": [
    "TRAV3 cnv",
    "TRAV3 rna"
  ],
  "TRAV30": [
    "TRAV30 cnv"
  ],
  "TRAV34": [
    "TRAV34 cnv"
  ],
  "TRAV35": [
    "TRAV35 cnv",
    "TRAV35 rna"
  ],
  "TRAV36DV7": [
    "TRAV36DV7 cnv",
    "TRAV36DV7 rna"
  ],
  "TRAV38-1": [
    "TRAV38-1 cnv",
    "TRAV38-1 rna"
  ],
  "TRAV38-2DV8": [
    "TRAV38-2DV8 cnv",
    "TRAV38-2DV8 rna"
  ],
  "TRAV39": [
    "TRAV39 cnv",
    "TRAV39 rna"
  ],
  "TRAV4": [
    "TRAV4 cnv",
    "TRAV4 rna"
  ],
  "TRAV40": [
    "TRAV40 cnv"
  ],
  "TRAV41": [
    "TRAV41 cnv",
    "TRAV41 rna"
  ],
  "TRAV5": [
    "TRAV5 cnv",
    "TRAV5 rna"
  ],
  "TRAV6": [
    "TRAV6 cnv",
    "TRAV6 rna"
  ],
  "TRAV7": [
    "TRAV7 cnv"
  ],
  "TRAV8-1": [
    "TRAV8-1 cnv",
    "TRAV8-1 rna"
  ],
  "TRAV8-2": [
    "TRAV8-2 cnv",
    "TRAV8-2 rna"
  ],
  "TRAV8-3": [
    "TRAV8-3 cnv",
    "TRAV8-3 rna"
  ],
  "TRAV8-4": [
    "TRAV8-4 cnv",
    "TRAV8-4 rna"
  ],
  "TRAV8-6": [
    "TRAV8-6 cnv",
    "TRAV8-6 rna"
  ],
  "TRAV9-1": [
    "TRAV9-1 cnv"
  ],
  "TRAV9-2": [
    "TRAV9-2 cnv",
    "TRAV9-2 rna"
  ],
  "TRBC1": [
    "TRBC1 cnv",
    "TRBC1 rna"
  ],
  "TRBC2": [
    "TRBC2 cnv",
    "TRBC2 rna"
  ],
  "TRBD1": [
    "TRBD1 cnv"
  ],
  "TRBJ1-1": [
    "TRBJ1-1 cnv"
  ],
  "TRBJ1-2": [
    "TRBJ1-2 cnv"
  ],
  "TRBJ1-3": [
    "TRBJ1-3 cnv"
  ],
  "TRBJ1-4": [
    "TRBJ1-4 cnv"
  ],
  "TRBJ1-5": [
    "TRBJ1-5 cnv"
  ],
  "TRBJ1-6": [
    "TRBJ1-6 cnv"
  ],
  "TRBJ2-1": [
    "TRBJ2-1 cnv"
  ],
  "TRBJ2-2": [
    "TRBJ2-2 cnv"
  ],
  "TRBJ2-2P": [
    "TRBJ2-2P cnv"
  ],
  "TRBJ2-3": [
    "TRBJ2-3 cnv"
  ],
  "TRBJ2-4": [
    "TRBJ2-4 cnv"
  ],
  "TRBJ2-5": [
    "TRBJ2-5 cnv"
  ],
  "TRBJ2-6": [
    "TRBJ2-6 cnv"
  ],
  "TRBJ2-7": [
    "TRBJ2-7 cnv"
  ],
  "TRBV10-1": [
    "TRBV10-1 cnv"
  ],
  "TRBV10-2": [
    "TRBV10-2 cnv",
    "TRBV10-2 rna"
  ],
  "TRBV10-3": [
    "TRBV10-3 cnv",
    "TRBV10-3 rna"
  ],
  "TRBV11-1": [
    "TRBV11-1 cnv"
  ],
  "TRBV11-2": [
    "TRBV11-2 cnv",
    "TRBV11-2 rna"
  ],
  "TRBV11-3": [
    "TRBV11-3 cnv"
  ],
  "TRBV12-3": [
    "TRBV12-3 cnv",
    "TRBV12-3 rna"
  ],
  "TRBV12-4": [
    "TRBV12-4 cnv",
    "TRBV12-4 rna"
  ],
  "TRBV12-5": [
    "TRBV12-5 cnv"
  ],
  "TRBV13": [
    "TRBV13 cnv",
    "TRBV13 rna"
  ],
  "TRBV14": [
    "TRBV14 cnv",
    "TRBV14 rna"
  ],
  "TRBV15": [
    "TRBV15 cnv",
    "TRBV15 rna"
  ],
  "TRBV16": [
    "TRBV16 cnv"
  ],
  "TRBV17": [
    "TRBV17 cnv"
  ],
  "TRBV18": [
    "TRBV18 cnv",
    "TRBV18 rna"
  ],
  "TRBV19": [
    "TRBV19 cnv",
    "TRBV19 rna"
  ],
  "TRBV2": [
    "TRBV2 cnv",
    "TRBV2 rna"
  ],
  "TRBV20-1": [
    "TRBV20-1 cnv",
    "TRBV20-1 rna"
  ],
  "TRBV20OR9-2": [
    "TRBV20OR9-2 cnv",
    "TRBV20OR9-2 rna"
  ],
  "TRBV23-1": [
    "TRBV23-1 cnv"
  ],
  "TRBV24-1": [
    "TRBV24-1 cnv",
    "TRBV24-1 rna"
  ],
  "TRBV25-1": [
    "TRBV25-1 cnv",
    "TRBV25-1 rna"
  ],
  "TRBV27": [
    "TRBV27 cnv",
    "TRBV27 rna"
  ],
  "TRBV28": [
    "TRBV28 cnv",
    "TRBV28 rna"
  ],
  "TRBV29-1": [
    "TRBV29-1 cnv",
    "TRBV29-1 rna"
  ],
  "TRBV29OR9-2": [
    "TRBV29OR9-2 cnv"
  ],
  "TRBV3-1": [
    "TRBV3-1 cnv",
    "TRBV3-1 rna"
  ],
  "TRBV30": [
    "TRBV30 cnv",
    "TRBV30 rna"
  ],
  "TRBV4-1": [
    "TRBV4-1 cnv",
    "TRBV4-1 rna"
  ],
  "TRBV4-2": [
    "TRBV4-2 cnv",
    "TRBV4-2 rna"
  ],
  "TRBV5-1": [
    "TRBV5-1 cnv",
    "TRBV5-1 rna"
  ],
  "TRBV5-3": [
    "TRBV5-3 cnv"
  ],
  "TRBV5-4": [
    "TRBV5-4 cnv",
    "TRBV5-4 rna"
  ],
  "TRBV5-5": [
    "TRBV5-5 cnv",
    "TRBV5-5 rna"
  ],
  "TRBV5-6": [
    "TRBV5-6 cnv",
    "TRBV5-6 rna"
  ],
  "TRBV5-7": [
    "TRBV5-7 cnv"
  ],
  "TRBV6-1": [
    "TRBV6-1 cnv",
    "TRBV6-1 rna"
  ],
  "TRBV6-2": [
    "TRBV6-2 cnv",
    "TRBV6-2 rna"
  ],
  "TRBV6-4": [
    "TRBV6-4 cnv"
  ],
  "TRBV6-5": [
    "TRBV6-5 cnv",
    "TRBV6-5 rna"
  ],
  "TRBV6-6": [
    "TRBV6-6 cnv",
    "TRBV6-6 rna"
  ],
  "TRBV6-7": [
    "TRBV6-7 cnv",
    "TRBV6-7 rna"
  ],
  "TRBV6-8": [
    "TRBV6-8 cnv"
  ],
  "TRBV7-1": [
    "TRBV7-1 cnv",
    "TRBV7-1 rna"
  ],
  "TRBV7-2": [
    "TRBV7-2 cnv",
    "TRBV7-2 rna"
  ],
  "TRBV7-3": [
    "TRBV7-3 cnv",
    "TRBV7-3 rna"
  ],
  "TRBV7-4": [
    "TRBV7-4 cnv"
  ],
  "TRBV7-6": [
    "TRBV7-6 cnv",
    "TRBV7-6 rna"
  ],
  "TRBV7-7": [
    "TRBV7-7 cnv"
  ],
  "TRBV7-9": [
    "TRBV7-9 cnv",
    "TRBV7-9 rna"
  ],
  "TRBV9": [
    "TRBV9 cnv",
    "TRBV9 rna"
  ],
  "TRDC": [
    "TRDC cnv",
    "TRDC rna"
  ],
  "TRDD1": [
    "TRDD1 cnv"
  ],
  "TRDD2": [
    "TRDD2 cnv"
  ],
  "TRDD3": [
    "TRDD3 cnv"
  ],
  "TRDJ1": [
    "TRDJ1 cnv"
  ],
  "TRDJ2": [
    "TRDJ2 cnv"
  ],
  "TRDJ3": [
    "TRDJ3 cnv"
  ],
  "TRDJ4": [
    "TRDJ4 cnv"
  ],
  "TRDMT1": [
    "TRDMT1 cnv",
    "TRDMT1 methyl",
    "TRDMT1 rna"
  ],
  "TRDN": [
    "TRDN cnv",
    "TRDN rna"
  ],
  "TRDV1": [
    "TRDV1 cnv",
    "TRDV1 rna"
  ],
  "TRDV2": [
    "TRDV2 cnv",
    "TRDV2 rna"
  ],
  "TRDV3": [
    "TRDV3 cnv",
    "TRDV3 rna"
  ],
  "TREH": [
    "TREH cnv",
    "TREH rna"
  ],
  "TREM1": [
    "TREM1 cnv",
    "TREM1 proteo",
    "TREM1 rna"
  ],
  "TREM2": [
    "TREM2 cnv",
    "TREM2 proteo",
    "TREM2 rna"
  ],
  "TREML1": [
    "TREML1 cnv",
    "TREML1 proteo",
    "TREML1 rna"
  ],
  "TREML2": [
    "TREML2 cnv",
    "TREML2 rna"
  ],
  "TREML4": [
    "TREML4 cnv",
    "TREML4 rna"
  ],
  "TRERF1": [
    "TRERF1 491_495_1_1_S491 phospho",
    "TRERF1 cnv",
    "TRERF1 methyl",
    "TRERF1 proteo",
    "TRERF1 rna"
  ],
  "TREX1": [
    "TREX1 156_159_1_1_S157 phospho",
    "TREX1 cnv",
    "TREX1 proteo",
    "TREX1 rna"
  ],
  "TREX2": [
    "TREX2 rna"
  ],
  "TRGC1": [
    "TRGC1 cnv",
    "TRGC1 rna"
  ],
  "TRGC2": [
    "TRGC2 cnv",
    "TRGC2 rna"
  ],
  "TRGJ1": [
    "TRGJ1 cnv"
  ],
  "TRGJ2": [
    "TRGJ2 cnv"
  ],
  "TRGJP": [
    "TRGJP cnv"
  ],
  "TRGJP1": [
    "TRGJP1 cnv"
  ],
  "TRGJP2": [
    "TRGJP2 cnv"
  ],
  "TRGV1": [
    "TRGV1 cnv",
    "TRGV1 rna"
  ],
  "TRGV10": [
    "TRGV10 cnv",
    "TRGV10 rna"
  ],
  "TRGV11": [
    "TRGV11 cnv"
  ],
  "TRGV2": [
    "TRGV2 cnv",
    "TRGV2 rna"
  ],
  "TRGV3": [
    "TRGV3 cnv",
    "TRGV3 rna"
  ],
  "TRGV4": [
    "TRGV4 cnv",
    "TRGV4 rna"
  ],
  "TRGV5": [
    "TRGV5 cnv",
    "TRGV5 rna"
  ],
  "TRGV8": [
    "TRGV8 cnv",
    "TRGV8 rna"
  ],
  "TRGV9": [
    "TRGV9 cnv",
    "TRGV9 rna"
  ],
  "TRH": [
    "TRH 166_166_1_1_S166 phospho",
    "TRH cnv",
    "TRH methyl",
    "TRH proteo",
    "TRH rna"
  ],
  "TRHDE": [
    "TRHDE cnv",
    "TRHDE methyl",
    "TRHDE rna"
  ],
  "TRHR": [
    "TRHR cnv",
    "TRHR rna"
  ],
  "TRIAP1": [
    "TRIAP1 cnv",
    "TRIAP1 methyl",
    "TRIAP1 proteo",
    "TRIAP1 rna"
  ],
  "TRIB1": [
    "TRIB1 cnv",
    "TRIB1 kinase",
    "TRIB1 methyl",
    "TRIB1 rna"
  ],
  "TRIB2": [
    "TRIB2 cnv",
    "TRIB2 kinase",
    "TRIB2 methyl",
    "TRIB2 rna"
  ],
  "TRIB3": [
    "TRIB3 cnv",
    "TRIB3 kinase",
    "TRIB3 methyl",
    "TRIB3 rna"
  ],
  "TRIL": [
    "TRIL cnv",
    "TRIL methyl",
    "TRIL proteo",
    "TRIL rna"
  ],
  "TRIM10": [
    "TRIM10 cnv",
    "TRIM10 rna"
  ],
  "TRIM11": [
    "TRIM11 85_85_1_1_S85 phospho",
    "TRIM11 cnv",
    "TRIM11 methyl",
    "TRIM11 rna"
  ],
  "TRIM13": [
    "TRIM13 cnv",
    "TRIM13 methyl",
    "TRIM13 rna"
  ],
  "TRIM14": [
    "TRIM14 cnv",
    "TRIM14 methyl",
    "TRIM14 rna"
  ],
  "TRIM15": [
    "TRIM15 cnv"
  ],
  "TRIM16": [
    "TRIM16 55_62_1_1_S60 phospho",
    "TRIM16 cnv",
    "TRIM16 proteo",
    "TRIM16 rna"
  ],
  "TRIM16L": [
    "TRIM16L cnv",
    "TRIM16L rna"
  ],
  "TRIM17": [
    "TRIM17 cnv",
    "TRIM17 methyl",
    "TRIM17 rna"
  ],
  "TRIM2": [
    "TRIM2 360_375_1_1_T371 phospho",
    "TRIM2 424_431_1_1_S424 phospho",
    "TRIM2 424_431_1_1_S428 phospho",
    "TRIM2 424_431_2_2_S424S428 phospho",
    "TRIM2 440_443_2_2_S440S443 phospho",
    "TRIM2 456_460_1_1_S456 phospho",
    "TRIM2 cnv",
    "TRIM2 methyl",
    "TRIM2 proteo",
    "TRIM2 rna"
  ],
  "TRIM21": [
    "TRIM21 cnv",
    "TRIM21 proteo",
    "TRIM21 rna"
  ],
  "TRIM22": [
    "TRIM22 379_391_1_1_S379 phospho",
    "TRIM22 379_391_1_1_S380 phospho",
    "TRIM22 87_87_1_1_S87 phospho",
    "TRIM22 cnv",
    "TRIM22 proteo",
    "TRIM22 rna"
  ],
  "TRIM23": [
    "TRIM23 cnv",
    "TRIM23 methyl",
    "TRIM23 rna"
  ],
  "TRIM24": [
    "TRIM24 768_784_1_1_S777 phospho",
    "TRIM24 777_784_1_1_S777 phospho",
    "TRIM24 985_994_1_1_S994 phospho",
    "TRIM24 985_994_2_2_S991S994 phospho",
    "TRIM24 cnv",
    "TRIM24 methyl",
    "TRIM24 proteo",
    "TRIM24 rna"
  ],
  "TRIM25": [
    "TRIM25 427_435_1_1_S435 phospho",
    "TRIM25 97_100_1_1_S100 phospho",
    "TRIM25 cnv",
    "TRIM25 methyl",
    "TRIM25 proteo",
    "TRIM25 rna"
  ],
  "TRIM26": [
    "TRIM26 cnv",
    "TRIM26 methyl",
    "TRIM26 proteo",
    "TRIM26 rna"
  ],
  "TRIM27": [
    "TRIM27 cnv",
    "TRIM27 methyl",
    "TRIM27 proteo",
    "TRIM27 rna"
  ],
  "TRIM28": [
    "TRIM28 33_50_1_0 phospho",
    "TRIM28 33_50_1_1_S50 phospho",
    "TRIM28 437_466_1_0 phospho",
    "TRIM28 471_479_1_1_S473 phospho",
    "TRIM28 489_501_1_1_S489 phospho",
    "TRIM28 498_501_1_1_S501 phospho",
    "TRIM28 531_541_1_1_T541 phospho",
    "TRIM28 594_626_1_0 phospho",
    "TRIM28 594_626_1_1_S594 phospho",
    "TRIM28 594_626_1_1_S601 phospho",
    "TRIM28 594_626_2_0 phospho",
    "TRIM28 752_757_1_1_S757 phospho",
    "TRIM28 806_828_1_0 phospho",
    "TRIM28 cnv",
    "TRIM28 methyl",
    "TRIM28 proteo",
    "TRIM28 rna"
  ],
  "TRIM29": [
    "TRIM29 cnv",
    "TRIM29 rna"
  ],
  "TRIM3": [
    "TRIM3 454_459_1_1_S454 phospho",
    "TRIM3 7_7_1_1_S7 phospho",
    "TRIM3 cnv",
    "TRIM3 methyl",
    "TRIM3 proteo",
    "TRIM3 rna"
  ],
  "TRIM31": [
    "TRIM31 cnv",
    "TRIM31 rna"
  ],
  "TRIM32": [
    "TRIM32 cnv",
    "TRIM32 methyl",
    "TRIM32 proteo",
    "TRIM32 rna"
  ],
  "TRIM33": [
    "TRIM33 1119_1119_1_1_S1119 phospho",
    "TRIM33 cnv",
    "TRIM33 methyl",
    "TRIM33 proteo",
    "TRIM33 rna"
  ],
  "TRIM34": [
    "TRIM34 cnv",
    "TRIM34 rna"
  ],
  "TRIM35": [
    "TRIM35 cnv",
    "TRIM35 methyl",
    "TRIM35 rna"
  ],
  "TRIM36": [
    "TRIM36 372_389_1_1_S380 phospho",
    "TRIM36 600_625_1_0 phospho",
    "TRIM36 cnv",
    "TRIM36 methyl",
    "TRIM36 proteo",
    "TRIM36 rna"
  ],
  "TRIM37": [
    "TRIM37 cnv",
    "TRIM37 methyl",
    "TRIM37 proteo",
    "TRIM37 rna"
  ],
  "TRIM38": [
    "TRIM38 cnv",
    "TRIM38 methyl",
    "TRIM38 proteo",
    "TRIM38 rna"
  ],
  "TRIM39": [
    "TRIM39 cnv",
    "TRIM39 methyl",
    "TRIM39 rna"
  ],
  "TRIM39-RPP21": [
    "TRIM39-RPP21 cnv",
    "TRIM39-RPP21 rna"
  ],
  "TRIM4": [
    "TRIM4 cnv",
    "TRIM4 methyl",
    "TRIM4 proteo",
    "TRIM4 rna"
  ],
  "TRIM40": [
    "TRIM40 cnv",
    "TRIM40 rna"
  ],
  "TRIM41": [
    "TRIM41 cnv",
    "TRIM41 methyl",
    "TRIM41 proteo",
    "TRIM41 rna"
  ],
  "TRIM42": [
    "TRIM42 cnv",
    "TRIM42 rna"
  ],
  "TRIM43": [
    "TRIM43 cnv",
    "TRIM43 rna"
  ],
  "TRIM43B": [
    "TRIM43B cnv",
    "TRIM43B rna"
  ],
  "TRIM44": [
    "TRIM44 cnv",
    "TRIM44 methyl",
    "TRIM44 rna"
  ],
  "TRIM45": [
    "TRIM45 cnv",
    "TRIM45 methyl",
    "TRIM45 rna"
  ],
  "TRIM46": [
    "TRIM46 595_604_1_1_S604 phospho",
    "TRIM46 cnv",
    "TRIM46 methyl",
    "TRIM46 proteo",
    "TRIM46 rna"
  ],
  "TRIM47": [
    "TRIM47 cnv",
    "TRIM47 methyl",
    "TRIM47 proteo",
    "TRIM47 rna"
  ],
  "TRIM48": [
    "TRIM48 cnv",
    "TRIM48 rna"
  ],
  "TRIM49": [
    "TRIM49 cnv"
  ],
  "TRIM49B": [
    "TRIM49B cnv",
    "TRIM49B rna"
  ],
  "TRIM49C": [
    "TRIM49C cnv"
  ],
  "TRIM49D1": [
    "TRIM49D1 cnv",
    "TRIM49D1 rna"
  ],
  "TRIM49D2": [
    "TRIM49D2 cnv"
  ],
  "TRIM5": [
    "TRIM5 cnv",
    "TRIM5 proteo",
    "TRIM5 rna"
  ],
  "TRIM50": [
    "TRIM50 cnv",
    "TRIM50 methyl",
    "TRIM50 rna"
  ],
  "TRIM51": [
    "TRIM51 cnv",
    "TRIM51 rna"
  ],
  "TRIM51G": [
    "TRIM51G cnv"
  ],
  "TRIM52": [
    "TRIM52 cnv",
    "TRIM52 methyl",
    "TRIM52 rna"
  ],
  "TRIM52-AS1": [
    "TRIM52-AS1 methyl"
  ],
  "TRIM54": [
    "TRIM54 cnv",
    "TRIM54 rna"
  ],
  "TRIM55": [
    "TRIM55 cnv",
    "TRIM55 methyl",
    "TRIM55 rna"
  ],
  "TRIM56": [
    "TRIM56 418_418_1_1_T418 phospho",
    "TRIM56 434_442_1_1_T442 phospho",
    "TRIM56 469_485_2_2_S469S475 phospho",
    "TRIM56 475_485_1_1_S475 phospho",
    "TRIM56 cnv",
    "TRIM56 proteo",
    "TRIM56 rna"
  ],
  "TRIM58": [
    "TRIM58 cnv",
    "TRIM58 methyl",
    "TRIM58 rna"
  ],
  "TRIM59": [
    "TRIM59 cnv",
    "TRIM59 methyl",
    "TRIM59 rna"
  ],
  "TRIM6": [
    "TRIM6 cnv",
    "TRIM6 rna"
  ],
  "TRIM6-TRIM34": [
    "TRIM6-TRIM34 cnv",
    "TRIM6-TRIM34 rna"
  ],
  "TRIM60": [
    "TRIM60 cnv",
    "TRIM60 rna"
  ],
  "TRIM61": [
    "TRIM61 cnv",
    "TRIM61 rna"
  ],
  "TRIM62": [
    "TRIM62 cnv",
    "TRIM62 methyl",
    "TRIM62 rna"
  ],
  "TRIM63": [
    "TRIM63 cnv",
    "TRIM63 rna"
  ],
  "TRIM64": [
    "TRIM64 cnv"
  ],
  "TRIM64B": [
    "TRIM64B cnv",
    "TRIM64B rna"
  ],
  "TRIM64C": [
    "TRIM64C cnv"
  ],
  "TRIM65": [
    "TRIM65 cnv",
    "TRIM65 methyl",
    "TRIM65 proteo",
    "TRIM65 rna"
  ],
  "TRIM66": [
    "TRIM66 cnv",
    "TRIM66 methyl",
    "TRIM66 rna"
  ],
  "TRIM67": [
    "TRIM67 33_52_1_1_T38 phospho",
    "TRIM67 cnv",
    "TRIM67 methyl",
    "TRIM67 proteo",
    "TRIM67 rna"
  ],
  "TRIM68": [
    "TRIM68 cnv",
    "TRIM68 methyl",
    "TRIM68 proteo",
    "TRIM68 rna"
  ],
  "TRIM69": [
    "TRIM69 cnv",
    "TRIM69 rna"
  ],
  "TRIM7": [
    "TRIM7 cnv",
    "TRIM7 methyl",
    "TRIM7 rna"
  ],
  "TRIM71": [
    "TRIM71 cnv",
    "TRIM71 methyl",
    "TRIM71 rna"
  ],
  "TRIM72": [
    "TRIM72 cnv",
    "TRIM72 rna"
  ],
  "TRIM73": [
    "TRIM73 cnv",
    "TRIM73 methyl",
    "TRIM73 rna"
  ],
  "TRIM74": [
    "TRIM74 cnv",
    "TRIM74 methyl",
    "TRIM74 rna"
  ],
  "TRIM75": [
    "TRIM75 cnv",
    "TRIM75 rna"
  ],
  "TRIM77": [
    "TRIM77 cnv"
  ],
  "TRIM8": [
    "TRIM8 cnv",
    "TRIM8 methyl",
    "TRIM8 rna"
  ],
  "TRIM9": [
    "TRIM9 227_240_1_0 phospho",
    "TRIM9 41_49_1_1_S46 phospho",
    "TRIM9 41_49_1_1_T41 phospho",
    "TRIM9 41_49_2_2_T41S46 phospho",
    "TRIM9 692_708_1_0 phospho",
    "TRIM9 cnv",
    "TRIM9 methyl",
    "TRIM9 proteo",
    "TRIM9 rna"
  ],
  "TRIML1": [
    "TRIML1 cnv",
    "TRIML1 rna"
  ],
  "TRIML2": [
    "TRIML2 cnv",
    "TRIML2 methyl",
    "TRIML2 rna"
  ],
  "TRIO": [
    "TRIO 1723_1724_1_1_S1724 phospho",
    "TRIO 1809_1829_1_1_S1818 phospho",
    "TRIO 1928_1954_1_0 phospho",
    "TRIO 1928_1954_1_1_S1954 phospho",
    "TRIO 2426_2429_1_1_S2429 phospho",
    "TRIO 2455_2467_1_1_S2455 phospho",
    "TRIO 2455_2467_2_2_S2455S2459 phospho",
    "TRIO 2484_2508_1_1_S2492 phospho",
    "TRIO cnv",
    "TRIO kinase",
    "TRIO methyl",
    "TRIO proteo",
    "TRIO rna"
  ],
  "TRIOBP": [
    "TRIOBP 1945_1955_1_1_S1955 phospho",
    "TRIOBP cnv",
    "TRIOBP methyl",
    "TRIOBP proteo",
    "TRIOBP rna"
  ],
  "TRIP10": [
    "TRIP10 296_304_1_1_S296 phospho",
    "TRIP10 335_351_1_1_S351 phospho",
    "TRIP10 cnv",
    "TRIP10 methyl",
    "TRIP10 proteo",
    "TRIP10 rna"
  ],
  "TRIP11": [
    "TRIP11 1881_1890_1_1_S1890 phospho",
    "TRIP11 cnv",
    "TRIP11 methyl",
    "TRIP11 proteo",
    "TRIP11 rna"
  ],
  "TRIP12": [
    "TRIP12 1063_1064_1_1_S1064 phospho",
    "TRIP12 1078_1084_1_1_S1078 phospho",
    "TRIP12 1078_1084_1_1_S1084 phospho",
    "TRIP12 117_122_1_1_S119 phospho",
    "TRIP12 352_361_1_1_S354 phospho",
    "TRIP12 cnv",
    "TRIP12 methyl",
    "TRIP12 proteo",
    "TRIP12 rna"
  ],
  "TRIP13": [
    "TRIP13 cnv",
    "TRIP13 methyl",
    "TRIP13 proteo",
    "TRIP13 rna"
  ],
  "TRIP4": [
    "TRIP4 cnv",
    "TRIP4 methyl",
    "TRIP4 proteo",
    "TRIP4 rna"
  ],
  "TRIP6": [
    "TRIP6 133_162_1_0 phospho",
    "TRIP6 133_162_1_1_S142 phospho",
    "TRIP6 cnv",
    "TRIP6 methyl",
    "TRIP6 proteo",
    "TRIP6 rna"
  ],
  "TRIQK": [
    "TRIQK cnv",
    "TRIQK methyl",
    "TRIQK rna"
  ],
  "TRIR": [
    "TRIR cnv",
    "TRIR methyl",
    "TRIR proteo",
    "TRIR rna"
  ],
  "TRIT1": [
    "TRIT1 cnv",
    "TRIT1 methyl",
    "TRIT1 rna"
  ],
  "TRMO": [
    "TRMO cnv",
    "TRMO methyl",
    "TRMO rna"
  ],
  "TRMT1": [
    "TRMT1 622_628_1_1_S625 phospho",
    "TRMT1 cnv",
    "TRMT1 methyl",
    "TRMT1 proteo",
    "TRMT1 rna"
  ],
  "TRMT10A": [
    "TRMT10A cnv",
    "TRMT10A methyl",
    "TRMT10A proteo",
    "TRMT10A rna"
  ],
  "TRMT10B": [
    "TRMT10B cnv",
    "TRMT10B methyl",
    "TRMT10B rna"
  ],
  "TRMT10C": [
    "TRMT10C cnv",
    "TRMT10C methyl",
    "TRMT10C proteo",
    "TRMT10C rna"
  ],
  "TRMT11": [
    "TRMT11 cnv",
    "TRMT11 methyl",
    "TRMT11 proteo",
    "TRMT11 rna"
  ],
  "TRMT112": [
    "TRMT112 cnv",
    "TRMT112 methyl",
    "TRMT112 proteo",
    "TRMT112 rna"
  ],
  "TRMT12": [
    "TRMT12 cnv",
    "TRMT12 rna"
  ],
  "TRMT13": [
    "TRMT13 cnv",
    "TRMT13 methyl",
    "TRMT13 proteo",
    "TRMT13 rna"
  ],
  "TRMT1L": [
    "TRMT1L 31_71_1_1_S66 phospho",
    "TRMT1L cnv",
    "TRMT1L methyl",
    "TRMT1L proteo",
    "TRMT1L rna"
  ],
  "TRMT2A": [
    "TRMT2A 613_643_1_0 phospho",
    "TRMT2A 613_643_1_1_S620 phospho",
    "TRMT2A cnv",
    "TRMT2A methyl",
    "TRMT2A proteo",
    "TRMT2A rna"
  ],
  "TRMT2B": [
    "TRMT2B methyl",
    "TRMT2B rna"
  ],
  "TRMT44": [
    "TRMT44 cnv",
    "TRMT44 methyl",
    "TRMT44 proteo",
    "TRMT44 rna"
  ],
  "TRMT5": [
    "TRMT5 522_527_1_1_T522 phospho",
    "TRMT5 cnv",
    "TRMT5 methyl",
    "TRMT5 proteo",
    "TRMT5 rna"
  ],
  "TRMT6": [
    "TRMT6 cnv",
    "TRMT6 methyl",
    "TRMT6 proteo",
    "TRMT6 rna"
  ],
  "TRMT61A": [
    "TRMT61A cnv",
    "TRMT61A proteo",
    "TRMT61A rna"
  ],
  "TRMT61B": [
    "TRMT61B cnv",
    "TRMT61B methyl",
    "TRMT61B proteo",
    "TRMT61B rna"
  ],
  "TRMT9B": [
    "TRMT9B cnv",
    "TRMT9B methyl",
    "TRMT9B rna"
  ],
  "TRMU": [
    "TRMU cnv",
    "TRMU methyl",
    "TRMU proteo",
    "TRMU rna"
  ],
  "TRNAU1AP": [
    "TRNAU1AP cnv",
    "TRNAU1AP methyl",
    "TRNAU1AP proteo",
    "TRNAU1AP rna"
  ],
  "TRNP1": [
    "TRNP1 cnv",
    "TRNP1 methyl",
    "TRNP1 rna"
  ],
  "TRNT1": [
    "TRNT1 cnv",
    "TRNT1 methyl",
    "TRNT1 proteo",
    "TRNT1 rna"
  ],
  "TRO": [
    "TRO proteo",
    "TRO rna"
  ],
  "TROAP": [
    "TROAP cnv",
    "TROAP methyl",
    "TROAP rna"
  ],
  "TRPA1": [
    "TRPA1 cnv",
    "TRPA1 methyl",
    "TRPA1 rna"
  ],
  "TRPC1": [
    "TRPC1 cnv",
    "TRPC1 methyl",
    "TRPC1 rna"
  ],
  "TRPC3": [
    "TRPC3 cnv",
    "TRPC3 methyl",
    "TRPC3 rna"
  ],
  "TRPC4": [
    "TRPC4 cnv",
    "TRPC4 methyl",
    "TRPC4 rna"
  ],
  "TRPC4AP": [
    "TRPC4AP cnv",
    "TRPC4AP methyl",
    "TRPC4AP rna"
  ],
  "TRPC5": [
    "TRPC5 methyl",
    "TRPC5 rna"
  ],
  "TRPC5OS": [
    "TRPC5OS rna"
  ],
  "TRPC6": [
    "TRPC6 cnv",
    "TRPC6 methyl",
    "TRPC6 rna"
  ],
  "TRPC7": [
    "TRPC7 cnv",
    "TRPC7 rna"
  ],
  "TRPM1": [
    "TRPM1 cnv",
    "TRPM1 rna"
  ],
  "TRPM2": [
    "TRPM2 cnv",
    "TRPM2 methyl",
    "TRPM2 rna"
  ],
  "TRPM3": [
    "TRPM3 cnv",
    "TRPM3 methyl",
    "TRPM3 rna"
  ],
  "TRPM4": [
    "TRPM4 cnv",
    "TRPM4 methyl",
    "TRPM4 proteo",
    "TRPM4 rna"
  ],
  "TRPM5": [
    "TRPM5 cnv",
    "TRPM5 methyl",
    "TRPM5 rna"
  ],
  "TRPM6": [
    "TRPM6 cnv",
    "TRPM6 kinase",
    "TRPM6 methyl",
    "TRPM6 rna"
  ],
  "TRPM7": [
    "TRPM7 1404_1410_1_0 phospho",
    "TRPM7 1503_1512_1_1_S1503 phospho",
    "TRPM7 cnv",
    "TRPM7 kinase",
    "TRPM7 methyl",
    "TRPM7 proteo",
    "TRPM7 rna"
  ],
  "TRPM8": [
    "TRPM8 cnv",
    "TRPM8 methyl",
    "TRPM8 rna"
  ],
  "TRPS1": [
    "TRPS1 1084_1089_2_2_S1085S1089 phospho",
    "TRPS1 165_188_1_1_S182 phospho",
    "TRPS1 204_220_1_1_S220 phospho",
    "TRPS1 807_828_1_1_S807 phospho",
    "TRPS1 830_834_1_1_S834 phospho",
    "TRPS1 cnv",
    "TRPS1 methyl",
    "TRPS1 proteo",
    "TRPS1 rna"
  ],
  "TRPT1": [
    "TRPT1 228_240_1_1_S240 phospho",
    "TRPT1 cnv",
    "TRPT1 methyl",
    "TRPT1 proteo",
    "TRPT1 rna"
  ],
  "TRPV1": [
    "TRPV1 cnv",
    "TRPV1 rna"
  ],
  "TRPV2": [
    "TRPV2 cnv",
    "TRPV2 proteo",
    "TRPV2 rna"
  ],
  "TRPV3": [
    "TRPV3 cnv",
    "TRPV3 rna"
  ],
  "TRPV4": [
    "TRPV4 cnv",
    "TRPV4 methyl",
    "TRPV4 rna"
  ],
  "TRPV5": [
    "TRPV5 cnv",
    "TRPV5 rna"
  ],
  "TRPV6": [
    "TRPV6 cnv",
    "TRPV6 rna"
  ],
  "TRRAP": [
    "TRRAP 2051_2054_1_1_S2051 phospho",
    "TRRAP cnv",
    "TRRAP methyl",
    "TRRAP proteo",
    "TRRAP rna"
  ],
  "TRUB1": [
    "TRUB1 cnv",
    "TRUB1 methyl",
    "TRUB1 proteo",
    "TRUB1 rna"
  ],
  "TRUB2": [
    "TRUB2 cnv",
    "TRUB2 methyl",
    "TRUB2 proteo",
    "TRUB2 rna"
  ],
  "TSACC": [
    "TSACC cnv",
    "TSACC methyl",
    "TSACC rna"
  ],
  "TSBP1": [
    "TSBP1 cnv",
    "TSBP1 rna"
  ],
  "TSC1": [
    "TSC1 1038_1047_1_1_S1041 phospho",
    "TSC1 1100_1116_1_0 phospho",
    "TSC1 1100_1116_1_1_S1100 phospho",
    "TSC1 1141_1164_1_1_S1141 phospho",
    "TSC1 386_417_1_1_S394 phospho",
    "TSC1 487_491_1_1_S487 phospho",
    "TSC1 cnv",
    "TSC1 methyl",
    "TSC1 proteo",
    "TSC1 rna"
  ],
  "TSC2": [
    "TSC2 1364_1383_1_1_S1371 phospho",
    "TSC2 1411_1411_1_1_S1411 phospho",
    "TSC2 1418_1437_1_1_S1420 phospho",
    "TSC2 1447_1449_1_1_S1449 phospho",
    "TSC2 1447_1454_2_0 phospho",
    "TSC2 1798_1804_1_1_S1799 phospho",
    "TSC2 cnv",
    "TSC2 methyl",
    "TSC2 mut",
    "TSC2 proteo",
    "TSC2 rna"
  ],
  "TSC22D1": [
    "TSC22D1 22_36_1_1_S22 phospho",
    "TSC22D1 263_291_1_0 phospho",
    "TSC22D1 cnv",
    "TSC22D1 methyl",
    "TSC22D1 proteo",
    "TSC22D1 rna"
  ],
  "TSC22D1-AS1": [
    "TSC22D1-AS1 methyl"
  ],
  "TSC22D2": [
    "TSC22D2 205_211_1_1_T207 phospho",
    "TSC22D2 cnv",
    "TSC22D2 methyl",
    "TSC22D2 proteo",
    "TSC22D2 rna"
  ],
  "TSC22D3": [
    "TSC22D3 73_83_1_1_S73 phospho",
    "TSC22D3 methyl",
    "TSC22D3 proteo",
    "TSC22D3 rna"
  ],
  "TSC22D4": [
    "TSC22D4 165_177_1_1_S165 phospho",
    "TSC22D4 211_215_1_1_T211 phospho",
    "TSC22D4 225_233_1_1_T229 phospho",
    "TSC22D4 260_274_1_0 phospho",
    "TSC22D4 260_279_2_0 phospho",
    "TSC22D4 279_279_1_1_S279 phospho",
    "TSC22D4 62_70_1_1_S62 phospho",
    "TSC22D4 cnv",
    "TSC22D4 methyl",
    "TSC22D4 proteo",
    "TSC22D4 rna"
  ],
  "TSEN15": [
    "TSEN15 cnv",
    "TSEN15 proteo",
    "TSEN15 rna"
  ],
  "TSEN2": [
    "TSEN2 cnv",
    "TSEN2 methyl",
    "TSEN2 rna"
  ],
  "TSEN34": [
    "TSEN34 cnv",
    "TSEN34 methyl",
    "TSEN34 proteo",
    "TSEN34 rna"
  ],
  "TSEN54": [
    "TSEN54 cnv",
    "TSEN54 methyl",
    "TSEN54 rna"
  ],
  "TSFM": [
    "TSFM 345_345_1_1_T345 phospho",
    "TSFM cnv",
    "TSFM methyl",
    "TSFM proteo",
    "TSFM rna"
  ],
  "TSG101": [
    "TSG101 cnv",
    "TSG101 methyl",
    "TSG101 proteo",
    "TSG101 rna"
  ],
  "TSGA10": [
    "TSGA10 cnv",
    "TSGA10 methyl",
    "TSGA10 rna"
  ],
  "TSGA10IP": [
    "TSGA10IP cnv",
    "TSGA10IP rna"
  ],
  "TSGA13": [
    "TSGA13 cnv",
    "TSGA13 rna"
  ],
  "TSHB": [
    "TSHB cnv"
  ],
  "TSHR": [
    "TSHR cnv",
    "TSHR methyl",
    "TSHR rna"
  ],
  "TSHZ1": [
    "TSHZ1 489_496_1_1_S489 phospho",
    "TSHZ1 611_628_1_1_T628 phospho",
    "TSHZ1 cnv",
    "TSHZ1 methyl",
    "TSHZ1 rna"
  ],
  "TSHZ2": [
    "TSHZ2 cnv",
    "TSHZ2 methyl",
    "TSHZ2 rna"
  ],
  "TSHZ3": [
    "TSHZ3 444_463_1_1_S463 phospho",
    "TSHZ3 cnv",
    "TSHZ3 methyl",
    "TSHZ3 rna"
  ],
  "TSKS": [
    "TSKS cnv",
    "TSKS rna"
  ],
  "TSKU": [
    "TSKU cnv",
    "TSKU methyl",
    "TSKU rna"
  ],
  "TSKU-AS1": [
    "TSKU-AS1 methyl"
  ],
  "TSLP": [
    "TSLP cnv",
    "TSLP methyl",
    "TSLP rna"
  ],
  "TSN": [
    "TSN cnv",
    "TSN methyl",
    "TSN proteo",
    "TSN rna"
  ],
  "TSNARE1": [
    "TSNARE1 cnv",
    "TSNARE1 methyl",
    "TSNARE1 rna"
  ],
  "TSNAX": [
    "TSNAX 31_33_1_1_S33 phospho",
    "TSNAX cnv",
    "TSNAX methyl",
    "TSNAX proteo",
    "TSNAX rna"
  ],
  "TSNAX-DISC1": [
    "TSNAX-DISC1 cnv",
    "TSNAX-DISC1 rna"
  ],
  "TSNAXIP1": [
    "TSNAXIP1 cnv",
    "TSNAXIP1 methyl",
    "TSNAXIP1 rna"
  ],
  "TSPAN1": [
    "TSPAN1 cnv",
    "TSPAN1 rna"
  ],
  "TSPAN10": [
    "TSPAN10 cnv",
    "TSPAN10 methyl",
    "TSPAN10 rna"
  ],
  "TSPAN11": [
    "TSPAN11 cnv",
    "TSPAN11 methyl",
    "TSPAN11 proteo",
    "TSPAN11 rna"
  ],
  "TSPAN12": [
    "TSPAN12 cnv",
    "TSPAN12 methyl",
    "TSPAN12 rna"
  ],
  "TSPAN13": [
    "TSPAN13 cnv",
    "TSPAN13 methyl",
    "TSPAN13 proteo",
    "TSPAN13 rna"
  ],
  "TSPAN14": [
    "TSPAN14 cnv",
    "TSPAN14 methyl",
    "TSPAN14 proteo",
    "TSPAN14 rna"
  ],
  "TSPAN15": [
    "TSPAN15 cnv",
    "TSPAN15 methyl",
    "TSPAN15 proteo",
    "TSPAN15 rna"
  ],
  "TSPAN16": [
    "TSPAN16 cnv",
    "TSPAN16 rna"
  ],
  "TSPAN17": [
    "TSPAN17 cnv",
    "TSPAN17 methyl",
    "TSPAN17 rna"
  ],
  "TSPAN18": [
    "TSPAN18 cnv",
    "TSPAN18 rna"
  ],
  "TSPAN19": [
    "TSPAN19 cnv",
    "TSPAN19 rna"
  ],
  "TSPAN2": [
    "TSPAN2 cnv",
    "TSPAN2 methyl",
    "TSPAN2 rna"
  ],
  "TSPAN3": [
    "TSPAN3 NQSVPLSCCR-N2H4F0S0G0 glyco",
    "TSPAN3 NQSVPLSCCR-N2H5F0S0G0 glyco",
    "TSPAN3 cnv",
    "TSPAN3 methyl",
    "TSPAN3 proteo",
    "TSPAN3 rna"
  ],
  "TSPAN31": [
    "TSPAN31 cnv",
    "TSPAN31 methyl",
    "TSPAN31 proteo",
    "TSPAN31 rna"
  ],
  "TSPAN32": [
    "TSPAN32 cnv",
    "TSPAN32 rna"
  ],
  "TSPAN33": [
    "TSPAN33 cnv",
    "TSPAN33 methyl",
    "TSPAN33 rna"
  ],
  "TSPAN4": [
    "TSPAN4 cnv",
    "TSPAN4 methyl",
    "TSPAN4 rna"
  ],
  "TSPAN5": [
    "TSPAN5 cnv",
    "TSPAN5 methyl",
    "TSPAN5 rna"
  ],
  "TSPAN6": [
    "TSPAN6 methyl",
    "TSPAN6 proteo",
    "TSPAN6 rna"
  ],
  "TSPAN7": [
    "TSPAN7 methyl",
    "TSPAN7 proteo",
    "TSPAN7 rna"
  ],
  "TSPAN8": [
    "TSPAN8 cnv",
    "TSPAN8 rna"
  ],
  "TSPAN9": [
    "TSPAN9 cnv",
    "TSPAN9 methyl",
    "TSPAN9 proteo",
    "TSPAN9 rna"
  ],
  "TSPEAR": [
    "TSPEAR cnv",
    "TSPEAR rna"
  ],
  "TSPO": [
    "TSPO cnv",
    "TSPO methyl",
    "TSPO proteo",
    "TSPO rna"
  ],
  "TSPO2": [
    "TSPO2 cnv",
    "TSPO2 rna"
  ],
  "TSPOAP1": [
    "TSPOAP1 cnv",
    "TSPOAP1 rna"
  ],
  "TSPOAP1-AS1": [
    "TSPOAP1-AS1 methyl"
  ],
  "TSPY1": [
    "TSPY1 methyl"
  ],
  "TSPY2": [
    "TSPY2 methyl",
    "TSPY2 rna"
  ],
  "TSPY8": [
    "TSPY8 methyl"
  ],
  "TSPYL1": [
    "TSPYL1 cnv",
    "TSPYL1 methyl",
    "TSPYL1 proteo",
    "TSPYL1 rna"
  ],
  "TSPYL2": [
    "TSPYL2 methyl",
    "TSPYL2 rna"
  ],
  "TSPYL4": [
    "TSPYL4 cnv",
    "TSPYL4 methyl",
    "TSPYL4 proteo",
    "TSPYL4 rna"
  ],
  "TSPYL5": [
    "TSPYL5 cnv",
    "TSPYL5 methyl",
    "TSPYL5 proteo",
    "TSPYL5 rna"
  ],
  "TSPYL6": [
    "TSPYL6 cnv",
    "TSPYL6 methyl",
    "TSPYL6 rna"
  ],
  "TSR1": [
    "TSR1 cnv",
    "TSR1 methyl",
    "TSR1 proteo",
    "TSR1 rna"
  ],
  "TSR2": [
    "TSR2 rna"
  ],
  "TSR3": [
    "TSR3 cnv",
    "TSR3 methyl",
    "TSR3 proteo",
    "TSR3 rna"
  ],
  "TSSC4": [
    "TSSC4 319_321_1_1_S321 phospho",
    "TSSC4 cnv",
    "TSSC4 methyl",
    "TSSC4 proteo",
    "TSSC4 rna"
  ],
  "TSSK1B": [
    "TSSK1B cnv",
    "TSSK1B kinase",
    "TSSK1B rna"
  ],
  "TSSK2": [
    "TSSK2 cnv",
    "TSSK2 kinase",
    "TSSK2 rna"
  ],
  "TSSK3": [
    "TSSK3 cnv",
    "TSSK3 kinase",
    "TSSK3 methyl",
    "TSSK3 rna"
  ],
  "TSSK4": [
    "TSSK4 cnv",
    "TSSK4 kinase",
    "TSSK4 rna"
  ],
  "TSSK6": [
    "TSSK6 cnv",
    "TSSK6 kinase",
    "TSSK6 methyl",
    "TSSK6 rna"
  ],
  "TST": [
    "TST cnv",
    "TST methyl",
    "TST proteo",
    "TST rna"
  ],
  "TSTD1": [
    "TSTD1 cnv",
    "TSTD1 methyl",
    "TSTD1 proteo",
    "TSTD1 rna"
  ],
  "TSTD2": [
    "TSTD2 cnv",
    "TSTD2 methyl",
    "TSTD2 rna"
  ],
  "TSTD3": [
    "TSTD3 cnv",
    "TSTD3 methyl",
    "TSTD3 rna"
  ],
  "TTBK1": [
    "TTBK1 315_331_1_1_T325 phospho",
    "TTBK1 432_444_2_2_S433S441 phospho",
    "TTBK1 441_444_1_1_S441 phospho",
    "TTBK1 456_459_1_1_S456 phospho",
    "TTBK1 483_485_1_1_S483 phospho",
    "TTBK1 627_645_2_2_S637S641 phospho",
    "TTBK1 821_833_1_1_S821 phospho",
    "TTBK1 cnv",
    "TTBK1 kinase",
    "TTBK1 methyl",
    "TTBK1 proteo",
    "TTBK1 rna"
  ],
  "TTBK2": [
    "TTBK2 445_448_1_1_S448 phospho",
    "TTBK2 cnv",
    "TTBK2 kinase",
    "TTBK2 methyl",
    "TTBK2 rna"
  ],
  "TTC1": [
    "TTC1 cnv",
    "TTC1 proteo",
    "TTC1 rna"
  ],
  "TTC12": [
    "TTC12 cnv",
    "TTC12 methyl",
    "TTC12 rna"
  ],
  "TTC13": [
    "TTC13 cnv",
    "TTC13 methyl",
    "TTC13 proteo",
    "TTC13 rna"
  ],
  "TTC14": [
    "TTC14 669_678_1_1_S671 phospho",
    "TTC14 cnv",
    "TTC14 methyl",
    "TTC14 proteo",
    "TTC14 rna"
  ],
  "TTC16": [
    "TTC16 cnv",
    "TTC16 methyl",
    "TTC16 rna"
  ],
  "TTC17": [
    "TTC17 cnv",
    "TTC17 methyl",
    "TTC17 proteo",
    "TTC17 rna"
  ],
  "TTC19": [
    "TTC19 cnv",
    "TTC19 methyl",
    "TTC19 proteo",
    "TTC19 rna"
  ],
  "TTC21A": [
    "TTC21A cnv",
    "TTC21A methyl",
    "TTC21A proteo",
    "TTC21A rna"
  ],
  "TTC21B": [
    "TTC21B cnv",
    "TTC21B methyl",
    "TTC21B proteo",
    "TTC21B rna"
  ],
  "TTC22": [
    "TTC22 cnv",
    "TTC22 methyl",
    "TTC22 rna"
  ],
  "TTC23": [
    "TTC23 cnv",
    "TTC23 methyl",
    "TTC23 rna"
  ],
  "TTC23L": [
    "TTC23L cnv",
    "TTC23L methyl",
    "TTC23L rna"
  ],
  "TTC24": [
    "TTC24 cnv",
    "TTC24 rna"
  ],
  "TTC26": [
    "TTC26 cnv",
    "TTC26 methyl",
    "TTC26 proteo",
    "TTC26 rna"
  ],
  "TTC27": [
    "TTC27 cnv",
    "TTC27 methyl",
    "TTC27 proteo",
    "TTC27 rna"
  ],
  "TTC28": [
    "TTC28 2102_2108_1_1_S2108 phospho",
    "TTC28 2246_2258_1_1_S2251 phospho",
    "TTC28 2262_2279_1_1_S2271 phospho",
    "TTC28 2393_2398_1_1_S2398 phospho",
    "TTC28 28_42_1_1_S28 phospho",
    "TTC28 47_54_1_1_S47 phospho",
    "TTC28 cnv",
    "TTC28 methyl",
    "TTC28 proteo",
    "TTC28 rna"
  ],
  "TTC28-AS1": [
    "TTC28-AS1 methyl"
  ],
  "TTC29": [
    "TTC29 cnv",
    "TTC29 methyl",
    "TTC29 rna"
  ],
  "TTC3": [
    "TTC3 1009_1017_1_1_S1009 phospho",
    "TTC3 cnv",
    "TTC3 methyl",
    "TTC3 proteo",
    "TTC3 rna"
  ],
  "TTC30A": [
    "TTC30A cnv",
    "TTC30A methyl",
    "TTC30A rna"
  ],
  "TTC30B": [
    "TTC30B cnv",
    "TTC30B methyl",
    "TTC30B rna"
  ],
  "TTC31": [
    "TTC31 cnv",
    "TTC31 methyl",
    "TTC31 rna"
  ],
  "TTC32": [
    "TTC32 cnv",
    "TTC32 methyl",
    "TTC32 rna"
  ],
  "TTC33": [
    "TTC33 187_197_1_1_S197 phospho",
    "TTC33 cnv",
    "TTC33 methyl",
    "TTC33 proteo",
    "TTC33 rna"
  ],
  "TTC34": [
    "TTC34 cnv",
    "TTC34 methyl",
    "TTC34 rna"
  ],
  "TTC36": [
    "TTC36 cnv",
    "TTC36 rna"
  ],
  "TTC37": [
    "TTC37 cnv",
    "TTC37 methyl",
    "TTC37 proteo",
    "TTC37 rna"
  ],
  "TTC38": [
    "TTC38 cnv",
    "TTC38 methyl",
    "TTC38 proteo",
    "TTC38 rna"
  ],
  "TTC39A": [
    "TTC39A cnv",
    "TTC39A methyl",
    "TTC39A rna"
  ],
  "TTC39B": [
    "TTC39B cnv",
    "TTC39B methyl",
    "TTC39B proteo",
    "TTC39B rna"
  ],
  "TTC39C": [
    "TTC39C cnv",
    "TTC39C methyl",
    "TTC39C proteo",
    "TTC39C rna"
  ],
  "TTC4": [
    "TTC4 cnv",
    "TTC4 methyl",
    "TTC4 proteo",
    "TTC4 rna"
  ],
  "TTC5": [
    "TTC5 cnv",
    "TTC5 proteo",
    "TTC5 rna"
  ],
  "TTC6": [
    "TTC6 cnv",
    "TTC6 methyl",
    "TTC6 rna"
  ],
  "TTC7A": [
    "TTC7A 51_61_1_1_S51 phospho",
    "TTC7A 671_677_1_1_S671 phospho",
    "TTC7A cnv",
    "TTC7A methyl",
    "TTC7A proteo",
    "TTC7A rna"
  ],
  "TTC7B": [
    "TTC7B 158_162_1_1_S160 phospho",
    "TTC7B 158_176_1_0 phospho",
    "TTC7B 158_176_1_1_S160 phospho",
    "TTC7B 196_220_1_1_S202 phospho",
    "TTC7B 202_220_1_1_S202 phospho",
    "TTC7B 615_630_2_2_S629S630 phospho",
    "TTC7B 673_682_1_1_S678 phospho",
    "TTC7B cnv",
    "TTC7B methyl",
    "TTC7B proteo",
    "TTC7B rna"
  ],
  "TTC8": [
    "TTC8 cnv",
    "TTC8 methyl",
    "TTC8 proteo",
    "TTC8 rna"
  ],
  "TTC9": [
    "TTC9 15_15_1_1_S15 phospho",
    "TTC9 cnv",
    "TTC9 methyl",
    "TTC9 proteo",
    "TTC9 rna"
  ],
  "TTC9-DT": [
    "TTC9-DT methyl"
  ],
  "TTC9B": [
    "TTC9B cnv",
    "TTC9B methyl",
    "TTC9B proteo",
    "TTC9B rna"
  ],
  "TTC9C": [
    "TTC9C cnv",
    "TTC9C methyl",
    "TTC9C proteo",
    "TTC9C rna"
  ],
  "TTF1": [
    "TTF1 cnv",
    "TTF1 methyl",
    "TTF1 proteo",
    "TTF1 rna"
  ],
  "TTF2": [
    "TTF2 cnv",
    "TTF2 methyl",
    "TTF2 proteo",
    "TTF2 rna"
  ],
  "TTI1": [
    "TTI1 cnv",
    "TTI1 methyl",
    "TTI1 proteo",
    "TTI1 rna"
  ],
  "TTI2": [
    "TTI2 cnv",
    "TTI2 proteo",
    "TTI2 rna"
  ],
  "TTK": [
    "TTK cnv",
    "TTK kinase",
    "TTK methyl",
    "TTK rna"
  ],
  "TTL": [
    "TTL cnv",
    "TTL methyl",
    "TTL proteo",
    "TTL rna"
  ],
  "TTLL1": [
    "TTLL1 cnv",
    "TTLL1 methyl",
    "TTLL1 rna"
  ],
  "TTLL10": [
    "TTLL10 cnv",
    "TTLL10 methyl",
    "TTLL10 rna"
  ],
  "TTLL11": [
    "TTLL11 cnv",
    "TTLL11 methyl",
    "TTLL11 rna"
  ],
  "TTLL12": [
    "TTLL12 15_20_1_0 phospho",
    "TTLL12 15_20_1_1_S16 phospho",
    "TTLL12 426_432_1_1_S426 phospho",
    "TTLL12 cnv",
    "TTLL12 methyl",
    "TTLL12 proteo",
    "TTLL12 rna"
  ],
  "TTLL13": [
    "TTLL13 cnv",
    "TTLL13 methyl",
    "TTLL13 rna"
  ],
  "TTLL2": [
    "TTLL2 cnv",
    "TTLL2 rna"
  ],
  "TTLL3": [
    "TTLL3 cnv",
    "TTLL3 methyl",
    "TTLL3 rna"
  ],
  "TTLL4": [
    "TTLL4 cnv",
    "TTLL4 methyl",
    "TTLL4 rna"
  ],
  "TTLL5": [
    "TTLL5 cnv",
    "TTLL5 methyl",
    "TTLL5 rna"
  ],
  "TTLL6": [
    "TTLL6 cnv",
    "TTLL6 methyl",
    "TTLL6 rna"
  ],
  "TTLL7": [
    "TTLL7 cnv",
    "TTLL7 methyl",
    "TTLL7 rna"
  ],
  "TTLL8": [
    "TTLL8 cnv",
    "TTLL8 methyl",
    "TTLL8 rna"
  ],
  "TTLL9": [
    "TTLL9 cnv",
    "TTLL9 methyl",
    "TTLL9 rna"
  ],
  "TTN": [
    "TTN cnv",
    "TTN kinase",
    "TTN mut",
    "TTN proteo",
    "TTN rna"
  ],
  "TTPA": [
    "TTPA cnv",
    "TTPA methyl",
    "TTPA rna"
  ],
  "TTPAL": [
    "TTPAL cnv",
    "TTPAL methyl",
    "TTPAL proteo",
    "TTPAL rna"
  ],
  "TTR": [
    "TTR cnv",
    "TTR proteo",
    "TTR rna"
  ],
  "TTTY10": [
    "TTTY10 methyl"
  ],
  "TTTY14": [
    "TTTY14 methyl"
  ],
  "TTTY23B": [
    "TTTY23B methyl"
  ],
  "TTYH1": [
    "TTYH1 426_447_1_1_S435 phospho",
    "TTYH1 435_447_1_1_S447 phospho",
    "TTYH1 449_450_1_1_S450 phospho",
    "TTYH1 cnv",
    "TTYH1 methyl",
    "TTYH1 proteo",
    "TTYH1 rna"
  ],
  "TTYH2": [
    "TTYH2 423_423_1_1_S423 phospho",
    "TTYH2 473_491_1_1_S483 phospho",
    "TTYH2 483_491_1_1_S483 phospho",
    "TTYH2 cnv",
    "TTYH2 methyl",
    "TTYH2 proteo",
    "TTYH2 rna"
  ],
  "TTYH3": [
    "TTYH3 437_439_1_1_S437 phospho",
    "TTYH3 489_504_1_1_S496 phospho",
    "TTYH3 cnv",
    "TTYH3 methyl",
    "TTYH3 proteo",
    "TTYH3 rna"
  ],
  "TUB": [
    "TUB cnv",
    "TUB methyl",
    "TUB proteo",
    "TUB rna"
  ],
  "TUBA1A": [
    "TUBA1A cnv",
    "TUBA1A methyl",
    "TUBA1A rna"
  ],
  "TUBA1B": [
    "TUBA1B cnv",
    "TUBA1B methyl",
    "TUBA1B rna"
  ],
  "TUBA1C": [
    "TUBA1C cnv",
    "TUBA1C methyl",
    "TUBA1C proteo",
    "TUBA1C rna"
  ],
  "TUBA3C": [
    "TUBA3C 432_450_1_1_Y450 phospho",
    "TUBA3C cnv",
    "TUBA3C rna"
  ],
  "TUBA3D": [
    "TUBA3D cnv",
    "TUBA3D methyl",
    "TUBA3D rna"
  ],
  "TUBA3E": [
    "TUBA3E cnv",
    "TUBA3E methyl",
    "TUBA3E rna"
  ],
  "TUBA3FP": [
    "TUBA3FP methyl"
  ],
  "TUBA4A": [
    "TUBA4A cnv",
    "TUBA4A methyl",
    "TUBA4A proteo",
    "TUBA4A rna"
  ],
  "TUBA4B": [
    "TUBA4B cnv",
    "TUBA4B methyl",
    "TUBA4B rna"
  ],
  "TUBA8": [
    "TUBA8 cnv",
    "TUBA8 methyl",
    "TUBA8 proteo",
    "TUBA8 rna"
  ],
  "TUBAL3": [
    "TUBAL3 cnv",
    "TUBAL3 proteo",
    "TUBAL3 rna"
  ],
  "TUBB": [
    "TUBB 48_55_1_1_T55 phospho",
    "TUBB cnv",
    "TUBB methyl",
    "TUBB proteo",
    "TUBB rna"
  ],
  "TUBB1": [
    "TUBB1 cnv",
    "TUBB1 proteo",
    "TUBB1 rna"
  ],
  "TUBB2A": [
    "TUBB2A cnv",
    "TUBB2A methyl",
    "TUBB2A proteo",
    "TUBB2A rna"
  ],
  "TUBB2B": [
    "TUBB2B 50_55_1_1_T55 phospho",
    "TUBB2B cnv",
    "TUBB2B methyl",
    "TUBB2B proteo",
    "TUBB2B rna"
  ],
  "TUBB3": [
    "TUBB3 48_56_1_1_S55 phospho",
    "TUBB3 cnv",
    "TUBB3 methyl",
    "TUBB3 proteo",
    "TUBB3 rna"
  ],
  "TUBB4A": [
    "TUBB4A 101_110_1_1_T106 phospho",
    "TUBB4A cnv",
    "TUBB4A methyl",
    "TUBB4A proteo",
    "TUBB4A rna"
  ],
  "TUBB4B": [
    "TUBB4B 50_55_1_1_T55 phospho",
    "TUBB4B cnv",
    "TUBB4B methyl",
    "TUBB4B proteo",
    "TUBB4B rna"
  ],
  "TUBB6": [
    "TUBB6 cnv",
    "TUBB6 methyl",
    "TUBB6 proteo",
    "TUBB6 rna"
  ],
  "TUBB8": [
    "TUBB8 cnv",
    "TUBB8 methyl",
    "TUBB8 proteo",
    "TUBB8 rna"
  ],
  "TUBB8B": [
    "TUBB8B cnv",
    "TUBB8B methyl",
    "TUBB8B rna"
  ],
  "TUBD1": [
    "TUBD1 cnv",
    "TUBD1 methyl",
    "TUBD1 rna"
  ],
  "TUBE1": [
    "TUBE1 cnv",
    "TUBE1 methyl",
    "TUBE1 rna"
  ],
  "TUBG1": [
    "TUBG1 cnv",
    "TUBG1 methyl",
    "TUBG1 proteo",
    "TUBG1 rna"
  ],
  "TUBG2": [
    "TUBG2 cnv",
    "TUBG2 methyl",
    "TUBG2 rna"
  ],
  "TUBGCP2": [
    "TUBGCP2 cnv",
    "TUBGCP2 methyl",
    "TUBGCP2 proteo",
    "TUBGCP2 rna"
  ],
  "TUBGCP3": [
    "TUBGCP3 502_514_1_1_S505 phospho",
    "TUBGCP3 cnv",
    "TUBGCP3 methyl",
    "TUBGCP3 proteo",
    "TUBGCP3 rna"
  ],
  "TUBGCP4": [
    "TUBGCP4 cnv",
    "TUBGCP4 methyl",
    "TUBGCP4 proteo",
    "TUBGCP4 rna"
  ],
  "TUBGCP5": [
    "TUBGCP5 cnv",
    "TUBGCP5 methyl",
    "TUBGCP5 proteo",
    "TUBGCP5 rna"
  ],
  "TUBGCP6": [
    "TUBGCP6 cnv",
    "TUBGCP6 methyl",
    "TUBGCP6 proteo",
    "TUBGCP6 rna"
  ],
  "TUFM": [
    "TUFM cnv",
    "TUFM methyl",
    "TUFM proteo",
    "TUFM rna"
  ],
  "TUFT1": [
    "TUFT1 cnv",
    "TUFT1 methyl",
    "TUFT1 rna"
  ],
  "TUG1": [
    "TUG1 cnv",
    "TUG1 rna"
  ],
  "TULP1": [
    "TULP1 cnv",
    "TULP1 methyl",
    "TULP1 rna"
  ],
  "TULP2": [
    "TULP2 cnv",
    "TULP2 rna"
  ],
  "TULP3": [
    "TULP3 cnv",
    "TULP3 methyl",
    "TULP3 proteo",
    "TULP3 rna"
  ],
  "TULP4": [
    "TULP4 563_565_1_1_S565 phospho",
    "TULP4 cnv",
    "TULP4 methyl",
    "TULP4 rna"
  ],
  "TUNAR": [
    "TUNAR cnv",
    "TUNAR rna"
  ],
  "TUSC1": [
    "TUSC1 cnv",
    "TUSC1 methyl",
    "TUSC1 proteo",
    "TUSC1 rna"
  ],
  "TUSC2": [
    "TUSC2 cnv",
    "TUSC2 methyl",
    "TUSC2 proteo",
    "TUSC2 rna"
  ],
  "TUSC3": [
    "TUSC3 cnv",
    "TUSC3 methyl",
    "TUSC3 proteo",
    "TUSC3 rna"
  ],
  "TUT1": [
    "TUT1 680_696_1_1_S682 phospho",
    "TUT1 682_696_1_1_S682 phospho",
    "TUT1 cnv",
    "TUT1 methyl",
    "TUT1 proteo",
    "TUT1 rna"
  ],
  "TUT4": [
    "TUT4 cnv",
    "TUT4 methyl",
    "TUT4 proteo",
    "TUT4 rna"
  ],
  "TUT7": [
    "TUT7 132_140_1_1_S132 phospho",
    "TUT7 cnv",
    "TUT7 methyl",
    "TUT7 proteo",
    "TUT7 rna"
  ],
  "TVP23A": [
    "TVP23A cnv",
    "TVP23A methyl",
    "TVP23A rna"
  ],
  "TVP23B": [
    "TVP23B cnv",
    "TVP23B methyl",
    "TVP23B rna"
  ],
  "TVP23C": [
    "TVP23C cnv",
    "TVP23C methyl",
    "TVP23C rna"
  ],
  "TVP23C-CDRT4": [
    "TVP23C-CDRT4 cnv",
    "TVP23C-CDRT4 methyl",
    "TVP23C-CDRT4 rna"
  ],
  "TWF1": [
    "TWF1 137_148_1_1_S143 phospho",
    "TWF1 322_322_1_1_S322 phospho",
    "TWF1 345_349_1_1_T349 phospho",
    "TWF1 cnv",
    "TWF1 methyl",
    "TWF1 proteo",
    "TWF1 rna"
  ],
  "TWF2": [
    "TWF2 cnv",
    "TWF2 methyl",
    "TWF2 proteo",
    "TWF2 rna"
  ],
  "TWF2-DT": [
    "TWF2-DT methyl"
  ],
  "TWIST1": [
    "TWIST1 cnv",
    "TWIST1 methyl",
    "TWIST1 rna"
  ],
  "TWIST2": [
    "TWIST2 cnv",
    "TWIST2 methyl",
    "TWIST2 rna"
  ],
  "TWNK": [
    "TWNK cnv",
    "TWNK methyl",
    "TWNK rna"
  ],
  "TWSG1": [
    "TWSG1 NYSDTPPTSK-N2H6F0S0G0 glyco",
    "TWSG1 NYSDTPPTSK-N2H7F0S0G0 glyco",
    "TWSG1 NYSDTPPTSK-N2H8F0S0G0 glyco",
    "TWSG1 cnv",
    "TWSG1 methyl",
    "TWSG1 proteo",
    "TWSG1 rna"
  ],
  "TXK": [
    "TXK cnv",
    "TXK kinase",
    "TXK rna"
  ],
  "TXLNA": [
    "TXLNA 514_515_1_1_S515 phospho",
    "TXLNA cnv",
    "TXLNA methyl",
    "TXLNA proteo",
    "TXLNA rna"
  ],
  "TXLNB": [
    "TXLNB 15_26_1_1_T16 phospho",
    "TXLNB cnv",
    "TXLNB proteo",
    "TXLNB rna"
  ],
  "TXLNG": [
    "TXLNG 97_105_1_1_S97 phospho",
    "TXLNG methyl",
    "TXLNG proteo",
    "TXLNG rna"
  ],
  "TXLNGY": [
    "TXLNGY methyl"
  ],
  "TXN": [
    "TXN cnv",
    "TXN methyl",
    "TXN proteo",
    "TXN rna"
  ],
  "TXN2": [
    "TXN2 cnv",
    "TXN2 proteo",
    "TXN2 rna"
  ],
  "TXNDC11": [
    "TXNDC11 cnv",
    "TXNDC11 methyl",
    "TXNDC11 rna"
  ],
  "TXNDC12": [
    "TXNDC12 cnv",
    "TXNDC12 methyl",
    "TXNDC12 proteo",
    "TXNDC12 rna"
  ],
  "TXNDC15": [
    "TXNDC15 IFIFNQTGIEAK-N2H8F0S0G0 glyco",
    "TXNDC15 cnv",
    "TXNDC15 methyl",
    "TXNDC15 proteo",
    "TXNDC15 rna"
  ],
  "TXNDC16": [
    "TXNDC16 cnv",
    "TXNDC16 methyl",
    "TXNDC16 proteo",
    "TXNDC16 rna"
  ],
  "TXNDC17": [
    "TXNDC17 cnv",
    "TXNDC17 methyl",
    "TXNDC17 proteo",
    "TXNDC17 rna"
  ],
  "TXNDC2": [
    "TXNDC2 cnv",
    "TXNDC2 rna"
  ],
  "TXNDC5": [
    "TXNDC5 cnv",
    "TXNDC5 methyl",
    "TXNDC5 proteo",
    "TXNDC5 rna"
  ],
  "TXNDC8": [
    "TXNDC8 cnv"
  ],
  "TXNDC9": [
    "TXNDC9 cnv",
    "TXNDC9 methyl",
    "TXNDC9 proteo",
    "TXNDC9 rna"
  ],
  "TXNIP": [
    "TXNIP cnv",
    "TXNIP methyl",
    "TXNIP proteo",
    "TXNIP rna"
  ],
  "TXNL1": [
    "TXNL1 113_117_1_1_S113 phospho",
    "TXNL1 9_22_1_1_S9 phospho",
    "TXNL1 cnv",
    "TXNL1 methyl",
    "TXNL1 proteo",
    "TXNL1 rna"
  ],
  "TXNL4A": [
    "TXNL4A cnv",
    "TXNL4A methyl",
    "TXNL4A proteo",
    "TXNL4A rna"
  ],
  "TXNL4B": [
    "TXNL4B cnv",
    "TXNL4B proteo",
    "TXNL4B rna"
  ],
  "TXNRD1": [
    "TXNRD1 cnv",
    "TXNRD1 methyl",
    "TXNRD1 proteo",
    "TXNRD1 rna"
  ],
  "TXNRD2": [
    "TXNRD2 cnv",
    "TXNRD2 methyl",
    "TXNRD2 proteo",
    "TXNRD2 rna"
  ],
  "TXNRD3": [
    "TXNRD3 ENNTCYAK-N2H4F0S0G0 glyco",
    "TXNRD3 ENNTCYAK-N3H5F0S0G0 glyco",
    "TXNRD3 ENNTCYAK-N3H5F0S1G0 glyco",
    "TXNRD3 ENNTCYAK-N3H5F0S2G0 glyco",
    "TXNRD3 ENNTCYAK-N4H6F0S2G0 glyco",
    "TXNRD3 cnv",
    "TXNRD3 methyl",
    "TXNRD3 proteo",
    "TXNRD3 rna"
  ],
  "TYK2": [
    "TYK2 cnv",
    "TYK2 kinase",
    "TYK2 methyl",
    "TYK2 proteo",
    "TYK2 rna"
  ],
  "TYMP": [
    "TYMP cnv",
    "TYMP methyl",
    "TYMP proteo",
    "TYMP rna"
  ],
  "TYMS": [
    "TYMS cnv",
    "TYMS methyl",
    "TYMS proteo",
    "TYMS rna"
  ],
  "TYR": [
    "TYR cnv",
    "TYR rna"
  ],
  "TYRO3": [
    "TYRO3 804_829_1_1_S824 phospho",
    "TYRO3 cnv",
    "TYRO3 kinase",
    "TYRO3 methyl",
    "TYRO3 proteo",
    "TYRO3 rna"
  ],
  "TYROBP": [
    "TYROBP cnv",
    "TYROBP proteo",
    "TYROBP rna"
  ],
  "TYRP1": [
    "TYRP1 cnv",
    "TYRP1 rna"
  ],
  "TYSND1": [
    "TYSND1 cnv",
    "TYSND1 methyl",
    "TYSND1 proteo",
    "TYSND1 rna"
  ],
  "TYW1": [
    "TYW1 cnv",
    "TYW1 methyl",
    "TYW1 rna"
  ],
  "TYW1B": [
    "TYW1B cnv",
    "TYW1B methyl",
    "TYW1B rna"
  ],
  "TYW3": [
    "TYW3 cnv",
    "TYW3 proteo",
    "TYW3 rna"
  ],
  "TYW5": [
    "TYW5 cnv",
    "TYW5 methyl",
    "TYW5 proteo",
    "TYW5 rna"
  ],
  "U2AF1": [
    "U2AF1 cnv",
    "U2AF1 methyl",
    "U2AF1 rna"
  ],
  "U2AF1L4": [
    "U2AF1L4 cnv",
    "U2AF1L4 methyl",
    "U2AF1L4 rna"
  ],
  "U2AF1L5": [
    "U2AF1L5 cnv",
    "U2AF1L5 proteo",
    "U2AF1L5 rna"
  ],
  "U2AF2": [
    "U2AF2 79_79_1_1_S79 phospho",
    "U2AF2 cnv",
    "U2AF2 methyl",
    "U2AF2 proteo",
    "U2AF2 rna"
  ],
  "U2SURP": [
    "U2SURP 811_818_1_1_S811 phospho",
    "U2SURP 919_921_1_1_T919 phospho",
    "U2SURP 969_979_1_1_S974 phospho",
    "U2SURP cnv",
    "U2SURP methyl",
    "U2SURP proteo",
    "U2SURP rna"
  ],
  "UACA": [
    "UACA cnv",
    "UACA methyl",
    "UACA proteo",
    "UACA rna"
  ],
  "UAP1": [
    "UAP1 cnv",
    "UAP1 methyl",
    "UAP1 proteo",
    "UAP1 rna"
  ],
  "UAP1L1": [
    "UAP1L1 cnv",
    "UAP1L1 methyl",
    "UAP1L1 proteo",
    "UAP1L1 rna"
  ],
  "UBA1": [
    "UBA1 13_38_1_0 phospho",
    "UBA1 13_38_1_1_S13 phospho",
    "UBA1 13_38_2_0 phospho",
    "UBA1 13_38_2_1_S13 phospho",
    "UBA1 13_38_2_2_S13S24 phospho",
    "UBA1 13_56_1_1_S24 phospho",
    "UBA1 46_56_1_1_S46 phospho",
    "UBA1 810_824_1_1_S810 phospho",
    "UBA1 810_824_1_1_S816 phospho",
    "UBA1 810_824_2_2_S816S820 phospho",
    "UBA1 832_835_1_1_S835 phospho",
    "UBA1 methyl",
    "UBA1 proteo",
    "UBA1 rna"
  ],
  "UBA2": [
    "UBA2 cnv",
    "UBA2 methyl",
    "UBA2 proteo",
    "UBA2 rna"
  ],
  "UBA3": [
    "UBA3 327_338_1_1_S336 phospho",
    "UBA3 cnv",
    "UBA3 proteo",
    "UBA3 rna"
  ],
  "UBA5": [
    "UBA5 cnv",
    "UBA5 methyl",
    "UBA5 proteo",
    "UBA5 rna"
  ],
  "UBA52": [
    "UBA52 cnv",
    "UBA52 methyl",
    "UBA52 proteo",
    "UBA52 rna"
  ],
  "UBA6": [
    "UBA6 33_45_1_1_S36 phospho",
    "UBA6 cnv",
    "UBA6 methyl",
    "UBA6 proteo",
    "UBA6 rna"
  ],
  "UBA7": [
    "UBA7 cnv",
    "UBA7 proteo",
    "UBA7 rna"
  ],
  "UBAC1": [
    "UBAC1 98_98_1_1_S98 phospho",
    "UBAC1 cnv",
    "UBAC1 methyl",
    "UBAC1 proteo",
    "UBAC1 rna"
  ],
  "UBAC2": [
    "UBAC2 cnv",
    "UBAC2 methyl",
    "UBAC2 proteo",
    "UBAC2 rna"
  ],
  "UBAC2-AS1": [
    "UBAC2-AS1 methyl"
  ],
  "UBALD1": [
    "UBALD1 cnv",
    "UBALD1 methyl",
    "UBALD1 proteo",
    "UBALD1 rna"
  ],
  "UBALD2": [
    "UBALD2 cnv",
    "UBALD2 methyl",
    "UBALD2 rna"
  ],
  "UBAP1": [
    "UBAP1 329_340_1_1_S331 phospho",
    "UBAP1 349_355_1_1_S353 phospho",
    "UBAP1 cnv",
    "UBAP1 methyl",
    "UBAP1 proteo",
    "UBAP1 rna"
  ],
  "UBAP1L": [
    "UBAP1L cnv",
    "UBAP1L methyl",
    "UBAP1L rna"
  ],
  "UBAP2": [
    "UBAP2 cnv",
    "UBAP2 methyl",
    "UBAP2 proteo",
    "UBAP2 rna"
  ],
  "UBAP2L": [
    "UBAP2L 114_116_1_1_S116 phospho",
    "UBAP2L 410_419_1_1_S416 phospho",
    "UBAP2L 439_458_1_0 phospho",
    "UBAP2L 460_477_1_0 phospho",
    "UBAP2L 460_477_1_1_S467 phospho",
    "UBAP2L 460_477_1_1_S477 phospho",
    "UBAP2L 460_477_2_0 phospho",
    "UBAP2L 460_477_2_2_S467S477 phospho",
    "UBAP2L 602_609_1_0 phospho",
    "UBAP2L 602_609_1_1_S604 phospho",
    "UBAP2L 602_609_1_1_S609 phospho",
    "UBAP2L cnv",
    "UBAP2L methyl",
    "UBAP2L proteo",
    "UBAP2L rna"
  ],
  "UBASH3A": [
    "UBASH3A cnv",
    "UBASH3A rna"
  ],
  "UBASH3B": [
    "UBASH3B 342_342_1_1_S342 phospho",
    "UBASH3B cnv",
    "UBASH3B methyl",
    "UBASH3B proteo",
    "UBASH3B rna"
  ],
  "UBB": [
    "UBB cnv",
    "UBB methyl",
    "UBB rna"
  ],
  "UBC": [
    "UBC cnv",
    "UBC methyl",
    "UBC rna"
  ],
  "UBD": [
    "UBD cnv",
    "UBD rna"
  ],
  "UBE2A": [
    "UBE2A methyl",
    "UBE2A proteo",
    "UBE2A rna"
  ],
  "UBE2B": [
    "UBE2B cnv",
    "UBE2B methyl",
    "UBE2B proteo",
    "UBE2B rna"
  ],
  "UBE2C": [
    "UBE2C cnv",
    "UBE2C methyl",
    "UBE2C proteo",
    "UBE2C rna"
  ],
  "UBE2D1": [
    "UBE2D1 cnv",
    "UBE2D1 methyl",
    "UBE2D1 rna"
  ],
  "UBE2D2": [
    "UBE2D2 cnv",
    "UBE2D2 methyl",
    "UBE2D2 rna"
  ],
  "UBE2D3": [
    "UBE2D3 cnv",
    "UBE2D3 methyl",
    "UBE2D3 rna"
  ],
  "UBE2D4": [
    "UBE2D4 cnv",
    "UBE2D4 methyl",
    "UBE2D4 rna"
  ],
  "UBE2DNL": [
    "UBE2DNL methyl"
  ],
  "UBE2E1": [
    "UBE2E1 cnv",
    "UBE2E1 methyl",
    "UBE2E1 proteo",
    "UBE2E1 rna"
  ],
  "UBE2E2": [
    "UBE2E2 11_19_1_1_S19 phospho",
    "UBE2E2 11_26_1_0 phospho",
    "UBE2E2 cnv",
    "UBE2E2 methyl",
    "UBE2E2 proteo",
    "UBE2E2 rna"
  ],
  "UBE2E2-DT": [
    "UBE2E2-DT methyl"
  ],
  "UBE2E3": [
    "UBE2E3 cnv",
    "UBE2E3 methyl",
    "UBE2E3 rna"
  ],
  "UBE2F": [
    "UBE2F cnv",
    "UBE2F methyl",
    "UBE2F proteo",
    "UBE2F rna"
  ],
  "UBE2F-SCLY": [
    "UBE2F-SCLY cnv",
    "UBE2F-SCLY rna"
  ],
  "UBE2G1": [
    "UBE2G1 cnv",
    "UBE2G1 methyl",
    "UBE2G1 proteo",
    "UBE2G1 rna"
  ],
  "UBE2G2": [
    "UBE2G2 cnv",
    "UBE2G2 methyl",
    "UBE2G2 proteo",
    "UBE2G2 rna"
  ],
  "UBE2H": [
    "UBE2H cnv",
    "UBE2H methyl",
    "UBE2H proteo",
    "UBE2H rna"
  ],
  "UBE2I": [
    "UBE2I cnv",
    "UBE2I methyl",
    "UBE2I proteo",
    "UBE2I rna"
  ],
  "UBE2J1": [
    "UBE2J1 184_192_1_1_S184 phospho",
    "UBE2J1 cnv",
    "UBE2J1 methyl",
    "UBE2J1 proteo",
    "UBE2J1 rna"
  ],
  "UBE2J2": [
    "UBE2J2 cnv",
    "UBE2J2 methyl",
    "UBE2J2 proteo",
    "UBE2J2 rna"
  ],
  "UBE2K": [
    "UBE2K cnv",
    "UBE2K methyl",
    "UBE2K proteo",
    "UBE2K rna"
  ],
  "UBE2L3": [
    "UBE2L3 cnv",
    "UBE2L3 proteo",
    "UBE2L3 rna"
  ],
  "UBE2L5": [
    "UBE2L5 cnv",
    "UBE2L5 methyl",
    "UBE2L5 rna"
  ],
  "UBE2L6": [
    "UBE2L6 cnv",
    "UBE2L6 methyl",
    "UBE2L6 proteo",
    "UBE2L6 rna"
  ],
  "UBE2M": [
    "UBE2M cnv",
    "UBE2M methyl",
    "UBE2M proteo",
    "UBE2M rna"
  ],
  "UBE2N": [
    "UBE2N cnv",
    "UBE2N methyl",
    "UBE2N proteo",
    "UBE2N rna"
  ],
  "UBE2NL": [
    "UBE2NL rna"
  ],
  "UBE2O": [
    "UBE2O 399_407_1_1_S399 phospho",
    "UBE2O 411_421_1_1_S411 phospho",
    "UBE2O 423_441_1_1_S431 phospho",
    "UBE2O 423_441_1_1_S441 phospho",
    "UBE2O 515_519_1_1_S515 phospho",
    "UBE2O 828_848_1_0 phospho",
    "UBE2O 828_848_1_1_S836 phospho",
    "UBE2O 828_848_2_1_S836 phospho",
    "UBE2O 87_102_2_2_S87S89 phospho",
    "UBE2O 87_89_2_2_S87S89 phospho",
    "UBE2O 896_896_1_1_S896 phospho",
    "UBE2O cnv",
    "UBE2O methyl",
    "UBE2O proteo",
    "UBE2O rna"
  ],
  "UBE2Q1": [
    "UBE2Q1 cnv",
    "UBE2Q1 methyl",
    "UBE2Q1 proteo",
    "UBE2Q1 rna"
  ],
  "UBE2Q2": [
    "UBE2Q2 cnv",
    "UBE2Q2 methyl",
    "UBE2Q2 proteo",
    "UBE2Q2 rna"
  ],
  "UBE2Q2P1": [
    "UBE2Q2P1 methyl"
  ],
  "UBE2QL1": [
    "UBE2QL1 cnv",
    "UBE2QL1 methyl",
    "UBE2QL1 rna"
  ],
  "UBE2R2": [
    "UBE2R2 cnv",
    "UBE2R2 methyl",
    "UBE2R2 proteo",
    "UBE2R2 rna"
  ],
  "UBE2S": [
    "UBE2S cnv",
    "UBE2S methyl",
    "UBE2S proteo",
    "UBE2S rna"
  ],
  "UBE2T": [
    "UBE2T cnv",
    "UBE2T methyl",
    "UBE2T rna"
  ],
  "UBE2U": [
    "UBE2U cnv",
    "UBE2U rna"
  ],
  "UBE2V1": [
    "UBE2V1 cnv",
    "UBE2V1 methyl",
    "UBE2V1 proteo",
    "UBE2V1 rna"
  ],
  "UBE2V2": [
    "UBE2V2 cnv",
    "UBE2V2 methyl",
    "UBE2V2 proteo",
    "UBE2V2 rna"
  ],
  "UBE2W": [
    "UBE2W cnv",
    "UBE2W methyl",
    "UBE2W rna"
  ],
  "UBE2Z": [
    "UBE2Z cnv",
    "UBE2Z methyl",
    "UBE2Z proteo",
    "UBE2Z rna"
  ],
  "UBE3A": [
    "UBE3A 217_218_1_1_S218 phospho",
    "UBE3A cnv",
    "UBE3A methyl",
    "UBE3A proteo",
    "UBE3A rna"
  ],
  "UBE3B": [
    "UBE3B cnv",
    "UBE3B methyl",
    "UBE3B proteo",
    "UBE3B rna"
  ],
  "UBE3C": [
    "UBE3C cnv",
    "UBE3C methyl",
    "UBE3C proteo",
    "UBE3C rna"
  ],
  "UBE3D": [
    "UBE3D cnv",
    "UBE3D methyl",
    "UBE3D rna"
  ],
  "UBE4A": [
    "UBE4A cnv",
    "UBE4A methyl",
    "UBE4A proteo",
    "UBE4A rna"
  ],
  "UBE4B": [
    "UBE4B 103_112_1_1_S105 phospho",
    "UBE4B 1265_1267_1_1_S1265 phospho",
    "UBE4B 373_388_1_1_S383 phospho",
    "UBE4B cnv",
    "UBE4B methyl",
    "UBE4B proteo",
    "UBE4B rna"
  ],
  "UBFD1": [
    "UBFD1 53_72_1_0 phospho",
    "UBFD1 cnv",
    "UBFD1 methyl",
    "UBFD1 proteo",
    "UBFD1 rna"
  ],
  "UBIAD1": [
    "UBIAD1 cnv",
    "UBIAD1 methyl",
    "UBIAD1 proteo",
    "UBIAD1 rna"
  ],
  "UBL3": [
    "UBL3 cnv",
    "UBL3 methyl",
    "UBL3 proteo",
    "UBL3 rna"
  ],
  "UBL4A": [
    "UBL4A 90_100_1_1_S90 phospho",
    "UBL4A methyl",
    "UBL4A proteo",
    "UBL4A rna"
  ],
  "UBL4B": [
    "UBL4B cnv",
    "UBL4B rna"
  ],
  "UBL5": [
    "UBL5 cnv",
    "UBL5 methyl",
    "UBL5 proteo",
    "UBL5 rna"
  ],
  "UBL7": [
    "UBL7 230_240_1_1_S230 phospho",
    "UBL7 cnv",
    "UBL7 methyl",
    "UBL7 proteo",
    "UBL7 rna"
  ],
  "UBL7-DT": [
    "UBL7-DT methyl"
  ],
  "UBLCP1": [
    "UBLCP1 cnv",
    "UBLCP1 methyl",
    "UBLCP1 proteo",
    "UBLCP1 rna"
  ],
  "UBN1": [
    "UBN1 493_493_1_1_S493 phospho",
    "UBN1 cnv",
    "UBN1 methyl",
    "UBN1 proteo",
    "UBN1 rna"
  ],
  "UBN2": [
    "UBN2 250_258_1_1_S250 phospho",
    "UBN2 cnv",
    "UBN2 methyl",
    "UBN2 rna"
  ],
  "UBOX5": [
    "UBOX5 cnv",
    "UBOX5 methyl",
    "UBOX5 rna"
  ],
  "UBP1": [
    "UBP1 cnv",
    "UBP1 methyl",
    "UBP1 proteo",
    "UBP1 rna"
  ],
  "UBQLN1": [
    "UBQLN1 cnv",
    "UBQLN1 methyl",
    "UBQLN1 proteo",
    "UBQLN1 rna"
  ],
  "UBQLN1-AS1": [
    "UBQLN1-AS1 methyl"
  ],
  "UBQLN2": [
    "UBQLN2 methyl",
    "UBQLN2 proteo",
    "UBQLN2 rna"
  ],
  "UBQLN3": [
    "UBQLN3 cnv",
    "UBQLN3 rna"
  ],
  "UBQLN4": [
    "UBQLN4 cnv",
    "UBQLN4 methyl",
    "UBQLN4 proteo",
    "UBQLN4 rna"
  ],
  "UBQLNL": [
    "UBQLNL cnv",
    "UBQLNL rna"
  ],
  "UBR1": [
    "UBR1 15_21_1_1_T21 phospho",
    "UBR1 cnv",
    "UBR1 proteo",
    "UBR1 rna"
  ],
  "UBR2": [
    "UBR2 cnv",
    "UBR2 methyl",
    "UBR2 proteo",
    "UBR2 rna"
  ],
  "UBR3": [
    "UBR3 cnv",
    "UBR3 methyl",
    "UBR3 proteo",
    "UBR3 rna"
  ],
  "UBR4": [
    "UBR4 166_181_1_1_S178 phospho",
    "UBR4 1760_1763_1_1_S1763 phospho",
    "UBR4 178_181_1_1_S178 phospho",
    "UBR4 2715_2719_1_1_S2719 phospho",
    "UBR4 2722_2724_1_1_T2724 phospho",
    "UBR4 2884_2912_1_1_S2885 phospho",
    "UBR4 904_908_1_1_T905 phospho",
    "UBR4 cnv",
    "UBR4 methyl",
    "UBR4 proteo",
    "UBR4 rna"
  ],
  "UBR5": [
    "UBR5 2026_2030_1_0 phospho",
    "UBR5 327_327_1_1_S327 phospho",
    "UBR5 636_637_1_1_T637 phospho",
    "UBR5 cnv",
    "UBR5 methyl",
    "UBR5 proteo",
    "UBR5 rna"
  ],
  "UBR7": [
    "UBR7 cnv",
    "UBR7 methyl",
    "UBR7 proteo",
    "UBR7 rna"
  ],
  "UBTD1": [
    "UBTD1 cnv",
    "UBTD1 methyl",
    "UBTD1 proteo",
    "UBTD1 rna"
  ],
  "UBTD2": [
    "UBTD2 cnv",
    "UBTD2 methyl",
    "UBTD2 proteo",
    "UBTD2 rna"
  ],
  "UBTF": [
    "UBTF cnv",
    "UBTF methyl",
    "UBTF proteo",
    "UBTF rna"
  ],
  "UBTFL1": [
    "UBTFL1 cnv"
  ],
  "UBXN1": [
    "UBXN1 179_207_1_0 phospho",
    "UBXN1 179_207_1_1_S200 phospho",
    "UBXN1 cnv",
    "UBXN1 methyl",
    "UBXN1 proteo",
    "UBXN1 rna"
  ],
  "UBXN10": [
    "UBXN10 cnv",
    "UBXN10 methyl",
    "UBXN10 rna"
  ],
  "UBXN11": [
    "UBXN11 cnv",
    "UBXN11 methyl",
    "UBXN11 rna"
  ],
  "UBXN2A": [
    "UBXN2A cnv",
    "UBXN2A methyl",
    "UBXN2A proteo",
    "UBXN2A rna"
  ],
  "UBXN2B": [
    "UBXN2B 224_235_1_1_S235 phospho",
    "UBXN2B 56_59_1_1_T59 phospho",
    "UBXN2B cnv",
    "UBXN2B methyl",
    "UBXN2B proteo",
    "UBXN2B rna"
  ],
  "UBXN4": [
    "UBXN4 cnv",
    "UBXN4 methyl",
    "UBXN4 proteo",
    "UBXN4 rna"
  ],
  "UBXN6": [
    "UBXN6 39_53_1_1_S43 phospho",
    "UBXN6 cnv",
    "UBXN6 methyl",
    "UBXN6 proteo",
    "UBXN6 rna"
  ],
  "UBXN7": [
    "UBXN7 278_288_2_2_S280S288 phospho",
    "UBXN7 cnv",
    "UBXN7 methyl",
    "UBXN7 proteo",
    "UBXN7 rna"
  ],
  "UBXN8": [
    "UBXN8 cnv",
    "UBXN8 methyl",
    "UBXN8 rna"
  ],
  "UCHL1": [
    "UCHL1 cnv",
    "UCHL1 methyl",
    "UCHL1 proteo",
    "UCHL1 rna"
  ],
  "UCHL1-DT": [
    "UCHL1-DT methyl"
  ],
  "UCHL3": [
    "UCHL3 90_94_1_1_S94 phospho",
    "UCHL3 cnv",
    "UCHL3 methyl",
    "UCHL3 proteo",
    "UCHL3 rna"
  ],
  "UCHL5": [
    "UCHL5 cnv",
    "UCHL5 methyl",
    "UCHL5 proteo",
    "UCHL5 rna"
  ],
  "UCK1": [
    "UCK1 242_255_1_0 phospho",
    "UCK1 242_255_1_1_S244 phospho",
    "UCK1 cnv",
    "UCK1 methyl",
    "UCK1 proteo",
    "UCK1 rna"
  ],
  "UCK2": [
    "UCK2 cnv",
    "UCK2 methyl",
    "UCK2 proteo",
    "UCK2 rna"
  ],
  "UCKL1": [
    "UCKL1 13_19_1_1_S16 phospho",
    "UCKL1 53_56_1_1_S56 phospho",
    "UCKL1 cnv",
    "UCKL1 methyl",
    "UCKL1 proteo",
    "UCKL1 rna"
  ],
  "UCMA": [
    "UCMA cnv",
    "UCMA rna"
  ],
  "UCN": [
    "UCN cnv",
    "UCN methyl",
    "UCN rna"
  ],
  "UCN2": [
    "UCN2 cnv",
    "UCN2 rna"
  ],
  "UCN3": [
    "UCN3 cnv",
    "UCN3 rna"
  ],
  "UCP1": [
    "UCP1 cnv",
    "UCP1 methyl",
    "UCP1 rna"
  ],
  "UCP2": [
    "UCP2 cnv",
    "UCP2 methyl",
    "UCP2 rna"
  ],
  "UCP3": [
    "UCP3 cnv",
    "UCP3 rna"
  ],
  "UEVLD": [
    "UEVLD cnv",
    "UEVLD methyl",
    "UEVLD proteo",
    "UEVLD rna"
  ],
  "UFC1": [
    "UFC1 cnv",
    "UFC1 proteo",
    "UFC1 rna"
  ],
  "UFD1": [
    "UFD1 204_214_1_1_S204 phospho",
    "UFD1 240_242_1_1_S242 phospho",
    "UFD1 cnv",
    "UFD1 methyl",
    "UFD1 proteo",
    "UFD1 rna"
  ],
  "UFL1": [
    "UFL1 458_467_1_1_S458 phospho",
    "UFL1 458_467_2_2_S458S462 phospho",
    "UFL1 cnv",
    "UFL1 methyl",
    "UFL1 proteo",
    "UFL1 rna"
  ],
  "UFM1": [
    "UFM1 cnv",
    "UFM1 methyl",
    "UFM1 proteo",
    "UFM1 rna"
  ],
  "UFSP1": [
    "UFSP1 cnv",
    "UFSP1 methyl",
    "UFSP1 proteo",
    "UFSP1 rna"
  ],
  "UFSP2": [
    "UFSP2 cnv",
    "UFSP2 methyl",
    "UFSP2 proteo",
    "UFSP2 rna"
  ],
  "UGCG": [
    "UGCG cnv",
    "UGCG methyl",
    "UGCG rna"
  ],
  "UGDH": [
    "UGDH cnv",
    "UGDH methyl",
    "UGDH proteo",
    "UGDH rna"
  ],
  "UGDH-AS1": [
    "UGDH-AS1 methyl"
  ],
  "UGGT1": [
    "UGGT1 cnv",
    "UGGT1 methyl",
    "UGGT1 proteo",
    "UGGT1 rna"
  ],
  "UGGT2": [
    "UGGT2 cnv",
    "UGGT2 methyl",
    "UGGT2 proteo",
    "UGGT2 rna"
  ],
  "UGP2": [
    "UGP2 13_18_1_1_S13 phospho",
    "UGP2 cnv",
    "UGP2 methyl",
    "UGP2 proteo",
    "UGP2 rna"
  ],
  "UGT1A1": [
    "UGT1A1 cnv"
  ],
  "UGT1A10": [
    "UGT1A10 cnv",
    "UGT1A10 rna"
  ],
  "UGT1A2P": [
    "UGT1A2P cnv"
  ],
  "UGT1A3": [
    "UGT1A3 cnv"
  ],
  "UGT1A4": [
    "UGT1A4 cnv"
  ],
  "UGT1A5": [
    "UGT1A5 cnv"
  ],
  "UGT1A6": [
    "UGT1A6 cnv",
    "UGT1A6 rna"
  ],
  "UGT1A7": [
    "UGT1A7 cnv"
  ],
  "UGT1A8": [
    "UGT1A8 cnv"
  ],
  "UGT1A9": [
    "UGT1A9 cnv"
  ],
  "UGT2A1": [
    "UGT2A1 cnv",
    "UGT2A1 rna"
  ],
  "UGT2A2": [
    "UGT2A2 cnv"
  ],
  "UGT2A3": [
    "UGT2A3 cnv"
  ],
  "UGT2B10": [
    "UGT2B10 cnv"
  ],
  "UGT2B11": [
    "UGT2B11 cnv"
  ],
  "UGT2B15": [
    "UGT2B15 cnv",
    "UGT2B15 rna"
  ],
  "UGT2B17": [
    "UGT2B17 cnv",
    "UGT2B17 rna"
  ],
  "UGT2B28": [
    "UGT2B28 cnv"
  ],
  "UGT2B4": [
    "UGT2B4 cnv",
    "UGT2B4 rna"
  ],
  "UGT2B7": [
    "UGT2B7 cnv",
    "UGT2B7 rna"
  ],
  "UGT3A1": [
    "UGT3A1 cnv"
  ],
  "UGT3A2": [
    "UGT3A2 cnv",
    "UGT3A2 rna"
  ],
  "UGT8": [
    "UGT8 NLGNNTK-N2H5F0S0G0 glyco",
    "UGT8 NLGNNTK-N2H6F0S0G0 glyco",
    "UGT8 YPGIFNSTTSDAFLQSK-N2H6F0S0G0 glyco",
    "UGT8 cnv",
    "UGT8 methyl",
    "UGT8 proteo",
    "UGT8 rna"
  ],
  "UHMK1": [
    "UHMK1 cnv",
    "UHMK1 kinase",
    "UHMK1 methyl",
    "UHMK1 rna"
  ],
  "UHRF1": [
    "UHRF1 cnv",
    "UHRF1 methyl",
    "UHRF1 proteo",
    "UHRF1 rna"
  ],
  "UHRF2": [
    "UHRF2 667_675_1_1_S667 phospho",
    "UHRF2 cnv",
    "UHRF2 methyl",
    "UHRF2 proteo",
    "UHRF2 rna"
  ],
  "UIMC1": [
    "UIMC1 643_662_1_1_S653 phospho",
    "UIMC1 653_662_1_1_S653 phospho",
    "UIMC1 cnv",
    "UIMC1 methyl",
    "UIMC1 proteo",
    "UIMC1 rna"
  ],
  "ULBP1": [
    "ULBP1 cnv",
    "ULBP1 methyl",
    "ULBP1 rna"
  ],
  "ULBP2": [
    "ULBP2 cnv",
    "ULBP2 methyl",
    "ULBP2 rna"
  ],
  "ULBP3": [
    "ULBP3 cnv",
    "ULBP3 methyl",
    "ULBP3 rna"
  ],
  "ULK1": [
    "ULK1 477_479_2_2_S477S479 phospho",
    "ULK1 660_665_1_1_T660 phospho",
    "ULK1 746_764_1_1_S758 phospho",
    "ULK1 cnv",
    "ULK1 kinase",
    "ULK1 methyl",
    "ULK1 proteo",
    "ULK1 rna"
  ],
  "ULK2": [
    "ULK2 592_602_1_1_S600 phospho",
    "ULK2 cnv",
    "ULK2 kinase",
    "ULK2 methyl",
    "ULK2 rna"
  ],
  "ULK3": [
    "ULK3 cnv",
    "ULK3 kinase",
    "ULK3 methyl",
    "ULK3 proteo",
    "ULK3 rna"
  ],
  "ULK4": [
    "ULK4 cnv",
    "ULK4 kinase",
    "ULK4 methyl",
    "ULK4 rna"
  ],
  "UMAD1": [
    "UMAD1 cnv",
    "UMAD1 methyl",
    "UMAD1 proteo",
    "UMAD1 rna"
  ],
  "UMOD": [
    "UMOD cnv"
  ],
  "UMODL1": [
    "UMODL1 cnv",
    "UMODL1 rna"
  ],
  "UMPS": [
    "UMPS cnv",
    "UMPS methyl",
    "UMPS proteo",
    "UMPS rna"
  ],
  "UNC119": [
    "UNC119 cnv",
    "UNC119 methyl",
    "UNC119 proteo",
    "UNC119 rna"
  ],
  "UNC119B": [
    "UNC119B cnv",
    "UNC119B methyl",
    "UNC119B proteo",
    "UNC119B rna"
  ],
  "UNC13A": [
    "UNC13A cnv",
    "UNC13A methyl",
    "UNC13A proteo",
    "UNC13A rna"
  ],
  "UNC13B": [
    "UNC13B 170_182_1_1_S176 phospho",
    "UNC13B 170_191_1_1_S176 phospho",
    "UNC13B 359_370_1_1_S359 phospho",
    "UNC13B cnv",
    "UNC13B methyl",
    "UNC13B proteo",
    "UNC13B rna"
  ],
  "UNC13C": [
    "UNC13C cnv",
    "UNC13C rna"
  ],
  "UNC13D": [
    "UNC13D cnv",
    "UNC13D proteo",
    "UNC13D rna"
  ],
  "UNC45A": [
    "UNC45A 2_20_1_1_T15 phospho",
    "UNC45A cnv",
    "UNC45A methyl",
    "UNC45A proteo",
    "UNC45A rna"
  ],
  "UNC45B": [
    "UNC45B cnv",
    "UNC45B rna"
  ],
  "UNC50": [
    "UNC50 cnv",
    "UNC50 methyl",
    "UNC50 rna"
  ],
  "UNC5A": [
    "UNC5A cnv",
    "UNC5A methyl",
    "UNC5A proteo",
    "UNC5A rna"
  ],
  "UNC5B": [
    "UNC5B 515_520_1_1_S517 phospho",
    "UNC5B cnv",
    "UNC5B methyl",
    "UNC5B rna"
  ],
  "UNC5B-AS1": [
    "UNC5B-AS1 methyl"
  ],
  "UNC5C": [
    "UNC5C cnv",
    "UNC5C methyl",
    "UNC5C proteo",
    "UNC5C rna"
  ],
  "UNC5CL": [
    "UNC5CL cnv",
    "UNC5CL rna"
  ],
  "UNC5D": [
    "UNC5D cnv",
    "UNC5D methyl",
    "UNC5D rna"
  ],
  "UNC79": [
    "UNC79 cnv",
    "UNC79 methyl",
    "UNC79 rna"
  ],
  "UNC80": [
    "UNC80 245_252_1_1_S246 phospho",
    "UNC80 cnv",
    "UNC80 methyl",
    "UNC80 proteo",
    "UNC80 rna"
  ],
  "UNC93A": [
    "UNC93A cnv"
  ],
  "UNC93B1": [
    "UNC93B1 541_550_2_2_S547S550 phospho",
    "UNC93B1 cnv",
    "UNC93B1 methyl",
    "UNC93B1 proteo",
    "UNC93B1 rna"
  ],
  "UNCX": [
    "UNCX cnv",
    "UNCX methyl",
    "UNCX rna"
  ],
  "UNG": [
    "UNG 23_40_1_1_S23 phospho",
    "UNG 60_67_1_1_T60 phospho",
    "UNG cnv",
    "UNG methyl",
    "UNG proteo",
    "UNG rna"
  ],
  "UNK": [
    "UNK 232_240_1_1_S240 phospho",
    "UNK 252_255_1_1_S254 phospho",
    "UNK 374_389_1_1_S385 phospho",
    "UNK cnv",
    "UNK methyl",
    "UNK proteo",
    "UNK rna"
  ],
  "UNKL": [
    "UNKL 13_25_1_1_S15 phospho",
    "UNKL 347_347_1_1_S347 phospho",
    "UNKL cnv",
    "UNKL methyl",
    "UNKL proteo",
    "UNKL rna"
  ],
  "UPB1": [
    "UPB1 cnv",
    "UPB1 methyl",
    "UPB1 rna"
  ],
  "UPF1": [
    "UPF1 1118_1129_1_1_Y1129 phospho",
    "UPF1 cnv",
    "UPF1 methyl",
    "UPF1 proteo",
    "UPF1 rna"
  ],
  "UPF2": [
    "UPF2 cnv",
    "UPF2 methyl",
    "UPF2 proteo",
    "UPF2 rna"
  ],
  "UPF3A": [
    "UPF3A 200_203_1_1_S200 phospho",
    "UPF3A cnv",
    "UPF3A methyl",
    "UPF3A proteo",
    "UPF3A rna"
  ],
  "UPF3B": [
    "UPF3B methyl",
    "UPF3B proteo",
    "UPF3B rna"
  ],
  "UPK1A": [
    "UPK1A cnv",
    "UPK1A rna"
  ],
  "UPK1B": [
    "UPK1B cnv",
    "UPK1B rna"
  ],
  "UPK2": [
    "UPK2 cnv",
    "UPK2 rna"
  ],
  "UPK3A": [
    "UPK3A cnv",
    "UPK3A methyl",
    "UPK3A rna"
  ],
  "UPK3B": [
    "UPK3B cnv",
    "UPK3B rna"
  ],
  "UPK3BL1": [
    "UPK3BL1 cnv",
    "UPK3BL1 rna"
  ],
  "UPK3BL2": [
    "UPK3BL2 cnv",
    "UPK3BL2 rna"
  ],
  "UPP1": [
    "UPP1 cnv",
    "UPP1 methyl",
    "UPP1 proteo",
    "UPP1 rna"
  ],
  "UPP2": [
    "UPP2 cnv",
    "UPP2 methyl",
    "UPP2 rna"
  ],
  "UPRT": [
    "UPRT proteo",
    "UPRT rna"
  ],
  "UQCC1": [
    "UQCC1 cnv",
    "UQCC1 proteo",
    "UQCC1 rna"
  ],
  "UQCC2": [
    "UQCC2 cnv",
    "UQCC2 methyl",
    "UQCC2 proteo",
    "UQCC2 rna"
  ],
  "UQCC3": [
    "UQCC3 cnv",
    "UQCC3 methyl",
    "UQCC3 proteo",
    "UQCC3 rna"
  ],
  "UQCR10": [
    "UQCR10 cnv",
    "UQCR10 methyl",
    "UQCR10 proteo",
    "UQCR10 rna"
  ],
  "UQCR11": [
    "UQCR11 cnv",
    "UQCR11 methyl",
    "UQCR11 proteo",
    "UQCR11 rna"
  ],
  "UQCRB": [
    "UQCRB cnv",
    "UQCRB proteo",
    "UQCRB rna"
  ],
  "UQCRC1": [
    "UQCRC1 cnv",
    "UQCRC1 methyl",
    "UQCRC1 proteo",
    "UQCRC1 rna"
  ],
  "UQCRC2": [
    "UQCRC2 cnv",
    "UQCRC2 proteo",
    "UQCRC2 rna"
  ],
  "UQCRFS1": [
    "UQCRFS1 cnv",
    "UQCRFS1 methyl",
    "UQCRFS1 proteo",
    "UQCRFS1 rna"
  ],
  "UQCRFS1-DT": [
    "UQCRFS1-DT methyl"
  ],
  "UQCRH": [
    "UQCRH cnv",
    "UQCRH methyl",
    "UQCRH proteo",
    "UQCRH rna"
  ],
  "UQCRHL": [
    "UQCRHL cnv",
    "UQCRHL rna"
  ],
  "UQCRQ": [
    "UQCRQ cnv",
    "UQCRQ methyl",
    "UQCRQ proteo",
    "UQCRQ rna"
  ],
  "URAD": [
    "URAD cnv",
    "URAD rna"
  ],
  "URAHP": [
    "URAHP methyl"
  ],
  "URB1": [
    "URB1 cnv",
    "URB1 methyl",
    "URB1 proteo",
    "URB1 rna"
  ],
  "URB1-AS1": [
    "URB1-AS1 methyl"
  ],
  "URB2": [
    "URB2 cnv",
    "URB2 methyl",
    "URB2 proteo",
    "URB2 rna"
  ],
  "URGCP": [
    "URGCP cnv",
    "URGCP methyl",
    "URGCP proteo",
    "URGCP rna"
  ],
  "URGCP-MRPS24": [
    "URGCP-MRPS24 cnv",
    "URGCP-MRPS24 methyl",
    "URGCP-MRPS24 rna"
  ],
  "URI1": [
    "URI1 cnv",
    "URI1 methyl",
    "URI1 proteo",
    "URI1 rna"
  ],
  "URM1": [
    "URM1 cnv",
    "URM1 methyl",
    "URM1 proteo",
    "URM1 rna"
  ],
  "UROC1": [
    "UROC1 cnv",
    "UROC1 rna"
  ],
  "UROD": [
    "UROD 57_69_1_1_S61 phospho",
    "UROD cnv",
    "UROD methyl",
    "UROD proteo",
    "UROD rna"
  ],
  "UROS": [
    "UROS cnv",
    "UROS methyl",
    "UROS proteo",
    "UROS rna"
  ],
  "USB1": [
    "USB1 36_36_1_1_S36 phospho",
    "USB1 cnv",
    "USB1 methyl",
    "USB1 proteo",
    "USB1 rna"
  ],
  "USE1": [
    "USE1 200_204_1_1_S204 phospho",
    "USE1 cnv",
    "USE1 methyl",
    "USE1 proteo",
    "USE1 rna"
  ],
  "USF1": [
    "USF1 309_309_1_1_S309 phospho",
    "USF1 cnv",
    "USF1 proteo",
    "USF1 rna"
  ],
  "USF2": [
    "USF2 161_163_1_1_T163 phospho",
    "USF2 cnv",
    "USF2 methyl",
    "USF2 proteo",
    "USF2 rna"
  ],
  "USF3": [
    "USF3 cnv",
    "USF3 methyl",
    "USF3 rna"
  ],
  "USH1C": [
    "USH1C cnv",
    "USH1C methyl",
    "USH1C rna"
  ],
  "USH1G": [
    "USH1G cnv",
    "USH1G methyl",
    "USH1G rna"
  ],
  "USH2A": [
    "USH2A cnv",
    "USH2A rna"
  ],
  "USHBP1": [
    "USHBP1 cnv",
    "USHBP1 methyl",
    "USHBP1 rna"
  ],
  "USO1": [
    "USO1 942_952_1_1_S942 phospho",
    "USO1 cnv",
    "USO1 methyl",
    "USO1 proteo",
    "USO1 rna"
  ],
  "USP1": [
    "USP1 cnv",
    "USP1 methyl",
    "USP1 rna"
  ],
  "USP10": [
    "USP10 212_240_1_1_S215 phospho",
    "USP10 368_378_1_1_S369 phospho",
    "USP10 567_580_1_1_S580 phospho",
    "USP10 cnv",
    "USP10 methyl",
    "USP10 proteo",
    "USP10 rna"
  ],
  "USP11": [
    "USP11 642_648_1_1_S648 phospho",
    "USP11 938_957_1_0 phospho",
    "USP11 methyl",
    "USP11 proteo",
    "USP11 rna"
  ],
  "USP12": [
    "USP12 cnv",
    "USP12 methyl",
    "USP12 proteo",
    "USP12 rna"
  ],
  "USP13": [
    "USP13 cnv",
    "USP13 methyl",
    "USP13 proteo",
    "USP13 rna"
  ],
  "USP14": [
    "USP14 143_153_1_1_S143 phospho",
    "USP14 226_237_1_1_T235 phospho",
    "USP14 52_52_1_1_T52 phospho",
    "USP14 cnv",
    "USP14 methyl",
    "USP14 proteo",
    "USP14 rna"
  ],
  "USP15": [
    "USP15 225_237_1_1_S229 phospho",
    "USP15 229_237_1_1_S229 phospho",
    "USP15 cnv",
    "USP15 methyl",
    "USP15 proteo",
    "USP15 rna"
  ],
  "USP16": [
    "USP16 406_414_1_1_S414 phospho",
    "USP16 549_553_1_1_S551 phospho",
    "USP16 cnv",
    "USP16 methyl",
    "USP16 proteo",
    "USP16 rna"
  ],
  "USP17L1": [
    "USP17L1 cnv",
    "USP17L1 rna"
  ],
  "USP17L10": [
    "USP17L10 cnv"
  ],
  "USP17L11": [
    "USP17L11 cnv",
    "USP17L11 rna"
  ],
  "USP17L12": [
    "USP17L12 cnv"
  ],
  "USP17L13": [
    "USP17L13 cnv"
  ],
  "USP17L15": [
    "USP17L15 cnv",
    "USP17L15 rna"
  ],
  "USP17L17": [
    "USP17L17 cnv"
  ],
  "USP17L18": [
    "USP17L18 cnv"
  ],
  "USP17L19": [
    "USP17L19 cnv"
  ],
  "USP17L2": [
    "USP17L2 cnv",
    "USP17L2 rna"
  ],
  "USP17L20": [
    "USP17L20 cnv",
    "USP17L20 rna"
  ],
  "USP17L21": [
    "USP17L21 cnv"
  ],
  "USP17L22": [
    "USP17L22 cnv"
  ],
  "USP17L23": [
    "USP17L23 cnv",
    "USP17L23 rna"
  ],
  "USP17L24": [
    "USP17L24 cnv"
  ],
  "USP17L25": [
    "USP17L25 cnv"
  ],
  "USP17L26": [
    "USP17L26 cnv"
  ],
  "USP17L27": [
    "USP17L27 cnv"
  ],
  "USP17L28": [
    "USP17L28 cnv"
  ],
  "USP17L29": [
    "USP17L29 cnv"
  ],
  "USP17L3": [
    "USP17L3 cnv"
  ],
  "USP17L30": [
    "USP17L30 cnv"
  ],
  "USP17L4": [
    "USP17L4 cnv"
  ],
  "USP17L5": [
    "USP17L5 cnv"
  ],
  "USP17L7": [
    "USP17L7 cnv",
    "USP17L7 rna"
  ],
  "USP17L8": [
    "USP17L8 cnv"
  ],
  "USP18": [
    "USP18 cnv",
    "USP18 methyl",
    "USP18 rna"
  ],
  "USP19": [
    "USP19 cnv",
    "USP19 methyl",
    "USP19 proteo",
    "USP19 rna"
  ],
  "USP2": [
    "USP2 cnv",
    "USP2 methyl",
    "USP2 rna"
  ],
  "USP20": [
    "USP20 132_134_1_1_S132 phospho",
    "USP20 132_134_2_2_S132S134 phospho",
    "USP20 371_377_1_0 phospho",
    "USP20 371_377_1_1_S373 phospho",
    "USP20 371_377_2_2_S373T377 phospho",
    "USP20 388_394_1_1_S394 phospho",
    "USP20 388_394_2_0 phospho",
    "USP20 cnv",
    "USP20 methyl",
    "USP20 proteo",
    "USP20 rna"
  ],
  "USP21": [
    "USP21 cnv",
    "USP21 methyl",
    "USP21 rna"
  ],
  "USP22": [
    "USP22 cnv",
    "USP22 methyl",
    "USP22 proteo",
    "USP22 rna"
  ],
  "USP24": [
    "USP24 1285_1289_1_1_S1285 phospho",
    "USP24 1371_1381_1_1_S1372 phospho",
    "USP24 1925_1927_1_1_S1925 phospho",
    "USP24 2043_2047_1_1_S2047 phospho",
    "USP24 2559_2570_1_1_S2561 phospho",
    "USP24 2602_2604_1_1_S2604 phospho",
    "USP24 cnv",
    "USP24 methyl",
    "USP24 proteo",
    "USP24 rna"
  ],
  "USP25": [
    "USP25 cnv",
    "USP25 methyl",
    "USP25 proteo",
    "USP25 rna"
  ],
  "USP26": [
    "USP26 rna"
  ],
  "USP27X": [
    "USP27X methyl",
    "USP27X rna"
  ],
  "USP27X-DT": [
    "USP27X-DT methyl"
  ],
  "USP28": [
    "USP28 1110_1121_1_1_S1115 phospho",
    "USP28 cnv",
    "USP28 methyl",
    "USP28 proteo",
    "USP28 rna"
  ],
  "USP29": [
    "USP29 cnv",
    "USP29 methyl",
    "USP29 rna"
  ],
  "USP3": [
    "USP3 cnv",
    "USP3 methyl",
    "USP3 proteo",
    "USP3 rna"
  ],
  "USP30": [
    "USP30 cnv",
    "USP30 methyl",
    "USP30 proteo",
    "USP30 rna"
  ],
  "USP31": [
    "USP31 169_169_1_1_S169 phospho",
    "USP31 44_57_1_1_S51 phospho",
    "USP31 cnv",
    "USP31 methyl",
    "USP31 proteo",
    "USP31 rna"
  ],
  "USP32": [
    "USP32 1326_1333_1_1_T1326 phospho",
    "USP32 1361_1372_1_1_S1372 phospho",
    "USP32 cnv",
    "USP32 methyl",
    "USP32 proteo",
    "USP32 rna"
  ],
  "USP33": [
    "USP33 cnv",
    "USP33 methyl",
    "USP33 proteo",
    "USP33 rna"
  ],
  "USP34": [
    "USP34 3358_3370_2_2_S3358S3359 phospho",
    "USP34 3393_3411_1_1_S3406 phospho",
    "USP34 cnv",
    "USP34 methyl",
    "USP34 proteo",
    "USP34 rna"
  ],
  "USP35": [
    "USP35 975_982_1_1_S982 phospho",
    "USP35 cnv",
    "USP35 methyl",
    "USP35 proteo",
    "USP35 rna"
  ],
  "USP36": [
    "USP36 610_624_1_1_S614 phospho",
    "USP36 742_749_1_1_S742 phospho",
    "USP36 cnv",
    "USP36 methyl",
    "USP36 proteo",
    "USP36 rna"
  ],
  "USP37": [
    "USP37 cnv",
    "USP37 methyl",
    "USP37 rna"
  ],
  "USP38": [
    "USP38 cnv",
    "USP38 methyl",
    "USP38 proteo",
    "USP38 rna"
  ],
  "USP38-DT": [
    "USP38-DT methyl"
  ],
  "USP39": [
    "USP39 42_46_1_1_S46 phospho",
    "USP39 82_82_1_1_S82 phospho",
    "USP39 cnv",
    "USP39 methyl",
    "USP39 proteo",
    "USP39 rna"
  ],
  "USP4": [
    "USP4 675_693_1_1_S680 phospho",
    "USP4 675_693_2_2_S675S680 phospho",
    "USP4 cnv",
    "USP4 methyl",
    "USP4 proteo",
    "USP4 rna"
  ],
  "USP40": [
    "USP40 1211_1228_1_1_S1211 phospho",
    "USP40 cnv",
    "USP40 proteo",
    "USP40 rna"
  ],
  "USP41": [
    "USP41 cnv",
    "USP41 rna"
  ],
  "USP42": [
    "USP42 1007_1007_1_1_S1007 phospho",
    "USP42 1133_1133_1_1_S1133 phospho",
    "USP42 1166_1172_1_1_S1166 phospho",
    "USP42 1181_1181_1_1_S1181 phospho",
    "USP42 cnv",
    "USP42 methyl",
    "USP42 proteo",
    "USP42 rna"
  ],
  "USP43": [
    "USP43 cnv",
    "USP43 methyl",
    "USP43 rna"
  ],
  "USP44": [
    "USP44 cnv",
    "USP44 methyl",
    "USP44 rna"
  ],
  "USP45": [
    "USP45 cnv",
    "USP45 methyl",
    "USP45 rna"
  ],
  "USP46": [
    "USP46 cnv",
    "USP46 methyl",
    "USP46 proteo",
    "USP46 rna"
  ],
  "USP47": [
    "USP47 812_817_1_1_S812 phospho",
    "USP47 879_890_1_1_S890 phospho",
    "USP47 879_900_1_1_S890 phospho",
    "USP47 897_900_1_1_S898 phospho",
    "USP47 912_920_1_1_S913 phospho",
    "USP47 cnv",
    "USP47 methyl",
    "USP47 proteo",
    "USP47 rna"
  ],
  "USP48": [
    "USP48 cnv",
    "USP48 methyl",
    "USP48 proteo",
    "USP48 rna"
  ],
  "USP49": [
    "USP49 cnv",
    "USP49 methyl",
    "USP49 rna"
  ],
  "USP5": [
    "USP5 605_623_1_1_T623 phospho",
    "USP5 cnv",
    "USP5 methyl",
    "USP5 proteo",
    "USP5 rna"
  ],
  "USP50": [
    "USP50 cnv",
    "USP50 rna"
  ],
  "USP51": [
    "USP51 rna"
  ],
  "USP53": [
    "USP53 cnv",
    "USP53 methyl",
    "USP53 rna"
  ],
  "USP54": [
    "USP54 1106_1116_1_1_S1107 phospho",
    "USP54 1464_1469_1_1_S1469 phospho",
    "USP54 420_428_1_1_S424 phospho",
    "USP54 612_633_1_1_S614 phospho",
    "USP54 cnv",
    "USP54 methyl",
    "USP54 proteo",
    "USP54 rna"
  ],
  "USP6": [
    "USP6 cnv",
    "USP6 methyl",
    "USP6 rna"
  ],
  "USP6NL": [
    "USP6NL 452_457_1_1_S452 phospho",
    "USP6NL 610_614_1_1_S612 phospho",
    "USP6NL 648_659_1_1_S659 phospho",
    "USP6NL 690_697_1_1_S697 phospho",
    "USP6NL 722_733_1_1_S733 phospho",
    "USP6NL cnv",
    "USP6NL methyl",
    "USP6NL proteo",
    "USP6NL rna"
  ],
  "USP6NL-AS1": [
    "USP6NL-AS1 methyl"
  ],
  "USP7": [
    "USP7 18_30_1_1_S18 phospho",
    "USP7 cnv",
    "USP7 methyl",
    "USP7 proteo",
    "USP7 rna"
  ],
  "USP8": [
    "USP8 389_400_1_1_S392 phospho",
    "USP8 425_437_1_1_S434 phospho",
    "USP8 577_577_1_1_T577 phospho",
    "USP8 641_641_1_1_S641 phospho",
    "USP8 668_695_1_0 phospho",
    "USP8 716_723_1_0 phospho",
    "USP8 716_723_1_1_S718 phospho",
    "USP8 cnv",
    "USP8 methyl",
    "USP8 proteo",
    "USP8 rna"
  ],
  "USP9X": [
    "USP9X 1591_1600_1_1_S1600 phospho",
    "USP9X 1591_1609_1_1_S1600 phospho",
    "USP9X 2431_2455_1_0 phospho",
    "USP9X 2431_2455_1_1_S2443 phospho",
    "USP9X 2556_2567_1_1_S2563 phospho",
    "USP9X methyl",
    "USP9X proteo",
    "USP9X rna"
  ],
  "USP9Y": [
    "USP9Y rna"
  ],
  "USPL1": [
    "USPL1 cnv",
    "USPL1 methyl",
    "USPL1 rna"
  ],
  "UST": [
    "UST cnv",
    "UST methyl",
    "UST rna"
  ],
  "UTF1": [
    "UTF1 cnv",
    "UTF1 methyl",
    "UTF1 rna"
  ],
  "UTP11": [
    "UTP11 cnv",
    "UTP11 methyl",
    "UTP11 rna"
  ],
  "UTP14A": [
    "UTP14A 382_396_1_1_S385 phospho",
    "UTP14A methyl",
    "UTP14A proteo",
    "UTP14A rna"
  ],
  "UTP14C": [
    "UTP14C cnv",
    "UTP14C rna"
  ],
  "UTP15": [
    "UTP15 cnv",
    "UTP15 methyl",
    "UTP15 proteo",
    "UTP15 rna"
  ],
  "UTP18": [
    "UTP18 121_124_1_0 phospho",
    "UTP18 121_124_2_2_S121S124 phospho",
    "UTP18 204_210_2_2_S206S210 phospho",
    "UTP18 cnv",
    "UTP18 methyl",
    "UTP18 proteo",
    "UTP18 rna"
  ],
  "UTP20": [
    "UTP20 1732_1751_1_1_T1741 phospho",
    "UTP20 cnv",
    "UTP20 methyl",
    "UTP20 proteo",
    "UTP20 rna"
  ],
  "UTP23": [
    "UTP23 cnv",
    "UTP23 methyl",
    "UTP23 proteo",
    "UTP23 rna"
  ],
  "UTP25": [
    "UTP25 cnv",
    "UTP25 methyl",
    "UTP25 proteo",
    "UTP25 rna"
  ],
  "UTP3": [
    "UTP3 cnv",
    "UTP3 methyl",
    "UTP3 proteo",
    "UTP3 rna"
  ],
  "UTP4": [
    "UTP4 cnv",
    "UTP4 methyl",
    "UTP4 proteo",
    "UTP4 rna"
  ],
  "UTP6": [
    "UTP6 cnv",
    "UTP6 methyl",
    "UTP6 proteo",
    "UTP6 rna"
  ],
  "UTRN": [
    "UTRN 2210_2219_1_1_S2211 phospho",
    "UTRN 2222_2226_1_1_S2223 phospho",
    "UTRN 4_19_1_1_S10 phospho",
    "UTRN cnv",
    "UTRN methyl",
    "UTRN proteo",
    "UTRN rna"
  ],
  "UTS2": [
    "UTS2 cnv",
    "UTS2 rna"
  ],
  "UTS2B": [
    "UTS2B cnv",
    "UTS2B methyl",
    "UTS2B rna"
  ],
  "UTS2R": [
    "UTS2R cnv",
    "UTS2R methyl",
    "UTS2R rna"
  ],
  "UTY": [
    "UTY methyl",
    "UTY rna"
  ],
  "UVRAG": [
    "UVRAG 571_590_1_1_S571 phospho",
    "UVRAG cnv",
    "UVRAG methyl",
    "UVRAG proteo",
    "UVRAG rna"
  ],
  "UVRAG-DT": [
    "UVRAG-DT methyl"
  ],
  "UVSSA": [
    "UVSSA cnv",
    "UVSSA methyl",
    "UVSSA rna"
  ],
  "UXS1": [
    "UXS1 cnv",
    "UXS1 methyl",
    "UXS1 proteo",
    "UXS1 rna"
  ],
  "UXT": [
    "UXT methyl",
    "UXT proteo",
    "UXT rna"
  ],
  "UXT-AS1": [
    "UXT-AS1 methyl"
  ],
  "VAC14": [
    "VAC14 517_528_1_1_S517 phospho",
    "VAC14 cnv",
    "VAC14 methyl",
    "VAC14 proteo",
    "VAC14 rna"
  ],
  "VAC14-AS1": [
    "VAC14-AS1 methyl"
  ],
  "VAMP1": [
    "VAMP1 cnv",
    "VAMP1 methyl",
    "VAMP1 proteo",
    "VAMP1 rna"
  ],
  "VAMP2": [
    "VAMP2 cnv",
    "VAMP2 methyl",
    "VAMP2 proteo",
    "VAMP2 rna"
  ],
  "VAMP3": [
    "VAMP3 cnv",
    "VAMP3 methyl",
    "VAMP3 proteo",
    "VAMP3 rna"
  ],
  "VAMP4": [
    "VAMP4 30_30_1_1_S30 phospho",
    "VAMP4 cnv",
    "VAMP4 methyl",
    "VAMP4 proteo",
    "VAMP4 rna"
  ],
  "VAMP5": [
    "VAMP5 41_50_1_1_S48 phospho",
    "VAMP5 cnv",
    "VAMP5 methyl",
    "VAMP5 proteo",
    "VAMP5 rna"
  ],
  "VAMP7": [
    "VAMP7 proteo",
    "VAMP7 rna"
  ],
  "VAMP8": [
    "VAMP8 cnv",
    "VAMP8 methyl",
    "VAMP8 proteo",
    "VAMP8 rna"
  ],
  "VAMP9P": [
    "VAMP9P methyl"
  ],
  "VANGL1": [
    "VANGL1 336_343_1_0 phospho",
    "VANGL1 cnv",
    "VANGL1 methyl",
    "VANGL1 proteo",
    "VANGL1 rna"
  ],
  "VANGL2": [
    "VANGL2 cnv",
    "VANGL2 methyl",
    "VANGL2 proteo",
    "VANGL2 rna"
  ],
  "VAPA": [
    "VAPA 164_172_1_1_S166 phospho",
    "VAPA cnv",
    "VAPA methyl",
    "VAPA proteo",
    "VAPA rna"
  ],
  "VAPB": [
    "VAPB 156_164_1_1_S158 phospho",
    "VAPB cnv",
    "VAPB methyl",
    "VAPB proteo",
    "VAPB rna"
  ],
  "VARS1": [
    "VARS1 cnv",
    "VARS1 methyl",
    "VARS1 proteo",
    "VARS1 rna"
  ],
  "VARS2": [
    "VARS2 cnv",
    "VARS2 methyl",
    "VARS2 proteo",
    "VARS2 rna"
  ],
  "VASH1": [
    "VASH1 cnv",
    "VASH1 methyl",
    "VASH1 proteo",
    "VASH1 rna"
  ],
  "VASH2": [
    "VASH2 cnv",
    "VASH2 methyl",
    "VASH2 rna"
  ],
  "VASN": [
    "VASN NLSGPDK-N2H5F0S0G0 glyco",
    "VASN cnv",
    "VASN methyl",
    "VASN proteo",
    "VASN rna"
  ],
  "VASP": [
    "VASP 239_249_1_1_S239 phospho",
    "VASP cnv",
    "VASP methyl",
    "VASP proteo",
    "VASP rna"
  ],
  "VAT1": [
    "VAT1 cnv",
    "VAT1 methyl",
    "VAT1 proteo",
    "VAT1 rna"
  ],
  "VAT1L": [
    "VAT1L 383_409_1_1_S396 phospho",
    "VAT1L cnv",
    "VAT1L methyl",
    "VAT1L proteo",
    "VAT1L rna"
  ],
  "VAV1": [
    "VAV1 cnv",
    "VAV1 proteo",
    "VAV1 rna"
  ],
  "VAV2": [
    "VAV2 768_775_1_1_S771 phospho",
    "VAV2 768_775_2_2_S768S771 phospho",
    "VAV2 771_775_1_1_S771 phospho",
    "VAV2 cnv",
    "VAV2 methyl",
    "VAV2 proteo",
    "VAV2 rna"
  ],
  "VAV3": [
    "VAV3 cnv",
    "VAV3 methyl",
    "VAV3 proteo",
    "VAV3 rna"
  ],
  "VAX1": [
    "VAX1 cnv",
    "VAX1 methyl",
    "VAX1 rna"
  ],
  "VAX2": [
    "VAX2 42_57_1_1_S42 phospho",
    "VAX2 cnv",
    "VAX2 methyl",
    "VAX2 rna"
  ],
  "VBP1": [
    "VBP1 methyl",
    "VBP1 proteo",
    "VBP1 rna"
  ],
  "VCAM1": [
    "VCAM1 cnv",
    "VCAM1 proteo",
    "VCAM1 rna"
  ],
  "VCAN": [
    "VCAN 1338_1351_1_0 phospho",
    "VCAN 1338_1351_1_1_S1351 phospho",
    "VCAN 1338_1351_2_2_S1349S1351 phospho",
    "VCAN 2112_2116_1_1_S2116 phospho",
    "VCAN FENQTGFPPPDSR-N2H5F0S0G0 glyco",
    "VCAN FENQTGFPPPDSR-N4H5F1S0G0 glyco",
    "VCAN FENQTGFPPPDSR-N5H3F1S0G0 glyco",
    "VCAN cnv",
    "VCAN proteo",
    "VCAN rna"
  ],
  "VCL": [
    "VCL 288_290_1_1_S290 phospho",
    "VCL 345_346_1_1_S346 phospho",
    "VCL 434_443_1_1_T442 phospho",
    "VCL 574_579_1_1_S579 phospho",
    "VCL 721_726_1_1_S721 phospho",
    "VCL 721_726_1_1_S726 phospho",
    "VCL 754_755_1_1_S755 phospho",
    "VCL 793_795_1_1_S795 phospho",
    "VCL cnv",
    "VCL methyl",
    "VCL proteo",
    "VCL rna"
  ],
  "VCP": [
    "VCP 702_705_1_1_S702 phospho",
    "VCP 775_805_1_0 phospho",
    "VCP cnv",
    "VCP methyl",
    "VCP proteo",
    "VCP rna"
  ],
  "VCPIP1": [
    "VCPIP1 1198_1222_1_1_S1198 phospho",
    "VCPIP1 745_763_1_1_S747 phospho",
    "VCPIP1 756_763_1_1_S757 phospho",
    "VCPIP1 997_1000_1_1_S998 phospho",
    "VCPIP1 cnv",
    "VCPIP1 methyl",
    "VCPIP1 proteo",
    "VCPIP1 rna"
  ],
  "VCPKMT": [
    "VCPKMT cnv",
    "VCPKMT methyl",
    "VCPKMT proteo",
    "VCPKMT rna"
  ],
  "VCX": [
    "VCX rna"
  ],
  "VCX3A": [
    "VCX3A rna"
  ],
  "VCX3B": [
    "VCX3B rna"
  ],
  "VDAC1": [
    "VDAC1 98_107_1_1_S104 phospho",
    "VDAC1 cnv",
    "VDAC1 methyl",
    "VDAC1 proteo",
    "VDAC1 rna"
  ],
  "VDAC2": [
    "VDAC2 124_133_1_1_S130 phospho",
    "VDAC2 cnv",
    "VDAC2 methyl",
    "VDAC2 proteo",
    "VDAC2 rna"
  ],
  "VDAC3": [
    "VDAC3 cnv",
    "VDAC3 methyl",
    "VDAC3 proteo",
    "VDAC3 rna"
  ],
  "VDR": [
    "VDR cnv",
    "VDR methyl",
    "VDR rna"
  ],
  "VEGFA": [
    "VEGFA cnv",
    "VEGFA methyl",
    "VEGFA proteo",
    "VEGFA rna"
  ],
  "VEGFB": [
    "VEGFB cnv",
    "VEGFB methyl",
    "VEGFB rna"
  ],
  "VEGFC": [
    "VEGFC cnv",
    "VEGFC methyl",
    "VEGFC rna"
  ],
  "VEGFD": [
    "VEGFD rna"
  ],
  "VENTX": [
    "VENTX cnv",
    "VENTX methyl",
    "VENTX rna"
  ],
  "VENTXP1": [
    "VENTXP1 methyl"
  ],
  "VEPH1": [
    "VEPH1 cnv",
    "VEPH1 methyl",
    "VEPH1 rna"
  ],
  "VEZF1": [
    "VEZF1 cnv",
    "VEZF1 methyl",
    "VEZF1 proteo",
    "VEZF1 rna"
  ],
  "VEZT": [
    "VEZT cnv",
    "VEZT methyl",
    "VEZT proteo",
    "VEZT rna"
  ],
  "VGF": [
    "VGF 420_424_1_1_S420 phospho",
    "VGF cnv",
    "VGF methyl",
    "VGF proteo",
    "VGF rna"
  ],
  "VGLL1": [
    "VGLL1 rna"
  ],
  "VGLL2": [
    "VGLL2 cnv",
    "VGLL2 methyl",
    "VGLL2 rna"
  ],
  "VGLL3": [
    "VGLL3 cnv",
    "VGLL3 methyl",
    "VGLL3 rna"
  ],
  "VGLL4": [
    "VGLL4 46_54_1_1_S52 phospho",
    "VGLL4 cnv",
    "VGLL4 methyl",
    "VGLL4 proteo",
    "VGLL4 rna"
  ],
  "VHL": [
    "VHL cnv",
    "VHL methyl",
    "VHL proteo",
    "VHL rna"
  ],
  "VHLL": [
    "VHLL cnv",
    "VHLL rna"
  ],
  "VIL1": [
    "VIL1 cnv",
    "VIL1 rna"
  ],
  "VILL": [
    "VILL cnv",
    "VILL methyl",
    "VILL rna"
  ],
  "VIM": [
    "VIM 144_150_1_1_S144 phospho",
    "VIM 261_266_1_1_S261 phospho",
    "VIM 276_278_1_1_S278 phospho",
    "VIM 325_327_1_1_S325 phospho",
    "VIM 325_339_1_1_S325 phospho",
    "VIM 409_420_1_1_S412 phospho",
    "VIM 412_420_1_1_S419 phospho",
    "VIM 412_420_1_1_S420 phospho",
    "VIM 412_438_1_0 phospho",
    "VIM 412_438_1_1_S420 phospho",
    "VIM 426_438_1_1_S438 phospho",
    "VIM 426_438_1_1_T436 phospho",
    "VIM 426_441_1_1_T441 phospho",
    "VIM 446_459_1_1_S459 phospho",
    "VIM 446_459_1_1_T449 phospho",
    "VIM 458_459_1_0 phospho",
    "VIM 458_459_1_1_S459 phospho",
    "VIM 51_63_1_0 phospho",
    "VIM 51_63_1_1_S51 phospho",
    "VIM 51_63_1_1_S56 phospho",
    "VIM 51_66_1_1_S51 phospho",
    "VIM 5_11_1_1_S5 phospho",
    "VIM 83_94_1_1_S83 phospho",
    "VIM cnv",
    "VIM methyl",
    "VIM proteo",
    "VIM rna"
  ],
  "VIM-AS1": [
    "VIM-AS1 methyl"
  ],
  "VIP": [
    "VIP cnv",
    "VIP rna"
  ],
  "VIPAS39": [
    "VIPAS39 117_132_1_1_S121 phospho",
    "VIPAS39 cnv",
    "VIPAS39 methyl",
    "VIPAS39 proteo",
    "VIPAS39 rna"
  ],
  "VIPR1": [
    "VIPR1 cnv",
    "VIPR1 methyl",
    "VIPR1 rna"
  ],
  "VIPR2": [
    "VIPR2 335_335_1_1_S335 phospho",
    "VIPR2 349_356_1_1_S349 phospho",
    "VIPR2 cnv",
    "VIPR2 methyl",
    "VIPR2 rna"
  ],
  "VIRMA": [
    "VIRMA 133_154_1_0 phospho",
    "VIRMA 133_154_1_1_S138 phospho",
    "VIRMA 173_173_1_1_S173 phospho",
    "VIRMA cnv",
    "VIRMA methyl",
    "VIRMA proteo",
    "VIRMA rna"
  ],
  "VIRMA-DT": [
    "VIRMA-DT methyl"
  ],
  "VIT": [
    "VIT cnv",
    "VIT rna"
  ],
  "VKORC1": [
    "VKORC1 cnv",
    "VKORC1 methyl",
    "VKORC1 proteo",
    "VKORC1 rna"
  ],
  "VKORC1L1": [
    "VKORC1L1 cnv",
    "VKORC1L1 methyl",
    "VKORC1L1 proteo",
    "VKORC1L1 rna"
  ],
  "VLDLR": [
    "VLDLR cnv",
    "VLDLR methyl",
    "VLDLR proteo",
    "VLDLR rna"
  ],
  "VLDLR-AS1": [
    "VLDLR-AS1 methyl"
  ],
  "VMA21": [
    "VMA21 methyl",
    "VMA21 proteo",
    "VMA21 rna"
  ],
  "VMAC": [
    "VMAC cnv",
    "VMAC methyl",
    "VMAC proteo",
    "VMAC rna"
  ],
  "VMO1": [
    "VMO1 cnv",
    "VMO1 rna"
  ],
  "VMP1": [
    "VMP1 cnv",
    "VMP1 methyl",
    "VMP1 proteo",
    "VMP1 rna"
  ],
  "VN1R1": [
    "VN1R1 cnv",
    "VN1R1 rna"
  ],
  "VN1R2": [
    "VN1R2 cnv",
    "VN1R2 rna"
  ],
  "VN1R4": [
    "VN1R4 cnv"
  ],
  "VN1R5": [
    "VN1R5 cnv",
    "VN1R5 rna"
  ],
  "VNN1": [
    "VNN1 cnv",
    "VNN1 rna"
  ],
  "VNN2": [
    "VNN2 cnv",
    "VNN2 proteo",
    "VNN2 rna"
  ],
  "VNN3P": [
    "VNN3P cnv",
    "VNN3P rna"
  ],
  "VOPP1": [
    "VOPP1 cnv",
    "VOPP1 methyl",
    "VOPP1 rna"
  ],
  "VPREB1": [
    "VPREB1 cnv"
  ],
  "VPREB3": [
    "VPREB3 cnv",
    "VPREB3 rna"
  ],
  "VPS11": [
    "VPS11 cnv",
    "VPS11 methyl",
    "VPS11 proteo",
    "VPS11 rna"
  ],
  "VPS13A": [
    "VPS13A 1307_1313_1_1_S1309 phospho",
    "VPS13A 1377_1385_1_1_S1377 phospho",
    "VPS13A cnv",
    "VPS13A methyl",
    "VPS13A proteo",
    "VPS13A rna"
  ],
  "VPS13B": [
    "VPS13B 1812_1815_1_1_S1815 phospho",
    "VPS13B cnv",
    "VPS13B methyl",
    "VPS13B proteo",
    "VPS13B rna"
  ],
  "VPS13C": [
    "VPS13C 1847_1859_1_1_S1851 phospho",
    "VPS13C 3591_3598_1_1_S3598 phospho",
    "VPS13C 690_694_1_1_S694 phospho",
    "VPS13C cnv",
    "VPS13C methyl",
    "VPS13C proteo",
    "VPS13C rna"
  ],
  "VPS13D": [
    "VPS13D 1042_1057_1_1_S1042 phospho",
    "VPS13D 1138_1144_1_1_S1138 phospho",
    "VPS13D 1705_1718_1_1_S1709 phospho",
    "VPS13D 1724_1739_1_1_S1724 phospho",
    "VPS13D 1724_1746_1_1_S1724 phospho",
    "VPS13D 1758_1767_1_1_S1765 phospho",
    "VPS13D 2074_2081_1_1_S2079 phospho",
    "VPS13D 2434_2438_1_1_S2434 phospho",
    "VPS13D 2454_2459_1_1_S2455 phospho",
    "VPS13D 2859_2873_2_2_S2861S2864 phospho",
    "VPS13D 2915_2938_1_1_S2919 phospho",
    "VPS13D IFISAPYWLINK-N4H3F1S0G0 glyco",
    "VPS13D cnv",
    "VPS13D proteo",
    "VPS13D rna"
  ],
  "VPS16": [
    "VPS16 cnv",
    "VPS16 methyl",
    "VPS16 proteo",
    "VPS16 rna"
  ],
  "VPS18": [
    "VPS18 cnv",
    "VPS18 methyl",
    "VPS18 proteo",
    "VPS18 rna"
  ],
  "VPS25": [
    "VPS25 cnv",
    "VPS25 proteo",
    "VPS25 rna"
  ],
  "VPS26A": [
    "VPS26A 308_314_1_1_S308 phospho",
    "VPS26A cnv",
    "VPS26A methyl",
    "VPS26A proteo",
    "VPS26A rna"
  ],
  "VPS26B": [
    "VPS26B 302_311_1_1_S302 phospho",
    "VPS26B 325_330_1_1_S330 phospho",
    "VPS26B cnv",
    "VPS26B methyl",
    "VPS26B proteo",
    "VPS26B rna"
  ],
  "VPS26C": [
    "VPS26C cnv",
    "VPS26C methyl",
    "VPS26C proteo",
    "VPS26C rna"
  ],
  "VPS28": [
    "VPS28 cnv",
    "VPS28 methyl",
    "VPS28 proteo",
    "VPS28 rna"
  ],
  "VPS29": [
    "VPS29 cnv",
    "VPS29 methyl",
    "VPS29 proteo",
    "VPS29 rna"
  ],
  "VPS33A": [
    "VPS33A cnv",
    "VPS33A methyl",
    "VPS33A proteo",
    "VPS33A rna"
  ],
  "VPS33B": [
    "VPS33B cnv",
    "VPS33B methyl",
    "VPS33B proteo",
    "VPS33B rna"
  ],
  "VPS33B-DT": [
    "VPS33B-DT methyl"
  ],
  "VPS35": [
    "VPS35 3_7_1_1_S7 phospho",
    "VPS35 783_791_1_1_S783 phospho",
    "VPS35 cnv",
    "VPS35 methyl",
    "VPS35 proteo",
    "VPS35 rna"
  ],
  "VPS35L": [
    "VPS35L cnv",
    "VPS35L methyl",
    "VPS35L proteo",
    "VPS35L rna"
  ],
  "VPS36": [
    "VPS36 cnv",
    "VPS36 methyl",
    "VPS36 proteo",
    "VPS36 rna"
  ],
  "VPS37A": [
    "VPS37A cnv",
    "VPS37A methyl",
    "VPS37A proteo",
    "VPS37A rna"
  ],
  "VPS37B": [
    "VPS37B cnv",
    "VPS37B methyl",
    "VPS37B proteo",
    "VPS37B rna"
  ],
  "VPS37C": [
    "VPS37C cnv",
    "VPS37C methyl",
    "VPS37C proteo",
    "VPS37C rna"
  ],
  "VPS37D": [
    "VPS37D cnv",
    "VPS37D methyl",
    "VPS37D rna"
  ],
  "VPS39": [
    "VPS39 cnv",
    "VPS39 methyl",
    "VPS39 proteo",
    "VPS39 rna"
  ],
  "VPS41": [
    "VPS41 cnv",
    "VPS41 proteo",
    "VPS41 rna"
  ],
  "VPS45": [
    "VPS45 cnv",
    "VPS45 methyl",
    "VPS45 proteo",
    "VPS45 rna"
  ],
  "VPS4A": [
    "VPS4A 90_99_1_0 phospho",
    "VPS4A 90_99_1_1_S97 phospho",
    "VPS4A 90_99_2_0 phospho",
    "VPS4A 90_99_2_2_S95S97 phospho",
    "VPS4A 90_99_3_3_S95S97S99 phospho",
    "VPS4A 95_99_1_1_S97 phospho",
    "VPS4A cnv",
    "VPS4A methyl",
    "VPS4A proteo",
    "VPS4A rna"
  ],
  "VPS4B": [
    "VPS4B 102_108_1_1_S102 phospho",
    "VPS4B 93_108_1_1_S102 phospho",
    "VPS4B 93_93_1_1_S93 phospho",
    "VPS4B cnv",
    "VPS4B methyl",
    "VPS4B proteo",
    "VPS4B rna"
  ],
  "VPS50": [
    "VPS50 15_28_1_1_S15 phospho",
    "VPS50 492_500_1_1_S494 phospho",
    "VPS50 492_508_1_1_S494 phospho",
    "VPS50 492_508_2_2_S494S498 phospho",
    "VPS50 494_500_1_1_S494 phospho",
    "VPS50 552_561_1_1_S559 phospho",
    "VPS50 cnv",
    "VPS50 proteo",
    "VPS50 rna"
  ],
  "VPS51": [
    "VPS51 cnv",
    "VPS51 methyl",
    "VPS51 proteo",
    "VPS51 rna"
  ],
  "VPS52": [
    "VPS52 285_301_1_1_S288 phospho",
    "VPS52 cnv",
    "VPS52 methyl",
    "VPS52 proteo",
    "VPS52 rna"
  ],
  "VPS53": [
    "VPS53 cnv",
    "VPS53 methyl",
    "VPS53 proteo",
    "VPS53 rna"
  ],
  "VPS54": [
    "VPS54 cnv",
    "VPS54 methyl",
    "VPS54 proteo",
    "VPS54 rna"
  ],
  "VPS72": [
    "VPS72 cnv",
    "VPS72 proteo",
    "VPS72 rna"
  ],
  "VPS8": [
    "VPS8 1338_1344_1_1_S1338 phospho",
    "VPS8 cnv",
    "VPS8 methyl",
    "VPS8 proteo",
    "VPS8 rna"
  ],
  "VPS9D1": [
    "VPS9D1 115_116_1_1_S116 phospho",
    "VPS9D1 317_322_1_1_T317 phospho",
    "VPS9D1 cnv",
    "VPS9D1 methyl",
    "VPS9D1 proteo",
    "VPS9D1 rna"
  ],
  "VRK1": [
    "VRK1 cnv",
    "VRK1 kinase",
    "VRK1 methyl",
    "VRK1 proteo",
    "VRK1 rna"
  ],
  "VRK2": [
    "VRK2 cnv",
    "VRK2 kinase",
    "VRK2 methyl",
    "VRK2 rna"
  ],
  "VRK3": [
    "VRK3 cnv",
    "VRK3 kinase",
    "VRK3 methyl",
    "VRK3 proteo",
    "VRK3 rna"
  ],
  "VRTN": [
    "VRTN cnv",
    "VRTN methyl",
    "VRTN rna"
  ],
  "VSIG1": [
    "VSIG1 rna"
  ],
  "VSIG10": [
    "VSIG10 cnv",
    "VSIG10 methyl",
    "VSIG10 rna"
  ],
  "VSIG10L": [
    "VSIG10L cnv",
    "VSIG10L methyl",
    "VSIG10L rna"
  ],
  "VSIG10L2": [
    "VSIG10L2 cnv",
    "VSIG10L2 rna"
  ],
  "VSIG2": [
    "VSIG2 cnv",
    "VSIG2 rna"
  ],
  "VSIG4": [
    "VSIG4 216_223_1_1_S217 phospho",
    "VSIG4 proteo",
    "VSIG4 rna"
  ],
  "VSIG8": [
    "VSIG8 cnv",
    "VSIG8 rna"
  ],
  "VSIR": [
    "VSIR 235_248_1_1_S235 phospho",
    "VSIR cnv",
    "VSIR methyl",
    "VSIR proteo",
    "VSIR rna"
  ],
  "VSNL1": [
    "VSNL1 146_146_1_1_T146 phospho",
    "VSNL1 cnv",
    "VSNL1 methyl",
    "VSNL1 proteo",
    "VSNL1 rna"
  ],
  "VSTM1": [
    "VSTM1 cnv",
    "VSTM1 rna"
  ],
  "VSTM2A": [
    "VSTM2A cnv",
    "VSTM2A methyl",
    "VSTM2A proteo",
    "VSTM2A rna"
  ],
  "VSTM2B": [
    "VSTM2B cnv",
    "VSTM2B methyl",
    "VSTM2B proteo",
    "VSTM2B rna"
  ],
  "VSTM2B-DT": [
    "VSTM2B-DT methyl"
  ],
  "VSTM2L": [
    "VSTM2L cnv",
    "VSTM2L methyl",
    "VSTM2L proteo",
    "VSTM2L rna"
  ],
  "VSTM4": [
    "VSTM4 cnv",
    "VSTM4 methyl",
    "VSTM4 rna"
  ],
  "VSTM5": [
    "VSTM5 cnv",
    "VSTM5 methyl",
    "VSTM5 rna"
  ],
  "VSX1": [
    "VSX1 cnv",
    "VSX1 methyl",
    "VSX1 rna"
  ],
  "VSX2": [
    "VSX2 cnv",
    "VSX2 methyl",
    "VSX2 rna"
  ],
  "VTA1": [
    "VTA1 16_16_1_1_S16 phospho",
    "VTA1 251_263_1_1_Y251 phospho",
    "VTA1 cnv",
    "VTA1 methyl",
    "VTA1 proteo",
    "VTA1 rna"
  ],
  "VTCN1": [
    "VTCN1 cnv",
    "VTCN1 rna"
  ],
  "VTI1A": [
    "VTI1A cnv",
    "VTI1A methyl",
    "VTI1A proteo",
    "VTI1A rna"
  ],
  "VTI1B": [
    "VTI1B cnv",
    "VTI1B methyl",
    "VTI1B proteo",
    "VTI1B rna"
  ],
  "VTN": [
    "VTN NGSLFAFR-N2H4F0S0G0 glyco",
    "VTN NGSLFAFR-N3H4F0S1G0 glyco",
    "VTN NGSLFAFR-N3H5F0S1G0 glyco",
    "VTN NGSLFAFR-N4H5F0S1G0 glyco",
    "VTN NGSLFAFR-N4H5F0S2G0 glyco",
    "VTN NISDGFDGIPDNVDAALALPAHSYSGR-N4H5F0S1G0 glyco",
    "VTN NISDGFDGIPDNVDAALALPAHSYSGR-N4H5F0S2G0 glyco",
    "VTN NNATVHEQVGGPSLTSDLQAQSK-N4H5F0S1G0 glyco",
    "VTN NNATVHEQVGGPSLTSDLQAQSK-N4H5F0S2G0 glyco",
    "VTN NNATVHEQVGGPSLTSDLQAQSK-N4H5F1S2G0 glyco",
    "VTN NNATVHEQVGGPSLTSDLQAQSK-N4H5F2S1G0 glyco",
    "VTN NNATVHEQVGGPSLTSDLQAQSK-N6H3F5S0G0 glyco",
    "VTN cnv",
    "VTN proteo",
    "VTN rna"
  ],
  "VWA1": [
    "VWA1 cnv",
    "VWA1 proteo",
    "VWA1 rna"
  ],
  "VWA2": [
    "VWA2 cnv",
    "VWA2 methyl",
    "VWA2 rna"
  ],
  "VWA3A": [
    "VWA3A cnv",
    "VWA3A rna"
  ],
  "VWA3B": [
    "VWA3B cnv",
    "VWA3B methyl",
    "VWA3B rna"
  ],
  "VWA5A": [
    "VWA5A cnv",
    "VWA5A proteo",
    "VWA5A rna"
  ],
  "VWA5B1": [
    "VWA5B1 cnv",
    "VWA5B1 rna"
  ],
  "VWA5B2": [
    "VWA5B2 740_768_1_1_T749 phospho",
    "VWA5B2 cnv",
    "VWA5B2 methyl",
    "VWA5B2 rna"
  ],
  "VWA7": [
    "VWA7 cnv",
    "VWA7 rna"
  ],
  "VWA8": [
    "VWA8 cnv",
    "VWA8 methyl",
    "VWA8 proteo",
    "VWA8 rna"
  ],
  "VWA8-AS1": [
    "VWA8-AS1 methyl"
  ],
  "VWC2": [
    "VWC2 cnv",
    "VWC2 methyl",
    "VWC2 rna"
  ],
  "VWC2L": [
    "VWC2L cnv",
    "VWC2L rna"
  ],
  "VWCE": [
    "VWCE cnv",
    "VWCE methyl",
    "VWCE rna"
  ],
  "VWDE": [
    "VWDE cnv",
    "VWDE methyl",
    "VWDE rna"
  ],
  "VWF": [
    "VWF GLQPTLTNPGECRPNFTCACR-N4H5F1S1G0 glyco",
    "VWF GQVYLQCGTPCNLTCR-N4H5F1S0G0 glyco",
    "VWF MEACMLNGTVIGPGK-N4H5F1S1G0 glyco",
    "VWF NVSCPQLEVPVCPSGFQLSCK-N4H5F1S1G0 glyco",
    "VWF NVSCPQLEVPVCPSGFQLSCK-N4H5F1S2G0 glyco",
    "VWF NVSCPQLEVPVCPSGFQLSCK-N4H5F2S1G0 glyco",
    "VWF cnv",
    "VWF proteo",
    "VWF rna"
  ],
  "VXN": [
    "VXN cnv",
    "VXN methyl",
    "VXN rna"
  ],
  "WAC": [
    "WAC 12_12_1_1_S12 phospho",
    "WAC 456_476_1_1_S470 phospho",
    "WAC 456_476_2_2_T457T471 phospho",
    "WAC 491_511_1_1_S511 phospho",
    "WAC 511_511_1_1_S511 phospho",
    "WAC 53_53_1_1_S53 phospho",
    "WAC 62_64_1_1_S64 phospho",
    "WAC 62_76_1_1_S64 phospho",
    "WAC cnv",
    "WAC methyl",
    "WAC proteo",
    "WAC rna"
  ],
  "WAKMAR2": [
    "WAKMAR2 methyl"
  ],
  "WAPL": [
    "WAPL 221_226_1_1_S221 phospho",
    "WAPL 221_226_2_2_S221S226 phospho",
    "WAPL cnv",
    "WAPL methyl",
    "WAPL proteo",
    "WAPL rna"
  ],
  "WARS1": [
    "WARS1 4_18_1_1_S4 phospho",
    "WARS1 cnv",
    "WARS1 methyl",
    "WARS1 proteo",
    "WARS1 rna"
  ],
  "WARS2": [
    "WARS2 cnv",
    "WARS2 methyl",
    "WARS2 proteo",
    "WARS2 rna"
  ],
  "WARS2-AS1": [
    "WARS2-AS1 methyl"
  ],
  "WAS": [
    "WAS 234_242_1_1_S234 phospho",
    "WAS methyl",
    "WAS proteo",
    "WAS rna"
  ],
  "WASF1": [
    "WASF1 489_495_1_1_S489 phospho",
    "WASF1 cnv",
    "WASF1 methyl",
    "WASF1 proteo",
    "WASF1 rna"
  ],
  "WASF2": [
    "WASF2 102_104_1_1_S103 phospho",
    "WASF2 284_284_1_1_S284 phospho",
    "WASF2 292_308_1_0 phospho",
    "WASF2 cnv",
    "WASF2 methyl",
    "WASF2 proteo",
    "WASF2 rna"
  ],
  "WASF3": [
    "WASF3 221_238_1_1_S235 phospho",
    "WASF3 cnv",
    "WASF3 methyl",
    "WASF3 proteo",
    "WASF3 rna"
  ],
  "WASH6P": [
    "WASH6P rna"
  ],
  "WASHC1": [
    "WASHC1 340_347_1_1_S345 phospho",
    "WASHC1 cnv",
    "WASHC1 methyl",
    "WASHC1 proteo",
    "WASHC1 rna"
  ],
  "WASHC2A": [
    "WASHC2A 1053_1060_1_0 phospho",
    "WASHC2A 1053_1060_1_1_S1053 phospho",
    "WASHC2A 539_554_1_1_S539 phospho",
    "WASHC2A 5_24_1_0 phospho",
    "WASHC2A cnv",
    "WASHC2A methyl",
    "WASHC2A proteo",
    "WASHC2A rna"
  ],
  "WASHC2C": [
    "WASHC2C 1053_1060_1_1_S1053 phospho",
    "WASHC2C 5_24_1_0 phospho",
    "WASHC2C 909_912_1_1_S909 phospho",
    "WASHC2C 909_912_1_1_S912 phospho",
    "WASHC2C cnv",
    "WASHC2C methyl",
    "WASHC2C proteo",
    "WASHC2C rna"
  ],
  "WASHC3": [
    "WASHC3 cnv",
    "WASHC3 methyl",
    "WASHC3 proteo",
    "WASHC3 rna"
  ],
  "WASHC4": [
    "WASHC4 1096_1098_1_1_S1098 phospho",
    "WASHC4 1155_1168_1_1_S1158 phospho",
    "WASHC4 cnv",
    "WASHC4 methyl",
    "WASHC4 proteo",
    "WASHC4 rna"
  ],
  "WASHC5": [
    "WASHC5 cnv",
    "WASHC5 methyl",
    "WASHC5 proteo",
    "WASHC5 rna"
  ],
  "WASL": [
    "WASL cnv",
    "WASL methyl",
    "WASL proteo",
    "WASL rna"
  ],
  "WBP1": [
    "WBP1 cnv",
    "WBP1 methyl",
    "WBP1 rna"
  ],
  "WBP11": [
    "WBP11 593_604_1_0 phospho",
    "WBP11 cnv",
    "WBP11 methyl",
    "WBP11 proteo",
    "WBP11 rna"
  ],
  "WBP1L": [
    "WBP1L cnv",
    "WBP1L rna"
  ],
  "WBP2": [
    "WBP2 cnv",
    "WBP2 methyl",
    "WBP2 proteo",
    "WBP2 rna"
  ],
  "WBP2NL": [
    "WBP2NL cnv",
    "WBP2NL methyl",
    "WBP2NL rna"
  ],
  "WBP4": [
    "WBP4 258_266_1_1_S262 phospho",
    "WBP4 258_266_2_2_S258S262 phospho",
    "WBP4 cnv",
    "WBP4 methyl",
    "WBP4 proteo",
    "WBP4 rna"
  ],
  "WDCP": [
    "WDCP 466_468_1_1_S468 phospho",
    "WDCP 686_696_1_1_S690 phospho",
    "WDCP cnv",
    "WDCP methyl",
    "WDCP proteo",
    "WDCP rna"
  ],
  "WDFY1": [
    "WDFY1 396_408_1_1_S408 phospho",
    "WDFY1 cnv",
    "WDFY1 methyl",
    "WDFY1 proteo",
    "WDFY1 rna"
  ],
  "WDFY2": [
    "WDFY2 cnv",
    "WDFY2 methyl",
    "WDFY2 proteo",
    "WDFY2 rna"
  ],
  "WDFY3": [
    "WDFY3 1940_1949_1_1_S1942 phospho",
    "WDFY3 2492_2525_1_1_S2492 phospho",
    "WDFY3 3335_3339_1_1_S3335 phospho",
    "WDFY3 813_822_1_1_T818 phospho",
    "WDFY3 969_973_1_1_S970 phospho",
    "WDFY3 cnv",
    "WDFY3 methyl",
    "WDFY3 proteo",
    "WDFY3 rna"
  ],
  "WDFY3-AS2": [
    "WDFY3-AS2 methyl"
  ],
  "WDFY4": [
    "WDFY4 cnv",
    "WDFY4 proteo",
    "WDFY4 rna"
  ],
  "WDHD1": [
    "WDHD1 374_387_1_1_S383 phospho",
    "WDHD1 391_427_1_1_S407 phospho",
    "WDHD1 868_888_1_1_S868 phospho",
    "WDHD1 cnv",
    "WDHD1 methyl",
    "WDHD1 proteo",
    "WDHD1 rna"
  ],
  "WDPCP": [
    "WDPCP cnv",
    "WDPCP methyl",
    "WDPCP rna"
  ],
  "WDR1": [
    "WDR1 322_327_1_1_S322 phospho",
    "WDR1 cnv",
    "WDR1 methyl",
    "WDR1 proteo",
    "WDR1 rna"
  ],
  "WDR11": [
    "WDR11 202_209_1_1_S205 phospho",
    "WDR11 202_209_1_1_S209 phospho",
    "WDR11 202_209_2_2_S205S209 phospho",
    "WDR11 cnv",
    "WDR11 methyl",
    "WDR11 proteo",
    "WDR11 rna"
  ],
  "WDR11-DT": [
    "WDR11-DT methyl"
  ],
  "WDR12": [
    "WDR12 217_231_1_1_T221 phospho",
    "WDR12 cnv",
    "WDR12 methyl",
    "WDR12 proteo",
    "WDR12 rna"
  ],
  "WDR13": [
    "WDR13 methyl",
    "WDR13 proteo",
    "WDR13 rna"
  ],
  "WDR17": [
    "WDR17 1215_1227_1_1_T1222 phospho",
    "WDR17 330_335_1_1_S333 phospho",
    "WDR17 cnv",
    "WDR17 methyl",
    "WDR17 proteo",
    "WDR17 rna"
  ],
  "WDR18": [
    "WDR18 cnv",
    "WDR18 methyl",
    "WDR18 proteo",
    "WDR18 rna"
  ],
  "WDR19": [
    "WDR19 cnv",
    "WDR19 methyl",
    "WDR19 proteo",
    "WDR19 rna"
  ],
  "WDR20": [
    "WDR20 371_384_1_0 phospho",
    "WDR20 371_384_2_2_S373S384 phospho",
    "WDR20 422_428_1_1_S422 phospho",
    "WDR20 cnv",
    "WDR20 methyl",
    "WDR20 proteo",
    "WDR20 rna"
  ],
  "WDR24": [
    "WDR24 cnv",
    "WDR24 methyl",
    "WDR24 proteo",
    "WDR24 rna"
  ],
  "WDR25": [
    "WDR25 cnv",
    "WDR25 methyl",
    "WDR25 rna"
  ],
  "WDR26": [
    "WDR26 121_123_1_1_S121 phospho",
    "WDR26 cnv",
    "WDR26 proteo",
    "WDR26 rna"
  ],
  "WDR27": [
    "WDR27 cnv",
    "WDR27 methyl",
    "WDR27 rna"
  ],
  "WDR3": [
    "WDR3 cnv",
    "WDR3 methyl",
    "WDR3 proteo",
    "WDR3 rna"
  ],
  "WDR31": [
    "WDR31 cnv",
    "WDR31 methyl",
    "WDR31 rna"
  ],
  "WDR33": [
    "WDR33 1277_1288_1_1_S1279 phospho",
    "WDR33 cnv",
    "WDR33 methyl",
    "WDR33 proteo",
    "WDR33 rna"
  ],
  "WDR35": [
    "WDR35 cnv",
    "WDR35 methyl",
    "WDR35 proteo",
    "WDR35 rna"
  ],
  "WDR35-DT": [
    "WDR35-DT methyl"
  ],
  "WDR36": [
    "WDR36 cnv",
    "WDR36 methyl",
    "WDR36 proteo",
    "WDR36 rna"
  ],
  "WDR37": [
    "WDR37 112_119_1_1_S119 phospho",
    "WDR37 cnv",
    "WDR37 methyl",
    "WDR37 proteo",
    "WDR37 rna"
  ],
  "WDR38": [
    "WDR38 cnv",
    "WDR38 methyl",
    "WDR38 rna"
  ],
  "WDR4": [
    "WDR4 cnv",
    "WDR4 methyl",
    "WDR4 proteo",
    "WDR4 rna"
  ],
  "WDR41": [
    "WDR41 cnv",
    "WDR41 methyl",
    "WDR41 proteo",
    "WDR41 rna"
  ],
  "WDR43": [
    "WDR43 cnv",
    "WDR43 methyl",
    "WDR43 proteo",
    "WDR43 rna"
  ],
  "WDR44": [
    "WDR44 143_173_1_0 phospho",
    "WDR44 158_173_1_0 phospho",
    "WDR44 194_200_1_1_S199 phospho",
    "WDR44 219_228_1_1_T219 phospho",
    "WDR44 262_268_1_1_S262 phospho",
    "WDR44 342_356_1_0 phospho",
    "WDR44 342_356_1_1_S344 phospho",
    "WDR44 395_403_1_1_S403 phospho",
    "WDR44 395_416_1_1_S403 phospho",
    "WDR44 39_50_1_1_S50 phospho",
    "WDR44 50_50_1_1_S50 phospho",
    "WDR44 554_572_1_1_S561 phospho",
    "WDR44 561_572_1_1_S561 phospho",
    "WDR44 574_584_1_1_S574 phospho",
    "WDR44 90_96_1_1_S96 phospho",
    "WDR44 methyl",
    "WDR44 proteo",
    "WDR44 rna"
  ],
  "WDR45": [
    "WDR45 methyl",
    "WDR45 proteo",
    "WDR45 rna"
  ],
  "WDR45B": [
    "WDR45B cnv",
    "WDR45B methyl",
    "WDR45B proteo",
    "WDR45B rna"
  ],
  "WDR46": [
    "WDR46 cnv",
    "WDR46 methyl",
    "WDR46 proteo",
    "WDR46 rna"
  ],
  "WDR47": [
    "WDR47 319_333_1_1_S319 phospho",
    "WDR47 339_364_1_0 phospho",
    "WDR47 339_364_1_1_S346 phospho",
    "WDR47 345_364_1_1_S351 phospho",
    "WDR47 430_438_1_1_S430 phospho",
    "WDR47 556_591_1_1_S586 phospho",
    "WDR47 cnv",
    "WDR47 methyl",
    "WDR47 proteo",
    "WDR47 rna"
  ],
  "WDR48": [
    "WDR48 253_269_1_1_S253 phospho",
    "WDR48 cnv",
    "WDR48 methyl",
    "WDR48 proteo",
    "WDR48 rna"
  ],
  "WDR49": [
    "WDR49 cnv",
    "WDR49 rna"
  ],
  "WDR5": [
    "WDR5 cnv",
    "WDR5 methyl",
    "WDR5 proteo",
    "WDR5 rna"
  ],
  "WDR53": [
    "WDR53 cnv",
    "WDR53 methyl",
    "WDR53 proteo",
    "WDR53 rna"
  ],
  "WDR54": [
    "WDR54 cnv",
    "WDR54 methyl",
    "WDR54 proteo",
    "WDR54 rna"
  ],
  "WDR55": [
    "WDR55 4_26_1_1_S14 phospho",
    "WDR55 cnv",
    "WDR55 methyl",
    "WDR55 proteo",
    "WDR55 rna"
  ],
  "WDR59": [
    "WDR59 564_569_1_1_S564 phospho",
    "WDR59 782_801_1_0 phospho",
    "WDR59 815_822_1_1_S822 phospho",
    "WDR59 cnv",
    "WDR59 methyl",
    "WDR59 proteo",
    "WDR59 rna"
  ],
  "WDR5B": [
    "WDR5B cnv",
    "WDR5B methyl",
    "WDR5B rna"
  ],
  "WDR6": [
    "WDR6 cnv",
    "WDR6 methyl",
    "WDR6 proteo",
    "WDR6 rna"
  ],
  "WDR61": [
    "WDR61 cnv",
    "WDR61 proteo",
    "WDR61 rna"
  ],
  "WDR62": [
    "WDR62 32_33_1_1_S33 phospho",
    "WDR62 cnv",
    "WDR62 methyl",
    "WDR62 rna"
  ],
  "WDR64": [
    "WDR64 cnv",
    "WDR64 rna"
  ],
  "WDR7": [
    "WDR7 1152_1170_1_1_S1154 phospho",
    "WDR7 935_940_1_1_S935 phospho",
    "WDR7 cnv",
    "WDR7 methyl",
    "WDR7 proteo",
    "WDR7 rna"
  ],
  "WDR70": [
    "WDR70 cnv",
    "WDR70 methyl",
    "WDR70 proteo",
    "WDR70 rna"
  ],
  "WDR72": [
    "WDR72 cnv",
    "WDR72 methyl",
    "WDR72 rna"
  ],
  "WDR73": [
    "WDR73 cnv",
    "WDR73 methyl",
    "WDR73 proteo",
    "WDR73 rna"
  ],
  "WDR74": [
    "WDR74 cnv",
    "WDR74 methyl",
    "WDR74 proteo",
    "WDR74 rna"
  ],
  "WDR75": [
    "WDR75 731_745_1_1_S732 phospho",
    "WDR75 cnv",
    "WDR75 methyl",
    "WDR75 proteo",
    "WDR75 rna"
  ],
  "WDR76": [
    "WDR76 cnv",
    "WDR76 methyl",
    "WDR76 proteo",
    "WDR76 rna"
  ],
  "WDR77": [
    "WDR77 5_5_1_1_T5 phospho",
    "WDR77 cnv",
    "WDR77 methyl",
    "WDR77 proteo",
    "WDR77 rna"
  ],
  "WDR81": [
    "WDR81 1266_1281_1_1_S1272 phospho",
    "WDR81 cnv",
    "WDR81 methyl",
    "WDR81 proteo",
    "WDR81 rna"
  ],
  "WDR82": [
    "WDR82 cnv",
    "WDR82 methyl",
    "WDR82 proteo",
    "WDR82 rna"
  ],
  "WDR83": [
    "WDR83 cnv",
    "WDR83 methyl",
    "WDR83 proteo",
    "WDR83 rna"
  ],
  "WDR83OS": [
    "WDR83OS cnv",
    "WDR83OS methyl",
    "WDR83OS rna"
  ],
  "WDR86": [
    "WDR86 cnv",
    "WDR86 methyl",
    "WDR86 rna"
  ],
  "WDR86-AS1": [
    "WDR86-AS1 methyl"
  ],
  "WDR87": [
    "WDR87 cnv",
    "WDR87 methyl",
    "WDR87 rna"
  ],
  "WDR87BP": [
    "WDR87BP methyl"
  ],
  "WDR88": [
    "WDR88 cnv",
    "WDR88 methyl",
    "WDR88 rna"
  ],
  "WDR89": [
    "WDR89 377_381_1_1_S380 phospho",
    "WDR89 cnv",
    "WDR89 methyl",
    "WDR89 proteo",
    "WDR89 rna"
  ],
  "WDR90": [
    "WDR90 cnv",
    "WDR90 methyl",
    "WDR90 rna"
  ],
  "WDR91": [
    "WDR91 cnv",
    "WDR91 methyl",
    "WDR91 proteo",
    "WDR91 rna"
  ],
  "WDR93": [
    "WDR93 cnv",
    "WDR93 methyl",
    "WDR93 rna"
  ],
  "WDR97": [
    "WDR97 cnv",
    "WDR97 methyl",
    "WDR97 rna"
  ],
  "WDSUB1": [
    "WDSUB1 cnv",
    "WDSUB1 methyl",
    "WDSUB1 proteo",
    "WDSUB1 rna"
  ],
  "WDTC1": [
    "WDTC1 353_361_1_1_S353 phospho",
    "WDTC1 511_513_1_1_S511 phospho",
    "WDTC1 cnv",
    "WDTC1 methyl",
    "WDTC1 proteo",
    "WDTC1 rna"
  ],
  "WEE1": [
    "WEE1 127_139_1_1_S139 phospho",
    "WEE1 165_173_1_1_S165 phospho",
    "WEE1 165_173_1_1_T173 phospho",
    "WEE1 165_173_2_2_S165T173 phospho",
    "WEE1 187_190_1_1_T190 phospho",
    "WEE1 640_646_1_1_S642 phospho",
    "WEE1 cnv",
    "WEE1 kinase",
    "WEE1 methyl",
    "WEE1 proteo",
    "WEE1 rna"
  ],
  "WEE2": [
    "WEE2 54_70_1_0 phospho",
    "WEE2 cnv",
    "WEE2 kinase",
    "WEE2 rna"
  ],
  "WEE2-AS1": [
    "WEE2-AS1 methyl"
  ],
  "WFDC1": [
    "WFDC1 cnv",
    "WFDC1 rna"
  ],
  "WFDC10A": [
    "WFDC10A cnv"
  ],
  "WFDC10B": [
    "WFDC10B cnv",
    "WFDC10B rna"
  ],
  "WFDC11": [
    "WFDC11 cnv",
    "WFDC11 rna"
  ],
  "WFDC12": [
    "WFDC12 cnv"
  ],
  "WFDC13": [
    "WFDC13 cnv",
    "WFDC13 rna"
  ],
  "WFDC2": [
    "WFDC2 cnv",
    "WFDC2 methyl",
    "WFDC2 rna"
  ],
  "WFDC3": [
    "WFDC3 cnv",
    "WFDC3 methyl",
    "WFDC3 rna"
  ],
  "WFDC5": [
    "WFDC5 cnv",
    "WFDC5 rna"
  ],
  "WFDC6": [
    "WFDC6 cnv"
  ],
  "WFDC8": [
    "WFDC8 cnv",
    "WFDC8 rna"
  ],
  "WFDC9": [
    "WFDC9 cnv"
  ],
  "WFIKKN1": [
    "WFIKKN1 cnv",
    "WFIKKN1 rna"
  ],
  "WFIKKN2": [
    "WFIKKN2 cnv",
    "WFIKKN2 rna"
  ],
  "WFS1": [
    "WFS1 CLYGEAYPACSPGNTSTAEEELCR-N2H5F0S0G0 glyco",
    "WFS1 cnv",
    "WFS1 methyl",
    "WFS1 proteo",
    "WFS1 rna"
  ],
  "WHAMM": [
    "WHAMM cnv",
    "WHAMM methyl",
    "WHAMM rna"
  ],
  "WHRN": [
    "WHRN 243_248_1_1_S245 phospho",
    "WHRN 685_685_1_1_S685 phospho",
    "WHRN cnv",
    "WHRN methyl",
    "WHRN proteo",
    "WHRN rna"
  ],
  "WIF1": [
    "WIF1 cnv",
    "WIF1 methyl",
    "WIF1 rna"
  ],
  "WIPF1": [
    "WIPF1 cnv",
    "WIPF1 methyl",
    "WIPF1 proteo",
    "WIPF1 rna"
  ],
  "WIPF2": [
    "WIPF2 155_168_1_1_S155 phospho",
    "WIPF2 173_175_1_1_S175 phospho",
    "WIPF2 235_235_1_1_S235 phospho",
    "WIPF2 266_272_1_0 phospho",
    "WIPF2 cnv",
    "WIPF2 methyl",
    "WIPF2 proteo",
    "WIPF2 rna"
  ],
  "WIPF3": [
    "WIPF3 139_149_1_1_S149 phospho",
    "WIPF3 198_208_1_1_S202 phospho",
    "WIPF3 233_244_1_1_T233 phospho",
    "WIPF3 281_303_1_1_S281 phospho",
    "WIPF3 307_332_1_1_S330 phospho",
    "WIPF3 383_390_1_1_S383 phospho",
    "WIPF3 412_421_1_1_S412 phospho",
    "WIPF3 cnv",
    "WIPF3 methyl",
    "WIPF3 proteo",
    "WIPF3 rna"
  ],
  "WIPI1": [
    "WIPI1 cnv",
    "WIPI1 methyl",
    "WIPI1 proteo",
    "WIPI1 rna"
  ],
  "WIPI2": [
    "WIPI2 cnv",
    "WIPI2 methyl",
    "WIPI2 proteo",
    "WIPI2 rna"
  ],
  "WIZ": [
    "WIZ 166_167_1_1_S167 phospho",
    "WIZ 173_182_1_1_S180 phospho",
    "WIZ 190_201_1_1_S201 phospho",
    "WIZ 311_318_1_1_S318 phospho",
    "WIZ cnv",
    "WIZ methyl",
    "WIZ proteo",
    "WIZ rna"
  ],
  "WLS": [
    "WLS cnv",
    "WLS methyl",
    "WLS proteo",
    "WLS rna"
  ],
  "WNK1": [
    "WNK1 1521_1526_1_1_S1521 phospho",
    "WNK1 1536_1568_1_0 phospho",
    "WNK1 167_174_1_1_S167 phospho",
    "WNK1 2108_2110_1_1_S2109 phospho",
    "WNK1 2238_2238_1_1_S2238 phospho",
    "WNK1 2262_2280_1_0 phospho",
    "WNK1 2262_2280_1_1_S2272 phospho",
    "WNK1 2287_2298_1_1_S2289 phospho",
    "WNK1 2287_2298_1_1_S2292 phospho",
    "WNK1 2287_2298_2_2_S2287S2289 phospho",
    "WNK1 2287_2298_3_3_S2287S2289S2292 phospho",
    "WNK1 2530_2536_1_1_S2530 phospho",
    "WNK1 2546_2577_1_1_S2546 phospho",
    "WNK1 2630_2637_1_1_S2630 phospho",
    "WNK1 950_961_1_1_S950 phospho",
    "WNK1 cnv",
    "WNK1 kinase",
    "WNK1 methyl",
    "WNK1 proteo",
    "WNK1 rna"
  ],
  "WNK2": [
    "WNK2 1767_1781_1_1_S1781 phospho",
    "WNK2 1825_1831_1_1_S1825 phospho",
    "WNK2 560_560_1_1_S560 phospho",
    "WNK2 cnv",
    "WNK2 kinase",
    "WNK2 methyl",
    "WNK2 proteo",
    "WNK2 rna"
  ],
  "WNK3": [
    "WNK3 1423_1435_1_1_S1424 phospho",
    "WNK3 1527_1538_1_1_S1538 phospho",
    "WNK3 905_905_1_1_S905 phospho",
    "WNK3 kinase",
    "WNK3 methyl",
    "WNK3 proteo",
    "WNK3 rna"
  ],
  "WNK4": [
    "WNK4 cnv",
    "WNK4 kinase",
    "WNK4 methyl",
    "WNK4 rna"
  ],
  "WNT1": [
    "WNT1 cnv",
    "WNT1 methyl",
    "WNT1 rna"
  ],
  "WNT10A": [
    "WNT10A cnv",
    "WNT10A methyl",
    "WNT10A rna"
  ],
  "WNT10B": [
    "WNT10B cnv",
    "WNT10B rna"
  ],
  "WNT11": [
    "WNT11 cnv",
    "WNT11 methyl",
    "WNT11 rna"
  ],
  "WNT16": [
    "WNT16 cnv",
    "WNT16 rna"
  ],
  "WNT2": [
    "WNT2 cnv",
    "WNT2 methyl",
    "WNT2 rna"
  ],
  "WNT2B": [
    "WNT2B cnv",
    "WNT2B methyl",
    "WNT2B rna"
  ],
  "WNT3": [
    "WNT3 cnv",
    "WNT3 methyl",
    "WNT3 rna"
  ],
  "WNT3A": [
    "WNT3A cnv",
    "WNT3A methyl",
    "WNT3A rna"
  ],
  "WNT4": [
    "WNT4 cnv",
    "WNT4 methyl",
    "WNT4 rna"
  ],
  "WNT5A": [
    "WNT5A cnv",
    "WNT5A methyl",
    "WNT5A rna"
  ],
  "WNT5B": [
    "WNT5B cnv",
    "WNT5B methyl",
    "WNT5B rna"
  ],
  "WNT6": [
    "WNT6 cnv",
    "WNT6 methyl",
    "WNT6 rna"
  ],
  "WNT7A": [
    "WNT7A cnv",
    "WNT7A methyl",
    "WNT7A rna"
  ],
  "WNT7B": [
    "WNT7B cnv",
    "WNT7B methyl",
    "WNT7B rna"
  ],
  "WNT8A": [
    "WNT8A cnv",
    "WNT8A rna"
  ],
  "WNT8B": [
    "WNT8B cnv",
    "WNT8B rna"
  ],
  "WNT9A": [
    "WNT9A cnv",
    "WNT9A methyl",
    "WNT9A rna"
  ],
  "WNT9B": [
    "WNT9B cnv",
    "WNT9B methyl",
    "WNT9B rna"
  ],
  "WRAP53": [
    "WRAP53 38_64_1_1_S54 phospho",
    "WRAP53 3_30_1_1_S26 phospho",
    "WRAP53 489_505_1_1_S491 phospho",
    "WRAP53 54_64_1_1_S54 phospho",
    "WRAP53 cnv",
    "WRAP53 methyl",
    "WRAP53 proteo",
    "WRAP53 rna"
  ],
  "WRAP73": [
    "WRAP73 cnv",
    "WRAP73 methyl",
    "WRAP73 rna"
  ],
  "WRN": [
    "WRN cnv",
    "WRN methyl",
    "WRN rna"
  ],
  "WRNIP1": [
    "WRNIP1 110_118_1_1_T116 phospho",
    "WRNIP1 65_65_1_1_S65 phospho",
    "WRNIP1 75_78_1_1_S75 phospho",
    "WRNIP1 85_107_2_2_S91S92 phospho",
    "WRNIP1 cnv",
    "WRNIP1 methyl",
    "WRNIP1 proteo",
    "WRNIP1 rna"
  ],
  "WSB1": [
    "WSB1 cnv",
    "WSB1 methyl",
    "WSB1 rna"
  ],
  "WSB2": [
    "WSB2 cnv",
    "WSB2 methyl",
    "WSB2 rna"
  ],
  "WSCD1": [
    "WSCD1 cnv",
    "WSCD1 methyl",
    "WSCD1 rna"
  ],
  "WSCD2": [
    "WSCD2 cnv",
    "WSCD2 methyl",
    "WSCD2 rna"
  ],
  "WT1": [
    "WT1 cnv",
    "WT1 methyl",
    "WT1 rna"
  ],
  "WTAP": [
    "WTAP 298_306_1_0 phospho",
    "WTAP 298_306_1_1_S306 phospho",
    "WTAP cnv",
    "WTAP methyl",
    "WTAP proteo",
    "WTAP rna"
  ],
  "WTIP": [
    "WTIP cnv",
    "WTIP methyl",
    "WTIP rna"
  ],
  "WWC1": [
    "WWC1 945_953_1_1_S947 phospho",
    "WWC1 cnv",
    "WWC1 methyl",
    "WWC1 proteo",
    "WWC1 rna"
  ],
  "WWC2": [
    "WWC2 1020_1026_1_1_S1022 phospho",
    "WWC2 cnv",
    "WWC2 methyl",
    "WWC2 rna"
  ],
  "WWC2-AS2": [
    "WWC2-AS2 methyl"
  ],
  "WWC3": [
    "WWC3 442_454_1_1_S442 phospho",
    "WWC3 methyl",
    "WWC3 proteo",
    "WWC3 rna"
  ],
  "WWOX": [
    "WWOX 6_14_1_1_S14 phospho",
    "WWOX cnv",
    "WWOX methyl",
    "WWOX proteo",
    "WWOX rna"
  ],
  "WWP1": [
    "WWP1 23_26_1_1_S26 phospho",
    "WWP1 cnv",
    "WWP1 methyl",
    "WWP1 proteo",
    "WWP1 rna"
  ],
  "WWP2": [
    "WWP2 cnv",
    "WWP2 methyl",
    "WWP2 proteo",
    "WWP2 rna"
  ],
  "WWTR1": [
    "WWTR1 290_307_1_1_S296 phospho",
    "WWTR1 cnv",
    "WWTR1 methyl",
    "WWTR1 proteo",
    "WWTR1 rna"
  ],
  "WWTR1-AS1": [
    "WWTR1-AS1 methyl"
  ],
  "XAB2": [
    "XAB2 cnv",
    "XAB2 methyl",
    "XAB2 proteo",
    "XAB2 rna"
  ],
  "XAF1": [
    "XAF1 139_139_1_1_S139 phospho",
    "XAF1 cnv",
    "XAF1 rna"
  ],
  "XAGE1B": [
    "XAGE1B rna"
  ],
  "XAGE3": [
    "XAGE3 rna"
  ],
  "XAGE5": [
    "XAGE5 rna"
  ],
  "XBP1": [
    "XBP1 cnv",
    "XBP1 methyl",
    "XBP1 rna"
  ],
  "XCL1": [
    "XCL1 cnv",
    "XCL1 rna"
  ],
  "XCL2": [
    "XCL2 cnv",
    "XCL2 rna"
  ],
  "XCR1": [
    "XCR1 cnv",
    "XCR1 rna"
  ],
  "XDH": [
    "XDH cnv",
    "XDH rna"
  ],
  "XG": [
    "XG rna"
  ],
  "XIAP": [
    "XIAP methyl",
    "XIAP proteo",
    "XIAP rna"
  ],
  "XIRP1": [
    "XIRP1 295_307_1_1_S295 phospho",
    "XIRP1 cnv",
    "XIRP1 rna"
  ],
  "XIRP2": [
    "XIRP2 cnv",
    "XIRP2 rna"
  ],
  "XK": [
    "XK methyl",
    "XK rna"
  ],
  "XKR3": [
    "XKR3 cnv",
    "XKR3 rna"
  ],
  "XKR4": [
    "XKR4 cnv",
    "XKR4 methyl",
    "XKR4 proteo",
    "XKR4 rna"
  ],
  "XKR5": [
    "XKR5 cnv",
    "XKR5 methyl",
    "XKR5 rna"
  ],
  "XKR6": [
    "XKR6 cnv",
    "XKR6 methyl",
    "XKR6 rna"
  ],
  "XKR7": [
    "XKR7 547_558_1_1_T558 phospho",
    "XKR7 5_13_1_1_S13 phospho",
    "XKR7 cnv",
    "XKR7 methyl",
    "XKR7 rna"
  ],
  "XKR8": [
    "XKR8 cnv",
    "XKR8 methyl",
    "XKR8 rna"
  ],
  "XKR9": [
    "XKR9 cnv",
    "XKR9 methyl",
    "XKR9 rna"
  ],
  "XKRX": [
    "XKRX methyl",
    "XKRX rna"
  ],
  "XNDC1N": [
    "XNDC1N cnv",
    "XNDC1N rna"
  ],
  "XPA": [
    "XPA cnv",
    "XPA methyl",
    "XPA proteo",
    "XPA rna"
  ],
  "XPC": [
    "XPC 61_66_1_1_S61 phospho",
    "XPC 867_890_1_1_S882 phospho",
    "XPC 867_890_2_2_S881S882 phospho",
    "XPC cnv",
    "XPC methyl",
    "XPC proteo",
    "XPC rna"
  ],
  "XPNPEP1": [
    "XPNPEP1 cnv",
    "XPNPEP1 methyl",
    "XPNPEP1 proteo",
    "XPNPEP1 rna"
  ],
  "XPNPEP2": [
    "XPNPEP2 rna"
  ],
  "XPNPEP3": [
    "XPNPEP3 cnv",
    "XPNPEP3 methyl",
    "XPNPEP3 proteo",
    "XPNPEP3 rna"
  ],
  "XPO1": [
    "XPO1 384_397_1_0 phospho",
    "XPO1 cnv",
    "XPO1 methyl",
    "XPO1 proteo",
    "XPO1 rna"
  ],
  "XPO4": [
    "XPO4 521_526_1_1_S521 phospho",
    "XPO4 cnv",
    "XPO4 methyl",
    "XPO4 proteo",
    "XPO4 rna"
  ],
  "XPO5": [
    "XPO5 cnv",
    "XPO5 methyl",
    "XPO5 proteo",
    "XPO5 rna"
  ],
  "XPO6": [
    "XPO6 185_213_1_0 phospho",
    "XPO6 cnv",
    "XPO6 methyl",
    "XPO6 proteo",
    "XPO6 rna"
  ],
  "XPO7": [
    "XPO7 cnv",
    "XPO7 methyl",
    "XPO7 proteo",
    "XPO7 rna"
  ],
  "XPOT": [
    "XPOT cnv",
    "XPOT methyl",
    "XPOT proteo",
    "XPOT rna"
  ],
  "XPR1": [
    "XPR1 cnv",
    "XPR1 methyl",
    "XPR1 proteo",
    "XPR1 rna"
  ],
  "XRCC1": [
    "XRCC1 234_241_1_1_S241 phospho",
    "XRCC1 257_268_1_1_S266 phospho",
    "XRCC1 437_457_1_1_S447 phospho",
    "XRCC1 437_457_1_1_T453 phospho",
    "XRCC1 437_457_2_2_S447T453 phospho",
    "XRCC1 cnv",
    "XRCC1 methyl",
    "XRCC1 proteo",
    "XRCC1 rna"
  ],
  "XRCC2": [
    "XRCC2 cnv",
    "XRCC2 methyl",
    "XRCC2 rna"
  ],
  "XRCC3": [
    "XRCC3 cnv",
    "XRCC3 methyl",
    "XRCC3 rna"
  ],
  "XRCC4": [
    "XRCC4 327_328_1_1_S328 phospho",
    "XRCC4 cnv",
    "XRCC4 methyl",
    "XRCC4 proteo",
    "XRCC4 rna"
  ],
  "XRCC5": [
    "XRCC5 cnv",
    "XRCC5 methyl",
    "XRCC5 proteo",
    "XRCC5 rna"
  ],
  "XRCC6": [
    "XRCC6 475_477_1_0 phospho",
    "XRCC6 520_520_1_1_S520 phospho",
    "XRCC6 cnv",
    "XRCC6 methyl",
    "XRCC6 proteo",
    "XRCC6 rna"
  ],
  "XRN1": [
    "XRN1 cnv",
    "XRN1 methyl",
    "XRN1 proteo",
    "XRN1 rna"
  ],
  "XRN2": [
    "XRN2 526_533_1_1_S526 phospho",
    "XRN2 548_565_1_0 phospho",
    "XRN2 548_565_1_1_S549 phospho",
    "XRN2 548_565_1_1_S565 phospho",
    "XRN2 577_579_1_0 phospho",
    "XRN2 577_579_1_1_S577 phospho",
    "XRN2 577_579_2_2_S577S579 phospho",
    "XRN2 cnv",
    "XRN2 methyl",
    "XRN2 proteo",
    "XRN2 rna"
  ],
  "XRRA1": [
    "XRRA1 cnv",
    "XRRA1 methyl",
    "XRRA1 rna"
  ],
  "XXYLT1": [
    "XXYLT1 cnv",
    "XXYLT1 methyl",
    "XXYLT1 proteo",
    "XXYLT1 rna"
  ],
  "XYLB": [
    "XYLB cnv",
    "XYLB methyl",
    "XYLB proteo",
    "XYLB rna"
  ],
  "XYLT1": [
    "XYLT1 cnv",
    "XYLT1 proteo",
    "XYLT1 rna"
  ],
  "XYLT2": [
    "XYLT2 cnv",
    "XYLT2 methyl",
    "XYLT2 rna"
  ],
  "YAE1": [
    "YAE1 cnv",
    "YAE1 methyl",
    "YAE1 proteo",
    "YAE1 rna"
  ],
  "YAF2": [
    "YAF2 131_137_1_1_S132 phospho",
    "YAF2 cnv",
    "YAF2 methyl",
    "YAF2 proteo",
    "YAF2 rna"
  ],
  "YAP1": [
    "YAP1 103_119_2_2_S105S109 phospho",
    "YAP1 109_119_1_0 phospho",
    "YAP1 109_119_1_1_T119 phospho",
    "YAP1 109_119_2_2_T110T119 phospho",
    "YAP1 163_164_1_1_S164 phospho",
    "YAP1 338_355_1_1_S344 phospho",
    "YAP1 61_63_1_1_S61 phospho",
    "YAP1 cnv",
    "YAP1 methyl",
    "YAP1 proteo",
    "YAP1 rna"
  ],
  "YARS1": [
    "YARS1 cnv",
    "YARS1 methyl",
    "YARS1 proteo",
    "YARS1 rna"
  ],
  "YARS2": [
    "YARS2 cnv",
    "YARS2 methyl",
    "YARS2 proteo",
    "YARS2 rna"
  ],
  "YBEY": [
    "YBEY cnv",
    "YBEY methyl",
    "YBEY proteo",
    "YBEY rna"
  ],
  "YBX1": [
    "YBX1 158_167_1_1_S165 phospho",
    "YBX1 158_176_1_0 phospho",
    "YBX1 174_176_1_1_S174 phospho",
    "YBX1 174_176_1_1_S176 phospho",
    "YBX1 174_176_2_2_S174S176 phospho",
    "YBX1 313_314_1_1_S314 phospho",
    "YBX1 cnv",
    "YBX1 methyl",
    "YBX1 proteo",
    "YBX1 rna"
  ],
  "YBX2": [
    "YBX2 cnv",
    "YBX2 methyl",
    "YBX2 proteo",
    "YBX2 rna"
  ],
  "YBX3": [
    "YBX3 192_212_1_1_S203 phospho",
    "YBX3 317_324_1_1_S324 phospho",
    "YBX3 359_370_1_0 phospho",
    "YBX3 cnv",
    "YBX3 methyl",
    "YBX3 proteo",
    "YBX3 rna"
  ],
  "YDJC": [
    "YDJC cnv",
    "YDJC methyl",
    "YDJC rna"
  ],
  "YEATS2": [
    "YEATS2 441_448_1_1_S448 phospho",
    "YEATS2 464_474_1_1_S466 phospho",
    "YEATS2 514_522_1_1_S520 phospho",
    "YEATS2 526_537_1_1_S537 phospho",
    "YEATS2 628_628_1_1_S628 phospho",
    "YEATS2 cnv",
    "YEATS2 methyl",
    "YEATS2 proteo",
    "YEATS2 rna"
  ],
  "YEATS4": [
    "YEATS4 cnv",
    "YEATS4 methyl",
    "YEATS4 proteo",
    "YEATS4 rna"
  ],
  "YES1": [
    "YES1 16_46_1_0 phospho",
    "YES1 cnv",
    "YES1 kinase",
    "YES1 methyl",
    "YES1 proteo",
    "YES1 rna"
  ],
  "YIF1A": [
    "YIF1A cnv",
    "YIF1A methyl",
    "YIF1A proteo",
    "YIF1A rna"
  ],
  "YIF1B": [
    "YIF1B cnv",
    "YIF1B methyl",
    "YIF1B proteo",
    "YIF1B rna"
  ],
  "YIPF1": [
    "YIPF1 cnv",
    "YIPF1 methyl",
    "YIPF1 rna"
  ],
  "YIPF2": [
    "YIPF2 cnv",
    "YIPF2 methyl",
    "YIPF2 rna"
  ],
  "YIPF3": [
    "YIPF3 cnv",
    "YIPF3 methyl",
    "YIPF3 proteo",
    "YIPF3 rna"
  ],
  "YIPF4": [
    "YIPF4 cnv",
    "YIPF4 methyl",
    "YIPF4 proteo",
    "YIPF4 rna"
  ],
  "YIPF5": [
    "YIPF5 cnv",
    "YIPF5 methyl",
    "YIPF5 proteo",
    "YIPF5 rna"
  ],
  "YIPF6": [
    "YIPF6 methyl",
    "YIPF6 rna"
  ],
  "YIPF7": [
    "YIPF7 cnv",
    "YIPF7 methyl",
    "YIPF7 rna"
  ],
  "YJEFN3": [
    "YJEFN3 cnv",
    "YJEFN3 methyl",
    "YJEFN3 rna"
  ],
  "YJU2": [
    "YJU2 cnv",
    "YJU2 methyl",
    "YJU2 proteo",
    "YJU2 rna"
  ],
  "YJU2B": [
    "YJU2B 332_343_1_1_S332 phospho",
    "YJU2B 362_376_1_1_S362 phospho",
    "YJU2B cnv",
    "YJU2B methyl",
    "YJU2B proteo",
    "YJU2B rna"
  ],
  "YKT6": [
    "YKT6 cnv",
    "YKT6 methyl",
    "YKT6 proteo",
    "YKT6 rna"
  ],
  "YLPM1": [
    "YLPM1 818_829_1_1_S829 phospho",
    "YLPM1 cnv",
    "YLPM1 methyl",
    "YLPM1 proteo",
    "YLPM1 rna"
  ],
  "YME1L1": [
    "YME1L1 cnv",
    "YME1L1 methyl",
    "YME1L1 proteo",
    "YME1L1 rna"
  ],
  "YOD1": [
    "YOD1 cnv",
    "YOD1 methyl",
    "YOD1 proteo",
    "YOD1 rna"
  ],
  "YPEL1": [
    "YPEL1 cnv",
    "YPEL1 methyl",
    "YPEL1 rna"
  ],
  "YPEL2": [
    "YPEL2 cnv",
    "YPEL2 methyl",
    "YPEL2 rna"
  ],
  "YPEL3": [
    "YPEL3 cnv",
    "YPEL3 methyl",
    "YPEL3 rna"
  ],
  "YPEL4": [
    "YPEL4 cnv",
    "YPEL4 methyl",
    "YPEL4 proteo",
    "YPEL4 rna"
  ],
  "YPEL5": [
    "YPEL5 cnv",
    "YPEL5 methyl",
    "YPEL5 proteo",
    "YPEL5 rna"
  ],
  "YRDC": [
    "YRDC 37_37_1_1_S37 phospho",
    "YRDC cnv",
    "YRDC methyl",
    "YRDC proteo",
    "YRDC rna"
  ],
  "YTHDC1": [
    "YTHDC1 146_152_2_2_S146T148 phospho",
    "YTHDC1 308_308_1_1_S308 phospho",
    "YTHDC1 416_435_1_1_S424 phospho",
    "YTHDC1 cnv",
    "YTHDC1 methyl",
    "YTHDC1 proteo",
    "YTHDC1 rna"
  ],
  "YTHDC2": [
    "YTHDC2 1039_1051_1_1_S1040 phospho",
    "YTHDC2 cnv",
    "YTHDC2 methyl",
    "YTHDC2 proteo",
    "YTHDC2 rna"
  ],
  "YTHDF1": [
    "YTHDF1 cnv",
    "YTHDF1 methyl",
    "YTHDF1 proteo",
    "YTHDF1 rna"
  ],
  "YTHDF2": [
    "YTHDF2 394_398_1_1_S394 phospho",
    "YTHDF2 cnv",
    "YTHDF2 methyl",
    "YTHDF2 proteo",
    "YTHDF2 rna"
  ],
  "YTHDF3": [
    "YTHDF3 372_388_1_1_S385 phospho",
    "YTHDF3 cnv",
    "YTHDF3 methyl",
    "YTHDF3 proteo",
    "YTHDF3 rna"
  ],
  "YTHDF3-DT": [
    "YTHDF3-DT methyl"
  ],
  "YWHAB": [
    "YWHAB cnv",
    "YWHAB methyl",
    "YWHAB proteo",
    "YWHAB rna"
  ],
  "YWHAE": [
    "YWHAE 208_214_1_1_S210 phospho",
    "YWHAE 229_233_1_1_S233 phospho",
    "YWHAE cnv",
    "YWHAE methyl",
    "YWHAE proteo",
    "YWHAE rna"
  ],
  "YWHAG": [
    "YWHAG 133_139_1_1_Y133 phospho",
    "YWHAG cnv",
    "YWHAG methyl",
    "YWHAG proteo",
    "YWHAG rna"
  ],
  "YWHAH": [
    "YWHAH 145_154_1_1_S145 phospho",
    "YWHAH cnv",
    "YWHAH methyl",
    "YWHAH proteo",
    "YWHAH rna"
  ],
  "YWHAQ": [
    "YWHAQ 226_232_1_1_S232 phospho",
    "YWHAQ cnv",
    "YWHAQ methyl",
    "YWHAQ proteo",
    "YWHAQ rna"
  ],
  "YWHAZ": [
    "YWHAZ 110_114_1_1_S110 phospho",
    "YWHAZ cnv",
    "YWHAZ methyl",
    "YWHAZ proteo",
    "YWHAZ rna"
  ],
  "YY1": [
    "YY1 cnv",
    "YY1 methyl",
    "YY1 proteo",
    "YY1 rna"
  ],
  "YY1AP1": [
    "YY1AP1 667_667_1_1_S667 phospho",
    "YY1AP1 cnv",
    "YY1AP1 methyl",
    "YY1AP1 rna"
  ],
  "YY2": [
    "YY2 methyl",
    "YY2 rna"
  ],
  "ZACN": [
    "ZACN cnv",
    "ZACN rna"
  ],
  "ZAN": [
    "ZAN cnv",
    "ZAN rna"
  ],
  "ZAP70": [
    "ZAP70 cnv",
    "ZAP70 kinase",
    "ZAP70 methyl",
    "ZAP70 rna"
  ],
  "ZAR1": [
    "ZAR1 cnv",
    "ZAR1 methyl",
    "ZAR1 rna"
  ],
  "ZAR1L": [
    "ZAR1L cnv",
    "ZAR1L methyl",
    "ZAR1L rna"
  ],
  "ZBBX": [
    "ZBBX cnv",
    "ZBBX methyl",
    "ZBBX rna"
  ],
  "ZBED1": [
    "ZBED1 proteo",
    "ZBED1 rna"
  ],
  "ZBED10P": [
    "ZBED10P cnv",
    "ZBED10P rna"
  ],
  "ZBED2": [
    "ZBED2 cnv",
    "ZBED2 rna"
  ],
  "ZBED3": [
    "ZBED3 cnv",
    "ZBED3 methyl",
    "ZBED3 rna"
  ],
  "ZBED4": [
    "ZBED4 614_627_1_1_S624 phospho",
    "ZBED4 cnv",
    "ZBED4 methyl",
    "ZBED4 rna"
  ],
  "ZBED5": [
    "ZBED5 cnv",
    "ZBED5 methyl",
    "ZBED5 rna"
  ],
  "ZBED5-AS1": [
    "ZBED5-AS1 methyl"
  ],
  "ZBED6": [
    "ZBED6 cnv",
    "ZBED6 methyl",
    "ZBED6 rna"
  ],
  "ZBED8": [
    "ZBED8 cnv",
    "ZBED8 methyl",
    "ZBED8 rna"
  ],
  "ZBED9": [
    "ZBED9 cnv",
    "ZBED9 methyl",
    "ZBED9 rna"
  ],
  "ZBP1": [
    "ZBP1 cnv",
    "ZBP1 rna"
  ],
  "ZBTB1": [
    "ZBTB1 cnv",
    "ZBTB1 methyl",
    "ZBTB1 proteo",
    "ZBTB1 rna"
  ],
  "ZBTB10": [
    "ZBTB10 cnv",
    "ZBTB10 methyl",
    "ZBTB10 rna"
  ],
  "ZBTB11": [
    "ZBTB11 cnv",
    "ZBTB11 methyl",
    "ZBTB11 rna"
  ],
  "ZBTB11-AS1": [
    "ZBTB11-AS1 methyl"
  ],
  "ZBTB12": [
    "ZBTB12 cnv",
    "ZBTB12 methyl",
    "ZBTB12 rna"
  ],
  "ZBTB14": [
    "ZBTB14 131_140_1_1_S132 phospho",
    "ZBTB14 cnv",
    "ZBTB14 methyl",
    "ZBTB14 proteo",
    "ZBTB14 rna"
  ],
  "ZBTB16": [
    "ZBTB16 cnv",
    "ZBTB16 methyl",
    "ZBTB16 rna"
  ],
  "ZBTB17": [
    "ZBTB17 113_130_1_1_S120 phospho",
    "ZBTB17 cnv",
    "ZBTB17 methyl",
    "ZBTB17 rna"
  ],
  "ZBTB18": [
    "ZBTB18 333_342_1_0 phospho",
    "ZBTB18 333_342_1_1_S333 phospho",
    "ZBTB18 cnv",
    "ZBTB18 methyl",
    "ZBTB18 rna"
  ],
  "ZBTB2": [
    "ZBTB2 cnv",
    "ZBTB2 proteo",
    "ZBTB2 rna"
  ],
  "ZBTB20": [
    "ZBTB20 194_211_1_1_T211 phospho",
    "ZBTB20 301_309_1_1_T305 phospho",
    "ZBTB20 353_368_1_1_S353 phospho",
    "ZBTB20 685_695_1_1_T695 phospho",
    "ZBTB20 cnv",
    "ZBTB20 methyl",
    "ZBTB20 proteo",
    "ZBTB20 rna"
  ],
  "ZBTB20-AS1": [
    "ZBTB20-AS1 methyl"
  ],
  "ZBTB21": [
    "ZBTB21 219_225_1_1_S225 phospho",
    "ZBTB21 343_356_1_1_S345 phospho",
    "ZBTB21 431_441_1_1_S435 phospho",
    "ZBTB21 431_441_2_2_T431S435 phospho",
    "ZBTB21 cnv",
    "ZBTB21 methyl",
    "ZBTB21 proteo",
    "ZBTB21 rna"
  ],
  "ZBTB22": [
    "ZBTB22 592_611_1_1_S599 phospho",
    "ZBTB22 592_611_2_2_S592S599 phospho",
    "ZBTB22 cnv",
    "ZBTB22 methyl",
    "ZBTB22 rna"
  ],
  "ZBTB24": [
    "ZBTB24 cnv",
    "ZBTB24 methyl",
    "ZBTB24 rna"
  ],
  "ZBTB25": [
    "ZBTB25 cnv",
    "ZBTB25 methyl",
    "ZBTB25 rna"
  ],
  "ZBTB26": [
    "ZBTB26 cnv",
    "ZBTB26 methyl",
    "ZBTB26 rna"
  ],
  "ZBTB3": [
    "ZBTB3 481_501_1_1_S499 phospho",
    "ZBTB3 cnv",
    "ZBTB3 methyl",
    "ZBTB3 proteo",
    "ZBTB3 rna"
  ],
  "ZBTB32": [
    "ZBTB32 cnv",
    "ZBTB32 methyl",
    "ZBTB32 rna"
  ],
  "ZBTB33": [
    "ZBTB33 207_246_1_0 phospho",
    "ZBTB33 methyl",
    "ZBTB33 proteo",
    "ZBTB33 rna"
  ],
  "ZBTB34": [
    "ZBTB34 cnv",
    "ZBTB34 methyl",
    "ZBTB34 rna"
  ],
  "ZBTB37": [
    "ZBTB37 cnv",
    "ZBTB37 methyl",
    "ZBTB37 rna"
  ],
  "ZBTB38": [
    "ZBTB38 cnv",
    "ZBTB38 methyl",
    "ZBTB38 rna"
  ],
  "ZBTB39": [
    "ZBTB39 cnv",
    "ZBTB39 methyl",
    "ZBTB39 rna"
  ],
  "ZBTB4": [
    "ZBTB4 cnv",
    "ZBTB4 methyl",
    "ZBTB4 proteo",
    "ZBTB4 rna"
  ],
  "ZBTB40": [
    "ZBTB40 202_223_1_1_S214 phospho",
    "ZBTB40 cnv",
    "ZBTB40 methyl",
    "ZBTB40 proteo",
    "ZBTB40 rna"
  ],
  "ZBTB41": [
    "ZBTB41 cnv",
    "ZBTB41 methyl",
    "ZBTB41 rna"
  ],
  "ZBTB42": [
    "ZBTB42 cnv",
    "ZBTB42 methyl",
    "ZBTB42 rna"
  ],
  "ZBTB43": [
    "ZBTB43 cnv",
    "ZBTB43 methyl",
    "ZBTB43 proteo",
    "ZBTB43 rna"
  ],
  "ZBTB44": [
    "ZBTB44 cnv",
    "ZBTB44 methyl",
    "ZBTB44 rna"
  ],
  "ZBTB45": [
    "ZBTB45 cnv",
    "ZBTB45 methyl",
    "ZBTB45 rna"
  ],
  "ZBTB46": [
    "ZBTB46 234_245_1_1_S234 phospho",
    "ZBTB46 cnv",
    "ZBTB46 methyl",
    "ZBTB46 rna"
  ],
  "ZBTB47": [
    "ZBTB47 390_390_1_1_T390 phospho",
    "ZBTB47 cnv",
    "ZBTB47 methyl",
    "ZBTB47 proteo",
    "ZBTB47 rna"
  ],
  "ZBTB48": [
    "ZBTB48 cnv",
    "ZBTB48 methyl",
    "ZBTB48 rna"
  ],
  "ZBTB49": [
    "ZBTB49 cnv",
    "ZBTB49 methyl",
    "ZBTB49 rna"
  ],
  "ZBTB5": [
    "ZBTB5 cnv",
    "ZBTB5 methyl",
    "ZBTB5 rna"
  ],
  "ZBTB6": [
    "ZBTB6 cnv",
    "ZBTB6 rna"
  ],
  "ZBTB7A": [
    "ZBTB7A 337_341_1_1_S337 phospho",
    "ZBTB7A 511_526_1_0 phospho",
    "ZBTB7A cnv",
    "ZBTB7A methyl",
    "ZBTB7A rna"
  ],
  "ZBTB7B": [
    "ZBTB7B cnv",
    "ZBTB7B methyl",
    "ZBTB7B rna"
  ],
  "ZBTB7C": [
    "ZBTB7C cnv",
    "ZBTB7C methyl",
    "ZBTB7C rna"
  ],
  "ZBTB8A": [
    "ZBTB8A cnv",
    "ZBTB8A methyl",
    "ZBTB8A rna"
  ],
  "ZBTB8B": [
    "ZBTB8B cnv",
    "ZBTB8B methyl",
    "ZBTB8B rna"
  ],
  "ZBTB8OS": [
    "ZBTB8OS cnv",
    "ZBTB8OS methyl",
    "ZBTB8OS proteo",
    "ZBTB8OS rna"
  ],
  "ZBTB9": [
    "ZBTB9 cnv",
    "ZBTB9 methyl",
    "ZBTB9 proteo",
    "ZBTB9 rna"
  ],
  "ZC2HC1A": [
    "ZC2HC1A 221_225_1_1_S223 phospho",
    "ZC2HC1A 292_292_1_1_S292 phospho",
    "ZC2HC1A cnv",
    "ZC2HC1A methyl",
    "ZC2HC1A proteo",
    "ZC2HC1A rna"
  ],
  "ZC2HC1B": [
    "ZC2HC1B cnv",
    "ZC2HC1B rna"
  ],
  "ZC2HC1C": [
    "ZC2HC1C cnv",
    "ZC2HC1C methyl",
    "ZC2HC1C rna"
  ],
  "ZC3H10": [
    "ZC3H10 cnv",
    "ZC3H10 methyl",
    "ZC3H10 rna"
  ],
  "ZC3H11A": [
    "ZC3H11A 100_108_1_1_S108 phospho",
    "ZC3H11A 290_295_1_1_S290 phospho",
    "ZC3H11A cnv",
    "ZC3H11A methyl",
    "ZC3H11A proteo",
    "ZC3H11A rna"
  ],
  "ZC3H11B": [
    "ZC3H11B cnv",
    "ZC3H11B methyl",
    "ZC3H11B rna"
  ],
  "ZC3H12A": [
    "ZC3H12A cnv",
    "ZC3H12A methyl",
    "ZC3H12A rna"
  ],
  "ZC3H12A-DT": [
    "ZC3H12A-DT methyl"
  ],
  "ZC3H12B": [
    "ZC3H12B methyl",
    "ZC3H12B rna"
  ],
  "ZC3H12C": [
    "ZC3H12C 123_123_1_1_S123 phospho",
    "ZC3H12C 467_474_1_1_S469 phospho",
    "ZC3H12C 612_617_1_1_S612 phospho",
    "ZC3H12C 689_691_1_1_S689 phospho",
    "ZC3H12C 719_734_1_1_S720 phospho",
    "ZC3H12C 719_734_1_1_S727 phospho",
    "ZC3H12C cnv",
    "ZC3H12C methyl",
    "ZC3H12C proteo",
    "ZC3H12C rna"
  ],
  "ZC3H12D": [
    "ZC3H12D cnv",
    "ZC3H12D methyl",
    "ZC3H12D rna"
  ],
  "ZC3H13": [
    "ZC3H13 1010_1025_1_1_S1017 phospho",
    "ZC3H13 1010_1025_2_2_S1014S1017 phospho",
    "ZC3H13 1010_1025_3_3_S1010S1014S1017 phospho",
    "ZC3H13 1033_1038_1_1_T1033 phospho",
    "ZC3H13 1278_1282_1_1_S1279 phospho",
    "ZC3H13 198_198_1_1_S198 phospho",
    "ZC3H13 237_242_1_1_S242 phospho",
    "ZC3H13 263_265_2_2_T263S265 phospho",
    "ZC3H13 316_329_2_2_S318S325 phospho",
    "ZC3H13 316_329_3_3_S316S318S325 phospho",
    "ZC3H13 362_364_1_1_T362 phospho",
    "ZC3H13 370_381_1_1_S381 phospho",
    "ZC3H13 642_643_1_1_S643 phospho",
    "ZC3H13 64_64_1_1_S64 phospho",
    "ZC3H13 77_82_1_1_S77 phospho",
    "ZC3H13 831_837_3_3_S831S833S837 phospho",
    "ZC3H13 845_853_1_1_S845 phospho",
    "ZC3H13 984_993_1_1_S986 phospho",
    "ZC3H13 984_993_1_1_S993 phospho",
    "ZC3H13 cnv",
    "ZC3H13 methyl",
    "ZC3H13 proteo",
    "ZC3H13 rna"
  ],
  "ZC3H14": [
    "ZC3H14 206_206_1_1_S206 phospho",
    "ZC3H14 481_481_1_1_S481 phospho",
    "ZC3H14 581_586_1_1_S586 phospho",
    "ZC3H14 cnv",
    "ZC3H14 methyl",
    "ZC3H14 proteo",
    "ZC3H14 rna"
  ],
  "ZC3H15": [
    "ZC3H15 381_381_1_1_S381 phospho",
    "ZC3H15 cnv",
    "ZC3H15 methyl",
    "ZC3H15 proteo",
    "ZC3H15 rna"
  ],
  "ZC3H18": [
    "ZC3H18 162_162_1_1_T162 phospho",
    "ZC3H18 32_53_1_1_S46 phospho",
    "ZC3H18 46_53_1_1_S46 phospho",
    "ZC3H18 511_516_1_1_S511 phospho",
    "ZC3H18 59_74_1_1_S67 phospho",
    "ZC3H18 59_74_2_2_S67S74 phospho",
    "ZC3H18 814_833_1_1_T820 phospho",
    "ZC3H18 866_866_1_1_S866 phospho",
    "ZC3H18 892_892_1_1_S892 phospho",
    "ZC3H18 93_110_1_1_S95 phospho",
    "ZC3H18 cnv",
    "ZC3H18 methyl",
    "ZC3H18 proteo",
    "ZC3H18 rna"
  ],
  "ZC3H3": [
    "ZC3H3 cnv",
    "ZC3H3 methyl",
    "ZC3H3 rna"
  ],
  "ZC3H4": [
    "ZC3H4 1104_1121_2_0 phospho",
    "ZC3H4 1265_1275_2_2_S1269S1275 phospho",
    "ZC3H4 1265_1286_1_1_S1275 phospho",
    "ZC3H4 1265_1286_2_0 phospho",
    "ZC3H4 155_175_1_1_S159 phospho",
    "ZC3H4 898_915_1_1_S908 phospho",
    "ZC3H4 cnv",
    "ZC3H4 methyl",
    "ZC3H4 proteo",
    "ZC3H4 rna"
  ],
  "ZC3H6": [
    "ZC3H6 1158_1169_1_1_S1158 phospho",
    "ZC3H6 180_190_1_1_S188 phospho",
    "ZC3H6 cnv",
    "ZC3H6 methyl",
    "ZC3H6 proteo",
    "ZC3H6 rna"
  ],
  "ZC3H7A": [
    "ZC3H7A 200_210_1_1_T210 phospho",
    "ZC3H7A cnv",
    "ZC3H7A methyl",
    "ZC3H7A proteo",
    "ZC3H7A rna"
  ],
  "ZC3H7B": [
    "ZC3H7B 217_243_1_1_T224 phospho",
    "ZC3H7B 217_243_2_1_S217 phospho",
    "ZC3H7B cnv",
    "ZC3H7B methyl",
    "ZC3H7B proteo",
    "ZC3H7B rna"
  ],
  "ZC3H8": [
    "ZC3H8 cnv",
    "ZC3H8 methyl",
    "ZC3H8 proteo",
    "ZC3H8 rna"
  ],
  "ZC3HAV1": [
    "ZC3HAV1 257_267_1_1_S257 phospho",
    "ZC3HAV1 271_280_1_1_T273 phospho",
    "ZC3HAV1 271_280_2_2_T273S275 phospho",
    "ZC3HAV1 271_294_1_1_S284 phospho",
    "ZC3HAV1 271_294_2_2_S275S284 phospho",
    "ZC3HAV1 316_327_1_1_S327 phospho",
    "ZC3HAV1 386_399_1_1_S387 phospho",
    "ZC3HAV1 631_644_1_1_S631 phospho",
    "ZC3HAV1 cnv",
    "ZC3HAV1 methyl",
    "ZC3HAV1 proteo",
    "ZC3HAV1 rna"
  ],
  "ZC3HAV1L": [
    "ZC3HAV1L 253_263_1_0 phospho",
    "ZC3HAV1L cnv",
    "ZC3HAV1L methyl",
    "ZC3HAV1L proteo",
    "ZC3HAV1L rna"
  ],
  "ZC3HC1": [
    "ZC3HC1 286_295_1_1_S292 phospho",
    "ZC3HC1 309_330_1_1_S311 phospho",
    "ZC3HC1 311_330_1_1_S327 phospho",
    "ZC3HC1 338_352_1_0 phospho",
    "ZC3HC1 338_352_1_1_S352 phospho",
    "ZC3HC1 cnv",
    "ZC3HC1 methyl",
    "ZC3HC1 proteo",
    "ZC3HC1 rna"
  ],
  "ZC4H2": [
    "ZC4H2 methyl",
    "ZC4H2 rna"
  ],
  "ZCCHC10": [
    "ZCCHC10 cnv",
    "ZCCHC10 methyl",
    "ZCCHC10 proteo",
    "ZCCHC10 rna"
  ],
  "ZCCHC12": [
    "ZCCHC12 methyl",
    "ZCCHC12 rna"
  ],
  "ZCCHC13": [
    "ZCCHC13 methyl"
  ],
  "ZCCHC14": [
    "ZCCHC14 cnv",
    "ZCCHC14 methyl",
    "ZCCHC14 proteo",
    "ZCCHC14 rna"
  ],
  "ZCCHC14-DT": [
    "ZCCHC14-DT methyl"
  ],
  "ZCCHC17": [
    "ZCCHC17 cnv",
    "ZCCHC17 methyl",
    "ZCCHC17 proteo",
    "ZCCHC17 rna"
  ],
  "ZCCHC18": [
    "ZCCHC18 methyl",
    "ZCCHC18 rna"
  ],
  "ZCCHC2": [
    "ZCCHC2 cnv",
    "ZCCHC2 methyl",
    "ZCCHC2 rna"
  ],
  "ZCCHC24": [
    "ZCCHC24 65_74_1_1_S65 phospho",
    "ZCCHC24 cnv",
    "ZCCHC24 methyl",
    "ZCCHC24 proteo",
    "ZCCHC24 rna"
  ],
  "ZCCHC3": [
    "ZCCHC3 cnv",
    "ZCCHC3 methyl",
    "ZCCHC3 proteo",
    "ZCCHC3 rna"
  ],
  "ZCCHC4": [
    "ZCCHC4 cnv",
    "ZCCHC4 methyl",
    "ZCCHC4 proteo",
    "ZCCHC4 rna"
  ],
  "ZCCHC7": [
    "ZCCHC7 cnv",
    "ZCCHC7 methyl",
    "ZCCHC7 rna"
  ],
  "ZCCHC8": [
    "ZCCHC8 419_427_1_1_S427 phospho",
    "ZCCHC8 479_485_1_1_T479 phospho",
    "ZCCHC8 591_605_1_1_S598 phospho",
    "ZCCHC8 648_654_1_1_S649 phospho",
    "ZCCHC8 658_664_1_1_S658 phospho",
    "ZCCHC8 cnv",
    "ZCCHC8 methyl",
    "ZCCHC8 proteo",
    "ZCCHC8 rna"
  ],
  "ZCCHC9": [
    "ZCCHC9 cnv",
    "ZCCHC9 methyl",
    "ZCCHC9 proteo",
    "ZCCHC9 rna"
  ],
  "ZCRB1": [
    "ZCRB1 206_216_1_1_S216 phospho",
    "ZCRB1 cnv",
    "ZCRB1 methyl",
    "ZCRB1 proteo",
    "ZCRB1 rna"
  ],
  "ZCWPW1": [
    "ZCWPW1 cnv",
    "ZCWPW1 methyl",
    "ZCWPW1 rna"
  ],
  "ZCWPW2": [
    "ZCWPW2 cnv",
    "ZCWPW2 methyl",
    "ZCWPW2 rna"
  ],
  "ZDBF2": [
    "ZDBF2 cnv",
    "ZDBF2 methyl",
    "ZDBF2 rna"
  ],
  "ZDHHC1": [
    "ZDHHC1 cnv",
    "ZDHHC1 methyl",
    "ZDHHC1 rna"
  ],
  "ZDHHC11": [
    "ZDHHC11 cnv",
    "ZDHHC11 rna"
  ],
  "ZDHHC11B": [
    "ZDHHC11B cnv",
    "ZDHHC11B methyl",
    "ZDHHC11B rna"
  ],
  "ZDHHC12": [
    "ZDHHC12 cnv",
    "ZDHHC12 methyl",
    "ZDHHC12 rna"
  ],
  "ZDHHC12-DT": [
    "ZDHHC12-DT methyl"
  ],
  "ZDHHC13": [
    "ZDHHC13 cnv",
    "ZDHHC13 methyl",
    "ZDHHC13 proteo",
    "ZDHHC13 rna"
  ],
  "ZDHHC14": [
    "ZDHHC14 cnv",
    "ZDHHC14 methyl",
    "ZDHHC14 proteo",
    "ZDHHC14 rna"
  ],
  "ZDHHC15": [
    "ZDHHC15 methyl",
    "ZDHHC15 rna"
  ],
  "ZDHHC16": [
    "ZDHHC16 cnv",
    "ZDHHC16 methyl",
    "ZDHHC16 rna"
  ],
  "ZDHHC17": [
    "ZDHHC17 cnv",
    "ZDHHC17 methyl",
    "ZDHHC17 proteo",
    "ZDHHC17 rna"
  ],
  "ZDHHC18": [
    "ZDHHC18 cnv",
    "ZDHHC18 proteo",
    "ZDHHC18 rna"
  ],
  "ZDHHC19": [
    "ZDHHC19 cnv",
    "ZDHHC19 rna"
  ],
  "ZDHHC2": [
    "ZDHHC2 cnv",
    "ZDHHC2 methyl",
    "ZDHHC2 proteo",
    "ZDHHC2 rna"
  ],
  "ZDHHC20": [
    "ZDHHC20 242_249_1_1_S242 phospho",
    "ZDHHC20 cnv",
    "ZDHHC20 methyl",
    "ZDHHC20 proteo",
    "ZDHHC20 rna"
  ],
  "ZDHHC21": [
    "ZDHHC21 cnv",
    "ZDHHC21 methyl",
    "ZDHHC21 rna"
  ],
  "ZDHHC22": [
    "ZDHHC22 cnv",
    "ZDHHC22 methyl",
    "ZDHHC22 rna"
  ],
  "ZDHHC23": [
    "ZDHHC23 cnv",
    "ZDHHC23 methyl",
    "ZDHHC23 rna"
  ],
  "ZDHHC24": [
    "ZDHHC24 cnv",
    "ZDHHC24 methyl",
    "ZDHHC24 rna"
  ],
  "ZDHHC3": [
    "ZDHHC3 cnv",
    "ZDHHC3 methyl",
    "ZDHHC3 rna"
  ],
  "ZDHHC4": [
    "ZDHHC4 cnv",
    "ZDHHC4 methyl",
    "ZDHHC4 proteo",
    "ZDHHC4 rna"
  ],
  "ZDHHC5": [
    "ZDHHC5 261_279_1_1_S274 phospho",
    "ZDHHC5 345_352_1_1_T348 phospho",
    "ZDHHC5 354_372_1_1_S372 phospho",
    "ZDHHC5 376_391_1_1_S380 phospho",
    "ZDHHC5 380_391_1_1_S380 phospho",
    "ZDHHC5 395_406_1_1_S398 phospho",
    "ZDHHC5 415_425_1_0 phospho",
    "ZDHHC5 554_577_1_1_S554 phospho",
    "ZDHHC5 583_593_1_1_S593 phospho",
    "ZDHHC5 679_696_1_1_S694 phospho",
    "ZDHHC5 cnv",
    "ZDHHC5 methyl",
    "ZDHHC5 proteo",
    "ZDHHC5 rna"
  ],
  "ZDHHC6": [
    "ZDHHC6 cnv",
    "ZDHHC6 methyl",
    "ZDHHC6 rna"
  ],
  "ZDHHC7": [
    "ZDHHC7 cnv",
    "ZDHHC7 methyl",
    "ZDHHC7 rna"
  ],
  "ZDHHC8": [
    "ZDHHC8 675_685_1_1_S675 phospho",
    "ZDHHC8 675_685_2_2_S675S682 phospho",
    "ZDHHC8 cnv",
    "ZDHHC8 methyl",
    "ZDHHC8 rna"
  ],
  "ZDHHC9": [
    "ZDHHC9 methyl",
    "ZDHHC9 rna"
  ],
  "ZEB1": [
    "ZEB1 288_304_1_1_S293 phospho",
    "ZEB1 536_565_1_1_S563 phospho",
    "ZEB1 618_626_1_0 phospho",
    "ZEB1 618_626_1_1_S626 phospho",
    "ZEB1 618_626_2_2_S622S626 phospho",
    "ZEB1 644_659_1_1_S659 phospho",
    "ZEB1 664_678_1_1_S666 phospho",
    "ZEB1 680_693_1_1_T682 phospho",
    "ZEB1 853_870_1_1_S867 phospho",
    "ZEB1 cnv",
    "ZEB1 methyl",
    "ZEB1 proteo",
    "ZEB1 rna"
  ],
  "ZEB1-AS1": [
    "ZEB1-AS1 methyl"
  ],
  "ZEB2": [
    "ZEB2 1088_1100_1_1_S1098 phospho",
    "ZEB2 1088_1105_1_0 phospho",
    "ZEB2 326_343_1_1_S336 phospho",
    "ZEB2 622_628_1_1_S623 phospho",
    "ZEB2 674_683_1_1_S681 phospho",
    "ZEB2 702_728_1_1_S707 phospho",
    "ZEB2 756_769_1_1_T758 phospho",
    "ZEB2 cnv",
    "ZEB2 methyl",
    "ZEB2 proteo",
    "ZEB2 rna"
  ],
  "ZEB2-AS1": [
    "ZEB2-AS1 methyl"
  ],
  "ZER1": [
    "ZER1 cnv",
    "ZER1 methyl",
    "ZER1 proteo",
    "ZER1 rna"
  ],
  "ZFAND1": [
    "ZFAND1 cnv",
    "ZFAND1 methyl",
    "ZFAND1 proteo",
    "ZFAND1 rna"
  ],
  "ZFAND2A": [
    "ZFAND2A cnv",
    "ZFAND2A methyl",
    "ZFAND2A rna"
  ],
  "ZFAND2B": [
    "ZFAND2B cnv",
    "ZFAND2B methyl",
    "ZFAND2B proteo",
    "ZFAND2B rna"
  ],
  "ZFAND3": [
    "ZFAND3 117_129_1_1_S129 phospho",
    "ZFAND3 cnv",
    "ZFAND3 methyl",
    "ZFAND3 proteo",
    "ZFAND3 rna"
  ],
  "ZFAND4": [
    "ZFAND4 cnv",
    "ZFAND4 methyl",
    "ZFAND4 rna"
  ],
  "ZFAND5": [
    "ZFAND5 48_65_1_1_S48 phospho",
    "ZFAND5 cnv",
    "ZFAND5 methyl",
    "ZFAND5 proteo",
    "ZFAND5 rna"
  ],
  "ZFAND6": [
    "ZFAND6 cnv",
    "ZFAND6 methyl",
    "ZFAND6 proteo",
    "ZFAND6 rna"
  ],
  "ZFAS1": [
    "ZFAS1 methyl"
  ],
  "ZFAT": [
    "ZFAT cnv",
    "ZFAT methyl",
    "ZFAT rna"
  ],
  "ZFC3H1": [
    "ZFC3H1 cnv",
    "ZFC3H1 methyl",
    "ZFC3H1 rna"
  ],
  "ZFHX2": [
    "ZFHX2 cnv",
    "ZFHX2 methyl",
    "ZFHX2 rna"
  ],
  "ZFHX3": [
    "ZFHX3 cnv",
    "ZFHX3 methyl",
    "ZFHX3 rna"
  ],
  "ZFHX4": [
    "ZFHX4 cnv",
    "ZFHX4 methyl",
    "ZFHX4 rna"
  ],
  "ZFP1": [
    "ZFP1 cnv",
    "ZFP1 methyl",
    "ZFP1 proteo",
    "ZFP1 rna"
  ],
  "ZFP14": [
    "ZFP14 cnv",
    "ZFP14 methyl",
    "ZFP14 rna"
  ],
  "ZFP2": [
    "ZFP2 cnv",
    "ZFP2 methyl",
    "ZFP2 rna"
  ],
  "ZFP28": [
    "ZFP28 cnv",
    "ZFP28 methyl",
    "ZFP28 rna"
  ],
  "ZFP28-DT": [
    "ZFP28-DT methyl"
  ],
  "ZFP3": [
    "ZFP3 cnv",
    "ZFP3 methyl",
    "ZFP3 proteo",
    "ZFP3 rna"
  ],
  "ZFP30": [
    "ZFP30 cnv",
    "ZFP30 methyl",
    "ZFP30 rna"
  ],
  "ZFP36": [
    "ZFP36 94_108_1_1_S99 phospho",
    "ZFP36 cnv",
    "ZFP36 methyl",
    "ZFP36 proteo",
    "ZFP36 rna"
  ],
  "ZFP36L1": [
    "ZFP36L1 54_60_1_1_S54 phospho",
    "ZFP36L1 69_81_1_1_S70 phospho",
    "ZFP36L1 90_92_1_1_S90 phospho",
    "ZFP36L1 cnv",
    "ZFP36L1 methyl",
    "ZFP36L1 proteo",
    "ZFP36L1 rna"
  ],
  "ZFP36L2": [
    "ZFP36L2 257_285_1_1_S259 phospho",
    "ZFP36L2 57_75_1_0 phospho",
    "ZFP36L2 57_75_1_1_S57 phospho",
    "ZFP36L2 57_75_2_2_S57S75 phospho",
    "ZFP36L2 cnv",
    "ZFP36L2 methyl",
    "ZFP36L2 proteo",
    "ZFP36L2 rna"
  ],
  "ZFP37": [
    "ZFP37 cnv",
    "ZFP37 methyl",
    "ZFP37 rna"
  ],
  "ZFP41": [
    "ZFP41 cnv",
    "ZFP41 methyl",
    "ZFP41 rna"
  ],
  "ZFP42": [
    "ZFP42 cnv",
    "ZFP42 rna"
  ],
  "ZFP57": [
    "ZFP57 cnv",
    "ZFP57 rna"
  ],
  "ZFP62": [
    "ZFP62 cnv",
    "ZFP62 methyl",
    "ZFP62 rna"
  ],
  "ZFP64": [
    "ZFP64 136_137_1_1_T137 phospho",
    "ZFP64 cnv",
    "ZFP64 methyl",
    "ZFP64 proteo",
    "ZFP64 rna"
  ],
  "ZFP69": [
    "ZFP69 cnv",
    "ZFP69 methyl",
    "ZFP69 rna"
  ],
  "ZFP69B": [
    "ZFP69B cnv",
    "ZFP69B methyl",
    "ZFP69B rna"
  ],
  "ZFP82": [
    "ZFP82 cnv",
    "ZFP82 methyl",
    "ZFP82 rna"
  ],
  "ZFP90": [
    "ZFP90 cnv",
    "ZFP90 methyl",
    "ZFP90 proteo",
    "ZFP90 rna"
  ],
  "ZFP91": [
    "ZFP91 82_85_1_1_S82 phospho",
    "ZFP91 82_85_1_1_S83 phospho",
    "ZFP91 cnv",
    "ZFP91 methyl",
    "ZFP91 proteo",
    "ZFP91 rna"
  ],
  "ZFP91-CNTF": [
    "ZFP91-CNTF cnv",
    "ZFP91-CNTF rna"
  ],
  "ZFP92": [
    "ZFP92 methyl",
    "ZFP92 rna"
  ],
  "ZFPL1": [
    "ZFPL1 cnv",
    "ZFPL1 methyl",
    "ZFPL1 proteo",
    "ZFPL1 rna"
  ],
  "ZFPM1": [
    "ZFPM1 894_914_1_1_S901 phospho",
    "ZFPM1 cnv",
    "ZFPM1 methyl",
    "ZFPM1 rna"
  ],
  "ZFPM2": [
    "ZFPM2 900_909_1_1_S904 phospho",
    "ZFPM2 cnv",
    "ZFPM2 methyl",
    "ZFPM2 proteo",
    "ZFPM2 rna"
  ],
  "ZFR": [
    "ZFR 1054_1054_1_1_S1054 phospho",
    "ZFR 544_568_1_1_T550 phospho",
    "ZFR cnv",
    "ZFR methyl",
    "ZFR proteo",
    "ZFR rna"
  ],
  "ZFR2": [
    "ZFR2 cnv",
    "ZFR2 rna"
  ],
  "ZFTA": [
    "ZFTA cnv",
    "ZFTA methyl",
    "ZFTA rna"
  ],
  "ZFTRAF1": [
    "ZFTRAF1 cnv",
    "ZFTRAF1 methyl",
    "ZFTRAF1 proteo",
    "ZFTRAF1 rna"
  ],
  "ZFX": [
    "ZFX methyl",
    "ZFX rna"
  ],
  "ZFX-AS1": [
    "ZFX-AS1 methyl"
  ],
  "ZFY": [
    "ZFY methyl",
    "ZFY rna"
  ],
  "ZFYVE1": [
    "ZFYVE1 cnv",
    "ZFYVE1 methyl",
    "ZFYVE1 proteo",
    "ZFYVE1 rna"
  ],
  "ZFYVE16": [
    "ZFYVE16 896_932_1_1_S896 phospho",
    "ZFYVE16 cnv",
    "ZFYVE16 methyl",
    "ZFYVE16 proteo",
    "ZFYVE16 rna"
  ],
  "ZFYVE19": [
    "ZFYVE19 136_149_1_1_S144 phospho",
    "ZFYVE19 144_149_1_1_S144 phospho",
    "ZFYVE19 277_294_1_1_S286 phospho",
    "ZFYVE19 286_294_1_1_S286 phospho",
    "ZFYVE19 391_395_1_1_S395 phospho",
    "ZFYVE19 cnv",
    "ZFYVE19 methyl",
    "ZFYVE19 proteo",
    "ZFYVE19 rna"
  ],
  "ZFYVE21": [
    "ZFYVE21 17_19_1_1_S17 phospho",
    "ZFYVE21 182_192_1_1_Y182 phospho",
    "ZFYVE21 cnv",
    "ZFYVE21 methyl",
    "ZFYVE21 proteo",
    "ZFYVE21 rna"
  ],
  "ZFYVE26": [
    "ZFYVE26 1255_1275_1_1_S1275 phospho",
    "ZFYVE26 144_146_1_1_S144 phospho",
    "ZFYVE26 1762_1782_1_1_S1764 phospho",
    "ZFYVE26 291_297_1_1_S297 phospho",
    "ZFYVE26 cnv",
    "ZFYVE26 proteo",
    "ZFYVE26 rna"
  ],
  "ZFYVE27": [
    "ZFYVE27 cnv",
    "ZFYVE27 methyl",
    "ZFYVE27 proteo",
    "ZFYVE27 rna"
  ],
  "ZFYVE28": [
    "ZFYVE28 cnv",
    "ZFYVE28 methyl",
    "ZFYVE28 rna"
  ],
  "ZFYVE9": [
    "ZFYVE9 cnv",
    "ZFYVE9 methyl",
    "ZFYVE9 proteo",
    "ZFYVE9 rna"
  ],
  "ZG16": [
    "ZG16 cnv"
  ],
  "ZG16B": [
    "ZG16B cnv",
    "ZG16B rna"
  ],
  "ZGLP1": [
    "ZGLP1 cnv",
    "ZGLP1 methyl",
    "ZGLP1 rna"
  ],
  "ZGPAT": [
    "ZGPAT cnv",
    "ZGPAT methyl",
    "ZGPAT proteo",
    "ZGPAT rna"
  ],
  "ZGRF1": [
    "ZGRF1 cnv",
    "ZGRF1 methyl",
    "ZGRF1 rna"
  ],
  "ZHX1": [
    "ZHX1 202_202_1_1_S202 phospho",
    "ZHX1 647_653_1_0 phospho",
    "ZHX1 cnv",
    "ZHX1 methyl",
    "ZHX1 proteo",
    "ZHX1 rna"
  ],
  "ZHX1-C8orf76": [
    "ZHX1-C8orf76 cnv",
    "ZHX1-C8orf76 methyl",
    "ZHX1-C8orf76 rna"
  ],
  "ZHX2": [
    "ZHX2 37_37_1_1_T37 phospho",
    "ZHX2 cnv",
    "ZHX2 methyl",
    "ZHX2 proteo",
    "ZHX2 rna"
  ],
  "ZHX3": [
    "ZHX3 604_614_1_1_S604 phospho",
    "ZHX3 680_698_1_1_S680 phospho",
    "ZHX3 897_910_1_1_S899 phospho",
    "ZHX3 938_946_1_1_S946 phospho",
    "ZHX3 cnv",
    "ZHX3 methyl",
    "ZHX3 proteo",
    "ZHX3 rna"
  ],
  "ZIC1": [
    "ZIC1 24_24_1_1_S24 phospho",
    "ZIC1 cnv",
    "ZIC1 methyl",
    "ZIC1 rna"
  ],
  "ZIC2": [
    "ZIC2 cnv",
    "ZIC2 methyl",
    "ZIC2 rna"
  ],
  "ZIC3": [
    "ZIC3 methyl",
    "ZIC3 rna"
  ],
  "ZIC4": [
    "ZIC4 cnv",
    "ZIC4 methyl",
    "ZIC4 rna"
  ],
  "ZIC5": [
    "ZIC5 cnv",
    "ZIC5 methyl",
    "ZIC5 rna"
  ],
  "ZIK1": [
    "ZIK1 cnv",
    "ZIK1 methyl",
    "ZIK1 rna"
  ],
  "ZIM2": [
    "ZIM2 cnv",
    "ZIM2 methyl",
    "ZIM2 rna"
  ],
  "ZIM3": [
    "ZIM3 cnv"
  ],
  "ZKSCAN1": [
    "ZKSCAN1 10_13_1_1_S13 phospho",
    "ZKSCAN1 208_208_1_1_S208 phospho",
    "ZKSCAN1 357_374_1_1_S359 phospho",
    "ZKSCAN1 cnv",
    "ZKSCAN1 methyl",
    "ZKSCAN1 proteo",
    "ZKSCAN1 rna"
  ],
  "ZKSCAN2": [
    "ZKSCAN2 cnv",
    "ZKSCAN2 methyl",
    "ZKSCAN2 rna"
  ],
  "ZKSCAN3": [
    "ZKSCAN3 cnv",
    "ZKSCAN3 rna"
  ],
  "ZKSCAN4": [
    "ZKSCAN4 cnv",
    "ZKSCAN4 rna"
  ],
  "ZKSCAN5": [
    "ZKSCAN5 cnv",
    "ZKSCAN5 methyl",
    "ZKSCAN5 rna"
  ],
  "ZKSCAN7": [
    "ZKSCAN7 cnv",
    "ZKSCAN7 methyl",
    "ZKSCAN7 rna"
  ],
  "ZKSCAN7-AS1": [
    "ZKSCAN7-AS1 methyl"
  ],
  "ZKSCAN8": [
    "ZKSCAN8 9_17_1_1_S12 phospho",
    "ZKSCAN8 cnv",
    "ZKSCAN8 methyl",
    "ZKSCAN8 proteo",
    "ZKSCAN8 rna"
  ],
  "ZKSCAN8P1": [
    "ZKSCAN8P1 cnv",
    "ZKSCAN8P1 rna"
  ],
  "ZMAT1": [
    "ZMAT1 methyl",
    "ZMAT1 rna"
  ],
  "ZMAT2": [
    "ZMAT2 cnv",
    "ZMAT2 proteo",
    "ZMAT2 rna"
  ],
  "ZMAT3": [
    "ZMAT3 cnv",
    "ZMAT3 methyl",
    "ZMAT3 proteo",
    "ZMAT3 rna"
  ],
  "ZMAT4": [
    "ZMAT4 cnv",
    "ZMAT4 methyl",
    "ZMAT4 proteo",
    "ZMAT4 rna"
  ],
  "ZMAT5": [
    "ZMAT5 cnv",
    "ZMAT5 methyl",
    "ZMAT5 rna"
  ],
  "ZMIZ1": [
    "ZMIZ1 cnv",
    "ZMIZ1 methyl",
    "ZMIZ1 proteo",
    "ZMIZ1 rna"
  ],
  "ZMIZ2": [
    "ZMIZ2 cnv",
    "ZMIZ2 methyl",
    "ZMIZ2 proteo",
    "ZMIZ2 rna"
  ],
  "ZMPSTE24": [
    "ZMPSTE24 cnv",
    "ZMPSTE24 methyl",
    "ZMPSTE24 proteo",
    "ZMPSTE24 rna"
  ],
  "ZMYM1": [
    "ZMYM1 cnv",
    "ZMYM1 methyl",
    "ZMYM1 rna"
  ],
  "ZMYM2": [
    "ZMYM2 831_840_1_1_S838 phospho",
    "ZMYM2 cnv",
    "ZMYM2 methyl",
    "ZMYM2 proteo",
    "ZMYM2 rna"
  ],
  "ZMYM3": [
    "ZMYM3 462_464_1_1_S464 phospho",
    "ZMYM3 811_826_1_1_T817 phospho",
    "ZMYM3 methyl",
    "ZMYM3 proteo",
    "ZMYM3 rna"
  ],
  "ZMYM4": [
    "ZMYM4 1030_1047_1_1_S1039 phospho",
    "ZMYM4 1207_1209_1_1_S1209 phospho",
    "ZMYM4 177_188_1_1_T185 phospho",
    "ZMYM4 86_90_1_1_S90 phospho",
    "ZMYM4 cnv",
    "ZMYM4 methyl",
    "ZMYM4 proteo",
    "ZMYM4 rna"
  ],
  "ZMYM5": [
    "ZMYM5 cnv",
    "ZMYM5 methyl",
    "ZMYM5 rna"
  ],
  "ZMYM6": [
    "ZMYM6 cnv",
    "ZMYM6 methyl",
    "ZMYM6 rna"
  ],
  "ZMYND10": [
    "ZMYND10 cnv",
    "ZMYND10 methyl",
    "ZMYND10 rna"
  ],
  "ZMYND11": [
    "ZMYND11 390_393_1_1_S393 phospho",
    "ZMYND11 cnv",
    "ZMYND11 methyl",
    "ZMYND11 proteo",
    "ZMYND11 rna"
  ],
  "ZMYND12": [
    "ZMYND12 cnv",
    "ZMYND12 methyl",
    "ZMYND12 rna"
  ],
  "ZMYND15": [
    "ZMYND15 cnv",
    "ZMYND15 methyl",
    "ZMYND15 rna"
  ],
  "ZMYND19": [
    "ZMYND19 cnv",
    "ZMYND19 methyl",
    "ZMYND19 rna"
  ],
  "ZMYND8": [
    "ZMYND8 404_406_1_1_T404 phospho",
    "ZMYND8 425_427_1_1_S425 phospho",
    "ZMYND8 432_444_1_1_S444 phospho",
    "ZMYND8 455_465_1_1_S460 phospho",
    "ZMYND8 481_490_1_1_S490 phospho",
    "ZMYND8 481_504_1_1_S490 phospho",
    "ZMYND8 481_504_2_2_S486S490 phospho",
    "ZMYND8 650_655_2_2_S652S655 phospho",
    "ZMYND8 668_676_1_1_S668 phospho",
    "ZMYND8 682_682_1_1_S682 phospho",
    "ZMYND8 737_737_1_1_S737 phospho",
    "ZMYND8 746_764_1_1_S756 phospho",
    "ZMYND8 746_764_2_2_T746S756 phospho",
    "ZMYND8 cnv",
    "ZMYND8 proteo",
    "ZMYND8 rna"
  ],
  "ZNF10": [
    "ZNF10 cnv",
    "ZNF10 methyl",
    "ZNF10 rna"
  ],
  "ZNF100": [
    "ZNF100 cnv",
    "ZNF100 methyl",
    "ZNF100 rna"
  ],
  "ZNF101": [
    "ZNF101 cnv",
    "ZNF101 methyl",
    "ZNF101 rna"
  ],
  "ZNF106": [
    "ZNF106 1370_1378_1_1_S1370 phospho",
    "ZNF106 639_641_1_1_S641 phospho",
    "ZNF106 937_942_1_1_S937 phospho",
    "ZNF106 cnv",
    "ZNF106 methyl",
    "ZNF106 rna"
  ],
  "ZNF107": [
    "ZNF107 cnv",
    "ZNF107 rna"
  ],
  "ZNF112": [
    "ZNF112 cnv",
    "ZNF112 methyl",
    "ZNF112 rna"
  ],
  "ZNF114": [
    "ZNF114 cnv",
    "ZNF114 methyl",
    "ZNF114 rna"
  ],
  "ZNF117": [
    "ZNF117 AFNQTSHLIR-N2H6F0S0G0 glyco",
    "ZNF117 AFNQTSHLIR-N2H7F0S0G0 glyco",
    "ZNF117 cnv",
    "ZNF117 rna"
  ],
  "ZNF12": [
    "ZNF12 cnv",
    "ZNF12 methyl",
    "ZNF12 rna"
  ],
  "ZNF121": [
    "ZNF121 cnv",
    "ZNF121 methyl",
    "ZNF121 rna"
  ],
  "ZNF124": [
    "ZNF124 cnv",
    "ZNF124 rna"
  ],
  "ZNF131": [
    "ZNF131 cnv",
    "ZNF131 methyl",
    "ZNF131 proteo",
    "ZNF131 rna"
  ],
  "ZNF132": [
    "ZNF132 cnv",
    "ZNF132 methyl",
    "ZNF132 rna"
  ],
  "ZNF133": [
    "ZNF133 cnv",
    "ZNF133 methyl",
    "ZNF133 rna"
  ],
  "ZNF134": [
    "ZNF134 cnv",
    "ZNF134 methyl",
    "ZNF134 rna"
  ],
  "ZNF135": [
    "ZNF135 cnv",
    "ZNF135 methyl",
    "ZNF135 rna"
  ],
  "ZNF136": [
    "ZNF136 cnv",
    "ZNF136 methyl",
    "ZNF136 rna"
  ],
  "ZNF138": [
    "ZNF138 cnv",
    "ZNF138 methyl",
    "ZNF138 rna"
  ],
  "ZNF14": [
    "ZNF14 cnv",
    "ZNF14 methyl",
    "ZNF14 rna"
  ],
  "ZNF140": [
    "ZNF140 cnv",
    "ZNF140 methyl",
    "ZNF140 rna"
  ],
  "ZNF141": [
    "ZNF141 cnv",
    "ZNF141 methyl",
    "ZNF141 rna"
  ],
  "ZNF142": [
    "ZNF142 cnv",
    "ZNF142 methyl",
    "ZNF142 rna"
  ],
  "ZNF143": [
    "ZNF143 cnv",
    "ZNF143 methyl",
    "ZNF143 proteo",
    "ZNF143 rna"
  ],
  "ZNF146": [
    "ZNF146 cnv",
    "ZNF146 methyl",
    "ZNF146 rna"
  ],
  "ZNF148": [
    "ZNF148 296_306_1_1_S306 phospho",
    "ZNF148 296_311_1_0 phospho",
    "ZNF148 410_420_1_1_S412 phospho",
    "ZNF148 661_670_2_0 phospho",
    "ZNF148 782_792_1_1_S784 phospho",
    "ZNF148 cnv",
    "ZNF148 methyl",
    "ZNF148 proteo",
    "ZNF148 rna"
  ],
  "ZNF154": [
    "ZNF154 cnv",
    "ZNF154 methyl",
    "ZNF154 rna"
  ],
  "ZNF155": [
    "ZNF155 cnv",
    "ZNF155 rna"
  ],
  "ZNF157": [
    "ZNF157 rna"
  ],
  "ZNF16": [
    "ZNF16 cnv",
    "ZNF16 methyl",
    "ZNF16 rna"
  ],
  "ZNF160": [
    "ZNF160 cnv",
    "ZNF160 methyl",
    "ZNF160 rna"
  ],
  "ZNF165": [
    "ZNF165 cnv",
    "ZNF165 rna"
  ],
  "ZNF169": [
    "ZNF169 cnv",
    "ZNF169 methyl",
    "ZNF169 rna"
  ],
  "ZNF17": [
    "ZNF17 cnv",
    "ZNF17 methyl",
    "ZNF17 rna"
  ],
  "ZNF174": [
    "ZNF174 cnv",
    "ZNF174 methyl",
    "ZNF174 rna"
  ],
  "ZNF175": [
    "ZNF175 cnv",
    "ZNF175 methyl",
    "ZNF175 rna"
  ],
  "ZNF177": [
    "ZNF177 cnv",
    "ZNF177 methyl",
    "ZNF177 rna"
  ],
  "ZNF18": [
    "ZNF18 cnv",
    "ZNF18 methyl",
    "ZNF18 rna"
  ],
  "ZNF180": [
    "ZNF180 cnv",
    "ZNF180 methyl",
    "ZNF180 rna"
  ],
  "ZNF181": [
    "ZNF181 cnv",
    "ZNF181 methyl",
    "ZNF181 rna"
  ],
  "ZNF182": [
    "ZNF182 methyl",
    "ZNF182 rna"
  ],
  "ZNF184": [
    "ZNF184 cnv",
    "ZNF184 methyl",
    "ZNF184 rna"
  ],
  "ZNF185": [
    "ZNF185 152_171_1_0 phospho",
    "ZNF185 152_171_1_1_S153 phospho",
    "ZNF185 447_448_1_1_T448 phospho",
    "ZNF185 466_473_1_1_S466 phospho",
    "ZNF185 466_482_1_1_S466 phospho",
    "ZNF185 methyl",
    "ZNF185 proteo",
    "ZNF185 rna"
  ],
  "ZNF189": [
    "ZNF189 cnv",
    "ZNF189 methyl",
    "ZNF189 proteo",
    "ZNF189 rna"
  ],
  "ZNF19": [
    "ZNF19 cnv",
    "ZNF19 rna"
  ],
  "ZNF195": [
    "ZNF195 cnv",
    "ZNF195 methyl",
    "ZNF195 rna"
  ],
  "ZNF197": [
    "ZNF197 cnv",
    "ZNF197 methyl",
    "ZNF197 rna"
  ],
  "ZNF197-AS1": [
    "ZNF197-AS1 methyl"
  ],
  "ZNF2": [
    "ZNF2 cnv",
    "ZNF2 methyl",
    "ZNF2 proteo",
    "ZNF2 rna"
  ],
  "ZNF20": [
    "ZNF20 cnv",
    "ZNF20 methyl",
    "ZNF20 rna"
  ],
  "ZNF200": [
    "ZNF200 cnv",
    "ZNF200 methyl",
    "ZNF200 rna"
  ],
  "ZNF202": [
    "ZNF202 cnv",
    "ZNF202 methyl",
    "ZNF202 rna"
  ],
  "ZNF205": [
    "ZNF205 cnv",
    "ZNF205 rna"
  ],
  "ZNF207": [
    "ZNF207 cnv",
    "ZNF207 methyl",
    "ZNF207 proteo",
    "ZNF207 rna"
  ],
  "ZNF208": [
    "ZNF208 cnv",
    "ZNF208 rna"
  ],
  "ZNF211": [
    "ZNF211 cnv",
    "ZNF211 methyl",
    "ZNF211 rna"
  ],
  "ZNF212": [
    "ZNF212 cnv",
    "ZNF212 rna"
  ],
  "ZNF213": [
    "ZNF213 cnv",
    "ZNF213 methyl",
    "ZNF213 rna"
  ],
  "ZNF214": [
    "ZNF214 cnv",
    "ZNF214 methyl",
    "ZNF214 rna"
  ],
  "ZNF215": [
    "ZNF215 cnv",
    "ZNF215 methyl",
    "ZNF215 rna"
  ],
  "ZNF217": [
    "ZNF217 cnv",
    "ZNF217 methyl",
    "ZNF217 rna"
  ],
  "ZNF219": [
    "ZNF219 106_114_1_1_S114 phospho",
    "ZNF219 10_16_1_1_S16 phospho",
    "ZNF219 cnv",
    "ZNF219 methyl",
    "ZNF219 proteo",
    "ZNF219 rna"
  ],
  "ZNF22": [
    "ZNF22 49_55_1_1_S49 phospho",
    "ZNF22 cnv",
    "ZNF22 methyl",
    "ZNF22 proteo",
    "ZNF22 rna"
  ],
  "ZNF22-AS1": [
    "ZNF22-AS1 methyl"
  ],
  "ZNF221": [
    "ZNF221 cnv",
    "ZNF221 methyl",
    "ZNF221 rna"
  ],
  "ZNF222": [
    "ZNF222 cnv",
    "ZNF222 methyl",
    "ZNF222 rna"
  ],
  "ZNF223": [
    "ZNF223 cnv",
    "ZNF223 rna"
  ],
  "ZNF224": [
    "ZNF224 cnv",
    "ZNF224 methyl",
    "ZNF224 rna"
  ],
  "ZNF225": [
    "ZNF225 cnv",
    "ZNF225 methyl",
    "ZNF225 rna"
  ],
  "ZNF226": [
    "ZNF226 cnv",
    "ZNF226 rna"
  ],
  "ZNF227": [
    "ZNF227 cnv",
    "ZNF227 methyl",
    "ZNF227 rna"
  ],
  "ZNF229": [
    "ZNF229 cnv",
    "ZNF229 methyl",
    "ZNF229 rna"
  ],
  "ZNF23": [
    "ZNF23 cnv",
    "ZNF23 methyl",
    "ZNF23 rna"
  ],
  "ZNF230": [
    "ZNF230 cnv",
    "ZNF230 methyl",
    "ZNF230 rna"
  ],
  "ZNF230-DT": [
    "ZNF230-DT methyl"
  ],
  "ZNF232": [
    "ZNF232 cnv",
    "ZNF232 methyl",
    "ZNF232 rna"
  ],
  "ZNF232-AS1": [
    "ZNF232-AS1 methyl"
  ],
  "ZNF233": [
    "ZNF233 cnv",
    "ZNF233 methyl",
    "ZNF233 rna"
  ],
  "ZNF234": [
    "ZNF234 cnv",
    "ZNF234 methyl",
    "ZNF234 rna"
  ],
  "ZNF235": [
    "ZNF235 cnv",
    "ZNF235 methyl",
    "ZNF235 rna"
  ],
  "ZNF236": [
    "ZNF236 cnv",
    "ZNF236 methyl",
    "ZNF236 rna"
  ],
  "ZNF236-DT": [
    "ZNF236-DT methyl"
  ],
  "ZNF239": [
    "ZNF239 cnv",
    "ZNF239 methyl",
    "ZNF239 rna"
  ],
  "ZNF24": [
    "ZNF24 cnv",
    "ZNF24 methyl",
    "ZNF24 proteo",
    "ZNF24 rna"
  ],
  "ZNF248": [
    "ZNF248 cnv",
    "ZNF248 methyl",
    "ZNF248 rna"
  ],
  "ZNF25": [
    "ZNF25 cnv",
    "ZNF25 methyl",
    "ZNF25 rna"
  ],
  "ZNF250": [
    "ZNF250 cnv",
    "ZNF250 methyl",
    "ZNF250 rna"
  ],
  "ZNF251": [
    "ZNF251 cnv",
    "ZNF251 methyl",
    "ZNF251 rna"
  ],
  "ZNF252P": [
    "ZNF252P methyl"
  ],
  "ZNF252P-AS1": [
    "ZNF252P-AS1 methyl"
  ],
  "ZNF253": [
    "ZNF253 cnv",
    "ZNF253 rna"
  ],
  "ZNF254": [
    "ZNF254 cnv",
    "ZNF254 rna"
  ],
  "ZNF256": [
    "ZNF256 cnv",
    "ZNF256 methyl",
    "ZNF256 rna"
  ],
  "ZNF257": [
    "ZNF257 cnv",
    "ZNF257 rna"
  ],
  "ZNF26": [
    "ZNF26 cnv",
    "ZNF26 methyl",
    "ZNF26 rna"
  ],
  "ZNF260": [
    "ZNF260 cnv",
    "ZNF260 methyl",
    "ZNF260 rna"
  ],
  "ZNF263": [
    "ZNF263 cnv",
    "ZNF263 methyl",
    "ZNF263 rna"
  ],
  "ZNF264": [
    "ZNF264 cnv",
    "ZNF264 methyl",
    "ZNF264 rna"
  ],
  "ZNF266": [
    "ZNF266 cnv",
    "ZNF266 methyl",
    "ZNF266 rna"
  ],
  "ZNF267": [
    "ZNF267 cnv",
    "ZNF267 methyl",
    "ZNF267 rna"
  ],
  "ZNF268": [
    "ZNF268 cnv",
    "ZNF268 methyl",
    "ZNF268 rna"
  ],
  "ZNF271P": [
    "ZNF271P methyl"
  ],
  "ZNF273": [
    "ZNF273 cnv",
    "ZNF273 methyl",
    "ZNF273 rna"
  ],
  "ZNF274": [
    "ZNF274 cnv",
    "ZNF274 methyl",
    "ZNF274 rna"
  ],
  "ZNF275": [
    "ZNF275 methyl",
    "ZNF275 rna"
  ],
  "ZNF276": [
    "ZNF276 599_614_1_0 phospho",
    "ZNF276 599_614_1_1_S599 phospho",
    "ZNF276 cnv",
    "ZNF276 methyl",
    "ZNF276 rna"
  ],
  "ZNF277": [
    "ZNF277 cnv",
    "ZNF277 methyl",
    "ZNF277 rna"
  ],
  "ZNF28": [
    "ZNF28 cnv",
    "ZNF28 methyl",
    "ZNF28 rna"
  ],
  "ZNF280A": [
    "ZNF280A cnv",
    "ZNF280A rna"
  ],
  "ZNF280B": [
    "ZNF280B cnv",
    "ZNF280B methyl",
    "ZNF280B rna"
  ],
  "ZNF280C": [
    "ZNF280C methyl",
    "ZNF280C proteo",
    "ZNF280C rna"
  ],
  "ZNF280D": [
    "ZNF280D 166_168_1_1_S166 phospho",
    "ZNF280D cnv",
    "ZNF280D methyl",
    "ZNF280D proteo",
    "ZNF280D rna"
  ],
  "ZNF281": [
    "ZNF281 cnv",
    "ZNF281 methyl",
    "ZNF281 rna"
  ],
  "ZNF282": [
    "ZNF282 cnv",
    "ZNF282 methyl",
    "ZNF282 proteo",
    "ZNF282 rna"
  ],
  "ZNF283": [
    "ZNF283 cnv",
    "ZNF283 rna"
  ],
  "ZNF284": [
    "ZNF284 cnv",
    "ZNF284 methyl",
    "ZNF284 rna"
  ],
  "ZNF285": [
    "ZNF285 cnv",
    "ZNF285 rna"
  ],
  "ZNF286A": [
    "ZNF286A 15_19_1_1_S19 phospho",
    "ZNF286A cnv",
    "ZNF286A methyl",
    "ZNF286A rna"
  ],
  "ZNF286A-TBC1D26": [
    "ZNF286A-TBC1D26 cnv",
    "ZNF286A-TBC1D26 rna"
  ],
  "ZNF286B": [
    "ZNF286B methyl"
  ],
  "ZNF287": [
    "ZNF287 cnv",
    "ZNF287 methyl",
    "ZNF287 rna"
  ],
  "ZNF292": [
    "ZNF292 cnv",
    "ZNF292 methyl",
    "ZNF292 rna"
  ],
  "ZNF295-AS1": [
    "ZNF295-AS1 methyl"
  ],
  "ZNF296": [
    "ZNF296 cnv",
    "ZNF296 methyl",
    "ZNF296 rna"
  ],
  "ZNF3": [
    "ZNF3 cnv",
    "ZNF3 methyl",
    "ZNF3 proteo",
    "ZNF3 rna"
  ],
  "ZNF30": [
    "ZNF30 cnv",
    "ZNF30 methyl",
    "ZNF30 rna"
  ],
  "ZNF300": [
    "ZNF300 cnv",
    "ZNF300 methyl",
    "ZNF300 rna"
  ],
  "ZNF300P1": [
    "ZNF300P1 methyl"
  ],
  "ZNF302": [
    "ZNF302 cnv",
    "ZNF302 methyl",
    "ZNF302 rna"
  ],
  "ZNF304": [
    "ZNF304 cnv",
    "ZNF304 methyl",
    "ZNF304 rna"
  ],
  "ZNF311": [
    "ZNF311 cnv",
    "ZNF311 rna"
  ],
  "ZNF316": [
    "ZNF316 112_112_1_1_S112 phospho",
    "ZNF316 cnv",
    "ZNF316 methyl",
    "ZNF316 proteo",
    "ZNF316 rna"
  ],
  "ZNF317": [
    "ZNF317 cnv",
    "ZNF317 methyl",
    "ZNF317 rna"
  ],
  "ZNF318": [
    "ZNF318 1037_1048_1_1_S1037 phospho",
    "ZNF318 1037_1048_2_2_S1037S1043 phospho",
    "ZNF318 1238_1243_1_1_S1243 phospho",
    "ZNF318 1267_1272_1_1_S1267 phospho",
    "ZNF318 136_143_1_1_S136 phospho",
    "ZNF318 151_161_1_1_T161 phospho",
    "ZNF318 1888_1896_1_1_S1896 phospho",
    "ZNF318 2030_2037_1_1_S2035 phospho",
    "ZNF318 2030_2037_2_2_S2030S2035 phospho",
    "ZNF318 2078_2091_1_1_S2091 phospho",
    "ZNF318 2101_2101_1_1_S2101 phospho",
    "ZNF318 2189_2198_2_2_S2189S2192 phospho",
    "ZNF318 39_50_1_0 phospho",
    "ZNF318 39_50_1_1_S40 phospho",
    "ZNF318 464_464_1_1_S464 phospho",
    "ZNF318 527_527_1_1_S527 phospho",
    "ZNF318 670_678_1_1_S671 phospho",
    "ZNF318 709_709_1_1_S709 phospho",
    "ZNF318 cnv",
    "ZNF318 methyl",
    "ZNF318 proteo",
    "ZNF318 rna"
  ],
  "ZNF319": [
    "ZNF319 cnv",
    "ZNF319 methyl",
    "ZNF319 rna"
  ],
  "ZNF32": [
    "ZNF32 cnv",
    "ZNF32 methyl",
    "ZNF32 proteo",
    "ZNF32 rna"
  ],
  "ZNF320": [
    "ZNF320 cnv",
    "ZNF320 methyl",
    "ZNF320 rna"
  ],
  "ZNF321P": [
    "ZNF321P methyl"
  ],
  "ZNF322": [
    "ZNF322 cnv",
    "ZNF322 methyl",
    "ZNF322 rna"
  ],
  "ZNF324": [
    "ZNF324 cnv",
    "ZNF324 methyl",
    "ZNF324 rna"
  ],
  "ZNF324B": [
    "ZNF324B cnv",
    "ZNF324B methyl",
    "ZNF324B rna"
  ],
  "ZNF326": [
    "ZNF326 48_69_1_1_S56 phospho",
    "ZNF326 cnv",
    "ZNF326 methyl",
    "ZNF326 proteo",
    "ZNF326 rna"
  ],
  "ZNF329": [
    "ZNF329 cnv",
    "ZNF329 methyl",
    "ZNF329 rna"
  ],
  "ZNF330": [
    "ZNF330 cnv",
    "ZNF330 methyl",
    "ZNF330 proteo",
    "ZNF330 rna"
  ],
  "ZNF331": [
    "ZNF331 cnv",
    "ZNF331 methyl",
    "ZNF331 rna"
  ],
  "ZNF333": [
    "ZNF333 cnv",
    "ZNF333 rna"
  ],
  "ZNF334": [
    "ZNF334 cnv",
    "ZNF334 methyl",
    "ZNF334 rna"
  ],
  "ZNF335": [
    "ZNF335 cnv",
    "ZNF335 methyl",
    "ZNF335 rna"
  ],
  "ZNF337": [
    "ZNF337 cnv",
    "ZNF337 methyl",
    "ZNF337 rna"
  ],
  "ZNF337-AS1": [
    "ZNF337-AS1 methyl"
  ],
  "ZNF33A": [
    "ZNF33A cnv",
    "ZNF33A methyl",
    "ZNF33A rna"
  ],
  "ZNF33B": [
    "ZNF33B cnv",
    "ZNF33B methyl",
    "ZNF33B rna"
  ],
  "ZNF34": [
    "ZNF34 cnv",
    "ZNF34 methyl",
    "ZNF34 rna"
  ],
  "ZNF341": [
    "ZNF341 cnv",
    "ZNF341 methyl",
    "ZNF341 rna"
  ],
  "ZNF341-AS1": [
    "ZNF341-AS1 methyl"
  ],
  "ZNF343": [
    "ZNF343 cnv",
    "ZNF343 methyl",
    "ZNF343 rna"
  ],
  "ZNF345": [
    "ZNF345 cnv",
    "ZNF345 methyl",
    "ZNF345 rna"
  ],
  "ZNF346": [
    "ZNF346 cnv",
    "ZNF346 methyl",
    "ZNF346 proteo",
    "ZNF346 rna"
  ],
  "ZNF347": [
    "ZNF347 cnv",
    "ZNF347 methyl",
    "ZNF347 rna"
  ],
  "ZNF35": [
    "ZNF35 cnv",
    "ZNF35 methyl",
    "ZNF35 rna"
  ],
  "ZNF350": [
    "ZNF350 283_285_1_1_T283 phospho",
    "ZNF350 cnv",
    "ZNF350 rna"
  ],
  "ZNF350-AS1": [
    "ZNF350-AS1 methyl"
  ],
  "ZNF354A": [
    "ZNF354A cnv",
    "ZNF354A methyl",
    "ZNF354A rna"
  ],
  "ZNF354B": [
    "ZNF354B cnv",
    "ZNF354B methyl",
    "ZNF354B rna"
  ],
  "ZNF354C": [
    "ZNF354C cnv",
    "ZNF354C methyl",
    "ZNF354C rna"
  ],
  "ZNF358": [
    "ZNF358 484_494_1_1_S487 phospho",
    "ZNF358 484_494_2_2_T485S487 phospho",
    "ZNF358 cnv",
    "ZNF358 methyl",
    "ZNF358 proteo",
    "ZNF358 rna"
  ],
  "ZNF362": [
    "ZNF362 394_404_1_1_S404 phospho",
    "ZNF362 cnv",
    "ZNF362 methyl",
    "ZNF362 proteo",
    "ZNF362 rna"
  ],
  "ZNF365": [
    "ZNF365 cnv",
    "ZNF365 methyl",
    "ZNF365 proteo",
    "ZNF365 rna"
  ],
  "ZNF366": [
    "ZNF366 cnv",
    "ZNF366 rna"
  ],
  "ZNF367": [
    "ZNF367 cnv",
    "ZNF367 methyl",
    "ZNF367 rna"
  ],
  "ZNF37A": [
    "ZNF37A cnv",
    "ZNF37A methyl",
    "ZNF37A rna"
  ],
  "ZNF37BP": [
    "ZNF37BP methyl"
  ],
  "ZNF382": [
    "ZNF382 cnv",
    "ZNF382 methyl",
    "ZNF382 rna"
  ],
  "ZNF383": [
    "ZNF383 cnv",
    "ZNF383 methyl",
    "ZNF383 rna"
  ],
  "ZNF384": [
    "ZNF384 cnv",
    "ZNF384 methyl",
    "ZNF384 proteo",
    "ZNF384 rna"
  ],
  "ZNF385A": [
    "ZNF385A 160_174_1_1_S160 phospho",
    "ZNF385A cnv",
    "ZNF385A proteo",
    "ZNF385A rna"
  ],
  "ZNF385B": [
    "ZNF385B cnv",
    "ZNF385B methyl",
    "ZNF385B rna"
  ],
  "ZNF385C": [
    "ZNF385C cnv",
    "ZNF385C rna"
  ],
  "ZNF385D": [
    "ZNF385D cnv",
    "ZNF385D methyl",
    "ZNF385D rna"
  ],
  "ZNF391": [
    "ZNF391 cnv",
    "ZNF391 methyl",
    "ZNF391 rna"
  ],
  "ZNF394": [
    "ZNF394 cnv",
    "ZNF394 methyl",
    "ZNF394 rna"
  ],
  "ZNF395": [
    "ZNF395 447_451_1_0 phospho",
    "ZNF395 447_451_1_1_S449 phospho",
    "ZNF395 cnv",
    "ZNF395 methyl",
    "ZNF395 rna"
  ],
  "ZNF396": [
    "ZNF396 cnv",
    "ZNF396 methyl",
    "ZNF396 rna"
  ],
  "ZNF397": [
    "ZNF397 cnv",
    "ZNF397 methyl",
    "ZNF397 rna"
  ],
  "ZNF398": [
    "ZNF398 cnv",
    "ZNF398 methyl",
    "ZNF398 rna"
  ],
  "ZNF404": [
    "ZNF404 cnv",
    "ZNF404 rna"
  ],
  "ZNF407": [
    "ZNF407 cnv",
    "ZNF407 methyl",
    "ZNF407 proteo",
    "ZNF407 rna"
  ],
  "ZNF408": [
    "ZNF408 314_328_1_1_T314 phospho",
    "ZNF408 cnv",
    "ZNF408 methyl",
    "ZNF408 rna"
  ],
  "ZNF41": [
    "ZNF41 methyl",
    "ZNF41 rna"
  ],
  "ZNF410": [
    "ZNF410 cnv",
    "ZNF410 methyl",
    "ZNF410 rna"
  ],
  "ZNF414": [
    "ZNF414 cnv",
    "ZNF414 methyl",
    "ZNF414 proteo",
    "ZNF414 rna"
  ],
  "ZNF415": [
    "ZNF415 cnv",
    "ZNF415 methyl",
    "ZNF415 rna"
  ],
  "ZNF416": [
    "ZNF416 cnv",
    "ZNF416 methyl",
    "ZNF416 rna"
  ],
  "ZNF417": [
    "ZNF417 cnv",
    "ZNF417 methyl",
    "ZNF417 rna"
  ],
  "ZNF418": [
    "ZNF418 cnv",
    "ZNF418 methyl",
    "ZNF418 rna"
  ],
  "ZNF419": [
    "ZNF419 cnv",
    "ZNF419 methyl",
    "ZNF419 rna"
  ],
  "ZNF420": [
    "ZNF420 cnv",
    "ZNF420 methyl",
    "ZNF420 rna"
  ],
  "ZNF423": [
    "ZNF423 1049_1054_1_1_S1054 phospho",
    "ZNF423 382_387_1_1_T383 phospho",
    "ZNF423 599_614_1_1_S604 phospho",
    "ZNF423 cnv",
    "ZNF423 methyl",
    "ZNF423 proteo",
    "ZNF423 rna"
  ],
  "ZNF425": [
    "ZNF425 cnv",
    "ZNF425 methyl",
    "ZNF425 rna"
  ],
  "ZNF426": [
    "ZNF426 cnv",
    "ZNF426 methyl",
    "ZNF426 rna"
  ],
  "ZNF426-DT": [
    "ZNF426-DT methyl"
  ],
  "ZNF428": [
    "ZNF428 99_108_1_1_S99 phospho",
    "ZNF428 99_108_1_1_T108 phospho",
    "ZNF428 cnv",
    "ZNF428 methyl",
    "ZNF428 proteo",
    "ZNF428 rna"
  ],
  "ZNF429": [
    "ZNF429 cnv",
    "ZNF429 rna"
  ],
  "ZNF43": [
    "ZNF43 cnv",
    "ZNF43 methyl",
    "ZNF43 rna"
  ],
  "ZNF430": [
    "ZNF430 cnv",
    "ZNF430 rna"
  ],
  "ZNF431": [
    "ZNF431 cnv",
    "ZNF431 rna"
  ],
  "ZNF432": [
    "ZNF432 cnv",
    "ZNF432 methyl",
    "ZNF432 rna"
  ],
  "ZNF433": [
    "ZNF433 cnv",
    "ZNF433 methyl",
    "ZNF433 rna"
  ],
  "ZNF433-AS1": [
    "ZNF433-AS1 methyl"
  ],
  "ZNF436": [
    "ZNF436 cnv",
    "ZNF436 methyl",
    "ZNF436 proteo",
    "ZNF436 rna"
  ],
  "ZNF438": [
    "ZNF438 cnv",
    "ZNF438 methyl",
    "ZNF438 rna"
  ],
  "ZNF439": [
    "ZNF439 cnv",
    "ZNF439 methyl",
    "ZNF439 rna"
  ],
  "ZNF44": [
    "ZNF44 cnv",
    "ZNF44 methyl",
    "ZNF44 rna"
  ],
  "ZNF440": [
    "ZNF440 cnv",
    "ZNF440 methyl",
    "ZNF440 rna"
  ],
  "ZNF441": [
    "ZNF441 cnv",
    "ZNF441 methyl",
    "ZNF441 rna"
  ],
  "ZNF442": [
    "ZNF442 cnv",
    "ZNF442 methyl",
    "ZNF442 rna"
  ],
  "ZNF443": [
    "ZNF443 cnv",
    "ZNF443 methyl",
    "ZNF443 rna"
  ],
  "ZNF444": [
    "ZNF444 cnv",
    "ZNF444 methyl",
    "ZNF444 rna"
  ],
  "ZNF445": [
    "ZNF445 cnv",
    "ZNF445 methyl",
    "ZNF445 rna"
  ],
  "ZNF446": [
    "ZNF446 131_154_1_1_S137 phospho",
    "ZNF446 131_154_2_2_S137S146 phospho",
    "ZNF446 3_24_1_1_S3 phospho",
    "ZNF446 cnv",
    "ZNF446 methyl",
    "ZNF446 proteo",
    "ZNF446 rna"
  ],
  "ZNF449": [
    "ZNF449 methyl",
    "ZNF449 rna"
  ],
  "ZNF45": [
    "ZNF45 cnv",
    "ZNF45 methyl",
    "ZNF45 rna"
  ],
  "ZNF45-AS1": [
    "ZNF45-AS1 methyl"
  ],
  "ZNF451": [
    "ZNF451 1027_1027_1_1_S1027 phospho",
    "ZNF451 cnv",
    "ZNF451 methyl",
    "ZNF451 proteo",
    "ZNF451 rna"
  ],
  "ZNF454": [
    "ZNF454 cnv",
    "ZNF454 methyl",
    "ZNF454 rna"
  ],
  "ZNF460": [
    "ZNF460 cnv",
    "ZNF460 methyl",
    "ZNF460 proteo",
    "ZNF460 rna"
  ],
  "ZNF460-AS1": [
    "ZNF460-AS1 methyl"
  ],
  "ZNF461": [
    "ZNF461 cnv",
    "ZNF461 methyl",
    "ZNF461 rna"
  ],
  "ZNF462": [
    "ZNF462 1419_1451_1_1_S1451 phospho",
    "ZNF462 2169_2183_1_1_S2172 phospho",
    "ZNF462 cnv",
    "ZNF462 proteo",
    "ZNF462 rna"
  ],
  "ZNF467": [
    "ZNF467 cnv",
    "ZNF467 methyl",
    "ZNF467 rna"
  ],
  "ZNF468": [
    "ZNF468 cnv",
    "ZNF468 methyl",
    "ZNF468 rna"
  ],
  "ZNF469": [
    "ZNF469 cnv",
    "ZNF469 methyl",
    "ZNF469 rna"
  ],
  "ZNF470": [
    "ZNF470 cnv",
    "ZNF470 methyl",
    "ZNF470 rna"
  ],
  "ZNF471": [
    "ZNF471 cnv",
    "ZNF471 methyl",
    "ZNF471 rna"
  ],
  "ZNF473": [
    "ZNF473 cnv",
    "ZNF473 methyl",
    "ZNF473 rna"
  ],
  "ZNF474": [
    "ZNF474 cnv",
    "ZNF474 rna"
  ],
  "ZNF479": [
    "ZNF479 cnv"
  ],
  "ZNF48": [
    "ZNF48 cnv",
    "ZNF48 methyl",
    "ZNF48 rna"
  ],
  "ZNF480": [
    "ZNF480 cnv",
    "ZNF480 methyl",
    "ZNF480 rna"
  ],
  "ZNF483": [
    "ZNF483 cnv",
    "ZNF483 rna"
  ],
  "ZNF484": [
    "ZNF484 cnv",
    "ZNF484 rna"
  ],
  "ZNF485": [
    "ZNF485 cnv",
    "ZNF485 methyl",
    "ZNF485 rna"
  ],
  "ZNF486": [
    "ZNF486 cnv",
    "ZNF486 rna"
  ],
  "ZNF487": [
    "ZNF487 cnv",
    "ZNF487 methyl",
    "ZNF487 rna"
  ],
  "ZNF488": [
    "ZNF488 cnv",
    "ZNF488 methyl",
    "ZNF488 rna"
  ],
  "ZNF490": [
    "ZNF490 cnv",
    "ZNF490 methyl",
    "ZNF490 rna"
  ],
  "ZNF491": [
    "ZNF491 cnv",
    "ZNF491 methyl",
    "ZNF491 rna"
  ],
  "ZNF492": [
    "ZNF492 cnv",
    "ZNF492 rna"
  ],
  "ZNF493": [
    "ZNF493 cnv",
    "ZNF493 rna"
  ],
  "ZNF496": [
    "ZNF496 cnv",
    "ZNF496 methyl",
    "ZNF496 rna"
  ],
  "ZNF497": [
    "ZNF497 cnv",
    "ZNF497 methyl",
    "ZNF497 rna"
  ],
  "ZNF500": [
    "ZNF500 cnv",
    "ZNF500 methyl",
    "ZNF500 rna"
  ],
  "ZNF501": [
    "ZNF501 cnv",
    "ZNF501 methyl",
    "ZNF501 rna"
  ],
  "ZNF502": [
    "ZNF502 cnv",
    "ZNF502 methyl",
    "ZNF502 rna"
  ],
  "ZNF503": [
    "ZNF503 cnv",
    "ZNF503 methyl",
    "ZNF503 rna"
  ],
  "ZNF503-AS1": [
    "ZNF503-AS1 methyl"
  ],
  "ZNF503-AS2": [
    "ZNF503-AS2 methyl"
  ],
  "ZNF506": [
    "ZNF506 cnv",
    "ZNF506 rna"
  ],
  "ZNF507": [
    "ZNF507 cnv",
    "ZNF507 methyl",
    "ZNF507 rna"
  ],
  "ZNF510": [
    "ZNF510 cnv",
    "ZNF510 methyl",
    "ZNF510 rna"
  ],
  "ZNF511": [
    "ZNF511 cnv",
    "ZNF511 methyl",
    "ZNF511 rna"
  ],
  "ZNF511-PRAP1": [
    "ZNF511-PRAP1 cnv",
    "ZNF511-PRAP1 rna"
  ],
  "ZNF512": [
    "ZNF512 cnv",
    "ZNF512 methyl",
    "ZNF512 proteo",
    "ZNF512 rna"
  ],
  "ZNF512B": [
    "ZNF512B 852_852_1_1_T852 phospho",
    "ZNF512B cnv",
    "ZNF512B methyl",
    "ZNF512B proteo",
    "ZNF512B rna"
  ],
  "ZNF513": [
    "ZNF513 191_193_1_1_S191 phospho",
    "ZNF513 cnv",
    "ZNF513 methyl",
    "ZNF513 proteo",
    "ZNF513 rna"
  ],
  "ZNF514": [
    "ZNF514 cnv",
    "ZNF514 methyl",
    "ZNF514 rna"
  ],
  "ZNF516": [
    "ZNF516 cnv",
    "ZNF516 methyl",
    "ZNF516 proteo",
    "ZNF516 rna"
  ],
  "ZNF516-AS1": [
    "ZNF516-AS1 methyl"
  ],
  "ZNF516-DT": [
    "ZNF516-DT methyl"
  ],
  "ZNF517": [
    "ZNF517 cnv",
    "ZNF517 methyl",
    "ZNF517 rna"
  ],
  "ZNF518A": [
    "ZNF518A cnv",
    "ZNF518A methyl",
    "ZNF518A rna"
  ],
  "ZNF518B": [
    "ZNF518B cnv",
    "ZNF518B methyl",
    "ZNF518B rna"
  ],
  "ZNF519": [
    "ZNF519 cnv",
    "ZNF519 methyl",
    "ZNF519 rna"
  ],
  "ZNF521": [
    "ZNF521 385_396_2_2_S385S388 phospho",
    "ZNF521 53_53_1_1_S53 phospho",
    "ZNF521 cnv",
    "ZNF521 proteo",
    "ZNF521 rna"
  ],
  "ZNF524": [
    "ZNF524 cnv",
    "ZNF524 methyl",
    "ZNF524 rna"
  ],
  "ZNF525": [
    "ZNF525 cnv",
    "ZNF525 methyl",
    "ZNF525 rna"
  ],
  "ZNF526": [
    "ZNF526 cnv",
    "ZNF526 methyl",
    "ZNF526 proteo",
    "ZNF526 rna"
  ],
  "ZNF527": [
    "ZNF527 cnv",
    "ZNF527 methyl",
    "ZNF527 rna"
  ],
  "ZNF528": [
    "ZNF528 cnv",
    "ZNF528 methyl",
    "ZNF528 rna"
  ],
  "ZNF529": [
    "ZNF529 cnv",
    "ZNF529 methyl",
    "ZNF529 rna"
  ],
  "ZNF529-AS1": [
    "ZNF529-AS1 methyl"
  ],
  "ZNF530": [
    "ZNF530 cnv",
    "ZNF530 methyl",
    "ZNF530 rna"
  ],
  "ZNF532": [
    "ZNF532 297_298_1_1_S298 phospho",
    "ZNF532 314_324_1_1_S314 phospho",
    "ZNF532 347_355_1_1_S350 phospho",
    "ZNF532 cnv",
    "ZNF532 methyl",
    "ZNF532 proteo",
    "ZNF532 rna"
  ],
  "ZNF534": [
    "ZNF534 cnv",
    "ZNF534 rna"
  ],
  "ZNF536": [
    "ZNF536 cnv",
    "ZNF536 methyl",
    "ZNF536 rna"
  ],
  "ZNF540": [
    "ZNF540 cnv",
    "ZNF540 methyl",
    "ZNF540 rna"
  ],
  "ZNF541": [
    "ZNF541 cnv",
    "ZNF541 methyl",
    "ZNF541 rna"
  ],
  "ZNF542P": [
    "ZNF542P methyl"
  ],
  "ZNF543": [
    "ZNF543 cnv",
    "ZNF543 methyl",
    "ZNF543 rna"
  ],
  "ZNF544": [
    "ZNF544 cnv",
    "ZNF544 methyl",
    "ZNF544 rna"
  ],
  "ZNF546": [
    "ZNF546 cnv",
    "ZNF546 methyl",
    "ZNF546 rna"
  ],
  "ZNF547": [
    "ZNF547 cnv",
    "ZNF547 methyl",
    "ZNF547 rna"
  ],
  "ZNF548": [
    "ZNF548 cnv",
    "ZNF548 methyl",
    "ZNF548 rna"
  ],
  "ZNF549": [
    "ZNF549 cnv",
    "ZNF549 methyl",
    "ZNF549 proteo",
    "ZNF549 rna"
  ],
  "ZNF550": [
    "ZNF550 cnv",
    "ZNF550 methyl",
    "ZNF550 rna"
  ],
  "ZNF551": [
    "ZNF551 cnv",
    "ZNF551 methyl",
    "ZNF551 rna"
  ],
  "ZNF552": [
    "ZNF552 cnv",
    "ZNF552 methyl",
    "ZNF552 rna"
  ],
  "ZNF554": [
    "ZNF554 cnv",
    "ZNF554 methyl",
    "ZNF554 rna"
  ],
  "ZNF555": [
    "ZNF555 cnv",
    "ZNF555 methyl",
    "ZNF555 rna"
  ],
  "ZNF556": [
    "ZNF556 cnv",
    "ZNF556 rna"
  ],
  "ZNF557": [
    "ZNF557 cnv",
    "ZNF557 rna"
  ],
  "ZNF558": [
    "ZNF558 cnv",
    "ZNF558 rna"
  ],
  "ZNF559": [
    "ZNF559 cnv",
    "ZNF559 methyl",
    "ZNF559 rna"
  ],
  "ZNF559-ZNF177": [
    "ZNF559-ZNF177 cnv",
    "ZNF559-ZNF177 methyl",
    "ZNF559-ZNF177 rna"
  ],
  "ZNF560": [
    "ZNF560 cnv",
    "ZNF560 methyl",
    "ZNF560 rna"
  ],
  "ZNF561": [
    "ZNF561 cnv",
    "ZNF561 methyl",
    "ZNF561 rna"
  ],
  "ZNF562": [
    "ZNF562 cnv",
    "ZNF562 methyl",
    "ZNF562 rna"
  ],
  "ZNF563": [
    "ZNF563 cnv",
    "ZNF563 methyl",
    "ZNF563 rna"
  ],
  "ZNF564": [
    "ZNF564 cnv",
    "ZNF564 methyl",
    "ZNF564 rna"
  ],
  "ZNF565": [
    "ZNF565 cnv",
    "ZNF565 methyl",
    "ZNF565 proteo",
    "ZNF565 rna"
  ],
  "ZNF566": [
    "ZNF566 cnv",
    "ZNF566 methyl",
    "ZNF566 rna"
  ],
  "ZNF566-AS1": [
    "ZNF566-AS1 methyl"
  ],
  "ZNF567": [
    "ZNF567 cnv",
    "ZNF567 methyl",
    "ZNF567 rna"
  ],
  "ZNF567-DT": [
    "ZNF567-DT methyl"
  ],
  "ZNF568": [
    "ZNF568 cnv",
    "ZNF568 methyl",
    "ZNF568 rna"
  ],
  "ZNF569": [
    "ZNF569 cnv",
    "ZNF569 methyl",
    "ZNF569 rna"
  ],
  "ZNF57": [
    "ZNF57 cnv",
    "ZNF57 methyl",
    "ZNF57 rna"
  ],
  "ZNF570": [
    "ZNF570 cnv",
    "ZNF570 methyl",
    "ZNF570 rna"
  ],
  "ZNF571": [
    "ZNF571 cnv",
    "ZNF571 methyl",
    "ZNF571 rna"
  ],
  "ZNF571-AS1": [
    "ZNF571-AS1 methyl"
  ],
  "ZNF572": [
    "ZNF572 cnv",
    "ZNF572 rna"
  ],
  "ZNF573": [
    "ZNF573 cnv",
    "ZNF573 methyl",
    "ZNF573 rna"
  ],
  "ZNF574": [
    "ZNF574 cnv",
    "ZNF574 methyl",
    "ZNF574 proteo",
    "ZNF574 rna"
  ],
  "ZNF575": [
    "ZNF575 cnv",
    "ZNF575 methyl",
    "ZNF575 rna"
  ],
  "ZNF576": [
    "ZNF576 cnv",
    "ZNF576 methyl",
    "ZNF576 rna"
  ],
  "ZNF577": [
    "ZNF577 cnv",
    "ZNF577 methyl",
    "ZNF577 rna"
  ],
  "ZNF578": [
    "ZNF578 cnv",
    "ZNF578 methyl",
    "ZNF578 rna"
  ],
  "ZNF579": [
    "ZNF579 cnv",
    "ZNF579 proteo",
    "ZNF579 rna"
  ],
  "ZNF580": [
    "ZNF580 cnv",
    "ZNF580 methyl",
    "ZNF580 rna"
  ],
  "ZNF581": [
    "ZNF581 cnv",
    "ZNF581 methyl",
    "ZNF581 rna"
  ],
  "ZNF582": [
    "ZNF582 cnv",
    "ZNF582 methyl",
    "ZNF582 rna"
  ],
  "ZNF582-DT": [
    "ZNF582-DT methyl"
  ],
  "ZNF583": [
    "ZNF583 cnv",
    "ZNF583 methyl",
    "ZNF583 rna"
  ],
  "ZNF584": [
    "ZNF584 cnv",
    "ZNF584 methyl",
    "ZNF584 rna"
  ],
  "ZNF585A": [
    "ZNF585A cnv",
    "ZNF585A rna"
  ],
  "ZNF585B": [
    "ZNF585B cnv",
    "ZNF585B methyl",
    "ZNF585B rna"
  ],
  "ZNF586": [
    "ZNF586 cnv",
    "ZNF586 methyl",
    "ZNF586 rna"
  ],
  "ZNF587": [
    "ZNF587 cnv",
    "ZNF587 methyl",
    "ZNF587 rna"
  ],
  "ZNF587B": [
    "ZNF587B cnv",
    "ZNF587B methyl",
    "ZNF587B rna"
  ],
  "ZNF589": [
    "ZNF589 cnv",
    "ZNF589 methyl",
    "ZNF589 rna"
  ],
  "ZNF592": [
    "ZNF592 1089_1089_1_1_S1089 phospho",
    "ZNF592 361_368_1_1_S368 phospho",
    "ZNF592 456_465_1_0 phospho",
    "ZNF592 686_700_1_1_S691 phospho",
    "ZNF592 cnv",
    "ZNF592 methyl",
    "ZNF592 proteo",
    "ZNF592 rna"
  ],
  "ZNF593": [
    "ZNF593 cnv",
    "ZNF593 methyl",
    "ZNF593 proteo",
    "ZNF593 rna"
  ],
  "ZNF593OS": [
    "ZNF593OS cnv",
    "ZNF593OS rna"
  ],
  "ZNF594": [
    "ZNF594 cnv",
    "ZNF594 methyl",
    "ZNF594 rna"
  ],
  "ZNF594-DT": [
    "ZNF594-DT methyl"
  ],
  "ZNF595": [
    "ZNF595 cnv",
    "ZNF595 methyl",
    "ZNF595 rna"
  ],
  "ZNF596": [
    "ZNF596 cnv",
    "ZNF596 methyl",
    "ZNF596 rna"
  ],
  "ZNF597": [
    "ZNF597 cnv",
    "ZNF597 methyl",
    "ZNF597 rna"
  ],
  "ZNF598": [
    "ZNF598 cnv",
    "ZNF598 methyl",
    "ZNF598 proteo",
    "ZNF598 rna"
  ],
  "ZNF599": [
    "ZNF599 cnv",
    "ZNF599 methyl",
    "ZNF599 rna"
  ],
  "ZNF600": [
    "ZNF600 cnv",
    "ZNF600 methyl",
    "ZNF600 rna"
  ],
  "ZNF605": [
    "ZNF605 cnv",
    "ZNF605 methyl",
    "ZNF605 rna"
  ],
  "ZNF606": [
    "ZNF606 cnv",
    "ZNF606 methyl",
    "ZNF606 rna"
  ],
  "ZNF607": [
    "ZNF607 cnv",
    "ZNF607 methyl",
    "ZNF607 rna"
  ],
  "ZNF608": [
    "ZNF608 421_424_1_1_S421 phospho",
    "ZNF608 481_481_1_1_T481 phospho",
    "ZNF608 627_636_1_1_S627 phospho",
    "ZNF608 887_902_1_1_S895 phospho",
    "ZNF608 963_971_1_1_S964 phospho",
    "ZNF608 cnv",
    "ZNF608 proteo",
    "ZNF608 rna"
  ],
  "ZNF609": [
    "ZNF609 1055_1057_1_1_S1055 phospho",
    "ZNF609 358_361_1_1_S358 phospho",
    "ZNF609 465_478_1_1_S467 phospho",
    "ZNF609 491_491_1_1_S491 phospho",
    "ZNF609 576_581_1_1_S576 phospho",
    "ZNF609 576_581_2_2_S576S578 phospho",
    "ZNF609 743_746_1_1_T746 phospho",
    "ZNF609 816_837_1_1_T817 phospho",
    "ZNF609 816_837_1_1_T823 phospho",
    "ZNF609 cnv",
    "ZNF609 methyl",
    "ZNF609 proteo",
    "ZNF609 rna"
  ],
  "ZNF610": [
    "ZNF610 cnv",
    "ZNF610 methyl",
    "ZNF610 rna"
  ],
  "ZNF611": [
    "ZNF611 cnv",
    "ZNF611 methyl",
    "ZNF611 rna"
  ],
  "ZNF613": [
    "ZNF613 cnv",
    "ZNF613 rna"
  ],
  "ZNF614": [
    "ZNF614 cnv",
    "ZNF614 methyl",
    "ZNF614 rna"
  ],
  "ZNF615": [
    "ZNF615 cnv",
    "ZNF615 methyl",
    "ZNF615 rna"
  ],
  "ZNF616": [
    "ZNF616 cnv",
    "ZNF616 methyl",
    "ZNF616 rna"
  ],
  "ZNF618": [
    "ZNF618 cnv",
    "ZNF618 methyl",
    "ZNF618 proteo",
    "ZNF618 rna"
  ],
  "ZNF619": [
    "ZNF619 cnv",
    "ZNF619 methyl",
    "ZNF619 rna"
  ],
  "ZNF620": [
    "ZNF620 cnv",
    "ZNF620 methyl",
    "ZNF620 rna"
  ],
  "ZNF621": [
    "ZNF621 cnv",
    "ZNF621 methyl",
    "ZNF621 rna"
  ],
  "ZNF622": [
    "ZNF622 141_143_1_1_S143 phospho",
    "ZNF622 cnv",
    "ZNF622 methyl",
    "ZNF622 proteo",
    "ZNF622 rna"
  ],
  "ZNF623": [
    "ZNF623 cnv",
    "ZNF623 methyl",
    "ZNF623 rna"
  ],
  "ZNF624": [
    "ZNF624 cnv",
    "ZNF624 methyl",
    "ZNF624 rna"
  ],
  "ZNF625": [
    "ZNF625 cnv",
    "ZNF625 methyl",
    "ZNF625 rna"
  ],
  "ZNF625-ZNF20": [
    "ZNF625-ZNF20 cnv",
    "ZNF625-ZNF20 rna"
  ],
  "ZNF626": [
    "ZNF626 cnv",
    "ZNF626 rna"
  ],
  "ZNF627": [
    "ZNF627 cnv",
    "ZNF627 methyl",
    "ZNF627 proteo",
    "ZNF627 rna"
  ],
  "ZNF628": [
    "ZNF628 cnv",
    "ZNF628 methyl",
    "ZNF628 rna"
  ],
  "ZNF629": [
    "ZNF629 cnv",
    "ZNF629 proteo",
    "ZNF629 rna"
  ],
  "ZNF630": [
    "ZNF630 methyl",
    "ZNF630 rna"
  ],
  "ZNF638": [
    "ZNF638 1100_1100_1_1_S1100 phospho",
    "ZNF638 119_128_1_1_S128 phospho",
    "ZNF638 1400_1401_1_1_S1401 phospho",
    "ZNF638 552_552_1_1_S552 phospho",
    "ZNF638 605_605_1_1_S605 phospho",
    "ZNF638 628_636_1_1_S636 phospho",
    "ZNF638 cnv",
    "ZNF638 methyl",
    "ZNF638 proteo",
    "ZNF638 rna"
  ],
  "ZNF639": [
    "ZNF639 cnv",
    "ZNF639 methyl",
    "ZNF639 proteo",
    "ZNF639 rna"
  ],
  "ZNF641": [
    "ZNF641 407_412_1_1_S412 phospho",
    "ZNF641 cnv",
    "ZNF641 methyl",
    "ZNF641 rna"
  ],
  "ZNF644": [
    "ZNF644 cnv",
    "ZNF644 methyl",
    "ZNF644 proteo",
    "ZNF644 rna"
  ],
  "ZNF646": [
    "ZNF646 cnv",
    "ZNF646 methyl",
    "ZNF646 proteo",
    "ZNF646 rna"
  ],
  "ZNF648": [
    "ZNF648 cnv",
    "ZNF648 proteo",
    "ZNF648 rna"
  ],
  "ZNF649": [
    "ZNF649 cnv",
    "ZNF649 rna"
  ],
  "ZNF649-AS1": [
    "ZNF649-AS1 methyl"
  ],
  "ZNF652": [
    "ZNF652 197_206_1_1_S204 phospho",
    "ZNF652 55_65_1_1_S57 phospho",
    "ZNF652 cnv",
    "ZNF652 methyl",
    "ZNF652 proteo",
    "ZNF652 rna"
  ],
  "ZNF653": [
    "ZNF653 cnv",
    "ZNF653 methyl",
    "ZNF653 rna"
  ],
  "ZNF654": [
    "ZNF654 cnv",
    "ZNF654 methyl",
    "ZNF654 rna"
  ],
  "ZNF655": [
    "ZNF655 80_84_1_1_S80 phospho",
    "ZNF655 cnv",
    "ZNF655 methyl",
    "ZNF655 proteo",
    "ZNF655 rna"
  ],
  "ZNF658": [
    "ZNF658 cnv",
    "ZNF658 methyl",
    "ZNF658 rna"
  ],
  "ZNF66": [
    "ZNF66 cnv",
    "ZNF66 rna"
  ],
  "ZNF660": [
    "ZNF660 cnv",
    "ZNF660 methyl",
    "ZNF660 proteo",
    "ZNF660 rna"
  ],
  "ZNF662": [
    "ZNF662 cnv",
    "ZNF662 methyl",
    "ZNF662 rna"
  ],
  "ZNF664": [
    "ZNF664 cnv",
    "ZNF664 methyl",
    "ZNF664 rna"
  ],
  "ZNF665": [
    "ZNF665 cnv",
    "ZNF665 methyl",
    "ZNF665 rna"
  ],
  "ZNF667": [
    "ZNF667 cnv",
    "ZNF667 methyl",
    "ZNF667 rna"
  ],
  "ZNF667-AS1": [
    "ZNF667-AS1 methyl"
  ],
  "ZNF668": [
    "ZNF668 cnv",
    "ZNF668 methyl",
    "ZNF668 proteo",
    "ZNF668 rna"
  ],
  "ZNF669": [
    "ZNF669 cnv",
    "ZNF669 methyl",
    "ZNF669 rna"
  ],
  "ZNF670": [
    "ZNF670 cnv",
    "ZNF670 methyl",
    "ZNF670 rna"
  ],
  "ZNF670-ZNF695": [
    "ZNF670-ZNF695 cnv",
    "ZNF670-ZNF695 rna"
  ],
  "ZNF671": [
    "ZNF671 cnv",
    "ZNF671 methyl",
    "ZNF671 rna"
  ],
  "ZNF672": [
    "ZNF672 cnv",
    "ZNF672 methyl",
    "ZNF672 rna"
  ],
  "ZNF674": [
    "ZNF674 methyl",
    "ZNF674 rna"
  ],
  "ZNF675": [
    "ZNF675 cnv",
    "ZNF675 rna"
  ],
  "ZNF676": [
    "ZNF676 cnv",
    "ZNF676 rna"
  ],
  "ZNF677": [
    "ZNF677 cnv",
    "ZNF677 methyl",
    "ZNF677 rna"
  ],
  "ZNF678": [
    "ZNF678 cnv",
    "ZNF678 methyl",
    "ZNF678 rna"
  ],
  "ZNF679": [
    "ZNF679 cnv",
    "ZNF679 rna"
  ],
  "ZNF680": [
    "ZNF680 cnv",
    "ZNF680 rna"
  ],
  "ZNF681": [
    "ZNF681 cnv",
    "ZNF681 rna"
  ],
  "ZNF682": [
    "ZNF682 cnv",
    "ZNF682 methyl",
    "ZNF682 rna"
  ],
  "ZNF683": [
    "ZNF683 cnv",
    "ZNF683 rna"
  ],
  "ZNF684": [
    "ZNF684 cnv",
    "ZNF684 methyl",
    "ZNF684 rna"
  ],
  "ZNF687": [
    "ZNF687 1057_1057_1_1_S1057 phospho",
    "ZNF687 1184_1201_1_1_S1191 phospho",
    "ZNF687 129_148_1_1_S140 phospho",
    "ZNF687 158_185_1_1_S183 phospho",
    "ZNF687 225_242_1_1_S242 phospho",
    "ZNF687 225_242_2_2_S227S242 phospho",
    "ZNF687 246_253_1_1_S253 phospho",
    "ZNF687 266_275_1_1_S271 phospho",
    "ZNF687 266_275_2_2_S266S271 phospho",
    "ZNF687 430_433_1_1_S433 phospho",
    "ZNF687 cnv",
    "ZNF687 methyl",
    "ZNF687 proteo",
    "ZNF687 rna"
  ],
  "ZNF688": [
    "ZNF688 cnv",
    "ZNF688 methyl",
    "ZNF688 proteo",
    "ZNF688 rna"
  ],
  "ZNF689": [
    "ZNF689 cnv",
    "ZNF689 methyl",
    "ZNF689 rna"
  ],
  "ZNF69": [
    "ZNF69 cnv",
    "ZNF69 rna"
  ],
  "ZNF691": [
    "ZNF691 304_315_1_1_S315 phospho",
    "ZNF691 cnv",
    "ZNF691 methyl",
    "ZNF691 proteo",
    "ZNF691 rna"
  ],
  "ZNF692": [
    "ZNF692 cnv",
    "ZNF692 methyl",
    "ZNF692 rna"
  ],
  "ZNF695": [
    "ZNF695 cnv",
    "ZNF695 methyl",
    "ZNF695 rna"
  ],
  "ZNF696": [
    "ZNF696 cnv",
    "ZNF696 methyl",
    "ZNF696 rna"
  ],
  "ZNF697": [
    "ZNF697 cnv",
    "ZNF697 methyl",
    "ZNF697 rna"
  ],
  "ZNF699": [
    "ZNF699 cnv",
    "ZNF699 methyl",
    "ZNF699 rna"
  ],
  "ZNF7": [
    "ZNF7 cnv",
    "ZNF7 methyl",
    "ZNF7 rna"
  ],
  "ZNF70": [
    "ZNF70 cnv",
    "ZNF70 methyl",
    "ZNF70 rna"
  ],
  "ZNF700": [
    "ZNF700 cnv",
    "ZNF700 methyl",
    "ZNF700 rna"
  ],
  "ZNF701": [
    "ZNF701 cnv",
    "ZNF701 methyl",
    "ZNF701 rna"
  ],
  "ZNF702P": [
    "ZNF702P methyl"
  ],
  "ZNF703": [
    "ZNF703 cnv",
    "ZNF703 methyl",
    "ZNF703 proteo",
    "ZNF703 rna"
  ],
  "ZNF704": [
    "ZNF704 294_319_1_1_S294 phospho",
    "ZNF704 cnv",
    "ZNF704 rna"
  ],
  "ZNF705A": [
    "ZNF705A cnv",
    "ZNF705A rna"
  ],
  "ZNF705B": [
    "ZNF705B cnv"
  ],
  "ZNF705D": [
    "ZNF705D cnv",
    "ZNF705D rna"
  ],
  "ZNF705EP": [
    "ZNF705EP cnv",
    "ZNF705EP rna"
  ],
  "ZNF705G": [
    "ZNF705G cnv",
    "ZNF705G rna"
  ],
  "ZNF706": [
    "ZNF706 cnv",
    "ZNF706 methyl",
    "ZNF706 proteo",
    "ZNF706 rna"
  ],
  "ZNF707": [
    "ZNF707 cnv",
    "ZNF707 methyl",
    "ZNF707 rna"
  ],
  "ZNF708": [
    "ZNF708 cnv",
    "ZNF708 rna"
  ],
  "ZNF709": [
    "ZNF709 cnv",
    "ZNF709 methyl",
    "ZNF709 rna"
  ],
  "ZNF71": [
    "ZNF71 cnv",
    "ZNF71 methyl",
    "ZNF71 rna"
  ],
  "ZNF710": [
    "ZNF710 cnv",
    "ZNF710 methyl",
    "ZNF710 rna"
  ],
  "ZNF711": [
    "ZNF711 methyl",
    "ZNF711 rna"
  ],
  "ZNF713": [
    "ZNF713 cnv",
    "ZNF713 methyl",
    "ZNF713 rna"
  ],
  "ZNF714": [
    "ZNF714 cnv",
    "ZNF714 rna"
  ],
  "ZNF716": [
    "ZNF716 cnv",
    "ZNF716 rna"
  ],
  "ZNF717": [
    "ZNF717 cnv",
    "ZNF717 methyl",
    "ZNF717 rna"
  ],
  "ZNF718": [
    "ZNF718 cnv",
    "ZNF718 methyl",
    "ZNF718 rna"
  ],
  "ZNF721": [
    "ZNF721 cnv",
    "ZNF721 methyl",
    "ZNF721 rna"
  ],
  "ZNF722": [
    "ZNF722 cnv",
    "ZNF722 rna"
  ],
  "ZNF723": [
    "ZNF723 cnv",
    "ZNF723 rna"
  ],
  "ZNF724": [
    "ZNF724 cnv",
    "ZNF724 rna"
  ],
  "ZNF726": [
    "ZNF726 cnv",
    "ZNF726 rna"
  ],
  "ZNF727": [
    "ZNF727 cnv",
    "ZNF727 rna"
  ],
  "ZNF728": [
    "ZNF728 cnv",
    "ZNF728 methyl",
    "ZNF728 rna"
  ],
  "ZNF729": [
    "ZNF729 cnv",
    "ZNF729 rna"
  ],
  "ZNF730": [
    "ZNF730 cnv",
    "ZNF730 methyl",
    "ZNF730 rna"
  ],
  "ZNF732": [
    "ZNF732 cnv",
    "ZNF732 methyl",
    "ZNF732 rna"
  ],
  "ZNF735": [
    "ZNF735 cnv",
    "ZNF735 rna"
  ],
  "ZNF736": [
    "ZNF736 cnv",
    "ZNF736 rna"
  ],
  "ZNF737": [
    "ZNF737 cnv",
    "ZNF737 rna"
  ],
  "ZNF738": [
    "ZNF738 cnv",
    "ZNF738 rna"
  ],
  "ZNF74": [
    "ZNF74 cnv",
    "ZNF74 methyl",
    "ZNF74 rna"
  ],
  "ZNF740": [
    "ZNF740 cnv",
    "ZNF740 methyl",
    "ZNF740 proteo",
    "ZNF740 rna"
  ],
  "ZNF746": [
    "ZNF746 cnv",
    "ZNF746 methyl",
    "ZNF746 rna"
  ],
  "ZNF747": [
    "ZNF747 cnv",
    "ZNF747 methyl",
    "ZNF747 rna"
  ],
  "ZNF749": [
    "ZNF749 cnv",
    "ZNF749 methyl",
    "ZNF749 rna"
  ],
  "ZNF750": [
    "ZNF750 cnv",
    "ZNF750 methyl",
    "ZNF750 rna"
  ],
  "ZNF75A": [
    "ZNF75A cnv",
    "ZNF75A methyl",
    "ZNF75A rna"
  ],
  "ZNF75D": [
    "ZNF75D methyl",
    "ZNF75D rna"
  ],
  "ZNF76": [
    "ZNF76 cnv",
    "ZNF76 methyl",
    "ZNF76 rna"
  ],
  "ZNF761": [
    "ZNF761 cnv",
    "ZNF761 methyl",
    "ZNF761 rna"
  ],
  "ZNF763": [
    "ZNF763 cnv",
    "ZNF763 methyl",
    "ZNF763 rna"
  ],
  "ZNF764": [
    "ZNF764 cnv",
    "ZNF764 methyl",
    "ZNF764 rna"
  ],
  "ZNF765": [
    "ZNF765 cnv",
    "ZNF765 methyl",
    "ZNF765 rna"
  ],
  "ZNF766": [
    "ZNF766 cnv",
    "ZNF766 rna"
  ],
  "ZNF767P": [
    "ZNF767P methyl"
  ],
  "ZNF768": [
    "ZNF768 125_128_1_1_S125 phospho",
    "ZNF768 158_168_1_1_S160 phospho",
    "ZNF768 cnv",
    "ZNF768 methyl",
    "ZNF768 proteo",
    "ZNF768 rna"
  ],
  "ZNF77": [
    "ZNF77 cnv",
    "ZNF77 methyl",
    "ZNF77 rna"
  ],
  "ZNF770": [
    "ZNF770 cnv",
    "ZNF770 methyl",
    "ZNF770 rna"
  ],
  "ZNF771": [
    "ZNF771 cnv",
    "ZNF771 methyl",
    "ZNF771 proteo",
    "ZNF771 rna"
  ],
  "ZNF772": [
    "ZNF772 cnv",
    "ZNF772 rna"
  ],
  "ZNF773": [
    "ZNF773 cnv",
    "ZNF773 methyl",
    "ZNF773 rna"
  ],
  "ZNF774": [
    "ZNF774 cnv",
    "ZNF774 methyl",
    "ZNF774 rna"
  ],
  "ZNF775": [
    "ZNF775 cnv",
    "ZNF775 methyl",
    "ZNF775 rna"
  ],
  "ZNF776": [
    "ZNF776 cnv",
    "ZNF776 methyl",
    "ZNF776 rna"
  ],
  "ZNF777": [
    "ZNF777 604_610_1_1_S604 phospho",
    "ZNF777 cnv",
    "ZNF777 rna"
  ],
  "ZNF778": [
    "ZNF778 cnv",
    "ZNF778 methyl",
    "ZNF778 rna"
  ],
  "ZNF780A": [
    "ZNF780A cnv",
    "ZNF780A methyl",
    "ZNF780A rna"
  ],
  "ZNF780B": [
    "ZNF780B cnv",
    "ZNF780B methyl",
    "ZNF780B rna"
  ],
  "ZNF781": [
    "ZNF781 cnv",
    "ZNF781 methyl",
    "ZNF781 rna"
  ],
  "ZNF782": [
    "ZNF782 cnv",
    "ZNF782 methyl",
    "ZNF782 rna"
  ],
  "ZNF783": [
    "ZNF783 cnv",
    "ZNF783 methyl",
    "ZNF783 rna"
  ],
  "ZNF784": [
    "ZNF784 12_18_1_1_S13 phospho",
    "ZNF784 cnv",
    "ZNF784 proteo",
    "ZNF784 rna"
  ],
  "ZNF785": [
    "ZNF785 cnv",
    "ZNF785 methyl",
    "ZNF785 rna"
  ],
  "ZNF786": [
    "ZNF786 cnv",
    "ZNF786 methyl",
    "ZNF786 rna"
  ],
  "ZNF787": [
    "ZNF787 cnv",
    "ZNF787 methyl",
    "ZNF787 proteo",
    "ZNF787 rna"
  ],
  "ZNF789": [
    "ZNF789 cnv",
    "ZNF789 methyl",
    "ZNF789 rna"
  ],
  "ZNF79": [
    "ZNF79 cnv",
    "ZNF79 methyl",
    "ZNF79 rna"
  ],
  "ZNF790": [
    "ZNF790 cnv",
    "ZNF790 methyl",
    "ZNF790 rna"
  ],
  "ZNF790-AS1": [
    "ZNF790-AS1 methyl"
  ],
  "ZNF791": [
    "ZNF791 cnv",
    "ZNF791 methyl",
    "ZNF791 rna"
  ],
  "ZNF792": [
    "ZNF792 cnv",
    "ZNF792 methyl",
    "ZNF792 rna"
  ],
  "ZNF793": [
    "ZNF793 cnv",
    "ZNF793 methyl",
    "ZNF793 rna"
  ],
  "ZNF793-AS1": [
    "ZNF793-AS1 methyl"
  ],
  "ZNF799": [
    "ZNF799 cnv",
    "ZNF799 methyl",
    "ZNF799 rna"
  ],
  "ZNF8": [
    "ZNF8 cnv",
    "ZNF8 methyl",
    "ZNF8 proteo",
    "ZNF8 rna"
  ],
  "ZNF8-ERVK3-1": [
    "ZNF8-ERVK3-1 methyl"
  ],
  "ZNF80": [
    "ZNF80 cnv",
    "ZNF80 rna"
  ],
  "ZNF800": [
    "ZNF800 cnv",
    "ZNF800 methyl",
    "ZNF800 proteo",
    "ZNF800 rna"
  ],
  "ZNF804A": [
    "ZNF804A cnv",
    "ZNF804A methyl",
    "ZNF804A rna"
  ],
  "ZNF804B": [
    "ZNF804B cnv",
    "ZNF804B methyl",
    "ZNF804B rna"
  ],
  "ZNF805": [
    "ZNF805 cnv",
    "ZNF805 methyl",
    "ZNF805 rna"
  ],
  "ZNF808": [
    "ZNF808 cnv",
    "ZNF808 methyl",
    "ZNF808 rna"
  ],
  "ZNF81": [
    "ZNF81 methyl",
    "ZNF81 rna"
  ],
  "ZNF813": [
    "ZNF813 cnv",
    "ZNF813 methyl",
    "ZNF813 rna"
  ],
  "ZNF814": [
    "ZNF814 cnv",
    "ZNF814 methyl",
    "ZNF814 rna"
  ],
  "ZNF816": [
    "ZNF816 cnv",
    "ZNF816 methyl",
    "ZNF816 rna"
  ],
  "ZNF816-ZNF321P": [
    "ZNF816-ZNF321P cnv",
    "ZNF816-ZNF321P methyl",
    "ZNF816-ZNF321P rna"
  ],
  "ZNF821": [
    "ZNF821 cnv",
    "ZNF821 methyl",
    "ZNF821 rna"
  ],
  "ZNF823": [
    "ZNF823 cnv",
    "ZNF823 methyl",
    "ZNF823 rna"
  ],
  "ZNF827": [
    "ZNF827 684_691_1_1_S689 phospho",
    "ZNF827 757_767_1_1_S760 phospho",
    "ZNF827 cnv",
    "ZNF827 methyl",
    "ZNF827 rna"
  ],
  "ZNF829": [
    "ZNF829 cnv",
    "ZNF829 methyl",
    "ZNF829 rna"
  ],
  "ZNF83": [
    "ZNF83 cnv",
    "ZNF83 methyl",
    "ZNF83 rna"
  ],
  "ZNF830": [
    "ZNF830 223_225_1_1_S225 phospho",
    "ZNF830 351_362_1_1_S351 phospho",
    "ZNF830 cnv",
    "ZNF830 methyl",
    "ZNF830 proteo",
    "ZNF830 rna"
  ],
  "ZNF831": [
    "ZNF831 739_750_1_0 phospho",
    "ZNF831 cnv",
    "ZNF831 rna"
  ],
  "ZNF835": [
    "ZNF835 cnv",
    "ZNF835 methyl",
    "ZNF835 rna"
  ],
  "ZNF836": [
    "ZNF836 cnv",
    "ZNF836 methyl",
    "ZNF836 rna"
  ],
  "ZNF837": [
    "ZNF837 cnv",
    "ZNF837 methyl",
    "ZNF837 rna"
  ],
  "ZNF839": [
    "ZNF839 cnv",
    "ZNF839 methyl",
    "ZNF839 rna"
  ],
  "ZNF84": [
    "ZNF84 cnv",
    "ZNF84 methyl",
    "ZNF84 proteo",
    "ZNF84 rna"
  ],
  "ZNF84-DT": [
    "ZNF84-DT methyl"
  ],
  "ZNF841": [
    "ZNF841 cnv",
    "ZNF841 methyl",
    "ZNF841 rna"
  ],
  "ZNF843": [
    "ZNF843 cnv",
    "ZNF843 methyl",
    "ZNF843 rna"
  ],
  "ZNF844": [
    "ZNF844 cnv",
    "ZNF844 rna"
  ],
  "ZNF845": [
    "ZNF845 cnv",
    "ZNF845 methyl",
    "ZNF845 rna"
  ],
  "ZNF846": [
    "ZNF846 cnv",
    "ZNF846 methyl",
    "ZNF846 rna"
  ],
  "ZNF85": [
    "ZNF85 cnv",
    "ZNF85 rna"
  ],
  "ZNF850": [
    "ZNF850 cnv",
    "ZNF850 methyl",
    "ZNF850 rna"
  ],
  "ZNF852": [
    "ZNF852 cnv",
    "ZNF852 methyl",
    "ZNF852 rna"
  ],
  "ZNF853": [
    "ZNF853 47_67_1_1_S48 phospho",
    "ZNF853 cnv",
    "ZNF853 methyl",
    "ZNF853 proteo",
    "ZNF853 rna"
  ],
  "ZNF860": [
    "ZNF860 cnv",
    "ZNF860 methyl",
    "ZNF860 rna"
  ],
  "ZNF862": [
    "ZNF862 cnv",
    "ZNF862 methyl",
    "ZNF862 rna"
  ],
  "ZNF865": [
    "ZNF865 cnv",
    "ZNF865 methyl",
    "ZNF865 rna"
  ],
  "ZNF875": [
    "ZNF875 cnv",
    "ZNF875 methyl",
    "ZNF875 rna"
  ],
  "ZNF878": [
    "ZNF878 cnv",
    "ZNF878 rna"
  ],
  "ZNF879": [
    "ZNF879 cnv",
    "ZNF879 methyl",
    "ZNF879 rna"
  ],
  "ZNF880": [
    "ZNF880 cnv",
    "ZNF880 methyl",
    "ZNF880 rna"
  ],
  "ZNF883": [
    "ZNF883 methyl"
  ],
  "ZNF888": [
    "ZNF888 cnv",
    "ZNF888 methyl",
    "ZNF888 rna"
  ],
  "ZNF891": [
    "ZNF891 cnv",
    "ZNF891 methyl",
    "ZNF891 rna"
  ],
  "ZNF90": [
    "ZNF90 cnv",
    "ZNF90 rna"
  ],
  "ZNF91": [
    "ZNF91 cnv",
    "ZNF91 rna"
  ],
  "ZNF92": [
    "ZNF92 cnv",
    "ZNF92 rna"
  ],
  "ZNF93": [
    "ZNF93 cnv",
    "ZNF93 rna"
  ],
  "ZNF98": [
    "ZNF98 cnv",
    "ZNF98 rna"
  ],
  "ZNF99": [
    "ZNF99 cnv",
    "ZNF99 rna"
  ],
  "ZNFX1": [
    "ZNFX1 cnv",
    "ZNFX1 methyl",
    "ZNFX1 proteo",
    "ZNFX1 rna"
  ],
  "ZNG1A": [
    "ZNG1A cnv",
    "ZNG1A rna"
  ],
  "ZNG1B": [
    "ZNG1B cnv",
    "ZNG1B rna"
  ],
  "ZNG1C": [
    "ZNG1C cnv",
    "ZNG1C rna"
  ],
  "ZNG1E": [
    "ZNG1E cnv",
    "ZNG1E methyl",
    "ZNG1E rna"
  ],
  "ZNG1F": [
    "ZNG1F cnv",
    "ZNG1F rna"
  ],
  "ZNHIT1": [
    "ZNHIT1 cnv",
    "ZNHIT1 methyl",
    "ZNHIT1 rna"
  ],
  "ZNHIT2": [
    "ZNHIT2 cnv",
    "ZNHIT2 methyl",
    "ZNHIT2 proteo",
    "ZNHIT2 rna"
  ],
  "ZNHIT3": [
    "ZNHIT3 cnv",
    "ZNHIT3 methyl",
    "ZNHIT3 rna"
  ],
  "ZNHIT6": [
    "ZNHIT6 11_25_1_1_S25 phospho",
    "ZNHIT6 cnv",
    "ZNHIT6 methyl",
    "ZNHIT6 proteo",
    "ZNHIT6 rna"
  ],
  "ZNRD1ASP": [
    "ZNRD1ASP methyl"
  ],
  "ZNRD2": [
    "ZNRD2 cnv",
    "ZNRD2 methyl",
    "ZNRD2 proteo",
    "ZNRD2 rna"
  ],
  "ZNRF1": [
    "ZNRF1 123_123_1_1_S123 phospho",
    "ZNRF1 cnv",
    "ZNRF1 methyl",
    "ZNRF1 proteo",
    "ZNRF1 rna"
  ],
  "ZNRF2": [
    "ZNRF2 18_34_1_1_S19 phospho",
    "ZNRF2 82_92_1_1_S82 phospho",
    "ZNRF2 cnv",
    "ZNRF2 methyl",
    "ZNRF2 proteo",
    "ZNRF2 rna"
  ],
  "ZNRF3": [
    "ZNRF3 cnv",
    "ZNRF3 methyl",
    "ZNRF3 rna"
  ],
  "ZNRF4": [
    "ZNRF4 cnv",
    "ZNRF4 methyl",
    "ZNRF4 rna"
  ],
  "ZP1": [
    "ZP1 cnv",
    "ZP1 rna"
  ],
  "ZP2": [
    "ZP2 cnv",
    "ZP2 rna"
  ],
  "ZP3": [
    "ZP3 cnv",
    "ZP3 methyl",
    "ZP3 rna"
  ],
  "ZP4": [
    "ZP4 cnv"
  ],
  "ZPBP": [
    "ZPBP cnv",
    "ZPBP methyl",
    "ZPBP rna"
  ],
  "ZPBP2": [
    "ZPBP2 cnv",
    "ZPBP2 methyl"
  ],
  "ZPLD1": [
    "ZPLD1 cnv",
    "ZPLD1 rna"
  ],
  "ZPLD2P": [
    "ZPLD2P methyl"
  ],
  "ZPR1": [
    "ZPR1 cnv",
    "ZPR1 methyl",
    "ZPR1 proteo",
    "ZPR1 rna"
  ],
  "ZRANB1": [
    "ZRANB1 cnv",
    "ZRANB1 methyl",
    "ZRANB1 rna"
  ],
  "ZRANB2": [
    "ZRANB2 114_124_1_1_S120 phospho",
    "ZRANB2 120_124_1_1_S120 phospho",
    "ZRANB2 153_165_1_1_S153 phospho",
    "ZRANB2 183_193_1_1_S188 phospho",
    "ZRANB2 303_317_3_3_T303S305S307 phospho",
    "ZRANB2 305_317_1_1_S307 phospho",
    "ZRANB2 305_317_2_2_S305S307 phospho",
    "ZRANB2 83_90_1_1_S83 phospho",
    "ZRANB2 83_90_1_1_T90 phospho",
    "ZRANB2 cnv",
    "ZRANB2 methyl",
    "ZRANB2 proteo",
    "ZRANB2 rna"
  ],
  "ZRANB3": [
    "ZRANB3 cnv",
    "ZRANB3 methyl",
    "ZRANB3 rna"
  ],
  "ZRSR2": [
    "ZRSR2 384_389_1_1_S384 phospho",
    "ZRSR2 methyl",
    "ZRSR2 rna"
  ],
  "ZSCAN1": [
    "ZSCAN1 cnv",
    "ZSCAN1 methyl",
    "ZSCAN1 rna"
  ],
  "ZSCAN10": [
    "ZSCAN10 cnv",
    "ZSCAN10 methyl",
    "ZSCAN10 proteo",
    "ZSCAN10 rna"
  ],
  "ZSCAN12": [
    "ZSCAN12 cnv",
    "ZSCAN12 methyl",
    "ZSCAN12 rna"
  ],
  "ZSCAN16": [
    "ZSCAN16 cnv",
    "ZSCAN16 rna"
  ],
  "ZSCAN16-AS1": [
    "ZSCAN16-AS1 methyl"
  ],
  "ZSCAN18": [
    "ZSCAN18 178_209_1_1_S196 phospho",
    "ZSCAN18 66_92_2_2_S66S70 phospho",
    "ZSCAN18 cnv",
    "ZSCAN18 methyl",
    "ZSCAN18 proteo",
    "ZSCAN18 rna"
  ],
  "ZSCAN2": [
    "ZSCAN2 cnv",
    "ZSCAN2 methyl",
    "ZSCAN2 rna"
  ],
  "ZSCAN20": [
    "ZSCAN20 cnv",
    "ZSCAN20 methyl",
    "ZSCAN20 rna"
  ],
  "ZSCAN21": [
    "ZSCAN21 cnv",
    "ZSCAN21 rna"
  ],
  "ZSCAN22": [
    "ZSCAN22 cnv",
    "ZSCAN22 methyl",
    "ZSCAN22 rna"
  ],
  "ZSCAN23": [
    "ZSCAN23 cnv",
    "ZSCAN23 rna"
  ],
  "ZSCAN25": [
    "ZSCAN25 cnv",
    "ZSCAN25 methyl",
    "ZSCAN25 rna"
  ],
  "ZSCAN26": [
    "ZSCAN26 cnv",
    "ZSCAN26 proteo",
    "ZSCAN26 rna"
  ],
  "ZSCAN29": [
    "ZSCAN29 153_153_1_1_S153 phospho",
    "ZSCAN29 cnv",
    "ZSCAN29 methyl",
    "ZSCAN29 rna"
  ],
  "ZSCAN30": [
    "ZSCAN30 cnv",
    "ZSCAN30 methyl",
    "ZSCAN30 rna"
  ],
  "ZSCAN31": [
    "ZSCAN31 cnv",
    "ZSCAN31 rna"
  ],
  "ZSCAN32": [
    "ZSCAN32 cnv",
    "ZSCAN32 methyl",
    "ZSCAN32 rna"
  ],
  "ZSCAN4": [
    "ZSCAN4 cnv",
    "ZSCAN4 rna"
  ],
  "ZSCAN5A": [
    "ZSCAN5A cnv",
    "ZSCAN5A methyl",
    "ZSCAN5A rna"
  ],
  "ZSCAN5B": [
    "ZSCAN5B cnv",
    "ZSCAN5B rna"
  ],
  "ZSCAN5C": [
    "ZSCAN5C cnv",
    "ZSCAN5C rna"
  ],
  "ZSCAN9": [
    "ZSCAN9 cnv",
    "ZSCAN9 methyl",
    "ZSCAN9 rna"
  ],
  "ZSWIM1": [
    "ZSWIM1 cnv",
    "ZSWIM1 rna"
  ],
  "ZSWIM2": [
    "ZSWIM2 cnv",
    "ZSWIM2 methyl",
    "ZSWIM2 rna"
  ],
  "ZSWIM3": [
    "ZSWIM3 cnv",
    "ZSWIM3 rna"
  ],
  "ZSWIM4": [
    "ZSWIM4 cnv",
    "ZSWIM4 methyl",
    "ZSWIM4 rna"
  ],
  "ZSWIM5": [
    "ZSWIM5 cnv",
    "ZSWIM5 methyl",
    "ZSWIM5 rna"
  ],
  "ZSWIM6": [
    "ZSWIM6 cnv",
    "ZSWIM6 methyl",
    "ZSWIM6 rna"
  ],
  "ZSWIM7": [
    "ZSWIM7 cnv",
    "ZSWIM7 methyl",
    "ZSWIM7 rna"
  ],
  "ZSWIM8": [
    "ZSWIM8 1088_1104_1_1_S1092 phospho",
    "ZSWIM8 1139_1160_1_1_S1156 phospho",
    "ZSWIM8 48_66_1_1_S48 phospho",
    "ZSWIM8 48_66_1_1_S53 phospho",
    "ZSWIM8 48_66_2_2_S48S53 phospho",
    "ZSWIM8 cnv",
    "ZSWIM8 methyl",
    "ZSWIM8 proteo",
    "ZSWIM8 rna"
  ],
  "ZSWIM9": [
    "ZSWIM9 cnv",
    "ZSWIM9 methyl",
    "ZSWIM9 rna"
  ],
  "ZUP1": [
    "ZUP1 cnv",
    "ZUP1 rna"
  ],
  "ZW10": [
    "ZW10 cnv",
    "ZW10 methyl",
    "ZW10 proteo",
    "ZW10 rna"
  ],
  "ZWILCH": [
    "ZWILCH cnv",
    "ZWILCH rna"
  ],
  "ZWINT": [
    "ZWINT cnv",
    "ZWINT methyl",
    "ZWINT rna"
  ],
  "ZXDA": [
    "ZXDA rna"
  ],
  "ZXDB": [
    "ZXDB rna"
  ],
  "ZXDC": [
    "ZXDC cnv",
    "ZXDC methyl",
    "ZXDC rna"
  ],
  "ZYG11A": [
    "ZYG11A cnv",
    "ZYG11A methyl",
    "ZYG11A rna"
  ],
  "ZYG11B": [
    "ZYG11B cnv",
    "ZYG11B methyl",
    "ZYG11B proteo",
    "ZYG11B rna"
  ],
  "ZYX": [
    "ZYX 142_159_1_0 phospho",
    "ZYX 142_159_1_1_S143 phospho",
    "ZYX 258_259_1_1_S259 phospho",
    "ZYX 258_270_1_1_S267 phospho",
    "ZYX 258_270_2_2_S259S267 phospho",
    "ZYX 274_290_1_1_S281 phospho",
    "ZYX 281_290_1_1_S290 phospho",
    "ZYX 303_316_1_0 phospho",
    "ZYX 303_316_1_1_S303 phospho",
    "ZYX 303_316_1_1_S313 phospho",
    "ZYX 344_352_1_1_S344 phospho",
    "ZYX cnv",
    "ZYX methyl",
    "ZYX proteo",
    "ZYX rna"
  ],
  "ZZEF1": [
    "ZZEF1 1462_1493_1_0 phospho",
    "ZZEF1 1462_1493_1_1_S1464 phospho",
    "ZZEF1 1499_1529_1_0 phospho",
    "ZZEF1 2443_2444_1_1_S2444 phospho",
    "ZZEF1 cnv",
    "ZZEF1 methyl",
    "ZZEF1 proteo",
    "ZZEF1 rna"
  ],
  "ZZZ3": [
    "ZZZ3 109_113_1_1_S113 phospho",
    "ZZZ3 cnv",
    "ZZZ3 methyl",
    "ZZZ3 rna"
  ]
}